webpackJsonp([2],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(509);
	module.exports = __webpack_require__(976);


/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.17.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i in momentProperties) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _ordinalParseLenient.
	    this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return this._months;
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return this._monthsShort;
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    //can't just apply() to create a date:
	    //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    //the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    //the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	//http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return this._weekdays;
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    ordinalParse: defaultOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            __webpack_require__(442)("./" + name);
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	        hooks.createFromInputFallback(config);
	    }
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse)) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (input === undefined) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (typeof(input) === 'object') {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString () {
	    var m = this.clone().utc();
	    if (0 < m.year() && m.year() <= 9999) {
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            return this.toDate().toISOString();
	        } else {
	            return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	    } else {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 < this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$1 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$1;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this[units + 's']();
	}
	
	function makeGetter(name) {
	    return function () {
	        return this._data[name];
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    s: 45,  // seconds to minute
	    m: 45,  // minutes to hour
	    h: 22,  // hours to day
	    d: 26,  // days to month
	    M: 11   // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds < thresholds.s && ['s', seconds]  ||
	            minutes <= 1           && ['m']           ||
	            minutes < thresholds.m && ['mm', minutes] ||
	            hours   <= 1           && ['h']           ||
	            hours   < thresholds.h && ['hh', hours]   ||
	            days    <= 1           && ['d']           ||
	            days    < thresholds.d && ['dd', days]    ||
	            months  <= 1           && ['M']           ||
	            months  < thresholds.M && ['MM', months]  ||
	            years   <= 1           && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    return true;
	}
	
	function humanize (withSuffix) {
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.17.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(558)(module)))

/***/ },
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.untouchWithKey = exports.untouch = exports.touchWithKey = exports.touch = exports.swapArrayValues = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.reset = exports.propTypes = exports.initializeWithKey = exports.initialize = exports.getValues = exports.removeArrayValue = exports.reduxForm = exports.reducer = exports.focus = exports.destroy = exports.changeWithKey = exports.change = exports.blur = exports.autofillWithKey = exports.autofill = exports.addArrayValue = exports.actionTypes = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _createAll2 = __webpack_require__(456);
	
	var _createAll3 = _interopRequireDefault(_createAll2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';
	
	var _createAll = (0, _createAll3.default)(isNative, _react2.default, _reactRedux.connect);
	
	var actionTypes = _createAll.actionTypes;
	var addArrayValue = _createAll.addArrayValue;
	var autofill = _createAll.autofill;
	var autofillWithKey = _createAll.autofillWithKey;
	var blur = _createAll.blur;
	var change = _createAll.change;
	var changeWithKey = _createAll.changeWithKey;
	var destroy = _createAll.destroy;
	var focus = _createAll.focus;
	var reducer = _createAll.reducer;
	var reduxForm = _createAll.reduxForm;
	var removeArrayValue = _createAll.removeArrayValue;
	var getValues = _createAll.getValues;
	var initialize = _createAll.initialize;
	var initializeWithKey = _createAll.initializeWithKey;
	var propTypes = _createAll.propTypes;
	var reset = _createAll.reset;
	var startAsyncValidation = _createAll.startAsyncValidation;
	var startSubmit = _createAll.startSubmit;
	var stopAsyncValidation = _createAll.stopAsyncValidation;
	var stopSubmit = _createAll.stopSubmit;
	var swapArrayValues = _createAll.swapArrayValues;
	var touch = _createAll.touch;
	var touchWithKey = _createAll.touchWithKey;
	var untouch = _createAll.untouch;
	var untouchWithKey = _createAll.untouchWithKey;
	exports.actionTypes = actionTypes;
	exports.addArrayValue = addArrayValue;
	exports.autofill = autofill;
	exports.autofillWithKey = autofillWithKey;
	exports.blur = blur;
	exports.change = change;
	exports.changeWithKey = changeWithKey;
	exports.destroy = destroy;
	exports.focus = focus;
	exports.reducer = reducer;
	exports.reduxForm = reduxForm;
	exports.removeArrayValue = removeArrayValue;
	exports.getValues = getValues;
	exports.initialize = initialize;
	exports.initializeWithKey = initializeWithKey;
	exports.propTypes = propTypes;
	exports.reset = reset;
	exports.startAsyncValidation = startAsyncValidation;
	exports.startSubmit = startSubmit;
	exports.stopAsyncValidation = stopAsyncValidation;
	exports.stopSubmit = stopSubmit;
	exports.swapArrayValues = swapArrayValues;
	exports.touch = touch;
	exports.touchWithKey = touchWithKey;
	exports.untouch = untouch;
	exports.untouchWithKey = untouchWithKey;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(153);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is a Buffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Buffer, otherwise false
	 */
	function isBuffer(val) {
	  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
	    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 * nativescript
	 *  navigator.product -> 'NativeScript' or 'NS'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
	                                           navigator.product === 'NativeScript' ||
	                                           navigator.product === 'NS')) {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Function equal to merge with the difference being that no reference
	 * to original objects is kept.
	 *
	 * @see merge
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function deepMerge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = deepMerge(result[key], val);
	    } else if (typeof val === 'object') {
	      result[key] = deepMerge({}, val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  deepMerge: deepMerge,
	  extend: extend,
	  trim: trim
	};


/***/ },
/* 19 */,
/* 20 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.stripProps = stripProps;
	function stripProps(props) {
	    return {
	        value: props.value || '',
	        onChange: props.onChange,
	        onBlur: props.onBlur,
	        name: props.name
	    };
	}

/***/ },
/* 21 */,
/* 22 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NOT_STARTED = exports.NOT_STARTED = 1;
	var FIRST = exports.FIRST = 2;
	var FIRST_BREAK = exports.FIRST_BREAK = 3;
	var SECOND = exports.SECOND = 4;
	var SECOND_BREAK = exports.SECOND_BREAK = 5;
	var THIRD = exports.THIRD = 6;
	var THIRD_BREAK = exports.THIRD_BREAK = 7;
	var FOURTH = exports.FOURTH = 8;
	var FOURTH_BREAK = exports.FOURTH_BREAK = 9;
	var FIFTH = exports.FIFTH = 10;
	var FIFTH_BREAK = exports.FIFTH_BREAK = 11;
	var SIXTH = exports.SIXTH = 12;
	var SIXTH_BREAK = exports.SIXTH_BREAK = 13;
	var SEVENTH = exports.SEVENTH = 14;
	var SEVENTH_BREAK = exports.SEVENTH_BREAK = 15;
	var FULL_TIME = exports.FULL_TIME = 16;
	var OVERTIME = exports.OVERTIME = 17;
	var OVERTIME_FINISHED = exports.OVERTIME_FINISHED = 18;
	var PENALTIES = exports.PENALTIES = 19;
	var FIRST_EXTRA = exports.FIRST_EXTRA = 20;
	var FIRST_EXTRA_BREAK = exports.FIRST_EXTRA_BREAK = 21;
	var SECOND_EXTRA = exports.SECOND_EXTRA = 22;
	var SECOND_EXTRA_BREAK = exports.SECOND_EXTRA_BREAK = 23;
	var FINISHED = exports.FINISHED = 24;
	
	var ROUND_FIRST = exports.ROUND_FIRST = 1;
	var ROUND_SECOND = exports.ROUND_SECOND = 2;
	var ROUND_THIRD = exports.ROUND_THIRD = 3;
	var ROUND_FOURTH = exports.ROUND_FOURTH = 4;
	var ROUND_FIFTH = exports.ROUND_FIFTH = 5;
	var ROUND_SIXTH = exports.ROUND_SIXTH = 6;
	var ROUND_SEVENTH = exports.ROUND_SEVENTH = 7;
	var ROUND_EIGHTH = exports.ROUND_EIGHTH = 8;
	var ROUND_NINTH = exports.ROUND_NINTH = 9;
	var ROUND_TENTH = exports.ROUND_TENTH = 10;
	var ROUND_ELEVENTH = exports.ROUND_ELEVENTH = 11;
	var ROUND_TWELFTH = exports.ROUND_TWELFTH = 12;
	
	var LAP_FIRST = exports.LAP_FIRST = 1;
	var LAP_SECOND = exports.LAP_SECOND = 2;
	var LAP_THIRD = exports.LAP_THIRD = 3;
	var LAP_FOURTH = exports.LAP_FOURTH = 4;
	var LAP_FIFTH = exports.LAP_FIFTH = 5;
	var LAP_SIXTH = exports.LAP_SIXTH = 6;
	var LAP_SEVENTH = exports.LAP_SEVENTH = 7;
	var LAP_EIGHTH = exports.LAP_EIGHTH = 8;

/***/ },
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DEFAULT_GROUP = exports.DEFAULT_GROUP = 0;
	var FIRST_PERIOD_GROUP = exports.FIRST_PERIOD_GROUP = 1;
	var SECOND_PERIOD_GROUP = exports.SECOND_PERIOD_GROUP = 2;
	var THIRD_PERIOD_GROUP = exports.THIRD_PERIOD_GROUP = 3;
	var FOURTH_PERIOD_GROUP = exports.FOURTH_PERIOD_GROUP = 4;
	var FIFTH_PERIOD_GROUP = exports.FIFTH_PERIOD_GROUP = 5;
	var SIXTH_PERIOD_GROUP = exports.SIXTH_PERIOD_GROUP = 6;
	var SEVENTH_PERIOD_GROUP = exports.SEVENTH_PERIOD_GROUP = 7;
	var EIGHTH_PERIOD_GROUP = exports.EIGHTH_PERIOD_GROUP = 8;
	var NINTH_PERIOD_GROUP = exports.NINTH_PERIOD_GROUP = 9;
	var TENTH_PERIOD_GROUP = exports.TENTH_PERIOD_GROUP = 10;
	var ELEVENTH_PERIOD_GROUP = exports.ELEVENTH_PERIOD_GROUP = 11;
	var TWELFTH_PERIOD_GROUP = exports.TWELFTH_PERIOD_GROUP = 12;
	var THIRTEENTH_PERIOD_GROUP = exports.THIRTEENTH_PERIOD_GROUP = 13;
	var FOURTEENTH_PERIOD_GROUP = exports.FOURTEENTH_PERIOD_GROUP = 14;
	var FIFTEENTH_PERIOD_GROUP = exports.FIFTEENTH_PERIOD_GROUP = 15;
	var SIXTEENTH_PERIOD_GROUP = exports.SIXTEENTH_PERIOD_GROUP = 16;
	var SEVENTEENTH_PERIOD_GROUP = exports.SEVENTEENTH_PERIOD_GROUP = 17;
	var EIGHTEENTH_PERIOD_GROUP = exports.EIGHTEENTH_PERIOD_GROUP = 18;
	var NINETEENTH_PERIOD_GROUP = exports.NINETEENTH_PERIOD_GROUP = 19;
	var TWENTIETH_PERIOD_GROUP = exports.TWENTIETH_PERIOD_GROUP = 20;
	var TWENTY_FIRST_PERIOD_GROUP = exports.TWENTY_FIRST_PERIOD_GROUP = 21;
	var TWENTY_SECOND_PERIOD_GROUP = exports.TWENTY_SECOND_PERIOD_GROUP = 22;
	var TWENTY_THIRD_PERIOD_GROUP = exports.TWENTY_THIRD_PERIOD_GROUP = 23;
	var TWENTY_FOURTH_PERIOD_GROUP = exports.TWENTY_FOURTH_PERIOD_GROUP = 24;
	var TWENTY_FIFTH_PERIOD_GROUP = exports.TWENTY_FIFTH_PERIOD_GROUP = 25;
	var TWENTY_SIXTH_PERIOD_GROUP = exports.TWENTY_SIXTH_PERIOD_GROUP = 26;
	var TWENTY_SEVENTH_PERIOD_GROUP = exports.TWENTY_SEVENTH_PERIOD_GROUP = 27;
	var TWENTY_EIGHTH_PERIOD_GROUP = exports.TWENTY_EIGHTH_PERIOD_GROUP = 28;
	var TWENTY_NINTH_PERIOD_GROUP = exports.TWENTY_NINTH_PERIOD_GROUP = 29;
	var THIRTIETH_PERIOD_GROUP = exports.THIRTIETH_PERIOD_GROUP = 30;
	var THIRTY_FIRST_PERIOD_GROUP = exports.THIRTY_FIRST_PERIOD_GROUP = 31;
	var THIRTY_SECOND_PERIOD_GROUP = exports.THIRTY_SECOND_PERIOD_GROUP = 32;
	var THIRTY_THIRD_PERIOD_GROUP = exports.THIRTY_THIRD_PERIOD_GROUP = 33;
	var THIRTY_FOURTH_PERIOD_GROUP = exports.THIRTY_FOURTH_PERIOD_GROUP = 34;
	var THIRTY_FIFTH_PERIOD_GROUP = exports.THIRTY_FIFTH_PERIOD_GROUP = 35;
	var THIRTY_SIXTH_PERIOD_GROUP = exports.THIRTY_SIXTH_PERIOD_GROUP = 36;
	var THIRTY_SEVENTH_PERIOD_GROUP = exports.THIRTY_SEVENTH_PERIOD_GROUP = 37;
	var FIRST_MINI_MATCH_GROUP = exports.FIRST_MINI_MATCH_GROUP = 38;
	var SECOND_MINI_MATCH_GROUP = exports.SECOND_MINI_MATCH_GROUP = 39;
	var THIRD_MINI_MATCH_GROUP = exports.THIRD_MINI_MATCH_GROUP = 40;
	var FOURTH_MINI_MATCH_GROUP = exports.FOURTH_MINI_MATCH_GROUP = 41;
	var FIFTH_MINI_MATCH_GROUP = exports.FIFTH_MINI_MATCH_GROUP = 42;
	var SIXTH_MINI_MATCH_GROUP = exports.SIXTH_MINI_MATCH_GROUP = 43;
	var CORNER_GROUP = exports.CORNER_GROUP = 44;
	var FIRST_PERIOD_CORNER_GROUP = exports.FIRST_PERIOD_CORNER_GROUP = 45;
	var YELLOW_CARD_GROUP = exports.YELLOW_CARD_GROUP = 46;
	var FIRST_PERIOD_YELLOW_CARD_GROUP = exports.FIRST_PERIOD_YELLOW_CARD_GROUP = 47;
	var BASKETBALL_MATCH_TWO_POINTS_GROUP = exports.BASKETBALL_MATCH_TWO_POINTS_GROUP = 48;
	var BASKETBALL_MATCH_THREE_POINTS_GROUP = exports.BASKETBALL_MATCH_THREE_POINTS_GROUP = 49;
	var ICE_HOCKEY_FIRST_MINI_MATCH_GROUP = exports.ICE_HOCKEY_FIRST_MINI_MATCH_GROUP = 50;
	var ICE_HOCKEY_SECOND_MINI_MATCH_GROUP = exports.ICE_HOCKEY_SECOND_MINI_MATCH_GROUP = 51;
	var ICE_HOCKEY_THIRD_MINI_MATCH_GROUP = exports.ICE_HOCKEY_THIRD_MINI_MATCH_GROUP = 52;
	var ICE_HOCKEY_FOURTH_MINI_MATCH_GROUP = exports.ICE_HOCKEY_FOURTH_MINI_MATCH_GROUP = 53;
	var ICE_HOCKEY_FIFTH_MINI_MATCH_GROUP = exports.ICE_HOCKEY_FIFTH_MINI_MATCH_GROUP = 54;
	var ICE_HOCKEY_SIXTH_MINI_MATCH_GROUP = exports.ICE_HOCKEY_SIXTH_MINI_MATCH_GROUP = 55;
	var FIRST_PERIOD_TEN_POINTS_MINI_MATCH_GROUP = exports.FIRST_PERIOD_TEN_POINTS_MINI_MATCH_GROUP = 56;
	var FIRST_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP = exports.FIRST_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP = 57;
	var SECOND_PERIOD_TEN_POINTS_MINI_MATCH_GROUP = exports.SECOND_PERIOD_TEN_POINTS_MINI_MATCH_GROUP = 58;
	var SECOND_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP = exports.SECOND_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP = 59;
	var THIRD_PERIOD_TEN_POINTS_MINI_MATCH_GROUP = exports.THIRD_PERIOD_TEN_POINTS_MINI_MATCH_GROUP = 60;
	var THIRD_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP = exports.THIRD_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP = 61;
	var FOURTH_PERIOD_TEN_POINTS_MINI_MATCH_GROUP = exports.FOURTH_PERIOD_TEN_POINTS_MINI_MATCH_GROUP = 62;
	var FOURTH_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP = exports.FOURTH_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP = 63;
	var OVERTIME_GROUP = exports.OVERTIME_GROUP = 64;
	var FIRST_OVERTIME_GROUP = exports.FIRST_OVERTIME_GROUP = 65;
	var SECOND_OVERTIME_GROUP = exports.SECOND_OVERTIME_GROUP = 66;
	var PENALTIES_GROUP = exports.PENALTIES_GROUP = 67;
	var FIRST_HALF_GROUP = exports.FIRST_HALF_GROUP = 68;
	var SECOND_HALF_GROUP = exports.SECOND_HALF_GROUP = 69;

/***/ },
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var REQUEST = 'REQUEST';
	var SUCCESS = 'SUCCESS';
	var FAILURE = 'FAILURE';
	
	function createRequestTypes(base) {
	    var res = {};
	    [REQUEST, SUCCESS, FAILURE].forEach(function (type) {
	        return res[type] = base + '_' + type;
	    });
	    return res;
	}
	
	function action(type) {
	    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var section = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	
	    return {
	        type: type,
	        data: data,
	        section: section
	    };
	}
	
	var LIVE_INIT = exports.LIVE_INIT = createRequestTypes('LIVE_INIT');
	var LIVE_UPDATE = exports.LIVE_UPDATE = createRequestTypes('LIVE_UPDATE');
	
	var TIMETABLE_INIT = exports.TIMETABLE_INIT = createRequestTypes('TIMETABLE_INIT');
	var TIMETABLE_UPDATE = exports.TIMETABLE_UPDATE = createRequestTypes('TIMETABLE_UPDATE');
	
	var GET_BALANCE = exports.GET_BALANCE = createRequestTypes('GET_BALANCE');
	var GET_NEW_MESSAGES = exports.GET_NEW_MESSAGES = createRequestTypes('GET_NEW_MESSAGES');
	var GET_FREEBET = exports.GET_FREEBET = createRequestTypes('GET_FREEBET');
	
	var GET_BET_STATUS = exports.GET_BET_STATUS = createRequestTypes('GET_BET_STATUS');
	var GET_STAKE_STATUS = exports.GET_STAKE_STATUS = createRequestTypes('GET_STAKE_STATUS');
	var GET_CASHOUT_STATUS = exports.GET_CASHOUT_STATUS = createRequestTypes('GET_CASHOUT_STATUS');
	
	var sagaActions = exports.sagaActions = {
	    live_initial: {
	        request: function request(data) {
	            return action(LIVE_INIT.REQUEST, { languageId: data.languageId }, 'live');
	        },
	        success: function success(data) {
	            return action(LIVE_INIT.SUCCESS, data, 'live');
	        },
	        failure: function failure(data, error) {
	            return action(LIVE_INIT.FAILURE, { languageId: data.languageId, error: error }, 'live');
	        }
	    },
	    live_update: {
	        request: function request(data) {
	            return action(LIVE_UPDATE.REQUEST, { languageId: data.languageId, version: data.version }, 'live');
	        },
	        success: function success(data) {
	            return action(LIVE_UPDATE.SUCCESS, data, 'live');
	        },
	        failure: function failure(data, error) {
	            return action(LIVE_UPDATE.FAILURE, { languageId: data.languageId, version: data.version, error: error }, 'live');
	        }
	    },
	    timetable_initial: {
	        request: function request(data) {
	            return action(TIMETABLE_INIT.REQUEST, { languageId: data.languageId }, 'timetable');
	        },
	        success: function success(data) {
	            return action(TIMETABLE_INIT.SUCCESS, data, 'timetable');
	        },
	        failure: function failure(data, error) {
	            return action(TIMETABLE_INIT.FAILURE, { languageId: data.languageId, error: error }, 'timetable');
	        }
	    },
	    timetable_update: {
	        request: function request(data) {
	            return action(TIMETABLE_UPDATE.REQUEST, { languageId: data.languageId, version: data.version }, 'timetable');
	        },
	        success: function success(data) {
	            return action(TIMETABLE_UPDATE.SUCCESS, data, 'timetable');
	        },
	        failure: function failure(data, error) {
	            return action(TIMETABLE_UPDATE.FAILURE, { languageId: data.languageId, version: data.version, error: error }, 'timetable');
	        }
	    },
	    get_balance: {
	        request: function request(data) {
	            return action(GET_BALANCE.REQUEST, data);
	        },
	        success: function success(data) {
	            return action(GET_BALANCE.SUCCESS, data);
	        },
	        failure: function failure() {
	            return action(GET_BALANCE.FAILURE);
	        }
	    },
	    get_new_messages: {
	        request: function request() {
	            return action(GET_NEW_MESSAGES.REQUEST);
	        },
	        success: function success(data) {
	            return action(GET_NEW_MESSAGES.SUCCESS, data);
	        },
	        failure: function failure() {
	            return action(GET_NEW_MESSAGES.FAILURE);
	        }
	    },
	    get_freebet: {
	        request: function request() {
	            return action(GET_FREEBET.REQUEST);
	        },
	        success: function success(data) {
	            return action(GET_FREEBET.SUCCESS, data);
	        },
	        failure: function failure() {
	            return action(GET_FREEBET.FAILURE);
	        }
	    },
	    get_bet_status: {
	        request: function request(data) {
	            return action(GET_BET_STATUS.REQUEST, data);
	        },
	        success: function success(data) {
	            return action(GET_BET_STATUS.SUCCESS, data);
	        },
	        failure: function failure(data) {
	            return action(GET_BET_STATUS.FAILURE, data);
	        }
	    },
	    get_stake_status: {
	        request: function request(data) {
	            return action(GET_STAKE_STATUS.REQUEST, data);
	        },
	        success: function success(data) {
	            return action(GET_STAKE_STATUS.SUCCESS, data);
	        },
	        failure: function failure(data) {
	            return action(GET_STAKE_STATUS.FAILURE, data);
	        }
	    },
	    get_cashout_status: {
	        request: function request(data) {
	            return action(GET_CASHOUT_STATUS.REQUEST, data);
	        },
	        success: function success(data) {
	            return action(GET_CASHOUT_STATUS.SUCCESS, data);
	        },
	        failure: function failure(data) {
	            return action(GET_CASHOUT_STATUS.FAILURE, data);
	        }
	    }
	};

/***/ },
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var REQUEST_FULL_LINE = exports.REQUEST_FULL_LINE = 'REQUEST_FULL_LINE';
	var SUCCESS_REQUEST_FULL_LINE = exports.SUCCESS_REQUEST_FULL_LINE = 'SUCCESS_REQUEST_FULL_LINE';
	var FAILURE_REQUEST_FULL_LINE = exports.FAILURE_REQUEST_FULL_LINE = 'FAILURE_REQUEST_FULL_LINE';
	
	var REQUEST_LINE_HEADERS = exports.REQUEST_LINE_HEADERS = 'REQUEST_LINE_HEADERS';
	var SUCCESS_REQUEST_LINE_HEADERS = exports.SUCCESS_REQUEST_LINE_HEADERS = 'SUCCESS_REQUEST_LINE_HEADERS';
	var FAILURE_REQUEST_LINE_HEADERS = exports.FAILURE_REQUEST_LINE_HEADERS = 'FAILURE_REQUEST_LINE_HEADERS';
	
	var REQUEST_SPORT_LINE_HEADERS = exports.REQUEST_SPORT_LINE_HEADERS = 'REQUEST_SPORT_LINE_HEADERS';
	var SUCCESS_REQUEST_SPORT_LINE_HEADERS = exports.SUCCESS_REQUEST_SPORT_LINE_HEADERS = 'SUCCESS_REQUEST_SPORT_LINE_HEADERS';
	var FAILURE_REQUEST_SPORT_LINE_HEADERS = exports.FAILURE_REQUEST_SPORT_LINE_HEADERS = 'FAILURE_REQUEST_SPORT_LINE_HEADERS';
	
	var REQUEST_LEAGUE_LINE_HEADERS = exports.REQUEST_LEAGUE_LINE_HEADERS = 'REQUEST_LEAGUE_LINE_HEADERS';
	var SUCCESS_REQUEST_LEAGUE_LINE_HEADERS = exports.SUCCESS_REQUEST_LEAGUE_LINE_HEADERS = 'SUCCESS_REQUEST_LEAGUE_LINE_HEADERS';
	var FAILURE_REQUEST_LEAGUE_LINE_HEADERS = exports.FAILURE_REQUEST_LEAGUE_LINE_HEADERS = 'FAILURE_REQUEST_LEAGUE_LINE_HEADERS';
	
	var CLEAR_LINE = exports.CLEAR_LINE = 'CLEAR_LINE';
	
	var SHOW_LINE_NUMBERS = exports.SHOW_LINE_NUMBERS = 'SHOW_LINE_NUMBERS';
	var HIDE_LINE_NUMBERS = exports.HIDE_LINE_NUMBERS = 'HIDE_LINE_NUMBERS';

/***/ },
/* 39 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CLEAR_LIVE = exports.CLEAR_LIVE = 'CLEAR_LIVE';

/***/ },
/* 40 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Match = exports.Match = 1;
	var MatchPoints = exports.MatchPoints = 2;
	var FirstPeriod = exports.FirstPeriod = 3;
	var SecondPeriod = exports.SecondPeriod = 4;
	var ThirdPeriod = exports.ThirdPeriod = 5;
	var FourthPeriod = exports.FourthPeriod = 6;
	var FifthPeriod = exports.FifthPeriod = 7;
	var SixthPeriod = exports.SixthPeriod = 8;
	var SeventhPeriod = exports.SeventhPeriod = 9;
	var EighthPeriod = exports.EighthPeriod = 10;
	var TennisServe = exports.TennisServe = 40;
	var RedCard = exports.RedCard = 41;
	var Penalty = exports.Penalty = 42;
	var YellowCard = exports.YellowCard = 43;
	var CurrentGame = exports.CurrentGame = 44;
	var PowerPlay = exports.PowerPlay = 45;
	var Feed = exports.Feed = 46;
	var Overtime = exports.Overtime = 47;
	var Corner = exports.Corner = 48;
	var BallPossession = exports.BallPossession = 49;
	var Timeout = exports.Timeout = 50;
	var FirstPeriodFouls = exports.FirstPeriodFouls = 51;
	var SecondPeriodFouls = exports.SecondPeriodFouls = 52;
	var ThirdPeriodFouls = exports.ThirdPeriodFouls = 53;
	var FourthPeriodFouls = exports.FourthPeriodFouls = 54;
	var PenaltySeries = exports.PenaltySeries = 55;
	var ExtraTime = exports.ExtraTime = 56;

/***/ },
/* 41 */,
/* 42 */,
/* 43 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./type')} */
	module.exports = TypeError;


/***/ },
/* 44 */,
/* 45 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.makeFieldValue = makeFieldValue;
	exports.isFieldValue = isFieldValue;
	var flag = '_isFieldValue';
	var isObject = function isObject(object) {
	  return typeof object === 'object';
	};
	
	function makeFieldValue(object) {
	  if (object && isObject(object)) {
	    Object.defineProperty(object, flag, { value: true });
	  }
	  return object;
	}
	
	function isFieldValue(object) {
	  return !!(object && isObject(object) && object[flag]);
	}

/***/ },
/* 46 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SINGLE = exports.SINGLE = 1;
	var EXPRESS = exports.EXPRESS = 2;
	var SYSTEM = exports.SYSTEM = 3;
	var ANTIEXPRESS = exports.ANTIEXPRESS = 5;

/***/ },
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GET_STAKE_OF_THE_DAY = exports.GET_STAKE_OF_THE_DAY = 'GET_STAKE_OF_THE_DAY';
	var SUCCESS_GET_STAKE_OF_THE_DAY = exports.SUCCESS_GET_STAKE_OF_THE_DAY = 'SUCCESS_GET_STAKE_OF_THE_DAY';
	var FAILURE_GET_STAKE_OF_THE_DAY = exports.FAILURE_GET_STAKE_OF_THE_DAY = 'FAILURE_GET_STAKE_OF_THE_DAY';

/***/ },
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(282);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
	
	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var defineDataProperty = __webpack_require__(105);
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var supportsDescriptors = __webpack_require__(109)();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object) {
			if (predicate === true) {
				if (object[name] === value) {
					return;
				}
			} else if (!isFunction(predicate) || !predicate()) {
				return;
			}
		}
	
		if (supportsDescriptors) {
			defineDataProperty(object, name, value, true);
		} else {
			defineDataProperty(object, name, value);
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var undefined;
	
	var $Error = __webpack_require__(426);
	var $EvalError = __webpack_require__(425);
	var $RangeError = __webpack_require__(427);
	var $ReferenceError = __webpack_require__(428);
	var $SyntaxError = __webpack_require__(170);
	var $TypeError = __webpack_require__(43);
	var $URIError = __webpack_require__(429);
	
	var $Function = Function;
	
	// eslint-disable-next-line consistent-return
	var getEvalledConstructor = function (expressionSyntax) {
		try {
			return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
		} catch (e) {}
	};
	
	var $gOPD = Object.getOwnPropertyDescriptor;
	if ($gOPD) {
		try {
			$gOPD({}, '');
		} catch (e) {
			$gOPD = null; // this is IE 8, which has a broken gOPD
		}
	}
	
	var throwTypeError = function () {
		throw new $TypeError();
	};
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(434)();
	var hasProto = __webpack_require__(433)();
	
	var getProto = Object.getPrototypeOf || (
		hasProto
			? function (x) { return x.__proto__; } // eslint-disable-line no-proto
			: null
	);
	
	var needsEval = {};
	
	var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		__proto__: null,
		'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': needsEval,
		'%AsyncGenerator%': needsEval,
		'%AsyncGeneratorFunction%': needsEval,
		'%AsyncIteratorPrototype%': needsEval,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
		'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
		'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
		'%Boolean%': Boolean,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%Date%': Date,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': $Error,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': $EvalError,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
		'%Function%': $Function,
		'%GeneratorFunction%': needsEval,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%Math%': Math,
		'%Number%': Number,
		'%Object%': Object,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': $RangeError,
		'%ReferenceError%': $ReferenceError,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SyntaxError%': $SyntaxError,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypeError%': $TypeError,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%URIError%': $URIError,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
	};
	
	if (getProto) {
		try {
			null.error; // eslint-disable-line no-unused-expressions
		} catch (e) {
			// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
			var errorProto = getProto(getProto(e));
			INTRINSICS['%Error.prototype%'] = errorProto;
		}
	}
	
	var doEval = function doEval(name) {
		var value;
		if (name === '%AsyncFunction%') {
			value = getEvalledConstructor('async function () {}');
		} else if (name === '%GeneratorFunction%') {
			value = getEvalledConstructor('function* () {}');
		} else if (name === '%AsyncGeneratorFunction%') {
			value = getEvalledConstructor('async function* () {}');
		} else if (name === '%AsyncGenerator%') {
			var fn = doEval('%AsyncGeneratorFunction%');
			if (fn) {
				value = fn.prototype;
			}
		} else if (name === '%AsyncIteratorPrototype%') {
			var gen = doEval('%AsyncGenerator%');
			if (gen && getProto) {
				value = getProto(gen.prototype);
			}
		}
	
		INTRINSICS[name] = value;
	
		return value;
	};
	
	var LEGACY_ALIASES = {
		__proto__: null,
		'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
		'%ArrayPrototype%': ['Array', 'prototype'],
		'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
		'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
		'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
		'%ArrayProto_values%': ['Array', 'prototype', 'values'],
		'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
		'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
		'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
		'%BooleanPrototype%': ['Boolean', 'prototype'],
		'%DataViewPrototype%': ['DataView', 'prototype'],
		'%DatePrototype%': ['Date', 'prototype'],
		'%ErrorPrototype%': ['Error', 'prototype'],
		'%EvalErrorPrototype%': ['EvalError', 'prototype'],
		'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
		'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
		'%FunctionPrototype%': ['Function', 'prototype'],
		'%Generator%': ['GeneratorFunction', 'prototype'],
		'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
		'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
		'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
		'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
		'%JSONParse%': ['JSON', 'parse'],
		'%JSONStringify%': ['JSON', 'stringify'],
		'%MapPrototype%': ['Map', 'prototype'],
		'%NumberPrototype%': ['Number', 'prototype'],
		'%ObjectPrototype%': ['Object', 'prototype'],
		'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
		'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
		'%PromisePrototype%': ['Promise', 'prototype'],
		'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
		'%Promise_all%': ['Promise', 'all'],
		'%Promise_reject%': ['Promise', 'reject'],
		'%Promise_resolve%': ['Promise', 'resolve'],
		'%RangeErrorPrototype%': ['RangeError', 'prototype'],
		'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
		'%RegExpPrototype%': ['RegExp', 'prototype'],
		'%SetPrototype%': ['Set', 'prototype'],
		'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
		'%StringPrototype%': ['String', 'prototype'],
		'%SymbolPrototype%': ['Symbol', 'prototype'],
		'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
		'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
		'%TypeErrorPrototype%': ['TypeError', 'prototype'],
		'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
		'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
		'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
		'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
		'%URIErrorPrototype%': ['URIError', 'prototype'],
		'%WeakMapPrototype%': ['WeakMap', 'prototype'],
		'%WeakSetPrototype%': ['WeakSet', 'prototype']
	};
	
	var bind = __webpack_require__(108);
	var hasOwn = __webpack_require__(435);
	var $concat = bind.call(Function.call, Array.prototype.concat);
	var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
	var $replace = bind.call(Function.call, String.prototype.replace);
	var $strSlice = bind.call(Function.call, String.prototype.slice);
	var $exec = bind.call(Function.call, RegExp.prototype.exec);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var first = $strSlice(string, 0, 1);
		var last = $strSlice(string, -1);
		if (first === '%' && last !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
		} else if (last === '%' && first !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
		}
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		var intrinsicName = name;
		var alias;
		if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
			alias = LEGACY_ALIASES[intrinsicName];
			intrinsicName = '%' + alias[0] + '%';
		}
	
		if (hasOwn(INTRINSICS, intrinsicName)) {
			var value = INTRINSICS[intrinsicName];
			if (value === needsEval) {
				value = doEval(intrinsicName);
			}
			if (typeof value === 'undefined' && !allowMissing) {
				throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
			}
	
			return {
				alias: alias,
				name: intrinsicName,
				value: value
			};
		}
	
		throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new $TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new $TypeError('"allowMissing" argument must be a boolean');
		}
	
		if ($exec(/^%?[^%]*%?$/, name) === null) {
			throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
		}
		var parts = stringToPath(name);
		var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
	
		var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
		var intrinsicRealName = intrinsic.name;
		var value = intrinsic.value;
		var skipFurtherCaching = false;
	
		var alias = intrinsic.alias;
		if (alias) {
			intrinsicBaseName = alias[0];
			$spliceApply(parts, $concat([0, 1], alias));
		}
	
		for (var i = 1, isOwn = true; i < parts.length; i += 1) {
			var part = parts[i];
			var first = $strSlice(part, 0, 1);
			var last = $strSlice(part, -1);
			if (
				(
					(first === '"' || first === "'" || first === '`')
					|| (last === '"' || last === "'" || last === '`')
				)
				&& first !== last
			) {
				throw new $SyntaxError('property names with quotes must have matching quotes');
			}
			if (part === 'constructor' || !isOwn) {
				skipFurtherCaching = true;
			}
	
			intrinsicBaseName += '.' + part;
			intrinsicRealName = '%' + intrinsicBaseName + '%';
	
			if (hasOwn(INTRINSICS, intrinsicRealName)) {
				value = INTRINSICS[intrinsicRealName];
			} else if (value != null) {
				if (!(part in value)) {
					if (!allowMissing) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					return void undefined;
				}
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, part);
					isOwn = !!desc;
	
					// By convention, when a data property is converted to an accessor
					// property to emulate a data property that does not suffer from
					// the override mistake, that accessor's getter is marked with
					// an `originalValue` property. Here, when we detect this, we
					// uphold the illusion by pretending to see that original data
					// property, i.e., returning the value rather than the getter
					// itself.
					if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
						value = desc.get;
					} else {
						value = value[part];
					}
				} else {
					isOwn = hasOwn(value, part);
					value = value[part];
				}
	
				if (isOwn && !skipFurtherCaching) {
					INTRINSICS[intrinsicRealName] = value;
				}
			}
		}
		return value;
	};


/***/ },
/* 58 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GET_POPULAR_MATCHES = exports.GET_POPULAR_MATCHES = 'GET_POPULAR_MATCHES';
	var SUCCESS_GET_POPULAR_MATCHES = exports.SUCCESS_GET_POPULAR_MATCHES = 'SUCCESS_GET_POPULAR_MATCHES';
	var FAILURE_GET_POPULAR_MATCHES = exports.FAILURE_GET_POPULAR_MATCHES = 'FAILURE_GET_POPULAR_MATCHES';

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.resourceNames = exports.UZ = exports.KZ = exports.KG = undefined;
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _resourceNames2;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var KG = exports.KG = 1;
	var KZ = exports.KZ = 4;
	var UZ = exports.UZ = 15;
	
	var _resourceNames = (_resourceNames2 = {}, (0, _defineProperty3.default)(_resourceNames2, KG, 'OPX'), (0, _defineProperty3.default)(_resourceNames2, 2, 'RUR'), (0, _defineProperty3.default)(_resourceNames2, 3, 'TJS'), (0, _defineProperty3.default)(_resourceNames2, KZ, 'KZT'), (0, _defineProperty3.default)(_resourceNames2, 5, 'USD'), (0, _defineProperty3.default)(_resourceNames2, 6, 'EUR'), (0, _defineProperty3.default)(_resourceNames2, 7, 'GBP'), (0, _defineProperty3.default)(_resourceNames2, 8, 'KSH'), (0, _defineProperty3.default)(_resourceNames2, 9, 'PEN'), (0, _defineProperty3.default)(_resourceNames2, 10, 'VRT'), (0, _defineProperty3.default)(_resourceNames2, UZ, 'UZS'), (0, _defineProperty3.default)(_resourceNames2, 101, 'WMZ'), (0, _defineProperty3.default)(_resourceNames2, 102, 'WMR'), (0, _defineProperty3.default)(_resourceNames2, 103, 'WME'), (0, _defineProperty3.default)(_resourceNames2, 104, 'WMU'), (0, _defineProperty3.default)(_resourceNames2, 201, 'YAD'), _resourceNames2);
	Object.defineProperty(_resourceNames, 'getCurrencyTag', {
	    value: function value() {
	        var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
	
	        switch (id) {
	            case 1:
	                return 'KGS';
	            default:
	                return this[id];
	        }
	    },
	    enumerable: false,
	    configurable: false,
	    writable: false
	});
	var resourceNames = exports.resourceNames = _resourceNames;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Loader = function Loader() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'showbox' },
	        _react2.default.createElement(
	            'div',
	            { className: 'loader' },
	            _react2.default.createElement(
	                'svg',
	                { className: 'circular', viewBox: '25 25 50 50' },
	                _react2.default.createElement('circle', { className: 'path', cx: '50', cy: '50', r: '20', fill: 'none', strokeWidth: '2', strokeMiterlimit: '10' })
	            )
	        )
	    );
	};
	
	exports.default = Loader;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2018 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString === Object.prototype.toString) {
						for (var key in arg) {
							if (hasOwn.call(arg, key) && arg[key]) {
								classes.push(key);
							}
						}
					} else {
						classes.push(arg.toString());
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.removeHistoryBet = removeHistoryBet;
	exports.removeHistoryBets = removeHistoryBets;
	exports.requestBetTypes = requestBetTypes;
	
	var _api = __webpack_require__(13);
	
	var _HistoryBet = __webpack_require__(302);
	
	var ActionTypes = _interopRequireWildcard(_HistoryBet);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function removeHistoryBet(data) {
	    return { type: ActionTypes.REMOVE_HISTORY_BET, data: data };
	}
	
	function removeHistoryBets(data) {
	    return { type: ActionTypes.REMOVE_HISTORY_BETS, data: data };
	}
	
	function fetchBetTypes(data) {
	    return (0, _defineProperty3.default)({
	        type: ActionTypes.REQUEST_BET_TYPES
	    }, _api.CALL_API, {
	        endpoint: '/api/bet/basket',
	        method: 'post',
	        types: [ActionTypes.SUCCESS_REQUEST_BET_TYPES, ActionTypes.FAILURE_REQUEST_BET_TYPES],
	        credentials: true,
	        data: data
	    });
	}
	
	function requestBetTypes() {
	    return function (dispatch, getState) {
	        try {
	            var couponBetSlips = getState().application.getIn(['coupon', 'betSlips']);
	            if (!couponBetSlips) {
	                return null;
	            }
	
	            var factors = [];
	
	            couponBetSlips.forEach(function (r) {
	                var rate = r.get('rate');
	                var match = r.get('match');
	
	                var basket = {
	                    eventId: rate.get('matchId'),
	                    eventTimeAndZone: match.get('timeAndZone'),
	                    outcomeId: rate.get('outcomeId'),
	                    factorId: rate.get('id')
	                };
	
	                factors.push(basket);
	            });
	
	            return dispatch(fetchBetTypes(factors));
	        } catch (error) {
	            return null;
	        }
	    };
	}

/***/ },
/* 66 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.removeEntities = removeEntities;
	exports.myRemoveEntities = myRemoveEntities;
	exports.myRemoveEntitiesBySport = myRemoveEntitiesBySport;
	function removeEntities(entities, field, values) {
	    if (values === undefined) {
	        return entities;
	    }
	
	    var idsToRemove = entities.valueSeq().filter(function (m) {
	        return values.indexOf(m.get(field)) !== -1;
	    }).map(function (m) {
	        return m.get('id');
	    }).toArray();
	
	    entities = entities.withMutations(function (e) {
	        for (var j = 0; j < idsToRemove.length; j++) {
	            var id = idsToRemove[j];
	            e.delete(id);
	        }
	    });
	
	    return entities;
	}
	
	function myRemoveEntities(entities, field, values) {
	    if (values === undefined) {
	        return entities;
	    }
	
	    if (entities.size <= 0) {
	        return entities;
	    }
	
	    var idsToRemove = values.map(function (v) {
	        return v.id;
	    });
	
	    entities = entities.filter(function (e) {
	        var fieldValue = Number(e.get(field));
	
	        return idsToRemove.indexOf(fieldValue) == -1;
	    });
	
	    return entities;
	}
	
	function myRemoveEntitiesBySport(entities, field, values) {
	    if (values === undefined) {
	        return entities;
	    }
	
	    if (entities.size <= 0) {
	        return entities;
	    }
	
	    entities = entities.filter(function (e) {
	        var fieldValue = Number(e.get(field));
	
	        return values.indexOf(fieldValue) == -1;
	    });
	
	    return entities;
	}

/***/ },
/* 67 */,
/* 68 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FETCH_MATCH_RESULTS = exports.FETCH_MATCH_RESULTS = 'FETCH_MATCH_RESULTS';
	var SUCCESS_FETCH_MATCH_RESULTS = exports.SUCCESS_FETCH_MATCH_RESULTS = 'SUCCESS_FETCH_MATCH_RESULTS';
	var FAILURE_FETCH_MATCH_RESULTS = exports.FAILURE_FETCH_MATCH_RESULTS = 'FAILURE_FETCH_MATCH_RESULTS';

/***/ },
/* 69 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_STORAGE = exports.LOAD_STORAGE = 'LOAD_STORAGE';

/***/ },
/* 70 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CLEAR_TIME_TABLE = exports.CLEAR_TIME_TABLE = 'CLEAR_TIME_TABLE';

/***/ },
/* 71 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CHANGE_LANGUAGE = exports.CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.addCouponRate = addCouponRate;
	exports.removeCouponRate = removeCouponRate;
	exports.removeCouponRates = removeCouponRates;
	exports.setCouponBetType = setCouponBetType;
	exports.setCouponAmount = setCouponAmount;
	exports.acceptRateValueChange = acceptRateValueChange;
	exports.addRate = addRate;
	exports.changeCouponSlipAmount = changeCouponSlipAmount;
	
	var _immutable = __webpack_require__(14);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _axios = __webpack_require__(146);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _AcceptFactorChange = __webpack_require__(333);
	
	var AcceptFactorChangeMode = _interopRequireWildcard(_AcceptFactorChange);
	
	var _BetType = __webpack_require__(46);
	
	var BetType = _interopRequireWildcard(_BetType);
	
	var _accountResourceNames = __webpack_require__(59);
	
	var resources = _interopRequireWildcard(_accountResourceNames);
	
	var _StakeMinAmount = __webpack_require__(135);
	
	var _StakeMaxAmount = __webpack_require__(570);
	
	var _CouponRate = __webpack_require__(130);
	
	var ActionTypes = _interopRequireWildcard(_CouponRate);
	
	var _MakeBet = __webpack_require__(133);
	
	var _balanceAction = __webpack_require__(132);
	
	var _HistoryBet = __webpack_require__(65);
	
	var _CouponDropDownMenu = __webpack_require__(306);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addCouponRate(data) {
	    try {
	        _axios2.default.post('/api/actions/set?type=rate');
	    } catch (error) {}
	    return { type: ActionTypes.ADD_COUPON_RATE, data: data };
	}
	
	function removeCouponRate(data) {
	    return function (dispatch, getState) {
	        var betSlips = getState().application.getIn(['coupon', 'betSlips']);
	
	        if (betSlips.size === 1) {
	            return dispatch(removeCouponRates(data));
	        } else {
	            return dispatch({ type: ActionTypes.REMOVE_COUPON_RATE, data: data });
	        }
	    };
	}
	
	function removeCouponRates(data) {
	    return { type: ActionTypes.REMOVE_COUPON_RATES, data: data };
	}
	
	function setCouponBetType(data) {
	    return { type: ActionTypes.SET_COUPON_BET_TYPE, data: data };
	}
	
	function setCouponAmount(data) {
	    return { type: ActionTypes.SET_COUPON_AMOUNT, data: data };
	}
	
	function acceptRateValueChange(data) {
	    return { type: ActionTypes.ACCEPT_RATE_VALUE_CHANGE, data: data };
	}
	
	function addRate(data) {
	    return function (dispatch, getState) {
	        var rate = data.rate,
	            match = data.match,
	            outcome = data.outcome,
	            score = data.score;
	
	
	        var bettingMode = getState().application.get('bettingMode');
	        var oneClickMode = bettingMode.get('isOneClick');
	
	        var betHistory = getState().application.get('betHistory');
	        var user = getState().auth.get('user');
	
	        var acceptFactorChangeMode = bettingMode.get('acceptFactorChange');
	        var oneClickAmount = bettingMode.get('oneClickAmount') || 50;
	        var isVerified = user && user.get('isVerified');
	
	        if (user) {
	            var resourceId = user.get('resourceId');
	            var currency = resources.resourceNames[resourceId];
	            var minStakeAmount = _StakeMinAmount.minAmount[currency];
	            var maxStakeAmount = _StakeMaxAmount.maxAmount[currency];
	
	            if ((0, _CouponDropDownMenu.isMinAndMaxValueWrong)(minStakeAmount, maxStakeAmount, oneClickAmount)) {
	                oneClickMode = false;
	            }
	        }
	
	        if (oneClickMode) {
	            var accountId = user.get('accountId');
	
	            var allowIncrease = false;
	            var allowDecrease = false;
	
	            if (acceptFactorChangeMode === AcceptFactorChangeMode.INCREASE) {
	                allowIncrease = true;
	            } else if (acceptFactorChangeMode === AcceptFactorChangeMode.DECREASE) {
	                allowDecrease = true;
	            } else if (acceptFactorChangeMode === AcceptFactorChangeMode.BOTH) {
	                allowIncrease = true;
	                allowDecrease = true;
	            }
	
	            var odd = rate.get('value');
	            var betId = betHistory.size > 0 ? parseInt(betHistory.keySeq().maxBy(function (x) {
	                return parseInt(x);
	            })) + 1 : '1';
	
	            var bets = [];
	            var historyBets = [];
	
	            var rateId = rate.get('id');
	
	            var factors = new _immutable.List().push(new _immutable.Map({
	                eventId: match.get('id'),
	                eventTimeAndZone: match.get('timeAndZone'),
	                outcomeId: outcome.get('id'),
	                factorId: rateId,
	                factorValue: rate.get('value'),
	                isConditional: false
	            }));
	
	            bets.push({
	                id: betId.toString(),
	                type: BetType.SINGLE,
	                rank: undefined,
	                amount: oneClickAmount,
	                factorValue: odd,
	                factors: factors,
	                oneClick: true,
	                allowIncrease: allowIncrease,
	                allowDecrease: allowDecrease,
	                isFreebet: false
	            });
	
	            var rates = new _immutable.Map().set(rateId, _immutable2.default.fromJS({
	                rate: rate,
	                outcome: {
	                    name: outcome.get('name')
	                },
	                match: {
	                    timeAndZone: match.get('timeAndZone'),
	                    name: match.get('name')
	                },
	                score: {
	                    score1: score ? score.get('score1') : undefined,
	                    score2: score ? score.get('score2') : undefined
	                }
	            }));
	
	            historyBets.push({
	                id: betId.toString(),
	                betType: BetType.SINGLE,
	                rank: undefined,
	                amount: oneClickAmount,
	                odd: odd,
	                betSlips: rates
	            });
	
	            if (isVerified === false) {
	                window.toggleVerifyModal && window.toggleVerifyModal(true);
	            } else {
	                dispatch((0, _MakeBet.makeBet)(bets, historyBets));
	            }
	            return dispatch((0, _balanceAction.balance)(accountId));
	        }
	
	        dispatch(addCouponRate({
	            rate: rate,
	            match: match,
	            outcome: outcome,
	            score: score
	        }));
	        return dispatch((0, _HistoryBet.requestBetTypes)());
	    };
	}
	
	function changeCouponSlipAmount(data) {
	    return { type: ActionTypes.CHANGE_COUPON_SLIP_AMOUNT, data: data };
	}

/***/ },
/* 73 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MATCH_NOT_STARTED = exports.MATCH_NOT_STARTED = 1;
	var MATCH_FINISHED = exports.MATCH_FINISHED = 2;
	var INTERMISSION = exports.INTERMISSION = 3;
	var FULL_TIME = exports.FULL_TIME = 4;
	var FIRST_EXTRA_ENDED = exports.FIRST_EXTRA_ENDED = 5;
	var PENALTY_SERIES = exports.PENALTY_SERIES = 6;

/***/ },
/* 74 */,
/* 75 */,
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	var moment = module.exports = __webpack_require__(441);
	moment.tz.load(__webpack_require__(440));


/***/ },
/* 77 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isValid;
	function isValid(error) {
	  if (Array.isArray(error)) {
	    return error.reduce(function (valid, errorValue) {
	      return valid && isValid(errorValue);
	    }, true);
	  }
	  if (error && typeof error === 'object') {
	    return Object.keys(error).reduce(function (valid, key) {
	      return valid && isValid(error[key]);
	    }, true);
	  }
	  return !error;
	}

/***/ },
/* 78 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ALL = exports.ALL = 1;
	var FAVOURITE = exports.FAVOURITE = 2;
	var SPORT = exports.SPORT = 3;
	var LEAGUE = exports.LEAGUE = 4;
	var MATCH = exports.MATCH = 5;
	var TIMETABLE = exports.TIMETABLE = 6;

/***/ },
/* 79 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NONE = exports.NONE = 1;
	var PARTIAL = exports.PARTIAL = 2;
	var FULL = exports.FULL = 3;

/***/ },
/* 80 */,
/* 81 */,
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(701);


/***/ },
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(653)();
	}


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseStartTime = parseStartTime;
	exports.parseEndTime = parseEndTime;
	exports.randomString = randomString;
	exports.queryString = queryString;
	exports.getSDK = getSDK;
	exports.getConfig = getConfig;
	exports.omit = omit;
	exports.callPlayer = callPlayer;
	exports.isObject = isObject;
	exports.isEqual = isEqual;
	exports.isMediaStream = isMediaStream;
	
	var _loadScript = _interopRequireDefault(__webpack_require__(1835));
	
	var _deepmerge = _interopRequireDefault(__webpack_require__(1657));
	
	var _props = __webpack_require__(548);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
	var MATCH_END_QUERY = /[?&#]end=([0-9hms]+)/;
	var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
	var MATCH_NUMERIC = /^\d+$/; // Parse YouTube URL for a start time param, ie ?t=1h14m30s
	// and return the start time in seconds
	
	function parseTimeParam(url, pattern) {
	  var match = url.match(pattern);
	
	  if (match) {
	    var stamp = match[1];
	
	    if (stamp.match(MATCH_START_STAMP)) {
	      return parseTimeString(stamp);
	    }
	
	    if (MATCH_NUMERIC.test(stamp)) {
	      return parseInt(stamp);
	    }
	  }
	
	  return undefined;
	}
	
	function parseTimeString(stamp) {
	  var seconds = 0;
	  var array = MATCH_START_STAMP.exec(stamp);
	
	  while (array !== null) {
	    var _array = array,
	        _array2 = _slicedToArray(_array, 3),
	        count = _array2[1],
	        period = _array2[2];
	
	    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
	    if (period === 'm') seconds += parseInt(count, 10) * 60;
	    if (period === 's') seconds += parseInt(count, 10);
	    array = MATCH_START_STAMP.exec(stamp);
	  }
	
	  return seconds;
	}
	
	function parseStartTime(url) {
	  return parseTimeParam(url, MATCH_START_QUERY);
	}
	
	function parseEndTime(url) {
	  return parseTimeParam(url, MATCH_END_QUERY);
	} // http://stackoverflow.com/a/38622545
	
	
	function randomString() {
	  return Math.random().toString(36).substr(2, 5);
	}
	
	function queryString(object) {
	  return Object.keys(object).map(function (key) {
	    return "".concat(key, "=").concat(object[key]);
	  }).join('&');
	} // Util function to load an external SDK
	// or return the SDK if it is already loaded
	
	
	var requests = {};
	
	function getSDK(url, sdkGlobal) {
	  var sdkReady = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  var isLoaded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
	    return true;
	  };
	  var fetchScript = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _loadScript["default"];
	
	  if (window[sdkGlobal] && isLoaded(window[sdkGlobal])) {
	    return Promise.resolve(window[sdkGlobal]);
	  }
	
	  return new Promise(function (resolve, reject) {
	    // If we are already loading the SDK, add the resolve and reject
	    // functions to the existing array of requests
	    if (requests[url]) {
	      requests[url].push({
	        resolve: resolve,
	        reject: reject
	      });
	      return;
	    }
	
	    requests[url] = [{
	      resolve: resolve,
	      reject: reject
	    }];
	
	    var onLoaded = function onLoaded(sdk) {
	      // When loaded, resolve all pending request promises
	      requests[url].forEach(function (request) {
	        return request.resolve(sdk);
	      });
	    };
	
	    if (sdkReady) {
	      var previousOnReady = window[sdkReady];
	
	      window[sdkReady] = function () {
	        if (previousOnReady) previousOnReady();
	        onLoaded(window[sdkGlobal]);
	      };
	    }
	
	    fetchScript(url, function (err) {
	      if (err) {
	        // Loading the SDK failed – reject all requests and
	        // reset the array of requests for this SDK
	        requests[url].forEach(function (request) {
	          return request.reject(err);
	        });
	        requests[url] = [];
	      } else if (!sdkReady) {
	        onLoaded(window[sdkGlobal]);
	      }
	    });
	  });
	}
	
	function getConfig(props, defaultProps, showWarning) {
	  var config = (0, _deepmerge["default"])(defaultProps.config, props.config);
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = _props.DEPRECATED_CONFIG_PROPS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var p = _step.value;
	
	      if (props[p]) {
	        var key = p.replace(/Config$/, '');
	        config = (0, _deepmerge["default"])(config, _defineProperty({}, key, props[p]));
	
	        if (showWarning) {
	          var link = 'https://github.com/CookPete/react-player#config-prop';
	          var message = "ReactPlayer: %c".concat(p, " %cis deprecated, please use the config prop instead \u2013 ").concat(link);
	          console.warn(message, 'font-weight: bold', '');
	        }
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
	        _iterator["return"]();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return config;
	}
	
	function omit(object) {
	  var _ref;
	
	  for (var _len = arguments.length, arrays = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    arrays[_key - 1] = arguments[_key];
	  }
	
	  var omitKeys = (_ref = []).concat.apply(_ref, arrays);
	
	  var output = {};
	  var keys = Object.keys(object);
	
	  for (var _i2 = 0, _keys = keys; _i2 < _keys.length; _i2++) {
	    var key = _keys[_i2];
	
	    if (omitKeys.indexOf(key) === -1) {
	      output[key] = object[key];
	    }
	  }
	
	  return output;
	}
	
	function callPlayer(method) {
	  var _this$player;
	
	  // Util method for calling a method on this.player
	  // but guard against errors and console.warn instead
	  if (!this.player || !this.player[method]) {
	    var message = "ReactPlayer: ".concat(this.constructor.displayName, " player could not call %c").concat(method, "%c \u2013 ");
	
	    if (!this.player) {
	      message += 'The player was not available';
	    } else if (!this.player[method]) {
	      message += 'The method was not available';
	    }
	
	    console.warn(message, 'font-weight: bold', '');
	    return null;
	  }
	
	  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    args[_key2 - 1] = arguments[_key2];
	  }
	
	  return (_this$player = this.player)[method].apply(_this$player, args);
	}
	
	function isObject(val) {
	  return val !== null && _typeof(val) === 'object';
	} // Deep comparison of two objects but ignoring
	// functions, for use in shouldComponentUpdate
	
	
	function isEqual(a, b) {
	  if (typeof a === 'function' && typeof b === 'function') {
	    return true;
	  }
	
	  if (a instanceof Array && b instanceof Array) {
	    if (a.length !== b.length) {
	      return false;
	    }
	
	    for (var i = 0; i !== a.length; i++) {
	      if (!isEqual(a[i], b[i])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  if (isObject(a) && isObject(b)) {
	    if (Object.keys(a).length !== Object.keys(b).length) {
	      return false;
	    }
	
	    for (var _i3 = 0, _Object$keys = Object.keys(a); _i3 < _Object$keys.length; _i3++) {
	      var key = _Object$keys[_i3];
	
	      if (!isEqual(a[key], b[key])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return a === b;
	}
	
	function isMediaStream(url) {
	  return typeof window !== 'undefined' && typeof window.MediaStream !== 'undefined' && url instanceof window.MediaStream;
	}

/***/ },
/* 89 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TABLE_TENNIS = exports.TABLE_TENNIS = 2;
	var BEACH_VOLLEYBALL = exports.BEACH_VOLLEYBALL = 3;
	var VOLLEYBALL = exports.VOLLEYBALL = 4;
	var BOX = exports.BOX = 5;
	var TENNIS = exports.TENNIS = 6;
	var FOOTBALL = exports.FOOTBALL = 7;
	var WATER_POLLO = exports.WATER_POLLO = 8;
	var RUGBY = exports.RUGBY = 9;
	var BASEBALL = exports.BASEBALL = 10;
	var AMERICAN_FOOTBAL = exports.AMERICAN_FOOTBAL = 11;
	var HOCKEY = exports.HOCKEY = 12;
	var LOTTERY = exports.LOTTERY = 13;
	var FORMULA1 = exports.FORMULA1 = 14;
	var SWIMMING = exports.SWIMMING = 15;
	var ELECTIONS = exports.ELECTIONS = 16;
	var ATHLETICS = exports.ATHLETICS = 17;
	var BEACH_FOOTBALL = exports.BEACH_FOOTBALL = 18;
	var HANDBALL = exports.HANDBALL = 19;
	var BIATHLON = exports.BIATHLON = 20;
	var SKIING = exports.SKIING = 21;
	var SPECIAL_OFFERS = exports.SPECIAL_OFFERS = 22;
	var KVN = exports.KVN = 23;
	var POKER = exports.POKER = 24;
	var DARTS = exports.DARTS = 25;
	var CYCLING = exports.CYCLING = 26;
	var WEATHER = exports.WEATHER = 27;
	var WHAT_WHERE_WHEN = exports.WHAT_WHERE_WHEN = 28;
	var SNOOKER = exports.SNOOKER = 29;
	var ICE_HOCKEY = exports.ICE_HOCKEY = 30;
	var BASKETBALL = exports.BASKETBALL = 31;
	var BADMINTON = exports.BADMINTON = 32;
	var OLYMPIC = exports.OLYMPIC = 33;
	var FUTSAL = exports.FUTSAL = 34;
	var BANDY = exports.BANDY = 35;
	var FLOORBALL = exports.FLOORBALL = 36;
	var CULTURE = exports.CULTURE = 37;
	var CYBER_SPORTS = exports.CYBER_SPORTS = 38;
	var MARTIAL_ARTS = exports.MARTIAL_ARTS = 39;
	var CHESS = exports.CHESS = 40;
	var BASKTBALL_NCAA = exports.BASKTBALL_NCAA = 41;
	var CYBER_SPORTS_DOTA2 = exports.CYBER_SPORTS_DOTA2 = 42;

/***/ },
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.beginSignIn = beginSignIn;
	exports.cancelSignIn = cancelSignIn;
	exports.beginJoin = beginJoin;
	exports.cancelJoin = cancelJoin;
	
	var _Auth = __webpack_require__(301);
	
	var ActionTypes = _interopRequireWildcard(_Auth);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function beginSignIn() {
	    return { type: ActionTypes.BEGIN_SIGNIN };
	}
	
	function cancelSignIn() {
	    return { type: ActionTypes.CANCEL_SIGNIN };
	}
	
	function beginJoin() {
	    return { type: ActionTypes.BEGIN_JOIN };
	}
	
	function cancelJoin() {
	    return { type: ActionTypes.CANCEL_JOIN };
	}

/***/ },
/* 96 */,
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _promise = __webpack_require__(307);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new _promise2.default(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return _promise2.default.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(108);
	var GetIntrinsic = __webpack_require__(57);
	var setFunctionLength = __webpack_require__(481);
	
	var $TypeError = __webpack_require__(43);
	var $apply = GetIntrinsic('%Function.prototype.apply%');
	var $call = GetIntrinsic('%Function.prototype.call%');
	var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);
	
	var $defineProperty = __webpack_require__(106);
	var $max = GetIntrinsic('%Math.max%');
	
	module.exports = function callBind(originalFunction) {
		if (typeof originalFunction !== 'function') {
			throw new $TypeError('a function is required');
		}
		var func = $reflectApply(bind, $call, arguments);
		return setFunctionLength(
			func,
			1 + $max(0, originalFunction.length - (arguments.length - 1)),
			true
		);
	};
	
	var applyBind = function applyBind() {
		return $reflectApply(bind, $apply, arguments);
	};
	
	if ($defineProperty) {
		$defineProperty(module.exports, 'apply', { value: applyBind });
	} else {
		module.exports.apply = applyBind;
	}


/***/ },
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $defineProperty = __webpack_require__(106);
	
	var $SyntaxError = __webpack_require__(170);
	var $TypeError = __webpack_require__(43);
	
	var gopd = __webpack_require__(171);
	
	/** @type {import('.')} */
	module.exports = function defineDataProperty(
		obj,
		property,
		value
	) {
		if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
			throw new $TypeError('`obj` must be an object or a function`');
		}
		if (typeof property !== 'string' && typeof property !== 'symbol') {
			throw new $TypeError('`property` must be a string or a symbol`');
		}
		if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
			throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
			throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
			throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
			throw new $TypeError('`loose`, if provided, must be a boolean');
		}
	
		var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
		var nonWritable = arguments.length > 4 ? arguments[4] : null;
		var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
		var loose = arguments.length > 6 ? arguments[6] : false;
	
		/* @type {false | TypedPropertyDescriptor<unknown>} */
		var desc = !!gopd && gopd(obj, property);
	
		if ($defineProperty) {
			$defineProperty(obj, property, {
				configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
				enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
				value: value,
				writable: nonWritable === null && desc ? desc.writable : !nonWritable
			});
		} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
			// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
			obj[property] = value; // eslint-disable-line no-param-reassign
		} else {
			throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
		}
	};


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(57);
	
	/** @type {import('.')} */
	var $defineProperty = GetIntrinsic('%Object.defineProperty%', true) || false;
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = false;
		}
	}
	
	module.exports = $defineProperty;


/***/ },
/* 107 */,
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(431);
	
	module.exports = Function.prototype.bind || implementation;


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $defineProperty = __webpack_require__(106);
	
	var hasPropertyDescriptors = function hasPropertyDescriptors() {
		return !!$defineProperty;
	};
	
	hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
		// node v0.6 has a bug where array lengths can be Set but not Defined
		if (!$defineProperty) {
			return null;
		}
		try {
			return $defineProperty([], 'length', { value: 1 }).length !== 1;
		} catch (e) {
			// In Firefox 4-22, defining length on an array throws an exception.
			return true;
		}
	};
	
	module.exports = hasPropertyDescriptors;


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasSymbols = __webpack_require__(172);
	
	/** @type {import('.')} */
	module.exports = function hasToStringTagShams() {
		return hasSymbols() && !!Symbol.toStringTag;
	};


/***/ },
/* 111 */
/***/ function(module, exports) {

	module.exports = isPromise;
	module.exports.default = isPromise;
	
	function isPromise(obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    ordinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ },
/* 113 */,
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var React = __webpack_require__(1);
	var InputMask = __webpack_require__(648);
	
	var KEYCODE_Z = 90;
	var KEYCODE_Y = 89;
	
	function isUndo(e) {
	  return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEYCODE_Y : KEYCODE_Z);
	}
	
	function isRedo(e) {
	  return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEYCODE_Z : KEYCODE_Y);
	}
	
	function getSelection(el) {
	  var start, end, rangeEl, clone;
	
	  if (el.selectionStart !== undefined) {
	    start = el.selectionStart;
	    end = el.selectionEnd;
	  } else {
	    try {
	      el.focus();
	      rangeEl = el.createTextRange();
	      clone = rangeEl.duplicate();
	
	      rangeEl.moveToBookmark(document.selection.createRange().getBookmark());
	      clone.setEndPoint('EndToStart', rangeEl);
	
	      start = clone.text.length;
	      end = start + rangeEl.text.length;
	    } catch (e) {/* not focused or not visible */}
	  }
	
	  return { start: start, end: end };
	}
	
	function setSelection(el, selection) {
	  var rangeEl;
	
	  try {
	    if (el.selectionStart !== undefined) {
	      el.focus();
	      el.setSelectionRange(selection.start, selection.end);
	    } else {
	      el.focus();
	      rangeEl = el.createTextRange();
	      rangeEl.collapse(true);
	      rangeEl.moveStart('character', selection.start);
	      rangeEl.moveEnd('character', selection.end - selection.start);
	      rangeEl.select();
	    }
	  } catch (e) {/* not focused or not visible */}
	}
	
	var MaskedInput = React.createClass({
	  displayName: 'MaskedInput',
	
	  propTypes: {
	    mask: React.PropTypes.string.isRequired,
	
	    formatCharacters: React.PropTypes.object,
	    placeholderChar: React.PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      value: ''
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    var options = {
	      pattern: this.props.mask,
	      value: this.props.value,
	      formatCharacters: this.props.formatCharacters
	    };
	    if (this.props.placeholderChar) {
	      options.placeholderChar = this.props.placeholderChar;
	    }
	    this.mask = new InputMask(options);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.mask !== nextProps.mask && this.props.value !== nextProps.mask) {
	      // if we get a new value and a new mask at the same time
	      // check if the mask.value is still the initial value
	      // - if so use the nextProps value
	      // - otherwise the `this.mask` has a value for us (most likely from paste action)
	      if (this.mask.getValue() === this.mask.emptyValue) {
	        this.mask.setPattern(nextProps.mask, { value: nextProps.value });
	      } else {
	        this.mask.setPattern(nextProps.mask, { value: this.mask.getRawValue() });
	      }
	    } else if (this.props.mask !== nextProps.mask) {
	      this.mask.setPattern(nextProps.mask, { value: this.mask.getRawValue() });
	    } else if (this.props.value !== nextProps.value) {
	      this.mask.setValue(nextProps.value);
	    }
	  },
	
	  componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
	    if (nextProps.mask !== this.props.mask) {
	      this._updatePattern(nextProps);
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (prevProps.mask !== this.props.mask && this.mask.selection.start) {
	      this._updateInputSelection();
	    }
	  },
	
	  _updatePattern: function _updatePattern(props) {
	    this.mask.setPattern(props.mask, {
	      value: this.mask.getRawValue(),
	      selection: getSelection(this.input)
	    });
	  },
	
	  _updateMaskSelection: function _updateMaskSelection() {
	    this.mask.selection = getSelection(this.input);
	  },
	
	  _updateInputSelection: function _updateInputSelection() {
	    setSelection(this.input, this.mask.selection);
	  },
	
	  _onChange: function _onChange(e) {
	    // console.log('onChange', JSON.stringify(getSelection(this.input)), e.target.value)
	
	    var maskValue = this.mask.getValue();
	    if (e.target.value !== maskValue) {
	      // Cut or delete operations will have shortened the value
	      if (e.target.value.length < maskValue.length) {
	        var sizeDiff = maskValue.length - e.target.value.length;
	        this._updateMaskSelection();
	        this.mask.selection.end = this.mask.selection.start + sizeDiff;
	        this.mask.backspace();
	      }
	      var value = this._getDisplayValue();
	      e.target.value = value;
	      if (value) {
	        this._updateInputSelection();
	      }
	    }
	    if (this.props.onChange) {
	      this.props.onChange(e);
	    }
	  },
	
	  _onKeyDown: function _onKeyDown(e) {
	    // console.log('onKeyDown', JSON.stringify(getSelection(this.input)), e.key, e.target.value)
	
	    if (isUndo(e)) {
	      e.preventDefault();
	      if (this.mask.undo()) {
	        e.target.value = this._getDisplayValue();
	        this._updateInputSelection();
	        if (this.props.onChange) {
	          this.props.onChange(e);
	        }
	      }
	      return;
	    } else if (isRedo(e)) {
	      e.preventDefault();
	      if (this.mask.redo()) {
	        e.target.value = this._getDisplayValue();
	        this._updateInputSelection();
	        if (this.props.onChange) {
	          this.props.onChange(e);
	        }
	      }
	      return;
	    }
	
	    if (e.key === 'Backspace') {
	      e.preventDefault();
	      this._updateMaskSelection();
	      if (this.mask.backspace()) {
	        var value = this._getDisplayValue();
	        e.target.value = value;
	        if (value) {
	          this._updateInputSelection();
	        }
	        if (this.props.onChange) {
	          this.props.onChange(e);
	        }
	      }
	    }
	  },
	
	  _onKeyPress: function _onKeyPress(e) {
	    // console.log('onKeyPress', JSON.stringify(getSelection(this.input)), e.key, e.target.value)
	
	    // Ignore modified key presses
	    // Ignore enter key to allow form submission
	    if (e.metaKey || e.altKey || e.ctrlKey || e.key === 'Enter') {
	      return;
	    }
	
	    e.preventDefault();
	    this._updateMaskSelection();
	    if (this.mask.input(e.key || e.data)) {
	      e.target.value = this.mask.getValue();
	      this._updateInputSelection();
	      if (this.props.onChange) {
	        this.props.onChange(e);
	      }
	    }
	  },
	
	  _onPaste: function _onPaste(e) {
	    // console.log('onPaste', JSON.stringify(getSelection(this.input)), e.clipboardData.getData('Text'), e.target.value)
	
	    e.preventDefault();
	    this._updateMaskSelection();
	    // getData value needed for IE also works in FF & Chrome
	    if (this.mask.paste(e.clipboardData.getData('Text'))) {
	      e.target.value = this.mask.getValue();
	      // Timeout needed for IE
	      setTimeout(this._updateInputSelection, 0);
	      if (this.props.onChange) {
	        this.props.onChange(e);
	      }
	    }
	  },
	
	  _getDisplayValue: function _getDisplayValue() {
	    var value = this.mask.getValue();
	    return value === this.mask.emptyValue ? '' : value;
	  },
	
	  _keyPressPropName: function _keyPressPropName() {
	    return navigator.userAgent.match(/Android/i) ? 'onBeforeInput' : 'onKeyPress';
	  },
	
	  _getEventHandlers: function _getEventHandlers() {
	    return _defineProperty({
	      onChange: this._onChange,
	      onKeyDown: this._onKeyDown,
	      onPaste: this._onPaste
	    }, this._keyPressPropName(), this._onKeyPress);
	  },
	
	  focus: function focus() {
	    this.input.focus();
	  },
	
	  blur: function blur() {
	    this.input.blur();
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var ref = function ref(r) {
	      return _this.input = r;
	    };
	    var maxLength = this.mask.pattern.length;
	    var value = this._getDisplayValue();
	    var eventHandlers = this._getEventHandlers();
	    var _props = this.props;
	    var _props$size = _props.size;
	    var size = _props$size === undefined ? maxLength : _props$size;
	    var _props$placeholder = _props.placeholder;
	    var placeholder = _props$placeholder === undefined ? this.mask.emptyValue : _props$placeholder;
	
	    var props = _extends({}, this.props, eventHandlers, { ref: ref, maxLength: maxLength, value: value, size: size, placeholder: placeholder });
	
	    return React.createElement('input', props);
	  }
	});
	
	module.exports = MaskedInput;

/***/ },
/* 115 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var ADD_ARRAY_VALUE = exports.ADD_ARRAY_VALUE = 'redux-form/ADD_ARRAY_VALUE';
	var AUTOFILL = exports.AUTOFILL = 'redux-form/AUTOFILL';
	var BLUR = exports.BLUR = 'redux-form/BLUR';
	var CHANGE = exports.CHANGE = 'redux-form/CHANGE';
	var DESTROY = exports.DESTROY = 'redux-form/DESTROY';
	var FOCUS = exports.FOCUS = 'redux-form/FOCUS';
	var INITIALIZE = exports.INITIALIZE = 'redux-form/INITIALIZE';
	var REMOVE_ARRAY_VALUE = exports.REMOVE_ARRAY_VALUE = 'redux-form/REMOVE_ARRAY_VALUE';
	var RESET = exports.RESET = 'redux-form/RESET';
	var START_ASYNC_VALIDATION = exports.START_ASYNC_VALIDATION = 'redux-form/START_ASYNC_VALIDATION';
	var START_SUBMIT = exports.START_SUBMIT = 'redux-form/START_SUBMIT';
	var STOP_ASYNC_VALIDATION = exports.STOP_ASYNC_VALIDATION = 'redux-form/STOP_ASYNC_VALIDATION';
	var STOP_SUBMIT = exports.STOP_SUBMIT = 'redux-form/STOP_SUBMIT';
	var SUBMIT_FAILED = exports.SUBMIT_FAILED = 'redux-form/SUBMIT_FAILED';
	var SWAP_ARRAY_VALUES = exports.SWAP_ARRAY_VALUES = 'redux-form/SWAP_ARRAY_VALUES';
	var TOUCH = exports.TOUCH = 'redux-form/TOUCH';
	var UNTOUCH = exports.UNTOUCH = 'redux-form/UNTOUCH';

/***/ },
/* 116 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = mapValues;
	/**
	 * Maps all the values in the given object through the given function and saves them, by key, to a result object
	 */
	function mapValues(obj, fn) {
	  return obj ? Object.keys(obj).reduce(function (accumulator, key) {
	    var _extends2;
	
	    return _extends({}, accumulator, (_extends2 = {}, _extends2[key] = fn(obj[key], key), _extends2));
	  }, {}) : obj;
	}

/***/ },
/* 117 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MAKE_BET = exports.MAKE_BET = 'MAKE_BET';
	var SUCCESS_MAKE_BET = exports.SUCCESS_MAKE_BET = 'SUCCESS_MAKE_BET';
	var FAILURE_MAKE_BET = exports.FAILURE_MAKE_BET = 'FAILURE_MAKE_BET';

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FAILURE_SIGNOUT = exports.SUCCESS_SIGNOUT = exports.SIGNOUT = undefined;
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.signout = signout;
	
	var _api = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SIGNOUT = exports.SIGNOUT = 'SIGNOUT';
	var SUCCESS_SIGNOUT = exports.SUCCESS_SIGNOUT = 'SUCCESS_SIGNOUT';
	var FAILURE_SIGNOUT = exports.FAILURE_SIGNOUT = 'FAILURE_SIGNOUT';
	
	function fetchSignout(data) {
	    return (0, _defineProperty3.default)({
	        type: SIGNOUT
	    }, _api.CALL_API, {
	        endpoint: '/api/sign/out',
	        method: 'post',
	        types: [SUCCESS_SIGNOUT, FAILURE_SIGNOUT],
	        credentials: true,
	        data: data
	    });
	}
	
	function signout(data) {
	    return function (dispatch) {
	        return dispatch(fetchSignout(data));
	    };
	}

/***/ },
/* 119 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NOT_INITED = exports.NOT_INITED = 1;
	var INITED = exports.INITED = 2;
	var UPDATING = exports.UPDATING = 3;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.cssClassMap = undefined;
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _cssClassMap;
	
	var _SportType = __webpack_require__(89);
	
	var SportType = _interopRequireWildcard(_SportType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cssClassMap = (_cssClassMap = {}, (0, _defineProperty3.default)(_cssClassMap, SportType.TABLE_TENNIS, 'ttennis'), (0, _defineProperty3.default)(_cssClassMap, SportType.BEACH_VOLLEYBALL, 'beachvolley'), (0, _defineProperty3.default)(_cssClassMap, SportType.VOLLEYBALL, 'volley'), (0, _defineProperty3.default)(_cssClassMap, SportType.BOX, 'box'), (0, _defineProperty3.default)(_cssClassMap, SportType.TENNIS, 'tennis'), (0, _defineProperty3.default)(_cssClassMap, SportType.FOOTBALL, 'soccer'), (0, _defineProperty3.default)(_cssClassMap, SportType.ICE_HOCKEY, 'icehockey'), (0, _defineProperty3.default)(_cssClassMap, SportType.HANDBALL, 'handball'), (0, _defineProperty3.default)(_cssClassMap, SportType.BASEBALL, 'baseball'), (0, _defineProperty3.default)(_cssClassMap, SportType.CYBER_SPORTS, 'cybersports'), (0, _defineProperty3.default)(_cssClassMap, SportType.LOTTERY, 'lottery'), (0, _defineProperty3.default)(_cssClassMap, SportType.AMERICAN_FOOTBAL, 'americanfootball'), (0, _defineProperty3.default)(_cssClassMap, SportType.BANDY, 'bandy'), (0, _defineProperty3.default)(_cssClassMap, SportType.BASKETBALL, 'basketball'), (0, _defineProperty3.default)(_cssClassMap, SportType.BADMINTON, 'badminton'), (0, _defineProperty3.default)(_cssClassMap, SportType.FUTSAL, 'futsal'), (0, _defineProperty3.default)(_cssClassMap, SportType.FLOORBALL, 'floorball'), (0, _defineProperty3.default)(_cssClassMap, SportType.WEATHER, 'weather'), (0, _defineProperty3.default)(_cssClassMap, SportType.WATER_POLLO, 'waterpolo'), (0, _defineProperty3.default)(_cssClassMap, SportType.BIATHLON, 'biathlon'), (0, _defineProperty3.default)(_cssClassMap, SportType.BEACH_FOOTBALL, 'beachsoccer'), (0, _defineProperty3.default)(_cssClassMap, SportType.MARTIAL_ARTS, 'wrestling'), (0, _defineProperty3.default)(_cssClassMap, SportType.FORMULA1, 'formula1'), (0, _defineProperty3.default)(_cssClassMap, SportType.CYCLING, 'cycling'), (0, _defineProperty3.default)(_cssClassMap, SportType.ELECTIONS, 'election'), (0, _defineProperty3.default)(_cssClassMap, SportType.DARTS, 'darts'), (0, _defineProperty3.default)(_cssClassMap, SportType.KVN, 'kvn'), (0, _defineProperty3.default)(_cssClassMap, SportType.CULTURE, 'culture'), (0, _defineProperty3.default)(_cssClassMap, SportType.ATHLETICS, 'athletics'), (0, _defineProperty3.default)(_cssClassMap, SportType.SKIING, 'skiing'), (0, _defineProperty3.default)(_cssClassMap, SportType.OLYMPIC, 'olimpicgames'), (0, _defineProperty3.default)(_cssClassMap, SportType.SWIMMING, 'swimming'), (0, _defineProperty3.default)(_cssClassMap, SportType.POKER, 'pocker'), (0, _defineProperty3.default)(_cssClassMap, SportType.RUGBY, 'rugby'), (0, _defineProperty3.default)(_cssClassMap, SportType.HOCKEY, 'hockeygras'), (0, _defineProperty3.default)(_cssClassMap, SportType.WHAT_WHERE_WHEN, 'whatwherewhen'), (0, _defineProperty3.default)(_cssClassMap, SportType.CHESS, 'chess'), (0, _defineProperty3.default)(_cssClassMap, SportType.SNOOKER, 'pool'), _cssClassMap);
	
	exports.cssClassMap = cssClassMap;

/***/ },
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = createSinglePlayer;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _props = __webpack_require__(548);
	
	var _utils = __webpack_require__(88);
	
	var _Player = _interopRequireDefault(__webpack_require__(679));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SUPPORTED_PROPS = Object.keys(_props.propTypes);
	
	function createSinglePlayer(activePlayer) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(SinglePlayer, _Component);
	
	    function SinglePlayer() {
	      var _getPrototypeOf2;
	
	      var _this;
	
	      _classCallCheck(this, SinglePlayer);
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SinglePlayer)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	      _defineProperty(_assertThisInitialized(_this), "config", (0, _utils.getConfig)(_this.props, _props.defaultProps, true));
	
	      _defineProperty(_assertThisInitialized(_this), "getDuration", function () {
	        if (!_this.player) return null;
	        return _this.player.getDuration();
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "getCurrentTime", function () {
	        if (!_this.player) return null;
	        return _this.player.getCurrentTime();
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "getSecondsLoaded", function () {
	        if (!_this.player) return null;
	        return _this.player.getSecondsLoaded();
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function () {
	        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';
	        if (!_this.player) return null;
	        return _this.player.getInternalPlayer(key);
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "seekTo", function (fraction, type) {
	        if (!_this.player) return null;
	
	        _this.player.seekTo(fraction, type);
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "ref", function (player) {
	        _this.player = player;
	      });
	
	      return _this;
	    }
	
	    _createClass(SinglePlayer, [{
	      key: "shouldComponentUpdate",
	      value: function shouldComponentUpdate(nextProps) {
	        return !(0, _utils.isEqual)(this.props, nextProps);
	      }
	    }, {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate() {
	        this.config = (0, _utils.getConfig)(this.props, _props.defaultProps);
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this$config$file = this.config.file,
	            forceVideo = _this$config$file.forceVideo,
	            forceAudio = _this$config$file.forceAudio,
	            forceHLS = _this$config$file.forceHLS,
	            forceDASH = _this$config$file.forceDASH;
	        var skipCanPlay = forceVideo || forceAudio || forceHLS || forceDASH;
	
	        if (!activePlayer.canPlay(this.props.url) && !skipCanPlay) {
	          return null;
	        }
	
	        var _this$props = this.props,
	            style = _this$props.style,
	            width = _this$props.width,
	            height = _this$props.height,
	            Wrapper = _this$props.wrapper;
	        var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props.DEPRECATED_CONFIG_PROPS);
	        return _react["default"].createElement(Wrapper, _extends({
	          style: _objectSpread({}, style, {
	            width: width,
	            height: height
	          })
	        }, otherProps), _react["default"].createElement(_Player["default"], _extends({}, this.props, {
	          ref: this.ref,
	          activePlayer: activePlayer,
	          config: this.config
	        })));
	      }
	    }]);
	
	    return SinglePlayer;
	  }(_react.Component), _defineProperty(_class, "displayName", "".concat(activePlayer.displayName, "Player")), _defineProperty(_class, "propTypes", _props.propTypes), _defineProperty(_class, "defaultProps", _props.defaultProps), _defineProperty(_class, "canPlay", activePlayer.canPlay), _temp;
	}

/***/ },
/* 130 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ADD_COUPON_RATE = exports.ADD_COUPON_RATE = 'ADD_COUPON_RATE';
	var REMOVE_COUPON_RATE = exports.REMOVE_COUPON_RATE = 'REMOVE_COUPON_RATE';
	var REMOVE_COUPON_RATES = exports.REMOVE_COUPON_RATES = 'REMOVE_COUPON_RATES';
	
	var SET_COUPON_BET_TYPE = exports.SET_COUPON_BET_TYPE = 'SET_COUPON_BET_TYPE';
	var SET_COUPON_AMOUNT = exports.SET_COUPON_AMOUNT = 'SET_COUPON_AMOUNT';
	
	var ACCEPT_RATE_VALUE_CHANGE = exports.ACCEPT_RATE_VALUE_CHANGE = 'ACCEPT_RATE_VALUE_CHANGE';
	
	var CHANGE_COUPON_SLIP_AMOUNT = exports.CHANGE_COUPON_SLIP_AMOUNT = 'CHANGE_COUPON_SLIP_AMOUNT';

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FAILURE_RESTORE = exports.SUCCESS_RESTORE = exports.RESTORE = undefined;
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.loadAuth = loadAuth;
	
	var _Storage = __webpack_require__(404);
	
	var _Storage2 = _interopRequireDefault(_Storage);
	
	var _api = __webpack_require__(13);
	
	var _Storage3 = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RESTORE = exports.RESTORE = 'RESTORE';
	var SUCCESS_RESTORE = exports.SUCCESS_RESTORE = 'SUCCESS_RESTORE';
	var FAILURE_RESTORE = exports.FAILURE_RESTORE = 'FAILURE_RESTORE';
	
	function fetchRestore(data) {
	    return (0, _defineProperty3.default)({
	        type: RESTORE
	    }, _api.CALL_API, {
	        endpoint: '/api/sign/restore',
	        method: 'post',
	        types: [[SUCCESS_RESTORE, _Storage2.default, _Storage3.LOAD_STORAGE], FAILURE_RESTORE],
	        credentials: true,
	        data: data
	    });
	}
	
	function loadAuth(data) {
	    return function (dispatch) {
	        return dispatch(fetchRestore(data));
	    };
	}

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FAILURE_FETCH_BALANCE = exports.SUCCESS_FETCH_BALANCE = exports.FETCH_BALANCE = undefined;
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.balance = balance;
	
	var _api = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FETCH_BALANCE = exports.FETCH_BALANCE = 'FETCH_BALANCE';
	var SUCCESS_FETCH_BALANCE = exports.SUCCESS_FETCH_BALANCE = 'SUCCESS_FETCH_BALANCE';
	var FAILURE_FETCH_BALANCE = exports.FAILURE_FETCH_BALANCE = 'FAILURE_FETCH_BALANCE';
	
	function fetchBalance(data) {
	    return (0, _defineProperty3.default)({
	        type: FETCH_BALANCE
	    }, _api.CALL_API, {
	        endpoint: '/api/balance/',
	        method: 'post',
	        types: [SUCCESS_FETCH_BALANCE, FAILURE_FETCH_BALANCE],
	        credentials: true,
	        data: data
	    });
	}
	
	function balance(data) {
	    return function (dispatch) {
	        dispatch(fetchBalance(data));
	    };
	}

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.makeBet = makeBet;
	
	var _api = __webpack_require__(13);
	
	var _MakeBet = __webpack_require__(117);
	
	var ActionTypes = _interopRequireWildcard(_MakeBet);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchMakeBet(apiData, historyData) {
	    return (0, _defineProperty3.default)({
	        type: ActionTypes.MAKE_BET,
	        historyData: historyData
	    }, _api.CALL_API, {
	        endpoint: '/api/bet/make',
	        method: 'post',
	        types: [ActionTypes.SUCCESS_MAKE_BET, ActionTypes.FAILURE_MAKE_BET],
	        credentials: true,
	        data: apiData
	    });
	}
	
	function makeBet(apiData, historyData) {
	    return function (dispatch) {
	        return dispatch(fetchMakeBet(apiData, historyData));
	    };
	}

/***/ },
/* 134 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var INIT = exports.INIT = 0;
	var REJECTED = exports.REJECTED = 1;
	var CONFIRMED = exports.CONFIRMED = 2;
	var CALCULATED = exports.CALCULATED = 3;
	var CASHOUT = exports.CASHOUT = 4;
	var BET_PAY_REQUEST = exports.BET_PAY_REQUEST = 5;
	var IN_DELAY = exports.IN_DELAY = 6;
	var STAKE_REQUEST = exports.STAKE_REQUEST = 7;
	var CONFIRM_AWAIT = exports.CONFIRM_AWAIT = 8;

/***/ },
/* 135 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var minAmount = exports.minAmount = {
	    KGS: 5,
	    OPX: 5,
	    RUR: 5,
	    TJS: 0.5,
	    KZT: 15,
	    USD: 0.01,
	    EUR: 0.01,
	    GBP: 0.01,
	    KSH: 0.01,
	    PEN: 0.01,
	    UZS: 1000
	};

/***/ },
/* 136 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.sportSortFunc = sportSortFunc;
	exports.leagueSortFunc = leagueSortFunc;
	exports.matchSortFunc = matchSortFunc;
	exports.matchStartDateSortFunc = matchStartDateSortFunc;
	exports.groupsSortFunc = groupsSortFunc;
	function sportSortFunc(a, b) {
	    var compare = a.get('priority') - b.get('priority');
	
	    if (compare === 0) {
	        compare = a.get('name').localeCompare(b.get('name'));
	    }
	
	    return compare;
	}
	
	function leagueSortFunc(a, b) {
	    var compare = a.get('priority') - b.get('priority');
	
	    if (compare === 0) {
	        compare = a.get('name').localeCompare(b.get('name'));
	    }
	
	    return compare;
	}
	
	function matchSortFunc(a, b) {
	    return a.get('name').localeCompare(b.get('name'));
	}
	
	function matchStartDateSortFunc(a, b) {
	    var compare = a.get('type') - b.get('type');
	
	    if (compare === 0) {
	        var aDate = a.get('startDate');
	        var bDate = b.get('startDate');
	
	        if (aDate > bDate) {
	            return 1;
	        } else if (aDate < bDate) {
	            return -1;
	        }
	
	        return 0;
	    }
	
	    return compare;
	}
	
	function groupsSortFunc(a, b) {
	    var aPriority = a.get('priority');
	    var bPriority = b.get('priority');
	
	    if (aPriority > bPriority) {
	        return 1;
	    } else if (aPriority < bPriority) {
	        return -1;
	    }
	
	    var aType = a.get('type');
	    var bType = b.get('type');
	
	    if (aType > bType) {
	        return 1;
	    } else if (aType < bType) {
	        return -1;
	    }
	
	    return 0;
	}

/***/ },
/* 137 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getRateDisplayValue = getRateDisplayValue;
	exports.firstHandicapCondition = firstHandicapCondition;
	exports.secondHandicapCondition = secondHandicapCondition;
	exports.addClass = addClass;
	exports.removeClass = removeClass;
	function getRateDisplayValue(value) {
	    if (value === undefined || value === null) {
	        return '';
	    }
	
	    if (value > 1 && value < 1.03) {
	        return value.toFixed(3);
	    } else {
	        return value.toFixed(2);
	    }
	}
	
	function firstHandicapCondition(value) {
	    if (value > 0) {
	        return '+' + value;
	    }
	
	    return value;
	}
	
	function secondHandicapCondition(value) {
	    value = -value;
	
	    if (value > 0) {
	        return '+' + value;
	    }
	
	    return value;
	}
	
	function addClass(element, className) {
	    var n = 0;
	
	    className = className.split(',');
	
	    for (var i = 0; i < className.length; i++) {
	        if ((' ' + element.className + ' ').indexOf(' ' + className[i] + ' ') == -1) {
	            element.className += ' ' + className[i];
	            n++;
	        }
	    }
	
	    return n;
	}
	
	function removeClass(element, className) {
	    var remainingClasses = element.className.replace(new RegExp('\\b' + className + '\\b'), '');
	
	    element.className = remainingClasses;
	}

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_React$Component) {
	    (0, _inherits3.default)(_class, _React$Component);
	
	    function _class(props) {
	        (0, _classCallCheck3.default)(this, _class);
	        return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, props));
	    }
	
	    (0, _createClass3.default)(_class, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                null,
	                this.props.children,
	                _react2.default.createElement("div", { className: "modal--backdrop" })
	            );
	        }
	    }]);
	    return _class;
	}(_react2.default.Component);
	
	_class.propTypes = {
	    children: _react2.default.PropTypes.any.isRequired
	};
	exports.default = _class;

/***/ },
/* 139 */
[2087, 53],
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.check = check;
	exports.remove = remove;
	exports.deferred = deferred;
	exports.arrayOfDeffered = arrayOfDeffered;
	exports.delay = delay;
	exports.createMockTask = createMockTask;
	exports.autoInc = autoInc;
	exports.makeIterator = makeIterator;
	exports.log = log;
	exports.wrapSagaDispatch = wrapSagaDispatch;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var sym = exports.sym = function sym(id) {
	  return '@@redux-saga/' + id;
	};
	var TASK = exports.TASK = sym('TASK');
	var HELPER = exports.HELPER = sym('HELPER');
	var MATCH = exports.MATCH = sym('MATCH');
	var CANCEL = exports.CANCEL = sym('cancelPromise');
	var SAGA_ACTION = exports.SAGA_ACTION = sym('SAGA_ACTION');
	var konst = exports.konst = function konst(v) {
	  return function () {
	    return v;
	  };
	};
	var kTrue = exports.kTrue = konst(true);
	var kFalse = exports.kFalse = konst(false);
	var noop = exports.noop = function noop() {};
	var ident = exports.ident = function ident(v) {
	  return v;
	};
	
	function check(value, predicate, error) {
	  if (!predicate(value)) {
	    log('error', 'uncaught at check', error);
	    throw new Error(error);
	  }
	}
	
	var is = exports.is = {
	  undef: function undef(v) {
	    return v === null || v === undefined;
	  },
	  notUndef: function notUndef(v) {
	    return v !== null && v !== undefined;
	  },
	  func: function func(f) {
	    return typeof f === 'function';
	  },
	  number: function number(n) {
	    return typeof n === 'number';
	  },
	  array: Array.isArray,
	  promise: function promise(p) {
	    return p && is.func(p.then);
	  },
	  iterator: function iterator(it) {
	    return it && is.func(it.next) && is.func(it.throw);
	  },
	  task: function task(t) {
	    return t && t[TASK];
	  },
	  observable: function observable(ob) {
	    return ob && is.func(ob.subscribe);
	  },
	  buffer: function buffer(buf) {
	    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
	  },
	  pattern: function pattern(pat) {
	    return pat && (typeof pat === 'string' || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
	  },
	  channel: function channel(ch) {
	    return ch && is.func(ch.take) && is.func(ch.close);
	  },
	  helper: function helper(it) {
	    return it && it[HELPER];
	  }
	};
	
	function remove(array, item) {
	  var index = array.indexOf(item);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	}
	
	function deferred() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var def = _extends({}, props);
	  var promise = new Promise(function (resolve, reject) {
	    def.resolve = resolve;
	    def.reject = reject;
	  });
	  def.promise = promise;
	  return def;
	}
	
	function arrayOfDeffered(length) {
	  var arr = [];
	  for (var i = 0; i < length; i++) {
	    arr.push(deferred());
	  }
	  return arr;
	}
	
	function delay(ms) {
	  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  var timeoutId = void 0;
	  var promise = new Promise(function (resolve) {
	    timeoutId = setTimeout(function () {
	      return resolve(val);
	    }, ms);
	  });
	
	  promise[CANCEL] = function () {
	    return clearTimeout(timeoutId);
	  };
	
	  return promise;
	}
	
	function createMockTask() {
	  var _ref;
	
	  var running = true;
	  var _result = void 0,
	      _error = void 0;
	
	  return _ref = {}, _defineProperty(_ref, TASK, true), _defineProperty(_ref, 'isRunning', function isRunning() {
	    return running;
	  }), _defineProperty(_ref, 'result', function result() {
	    return _result;
	  }), _defineProperty(_ref, 'error', function error() {
	    return _error;
	  }), _defineProperty(_ref, 'setRunning', function setRunning(b) {
	    return running = b;
	  }), _defineProperty(_ref, 'setResult', function setResult(r) {
	    return _result = r;
	  }), _defineProperty(_ref, 'setError', function setError(e) {
	    return _error = e;
	  }), _ref;
	}
	
	function autoInc() {
	  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = exports.uid = autoInc();
	
	var kThrow = function kThrow(err) {
	  throw err;
	};
	var kReturn = function kReturn(value) {
	  return { value: value, done: true };
	};
	function makeIterator(next) {
	  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
	  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var isHelper = arguments[3];
	
	  var iterator = { name: name, next: next, throw: thro, return: kReturn };
	
	  if (isHelper) {
	    iterator[HELPER] = true;
	  }
	  if (typeof Symbol !== 'undefined') {
	    iterator[Symbol.iterator] = function () {
	      return iterator;
	    };
	  }
	  return iterator;
	}
	
	/**
	  Print error in a useful way whether in a browser environment
	  (with expandable error stack traces), or in a node.js environment
	  (text-only log output)
	 **/
	function log(level, message, error) {
	  /*eslint-disable no-console*/
	  if (typeof window === 'undefined') {
	    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
	  } else {
	    console[level](message, error);
	  }
	}
	
	var internalErr = exports.internalErr = function internalErr(err) {
	  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
	};
	
	function wrapSagaDispatch(dispatch) {
	  return function sagaDispatch(action) {
	    var wrappedAction = Object.defineProperty(action, SAGA_ACTION, { value: true });
	    return dispatch(wrappedAction);
	  };
	}

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
	//     http://underscorejs.org
	//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind,
	    nativeCreate       = Object.create;
	
	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function(){};
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.8.3';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value)) return _.matcher(value);
	    return _.property(value);
	  };
	  _.iteratee = function(value, context) {
	    return cb(value, context, Infinity);
	  };
	
	  // An internal function for creating assigner functions.
	  var createAssigner = function(keysFunc, undefinedOnly) {
	    return function(obj) {
	      var length = arguments.length;
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };
	
	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function(prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  };
	
	  var property = function(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = property('length');
	  var isArrayLike = function(collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Create a reducing function iterating left or right.
	  function createReduce(dir) {
	    // Optimized iterator function as using arguments.length
	    // in the main function will deoptimize the, see #1991.
	    function iterator(obj, iteratee, memo, keys, index, length) {
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    }
	
	    return function(obj, iteratee, memo, context) {
	      iteratee = optimizeCb(iteratee, context, 4);
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      // Determine the initial value if none is provided.
	      if (arguments.length < 3) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      return iterator(obj, iteratee, memo, keys, index, length);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var key;
	    if (isArrayLike(obj)) {
	      key = _.findIndex(obj, predicate, context);
	    } else {
	      key = _.findKey(obj, predicate, context);
	    }
	    if (key !== void 0 && key !== -1) return obj[key];
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given item (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return _.indexOf(obj, item, fromIndex) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      var func = isFunc ? method : value[method];
	      return func == null ? func : func.apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var set = isArrayLike(obj) ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iteratee, context) {
	      var result = {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var pass = [], fail = [];
	    _.each(obj, function(value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, startIndex) {
	    var output = [], idx = 0;
	    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        //flatten current level of array or arguments object
	        if (!shallow) value = flatten(value, shallow, strict);
	        var j = 0, len = value.length;
	        output.length += len;
	        while (j < len) {
	          output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(flatten(arguments, true, true));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = flatten(arguments, true, true, 1);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    return _.unzip(arguments);
	  };
	
	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices
	  _.unzip = function(array) {
	    var length = array && _.max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Generator function to create the findIndex and findLastIndex functions
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a predicate test
	  _.findIndex = createPredicateIndexFinder(1);
	  _.findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };
	
	  // Generator function to create the indexOf and lastIndexOf functions
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	            i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), _.isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments
	  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var args = slice.call(arguments, 2);
	    var bound = function() {
	      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
	    };
	    return bound;
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var i, length = arguments.length, key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){
	      return func.apply(null, args);
	    }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function() {
	      var last = _.now() - timestamp;
	
	      if (last < wait && last >= 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };
	
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  function collectNonEnumProps(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve all the property names of an object.
	  _.allKeys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Returns the results of applying the iteratee to each element of the object
	  // In contrast to _.map it returns an object
	  _.mapObject = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys =  _.keys(obj),
	          length = keys.length,
	          results = {},
	          currentKey;
	      for (var index = 0; index < length; index++) {
	        currentKey = keys[index];
	        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	      }
	      return results;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in object(s)
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = _.assign = createAssigner(_.keys);
	
	  // Returns the first key on an object that passes a predicate test
	  _.findKey = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj), key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(object, oiteratee, context) {
	    var result = {}, obj = object, iteratee, keys;
	    if (obj == null) return result;
	    if (_.isFunction(oiteratee)) {
	      keys = _.allKeys(obj);
	      iteratee = optimizeCb(oiteratee, context);
	    } else {
	      keys = flatten(arguments, false, false, 1);
	      iteratee = function(value, key, obj) { return key in obj; };
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(flatten(arguments, false, false, 1), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  _.create = function(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) _.extendOwn(result, props);
	    return result;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function(object, attrs) {
	    var keys = _.keys(attrs), length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };
	
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	                               _.isFunction(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return _.has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), and in Safari 8 (#1929).
	  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };
	
	  _.noop = function(){};
	
	  _.property = property;
	
	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function(obj) {
	    return obj == null ? function(){} : function(key) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  _.matcher = _.matches = function(attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function(obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	   // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property, fallback) {
	    var value = object == null ? void 0 : object[property];
	    if (value === void 0) {
	      value = fallback;
	    }
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	  _.prototype.toString = function() {
	    return '' + this._wrapped;
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}.call(this));


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(368);

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(18);
	var settle = __webpack_require__(375);
	var buildURL = __webpack_require__(154);
	var buildFullPath = __webpack_require__(372);
	var parseHeaders = __webpack_require__(382);
	var isURLSameOrigin = __webpack_require__(380);
	var createError = __webpack_require__(150);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    var fullPath = buildFullPath(config.baseURL, config.url);
	    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request.onreadystatechange = function handleLoad() {
	      if (!request || request.readyState !== 4) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle browser request cancellation (as opposed to a manual cancellation)
	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }
	
	      reject(createError('Request aborted', config, 'ECONNABORTED', request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
	      if (config.timeoutErrorMessage) {
	        timeoutErrorMessage = config.timeoutErrorMessage;
	      }
	      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(378);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (!utils.isUndefined(config.withCredentials)) {
	      request.withCredentials = !!config.withCredentials;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 148 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ },
/* 149 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(374);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(18);
	
	/**
	 * Config-specific merge-function which creates a new config-object
	 * by merging two configuration objects together.
	 *
	 * @param {Object} config1
	 * @param {Object} config2
	 * @returns {Object} New object resulting from merging config2 to config1
	 */
	module.exports = function mergeConfig(config1, config2) {
	  // eslint-disable-next-line no-param-reassign
	  config2 = config2 || {};
	  var config = {};
	
	  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
	  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
	  var defaultToConfig2Keys = [
	    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
	    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
	    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
	    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
	    'httpsAgent', 'cancelToken', 'socketPath'
	  ];
	
	  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
	    if (typeof config2[prop] !== 'undefined') {
	      config[prop] = config2[prop];
	    }
	  });
	
	  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
	    if (utils.isObject(config2[prop])) {
	      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
	    } else if (typeof config2[prop] !== 'undefined') {
	      config[prop] = config2[prop];
	    } else if (utils.isObject(config1[prop])) {
	      config[prop] = utils.deepMerge(config1[prop]);
	    } else if (typeof config1[prop] !== 'undefined') {
	      config[prop] = config1[prop];
	    }
	  });
	
	  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
	    if (typeof config2[prop] !== 'undefined') {
	      config[prop] = config2[prop];
	    } else if (typeof config1[prop] !== 'undefined') {
	      config[prop] = config1[prop];
	    }
	  });
	
	  var axiosKeys = valueFromConfig2Keys
	    .concat(mergeDeepPropertiesKeys)
	    .concat(defaultToConfig2Keys);
	
	  var otherKeys = Object
	    .keys(config2)
	    .filter(function filterAxiosKeys(key) {
	      return axiosKeys.indexOf(key) === -1;
	    });
	
	  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
	    if (typeof config2[prop] !== 'undefined') {
	      config[prop] = config2[prop];
	    } else if (typeof config1[prop] !== 'undefined') {
	      config[prop] = config1[prop];
	    }
	  });
	
	  return config;
	};


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(18);
	var normalizeHeaderName = __webpack_require__(381);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(147);
	  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(147);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Accept');
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(446)))

/***/ },
/* 153 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(18);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    var hashmarkIndex = url.indexOf('#');
	    if (hashmarkIndex !== -1) {
	      url = url.slice(0, hashmarkIndex);
	    }
	
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 155 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TOGGLE_FAVOURITE_LEAGUE = exports.TOGGLE_FAVOURITE_LEAGUE = 'TOGGLE_FAVOURITE_LEAGUE';
	var TOGGLE_FAVOURITE_MATCH = exports.TOGGLE_FAVOURITE_MATCH = 'TOGGLE_FAVOURITE_MATCH';
	var TOGGLE_FAVOURITE_SPORT = exports.TOGGLE_FAVOURITE_SPORT = 'TOGGLE_FAVOURITE_SPORT';

/***/ },
/* 156 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CREATE_PHONE_CONFIRMATION = exports.CREATE_PHONE_CONFIRMATION = 'CREATE_PHONE_CONFIRMATION';
	var SUCCESS_CREATE_PHONE_CONFIRMATION = exports.SUCCESS_CREATE_PHONE_CONFIRMATION = 'SUCCESS_CREATE_PHONE_CONFIRMATION';
	var FAILURE_CREATE_PHONE_CONFIRMATION = exports.FAILURE_CREATE_PHONE_CONFIRMATION = 'FAILURE_CREATE_PHONE_CONFIRMATION';
	
	var CONFIRM_PHONE = exports.CONFIRM_PHONE = 'CONFIRM_PHONE';
	var SUCCESS_CONFIRM_PHONE = exports.SUCCESS_CONFIRM_PHONE = 'SUCCESS_CONFIRM_PHONE';
	var FAILURE_CONFIRM_PHONE = exports.FAILURE_CONFIRM_PHONE = 'FAILURE_CONFIRM_PHONE';
	
	var DENY_CONFIRMATION = exports.DENY_CONFIRMATION = 'DENY_CONFIRMATION';

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FAILURE_FAST_CONFIRM_PHONE = exports.SUCCESS_FAST_CONFIRM_PHONE = exports.FAST_CONFIRM_PHONE = exports.FAILURE_FAST_JOIN = exports.SUCCESS_FAST_JOIN = exports.FAST_JOIN = undefined;
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.join = join;
	exports.confirmPhone = confirmPhone;
	
	var _api = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FAST_JOIN = exports.FAST_JOIN = 'FAST_JOIN';
	var SUCCESS_FAST_JOIN = exports.SUCCESS_FAST_JOIN = 'SUCCESS_FAST_JOIN';
	var FAILURE_FAST_JOIN = exports.FAILURE_FAST_JOIN = 'FAILURE_FAST_JOIN';
	
	var FAST_CONFIRM_PHONE = exports.FAST_CONFIRM_PHONE = 'FAST_CONFIRM_PHONE';
	var SUCCESS_FAST_CONFIRM_PHONE = exports.SUCCESS_FAST_CONFIRM_PHONE = 'SUCCESS_FAST_CONFIRM_PHONE';
	var FAILURE_FAST_CONFIRM_PHONE = exports.FAILURE_FAST_CONFIRM_PHONE = 'FAILURE_FAST_CONFIRM_PHONE';
	
	function join(data) {
	    return function (dispatch) {
	        dispatch((0, _defineProperty3.default)({
	            type: FAST_JOIN
	        }, _api.CALL_API, {
	            endpoint: '/api/fast_join/',
	            method: 'post',
	            types: [SUCCESS_FAST_JOIN, FAILURE_FAST_JOIN],
	            credentials: true,
	            data: data
	        }));
	    };
	}
	
	function confirmPhone(data) {
	    return function (dispatch) {
	        dispatch((0, _defineProperty3.default)({
	            type: FAST_CONFIRM_PHONE
	        }, _api.CALL_API, {
	            endpoint: '/api/fast_join/confirm',
	            method: 'post',
	            types: [SUCCESS_FAST_CONFIRM_PHONE, FAILURE_FAST_CONFIRM_PHONE],
	            credentials: true,
	            data: data
	        }));
	    };
	}

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FAILURE_SIGNIN = exports.SUCCESS_SIGNIN = exports.SIGNIN = undefined;
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.signin = signin;
	
	var _Storage = __webpack_require__(404);
	
	var _Storage2 = _interopRequireDefault(_Storage);
	
	var _api = __webpack_require__(13);
	
	var _Storage3 = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SIGNIN = exports.SIGNIN = 'SIGNIN';
	var SUCCESS_SIGNIN = exports.SUCCESS_SIGNIN = 'SUCCESS_SIGNIN';
	var FAILURE_SIGNIN = exports.FAILURE_SIGNIN = 'FAILURE_SIGNIN';
	
	function fetchSignin(data) {
	    return (0, _defineProperty3.default)({
	        type: SIGNIN
	    }, _api.CALL_API, {
	        endpoint: '/api/sign/in',
	        method: 'post',
	        types: [[SUCCESS_SIGNIN, _Storage2.default, _Storage3.LOAD_STORAGE], FAILURE_SIGNIN],
	        credentials: true,
	        data: data
	    });
	}
	
	function signin(data) {
	    return function (dispatch) {
	        dispatch(fetchSignin(data));
	    };
	}

/***/ },
/* 159 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NONE = exports.NONE = 0;
	var INIT = exports.INIT = 1;
	var SUCCESS = exports.SUCCESS = 2;
	var RESTRICTED = exports.RESTRICTED = 3;
	var INTERNAL_ERROR = exports.INTERNAL_ERROR = -100;

/***/ },
/* 160 */,
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlotName = function (_React$Component) {
	    (0, _inherits3.default)(SlotName, _React$Component);
	
	    function SlotName(props) {
	        (0, _classCallCheck3.default)(this, SlotName);
	        return (0, _possibleConstructorReturn3.default)(this, (SlotName.__proto__ || (0, _getPrototypeOf2.default)(SlotName)).call(this, props));
	    }
	
	    (0, _createClass3.default)(SlotName, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                sportId = _props.sportId,
	                slot = _props.slot,
	                outcome = _props.outcome;
	
	
	            var match = {
	                homeTeam: this.props.match.get('firstTeam'),
	                awayTeam: this.props.match.get('secondTeam')
	            };
	
	            var slotName = this.props.gridLocalization.getSlotName(sportId, match, slot);
	            var outcomeName = this.props.gridLocalization.getOutcomeName(sportId, outcome.toJS(), match);
	
	            return _react2.default.createElement(
	                'span',
	                { className: 'cell-content' },
	                outcomeName || slotName
	            );
	        }
	    }]);
	    return SlotName;
	}(_react2.default.Component);
	
	SlotName.propTypes = {
	    match: _react2.default.PropTypes.object,
	    slot: _react2.default.PropTypes.object,
	    outcome: _react2.default.PropTypes.object,
	    sportId: _react2.default.PropTypes.number.isRequired,
	    gridLocalization: _react2.default.PropTypes.object.isRequired
	};
	exports.default = SlotName;

/***/ },
/* 162 */,
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(57);
	
	var callBind = __webpack_require__(98);
	
	var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));
	
	module.exports = function callBoundIntrinsic(name, allowMissing) {
		var intrinsic = GetIntrinsic(name, !!allowMissing);
		if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
			return callBind(intrinsic);
		}
		return intrinsic;
	};


/***/ },
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	var objectKeys = __webpack_require__(282);
	var isArguments = __webpack_require__(437);
	var is = __webpack_require__(443);
	var isRegex = __webpack_require__(439);
	var flags = __webpack_require__(479);
	var isDate = __webpack_require__(438);
	
	var getTime = Date.prototype.getTime;
	
	function deepEqual(actual, expected, options) {
	  var opts = options || {};
	
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (opts.strict ? is(actual, expected) : actual === expected) {
	    return true;
	  }
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
	  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
	    return opts.strict ? is(actual, expected) : actual == expected;
	  }
	
	  /*
	   * 7.4. For all other Object pairs, including Array objects, equivalence is
	   * determined by having the same number of owned properties (as verified
	   * with Object.prototype.hasOwnProperty.call), the same set of keys
	   * (although not necessarily the same order), equivalent values for every
	   * corresponding key, and an identical 'prototype' property. Note: this
	   * accounts for both named and indexed properties on Arrays.
	   */
	  // eslint-disable-next-line no-use-before-define
	  return objEquiv(actual, expected, opts);
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer(x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
	    return false;
	  }
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') {
	    return false;
	  }
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  /* eslint max-statements: [2, 50] */
	  var i, key;
	  if (typeof a !== typeof b) { return false; }
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }
	
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) { return false; }
	
	  if (isArguments(a) !== isArguments(b)) { return false; }
	
	  var aIsRegex = isRegex(a);
	  var bIsRegex = isRegex(b);
	  if (aIsRegex !== bIsRegex) { return false; }
	  if (aIsRegex || bIsRegex) {
	    return a.source === b.source && flags(a) === flags(b);
	  }
	
	  if (isDate(a) && isDate(b)) {
	    return getTime.call(a) === getTime.call(b);
	  }
	
	  var aIsBuffer = isBuffer(a);
	  var bIsBuffer = isBuffer(b);
	  if (aIsBuffer !== bIsBuffer) { return false; }
	  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
	    if (a.length !== b.length) { return false; }
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) { return false; }
	    }
	    return true;
	  }
	
	  if (typeof a !== typeof b) { return false; }
	
	  try {
	    var ka = objectKeys(a);
	    var kb = objectKeys(b);
	  } catch (e) { // happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates hasOwnProperty)
	  if (ka.length !== kb.length) { return false; }
	
	  // the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  // ~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i]) { return false; }
	  }
	  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) { return false; }
	  }
	
	  return true;
	}
	
	module.exports = deepEqual;


/***/ },
/* 170 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./syntax')} */
	module.exports = SyntaxError;


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(57);
	
	var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
	
	if ($gOPD) {
		try {
			$gOPD([], 'length');
		} catch (e) {
			// IE 8 has a broken gOPD
			$gOPD = null;
		}
	}
	
	module.exports = $gOPD;


/***/ },
/* 172 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    ordinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    ordinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    ordinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	    monthsShort : 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    ordinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    ordinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    ordinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[I dag kl.] LT',
	        nextDay : '[I morgen kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[I går kl.] LT',
	        lastWeek : '[sidste] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    ordinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! komento: Mi estas malcerta se mi korekte traktis akuzativojn en tiu traduko.
	//!          Se ne, bonvolu korekti kaj avizi min por ke mi povas lerni!
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato'.split('_'),
	    weekdaysShort : 'Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Ĵa_Ve_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-an de] MMMM, YYYY',
	        LLL : 'D[-an de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-an de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'je %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    ordinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چندین ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    ordinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Aujourd\'hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    ordinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number) {
	        return number + (number === 1 ? 'er' : 'e');
	    }
	});
	
	return frCa;
	
	})));


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Aujourd\'hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    ordinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number) {
	        return number + (number === 1 ? 'er' : 'e');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Aujourd\'hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    ordinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number) {
	        return number + (number === 1 ? 'er' : '');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    ordinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    ordinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
	    weekdaysShort : 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
	    weekdaysMin : 'Do_Lu_Ma_Me_Gi_Ve_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'Ah時m分',
	        LTS : 'Ah時m分s秒',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日Ah時m分',
	        LLLL : 'YYYY年M月D日Ah時m分 dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    ordinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის წინ');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის წინ');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    ordinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    ordinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h시 m분',
	        LTS : 'A h시 m분 s초',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h시 m분',
	        LLLL : 'YYYY년 MMMM D일 dddd A h시 m분'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '일분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    ordinalParse : /\d{1,2}일/,
	    ordinal : '%d일',
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    ordinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    ordinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    ordinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: '[W] dddd [o] LT',
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    ordinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    ordinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    ordinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    ordinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    ordinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    ordinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    ordinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[haftaya] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen hafta] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    ordinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    },
	    nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    ordinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    ordinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    ordinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'Ah点mm分',
	        LTS : 'Ah点m分s秒',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日Ah点mm分',
	        llll : 'YYYY年MMMD日ddddAh点mm分'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : function () {
	            return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
	        },
	        nextDay : function () {
	            return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
	        },
	        lastDay : function () {
	            return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
	        },
	        nextWeek : function () {
	            var startOfWeek, prefix;
	            startOfWeek = moment().startOf('week');
	            prefix = this.diff(startOfWeek, 'days') >= 7 ? '[下]' : '[本]';
	            return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	        },
	        lastWeek : function () {
	            var startOfWeek, prefix;
	            startOfWeek = moment().startOf('week');
	            prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
	            return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	        },
	        sameElse : 'LL'
	    },
	    ordinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'Ah點mm分',
	        LTS : 'Ah點m分s秒',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah點mm分',
	        LLLL : 'YYYY年MMMD日ddddAh點mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日Ah點mm分',
	        llll : 'YYYY年MMMD日ddddAh點mm分'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    ordinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'Ah點mm分',
	        LTS : 'Ah點m分s秒',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah點mm分',
	        LLLL : 'YYYY年MMMD日ddddAh點mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日Ah點mm分',
	        llll : 'YYYY年MMMD日ddddAh點mm分'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    ordinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ },
/* 280 */
/***/ function(module, exports) {

	'use strict';
	
	var numberIsNaN = function (value) {
		return value !== value;
	};
	
	module.exports = function is(a, b) {
		if (a === 0 && b === 0) {
			return 1 / a === 1 / b;
		}
		if (a === b) {
			return true;
		}
		if (numberIsNaN(a) && numberIsNaN(b)) {
			return true;
		}
		return false;
	};
	


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(280);
	
	module.exports = function getPolyfill() {
		return typeof Object.is === 'function' ? Object.is : implementation;
	};


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(283);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(445);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ },
/* 283 */
/***/ function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ },
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.untouch = exports.touch = exports.swapArrayValues = exports.submitFailed = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.reset = exports.removeArrayValue = exports.initialize = exports.focus = exports.destroy = exports.change = exports.blur = exports.autofill = exports.addArrayValue = undefined;
	
	var _actionTypes = __webpack_require__(115);
	
	var addArrayValue = exports.addArrayValue = function addArrayValue(path, value, index, fields) {
	  return { type: _actionTypes.ADD_ARRAY_VALUE, path: path, value: value, index: index, fields: fields };
	};
	
	var autofill = exports.autofill = function autofill(field, value) {
	  return { type: _actionTypes.AUTOFILL, field: field, value: value };
	};
	
	var blur = exports.blur = function blur(field, value) {
	  return { type: _actionTypes.BLUR, field: field, value: value };
	};
	
	var change = exports.change = function change(field, value) {
	  return { type: _actionTypes.CHANGE, field: field, value: value };
	};
	
	var destroy = exports.destroy = function destroy() {
	  return { type: _actionTypes.DESTROY };
	};
	
	var focus = exports.focus = function focus(field) {
	  return { type: _actionTypes.FOCUS, field: field };
	};
	
	var initialize = exports.initialize = function initialize(data, fields) {
	  var overwriteValues = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
	
	  if (!Array.isArray(fields)) {
	    throw new Error('must provide fields array to initialize() action creator');
	  }
	  return { type: _actionTypes.INITIALIZE, data: data, fields: fields, overwriteValues: overwriteValues };
	};
	
	var removeArrayValue = exports.removeArrayValue = function removeArrayValue(path, index) {
	  return { type: _actionTypes.REMOVE_ARRAY_VALUE, path: path, index: index };
	};
	
	var reset = exports.reset = function reset() {
	  return { type: _actionTypes.RESET };
	};
	
	var startAsyncValidation = exports.startAsyncValidation = function startAsyncValidation(field) {
	  return { type: _actionTypes.START_ASYNC_VALIDATION, field: field };
	};
	
	var startSubmit = exports.startSubmit = function startSubmit() {
	  return { type: _actionTypes.START_SUBMIT };
	};
	
	var stopAsyncValidation = exports.stopAsyncValidation = function stopAsyncValidation(errors) {
	  return { type: _actionTypes.STOP_ASYNC_VALIDATION, errors: errors };
	};
	
	var stopSubmit = exports.stopSubmit = function stopSubmit(errors) {
	  return { type: _actionTypes.STOP_SUBMIT, errors: errors };
	};
	
	var submitFailed = exports.submitFailed = function submitFailed() {
	  return { type: _actionTypes.SUBMIT_FAILED };
	};
	
	var swapArrayValues = exports.swapArrayValues = function swapArrayValues(path, indexA, indexB) {
	  return { type: _actionTypes.SWAP_ARRAY_VALUES, path: path, indexA: indexA, indexB: indexB };
	};
	
	var touch = exports.touch = function touch() {
	  for (var _len = arguments.length, fields = Array(_len), _key = 0; _key < _len; _key++) {
	    fields[_key] = arguments[_key];
	  }
	
	  return { type: _actionTypes.TOUCH, fields: fields };
	};
	
	var untouch = exports.untouch = function untouch() {
	  for (var _len2 = arguments.length, fields = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    fields[_key2] = arguments[_key2];
	  }
	
	  return { type: _actionTypes.UNTOUCH, fields: fields };
	};

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = bindActionData;
	
	var _mapValues = __webpack_require__(116);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Adds additional properties to the results of the function or map of functions passed
	 */
	function bindActionData(action, data) {
	  if (typeof action === 'function') {
	    return function () {
	      return _extends({}, action.apply(undefined, arguments), data);
	    };
	  }
	  if (typeof action === 'object') {
	    return (0, _mapValues2.default)(action, function (value) {
	      return bindActionData(value, data);
	    });
	  }
	  return action;
	}

/***/ },
/* 289 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var dataKey = exports.dataKey = 'value';
	var createOnDragStart = function createOnDragStart(name, getValue) {
	  return function (event) {
	    event.dataTransfer.setData(dataKey, getValue());
	  };
	};
	
	exports.default = createOnDragStart;

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isEvent = __webpack_require__(291);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSelectedValues = function getSelectedValues(options) {
	  var result = [];
	  if (options) {
	    for (var index = 0; index < options.length; index++) {
	      var option = options[index];
	      if (option.selected) {
	        result.push(option.value);
	      }
	    }
	  }
	  return result;
	};
	
	var getValue = function getValue(event, isReactNative) {
	  if ((0, _isEvent2.default)(event)) {
	    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
	      return event.nativeEvent.text;
	    }
	    if (isReactNative && event.nativeEvent !== undefined) {
	      return event.nativeEvent.text;
	    }
	    var _event$target = event.target;
	    var type = _event$target.type;
	    var value = _event$target.value;
	    var checked = _event$target.checked;
	    var files = _event$target.files;
	    var dataTransfer = event.dataTransfer;
	
	    if (type === 'checkbox') {
	      return checked;
	    }
	    if (type === 'file') {
	      return files || dataTransfer && dataTransfer.files;
	    }
	    if (type === 'select-multiple') {
	      return getSelectedValues(event.target.options);
	    }
	    return value;
	  }
	  // not an event, so must be either our value or an object containing our value in the 'value' key
	  return event && typeof event === 'object' && event.value !== undefined ? event.value : // extract value from { value: value } structure. https://github.com/nikgraf/belle/issues/58
	  event;
	};
	
	exports.default = getValue;

/***/ },
/* 291 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var isEvent = function isEvent(candidate) {
	  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
	};
	
	exports.default = isEvent;

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isEvent = __webpack_require__(291);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvent = function silenceEvent(event) {
	  var is = (0, _isEvent2.default)(event);
	  if (is) {
	    event.preventDefault();
	  }
	  return is;
	};
	
	exports.default = silenceEvent;

/***/ },
/* 293 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getDisplayName;
	function getDisplayName(Comp) {
	  return Comp.displayName || Comp.name || 'Component';
	}

/***/ },
/* 294 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Given a state[field], get the value.
	 *  Fallback to .initialValue when .value is undefined to prevent double render/initialize cycle.
	 *  See {@link https://github.com/erikras/redux-form/issues/621}.
	 */
	var itemToValue = function itemToValue(_ref) {
	  var value = _ref.value;
	  var initialValue = _ref.initialValue;
	  return typeof value !== 'undefined' ? value : initialValue;
	};
	
	var getValue = function getValue(field, state, dest) {
	  var dotIndex = field.indexOf('.');
	  var openIndex = field.indexOf('[');
	  var closeIndex = field.indexOf(']');
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    (function () {
	      // array field
	      var key = field.substring(0, openIndex);
	      var rest = field.substring(closeIndex + 1);
	      if (rest[0] === '.') {
	        rest = rest.substring(1);
	      }
	      var array = state && state[key] || [];
	      if (rest) {
	        if (!dest[key]) {
	          dest[key] = [];
	        }
	        array.forEach(function (item, index) {
	          if (!dest[key][index]) {
	            dest[key][index] = {};
	          }
	          getValue(rest, item, dest[key][index]);
	        });
	      } else {
	        dest[key] = array.map(itemToValue);
	      }
	    })();
	  } else if (dotIndex > 0) {
	    // subobject field
	    var _key = field.substring(0, dotIndex);
	    var _rest = field.substring(dotIndex + 1);
	    if (!dest[_key]) {
	      dest[_key] = {};
	    }
	    getValue(_rest, state && state[_key] || {}, dest[_key]);
	  } else {
	    dest[field] = state[field] && itemToValue(state[field]);
	  }
	};
	
	var getValues = function getValues(fields, state) {
	  return fields.reduce(function (accumulator, field) {
	    getValue(field, state, accumulator);
	    return accumulator;
	  }, {});
	};
	
	exports.default = getValues;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _fieldValue = __webpack_require__(45);
	
	/**
	 * A different version of getValues() that does not need the fields array
	 */
	var getValuesFromState = function getValuesFromState(state) {
	  if (!state) {
	    return state;
	  }
	  var keys = Object.keys(state);
	  if (!keys.length) {
	    return undefined;
	  }
	  return keys.reduce(function (accumulator, key) {
	    var field = state[key];
	    if (field) {
	      if ((0, _fieldValue.isFieldValue)(field)) {
	        if (field.value !== undefined) {
	          accumulator[key] = field.value;
	        }
	      } else if (Array.isArray(field)) {
	        accumulator[key] = field.map(function (arrayField) {
	          return (0, _fieldValue.isFieldValue)(arrayField) ? arrayField.value : getValuesFromState(arrayField);
	        });
	      } else if (typeof field === 'object') {
	        var result = getValuesFromState(field);
	
	        if (result && Object.keys(result).length > 0) {
	          accumulator[key] = result;
	        }
	      }
	    }
	    return accumulator;
	  }, {});
	};
	
	exports.default = getValuesFromState;

/***/ },
/* 296 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Reads any potentially deep value from an object using dot and array syntax
	 */
	var read = function read(path, object) {
	  if (!path || !object) {
	    return object;
	  }
	  var dotIndex = path.indexOf('.');
	  if (dotIndex === 0) {
	    return read(path.substring(1), object);
	  }
	  var openIndex = path.indexOf('[');
	  var closeIndex = path.indexOf(']');
	  if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
	    // iterate down object tree
	    return read(path.substring(dotIndex + 1), object[path.substring(0, dotIndex)]);
	  }
	  if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    if (closeIndex < 0) {
	      throw new Error('found [ but no ]');
	    }
	    var key = path.substring(0, openIndex);
	    var index = path.substring(openIndex + 1, closeIndex);
	    if (!index.length) {
	      return object[key];
	    }
	    if (openIndex === 0) {
	      return read(path.substring(closeIndex + 1), object[index]);
	    }
	    if (!object[key]) {
	      return undefined;
	    }
	    return read(path.substring(closeIndex + 1), object[key][index]);
	  }
	  return object[path];
	};
	
	exports.default = read;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.initialState = exports.globalErrorKey = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _initialState, _behaviors;
	
	var _actionTypes = __webpack_require__(115);
	
	var _mapValues = __webpack_require__(116);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _read = __webpack_require__(296);
	
	var _read2 = _interopRequireDefault(_read);
	
	var _write = __webpack_require__(298);
	
	var _write2 = _interopRequireDefault(_write);
	
	var _getValuesFromState = __webpack_require__(295);
	
	var _getValuesFromState2 = _interopRequireDefault(_getValuesFromState);
	
	var _initializeState = __webpack_require__(467);
	
	var _initializeState2 = _interopRequireDefault(_initializeState);
	
	var _resetState = __webpack_require__(473);
	
	var _resetState2 = _interopRequireDefault(_resetState);
	
	var _setErrors = __webpack_require__(474);
	
	var _setErrors2 = _interopRequireDefault(_setErrors);
	
	var _fieldValue = __webpack_require__(45);
	
	var _normalizeFields = __webpack_require__(469);
	
	var _normalizeFields2 = _interopRequireDefault(_normalizeFields);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var globalErrorKey = exports.globalErrorKey = '_error';
	
	var initialState = exports.initialState = (_initialState = {
	  _active: undefined,
	  _asyncValidating: false
	}, _initialState[globalErrorKey] = undefined, _initialState._initialized = false, _initialState._submitting = false, _initialState._submitFailed = false, _initialState);
	
	var behaviors = (_behaviors = {}, _behaviors[_actionTypes.ADD_ARRAY_VALUE] = function (state, _ref) {
	  var path = _ref.path;
	  var index = _ref.index;
	  var value = _ref.value;
	  var fields = _ref.fields;
	
	  var array = (0, _read2.default)(path, state);
	  var stateCopy = _extends({}, state);
	  var arrayCopy = array ? [].concat(array) : [];
	  var newValue = value !== null && typeof value === 'object' ? (0, _initializeState2.default)(value, fields || Object.keys(value)) : (0, _fieldValue.makeFieldValue)({ value: value });
	  if (index === undefined) {
	    arrayCopy.push(newValue);
	  } else {
	    arrayCopy.splice(index, 0, newValue);
	  }
	  return (0, _write2.default)(path, arrayCopy, stateCopy);
	}, _behaviors[_actionTypes.AUTOFILL] = function (state, _ref2) {
	  var field = _ref2.field;
	  var value = _ref2.value;
	
	  return (0, _write2.default)(field, function (previous) {
	    var _previous$value$autof = _extends({}, previous, { value: value, autofilled: true });
	
	    var asyncError = _previous$value$autof.asyncError;
	    var submitError = _previous$value$autof.submitError;
	
	    var result = _objectWithoutProperties(_previous$value$autof, ['asyncError', 'submitError']);
	
	    return (0, _fieldValue.makeFieldValue)(result);
	  }, state);
	}, _behaviors[_actionTypes.BLUR] = function (state, _ref3) {
	  var field = _ref3.field;
	  var value = _ref3.value;
	  var touch = _ref3.touch;
	  var _active = state._active;
	
	  var stateCopy = _objectWithoutProperties(state, ['_active']);
	
	  if (_active && _active !== field) {
	    // remove _active from state
	    stateCopy._active = _active;
	  }
	  return (0, _write2.default)(field, function (previous) {
	    var result = _extends({}, previous);
	    if (value !== undefined) {
	      result.value = value;
	    }
	    if (touch) {
	      result.touched = true;
	    }
	    return (0, _fieldValue.makeFieldValue)(result);
	  }, stateCopy);
	}, _behaviors[_actionTypes.CHANGE] = function (state, _ref4) {
	  var field = _ref4.field;
	  var value = _ref4.value;
	  var touch = _ref4.touch;
	
	  return (0, _write2.default)(field, function (previous) {
	    var _previous$value = _extends({}, previous, { value: value });
	
	    var asyncError = _previous$value.asyncError;
	    var submitError = _previous$value.submitError;
	    var autofilled = _previous$value.autofilled;
	
	    var result = _objectWithoutProperties(_previous$value, ['asyncError', 'submitError', 'autofilled']);
	
	    if (touch) {
	      result.touched = true;
	    }
	    return (0, _fieldValue.makeFieldValue)(result);
	  }, state);
	}, _behaviors[_actionTypes.DESTROY] = function () {
	  return undefined;
	}, _behaviors[_actionTypes.FOCUS] = function (state, _ref5) {
	  var field = _ref5.field;
	
	  var stateCopy = (0, _write2.default)(field, function (previous) {
	    return (0, _fieldValue.makeFieldValue)(_extends({}, previous, { visited: true }));
	  }, state);
	  stateCopy._active = field;
	  return stateCopy;
	}, _behaviors[_actionTypes.INITIALIZE] = function (state, _ref6) {
	  var _extends2;
	
	  var data = _ref6.data;
	  var fields = _ref6.fields;
	  var overwriteValues = _ref6.overwriteValues;
	
	  return _extends({}, (0, _initializeState2.default)(data, fields, state, overwriteValues), (_extends2 = {
	    _asyncValidating: false,
	    _active: undefined
	  }, _extends2[globalErrorKey] = undefined, _extends2._initialized = true, _extends2._submitting = false, _extends2._submitFailed = false, _extends2));
	}, _behaviors[_actionTypes.REMOVE_ARRAY_VALUE] = function (state, _ref7) {
	  var path = _ref7.path;
	  var index = _ref7.index;
	
	  var array = (0, _read2.default)(path, state);
	  var stateCopy = _extends({}, state);
	  var arrayCopy = array ? [].concat(array) : [];
	  if (index === undefined) {
	    arrayCopy.pop();
	  } else if (isNaN(index)) {
	    delete arrayCopy[index];
	  } else {
	    arrayCopy.splice(index, 1);
	  }
	  return (0, _write2.default)(path, arrayCopy, stateCopy);
	}, _behaviors[_actionTypes.RESET] = function (state) {
	  var _extends3;
	
	  return _extends({}, (0, _resetState2.default)(state), (_extends3 = {
	    _active: undefined,
	    _asyncValidating: false
	  }, _extends3[globalErrorKey] = undefined, _extends3._initialized = state._initialized, _extends3._submitting = false, _extends3._submitFailed = false, _extends3));
	}, _behaviors[_actionTypes.START_ASYNC_VALIDATION] = function (state, _ref8) {
	  var field = _ref8.field;
	
	  return _extends({}, state, {
	    _asyncValidating: field || true
	  });
	}, _behaviors[_actionTypes.START_SUBMIT] = function (state) {
	  return _extends({}, state, {
	    _submitting: true
	  });
	}, _behaviors[_actionTypes.STOP_ASYNC_VALIDATION] = function (state, _ref9) {
	  var _extends4;
	
	  var errors = _ref9.errors;
	
	  return _extends({}, (0, _setErrors2.default)(state, errors, 'asyncError'), (_extends4 = {
	    _asyncValidating: false
	  }, _extends4[globalErrorKey] = errors && errors[globalErrorKey], _extends4));
	}, _behaviors[_actionTypes.STOP_SUBMIT] = function (state, _ref10) {
	  var _extends5;
	
	  var errors = _ref10.errors;
	
	  return _extends({}, (0, _setErrors2.default)(state, errors, 'submitError'), (_extends5 = {}, _extends5[globalErrorKey] = errors && errors[globalErrorKey], _extends5._submitting = false, _extends5._submitFailed = !!(errors && Object.keys(errors).length), _extends5));
	}, _behaviors[_actionTypes.SUBMIT_FAILED] = function (state) {
	  return _extends({}, state, {
	    _submitFailed: true
	  });
	}, _behaviors[_actionTypes.SWAP_ARRAY_VALUES] = function (state, _ref11) {
	  var path = _ref11.path;
	  var indexA = _ref11.indexA;
	  var indexB = _ref11.indexB;
	
	  var array = (0, _read2.default)(path, state);
	  var arrayLength = array.length;
	  if (indexA === indexB || isNaN(indexA) || isNaN(indexB) || indexA >= arrayLength || indexB >= arrayLength) {
	    return state; // do nothing
	  }
	  var stateCopy = _extends({}, state);
	  var arrayCopy = [].concat(array);
	  arrayCopy[indexA] = array[indexB];
	  arrayCopy[indexB] = array[indexA];
	  return (0, _write2.default)(path, arrayCopy, stateCopy);
	}, _behaviors[_actionTypes.TOUCH] = function (state, _ref12) {
	  var fields = _ref12.fields;
	
	  return _extends({}, state, fields.reduce(function (accumulator, field) {
	    return (0, _write2.default)(field, function (value) {
	      return (0, _fieldValue.makeFieldValue)(_extends({}, value, { touched: true }));
	    }, accumulator);
	  }, state));
	}, _behaviors[_actionTypes.UNTOUCH] = function (state, _ref13) {
	  var fields = _ref13.fields;
	
	  return _extends({}, state, fields.reduce(function (accumulator, field) {
	    return (0, _write2.default)(field, function (value) {
	      if (value) {
	        var touched = value.touched;
	
	        var rest = _objectWithoutProperties(value, ['touched']);
	
	        return (0, _fieldValue.makeFieldValue)(rest);
	      }
	      return (0, _fieldValue.makeFieldValue)(value);
	    }, accumulator);
	  }, state));
	}, _behaviors);
	
	var reducer = function reducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  var behavior = behaviors[action.type];
	  return behavior ? behavior(state, action) : state;
	};
	
	function formReducer() {
	  var _extends11;
	
	  var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	  var form = action.form;
	  var key = action.key;
	
	  var rest = _objectWithoutProperties(action, ['form', 'key']); // eslint-disable-line no-redeclare
	
	
	  if (!form) {
	    return state;
	  }
	  if (key) {
	    var _extends8, _extends9;
	
	    if (action.type === _actionTypes.DESTROY) {
	      var _extends7;
	
	      return _extends({}, state, (_extends7 = {}, _extends7[form] = state[form] && Object.keys(state[form]).reduce(function (accumulator, stateKey) {
	        var _extends6;
	
	        return stateKey === key ? accumulator : _extends({}, accumulator, (_extends6 = {}, _extends6[stateKey] = state[form][stateKey], _extends6));
	      }, {}), _extends7));
	    }
	    return _extends({}, state, (_extends9 = {}, _extends9[form] = _extends({}, state[form], (_extends8 = {}, _extends8[key] = reducer((state[form] || {})[key], rest), _extends8)), _extends9));
	  }
	  if (action.type === _actionTypes.DESTROY) {
	    return Object.keys(state).reduce(function (accumulator, formName) {
	      var _extends10;
	
	      return formName === form ? accumulator : _extends({}, accumulator, (_extends10 = {}, _extends10[formName] = state[formName], _extends10));
	    }, {});
	  }
	  return _extends({}, state, (_extends11 = {}, _extends11[form] = reducer(state[form], rest), _extends11));
	}
	
	/**
	 * Adds additional functionality to the reducer
	 */
	function decorate(target) {
	  target.plugin = function plugin(reducers) {
	    var _this = this;
	
	    // use 'function' keyword to enable 'this'
	    return decorate(function () {
	      var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	      var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      var result = _this(state, action);
	      return _extends({}, result, (0, _mapValues2.default)(reducers, function (pluginReducer, key) {
	        return pluginReducer(result[key] || initialState, action);
	      }));
	    });
	  };
	
	  target.normalize = function normalize(normalizers) {
	    var _this2 = this;
	
	    // use 'function' keyword to enable 'this'
	    return decorate(function () {
	      var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	      var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      var result = _this2(state, action);
	      return _extends({}, result, (0, _mapValues2.default)(normalizers, function (formNormalizers, form) {
	        var runNormalize = function runNormalize(previous, currentResult) {
	          var previousValues = (0, _getValuesFromState2.default)(_extends({}, initialState, previous));
	          var formResult = _extends({}, initialState, currentResult);
	          var values = (0, _getValuesFromState2.default)(formResult);
	          return (0, _normalizeFields2.default)(formNormalizers, formResult, previous, values, previousValues);
	        };
	        if (action.key) {
	          var _extends12;
	
	          return _extends({}, result[form], (_extends12 = {}, _extends12[action.key] = runNormalize(state[form][action.key], result[form][action.key]), _extends12));
	        }
	        return runNormalize(state[form], result[form]);
	      }));
	    });
	  };
	
	  return target;
	}
	
	exports.default = decorate(formReducer);

/***/ },
/* 298 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * Writes any potentially deep value from an object using dot and array syntax,
	 * and returns a new copy of the object.
	 */
	var write = function write(path, value, object) {
	  var _extends7;
	
	  var dotIndex = path.indexOf('.');
	  if (dotIndex === 0) {
	    return write(path.substring(1), value, object);
	  }
	  var openIndex = path.indexOf('[');
	  var closeIndex = path.indexOf(']');
	  if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
	    var _extends2;
	
	    // is dot notation
	    var key = path.substring(0, dotIndex);
	    return _extends({}, object, (_extends2 = {}, _extends2[key] = write(path.substring(dotIndex + 1), value, object[key] || {}), _extends2));
	  }
	  if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    var _ret = function () {
	      var _extends6;
	
	      // is array notation
	      if (closeIndex < 0) {
	        throw new Error('found [ but no ]');
	      }
	      var key = path.substring(0, openIndex);
	      var index = path.substring(openIndex + 1, closeIndex);
	      var array = object[key] || [];
	      var rest = path.substring(closeIndex + 1);
	      if (index) {
	        var _extends4;
	
	        // indexed array
	        if (rest.length) {
	          var _extends3;
	
	          // need to keep recursing
	          var dest = array[index] || {};
	          var arrayCopy = [].concat(array);
	          arrayCopy[index] = write(rest, value, dest);
	          return {
	            v: _extends({}, object || {}, (_extends3 = {}, _extends3[key] = arrayCopy, _extends3))
	          };
	        }
	        var copy = [].concat(array);
	        copy[index] = typeof value === 'function' ? value(copy[index]) : value;
	        return {
	          v: _extends({}, object || {}, (_extends4 = {}, _extends4[key] = copy, _extends4))
	        };
	      }
	      // indexless array
	      if (rest.length) {
	        var _extends5;
	
	        // need to keep recursing
	        if ((!array || !array.length) && typeof value === 'function') {
	          return {
	            v: object
	          }; // don't even set a value under [key]
	        }
	        var _arrayCopy = array.map(function (dest) {
	          return write(rest, value, dest);
	        });
	        return {
	          v: _extends({}, object || {}, (_extends5 = {}, _extends5[key] = _arrayCopy, _extends5))
	        };
	      }
	      var result = void 0;
	      if (Array.isArray(value)) {
	        result = value;
	      } else if (object[key]) {
	        result = array.map(function (dest) {
	          return typeof value === 'function' ? value(dest) : value;
	        });
	      } else if (typeof value === 'function') {
	        return {
	          v: object
	        }; // don't even set a value under [key]
	      } else {
	          result = value;
	        }
	      return {
	        v: _extends({}, object || {}, (_extends6 = {}, _extends6[key] = result, _extends6))
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	  return _extends({}, object, (_extends7 = {}, _extends7[path] = typeof value === 'function' ? value(object[path]) : value, _extends7));
	};
	
	exports.default = write;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var setFunctionName = __webpack_require__(482);
	var $TypeError = __webpack_require__(43);
	
	var $Object = Object;
	
	module.exports = setFunctionName(function flags() {
		if (this == null || this !== $Object(this)) {
			throw new $TypeError('RegExp.prototype.flags getter called on non-object');
		}
		var result = '';
		if (this.hasIndices) {
			result += 'd';
		}
		if (this.global) {
			result += 'g';
		}
		if (this.ignoreCase) {
			result += 'i';
		}
		if (this.multiline) {
			result += 'm';
		}
		if (this.dotAll) {
			result += 's';
		}
		if (this.unicode) {
			result += 'u';
		}
		if (this.unicodeSets) {
			result += 'v';
		}
		if (this.sticky) {
			result += 'y';
		}
		return result;
	}, 'get flags', true);
	


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(299);
	
	var supportsDescriptors = __webpack_require__(56).supportsDescriptors;
	var $gOPD = Object.getOwnPropertyDescriptor;
	
	module.exports = function getPolyfill() {
		if (supportsDescriptors && (/a/mig).flags === 'gim') {
			var descriptor = $gOPD(RegExp.prototype, 'flags');
			if (
				descriptor
				&& typeof descriptor.get === 'function'
				&& 'dotAll' in RegExp.prototype
				&& 'hasIndices' in RegExp.prototype
			) {
				/* eslint getter-return: 0 */
				var calls = '';
				var o = {};
				Object.defineProperty(o, 'hasIndices', {
					get: function () {
						calls += 'd';
					}
				});
				Object.defineProperty(o, 'sticky', {
					get: function () {
						calls += 'y';
					}
				});
	
				descriptor.get.call(o);
	
				if (calls === 'dy') {
					return descriptor.get;
				}
			}
		}
		return implementation;
	};


/***/ },
/* 301 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var BEGIN_SIGNIN = exports.BEGIN_SIGNIN = 'BEGIN_SIGNIN';
	var CANCEL_SIGNIN = exports.CANCEL_SIGNIN = 'CANCEL_SIGNIN';
	var BEGIN_JOIN = exports.BEGIN_JOIN = 'BEGIN_JOIN';
	var CANCEL_JOIN = exports.CANCEL_JOIN = 'CANCEL_JOIN';

/***/ },
/* 302 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var REMOVE_HISTORY_BET = exports.REMOVE_HISTORY_BET = 'REMOVE_HISTORY_BET';
	var REMOVE_HISTORY_BETS = exports.REMOVE_HISTORY_BETS = 'REMOVE_HISTORY_BETS';
	
	var REQUEST_BET_TYPES = exports.REQUEST_BET_TYPES = 'REQUEST_BET_TYPES';
	var SUCCESS_REQUEST_BET_TYPES = exports.SUCCESS_REQUEST_BET_TYPES = 'SUCCESS_REQUEST_BET_TYPES';
	var FAILURE_REQUEST_BET_TYPES = exports.FAILURE_REQUEST_BET_TYPES = 'FAILURE_REQUEST_BET_TYPES';

/***/ },
/* 303 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var BEGIN_PASSWORD_RECOVERY = exports.BEGIN_PASSWORD_RECOVERY = 'BEGIN_PASSWORD_RECOVERY';
	var CANCEL_PASSWORD_RECOVERY = exports.CANCEL_PASSWORD_RECOVERY = 'CANCEL_PASSWORD_RECOVERY';
	
	var RECOVER_PASSWORD = exports.RECOVER_PASSWORD = 'RECOVER_PASSWORD';
	var SUCCESS_RECOVER_PASSWORD = exports.SUCCESS_RECOVER_PASSWORD = 'SUCCESS_RECOVER_PASSWORD';
	var FAILURE_RECOVER_PASSWORD = exports.FAILURE_RECOVER_PASSWORD = 'FAILURE_RECOVER_PASSWORD';
	
	var PHONE_RECOVER_PASSWORD = exports.PHONE_RECOVER_PASSWORD = 'RECOVER_PASSWORD';
	var SUCCESS_PHONE_RECOVER_PASSWORD = exports.SUCCESS_PHONE_RECOVER_PASSWORD = 'SUCCESS_PHONE_RECOVER_PASSWORD';
	var FAILURE_PHONE_RECOVER_PASSWORD = exports.FAILURE_PHONE_RECOVER_PASSWORD = 'FAILURE_PHONE_RECOVER_PASSWORD';

/***/ },
/* 304 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ACTIVE = exports.ACTIVE = 0;
	var WON = exports.WON = 1;
	var LOST = exports.LOST = 2;
	var REFUND = exports.REFUND = 3;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isAvailableGames = isAvailableGames;
	exports.getInitialCountryCode = getInitialCountryCode;
	
	var _accountResourceNames = __webpack_require__(59);
	
	var AccountResources = _interopRequireWildcard(_accountResourceNames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * @param {string} countryCode
	 * @param {number|null} accountResourceId
	 * @param {number|null} gamblerId
	 * @returns {boolean}
	 */
	function isAvailableGames(countryCode, accountResourceId, gamblerId) {
	    if (gamblerId === 75514727) return true; // DEMO ACCOUNT 276502
	    if (gamblerId) {
	        return accountResourceId === AccountResources.KG && countryCode === "KG" || accountResourceId === AccountResources.UZ && countryCode === "UZ";
	    }
	    return countryCode === "KG" || countryCode === "UZ";
	}
	
	/**
	 * @param {string} countryCode
	 * @returns {object}
	 */
	function getInitialCountryCode(countryCode) {
	    switch (countryCode) {
	        case 'KZ':
	            return {
	                defaultCountryId: 79,
	                accountResourceId: AccountResources.KZ
	            };
	        case 'UZ':
	            return {
	                defaultCountryId: 192,
	                accountResourceId: AccountResources.UZ
	            };
	        default:
	            return {
	                defaultCountryId: 96,
	                accountResourceId: AccountResources.KG
	            };
	    }
	}

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.STAKES_VALUES = undefined;
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(15);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.isMinAndMaxValueWrong = isMinAndMaxValueWrong;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _classnames = __webpack_require__(61);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactIntl = __webpack_require__(8);
	
	var _underscore = __webpack_require__(145);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _BettingMode = __webpack_require__(735);
	
	var _AcceptFactorChange = __webpack_require__(333);
	
	var AcceptFactorChangeMode = _interopRequireWildcard(_AcceptFactorChange);
	
	var _accountResourceNames = __webpack_require__(59);
	
	var resources = _interopRequireWildcard(_accountResourceNames);
	
	var _StakeMinAmount = __webpack_require__(135);
	
	var _StakeMaxAmount = __webpack_require__(570);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    title: {
	        id: 'coupon.menu.title',
	        defaultMessage: 'Меню ставок'
	    },
	    oneClickCheckBox: {
	        id: 'coupon.menu.one-click_checkbox',
	        defaultMessage: 'Ставка в один клик'
	    },
	    oneClickAmount: {
	        id: 'coupon.menu.one-click_amount',
	        defaultMessage: 'Сумма ставки '
	    },
	    acceptFactorIncrease: {
	        id: 'coupon.menu.accept_factor_increase',
	        defaultMessage: 'Согласен на повышение коэффициента'
	    },
	    acceptFactorDecrease: {
	        id: 'coupon.menu.accept_factor_decrease',
	        defaultMessage: 'Согласен на понижение коэффициента'
	    },
	    favouriteBets: {
	        id: 'coupon.menu.favouriteBets',
	        defaultMessage: 'Любимые ставки'
	    },
	    favouriteBet: {
	        id: 'coupon.menu.favouriteBet',
	        defaultMessage: 'Ставка {num} '
	    }
	});
	
	var STAKES_VALUES = exports.STAKES_VALUES = {
	    UZ: [5000, 10000, 50000, 1000000],
	    KZ: [50, 50, 100, 200],
	    KG: [50, 50, 100, 200]
	};
	
	var CouponDropDownMenu = function (_React$Component) {
	    (0, _inherits3.default)(CouponDropDownMenu, _React$Component);
	
	    function CouponDropDownMenu(props) {
	        (0, _classCallCheck3.default)(this, CouponDropDownMenu);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (CouponDropDownMenu.__proto__ || (0, _getPrototypeOf2.default)(CouponDropDownMenu)).call(this, props));
	
	        _this._handleFavouriteAmountChange = function (number) {
	            return function (e) {
	                e.preventDefault();
	                var value = parseInt(e.target.value);
	
	                if (number === 1) {
	                    _this.setState({
	                        favouriteBet1Amount: value
	                    });
	                } else if (number === 2) {
	                    _this.setState({
	                        favouriteBet2Amount: value
	                    });
	                } else if (number === 3) {
	                    _this.setState({
	                        favouriteBet3Amount: value
	                    });
	                }
	
	                _this._onFavouriteAmountChanged(number, value);
	            };
	        };
	
	        _this.state = {
	            isOneClickOn: undefined,
	            acceptFactorIncrease: undefined,
	            acceptFactorDecrease: undefined,
	            oneClickAmount: undefined,
	            favouriteBet1Amount: undefined,
	            favouriteBet2Amount: undefined,
	            favouriteBet3Amount: undefined
	        };
	
	        _this._isInsidePopup = _this._isInsidePopup.bind(_this);
	        _this._onDocumentClick = _this._onDocumentClick.bind(_this);
	
	        document.addEventListener('click', _this._onDocumentClick);
	
	        _this._handleOneClickModeClick = _this._handleOneClickModeClick.bind(_this);
	
	        _this._onOneClickModeChanged = _underscore2.default.debounce(function () {
	            _this.props.toggleOneClickModeAction();
	        }, 50);
	
	        _this._onOneClickAmountChanged = _underscore2.default.debounce(function (value) {
	            _this.props.setOneClickAmountAction(value);
	        }, 50);
	
	        _this._onAcceptFactorIncreaseChanged = _underscore2.default.debounce(function (value) {
	            _this.props.toggleAcceptFactorIncreaseAction(value);
	        }, 50);
	
	        _this._onAcceptFactorDecreaseChanged = _underscore2.default.debounce(function (value) {
	            _this.props.toggleAcceptFactorDecreaseAction(value);
	        }, 50);
	
	        _this._onFavouriteAmountChanged = _underscore2.default.debounce(function (number, value) {
	            _this.props.setFavouriteBetAmountAction({ number: number, amount: value });
	        }, 50);
	        return _this;
	    }
	
	    (0, _createClass3.default)(CouponDropDownMenu, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                bettingMode = _props.bettingMode,
	                countryCode = _props.countryCode;
	
	            var values = STAKES_VALUES[countryCode];
	            var oneClickAmount = bettingMode.get('oneClickAmount') || values[0];
	            var favouriteBet1Amount = bettingMode.get('favouriteBet1Amount') || values[1];
	            var favouriteBet2Amount = bettingMode.get('favouriteBet2Amount') || values[2];
	            var favouriteBet3Amount = bettingMode.get('favouriteBet3Amount') || values[3];
	            var isOneClickOn = bettingMode.get('isOneClick') || false;
	            var acceptFactorChange = bettingMode.get('acceptFactorChange') || AcceptFactorChangeMode.NONE;
	
	            var acceptFactorIncrease = acceptFactorChange === AcceptFactorChangeMode.INCREASE || acceptFactorChange === AcceptFactorChangeMode.BOTH;
	            var acceptFactorDecrease = acceptFactorChange === AcceptFactorChangeMode.DECREASE || acceptFactorChange === AcceptFactorChangeMode.BOTH;
	
	            this.setState({
	                oneClickAmount: oneClickAmount,
	                favouriteBet1Amount: favouriteBet1Amount,
	                favouriteBet2Amount: favouriteBet2Amount,
	                favouriteBet3Amount: favouriteBet3Amount,
	                isOneClickOn: isOneClickOn,
	                acceptFactorIncrease: acceptFactorIncrease,
	                acceptFactorDecrease: acceptFactorDecrease
	            });
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return this.props.bettingMode !== nextProps.bettingMode || this.props.user !== nextProps.user || this.state !== nextState;
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener('click', this._onDocumentClick);
	        }
	    }, {
	        key: '_isInsidePopup',
	        value: function _isInsidePopup(element) {
	            if (element === null) {
	                return false;
	            }
	
	            if (element === this.refs.popup) {
	                return true;
	            }
	
	            return this._isInsidePopup(element.parentElement);
	        }
	    }, {
	        key: '_onDocumentClick',
	        value: function _onDocumentClick(e) {
	            if (this._isInsidePopup(e.target)) {
	                return;
	            }
	
	            document.removeEventListener('click', this._onDocumentClick);
	
	            this.props.onClosing();
	        }
	    }, {
	        key: '_handleOneClickModeClick',
	        value: function _handleOneClickModeClick(e) {
	            e.preventDefault();
	            var value = !this.state.isOneClickOn;
	
	            this.setState((0, _assign2.default)({}, this.state, {
	                isOneClickOn: value
	            }));
	
	            this._onOneClickModeChanged();
	        }
	    }, {
	        key: '_handleOneClickAmountChange',
	        value: function _handleOneClickAmountChange(e) {
	            e.preventDefault();
	            var value = parseInt(e.target.value);
	
	            this.setState((0, _assign2.default)({}, this.state, {
	                oneClickAmount: value
	            }));
	
	            this._onOneClickAmountChanged(value);
	        }
	    }, {
	        key: '_handleAcceptFactorIncrease',
	        value: function _handleAcceptFactorIncrease(val, e) {
	            e.preventDefault();
	
	            var state = this.state;
	            this.setState((0, _extends3.default)({}, state, {
	                acceptFactorIncrease: val
	            }));
	
	            this._onAcceptFactorIncreaseChanged(val);
	        }
	    }, {
	        key: '_handleAcceptFactorDecrease',
	        value: function _handleAcceptFactorDecrease(val, e) {
	            e.preventDefault();
	
	            this.setState((0, _assign2.default)({}, this.state, {
	                acceptFactorDecrease: val
	            }));
	
	            this._onAcceptFactorDecreaseChanged(val);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var user = this.props.user;
	
	
	            var resourceId = void 0;
	            var currency = void 0;
	            var minStakeAmount = 0;
	            var maxStakeAmount = 0;
	
	            if (user) {
	                resourceId = user.get('resourceId');
	                currency = resources.resourceNames[resourceId];
	                minStakeAmount = _StakeMinAmount.minAmount[currency];
	                maxStakeAmount = _StakeMaxAmount.maxAmount[currency];
	            }
	
	            var acceptIncrease = this.state.acceptFactorIncrease;
	            var acceptDecrease = this.state.acceptFactorDecrease;
	
	            var oneClick = this.state.isOneClickOn;
	
	            var oneClickAmount = this.state.oneClickAmount || 0;
	            var favouriteBet1Amount = this.state.favouriteBet1Amount || 0;
	            var favouriteBet2Amount = this.state.favouriteBet2Amount || 0;
	            var favouriteBet3Amount = this.state.favouriteBet3Amount || 0;
	
	            var boundAcceptIncreaseClick = this._handleAcceptFactorIncrease.bind(this, !acceptIncrease);
	            var boundAcceptDecreaseClick = this._handleAcceptFactorDecrease.bind(this, !acceptDecrease);
	
	            var boundOneClickAmountChange = this._handleOneClickAmountChange.bind(this);
	
	            return _react2.default.createElement(
	                'ul',
	                { ref: 'popup', className: 'dropdown--menu dropdown--menu-coupon  dropdown--menu__shown' },
	                _react2.default.createElement(
	                    'li',
	                    { className: 'title dropdown--menu__title dropdown--menu__item' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'dropdown--menu__span' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.title)
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    { className: 'dropdown--menu__item' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'dropdown--menu-coupon__block', onClick: this._handleOneClickModeClick },
	                        _react2.default.createElement('input', { className: 'checkbox--list__checkbox',
	                            type: 'checkbox',
	                            checked: oneClick,
	                            onChange: this._handleOneClickModeClick }),
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'checkbox--list__label checkbox--list__label__js' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.oneClickCheckBox)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'dropdown--menu-coupon__block' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'dropdown--menu-coupon__span' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.oneClickAmount)
	                        ),
	                        _react2.default.createElement('input', { className: (0, _classnames2.default)('dropdown--menu-coupon__input', { error: isMinAndMaxValueWrong(minStakeAmount, maxStakeAmount, oneClickAmount) }),
	                            pattern: '[0-9]*',
	                            maxLength: '7',
	                            value: oneClickAmount,
	                            onChange: boundOneClickAmountChange,
	                            onBlur: boundOneClickAmountChange }),
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'dropdown--menu-coupon__input__label' },
	                            currency
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    { className: 'dropdown--menu__item' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'dropdown--menu-coupon__block', onClick: boundAcceptIncreaseClick },
	                        _react2.default.createElement('input', { className: 'checkbox--list__checkbox',
	                            type: 'checkbox',
	                            checked: acceptIncrease,
	                            onChange: boundAcceptIncreaseClick }),
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'checkbox--list__label checkbox--list__label__js' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.acceptFactorIncrease)
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    { className: 'dropdown--menu__item' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'dropdown--menu-coupon__block', onClick: boundAcceptDecreaseClick },
	                        _react2.default.createElement('input', { className: 'checkbox--list__checkbox',
	                            type: 'checkbox',
	                            checked: acceptDecrease,
	                            onChange: boundAcceptDecreaseClick }),
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'checkbox--list__label checkbox--list__label__js' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.acceptFactorDecrease)
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    { className: 'dropdown--menu__item dropdown--menu__item__favourites' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'dropdown--menu-coupon__block__favourites dropdown--menu-coupon__block' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'dropdown--menu-coupon__input__label' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.favouriteBets)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'dropdown--menu-coupon__block' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'dropdown--menu-coupon__span' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, messages.favouriteBet, { values: { num: 1 } }))
	                        ),
	                        _react2.default.createElement('input', { className: (0, _classnames2.default)('dropdown--menu-coupon__input', { error: isMinAndMaxValueWrong(minStakeAmount, maxStakeAmount, favouriteBet1Amount) }),
	                            value: favouriteBet1Amount,
	                            onChange: this._handleFavouriteAmountChange(1),
	                            onBlur: this._handleFavouriteAmountChange(1) }),
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'dropdown--menu-coupon__input__label' },
	                            currency
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'dropdown--menu-coupon__block' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'dropdown--menu-coupon__span' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, messages.favouriteBet, { values: { num: 2 } }))
	                        ),
	                        _react2.default.createElement('input', { className: (0, _classnames2.default)('dropdown--menu-coupon__input', { error: isMinAndMaxValueWrong(minStakeAmount, maxStakeAmount, favouriteBet2Amount) }),
	                            value: favouriteBet2Amount,
	                            onChange: this._handleFavouriteAmountChange(2),
	                            onBlur: this._handleFavouriteAmountChange(2) }),
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'dropdown--menu-coupon__input__label' },
	                            currency
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'dropdown--menu-coupon__block' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'dropdown--menu-coupon__span' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, messages.favouriteBet, { values: { num: 3 } }))
	                        ),
	                        _react2.default.createElement('input', { className: (0, _classnames2.default)('dropdown--menu-coupon__input', { error: isMinAndMaxValueWrong(minStakeAmount, maxStakeAmount, favouriteBet3Amount) }),
	                            value: favouriteBet3Amount,
	                            onChange: this._handleFavouriteAmountChange(3),
	                            onBlur: this._handleFavouriteAmountChange(3) }),
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'dropdown--menu-coupon__input__label' },
	                            currency
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return CouponDropDownMenu;
	}(_react2.default.Component);
	
	CouponDropDownMenu.propTypes = {
	    bettingMode: _react2.default.PropTypes.object.isRequired,
	    user: _react2.default.PropTypes.any,
	    onClosing: _react2.default.PropTypes.func.isRequired,
	    toggleOneClickModeAction: _react2.default.PropTypes.func.isRequired,
	    setOneClickAmountAction: _react2.default.PropTypes.func.isRequired,
	    toggleAcceptFactorIncreaseAction: _react2.default.PropTypes.func.isRequired,
	    toggleAcceptFactorDecreaseAction: _react2.default.PropTypes.func.isRequired,
	    setFavouriteBetAmountAction: _react2.default.PropTypes.func.isRequired
	};
	function isMinAndMaxValueWrong() {
	    var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 99999999;
	    var value = arguments[2];
	
	    if (value < min || value > max) {
	        return true;
	    }
	    return false;
	}
	
	function select(state, props) {
	    var bettingMode = props.bettingMode;
	    var user = props.user;
	
	    return {
	        countryCode: state.application.get('countryCode'),
	        bettingMode: bettingMode,
	        user: user
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, {
	    toggleOneClickModeAction: _BettingMode.toggleOneClickMode,
	    setOneClickAmountAction: _BettingMode.setOneClickAmount,
	    toggleAcceptFactorIncreaseAction: _BettingMode.toggleAcceptFactorIncrease,
	    toggleAcceptFactorDecreaseAction: _BettingMode.toggleAcceptFactorDecrease,
	    setFavouriteBetAmountAction: _BettingMode.setFavouriteBetAmount
	})(CouponDropDownMenu);

/***/ },
/* 307 */,
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(345);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ },
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var COLLAPSE_ALL_GROUPS = exports.COLLAPSE_ALL_GROUPS = 'COLLAPSE_ALL_GROUPS';
	var COLLAPSE_ALL_MATCHES = exports.COLLAPSE_ALL_MATCHES = 'COLLAPSE_ALL_MATCHES';

/***/ },
/* 332 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var EXPAND_ALL_GROUPS = exports.EXPAND_ALL_GROUPS = 'EXPAND_ALL_GROUPS';
	var EXPAND_ALL_MATCHES = exports.EXPAND_ALL_MATCHES = 'EXPAND_ALL_MATCHES';

/***/ },
/* 333 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NONE = exports.NONE = 1;
	var DECREASE = exports.DECREASE = 2;
	var INCREASE = exports.INCREASE = 3;
	var BOTH = exports.BOTH = 4;

/***/ },
/* 334 */,
/* 335 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var INIT = exports.INIT = 0;
	var REQUEST = exports.REQUEST = 2;
	var FINISH = exports.FINISH = 3;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TRANSFORM = undefined;
	
	var _assign = __webpack_require__(15);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _symbol = __webpack_require__(512);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _ImmutableRepository = __webpack_require__(337);
	
	var _ImmutableRepository2 = _interopRequireDefault(_ImmutableRepository);
	
	var _ExpandKeyModifier = __webpack_require__(338);
	
	var _ExpandKeyModifier2 = _interopRequireDefault(_ExpandKeyModifier);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TRANSFORM = exports.TRANSFORM = (0, _symbol2.default)('Transform');
	
	var preMatchRepository = new _ImmutableRepository2.default();
	var menuRepository = new _ImmutableRepository2.default();
	var liveRepository = new _ImmutableRepository2.default();
	var stakeOfTheDayRepository = new _ImmutableRepository2.default();
	var popularMatchesRepository = new _ImmutableRepository2.default();
	var timetableRepository = new _ImmutableRepository2.default();
	
	function transformData(data, transformType, section) {
	    var repo = void 0;
	    var modifier = void 0;
	
	    if (section === 'preMatch') {
	        repo = preMatchRepository;
	    } else if (section === 'live') {
	        repo = liveRepository;
	    } else if (section === 'menu') {
	        repo = menuRepository;
	    } else if (section === 'stakeOfTheDay') {
	        repo = stakeOfTheDayRepository;
	    } else if (section === 'popularMatches') {
	        repo = popularMatchesRepository;
	    } else if (section === 'timetable') {
	        repo = timetableRepository;
	    }
	
	    if (!repo) {
	        return data;
	    }
	
	    if (transformType === 'init' || transformType === 'update') {
	        modifier = new _ExpandKeyModifier2.default(repo);
	    }
	
	    if (modifier) {
	        modifier.modify(data);
	    }
	
	    return data;
	}
	
	exports.default = function (store) {
	    return function (next) {
	        return function (action) {
	            //eslint-disable-line no-unused-vars
	            var transform = action[TRANSFORM];
	            if (typeof transform === 'undefined') {
	                return next(action);
	            }
	
	            var transformType = transform.transformType,
	                section = transform.section,
	                provider = transform.provider;
	
	            var type = action.type;
	            var data = action.data;
	
	            var content = void 0;
	            if (typeof provider === 'function') {
	                content = provider(data);
	            }
	
	            if (!content) {
	                return next(action);
	            }
	
	            function actionWith(data) {
	                var finalAction = (0, _assign2.default)({}, action, data);
	                delete finalAction[TRANSFORM];
	                return finalAction;
	            }
	
	            var transformedData = transformData(content, transformType, section);
	
	            return next(actionWith({
	                type: type,
	                data: transformedData,
	                section: section
	            }));
	        };
	    };
	};

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _Immutable$fromJS;
	
	var _immutable = __webpack_require__(14);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SPORT_KEYS = 'sports';
	var LEAGUE_KEYS = 'leagues';
	var MATCH_KEYS = 'matches';
	var SCORE_KEYS = 'scores';
	var OUTCOME_KEYS = 'outcomes';
	var RATE_KEYS = 'rates';
	
	var repository = _immutable2.default.fromJS((_Immutable$fromJS = {}, (0, _defineProperty3.default)(_Immutable$fromJS, SPORT_KEYS, {}), (0, _defineProperty3.default)(_Immutable$fromJS, LEAGUE_KEYS, {}), (0, _defineProperty3.default)(_Immutable$fromJS, MATCH_KEYS, {}), (0, _defineProperty3.default)(_Immutable$fromJS, SCORE_KEYS, {}), (0, _defineProperty3.default)(_Immutable$fromJS, OUTCOME_KEYS, {}), (0, _defineProperty3.default)(_Immutable$fromJS, RATE_KEYS, {}), _Immutable$fromJS));
	
	var ImmutableRepository = function () {
	    function ImmutableRepository() {
	        (0, _classCallCheck3.default)(this, ImmutableRepository);
	
	        this._repo = repository;
	    }
	
	    (0, _createClass3.default)(ImmutableRepository, [{
	        key: 'addSport',
	        value: function addSport(id) {
	            var key = { id: id };
	            this._repo = this._repo.setIn([SPORT_KEYS, id], key);
	            return key;
	        }
	    }, {
	        key: 'getSportKey',
	        value: function getSportKey(id) {
	            return this._repo.getIn([SPORT_KEYS, id]);
	        }
	    }, {
	        key: 'removeSport',
	        value: function removeSport(id) {
	            this._repo = this._repo.deleteIn([SPORT_KEYS, id]);
	
	            var leagues = this._repo.get(LEAGUE_KEYS).filter(function (l) {
	                return l.sportId === id;
	            }).map(function (l) {
	                return l.id;
	            }).toArray();
	
	            for (var i = 0; i < leagues.length; i++) {
	                this.removeLeague(leagues[i]);
	            }
	        }
	    }, {
	        key: 'addLeague',
	        value: function addLeague(sportId, leagueId) {
	            var key = {
	                sportId: sportId,
	                id: leagueId
	            };
	
	            this._repo = this._repo.setIn([LEAGUE_KEYS, leagueId], key);
	
	            return key;
	        }
	    }, {
	        key: 'getLeagueKey',
	        value: function getLeagueKey(id) {
	            return this._repo.getIn([LEAGUE_KEYS, id]);
	        }
	    }, {
	        key: 'removeLeague',
	        value: function removeLeague(leagueId) {
	            var key = this._repo.getIn([LEAGUE_KEYS, leagueId]);
	
	            this._repo = this._repo.deleteIn([LEAGUE_KEYS, leagueId]);
	
	            var matches = this._repo.get(MATCH_KEYS).filter(function (m) {
	                return m.leagueId === leagueId;
	            }).map(function (l) {
	                return l.id;
	            }).toArray();
	
	            for (var i = 0; i < matches.length; i++) {
	                this.removeMatch(matches[i]);
	            }
	
	            return key;
	        }
	    }, {
	        key: 'addMatch',
	        value: function addMatch(leagueId, matchId) {
	            var leagueKey = this._repo.getIn([LEAGUE_KEYS, leagueId]);
	
	            var key = {
	                sportId: leagueKey.sportId,
	                leagueId: leagueId,
	                id: matchId
	            };
	
	            this._repo = this._repo.setIn([MATCH_KEYS, matchId], key);
	
	            return key;
	        }
	    }, {
	        key: 'getMatchKey',
	        value: function getMatchKey(id) {
	            return this._repo.getIn([MATCH_KEYS, id]);
	        }
	    }, {
	        key: 'removeMatch',
	        value: function removeMatch(matchId) {
	            var key = this._repo.getIn([MATCH_KEYS, matchId]);
	
	            this._repo = this._repo.deleteIn([MATCH_KEYS, matchId]);
	
	            var scores = this._repo.get(SCORE_KEYS).filter(function (s) {
	                return s.matchId === matchId;
	            }).map(function (s) {
	                return s.id;
	            }).toArray();
	
	            for (var i = 0; i < scores.length; i++) {
	                this.removeScore(scores[i]);
	            }
	
	            var outcomes = this._repo.get(OUTCOME_KEYS).filter(function (o) {
	                return o.matchId === matchId;
	            }).map(function (o) {
	                return o.id;
	            }).toArray();
	
	            for (var _i = 0; _i < outcomes.length; _i++) {
	                this.removeOutcome(outcomes[_i]);
	            }
	
	            return key;
	        }
	    }, {
	        key: 'addScore',
	        value: function addScore(matchId, scoreId) {
	            var matchKey = this._repo.getIn([MATCH_KEYS, matchId]);
	
	            var key = {
	                sportId: matchKey.sportId,
	                leagueId: matchKey.leagueId,
	                matchId: matchKey.id,
	                id: scoreId
	            };
	
	            this._repo = this._repo.setIn([SCORE_KEYS, scoreId], key);
	
	            return key;
	        }
	    }, {
	        key: 'getScoreKey',
	        value: function getScoreKey(id) {
	            return this._repo.getIn([SCORE_KEYS, id]);
	        }
	    }, {
	        key: 'removeScore',
	        value: function removeScore(scoreId) {
	            var key = this._repo.getIn([SCORE_KEYS, scoreId]);
	
	            this._repo = this._repo.deleteIn([SCORE_KEYS, scoreId]);
	
	            return key;
	        }
	    }, {
	        key: 'addOutcome',
	        value: function addOutcome(matchId, outcomeId) {
	            var matchKey = this._repo.getIn([MATCH_KEYS, matchId]);
	
	            var key = {
	                sportId: matchKey.sportId,
	                leagueId: matchKey.leagueId,
	                matchId: matchKey.id,
	                id: outcomeId
	            };
	
	            this._repo = this._repo.setIn([OUTCOME_KEYS, outcomeId], key);
	
	            return key;
	        }
	    }, {
	        key: 'getOutcomeKey',
	        value: function getOutcomeKey(id) {
	            return this._repo.getIn([OUTCOME_KEYS, id]);
	        }
	    }, {
	        key: 'removeOutcome',
	        value: function removeOutcome(outcomeId) {
	            var key = this._repo.getIn([OUTCOME_KEYS, outcomeId]);
	
	            this._repo = this._repo.deleteIn([OUTCOME_KEYS, outcomeId]);
	
	            var rates = this._repo.get(RATE_KEYS).filter(function (r) {
	                return r.outcomeId === outcomeId;
	            }).map(function (r) {
	                return r.id;
	            }).toArray();
	
	            for (var i = 0; i < rates.length; i++) {
	                this.removeRate(rates[i]);
	            }
	
	            return key;
	        }
	    }, {
	        key: 'addRate',
	        value: function addRate(outcomeId, rateId) {
	            var outcomeKey = this._repo.getIn([OUTCOME_KEYS, outcomeId]);
	
	            var key = {
	                sportId: outcomeKey.sportId,
	                leagueId: outcomeKey.leagueId,
	                matchId: outcomeKey.matchId,
	                outcomeId: outcomeKey.id,
	                id: rateId
	            };
	
	            this._repo = this._repo.setIn([RATE_KEYS, rateId], key);
	
	            return key;
	        }
	    }, {
	        key: 'getRateKey',
	        value: function getRateKey(id) {
	            return this._repo.getIn([RATE_KEYS, id]);
	        }
	    }, {
	        key: 'removeRate',
	        value: function removeRate(rateId) {
	            this._repo = this._repo.deleteIn([RATE_KEYS, rateId]);
	        }
	    }]);
	    return ImmutableRepository;
	}();
	
	exports.default = ImmutableRepository;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _AddedSportsModifier = __webpack_require__(393);
	
	var _AddedSportsModifier2 = _interopRequireDefault(_AddedSportsModifier);
	
	var _AddedLeaguesModifier = __webpack_require__(388);
	
	var _AddedLeaguesModifier2 = _interopRequireDefault(_AddedLeaguesModifier);
	
	var _AddedMatchesModifier = __webpack_require__(389);
	
	var _AddedMatchesModifier2 = _interopRequireDefault(_AddedMatchesModifier);
	
	var _AddedScoresModifier = __webpack_require__(392);
	
	var _AddedScoresModifier2 = _interopRequireDefault(_AddedScoresModifier);
	
	var _AddedOutcomesModifier = __webpack_require__(390);
	
	var _AddedOutcomesModifier2 = _interopRequireDefault(_AddedOutcomesModifier);
	
	var _AddedRatesModifier = __webpack_require__(391);
	
	var _AddedRatesModifier2 = _interopRequireDefault(_AddedRatesModifier);
	
	var _ChangedSportsModifier = __webpack_require__(398);
	
	var _ChangedSportsModifier2 = _interopRequireDefault(_ChangedSportsModifier);
	
	var _ChangedLeaguesModifier = __webpack_require__(394);
	
	var _ChangedLeaguesModifier2 = _interopRequireDefault(_ChangedLeaguesModifier);
	
	var _ChangedMatchesModifier = __webpack_require__(395);
	
	var _ChangedMatchesModifier2 = _interopRequireDefault(_ChangedMatchesModifier);
	
	var _ChangedScoresModifier = __webpack_require__(397);
	
	var _ChangedScoresModifier2 = _interopRequireDefault(_ChangedScoresModifier);
	
	var _ChangedOutcomesModifier = __webpack_require__(396);
	
	var _ChangedOutcomesModifier2 = _interopRequireDefault(_ChangedOutcomesModifier);
	
	var _RemovedSportsModifier = __webpack_require__(403);
	
	var _RemovedSportsModifier2 = _interopRequireDefault(_RemovedSportsModifier);
	
	var _RemovedLeaguesModifier = __webpack_require__(399);
	
	var _RemovedLeaguesModifier2 = _interopRequireDefault(_RemovedLeaguesModifier);
	
	var _RemovedMatchesModifier = __webpack_require__(400);
	
	var _RemovedMatchesModifier2 = _interopRequireDefault(_RemovedMatchesModifier);
	
	var _RemovedScoresModifier = __webpack_require__(402);
	
	var _RemovedScoresModifier2 = _interopRequireDefault(_RemovedScoresModifier);
	
	var _RemovedOutcomesModifier = __webpack_require__(401);
	
	var _RemovedOutcomesModifier2 = _interopRequireDefault(_RemovedOutcomesModifier);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExpandKeyModifier = function () {
	    function ExpandKeyModifier(repository, modifiers) {
	        (0, _classCallCheck3.default)(this, ExpandKeyModifier);
	
	        this._modifiers = modifiers || [new _AddedSportsModifier2.default(repository), new _AddedLeaguesModifier2.default(repository), new _AddedMatchesModifier2.default(repository), new _AddedScoresModifier2.default(repository), new _AddedOutcomesModifier2.default(repository), new _AddedRatesModifier2.default(repository), new _ChangedSportsModifier2.default(repository), new _ChangedLeaguesModifier2.default(repository), new _ChangedMatchesModifier2.default(repository), new _ChangedOutcomesModifier2.default(repository), new _ChangedScoresModifier2.default(repository), new _RemovedOutcomesModifier2.default(repository), new _RemovedScoresModifier2.default(repository), new _RemovedMatchesModifier2.default(repository), new _RemovedLeaguesModifier2.default(repository), new _RemovedSportsModifier2.default(repository)];
	    }
	
	    (0, _createClass3.default)(ExpandKeyModifier, [{
	        key: 'modify',
	        value: function modify(content) {
	            for (var i = 0; i < this._modifiers.length; i++) {
	                var modifier = this._modifiers[i];
	
	                modifier.modify(content);
	            }
	        }
	    }]);
	    return ExpandKeyModifier;
	}();
	
	exports.default = ExpandKeyModifier;

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LocalizedDocumentMeta = undefined;
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(8);
	
	var _reactHelmet = __webpack_require__(672);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _domainUtils = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LocalizedDocumentMeta = function LocalizedDocumentMeta(_ref) {
	    var title = _ref.title,
	        description = _ref.description,
	        keywords = _ref.keywords;
	
	    var companyName = (0, _domainUtils.getCompanyName)();
	    var currentUrl = window.location.href;
	    return _react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        (0, _extends3.default)({}, title, { values: { companyName: companyName } }),
	        function (titleString) {
	            return _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                (0, _extends3.default)({}, description, { values: { companyName: companyName } }),
	                function (descriptionString) {
	                    return _react2.default.createElement(
	                        _reactIntl.FormattedMessage,
	                        (0, _extends3.default)({}, keywords, { values: { companyName: companyName } }),
	                        function (keywordsString) {
	                            return _react2.default.createElement(_reactHelmet2.default, {
	                                title: titleString,
	                                meta: [{
	                                    "name": "description",
	                                    "content": descriptionString
	                                }, {
	                                    "name": "keywords",
	                                    "content": keywordsString
	                                }],
	                                link: [{ rel: 'canonical', href: currentUrl }]
	                            });
	                        }
	                    );
	                }
	            );
	        }
	    );
	};
	
	exports.LocalizedDocumentMeta = LocalizedDocumentMeta;
	exports.default = LocalizedDocumentMeta;

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getMetadata = undefined;
	
	var _reactIntl = __webpack_require__(8);
	
	var messages = (0, _reactIntl.defineMessages)({
	  general_keywords_KZ: {
	    id: 'page.general_keywords_KZ',
	    defaultMessage: 'букмекерская контора официальный сайт ставка на спорт ставки ставки на спорт онлайн букмекерская контора букмекер ставки букмекерские ставки онлайн сайт ставки ставки онлайн казахстан ставки букмекерская контора ставки кз букмекерская контора онлайн букмекерская контора сайт бк ставки на спорт онлайн онлайн букмекер букмекерская контора сделать ставку онлайн букмекерская контора букмекерская контора он лайн бк ставки на спорт букмекерская контора ставки онлайн букмекерские ставки на спорт онлайн ставки на спорт официальный сайт ставки на спорт бк ставкина спорт букмекерская контора онлайн букмекер кз интернет ставки на спорт контора букмекерская поставить ставку онлайн ставки онлайн кз букмекерская контора ставки спортивный букмекер онлайн ставки букмекерская контора казахстан букмекерские конторы казахстана онлайн официальный букмекер казахстан ставки на спорт ставки онлайн ставки online ставки онлайн на спорт ставка онлайн ставки спортивные букмекерская контора в казахстане ставки на спорт в казахстане букмекерская контора онлайн ставки на спорт бк в казахстане'
	  },
	  general_description_KZ: {
	    id: 'page.general_description_KZ',
	    defaultMessage: 'Онлайн ставки на спорт в Казахстане ➤ Официальный сайт легальной букмекерской конторы {companyName} кз 💰 Делайте ставки онлайн в прематч и live ☝ Бонусы 💲 Привлекательные Коэффициенты '
	  },
	  general_page_title_KZ: {
	    id: 'page.general_page_title_KZ',
	    defaultMessage: 'Ставки на спорт онлайн - Букмекерская контора {companyName} в Казахстане'
	  },
	  general_keywords_KG: {
	    id: 'page.general_keywords_KG',
	    defaultMessage: 'букмекерская контора официальный сайт ставка на спорт ставки ставки на спорт онлайн букмекерская контора букмекер ставки букмекерские ставки онлайн сайт ставки ставки онлайн Кыргызстан ставки букмекерская контора ставки кг букмекерская контора онлайн букмекерская контора сайт бк ставки на спорт онлайн онлайн букмекер букмекерская контора сделать ставку онлайн букмекерская контора букмекерская контора он лайн бк ставки на спорт букмекерская контора ставки онлайн букмекерские ставки на спорт онлайн ставки на спорт официальный сайт ставки на спорт бк ставкина спорт букмекерская контора онлайн букмекер кг интернет ставки на спорт контора букмекерская поставить ставку онлайн ставки онлайн кг букмекерская контора ставки спортивный букмекер онлайн ставки букмекерская контора Кыргызстан букмекерские конторы Кыргызстана онлайн официальный букмекер Кыргызстан ставки на спорт ставки онлайн ставки online ставки онлайн на спорт ставка онлайн ставки спортивные букмекерская контора в Кыргызстане ставки на спорт в Кыргызстане букмекерская контора онлайн ставки на спорт бк в Кыргызстане'
	  },
	  general_description_KG: {
	    id: 'page.general_description_KG',
	    defaultMessage: 'Онлайн ставки на спорт в Кыргызстане ➤ Официальный сайт легальной букмекерской конторы {companyName} кг 💰 Делайте ставки онлайн в прематч и live ☝ Бонусы 💲 Привлекательные Коэффициенты'
	  },
	  general_page_title_KG: {
	    id: 'page.general_page_title_KG',
	    defaultMessage: 'Ставки на спорт онлайн - Букмекерская контора {companyName} в Кыргызстане'
	  },
	  general_page_title_UZ: {
	    id: 'page.general_page_title_UZ',
	    defaultMessage: 'Ставки на спорт онлайн - Букмекерская контора {companyName} в Узбекистане'
	  },
	  general_description_UZ: {
	    id: 'page.general_description_UZ',
	    defaultMessage: 'Онлайн ставки на спорт в Узбекистане ➤ Официальный сайт легальной букмекерской конторы {companyName} уз 💰 Делайте ставки онлайн в прематч и live ☝ Бонусы 💲 Привлекательные Коэффициенты '
	  },
	  general_keywords_UZ: {
	    id: 'page.general_keywords_UZ',
	    defaultMessage: 'букмекерская контора официальный сайт ставка на спорт ставки ставки на спорт онлайн букмекерская контора букмекер ставки букмекерские ставки онлайн сайт ставки ставки онлайн Узбекистан ставки букмекерская контора ставки уз букмекерская контора онлайн букмекерская контора сайт бк ставки на спорт онлайн онлайн букмекер букмекерская контора сделать ставку онлайн букмекерская контора букмекерская контора он лайн бк ставки на спорт букмекерская контора ставки онлайн букмекерские ставки на спорт онлайн ставки на спорт официальный сайт ставки на спорт бк ставкина спорт букмекерская контора онлайн букмекер уз интернет ставки на спорт контора букмекерская поставить ставку онлайн ставки онлайн уз букмекерская контора ставки спортивный букмекер онлайн ставки букмекерская контора Узбекистан букмекерские конторы Узбекистана онлайн официальный букмекер Узбекистан ставки на спорт ставки онлайн ставки online ставки онлайн на спорт ставка онлайн ставки спортивные букмекерская контора в Узбекистане ставки на спорт в Узбекистане букмекерская контора онлайн ставки на спорт бк в Узбекистане'
	  },
	  live_page_title_KZ: {
	    id: 'page.live_page_title_KZ',
	    defaultMessage: 'Лайв ставки на спорт в букмекерской конторе {companyName}'
	  },
	  live_page_description_KZ: {
	    id: 'page.live_page_description_KZ',
	    defaultMessage: 'Сделать лайв-ставки по ходу матча 👉 Ставки на спорт в режиме live на официальной сайте бк РингоБет в Казахстане'
	  },
	  live_page_keywords_KZ: {
	    id: 'page.live_page_keywords_KZ',
	    defaultMessage: 'live ставки лайв ставки ставки лайв ставки live ставки лайф ставки на лайв лайв ставка live ставка live ставки на спорт ставки лайв на спорт ставки на спорт лайф ставки на сегодня'
	  },
	  live_page_title_KG: {
	    id: 'page.live_page_title_KG',
	    defaultMessage: 'Лайв ставки на спорт в букмекерской конторе {companyName}'
	  },
	  live_page_description_KG: {
	    id: 'page.live_page_description_KG',
	    defaultMessage: 'Сделать лайв-ставки по ходу матча 👉 Ставки на спорт в режиме live на официальной сайте бк Фэйрплей в Кыргызстане'
	  },
	  live_page_keywords_KG: {
	    id: 'page.live_page_keywords_KG',
	    defaultMessage: 'live ставки лайв ставки ставки лайв ставки live ставки лайф ставки на лайв лайв ставка live ставка live ставки на спорт ставки лайв на спорт ставки на спорт лайф ставки на сегодня'
	  },
	  live_page_title_UZ: {
	    id: 'page.live_page_title_UZ',
	    defaultMessage: 'Лайв ставки на спорт в букмекерской конторе {companyName}'
	  },
	  live_page_description_UZ: {
	    id: 'page.live_page_description_UZ',
	    defaultMessage: 'Сделать лайв-ставки по ходу матча 👉 Ставки на спорт в режиме live на официальной сайте бк Фэйрплей в Узбекистане'
	  },
	  live_page_keywords_UZ: {
	    id: 'page.live_page_keywords_UZ',
	    defaultMessage: 'live ставки лайв ставки ставки лайв ставки live ставки лайф ставки на лайв лайв ставка live ставка live ставки на спорт ставки лайв на спорт ставки на спорт лайф ставки на сегодня'
	  },
	  sports_2_title_KZ: {
	    id: 'page.sports_2_title_KZ',
	    defaultMessage: 'Ставки на настольный теннис онлайн сегодня 👉 бк {companyName} в Казахстане'
	  },
	  sports_2_description_KZ: {
	    id: 'page.sports_2_description_KZ',
	    defaultMessage: 'Ставки на настольный теннис онлайн 🏈 Пинг-понг сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на настольный теннис 👉 на официальной сайте бк РингоБет в Казахстане'
	  },
	  sports_2_keywords_KZ: {
	    id: 'page.sports_2_keywords_KZ',
	    defaultMessage: 'настольный теннис лайв результаты ставки на настольный теннис настольный теннис лайв ставки ставки на настольный теннис в лайве настольный теннис ставки ставки настольный теннис ставки на настольный теннис лайв пингпонг ставки ставки на ping pong ставки на пинг понг пинг понг ставки'
	  },
	  sports_4_title_KZ: {
	    id: 'page.sports_4_title_KZ',
	    defaultMessage: 'Волейбол лайф - Live ставки на волейбол онлайн сегодня 👉 бк {companyName} в Казахстане'
	  },
	  sports_4_description_KZ: {
	    id: 'page.sports_4_description_KZ',
	    defaultMessage: 'Live ставки на волейбол онлайн 🏐 Волейбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Волейбол Live 👉 на официальной сайте бк РингоБет в Казахстане'
	  },
	  sports_4_keywords_KZ: {
	    id: 'page.sports_4_keywords_KZ',
	    defaultMessage: 'ставки на волейбол онлайн волейбол лайв волейбол live live волейбол ставки на волейбол в лайве'
	  },
	  sports_5_title_KZ: {
	    id: 'page.sports_5_title_KZ',
	    defaultMessage: 'Ставки на бокс - Ставки на бокс онлайн сегодня 👉 бк {companyName} в Казахстане'
	  },
	  sports_5_description_KZ: {
	    id: 'page.sports_5_description_KZ',
	    defaultMessage: 'Ставки на бокс онлайн 🥊 Боксерские бои сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на бокс 👉 на официальной сайте бк РингоБет в Казахстане'
	  },
	  sports_5_keywords_KZ: {
	    id: 'page.sports_5_keywords_KZ',
	    defaultMessage: 'ставки на бокс бокс ставка ставки бокс бокс ставки ставки на бокс на сегодня ставки на бои бокс букмекерские ставки на бокс букмекерская контора ставки на бокс поставить ставку на бокс коэффициенты на бокс ставки на бокс сегодня ставки на спорт бокс сделать ставку на бокс сегодня сделать ставку на бокс сделать ставку на бокс онлайн'
	  },
	  sports_6_title_KZ: {
	    id: 'page.sports_6_title_KZ',
	    defaultMessage: 'Теннис лайв - Live ставки на теннис онлайн сегодня 👉 бк {companyName} в Казахстане'
	  },
	  sports_6_description_KZ: {
	    id: 'page.sports_6_description_KZ',
	    defaultMessage: 'Live ставки на теннис онлайн 🎾 Теннисные матчи сегодня 💰 Высокие коэффициенты ⭐ Теннис Live 👉 на официальной сайте бк РингоБет в Казахстане'
	  },
	  sports_6_keywords_KZ: {
	    id: 'page.sports_6_keywords_KZ',
	    defaultMessage: 'live ставки на теннис ставки на теннис онлайн ставки теннис лайв теннис лайв ставки лайв ставки на теннис лайв ставки теннис ставки на теннис лайв лайв теннис ставки на теннис в лайве прогнозы на теннис live теннис лайв счет теннис онлайн теннис лайв прогнозы'
	  },
	  sports_7_title_KZ: {
	    id: 'page.sports_7_title_KZ',
	    defaultMessage: 'Футбол лайф - Live ставки на футбол онлайн сегодня 👉 бк {companyName} в Казахстане'
	  },
	  sports_7_description_KZ: {
	    id: 'page.sports_7_description_KZ',
	    defaultMessage: 'Live ставки на футбол онлайн ⚽ Футбольные матчи сегодня 👍 Ставки по ходу футбольного матча ⭐ Футбол Live 👉 на официальной сайте бк РингоБет в Казахстане'
	  },
	  sports_7_keywords_KZ: {
	    id: 'page.sports_7_keywords_KZ',
	    defaultMessage: 'live ставки футбол live ставки на футбол футбол лайв ставки лайв футболы футбол лай лив футбол ставки в лайве на футбол лайф футбол футбол лайф футбол лайф сегодня ливе футбол футбол life лайв футбол онлайн live футбол live футбол онлайн футбол в лайве футбольный live лайв спорт футбол live sport футбол ливе спорт футбол футбол лайв футбол ставки на сегодня'
	  },
	  sports_11_title_KZ: {
	    id: 'page.sports_11_title_KZ',
	    defaultMessage: 'Ставки на американский футбол онлайн сегодня 👉 бк {companyName} в Казахстане'
	  },
	  sports_11_description_KZ: {
	    id: 'page.sports_11_description_KZ',
	    defaultMessage: 'Ставки на американский футбол онлайн 🏈 Матчи американского футбола сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на американский футбол 👉 на официальной сайте бк РингоБет в Казахстане'
	  },
	  sports_11_keywords_KZ: {
	    id: 'page.sports_11_keywords_KZ',
	    defaultMessage: 'американский футбол ставки ставки на американский футбол американский футбол сегодня ставки на американский футбол онлайн ставки на американский футбол на сегодня ставки на спорт американский футбол'
	  },
	  sports_19_title_KZ: {
	    id: 'page.sports_19_title_KZ',
	    defaultMessage: 'Гандбол лайф - Live ставки на гандбол онлайн сегодня 👉 бк {companyName} в Казахстане'
	  },
	  sports_19_description_KZ: {
	    id: 'page.sports_19_description_KZ',
	    defaultMessage: 'Live ставки на гандбол онлайн 🤾 Гандбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Гандбол Live 👉 на официальной сайте бк РингоБет в Казахстане'
	  },
	  sports_19_keywords_KZ: {
	    id: 'page.sports_19_keywords_KZ',
	    defaultMessage: 'ставки на гандбол лайв гандбол онлайн'
	  },
	  sports_30_title_KZ: {
	    id: 'page.sports_30_title_KZ',
	    defaultMessage: 'Хоккей лайф - Live ставки на хоккей онлайн сегодня 👉 бк {companyName} в Казахстане'
	  },
	  sports_30_description_KZ: {
	    id: 'page.sports_30_description_KZ',
	    defaultMessage: 'Live ставки на хоккей онлайн 🏒 Хоккейные матчи сегодня 💰 Высокие коэффициенты ⭐ Хоккей Live 👉 на официальной сайте бк РингоБет в Казахстане'
	  },
	  sports_30_keywords_KZ: {
	    id: 'page.sports_30_keywords_KZ',
	    defaultMessage: 'хоккей лайв ставки ставки лайв хоккей ставки на хоккей онлайн хоккей лайф хоккей ливе лайв хоккей лайф хоккей хоккей live хоккей лайв ставки хоккей хоккей ставки'
	  },
	  sports_31_title_KZ: {
	    id: 'page.sports_31_title_KZ',
	    defaultMessage: 'Баскетбол лайв - Live ставки на баскетбол онлайн сегодня 👉 бк {companyName} в Казахстане'
	  },
	  sports_31_description_KZ: {
	    id: 'page.sports_31_description_KZ',
	    defaultMessage: 'Live ставки на баскетбол онлайн 🏀 Баскетбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Баскетбол Live 👉 на официальном сайте бк РингоБет в Казахстане'
	  },
	  sports_31_keywords_KZ: {
	    id: 'page.sports_31_keywords_KZ',
	    defaultMessage: 'баскетбол лайв ставки лайф баскетбол баскетбол ливе баскетбол live ставки на баскетбол в лайве спорт лайф баскетбол'
	  },
	  sports_38_title_KZ: {
	    id: 'page.sports_38_title_KZ',
	    defaultMessage: 'Ставки на киберспорт live онлайн сегодня 👉 бк {companyName} в Казахстане'
	  },
	  sports_38_description_KZ: {
	    id: 'page.sports_38_description_KZ',
	    defaultMessage: 'Live ставки на киберспорт онлайн 🎮 Киберспорт лайв 💰 Высокие коэффициенты 👉 на официальной сайте бк РингоБет в Казахстане'
	  },
	  sports_38_keywords_KZ: {
	    id: 'page.sports_38_keywords_KZ',
	    defaultMessage: 'лайв ставки на киберспорт лайв ставки киберспорт live ставки на киберспорт ставки киберспорт ставки на киберспор'
	  },
	  sports_39_title_KZ: {
	    id: 'page.sports_39_title_KZ',
	    defaultMessage: 'Ставки на UFC - Ставки на ММА онлайн сегодня 👉 бк {companyName} в Казахстане'
	  },
	  sports_39_description_KZ: {
	    id: 'page.sports_39_description_KZ',
	    defaultMessage: 'Ставки на смешанные единоборства (MMA и UFC) онлайн 👊 ЮФС бои сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на бой ММА 👉 на официальной сайте бк РингоБет в Казахстане'
	  },
	  sports_39_keywords_KZ: {
	    id: 'page.sports_39_keywords_KZ',
	    defaultMessage: 'ставки на бои ставки на бой ставки на ufc ставки на юфс ufc ставки ставка на юфс ставка на бой ставка на ufc ставки юфс ставки на ufc в казахстане коэффициент ufc юфс ставки ставки на спорт ufc коэффициенты на бои ufc ставки на бои юфс поставить ставку ufc поставить ставку на бой сделать ставку на ufc ставка ufc сделать ставку на бой ставки на ufc онлайн ставки на бои без правил ufc ставки на бои мма коэффициенты на юфс ставки на мма ставки на спорт юфс ставки на мма бои коэффициент на бой ставки на бойцов ufc ставки ufc сделать ставку ufc ставки на бои ufc ufc коэффициенты ставки ufc коэффициенты ставки на мма сегодня поставить ставку на ufc ставки на спорт бои сделать ставку на мма ставки на спорт мма ставки на мма онлайн'
	  },
	  sports_2_title_KG: {
	    id: 'page.sports_2_title_KG',
	    defaultMessage: 'Ставки на настольный теннис онлайн сегодня 👉 бк {companyName} в Кыргызстане'
	  },
	  sports_2_description_KG: {
	    id: 'page.sports_2_description_KG',
	    defaultMessage: 'Ставки на настольный теннис онлайн 🏈 Пинг-понг сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на настольный теннис 👉 на официальной сайте бк Фэйрплей в Кыргызстане'
	  },
	  sports_2_keywords_KG: {
	    id: 'page.sports_2_keywords_KG',
	    defaultMessage: 'настольный теннис лайв результаты ставки на настольный теннис настольный теннис лайв ставки ставки на настольный теннис в лайве настольный теннис ставки ставки настольный теннис ставки на настольный теннис лайв пингпонг ставки ставки на ping pong ставки на пинг понг пинг понг ставки'
	  },
	  sports_4_title_KG: {
	    id: 'page.sports_4_title_KG',
	    defaultMessage: 'Волейбол лайф - Live ставки на волейбол онлайн сегодня 👉 бк {companyName} в Кыргызстане'
	  },
	  sports_4_description_KG: {
	    id: 'page.sports_4_description_KG',
	    defaultMessage: 'Live ставки на волейбол онлайн 🏐 Волейбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Волейбол Live 👉 на официальной сайте бк Фэйрплей в Кыргызстане'
	  },
	  sports_4_keywords_KG: {
	    id: 'page.sports_4_keywords_KG',
	    defaultMessage: 'ставки на волейбол онлайн волейбол лайв волейбол live live волейбол ставки на волейбол в лайве'
	  },
	  sports_5_title_KG: {
	    id: 'page.sports_5_title_KG',
	    defaultMessage: 'Ставки на бокс - Ставки на бокс онлайн сегодня 👉 бк {companyName} в Кыргызстане'
	  },
	  sports_5_description_KG: {
	    id: 'page.sports_5_description_KG',
	    defaultMessage: 'Ставки на бокс онлайн 🥊 Боксерские бои сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на бокс 👉 на официальной сайте бк Фэйрплей в Кыргызстане'
	  },
	  sports_5_keywords_KG: {
	    id: 'page.sports_5_keywords_KG',
	    defaultMessage: 'ставки на бокс бокс ставка ставки бокс бокс ставки ставки на бокс на сегодня ставки на бои бокс букмекерские ставки на бокс букмекерская контора ставки на бокс поставить ставку на бокс коэффициенты на бокс ставки на бокс сегодня ставки на спорт бокс сделать ставку на бокс сегодня сделать ставку на бокс сделать ставку на бокс онлайн'
	  },
	  sports_6_title_KG: {
	    id: 'page.sports_6_title_KG',
	    defaultMessage: 'Теннис лайв - Live ставки на теннис онлайн сегодня 👉 бк {companyName} в Кыргызстане'
	  },
	  sports_6_description_KG: {
	    id: 'page.sports_6_description_KG',
	    defaultMessage: 'Live ставки на теннис онлайн 🎾 Теннисные матчи сегодня 💰 Высокие коэффициенты ⭐ Теннис Live 👉 на официальной сайте бк Фэйрплей в Кыргызстане'
	  },
	  sports_6_keywords_KG: {
	    id: 'page.sports_6_keywords_KG',
	    defaultMessage: 'live ставки на теннис ставки на теннис онлайн ставки теннис лайв теннис лайв ставки лайв ставки на теннис лайв ставки теннис ставки на теннис лайв лайв теннис ставки на теннис в лайве прогнозы на теннис live теннис лайв счет теннис онлайн теннис лайв прогнозы'
	  },
	  sports_7_title_KG: {
	    id: 'page.sports_7_title_KG',
	    defaultMessage: 'Футбол лайф - Live ставки на футбол онлайн сегодня 👉 бк {companyName} в Кыргызстане'
	  },
	  sports_7_description_KG: {
	    id: 'page.sports_7_description_KG',
	    defaultMessage: 'Live ставки на футбол онлайн ⚽ Футбольные матчи сегодня 👍 Ставки по ходу футбольного матча ⭐ Футбол Live 👉 на официальной сайте бк Фэйрплей в Кыргызстане'
	  },
	  sports_7_keywords_KG: {
	    id: 'page.sports_7_keywords_KG',
	    defaultMessage: 'live ставки футбол live ставки на футбол футбол лайв ставки лайв футболы футбол лай лив футбол ставки в лайве на футбол лайф футбол футбол лайф футбол лайф сегодня ливе футбол футбол life лайв футбол онлайн live футбол live футбол онлайн футбол в лайве футбольный live лайв спорт футбол live sport футбол ливе спорт футбол футбол лайв футбол ставки на сегодня'
	  },
	  sports_11_title_KG: {
	    id: 'page.sports_11_title_KG',
	    defaultMessage: 'Ставки на американский футбол онлайн сегодня 👉 бк {companyName} в Кыргызстане'
	  },
	  sports_11_description_KG: {
	    id: 'page.sports_11_description_KG',
	    defaultMessage: 'Ставки на американский футбол онлайн 🏈 Матчи американского футбола сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на американский футбол 👉 на официальной сайте бк Фэйрплей в Кыргызстане'
	  },
	  sports_11_keywords_KG: {
	    id: 'page.sports_11_keywords_KG',
	    defaultMessage: 'американский футбол ставки ставки на американский футбол американский футбол сегодня ставки на американский футбол онлайн ставки на американский футбол на сегодня ставки на спорт американский футбол'
	  },
	  sports_19_title_KG: {
	    id: 'page.sports_19_title_KG',
	    defaultMessage: 'Гандбол лайф - Live ставки на гандбол онлайн сегодня 👉 бк {companyName} в Кыргызстане'
	  },
	  sports_19_description_KG: {
	    id: 'page.sports_19_description_KG',
	    defaultMessage: 'Live ставки на гандбол онлайн 🤾 Гандбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Гандбол Live 👉 на официальной сайте бк Фэйрплей в Кыргызстане'
	  },
	  sports_19_keywords_KG: {
	    id: 'page.sports_19_keywords_KG',
	    defaultMessage: 'ставки на гандбол лайв гандбол онлайн'
	  },
	  sports_30_title_KG: {
	    id: 'page.sports_30_title_KG',
	    defaultMessage: 'Хоккей лайф - Live ставки на хоккей онлайн сегодня 👉 бк {companyName} в Кыргызстане'
	  },
	  sports_30_description_KG: {
	    id: 'page.sports_30_description_KG',
	    defaultMessage: 'Live ставки на хоккей онлайн 🏒 Хоккейные матчи сегодня 💰 Высокие коэффициенты ⭐ Хоккей Live 👉 на официальной сайте бк Фэйрплей в Кыргызстане'
	  },
	  sports_30_keywords_KG: {
	    id: 'page.sports_30_keywords_KG',
	    defaultMessage: 'хоккей лайв ставки ставки лайв хоккей ставки на хоккей онлайн хоккей лайф хоккей ливе лайв хоккей лайф хоккей хоккей live хоккей лайв ставки хоккей хоккей ставки'
	  },
	  sports_31_title_KG: {
	    id: 'page.sports_31_title_KG',
	    defaultMessage: 'Баскетбол лайв - Live ставки на баскетбол онлайн сегодня 👉 бк {companyName} в Кыргызстане'
	  },
	  sports_31_description_KG: {
	    id: 'page.sports_31_description_KG',
	    defaultMessage: 'Live ставки на баскетбол онлайн 🏀 Баскетбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Баскетбол Live 👉 на официальной сайте бк Фэйрплей в Кыргызстане'
	  },
	  sports_31_keywords_KG: {
	    id: 'page.sports_31_keywords_KG',
	    defaultMessage: 'баскетбол лайв ставки лайф баскетбол баскетбол ливе баскетбол live ставки на баскетбол в лайве спорт лайф баскетбол'
	  },
	  sports_38_title_KG: {
	    id: 'page.sports_38_title_KG',
	    defaultMessage: 'Ставки на киберспорт live онлайн сегодня 👉 бк {companyName} в Кыргызстане'
	  },
	  sports_38_description_KG: {
	    id: 'page.sports_38_description_KG',
	    defaultMessage: 'Live ставки на киберспорт онлайн 🎮 Киберспорт лайв 💰 Высокие коэффициенты 👉 на официальной сайте бк Фэйрплей в Кыргызстане'
	  },
	  sports_38_keywords_KG: {
	    id: 'page.sports_38_keywords_KG',
	    defaultMessage: 'лайв ставки на киберспорт лайв ставки киберспорт live ставки на киберспорт ставки киберспорт ставки на киберспор'
	  },
	  sports_39_title_KG: {
	    id: 'page.sports_39_title_KG',
	    defaultMessage: 'Ставки на UFC - Ставки на ММА онлайн сегодня 👉 бк {companyName} в Кыргызстане'
	  },
	  sports_39_description_KG: {
	    id: 'page.sports_39_description_KG',
	    defaultMessage: 'Ставки на смешанные единоборства (MMA и UFC) онлайн 👊 ЮФС бои сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на бой ММА 👉 на официальной сайте бк Фэйрплей в Кыргызстане'
	  },
	  sports_39_keywords_KG: {
	    id: 'page.sports_39_keywords_KG',
	    defaultMessage: 'ставки на бои ставки на бой ставки на ufc ставки на юфс ufc ставки ставка на юфс ставка на бой ставка на ufc ставки юфс ставки на ufc в Кыргызстане коэффициент ufc юфс ставки ставки на спорт ufc коэффициенты на бои ufc ставки на бои юфс поставить ставку ufc поставить ставку на бой сделать ставку на ufc ставка ufc сделать ставку на бой ставки на ufc онлайн ставки на бои без правил ufc ставки на бои мма коэффициенты на юфс ставки на мма ставки на спорт юфс ставки на мма бои коэффициент на бой ставки на бойцов ufc ставки ufc сделать ставку ufc ставки на бои ufc ufc коэффициенты ставки ufc коэффициенты ставки на мма сегодня поставить ставку на ufc ставки на спорт бои сделать ставку на мма ставки на спорт мма ставки на мма онлайн'
	  },
	  sports_2_title_UZ: {
	    id: 'page.sports_2_title_UZ',
	    defaultMessage: 'Ставки на настольный теннис онлайн сегодня 👉 бк {companyName} в Узбекистане'
	  },
	  sports_2_description_UZ: {
	    id: 'page.sports_2_description_UZ',
	    defaultMessage: 'Ставки на настольный теннис онлайн 🏈 Пинг-понг сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на настольный теннис 👉 на официальной сайте бк Фэйрплей в Узбекистане'
	  },
	  sports_2_keywords_UZ: {
	    id: 'page.sports_2_keywords_UZ',
	    defaultMessage: 'настольный теннис лайв результаты ставки на настольный теннис настольный теннис лайв ставки ставки на настольный теннис в лайве настольный теннис ставки ставки настольный теннис ставки на настольный теннис лайв пингпонг ставки ставки на ping pong ставки на пинг понг пинг понг ставки'
	  },
	  sports_4_title_UZ: {
	    id: 'page.sports_4_title_UZ',
	    defaultMessage: 'Волейбол лайф - Live ставки на волейбол онлайн сегодня 👉 бк {companyName} в Узбекистане'
	  },
	  sports_4_description_UZ: {
	    id: 'page.sports_4_description_UZ',
	    defaultMessage: 'Live ставки на волейбол онлайн 🏐 Волейбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Волейбол Live 👉 на официальной сайте бк Фэйрплей в Узбекистане'
	  },
	  sports_4_keywords_UZ: {
	    id: 'page.sports_4_keywords_UZ',
	    defaultMessage: 'ставки на волейбол онлайн волейбол лайв волейбол live live волейбол ставки на волейбол в лайве'
	  },
	  sports_5_title_UZ: {
	    id: 'page.sports_5_title_UZ',
	    defaultMessage: 'Ставки на бокс - Ставки на бокс онлайн сегодня 👉 бк {companyName} в Узбекистане'
	  },
	  sports_5_description_UZ: {
	    id: 'page.sports_5_description_UZ',
	    defaultMessage: 'Ставки на бокс онлайн 🥊 Боксерские бои сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на бокс 👉 на официальной сайте бк Фэйрплей в Узбекистане'
	  },
	  sports_5_keywords_UZ: {
	    id: 'page.sports_5_keywords_UZ',
	    defaultMessage: 'ставки на бокс бокс ставка ставки бокс бокс ставки ставки на бокс на сегодня ставки на бои бокс букмекерские ставки на бокс букмекерская контора ставки на бокс поставить ставку на бокс коэффициенты на бокс ставки на бокс сегодня ставки на спорт бокс сделать ставку на бокс сегодня сделать ставку на бокс сделать ставку на бокс онлайн'
	  },
	  sports_6_title_UZ: {
	    id: 'page.sports_6_title_UZ',
	    defaultMessage: 'Теннис лайв - Live ставки на теннис онлайн сегодня 👉 бк {companyName} в Узбекистане'
	  },
	  sports_6_description_UZ: {
	    id: 'page.sports_6_description_UZ',
	    defaultMessage: 'Live ставки на теннис онлайн 🎾 Теннисные матчи сегодня 💰 Высокие коэффициенты ⭐ Теннис Live 👉 на официальной сайте бк Фэйрплей в Узбекистане'
	  },
	  sports_6_keywords_UZ: {
	    id: 'page.sports_6_keywords_UZ',
	    defaultMessage: 'live ставки на теннис ставки на теннис онлайн ставки теннис лайв теннис лайв ставки лайв ставки на теннис лайв ставки теннис ставки на теннис лайв лайв теннис ставки на теннис в лайве прогнозы на теннис live теннис лайв счет теннис онлайн теннис лайв прогнозы'
	  },
	  sports_7_title_UZ: {
	    id: 'page.sports_7_title_UZ',
	    defaultMessage: 'Футбол лайф - Live ставки на футбол онлайн сегодня 👉 бк {companyName} в Узбекистане'
	  },
	  sports_7_description_UZ: {
	    id: 'page.sports_7_description_UZ',
	    defaultMessage: 'Live ставки на футбол онлайн ⚽ Футбольные матчи сегодня 👍 Ставки по ходу футбольного матча ⭐ Футбол Live 👉 на официальной сайте бк Фэйрплей в Узбекистане'
	  },
	  sports_7_keywords_UZ: {
	    id: 'page.sports_7_keywords_UZ',
	    defaultMessage: 'live ставки футбол live ставки на футбол футбол лайв ставки лайв футболы футбол лай лив футбол ставки в лайве на футбол лайф футбол футбол лайф футбол лайф сегодня ливе футбол футбол life лайв футбол онлайн live футбол live футбол онлайн футбол в лайве футбольный live лайв спорт футбол live sport футбол ливе спорт футбол футбол лайв футбол ставки на сегодня'
	  },
	  sports_11_title_UZ: {
	    id: 'page.sports_11_title_UZ',
	    defaultMessage: 'Ставки на американский футбол онлайн сегодня 👉 бк {companyName} в Узбекистане'
	  },
	  sports_11_description_UZ: {
	    id: 'page.sports_11_description_UZ',
	    defaultMessage: 'Ставки на американский футбол онлайн 🏈 Матчи американского футбола сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на американский футбол 👉 на официальной сайте бк Фэйрплей в Узбекистане'
	  },
	  sports_11_keywords_UZ: {
	    id: 'page.sports_11_keywords_UZ',
	    defaultMessage: 'американский футбол ставки ставки на американский футбол американский футбол сегодня ставки на американский футбол онлайн ставки на американский футбол на сегодня ставки на спорт американский футбол'
	  },
	  sports_19_title_UZ: {
	    id: 'page.sports_19_title_UZ',
	    defaultMessage: 'Гандбол лайф - Live ставки на гандбол онлайн сегодня 👉 бк {companyName} в Узбекистане'
	  },
	  sports_19_description_UZ: {
	    id: 'page.sports_19_description_UZ',
	    defaultMessage: 'Live ставки на гандбол онлайн 🤾 Гандбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Гандбол Live 👉 на официальной сайте бк Фэйрплей в Узбекистане'
	  },
	  sports_19_keywords_UZ: {
	    id: 'page.sports_19_keywords_UZ',
	    defaultMessage: 'ставки на гандбол лайв гандбол онлайн'
	  },
	  sports_30_title_UZ: {
	    id: 'page.sports_30_title_UZ',
	    defaultMessage: 'Хоккей лайф - Live ставки на хоккей онлайн сегодня 👉 бк {companyName} в Узбекистане'
	  },
	  sports_30_description_UZ: {
	    id: 'page.sports_30_description_UZ',
	    defaultMessage: 'Live ставки на хоккей онлайн 🏒 Хоккейные матчи сегодня 💰 Высокие коэффициенты ⭐ Хоккей Live 👉 на официальной сайте бк Фэйрплей в Узбекистане'
	  },
	  sports_30_keywords_UZ: {
	    id: 'page.sports_30_keywords_UZ',
	    defaultMessage: 'хоккей лайв ставки ставки лайв хоккей ставки на хоккей онлайн хоккей лайф хоккей ливе лайв хоккей лайф хоккей хоккей live хоккей лайв ставки хоккей хоккей ставки'
	  },
	  sports_31_title_UZ: {
	    id: 'page.sports_31_title_UZ',
	    defaultMessage: 'Баскетбол лайв - Live ставки на баскетбол онлайн сегодня 👉 бк {companyName} в Узбекистане'
	  },
	  sports_31_description_UZ: {
	    id: 'page.sports_31_description_UZ',
	    defaultMessage: 'Live ставки на баскетбол онлайн 🏀 Баскетбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Баскетбол Live 👉 на официальной сайте бк Фэйрплей в Узбекистане'
	  },
	  sports_31_keywords_UZ: {
	    id: 'page.sports_31_keywords_UZ',
	    defaultMessage: 'баскетбол лайв ставки лайф баскетбол баскетбол ливе баскетбол live ставки на баскетбол в лайве спорт лайф баскетбол'
	  },
	  sports_38_title_UZ: {
	    id: 'page.sports_38_title_UZ',
	    defaultMessage: 'Ставки на киберспорт live онлайн сегодня 👉 бк {companyName} в Узбекистане'
	  },
	  sports_38_description_UZ: {
	    id: 'page.sports_38_description_UZ',
	    defaultMessage: 'Live ставки на киберспорт онлайн 🎮 Киберспорт лайв 💰 Высокие коэффициенты 👉 на официальной сайте бк Фэйрплей в Узбекистане'
	  },
	  sports_38_keywords_UZ: {
	    id: 'page.sports_38_keywords_UZ',
	    defaultMessage: 'лайв ставки на киберспорт лайв ставки киберспорт live ставки на киберспорт ставки киберспорт ставки на киберспор'
	  },
	  sports_39_title_UZ: {
	    id: 'page.sports_39_title_UZ',
	    defaultMessage: 'Ставки на UFC - Ставки на ММА онлайн сегодня 👉 бк {companyName} в Узбекистане'
	  },
	  sports_39_description_UZ: {
	    id: 'page.sports_39_description_UZ',
	    defaultMessage: 'Ставки на смешанные единоборства (MMA и UFC) онлайн 👊 ЮФС бои сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на бой ММА 👉 на официальной сайте бк Фэйрплей в Узбекистане'
	  },
	  sports_39_keywords_UZ: {
	    id: 'page.sports_39_keywords_UZ',
	    defaultMessage: 'ставки на бои ставки на бой ставки на ufc ставки на юфс ufc ставки ставка на юфс ставка на бой ставка на ufc ставки юфс ставки на ufc в Узбекистане коэффициент ufc юфс ставки ставки на спорт ufc коэффициенты на бои ufc ставки на бои юфс поставить ставку ufc поставить ставку на бой сделать ставку на ufc ставка ufc сделать ставку на бой ставки на ufc онлайн ставки на бои без правил ufc ставки на бои мма коэффициенты на юфс ставки на мма ставки на спорт юфс ставки на мма бои коэффициент на бой ставки на бойцов ufc ставки ufc сделать ставку ufc ставки на бои ufc ufc коэффициенты ставки ufc коэффициенты ставки на мма сегодня поставить ставку на ufc ставки на спорт бои сделать ставку на мма ставки на спорт мма ставки на мма онлайн'
	  }
	});
	
	var getMetadata = exports.getMetadata = function getMetadata(countryCode, sportId, live) {
	  var sportIdsWithMetaData = [2, 4, 5, 6, 7, 11, 19, 30, 31, 38, 39];
	
	  if (sportIdsWithMetaData.includes(parseInt(sportId))) {
	    return {
	      title: messages['sports_' + sportId + '_title_' + countryCode],
	      description: messages['sports_' + sportId + '_description_' + countryCode],
	      keywords: messages['sports_' + sportId + '_keywords_' + countryCode]
	    };
	  } else if (live) {
	    return {
	      title: messages['live_page_title_' + countryCode],
	      description: messages['live_page_description_' + countryCode],
	      keywords: messages['live_page_keywords_' + countryCode]
	    };
	  } else {
	    return {
	      title: messages['general_page_title_' + countryCode],
	      description: messages['general_description_' + countryCode],
	      keywords: messages['general_keywords_' + countryCode]
	    };
	  }
	};

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BaseRate = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.mapStateToProps = mapStateToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(14);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _BetStatus = __webpack_require__(134);
	
	var BetStatus = _interopRequireWildcard(_BetStatus);
	
	var _renderingCommons = __webpack_require__(137);
	
	var _MatchScoresAdapter = __webpack_require__(768);
	
	var MatchScoresAdapter = _interopRequireWildcard(_MatchScoresAdapter);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BaseRate = exports.BaseRate = function (_React$Component) {
	    (0, _inherits3.default)(BaseRate, _React$Component);
	
	    function BaseRate(props) {
	        (0, _classCallCheck3.default)(this, BaseRate);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (BaseRate.__proto__ || (0, _getPrototypeOf2.default)(BaseRate)).call(this, props));
	
	        _this._timeoutId = null;
	
	        _this._onClick = _this._onClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(BaseRate, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return this.props.rate !== nextProps.rate || this.props.outcomeIsBlocked !== nextProps.outcomeIsBlocked || this.props.isInCoupon !== nextProps.isInCoupon || this.props.user !== nextProps.user || this.props.gridLocalization.languageId !== nextProps.gridLocalization.languageId;
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            var rate = this.props.rate;
	
	            if (rate === undefined || rate.get('isBlocked') || !rate.get('isVisible')) {
	                return;
	            }
	
	            var element = this.refs.rate;
	
	            if (!element) {
	                return;
	            }
	
	            var currentValue = rate.get('value');
	            var prevValue = prevProps.rate.get('value');
	
	            var className = null;
	
	            if (currentValue > prevValue) {
	                className = 'changed-outcome-up';
	            } else if (currentValue < prevValue) {
	                className = 'changed-outcome-down';
	            }
	
	            if (className === null) {
	                return;
	            }
	
	            (0, _renderingCommons.addClass)(element, className);
	
	            this._timeoutId = window.setTimeout(this._onTimeout.bind(this, element, className), 2000);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this._timeoutId !== null) {
	                window.clearTimeout(this._timeoutId);
	            }
	        }
	    }, {
	        key: '_onTimeout',
	        value: function _onTimeout(element, className) {
	            (0, _renderingCommons.removeClass)(element, className);
	            this._timeoutId = null;
	        }
	    }, {
	        key: '_onClick',
	        value: function _onClick(e) {
	            e.preventDefault();
	
	            var _props = this.props,
	                rate = _props.rate,
	                match = _props.match,
	                outcome = _props.outcome,
	                betHistory = _props.betHistory,
	                isInCoupon = _props.isInCoupon;
	
	            /*if (!user) {
	             //TODO: dispatch action 'require log in'
	             return;
	             }*/
	
	            if (isInCoupon) {
	                return;
	            }
	
	            if (rate.get('isBlocked') || !rate.get('isVisible')) {
	                return;
	            }
	
	            if (BaseRate.activeBetExists(betHistory)) {
	                return;
	            }
	
	            var score = this.getMatchScore(match);
	
	            this.props.addRateAction({ rate: rate, match: match, outcome: outcome, score: score });
	        }
	    }, {
	        key: 'getMatchScore',
	        value: function getMatchScore(match) {
	            if (match === undefined) {
	                return undefined;
	            }
	
	            var mainScoreId = MatchScoresAdapter.getMainScore(match.get('scores'));
	
	            if (mainScoreId !== null) {
	                return this.props.scores.get(mainScoreId);
	            }
	
	            return undefined;
	        }
	    }], [{
	        key: 'activeBetExists',
	        value: function activeBetExists(betHistory) {
	            var bet = betHistory.valueSeq().find(function (b) {
	                return b.get('betStatus') < BetStatus.ACCEPTED;
	            });
	
	            return bet !== undefined;
	        }
	    }]);
	    return BaseRate;
	}(_react2.default.Component);
	
	BaseRate.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    user: _react2.default.PropTypes.object,
	    rate: _react2.default.PropTypes.object,
	    match: _react2.default.PropTypes.object,
	    outcome: _react2.default.PropTypes.object,
	    score: _react2.default.PropTypes.object,
	    isInCoupon: _react2.default.PropTypes.bool.isRequired,
	    outcomeIsBlocked: _react2.default.PropTypes.bool.isRequired,
	    addCouponRateAction: _react2.default.PropTypes.func.isRequired,
	    makeBetAction: _react2.default.PropTypes.func.isRequired,
	    requestBetTypesAction: _react2.default.PropTypes.func.isRequired,
	    addRateAction: _react2.default.PropTypes.func.isRequired,
	    gridLocalization: _react2.default.PropTypes.object.isRequired
	};
	function mapStateToProps(state, props) {
	    var section = props.section,
	        id = props.id,
	        gridLocalization = props.gridLocalization;
	
	
	    var sectionObject = state.application.get(section);
	    var coupon = state.application.get('coupon');
	
	    var rate = sectionObject.get('rates').get(id);
	    var isInCoupon = coupon ? coupon.get('betSlips').has(id) : false;
	    var scores = sectionObject.get('scores');
	    var bettingMode = state.application.get('bettingMode');
	    var betHistory = state.application.get('betHistory');
	    var user = state.auth.get('user');
	
	    var match = void 0;
	    var outcome = void 0;
	    var rateWithName = rate;
	    var outcomeIsBlocked = false;
	
	    if (rate) {
	        match = sectionObject.get('matches').get(rate.get('matchId'));
	        outcome = sectionObject.get('outcomes').get(rate.get('outcomeId'));
	        outcomeIsBlocked = outcome.get('isBlocked');
	
	        rateWithName = rate;
	
	        if (match) {
	            var sportId = match.get('realSportId');
	            var matchObj = {
	                homeTeam: match.get('firstTeam'),
	                awayTeam: match.get('secondTeam')
	            };
	
	            var outcomeObj = outcome.toJS();
	            outcomeObj.name = gridLocalization.getOutcomeName(sportId, outcomeObj, matchObj);
	            outcome = _immutable2.default.fromJS(outcomeObj);
	
	            var rateObj = rate.toJS();
	            rateObj.shortName = gridLocalization.getRateName(sportId, outcomeObj, rate.get('type'), matchObj);
	            rateWithName = _immutable2.default.fromJS(rateObj);
	        }
	    }
	
	    return {
	        rate: rateWithName,
	        match: match,
	        outcome: outcome,
	        scores: scores,
	        isInCoupon: isInCoupon,
	        outcomeIsBlocked: outcomeIsBlocked,
	        bettingMode: bettingMode,
	        betHistory: betHistory,
	        user: user
	    };
	}

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(8);
	
	var _domainUtils = __webpack_require__(27);
	
	var _Auth = __webpack_require__(95);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    join: {
	        id: 'header.signin.join_title',
	        defaultMessage: 'Регистрация'
	    },
	    signin: {
	        id: 'header.signin.title',
	        defaultMessage: 'Вход'
	    }
	});
	
	var SignIn = function (_React$Component) {
	    (0, _inherits3.default)(SignIn, _React$Component);
	
	    function SignIn(props, context) {
	        (0, _classCallCheck3.default)(this, SignIn);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (SignIn.__proto__ || (0, _getPrototypeOf2.default)(SignIn)).call(this, props, context));
	
	        _this._handleLogInClick = _this._handleLogInClick.bind(_this);
	        _this._handleJoinClick = _this._handleJoinClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(SignIn, [{
	        key: '_handleLogInClick',
	        value: function _handleLogInClick(e) {
	            e.preventDefault();
	            this.props.beginSignInAction();
	        }
	    }, {
	        key: '_handleJoinClick',
	        value: function _handleJoinClick(e) {
	            e.preventDefault();
	            this.props.beginJoinAction();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'ul',
	                { className: 'header--auth__list' },
	                _domainUtils.isRingo ? null : _react2.default.createElement(
	                    'li',
	                    { className: 'header--auth__item' },
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#', className: 'header--auth__link', onClick: this._handleJoinClick },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.join)
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    { className: 'header--auth__item' },
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#', className: 'header--auth__link', onClick: this._handleLogInClick },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.signin)
	                    )
	                )
	            );
	        }
	    }]);
	    return SignIn;
	}(_react2.default.Component);
	
	SignIn.propTypes = {
	    beginSignInAction: _react.PropTypes.func.isRequired,
	    beginJoinAction: _react.PropTypes.func.isRequired
	};
	
	
	function select() {
	    return {};
	}
	
	exports.default = (0, _reactRedux.connect)(select, { beginSignInAction: _Auth.beginSignIn, beginJoinAction: _Auth.beginJoin })(SignIn);

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderGame = exports.openRegistrationForm = exports.showErrorMessage = exports.handleErrorCode = exports.handleGameClick = undefined;
	
	var _regenerator = __webpack_require__(82);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(97);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Language = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// gameUtils.js
	var handleGameClick = exports.handleGameClick = function () {
	  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(gameId, user, setLoading, handleErrorCode) {
	    var language, gamblerId, queryParam, response, data;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            language = (0, _Language.getLanguageType)().name;
	            gamblerId = user ? user.get('gamblerId') : null;
	            queryParam = gamblerId ? '?gamblerId=' + gamblerId + '&language=' + language : '?language=' + language;
	            _context.prev = 3;
	
	            setLoading(true);
	
	            _context.next = 7;
	            return fetch('/api/games/' + gameId + '/launch/' + queryParam);
	
	          case 7:
	            response = _context.sent;
	
	            if (response.ok) {
	              _context.next = 10;
	              break;
	            }
	
	            throw new Error('Network response was not ok');
	
	          case 10:
	            _context.next = 12;
	            return response.json();
	
	          case 12:
	            data = _context.sent;
	
	
	            if (data.Code) {
	              handleErrorCode(data.Code);
	            } else {
	              console.log('Game Data:', data.LaunchUrl);
	              window.location.assign(data.LaunchUrl);
	            }
	            _context.next = 19;
	            break;
	
	          case 16:
	            _context.prev = 16;
	            _context.t0 = _context['catch'](3);
	
	            console.error('Failed to fetch game details:', _context.t0);
	
	          case 19:
	            _context.prev = 19;
	
	            setLoading(false);
	            return _context.finish(19);
	
	          case 22:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined, [[3, 16, 19, 22]]);
	  }));
	
	  return function handleGameClick(_x, _x2, _x3, _x4) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var handleErrorCode = exports.handleErrorCode = function handleErrorCode(code, showErrorMessage, openRegistrationForm) {
	  var message = void 0;
	
	  switch (code) {
	    case -1:
	      message = {
	        en: 'Failed to find the player in the system.',
	        ru: 'Системаная ошибка (Не удалось найти игрока в системе).'
	      };
	      break;
	    case -2:
	    case -3:
	      openRegistrationForm();
	      // message = {
	      //   en: 'The game is temporarily unavailable; please try again later.',
	      //   ru: 'Игра временно недоступна, повторите попытку позже.',
	      // }
	      break;
	    case -4:
	      openRegistrationForm();
	      break;
	    case -5:
	      message = {
	        en: 'Platform not supported.',
	        ru: 'Платформа не поддерживается.'
	      };
	      break;
	    default:
	      message = {
	        en: 'An unknown error occurred.',
	        ru: 'Произошла неизвестная ошибка.'
	      };
	  }
	
	  showErrorMessage(message);
	};
	
	var showErrorMessage = exports.showErrorMessage = function showErrorMessage(message) {
	  alert(message.ru);
	};
	
	var openRegistrationForm = exports.openRegistrationForm = function openRegistrationForm(setShowSignIn) {
	  setShowSignIn(true);
	};
	
	// gameUtils.js
	
	var renderGame = exports.renderGame = function renderGame(game, handleGameClickWrapper, favoriteGames, pinGame, unpinGame) {
	  var isFavorite = favoriteGames.some(function (g) {
	    return g.Id === game.Id;
	  });
	  var handleFavoriteClick = function handleFavoriteClick(e) {
	    e.stopPropagation();
	    if (isFavorite) {
	      unpinGame(game.Id); // Call unpinGame if already a favorite
	    } else {
	      pinGame(game.Id); // Call pinGame if not a favorite
	    }
	  };
	  return _react2.default.createElement(
	    'div',
	    { key: game.Id, className: 'game-card', onClick: function onClick() {
	        return handleGameClickWrapper(game.Id);
	      } },
	    _react2.default.createElement(
	      'div',
	      { className: 'game-thumbnail' },
	      (game.ThumbnailUrl || '').endsWith(".mp4") ? _react2.default.createElement(
	        'video',
	        { poster: game.ThumbnailUrl, autoPlay: true, muted: true, loop: true, controls: false, className: 'game-image' },
	        _react2.default.createElement('source', { src: game.ThumbnailUrl, type: 'video/mp4' })
	      ) : _react2.default.createElement('img', { src: game.ThumbnailUrl, alt: 'Game ' + game.Name, className: 'game-image' }),
	      _react2.default.createElement(
	        'h3',
	        { className: 'game-title' },
	        game.Name
	      ),
	      _react2.default.createElement(
	        'button',
	        {
	          className: 'favorite-button ' + (isFavorite ? 'favorite' : ''),
	          onClick: handleFavoriteClick
	        },
	        isFavorite ? '★' : '☆'
	      )
	    )
	  );
	};

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.messages = undefined;
	
	var _reactIntl = __webpack_require__(8);
	
	var messages = exports.messages = (0, _reactIntl.defineMessages)({
	  showAllGames: {
	    id: 'newGames.showAllGames',
	    defaultMessage: 'View all games'
	  },
	  showRecentGames: {
	    id: 'newGames.showRecentGames',
	    defaultMessage: 'View recent games'
	  },
	  showFavorites: {
	    id: 'newGames.showFavorites',
	    defaultMessage: 'View favorite games'
	  },
	  allTypes: {
	    id: 'newGames.allTypes',
	    defaultMessage: 'All types'
	  },
	  allProviders: {
	    id: 'newGames.allProviders',
	    defaultMessage: 'All providers'
	  },
	  popular: {
	    id: 'newGames.popular',
	    defaultMessage: 'Popular'
	  },
	  showAll: {
	    id: 'newGames.showAll',
	    defaultMessage: 'View all'
	  },
	  searchGame: {
	    id: 'newGames.searchGame',
	    defaultMessage: 'Search by game name'
	  },
	  goBackToGames: {
	    id: 'newGames.goBackToGames',
	    defaultMessage: 'Back to games'
	  },
	  allGamesForCategory: {
	    id: 'newGames.allGamesForCategory',
	    defaultMessage: 'All games for category'
	  },
	  favoriteGames: {
	    id: 'newGames.favoriteGames',
	    defaultMessage: 'Favorite games'
	  },
	  recentGames: {
	    id: 'newGames.recentGames',
	    defaultMessage: 'Recent games'
	  },
	  recentGamesNot: {
	    id: 'newGames.recentGamesNot',
	    defaultMessage: 'You have no recent games'
	  },
	  favoriteGamesNot: {
	    id: 'newGames.favoriteGamesNot',
	    defaultMessage: 'You have no favorite games'
	  },
	  showMore: {
	    id: 'newGames.showMore',
	    defaultMessage: 'Show more'
	  },
	  allGames: {
	    id: 'newGames.allGames',
	    defaultMessage: 'All games'
	  },
	  new: {
	    id: 'newGames.New',
	    defaultMessage: 'New'
	  },
	  hot: {
	    id: 'newGames.Hot',
	    defaultMessage: 'Hot'
	  }
	});

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(407), __esModule: true };

/***/ },
/* 346 */,
/* 347 */
[2079, 54, 351, 315, 52, 310, 83, 415, 518, 519, 62, 312, 139],
/* 348 */
[2080, 346, 408],
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(50);
	var $export = __webpack_require__(33);
	var meta = __webpack_require__(312);
	var fails = __webpack_require__(122);
	var hide = __webpack_require__(123);
	var redefineAll = __webpack_require__(315);
	var forOf = __webpack_require__(83);
	var anInstance = __webpack_require__(310);
	var isObject = __webpack_require__(53);
	var setToStringTag = __webpack_require__(316);
	var dP = __webpack_require__(54).f;
	var each = __webpack_require__(409)(0);
	var DESCRIPTORS = __webpack_require__(62);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    C = wrapper(function (target, iterable) {
	      anInstance(target, C, NAME, '_c');
	      target._c = new Base();
	      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
	    });
	    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
	      var IS_ADDER = KEY == 'add' || KEY == 'set';
	      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
	        anInstance(this, C, KEY);
	        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
	        var result = this._c[KEY](a === 0 ? 0 : a, b);
	        return IS_ADDER ? this : result;
	      });
	    });
	    IS_WEAK || dP(C.prototype, 'size', {
	      get: function () {
	        return this._c.size;
	      }
	    });
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F, O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 350 */,
/* 351 */,
/* 352 */
[2084, 33, 309, 52, 83],
/* 353 */
[2085, 33],
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(18);
	var bind = __webpack_require__(153);
	var Axios = __webpack_require__(370);
	var mergeConfig = __webpack_require__(151);
	var defaults = __webpack_require__(152);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(mergeConfig(axios.defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(148);
	axios.CancelToken = __webpack_require__(369);
	axios.isCancel = __webpack_require__(149);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(383);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(148);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(18);
	var buildURL = __webpack_require__(154);
	var InterceptorManager = __webpack_require__(371);
	var dispatchRequest = __webpack_require__(373);
	var mergeConfig = __webpack_require__(151);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = arguments[1] || {};
	    config.url = arguments[0];
	  } else {
	    config = config || {};
	  }
	
	  config = mergeConfig(this.defaults, config);
	
	  // Set config.method
	  if (config.method) {
	    config.method = config.method.toLowerCase();
	  } else if (this.defaults.method) {
	    config.method = this.defaults.method.toLowerCase();
	  } else {
	    config.method = 'get';
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	Axios.prototype.getUri = function getUri(config) {
	  config = mergeConfig(this.defaults, config);
	  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(18);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isAbsoluteURL = __webpack_require__(379);
	var combineURLs = __webpack_require__(377);
	
	/**
	 * Creates a new URL by combining the baseURL with the requestedURL,
	 * only when the requestedURL is not already an absolute URL.
	 * If the requestURL is absolute, this function returns the requestedURL untouched.
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} requestedURL Absolute or relative URL to combine
	 * @returns {string} The combined full path
	 */
	module.exports = function buildFullPath(baseURL, requestedURL) {
	  if (baseURL && !isAbsoluteURL(requestedURL)) {
	    return combineURLs(baseURL, requestedURL);
	  }
	  return requestedURL;
	};


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(18);
	var transformData = __webpack_require__(376);
	var isCancel = __webpack_require__(149);
	var defaults = __webpack_require__(152);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 374 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	
	  error.request = request;
	  error.response = response;
	  error.isAxiosError = true;
	
	  error.toJSON = function() {
	    return {
	      // Standard
	      message: this.message,
	      name: this.name,
	      // Microsoft
	      description: this.description,
	      number: this.number,
	      // Mozilla
	      fileName: this.fileName,
	      lineNumber: this.lineNumber,
	      columnNumber: this.columnNumber,
	      stack: this.stack,
	      // Axios
	      config: this.config,
	      code: this.code
	    };
	  };
	  return error;
	};


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(150);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  if (!validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(18);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 377 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(18);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	    (function standardBrowserEnv() {
	      return {
	        write: function write(name, value, expires, path, domain, secure) {
	          var cookie = [];
	          cookie.push(name + '=' + encodeURIComponent(value));
	
	          if (utils.isNumber(expires)) {
	            cookie.push('expires=' + new Date(expires).toGMTString());
	          }
	
	          if (utils.isString(path)) {
	            cookie.push('path=' + path);
	          }
	
	          if (utils.isString(domain)) {
	            cookie.push('domain=' + domain);
	          }
	
	          if (secure === true) {
	            cookie.push('secure');
	          }
	
	          document.cookie = cookie.join('; ');
	        },
	
	        read: function read(name) {
	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	          return (match ? decodeURIComponent(match[3]) : null);
	        },
	
	        remove: function remove(name) {
	          this.write(name, '', Date.now() - 86400000);
	        }
	      };
	    })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return {
	        write: function write() {},
	        read: function read() { return null; },
	        remove: function remove() {}
	      };
	    })()
	);


/***/ },
/* 379 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(18);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	    (function standardBrowserEnv() {
	      var msie = /(msie|trident)/i.test(navigator.userAgent);
	      var urlParsingNode = document.createElement('a');
	      var originURL;
	
	      /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	      function resolveURL(url) {
	        var href = url;
	
	        if (msie) {
	        // IE needs attribute set twice to normalize properties
	          urlParsingNode.setAttribute('href', href);
	          href = urlParsingNode.href;
	        }
	
	        urlParsingNode.setAttribute('href', href);
	
	        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	        return {
	          href: urlParsingNode.href,
	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	          host: urlParsingNode.host,
	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	          hostname: urlParsingNode.hostname,
	          port: urlParsingNode.port,
	          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	            urlParsingNode.pathname :
	            '/' + urlParsingNode.pathname
	        };
	      }
	
	      originURL = resolveURL(window.location.href);
	
	      /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	      return function isURLSameOrigin(requestURL) {
	        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	        return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	      };
	    })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return function isURLSameOrigin() {
	        return true;
	      };
	    })()
	);


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(18);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(18);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 383 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 384 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CREATE_PASSWORD = exports.CREATE_PASSWORD = 'CREATE_PASSWORD';
	var SUCCESS_CREATE_PASSWORD = exports.SUCCESS_CREATE_PASSWORD = 'SUCCESS_CREATE_PASSWORD';
	var FAILURE_CREATE_PASSWORD = exports.FAILURE_CREATE_PASSWORD = 'FAILURE_CREATE_PASSWORD';
	
	var INIT_CREATE_PASSWORD = exports.INIT_CREATE_PASSWORD = 'INIT_CREATE_PASSWORD';

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.changeLanguage = changeLanguage;
	
	var _changeLanguage = __webpack_require__(71);
	
	function changeLanguage(languageId) {
	    return {
	        type: _changeLanguage.CHANGE_LANGUAGE,
	        languageId: languageId
	    };
	}

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.fetchVivoGamesToken = fetchVivoGamesToken;
	exports.fetchTvbetGamesToken = fetchTvbetGamesToken;
	exports.fetchFastsportToken = fetchFastsportToken;
	exports.fetchTvbetRoulletteToken = fetchTvbetRoulletteToken;
	exports.fetchBetsolutionsGamesToken = fetchBetsolutionsGamesToken;
	exports.fetchVirtualSportsGamesToken = fetchVirtualSportsGamesToken;
	exports.getXpressGamesList = getXpressGamesList;
	exports.joinXpressGame = joinXpressGame;
	exports.clearTvBetGamesError = clearTvBetGamesError;
	exports.getProviderXpressGames = getProviderXpressGames;
	exports.getTypesXpressGames = getTypesXpressGames;
	exports.getPinnedXpressGames = getPinnedXpressGames;
	exports.updateXpressPinnedGames = updateXpressPinnedGames;
	
	var _api = __webpack_require__(13);
	
	var _index = __webpack_require__(741);
	
	var Actions = _interopRequireWildcard(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchVivoGamesToken() {
	    return function (dispatch) {
	        return dispatch((0, _defineProperty3.default)({
	            type: Actions.FETCH_VIVO_GAMES_TOKEN
	        }, _api.CALL_API, {
	            endpoint: '/api/games-vivo/',
	            method: "get",
	            types: [Actions.SUCCESS_FETCH_VIVO_GAMES_TOKEN, Actions.FAILURE_FETCH_VIVO_GAMES_TOKEN]
	        }));
	    };
	}
	
	function fetchTvbetGamesToken() {
	    return function (dispatch) {
	        return dispatch((0, _defineProperty3.default)({
	            type: Actions.FETCH_TVBET_GAMES_TOKEN
	        }, _api.CALL_API, {
	            endpoint: '/api/games-tvbet/',
	            method: "get",
	            types: [Actions.SUCCESS_FETCH_TVBET_GAMES_TOKEN, Actions.FAILURE_FETCH_TVBET_GAMES_TOKEN]
	        }));
	    };
	}
	
	function fetchFastsportToken() {
	    return function (dispatch) {
	        return dispatch((0, _defineProperty3.default)({
	            type: Actions.FETCH_FASTSPORT_GAMES_TOKEN
	        }, _api.CALL_API, {
	            endpoint: '/api/games-tvbet/',
	            method: "get",
	            types: [Actions.SUCCESS_FETCH_FASTSPORT_GAMES_TOKEN, Actions.FAILURE_FETCH_FASTSPORT_GAMES_TOKEN]
	        }));
	    };
	}
	
	function fetchTvbetRoulletteToken() {
	    return function (dispatch) {
	        return dispatch((0, _defineProperty3.default)({
	            type: Actions.FETCH_TVBET_ROULLETTE_TOKEN
	        }, _api.CALL_API, {
	            endpoint: '/api/games-tvbet/',
	            method: "get",
	            types: [Actions.SUCCESS_FETCH_TVBET_ROULLETTE_TOKEN, Actions.FAILURE_FETCH_TVBET_ROULLETTE_TOKEN]
	        }));
	    };
	}
	
	function fetchBetsolutionsGamesToken() {
	    return function (dispatch) {
	        return dispatch((0, _defineProperty3.default)({
	            type: Actions.FETCH_BETSOLUTIONS_GAMES_TOKEN
	        }, _api.CALL_API, {
	            endpoint: '/api/games-betsolutions/',
	            method: "get",
	            types: [Actions.SUCCESS_FETCH_BETSOLUTIONS_GAMES_TOKEN, Actions.FAILURE_FETCH_BETSOLUTIONS_GAMES_TOKEN]
	        }));
	    };
	}
	
	function fetchVirtualSportsGamesToken() {
	    return function (dispatch) {
	        return dispatch((0, _defineProperty3.default)({
	            type: Actions.FETCH_VIRTUAL_SPORTS_GAMES_TOKEN
	        }, _api.CALL_API, {
	            endpoint: '/api/games-virtual/',
	            method: "get",
	            types: [Actions.SUCCESS_FETCH_VIRTUAL_SPORTS_GAMES_TOKEN, Actions.FAILURE_FETCH_VIRTUAL_SPORTS_GAMES_TOKEN]
	        }));
	    };
	}
	
	function getXpressGamesList(data) {
	    return function (dispatch) {
	        return dispatch((0, _defineProperty3.default)({
	            type: Actions.FETCH_XPRESS_GAMES
	        }, _api.CALL_API, {
	            endpoint: '/api/games-xpress/games',
	            method: 'post',
	            types: [Actions.SUCCESS_FETCH_XPRESS_GAMES, Actions.FAILURE_FETCH_XPRESS_GAMES],
	            credentials: true,
	            data: data
	        }));
	    };
	}
	
	function joinXpressGame(gameId, data) {
	    return function (dispatch) {
	        return dispatch((0, _defineProperty3.default)({
	            type: Actions.FETCH_XPRESS_TOKEN
	        }, _api.CALL_API, {
	            endpoint: '/api/games-xpress/join/' + gameId,
	            method: "post",
	            types: [Actions.SUCCESS_FETCH_XPRESS_TOKEN, Actions.FAILURE_FETCH_XPRESS_TOKEN],
	            credentials: true,
	            data: data
	        }));
	    };
	}
	
	function clearTvBetGamesError() {
	    return function (dispatch) {
	        return dispatch({ type: Actions.CLEAR_TV_BET_ERROR });
	    };
	}
	
	function getProviderXpressGames() {
	    return function (dispatch) {
	        return dispatch((0, _defineProperty3.default)({
	            type: Actions.FETCH_PROVIDER_XPRESS_GAMES
	        }, _api.CALL_API, {
	            endpoint: '/api/games-xpress/providers',
	            method: "get",
	            types: [Actions.SUCCESS_FETCH_PROVIDER_XPRESS_GAMES, Actions.FAILURE_FETCH_PROVIDER_XPRESS_GAMES]
	        }));
	    };
	}
	
	function getTypesXpressGames() {
	    return function (dispatch) {
	        return dispatch((0, _defineProperty3.default)({
	            type: Actions.FETCH_TYPE_XPRESS_GAMES
	        }, _api.CALL_API, {
	            endpoint: '/api/games-xpress/types',
	            method: "get",
	            types: [Actions.SUCCESS_FETCH_TYPE_XPRESS_GAMES, Actions.FAILURE_FETCH_TYPE_XPRESS_GAMES]
	        }));
	    };
	}
	
	function getPinnedXpressGames(data) {
	    return function (dispatch) {
	        return dispatch((0, _defineProperty3.default)({
	            type: Actions.FETCH_PINNED_XPRESS_GAMES
	        }, _api.CALL_API, {
	            endpoint: '/api/games-xpress/gambler/' + data.gamblerId + '/pinned-games',
	            method: 'get',
	            types: [Actions.SUCCESS_FETCH_PINNED_XPRESS_GAMES, Actions.FAILURE_FETCH_PINNED_XPRESS_GAMES]
	        }));
	    };
	}
	
	function updateXpressPinnedGames(gameId, isPinned) {
	    return function (dispatch) {
	        return dispatch({
	            type: Actions.UPDATE_XPRESS_PINNED_GAMES,
	            data: { gameId: gameId, isPinned: isPinned }
	        });
	    };
	}

/***/ },
/* 387 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var combobetUrl = exports.combobetUrl = 'https://combo.fp.kz';
	// export const combobetUrl = 'http://172.28.4.121:3000';
	var allowedAccountResources = exports.allowedAccountResources = [1];

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(15);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddedLeaguesModifier = function () {
	    function AddedLeaguesModifier(modelKeyRepository) {
	        (0, _classCallCheck3.default)(this, AddedLeaguesModifier);
	
	        this._modelKeyRepository = modelKeyRepository;
	    }
	
	    (0, _createClass3.default)(AddedLeaguesModifier, [{
	        key: "modify",
	        value: function modify(content) {
	            if (content.leagues === undefined || content.leagues.add === undefined) {
	                return;
	            }
	
	            var leagues = content.leagues.add;
	
	            for (var i = 0; i < leagues.length; i++) {
	                var league = leagues[i];
	
	                var key = this._modelKeyRepository.addLeague(league.s, league.id);
	
	                leagues[i] = (0, _assign2.default)({
	                    name: league.n,
	                    priority: league.p
	                }, key);
	            }
	        }
	    }]);
	    return AddedLeaguesModifier;
	}();
	
	exports.default = AddedLeaguesModifier;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(15);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddedMatchesModifier = function () {
	    function AddedMatchesModifier(modelKeyRepository) {
	        (0, _classCallCheck3.default)(this, AddedMatchesModifier);
	
	        this._modelKeyRepository = modelKeyRepository;
	    }
	
	    (0, _createClass3.default)(AddedMatchesModifier, [{
	        key: "modify",
	        value: function modify(content) {
	            if (content.events === undefined || content.events.add === undefined) {
	                return;
	            }
	
	            var matches = content.events.add;
	
	            for (var i = 0; i < matches.length; i++) {
	                var match = matches[i];
	
	                var key = this._modelKeyRepository.addMatch(match.l, match.id);
	
	                matches[i] = (0, _assign2.default)({
	                    timeAndZone: match.taz,
	                    name: match.n,
	                    firstTeam: match.ft,
	                    secondTeam: match.st,
	                    notice: match.ntc,
	                    type: match.t,
	                    realSportId: match.rs,
	                    outcomesCount: match.oc,
	                    radarId: match.te
	                }, key);
	            }
	        }
	    }]);
	    return AddedMatchesModifier;
	}();
	
	exports.default = AddedMatchesModifier;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(15);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddedOutcomesModifier = function () {
	    function AddedOutcomesModifier(modelKeyRepository) {
	        (0, _classCallCheck3.default)(this, AddedOutcomesModifier);
	
	        this._modelKeyRepository = modelKeyRepository;
	    }
	
	    (0, _createClass3.default)(AddedOutcomesModifier, [{
	        key: "modify",
	        value: function modify(content) {
	            var _this = this;
	
	            if (!content.groups) {
	                content.groups = { add: [] };
	            } else {
	                content.groups.add = [];
	            }
	            if (content.outcomes === undefined || content.outcomes.add === undefined) {
	                return;
	            }
	
	            var outcomes = content.outcomes.add;
	
	            var groups = [];
	
	            var _loop = function _loop(i) {
	                var outcome = outcomes[i];
	
	                var key = _this._modelKeyRepository.addOutcome(outcome.e, outcome.id);
	
	                var groupId = parseInt("" + outcome.e + (outcome.g || 0));
	                outcomes[i] = (0, _assign2.default)({
	                    type: outcome.t,
	                    condition: outcome.c,
	                    conditionTwo: outcome.c2,
	                    conditionThree: outcome.c3,
	                    groupId: groupId,
	                    isHeader: outcome.ih,
	                    playerId: outcome.p,
	                    playerName: outcome.pn,
	                    teamOne: outcome.t1,
	                    teamTwo: outcome.t2
	                }, key);
	
	                var group = groups.find(function (g) {
	                    return g.id === groupId;
	                });
	                if (!group) {
	                    group = {
	                        id: groupId,
	                        sportId: key.sportId,
	                        leagueId: key.leagueId,
	                        matchId: key.matchId,
	                        type: outcome.g || 0
	                    };
	
	                    groups.push(group);
	                }
	            };
	
	            for (var i = 0; i < outcomes.length; i++) {
	                _loop(i);
	            }
	
	            if (!content.groups) {
	                content.groups = { add: groups };
	            } else {
	                content.groups.add = groups;
	            }
	        }
	    }]);
	    return AddedOutcomesModifier;
	}();
	
	exports.default = AddedOutcomesModifier;

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(15);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddedRatesModifier = function () {
	    function AddedRatesModifier(modelKeyRepository) {
	        (0, _classCallCheck3.default)(this, AddedRatesModifier);
	
	        this._modelKeyRepository = modelKeyRepository;
	    }
	
	    (0, _createClass3.default)(AddedRatesModifier, [{
	        key: "modify",
	        value: function modify(content) {
	            if (content.rates === undefined || content.rates.add === undefined) {
	                return;
	            }
	
	            var rates = content.rates.add;
	
	            for (var i = 0; i < rates.length; i++) {
	                var rate = rates[i];
	
	                var key = this._modelKeyRepository.addRate(rate.o, rate.id);
	
	                rates[i] = (0, _assign2.default)({
	                    type: rate.t,
	                    value: rate.v
	                }, key);
	            }
	        }
	    }]);
	    return AddedRatesModifier;
	}();
	
	exports.default = AddedRatesModifier;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(15);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddedScoresModifier = function () {
	    function AddedScoresModifier(modelKeyRepository) {
	        (0, _classCallCheck3.default)(this, AddedScoresModifier);
	
	        this._modelKeyRepository = modelKeyRepository;
	    }
	
	    (0, _createClass3.default)(AddedScoresModifier, [{
	        key: "modify",
	        value: function modify(content) {
	            if (content.scores === undefined || content.scores.add === undefined) {
	                return;
	            }
	
	            var scores = content.scores.add;
	
	            for (var i = 0; i < scores.length; i++) {
	                var score = scores[i];
	
	                var scoreKey = this._modelKeyRepository.addScore(score.e, score.id);
	
	                scores[i] = (0, _assign2.default)({
	                    score1: score.s1,
	                    score2: score.s2,
	                    team: score.tm,
	                    type: score.t,
	                    isActive: score.ia
	                }, scoreKey);
	            }
	        }
	    }]);
	    return AddedScoresModifier;
	}();
	
	exports.default = AddedScoresModifier;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(15);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddedSportsModifier = function () {
	    function AddedSportsModifier(modelKeyRepository) {
	        (0, _classCallCheck3.default)(this, AddedSportsModifier);
	
	        this._modelKeyRepository = modelKeyRepository;
	    }
	
	    (0, _createClass3.default)(AddedSportsModifier, [{
	        key: "modify",
	        value: function modify(content) {
	            if (content.sports === undefined || content.sports.add === undefined) {
	                return;
	            }
	
	            var sports = content.sports.add;
	
	            for (var i = 0; i < sports.length; i++) {
	                var sport = sports[i];
	
	                var key = this._modelKeyRepository.addSport(sport.id);
	
	                sports[i] = (0, _assign2.default)({
	                    name: sport.n,
	                    priority: sport.p,
	                    eventCount: sport.ec
	                }, key);
	            }
	        }
	    }]);
	    return AddedSportsModifier;
	}();
	
	exports.default = AddedSportsModifier;

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(15);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChangedLeaguesModifier = function () {
	    function ChangedLeaguesModifier(modelKeyRepository) {
	        (0, _classCallCheck3.default)(this, ChangedLeaguesModifier);
	
	        this._modelKeyRepository = modelKeyRepository;
	    }
	
	    (0, _createClass3.default)(ChangedLeaguesModifier, [{
	        key: "modify",
	        value: function modify(content) {
	            if (content.leagues === undefined || content.leagues.change === undefined) {
	                return;
	            }
	
	            var leagues = content.leagues.change;
	
	            for (var i = 0; i < leagues.length; i++) {
	                var league = leagues[i];
	
	                var key = this._modelKeyRepository.getLeagueKey(league.id);
	
	                leagues[i] = (0, _assign2.default)({
	                    name: league.n,
	                    priority: league.p
	                }, key);
	            }
	        }
	    }]);
	    return ChangedLeaguesModifier;
	}();
	
	exports.default = ChangedLeaguesModifier;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(15);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChangedMatchesModifier = function () {
	    function ChangedMatchesModifier(modelKeyRepository) {
	        (0, _classCallCheck3.default)(this, ChangedMatchesModifier);
	
	        this._modelKeyRepository = modelKeyRepository;
	    }
	
	    (0, _createClass3.default)(ChangedMatchesModifier, [{
	        key: "modify",
	        value: function modify(content) {
	            if (content.events === undefined || content.events.change === undefined) {
	                return;
	            }
	
	            var matches = content.events.change;
	
	            for (var i = 0; i < matches.length; i++) {
	                var match = matches[i];
	
	                var key = this._modelKeyRepository.getMatchKey(match.id);
	
	                matches[i] = (0, _assign2.default)({
	                    name: match.n,
	                    notice: match.ntc
	                }, key);
	            }
	        }
	    }]);
	    return ChangedMatchesModifier;
	}();
	
	exports.default = ChangedMatchesModifier;

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChangedOutcomesModifier = function () {
	    function ChangedOutcomesModifier(modelKeyRepository) {
	        (0, _classCallCheck3.default)(this, ChangedOutcomesModifier);
	
	        this._modelKeyRepository = modelKeyRepository;
	    }
	
	    (0, _createClass3.default)(ChangedOutcomesModifier, [{
	        key: "modify",
	        value: function modify(content) {
	            if (!content.groups) {
	                content.groups = { change: [] };
	            } else {
	                content.groups.change = [];
	            }
	
	            if (content.outcomes === undefined || content.outcomes.change === undefined) {
	                return;
	            }
	
	            var outcomes = content.outcomes.change;
	
	            var groups = [];
	
	            var _loop = function _loop(i) {
	                var outcome = outcomes[i];
	                var groupId = parseInt("" + outcome.e + (outcome.g || 0));
	
	                if (!groups.find(function (g) {
	                    return g === groupId;
	                })) {
	                    groups.push(groupId);
	                }
	            };
	
	            for (var i = 0; i < outcomes.length; i++) {
	                _loop(i);
	            }
	
	            if (!content.groups) {
	                content.groups = { change: groups };
	            } else {
	                content.groups.change = groups;
	            }
	        }
	    }]);
	    return ChangedOutcomesModifier;
	}();
	
	exports.default = ChangedOutcomesModifier;

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(15);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChangedScoresModifier = function () {
	    function ChangedScoresModifier(modelKeyRepository) {
	        (0, _classCallCheck3.default)(this, ChangedScoresModifier);
	
	        this._modelKeyRepository = modelKeyRepository;
	    }
	
	    (0, _createClass3.default)(ChangedScoresModifier, [{
	        key: "modify",
	        value: function modify(content) {
	            if (content.scores === undefined || content.scores.change === undefined) {
	                return;
	            }
	
	            var scores = content.scores.change;
	
	            for (var i = 0; i < scores.length; i++) {
	                var score = scores[i];
	
	                var scoreKey = this._modelKeyRepository.getScoreKey(score.id);
	
	                scores[i] = (0, _assign2.default)({
	                    score1: score.s1,
	                    score2: score.s2,
	                    team: score.tm,
	                    type: score.t,
	                    isActive: score.ia
	                }, scoreKey);
	            }
	        }
	    }]);
	    return ChangedScoresModifier;
	}();
	
	exports.default = ChangedScoresModifier;

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(15);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChangedSportsModifier = function () {
	    function ChangedSportsModifier(modelKeyRepository) {
	        (0, _classCallCheck3.default)(this, ChangedSportsModifier);
	
	        this._modelKeyRepository = modelKeyRepository;
	    }
	
	    (0, _createClass3.default)(ChangedSportsModifier, [{
	        key: "modify",
	        value: function modify(content) {
	            if (content.sports === undefined || content.sports.change === undefined) {
	                return;
	            }
	
	            var sports = content.sports.change;
	
	            for (var i = 0; i < sports.length; i++) {
	                var sport = sports[i];
	
	                var key = this._modelKeyRepository.getSportKey(sport.id);
	
	                sports[i] = (0, _assign2.default)({
	                    name: sport.n,
	                    priority: sport.p
	                }, key);
	            }
	        }
	    }]);
	    return ChangedSportsModifier;
	}();
	
	exports.default = ChangedSportsModifier;

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RemovedLeaguesModifier = function () {
	    function RemovedLeaguesModifier(modelKeyRepository) {
	        (0, _classCallCheck3.default)(this, RemovedLeaguesModifier);
	
	        this._modelKeyRepository = modelKeyRepository;
	    }
	
	    (0, _createClass3.default)(RemovedLeaguesModifier, [{
	        key: "modify",
	        value: function modify(content) {
	            if (content.leagues === undefined) {
	                return;
	            }
	
	            var leagues = content.leagues.remove;
	
	            if (leagues !== undefined) {
	                for (var i = 0; i < leagues.length; i++) {
	                    leagues[i] = this._modelKeyRepository.removeLeague(leagues[i]);
	                }
	            }
	        }
	    }]);
	    return RemovedLeaguesModifier;
	}();
	
	exports.default = RemovedLeaguesModifier;

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RemovedMatchesModifier = function () {
	    function RemovedMatchesModifier(modelKeyRepository) {
	        (0, _classCallCheck3.default)(this, RemovedMatchesModifier);
	
	        this._modelKeyRepository = modelKeyRepository;
	    }
	
	    (0, _createClass3.default)(RemovedMatchesModifier, [{
	        key: "modify",
	        value: function modify(content) {
	            if (content.events === undefined) {
	                return;
	            }
	
	            var matches = content.events.remove;
	
	            if (matches !== undefined) {
	                for (var i = 0; i < matches.length; i++) {
	                    matches[i] = this._modelKeyRepository.removeMatch(matches[i]);
	                }
	            }
	        }
	    }]);
	    return RemovedMatchesModifier;
	}();
	
	exports.default = RemovedMatchesModifier;

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RemovedOutcomesModifier = function () {
	    function RemovedOutcomesModifier(modelKeyRepository) {
	        (0, _classCallCheck3.default)(this, RemovedOutcomesModifier);
	
	        this._modelKeyRepository = modelKeyRepository;
	    }
	
	    (0, _createClass3.default)(RemovedOutcomesModifier, [{
	        key: "modify",
	        value: function modify(content) {
	            if (content.outcomes === undefined) {
	                return;
	            }
	
	            var outcomes = content.outcomes.remove;
	
	            if (outcomes !== undefined) {
	                for (var i = 0; i < outcomes.length; i++) {
	                    outcomes[i] = this._modelKeyRepository.removeOutcome(outcomes[i]);
	                }
	            }
	        }
	    }]);
	    return RemovedOutcomesModifier;
	}();
	
	exports.default = RemovedOutcomesModifier;

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RemovedScoresModifier = function () {
	    function RemovedScoresModifier(modelKeyRepository) {
	        (0, _classCallCheck3.default)(this, RemovedScoresModifier);
	
	        this._modelKeyRepository = modelKeyRepository;
	    }
	
	    (0, _createClass3.default)(RemovedScoresModifier, [{
	        key: "modify",
	        value: function modify(content) {
	            if (content.scores === undefined) {
	                return;
	            }
	
	            var scores = content.scores.remove;
	
	            if (scores !== undefined) {
	                for (var i = 0; i < scores.length; i++) {
	                    scores[i] = this._modelKeyRepository.removeScore(scores[i]);
	                }
	            }
	        }
	    }]);
	    return RemovedScoresModifier;
	}();
	
	exports.default = RemovedScoresModifier;

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RemovedSportsModifier = function () {
	    function RemovedSportsModifier(modelKeyRepository) {
	        (0, _classCallCheck3.default)(this, RemovedSportsModifier);
	
	        this._modelKeyRepository = modelKeyRepository;
	    }
	
	    (0, _createClass3.default)(RemovedSportsModifier, [{
	        key: "modify",
	        value: function modify(content) {
	            if (content.sports === undefined) {
	                return;
	            }
	
	            var sports = content.sports.remove;
	
	            if (sports !== undefined) {
	                for (var i = 0; i < sports.length; i++) {
	                    this._modelKeyRepository.removeSport(sports[i]);
	                }
	            }
	        }
	    }]);
	    return RemovedSportsModifier;
	}();
	
	exports.default = RemovedSportsModifier;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (data) {
	    var gamblerId = data.Id;
	
	    var betHistory = void 0;
	    var bettingMode = void 0;
	    var userGridSelection = void 0;
	    var betSlips = void 0;
	    var betTypes = void 0;
	    var betTypeIndex = void 0;
	    var couponState = void 0;
	    var betSlipAmounts = void 0;
	
	    var betHistoryJson = localStorage.getItem(gamblerId + '_betHistory');
	    if (betHistoryJson !== null && betHistoryJson !== '' && betHistoryJson !== '{}') {
	        betHistory = _immutable2.default.fromJS(JSON.parse(betHistoryJson));
	
	        var isValid = validate(betHistory);
	        if (!isValid) {
	            localStorage.removeItem(gamblerId + '_betHistory');
	        }
	    }
	
	    var bettingModeJson = localStorage.getItem(gamblerId + '_bettingMode');
	    if (bettingModeJson !== null && bettingModeJson !== '' && bettingModeJson !== '{}') {
	        bettingMode = _immutable2.default.fromJS(JSON.parse(bettingModeJson));
	    }
	
	    var userSelectionsJson = localStorage.getItem(gamblerId + '_userSelections');
	    if (userSelectionsJson !== null && userSelectionsJson !== '' && userSelectionsJson !== '{}') {
	        userGridSelection = _immutable2.default.fromJS(JSON.parse(userSelectionsJson));
	    }
	
	    var betSlipsJson = localStorage.getItem(gamblerId + '_betSlips');
	    var betTypesJson = localStorage.getItem(gamblerId + '_betTypes');
	    var betSlipAmountsJson = localStorage.getItem(gamblerId + '_betSlipAmounts');
	    betTypeIndex = localStorage.getItem(gamblerId + '_betTypeIndex');
	    couponState = localStorage.getItem(gamblerId + '_couponState');
	
	    if (betSlipsJson !== null && betSlipsJson !== '' && betSlipsJson !== '{}' && betTypesJson !== null && betTypesJson !== '' && betTypesJson !== '{}' && betSlipAmountsJson !== null && betSlipAmountsJson !== '' && betSlipAmountsJson !== '{}' && betTypeIndex !== null && betTypeIndex !== '') {
	        betSlips = _immutable2.default.fromJS(JSON.parse(betSlipsJson));
	        betTypes = JSON.parse(betTypesJson);
	        betSlipAmounts = JSON.parse(betSlipAmountsJson);
	    }
	
	    return {
	        betHistory: betHistory,
	        bettingMode: bettingMode,
	        userGridSelection: userGridSelection,
	        betSlips: betSlips,
	        betTypes: betTypes,
	        betTypeIndex: Number(betTypeIndex),
	        couponState: Number(couponState),
	        betSlipAmounts: betSlipAmounts
	    };
	};
	
	var _immutable = __webpack_require__(14);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _BetStatus = __webpack_require__(134);
	
	var BetStatus = _interopRequireWildcard(_BetStatus);
	
	var _StakeStatus = __webpack_require__(304);
	
	var StakeStatus = _interopRequireWildcard(_StakeStatus);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(betHistory) {
	    var keys = betHistory.keySeq().toArray();
	
	    for (var i = 0; i < keys.length; i++) {
	        var bh = betHistory.get(keys[i]);
	
	        if (bh.get('stakeId') === undefined || bh.get('betType') === undefined || bh.get('amount') === undefined || bh.get('odd') === undefined || bh.get('possibleWinAmount') === undefined) {
	            return false;
	        }
	
	        var betStatus = bh.get('betStatus');
	        if (betStatus === undefined || betStatus !== BetStatus.INIT && betStatus !== BetStatus.REJECTED && betStatus !== BetStatus.CONFIRMED && betStatus !== BetStatus.CALCULATED && betStatus !== BetStatus.CASHOUT && betStatus !== BetStatus.BET_PAY_REQUEST && betStatus !== BetStatus.IN_DELAY && betStatus !== BetStatus.STAKE_REQUEST && betStatus !== BetStatus.CONFIRM_AWAIT) {
	            return false;
	        }
	
	        var stakeStatus = bh.get('stakeStatus');
	        if (stakeStatus === undefined || stakeStatus !== StakeStatus.ACTIVE && stakeStatus !== StakeStatus.WON && stakeStatus !== StakeStatus.LOST) {
	            return false;
	        }
	
	        var betSlips = bh.get('betSlips');
	        if (betSlips === undefined) {
	            return false;
	        }
	
	        var betSlipKeys = betSlips.keySeq().toArray();
	
	        for (var j = 0; j < betSlipKeys.length; j++) {
	            var bs = betSlips.get(betSlipKeys[j]);
	
	            var rate = bs.get('rate');
	            var outcome = bs.get('outcome');
	            var match = bs.get('match');
	
	            if (rate === undefined || outcome === undefined || match === undefined) {
	                return false;
	            }
	
	            if (rate.get('id') === undefined || rate.get('outcomeId') === undefined || rate.get('type') === undefined || rate.get('value') === undefined) {
	                return false;
	            }
	
	            if (outcome.get('name') === undefined) {
	                return false;
	            }
	
	            if (match.get('timeAndZone') === undefined || match.get('name') === undefined) {
	                return false;
	            }
	        }
	    }
	
	    return true;
	}

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _languageNameMap, _languageClassMap;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(8);
	
	var _Language = __webpack_require__(47);
	
	var Languages = _interopRequireWildcard(_Language);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var languageNameMap = (_languageNameMap = {}, (0, _defineProperty3.default)(_languageNameMap, Languages.RU, 'Русский'), (0, _defineProperty3.default)(_languageNameMap, Languages.EN, 'English'), (0, _defineProperty3.default)(_languageNameMap, Languages.UZ, 'O\'zbek'), (0, _defineProperty3.default)(_languageNameMap, Languages.KK, 'Қазақша'), _languageNameMap);
	
	var languageClassMap = (_languageClassMap = {}, (0, _defineProperty3.default)(_languageClassMap, Languages.RU, 'ru'), (0, _defineProperty3.default)(_languageClassMap, Languages.EN, 'en'), (0, _defineProperty3.default)(_languageClassMap, Languages.UZ, 'uz'), (0, _defineProperty3.default)(_languageClassMap, Languages.KK, 'kk'), _languageClassMap);
	
	var messages = (0, _reactIntl.defineMessages)({
	    localeChoose: {
	        id: 'header.locale.choose',
	        defaultMessage: 'Выбор языка:'
	    }
	});
	
	var Locale = function (_React$Component) {
	    (0, _inherits3.default)(Locale, _React$Component);
	
	    function Locale(props) {
	        (0, _classCallCheck3.default)(this, Locale);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Locale.__proto__ || (0, _getPrototypeOf2.default)(Locale)).call(this, props));
	
	        _this._onLangClick = function (id) {
	            return function (e) {
	                e.preventDefault();
	                _this.props.onLocaleChange(id);
	            };
	        };
	
	        _this.state = { showMenu: false };
	
	        _this._onDocumentClick = _this._onDocumentClick.bind(_this);
	        _this._onShowMenuClick = _this._onShowMenuClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(Locale, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return this.props.languageId !== nextProps.languageId || this.state.showMenu !== nextState.showMenu;
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.showMenu) {
	                document.addEventListener('click', this._onDocumentClick);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener('click', this._onDocumentClick);
	        }
	    }, {
	        key: '_onDocumentClick',
	        value: function _onDocumentClick() {
	            document.removeEventListener('click', this._onDocumentClick);
	
	            this.setState({
	                showMenu: false
	            });
	        }
	    }, {
	        key: '_onShowMenuClick',
	        value: function _onShowMenuClick(e) {
	            e.preventDefault();
	
	            this.setState({
	                showMenu: true
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                languageId = _props.languageId,
	                countryCode = _props.countryCode;
	
	            var languageName = languageNameMap[languageId];
	            var currentLangClass = languageClassMap[languageId];
	
	            var ruSelectLangClass = 'lang' + (languageId === Languages.RU ? ' selected' : '');
	            var enSelectLangClass = 'lang' + (languageId === Languages.EN ? ' selected' : '');
	            var uzSelectLangClass = 'lang' + (languageId === Languages.UZ ? ' selected' : '');
	            var kkSelectLangClass = 'lang' + (languageId === Languages.KK ? ' selected' : '');
	
	            var dropdownCls = 'dropdown' + (this.state.showMenu ? ' shown' : '');
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'language pull-right' },
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', className: 'language-choose', onClick: this._onShowMenuClick },
	                    _react2.default.createElement('span', { className: 'language-toggle' }),
	                    _react2.default.createElement(
	                        'span',
	                        { className: currentLangClass },
	                        languageName
	                    )
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: dropdownCls },
	                    _react2.default.createElement(
	                        'li',
	                        { className: 'title' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.localeChoose)
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: ruSelectLangClass },
	                        _react2.default.createElement(
	                            'a',
	                            { href: '#', className: languageClassMap[Languages.RU], onClick: this._onLangClick(Languages.RU) },
	                            languageNameMap[Languages.RU]
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: enSelectLangClass },
	                        _react2.default.createElement(
	                            'a',
	                            { href: '#', className: languageClassMap[Languages.EN], onClick: this._onLangClick(Languages.EN) },
	                            languageNameMap[Languages.EN]
	                        )
	                    ),
	                    countryCode === 'KZ' && _react2.default.createElement(
	                        'li',
	                        { className: kkSelectLangClass },
	                        _react2.default.createElement(
	                            'a',
	                            { href: '#', className: languageClassMap[Languages.KK], onClick: this._onLangClick(Languages.KK) },
	                            languageNameMap[Languages.KK]
	                        )
	                    ),
	                    countryCode === 'UZ' && _react2.default.createElement(
	                        'li',
	                        { className: uzSelectLangClass },
	                        _react2.default.createElement(
	                            'a',
	                            { href: '#', className: languageClassMap[Languages.UZ], onClick: this._onLangClick(Languages.UZ) },
	                            languageNameMap[Languages.UZ]
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return Locale;
	}(_react2.default.Component);
	
	Locale.propTypes = {
	    languageId: _react2.default.PropTypes.number.isRequired,
	    onLocaleChange: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select(state, props) {
	    var countryCode = state.application.get('countryCode');
	
	    return (0, _extends3.default)({}, props, {
	        countryCode: countryCode
	    });
	}
	
	exports.default = (0, _reactRedux.connect)(select)(Locale);

/***/ },
/* 406 */,
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(99);
	__webpack_require__(419);
	module.exports = __webpack_require__(32).Array.from;


/***/ },
/* 408 */
[2075, 83],
/* 409 */
[2076, 52, 414, 90, 164, 411],
/* 410 */
[2077, 53, 515, 55],
/* 411 */
[2078, 410],
/* 412 */,
/* 413 */
[2081, 54, 314],
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */
[2088, 52, 33, 90, 516, 514, 164, 413, 418, 517],
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./eval')} */
	module.exports = EvalError;


/***/ },
/* 426 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	module.exports = Error;


/***/ },
/* 427 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./range')} */
	module.exports = RangeError;


/***/ },
/* 428 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./ref')} */
	module.exports = ReferenceError;


/***/ },
/* 429 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./uri')} */
	module.exports = URIError;


/***/ },
/* 430 */,
/* 431 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var toStr = Object.prototype.toString;
	var max = Math.max;
	var funcType = '[object Function]';
	
	var concatty = function concatty(a, b) {
	    var arr = [];
	
	    for (var i = 0; i < a.length; i += 1) {
	        arr[i] = a[i];
	    }
	    for (var j = 0; j < b.length; j += 1) {
	        arr[j + a.length] = b[j];
	    }
	
	    return arr;
	};
	
	var slicy = function slicy(arrLike, offset) {
	    var arr = [];
	    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
	        arr[j] = arrLike[i];
	    }
	    return arr;
	};
	
	var joiny = function (arr, joiner) {
	    var str = '';
	    for (var i = 0; i < arr.length; i += 1) {
	        str += arr[i];
	        if (i + 1 < arr.length) {
	            str += joiner;
	        }
	    }
	    return str;
	};
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slicy(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                concatty(args, arguments)
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        }
	        return target.apply(
	            that,
	            concatty(args, arguments)
	        );
	
	    };
	
	    var boundLength = max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs[i] = '$' + i;
	    }
	
	    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ },
/* 432 */
/***/ function(module, exports) {

	'use strict';
	
	var functionsHaveNames = function functionsHaveNames() {
		return typeof function f() {}.name === 'string';
	};
	
	var gOPD = Object.getOwnPropertyDescriptor;
	if (gOPD) {
		try {
			gOPD([], 'length');
		} catch (e) {
			// IE 8 has a broken gOPD
			gOPD = null;
		}
	}
	
	functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
		if (!functionsHaveNames() || !gOPD) {
			return false;
		}
		var desc = gOPD(function () {}, 'name');
		return !!desc && !!desc.configurable;
	};
	
	var $bind = Function.prototype.bind;
	
	functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
		return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
	};
	
	module.exports = functionsHaveNames;


/***/ },
/* 433 */
/***/ function(module, exports) {

	'use strict';
	
	var test = {
		__proto__: null,
		foo: {}
	};
	
	var $Object = Object;
	
	/** @type {import('.')} */
	module.exports = function hasProto() {
		// @ts-expect-error: TS errors on an inherited property for some reason
		return { __proto__: test }.foo === test.foo
			&& !(test instanceof $Object);
	};


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var origSymbol = typeof Symbol !== 'undefined' && Symbol;
	var hasSymbolSham = __webpack_require__(172);
	
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var call = Function.prototype.call;
	var $hasOwn = Object.prototype.hasOwnProperty;
	var bind = __webpack_require__(108);
	
	/** @type {import('.')} */
	module.exports = bind.call(call, $hasOwn);


/***/ },
/* 436 */,
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasToStringTag = __webpack_require__(110)();
	var callBound = __webpack_require__(163);
	
	var $toString = callBound('Object.prototype.toString');
	
	var isStandardArguments = function isArguments(value) {
		if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
			return false;
		}
		return $toString(value) === '[object Arguments]';
	};
	
	var isLegacyArguments = function isArguments(value) {
		if (isStandardArguments(value)) {
			return true;
		}
		return value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			$toString(value) !== '[object Array]' &&
			$toString(value.callee) === '[object Function]';
	};
	
	var supportsStandardArguments = (function () {
		return isStandardArguments(arguments);
	}());
	
	isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
	
	module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getDay = Date.prototype.getDay;
	var tryDateObject = function tryDateGetDayCall(value) {
		try {
			getDay.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	var toStr = Object.prototype.toString;
	var dateClass = '[object Date]';
	var hasToStringTag = __webpack_require__(110)();
	
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) {
			return false;
		}
		return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
	};


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBound = __webpack_require__(163);
	var hasToStringTag = __webpack_require__(110)();
	var has;
	var $exec;
	var isRegexMarker;
	var badStringifier;
	
	if (hasToStringTag) {
		has = callBound('Object.prototype.hasOwnProperty');
		$exec = callBound('RegExp.prototype.exec');
		isRegexMarker = {};
	
		var throwRegexMarker = function () {
			throw isRegexMarker;
		};
		badStringifier = {
			toString: throwRegexMarker,
			valueOf: throwRegexMarker
		};
	
		if (typeof Symbol.toPrimitive === 'symbol') {
			badStringifier[Symbol.toPrimitive] = throwRegexMarker;
		}
	}
	
	var $toString = callBound('Object.prototype.toString');
	var gOPD = Object.getOwnPropertyDescriptor;
	var regexClass = '[object RegExp]';
	
	module.exports = hasToStringTag
		// eslint-disable-next-line consistent-return
		? function isRegex(value) {
			if (!value || typeof value !== 'object') {
				return false;
			}
	
			var descriptor = gOPD(value, 'lastIndex');
			var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
			if (!hasLastIndexDataProperty) {
				return false;
			}
	
			try {
				$exec(value, badStringifier);
			} catch (e) {
				return e === isRegexMarker;
			}
		}
		: function isRegex(value) {
			// In older browsers, typeof regex incorrectly returns 'function'
			if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
				return false;
			}
	
			return $toString(value) === regexClass;
		};


/***/ },
/* 440 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2016j",
		"zones": [
			"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
			"Africa/Accra|LMT GMT GHST|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5",
			"Africa/Nairobi|LMT EAT BEAT BEAUT|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5",
			"Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
			"Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6",
			"Africa/Bissau|LMT WAT GMT|12.k 10 0|012|-2ldWV.E 2xonV.E|39e4",
			"Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
			"Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6",
			"Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5",
			"Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1y7p0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3",
			"Africa/El_Aaiun|LMT WAT WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4",
			"Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5",
			"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|01212121212121212121212121212121213|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|51e5",
			"Africa/Monrovia|MMT LRT GMT|H.8 I.u 0|012|-23Lzg.Q 29s01.m|11e5",
			"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
			"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
			"Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
			"Africa/Windhoek|SWAT SAST SAST CAT WAT WAST|-1u -20 -30 -20 -10 -20|012134545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2GJdu 1Ajdu 1cL0 1SqL0 9NA0 11D0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0|32e4",
			"America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
			"America/Anchorage|CAT CAWT CAPT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
			"America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3",
			"America/Araguaina|LMT BRT BRST|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
			"America/Argentina/Buenos_Aires|CMT ART ARST ART ARST|4g.M 40 30 30 20|0121212121212121212121212121212121212121213434343434343234343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 g0p0 10M0 j3c0 uL0 1qN0 WL0",
			"America/Argentina/Catamarca|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343454343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 ako0 7B0 8zb0 uL0",
			"America/Argentina/Cordoba|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343454343234343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 j3c0 uL0 1qN0 WL0",
			"America/Argentina/Jujuy|CMT ART ARST ART ARST WART WARST|4g.M 40 30 30 20 40 30|01212121212121212121212121212121212121212134343456543432343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 g0p0 10M0 j3c0 uL0",
			"America/Argentina/La_Rioja|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|01212121212121212121212121212121212121212134343434534343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 g0p0 10M0 ako0 7B0 8zb0 uL0",
			"America/Argentina/Mendoza|CMT ART ARST ART ARST WART WARST|4g.M 40 30 30 20 40 30|0121212121212121212121212121212121212121213434345656543235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 g0p0 10M0 agM0 Op0 7TX0 uL0",
			"America/Argentina/Rio_Gallegos|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343434343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 g0p0 10M0 ako0 7B0 8zb0 uL0",
			"America/Argentina/Salta|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|01212121212121212121212121212121212121212134343434543432343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 j3c0 uL0",
			"America/Argentina/San_Juan|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|01212121212121212121212121212121212121212134343434534343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 g0p0 10M0 ak00 m10 8lb0 uL0",
			"America/Argentina/San_Luis|CMT ART ARST ART ARST WART WARST|4g.M 40 30 30 20 40 30|01212121212121212121212121212121212121212134343456536353465653|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 kin0 10M0 ak00 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0",
			"America/Argentina/Tucuman|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|012121212121212121212121212121212121212121343434345434323534343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 ako0 4N0 8BX0 uL0 1qN0 WL0",
			"America/Argentina/Ushuaia|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343434343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 g0p0 10M0 ajA0 8p0 8zb0 uL0",
			"America/Curacao|LMT ANT AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4",
			"America/Asuncion|AMT PYT PYT PYST|3O.E 40 30 30|012131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
			"America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2",
			"America/Bahia|LMT BRT BRST|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
			"America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3",
			"America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
			"America/Belem|LMT BRT BRST|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
			"America/Belize|LMT CST CHDT CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3",
			"America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2",
			"America/Boa_Vista|LMT AMT AMST|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
			"America/Bogota|BMT COT COST|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5",
			"America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
			"America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
			"America/Campo_Grande|LMT AMT AMST|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|77e4",
			"America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
			"America/Caracas|CMT VET VET|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5",
			"America/Cayenne|LMT GFT GFT|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
			"America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5",
			"America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
			"America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4",
			"America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
			"America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2",
			"America/Cuiaba|LMT AMT AMST|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|54e4",
			"America/Danmarkshavn|LMT WGT WGST GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
			"America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2",
			"America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
			"America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
			"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|01234252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 Jy10 SL0 dnB0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
			"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
			"America/Eirunepe|LMT ACT ACST AMT|4D.s 50 40 40|0121212121212121212121212121212131|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
			"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
			"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
			"America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
			"America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Fortaleza|LMT BRT BRST|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
			"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"America/Godthab|LMT WGT WGST|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3",
			"America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
			"America/Grand_Turk|KMT EST EDT AST|57.b 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212123|-2l1uQ.N 2HHBQ.N 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
			"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
			"America/Guayaquil|QMT ECT|5e 50|01|-1yVSK|27e5",
			"America/Guyana|LMT GBGT GYT GYT GYT|3Q.E 3J 3J 30 40|01234|-2dvU7.k 24JzQ.k mlc0 Bxbf|80e4",
			"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
			"America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
			"America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
			"America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
			"America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
			"America/Jamaica|KMT EST EDT|57.b 50 40|0121212121212121212121|-2l1uQ.N 2uM1Q.N 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
			"America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
			"America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/La_Paz|CMT BOST BOT|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5",
			"America/Lima|LMT PET PEST|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
			"America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
			"America/Maceio|LMT BRT BRST|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
			"America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
			"America/Manaus|LMT AMT AMST|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
			"America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4",
			"America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
			"America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4",
			"America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
			"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5",
			"America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6",
			"America/Miquelon|LMT AST PMST PMDT|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
			"America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
			"America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5",
			"America/Montevideo|MMT UYT UYHST UYST UYT UYHST|3I.I 3u 30 20 30 2u|012121212121212121212121213434343434345454543453434343434343434343434343434343434343434|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
			"America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
			"America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4",
			"America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
			"America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2",
			"America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
			"America/Noronha|LMT FNT FNST|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
			"America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
			"America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Paramaribo|LMT PMT PMT NEGT SRT SRT|3E.E 3E.Q 3E.A 3u 3u 30|012345|-2nDUj.k Wqo0.c qanX.I 1dmLN.o lzc0|24e4",
			"America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
			"America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Rio_Branco|LMT ACT ACST AMT|4v.c 50 40 40|01212121212121212121212121212131|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
			"America/Porto_Velho|LMT AMT AMST|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
			"America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5",
			"America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842",
			"America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
			"America/Recife|LMT BRT BRST|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
			"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
			"America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
			"America/Santarem|LMT AMT AMST BRT|3C.M 40 30 30|0121212121212121212121212121213|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
			"America/Santiago|SMT CLT CLT CLST CLST|4G.K 50 40 40 30|010203131313131212421242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5",
			"America/Santo_Domingo|SDMT EST EDT EHDT AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
			"America/Sao_Paulo|LMT BRT BRST|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|20e6",
			"America/Scoresbysund|LMT CGT CGST EGST EGT|1r.Q 20 10 0 10|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452",
			"America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
			"America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
			"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
			"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
			"America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
			"America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
			"America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
			"America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212|-2q00 1DjS0 T90 40P0 KL0 blz0|10",
			"Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
			"Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80",
			"Antarctica/Macquarie|AEST AEDT -00 MIST|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
			"Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
			"Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5",
			"Antarctica/Palmer|-00 ARST ART ART ARST CLT CLST|0 30 40 30 20 40 30|0121212121234356565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|40",
			"Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
			"Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20",
			"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40",
			"Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25",
			"Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4",
			"Asia/Riyadh|LMT AST|-36.Q -30|01|-TvD6.Q|57e5",
			"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
			"Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5",
			"Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
			"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
			"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
			"Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
			"Asia/Atyrau|LMT +04 +05 +06|-3r.I -40 -50 -60|01232323232323232323212323232323232321212121212|-1Pc3r.I eUnr.I 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0",
			"Asia/Baghdad|BMT AST ADT|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
			"Asia/Qatar|LMT GST AST|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
			"Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
			"Asia/Bangkok|BMT ICT|-6G.4 -70|01|-218SG.4|15e6",
			"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
			"Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5",
			"Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
			"Asia/Brunei|LMT BNT BNT|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4",
			"Asia/Kolkata|HMT BURT IST IST|-5R.k -6u -5u -6u|01232|-18LFR.k 1unn.k HB0 7zX0|15e6",
			"Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
			"Asia/Choibalsan|LMT ULAT ULAT CHOST CHOT CHOT CHOST|-7C -70 -80 -a0 -90 -80 -90|0123434343434343434343434343434343434343434343456565656565656565656565656565656565656565656565|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0|38e3",
			"Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
			"Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
			"Asia/Dhaka|HMT BURT IST DACT BDT BDST|-5R.k -6u -5u -60 -60 -70|01213454|-18LFR.k 1unn.k HB0 m6n0 LqMu 1x6n0 1i00|16e6",
			"Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5",
			"Asia/Dili|LMT TLT JST TLT WITA|-8m.k -80 -90 -90 -80|012343|-2le8m.k 1dnXm.k 8HA0 1ew00 Xld0|19e4",
			"Asia/Dubai|LMT GST|-3F.c -40|01|-21JfF.c|39e5",
			"Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
			"Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0",
			"Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|18e5",
			"Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|25e4",
			"Asia/Ho_Chi_Minh|LMT PLMT ICT IDT JST|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
			"Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
			"Asia/Hovd|LMT HOVT HOVT HOVST|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0|81e3",
			"Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
			"Asia/Jakarta|BMT JAVT WIB JST WIB WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
			"Asia/Jayapura|LMT WIT ACST|-9m.M -90 -9u|0121|-1uu9m.M sMMm.M L4nu|26e4",
			"Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4",
			"Asia/Kabul|AFT AFT|-40 -4u|01|-10Qs0|46e5",
			"Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
			"Asia/Karachi|LMT IST IST KART PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
			"Asia/Urumqi|LMT XJT|-5O.k -60|01|-1GgtO.k|32e5",
			"Asia/Kathmandu|LMT IST NPT|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
			"Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
			"Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
			"Asia/Kuala_Lumpur|SMT MALT MALST MALT MALT JST MYT|-6T.p -70 -7k -7k -7u -90 -80|01234546|-2Bg6T.p 17anT.p 7hXE dM00 17bO 8Fyu 1so1u|71e5",
			"Asia/Kuching|LMT BORT BORT BORTST JST MYT|-7l.k -7u -80 -8k -90 -80|01232323232323232425|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0 1so10|13e4",
			"Asia/Macau|LMT MOT MOST CST|-7y.k -80 -90 -80|0121212121212121212121212121212121212121213|-2le7y.k 1XO34.k 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0 KEp0|57e4",
			"Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
			"Asia/Makassar|LMT MMT WITA JST|-7V.A -7V.A -80 -90|01232|-21JjV.A vfc0 myLV.A 8ML0|15e5",
			"Asia/Manila|PHT PHST JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
			"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4",
			"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
			"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
			"Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
			"Asia/Oral|LMT +04 +05 +06|-3p.o -40 -50 -60|01232323232323232121212121212121212121212121212|-1Pc3p.o eUnp.o 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
			"Asia/Pontianak|LMT PMT WIB JST WIB WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
			"Asia/Pyongyang|LMT KST JCST JST KST|-8n -8u -90 -90 -90|012341|-2um8n 97XR 12FXu jdA0 2Onc0|29e5",
			"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4",
			"Asia/Rangoon|RMT BURT JST MMT|-6o.E -6u -90 -6u|0123|-21Jio.E SmnS.E 7j9u|48e5",
			"Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
			"Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
			"Asia/Seoul|LMT KST JCST JST KST KDT KDT|-8r.Q -8u -90 -90 -90 -9u -a0|01234151515151515146464|-2um8r.Q 97XV.Q 12FXu jjA0 kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
			"Asia/Singapore|SMT MALT MALST MALT MALT JST SGT SGT|-6T.p -70 -7k -7k -7u -90 -7u -80|012345467|-2Bg6T.p 17anT.p 7hXE dM00 17bO 8Fyu Mspu DTA0|56e5",
			"Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
			"Asia/Taipei|JWST JST CST CDT|-80 -90 -80 -90|01232323232323232323232323232323232323232|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
			"Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
			"Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
			"Asia/Tehran|LMT TMT IRST IRST IRDT IRDT|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6",
			"Asia/Thimphu|LMT IST BTT|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
			"Asia/Tokyo|JCST JST JDT|-90 -90 -a0|0121212121|-1iw90 pKq0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0|38e6",
			"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
			"Asia/Ulaanbaatar|LMT ULAT ULAT ULAST|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0|12e5",
			"Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
			"Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
			"Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
			"Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
			"Atlantic/Azores|HMT AZOT AZOST AZOMT AZOT AZOST WET|1S.w 20 10 0 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545456545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4",
			"Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
			"Atlantic/Canary|LMT CANT WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Atlantic/Cape_Verde|LMT CVT CVST CVT|1y.4 20 10 10|01213|-2xomp.U 1qOMp.U 7zX0 1djf0|50e4",
			"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3",
			"Atlantic/Madeira|FMT MADT MADST MADMT WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldWQ.o aPWQ.o Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4",
			"Atlantic/Reykjavik|LMT IST ISST GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4",
			"Atlantic/South_Georgia|GST|20|0||30",
			"Atlantic/Stanley|SMT FKT FKST FKT FKST|3P.o 40 30 30 20|0121212121212134343212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 U10 1qM0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
			"Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5",
			"Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5",
			"Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
			"Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3",
			"Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746",
			"Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4",
			"Australia/Eucla|ACWST ACWDT|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
			"Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4",
			"Australia/Lord_Howe|AEST LHST LHDT LHDT|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347",
			"Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
			"Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5",
			"Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
			"CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Pacific/Easter|EMT EAST EASST EAST EASST|7h.s 70 60 60 50|0121212121212121212121212121234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2",
			"EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"EST|EST|50|0|",
			"EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g5X0 14p0 1wn0 17d0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Etc/GMT+0|GMT|0|0|",
			"Etc/GMT+1|-01|10|0|",
			"Etc/GMT+10|-10|a0|0|",
			"Etc/GMT+11|-11|b0|0|",
			"Etc/GMT+12|-12|c0|0|",
			"Etc/GMT+2|-02|20|0|",
			"Etc/GMT+3|-03|30|0|",
			"Etc/GMT+4|-04|40|0|",
			"Etc/GMT+5|-05|50|0|",
			"Etc/GMT+6|-06|60|0|",
			"Etc/GMT+7|-07|70|0|",
			"Etc/GMT+8|-08|80|0|",
			"Etc/GMT+9|-09|90|0|",
			"Etc/GMT-1|+01|-10|0|",
			"Etc/GMT-10|+10|-a0|0|",
			"Etc/GMT-11|+11|-b0|0|",
			"Etc/GMT-12|+12|-c0|0|",
			"Etc/GMT-13|+13|-d0|0|",
			"Etc/GMT-14|+14|-e0|0|",
			"Etc/GMT-2|+02|-20|0|",
			"Etc/GMT-3|+03|-30|0|",
			"Etc/GMT-4|+04|-40|0|",
			"Etc/GMT-5|+05|-50|0|",
			"Etc/GMT-6|+06|-60|0|",
			"Etc/GMT-7|+07|-70|0|",
			"Etc/GMT-8|+08|-80|0|",
			"Etc/GMT-9|+09|-90|0|",
			"Etc/UCT|UCT|0|0|",
			"Etc/UTC|UTC|0|0|",
			"Europe/Amsterdam|AMT NST NEST NET CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5",
			"Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3",
			"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
			"Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5",
			"Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6",
			"Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5",
			"Europe/Prague|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 16M0 1lc0 1tA0 17A0 11c0 1io0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5",
			"Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5",
			"Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5",
			"Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
			"Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4",
			"Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4",
			"Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3",
			"Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
			"Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5",
			"Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
			"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ldXn.f aPWn.f Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5",
			"Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|01010101010101010101010121212121234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-28dd0 11A0 1go0 19A0 1co0 1dA0 b1A0 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 iyo0 Rc0 18o0 1hc0 1io0 1a00 14o0 5aL0 MM0 1vc0 17A0 1i00 1bc0 1eo0 17d0 1in0 17A0 6hA0 10N0 XIL0 1a10 1in0 17d0 19X0 1cN0 1fz0 1a10 1fX0 1cp0 1cO0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5",
			"Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
			"Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
			"Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3",
			"Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
			"Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6",
			"Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4",
			"Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5",
			"Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
			"Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810",
			"Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
			"Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5",
			"Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4",
			"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
			"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
			"Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4",
			"Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5",
			"Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
			"Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
			"Europe/Zaporozhye|CUT EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4",
			"HST|HST|a0|0|",
			"Indian/Chagos|LMT IOT IOT|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
			"Indian/Christmas|CXT|-70|0||21e2",
			"Indian/Cocos|CCT|-6u|0||596",
			"Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130",
			"Indian/Mahe|LMT SCT|-3F.M -40|01|-2yO3F.M|79e3",
			"Indian/Maldives|MMT MVT|-4S -50|01|-olgS|35e4",
			"Indian/Mauritius|LMT MUT MUST|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
			"Indian/Reunion|LMT RET|-3F.Q -40|01|-2mDDF.Q|84e4",
			"Pacific/Kwajalein|MHT KWAT MHT|-b0 c0 -c0|012|-AX0 W9X0|14e3",
			"MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"MST|MST|70|0|",
			"MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Pacific/Chatham|CHAST CHAST CHADT|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600",
			"PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Pacific/Apia|LMT WSST SST SDT WSDT WSST|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3",
			"Pacific/Bougainville|PGT JST BST|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4",
			"Pacific/Chuuk|CHUT|-a0|0||49e3",
			"Pacific/Efate|LMT VUT VUST|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
			"Pacific/Enderbury|PHOT PHOT PHOT|c0 b0 -d0|012|nIc0 B8n0|1",
			"Pacific/Fakaofo|TKT TKT|b0 -d0|01|1Gfn0|483",
			"Pacific/Fiji|LMT FJT FJST|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|88e4",
			"Pacific/Funafuti|TVT|-c0|0||45e2",
			"Pacific/Galapagos|LMT ECT GALT|5W.o 50 60|012|-1yVS1.A 2dTz1.A|25e3",
			"Pacific/Gambier|LMT GAMT|8X.M 90|01|-2jof0.c|125",
			"Pacific/Guadalcanal|LMT SBT|-aD.M -b0|01|-2joyD.M|11e4",
			"Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4",
			"Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4",
			"Pacific/Kiritimati|LINT LINT LINT|aE a0 -e0|012|nIaE B8nk|51e2",
			"Pacific/Kosrae|KOST KOST|-b0 -c0|010|-AX0 1bdz0|66e2",
			"Pacific/Majuro|MHT MHT|-b0 -c0|01|-AX0|28e3",
			"Pacific/Marquesas|LMT MART|9i 9u|01|-2joeG|86e2",
			"Pacific/Pago_Pago|LMT NST BST SST|bm.M b0 b0 b0|0123|-2nDMB.c 2gVzB.c EyM0|37e2",
			"Pacific/Nauru|LMT NRT JST NRT|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3",
			"Pacific/Niue|NUT NUT NUT|bk bu b0|012|-KfME 17y0a|12e2",
			"Pacific/Norfolk|NMT NFT NFST NFT|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4",
			"Pacific/Noumea|LMT NCT NCST|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
			"Pacific/Palau|PWT|-90|0||21e3",
			"Pacific/Pitcairn|PNT PST|8u 80|01|18Vku|56",
			"Pacific/Pohnpei|PONT|-b0|0||34e3",
			"Pacific/Port_Moresby|PGT|-a0|0||25e4",
			"Pacific/Rarotonga|CKT CKHST CKT|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
			"Pacific/Tahiti|LMT TAHT|9W.g a0|01|-2joe1.I|18e4",
			"Pacific/Tarawa|GILT|-c0|0||29e3",
			"Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121212121212121212121212121212121212121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|75e3",
			"Pacific/Wake|WAKT|-c0|0||16e3",
			"Pacific/Wallis|WFT|-c0|0||94",
			"WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"
		],
		"links": [
			"Africa/Abidjan|Africa/Bamako",
			"Africa/Abidjan|Africa/Banjul",
			"Africa/Abidjan|Africa/Conakry",
			"Africa/Abidjan|Africa/Dakar",
			"Africa/Abidjan|Africa/Freetown",
			"Africa/Abidjan|Africa/Lome",
			"Africa/Abidjan|Africa/Nouakchott",
			"Africa/Abidjan|Africa/Ouagadougou",
			"Africa/Abidjan|Africa/Sao_Tome",
			"Africa/Abidjan|Africa/Timbuktu",
			"Africa/Abidjan|Atlantic/St_Helena",
			"Africa/Cairo|Egypt",
			"Africa/Johannesburg|Africa/Maseru",
			"Africa/Johannesburg|Africa/Mbabane",
			"Africa/Khartoum|Africa/Juba",
			"Africa/Lagos|Africa/Bangui",
			"Africa/Lagos|Africa/Brazzaville",
			"Africa/Lagos|Africa/Douala",
			"Africa/Lagos|Africa/Kinshasa",
			"Africa/Lagos|Africa/Libreville",
			"Africa/Lagos|Africa/Luanda",
			"Africa/Lagos|Africa/Malabo",
			"Africa/Lagos|Africa/Niamey",
			"Africa/Lagos|Africa/Porto-Novo",
			"Africa/Maputo|Africa/Blantyre",
			"Africa/Maputo|Africa/Bujumbura",
			"Africa/Maputo|Africa/Gaborone",
			"Africa/Maputo|Africa/Harare",
			"Africa/Maputo|Africa/Kigali",
			"Africa/Maputo|Africa/Lubumbashi",
			"Africa/Maputo|Africa/Lusaka",
			"Africa/Nairobi|Africa/Addis_Ababa",
			"Africa/Nairobi|Africa/Asmara",
			"Africa/Nairobi|Africa/Asmera",
			"Africa/Nairobi|Africa/Dar_es_Salaam",
			"Africa/Nairobi|Africa/Djibouti",
			"Africa/Nairobi|Africa/Kampala",
			"Africa/Nairobi|Africa/Mogadishu",
			"Africa/Nairobi|Indian/Antananarivo",
			"Africa/Nairobi|Indian/Comoro",
			"Africa/Nairobi|Indian/Mayotte",
			"Africa/Tripoli|Libya",
			"America/Adak|America/Atka",
			"America/Adak|US/Aleutian",
			"America/Anchorage|US/Alaska",
			"America/Argentina/Buenos_Aires|America/Buenos_Aires",
			"America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
			"America/Argentina/Catamarca|America/Catamarca",
			"America/Argentina/Cordoba|America/Cordoba",
			"America/Argentina/Cordoba|America/Rosario",
			"America/Argentina/Jujuy|America/Jujuy",
			"America/Argentina/Mendoza|America/Mendoza",
			"America/Atikokan|America/Coral_Harbour",
			"America/Chicago|US/Central",
			"America/Curacao|America/Aruba",
			"America/Curacao|America/Kralendijk",
			"America/Curacao|America/Lower_Princes",
			"America/Denver|America/Shiprock",
			"America/Denver|Navajo",
			"America/Denver|US/Mountain",
			"America/Detroit|US/Michigan",
			"America/Edmonton|Canada/Mountain",
			"America/Fort_Wayne|America/Indiana/Indianapolis",
			"America/Fort_Wayne|America/Indianapolis",
			"America/Fort_Wayne|US/East-Indiana",
			"America/Halifax|Canada/Atlantic",
			"America/Havana|Cuba",
			"America/Indiana/Knox|America/Knox_IN",
			"America/Indiana/Knox|US/Indiana-Starke",
			"America/Jamaica|Jamaica",
			"America/Kentucky/Louisville|America/Louisville",
			"America/Los_Angeles|US/Pacific",
			"America/Los_Angeles|US/Pacific-New",
			"America/Manaus|Brazil/West",
			"America/Mazatlan|Mexico/BajaSur",
			"America/Mexico_City|Mexico/General",
			"America/New_York|US/Eastern",
			"America/Noronha|Brazil/DeNoronha",
			"America/Panama|America/Cayman",
			"America/Phoenix|US/Arizona",
			"America/Port_of_Spain|America/Anguilla",
			"America/Port_of_Spain|America/Antigua",
			"America/Port_of_Spain|America/Dominica",
			"America/Port_of_Spain|America/Grenada",
			"America/Port_of_Spain|America/Guadeloupe",
			"America/Port_of_Spain|America/Marigot",
			"America/Port_of_Spain|America/Montserrat",
			"America/Port_of_Spain|America/St_Barthelemy",
			"America/Port_of_Spain|America/St_Kitts",
			"America/Port_of_Spain|America/St_Lucia",
			"America/Port_of_Spain|America/St_Thomas",
			"America/Port_of_Spain|America/St_Vincent",
			"America/Port_of_Spain|America/Tortola",
			"America/Port_of_Spain|America/Virgin",
			"America/Regina|Canada/East-Saskatchewan",
			"America/Regina|Canada/Saskatchewan",
			"America/Rio_Branco|America/Porto_Acre",
			"America/Rio_Branco|Brazil/Acre",
			"America/Santiago|Chile/Continental",
			"America/Sao_Paulo|Brazil/East",
			"America/St_Johns|Canada/Newfoundland",
			"America/Tijuana|America/Ensenada",
			"America/Tijuana|America/Santa_Isabel",
			"America/Tijuana|Mexico/BajaNorte",
			"America/Toronto|America/Montreal",
			"America/Toronto|Canada/Eastern",
			"America/Vancouver|Canada/Pacific",
			"America/Whitehorse|Canada/Yukon",
			"America/Winnipeg|Canada/Central",
			"Asia/Ashgabat|Asia/Ashkhabad",
			"Asia/Bangkok|Asia/Phnom_Penh",
			"Asia/Bangkok|Asia/Vientiane",
			"Asia/Dhaka|Asia/Dacca",
			"Asia/Dubai|Asia/Muscat",
			"Asia/Ho_Chi_Minh|Asia/Saigon",
			"Asia/Hong_Kong|Hongkong",
			"Asia/Jerusalem|Asia/Tel_Aviv",
			"Asia/Jerusalem|Israel",
			"Asia/Kathmandu|Asia/Katmandu",
			"Asia/Kolkata|Asia/Calcutta",
			"Asia/Macau|Asia/Macao",
			"Asia/Makassar|Asia/Ujung_Pandang",
			"Asia/Nicosia|Europe/Nicosia",
			"Asia/Qatar|Asia/Bahrain",
			"Asia/Rangoon|Asia/Yangon",
			"Asia/Riyadh|Asia/Aden",
			"Asia/Riyadh|Asia/Kuwait",
			"Asia/Seoul|ROK",
			"Asia/Shanghai|Asia/Chongqing",
			"Asia/Shanghai|Asia/Chungking",
			"Asia/Shanghai|Asia/Harbin",
			"Asia/Shanghai|PRC",
			"Asia/Singapore|Singapore",
			"Asia/Taipei|ROC",
			"Asia/Tehran|Iran",
			"Asia/Thimphu|Asia/Thimbu",
			"Asia/Tokyo|Japan",
			"Asia/Ulaanbaatar|Asia/Ulan_Bator",
			"Asia/Urumqi|Asia/Kashgar",
			"Atlantic/Faroe|Atlantic/Faeroe",
			"Atlantic/Reykjavik|Iceland",
			"Australia/Adelaide|Australia/South",
			"Australia/Brisbane|Australia/Queensland",
			"Australia/Broken_Hill|Australia/Yancowinna",
			"Australia/Darwin|Australia/North",
			"Australia/Hobart|Australia/Tasmania",
			"Australia/Lord_Howe|Australia/LHI",
			"Australia/Melbourne|Australia/Victoria",
			"Australia/Perth|Australia/West",
			"Australia/Sydney|Australia/ACT",
			"Australia/Sydney|Australia/Canberra",
			"Australia/Sydney|Australia/NSW",
			"Etc/GMT+0|Etc/GMT",
			"Etc/GMT+0|Etc/GMT-0",
			"Etc/GMT+0|Etc/GMT0",
			"Etc/GMT+0|Etc/Greenwich",
			"Etc/GMT+0|GMT",
			"Etc/GMT+0|GMT+0",
			"Etc/GMT+0|GMT-0",
			"Etc/GMT+0|GMT0",
			"Etc/GMT+0|Greenwich",
			"Etc/UCT|UCT",
			"Etc/UTC|Etc/Universal",
			"Etc/UTC|Etc/Zulu",
			"Etc/UTC|UTC",
			"Etc/UTC|Universal",
			"Etc/UTC|Zulu",
			"Europe/Belgrade|Europe/Ljubljana",
			"Europe/Belgrade|Europe/Podgorica",
			"Europe/Belgrade|Europe/Sarajevo",
			"Europe/Belgrade|Europe/Skopje",
			"Europe/Belgrade|Europe/Zagreb",
			"Europe/Chisinau|Europe/Tiraspol",
			"Europe/Dublin|Eire",
			"Europe/Helsinki|Europe/Mariehamn",
			"Europe/Istanbul|Asia/Istanbul",
			"Europe/Istanbul|Turkey",
			"Europe/Lisbon|Portugal",
			"Europe/London|Europe/Belfast",
			"Europe/London|Europe/Guernsey",
			"Europe/London|Europe/Isle_of_Man",
			"Europe/London|Europe/Jersey",
			"Europe/London|GB",
			"Europe/London|GB-Eire",
			"Europe/Moscow|W-SU",
			"Europe/Oslo|Arctic/Longyearbyen",
			"Europe/Oslo|Atlantic/Jan_Mayen",
			"Europe/Prague|Europe/Bratislava",
			"Europe/Rome|Europe/San_Marino",
			"Europe/Rome|Europe/Vatican",
			"Europe/Warsaw|Poland",
			"Europe/Zurich|Europe/Busingen",
			"Europe/Zurich|Europe/Vaduz",
			"Pacific/Auckland|Antarctica/McMurdo",
			"Pacific/Auckland|Antarctica/South_Pole",
			"Pacific/Auckland|NZ",
			"Pacific/Chatham|NZ-CHAT",
			"Pacific/Chuuk|Pacific/Truk",
			"Pacific/Chuuk|Pacific/Yap",
			"Pacific/Easter|Chile/EasterIsland",
			"Pacific/Guam|Pacific/Saipan",
			"Pacific/Honolulu|Pacific/Johnston",
			"Pacific/Honolulu|US/Hawaii",
			"Pacific/Kwajalein|Kwajalein",
			"Pacific/Pago_Pago|Pacific/Midway",
			"Pacific/Pago_Pago|Pacific/Samoa",
			"Pacific/Pago_Pago|US/Samoa",
			"Pacific/Pohnpei|Pacific/Ponape"
		]
	};

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
	//! version : 0.5.10
	//! Copyright (c) JS Foundation and other contributors
	//! license : MIT
	//! github.com/moment/moment-timezone
	
	(function (root, factory) {
		"use strict";
	
		/*global define*/
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
		} else if (typeof module === 'object' && module.exports) {
			module.exports = factory(require('moment')); // Node
		} else {
			factory(root.moment);                        // Browser
		}
	}(this, function (moment) {
		"use strict";
	
		// Do not load moment-timezone a second time.
		if (moment.tz !== undefined) {
			logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
			return moment;
		}
	
		var VERSION = "0.5.10",
			zones = {},
			links = {},
			names = {},
			guesses = {},
			cachedGuess,
	
			momentVersion = moment.version.split('.'),
			major = +momentVersion[0],
			minor = +momentVersion[1];
	
		// Moment.js version check
		if (major < 2 || (major === 2 && minor < 6)) {
			logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
		}
	
		/************************************
			Unpacking
		************************************/
	
		function charCodeToInt(charCode) {
			if (charCode > 96) {
				return charCode - 87;
			} else if (charCode > 64) {
				return charCode - 29;
			}
			return charCode - 48;
		}
	
		function unpackBase60(string) {
			var i = 0,
				parts = string.split('.'),
				whole = parts[0],
				fractional = parts[1] || '',
				multiplier = 1,
				num,
				out = 0,
				sign = 1;
	
			// handle negative numbers
			if (string.charCodeAt(0) === 45) {
				i = 1;
				sign = -1;
			}
	
			// handle digits before the decimal
			for (i; i < whole.length; i++) {
				num = charCodeToInt(whole.charCodeAt(i));
				out = 60 * out + num;
			}
	
			// handle digits after the decimal
			for (i = 0; i < fractional.length; i++) {
				multiplier = multiplier / 60;
				num = charCodeToInt(fractional.charCodeAt(i));
				out += num * multiplier;
			}
	
			return out * sign;
		}
	
		function arrayToInt (array) {
			for (var i = 0; i < array.length; i++) {
				array[i] = unpackBase60(array[i]);
			}
		}
	
		function intToUntil (array, length) {
			for (var i = 0; i < length; i++) {
				array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
			}
	
			array[length - 1] = Infinity;
		}
	
		function mapIndices (source, indices) {
			var out = [], i;
	
			for (i = 0; i < indices.length; i++) {
				out[i] = source[indices[i]];
			}
	
			return out;
		}
	
		function unpack (string) {
			var data = string.split('|'),
				offsets = data[2].split(' '),
				indices = data[3].split(''),
				untils  = data[4].split(' ');
	
			arrayToInt(offsets);
			arrayToInt(indices);
			arrayToInt(untils);
	
			intToUntil(untils, indices.length);
	
			return {
				name       : data[0],
				abbrs      : mapIndices(data[1].split(' '), indices),
				offsets    : mapIndices(offsets, indices),
				untils     : untils,
				population : data[5] | 0
			};
		}
	
		/************************************
			Zone object
		************************************/
	
		function Zone (packedString) {
			if (packedString) {
				this._set(unpack(packedString));
			}
		}
	
		Zone.prototype = {
			_set : function (unpacked) {
				this.name       = unpacked.name;
				this.abbrs      = unpacked.abbrs;
				this.untils     = unpacked.untils;
				this.offsets    = unpacked.offsets;
				this.population = unpacked.population;
			},
	
			_index : function (timestamp) {
				var target = +timestamp,
					untils = this.untils,
					i;
	
				for (i = 0; i < untils.length; i++) {
					if (target < untils[i]) {
						return i;
					}
				}
			},
	
			parse : function (timestamp) {
				var target  = +timestamp,
					offsets = this.offsets,
					untils  = this.untils,
					max     = untils.length - 1,
					offset, offsetNext, offsetPrev, i;
	
				for (i = 0; i < max; i++) {
					offset     = offsets[i];
					offsetNext = offsets[i + 1];
					offsetPrev = offsets[i ? i - 1 : i];
	
					if (offset < offsetNext && tz.moveAmbiguousForward) {
						offset = offsetNext;
					} else if (offset > offsetPrev && tz.moveInvalidForward) {
						offset = offsetPrev;
					}
	
					if (target < untils[i] - (offset * 60000)) {
						return offsets[i];
					}
				}
	
				return offsets[max];
			},
	
			abbr : function (mom) {
				return this.abbrs[this._index(mom)];
			},
	
			offset : function (mom) {
				return this.offsets[this._index(mom)];
			}
		};
	
		/************************************
			Current Timezone
		************************************/
	
		function OffsetAt(at) {
			var timeString = at.toTimeString();
			var abbr = timeString.match(/\([a-z ]+\)/i);
			if (abbr && abbr[0]) {
				// 17:56:31 GMT-0600 (CST)
				// 17:56:31 GMT-0600 (Central Standard Time)
				abbr = abbr[0].match(/[A-Z]/g);
				abbr = abbr ? abbr.join('') : undefined;
			} else {
				// 17:56:31 CST
				// 17:56:31 GMT+0800 (台北標準時間)
				abbr = timeString.match(/[A-Z]{3,5}/g);
				abbr = abbr ? abbr[0] : undefined;
			}
	
			if (abbr === 'GMT') {
				abbr = undefined;
			}
	
			this.at = +at;
			this.abbr = abbr;
			this.offset = at.getTimezoneOffset();
		}
	
		function ZoneScore(zone) {
			this.zone = zone;
			this.offsetScore = 0;
			this.abbrScore = 0;
		}
	
		ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
			this.offsetScore += Math.abs(this.zone.offset(offsetAt.at) - offsetAt.offset);
			if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
				this.abbrScore++;
			}
		};
	
		function findChange(low, high) {
			var mid, diff;
	
			while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
				mid = new OffsetAt(new Date(low.at + diff));
				if (mid.offset === low.offset) {
					low = mid;
				} else {
					high = mid;
				}
			}
	
			return low;
		}
	
		function userOffsets() {
			var startYear = new Date().getFullYear() - 2,
				last = new OffsetAt(new Date(startYear, 0, 1)),
				offsets = [last],
				change, next, i;
	
			for (i = 1; i < 48; i++) {
				next = new OffsetAt(new Date(startYear, i, 1));
				if (next.offset !== last.offset) {
					change = findChange(last, next);
					offsets.push(change);
					offsets.push(new OffsetAt(new Date(change.at + 6e4)));
				}
				last = next;
			}
	
			for (i = 0; i < 4; i++) {
				offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
				offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
			}
	
			return offsets;
		}
	
		function sortZoneScores (a, b) {
			if (a.offsetScore !== b.offsetScore) {
				return a.offsetScore - b.offsetScore;
			}
			if (a.abbrScore !== b.abbrScore) {
				return a.abbrScore - b.abbrScore;
			}
			return b.zone.population - a.zone.population;
		}
	
		function addToGuesses (name, offsets) {
			var i, offset;
			arrayToInt(offsets);
			for (i = 0; i < offsets.length; i++) {
				offset = offsets[i];
				guesses[offset] = guesses[offset] || {};
				guesses[offset][name] = true;
			}
		}
	
		function guessesForUserOffsets (offsets) {
			var offsetsLength = offsets.length,
				filteredGuesses = {},
				out = [],
				i, j, guessesOffset;
	
			for (i = 0; i < offsetsLength; i++) {
				guessesOffset = guesses[offsets[i].offset] || {};
				for (j in guessesOffset) {
					if (guessesOffset.hasOwnProperty(j)) {
						filteredGuesses[j] = true;
					}
				}
			}
	
			for (i in filteredGuesses) {
				if (filteredGuesses.hasOwnProperty(i)) {
					out.push(names[i]);
				}
			}
	
			return out;
		}
	
		function rebuildGuess () {
	
			// use Intl API when available and returning valid time zone
			try {
				var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
				if (intlName){
					var name = names[normalizeName(intlName)];
					if (name) {
						return name;
					}
					logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
				}
			} catch (e) {
				// Intl unavailable, fall back to manual guessing.
			}
	
			var offsets = userOffsets(),
				offsetsLength = offsets.length,
				guesses = guessesForUserOffsets(offsets),
				zoneScores = [],
				zoneScore, i, j;
	
			for (i = 0; i < guesses.length; i++) {
				zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
				for (j = 0; j < offsetsLength; j++) {
					zoneScore.scoreOffsetAt(offsets[j]);
				}
				zoneScores.push(zoneScore);
			}
	
			zoneScores.sort(sortZoneScores);
	
			return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
		}
	
		function guess (ignoreCache) {
			if (!cachedGuess || ignoreCache) {
				cachedGuess = rebuildGuess();
			}
			return cachedGuess;
		}
	
		/************************************
			Global Methods
		************************************/
	
		function normalizeName (name) {
			return (name || '').toLowerCase().replace(/\//g, '_');
		}
	
		function addZone (packed) {
			var i, name, split, normalized;
	
			if (typeof packed === "string") {
				packed = [packed];
			}
	
			for (i = 0; i < packed.length; i++) {
				split = packed[i].split('|');
				name = split[0];
				normalized = normalizeName(name);
				zones[normalized] = packed[i];
				names[normalized] = name;
				if (split[5]) {
					addToGuesses(normalized, split[2].split(' '));
				}
			}
		}
	
		function getZone (name, caller) {
			name = normalizeName(name);
	
			var zone = zones[name];
			var link;
	
			if (zone instanceof Zone) {
				return zone;
			}
	
			if (typeof zone === 'string') {
				zone = new Zone(zone);
				zones[name] = zone;
				return zone;
			}
	
			// Pass getZone to prevent recursion more than 1 level deep
			if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
				zone = zones[name] = new Zone();
				zone._set(link);
				zone.name = names[name];
				return zone;
			}
	
			return null;
		}
	
		function getNames () {
			var i, out = [];
	
			for (i in names) {
				if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
					out.push(names[i]);
				}
			}
	
			return out.sort();
		}
	
		function addLink (aliases) {
			var i, alias, normal0, normal1;
	
			if (typeof aliases === "string") {
				aliases = [aliases];
			}
	
			for (i = 0; i < aliases.length; i++) {
				alias = aliases[i].split('|');
	
				normal0 = normalizeName(alias[0]);
				normal1 = normalizeName(alias[1]);
	
				links[normal0] = normal1;
				names[normal0] = alias[0];
	
				links[normal1] = normal0;
				names[normal1] = alias[1];
			}
		}
	
		function loadData (data) {
			addZone(data.zones);
			addLink(data.links);
			tz.dataVersion = data.version;
		}
	
		function zoneExists (name) {
			if (!zoneExists.didShowError) {
				zoneExists.didShowError = true;
					logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
			}
			return !!getZone(name);
		}
	
		function needsOffset (m) {
			return !!(m._a && (m._tzm === undefined));
		}
	
		function logError (message) {
			if (typeof console !== 'undefined' && typeof console.error === 'function') {
				console.error(message);
			}
		}
	
		/************************************
			moment.tz namespace
		************************************/
	
		function tz (input) {
			var args = Array.prototype.slice.call(arguments, 0, -1),
				name = arguments[arguments.length - 1],
				zone = getZone(name),
				out  = moment.utc.apply(null, args);
	
			if (zone && !moment.isMoment(input) && needsOffset(out)) {
				out.add(zone.parse(out), 'minutes');
			}
	
			out.tz(name);
	
			return out;
		}
	
		tz.version      = VERSION;
		tz.dataVersion  = '';
		tz._zones       = zones;
		tz._links       = links;
		tz._names       = names;
		tz.add          = addZone;
		tz.link         = addLink;
		tz.load         = loadData;
		tz.zone         = getZone;
		tz.zoneExists   = zoneExists; // deprecated in 0.1.0
		tz.guess        = guess;
		tz.names        = getNames;
		tz.Zone         = Zone;
		tz.unpack       = unpack;
		tz.unpackBase60 = unpackBase60;
		tz.needsOffset  = needsOffset;
		tz.moveInvalidForward   = true;
		tz.moveAmbiguousForward = false;
	
		/************************************
			Interface with Moment.js
		************************************/
	
		var fn = moment.fn;
	
		moment.tz = tz;
	
		moment.defaultZone = null;
	
		moment.updateOffset = function (mom, keepTime) {
			var zone = moment.defaultZone,
				offset;
	
			if (mom._z === undefined) {
				if (zone && needsOffset(mom) && !mom._isUTC) {
					mom._d = moment.utc(mom._a)._d;
					mom.utc().add(zone.parse(mom), 'minutes');
				}
				mom._z = zone;
			}
			if (mom._z) {
				offset = mom._z.offset(mom);
				if (Math.abs(offset) < 16) {
					offset = offset / 60;
				}
				if (mom.utcOffset !== undefined) {
					mom.utcOffset(-offset, keepTime);
				} else {
					mom.zone(offset, keepTime);
				}
			}
		};
	
		fn.tz = function (name) {
			if (name) {
				this._z = getZone(name);
				if (this._z) {
					moment.updateOffset(this);
				} else {
					logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
				}
				return this;
			}
			if (this._z) { return this._z.name; }
		};
	
		function abbrWrap (old) {
			return function () {
				if (this._z) { return this._z.abbr(this); }
				return old.call(this);
			};
		}
	
		function resetZoneWrap (old) {
			return function () {
				this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		fn.zoneName = abbrWrap(fn.zoneName);
		fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
		fn.utc      = resetZoneWrap(fn.utc);
	
		moment.tz.setDefault = function(name) {
			if (major < 2 || (major === 2 && minor < 9)) {
				logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
			}
			moment.defaultZone = name ? getZone(name) : null;
			return moment;
		};
	
		// Cloning a moment should include the _z property.
		var momentProperties = moment.momentProperties;
		if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
			// moment 2.8.1+
			momentProperties.push('_z');
			momentProperties.push('_a');
		} else if (momentProperties) {
			// moment 2.7.0
			momentProperties._z = null;
		}
	
		// INJECT DATA
	
		return moment;
	}));


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 173,
		"./af.js": 173,
		"./ar": 179,
		"./ar-dz": 174,
		"./ar-dz.js": 174,
		"./ar-ly": 175,
		"./ar-ly.js": 175,
		"./ar-ma": 176,
		"./ar-ma.js": 176,
		"./ar-sa": 177,
		"./ar-sa.js": 177,
		"./ar-tn": 178,
		"./ar-tn.js": 178,
		"./ar.js": 179,
		"./az": 180,
		"./az.js": 180,
		"./be": 181,
		"./be.js": 181,
		"./bg": 182,
		"./bg.js": 182,
		"./bn": 183,
		"./bn.js": 183,
		"./bo": 184,
		"./bo.js": 184,
		"./br": 185,
		"./br.js": 185,
		"./bs": 186,
		"./bs.js": 186,
		"./ca": 187,
		"./ca.js": 187,
		"./cs": 188,
		"./cs.js": 188,
		"./cv": 189,
		"./cv.js": 189,
		"./cy": 190,
		"./cy.js": 190,
		"./da": 191,
		"./da.js": 191,
		"./de": 193,
		"./de-at": 192,
		"./de-at.js": 192,
		"./de.js": 193,
		"./dv": 194,
		"./dv.js": 194,
		"./el": 195,
		"./el.js": 195,
		"./en-au": 196,
		"./en-au.js": 196,
		"./en-ca": 197,
		"./en-ca.js": 197,
		"./en-gb": 198,
		"./en-gb.js": 198,
		"./en-ie": 199,
		"./en-ie.js": 199,
		"./en-nz": 200,
		"./en-nz.js": 200,
		"./eo": 201,
		"./eo.js": 201,
		"./es": 203,
		"./es-do": 202,
		"./es-do.js": 202,
		"./es.js": 203,
		"./et": 204,
		"./et.js": 204,
		"./eu": 205,
		"./eu.js": 205,
		"./fa": 206,
		"./fa.js": 206,
		"./fi": 207,
		"./fi.js": 207,
		"./fo": 208,
		"./fo.js": 208,
		"./fr": 211,
		"./fr-ca": 209,
		"./fr-ca.js": 209,
		"./fr-ch": 210,
		"./fr-ch.js": 210,
		"./fr.js": 211,
		"./fy": 212,
		"./fy.js": 212,
		"./gd": 213,
		"./gd.js": 213,
		"./gl": 214,
		"./gl.js": 214,
		"./he": 215,
		"./he.js": 215,
		"./hi": 216,
		"./hi.js": 216,
		"./hr": 217,
		"./hr.js": 217,
		"./hu": 218,
		"./hu.js": 218,
		"./hy-am": 219,
		"./hy-am.js": 219,
		"./id": 220,
		"./id.js": 220,
		"./is": 221,
		"./is.js": 221,
		"./it": 222,
		"./it.js": 222,
		"./ja": 223,
		"./ja.js": 223,
		"./jv": 224,
		"./jv.js": 224,
		"./ka": 225,
		"./ka.js": 225,
		"./kk": 226,
		"./kk.js": 226,
		"./km": 227,
		"./km.js": 227,
		"./ko": 228,
		"./ko.js": 228,
		"./ky": 229,
		"./ky.js": 229,
		"./lb": 230,
		"./lb.js": 230,
		"./lo": 231,
		"./lo.js": 231,
		"./lt": 232,
		"./lt.js": 232,
		"./lv": 233,
		"./lv.js": 233,
		"./me": 234,
		"./me.js": 234,
		"./mi": 235,
		"./mi.js": 235,
		"./mk": 236,
		"./mk.js": 236,
		"./ml": 237,
		"./ml.js": 237,
		"./mr": 238,
		"./mr.js": 238,
		"./ms": 240,
		"./ms-my": 239,
		"./ms-my.js": 239,
		"./ms.js": 240,
		"./my": 241,
		"./my.js": 241,
		"./nb": 242,
		"./nb.js": 242,
		"./ne": 243,
		"./ne.js": 243,
		"./nl": 245,
		"./nl-be": 244,
		"./nl-be.js": 244,
		"./nl.js": 245,
		"./nn": 246,
		"./nn.js": 246,
		"./pa-in": 247,
		"./pa-in.js": 247,
		"./pl": 248,
		"./pl.js": 248,
		"./pt": 250,
		"./pt-br": 249,
		"./pt-br.js": 249,
		"./pt.js": 250,
		"./ro": 251,
		"./ro.js": 251,
		"./ru": 112,
		"./ru.js": 112,
		"./se": 252,
		"./se.js": 252,
		"./si": 253,
		"./si.js": 253,
		"./sk": 254,
		"./sk.js": 254,
		"./sl": 255,
		"./sl.js": 255,
		"./sq": 256,
		"./sq.js": 256,
		"./sr": 258,
		"./sr-cyrl": 257,
		"./sr-cyrl.js": 257,
		"./sr.js": 258,
		"./ss": 259,
		"./ss.js": 259,
		"./sv": 260,
		"./sv.js": 260,
		"./sw": 261,
		"./sw.js": 261,
		"./ta": 262,
		"./ta.js": 262,
		"./te": 263,
		"./te.js": 263,
		"./tet": 264,
		"./tet.js": 264,
		"./th": 265,
		"./th.js": 265,
		"./tl-ph": 266,
		"./tl-ph.js": 266,
		"./tlh": 267,
		"./tlh.js": 267,
		"./tr": 268,
		"./tr.js": 268,
		"./tzl": 269,
		"./tzl.js": 269,
		"./tzm": 271,
		"./tzm-latn": 270,
		"./tzm-latn.js": 270,
		"./tzm.js": 271,
		"./uk": 272,
		"./uk.js": 272,
		"./uz": 273,
		"./uz.js": 273,
		"./vi": 274,
		"./vi.js": 274,
		"./x-pseudo": 275,
		"./x-pseudo.js": 275,
		"./yo": 276,
		"./yo.js": 276,
		"./zh-cn": 277,
		"./zh-cn.js": 277,
		"./zh-hk": 278,
		"./zh-hk.js": 278,
		"./zh-tw": 279,
		"./zh-tw.js": 279
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 442;


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(56);
	var callBind = __webpack_require__(98);
	
	var implementation = __webpack_require__(280);
	var getPolyfill = __webpack_require__(281);
	var shim = __webpack_require__(444);
	
	var polyfill = callBind(getPolyfill(), Object);
	
	define(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = polyfill;


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getPolyfill = __webpack_require__(281);
	var define = __webpack_require__(56);
	
	module.exports = function shimObjectIs() {
		var polyfill = getPolyfill();
		define(Object, { is: polyfill }, {
			is: function testObjectIs() {
				return Object.is !== polyfill;
			}
		});
		return polyfill;
	};


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(283); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ },
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _deepEqual = __webpack_require__(169);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	function intersects(array1, array2) {
	  return !!(array1 && array2 && array1.some(function (item) {
	    return ~array2.indexOf(item);
	  }));
	}
	
	var LazyCache = (function () {
	  function LazyCache(component, calculators) {
	    var _this = this;
	
	    _classCallCheck(this, LazyCache);
	
	    this.component = component;
	    this.allProps = [];
	    this.cache = Object.keys(calculators).reduce(function (accumulator, key) {
	      var _extends2;
	
	      var calculator = calculators[key];
	      var fn = calculator.fn;
	      var paramNames = calculator.params;
	      paramNames.forEach(function (param) {
	        if (! ~_this.allProps.indexOf(param)) {
	          _this.allProps.push(param);
	        }
	      });
	      return _extends({}, accumulator, (_extends2 = {}, _extends2[key] = {
	        value: undefined,
	        props: paramNames,
	        fn: fn
	      }, _extends2));
	    }, {});
	  }
	
	  LazyCache.prototype.get = function get(key) {
	    var component = this.component;
	    var _cache$key = this.cache[key];
	    var value = _cache$key.value;
	    var fn = _cache$key.fn;
	    var props = _cache$key.props;
	
	    if (value !== undefined) {
	      return value;
	    }
	    var params = props.map(function (prop) {
	      return component.props[prop];
	    });
	    var result = fn.apply(undefined, params);
	    this.cache[key].value = result;
	    return result;
	  };
	
	  LazyCache.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    var component = this.component;
	
	    var diffProps = [];
	    this.allProps.forEach(function (prop) {
	      if (!_deepEqual2['default'](component.props[prop], nextProps[prop])) {
	        diffProps.push(prop);
	      }
	    });
	    if (diffProps.length) {
	      Object.keys(this.cache).forEach(function (key) {
	        if (intersects(diffProps, _this2.cache[key].props)) {
	          delete _this2.cache[key].value; // uncache value
	        }
	      });
	    }
	  };
	
	  return LazyCache;
	})();
	
	exports['default'] = LazyCache;
	module.exports = exports['default'];

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(452);


/***/ },
/* 454 */,
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isPromise = __webpack_require__(111);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _isValid = __webpack_require__(77);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var asyncValidation = function asyncValidation(fn, start, stop, field) {
	  start(field);
	  var promise = fn();
	  if (!(0, _isPromise2.default)(promise)) {
	    throw new Error('asyncValidate function passed to reduxForm must return a promise');
	  }
	  var handleErrors = function handleErrors(rejected) {
	    return function (errors) {
	      if (!(0, _isValid2.default)(errors)) {
	        stop(errors);
	        return Promise.reject();
	      } else if (rejected) {
	        stop();
	        throw new Error('Asynchronous validation promise was rejected without errors.');
	      }
	      stop();
	      return Promise.resolve();
	    };
	  };
	  return promise.then(handleErrors(false), handleErrors(true));
	};
	
	exports.default = asyncValidation;

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createAll;
	
	var _reducer = __webpack_require__(297);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _createReduxForm = __webpack_require__(459);
	
	var _createReduxForm2 = _interopRequireDefault(_createReduxForm);
	
	var _mapValues = __webpack_require__(116);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _bindActionData = __webpack_require__(288);
	
	var _bindActionData2 = _interopRequireDefault(_bindActionData);
	
	var _actions = __webpack_require__(287);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _actionTypes = __webpack_require__(115);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _createPropTypes = __webpack_require__(458);
	
	var _createPropTypes2 = _interopRequireDefault(_createPropTypes);
	
	var _getValuesFromState = __webpack_require__(295);
	
	var _getValuesFromState2 = _interopRequireDefault(_getValuesFromState);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// bind form as first parameter of action creators
	var boundActions = _extends({}, (0, _mapValues2.default)(_extends({}, actions, {
	  autofillWithKey: function autofillWithKey(key) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _bindActionData2.default)(actions.autofill, { key: key }).apply(undefined, args);
	  },
	  changeWithKey: function changeWithKey(key) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      args[_key2 - 1] = arguments[_key2];
	    }
	
	    return (0, _bindActionData2.default)(actions.change, { key: key }).apply(undefined, args);
	  },
	  initializeWithKey: function initializeWithKey(key) {
	    for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	      args[_key3 - 1] = arguments[_key3];
	    }
	
	    return (0, _bindActionData2.default)(actions.initialize, { key: key }).apply(undefined, args);
	  },
	  reset: function reset(key) {
	    return (0, _bindActionData2.default)(actions.reset, { key: key })();
	  },
	  touchWithKey: function touchWithKey(key) {
	    for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	      args[_key4 - 1] = arguments[_key4];
	    }
	
	    return (0, _bindActionData2.default)(actions.touch, { key: key }).apply(undefined, args);
	  },
	  untouchWithKey: function untouchWithKey(key) {
	    for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	      args[_key5 - 1] = arguments[_key5];
	    }
	
	    return (0, _bindActionData2.default)(actions.untouch, { key: key }).apply(undefined, args);
	  },
	  destroy: function destroy(key) {
	    return (0, _bindActionData2.default)(actions.destroy, { key: key })();
	  }
	}), function (action) {
	  return function (form) {
	    for (var _len6 = arguments.length, args = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
	      args[_key6 - 1] = arguments[_key6];
	    }
	
	    return (0, _bindActionData2.default)(action, { form: form }).apply(undefined, args);
	  };
	}));
	
	var addArrayValue = boundActions.addArrayValue;
	var autofill = boundActions.autofill;
	var autofillWithKey = boundActions.autofillWithKey;
	var blur = boundActions.blur;
	var change = boundActions.change;
	var changeWithKey = boundActions.changeWithKey;
	var destroy = boundActions.destroy;
	var focus = boundActions.focus;
	var initialize = boundActions.initialize;
	var initializeWithKey = boundActions.initializeWithKey;
	var removeArrayValue = boundActions.removeArrayValue;
	var reset = boundActions.reset;
	var startAsyncValidation = boundActions.startAsyncValidation;
	var startSubmit = boundActions.startSubmit;
	var stopAsyncValidation = boundActions.stopAsyncValidation;
	var stopSubmit = boundActions.stopSubmit;
	var submitFailed = boundActions.submitFailed;
	var swapArrayValues = boundActions.swapArrayValues;
	var touch = boundActions.touch;
	var touchWithKey = boundActions.touchWithKey;
	var untouch = boundActions.untouch;
	var untouchWithKey = boundActions.untouchWithKey;
	
	function createAll(isReactNative, React, connect) {
	  return {
	    actionTypes: actionTypes,
	    addArrayValue: addArrayValue,
	    autofill: autofill,
	    autofillWithKey: autofillWithKey,
	    blur: blur,
	    change: change,
	    changeWithKey: changeWithKey,
	    destroy: destroy,
	    focus: focus,
	    getValues: _getValuesFromState2.default,
	    initialize: initialize,
	    initializeWithKey: initializeWithKey,
	    propTypes: (0, _createPropTypes2.default)(React),
	    reduxForm: (0, _createReduxForm2.default)(isReactNative, React, connect),
	    reducer: _reducer2.default,
	    removeArrayValue: removeArrayValue,
	    reset: reset,
	    startAsyncValidation: startAsyncValidation,
	    startSubmit: startSubmit,
	    stopAsyncValidation: stopAsyncValidation,
	    stopSubmit: stopSubmit,
	    submitFailed: submitFailed,
	    swapArrayValues: swapArrayValues,
	    touch: touch,
	    touchWithKey: touchWithKey,
	    untouch: untouch,
	    untouchWithKey: untouchWithKey
	  };
	}

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actions = __webpack_require__(287);
	
	var importedActions = _interopRequireWildcard(_actions);
	
	var _getDisplayName = __webpack_require__(293);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _reducer = __webpack_require__(297);
	
	var _deepEqual = __webpack_require__(169);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _bindActionData = __webpack_require__(288);
	
	var _bindActionData2 = _interopRequireDefault(_bindActionData);
	
	var _getValues = __webpack_require__(294);
	
	var _getValues2 = _interopRequireDefault(_getValues);
	
	var _isValid = __webpack_require__(77);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _readFields = __webpack_require__(471);
	
	var _readFields2 = _interopRequireDefault(_readFields);
	
	var _handleSubmit2 = __webpack_require__(466);
	
	var _handleSubmit3 = _interopRequireDefault(_handleSubmit2);
	
	var _asyncValidation = __webpack_require__(455);
	
	var _asyncValidation2 = _interopRequireDefault(_asyncValidation);
	
	var _silenceEvents = __webpack_require__(465);
	
	var _silenceEvents2 = _interopRequireDefault(_silenceEvents);
	
	var _silenceEvent = __webpack_require__(292);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	var _wrapMapDispatchToProps = __webpack_require__(477);
	
	var _wrapMapDispatchToProps2 = _interopRequireDefault(_wrapMapDispatchToProps);
	
	var _wrapMapStateToProps = __webpack_require__(478);
	
	var _wrapMapStateToProps2 = _interopRequireDefault(_wrapMapStateToProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Creates a HOC that knows how to create redux-connected sub-components.
	 */
	var createHigherOrderComponent = function createHigherOrderComponent(config, isReactNative, React, connect, WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options) {
	  var Component = React.Component;
	  var PropTypes = React.PropTypes;
	
	  return function (reduxMountPoint, formName, formKey, getFormState) {
	    var ReduxForm = function (_Component) {
	      _inherits(ReduxForm, _Component);
	
	      function ReduxForm(props) {
	        _classCallCheck(this, ReduxForm);
	
	        // bind functions
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.asyncValidate = _this.asyncValidate.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.fields = (0, _readFields2.default)(props, {}, {}, _this.asyncValidate, isReactNative);
	        var submitPassback = _this.props.submitPassback;
	
	        submitPassback(function () {
	          return _this.handleSubmit();
	        }); // wrapped in function to disallow params
	        return _this;
	      }
	
	      ReduxForm.prototype.componentWillMount = function componentWillMount() {
	        var _props = this.props;
	        var fields = _props.fields;
	        var form = _props.form;
	        var initialize = _props.initialize;
	        var initialValues = _props.initialValues;
	
	        if (initialValues && !form._initialized) {
	          initialize(initialValues, fields);
	        }
	      };
	
	      ReduxForm.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!(0, _deepEqual2.default)(this.props.fields, nextProps.fields) || !(0, _deepEqual2.default)(this.props.form, nextProps.form, { strict: true })) {
	          this.fields = (0, _readFields2.default)(nextProps, this.props, this.fields, this.asyncValidate, isReactNative);
	        }
	        if (!(0, _deepEqual2.default)(this.props.initialValues, nextProps.initialValues)) {
	          this.props.initialize(nextProps.initialValues, nextProps.fields, this.props.overwriteOnInitialValuesChange || !this.props.form._initialized);
	        }
	      };
	
	      ReduxForm.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (config.destroyOnUnmount) {
	          this.props.destroy();
	        }
	      };
	
	      ReduxForm.prototype.asyncValidate = function asyncValidate(name, value) {
	        var _this2 = this;
	
	        var _props2 = this.props;
	        var alwaysAsyncValidate = _props2.alwaysAsyncValidate;
	        var asyncValidate = _props2.asyncValidate;
	        var dispatch = _props2.dispatch;
	        var fields = _props2.fields;
	        var form = _props2.form;
	        var startAsyncValidation = _props2.startAsyncValidation;
	        var stopAsyncValidation = _props2.stopAsyncValidation;
	        var validate = _props2.validate;
	
	        var isSubmitting = !name;
	        if (asyncValidate) {
	          var _ret = function () {
	            var values = (0, _getValues2.default)(fields, form);
	            if (name) {
	              values[name] = value;
	            }
	            var syncErrors = validate(values, _this2.props);
	            var allPristine = _this2.fields._meta.allPristine;
	
	            var initialized = form._initialized;
	
	            // if blur validating, only run async validate if sync validation passes
	            // and submitting (not blur validation) or form is dirty or form was never initialized
	            // unless alwaysAsyncValidate is true
	            var syncValidationPasses = isSubmitting || (0, _isValid2.default)(syncErrors[name]);
	            if (alwaysAsyncValidate || syncValidationPasses && (isSubmitting || !allPristine || !initialized)) {
	              return {
	                v: (0, _asyncValidation2.default)(function () {
	                  return asyncValidate(values, dispatch, _this2.props);
	                }, startAsyncValidation, stopAsyncValidation, name)
	              };
	            }
	          }();
	
	          if (typeof _ret === "object") return _ret.v;
	        }
	      };
	
	      ReduxForm.prototype.handleSubmit = function handleSubmit(submitOrEvent) {
	        var _this3 = this;
	
	        var _props3 = this.props;
	        var onSubmit = _props3.onSubmit;
	        var fields = _props3.fields;
	        var form = _props3.form;
	
	        var check = function check(submit) {
	          if (!submit || typeof submit !== 'function') {
	            throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
	          }
	          return submit;
	        };
	        return !submitOrEvent || (0, _silenceEvent2.default)(submitOrEvent) ?
	        // submitOrEvent is an event: fire submit
	        (0, _handleSubmit3.default)(check(onSubmit), (0, _getValues2.default)(fields, form), this.props, this.asyncValidate) :
	        // submitOrEvent is the submit function: return deferred submit thunk
	        (0, _silenceEvents2.default)(function () {
	          return (0, _handleSubmit3.default)(check(submitOrEvent), (0, _getValues2.default)(fields, form), _this3.props, _this3.asyncValidate);
	        });
	      };
	
	      ReduxForm.prototype.render = function render() {
	        var _this4 = this,
	            _ref;
	
	        var allFields = this.fields;
	        var _props4 = this.props;
	        var addArrayValue = _props4.addArrayValue;
	        var asyncBlurFields = _props4.asyncBlurFields;
	        var autofill = _props4.autofill;
	        var blur = _props4.blur;
	        var change = _props4.change;
	        var destroy = _props4.destroy;
	        var focus = _props4.focus;
	        var fields = _props4.fields;
	        var form = _props4.form;
	        var initialValues = _props4.initialValues;
	        var initialize = _props4.initialize;
	        var onSubmit = _props4.onSubmit;
	        var propNamespace = _props4.propNamespace;
	        var reset = _props4.reset;
	        var removeArrayValue = _props4.removeArrayValue;
	        var returnRejectedSubmitPromise = _props4.returnRejectedSubmitPromise;
	        var startAsyncValidation = _props4.startAsyncValidation;
	        var startSubmit = _props4.startSubmit;
	        var stopAsyncValidation = _props4.stopAsyncValidation;
	        var stopSubmit = _props4.stopSubmit;
	        var submitFailed = _props4.submitFailed;
	        var swapArrayValues = _props4.swapArrayValues;
	        var touch = _props4.touch;
	        var untouch = _props4.untouch;
	        var validate = _props4.validate;
	
	        var passableProps = _objectWithoutProperties(_props4, ['addArrayValue', 'asyncBlurFields', 'autofill', 'blur', 'change', 'destroy', 'focus', 'fields', 'form', 'initialValues', 'initialize', 'onSubmit', 'propNamespace', 'reset', 'removeArrayValue', 'returnRejectedSubmitPromise', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitFailed', 'swapArrayValues', 'touch', 'untouch', 'validate']); // eslint-disable-line no-redeclare
	
	
	        var _allFields$_meta = allFields._meta;
	        var allPristine = _allFields$_meta.allPristine;
	        var allValid = _allFields$_meta.allValid;
	        var errors = _allFields$_meta.errors;
	        var formError = _allFields$_meta.formError;
	        var values = _allFields$_meta.values;
	
	
	        var props = {
	          // State:
	          active: form._active,
	          asyncValidating: form._asyncValidating,
	          dirty: !allPristine,
	          error: formError,
	          errors: errors,
	          fields: allFields,
	          formKey: formKey,
	          invalid: !allValid,
	          pristine: allPristine,
	          submitting: form._submitting,
	          submitFailed: form._submitFailed,
	          valid: allValid,
	          values: values,
	
	          // Actions:
	          asyncValidate: (0, _silenceEvents2.default)(function () {
	            return _this4.asyncValidate();
	          }),
	          // ^ doesn't just pass this.asyncValidate to disallow values passing
	          destroyForm: (0, _silenceEvents2.default)(destroy),
	          handleSubmit: this.handleSubmit,
	          initializeForm: (0, _silenceEvents2.default)(function (initValues) {
	            return initialize(initValues, fields);
	          }),
	          resetForm: (0, _silenceEvents2.default)(reset),
	          touch: (0, _silenceEvents2.default)(function () {
	            return touch.apply(undefined, arguments);
	          }),
	          touchAll: (0, _silenceEvents2.default)(function () {
	            return touch.apply(undefined, fields);
	          }),
	          untouch: (0, _silenceEvents2.default)(function () {
	            return untouch.apply(undefined, arguments);
	          }),
	          untouchAll: (0, _silenceEvents2.default)(function () {
	            return untouch.apply(undefined, fields);
	          })
	        };
	        var passedProps = propNamespace ? (_ref = {}, _ref[propNamespace] = props, _ref) : props;
	        return React.createElement(WrappedComponent, _extends({}, passableProps, passedProps));
	      };
	
	      return ReduxForm;
	    }(Component);
	
	    ReduxForm.displayName = 'ReduxForm(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
	    ReduxForm.WrappedComponent = WrappedComponent;
	    ReduxForm.propTypes = {
	      // props:
	      alwaysAsyncValidate: PropTypes.bool,
	      asyncBlurFields: PropTypes.arrayOf(PropTypes.string),
	      asyncValidate: PropTypes.func,
	      dispatch: PropTypes.func.isRequired,
	      fields: PropTypes.arrayOf(PropTypes.string).isRequired,
	      form: PropTypes.object,
	      initialValues: PropTypes.any,
	      onSubmit: PropTypes.func,
	      onSubmitSuccess: PropTypes.func,
	      onSubmitFail: PropTypes.func,
	      overwriteOnInitialValuesChange: PropTypes.bool.isRequired,
	      propNamespace: PropTypes.string,
	      readonly: PropTypes.bool,
	      returnRejectedSubmitPromise: PropTypes.bool,
	      submitPassback: PropTypes.func.isRequired,
	      validate: PropTypes.func,
	
	      // actions:
	      addArrayValue: PropTypes.func.isRequired,
	      autofill: PropTypes.func.isRequired,
	      blur: PropTypes.func.isRequired,
	      change: PropTypes.func.isRequired,
	      destroy: PropTypes.func.isRequired,
	      focus: PropTypes.func.isRequired,
	      initialize: PropTypes.func.isRequired,
	      removeArrayValue: PropTypes.func.isRequired,
	      reset: PropTypes.func.isRequired,
	      startAsyncValidation: PropTypes.func.isRequired,
	      startSubmit: PropTypes.func.isRequired,
	      stopAsyncValidation: PropTypes.func.isRequired,
	      stopSubmit: PropTypes.func.isRequired,
	      submitFailed: PropTypes.func.isRequired,
	      swapArrayValues: PropTypes.func.isRequired,
	      touch: PropTypes.func.isRequired,
	      untouch: PropTypes.func.isRequired
	    };
	    ReduxForm.defaultProps = {
	      asyncBlurFields: [],
	      form: _reducer.initialState,
	      readonly: false,
	      returnRejectedSubmitPromise: false,
	      validate: function validate() {
	        return {};
	      }
	    };
	
	    // bind touch flags to blur and change
	    var unboundActions = _extends({}, importedActions, {
	      blur: (0, _bindActionData2.default)(importedActions.blur, {
	        touch: !!config.touchOnBlur
	      }),
	      change: (0, _bindActionData2.default)(importedActions.change, {
	        touch: !!config.touchOnChange
	      })
	    });
	
	    // make redux connector with or without form key
	    var decorate = formKey !== undefined && formKey !== null ? connect((0, _wrapMapStateToProps2.default)(mapStateToProps, function (state) {
	      var formState = getFormState(state, reduxMountPoint);
	      if (!formState) {
	        throw new Error('You need to mount the redux-form reducer at "' + reduxMountPoint + '"');
	      }
	      return formState && formState[formName] && formState[formName][formKey];
	    }), (0, _wrapMapDispatchToProps2.default)(mapDispatchToProps, (0, _bindActionData2.default)(unboundActions, {
	      form: formName,
	      key: formKey
	    })), mergeProps, options) : connect((0, _wrapMapStateToProps2.default)(mapStateToProps, function (state) {
	      var formState = getFormState(state, reduxMountPoint);
	      if (!formState) {
	        throw new Error('You need to mount the redux-form reducer at "' + reduxMountPoint + '"');
	      }
	      return formState && formState[formName];
	    }), (0, _wrapMapDispatchToProps2.default)(mapDispatchToProps, (0, _bindActionData2.default)(unboundActions, { form: formName })), mergeProps, options);
	
	    return decorate(ReduxForm);
	  };
	};
	
	exports.default = createHigherOrderComponent;

/***/ },
/* 458 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var createPropTypes = function createPropTypes(_ref) {
	  var _ref$PropTypes = _ref.PropTypes;
	  var any = _ref$PropTypes.any;
	  var bool = _ref$PropTypes.bool;
	  var string = _ref$PropTypes.string;
	  var func = _ref$PropTypes.func;
	  var object = _ref$PropTypes.object;
	  return {
	    // State:
	    active: string, // currently active field
	    asyncValidating: bool.isRequired, // true if async validation is running
	    autofilled: bool, // true if set programmatically by autofill
	    dirty: bool.isRequired, // true if any values are different from initialValues
	    error: any, // form-wide error from '_error' key in validation result
	    errors: object, // a map of errors corresponding to structure of form data (result of validation)
	    fields: object.isRequired, // the map of fields
	    formKey: any, // the form key if one was provided (used when doing multirecord forms)
	    invalid: bool.isRequired, // true if there are any validation errors
	    pristine: bool.isRequired, // true if the values are the same as initialValues
	    submitting: bool.isRequired, // true if the form is in the process of being submitted
	    submitFailed: bool.isRequired, // true if the form was submitted and failed for any reason
	    valid: bool.isRequired, // true if there are no validation errors
	    values: object.isRequired, // the values of the form as they will be submitted
	
	    // Actions:
	    asyncValidate: func.isRequired, // function to trigger async validation
	    destroyForm: func.isRequired, // action to destroy the form's data in Redux
	    handleSubmit: func.isRequired, // function to submit the form
	    initializeForm: func.isRequired, // action to initialize form data
	    resetForm: func.isRequired, // action to reset the form data to previously initialized values
	    touch: func.isRequired, // action to mark fields as touched
	    touchAll: func.isRequired, // action to mark ALL fields as touched
	    untouch: func.isRequired, // action to mark fields as untouched
	    untouchAll: func.isRequired // action to mark ALL fields as untouched
	  };
	};
	
	exports.default = createPropTypes;

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createReduxFormConnector = __webpack_require__(460);
	
	var _createReduxFormConnector2 = _interopRequireDefault(_createReduxFormConnector);
	
	var _hoistNonReactStatics = __webpack_require__(436);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The decorator that is the main API to redux-form
	 */
	var createReduxForm = function createReduxForm(isReactNative, React, connect) {
	  var Component = React.Component;
	
	  var reduxFormConnector = (0, _createReduxFormConnector2.default)(isReactNative, React, connect);
	  return function (config, mapStateToProps, mapDispatchToProps, mergeProps, options) {
	    return function (WrappedComponent) {
	      var ReduxFormConnector = reduxFormConnector(WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options);
	      var configWithDefaults = _extends({
	        overwriteOnInitialValuesChange: true,
	        touchOnBlur: true,
	        touchOnChange: false,
	        destroyOnUnmount: true
	      }, config);
	
	      var ConnectedForm = function (_Component) {
	        _inherits(ConnectedForm, _Component);
	
	        function ConnectedForm(props) {
	          _classCallCheck(this, ConnectedForm);
	
	          var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	          _this.handleSubmitPassback = _this.handleSubmitPassback.bind(_this);
	          return _this;
	        }
	
	        ConnectedForm.prototype.handleSubmitPassback = function handleSubmitPassback(submit) {
	          this.submit = submit;
	        };
	
	        ConnectedForm.prototype.render = function render() {
	          return React.createElement(ReduxFormConnector, _extends({}, configWithDefaults, this.props, {
	            submitPassback: this.handleSubmitPassback }));
	        };
	
	        return ConnectedForm;
	      }(Component);
	
	      return (0, _hoistNonReactStatics2.default)(ConnectedForm, WrappedComponent);
	    };
	  };
	};
	
	exports.default = createReduxForm;

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _noGetters = __webpack_require__(453);
	
	var _noGetters2 = _interopRequireDefault(_noGetters);
	
	var _getDisplayName = __webpack_require__(293);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _createHigherOrderComponent = __webpack_require__(457);
	
	var _createHigherOrderComponent2 = _interopRequireDefault(_createHigherOrderComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component tracks props that affect how the form is mounted to the store. Normally these should not change,
	 * but if they do, the connected components below it need to be redefined.
	 */
	var createReduxFormConnector = function createReduxFormConnector(isReactNative, React, connect) {
	  return function (WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options) {
	    var Component = React.Component;
	    var PropTypes = React.PropTypes;
	
	    var ReduxFormConnector = function (_Component) {
	      _inherits(ReduxFormConnector, _Component);
	
	      function ReduxFormConnector(props) {
	        _classCallCheck(this, ReduxFormConnector);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.cache = new _noGetters2.default(_this, {
	          ReduxForm: {
	            params: [
	            // props that effect how redux-form connects to the redux store
	            'reduxMountPoint', 'form', 'formKey', 'getFormState'],
	            fn: (0, _createHigherOrderComponent2.default)(props, isReactNative, React, connect, WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options)
	          }
	        });
	        return _this;
	      }
	
	      ReduxFormConnector.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.cache.componentWillReceiveProps(nextProps);
	      };
	
	      ReduxFormConnector.prototype.render = function render() {
	        var ReduxForm = this.cache.get('ReduxForm');
	        // remove some redux-form config-only props
	        var _props = this.props;
	        var reduxMountPoint = _props.reduxMountPoint;
	        var destroyOnUnmount = _props.destroyOnUnmount;
	        var form = _props.form;
	        var getFormState = _props.getFormState;
	        var touchOnBlur = _props.touchOnBlur;
	        var touchOnChange = _props.touchOnChange;
	
	        var passableProps = _objectWithoutProperties(_props, ['reduxMountPoint', 'destroyOnUnmount', 'form', 'getFormState', 'touchOnBlur', 'touchOnChange']); // eslint-disable-line no-redeclare
	
	
	        return React.createElement(ReduxForm, passableProps);
	      };
	
	      return ReduxFormConnector;
	    }(Component);
	
	    ReduxFormConnector.displayName = 'ReduxFormConnector(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
	    ReduxFormConnector.WrappedComponent = WrappedComponent;
	    ReduxFormConnector.propTypes = {
	      destroyOnUnmount: PropTypes.bool,
	      reduxMountPoint: PropTypes.string,
	      form: PropTypes.string.isRequired,
	      formKey: PropTypes.string,
	      getFormState: PropTypes.func,
	      touchOnBlur: PropTypes.bool,
	      touchOnChange: PropTypes.bool
	    };
	    ReduxFormConnector.defaultProps = {
	      reduxMountPoint: 'form',
	      getFormState: function getFormState(state, reduxMountPoint) {
	        return state[reduxMountPoint];
	      }
	    };
	    return ReduxFormConnector;
	  };
	};
	
	exports.default = createReduxFormConnector;

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getValue = __webpack_require__(290);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createOnBlur = function createOnBlur(name, blur, isReactNative, afterBlur) {
	  return function (event) {
	    var value = (0, _getValue2.default)(event, isReactNative);
	    blur(name, value);
	    if (afterBlur) {
	      afterBlur(name, value);
	    }
	  };
	};
	exports.default = createOnBlur;

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getValue = __webpack_require__(290);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createOnChange = function createOnChange(name, change, isReactNative) {
	  return function (event) {
	    return change(name, (0, _getValue2.default)(event, isReactNative));
	  };
	};
	exports.default = createOnChange;

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createOnDragStart = __webpack_require__(289);
	
	var createOnDrop = function createOnDrop(name, change) {
	  return function (event) {
	    change(name, event.dataTransfer.getData(_createOnDragStart.dataKey));
	  };
	};
	exports.default = createOnDrop;

/***/ },
/* 464 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var createOnFocus = function createOnFocus(name, focus) {
	  return function () {
	    return focus(name);
	  };
	};
	exports.default = createOnFocus;

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _silenceEvent = __webpack_require__(292);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvents = function silenceEvents(fn) {
	  return function (event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _silenceEvent2.default)(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
	  };
	};
	
	exports.default = silenceEvents;

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isPromise = __webpack_require__(111);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _isValid = __webpack_require__(77);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var handleSubmit = function handleSubmit(submit, values, props, asyncValidate) {
	  var dispatch = props.dispatch;
	  var fields = props.fields;
	  var onSubmitSuccess = props.onSubmitSuccess;
	  var onSubmitFail = props.onSubmitFail;
	  var startSubmit = props.startSubmit;
	  var stopSubmit = props.stopSubmit;
	  var submitFailed = props.submitFailed;
	  var returnRejectedSubmitPromise = props.returnRejectedSubmitPromise;
	  var touch = props.touch;
	  var validate = props.validate;
	
	  var syncErrors = validate(values, props);
	  touch.apply(undefined, fields); // touch all fields
	  if ((0, _isValid2.default)(syncErrors)) {
	    var doSubmit = function doSubmit() {
	      var result = submit(values, dispatch);
	      if ((0, _isPromise2.default)(result)) {
	        startSubmit();
	        return result.then(function (submitResult) {
	          stopSubmit();
	          if (onSubmitSuccess) {
	            onSubmitSuccess(submitResult);
	          }
	          return submitResult;
	        }, function (submitError) {
	          stopSubmit(submitError);
	          if (onSubmitFail) {
	            onSubmitFail(submitError);
	          }
	          if (returnRejectedSubmitPromise) {
	            return Promise.reject(submitError);
	          }
	        });
	      }
	      if (onSubmitSuccess) {
	        onSubmitSuccess(result);
	      }
	      return result;
	    };
	    var asyncValidateResult = asyncValidate();
	    return (0, _isPromise2.default)(asyncValidateResult) ?
	    // asyncValidateResult will be rejected if async validation failed
	    asyncValidateResult.then(doSubmit, function () {
	      submitFailed();
	      if (onSubmitFail) {
	        onSubmitFail();
	      }
	      return returnRejectedSubmitPromise ? Promise.reject() : Promise.resolve();
	    }) : doSubmit(); // no async validation, so submit
	  }
	  submitFailed();
	
	  if (onSubmitFail) {
	    onSubmitFail(syncErrors);
	  }
	
	  if (returnRejectedSubmitPromise) {
	    return Promise.reject(syncErrors);
	  }
	};
	
	exports.default = handleSubmit;

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _fieldValue = __webpack_require__(45);
	
	var makeEntry = function makeEntry(value, previousValue, overwriteValues) {
	  return (0, _fieldValue.makeFieldValue)(value === undefined ? {} : {
	    initial: value,
	    value: overwriteValues ? value : previousValue
	  });
	};
	
	/**
	 * Sets the initial values into the state and returns a new copy of the state
	 */
	var initializeState = function initializeState(values, fields) {
	  var state = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	  var overwriteValues = arguments.length <= 3 || arguments[3] === undefined ? true : arguments[3];
	
	  if (!fields) {
	    throw new Error('fields must be passed when initializing state');
	  }
	  if (!values || !fields.length) {
	    return state;
	  }
	  var initializeField = function initializeField(path, src, dest) {
	    var dotIndex = path.indexOf('.');
	    if (dotIndex === 0) {
	      return initializeField(path.substring(1), src, dest);
	    }
	    var openIndex = path.indexOf('[');
	    var closeIndex = path.indexOf(']');
	    var result = _extends({}, dest) || {};
	    if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
	      // is dot notation
	      var key = path.substring(0, dotIndex);
	      result[key] = src[key] && initializeField(path.substring(dotIndex + 1), src[key], result[key] || {});
	    } else if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	      (function () {
	        // is array notation
	        if (closeIndex < 0) {
	          throw new Error('found \'[\' but no \']\': \'' + path + '\'');
	        }
	        var key = path.substring(0, openIndex);
	        var srcArray = src[key];
	        var destArray = result[key];
	        var rest = path.substring(closeIndex + 1);
	        if (Array.isArray(srcArray)) {
	          if (rest.length) {
	            // need to keep recursing
	            result[key] = srcArray.map(function (srcValue, srcIndex) {
	              return initializeField(rest, srcValue, destArray && destArray[srcIndex]);
	            });
	          } else {
	            result[key] = srcArray.map(function (srcValue, srcIndex) {
	              return makeEntry(srcValue, destArray && destArray[srcIndex] && destArray[srcIndex].value, overwriteValues);
	            });
	          }
	        } else {
	          result[key] = [];
	        }
	      })();
	    } else {
	      result[path] = makeEntry(src && src[path], dest && dest[path] && dest[path].value, overwriteValues);
	    }
	    return result;
	  };
	  return fields.reduce(function (accumulator, field) {
	    return initializeField(field, values, accumulator);
	  }, _extends({}, state));
	};
	
	exports.default = initializeState;

/***/ },
/* 468 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isPristine;
	function isPristine(initial, data) {
	  if (initial === data) {
	    return true;
	  }
	  if (typeof initial === 'boolean' || typeof data === 'boolean') {
	    return initial === data;
	  } else if (initial instanceof Date && data instanceof Date) {
	    return initial.getTime() === data.getTime();
	  } else if (initial && typeof initial === 'object') {
	    if (!data || typeof data !== 'object') {
	      return false;
	    }
	    var initialKeys = Object.keys(initial);
	    var dataKeys = Object.keys(data);
	    if (initialKeys.length !== dataKeys.length) {
	      return false;
	    }
	    for (var index = 0; index < dataKeys.length; index++) {
	      var key = dataKeys[index];
	      if (!isPristine(initial[key], data[key])) {
	        return false;
	      }
	    }
	  } else if (initial || data) {
	    // allow '' to equate to undefined or null
	    return initial === data;
	  }
	  return true;
	}

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = normalizeFields;
	
	var _fieldValue = __webpack_require__(45);
	
	function extractKey(field) {
	  var dotIndex = field.indexOf('.');
	  var openIndex = field.indexOf('[');
	  var closeIndex = field.indexOf(']');
	
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	
	  var isArray = openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex);
	  var key = void 0;
	  var nestedPath = void 0;
	
	  if (isArray) {
	    key = field.substring(0, openIndex);
	    nestedPath = field.substring(closeIndex + 1);
	
	    if (nestedPath[0] === '.') {
	      nestedPath = nestedPath.substring(1);
	    }
	  } else if (dotIndex > 0) {
	    key = field.substring(0, dotIndex);
	    nestedPath = field.substring(dotIndex + 1);
	  } else {
	    key = field;
	  }
	
	  return { isArray: isArray, key: key, nestedPath: nestedPath };
	}
	
	function normalizeField(field, fullFieldPath, state, previousState, values, previousValues, normalizers) {
	  if (field.isArray) {
	    if (field.nestedPath) {
	      var _ret = function () {
	        var array = state && state[field.key] || [];
	        var previousArray = previousState && previousState[field.key] || [];
	        var nestedField = extractKey(field.nestedPath);
	
	        return {
	          v: array.map(function (nestedState, i) {
	            nestedState[nestedField.key] = normalizeField(nestedField, fullFieldPath, nestedState, previousArray[i], values, previousValues, normalizers);
	
	            return nestedState;
	          })
	        };
	      }();
	
	      if (typeof _ret === "object") return _ret.v;
	    }
	
	    var _normalizer = normalizers[fullFieldPath];
	
	    var result = _normalizer(state && state[field.key], previousState && previousState[field.key], values, previousValues);
	    return field.isArray ? result && result.map(_fieldValue.makeFieldValue) : result;
	  } else if (field.nestedPath) {
	    var nestedState = state && state[field.key] || {};
	    var _nestedField = extractKey(field.nestedPath);
	
	    nestedState[_nestedField.key] = normalizeField(_nestedField, fullFieldPath, nestedState, previousState && previousState[field.key], values, previousValues, normalizers);
	
	    return nestedState;
	  }
	
	  var finalField = state && state[field.key] || {};
	  var normalizer = normalizers[fullFieldPath];
	
	  finalField.value = normalizer(finalField.value, previousState && previousState[field.key] && previousState[field.key].value, values, previousValues);
	
	  return (0, _fieldValue.makeFieldValue)(finalField);
	}
	
	function normalizeFields(normalizers, state, previousState, values, previousValues) {
	  var newState = Object.keys(normalizers).reduce(function (accumulator, field) {
	    var extracted = extractKey(field);
	
	    accumulator[extracted.key] = normalizeField(extracted, field, state, previousState, values, previousValues, normalizers);
	
	    return accumulator;
	  }, {});
	
	  return _extends({}, state, newState);
	}

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createOnBlur = __webpack_require__(461);
	
	var _createOnBlur2 = _interopRequireDefault(_createOnBlur);
	
	var _createOnChange = __webpack_require__(462);
	
	var _createOnChange2 = _interopRequireDefault(_createOnChange);
	
	var _createOnDragStart = __webpack_require__(289);
	
	var _createOnDragStart2 = _interopRequireDefault(_createOnDragStart);
	
	var _createOnDrop = __webpack_require__(463);
	
	var _createOnDrop2 = _interopRequireDefault(_createOnDrop);
	
	var _createOnFocus = __webpack_require__(464);
	
	var _createOnFocus2 = _interopRequireDefault(_createOnFocus);
	
	var _silencePromise = __webpack_require__(475);
	
	var _silencePromise2 = _interopRequireDefault(_silencePromise);
	
	var _read = __webpack_require__(296);
	
	var _read2 = _interopRequireDefault(_read);
	
	var _updateField = __webpack_require__(476);
	
	var _updateField2 = _interopRequireDefault(_updateField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getSuffix(input, closeIndex) {
	  var suffix = input.substring(closeIndex + 1);
	  if (suffix[0] === '.') {
	    suffix = suffix.substring(1);
	  }
	  return suffix;
	}
	
	var getNextKey = function getNextKey(path) {
	  var dotIndex = path.indexOf('.');
	  var openIndex = path.indexOf('[');
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    return path.substring(0, openIndex);
	  }
	  return dotIndex > 0 ? path.substring(0, dotIndex) : path;
	};
	
	var shouldAsyncValidate = function shouldAsyncValidate(name, asyncBlurFields) {
	  return(
	    // remove array indices
	    ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'))
	  );
	};
	
	var readField = function readField(state, fieldName) {
	  var pathToHere = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
	  var fields = arguments[3];
	  var syncErrors = arguments[4];
	  var asyncValidate = arguments[5];
	  var isReactNative = arguments[6];
	  var props = arguments[7];
	  var callback = arguments.length <= 8 || arguments[8] === undefined ? function () {
	    return null;
	  } : arguments[8];
	  var prefix = arguments.length <= 9 || arguments[9] === undefined ? '' : arguments[9];
	  var asyncBlurFields = props.asyncBlurFields;
	  var autofill = props.autofill;
	  var blur = props.blur;
	  var change = props.change;
	  var focus = props.focus;
	  var form = props.form;
	  var initialValues = props.initialValues;
	  var readonly = props.readonly;
	  var addArrayValue = props.addArrayValue;
	  var removeArrayValue = props.removeArrayValue;
	  var swapArrayValues = props.swapArrayValues;
	
	  var dotIndex = fieldName.indexOf('.');
	  var openIndex = fieldName.indexOf('[');
	  var closeIndex = fieldName.indexOf(']');
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    var _ret = function () {
	      // array field
	      var key = fieldName.substring(0, openIndex);
	      var rest = getSuffix(fieldName, closeIndex);
	      var stateArray = state && state[key] || [];
	      var fullPrefix = prefix + fieldName.substring(0, closeIndex + 1);
	      var subfields = props.fields.reduce(function (accumulator, field) {
	        if (field.indexOf(fullPrefix) === 0) {
	          accumulator.push(field);
	        }
	        return accumulator;
	      }, []).map(function (field) {
	        return getSuffix(field, prefix.length + closeIndex);
	      });
	      var addMethods = function addMethods(dest) {
	        Object.defineProperty(dest, 'addField', {
	          value: function value(_value, index) {
	            return addArrayValue(pathToHere + key, _value, index, subfields);
	          }
	        });
	        Object.defineProperty(dest, 'removeField', {
	          value: function value(index) {
	            return removeArrayValue(pathToHere + key, index);
	          }
	        });
	        Object.defineProperty(dest, 'swapFields', {
	          value: function value(indexA, indexB) {
	            return swapArrayValues(pathToHere + key, indexA, indexB);
	          }
	        });
	        return dest;
	      };
	      if (!fields[key] || fields[key].length !== stateArray.length) {
	        fields[key] = fields[key] ? [].concat(fields[key]) : [];
	        addMethods(fields[key]);
	      }
	      var fieldArray = fields[key];
	      var changed = false;
	      stateArray.forEach(function (fieldState, index) {
	        if (rest && !fieldArray[index]) {
	          fieldArray[index] = {};
	          changed = true;
	        }
	        var dest = rest ? fieldArray[index] : {};
	        var nextPath = '' + pathToHere + key + '[' + index + ']' + (rest ? '.' : '');
	        var nextPrefix = '' + prefix + key + '[]' + (rest ? '.' : '');
	
	        var result = readField(fieldState, rest, nextPath, dest, syncErrors, asyncValidate, isReactNative, props, callback, nextPrefix);
	        if (!rest && fieldArray[index] !== result) {
	          // if nothing after [] in field name, assign directly to array
	          fieldArray[index] = result;
	          changed = true;
	        }
	      });
	      if (fieldArray.length > stateArray.length) {
	        // remove extra items that aren't in state array
	        fieldArray.splice(stateArray.length, fieldArray.length - stateArray.length);
	      }
	      return {
	        v: changed ? addMethods([].concat(fieldArray)) : fieldArray
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	  if (dotIndex > 0) {
	    // subobject field
	    var _key = fieldName.substring(0, dotIndex);
	    var _rest = fieldName.substring(dotIndex + 1);
	    var subobject = fields[_key] || {};
	    var nextPath = pathToHere + _key + '.';
	    var nextKey = getNextKey(_rest);
	    var previous = subobject[nextKey];
	    var result = readField(state[_key] || {}, _rest, nextPath, subobject, syncErrors, asyncValidate, isReactNative, props, callback, nextPath);
	    if (result !== previous) {
	      var _extends2;
	
	      subobject = _extends({}, subobject, (_extends2 = {}, _extends2[nextKey] = result, _extends2));
	    }
	    fields[_key] = subobject;
	    return subobject;
	  }
	  var name = pathToHere + fieldName;
	  var field = fields[fieldName] || {};
	  if (field.name !== name) {
	    var onChange = (0, _createOnChange2.default)(name, change, isReactNative);
	    var initialFormValue = (0, _read2.default)(name + '.initial', form);
	    var initialValue = initialFormValue || (0, _read2.default)(name, initialValues);
	    initialValue = initialValue === undefined ? '' : initialValue;
	    field.name = name;
	    field.checked = initialValue === true || undefined;
	    field.value = initialValue;
	    field.initialValue = initialValue;
	    if (!readonly) {
	      field.autofill = function (value) {
	        return autofill(name, value);
	      };
	      field.onBlur = (0, _createOnBlur2.default)(name, blur, isReactNative, shouldAsyncValidate(name, asyncBlurFields) && function (blurName, blurValue) {
	        return (0, _silencePromise2.default)(asyncValidate(blurName, blurValue));
	      });
	      field.onChange = onChange;
	      field.onDragStart = (0, _createOnDragStart2.default)(name, function () {
	        return field.value;
	      });
	      field.onDrop = (0, _createOnDrop2.default)(name, change);
	      field.onFocus = (0, _createOnFocus2.default)(name, focus);
	      field.onUpdate = onChange; // alias to support belle. https://github.com/nikgraf/belle/issues/58
	    }
	    field.valid = true;
	    field.invalid = false;
	    Object.defineProperty(field, '_isField', { value: true });
	  }
	
	  var defaultFieldState = {
	    initial: field.value,
	    value: field.value
	  };
	
	  var fieldState = (fieldName ? state[fieldName] : state) || defaultFieldState;
	  var syncError = (0, _read2.default)(name, syncErrors);
	  var updated = (0, _updateField2.default)(field, fieldState, name === form._active, syncError);
	  if (fieldName || fields[fieldName] !== updated) {
	    fields[fieldName] = updated;
	  }
	  callback(updated);
	  return updated;
	};
	
	exports.default = readField;

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _readField = __webpack_require__(470);
	
	var _readField2 = _interopRequireDefault(_readField);
	
	var _write = __webpack_require__(298);
	
	var _write2 = _interopRequireDefault(_write);
	
	var _getValues = __webpack_require__(294);
	
	var _getValues2 = _interopRequireDefault(_getValues);
	
	var _removeField = __webpack_require__(472);
	
	var _removeField2 = _interopRequireDefault(_removeField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Reads props and generates (or updates) field structure
	 */
	var readFields = function readFields(props, previousProps, myFields, asyncValidate, isReactNative) {
	  var fields = props.fields;
	  var form = props.form;
	  var validate = props.validate;
	
	  var previousFields = previousProps.fields;
	  var values = (0, _getValues2.default)(fields, form);
	  var syncErrors = validate(values, props) || {};
	  var errors = {};
	  var formError = syncErrors._error || form._error;
	  var allValid = !formError;
	  var allPristine = true;
	  var tally = function tally(field) {
	    if (field.error) {
	      errors = (0, _write2.default)(field.name, field.error, errors);
	      allValid = false;
	    }
	    if (field.dirty) {
	      allPristine = false;
	    }
	  };
	  var fieldObjects = previousFields ? previousFields.reduce(function (accumulator, previousField) {
	    return ~fields.indexOf(previousField) ? accumulator : (0, _removeField2.default)(accumulator, previousField);
	  }, _extends({}, myFields)) : _extends({}, myFields);
	  fields.forEach(function (name) {
	    (0, _readField2.default)(form, name, undefined, fieldObjects, syncErrors, asyncValidate, isReactNative, props, tally);
	  });
	  Object.defineProperty(fieldObjects, '_meta', {
	    value: {
	      allPristine: allPristine,
	      allValid: allValid,
	      values: values,
	      errors: errors,
	      formError: formError
	    }
	  });
	  return fieldObjects;
	};
	exports.default = readFields;

/***/ },
/* 472 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var without = function without(object, key) {
	  var copy = _extends({}, object);
	  delete copy[key];
	  return copy;
	};
	
	var removeField = function removeField(fields, path) {
	  var dotIndex = path.indexOf('.');
	  var openIndex = path.indexOf('[');
	  var closeIndex = path.indexOf(']');
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    var _ret = function () {
	      // array field
	      var key = path.substring(0, openIndex);
	      if (!Array.isArray(fields[key])) {
	        return {
	          v: without(fields, key)
	        };
	      }
	      var rest = path.substring(closeIndex + 1);
	      if (rest[0] === '.') {
	        rest = rest.substring(1);
	      }
	      if (rest) {
	        var _ret2 = function () {
	          var _extends2;
	
	          var copy = [];
	          fields[key].forEach(function (item, index) {
	            var result = removeField(item, rest);
	            if (Object.keys(result).length) {
	              copy[index] = result;
	            }
	          });
	          return {
	            v: {
	              v: copy.length ? _extends({}, fields, (_extends2 = {}, _extends2[key] = copy, _extends2)) : without(fields, key)
	            }
	          };
	        }();
	
	        if (typeof _ret2 === "object") return _ret2.v;
	      }
	      return {
	        v: without(fields, key)
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	  if (dotIndex > 0) {
	    var _extends3;
	
	    // subobject field
	    var _key = path.substring(0, dotIndex);
	    var _rest = path.substring(dotIndex + 1);
	    if (!fields[_key]) {
	      return fields;
	    }
	    var result = removeField(fields[_key], _rest);
	    return Object.keys(result).length ? _extends({}, fields, (_extends3 = {}, _extends3[_key] = removeField(fields[_key], _rest), _extends3)) : without(fields, _key);
	  }
	  return without(fields, path);
	};
	
	exports.default = removeField;

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _fieldValue = __webpack_require__(45);
	
	var reset = function reset(value) {
	  return (0, _fieldValue.makeFieldValue)(value === undefined || value && value.initial === undefined ? {} : { initial: value.initial, value: value.initial });
	};
	
	/**
	 * Sets the initial values into the state and returns a new copy of the state
	 */
	var resetState = function resetState(values) {
	  return values ? Object.keys(values).reduce(function (accumulator, key) {
	    var value = values[key];
	    if (Array.isArray(value)) {
	      accumulator[key] = value.map(function (item) {
	        return (0, _fieldValue.isFieldValue)(item) ? reset(item) : resetState(item);
	      });
	    } else if (value) {
	      if ((0, _fieldValue.isFieldValue)(value)) {
	        accumulator[key] = reset(value);
	      } else if (typeof value === 'object' && value !== null) {
	        accumulator[key] = resetState(value);
	      } else {
	        accumulator[key] = value;
	      }
	    }
	    return accumulator;
	  }, {}) : values;
	};
	
	exports.default = resetState;

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _fieldValue = __webpack_require__(45);
	
	var isMetaKey = function isMetaKey(key) {
	  return key[0] === '_';
	};
	
	/**
	 * Sets an error on a field deep in the tree, returning a new copy of the state
	 */
	var setErrors = function setErrors(state, errors, destKey) {
	  var clear = function clear() {
	    if (Array.isArray(state)) {
	      return state.map(function (stateItem, index) {
	        return setErrors(stateItem, errors && errors[index], destKey);
	      });
	    }
	    if (state && typeof state === 'object') {
	      var result = Object.keys(state).reduce(function (accumulator, key) {
	        var _extends2;
	
	        return isMetaKey(key) ? accumulator : _extends({}, accumulator, (_extends2 = {}, _extends2[key] = setErrors(state[key], errors && errors[key], destKey), _extends2));
	      }, state);
	      if ((0, _fieldValue.isFieldValue)(state)) {
	        (0, _fieldValue.makeFieldValue)(result);
	      }
	      return result;
	    }
	    return (0, _fieldValue.makeFieldValue)(state);
	  };
	  if (typeof File !== 'undefined' && state instanceof File) {
	    return state;
	  }
	  if (!errors) {
	    if (!state) {
	      return state;
	    }
	    if (state[destKey]) {
	      var copy = _extends({}, state);
	      delete copy[destKey];
	      return (0, _fieldValue.makeFieldValue)(copy);
	    }
	    return clear();
	  }
	  if (typeof errors === 'string') {
	    var _extends3;
	
	    return (0, _fieldValue.makeFieldValue)(_extends({}, state, (_extends3 = {}, _extends3[destKey] = errors, _extends3)));
	  }
	  if (Array.isArray(errors)) {
	    if (!state || Array.isArray(state)) {
	      var _ret = function () {
	        var copy = (state || []).map(function (stateItem, index) {
	          return setErrors(stateItem, errors[index], destKey);
	        });
	        errors.forEach(function (errorItem, index) {
	          return copy[index] = setErrors(copy[index], errorItem, destKey);
	        });
	        return {
	          v: copy
	        };
	      }();
	
	      if (typeof _ret === "object") return _ret.v;
	    }
	    return setErrors(state, errors[0], destKey); // use first error
	  }
	  if ((0, _fieldValue.isFieldValue)(state)) {
	    var _extends4;
	
	    return (0, _fieldValue.makeFieldValue)(_extends({}, state, (_extends4 = {}, _extends4[destKey] = errors, _extends4)));
	  }
	  var errorKeys = Object.keys(errors);
	  if (!errorKeys.length && !state) {
	    return state;
	  }
	  return errorKeys.reduce(function (accumulator, key) {
	    var _extends5;
	
	    return isMetaKey(key) ? accumulator : _extends({}, accumulator, (_extends5 = {}, _extends5[key] = setErrors(state && state[key], errors[key], destKey), _extends5));
	  }, clear() || {});
	};
	
	exports.default = setErrors;

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isPromise = __webpack_require__(111);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noop = function noop() {
	  return undefined;
	};
	
	var silencePromise = function silencePromise(promise) {
	  return (0, _isPromise2.default)(promise) ? promise.then(noop, noop) : promise;
	};
	
	exports.default = silencePromise;

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isPristine = __webpack_require__(468);
	
	var _isPristine2 = _interopRequireDefault(_isPristine);
	
	var _isValid = __webpack_require__(77);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Updates a field object from the store values
	 */
	var updateField = function updateField(field, formField, active, syncError) {
	  var diff = {};
	  var formFieldValue = formField.value === undefined ? '' : formField.value;
	
	  // update field value
	  if (field.value !== formFieldValue) {
	    diff.value = formFieldValue;
	    diff.checked = typeof formFieldValue === 'boolean' ? formFieldValue : undefined;
	  }
	
	  // update dirty/pristine
	  var pristine = (0, _isPristine2.default)(formFieldValue, formField.initial);
	  if (field.pristine !== pristine) {
	    diff.dirty = !pristine;
	    diff.pristine = pristine;
	  }
	
	  // update field error
	  var error = syncError || formField.submitError || formField.asyncError;
	  if (error !== field.error) {
	    diff.error = error;
	  }
	  var valid = (0, _isValid2.default)(error);
	  if (field.valid !== valid) {
	    diff.invalid = !valid;
	    diff.valid = valid;
	  }
	
	  if (active !== field.active) {
	    diff.active = active;
	  }
	  var touched = !!formField.touched;
	  if (touched !== field.touched) {
	    diff.touched = touched;
	  }
	  var visited = !!formField.visited;
	  if (visited !== field.visited) {
	    diff.visited = visited;
	  }
	  var autofilled = !!formField.autofilled;
	  if (autofilled !== field.autofilled) {
	    diff.autofilled = autofilled;
	  }
	
	  if ('initial' in formField && formField.initial !== field.initialValue) {
	    field.initialValue = formField.initial;
	  }
	
	  return Object.keys(diff).length ? _extends({}, field, diff) : field;
	};
	exports.default = updateField;

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(64);
	
	var wrapMapDispatchToProps = function wrapMapDispatchToProps(mapDispatchToProps, actionCreators) {
	  if (mapDispatchToProps) {
	    if (typeof mapDispatchToProps === 'function') {
	      if (mapDispatchToProps.length > 1) {
	        return function (dispatch, ownProps) {
	          return _extends({
	            dispatch: dispatch
	          }, mapDispatchToProps(dispatch, ownProps), (0, _redux.bindActionCreators)(actionCreators, dispatch));
	        };
	      }
	      return function (dispatch) {
	        return _extends({
	          dispatch: dispatch
	        }, mapDispatchToProps(dispatch), (0, _redux.bindActionCreators)(actionCreators, dispatch));
	      };
	    }
	    return function (dispatch) {
	      return _extends({
	        dispatch: dispatch
	      }, (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch), (0, _redux.bindActionCreators)(actionCreators, dispatch));
	    };
	  }
	  return function (dispatch) {
	    return _extends({
	      dispatch: dispatch
	    }, (0, _redux.bindActionCreators)(actionCreators, dispatch));
	  };
	};
	
	exports.default = wrapMapDispatchToProps;

/***/ },
/* 478 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var wrapMapStateToProps = function wrapMapStateToProps(mapStateToProps, getForm) {
	  if (mapStateToProps) {
	    if (typeof mapStateToProps !== 'function') {
	      throw new Error('mapStateToProps must be a function');
	    }
	    if (mapStateToProps.length > 1) {
	      return function (state, ownProps) {
	        return _extends({}, mapStateToProps(state, ownProps), {
	          form: getForm(state)
	        });
	      };
	    }
	    return function (state) {
	      return _extends({}, mapStateToProps(state), {
	        form: getForm(state)
	      });
	    };
	  }
	  return function (state) {
	    return {
	      form: getForm(state)
	    };
	  };
	};
	
	exports.default = wrapMapStateToProps;

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(56);
	var callBind = __webpack_require__(98);
	
	var implementation = __webpack_require__(299);
	var getPolyfill = __webpack_require__(300);
	var shim = __webpack_require__(480);
	
	var flagsBound = callBind(getPolyfill());
	
	define(flagsBound, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = flagsBound;


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var supportsDescriptors = __webpack_require__(56).supportsDescriptors;
	var getPolyfill = __webpack_require__(300);
	var gOPD = Object.getOwnPropertyDescriptor;
	var defineProperty = Object.defineProperty;
	var TypeErr = TypeError;
	var getProto = Object.getPrototypeOf;
	var regex = /a/;
	
	module.exports = function shimFlags() {
		if (!supportsDescriptors || !getProto) {
			throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		var polyfill = getPolyfill();
		var proto = getProto(regex);
		var descriptor = gOPD(proto, 'flags');
		if (!descriptor || descriptor.get !== polyfill) {
			defineProperty(proto, 'flags', {
				configurable: true,
				enumerable: false,
				get: polyfill
			});
		}
		return polyfill;
	};


/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(57);
	var define = __webpack_require__(105);
	var hasDescriptors = __webpack_require__(109)();
	var gOPD = __webpack_require__(171);
	
	var $TypeError = __webpack_require__(43);
	var $floor = GetIntrinsic('%Math.floor%');
	
	/** @type {import('.')} */
	module.exports = function setFunctionLength(fn, length) {
		if (typeof fn !== 'function') {
			throw new $TypeError('`fn` is not a function');
		}
		if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
			throw new $TypeError('`length` must be a positive 32-bit integer');
		}
	
		var loose = arguments.length > 2 && !!arguments[2];
	
		var functionLengthIsConfigurable = true;
		var functionLengthIsWritable = true;
		if ('length' in fn && gOPD) {
			var desc = gOPD(fn, 'length');
			if (desc && !desc.configurable) {
				functionLengthIsConfigurable = false;
			}
			if (desc && !desc.writable) {
				functionLengthIsWritable = false;
			}
		}
	
		if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
			if (hasDescriptors) {
				define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
			} else {
				define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
			}
		}
		return fn;
	};


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(105);
	var hasDescriptors = __webpack_require__(109)();
	var functionsHaveConfigurableNames = __webpack_require__(432).functionsHaveConfigurableNames();
	
	var $TypeError = __webpack_require__(43);
	
	/** @type {import('.')} */
	module.exports = function setFunctionName(fn, name) {
		if (typeof fn !== 'function') {
			throw new $TypeError('`fn` is not a function');
		}
		var loose = arguments.length > 2 && !!arguments[2];
		if (!loose || functionsHaveConfigurableNames) {
			if (hasDescriptors) {
				define(/** @type {Parameters<define>[0]} */ (fn), 'name', name, true, true);
			} else {
				define(/** @type {Parameters<define>[0]} */ (fn), 'name', name);
			}
		}
		return fn;
	};


/***/ },
/* 483 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TOGGLE_ONE_CLICK_MODE = exports.TOGGLE_ONE_CLICK_MODE = 'TOGGLE_ONE_CLICK_MODE';
	var SET_ONE_CLICK_AMOUNT = exports.SET_ONE_CLICK_AMOUNT = 'SET_ONE_CLICK_AMOUNT';
	var SET_ACCEPT_FACTOR_CHANGE_MODE = exports.SET_ACCEPT_FACTOR_CHANGE_MODE = 'SET_ACCEPT_FACTOR_CHANGE_MODE';
	var TOGGLE_ACCEPT_FACTOR_INCREASE = exports.TOGGLE_ACCEPT_FACTOR_INCREASE = 'TOGGLE_ACCEPT_FACTOR_INCREASE';
	var TOGGLE_ACCEPT_FACTOR_DECREASE = exports.TOGGLE_ACCEPT_FACTOR_DECREASE = 'TOGGLE_ACCEPT_FACTOR_DECREASE';
	var SET_FAVOURITE_BET_AMOUNT = exports.SET_FAVOURITE_BET_AMOUNT = 'SET_FAVOURITE_BET_AMOUNT';

/***/ },
/* 484 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TOGGLE_GROUP = exports.TOGGLE_GROUP = 'TOGGLE_GROUP';
	var EXPAND_GROUP = exports.EXPAND_GROUP = 'EXPAND_GROUP';

/***/ },
/* 485 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TOGGLE_MATCH = exports.TOGGLE_MATCH = 'TOGGLE_MATCH';

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.getFreebet = getFreebet;
	exports.toggleFreebet = toggleFreebet;
	
	var _api = __webpack_require__(13);
	
	var _Freebet = __webpack_require__(559);
	
	var ActionTypes = _interopRequireWildcard(_Freebet);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getFreebet() {
	    return function (dispatch) {
	        return dispatch((0, _defineProperty3.default)({
	            type: ActionTypes.GET_FREEBET
	        }, _api.CALL_API, {
	            endpoint: '/api/gambler/freebet',
	            method: 'get',
	            types: [ActionTypes.SUCCESS_GET_FREEBET, ActionTypes.FAILURE_GET_FREEBET],
	            credentials: true
	        }));
	    };
	}
	
	function toggleFreebet(data) {
	    return { type: ActionTypes.TOGGLE_FREEBET, data: data };
	}

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.beginPasswordRecovery = beginPasswordRecovery;
	exports.cancelPasswordRecovery = cancelPasswordRecovery;
	exports.recoverPassword = recoverPassword;
	exports.recoverPasswordViaPhone = recoverPasswordViaPhone;
	
	var _api = __webpack_require__(13);
	
	var _PasswordRecovery = __webpack_require__(303);
	
	var ActionTypes = _interopRequireWildcard(_PasswordRecovery);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function beginPasswordRecovery() {
	    return { type: ActionTypes.BEGIN_PASSWORD_RECOVERY };
	}
	
	function cancelPasswordRecovery() {
	    return { type: ActionTypes.CANCEL_PASSWORD_RECOVERY };
	}
	
	function recoverPassword(data) {
	    return (0, _defineProperty3.default)({
	        type: ActionTypes.RECOVER_PASSWORD
	    }, _api.CALL_API, {
	        endpoint: '/api/gambler/recover-password',
	        method: 'post',
	        types: [ActionTypes.SUCCESS_RECOVER_PASSWORD, ActionTypes.FAILURE_RECOVER_PASSWORD],
	        data: data
	    });
	}
	
	function recoverPasswordViaPhone(data) {
	    return (0, _defineProperty3.default)({
	        type: ActionTypes.PHONE_RECOVER_PASSWORD
	    }, _api.CALL_API, {
	        endpoint: '/api/gambler/phone-recover',
	        method: 'post',
	        types: [ActionTypes.SUCCESS_PHONE_RECOVER_PASSWORD, ActionTypes.FAILURE_PHONE_RECOVER_PASSWORD],
	        data: data
	    });
	}

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.createPhoneConfirmation = createPhoneConfirmation;
	exports.confirmPhone = confirmPhone;
	exports.denyConfirmation = denyConfirmation;
	
	var _api = __webpack_require__(13);
	
	var _PhoneConfirmation = __webpack_require__(156);
	
	var Actions = _interopRequireWildcard(_PhoneConfirmation);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchPhoneConfirmation(data) {
	    var gamblerId = data.gamblerId,
	        newPhone = data.newPhone,
	        oldPhone = data.oldPhone;
	
	    return (0, _defineProperty3.default)({
	        type: Actions.CREATE_PHONE_CONFIRMATION
	    }, _api.CALL_API, {
	        endpoint: '/api/gambler/' + gamblerId + '/phone/create?newPhone=' + newPhone + '&oldPhone=' + oldPhone,
	        method: 'post',
	        types: [Actions.SUCCESS_CREATE_PHONE_CONFIRMATION, Actions.FAILURE_CREATE_PHONE_CONFIRMATION],
	        credentials: true,
	        data: data
	    });
	}
	
	function createPhoneConfirmation(data) {
	    return function (dispatch) {
	        dispatch(fetchPhoneConfirmation(data));
	    };
	}
	
	function fetchConfirmPhone(data) {
	    var gamblerId = data.gamblerId,
	        code = data.code,
	        authorize = data.authorize;
	
	    return (0, _defineProperty3.default)({
	        type: Actions.CONFIRM_PHONE
	    }, _api.CALL_API, {
	        endpoint: '/api/gambler/' + gamblerId + '/phone/confirm?code=' + code + '&authorize=' + authorize,
	        method: 'post',
	        types: [Actions.SUCCESS_CONFIRM_PHONE, Actions.FAILURE_CONFIRM_PHONE],
	        credentials: true,
	        data: data
	    });
	}
	
	function confirmPhone(data) {
	    return function (dispatch) {
	        dispatch(fetchConfirmPhone(data));
	    };
	}
	
	function denyConfirmation() {
	    return { type: Actions.DENY_CONFIRMATION };
	}

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.toggleSportMain = toggleSportMain;
	exports.toggleSportPrematch = toggleSportPrematch;
	exports.toggleLeaguePrematch = toggleLeaguePrematch;
	exports.toggleMatchPrematch = toggleMatchPrematch;
	exports.showAllPrematch = showAllPrematch;
	exports.toggleSportLive = toggleSportLive;
	exports.toggleLeagueLive = toggleLeagueLive;
	exports.toggleMatchLive = toggleMatchLive;
	exports.showAllLive = showAllLive;
	
	var _UserSelection = __webpack_require__(709);
	
	var ActionTypes = _interopRequireWildcard(_UserSelection);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function toggleSportMain(data) {
	    return { type: ActionTypes.USER_SELECTION_TOGGLE_SPORT, section: 'main', data: data };
	}
	
	function toggleSportPrematch(data) {
	    return { type: ActionTypes.USER_SELECTION_TOGGLE_SPORT, section: 'preMatch', data: data };
	}
	
	function toggleLeaguePrematch(data) {
	    return { type: ActionTypes.USER_SELECTION_TOGGLE_LEAGUE, section: 'preMatch', data: data };
	}
	
	function toggleMatchPrematch(data) {
	    return { type: ActionTypes.USER_SELECTION_TOGGLE_MATCH, section: 'preMatch', data: data };
	}
	
	function showAllPrematch(data) {
	    return { type: ActionTypes.USER_SELECTION_SHOW_ALL, section: 'preMatch', data: data };
	}
	
	function toggleSportLive(data) {
	    return { type: ActionTypes.USER_SELECTION_TOGGLE_SPORT, section: 'live', data: data };
	}
	
	function toggleLeagueLive(data) {
	    return { type: ActionTypes.USER_SELECTION_TOGGLE_LEAGUE, section: 'live', data: data };
	}
	
	function toggleMatchLive(data) {
	    return { type: ActionTypes.USER_SELECTION_TOGGLE_MATCH, section: 'live', data: data };
	}
	
	function showAllLive(data) {
	    return { type: ActionTypes.USER_SELECTION_SHOW_ALL, section: 'live', data: data };
	}

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.createPassword = createPassword;
	exports.initCreatePassword = initCreatePassword;
	
	var _api = __webpack_require__(13);
	
	var _createPassword = __webpack_require__(384);
	
	var ActionTypes = _interopRequireWildcard(_createPassword);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createPassword(data) {
	    return (0, _defineProperty3.default)({
	        type: ActionTypes.CREATE_PASSWORD
	    }, _api.CALL_API, {
	        endpoint: '/api/passwd',
	        method: 'post',
	        types: [ActionTypes.SUCCESS_CREATE_PASSWORD, ActionTypes.SUCCESS_CREATE_PASSWORD],
	        credentials: true,
	        data: data
	    });
	}
	
	function initCreatePassword() {
	    return { type: ActionTypes.INIT_CREATE_PASSWORD };
	}

/***/ },
/* 491 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FETCH_PROMOCODE_ACTIVATE = exports.FETCH_PROMOCODE_ACTIVATE = 'FETCH_PROMOCODE_ACTIVATE';
	var SUCCESS_FETCH_PROMOCODE_ACTIVATE = exports.SUCCESS_FETCH_PROMOCODE_ACTIVATE = 'SUCCESS_FETCH_PROMOCODE_ACTIVATE';
	var FAILURE_FETCH_PROMOCODE_ACTIVATE = exports.FAILURE_FETCH_PROMOCODE_ACTIVATE = 'FAILURE_FETCH_PROMOCODE_ACTIVATE';

/***/ },
/* 492 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.openBetsolutionGameWindow = openBetsolutionGameWindow;
	var ORIGIN = window.location.origin;
	var SLOTS_HOME_URL = "homeurl=" + ORIGIN + "/games/slots";
	var VIVO_OPERATOR_ID = 1000138;
	
	var getTomhornGamesURL = exports.getTomhornGamesURL = function getTomhornGamesURL(_ref) {
	  var _ref$serverId = _ref.serverId,
	      serverId = _ref$serverId === undefined ? 6401748 : _ref$serverId,
	      token = _ref.token,
	      _ref$langType = _ref.langType,
	      langType = _ref$langType === undefined ? "en" : _ref$langType,
	      gameID = _ref.gameID;
	
	  if (!token) {
	    return "https://s4.toogri.com/cwguestlogin.do?bankId=92C339E8-14B5-4572-8B8E-C030E1E0300A&gameID=" + gameID + "&lang=" + langType + "&" + SLOTS_HOME_URL;
	  }
	  return "https://www.2vivo.com/FlashRunGame/Prod/RunTomHornGame.aspx?GameID=" + gameID + "&serverid=" + serverId + "&Token=" + token + "&lang=" + langType + "&OperatorID=" + VIVO_OPERATOR_ID + "&" + SLOTS_HOME_URL;
	};
	
	var getBetsoftGamesURL = exports.getBetsoftGamesURL = function getBetsoftGamesURL(_ref2) {
	  var _ref2$serverId = _ref2.serverId,
	      serverId = _ref2$serverId === undefined ? 6401748 : _ref2$serverId,
	      token = _ref2.token,
	      _ref2$langType = _ref2.langType,
	      langType = _ref2$langType === undefined ? "en" : _ref2$langType,
	      gameID = _ref2.gameID;
	
	  if (!token) {
	    return "https://streamtech-c2ss.betsoftgaming.com/cwguestlogin.do?gameId=" + gameID + "&lang=" + langType + "&bankId=ED";
	  }
	  return "https://www.2vivo.com/FlashRunGame/RunRngGame.aspx?Token=" + token + "&serverid=" + serverId + "&lang=" + langType + "&operatorID=" + VIVO_OPERATOR_ID + "&gameID=" + gameID;
	};
	
	var getVirtualSportsGamesURL = exports.getVirtualSportsGamesURL = function getVirtualSportsGamesURL(_ref3) {
	  var gameType = _ref3.gameType,
	      gamblerId = _ref3.gamblerId,
	      token = _ref3.token,
	      _ref3$lang = _ref3.lang,
	      lang = _ref3$lang === undefined ? "en" : _ref3$lang;
	
	  if (!token) {
	    return "https://rgs.betradar.com/bgw-auth-generic/auth/register?key=BLrLziTdLaenpyTM&gameType=" + gameType + "&lang=" + lang;
	  }
	  return "https://rgs.betradar.com/bgw-auth-generic/auth/register?key=BLrLziTdLaenpyTM&gameType=" + gameType + "&lang=" + lang + "&clientId=" + gamblerId + "&id=" + token;
	};
	
	function openBetsolutionGameWindow(config) {
	  if (window.BETSOLUTION_GAME_WINDOW) {
	    window.BETSOLUTION_GAME_WINDOW.close();
	  }
	
	  var startUrl = window.Charismatic.Casino.GameStarter.getGameStartUrl(config);
	  window.BETSOLUTION_GAME_WINDOW = window.open(startUrl, 'Betsolutions', 'width=1600,height=900,menubar=no,toolbar=no,location=no');
	}

/***/ },
/* 493 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NOT_FOUND = exports.NOT_FOUND = -1;
	var NOT_ACTIVATED = exports.NOT_ACTIVATED = -2;
	var BLOCKED = exports.BLOCKED = -5;
	var WRONG_CERT = exports.WRONG_CERT = -3;
	var WRONG_PASSWORD = exports.WRONG_PASSWORD = -4;

/***/ },
/* 494 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CONNECTED = exports.CONNECTED = 1;
	var DISCONNECTED = exports.DISCONNECTED = 2;

/***/ },
/* 495 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SITE146 = exports.SITE146 = 1;

/***/ },
/* 496 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var maxWinAmount = exports.maxWinAmount = {
	    KGS: 3000000,
	    RUR: 2500000,
	    TJS: 3500000,
	    KZT: 15000000,
	    USD: 45000,
	    EUR: 40000,
	    GBP: 35000
	};

/***/ },
/* 497 */,
/* 498 */,
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(406);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _Locales = __webpack_require__(80);
	
	var _Locales2 = _interopRequireDefault(_Locales);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var translations = {
	  en: {
	    verify_modal_text_1: 'According to the legislation of the Republic of Kazakhstan, in order to place a bet, you must be identified on our website.',
	    verify_modal_text_2: 'To do this, send a photo of the front and back of the identity card, as well as a selfie with the document.',
	    verify_modal_text_3: 'We accept the following documents:',
	    verify_modal__sub_text_1: 'RK ID',
	    verify_modal__sub_text_2: 'Passport of the Republic of Kazakhstan',
	    verify_modal__sub_text_3: 'Residence permit of the Republic of Kazakhstan',
	    verify_modal__sub_text_4: 'Document of a foreign citizen'
	  },
	  ru: {
	    verify_modal_text_1: 'Согласно законодательству Республики Казахстан, для заключения пари необходимо быть идентифицированным на нашем сайте.',
	    verify_modal_text_2: 'Для этого загрузите лицевую и оборотную стороны удостоверения личности, а также селфи с документом.',
	    verify_modal_text_3: 'Мы принимаем следующие документы:',
	    verify_modal__sub_text_1: 'Удостоверение личности РК',
	    verify_modal__sub_text_2: 'Паспорт РК',
	    verify_modal__sub_text_3: 'Вид на жительство РК',
	    verify_modal__sub_text_4: 'Документ иностранного гражданина'
	  },
	  kk: {
	    verify_modal_text_1: 'Қазақстан Республикасының заңнамасына сәйкес бәс тігу үшін сіз біздің веб сайтта анықталуыңыз керек.',
	    verify_modal_text_2: 'Ол үшін жеке куәлігіңіздің алдыңғы және артқы жағындағы фотосуретті , сонымен қатар селфиді жүктеңіз.',
	    verify_modal_text_3: 'Біз келесі құжаттарды қабылдаймыз:',
	    verify_modal__sub_text_1: 'Қазақстан Республикасының жеке куәлігі',
	    verify_modal__sub_text_2: 'Қазақстан Республикасының төлқұжаты',
	    verify_modal__sub_text_3: 'ҚР да тұруға ықтиярхаты',
	    verify_modal__sub_text_4: 'Шетелдік азаматтың құжаты'
	  },
	  uz: {
	    verify_modal_text_1: 'According to the legislation of the Republic of Kazakhstan, in order to place a bet, you must be identified on our website.',
	    verify_modal_text_2: 'To do this, send a photo of the front and back of the identity card, as well as a selfie with the document.',
	    verify_modal_text_3: 'We accept the following documents:',
	    verify_modal__sub_text_1: 'RK ID',
	    verify_modal__sub_text_2: 'Passport of the Republic of Kazakhstan',
	    verify_modal__sub_text_3: 'Residence permit of the Republic of Kazakhstan',
	    verify_modal__sub_text_4: 'Document of a foreign citizen'
	  }
	};
	
	function toggleVerifyModal(show) {
	  var modalEl = document.getElementById('verify-modal');
	  console.log('toggleVerifyModal: ' + show);
	  if (modalEl) {
	    modalEl.style.display = show ? 'flex' : 'none';
	  }
	}
	
	window.toggleVerifyModal = toggleVerifyModal;
	
	// const showRoutes = ['/balance/withdraw', '/balance/recharge', '/']
	var hideRoutes = ['/identify'];
	
	var VerifyModal = function (_React$Component) {
	  (0, _inherits3.default)(VerifyModal, _React$Component);
	
	  function VerifyModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, VerifyModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = VerifyModal.__proto__ || (0, _getPrototypeOf2.default)(VerifyModal)).call.apply(_ref, [this].concat(args))), _this), _this.handleClose = function () {
	      var _window$location = window.location,
	          protocol = _window$location.protocol,
	          host = _window$location.host;
	
	      var _host$split$reverse = host.split('.').reverse(),
	          _host$split$reverse2 = (0, _slicedToArray3.default)(_host$split$reverse, 2),
	          zone = _host$split$reverse2[0],
	          domain = _host$split$reverse2[1];
	
	      window.location.assign(protocol + '//' + domain + '.' + zone + '/identify');
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(VerifyModal, [{
	    key: 'render',
	    value: function render() {
	      var languageId = this.props.languageId;
	      // if (!showRoutes.includes(window.location.pathname)) return null
	
	      if (hideRoutes.includes(window.location.pathname)) return null;
	
	      var texts = translations[_Locales2.default[languageId]] || {};
	
	      return _react2.default.createElement(
	        'div',
	        {
	          id: 'verify-modal',
	          style: {
	            position: 'fixed',
	            width: '100vw',
	            height: '100vh',
	            top: 0,
	            right: 0,
	            bottom: 0,
	            left: 0,
	            zIndex: 9999,
	            display: 'none',
	            alignItems: 'center',
	            justifyContent: 'center'
	          }
	        },
	        _react2.default.createElement('div', {
	          style: {
	            position: 'absolute',
	            width: '100%',
	            height: '100%',
	            backgroundColor: 'rgba(0,0,0,0.3)',
	            zIndex: 1
	          }
	        }),
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              maxWidth: 400,
	              backgroundColor: '#fff',
	              padding: 20,
	              borderRadius: 10,
	              zIndex: 2,
	              fontSize: 16,
	              marginBottom: 15,
	              fontWeight: 'bold'
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                margin: '0 auto',
	                display: 'flex',
	                justifyContent: 'center',
	                marginBottom: 10
	              }
	            },
	            _react2.default.createElement(
	              'svg',
	              { width: '50px', height: '50px', viewBox: '0 0 21 21', xmlns: 'http://www.w3.org/2000/svg' },
	              _react2.default.createElement(
	                'g',
	                { fill: 'none', fillRule: 'evenodd' },
	                _react2.default.createElement('circle', { cx: '10.5', cy: '10.5', r: '8', stroke: '#A1A1A1', strokeLinecap: 'round', strokeLinejoin: 'round' }),
	                _react2.default.createElement('path', { d: 'm10.5 11.5v-5', stroke: '#A1A1A1', strokeLinecap: 'round', strokeLinejoin: 'round' }),
	                _react2.default.createElement('circle', { cx: '10.5', cy: '14.5', fill: '#A1A1A1', r: '1' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { marginBottom: 15 } },
	            texts.verify_modal_text_1
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { marginBottom: 15 } },
	            texts.verify_modal_text_2
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { marginBottom: 15 } },
	            texts.verify_modal_text_3
	          ),
	          _react2.default.createElement(
	            'ul',
	            {
	              style: {
	                margin: '0 auto',
	                fontSize: 16,
	                width: '80%',
	                listStyle: 'unset'
	              }
	            },
	            _react2.default.createElement(
	              'li',
	              null,
	              texts.verify_modal__sub_text_1
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              texts.verify_modal__sub_text_2
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              texts.verify_modal__sub_text_3
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              texts.verify_modal__sub_text_4
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn',
	              onClick: this.handleClose,
	              style: {
	                width: '100%',
	                height: 45,
	                backgroundColor: '#025A34',
	                color: '#fff',
	                fontSize: 18,
	                fontWeight: 'normal',
	                marginTop: 20,
	                border: 'none',
	                cursor: 'pointer'
	              }
	            },
	            'OK'
	          )
	        )
	      );
	    }
	  }]);
	  return VerifyModal;
	}(_react2.default.Component);
	
	function select(state) {
	  var languageId = state.application.get('languageId');
	  return {
	    languageId: languageId
	  };
	}
	exports.default = (0, _reactRedux.connect)(select)(VerifyModal);

/***/ },
/* 500 */,
/* 501 */,
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function renderElement(elem, index) {
	    return _react2.default.createElement(
	        'li',
	        { key: index, className: 'dropdown--menu__item' },
	        elem.content
	    );
	}
	
	var _class = function (_React$Component) {
	    (0, _inherits3.default)(_class, _React$Component);
	
	    function _class(props) {
	        (0, _classCallCheck3.default)(this, _class);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, props));
	
	        _this._onDocumentClick = _this._onDocumentClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(_class, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            document.addEventListener('click', this._onDocumentClick);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener('click', this._onDocumentClick);
	        }
	    }, {
	        key: '_onDocumentClick',
	        value: function _onDocumentClick() {
	            document.removeEventListener('click', this._onDocumentClick);
	
	            this.props.onClosing();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                cssClass = _props.cssClass,
	                title = _props.title,
	                elements = _props.elements;
	
	
	            var cls = 'dropdown--menu ' + cssClass + ' dropdown--menu__shown';
	
	            return _react2.default.createElement(
	                'ul',
	                { className: cls },
	                _react2.default.createElement(
	                    'li',
	                    { className: 'title dropdown--menu__title dropdown--menu__item' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'dropdown--menu__span' },
	                        title
	                    )
	                ),
	                elements.filter(function (s) {
	                    return Boolean(s);
	                }).map(renderElement)
	            );
	        }
	    }]);
	    return _class;
	}(_react2.default.Component);
	
	_class.propTypes = {
	    cssClass: _react2.default.PropTypes.string.isRequired,
	    title: _react2.default.PropTypes.object.isRequired,
	    elements: _react2.default.PropTypes.array.isRequired,
	    onClosing: _react2.default.PropTypes.func.isRequired
	};
	exports.default = _class;

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _immutable = __webpack_require__(14);
	
	var _reactIntl = __webpack_require__(8);
	
	var _BetType = __webpack_require__(46);
	
	var BetTypes = _interopRequireWildcard(_BetType);
	
	var _CouponState = __webpack_require__(750);
	
	var CouponState = _interopRequireWildcard(_CouponState);
	
	var _CouponRate = __webpack_require__(72);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    ordinar: {
	        id: 'bet_type.ordinar',
	        defaultMessage: 'Ординар'
	    },
	    accumulator: {
	        id: 'bet_type.accumulator',
	        defaultMessage: 'Экспресс'
	    },
	    looseToWinAccumulator: {
	        id: 'bet_type.looseToWinAccumulator',
	        defaultMessage: 'Антиэкспресс'
	    },
	    system: {
	        id: 'bet_type.system',
	        defaultMessage: 'Система {rank} из {count}'
	    },
	    betType: {
	        id: 'coupon.bet_type_hint',
	        defaultMessage: 'Тип ставки'
	    }
	});
	
	var BetType = function (_React$Component) {
	    (0, _inherits3.default)(BetType, _React$Component);
	    (0, _createClass3.default)(BetType, null, [{
	        key: 'renderBetType',
	        value: function renderBetType(betType, index) {
	            var message = null;
	
	            switch (betType.type) {
	                case BetTypes.SINGLE:
	                    message = messages.ordinar;
	                    break;
	
	                case BetTypes.EXPRESS:
	                    message = messages.accumulator;
	                    break;
	
	                case BetTypes.SYSTEM:
	                    message = messages.system;
	                    break;
	
	                case BetTypes.ANTIEXPRESS:
	                    message = messages.looseToWinAccumulator;
	                    break;
	            }
	
	            return _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                (0, _extends3.default)({ key: index }, message, { values: betType }),
	                function (message) {
	                    return _react2.default.createElement(
	                        'option',
	                        { value: index },
	                        message
	                    );
	                }
	            );
	        }
	    }]);
	
	    function BetType(props) {
	        (0, _classCallCheck3.default)(this, BetType);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (BetType.__proto__ || (0, _getPrototypeOf2.default)(BetType)).call(this, props));
	
	        _this._onBetTypeChanged = _this._onBetTypeChanged.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(BetType, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return nextProps.languageId !== this.props.languageId || this.props.betTypes !== nextProps.betTypes || this.props.couponState !== nextProps.couponState || this.props.currentBetTypeIndex !== nextProps.currentBetTypeIndex;
	        }
	    }, {
	        key: '_onBetTypeChanged',
	        value: function _onBetTypeChanged(e) {
	            e.preventDefault();
	
	            var index = parseInt(e.target.value);
	
	            this.props.setCouponBetTypeAction(index);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                betTypes = _props.betTypes,
	                currentBetTypeIndex = _props.currentBetTypeIndex,
	                couponState = _props.couponState;
	
	
	            if (couponState === CouponState.DISABLED || currentBetTypeIndex === -1) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'bet-type' },
	                    _react2.default.createElement('select', { disabled: 'disabled' }),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'select-chevron-down' },
	                        '\xA0'
	                    )
	                );
	            }
	
	            return _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                messages.betType,
	                function (message) {
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'bet-type', title: message },
	                        _react2.default.createElement(
	                            'select',
	                            { value: currentBetTypeIndex, onChange: _this2._onBetTypeChanged },
	                            betTypes.map(function (bt) {
	                                return BetType.renderBetType(bt, betTypes.indexOf(bt));
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'select-chevron-down' },
	                            '\xA0'
	                        )
	                    );
	                }
	            );
	        }
	    }]);
	    return BetType;
	}(_react2.default.Component);
	
	BetType.propTypes = {
	    languageId: _react2.default.PropTypes.number.isRequired,
	    betTypes: _react2.default.PropTypes.instanceOf(_immutable.List),
	    antiExpressOdd: _react2.default.PropTypes.number,
	    couponState: _react2.default.PropTypes.number.isRequired,
	    currentBetTypeIndex: _react2.default.PropTypes.number,
	    setCouponBetTypeAction: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select(state) {
	    var languageId = state.application.get('languageId');
	    var betTypes = state.application.getIn(['coupon', 'betTypes']);
	    var currentBetTypeIndex = state.application.getIn(['coupon', 'currentBetTypeIndex']);
	    var couponState = state.application.getIn(['coupon', 'state']);
	
	    return {
	        languageId: languageId,
	        betTypes: betTypes,
	        couponState: couponState,
	        currentBetTypeIndex: currentBetTypeIndex
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, { setCouponBetTypeAction: _CouponRate.setCouponBetType })(BetType);

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _classnames = __webpack_require__(61);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _accountResourceNames = __webpack_require__(59);
	
	var resources = _interopRequireWildcard(_accountResourceNames);
	
	var _StakeMinAmount = __webpack_require__(135);
	
	var _StakeMaxAmount = __webpack_require__(570);
	
	var _CouponDropDownMenu = __webpack_require__(306);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FavouriteBetAmount = function (_React$Component) {
	    (0, _inherits3.default)(FavouriteBetAmount, _React$Component);
	
	    function FavouriteBetAmount(props) {
	        (0, _classCallCheck3.default)(this, FavouriteBetAmount);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (FavouriteBetAmount.__proto__ || (0, _getPrototypeOf2.default)(FavouriteBetAmount)).call(this, props));
	
	        _this._onClick = _this._onClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(FavouriteBetAmount, [{
	        key: '_onClick',
	        value: function _onClick(e) {
	            e.preventDefault();
	            this.props.callback(this.props.amount);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                amount = _props.amount,
	                user = _props.user,
	                number = _props.number;
	
	            var cls = 'fav-bet-' + number;
	
	            var resourceId = void 0;
	            var currency = void 0;
	            var minStakeAmount = 0;
	            var maxStakeAmount = 0;
	
	            if (user) {
	                resourceId = user.get('resourceId');
	                currency = resources.resourceNames[resourceId];
	                minStakeAmount = _StakeMinAmount.minAmount[currency];
	                maxStakeAmount = _StakeMaxAmount.maxAmount[currency];
	            }
	
	            var disabled = user && (0, _CouponDropDownMenu.isMinAndMaxValueWrong)(minStakeAmount, maxStakeAmount, amount);
	
	            return _react2.default.createElement(
	                'a',
	                { href: '#', className: (0, _classnames2.default)(cls, { disabled: disabled }), onClick: disabled ? null : this._onClick },
	                amount
	            );
	        }
	    }]);
	    return FavouriteBetAmount;
	}(_react2.default.Component);
	
	FavouriteBetAmount.propTypes = {
	    amount: _react2.default.PropTypes.number.isRequired,
	    number: _react2.default.PropTypes.number.isRequired,
	    callback: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select(state) {
	    return {
	        countryCode: state.application.get('countryCode'),
	        user: state.auth.get('user')
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select)(FavouriteBetAmount);

/***/ },
/* 505 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isRateUnavailable = isRateUnavailable;
	exports.rateFactorChangeConfirmNeeded = rateFactorChangeConfirmNeeded;
	function isRateUnavailable(rate) {
	    var blockedBySport = rate.get('isBlockedBySport');
	    if (blockedBySport !== undefined && blockedBySport) {
	        return true;
	    }
	
	    var blockedByLeague = rate.get('isBlockedByLeague');
	    if (blockedByLeague !== undefined && blockedByLeague) {
	        return true;
	    }
	
	    var blockedByMatch = rate.get('isBlockedByMatch');
	    if (blockedByMatch !== undefined && blockedByMatch) {
	        return true;
	    }
	
	    var blockedByGroup = rate.get('isBlockedByGroup');
	    if (blockedByGroup !== undefined && blockedByGroup) {
	        return true;
	    }
	
	    var blockedByOutcome = rate.get('isBlockedByOutcome');
	
	    return !!(blockedByOutcome !== undefined && blockedByOutcome);
	}
	
	function rateFactorChangeConfirmNeeded(rate) {
	    var actualValue = rate.get('actualValue');
	    var originalValue = rate.get('value');
	    var blockedByRate = rate.get('isBlocked');
	
	    if (actualValue === undefined || blockedByRate === undefined || blockedByRate === false) {
	        return false;
	    }
	
	    return actualValue !== originalValue;
	}

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _BaseRate2 = __webpack_require__(341);
	
	var _CouponRate = __webpack_require__(72);
	
	var _MakeBet = __webpack_require__(133);
	
	var _HistoryBet = __webpack_require__(65);
	
	var _renderingCommons = __webpack_require__(137);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeaderRate = function (_BaseRate) {
	    (0, _inherits3.default)(HeaderRate, _BaseRate);
	
	    function HeaderRate(props) {
	        (0, _classCallCheck3.default)(this, HeaderRate);
	        return (0, _possibleConstructorReturn3.default)(this, (HeaderRate.__proto__ || (0, _getPrototypeOf2.default)(HeaderRate)).call(this, props));
	    }
	
	    (0, _createClass3.default)(HeaderRate, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                rate = _props.rate,
	                isInCoupon = _props.isInCoupon,
	                outcomeIsBlocked = _props.outcomeIsBlocked;
	
	
	            if (rate === undefined) {
	                return false;
	            }
	
	            var isVisible = rate.get('isVisible');
	            var rateValue = isVisible ? (0, _renderingCommons.getRateDisplayValue)(rate.get('value')) : '\xA0';
	
	            var cls = 'cell rate';
	
	            if (rate.get('isBlocked') || outcomeIsBlocked || !isVisible) {
	                cls += ' closed';
	            } else if (isInCoupon) {
	                cls += '--in-coupon';
	            }
	
	            var props = {
	                key: rate.get('id'),
	                ref: "rate",
	                className: cls
	            };
	
	            if (rate.get('isVisible')) {
	                props.onClick = this._onClick;
	            }
	
	            return _react2.default.createElement(
	                'span',
	                props,
	                rateValue
	            );
	        }
	    }]);
	    return HeaderRate;
	}(_BaseRate2.BaseRate);
	
	exports.default = (0, _reactRedux.connect)(_BaseRate2.mapStateToProps, {
	    addCouponRateAction: _CouponRate.addCouponRate, makeBetAction: _MakeBet.makeBet, requestBetTypesAction: _HistoryBet.requestBetTypes, addRateAction: _CouponRate.addRate
	}, null, false)(HeaderRate);

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _BaseRate2 = __webpack_require__(341);
	
	var _CouponRate = __webpack_require__(72);
	
	var _MakeBet = __webpack_require__(133);
	
	var _HistoryBet = __webpack_require__(65);
	
	var _renderingCommons = __webpack_require__(137);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegularRate = function (_BaseRate) {
	    (0, _inherits3.default)(RegularRate, _BaseRate);
	
	    function RegularRate(props) {
	        (0, _classCallCheck3.default)(this, RegularRate);
	        return (0, _possibleConstructorReturn3.default)(this, (RegularRate.__proto__ || (0, _getPrototypeOf2.default)(RegularRate)).call(this, props));
	    }
	
	    (0, _createClass3.default)(RegularRate, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                rate = _props.rate,
	                outcomeIsBlocked = _props.outcomeIsBlocked;
	
	
	            if (rate === undefined) {
	                return false;
	            }
	
	            var isVisible = rate.get('isVisible');
	
	            if (!isVisible) {
	                return false;
	            }
	
	            var rateName = rate.get('shortName');
	            var rateValue = (0, _renderingCommons.getRateDisplayValue)(rate.get('value'));
	
	            var isBlocked = rate.get('isBlocked') || outcomeIsBlocked;
	
	            var outCls = 'out' + (isBlocked ? ' closed' : '');
	            var rateCls = 'out-rate' + (isBlocked ? ' closed' : '');
	            var conditionCls = 'out-cond' + (isBlocked ? ' closed' : '');
	
	            return _react2.default.createElement(
	                'span',
	                { key: rate.get('id'), ref: 'rate', className: outCls, onClick: this._onClick },
	                _react2.default.createElement(
	                    'span',
	                    { className: conditionCls },
	                    rateName
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: rateCls },
	                    rateValue
	                )
	            );
	        }
	    }]);
	    return RegularRate;
	}(_BaseRate2.BaseRate);
	
	exports.default = (0, _reactRedux.connect)(_BaseRate2.mapStateToProps, {
	    addCouponRateAction: _CouponRate.addCouponRate, makeBetAction: _MakeBet.makeBet, requestBetTypesAction: _HistoryBet.requestBetTypes, addRateAction: _CouponRate.addRate
	}, null, false)(RegularRate);

/***/ },
/* 508 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SINGLE_OUTCOME = exports.SINGLE_OUTCOME = 1;
	var MULTI_OUTCOME = exports.MULTI_OUTCOME = 2;
	var WIDE_SINGLE_OUTCOME = exports.WIDE_SINGLE_OUTCOME = 3;
	var WIDE_MULTI_OUTCOME = exports.WIDE_MULTI_OUTCOME = 4;
	var TOTAL = exports.TOTAL = 5;
	var TENNIS_GAME = exports.TENNIS_GAME = 6;
	var SOCCER_MATCH_CORRECT_SCORE = exports.SOCCER_MATCH_CORRECT_SCORE = 7;
	var BASKETBALL_TOTAL_UNDER = exports.BASKETBALL_TOTAL_UNDER = 8;
	var BASKETBALL_TOTAL_OVER = exports.BASKETBALL_TOTAL_OVER = 9;
	var NAMED_OUTCOME_SLOT = exports.NAMED_OUTCOME_SLOT = 10;

/***/ },
/* 509 */,
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1416), __esModule: true };

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(598), __esModule: true };

/***/ },
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _scrollbar = __webpack_require__(1916);
	
	var _scrollbar2 = _interopRequireDefault(_scrollbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _scrollbar2.default;
	module.exports = exports['default'];

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEPRECATED_CONFIG_PROPS = exports.defaultProps = exports.propTypes = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(87));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var string = _propTypes["default"].string,
	    bool = _propTypes["default"].bool,
	    number = _propTypes["default"].number,
	    array = _propTypes["default"].array,
	    oneOfType = _propTypes["default"].oneOfType,
	    shape = _propTypes["default"].shape,
	    object = _propTypes["default"].object,
	    func = _propTypes["default"].func;
	var propTypes = {
	  url: oneOfType([string, array, object]),
	  playing: bool,
	  loop: bool,
	  controls: bool,
	  volume: number,
	  muted: bool,
	  playbackRate: number,
	  width: oneOfType([string, number]),
	  height: oneOfType([string, number]),
	  style: object,
	  progressInterval: number,
	  playsinline: bool,
	  pip: bool,
	  light: oneOfType([bool, string]),
	  wrapper: oneOfType([string, func, shape({
	    render: func.isRequired
	  })]),
	  config: shape({
	    soundcloud: shape({
	      options: object,
	      preload: bool
	    }),
	    youtube: shape({
	      playerVars: object,
	      embedOptions: object,
	      preload: bool
	    }),
	    facebook: shape({
	      appId: string
	    }),
	    dailymotion: shape({
	      params: object,
	      preload: bool
	    }),
	    vimeo: shape({
	      playerOptions: object,
	      preload: bool
	    }),
	    file: shape({
	      attributes: object,
	      tracks: array,
	      forceVideo: bool,
	      forceAudio: bool,
	      forceHLS: bool,
	      forceDASH: bool,
	      hlsOptions: object,
	      hlsVersion: string,
	      dashVersion: string
	    }),
	    wistia: shape({
	      options: object
	    }),
	    mixcloud: shape({
	      options: object
	    }),
	    twitch: shape({
	      options: object
	    })
	  }),
	  onReady: func,
	  onStart: func,
	  onPlay: func,
	  onPause: func,
	  onBuffer: func,
	  onBufferEnd: func,
	  onEnded: func,
	  onError: func,
	  onDuration: func,
	  onSeek: func,
	  onProgress: func,
	  onEnablePIP: func,
	  onDisablePIP: func
	};
	exports.propTypes = propTypes;
	var defaultProps = {
	  playing: false,
	  loop: false,
	  controls: false,
	  volume: null,
	  muted: false,
	  playbackRate: 1,
	  width: '640px',
	  height: '360px',
	  style: {},
	  progressInterval: 1000,
	  playsinline: false,
	  pip: false,
	  light: false,
	  wrapper: 'div',
	  config: {
	    soundcloud: {
	      options: {
	        visual: true,
	        // Undocumented, but makes player fill container and look better
	        buying: false,
	        liking: false,
	        download: false,
	        sharing: false,
	        show_comments: false,
	        show_playcount: false
	      }
	    },
	    youtube: {
	      playerVars: {
	        playsinline: 1,
	        showinfo: 0,
	        rel: 0,
	        iv_load_policy: 3,
	        modestbranding: 1
	      },
	      embedOptions: {},
	      preload: false
	    },
	    facebook: {
	      appId: '1309697205772819'
	    },
	    dailymotion: {
	      params: {
	        api: 1,
	        'endscreen-enable': false
	      },
	      preload: false
	    },
	    vimeo: {
	      playerOptions: {
	        autopause: false,
	        byline: false,
	        portrait: false,
	        title: false
	      },
	      preload: false
	    },
	    file: {
	      attributes: {},
	      tracks: [],
	      forceVideo: false,
	      forceAudio: false,
	      forceHLS: false,
	      forceDASH: false,
	      hlsOptions: {},
	      hlsVersion: '0.10.1',
	      dashVersion: '2.9.2'
	    },
	    wistia: {
	      options: {}
	    },
	    mixcloud: {
	      options: {
	        hide_cover: 1
	      }
	    },
	    twitch: {
	      options: {}
	    }
	  },
	  onReady: function onReady() {},
	  onStart: function onStart() {},
	  onPlay: function onPlay() {},
	  onPause: function onPause() {},
	  onBuffer: function onBuffer() {},
	  onBufferEnd: function onBufferEnd() {},
	  onEnded: function onEnded() {},
	  onError: function onError() {},
	  onDuration: function onDuration() {},
	  onSeek: function onSeek() {},
	  onProgress: function onProgress() {},
	  onEnablePIP: function onEnablePIP() {},
	  onDisablePIP: function onDisablePIP() {}
	};
	exports.defaultProps = defaultProps;
	var DEPRECATED_CONFIG_PROPS = ['soundcloudConfig', 'youtubeConfig', 'facebookConfig', 'dailymotionConfig', 'vimeoConfig', 'fileConfig', 'wistiaConfig'];
	exports.DEPRECATED_CONFIG_PROPS = DEPRECATED_CONFIG_PROPS;

/***/ },
/* 549 */,
/* 550 */,
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*!
	                                                                                                                                                                                                                                                                                Copyright (c) 2018 Jed Watson.
	                                                                                                                                                                                                                                                                                Licensed under the MIT License (MIT), see
	                                                                                                                                                                                                                                                                                http://jedwatson.github.io/react-select
	                                                                                                                                                                                                                                                                              */
	
	
	var _reactInputAutosize = __webpack_require__(1915);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(61);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(87);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(329);
	
	var _defaultArrowRenderer = __webpack_require__(920);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(921);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(693);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(694);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Option = __webpack_require__(918);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(919);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var stringifyValue = function stringifyValue(value) {
		return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
	};
	
	var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);
	var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var instanceId = 1;
	
	var shouldShowValue = function shouldShowValue(state, props) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		if (!inputValue) return true;
	
		if (!onSelectResetsInput) {
			return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
		}
	
		return false;
	};
	
	var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
	};
	
	/**
	 * Retrieve a value from the given options and valueKey
	 * @param {String|Number|Array} value	- the selected value(s)
	 * @param {Object}		 props	- the Select component's props (or nextProps)
	 */
	var expandValue = function expandValue(value, props) {
		var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
		if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
		var options = props.options,
		    valueKey = props.valueKey;
	
		if (!options) return;
		for (var i = 0; i < options.length; i++) {
			if (String(options[i][valueKey]) === String(value)) return options[i];
		}
	};
	
	var handleRequired = function handleRequired(value, multi) {
		if (!value) return true;
		return multi ? value.length === 0 : Object.keys(value).length === 0;
	};
	
	var Select = function (_React$Component) {
		_inherits(Select, _React$Component);
	
		function Select(props) {
			_classCallCheck(this, Select);
	
			var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
			['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
				return _this[fn] = _this[fn].bind(_this);
			});
	
			_this.state = {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
			return _this;
		}
	
		_createClass(Select, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
				var valueArray = this.getValueArray(this.props.value);
	
				if (this.props.required) {
					this.setState({
						required: handleRequired(valueArray[0], this.props.multi)
					});
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
					console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
				}
				if (this.props.autoFocus || this.props.autofocus) {
					this.focus();
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var valueArray = this.getValueArray(nextProps.value, nextProps);
	
				if (nextProps.required) {
					this.setState({
						required: handleRequired(valueArray[0], nextProps.multi)
					});
				} else if (this.props.required) {
					// Used to be required but it's not any more
					this.setState({ required: false });
				}
	
				if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
					this.setState({ inputValue: this.handleInputValueChange('') });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				// focus to the selected option
				if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
					var focusedOptionNode = (0, _reactDom.findDOMNode)(this.focused);
					var menuNode = (0, _reactDom.findDOMNode)(this.menu);
	
					var scrollTop = menuNode.scrollTop;
					var scrollBottom = scrollTop + menuNode.offsetHeight;
					var optionTop = focusedOptionNode.offsetTop;
					var optionBottom = optionTop + focusedOptionNode.offsetHeight;
	
					if (scrollTop > optionTop || scrollBottom < optionBottom) {
						menuNode.scrollTop = focusedOptionNode.offsetTop;
					}
	
					// We still set hasScrolledToOption to true even if we didn't
					// actually need to scroll, as we've still confirmed that the
					// option is in view.
					this.hasScrolledToOption = true;
				} else if (!this.state.isOpen) {
					this.hasScrolledToOption = false;
				}
	
				if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
					this._scrollToFocusedOptionOnUpdate = false;
					var focusedDOM = (0, _reactDom.findDOMNode)(this.focused);
					var menuDOM = (0, _reactDom.findDOMNode)(this.menu);
					var focusedRect = focusedDOM.getBoundingClientRect();
					var menuRect = menuDOM.getBoundingClientRect();
					if (focusedRect.bottom > menuRect.bottom) {
						menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
					} else if (focusedRect.top < menuRect.top) {
						menuDOM.scrollTop = focusedDOM.offsetTop;
					}
				}
				if (this.props.scrollMenuIntoView && this.menuContainer) {
					var menuContainerRect = this.menuContainer.getBoundingClientRect();
					if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
						window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
					}
				}
				if (prevProps.disabled !== this.props.disabled) {
					this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
					this.closeMenu();
				}
				if (prevState.isOpen !== this.state.isOpen) {
					this.toggleTouchOutsideEvent(this.state.isOpen);
					var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
					handler && handler();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.toggleTouchOutsideEvent(false);
			}
		}, {
			key: 'toggleTouchOutsideEvent',
			value: function toggleTouchOutsideEvent(enabled) {
				var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
				var pref = document.addEventListener ? '' : 'on';
	
				document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
				document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
			}
		}, {
			key: 'handleTouchOutside',
			value: function handleTouchOutside(event) {
				// handle touch outside on ios to dismiss menu
				if (this.wrapper && !this.wrapper.contains(event.target)) {
					this.closeMenu();
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				if (!this.input) return;
				this.input.focus();
			}
		}, {
			key: 'blurInput',
			value: function blurInput() {
				if (!this.input) return;
				this.input.blur();
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchEndClearValue',
			value: function handleTouchEndClearValue(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Clear the value
				this.clearValue(event);
			}
		}, {
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (event.target.tagName === 'INPUT') {
					if (!this.state.isFocused) {
						this._openAfterFocus = this.props.openOnClick;
						this.focus();
					} else if (!this.state.isOpen) {
						this.setState({
							isOpen: true,
							isPseudoFocused: false,
							focusedOption: null
						});
					}
	
					return;
				}
	
				// prevent default event handlers
				event.preventDefault();
	
				// for the non-searchable select, toggle the menu
				if (!this.props.searchable) {
					// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
					this.focus();
					return this.setState({
						isOpen: !this.state.isOpen,
						focusedOption: null
					});
				}
	
				if (this.state.isFocused) {
					// On iOS, we can get into a state where we think the input is focused but it isn't really,
					// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
					// Call focus() again here to be safe.
					this.focus();
	
					var input = this.input;
					var toOpen = true;
	
					if (typeof input.getInput === 'function') {
						// Get the actual DOM input if the ref is an <AutosizeInput /> component
						input = input.getInput();
					}
	
					// clears the value so that the cursor will be at the end of input when the component re-renders
					input.value = '';
	
					if (this._focusAfterClear) {
						toOpen = false;
						this._focusAfterClear = false;
					}
	
					// if the input is focused, ensure the menu is open
					this.setState({
						isOpen: toOpen,
						isPseudoFocused: false,
						focusedOption: null
					});
				} else {
					// otherwise, focus the input and open the menu
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
					this.setState({ focusedOption: null });
				}
			}
		}, {
			key: 'handleMouseDownOnArrow',
			value: function handleMouseDownOnArrow(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (this.state.isOpen) {
					// prevent default event handlers
					event.stopPropagation();
					event.preventDefault();
					// close the menu
					this.closeMenu();
				} else {
					// If the menu isn't open, let the event bubble to the main handleMouseDown
					this.setState({
						isOpen: true
					});
				}
			}
		}, {
			key: 'handleMouseDownOnMenu',
			value: function handleMouseDownOnMenu(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.stopPropagation();
				event.preventDefault();
	
				this._openAfterFocus = true;
				this.focus();
			}
		}, {
			key: 'closeMenu',
			value: function closeMenu() {
				if (this.props.onCloseResetsInput) {
					this.setState({
						inputValue: this.handleInputValueChange(''),
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				} else {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				}
				this.hasScrolledToOption = false;
			}
		}, {
			key: 'handleInputFocus',
			value: function handleInputFocus(event) {
				if (this.props.disabled) return;
	
				var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
				toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.
	
				if (this.props.onFocus) {
					this.props.onFocus(event);
				}
	
				this.setState({
					isFocused: true,
					isOpen: !!toOpen
				});
	
				this._focusAfterClear = false;
				this._openAfterFocus = false;
			}
		}, {
			key: 'handleInputBlur',
			value: function handleInputBlur(event) {
				// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
				if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
					this.focus();
					return;
				}
	
				if (this.props.onBlur) {
					this.props.onBlur(event);
				}
				var onBlurredState = {
					isFocused: false,
					isOpen: false,
					isPseudoFocused: false
				};
				if (this.props.onBlurResetsInput) {
					onBlurredState.inputValue = this.handleInputValueChange('');
				}
				this.setState(onBlurredState);
			}
		}, {
			key: 'handleInputChange',
			value: function handleInputChange(event) {
				var newInputValue = event.target.value;
	
				if (this.state.inputValue !== event.target.value) {
					newInputValue = this.handleInputValueChange(newInputValue);
				}
	
				this.setState({
					inputValue: newInputValue,
					isOpen: true,
					isPseudoFocused: false
				});
			}
		}, {
			key: 'setInputValue',
			value: function setInputValue(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				this.setState({
					inputValue: newValue
				});
			}
		}, {
			key: 'handleInputValueChange',
			value: function handleInputValueChange(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					// Note: != used deliberately here to catch undefined and null
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				return newValue;
			}
		}, {
			key: 'handleKeyDown',
			value: function handleKeyDown(event) {
				if (this.props.disabled) return;
	
				if (typeof this.props.onInputKeyDown === 'function') {
					this.props.onInputKeyDown(event);
					if (event.defaultPrevented) {
						return;
					}
				}
	
				switch (event.keyCode) {
					case 8:
						// backspace
						if (!this.state.inputValue && this.props.backspaceRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
					case 9:
						// tab
						if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
							break;
						}
						event.preventDefault();
						this.selectFocusedOption();
						break;
					case 13:
						// enter
						event.preventDefault();
						event.stopPropagation();
						if (this.state.isOpen) {
							this.selectFocusedOption();
						} else {
							this.focusNextOption();
						}
						break;
					case 27:
						// escape
						event.preventDefault();
						if (this.state.isOpen) {
							this.closeMenu();
							event.stopPropagation();
						} else if (this.props.clearable && this.props.escapeClearsValue) {
							this.clearValue(event);
							event.stopPropagation();
						}
						break;
					case 32:
						// space
						if (this.props.searchable) {
							break;
						}
						event.preventDefault();
						if (!this.state.isOpen) {
							this.focusNextOption();
							break;
						}
						event.stopPropagation();
						this.selectFocusedOption();
						break;
					case 38:
						// up
						event.preventDefault();
						this.focusPreviousOption();
						break;
					case 40:
						// down
						event.preventDefault();
						this.focusNextOption();
						break;
					case 33:
						// page up
						event.preventDefault();
						this.focusPageUpOption();
						break;
					case 34:
						// page down
						event.preventDefault();
						this.focusPageDownOption();
						break;
					case 35:
						// end key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusEndOption();
						break;
					case 36:
						// home key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusStartOption();
						break;
					case 46:
						// delete
						if (!this.state.inputValue && this.props.deleteRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
				}
			}
		}, {
			key: 'handleValueClick',
			value: function handleValueClick(option, event) {
				if (!this.props.onValueClick) return;
				this.props.onValueClick(option, event);
			}
		}, {
			key: 'handleMenuScroll',
			value: function handleMenuScroll(event) {
				if (!this.props.onMenuScrollToBottom) return;
				var target = event.target;
	
				if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
					this.props.onMenuScrollToBottom();
				}
			}
		}, {
			key: 'getOptionLabel',
			value: function getOptionLabel(op) {
				return op[this.props.labelKey];
			}
	
			/**
	   * Turns a value into an array from the given options
	   * @param {String|Number|Array} value		- the value of the select input
	   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	   * @returns	{Array}	the value of the select represented in an array
	   */
	
		}, {
			key: 'getValueArray',
			value: function getValueArray(value) {
				var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
				/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
				var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
				if (props.multi) {
					if (typeof value === 'string') {
						value = value.split(props.delimiter);
					}
					if (!Array.isArray(value)) {
						if (value === null || value === undefined) return [];
						value = [value];
					}
					return value.map(function (value) {
						return expandValue(value, props);
					}).filter(function (i) {
						return i;
					});
				}
				var expandedValue = expandValue(value, props);
				return expandedValue ? [expandedValue] : [];
			}
		}, {
			key: 'setValue',
			value: function setValue(value) {
				var _this2 = this;
	
				if (this.props.autoBlur) {
					this.blurInput();
				}
				if (this.props.required) {
					var required = handleRequired(value, this.props.multi);
					this.setState({ required: required });
				}
				if (this.props.simpleValue && value) {
					value = this.props.multi ? value.map(function (i) {
						return i[_this2.props.valueKey];
					}).join(this.props.delimiter) : value[this.props.valueKey];
				}
				if (this.props.onChange) {
					this.props.onChange(value);
				}
			}
		}, {
			key: 'selectValue',
			value: function selectValue(value) {
				var _this3 = this;
	
				// NOTE: we actually add/set the value in a callback to make sure the
				// input value is empty to avoid styling issues in Chrome
				if (this.props.closeOnSelect) {
					this.hasScrolledToOption = false;
				}
				var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
				if (this.props.multi) {
					this.setState({
						focusedIndex: null,
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect
					}, function () {
						var valueArray = _this3.getValueArray(_this3.props.value);
						if (valueArray.some(function (i) {
							return i[_this3.props.valueKey] === value[_this3.props.valueKey];
						})) {
							_this3.removeValue(value);
						} else {
							_this3.addValue(value);
						}
					});
				} else {
					this.setState({
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect,
						isPseudoFocused: this.state.isFocused
					}, function () {
						_this3.setValue(value);
					});
				}
			}
		}, {
			key: 'addValue',
			value: function addValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				var visibleOptions = this._visibleOptions.filter(function (val) {
					return !val.disabled;
				});
				var lastValueIndex = visibleOptions.indexOf(value);
				this.setValue(valueArray.concat(value));
				if (!this.props.closeOnSelect) {
					return;
				}
				if (visibleOptions.length - 1 === lastValueIndex) {
					// the last option was selected; focus the second-last one
					this.focusOption(visibleOptions[lastValueIndex - 1]);
				} else if (visibleOptions.length > lastValueIndex) {
					// focus the option below the selected one
					this.focusOption(visibleOptions[lastValueIndex + 1]);
				}
			}
		}, {
			key: 'popValue',
			value: function popValue() {
				var valueArray = this.getValueArray(this.props.value);
				if (!valueArray.length) return;
				if (valueArray[valueArray.length - 1].clearableValue === false) return;
				this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
			}
		}, {
			key: 'removeValue',
			value: function removeValue(value) {
				var _this4 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				this.setValue(valueArray.filter(function (i) {
					return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
				}));
				this.focus();
			}
		}, {
			key: 'clearValue',
			value: function clearValue(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, ignore it.
				if (event && event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.preventDefault();
	
				this.setValue(this.getResetValue());
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false
				}, this.focus);
	
				this._focusAfterClear = true;
			}
		}, {
			key: 'getResetValue',
			value: function getResetValue() {
				if (this.props.resetValue !== undefined) {
					return this.props.resetValue;
				} else if (this.props.multi) {
					return [];
				} else {
					return null;
				}
			}
		}, {
			key: 'focusOption',
			value: function focusOption(option) {
				this.setState({
					focusedOption: option
				});
			}
		}, {
			key: 'focusNextOption',
			value: function focusNextOption() {
				this.focusAdjacentOption('next');
			}
		}, {
			key: 'focusPreviousOption',
			value: function focusPreviousOption() {
				this.focusAdjacentOption('previous');
			}
		}, {
			key: 'focusPageUpOption',
			value: function focusPageUpOption() {
				this.focusAdjacentOption('page_up');
			}
		}, {
			key: 'focusPageDownOption',
			value: function focusPageDownOption() {
				this.focusAdjacentOption('page_down');
			}
		}, {
			key: 'focusStartOption',
			value: function focusStartOption() {
				this.focusAdjacentOption('start');
			}
		}, {
			key: 'focusEndOption',
			value: function focusEndOption() {
				this.focusAdjacentOption('end');
			}
		}, {
			key: 'focusAdjacentOption',
			value: function focusAdjacentOption(dir) {
				var options = this._visibleOptions.map(function (option, index) {
					return { option: option, index: index };
				}).filter(function (option) {
					return !option.option.disabled;
				});
				this._scrollToFocusedOptionOnUpdate = true;
				if (!this.state.isOpen) {
					var newState = {
						focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
						isOpen: true
					};
					if (this.props.onSelectResetsInput) {
						newState.inputValue = '';
					}
					this.setState(newState);
					return;
				}
				if (!options.length) return;
				var focusedIndex = -1;
				for (var i = 0; i < options.length; i++) {
					if (this._focusedOption === options[i].option) {
						focusedIndex = i;
						break;
					}
				}
				if (dir === 'next' && focusedIndex !== -1) {
					focusedIndex = (focusedIndex + 1) % options.length;
				} else if (dir === 'previous') {
					if (focusedIndex > 0) {
						focusedIndex = focusedIndex - 1;
					} else {
						focusedIndex = options.length - 1;
					}
				} else if (dir === 'start') {
					focusedIndex = 0;
				} else if (dir === 'end') {
					focusedIndex = options.length - 1;
				} else if (dir === 'page_up') {
					var potentialIndex = focusedIndex - this.props.pageSize;
					if (potentialIndex < 0) {
						focusedIndex = 0;
					} else {
						focusedIndex = potentialIndex;
					}
				} else if (dir === 'page_down') {
					var _potentialIndex = focusedIndex + this.props.pageSize;
					if (_potentialIndex > options.length - 1) {
						focusedIndex = options.length - 1;
					} else {
						focusedIndex = _potentialIndex;
					}
				}
	
				if (focusedIndex === -1) {
					focusedIndex = 0;
				}
	
				this.setState({
					focusedIndex: options[focusedIndex].index,
					focusedOption: options[focusedIndex].option
				});
			}
		}, {
			key: 'getFocusedOption',
			value: function getFocusedOption() {
				return this._focusedOption;
			}
		}, {
			key: 'selectFocusedOption',
			value: function selectFocusedOption() {
				if (this._focusedOption) {
					return this.selectValue(this._focusedOption);
				}
			}
		}, {
			key: 'renderLoading',
			value: function renderLoading() {
				if (!this.props.isLoading) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
					_react2.default.createElement('span', { className: 'Select-loading' })
				);
			}
		}, {
			key: 'renderValue',
			value: function renderValue(valueArray, isOpen) {
				var _this5 = this;
	
				var renderLabel = this.props.valueRenderer || this.getOptionLabel;
				var ValueComponent = this.props.valueComponent;
				if (!valueArray.length) {
					var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
					return showPlaceholder ? _react2.default.createElement(
						'div',
						{ className: 'Select-placeholder' },
						this.props.placeholder
					) : null;
				}
				var onClick = this.props.onValueClick ? this.handleValueClick : null;
				if (this.props.multi) {
					return valueArray.map(function (value, i) {
						return _react2.default.createElement(
							ValueComponent,
							{
								disabled: _this5.props.disabled || value.clearableValue === false,
								id: _this5._instancePrefix + '-value-' + i,
								instancePrefix: _this5._instancePrefix,
								key: 'value-' + i + '-' + value[_this5.props.valueKey],
								onClick: onClick,
								onRemove: _this5.removeValue,
								placeholder: _this5.props.placeholder,
								value: value,
								values: valueArray
							},
							renderLabel(value, i),
							_react2.default.createElement(
								'span',
								{ className: 'Select-aria-only' },
								'\xA0'
							)
						);
					});
				} else if (shouldShowValue(this.state, this.props)) {
					if (isOpen) onClick = null;
					return _react2.default.createElement(
						ValueComponent,
						{
							disabled: this.props.disabled,
							id: this._instancePrefix + '-value-item',
							instancePrefix: this._instancePrefix,
							onClick: onClick,
							placeholder: this.props.placeholder,
							value: valueArray[0]
						},
						renderLabel(valueArray[0])
					);
				}
			}
		}, {
			key: 'renderInput',
			value: function renderInput(valueArray, focusedOptionIndex) {
				var _classNames,
				    _this6 = this;
	
				var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
				var isOpen = this.state.isOpen;
	
				var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
				var value = this.state.inputValue;
				if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
					// it hides input value when it is not focused and was not reset on select
					value = '';
				}
	
				var inputProps = _extends({}, this.props.inputProps, {
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-describedby': this.props['aria-describedby'],
					'aria-expanded': '' + isOpen,
					'aria-haspopup': '' + isOpen,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-owns': ariaOwns,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref) {
						return _this6.input = _ref;
					},
					role: 'combobox',
					required: this.state.required,
					tabIndex: this.props.tabIndex,
					value: value
				});
	
				if (this.props.inputRenderer) {
					return this.props.inputRenderer(inputProps);
				}
	
				if (this.props.disabled || !this.props.searchable) {
					var divProps = _objectWithoutProperties(this.props.inputProps, []);
	
					var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));
					return _react2.default.createElement('div', _extends({}, divProps, {
						'aria-expanded': isOpen,
						'aria-owns': _ariaOwns,
						'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
						'aria-disabled': '' + this.props.disabled,
						'aria-label': this.props['aria-label'],
						'aria-labelledby': this.props['aria-labelledby'],
						className: className,
						onBlur: this.handleInputBlur,
						onFocus: this.handleInputFocus,
						ref: function ref(_ref2) {
							return _this6.input = _ref2;
						},
						role: 'combobox',
						style: { border: 0, width: 1, display: 'inline-block' },
						tabIndex: this.props.tabIndex || 0
					}));
				}
	
				if (this.props.autosize) {
					return _react2.default.createElement(_reactInputAutosize2.default, _extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
				}
				return _react2.default.createElement(
					'div',
					{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
					_react2.default.createElement('input', _extends({ id: this.props.id }, inputProps))
				);
			}
		}, {
			key: 'renderClear',
			value: function renderClear() {
				var valueArray = this.getValueArray(this.props.value);
				if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
				var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
				var clear = this.props.clearRenderer();
	
				return _react2.default.createElement(
					'span',
					{
						'aria-label': ariaLabel,
						className: 'Select-clear-zone',
						onMouseDown: this.clearValue,
						onTouchEnd: this.handleTouchEndClearValue,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						title: ariaLabel
					},
					clear
				);
			}
		}, {
			key: 'renderArrow',
			value: function renderArrow() {
				if (!this.props.arrowRenderer) return;
	
				var onMouseDown = this.handleMouseDownOnArrow;
				var isOpen = this.state.isOpen;
				var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
				if (!arrow) {
					return null;
				}
	
				return _react2.default.createElement(
					'span',
					{
						className: 'Select-arrow-zone',
						onMouseDown: onMouseDown
					},
					arrow
				);
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions(excludeOptions) {
				var filterValue = this.state.inputValue;
				var options = this.props.options || [];
				if (this.props.filterOptions) {
					// Maintain backwards compatibility with boolean attribute
					var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;
	
					return filterOptions(options, filterValue, excludeOptions, {
						filterOption: this.props.filterOption,
						ignoreAccents: this.props.ignoreAccents,
						ignoreCase: this.props.ignoreCase,
						labelKey: this.props.labelKey,
						matchPos: this.props.matchPos,
						matchProp: this.props.matchProp,
						trimFilter: this.props.trimFilter,
						valueKey: this.props.valueKey
					});
				} else {
					return options;
				}
			}
		}, {
			key: 'onOptionRef',
			value: function onOptionRef(ref, isFocused) {
				if (isFocused) {
					this.focused = ref;
				}
			}
		}, {
			key: 'renderMenu',
			value: function renderMenu(options, valueArray, focusedOption) {
				if (options && options.length) {
					return this.props.menuRenderer({
						focusedOption: focusedOption,
						focusOption: this.focusOption,
						inputValue: this.state.inputValue,
						instancePrefix: this._instancePrefix,
						labelKey: this.props.labelKey,
						onFocus: this.focusOption,
						onOptionRef: this.onOptionRef,
						onSelect: this.selectValue,
						optionClassName: this.props.optionClassName,
						optionComponent: this.props.optionComponent,
						optionRenderer: this.props.optionRenderer || this.getOptionLabel,
						options: options,
						removeValue: this.removeValue,
						selectValue: this.selectValue,
						valueArray: valueArray,
						valueKey: this.props.valueKey
					});
				} else if (this.props.noResultsText) {
					return _react2.default.createElement(
						'div',
						{ className: 'Select-noresults' },
						this.props.noResultsText
					);
				} else {
					return null;
				}
			}
		}, {
			key: 'renderHiddenField',
			value: function renderHiddenField(valueArray) {
				var _this7 = this;
	
				if (!this.props.name) return;
				if (this.props.joinValues) {
					var value = valueArray.map(function (i) {
						return stringifyValue(i[_this7.props.valueKey]);
					}).join(this.props.delimiter);
					return _react2.default.createElement('input', {
						disabled: this.props.disabled,
						name: this.props.name,
						ref: function ref(_ref3) {
							return _this7.value = _ref3;
						},
						type: 'hidden',
						value: value
					});
				}
				return valueArray.map(function (item, index) {
					return _react2.default.createElement('input', {
						disabled: _this7.props.disabled,
						key: 'hidden.' + index,
						name: _this7.props.name,
						ref: 'value' + index,
						type: 'hidden',
						value: stringifyValue(item[_this7.props.valueKey])
					});
				});
			}
		}, {
			key: 'getFocusableOptionIndex',
			value: function getFocusableOptionIndex(selectedOption) {
				var options = this._visibleOptions;
				if (!options.length) return null;
	
				var valueKey = this.props.valueKey;
				var focusedOption = this.state.focusedOption || selectedOption;
				if (focusedOption && !focusedOption.disabled) {
					var focusedOptionIndex = -1;
					options.some(function (option, index) {
						var isOptionEqual = option[valueKey] === focusedOption[valueKey];
						if (isOptionEqual) {
							focusedOptionIndex = index;
						}
						return isOptionEqual;
					});
					if (focusedOptionIndex !== -1) {
						return focusedOptionIndex;
					}
				}
	
				for (var i = 0; i < options.length; i++) {
					if (!options[i].disabled) return i;
				}
				return null;
			}
		}, {
			key: 'renderOuter',
			value: function renderOuter(options, valueArray, focusedOption) {
				var _this8 = this;
	
				var menu = this.renderMenu(options, valueArray, focusedOption);
				if (!menu) {
					return null;
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref5) {
							return _this8.menuContainer = _ref5;
						}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
					_react2.default.createElement(
						'div',
						{
							className: 'Select-menu',
							id: this._instancePrefix + '-list',
							onMouseDown: this.handleMouseDownOnMenu,
							onScroll: this.handleMenuScroll,
							ref: function ref(_ref4) {
								return _this8.menu = _ref4;
							},
							role: 'listbox',
							style: this.props.menuStyle,
							tabIndex: -1
						},
						menu
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this9 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
				var isOpen = this.state.isOpen;
				if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
				var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
				var focusedOption = null;
				if (focusedOptionIndex !== null) {
					focusedOption = this._focusedOption = options[focusedOptionIndex];
				} else {
					focusedOption = this._focusedOption = null;
				}
				var className = (0, _classnames2.default)('Select', this.props.className, {
					'has-value': valueArray.length,
					'is-clearable': this.props.clearable,
					'is-disabled': this.props.disabled,
					'is-focused': this.state.isFocused,
					'is-loading': this.props.isLoading,
					'is-open': isOpen,
					'is-pseudo-focused': this.state.isPseudoFocused,
					'is-searchable': this.props.searchable,
					'Select--multi': this.props.multi,
					'Select--rtl': this.props.rtl,
					'Select--single': !this.props.multi
				});
	
				var removeMessage = null;
				if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
					removeMessage = _react2.default.createElement(
						'span',
						{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
						this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref7) {
							return _this9.wrapper = _ref7;
						},
						className: className,
						style: this.props.wrapperStyle },
					this.renderHiddenField(valueArray),
					_react2.default.createElement(
						'div',
						{ ref: function ref(_ref6) {
								return _this9.control = _ref6;
							},
							className: 'Select-control',
							onKeyDown: this.handleKeyDown,
							onMouseDown: this.handleMouseDown,
							onTouchEnd: this.handleTouchEnd,
							onTouchMove: this.handleTouchMove,
							onTouchStart: this.handleTouchStart,
							style: this.props.style
						},
						_react2.default.createElement(
							'div',
							{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
							this.renderValue(valueArray, isOpen),
							this.renderInput(valueArray, focusedOptionIndex)
						),
						removeMessage,
						this.renderLoading(),
						this.renderClear(),
						this.renderArrow()
					),
					isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
				);
			}
		}]);
	
		return Select;
	}(_react2.default.Component);
	
	Select.propTypes = {
		'aria-describedby': _propTypes2.default.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _propTypes2.default.string, // aria label (for assistive tech)
		'aria-labelledby': _propTypes2.default.string, // html id of an element that should be used as the label (for assistive tech)
		arrowRenderer: _propTypes2.default.func, // create the drop-down caret element
		autoBlur: _propTypes2.default.bool, // automatically blur the component when an option is selected
		autoFocus: _propTypes2.default.bool, // autofocus the component on mount
		autofocus: _propTypes2.default.bool, // deprecated; use autoFocus instead
		autosize: _propTypes2.default.bool, // whether to enable autosizing or not
		backspaceRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _propTypes2.default.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _propTypes2.default.string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _propTypes2.default.func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _propTypes2.default.bool, // should it be possible to reset value
		closeOnSelect: _propTypes2.default.bool, // whether to close the menu when a value is selected
		deleteRemoves: _propTypes2.default.bool, // whether delete removes an item if there is no text input
		delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
		disabled: _propTypes2.default.bool, // whether the Select is disabled or not
		escapeClearsValue: _propTypes2.default.bool, // whether escape clears the value when the menu is closed
		filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
		filterOptions: _propTypes2.default.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		id: _propTypes2.default.string, // html id to set on the input element for accessibility or tests
		ignoreAccents: _propTypes2.default.bool, // whether to strip diacritics when filtering
		ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
		inputProps: _propTypes2.default.object, // custom attributes for the Input
		inputRenderer: _propTypes2.default.func, // returns a custom input component
		instanceId: _propTypes2.default.string, // set the components instanceId
		isLoading: _propTypes2.default.bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _propTypes2.default.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _propTypes2.default.string, // path of the label value in option objects
		matchPos: _propTypes2.default.string, // (any|start) match the start or entire string when filtering
		matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
		menuBuffer: _propTypes2.default.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _propTypes2.default.object, // optional style to apply to the menu container
		menuRenderer: _propTypes2.default.func, // renders a custom menu with options
		menuStyle: _propTypes2.default.object, // optional style to apply to the menu
		multi: _propTypes2.default.bool, // multi-value input
		name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
		onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onClose: _propTypes2.default.func, // fires when the menu is closed
		onCloseResetsInput: _propTypes2.default.bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
		onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _propTypes2.default.func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _propTypes2.default.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _propTypes2.default.func, // fires when the menu is opened
		onSelectResetsInput: _propTypes2.default.bool, // whether input is cleared on select (works only for multiselect)
		onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
		openOnClick: _propTypes2.default.bool, // boolean to control opening the menu when the control is clicked
		openOnFocus: _propTypes2.default.bool, // always open options menu on focus
		optionClassName: _propTypes2.default.string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _propTypes2.default.func, // option component to render in dropdown
		optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
		options: _propTypes2.default.array, // array of options
		pageSize: _propTypes2.default.number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		removeSelected: _propTypes2.default.bool, // whether the selected option is removed from the dropdown on multi selects
		required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
		resetValue: _propTypes2.default.any, // value to use when you clear the control
		rtl: _propTypes2.default.bool, // set to true in order to use react-select in right-to-left direction
		scrollMenuIntoView: _propTypes2.default.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _propTypes2.default.bool, // whether to enable searching feature or not
		simpleValue: _propTypes2.default.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _propTypes2.default.object, // optional style to apply to the control
		tabIndex: stringOrNumber, // optional tab index of the control
		tabSelectsValue: _propTypes2.default.bool, // whether to treat tabbing out while focused to be value selection
		trimFilter: _propTypes2.default.bool, // whether to trim whitespace around filter value
		value: _propTypes2.default.any, // initial field value
		valueComponent: _propTypes2.default.func, // value component to render
		valueKey: _propTypes2.default.string, // path of the label value in option objects
		valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
		wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
	};
	
	Select.defaultProps = {
		arrowRenderer: _defaultArrowRenderer2.default,
		autosize: true,
		backspaceRemoves: true,
		backspaceToRemoveMessage: 'Press backspace to remove {label}',
		clearable: true,
		clearAllText: 'Clear all',
		clearRenderer: _defaultClearRenderer2.default,
		clearValueText: 'Clear value',
		closeOnSelect: true,
		deleteRemoves: true,
		delimiter: ',',
		disabled: false,
		escapeClearsValue: true,
		filterOptions: _defaultFilterOptions2.default,
		ignoreAccents: true,
		ignoreCase: true,
		inputProps: {},
		isLoading: false,
		joinValues: false,
		labelKey: 'label',
		matchPos: 'any',
		matchProp: 'any',
		menuBuffer: 0,
		menuRenderer: _defaultMenuRenderer2.default,
		multi: false,
		noResultsText: 'No results found',
		onBlurResetsInput: true,
		onCloseResetsInput: true,
		onSelectResetsInput: true,
		openOnClick: true,
		optionComponent: _Option2.default,
		pageSize: 5,
		placeholder: 'Select...',
		removeSelected: true,
		required: false,
		rtl: false,
		scrollMenuIntoView: true,
		searchable: true,
		simpleValue: false,
		tabSelectsValue: true,
		trimFilter: true,
		valueComponent: _Value2.default,
		valueKey: 'value'
	};
	
	exports.default = Select;

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(329);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
	  var onDemandSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
	      onDemandSlides.push(slideIndex);
	    }
	  }
	  return onDemandSlides;
	};
	
	// return list of slides that need to be present
	var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
	  var requiredSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    requiredSlides.push(slideIndex);
	  }
	  return requiredSlides;
	};
	
	// startIndex that needs to be present
	var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
	  return spec.currentSlide - lazySlidesOnLeft(spec);
	};
	var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
	  return spec.currentSlide + lazySlidesOnRight(spec);
	};
	var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
	  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
	};
	var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
	  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
	};
	
	// get width of an element
	var getWidth = exports.getWidth = function getWidth(elem) {
	  return elem && elem.offsetWidth || 0;
	};
	var getHeight = exports.getHeight = function getHeight(elem) {
	  return elem && elem.offsetHeight || 0;
	};
	var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
	  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var xDist, yDist, r, swipeAngle;
	  xDist = touchObject.startX - touchObject.curX;
	  yDist = touchObject.startY - touchObject.curY;
	  r = Math.atan2(yDist, xDist);
	  swipeAngle = Math.round(r * 180 / Math.PI);
	  if (swipeAngle < 0) {
	    swipeAngle = 360 - Math.abs(swipeAngle);
	  }
	  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	    return "left";
	  }
	  if (swipeAngle >= 135 && swipeAngle <= 225) {
	    return "right";
	  }
	  if (verticalSwiping === true) {
	    if (swipeAngle >= 35 && swipeAngle <= 135) {
	      return "up";
	    } else {
	      return "down";
	    }
	  }
	
	  return "vertical";
	};
	
	// whether or not we can go next
	var canGoNext = exports.canGoNext = function canGoNext(spec) {
	  var canGo = true;
	  if (!spec.infinite) {
	    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
	      canGo = false;
	    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
	      canGo = false;
	    }
	  }
	  return canGo;
	};
	
	// given an object and a list of keys, return new object with given keys
	var extractObject = exports.extractObject = function extractObject(spec, keys) {
	  var newObject = {};
	  keys.forEach(function (key) {
	    return newObject[key] = spec[key];
	  });
	  return newObject;
	};
	
	// get initialized state
	var initializedState = exports.initializedState = function initializedState(spec) {
	  // spec also contains listRef, trackRef
	  var slideCount = _react2.default.Children.count(spec.children);
	  var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
	  var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
	  var slideWidth = void 0;
	  if (!spec.vertical) {
	    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
	    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
	      centerPaddingAdj *= listWidth / 100;
	    }
	    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
	  } else {
	    slideWidth = listWidth;
	  }
	  var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
	  var listHeight = slideHeight * spec.slidesToShow;
	  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
	  if (spec.rtl && spec.currentSlide === undefined) {
	    currentSlide = slideCount - 1 - spec.initialSlide;
	  }
	  var lazyLoadedList = spec.lazyLoadedList || [];
	  var slidesToLoad = getOnDemandLazySlides({ currentSlide: currentSlide, lazyLoadedList: lazyLoadedList }, spec);
	  lazyLoadedList.concat(slidesToLoad);
	
	  var state = {
	    slideCount: slideCount,
	    slideWidth: slideWidth,
	    listWidth: listWidth,
	    trackWidth: trackWidth,
	    currentSlide: currentSlide,
	    slideHeight: slideHeight,
	    listHeight: listHeight,
	    lazyLoadedList: lazyLoadedList
	  };
	
	  if (spec.autoplaying === null && spec.autoplay) {
	    state["autoplaying"] = "playing";
	  }
	
	  return state;
	};
	
	var slideHandler = exports.slideHandler = function slideHandler(spec) {
	  var waitForAnimate = spec.waitForAnimate,
	      animating = spec.animating,
	      fade = spec.fade,
	      infinite = spec.infinite,
	      index = spec.index,
	      slideCount = spec.slideCount,
	      lazyLoadedList = spec.lazyLoadedList,
	      lazyLoad = spec.lazyLoad,
	      currentSlide = spec.currentSlide,
	      centerMode = spec.centerMode,
	      slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      useCSS = spec.useCSS;
	
	  if (waitForAnimate && animating) return {};
	  var animationSlide = index,
	      finalSlide = void 0,
	      animationLeft = void 0,
	      finalLeft = void 0;
	  var state = {},
	      nextState = {};
	  if (fade) {
	    if (!infinite && (index < 0 || index >= slideCount)) return {};
	    if (index < 0) {
	      animationSlide = index + slideCount;
	    } else if (index >= slideCount) {
	      animationSlide = index - slideCount;
	    }
	    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
	      lazyLoadedList.push(animationSlide);
	    }
	    state = {
	      animating: true,
	      currentSlide: animationSlide,
	      lazyLoadedList: lazyLoadedList
	    };
	    nextState = { animating: false };
	  } else {
	    finalSlide = animationSlide;
	    if (animationSlide < 0) {
	      finalSlide = animationSlide + slideCount;
	      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
	    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
	      animationSlide = finalSlide = currentSlide;
	    } else if (centerMode && animationSlide >= slideCount) {
	      animationSlide = infinite ? slideCount : slideCount - 1;
	      finalSlide = infinite ? 0 : slideCount - 1;
	    } else if (animationSlide >= slideCount) {
	      finalSlide = animationSlide - slideCount;
	      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
	    }
	    animationLeft = getTrackLeft(_extends({}, spec, { slideIndex: animationSlide }));
	    finalLeft = getTrackLeft(_extends({}, spec, { slideIndex: finalSlide }));
	    if (!infinite) {
	      if (animationLeft === finalLeft) animationSlide = finalSlide;
	      animationLeft = finalLeft;
	    }
	    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, { currentSlide: animationSlide })));
	    if (!useCSS) {
	      state = {
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
	        lazyLoadedList: lazyLoadedList
	      };
	    } else {
	      state = {
	        animating: true,
	        currentSlide: finalSlide,
	        trackStyle: getTrackAnimateCSS(_extends({}, spec, { left: animationLeft })),
	        lazyLoadedList: lazyLoadedList
	      };
	      nextState = {
	        animating: false,
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
	        swipeLeft: null
	      };
	    }
	  }
	  return { state: state, nextState: nextState };
	};
	
	var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
	  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	  var slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      slideCount = spec.slideCount,
	      currentSlide = spec.currentSlide,
	      lazyLoad = spec.lazyLoad,
	      infinite = spec.infinite;
	
	  unevenOffset = slideCount % slidesToScroll !== 0;
	  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	  if (options.message === "previous") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	    targetSlide = currentSlide - slideOffset;
	    if (lazyLoad && !infinite) {
	      previousInt = currentSlide - slideOffset;
	      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	    }
	  } else if (options.message === "next") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	    targetSlide = currentSlide + slideOffset;
	    if (lazyLoad && !infinite) {
	      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	    }
	  } else if (options.message === "dots") {
	    // Click on dots
	    targetSlide = options.index * options.slidesToScroll;
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  } else if (options.message === "children") {
	    // Click on the slides
	    targetSlide = options.index;
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	    if (infinite) {
	      var direction = siblingDirection(_extends({}, spec, { targetSlide: targetSlide }));
	      if (targetSlide > options.currentSlide && direction === "left") {
	        targetSlide = targetSlide - slideCount;
	      } else if (targetSlide < options.currentSlide && direction === "right") {
	        targetSlide = targetSlide + slideCount;
	      }
	    }
	  } else if (options.message === "index") {
	    targetSlide = Number(options.index);
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  }
	  return targetSlide;
	};
	var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
	  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
	  if (e.keyCode === 37) return rtl ? "next" : "previous";
	  if (e.keyCode === 39) return rtl ? "previous" : "next";
	  return "";
	};
	
	var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
	  e.target.tagName === "IMG" && e.preventDefault();
	  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
	  return {
	    dragging: true,
	    touchObject: {
	      startX: e.touches ? e.touches[0].pageX : e.clientX,
	      startY: e.touches ? e.touches[0].pageY : e.clientY,
	      curX: e.touches ? e.touches[0].pageX : e.clientX,
	      curY: e.touches ? e.touches[0].pageY : e.clientY
	    }
	  };
	};
	var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
	  // spec also contains, trackRef and slideIndex
	  var scrolling = spec.scrolling,
	      animating = spec.animating,
	      vertical = spec.vertical,
	      swipeToSlide = spec.swipeToSlide,
	      verticalSwiping = spec.verticalSwiping,
	      rtl = spec.rtl,
	      currentSlide = spec.currentSlide,
	      edgeFriction = spec.edgeFriction,
	      edgeDragged = spec.edgeDragged,
	      onEdge = spec.onEdge,
	      swiped = spec.swiped,
	      swiping = spec.swiping,
	      slideCount = spec.slideCount,
	      slidesToScroll = spec.slidesToScroll,
	      infinite = spec.infinite,
	      touchObject = spec.touchObject,
	      swipeEvent = spec.swipeEvent,
	      listHeight = spec.listHeight,
	      listWidth = spec.listWidth;
	
	  if (scrolling) return;
	  if (animating) return e.preventDefault();
	  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
	  var swipeLeft = void 0,
	      state = {};
	  var curLeft = getTrackLeft(spec);
	  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
	    return { scrolling: true };
	  }
	  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
	  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	
	  var dotCount = Math.ceil(slideCount / slidesToScroll);
	  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
	  var touchSwipeLength = touchObject.swipeLength;
	  if (!infinite) {
	    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
	      touchSwipeLength = touchObject.swipeLength * edgeFriction;
	      if (edgeDragged === false && onEdge) {
	        onEdge(swipeDirection);
	        state["edgeDragged"] = true;
	      }
	    }
	  }
	  if (!swiped && swipeEvent) {
	    swipeEvent(swipeDirection);
	    state["swiped"] = true;
	  }
	  if (!vertical) {
	    if (!rtl) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft - touchSwipeLength * positionOffset;
	    }
	  } else {
	    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
	  }
	  if (verticalSwiping) {
	    swipeLeft = curLeft + touchSwipeLength * positionOffset;
	  }
	  state = _extends({}, state, {
	    touchObject: touchObject,
	    swipeLeft: swipeLeft,
	    trackStyle: getTrackCSS(_extends({}, spec, { left: swipeLeft }))
	  });
	  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	    return state;
	  }
	  if (touchObject.swipeLength > 10) {
	    state["swiping"] = true;
	    e.preventDefault();
	  }
	  return state;
	};
	var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
	  var dragging = spec.dragging,
	      swipe = spec.swipe,
	      touchObject = spec.touchObject,
	      listWidth = spec.listWidth,
	      touchThreshold = spec.touchThreshold,
	      verticalSwiping = spec.verticalSwiping,
	      listHeight = spec.listHeight,
	      currentSlide = spec.currentSlide,
	      swipeToSlide = spec.swipeToSlide,
	      scrolling = spec.scrolling,
	      onSwipe = spec.onSwipe;
	
	  if (!dragging) {
	    if (swipe) e.preventDefault();
	    return {};
	  }
	  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
	  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
	  // reset the state of touch related state variables.
	  var state = {
	    dragging: false,
	    edgeDragged: false,
	    scrolling: false,
	    swiping: false,
	    swiped: false,
	    swipeLeft: null,
	    touchObject: {}
	  };
	  if (scrolling) {
	    return state;
	  }
	  if (!touchObject.swipeLength) {
	    return state;
	  }
	  if (touchObject.swipeLength > minSwipe) {
	    e.preventDefault();
	    if (onSwipe) {
	      onSwipe(swipeDirection);
	    }
	    var slideCount = void 0,
	        newSlide = void 0;
	    switch (swipeDirection) {
	      case "left":
	      case "up":
	        newSlide = currentSlide + getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 0;
	        break;
	      case "right":
	      case "down":
	        newSlide = currentSlide - getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 1;
	        break;
	      default:
	        slideCount = currentSlide;
	    }
	    state["triggerSlideHandler"] = slideCount;
	  } else {
	    // Adjust the track back to it's original position.
	    var currentLeft = getTrackLeft(spec);
	    state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, { left: currentLeft }));
	  }
	  return state;
	};
	var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
	  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
	  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var indexes = [];
	  while (breakpoint < max) {
	    indexes.push(breakpoint);
	    breakpoint = counter + spec.slidesToScroll;
	    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
	  }
	  return indexes;
	};
	var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
	  var navigables = getNavigableIndexes(spec);
	  var prevNavigable = 0;
	  if (index > navigables[navigables.length - 1]) {
	    index = navigables[navigables.length - 1];
	  } else {
	    for (var n in navigables) {
	      if (index < navigables[n]) {
	        index = prevNavigable;
	        break;
	      }
	      prevNavigable = navigables[n];
	    }
	  }
	  return index;
	};
	var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
	  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
	  if (spec.swipeToSlide) {
	    var swipedSlide = void 0;
	    var slickList = _reactDom2.default.findDOMNode(spec.listRef);
	    var slides = slickList.querySelectorAll(".slick-slide");
	    Array.from(slides).every(function (slide) {
	      if (!spec.vertical) {
	        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      } else {
	        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      }
	
	      return true;
	    });
	
	    if (!swipedSlide) {
	      return 0;
	    }
	    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
	    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
	    return slidesTraversed;
	  } else {
	    return spec.slidesToScroll;
	  }
	};
	
	var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error("Keys Missing:", spec);
	};
	
	var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
	  var trackWidth = void 0,
	      trackHeight = void 0;
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	  if (!spec.vertical) {
	    trackWidth = getTotalSlides(spec) * spec.slideWidth;
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	  var style = {
	    opacity: 1,
	    transition: "",
	    WebkitTransition: ""
	  };
	  if (spec.useTransform) {
	    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
	    style = _extends({}, style, {
	      WebkitTransform: WebkitTransform,
	      transform: transform,
	      msTransform: msTransform
	    });
	  } else {
	    if (spec.vertical) {
	      style["top"] = spec.left;
	    } else {
	      style["left"] = spec.left;
	    }
	  }
	  if (spec.fade) style = { opacity: 1 };
	  if (trackWidth) style.width = trackWidth;
	  if (trackHeight) style.height = trackHeight;
	
	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + "px";
	    } else {
	      style.marginTop = spec.left + "px";
	    }
	  }
	
	  return style;
	};
	var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  if (spec.useTransform) {
	    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
	    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
	  } else {
	    if (spec.vertical) {
	      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
	    } else {
	      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	  return style;
	};
	var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
	  if (spec.unslick) {
	    return 0;
	  }
	
	  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
	
	  var slideIndex = spec.slideIndex,
	      trackRef = spec.trackRef,
	      infinite = spec.infinite,
	      centerMode = spec.centerMode,
	      slideCount = spec.slideCount,
	      slidesToShow = spec.slidesToShow,
	      slidesToScroll = spec.slidesToScroll,
	      slideWidth = spec.slideWidth,
	      listWidth = spec.listWidth,
	      variableWidth = spec.variableWidth,
	      slideHeight = spec.slideHeight,
	      fade = spec.fade,
	      vertical = spec.vertical;
	
	
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (fade || spec.slideCount === 1) {
	    return 0;
	  }
	
	  var slidesToOffset = 0;
	  if (infinite) {
	    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
	    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
	    }
	    // shift current slide to center of the frame
	    if (centerMode) {
	      slidesToOffset += parseInt(slidesToShow / 2);
	    }
	  } else {
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
	    }
	    if (centerMode) {
	      slidesToOffset = parseInt(slidesToShow / 2);
	    }
	  }
	  slideOffset = slidesToOffset * slideWidth;
	  verticalOffset = slidesToOffset * slideHeight;
	
	  if (!vertical) {
	    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
	  }
	
	  if (variableWidth === true) {
	    var targetSlideIndex;
	    var trackElem = _reactDom2.default.findDOMNode(trackRef);
	    targetSlideIndex = slideIndex + getPreClones(spec);
	    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (centerMode === true) {
	      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
	      targetSlide = trackElem && trackElem.children[targetSlideIndex];
	      targetLeft = 0;
	      for (var slide = 0; slide < targetSlideIndex; slide++) {
	        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
	      }
	      targetLeft -= parseInt(spec.centerPadding);
	      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
	    }
	  }
	
	  return targetLeft;
	};
	
	var getPreClones = exports.getPreClones = function getPreClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	  if (spec.variableWidth) {
	    return spec.slideCount;
	  }
	  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
	};
	
	var getPostClones = exports.getPostClones = function getPostClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	  return spec.slideCount;
	};
	
	var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
	  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
	};
	var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
	  if (spec.targetSlide > spec.currentSlide) {
	    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
	      return "left";
	    }
	    return "right";
	  } else {
	    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
	      return "right";
	    }
	    return "left";
	  }
	};
	
	var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
	  var slidesToShow = _ref.slidesToShow,
	      centerMode = _ref.centerMode,
	      rtl = _ref.rtl,
	      centerPadding = _ref.centerPadding;
	
	  // returns no of slides on the right of active slide
	  if (centerMode) {
	    var right = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) right += 1;
	    if (rtl && slidesToShow % 2 === 0) right += 1;
	    return right;
	  }
	  if (rtl) {
	    return 0;
	  }
	  return slidesToShow - 1;
	};
	
	var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
	  var slidesToShow = _ref2.slidesToShow,
	      centerMode = _ref2.centerMode,
	      rtl = _ref2.rtl,
	      centerPadding = _ref2.centerPadding;
	
	  // returns no of slides on the left of active slide
	  if (centerMode) {
	    var left = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) left += 1;
	    if (!rtl && slidesToShow % 2 === 0) left += 1;
	    return left;
	  }
	  if (rtl) {
	    return slidesToShow - 1;
	  }
	  return 0;
	};
	
	var canUseDOM = exports.canUseDOM = function canUseDOM() {
	  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
	};

/***/ },
/* 553 */,
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buffers = exports.BUFFER_OVERFLOW = undefined;
	
	var _utils = __webpack_require__(144);
	
	var BUFFER_OVERFLOW = exports.BUFFER_OVERFLOW = 'Channel\'s Buffer overflow!';
	
	var ON_OVERFLOW_THROW = 1;
	var ON_OVERFLOW_DROP = 2;
	var ON_OVERFLOW_SLIDE = 3;
	var ON_OVERFLOW_EXPAND = 4;
	
	var zeroBuffer = { isEmpty: _utils.kTrue, put: _utils.noop, take: _utils.noop };
	
	function ringBuffer() {
	  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
	  var overflowAction = arguments[1];
	
	  var arr = new Array(limit);
	  var length = 0;
	  var pushIndex = 0;
	  var popIndex = 0;
	
	  var push = function push(it) {
	    arr[pushIndex] = it;
	    pushIndex = (pushIndex + 1) % limit;
	    length++;
	  };
	
	  var take = function take() {
	    if (length != 0) {
	      var it = arr[popIndex];
	      arr[popIndex] = null;
	      length--;
	      popIndex = (popIndex + 1) % limit;
	      return it;
	    }
	  };
	
	  var flush = function flush() {
	    var items = [];
	    while (length) {
	      items.push(take());
	    }
	    return items;
	  };
	
	  return {
	    isEmpty: function isEmpty() {
	      return length == 0;
	    },
	    put: function put(it) {
	      if (length < limit) {
	        push(it);
	      } else {
	        var doubledLimit = void 0;
	        switch (overflowAction) {
	          case ON_OVERFLOW_THROW:
	            throw new Error(BUFFER_OVERFLOW);
	          case ON_OVERFLOW_SLIDE:
	            arr[pushIndex] = it;
	            pushIndex = (pushIndex + 1) % limit;
	            popIndex = pushIndex;
	            break;
	          case ON_OVERFLOW_EXPAND:
	            doubledLimit = 2 * limit;
	
	            arr = flush();
	
	            length = arr.length;
	            pushIndex = arr.length;
	            popIndex = 0;
	
	            arr.length = doubledLimit;
	            limit = doubledLimit;
	
	            push(it);
	            break;
	          default:
	          // DROP
	        }
	      }
	    },
	    take: take, flush: flush
	  };
	}
	
	var buffers = exports.buffers = {
	  none: function none() {
	    return zeroBuffer;
	  },
	  fixed: function fixed(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_THROW);
	  },
	  dropping: function dropping(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_DROP);
	  },
	  sliding: function sliding(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
	  },
	  expanding: function expanding(initialSize) {
	    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
	  }
	};

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UNDEFINED_INPUT_ERROR = exports.INVALID_BUFFER = exports.isEnd = exports.END = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.emitter = emitter;
	exports.channel = channel;
	exports.eventChannel = eventChannel;
	exports.stdChannel = stdChannel;
	
	var _utils = __webpack_require__(144);
	
	var _buffers = __webpack_require__(554);
	
	var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
	var END = exports.END = { type: CHANNEL_END_TYPE };
	var isEnd = exports.isEnd = function isEnd(a) {
	  return a && a.type === CHANNEL_END_TYPE;
	};
	
	function emitter() {
	  var subscribers = [];
	
	  function subscribe(sub) {
	    subscribers.push(sub);
	    return function () {
	      return (0, _utils.remove)(subscribers, sub);
	    };
	  }
	
	  function emit(item) {
	    var arr = subscribers.slice();
	    for (var i = 0, len = arr.length; i < len; i++) {
	      arr[i](item);
	    }
	  }
	
	  return {
	    subscribe: subscribe,
	    emit: emit
	  };
	}
	
	var INVALID_BUFFER = exports.INVALID_BUFFER = 'invalid buffer passed to channel factory function';
	var UNDEFINED_INPUT_ERROR = exports.UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';
	
	if (false) {
	  exports.UNDEFINED_INPUT_ERROR = UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
	}
	
	function channel() {
	  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _buffers.buffers.fixed();
	
	  var closed = false;
	  var takers = [];
	
	  (0, _utils.check)(buffer, _utils.is.buffer, INVALID_BUFFER);
	
	  function checkForbiddenStates() {
	    if (closed && takers.length) {
	      throw (0, _utils.internalErr)('Cannot have a closed channel with pending takers');
	    }
	    if (takers.length && !buffer.isEmpty()) {
	      throw (0, _utils.internalErr)('Cannot have pending takers with non empty buffer');
	    }
	  }
	
	  function put(input) {
	    checkForbiddenStates();
	    (0, _utils.check)(input, _utils.is.notUndef, UNDEFINED_INPUT_ERROR);
	    if (closed) {
	      return;
	    }
	    if (!takers.length) {
	      return buffer.put(input);
	    }
	    for (var i = 0; i < takers.length; i++) {
	      var cb = takers[i];
	      if (!cb[_utils.MATCH] || cb[_utils.MATCH](input)) {
	        takers.splice(i, 1);
	        return cb(input);
	      }
	    }
	  }
	
	  function take(cb) {
	    checkForbiddenStates();
	    (0, _utils.check)(cb, _utils.is.func, 'channel.take\'s callback must be a function');
	
	    if (closed && buffer.isEmpty()) {
	      cb(END);
	    } else if (!buffer.isEmpty()) {
	      cb(buffer.take());
	    } else {
	      takers.push(cb);
	      cb.cancel = function () {
	        return (0, _utils.remove)(takers, cb);
	      };
	    }
	  }
	
	  function flush(cb) {
	    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
	    (0, _utils.check)(cb, _utils.is.func, 'channel.flush\' callback must be a function');
	    if (closed && buffer.isEmpty()) {
	      cb(END);
	      return;
	    }
	    cb(buffer.flush());
	  }
	
	  function close() {
	    checkForbiddenStates();
	    if (!closed) {
	      closed = true;
	      if (takers.length) {
	        var arr = takers;
	        takers = [];
	        for (var i = 0, len = arr.length; i < len; i++) {
	          arr[i](END);
	        }
	      }
	    }
	  }
	
	  return { take: take, put: put, flush: flush, close: close,
	    get __takers__() {
	      return takers;
	    },
	    get __closed__() {
	      return closed;
	    }
	  };
	}
	
	function eventChannel(subscribe) {
	  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _buffers.buffers.none();
	  var matcher = arguments[2];
	
	  /**
	    should be if(typeof matcher !== undefined) instead?
	    see PR #273 for a background discussion
	  **/
	  if (arguments.length > 2) {
	    (0, _utils.check)(matcher, _utils.is.func, 'Invalid match function passed to eventChannel');
	  }
	
	  var chan = channel(buffer);
	  var unsubscribe = subscribe(function (input) {
	    if (isEnd(input)) {
	      chan.close();
	    } else if (!matcher || matcher(input)) {
	      chan.put(input);
	    }
	  });
	
	  if (!_utils.is.func(unsubscribe)) {
	    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
	  }
	
	  return {
	    take: chan.take,
	    flush: chan.flush,
	    close: function close() {
	      if (!chan.__closed__) {
	        chan.close();
	        unsubscribe();
	      }
	    }
	  };
	}
	
	function stdChannel(subscribe) {
	  var chan = eventChannel(subscribe);
	
	  return _extends({}, chan, {
	    take: function take(cb, matcher) {
	      if (arguments.length > 1) {
	        (0, _utils.check)(matcher, _utils.is.func, 'channel.take\'s matcher argument must be a function');
	        cb[_utils.MATCH] = matcher;
	      }
	      chan.take(cb);
	    }
	  });
	}

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.asEffect = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.take = take;
	exports.takem = takem;
	exports.put = put;
	exports.race = race;
	exports.call = call;
	exports.apply = apply;
	exports.cps = cps;
	exports.fork = fork;
	exports.spawn = spawn;
	exports.join = join;
	exports.cancel = cancel;
	exports.select = select;
	exports.actionChannel = actionChannel;
	exports.cancelled = cancelled;
	exports.flush = flush;
	
	var _utils = __webpack_require__(144);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var IO = (0, _utils.sym)('IO');
	var TAKE = 'TAKE';
	var PUT = 'PUT';
	var RACE = 'RACE';
	var CALL = 'CALL';
	var CPS = 'CPS';
	var FORK = 'FORK';
	var JOIN = 'JOIN';
	var CANCEL = 'CANCEL';
	var SELECT = 'SELECT';
	var ACTION_CHANNEL = 'ACTION_CHANNEL';
	var CANCELLED = 'CANCELLED';
	var FLUSH = 'FLUSH';
	
	var effect = function effect(type, payload) {
	  var _ref;
	
	  return _ref = {}, _defineProperty(_ref, IO, true), _defineProperty(_ref, type, payload), _ref;
	};
	
	function take() {
	  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';
	
	  if (arguments.length) {
	    (0, _utils.check)(arguments[0], _utils.is.notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
	  }
	  if (_utils.is.pattern(patternOrChannel)) {
	    return effect(TAKE, { pattern: patternOrChannel });
	  }
	  if (_utils.is.channel(patternOrChannel)) {
	    return effect(TAKE, { channel: patternOrChannel });
	  }
	  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
	}
	
	function takem() {
	  var eff = take.apply(undefined, arguments);
	  eff[TAKE].maybe = true;
	  return eff;
	}
	
	function put(channel, action) {
	  if (arguments.length > 1) {
	    (0, _utils.check)(channel, _utils.is.notUndef, 'put(channel, action): argument channel is undefined');
	    (0, _utils.check)(channel, _utils.is.channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
	    (0, _utils.check)(action, _utils.is.notUndef, 'put(channel, action): argument action is undefined');
	  } else {
	    (0, _utils.check)(channel, _utils.is.notUndef, 'put(action): argument action is undefined');
	    action = channel;
	    channel = null;
	  }
	  return effect(PUT, { channel: channel, action: action });
	}
	
	put.sync = function () {
	  var eff = put.apply(undefined, arguments);
	  eff[PUT].sync = true;
	  return eff;
	};
	
	function race(effects) {
	  return effect(RACE, effects);
	}
	
	function getFnCallDesc(meth, fn, args) {
	  (0, _utils.check)(fn, _utils.is.notUndef, meth + ': argument fn is undefined');
	
	  var context = null;
	  if (_utils.is.array(fn)) {
	    var _fn = fn;
	
	    var _fn2 = _slicedToArray(_fn, 2);
	
	    context = _fn2[0];
	    fn = _fn2[1];
	  } else if (fn.fn) {
	    var _fn3 = fn;
	    context = _fn3.context;
	    fn = _fn3.fn;
	  }
	  (0, _utils.check)(fn, _utils.is.func, meth + ': argument ' + fn + ' is not a function');
	
	  return { context: context, fn: fn, args: args };
	}
	
	function call(fn) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return effect(CALL, getFnCallDesc('call', fn, args));
	}
	
	function apply(context, fn) {
	  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
	}
	
	function cps(fn) {
	  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    args[_key2 - 1] = arguments[_key2];
	  }
	
	  return effect(CPS, getFnCallDesc('cps', fn, args));
	}
	
	function fork(fn) {
	  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    args[_key3 - 1] = arguments[_key3];
	  }
	
	  return effect(FORK, getFnCallDesc('fork', fn, args));
	}
	
	function spawn(fn) {
	  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    args[_key4 - 1] = arguments[_key4];
	  }
	
	  var eff = fork.apply(undefined, [fn].concat(args));
	  eff[FORK].detached = true;
	  return eff;
	}
	
	var isForkedTask = function isForkedTask(task) {
	  return task[_utils.TASK];
	};
	
	function join(task) {
	  (0, _utils.check)(task, _utils.is.notUndef, 'join(task): argument task is undefined');
	  if (!isForkedTask(task)) {
	    throw new Error('join(task): argument ' + task + ' is not a valid Task object \n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)');
	  }
	
	  return effect(JOIN, task);
	}
	
	function cancel(task) {
	  (0, _utils.check)(task, _utils.is.notUndef, 'cancel(task): argument task is undefined');
	  if (!isForkedTask(task)) {
	    throw new Error('cancel(task): argument ' + task + ' is not a valid Task object \n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)');
	  }
	
	  return effect(CANCEL, task);
	}
	
	function select(selector) {
	  for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	    args[_key5 - 1] = arguments[_key5];
	  }
	
	  if (arguments.length === 0) {
	    selector = _utils.ident;
	  } else {
	    (0, _utils.check)(selector, _utils.is.notUndef, 'select(selector,[...]): argument selector is undefined');
	    (0, _utils.check)(selector, _utils.is.func, 'select(selector,[...]): argument ' + selector + ' is not a function');
	  }
	  return effect(SELECT, { selector: selector, args: args });
	}
	
	/**
	  channel(pattern, [buffer])    => creates an event channel for store actions
	**/
	function actionChannel(pattern, buffer) {
	  (0, _utils.check)(pattern, _utils.is.notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
	  if (arguments.length > 1) {
	    (0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
	    (0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
	  }
	  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
	}
	
	function cancelled() {
	  return effect(CANCELLED, {});
	}
	
	function flush(channel) {
	  (0, _utils.check)(channel, _utils.is.channel, 'flush(channel): argument ' + channel + ' is not valid channel');
	  return effect(FLUSH, channel);
	}
	
	var asEffect = exports.asEffect = {
	  take: function take(effect) {
	    return effect && effect[IO] && effect[TAKE];
	  },
	  put: function put(effect) {
	    return effect && effect[IO] && effect[PUT];
	  },
	  race: function race(effect) {
	    return effect && effect[IO] && effect[RACE];
	  },
	  call: function call(effect) {
	    return effect && effect[IO] && effect[CALL];
	  },
	  cps: function cps(effect) {
	    return effect && effect[IO] && effect[CPS];
	  },
	  fork: function fork(effect) {
	    return effect && effect[IO] && effect[FORK];
	  },
	  join: function join(effect) {
	    return effect && effect[IO] && effect[JOIN];
	  },
	  cancel: function cancel(effect) {
	    return effect && effect[IO] && effect[CANCEL];
	  },
	  select: function select(effect) {
	    return effect && effect[IO] && effect[SELECT];
	  },
	  actionChannel: function actionChannel(effect) {
	    return effect && effect[IO] && effect[ACTION_CHANNEL];
	  },
	  cancelled: function cancelled(effect) {
	    return effect && effect[IO] && effect[CANCELLED];
	  },
	  flush: function flush(effect) {
	    return effect && effect[IO] && effect[FLUSH];
	  }
	};

/***/ },
/* 557 */,
/* 558 */,
/* 559 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GET_FREEBET = exports.GET_FREEBET = 'GET_FREEBET';
	var SUCCESS_GET_FREEBET = exports.SUCCESS_GET_FREEBET = 'SUCCESS_GET_FREEBET';
	var FAILURE_GET_FREEBET = exports.FAILURE_GET_FREEBET = 'FAILURE_GET_FREEBET';
	
	var TOGGLE_FREEBET = exports.TOGGLE_FREEBET = 'TOGGLE_FREEBET';

/***/ },
/* 560 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var INIT_PREMATCH_MENU = exports.INIT_PREMATCH_MENU = 'INIT_PREMATCH_MENU';
	var SUCCESS_INIT_PREMATCH_MENU = exports.SUCCESS_INIT_PREMATCH_MENU = 'SUCCESS_INIT_PREMATCH_MENU';
	var FAILURE_INIT_PREMATCH_MENU = exports.FAILURE_INIT_PREMATCH_MENU = 'FAILURE_INIT_PREMATCH_MENU';

/***/ },
/* 561 */,
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.requestFullLine = requestFullLine;
	exports.requestLineHeaders = requestLineHeaders;
	exports.requestSportLineHeaders = requestSportLineHeaders;
	exports.requestLeagueLineHeaders = requestLeagueLineHeaders;
	exports.clearLine = clearLine;
	exports.showLineNumbers = showLineNumbers;
	exports.hideLineNumbers = hideLineNumbers;
	
	var _api = __webpack_require__(13);
	
	var _transform = __webpack_require__(336);
	
	var _Line = __webpack_require__(38);
	
	var ActionTypes = _interopRequireWildcard(_Line);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchFullLine(data) {
	    var _ref;
	
	    var languageId = data.languageId,
	        eventId = data.eventId;
	
	
	    return _ref = {
	        type: ActionTypes.REQUEST_FULL_LINE
	    }, (0, _defineProperty3.default)(_ref, _api.CALL_API, {
	        endpoint: '/api/event/' + eventId + '/full?languageId=' + languageId,
	        method: 'get',
	        types: [ActionTypes.SUCCESS_REQUEST_FULL_LINE, ActionTypes.FAILURE_REQUEST_FULL_LINE],
	        data: data
	    }), (0, _defineProperty3.default)(_ref, _transform.TRANSFORM, {
	        section: 'preMatch',
	        transformType: 'init',
	        provider: function provider(data) {
	            return data;
	        }
	    }), _ref;
	}
	
	function requestFullLine(data) {
	    return function (dispatch) {
	        return dispatch(fetchFullLine(data));
	    };
	}
	
	function fetchLineHeaders(data) {
	    var _ref2;
	
	    var languageId = data.languageId;
	
	
	    return _ref2 = {
	        type: ActionTypes.REQUEST_LINE_HEADERS
	    }, (0, _defineProperty3.default)(_ref2, _api.CALL_API, {
	        endpoint: '/api/line/headers?languageId=' + languageId,
	        method: 'get',
	        types: [ActionTypes.SUCCESS_REQUEST_LINE_HEADERS, ActionTypes.FAILURE_REQUEST_LINE_HEADERS],
	        data: data
	    }), (0, _defineProperty3.default)(_ref2, _transform.TRANSFORM, {
	        section: 'preMatch',
	        transformType: 'init',
	        provider: function provider(data) {
	            return data;
	        }
	    }), _ref2;
	}
	
	function requestLineHeaders(data) {
	    return function (dispatch) {
	        return dispatch(fetchLineHeaders(data));
	    };
	}
	
	function fetchSportLineHeaders(data) {
	    var _ref3;
	
	    var sportId = data.sportId,
	        languageId = data.languageId;
	
	
	    return _ref3 = {
	        type: ActionTypes.REQUEST_SPORT_LINE_HEADERS
	    }, (0, _defineProperty3.default)(_ref3, _api.CALL_API, {
	        endpoint: '/api/line/sport/' + sportId + '/headers?languageId=' + languageId,
	        method: 'get',
	        types: [ActionTypes.SUCCESS_REQUEST_SPORT_LINE_HEADERS, ActionTypes.FAILURE_REQUEST_SPORT_LINE_HEADERS],
	        data: data
	    }), (0, _defineProperty3.default)(_ref3, _transform.TRANSFORM, {
	        section: 'preMatch',
	        transformType: 'init',
	        provider: function provider(data) {
	            return data;
	        }
	    }), _ref3;
	}
	
	function requestSportLineHeaders(data) {
	    return function (dispatch) {
	        return dispatch(fetchSportLineHeaders(data));
	    };
	}
	
	function fetchLeagueLineHeaders(data) {
	    var _ref4;
	
	    var leagueId = data.leagueId,
	        languageId = data.languageId;
	
	
	    return _ref4 = {
	        type: ActionTypes.REQUEST_LEAGUE_LINE_HEADERS
	    }, (0, _defineProperty3.default)(_ref4, _api.CALL_API, {
	        endpoint: '/api/line/league/' + leagueId + '/headers?languageId=' + languageId,
	        method: 'get',
	        types: [ActionTypes.SUCCESS_REQUEST_LEAGUE_LINE_HEADERS, ActionTypes.FAILURE_REQUEST_LEAGUE_LINE_HEADERS],
	        data: data
	    }), (0, _defineProperty3.default)(_ref4, _transform.TRANSFORM, {
	        section: 'preMatch',
	        transformType: 'init',
	        provider: function provider(data) {
	            return data;
	        }
	    }), _ref4;
	}
	
	function requestLeagueLineHeaders(data) {
	    return function (dispatch) {
	        return dispatch(fetchLeagueLineHeaders(data));
	    };
	}
	
	function clearLine() {
	    return { type: ActionTypes.CLEAR_LINE, section: 'preMatch' };
	}
	
	function showLineNumbers(section) {
	    return { type: ActionTypes.SHOW_LINE_NUMBERS, section: section };
	}
	function hideLineNumbers(section) {
	    return { type: ActionTypes.HIDE_LINE_NUMBERS, section: section };
	}

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setDisplayMode = setDisplayMode;
	
	var _SetDisplayMode = __webpack_require__(707);
	
	var ActionTypes = _interopRequireWildcard(_SetDisplayMode);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function setDisplayMode(data) {
	    return { type: ActionTypes.SET_DISPLAY_MODE, data: data };
	}

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.stopFetchStream = exports.fetchStream = undefined;
	
	var _Stream = __webpack_require__(708);
	
	var fetchStream = exports.fetchStream = function fetchStream(data) {
	  return { type: _Stream.LOAD_STREAM, data: data };
	};
	var stopFetchStream = exports.stopFetchStream = function stopFetchStream() {
	  return { type: _Stream.STOP_STREAM };
	};

/***/ },
/* 565 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setRadarWidget = setRadarWidget;
	exports.removeRadarWidget = removeRadarWidget;
	var SET_RADAR_WIDGET = exports.SET_RADAR_WIDGET = 'SET_RADAR_WIDGET';
	var REMOVE_RADAR_WIDGET = exports.REMOVE_RADAR_WIDGET = 'REMOVE_RADAR_WIDGET';
	
	function setRadarWidget(data) {
	  return function (dispatch) {
	    return dispatch({ type: SET_RADAR_WIDGET, data: data });
	  };
	}
	
	function removeRadarWidget() {
	  return function (dispatch) {
	    return dispatch({ type: REMOVE_RADAR_WIDGET });
	  };
	}

/***/ },
/* 566 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var UNAVAILABLE = exports.UNAVAILABLE = 0;
	var AVAILABLE = exports.AVAILABLE = 1;
	var MBOX_SHOWN = exports.MBOX_SHOWN = 2;
	var SELL_REQUESTED = exports.SELL_REQUESTED = 3;
	var SUCCESS = exports.SUCCESS = 4;
	var REJECTED = exports.REJECTED = 5;
	var AMOUNT_CHANGED = exports.AMOUNT_CHANGED = 6;

/***/ },
/* 567 */,
/* 568 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SMS = exports.SMS = 1;
	var EMAIL = exports.EMAIL = 2;

/***/ },
/* 569 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NONE = exports.NONE = 1;
	var INIT = exports.INIT = 2;
	var PHONE_CONFIRMATION = exports.PHONE_CONFIRMATION = 3;
	var EMAIL_SENT = exports.EMAIL_SENT = 4;
	var SUCCESS = exports.SUCCESS = 5;

/***/ },
/* 570 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var maxAmount = exports.maxAmount = {
	    OPX: 5000,
	    UZS: 99999999
	};

/***/ },
/* 571 */,
/* 572 */,
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fields = undefined;
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(8);
	
	var _PasswordFormValidation = __webpack_require__(574);
	
	var _PasswordFormValidation2 = _interopRequireDefault(_PasswordFormValidation);
	
	var _stripCorrectProps = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    profile_password_form_new_password_label: {
	        id: 'create-password.profile_password_form_new_password_label',
	        defaultMessage: 'Новый пароль'
	    },
	    profile_password_form_retype_password: {
	        id: 'create-password.profile_password_form_retype_password',
	        defaultMessage: 'Повторите пароль'
	    },
	    profile_password_form_btn_msg: {
	        id: 'create-password.profile_password_form_btn_msg',
	        defaultMessage: 'Сохранить'
	    }
	});
	
	var SUCCESSFUL_UPDATE_REQUEST = 0;
	
	var fields = exports.fields = ['NewPassword', 'NewPasswordConfirm'];
	
	var PasswordForm = function (_React$Component) {
	    (0, _inherits3.default)(PasswordForm, _React$Component);
	    (0, _createClass3.default)(PasswordForm, null, [{
	        key: '_renderError',
	        value: function _renderError(error) {
	            return _react2.default.createElement(
	                'div',
	                { style: { marginLeft: '170px', color: '#9e2929' } },
	                _react2.default.createElement(_reactIntl.FormattedMessage, error)
	            );
	        }
	    }]);
	
	    function PasswordForm(props) {
	        (0, _classCallCheck3.default)(this, PasswordForm);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (PasswordForm.__proto__ || (0, _getPrototypeOf2.default)(PasswordForm)).call(this, props));
	
	        _this.state = { requestSent: false, successfulRequest: false };
	        _this._onSubmit = _this._onSubmit.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(PasswordForm, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            if (this.props.isUpdating && !newProps.isUpdating) {
	                this.setState({ requestSent: true });
	            } else {
	                this.setState({ requestSent: false });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.requestSent && this.props.isUpdated == SUCCESSFUL_UPDATE_REQUEST) {
	                this.props.resetForm();
	            }
	        }
	    }, {
	        key: '_onSubmit',
	        value: function _onSubmit(values) {
	            this.props.submitAction(values);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                _props$fields = _props.fields,
	                NewPassword = _props$fields.NewPassword,
	                NewPasswordConfirm = _props$fields.NewPasswordConfirm,
	                handleSubmit = _props.handleSubmit;
	
	            var submitHandler = this._onSubmit;
	
	            var formClass = 'settings--form settings--form__password-change form';
	            var cleanClass = 'profile--form__row form__row';
	            var errorClass = 'profile--form__row form__row form__row__error';
	            var labelClass = 'settings--form__label form__label';
	            var inputClass = 'settings--form__control form__control';
	            var btnClass = 'withdrawal--form__btn withdrawal-bid--form__btn__js form__btn';
	
	            return _react2.default.createElement(
	                'form',
	                { className: formClass, onSubmit: handleSubmit(submitHandler) },
	                _react2.default.createElement('input', { style: { display: 'none' }, type: 'password', name: 'fakepasswordremembered' }),
	                NewPassword.touched && NewPassword.error && _react2.default.createElement(
	                    'div',
	                    { className: errorClass },
	                    _react2.default.createElement(
	                        'label',
	                        { className: labelClass },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.profile_password_form_new_password_label)
	                    ),
	                    _react2.default.createElement('input', (0, _extends3.default)({ type: 'password', className: inputClass }, (0, _stripCorrectProps.stripProps)(NewPassword))),
	                    PasswordForm._renderError(NewPassword.error)
	                ),
	                (!NewPassword.touched || !NewPassword.error) && _react2.default.createElement(
	                    'div',
	                    { className: cleanClass },
	                    _react2.default.createElement(
	                        'label',
	                        { className: labelClass },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.profile_password_form_new_password_label)
	                    ),
	                    _react2.default.createElement('input', (0, _extends3.default)({ type: 'password', className: inputClass }, (0, _stripCorrectProps.stripProps)(NewPassword)))
	                ),
	                NewPasswordConfirm.touched && NewPasswordConfirm.error && _react2.default.createElement(
	                    'div',
	                    { className: errorClass },
	                    _react2.default.createElement(
	                        'label',
	                        { className: labelClass },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.profile_password_form_retype_password)
	                    ),
	                    _react2.default.createElement('input', (0, _extends3.default)({ type: 'password', className: inputClass }, (0, _stripCorrectProps.stripProps)(NewPasswordConfirm))),
	                    PasswordForm._renderError(NewPasswordConfirm.error)
	                ),
	                (!NewPasswordConfirm.touched || !NewPasswordConfirm.error) && _react2.default.createElement(
	                    'div',
	                    { className: cleanClass },
	                    _react2.default.createElement(
	                        'label',
	                        { className: labelClass },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.profile_password_form_retype_password)
	                    ),
	                    _react2.default.createElement('input', (0, _extends3.default)({ type: 'password', className: inputClass }, (0, _stripCorrectProps.stripProps)(NewPasswordConfirm)))
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'settings--form__row form__row' },
	                    _react2.default.createElement(
	                        'button',
	                        { type: 'submit', className: btnClass, onClick: handleSubmit(submitHandler) },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.profile_password_form_btn_msg)
	                    )
	                )
	            );
	        }
	    }]);
	    return PasswordForm;
	}(_react2.default.Component);
	
	PasswordForm.propTypes = {
	    fields: _react2.default.PropTypes.any,
	    handleSubmit: _react2.default.PropTypes.any,
	    resetForm: _react2.default.PropTypes.any,
	    submitAction: _react2.default.PropTypes.func.isRequired,
	    isUpdating: _react2.default.PropTypes.any,
	    isUpdated: _react2.default.PropTypes.any
	};
	exports.default = (0, _reduxForm.reduxForm)({
	    form: 'password-form',
	    fields: fields,
	    initialValues: {},
	    validate: _PasswordFormValidation2.default
	})(PasswordForm);

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactIntl = __webpack_require__(8);
	
	var messages = (0, _reactIntl.defineMessages)({
	    password_form_error_empty_field: {
	        id: 'create-password.password_form_error_empty_field',
	        defaultMessage: 'Поле обязательно для заполнения'
	    },
	    password_form_error_mismatch: {
	        id: 'create-password.password_form_error_mismatch',
	        defaultMessage: 'Подтверждение пароля не совпадает'
	    }
	});
	
	var PasswordFormValidation = function PasswordFormValidation(values) {
	    var errors = {};
	
	    var newPassword = values.NewPassword;
	    var newPasswordConfirm = values.NewPasswordConfirm;
	
	    if (!newPassword || !newPassword.length) {
	        errors.NewPassword = messages.password_form_error_empty_field;
	    }
	
	    if (!newPasswordConfirm || !newPasswordConfirm.length) {
	        errors.NewPasswordConfirm = messages.password_form_error_empty_field;
	    } else if (newPassword != newPasswordConfirm) {
	        errors.NewPasswordConfirm = messages.password_form_error_mismatch;
	    }
	
	    return errors;
	};
	
	exports.default = PasswordFormValidation;

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouterRedux = __webpack_require__(23);
	
	var _reactIntl = __webpack_require__(8);
	
	var _createPassword = __webpack_require__(490);
	
	var _PasswordForm = __webpack_require__(573);
	
	var _PasswordForm2 = _interopRequireDefault(_PasswordForm);
	
	var _CreatePasswordStage = __webpack_require__(159);
	
	var CreatePasswordStage = _interopRequireWildcard(_CreatePasswordStage);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    success: {
	        id: 'create-password.password_changed',
	        defaultMessage: 'Пароль изменен'
	    }
	});
	
	var CreatePasswordModal = function (_React$Component) {
	    (0, _inherits3.default)(CreatePasswordModal, _React$Component);
	
	    function CreatePasswordModal(props) {
	        (0, _classCallCheck3.default)(this, CreatePasswordModal);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (CreatePasswordModal.__proto__ || (0, _getPrototypeOf2.default)(CreatePasswordModal)).call(this, props));
	
	        _this.propTypes = {
	            push: _react2.default.PropTypes.func.isRequired,
	            createPasswordAction: _react2.default.PropTypes.func.isRequired,
	            initCreatePasswordAction: _react2.default.PropTypes.func.isRequired,
	            passwordStage: _react2.default.PropTypes.number.isRequired
	        };
	
	
	        _this.onHandleSubmit = _this.onHandleSubmit.bind(_this);
	        _this.onModalClose = _this.onModalClose.bind(_this);
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(CreatePasswordModal, [{
	        key: 'onHandleSubmit',
	        value: function onHandleSubmit(data) {
	            this.props.createPasswordAction(data);
	        }
	    }, {
	        key: 'onModalClose',
	        value: function onModalClose() {
	            this.props.initCreatePasswordAction();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var passwordStage = this.props.passwordStage;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'modal--content__wrapper' },
	                passwordStage === CreatePasswordStage.INIT && _react2.default.createElement(_PasswordForm2.default, { submitAction: this.onHandleSubmit }),
	                passwordStage === CreatePasswordStage.SUCCESS && _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    messages.success,
	                    function (m) {
	                        return _react2.default.createElement(
	                            'span',
	                            { className: 'modal--auth-recover__title__span' },
	                            m
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	    return CreatePasswordModal;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(null, {
	    createPasswordAction: _createPassword.createPassword,
	    initCreatePasswordAction: _createPassword.initCreatePassword,
	    push: _reactRouterRedux.push
	})(CreatePasswordModal);

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = auth;
	
	var _immutable = __webpack_require__(14);
	
	var _SigninAction = __webpack_require__(158);
	
	var Signin = _interopRequireWildcard(_SigninAction);
	
	var _SignoutAction = __webpack_require__(118);
	
	var Signout = _interopRequireWildcard(_SignoutAction);
	
	var _loadAuthAction = __webpack_require__(131);
	
	var LoadAuth = _interopRequireWildcard(_loadAuthAction);
	
	var _sessionExpiredAction = __webpack_require__(561);
	
	var SessionExpired = _interopRequireWildcard(_sessionExpiredAction);
	
	var _PhoneConfirmation = __webpack_require__(156);
	
	var PhoneConfirm = _interopRequireWildcard(_PhoneConfirmation);
	
	var _FastJoin = __webpack_require__(157);
	
	var FastJoin = _interopRequireWildcard(_FastJoin);
	
	var _Auth = __webpack_require__(301);
	
	var AuthActions = _interopRequireWildcard(_Auth);
	
	var _PasswordRecovery = __webpack_require__(303);
	
	var PasswordRecoveryActions = _interopRequireWildcard(_PasswordRecovery);
	
	var _AuthError = __webpack_require__(493);
	
	var AuthError = _interopRequireWildcard(_AuthError);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = (0, _immutable.Map)({
	    signInOngoing: false,
	    isAuthenticating: null,
	    isSignout: null,
	    user: null,
	    authError: null
	});
	
	//sport-betting
	function auth() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case PhoneConfirm.SUCCESS_CONFIRM_PHONE:
	            if (action.data.User) {
	                var user = (0, _immutable.Map)({
	                    gamblerId: action.data.User.Id,
	                    login: action.data.User.Login,
	                    accountId: action.data.User.AccountId,
	                    accountNum: action.data.User.AccountNumber,
	                    gamblerAccountId: action.data.User.GamblerAccountId,
	                    isVerified: action.data.IsVerified,
	                    resourceId: action.data.User.AccountResourceId,
	                    selfBlockingExpired: action.data.User.SelfBlockingEndDate,
	                    selfBlockingUnlock: action.data.User.SelfBlockingUnlock,
	                    name: action.data.User.FirstName,
	                    lastName: action.data.User.LastName,
	                    email: action.data.User.Email
	                });
	
	                state = state.set('user', user);
	            }
	            break;
	
	        case SessionExpired.SESSION_EXPIRED:
	            state = initialState;
	            break;
	
	        case Signin.SIGNIN:
	        case LoadAuth.RESTORE:
	            state = state.set('isAuthenticating', true);
	            state = state.set('authError', null);
	            break;
	
	        case Signout.SIGNOUT:
	            state = state.set('isSignout', true);
	            break;
	
	        case Signin.SUCCESS_SIGNIN:
	        case LoadAuth.SUCCESS_RESTORE:
	        case FastJoin.SUCCESS_FAST_CONFIRM_PHONE:
	            {
	                state = state.set('isAuthenticating', false);
	                // auth responded with error
	                var error = action.data.Error;
	                if (error !== undefined) {
	
	                    state = state.set('authError', error);
	
	                    if (error === AuthError.NOT_ACTIVATED) {
	                        state = state.set('email', action.data.Email);
	                    }
	                } else {
	                    var _user = (0, _immutable.Map)({
	                        gamblerId: action.data.Id,
	                        login: action.data.Login,
	                        accountId: action.data.AccountId,
	                        accountNum: action.data.AccountNumber,
	                        gamblerAccountId: action.data.GamblerAccountId,
	                        isVerified: action.data.IsVerified,
	                        resourceId: action.data.AccountResourceId,
	                        selfBlockingExpired: action.data.SelfBlockingEndDate,
	                        selfBlockingUnlock: action.data.SelfBlockingUnlock,
	                        name: action.data.FirstName,
	                        lastName: action.data.LastName,
	                        phone: action.data.Phone,
	                        email: action.data.Email,
	                        joinPromo: action.data.JoinPromo,
	                        phoneConfirmed: action.data.IsPhoneConfirmed
	                    });
	
	                    if (action.data.CountryId) {
	                        _user = _user.update('countryId', function () {
	                            return action.data.CountryId;
	                        });
	                    }
	
	                    state = state.set('user', _user);
	                    state = state.set('authError', null);
	                    state = state.set('signInOngoing', false);
	                }
	                break;
	            }
	
	        case Signout.SUCCESS_SIGNOUT:
	            if (action.data.Result) {
	                state = state.set('isAuthenticating', false);
	                state = state.set('user', null);
	                state = state.set('isSignout', false);
	            }
	            break;
	
	        case AuthActions.BEGIN_SIGNIN:
	            state = state.set('signInOngoing', true);
	            break;
	
	        case AuthActions.BEGIN_JOIN:
	            state = state.set('signInOngoing', false);
	            break;
	
	        case AuthActions.CANCEL_SIGNIN:
	        case PasswordRecoveryActions.BEGIN_PASSWORD_RECOVERY:
	            state = state.set('signInOngoing', false);
	            state = state.set('authError', null);
	            break;
	    }
	
	    return state;
	}

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = balance;
	
	var _immutable = __webpack_require__(14);
	
	var _balanceAction = __webpack_require__(132);
	
	var Balance = _interopRequireWildcard(_balanceAction);
	
	var _actions = __webpack_require__(30);
	
	var _SigninAction = __webpack_require__(158);
	
	var Signin = _interopRequireWildcard(_SigninAction);
	
	var _loadAuthAction = __webpack_require__(131);
	
	var LoadAuth = _interopRequireWildcard(_loadAuthAction);
	
	var _Combobet = __webpack_require__(387);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = (0, _immutable.Map)({ isLoading: null, value: null });
	
	function balance() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case Balance.FETCH_BALANCE:
	        case _actions.GET_BALANCE.REQUEST:
	            state = state.set('isLoading', true);
	            break;
	        case Balance.SUCCESS_FETCH_BALANCE:
	            sendBalance(action.data.response.Result);
	            state = state.set('isLoading', false);
	            state = state.set('value', action.data.response.Result);
	            break;
	        case _actions.GET_BALANCE.SUCCESS:
	            state = state.set('isLoading', false);
	            state = state.set('value', action.data.Result);
	            break;
	        case Balance.FAILURE_FETCH_BALANCE:
	        case _actions.GET_BALANCE.FAILURE:
	            state = state.set('isLoading', false);
	            state = state.set('value', null);
	            break;
	        case Signin.SUCCESS_SIGNIN:
	        case LoadAuth.SUCCESS_RESTORE:
	            if (action.data.Balance) {
	                state = state.set('value', action.data.Balance.Result);
	            }
	            break;
	
	    }
	
	    return state;
	}
	
	function sendBalance(balance) {
	    if (document.getElementById('combobetFrame')) {
	        var win = document.getElementById('combobetFrame').contentWindow;
	
	        var data = {
	            balance: balance
	        };
	
	        win.postMessage(data, _Combobet.combobetUrl);
	    }
	}

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _map = __webpack_require__(595);
	
	var _map2 = _interopRequireDefault(_map);
	
	exports.default = createPassword;
	
	var _CreatePasswordStage = __webpack_require__(159);
	
	var CreatePasswordStage = _interopRequireWildcard(_CreatePasswordStage);
	
	var _createPassword = __webpack_require__(384);
	
	var CreatePasswordActions = _interopRequireWildcard(_createPassword);
	
	var _FastJoin = __webpack_require__(157);
	
	var FastJoin = _interopRequireWildcard(_FastJoin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createPassword() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _map2.default();
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case FastJoin.SUCCESS_FAST_CONFIRM_PHONE:
	            if (!action.data.hasOwnProperty('Error')) {
	                return (0, _extends3.default)({}, state, { stage: CreatePasswordStage.INIT });
	            }
	            return state;
	        case CreatePasswordActions.SUCCESS_CREATE_PASSWORD:
	            if (action.data.ResultState === 0) {
	                return (0, _extends3.default)({}, state, { stage: CreatePasswordStage.SUCCESS });
	            } else {
	                return (0, _extends3.default)({}, state, { stage: CreatePasswordStage.INTERNAL_ERROR });
	            }
	        case CreatePasswordActions.FAILURE_CREATE_PASSWORD:
	            return (0, _extends3.default)({}, state, { stage: CreatePasswordStage.INTERNAL_ERROR });
	
	        case CreatePasswordActions.INIT_CREATE_PASSWORD:
	            return (0, _extends3.default)({}, state, { stage: CreatePasswordStage.NONE });
	
	        default:
	            return state;
	    }
	}

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = commonStateReducer;
	
	var _changeLanguage = __webpack_require__(71);
	
	var ChangeLanguageActions = _interopRequireWildcard(_changeLanguage);
	
	var _RepositoryState = __webpack_require__(119);
	
	var RepositoryState = _interopRequireWildcard(_RepositoryState);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function commonStateReducer(state, action) {
	    switch (action.type) {
	        case ChangeLanguageActions.CHANGE_LANGUAGE:
	            return RepositoryState.NOT_INITED;
	    }
	
	    return state;
	}

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (entities, action, section) {
	    if (entities === undefined) {
	        return initialState;
	    }
	
	    if (action.section !== section) {
	        entities = entities.update('state', function (s) {
	            return (0, _commonStateReducer2.default)(s, action);
	        });
	    } else {
	        try {
	            entities = entities.update('sports', function (s) {
	                return (0, _sportsReducer2.default)(s, action);
	            });
	            entities = entities.update('leagues', function (l) {
	                return (0, _leaguesReducer2.default)(l, action);
	            });
	            entities = entities.update('matches', function (m) {
	                return (0, _matchesReducer2.default)(m, action);
	            });
	            entities = entities.update('showLineNumbers', function (flag) {
	                return (0, _showLineNumbersReducer2.default)(flag, action);
	            });
	            entities = entities.update('scores', function (s) {
	                return (0, _scoresReducer2.default)(s, action);
	            });
	
	            entities = entities.update('rates', function (r) {
	                return (0, _ratesReducer2.default)(r, action);
	            });
	
	            entities = entities.update('outcomes', function (o) {
	                return (0, _outcomesReducer2.default)(o, action);
	            });
	
	            //entities = entities.update('outcomes', (o) =>
	            //    outcomesHeadersReducer(action, o, entities.get('matches'), entities.get('rates')));
	
	            // entities = entities.update('outcomes', (o) =>
	            //     outcomesGroupsReducer(action, o, entities.get('matches')));
	
	            entities = entities.update('groups', function (g) {
	                return (0, _groupsReducer2.default)(g, action, entities.get('outcomes'), entities.get('matches'));
	            });
	
	            entities = entities.update('matches', function (m) {
	                return (0, _matchGroupsReducer2.default)(action, m, entities.get('groups'));
	            });
	
	            entities = entities.update('state', function (s) {
	                return (0, _stateReducer2.default)(s, action);
	            });
	            entities = entities.update('version', function (v) {
	                return (0, _versionReducer2.default)(v, action);
	            });
	
	            entities = entities.update('valid', function () {
	                return true;
	            });
	        } catch (err) {
	            //if (process.env.NODE_ENV !== 'production') {
	            console.warn('Exception at entitiesReducer'); //eslint-disable-line no-console
	            console.warn(err); //eslint-disable-line no-console
	            //}
	            return initialState.set('valid', false);
	        }
	    }
	
	    return entities;
	};
	
	var _immutable = __webpack_require__(14);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _sportsReducer = __webpack_require__(589);
	
	var _sportsReducer2 = _interopRequireDefault(_sportsReducer);
	
	var _leaguesReducer = __webpack_require__(582);
	
	var _leaguesReducer2 = _interopRequireDefault(_leaguesReducer);
	
	var _matchesReducer = __webpack_require__(584);
	
	var _matchesReducer2 = _interopRequireDefault(_matchesReducer);
	
	var _scoresReducer = __webpack_require__(587);
	
	var _scoresReducer2 = _interopRequireDefault(_scoresReducer);
	
	var _groupsReducer = __webpack_require__(581);
	
	var _groupsReducer2 = _interopRequireDefault(_groupsReducer);
	
	var _outcomesReducer = __webpack_require__(585);
	
	var _outcomesReducer2 = _interopRequireDefault(_outcomesReducer);
	
	var _matchGroupsReducer = __webpack_require__(583);
	
	var _matchGroupsReducer2 = _interopRequireDefault(_matchGroupsReducer);
	
	var _ratesReducer = __webpack_require__(586);
	
	var _ratesReducer2 = _interopRequireDefault(_ratesReducer);
	
	var _stateReducer = __webpack_require__(590);
	
	var _stateReducer2 = _interopRequireDefault(_stateReducer);
	
	var _commonStateReducer = __webpack_require__(579);
	
	var _commonStateReducer2 = _interopRequireDefault(_commonStateReducer);
	
	var _versionReducer = __webpack_require__(591);
	
	var _versionReducer2 = _interopRequireDefault(_versionReducer);
	
	var _showLineNumbersReducer = __webpack_require__(588);
	
	var _showLineNumbersReducer2 = _interopRequireDefault(_showLineNumbersReducer);
	
	var _RepositoryState = __webpack_require__(119);
	
	var RepositoryState = _interopRequireWildcard(_RepositoryState);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.fromJS({
	    sports: {},
	    leagues: {},
	    matches: {},
	    groups: {},
	    outcomes: {},
	    rates: {},
	    scores: {},
	    valid: true,
	    state: RepositoryState.NOT_INITED,
	    showLineNumbers: false,
	    version: 0
	});
	// import outcomesHeadersReducer from './outcomesHeadersReducer';
	// import outcomesGroupsReducer from './outcomesGroupsReducer';

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = groupsReducer;
	
	var _immutable = __webpack_require__(14);
	
	var _utils = __webpack_require__(66);
	
	var _actions = __webpack_require__(30);
	
	var _Live = __webpack_require__(39);
	
	var LiveActions = _interopRequireWildcard(_Live);
	
	var _Line = __webpack_require__(38);
	
	var LineActions = _interopRequireWildcard(_Line);
	
	var _Expand = __webpack_require__(332);
	
	var ExpandActions = _interopRequireWildcard(_Expand);
	
	var _Collapse = __webpack_require__(331);
	
	var CollapseActions = _interopRequireWildcard(_Collapse);
	
	var _ToggleGroup = __webpack_require__(484);
	
	var ToggleGroupActions = _interopRequireWildcard(_ToggleGroup);
	
	var _StakeOfTheDay = __webpack_require__(51);
	
	var StakeOfTheDayActions = _interopRequireWildcard(_StakeOfTheDay);
	
	var _Popular = __webpack_require__(58);
	
	var PopularActions = _interopRequireWildcard(_Popular);
	
	var _groupHeaders = __webpack_require__(651);
	
	var _groupHeaders2 = _interopRequireDefault(_groupHeaders);
	
	var _axios = __webpack_require__(146);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function groupsReducer(groups, action, outcomes, matches) {
	    switch (action.type) {
	        case LiveActions.CLEAR_LIVE:
	        case LineActions.CLEAR_LINE:
	            return new _immutable.Map();
	
	        case _actions.LIVE_INIT.SUCCESS:
	        case LineActions.SUCCESS_REQUEST_LINE_HEADERS:
	        case LineActions.SUCCESS_REQUEST_SPORT_LINE_HEADERS:
	        case LineActions.SUCCESS_REQUEST_LEAGUE_LINE_HEADERS:
	        case StakeOfTheDayActions.SUCCESS_GET_STAKE_OF_THE_DAY:
	        case PopularActions.SUCCESS_GET_POPULAR_MATCHES:
	            return setGroups(new _immutable.Map(), action.data.groups.add, outcomes, matches);
	
	        case _actions.LIVE_UPDATE.SUCCESS:
	            return update(groups, outcomes, matches, action.data);
	
	        case LineActions.SUCCESS_REQUEST_FULL_LINE:
	            groups = setGroups(groups, action.data.groups.add, outcomes, matches);
	            return expandMatchGroups(groups, action.data.events.add);
	
	        case ExpandActions.EXPAND_ALL_GROUPS:
	            return expandAllGroups(groups);
	
	        case CollapseActions.COLLAPSE_ALL_GROUPS:
	            return collapseAllGroups(groups);
	
	        case ToggleGroupActions.TOGGLE_GROUP:
	            return toggleGroup(groups, action.data);
	
	        case ToggleGroupActions.EXPAND_GROUP:
	            return toggleExpandGroup(groups, action.data);
	    }
	
	    return groups;
	}
	
	function update(groups, outcomes, matches, data) {
	
	    if (data.sports !== undefined && data.sports.remove !== undefined) {
	        groups = (0, _utils.myRemoveEntitiesBySport)(groups, 'sportId', data.sports.remove);
	    }
	
	    if (data.leagues !== undefined && data.leagues.remove !== undefined) {
	        groups = (0, _utils.myRemoveEntities)(groups, 'leagueId', data.leagues.remove);
	    }
	
	    if (data.events !== undefined && data.events.remove !== undefined) {
	        groups = (0, _utils.myRemoveEntities)(groups, 'matchId', data.events.remove);
	    }
	
	    if (data.outcomes !== undefined) {
	        groups = removeGroupOutcomes(groups, outcomes, data.outcomes.remove);
	        groups = setGroups(groups, data.groups.add, outcomes, matches);
	        groups = updateGroups(groups, outcomes, data.groups.change);
	    }
	
	    return groups;
	}
	
	function removeGroupOutcomes(groups, outcomes, outcomesToRemove) {
	    if (outcomesToRemove === undefined) {
	        return groups;
	    }
	
	    var _loop = function _loop(i) {
	        var outcomeId = outcomesToRemove[i].id;
	        var groupWithOutcome = groups.find(function (g) {
	            return g.get('outcomes').includes(outcomeId);
	        });
	
	        if (groupWithOutcome) {
	            var id = groupWithOutcome.get('id');
	            if (groupWithOutcome.get('outcomes').size === 1) {
	                groups = groups.delete(id);
	            } else {
	                groups = groups.updateIn([id, 'outcomes'], function (g) {
	                    var index = g.indexOf(outcomeId);
	                    return g.remove(index);
	                });
	            }
	        }
	    };
	
	    for (var i = 0; i < outcomesToRemove.length; i++) {
	        _loop(i);
	    }
	
	    return groups;
	}
	
	function updateGroups(groups, outcomes, changedGroups) {
	    if (outcomes === undefined || changedGroups === undefined) {
	        return groups;
	    }
	
	    var _loop2 = function _loop2(i) {
	        var changedGroup = changedGroups[i];
	
	        var group = groups.get(changedGroup);
	        if (group) {
	            var filtered = outcomes.filter(function (o) {
	                return o.get('groupId') === changedGroup;
	            }).toArray();
	            if (filtered) {
	                var headers = filtered.filter(function (o) {
	                    return o.get('isHeader') === true;
	                });
	
	                (function (groupId, groupHasBody, groupOutcomes) {
	                    groups = groups.update(groupId, function (g) {
	                        return g.set('hasBody', groupHasBody).set('outcomes', groupOutcomes);
	                    });
	                })(changedGroup, filtered.length > headers.length, (0, _immutable.List)(filtered.map(function (o) {
	                    return o.get('id');
	                })));
	            } else {
	                (function (groupId) {
	                    groups = groups.update(groupId, function (g) {
	                        return g.set('hasBody', false).set('outcomes', new _immutable.List());
	                    });
	                })(changedGroup);
	            }
	        }
	    };
	
	    for (var i = 0; i < changedGroups.length; i++) {
	        _loop2(i);
	    }
	
	    return groups;
	}
	
	function setGroups(groups, addedGroups, outcomes, matches) {
	    if (outcomes === undefined) {
	        return groups;
	    }
	
	    var _loop3 = function _loop3(i) {
	        var addedGroup = addedGroups[i];
	
	        var match = matches.get(addedGroup.matchId);
	
	        var group = groups.get(addedGroup.id);
	        if (!group) {
	
	            var sportGroups = _groupHeaders2.default[match.get('realSportId')];
	            var groupConfig = sportGroups[addedGroup.type];
	
	            group = new _immutable.Map();
	
	            group = group.set('sportId', addedGroup.sportId);
	            group = group.set('realSportId', match.get('realSportId'));
	            group = group.set('leagueId', addedGroup.leagueId);
	            group = group.set('matchId', addedGroup.matchId);
	            group = group.set('isClosed', false);
	            group = group.set('type', addedGroup.type);
	            group = group.set('id', addedGroup.id);
	            group = group.set('parentId', groupConfig.parent);
	            group = group.set('priority', groupConfig.priority);
	            group = group.set('isExpanded', false);
	        }
	
	        if (!(addedGroup.type === 0 && groups.has(addedGroup.id))) {
	            group = group.set('isClosed', true);
	        }
	
	        group = group.set('hasBody', false);
	        group = group.set('outcomes', new _immutable.List());
	
	        var filtered = outcomes.filter(function (o) {
	            return o.get('groupId') === addedGroup.id;
	        }).toArray();
	        if (filtered) {
	            var headers = filtered.filter(function (o) {
	                return o.get('isHeader') === true;
	            });
	            if (filtered.length > headers.length) {
	                group = group.set('hasBody', true);
	            }
	
	            group = group.set('outcomes', (0, _immutable.List)(filtered.map(function (o) {
	                return o.get('id');
	            })));
	        }
	
	        groups = groups.set(addedGroup.id, group);
	    };
	
	    for (var i = 0; i < addedGroups.length; i++) {
	        _loop3(i);
	    }
	
	    return groups;
	}
	
	function toggleGroup(groups, groupId) {
	    return groups.updateIn([groupId], function (g) {
	        var isClosed = !g.get('isClosed');
	
	        if (g.get('isClosed')) {
	            try {
	                _axios2.default.post('/api/actions/set?type=expand');
	            } catch (error) {}
	        }
	
	        return g.set('isClosed', isClosed);
	    });
	}
	
	function expandAllGroups(groups) {
	    return (0, _immutable.Seq)(groups).map(function (g) {
	        g = g.set('isExpanded', true);
	        return g.set('isClosed', false);
	    }).toMap();
	}
	
	function collapseAllGroups(groups) {
	    return (0, _immutable.Seq)(groups).map(function (g) {
	        g = g.set('isExpanded', false);
	        return g.set('isClosed', true);
	    }).toMap();
	}
	
	function expandMatchGroups(groups, loadedMatches) {
	    if (loadedMatches.length === 0) {
	        return groups;
	    }
	
	    var _loop4 = function _loop4(i) {
	        var matchId = loadedMatches[i].id;
	
	        var matchGroups = groups.filter(function (g) {
	            return g.get('type') === 0 && g.get('matchId') === matchId;
	        });
	        var matchGroupIds = matchGroups.map(function (g) {
	            return g.get('id');
	        }).toArray();
	
	        for (var j = 0; j < matchGroupIds.length; j++) {
	            var groupId = matchGroupIds[j];
	
	            groups = groups.updateIn([groupId, 'isClosed'], function () {
	                return false;
	            });
	        }
	    };
	
	    for (var i = 0; i < loadedMatches.length; i++) {
	        _loop4(i);
	    }
	
	    return groups;
	}
	
	function toggleExpandGroup(groups, groupId) {
	    return groups.updateIn([groupId], function (g) {
	        return g.set('isExpanded', !g.get('isExpanded'));
	    });
	}

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (leagues, action) {
	    switch (action.type) {
	        case LiveActions.CLEAR_LIVE:
	        case LineActions.CLEAR_LINE:
	        case TimeTableActions.CLEAR_TIME_TABLE:
	            return (0, _immutable.Map)();
	
	        case _actions.LIVE_INIT.SUCCESS:
	        case _actions.TIMETABLE_INIT.SUCCESS:
	        case LineActions.SUCCESS_REQUEST_LINE_HEADERS:
	        case LineActions.SUCCESS_REQUEST_SPORT_LINE_HEADERS:
	        case LineActions.SUCCESS_REQUEST_LEAGUE_LINE_HEADERS:
	        case MatchResultActions.SUCCESS_FETCH_MATCH_RESULTS:
	        case StakeOfTheDayActions.SUCCESS_GET_STAKE_OF_THE_DAY:
	        case PopularActions.SUCCESS_GET_POPULAR_MATCHES:
	            return init((0, _immutable.Map)(), action.data);
	
	        case _actions.LIVE_UPDATE.SUCCESS:
	        case _actions.TIMETABLE_UPDATE.SUCCESS:
	            return update(leagues, action.data);
	
	        case FavouritesActions.TOGGLE_FAVOURITE_SPORT:
	            return toggleSportFavouriteLeagues(leagues, action.data);
	
	        case FavouritesActions.TOGGLE_FAVOURITE_LEAGUE:
	            return toggleFavouriteLeague(leagues, action.data);
	
	        case FavouritesActions.TOGGLE_FAVOURITE_MATCH:
	            return toggleFavouriteMatchLeague(leagues, action.data);
	    }
	
	    return leagues;
	};
	
	var _immutable = __webpack_require__(14);
	
	var _utils = __webpack_require__(66);
	
	var _actions = __webpack_require__(30);
	
	var _Live = __webpack_require__(39);
	
	var LiveActions = _interopRequireWildcard(_Live);
	
	var _Line = __webpack_require__(38);
	
	var LineActions = _interopRequireWildcard(_Line);
	
	var _Timetable = __webpack_require__(70);
	
	var TimeTableActions = _interopRequireWildcard(_Timetable);
	
	var _Favourites = __webpack_require__(155);
	
	var FavouritesActions = _interopRequireWildcard(_Favourites);
	
	var _MatchResults = __webpack_require__(68);
	
	var MatchResultActions = _interopRequireWildcard(_MatchResults);
	
	var _StakeOfTheDay = __webpack_require__(51);
	
	var StakeOfTheDayActions = _interopRequireWildcard(_StakeOfTheDay);
	
	var _Popular = __webpack_require__(58);
	
	var PopularActions = _interopRequireWildcard(_Popular);
	
	var _FavouriteState = __webpack_require__(79);
	
	var FavouriteState = _interopRequireWildcard(_FavouriteState);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function init(leagues, data) {
	    if (data.leagues !== undefined) {
	        leagues = addLeagues(leagues, data.leagues.add);
	    }
	    if (data.events !== undefined) {
	        leagues = addLeagueMatches(leagues, data.events.add);
	    }
	
	    return leagues;
	}
	
	function update(leagues, data) {
	    if (data.sports !== undefined && data.sports.remove !== undefined) {
	        //leagues = removeEntities(leagues, 'sportId', data.sports.remove);
	        leagues = (0, _utils.myRemoveEntitiesBySport)(leagues, 'sportId', data.sports.remove);
	    }
	
	    if (data.leagues !== undefined) {
	        //leagues = removeEntities(leagues, 'id', data.leagues.remove);
	        leagues = (0, _utils.myRemoveEntities)(leagues, 'id', data.leagues.remove);
	        leagues = addLeagues(leagues, data.leagues.add);
	        leagues = changeLeagues(leagues, data.leagues.change);
	    }
	
	    if (data.events !== undefined) {
	        //leagues = removeLeagueMatches(leagues, data.events.remove);
	        leagues = myRemoveLeagueMatches(leagues, data.events.remove);
	        leagues = leagueFavouriteStateChangeOnMatchesRemove(leagues, data.events.remove);
	        leagues = addLeagueMatches(leagues, data.events.add);
	        leagues = leagueFavouriteStateChangeOnMatchesAdd(leagues, data.events.add);
	    }
	
	    return leagues;
	}
	
	function addLeagues(leagues, addedLeagues) {
	    if (addedLeagues === undefined) {
	        return leagues;
	    }
	
	    return leagues.withMutations(function (l) {
	        for (var i = 0; i < addedLeagues.length; i++) {
	            var league = (0, _immutable.Map)(addedLeagues[i]);
	            league = league.set('matches', (0, _immutable.List)());
	            league = league.set('favouriteState', FavouriteState.NONE);
	            league = league.set('favouriteMatches', (0, _immutable.List)());
	
	            l.set(league.get('id'), league);
	        }
	    });
	}
	
	function changeLeagues(leagues, changedLeagues) {
	    if (changedLeagues === undefined) {
	        return leagues;
	    }
	
	    var _loop = function _loop(i) {
	        var league = changedLeagues[i];
	
	        leagues = leagues.updateIn([league.id, 'name'], function () {
	            return league.name;
	        });
	        leagues = leagues.updateIn([league.id, 'priority'], function () {
	            return league.priority;
	        });
	    };
	
	    for (var i = 0; i < changedLeagues.length; i++) {
	        _loop(i);
	    }
	
	    return leagues;
	}
	
	function addLeagueMatches(leagues, addMatches) {
	    if (addMatches === undefined) {
	        return leagues;
	    }
	
	    for (var i = 0; i < addMatches.length; i++) {
	        (function (leagueId, matchId) {
	            leagues = leagues.updateIn([leagueId, 'matches'], function (m) {
	                return m.push(matchId);
	            });
	        })(addMatches[i].leagueId, addMatches[i].id);
	    }
	
	    return leagues;
	}
	
	function myRemoveLeagueMatches(leagues, removeMatches) {
	    if (removeMatches === undefined) {
	        return leagues;
	    }
	
	    var _loop2 = function _loop2(i) {
	        var matchId = removeMatches[i].id;
	        var leagueId = removeMatches[i].leagueId;
	
	        var matches = leagues.getIn([leagueId, 'matches']);
	        if (matches !== undefined) {
	            matches = matches.filter(function (mId) {
	                return mId != matchId;
	            });
	        }
	        leagues = leagues.setIn([leagueId, 'matches'], matches);
	
	        var favouriteMatches = leagues.getIn([leagueId, 'favouriteMatches']);
	        if (favouriteMatches !== undefined) {
	            favouriteMatches = favouriteMatches.filter(function (mId) {
	                return mId != matchId;
	            });
	        }
	        leagues = leagues.setIn([leagueId, 'favouriteMatches'], favouriteMatches);
	    };
	
	    for (var i = 0; i < removeMatches.length; i++) {
	        _loop2(i);
	    }
	
	    return leagues;
	}
	
	function toggleFavouriteLeague(leagues, league) {
	    return leagues.updateIn([league.get('id')], function (l) {
	        var favouriteState = l.get('favouriteState') === FavouriteState.FULL ? FavouriteState.NONE : FavouriteState.FULL;
	
	        l = l.set('favouriteState', favouriteState);
	
	        if (favouriteState === FavouriteState.FULL) {
	            return l.set('favouriteMatches', l.get('matches'));
	        } else {
	            return l.set('favouriteMatches', (0, _immutable.List)());
	        }
	    });
	}
	
	function toggleSportFavouriteLeagues(leagues, sport) {
	    var sportLeagues = leagues.valueSeq().filter(function (l) {
	        return l.get('sportId') === sport.get('id');
	    }).map(function (l) {
	        return l.get('id');
	    }).toArray();
	
	    var favouriteState = sport.get('favouriteState') === FavouriteState.FULL ? FavouriteState.NONE : FavouriteState.FULL;
	
	    for (var i = 0; i < sportLeagues.length; i++) {
	        leagues = leagues.updateIn([sportLeagues[i]], function (l) {
	            l = l.set('favouriteState', favouriteState);
	
	            if (favouriteState === FavouriteState.FULL) {
	                return l.set('favouriteMatches', l.get('matches'));
	            } else {
	                return l.set('favouriteMatches', (0, _immutable.List)());
	            }
	        });
	    }
	
	    return leagues;
	}
	
	function toggleFavouriteMatchLeague(leagues, match) {
	    var leagueId = match.get('leagueId');
	    var matchFavouriteState = match.get('favouriteState');
	
	    var matchId = match.get('id');
	
	    if (matchFavouriteState === FavouriteState.NONE) {
	        leagues = leagues.updateIn([leagueId, 'favouriteMatches'], function (m) {
	            return m.push(matchId);
	        });
	    } else {
	        leagues = leagues.updateIn([leagueId, 'favouriteMatches'], function (m) {
	            var index = m.indexOf(matchId);
	            return m.remove(index);
	        });
	    }
	
	    var leagueFavouriteState = FavouriteState.FULL;
	
	    var leagueMatches = leagues.getIn([leagueId, 'matches']);
	    var leagueFavouriteMatches = leagues.getIn([leagueId, 'favouriteMatches']);
	
	    if (leagueFavouriteMatches.size === 0) {
	        leagueFavouriteState = FavouriteState.NONE;
	    } else if (leagueFavouriteMatches.size < leagueMatches.size) {
	        leagueFavouriteState = FavouriteState.PARTIAL;
	    }
	
	    return leagues.updateIn([leagueId], function (l) {
	        return l.set('favouriteState', leagueFavouriteState);
	    });
	}
	
	function leagueFavouriteStateChangeOnMatchesAdd(leagues, newMatches) {
	    if (newMatches === undefined) {
	        return leagues;
	    }
	
	    var _loop3 = function _loop3(i) {
	        var match = newMatches[i];
	        var leagueId = match.leagueId;
	
	        var leagueFavouriteState = leagues.getIn([leagueId, 'favouriteState']);
	
	        leagues = leagues.updateIn([leagueId], function (s) {
	            return s.set('favouriteState', leagueFavouriteState === FavouriteState.FULL ? FavouriteState.PARTIAL : leagueFavouriteState);
	        });
	    };
	
	    for (var i = 0; i < newMatches.length; i++) {
	        _loop3(i);
	    }
	
	    return leagues;
	}
	
	function leagueFavouriteStateChangeOnMatchesRemove(leagues, removeMatches) {
	    if (removeMatches === undefined) {
	        return leagues;
	    }
	
	    var _loop4 = function _loop4(i) {
	        var match = removeMatches[i];
	        var leagueId = match.leagueId;
	
	        var leagueMatches = leagues.getIn([leagueId, 'matches']);
	        var leagueFavouriteMatches = leagues.getIn([leagueId, 'favouriteMatches']);
	
	        var leagueFavouriteState = FavouriteState.FULL;
	
	        if (leagueFavouriteMatches.size === 0) {
	            leagueFavouriteState = FavouriteState.NONE;
	        } else if (leagueFavouriteMatches.size < leagueMatches.size) {
	            leagueFavouriteState = FavouriteState.PARTIAL;
	        }
	
	        leagues = leagues.updateIn([leagueId], function (s) {
	            return s.set('favouriteState', leagueFavouriteState);
	        });
	    };
	
	    for (var i = 0; i < removeMatches.length; i++) {
	        _loop4(i);
	    }
	
	    return leagues;
	}

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _set = __webpack_require__(596);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _from = __webpack_require__(345);
	
	var _from2 = _interopRequireDefault(_from);
	
	exports.default = matchGroupsReducer;
	
	var _immutable = __webpack_require__(14);
	
	var _actions = __webpack_require__(30);
	
	var _Line = __webpack_require__(38);
	
	var LineActions = _interopRequireWildcard(_Line);
	
	var _MatchResults = __webpack_require__(68);
	
	var MatchResultActions = _interopRequireWildcard(_MatchResults);
	
	var _StakeOfTheDay = __webpack_require__(51);
	
	var StakeOfTheDayActions = _interopRequireWildcard(_StakeOfTheDay);
	
	var _Popular = __webpack_require__(58);
	
	var PopularActions = _interopRequireWildcard(_Popular);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function matchGroupsReducer(action, matches, groups) {
	    switch (action.type) {
	        case _actions.LIVE_INIT.SUCCESS:
	        case LineActions.SUCCESS_REQUEST_LINE_HEADERS:
	        case LineActions.SUCCESS_REQUEST_SPORT_LINE_HEADERS:
	        case LineActions.SUCCESS_REQUEST_LEAGUE_LINE_HEADERS:
	        case MatchResultActions.SUCCESS_FETCH_MATCH_RESULTS:
	        case StakeOfTheDayActions.SUCCESS_GET_STAKE_OF_THE_DAY:
	        case PopularActions.SUCCESS_GET_POPULAR_MATCHES:
	        case LineActions.SUCCESS_REQUEST_FULL_LINE:
	            return setMatchGroups(matches, groups);
	
	        case _actions.LIVE_UPDATE.SUCCESS:
	            return update(matches, groups, action.data);
	    }
	
	    return matches;
	}
	
	function update(matches, groups, data) {
	    if (data.events !== undefined) {
	        matches = setNewMatchesGroups(matches, groups, data.events.add);
	    }
	
	    if (data.outcomes !== undefined) {
	        matches = updateMatchGroups(matches, groups, data.outcomes.remove);
	        matches = updateMatchGroups(matches, groups, data.outcomes.add);
	    }
	
	    return matches;
	}
	
	function setMatchGroups(matches, groups) {
	    var matchesArr = matches.toArray();
	
	    for (var i = 0; i < matchesArr.length; i++) {
	        matches = matches.setIn([matchesArr[i].get('id'), 'groups'], new _immutable.List());
	    }
	
	    var groupArr = groups.toArray();
	    for (var _i = 0; _i < groupArr.length; _i++) {
	        (function (group) {
	            var matchId = group.get('matchId');
	            var groupId = group.get('id');
	            var groupType = group.get('type');
	
	            if (groupType === 0) {
	                matches = matches.updateIn([matchId, 'matchGroup'], function () {
	                    return groupId;
	                });
	            } else {
	                matches = matches.updateIn([matchId, 'groups'], function (m) {
	                    return m.push(groupId);
	                });
	            }
	        })(groupArr[_i]);
	    }
	
	    return matches;
	}
	
	function setNewMatchesGroups(matches, groups, newMatches) {
	    if (newMatches === undefined) {
	        return matches;
	    }
	
	    var _loop = function _loop(i) {
	        var matchId = newMatches[i].id;
	        var matchGroups = groups.filter(function (g) {
	            return g.get('matchId') === matchId;
	        });
	
	        var defaultMatchGroup = matchGroups.find(function (mg) {
	            return mg.get('type') === 0;
	        });
	        var matchGroupIds = matchGroups.filter(function (mg) {
	            return mg.get('type') !== 0;
	        }).map(function (mg) {
	            return mg.get('id');
	        });
	
	        matches = matches.setIn([matchId, 'matchGroup'], defaultMatchGroup ? defaultMatchGroup.get('id') : undefined);
	        matches = matches.setIn([matchId, 'groups'], (0, _immutable.List)(matchGroupIds));
	    };
	
	    for (var i = 0; i < newMatches.length; i++) {
	        _loop(i);
	    }
	
	    return matches;
	}
	
	function updateMatchGroups(matches, groups, outcomes) {
	    if (outcomes === undefined) {
	        return matches;
	    }
	
	    var modifiedMatchIds = (0, _from2.default)(new _set2.default(outcomes.map(function (ro) {
	        return ro.matchId;
	    })));
	
	    var _loop2 = function _loop2(i) {
	        var matchId = modifiedMatchIds[i];
	        var matchGroups = groups.filter(function (g) {
	            return g.get('matchId') === matchId;
	        });
	        var defaultMatchGroup = matchGroups.find(function (g) {
	            return g.get('type') === 0;
	        });
	        var currentMatchGroupIds = matchGroups.filter(function (g) {
	            return g.get('type') !== 0;
	        }).map(function (g) {
	            return g.get('id');
	        }).toList();
	
	        matches = matches.setIn([matchId, 'matchGroup'], defaultMatchGroup ? defaultMatchGroup.get('id') : undefined);
	        matches = matches.setIn([matchId, 'groups'], currentMatchGroupIds);
	    };
	
	    for (var i = 0; i < modifiedMatchIds.length; i++) {
	        _loop2(i);
	    }
	
	    return matches;
	}

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = matchesReducer;
	
	var _immutable = __webpack_require__(14);
	
	var _momentTimezone = __webpack_require__(76);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _utils = __webpack_require__(66);
	
	var _actions = __webpack_require__(30);
	
	var _Live = __webpack_require__(39);
	
	var LiveActions = _interopRequireWildcard(_Live);
	
	var _Line = __webpack_require__(38);
	
	var LineActions = _interopRequireWildcard(_Line);
	
	var _Timetable = __webpack_require__(70);
	
	var TimeTableActions = _interopRequireWildcard(_Timetable);
	
	var _Favourites = __webpack_require__(155);
	
	var FavouritesActions = _interopRequireWildcard(_Favourites);
	
	var _Expand = __webpack_require__(332);
	
	var ExpandActions = _interopRequireWildcard(_Expand);
	
	var _Collapse = __webpack_require__(331);
	
	var CollapseActions = _interopRequireWildcard(_Collapse);
	
	var _ToggleMatch = __webpack_require__(485);
	
	var ToggleMatchActions = _interopRequireWildcard(_ToggleMatch);
	
	var _MatchResults = __webpack_require__(68);
	
	var MatchResultActions = _interopRequireWildcard(_MatchResults);
	
	var _StakeOfTheDay = __webpack_require__(51);
	
	var StakeOfTheDayActions = _interopRequireWildcard(_StakeOfTheDay);
	
	var _Popular = __webpack_require__(58);
	
	var PopularActions = _interopRequireWildcard(_Popular);
	
	var _FavouriteState = __webpack_require__(79);
	
	var FavouriteState = _interopRequireWildcard(_FavouriteState);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function matchesReducer(matches, action) {
	    switch (action.type) {
	        case LiveActions.CLEAR_LIVE:
	        case LineActions.CLEAR_LINE:
	        case TimeTableActions.CLEAR_TIME_TABLE:
	            return new _immutable.Map();
	
	        case _actions.LIVE_INIT.SUCCESS:
	            if (action.data.events !== undefined) {
	                matches = init(new _immutable.Map(), action.data);
	                matches = setMatchLineFullyLoaded(matches, action.data.events.add);
	                matches = expandMatches(matches, action.data.events.add);
	            } else {
	                matches = new _immutable.Map();
	            }
	            return matches;
	
	        case _actions.TIMETABLE_INIT.SUCCESS:
	            matches = init(new _immutable.Map(), action.data);
	            return matches;
	
	        case LineActions.SUCCESS_REQUEST_LINE_HEADERS:
	        case LineActions.SUCCESS_REQUEST_SPORT_LINE_HEADERS:
	        case LineActions.SUCCESS_REQUEST_LEAGUE_LINE_HEADERS:
	        case MatchResultActions.SUCCESS_FETCH_MATCH_RESULTS:
	        case StakeOfTheDayActions.SUCCESS_GET_STAKE_OF_THE_DAY:
	        case PopularActions.SUCCESS_GET_POPULAR_MATCHES:
	            return init(new _immutable.Map(), action.data);
	
	        case LineActions.SUCCESS_REQUEST_FULL_LINE:
	            matches = init(matches, action.data);
	            matches = setMatchLineFullyLoaded(matches, action.data.events.add);
	            matches = expandMatches(matches, action.data.events.add);
	            return matches;
	
	        case _actions.LIVE_UPDATE.SUCCESS:
	            matches = update(matches, action.data);
	            if (action.data.events) {
	                matches = expandMatches(matches, action.data.events.add);
	            }
	            return matches;
	
	        case _actions.TIMETABLE_UPDATE.SUCCESS:
	            return update(matches, action.data);
	
	        case FavouritesActions.TOGGLE_FAVOURITE_SPORT:
	            return toggleSportFavouriteMatches(matches, action.data);
	
	        case FavouritesActions.TOGGLE_FAVOURITE_LEAGUE:
	            return toggleLeagueFavouriteMatches(matches, action.data);
	
	        case FavouritesActions.TOGGLE_FAVOURITE_MATCH:
	            return toggleFavouriteMatch(matches, action.data);
	
	        case ExpandActions.EXPAND_ALL_MATCHES:
	            return expandAllMatches(matches);
	
	        case CollapseActions.COLLAPSE_ALL_MATCHES:
	            return collapseAllMatches(matches);
	
	        case ToggleMatchActions.TOGGLE_MATCH:
	            return toggleMatch(matches, action.data);
	    }
	
	    return matches;
	}
	
	function init(matches, data) {
	    if (data.events !== undefined) {
	        matches = addMatches(matches, data.events.add);
	    }
	
	    if (data.dates !== undefined) {
	        matches = changeStartDates(matches, data.dates.add);
	    }
	
	    if (data.lines !== undefined) {
	        matches = changeLineNumbers(matches, data.lines.add);
	    }
	
	    if (data.channels !== undefined) {
	        matches = changeChannels(matches, data.channels.add);
	    }
	
	    if (data.blocked_events !== undefined) {
	        matches = addBlockedMatches(matches, data.blocked_events.add);
	    }
	
	    if (data.remarks !== undefined) {
	        matches = changeRemarks(matches, data.remarks.add);
	    }
	
	    if (data.periods !== undefined) {
	        matches = changePeriods(matches, data.periods.add);
	    }
	
	    if (data.scores !== undefined) {
	        matches = addMatchScores(matches, data.scores.add);
	    }
	
	    return matches;
	}
	
	function update(matches, data) {
	    if (data.sports !== undefined && data.sports.remove !== undefined) {
	        //matches = removeEntities(matches, 'sportId', data.sports.remove);
	        matches = (0, _utils.myRemoveEntitiesBySport)(matches, 'sportId', data.sports.remove);
	    }
	
	    if (data.leagues !== undefined && data.leagues.remove !== undefined) {
	        //matches = removeEntities(matches, 'leagueId', data.leagues.remove);
	        matches = (0, _utils.myRemoveEntities)(matches, 'leagueId', data.leagues.remove);
	    }
	
	    if (data.events !== undefined) {
	        //matches = removeEntities(matches, 'id', data.events.remove);
	        matches = (0, _utils.myRemoveEntities)(matches, 'id', data.events.remove);
	        matches = addMatches(matches, data.events.add);
	        matches = setMatchLineFullyLoaded(matches, data.events.add);
	    }
	
	    if (data.blocked_events !== undefined) {
	        matches = removeBlockedMatches(matches, data.blocked_events.remove);
	        matches = addBlockedMatches(matches, data.blocked_events.add);
	    }
	
	    if (data.dates !== undefined) {
	        matches = changeStartDates(matches, data.dates.add);
	    }
	
	    if (data.lines !== undefined) {
	        matches = changeLineNumbers(matches, data.lines.add);
	    }
	
	    if (data.channels !== undefined) {
	        matches = removeChannels(matches, data.channels.remove);
	        matches = changeChannels(matches, data.channels.add);
	        matches = changeChannels(matches, data.channels.change);
	    }
	
	    if (data.periods !== undefined) {
	        matches = changePeriods(matches, data.periods.add);
	        matches = changePeriods(matches, data.periods.change);
	        matches = removePeriods(matches, data.periods.remove);
	    }
	
	    if (data.remarks !== undefined) {
	        matches = removeRemarks(matches, data.remarks.remove);
	        matches = changeRemarks(matches, data.remarks.add);
	        matches = changeRemarks(matches, data.remarks.change);
	    }
	
	    if (data.scores !== undefined) {
	        matches = removeMatchScores(matches, data.scores.remove);
	        matches = addMatchScores(matches, data.scores.add);
	    }
	
	    return matches;
	}
	
	function addMatches(matches, addMatches) {
	    if (addMatches === undefined) {
	        return matches;
	    }
	
	    return matches.withMutations(function (m) {
	        for (var i = 0; i < addMatches.length; i++) {
	            var match = new _immutable.Map(addMatches[i]);
	            match = match.set('scores', new _immutable.Map());
	            match = match.set('groups', new _immutable.List());
	            match = match.set('isBlocked', false);
	            match = match.set('isClosed', true);
	            match = match.set('favouriteState', FavouriteState.NONE);
	            match = match.set('isFullyLoaded', false);
	            match = match.set('matchGroup', null);
	
	            m.set(match.get('id'), match);
	        }
	    });
	}
	
	function setMatchLineFullyLoaded(matches, loadedMatches) {
	    if (loadedMatches === undefined) {
	        return matches;
	    }
	
	    for (var i = 0; i < loadedMatches.length; i++) {
	        (function (match) {
	            var matchId = match.id;
	            matches = matches.setIn([matchId, 'isFullyLoaded'], true);
	        })(loadedMatches[i]);
	    }
	
	    return matches;
	}
	
	function changeStartDates(matches, changeStartDates) {
	    if (changeStartDates === undefined) {
	        return matches;
	    }
	
	    for (var eventId in changeStartDates) {
	        if (!changeStartDates.hasOwnProperty(eventId)) {
	            continue;
	        }
	
	        (function (matchId, startDate) {
	            startDate = _momentTimezone2.default.tz(startDate, 'Asia/Bishkek').clone().tz('UTC');
	
	            matches = matches.setIn([parseInt(matchId), 'startDate'], startDate);
	        })(eventId, changeStartDates[eventId]);
	    }
	
	    return matches;
	}
	
	function changeLineNumbers(matches, changeLineNumbers) {
	    if (changeLineNumbers === undefined) {
	        return matches;
	    }
	
	    for (var eventId in changeLineNumbers) {
	        if (!changeLineNumbers.hasOwnProperty(eventId)) {
	            continue;
	        }
	
	        (function (matchId, lineNumber) {
	            matches = matches.setIn([parseInt(matchId), 'lineNumber'], lineNumber);
	        })(eventId, changeLineNumbers[eventId]);
	    }
	
	    return matches;
	}
	
	function changeChannels(matches, changeChannels) {
	    if (changeChannels === undefined) {
	        return matches;
	    }
	
	    for (var eventId in changeChannels) {
	        if (!changeChannels.hasOwnProperty(eventId)) {
	            continue;
	        }
	
	        (function (matchId, channel) {
	            matches = matches.setIn([parseInt(matchId), 'channel'], channel);
	        })(eventId, changeChannels[eventId]);
	    }
	
	    return matches;
	}
	
	function removeChannels(matches, removeChannels) {
	    //TODO implement in php for written logic
	    if (removeChannels === undefined) {
	        return matches;
	    }
	
	    for (var i = 0; i < removeChannels.length; i++) {
	        (function (matchId) {
	            matches = matches.deleteIn([matchId, 'channel']);
	        })(removeChannels[i]);
	    }
	
	    return matches;
	}
	
	function changeRemarks(matches, changeRemarks) {
	    if (changeRemarks === undefined) {
	        return matches;
	    }
	
	    for (var eventId in changeRemarks) {
	        if (!changeRemarks.hasOwnProperty(eventId)) {
	            continue;
	        }
	
	        (function (matchId, remark) {
	            matches = matches.setIn([parseInt(matchId), 'remark'], remark);
	        })(eventId, changeRemarks[eventId]);
	    }
	
	    return matches;
	}
	
	function removeRemarks(matches, removeRemarks) {
	    //TODO implement in php for written logic
	    if (removeRemarks === undefined) {
	        return matches;
	    }
	
	    for (var i = 0; i < removeRemarks.length; i++) {
	        (function (matchId) {
	            matches = matches.deleteIn([matchId, 'remark']);
	        })(removeRemarks[i]);
	    }
	
	    return matches;
	}
	
	function changePeriods(matches, changePeriods) {
	    if (changePeriods === undefined) {
	        return matches;
	    }
	
	    for (var i = 0; i < changePeriods.length; i++) {
	        (function (matchPeriod) {
	            var matchId = matchPeriod.e;
	            var periodId = matchPeriod.p;
	            var minute = matchPeriod.m;
	
	            var period = new _immutable.Map({
	                id: periodId,
	                minute: minute
	            });
	
	            matches = matches.setIn([matchId, 'period'], period);
	        })(changePeriods[i]);
	    }
	
	    return matches;
	}
	
	function removePeriods(matches, removePeriods) {
	    //TODO implement in php for written logic
	    if (removePeriods === undefined) {
	        return matches;
	    }
	
	    for (var i = 0; i < removePeriods.length; i++) {
	        (function (matchId) {
	            matches = matches.deleteIn([matchId, 'period']);
	        })(removePeriods[i]);
	    }
	
	    return matches;
	}
	
	function addBlockedMatches(matches, addBlockedMatches) {
	    if (addBlockedMatches === undefined) {
	        return matches;
	    }
	
	    for (var i = 0; i < addBlockedMatches.length; i++) {
	        var matchId = addBlockedMatches[i];
	
	        (function (matchId) {
	            matches = matches.setIn([matchId, 'isBlocked'], true);
	        })(matchId);
	    }
	
	    return matches;
	}
	
	function removeBlockedMatches(matches, removeBlockedMatches) {
	    if (removeBlockedMatches === undefined) {
	        return matches;
	    }
	
	    for (var i = 0; i < removeBlockedMatches.length; i++) {
	        var matchId = removeBlockedMatches[i];
	
	        (function (matchId) {
	            matches = matches.setIn([matchId, 'isBlocked'], false);
	        })(matchId);
	    }
	
	    return matches;
	}
	
	function addMatchScores(matches, addScores) {
	    if (addScores === undefined) {
	        return matches;
	    }
	
	    for (var i = 0; i < addScores.length; i++) {
	        (function (score) {
	            var matchId = score.matchId;
	            var scoreType = score.type;
	
	            matches = matches.setIn([matchId, 'scores', scoreType], score.id);
	        })(addScores[i]);
	    }
	
	    return matches;
	}
	
	function removeMatchScores(matches, removeScores) {
	    if (removeScores === undefined) {
	        return matches;
	    }
	
	    for (var i = 0; i < removeScores.length; i++) {
	        (function (score) {
	            var matchId = score.matchId;
	
	            var scores = matches.getIn([matchId, 'scores']);
	            var key = scores.keyOf(score.id);
	
	            matches = matches.deleteIn([matchId, 'scores', key]);
	        })(removeScores[i]);
	    }
	
	    return matches;
	}
	
	function toggleMatch(matches, toggledMatch) {
	    var matchId = toggledMatch.matchId,
	        isClosed = toggledMatch.isClosed;
	
	
	    return matches.updateIn([matchId], function (m) {
	        return m.set('isClosed', isClosed);
	    });
	}
	
	function toggleSportFavouriteMatches(matches, sport) {
	    var sportMatches = matches.valueSeq().filter(function (m) {
	        return m.get('sportId') === sport.get('id');
	    }).map(function (m) {
	        return m.get('id');
	    }).toArray();
	
	    var favouriteState = sport.get('favouriteState') === FavouriteState.FULL ? FavouriteState.NONE : FavouriteState.FULL;
	
	    for (var i = 0; i < sportMatches.length; i++) {
	        matches = matches.updateIn([sportMatches[i]], function (m) {
	            return m.set('favouriteState', favouriteState);
	        });
	    }
	
	    return matches;
	}
	
	function toggleLeagueFavouriteMatches(matches, league) {
	    var leagueMatches = matches.valueSeq().filter(function (m) {
	        return m.get('leagueId') === league.get('id');
	    }).map(function (m) {
	        return m.get('id');
	    }).toArray();
	
	    var favouriteState = league.get('favouriteState') === FavouriteState.FULL ? FavouriteState.NONE : FavouriteState.FULL;
	
	    for (var i = 0; i < leagueMatches.length; i++) {
	        matches = matches.updateIn([leagueMatches[i]], function (m) {
	            return m.set('favouriteState', favouriteState);
	        });
	    }
	
	    return matches;
	}
	
	function toggleFavouriteMatch(matches, match) {
	    return matches.updateIn([match.get('id')], function (m) {
	        var favouriteState = m.get('favouriteState') === FavouriteState.FULL ? FavouriteState.NONE : FavouriteState.FULL;
	
	        return m.set('favouriteState', favouriteState);
	    });
	}
	
	function expandMatches(matches, loadedMatches) {
	    if (loadedMatches === undefined) {
	        return matches;
	    }
	
	    for (var i = 0; i < loadedMatches.length; i++) {
	        matches = matches.updateIn([loadedMatches[i].id], function (m) {
	            return m.set('isClosed', false);
	        });
	    }
	
	    return matches;
	}
	
	function expandAllMatches(matches) {
	    return (0, _immutable.Seq)(matches).map(function (m) {
	        return m.set('isClosed', false);
	    }).toMap();
	}
	
	function collapseAllMatches(matches) {
	    return (0, _immutable.Seq)(matches).map(function (m) {
	        return m.set('isClosed', true);
	    }).toMap();
	}

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function (outcomes, action) {
	    switch (action.type) {
	        case LiveActions.CLEAR_LIVE:
	        case LineActions.CLEAR_LINE:
	            return (0, _immutable.Map)();
	
	        case _actions.LIVE_INIT.SUCCESS:
	        case LineActions.SUCCESS_REQUEST_LINE_HEADERS:
	        case LineActions.SUCCESS_REQUEST_SPORT_LINE_HEADERS:
	        case LineActions.SUCCESS_REQUEST_LEAGUE_LINE_HEADERS:
	        case StakeOfTheDayActions.SUCCESS_GET_STAKE_OF_THE_DAY:
	        case PopularActions.SUCCESS_GET_POPULAR_MATCHES:
	            return init((0, _immutable.Map)(), action.data);
	
	        case LineActions.SUCCESS_REQUEST_FULL_LINE:
	            {
	                var matches = _underscore2.default.map(action.data.events.add, function (m) {
	                    return { id: m.id };
	                });
	                //outcomes = removeEntities(outcomes, 'matchId', matches);
	                outcomes = (0, _utils.myRemoveEntities)(outcomes, 'matchId', matches);
	                return init(outcomes, action.data);
	            }
	
	        case _actions.LIVE_UPDATE.SUCCESS:
	            return update(outcomes, action.data);
	    }
	
	    return outcomes;
	};
	
	var _underscore = __webpack_require__(145);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _immutable = __webpack_require__(14);
	
	var _utils = __webpack_require__(66);
	
	var _actions = __webpack_require__(30);
	
	var _Live = __webpack_require__(39);
	
	var LiveActions = _interopRequireWildcard(_Live);
	
	var _Line = __webpack_require__(38);
	
	var LineActions = _interopRequireWildcard(_Line);
	
	var _StakeOfTheDay = __webpack_require__(51);
	
	var StakeOfTheDayActions = _interopRequireWildcard(_StakeOfTheDay);
	
	var _Popular = __webpack_require__(58);
	
	var PopularActions = _interopRequireWildcard(_Popular);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function init(outcomes, data) {
	    if (data.outcomes !== undefined) {
	        outcomes = addOutcomes(outcomes, data.outcomes.add);
	    }
	
	    if (data.blocked_outcomes !== undefined) {
	        outcomes = addBlockedOutcomes(outcomes, data.blocked_outcomes.add);
	    }
	
	    if (data.rates !== undefined) {
	        outcomes = addOutcomeRates(outcomes, data.rates.add);
	    }
	
	    return outcomes;
	}
	
	function update(outcomes, data) {
	
	    if (data.sports !== undefined && data.sports.remove !== undefined) {
	        //outcomes = removeEntities(outcomes, 'sportId', data.sports.remove);
	        outcomes = (0, _utils.myRemoveEntitiesBySport)(outcomes, 'sportId', data.sports.remove);
	    }
	
	    if (data.leagues !== undefined && data.leagues.remove !== undefined) {
	        //outcomes = removeEntities(outcomes, 'leagueId', data.leagues.remove);
	        outcomes = (0, _utils.myRemoveEntities)(outcomes, 'leagueId', data.leagues.remove);
	    }
	
	    if (data.events !== undefined && data.events.remove !== undefined) {
	        //outcomes = removeEntities(outcomes, 'matchId', data.events.remove);
	        outcomes = (0, _utils.myRemoveEntities)(outcomes, 'matchId', data.events.remove);
	    }
	
	    if (data.blocked_outcomes !== undefined) {
	        outcomes = removeBlockedOutcomes(outcomes, data.blocked_outcomes.remove);
	    }
	
	    if (data.outcomes !== undefined) {
	        //outcomes = removeEntities(outcomes, 'id', data.outcomes.remove);
	        outcomes = (0, _utils.myRemoveEntities)(outcomes, 'id', data.outcomes.remove);
	        outcomes = addOutcomes(outcomes, data.outcomes.add);
	        outcomes = updateOutcomes(outcomes, data.outcomes.change);
	    }
	
	    if (data.blocked_outcomes !== undefined) {
	        outcomes = addBlockedOutcomes(outcomes, data.blocked_outcomes.add);
	    }
	
	    if (data.rates !== undefined) {
	        outcomes = addOutcomeRates(outcomes, data.rates.add);
	    }
	
	    return outcomes;
	}
	
	function addOutcomes(outcomes, addOutcomes) {
	    if (addOutcomes === undefined) {
	        return outcomes;
	    }
	
	    outcomes = outcomes.withMutations(function (o) {
	        for (var i = 0; i < addOutcomes.length; i++) {
	            var addedOutcome = addOutcomes[i];
	            if (addedOutcome === undefined || addedOutcome.matchId === undefined) {
	                throw new Error('Add outcome: parent key not found');
	            }
	
	            var plainOutcome = (0, _extends3.default)({}, addedOutcome, {
	                rates: (0, _immutable.Map)(),
	                isBlocked: false
	                //isHeader: false
	            });
	
	            var outcome = (0, _immutable.Map)(plainOutcome);
	
	            o.set(addedOutcome.id, outcome);
	        }
	    });
	
	    return outcomes;
	}
	
	function updateOutcomes(outcomes, changeOutcomes) {
	    if (changeOutcomes === undefined) {
	        return outcomes;
	    }
	
	    for (var i = 0; i < changeOutcomes.length; i++) {
	        var changeOutcome = changeOutcomes[i];
	
	        var outcome = outcomes.get(changeOutcome.id);
	        if (outcome) {
	            (function (outcomeId, isHeader, groupId) {
	                outcomes = outcomes.update(outcomeId, function (o) {
	                    return o.set('isHeader', isHeader).set('groupId', groupId);
	                });
	            })(changeOutcome.id, changeOutcome.ih || false, parseInt('' + changeOutcome.e + (changeOutcome.g || 0)));
	        }
	    }
	
	    return outcomes;
	}
	
	function addOutcomeRates(outcomes, addRates) {
	    if (addRates === undefined) {
	        return outcomes;
	    }
	
	    for (var i = 0; i < addRates.length; i++) {
	        (function (rate) {
	            var outcomeId = rate.outcomeId;
	            var rateId = rate.id;
	            var rateType = rate.type;
	
	            outcomes = outcomes.setIn([outcomeId, 'rates', rateType], rateId);
	        })(addRates[i]);
	    }
	
	    return outcomes;
	}
	
	function addBlockedOutcomes(outcomes, addBlockedOutcomes) {
	    if (addBlockedOutcomes === undefined) {
	        return outcomes;
	    }
	
	    for (var i = 0; i < addBlockedOutcomes.length; i++) {
	        var outcomeId = addBlockedOutcomes[i];
	
	        (function (outcomeId) {
	            outcomes = outcomes.setIn([outcomeId, 'isBlocked'], true);
	        })(outcomeId);
	    }
	
	    return outcomes;
	}
	
	function removeBlockedOutcomes(outcomes, removeBlockedOutcomes) {
	    if (removeBlockedOutcomes === undefined) {
	        return outcomes;
	    }
	
	    for (var i = 0; i < removeBlockedOutcomes.length; i++) {
	        var outcomeId = removeBlockedOutcomes[i];
	
	        (function (outcomeId) {
	            outcomes = outcomes.setIn([outcomeId, 'isBlocked'], false);
	        })(outcomeId);
	    }
	
	    return outcomes;
	}

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(15);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = function (rates, action) {
	    switch (action.type) {
	        case LiveActions.CLEAR_LIVE:
	        case LineActions.CLEAR_LINE:
	            return (0, _immutable.Map)();
	
	        case _actions.LIVE_INIT.SUCCESS:
	        case LineActions.SUCCESS_REQUEST_LINE_HEADERS:
	        case LineActions.SUCCESS_REQUEST_SPORT_LINE_HEADERS:
	        case LineActions.SUCCESS_REQUEST_LEAGUE_LINE_HEADERS:
	        case StakeOfTheDayActions.SUCCESS_GET_STAKE_OF_THE_DAY:
	        case PopularActions.SUCCESS_GET_POPULAR_MATCHES:
	            return init((0, _immutable.Map)(), action.data);
	
	        case LineActions.SUCCESS_REQUEST_FULL_LINE:
	            {
	                var matches = action.data.events.add.map(function (m) {
	                    return { id: m.id };
	                });
	                //rates = removeEntities(rates, 'matchId', matches);
	                rates = (0, _utils.myRemoveEntities)(rates, 'matchId', matches);
	                return init(rates, action.data);
	            }
	
	        case _actions.LIVE_UPDATE.SUCCESS:
	            return update(rates, action.data);
	    }
	
	    return rates;
	};
	
	var _immutable = __webpack_require__(14);
	
	var _utils = __webpack_require__(66);
	
	var _actions = __webpack_require__(30);
	
	var _Live = __webpack_require__(39);
	
	var LiveActions = _interopRequireWildcard(_Live);
	
	var _Line = __webpack_require__(38);
	
	var LineActions = _interopRequireWildcard(_Line);
	
	var _StakeOfTheDay = __webpack_require__(51);
	
	var StakeOfTheDayActions = _interopRequireWildcard(_StakeOfTheDay);
	
	var _Popular = __webpack_require__(58);
	
	var PopularActions = _interopRequireWildcard(_Popular);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function init(rates, data) {
	    if (data.rates !== undefined) {
	        rates = addRates(rates, data.rates.add);
	    }
	
	    if (data.blocked_events !== undefined && data.blocked_events.add !== undefined) {
	        rates = updateRatesBlock(rates, 'matchId', data.blocked_events.add, true);
	    }
	
	    if (data.blocked_outcomes !== undefined && data.blocked_outcomes.add !== undefined) {
	        rates = updateRatesBlock(rates, 'outcomeId', data.blocked_outcomes.add, true);
	    }
	
	    return rates;
	}
	
	function update(rates, data) {
	    if (data.sports !== undefined && data.sports.remove !== undefined) {
	        //rates = removeEntities(rates, 'sportId', data.sports.remove);
	        rates = (0, _utils.myRemoveEntitiesBySport)(rates, 'sportId', data.sports.remove);
	    }
	
	    if (data.leagues !== undefined && data.leagues.remove !== undefined) {
	        //rates = removeEntities(rates, 'leagueId', data.leagues.remove);
	        rates = (0, _utils.myRemoveEntities)(rates, 'leagueId', data.leagues.remove);
	    }
	
	    if (data.events !== undefined && data.events.remove !== undefined) {
	        //rates = removeEntities(rates, 'matchId', data.events.remove);
	        rates = (0, _utils.myRemoveEntities)(rates, 'matchId', data.events.remove);
	    }
	
	    if (data.outcomes !== undefined && data.outcomes.remove !== undefined) {
	        //rates = removeEntities(rates, 'outcomeId', data.outcomes.remove);
	        rates = (0, _utils.myRemoveEntities)(rates, 'outcomeId', data.outcomes.remove);
	    }
	
	    if (data.rates !== undefined) {
	        if (data.rates.add !== undefined) {
	            rates = addRates(rates, data.rates.add);
	        }
	
	        rates = changeRates(rates, data.rates.change);
	    }
	
	    if (data.blocked_events !== undefined) {
	        rates = updateRatesBlock(rates, 'matchId', data.blocked_events.add, true);
	        rates = updateRatesBlock(rates, 'matchId', data.blocked_events.remove, false);
	    }
	
	    if (data.blocked_outcomes !== undefined) {
	        rates = updateRatesBlock(rates, 'outcomeId', data.blocked_outcomes.add, true);
	        rates = updateRatesBlock(rates, 'outcomeId', data.blocked_outcomes.remove, false);
	    }
	
	    return rates;
	}
	
	function addRates(rates, addRates) {
	    if (addRates === undefined) {
	        return rates;
	    }
	
	    return rates.withMutations(function (r) {
	        for (var i = 0; i < addRates.length; i++) {
	            var addRate = addRates[i];
	
	            if (addRate === undefined || addRate.outcomeId === undefined) {
	                throw new Error('Add rate: parent key not found');
	            }
	
	            var plainRate = (0, _assign2.default)({}, addRate, {
	                isVisible: addRate.value > 1,
	                isBlocked: false
	            });
	
	            var rate = (0, _immutable.Map)(plainRate);
	
	            r.set(addRate.id, rate);
	        }
	    });
	}
	
	function changeRates(rates, changeRates) {
	    if (changeRates === undefined) {
	        return rates;
	    }
	
	    for (var rateId in changeRates) {
	        if (!changeRates.hasOwnProperty(rateId)) {
	            continue;
	        }
	
	        (function (rateId, value) {
	            rates = rates.update(parseInt(rateId), function (r) {
	                if (r === undefined) {
	                    throw new Error('Rate#' + rateId + 'not present in state, but change received');
	                }
	                return r.set('value', value).set('isVisible', value > 1);
	            });
	        })(rateId, changeRates[rateId]);
	    }
	
	    return rates;
	}
	
	function updateRatesBlock(entities, field, values, isBlocked) {
	    if (values === undefined) {
	        return entities;
	    }
	
	    var affectedIds = entities.valueSeq().filter(function (m) {
	        return values.indexOf(m.get(field)) !== -1;
	    }).map(function (m) {
	        return m.get('id');
	    }).toArray();
	
	    entities = entities.withMutations(function (e) {
	        for (var j = 0; j < affectedIds.length; j++) {
	            var id = affectedIds[j];
	            e.setIn([id, 'isBlocked'], isBlocked);
	        }
	    });
	
	    return entities;
	}

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (scores, action) {
	    switch (action.type) {
	        case LiveActions.CLEAR_LIVE:
	            return (0, _immutable.Map)();
	
	        case _actions.LIVE_INIT.SUCCESS:
	        case MatchResultActions.SUCCESS_FETCH_MATCH_RESULTS:
	            return init((0, _immutable.Map)(), action.data);
	
	        case _actions.LIVE_UPDATE.SUCCESS:
	            return update(scores, action.data);
	    }
	
	    return scores;
	};
	
	var _immutable = __webpack_require__(14);
	
	var _utils = __webpack_require__(66);
	
	var _actions = __webpack_require__(30);
	
	var _Live = __webpack_require__(39);
	
	var LiveActions = _interopRequireWildcard(_Live);
	
	var _MatchResults = __webpack_require__(68);
	
	var MatchResultActions = _interopRequireWildcard(_MatchResults);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function init(scores, data) {
	    if (data.scores !== undefined) {
	        scores = addScores(scores, data.scores.add);
	    }
	
	    return scores;
	}
	
	function update(scores, data) {
	    if (data.sports !== undefined && data.sports.remove !== undefined) {
	        //scores = removeEntities(scores, 'sportId', data.sports.remove);
	        scores = (0, _utils.myRemoveEntitiesBySport)(scores, 'sportId', data.sports.remove);
	    }
	
	    if (data.leagues !== undefined && data.leagues.remove !== undefined) {
	        //scores = removeEntities(scores, 'leagueId', data.leagues.remove);
	        scores = (0, _utils.myRemoveEntities)(scores, 'leagueId', data.leagues.remove);
	    }
	
	    if (data.events != undefined && data.events.remove !== undefined) {
	        //scores = removeEntities(scores, 'matchId', data.events.remove);
	        scores = (0, _utils.myRemoveEntities)(scores, 'matchId', data.events.remove);
	    }
	
	    if (data.scores !== undefined) {
	        //scores = removeEntities(scores, 'id', data.scores.remove);
	        scores = (0, _utils.myRemoveEntities)(scores, 'id', data.scores.remove);
	        scores = addScores(scores, data.scores.add);
	        scores = changeScores(scores, data.scores.change);
	    }
	
	    return scores;
	}
	
	function addScores(scores, addScores) {
	    if (addScores === undefined) {
	        return scores;
	    }
	
	    return scores.withMutations(function (s) {
	        for (var i = 0; i < addScores.length; i++) {
	            var score = (0, _immutable.Map)(addScores[i]);
	
	            s.set(score.get('id'), score);
	        }
	    });
	}
	
	function changeScores(scores, changeScores) {
	    if (changeScores === undefined) {
	        return scores;
	    }
	
	    return scores.withMutations(function (s) {
	        for (var i = 0; i < changeScores.length; i++) {
	            var score = (0, _immutable.Map)(changeScores[i]);
	
	            s.set(score.get('id'), score);
	        }
	    });
	}

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = showLineNumbersReducer;
	
	var _Live = __webpack_require__(39);
	
	var LiveActions = _interopRequireWildcard(_Live);
	
	var _Line = __webpack_require__(38);
	
	var LineActions = _interopRequireWildcard(_Line);
	
	var _Timetable = __webpack_require__(70);
	
	var TimeTableActions = _interopRequireWildcard(_Timetable);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function showLineNumbersReducer(flag, action) {
	    switch (action.type) {
	        case LiveActions.CLEAR_LIVE:
	        case LineActions.CLEAR_LINE:
	        case TimeTableActions.CLEAR_TIME_TABLE:
	        case LineActions.HIDE_LINE_NUMBERS:
	            return false;
	
	        case LineActions.SHOW_LINE_NUMBERS:
	            return true;
	    }
	
	    return flag;
	}

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = sportsReducer;
	
	var _immutable = __webpack_require__(14);
	
	var _utils = __webpack_require__(66);
	
	var _actions = __webpack_require__(30);
	
	var _Live = __webpack_require__(39);
	
	var LiveActions = _interopRequireWildcard(_Live);
	
	var _Line = __webpack_require__(38);
	
	var LineActions = _interopRequireWildcard(_Line);
	
	var _Timetable = __webpack_require__(70);
	
	var TimeTableActions = _interopRequireWildcard(_Timetable);
	
	var _Favourites = __webpack_require__(155);
	
	var FavouritesActions = _interopRequireWildcard(_Favourites);
	
	var _MatchResults = __webpack_require__(68);
	
	var MatchResultActions = _interopRequireWildcard(_MatchResults);
	
	var _StakeOfTheDay = __webpack_require__(51);
	
	var StakeOfTheDayActions = _interopRequireWildcard(_StakeOfTheDay);
	
	var _Popular = __webpack_require__(58);
	
	var PopularActions = _interopRequireWildcard(_Popular);
	
	var _FavouriteState = __webpack_require__(79);
	
	var FavouriteState = _interopRequireWildcard(_FavouriteState);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function sportsReducer(sports, action) {
	    switch (action.type) {
	        case LiveActions.CLEAR_LIVE:
	        case LineActions.CLEAR_LINE:
	        case TimeTableActions.CLEAR_TIME_TABLE:
	        case MatchResultActions.FETCH_MATCH_RESULTS:
	        case MatchResultActions.FAILURE_FETCH_MATCH_RESULTS:
	            return new _immutable.Map();
	
	        case _actions.LIVE_INIT.SUCCESS:
	        case _actions.TIMETABLE_INIT.SUCCESS:
	        case LineActions.SUCCESS_REQUEST_LINE_HEADERS:
	        case LineActions.SUCCESS_REQUEST_SPORT_LINE_HEADERS:
	        case LineActions.SUCCESS_REQUEST_LEAGUE_LINE_HEADERS:
	        case MatchResultActions.SUCCESS_FETCH_MATCH_RESULTS:
	        case StakeOfTheDayActions.SUCCESS_GET_STAKE_OF_THE_DAY:
	        case PopularActions.SUCCESS_GET_POPULAR_MATCHES:
	            return init(new _immutable.Map(), action.data);
	
	        case _actions.LIVE_UPDATE.SUCCESS:
	        case _actions.TIMETABLE_UPDATE.SUCCESS:
	            return update(sports, action.data);
	
	        case FavouritesActions.TOGGLE_FAVOURITE_SPORT:
	            return toggleFavouriteSport(sports, action.data);
	
	        case FavouritesActions.TOGGLE_FAVOURITE_LEAGUE:
	            return toggleFavouriteLeagueSport(sports, action.data);
	
	        case FavouritesActions.TOGGLE_FAVOURITE_MATCH:
	            return toggleFavouriteMatchSport(sports, action.data);
	    }
	
	    return sports;
	}
	
	function init(sports, data) {
	    if (data.sports !== undefined) {
	        sports = addSports(sports, data.sports.add);
	    }
	    if (data.leagues !== undefined) {
	        sports = addSportsLeagues(sports, data.leagues.add);
	    }
	    if (data.events !== undefined) {
	        sports = addSportsMatches(sports, data.events.add);
	    }
	
	    return sports;
	}
	
	function update(sports, data) {
	    if (data.sports !== undefined) {
	        //sports = removeEntities(sports, 'id', data.sports.remove);
	        sports = (0, _utils.myRemoveEntitiesBySport)(sports, 'id', data.sports.remove);
	        sports = addSports(sports, data.sports.add);
	        sports = changeSports(sports, data.sports.change);
	    }
	
	    if (data.leagues !== undefined) {
	        //sports = removeSportLeagues(sports, data.leagues.remove);
	        sports = myRemoveSportLeagues(sports, data.leagues.remove);
	        sports = sportFavouriteStateChangeOnLeaguesRemove(sports, data.leagues.remove);
	
	        sports = addSportsLeagues(sports, data.leagues.add);
	        sports = sportFavouriteStateChangeOnLeaguesAdd(sports, data.leagues.add);
	    }
	
	    if (data.events !== undefined) {
	        //sports = removeSportMatches(sports, data.events.remove);
	        sports = myRemoveSportMatches(sports, data.events.remove);
	        sports = sportFavouriteStateChangeOnMatchesRemove(sports, data.events.remove);
	
	        sports = addSportsMatches(sports, data.events.add);
	        sports = sportFavouriteStateChangeOnMatchesAdd(sports, data.events.add);
	    }
	
	    return sports;
	}
	
	function addSports(sports, addSports) {
	    if (addSports === undefined) {
	        return sports;
	    }
	
	    sports = sports.withMutations(function (s) {
	        for (var i = 0; i < addSports.length; i++) {
	            var sport = new _immutable.Map(addSports[i]);
	            sport = sport.set('leagues', new _immutable.List());
	            sport = sport.set('leagueMatches', new _immutable.Map());
	            sport = sport.set('favouriteLeagueMatches', new _immutable.Map());
	            sport = sport.set('favouriteState', FavouriteState.NONE);
	
	            s.set(sport.get('id'), sport);
	        }
	    });
	
	    return sports;
	}
	
	function changeSports(sports, changedSports) {
	    if (changedSports === undefined) {
	        return sports;
	    }
	
	    var _loop = function _loop(i) {
	        var sport = changedSports[i];
	
	        sports = sports.updateIn([sport.id, 'name'], function () {
	            return sport.name;
	        });
	        sports = sports.updateIn([sport.id, 'priority'], function () {
	            return sport.priority;
	        });
	    };
	
	    for (var i = 0; i < changedSports.length; i++) {
	        _loop(i);
	    }
	
	    return sports;
	}
	
	function addSportsLeagues(sports, addLeagues) {
	    if (addLeagues === undefined) {
	        return sports;
	    }
	
	    for (var i = 0; i < addLeagues.length; i++) {
	        var sportId = addLeagues[i].sportId;
	        var leagueId = addLeagues[i].id;
	
	        (function (sportId, leagueId) {
	            sports = sports.updateIn([sportId, 'leagues'], function (l) {
	                return l.push(leagueId);
	            });
	            sports = sports.updateIn([sportId, 'leagueMatches'], function (l) {
	                return l.set(leagueId, new _immutable.List());
	            });
	        })(sportId, leagueId);
	    }
	
	    return sports;
	}
	
	function addSportsMatches(sports, addMatches) {
	    if (addMatches === undefined) {
	        return sports;
	    }
	
	    for (var i = 0; i < addMatches.length; i++) {
	        var sportId = addMatches[i].sportId;
	        var leagueId = addMatches[i].leagueId;
	        var matchId = addMatches[i].id;
	
	        (function (sportId, leagueId, matchId) {
	            sports = sports.updateIn([sportId, 'leagueMatches', leagueId], function (l) {
	                return l.push(matchId);
	            });
	        })(sportId, leagueId, matchId);
	    }
	
	    return sports;
	}
	
	function myRemoveSportLeagues(sports, removeLeagues) {
	    if (removeLeagues === undefined) {
	        return sports;
	    }
	
	    var _loop2 = function _loop2(i) {
	        var sportId = removeLeagues[i].sportId;
	        var leagueId = removeLeagues[i].id;
	
	        var leagues = sports.getIn([sportId, 'leagues']);
	        if (leagues !== undefined) {
	            leagues = leagues.filter(function (lId) {
	                return lId != leagueId;
	            });
	        }
	        sports = sports.setIn([sportId, 'leagues'], leagues);
	
	        var leagueMatches = sports.getIn([sportId, 'leagueMatches']);
	        if (leagueMatches !== undefined) {
	            leagueMatches = leagueMatches.filter(function (matches, lId) {
	                return lId != leagueId;
	            });
	        }
	        sports = sports.setIn([sportId, 'leagueMatches'], leagueMatches);
	
	        var favouriteLeagueMatches = sports.getIn([sportId, 'favouriteLeagueMatches']);
	        if (favouriteLeagueMatches !== undefined) {
	            favouriteLeagueMatches = favouriteLeagueMatches.filter(function (matches, lId) {
	                return lId != leagueId;
	            });
	        }
	        sports = sports.setIn([sportId, 'favouriteLeagueMatches'], favouriteLeagueMatches);
	    };
	
	    for (var i = 0; i < removeLeagues.length; i++) {
	        _loop2(i);
	    }
	
	    return sports;
	}
	
	function myRemoveSportMatches(sports, removeMatches) {
	    if (removeMatches === undefined) {
	        return sports;
	    }
	
	    var _loop3 = function _loop3(i) {
	        var sportId = removeMatches[i].sportId;
	        var leagueId = removeMatches[i].leagueId;
	        var matchId = removeMatches[i].id;
	
	        var matches = sports.getIn([sportId, 'leagueMatches', leagueId]);
	        if (matches !== undefined) {
	            matches = matches.filter(function (mId) {
	                return mId != matchId;
	            });
	        }
	        sports = sports.setIn([sportId, 'leagueMatches', leagueId], matches);
	
	        var favouriteMatches = sports.getIn([sportId, 'favouriteLeagueMatches', leagueId]);
	        if (favouriteMatches !== undefined) {
	            favouriteMatches = favouriteMatches.filter(function (mId) {
	                return mId != matchId;
	            });
	        }
	
	        if (favouriteMatches === undefined || !favouriteMatches || !favouriteMatches.size) {
	            sports = sports.removeIn([sportId, 'favouriteLeagueMatches', leagueId]);
	        } else {
	            sports = sports.setIn([sportId, 'favouriteLeagueMatches', leagueId], favouriteMatches);
	        }
	    };
	
	    for (var i = 0; i < removeMatches.length; i++) {
	        _loop3(i);
	    }
	
	    return sports;
	}
	
	function toggleFavouriteSport(sports, sport) {
	    return sports.updateIn([sport.get('id')], function (s) {
	        var favouriteState = s.get('favouriteState') === FavouriteState.FULL ? FavouriteState.NONE : FavouriteState.FULL;
	
	        s = s.set('favouriteState', favouriteState);
	
	        if (favouriteState === FavouriteState.FULL) {
	            return s.set('favouriteLeagueMatches', s.get('leagueMatches'));
	        } else {
	            return s.set('favouriteLeagueMatches', new _immutable.Map());
	        }
	    });
	}
	
	function toggleFavouriteLeagueSport(sports, league) {
	    var sportId = league.get('sportId');
	    var leagueFavouriteState = league.get('favouriteState');
	
	    var leagueId = league.get('id');
	
	    if (leagueFavouriteState === FavouriteState.FULL) {
	        sports = sports.updateIn([sportId, 'favouriteLeagueMatches'], function (l) {
	            return l.delete(leagueId);
	        });
	    } else {
	        var _leagueMatches = sports.getIn([sportId, 'leagueMatches', leagueId]);
	        sports = sports.updateIn([sportId, 'favouriteLeagueMatches'], function (l) {
	            return l.set(leagueId, _leagueMatches);
	        });
	    }
	
	    var sportFavouriteState = FavouriteState.FULL;
	
	    var sportLeagues = sports.getIn([sportId, 'leagues']);
	    var sportFavouriteLeagues = sports.getIn([sportId, 'favouriteLeagueMatches']).keySeq();
	
	    if (sportFavouriteLeagues.size === 0) {
	        sportFavouriteState = FavouriteState.NONE;
	    } else if (sportFavouriteLeagues.size < sportLeagues.size) {
	        sportFavouriteState = FavouriteState.PARTIAL;
	    }
	
	    return sports.updateIn([sportId], function (l) {
	        return l.set('favouriteState', sportFavouriteState);
	    });
	}
	
	function toggleFavouriteMatchSport(sports, match) {
	    var sportId = match.get('sportId');
	    var leagueId = match.get('leagueId');
	    var matchId = match.get('id');
	
	    var matchFavouriteState = match.get('favouriteState');
	
	    if (matchFavouriteState === FavouriteState.NONE) {
	        if (sports.getIn([sportId, 'favouriteLeagueMatches', leagueId]) === undefined) {
	            sports = sports.updateIn([sportId, 'favouriteLeagueMatches'], function (l) {
	                return l.set(leagueId, new _immutable.List());
	            });
	        }
	
	        sports = sports.updateIn([sportId, 'favouriteLeagueMatches', leagueId], function (m) {
	            return m.push(matchId);
	        });
	    } else {
	        sports = sports.updateIn([sportId, 'favouriteLeagueMatches', leagueId], function (m) {
	            var index = m.indexOf(matchId);
	            return m.remove(index);
	        });
	
	        if (sports.getIn([sportId, 'favouriteLeagueMatches', leagueId]).size === 0) {
	            sports = sports.updateIn([sportId, 'favouriteLeagueMatches'], function (l) {
	                return l.delete(leagueId);
	            });
	        }
	    }
	
	    var sportLeagues = sports.getIn([sportId, 'leagues']);
	    var sportFavouriteLeagues = sports.getIn([sportId, 'favouriteLeagueMatches']).keySeq();
	
	    var sportFavouriteState = FavouriteState.FULL;
	
	    if (sportFavouriteLeagues.size === 0) {
	        sportFavouriteState = FavouriteState.NONE;
	    } else if (sportFavouriteLeagues.size < sportLeagues.size) {
	        sportFavouriteState = FavouriteState.PARTIAL;
	    }
	
	    return sports.updateIn([sportId], function (l) {
	        return l.set('favouriteState', sportFavouriteState);
	    });
	}
	
	function sportFavouriteStateChangeOnLeaguesAdd(sports, newLeagues) {
	    if (newLeagues === undefined) {
	        return sports;
	    }
	
	    var _loop4 = function _loop4(i) {
	        var league = newLeagues[i];
	        var sportId = league.sportId;
	
	        var sportFavouriteState = sports.getIn([sportId, 'favouriteState']);
	
	        sports = sports.updateIn([sportId], function (s) {
	            return s.set('favouriteState', sportFavouriteState === FavouriteState.FULL ? FavouriteState.PARTIAL : sportFavouriteState);
	        });
	    };
	
	    for (var i = 0; i < newLeagues.length; i++) {
	        _loop4(i);
	    }
	
	    return sports;
	}
	
	function sportFavouriteStateChangeOnLeaguesRemove(sports, removeLeagues) {
	    if (removeLeagues === undefined) {
	        return sports;
	    }
	
	    var _loop5 = function _loop5(i) {
	        var league = removeLeagues[i];
	        var sportId = league.sportId;
	
	        var sportLeagues = sports.getIn([sportId, 'leagues']);
	        var sportFavouriteLeagues = sports.getIn([sportId, 'favouriteLeagueMatches']).keySeq();
	
	        var sportFavouriteState = FavouriteState.FULL;
	
	        if (sportFavouriteLeagues.size === 0) {
	            sportFavouriteState = FavouriteState.NONE;
	        } else if (sportFavouriteLeagues.size < sportLeagues.size) {
	            sportFavouriteState = FavouriteState.PARTIAL;
	        }
	
	        sports = sports.updateIn([sportId], function (s) {
	            return s.set('favouriteState', sportFavouriteState === FavouriteState.FULL ? FavouriteState.PARTIAL : sportFavouriteState);
	        });
	    };
	
	    for (var i = 0; i < removeLeagues.length; i++) {
	        _loop5(i);
	    }
	
	    return sports;
	}
	
	function sportFavouriteStateChangeOnMatchesAdd(sports, newMatches) {
	    if (newMatches === undefined) {
	        return sports;
	    }
	
	    var _loop6 = function _loop6(i) {
	        var match = newMatches[i];
	        var sportId = match.sportId;
	
	        var sportFavouriteState = sports.getIn([sportId, 'favouriteState']);
	
	        sports = sports.updateIn([sportId], function (s) {
	            return s.set('favouriteState', sportFavouriteState === FavouriteState.FULL ? FavouriteState.PARTIAL : sportFavouriteState);
	        });
	    };
	
	    for (var i = 0; i < newMatches.length; i++) {
	        _loop6(i);
	    }
	
	    return sports;
	}
	
	function sportFavouriteStateChangeOnMatchesRemove(sports, removeMatches) {
	    if (removeMatches === undefined) {
	        return sports;
	    }
	
	    var _loop7 = function _loop7(i) {
	        var match = removeMatches[i];
	        var sportId = match.sportId;
	
	        var sportLeagues = sports.getIn([sportId, 'leagues']);
	        var sportFavouriteLeagues = sports.getIn([sportId, 'favouriteLeagueMatches']).keySeq();
	
	        var sportFavouriteState = FavouriteState.FULL;
	
	        if (sportFavouriteLeagues.size === 0) {
	            sportFavouriteState = FavouriteState.NONE;
	        } else if (sportFavouriteLeagues.size < sportLeagues.size) {
	            sportFavouriteState = FavouriteState.PARTIAL;
	        }
	
	        sports = sports.updateIn([sportId], function (s) {
	            return s.set('favouriteState', sportFavouriteState === FavouriteState.FULL ? FavouriteState.PARTIAL : sportFavouriteState);
	        });
	    };
	
	    for (var i = 0; i < removeMatches.length; i++) {
	        _loop7(i);
	    }
	
	    return sports;
	}

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = stateReducer;
	
	var _actions = __webpack_require__(30);
	
	var _Live = __webpack_require__(39);
	
	var LiveActions = _interopRequireWildcard(_Live);
	
	var _Line = __webpack_require__(38);
	
	var LineActions = _interopRequireWildcard(_Line);
	
	var _Timetable = __webpack_require__(70);
	
	var TimeTableActions = _interopRequireWildcard(_Timetable);
	
	var _MatchResults = __webpack_require__(68);
	
	var MatchResultActions = _interopRequireWildcard(_MatchResults);
	
	var _StakeOfTheDay = __webpack_require__(51);
	
	var StakeOfTheDayActions = _interopRequireWildcard(_StakeOfTheDay);
	
	var _changeLanguage = __webpack_require__(71);
	
	var ChangeLanguageActions = _interopRequireWildcard(_changeLanguage);
	
	var _RepositoryState = __webpack_require__(119);
	
	var RepositoryState = _interopRequireWildcard(_RepositoryState);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function stateReducer(state, action) {
	    switch (action.type) {
	        case LiveActions.CLEAR_LIVE:
	        case LineActions.CLEAR_LINE:
	        case TimeTableActions.CLEAR_TIME_TABLE:
	        case ChangeLanguageActions.CHANGE_LANGUAGE:
	        case _actions.LIVE_INIT.FAILURE:
	        case _actions.LIVE_UPDATE.FAILURE:
	        case _actions.TIMETABLE_INIT.FAILURE:
	        case _actions.TIMETABLE_UPDATE.FAILURE:
	            return RepositoryState.NOT_INITED;
	
	        case _actions.LIVE_INIT.SUCCESS:
	        case _actions.TIMETABLE_INIT.SUCCESS:
	        case LineActions.SUCCESS_REQUEST_LINE_HEADERS:
	        case LineActions.SUCCESS_REQUEST_SPORT_LINE_HEADERS:
	        case LineActions.SUCCESS_REQUEST_LEAGUE_LINE_HEADERS:
	        case MatchResultActions.SUCCESS_FETCH_MATCH_RESULTS:
	        case StakeOfTheDayActions.SUCCESS_GET_STAKE_OF_THE_DAY:
	            return RepositoryState.INITED;
	
	        case _actions.LIVE_UPDATE.SUCCESS:
	        case _actions.TIMETABLE_UPDATE.SUCCESS:
	            if (action.data.expired && action.data.expired === true) {
	                return RepositoryState.NOT_INITED;
	            }
	
	            return RepositoryState.UPDATING;
	    }
	
	    return state;
	}

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = versionReducer;
	
	var _actions = __webpack_require__(30);
	
	var _Live = __webpack_require__(39);
	
	var LiveActions = _interopRequireWildcard(_Live);
	
	var _Timetable = __webpack_require__(70);
	
	var TimeTableActions = _interopRequireWildcard(_Timetable);
	
	var _changeLanguage = __webpack_require__(71);
	
	var ChangeLanguageActions = _interopRequireWildcard(_changeLanguage);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function versionReducer(version, action) {
	    switch (action.type) {
	        case LiveActions.CLEAR_LIVE:
	        case TimeTableActions.CLEAR_TIME_TABLE:
	        case _actions.LIVE_INIT.FAILURE:
	        case _actions.LIVE_UPDATE.FAILURE:
	        case _actions.TIMETABLE_INIT.FAILURE:
	        case _actions.TIMETABLE_UPDATE.FAILURE:
	        case ChangeLanguageActions.CHANGE_LANGUAGE:
	            return 0;
	
	        case _actions.LIVE_INIT.SUCCESS:
	        case _actions.LIVE_UPDATE.SUCCESS:
	        case _actions.TIMETABLE_INIT.SUCCESS:
	        case _actions.TIMETABLE_UPDATE.SUCCESS:
	            return action.data.version;
	    }
	
	    return version;
	}

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = phoneConfirm;
	
	var _immutable = __webpack_require__(14);
	
	var _Auth = __webpack_require__(301);
	
	var AuthActions = _interopRequireWildcard(_Auth);
	
	var _PhoneConfirmation = __webpack_require__(156);
	
	var PhoneConfirm = _interopRequireWildcard(_PhoneConfirmation);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = (0, _immutable.Map)({
	    inProcess: false,
	    error: null,
	    requested: false,
	    confirmed: false,
	    reconfirmedPhone: null
	});
	
	function phoneConfirm() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	
	        case AuthActions.BEGIN_JOIN:
	            state = initialState;
	            break;
	
	        case PhoneConfirm.CREATE_PHONE_CONFIRMATION:
	            state = state.set('confirmed', false);
	            state = state.set('error', null);
	            state = state.set('requested', false);
	            state = state.set('inProcess', true);
	            state = state.set('reconfirmedPhone', null);
	            break;
	
	        case PhoneConfirm.SUCCESS_CREATE_PHONE_CONFIRMATION:
	            state = state.set('inProcess', false);
	            if (action.data.Error) {
	                state = state.set('error', action.data.Error);
	            } else {
	                state = state.set('error', null);
	                state = state.set('requested', true);
	                state = state.set('reconfirmedPhone', action.data.Phone);
	            }
	            break;
	
	        case PhoneConfirm.FAILURE_CREATE_PHONE_CONFIRMATION:
	            state = state.set('inProcess', false);
	            break;
	
	        case PhoneConfirm.CONFIRM_PHONE:
	            state = state.set('inProcess', true);
	            state = state.set('error', null);
	            state = state.set('confirmed', false);
	            break;
	
	        case PhoneConfirm.SUCCESS_CONFIRM_PHONE:
	            state = state.set('inProcess', false);
	            if (action.data.Error) {
	                state = state.set('error', action.data.Error);
	            } else {
	                state = state.set('error', null);
	                state = state.set('confirmed', true);
	            }
	            break;
	
	        case PhoneConfirm.FAILURE_CONFIRM_PHONE:
	            state = state.set('inProcess', false);
	            break;
	
	        case PhoneConfirm.DENY_CONFIRMATION:
	            state = state.set('requested', false);
	            state = state.set('confirmed', false);
	            break;
	    }
	
	    return state;
	}

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = promoCode;
	
	var _index = __webpack_require__(491);
	
	var PromoCode = _interopRequireWildcard(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    error: undefined,
	    success: false
	};
	
	function promoCode() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case PromoCode.SUCCESS_FETCH_PROMOCODE_ACTIVATE:
	            if (action.data.Result === 0) {
	                return (0, _extends3.default)({}, state, {
	                    success: true,
	                    error: undefined
	                });
	            }
	            if (action.data.Error === undefined) {
	                return (0, _extends3.default)({}, state, {
	                    error: -1,
	                    success: false
	                });
	            } else {
	                return (0, _extends3.default)({}, state, {
	                    error: action.data.Error,
	                    success: false
	                });
	            }
	
	        case PromoCode.FAILURE_FETCH_PROMOCODE_ACTIVATE:
	            return (0, _extends3.default)({}, state, {
	                error: -1,
	                success: false
	            });
	
	        case PromoCode.FETCH_PROMOCODE_ACTIVATE:
	            return (0, _extends3.default)({}, state, {
	                error: undefined,
	                success: false
	            });
	
	        default:
	            return state;
	    }
	}

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BackIcon = undefined;
	exports.default = SlotsNav;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(25);
	
	var _reactIntl = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	  games_back_to_games: {
	    id: 'games.back_to_games',
	    defaultMessage: 'Назад к списку игр'
	  },
	  all_slots: {
	    id: 'games.all_slots',
	    defaultMessage: 'Все слоты'
	  }
	}); /* eslint-disable jsx-a11y/iframe-has-title */
	function SlotsNav(_ref) {
	  var countryCode = _ref.countryCode;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'slots__nav' },
	    _react2.default.createElement(
	      _reactRouter.Link,
	      { to: '/games-vivo', className: 'slots--back', activeClassName: 'active' },
	      _react2.default.createElement(BackIcon, null),
	      _react2.default.createElement(_reactIntl.FormattedMessage, messages.games_back_to_games)
	    ),
	    _react2.default.createElement(
	      _reactRouter.Link,
	      { to: '/games/slots/betsoft', activeClassName: 'active' },
	      'Betsoft'
	    ),
	    _react2.default.createElement(
	      _reactRouter.Link,
	      { to: '/games/slots/tom-horn', activeClassName: 'active' },
	      'Tom Horn'
	    )
	  );
	}
	
	var BackIcon = exports.BackIcon = function BackIcon(_ref2) {
	  var _ref2$fill = _ref2.fill,
	      fill = _ref2$fill === undefined ? '#000' : _ref2$fill;
	  return _react2.default.createElement(
	    'svg',
	    {
	      id: 'Layer',
	      fill: fill,
	      enableBackground: 'new 0 0 64 64',
	      height: '20',
	      viewBox: '0 0 64 64',
	      width: '20',
	      xmlns: 'http://www.w3.org/2000/svg'
	    },
	    _react2.default.createElement('path', { d: 'm54 30h-39.899l15.278-14.552c.8-.762.831-2.028.069-2.828-.761-.799-2.027-.831-2.828-.069l-17.448 16.62c-.755.756-1.172 1.76-1.172 2.829 0 1.068.417 2.073 1.207 2.862l17.414 16.586c.387.369.883.552 1.379.552.528 0 1.056-.208 1.449-.621.762-.8.731-2.065-.069-2.827l-15.342-14.552h39.962c1.104 0 2-.896 2-2s-.896-2-2-2z' })
	  );
	};

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(597), __esModule: true };

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(599), __esModule: true };

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(354);
	__webpack_require__(99);
	__webpack_require__(165);
	__webpack_require__(611);
	__webpack_require__(616);
	__webpack_require__(615);
	__webpack_require__(614);
	module.exports = __webpack_require__(32).Map;


/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(612);
	module.exports = __webpack_require__(32).Object.keys;


/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(354);
	__webpack_require__(99);
	__webpack_require__(165);
	__webpack_require__(613);
	__webpack_require__(619);
	__webpack_require__(618);
	__webpack_require__(617);
	module.exports = __webpack_require__(32).Set;


/***/ },
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */
[2089, 347, 139, 349],
/* 612 */
[2091, 90, 313, 604],
/* 613 */
[2092, 347, 139, 349],
/* 614 */
[2093, 352],
/* 615 */
[2094, 353],
/* 616 */
[2095, 33, 348],
/* 617 */
[2097, 352],
/* 618 */
[2098, 353],
/* 619 */
[2099, 33, 348],
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */
/***/ function(module, exports) {

	'use strict'
	
	function extend(dest, src) {
	  if (src) {
	    var props = Object.keys(src)
	    for (var i = 0, l = props.length; i < l ; i++) {
	      dest[props[i]] = src[props[i]]
	    }
	  }
	  return dest
	}
	
	function copy(obj) {
	  return extend({}, obj)
	}
	
	/**
	 * Merge an object defining format characters into the defaults.
	 * Passing null/undefined for en existing format character removes it.
	 * Passing a definition for an existing format character overrides it.
	 * @param {?Object} formatCharacters.
	 */
	function mergeFormatCharacters(formatCharacters) {
	  var merged = copy(DEFAULT_FORMAT_CHARACTERS)
	  if (formatCharacters) {
	    var chars = Object.keys(formatCharacters)
	    for (var i = 0, l = chars.length; i < l ; i++) {
	      var char = chars[i]
	      if (formatCharacters[char] == null) {
	        delete merged[char]
	      }
	      else {
	        merged[char] = formatCharacters[char]
	      }
	    }
	  }
	  return merged
	}
	
	var ESCAPE_CHAR = '\\'
	
	var DIGIT_RE = /^\d$/
	var LETTER_RE = /^[A-Za-z]$/
	var ALPHANNUMERIC_RE = /^[\dA-Za-z]$/
	
	var DEFAULT_PLACEHOLDER_CHAR = '_'
	var DEFAULT_FORMAT_CHARACTERS = {
	  '*': {
	    validate: function(char) { return ALPHANNUMERIC_RE.test(char) }
	  },
	  '1': {
	    validate: function(char) { return DIGIT_RE.test(char) }
	  },
	  'a': {
	    validate: function(char) { return LETTER_RE.test(char) }
	  },
	  'A': {
	    validate: function(char) { return LETTER_RE.test(char) },
	    transform: function(char) { return char.toUpperCase() }
	  },
	  '#': {
	    validate: function(char) { return ALPHANNUMERIC_RE.test(char) },
	    transform: function(char) { return char.toUpperCase() }
	  }
	}
	
	/**
	 * @param {string} source
	 * @patam {?Object} formatCharacters
	 */
	function Pattern(source, formatCharacters, placeholderChar, isRevealingMask) {
	  if (!(this instanceof Pattern)) {
	    return new Pattern(source, formatCharacters, placeholderChar)
	  }
	
	  /** Placeholder character */
	  this.placeholderChar = placeholderChar || DEFAULT_PLACEHOLDER_CHAR
	  /** Format character definitions. */
	  this.formatCharacters = formatCharacters || DEFAULT_FORMAT_CHARACTERS
	  /** Pattern definition string with escape characters. */
	  this.source = source
	  /** Pattern characters after escape characters have been processed. */
	  this.pattern = []
	  /** Length of the pattern after escape characters have been processed. */
	  this.length = 0
	  /** Index of the first editable character. */
	  this.firstEditableIndex = null
	  /** Index of the last editable character. */
	  this.lastEditableIndex = null
	  /** Lookup for indices of editable characters in the pattern. */
	  this._editableIndices = {}
	  /** If true, only the pattern before the last valid value character shows. */
	  this.isRevealingMask = isRevealingMask || false
	
	  this._parse()
	}
	
	Pattern.prototype._parse = function parse() {
	  var sourceChars = this.source.split('')
	  var patternIndex = 0
	  var pattern = []
	
	  for (var i = 0, l = sourceChars.length; i < l; i++) {
	    var char = sourceChars[i]
	    if (char === ESCAPE_CHAR) {
	      if (i === l - 1) {
	        throw new Error('InputMask: pattern ends with a raw ' + ESCAPE_CHAR)
	      }
	      char = sourceChars[++i]
	    }
	    else if (char in this.formatCharacters) {
	      if (this.firstEditableIndex === null) {
	        this.firstEditableIndex = patternIndex
	      }
	      this.lastEditableIndex = patternIndex
	      this._editableIndices[patternIndex] = true
	    }
	
	    pattern.push(char)
	    patternIndex++
	  }
	
	  if (this.firstEditableIndex === null) {
	    throw new Error(
	      'InputMask: pattern "' + this.source + '" does not contain any editable characters.'
	    )
	  }
	
	  this.pattern = pattern
	  this.length = pattern.length
	}
	
	/**
	 * @param {Array<string>} value
	 * @return {Array<string>}
	 */
	Pattern.prototype.formatValue = function format(value) {
	  var valueBuffer = new Array(this.length)
	  var valueIndex = 0
	
	  for (var i = 0, l = this.length; i < l ; i++) {
	    if (this.isEditableIndex(i)) {
	      if (this.isRevealingMask &&
	          value.length <= valueIndex &&
	          !this.isValidAtIndex(value[valueIndex], i)) {
	        break
	      }
	      valueBuffer[i] = (value.length > valueIndex && this.isValidAtIndex(value[valueIndex], i)
	                        ? this.transform(value[valueIndex], i)
	                        : this.placeholderChar)
	      valueIndex++
	    }
	    else {
	      valueBuffer[i] = this.pattern[i]
	      // Also allow the value to contain static values from the pattern by
	      // advancing its index.
	      if (value.length > valueIndex && value[valueIndex] === this.pattern[i]) {
	        valueIndex++
	      }
	    }
	  }
	
	  return valueBuffer
	}
	
	/**
	 * @param {number} index
	 * @return {boolean}
	 */
	Pattern.prototype.isEditableIndex = function isEditableIndex(index) {
	  return !!this._editableIndices[index]
	}
	
	/**
	 * @param {string} char
	 * @param {number} index
	 * @return {boolean}
	 */
	Pattern.prototype.isValidAtIndex = function isValidAtIndex(char, index) {
	  return this.formatCharacters[this.pattern[index]].validate(char)
	}
	
	Pattern.prototype.transform = function transform(char, index) {
	  var format = this.formatCharacters[this.pattern[index]]
	  return typeof format.transform == 'function' ? format.transform(char) : char
	}
	
	function InputMask(options) {
	  if (!(this instanceof InputMask)) { return new InputMask(options) }
	  options = extend({
	    formatCharacters: null,
	    pattern: null,
	    isRevealingMask: false,
	    placeholderChar: DEFAULT_PLACEHOLDER_CHAR,
	    selection: {start: 0, end: 0},
	    value: ''
	  }, options)
	
	  if (options.pattern == null) {
	    throw new Error('InputMask: you must provide a pattern.')
	  }
	
	  if (typeof options.placeholderChar !== 'string' || options.placeholderChar.length > 1) {
	    throw new Error('InputMask: placeholderChar should be a single character or an empty string.')
	  }
	
	  this.placeholderChar = options.placeholderChar
	  this.formatCharacters = mergeFormatCharacters(options.formatCharacters)
	  this.setPattern(options.pattern, {
	    value: options.value,
	    selection: options.selection,
	    isRevealingMask: options.isRevealingMask
	  })
	}
	
	// Editing
	
	/**
	 * Applies a single character of input based on the current selection.
	 * @param {string} char
	 * @return {boolean} true if a change has been made to value or selection as a
	 *   result of the input, false otherwise.
	 */
	InputMask.prototype.input = function input(char) {
	  // Ignore additional input if the cursor's at the end of the pattern
	  if (this.selection.start === this.selection.end &&
	      this.selection.start === this.pattern.length) {
	    return false
	  }
	
	  var selectionBefore = copy(this.selection)
	  var valueBefore = this.getValue()
	
	  var inputIndex = this.selection.start
	
	  // If the cursor or selection is prior to the first editable character, make
	  // sure any input given is applied to it.
	  if (inputIndex < this.pattern.firstEditableIndex) {
	    inputIndex = this.pattern.firstEditableIndex
	  }
	
	  // Bail out or add the character to input
	  if (this.pattern.isEditableIndex(inputIndex)) {
	    if (!this.pattern.isValidAtIndex(char, inputIndex)) {
	      return false
	    }
	    this.value[inputIndex] = this.pattern.transform(char, inputIndex)
	  }
	
	  // If multiple characters were selected, blank the remainder out based on the
	  // pattern.
	  var end = this.selection.end - 1
	  while (end > inputIndex) {
	    if (this.pattern.isEditableIndex(end)) {
	      this.value[end] = this.placeholderChar
	    }
	    end--
	  }
	
	  // Advance the cursor to the next character
	  this.selection.start = this.selection.end = inputIndex + 1
	
	  // Skip over any subsequent static characters
	  while (this.pattern.length > this.selection.start &&
	         !this.pattern.isEditableIndex(this.selection.start)) {
	    this.selection.start++
	    this.selection.end++
	  }
	
	  // History
	  if (this._historyIndex != null) {
	    // Took more input after undoing, so blow any subsequent history away
	    this._history.splice(this._historyIndex, this._history.length - this._historyIndex)
	    this._historyIndex = null
	  }
	  if (this._lastOp !== 'input' ||
	      selectionBefore.start !== selectionBefore.end ||
	      this._lastSelection !== null && selectionBefore.start !== this._lastSelection.start) {
	    this._history.push({value: valueBefore, selection: selectionBefore, lastOp: this._lastOp})
	  }
	  this._lastOp = 'input'
	  this._lastSelection = copy(this.selection)
	
	  return true
	}
	
	/**
	 * Attempts to delete from the value based on the current cursor position or
	 * selection.
	 * @return {boolean} true if the value or selection changed as the result of
	 *   backspacing, false otherwise.
	 */
	InputMask.prototype.backspace = function backspace() {
	  // If the cursor is at the start there's nothing to do
	  if (this.selection.start === 0 && this.selection.end === 0) {
	    return false
	  }
	
	  var selectionBefore = copy(this.selection)
	  var valueBefore = this.getValue()
	
	  // No range selected - work on the character preceding the cursor
	  if (this.selection.start === this.selection.end) {
	    if (this.pattern.isEditableIndex(this.selection.start - 1)) {
	      this.value[this.selection.start - 1] = this.placeholderChar
	    }
	    this.selection.start--
	    this.selection.end--
	  }
	  // Range selected - delete characters and leave the cursor at the start of the selection
	  else {
	    var end = this.selection.end - 1
	    while (end >= this.selection.start) {
	      if (this.pattern.isEditableIndex(end)) {
	        this.value[end] = this.placeholderChar
	      }
	      end--
	    }
	    this.selection.end = this.selection.start
	  }
	
	  // History
	  if (this._historyIndex != null) {
	    // Took more input after undoing, so blow any subsequent history away
	    this._history.splice(this._historyIndex, this._history.length - this._historyIndex)
	  }
	  if (this._lastOp !== 'backspace' ||
	      selectionBefore.start !== selectionBefore.end ||
	      this._lastSelection !== null && selectionBefore.start !== this._lastSelection.start) {
	    this._history.push({value: valueBefore, selection: selectionBefore, lastOp: this._lastOp})
	  }
	  this._lastOp = 'backspace'
	  this._lastSelection = copy(this.selection)
	
	  return true
	}
	
	/**
	 * Attempts to paste a string of input at the current cursor position or over
	 * the top of the current selection.
	 * Invalid content at any position will cause the paste to be rejected, and it
	 * may contain static parts of the mask's pattern.
	 * @param {string} input
	 * @return {boolean} true if the paste was successful, false otherwise.
	 */
	InputMask.prototype.paste = function paste(input) {
	  // This is necessary because we're just calling input() with each character
	  // and rolling back if any were invalid, rather than checking up-front.
	  var initialState = {
	    value: this.value.slice(),
	    selection: copy(this.selection),
	    _lastOp: this._lastOp,
	    _history: this._history.slice(),
	    _historyIndex: this._historyIndex,
	    _lastSelection: copy(this._lastSelection)
	  }
	
	  // If there are static characters at the start of the pattern and the cursor
	  // or selection is within them, the static characters must match for a valid
	  // paste.
	  if (this.selection.start < this.pattern.firstEditableIndex) {
	    for (var i = 0, l = this.pattern.firstEditableIndex - this.selection.start; i < l; i++) {
	      if (input.charAt(i) !== this.pattern.pattern[i]) {
	        return false
	      }
	    }
	
	    // Continue as if the selection and input started from the editable part of
	    // the pattern.
	    input = input.substring(this.pattern.firstEditableIndex - this.selection.start)
	    this.selection.start = this.pattern.firstEditableIndex
	  }
	
	  for (i = 0, l = input.length;
	       i < l && this.selection.start <= this.pattern.lastEditableIndex;
	       i++) {
	    var valid = this.input(input.charAt(i))
	    // Allow static parts of the pattern to appear in pasted input - they will
	    // already have been stepped over by input(), so verify that the value
	    // deemed invalid by input() was the expected static character.
	    if (!valid) {
	      if (this.selection.start > 0) {
	        // XXX This only allows for one static character to be skipped
	        var patternIndex = this.selection.start - 1
	        if (!this.pattern.isEditableIndex(patternIndex) &&
	            input.charAt(i) === this.pattern.pattern[patternIndex]) {
	          continue
	        }
	      }
	      extend(this, initialState)
	      return false
	    }
	  }
	
	  return true
	}
	
	// History
	
	InputMask.prototype.undo = function undo() {
	  // If there is no history, or nothing more on the history stack, we can't undo
	  if (this._history.length === 0 || this._historyIndex === 0) {
	    return false
	  }
	
	  var historyItem
	  if (this._historyIndex == null) {
	    // Not currently undoing, set up the initial history index
	    this._historyIndex = this._history.length - 1
	    historyItem = this._history[this._historyIndex]
	    // Add a new history entry if anything has changed since the last one, so we
	    // can redo back to the initial state we started undoing from.
	    var value = this.getValue()
	    if (historyItem.value !== value ||
	        historyItem.selection.start !== this.selection.start ||
	        historyItem.selection.end !== this.selection.end) {
	      this._history.push({value: value, selection: copy(this.selection), lastOp: this._lastOp, startUndo: true})
	    }
	  }
	  else {
	    historyItem = this._history[--this._historyIndex]
	  }
	
	  this.value = historyItem.value.split('')
	  this.selection = historyItem.selection
	  this._lastOp = historyItem.lastOp
	  return true
	}
	
	InputMask.prototype.redo = function redo() {
	  if (this._history.length === 0 || this._historyIndex == null) {
	    return false
	  }
	  var historyItem = this._history[++this._historyIndex]
	  // If this is the last history item, we're done redoing
	  if (this._historyIndex === this._history.length - 1) {
	    this._historyIndex = null
	    // If the last history item was only added to start undoing, remove it
	    if (historyItem.startUndo) {
	      this._history.pop()
	    }
	  }
	  this.value = historyItem.value.split('')
	  this.selection = historyItem.selection
	  this._lastOp = historyItem.lastOp
	  return true
	}
	
	// Getters & setters
	
	InputMask.prototype.setPattern = function setPattern(pattern, options) {
	  options = extend({
	    selection: {start: 0, end: 0},
	    value: ''
	  }, options)
	  this.pattern = new Pattern(pattern, this.formatCharacters, this.placeholderChar, options.isRevealingMask)
	  this.setValue(options.value)
	  this.emptyValue = this.pattern.formatValue([]).join('')
	  this.selection = options.selection
	  this._resetHistory()
	}
	
	InputMask.prototype.setSelection = function setSelection(selection) {
	  this.selection = copy(selection)
	  if (this.selection.start === this.selection.end) {
	    if (this.selection.start < this.pattern.firstEditableIndex) {
	      this.selection.start = this.selection.end = this.pattern.firstEditableIndex
	      return true
	    }
	    // Set selection to the first editable, non-placeholder character before the selection
	    // OR to the beginning of the pattern
	    var index = this.selection.start
	    while (index >= this.pattern.firstEditableIndex) {
	      if (this.pattern.isEditableIndex(index - 1) &&
	          this.value[index - 1] !== this.placeholderChar ||
	          index === this.pattern.firstEditableIndex) {
	        this.selection.start = this.selection.end = index
	        break
	      }
	      index--
	    }
	    return true
	  }
	  return false
	}
	
	InputMask.prototype.setValue = function setValue(value) {
	  if (value == null) {
	    value = ''
	  }
	  this.value = this.pattern.formatValue(value.split(''))
	}
	
	InputMask.prototype.getValue = function getValue() {
	  return this.value.join('')
	}
	
	InputMask.prototype.getRawValue = function getRawValue() {
	  var rawValue = []
	  for (var i = 0; i < this.value.length; i++) {
	    if (this.pattern._editableIndices[i] === true) {
	      rawValue.push(this.value[i])
	    }
	  }
	  return rawValue.join('')
	}
	
	InputMask.prototype._resetHistory = function _resetHistory() {
	  this._history = []
	  this._historyIndex = null
	  this._lastOp = null
	  this._lastSelection = copy(this.selection)
	}
	
	InputMask.Pattern = Pattern
	
	module.exports = InputMask


/***/ },
/* 649 */
/***/ function(module, exports) {

	module.exports = {
		"1": {
			"name": "Australia",
			"mask": "+61",
			"length": 9
		},
		"2": {
			"name": "Austria",
			"mask": "+43",
			"length": 9
		},
		"3": {
			"name": "Azerbaijan",
			"mask": "+994",
			"length": 9
		},
		"5": {
			"name": "Algeria",
			"mask": "+213",
			"length": 9
		},
		"6": {
			"name": "American Samoa",
			"mask": "+1",
			"length": 10
		},
		"7": {
			"name": "Anguilla",
			"mask": "+1",
			"length": 10
		},
		"8": {
			"name": "Angola",
			"mask": "+244",
			"length": 9
		},
		"9": {
			"name": "Andorra",
			"mask": "+376",
			"length": 6
		},
		"11": {
			"name": "Antigua And Barbuda",
			"mask": "+1",
			"length": 10
		},
		"12": {
			"name": "Argentina",
			"mask": "+54",
			"length": 11
		},
		"13": {
			"name": "Armenia",
			"mask": "+374",
			"length": 8
		},
		"14": {
			"name": "Aruba",
			"mask": "+297",
			"length": 7
		},
		"15": {
			"name": "Afghanistan",
			"mask": "+93",
			"length": 9
		},
		"16": {
			"name": "Bahamas",
			"mask": "+1",
			"length": 10
		},
		"17": {
			"name": "Bangladesh",
			"mask": "+880",
			"length": 10
		},
		"18": {
			"name": "Barbados",
			"mask": "+1",
			"length": 10
		},
		"19": {
			"name": "Bahrain",
			"mask": "+973",
			"length": 8
		},
		"20": {
			"name": "Belize",
			"mask": "+501",
			"length": 7
		},
		"21": {
			"name": "Belarus",
			"mask": "+375",
			"length": 9
		},
		"22": {
			"name": "Belgium",
			"mask": "+32",
			"length": 9
		},
		"23": {
			"name": "Benin",
			"mask": "+229",
			"length": 8
		},
		"24": {
			"name": "Bermuda",
			"mask": "+1",
			"length": 10
		},
		"25": {
			"name": "Bulgaria",
			"mask": "+359",
			"length": 8
		},
		"26": {
			"name": "Bolivia",
			"mask": "+571",
			"length": 8
		},
		"27": {
			"name": "Bosnia And Herzegovina",
			"mask": "+387",
			"length": 8
		},
		"28": {
			"name": "Botswana",
			"mask": "+267",
			"length": 8
		},
		"29": {
			"name": "Brazil",
			"mask": "+55",
			"length": 10
		},
		"30": {
			"name": "British Indian Ocean Territory",
			"mask": "+246",
			"length": 7
		},
		"32": {
			"name": "Brunei Darussalam",
			"mask": "+673",
			"length": 7
		},
		"33": {
			"name": "Burkina Faso",
			"mask": "+226",
			"length": 8
		},
		"34": {
			"name": "Burundi",
			"mask": "+257",
			"length": 8
		},
		"35": {
			"name": "Bhutan",
			"mask": "+975",
			"length": 8
		},
		"36": {
			"name": "Vanuatu",
			"mask": "+678",
			"length": 7
		},
		"38": {
			"name": "United Kingdom",
			"mask": "+44",
			"length": 10
		},
		"39": {
			"name": "Hungary",
			"mask": "+36",
			"length": 9
		},
		"40": {
			"name": "Venezuela",
			"mask": "+58",
			"length": 10
		},
		"42": {
			"name": "Vietnam",
			"mask": "+84",
			"length": 9
		},
		"43": {
			"name": "Gabon",
			"mask": "+241",
			"length": 8
		},
		"44": {
			"name": "Haiti",
			"mask": "+509",
			"length": 8
		},
		"45": {
			"name": "Guyana",
			"mask": "+592",
			"length": 7
		},
		"46": {
			"name": "Gambia",
			"mask": "+220",
			"length": 7
		},
		"47": {
			"name": "Ghana",
			"mask": "+233",
			"length": 9
		},
		"48": {
			"name": "Guadeloupe",
			"mask": "+590",
			"length": 9
		},
		"49": {
			"name": "Guatemala",
			"mask": "+502",
			"length": 8
		},
		"50": {
			"name": "Guinea",
			"mask": "+224",
			"length": 8
		},
		"51": {
			"name": "Guinea-Bissau",
			"mask": "+245",
			"length": 7
		},
		"52": {
			"name": "Germany",
			"mask": "+49",
			"length": 11
		},
		"53": {
			"name": "Honduras",
			"mask": "+504",
			"length": 8
		},
		"54": {
			"name": "State of Palestine",
			"mask": "+970",
			"length": 9
		},
		"55": {
			"name": "Grenada",
			"mask": "+1",
			"length": 10
		},
		"56": {
			"name": "Greenland",
			"mask": "+299",
			"length": 6
		},
		"58": {
			"name": "Guam",
			"mask": "+1",
			"length": 10
		},
		"60": {
			"name": "Djibouti",
			"mask": "+253",
			"length": 8
		},
		"61": {
			"name": "Dominica",
			"mask": "+1",
			"length": 10
		},
		"62": {
			"name": "Dominican Republic",
			"mask": "+1",
			"length": 10
		},
		"63": {
			"name": "Egypt",
			"mask": "+20",
			"length": 10
		},
		"64": {
			"name": "Zambia",
			"mask": "+260",
			"length": 9
		},
		"65": {
			"name": "Western Sahara",
			"mask": "+212",
			"length": 9
		},
		"66": {
			"name": "Zimbabwe",
			"mask": "+263",
			"length": 9
		},
		"67": {
			"name": "Israel",
			"mask": "+972",
			"length": 9
		},
		"68": {
			"name": "India",
			"mask": "+91",
			"length": 10
		},
		"69": {
			"name": "Indonesia",
			"mask": "+62",
			"length": 9
		},
		"70": {
			"name": "Jordan",
			"mask": "+962",
			"length": 9
		},
		"71": {
			"name": "Iraq",
			"mask": "+964",
			"length": 10
		},
		"72": {
			"name": "Iran, Islamic Republic of",
			"mask": "+98",
			"length": 10
		},
		"73": {
			"name": "Ireland",
			"mask": "+353",
			"length": 9
		},
		"74": {
			"name": "Iceland",
			"mask": "+354",
			"length": 7
		},
		"75": {
			"name": "Spain",
			"mask": "+34",
			"length": 9
		},
		"76": {
			"name": "Italy",
			"mask": "+39",
			"length": 10
		},
		"77": {
			"name": "Yemen",
			"mask": "+967",
			"length": 9
		},
		"78": {
			"name": "Cape Verde",
			"mask": "+238",
			"length": 7
		},
		"79": {
			"name": "Kazakstan",
			"mask": "+7",
			"length": 10
		},
		"80": {
			"name": "Cayman Islands",
			"mask": "+1",
			"length": 10
		},
		"81": {
			"name": "Cambodia",
			"mask": "+855",
			"length": 8
		},
		"82": {
			"name": "Cameroon",
			"mask": "+237",
			"length": 8
		},
		"83": {
			"name": "Canada",
			"mask": "+1",
			"length": 10
		},
		"84": {
			"name": "Qatar",
			"mask": "+974",
			"length": 8
		},
		"85": {
			"name": "Kenya",
			"mask": "+254",
			"length": 9
		},
		"86": {
			"name": "Kiribati",
			"mask": "+686",
			"length": 5
		},
		"87": {
			"name": "Taiwan, Province of China",
			"mask": "+886",
			"length": 9
		},
		"88": {
			"name": "Korea, Democratic People's Republic of",
			"mask": "+850",
			"length": 10
		},
		"89": {
			"name": "Cocos (Keeling) Islands",
			"mask": "+61",
			"length": 9
		},
		"90": {
			"name": "Colombia",
			"mask": "+57",
			"length": 10
		},
		"91": {
			"name": "Comoros",
			"mask": "+269",
			"length": 7
		},
		"92": {
			"name": "Costa Rica",
			"mask": "+506",
			"length": 8
		},
		"93": {
			"name": "Cote D'Ivoire",
			"mask": "+255",
			"length": 8
		},
		"94": {
			"name": "Cuba",
			"mask": "+53",
			"length": 8
		},
		"95": {
			"name": "Kuwait",
			"mask": "+965",
			"length": 7
		},
		"96": {
			"name": "Kyrgyzstan",
			"mask": "+996",
			"length": 9
		},
		"97": {
			"name": "Lao People's Democratic Republic",
			"mask": "+856",
			"length": 10
		},
		"98": {
			"name": "Lesotho",
			"mask": "+266",
			"length": 8
		},
		"99": {
			"name": "Liberia",
			"mask": "+231",
			"length": 7
		},
		"100": {
			"name": "Lebanon",
			"mask": "+961",
			"length": 8
		},
		"101": {
			"name": "Libyan Arab Jamahiriya",
			"mask": "+218",
			"length": 9
		},
		"102": {
			"name": "Lithuania",
			"mask": "+218",
			"length": 9
		},
		"103": {
			"name": "Luxembourg",
			"mask": "+352",
			"length": 9
		},
		"104": {
			"name": "Mauritius",
			"mask": "+230",
			"length": 7
		},
		"105": {
			"name": "Mauritania",
			"mask": "+222",
			"length": 8
		},
		"106": {
			"name": "Madagascar",
			"mask": "+261",
			"length": 9
		},
		"107": {
			"name": "Mayotte",
			"mask": "+262",
			"length": 9
		},
		"108": {
			"name": "Malawi",
			"mask": "+265",
			"length": 9
		},
		"109": {
			"name": "Malaysia",
			"mask": "+60",
			"length": 9
		},
		"110": {
			"name": "Mali",
			"mask": "+223",
			"length": 8
		},
		"111": {
			"name": "Maldives",
			"mask": "+960",
			"length": 7
		},
		"112": {
			"name": "Malta",
			"mask": "+356",
			"length": 8
		},
		"113": {
			"name": "Morocco",
			"mask": "+212",
			"length": 9
		},
		"114": {
			"name": "Marshall Islands",
			"mask": "+692",
			"length": 7
		},
		"115": {
			"name": "Mexico",
			"mask": "+52",
			"length": 11
		},
		"116": {
			"name": "Micronesia, Federated States of",
			"mask": "+691",
			"length": 7
		},
		"117": {
			"name": "Mozambique",
			"mask": "+258",
			"length": 9
		},
		"118": {
			"name": "Moldova, Republic of",
			"mask": "+373",
			"length": 8
		},
		"119": {
			"name": "Monaco",
			"mask": "+377",
			"length": 9
		},
		"120": {
			"name": "Mongolia",
			"mask": "+976",
			"length": 8
		},
		"121": {
			"name": "Montserrat",
			"mask": "+1",
			"length": 10
		},
		"122": {
			"name": "Myanmar",
			"mask": "+95",
			"length": 8
		},
		"123": {
			"name": "Namibia",
			"mask": "+264",
			"length": 9
		},
		"124": {
			"name": "Nauru",
			"mask": "+674",
			"length": 7
		},
		"125": {
			"name": "Nepal",
			"mask": "+977",
			"length": 10
		},
		"126": {
			"name": "Niger",
			"mask": "+227",
			"length": 8
		},
		"127": {
			"name": "Nigeria",
			"mask": "+234",
			"length": 10
		},
		"129": {
			"name": "Netherlands",
			"mask": "+31",
			"length": 9
		},
		"130": {
			"name": "Nicaragua",
			"mask": "+505",
			"length": 8
		},
		"131": {
			"name": "Niue",
			"mask": "+683",
			"length": 4
		},
		"132": {
			"name": "New Zealand",
			"mask": "+64",
			"length": 9
		},
		"133": {
			"name": "New Caledonia",
			"mask": "+687",
			"length": 6
		},
		"134": {
			"name": "Norway",
			"mask": "+47",
			"length": 8
		},
		"135": {
			"name": "United Arab Emirates",
			"mask": "+971",
			"length": 9
		},
		"136": {
			"name": "Oman",
			"mask": "+968",
			"length": 8
		},
		"138": {
			"name": "Norfolk Island",
			"mask": "+672",
			"length": 6
		},
		"139": {
			"name": "Christmas Island",
			"mask": "+61",
			"length": 9
		},
		"141": {
			"name": "Cook Islands",
			"mask": "+682",
			"length": 5
		},
		"143": {
			"name": "Pakistan",
			"mask": "+92",
			"length": 10
		},
		"144": {
			"name": "Palau",
			"mask": "+680",
			"length": 7
		},
		"145": {
			"name": "Papua New Guinea",
			"mask": "+675",
			"length": 7
		},
		"146": {
			"name": "Paraguay",
			"mask": "+595",
			"length": 9
		},
		"147": {
			"name": "Peru",
			"mask": "+51",
			"length": 9
		},
		"148": {
			"name": "Poland",
			"mask": "+48",
			"length": 9
		},
		"149": {
			"name": "Portugal",
			"mask": "+351",
			"length": 9
		},
		"150": {
			"name": "Puerto Rico",
			"mask": "+1",
			"length": 10
		},
		"151": {
			"name": "Congo",
			"mask": "+243",
			"length": 9
		},
		"152": {
			"name": "Korea, Republic of",
			"mask": "+82",
			"length": 10
		},
		"153": {
			"name": "Macedonia, The Former Yugoslav Republic of",
			"mask": "+389",
			"length": 8
		},
		"154": {
			"name": "Russian Federation",
			"mask": "+7",
			"length": 10
		},
		"155": {
			"name": "Rwanda",
			"mask": "+250",
			"length": 9
		},
		"156": {
			"name": "Romania",
			"mask": "+40",
			"length": 9
		},
		"157": {
			"name": "El Salvador",
			"mask": "+503",
			"length": 8
		},
		"158": {
			"name": "Samoa",
			"mask": "+685",
			"length": 6
		},
		"159": {
			"name": "San Marino",
			"mask": "+378",
			"length": 8
		},
		"160": {
			"name": "Sao Tome And Principe",
			"mask": "+239",
			"length": 7
		},
		"161": {
			"name": "Saudi Arabia",
			"mask": "+966",
			"length": 9
		},
		"162": {
			"name": "Swaziland",
			"mask": "+268",
			"length": 8
		},
		"163": {
			"name": "Northern Mariana Islands",
			"mask": "+1",
			"length": 10
		},
		"164": {
			"name": "Seychelles",
			"mask": "+248",
			"length": 7
		},
		"165": {
			"name": "Saint Pierre And Miquelon",
			"mask": "+508",
			"length": 6
		},
		"166": {
			"name": "Senegal",
			"mask": "+221",
			"length": 9
		},
		"167": {
			"name": "Saint Vincent And The Grenadines",
			"mask": "+1",
			"length": 10
		},
		"168": {
			"name": "Saint Kitts And Nevis",
			"mask": "+1",
			"length": 10
		},
		"169": {
			"name": "Saint Lucia",
			"mask": "+1",
			"length": 10
		},
		"170": {
			"name": "Serbia",
			"mask": "+381",
			"length": 9
		},
		"171": {
			"name": "Singapore",
			"mask": "+65",
			"length": 8
		},
		"172": {
			"name": "Syrian Arab Republic",
			"mask": "+963",
			"length": 9
		},
		"173": {
			"name": "Slovakia (Slovak Republic)",
			"mask": "+421",
			"length": 9
		},
		"174": {
			"name": "Slovenia",
			"mask": "+386",
			"length": 8
		},
		"175": {
			"name": "Solomon Islands",
			"mask": "+677",
			"length": 7
		},
		"176": {
			"name": "Somalia",
			"mask": "+252",
			"length": 8
		},
		"177": {
			"name": "Sudan",
			"mask": "+249",
			"length": 9
		},
		"178": {
			"name": "Suriname",
			"mask": "+597",
			"length": 7
		},
		"179": {
			"name": "Sierra Leone",
			"mask": "+232",
			"length": 8
		},
		"180": {
			"name": "Tajikistan",
			"mask": "+992",
			"length": 9
		},
		"181": {
			"name": "Thailand",
			"mask": "+66",
			"length": 9
		},
		"182": {
			"name": "Tanzania, United Republic of",
			"mask": "+255",
			"length": 9
		},
		"183": {
			"name": "Turks And Caicos Islands",
			"mask": "+1",
			"length": 10
		},
		"184": {
			"name": "Togo",
			"mask": "+228",
			"length": 8
		},
		"185": {
			"name": "Tokelau",
			"mask": "+676",
			"length": 7
		},
		"186": {
			"name": "Tonga",
			"mask": "+676",
			"length": 7
		},
		"187": {
			"name": "Trinidad And Tobago",
			"mask": "+1",
			"length": 10
		},
		"188": {
			"name": "Tuvalu",
			"mask": "+688",
			"length": 6
		},
		"189": {
			"name": "Tunisia",
			"mask": "+216",
			"length": 8
		},
		"190": {
			"name": "Turkmenistan",
			"mask": "+993",
			"length": 8
		},
		"191": {
			"name": "Uganda",
			"mask": "+256",
			"length": 9
		},
		"192": {
			"name": "Uzbekistan",
			"mask": "+998",
			"length": 9
		},
		"193": {
			"name": "Ukraine",
			"mask": "+380",
			"length": 9
		},
		"194": {
			"name": "Wallis And Futuna Islands",
			"mask": "+681",
			"length": 6
		},
		"195": {
			"name": "Uruguay",
			"mask": "+598",
			"length": 8
		},
		"196": {
			"name": "Faroe Islands",
			"mask": "+298",
			"length": 6
		},
		"197": {
			"name": "Fiji",
			"mask": "+679",
			"length": 7
		},
		"198": {
			"name": "Philippines",
			"mask": "+63",
			"length": 10
		},
		"199": {
			"name": "Finland",
			"mask": "+358",
			"length": 9
		},
		"200": {
			"name": "Falkland Islands (Malvinas)",
			"mask": "+500",
			"length": 5
		},
		"201": {
			"name": "French Polynesia",
			"mask": "+689",
			"length": 9
		},
		"203": {
			"name": "Central African Republic",
			"mask": "+236",
			"length": 8
		},
		"204": {
			"name": "Chad",
			"mask": "+235",
			"length": 8
		},
		"205": {
			"name": "Montenegro",
			"mask": "+382",
			"length": 8
		},
		"206": {
			"name": "Czech Republic",
			"mask": "+420",
			"length": 9
		},
		"207": {
			"name": "Chile",
			"mask": "+56",
			"length": 9
		},
		"208": {
			"name": "Sweden",
			"mask": "+46",
			"length": 9
		},
		"209": {
			"name": "Svalbard And Jan Mayen Islands",
			"mask": "+47",
			"length": 8
		},
		"210": {
			"name": "Sri Lanka",
			"mask": "+94",
			"length": 9
		},
		"211": {
			"name": "Ecuador",
			"mask": "+593",
			"length": 9
		},
		"212": {
			"name": "Equatorial Guinea",
			"mask": "+240",
			"length": 9
		},
		"213": {
			"name": "Eritrea",
			"mask": "+291",
			"length": 7
		},
		"214": {
			"name": "Estonia",
			"mask": "+372",
			"length": 8
		},
		"216": {
			"name": "South Africa",
			"mask": "+27",
			"length": 9
		},
		"218": {
			"name": "Jamaica",
			"mask": "+1",
			"length": 10
		},
		"219": {
			"name": "Japan",
			"mask": "+81",
			"length": 10
		}
	};

/***/ },
/* 650 */
/***/ function(module, exports) {

	module.exports = {
		"1": {
			"name": "Австралия",
			"mask": "+61",
			"length": 9
		},
		"2": {
			"name": "Австрия",
			"mask": "+43",
			"length": 9
		},
		"3": {
			"name": "Азербайджан",
			"mask": "+994",
			"length": 9
		},
		"5": {
			"name": "Алжир",
			"mask": "+213",
			"length": 9
		},
		"6": {
			"name": "Американское Самоа",
			"mask": "+1",
			"length": 10
		},
		"7": {
			"name": "Ангилья",
			"mask": "+1",
			"length": 10
		},
		"8": {
			"name": "Ангола",
			"mask": "+244",
			"length": 9
		},
		"9": {
			"name": "Андорра",
			"mask": "+376",
			"length": 6
		},
		"11": {
			"name": "Антигуа и Барбуда",
			"mask": "+1",
			"length": 10
		},
		"12": {
			"name": "Аргентина",
			"mask": "+54",
			"length": 11
		},
		"13": {
			"name": "Армения",
			"mask": "+374",
			"length": 8
		},
		"14": {
			"name": "Аруба",
			"mask": "+297",
			"length": 7
		},
		"15": {
			"name": "Афганистан",
			"mask": "+93",
			"length": 9
		},
		"16": {
			"name": "Багамы",
			"mask": "+1",
			"length": 10
		},
		"17": {
			"name": "Бангладеш",
			"mask": "+880",
			"length": 10
		},
		"18": {
			"name": "Барбадос",
			"mask": "+1",
			"length": 10
		},
		"19": {
			"name": "Бахрейн",
			"mask": "+973",
			"length": 8
		},
		"20": {
			"name": "Белиз",
			"mask": "+501",
			"length": 7
		},
		"21": {
			"name": "Белоруссия",
			"mask": "+375",
			"length": 9
		},
		"22": {
			"name": "Бельгия",
			"mask": "+32",
			"length": 9
		},
		"23": {
			"name": "Бенин",
			"mask": "+229",
			"length": 8
		},
		"24": {
			"name": "Бермуды",
			"mask": "+1",
			"length": 10
		},
		"25": {
			"name": "Болгария",
			"mask": "+359",
			"length": 8
		},
		"26": {
			"name": "Боливия",
			"mask": "+571",
			"length": 8
		},
		"27": {
			"name": "Босния и Герцеговина",
			"mask": "+387",
			"length": 8
		},
		"28": {
			"name": "Ботсвана",
			"mask": "+267",
			"length": 8
		},
		"29": {
			"name": "Бразилия",
			"mask": "+55",
			"length": 10
		},
		"30": {
			"name": "Британская территория в Индийском океане",
			"mask": "+246",
			"length": 7
		},
		"32": {
			"name": "Бруней",
			"mask": "+673",
			"length": 7
		},
		"33": {
			"name": "Буркина Фасо",
			"mask": "+226",
			"length": 8
		},
		"34": {
			"name": "Бурунди",
			"mask": "+257",
			"length": 8
		},
		"35": {
			"name": "Бутан",
			"mask": "+975",
			"length": 8
		},
		"36": {
			"name": "Вануату",
			"mask": "+678",
			"length": 7
		},
		"38": {
			"name": "Великобритания",
			"mask": "+44",
			"length": 10
		},
		"39": {
			"name": "Венгрия",
			"mask": "+36",
			"length": 9
		},
		"40": {
			"name": "Венесуэла",
			"mask": "+58",
			"length": 10
		},
		"42": {
			"name": "Вьетнам",
			"mask": "+84",
			"length": 9
		},
		"43": {
			"name": "Габон",
			"mask": "+241",
			"length": 8
		},
		"44": {
			"name": "Гаити",
			"mask": "+509",
			"length": 8
		},
		"45": {
			"name": "Гайана",
			"mask": "+592",
			"length": 7
		},
		"46": {
			"name": "Гамбия",
			"mask": "+220",
			"length": 7
		},
		"47": {
			"name": "Гана",
			"mask": "+233",
			"length": 9
		},
		"48": {
			"name": "Гваделупа",
			"mask": "+590",
			"length": 9
		},
		"49": {
			"name": "Гватемала",
			"mask": "+502",
			"length": 8
		},
		"50": {
			"name": "Гвинея",
			"mask": "+224",
			"length": 8
		},
		"51": {
			"name": "Гвинея-Бисау",
			"mask": "+245",
			"length": 7
		},
		"52": {
			"name": "Германия",
			"mask": "+49",
			"length": 11
		},
		"53": {
			"name": "Гондурас",
			"mask": "+504",
			"length": 8
		},
		"54": {
			"name": "Государство Палестина",
			"mask": "+970",
			"length": 9
		},
		"55": {
			"name": "Гренада",
			"mask": "+1",
			"length": 10
		},
		"56": {
			"name": "Гренландия",
			"mask": "+299",
			"length": 6
		},
		"58": {
			"name": "Гуам",
			"mask": "+1",
			"length": 10
		},
		"60": {
			"name": "Джибути",
			"mask": "+253",
			"length": 8
		},
		"61": {
			"name": "Доминика",
			"mask": "+1",
			"length": 10
		},
		"62": {
			"name": "Доминиканская Республика",
			"mask": "+1",
			"length": 10
		},
		"63": {
			"name": "Египет",
			"mask": "+20",
			"length": 10
		},
		"64": {
			"name": "Замбия",
			"mask": "+260",
			"length": 9
		},
		"65": {
			"name": "Западная Сахара",
			"mask": "+212",
			"length": 9
		},
		"66": {
			"name": "Зимбабве",
			"mask": "+263",
			"length": 9
		},
		"67": {
			"name": "Израиль",
			"mask": "+972",
			"length": 9
		},
		"68": {
			"name": "Индия",
			"mask": "+91",
			"length": 10
		},
		"69": {
			"name": "Индонезия",
			"mask": "+62",
			"length": 9
		},
		"70": {
			"name": "Иордания",
			"mask": "+962",
			"length": 9
		},
		"71": {
			"name": "Ирак",
			"mask": "+964",
			"length": 10
		},
		"72": {
			"name": "Иран",
			"mask": "+98",
			"length": 10
		},
		"73": {
			"name": "Ирландия",
			"mask": "+353",
			"length": 9
		},
		"74": {
			"name": "Исландия",
			"mask": "+354",
			"length": 7
		},
		"75": {
			"name": "Испания",
			"mask": "+34",
			"length": 9
		},
		"76": {
			"name": "Италия",
			"mask": "+39",
			"length": 10
		},
		"77": {
			"name": "Йемен",
			"mask": "+967",
			"length": 9
		},
		"78": {
			"name": "Кабо-Верде",
			"mask": "+238",
			"length": 7
		},
		"79": {
			"name": "Казахстан",
			"mask": "+7",
			"length": 10
		},
		"80": {
			"name": "Каймановы острова",
			"mask": "+1",
			"length": 10
		},
		"81": {
			"name": "Камбоджа",
			"mask": "+855",
			"length": 8
		},
		"82": {
			"name": "Камерун",
			"mask": "+237",
			"length": 8
		},
		"83": {
			"name": "Канада",
			"mask": "+1",
			"length": 10
		},
		"84": {
			"name": "Катар",
			"mask": "+974",
			"length": 8
		},
		"85": {
			"name": "Кения",
			"mask": "+254",
			"length": 9
		},
		"86": {
			"name": "Кирибати",
			"mask": "+686",
			"length": 5
		},
		"87": {
			"name": "Китайская Республика",
			"mask": "+886",
			"length": 9
		},
		"88": {
			"name": "Korea, Democratic People's Republic of",
			"mask": "+850",
			"length": 10
		},
		"89": {
			"name": "Кокосовые острова",
			"mask": "+61",
			"length": 9
		},
		"90": {
			"name": "Колумбия",
			"mask": "+57",
			"length": 10
		},
		"91": {
			"name": "Коморы",
			"mask": "+269",
			"length": 7
		},
		"92": {
			"name": "Коста-Рика",
			"mask": "+506",
			"length": 8
		},
		"93": {
			"name": "Кот-д’Ивуар",
			"mask": "+255",
			"length": 8
		},
		"94": {
			"name": "Куба",
			"mask": "+53",
			"length": 8
		},
		"95": {
			"name": "Кувейт",
			"mask": "+965",
			"length": 7
		},
		"96": {
			"name": "Кыргызстан",
			"mask": "+996",
			"length": 9
		},
		"97": {
			"name": "Лаос",
			"mask": "+856",
			"length": 10
		},
		"98": {
			"name": "Лесото",
			"mask": "+266",
			"length": 8
		},
		"99": {
			"name": "Либерия",
			"mask": "+231",
			"length": 7
		},
		"100": {
			"name": "Ливан",
			"mask": "+961",
			"length": 8
		},
		"101": {
			"name": "Ливия",
			"mask": "+218",
			"length": 9
		},
		"102": {
			"name": "Литва",
			"mask": "+218",
			"length": 9
		},
		"103": {
			"name": "Люксембург",
			"mask": "+352",
			"length": 9
		},
		"104": {
			"name": "Маврикий",
			"mask": "+230",
			"length": 7
		},
		"105": {
			"name": "Мавритания",
			"mask": "+222",
			"length": 8
		},
		"106": {
			"name": "Мадагаскар",
			"mask": "+261",
			"length": 9
		},
		"107": {
			"name": "Майотта",
			"mask": "+262",
			"length": 9
		},
		"108": {
			"name": "Малави",
			"mask": "+265",
			"length": 9
		},
		"109": {
			"name": "Малайзия",
			"mask": "+60",
			"length": 9
		},
		"110": {
			"name": "Мали",
			"mask": "+223",
			"length": 8
		},
		"111": {
			"name": "Мальдивы",
			"mask": "+960",
			"length": 7
		},
		"112": {
			"name": "Мальта",
			"mask": "+356",
			"length": 8
		},
		"113": {
			"name": "Марокко",
			"mask": "+212",
			"length": 9
		},
		"114": {
			"name": "Маршалловы Острова",
			"mask": "+692",
			"length": 7
		},
		"115": {
			"name": "Мексика",
			"mask": "+52",
			"length": 11
		},
		"116": {
			"name": "Микронезия",
			"mask": "+691",
			"length": 7
		},
		"117": {
			"name": "Мозамбик",
			"mask": "+258",
			"length": 9
		},
		"118": {
			"name": "Молдавия",
			"mask": "+373",
			"length": 8
		},
		"119": {
			"name": "Монако",
			"mask": "+377",
			"length": 9
		},
		"120": {
			"name": "Монголия",
			"mask": "+976",
			"length": 8
		},
		"121": {
			"name": "Монтсеррат",
			"mask": "+1",
			"length": 10
		},
		"122": {
			"name": "Мьянма",
			"mask": "+95",
			"length": 8
		},
		"123": {
			"name": "Намибия",
			"mask": "+264",
			"length": 9
		},
		"124": {
			"name": "Науру",
			"mask": "+674",
			"length": 7
		},
		"125": {
			"name": "Непал",
			"mask": "+977",
			"length": 10
		},
		"126": {
			"name": "Нигер",
			"mask": "+227",
			"length": 8
		},
		"127": {
			"name": "Нигерия",
			"mask": "+234",
			"length": 10
		},
		"129": {
			"name": "Нидерланды",
			"mask": "+31",
			"length": 9
		},
		"130": {
			"name": "Никарагуа",
			"mask": "+505",
			"length": 8
		},
		"131": {
			"name": "Ниуэ",
			"mask": "+683",
			"length": 4
		},
		"132": {
			"name": "Новая Зеландия",
			"mask": "+64",
			"length": 9
		},
		"133": {
			"name": "Новая Каледония",
			"mask": "+687",
			"length": 6
		},
		"134": {
			"name": "Норвегия",
			"mask": "+47",
			"length": 8
		},
		"135": {
			"name": "ОАЭ",
			"mask": "+971",
			"length": 9
		},
		"136": {
			"name": "Оман",
			"mask": "+968",
			"length": 8
		},
		"138": {
			"name": "Остров Норфолк",
			"mask": "+672",
			"length": 6
		},
		"139": {
			"name": "Остров Рождества",
			"mask": "+61",
			"length": 9
		},
		"141": {
			"name": "Острова Кука",
			"mask": "+682",
			"length": 5
		},
		"143": {
			"name": "Пакистан",
			"mask": "+92",
			"length": 10
		},
		"144": {
			"name": "Палау",
			"mask": "+680",
			"length": 7
		},
		"145": {
			"name": "Папуа - Новая Гвинея",
			"mask": "+675",
			"length": 7
		},
		"146": {
			"name": "Парагвай",
			"mask": "+595",
			"length": 9
		},
		"147": {
			"name": "Перу",
			"mask": "+51",
			"length": 9
		},
		"148": {
			"name": "Польша",
			"mask": "+48",
			"length": 9
		},
		"149": {
			"name": "Португалия",
			"mask": "+351",
			"length": 9
		},
		"150": {
			"name": "Пуэрто-Рико",
			"mask": "+1",
			"length": 10
		},
		"151": {
			"name": "Республика Конго",
			"mask": "+243",
			"length": 9
		},
		"152": {
			"name": "КНДР",
			"mask": "+82",
			"length": 10
		},
		"153": {
			"name": "Республика Македония",
			"mask": "+389",
			"length": 8
		},
		"154": {
			"name": "Россия",
			"mask": "+7",
			"length": 10
		},
		"155": {
			"name": "Руанда",
			"mask": "+250",
			"length": 9
		},
		"156": {
			"name": "Румыния",
			"mask": "+40",
			"length": 9
		},
		"157": {
			"name": "Сальвадор",
			"mask": "+503",
			"length": 8
		},
		"158": {
			"name": "Самоа",
			"mask": "+685",
			"length": 6
		},
		"159": {
			"name": "Сан-Марино",
			"mask": "+378",
			"length": 8
		},
		"160": {
			"name": "Сан-Томе и Принсипи",
			"mask": "+239",
			"length": 7
		},
		"161": {
			"name": "Саудовская Аравия",
			"mask": "+966",
			"length": 9
		},
		"162": {
			"name": "Свазиленд",
			"mask": "+268",
			"length": 8
		},
		"163": {
			"name": "Северные Марианские острова",
			"mask": "+1",
			"length": 10
		},
		"164": {
			"name": "Сейшельские Острова",
			"mask": "+248",
			"length": 7
		},
		"165": {
			"name": "Сен-Пьер и Микелон",
			"mask": "+508",
			"length": 6
		},
		"166": {
			"name": "Сенегал",
			"mask": "+221",
			"length": 9
		},
		"167": {
			"name": "Сент-Винсент и Гренадины",
			"mask": "+1",
			"length": 10
		},
		"168": {
			"name": "Сент-Китс и Невис",
			"mask": "+1",
			"length": 10
		},
		"169": {
			"name": "Сент-Люсия",
			"mask": "+1",
			"length": 10
		},
		"170": {
			"name": "Сербия",
			"mask": "+381",
			"length": 9
		},
		"171": {
			"name": "Сингапур",
			"mask": "+65",
			"length": 8
		},
		"172": {
			"name": "Сирия",
			"mask": "+963",
			"length": 9
		},
		"173": {
			"name": "Словакия",
			"mask": "+421",
			"length": 9
		},
		"174": {
			"name": "Словения",
			"mask": "+386",
			"length": 8
		},
		"175": {
			"name": "Соломоновы Острова",
			"mask": "+677",
			"length": 7
		},
		"176": {
			"name": "Сомали",
			"mask": "+252",
			"length": 8
		},
		"177": {
			"name": "Судан",
			"mask": "+249",
			"length": 9
		},
		"178": {
			"name": "Суринам",
			"mask": "+597",
			"length": 7
		},
		"179": {
			"name": "Сьерра-Леоне",
			"mask": "+232",
			"length": 8
		},
		"180": {
			"name": "Таджикистан",
			"mask": "+992",
			"length": 9
		},
		"181": {
			"name": "Таиланд",
			"mask": "+66",
			"length": 9
		},
		"182": {
			"name": "Танзания",
			"mask": "+255",
			"length": 9
		},
		"183": {
			"name": "Тёркс и Кайкос",
			"mask": "+1",
			"length": 10
		},
		"184": {
			"name": "Того",
			"mask": "+228",
			"length": 8
		},
		"185": {
			"name": "Токелау",
			"mask": "+676",
			"length": 7
		},
		"186": {
			"name": "Тонга",
			"mask": "+676",
			"length": 7
		},
		"187": {
			"name": "Тринидад и Тобаго",
			"mask": "+1",
			"length": 10
		},
		"188": {
			"name": "Тувалу",
			"mask": "+688",
			"length": 6
		},
		"189": {
			"name": "Тунис",
			"mask": "+216",
			"length": 8
		},
		"190": {
			"name": "Туркмения",
			"mask": "+993",
			"length": 8
		},
		"191": {
			"name": "Уганда",
			"mask": "+256",
			"length": 9
		},
		"192": {
			"name": "Узбекистан",
			"mask": "+998",
			"length": 9
		},
		"193": {
			"name": "Украина",
			"mask": "+380",
			"length": 9
		},
		"194": {
			"name": "Уоллис и Футуна",
			"mask": "+681",
			"length": 6
		},
		"195": {
			"name": "Уругвай",
			"mask": "+598",
			"length": 8
		},
		"196": {
			"name": "Фарерские острова",
			"mask": "+298",
			"length": 6
		},
		"197": {
			"name": "Фиджи",
			"mask": "+679",
			"length": 7
		},
		"198": {
			"name": "Филиппины",
			"mask": "+63",
			"length": 10
		},
		"199": {
			"name": "Финляндия",
			"mask": "+358",
			"length": 9
		},
		"200": {
			"name": "Фолклендские острова",
			"mask": "+500",
			"length": 5
		},
		"201": {
			"name": "Французская Полинезия",
			"mask": "+689",
			"length": 9
		},
		"203": {
			"name": "ЦАР",
			"mask": "+236",
			"length": 8
		},
		"204": {
			"name": "Чад",
			"mask": "+235",
			"length": 8
		},
		"205": {
			"name": "Черногория",
			"mask": "+382",
			"length": 8
		},
		"206": {
			"name": "Чехия",
			"mask": "+420",
			"length": 9
		},
		"207": {
			"name": "Чили",
			"mask": "+56",
			"length": 9
		},
		"208": {
			"name": "Швеция",
			"mask": "+46",
			"length": 9
		},
		"209": {
			"name": "Шпицберген и Ян-Майен",
			"mask": "+47",
			"length": 8
		},
		"210": {
			"name": "Шри-Ланка",
			"mask": "+94",
			"length": 9
		},
		"211": {
			"name": "Эквадор",
			"mask": "+593",
			"length": 9
		},
		"212": {
			"name": "Экваториальная Гвинея",
			"mask": "+240",
			"length": 9
		},
		"213": {
			"name": "Эритрея",
			"mask": "+291",
			"length": 7
		},
		"214": {
			"name": "Эстония",
			"mask": "+372",
			"length": 8
		},
		"216": {
			"name": "ЮАР",
			"mask": "+27",
			"length": 9
		},
		"218": {
			"name": "Ямайка",
			"mask": "+1",
			"length": 10
		},
		"219": {
			"name": "Япония",
			"mask": "+81",
			"length": 10
		}
	};

/***/ },
/* 651 */
/***/ function(module, exports) {

	module.exports = {
		"2": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						73
					],
					"Total": [
						318
					]
				},
				"priority": 0,
				"parent": null
			},
			"1": {
				"headers": {
					"Result": [
						673,
						366
					],
					"Double": [
						657
					],
					"Handicap": [
						21
					],
					"Total": [
						195
					]
				},
				"priority": 0,
				"parent": null
			},
			"2": {
				"headers": {
					"Result": [
						674,
						367
					],
					"Double": [
						658
					],
					"Handicap": [
						22
					],
					"Total": [
						196
					]
				},
				"priority": 0,
				"parent": null
			},
			"3": {
				"headers": {
					"Result": [
						675,
						368
					],
					"Double": [],
					"Handicap": [
						23
					],
					"Total": [
						197
					]
				},
				"priority": 0,
				"parent": null
			},
			"4": {
				"headers": {
					"Result": [
						676,
						369
					],
					"Double": [],
					"Handicap": [
						24
					],
					"Total": [
						198
					]
				},
				"priority": 0,
				"parent": null
			},
			"5": {
				"headers": {
					"Result": [
						677,
						370
					],
					"Double": [],
					"Handicap": [
						25
					],
					"Total": [
						199
					]
				},
				"priority": 0,
				"parent": null
			},
			"6": {
				"headers": {
					"Result": [
						678,
						371
					],
					"Double": [],
					"Handicap": [
						26
					],
					"Total": [
						200
					]
				},
				"priority": 0,
				"parent": null
			},
			"7": {
				"headers": {
					"Result": [
						679,
						372
					],
					"Double": [],
					"Handicap": [
						27
					],
					"Total": [
						201
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"3": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						73
					],
					"Total": [
						318
					]
				},
				"priority": 0,
				"parent": null
			},
			"1": {
				"headers": {
					"Result": [
						673,
						366
					],
					"Double": [
						657
					],
					"Handicap": [
						21
					],
					"Total": [
						195
					]
				},
				"priority": 0,
				"parent": null
			},
			"2": {
				"headers": {
					"Result": [
						674,
						367
					],
					"Double": [
						658
					],
					"Handicap": [
						22
					],
					"Total": [
						196
					]
				},
				"priority": 0,
				"parent": null
			},
			"3": {
				"headers": {
					"Result": [
						675,
						368
					],
					"Double": [],
					"Handicap": [
						23
					],
					"Total": [
						197
					]
				},
				"priority": 0,
				"parent": null
			},
			"4": {
				"headers": {
					"Result": [
						362
					],
					"Double": [],
					"Handicap": [
						17
					],
					"Total": [
						176
					]
				},
				"priority": 0,
				"parent": null
			},
			"5": {
				"headers": {
					"Result": [
						358
					],
					"Double": [],
					"Handicap": [
						13
					],
					"Total": [
						172
					]
				},
				"priority": 0,
				"parent": null
			},
			"6": {
				"headers": {
					"Result": [
						363
					],
					"Double": [],
					"Handicap": [
						18
					],
					"Total": [
						177
					]
				},
				"priority": 0,
				"parent": null
			},
			"7": {
				"headers": {
					"Result": [
						359
					],
					"Double": [],
					"Handicap": [
						14
					],
					"Total": [
						173
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"4": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						73
					],
					"Total": [
						318
					]
				},
				"priority": 0,
				"parent": null
			},
			"1": {
				"headers": {
					"Result": [
						673,
						366
					],
					"Double": [
						657
					],
					"Handicap": [
						21
					],
					"Total": [
						195
					]
				},
				"priority": 0,
				"parent": null
			},
			"2": {
				"headers": {
					"Result": [
						674,
						367
					],
					"Double": [
						658
					],
					"Handicap": [
						22
					],
					"Total": [
						196
					]
				},
				"priority": 0,
				"parent": null
			},
			"3": {
				"headers": {
					"Result": [
						675,
						368
					],
					"Double": [],
					"Handicap": [
						23
					],
					"Total": [
						197
					]
				},
				"priority": 0,
				"parent": null
			},
			"4": {
				"headers": {
					"Result": [
						676,
						369
					],
					"Double": [],
					"Handicap": [
						24
					],
					"Total": [
						198
					]
				},
				"priority": 0,
				"parent": null
			},
			"5": {
				"headers": {
					"Result": [
						677,
						370
					],
					"Double": [],
					"Handicap": [
						25
					],
					"Total": [
						199
					]
				},
				"priority": 0,
				"parent": null
			},
			"6": {
				"headers": {
					"Result": [
						678,
						371
					],
					"Double": [],
					"Handicap": [
						26
					],
					"Total": [
						200
					]
				},
				"priority": 0,
				"parent": null
			},
			"7": {
				"headers": {
					"Result": [
						362
					],
					"Double": [],
					"Handicap": [
						17
					],
					"Total": [
						176
					]
				},
				"priority": 0,
				"parent": null
			},
			"8": {
				"headers": {
					"Result": [
						358
					],
					"Double": [],
					"Handicap": [
						13
					],
					"Total": [
						172
					]
				},
				"priority": 0,
				"parent": null
			},
			"9": {
				"headers": {
					"Result": [
						363
					],
					"Double": [],
					"Handicap": [
						18
					],
					"Total": [
						177
					]
				},
				"priority": 0,
				"parent": null
			},
			"10": {
				"headers": {
					"Result": [
						359
					],
					"Double": [],
					"Handicap": [
						14
					],
					"Total": [
						173
					]
				},
				"priority": 0,
				"parent": null
			},
			"11": {
				"headers": {
					"Result": [
						364
					],
					"Double": [],
					"Handicap": [
						19
					],
					"Total": [
						178
					]
				},
				"priority": 0,
				"parent": null
			},
			"12": {
				"headers": {
					"Result": [
						360
					],
					"Double": [],
					"Handicap": [
						15
					],
					"Total": [
						174
					]
				},
				"priority": 0,
				"parent": null
			},
			"13": {
				"headers": {
					"Result": [
						365
					],
					"Double": [],
					"Handicap": [
						20
					],
					"Total": [
						179
					]
				},
				"priority": 0,
				"parent": null
			},
			"14": {
				"headers": {
					"Result": [
						361
					],
					"Double": [],
					"Handicap": [
						16
					],
					"Total": [
						175
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"5": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"6": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						73
					],
					"Total": [
						318
					]
				},
				"priority": 0,
				"parent": null
			},
			"1": {
				"headers": {
					"Result": [
						673,
						366
					],
					"Double": [
						657
					],
					"Handicap": [
						21
					],
					"Total": [
						195
					]
				},
				"priority": 0,
				"parent": null
			},
			"2": {
				"headers": {
					"Result": [
						674,
						367
					],
					"Double": [
						658
					],
					"Handicap": [
						22
					],
					"Total": [
						196
					]
				},
				"priority": 0,
				"parent": null
			},
			"3": {
				"headers": {
					"Result": [
						675,
						368
					],
					"Double": [],
					"Handicap": [
						23
					],
					"Total": [
						197
					]
				},
				"priority": 0,
				"parent": null
			},
			"4": {
				"headers": {
					"Result": [
						676,
						369
					],
					"Double": [],
					"Handicap": [
						24
					],
					"Total": [
						198
					]
				},
				"priority": 0,
				"parent": null
			},
			"5": {
				"headers": {
					"Result": [
						677,
						370
					],
					"Double": [],
					"Handicap": [
						25
					],
					"Total": [
						199
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"7": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 1,
				"parent": null
			},
			"1": {
				"headers": {
					"Result": [
						673,
						366
					],
					"Double": [
						657
					],
					"Handicap": [
						21
					],
					"Total": [
						195
					]
				},
				"priority": 2,
				"parent": null
			},
			"2": {
				"headers": {
					"Result": [
						674,
						367
					],
					"Double": [
						658
					],
					"Handicap": [
						22
					],
					"Total": [
						196
					]
				},
				"priority": 3,
				"parent": null
			},
			"3": {
				"headers": {
					"Result": [
						661
					],
					"Double": [
						650
					],
					"Handicap": [
						2
					],
					"Total": [
						160
					]
				},
				"priority": 8,
				"parent": null
			},
			"4": {
				"headers": {
					"Result": [
						664
					],
					"Double": [
						651
					],
					"Handicap": [
						5
					],
					"Total": [
						163
					]
				},
				"priority": 9,
				"parent": null
			},
			"5": {
				"headers": {
					"Result": [
						666
					],
					"Double": [
						652
					],
					"Handicap": [
						7
					],
					"Total": [
						165
					]
				},
				"priority": 10,
				"parent": null
			},
			"6": {
				"headers": {
					"Result": [
						667
					],
					"Double": [
						653
					],
					"Handicap": [
						939
					],
					"Total": [
						166
					]
				},
				"priority": 13,
				"parent": null
			},
			"7": {
				"headers": {
					"Result": [
						669
					],
					"Double": [
						654
					],
					"Handicap": [
						9
					],
					"Total": [
						168
					]
				},
				"priority": 14,
				"parent": null
			},
			"8": {
				"headers": {
					"Result": [
						672
					],
					"Double": [
						655
					],
					"Handicap": [
						12
					],
					"Total": [
						171
					]
				},
				"priority": 15,
				"parent": null
			},
			"9": {
				"headers": {
					"Result": [
						689
					],
					"Double": [],
					"Handicap": [
						66
					],
					"Total": [
						255
					]
				},
				"priority": 4,
				"parent": null
			},
			"10": {
				"headers": {
					"Result": [
						690
					],
					"Double": [],
					"Handicap": [
						67
					],
					"Total": [
						258
					]
				},
				"priority": 11,
				"parent": 9
			},
			"11": {
				"headers": {
					"Result": [
						699
					],
					"Double": [],
					"Handicap": [
						81
					],
					"Total": [
						353
					]
				},
				"priority": 5,
				"parent": null
			},
			"12": {
				"headers": {
					"Result": [
						691
					],
					"Double": [],
					"Handicap": [
						68
					],
					"Total": [
						259
					]
				},
				"priority": 12,
				"parent": 11
			},
			"13": {
				"headers": {
					"Result": [
						692
					],
					"Double": [
						659
					],
					"Handicap": [
						69
					],
					"Total": [
						262
					]
				},
				"priority": 6,
				"parent": null
			},
			"14": {
				"headers": {
					"Result": [
						693
					],
					"Double": [],
					"Handicap": [
						70
					],
					"Total": [
						263
					]
				},
				"priority": 16,
				"parent": 13
			},
			"15": {
				"headers": {
					"Result": [
						695
					],
					"Double": [],
					"Handicap": [
						72
					],
					"Total": [
						277
					]
				},
				"priority": 17,
				"parent": 13
			},
			"16": {
				"headers": {
					"Result": [],
					"Double": [],
					"Handicap": [],
					"Total": []
				},
				"priority": 7,
				"parent": null
			}
		},
		"8": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			},
			"1": {
				"headers": {
					"Result": [
						673,
						366
					],
					"Double": [
						657
					],
					"Handicap": [
						21
					],
					"Total": [
						195
					]
				},
				"priority": 0,
				"parent": null
			},
			"2": {
				"headers": {
					"Result": [
						674,
						367
					],
					"Double": [
						658
					],
					"Handicap": [
						22
					],
					"Total": [
						196
					]
				},
				"priority": 0,
				"parent": null
			},
			"3": {
				"headers": {
					"Result": [
						675,
						368
					],
					"Double": [],
					"Handicap": [
						23
					],
					"Total": [
						197
					]
				},
				"priority": 0,
				"parent": null
			},
			"4": {
				"headers": {
					"Result": [
						676,
						369
					],
					"Double": [],
					"Handicap": [
						24
					],
					"Total": [
						198
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"9": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			},
			"1": {
				"headers": {
					"Result": [
						673,
						366
					],
					"Double": [
						657
					],
					"Handicap": [
						21
					],
					"Total": [
						195
					]
				},
				"priority": 0,
				"parent": null
			},
			"2": {
				"headers": {
					"Result": [
						674,
						367
					],
					"Double": [
						658
					],
					"Handicap": [
						22
					],
					"Total": [
						196
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"10": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"11": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"12": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"13": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"14": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"15": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"16": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"17": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"18": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			},
			"1": {
				"headers": {
					"Result": [
						673,
						366
					],
					"Double": [
						657
					],
					"Handicap": [
						21
					],
					"Total": [
						195
					]
				},
				"priority": 0,
				"parent": null
			},
			"2": {
				"headers": {
					"Result": [
						674,
						367
					],
					"Double": [
						658
					],
					"Handicap": [
						22
					],
					"Total": [
						196
					]
				},
				"priority": 0,
				"parent": null
			},
			"3": {
				"headers": {
					"Result": [
						675,
						368
					],
					"Double": [],
					"Handicap": [
						23
					],
					"Total": [
						197
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"19": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			},
			"1": {
				"headers": {
					"Result": [
						673,
						366
					],
					"Double": [
						657
					],
					"Handicap": [
						21
					],
					"Total": [
						195
					]
				},
				"priority": 0,
				"parent": null
			},
			"2": {
				"headers": {
					"Result": [
						674,
						367
					],
					"Double": [
						658
					],
					"Handicap": [
						22
					],
					"Total": [
						196
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"20": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			},
			"1": {
				"headers": {
					"Result": [
						673,
						366
					],
					"Double": [
						657
					],
					"Handicap": [
						21
					],
					"Total": [
						195
					]
				},
				"priority": 0,
				"parent": null
			},
			"2": {
				"headers": {
					"Result": [
						674,
						367
					],
					"Double": [
						658
					],
					"Handicap": [
						22
					],
					"Total": [
						196
					]
				},
				"priority": 0,
				"parent": null
			},
			"3": {
				"headers": {
					"Result": [
						675,
						368
					],
					"Double": [],
					"Handicap": [
						23
					],
					"Total": [
						197
					]
				},
				"priority": 0,
				"parent": null
			},
			"4": {
				"headers": {
					"Result": [
						676,
						369
					],
					"Double": [],
					"Handicap": [
						24
					],
					"Total": [
						198
					]
				},
				"priority": 0,
				"parent": null
			},
			"5": {
				"headers": {
					"Result": [
						677,
						370
					],
					"Double": [],
					"Handicap": [
						25
					],
					"Total": [
						199
					]
				},
				"priority": 0,
				"parent": null
			},
			"6": {
				"headers": {
					"Result": [
						678,
						371
					],
					"Double": [],
					"Handicap": [
						26
					],
					"Total": [
						200
					]
				},
				"priority": 0,
				"parent": null
			},
			"7": {
				"headers": {
					"Result": [
						679,
						372
					],
					"Double": [],
					"Handicap": [
						27
					],
					"Total": [
						201
					]
				},
				"priority": 0,
				"parent": null
			},
			"8": {
				"headers": {
					"Result": [
						680,
						373
					],
					"Double": [],
					"Handicap": [
						28
					],
					"Total": [
						202
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"21": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"23": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"24": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"25": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"26": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"27": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"28": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"29": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			},
			"1": {
				"headers": {
					"Result": [
						673,
						366
					],
					"Double": [
						657
					],
					"Handicap": [
						21
					],
					"Total": [
						195
					]
				},
				"priority": 0,
				"parent": null
			},
			"2": {
				"headers": {
					"Result": [
						674,
						367
					],
					"Double": [
						658
					],
					"Handicap": [
						22
					],
					"Total": [
						196
					]
				},
				"priority": 0,
				"parent": null
			},
			"3": {
				"headers": {
					"Result": [
						675,
						368
					],
					"Double": [],
					"Handicap": [
						23
					],
					"Total": [
						197
					]
				},
				"priority": 0,
				"parent": null
			},
			"4": {
				"headers": {
					"Result": [
						676,
						369
					],
					"Double": [],
					"Handicap": [
						24
					],
					"Total": [
						198
					]
				},
				"priority": 0,
				"parent": null
			},
			"5": {
				"headers": {
					"Result": [
						677,
						370
					],
					"Double": [],
					"Handicap": [
						25
					],
					"Total": [
						199
					]
				},
				"priority": 0,
				"parent": null
			},
			"6": {
				"headers": {
					"Result": [
						678,
						371
					],
					"Double": [],
					"Handicap": [
						26
					],
					"Total": [
						200
					]
				},
				"priority": 0,
				"parent": null
			},
			"7": {
				"headers": {
					"Result": [
						679,
						372
					],
					"Double": [],
					"Handicap": [
						27
					],
					"Total": [
						201
					]
				},
				"priority": 0,
				"parent": null
			},
			"8": {
				"headers": {
					"Result": [
						680,
						373
					],
					"Double": [],
					"Handicap": [
						28
					],
					"Total": [
						202
					]
				},
				"priority": 0,
				"parent": null
			},
			"9": {
				"headers": {
					"Result": [
						374
					],
					"Double": [],
					"Handicap": [
						29
					],
					"Total": [
						203
					]
				},
				"priority": 0,
				"parent": null
			},
			"10": {
				"headers": {
					"Result": [
						375
					],
					"Double": [],
					"Handicap": [
						30
					],
					"Total": [
						204
					]
				},
				"priority": 0,
				"parent": null
			},
			"11": {
				"headers": {
					"Result": [
						376
					],
					"Double": [],
					"Handicap": [
						31
					],
					"Total": [
						205
					]
				},
				"priority": 0,
				"parent": null
			},
			"12": {
				"headers": {
					"Result": [
						377
					],
					"Double": [],
					"Handicap": [
						32
					],
					"Total": [
						206
					]
				},
				"priority": 0,
				"parent": null
			},
			"13": {
				"headers": {
					"Result": [
						378
					],
					"Double": [],
					"Handicap": [
						33
					],
					"Total": [
						207
					]
				},
				"priority": 0,
				"parent": null
			},
			"14": {
				"headers": {
					"Result": [
						379
					],
					"Double": [],
					"Handicap": [
						34
					],
					"Total": [
						208
					]
				},
				"priority": 0,
				"parent": null
			},
			"15": {
				"headers": {
					"Result": [
						380
					],
					"Double": [],
					"Handicap": [
						35
					],
					"Total": [
						209
					]
				},
				"priority": 0,
				"parent": null
			},
			"16": {
				"headers": {
					"Result": [
						381
					],
					"Double": [],
					"Handicap": [
						36
					],
					"Total": [
						210
					]
				},
				"priority": 0,
				"parent": null
			},
			"17": {
				"headers": {
					"Result": [
						382
					],
					"Double": [],
					"Handicap": [
						37
					],
					"Total": [
						211
					]
				},
				"priority": 0,
				"parent": null
			},
			"18": {
				"headers": {
					"Result": [
						383
					],
					"Double": [],
					"Handicap": [
						38
					],
					"Total": [
						212
					]
				},
				"priority": 0,
				"parent": null
			},
			"19": {
				"headers": {
					"Result": [
						384
					],
					"Double": [],
					"Handicap": [
						39
					],
					"Total": [
						213
					]
				},
				"priority": 0,
				"parent": null
			},
			"20": {
				"headers": {
					"Result": [
						385
					],
					"Double": [],
					"Handicap": [
						40
					],
					"Total": [
						214
					]
				},
				"priority": 0,
				"parent": null
			},
			"21": {
				"headers": {
					"Result": [
						386
					],
					"Double": [],
					"Handicap": [
						41
					],
					"Total": [
						215
					]
				},
				"priority": 0,
				"parent": null
			},
			"22": {
				"headers": {
					"Result": [
						387
					],
					"Double": [],
					"Handicap": [
						42
					],
					"Total": [
						216
					]
				},
				"priority": 0,
				"parent": null
			},
			"23": {
				"headers": {
					"Result": [
						388
					],
					"Double": [],
					"Handicap": [
						43
					],
					"Total": [
						217
					]
				},
				"priority": 0,
				"parent": null
			},
			"24": {
				"headers": {
					"Result": [
						389
					],
					"Double": [],
					"Handicap": [
						44
					],
					"Total": [
						218
					]
				},
				"priority": 0,
				"parent": null
			},
			"25": {
				"headers": {
					"Result": [
						390
					],
					"Double": [],
					"Handicap": [
						45
					],
					"Total": [
						219
					]
				},
				"priority": 0,
				"parent": null
			},
			"26": {
				"headers": {
					"Result": [
						391
					],
					"Double": [],
					"Handicap": [
						46
					],
					"Total": [
						220
					]
				},
				"priority": 0,
				"parent": null
			},
			"27": {
				"headers": {
					"Result": [
						392
					],
					"Double": [],
					"Handicap": [
						47
					],
					"Total": [
						221
					]
				},
				"priority": 0,
				"parent": null
			},
			"28": {
				"headers": {
					"Result": [
						393
					],
					"Double": [],
					"Handicap": [
						48
					],
					"Total": [
						222
					]
				},
				"priority": 0,
				"parent": null
			},
			"29": {
				"headers": {
					"Result": [
						394
					],
					"Double": [],
					"Handicap": [
						49
					],
					"Total": [
						223
					]
				},
				"priority": 0,
				"parent": null
			},
			"30": {
				"headers": {
					"Result": [
						395
					],
					"Double": [],
					"Handicap": [
						50
					],
					"Total": [
						224
					]
				},
				"priority": 0,
				"parent": null
			},
			"31": {
				"headers": {
					"Result": [
						396
					],
					"Double": [],
					"Handicap": [
						51
					],
					"Total": [
						225
					]
				},
				"priority": 0,
				"parent": null
			},
			"32": {
				"headers": {
					"Result": [
						397
					],
					"Double": [],
					"Handicap": [
						52
					],
					"Total": [
						226
					]
				},
				"priority": 0,
				"parent": null
			},
			"33": {
				"headers": {
					"Result": [
						398
					],
					"Double": [],
					"Handicap": [
						53
					],
					"Total": [
						227
					]
				},
				"priority": 0,
				"parent": null
			},
			"34": {
				"headers": {
					"Result": [
						399
					],
					"Double": [],
					"Handicap": [
						54
					],
					"Total": [
						228
					]
				},
				"priority": 0,
				"parent": null
			},
			"35": {
				"headers": {
					"Result": [
						400
					],
					"Double": [],
					"Handicap": [
						55
					],
					"Total": [
						229
					]
				},
				"priority": 0,
				"parent": null
			},
			"36": {
				"headers": {
					"Result": [
						401
					],
					"Double": [],
					"Handicap": [
						56
					],
					"Total": [
						230
					]
				},
				"priority": 0,
				"parent": null
			},
			"37": {
				"headers": {
					"Result": [
						402
					],
					"Double": [],
					"Handicap": [
						57
					],
					"Total": [
						231
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"30": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			},
			"1": {
				"headers": {
					"Result": [
						673,
						366
					],
					"Double": [
						657
					],
					"Handicap": [
						21
					],
					"Total": [
						195
					]
				},
				"priority": 0,
				"parent": null
			},
			"2": {
				"headers": {
					"Result": [
						674,
						367
					],
					"Double": [
						658
					],
					"Handicap": [
						22
					],
					"Total": [
						196
					]
				},
				"priority": 0,
				"parent": null
			},
			"3": {
				"headers": {
					"Result": [
						675,
						368
					],
					"Double": [],
					"Handicap": [
						23
					],
					"Total": [
						197
					]
				},
				"priority": 0,
				"parent": null
			},
			"4": {
				"headers": {
					"Result": [
						662
					],
					"Double": [],
					"Handicap": [
						3
					],
					"Total": [
						161
					]
				},
				"priority": 0,
				"parent": null
			},
			"5": {
				"headers": {
					"Result": [
						663
					],
					"Double": [],
					"Handicap": [
						4
					],
					"Total": [
						162
					]
				},
				"priority": 0,
				"parent": null
			},
			"6": {
				"headers": {
					"Result": [
						665
					],
					"Double": [],
					"Handicap": [
						6
					],
					"Total": [
						164
					]
				},
				"priority": 0,
				"parent": null
			},
			"7": {
				"headers": {
					"Result": [
						668
					],
					"Double": [],
					"Handicap": [
						8
					],
					"Total": [
						167
					]
				},
				"priority": 0,
				"parent": null
			},
			"8": {
				"headers": {
					"Result": [
						670
					],
					"Double": [],
					"Handicap": [
						10
					],
					"Total": [
						169
					]
				},
				"priority": 0,
				"parent": null
			},
			"9": {
				"headers": {
					"Result": [
						671
					],
					"Double": [],
					"Handicap": [
						11
					],
					"Total": [
						170
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"31": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			},
			"1": {
				"headers": {
					"Result": [
						673,
						366
					],
					"Double": [
						657
					],
					"Handicap": [
						21
					],
					"Total": [
						195
					]
				},
				"priority": 0,
				"parent": null
			},
			"2": {
				"headers": {
					"Result": [
						674,
						367
					],
					"Double": [
						658
					],
					"Handicap": [
						22
					],
					"Total": [
						196
					]
				},
				"priority": 0,
				"parent": null
			},
			"3": {
				"headers": {
					"Result": [
						675,
						368
					],
					"Double": [],
					"Handicap": [
						23
					],
					"Total": [
						197
					]
				},
				"priority": 0,
				"parent": null
			},
			"4": {
				"headers": {
					"Result": [
						676,
						369
					],
					"Double": [],
					"Handicap": [
						24
					],
					"Total": [
						198
					]
				},
				"priority": 0,
				"parent": null
			},
			"5": {
				"headers": {
					"Result": [
						685
					],
					"Double": [],
					"Handicap": [
						62
					],
					"Total": [
						248
					]
				},
				"priority": 0,
				"parent": null
			},
			"6": {
				"headers": {
					"Result": [
						684
					],
					"Double": [],
					"Handicap": [
						61
					],
					"Total": [
						246
					]
				},
				"priority": 0,
				"parent": null
			},
			"7": {
				"headers": {
					"Result": [
						681
					],
					"Double": [],
					"Handicap": [
						58
					],
					"Total": [
						238
					]
				},
				"priority": 0,
				"parent": null
			},
			"8": {
				"headers": {
					"Result": [
						682
					],
					"Double": [],
					"Handicap": [
						59
					],
					"Total": [
						239
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"32": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						73
					],
					"Total": [
						318
					]
				},
				"priority": 0,
				"parent": null
			},
			"1": {
				"headers": {
					"Result": [
						673,
						366
					],
					"Double": [
						657
					],
					"Handicap": [
						21
					],
					"Total": [
						195
					]
				},
				"priority": 0,
				"parent": null
			},
			"2": {
				"headers": {
					"Result": [
						674,
						367
					],
					"Double": [
						658
					],
					"Handicap": [
						22
					],
					"Total": [
						196
					]
				},
				"priority": 0,
				"parent": null
			},
			"3": {
				"headers": {
					"Result": [
						675,
						368
					],
					"Double": [],
					"Handicap": [
						23
					],
					"Total": [
						197
					]
				},
				"priority": 0,
				"parent": null
			},
			"4": {
				"headers": {
					"Result": [
						362
					],
					"Double": [],
					"Handicap": [
						17
					],
					"Total": [
						176
					]
				},
				"priority": 0,
				"parent": null
			},
			"5": {
				"headers": {
					"Result": [
						358
					],
					"Double": [],
					"Handicap": [
						13
					],
					"Total": [
						172
					]
				},
				"priority": 0,
				"parent": null
			},
			"6": {
				"headers": {
					"Result": [
						363
					],
					"Double": [],
					"Handicap": [
						18
					],
					"Total": [
						177
					]
				},
				"priority": 0,
				"parent": null
			},
			"7": {
				"headers": {
					"Result": [
						359
					],
					"Double": [],
					"Handicap": [
						14
					],
					"Total": [
						173
					]
				},
				"priority": 0,
				"parent": null
			},
			"8": {
				"headers": {
					"Result": [
						364
					],
					"Double": [],
					"Handicap": [
						19
					],
					"Total": [
						178
					]
				},
				"priority": 0,
				"parent": null
			},
			"9": {
				"headers": {
					"Result": [
						360
					],
					"Double": [],
					"Handicap": [
						15
					],
					"Total": [
						174
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"33": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"34": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			},
			"1": {
				"headers": {
					"Result": [
						673,
						366
					],
					"Double": [
						657
					],
					"Handicap": [
						21
					],
					"Total": [
						195
					]
				},
				"priority": 0,
				"parent": null
			},
			"2": {
				"headers": {
					"Result": [
						674,
						367
					],
					"Double": [
						658
					],
					"Handicap": [
						22
					],
					"Total": [
						196
					]
				},
				"priority": 0,
				"parent": null
			},
			"3": {
				"headers": {
					"Result": [
						661
					],
					"Double": [],
					"Handicap": [
						2
					],
					"Total": [
						160
					]
				},
				"priority": 0,
				"parent": null
			},
			"4": {
				"headers": {
					"Result": [
						664
					],
					"Double": [],
					"Handicap": [
						5
					],
					"Total": [
						163
					]
				},
				"priority": 0,
				"parent": null
			},
			"5": {
				"headers": {
					"Result": [
						666
					],
					"Double": [],
					"Handicap": [
						7
					],
					"Total": [
						165
					]
				},
				"priority": 0,
				"parent": null
			},
			"6": {
				"headers": {
					"Result": [
						667
					],
					"Double": [],
					"Handicap": [
						939
					],
					"Total": [
						166
					]
				},
				"priority": 0,
				"parent": null
			},
			"7": {
				"headers": {
					"Result": [
						669
					],
					"Double": [],
					"Handicap": [
						9
					],
					"Total": [
						168
					]
				},
				"priority": 0,
				"parent": null
			},
			"8": {
				"headers": {
					"Result": [
						672
					],
					"Double": [],
					"Handicap": [
						12
					],
					"Total": [
						171
					]
				},
				"priority": 0,
				"parent": null
			},
			"9": {
				"headers": {
					"Result": [],
					"Double": [],
					"Handicap": [],
					"Total": [
						255
					]
				},
				"priority": 0,
				"parent": null
			},
			"10": {
				"headers": {
					"Result": [],
					"Double": [],
					"Handicap": [],
					"Total": [
						353
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"35": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			},
			"1": {
				"headers": {
					"Result": [
						673,
						366
					],
					"Double": [
						657
					],
					"Handicap": [
						21
					],
					"Total": [
						195
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"36": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			},
			"1": {
				"headers": {
					"Result": [
						673,
						366
					],
					"Double": [
						657
					],
					"Handicap": [
						21
					],
					"Total": [
						195
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"37": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"38": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			},
			"1": {
				"headers": {
					"Result": [
						366,
						673
					],
					"Double": [],
					"Handicap": [],
					"Total": []
				},
				"priority": 1,
				"parent": null
			},
			"2": {
				"headers": {
					"Result": [
						367,
						674
					],
					"Double": [],
					"Handicap": [],
					"Total": []
				},
				"priority": 2,
				"parent": null
			},
			"3": {
				"headers": {
					"Result": [
						368,
						675
					],
					"Double": [],
					"Handicap": [],
					"Total": []
				},
				"priority": 3,
				"parent": null
			},
			"4": {
				"headers": {
					"Result": [
						369,
						676
					],
					"Double": [],
					"Handicap": [],
					"Total": []
				},
				"priority": 4,
				"parent": null
			},
			"5": {
				"headers": {
					"Result": [
						370,
						677
					],
					"Double": [],
					"Handicap": [],
					"Total": []
				},
				"priority": 5,
				"parent": null
			}
		},
		"39": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			},
			"1": {
				"headers": {
					"Result": [
						673,
						366
					],
					"Double": [
						657
					],
					"Handicap": [
						21
					],
					"Total": [
						195
					]
				},
				"priority": 0,
				"parent": null
			},
			"2": {
				"headers": {
					"Result": [
						674,
						367
					],
					"Double": [
						658
					],
					"Handicap": [
						22
					],
					"Total": [
						196
					]
				},
				"priority": 0,
				"parent": null
			},
			"3": {
				"headers": {
					"Result": [
						675,
						368
					],
					"Double": [],
					"Handicap": [
						23
					],
					"Total": [
						197
					]
				},
				"priority": 0,
				"parent": null
			},
			"4": {
				"headers": {
					"Result": [
						676,
						369
					],
					"Double": [],
					"Handicap": [
						24
					],
					"Total": [
						198
					]
				},
				"priority": 0,
				"parent": null
			},
			"5": {
				"headers": {
					"Result": [
						685
					],
					"Double": [],
					"Handicap": [
						62
					],
					"Total": [
						248
					]
				},
				"priority": 0,
				"parent": null
			},
			"6": {
				"headers": {
					"Result": [
						684
					],
					"Double": [],
					"Handicap": [
						61
					],
					"Total": [
						246
					]
				},
				"priority": 0,
				"parent": null
			},
			"7": {
				"headers": {
					"Result": [
						681
					],
					"Double": [],
					"Handicap": [
						58
					],
					"Total": [
						238
					]
				},
				"priority": 0,
				"parent": null
			},
			"8": {
				"headers": {
					"Result": [
						682
					],
					"Double": [],
					"Handicap": [
						59
					],
					"Total": [
						239
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"40": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"41": {
			"0": {
				"headers": {
					"Result": [
						698,
						403
					],
					"Double": [
						656
					],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			},
			"1": {
				"headers": {
					"Result": [
						673,
						366
					],
					"Double": [
						657
					],
					"Handicap": [
						21
					],
					"Total": [
						195
					]
				},
				"priority": 0,
				"parent": null
			},
			"2": {
				"headers": {
					"Result": [
						674,
						367
					],
					"Double": [
						658
					],
					"Handicap": [
						22
					],
					"Total": [
						196
					]
				},
				"priority": 0,
				"parent": null
			},
			"3": {
				"headers": {
					"Result": [
						685
					],
					"Double": [],
					"Handicap": [
						62
					],
					"Total": [
						248
					]
				},
				"priority": 0,
				"parent": null
			},
			"4": {
				"headers": {
					"Result": [
						684
					],
					"Double": [],
					"Handicap": [
						61
					],
					"Total": [
						246
					]
				},
				"priority": 0,
				"parent": null
			}
		},
		"42": {
			"0": {
				"headers": {
					"Result": [
						403,
						698
					],
					"Double": [],
					"Handicap": [
						74
					],
					"Total": [
						349
					]
				},
				"priority": 0,
				"parent": null
			},
			"1": {
				"headers": {
					"Result": [
						366,
						673
					],
					"Double": [],
					"Handicap": [],
					"Total": []
				},
				"priority": 1,
				"parent": null
			},
			"2": {
				"headers": {
					"Result": [
						367,
						674
					],
					"Double": [],
					"Handicap": [],
					"Total": []
				},
				"priority": 2,
				"parent": null
			},
			"3": {
				"headers": {
					"Result": [
						368,
						675
					],
					"Double": [],
					"Handicap": [],
					"Total": []
				},
				"priority": 3,
				"parent": null
			},
			"4": {
				"headers": {
					"Result": [
						369,
						676
					],
					"Double": [],
					"Handicap": [],
					"Total": []
				},
				"priority": 4,
				"parent": null
			},
			"5": {
				"headers": {
					"Result": [
						370,
						677
					],
					"Double": [],
					"Handicap": [],
					"Total": []
				},
				"priority": 5,
				"parent": null
			}
		}
	};

/***/ },
/* 652 */,
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(654);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 654 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1992);

/***/ },
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSideEffect = __webpack_require__(695);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(675);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _objectAssign = __webpack_require__(678);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(673);
	
	var _PlainComponent = __webpack_require__(674);
	
	var _PlainComponent2 = _interopRequireDefault(_PlainComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var HELMET_ATTRIBUTE = "data-react-helmet";
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props[property]) {
	            return props[property];
	        }
	    }
	    return null;
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, "title");
	    var innermostTemplate = getInnermostProperty(propsList, "titleTemplate");
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, "defaultTitle");
	
	    return innermostTitle || innermostDefaultTitle || "";
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, "onChangeClientState") || function () {};
	};
	
	var getHtmlAttributesFromPropsList = function getHtmlAttributesFromPropsList(propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.HTML] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.HTML];
	    }).reduce(function (html, current) {
	        return _extends({}, html, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    var tagList = propsList.filter(function (props) {
	        return typeof props[tagName] !== "undefined";
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	
	    return tagList;
	};
	
	var updateTitle = function updateTitle(title) {
	    document.title = title || document.title;
	};
	
	var updateHtmlAttributes = function updateHtmlAttributes(attributes) {
	    var htmlTag = document.getElementsByTagName("html")[0];
	    var helmetAttributeString = htmlTag.getAttribute(HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	        htmlTag.setAttribute(attribute, value);
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        htmlTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        htmlTag.removeAttribute(HELMET_ATTRIBUTE);
	    } else {
	        htmlTag.setAttribute(HELMET_ATTRIBUTE, helmetAttributes.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector("head");
	    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === "innerHTML") {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === "cssText") {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateHtmlAttributesAsString = function generateHtmlAttributesAsString(attributes) {
	    var keys = Object.keys(attributes);
	    var attributeString = "";
	
	    for (var i = 0; i < keys.length; i++) {
	        var attribute = keys[i];
	        var attr = typeof attributes[attribute] !== "undefined" ? attribute + "=\"" + attributes[attribute] + "\"" : "" + attribute;
	        attributeString += attr + " ";
	    }
	
	    return attributeString.trim();
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title) {
	    var stringifiedMarkup = "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(title) + "</" + type + ">";
	
	    return stringifiedMarkup;
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags) {
	    var stringifiedMarkup = tags.map(function (tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === "innerHTML" || attribute === "cssText");
	        }).map(function (attribute) {
	            if (typeof tag[attribute] === "undefined") {
	                return attribute;
	            }
	
	            var encodedValue = encodeSpecialCharacters(tag[attribute]);
	            return attribute + "=\"" + encodedValue + "\"";
	        }).join(" ").trim();
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = [_HelmetConstants.TAG_NAMES.NOSCRIPT, _HelmetConstants.TAG_NAMES.SCRIPT, _HelmetConstants.TAG_NAMES.STYLE].indexOf(type) === -1;
	
	        return "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }).join("");
	
	    return stringifiedMarkup;
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title) {
	    // assigning into an array to define toString function on it
	    var component = [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, _defineProperty({
	        key: title
	    }, HELMET_ATTRIBUTE, true), title)];
	
	    return component;
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    /* eslint-disable react/display-name */
	    var component = tags.map(function (tag, i) {
	        var mappedTag = _defineProperty({
	            key: i
	        }, HELMET_ATTRIBUTE, true);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === "innerHTML" || mappedAttribute === "cssText") {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	
	    return component;
	    /* eslint-enable react/display-name */
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags);
	                }
	            };
	        case _HelmetConstants.TAG_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return tags;
	                },
	                toString: function toString() {
	                    return generateHtmlAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var htmlAttributes = _ref.htmlAttributes,
	        title = _ref.title,
	        baseTag = _ref.baseTag,
	        metaTags = _ref.metaTags,
	        linkTags = _ref.linkTags,
	        scriptTags = _ref.scriptTags,
	        noscriptTags = _ref.noscriptTags,
	        styleTags = _ref.styleTags;
	    return {
	        htmlAttributes: getMethodsForTag(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, title),
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	};
	
	var Helmet = function Helmet(Component) {
	    /* eslint-disable react/no-multi-comp */
	    var HelmetWrapper = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, (HelmetWrapper.__proto__ || Object.getPrototypeOf(HelmetWrapper)).apply(this, arguments));
	        }
	
	        _createClass(HelmetWrapper, [{
	            key: "shouldComponentUpdate",
	            value: function shouldComponentUpdate(nextProps) {
	                return !(0, _deepEqual2.default)(this.props, nextProps);
	            }
	        }, {
	            key: "render",
	            value: function render() {
	                return _react2.default.createElement(Component, this.props);
	            }
	        }], [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	            /**
	             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	             * @param {String} title: "Title"
	             * @param {String} defaultTitle: "Default Title"
	             * @param {String} titleTemplate: "MySite.com - %s"
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	             * @param {Array} style: [{"type": "text/css", "cssText": "div{ display: block; color: blue; }"}]
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             */
	
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component);
	    /* eslint-enable react/no-multi-comp */
	
	    HelmetWrapper.propTypes = {
	        htmlAttributes: _react2.default.PropTypes.object,
	        title: _react2.default.PropTypes.string,
	        defaultTitle: _react2.default.PropTypes.string,
	        titleTemplate: _react2.default.PropTypes.string,
	        base: _react2.default.PropTypes.object,
	        meta: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        link: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        script: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        noscript: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        style: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        onChangeClientState: _react2.default.PropTypes.func
	    };
	    HelmetWrapper.peek = Component.peek;
	
	    HelmetWrapper.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = mapStateOnServer({
	                htmlAttributes: {},
	                title: "",
	                baseTag: [],
	                metaTags: [],
	                linkTags: [],
	                scriptTags: [],
	                noscriptTags: [],
	                styleTags: []
	            });
	        }
	
	        return mappedState;
	    };
	
	    return HelmetWrapper;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        htmlAttributes: getHtmlAttributesFromPropsList(propsList),
	        title: getTitleFromPropsList(propsList),
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY], propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        onChangeClientState: getOnChangeClientState(propsList)
	    };
	};
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    var htmlAttributes = newState.htmlAttributes,
	        title = newState.title,
	        baseTag = newState.baseTag,
	        metaTags = newState.metaTags,
	        linkTags = newState.linkTags,
	        scriptTags = newState.scriptTags,
	        noscriptTags = newState.noscriptTags,
	        styleTags = newState.styleTags,
	        onChangeClientState = newState.onChangeClientState;
	
	
	    updateHtmlAttributes(htmlAttributes);
	
	    updateTitle(title);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var SideEffect = (0, _reactSideEffect2.default)(reducePropsToState, handleClientStateChange, mapStateOnServer);
	
	// PlainComponent is used to be a blank component decorated by react-side-effect
	exports.default = Helmet(SideEffect(_PlainComponent2.default));
	module.exports = exports["default"];

/***/ },
/* 673 */
/***/ function(module, exports) {

	exports.__esModule = true;
	var TAG_NAMES = exports.TAG_NAMES = {
	    HTML: "htmlAttributes",
	    TITLE: "title",
	    BASE: "base",
	    META: "meta",
	    LINK: "link",
	    SCRIPT: "script",
	    NOSCRIPT: "noscript",
	    STYLE: "style"
	};
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    NAME: "name",
	    CHARSET: "charset",
	    HTTPEQUIV: "http-equiv",
	    REL: "rel",
	    HREF: "href",
	    PROPERTY: "property",
	    SRC: "src",
	    INNER_HTML: "innerHTML",
	    CSS_TEXT: "cssText"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    "charset": "charSet",
	    "http-equiv": "httpEquiv"
	};

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PlainComponent = function (_React$Component) {
	    _inherits(PlainComponent, _React$Component);
	
	    function PlainComponent() {
	        _classCallCheck(this, PlainComponent);
	
	        return _possibleConstructorReturn(this, (PlainComponent.__proto__ || Object.getPrototypeOf(PlainComponent)).apply(this, arguments));
	    }
	
	    _createClass(PlainComponent, [{
	        key: "render",
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return PlainComponent;
	}(_react2.default.Component);
	
	exports.default = PlainComponent;
	module.exports = exports["default"];

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(677);
	var isArguments = __webpack_require__(676);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ },
/* 676 */
/***/ function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ },
/* 677 */
/***/ function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ },
/* 678 */
49,
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _props = __webpack_require__(548);
	
	var _utils = __webpack_require__(88);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SEEK_ON_PLAY_EXPIRY = 5000;
	
	var Player =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Player, _Component);
	
	  function Player() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Player);
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Player)).call.apply(_getPrototypeOf2, [this].concat(_args)));
	
	    _defineProperty(_assertThisInitialized(_this), "mounted", false);
	
	    _defineProperty(_assertThisInitialized(_this), "isReady", false);
	
	    _defineProperty(_assertThisInitialized(_this), "isPlaying", false);
	
	    _defineProperty(_assertThisInitialized(_this), "isLoading", true);
	
	    _defineProperty(_assertThisInitialized(_this), "loadOnReady", null);
	
	    _defineProperty(_assertThisInitialized(_this), "startOnPlay", true);
	
	    _defineProperty(_assertThisInitialized(_this), "seekOnPlay", null);
	
	    _defineProperty(_assertThisInitialized(_this), "onDurationCalled", false);
	
	    _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function (key) {
	      if (!_this.player) return null;
	      return _this.player[key];
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "progress", function () {
	      if (_this.props.url && _this.player && _this.isReady) {
	        var playedSeconds = _this.getCurrentTime() || 0;
	
	        var loadedSeconds = _this.getSecondsLoaded();
	
	        var duration = _this.getDuration();
	
	        if (duration) {
	          var progress = {
	            playedSeconds: playedSeconds,
	            played: playedSeconds / duration
	          };
	
	          if (loadedSeconds !== null) {
	            progress.loadedSeconds = loadedSeconds;
	            progress.loaded = loadedSeconds / duration;
	          } // Only call onProgress if values have changed
	
	
	          if (progress.playedSeconds !== _this.prevPlayed || progress.loadedSeconds !== _this.prevLoaded) {
	            _this.props.onProgress(progress);
	          }
	
	          _this.prevPlayed = progress.playedSeconds;
	          _this.prevLoaded = progress.loadedSeconds;
	        }
	      }
	
	      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency || _this.props.progressInterval);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleReady", function () {
	      if (!_this.mounted) return;
	      _this.isReady = true;
	      _this.isLoading = false;
	      var _this$props = _this.props,
	          onReady = _this$props.onReady,
	          playing = _this$props.playing,
	          volume = _this$props.volume,
	          muted = _this$props.muted;
	      onReady();
	
	      if (!muted && volume !== null) {
	        _this.player.setVolume(volume);
	      }
	
	      if (_this.loadOnReady) {
	        _this.player.load(_this.loadOnReady, true);
	
	        _this.loadOnReady = null;
	      } else if (playing) {
	        _this.player.play();
	      }
	
	      _this.handleDurationCheck();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handlePlay", function () {
	      _this.isPlaying = true;
	      _this.isLoading = false;
	      var _this$props2 = _this.props,
	          onStart = _this$props2.onStart,
	          onPlay = _this$props2.onPlay,
	          playbackRate = _this$props2.playbackRate;
	
	      if (_this.startOnPlay) {
	        if (_this.player.setPlaybackRate && playbackRate !== 1) {
	          _this.player.setPlaybackRate(playbackRate);
	        }
	
	        onStart();
	        _this.startOnPlay = false;
	      }
	
	      onPlay();
	
	      if (_this.seekOnPlay) {
	        _this.seekTo(_this.seekOnPlay);
	
	        _this.seekOnPlay = null;
	      }
	
	      _this.handleDurationCheck();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handlePause", function (e) {
	      _this.isPlaying = false;
	
	      if (!_this.isLoading) {
	        _this.props.onPause(e);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleEnded", function () {
	      var _this$props3 = _this.props,
	          activePlayer = _this$props3.activePlayer,
	          loop = _this$props3.loop,
	          onEnded = _this$props3.onEnded;
	
	      if (activePlayer.loopOnEnded && loop) {
	        _this.seekTo(0);
	      }
	
	      if (!loop) {
	        _this.isPlaying = false;
	        onEnded();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleError", function () {
	      var _this$props4;
	
	      _this.isLoading = false;
	
	      (_this$props4 = _this.props).onError.apply(_this$props4, arguments);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleDurationCheck", function () {
	      clearTimeout(_this.durationCheckTimeout);
	
	      var duration = _this.getDuration();
	
	      if (duration) {
	        if (!_this.onDurationCalled) {
	          _this.props.onDuration(duration);
	
	          _this.onDurationCalled = true;
	        }
	      } else {
	        _this.durationCheckTimeout = setTimeout(_this.handleDurationCheck, 100);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleLoaded", function () {
	      // Sometimes we know loading has stopped but onReady/onPlay are never called
	      // so this provides a way for players to avoid getting stuck
	      _this.isLoading = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ref", function (player) {
	      if (player) {
	        _this.player = player;
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(Player, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true;
	      this.player.load(this.props.url);
	      this.progress();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.progressTimeout);
	      clearTimeout(this.durationCheckTimeout);
	
	      if (this.isReady) {
	        this.player.stop();
	      }
	
	      if (this.player.disablePIP) {
	        this.player.disablePIP();
	      }
	
	      this.mounted = false;
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this2 = this;
	
	      // Invoke player methods based on changed props
	      var _this$props5 = this.props,
	          url = _this$props5.url,
	          playing = _this$props5.playing,
	          volume = _this$props5.volume,
	          muted = _this$props5.muted,
	          playbackRate = _this$props5.playbackRate,
	          pip = _this$props5.pip,
	          loop = _this$props5.loop,
	          activePlayer = _this$props5.activePlayer;
	
	      if (!(0, _utils.isEqual)(prevProps.url, url)) {
	        if (this.isLoading && !activePlayer.forceLoad) {
	          console.warn("ReactPlayer: the attempt to load ".concat(url, " is being deferred until the player has loaded"));
	          this.loadOnReady = url;
	          return;
	        }
	
	        this.isLoading = true;
	        this.startOnPlay = true;
	        this.onDurationCalled = false;
	        this.player.load(url, this.isReady);
	      }
	
	      if (!prevProps.playing && playing && !this.isPlaying) {
	        this.player.play();
	      }
	
	      if (prevProps.playing && !playing && this.isPlaying) {
	        this.player.pause();
	      }
	
	      if (!prevProps.pip && pip && this.player.enablePIP) {
	        this.player.enablePIP();
	      }
	
	      if (prevProps.pip && !pip && this.player.disablePIP) {
	        this.player.disablePIP();
	      }
	
	      if (prevProps.volume !== volume && volume !== null) {
	        this.player.setVolume(volume);
	      }
	
	      if (prevProps.muted !== muted) {
	        if (muted) {
	          this.player.mute();
	        } else {
	          this.player.unmute();
	
	          if (volume !== null) {
	            // Set volume next tick to fix a bug with DailyMotion
	            setTimeout(function () {
	              return _this2.player.setVolume(volume);
	            });
	          }
	        }
	      }
	
	      if (prevProps.playbackRate !== playbackRate && this.player.setPlaybackRate) {
	        this.player.setPlaybackRate(playbackRate);
	      }
	
	      if (prevProps.loop !== loop && this.player.setLoop) {
	        this.player.setLoop(loop);
	      }
	    }
	  }, {
	    key: "getDuration",
	    value: function getDuration() {
	      if (!this.isReady) return null;
	      return this.player.getDuration();
	    }
	  }, {
	    key: "getCurrentTime",
	    value: function getCurrentTime() {
	      if (!this.isReady) return null;
	      return this.player.getCurrentTime();
	    }
	  }, {
	    key: "getSecondsLoaded",
	    value: function getSecondsLoaded() {
	      if (!this.isReady) return null;
	      return this.player.getSecondsLoaded();
	    }
	  }, {
	    key: "seekTo",
	    value: function seekTo(amount, type) {
	      var _this3 = this;
	
	      // When seeking before player is ready, store value and seek later
	      if (!this.isReady && amount !== 0) {
	        this.seekOnPlay = amount;
	        setTimeout(function () {
	          _this3.seekOnPlay = null;
	        }, SEEK_ON_PLAY_EXPIRY);
	        return;
	      }
	
	      var isFraction = !type ? amount > 0 && amount < 1 : type === 'fraction';
	
	      if (isFraction) {
	        // Convert fraction to seconds based on duration
	        var duration = this.player.getDuration();
	
	        if (!duration) {
	          console.warn('ReactPlayer: could not seek using fraction – duration not yet available');
	          return;
	        }
	
	        this.player.seekTo(duration * amount);
	        return;
	      }
	
	      this.player.seekTo(amount);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var Player = this.props.activePlayer;
	
	      if (!Player) {
	        return null;
	      }
	
	      return _react["default"].createElement(Player, _extends({}, this.props, {
	        ref: this.ref,
	        onReady: this.handleReady,
	        onPlay: this.handlePlay,
	        onPause: this.handlePause,
	        onEnded: this.handleEnded,
	        onLoaded: this.handleLoaded,
	        onError: this.handleError
	      }));
	    }
	  }]);
	
	  return Player;
	}(_react.Component);
	
	exports["default"] = Player;
	
	_defineProperty(Player, "displayName", 'Player');
	
	_defineProperty(Player, "propTypes", _props.propTypes);
	
	_defineProperty(Player, "defaultProps", _props.defaultProps);

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.DailyMotion = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(88);
	
	var _singlePlayer = _interopRequireDefault(__webpack_require__(129));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SDK_URL = 'https://api.dmcdn.net/all.js';
	var SDK_GLOBAL = 'DM';
	var SDK_GLOBAL_READY = 'dmAsyncInit';
	var MATCH_URL = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?$/;
	
	var DailyMotion =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(DailyMotion, _Component);
	
	  function DailyMotion() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, DailyMotion);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DailyMotion)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);
	
	    _defineProperty(_assertThisInitialized(_this), "onDurationChange", function () {
	      var duration = _this.getDuration();
	
	      _this.props.onDuration(duration);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "mute", function () {
	      _this.callPlayer('setMuted', true);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
	      _this.callPlayer('setMuted', false);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
	      _this.container = container;
	    });
	
	    return _this;
	  }
	
	  _createClass(DailyMotion, [{
	    key: "load",
	    value: function load(url) {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          controls = _this$props.controls,
	          config = _this$props.config,
	          onError = _this$props.onError,
	          playing = _this$props.playing;
	
	      var _url$match = url.match(MATCH_URL),
	          _url$match2 = _slicedToArray(_url$match, 2),
	          id = _url$match2[1];
	
	      if (this.player) {
	        this.player.load(id, {
	          start: (0, _utils.parseStartTime)(url),
	          autoplay: playing
	        });
	        return;
	      }
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (DM) {
	        return DM.player;
	      }).then(function (DM) {
	        if (!_this2.container) return;
	        var Player = DM.player;
	        _this2.player = new Player(_this2.container, {
	          width: '100%',
	          height: '100%',
	          video: id,
	          params: _objectSpread({
	            controls: controls,
	            autoplay: _this2.props.playing,
	            mute: _this2.props.muted,
	            start: (0, _utils.parseStartTime)(url),
	            origin: window.location.origin
	          }, config.dailymotion.params),
	          events: {
	            apiready: _this2.props.onReady,
	            seeked: function seeked() {
	              return _this2.props.onSeek(_this2.player.currentTime);
	            },
	            video_end: _this2.props.onEnded,
	            durationchange: _this2.onDurationChange,
	            pause: _this2.props.onPause,
	            playing: _this2.props.onPlay,
	            waiting: _this2.props.onBuffer,
	            error: function error(event) {
	              return onError(event);
	            }
	          }
	        });
	      }, onError);
	    }
	  }, {
	    key: "play",
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: "stop",
	    value: function stop() {// Nothing to do
	    }
	  }, {
	    key: "seekTo",
	    value: function seekTo(seconds) {
	      this.callPlayer('seek', seconds);
	    }
	  }, {
	    key: "setVolume",
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction);
	    }
	  }, {
	    key: "getDuration",
	    value: function getDuration() {
	      return this.player.duration || null;
	    }
	  }, {
	    key: "getCurrentTime",
	    value: function getCurrentTime() {
	      return this.player.currentTime;
	    }
	  }, {
	    key: "getSecondsLoaded",
	    value: function getSecondsLoaded() {
	      return this.player.bufferedTime;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var display = this.props.display;
	      var style = {
	        width: '100%',
	        height: '100%',
	        display: display
	      };
	      return _react["default"].createElement("div", {
	        style: style
	      }, _react["default"].createElement("div", {
	        ref: this.ref
	      }));
	    }
	  }]);
	
	  return DailyMotion;
	}(_react.Component);
	
	exports.DailyMotion = DailyMotion;
	
	_defineProperty(DailyMotion, "displayName", 'DailyMotion');
	
	_defineProperty(DailyMotion, "canPlay", function (url) {
	  return MATCH_URL.test(url);
	});
	
	_defineProperty(DailyMotion, "loopOnEnded", true);
	
	var _default = (0, _singlePlayer["default"])(DailyMotion);
	
	exports["default"] = _default;

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.SoundCloud = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(88);
	
	var _singlePlayer = _interopRequireDefault(__webpack_require__(129));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SDK_URL = 'https://w.soundcloud.com/player/api.js';
	var SDK_GLOBAL = 'SC';
	var MATCH_URL = /(soundcloud\.com|snd\.sc)\/.+$/;
	
	var SoundCloud =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(SoundCloud, _Component);
	
	  function SoundCloud() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, SoundCloud);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SoundCloud)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);
	
	    _defineProperty(_assertThisInitialized(_this), "duration", null);
	
	    _defineProperty(_assertThisInitialized(_this), "currentTime", null);
	
	    _defineProperty(_assertThisInitialized(_this), "fractionLoaded", null);
	
	    _defineProperty(_assertThisInitialized(_this), "mute", function () {
	      _this.setVolume(0);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
	      if (_this.props.volume !== null) {
	        _this.setVolume(_this.props.volume);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
	      _this.iframe = iframe;
	    });
	
	    return _this;
	  }
	
	  _createClass(SoundCloud, [{
	    key: "load",
	    value: function load(url, isReady) {
	      var _this2 = this;
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (SC) {
	        if (!_this2.iframe) return;
	        var _SC$Widget$Events = SC.Widget.Events,
	            PLAY = _SC$Widget$Events.PLAY,
	            PLAY_PROGRESS = _SC$Widget$Events.PLAY_PROGRESS,
	            PAUSE = _SC$Widget$Events.PAUSE,
	            FINISH = _SC$Widget$Events.FINISH,
	            ERROR = _SC$Widget$Events.ERROR;
	
	        if (!isReady) {
	          _this2.player = SC.Widget(_this2.iframe);
	
	          _this2.player.bind(PLAY, _this2.props.onPlay);
	
	          _this2.player.bind(PAUSE, _this2.props.onPause);
	
	          _this2.player.bind(PLAY_PROGRESS, function (e) {
	            _this2.currentTime = e.currentPosition / 1000;
	            _this2.fractionLoaded = e.loadedProgress;
	          });
	
	          _this2.player.bind(FINISH, function () {
	            return _this2.props.onEnded();
	          });
	
	          _this2.player.bind(ERROR, function (e) {
	            return _this2.props.onError(e);
	          });
	        }
	
	        _this2.player.load(url, _objectSpread({}, _this2.props.config.soundcloud.options, {
	          callback: function callback() {
	            _this2.player.getDuration(function (duration) {
	              _this2.duration = duration / 1000;
	
	              _this2.props.onReady();
	            });
	          }
	        }));
	      });
	    }
	  }, {
	    key: "play",
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: "stop",
	    value: function stop() {// Nothing to do
	    }
	  }, {
	    key: "seekTo",
	    value: function seekTo(seconds) {
	      this.callPlayer('seekTo', seconds * 1000);
	    }
	  }, {
	    key: "setVolume",
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction * 100);
	    }
	  }, {
	    key: "getDuration",
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: "getCurrentTime",
	    value: function getCurrentTime() {
	      return this.currentTime;
	    }
	  }, {
	    key: "getSecondsLoaded",
	    value: function getSecondsLoaded() {
	      return this.fractionLoaded * this.duration;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var display = this.props.display;
	      var style = {
	        width: '100%',
	        height: '100%',
	        display: display
	      };
	      return _react["default"].createElement("iframe", {
	        ref: this.ref,
	        src: "https://w.soundcloud.com/player/?url=".concat(encodeURIComponent(this.props.url)),
	        style: style,
	        frameBorder: 0,
	        allow: "autoplay"
	      });
	    }
	  }]);
	
	  return SoundCloud;
	}(_react.Component);
	
	exports.SoundCloud = SoundCloud;
	
	_defineProperty(SoundCloud, "displayName", 'SoundCloud');
	
	_defineProperty(SoundCloud, "canPlay", function (url) {
	  return MATCH_URL.test(url);
	});
	
	_defineProperty(SoundCloud, "loopOnEnded", true);
	
	var _default = (0, _singlePlayer["default"])(SoundCloud);
	
	exports["default"] = _default;

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.Vimeo = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(88);
	
	var _singlePlayer = _interopRequireDefault(__webpack_require__(129));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SDK_URL = 'https://player.vimeo.com/api/player.js';
	var SDK_GLOBAL = 'Vimeo';
	var MATCH_URL = /vimeo\.com\/.+/;
	var MATCH_FILE_URL = /vimeo\.com\/external\/[0-9]+\..+/;
	
	var Vimeo =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Vimeo, _Component);
	
	  function Vimeo() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Vimeo);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Vimeo)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);
	
	    _defineProperty(_assertThisInitialized(_this), "duration", null);
	
	    _defineProperty(_assertThisInitialized(_this), "currentTime", null);
	
	    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);
	
	    _defineProperty(_assertThisInitialized(_this), "mute", function () {
	      _this.setVolume(0);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
	      if (_this.props.volume !== null) {
	        _this.setVolume(_this.props.volume);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
	      _this.container = container;
	    });
	
	    return _this;
	  }
	
	  _createClass(Vimeo, [{
	    key: "load",
	    value: function load(url) {
	      var _this2 = this;
	
	      this.duration = null;
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Vimeo) {
	        if (!_this2.container) return;
	        _this2.player = new Vimeo.Player(_this2.container, _objectSpread({
	          url: url,
	          autoplay: _this2.props.playing,
	          muted: _this2.props.muted,
	          loop: _this2.props.loop,
	          playsinline: _this2.props.playsinline,
	          controls: _this2.props.controls
	        }, _this2.props.config.vimeo.playerOptions));
	
	        _this2.player.ready().then(function () {
	          var iframe = _this2.container.querySelector('iframe');
	
	          iframe.style.width = '100%';
	          iframe.style.height = '100%';
	        })["catch"](_this2.props.onError);
	
	        _this2.player.on('loaded', function () {
	          _this2.props.onReady();
	
	          _this2.refreshDuration();
	        });
	
	        _this2.player.on('play', function () {
	          _this2.props.onPlay();
	
	          _this2.refreshDuration();
	        });
	
	        _this2.player.on('pause', _this2.props.onPause);
	
	        _this2.player.on('seeked', function (e) {
	          return _this2.props.onSeek(e.seconds);
	        });
	
	        _this2.player.on('ended', _this2.props.onEnded);
	
	        _this2.player.on('error', _this2.props.onError);
	
	        _this2.player.on('timeupdate', function (_ref) {
	          var seconds = _ref.seconds;
	          _this2.currentTime = seconds;
	        });
	
	        _this2.player.on('progress', function (_ref2) {
	          var seconds = _ref2.seconds;
	          _this2.secondsLoaded = seconds;
	        });
	      }, this.props.onError);
	    }
	  }, {
	    key: "refreshDuration",
	    value: function refreshDuration() {
	      var _this3 = this;
	
	      this.player.getDuration().then(function (duration) {
	        _this3.duration = duration;
	      });
	    }
	  }, {
	    key: "play",
	    value: function play() {
	      var promise = this.callPlayer('play');
	
	      if (promise) {
	        promise["catch"](this.props.onError);
	      }
	    }
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: "stop",
	    value: function stop() {
	      this.callPlayer('unload');
	    }
	  }, {
	    key: "seekTo",
	    value: function seekTo(seconds) {
	      this.callPlayer('setCurrentTime', seconds);
	    }
	  }, {
	    key: "setVolume",
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction);
	    }
	  }, {
	    key: "setLoop",
	    value: function setLoop(loop) {
	      this.callPlayer('setLoop', loop);
	    }
	  }, {
	    key: "setPlaybackRate",
	    value: function setPlaybackRate(rate) {
	      this.callPlayer('setPlaybackRate', rate);
	    }
	  }, {
	    key: "getDuration",
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: "getCurrentTime",
	    value: function getCurrentTime() {
	      return this.currentTime;
	    }
	  }, {
	    key: "getSecondsLoaded",
	    value: function getSecondsLoaded() {
	      return this.secondsLoaded;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var display = this.props.display;
	      var style = {
	        width: '100%',
	        height: '100%',
	        overflow: 'hidden',
	        display: display
	      };
	      return _react["default"].createElement("div", {
	        key: this.props.url,
	        ref: this.ref,
	        style: style
	      });
	    }
	  }]);
	
	  return Vimeo;
	}(_react.Component);
	
	exports.Vimeo = Vimeo;
	
	_defineProperty(Vimeo, "displayName", 'Vimeo');
	
	_defineProperty(Vimeo, "forceLoad", true);
	
	_defineProperty(Vimeo, "canPlay", function (url) {
	  if (MATCH_FILE_URL.test(url)) {
	    return false;
	  }
	
	  return MATCH_URL.test(url);
	});
	
	var _default = (0, _singlePlayer["default"])(Vimeo);
	
	exports["default"] = _default;

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.YouTube = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(88);
	
	var _singlePlayer = _interopRequireDefault(__webpack_require__(129));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var SDK_URL = 'https://www.youtube.com/iframe_api';
	var SDK_GLOBAL = 'YT';
	var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
	var MATCH_URL = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})|youtube\.com\/playlist\?list=/;
	var MATCH_PLAYLIST = /list=([a-zA-Z0-9_-]+)/;
	
	function parsePlaylist(url) {
	  if (MATCH_PLAYLIST.test(url)) {
	    var _url$match = url.match(MATCH_PLAYLIST),
	        _url$match2 = _slicedToArray(_url$match, 2),
	        playlistId = _url$match2[1];
	
	    return {
	      listType: 'playlist',
	      list: playlistId
	    };
	  }
	
	  return {};
	}
	
	var YouTube =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(YouTube, _Component);
	
	  function YouTube() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, YouTube);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(YouTube)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);
	
	    _defineProperty(_assertThisInitialized(_this), "onStateChange", function (_ref) {
	      var data = _ref.data;
	      var _this$props = _this.props,
	          onPlay = _this$props.onPlay,
	          onPause = _this$props.onPause,
	          onBuffer = _this$props.onBuffer,
	          onBufferEnd = _this$props.onBufferEnd,
	          onEnded = _this$props.onEnded,
	          onReady = _this$props.onReady,
	          loop = _this$props.loop;
	      var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState,
	          PLAYING = _window$SDK_GLOBAL$Pl.PLAYING,
	          PAUSED = _window$SDK_GLOBAL$Pl.PAUSED,
	          BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING,
	          ENDED = _window$SDK_GLOBAL$Pl.ENDED,
	          CUED = _window$SDK_GLOBAL$Pl.CUED;
	
	      if (data === PLAYING) {
	        onPlay();
	        onBufferEnd();
	      }
	
	      if (data === PAUSED) onPause();
	      if (data === BUFFERING) onBuffer();
	
	      if (data === ENDED) {
	        var isPlaylist = !!_this.callPlayer('getPlaylist');
	
	        if (loop && !isPlaylist) {
	          _this.play(); // Only loop manually if not playing a playlist
	
	        }
	
	        onEnded();
	      }
	
	      if (data === CUED) onReady();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "mute", function () {
	      _this.callPlayer('mute');
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
	      _this.callPlayer('unMute');
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
	      _this.container = container;
	    });
	
	    return _this;
	  }
	
	  _createClass(YouTube, [{
	    key: "load",
	    value: function load(url, isReady) {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          playing = _this$props2.playing,
	          muted = _this$props2.muted,
	          playsinline = _this$props2.playsinline,
	          controls = _this$props2.controls,
	          loop = _this$props2.loop,
	          config = _this$props2.config,
	          _onError = _this$props2.onError;
	      var _config$youtube = config.youtube,
	          playerVars = _config$youtube.playerVars,
	          embedOptions = _config$youtube.embedOptions;
	      var id = url && url.match(MATCH_URL)[1];
	
	      if (isReady) {
	        if (MATCH_PLAYLIST.test(url)) {
	          this.player.loadPlaylist(parsePlaylist(url));
	          return;
	        }
	
	        this.player.cueVideoById({
	          videoId: id,
	          startSeconds: (0, _utils.parseStartTime)(url) || playerVars.start,
	          endSeconds: (0, _utils.parseEndTime)(url) || playerVars.end
	        });
	        return;
	      }
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (YT) {
	        return YT.loaded;
	      }).then(function (YT) {
	        if (!_this2.container) return;
	        _this2.player = new YT.Player(_this2.container, _objectSpread({
	          width: '100%',
	          height: '100%',
	          videoId: id,
	          playerVars: _objectSpread({
	            autoplay: playing ? 1 : 0,
	            mute: muted ? 1 : 0,
	            controls: controls ? 1 : 0,
	            start: (0, _utils.parseStartTime)(url),
	            end: (0, _utils.parseEndTime)(url),
	            origin: window.location.origin,
	            playsinline: playsinline
	          }, parsePlaylist(url), {}, playerVars),
	          events: {
	            onReady: function onReady() {
	              if (loop) {
	                _this2.player.setLoop(true); // Enable playlist looping
	
	              }
	
	              _this2.props.onReady();
	            },
	            onStateChange: _this2.onStateChange,
	            onError: function onError(event) {
	              return _onError(event.data);
	            }
	          }
	        }, embedOptions));
	      }, _onError);
	    }
	  }, {
	    key: "play",
	    value: function play() {
	      this.callPlayer('playVideo');
	    }
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.callPlayer('pauseVideo');
	    }
	  }, {
	    key: "stop",
	    value: function stop() {
	      if (!document.body.contains(this.callPlayer('getIframe'))) return;
	      this.callPlayer('stopVideo');
	    }
	  }, {
	    key: "seekTo",
	    value: function seekTo(amount) {
	      this.callPlayer('seekTo', amount);
	
	      if (!this.props.playing) {
	        this.pause();
	      }
	    }
	  }, {
	    key: "setVolume",
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction * 100);
	    }
	  }, {
	    key: "setPlaybackRate",
	    value: function setPlaybackRate(rate) {
	      this.callPlayer('setPlaybackRate', rate);
	    }
	  }, {
	    key: "setLoop",
	    value: function setLoop(loop) {
	      this.callPlayer('setLoop', loop);
	    }
	  }, {
	    key: "getDuration",
	    value: function getDuration() {
	      return this.callPlayer('getDuration');
	    }
	  }, {
	    key: "getCurrentTime",
	    value: function getCurrentTime() {
	      return this.callPlayer('getCurrentTime');
	    }
	  }, {
	    key: "getSecondsLoaded",
	    value: function getSecondsLoaded() {
	      return this.callPlayer('getVideoLoadedFraction') * this.getDuration();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var display = this.props.display;
	      var style = {
	        width: '100%',
	        height: '100%',
	        display: display
	      };
	      return _react["default"].createElement("div", {
	        style: style
	      }, _react["default"].createElement("div", {
	        ref: this.ref
	      }));
	    }
	  }]);
	
	  return YouTube;
	}(_react.Component);
	
	exports.YouTube = YouTube;
	
	_defineProperty(YouTube, "displayName", 'YouTube');
	
	_defineProperty(YouTube, "canPlay", function (url) {
	  return MATCH_URL.test(url);
	});
	
	var _default = (0, _singlePlayer["default"])(YouTube);
	
	exports["default"] = _default;

/***/ },
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stripDiacritics = __webpack_require__(922);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	var _trim = __webpack_require__(1958);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isValid = function isValid(value) {
		return typeof value !== 'undefined' && value !== null && value !== '';
	};
	
	var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
		if (props.ignoreAccents) {
			filterValue = (0, _stripDiacritics2.default)(filterValue);
		}
	
		if (props.ignoreCase) {
			filterValue = filterValue.toLowerCase();
		}
	
		if (props.trimFilter) {
			filterValue = (0, _trim2.default)(filterValue);
		}
	
		if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
			return i[props.valueKey];
		});
	
		return options.filter(function (option) {
			if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
			if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
			if (!filterValue) return true;
	
			var value = option[props.valueKey];
			var label = option[props.labelKey];
			var hasValue = isValid(value);
			var hasLabel = isValid(label);
	
			if (!hasValue && !hasLabel) {
				return false;
			}
	
			var valueTest = hasValue ? String(value) : null;
			var labelTest = hasLabel ? String(label) : null;
	
			if (props.ignoreAccents) {
				if (valueTest && props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
				if (labelTest && props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
			}
	
			if (props.ignoreCase) {
				if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
				if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
			}
	
			return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
		});
	};
	
	exports.default = filterOptions;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classnames = __webpack_require__(61);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(87);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuRenderer = function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption,
		    focusOption = _ref.focusOption,
		    inputValue = _ref.inputValue,
		    instancePrefix = _ref.instancePrefix,
		    onFocus = _ref.onFocus,
		    onOptionRef = _ref.onOptionRef,
		    onSelect = _ref.onSelect,
		    optionClassName = _ref.optionClassName,
		    optionComponent = _ref.optionComponent,
		    optionRenderer = _ref.optionRenderer,
		    options = _ref.options,
		    removeValue = _ref.removeValue,
		    selectValue = _ref.selectValue,
		    valueArray = _ref.valueArray,
		    valueKey = _ref.valueKey;
	
		var Option = optionComponent;
	
		return options.map(function (option, i) {
			var isSelected = valueArray && valueArray.some(function (x) {
				return x[valueKey] === option[valueKey];
			});
			var isFocused = option === focusedOption;
			var optionClass = (0, _classnames2.default)(optionClassName, {
				'Select-option': true,
				'is-selected': isSelected,
				'is-focused': isFocused,
				'is-disabled': option.disabled
			});
	
			return _react2.default.createElement(
				Option,
				{
					className: optionClass,
					focusOption: focusOption,
					inputValue: inputValue,
					instancePrefix: instancePrefix,
					isDisabled: option.disabled,
					isFocused: isFocused,
					isSelected: isSelected,
					key: 'option-' + i + '-' + option[valueKey],
					onFocus: onFocus,
					onSelect: onSelect,
					option: option,
					optionIndex: i,
					ref: function ref(_ref2) {
						onOptionRef(_ref2, isFocused);
					},
					removeValue: removeValue,
					selectValue: selectValue
				},
				optionRenderer(option, i, inputValue)
			);
		});
	};
	
	menuRenderer.propTypes = {
		focusOption: _propTypes2.default.func,
		focusedOption: _propTypes2.default.object,
		inputValue: _propTypes2.default.string,
		instancePrefix: _propTypes2.default.string,
		onFocus: _propTypes2.default.func,
		onOptionRef: _propTypes2.default.func,
		onSelect: _propTypes2.default.func,
		optionClassName: _propTypes2.default.string,
		optionComponent: _propTypes2.default.func,
		optionRenderer: _propTypes2.default.func,
		options: _propTypes2.default.array,
		removeValue: _propTypes2.default.func,
		selectValue: _propTypes2.default.func,
		valueArray: _propTypes2.default.array,
		valueKey: _propTypes2.default.string
	};
	
	exports.default = menuRenderer;

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fbjsLibExecutionEnvironment = __webpack_require__(696);
	
	var _fbjsLibExecutionEnvironment2 = _interopRequireDefault(_fbjsLibExecutionEnvironment);
	
	var _fbjsLibShallowEqual = __webpack_require__(697);
	
	var _fbjsLibShallowEqual2 = _interopRequireDefault(_fbjsLibShallowEqual);
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = undefined;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = (function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        _Component.apply(this, arguments);
	      }
	
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may ony call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !_fbjsLibShallowEqual2['default'](nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2['default'].createElement(WrappedComponent, this.props);
	      };
	
	      _createClass(SideEffect, null, [{
	        key: 'displayName',
	
	        // Try to use displayName of wrapped component
	        value: 'SideEffect(' + getDisplayName(WrappedComponent) + ')',
	
	        // Expose canUseDOM so tests can monkeypatch it
	        enumerable: true
	      }, {
	        key: 'canUseDOM',
	        value: _fbjsLibExecutionEnvironment2['default'].canUseDOM,
	        enumerable: true
	      }]);
	
	      return SideEffect;
	    })(_react.Component);
	
	    return SideEffect;
	  };
	};

/***/ },
/* 696 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 697 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _slider = __webpack_require__(1964);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _slider2.default;

/***/ },
/* 699 */,
/* 700 */,
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(702);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 702 */,
/* 703 */,
/* 704 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CANCEL_BIG_STAKE_REQUEST = exports.CANCEL_BIG_STAKE_REQUEST = 'CANCEL_BIG_STAKE_REQUEST';
	var SUCCESS_BIG_STAKE_REQUEST_CANCEL = exports.SUCCESS_BIG_STAKE_REQUEST_CANCEL = 'SUCCESS_BIG_STAKE_REQUEST_CANCEL';
	var FAILURE_BIG_STAKE_REQUEST_CANCEL = exports.FAILURE_BIG_STAKE_REQUEST_CANCEL = 'FAILURE_BIG_STAKE_REQUEST_CANCEL';

/***/ },
/* 705 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CREATE_CASHOUT = exports.CREATE_CASHOUT = 'CREATE_CASHOUT';
	var SUCCESS_CREATE_CASHOUT = exports.SUCCESS_CREATE_CASHOUT = 'SUCCESS_CREATE_CASHOUT';
	var FAILURE_CREATE_CASHOUT = exports.FAILURE_CREATE_CASHOUT = 'FAILURE_CREATE_CASHOUT';
	
	var SET_CASHOUT_STATUS = exports.SET_CASHOUT_STATUS = 'SET_CASHOUT_STATUS';

/***/ },
/* 706 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GET_NEWS = exports.GET_NEWS = 'GET_NEWS';
	var SUCCESS_GET_NEWS = exports.SUCCESS_GET_NEWS = 'SUCCESS_GET_NEWS';
	var FAILURE_GET_NEWS = exports.FAILURE_GET_NEWS = 'FAILURE_GET_NEWS';

/***/ },
/* 707 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_DISPLAY_MODE = exports.SET_DISPLAY_MODE = 'SET_DISPLAY_MODE';

/***/ },
/* 708 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_STREAM = exports.LOAD_STREAM = 'LOAD_STREAM';
	var STOP_STREAM = exports.STOP_STREAM = 'STOP_STREAM';

/***/ },
/* 709 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var USER_SELECTION_TOGGLE_SPORT = exports.USER_SELECTION_TOGGLE_SPORT = 'USER_SELECTION_TOGGLE_SPORT';
	
	var USER_SELECTION_TOGGLE_LEAGUE = exports.USER_SELECTION_TOGGLE_LEAGUE = 'USER_SELECTION_TOGGLE_LEAGUE';
	
	var USER_SELECTION_TOGGLE_MATCH = exports.USER_SELECTION_TOGGLE_MATCH = 'USER_SELECTION_TOGGLE_MATCH';
	
	var USER_SELECTION_SHOW_ALL = exports.USER_SELECTION_SHOW_ALL = 'USER_SELECTION_SHOW_ALL';

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CHANGE_JOIN_TYPE = exports.FAILURE_JOIN = exports.SUCCESS_JOIN = exports.JOIN = undefined;
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.join = join;
	exports.changeJoinType = changeJoinType;
	
	var _api = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JOIN = exports.JOIN = 'JOIN';
	var SUCCESS_JOIN = exports.SUCCESS_JOIN = 'SUCCESS_JOIN';
	var FAILURE_JOIN = exports.FAILURE_JOIN = 'FAILURE_JOIN';
	
	var CHANGE_JOIN_TYPE = exports.CHANGE_JOIN_TYPE = 'CHANGE_JOIN_TYPE';
	
	function fetchJoin(data) {
	    return (0, _defineProperty3.default)({
	        type: JOIN
	    }, _api.CALL_API, {
	        endpoint: '/api/join/',
	        method: 'post',
	        types: [SUCCESS_JOIN, FAILURE_JOIN],
	        credentials: true,
	        data: data
	    });
	}
	
	function join(data) {
	    return function (dispatch) {
	        dispatch(fetchJoin(data));
	    };
	}
	
	function changeJoinType(data) {
	    return function (dispatch) {
	        dispatch({
	            type: CHANGE_JOIN_TYPE, data: data
	        });
	    };
	}

/***/ },
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.getToken = getToken;
	
	var _api = __webpack_require__(13);
	
	var _index = __webpack_require__(732);
	
	var Actions = _interopRequireWildcard(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchToken() {
	    return (0, _defineProperty3.default)({
	        type: Actions.FETCH_BETGAMES_TOKEN
	    }, _api.CALL_API, {
	        endpoint: '/api/betgames/',
	        method: 'get',
	        types: [Actions.SUCCESS_FETCH_BETGAMES_TOKEN, Actions.FAILURE_FETCH_BETGAMES_TOKEN],
	        credentials: true
	    });
	}
	
	function getToken() {
	    return function (dispatch) {
	        dispatch(fetchToken());
	    };
	}

/***/ },
/* 732 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FETCH_BETGAMES_TOKEN = exports.FETCH_BETGAMES_TOKEN = 'FETCH_BETGAMES_TOKEN';
	var SUCCESS_FETCH_BETGAMES_TOKEN = exports.SUCCESS_FETCH_BETGAMES_TOKEN = 'SUCCESS_FETCH_BETGAMES_TOKEN';
	var FAILURE_FETCH_BETGAMES_TOKEN = exports.FAILURE_FETCH_BETGAMES_TOKEN = 'FAILURE_FETCH_BETGAMES_TOKEN';

/***/ },
/* 733 */,
/* 734 */,
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.toggleOneClickMode = toggleOneClickMode;
	exports.setOneClickAmount = setOneClickAmount;
	exports.setAcceptFactorChangeMode = setAcceptFactorChangeMode;
	exports.toggleAcceptFactorIncrease = toggleAcceptFactorIncrease;
	exports.toggleAcceptFactorDecrease = toggleAcceptFactorDecrease;
	exports.setFavouriteBetAmount = setFavouriteBetAmount;
	
	var _BettingMode = __webpack_require__(483);
	
	var ActionTypes = _interopRequireWildcard(_BettingMode);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function toggleOneClickMode(data) {
	    return { type: ActionTypes.TOGGLE_ONE_CLICK_MODE, data: data };
	}
	
	function setOneClickAmount(data) {
	    return { type: ActionTypes.SET_ONE_CLICK_AMOUNT, data: data };
	}
	
	function setAcceptFactorChangeMode(data) {
	    return { type: ActionTypes.SET_ACCEPT_FACTOR_CHANGE_MODE, data: data };
	}
	
	function toggleAcceptFactorIncrease(data) {
	    return { type: ActionTypes.TOGGLE_ACCEPT_FACTOR_INCREASE, data: data };
	}
	
	function toggleAcceptFactorDecrease(data) {
	    return { type: ActionTypes.TOGGLE_ACCEPT_FACTOR_DECREASE, data: data };
	}
	
	function setFavouriteBetAmount(data) {
	    return { type: ActionTypes.SET_FAVOURITE_BET_AMOUNT, data: data };
	}

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.toggleFavouriteLeague = toggleFavouriteLeague;
	exports.toggleFavouriteMatch = toggleFavouriteMatch;
	exports.toggleFavouriteSport = toggleFavouriteSport;
	
	var _Favourites = __webpack_require__(155);
	
	var ActionTypes = _interopRequireWildcard(_Favourites);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function toggleFavouriteLeague(data) {
	    return { type: ActionTypes.TOGGLE_FAVOURITE_LEAGUE, data: data, section: 'live' };
	}
	
	function toggleFavouriteMatch(data) {
	    return { type: ActionTypes.TOGGLE_FAVOURITE_MATCH, data: data, section: 'live' };
	}
	
	function toggleFavouriteSport(data) {
	    return { type: ActionTypes.TOGGLE_FAVOURITE_SPORT, data: data, section: 'live' };
	}

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FAILURE_FETCH_GAMBLER_INFO = exports.SUCCESS_FETCH_GAMBLER_INFO = exports.FETCH_GAMBLER_INFO = undefined;
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.getGamblerInfo = getGamblerInfo;
	
	var _api = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FETCH_GAMBLER_INFO = exports.FETCH_GAMBLER_INFO = 'FETCH_GAMBLER_INFO';
	var SUCCESS_FETCH_GAMBLER_INFO = exports.SUCCESS_FETCH_GAMBLER_INFO = 'SUCCESS_FETCH_GAMBLER_INFO';
	var FAILURE_FETCH_GAMBLER_INFO = exports.FAILURE_FETCH_GAMBLER_INFO = 'FAILURE_FETCH_GAMBLER_INFO';
	
	function getGamblerInfo() {
	  return function (dispatch) {
	    dispatch((0, _defineProperty3.default)({
	      type: FETCH_GAMBLER_INFO
	    }, _api.CALL_API, {
	      endpoint: '/api/gambler',
	      method: 'GET',
	      types: [SUCCESS_FETCH_GAMBLER_INFO, FAILURE_FETCH_GAMBLER_INFO],
	      credentials: true
	    }));
	  };
	}

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.initPreMatchMenu = initPreMatchMenu;
	
	var _api = __webpack_require__(13);
	
	var _transform = __webpack_require__(336);
	
	var _PreMatchMenu = __webpack_require__(560);
	
	var ActionTypes = _interopRequireWildcard(_PreMatchMenu);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function initPreMatchMenu(data) {
	    var languageId = data.languageId;
	
	    return function (dispatch) {
	        var _dispatch;
	
	        return dispatch((_dispatch = {
	            type: ActionTypes.INIT_PREMATCH_MENU
	        }, (0, _defineProperty3.default)(_dispatch, _api.CALL_API, {
	            endpoint: '/api/menu?languageId=' + languageId,
	            method: 'get',
	            types: [ActionTypes.SUCCESS_INIT_PREMATCH_MENU, ActionTypes.FAILURE_INIT_PREMATCH_MENU],
	            data: data
	        }), (0, _defineProperty3.default)(_dispatch, _transform.TRANSFORM, {
	            section: 'menu',
	            transformType: 'init',
	            provider: function provider(data) {
	                return data;
	            }
	        }), _dispatch));
	    };
	}

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.toggleGroup = toggleGroup;
	exports.expandGroup = expandGroup;
	
	var _ToggleGroup = __webpack_require__(484);
	
	var ActionTypes = _interopRequireWildcard(_ToggleGroup);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function toggleGroup(data, section) {
	    return { type: ActionTypes.TOGGLE_GROUP, data: data, section: section };
	}
	
	function expandGroup(data, section) {
	    return { type: ActionTypes.EXPAND_GROUP, data: data, section: section };
	}

/***/ },
/* 740 */,
/* 741 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FETCH_VIVO_GAMES_TOKEN = exports.FETCH_VIVO_GAMES_TOKEN = 'FETCH_VIVO_GAMES_TOKEN';
	var SUCCESS_FETCH_VIVO_GAMES_TOKEN = exports.SUCCESS_FETCH_VIVO_GAMES_TOKEN = 'SUCCESS_FETCH_VIVO_GAMES_TOKEN';
	var FAILURE_FETCH_VIVO_GAMES_TOKEN = exports.FAILURE_FETCH_VIVO_GAMES_TOKEN = 'FAILURE_FETCH_VIVO_GAMES_TOKEN';
	
	var FETCH_TVBET_GAMES_TOKEN = exports.FETCH_TVBET_GAMES_TOKEN = 'FETCH_TVBET_GAMES_TOKEN';
	var SUCCESS_FETCH_TVBET_GAMES_TOKEN = exports.SUCCESS_FETCH_TVBET_GAMES_TOKEN = 'SUCCESS_FETCH_TVBET_GAMES_TOKEN';
	var FAILURE_FETCH_TVBET_GAMES_TOKEN = exports.FAILURE_FETCH_TVBET_GAMES_TOKEN = 'FAILURE_FETCH_TVBET_GAMES_TOKEN';
	
	var FETCH_TVBET_DEMO_GAMES = exports.FETCH_TVBET_DEMO_GAMES = 'FETCH_TVBET_DEMO_GAMES';
	
	var FETCH_TVBET_ROULLETTE_DEMO = exports.FETCH_TVBET_ROULLETTE_DEMO = 'FETCH_TVBET_ROULLETTE_DEMO';
	
	var FETCH_FASTSPORT_GAMES_TOKEN = exports.FETCH_FASTSPORT_GAMES_TOKEN = 'FETCH_FASTSPORT_GAMES_TOKEN';
	var SUCCESS_FETCH_FASTSPORT_GAMES_TOKEN = exports.SUCCESS_FETCH_FASTSPORT_GAMES_TOKEN = 'SUCCESS_FETCH_FASTSPORT_GAMES_TOKEN';
	var FAILURE_FETCH_FASTSPORT_GAMES_TOKEN = exports.FAILURE_FETCH_FASTSPORT_GAMES_TOKEN = 'FAILURE_FETCH_TVBET_GAMES_TOKEN';
	
	var FETCH_TVBET_ROULLETTE_TOKEN = exports.FETCH_TVBET_ROULLETTE_TOKEN = 'FETCH_TVBET_ROULLETTE_TOKEN';
	var SUCCESS_FETCH_TVBET_ROULLETTE_TOKEN = exports.SUCCESS_FETCH_TVBET_ROULLETTE_TOKEN = 'SUCCESS_FETCH_TVBET_ROULLETTE_TOKEN';
	var FAILURE_FETCH_TVBET_ROULLETTE_TOKEN = exports.FAILURE_FETCH_TVBET_ROULLETTE_TOKEN = 'FAILURE_FETCH_TVBET_ROULLETTE_TOKEN';
	
	var FETCH_BETSOLUTIONS_GAMES_TOKEN = exports.FETCH_BETSOLUTIONS_GAMES_TOKEN = 'FETCH_BETSOLUTIONS_GAMES_TOKEN';
	var SUCCESS_FETCH_BETSOLUTIONS_GAMES_TOKEN = exports.SUCCESS_FETCH_BETSOLUTIONS_GAMES_TOKEN = 'SUCCESS_FETCH_BETSOLUTIONS_GAMES_TOKEN';
	var FAILURE_FETCH_BETSOLUTIONS_GAMES_TOKEN = exports.FAILURE_FETCH_BETSOLUTIONS_GAMES_TOKEN = 'FAILURE_FETCH_BETSOLUTIONS_GAMES_TOKEN';
	
	var FETCH_VIRTUAL_SPORTS_GAMES_TOKEN = exports.FETCH_VIRTUAL_SPORTS_GAMES_TOKEN = 'FETCH_VIRTUAL_SPORTS_GAMES_TOKEN';
	var SUCCESS_FETCH_VIRTUAL_SPORTS_GAMES_TOKEN = exports.SUCCESS_FETCH_VIRTUAL_SPORTS_GAMES_TOKEN = 'SUCCESS_FETCH_VIRTUAL_SPORTS_GAMES_TOKEN';
	var FAILURE_FETCH_VIRTUAL_SPORTS_GAMES_TOKEN = exports.FAILURE_FETCH_VIRTUAL_SPORTS_GAMES_TOKEN = 'FAILURE_FETCH_VIRTUAL_SPORTS_GAMES_TOKEN';
	
	var FETCH_XPRESS_GAMES = exports.FETCH_XPRESS_GAMES = 'FETCH_XPRESS_GAMES';
	var SUCCESS_FETCH_XPRESS_GAMES = exports.SUCCESS_FETCH_XPRESS_GAMES = 'SUCCESS_FETCH_XPRESS_GAMES';
	var FAILURE_FETCH_XPRESS_GAMES = exports.FAILURE_FETCH_XPRESS_GAMES = 'FAILURE_FETCH_XPRESS_GAMES';
	
	var FETCH_XPRESS_TOKEN = exports.FETCH_XPRESS_TOKEN = 'FETCH_XPRESS_TOKEN';
	var SUCCESS_FETCH_XPRESS_TOKEN = exports.SUCCESS_FETCH_XPRESS_TOKEN = 'SUCCESS_FETCH_XPRESS_TOKEN';
	var FAILURE_FETCH_XPRESS_TOKEN = exports.FAILURE_FETCH_XPRESS_TOKEN = 'FAILURE_FETCH_XPRESS_TOKEN';
	
	var CLEAR_TV_BET_ERROR = exports.CLEAR_TV_BET_ERROR = "CLEAR_TV_BET_ERROR";
	
	var FETCH_PROVIDER_XPRESS_GAMES = exports.FETCH_PROVIDER_XPRESS_GAMES = 'FETCH_PROVIDER_XPRESS_GAMES';
	var SUCCESS_FETCH_PROVIDER_XPRESS_GAMES = exports.SUCCESS_FETCH_PROVIDER_XPRESS_GAMES = 'SUCCESS_FETCH_PROVIDER_XPRESS_GAMES';
	var FAILURE_FETCH_PROVIDER_XPRESS_GAMES = exports.FAILURE_FETCH_PROVIDER_XPRESS_GAMES = 'FAILURE_FETCH_PROVIDER_XPRESS_GAMES';
	
	var FETCH_TYPE_XPRESS_GAMES = exports.FETCH_TYPE_XPRESS_GAMES = 'FETCH_TYPE_XPRESS_GAMES';
	var SUCCESS_FETCH_TYPE_XPRESS_GAMES = exports.SUCCESS_FETCH_TYPE_XPRESS_GAMES = 'SUCCESS_FETCH_TYPE_XPRESS_GAMES';
	var FAILURE_FETCH_TYPE_XPRESS_GAMES = exports.FAILURE_FETCH_TYPE_XPRESS_GAMES = 'FAILURE_FETCH_TYPE_XPRESS_GAMES';
	
	var FETCH_PINNED_XPRESS_GAMES = exports.FETCH_PINNED_XPRESS_GAMES = 'FETCH_PINNED_XPRESS_GAMES';
	var SUCCESS_FETCH_PINNED_XPRESS_GAMES = exports.SUCCESS_FETCH_PINNED_XPRESS_GAMES = 'SUCCESS_FETCH_PINNED_XPRESS_GAMES';
	var FAILURE_FETCH_PINNED_XPRESS_GAMES = exports.FAILURE_FETCH_PINNED_XPRESS_GAMES = 'FAILURE_FETCH_PINNED_XPRESS_GAMES';
	
	var UPDATE_XPRESS_PINNED_GAMES = exports.UPDATE_XPRESS_PINNED_GAMES = "UPDATE_XPRESS_PINNED_GAMES";

/***/ },
/* 742 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GET_JACKTOP_TOKEN = exports.GET_JACKTOP_TOKEN = 'GET_JACKTOP_TOKEN';
	var SUCCESS_GET_JACKTOP_TOKEN = exports.SUCCESS_GET_JACKTOP_TOKEN = 'SUCCESS_GET_JACKTOP_TOKEN';
	var FAILURE_GET_JACKTOP_TOKEN = exports.FAILURE_GET_JACKTOP_TOKEN = 'FAILURE_GET_JACKTOP_TOKEN';

/***/ },
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var INTERNAL_ERROR = exports.INTERNAL_ERROR = 0;
	var INSUFFICIENT_FUNDS = exports.INSUFFICIENT_FUNDS = 1;
	var FACTORS_CHANGED = exports.FACTORS_CHANGED = 2;
	var ACCOUNT_LOCKED = exports.ACCOUNT_LOCKED = 3;
	var SYSTEM_NOT_ALLOWED_FOR_FREEBET = exports.SYSTEM_NOT_ALLOWED_FOR_FREEBET = 4;
	
	var INCORRECT_STAKE = exports.INCORRECT_STAKE = 5;
	var MIN_STAKE_AMOUNT = exports.MIN_STAKE_AMOUNT = 6;
	var INCORRECT_VIRTUAL_STAKE = exports.INCORRECT_VIRTUAL_STAKE = 7;
	var INCORRECT_FREEBET_STAKE = exports.INCORRECT_FREEBET_STAKE = 8;
	var EXISTING_ACTIVE_STAKE = exports.EXISTING_ACTIVE_STAKE = 9;
	var NO_BIG_STAKE_PERMISSION = exports.NO_BIG_STAKE_PERMISSION = 10;
	var FREEBET_BIG_STAKE = exports.FREEBET_BIG_STAKE = 11;
	var ALTERNATIVE_STAKE = exports.ALTERNATIVE_STAKE = 12;
	var NOT_POSSIBLE_STAKE = exports.NOT_POSSIBLE_STAKE = 13;
	
	var PromoCodeErrors = exports.PromoCodeErrors = [-1, -2, -21, -22, -23, -24, -31, -32, -33, -34, -35, -36, -37, -38];

/***/ },
/* 748 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CORRECT = exports.CORRECT = 0;
	var FACTOR_CHANGED = exports.FACTOR_CHANGED = 1;
	var FACTOR_CLOSED = exports.FACTOR_CLOSED = 2;
	var OUTCOME_CLOSED = exports.OUTCOME_CLOSED = 3;
	var EVENT_CLOSED = exports.EVENT_CLOSED = 4;

/***/ },
/* 749 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CANCEL_NOT_POSSIBLE = exports.CANCEL_NOT_POSSIBLE = 1;

/***/ },
/* 750 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ENABLED = exports.ENABLED = 1;
	var DISABLED = exports.DISABLED = 0;

/***/ },
/* 751 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FAST = exports.FAST = 1;
	var REGULAR = exports.REGULAR = 2;

/***/ },
/* 752 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MAIN = exports.MAIN = 1;
	var ADDITIONAL = exports.ADDITIONAL = 2;
	var OVERTIME = exports.OVERTIME = 3;
	var CURRENT_GAME = exports.CURRENT_GAME = 4;
	var FOULS = exports.FOULS = 5;
	var POSSESSION = exports.POSSESSION = 6;
	var INFO = exports.INFO = 7;
	var PERIOD_INFO = exports.PERIOD_INFO = 8;

/***/ },
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getMainScore = getMainScore;
	
	var _ScoreType = __webpack_require__(40);
	
	var ScoreType = _interopRequireWildcard(_ScoreType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function getMainScore(scores) {
	    var mainScoreId = scores.getIn([ScoreType.Match, 'id']);
	    if (mainScoreId) {
	        return mainScoreId;
	    }
	
	    return null;
	}

/***/ },
/* 769 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SORT_BY_TIME = exports.SORT_BY_TIME = 1;
	var SORT_BY_LEAGUE = exports.SORT_BY_LEAGUE = 2;

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(8);
	
	var _Coupon = __webpack_require__(1200);
	
	var _Coupon2 = _interopRequireDefault(_Coupon);
	
	var _BetHistory = __webpack_require__(1190);
	
	var _BetHistory2 = _interopRequireDefault(_BetHistory);
	
	var _CouponDropDownMenu = __webpack_require__(306);
	
	var _CouponDropDownMenu2 = _interopRequireDefault(_CouponDropDownMenu);
	
	var _UnauthUserCouponDropDownMenu = __webpack_require__(1188);
	
	var _UnauthUserCouponDropDownMenu2 = _interopRequireDefault(_UnauthUserCouponDropDownMenu);
	
	var _BettingMode = __webpack_require__(735);
	
	var _AcceptFactorChange = __webpack_require__(333);
	
	var AcceptFactorChangeMode = _interopRequireWildcard(_AcceptFactorChange);
	
	var _reactPerfectScrollbar = __webpack_require__(547);
	
	var _reactPerfectScrollbar2 = _interopRequireDefault(_reactPerfectScrollbar);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    title: {
	        id: 'betpanel.title',
	        defaultMessage: 'Ставки'
	    },
	    help: {
	        id: 'betpanel.help',
	        defaultMessage: 'Кликните на любой исход, чтобы добавить ставку в купон.'
	    }
	});
	
	var BetPanel = function (_React$Component) {
	    (0, _inherits3.default)(BetPanel, _React$Component);
	
	    function BetPanel(props) {
	        (0, _classCallCheck3.default)(this, BetPanel);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (BetPanel.__proto__ || (0, _getPrototypeOf2.default)(BetPanel)).call(this, props));
	
	        _this.onScrollUpdate = function () {
	            _this.refs._scrollBarRef2.updateScroll();
	        };
	
	        _this._onOneClickBetClick = _this._onOneClickBetClick.bind(_this);
	        _this._onAcceptChangeClick = _this._onAcceptChangeClick.bind(_this);
	        _this._onPopupClosing = _this._onPopupClosing.bind(_this);
	        _this._onShowMenuClick = _this._onShowMenuClick.bind(_this);
	
	        _this.state = {
	            popupShown: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(BetPanel, [{
	        key: '_onOneClickBetClick',
	        value: function _onOneClickBetClick(e) {
	            e.preventDefault();
	
	            if (this.props.user) {
	                this.props.toggleOneClickModeAction();
	            }
	        }
	    }, {
	        key: '_onPopupClosing',
	        value: function _onPopupClosing() {
	            this.setState({
	                popupShown: false
	            });
	        }
	    }, {
	        key: '_onShowMenuClick',
	        value: function _onShowMenuClick(e) {
	            e.preventDefault();
	
	            this.setState({
	                popupShown: true
	            });
	        }
	    }, {
	        key: '_onAcceptChangeClick',
	        value: function _onAcceptChangeClick(e) {
	            e.preventDefault();
	
	            if (!this.props.user) {
	                return;
	            }
	
	            var bettingMode = this.props.bettingMode;
	
	            var acceptFactorChangeMode = bettingMode.get('acceptFactorChange');
	
	            var newMode = BetPanel.getNextAcceptFactorChangeMode(acceptFactorChangeMode);
	
	            this.props.setAcceptFactorChangeModeAction(newMode);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                bettingMode = _props.bettingMode,
	                user = _props.user,
	                hasNoBetSlips = _props.hasNoBetSlips;
	
	            var showPopup = this.state.popupShown;
	
	            var isOneClick = bettingMode.get('isOneClick');
	
	            var oneClickCls = 'quick-bet';
	            if (isOneClick) {
	                oneClickCls += ' enabled';
	            }
	
	            var acceptFactorChangeMode = bettingMode.get('acceptFactorChange');
	
	            var acceptChangeCls = 'accept-change-button';
	            if (acceptFactorChangeMode === AcceptFactorChangeMode.BOTH) {
	                acceptChangeCls += ' accept-low-high';
	            } else if (acceptFactorChangeMode === AcceptFactorChangeMode.INCREASE) {
	                acceptChangeCls += ' accept-high';
	            } else if (acceptFactorChangeMode === AcceptFactorChangeMode.DECREASE) {
	                acceptChangeCls += ' accept-low';
	            } else {
	                acceptChangeCls += ' accept-change';
	            }
	
	            var props = {
	                bettingMode: bettingMode,
	                user: user,
	                onClosing: this._onPopupClosing
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'heading coupon-heading top-coupon-heading' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'title' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'dropdown--menu__container' },
	                            _react2.default.createElement('a', { href: '#', className: 'dropdown--toggle', onClick: this._onShowMenuClick }),
	                            user && showPopup && _react2.default.createElement(_CouponDropDownMenu2.default, props),
	                            !user && showPopup && _react2.default.createElement(_UnauthUserCouponDropDownMenu2.default, { onClosing: this._onPopupClosing })
	                        ),
	                        _react2.default.createElement(
	                            _reactIntl.FormattedMessage,
	                            messages.title,
	                            function (label) {
	                                return _react2.default.createElement(
	                                    'label',
	                                    { onClick: _this2._onShowMenuClick },
	                                    label
	                                );
	                            }
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'controls' },
	                        user && _react2.default.createElement('a', { href: '#', className: acceptChangeCls, onClick: this._onAcceptChangeClick }),
	                        user && _react2.default.createElement('a', { href: '#', className: oneClickCls, onClick: this._onOneClickBetClick }),
	                        !user && _react2.default.createElement('a', { href: '#', className: acceptChangeCls, style: { cursor: 'default' } }),
	                        !user && _react2.default.createElement('a', { href: '#', className: oneClickCls, style: { cursor: 'default' } })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { id: 'coupons', className: 'coupon' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'scroll--wrapper', ref: 'couponContainer' },
	                        _react2.default.createElement(
	                            _reactPerfectScrollbar2.default,
	                            { ref: '_scrollBarRef2' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'scroll--wrapper__inner' },
	                                hasNoBetSlips && BetPanel.renderHelpMessage(),
	                                _react2.default.createElement(_Coupon2.default, { onUpdateSize: this.onScrollUpdate }),
	                                user && _react2.default.createElement(_BetHistory2.default, null)
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'getNextAcceptFactorChangeMode',
	        value: function getNextAcceptFactorChangeMode(current) {
	            var newMode = AcceptFactorChangeMode.NONE;
	            if (current === AcceptFactorChangeMode.NONE) {
	                newMode = AcceptFactorChangeMode.DECREASE;
	            } else if (current === AcceptFactorChangeMode.DECREASE) {
	                newMode = AcceptFactorChangeMode.INCREASE;
	            } else if (current === AcceptFactorChangeMode.INCREASE) {
	                newMode = AcceptFactorChangeMode.BOTH;
	            }
	
	            return newMode;
	        }
	    }, {
	        key: 'renderHelpMessage',
	        value: function renderHelpMessage() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'history-menu cf' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'body history-menu-body' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'unauth-user-panel' },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '\xA0'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.help)
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '\xA0'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return BetPanel;
	}(_react2.default.Component);
	
	BetPanel.propTypes = {
	    bettingMode: _react2.default.PropTypes.object.isRequired,
	    languageId: _react2.default.PropTypes.number.isRequired,
	    user: _react2.default.PropTypes.any,
	    hasNoBetSlips: _react2.default.PropTypes.bool.isRequired,
	    toggleOneClickModeAction: _react2.default.PropTypes.func.isRequired,
	    setAcceptFactorChangeModeAction: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select(state) {
	    var bettingMode = state.application.get('bettingMode');
	    var languageId = state.application.get('languageId');
	    var user = state.auth.get('user');
	    var betSlips = state.application.getIn(['coupon', 'betSlips']);
	    var hasNoBetSlips = betSlips === undefined || betSlips.size === 0;
	
	    return {
	        bettingMode: bettingMode,
	        languageId: languageId,
	        user: user,
	        hasNoBetSlips: hasNoBetSlips
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, {
	    toggleOneClickModeAction: _BettingMode.toggleOneClickMode, setAcceptFactorChangeModeAction: _BettingMode.setAcceptFactorChangeMode
	})(BetPanel);

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BetPanel = __webpack_require__(770);
	
	var _BetPanel2 = _interopRequireDefault(_BetPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BetPanel2.default;

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.jacktopConstants = undefined;
	
	var _jacktop_black_jack = __webpack_require__(1683);
	
	var _jacktop_black_jack2 = _interopRequireDefault(_jacktop_black_jack);
	
	var _jacktop_roulette = __webpack_require__(1685);
	
	var _jacktop_roulette2 = _interopRequireDefault(_jacktop_roulette);
	
	var _jacktop_pocker = __webpack_require__(1684);
	
	var _jacktop_pocker2 = _interopRequireDefault(_jacktop_pocker);
	
	var _jacktop_baccarat = __webpack_require__(1682);
	
	var _jacktop_baccarat2 = _interopRequireDefault(_jacktop_baccarat);
	
	var _domainUtils = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CLIENT_ID = _domainUtils.isStage ? 28 : 146;
	var SERVER = _domainUtils.isStage ? 'https://delightful-pebble-058f0fe03-partner.westeurope.1.azurestaticapps.net/init-game?' : 'https://web.jacktop.win/init-game?';
	
	var jacktopConstants = exports.jacktopConstants = {
	  client_id: CLIENT_ID,
	  server: SERVER,
	  games: {
	    black_jack: {
	      id: _domainUtils.isStage ? 100101 : 113601,
	      img: _jacktop_black_jack2.default
	    },
	    roulette: {
	      id: _domainUtils.isStage ? 100302 : 113702,
	      img: _jacktop_roulette2.default
	    },
	    poker: {
	      id: _domainUtils.isStage ? 100403 : 113803,
	      img: _jacktop_pocker2.default
	    },
	    baccarat: {
	      id: _domainUtils.isStage ? 100604 : 113904,
	      img: _jacktop_baccarat2.default
	    }
	  }
	};

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.allSlotsImage = undefined;
	
	var _BetsolutionsZeppelin = __webpack_require__(1723);
	
	var _BetsolutionsZeppelin2 = _interopRequireDefault(_BetsolutionsZeppelin);
	
	var _BetsolutionsPlinko = __webpack_require__(1724);
	
	var _BetsolutionsPlinko2 = _interopRequireDefault(_BetsolutionsPlinko);
	
	var _BetsolutionsHighlow = __webpack_require__(1725);
	
	var _BetsolutionsHighlow2 = _interopRequireDefault(_BetsolutionsHighlow);
	
	var _BetsolutionsDice = __webpack_require__(1726);
	
	var _BetsolutionsDice2 = _interopRequireDefault(_BetsolutionsDice);
	
	var _BetsolutionsMines = __webpack_require__(1727);
	
	var _BetsolutionsMines2 = _interopRequireDefault(_BetsolutionsMines);
	
	var _BetsolutionsWW = __webpack_require__(1728);
	
	var _BetsolutionsWW2 = _interopRequireDefault(_BetsolutionsWW);
	
	var _BetsolutionsCaptainOfPirates = __webpack_require__(1729);
	
	var _BetsolutionsCaptainOfPirates2 = _interopRequireDefault(_BetsolutionsCaptainOfPirates);
	
	var _BetsolutionsTheMysteryOfFaberge = __webpack_require__(1730);
	
	var _BetsolutionsTheMysteryOfFaberge2 = _interopRequireDefault(_BetsolutionsTheMysteryOfFaberge);
	
	var _BetsolutionsBackgammon = __webpack_require__(1731);
	
	var _BetsolutionsBackgammon2 = _interopRequireDefault(_BetsolutionsBackgammon);
	
	var _BetsolutionsOkey = __webpack_require__(1732);
	
	var _BetsolutionsOkey2 = _interopRequireDefault(_BetsolutionsOkey);
	
	var _BetsolutionsBura = __webpack_require__(1733);
	
	var _BetsolutionsBura2 = _interopRequireDefault(_BetsolutionsBura);
	
	var _BetsolutionsDominoes = __webpack_require__(1734);
	
	var _BetsolutionsDominoes2 = _interopRequireDefault(_BetsolutionsDominoes);
	
	var _BetsolutionsSeka = __webpack_require__(1735);
	
	var _BetsolutionsSeka2 = _interopRequireDefault(_BetsolutionsSeka);
	
	var _BetsolutionsPokerRoom = __webpack_require__(1736);
	
	var _BetsolutionsPokerRoom2 = _interopRequireDefault(_BetsolutionsPokerRoom);
	
	var _BetsolutionsUndergroundTuning = __webpack_require__(1737);
	
	var _BetsolutionsUndergroundTuning2 = _interopRequireDefault(_BetsolutionsUndergroundTuning);
	
	var _BetsolutionsNightLife = __webpack_require__(1738);
	
	var _BetsolutionsNightLife2 = _interopRequireDefault(_BetsolutionsNightLife);
	
	var _BetsolutionsLegendOfMaasai = __webpack_require__(1739);
	
	var _BetsolutionsLegendOfMaasai2 = _interopRequireDefault(_BetsolutionsLegendOfMaasai);
	
	var _BetsolutionsBettingShop = __webpack_require__(1740);
	
	var _BetsolutionsBettingShop2 = _interopRequireDefault(_BetsolutionsBettingShop);
	
	var _BetsolutionsDrunkSanta = __webpack_require__(1741);
	
	var _BetsolutionsDrunkSanta2 = _interopRequireDefault(_BetsolutionsDrunkSanta);
	
	var _BetsolutionsSultansGift = __webpack_require__(1742);
	
	var _BetsolutionsSultansGift2 = _interopRequireDefault(_BetsolutionsSultansGift);
	
	var _all = __webpack_require__(1743);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ id: 7001, productId: 3, type: "betsolutions", name: "Zeppelin", img: _BetsolutionsZeppelin2.default }, { id: 7004, productId: 3, type: "betsolutions", name: "Plinko", img: _BetsolutionsPlinko2.default }, { id: 7000, productId: 3, type: "betsolutions", name: "High Low", img: _BetsolutionsHighlow2.default }, { id: 7002, productId: 3, type: "betsolutions", name: "Dice", img: _BetsolutionsDice2.default }, { id: 7003, productId: 3, type: "betsolutions", name: "Mines", img: _BetsolutionsMines2.default }, { id: 9, productId: 2, type: "betsolutions", name: "WW2", img: _BetsolutionsWW2.default }, { id: 2, productId: 2, type: "betsolutions", name: "Captain Of Pirates", img: _BetsolutionsCaptainOfPirates2.default }, { id: 3, productId: 2, type: "betsolutions", name: "The Mystery of Faberge", img: _BetsolutionsTheMysteryOfFaberge2.default }, { id: 5000, productId: 1, type: "betsolutions", name: "Backgammon", img: _BetsolutionsBackgammon2.default }, { id: 5001, productId: 1, type: "betsolutions", name: "Okey", img: _BetsolutionsOkey2.default }, { id: 5002, productId: 1, type: "betsolutions", name: "Bura", img: _BetsolutionsBura2.default }, { id: 5003, productId: 1, type: "betsolutions", name: "Dominoes", img: _BetsolutionsDominoes2.default }, { id: 5004, productId: 1, type: "betsolutions", name: "Seka", img: _BetsolutionsSeka2.default }, { id: 7, productId: 2, type: "betsolutions", name: "Poker Room", img: _BetsolutionsPokerRoom2.default }, { id: 1, productId: 2, type: "betsolutions", name: "Underground Tuning", img: _BetsolutionsUndergroundTuning2.default }, { id: 10, productId: 2, type: "betsolutions", name: "Night Life", img: _BetsolutionsNightLife2.default }, { id: 5, productId: 2, type: "betsolutions", name: "Legend of Maasai", img: _BetsolutionsLegendOfMaasai2.default }, { id: 6, productId: 2, type: "betsolutions", name: "Betting Shop", img: _BetsolutionsBettingShop2.default }, { id: 4, productId: 2, type: "betsolutions", name: "Drunk Santa", img: _BetsolutionsDrunkSanta2.default }, { id: 8, productId: 2, type: "betsolutions", name: "Sultans gift", img: _BetsolutionsSultansGift2.default }];
	var allSlotsImage = exports.allSlotsImage = _all2.default;

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _SlotFamilyType = __webpack_require__(508);
	
	var SlotFamilyType = _interopRequireWildcard(_SlotFamilyType);
	
	var _slotArrangementPolicies = __webpack_require__(1263);
	
	var _slotArrangementPolicies2 = _interopRequireDefault(_slotArrangementPolicies);
	
	var _SingleOutcomeSlot = __webpack_require__(1244);
	
	var _SingleOutcomeSlot2 = _interopRequireDefault(_SingleOutcomeSlot);
	
	var _MultiOutcomeSlot = __webpack_require__(1242);
	
	var _MultiOutcomeSlot2 = _interopRequireDefault(_MultiOutcomeSlot);
	
	var _WideSingleOutcomeSlot = __webpack_require__(1247);
	
	var _WideSingleOutcomeSlot2 = _interopRequireDefault(_WideSingleOutcomeSlot);
	
	var _WideMultiOutcomeSlot = __webpack_require__(1246);
	
	var _WideMultiOutcomeSlot2 = _interopRequireDefault(_WideMultiOutcomeSlot);
	
	var _TotalSlot = __webpack_require__(1245);
	
	var _TotalSlot2 = _interopRequireDefault(_TotalSlot);
	
	var _TennisGameSlot = __webpack_require__(1249);
	
	var _TennisGameSlot2 = _interopRequireDefault(_TennisGameSlot);
	
	var _MatchCorrectScoreOutcomeSlot = __webpack_require__(1248);
	
	var _MatchCorrectScoreOutcomeSlot2 = _interopRequireDefault(_MatchCorrectScoreOutcomeSlot);
	
	var _NamedOutcomeSlot = __webpack_require__(1243);
	
	var _NamedOutcomeSlot2 = _interopRequireDefault(_NamedOutcomeSlot);
	
	var _SlotTypeProvider = __webpack_require__(1261);
	
	var _SlotTypeProvider2 = _interopRequireDefault(_SlotTypeProvider);
	
	var _SlotIdProvider = __webpack_require__(1260);
	
	var _SlotIdProvider2 = _interopRequireDefault(_SlotIdProvider);
	
	var _CustomSlotIdProvider = __webpack_require__(1258);
	
	var _CustomSlotIdProvider2 = _interopRequireDefault(_CustomSlotIdProvider);
	
	var _SlotFamilyProvider = __webpack_require__(1259);
	
	var _SlotFamilyProvider2 = _interopRequireDefault(_SlotFamilyProvider);
	
	var _SlotFactory = __webpack_require__(1253);
	
	var _SlotFactory2 = _interopRequireDefault(_SlotFactory);
	
	var _CustomSlotFactory = __webpack_require__(1252);
	
	var _CustomSlotFactory2 = _interopRequireDefault(_CustomSlotFactory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function sortOutcomes(a, b) {
	    return a.get('condition') > b.get('condition') ? 1 : -1;
	}
	
	var Body = function (_React$Component) {
	    (0, _inherits3.default)(Body, _React$Component);
	    (0, _createClass3.default)(Body, null, [{
	        key: 'getSlots',
	        value: function getSlots(sportId, match, groupType, outcomes, rates) {
	            var slotsMap = null;
	            var slots = null;
	
	            var matchType = match.get('type');
	
	            outcomes.forEach(function (o) {
	                if (o.get('isHeader')) {
	                    return;
	                }
	
	                if (slotsMap === null) {
	                    slotsMap = {};
	                    slots = [];
	                }
	
	                var rate = void 0;
	                if (matchType !== 1) {
	                    rate = o.get('rates').map(function (r) {
	                        return rates.get(r);
	                    }).find(function (r) {
	                        return r.get('type') === 1;
	                    });
	                }
	
	                var slotTypes = (0, _SlotTypeProvider2.default)(sportId, groupType, o.get('type'));
	
	                for (var i = 0; i < slotTypes.length; i++) {
	                    var slotType = slotTypes[i];
	
	                    var slotFamily = (0, _SlotFamilyProvider2.default)(sportId, groupType, slotType);
	
	                    var slotId = void 0;
	
	                    if (matchType !== 1) {
	                        slotId = (0, _CustomSlotIdProvider2.default)(slotType, slotFamily, rate);
	                    } else {
	                        slotId = (0, _SlotIdProvider2.default)(slotType, slotFamily, o);
	                    }
	
	                    var slot = slotsMap[slotId];
	
	                    if (slot === undefined) {
	                        if (matchType !== 1) {
	                            slot = (0, _CustomSlotFactory2.default)(slotId, slotType, slotFamily, rate);
	                        } else {
	                            slot = (0, _SlotFactory2.default)(slotId, slotType, slotFamily, o);
	                        }
	
	                        slotsMap[slotId] = slot;
	                        slot.position = _slotArrangementPolicies2.default.getPosition(sportId, groupType, slot);
	                        slot.sportId = match.get('sportId');
	
	                        var targetIndex = void 0;
	                        for (targetIndex = 0; targetIndex < slots.length; targetIndex++) {
	                            if (Body.comparePositions(slot.position, slots[targetIndex].position) < 0) {
	                                break;
	                            }
	                        }
	
	                        slots.splice(targetIndex, 0, slot);
	                    }
	
	                    slot.outcomes.push(o.get('id'));
	                }
	            });
	
	            return slots;
	        }
	    }, {
	        key: 'comparePositions',
	        value: function comparePositions(position1, position2) {
	            for (var i = 0; i < Math.min(position1.length, position2.length); i++) {
	                if (position1[i] < position2[i]) {
	                    return -1;
	                }
	
	                if (position1[i] > position2[i]) {
	                    return 1;
	                }
	            }
	
	            return 1;
	        }
	    }, {
	        key: 'renderSlot',
	        value: function renderSlot(slot, props) {
	            var outcomes = slot.outcomes.map(function (o) {
	                return props.groupOutcomes.find(function (go) {
	                    return go.get('id') === o;
	                });
	            }).sort(sortOutcomes);
	
	            var slotProps = {
	                slot: slot,
	                section: props.section,
	                sportId: props.sportId,
	                match: props.match,
	                gridLocalization: props.gridLocalization,
	                outcomes: outcomes
	            };
	
	            switch (slot.family) {
	                case SlotFamilyType.SINGLE_OUTCOME:
	                    return _react2.default.createElement(_SingleOutcomeSlot2.default, (0, _extends3.default)({ key: slot.id }, slotProps));
	
	                case SlotFamilyType.MULTI_OUTCOME:
	                    return _react2.default.createElement(_MultiOutcomeSlot2.default, (0, _extends3.default)({ key: slot.id }, slotProps));
	
	                case SlotFamilyType.WIDE_SINGLE_OUTCOME:
	                    return _react2.default.createElement(_WideSingleOutcomeSlot2.default, (0, _extends3.default)({ key: slot.id }, slotProps));
	
	                case SlotFamilyType.WIDE_MULTI_OUTCOME:
	                    return _react2.default.createElement(_WideMultiOutcomeSlot2.default, (0, _extends3.default)({ key: slot.id }, slotProps));
	
	                case SlotFamilyType.TOTAL:
	                    return _react2.default.createElement(_TotalSlot2.default, (0, _extends3.default)({ key: slot.id }, slotProps));
	
	                case SlotFamilyType.TENNIS_GAME:
	                    return _react2.default.createElement(_TennisGameSlot2.default, (0, _extends3.default)({ key: slot.id }, slotProps));
	
	                case SlotFamilyType.SOCCER_MATCH_CORRECT_SCORE:
	                    return _react2.default.createElement(_MatchCorrectScoreOutcomeSlot2.default, (0, _extends3.default)({ key: slot.id }, slotProps));
	
	                //TODO: implement
	                case SlotFamilyType.BASKETBALL_TOTAL_UNDER:
	                    return _react2.default.createElement(
	                        'div',
	                        { key: slot.id },
	                        'BASKETBALL_TOTAL_UNDER'
	                    );
	
	                //TODO: implement
	                case SlotFamilyType.BASKETBALL_TOTAL_OVER:
	                    return _react2.default.createElement(
	                        'div',
	                        { key: slot.id },
	                        'BASKETBALL_TOTAL_OVER'
	                    );
	
	                case SlotFamilyType.NAMED_OUTCOME_SLOT:
	                    return _react2.default.createElement(_NamedOutcomeSlot2.default, (0, _extends3.default)({ key: slot.id }, slotProps));
	
	                default:
	                    console.log('unknown family', slot.family); //eslint-disable-line no-console
	            }
	        }
	    }]);
	
	    function Body(props) {
	        (0, _classCallCheck3.default)(this, Body);
	        return (0, _possibleConstructorReturn3.default)(this, (Body.__proto__ || (0, _getPrototypeOf2.default)(Body)).call(this, props));
	    }
	
	    (0, _createClass3.default)(Body, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return this.props.group !== nextProps.group;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                section = _props.section,
	                sportId = _props.sportId,
	                match = _props.match,
	                group = _props.group,
	                outcomeStore = _props.outcomeStore,
	                rateStore = _props.rateStore,
	                gridLocalization = _props.gridLocalization,
	                nestingLevel = _props.nestingLevel;
	
	            if (group == undefined) {
	                return false;
	            }
	
	            var groupOutcomes = group.get('outcomes').map(function (o) {
	                return outcomeStore.get(o);
	            }).filter(function (o) {
	                return o !== undefined;
	            });
	
	            var slots = Body.getSlots(sportId, match, group.get('type'), groupOutcomes, rateStore);
	
	            if (slots === null) {
	                return false;
	            }
	
	            var cls = 'event-detailed-view level-' + nestingLevel;
	
	            var slotProps = {
	                section: section,
	                sportId: sportId,
	                match: match,
	                groupOutcomes: groupOutcomes,
	                gridLocalization: gridLocalization
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: cls },
	                slots.map(function (s) {
	                    return Body.renderSlot(s, slotProps);
	                })
	            );
	        }
	    }]);
	    return Body;
	}(_react2.default.Component);
	
	Body.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    sportId: _react2.default.PropTypes.number,
	    outcomeStore: _react2.default.PropTypes.object.isRequired,
	    rateStore: _react2.default.PropTypes.object.isRequired,
	    group: _react2.default.PropTypes.object,
	    match: _react2.default.PropTypes.object,
	    gridLocalization: _react2.default.PropTypes.object.isRequired,
	    nestingLevel: _react2.default.PropTypes.number
	};
	
	
	function select(state, props) {
	    var section = props.section,
	        id = props.id,
	        gridLocalization = props.gridLocalization;
	
	    var group = state.application.getIn([section, 'groups', id]);
	
	    var sportId = void 0;
	    var match = void 0;
	
	    if (group !== undefined) {
	        sportId = group.get('realSportId');
	        match = state.application.getIn([section, 'matches', group.get('matchId')]);
	    }
	
	    return {
	        section: section,
	        sportId: sportId,
	        match: match,
	        group: group,
	        outcomeStore: state.application.getIn([section, 'outcomes']),
	        rateStore: state.application.getIn([section, 'rates']),
	        gridLocalization: gridLocalization
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select)(Body);

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _headerOutcomePlaceConfig = __webpack_require__(1825);
	
	var _headerOutcomePlaceConfig2 = _interopRequireDefault(_headerOutcomePlaceConfig);
	
	var _HeaderType = __webpack_require__(1250);
	
	var HeaderType = _interopRequireWildcard(_HeaderType);
	
	var _ResultOutcome = __webpack_require__(1226);
	
	var _ResultOutcome2 = _interopRequireDefault(_ResultOutcome);
	
	var _DoubleOutcome = __webpack_require__(1224);
	
	var _DoubleOutcome2 = _interopRequireDefault(_DoubleOutcome);
	
	var _HandicapOutcome = __webpack_require__(1225);
	
	var _HandicapOutcome2 = _interopRequireDefault(_HandicapOutcome);
	
	var _TotalOutcome = __webpack_require__(1227);
	
	var _TotalOutcome2 = _interopRequireDefault(_TotalOutcome);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainLine = function (_React$Component) {
	    (0, _inherits3.default)(MainLine, _React$Component);
	
	    function MainLine(props) {
	        (0, _classCallCheck3.default)(this, MainLine);
	        return (0, _possibleConstructorReturn3.default)(this, (MainLine.__proto__ || (0, _getPrototypeOf2.default)(MainLine)).call(this, props));
	    }
	
	    (0, _createClass3.default)(MainLine, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return this.props.outcomes !== nextProps.outcomes || this.props.gridLocalization.languageId !== nextProps.gridLocalization.languageId;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                section = _props.section,
	                outcomes = _props.outcomes,
	                outcomesStore = _props.outcomesStore,
	                gridLocalization = _props.gridLocalization;
	
	
	            var resultOutcomeId = null;
	            var doubleOutcomeId = null;
	            var handicapOutcomeId = null;
	            var totalOutcomeId = null;
	
	            if (outcomes !== null) {
	                var headerOutcomes = outcomes.map(function (h) {
	                    var o = outcomesStore.get(h);
	                    if (o.get('isHeader') === true) {
	                        return o;
	                    }
	
	                    return undefined;
	                }).filter(function (h) {
	                    return h !== undefined;
	                });
	
	                for (var i = 0; i < headerOutcomes.size; i++) {
	                    var outcome = headerOutcomes.get(i);
	                    var outcomeId = outcome.get('id');
	
	                    var headerOutcomePlace = _headerOutcomePlaceConfig2.default[outcome.get('type')];
	
	                    switch (headerOutcomePlace) {
	                        case HeaderType.RESULT:
	                            resultOutcomeId = outcomeId;
	                            break;
	
	                        case HeaderType.DOUBLE:
	                            doubleOutcomeId = outcomeId;
	                            break;
	
	                        case HeaderType.HANDICAP:
	                            handicapOutcomeId = outcomeId;
	                            break;
	
	                        case HeaderType.TOTAL:
	                            totalOutcomeId = outcomeId;
	                            break;
	                    }
	                }
	            }
	
	            var props = {
	                section: section,
	                gridLocalization: gridLocalization
	            };
	
	            return _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_ResultOutcome2.default, (0, _extends3.default)({ id: resultOutcomeId }, props)),
	                _react2.default.createElement(_DoubleOutcome2.default, (0, _extends3.default)({ id: doubleOutcomeId }, props)),
	                _react2.default.createElement(_HandicapOutcome2.default, (0, _extends3.default)({ id: handicapOutcomeId }, props)),
	                _react2.default.createElement(_TotalOutcome2.default, (0, _extends3.default)({ id: totalOutcomeId }, props))
	            );
	        }
	    }]);
	    return MainLine;
	}(_react2.default.Component);
	
	MainLine.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    outcomes: _react2.default.PropTypes.object,
	    outcomesStore: _react2.default.PropTypes.object.isRequired,
	    gridLocalization: _react2.default.PropTypes.object.isRequired
	};
	
	
	function select(state, props) {
	    var section = props.section,
	        id = props.id,
	        gridLocalization = props.gridLocalization;
	
	    var group = state.application.getIn([section, 'groups', id]);
	
	    var outcomes = null;
	    if (group !== undefined) {
	        outcomes = group.get('outcomes');
	    }
	
	    return {
	        section: section,
	        gridLocalization: gridLocalization,
	        outcomes: outcomes,
	        outcomesStore: state.application.getIn([section, 'outcomes'])
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, null, null, false)(MainLine);

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _ScoreType = __webpack_require__(40);
	
	var ScoreType = _interopRequireWildcard(_ScoreType);
	
	var _MatchScore = __webpack_require__(752);
	
	var MatchScoreType = _interopRequireWildcard(_MatchScore);
	
	var _MatchScoresAdapter = __webpack_require__(1215);
	
	var _MatchScoresAdapter2 = _interopRequireDefault(_MatchScoresAdapter);
	
	var _FlashScore = __webpack_require__(1228);
	
	var _FlashScore2 = _interopRequireDefault(_FlashScore);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchScores = function (_React$Component) {
	    (0, _inherits3.default)(MatchScores, _React$Component);
	
	    function MatchScores() {
	        (0, _classCallCheck3.default)(this, MatchScores);
	        return (0, _possibleConstructorReturn3.default)(this, (MatchScores.__proto__ || (0, _getPrototypeOf2.default)(MatchScores)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(MatchScores, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return this.props.gridLocalization.languageId !== nextProps.gridLocalization.languageId || this.props.groupScores !== nextProps.groupScores;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                groupId = _props.groupId,
	                groupScores = _props.groupScores,
	                gridLocalization = _props.gridLocalization;
	
	
	            if (groupScores === undefined || groupScores.length === 0) {
	                return false;
	            }
	
	            var scoreString = '';
	            for (var i = 0; i < groupScores.length; i++) {
	                var matchScore = groupScores[i];
	
	                switch (matchScore.type) {
	                    case MatchScoreType.MAIN:
	                        if (scoreString.length > 0) {
	                            scoreString += ' ';
	                        }
	                        if (matchScore.possession !== undefined) {
	                            scoreString += MatchScores.renderScoreWithPossession(matchScore.value, matchScore.possession);
	                        } else if (matchScore.powerplay !== undefined) {
	                            scoreString += MatchScores.renderScoreWithPowerPlay(matchScore.value, matchScore.powerplay);
	                        } else {
	                            scoreString += MatchScores.renderScore(matchScore.value);
	                        }
	                        break;
	                    case MatchScoreType.INFO:
	                        if (scoreString.length > 0) {
	                            scoreString += ' ';
	                        }
	                        scoreString += gridLocalization.getMatchInfoText(matchScore.value);
	                        break;
	                    case MatchScoreType.PERIOD_INFO:
	                        if (scoreString.length > 0) {
	                            scoreString += ' ';
	                        }
	                        scoreString += gridLocalization.getPeriodName(matchScore.sportId, matchScore.periodId);
	                        break;
	                    case MatchScoreType.ADDITIONAL:
	                        scoreString += ' (';
	                        matchScore.value.forEach(function (m) {
	                            return scoreString += MatchScores.renderScore(m) + ' ';
	                        });
	                        scoreString = scoreString.trim();
	                        scoreString += ')';
	                        break;
	                    case MatchScoreType.CURRENT_GAME:
	                        scoreString += ' ' + MatchScores.renderScore(matchScore.value);
	                        break;
	                    case MatchScoreType.OVERTIME:
	                        scoreString += ' (' + MatchScores.renderScore(matchScore.value) + ')';
	                        break;
	                    case MatchScoreType.FOULS:
	                        {
	                            var foulsText = gridLocalization.getFoulsText();
	                            scoreString += ' ' + MatchScores.renderFoulsScore(matchScore.value, foulsText);
	                        }
	                }
	            }
	
	            return _react2.default.createElement(_FlashScore2.default, { key: groupId, scoreString: scoreString, languageId: gridLocalization.languageId });
	        }
	    }], [{
	        key: 'renderScore',
	        value: function renderScore(score) {
	            var scoreType = score.get('type');
	
	            if (scoreType === ScoreType.CurrentGame) {
	                return MatchScores.renderTennisGameScore(score);
	            }
	
	            return MatchScores.renderRegularScore(score);
	        }
	    }, {
	        key: 'renderFoulsScore',
	        value: function renderFoulsScore(score, foulsText) {
	            var score1 = score.get('score1') || 0;
	            var score2 = score.get('score2') || 0;
	
	            return foulsText + ' ' + score1 + ':' + score2;
	        }
	    }, {
	        key: 'renderRegularScore',
	        value: function renderRegularScore(score) {
	            var score1 = score.get('score1') || 0;
	            var score2 = score.get('score2') || 0;
	
	            return score1 + ':' + score2;
	        }
	    }, {
	        key: 'renderScoreWithPossession',
	        value: function renderScoreWithPossession(score, possession) {
	            var score1 = score.get('score1') || 0;
	            var score2 = score.get('score2') || 0;
	
	            if (possession === 1) {
	                return '*' + score1 + ':' + score2;
	            } else if (possession === 2) {
	                return score1 + ':' + score2 + '*';
	            }
	
	            return score1 + ':' + score2;
	        }
	    }, {
	        key: 'renderScoreWithPowerPlay',
	        value: function renderScoreWithPowerPlay(score, powerplay) {
	            var score1 = score.get('score1') || 0;
	            var score2 = score.get('score2') || 0;
	
	            if (powerplay === 1) {
	                return 'PP ' + score1 + ':' + score2;
	            } else if (powerplay === 2) {
	                return score1 + ':' + score2 + ' PP';
	            }
	
	            return score1 + ':' + score2;
	        }
	    }, {
	        key: 'renderTennisGameScore',
	        value: function renderTennisGameScore(score) {
	            var team = score.get('team');
	            var score1 = score.get('score1') || 0;
	            var score2 = score.get('score2') || 0;
	
	            score1 = score1 === 100 ? 'A' : score1;
	            score2 = score2 === 100 ? 'A' : score2;
	
	            var result = score1 + ':' + score2;
	
	            if (team !== null) {
	
	                if (team === 1) {
	                    result = '*' + result;
	                } else if (team === 2) {
	                    result = result + '*';
	                }
	            }
	
	            return result;
	        }
	    }]);
	    return MatchScores;
	}(_react2.default.Component);
	
	MatchScores.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    groupId: _react2.default.PropTypes.number,
	    gridLocalization: _react2.default.PropTypes.object.isRequired,
	    groupScores: _react2.default.PropTypes.array
	};
	
	
	function select(state, props) {
	    var section = props.section,
	        matchId = props.matchId,
	        groupId = props.groupId,
	        gridLocalization = props.gridLocalization;
	
	    var match = state.application.getIn([section, 'matches', matchId]);
	    var group = state.application.getIn([section, 'groups', groupId]);
	    var scores = state.application.getIn([section, 'scores']);
	
	    var groupScores = void 0;
	    var groupTypeId = group ? group.get('type') : 0;
	
	    if (match) {
	        groupScores = _MatchScoresAdapter2.default.getGroupScores(match, groupTypeId, scores);
	    }
	
	    return {
	        groupId: groupId,
	        groupScores: groupScores,
	        gridLocalization: gridLocalization
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, null, null, false)(MatchScores);

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RegularRate = __webpack_require__(507);
	
	var _RegularRate2 = _interopRequireDefault(_RegularRate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MultiOutcome = function MultiOutcome(_ref) {
	    var section = _ref.section,
	        outcome = _ref.outcome,
	        gridLocalization = _ref.gridLocalization;
	
	    var outcomeRates = [];
	
	    outcome.get('rates').entrySeq().sortBy(function (r) {
	        return r[0];
	    }).forEach(function (r) {
	        outcomeRates.push(r[1]);
	    });
	
	    var props = {
	        section: section,
	        gridLocalization: gridLocalization
	    };
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'rates' },
	        outcomeRates.map(function (r) {
	            return _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: r, id: r }, props));
	        })
	    );
	};
	
	MultiOutcome.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    outcome: _react2.default.PropTypes.object.isRequired,
	    gridLocalization: _react2.default.PropTypes.object.isRequired
	};
	
	exports.default = MultiOutcome;

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _DisplayMode = __webpack_require__(78);
	
	var DisplayMode = _interopRequireWildcard(_DisplayMode);
	
	var _Expand = __webpack_require__(956);
	
	var _Collapse = __webpack_require__(955);
	
	var _Line = __webpack_require__(562);
	
	var _SetDisplayMode = __webpack_require__(563);
	
	var _UserSelection = __webpack_require__(489);
	
	var _Grid = __webpack_require__(1216);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchDisplayMode(props) {
	    var defaultDisplayMode = { type: DisplayMode.ALL };
	
	    if (props.gridSelection === undefined || !props.gridSelection) {
	        return defaultDisplayMode;
	    }
	
	    var newDisplayMode = void 0;
	    var section = props.section;
	    var displayModeAttr = props.gridSelection.getIn([section, 'lastShown']);
	
	    if (!displayModeAttr) {
	        newDisplayMode = defaultDisplayMode;
	    } else {
	        if (displayModeAttr.has('sportId')) {
	            newDisplayMode = { type: DisplayMode.SPORT, id: displayModeAttr.get('sportId') };
	        }
	
	        if (displayModeAttr.has('leagueId')) {
	            newDisplayMode = { type: DisplayMode.LEAGUE, id: displayModeAttr.get('leagueId') };
	        }
	    }
	
	    return newDisplayMode;
	}
	
	var LocalizedGrid = function (_React$Component) {
	    (0, _inherits3.default)(LocalizedGrid, _React$Component);
	
	    function LocalizedGrid(props) {
	        (0, _classCallCheck3.default)(this, LocalizedGrid);
	        return (0, _possibleConstructorReturn3.default)(this, (LocalizedGrid.__proto__ || (0, _getPrototypeOf2.default)(LocalizedGrid)).call(this, props));
	    }
	
	    (0, _createClass3.default)(LocalizedGrid, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var displayMode = this.props.displayMode;
	
	
	            if (displayMode.type == DisplayMode.TIMETABLE) {
	                this.props.setDisplayModeAction(fetchDisplayMode(this.props));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                section = _props.section,
	                matchId = _props.matchId,
	                gridSelection = _props.gridSelection,
	                gridLocalization = _props.gridLocalization,
	                sportId = _props.sportId;
	
	
	            var expandAllMatchesAction = this.props.expandAllMatches;
	            var expandAllGroupsAction = this.props.expandAllGroups;
	            var collapseAllMatchesAction = this.props.collapseAllMatches;
	            var collapseAllGroupsAction = this.props.collapseAllGroups;
	            var showLineNumbersAction = this.props.showLineNumbers;
	            var hideLineNumbersAction = this.props.hideLineNumbers;
	            var toggleMatchLiveAction = this.props.toggleMatchLiveAction;
	            var toggleMatchPrematchAction = this.props.toggleMatchPrematchAction;
	
	            var selectionToggleMatchAction = section === 'live' ? toggleMatchLiveAction : toggleMatchPrematchAction;
	            var gridSelectionSection = section === 'live' ? gridSelection.get('live') : gridSelection.get('preMatch');
	
	            return _react2.default.createElement(_Grid2.default, { section: section,
	                gridLocalization: gridLocalization,
	                expandAllMatchesAction: expandAllMatchesAction,
	                expandAllGroupsAction: expandAllGroupsAction,
	                collapseAllMatchesAction: collapseAllMatchesAction,
	                collapseAllGroupsAction: collapseAllGroupsAction,
	                showLineNumbersAction: showLineNumbersAction,
	                hideLineNumbersAction: hideLineNumbersAction,
	                selectionToggleMatchAction: selectionToggleMatchAction,
	                gridSelection: gridSelectionSection,
	                matchId: matchId,
	                currentPage: this.props.currentPage,
	                perPage: this.props.perPage,
	                changeFilter: this.props.changeFilter,
	                sportId: sportId
	            });
	        }
	    }]);
	    return LocalizedGrid;
	}(_react2.default.Component);
	
	LocalizedGrid.propTypes = {
	    section: _react.PropTypes.string.isRequired,
	    languageId: _react2.default.PropTypes.number.isRequired,
	    displayMode: _react2.default.PropTypes.object.isRequired,
	    matchId: _react.PropTypes.any,
	    gridSelection: _react2.default.PropTypes.object.isRequired,
	    gridLocalization: _react2.default.PropTypes.object.isRequired,
	    setDisplayModeAction: _react2.default.PropTypes.func.isRequired,
	    toggleMatchLiveAction: _react2.default.PropTypes.func.isRequired,
	    toggleMatchPrematchAction: _react2.default.PropTypes.func.isRequired,
	    expandAllMatches: _react2.default.PropTypes.func.isRequired,
	    expandAllGroups: _react2.default.PropTypes.func.isRequired,
	    collapseAllMatches: _react2.default.PropTypes.func.isRequired,
	    collapseAllGroups: _react2.default.PropTypes.func.isRequired,
	    showLineNumbers: _react2.default.PropTypes.func.isRequired,
	    hideLineNumbers: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select(state, props) {
	    return (0, _extends3.default)({}, props, {
	        languageId: state.application.get('languageId'),
	        displayMode: state.application.get('displayMode'),
	        gridSelection: state.application.get('userGridSelection')
	    });
	}
	
	exports.default = (0, _reactRedux.connect)(select, {
	    setDisplayModeAction: _SetDisplayMode.setDisplayMode,
	    toggleMatchLiveAction: _UserSelection.toggleMatchLive,
	    toggleMatchPrematchAction: _UserSelection.toggleMatchPrematch,
	    expandAllMatches: _Expand.expandAllMatches,
	    expandAllGroups: _Expand.expandAllGroups,
	    collapseAllMatches: _Collapse.collapseAllMatches,
	    collapseAllGroups: _Collapse.collapseAllGroups,
	    showLineNumbers: _Line.showLineNumbers,
	    hideLineNumbers: _Line.hideLineNumbers
	})(LocalizedGrid);

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = slotTypePositionCalculator;
	
	var _slotPositionsConfig = __webpack_require__(1828);
	
	var _slotPositionsConfig2 = _interopRequireDefault(_slotPositionsConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TOO_BIG_POSITION = 1000000000;
	
	function slotTypePositionCalculator(sportId, groupType, slot) {
	    var slotType = slot.type;
	
	    //slotType => position
	    var slotPositions = _slotPositionsConfig2.default[sportId][groupType];
	
	    if (slotPositions == undefined) {
	        return TOO_BIG_POSITION;
	    }
	
	    return slotPositions[slotType] * 10000 || TOO_BIG_POSITION;
	}

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var BADMINTON_PERIOD_MAP = {};
	BADMINTON_PERIOD_MAP[3200] = Period.NOT_STARTED;
	BADMINTON_PERIOD_MAP[3201] = Period.FIRST;
	BADMINTON_PERIOD_MAP[3202] = Period.SECOND;
	BADMINTON_PERIOD_MAP[3203] = Period.THIRD;
	BADMINTON_PERIOD_MAP[3204] = Period.FINISHED;
	
	exports.default = BADMINTON_PERIOD_MAP;

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var BANDY_PERIOD_MAP = {};
	BANDY_PERIOD_MAP[3500] = Period.NOT_STARTED;
	BANDY_PERIOD_MAP[3501] = Period.FIRST;
	BANDY_PERIOD_MAP[3502] = Period.FIRST_BREAK;
	BANDY_PERIOD_MAP[3503] = Period.SECOND;
	BANDY_PERIOD_MAP[3504] = Period.FINISHED;
	
	exports.default = BANDY_PERIOD_MAP;

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var BASKETBALL_PERIOD_MAP = {};
	BASKETBALL_PERIOD_MAP[3100] = Period.NOT_STARTED;
	BASKETBALL_PERIOD_MAP[3101] = Period.FIRST;
	BASKETBALL_PERIOD_MAP[3102] = Period.FIRST_BREAK;
	BASKETBALL_PERIOD_MAP[3103] = Period.SECOND;
	BASKETBALL_PERIOD_MAP[3104] = Period.SECOND_BREAK;
	BASKETBALL_PERIOD_MAP[3105] = Period.THIRD;
	BASKETBALL_PERIOD_MAP[3106] = Period.THIRD_BREAK;
	BASKETBALL_PERIOD_MAP[3107] = Period.FOURTH;
	BASKETBALL_PERIOD_MAP[3108] = Period.FOURTH_BREAK;
	BASKETBALL_PERIOD_MAP[3109] = Period.OVERTIME;
	BASKETBALL_PERIOD_MAP[3110] = Period.FINISHED;
	
	exports.default = BASKETBALL_PERIOD_MAP;

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var BASKETBALL_NCAA_PERIOD_MAP = {};
	BASKETBALL_NCAA_PERIOD_MAP[4100] = Period.NOT_STARTED;
	BASKETBALL_NCAA_PERIOD_MAP[4101] = Period.FIRST;
	BASKETBALL_NCAA_PERIOD_MAP[4102] = Period.FIRST_BREAK;
	BASKETBALL_NCAA_PERIOD_MAP[4103] = Period.SECOND;
	BASKETBALL_NCAA_PERIOD_MAP[4104] = Period.SECOND_BREAK;
	BASKETBALL_NCAA_PERIOD_MAP[4105] = Period.OVERTIME;
	BASKETBALL_NCAA_PERIOD_MAP[4106] = Period.FINISHED;
	
	exports.default = BASKETBALL_NCAA_PERIOD_MAP;

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var BEACH_VOLLEYBALL_PERIOD_MAP = {};
	BEACH_VOLLEYBALL_PERIOD_MAP[300] = Period.NOT_STARTED;
	BEACH_VOLLEYBALL_PERIOD_MAP[301] = Period.FIRST;
	BEACH_VOLLEYBALL_PERIOD_MAP[302] = Period.SECOND;
	BEACH_VOLLEYBALL_PERIOD_MAP[303] = Period.THIRD;
	BEACH_VOLLEYBALL_PERIOD_MAP[304] = Period.FINISHED;
	
	exports.default = BEACH_VOLLEYBALL_PERIOD_MAP;

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var BIATHLON_PERIOD_MAP = {};
	
	BIATHLON_PERIOD_MAP[2000] = Period.NOT_STARTED;
	BIATHLON_PERIOD_MAP[2002] = Period.LAP_FIRST;
	BIATHLON_PERIOD_MAP[2004] = Period.LAP_SECOND;
	BIATHLON_PERIOD_MAP[2006] = Period.LAP_THIRD;
	BIATHLON_PERIOD_MAP[2008] = Period.LAP_FOURTH;
	BIATHLON_PERIOD_MAP[2010] = Period.LAP_FIFTH;
	BIATHLON_PERIOD_MAP[2012] = Period.LAP_SIXTH;
	BIATHLON_PERIOD_MAP[2014] = Period.LAP_SEVENTH;
	BIATHLON_PERIOD_MAP[2016] = Period.LAP_EIGHTH;
	BIATHLON_PERIOD_MAP[2017] = Period.FINISHED;
	
	exports.default = BIATHLON_PERIOD_MAP;

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var BOXING_PERIOD_MAP = {};
	BOXING_PERIOD_MAP[500] = Period.NOT_STARTED;
	BOXING_PERIOD_MAP[501] = Period.ROUND_FIRST;
	BOXING_PERIOD_MAP[502] = Period.ROUND_SECOND;
	BOXING_PERIOD_MAP[503] = Period.ROUND_THIRD;
	BOXING_PERIOD_MAP[504] = Period.ROUND_FOURTH;
	BOXING_PERIOD_MAP[505] = Period.ROUND_FIFTH;
	BOXING_PERIOD_MAP[506] = Period.ROUND_SIXTH;
	BOXING_PERIOD_MAP[507] = Period.ROUND_SEVENTH;
	BOXING_PERIOD_MAP[508] = Period.ROUND_EIGHTH;
	BOXING_PERIOD_MAP[509] = Period.ROUND_NINTH;
	BOXING_PERIOD_MAP[510] = Period.ROUND_TENTH;
	BOXING_PERIOD_MAP[511] = Period.ROUND_ELEVENTH;
	BOXING_PERIOD_MAP[512] = Period.ROUND_TWELFTH;
	BOXING_PERIOD_MAP[513] = Period.FINISHED;
	
	exports.default = BOXING_PERIOD_MAP;

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var CYBERSPORTDOTA2_PERIOD_MAP = {};
	CYBERSPORTDOTA2_PERIOD_MAP[4200] = Period.NOT_STARTED;
	CYBERSPORTDOTA2_PERIOD_MAP[4201] = Period.FIRST;
	CYBERSPORTDOTA2_PERIOD_MAP[4202] = Period.SECOND;
	CYBERSPORTDOTA2_PERIOD_MAP[4203] = Period.THIRD;
	CYBERSPORTDOTA2_PERIOD_MAP[4204] = Period.FOURTH;
	CYBERSPORTDOTA2_PERIOD_MAP[4205] = Period.FIFTH;
	CYBERSPORTDOTA2_PERIOD_MAP[4206] = Period.FINISHED;
	
	exports.default = CYBERSPORTDOTA2_PERIOD_MAP;

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var FOOTBALL_PERIOD_MAP = {};
	FOOTBALL_PERIOD_MAP[700] = Period.NOT_STARTED;
	FOOTBALL_PERIOD_MAP[701] = Period.FIRST;
	FOOTBALL_PERIOD_MAP[702] = Period.FIRST_BREAK;
	FOOTBALL_PERIOD_MAP[703] = Period.SECOND;
	FOOTBALL_PERIOD_MAP[704] = Period.FULL_TIME;
	FOOTBALL_PERIOD_MAP[705] = Period.FIRST_EXTRA;
	FOOTBALL_PERIOD_MAP[706] = Period.FIRST_EXTRA_BREAK;
	FOOTBALL_PERIOD_MAP[707] = Period.SECOND_EXTRA;
	FOOTBALL_PERIOD_MAP[708] = Period.SECOND_EXTRA_BREAK;
	FOOTBALL_PERIOD_MAP[709] = Period.PENALTIES;
	FOOTBALL_PERIOD_MAP[710] = Period.FINISHED;
	
	exports.default = FOOTBALL_PERIOD_MAP;

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var HANDBALL_PERIOD_MAP = {};
	HANDBALL_PERIOD_MAP[1900] = Period.NOT_STARTED;
	HANDBALL_PERIOD_MAP[1901] = Period.FIRST;
	HANDBALL_PERIOD_MAP[1902] = Period.FIRST_BREAK;
	HANDBALL_PERIOD_MAP[1903] = Period.SECOND;
	HANDBALL_PERIOD_MAP[1904] = Period.FULL_TIME;
	HANDBALL_PERIOD_MAP[1905] = Period.FINISHED;
	
	exports.default = HANDBALL_PERIOD_MAP;

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var ICE_HOCKEY_PERIOD_MAP = {};
	ICE_HOCKEY_PERIOD_MAP[3000] = Period.NOT_STARTED;
	ICE_HOCKEY_PERIOD_MAP[3001] = Period.FIRST;
	ICE_HOCKEY_PERIOD_MAP[3002] = Period.FIRST_BREAK;
	ICE_HOCKEY_PERIOD_MAP[3003] = Period.SECOND;
	ICE_HOCKEY_PERIOD_MAP[3004] = Period.SECOND_BREAK;
	ICE_HOCKEY_PERIOD_MAP[3005] = Period.THIRD;
	ICE_HOCKEY_PERIOD_MAP[3006] = Period.FULL_TIME;
	ICE_HOCKEY_PERIOD_MAP[3007] = Period.OVERTIME;
	ICE_HOCKEY_PERIOD_MAP[3008] = Period.OVERTIME_FINISHED;
	ICE_HOCKEY_PERIOD_MAP[3009] = Period.PENALTIES;
	ICE_HOCKEY_PERIOD_MAP[3010] = Period.FINISHED;
	
	exports.default = ICE_HOCKEY_PERIOD_MAP;

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var TABLE_TENNIS_PERIOD_MAP = {};
	TABLE_TENNIS_PERIOD_MAP[200] = Period.NOT_STARTED;
	TABLE_TENNIS_PERIOD_MAP[201] = Period.FIRST;
	TABLE_TENNIS_PERIOD_MAP[202] = Period.SECOND;
	TABLE_TENNIS_PERIOD_MAP[203] = Period.THIRD;
	TABLE_TENNIS_PERIOD_MAP[204] = Period.FOURTH;
	TABLE_TENNIS_PERIOD_MAP[205] = Period.FIFTH;
	TABLE_TENNIS_PERIOD_MAP[206] = Period.SIXTH;
	TABLE_TENNIS_PERIOD_MAP[207] = Period.SEVENTH;
	TABLE_TENNIS_PERIOD_MAP[208] = Period.FINISHED;
	
	exports.default = TABLE_TENNIS_PERIOD_MAP;

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var TENNIS_PERIOD_MAP = {};
	TENNIS_PERIOD_MAP[600] = Period.NOT_STARTED;
	TENNIS_PERIOD_MAP[601] = Period.FIRST;
	TENNIS_PERIOD_MAP[602] = Period.SECOND;
	TENNIS_PERIOD_MAP[603] = Period.THIRD;
	TENNIS_PERIOD_MAP[604] = Period.FOURTH;
	TENNIS_PERIOD_MAP[605] = Period.FIFTH;
	TENNIS_PERIOD_MAP[606] = Period.FINISHED;
	
	exports.default = TENNIS_PERIOD_MAP;

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var VOLLEYBALL_PERIOD_MAP = {};
	VOLLEYBALL_PERIOD_MAP[400] = Period.NOT_STARTED;
	VOLLEYBALL_PERIOD_MAP[401] = Period.FIRST;
	VOLLEYBALL_PERIOD_MAP[402] = Period.SECOND;
	VOLLEYBALL_PERIOD_MAP[403] = Period.THIRD;
	VOLLEYBALL_PERIOD_MAP[404] = Period.FOURTH;
	VOLLEYBALL_PERIOD_MAP[405] = Period.FIFTH;
	VOLLEYBALL_PERIOD_MAP[406] = Period.FINISHED;
	VOLLEYBALL_PERIOD_MAP[407] = Period.SIXTH;
	
	exports.default = VOLLEYBALL_PERIOD_MAP;

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var WATERPOLO_PERIOD_MAP = {};
	WATERPOLO_PERIOD_MAP[800] = Period.NOT_STARTED;
	WATERPOLO_PERIOD_MAP[801] = Period.FIRST;
	WATERPOLO_PERIOD_MAP[802] = Period.FIRST_BREAK;
	WATERPOLO_PERIOD_MAP[803] = Period.SECOND;
	WATERPOLO_PERIOD_MAP[804] = Period.SECOND_BREAK;
	WATERPOLO_PERIOD_MAP[805] = Period.THIRD;
	WATERPOLO_PERIOD_MAP[806] = Period.THIRD_BREAK;
	WATERPOLO_PERIOD_MAP[807] = Period.FOURTH;
	WATERPOLO_PERIOD_MAP[808] = Period.FOURTH_BREAK;
	WATERPOLO_PERIOD_MAP[809] = Period.OVERTIME;
	WATERPOLO_PERIOD_MAP[810] = Period.FINISHED;
	
	exports.default = WATERPOLO_PERIOD_MAP;

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var WHATWHEREWHEN_PERIOD_MAP = {};
	WHATWHEREWHEN_PERIOD_MAP[2800] = Period.NOT_STARTED;
	WHATWHEREWHEN_PERIOD_MAP[2801] = Period.FIRST;
	WHATWHEREWHEN_PERIOD_MAP[2802] = Period.FINISHED;
	
	exports.default = WHATWHEREWHEN_PERIOD_MAP;

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FavouriteState = __webpack_require__(79);
	
	var FavouriteState = _interopRequireWildcard(_FavouriteState);
	
	var _DisplayMode = __webpack_require__(78);
	
	var DisplayMode = _interopRequireWildcard(_DisplayMode);
	
	var _Sorting = __webpack_require__(136);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var League = function (_React$Component) {
	    (0, _inherits3.default)(League, _React$Component);
	
	    function League(props) {
	        (0, _classCallCheck3.default)(this, League);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (League.__proto__ || (0, _getPrototypeOf2.default)(League)).call(this, props));
	
	        _this.state = { closed: true };
	
	        _this._onFavouriteClick = _this._onFavouriteClick.bind(_this);
	        _this._onClick = _this._onClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(League, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                league = _props.league,
	                gridSelection = _props.gridSelection;
	
	
	            if (this.props.isLive && gridSelection.get('leaguesExpanded').includes(league.get('id'))) {
	                this.setState({ closed: false });
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var league = nextProps.league,
	                gridSelection = nextProps.gridSelection,
	                isLive = nextProps.isLive;
	
	
	            if (league) {
	                if (isLive && gridSelection.get('leaguesExpanded').includes(league.get('id'))) {
	                    this.setState({ closed: false });
	                }
	            }
	        }
	    }, {
	        key: '_onLeagueClick',
	        value: function _onLeagueClick(sportId, id, e) {
	            e.preventDefault();
	
	            var _props2 = this.props,
	                leagueClickCallback = _props2.leagueClickCallback,
	                selectionToggleLeagueCallback = _props2.selectionToggleLeagueCallback;
	
	
	            leagueClickCallback(sportId, id);
	
	            if (selectionToggleLeagueCallback) {
	                selectionToggleLeagueCallback({ id: id, sportId: sportId, showMatches: true });
	            }
	        }
	    }, {
	        key: '_onFavouriteClick',
	        value: function _onFavouriteClick(e) {
	            e.preventDefault();
	            this.props.leagueFavouriteClickCallback(this.props.league);
	        }
	    }, {
	        key: '_onClick',
	        value: function _onClick(e) {
	            e.preventDefault();
	            this.setState({ closed: !this.state.closed });
	
	            var _props3 = this.props,
	                league = _props3.league,
	                selectionToggleLeagueCallback = _props3.selectionToggleLeagueCallback;
	
	
	            if (selectionToggleLeagueCallback) {
	                selectionToggleLeagueCallback({ id: league.get('id'), sportId: league.get('sportId'), showMatches: false });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props4 = this.props,
	                showMatches = _props4.showMatches,
	                showBookmarks = _props4.showBookmarks,
	                displayMode = _props4.displayMode,
	                league = _props4.league;
	
	
	            if (league === undefined) {
	                return false;
	            }
	
	            var isClosed = this.state.closed;
	
	            var isSelected = displayMode.type === DisplayMode.LEAGUE && displayMode.id == league.get('id');
	
	            var cls = 'league cf' + (isClosed ? ' closed' : '') + (isSelected ? ' selected' : '');
	
	            var matches = showMatches === true ? league.get('matches').map(function (id) {
	                return _this2.props.matches.get(id);
	            }).sort(_Sorting.matchSortFunc) : undefined;
	
	            var favouritesCls = 'favourites';
	
	            var favouriteState = league.get('favouriteState');
	
	            if (favouriteState === FavouriteState.FULL) {
	                favouritesCls += ' added';
	            } else if (favouriteState === FavouriteState.PARTIAL) {
	                favouritesCls += ' semi';
	            }
	
	            var boundLeagueClick = this._onLeagueClick.bind(this, league.get('sportId'), league.get('id'));
	
	            return _react2.default.createElement(
	                'div',
	                { className: cls },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'league-title' },
	                    showMatches && _react2.default.createElement(
	                        'a',
	                        { href: '#', className: 'league-expand', onClick: this._onClick },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#', className: 'league-name', onClick: boundLeagueClick },
	                        league.get('name')
	                    ),
	                    showBookmarks && _react2.default.createElement(
	                        'a',
	                        { href: '#', className: favouritesCls, onClick: this._onFavouriteClick },
	                        '\xA0'
	                    )
	                ),
	                showMatches && !isClosed && _react2.default.createElement(
	                    'ul',
	                    { className: 'events-list' },
	                    matches.map(function (m) {
	                        return League.renderMatch(m.get('id'), _this2.props);
	                    })
	                )
	            );
	        }
	    }], [{
	        key: 'renderMatch',
	        value: function renderMatch(matchId, props) {
	            var matchProps = {
	                matchId: matchId,
	                matchStatsElement: props.matchStatsElement,
	                mainScoreElement: props.mainScoreElement,
	                additionalScoresElement: props.additionalScoresElement,
	                additionalScoreElement: props.additionalScoreElement,
	                matchClickCallback: props.matchClickCallback,
	                matchFavouriteClickCallback: props.matchFavouriteClickCallback
	            };
	
	            var MatchElement = props.matchElement;
	
	            return _react2.default.createElement(MatchElement, (0, _extends3.default)({ key: matchId }, matchProps));
	        }
	    }]);
	    return League;
	}(_react2.default.Component);
	
	League.propTypes = {
	    league: _react2.default.PropTypes.object,
	    isLive: _react2.default.PropTypes.bool.isRequired,
	    displayMode: _react2.default.PropTypes.object.isRequired,
	    matches: _react2.default.PropTypes.object,
	    matchElement: _react2.default.PropTypes.func,
	    showBookmarks: _react2.default.PropTypes.bool.isRequired,
	    showMatches: _react2.default.PropTypes.bool.isRequired,
	    gridSelection: _react2.default.PropTypes.object,
	    leagueClickCallback: _react2.default.PropTypes.func.isRequired,
	    leagueFavouriteClickCallback: _react2.default.PropTypes.func,
	    selectionToggleLeagueCallback: _react2.default.PropTypes.any
	};
	exports.default = League;

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(8);
	
	var _reactRouterRedux = __webpack_require__(23);
	
	var _redux = __webpack_require__(64);
	
	var _DisplayMode = __webpack_require__(78);
	
	var DisplayMode = _interopRequireWildcard(_DisplayMode);
	
	var _reactPerfectScrollbar = __webpack_require__(547);
	
	var _reactPerfectScrollbar2 = _interopRequireDefault(_reactPerfectScrollbar);
	
	var _SidebarWidget = __webpack_require__(1206);
	
	var _SidebarWidget2 = _interopRequireDefault(_SidebarWidget);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    bookmarks: {
	        id: 'menu.bookmarks',
	        defaultMessage: 'Избранное'
	    }
	});
	
	var Menu = function (_React$Component) {
	    (0, _inherits3.default)(Menu, _React$Component);
	
	    function Menu(props) {
	        (0, _classCallCheck3.default)(this, Menu);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call(this, props));
	
	        _this.state = { showMenu: false, filter: null, contentHeight: 0 };
	        _this._onShowFavouritesClick = _this._onShowFavouritesClick.bind(_this);
	        _this._onSlideClick = _this._onSlideClick.bind(_this);
	
	        _this._handleWidthAdjust = _this._handleWidthAdjust.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(Menu, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.refs.title === undefined) {
	                return;
	            }
	
	            this._widthAdjustmentInterval = window.setInterval(this._handleWidthAdjust, 500);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this._widthAdjustmentInterval) {
	                window.clearInterval(this._widthAdjustmentInterval);
	            }
	        }
	    }, {
	        key: '_handleWidthAdjust',
	        value: function _handleWidthAdjust() {
	            var contentWidth = this.refs.content.offsetWidth;
	            var contentHeight = this.refs.content.offsetHeight;
	            var titleWidth = this.refs.title.offsetWidth;
	
	            if (contentHeight !== this.state.contentHeight) {
	                this.setState({ contentHeight: contentHeight });
	                this.refs._scrollBarRef.updateScroll();
	            }
	
	            if (contentWidth !== titleWidth) {
	                this.refs.title.style.width = contentWidth + 'px';
	            }
	        }
	    }, {
	        key: '_onShowFavouritesClick',
	        value: function _onShowFavouritesClick(e) {
	            e.preventDefault();
	            this.props.showFavouritesCallback();
	        }
	    }, {
	        key: '_onSlideClick',
	        value: function _onSlideClick(e) {
	            e.preventDefault();
	            this.context.toggleMenu();
	            this.refs._scrollBarRef.updateScroll();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var sports = this.props.sports;
	            var _props = this.props,
	                showSlider = _props.showSlider,
	                showBookmarks = _props.showBookmarks,
	                displayMode = _props.displayMode,
	                isShortcut = _props.isShortcut,
	                showWidget = _props.showWidget,
	                countryCode = _props.countryCode;
	
	
	            var bookmarksCls = displayMode.type == DisplayMode.FAVOURITE ? 'bookmarks selected' : 'bookmarks';
	
	            return _react2.default.createElement(
	                'div',
	                { id: 'menu-sports', className: 'sports-live' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'sports-list cf', id: 'menu-sports-list' },
	                    showSlider && _react2.default.createElement(
	                        'div',
	                        { className: 'slide scroll--top', onClick: this._onSlideClick, ref: 'title' },
	                        _react2.default.createElement('a', { href: '#', className: 'slide-button' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'scroll--wrapper' },
	                        _react2.default.createElement(
	                            _reactPerfectScrollbar2.default,
	                            { ref: '_scrollBarRef' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'scroll--wrapper__inner', ref: 'content' },
	                                showBookmarks && _react2.default.createElement(
	                                    'div',
	                                    { className: bookmarksCls },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: '#', className: 'sport-title', onClick: this._onShowFavouritesClick },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.bookmarks)
	                                    )
	                                ),
	                                Menu.renderSports(sports, this.props)
	                            ),
	                            countryCode === 'KG' && !isShortcut && _react2.default.createElement(_SidebarWidget2.default, null)
	                        )
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'renderSports',
	        value: function renderSports(sports, props) {
	            var sportProps = {
	                sports: sports,
	                push: (0, _redux.bindActionCreators)(_reactRouterRedux.push, props.dispatch),
	                showBookmarks: props.showBookmarks,
	                showCalendar: props.showCalendar,
	                showMatches: props.showMatches,
	                sportElement: props.sportElement,
	                leagueElement: props.leagueElement,
	                matchElement: props.matchElement,
	                matchStatsElement: props.matchStatsElement,
	                mainScoreElement: props.mainScoreElement,
	                additionalScoresElement: props.additionalScoresElement,
	                additionalScoreElement: props.additionalScoreElement,
	                showAllSports: props.showAllSports,
	                gridSelection: props.gridSelection,
	                showAllCallback: props.showAllCallback,
	                sportClickCallback: props.sportClickCallback,
	                sportFavouriteClickCallback: props.sportFavouriteClickCallback,
	                leagueClickCallback: props.leagueClickCallback,
	                leagueFavouriteClickCallback: props.leagueFavouriteClickCallback,
	                matchClickCallback: props.matchClickCallback,
	                matchFavouriteClickCallback: props.matchFavouriteClickCallback,
	                displayMode: props.displayMode,
	                selectionToggleCallback: props.selectionToggleCallback,
	                selectionToggleLeagueCallback: props.selectionToggleLeagueCallback
	            };
	
	            var SportsElement = props.sportsElement;
	
	            return _react2.default.createElement(SportsElement, sportProps);
	        }
	    }]);
	    return Menu;
	}(_react2.default.Component);
	
	Menu.propTypes = {
	    sports: _react2.default.PropTypes.object,
	    sportsElement: _react2.default.PropTypes.func.isRequired,
	    showSlider: _react2.default.PropTypes.bool.isRequired,
	    showBookmarks: _react2.default.PropTypes.bool.isRequired,
	    displayMode: _react2.default.PropTypes.object.isRequired,
	    showAllSports: _react2.default.PropTypes.bool.isRequired,
	    gridSelection: _react2.default.PropTypes.object.isRequired,
	    showFavouritesCallback: _react2.default.PropTypes.func,
	    selectionToggleCallback: _react2.default.PropTypes.func.isRequired,
	    selectionToggleLeagueCallback: _react2.default.PropTypes.any
	};
	Menu.contextTypes = {
	    toggleMenu: _react2.default.PropTypes.func
	};
	exports.default = Menu;

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Sorting = __webpack_require__(136);
	
	var _SportCssMap = __webpack_require__(120);
	
	var _FavouriteState = __webpack_require__(79);
	
	var FavouriteState = _interopRequireWildcard(_FavouriteState);
	
	var _DisplayMode = __webpack_require__(78);
	
	var DisplayMode = _interopRequireWildcard(_DisplayMode);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Sport = function (_React$Component) {
	    (0, _inherits3.default)(Sport, _React$Component);
	
	    function Sport(props) {
	        (0, _classCallCheck3.default)(this, Sport);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Sport.__proto__ || (0, _getPrototypeOf2.default)(Sport)).call(this, props));
	
	        _this.state = { closed: true };
	
	        _this._onFavouriteClick = _this._onFavouriteClick.bind(_this);
	        _this._onExpandClick = _this._onExpandClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(Sport, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                sport = _props.sport,
	                gridSelection = _props.gridSelection;
	
	            var inGridSelection = gridSelection.get('sportsExpanded').includes(sport.get('id'));
	
	            if (inGridSelection) {
	                this.setState({ closed: false });
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            //const {sport, leagues, displayMode, gridSelection} = nextProps;
	            var sport = nextProps.sport,
	                gridSelection = nextProps.gridSelection;
	
	            if (sport && gridSelection.get('sportsExpanded').includes(sport.get('id'))) {
	                this.setState({ closed: false });
	            }
	            //const sportId = sport.get('id');
	
	            //const isChoosenSport = (displayMode.type === DisplayMode.SPORT && displayMode.id == sportId);
	            //const isLeagueDisplayMode = (displayMode.type === DisplayMode.LEAGUE);
	            //const isChoosenLeague = (leagues.hasIn([displayMode.id]) && leagues.getIn([displayMode.id, 'sportId']) === sportId);
	        }
	    }, {
	        key: '_onSportClick',
	        value: function _onSportClick(id, e) {
	            e.preventDefault();
	            this.props.sportClickCallback(id);
	            this.props.selectionToggleCallback({ id: id, showMatches: true });
	        }
	    }, {
	        key: '_onFavouriteClick',
	        value: function _onFavouriteClick(e) {
	            e.preventDefault();
	            this.props.sportFavouriteClickCallback(this.props.sport);
	        }
	    }, {
	        key: '_onExpandClick',
	        value: function _onExpandClick(e) {
	            e.preventDefault();
	            var sport = this.props.sport;
	
	
	            this.setState({ closed: !this.state.closed });
	
	            this.props.selectionToggleCallback({ id: sport.get('id'), showMatches: false });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                sport = _props2.sport,
	                showBookmarks = _props2.showBookmarks,
	                displayMode = _props2.displayMode;
	
	
	            if (sport === undefined) {
	                return false;
	            }
	
	            var leagues = sport.get('leagues').map(function (id) {
	                return _this2.props.leagues.get(id);
	            }).sort(_Sorting.leagueSortFunc);
	            var sportId = sport.get('id');
	            var isClosed = this.state.closed;
	
	            var isSelected = displayMode.type === DisplayMode.SPORT && displayMode.id == sportId;
	
	            var cls = 'sport-list-item ' + _SportCssMap.cssClassMap[sportId] + (isClosed ? ' closed' : '') + (isSelected ? ' selected' : '');
	            var iconCls = 'sport-icon svg-' + _SportCssMap.cssClassMap[sportId];
	
	            var favouritesCls = 'favourites';
	
	            var favouriteState = sport.get('favouriteState');
	
	            if (favouriteState === FavouriteState.FULL) {
	                favouritesCls += ' added';
	            } else if (favouriteState === FavouriteState.PARTIAL) {
	                favouritesCls += ' semi';
	            }
	
	            var boundSportClick = this._onSportClick.bind(this, sportId);
	
	            var leaguesPresent = leagues.size > 0;
	
	            return _react2.default.createElement(
	                'div',
	                { className: cls },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'sport-title' },
	                    _react2.default.createElement('span', { className: iconCls, onClick: boundSportClick }),
	                    leaguesPresent && _react2.default.createElement(
	                        'a',
	                        { href: '#', className: 'sport-expand', onClick: this._onExpandClick },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#', className: 'sport-name', onClick: boundSportClick },
	                        sport.get('name'),
	                        !showBookmarks && sport.get('eventCount') && _react2.default.createElement(
	                            'span',
	                            { className: 'event-count pull-right' },
	                            '+',
	                            sport.get('eventCount')
	                        )
	                    ),
	                    showBookmarks && _react2.default.createElement(
	                        'a',
	                        { href: '#', className: favouritesCls, onClick: this._onFavouriteClick },
	                        '\xA0'
	                    )
	                ),
	                !isClosed && leaguesPresent && _react2.default.createElement(
	                    'div',
	                    { className: 'sport-collapse' },
	                    leagues.map(function (l) {
	                        return Sport.renderLeague(l.get('id'), _this2.props);
	                    })
	                )
	            );
	        }
	    }], [{
	        key: 'renderLeague',
	        value: function renderLeague(leagueId, props) {
	            var leagueProps = {
	                leagueId: leagueId,
	                isLive: props.isLive,
	                displayMode: props.displayMode,
	                gridSelection: props.gridSelection,
	                matchElement: props.matchElement,
	                matchStatsElement: props.matchStatsElement,
	                mainScoreElement: props.mainScoreElement,
	                additionalScoresElement: props.additionalScoresElement,
	                additionalScoreElement: props.additionalScoreElement,
	                showBookmarks: props.showBookmarks,
	                showMatches: props.showMatches,
	                leagueClickCallback: props.leagueClickCallback,
	                leagueFavouriteClickCallback: props.leagueFavouriteClickCallback,
	                matchClickCallback: props.matchClickCallback,
	                matchFavouriteClickCallback: props.matchFavouriteClickCallback,
	                selectionToggleLeagueCallback: props.selectionToggleLeagueCallback
	            };
	
	            var LeagueElement = props.leagueElement;
	
	            return _react2.default.createElement(LeagueElement, (0, _extends3.default)({ key: leagueId }, leagueProps));
	        }
	    }]);
	    return Sport;
	}(_react2.default.Component);
	
	Sport.propTypes = {
	    sport: _react2.default.PropTypes.object,
	    isLive: _react2.default.PropTypes.bool.isRequired,
	    displayMode: _react2.default.PropTypes.object.isRequired,
	    leagues: _react2.default.PropTypes.object,
	    leagueElement: _react2.default.PropTypes.func,
	    showBookmarks: _react2.default.PropTypes.bool,
	    gridSelection: _react2.default.PropTypes.object.isRequired,
	    sportClickCallback: _react2.default.PropTypes.func.isRequired,
	    sportFavouriteClickCallback: _react2.default.PropTypes.func,
	    leagueClickCallback: _react2.default.PropTypes.func,
	    leagueFavouriteClickCallback: _react2.default.PropTypes.func,
	    selectionToggleCallback: _react2.default.PropTypes.func,
	    selectionToggleLeagueCallback: _react2.default.PropTypes.func
	};
	exports.default = Sport;

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(8);
	
	var _classnames = __webpack_require__(61);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DisplayMode = __webpack_require__(78);
	
	var DisplayMode = _interopRequireWildcard(_DisplayMode);
	
	var _Sorting = __webpack_require__(136);
	
	var _domainUtils = __webpack_require__(27);
	
	var _creators = __webpack_require__(386);
	
	var _reactRedux = __webpack_require__(9);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    others: {
	        id: 'menu.others',
	        defaultMessage: 'Разное'
	    },
	    allSport: {
	        id: 'menu.all_sport',
	        defaultMessage: 'Все события'
	    },
	    popularSports: {
	        id: 'menu.popular_sport',
	        defaultMessage: 'Популярные события'
	    },
	    calendar: {
	        id: 'menu.calendar',
	        defaultMessage: 'Календарь'
	    },
	    fastSport: {
	        id: 'games.fastsport',
	        defaultMessage: 'Быстрый спорт'
	    }
	});
	
	var Sports = function (_React$Component) {
	    (0, _inherits3.default)(Sports, _React$Component);
	
	    function Sports(props) {
	        (0, _classCallCheck3.default)(this, Sports);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Sports.__proto__ || (0, _getPrototypeOf2.default)(Sports)).call(this, props));
	
	        _this.openAuthModal = function () {
	            return _this.props.dispatch({ type: 'BEGIN_SIGNIN' });
	        };
	
	        _this.onFastsportClick = function () {
	            var gamblerId = _this.props.gamblerId;
	
	
	            if (gamblerId) {
	                _this.props.fetchFastsportToken(gamblerId);
	            } else {
	                _this.openAuthModal();
	            }
	        };
	
	        _this._onShowAllClick = _this._onShowAllClick.bind(_this);
	        _this._onCalendarClick = _this._onCalendarClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(Sports, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return this.props.sports !== nextProps.sports || this.props.displayMode !== nextProps.displayMode || this.props.gridSelection !== nextProps.gridSelection;
	        }
	    }, {
	        key: '_onShowAllClick',
	        value: function _onShowAllClick(e) {
	            e.preventDefault();
	            this.props.showAllCallback();
	        }
	    }, {
	        key: '_onCalendarClick',
	        value: function _onCalendarClick() {
	            this.props.push('/live/timetable');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var sports = this.props.sports.valueSeq().sort(_Sorting.sportSortFunc);
	
	            var sportsWithLeagues = sports.filter(function (s) {
	                return s.get('leagues').size > 0;
	            }).toList();
	
	            var _props = this.props,
	                showCalendar = _props.showCalendar,
	                isLive = _props.isLive,
	                displayMode = _props.displayMode,
	                showAllSports = _props.showAllSports;
	
	
	            var allSports = isLive ? messages.allSport : messages.popularSports;
	
	            var allSportsCls = displayMode.type == DisplayMode.ALL ? 'allsport selected' : 'allsport';
	
	            var calendarCls = displayMode.type == DisplayMode.TIMETABLE ? 'calendars selected' : 'calendars';
	            return _react2.default.createElement(
	                'div',
	                null,
	                showAllSports && _react2.default.createElement(
	                    'div',
	                    { className: allSportsCls },
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#', className: 'sport-title', onClick: this._onShowAllClick },
	                        _react2.default.createElement('span', { className: (0, _classnames2.default)('sport-icon svg-all', { 'svg-ringobet': _domainUtils.isRingo }) }),
	                        _react2.default.createElement(_reactIntl.FormattedMessage, allSports)
	                    )
	                ),
	                sportsWithLeagues.map(function (s) {
	                    return Sports.renderSport(s.get('id'), _this2.props);
	                }),
	                showCalendar && _react2.default.createElement(
	                    'div',
	                    { className: calendarCls, id: 'menu-calendar' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'calendar-title' },
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'calendar-name', onClick: this._onCalendarClick },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.calendar)
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'show-all' },
	                            '\xA0'
	                        )
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'renderSport',
	        value: function renderSport(sportId, props) {
	            var sportProps = {
	                sportId: sportId,
	                isLive: props.isLive,
	                showBookmarks: props.showBookmarks,
	                showMatches: props.showMatches,
	                displayMode: props.displayMode,
	                leagueElement: props.leagueElement,
	                matchElement: props.matchElement,
	                matchStatsElement: props.matchStatsElement,
	                mainScoreElement: props.mainScoreElement,
	                additionalScoresElement: props.additionalScoresElement,
	                additionalScoreElement: props.additionalScoreElement,
	                gridSelection: props.gridSelection,
	                sportClickCallback: props.sportClickCallback,
	                sportFavouriteClickCallback: props.sportFavouriteClickCallback,
	                leagueClickCallback: props.leagueClickCallback,
	                leagueFavouriteClickCallback: props.leagueFavouriteClickCallback,
	                matchClickCallback: props.matchClickCallback,
	                matchFavouriteClickCallback: props.matchFavouriteClickCallback,
	                selectionToggleCallback: props.selectionToggleCallback,
	                selectionToggleLeagueCallback: props.selectionToggleLeagueCallback
	            };
	
	            var SportElement = props.sportElement;
	
	            return _react2.default.createElement(SportElement, (0, _extends3.default)({ key: sportId }, sportProps));
	        }
	    }]);
	    return Sports;
	}(_react2.default.Component);
	
	Sports.propTypes = {
	    sports: _react2.default.PropTypes.object,
	    isLive: _react2.default.PropTypes.bool.isRequired,
	    sportElement: _react2.default.PropTypes.func.isRequired,
	    showBookmarks: _react2.default.PropTypes.bool.isRequired,
	    showCalendar: _react2.default.PropTypes.bool.isRequired,
	    displayMode: _react2.default.PropTypes.object.isRequired,
	    showAllSports: _react2.default.PropTypes.bool.isRequired,
	    gridSelection: _react2.default.PropTypes.object.isRequired,
	    showAllCallback: _react2.default.PropTypes.func.isRequired,
	    push: _react2.default.PropTypes.func.isRequired,
	    selectionToggleCallback: _react2.default.PropTypes.func.isRequired,
	    selectionToggleLeagueCallback: _react2.default.PropTypes.any
	};
	Sports.contextTypes = {
	    toggleMenu: _react2.default.PropTypes.func
	};
	exports.default = (0, _reactRedux.connect)(function (state) {
	    var user = state.auth.get('user');
	    var gamblerId = user ? user.get('gamblerId') : null;
	    return {
	        gamblerId: gamblerId
	    };
	}, { fetchFastsportToken: _creators.fetchFastsportToken })(Sports);

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _reactRedux = __webpack_require__(9);
	
	var _League = __webpack_require__(796);
	
	var _League2 = _interopRequireDefault(_League);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function select(state, props) {
	    var league = state.application.getIn(['menu', 'leagues', props.leagueId]);
	
	    return (0, _extends3.default)({}, props, {
	        league: league
	    });
	}
	
	exports.default = (0, _reactRedux.connect)(select, null, null, false)(_League2.default);

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _reactRedux = __webpack_require__(9);
	
	var _DisplayMode = __webpack_require__(78);
	
	var DisplayMode = _interopRequireWildcard(_DisplayMode);
	
	var _Menu = __webpack_require__(797);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function select(state, props) {
	    var sports = state.application.getIn(['menu', 'sports']);
	
	    var sportId = undefined,
	        leagueId = undefined;
	    if (props.params) {
	        sportId = props.params.sportId;
	        leagueId = props.params.leagueId;
	    }
	
	    var displayMode = { type: DisplayMode.ALL };
	
	    if (leagueId === undefined && sportId) {
	        displayMode.type = DisplayMode.SPORT;
	        displayMode.id = parseInt(sportId);
	    } else if (leagueId && sportId) {
	        displayMode.type = DisplayMode.LEAGUE;
	        displayMode.id = parseInt(leagueId);
	    }
	
	    return (0, _extends3.default)({}, props, {
	        sports: sports,
	        displayMode: displayMode,
	        showWidget: true,
	        user: state.auth.get('user'),
	        countryCode: state.application.get('countryCode')
	    });
	}
	
	exports.default = (0, _reactRedux.connect)(select)(_Menu2.default);

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _reactRedux = __webpack_require__(9);
	
	var _Sport = __webpack_require__(798);
	
	var _Sport2 = _interopRequireDefault(_Sport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function select(state, props) {
	    var sport = state.application.getIn(['menu', 'sports', props.sportId]);
	    var leagues = state.application.getIn(['menu', 'leagues']);
	
	    return (0, _extends3.default)({}, props, {
	        sport: sport,
	        leagues: leagues
	    });
	}
	
	exports.default = (0, _reactRedux.connect)(select, null, null, false)(_Sport2.default);

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _reactRedux = __webpack_require__(9);
	
	var _Sports = __webpack_require__(799);
	
	var _Sports2 = _interopRequireDefault(_Sports);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function select(state, props) {
	    return (0, _extends3.default)({}, props, {
	        isLive: false
	    });
	}
	
	exports.default = (0, _reactRedux.connect)(select, null, null, false)(_Sports2.default);

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormField = function (_React$Component) {
	    (0, _inherits3.default)(FormField, _React$Component);
	
	    function FormField() {
	        (0, _classCallCheck3.default)(this, FormField);
	        return (0, _possibleConstructorReturn3.default)(this, (FormField.__proto__ || (0, _getPrototypeOf2.default)(FormField)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(FormField, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                message = _props.message,
	                type = _props.type,
	                field = _props.field,
	                divClass = _props.divClass,
	                required = _props.required,
	                joinError = _props.joinError,
	                msg = _props.msg;
	
	
	            var notRequiredLabelClass = 'login--form__label form__label';
	            var requiredLabelClass = 'login--form__label form__label form__label__required';
	            var inputClass = 'login--form__control form__control';
	
	            var labelClass = required ? requiredLabelClass : notRequiredLabelClass;
	
	            var rowClass = divClass ? divClass : 'form__row';
	
	            return _react2.default.createElement(
	                'div',
	                { className: rowClass },
	                _react2.default.createElement(
	                    'label',
	                    { className: labelClass },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, message)
	                ),
	                _react2.default.createElement('input', (0, _extends3.default)({ type: type, className: inputClass }, field)),
	                field.touched && field.error && FormField.renderHint(field.error),
	                joinError && joinError === -2 && !field.error && FormField.renderHint(msg)
	            );
	        }
	    }], [{
	        key: 'renderHint',
	        value: function renderHint(hint) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'hint hint--error' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, hint)
	            );
	        }
	    }]);
	    return FormField;
	}(_react2.default.Component);
	
	FormField.propTypes = {
	    field: _react2.default.PropTypes.object.isRequired,
	    type: _react2.default.PropTypes.string.isRequired,
	    message: _react2.default.PropTypes.object.isRequired,
	    divClass: _react2.default.PropTypes.string,
	    required: _react2.default.PropTypes.bool
	};
	exports.default = FormField;

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormSelectableField = function (_React$Component) {
	    (0, _inherits3.default)(FormSelectableField, _React$Component);
	
	    function FormSelectableField() {
	        (0, _classCallCheck3.default)(this, FormSelectableField);
	        return (0, _possibleConstructorReturn3.default)(this, (FormSelectableField.__proto__ || (0, _getPrototypeOf2.default)(FormSelectableField)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(FormSelectableField, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                message = _props.message,
	                field = _props.field,
	                options = _props.options,
	                required = _props.required,
	                disabled = _props.disabled;
	
	
	            var notRequiredLabelClass = 'login--form__label form__label';
	            var requiredLabelClass = 'login--form__label form__label form__label__required';
	            var inputClass = 'login--form__control form__control';
	            var rowClass = 'form__row';
	
	            var labelClass = required ? requiredLabelClass : notRequiredLabelClass;
	
	            return _react2.default.createElement(
	                'div',
	                { className: rowClass },
	                _react2.default.createElement(
	                    'label',
	                    { className: labelClass },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, message)
	                ),
	                _react2.default.createElement(
	                    'select',
	                    (0, _extends3.default)({ className: inputClass }, field, { disabled: disabled }),
	                    options
	                ),
	                field.touched && field.error && FormSelectableField.renderHint(field.error)
	            );
	        }
	    }], [{
	        key: 'renderHint',
	        value: function renderHint(hint) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'hint hint--error' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, hint)
	            );
	        }
	    }]);
	    return FormSelectableField;
	}(_react2.default.Component);
	
	FormSelectableField.propTypes = {
	    field: _react2.default.PropTypes.object.isRequired,
	    message: _react2.default.PropTypes.object.isRequired,
	    options: _react2.default.PropTypes.array.isRequired,
	    required: _react2.default.PropTypes.bool
	};
	exports.default = FormSelectableField;

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ModalWindow = __webpack_require__(138);
	
	var _ModalWindow2 = _interopRequireDefault(_ModalWindow);
	
	var _Stream = __webpack_require__(1368);
	
	var _Stream2 = _interopRequireDefault(_Stream);
	
	var _reactIntl = __webpack_require__(8);
	
	var _fullscreenBtn_img = __webpack_require__(1678);
	
	var _fullscreenBtn_img2 = _interopRequireDefault(_fullscreenBtn_img);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    playStream: {
	        id: 'play.stream.video',
	        defaultMessage: 'Доступна прямая трансиляция'
	    },
	    logInToWatch: {
	        id: 'login.to.watch',
	        defaultMessage: 'Войдите в систему для просмотра'
	    }
	});
	
	var StreamPanel = function (_Component) {
	    (0, _inherits3.default)(StreamPanel, _Component);
	
	    function StreamPanel() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, StreamPanel);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = StreamPanel.__proto__ || (0, _getPrototypeOf2.default)(StreamPanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            showPopUp: false
	        }, _this.closeStreamBlock = function () {
	            _this.props.stopFetchStreamAction();
	        }, _this.showPopUpHandler = function () {
	            _this.setState({
	                showPopUp: true
	            });
	        }, _this.closePopUpHandler = function () {
	            _this.setState({
	                showPopUp: false
	            });
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(StreamPanel, [{
	        key: 'render',
	        value: function render() {
	            var showPopUp = this.state.showPopUp;
	            var _props = this.props,
	                stream = _props.stream,
	                streamName = _props.streamName,
	                user = _props.user;
	
	
	            var openStream = stream.openStream;
	            var streamSrc = stream.src;
	
	            var streamBlockClassName = void 0;
	            var streamDisplay = void 0;
	            var streamBlock = void 0;
	
	            if (openStream) {
	                streamBlockClassName = 'stream-block';
	                streamBlock = _react2.default.createElement(_Stream2.default, { src: streamSrc });
	            } else {
	                streamBlockClassName = 'stream-block hidden';
	                streamBlock = null;
	            }
	
	            if (user !== null && user.get('accountId')) {
	                streamDisplay = _react2.default.createElement(
	                    'div',
	                    { className: 'stream stream-display' },
	                    streamBlock
	                );
	            } else {
	                streamDisplay = _react2.default.createElement(
	                    'div',
	                    { className: 'stream' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'display-inner' },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.playStream)
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.logInToWatch)
	                        )
	                    )
	                );
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: streamBlockClassName },
	                !showPopUp && _react2.default.createElement(
	                    'div',
	                    { className: 'heading' },
	                    _react2.default.createElement('button', { onClick: this.closeStreamBlock, className: 'close-stream-btn' }),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'stream-team', title: streamName },
	                        streamName
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'full-screen-btn', onClick: this.showPopUpHandler },
	                        _react2.default.createElement('img', { src: _fullscreenBtn_img2.default, alt: 'full-screen' })
	                    )
	                ),
	                !showPopUp && streamDisplay,
	                showPopUp && _react2.default.createElement(
	                    _ModalWindow2.default,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'modal_stream' },
	                        _react2.default.createElement('button', { onClick: this.closePopUpHandler, className: 'close-modal-stream' }),
	                        _react2.default.createElement(_Stream2.default, { src: streamSrc })
	                    )
	                )
	            );
	        }
	    }]);
	    return StreamPanel;
	}(_react.Component);
	
	StreamPanel.propTypes = {
	    stream: _react2.default.PropTypes.object.isRequired,
	    streamName: _react2.default.PropTypes.any,
	    user: _react2.default.PropTypes.any,
	    stopFetchStreamAction: _react2.default.PropTypes.func.isRequired
	};
	
	exports.default = StreamPanel;

/***/ },
/* 807 */,
/* 808 */,
/* 809 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */
641,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */
/***/ function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ },
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */
/***/ function(module, exports) {

	module.exports = {
		"1": {
			"name": "Австралия",
			"short": "AU",
			"mask": "+61",
			"length": 9
		},
		"2": {
			"name": "Австрия",
			"short": "AT",
			"mask": "+43",
			"length": 9
		},
		"3": {
			"name": "Азербайджан",
			"short": "AZ",
			"mask": "+994",
			"length": 9
		},
		"5": {
			"name": "Алжир",
			"short": "DZ",
			"mask": "+213",
			"length": 9
		},
		"6": {
			"name": "Американское Самоа",
			"short": "AS",
			"mask": "+1",
			"length": 10
		},
		"7": {
			"name": "Ангилья",
			"short": "AI",
			"mask": "+1",
			"length": 10
		},
		"8": {
			"name": "Ангола",
			"short": "AO",
			"mask": "+244",
			"length": 9
		},
		"9": {
			"name": "Андорра",
			"short": "AD",
			"mask": "+376",
			"length": 6
		},
		"11": {
			"name": "Антигуа и Барбуда",
			"short": "AG",
			"mask": "+1",
			"length": 10
		},
		"12": {
			"name": "Аргентина",
			"short": "AR",
			"mask": "+54",
			"length": 11
		},
		"13": {
			"name": "Армения",
			"short": "AM",
			"mask": "+374",
			"length": 8
		},
		"14": {
			"name": "Аруба",
			"short": "AW",
			"mask": "+297",
			"length": 7
		},
		"15": {
			"name": "Афганистан",
			"short": "AF",
			"mask": "+93",
			"length": 9
		},
		"16": {
			"name": "Багамы",
			"short": "BS",
			"mask": "+1",
			"length": 10
		},
		"17": {
			"name": "Бангладеш",
			"short": "BD",
			"mask": "+880",
			"length": 10
		},
		"18": {
			"name": "Барбадос",
			"short": "BB",
			"mask": "+1",
			"length": 10
		},
		"19": {
			"name": "Бахрейн",
			"short": "BH",
			"mask": "+973",
			"length": 8
		},
		"20": {
			"name": "Белиз",
			"short": "BZ",
			"mask": "+501",
			"length": 7
		},
		"21": {
			"name": "Белоруссия",
			"short": "BY",
			"mask": "+375",
			"length": 9
		},
		"22": {
			"name": "Бельгия",
			"short": "BE",
			"mask": "+32",
			"length": 9
		},
		"23": {
			"name": "Бенин",
			"short": "BJ",
			"mask": "+229",
			"length": 8
		},
		"24": {
			"name": "Бермуды",
			"short": "BM",
			"mask": "+1",
			"length": 10
		},
		"25": {
			"name": "Болгария",
			"short": "BG",
			"mask": "+359",
			"length": 8
		},
		"26": {
			"name": "Боливия",
			"short": "BO",
			"mask": "+571",
			"length": 8
		},
		"27": {
			"name": "Босния и Герцеговина",
			"short": "BA",
			"mask": "+387",
			"length": 8
		},
		"28": {
			"name": "Ботсвана",
			"short": "BW",
			"mask": "+267",
			"length": 8
		},
		"29": {
			"name": "Бразилия",
			"short": "BR",
			"mask": "+55",
			"length": 10
		},
		"30": {
			"name": "Британская территория в Индийском океане",
			"short": "IO",
			"mask": "+246",
			"length": 7
		},
		"32": {
			"name": "Бруней",
			"short": "BN",
			"mask": "+673",
			"length": 7
		},
		"33": {
			"name": "Буркина Фасо",
			"short": "BF",
			"mask": "+226",
			"length": 8
		},
		"34": {
			"name": "Бурунди",
			"short": "BI",
			"mask": "+257",
			"length": 8
		},
		"35": {
			"name": "Бутан",
			"short": "BT",
			"mask": "+975",
			"length": 8
		},
		"36": {
			"name": "Вануату",
			"short": "VU",
			"mask": "+678",
			"length": 7
		},
		"38": {
			"name": "Великобритания",
			"short": "GB",
			"mask": "+44",
			"length": 10
		},
		"39": {
			"name": "Венгрия",
			"short": "HU",
			"mask": "+36",
			"length": 9
		},
		"40": {
			"name": "Венесуэла",
			"short": "VE",
			"mask": "+58",
			"length": 10
		},
		"42": {
			"name": "Вьетнам",
			"short": "VN",
			"mask": "+84",
			"length": 9
		},
		"43": {
			"name": "Габон",
			"short": "GA",
			"mask": "+241",
			"length": 8
		},
		"44": {
			"name": "Гаити",
			"short": "HT",
			"mask": "+509",
			"length": 8
		},
		"45": {
			"name": "Гайана",
			"short": "GY",
			"mask": "+592",
			"length": 7
		},
		"46": {
			"name": "Гамбия",
			"short": "GM",
			"mask": "+220",
			"length": 7
		},
		"47": {
			"name": "Гана",
			"short": "GH",
			"mask": "+233",
			"length": 9
		},
		"48": {
			"name": "Гваделупа",
			"short": "GP",
			"mask": "+590",
			"length": 9
		},
		"49": {
			"name": "Гватемала",
			"short": "GT",
			"mask": "+502",
			"length": 8
		},
		"50": {
			"name": "Гвинея",
			"short": "GN",
			"mask": "+224",
			"length": 8
		},
		"51": {
			"name": "Гвинея-Бисау",
			"short": "GW",
			"mask": "+245",
			"length": 7
		},
		"52": {
			"name": "Германия",
			"short": "DE",
			"mask": "+49",
			"length": 11
		},
		"53": {
			"name": "Гондурас",
			"short": "HN",
			"mask": "+504",
			"length": 8
		},
		"54": {
			"name": "Государство Палестина",
			"short": "PS",
			"mask": "+970",
			"length": 9
		},
		"55": {
			"name": "Гренада",
			"short": "GD",
			"mask": "+1",
			"length": 10
		},
		"56": {
			"name": "Гренландия",
			"short": "GL",
			"mask": "+299",
			"length": 6
		},
		"58": {
			"name": "Гуам",
			"short": "GU",
			"mask": "+1",
			"length": 10
		},
		"60": {
			"name": "Джибути",
			"short": "DJ",
			"mask": "+253",
			"length": 8
		},
		"61": {
			"name": "Доминика",
			"short": "DM",
			"mask": "+1",
			"length": 10
		},
		"62": {
			"name": "Доминиканская Республика",
			"short": "DO",
			"mask": "+1",
			"length": 10
		},
		"63": {
			"name": "Египет",
			"short": "EG",
			"mask": "+20",
			"length": 10
		},
		"64": {
			"name": "Замбия",
			"short": "ZM",
			"mask": "+260",
			"length": 9
		},
		"65": {
			"name": "Западная Сахара",
			"short": "EH",
			"mask": "+212",
			"length": 9
		},
		"66": {
			"name": "Зимбабве",
			"short": "ZW",
			"mask": "+263",
			"length": 9
		},
		"67": {
			"name": "Израиль",
			"short": "IL",
			"mask": "+972",
			"length": 9
		},
		"68": {
			"name": "Индия",
			"short": "IN",
			"mask": "+91",
			"length": 10
		},
		"69": {
			"name": "Индонезия",
			"short": "ID",
			"mask": "+62",
			"length": 9
		},
		"70": {
			"name": "Иордания",
			"short": "JO",
			"mask": "+962",
			"length": 9
		},
		"71": {
			"name": "Ирак",
			"short": "IQ",
			"mask": "+964",
			"length": 10
		},
		"72": {
			"name": "Иран",
			"short": "IR",
			"mask": "+98",
			"length": 10
		},
		"73": {
			"name": "Ирландия",
			"short": "IE",
			"mask": "+353",
			"length": 9
		},
		"74": {
			"name": "Исландия",
			"short": "IS",
			"mask": "+354",
			"length": 7
		},
		"75": {
			"name": "Испания",
			"short": "ES",
			"mask": "+34",
			"length": 9
		},
		"76": {
			"name": "Италия",
			"short": "IT",
			"mask": "+39",
			"length": 10
		},
		"77": {
			"name": "Йемен",
			"short": "YE",
			"mask": "+967",
			"length": 9
		},
		"78": {
			"name": "Кабо-Верде",
			"short": "CV",
			"mask": "+238",
			"length": 7
		},
		"79": {
			"name": "Казахстан",
			"short": "KZ",
			"mask": "+7",
			"length": 10
		},
		"80": {
			"name": "Каймановы острова",
			"short": "KY",
			"mask": "+1",
			"length": 10
		},
		"81": {
			"name": "Камбоджа",
			"short": "KH",
			"mask": "+855",
			"length": 8
		},
		"82": {
			"name": "Камерун",
			"short": "CM",
			"mask": "+237",
			"length": 8
		},
		"83": {
			"name": "Канада",
			"short": "CA",
			"mask": "+1",
			"length": 10
		},
		"84": {
			"name": "Катар",
			"short": "QA",
			"mask": "+974",
			"length": 8
		},
		"85": {
			"name": "Кения",
			"short": "KE",
			"mask": "+254",
			"length": 9
		},
		"86": {
			"name": "Кирибати",
			"short": "KI",
			"mask": "+686",
			"length": 5
		},
		"87": {
			"name": "Китайская Республика",
			"short": "TW",
			"mask": "+886",
			"length": 9
		},
		"88": {
			"name": "Korea, Democratic People's Republic of",
			"short": "KP",
			"mask": "+850",
			"length": 10
		},
		"89": {
			"name": "Кокосовые острова",
			"short": "CC",
			"mask": "+61",
			"length": 9
		},
		"90": {
			"name": "Колумбия",
			"short": "CO",
			"mask": "+57",
			"length": 10
		},
		"91": {
			"name": "Коморы",
			"short": "KM",
			"mask": "+269",
			"length": 7
		},
		"92": {
			"name": "Коста-Рика",
			"short": "CR",
			"mask": "+506",
			"length": 8
		},
		"93": {
			"name": "Кот-д’Ивуар",
			"short": "CI",
			"mask": "+255",
			"length": 8
		},
		"94": {
			"name": "Куба",
			"short": "CU",
			"mask": "+53",
			"length": 8
		},
		"95": {
			"name": "Кувейт",
			"short": "KW",
			"mask": "+965",
			"length": 7
		},
		"96": {
			"name": "Кыргызстан",
			"short": "KG",
			"mask": "+996",
			"length": 9
		},
		"97": {
			"name": "Лаос",
			"short": "LA",
			"mask": "+856",
			"length": 10
		},
		"98": {
			"name": "Лесото",
			"short": "LS",
			"mask": "+266",
			"length": 8
		},
		"99": {
			"name": "Либерия",
			"short": "LR",
			"mask": "+231",
			"length": 7
		},
		"100": {
			"name": "Ливан",
			"short": "LB",
			"mask": "+961",
			"length": 8
		},
		"101": {
			"name": "Ливия",
			"short": "LY",
			"mask": "+218",
			"length": 9
		},
		"102": {
			"name": "Литва",
			"short": "LT",
			"mask": "+218",
			"length": 9
		},
		"103": {
			"name": "Люксембург",
			"short": "LU",
			"mask": "+352",
			"length": 9
		},
		"104": {
			"name": "Маврикий",
			"short": "MU",
			"mask": "+230",
			"length": 7
		},
		"105": {
			"name": "Мавритания",
			"short": "MR",
			"mask": "+222",
			"length": 8
		},
		"106": {
			"name": "Мадагаскар",
			"short": "MG",
			"mask": "+261",
			"length": 9
		},
		"107": {
			"name": "Майотта",
			"short": "YT",
			"mask": "+262",
			"length": 9
		},
		"108": {
			"name": "Малави",
			"short": "MW",
			"mask": "+265",
			"length": 9
		},
		"109": {
			"name": "Малайзия",
			"short": "MY",
			"mask": "+60",
			"length": 9
		},
		"110": {
			"name": "Мали",
			"short": "ML",
			"mask": "+223",
			"length": 8
		},
		"111": {
			"name": "Мальдивы",
			"short": "MV",
			"mask": "+960",
			"length": 7
		},
		"112": {
			"name": "Мальта",
			"short": "MT",
			"mask": "+356",
			"length": 8
		},
		"113": {
			"name": "Марокко",
			"short": "MA",
			"mask": "+212",
			"length": 9
		},
		"114": {
			"name": "Маршалловы Острова",
			"short": "MH",
			"mask": "+692",
			"length": 7
		},
		"115": {
			"name": "Мексика",
			"short": "MX",
			"mask": "+52",
			"length": 11
		},
		"116": {
			"name": "Микронезия",
			"short": "FM",
			"mask": "+691",
			"length": 7
		},
		"117": {
			"name": "Мозамбик",
			"short": "MZ",
			"mask": "+258",
			"length": 9
		},
		"118": {
			"name": "Молдавия",
			"short": "MD",
			"mask": "+373",
			"length": 8
		},
		"119": {
			"name": "Монако",
			"short": "MC",
			"mask": "+377",
			"length": 9
		},
		"120": {
			"name": "Монголия",
			"short": "MN",
			"mask": "+976",
			"length": 8
		},
		"121": {
			"name": "Монтсеррат",
			"short": "MS",
			"mask": "+1",
			"length": 10
		},
		"122": {
			"name": "Мьянма",
			"short": "MM",
			"mask": "+95",
			"length": 8
		},
		"123": {
			"name": "Намибия",
			"short": "NA",
			"mask": "+264",
			"length": 9
		},
		"124": {
			"name": "Науру",
			"short": "NR",
			"mask": "+674",
			"length": 7
		},
		"125": {
			"name": "Непал",
			"short": "NP",
			"mask": "+977",
			"length": 10
		},
		"126": {
			"name": "Нигер",
			"short": "NE",
			"mask": "+227",
			"length": 8
		},
		"127": {
			"name": "Нигерия",
			"short": "NG",
			"mask": "+234",
			"length": 10
		},
		"129": {
			"name": "Нидерланды",
			"short": "NL",
			"mask": "+31",
			"length": 9
		},
		"130": {
			"name": "Никарагуа",
			"short": "NI",
			"mask": "+505",
			"length": 8
		},
		"131": {
			"name": "Ниуэ",
			"short": "NU",
			"mask": "+683",
			"length": 4
		},
		"132": {
			"name": "Новая Зеландия",
			"short": "NZ",
			"mask": "+64",
			"length": 9
		},
		"133": {
			"name": "Новая Каледония",
			"short": "NC",
			"mask": "+687",
			"length": 6
		},
		"134": {
			"name": "Норвегия",
			"short": "NO",
			"mask": "+47",
			"length": 8
		},
		"135": {
			"name": "ОАЭ",
			"short": "AE",
			"mask": "+971",
			"length": 9
		},
		"136": {
			"name": "Оман",
			"short": "OM",
			"mask": "+968",
			"length": 8
		},
		"138": {
			"name": "Остров Норфолк",
			"short": "NF",
			"mask": "+672",
			"length": 6
		},
		"139": {
			"name": "Остров Рождества",
			"short": "CX",
			"mask": "+61",
			"length": 9
		},
		"141": {
			"name": "Острова Кука",
			"short": "CK",
			"mask": "+682",
			"length": 5
		},
		"143": {
			"name": "Пакистан",
			"short": "PK",
			"mask": "+92",
			"length": 10
		},
		"144": {
			"name": "Палау",
			"short": "PW",
			"mask": "+680",
			"length": 7
		},
		"145": {
			"name": "Папуа - Новая Гвинея",
			"short": "PG",
			"mask": "+675",
			"length": 7
		},
		"146": {
			"name": "Парагвай",
			"short": "PY",
			"mask": "+595",
			"length": 9
		},
		"147": {
			"name": "Перу",
			"short": "PE",
			"mask": "+51",
			"length": 9
		},
		"148": {
			"name": "Польша",
			"short": "PL",
			"mask": "+48",
			"length": 9
		},
		"149": {
			"name": "Португалия",
			"short": "PT",
			"mask": "+351",
			"length": 9
		},
		"150": {
			"name": "Пуэрто-Рико",
			"short": "PR",
			"mask": "+1",
			"length": 10
		},
		"151": {
			"name": "Республика Конго",
			"short": "CG",
			"mask": "+243",
			"length": 9
		},
		"152": {
			"name": "КНДР",
			"short": "KR",
			"mask": "+82",
			"length": 10
		},
		"153": {
			"name": "Республика Македония",
			"short": "MK",
			"mask": "+389",
			"length": 8
		},
		"154": {
			"name": "Россия",
			"short": "RU",
			"mask": "+7",
			"length": 10
		},
		"155": {
			"name": "Руанда",
			"short": "RW",
			"mask": "+250",
			"length": 9
		},
		"156": {
			"name": "Румыния",
			"short": "RO",
			"mask": "+40",
			"length": 9
		},
		"157": {
			"name": "Сальвадор",
			"short": "SV",
			"mask": "+503",
			"length": 8
		},
		"158": {
			"name": "Самоа",
			"short": "WS",
			"mask": "+685",
			"length": 6
		},
		"159": {
			"name": "Сан-Марино",
			"short": "SM",
			"mask": "+378",
			"length": 8
		},
		"160": {
			"name": "Сан-Томе и Принсипи",
			"short": "ST",
			"mask": "+239",
			"length": 7
		},
		"161": {
			"name": "Саудовская Аравия",
			"short": "SA",
			"mask": "+966",
			"length": 9
		},
		"162": {
			"name": "Свазиленд",
			"short": "SZ",
			"mask": "+268",
			"length": 8
		},
		"163": {
			"name": "Северные Марианские острова",
			"short": "MP",
			"mask": "+1",
			"length": 10
		},
		"164": {
			"name": "Сейшельские Острова",
			"short": "SC",
			"mask": "+248",
			"length": 7
		},
		"165": {
			"name": "Сен-Пьер и Микелон",
			"short": "PM",
			"mask": "+508",
			"length": 6
		},
		"166": {
			"name": "Сенегал",
			"short": "SN",
			"mask": "+221",
			"length": 9
		},
		"167": {
			"name": "Сент-Винсент и Гренадины",
			"short": "VC",
			"mask": "+1",
			"length": 10
		},
		"168": {
			"name": "Сент-Китс и Невис",
			"short": "KN",
			"mask": "+1",
			"length": 10
		},
		"169": {
			"name": "Сент-Люсия",
			"short": "LC",
			"mask": "+1",
			"length": 10
		},
		"170": {
			"name": "Сербия",
			"short": "RS",
			"mask": "+381",
			"length": 9
		},
		"171": {
			"name": "Сингапур",
			"short": "SG",
			"mask": "+65",
			"length": 8
		},
		"172": {
			"name": "Сирия",
			"short": "SY",
			"mask": "+963",
			"length": 9
		},
		"173": {
			"name": "Словакия",
			"short": "SK",
			"mask": "+421",
			"length": 9
		},
		"174": {
			"name": "Словения",
			"short": "SI",
			"mask": "+386",
			"length": 8
		},
		"175": {
			"name": "Соломоновы Острова",
			"short": "SB",
			"mask": "+677",
			"length": 7
		},
		"176": {
			"name": "Сомали",
			"short": "SO",
			"mask": "+252",
			"length": 8
		},
		"177": {
			"name": "Судан",
			"short": "SD",
			"mask": "+249",
			"length": 9
		},
		"178": {
			"name": "Суринам",
			"short": "SR",
			"mask": "+597",
			"length": 7
		},
		"179": {
			"name": "Сьерра-Леоне",
			"short": "SL",
			"mask": "+232",
			"length": 8
		},
		"180": {
			"name": "Таджикистан",
			"short": "TJ",
			"mask": "+992",
			"length": 9
		},
		"181": {
			"name": "Таиланд",
			"short": "TH",
			"mask": "+66",
			"length": 9
		},
		"182": {
			"name": "Танзания",
			"short": "TZ",
			"mask": "+255",
			"length": 9
		},
		"183": {
			"name": "Тёркс и Кайкос",
			"short": "TC",
			"mask": "+1",
			"length": 10
		},
		"184": {
			"name": "Того",
			"short": "TG",
			"mask": "+228",
			"length": 8
		},
		"185": {
			"name": "Токелау",
			"short": "TK",
			"mask": "+676",
			"length": 7
		},
		"186": {
			"name": "Тонга",
			"short": "TO",
			"mask": "+676",
			"length": 7
		},
		"187": {
			"name": "Тринидад и Тобаго",
			"short": "TT",
			"mask": "+1",
			"length": 10
		},
		"188": {
			"name": "Тувалу",
			"short": "TV",
			"mask": "+688",
			"length": 6
		},
		"189": {
			"name": "Тунис",
			"short": "TN",
			"mask": "+216",
			"length": 8
		},
		"190": {
			"name": "Туркмения",
			"short": "TM",
			"mask": "+993",
			"length": 8
		},
		"191": {
			"name": "Уганда",
			"short": "UG",
			"mask": "+256",
			"length": 9
		},
		"192": {
			"name": "Узбекистан",
			"short": "UZ",
			"mask": "+998",
			"length": 9
		},
		"193": {
			"name": "Украина",
			"short": "UA",
			"mask": "+380",
			"length": 9
		},
		"194": {
			"name": "Уоллис и Футуна",
			"short": "WF",
			"mask": "+681",
			"length": 6
		},
		"195": {
			"name": "Уругвай",
			"short": "UY",
			"mask": "+598",
			"length": 8
		},
		"196": {
			"name": "Фарерские острова",
			"short": "FO",
			"mask": "+298",
			"length": 6
		},
		"197": {
			"name": "Фиджи",
			"short": "FJ",
			"mask": "+679",
			"length": 7
		},
		"198": {
			"name": "Филиппины",
			"short": "PH",
			"mask": "+63",
			"length": 10
		},
		"199": {
			"name": "Финляндия",
			"short": "FI",
			"mask": "+358",
			"length": 9
		},
		"200": {
			"name": "Фолклендские острова",
			"short": "FK",
			"mask": "+500",
			"length": 5
		},
		"201": {
			"name": "Французская Полинезия",
			"short": "PF",
			"mask": "+689",
			"length": 9
		},
		"203": {
			"name": "ЦАР",
			"short": "CF",
			"mask": "+236",
			"length": 8
		},
		"204": {
			"name": "Чад",
			"short": "TD",
			"mask": "+235",
			"length": 8
		},
		"205": {
			"name": "Черногория",
			"short": "ME",
			"mask": "+382",
			"length": 8
		},
		"206": {
			"name": "Чехия",
			"short": "CZ",
			"mask": "+420",
			"length": 9
		},
		"207": {
			"name": "Чили",
			"short": "CL",
			"mask": "+56",
			"length": 9
		},
		"208": {
			"name": "Швеция",
			"short": "SE",
			"mask": "+46",
			"length": 9
		},
		"209": {
			"name": "Шпицберген и Ян-Майен",
			"short": "SJ",
			"mask": "+47",
			"length": 8
		},
		"210": {
			"name": "Шри-Ланка",
			"short": "LK",
			"mask": "+94",
			"length": 9
		},
		"211": {
			"name": "Эквадор",
			"short": "EC",
			"mask": "+593",
			"length": 9
		},
		"212": {
			"name": "Экваториальная Гвинея",
			"short": "GQ",
			"mask": "+240",
			"length": 9
		},
		"213": {
			"name": "Эритрея",
			"short": "ER",
			"mask": "+291",
			"length": 7
		},
		"214": {
			"name": "Эстония",
			"short": "EE",
			"mask": "+372",
			"length": 8
		},
		"216": {
			"name": "ЮАР",
			"short": "ZA",
			"mask": "+27",
			"length": 9
		},
		"218": {
			"name": "Ямайка",
			"short": "JM",
			"mask": "+1",
			"length": 10
		},
		"219": {
			"name": "Япония",
			"short": "JP",
			"mask": "+81",
			"length": 10
		}
	};

/***/ },
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.Facebook = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(88);
	
	var _singlePlayer = _interopRequireDefault(__webpack_require__(129));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SDK_URL = '//connect.facebook.net/en_US/sdk.js';
	var SDK_GLOBAL = 'FB';
	var SDK_GLOBAL_READY = 'fbAsyncInit';
	var MATCH_URL = /facebook\.com\/([^/?].+\/)?video(s|\.php)[/?].*$/;
	var PLAYER_ID_PREFIX = 'facebook-player-';
	
	var Facebook =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Facebook, _Component);
	
	  function Facebook() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Facebook);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Facebook)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);
	
	    _defineProperty(_assertThisInitialized(_this), "playerID", PLAYER_ID_PREFIX + (0, _utils.randomString)());
	
	    _defineProperty(_assertThisInitialized(_this), "mute", function () {
	      _this.callPlayer('mute');
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
	      _this.callPlayer('unmute');
	    });
	
	    return _this;
	  }
	
	  _createClass(Facebook, [{
	    key: "load",
	    value: function load(url, isReady) {
	      var _this2 = this;
	
	      if (isReady) {
	        (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
	          return FB.XFBML.parse();
	        });
	        return;
	      }
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
	        FB.init({
	          appId: _this2.props.config.facebook.appId,
	          xfbml: true,
	          version: 'v2.5'
	        });
	        FB.Event.subscribe('xfbml.render', function (msg) {
	          // Here we know the SDK has loaded, even if onReady/onPlay
	          // is not called due to a video that cannot be embedded
	          _this2.props.onLoaded();
	        });
	        FB.Event.subscribe('xfbml.ready', function (msg) {
	          if (msg.type === 'video' && msg.id === _this2.playerID) {
	            _this2.player = msg.instance;
	
	            _this2.player.subscribe('startedPlaying', _this2.props.onPlay);
	
	            _this2.player.subscribe('paused', _this2.props.onPause);
	
	            _this2.player.subscribe('finishedPlaying', _this2.props.onEnded);
	
	            _this2.player.subscribe('startedBuffering', _this2.props.onBuffer);
	
	            _this2.player.subscribe('finishedBuffering', _this2.props.onBufferEnd);
	
	            _this2.player.subscribe('error', _this2.props.onError);
	
	            if (!_this2.props.muted) {
	              // Player is muted by default
	              _this2.callPlayer('unmute');
	            }
	
	            _this2.props.onReady(); // For some reason Facebook have added `visibility: hidden`
	            // to the iframe when autoplay fails, so here we set it back
	
	
	            document.getElementById(_this2.playerID).querySelector('iframe').style.visibility = 'visible';
	          }
	        });
	      });
	    }
	  }, {
	    key: "play",
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: "stop",
	    value: function stop() {// Nothing to do
	    }
	  }, {
	    key: "seekTo",
	    value: function seekTo(seconds) {
	      this.callPlayer('seek', seconds);
	    }
	  }, {
	    key: "setVolume",
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction);
	    }
	  }, {
	    key: "getDuration",
	    value: function getDuration() {
	      return this.callPlayer('getDuration');
	    }
	  }, {
	    key: "getCurrentTime",
	    value: function getCurrentTime() {
	      return this.callPlayer('getCurrentPosition');
	    }
	  }, {
	    key: "getSecondsLoaded",
	    value: function getSecondsLoaded() {
	      return null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var style = {
	        width: '100%',
	        height: '100%'
	      };
	      return _react["default"].createElement("div", {
	        style: style,
	        id: this.playerID,
	        className: "fb-video",
	        "data-href": this.props.url,
	        "data-autoplay": this.props.playing ? 'true' : 'false',
	        "data-allowfullscreen": "true",
	        "data-controls": this.props.controls ? 'true' : 'false'
	      });
	    }
	  }]);
	
	  return Facebook;
	}(_react.Component);
	
	exports.Facebook = Facebook;
	
	_defineProperty(Facebook, "displayName", 'Facebook');
	
	_defineProperty(Facebook, "canPlay", function (url) {
	  return MATCH_URL.test(url);
	});
	
	_defineProperty(Facebook, "loopOnEnded", true);
	
	var _default = (0, _singlePlayer["default"])(Facebook);
	
	exports["default"] = _default;

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.FilePlayer = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(88);
	
	var _singlePlayer = _interopRequireDefault(__webpack_require__(129));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var IOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
	var AUDIO_EXTENSIONS = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
	var VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)($|\?)/i;
	var HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
	var HLS_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/hls.js/VERSION/hls.min.js';
	var HLS_GLOBAL = 'Hls';
	var DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
	var DASH_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/dashjs/VERSION/dash.all.min.js';
	var DASH_GLOBAL = 'dashjs';
	var MATCH_DROPBOX_URL = /www\.dropbox\.com\/.+/;
	
	function canPlay(url) {
	  if (url instanceof Array) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = url[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var item = _step.value;
	
	        if (typeof item === 'string' && canPlay(item)) {
	          return true;
	        }
	
	        if (canPlay(item.src)) {
	          return true;
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
	          _iterator["return"]();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    return false;
	  }
	
	  if ((0, _utils.isMediaStream)(url)) {
	    return true;
	  }
	
	  return AUDIO_EXTENSIONS.test(url) || VIDEO_EXTENSIONS.test(url) || HLS_EXTENSIONS.test(url) || DASH_EXTENSIONS.test(url);
	}
	
	function canEnablePIP(url) {
	  return canPlay(url) && !!document.pictureInPictureEnabled && !AUDIO_EXTENSIONS.test(url);
	}
	
	var FilePlayer =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(FilePlayer, _Component);
	
	  function FilePlayer() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, FilePlayer);
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FilePlayer)).call.apply(_getPrototypeOf2, [this].concat(_args)));
	
	    _defineProperty(_assertThisInitialized(_this), "onReady", function () {
	      var _this$props;
	
	      return (_this$props = _this.props).onReady.apply(_this$props, arguments);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onPlay", function () {
	      var _this$props2;
	
	      return (_this$props2 = _this.props).onPlay.apply(_this$props2, arguments);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onBuffer", function () {
	      var _this$props3;
	
	      return (_this$props3 = _this.props).onBuffer.apply(_this$props3, arguments);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onBufferEnd", function () {
	      var _this$props4;
	
	      return (_this$props4 = _this.props).onBufferEnd.apply(_this$props4, arguments);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onPause", function () {
	      var _this$props5;
	
	      return (_this$props5 = _this.props).onPause.apply(_this$props5, arguments);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onEnded", function () {
	      var _this$props6;
	
	      return (_this$props6 = _this.props).onEnded.apply(_this$props6, arguments);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onError", function () {
	      var _this$props7;
	
	      return (_this$props7 = _this.props).onError.apply(_this$props7, arguments);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onEnablePIP", function () {
	      var _this$props8;
	
	      return (_this$props8 = _this.props).onEnablePIP.apply(_this$props8, arguments);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDisablePIP", function (e) {
	      var _this$props9 = _this.props,
	          onDisablePIP = _this$props9.onDisablePIP,
	          playing = _this$props9.playing;
	      onDisablePIP(e);
	
	      if (playing) {
	        _this.play();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSeek", function (e) {
	      _this.props.onSeek(e.target.currentTime);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "mute", function () {
	      _this.player.muted = true;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
	      _this.player.muted = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "renderSourceElement", function (source, index) {
	      if (typeof source === 'string') {
	        return _react["default"].createElement("source", {
	          key: index,
	          src: source
	        });
	      }
	
	      return _react["default"].createElement("source", _extends({
	        key: index
	      }, source));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "renderTrack", function (track, index) {
	      return _react["default"].createElement("track", _extends({
	        key: index
	      }, track));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ref", function (player) {
	      if (_this.player) {
	        // Store previous player to be used by removeListeners()
	        _this.prevPlayer = _this.player;
	      }
	
	      _this.player = player;
	    });
	
	    return _this;
	  }
	
	  _createClass(FilePlayer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.addListeners(this.player);
	
	      if (IOS) {
	        this.player.load();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(prevProps)) {
	        this.removeListeners(this.prevPlayer);
	        this.addListeners(this.player);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.removeListeners(this.player);
	    }
	  }, {
	    key: "addListeners",
	    value: function addListeners(player) {
	      var playsinline = this.props.playsinline;
	      player.addEventListener('canplay', this.onReady);
	      player.addEventListener('play', this.onPlay);
	      player.addEventListener('waiting', this.onBuffer);
	      player.addEventListener('playing', this.onBufferEnd);
	      player.addEventListener('pause', this.onPause);
	      player.addEventListener('seeked', this.onSeek);
	      player.addEventListener('ended', this.onEnded);
	      player.addEventListener('error', this.onError);
	      player.addEventListener('enterpictureinpicture', this.onEnablePIP);
	      player.addEventListener('leavepictureinpicture', this.onDisablePIP);
	
	      if (playsinline) {
	        player.setAttribute('playsinline', '');
	        player.setAttribute('webkit-playsinline', '');
	        player.setAttribute('x5-playsinline', '');
	      }
	    }
	  }, {
	    key: "removeListeners",
	    value: function removeListeners(player) {
	      player.removeEventListener('canplay', this.onReady);
	      player.removeEventListener('play', this.onPlay);
	      player.removeEventListener('waiting', this.onBuffer);
	      player.removeEventListener('playing', this.onBufferEnd);
	      player.removeEventListener('pause', this.onPause);
	      player.removeEventListener('seeked', this.onSeek);
	      player.removeEventListener('ended', this.onEnded);
	      player.removeEventListener('error', this.onError);
	      player.removeEventListener('enterpictureinpicture', this.onEnablePIP);
	      player.removeEventListener('leavepictureinpicture', this.onDisablePIP);
	    } // Proxy methods to prevent listener leaks
	
	  }, {
	    key: "shouldUseAudio",
	    value: function shouldUseAudio(props) {
	      if (props.config.file.forceVideo) {
	        return false;
	      }
	
	      if (props.config.file.attributes.poster) {
	        return false; // Use <video> so that poster is shown
	      }
	
	      return AUDIO_EXTENSIONS.test(props.url) || props.config.file.forceAudio;
	    }
	  }, {
	    key: "shouldUseHLS",
	    value: function shouldUseHLS(url) {
	      return HLS_EXTENSIONS.test(url) && !IOS || this.props.config.file.forceHLS;
	    }
	  }, {
	    key: "shouldUseDASH",
	    value: function shouldUseDASH(url) {
	      return DASH_EXTENSIONS.test(url) || this.props.config.file.forceDASH;
	    }
	  }, {
	    key: "load",
	    value: function load(url) {
	      var _this2 = this;
	
	      var _this$props$config$fi = this.props.config.file,
	          hlsVersion = _this$props$config$fi.hlsVersion,
	          dashVersion = _this$props$config$fi.dashVersion;
	
	      if (this.shouldUseHLS(url)) {
	        (0, _utils.getSDK)(HLS_SDK_URL.replace('VERSION', hlsVersion), HLS_GLOBAL).then(function (Hls) {
	          _this2.hls = new Hls(_this2.props.config.file.hlsOptions);
	
	          _this2.hls.on(Hls.Events.ERROR, function (e, data) {
	            _this2.props.onError(e, data, _this2.hls, Hls);
	          });
	
	          _this2.hls.loadSource(url);
	
	          _this2.hls.attachMedia(_this2.player);
	        });
	      }
	
	      if (this.shouldUseDASH(url)) {
	        (0, _utils.getSDK)(DASH_SDK_URL.replace('VERSION', dashVersion), DASH_GLOBAL).then(function (dashjs) {
	          _this2.dash = dashjs.MediaPlayer().create();
	
	          _this2.dash.initialize(_this2.player, url, _this2.props.playing);
	
	          _this2.dash.getDebug().setLogToBrowserConsole(false);
	        });
	      }
	
	      if (url instanceof Array) {
	        // When setting new urls (<source>) on an already loaded video,
	        // HTMLMediaElement.load() is needed to reset the media element
	        // and restart the media resource. Just replacing children source
	        // dom nodes is not enough
	        this.player.load();
	      } else if ((0, _utils.isMediaStream)(url)) {
	        try {
	          this.player.srcObject = url;
	        } catch (e) {
	          this.player.src = window.URL.createObjectURL(url);
	        }
	      }
	    }
	  }, {
	    key: "play",
	    value: function play() {
	      var promise = this.player.play();
	
	      if (promise) {
	        promise["catch"](this.props.onError);
	      }
	    }
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.player.pause();
	    }
	  }, {
	    key: "stop",
	    value: function stop() {
	      this.player.removeAttribute('src');
	
	      if (this.hls) {
	        this.hls.destroy();
	      }
	
	      if (this.dash) {
	        this.dash.reset();
	      }
	    }
	  }, {
	    key: "seekTo",
	    value: function seekTo(seconds) {
	      this.player.currentTime = seconds;
	    }
	  }, {
	    key: "setVolume",
	    value: function setVolume(fraction) {
	      this.player.volume = fraction;
	    }
	  }, {
	    key: "enablePIP",
	    value: function enablePIP() {
	      if (this.player.requestPictureInPicture && document.pictureInPictureElement !== this.player) {
	        this.player.requestPictureInPicture();
	      }
	    }
	  }, {
	    key: "disablePIP",
	    value: function disablePIP() {
	      if (document.exitPictureInPicture && document.pictureInPictureElement === this.player) {
	        document.exitPictureInPicture();
	      }
	    }
	  }, {
	    key: "setPlaybackRate",
	    value: function setPlaybackRate(rate) {
	      this.player.playbackRate = rate;
	    }
	  }, {
	    key: "getDuration",
	    value: function getDuration() {
	      if (!this.player) return null;
	      var _this$player = this.player,
	          duration = _this$player.duration,
	          seekable = _this$player.seekable; // on iOS, live streams return Infinity for the duration
	      // so instead we use the end of the seekable timerange
	
	      if (duration === Infinity && seekable.length > 0) {
	        return seekable.end(seekable.length - 1);
	      }
	
	      return duration;
	    }
	  }, {
	    key: "getCurrentTime",
	    value: function getCurrentTime() {
	      if (!this.player) return null;
	      return this.player.currentTime;
	    }
	  }, {
	    key: "getSecondsLoaded",
	    value: function getSecondsLoaded() {
	      if (!this.player) return null;
	      var buffered = this.player.buffered;
	
	      if (buffered.length === 0) {
	        return 0;
	      }
	
	      var end = buffered.end(buffered.length - 1);
	      var duration = this.getDuration();
	
	      if (end > duration) {
	        return duration;
	      }
	
	      return end;
	    }
	  }, {
	    key: "getSource",
	    value: function getSource(url) {
	      var useHLS = this.shouldUseHLS(url);
	      var useDASH = this.shouldUseDASH(url);
	
	      if (url instanceof Array || (0, _utils.isMediaStream)(url) || useHLS || useDASH) {
	        return undefined;
	      }
	
	      if (MATCH_DROPBOX_URL.test(url)) {
	        return url.replace('www.dropbox.com', 'dl.dropboxusercontent.com');
	      }
	
	      return url;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props10 = this.props,
	          url = _this$props10.url,
	          playing = _this$props10.playing,
	          loop = _this$props10.loop,
	          controls = _this$props10.controls,
	          muted = _this$props10.muted,
	          config = _this$props10.config,
	          width = _this$props10.width,
	          height = _this$props10.height;
	      var useAudio = this.shouldUseAudio(this.props);
	      var Element = useAudio ? 'audio' : 'video';
	      var style = {
	        width: width === 'auto' ? width : '100%',
	        height: height === 'auto' ? height : '100%'
	      };
	      return _react["default"].createElement(Element, _extends({
	        ref: this.ref,
	        src: this.getSource(url),
	        style: style,
	        preload: "auto",
	        autoPlay: playing || undefined,
	        controls: controls,
	        muted: muted,
	        loop: loop
	      }, config.file.attributes), url instanceof Array && url.map(this.renderSourceElement), config.file.tracks.map(this.renderTrack));
	    }
	  }]);
	
	  return FilePlayer;
	}(_react.Component);
	
	exports.FilePlayer = FilePlayer;
	
	_defineProperty(FilePlayer, "displayName", 'FilePlayer');
	
	_defineProperty(FilePlayer, "canPlay", canPlay);
	
	_defineProperty(FilePlayer, "canEnablePIP", canEnablePIP);
	
	var _default = (0, _singlePlayer["default"])(FilePlayer);
	
	exports["default"] = _default;

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.Mixcloud = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(88);
	
	var _singlePlayer = _interopRequireDefault(__webpack_require__(129));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SDK_URL = '//widget.mixcloud.com/media/js/widgetApi.js';
	var SDK_GLOBAL = 'Mixcloud';
	var MATCH_URL = /mixcloud\.com\/([^/]+\/[^/]+)/;
	
	var Mixcloud =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Mixcloud, _Component);
	
	  function Mixcloud() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Mixcloud);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Mixcloud)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);
	
	    _defineProperty(_assertThisInitialized(_this), "duration", null);
	
	    _defineProperty(_assertThisInitialized(_this), "currentTime", null);
	
	    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);
	
	    _defineProperty(_assertThisInitialized(_this), "mute", function () {// No volume support
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "unmute", function () {// No volume support
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
	      _this.iframe = iframe;
	    });
	
	    return _this;
	  }
	
	  _createClass(Mixcloud, [{
	    key: "load",
	    value: function load(url) {
	      var _this2 = this;
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Mixcloud) {
	        _this2.player = Mixcloud.PlayerWidget(_this2.iframe);
	
	        _this2.player.ready.then(function () {
	          _this2.player.events.play.on(_this2.props.onPlay);
	
	          _this2.player.events.pause.on(_this2.props.onPause);
	
	          _this2.player.events.ended.on(_this2.props.onEnded);
	
	          _this2.player.events.error.on(_this2.props.error);
	
	          _this2.player.events.progress.on(function (seconds, duration) {
	            _this2.currentTime = seconds;
	            _this2.duration = duration;
	          });
	
	          _this2.props.onReady();
	        });
	      }, this.props.onError);
	    }
	  }, {
	    key: "play",
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: "stop",
	    value: function stop() {// Nothing to do
	    }
	  }, {
	    key: "seekTo",
	    value: function seekTo(seconds) {
	      this.callPlayer('seek', seconds);
	    }
	  }, {
	    key: "setVolume",
	    value: function setVolume(fraction) {// No volume support
	    }
	  }, {
	    key: "getDuration",
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: "getCurrentTime",
	    value: function getCurrentTime() {
	      return this.currentTime;
	    }
	  }, {
	    key: "getSecondsLoaded",
	    value: function getSecondsLoaded() {
	      return null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          url = _this$props.url,
	          config = _this$props.config;
	      var id = url.match(MATCH_URL)[1];
	      var style = {
	        width: '100%',
	        height: '100%'
	      };
	      var query = (0, _utils.queryString)(_objectSpread({}, config.mixcloud.options, {
	        feed: "/".concat(id, "/")
	      })); // We have to give the iframe a key here to prevent a
	      // weird dialog appearing when loading a new track
	
	      return _react["default"].createElement("iframe", {
	        key: id,
	        ref: this.ref,
	        style: style,
	        src: "https://www.mixcloud.com/widget/iframe/?".concat(query),
	        frameBorder: "0"
	      });
	    }
	  }]);
	
	  return Mixcloud;
	}(_react.Component);
	
	exports.Mixcloud = Mixcloud;
	
	_defineProperty(Mixcloud, "displayName", 'Mixcloud');
	
	_defineProperty(Mixcloud, "canPlay", function (url) {
	  return MATCH_URL.test(url);
	});
	
	_defineProperty(Mixcloud, "loopOnEnded", true);
	
	var _default = (0, _singlePlayer["default"])(Mixcloud);
	
	exports["default"] = _default;

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.Streamable = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(88);
	
	var _singlePlayer = _interopRequireDefault(__webpack_require__(129));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SDK_URL = '//cdn.embed.ly/player-0.1.0.min.js';
	var SDK_GLOBAL = 'playerjs';
	var MATCH_URL = /streamable\.com\/([a-z0-9]+)$/;
	
	var Streamable =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Streamable, _Component);
	
	  function Streamable() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Streamable);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Streamable)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);
	
	    _defineProperty(_assertThisInitialized(_this), "duration", null);
	
	    _defineProperty(_assertThisInitialized(_this), "currentTime", null);
	
	    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);
	
	    _defineProperty(_assertThisInitialized(_this), "mute", function () {
	      _this.callPlayer('mute');
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
	      _this.callPlayer('unmute');
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
	      _this.iframe = iframe;
	    });
	
	    return _this;
	  }
	
	  _createClass(Streamable, [{
	    key: "load",
	    value: function load(url) {
	      var _this2 = this;
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (playerjs) {
	        if (!_this2.iframe) return;
	        _this2.player = new playerjs.Player(_this2.iframe);
	
	        _this2.player.setLoop(_this2.props.loop);
	
	        _this2.player.on('ready', _this2.props.onReady);
	
	        _this2.player.on('play', _this2.props.onPlay);
	
	        _this2.player.on('pause', _this2.props.onPause);
	
	        _this2.player.on('seeked', _this2.props.onSeek);
	
	        _this2.player.on('ended', _this2.props.onEnded);
	
	        _this2.player.on('error', _this2.props.onError);
	
	        _this2.player.on('timeupdate', function (_ref) {
	          var duration = _ref.duration,
	              seconds = _ref.seconds;
	          _this2.duration = duration;
	          _this2.currentTime = seconds;
	        });
	
	        _this2.player.on('buffered', function (_ref2) {
	          var percent = _ref2.percent;
	
	          if (_this2.duration) {
	            _this2.secondsLoaded = _this2.duration * percent;
	          }
	        });
	
	        if (_this2.props.muted) {
	          _this2.player.mute();
	        }
	      }, this.props.onError);
	    }
	  }, {
	    key: "play",
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: "stop",
	    value: function stop() {// Nothing to do
	    }
	  }, {
	    key: "seekTo",
	    value: function seekTo(seconds) {
	      this.callPlayer('setCurrentTime', seconds);
	    }
	  }, {
	    key: "setVolume",
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction * 100);
	    }
	  }, {
	    key: "setLoop",
	    value: function setLoop(loop) {
	      this.callPlayer('setLoop', loop);
	    }
	  }, {
	    key: "getDuration",
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: "getCurrentTime",
	    value: function getCurrentTime() {
	      return this.currentTime;
	    }
	  }, {
	    key: "getSecondsLoaded",
	    value: function getSecondsLoaded() {
	      return this.secondsLoaded;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var id = this.props.url.match(MATCH_URL)[1];
	      var style = {
	        width: '100%',
	        height: '100%'
	      };
	      return _react["default"].createElement("iframe", {
	        ref: this.ref,
	        src: "https://streamable.com/o/".concat(id),
	        frameBorder: "0",
	        scrolling: "no",
	        style: style,
	        allowFullScreen: true
	      });
	    }
	  }]);
	
	  return Streamable;
	}(_react.Component);
	
	exports.Streamable = Streamable;
	
	_defineProperty(Streamable, "displayName", 'Streamable');
	
	_defineProperty(Streamable, "canPlay", function (url) {
	  return MATCH_URL.test(url);
	});
	
	var _default = (0, _singlePlayer["default"])(Streamable);
	
	exports["default"] = _default;

/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.Twitch = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(88);
	
	var _singlePlayer = _interopRequireDefault(__webpack_require__(129));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SDK_URL = 'https://player.twitch.tv/js/embed/v1.js';
	var SDK_GLOBAL = 'Twitch';
	var MATCH_VIDEO_URL = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/;
	var MATCH_CHANNEL_URL = /(?:www\.|go\.)?twitch\.tv\/([a-z0-9_]+)($|\?)/;
	var PLAYER_ID_PREFIX = 'twitch-player-';
	
	var Twitch =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Twitch, _Component);
	
	  function Twitch() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Twitch);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Twitch)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);
	
	    _defineProperty(_assertThisInitialized(_this), "playerID", PLAYER_ID_PREFIX + (0, _utils.randomString)());
	
	    _defineProperty(_assertThisInitialized(_this), "mute", function () {
	      _this.callPlayer('setMuted', true);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
	      _this.callPlayer('setMuted', false);
	    });
	
	    return _this;
	  }
	
	  _createClass(Twitch, [{
	    key: "load",
	    value: function load(url, isReady) {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          playsinline = _this$props.playsinline,
	          onError = _this$props.onError,
	          config = _this$props.config;
	      var isChannel = MATCH_CHANNEL_URL.test(url);
	      var id = isChannel ? url.match(MATCH_CHANNEL_URL)[1] : url.match(MATCH_VIDEO_URL)[1];
	
	      if (isReady) {
	        if (isChannel) {
	          this.player.setChannel(id);
	        } else {
	          this.player.setVideo('v' + id);
	        }
	
	        return;
	      }
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Twitch) {
	        _this2.player = new Twitch.Player(_this2.playerID, _objectSpread({
	          video: isChannel ? '' : id,
	          channel: isChannel ? id : '',
	          height: '100%',
	          width: '100%',
	          playsinline: playsinline,
	          autoplay: _this2.props.playing,
	          muted: _this2.props.muted,
	          controls: _this2.props.controls
	        }, config.twitch.options));
	        var _Twitch$Player = Twitch.Player,
	            READY = _Twitch$Player.READY,
	            PLAYING = _Twitch$Player.PLAYING,
	            PAUSE = _Twitch$Player.PAUSE,
	            ENDED = _Twitch$Player.ENDED,
	            ONLINE = _Twitch$Player.ONLINE,
	            OFFLINE = _Twitch$Player.OFFLINE;
	
	        _this2.player.addEventListener(READY, _this2.props.onReady);
	
	        _this2.player.addEventListener(PLAYING, _this2.props.onPlay);
	
	        _this2.player.addEventListener(PAUSE, _this2.props.onPause);
	
	        _this2.player.addEventListener(ENDED, _this2.props.onEnded); // Prevent weird isLoading behaviour when streams are offline
	
	
	        _this2.player.addEventListener(ONLINE, _this2.props.onLoaded);
	
	        _this2.player.addEventListener(OFFLINE, _this2.props.onLoaded);
	      }, onError);
	    }
	  }, {
	    key: "play",
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: "stop",
	    value: function stop() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: "seekTo",
	    value: function seekTo(seconds) {
	      this.callPlayer('seek', seconds);
	    }
	  }, {
	    key: "setVolume",
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction);
	    }
	  }, {
	    key: "getDuration",
	    value: function getDuration() {
	      return this.callPlayer('getDuration');
	    }
	  }, {
	    key: "getCurrentTime",
	    value: function getCurrentTime() {
	      return this.callPlayer('getCurrentTime');
	    }
	  }, {
	    key: "getSecondsLoaded",
	    value: function getSecondsLoaded() {
	      return null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var style = {
	        width: '100%',
	        height: '100%'
	      };
	      return _react["default"].createElement("div", {
	        style: style,
	        id: this.playerID
	      });
	    }
	  }]);
	
	  return Twitch;
	}(_react.Component);
	
	exports.Twitch = Twitch;
	
	_defineProperty(Twitch, "displayName", 'Twitch');
	
	_defineProperty(Twitch, "canPlay", function (url) {
	  return MATCH_VIDEO_URL.test(url) || MATCH_CHANNEL_URL.test(url);
	});
	
	_defineProperty(Twitch, "loopOnEnded", true);
	
	var _default = (0, _singlePlayer["default"])(Twitch);
	
	exports["default"] = _default;

/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.Wistia = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(88);
	
	var _singlePlayer = _interopRequireDefault(__webpack_require__(129));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SDK_URL = '//fast.wistia.com/assets/external/E-v1.js';
	var SDK_GLOBAL = 'Wistia';
	var MATCH_URL = /(?:wistia\.com|wi\.st)\/(?:medias|embed)\/(.*)$/;
	
	var Wistia =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Wistia, _Component);
	
	  function Wistia() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Wistia);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Wistia)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);
	
	    _defineProperty(_assertThisInitialized(_this), "mute", function () {
	      _this.callPlayer('mute');
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
	      _this.callPlayer('unmute');
	    });
	
	    return _this;
	  }
	
	  _createClass(Wistia, [{
	    key: "getID",
	    value: function getID(url) {
	      return url && url.match(MATCH_URL)[1];
	    }
	  }, {
	    key: "load",
	    value: function load(url) {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          playing = _this$props.playing,
	          muted = _this$props.muted,
	          controls = _this$props.controls,
	          _onReady = _this$props.onReady,
	          onPlay = _this$props.onPlay,
	          onPause = _this$props.onPause,
	          onSeek = _this$props.onSeek,
	          onEnded = _this$props.onEnded,
	          config = _this$props.config,
	          onError = _this$props.onError;
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function () {
	        window._wq = window._wq || [];
	
	        window._wq.push({
	          id: _this2.getID(url),
	          options: _objectSpread({
	            autoPlay: playing,
	            silentAutoPlay: 'allow',
	            muted: muted,
	            controlsVisibleOnLoad: controls
	          }, config.wistia.options),
	          onReady: function onReady(player) {
	            _this2.player = player;
	
	            _this2.unbind();
	
	            _this2.player.bind('play', onPlay);
	
	            _this2.player.bind('pause', onPause);
	
	            _this2.player.bind('seek', onSeek);
	
	            _this2.player.bind('end', onEnded);
	
	            _onReady();
	          }
	        });
	      }, onError);
	    }
	  }, {
	    key: "play",
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: "unbind",
	    value: function unbind() {
	      var _this$props2 = this.props,
	          onPlay = _this$props2.onPlay,
	          onPause = _this$props2.onPause,
	          onSeek = _this$props2.onSeek,
	          onEnded = _this$props2.onEnded;
	      this.player.unbind('play', onPlay);
	      this.player.unbind('pause', onPause);
	      this.player.unbind('seek', onSeek);
	      this.player.unbind('end', onEnded);
	    }
	  }, {
	    key: "stop",
	    value: function stop() {
	      this.unbind();
	      this.callPlayer('remove');
	    }
	  }, {
	    key: "seekTo",
	    value: function seekTo(seconds) {
	      this.callPlayer('time', seconds);
	    }
	  }, {
	    key: "setVolume",
	    value: function setVolume(fraction) {
	      this.callPlayer('volume', fraction);
	    }
	  }, {
	    key: "setPlaybackRate",
	    value: function setPlaybackRate(rate) {
	      this.callPlayer('playbackRate', rate);
	    }
	  }, {
	    key: "getDuration",
	    value: function getDuration() {
	      return this.callPlayer('duration');
	    }
	  }, {
	    key: "getCurrentTime",
	    value: function getCurrentTime() {
	      return this.callPlayer('time');
	    }
	  }, {
	    key: "getSecondsLoaded",
	    value: function getSecondsLoaded() {
	      return null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var id = this.getID(this.props.url);
	      var className = "wistia_embed wistia_async_".concat(id);
	      var style = {
	        width: '100%',
	        height: '100%'
	      };
	      return _react["default"].createElement("div", {
	        key: id,
	        className: className,
	        style: style
	      });
	    }
	  }]);
	
	  return Wistia;
	}(_react.Component);
	
	exports.Wistia = Wistia;
	
	_defineProperty(Wistia, "displayName", 'Wistia');
	
	_defineProperty(Wistia, "canPlay", function (url) {
	  return MATCH_URL.test(url);
	});
	
	_defineProperty(Wistia, "loopOnEnded", true);
	
	var _default = (0, _singlePlayer["default"])(Wistia);
	
	exports["default"] = _default;

/***/ },
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(87);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(551);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _stripDiacritics = __webpack_require__(922);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
		autoload: _propTypes2.default.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
		cache: _propTypes2.default.any, // object to use to cache results; set to null/false to disable caching
		children: _propTypes2.default.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
		ignoreAccents: _propTypes2.default.bool, // strip diacritics when filtering; defaults to true
		ignoreCase: _propTypes2.default.bool, // perform case-insensitive filtering; defaults to true
		loadOptions: _propTypes2.default.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
		loadingPlaceholder: _propTypes2.default.oneOfType([// replaces the placeholder while options are loading
		_propTypes2.default.string, _propTypes2.default.node]),
		multi: _propTypes2.default.bool, // multi-value input
		noResultsText: _propTypes2.default.oneOfType([// field noResultsText, displayed when no options come back from the server
		_propTypes2.default.string, _propTypes2.default.node]),
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onInputChange: _propTypes2.default.func, // optional for keeping track of what is being typed
		options: _propTypes2.default.array.isRequired, // array of options
		placeholder: _propTypes2.default.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
		_propTypes2.default.string, _propTypes2.default.node]),
		searchPromptText: _propTypes2.default.oneOfType([// label to prompt for search input
		_propTypes2.default.string, _propTypes2.default.node]),
		value: _propTypes2.default.any // initial field value
	};
	
	var defaultCache = {};
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var defaultProps = {
		autoload: true,
		cache: defaultCache,
		children: defaultChildren,
		ignoreAccents: true,
		ignoreCase: true,
		loadingPlaceholder: 'Loading...',
		options: [],
		searchPromptText: 'Type to search'
	};
	
	var Async = function (_Component) {
		_inherits(Async, _Component);
	
		function Async(props, context) {
			_classCallCheck(this, Async);
	
			var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));
	
			_this._cache = props.cache === defaultCache ? {} : props.cache;
	
			_this.state = {
				inputValue: '',
				isLoading: false,
				options: props.options
			};
	
			_this.onInputChange = _this.onInputChange.bind(_this);
			return _this;
		}
	
		_createClass(Async, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var autoload = this.props.autoload;
	
	
				if (autoload) {
					this.loadOptions('');
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.options !== this.props.options) {
					this.setState({
						options: nextProps.options
					});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this._callback = null;
			}
		}, {
			key: 'loadOptions',
			value: function loadOptions(inputValue) {
				var _this2 = this;
	
				var loadOptions = this.props.loadOptions;
	
				var cache = this._cache;
	
				if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
					this._callback = null;
	
					this.setState({
						isLoading: false,
						options: cache[inputValue]
					});
	
					return;
				}
	
				var callback = function callback(error, data) {
					var options = data && data.options || [];
	
					if (cache) {
						cache[inputValue] = options;
					}
	
					if (callback === _this2._callback) {
						_this2._callback = null;
	
						_this2.setState({
							isLoading: false,
							options: options
						});
					}
				};
	
				// Ignore all but the most recent request
				this._callback = callback;
	
				var promise = loadOptions(inputValue, callback);
				if (promise) {
					promise.then(function (data) {
						return callback(null, data);
					}, function (error) {
						return callback(error);
					});
				}
	
				if (this._callback && !this.state.isLoading) {
					this.setState({
						isLoading: true
					});
				}
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(inputValue) {
				var _props = this.props,
				    ignoreAccents = _props.ignoreAccents,
				    ignoreCase = _props.ignoreCase,
				    onInputChange = _props.onInputChange;
	
				var newInputValue = inputValue;
	
				if (onInputChange) {
					var value = onInputChange(newInputValue);
					// Note: != used deliberately here to catch undefined and null
					if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
						newInputValue = '' + value;
					}
				}
	
				var transformedInputValue = newInputValue;
	
				if (ignoreAccents) {
					transformedInputValue = (0, _stripDiacritics2.default)(transformedInputValue);
				}
	
				if (ignoreCase) {
					transformedInputValue = transformedInputValue.toLowerCase();
				}
	
				this.setState({ inputValue: newInputValue });
				this.loadOptions(transformedInputValue);
	
				// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
				return newInputValue;
			}
		}, {
			key: 'noResultsText',
			value: function noResultsText() {
				var _props2 = this.props,
				    loadingPlaceholder = _props2.loadingPlaceholder,
				    noResultsText = _props2.noResultsText,
				    searchPromptText = _props2.searchPromptText;
				var _state = this.state,
				    inputValue = _state.inputValue,
				    isLoading = _state.isLoading;
	
	
				if (isLoading) {
					return loadingPlaceholder;
				}
				if (inputValue && noResultsText) {
					return noResultsText;
				}
				return searchPromptText;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props3 = this.props,
				    children = _props3.children,
				    loadingPlaceholder = _props3.loadingPlaceholder,
				    placeholder = _props3.placeholder;
				var _state2 = this.state,
				    isLoading = _state2.isLoading,
				    options = _state2.options;
	
	
				var props = {
					noResultsText: this.noResultsText(),
					placeholder: isLoading ? loadingPlaceholder : placeholder,
					options: isLoading && loadingPlaceholder ? [] : options,
					ref: function ref(_ref) {
						return _this3.select = _ref;
					}
				};
	
				return children(_extends({}, this.props, props, {
					isLoading: isLoading,
					onInputChange: this.onInputChange
				}));
			}
		}]);
	
		return Async;
	}(_react.Component);
	
	exports.default = Async;
	
	
	Async.propTypes = propTypes;
	Async.defaultProps = defaultProps;

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(87);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _defaultFilterOptions = __webpack_require__(693);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(694);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Select = __webpack_require__(551);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreatableSelect = function (_React$Component) {
		_inherits(CreatableSelect, _React$Component);
	
		function CreatableSelect(props, context) {
			_classCallCheck(this, CreatableSelect);
	
			var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));
	
			_this.filterOptions = _this.filterOptions.bind(_this);
			_this.menuRenderer = _this.menuRenderer.bind(_this);
			_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
			_this.onInputChange = _this.onInputChange.bind(_this);
			_this.onOptionSelect = _this.onOptionSelect.bind(_this);
			return _this;
		}
	
		_createClass(CreatableSelect, [{
			key: 'createNewOption',
			value: function createNewOption() {
				var _props = this.props,
				    isValidNewOption = _props.isValidNewOption,
				    newOptionCreator = _props.newOptionCreator,
				    onNewOptionClick = _props.onNewOptionClick,
				    _props$options = _props.options,
				    options = _props$options === undefined ? [] : _props$options;
	
	
				if (isValidNewOption({ label: this.inputValue })) {
					var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
					var _isOptionUnique = this.isOptionUnique({ option: option, options: options });
	
					// Don't add the same option twice.
					if (_isOptionUnique) {
						if (onNewOptionClick) {
							onNewOptionClick(option);
						} else {
							options.unshift(option);
	
							this.select.selectValue(option);
						}
					}
				}
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions() {
				var _props2 = this.props,
				    filterOptions = _props2.filterOptions,
				    isValidNewOption = _props2.isValidNewOption,
				    promptTextCreator = _props2.promptTextCreator,
				    showNewOptionAtTop = _props2.showNewOptionAtTop;
	
				// TRICKY Check currently selected options as well.
				// Don't display a create-prompt for a value that's selected.
				// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
	
				var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];
	
				var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
				if (isValidNewOption({ label: this.inputValue })) {
					var _newOptionCreator = this.props.newOptionCreator;
	
	
					var option = _newOptionCreator({
						label: this.inputValue,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
					// For multi-selects, this would remove it from the filtered list.
					var _isOptionUnique2 = this.isOptionUnique({
						option: option,
						options: excludeOptions.concat(filteredOptions)
					});
	
					if (_isOptionUnique2) {
						var prompt = promptTextCreator(this.inputValue);
	
						this._createPlaceholderOption = _newOptionCreator({
							label: prompt,
							labelKey: this.labelKey,
							valueKey: this.valueKey
						});
	
						if (showNewOptionAtTop) {
							filteredOptions.unshift(this._createPlaceholderOption);
						} else {
							filteredOptions.push(this._createPlaceholderOption);
						}
					}
				}
	
				return filteredOptions;
			}
		}, {
			key: 'isOptionUnique',
			value: function isOptionUnique(_ref) {
				var option = _ref.option,
				    options = _ref.options;
				var isOptionUnique = this.props.isOptionUnique;
	
	
				options = options || this.props.options;
	
				return isOptionUnique({
					labelKey: this.labelKey,
					option: option,
					options: options,
					valueKey: this.valueKey
				});
			}
		}, {
			key: 'menuRenderer',
			value: function menuRenderer(params) {
				var menuRenderer = this.props.menuRenderer;
	
	
				return menuRenderer(_extends({}, params, {
					onSelect: this.onOptionSelect,
					selectValue: this.onOptionSelect
				}));
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(input) {
				var onInputChange = this.props.onInputChange;
	
				// This value may be needed in between Select mounts (when this.select is null)
	
				this.inputValue = input;
	
				if (onInputChange) {
					this.inputValue = onInputChange(input);
				}
	
				return this.inputValue;
			}
		}, {
			key: 'onInputKeyDown',
			value: function onInputKeyDown(event) {
				var _props3 = this.props,
				    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
				    onInputKeyDown = _props3.onInputKeyDown;
	
				var focusedOption = this.select.getFocusedOption();
	
				if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
					this.createNewOption();
	
					// Prevent decorated Select from doing anything additional with this keyDown event
					event.preventDefault();
				} else if (onInputKeyDown) {
					onInputKeyDown(event);
				}
			}
		}, {
			key: 'onOptionSelect',
			value: function onOptionSelect(option) {
				if (option === this._createPlaceholderOption) {
					this.createNewOption();
				} else {
					this.select.selectValue(option);
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props4 = this.props,
				    refProp = _props4.ref,
				    restProps = _objectWithoutProperties(_props4, ['ref']);
	
				var children = this.props.children;
	
				// We can't use destructuring default values to set the children,
				// because it won't apply work if `children` is null. A falsy check is
				// more reliable in real world use-cases.
	
				if (!children) {
					children = defaultChildren;
				}
	
				var props = _extends({}, restProps, {
					allowCreate: true,
					filterOptions: this.filterOptions,
					menuRenderer: this.menuRenderer,
					onInputChange: this.onInputChange,
					onInputKeyDown: this.onInputKeyDown,
					ref: function ref(_ref2) {
						_this2.select = _ref2;
	
						// These values may be needed in between Select mounts (when this.select is null)
						if (_ref2) {
							_this2.labelKey = _ref2.props.labelKey;
							_this2.valueKey = _ref2.props.valueKey;
						}
						if (refProp) {
							refProp(_ref2);
						}
					}
				});
	
				return children(props);
			}
		}]);
	
		return CreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var isOptionUnique = function isOptionUnique(_ref3) {
		var option = _ref3.option,
		    options = _ref3.options,
		    labelKey = _ref3.labelKey,
		    valueKey = _ref3.valueKey;
	
		if (!options || !options.length) {
			return true;
		}
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	var isValidNewOption = function isValidNewOption(_ref4) {
		var label = _ref4.label;
		return !!label;
	};
	
	var newOptionCreator = function newOptionCreator(_ref5) {
		var label = _ref5.label,
		    labelKey = _ref5.labelKey,
		    valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
	
		return option;
	};
	
	var promptTextCreator = function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	};
	
	var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
			default:
				return false;
		}
	};
	
	// Default prop methods
	CreatableSelect.isOptionUnique = isOptionUnique;
	CreatableSelect.isValidNewOption = isValidNewOption;
	CreatableSelect.newOptionCreator = newOptionCreator;
	CreatableSelect.promptTextCreator = promptTextCreator;
	CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;
	
	CreatableSelect.defaultProps = {
		filterOptions: _defaultFilterOptions2.default,
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		menuRenderer: _defaultMenuRenderer2.default,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
		showNewOptionAtTop: true
	};
	
	CreatableSelect.propTypes = {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _propTypes2.default.func,
	
		// See Select.propTypes.filterOptions
		filterOptions: _propTypes2.default.any,
	
		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _propTypes2.default.func,
	
		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _propTypes2.default.func,
	
		// See Select.propTypes.menuRenderer
		menuRenderer: _propTypes2.default.any,
	
		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _propTypes2.default.func,
	
		// input change handler: function (inputValue) {}
		onInputChange: _propTypes2.default.func,
	
		// input keyDown handler: function (event) {}
		onInputKeyDown: _propTypes2.default.func,
	
		// new option click handler: function (option) {}
		onNewOptionClick: _propTypes2.default.func,
	
		// See Select.propTypes.options
		options: _propTypes2.default.array,
	
		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _propTypes2.default.func,
	
		ref: _propTypes2.default.func,
	
		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _propTypes2.default.func,
	
		// Where to show prompt/placeholder option text.
		// true: new option prompt at top of list (default)
		// false: new option prompt at bottom of list
		showNewOptionAtTop: _propTypes2.default.bool
	};
	
	exports.default = CreatableSelect;

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(61);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(87);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blockEvent = __webpack_require__(1957);
	
	var _blockEvent2 = _interopRequireDefault(_blockEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = function (_React$Component) {
		_inherits(Option, _React$Component);
	
		function Option(props) {
			_classCallCheck(this, Option);
	
			var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
			_this.handleMouseMove = _this.handleMouseMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.onFocus = _this.onFocus.bind(_this);
			return _this;
		}
	
		_createClass(Option, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onSelect(this.props.option, event);
			}
		}, {
			key: 'handleMouseEnter',
			value: function handleMouseEnter(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleMouseMove',
			value: function handleMouseMove(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'onFocus',
			value: function onFocus(event) {
				if (!this.props.isFocused) {
					this.props.onFocus(this.props.option, event);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    option = _props.option,
				    instancePrefix = _props.instancePrefix,
				    optionIndex = _props.optionIndex;
	
				var className = (0, _classnames2.default)(this.props.className, option.className);
	
				return option.disabled ? _react2.default.createElement(
					'div',
					{ className: className,
						onMouseDown: _blockEvent2.default,
						onClick: _blockEvent2.default },
					this.props.children
				) : _react2.default.createElement(
					'div',
					{ className: className,
						style: option.style,
						role: 'option',
						'aria-label': option.label,
						onMouseDown: this.handleMouseDown,
						onMouseEnter: this.handleMouseEnter,
						onMouseMove: this.handleMouseMove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEnd,
						id: instancePrefix + '-option-' + optionIndex,
						title: option.title },
					this.props.children
				);
			}
		}]);
	
		return Option;
	}(_react2.default.Component);
	
	Option.propTypes = {
		children: _propTypes2.default.node,
		className: _propTypes2.default.string, // className (based on mouse position)
		instancePrefix: _propTypes2.default.string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _propTypes2.default.bool, // the option is disabled
		isFocused: _propTypes2.default.bool, // the option is focused
		isSelected: _propTypes2.default.bool, // the option is selected
		onFocus: _propTypes2.default.func, // method to handle mouseEnter on option element
		onSelect: _propTypes2.default.func, // method to handle click on option element
		onUnfocus: _propTypes2.default.func, // method to handle mouseLeave on option element
		option: _propTypes2.default.object.isRequired, // object that is base for that option
		optionIndex: _propTypes2.default.number // index of the option, used to generate unique ids for aria
	};
	
	exports.default = Option;

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(61);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(87);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Value = function (_React$Component) {
		_inherits(Value, _React$Component);
	
		function Value(props) {
			_classCallCheck(this, Value);
	
			var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.onRemove = _this.onRemove.bind(_this);
			_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			return _this;
		}
	
		_createClass(Value, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				if (event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				if (this.props.onClick) {
					event.stopPropagation();
					this.props.onClick(this.props.value, event);
					return;
				}
				if (this.props.value.href) {
					event.stopPropagation();
				}
			}
		}, {
			key: 'onRemove',
			value: function onRemove(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onRemove(this.props.value);
			}
		}, {
			key: 'handleTouchEndRemove',
			value: function handleTouchEndRemove(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.onRemove(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'renderRemoveIcon',
			value: function renderRemoveIcon() {
				if (this.props.disabled || !this.props.onRemove) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-value-icon',
						'aria-hidden': 'true',
						onMouseDown: this.onRemove,
						onTouchEnd: this.handleTouchEndRemove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove },
					'\xD7'
				);
			}
		}, {
			key: 'renderLabel',
			value: function renderLabel() {
				var className = 'Select-value-label';
				return this.props.onClick || this.props.value.href ? _react2.default.createElement(
					'a',
					{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
					this.props.children
				) : _react2.default.createElement(
					'span',
					{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
					this.props.children
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
						style: this.props.value.style,
						title: this.props.value.title
					},
					this.renderRemoveIcon(),
					this.renderLabel()
				);
			}
		}]);
	
		return Value;
	}(_react2.default.Component);
	
	Value.propTypes = {
		children: _propTypes2.default.node,
		disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
		id: _propTypes2.default.string, // Unique id for the value - used for aria
		onClick: _propTypes2.default.func, // method to handle click on value label
		onRemove: _propTypes2.default.func, // method to handle removal of the value
		value: _propTypes2.default.object.isRequired // the option object for this value
	};
	
	exports.default = Value;

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(87);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arrowRenderer = function arrowRenderer(_ref) {
		var onMouseDown = _ref.onMouseDown;
	
		return _react2.default.createElement('span', {
			className: 'Select-arrow',
			onMouseDown: onMouseDown
		});
	};
	
	arrowRenderer.propTypes = {
		onMouseDown: _propTypes2.default.func
	};
	
	exports.default = arrowRenderer;

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clearRenderer = function clearRenderer() {
		return _react2.default.createElement('span', {
			className: 'Select-clear',
			dangerouslySetInnerHTML: { __html: '&times;' }
		});
	};
	
	exports.default = clearRenderer;

/***/ },
/* 922 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	var stripDiacritics = function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};
	
	exports.default = stripDiacritics;

/***/ },
/* 923 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultCellRangeRenderer;
	
	/**
	 * Default implementation of cellRangeRenderer used by Grid.
	 * This renderer supports cell-caching while the user is scrolling.
	 */
	function defaultCellRangeRenderer(_ref) {
	  var cellCache = _ref.cellCache;
	  var cellRenderer = _ref.cellRenderer;
	  var columnSizeAndPositionManager = _ref.columnSizeAndPositionManager;
	  var columnStartIndex = _ref.columnStartIndex;
	  var columnStopIndex = _ref.columnStopIndex;
	  var horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment;
	  var isScrolling = _ref.isScrolling;
	  var rowSizeAndPositionManager = _ref.rowSizeAndPositionManager;
	  var rowStartIndex = _ref.rowStartIndex;
	  var rowStopIndex = _ref.rowStopIndex;
	  var scrollLeft = _ref.scrollLeft;
	  var scrollTop = _ref.scrollTop;
	  var verticalOffsetAdjustment = _ref.verticalOffsetAdjustment;
	  var visibleColumnIndices = _ref.visibleColumnIndices;
	  var visibleRowIndices = _ref.visibleRowIndices;
	
	  var renderedCells = [];
	
	  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
	    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);
	
	    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
	      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
	      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
	      var key = rowIndex + '-' + columnIndex;
	      var style = {
	        height: rowDatum.size,
	        left: columnDatum.offset + horizontalOffsetAdjustment,
	        position: 'absolute',
	        top: rowDatum.offset + verticalOffsetAdjustment,
	        width: columnDatum.size
	      };
	
	      var cellRendererParams = {
	        columnIndex: columnIndex,
	        isScrolling: isScrolling,
	        isVisible: isVisible,
	        key: key,
	        rowIndex: rowIndex,
	        style: style
	      };
	
	      var renderedCell = void 0;
	
	      // Avoid re-creating cells while scrolling.
	      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
	      // If a scroll is in progress- cache and reuse cells.
	      // This cache will be thrown away once scrolling completes.
	      // However if we are scaling scroll positions and sizes, we should also avoid caching.
	      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
	      // For more info refer to issue #395
	      if (isScrolling && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
	        if (!cellCache[key]) {
	          cellCache[key] = cellRenderer(cellRendererParams);
	        }
	        renderedCell = cellCache[key];
	        // If the user is no longer scrolling, don't cache cells.
	        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
	      } else {
	        renderedCell = cellRenderer(cellRendererParams);
	      }
	
	      if (renderedCell == null || renderedCell === false) {
	        continue;
	      }
	
	      renderedCells.push(renderedCell);
	    }
	  }
	
	  return renderedCells;
	}

/***/ },
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(930)

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _io = __webpack_require__(556);
	
	Object.defineProperty(exports, 'take', {
	  enumerable: true,
	  get: function get() {
	    return _io.take;
	  }
	});
	Object.defineProperty(exports, 'takem', {
	  enumerable: true,
	  get: function get() {
	    return _io.takem;
	  }
	});
	Object.defineProperty(exports, 'put', {
	  enumerable: true,
	  get: function get() {
	    return _io.put;
	  }
	});
	Object.defineProperty(exports, 'race', {
	  enumerable: true,
	  get: function get() {
	    return _io.race;
	  }
	});
	Object.defineProperty(exports, 'call', {
	  enumerable: true,
	  get: function get() {
	    return _io.call;
	  }
	});
	Object.defineProperty(exports, 'apply', {
	  enumerable: true,
	  get: function get() {
	    return _io.apply;
	  }
	});
	Object.defineProperty(exports, 'cps', {
	  enumerable: true,
	  get: function get() {
	    return _io.cps;
	  }
	});
	Object.defineProperty(exports, 'fork', {
	  enumerable: true,
	  get: function get() {
	    return _io.fork;
	  }
	});
	Object.defineProperty(exports, 'spawn', {
	  enumerable: true,
	  get: function get() {
	    return _io.spawn;
	  }
	});
	Object.defineProperty(exports, 'join', {
	  enumerable: true,
	  get: function get() {
	    return _io.join;
	  }
	});
	Object.defineProperty(exports, 'cancel', {
	  enumerable: true,
	  get: function get() {
	    return _io.cancel;
	  }
	});
	Object.defineProperty(exports, 'select', {
	  enumerable: true,
	  get: function get() {
	    return _io.select;
	  }
	});
	Object.defineProperty(exports, 'actionChannel', {
	  enumerable: true,
	  get: function get() {
	    return _io.actionChannel;
	  }
	});
	Object.defineProperty(exports, 'cancelled', {
	  enumerable: true,
	  get: function get() {
	    return _io.cancelled;
	  }
	});
	Object.defineProperty(exports, 'flush', {
	  enumerable: true,
	  get: function get() {
	    return _io.flush;
	  }
	});

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TASK_CANCEL = exports.CHANNEL_END = exports.NOT_ITERATOR_ERROR = undefined;
	exports.default = proc;
	
	var _utils = __webpack_require__(144);
	
	var _scheduler = __webpack_require__(932);
	
	var _io = __webpack_require__(556);
	
	var _channel = __webpack_require__(555);
	
	var _buffers = __webpack_require__(554);
	
	function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var isDev = ("production") === 'development';
	
	var NOT_ITERATOR_ERROR = exports.NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';
	
	var CHANNEL_END = exports.CHANNEL_END = {
	  toString: function toString() {
	    return '@@redux-saga/CHANNEL_END';
	  }
	};
	var TASK_CANCEL = exports.TASK_CANCEL = {
	  toString: function toString() {
	    return '@@redux-saga/TASK_CANCEL';
	  }
	};
	
	var matchers = {
	  wildcard: function wildcard() {
	    return _utils.kTrue;
	  },
	  default: function _default(pattern) {
	    return function (input) {
	      return input.type === pattern;
	    };
	  },
	  array: function array(patterns) {
	    return function (input) {
	      return patterns.some(function (p) {
	        return p === input.type;
	      });
	    };
	  },
	  predicate: function predicate(_predicate) {
	    return function (input) {
	      return _predicate(input);
	    };
	  }
	};
	
	function matcher(pattern) {
	  return (pattern === '*' ? matchers.wildcard : _utils.is.array(pattern) ? matchers.array : _utils.is.func(pattern) ? matchers.predicate : matchers.default)(pattern);
	}
	
	/**
	  Used to track a parent task and its forks
	  In the new fork model, forked tasks are attached by default to their parent
	  We model this using the concept of Parent task && main Task
	  main task is the main flow of the current Generator, the parent tasks is the
	  aggregation of the main tasks + all its forked tasks.
	  Thus the whole model represents an execution tree with multiple branches (vs the
	  linear execution tree in sequential (non parallel) programming)
	
	  A parent tasks has the following semantics
	  - It completes iff all its forks either complete or all cancelled
	  - If it's cancelled, all forks are cancelled as well
	  - It aborts if any uncaught error bubbles up from forks
	  - If it completes, the return value is the one returned by the main task
	**/
	function forkQueue(name, mainTask, cb) {
	  var tasks = [],
	      result = void 0,
	      completed = false;
	  addTask(mainTask);
	
	  function abort(err) {
	    cancelAll();
	    cb(err, true);
	  }
	
	  function addTask(task) {
	    tasks.push(task);
	    task.cont = function (res, isErr) {
	      if (completed) {
	        return;
	      }
	
	      (0, _utils.remove)(tasks, task);
	      task.cont = _utils.noop;
	      if (isErr) {
	        abort(res);
	      } else {
	        if (task === mainTask) {
	          result = res;
	        }
	        if (!tasks.length) {
	          completed = true;
	          cb(result);
	        }
	      }
	    };
	    // task.cont.cancel = task.cancel
	  }
	
	  function cancelAll() {
	    if (completed) {
	      return;
	    }
	    completed = true;
	    tasks.forEach(function (t) {
	      t.cont = _utils.noop;
	      t.cancel();
	    });
	    tasks = [];
	  }
	
	  return {
	    addTask: addTask,
	    cancelAll: cancelAll,
	    abort: abort,
	    getTasks: function getTasks() {
	      return tasks;
	    },
	    taskNames: function taskNames() {
	      return tasks.map(function (t) {
	        return t.name;
	      });
	    }
	  };
	}
	
	function createTaskIterator(_ref) {
	  var context = _ref.context,
	      fn = _ref.fn,
	      args = _ref.args;
	
	  if (_utils.is.iterator(fn)) {
	    return fn;
	  }
	
	  // catch synchronous failures; see #152 and #441
	  var result = void 0,
	      error = void 0;
	  try {
	    result = fn.apply(context, args);
	  } catch (err) {
	    error = err;
	  }
	
	  // i.e. a generator function returns an iterator
	  if (_utils.is.iterator(result)) {
	    return result;
	  }
	
	  // do not bubble up synchronous failures for detached forks
	  // instead create a failed task. See #152 and #441
	  return error ? (0, _utils.makeIterator)(function () {
	    throw error;
	  }) : (0, _utils.makeIterator)(function () {
	    var pc = void 0;
	    var eff = { done: false, value: result };
	    var ret = function ret(value) {
	      return { done: true, value: value };
	    };
	    return function (arg) {
	      if (!pc) {
	        pc = true;
	        return eff;
	      } else {
	        return ret(arg);
	      }
	    };
	  }());
	}
	
	function wrapHelper(helper) {
	  return {
	    fn: helper
	  };
	}
	
	function proc(iterator) {
	  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
	    return _utils.noop;
	  };
	  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _utils.noop;
	  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _utils.noop;
	  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	  var parentEffectId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	  var name = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'anonymous';
	  var cont = arguments[7];
	
	  (0, _utils.check)(iterator, _utils.is.iterator, NOT_ITERATOR_ERROR);
	
	  var sagaMonitor = options.sagaMonitor,
	      logger = options.logger,
	      onError = options.onError;
	
	  var log = logger || _utils.log;
	  var stdChannel = (0, _channel.stdChannel)(subscribe);
	  /**
	    Tracks the current effect cancellation
	    Each time the generator progresses. calling runEffect will set a new value
	    on it. It allows propagating cancellation to child effects
	  **/
	  next.cancel = _utils.noop;
	
	  /**
	    Creates a new task descriptor for this generator, We'll also create a main task
	    to track the main flow (besides other forked tasks)
	  **/
	  var task = newTask(parentEffectId, name, iterator, cont);
	  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
	  var taskQueue = forkQueue(name, mainTask, end);
	
	  /**
	    cancellation of the main task. We'll simply resume the Generator with a Cancel
	  **/
	  function cancelMain() {
	    if (mainTask.isRunning && !mainTask.isCancelled) {
	      mainTask.isCancelled = true;
	      next(TASK_CANCEL);
	    }
	  }
	
	  /**
	    This may be called by a parent generator to trigger/propagate cancellation
	    cancel all pending tasks (including the main task), then end the current task.
	      Cancellation propagates down to the whole execution tree holded by this Parent task
	    It's also propagated to all joiners of this task and their execution tree/joiners
	      Cancellation is noop for terminated/Cancelled tasks tasks
	  **/
	  function cancel() {
	    /**
	      We need to check both Running and Cancelled status
	      Tasks can be Cancelled but still Running
	    **/
	    if (iterator._isRunning && !iterator._isCancelled) {
	      iterator._isCancelled = true;
	      taskQueue.cancelAll();
	      /**
	        Ending with a Never result will propagate the Cancellation to all joiners
	      **/
	      end(TASK_CANCEL);
	    }
	  }
	  /**
	    attaches cancellation logic to this task's continuation
	    this will permit cancellation to propagate down the call chain
	  **/
	  cont && (cont.cancel = cancel);
	
	  // tracks the running status
	  iterator._isRunning = true;
	
	  // kicks up the generator
	  next();
	
	  // then return the task descriptor to the caller
	  return task;
	
	  /**
	    This is the generator driver
	    It's a recursive async/continuation function which calls itself
	    until the generator terminates or throws
	  **/
	  function next(arg, isErr) {
	    // Preventive measure. If we end up here, then there is really something wrong
	    if (!mainTask.isRunning) {
	      throw new Error('Trying to resume an already finished generator');
	    }
	
	    try {
	      var result = void 0;
	      if (isErr) {
	        result = iterator.throw(arg);
	      } else if (arg === TASK_CANCEL) {
	        /**
	          getting TASK_CANCEL autoamtically cancels the main task
	          We can get this value here
	            - By cancelling the parent task manually
	          - By joining a Cancelled task
	        **/
	        mainTask.isCancelled = true;
	        /**
	          Cancels the current effect; this will propagate the cancellation down to any called tasks
	        **/
	        next.cancel();
	        /**
	          If this Generator has a `return` method then invokes it
	          Thill will jump to the finally block
	        **/
	        result = _utils.is.func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
	      } else if (arg === CHANNEL_END) {
	        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
	        result = _utils.is.func(iterator.return) ? iterator.return() : { done: true };
	      } else {
	        result = iterator.next(arg);
	      }
	
	      if (!result.done) {
	        runEffect(result.value, parentEffectId, '', next);
	      } else {
	        /**
	          This Generator has ended, terminate the main task and notify the fork queue
	        **/
	        mainTask.isMainRunning = false;
	        mainTask.cont && mainTask.cont(result.value);
	      }
	    } catch (error) {
	      if (mainTask.isCancelled) {
	        log('error', 'uncaught at ' + name, error.message);
	      }
	      mainTask.isMainRunning = false;
	      mainTask.cont(error, true);
	    }
	  }
	
	  function end(result, isErr) {
	    iterator._isRunning = false;
	    stdChannel.close();
	    if (!isErr) {
	      if (result === TASK_CANCEL && isDev) {
	        log('info', name + ' has been cancelled', '');
	      }
	      iterator._result = result;
	      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
	    } else {
	      if (result instanceof Error) {
	        result.sagaStack = 'at ' + name + ' \n ' + (result.sagaStack || result.stack);
	      }
	      if (!task.cont) {
	        log('error', 'uncaught', result.sagaStack || result.stack);
	        if (result instanceof Error && onError) {
	          onError(result);
	        }
	      }
	      iterator._error = result;
	      iterator._isAborted = true;
	      iterator._deferredEnd && iterator._deferredEnd.reject(result);
	    }
	    task.cont && task.cont(result, isErr);
	    task.joiners.forEach(function (j) {
	      return j.cb(result, isErr);
	    });
	    task.joiners = null;
	  }
	
	  function runEffect(effect, parentEffectId) {
	    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var cb = arguments[3];
	
	    var effectId = (0, _utils.uid)();
	    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });
	
	    /**
	      completion callback and cancel callback are mutually exclusive
	      We can't cancel an already completed effect
	      And We can't complete an already cancelled effectId
	    **/
	    var effectSettled = void 0;
	
	    // Completion callback passed to the appropriate effect runner
	    function currCb(res, isErr) {
	      if (effectSettled) {
	        return;
	      }
	
	      effectSettled = true;
	      cb.cancel = _utils.noop; // defensive measure
	      if (sagaMonitor) {
	        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
	      }
	
	      cb(res, isErr);
	    }
	    // tracks down the current cancel
	    currCb.cancel = _utils.noop;
	
	    // setup cancellation logic on the parent cb
	    cb.cancel = function () {
	      // prevents cancelling an already completed effect
	      if (effectSettled) {
	        return;
	      }
	
	      effectSettled = true;
	      /**
	        propagates cancel downward
	        catch uncaught cancellations errors; since we can no longer call the completion
	        callback, log errors raised during cancellations into the console
	      **/
	      try {
	        currCb.cancel();
	      } catch (err) {
	        log('error', 'uncaught at ' + name, err.message);
	      }
	      currCb.cancel = _utils.noop; // defensive measure
	
	      sagaMonitor && sagaMonitor.effectCancelled(effectId);
	    };
	
	    /**
	      each effect runner must attach its own logic of cancellation to the provided callback
	      it allows this generator to propagate cancellation downward.
	        ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
	      And the setup must occur before calling the callback
	        This is a sort of inversion of control: called async functions are responsible
	      of completing the flow by calling the provided continuation; while caller functions
	      are responsible for aborting the current flow by calling the attached cancel function
	        Library users can attach their own cancellation logic to promises by defining a
	      promise[CANCEL] method in their returned promises
	      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
	    **/
	    var data = void 0;
	    return (
	      // Non declarative effect
	      _utils.is.promise(effect) ? resolvePromise(effect, currCb) : _utils.is.helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : _utils.is.iterator(effect) ? resolveIterator(effect, effectId, name, currCb)
	
	      // declarative effects
	      : _utils.is.array(effect) ? runParallelEffect(effect, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.take(effect)) ? runTakeEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.put(effect)) ? runPutEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.race(effect)) ? runRaceEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.call(effect)) ? runCallEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.cps(effect)) ? runCPSEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.fork(effect)) ? runForkEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.join(effect)) ? runJoinEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.cancel(effect)) ? runCancelEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.select(effect)) ? runSelectEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.actionChannel(effect)) ? runChannelEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.flush(effect)) ? runFlushEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.cancelled(effect)) ? runCancelledEffect(data, currCb) : /* anything else returned as is        */currCb(effect)
	    );
	  }
	
	  function resolvePromise(promise, cb) {
	    var cancelPromise = promise[_utils.CANCEL];
	    if (typeof cancelPromise === 'function') {
	      cb.cancel = cancelPromise;
	    }
	    promise.then(cb, function (error) {
	      return cb(error, true);
	    });
	  }
	
	  function resolveIterator(iterator, effectId, name, cb) {
	    proc(iterator, subscribe, dispatch, getState, options, effectId, name, cb);
	  }
	
	  function runTakeEffect(_ref2, cb) {
	    var channel = _ref2.channel,
	        pattern = _ref2.pattern,
	        maybe = _ref2.maybe;
	
	    channel = channel || stdChannel;
	    var takeCb = function takeCb(inp) {
	      return inp instanceof Error ? cb(inp, true) : (0, _channel.isEnd)(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
	    };
	    try {
	      channel.take(takeCb, matcher(pattern));
	    } catch (err) {
	      return cb(err, true);
	    }
	    cb.cancel = takeCb.cancel;
	  }
	
	  function runPutEffect(_ref3, cb) {
	    var channel = _ref3.channel,
	        action = _ref3.action,
	        sync = _ref3.sync;
	
	    /**
	      Schedule the put in case another saga is holding a lock.
	      The put will be executed atomically. ie nested puts will execute after
	      this put has terminated.
	    **/
	    (0, _scheduler.asap)(function () {
	      var result = void 0;
	      try {
	        result = (channel ? channel.put : dispatch)(action);
	      } catch (error) {
	        // If we have a channel or `put.sync` was used then bubble up the error.
	        if (channel || sync) return cb(error, true);
	        log('error', 'uncaught at ' + name, error.stack || error.message || error);
	      }
	
	      if (sync && _utils.is.promise(result)) {
	        resolvePromise(result, cb);
	      } else {
	        return cb(result);
	      }
	    });
	    // Put effects are non cancellables
	  }
	
	  function runCallEffect(_ref4, effectId, cb) {
	    var context = _ref4.context,
	        fn = _ref4.fn,
	        args = _ref4.args;
	
	    var result = void 0;
	    // catch synchronous failures; see #152
	    try {
	      result = fn.apply(context, args);
	    } catch (error) {
	      return cb(error, true);
	    }
	    return _utils.is.promise(result) ? resolvePromise(result, cb) : _utils.is.iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
	  }
	
	  function runCPSEffect(_ref5, cb) {
	    var context = _ref5.context,
	        fn = _ref5.fn,
	        args = _ref5.args;
	
	    // CPS (ie node style functions) can define their own cancellation logic
	    // by setting cancel field on the cb
	
	    // catch synchronous failures; see #152
	    try {
	      (function () {
	        var cpsCb = function cpsCb(err, res) {
	          return _utils.is.undef(err) ? cb(res) : cb(err, true);
	        };
	        fn.apply(context, args.concat(cpsCb));
	        if (cpsCb.cancel) {
	          cb.cancel = function () {
	            return cpsCb.cancel();
	          };
	        }
	      })();
	    } catch (error) {
	      return cb(error, true);
	    }
	  }
	
	  function runForkEffect(_ref6, effectId, cb) {
	    var context = _ref6.context,
	        fn = _ref6.fn,
	        args = _ref6.args,
	        detached = _ref6.detached;
	
	    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });
	
	    try {
	      (0, _scheduler.suspend)();
	      var _task = proc(taskIterator, subscribe, dispatch, getState, options, effectId, fn.name, detached ? null : _utils.noop);
	
	      if (detached) {
	        cb(_task);
	      } else {
	        if (taskIterator._isRunning) {
	          taskQueue.addTask(_task);
	          cb(_task);
	        } else if (taskIterator._error) {
	          taskQueue.abort(taskIterator._error);
	        } else {
	          cb(_task);
	        }
	      }
	    } finally {
	      (0, _scheduler.flush)();
	    }
	    // Fork effects are non cancellables
	  }
	
	  function runJoinEffect(t, cb) {
	    if (t.isRunning()) {
	      (function () {
	        var joiner = { task: task, cb: cb };
	        cb.cancel = function () {
	          return (0, _utils.remove)(t.joiners, joiner);
	        };
	        t.joiners.push(joiner);
	      })();
	    } else {
	      t.isAborted() ? cb(t.error(), true) : cb(t.result());
	    }
	  }
	
	  function runCancelEffect(task, cb) {
	    if (task.isRunning()) {
	      task.cancel();
	    }
	    cb();
	    // cancel effects are non cancellables
	  }
	
	  function runParallelEffect(effects, effectId, cb) {
	    if (!effects.length) {
	      return cb([]);
	    }
	
	    var completedCount = 0;
	    var completed = void 0;
	    var results = Array(effects.length);
	
	    function checkEffectEnd() {
	      if (completedCount === results.length) {
	        completed = true;
	        cb(results);
	      }
	    }
	
	    var childCbs = effects.map(function (eff, idx) {
	      var chCbAtIdx = function chCbAtIdx(res, isErr) {
	        if (completed) {
	          return;
	        }
	        if (isErr || (0, _channel.isEnd)(res) || res === CHANNEL_END || res === TASK_CANCEL) {
	          cb.cancel();
	          cb(res, isErr);
	        } else {
	          results[idx] = res;
	          completedCount++;
	          checkEffectEnd();
	        }
	      };
	      chCbAtIdx.cancel = _utils.noop;
	      return chCbAtIdx;
	    });
	
	    cb.cancel = function () {
	      if (!completed) {
	        completed = true;
	        childCbs.forEach(function (chCb) {
	          return chCb.cancel();
	        });
	      }
	    };
	
	    effects.forEach(function (eff, idx) {
	      return runEffect(eff, effectId, idx, childCbs[idx]);
	    });
	  }
	
	  function runRaceEffect(effects, effectId, cb) {
	    var completed = void 0;
	    var keys = Object.keys(effects);
	    var childCbs = {};
	
	    keys.forEach(function (key) {
	      var chCbAtKey = function chCbAtKey(res, isErr) {
	        if (completed) {
	          return;
	        }
	
	        if (isErr) {
	          // Race Auto cancellation
	          cb.cancel();
	          cb(res, true);
	        } else if (!(0, _channel.isEnd)(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
	          cb.cancel();
	          completed = true;
	          cb(_defineProperty({}, key, res));
	        }
	      };
	      chCbAtKey.cancel = _utils.noop;
	      childCbs[key] = chCbAtKey;
	    });
	
	    cb.cancel = function () {
	      // prevents unnecessary cancellation
	      if (!completed) {
	        completed = true;
	        keys.forEach(function (key) {
	          return childCbs[key].cancel();
	        });
	      }
	    };
	    keys.forEach(function (key) {
	      if (completed) {
	        return;
	      }
	      runEffect(effects[key], effectId, key, childCbs[key]);
	    });
	  }
	
	  function runSelectEffect(_ref7, cb) {
	    var selector = _ref7.selector,
	        args = _ref7.args;
	
	    try {
	      var state = selector.apply(undefined, [getState()].concat(_toConsumableArray(args)));
	      cb(state);
	    } catch (error) {
	      cb(error, true);
	    }
	  }
	
	  function runChannelEffect(_ref8, cb) {
	    var pattern = _ref8.pattern,
	        buffer = _ref8.buffer;
	
	    var match = matcher(pattern);
	    match.pattern = pattern;
	    cb((0, _channel.eventChannel)(subscribe, buffer || _buffers.buffers.fixed(), match));
	  }
	
	  function runCancelledEffect(data, cb) {
	    cb(!!mainTask.isCancelled);
	  }
	
	  function runFlushEffect(channel, cb) {
	    channel.flush(cb);
	  }
	
	  function newTask(id, name, iterator, cont) {
	    var _done, _ref9, _mutatorMap;
	
	    iterator._deferredEnd = null;
	    return _ref9 = {}, _defineProperty(_ref9, _utils.TASK, true), _defineProperty(_ref9, 'id', id), _defineProperty(_ref9, 'name', name), _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
	      if (iterator._deferredEnd) {
	        return iterator._deferredEnd.promise;
	      } else {
	        var def = (0, _utils.deferred)();
	        iterator._deferredEnd = def;
	        if (!iterator._isRunning) {
	          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
	        }
	        return def.promise;
	      }
	    }, _defineProperty(_ref9, 'cont', cont), _defineProperty(_ref9, 'joiners', []), _defineProperty(_ref9, 'cancel', cancel), _defineProperty(_ref9, 'isRunning', function isRunning() {
	      return iterator._isRunning;
	    }), _defineProperty(_ref9, 'isCancelled', function isCancelled() {
	      return iterator._isCancelled;
	    }), _defineProperty(_ref9, 'isAborted', function isAborted() {
	      return iterator._isAborted;
	    }), _defineProperty(_ref9, 'result', function result() {
	      return iterator._result;
	    }), _defineProperty(_ref9, 'error', function error() {
	      return iterator._error;
	    }), _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
	  }
	}

/***/ },
/* 932 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.asap = asap;
	exports.suspend = suspend;
	exports.flush = flush;
	
	var queue = [];
	/**
	  Variable to hold a counting semaphore
	  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
	    already suspended)
	  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
	    triggers flushing the queued tasks.
	**/
	var semaphore = 0;
	
	/**
	  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
	  and flushed after this task has finished (assuming the scheduler endup in a released
	  state).
	**/
	function exec(task) {
	  try {
	    suspend();
	    task();
	  } finally {
	    flush();
	  }
	}
	
	/**
	  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
	**/
	function asap(task) {
	  if (!semaphore) {
	    exec(task);
	  } else {
	    queue.push(task);
	  }
	}
	
	/**
	  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
	  scheduler is released.
	**/
	function suspend() {
	  semaphore++;
	}
	
	/**
	  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
	**/
	function flush() {
	  semaphore--;
	  if (!semaphore && queue.length) {
	    exec(queue.shift());
	  }
	}

/***/ },
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_CONNECTION_STATUS = exports.SET_CONNECTION_STATUS = 'SET_CONNECTION_STATUS';

/***/ },
/* 950 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GET_NEW_MESSAGES_COUNT = exports.GET_NEW_MESSAGES_COUNT = 'GET_NEW_MESSAGES_COUNT';
	var SUCCESS_GET_NEW_MESSAGES_COUNT = exports.SUCCESS_GET_NEW_MESSAGES_COUNT = 'SUCCESS_GET_NEW_MESSAGES_COUNT';
	var FAILURE_GET_NEW_MESSAGES_COUNT = exports.FAILURE_GET_NEW_MESSAGES_COUNT = 'FAILURE_GET_NEW_MESSAGES_COUNT';

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FAILURE_ACTIVATION = exports.SUCCESS_ACTIVATION = exports.ACTIVATION = undefined;
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.activation = activation;
	
	var _api = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ACTIVATION = exports.ACTIVATION = 'ACTIVATION';
	var SUCCESS_ACTIVATION = exports.SUCCESS_ACTIVATION = 'SUCCESS_ACTIVATION';
	var FAILURE_ACTIVATION = exports.FAILURE_ACTIVATION = 'FAILURE_ACTIVATION';
	
	function fetchActivation(data) {
	    var email = data.email;
	
	    return (0, _defineProperty3.default)({
	        type: ACTIVATION
	    }, _api.CALL_API, {
	        endpoint: '/api/activation?email=' + email,
	        method: 'get',
	        types: [SUCCESS_ACTIVATION, FAILURE_ACTIVATION]
	    });
	}
	
	function activation(data) {
	    return function (dispatch) {
	        dispatch(fetchActivation(data));
	    };
	}

/***/ },
/* 952 */,
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.cancelBigStakeRequest = cancelBigStakeRequest;
	
	var _api = __webpack_require__(13);
	
	var _BigStakeRequest = __webpack_require__(704);
	
	var ActionTypes = _interopRequireWildcard(_BigStakeRequest);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchCancelBigStakeRequest(data) {
	    var betId = data.betId,
	        stakeId = data.stakeId;
	
	    return (0, _defineProperty3.default)({
	        type: ActionTypes.CANCEL_BIG_STAKE_REQUEST
	    }, _api.CALL_API, {
	        endpoint: '/api/bet/' + betId + '/big-stake/' + stakeId + '/cancel',
	        method: 'post',
	        types: [ActionTypes.SUCCESS_BIG_STAKE_REQUEST_CANCEL, ActionTypes.FAILURE_BIG_STAKE_REQUEST_CANCEL],
	        credentials: true,
	        data: data
	    });
	}
	
	function cancelBigStakeRequest(data) {
	    return function (dispatch) {
	        return dispatch(fetchCancelBigStakeRequest(data));
	    };
	}

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.createCashout = createCashout;
	exports.setCashoutStatus = setCashoutStatus;
	
	var _api = __webpack_require__(13);
	
	var _Cashout = __webpack_require__(705);
	
	var ActionTypes = _interopRequireWildcard(_Cashout);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchCreateCashout(data) {
	    var betId = data.betId,
	        stakeId = data.stakeId,
	        amount = data.amount;
	
	    return (0, _defineProperty3.default)({
	        type: ActionTypes.CREATE_CASHOUT
	    }, _api.CALL_API, {
	        endpoint: '/api/bet/' + betId + '/stake/' + stakeId + '/cashout?amount=' + amount,
	        method: 'post',
	        types: [ActionTypes.SUCCESS_CREATE_CASHOUT, ActionTypes.FAILURE_CREATE_CASHOUT],
	        credentials: true,
	        data: data
	    });
	}
	
	function createCashout(data) {
	    return function (dispatch) {
	        return dispatch(fetchCreateCashout(data));
	    };
	}
	
	function setCashoutStatus(data) {
	    return { type: ActionTypes.SET_CASHOUT_STATUS, data: data };
	}

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.collapseAllGroups = collapseAllGroups;
	exports.collapseAllMatches = collapseAllMatches;
	
	var _Collapse = __webpack_require__(331);
	
	var ActionTypes = _interopRequireWildcard(_Collapse);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function collapseAllGroups(data) {
	    return { type: ActionTypes.COLLAPSE_ALL_GROUPS, data: data, section: 'live' };
	}
	
	function collapseAllMatches(data) {
	    return { type: ActionTypes.COLLAPSE_ALL_MATCHES, data: data, section: 'live' };
	}

/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.expandAllGroups = expandAllGroups;
	exports.expandAllMatches = expandAllMatches;
	
	var _Expand = __webpack_require__(332);
	
	var ActionTypes = _interopRequireWildcard(_Expand);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function expandAllGroups(data) {
	    return { type: ActionTypes.EXPAND_ALL_GROUPS, data: data, section: 'live' };
	}
	
	function expandAllMatches(data) {
	    return { type: ActionTypes.EXPAND_ALL_MATCHES, data: data, section: 'live' };
	}

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.clearLive = clearLive;
	
	var _Live = __webpack_require__(39);
	
	var ActionTypes = _interopRequireWildcard(_Live);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function clearLive() {
	    return { type: ActionTypes.CLEAR_LIVE, section: 'live' };
	}

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.getNews = getNews;
	
	var _api = __webpack_require__(13);
	
	var _News = __webpack_require__(706);
	
	var ActionTypes = _interopRequireWildcard(_News);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchNews(languageId) {
	    return (0, _defineProperty3.default)({
	        type: ActionTypes.GET_NEWS
	    }, _api.CALL_API, {
	        endpoint: '/api/news?languageId=' + languageId,
	        method: 'get',
	        types: [ActionTypes.SUCCESS_GET_NEWS, ActionTypes.FAILURE_GET_NEWS]
	    });
	}
	
	function getNews(languageId) {
	    return function (dispatch) {
	        return dispatch(fetchNews(languageId));
	    };
	}

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.fetchPopularMatches = fetchPopularMatches;
	
	var _api = __webpack_require__(13);
	
	var _transform = __webpack_require__(336);
	
	var _Popular = __webpack_require__(58);
	
	var ActionTypes = _interopRequireWildcard(_Popular);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchPopularMatches(data) {
	    var languageId = data.languageId;
	
	    return function (dispatch) {
	        var _dispatch;
	
	        return dispatch((_dispatch = {
	            type: ActionTypes.GET_POPULAR_MATCHES
	        }, (0, _defineProperty3.default)(_dispatch, _api.CALL_API, {
	            endpoint: '/api/event/popular?languageId=' + languageId,
	            method: 'get',
	            types: [ActionTypes.SUCCESS_GET_POPULAR_MATCHES, ActionTypes.FAILURE_GET_POPULAR_MATCHES],
	            data: data
	        }), (0, _defineProperty3.default)(_dispatch, _transform.TRANSFORM, {
	            section: 'popularMatches',
	            transformType: 'init',
	            provider: function provider(data) {
	                return data;
	            }
	        }), _dispatch));
	    };
	}

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.clearTimetable = clearTimetable;
	
	var _Timetable = __webpack_require__(70);
	
	var ActionTypes = _interopRequireWildcard(_Timetable);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function clearTimetable() {
	    return { type: ActionTypes.CLEAR_TIME_TABLE, section: 'timetable' };
	}

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.toggleMatch = toggleMatch;
	
	var _ToggleMatch = __webpack_require__(485);
	
	var ActionTypes = _interopRequireWildcard(_ToggleMatch);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function toggleMatch(data, section) {
	    return { type: ActionTypes.TOGGLE_MATCH, data: data, section: section };
	}

/***/ },
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.getJacktopGamesToken = getJacktopGamesToken;
	
	var _api = __webpack_require__(13);
	
	var _jacktopGames = __webpack_require__(742);
	
	var actions = _interopRequireWildcard(_jacktopGames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getJacktopGamesToken(languageId, gameId) {
	  return function (dispatch) {
	    return dispatch((0, _defineProperty3.default)({
	      type: actions.GET_JACKTOP_TOKEN,
	      languageId: languageId,
	      gameId: gameId
	    }, _api.CALL_API, {
	      endpoint: '/api/games-tvbet/',
	      method: 'get',
	      types: [actions.SUCCESS_GET_JACKTOP_TOKEN, actions.FAILURE_GET_JACKTOP_TOKEN],
	      credentials: true
	    }));
	  };
	}

/***/ },
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _reactDom = __webpack_require__(329);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _loadInitialState = __webpack_require__(1369);
	
	var _loadInitialState2 = _interopRequireDefault(_loadInitialState);
	
	var _Store = __webpack_require__(1169);
	
	var _Store2 = _interopRequireDefault(_Store);
	
	var _rootSaga = __webpack_require__(1404);
	
	var _rootSaga2 = _interopRequireDefault(_rootSaga);
	
	var _LocaleProvider = __webpack_require__(1175);
	
	var _LocaleProvider2 = _interopRequireDefault(_LocaleProvider);
	
	var _routes = __webpack_require__(1405);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(500);
	
	var initialState = (0, _loadInitialState2.default)();
	
	var store = (0, _Store2.default)(initialState);
	
	store.runSaga(_rootSaga2.default);
	
	_reactDom2.default.render(_react2.default.createElement(
	    _reactRedux.Provider,
	    { store: store },
	    _react2.default.createElement(
	        _LocaleProvider2.default,
	        null,
	        (0, _routes2.default)(store)
	    )
	), document.getElementById('app'));

/***/ },
/* 977 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var IN_PROGRESS = exports.IN_PROGRESS = 1;
	var ACCEPTED = exports.ACCEPTED = 2;
	var REJECTED = exports.REJECTED = 3;
	var TIMEDOUT = exports.TIMEDOUT = 4;

/***/ },
/* 978 */,
/* 979 */,
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(809);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _functions = __webpack_require__(305);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hoc = function Hoc(HocComponent) {
	  return function (_ref) {
	    var countryCode = _ref.countryCode,
	        accountResourceId = _ref.accountResourceId,
	        gamblerId = _ref.gamblerId,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['countryCode', 'accountResourceId', 'gamblerId']);
	
	    var isAvailable = (0, _functions.isAvailableGames)(countryCode, accountResourceId, gamblerId);
	    if (isAvailable) {
	      return _react2.default.createElement(HocComponent, props);
	    }
	    props.router.push('/');
	    return null;
	  };
	};
	
	exports.default = function (HocComponent) {
	  return (0, _reactRedux.connect)(function (state) {
	    var user = state.auth.get('user');
	    var gamblerId = user ? user.get('gamblerId') : null;
	    var accountResourceId = user ? user.get('resourceId') : null;
	    var countryCode = state.application.get('countryCode');
	
	    return {
	      gamblerId: gamblerId,
	      countryCode: countryCode,
	      accountResourceId: accountResourceId
	    };
	  })(Hoc(HocComponent));
	};

/***/ },
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchCashoutStatus = exports.fetchStakeStatus = exports.fetchBetStatus = exports.fetchFreebet = exports.fetchUserBalance = exports.fetchTimetableUpdate = exports.fetchInitialTimetable = exports.fetchLiveUpdate = exports.fetchInitialLive = undefined;
	
	var _api = __webpack_require__(13);
	
	var fetchInitialLive = exports.fetchInitialLive = function fetchInitialLive(requestData) {
	  return (0, _api.callApi)('/api/live/current?languageId=' + requestData.languageId, 'get');
	};
	var fetchLiveUpdate = exports.fetchLiveUpdate = function fetchLiveUpdate(requestData) {
	  return (0, _api.callApi)('/api/live/update?version=' + requestData.version + '&languageId=' + requestData.languageId, 'get');
	};
	
	var fetchInitialTimetable = exports.fetchInitialTimetable = function fetchInitialTimetable(requestData) {
	  return (0, _api.callApi)('/api/timetable/current?languageId=' + getLanguageId(requestData.languageId), 'get');
	};
	var fetchTimetableUpdate = exports.fetchTimetableUpdate = function fetchTimetableUpdate(requestData) {
	  return (0, _api.callApi)('/api/timetable/update?version=' + requestData.version + '&languageId=' + getLanguageId(requestData.languageId), 'get');
	};
	
	var fetchUserBalance = exports.fetchUserBalance = function fetchUserBalance(requestData) {
	  return (0, _api.callApi)('/api/balance/', 'post', requestData, true);
	};
	var fetchFreebet = exports.fetchFreebet = function fetchFreebet() {
	  return (0, _api.callApi)('/api/gambler/freebet', 'get', {}, true);
	};
	
	var fetchBetStatus = exports.fetchBetStatus = function fetchBetStatus(requestData) {
	  return (0, _api.callApi)('/api/bet/' + requestData.betId + '/status?stakeId=' + requestData.stakeId + '&languageId=' + getLanguageId(requestData.languageId), 'get', {}, true);
	};
	var fetchStakeStatus = exports.fetchStakeStatus = function fetchStakeStatus(requestData) {
	  return (0, _api.callApi)('/api/bet/' + requestData.betId + '/stake/' + requestData.stakeId + '/status', 'get', {}, true);
	};
	var fetchCashoutStatus = exports.fetchCashoutStatus = function fetchCashoutStatus(requestData) {
	  return (0, _api.callApi)('/api/bet/' + requestData.betId + '/stake/cashout/' + requestData.requestId + '/status', 'get', {}, true);
	};
	
	function getLanguageId(languageId) {
	  if (languageId === 13) return 5;
	  return languageId;
	}

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(82);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _promise = __webpack_require__(307);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	exports.loadInitialLive = loadInitialLive;
	exports.loadLiveUpdate = loadLiveUpdate;
	exports.loadInitialTimetable = loadInitialTimetable;
	exports.loadTimetableUpdate = loadTimetableUpdate;
	exports.loadBalance = loadBalance;
	exports.loadFreebet = loadFreebet;
	exports.loadBetsStatus = loadBetsStatus;
	exports.loadStakesStatus = loadStakesStatus;
	exports.loadCashoutsStatus = loadCashoutsStatus;
	
	var _effects = __webpack_require__(929);
	
	var _api = __webpack_require__(1159);
	
	var _actions = __webpack_require__(30);
	
	var _selectors = __webpack_require__(1161);
	
	var _ImmutableRepository = __webpack_require__(337);
	
	var _ImmutableRepository2 = _interopRequireDefault(_ImmutableRepository);
	
	var _ExpandKeyModifier = __webpack_require__(338);
	
	var _ExpandKeyModifier2 = _interopRequireDefault(_ExpandKeyModifier);
	
	var _RepositoryState = __webpack_require__(119);
	
	var RepositoryState = _interopRequireWildcard(_RepositoryState);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchActionWithTransform),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(fetchAction),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(loadInitialLive),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(loadLiveUpdate),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(loadInitialTimetable),
	    _marked6 = /*#__PURE__*/_regenerator2.default.mark(loadTimetableUpdate),
	    _marked7 = /*#__PURE__*/_regenerator2.default.mark(loadBalance),
	    _marked8 = /*#__PURE__*/_regenerator2.default.mark(loadFreebet),
	    _marked9 = /*#__PURE__*/_regenerator2.default.mark(loadBetsStatus),
	    _marked10 = /*#__PURE__*/_regenerator2.default.mark(loadStakesStatus),
	    _marked11 = /*#__PURE__*/_regenerator2.default.mark(loadCashoutsStatus); /* eslint-disable no-console */
	/* eslint-disable no-constant-condition */
	
	
	var live_initial = _actions.sagaActions.live_initial,
	    live_update = _actions.sagaActions.live_update,
	    timetable_initial = _actions.sagaActions.timetable_initial,
	    timetable_update = _actions.sagaActions.timetable_update,
	    get_balance = _actions.sagaActions.get_balance,
	    get_freebet = _actions.sagaActions.get_freebet,
	    get_bet_status = _actions.sagaActions.get_bet_status,
	    get_stake_status = _actions.sagaActions.get_stake_status,
	    get_cashout_status = _actions.sagaActions.get_cashout_status;
	
	
	var liveRepository = new _ImmutableRepository2.default();
	var timetableRepository = new _ImmutableRepository2.default();
	
	var delay = function delay(ms) {
	    return new _promise2.default(function (resolve) {
	        return setTimeout(resolve, ms);
	    });
	};
	
	function transformData(data, section) {
	    var repo = void 0;
	
	    switch (section) {
	        case 'live':
	            repo = liveRepository;
	            break;
	        case 'timetable':
	            repo = timetableRepository;
	            break;
	    }
	
	    if (!repo) {
	        return data;
	    }
	
	    var modifier = new _ExpandKeyModifier2.default(repo);
	
	    if (modifier) {
	        modifier.modify(data);
	    }
	
	    return data;
	}
	
	function fetchActionWithTransform(action, apiFn, section, requestData) {
	    var _ref, version, content, expired, error, transformed, data;
	
	    return _regenerator2.default.wrap(function fetchActionWithTransform$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.prev = 0;
	                    _context.next = 3;
	                    return (0, _effects.put)(action.request((0, _extends3.default)({}, requestData)));
	
	                case 3:
	                    _context.next = 5;
	                    return (0, _effects.call)(apiFn, requestData);
	
	                case 5:
	                    _ref = _context.sent;
	                    version = _ref.version;
	                    content = _ref.content;
	                    expired = _ref.expired;
	                    error = _ref.error;
	
	                    if (!content) {
	                        _context.next = 17;
	                        break;
	                    }
	
	                    transformed = transformData(content, section);
	                    data = (0, _extends3.default)({
	                        expired: expired,
	                        version: version
	                    }, transformed);
	                    _context.next = 15;
	                    return (0, _effects.put)(action.success(data));
	
	                case 15:
	                    _context.next = 19;
	                    break;
	
	                case 17:
	                    _context.next = 19;
	                    return (0, _effects.put)(action.failure(requestData, error));
	
	                case 19:
	                    _context.next = 25;
	                    break;
	
	                case 21:
	                    _context.prev = 21;
	                    _context.t0 = _context['catch'](0);
	                    _context.next = 25;
	                    return (0, _effects.put)(action.failure(requestData, _context.t0));
	
	                case 25:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked, this, [[0, 21]]);
	}
	
	function fetchAction(action, apiFn, requestData) {
	    var _ref2, response, error;
	
	    return _regenerator2.default.wrap(function fetchAction$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _effects.put)(action.request(requestData));
	
	                case 2:
	                    _context2.next = 4;
	                    return (0, _effects.call)(apiFn, requestData);
	
	                case 4:
	                    _ref2 = _context2.sent;
	                    response = _ref2.response;
	                    error = _ref2.error;
	
	                    if (!response) {
	                        _context2.next = 12;
	                        break;
	                    }
	
	                    _context2.next = 10;
	                    return (0, _effects.put)(action.success(response));
	
	                case 10:
	                    _context2.next = 14;
	                    break;
	
	                case 12:
	                    _context2.next = 14;
	                    return (0, _effects.put)(action.failure(requestData, error));
	
	                case 14:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked2, this);
	}
	
	var fetchInitialLiveSaga = fetchActionWithTransform.bind(null, live_initial, _api.fetchInitialLive, 'live');
	var fetchLiveUpdateSaga = fetchActionWithTransform.bind(null, live_update, _api.fetchLiveUpdate, 'live');
	
	var fetchInitialTimetableSaga = fetchActionWithTransform.bind(null, timetable_initial, _api.fetchInitialTimetable, 'timetable');
	var fetchTimetableUpdateSaga = fetchActionWithTransform.bind(null, timetable_update, _api.fetchTimetableUpdate, 'timetable');
	
	var fetchBalanceSaga = fetchAction.bind(null, get_balance, _api.fetchUserBalance);
	var fetchFreebetSaga = fetchAction.bind(null, get_freebet, _api.fetchFreebet);
	
	var fetchBetsStatusSaga = fetchAction.bind(null, get_bet_status, _api.fetchBetStatus);
	var fetchStakeStatusSaga = fetchAction.bind(null, get_stake_status, _api.fetchStakeStatus);
	var fetchCashoutsStatusSaga = fetchAction.bind(null, get_cashout_status, _api.fetchCashoutStatus);
	
	function loadInitialLive() {
	    var requestData, path, eligible;
	    return _regenerator2.default.wrap(function loadInitialLive$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    if (false) {
	                        _context3.next = 13;
	                        break;
	                    }
	
	                    _context3.next = 3;
	                    return (0, _effects.select)(_selectors.selectForLive);
	
	                case 3:
	                    requestData = _context3.sent;
	                    path = requestData.path;
	                    eligible = requestData.repoState === RepositoryState.NOT_INITED && (path === '/live' || path === '/live/timetable');
	
	                    if (!eligible) {
	                        _context3.next = 9;
	                        break;
	                    }
	
	                    _context3.next = 9;
	                    return (0, _effects.call)(fetchInitialLiveSaga, requestData);
	
	                case 9:
	                    _context3.next = 11;
	                    return (0, _effects.call)(delay, 2000);
	
	                case 11:
	                    _context3.next = 0;
	                    break;
	
	                case 13:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _marked3, this);
	}
	
	function loadLiveUpdate() {
	    var requestData, repoState, path, eligible;
	    return _regenerator2.default.wrap(function loadLiveUpdate$(_context4) {
	        while (1) {
	            switch (_context4.prev = _context4.next) {
	                case 0:
	                    if (false) {
	                        _context4.next = 20;
	                        break;
	                    }
	
	                    _context4.next = 3;
	                    return (0, _effects.select)(_selectors.selectForLive);
	
	                case 3:
	                    requestData = _context4.sent;
	                    repoState = requestData.repoState;
	                    path = requestData.path;
	                    eligible = (repoState === RepositoryState.INITED || repoState === RepositoryState.UPDATING) && (path === '/live' || path === '/live/timetable');
	
	                    if (!eligible) {
	                        _context4.next = 16;
	                        break;
	                    }
	
	                    _context4.prev = 8;
	                    _context4.next = 11;
	                    return (0, _effects.call)(fetchLiveUpdateSaga, requestData);
	
	                case 11:
	                    _context4.next = 16;
	                    break;
	
	                case 13:
	                    _context4.prev = 13;
	                    _context4.t0 = _context4['catch'](8);
	
	                    console.error('(/var/www/site/js/sagas/index.js): ', _context4.t0);
	
	                case 16:
	                    _context4.next = 18;
	                    return (0, _effects.call)(delay, 2000);
	
	                case 18:
	                    _context4.next = 0;
	                    break;
	
	                case 20:
	                case 'end':
	                    return _context4.stop();
	            }
	        }
	    }, _marked4, this, [[8, 13]]);
	}
	
	function loadInitialTimetable() {
	    var requestData, path, eligible;
	    return _regenerator2.default.wrap(function loadInitialTimetable$(_context5) {
	        while (1) {
	            switch (_context5.prev = _context5.next) {
	                case 0:
	                    if (false) {
	                        _context5.next = 13;
	                        break;
	                    }
	
	                    _context5.next = 3;
	                    return (0, _effects.select)(_selectors.selectForTimetable);
	
	                case 3:
	                    requestData = _context5.sent;
	                    path = requestData.path;
	                    eligible = requestData.repoState === RepositoryState.NOT_INITED && (path === '/live' || path === '/live/timetable');
	
	                    if (!eligible) {
	                        _context5.next = 9;
	                        break;
	                    }
	
	                    _context5.next = 9;
	                    return (0, _effects.call)(fetchInitialTimetableSaga, requestData);
	
	                case 9:
	                    _context5.next = 11;
	                    return (0, _effects.call)(delay, 3000);
	
	                case 11:
	                    _context5.next = 0;
	                    break;
	
	                case 13:
	                case 'end':
	                    return _context5.stop();
	            }
	        }
	    }, _marked5, this);
	}
	
	function loadTimetableUpdate() {
	    var requestData, repoState, path, eligible;
	    return _regenerator2.default.wrap(function loadTimetableUpdate$(_context6) {
	        while (1) {
	            switch (_context6.prev = _context6.next) {
	                case 0:
	                    if (false) {
	                        _context6.next = 18;
	                        break;
	                    }
	
	                    _context6.next = 3;
	                    return (0, _effects.select)(_selectors.selectForTimetable);
	
	                case 3:
	                    requestData = _context6.sent;
	                    repoState = requestData.repoState;
	                    path = requestData.path;
	                    eligible = (repoState === RepositoryState.INITED || repoState === RepositoryState.UPDATING) && (path === '/live' || path === '/live/timetable');
	
	                    if (!eligible) {
	                        _context6.next = 14;
	                        break;
	                    }
	
	                    _context6.next = 10;
	                    return (0, _effects.call)(fetchTimetableUpdateSaga, requestData);
	
	                case 10:
	                    _context6.next = 12;
	                    return (0, _effects.call)(delay, 30000);
	
	                case 12:
	                    _context6.next = 16;
	                    break;
	
	                case 14:
	                    _context6.next = 16;
	                    return (0, _effects.call)(delay, 3000);
	
	                case 16:
	                    _context6.next = 0;
	                    break;
	
	                case 18:
	                case 'end':
	                    return _context6.stop();
	            }
	        }
	    }, _marked6, this);
	}
	
	function loadBalance() {
	    var selectData, user, data;
	    return _regenerator2.default.wrap(function loadBalance$(_context7) {
	        while (1) {
	            switch (_context7.prev = _context7.next) {
	                case 0:
	                    if (false) {
	                        _context7.next = 13;
	                        break;
	                    }
	
	                    _context7.next = 3;
	                    return (0, _effects.select)(_selectors.selectUser);
	
	                case 3:
	                    selectData = _context7.sent;
	                    user = selectData.user;
	
	                    if (!user) {
	                        _context7.next = 9;
	                        break;
	                    }
	
	                    data = { accountId: user.get('accountId') };
	                    _context7.next = 9;
	                    return (0, _effects.call)(fetchBalanceSaga, data);
	
	                case 9:
	                    _context7.next = 11;
	                    return (0, _effects.call)(delay, 10000);
	
	                case 11:
	                    _context7.next = 0;
	                    break;
	
	                case 13:
	                case 'end':
	                    return _context7.stop();
	            }
	        }
	    }, _marked7, this);
	}
	
	function loadFreebet() {
	    var selectData;
	    return _regenerator2.default.wrap(function loadFreebet$(_context8) {
	        while (1) {
	            switch (_context8.prev = _context8.next) {
	                case 0:
	                    if (false) {
	                        _context8.next = 15;
	                        break;
	                    }
	
	                    _context8.next = 3;
	                    return (0, _effects.select)(_selectors.selectUser);
	
	                case 3:
	                    selectData = _context8.sent;
	
	                    if (!selectData.user) {
	                        _context8.next = 11;
	                        break;
	                    }
	
	                    _context8.next = 7;
	                    return (0, _effects.call)(fetchFreebetSaga);
	
	                case 7:
	                    _context8.next = 9;
	                    return (0, _effects.call)(delay, 5 * 60 * 1000);
	
	                case 9:
	                    _context8.next = 13;
	                    break;
	
	                case 11:
	                    _context8.next = 13;
	                    return (0, _effects.call)(delay, 60 * 1000);
	
	                case 13:
	                    _context8.next = 0;
	                    break;
	
	                case 15:
	                case 'end':
	                    return _context8.stop();
	            }
	        }
	    }, _marked8, this);
	}
	
	function loadBetsStatus() {
	    var _this = this;
	
	    var _loop;
	
	    return _regenerator2.default.wrap(function loadBetsStatus$(_context10) {
	        while (1) {
	            switch (_context10.prev = _context10.next) {
	                case 0:
	                    _loop = /*#__PURE__*/_regenerator2.default.mark(function _loop() {
	                        var requestData, languageId, bets, tasks;
	                        return _regenerator2.default.wrap(function _loop$(_context9) {
	                            while (1) {
	                                switch (_context9.prev = _context9.next) {
	                                    case 0:
	                                        _context9.next = 2;
	                                        return (0, _effects.select)(_selectors.selectForBets);
	
	                                    case 2:
	                                        requestData = _context9.sent;
	                                        languageId = requestData.languageId, bets = requestData.bets;
	
	                                        if (!(bets.length > 0)) {
	                                            _context9.next = 14;
	                                            break;
	                                        }
	
	                                        _context9.next = 7;
	                                        return bets.map(function (b) {
	                                            return (0, _effects.fork)(fetchBetsStatusSaga, { languageId: languageId, betId: b.betId, stakeId: b.stakeId, delay: b.delay });
	                                        });
	
	                                    case 7:
	                                        tasks = _context9.sent;
	                                        _context9.next = 10;
	                                        return tasks.map(_effects.join);
	
	                                    case 10:
	                                        _context9.next = 12;
	                                        return (0, _effects.call)(delay, 1000);
	
	                                    case 12:
	                                        _context9.next = 16;
	                                        break;
	
	                                    case 14:
	                                        _context9.next = 16;
	                                        return (0, _effects.call)(delay, 1500);
	
	                                    case 16:
	                                    case 'end':
	                                        return _context9.stop();
	                                }
	                            }
	                        }, _loop, _this);
	                    });
	
	                case 1:
	                    if (false) {
	                        _context10.next = 5;
	                        break;
	                    }
	
	                    return _context10.delegateYield(_loop(), 't0', 3);
	
	                case 3:
	                    _context10.next = 1;
	                    break;
	
	                case 5:
	                case 'end':
	                    return _context10.stop();
	            }
	        }
	    }, _marked9, this);
	}
	
	function loadStakesStatus() {
	    var requestData, _bets, tasks;
	
	    return _regenerator2.default.wrap(function loadStakesStatus$(_context11) {
	        while (1) {
	            switch (_context11.prev = _context11.next) {
	                case 0:
	                    if (false) {
	                        _context11.next = 19;
	                        break;
	                    }
	
	                    _context11.next = 3;
	                    return (0, _effects.select)(_selectors.selectForStakes);
	
	                case 3:
	                    requestData = _context11.sent;
	                    _bets = requestData.bets;
	
	                    if (!(_bets.length > 0)) {
	                        _context11.next = 15;
	                        break;
	                    }
	
	                    _context11.next = 8;
	                    return _bets.map(function (b) {
	                        return (0, _effects.fork)(fetchStakeStatusSaga, { betId: b.betId, stakeId: b.stakeId });
	                    });
	
	                case 8:
	                    tasks = _context11.sent;
	                    _context11.next = 11;
	                    return tasks.map(_effects.join);
	
	                case 11:
	                    _context11.next = 13;
	                    return (0, _effects.call)(delay, 30000);
	
	                case 13:
	                    _context11.next = 17;
	                    break;
	
	                case 15:
	                    _context11.next = 17;
	                    return (0, _effects.call)(delay, 5000);
	
	                case 17:
	                    _context11.next = 0;
	                    break;
	
	                case 19:
	                case 'end':
	                    return _context11.stop();
	            }
	        }
	    }, _marked10, this);
	}
	
	function loadCashoutsStatus() {
	    var requestData, _bets2, tasks;
	
	    return _regenerator2.default.wrap(function loadCashoutsStatus$(_context12) {
	        while (1) {
	            switch (_context12.prev = _context12.next) {
	                case 0:
	                    if (false) {
	                        _context12.next = 19;
	                        break;
	                    }
	
	                    _context12.next = 3;
	                    return (0, _effects.select)(_selectors.selectForCashout);
	
	                case 3:
	                    requestData = _context12.sent;
	                    _bets2 = requestData.bets;
	
	                    if (!(_bets2.length > 0)) {
	                        _context12.next = 15;
	                        break;
	                    }
	
	                    _context12.next = 8;
	                    return _bets2.map(function (b) {
	                        return (0, _effects.fork)(fetchCashoutsStatusSaga, { betId: b.betId, requestId: b.requestId });
	                    });
	
	                case 8:
	                    tasks = _context12.sent;
	                    _context12.next = 11;
	                    return tasks.map(_effects.join);
	
	                case 11:
	                    _context12.next = 13;
	                    return (0, _effects.call)(delay, 1000);
	
	                case 13:
	                    _context12.next = 17;
	                    break;
	
	                case 15:
	                    _context12.next = 17;
	                    return (0, _effects.call)(delay, 3000);
	
	                case 17:
	                    _context12.next = 0;
	                    break;
	
	                case 19:
	                case 'end':
	                    return _context12.stop();
	            }
	        }
	    }, _marked11, this);
	}

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.selectForCashout = exports.selectForStakes = exports.selectForBets = exports.selectForTimetable = exports.selectForLive = exports.selectUser = undefined;
	
	var _BetStatus = __webpack_require__(134);
	
	var BetStatuses = _interopRequireWildcard(_BetStatus);
	
	var _CashoutStatus = __webpack_require__(566);
	
	var CashoutStatuses = _interopRequireWildcard(_CashoutStatus);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var selectUser = exports.selectUser = function selectUser(state) {
	    return {
	        user: state.auth.get('user')
	    };
	};
	
	var selectForLive = exports.selectForLive = function selectForLive(state) {
	    var path = state.routing.locationBeforeTransitions !== null ? state.routing.locationBeforeTransitions.pathname : undefined;
	    return {
	        path: path,
	        languageId: state.application.get('languageId'),
	        version: state.application.get('live').get('version'),
	        repoState: state.application.get('live').get('state')
	    };
	};
	
	var selectForTimetable = exports.selectForTimetable = function selectForTimetable(state) {
	    var path = state.routing.locationBeforeTransitions !== null ? state.routing.locationBeforeTransitions.pathname : undefined;
	    return {
	        path: path,
	        languageId: state.application.get('languageId'),
	        version: state.application.get('timetable').get('version'),
	        repoState: state.application.get('timetable').get('state')
	    };
	};
	
	var selectForBets = exports.selectForBets = function selectForBets(state) {
	    var betHistory = state.application.get('betHistory');
	    var keys = betHistory.keySeq().toList();
	
	    var betArr = [];
	    keys.map(function (betId) {
	        var bet = betHistory.get(betId);
	        var betStatus = bet.get('betStatus');
	
	        if (betStatus === BetStatuses.IN_DELAY || betStatus === BetStatuses.STAKE_REQUEST) {
	            var stakeId = bet.get('stakeId');
	            betArr.push({ betId: betId, stakeId: stakeId });
	        }
	    });
	
	    return {
	        languageId: state.application.get('languageId'),
	        bets: betArr
	    };
	};
	
	var selectForStakes = exports.selectForStakes = function selectForStakes(state) {
	    var betHistory = state.application.get('betHistory');
	    var keys = betHistory.keySeq().toList();
	
	    var betArr = [];
	    keys.map(function (betId) {
	        var bet = betHistory.get(betId);
	        var betStatus = bet.get('betStatus');
	
	        if (betStatus === BetStatuses.CONFIRMED) {
	            var stakeId = bet.get('stakeId');
	            betArr.push({ betId: betId, stakeId: stakeId });
	        }
	    });
	
	    return {
	        bets: betArr
	    };
	};
	
	var selectForCashout = exports.selectForCashout = function selectForCashout(state) {
	    var betHistory = state.application.get('betHistory');
	    var keys = betHistory.keySeq().toList();
	
	    var betArr = [];
	    keys.map(function (betId) {
	        var bet = betHistory.get(betId);
	        var betStatus = bet.get('betStatus');
	        var cashout = bet.get('cashout');
	
	        if (betStatus === BetStatuses.CONFIRMED && cashout) {
	            var cashoutState = cashout.get('state');
	            var requestId = cashout.get('requestId');
	            if (cashoutState === CashoutStatuses.SELL_REQUESTED && requestId) {
	                betArr.push({ betId: betId, requestId: requestId });
	            }
	        }
	    });
	
	    return {
	        bets: betArr
	    };
	};

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Alert types: wide, widest
	
	var _class = function (_React$Component) {
	    (0, _inherits3.default)(_class, _React$Component);
	
	    function _class() {
	        (0, _classCallCheck3.default)(this, _class);
	        return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(_class, [{
	        key: 'render',
	        value: function render() {
	
	            var containerCSSClass = 'alert-container ' + this.props.type;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'alert-modal' },
	                _react2.default.createElement(
	                    'div',
	                    { className: containerCSSClass },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'title' },
	                        this.props.title
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'message' },
	                        this.props.message
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-yellow', onClick: this.props.clickCallback },
	                        this.props.btnText
	                    )
	                )
	            );
	        }
	    }]);
	    return _class;
	}(_react2.default.Component);
	
	_class.propTypes = {
	    type: _react2.default.PropTypes.string.isRequired,
	    title: _react2.default.PropTypes.string.isRequired,
	    message: _react2.default.PropTypes.any.isRequired,
	    btnText: _react2.default.PropTypes.any.isRequired,
	    clickCallback: _react2.default.PropTypes.func.isRequired
	};
	exports.default = _class;

/***/ },
/* 1163 */,
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    title: {
	        id: 'phone_confirm.title',
	        defaultMessage: 'Подтверждение номера телефона'
	    },
	    phone: {
	        id: 'phone_confirm.phone',
	        defaultMessage: 'Мобильный телефон'
	    },
	    confirmButton: {
	        id: 'phone_confirm.confirm_button',
	        defaultMessage: 'Подтвердить'
	    },
	    confirmationCode: {
	        id: 'phone_confirm.confirmation_code',
	        defaultMessage: 'Код подтверждения'
	    },
	    smsReceivedText: {
	        id: 'phone_confirm.sms_received_text',
	        defaultMessage: 'Введите код из SMS сообщения, высланного на номер {phone}'
	    },
	    denial: {
	        id: 'phone_confirm.denial',
	        defaultMessage: 'Не желаю участвовать в акции, просто зарегистрируйте мне счет'
	    },
	    confirmationError: {
	        id: 'phone_confirm.errors.confirmation_fail',
	        defaultMessage: 'Ошибка при подтверждении'
	    }
	});
	
	var _class = function (_React$Component) {
	    (0, _inherits3.default)(_class, _React$Component);
	
	    function _class(props) {
	        (0, _classCallCheck3.default)(this, _class);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, props));
	
	        _this._handleCodeConfirmClick = _this._handleCodeConfirmClick.bind(_this);
	        _this._onChangeCode = _this._onChangeCode.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(_class, [{
	        key: '_onChangeCode',
	        value: function _onChangeCode(e) {
	            e.preventDefault();
	
	            var code = e.target.value;
	            var isValid = true;
	            for (var offset = 0; offset < code.length; offset++) {
	                var charCode = parseInt(code[offset].charCodeAt());
	                if (!(charCode > 47 && charCode < 58 || charCode > 64 && charCode < 91 || charCode > 96 && charCode < 123)) {
	                    isValid = false;
	                }
	            }
	            if (isValid) {
	                e.target.value = e.target.value.toUpperCase();
	            } else {
	                e.target.value = e.target.value.substring(0, e.target.value.length - 1);
	            }
	        }
	    }, {
	        key: '_handleCodeConfirmClick',
	        value: function _handleCodeConfirmClick(e) {
	            e.preventDefault();
	
	            var gamblerId = this.props.gamblerId;
	
	            var codeVal = this.refs.code.value;
	            if (codeVal) {
	                this.props.confirmPhone({ gamblerId: gamblerId, code: codeVal.toUpperCase(), authorize: true });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                phone = _props.phone,
	                phoneConfirming = _props.phoneConfirming,
	                phoneConfirmationError = _props.phoneConfirmationError;
	
	            var denialLinkStyle = { color: '#186b38' };
	            var codeStyle = { textTransform: 'uppercase' };
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'modal--dialog' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal--header' },
	                    _react2.default.createElement('div', { className: 'header-inner--logotype__link' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'header-inner__title' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.title)
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal--content' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'modal--content__wrapper' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'login--form form' },
	                            _react2.default.createElement(
	                                'p',
	                                { className: 'plain-text__paragraph' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, messages.smsReceivedText, { values: { phone: phone } }))
	                            ),
	                            phoneConfirmationError && _react2.default.createElement(
	                                'div',
	                                { className: 'error-message' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, messages.confirmationError)
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'login--form__row form__row' },
	                                phoneConfirming && _react2.default.createElement(
	                                    'i',
	                                    null,
	                                    '...spinner...'
	                                ),
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'login--form__label form__label' },
	                                    '\xA0'
	                                ),
	                                _react2.default.createElement('input', { ref: 'code', onChange: this._onChangeCode, style: codeStyle, className: 'login--form__control form__control' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'login--form__row form__row' },
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: 'login--form__btn login--form__btn__js form__btn',
	                                        onClick: this._handleCodeConfirmClick },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.confirmButton)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'login--form__row form__row' },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '#', className: 'login--form__btn login--form__btn__js', style: denialLinkStyle,
	                                        onClick: this.props.denyConfirmationCallback },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.denial)
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return _class;
	}(_react2.default.Component);
	
	_class.propTypes = {
	    languageId: _react2.default.PropTypes.number.isRequired,
	    gamblerId: _react2.default.PropTypes.number.isRequired,
	    phone: _react2.default.PropTypes.string,
	    phoneConfirming: _react2.default.PropTypes.bool.isRequired,
	    phoneConfirmationError: _react2.default.PropTypes.any,
	    confirmPhone: _react2.default.PropTypes.func.isRequired,
	    denyConfirmationCallback: _react2.default.PropTypes.func.isRequired
	};
	exports.default = _class;

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(8);
	
	var _JoinPromoType = __webpack_require__(495);
	
	var JoinPromoTypes = _interopRequireWildcard(_JoinPromoType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    title: {
	        id: 'phone_confirm.title',
	        defaultMessage: 'Подтверждение номера телефона'
	    },
	    successText: {
	        id: 'phone_confirm.success',
	        defaultMessage: 'Номер {phone} успешно подтвержден!'
	    },
	    startGameText: {
	        id: 'phone_confirm.start_playing',
	        defaultMessage: 'Начать игру'
	    },
	    site146Accepted: {
	        id: 'special_offers.site146_accepted',
	        defaultMessage: 'Ваш игровой счет принимает участие в акции «Вступительный бонус – 1000 тенге!»'
	    }
	});
	
	var ConfirmSuccess = function (_React$Component) {
	    (0, _inherits3.default)(ConfirmSuccess, _React$Component);
	
	    function ConfirmSuccess() {
	        (0, _classCallCheck3.default)(this, ConfirmSuccess);
	        return (0, _possibleConstructorReturn3.default)(this, (ConfirmSuccess.__proto__ || (0, _getPrototypeOf2.default)(ConfirmSuccess)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(ConfirmSuccess, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                phone = _props.phone,
	                joinPromoType = _props.joinPromoType;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'modal--dialog' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal--header' },
	                    _react2.default.createElement('div', { className: 'header-inner--logotype__link' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'header-inner__title' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.title)
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal--content' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'modal--content__wrapper' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'login--form form' },
	                            _react2.default.createElement(
	                                'p',
	                                { className: 'plain-text__paragraph' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, messages.successText, { values: { phone: phone } }))
	                            )
	                        ),
	                        joinPromoType && _react2.default.createElement(
	                            'div',
	                            { className: 'login--form form' },
	                            _react2.default.createElement(
	                                'p',
	                                { className: 'plain-text__paragraph' },
	                                ConfirmSuccess.renderSpecialOffer(joinPromoType)
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'login--form__row form' },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'login--form__btn login--form__btn__js form__btn',
	                                    onClick: this.props.cancelCallback },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, messages.startGameText)
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'renderSpecialOffer',
	        value: function renderSpecialOffer(joinPromoType) {
	            if (joinPromoType === JoinPromoTypes.SITE146) {
	                return _react2.default.createElement(_reactIntl.FormattedMessage, messages.site146Accepted);
	            }
	
	            return false;
	        }
	    }]);
	    return ConfirmSuccess;
	}(_react2.default.Component);
	
	ConfirmSuccess.propTypes = {
	    languageId: _react2.default.PropTypes.number.isRequired,
	    joinPromoType: _react2.default.PropTypes.any,
	    phone: _react2.default.PropTypes.string,
	    cancelCallback: _react2.default.PropTypes.func.isRequired
	};
	exports.default = ConfirmSuccess;

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reduxForm = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(8);
	
	var _stripCorrectProps = __webpack_require__(20);
	
	var _JoinPromoType = __webpack_require__(495);
	
	var JoinPromoTypes = _interopRequireWildcard(_JoinPromoType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fields = ['phone'];
	
	function phoneValidation(values) {
	    var errors = {};
	
	    if (!values.phone || !values.phone.length) {
	        errors.phone = 'Поле обязательно для заполнения';
	    }
	
	    return errors;
	}
	
	var messages = (0, _reactIntl.defineMessages)({
	    title: {
	        id: 'phone_confirm.title',
	        defaultMessage: 'Подтверждение номера телефона'
	    },
	    phone: {
	        id: 'phone_confirm.phone',
	        defaultMessage: 'Мобильный телефон'
	    },
	    smsText: {
	        id: 'phone_confirm.sms_text',
	        defaultMessage: 'На данный телефон будет выслано SMS с кодом подтверждения'
	    },
	    confirmButton: {
	        id: 'phone_confirm.confirm_button',
	        defaultMessage: 'Подтвердить'
	    },
	    denial: {
	        id: 'phone_confirm.denial',
	        defaultMessage: 'Не желаю участвовать в акции, просто зарегистрируйте мне счет'
	    },
	    conditions: {
	        id: 'phone_confirm.conditions',
	        defaultMessage: 'Для участия в акциях необходимо подтвердить номер мобильного телефона'
	    },
	    confirmationError: {
	        id: 'phone_confirm.errors.confirmation_fail',
	        defaultMessage: 'Ошибка при подтверждении'
	    },
	    phoneTakenError: {
	        id: 'phone_confirm.errors.phone_taken',
	        defaultMessage: 'Телефон уже используется'
	    },
	    site146Proposal: {
	        id: 'special_offers.site146_proposal',
	        defaultMessage: "Указанный Вами промо-код позволяет принять участие в акции «Вступительный бонус – 1000 тенге!».<br />" + "Для начисления бонуса необходимо подтвердить номер мобильного телефона"
	    },
	    phone_hint: {
	        id: 'phone_confirm.phone_hint',
	        defaultMessage: 'Используйте международный префикс, например: 7 777 123 45 67'
	    }
	});
	
	var PhoneInput = function (_React$Component) {
	    (0, _inherits3.default)(PhoneInput, _React$Component);
	
	    function PhoneInput(props) {
	        (0, _classCallCheck3.default)(this, PhoneInput);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (PhoneInput.__proto__ || (0, _getPrototypeOf2.default)(PhoneInput)).call(this, props));
	
	        _this._onSubmit = _this._onSubmit.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(PhoneInput, [{
	        key: '_onSubmit',
	        value: function _onSubmit(values) {
	            var gamblerId = this.props.gamblerId;
	
	            this.props.createPhoneConfirmation({
	                gamblerId: gamblerId,
	                oldPhone: this.props.fields.phone.initialValue,
	                newPhone: values.phone
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                phone = _props.fields.phone,
	                joinPromoType = _props.joinPromoType,
	                phoneConfirming = _props.phoneConfirming,
	                phoneConfirmationError = _props.phoneConfirmationError,
	                handleSubmit = _props.handleSubmit;
	
	            var denialLinkStyle = { color: '#186b38' };
	
	            var message = messages.confirmationError;
	            if (phoneConfirmationError === -1) {
	                message = messages.phoneTakenError;
	            }
	
	            var specialOfferMessage = messages.conditions;
	            if (joinPromoType === JoinPromoTypes.SITE146) {
	                specialOfferMessage = messages.site146Proposal;
	            }
	
	            var submitHandler = this._onSubmit;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'modal--dialog' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal--header' },
	                    _react2.default.createElement('div', { className: 'header-inner--logotype__link' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'header-inner__title' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.title)
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal--content' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'modal--content__wrapper' },
	                        _react2.default.createElement(
	                            'form',
	                            { className: 'login--form form', onSubmit: handleSubmit(submitHandler), autoComplete: 'off' },
	                            _react2.default.createElement(
	                                'p',
	                                { className: 'plain-text__paragraph' },
	                                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, specialOfferMessage)
	                            ),
	                            phoneConfirmationError && _react2.default.createElement(
	                                'div',
	                                { className: 'error-message' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, message)
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'login--form__row form__row' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'login--form__label form__label' },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.phone)
	                                ),
	                                _react2.default.createElement('input', (0, _extends3.default)({ className: 'login--form__control form__control' }, (0, _stripCorrectProps.stripProps)(phone))),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'hint' },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.phone_hint)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'login--form__row form__row' },
	                                _react2.default.createElement(
	                                    'button',
	                                    { disabled: phoneConfirming,
	                                        type: 'submit',
	                                        className: 'login--form__btn login--form__btn__js form__btn',
	                                        onClick: handleSubmit(submitHandler) },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.confirmButton)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'login--form__row form__row' },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '#', className: 'login--form__btn login--form__btn__js', style: denialLinkStyle,
	                                        onClick: this.props.denyConfirmationCallback },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.denial)
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return PhoneInput;
	}(_react2.default.Component);
	
	PhoneInput.propTypes = {
	    fields: _react2.default.PropTypes.object.isRequired,
	    handleSubmit: _react2.default.PropTypes.func.isRequired,
	    submitting: _react2.default.PropTypes.bool.isRequired,
	    languageId: _react2.default.PropTypes.number.isRequired,
	    gamblerId: _react2.default.PropTypes.number.isRequired,
	    joinPromoType: _react2.default.PropTypes.any,
	    phone: _react2.default.PropTypes.string,
	    phoneConfirming: _react2.default.PropTypes.bool.isRequired,
	    phoneConfirmationError: _react2.default.PropTypes.any,
	    createPhoneConfirmation: _react2.default.PropTypes.func.isRequired,
	    denyConfirmationCallback: _react2.default.PropTypes.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)()((0, _reduxForm.reduxForm)({
	    form: 'phone-input-form',
	    fields: fields,
	    validate: phoneValidation
	})(PhoneInput));

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Modal types: wide, widest
	
	var _class = function (_React$Component) {
	    (0, _inherits3.default)(_class, _React$Component);
	
	    function _class() {
	        (0, _classCallCheck3.default)(this, _class);
	        return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(_class, [{
	        key: 'render',
	        value: function render() {
	
	            var containerCSSClass = 'modal-container ' + this.props.type;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'single-content-modal' },
	                _react2.default.createElement(
	                    'div',
	                    { className: containerCSSClass },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'modal-header' },
	                        this.props.title,
	                        _react2.default.createElement('div', { className: 'close', onClick: this.props.closeCallback })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'modal-content' },
	                        this.props.children
	                    )
	                )
	            );
	        }
	    }]);
	    return _class;
	}(_react2.default.Component);
	
	_class.propTypes = {
	    type: _react2.default.PropTypes.string.isRequired,
	    title: _react2.default.PropTypes.any.isRequired,
	    children: _react2.default.PropTypes.any.isRequired,
	    closeCallback: _react2.default.PropTypes.func.isRequired
	};
	exports.default = _class;

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(809);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _VerifyModal = __webpack_require__(499);
	
	var _VerifyModal2 = _interopRequireDefault(_VerifyModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hoc = function Hoc(WrappedComponent) {
	  return function (_ref) {
	    var isVerified = _ref.isVerified,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['isVerified']);
	
	    if (isVerified === false) {
	      window.toggleVerifyModal && window.toggleVerifyModal(true);
	      return _react2.default.createElement(_VerifyModal2.default, null);
	    }
	    return _react2.default.createElement(WrappedComponent, props);
	  };
	};
	
	exports.default = function (HocComponent) {
	  return (0, _reactRedux.connect)(function (state) {
	    var user = state.auth.get('user');
	    var isVerified = user && user.get('isVerified');
	
	    return {
	      isVerified: isVerified
	    };
	  })(Hoc(HocComponent));
	};

/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	    module.exports = __webpack_require__(1170);
	} else {
	    module.exports = require('./Store.dev');
	}

/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (initialState) {
	    var sagaMiddleware = (0, _reduxSaga2.default)();
	
	    var store = (0, _redux.createStore)(_rootReducer2.default, initialState, (0, _redux.compose)((0, _redux.applyMiddleware)((0, _reactRouterRedux.routerMiddleware)(_reactRouter.browserHistory), _reduxThunk2.default, sagaMiddleware, _api2.default, _transform2.default), (0, _storeInitialState2.default)()));
	
	    store.runSaga = sagaMiddleware.run;
	    store.close = function () {
	        return store.dispatch(_reduxSaga.END);
	    };
	
	    return store;
	};
	
	var _redux = __webpack_require__(64);
	
	var _rootReducer = __webpack_require__(1403);
	
	var _rootReducer2 = _interopRequireDefault(_rootReducer);
	
	var _reactRouter = __webpack_require__(25);
	
	var _reactRouterRedux = __webpack_require__(23);
	
	var _reduxSaga = __webpack_require__(1994);
	
	var _reduxSaga2 = _interopRequireDefault(_reduxSaga);
	
	var _reduxThunk = __webpack_require__(557);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _api = __webpack_require__(13);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _transform = __webpack_require__(336);
	
	var _transform2 = _interopRequireDefault(_transform);
	
	var _storeInitialState = __webpack_require__(1406);
	
	var _storeInitialState2 = _interopRequireDefault(_storeInitialState);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _localeMap;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _header = __webpack_require__(1311);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _reactPerfectScrollbar = __webpack_require__(547);
	
	var _reactPerfectScrollbar2 = _interopRequireDefault(_reactPerfectScrollbar);
	
	var _ModalWindow = __webpack_require__(138);
	
	var _ModalWindow2 = _interopRequireDefault(_ModalWindow);
	
	var _VerifyModal = __webpack_require__(499);
	
	var _VerifyModal2 = _interopRequireDefault(_VerifyModal);
	
	var _Join = __webpack_require__(1174);
	
	var _Join2 = _interopRequireDefault(_Join);
	
	var _SignIn = __webpack_require__(1181);
	
	var _SignIn2 = _interopRequireDefault(_SignIn);
	
	var _CreatePassword = __webpack_require__(575);
	
	var _CreatePassword2 = _interopRequireDefault(_CreatePassword);
	
	var _PasswordRecovery = __webpack_require__(1178);
	
	var _PasswordRecovery2 = _interopRequireDefault(_PasswordRecovery);
	
	var _JoinStage = __webpack_require__(569);
	
	var JoinStage = _interopRequireWildcard(_JoinStage);
	
	var _CreatePasswordStage = __webpack_require__(159);
	
	var CreatePasswordStage = _interopRequireWildcard(_CreatePasswordStage);
	
	var _accountResourceNames = __webpack_require__(59);
	
	var _loadAuthAction = __webpack_require__(131);
	
	var _createPassword = __webpack_require__(490);
	
	var _Auth = __webpack_require__(95);
	
	var _cookieUtils = __webpack_require__(96);
	
	var cookie = _interopRequireWildcard(_cookieUtils);
	
	var _reactIntl = __webpack_require__(8);
	
	var _ru = __webpack_require__(1256);
	
	var ruMessages = _interopRequireWildcard(_ru);
	
	var _en = __webpack_require__(1254);
	
	var enMessages = _interopRequireWildcard(_en);
	
	var _uz = __webpack_require__(1257);
	
	var uzMessages = _interopRequireWildcard(_uz);
	
	var _kk = __webpack_require__(1255);
	
	var kkMessages = _interopRequireWildcard(_kk);
	
	var _Language = __webpack_require__(47);
	
	var Languages = _interopRequireWildcard(_Language);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    password: {
	        id: 'create-password.modla-title',
	        defaultMessage: 'Придумайте пароль'
	    }
	});
	
	var localeMap = (_localeMap = {}, (0, _defineProperty3.default)(_localeMap, Languages.RU, ruMessages), (0, _defineProperty3.default)(_localeMap, Languages.EN, enMessages), (0, _defineProperty3.default)(_localeMap, Languages.UZ, uzMessages), (0, _defineProperty3.default)(_localeMap, Languages.KK, kkMessages), _localeMap);
	
	var Application = function (_React$Component) {
	    (0, _inherits3.default)(Application, _React$Component);
	
	    function Application(props, context) {
	        (0, _classCallCheck3.default)(this, Application);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Application.__proto__ || (0, _getPrototypeOf2.default)(Application)).call(this, props, context));
	
	        _this.componentDidMount = function () {
	            window.beginSignIn = _this.props.beginSignInAction;
	        };
	
	        _this._timeoutId = null;
	
	        _this.onModalClose = _this.onModalClose.bind(_this);
	
	        _this.state = { isShortcut: false };
	        return _this;
	    }
	
	    (0, _createClass3.default)(Application, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            return {
	                toggleMenu: this.toggleMenu.bind(this),
	                footer: this.props.footer
	            };
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var user = this.props.user;
	
	            if (!user && cookie.getCookie('token')) {
	                this.props.loadAuthAction();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.user !== nextProps.user) {
	                this._timeoutId = window.setTimeout(function () {
	                    if (nextProps.user) {
	                        var user = nextProps.user;
	                        if (window.jivo_api) {
	                            window.jivo_api.setContactInfo({
	                                'name': user.get('login')
	                            });
	
	                            window.jivo_api.setCustomData([{
	                                'content': 'ID \u0438\u0440\u043E\u043A\u0430: ' + user.get('gamblerId') + ', \u041B\u0438\u0446\u0435\u0432\u043E\u0439 \u0441\u0447\u0435\u0442: ' + user.get('accountNum') + ', \u043B\u043E\u0433\u0438\u043D: ' + user.get('login') + ', \u0432\u0430\u043B\u044E\u0442\u0430: ' + _accountResourceNames.resourceNames[user.get('resourceId')]
	                            }]);
	                        }
	                    } else {
	                        if (window.jivo_api) {
	                            window.jivo_api.setContactInfo({});
	                            window.jivo_api.setCustomData([]);
	                        }
	                    }
	                }, 3000);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this._timeoutId !== null) {
	                window.clearTimeout(this._timeoutId);
	            }
	        }
	    }, {
	        key: 'toggleMenu',
	        value: function toggleMenu() {
	            var isShortcut = this.state.isShortcut;
	
	
	            this.setState({ isShortcut: !isShortcut });
	        }
	    }, {
	        key: 'onModalClose',
	        value: function onModalClose() {
	            this.props.initCreatePasswordAction();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                languageId = _props.languageId,
	                user = _props.user,
	                freebet = _props.freebet,
	                balance = _props.balance,
	                newMessagesCount = _props.newMessagesCount,
	                userGridSelection = _props.userGridSelection,
	                countryCode = _props.countryCode,
	                signInOngoing = _props.signInOngoing,
	                joinStage = _props.joinStage,
	                passwordRecoveryOngoing = _props.passwordRecoveryOngoing,
	                domain = _props.domain,
	                sportId = _props.sportId,
	                leagueId = _props.leagueId,
	                footer = _props.footer,
	                passwordStage = _props.passwordStage;
	            var isShortcut = this.state.isShortcut;
	
	
	            var localeStrings = localeMap[languageId];
	
	            var gridLocalization = (0, _extends3.default)({}, localeStrings, {
	                languageId: languageId
	            });
	
	            var cls = footer !== undefined ? '' : isShortcut ? 'shortcut-menu' : '';
	
	            var headerProps = {
	                languageId: languageId,
	                user: user,
	                gamblerId: user ? user.get('gamblerId') : null,
	                freebet: freebet === undefined ? null : freebet,
	                balance: balance,
	                newMessagesCount: newMessagesCount,
	                userGridSelection: userGridSelection,
	                domain: domain,
	                sportId: sportId,
	                leagueId: leagueId,
	                countryCode: countryCode
	            };
	
	            var withProps = _react2.default.cloneElement(this.props.main, { gridLocalization: gridLocalization, isShortcut: isShortcut });
	
	            if (window.location.pathname.includes('games') || countryCode === 'KG') {
	                return _react2.default.createElement(
	                    'div',
	                    { style: { minWidth: '1280px' } },
	                    _react2.default.createElement(_VerifyModal2.default, null),
	                    _react2.default.createElement(_header2.default, headerProps),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'wrapper', className: cls },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'page-wrap' },
	                            withProps
	                        )
	                    ),
	                    joinStage !== JoinStage.NONE && _react2.default.createElement(
	                        _ModalWindow2.default,
	                        null,
	                        _react2.default.createElement(_Join2.default, null)
	                    ),
	                    signInOngoing && _react2.default.createElement(
	                        _ModalWindow2.default,
	                        null,
	                        _react2.default.createElement(_SignIn2.default, null)
	                    ),
	                    passwordRecoveryOngoing && _react2.default.createElement(
	                        _ModalWindow2.default,
	                        null,
	                        _react2.default.createElement(_PasswordRecovery2.default, null)
	                    ),
	                    passwordStage === CreatePasswordStage.INIT && _react2.default.createElement(
	                        _ModalWindow2.default,
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'modal modal--auth modal--auth-login modal__visible modal--create-password' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'modal--dialog' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'modal--header' },
	                                    _react2.default.createElement('div', { className: 'header-inner--logotype__link' }),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'header-inner__title' },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.password)
	                                    ),
	                                    _react2.default.createElement('button', { className: 'modal__close modal__close__green modal__close__js', onClick: this.onModalClose })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'modal--content' },
	                                    _react2.default.createElement(_CreatePassword2.default, { passwordStage: passwordStage })
	                                )
	                            )
	                        )
	                    )
	                );
	            }
	
	            return _react2.default.createElement(
	                _reactPerfectScrollbar2.default,
	                null,
	                _react2.default.createElement(_VerifyModal2.default, null),
	                _react2.default.createElement(
	                    'div',
	                    { style: { minWidth: '1280px' } },
	                    _react2.default.createElement(_header2.default, headerProps),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'wrapper', className: cls },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'page-wrap' },
	                            withProps
	                        )
	                    ),
	                    joinStage !== JoinStage.NONE && _react2.default.createElement(
	                        _ModalWindow2.default,
	                        null,
	                        _react2.default.createElement(_Join2.default, null)
	                    ),
	                    signInOngoing && _react2.default.createElement(
	                        _ModalWindow2.default,
	                        null,
	                        _react2.default.createElement(_SignIn2.default, null)
	                    ),
	                    passwordRecoveryOngoing && _react2.default.createElement(
	                        _ModalWindow2.default,
	                        null,
	                        _react2.default.createElement(_PasswordRecovery2.default, null)
	                    ),
	                    passwordStage === CreatePasswordStage.INIT && _react2.default.createElement(
	                        _ModalWindow2.default,
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'modal modal--auth modal--auth-login modal__visible modal--create-password' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'modal--dialog' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'modal--header' },
	                                    _react2.default.createElement('div', { className: 'header-inner--logotype__link' }),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'header-inner__title' },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.password)
	                                    ),
	                                    _react2.default.createElement('button', { className: 'modal__close modal__close__green modal__close__js', onClick: this.onModalClose })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'modal--content' },
	                                    _react2.default.createElement(_CreatePassword2.default, { passwordStage: passwordStage })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return Application;
	}(_react2.default.Component);
	
	Application.propTypes = {
	    languageId: _react2.default.PropTypes.number.isRequired,
	    user: _react2.default.PropTypes.any,
	    freebet: _react2.default.PropTypes.any,
	    balance: _react2.default.PropTypes.any,
	    newMessagesCount: _react2.default.PropTypes.number,
	    joinStage: _react2.default.PropTypes.number.isRequired,
	    signInOngoing: _react2.default.PropTypes.bool.isRequired,
	    userGridSelection: _react2.default.PropTypes.object.isRequired,
	    domain: _react2.default.PropTypes.string.isRequired,
	    sportId: _react2.default.PropTypes.any,
	    leagueId: _react2.default.PropTypes.any,
	    passwordRecoveryOngoing: _react2.default.PropTypes.bool.isRequired,
	    main: _react2.default.PropTypes.any,
	    footer: _react2.default.PropTypes.any,
	    loadAuthAction: _react2.default.PropTypes.func.isRequired,
	    initCreatePasswordAction: _react2.default.PropTypes.func.isRequired
	};
	Application.childContextTypes = {
	    toggleMenu: _react2.default.PropTypes.func,
	    footer: _react2.default.PropTypes.object
	};
	
	
	function select(state, props) {
	    var languageId = state.application.get('languageId');
	    var countryCode = state.application.get('countryCode');
	    var user = state.auth.get('user');
	    var freebet = state.application.getIn(['coupon', 'freebet']);
	    var balance = state.balance.get('value');
	    var newMessagesCount = state.application.getIn(['messages', 'newMessagesCount']);
	    var joinStage = state.join.get('stage');
	    var passwordStage = state.createPassword.stage;
	    var signInOngoing = state.auth.get('signInOngoing');
	    var passwordRecoveryOngoing = state.passwordRecovery.get('isOngoing');
	    var domain = state.domain;
	    var userGridSelection = state.application.getIn(['userGridSelection', 'preMatch']);
	
	    var sportId = props.params.sportId;
	    var leagueId = props.params.leagueId;
	
	    return {
	        countryCode: countryCode,
	        languageId: languageId,
	        user: user,
	        freebet: freebet,
	        balance: balance,
	        newMessagesCount: newMessagesCount,
	        joinStage: joinStage,
	        passwordStage: passwordStage,
	        signInOngoing: signInOngoing,
	        passwordRecoveryOngoing: passwordRecoveryOngoing,
	        userGridSelection: userGridSelection,
	        domain: domain,
	        sportId: sportId,
	        leagueId: leagueId
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, { loadAuthAction: _loadAuthAction.loadAuth, initCreatePasswordAction: _createPassword.initCreatePassword, beginSignInAction: _Auth.beginSignIn })(Application);

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	  connectionLost: {
	    id: 'live.error.connection_lost',
	    defaultMessage: 'Соединение с сервером данных не может быть установленно, пожалуйста подождите'
	  }
	});
	
	var _class = function (_React$Component) {
	  (0, _inherits3.default)(_class, _React$Component);
	
	  function _class(props) {
	    (0, _classCallCheck3.default)(this, _class);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, props));
	
	    _this._handleClick = _this._handleClick.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: '_handleClick',
	    value: function _handleClick(e) {
	      e.preventDefault();
	
	      var onClose = this.props.onClose;
	
	
	      onClose();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal connection-lost--modal modal__visible' },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal--dialog' },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal--header' },
	            _react2.default.createElement('button', { className: 'modal__close modal__close__green modal__close__js',
	              onClick: this._handleClick })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'modal--content' },
	            _react2.default.createElement('div', { className: 'spinner' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'connection-lost--modal__content' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, messages.connectionLost)
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return _class;
	}(_react2.default.Component);
	
	_class.propTypes = {
	  onClose: _react2.default.PropTypes.func.isRequired
	};
	exports.default = _class;

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(8);
	
	var _domainUtils = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	  copyright: {
	    id: 'footer.fairplay.copyright',
	    defaultMessage: '&copy; {year} Букмекерская компания «Fair Play»'
	  },
	  copyright_kz: {
	    id: 'footer.fairplay.copyright_kz',
	    defaultMessage: '&copy; {year} ТОО «BETtery». Торговая марка «Fair Play» Лицензия № 320 от 23.08.2019'
	  },
	  copyright_ringobet: {
	    id: 'footer.fairplay.copyright_ringobet',
	    defaultMessage: '&copy; {year} ТОО «TakeBet». Торговая марка «RingoBet» Лицензия № 34 от 12.07.2022'
	  }
	});
	
	function SocialLink(_ref) {
	  var social = _ref.social,
	      href = _ref.href;
	
	  return _react2.default.createElement(
	    'li',
	    null,
	    _react2.default.createElement('a', { href: href, className: 'footer-social-buttons--' + social, target: '_blank' })
	  );
	}
	
	function RechargeProvider(_ref2) {
	  var provider = _ref2.provider,
	      href = _ref2.href;
	
	  return _react2.default.createElement(
	    'li',
	    { className: 'recharge-providers__provider recharge-providers__provider--' + provider },
	    _react2.default.createElement('a', { href: href ? href : '#', target: href ? '_blank' : '' })
	  );
	}
	
	function Footer(_ref3) {
	  var countryCode = _ref3.countryCode;
	
	  var copyrightMessage = countryCode === 'KZ' ? _domainUtils.isRingo ? messages.copyright_ringobet : messages.copyright_kz : messages.copyright;
	
	  return _react2.default.createElement(
	    'footer',
	    { className: 'page-footer' },
	    countryCode === 'KZ' && (_domainUtils.isRingo ? _react2.default.createElement(
	      'div',
	      { className: 'recharge-providers cf' },
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(RechargeProvider, { provider: 'visa' }),
	        _react2.default.createElement(RechargeProvider, { provider: 'qiwi' }),
	        _react2.default.createElement(RechargeProvider, { provider: 'wooppay' }),
	        _react2.default.createElement(RechargeProvider, { provider: 'kassa24' })
	      )
	    ) : _react2.default.createElement(
	      'div',
	      { className: 'recharge-providers cf' },
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(RechargeProvider, { provider: 'visa' }),
	        _react2.default.createElement(RechargeProvider, { provider: 'qiwi' }),
	        _react2.default.createElement(RechargeProvider, { provider: 'wooppay' }),
	        _react2.default.createElement(RechargeProvider, { provider: 'kassa24' }),
	        _react2.default.createElement(RechargeProvider, { provider: 'cyberplat' }),
	        _react2.default.createElement(RechargeProvider, { provider: 'tenge' }),
	        _react2.default.createElement(RechargeProvider, { provider: 'quickpay' })
	      )
	    )),
	    countryCode === 'KG' && _react2.default.createElement(
	      'div',
	      { className: 'recharge-providers cf' },
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(RechargeProvider, { provider: 'visa' }),
	        _react2.default.createElement(RechargeProvider, { provider: 'bitcoin' }),
	        _react2.default.createElement(RechargeProvider, { provider: 'ethereum' }),
	        _react2.default.createElement(RechargeProvider, { provider: 'tether' }),
	        _react2.default.createElement(RechargeProvider, { provider: 'opex' }),
	        _react2.default.createElement(RechargeProvider, { provider: 'binance' }),
	        _react2.default.createElement(RechargeProvider, { provider: 'litecoin' }),
	        _react2.default.createElement(RechargeProvider, { provider: 'dash-dash' }),
	        _react2.default.createElement(RechargeProvider, { provider: 'tron-trx' }),
	        _react2.default.createElement(RechargeProvider, { provider: 'usd-coin-usdc' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'info pull-left' },
	      _react2.default.createElement(
	        'span',
	        { className: countryCode === 'KZ' ? 'plus18' : 'plus18KG' },
	        '\xA0'
	      ),
	      (0, _domainUtils.checkIsFlayBet)() ? _react2.default.createElement(
	        'div',
	        { style: { fontSize: 14 } },
	        _react2.default.createElement(
	          'p',
	          null,
	          'SmartPlay Interactive N.V., Curacao, Willemstad, Zuikertuintjeweg Z/N Zuikertuin Tower'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Registration number: 161764'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'a',
	          { style: { color: '#306d41', cursor: 'pointer' } },
	          _react2.default.createElement(
	            'span',
	            {
	              onClick: function onClick() {
	                window.open('//help.' + window.location.host + '/responsible', 'Menu', 'toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650');
	              }
	            },
	            'Responsible Gaming'
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'a',
	          { style: { color: '#306d41', cursor: 'pointer' } },
	          _react2.default.createElement(
	            'span',
	            {
	              onClick: function onClick() {
	                window.open('//help.' + window.location.host, 'Menu', 'toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650');
	              }
	            },
	            'Terms and Conditions'
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'a',
	          { style: { color: '#306d41', cursor: 'pointer' } },
	          _react2.default.createElement(
	            'span',
	            {
	              onClick: function onClick() {
	                window.open('//help.' + window.location.host + '/privacy', 'Menu', 'toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650');
	              }
	            },
	            'KYC Policy'
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:support@fp.bet' },
	          'support@fp.bet'
	        )
	      ) : _react2.default.createElement(
	        'span',
	        { className: 'copyright' },
	        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, (0, _extends3.default)({}, copyrightMessage, { values: { year: new Date().getFullYear() } }))
	      ),
	      countryCode === 'KG' ? _react2.default.createElement(
	        'span',
	        { className: 'rapid' },
	        '\xA0'
	      ) : _react2.default.createElement(
	        'span',
	        { className: 'comodo' },
	        '\xA0'
	      )
	    ),
	    countryCode === 'KZ' ? _domainUtils.isRingo ? _react2.default.createElement(
	      'div',
	      { className: 'footer-social-buttons' },
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(SocialLink, { href: 'https://www.instagram.com/ringobet.kz/', social: 'instagram' }),
	        _react2.default.createElement(SocialLink, { href: 'https://www.tiktok.com/@ringobet.kz/', social: 'tiktok' }),
	        _react2.default.createElement(SocialLink, { href: 'https://t.me/ringobet_kaz', social: 'telegram' })
	      )
	    ) : _react2.default.createElement(
	      'div',
	      { className: 'footer-social-buttons' },
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(SocialLink, { href: 'https://www.facebook.com/fairplaykz', social: 'facebook' }),
	        _react2.default.createElement(SocialLink, { href: 'https://twitter.com/fairplaykz', social: 'twitter' }),
	        _react2.default.createElement(SocialLink, { href: 'https://instagram.com/fairplaykz', social: 'instagram' }),
	        _react2.default.createElement(SocialLink, { href: 'https://vk.com/fairplaykz', social: 'vk' })
	      )
	    ) : null,
	    countryCode === 'UZ' && _react2.default.createElement(
	      'div',
	      { className: 'footer-social-buttons' },
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(SocialLink, { href: 'https://www.instagram.com/fairplay.uz', social: 'instagram' }),
	        _react2.default.createElement(SocialLink, { href: 'https://t.me/tikish_sport', social: 'telegram' })
	      )
	    )
	  );
	}
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    countryCode: state.application.get('countryCode')
	  };
	})(Footer);

/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _languageCountriesMap, _languageFastJoinCoun;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(8);
	
	var _Join = __webpack_require__(710);
	
	var _FastJoin = __webpack_require__(157);
	
	var _Auth = __webpack_require__(95);
	
	var _FastRegistrationForm = __webpack_require__(1360);
	
	var _FastRegistrationForm2 = _interopRequireDefault(_FastRegistrationForm);
	
	var _PhoneConfirmation = __webpack_require__(1362);
	
	var _PhoneConfirmation2 = _interopRequireDefault(_PhoneConfirmation);
	
	var _PhoneRegistrationSuccess = __webpack_require__(1363);
	
	var _PhoneRegistrationSuccess2 = _interopRequireDefault(_PhoneRegistrationSuccess);
	
	var _EmailRegistrationSuccess = __webpack_require__(1359);
	
	var _EmailRegistrationSuccess2 = _interopRequireDefault(_EmailRegistrationSuccess);
	
	var _RegistrationForm = __webpack_require__(1365);
	
	var _RegistrationForm2 = _interopRequireDefault(_RegistrationForm);
	
	var _PhoneConfirmation3 = __webpack_require__(1364);
	
	var _PhoneConfirmation4 = _interopRequireDefault(_PhoneConfirmation3);
	
	var _RegistrationSuccess = __webpack_require__(1367);
	
	var _RegistrationSuccess2 = _interopRequireDefault(_RegistrationSuccess);
	
	var _JoinType = __webpack_require__(751);
	
	var JoinType = _interopRequireWildcard(_JoinType);
	
	var _FastJoinType = __webpack_require__(568);
	
	var FastJoinType = _interopRequireWildcard(_FastJoinType);
	
	var _JoinStage = __webpack_require__(569);
	
	var JoinStage = _interopRequireWildcard(_JoinStage);
	
	var _Language = __webpack_require__(47);
	
	var _accountResources = __webpack_require__(1815);
	
	var _accountResources2 = _interopRequireDefault(_accountResources);
	
	var _accountResourcesUz = __webpack_require__(1816);
	
	var _accountResourcesUz2 = _interopRequireDefault(_accountResourcesUz);
	
	var _languages = __webpack_require__(1822);
	
	var _languages2 = _interopRequireDefault(_languages);
	
	var _timezones = __webpack_require__(1823);
	
	var _timezones2 = _interopRequireDefault(_timezones);
	
	var _ru = __webpack_require__(650);
	
	var _ru2 = _interopRequireDefault(_ru);
	
	var _en = __webpack_require__(649);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _uz = __webpack_require__(1818);
	
	var _uz2 = _interopRequireDefault(_uz);
	
	var _kk = __webpack_require__(1817);
	
	var _kk2 = _interopRequireDefault(_kk);
	
	var _ru3 = __webpack_require__(869);
	
	var _ru4 = _interopRequireDefault(_ru3);
	
	var _en3 = __webpack_require__(1819);
	
	var _en4 = _interopRequireDefault(_en3);
	
	var _uz3 = __webpack_require__(1821);
	
	var _uz4 = _interopRequireDefault(_uz3);
	
	var _kk3 = __webpack_require__(1820);
	
	var _kk4 = _interopRequireDefault(_kk3);
	
	var _functions = __webpack_require__(305);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var languageCountriesMap = (_languageCountriesMap = {}, (0, _defineProperty3.default)(_languageCountriesMap, _Language.RU, _ru2.default), (0, _defineProperty3.default)(_languageCountriesMap, 2, _ru2.default), (0, _defineProperty3.default)(_languageCountriesMap, 3, _ru2.default), (0, _defineProperty3.default)(_languageCountriesMap, 4, _ru2.default), (0, _defineProperty3.default)(_languageCountriesMap, _Language.EN, _en2.default), (0, _defineProperty3.default)(_languageCountriesMap, _Language.UZ, _uz2.default), (0, _defineProperty3.default)(_languageCountriesMap, _Language.KK, _kk2.default), _languageCountriesMap);
	
	var languageFastJoinCountriesMap = (_languageFastJoinCoun = {}, (0, _defineProperty3.default)(_languageFastJoinCoun, _Language.RU, _ru4.default), (0, _defineProperty3.default)(_languageFastJoinCoun, _Language.EN, _en4.default), (0, _defineProperty3.default)(_languageFastJoinCoun, _Language.UZ, _uz4.default), (0, _defineProperty3.default)(_languageFastJoinCoun, _Language.KK, _kk4.default), _languageFastJoinCoun);
	
	var messages = (0, _reactIntl.defineMessages)({
	    title: {
	        id: 'join.title',
	        defaultMessage: 'Регистрация'
	    },
	    fastTitle: {
	        id: 'join.fast_registration_title',
	        defaultMessage: 'Быстрая Регистрация'
	    },
	    regularTitle: {
	        id: 'join.registration_title',
	        defaultMessage: 'Обычная Регистрация'
	    }
	});
	
	var Join = function (_React$Component) {
	    (0, _inherits3.default)(Join, _React$Component);
	    (0, _createClass3.default)(Join, null, [{
	        key: '_renderTab',
	        value: function _renderTab(label, itemClass, clickHandler) {
	            return _react2.default.createElement(
	                'li',
	                { className: itemClass, onClick: clickHandler },
	                _react2.default.createElement(_reactIntl.FormattedMessage, label)
	            );
	        }
	    }]);
	
	    function Join(props) {
	        (0, _classCallCheck3.default)(this, Join);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Join.__proto__ || (0, _getPrototypeOf2.default)(Join)).call(this, props));
	
	        _this._handleCloseClick = _this._handleCloseClick.bind(_this);
	        _this._tabChange = _this._tabChange.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(Join, [{
	        key: '_tabChange',
	        value: function _tabChange(type) {
	            this.props.changeJoinTypeAction({ joinType: type });
	        }
	    }, {
	        key: '_handleCloseClick',
	        value: function _handleCloseClick(e) {
	            e.preventDefault();
	            this.props.cancelJoinAction();
	        }
	    }, {
	        key: 'renderHeader',
	        value: function renderHeader() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'modal--header' },
	                _react2.default.createElement('div', { className: 'header-inner--logotype__link' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'header-inner__title' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.title)
	                ),
	                _react2.default.createElement('button', { className: 'modal__close modal__close__green modal__close__js',
	                    onClick: this._handleCloseClick }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'tabs' },
	                    this._renderMenu()
	                )
	            );
	        }
	    }, {
	        key: '_renderMenu',
	        value: function _renderMenu() {
	            var joinType = this.props.joinType;
	
	
	            var listItemClass = 'main-tabs--list__item tabs--list__item main-tabs--list__item__js';
	            var listActiveItemClass = 'main-tabs--list__item tabs--list__item main-tabs--list__item__js active';
	
	            var fastJoinClass = joinType === JoinType.FAST ? listActiveItemClass : listItemClass;
	            var regularJoinClass = joinType === JoinType.REGULAR ? listActiveItemClass : listItemClass;
	
	            var fastJoinClick = this._tabChange.bind(this, JoinType.FAST);
	            var regularJoinClick = this._tabChange.bind(this, JoinType.REGULAR);
	
	            return _react2.default.createElement(
	                'ul',
	                { className: 'main-tabs--list tabs--list' },
	                Join._renderTab(messages.fastTitle, fastJoinClass, fastJoinClick),
	                Join._renderTab(messages.regularTitle, regularJoinClass, regularJoinClick)
	            );
	        }
	    }, {
	        key: 'renderFastJoin',
	        value: function renderFastJoin() {
	            var _props = this.props,
	                languageId = _props.languageId,
	                joinStage = _props.joinStage,
	                joining = _props.joining,
	                joinError = _props.joinError,
	                promoCodeError = _props.promoCodeError,
	                fastJoin = _props.fastJoin,
	                fastJoinAction = _props.fastJoinAction,
	                fastConfirmAction = _props.fastConfirmAction,
	                cancelJoinAction = _props.cancelJoinAction,
	                domain = _props.domain;
	
	
	            var countries = languageFastJoinCountriesMap[languageId];
	
	            var _getInitialCountryCod = (0, _functions.getInitialCountryCode)(this.props.countryCode),
	                defaultCountryId = _getInitialCountryCod.defaultCountryId,
	                accountResourceId = _getInitialCountryCod.accountResourceId;
	
	            var defaultCountry = countries[defaultCountryId];
	
	            var countryCode = defaultCountry.mask;
	            var countryNumberLength = defaultCountry.length;
	            var accountResources = this.props.countryCode === 'UZ' ? _accountResourcesUz2.default : _accountResources2.default;
	
	            var defaultValues = {
	                initialValues: {
	                    type: FastJoinType.SMS,
	                    agree: false,
	                    accountResourceId: accountResourceId,
	                    countryId: defaultCountryId,
	                    countryCode: countryCode,
	                    countryNumberLength: countryNumberLength
	                }
	            };
	
	            var registrationProps = (0, _extends3.default)({
	                languageId: languageId,
	                joining: joining,
	                joinError: joinError,
	                promoCodeError: promoCodeError,
	                fastJoin: fastJoin,
	                submitAction: fastJoinAction,
	                accountResources: accountResources,
	                countries: countries,
	                domain: domain
	            }, defaultValues);
	
	            var phoneConfirmationProps = {
	                languageId: languageId,
	                inProcess: joining,
	                error: joinError,
	                fastJoin: fastJoin,
	                countryCode: this.props.countryCode,
	                confirmPhone: fastConfirmAction,
	                resendCode: fastJoinAction,
	                closeCallback: this._handleCloseClick
	            };
	
	            var phoneSuccessProps = {
	                languageId: languageId,
	                domain: domain,
	                finalizeJoin: cancelJoinAction
	            };
	
	            var email = fastJoin ? fastJoin.get('Email') : '';
	
	            var emailSuccessProps = {
	                languageId: languageId,
	                email: email,
	                cancelCallback: this._handleCloseClick
	            };
	
	            if (joinStage === JoinStage.SUCCESS) {
	                return _react2.default.createElement(_PhoneRegistrationSuccess2.default, phoneSuccessProps);
	            }
	
	            if (joinStage === JoinStage.EMAIL_SENT) {
	                return _react2.default.createElement(_EmailRegistrationSuccess2.default, emailSuccessProps);
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'modal--registration' },
	                this.renderHeader(),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal--content' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'modal--content__wrapper' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'main-tabs--content tabs-content' },
	                            joinStage === JoinStage.INIT && _react2.default.createElement(_FastRegistrationForm2.default, registrationProps),
	                            joinStage === JoinStage.PHONE_CONFIRMATION && _react2.default.createElement(_PhoneConfirmation2.default, phoneConfirmationProps)
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'renderRegularJoin',
	        value: function renderRegularJoin() {
	            var _props2 = this.props,
	                languageId = _props2.languageId,
	                joinStage = _props2.joinStage,
	                joining = _props2.joining,
	                joinError = _props2.joinError,
	                userRegistration = _props2.userRegistration,
	                promoCodeError = _props2.promoCodeError,
	                phoneConfirming = _props2.phoneConfirming,
	                phoneConfirmationRequested = _props2.phoneConfirmationRequested,
	                phoneConfirmed = _props2.phoneConfirmed,
	                phoneConfirmationError = _props2.phoneConfirmationError,
	                joinAction = _props2.joinAction,
	                domain = _props2.domain;
	
	
	            var countries = languageCountriesMap[languageId];
	
	            var _getInitialCountryCod2 = (0, _functions.getInitialCountryCode)(this.props.countryCode),
	                defaultCountryId = _getInitialCountryCod2.defaultCountryId,
	                accountResourceId = _getInitialCountryCod2.accountResourceId;
	
	            var defaultCountry = countries[defaultCountryId];
	
	            var countryCode = defaultCountry.mask;
	            var countryNumberLength = defaultCountry.length;
	            var accountResources = this.props.countryCode === 'UZ' ? _accountResourcesUz2.default : _accountResources2.default;
	
	            var defaultValues = {
	                initialValues: {
	                    agree: false,
	                    accountResourceId: accountResourceId,
	                    countryId: defaultCountryId,
	                    countryCode: countryCode,
	                    countryNumberLength: countryNumberLength,
	                    timezoneId: 1
	                }
	            };
	
	            var registrationProps = (0, _extends3.default)({
	                languageId: languageId,
	                joining: joining,
	                joinError: joinError,
	                promoCodeError: promoCodeError,
	                submitAction: joinAction,
	                cancelCallback: this._handleCloseClick,
	                accountResources: accountResources,
	                countries: countries,
	                languages: _languages2.default,
	                timezones: _timezones2.default,
	                domain: domain
	            }, defaultValues);
	
	            var gamblerId = void 0;
	            var phone = void 0;
	            var email = void 0;
	            var joinPromoType = void 0;
	            if (userRegistration) {
	                gamblerId = userRegistration.get('gamblerId');
	                phone = userRegistration.get('phone');
	                email = userRegistration.get('email');
	                joinPromoType = userRegistration.get('joinPromoType');
	            }
	
	            var registrationSuccessProps = {
	                languageId: languageId,
	                email: email,
	                cancelCallback: this._handleCloseClick
	            };
	
	            var phoneConfirmationProps = {
	                languageId: languageId,
	                gamblerId: gamblerId,
	                joinPromoType: joinPromoType,
	                countryCode: this.props.countryCode,
	                phone: phone,
	                phoneConfirming: phoneConfirming,
	                phoneConfirmationRequested: phoneConfirmationRequested,
	                phoneConfirmationError: phoneConfirmationError,
	                phoneConfirmed: phoneConfirmed,
	                cancelCallback: this._handleCloseClick
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'modal--registration' },
	                joinStage === JoinStage.INIT && this.renderHeader(),
	                joinStage === JoinStage.INIT && _react2.default.createElement(
	                    'div',
	                    { className: 'modal--content' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'modal--content__wrapper' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'main-tabs--content tabs-content' },
	                            _react2.default.createElement(_RegistrationForm2.default, registrationProps)
	                        )
	                    )
	                ),
	                joinStage === JoinStage.PHONE_CONFIRMATION && _react2.default.createElement(_PhoneConfirmation4.default, phoneConfirmationProps),
	                joinStage === JoinStage.SUCCESS && _react2.default.createElement(_RegistrationSuccess2.default, registrationSuccessProps)
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var joinType = this.props.joinType;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'modal modal--auth modal--auth__simple-registration modal__visible ' },
	                joinType === JoinType.FAST && this.renderFastJoin(),
	                joinType === JoinType.REGULAR && this.renderRegularJoin()
	            );
	        }
	    }]);
	    return Join;
	}(_react2.default.Component);
	
	Join.propTypes = {
	    languageId: _react2.default.PropTypes.number.isRequired,
	    joinType: _react2.default.PropTypes.number.isRequired,
	    joinStage: _react2.default.PropTypes.number.isRequired,
	    joining: _react2.default.PropTypes.bool.isRequired,
	    joinError: _react2.default.PropTypes.any,
	    promoCodeError: _react2.default.PropTypes.any,
	    userRegistration: _react2.default.PropTypes.any,
	    fastJoin: _react2.default.PropTypes.any,
	    phoneConfirming: _react2.default.PropTypes.bool.isRequired,
	    phoneConfirmationRequested: _react2.default.PropTypes.bool.isRequired,
	    phoneConfirmed: _react2.default.PropTypes.bool.isRequired,
	    phoneConfirmationError: _react2.default.PropTypes.any,
	    domain: _react2.default.PropTypes.string.isRequired,
	    joinAction: _react2.default.PropTypes.func.isRequired,
	    fastJoinAction: _react2.default.PropTypes.func.isRequired,
	    fastConfirmAction: _react2.default.PropTypes.func.isRequired,
	    cancelJoinAction: _react2.default.PropTypes.func.isRequired,
	    changeJoinTypeAction: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select(state) {
	    return {
	        languageId: state.application.get('languageId'),
	        countryCode: state.application.get('countryCode'),
	        joinType: state.join.get('type'),
	        joinStage: state.join.get('stage'),
	        joining: state.join.get('inProcess'),
	        joinError: state.join.get('error'),
	        promoCodeError: state.join.get('PromocodeError'),
	        userRegistration: state.join.get('userRegistration'),
	        fastJoin: state.join.get('fastJoin'),
	        phoneConfirming: state.phoneConfirm.get('inProcess'),
	        phoneConfirmationError: state.phoneConfirm.get('error'),
	        phoneConfirmationRequested: state.phoneConfirm.get('requested'),
	        phoneConfirmed: state.phoneConfirm.get('confirmed'),
	        domain: state.domain
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, { joinAction: _Join.join, cancelJoinAction: _Auth.cancelJoin, fastJoinAction: _FastJoin.join, fastConfirmAction: _FastJoin.confirmPhone, changeJoinTypeAction: _Join.changeJoinType })(Join);

/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _localeMessagesMap;
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(8);
	
	var _Locales = __webpack_require__(80);
	
	var _Locales2 = _interopRequireDefault(_Locales);
	
	var _ru = __webpack_require__(545);
	
	var _ru2 = _interopRequireDefault(_ru);
	
	var _en = __webpack_require__(543);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _uz = __webpack_require__(546);
	
	var _uz2 = _interopRequireDefault(_uz);
	
	var _kk = __webpack_require__(544);
	
	var _kk2 = _interopRequireDefault(_kk);
	
	var _ru3 = __webpack_require__(1832);
	
	var _ru4 = _interopRequireDefault(_ru3);
	
	var _en3 = __webpack_require__(1830);
	
	var _en4 = _interopRequireDefault(_en3);
	
	var _uz3 = __webpack_require__(1833);
	
	var _uz4 = _interopRequireDefault(_uz3);
	
	var _kk3 = __webpack_require__(1831);
	
	var _kk4 = _interopRequireDefault(_kk3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var localeMessagesMap = (_localeMessagesMap = {}, (0, _defineProperty3.default)(_localeMessagesMap, 'ru', _ru4.default), (0, _defineProperty3.default)(_localeMessagesMap, 'en', _en4.default), (0, _defineProperty3.default)(_localeMessagesMap, 'uz', _uz4.default), (0, _defineProperty3.default)(_localeMessagesMap, 'kk', _kk4.default), _localeMessagesMap);
	
	(0, _reactIntl.addLocaleData)(_ru2.default);
	(0, _reactIntl.addLocaleData)(_en2.default);
	(0, _reactIntl.addLocaleData)(_uz2.default);
	(0, _reactIntl.addLocaleData)(_kk2.default);
	
	function select(state) {
	    var locale = _Locales2.default[state.application.get('languageId')];
	    var messages = localeMessagesMap[locale];
	
	    return {
	        locale: locale,
	        messages: messages
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select)(_reactIntl.IntlProvider);

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Pagination = function (_React$Component) {
	  (0, _inherits3.default)(Pagination, _React$Component);
	
	  function Pagination() {
	    (0, _classCallCheck3.default)(this, Pagination);
	    return (0, _possibleConstructorReturn3.default)(this, (Pagination.__proto__ || (0, _getPrototypeOf2.default)(Pagination)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Pagination, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          count = _props.count,
	          currentPage = _props.currentPage,
	          perPage = _props.perPage,
	          changePage = _props.changePage;
	
	      var totalPages = Math.ceil(count / perPage);
	      var items = [];
	
	      // Сокращение дистанции между страницами
	      var minPagesToShow = 5;
	      var startPage = Math.max(1, currentPage - Math.floor(minPagesToShow / 2));
	      var endPage = Math.min(startPage + minPagesToShow - 1, totalPages);
	
	      // Добавление элементов пагинации
	      items.push(_react2.default.createElement(
	        'button',
	        {
	          className: 'arrow',
	          key: 'first',
	          onClick: function onClick() {
	            return changePage(1);
	          },
	          disabled: currentPage === 1
	        },
	        _react2.default.createElement(
	          'svg',
	          { xmlns: 'http://www.w3.org/2000/svg', width: '24', height: '24' },
	          _react2.default.createElement('path', { d: 'm13.707 4.707-1.414-1.414L3.586 12l8.707 8.707 1.414-1.414L6.414 12l7.293-7.293z' }),
	          _react2.default.createElement('path', { d: 'm19.707 4.707-1.414-1.414L9.586 12l8.707 8.707 1.414-1.414L12.414 12l7.293-7.293z' })
	        )
	      ));
	
	      items.push(_react2.default.createElement(
	        'button',
	        {
	          className: 'arrow',
	          key: 'prev',
	          onClick: function onClick() {
	            return changePage(currentPage - 1);
	          },
	          disabled: currentPage === 1
	        },
	        _react2.default.createElement(
	          'svg',
	          { xmlns: 'http://www.w3.org/2000/svg', width: '24', height: '24' },
	          _react2.default.createElement('path', { d: 'M15.293 3.293 6.586 12l8.707 8.707 1.414-1.414L9.414 12l7.293-7.293-1.414-1.414z' })
	        )
	      ));
	
	      if (startPage > 1) {
	        items.push(_react2.default.createElement(
	          'span',
	          { key: 'ellipsis-start' },
	          '...'
	        ));
	      }
	
	      var _loop = function _loop(number) {
	        items.push(_react2.default.createElement(
	          'button',
	          {
	            key: number,
	            className: number === currentPage ? 'active' : '',
	            onClick: function onClick() {
	              return changePage(number);
	            }
	          },
	          number
	        ));
	      };
	
	      for (var number = startPage; number <= endPage; number++) {
	        _loop(number);
	      }
	
	      if (endPage < totalPages) {
	        items.push(_react2.default.createElement(
	          'span',
	          { key: 'ellipsis-end' },
	          '...'
	        ));
	      }
	
	      items.push(_react2.default.createElement(
	        'button',
	        {
	          className: 'arrow',
	          key: 'next',
	          onClick: function onClick() {
	            return changePage(currentPage + 1);
	          },
	          disabled: currentPage === totalPages || totalPages === 0
	        },
	        _react2.default.createElement(
	          'svg',
	          { xmlns: 'http://www.w3.org/2000/svg', width: '24', height: '24' },
	          _react2.default.createElement('path', { d: 'M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z' })
	        )
	      ));
	
	      items.push(_react2.default.createElement(
	        'button',
	        {
	          className: 'arrow',
	          key: 'last',
	          onClick: function onClick() {
	            return changePage(totalPages);
	          },
	          disabled: currentPage === totalPages || totalPages === 0
	        },
	        _react2.default.createElement(
	          'svg',
	          { xmlns: 'http://www.w3.org/2000/svg', width: '24', height: '24' },
	          _react2.default.createElement('path', { d: 'm11.707 3.293-1.414 1.414L17.586 12l-7.293 7.293 1.414 1.414L20.414 12l-8.707-8.707z' }),
	          _react2.default.createElement('path', { d: 'M5.707 3.293 4.293 4.707 11.586 12l-7.293 7.293 1.414 1.414L14.414 12 5.707 3.293z' })
	        )
	      ));
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'pagination' },
	        items
	      );
	    }
	  }]);
	  return Pagination;
	}(_react2.default.Component);
	
	exports.default = Pagination;

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fields = undefined;
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(8);
	
	var _PasswordRecoveryViaPhoneValidation = __webpack_require__(1179);
	
	var _PasswordRecoveryViaPhoneValidation2 = _interopRequireDefault(_PasswordRecoveryViaPhoneValidation);
	
	var _stripCorrectProps = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    profile_code_label: {
	        id: 'join.fast.phone_confirm.confirmation_code',
	        defaultMessage: 'Код подтверждения'
	    },
	    profile_password_form_new_password_label: {
	        id: 'create-password.profile_password_form_new_password_label',
	        defaultMessage: 'Новый пароль'
	    },
	    profile_password_form_retype_password: {
	        id: 'create-password.profile_password_form_retype_password',
	        defaultMessage: 'Повторите пароль'
	    },
	    profile_password_form_btn_msg: {
	        id: 'create-password.profile_password_form_btn_msg',
	        defaultMessage: 'Сохранить'
	    }
	});
	
	var SUCCESSFUL_UPDATE_REQUEST = 0;
	
	var fields = exports.fields = ['Code', 'NewPassword', 'NewPasswordConfirm'];
	
	var PasswordRecoverViaPhone = function (_React$Component) {
	    (0, _inherits3.default)(PasswordRecoverViaPhone, _React$Component);
	    (0, _createClass3.default)(PasswordRecoverViaPhone, null, [{
	        key: '_renderError',
	        value: function _renderError(error) {
	            return _react2.default.createElement(
	                'div',
	                { style: { marginLeft: '170px', color: '#9e2929' } },
	                _react2.default.createElement(_reactIntl.FormattedMessage, error)
	            );
	        }
	    }]);
	
	    function PasswordRecoverViaPhone(props) {
	        (0, _classCallCheck3.default)(this, PasswordRecoverViaPhone);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (PasswordRecoverViaPhone.__proto__ || (0, _getPrototypeOf2.default)(PasswordRecoverViaPhone)).call(this, props));
	
	        _this.state = { requestSent: false, successfulRequest: false };
	        _this._onSubmit = _this._onSubmit.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(PasswordRecoverViaPhone, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            if (this.props.isUpdating && !newProps.isUpdating) {
	                this.setState({ requestSent: true });
	            } else {
	                this.setState({ requestSent: false });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.requestSent && this.props.isUpdated == SUCCESSFUL_UPDATE_REQUEST) {
	                this.props.resetForm();
	            }
	        }
	    }, {
	        key: '_onSubmit',
	        value: function _onSubmit(values) {
	            this.props.submitAction(values);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                _props$fields = _props.fields,
	                NewPassword = _props$fields.NewPassword,
	                NewPasswordConfirm = _props$fields.NewPasswordConfirm,
	                Code = _props$fields.Code,
	                handleSubmit = _props.handleSubmit;
	
	            var submitHandler = this._onSubmit;
	
	            var formClass = 'settings--form settings--form__password-change form';
	            var cleanClass = 'profile--form__row form__row';
	            var errorClass = 'profile--form__row form__row form__row__error';
	            var labelClass = 'settings--form__label form__label';
	            var inputClass = 'settings--form__control form__control';
	            var btnClass = 'withdrawal--form__btn withdrawal-bid--form__btn__js form__btn';
	
	            return _react2.default.createElement(
	                'form',
	                { className: formClass, onSubmit: handleSubmit(submitHandler) },
	                _react2.default.createElement('input', { style: { display: 'none' }, type: 'password', name: 'fakepasswordremembered' }),
	                Code.touched && Code.error && _react2.default.createElement(
	                    'div',
	                    { className: errorClass },
	                    _react2.default.createElement(
	                        'label',
	                        { className: labelClass },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.profile_code_label)
	                    ),
	                    _react2.default.createElement('input', (0, _extends3.default)({ type: 'text', className: inputClass }, (0, _stripCorrectProps.stripProps)(Code))),
	                    PasswordRecoverViaPhone._renderError(Code.error)
	                ),
	                (!Code.touched || !Code.error) && _react2.default.createElement(
	                    'div',
	                    { className: cleanClass },
	                    _react2.default.createElement(
	                        'label',
	                        { className: labelClass },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.profile_code_label)
	                    ),
	                    _react2.default.createElement('input', (0, _extends3.default)({ type: 'text', className: inputClass }, (0, _stripCorrectProps.stripProps)(Code)))
	                ),
	                NewPassword.touched && NewPassword.error && _react2.default.createElement(
	                    'div',
	                    { className: errorClass },
	                    _react2.default.createElement(
	                        'label',
	                        { className: labelClass },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.profile_password_form_new_password_label)
	                    ),
	                    _react2.default.createElement('input', (0, _extends3.default)({ type: 'password', className: inputClass }, (0, _stripCorrectProps.stripProps)(NewPassword))),
	                    PasswordRecoverViaPhone._renderError(NewPassword.error)
	                ),
	                (!NewPassword.touched || !NewPassword.error) && _react2.default.createElement(
	                    'div',
	                    { className: cleanClass },
	                    _react2.default.createElement(
	                        'label',
	                        { className: labelClass },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.profile_password_form_new_password_label)
	                    ),
	                    _react2.default.createElement('input', (0, _extends3.default)({ type: 'password', className: inputClass }, (0, _stripCorrectProps.stripProps)(NewPassword)))
	                ),
	                NewPasswordConfirm.touched && NewPasswordConfirm.error && _react2.default.createElement(
	                    'div',
	                    { className: errorClass },
	                    _react2.default.createElement(
	                        'label',
	                        { className: labelClass },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.profile_password_form_retype_password)
	                    ),
	                    _react2.default.createElement('input', (0, _extends3.default)({ type: 'password', className: inputClass }, (0, _stripCorrectProps.stripProps)(NewPasswordConfirm))),
	                    PasswordRecoverViaPhone._renderError(NewPasswordConfirm.error)
	                ),
	                (!NewPasswordConfirm.touched || !NewPasswordConfirm.error) && _react2.default.createElement(
	                    'div',
	                    { className: cleanClass },
	                    _react2.default.createElement(
	                        'label',
	                        { className: labelClass },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.profile_password_form_retype_password)
	                    ),
	                    _react2.default.createElement('input', (0, _extends3.default)({ type: 'password', className: inputClass }, (0, _stripCorrectProps.stripProps)(NewPasswordConfirm)))
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'settings--form__row form__row' },
	                    _react2.default.createElement(
	                        'button',
	                        { type: 'submit', className: btnClass, onClick: handleSubmit(submitHandler) },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.profile_password_form_btn_msg)
	                    )
	                )
	            );
	        }
	    }]);
	    return PasswordRecoverViaPhone;
	}(_react2.default.Component);
	
	PasswordRecoverViaPhone.propTypes = {
	    fields: _react2.default.PropTypes.any,
	    handleSubmit: _react2.default.PropTypes.any,
	    resetForm: _react2.default.PropTypes.any,
	    submitAction: _react2.default.PropTypes.func.isRequired,
	    isUpdating: _react2.default.PropTypes.any,
	    isUpdated: _react2.default.PropTypes.any
	};
	exports.default = (0, _reduxForm.reduxForm)({
	    form: 'phone-password-recovery',
	    fields: fields,
	    initialValues: {},
	    validate: _PasswordRecoveryViaPhoneValidation2.default
	})(PasswordRecoverViaPhone);

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(8);
	
	var _PasswordRecovery = __webpack_require__(487);
	
	var _PasswordRecoveryState = __webpack_require__(335);
	
	var PasswordRecoveryStates = _interopRequireWildcard(_PasswordRecoveryState);
	
	var _PasswordRecoverViaPhone = __webpack_require__(1177);
	
	var _PasswordRecoverViaPhone2 = _interopRequireDefault(_PasswordRecoverViaPhone);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    recovery: {
	        id: 'password_recovery.title',
	        defaultMessage: 'Восстановление учетной записи'
	    },
	    passwordSentTo: {
	        id: 'password_recovery.sent_to',
	        defaultMessage: 'Новый пароль был выслан на'
	    },
	    passwordSentRepeatedly: {
	        id: 'password_recovery.sent_repeatedly',
	        defaultMessage: 'Мы многократно отправили информацию о восстановлении пароля. В целях безопасности, пожалуйста, обратитесь в службу поддержки.'
	    },
	    smsExceeded: {
	        id: 'password_recovery.sms_exceeded',
	        defaultMessage: 'Мы дважды выслали на Ваш номер сообщение для восстановления пароля. Пожалуйста, дождитесь СМС, либо обратитесь в службу поддержки.'
	    },
	    deliveryCondition: {
	        id: 'password_recovery.delivery_condition',
	        defaultMessage: 'Если в течении пяти вы не получите от нас письма, то проверьте папку "Спам"'
	    },
	    support: {
	        id: 'password_recovery.support',
	        defaultMessage: 'В противном случае, свяжитесь со службой поддержки клиентов через онлайн-чат'
	    },
	    registrationRequisite: {
	        id: 'password_recovery.registration_requisite',
	        defaultMessage: 'Укажите логин, номер счета, е-майл или номер телефона (в формате {mask}), который вы использовали при регистрации на сайте'
	    },
	    requisite: {
	        id: 'password_recovery.requisite',
	        defaultMessage: 'Реквизит'
	    },
	    recoverTitle: {
	        id: 'password_recovery.recover_title',
	        defaultMessage: 'Восстановить'
	    },
	    passwordSentToPhone: {
	        id: 'password_recovery.sent_via_sms',
	        defaultMessage: 'Пароль выслан на номер <strong>{phone}</strong>'
	    },
	    supportPhone: {
	        id: 'password_recovery.support_phone',
	        defaultMessage: 'Если в течении нескольких минут вы не получите SMS, свяжитесь со службой поддержки клиентов через онлайн-чат'
	    },
	    passwordChanged: {
	        id: 'create-password.password_changed',
	        defaultMessage: 'Пароль изменен'
	    }
	});
	
	var PasswordRecovery = function (_React$Component) {
	    (0, _inherits3.default)(PasswordRecovery, _React$Component);
	    (0, _createClass3.default)(PasswordRecovery, null, [{
	        key: '_successEmail',
	        value: function _successEmail(email) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'modal--auth-recover__success' },
	                _react2.default.createElement(
	                    'p',
	                    { className: 'plain-text__paragraph modal--auth-recover__title' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'modal--auth-recover__title__span' },
	                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, (0, _extends3.default)({}, messages.passwordSentTo, { values: { email: email } }))
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'plain-text__paragraph' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.deliveryCondition)
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'plain-text__paragraph' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.support)
	                )
	            );
	        }
	    }, {
	        key: '_successPhone',
	        value: function _successPhone(recoverPassword, errorCode, state) {
	            var message = void 0;
	            if (errorCode === -100 || errorCode == -500) {
	                message = _react2.default.createElement(
	                    'div',
	                    { className: 'error-message', style: { marginLeft: '175px', marginBottom: '15px' } },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'password_recovery.errors.internal_error' })
	                );
	            }
	
	            if (state === 0) {
	                return _react2.default.createElement(
	                    'p',
	                    { className: 'plain-text__paragraph' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.passwordChanged)
	                );
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'modal--auth-recover__success' },
	                message,
	                _react2.default.createElement(_PasswordRecoverViaPhone2.default, { submitAction: recoverPassword })
	            );
	        }
	    }, {
	        key: '_init',
	        value: function _init(errorCode, onRecoverClick, email, emailRecover, phoneRecover, countryCode) {
	            var message = void 0;
	            var mask = '77011234567';
	            if (countryCode === 'UZ') mask = '998011234567';
	            if (countryCode === 'KG') mask = '996011234567';
	
	            if (errorCode === -2) {
	                message = _react2.default.createElement(
	                    'div',
	                    { className: 'error-message' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'password_recovery.errors.invalid_credentials' })
	                );
	            } else if (errorCode === -3 || errorCode === -4) {
	                if (emailRecover) {
	                    message = _react2.default.createElement(
	                        'div',
	                        { className: 'error-message' },
	                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, (0, _extends3.default)({}, messages.passwordSentRepeatedly, { values: { email: email } }))
	                    );
	                } else if (phoneRecover) {
	                    message = _react2.default.createElement(
	                        'div',
	                        { className: 'error-message' },
	                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, (0, _extends3.default)({}, messages.smsExceeded, { values: { email: email } }))
	                    );
	                }
	            } else if (errorCode === -5) {
	                message = _react2.default.createElement(
	                    'div',
	                    { className: 'error-message' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'password_recovery.errors.blocked' })
	                );
	            } else if (errorCode === -10000 || errorCode === -100) {
	                message = _react2.default.createElement(
	                    'div',
	                    { className: 'error-message' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'password_recovery.errors.internal_error' })
	                );
	            }
	
	            return _react2.default.createElement(
	                'form',
	                { className: 'login--form form' },
	                _react2.default.createElement(
	                    'p',
	                    { className: 'plain-text__paragraph' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, messages.registrationRequisite, { values: { mask: mask } }))
	                ),
	                message,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'login--form__row form__row' },
	                    _react2.default.createElement('input', { ref: 'requisite', className: 'login--form__control form__control', style: { marginLeft: 175 } })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'login--form__row form__row' },
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'login--form__btn login--form__btn__js form__btn',
	                            onClick: onRecoverClick },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.recoverTitle)
	                    )
	                )
	            );
	        }
	    }]);
	
	    function PasswordRecovery(props) {
	        (0, _classCallCheck3.default)(this, PasswordRecovery);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (PasswordRecovery.__proto__ || (0, _getPrototypeOf2.default)(PasswordRecovery)).call(this, props));
	
	        _this._handleCloseClick = _this._handleCloseClick.bind(_this);
	        _this._handleRecoverClick = _this._handleRecoverClick.bind(_this);
	        _this._recoverPassword = _this._recoverPassword.bind(_this);
	
	        _this.state = {
	            requisite: '',
	            emailRecover: false,
	            phoneRecover: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(PasswordRecovery, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.refs.requisite.focus();
	        }
	    }, {
	        key: '_handleCloseClick',
	        value: function _handleCloseClick(e) {
	            e.preventDefault();
	            this.props.cancelPasswordRecoveryAction();
	        }
	    }, {
	        key: '_handleRecoverClick',
	        value: function _handleRecoverClick(e) {
	            e.preventDefault();
	
	            var emailRecover = false;
	            var phoneRecover = false;
	            var requisiteVal = this.refs.requisite.value;
	            if (requisiteVal) {
	                var phone = requisiteVal.substring(1);
	                if (requisiteVal[0] === '+' && /^\d+$/.test(phone)) {
	                    this.props.recoverPasswordAction({ requisite: phone });
	                    phoneRecover = true;
	                } else {
	                    this.props.recoverPasswordAction({ requisite: requisiteVal });
	                    emailRecover = true;
	                }
	            }
	
	            this.setState({
	                requisite: requisiteVal,
	                emailRecover: emailRecover,
	                phoneRecover: phoneRecover
	            });
	        }
	    }, {
	        key: '_recoverPassword',
	        value: function _recoverPassword(values) {
	            this.props.recoverPasswordViaPhoneAction(values);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                errorCode = _props.errorCode,
	                email = _props.email,
	                phone = _props.phone,
	                recoveryState = _props.recoveryState,
	                createPasswordErrorCode = _props.createPasswordErrorCode,
	                createPasswordState = _props.createPasswordState,
	                countryCode = _props.countryCode;
	            var _state = this.state,
	                requisite = _state.requisite,
	                emailRecover = _state.emailRecover,
	                phoneRecover = _state.phoneRecover;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'modal modal--auth modal--auth-recover modal__visible ' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal--dialog' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'modal--header' },
	                        _react2.default.createElement('div', { className: 'header-inner--logotype__link' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-inner__title' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.recovery)
	                        ),
	                        _react2.default.createElement('button', { className: 'modal__close modal__close__green modal__close__js',
	                            onClick: this._handleCloseClick })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'modal--content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'modal--content__wrapper' },
	                            !errorCode && email && recoveryState === PasswordRecoveryStates.FINISH && PasswordRecovery._successEmail(email),
	                            !errorCode && phone && recoveryState === PasswordRecoveryStates.FINISH && PasswordRecovery._successPhone(this._recoverPassword, createPasswordErrorCode, createPasswordState),
	                            !errorCode && phone && createPasswordState === 0 && PasswordRecovery._successPhone(this._recoverPassword, createPasswordErrorCode, createPasswordState),
	                            !errorCode && phone && createPasswordErrorCode && PasswordRecovery._successPhone(this._recoverPassword, createPasswordErrorCode, createPasswordState),
	                            (errorCode || recoveryState === PasswordRecoveryStates.INIT) && PasswordRecovery._init(errorCode, this._handleRecoverClick, requisite, emailRecover, phoneRecover, countryCode)
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return PasswordRecovery;
	}(_react2.default.Component);
	
	PasswordRecovery.propTypes = {
	    createPasswordErrorCode: _react2.default.PropTypes.any,
	    errorCode: _react2.default.PropTypes.number,
	    email: _react2.default.PropTypes.string,
	    phone: _react2.default.PropTypes.string,
	    recoveryState: _react2.default.PropTypes.number.isRequired,
	    cancelPasswordRecoveryAction: _react2.default.PropTypes.func.isRequired,
	    recoverPasswordViaPhoneAction: _react2.default.PropTypes.func.isRequired,
	    recoverPasswordAction: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select(state) {
	    var errorCode = state.passwordRecovery.get('errorCode');
	    var email = state.passwordRecovery.get('email');
	    var phone = state.passwordRecovery.get('phone');
	    var recoveryState = state.passwordRecovery.get('state');
	    var createPasswordErrorCode = state.passwordRecovery.get('createPasswordErrorCode');
	    var createPasswordState = state.passwordRecovery.get('createPasswordState');
	    var countryCode = state.application.get('countryCode');
	
	    return {
	        errorCode: errorCode,
	        email: email,
	        phone: phone,
	        recoveryState: recoveryState,
	        createPasswordErrorCode: createPasswordErrorCode,
	        createPasswordState: createPasswordState,
	        countryCode: countryCode
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, { cancelPasswordRecoveryAction: _PasswordRecovery.cancelPasswordRecovery, recoverPasswordAction: _PasswordRecovery.recoverPassword, recoverPasswordViaPhoneAction: _PasswordRecovery.recoverPasswordViaPhone })(PasswordRecovery);

/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactIntl = __webpack_require__(8);
	
	var messages = (0, _reactIntl.defineMessages)({
	    password_form_error_empty_field: {
	        id: 'create-password.limit_form_error_empty_field',
	        defaultMessage: 'Поле обязательно для заполнения'
	    },
	    password_form_error_mismatch: {
	        id: 'create-password.password_form_error_mismatch',
	        defaultMessage: 'Подтверждение пароля не совпадает'
	    }
	});
	
	var PasswordFormValidation = function PasswordFormValidation(values) {
	    var errors = {};
	
	    var code = values.Code;
	    var newPassword = values.NewPassword;
	    var newPasswordConfirm = values.NewPasswordConfirm;
	
	    if (!code) {
	        errors.Code = messages.password_form_error_empty_field;
	    }
	
	    if (!newPassword || !newPassword.length) {
	        errors.NewPassword = messages.password_form_error_empty_field;
	    }
	
	    if (!newPasswordConfirm || !newPasswordConfirm.length) {
	        errors.NewPasswordConfirm = messages.password_form_error_empty_field;
	    } else if (newPassword != newPasswordConfirm) {
	        errors.NewPasswordConfirm = messages.password_form_error_mismatch;
	    }
	
	    return errors;
	};
	
	exports.default = PasswordFormValidation;

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Select = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(61);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Select = exports.Select = function (_Component) {
	  (0, _inherits3.default)(Select, _Component);
	
	  function Select(props) {
	    (0, _classCallCheck3.default)(this, Select);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Select.__proto__ || (0, _getPrototypeOf2.default)(Select)).call(this, props));
	
	    _this.onOptionClick = function (option) {
	      if (option.disabled) return;
	      if (option.value !== _this.props.value) {
	        _this.props.onChange && _this.props.onChange(option.value);
	      }
	      _this.setState({ isOpen: false });
	    };
	
	    _this.onMouseEnter = function () {
	      _this.setState({ isMouseInside: true });
	    };
	
	    _this.onMouseLeave = function () {
	      _this.setState({ isMouseInside: false });
	    };
	
	    _this.onToggleDropdown = function () {
	      if (_this.props.disabled) return;
	      _this.setState(function (prev) {
	        return { isOpen: !prev.isOpen };
	      });
	    };
	
	    _this.updateScrollArrows = function () {
	      var container = _this.scrollRef;
	      if (!container) return;
	
	      var scrollTop = container.scrollTop,
	          scrollHeight = container.scrollHeight,
	          clientHeight = container.clientHeight;
	
	      _this.setState({
	        showScrollUp: scrollTop > 5,
	        showScrollDown: scrollTop + clientHeight < scrollHeight - 5
	      });
	    };
	
	    _this.preventScroll = function (e) {
	      var _this$state = _this.state,
	          isMouseInside = _this$state.isMouseInside,
	          isOpen = _this$state.isOpen;
	
	
	      if (isMouseInside && isOpen) {
	        e.preventDefault();
	
	        var dropdown = _this.scrollRef;
	        if (dropdown) {
	          var maxScrollTop = dropdown.scrollHeight - dropdown.clientHeight;
	          var delta = e.deltaY;
	
	          if (delta > 0) {
	            dropdown.scrollTop = Math.min(dropdown.scrollTop + 30, maxScrollTop);
	          } else {
	            dropdown.scrollTop = Math.max(dropdown.scrollTop - 30, 0);
	          }
	        }
	      }
	    };
	
	    _this.state = {
	      isOpen: false,
	      showScrollUp: false,
	      showScrollDown: false,
	      isMouseInside: false
	    };
	    _this.selectRef = null;
	    _this.scrollRef = null;
	    _this.onDocumentClick = _this.onDocumentClick.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Select, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('mousedown', this.onDocumentClick);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('mousedown', this.onDocumentClick);
	      document.removeEventListener('wheel', this.preventScroll);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(_, prevState) {
	      var becameOpen = !prevState.isOpen && this.state.isOpen;
	      var becameClosed = prevState.isOpen && !this.state.isOpen;
	
	      if (becameOpen && this.scrollRef) {
	        this.updateScrollArrows();
	        this.scrollRef.addEventListener('scroll', this.updateScrollArrows);
	        document.addEventListener('wheel', this.preventScroll, { passive: false });
	      }
	
	      if (becameClosed && this.scrollRef) {
	        this.scrollRef.removeEventListener('scroll', this.updateScrollArrows);
	        document.removeEventListener('wheel', this.preventScroll);
	      }
	    }
	  }, {
	    key: 'onDocumentClick',
	    value: function onDocumentClick(event) {
	      if (this.selectRef && !this.selectRef.contains(event.target)) {
	        this.setState({ isOpen: false });
	      }
	    }
	  }, {
	    key: 'renderTag',
	    value: function renderTag(tag) {
	      if (!tag) return null;
	      var className = 'select--ui__tag ' + tag.type;
	      return _react2.default.createElement(
	        'span',
	        { className: className },
	        tag.text
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          _props$options = _props.options,
	          options = _props$options === undefined ? [] : _props$options,
	          _props$value = _props.value,
	          value = _props$value === undefined ? '' : _props$value,
	          _props$placeholder = _props.placeholder,
	          placeholder = _props$placeholder === undefined ? 'Выберите...' : _props$placeholder,
	          _props$disabled = _props.disabled,
	          disabled = _props$disabled === undefined ? false : _props$disabled;
	      var _state = this.state,
	          isOpen = _state.isOpen,
	          showScrollUp = _state.showScrollUp,
	          showScrollDown = _state.showScrollDown;
	
	
	      var selectedOption = options.find(function (opt) {
	        return opt.value === value;
	      });
	
	      var hasScroll = showScrollUp || showScrollDown;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'select--ui',
	          ref: function ref(_ref2) {
	            return _this2.selectRef = _ref2;
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)('select--ui__trigger', { 'select--ui__trigger--disabled': disabled }),
	            onClick: this.onToggleDropdown
	          },
	          _react2.default.createElement(
	            'span',
	            {
	              className: (0, _classnames2.default)('select--ui__label', {
	                'select--ui__label--placeholder': !selectedOption
	              })
	            },
	            selectedOption ? selectedOption.label : placeholder
	          ),
	          _react2.default.createElement('span', { className: 'select--ui__icon' })
	        ),
	        isOpen && _react2.default.createElement(
	          'div',
	          {
	            className: 'select--ui__dropdown',
	            style: hasScroll ? { padding: '24px 0px' } : {}
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'select--ui__options',
	              ref: function ref(_ref) {
	                return _this2.scrollRef = _ref;
	              },
	              onMouseEnter: this.onMouseEnter,
	              onMouseLeave: this.onMouseLeave
	            },
	            options.map(function (option) {
	              return _react2.default.createElement(
	                'div',
	                {
	                  key: option.value,
	                  className: (0, _classnames2.default)('select--ui__option', {
	                    'select--ui__option--disabled': option.disabled,
	                    'select--ui__option--selected': value === option.value
	                  }),
	                  onClick: function onClick() {
	                    return _this2.onOptionClick(option);
	                  }
	                },
	                option.tag ? _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('select--ui__label-box', option.tag.type) },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'select--ui__option-label' },
	                    option.label
	                  ),
	                  _this2.renderTag(option.tag)
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'select--ui__label-box' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'select--ui__option-label' },
	                    option.label
	                  )
	                )
	              );
	            })
	          ),
	          hasScroll && _react2.default.createElement('div', {
	            className: (0, _classnames2.default)('select--ui__arrow', 'select--ui__arrow--up', { 'select--ui__arrow--visible': showScrollUp })
	          }),
	          hasScroll && _react2.default.createElement('div', {
	            className: (0, _classnames2.default)('select--ui__arrow', 'select--ui__arrow--down', { 'select--ui__arrow--visible': showScrollDown })
	          })
	        )
	      );
	    }
	  }]);
	  return Select;
	}(_react.Component);

/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(8);
	
	var _SigninAction = __webpack_require__(158);
	
	var _ActivationAction = __webpack_require__(951);
	
	var _Auth = __webpack_require__(95);
	
	var _PasswordRecovery = __webpack_require__(487);
	
	var _AuthError = __webpack_require__(493);
	
	var AuthError = _interopRequireWildcard(_AuthError);
	
	var _functions = __webpack_require__(305);
	
	var _ru = __webpack_require__(869);
	
	var _ru2 = _interopRequireDefault(_ru);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    authorization: {
	        id: 'sign_in.title',
	        defaultMessage: 'Авторизация'
	    },
	    requisite: {
	        id: 'sign_in.requisite',
	        defaultMessage: 'Логин или номер счета'
	    },
	    password: {
	        id: 'sign_in.password',
	        defaultMessage: 'Пароль'
	    },
	    logIn: {
	        id: 'sign_in.log_in',
	        defaultMessage: 'Войти'
	    },
	    resendActivation: {
	        id: 'sign_in.resend_activation',
	        defaultMessage: 'Отправить'
	    },
	    join: {
	        id: 'sign_in.join',
	        defaultMessage: 'Регистрация'
	    },
	    forgot: {
	        id: 'sign_in.forgot',
	        defaultMessage: 'Забыли логин или пароль'
	    },
	    activationSent: {
	        id: 'sign_in.activation_sent',
	        defaultMessage: 'Письмо с ссылкой для активации учетной записи отправлено на {email}'
	    },
	    phone: {
	        id: 'sign_in.phone',
	        defaultMessage: 'Номер телефона'
	    },
	    email: {
	        id: 'sign_in.email',
	        defaultMessage: 'E-mail'
	    },
	    login: {
	        id: 'sign_in.login',
	        defaultMessage: 'Логин'
	    },
	    or: {
	        id: 'sign_in.or',
	        defaultMessage: 'или'
	    }
	});
	
	var SignIn = function (_React$Component) {
	    (0, _inherits3.default)(SignIn, _React$Component);
	
	    function SignIn(props) {
	        (0, _classCallCheck3.default)(this, SignIn);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (SignIn.__proto__ || (0, _getPrototypeOf2.default)(SignIn)).call(this, props));
	
	        _this._handleCloseClick = _this._handleCloseClick.bind(_this);
	        _this._handleLogInClick = _this._handleLogInClick.bind(_this);
	        _this._handleJoinClick = _this._handleJoinClick.bind(_this);
	        _this._handleForgotClick = _this._handleForgotClick.bind(_this);
	
	        _this._handleActivateClick = _this._handleActivateClick.bind(_this);
	
	        _this.renderResendActivation = _this.renderResendActivation.bind(_this);
	        _this.onSelectInputType = _this.onSelectInputType.bind(_this);
	        _this.onInputBlur = _this.onInputBlur.bind(_this);
	
	        _this.state = {
	            activationSent: false,
	            inputType: ''
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(SignIn, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.refs.login.focus();
	        }
	    }, {
	        key: '_handleCloseClick',
	        value: function _handleCloseClick(e) {
	            e.preventDefault();
	            this.props.cancelSignInAction();
	        }
	    }, {
	        key: '_handleLogInClick',
	        value: function _handleLogInClick(e) {
	            e.preventDefault();
	
	            var loginVal = this.refs.login.value;
	            var passwordVal = this.refs.password.value;
	
	            var isAvailableAcc = ['demo', '276502'].some(function (acc) {
	                return acc === loginVal;
	            });
	
	            if (window.location.host === "qa1.fp.kz") {
	                this.props.signInAction({ login: loginVal, password: isAvailableAcc ? passwordVal : "" });
	            } else {
	                this.props.signInAction({ login: loginVal, password: passwordVal });
	            }
	        }
	    }, {
	        key: '_handleJoinClick',
	        value: function _handleJoinClick(e) {
	            e.preventDefault();
	            this.props.beginJoinAction();
	        }
	    }, {
	        key: '_handleForgotClick',
	        value: function _handleForgotClick(e) {
	            e.preventDefault();
	            this.props.beginPasswordRecoveryAction();
	        }
	    }, {
	        key: '_handleActivateClick',
	        value: function _handleActivateClick(e) {
	            e.preventDefault();
	            this.props.activationAction({ email: this.props.email });
	
	            this.setState({
	                activationSent: true
	            });
	        }
	    }, {
	        key: 'onSelectInputType',
	        value: function onSelectInputType(e) {
	            this.setState({
	                inputType: e.target.name
	            });
	
	            this.refs.login.type = e.target.name;
	            this.refs.login.focus();
	        }
	    }, {
	        key: 'onInputBlur',
	        value: function onInputBlur(e) {
	            if (e.target.value === '') {
	                this.setState({
	                    inputType: ''
	                });
	            }
	        }
	    }, {
	        key: 'renderResendActivation',
	        value: function renderResendActivation(email, activationSent) {
	            var activationSentLayout = _react2.default.createElement(
	                'div',
	                { className: 'login--form__row form__row' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'sign_in.activation_sent', values: { email: email } })
	            );
	
	            if (activationSent) {
	                return activationSentLayout;
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'login--form__row form__row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'error-message' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'sign_in.errors.not_activated', values: { email: email } })
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { className: 'login--form__btn login--form__btn__js form__btn',
	                        onClick: this._handleActivateClick },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.resendActivation)
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                errorCode = _props.errorCode,
	                email = _props.email,
	                countryCode = _props.countryCode;
	            var _state = this.state,
	                activationSent = _state.activationSent,
	                inputType = _state.inputType;
	
	
	            var message = void 0;
	
	            if (errorCode === AuthError.NOT_FOUND) {
	                message = { id: 'sign_in.errors.invalid_credentials' };
	            } else if (errorCode === AuthError.BLOCKED) {
	                message = { id: 'sign_in.errors.user_blocked' };
	            } else if (errorCode === AuthError.WRONG_CERT) {
	                message = { id: 'sign_in.errors.wrong_certificate' };
	            } else if (errorCode === -100) {
	                message = { id: 'sign_in.errors.internal' };
	            } else if (errorCode === AuthError.WRONG_PASSWORD) {
	                message = { id: 'sign_in.errors.invalid_credentials' };
	            }
	
	            var notActivated = errorCode === AuthError.NOT_ACTIVATED;
	
	            var loginInputType = inputType;
	
	            if (inputType === '') {
	                loginInputType = 'text';
	            }
	
	            var loginInputPlaceholder = '';
	            if (loginInputType === 'tel') {
	                var _getInitialCountryCod = (0, _functions.getInitialCountryCode)(countryCode),
	                    defaultCountryId = _getInitialCountryCod.defaultCountryId;
	
	                var country = _ru2.default[defaultCountryId];
	                var mask = ('' + country.mask + "x".repeat(country.length)).replace(/\+/, '');
	                loginInputPlaceholder = mask;
	            }
	            if (loginInputType === 'email') {
	                loginInputPlaceholder = 'example@mail.com';
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'modal modal--auth modal--auth-login modal__visible ' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal--dialog' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'modal--header' },
	                        _react2.default.createElement('div', { className: 'header-inner--logotype__link' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-inner__title' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.authorization)
	                        ),
	                        _react2.default.createElement('button', { className: 'modal__close modal__close__green modal__close__js',
	                            onClick: this._handleCloseClick })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'modal--content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'modal--content__wrapper' },
	                            _react2.default.createElement(
	                                'form',
	                                { className: 'login--form form' },
	                                notActivated && this.renderResendActivation(email, activationSent),
	                                !notActivated && errorCode && _react2.default.createElement(
	                                    'div',
	                                    { className: 'error-message' },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, message)
	                                ),
	                                errorCode !== -2 && _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'login--form__row form__row' },
	                                        inputType === '' && _react2.default.createElement(
	                                            'div',
	                                            { className: 'form__row__mask', style: { fontSize: 11 } },
	                                            _react2.default.createElement(
	                                                _reactIntl.FormattedMessage,
	                                                messages.login,
	                                                function (m) {
	                                                    return _react2.default.createElement(
	                                                        'a',
	                                                        { href: '#', name: 'text', onClick: _this2.onSelectInputType },
	                                                        m
	                                                    );
	                                                }
	                                            ),
	                                            '\xA0',
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.or),
	                                            '\xA0',
	                                            _react2.default.createElement(
	                                                _reactIntl.FormattedMessage,
	                                                messages.phone,
	                                                function (m) {
	                                                    return _react2.default.createElement(
	                                                        'a',
	                                                        { href: '#', name: 'tel', onClick: _this2.onSelectInputType },
	                                                        m
	                                                    );
	                                                }
	                                            ),
	                                            '\xA0',
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.or),
	                                            '\xA0',
	                                            _react2.default.createElement(
	                                                _reactIntl.FormattedMessage,
	                                                messages.email,
	                                                function (m) {
	                                                    return _react2.default.createElement(
	                                                        'a',
	                                                        { href: '#', name: 'email', onClick: _this2.onSelectInputType },
	                                                        m
	                                                    );
	                                                }
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'login--form__label form__label' },
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.requisite)
	                                        ),
	                                        _react2.default.createElement('input', { ref: 'login',
	                                            placeholder: loginInputPlaceholder,
	                                            type: inputType,
	                                            className: 'login--form__control form__control',
	                                            onBlur: this.onInputBlur })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'login--form__row form__row' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'login--form__label form__label' },
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.password)
	                                        ),
	                                        _react2.default.createElement('input', { ref: 'password',
	                                            type: 'password',
	                                            className: 'login--form__control form__control' })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'login--form__row form__row' },
	                                        _react2.default.createElement(
	                                            'button',
	                                            { className: 'login--form__btn login--form__btn__js form__btn',
	                                                onClick: this._handleLogInClick },
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.logIn)
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'modal--content__controls' },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '#', className: 'modal--auth__registration',
	                                        onClick: this._handleJoinClick },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.join)
	                                ),
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '#', className: 'modal--auth__forget',
	                                        onClick: this._handleForgotClick },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.forgot)
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return SignIn;
	}(_react2.default.Component);
	
	SignIn.propTypes = {
	    errorCode: _react2.default.PropTypes.number,
	    email: _react2.default.PropTypes.string,
	    cancelSignInAction: _react2.default.PropTypes.func.isRequired,
	    signInAction: _react2.default.PropTypes.func.isRequired,
	    beginJoinAction: _react2.default.PropTypes.func.isRequired,
	    beginPasswordRecoveryAction: _react2.default.PropTypes.func.isRequired,
	    activationAction: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select(state) {
	    var errorCode = state.auth.get('authError');
	    var email = state.auth.get('email');
	    var countryCode = state.application.get('countryCode');
	
	    return {
	        countryCode: countryCode,
	        errorCode: errorCode,
	        email: email
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, {
	    cancelSignInAction: _Auth.cancelSignIn, signInAction: _SigninAction.signin, beginJoinAction: _Auth.beginJoin, beginPasswordRecoveryAction: _PasswordRecovery.beginPasswordRecovery, activationAction: _ActivationAction.activation
	})(SignIn);

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(8);
	
	var _DropDownMenu = __webpack_require__(502);
	
	var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    title: {
	        id: 'timetable.matches_filter_menu.title',
	        defaultMessage: 'Показать'
	    },
	    no_filter: {
	        id: 'timetable.matches_filter_menu.no_filter',
	        defaultMessage: 'Все события'
	    },
	    one_hour: {
	        id: 'timetable.matches_filter_menu.one_hour',
	        defaultMessage: 'Ближайщий час'
	    },
	    two_hours: {
	        id: 'timetable.matches_filter_menu.two_hours',
	        defaultMessage: 'Ближайщие 2 часа'
	    },
	    four_hours: {
	        id: 'timetable.matches_filter_menu.four_hours',
	        defaultMessage: 'Ближайщие 4 часа'
	    },
	    six_hours: {
	        id: 'timetable.matches_filter_menu.six_hours',
	        defaultMessage: 'Ближайщие 6 часов'
	    },
	    twelve_hours: {
	        id: 'timetable.matches_filter_menu.twelve_hours',
	        defaultMessage: 'Ближайщие 12 часов'
	    },
	    one_day: {
	        id: 'timetable.matches_filter_menu.one_day',
	        defaultMessage: 'Ближайщий день'
	    },
	    two_days: {
	        id: 'timetable.matches_filter_menu.two_days',
	        defaultMessage: 'Ближайщие 2 дня'
	    }
	});
	
	function _localizedLink(message, onClick) {
	    var isActive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var linkClass = isActive ? 'dropdown--menu__link active' : 'dropdown--menu__link';
	
	    return _react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        message,
	        function (localizedMessage) {
	            return _react2.default.createElement(
	                'a',
	                { href: '#', className: linkClass, onClick: onClick },
	                localizedMessage
	            );
	        }
	    );
	}
	
	var FilterMatchesMenu = function (_React$Component) {
	    (0, _inherits3.default)(FilterMatchesMenu, _React$Component);
	
	    function FilterMatchesMenu(props) {
	        (0, _classCallCheck3.default)(this, FilterMatchesMenu);
	        return (0, _possibleConstructorReturn3.default)(this, (FilterMatchesMenu.__proto__ || (0, _getPrototypeOf2.default)(FilterMatchesMenu)).call(this, props));
	    }
	
	    (0, _createClass3.default)(FilterMatchesMenu, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                onFilterClick = _props.onFilterClick,
	                activeElement = _props.activeElement;
	
	
	            var cssClass = 'dropdown--menu__schedule';
	
	            var curryFilter = function curryFilter(filter) {
	                return function () {
	                    return onFilterClick(filter);
	                };
	            };
	
	            var elements = [{ content: _localizedLink(messages.no_filter, curryFilter(null), activeElement === null) }, { content: _localizedLink(messages.one_hour, curryFilter(1), activeElement === 1) }, { content: _localizedLink(messages.two_hours, curryFilter(2), activeElement === 2) }, { content: _localizedLink(messages.four_hours, curryFilter(4), activeElement === 4) }, { content: _localizedLink(messages.six_hours, curryFilter(6), activeElement === 6) }, { content: _localizedLink(messages.twelve_hours, curryFilter(12), activeElement === 12) }, { content: _localizedLink(messages.one_day, curryFilter(24), activeElement === 24) }, { content: _localizedLink(messages.two_days, curryFilter(48), activeElement === 48) }];
	
	            var title = _react2.default.createElement(_reactIntl.FormattedMessage, messages.title);
	
	            return _react2.default.createElement(_DropDownMenu2.default, { cssClass: cssClass,
	                title: title,
	                elements: elements,
	                onClosing: this.props.onClosing
	            });
	        }
	    }]);
	    return FilterMatchesMenu;
	}(_react2.default.Component);
	
	FilterMatchesMenu.propTypes = {
	    onFilterClick: _react2.default.PropTypes.func.isRequired,
	    onClosing: _react2.default.PropTypes.func.isRequired,
	    activeElement: _react2.default.PropTypes.any
	};
	exports.default = FilterMatchesMenu;

/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(14);
	
	var _League = __webpack_require__(1184);
	
	var _League2 = _interopRequireDefault(_League);
	
	var _Sorting = __webpack_require__(136);
	
	var _SortMode = __webpack_require__(769);
	
	var SortMode = _interopRequireWildcard(_SortMode);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function matchByStartDateCompare(a, b) {
	    var firstStart = a.get('startDate');
	    var secondStart = b.get('startDate');
	
	    if (firstStart > secondStart) {
	        return 1;
	    } else if (firstStart < secondStart) {
	        return -1;
	    }
	
	    return 0;
	}
	
	function sortByTime(matches) {
	    var result = matches.slice();
	
	    result.sort(matchByStartDateCompare);
	
	    return result;
	}
	
	function sortByLeague(matches, sports, leagues) {
	    var result = matches.slice();
	
	    result.sort(function (a, b) {
	        var firstSport = sports.get(a.get('sportId'));
	        var secondSport = sports.get(b.get('sportId'));
	
	        var sportOrder = (0, _Sorting.sportSortFunc)(firstSport, secondSport);
	
	        if (sportOrder !== 0) {
	            return sportOrder;
	        }
	
	        var firstLeague = leagues.get(a.get('leagueId'));
	        var secondLeague = leagues.get(b.get('leagueId'));
	
	        var leagueOrder = (0, _Sorting.leagueSortFunc)(firstLeague, secondLeague);
	
	        if (leagueOrder !== 0) {
	            return leagueOrder;
	        }
	
	        return matchByStartDateCompare(a, b);
	    });
	
	    return result;
	}
	
	function filter(matches, date) {
	    var result = [];
	
	    date = new Date(date);
	
	    matches.forEach(function (m) {
	        if (new Date(m.get('startDate')) <= date) {
	            result.push(m);
	        }
	    });
	
	    return result;
	}
	
	function groupByLeague(matches, sports, leagues) {
	    var currentGroup = {};
	
	    var result = [];
	
	    for (var i = 0; i < matches.length; i++) {
	        var match = matches[i];
	        var league = leagues.get(match.get('leagueId'));
	
	        if (currentGroup.league !== league) {
	            if (i !== 0) {
	                result.push(currentGroup);
	            }
	
	            var sport = sports.get(match.get('sportId'));
	            var groupMatches = [match];
	
	            currentGroup = {
	                league: league,
	                sport: sport,
	                matches: groupMatches
	            };
	        } else {
	            var _groupMatches = [];
	            _groupMatches.push(match);
	
	            currentGroup.matches = currentGroup.matches.concat(_groupMatches);
	        }
	    }
	
	    result.push(currentGroup);
	
	    return result;
	}
	
	var Grid = function (_React$Component) {
	    (0, _inherits3.default)(Grid, _React$Component);
	
	    function Grid(props) {
	        (0, _classCallCheck3.default)(this, Grid);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Grid.__proto__ || (0, _getPrototypeOf2.default)(Grid)).call(this, props));
	
	        var filter = props.filter;
	
	
	        var dateFilter = void 0;
	
	        if (filter === null) {
	            dateFilter = null;
	        } else {
	            var date = new Date();
	
	            dateFilter = new Date(date.getTime() + filter * 60 * 60 * 1000);
	        }
	
	        _this.state = {
	            dateFilter: dateFilter
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(Grid, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var filter = nextProps.filter;
	
	
	            var dateFilter = void 0;
	
	            if (filter === null) {
	                dateFilter = null;
	            } else {
	                var date = new Date();
	
	                dateFilter = new Date(date.getTime() + filter * 60 * 60 * 1000);
	            }
	
	            this.setState({
	                dateFilter: dateFilter
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                sports = _props.sports,
	                leagues = _props.leagues,
	                matches = _props.matches,
	                sortMode = _props.sortMode;
	            var dateFilter = this.state.dateFilter;
	
	
	            var matchesToShow = dateFilter === null ? matches.toArray() : filter(matches, dateFilter);
	
	            if (matchesToShow.length === 0) {
	                return false;
	            }
	
	            var sortedMatches = sortMode === SortMode.SORT_BY_TIME ? sortByTime(matchesToShow) : sortByLeague(matchesToShow, sports, leagues);
	
	            var groups = groupByLeague(sortedMatches, sports, leagues);
	
	            var leagueElements = [];
	
	            for (var i = 0; i < groups.length; i++) {
	                var _groups$i = groups[i],
	                    sport = _groups$i.sport,
	                    league = _groups$i.league;
	
	
	                var groupMatches = groups[i].matches;
	
	                leagueElements.push(_react2.default.createElement(_League2.default, { key: i, league: league, sport: sport, matches: groupMatches }));
	            }
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                leagueElements
	            );
	        }
	    }]);
	    return Grid;
	}(_react2.default.Component);
	
	Grid.propTypes = {
	    sports: _react2.default.PropTypes.instanceOf(_immutable.Map).isRequired,
	    leagues: _react2.default.PropTypes.instanceOf(_immutable.Map).isRequired,
	    matches: _react2.default.PropTypes.instanceOf(_immutable.Map).isRequired,
	    sortMode: _react2.default.PropTypes.number.isRequired,
	    filter: _react2.default.PropTypes.number
	};
	exports.default = Grid;

/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(14);
	
	var _Match = __webpack_require__(1185);
	
	var _Match2 = _interopRequireDefault(_Match);
	
	var _SportCssMap = __webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var League = function (_React$Component) {
	    (0, _inherits3.default)(League, _React$Component);
	
	    function League() {
	        (0, _classCallCheck3.default)(this, League);
	        return (0, _possibleConstructorReturn3.default)(this, (League.__proto__ || (0, _getPrototypeOf2.default)(League)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(League, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                sport = _props.sport,
	                league = _props.league,
	                matches = _props.matches;
	
	
	            var sportId = sport.get('id');
	            var sportName = sport.get('name');
	            var leagueName = league.get('name');
	
	            var sportCssName = _SportCssMap.cssClassMap[sportId];
	
	            var leagueClass = 'schedule league ' + sportCssName;
	            var titleClass = 'title';
	
	            var sportIconClass = 'schedule sport-icon svg-' + sportCssName;
	
	            return _react2.default.createElement(
	                'div',
	                { className: leagueClass },
	                _react2.default.createElement(
	                    'div',
	                    { className: titleClass },
	                    _react2.default.createElement('span', { className: sportIconClass }),
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        sportName + '. '
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        leagueName
	                    )
	                ),
	                matches.map(function (match) {
	                    return _react2.default.createElement(_Match2.default, { key: match.get('id'), match: match });
	                })
	            );
	        }
	    }]);
	    return League;
	}(_react2.default.Component);
	
	League.propTypes = {
	    league: _react2.default.PropTypes.instanceOf(_immutable.Map).isRequired,
	    sport: _react2.default.PropTypes.instanceOf(_immutable.Map).isRequired,
	    matches: _react2.default.PropTypes.array.isRequired
	};
	exports.default = League;

/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(9);
	
	var _immutable = __webpack_require__(14);
	
	var _Locales = __webpack_require__(80);
	
	var _Locales2 = _interopRequireDefault(_Locales);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Match = function (_React$Component) {
	    (0, _inherits3.default)(Match, _React$Component);
	
	    function Match(props) {
	        (0, _classCallCheck3.default)(this, Match);
	        return (0, _possibleConstructorReturn3.default)(this, (Match.__proto__ || (0, _getPrototypeOf2.default)(Match)).call(this, props));
	    }
	
	    (0, _createClass3.default)(Match, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return this.props.match !== nextProps.match || this.props.languageId !== nextProps.languageId;
	        }
	    }, {
	        key: 'renderMatchDate',
	        value: function renderMatchDate(date) {
	            var timezone = _moment2.default.tz.guess();
	
	            var locale = _Locales2.default[this.props.languageId];
	            _moment2.default.locale('uz');
	
	            _moment2.default.updateLocale('en', {
	                calendar: {
	                    sameDay: '[Today at] HH:mm',
	                    nextDay: '[Tomorrow at] HH:mm',
	                    lastWeek: 'D MMMM [at] HH:mm',
	                    nextWeek: 'D MMMM [at] HH:mm',
	                    sameElse: 'D MMMM [at] HH:mm'
	                }
	            });
	
	            _moment2.default.updateLocale('ru', {
	                calendar: {
	                    sameDay: '[Сегодня в] HH:mm',
	                    nextDay: '[Завтра в] HH:mm',
	                    lastWeek: 'D MMMM [в] HH:mm',
	                    nextWeek: 'D MMMM [в] HH:mm',
	                    sameElse: 'D MMMM [в] HH:mm'
	                }
	            });
	
	            _moment2.default.updateLocale('uz', {
	                calendar: {
	                    sameDay: '[Bugun soat] HH:mm',
	                    nextDay: '[Ertaga soat] HH:mm',
	                    lastWeek: 'D MMMM [в] HH:mm',
	                    nextWeek: 'D MMMM [в] HH:mm',
	                    sameElse: 'D MMMM [в] HH:mm'
	                }
	            });
	
	            date.locale(locale).tz(timezone);
	
	            return _react2.default.createElement(
	                'span',
	                { className: 'cell event-date' },
	                date.calendar()
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var match = this.props.match;
	
	
	            var matchName = match.get('name');
	            var notice = match.get('notice');
	            if (notice) {
	                matchName = matchName + ' (' + notice + ')';
	            }
	
	            var matchStartTime = match.get('startDate');
	
	            var tv = null;
	            var channel = match.get('channel', null);
	            if (channel !== null) {
	                tv = _react2.default.createElement(
	                    'span',
	                    { className: 'tv' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'hint hint--broadcast' },
	                        channel
	                    )
	                );
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'event' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'event-header' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'table' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'cell main' },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'event-name' },
	                                    matchName
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'cell-main tools' },
	                                    tv
	                                )
	                            ),
	                            this.renderMatchDate(matchStartTime)
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return Match;
	}(_react2.default.Component);
	
	Match.propTypes = {
	    match: _react2.default.PropTypes.instanceOf(_immutable.Map).isRequired,
	    languageId: _react2.default.PropTypes.number.isRequired
	};
	
	
	function select(state) {
	    var languageId = state.application.get('languageId');
	
	    return {
	        languageId: languageId
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select)(Match);

/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(8);
	
	var _immutable = __webpack_require__(14);
	
	var _DisplayMode = __webpack_require__(78);
	
	var DisplayMode = _interopRequireWildcard(_DisplayMode);
	
	var _SetDisplayMode = __webpack_require__(563);
	
	var _LocalizedDocumentMeta = __webpack_require__(339);
	
	var _SortMode = __webpack_require__(769);
	
	var SortMode = _interopRequireWildcard(_SortMode);
	
	var _Grid = __webpack_require__(1183);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _FilterMatchesMenu = __webpack_require__(1182);
	
	var _FilterMatchesMenu2 = _interopRequireDefault(_FilterMatchesMenu);
	
	var _metadata = __webpack_require__(340);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    title: {
	        id: 'timetable.title',
	        defaultMessage: 'Календарь лайв событий'
	    },
	    timeFilterTitle: {
	        id: 'timetable.time_filter',
	        defaultMessage: 'Все события'
	    },
	    sortByTime: {
	        id: 'timetable.sort_by_time',
	        defaultMessage: 'Сортировать по времени'
	    },
	    sortByLeague: {
	        id: 'timetable.sort_by_league',
	        defaultMessage: 'Сортировать по виду соревнования'
	    },
	    pageTitle: {
	        id: 'pages.timetable.title',
	        defaultMessage: 'Спортивные трансляции. Расписание предстоящих матчей.'
	    },
	    pageDescription: {
	        id: 'pages.timetable.description',
	        defaultMessage: 'Список онлайн трансляций спортивных событий, для которых возможны букмекерские ставки.'
	    },
	    no_filter: {
	        id: 'timetable.matches_filter_menu.no_filter',
	        defaultMessage: 'Все события'
	    },
	    one_hour: {
	        id: 'timetable.matches_filter_menu.one_hour',
	        defaultMessage: 'Ближайщий час'
	    },
	    two_hours: {
	        id: 'timetable.matches_filter_menu.two_hours',
	        defaultMessage: 'Ближайщие 2 часа'
	    },
	    four_hours: {
	        id: 'timetable.matches_filter_menu.four_hours',
	        defaultMessage: 'Ближайщие 4 часа'
	    },
	    six_hours: {
	        id: 'timetable.matches_filter_menu.six_hours',
	        defaultMessage: 'Ближайщие 6 часов'
	    },
	    twelve_hours: {
	        id: 'timetable.matches_filter_menu.twelve_hours',
	        defaultMessage: 'Ближайщие 12 часов'
	    },
	    one_day: {
	        id: 'timetable.matches_filter_menu.one_day',
	        defaultMessage: 'Ближайщий день'
	    },
	    two_days: {
	        id: 'timetable.matches_filter_menu.two_days',
	        defaultMessage: 'Ближайщие 2 дня'
	    }
	});
	
	var Timetable = function (_React$Component) {
	    (0, _inherits3.default)(Timetable, _React$Component);
	
	    function Timetable(props) {
	        (0, _classCallCheck3.default)(this, Timetable);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Timetable.__proto__ || (0, _getPrototypeOf2.default)(Timetable)).call(this, props));
	
	        _this.state = {
	            filter: null,
	            filterMenuVisible: false,
	            sortMode: SortMode.SORT_BY_LEAGUE
	        };
	
	        _this._handleWidthAdjust = _this._handleWidthAdjust.bind(_this);
	        _this._handleFilterClick = _this._handleFilterClick.bind(_this);
	        _this._handleFilterMatches = _this._handleFilterMatches.bind(_this);
	        _this._handleMenuClosing = _this._handleMenuClosing.bind(_this);
	        _this._handleSortClick = _this._handleSortClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(Timetable, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.setDisplayModeAction({ type: DisplayMode.TIMETABLE });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this._widthAdjustmentInterval = window.setInterval(this._handleWidthAdjust, 500);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this._widthAdjustmentInterval) {
	                window.clearInterval(this._widthAdjustmentInterval);
	            }
	        }
	    }, {
	        key: '_handleWidthAdjust',
	        value: function _handleWidthAdjust() {
	            var contentWidth = this.refs.content.offsetWidth;
	            var titleWidth = this.refs.title.offsetWidth;
	
	            if (contentWidth !== titleWidth) {
	                this.refs.title.style.width = contentWidth + 'px';
	            }
	        }
	    }, {
	        key: '_handleFilterClick',
	        value: function _handleFilterClick(hours) {
	            var state = this.state;
	
	            this.setState((0, _extends3.default)({}, state, {
	                filter: hours
	            }));
	        }
	    }, {
	        key: '_handleFilterMatches',
	        value: function _handleFilterMatches(e) {
	            e.preventDefault();
	
	            var state = this.state;
	
	            this.setState((0, _extends3.default)({}, state, {
	                filterMenuVisible: !state.filterMenuVisible
	            }));
	        }
	    }, {
	        key: '_handleMenuClosing',
	        value: function _handleMenuClosing() {
	            var state = this.state;
	
	            this.setState((0, _extends3.default)({}, state, {
	                filterMenuVisible: false
	            }));
	        }
	    }, {
	        key: '_handleSortClick',
	        value: function _handleSortClick(e) {
	            e.preventDefault();
	
	            var currentSortMode = this.state.sortMode;
	
	            var sortMode = currentSortMode === SortMode.SORT_BY_TIME ? SortMode.SORT_BY_LEAGUE : SortMode.SORT_BY_TIME;
	
	            var state = this.state;
	
	            this.setState((0, _extends3.default)({}, state, {
	                sortMode: sortMode
	            }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                sports = _props.sports,
	                leagues = _props.leagues,
	                matches = _props.matches,
	                countryCode = _props.countryCode;
	            var _state = this.state,
	                filterMenuVisible = _state.filterMenuVisible,
	                sortMode = _state.sortMode,
	                filter = _state.filter;
	
	
	            var menuProps = {
	                onFilterClick: this._handleFilterClick,
	                onClosing: this._handleMenuClosing,
	                activeElement: filter
	            };
	
	            var sortTitle = sortMode === SortMode.SORT_BY_TIME ? messages.sortByLeague : messages.sortByTime;
	
	            var gridProps = {
	                sports: sports,
	                leagues: leagues,
	                matches: matches,
	                sortMode: sortMode,
	                filter: filter
	            };
	
	            var metadata = (0, _metadata.getMetadata)(countryCode);
	
	            return _react2.default.createElement(
	                'div',
	                { id: 'live-content' },
	                _react2.default.createElement(_LocalizedDocumentMeta.LocalizedDocumentMeta, { title: messages.pageTitle, description: messages.pageDescription, keywords: metadata.keywords }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'live-titles scroll--top schedule', ref: 'title' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'table main-heading' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'cell main' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'cell-main__title' },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.title)
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'pull-right' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'schedule--events' },
	                                        _react2.default.createElement(
	                                            'a',
	                                            { href: '#', className: 'dropdown--toggle', onClick: this._handleFilterMatches },
	                                            Timetable._renderDropdownTitle(filter)
	                                        ),
	                                        filterMenuVisible && _react2.default.createElement(_FilterMatchesMenu2.default, menuProps)
	                                    ),
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: '#', className: 'schedule--sort', onClick: this._handleSortClick },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, sortTitle)
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'scroll--wrapper' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'scroll--wrapper__inner', ref: 'content' },
	                        _react2.default.createElement(_Grid2.default, gridProps)
	                    )
	                )
	            );
	        }
	    }], [{
	        key: '_renderDropdownTitle',
	        value: function _renderDropdownTitle(hours) {
	            var msg = void 0;
	
	            if (hours === 1) {
	                msg = _react2.default.createElement(_reactIntl.FormattedMessage, messages.one_hour);
	            } else if (hours === 2) {
	                msg = _react2.default.createElement(_reactIntl.FormattedMessage, messages.two_hours);
	            } else if (hours === 4) {
	                msg = _react2.default.createElement(_reactIntl.FormattedMessage, messages.four_hours);
	            } else if (hours === 6) {
	                msg = _react2.default.createElement(_reactIntl.FormattedMessage, messages.six_hours);
	            } else if (hours === 12) {
	                msg = _react2.default.createElement(_reactIntl.FormattedMessage, messages.twelve_hours);
	            } else if (hours === 24) {
	                msg = _react2.default.createElement(_reactIntl.FormattedMessage, messages.one_day);
	            } else if (hours === 48) {
	                msg = _react2.default.createElement(_reactIntl.FormattedMessage, messages.two_days);
	            } else {
	                msg = _react2.default.createElement(_reactIntl.FormattedMessage, messages.no_filter);
	            }
	
	            return msg;
	        }
	    }]);
	    return Timetable;
	}(_react2.default.Component);
	
	Timetable.propTypes = {
	    sports: _react2.default.PropTypes.instanceOf(_immutable.Map).isRequired,
	    leagues: _react2.default.PropTypes.instanceOf(_immutable.Map).isRequired,
	    matches: _react2.default.PropTypes.instanceOf(_immutable.Map).isRequired,
	    setDisplayModeAction: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select(state) {
	    var countryCode = state.application.get('countryCode');
	    var timetable = state.application.get('timetable');
	
	    var sports = timetable.get('sports');
	    var leagues = timetable.get('leagues');
	    var matches = timetable.get('matches');
	
	    return {
	        sports: sports,
	        leagues: leagues,
	        matches: matches,
	        countryCode: countryCode
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, { setDisplayModeAction: _SetDisplayMode.setDisplayMode })(Timetable);

/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Timetable = __webpack_require__(1186);
	
	Object.defineProperty(exports, 'Timetable', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Timetable).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(9);
	
	var _Auth = __webpack_require__(95);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    title: {
	        id: 'coupon.menu.title',
	        defaultMessage: 'Меню ставок'
	    },
	    to_configure_coupon: {
	        id: 'betpanel.unauth.to_configure_coupon',
	        defaultMessage: 'Чтобы менять настройки купона - '
	    },
	    should_auth: {
	        id: 'betpanel.unauth.should_auth',
	        defaultMessage: 'войдите'
	    },
	    should_register: {
	        id: 'betpanel.unauth.should_register',
	        defaultMessage: 'зарегистрируйтесь'
	    },
	    auth_or_register_to_bet: {
	        id: 'betpanel.unauth.auth_or_register_to_bet',
	        defaultMessage: '{signTrigger} или {joinTrigger}'
	    }
	});
	
	var UnauthUserCouponDropDownMenu = function (_React$Component) {
	    (0, _inherits3.default)(UnauthUserCouponDropDownMenu, _React$Component);
	
	    function UnauthUserCouponDropDownMenu(props) {
	        (0, _classCallCheck3.default)(this, UnauthUserCouponDropDownMenu);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (UnauthUserCouponDropDownMenu.__proto__ || (0, _getPrototypeOf2.default)(UnauthUserCouponDropDownMenu)).call(this, props));
	
	        _this._handleLogInClick = _this._handleLogInClick.bind(_this);
	        _this._handleJoinClick = _this._handleJoinClick.bind(_this);
	
	        _this._isInsidePopup = _this._isInsidePopup.bind(_this);
	        _this._onDocumentClick = _this._onDocumentClick.bind(_this);
	
	        document.addEventListener('click', _this._onDocumentClick);
	        return _this;
	    }
	
	    (0, _createClass3.default)(UnauthUserCouponDropDownMenu, [{
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener('click', this._onDocumentClick);
	        }
	    }, {
	        key: '_isInsidePopup',
	        value: function _isInsidePopup(element) {
	            if (element === null) {
	                return false;
	            }
	
	            if (element === this.refs.popup) {
	                return true;
	            }
	
	            return this._isInsidePopup(element.parentElement);
	        }
	    }, {
	        key: '_onDocumentClick',
	        value: function _onDocumentClick(e) {
	            if (this._isInsidePopup(e.target)) {
	                return;
	            }
	
	            document.removeEventListener('click', this._onDocumentClick);
	
	            this.props.onClosing();
	        }
	    }, {
	        key: '_handleLogInClick',
	        value: function _handleLogInClick(e) {
	            e.preventDefault();
	            this.props.beginSignInAction();
	        }
	    }, {
	        key: '_handleJoinClick',
	        value: function _handleJoinClick(e) {
	            e.preventDefault();
	            this.props.beginJoinAction();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var signTrigger = _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                messages.should_auth,
	                function (message) {
	                    return _react2.default.createElement(
	                        'a',
	                        { className: 'trigger', onClick: _this2._handleLogInClick },
	                        message
	                    );
	                }
	            );
	
	            var joinTrigger = _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                messages.should_register,
	                function (message) {
	                    return _react2.default.createElement(
	                        'a',
	                        { className: 'trigger', onClick: _this2._handleJoinClick },
	                        message
	                    );
	                }
	            );
	
	            return _react2.default.createElement(
	                'ul',
	                { ref: 'popup', className: 'dropdown--menu dropdown--menu-coupon  dropdown--menu__shown' },
	                _react2.default.createElement(
	                    'li',
	                    { className: 'title dropdown--menu__title dropdown--menu__item' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'dropdown--menu__span' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.title)
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    { className: 'dropdown--menu__item dropdown--menu__item__favourites' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'dropdown--menu-coupon__block__favourites dropdown--menu-coupon__block' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'dropdown--menu-coupon__input__label' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'auth-attention-modal' },
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(_reactIntl.FormattedMessage, messages.to_configure_coupon),
	                                '\xA0',
	                                _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, messages.auth_or_register_to_bet, {
	                                    values: { signTrigger: signTrigger, joinTrigger: joinTrigger } }))
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return UnauthUserCouponDropDownMenu;
	}(_react2.default.Component);
	
	UnauthUserCouponDropDownMenu.propTypes = {
	    beginSignInAction: _react2.default.PropTypes.func.isRequired,
	    beginJoinAction: _react2.default.PropTypes.func.isRequired,
	    onClosing: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select() {
	    return {};
	}
	
	exports.default = (0, _reactRedux.connect)(select, { beginSignInAction: _Auth.beginSignIn, beginJoinAction: _Auth.beginJoin })(UnauthUserCouponDropDownMenu);

/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _StakeStatus = __webpack_require__(304);
	
	var StakeStatuses = _interopRequireWildcard(_StakeStatus);
	
	var _BetRate = __webpack_require__(1192);
	
	var _BetRate2 = _interopRequireDefault(_BetRate);
	
	var _BetStatus = __webpack_require__(1193);
	
	var _BetStatus2 = _interopRequireDefault(_BetStatus);
	
	var _BetTitle = __webpack_require__(1194);
	
	var _BetTitle2 = _interopRequireDefault(_BetTitle);
	
	var _BetOverallInfo = __webpack_require__(1191);
	
	var _BetOverallInfo2 = _interopRequireDefault(_BetOverallInfo);
	
	var _balanceAction = __webpack_require__(132);
	
	var _Freebet = __webpack_require__(486);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function betUnderConfirmation(betStatus) {
	    return betStatus === _BetStatus2.default.CONFIRM_AWAIT || betStatus === _BetStatus2.default.IN_DELAY || betStatus === _BetStatus2.default.STAKE_REQUEST;
	}
	
	var Bet = function (_React$Component) {
	    (0, _inherits3.default)(Bet, _React$Component);
	
	    function Bet() {
	        (0, _classCallCheck3.default)(this, Bet);
	        return (0, _possibleConstructorReturn3.default)(this, (Bet.__proto__ || (0, _getPrototypeOf2.default)(Bet)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Bet, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            var newBetStatus = nextProps.bet.get('betStatus');
	            var oldBetStatus = this.props.bet.get('betStatus');
	
	            if (newBetStatus === oldBetStatus || betUnderConfirmation(newBetStatus) && betUnderConfirmation(oldBetStatus)) {
	                return;
	            }
	
	            if (oldBetStatus !== _BetStatus2.default.CONFIRMED && newBetStatus === _BetStatus2.default.CONFIRMED) {
	                window.setTimeout(function () {
	                    _this2.props.getBalanceAction({ accountId: _this2.props.user.get('accountId') });
	                    _this2.props.getFreebetAction();
	                }, 0);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var id = this.props.id;
	            var bet = this.props.bet;
	
	            if (!bet) {
	                return null;
	            }
	
	            var betSlips = bet.get('betSlips').valueSeq().toList();
	            var stakeStatus = bet.get('stakeStatus');
	
	            var className = 'bet-item';
	            if (stakeStatus === StakeStatuses.WON) {
	                className += ' win';
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: className },
	                _react2.default.createElement(_BetTitle2.default, { id: id }),
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'bet-history-list' },
	                    betSlips.map(function (bs) {
	                        return Bet.renderBetRate(bs.getIn(['rate', 'id']), id);
	                    })
	                ),
	                _react2.default.createElement(_BetOverallInfo2.default, { id: id }),
	                _react2.default.createElement(_BetStatus2.default, { id: id })
	            );
	        }
	    }], [{
	        key: 'renderBetRate',
	        value: function renderBetRate(rateId, id) {
	            return _react2.default.createElement(_BetRate2.default, { key: rateId, id: id, rateId: rateId });
	        }
	    }]);
	    return Bet;
	}(_react2.default.Component);
	
	Bet.propTypes = {
	    user: _react2.default.PropTypes.object.isRequired,
	    id: _react2.default.PropTypes.string.isRequired,
	    bet: _react2.default.PropTypes.object.isRequired,
	    getBalanceAction: _react2.default.PropTypes.func.isRequired,
	    getFreebetAction: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select(state, props) {
	    var user = state.auth.get('user');
	    var id = props.id;
	    var bet = state.application.getIn(['betHistory', id]);
	    var languageId = state.application.get('languageId');
	
	    return {
	        user: user,
	        id: id,
	        bet: bet,
	        languageId: languageId
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, { getBalanceAction: _balanceAction.balance, getFreebetAction: _Freebet.getFreebet })(Bet);

/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _Bet = __webpack_require__(1189);
	
	var _Bet2 = _interopRequireDefault(_Bet);
	
	var _HistoryBet = __webpack_require__(65);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BetHistory = function (_React$Component) {
	    (0, _inherits3.default)(BetHistory, _React$Component);
	
	    function BetHistory(props) {
	        (0, _classCallCheck3.default)(this, BetHistory);
	        return (0, _possibleConstructorReturn3.default)(this, (BetHistory.__proto__ || (0, _getPrototypeOf2.default)(BetHistory)).call(this, props));
	    }
	
	    (0, _createClass3.default)(BetHistory, [{
	        key: 'render',
	        value: function render() {
	            var betHistory = this.props.betHistory;
	
	            if (betHistory === undefined || betHistory.size === 0) {
	                return false;
	            }
	
	            var betIds = betHistory.keySeq().sortBy(function (x) {
	                return parseInt(x);
	            }).reverse().toList();
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'history-menu cf' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'body history-menu-body' },
	                    betIds.map(BetHistory.renderBet)
	                )
	            );
	        }
	    }], [{
	        key: 'renderBet',
	        value: function renderBet(id) {
	            return _react2.default.createElement(_Bet2.default, { key: id, id: id });
	        }
	    }]);
	    return BetHistory;
	}(_react2.default.Component);
	
	BetHistory.propTypes = {
	    betHistory: _react2.default.PropTypes.object.isRequired,
	    removeHistoryBetsAction: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select(state) {
	    var betHistory = state.application.get('betHistory');
	    var languageId = state.application.get('languageId');
	
	    return {
	        betHistory: betHistory,
	        languageId: languageId
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, {
	    removeHistoryBetsAction: _HistoryBet.removeHistoryBets
	})(BetHistory);

/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(8);
	
	var _BetType = __webpack_require__(46);
	
	var BetType = _interopRequireWildcard(_BetType);
	
	var _BetStatus = __webpack_require__(134);
	
	var BetStatuses = _interopRequireWildcard(_BetStatus);
	
	var _StakeStatus = __webpack_require__(304);
	
	var StakeStatuses = _interopRequireWildcard(_StakeStatus);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    single: {
	        id: 'bet_type.ordinar',
	        defaultMessage: 'Ординар'
	    },
	    express: {
	        id: 'bet_type.accumulator',
	        defaultMessage: 'Экспресс'
	    },
	    antiexpress: {
	        id: 'bet_type.looseToWinAccumulator',
	        defaultMessage: 'Антиэкспресс'
	    },
	    system: {
	        id: 'bet_type.system',
	        defaultMessage: 'Система {rank} из {count}'
	    }
	});
	
	var BetOverallInfo = function (_React$Component) {
	    (0, _inherits3.default)(BetOverallInfo, _React$Component);
	
	    function BetOverallInfo(props) {
	        (0, _classCallCheck3.default)(this, BetOverallInfo);
	        return (0, _possibleConstructorReturn3.default)(this, (BetOverallInfo.__proto__ || (0, _getPrototypeOf2.default)(BetOverallInfo)).call(this, props));
	    }
	
	    (0, _createClass3.default)(BetOverallInfo, [{
	        key: 'render',
	        value: function render() {
	            var bet = this.props.bet;
	            var betType = bet.get('betType');
	            var rank = bet.get('rank');
	            var count = bet.get('betSlips').size;
	            var betStatus = bet.get('betStatus');
	            var stakeStatus = bet.get('stakeStatus');
	            var odd = bet.get('odd');
	            var amount = bet.get('amount');
	            var possibleWinAmount = bet.get('possibleWinAmount');
	
	            var betTypeStr = void 0;
	            switch (betType) {
	                case BetType.SINGLE:
	                    betTypeStr = _react2.default.createElement(_reactIntl.FormattedMessage, messages.single);
	                    break;
	                case BetType.EXPRESS:
	                    betTypeStr = _react2.default.createElement(_reactIntl.FormattedMessage, messages.express);
	                    break;
	                case BetType.ANTIEXPRESS:
	                    betTypeStr = _react2.default.createElement(_reactIntl.FormattedMessage, messages.antiexpress);
	                    break;
	                case BetType.SYSTEM:
	                    betTypeStr = _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, messages.system, { values: { rank: rank, count: count } }));
	                    break;
	            }
	
	            switch (betStatus) {
	                case BetStatuses.INIT:
	                case BetStatuses.IN_DELAY:
	                case BetStatuses.CONFIRM_AWAIT:
	                case BetStatuses.CONFIRMED:
	                case BetStatuses.STAKE_REQUEST:
	                case BetStatuses.BET_PAY_REQUEST:
	                case BetStatuses.CALCULATED:
	                    switch (stakeStatus) {
	                        case StakeStatuses.ACTIVE:
	                        case StakeStatuses.WON:
	                            return _react2.default.createElement(
	                                'div',
	                                { className: 'bet-controls cf' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'bet-type' },
	                                    betTypeStr
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'balance' },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        amount
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'rate' },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        odd
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'possible-win' },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        possibleWinAmount
	                                    )
	                                )
	                            );
	                        case StakeStatuses.LOST:
	                            return _react2.default.createElement(
	                                'div',
	                                { className: 'bet-controls cf' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'bet-type' },
	                                    betTypeStr
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'balance' },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        amount
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'rate' },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        odd
	                                    )
	                                )
	                            );
	                    }
	                    break;
	
	                case BetStatuses.CASHOUT:
	                    {
	                        var cashout = bet.get('cashout');
	
	                        var cashoutAmount = bet.get('possibleWinAmount');
	                        if (cashout) {
	                            cashoutAmount = cashout.get('amount');
	                        }
	
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'bet-controls cf' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'bet-type' },
	                                betTypeStr
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'balance' },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    amount
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'rate' },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    odd
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'possible-win' },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    cashoutAmount
	                                )
	                            )
	                        );
	                    }
	
	                case BetStatuses.REJECTED:
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'bet-controls cf' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'bet-type' },
	                            betTypeStr
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'balance' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                amount
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'rate' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                odd
	                            )
	                        )
	                    );
	            }
	
	            return false;
	        }
	    }]);
	    return BetOverallInfo;
	}(_react2.default.Component);
	
	BetOverallInfo.propTypes = {
	    bet: _react2.default.PropTypes.object.isRequired
	};
	
	
	function select(state, props) {
	    var id = props.id;
	    var bet = state.application.getIn(['betHistory', id]);
	    var languageId = state.application.get('languageId');
	
	    return {
	        bet: bet,
	        languageId: languageId
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select)(BetOverallInfo);

/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(8);
	
	var _underscore = __webpack_require__(145);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _SportCssMap = __webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    Rate: {
	        id: 'bet_history.rate',
	        defaultMessage: 'Коэфф: '
	    },
	    Stake: {
	        id: 'bet_history.stake',
	        defaultMessage: 'Ставка: '
	    },
	    rateChanged: {
	        id: 'coupon.rate_changed',
	        defaultMessage: 'Коэфф недоступен'
	    },
	    rateUnavailable: {
	        id: 'coupon.rate_unavailable',
	        defaultMessage: 'Прием закрыт'
	    }
	});
	
	var BetRate = function (_React$Component) {
	    (0, _inherits3.default)(BetRate, _React$Component);
	
	    function BetRate(props) {
	        (0, _classCallCheck3.default)(this, BetRate);
	        return (0, _possibleConstructorReturn3.default)(this, (BetRate.__proto__ || (0, _getPrototypeOf2.default)(BetRate)).call(this, props));
	    }
	
	    (0, _createClass3.default)(BetRate, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                rate = _props.rate,
	                match = _props.match,
	                score = _props.score,
	                outcome = _props.outcome,
	                rateChange = _props.rateChange;
	
	
	            var odd = rate.get('value');
	
	            var rateSpan = _react2.default.createElement(
	                'span',
	                { className: 'event-rate' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, messages.Rate),
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    odd
	                )
	            );
	
	            var sportIconCls = 'sport-icon svg-' + _SportCssMap.cssClassMap[rate.get('sportId')];
	
	            if (rateChange) {
	                var factorRateChange = _underscore2.default.find(rateChange, { factorId: rate.get('id') });
	
	                if (factorRateChange) {
	                    var newFactorOdd = factorRateChange.value;
	                    var factorUnavailable = factorRateChange.unavailable;
	
	                    if (newFactorOdd) {
	                        var cls = 'new-rate';
	                        if (odd < newFactorOdd) {
	                            cls += ' up';
	                        } else {
	                            cls += ' down';
	                        }
	
	                        rateSpan = _react2.default.createElement(
	                            'div',
	                            { className: 'rate changed' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.Rate),
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'old-rate' },
	                                odd
	                            ),
	                            '\xA0',
	                            _react2.default.createElement(
	                                'span',
	                                { className: cls },
	                                newFactorOdd
	                            ),
	                            _react2.default.createElement(
	                                _reactIntl.FormattedMessage,
	                                messages.rateChanged,
	                                function (message) {
	                                    return _react2.default.createElement(
	                                        'span',
	                                        { className: 'event-rate event-rate__unavailable' },
	                                        message
	                                    );
	                                }
	                            )
	                        );
	                    } else if (factorUnavailable) {
	                        rateSpan = _react2.default.createElement(
	                            'span',
	                            { className: 'event-rate' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.Rate),
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                odd
	                            ),
	                            _react2.default.createElement(
	                                _reactIntl.FormattedMessage,
	                                messages.rateUnavailable,
	                                function (message) {
	                                    return _react2.default.createElement(
	                                        'span',
	                                        { className: 'event-rate event-rate__unavailable' },
	                                        message
	                                    );
	                                }
	                            )
	                        );
	                    }
	                }
	            }
	
	            var scoreSpan = undefined;
	
	            if (score) {
	                var score1 = score.get('score1');
	                var score2 = score.get('score2');
	                if (score1 && score2) {
	                    score1 = score1 === undefined ? 0 : score1;
	                    score2 = score2 === undefined ? 0 : score2;
	
	                    scoreSpan = _react2.default.createElement(
	                        'span',
	                        { className: 'current-score' },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            score1 + ':' + score2
	                        )
	                    );
	                }
	            }
	
	            var matchName = match.get('name');
	            if (match.get('notice')) {
	                matchName += '(' + match.get('notice') + ')';
	            }
	
	            return _react2.default.createElement(
	                'li',
	                { className: 'bet-history-list-item' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'event-name' },
	                    _react2.default.createElement('span', { className: sportIconCls }),
	                    scoreSpan,
	                    matchName,
	                    _react2.default.createElement('br', null),
	                    outcome.get('name')
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'event-type' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.Stake),
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        rate.get('shortName')
	                    )
	                ),
	                rateSpan
	            );
	        }
	    }]);
	    return BetRate;
	}(_react2.default.Component);
	
	BetRate.propTypes = {
	    rate: _react2.default.PropTypes.object.isRequired,
	    score: _react2.default.PropTypes.object,
	    match: _react2.default.PropTypes.object.isRequired,
	    outcome: _react2.default.PropTypes.object.isRequired,
	    rateChange: _react2.default.PropTypes.array,
	    languageId: _react2.default.PropTypes.number.isRequired
	};
	
	
	function select(state, props) {
	    var id = props.id;
	    var rateId = props.rateId;
	    var bet = state.application.getIn(['betHistory', id]);
	    var betSlip = bet.get('betSlips').find(function (bs) {
	        return bs.getIn(['rate', 'id']) === rateId;
	    });
	    var rate = betSlip.get('rate');
	    var score = betSlip.get('score');
	    var match = betSlip.get('match');
	    var outcome = betSlip.get('outcome');
	    var rateChange = bet.get('rateChange');
	    var languageId = state.application.get('languageId');
	
	    return {
	        rate: rate,
	        score: score,
	        match: match,
	        outcome: outcome,
	        rateChange: rateChange,
	        languageId: languageId
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select)(BetRate);

/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(8);
	
	var _BigStakeRequest = __webpack_require__(953);
	
	var _Cashout = __webpack_require__(954);
	
	var _CashoutStatus = __webpack_require__(566);
	
	var CashoutStatuses = _interopRequireWildcard(_CashoutStatus);
	
	var _BetStatus = __webpack_require__(134);
	
	var BetStatuses = _interopRequireWildcard(_BetStatus);
	
	var _StakeStatus = __webpack_require__(304);
	
	var StakeStatuses = _interopRequireWildcard(_StakeStatus);
	
	var _BetCreateErrorStatus = __webpack_require__(747);
	
	var BetCreateErrors = _interopRequireWildcard(_BetCreateErrorStatus);
	
	var _BigStakeCancelError = __webpack_require__(749);
	
	var BigStakeCancelError = _interopRequireWildcard(_BigStakeCancelError);
	
	var _accountResourceNames = __webpack_require__(59);
	
	var _StakeMinAmount = __webpack_require__(135);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    betUnderConsideration: {
	        id: 'bet_history.bet_under_consideration',
	        defaultMessage: 'Ставка на подтверждении'
	    },
	    betUnderConsiderationToolTip: {
	        id: 'bet_history.bet_under_consideration_tooltip',
	        defaultMessage: 'Ставка на потверждении. Ещё-ещё-ещё. Ставка на потверждении. Ещё-ещё-ещё.'
	    },
	    accepted: {
	        id: 'bet_status.accepted',
	        defaultMessage: 'Принята'
	    },
	    canceled: {
	        id: 'bet_status.canceled',
	        defaultMessage: 'Отменена'
	    },
	    sold: {
	        id: 'bet_status.sold',
	        defaultMessage: 'Продана'
	    },
	    won: {
	        id: 'bet_status.won',
	        defaultMessage: 'Выиграла'
	    },
	    lost: {
	        id: 'bet_status.lost',
	        defaultMessage: 'Проиграла'
	    },
	    sell: {
	        id: 'bet_history.sell',
	        defaultMessage: 'Продать'
	    },
	    refund: {
	        id: 'bet_history.refund',
	        defaultMessage: 'Возврат'
	    },
	    sellCancel: {
	        id: 'bet_history.sell_cancel',
	        defaultMessage: 'Отмена'
	    },
	    cashoutAmountChanged: {
	        id: 'bet_history.cashout_amount_changed',
	        defaultMessage: 'Сумма продажи изменена'
	    },
	    cashoutConfirmation: {
	        id: 'bet_history.cashout_confirmation',
	        defaultMessage: 'Подтвердите продажу ставки,{br}cумма продажи'
	    },
	    eventStakeCashoutForbidden: {
	        id: 'bet_history.event_stake_cashout_forbidden',
	        defaultMessage: 'Продажа ставок на данное событие закрыта'
	    },
	    ratesChanged: {
	        id: 'coupon.rate_changed',
	        defaultMessage: 'Коэфф изменился'
	    },
	    bigStakeCancel: {
	        id: 'bet_history.big_stake_cancel',
	        defaultMessage: 'Отменить ставку'
	    },
	    insufficientFunds: {
	        id: 'bet_history.errors.insufficient_funds',
	        defaultMessage: 'Недостаточно средств на балансе'
	    },
	    accountLocked: {
	        id: 'bet_history.errors.account_locked',
	        defaultMessage: 'Ваш счет заблокирован'
	    },
	    systemNotAllowedForFreebet: {
	        id: 'bet_history.errors.system_not_allowed_for_freebet',
	        defaultMessage: 'Фрибет ставки типа "Система" запрещены'
	    },
	    incorrectStakeData: {
	        id: 'bet_history.errors.incorrect_stake_data',
	        defaultMessage: 'Некорректные данные по ставке'
	    },
	    minStakeAmount: {
	        id: 'bet_history.errors.min_stake_amount',
	        defaultMessage: 'Минимальная сумма ставки {minAmount} {currency}'
	    },
	    alternativeStake: {
	        id: 'coupon.max_amount_hint',
	        defaultMessage: 'Макс. {amount} {resource}'
	    },
	    not_possible_stake: {
	        id: 'coupon.not_possible_stake',
	        defaultMessage: 'Данная ставка невозможна'
	    },
	    incorrectVirtualStake: {
	        id: 'bet_history.errors.incorrect_virtual_stake',
	        defaultMessage: 'Некорректная ставка с виртуального счета'
	    },
	    incorrectFreebetStake: {
	        id: 'bet_history.errors.incorrect_freebet_stake',
	        defaultMessage: 'Некорректные данные по бесплатной ставке'
	    },
	    existingActiveStake: {
	        id: 'bet_history.errors.existing_active_stake',
	        defaultMessage: 'Ошибка системы'
	    },
	    noBigStakePermission: {
	        id: 'bet_history.errors.no_big_stake_permission',
	        defaultMessage: 'Крупные ставки запрещены'
	    },
	    freebetBigStake: {
	        id: 'bet_history.errors.freebet_big_stake',
	        defaultMessage: 'Фрибет ставка не может быть крупной'
	    },
	    bet_history_bet_not_accepted_by_terms: {
	        id: 'bet_history.errors.bet_not_accepted_by_terms',
	        defaultMessage: 'Ставка не принята, не соблюдены условия промокода'
	    },
	    coupon_bet_not_accepted: {
	        id: "coupon.bet_not_accepted",
	        defaultMessage: "Ставка не принята"
	    },
	    coupon_bet_not_accepted_by_terms: {
	        id: "coupon.bet_not_accepted_by_terms",
	        defaultMessage: "Ставка не принята, не соблюдены условия промокода"
	    },
	    "-1": {
	        id: "coupon_bet_promocode_not_found1",
	        defaultMessage: "Промокод не найден"
	    },
	    "-2": {
	        id: "coupon_bet_coef_stakes_changed2",
	        defaultMessage: "Коэффициент ставки был изменен"
	    },
	    "-21": {
	        id: "coupon_bet_for_get_freebet_fill_balance21",
	        defaultMessage: "Для получения фрибета необходимо пополнить счет на сумму {amount} {currency}"
	    },
	    "-23": {
	        id: "coupon_bet_nessary_should_more23",
	        defaultMessage: "Сумма ставок должна превышать {amount}"
	    },
	    "-22": {
	        id: "coupon_bet_for_using_freebet_make_stake_more22",
	        defaultMessage: "Для использования фрибета необходимо сделать ставку на сумму от {amount} {currency}"
	    },
	    "-24": {
	        id: "coupon_bet_for_using_freebet_nessery_auth24",
	        defaultMessage: "Для использования фрибета необходима идентификация учетной записи"
	    },
	    "-31": {
	        id: "coupon_bet_validation_is_not_accept31",
	        defaultMessage: "Промокод доступен только в {value}"
	    },
	    "-32": {
	        id: "coupon_bet_for_stake_type32",
	        defaultMessage: "Применимо к ставке типа: {amount}"
	    },
	    "-33": {
	        id: "coupon_bet_min_coef_should33",
	        defaultMessage: "Минимальный коэфицент должен быть {amount}"
	    },
	    "-34": {
	        id: "coupon_bet_validation_is_not_accept_by_minCoef34",
	        defaultMessage: "Коэффициент не должен превышать {amount}"
	    },
	    "-35": {
	        id: "coupon_for_using_freebet_nesessarry_choose_more35",
	        defaultMessage: "Для использования фрибета необходимо выбрать не менее {amount} событий."
	    },
	    "-36": {
	        id: "coupon_bet_freebet_sum_not_equal_sum_stake36",
	        defaultMessage: "Сумма фрибета меньше/больше суммы ставки"
	    },
	    "-37": {
	        id: "coupon_bet_not_for_stake_type37",
	        defaultMessage: "Не применимо к данному матчу"
	    },
	    "-38": {
	        id: "coupon_bet_not_for_the_league38",
	        defaultMessage: "Не применимо к данной лиге"
	    },
	    single: {
	        id: 'bet_type.ordinar',
	        defaultMessage: 'Ординар'
	    },
	    express: {
	        id: 'bet_type.accumulator',
	        defaultMessage: 'Экспресс'
	    },
	    system: {
	        id: 'bet_type.system',
	        defaultMessage: 'Система'
	    }
	});
	
	var BetStatus = function (_React$Component) {
	    (0, _inherits3.default)(BetStatus, _React$Component);
	
	    function BetStatus(props) {
	        (0, _classCallCheck3.default)(this, BetStatus);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (BetStatus.__proto__ || (0, _getPrototypeOf2.default)(BetStatus)).call(this, props));
	
	        _this.getStakeTypesInFormat = function (arr) {
	            var stakeTypes = {
	                1: _this.props.intl.formatMessage(messages['single']),
	                2: _this.props.intl.formatMessage(messages['express']),
	                3: _this.props.intl.formatMessage(messages['system'])
	            };
	            return arr.map(function (item) {
	                return stakeTypes[item];
	            }).join('');
	        };
	
	        _this.renderCashout = _this.renderCashout.bind(_this);
	
	        _this._onCancelBigStakeRequestClick = _this._onCancelBigStakeRequestClick.bind(_this);
	        _this._onSellClick = _this._onSellClick.bind(_this);
	        _this._onSellCancelClick = _this._onSellCancelClick.bind(_this);
	        _this._onSellAgreeClick = _this._onSellAgreeClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(BetStatus, [{
	        key: '_onCancelBigStakeRequestClick',
	        value: function _onCancelBigStakeRequestClick(e) {
	            e.preventDefault();
	
	            var stakeId = this.props.bet.get('stakeId');
	
	            this.props.cancelBigStakeRequestAction({
	                betId: this.props.id,
	                stakeId: stakeId
	            });
	        }
	    }, {
	        key: '_onSellClick',
	        value: function _onSellClick(e) {
	            e.preventDefault();
	            this.props.setCashoutStatusAction({
	                betId: this.props.id,
	                status: CashoutStatuses.MBOX_SHOWN
	            });
	        }
	    }, {
	        key: '_onSellCancelClick',
	        value: function _onSellCancelClick(e) {
	            e.preventDefault();
	            this.props.setCashoutStatusAction({
	                betId: this.props.id,
	                status: CashoutStatuses.AVAILABLE
	            });
	        }
	    }, {
	        key: '_onSellAgreeClick',
	        value: function _onSellAgreeClick(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	            var bet = this.props.bet;
	            var betId = this.props.id;
	
	            var cashout = bet.get('cashout');
	            var stakeId = bet.get('stakeId');
	            var amount = cashout.get('amount');
	
	            this.props.setCashoutStatusAction({
	                betId: betId,
	                status: CashoutStatuses.SELL_REQUESTED
	            });
	
	            setTimeout(function () {
	                _this2.props.createCashoutAction({
	                    betId: betId,
	                    stakeId: stakeId,
	                    amount: amount
	                });
	            }, 10000);
	        }
	    }, {
	        key: 'renderCashout',
	        value: function renderCashout() {
	            var cashout = this.props.bet.get('cashout');
	
	            if (!cashout) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'bet-controls-bottom cf' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'bet-status cf' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'bet-status__label bet-status__label__sold' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.sold)
	                        )
	                    )
	                );
	            }
	
	            var cashoutAmount = cashout.get('amount');
	            var cashoutState = cashout.get('state');
	
	            switch (cashoutState) {
	                case CashoutStatuses.AVAILABLE:
	                    {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'bet-controls-bottom cf' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'bet-status cf' },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'bet-status__label bet-status__label__accepted' },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.accepted)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'bet-sell' },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '#', className: 'bet-sell__btn bet-sell__btn__js', onClick: this._onSellClick },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.sell)
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'bet-sell__amount' },
	                                    cashoutAmount
	                                )
	                            )
	                        );
	                    }
	
	                case CashoutStatuses.MBOX_SHOWN:
	                    {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'bet-controls-bottom cf' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'message-box message-box--sell-bet  message-box message-box--sell-bet--visible' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'message-box--sell-bet__text' },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, messages.cashoutConfirmation, { values: { br: _react2.default.createElement('br', null) } }))
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'message-box--sell-bet__amount' },
	                                    cashoutAmount
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'message-box--sell-bet__sell message-box--sell-bet__sell__js',
	                                        onClick: this._onSellAgreeClick },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: '#', className: 'message-box--sell-bet__btn--confirm' },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.sell)
	                                    )
	                                ),
	                                '\xA0',
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '#',
	                                        className: 'message-box--sell-bet__btn message-box--sell-bet__btn--cancel message-box--sell-bet__btn--cancel__js',
	                                        onClick: this._onSellCancelClick },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.sellCancel)
	                                )
	                            )
	                        );
	                    }
	
	                case CashoutStatuses.SELL_REQUESTED:
	                    {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'bet-controls-bottom cf' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'message-box message-box--sell-bet  message-box message-box--sell-bet--visible' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'message-box--sell-bet__text' },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, messages.cashoutConfirmation, { values: { br: _react2.default.createElement('br', null) } }))
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'message-box--sell-bet__amount' },
	                                    cashoutAmount
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'message-box--sell-bet__sell message-box--sell-bet__sell__js  btn__disabled' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'btn-preloader--visible' },
	                                        _react2.default.createElement('div', { className: 'btn-preloader__bar btn-preloader__bar-first' }),
	                                        _react2.default.createElement('div', { className: 'btn-preloader__bar btn-preloader__bar-second' }),
	                                        _react2.default.createElement('div', { className: 'btn-preloader__bar btn-preloader__bar-third' })
	                                    )
	                                )
	                            )
	                        );
	                    }
	
	                case CashoutStatuses.SUCCESS:
	                    {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'bet-controls-bottom cf' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'bet-status cf' },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'bet-status__label bet-status__label__sold' },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.sold)
	                                )
	                            )
	                        );
	                    }
	
	                case CashoutStatuses.REJECTED:
	                    {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'bet-controls-bottom cf' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'bet-status cf' },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'bet-status__label bet-status__label__accepted' },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.accepted)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'bet-sell__status-message bet-sell__status-message__forbidden cf' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, messages.eventStakeCashoutForbidden)
	                            )
	                        );
	                    }
	
	                case CashoutStatuses.AMOUNT_CHANGED:
	                    {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'bet-controls-bottom cf' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'message-box message-box--sell-bet  message-box message-box--sell-bet--visible' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'message-box--sell-bet__text' },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.cashoutAmountChanged)
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'message-box--sell-bet__amount' },
	                                    cashoutAmount
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'message-box--sell-bet__sell message-box--sell-bet__sell__js',
	                                        onClick: this._onSellAgreeClick },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: '#', className: 'message-box--sell-bet__btn--confirm' },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.sell)
	                                    )
	                                ),
	                                '\xA0',
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '#',
	                                        className: 'message-box--sell-bet__btn message-box--sell-bet__btn--cancel message-box--sell-bet__btn--cancel__js',
	                                        onClick: this._onSellCancelClick },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.sellCancel)
	                                )
	                            )
	                        );
	                    }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            if (!this.props.id) {
	                return false;
	            }
	            var _props = this.props,
	                bet = _props.bet,
	                resourceId = _props.resourceId;
	
	
	            var betStatus = bet.get('betStatus');
	            var stakeStatus = bet.get('stakeStatus');
	            var betCreateError = bet.get('betCreateError');
	            var resolution = bet.get('resolution');
	            var rateChanged = bet.get('rateChanged');
	            var bigStakeCancelError = bet.get('bigStakeCancelError');
	            var alternativeStake = bet.get('alternativeStake');
	
	            var currency = _accountResourceNames.resourceNames[resourceId];
	            var minAmount = _StakeMinAmount.minAmount[currency];
	
	            var cancellReasonMessage = void 0;
	
	            if (rateChanged || betCreateError === 2) {
	                cancellReasonMessage = _react2.default.createElement(
	                    'span',
	                    { className: 'bet-status__text bet-status__text__cancelled' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.ratesChanged)
	                );
	            } else if (betCreateError === BetCreateErrors.INSUFFICIENT_FUNDS) {
	                cancellReasonMessage = _react2.default.createElement(
	                    'span',
	                    { className: 'bet-status__text bet-status__text__cancelled' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.insufficientFunds)
	                );
	            } else if (betCreateError && betCreateError.length) {
	                cancellReasonMessage = betCreateError.map(function (err) {
	                    return _react2.default.createElement(
	                        'span',
	                        { key: err['ErrorCode'], className: 'bet-status__text bet-status__text__cancelled' },
	                        err['AdditionalValue'] ? _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, messages[err['ErrorCode']], { values: { amount: Array.isArray(err['AdditionalValue']) ? _this3.getStakeTypesInFormat(err['AdditionalValue']) : err['AdditionalValue'], currency: currency } })) : _react2.default.createElement(_reactIntl.FormattedMessage, messages[err['ErrorCode']])
	                    );
	                });
	            } else if (betCreateError === BetCreateErrors.ACCOUNT_LOCKED) {
	                cancellReasonMessage = _react2.default.createElement(
	                    'span',
	                    { className: 'bet-status__text bet-status__text__cancelled' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.accountLocked)
	                );
	            } else if (betCreateError === BetCreateErrors.SYSTEM_NOT_ALLOWED_FOR_FREEBET) {
	                cancellReasonMessage = _react2.default.createElement(
	                    'span',
	                    { className: 'bet-status__text bet-status__text__cancelled' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.systemNotAllowedForFreebet)
	                );
	            } else if (betCreateError === BetCreateErrors.INCORRECT_STAKE) {
	                cancellReasonMessage = _react2.default.createElement(
	                    'span',
	                    { className: 'bet-status__text bet-status__text__cancelled' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.incorrectStakeData)
	                );
	            } else if (betCreateError === BetCreateErrors.MIN_STAKE_AMOUNT) {
	                cancellReasonMessage = _react2.default.createElement(
	                    'span',
	                    { className: 'bet-status__text bet-status__text__cancelled' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, messages.minStakeAmount, { values: { currency: currency, minAmount: minAmount } }))
	                );
	            } else if (betCreateError === BetCreateErrors.INCORRECT_VIRTUAL_STAKE) {
	                cancellReasonMessage = _react2.default.createElement(
	                    'span',
	                    { className: 'bet-status__text bet-status__text__cancelled' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.incorrectVirtualStake)
	                );
	            } else if (betCreateError === BetCreateErrors.INCORRECT_FREEBET_STAKE) {
	                cancellReasonMessage = _react2.default.createElement(
	                    'span',
	                    { className: 'bet-status__text bet-status__text__cancelled' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.incorrectFreebetStake)
	                );
	            } else if (betCreateError === BetCreateErrors.EXISTING_ACTIVE_STAKE) {
	                cancellReasonMessage = _react2.default.createElement(
	                    'span',
	                    { className: 'bet-status__text bet-status__text__cancelled' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.existingActiveStake)
	                );
	            } else if (betCreateError === BetCreateErrors.NO_BIG_STAKE_PERMISSION) {
	                cancellReasonMessage = _react2.default.createElement(
	                    'span',
	                    { className: 'bet-status__text bet-status__text__cancelled' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.noBigStakePermission)
	                );
	            } else if (betCreateError === BetCreateErrors.FREEBET_BIG_STAKE) {
	                cancellReasonMessage = _react2.default.createElement(
	                    'span',
	                    { className: 'bet-status__text bet-status__text__cancelled' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.freebetBigStake)
	                );
	            } else if (betCreateError === BetCreateErrors.INTERNAL_ERROR) {
	                cancellReasonMessage = _react2.default.createElement(
	                    'span',
	                    { className: 'bet-status__text bet-status__text__cancelled' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.canceled)
	                );
	            } else if (betCreateError === BetCreateErrors.ALTERNATIVE_STAKE) {
	                cancellReasonMessage = _react2.default.createElement(
	                    'span',
	                    { className: 'bet-status__text bet-status__text__cancelled' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, messages.alternativeStake, {
	                        values: { resource: currency, amount: alternativeStake }
	                    }))
	                );
	            } else if (betCreateError === BetCreateErrors.NOT_POSSIBLE_STAKE) {
	                cancellReasonMessage = _react2.default.createElement(
	                    'span',
	                    { className: 'bet-status__text bet-status__text__cancelled' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.not_possible_stake)
	                );
	            } else if (resolution !== undefined) {
	                cancellReasonMessage = _react2.default.createElement(
	                    'span',
	                    { className: 'bet-status__text bet-status__text__cancelled' },
	                    resolution
	                );
	            }
	
	            switch (betStatus) {
	                case BetStatuses.INIT:
	                case BetStatuses.IN_DELAY:
	                case BetStatuses.CONFIRM_AWAIT:
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'bet-controls-bottom cf' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'bet-status bet-status__preloader' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'btn__disabled' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'btn-preloader--visible' },
	                                    _react2.default.createElement('div', { className: 'btn-preloader__bar btn-preloader__bar-first' }),
	                                    _react2.default.createElement('div', { className: 'btn-preloader__bar btn-preloader__bar-second' }),
	                                    _react2.default.createElement('div', { className: 'btn-preloader__bar btn-preloader__bar-third' })
	                                )
	                            )
	                        )
	                    );
	
	                case BetStatuses.STAKE_REQUEST:
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'bet-controls-bottom cf' },
	                        (bigStakeCancelError === undefined || bigStakeCancelError !== BigStakeCancelError.CANCEL_NOT_POSSIBLE) && _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'bet-status bet-status__preloader' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'btn__disabled' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'btn-preloader--visible' },
	                                        _react2.default.createElement('div', { className: 'btn-preloader__bar btn-preloader__bar-first' }),
	                                        _react2.default.createElement('div', { className: 'btn-preloader__bar btn-preloader__bar-second' }),
	                                        _react2.default.createElement('div', { className: 'btn-preloader__bar btn-preloader__bar-third' })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'bet-cancel' },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '#', onClick: this._onCancelBigStakeRequestClick },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.bigStakeCancel)
	                                )
	                            )
	                        )
	                    );
	
	                case BetStatuses.BET_PAY_REQUEST:
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'bet-status cf' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'bet-status__label bet-status__label__accepted' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.accepted)
	                        )
	                    );
	
	                case BetStatuses.CONFIRMED:
	                    {
	                        var cashout = bet.get('cashout');
	
	                        if (cashout) {
	                            var cashoutState = cashout.get('state');
	                            var cashoutAmount = cashout.get('amount');
	
	                            if (cashoutState && cashoutAmount !== undefined) {
	                                return this.renderCashout();
	                            }
	                        }
	
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'bet-status cf' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'bet-status__label bet-status__label__accepted' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, messages.accepted)
	                            )
	                        );
	                    }
	
	                case BetStatuses.REJECTED:
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'bet-controls-bottom cf' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'bet-status cf' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'bet-status__label bet-status__label__canceled' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, messages.canceled)
	                            ),
	                            cancellReasonMessage
	                        )
	                    );
	
	                case BetStatuses.CALCULATED:
	                    switch (stakeStatus) {
	                        case StakeStatuses.WON:
	                            return _react2.default.createElement(
	                                'div',
	                                { className: 'bet-controls-bottom cf' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'bet-status cf' },
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: 'bet-status__label bet-status__label__win' },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.won)
	                                    )
	                                )
	                            );
	                        case StakeStatuses.LOST:
	                            return _react2.default.createElement(
	                                'div',
	                                { className: 'bet-controls-bottom cf' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'bet-status cf' },
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: 'bet-status__label bet-status__label__loss' },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.lost)
	                                    )
	                                )
	                            );
	                        case StakeStatuses.REFUND:
	                            return _react2.default.createElement(
	                                'div',
	                                { className: 'bet-controls-bottom cf' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'bet-status cf' },
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: 'bet-status__label bet-status__label__win' },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.refund)
	                                    )
	                                )
	                            );
	                    }
	                    break;
	
	                case BetStatuses.CASHOUT:
	                    return this.renderCashout();
	
	            }
	
	            return false;
	        }
	    }]);
	    return BetStatus;
	}(_react2.default.Component);
	
	BetStatus.propTypes = {
	    id: _react2.default.PropTypes.string.isRequired,
	    bet: _react2.default.PropTypes.object.isRequired,
	    resourceId: _react2.default.PropTypes.number.isRequired,
	    accountId: _react2.default.PropTypes.number.isRequired,
	    cancelBigStakeRequestAction: _react2.default.PropTypes.func.isRequired,
	    setCashoutStatusAction: _react2.default.PropTypes.func.isRequired,
	    createCashoutAction: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select(state, props) {
	    var user = state.auth.get('user');
	    if (!user) {
	        return {};
	    }
	    var id = props.id;
	    var bet = state.application.getIn(['betHistory', id]);
	    var languageId = state.application.get('languageId');
	    var resourceId = user.get('resourceId');
	    var accountId = user.get('accountId');
	
	    return {
	        id: id,
	        bet: bet,
	        languageId: languageId,
	        resourceId: resourceId,
	        accountId: accountId
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, {
	    cancelBigStakeRequestAction: _BigStakeRequest.cancelBigStakeRequest,
	    setCashoutStatusAction: _Cashout.setCashoutStatus,
	    createCashoutAction: _Cashout.createCashout
	})((0, _reactIntl.injectIntl)(BetStatus));

/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(8);
	
	var _BetStatus = __webpack_require__(134);
	
	var BetStatuses = _interopRequireWildcard(_BetStatus);
	
	var _HistoryBet = __webpack_require__(65);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    notAccepted: {
	        id: 'bet_status.not_accepted',
	        defaultMessage: 'Не принята'
	    },
	    newBet: {
	        id: 'bet_title.new_bet',
	        defaultMessage: 'Новая ставка'
	    }
	});
	
	var BetTitle = function (_React$Component) {
	    (0, _inherits3.default)(BetTitle, _React$Component);
	
	    function BetTitle(props) {
	        (0, _classCallCheck3.default)(this, BetTitle);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (BetTitle.__proto__ || (0, _getPrototypeOf2.default)(BetTitle)).call(this, props));
	
	        _this._onRemoveClick = _this._onRemoveClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(BetTitle, [{
	        key: '_onRemoveClick',
	        value: function _onRemoveClick(e) {
	            e.preventDefault();
	            this.props.removeHistoryBetAction(this.props.id);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var bet = this.props.bet;
	
	            if (!bet) {
	                return false;
	            }
	
	            var betStatus = bet.get('betStatus');
	            var stakeId = bet.get('stakeId');
	            var stakeTime = bet.get('stakeTime');
	
	            var stakeIdStr = void 0;
	            var stakeTimeSpan = void 0;
	            if (stakeId) {
	                stakeIdStr = '#' + stakeId;
	            }
	            if (stakeTime) {
	                stakeTimeSpan = _react2.default.createElement(_reactIntl.FormattedDate, { value: stakeTime,
	                    day: 'numeric',
	                    month: 'numeric',
	                    hour: 'numeric',
	                    minute: 'numeric',
	                    second: 'numeric' });
	            }
	
	            switch (betStatus) {
	                case BetStatuses.INIT:
	                case BetStatuses.IN_DELAY:
	                case BetStatuses.CONFIRM_AWAIT:
	                case BetStatuses.BET_PAY_REQUEST:
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'title title-white cf' },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.newBet)
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: '#', className: 'close', onClick: this._onRemoveClick },
	                            '\xA0'
	                        )
	                    );
	
	                case BetStatuses.REJECTED:
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'title cf' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'not-accepted' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.notAccepted)
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: '#', className: 'close', onClick: this._onRemoveClick },
	                            '\xA0'
	                        )
	                    );
	
	                case BetStatuses.CALCULATED:
	                case BetStatuses.CASHOUT:
	                case BetStatuses.CONFIRMED:
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'title cf' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'bet-id pull-left' },
	                            stakeIdStr
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'bet-date pull-right' },
	                            stakeTimeSpan
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: '#', className: 'close', onClick: this._onRemoveClick },
	                            '\xA0'
	                        )
	                    );
	
	                default:
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'title cf' },
	                        _react2.default.createElement(
	                            'a',
	                            { href: '#', className: 'close', onClick: this._onRemoveClick },
	                            '\xA0'
	                        )
	                    );
	            }
	        }
	    }]);
	    return BetTitle;
	}(_react2.default.Component);
	
	BetTitle.propTypes = {
	    id: _react2.default.PropTypes.string.isRequired,
	    bet: _react2.default.PropTypes.object.isRequired,
	    removeHistoryBetAction: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select(state, props) {
	    var id = props.id;
	    var bet = state.application.getIn(['betHistory', id]);
	    var languageId = state.application.get('languageId');
	
	    return {
	        id: id,
	        bet: bet,
	        languageId: languageId
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, {
	    removeHistoryBetAction: _HistoryBet.removeHistoryBet
	})(BetTitle);

/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(307);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(8);
	
	var _SportCssMap = __webpack_require__(120);
	
	var _CouponRate = __webpack_require__(72);
	
	var _HistoryBet = __webpack_require__(65);
	
	var _rateUtils = __webpack_require__(505);
	
	var _BetType = __webpack_require__(46);
	
	var BetTypeMap = _interopRequireWildcard(_BetType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    rateChanged: {
	        id: 'coupon.rate_changed',
	        defaultMessage: 'Коэфф недоступен'
	    },
	    rateUnavailable: {
	        id: 'coupon.rate_unavailable',
	        defaultMessage: 'Прием закрыт'
	    },
	    confirmRateValueChange: {
	        id: 'coupon.confirm_rate_value_change',
	        defaultMessage: 'Принять изменения'
	    },
	    stake: {
	        id: 'coupon.stake_title',
	        defaultMessage: 'Ставка:'
	    },
	    rate: {
	        id: 'coupon.rate_title',
	        defaultMessage: 'Коэфф:'
	    },
	    sumLabel: {
	        id: 'coupon.sum_label',
	        defaultMessage: 'Сумма'
	    }
	});
	
	var BetSlip = function (_React$Component) {
	    (0, _inherits3.default)(BetSlip, _React$Component);
	
	    function BetSlip(props) {
	        (0, _classCallCheck3.default)(this, BetSlip);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (BetSlip.__proto__ || (0, _getPrototypeOf2.default)(BetSlip)).call(this, props));
	
	        _this._onRemoveClick = _this._onRemoveClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(BetSlip, [{
	        key: '_onRemoveClick',
	        value: function _onRemoveClick(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	            _promise2.default.resolve(this.props.removeCouponRateAction({ rateId: this.props.rate.get('id') })).then(function () {
	                return _this2.props.onUpdateSize();
	            });
	            this.props.requestBetTypesAction();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (!this.props.betSlip) {
	                return false;
	            }
	
	            var rate = this.props.rate;
	            var match = this.props.match;
	            var score = this.props.score;
	            var outcome = this.props.outcome;
	            var bettingMode = this.props.bettingMode;
	            var stake = this.props.stake;
	            var betSlipCount = this.props.betSlipCount;
	            var originalValue = rate.get('value');
	            var actualValue = rate.get('actualValue');
	            var betTypes = this.props.betTypes;
	            var currentBetTypeIndex = this.props.currentBetTypeIndex;
	
	            if (!match) {
	                return false;
	            }
	
	            var betType = betTypes.get(currentBetTypeIndex);
	            var currentBetTypeIsSingle = betType && betType.type == BetTypeMap.SINGLE;
	
	            var acceptFactorChange = bettingMode.get('acceptFactorChange');
	
	            var sportIconCls = 'sport-icon svg-' + _SportCssMap.cssClassMap[rate.get('sportId')];
	
	            var unavailableSpan = void 0;
	            if ((0, _rateUtils.isRateUnavailable)(rate)) {
	                unavailableSpan = _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    messages.rateUnavailable,
	                    function (message) {
	                        return _react2.default.createElement(
	                            'span',
	                            { className: 'event-rate event-rate__unavailable' },
	                            message
	                        );
	                    }
	                );
	            } else if ((0, _rateUtils.rateFactorChangeConfirmNeeded)(rate, acceptFactorChange)) {
	                unavailableSpan = _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    messages.rateChanged,
	                    function (message) {
	                        return _react2.default.createElement(
	                            'span',
	                            { className: 'event-rate event-rate__unavailable' },
	                            message
	                        );
	                    }
	                );
	            }
	
	            var scoreSpan = undefined;
	            if (score) {
	                var score1 = score.get('score1');
	                score1 = score1 === null ? 0 : score1;
	
	                var score2 = score.get('score2');
	                score2 = score2 === null ? 0 : score2;
	
	                scoreSpan = _react2.default.createElement(
	                    'span',
	                    { className: 'current-score' },
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        score1 + ':' + score2
	                    )
	                );
	            }
	
	            var eventSingleBetAmount = undefined;
	            if (betSlipCount > 1) {
	                eventSingleBetAmount = _react2.default.createElement(
	                    'span',
	                    { className: 'event-single-bet-amount' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.sumLabel),
	                    ': ',
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        stake
	                    )
	                );
	            }
	
	            var rateSpan = _react2.default.createElement(
	                'span',
	                { className: 'event-rate' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, messages.rate),
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    originalValue
	                ),
	                currentBetTypeIsSingle && eventSingleBetAmount,
	                unavailableSpan
	            );
	
	            if (actualValue && originalValue !== actualValue) {
	                var cls = 'new-rate';
	                if (originalValue < actualValue) {
	                    cls += ' up';
	                } else {
	                    cls += ' down';
	                }
	
	                rateSpan = _react2.default.createElement(
	                    'div',
	                    { className: 'rate changed' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.rate),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'old-rate' },
	                        '\xA0',
	                        originalValue
	                    ),
	                    '\xA0',
	                    _react2.default.createElement(
	                        'span',
	                        { className: cls },
	                        actualValue
	                    ),
	                    unavailableSpan
	                );
	            }
	
	            var matchName = match.get('name');
	            if (match.get('notice')) {
	                matchName += '(' + match.get('notice') + ')';
	            }
	
	            return _react2.default.createElement(
	                'li',
	                { className: 'coupons-list-item' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'event-name' },
	                    _react2.default.createElement('span', { className: sportIconCls }),
	                    scoreSpan,
	                    matchName,
	                    _react2.default.createElement('br', null),
	                    outcome.get('name')
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'event-type' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.stake),
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        rate.get('shortName')
	                    )
	                ),
	                rateSpan,
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', className: 'close', onClick: this._onRemoveClick },
	                    '\xA0'
	                )
	            );
	        }
	    }]);
	    return BetSlip;
	}(_react2.default.Component);
	
	BetSlip.propTypes = {
	    rate: _react2.default.PropTypes.object,
	    match: _react2.default.PropTypes.object,
	    score: _react2.default.PropTypes.object,
	    outcome: _react2.default.PropTypes.object,
	    bettingMode: _react2.default.PropTypes.object,
	    removeCouponRateAction: _react2.default.PropTypes.func.isRequired,
	    requestBetTypesAction: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select(state, props) {
	    var betSlipId = props.id;
	    var betSlip = state.application.getIn(['coupon', 'betSlips', betSlipId]);
	    var betSlipCount = state.application.getIn(['coupon', 'betSlips']).size;
	    var stake = state.application.getIn(['coupon', 'amount']);
	    var currentBetTypeIndex = state.application.getIn(['coupon', 'currentBetTypeIndex']);
	    var betTypes = state.application.getIn(['coupon', 'betTypes']);
	
	    var rate = void 0,
	        match = void 0,
	        score = void 0,
	        outcome = void 0;
	    if (betSlip) {
	        rate = betSlip.get('rate');
	        match = betSlip.get('match');
	        score = betSlip.get('score');
	        outcome = betSlip.get('outcome');
	    }
	
	    var bettingMode = state.application.get('bettingMode');
	
	    return {
	        betSlip: betSlip,
	        rate: rate,
	        match: match,
	        score: score,
	        outcome: outcome,
	        bettingMode: bettingMode,
	        stake: stake,
	        betSlipCount: betSlipCount,
	        currentBetTypeIndex: currentBetTypeIndex,
	        betTypes: betTypes
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, {
	    removeCouponRateAction: _CouponRate.removeCouponRate, requestBetTypesAction: _HistoryBet.requestBetTypes
	})(BetSlip);

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _BetType = __webpack_require__(46);
	
	var BetTypeMap = _interopRequireWildcard(_BetType);
	
	var _BetSlip = __webpack_require__(1195);
	
	var _BetSlip2 = _interopRequireDefault(_BetSlip);
	
	var _BetSlipeExt = __webpack_require__(1197);
	
	var _BetSlipeExt2 = _interopRequireDefault(_BetSlipeExt);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BetSlipList = function (_React$Component) {
	    (0, _inherits3.default)(BetSlipList, _React$Component);
	
	    function BetSlipList(props) {
	        (0, _classCallCheck3.default)(this, BetSlipList);
	        return (0, _possibleConstructorReturn3.default)(this, (BetSlipList.__proto__ || (0, _getPrototypeOf2.default)(BetSlipList)).call(this, props));
	    }
	
	    (0, _createClass3.default)(BetSlipList, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                currentBetTypeIndex = _props.currentBetTypeIndex,
	                betTypes = _props.betTypes;
	
	            var betSlips = this.props.betSlips.reverse().keySeq();
	            var betType = betTypes.get(currentBetTypeIndex) || {};
	            var isMultiSingleSlip = betSlips.size > 1 && betType.type === BetTypeMap.SINGLE;
	
	            return _react2.default.createElement(
	                'ul',
	                { className: 'coupons-list' },
	                !isMultiSingleSlip && betSlips.map(function (betSlipId) {
	                    return BetSlipList.renderBetSlip(betSlipId, _this2.props.onUpdateSize);
	                }),
	                isMultiSingleSlip && betSlips.map(function (betSlipId) {
	                    return BetSlipList.renderBetSlipExt(betSlipId, _this2.props.onUpdateSize);
	                })
	            );
	        }
	    }], [{
	        key: 'renderBetSlipExt',
	        value: function renderBetSlipExt(betSlipId, onUpdateSize) {
	            return _react2.default.createElement(_BetSlipeExt2.default, { key: betSlipId, id: betSlipId, onUpdateSize: onUpdateSize });
	        }
	    }, {
	        key: 'renderBetSlip',
	        value: function renderBetSlip(betSlipId, onUpdateSize) {
	            return _react2.default.createElement(_BetSlip2.default, { key: betSlipId, id: betSlipId, onUpdateSize: onUpdateSize });
	        }
	    }]);
	    return BetSlipList;
	}(_react2.default.Component);
	
	BetSlipList.propTypes = {
	    betSlips: _react2.default.PropTypes.object.isRequired,
	    currentBetTypeIndex: _react2.default.PropTypes.number.isRequired,
	    betTypes: _react2.default.PropTypes.object.isRequired,
	    onUpdateSize: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select(state) {
	    var betSlips = state.application.getIn(['coupon', 'betSlips']);
	    var currentBetTypeIndex = state.application.getIn(['coupon', 'currentBetTypeIndex']);
	    var betTypes = state.application.getIn(['coupon', 'betTypes']);
	
	    return {
	        betSlips: betSlips,
	        currentBetTypeIndex: currentBetTypeIndex,
	        betTypes: betTypes
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select)(BetSlipList);

/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _promise = __webpack_require__(307);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(8);
	
	var _SportCssMap = __webpack_require__(120);
	
	var _CouponRate = __webpack_require__(72);
	
	var _HistoryBet = __webpack_require__(65);
	
	var _Freebet = __webpack_require__(486);
	
	var _rateUtils = __webpack_require__(505);
	
	var _StakeMinAmount = __webpack_require__(135);
	
	var _StakeMaxWinAmount = __webpack_require__(496);
	
	var _accountResourceNames = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultResourceId = 4;
	
	var messages = (0, _reactIntl.defineMessages)({
	    rateChanged: {
	        id: 'coupon.rate_changed',
	        defaultMessage: 'Коэфф недоступен'
	    },
	    rateUnavailable: {
	        id: 'coupon.rate_unavailable',
	        defaultMessage: 'Прием закрыт'
	    },
	    confirmRateValueChange: {
	        id: 'coupon.confirm_rate_value_change',
	        defaultMessage: 'Принять изменения'
	    },
	    stake: {
	        id: 'coupon.stake_title',
	        defaultMessage: 'Ставка:'
	    },
	    rate: {
	        id: 'coupon.rate_title',
	        defaultMessage: 'Коэфф:'
	    },
	    sumLabel: {
	        id: 'coupon.sum_label',
	        defaultMessage: 'Сумма'
	    },
	    minAmountHint: {
	        id: 'coupon.min_amount_hint',
	        defaultMessage: 'Мин.'
	    },
	    possible_winning_hint: {
	        id: 'coupon.possible_winning_hint_short',
	        defaultMessage: 'Выигрыш'
	    },
	    maxAmountHint: {
	        id: 'coupon.max_amount_hint',
	        defaultMessage: 'Макс. {amount} {resource}'
	    }
	});
	
	var BetSlipExt = function (_React$Component) {
	    (0, _inherits3.default)(BetSlipExt, _React$Component);
	
	    function BetSlipExt(props) {
	        (0, _classCallCheck3.default)(this, BetSlipExt);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (BetSlipExt.__proto__ || (0, _getPrototypeOf2.default)(BetSlipExt)).call(this, props));
	
	        var rawAmount = _this.props.amount > 0 ? Number(_this.props.amount) : 0;
	
	        _this.state = { rawAmount: rawAmount };
	        _this._onAmountChange = _this._onAmountChange.bind(_this);
	        _this._onToggleFreebetClick = _this._onToggleFreebetClick.bind(_this);
	        _this._onRemoveClick = _this._onRemoveClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(BetSlipExt, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var rawAmount = Number(this.state.rawAmount);
	
	            if (rawAmount !== nextProps.amount) {
	                this.setState({ rawAmount: nextProps.amount });
	            }
	        }
	    }, {
	        key: '_onAmountChange',
	        value: function _onAmountChange(e) {
	            e.preventDefault();
	
	            var rate = this.props.rate;
	
	            var rateId = rate.get('id');
	            var rawAmount = e.target.value;
	
	            // checking for length
	            if (!rawAmount.length) {
	                this.setState({ rawAmount: '' });
	                this.props.changeCouponSlipAmountAction([{ rateId: rateId, amount: 0 }]);
	            }
	
	            var amount = Number(rawAmount);
	
	            if (isNaN(amount)) {
	                return;
	            }
	
	            var splittedRawAmount = rawAmount.split('.');
	            var zeroSum = splittedRawAmount[0].length > 1 && amount == 0.0;
	            var longDecimalPart = splittedRawAmount[1] !== undefined && splittedRawAmount[1].length > 2;
	
	            // checking for several zeros and long decimal part of value
	            if (zeroSum || longDecimalPart) {
	                return;
	            }
	
	            // concating splitted value to normal amount
	            rawAmount = Number(splittedRawAmount[0]).toString();
	            if (splittedRawAmount[1] !== undefined) {
	                rawAmount = rawAmount + '.' + splittedRawAmount[1];
	            }
	
	            var splittedAmount = amount.toString().split('.');
	            var ceilPart = splittedAmount[0];
	            var decimalPart = splittedAmount[1] !== undefined ? splittedAmount[1] : '';
	
	            // checking for fract.num length
	            if (ceilPart.toString().length > 7 || decimalPart.toString().length > 2) {
	                return;
	            }
	
	            this.setState({ rawAmount: rawAmount });
	            this.props.changeCouponSlipAmountAction([{ rateId: rateId, amount: amount }]);
	        }
	    }, {
	        key: '_onRemoveClick',
	        value: function _onRemoveClick(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	            _promise2.default.resolve(this.props.removeCouponRateAction({ rateId: this.props.rate.get('id') })).then(function () {
	                return _this2.props.onUpdateSize();
	            });
	            this.props.requestBetTypesAction();
	        }
	    }, {
	        key: '_onToggleFreebetClick',
	        value: function _onToggleFreebetClick(e) {
	            e.preventDefault();
	
	            var _props = this.props,
	                freebet = _props.freebet,
	                isFreebet = _props.isFreebet,
	                rate = _props.rate;
	
	            var rateId = rate.get('id');
	
	            if (isFreebet) {
	                this.setState({ rawAmount: 0 });
	                this.props.toggleFreebetAction(false);
	                this.props.changeCouponSlipAmountAction([{ rateId: rateId, amount: 0, isFreeBet: false }]);
	            } else {
	                var freebetAmount = freebet.get('amount');
	
	                this.setState({ rawAmount: freebetAmount });
	                this.props.toggleFreebetAction(true);
	                this.props.changeCouponSlipAmountAction([{ rateId: rateId, amount: freebetAmount, isFreeBet: true }]);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                rate = _props2.rate,
	                match = _props2.match,
	                score = _props2.score,
	                outcome = _props2.outcome,
	                bettingMode = _props2.bettingMode,
	                stake = _props2.stake,
	                amount = _props2.amount,
	                alternativeStake = _props2.alternativeStake,
	                minBetAmount = _props2.minBetAmount,
	                maxWinAmount = _props2.maxWinAmount,
	                resourceName = _props2.resourceName,
	                isFreebet = _props2.isFreebet,
	                freebetAvailable = _props2.freebetAvailable;
	            var rawAmount = this.state.rawAmount;
	
	            var ltMinAmount = amount < minBetAmount;
	            var originalValue = rate.get('value');
	            var actualValue = rate.get('actualValue');
	            var acceptFactorChange = bettingMode.get('acceptFactorChange');
	            var sportIconCls = 'sport-icon svg-' + _SportCssMap.cssClassMap[rate.get('sportId')];
	            var possibleWinning = ltMinAmount ? 0 : parseFloat(amount * originalValue).toFixed(2);
	
	            var maxRestriction = possibleWinning > maxWinAmount;
	
	            var unavailableSpan = void 0;
	            if ((0, _rateUtils.isRateUnavailable)(rate)) {
	                unavailableSpan = _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    messages.rateUnavailable,
	                    function (message) {
	                        return _react2.default.createElement(
	                            'span',
	                            { className: 'event-rate event-rate__unavailable' },
	                            message
	                        );
	                    }
	                );
	            } else if ((0, _rateUtils.rateFactorChangeConfirmNeeded)(rate, acceptFactorChange)) {
	                unavailableSpan = _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    messages.rateChanged,
	                    function (message) {
	                        return _react2.default.createElement(
	                            'span',
	                            { className: 'event-rate event-rate__unavailable' },
	                            message
	                        );
	                    }
	                );
	            }
	
	            var scoreSpan = undefined;
	            if (score) {
	                var score1 = score.get('score1', 0);
	                var score2 = score.get('score2', 0);
	
	                scoreSpan = _react2.default.createElement(
	                    'span',
	                    { className: 'current-score' },
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        score1 + ':' + score2
	                    )
	                );
	            }
	
	            var rateSpan = _react2.default.createElement(
	                'span',
	                { className: 'event-rate' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, messages.rate),
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    originalValue
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'event-single-bet-amount' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.sumLabel),
	                    ':',
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedNumber, { value: stake })
	                    )
	                ),
	                unavailableSpan
	            );
	
	            var rateChanged = actualValue && originalValue !== actualValue;
	
	            if (rateChanged) {
	                var cls = originalValue < actualValue ? 'new-rate up' : 'new-rate down';
	
	                rateSpan = _react2.default.createElement(
	                    'div',
	                    { className: 'rate changed' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.rate),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'old-rate' },
	                        '\xA0',
	                        originalValue
	                    ),
	                    '\xA0',
	                    _react2.default.createElement(
	                        'span',
	                        { className: cls },
	                        actualValue
	                    ),
	                    unavailableSpan
	                );
	            }
	
	            var matchName = match.get('name');
	            if (match.get('notice')) {
	                matchName += '(' + match.get('notice') + ')';
	            }
	
	            return _react2.default.createElement(
	                'li',
	                { className: 'coupons-list-item' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'event-name' },
	                    _react2.default.createElement('span', { className: sportIconCls }),
	                    scoreSpan,
	                    matchName,
	                    _react2.default.createElement('br', null),
	                    outcome.get('name')
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'event-type' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.stake),
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        rate.get('shortName')
	                    )
	                ),
	                rateSpan,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'singlebet-amount cf' },
	                    _react2.default.createElement('input', { value: rawAmount, type: 'text', readOnly: isFreebet, id: 'bet-amount', className: 'bet',
	                        onChange: this._onAmountChange, onBlur: this._onAmountChange }),
	                    ltMinAmount && _react2.default.createElement(
	                        'p',
	                        { className: 'min-bet-amount-hint' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.minAmountHint),
	                        ' ',
	                        minBetAmount
	                    ),
	                    freebetAvailable && _react2.default.createElement('div', { className: 'freebet--icon freebet--icon__active freebet--icon__bet-amount',
	                        onClick: this._onToggleFreebetClick })
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'singlebet-amount' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.possible_winning_hint),
	                    ':',
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedNumber, { value: possibleWinning })
	                    )
	                ),
	                maxRestriction && _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    (0, _extends3.default)({}, messages.maxAmountHint, {
	                        values: { amount: maxWinAmount, resource: resourceName } }),
	                    function (message) {
	                        return _react2.default.createElement(
	                            'p',
	                            { className: 'max-win-amount-hint-ext' },
	                            message
	                        );
	                    }
	                ),
	                alternativeStake && _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    (0, _extends3.default)({}, messages.maxAmountHint, {
	                        values: { amount: alternativeStake, resource: resourceName } }),
	                    function (message) {
	                        return _react2.default.createElement(
	                            'p',
	                            { className: 'max-win-amount-hint-ext' },
	                            message
	                        );
	                    }
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', className: 'close', onClick: this._onRemoveClick },
	                    '\xA0'
	                )
	            );
	        }
	    }]);
	    return BetSlipExt;
	}(_react2.default.Component);
	
	BetSlipExt.propTypes = {
	    user: _react2.default.PropTypes.any,
	    rate: _react2.default.PropTypes.object,
	    match: _react2.default.PropTypes.object,
	    score: _react2.default.PropTypes.object,
	    outcome: _react2.default.PropTypes.object,
	    bettingMode: _react2.default.PropTypes.object,
	    amount: _react2.default.PropTypes.number,
	    minBetAmount: _react2.default.PropTypes.number,
	    removeCouponRateAction: _react2.default.PropTypes.func.isRequired,
	    requestBetTypesAction: _react2.default.PropTypes.func.isRequired,
	    changeCouponSlipAmountAction: _react2.default.PropTypes.func.isRequired,
	    toggleFreebetAction: _react2.default.PropTypes.func.isRequired
	};
	
	
	function isFreeBetAvailable(oddValue, maxFactorValue) {
	    var odd = Number(oddValue);
	    var maxFactor = Number(maxFactorValue);
	
	    return !maxFactor || maxFactor == 0.0 || odd <= maxFactor;
	}
	
	function select(state, props) {
	    var user = state.auth.get('user');
	    var bettingMode = state.application.get('bettingMode');
	    var resourceName = user === undefined || !user ? _accountResourceNames.resourceNames[defaultResourceId] : _accountResourceNames.resourceNames[user.get('resourceId')];
	    var minBetAmount = _StakeMinAmount.minAmount[resourceName];
	    var maxWinAmount = _StakeMaxWinAmount.maxWinAmount[resourceName];
	
	    var betSlipId = props.id;
	    var betSlip = state.application.getIn(['coupon', 'betSlips', betSlipId]);
	
	    var rate = betSlip.get('rate');
	    var match = betSlip.get('match');
	    var score = betSlip.get('score');
	    var outcome = betSlip.get('outcome');
	
	    var rateId = rate.get('id');
	    var betSlipAmount = state.application.getIn(['coupon', 'betSlipAmounts', rateId]);
	
	    var stake = betSlipAmount.get('amount');
	    var amount = betSlipAmount.get('amount');
	    var alternativeStake = betSlipAmount.get('alternativeStake');
	
	    var freebet = state.application.getIn(['coupon', 'freebet']);
	    var isFreebet = state.application.getIn(['coupon', 'isFreebet', 'isFreebet']);
	
	    var freebetAvailable = !freebet || freebet.size === 0 ? false : isFreeBetAvailable(rate.get('value'), freebet.get('maxFactorValue'));
	
	    var isFreebetSlip = betSlipAmount.get('isFreeBet');
	
	    var freebetEnable = freebetAvailable && !isFreebet || freebetAvailable && isFreebet && isFreebetSlip;
	
	    return {
	        rate: rate,
	        match: match,
	        score: score,
	        outcome: outcome,
	        bettingMode: bettingMode,
	        stake: stake,
	        amount: amount,
	        alternativeStake: alternativeStake,
	        freebet: freebet,
	        isFreebet: isFreebetSlip,
	        freebetAvailable: freebetEnable,
	        minBetAmount: minBetAmount,
	        maxWinAmount: maxWinAmount,
	        resourceName: resourceName,
	        user: user
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, {
	    removeCouponRateAction: _CouponRate.removeCouponRate,
	    requestBetTypesAction: _HistoryBet.requestBetTypes,
	    changeCouponSlipAmountAction: _CouponRate.changeCouponSlipAmount,
	    toggleFreebetAction: _Freebet.toggleFreebet
	})(BetSlipExt);

/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(8);
	
	var _immutable = __webpack_require__(14);
	
	var _BetType = __webpack_require__(46);
	
	var BetTypeMap = _interopRequireWildcard(_BetType);
	
	var _AcceptFactorChange = __webpack_require__(333);
	
	var AcceptFactorChangeMode = _interopRequireWildcard(_AcceptFactorChange);
	
	var _MakeBet = __webpack_require__(133);
	
	var _CouponRate = __webpack_require__(72);
	
	var _balanceAction = __webpack_require__(132);
	
	var _HistoryBet = __webpack_require__(65);
	
	var _Freebet = __webpack_require__(486);
	
	var _rateUtils = __webpack_require__(505);
	
	var _BetType2 = __webpack_require__(503);
	
	var _BetType3 = _interopRequireDefault(_BetType2);
	
	var _FavouriteBetAmount = __webpack_require__(504);
	
	var _FavouriteBetAmount2 = _interopRequireDefault(_FavouriteBetAmount);
	
	var _StakeMinAmount = __webpack_require__(135);
	
	var _StakeMaxWinAmount = __webpack_require__(496);
	
	var _accountResourceNames = __webpack_require__(59);
	
	var _CouponDropDownMenu = __webpack_require__(306);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    makeBet: {
	        id: 'coupon.make_bet',
	        defaultMessage: 'Сделать ставку'
	    },
	    confirmRateValueChange: {
	        id: 'coupon.confirm_rate_value_change',
	        defaultMessage: 'Принять'
	    },
	    totalOdd: {
	        id: 'coupon.total_odd_hint',
	        defaultMessage: 'Общий коэффициент'
	    },
	    possibleWinning: {
	        id: 'coupon.possible_winning_hint',
	        defaultMessage: 'Возможный выигрыш'
	    },
	    stake: {
	        id: 'coupon.stake_hint',
	        defaultMessage: 'Сумма ставки'
	    },
	    minAmountHint: {
	        id: 'coupon.min_amount_hint',
	        defaultMessage: 'Мин.'
	    },
	    maxAmountHint: {
	        id: 'coupon.max_amount_hint',
	        defaultMessage: 'Макс. {amount} {resource}'
	    }
	});
	
	var Controls = function (_React$Component) {
	    (0, _inherits3.default)(Controls, _React$Component);
	
	    function Controls(props) {
	        (0, _classCallCheck3.default)(this, Controls);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Controls.__proto__ || (0, _getPrototypeOf2.default)(Controls)).call(this, props));
	
	        _this.componentWillUpdate = function (nextProps) {
	            if (nextProps.alternativeStake && _this.state.rawAmount > 0 && nextProps.amount != _this.state.rawAmount) {
	                _this.setState({ rawAmount: nextProps.amount });
	            }
	        };
	
	        var amount = props.amount || 0;
	        var inActive = amount < props.minBetAmount;
	
	        _this.state = { inActive: inActive, rawAmount: amount };
	
	        _this._onMakeBetClick = _this._onMakeBetClick.bind(_this);
	        _this._onAmountChange = _this._onAmountChange.bind(_this);
	        _this._onFavouriteBetAmountClick = _this._onFavouriteBetAmountClick.bind(_this);
	        _this._onToggleFreebetClick = _this._onToggleFreebetClick.bind(_this);
	        _this._onConfirmClick = _this._onConfirmClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(Controls, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return nextProps.languageId !== this.props.languageId || nextProps.betSlips !== this.props.betSlips || nextProps.amount !== this.props.amount || nextProps.isFreebet !== this.props.isFreebet || nextProps.currentBetTypeIndex !== this.props.currentBetTypeIndex || nextProps.betTypes !== this.props.betTypes || nextProps.bettingMode !== this.props.bettingMode || nextProps.nextKey !== this.props.nextKey || nextState.rawAmount !== this.state.rawAmount;
	        }
	    }, {
	        key: '_onMakeBetClick',
	        value: function _onMakeBetClick(e) {
	            e.preventDefault();
	
	            var amount = this.props.amount;
	
	            if (amount <= 0) {
	                return;
	            }
	
	            var _props = this.props,
	                currentBetTypeIndex = _props.currentBetTypeIndex,
	                betTypes = _props.betTypes,
	                isFreebet = _props.isFreebet;
	
	            if (currentBetTypeIndex === -1) {
	                return;
	            }
	
	            var betType = betTypes.get(currentBetTypeIndex);
	
	            var betSlips = this.props.betSlips;
	            var bettingMode = this.props.bettingMode;
	            var acceptFactorChangeMode = bettingMode.get('acceptFactorChange');
	
	            var makeBetPossible = true;
	            betSlips.forEach(function (bs) {
	                var rate = bs.get('rate');
	
	                if ((0, _rateUtils.rateFactorChangeConfirmNeeded)(rate, acceptFactorChangeMode) || (0, _rateUtils.isRateUnavailable)(rate)) {
	                    makeBetPossible = false;
	                    return false;
	                }
	            });
	
	            if (makeBetPossible === false) {
	                return;
	            }
	
	            var allowIncrease = false;
	            var allowDecrease = false;
	
	            if (acceptFactorChangeMode === AcceptFactorChangeMode.INCREASE) {
	                allowIncrease = true;
	            } else if (acceptFactorChangeMode === AcceptFactorChangeMode.DECREASE) {
	                allowDecrease = true;
	            } else if (acceptFactorChangeMode === AcceptFactorChangeMode.BOTH) {
	                allowIncrease = true;
	                allowDecrease = true;
	            }
	
	            var betTypeId = betType.type;
	            var betTypeRank = betType.rank;
	
	            var betId = this.props.nextKey;
	
	            var bets = [];
	            var historyBets = [];
	
	            if (betTypeId === BetTypeMap.SINGLE) {
	                betSlips.valueSeq().forEach(function (betSlip) {
	                    var id = (betId++).toString();
	                    var rate = betSlip.get('rate');
	                    var factorValue = rate.get('value');
	                    var factorId = rate.get('id');
	
	                    var transformedMap = new _immutable.List().push(Controls.transformBetSlip(betSlip));
	
	                    bets.push({
	                        id: id,
	                        type: betTypeId,
	                        rank: betTypeRank,
	                        amount: amount,
	                        factorValue: factorValue,
	                        factors: transformedMap,
	                        oneClick: false,
	                        allowIncrease: allowIncrease,
	                        allowDecrease: allowDecrease,
	                        isFreebet: isFreebet
	                    });
	
	                    var betSlipMap = new _immutable.Map().set(factorId, betSlip);
	
	                    historyBets.push({
	                        id: id,
	                        betType: betTypeId,
	                        rank: betTypeRank,
	                        amount: amount,
	                        odd: factorValue,
	                        betSlips: betSlipMap
	                    });
	                });
	            } else {
	                var id = betId.toString();
	
	                bets.push({
	                    id: id,
	                    type: betTypeId,
	                    rank: betTypeRank,
	                    amount: amount,
	                    factorValue: betType.odd,
	                    factors: Controls.transform(betSlips),
	                    oneClick: false,
	                    allowIncrease: allowIncrease,
	                    allowDecrease: allowDecrease,
	                    isFreebet: isFreebet
	                });
	
	                historyBets.push({
	                    id: id,
	                    betType: betTypeId,
	                    rank: betTypeRank,
	                    amount: amount,
	                    odd: betType.odd,
	                    betSlips: betSlips
	                });
	            }
	
	            if (this.props.user.get('isVerified') === false) {
	                window.toggleVerifyModal && window.toggleVerifyModal(true);
	            } else {
	                this.props.makeBetAction(bets, historyBets);
	            }
	            this.props.getBalanceAction({ accountId: this.props.user.get('accountId') });
	        }
	    }, {
	        key: '_onFavouriteBetAmountClick',
	        value: function _onFavouriteBetAmountClick(amount) {
	            this.props.toggleFreebetAction(false);
	            this.props.setCouponAmountAction(amount);
	            this.setState({ inActive: false, rawAmount: amount });
	        }
	    }, {
	        key: '_onAmountChange',
	        value: function _onAmountChange(e) {
	            e.preventDefault();
	
	            var minBetAmount = this.props.minBetAmount;
	
	            var rawAmount = e.target.value;
	
	            // checking for length
	            if (!rawAmount.length) {
	                this.setState({ inActive: true, rawAmount: '' });
	                this.props.setCouponAmountAction(0);
	            }
	
	            var amount = Number(rawAmount);
	
	            if (isNaN(amount)) {
	                return;
	            }
	
	            var splittedRawAmount = rawAmount.split('.');
	            var zeroSum = splittedRawAmount[0].length > 1 && amount == 0.0;
	            var longDecimalPart = splittedRawAmount[1] !== undefined && splittedRawAmount[1].length > 2;
	
	            // checking for several zeros and long decimal part of value
	            if (zeroSum || longDecimalPart) {
	                return;
	            }
	
	            // concating splitted value to normal amount
	            rawAmount = Number(splittedRawAmount[0]).toString();
	            if (splittedRawAmount[1] !== undefined) {
	                rawAmount = rawAmount + '.' + splittedRawAmount[1];
	            }
	
	            var splittedAmount = amount.toString().split('.');
	            var ceilPart = splittedAmount[0];
	            var decimalPart = splittedAmount[1] !== undefined ? splittedAmount[1] : '';
	
	            // checking for fract.num length
	            if (ceilPart.toString().length > 7 || decimalPart.toString().length > 2) {
	                return;
	            }
	
	            this.setState({ inActive: amount < minBetAmount, rawAmount: rawAmount });
	            this.props.setCouponAmountAction(amount);
	        }
	    }, {
	        key: '_onToggleFreebetClick',
	        value: function _onToggleFreebetClick(e) {
	            e.preventDefault();
	
	            var _props2 = this.props,
	                freebet = _props2.freebet,
	                isFreebet = _props2.isFreebet;
	
	
	            if (isFreebet) {
	                this.props.setCouponAmountAction(0);
	                this.props.toggleFreebetAction(false);
	                this.setState({ inActive: true, rawAmount: 0 });
	            } else {
	                var freebetAmount = freebet.get('amount');
	                this.props.setCouponAmountAction(freebetAmount);
	                this.props.toggleFreebetAction(true);
	                this.setState({ inActive: false, rawAmount: freebetAmount });
	            }
	        }
	    }, {
	        key: '_onConfirmClick',
	        value: function _onConfirmClick(changedRates, e) {
	            e.preventDefault();
	
	            this.props.acceptRateValueChangeAction(changedRates);
	            this.props.requestBetTypesAction();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                inActive = _state.inActive,
	                rawAmount = _state.rawAmount;
	            var _props3 = this.props,
	                bettingMode = _props3.bettingMode,
	                betSlips = _props3.betSlips,
	                betTypes = _props3.betTypes,
	                currentBetTypeIndex = _props3.currentBetTypeIndex,
	                bettingAvailable = _props3.bettingAvailable,
	                isFreebet = _props3.isFreebet,
	                freebetAvailable = _props3.freebetAvailable,
	                amount = _props3.amount,
	                alternativeStake = _props3.alternativeStake,
	                minBetAmount = _props3.minBetAmount,
	                maxWinAmount = _props3.maxWinAmount,
	                resourceName = _props3.resourceName,
	                countryCode = _props3.countryCode;
	
	            var currentBetType = betTypes.get(currentBetTypeIndex);
	            var betType = betTypes.get(currentBetTypeIndex);
	            var currentBetTypeIsSingle = betType && betType.type == BetTypeMap.SINGLE;
	
	            var odd = currentBetType ? currentBetType.odd : 0;
	
	            var possibleWinAmount = 0;
	
	            if (amount && !isNaN(amount)) {
	                possibleWinAmount = (amount * odd).toFixed(2);
	            }
	
	            if (betType && betType.type == BetTypeMap.SYSTEM && betType.rank !== undefined) {
	                possibleWinAmount = (amount * odd).toFixed(2);
	            }
	
	            var maxRestriction = possibleWinAmount > maxWinAmount;
	
	            var values = _CouponDropDownMenu.STAKES_VALUES[countryCode];
	            var favouriteBet1Amount = bettingMode.get('favouriteBet1Amount') || values[1];
	            var favouriteBet2Amount = bettingMode.get('favouriteBet2Amount') || values[2];
	            var favouriteBet3Amount = bettingMode.get('favouriteBet3Amount') || values[3];
	
	            var makeBetEnabled = !inActive && !maxRestriction;
	            var confirmRateChangeSpan = void 0;
	            var changedFactorRates = [];
	
	            betSlips.forEach(function (r) {
	                var rate = r.get('rate');
	                var id = rate.get('id');
	                var actualValue = rate.get('actualValue');
	
	                if ((0, _rateUtils.rateFactorChangeConfirmNeeded)(rate)) {
	                    changedFactorRates.push({ id: id, actualValue: actualValue });
	                }
	
	                if (makeBetEnabled && (0, _rateUtils.isRateUnavailable)(rate)) {
	                    makeBetEnabled = false;
	                }
	            });
	
	            if (changedFactorRates.length > 0) {
	                makeBetEnabled = false;
	                var boundConfirmClick = this._onConfirmClick.bind(this, changedFactorRates);
	
	                confirmRateChangeSpan = _react2.default.createElement(
	                    'div',
	                    { className: 'btn__accept-changes', onClick: boundConfirmClick },
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#',
	                            className: 'message-box--sell-bet__btn--confirm',
	                            onClick: boundConfirmClick },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.confirmRateValueChange)
	                    )
	                );
	            }
	
	            var cls = 'coupon--make-bet make-bet btn__orange make-bet__btn';
	            if (!makeBetEnabled || !bettingAvailable) {
	                cls += ' btn__disabled';
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'coupon-controls' },
	                _react2.default.createElement(_BetType3.default, null),
	                _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    messages.totalOdd,
	                    function (message) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'rate', title: message },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                odd.toFixed(2)
	                            )
	                        );
	                    }
	                ),
	                _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    messages.possibleWinning,
	                    function (message) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'balance', title: message },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                possibleWinAmount
	                            )
	                        );
	                    }
	                ),
	                maxRestriction && _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    (0, _extends3.default)({}, messages.maxAmountHint, {
	                        values: { amount: maxWinAmount, resource: resourceName } }),
	                    function (message) {
	                        return _react2.default.createElement(
	                            'p',
	                            { className: 'max-win-amount-hint' },
	                            message
	                        );
	                    }
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'bet-amount cf' },
	                    _react2.default.createElement('input', { ref: 'betAmount', value: rawAmount, type: 'text',
	                        readOnly: isFreebet, id: 'bet-amount', className: 'bet',
	                        onChange: this._onAmountChange, onBlur: this._onAmountChange }),
	                    inActive && _react2.default.createElement(
	                        _reactIntl.FormattedMessage,
	                        messages.minAmountHint,
	                        function (message) {
	                            return _react2.default.createElement(
	                                'p',
	                                { className: 'min-bet-amount-hint' },
	                                message,
	                                ' ',
	                                minBetAmount
	                            );
	                        }
	                    ),
	                    !inActive && !maxRestriction && currentBetTypeIsSingle && betSlips.size > 1 && _react2.default.createElement(
	                        'p',
	                        { className: 'total-rates' },
	                        ' X ',
	                        betSlips.size,
	                        ' = ',
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            amount * betSlips.size
	                        )
	                    ),
	                    freebetAvailable && _react2.default.createElement('div', { className: 'freebet--icon freebet--icon__active freebet--icon__bet-amount',
	                        onClick: this._onToggleFreebetClick })
	                ),
	                alternativeStake && _react2.default.createElement(
	                    'div',
	                    { className: 'bet-error-message' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, messages.maxAmountHint, {
	                        values: { amount: alternativeStake, resource: resourceName } }))
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'favourites-bet-amounts cf' },
	                    _react2.default.createElement(_FavouriteBetAmount2.default, { number: 1,
	                        amount: favouriteBet1Amount,
	                        callback: this._onFavouriteBetAmountClick }),
	                    _react2.default.createElement(_FavouriteBetAmount2.default, { number: 2,
	                        amount: favouriteBet2Amount,
	                        callback: this._onFavouriteBetAmountClick }),
	                    _react2.default.createElement(_FavouriteBetAmount2.default, { number: 3,
	                        amount: favouriteBet3Amount,
	                        callback: this._onFavouriteBetAmountClick })
	                ),
	                confirmRateChangeSpan,
	                _react2.default.createElement(
	                    'div',
	                    { className: cls },
	                    freebetAvailable && isFreebet && _react2.default.createElement('div', { className: 'freebet--icon freebet--icon__active freebet--icon__make-bet' }),
	                    _react2.default.createElement(
	                        _reactIntl.FormattedMessage,
	                        messages.makeBet,
	                        function (message) {
	                            return _react2.default.createElement(
	                                'a',
	                                { href: '#', className: 'coupon--make-bet__btn', onClick: _this2._onMakeBetClick },
	                                message
	                            );
	                        }
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'transform',
	        value: function transform(rates) {
	            var transformedRates = new _immutable.List();
	
	            rates.valueSeq().forEach(function (rate) {
	                transformedRates = transformedRates.push(Controls.transformBetSlip(rate));
	            });
	
	            return transformedRates;
	        }
	    }, {
	        key: 'transformBetSlip',
	        value: function transformBetSlip(betSlip) {
	            var rate = betSlip.get('rate');
	
	            return new _immutable.Map({
	                eventId: rate.get('matchId'),
	                eventTimeAndZone: betSlip.getIn(['match', 'timeAndZone']),
	                outcomeId: rate.get('outcomeId'),
	                factorId: rate.get('id'),
	                factorValue: rate.get('value'),
	                isConditional: false
	            });
	        }
	    }]);
	    return Controls;
	}(_react2.default.Component);
	
	Controls.propTypes = {
	    languageId: _react2.default.PropTypes.number.isRequired,
	    user: _react2.default.PropTypes.object,
	    betSlips: _react2.default.PropTypes.object,
	    currentBetTypeIndex: _react2.default.PropTypes.number.isRequired,
	    betTypes: _react2.default.PropTypes.object,
	    amount: _react2.default.PropTypes.number,
	    minBetAmount: _react2.default.PropTypes.number,
	    maxWinAmount: _react2.default.PropTypes.number,
	    isFreebet: _react2.default.PropTypes.bool,
	    freebetAvailable: _react2.default.PropTypes.bool,
	    freebet: _react2.default.PropTypes.object,
	    bettingMode: _react2.default.PropTypes.object,
	    nextKey: _react2.default.PropTypes.number,
	    bettingAvailable: _react2.default.PropTypes.bool.isRequired,
	    makeBetAction: _react2.default.PropTypes.func.isRequired,
	    setCouponAmountAction: _react2.default.PropTypes.func.isRequired,
	    getBalanceAction: _react2.default.PropTypes.func.isRequired,
	    acceptRateValueChangeAction: _react2.default.PropTypes.func.isRequired,
	    requestBetTypesAction: _react2.default.PropTypes.func.isRequired,
	    toggleFreebetAction: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select(state) {
	    var languageId = state.application.get('languageId');
	    var user = state.auth.get('user');
	    var bettingAvailable = state.application.get('bettingAvailable');
	    var betSlips = state.application.getIn(['coupon', 'betSlips']);
	    var betTypes = state.application.getIn(['coupon', 'betTypes']);
	    var currentBetTypeIndex = state.application.getIn(['coupon', 'currentBetTypeIndex']);
	    var amount = state.application.getIn(['coupon', 'amount']);
	    var alternativeStake = state.application.getIn(['coupon', 'alternativeStake']);
	    var freebet = state.application.getIn(['coupon', 'freebet']);
	    var isFreebetObj = state.application.getIn(['coupon', 'isFreebet']);
	    var bettingMode = state.application.getIn(['bettingMode']);
	    var betHistory = state.application.getIn(['betHistory']);
	    var isFreebet = isFreebetObj.get('isFreebet');
	    var freebetAvailable = isFreebetObj.get('freebetAvailable');
	    var nextKey = betHistory.size > 0 ? parseInt(betHistory.keySeq().maxBy(function (x) {
	        return parseInt(x);
	    })) + 1 : 1;
	    var resourceName = _accountResourceNames.resourceNames[user.get('resourceId')];
	    var minBetAmount = _StakeMinAmount.minAmount[resourceName];
	    var maxWinAmount = _StakeMaxWinAmount.maxWinAmount[resourceName];
	
	    return {
	        countryCode: state.application.get('countryCode'),
	        languageId: languageId,
	        user: user,
	        betSlips: betSlips,
	        betTypes: betTypes,
	        currentBetTypeIndex: currentBetTypeIndex,
	        amount: amount,
	        alternativeStake: alternativeStake,
	        freebet: freebet,
	        isFreebet: isFreebet,
	        freebetAvailable: freebetAvailable,
	        bettingMode: bettingMode,
	        nextKey: nextKey,
	        minBetAmount: minBetAmount,
	        maxWinAmount: maxWinAmount,
	        bettingAvailable: bettingAvailable,
	        resourceName: resourceName
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, {
	    makeBetAction: _MakeBet.makeBet, setCouponAmountAction: _CouponRate.setCouponAmount, getBalanceAction: _balanceAction.balance, acceptRateValueChangeAction: _CouponRate.acceptRateValueChange, requestBetTypesAction: _HistoryBet.requestBetTypes,
	    toggleFreebetAction: _Freebet.toggleFreebet
	})(Controls);

/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(8);
	
	var _immutable = __webpack_require__(14);
	
	var _AcceptFactorChange = __webpack_require__(333);
	
	var AcceptFactorChangeMode = _interopRequireWildcard(_AcceptFactorChange);
	
	var _MakeBet = __webpack_require__(133);
	
	var _CouponRate = __webpack_require__(72);
	
	var _balanceAction = __webpack_require__(132);
	
	var _HistoryBet = __webpack_require__(65);
	
	var _Freebet = __webpack_require__(486);
	
	var _rateUtils = __webpack_require__(505);
	
	var _BetType = __webpack_require__(503);
	
	var _BetType2 = _interopRequireDefault(_BetType);
	
	var _FavouriteBetAmount = __webpack_require__(504);
	
	var _FavouriteBetAmount2 = _interopRequireDefault(_FavouriteBetAmount);
	
	var _StakeMinAmount = __webpack_require__(135);
	
	var _StakeMaxWinAmount = __webpack_require__(496);
	
	var _accountResourceNames = __webpack_require__(59);
	
	var _CouponDropDownMenu = __webpack_require__(306);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    makeBet: {
	        id: 'coupon.make_bet',
	        defaultMessage: 'Сделать ставку'
	    },
	    confirmRateValueChange: {
	        id: 'coupon.confirm_rate_value_change',
	        defaultMessage: 'Принять'
	    },
	    totalOdd: {
	        id: 'coupon.total_odd_hint',
	        defaultMessage: 'Общий коэффициент'
	    },
	    possibleWinning: {
	        id: 'coupon.possible_winning_hint',
	        defaultMessage: 'Возможный выигрыш'
	    },
	    stake: {
	        id: 'coupon.stake_hint',
	        defaultMessage: 'Сумма ставки'
	    },
	    minAmountHint: {
	        id: 'coupon.min_amount_hint',
	        defaultMessage: 'Мин.'
	    },
	    maxAmountHint: {
	        id: 'coupon.max_amount_hint',
	        defaultMessage: 'Макс.'
	    }
	});
	
	var ControlsExt = function (_React$Component) {
	    (0, _inherits3.default)(ControlsExt, _React$Component);
	
	    function ControlsExt(props) {
	        (0, _classCallCheck3.default)(this, ControlsExt);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (ControlsExt.__proto__ || (0, _getPrototypeOf2.default)(ControlsExt)).call(this, props));
	
	        _this._onMakeBetClick = _this._onMakeBetClick.bind(_this);
	        _this._onFavouriteBetAmountClick = _this._onFavouriteBetAmountClick.bind(_this);
	        _this._onConfirmClick = _this._onConfirmClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(ControlsExt, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return nextProps.languageId !== this.props.languageId || nextProps.betSlips !== this.props.betSlips || nextProps.betSlipAmounts !== this.props.betSlipAmounts || nextProps.amount !== this.props.amount || nextProps.odd !== this.props.odd || nextProps.possibleWinAmount !== this.props.possibleWinAmount || nextProps.currentBetTypeIndex !== this.props.currentBetTypeIndex || nextProps.betTypes !== this.props.betTypes || nextProps.bettingMode !== this.props.bettingMode || nextProps.nextKey !== this.props.nextKey;
	        }
	    }, {
	        key: '_onMakeBetClick',
	        value: function _onMakeBetClick(e) {
	            e.preventDefault();
	
	            var _props = this.props,
	                betSlips = _props.betSlips,
	                betSlipAmounts = _props.betSlipAmounts,
	                bettingMode = _props.bettingMode,
	                currentBetTypeIndex = _props.currentBetTypeIndex,
	                betTypes = _props.betTypes;
	
	
	            var slipAmounts = betSlipAmounts.filter(function (slip) {
	                return slip.get('amount') <= 0.0;
	            });
	
	            if (slipAmounts.size > 0 || currentBetTypeIndex === -1) {
	                return;
	            }
	
	            var betType = betTypes.get(currentBetTypeIndex);
	            var acceptFactorChangeMode = bettingMode.get('acceptFactorChange');
	
	            var makeBetPossible = true;
	            betSlips.forEach(function (bs) {
	                var rate = bs.get('rate');
	
	                if ((0, _rateUtils.rateFactorChangeConfirmNeeded)(rate, acceptFactorChangeMode) || (0, _rateUtils.isRateUnavailable)(rate)) {
	                    makeBetPossible = false;
	                    return false;
	                }
	            });
	
	            if (!makeBetPossible) {
	                return;
	            }
	
	            var allowIncrease = false;
	            var allowDecrease = false;
	
	            if (acceptFactorChangeMode === AcceptFactorChangeMode.INCREASE) {
	                allowIncrease = true;
	            } else if (acceptFactorChangeMode === AcceptFactorChangeMode.DECREASE) {
	                allowDecrease = true;
	            } else if (acceptFactorChangeMode === AcceptFactorChangeMode.BOTH) {
	                allowIncrease = true;
	                allowDecrease = true;
	            }
	
	            var betTypeId = betType.type;
	            var betTypeRank = betType.rank;
	
	            var betId = this.props.nextKey;
	
	            var bets = [];
	            var historyBets = [];
	
	            betSlips.valueSeq().forEach(function (betSlip) {
	                var id = (betId++).toString();
	                var rate = betSlip.get('rate');
	                var factorValue = rate.get('value');
	                var factorId = rate.get('id');
	
	                var transformedMap = new _immutable.List().push(ControlsExt.transformBetSlip(betSlip));
	                var slipAmount = betSlipAmounts.getIn([factorId, 'amount'], 0);
	                var isFreebet = betSlipAmounts.getIn([factorId, 'isFreeBet'], false);
	
	                bets.push({
	                    id: id,
	                    type: betTypeId,
	                    rank: betTypeRank,
	                    amount: slipAmount,
	                    factorValue: factorValue,
	                    factors: transformedMap,
	                    oneClick: false,
	                    allowIncrease: allowIncrease,
	                    allowDecrease: allowDecrease,
	                    isFreebet: isFreebet
	                });
	
	                var betSlipMap = new _immutable.Map().set(factorId, betSlip);
	
	                historyBets.push({
	                    id: id,
	                    betType: betTypeId,
	                    rank: betTypeRank,
	                    amount: slipAmount,
	                    odd: factorValue,
	                    betSlips: betSlipMap
	                });
	            });
	
	            if (this.props.user.get('isVerified') === false) {
	                window.toggleVerifyModal && window.toggleVerifyModal(true);
	            } else {
	                this.props.makeBetAction(bets, historyBets);
	            }
	            this.props.getBalanceAction({ accountId: this.props.user.get('accountId') });
	        }
	    }, {
	        key: '_onFavouriteBetAmountClick',
	        value: function _onFavouriteBetAmountClick(amount) {
	            var betSlips = this.props.betSlips;
	
	            var slipAmounts = [];
	
	            betSlips.forEach(function (slip) {
	                var rate = slip.get('rate');
	                var rateId = rate.get('id');
	
	                slipAmounts.push({ rateId: rateId, amount: amount, isFreeBet: false });
	            });
	
	            this.props.toggleFreebetAction(false);
	            this.props.changeCouponSlipAmountAction(slipAmounts);
	        }
	    }, {
	        key: '_onConfirmClick',
	        value: function _onConfirmClick(changedRates, e) {
	            e.preventDefault();
	
	            this.props.acceptRateValueChangeAction(changedRates);
	            this.props.requestBetTypesAction();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                bettingMode = _props2.bettingMode,
	                betSlips = _props2.betSlips,
	                amount = _props2.amount,
	                odd = _props2.odd,
	                possibleWinAmount = _props2.possibleWinAmount,
	                makeBetAvailable = _props2.makeBetAvailable,
	                bettingAvailable = _props2.bettingAvailable,
	                countryCode = _props2.countryCode;
	
	
	            var values = _CouponDropDownMenu.STAKES_VALUES[countryCode];
	            var favouriteBet1Amount = bettingMode.get('favouriteBet1Amount') || values[1];
	            var favouriteBet2Amount = bettingMode.get('favouriteBet2Amount') || values[2];
	            var favouriteBet3Amount = bettingMode.get('favouriteBet3Amount') || values[3];
	
	            var makeBetEnabled = makeBetAvailable;
	            var confirmRateChangeSpan = void 0;
	            var changedFactorRates = [];
	
	            betSlips.forEach(function (r) {
	                var rate = r.get('rate');
	                var id = rate.get('id');
	                var actualValue = rate.get('actualValue');
	
	                if ((0, _rateUtils.rateFactorChangeConfirmNeeded)(rate)) {
	                    changedFactorRates.push({ id: id, actualValue: actualValue });
	                }
	
	                if (makeBetEnabled && (0, _rateUtils.isRateUnavailable)(rate)) {
	                    makeBetEnabled = false;
	                }
	            });
	
	            if (changedFactorRates.length > 0) {
	                makeBetEnabled = false;
	                var boundConfirmClick = this._onConfirmClick.bind(this, changedFactorRates);
	
	                confirmRateChangeSpan = _react2.default.createElement(
	                    'div',
	                    { className: 'btn__accept-changes', onClick: boundConfirmClick },
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#',
	                            className: 'message-box--sell-bet__btn--confirm',
	                            onClick: boundConfirmClick },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.confirmRateValueChange)
	                    )
	                );
	            }
	
	            var cls = 'coupon--make-bet make-bet btn__orange make-bet__btn';
	            if (!makeBetEnabled || !bettingAvailable) {
	                cls += ' btn__disabled';
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'coupon-controls' },
	                _react2.default.createElement(_BetType2.default, null),
	                _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    messages.totalOdd,
	                    function (message) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'rate', title: message },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                odd.toFixed(2)
	                            )
	                        );
	                    }
	                ),
	                _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    messages.possibleWinning,
	                    function (message) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'balance', title: message },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                possibleWinAmount.toFixed(2)
	                            )
	                        );
	                    }
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'bet-amount cf' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'total-rates' },
	                        _react2.default.createElement(
	                            'strong',
	                            { style: { color: '#fff' } },
	                            amount.toFixed(2)
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'favourites-bet-amounts cf' },
	                    _react2.default.createElement(_FavouriteBetAmount2.default, { number: 1,
	                        amount: favouriteBet1Amount,
	                        callback: this._onFavouriteBetAmountClick }),
	                    _react2.default.createElement(_FavouriteBetAmount2.default, { number: 2,
	                        amount: favouriteBet2Amount,
	                        callback: this._onFavouriteBetAmountClick }),
	                    _react2.default.createElement(_FavouriteBetAmount2.default, { number: 3,
	                        amount: favouriteBet3Amount,
	                        callback: this._onFavouriteBetAmountClick })
	                ),
	                confirmRateChangeSpan,
	                _react2.default.createElement(
	                    'div',
	                    { className: cls },
	                    _react2.default.createElement(
	                        _reactIntl.FormattedMessage,
	                        messages.makeBet,
	                        function (message) {
	                            return _react2.default.createElement(
	                                'a',
	                                { href: '#', className: 'coupon--make-bet__btn', onClick: _this2._onMakeBetClick },
	                                message
	                            );
	                        }
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'transformBetSlip',
	        value: function transformBetSlip(betSlip) {
	            var rate = betSlip.get('rate');
	
	            return new _immutable.Map({
	                eventId: rate.get('matchId'),
	                eventTimeAndZone: betSlip.getIn(['match', 'timeAndZone']),
	                outcomeId: rate.get('outcomeId'),
	                factorId: rate.get('id'),
	                factorValue: rate.get('value'),
	                isConditional: false
	            });
	        }
	    }]);
	    return ControlsExt;
	}(_react2.default.Component);
	
	ControlsExt.propTypes = {
	    languageId: _react2.default.PropTypes.number.isRequired,
	    user: _react2.default.PropTypes.object,
	    betSlips: _react2.default.PropTypes.object,
	    betSlipAmounts: _react2.default.PropTypes.object,
	    currentBetTypeIndex: _react2.default.PropTypes.number.isRequired,
	    betTypes: _react2.default.PropTypes.object,
	    amount: _react2.default.PropTypes.number,
	    odd: _react2.default.PropTypes.number,
	    possibleWinAmount: _react2.default.PropTypes.number,
	    makeBetAvailable: _react2.default.PropTypes.bool,
	    bettingMode: _react2.default.PropTypes.object,
	    nextKey: _react2.default.PropTypes.number,
	    bettingAvailable: _react2.default.PropTypes.bool.isRequired,
	    makeBetAction: _react2.default.PropTypes.func.isRequired,
	    getBalanceAction: _react2.default.PropTypes.func.isRequired,
	    acceptRateValueChangeAction: _react2.default.PropTypes.func.isRequired,
	    requestBetTypesAction: _react2.default.PropTypes.func.isRequired,
	    changeCouponSlipAmountAction: _react2.default.PropTypes.func.isRequired,
	    toggleFreebetAction: _react2.default.PropTypes.func.isRequired
	};
	
	
	function calcTotalAmount(betSlipAmounts) {
	    var amount = 0;
	
	    betSlipAmounts.forEach(function (value) {
	        var slipAmount = Number(value.get('amount'));
	
	        if (!isNaN(slipAmount)) {
	            amount += slipAmount;
	        }
	    });
	
	    return amount;
	}
	
	function calcTotalOdd(betSlips) {
	    var odd = 0;
	
	    betSlips.forEach(function (slip) {
	        var rate = slip.get('rate');
	        var slipOdd = Number(rate.get('value'));
	
	        if (!isNaN(slipOdd)) {
	            odd += slipOdd;
	        }
	    });
	
	    return odd;
	}
	
	function calcTotalWinning(betSlips, betSlipAmounts) {
	    var winning = 0;
	
	    betSlips.forEach(function (slip) {
	        var rate = slip.get('rate');
	        var rateId = rate.get('id');
	        var slipOdd = Number(rate.get('value'));
	        var slipamount = betSlipAmounts.has(rateId) ? betSlipAmounts.getIn([rateId, 'amount']) : 0;
	
	        if (!isNaN(slipOdd) && !isNaN(slipamount)) {
	            winning += slipOdd * slipamount;
	        }
	    });
	
	    return winning;
	}
	
	function isAvailableMakeBet(betSlips, betSlipAmounts, minvalue, maxWinValue) {
	    var slips = betSlips.toArray();
	
	    for (var offset = 0; offset < slips.length; offset++) {
	        var slip = slips[offset];
	        var rate = slip.get('rate');
	        var rateId = rate.get('id');
	        var slipOdd = Number(rate.get('value'));
	        var slipAmount = betSlipAmounts.has(rateId) ? betSlipAmounts.getIn([rateId, 'amount']) : 0;
	
	        if (isNaN(slipAmount) || slipAmount < minvalue) {
	            return false;
	        }
	
	        if (!isNaN(slipOdd) && slipAmount * slipOdd > maxWinValue) {
	            return false;
	        }
	    }
	
	    return true;
	}
	
	function select(state) {
	    var languageId = state.application.get('languageId');
	    var user = state.auth.get('user');
	    var bettingAvailable = state.application.get('bettingAvailable');
	    var betSlips = state.application.getIn(['coupon', 'betSlips']);
	    var betSlipAmounts = state.application.getIn(['coupon', 'betSlipAmounts']);
	    var betTypes = state.application.getIn(['coupon', 'betTypes']);
	    var currentBetTypeIndex = state.application.getIn(['coupon', 'currentBetTypeIndex']);
	    var bettingMode = state.application.getIn(['bettingMode']);
	    var betHistory = state.application.getIn(['betHistory']);
	
	    var resourceName = _accountResourceNames.resourceNames[user.get('resourceId')];
	    var maxWinAmount = _StakeMaxWinAmount.maxWinAmount[resourceName];
	    var minAmountValue = _StakeMinAmount.minAmount[resourceName];
	    var makeBetAvailable = isAvailableMakeBet(betSlips, betSlipAmounts, minAmountValue, maxWinAmount);
	    var amount = makeBetAvailable ? calcTotalAmount(betSlipAmounts) : 0;
	    var odd = calcTotalOdd(betSlips);
	    var possibleWinAmount = makeBetAvailable ? calcTotalWinning(betSlips, betSlipAmounts) : 0;
	
	    var nextKey = betHistory.size > 0 ? parseInt(betHistory.keySeq().maxBy(function (x) {
	        return parseInt(x);
	    })) + 1 : 1;
	
	    return {
	        countryCode: state.application.get('countryCode'),
	        languageId: languageId,
	        user: user,
	        betSlips: betSlips,
	        betSlipAmounts: betSlipAmounts,
	        betTypes: betTypes,
	        currentBetTypeIndex: currentBetTypeIndex,
	        amount: amount,
	        odd: odd,
	        possibleWinAmount: possibleWinAmount,
	        makeBetAvailable: makeBetAvailable,
	        bettingMode: bettingMode,
	        nextKey: nextKey,
	        bettingAvailable: bettingAvailable,
	        maxWinAmount: maxWinAmount
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, {
	    makeBetAction: _MakeBet.makeBet,
	    getBalanceAction: _balanceAction.balance,
	    acceptRateValueChangeAction: _CouponRate.acceptRateValueChange,
	    requestBetTypesAction: _HistoryBet.requestBetTypes,
	    changeCouponSlipAmountAction: _CouponRate.changeCouponSlipAmount,
	    toggleFreebetAction: _Freebet.toggleFreebet
	})(ControlsExt);

/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(8);
	
	var _BetType = __webpack_require__(46);
	
	var BetTypeMap = _interopRequireWildcard(_BetType);
	
	var _BetSlipList = __webpack_require__(1196);
	
	var _BetSlipList2 = _interopRequireDefault(_BetSlipList);
	
	var _Controls = __webpack_require__(1198);
	
	var _Controls2 = _interopRequireDefault(_Controls);
	
	var _UnauthControls = __webpack_require__(1201);
	
	var _UnauthControls2 = _interopRequireDefault(_UnauthControls);
	
	var _ControlsExt = __webpack_require__(1199);
	
	var _ControlsExt2 = _interopRequireDefault(_ControlsExt);
	
	var _UnauthControlsExt = __webpack_require__(1202);
	
	var _UnauthControlsExt2 = _interopRequireDefault(_UnauthControlsExt);
	
	var _CouponRate = __webpack_require__(72);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    newBet: {
	        id: 'coupon.title',
	        defaultMessage: 'Новая ставка'
	    }
	});
	
	var Coupon = function (_React$Component) {
	    (0, _inherits3.default)(Coupon, _React$Component);
	
	    function Coupon(props) {
	        (0, _classCallCheck3.default)(this, Coupon);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Coupon.__proto__ || (0, _getPrototypeOf2.default)(Coupon)).call(this, props));
	
	        _this._onClearClick = _this._onClearClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(Coupon, [{
	        key: '_onClearClick',
	        value: function _onClearClick(e) {
	            e.preventDefault();
	            this.props.removeCouponRatesAction();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                betSlips = _props.betSlips,
	                currentBetTypeIndex = _props.currentBetTypeIndex,
	                betTypes = _props.betTypes,
	                user = _props.user;
	
	            if (betSlips === undefined || betSlips.size === 0) {
	                return false;
	            }
	
	            var betType = betTypes.get(currentBetTypeIndex);
	            var isMultiSingleSlip = betSlips.size > 1 && (betType || {}).type === BetTypeMap.SINGLE;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'body coupon-body cf' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'title' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.newBet),
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#', className: 'close', onClick: this._onClearClick },
	                        '\xA0'
	                    )
	                ),
	                _react2.default.createElement(_BetSlipList2.default, { onUpdateSize: this.props.onUpdateSize }),
	                user && !isMultiSingleSlip && _react2.default.createElement(_Controls2.default, null),
	                user && isMultiSingleSlip && _react2.default.createElement(_ControlsExt2.default, null),
	                !user && !isMultiSingleSlip && _react2.default.createElement(_UnauthControls2.default, null),
	                !user && isMultiSingleSlip && _react2.default.createElement(_UnauthControlsExt2.default, null)
	            );
	        }
	    }]);
	    return Coupon;
	}(_react2.default.Component);
	
	Coupon.propTypes = {
	    betSlips: _react2.default.PropTypes.object.isRequired,
	    currentBetTypeIndex: _react2.default.PropTypes.number.isRequired,
	    betTypes: _react2.default.PropTypes.object.isRequired,
	    user: _react2.default.PropTypes.any,
	    removeCouponRatesAction: _react2.default.PropTypes.func.isRequired,
	    onUpdateSize: _react2.default.PropTypes.func.isRequired
	};
	
	function select(state) {
	    var betSlips = state.application.getIn(['coupon', 'betSlips']);
	    var currentBetTypeIndex = state.application.getIn(['coupon', 'currentBetTypeIndex']);
	    var betTypes = state.application.getIn(['coupon', 'betTypes']);
	    var user = state.auth.get('user');
	    var languageId = state.application.get('languageId');
	
	    return {
	        betSlips: betSlips,
	        currentBetTypeIndex: currentBetTypeIndex,
	        betTypes: betTypes,
	        user: user,
	        languageId: languageId
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, { removeCouponRatesAction: _CouponRate.removeCouponRates })(Coupon);

/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(8);
	
	var _immutable = __webpack_require__(14);
	
	var _BetType = __webpack_require__(46);
	
	var BetTypeMap = _interopRequireWildcard(_BetType);
	
	var _CouponRate = __webpack_require__(72);
	
	var _HistoryBet = __webpack_require__(65);
	
	var _Auth = __webpack_require__(95);
	
	var _BetType2 = __webpack_require__(503);
	
	var _BetType3 = _interopRequireDefault(_BetType2);
	
	var _FavouriteBetAmount = __webpack_require__(504);
	
	var _FavouriteBetAmount2 = _interopRequireDefault(_FavouriteBetAmount);
	
	var _StakeMinAmount = __webpack_require__(135);
	
	var _StakeMaxWinAmount = __webpack_require__(496);
	
	var _accountResourceNames = __webpack_require__(59);
	
	var _CouponDropDownMenu = __webpack_require__(306);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    makeBet: {
	        id: 'coupon.make_bet',
	        defaultMessage: 'Сделать ставку'
	    },
	    confirmRateValueChange: {
	        id: 'coupon.confirm_rate_value_change',
	        defaultMessage: 'Принять'
	    },
	    totalOdd: {
	        id: 'coupon.total_odd_hint',
	        defaultMessage: 'Общий коэффициент'
	    },
	    possibleWinning: {
	        id: 'coupon.possible_winning_hint',
	        defaultMessage: 'Возможный выигрыш'
	    },
	    stake: {
	        id: 'coupon.stake_hint',
	        defaultMessage: 'Сумма ставки'
	    },
	    minAmountHint: {
	        id: 'coupon.min_amount_hint',
	        defaultMessage: 'Мин.'
	    },
	    maxAmountHint: {
	        id: 'coupon.max_amount_hint',
	        defaultMessage: 'Макс. {amount} {resource}'
	    },
	    to_place_bet: {
	        id: 'betpanel.unauth.to_place_bet',
	        defaultMessage: 'Чтобы сделать ставку - '
	    },
	    should_auth: {
	        id: 'betpanel.unauth.should_auth',
	        defaultMessage: 'войдите'
	    },
	    should_register: {
	        id: 'betpanel.unauth.should_register',
	        defaultMessage: 'зарегистрируйтесь'
	    },
	    auth_or_register_to_bet: {
	        id: 'betpanel.unauth.auth_or_register_to_bet',
	        defaultMessage: '{signTrigger} или {joinTrigger}'
	    }
	});
	
	var UnauthControls = function (_React$Component) {
	    (0, _inherits3.default)(UnauthControls, _React$Component);
	
	    function UnauthControls(props) {
	        (0, _classCallCheck3.default)(this, UnauthControls);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (UnauthControls.__proto__ || (0, _getPrototypeOf2.default)(UnauthControls)).call(this, props));
	
	        var inActive = props.amount < props.minBetAmount;
	        var rawAmount = props.amount;
	
	        _this.state = { inActive: inActive, rawAmount: rawAmount };
	
	        _this._onAmountChange = _this._onAmountChange.bind(_this);
	        _this._onFavouriteBetAmountClick = _this._onFavouriteBetAmountClick.bind(_this);
	        _this._handleLogInClick = _this._handleLogInClick.bind(_this);
	        _this._handleJoinClick = _this._handleJoinClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(UnauthControls, [{
	        key: '_handleLogInClick',
	        value: function _handleLogInClick(e) {
	            e.preventDefault();
	            this.props.beginSignInAction();
	        }
	    }, {
	        key: '_handleJoinClick',
	        value: function _handleJoinClick(e) {
	            e.preventDefault();
	            this.props.beginJoinAction();
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return nextProps.languageId !== this.props.languageId || nextProps.betSlips !== this.props.betSlips || nextProps.amount !== this.props.amount || nextProps.currentBetTypeIndex !== this.props.currentBetTypeIndex || nextProps.betTypes !== this.props.betTypes || nextProps.bettingMode !== this.props.bettingMode || nextProps.nextKey !== this.props.nextKey || nextState.rawAmount !== this.state.rawAmount;
	        }
	    }, {
	        key: '_onFavouriteBetAmountClick',
	        value: function _onFavouriteBetAmountClick(amount) {
	            this.props.setCouponAmountAction(amount);
	            this.setState({ inActive: false, rawAmount: amount });
	        }
	    }, {
	        key: '_onAmountChange',
	        value: function _onAmountChange(e) {
	            e.preventDefault();
	
	            var minBetAmount = this.props.minBetAmount;
	
	            var rawAmount = e.target.value;
	
	            // checking for length
	            if (!rawAmount.length) {
	                this.setState({ inActive: true, rawAmount: '' });
	                this.props.setCouponAmountAction(0);
	            }
	
	            var amount = Number(rawAmount);
	
	            if (isNaN(amount)) {
	                return;
	            }
	
	            var splittedRawAmount = rawAmount.split('.');
	            var zeroSum = splittedRawAmount[0].length > 1 && amount == 0.0;
	            var longDecimalPart = splittedRawAmount[1] !== undefined && splittedRawAmount[1].length > 2;
	
	            // checking for several zeros and long decimal part of value
	            if (zeroSum || longDecimalPart) {
	                return;
	            }
	
	            // concating splitted value to normal amount
	            rawAmount = Number(splittedRawAmount[0]).toString();
	            if (splittedRawAmount[1] !== undefined) {
	                rawAmount = rawAmount + '.' + splittedRawAmount[1];
	            }
	
	            var splittedAmount = amount.toString().split('.');
	            var ceilPart = splittedAmount[0];
	            var decimalPart = splittedAmount[1] !== undefined ? splittedAmount[1] : '';
	
	            // checking for fract.num length
	            if (ceilPart.toString().length > 7 || decimalPart.toString().length > 2) {
	                return;
	            }
	
	            this.setState({ inActive: amount < minBetAmount, rawAmount: rawAmount });
	            this.props.setCouponAmountAction(amount);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                inActive = _state.inActive,
	                rawAmount = _state.rawAmount;
	            var _props = this.props,
	                bettingMode = _props.bettingMode,
	                betSlips = _props.betSlips,
	                betTypes = _props.betTypes,
	                currentBetTypeIndex = _props.currentBetTypeIndex,
	                amount = _props.amount,
	                minBetAmount = _props.minBetAmount,
	                maxWinAmount = _props.maxWinAmount,
	                resourceName = _props.resourceName,
	                countryCode = _props.countryCode;
	
	            var currentBetType = betTypes.get(currentBetTypeIndex);
	            var betType = betTypes.get(currentBetTypeIndex);
	            var currentBetTypeIsSingle = betType && betType.type == BetTypeMap.SINGLE;
	
	            var odd = currentBetType ? currentBetType.odd : 0;
	
	            var possibleWinAmount = 0;
	
	            if (amount && !isNaN(amount)) {
	                possibleWinAmount = (amount * odd).toFixed(2);
	            }
	
	            if (betType && betType.type == BetTypeMap.SYSTEM && betType.rank !== undefined) {
	                possibleWinAmount = (amount * odd).toFixed(2);
	            }
	
	            var maxRestriction = possibleWinAmount > maxWinAmount;
	
	            var values = _CouponDropDownMenu.STAKES_VALUES[countryCode];
	            var favouriteBet1Amount = bettingMode.get('favouriteBet1Amount') || values[1];
	            var favouriteBet2Amount = bettingMode.get('favouriteBet2Amount') || values[2];
	            var favouriteBet3Amount = bettingMode.get('favouriteBet3Amount') || values[3];
	
	            var signTrigger = _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                messages.should_auth,
	                function (message) {
	                    return _react2.default.createElement(
	                        'a',
	                        { className: 'trigger', onClick: _this2._handleLogInClick },
	                        message
	                    );
	                }
	            );
	
	            var joinTrigger = _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                messages.should_register,
	                function (message) {
	                    return _react2.default.createElement(
	                        'a',
	                        { className: 'trigger', onClick: _this2._handleJoinClick },
	                        message
	                    );
	                }
	            );
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'coupon-controls' },
	                _react2.default.createElement(_BetType3.default, null),
	                _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    messages.totalOdd,
	                    function (message) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'rate', title: message },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                odd.toFixed(2)
	                            )
	                        );
	                    }
	                ),
	                _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    messages.possibleWinning,
	                    function (message) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'balance', title: message },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                possibleWinAmount
	                            )
	                        );
	                    }
	                ),
	                maxRestriction && _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    (0, _extends3.default)({}, messages.maxAmountHint, {
	                        values: { amount: maxWinAmount, resource: resourceName } }),
	                    function (message) {
	                        return _react2.default.createElement(
	                            'p',
	                            { className: 'max-win-amount-hint' },
	                            message
	                        );
	                    }
	                ),
	                _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    messages.stake,
	                    function (message) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'bet-amount cf', title: message },
	                            _react2.default.createElement('input', { ref: 'betAmount', value: rawAmount, type: 'text', id: 'bet-amount', className: 'bet',
	                                onChange: _this2._onAmountChange, onBlur: _this2._onAmountChange }),
	                            _react2.default.createElement(
	                                _reactIntl.FormattedMessage,
	                                messages.minAmountHint,
	                                function (message) {
	                                    return inActive && _react2.default.createElement(
	                                        'p',
	                                        { className: 'min-bet-amount-hint' },
	                                        message,
	                                        ' ',
	                                        minBetAmount
	                                    );
	                                }
	                            ),
	                            !inActive && currentBetTypeIsSingle && betSlips.size > 1 && _react2.default.createElement(
	                                'p',
	                                { className: 'total-rates' },
	                                ' X ',
	                                betSlips.size,
	                                ' = ',
	                                _react2.default.createElement(
	                                    'strong',
	                                    null,
	                                    amount * betSlips.size
	                                )
	                            )
	                        );
	                    }
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'favourites-bet-amounts cf' },
	                    _react2.default.createElement(_FavouriteBetAmount2.default, { number: 1,
	                        amount: favouriteBet1Amount,
	                        callback: this._onFavouriteBetAmountClick }),
	                    _react2.default.createElement(_FavouriteBetAmount2.default, { number: 2,
	                        amount: favouriteBet2Amount,
	                        callback: this._onFavouriteBetAmountClick }),
	                    _react2.default.createElement(_FavouriteBetAmount2.default, { number: 3,
	                        amount: favouriteBet3Amount,
	                        callback: this._onFavouriteBetAmountClick })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'not-auth-bet-control-message' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'attention' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.to_place_bet)
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'links' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, messages.auth_or_register_to_bet, { values: { signTrigger: signTrigger, joinTrigger: joinTrigger } }))
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'transform',
	        value: function transform(rates) {
	            var transformedRates = new _immutable.List();
	
	            rates.valueSeq().forEach(function (rate) {
	                transformedRates = transformedRates.push(UnauthControls.transformBetSlip(rate));
	            });
	
	            return transformedRates;
	        }
	    }, {
	        key: 'transformBetSlip',
	        value: function transformBetSlip(betSlip) {
	            var rate = betSlip.get('rate');
	
	            return new _immutable.Map({
	                eventId: rate.get('matchId'),
	                eventTimeAndZone: betSlip.getIn(['match', 'timeAndZone']),
	                outcomeId: rate.get('outcomeId'),
	                factorId: rate.get('id'),
	                factorValue: rate.get('value'),
	                isConditional: false
	            });
	        }
	    }]);
	    return UnauthControls;
	}(_react2.default.Component);
	
	UnauthControls.propTypes = {
	    languageId: _react2.default.PropTypes.number.isRequired,
	    user: _react2.default.PropTypes.object,
	    betSlips: _react2.default.PropTypes.object,
	    currentBetTypeIndex: _react2.default.PropTypes.number.isRequired,
	    betTypes: _react2.default.PropTypes.object,
	    amount: _react2.default.PropTypes.number,
	    minBetAmount: _react2.default.PropTypes.number,
	    bettingMode: _react2.default.PropTypes.object,
	    nextKey: _react2.default.PropTypes.number,
	    setCouponAmountAction: _react2.default.PropTypes.func.isRequired,
	    requestBetTypesAction: _react2.default.PropTypes.func.isRequired,
	    beginSignInAction: _react2.default.PropTypes.func.isRequired,
	    beginJoinAction: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select(state) {
	    var defaultResourceId = 4;
	    var countryCode = state.application.get('countryCode');
	    var languageId = state.application.get('languageId');
	    var user = state.auth.get('user');
	    var betSlips = state.application.getIn(['coupon', 'betSlips']);
	    var betTypes = state.application.getIn(['coupon', 'betTypes']);
	    var currentBetTypeIndex = state.application.getIn(['coupon', 'currentBetTypeIndex']);
	    var amount = state.application.getIn(['coupon', 'amount']);
	    var bettingMode = state.application.getIn(['bettingMode']);
	    var betHistory = state.application.getIn(['betHistory']);
	    var nextKey = betHistory.size > 0 ? parseInt(betHistory.keySeq().maxBy(function (x) {
	        return parseInt(x);
	    })) + 1 : 1;
	
	    if (countryCode === 'KG') defaultResourceId = 1;
	    if (countryCode === 'UZ') defaultResourceId = 15;
	    var resourceName = user === undefined || !user ? _accountResourceNames.resourceNames[defaultResourceId] : _accountResourceNames.resourceNames[user.get('resourceId')];
	    var minBetAmount = _StakeMinAmount.minAmount[resourceName];
	    var maxWinAmount = _StakeMaxWinAmount.maxWinAmount[resourceName];
	
	    return {
	        countryCode: countryCode,
	        languageId: languageId,
	        user: user,
	        betSlips: betSlips,
	        betTypes: betTypes,
	        currentBetTypeIndex: currentBetTypeIndex,
	        amount: amount,
	        bettingMode: bettingMode,
	        nextKey: nextKey,
	        minBetAmount: minBetAmount,
	        maxWinAmount: maxWinAmount,
	        resourceName: resourceName
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, {
	    setCouponAmountAction: _CouponRate.setCouponAmount,
	    requestBetTypesAction: _HistoryBet.requestBetTypes,
	    beginSignInAction: _Auth.beginSignIn,
	    beginJoinAction: _Auth.beginJoin
	})(UnauthControls);

/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(8);
	
	var _immutable = __webpack_require__(14);
	
	var _HistoryBet = __webpack_require__(65);
	
	var _CouponRate = __webpack_require__(72);
	
	var _Auth = __webpack_require__(95);
	
	var _BetType = __webpack_require__(503);
	
	var _BetType2 = _interopRequireDefault(_BetType);
	
	var _FavouriteBetAmount = __webpack_require__(504);
	
	var _FavouriteBetAmount2 = _interopRequireDefault(_FavouriteBetAmount);
	
	var _StakeMinAmount = __webpack_require__(135);
	
	var _accountResourceNames = __webpack_require__(59);
	
	var _CouponDropDownMenu = __webpack_require__(306);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    makeBet: {
	        id: 'coupon.make_bet',
	        defaultMessage: 'Сделать ставку'
	    },
	    confirmRateValueChange: {
	        id: 'coupon.confirm_rate_value_change',
	        defaultMessage: 'Принять'
	    },
	    totalOdd: {
	        id: 'coupon.total_odd_hint',
	        defaultMessage: 'Общий коэффициент'
	    },
	    possibleWinning: {
	        id: 'coupon.possible_winning_hint',
	        defaultMessage: 'Возможный выигрыш'
	    },
	    stake: {
	        id: 'coupon.stake_hint',
	        defaultMessage: 'Сумма ставки'
	    },
	    minAmountHint: {
	        id: 'coupon.min_amount_hint',
	        defaultMessage: 'Мин.'
	    },
	    to_place_bet: {
	        id: 'betpanel.unauth.to_place_bet',
	        defaultMessage: 'Чтобы сделать ставку - '
	    },
	    should_auth: {
	        id: 'betpanel.unauth.should_auth',
	        defaultMessage: 'войдите'
	    },
	    should_register: {
	        id: 'betpanel.unauth.should_register',
	        defaultMessage: 'зарегистрируйтесь'
	    },
	    auth_or_register_to_bet: {
	        id: 'betpanel.unauth.auth_or_register_to_bet',
	        defaultMessage: '{signTrigger} или {joinTrigger}'
	    }
	});
	
	var defaultResourceId = 4;
	
	var UnauthControlsExt = function (_React$Component) {
	    (0, _inherits3.default)(UnauthControlsExt, _React$Component);
	
	    function UnauthControlsExt(props) {
	        (0, _classCallCheck3.default)(this, UnauthControlsExt);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (UnauthControlsExt.__proto__ || (0, _getPrototypeOf2.default)(UnauthControlsExt)).call(this, props));
	
	        _this._onFavouriteBetAmountClick = _this._onFavouriteBetAmountClick.bind(_this);
	        _this._handleLogInClick = _this._handleLogInClick.bind(_this);
	        _this._handleJoinClick = _this._handleJoinClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(UnauthControlsExt, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return nextProps.languageId !== this.props.languageId || nextProps.betSlips !== this.props.betSlips || nextProps.betSlipAmounts !== this.props.betSlipAmounts || nextProps.amount !== this.props.amount || nextProps.odd !== this.props.odd || nextProps.possibleWinAmount !== this.props.possibleWinAmount || nextProps.currentBetTypeIndex !== this.props.currentBetTypeIndex || nextProps.betTypes !== this.props.betTypes || nextProps.bettingMode !== this.props.bettingMode || nextProps.nextKey !== this.props.nextKey;
	        }
	    }, {
	        key: '_handleLogInClick',
	        value: function _handleLogInClick(e) {
	            e.preventDefault();
	            this.props.beginSignInAction();
	        }
	    }, {
	        key: '_handleJoinClick',
	        value: function _handleJoinClick(e) {
	            e.preventDefault();
	            this.props.beginJoinAction();
	        }
	    }, {
	        key: '_onFavouriteBetAmountClick',
	        value: function _onFavouriteBetAmountClick(amount) {
	            var betSlips = this.props.betSlips;
	
	            var slipAmounts = [];
	
	            betSlips.forEach(function (slip) {
	                var rate = slip.get('rate');
	                var rateId = rate.get('id');
	
	                slipAmounts.push({ rateId: rateId, amount: amount, isFreeBet: false });
	            });
	
	            this.props.changeCouponSlipAmountAction(slipAmounts);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                bettingMode = _props.bettingMode,
	                amount = _props.amount,
	                odd = _props.odd,
	                possibleWinAmount = _props.possibleWinAmount,
	                countryCode = _props.countryCode;
	
	
	            var values = _CouponDropDownMenu.STAKES_VALUES[countryCode];
	            var favouriteBet1Amount = bettingMode.get('favouriteBet1Amount') || values[1];
	            var favouriteBet2Amount = bettingMode.get('favouriteBet2Amount') || values[2];
	            var favouriteBet3Amount = bettingMode.get('favouriteBet3Amount') || values[3];
	
	            var signTrigger = _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                messages.should_auth,
	                function (message) {
	                    return _react2.default.createElement(
	                        'a',
	                        { className: 'trigger', onClick: _this2._handleLogInClick },
	                        message
	                    );
	                }
	            );
	
	            var joinTrigger = _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                messages.should_register,
	                function (message) {
	                    return _react2.default.createElement(
	                        'a',
	                        { className: 'trigger', onClick: _this2._handleJoinClick },
	                        message
	                    );
	                }
	            );
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'coupon-controls' },
	                _react2.default.createElement(_BetType2.default, null),
	                _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    messages.totalOdd,
	                    function (message) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'rate', title: message },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                odd.toFixed(2)
	                            )
	                        );
	                    }
	                ),
	                _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    messages.possibleWinning,
	                    function (message) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'balance', title: message },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                possibleWinAmount.toFixed(2)
	                            )
	                        );
	                    }
	                ),
	                _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    messages.stake,
	                    function (message) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'bet-amount cf', title: message },
	                            _react2.default.createElement(
	                                'p',
	                                { className: 'total-rates' },
	                                _react2.default.createElement(
	                                    'strong',
	                                    { style: { color: '#fff' } },
	                                    amount.toFixed(2)
	                                )
	                            )
	                        );
	                    }
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'favourites-bet-amounts cf' },
	                    _react2.default.createElement(_FavouriteBetAmount2.default, { number: 1,
	                        amount: favouriteBet1Amount,
	                        callback: this._onFavouriteBetAmountClick }),
	                    _react2.default.createElement(_FavouriteBetAmount2.default, { number: 2,
	                        amount: favouriteBet2Amount,
	                        callback: this._onFavouriteBetAmountClick }),
	                    _react2.default.createElement(_FavouriteBetAmount2.default, { number: 3,
	                        amount: favouriteBet3Amount,
	                        callback: this._onFavouriteBetAmountClick })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'not-auth-bet-control-message' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'attention' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.to_place_bet)
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'links' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, messages.auth_or_register_to_bet, { values: { signTrigger: signTrigger, joinTrigger: joinTrigger } }))
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'transformBetSlip',
	        value: function transformBetSlip(betSlip) {
	            var rate = betSlip.get('rate');
	
	            return new _immutable.Map({
	                eventId: rate.get('matchId'),
	                eventTimeAndZone: betSlip.getIn(['match', 'timeAndZone']),
	                outcomeId: rate.get('outcomeId'),
	                factorId: rate.get('id'),
	                factorValue: rate.get('value'),
	                isConditional: false
	            });
	        }
	    }]);
	    return UnauthControlsExt;
	}(_react2.default.Component);
	
	UnauthControlsExt.propTypes = {
	    languageId: _react2.default.PropTypes.number.isRequired,
	    user: _react2.default.PropTypes.any,
	    betSlips: _react2.default.PropTypes.object,
	    betSlipAmounts: _react2.default.PropTypes.object,
	    currentBetTypeIndex: _react2.default.PropTypes.number.isRequired,
	    betTypes: _react2.default.PropTypes.object,
	    amount: _react2.default.PropTypes.number,
	    odd: _react2.default.PropTypes.number,
	    possibleWinAmount: _react2.default.PropTypes.number,
	    makeBetAvailable: _react2.default.PropTypes.bool,
	    bettingMode: _react2.default.PropTypes.object,
	    nextKey: _react2.default.PropTypes.number,
	    requestBetTypesAction: _react2.default.PropTypes.func.isRequired,
	    changeCouponSlipAmountAction: _react2.default.PropTypes.func.isRequired,
	    beginSignInAction: _react2.default.PropTypes.func.isRequired,
	    beginJoinAction: _react2.default.PropTypes.func.isRequired
	};
	
	
	function calcTotalAmount(betSlipAmounts) {
	    var amount = 0;
	
	    betSlipAmounts.forEach(function (value) {
	        var slipAmount = Number(value.get('amount'));
	
	        if (!isNaN(slipAmount)) {
	            amount += slipAmount;
	        }
	    });
	
	    return amount;
	}
	
	function calcTotalOdd(betSlips) {
	    var odd = 0;
	
	    betSlips.forEach(function (slip) {
	        var rate = slip.get('rate');
	        var slipOdd = Number(rate.get('value'));
	
	        if (!isNaN(slipOdd)) {
	            odd += slipOdd;
	        }
	    });
	
	    return odd;
	}
	
	function calcTotalWinning(betSlips, betSlipAmounts) {
	    var winning = 0;
	
	    betSlips.forEach(function (slip) {
	        var rate = slip.get('rate');
	        var rateId = rate.get('id');
	        var slipOdd = Number(rate.get('value'));
	        var slipamount = betSlipAmounts.has(rateId) ? betSlipAmounts.getIn([rateId, 'amount']) : 0;
	
	        if (!isNaN(slipOdd) && !isNaN(slipamount)) {
	            winning += slipOdd * slipamount;
	        }
	    });
	
	    return winning;
	}
	
	function isAvailableMakeBet(betSlipAmounts, minvalue) {
	    var slipAmounts = betSlipAmounts.toArray();
	
	    for (var offset = 0; offset < slipAmounts.length; offset++) {
	        var slipAmount = Number(slipAmounts[offset].get('amount'));
	
	        if (isNaN(slipAmount) || slipAmount < minvalue) {
	            return false;
	        }
	    }
	
	    return true;
	}
	
	function select(state) {
	    var languageId = state.application.get('languageId');
	    var user = state.auth.get('user');
	    var betSlips = state.application.getIn(['coupon', 'betSlips']);
	    var betSlipAmounts = state.application.getIn(['coupon', 'betSlipAmounts']);
	    var betTypes = state.application.getIn(['coupon', 'betTypes']);
	    var currentBetTypeIndex = state.application.getIn(['coupon', 'currentBetTypeIndex']);
	    var bettingMode = state.application.getIn(['bettingMode']);
	    var betHistory = state.application.getIn(['betHistory']);
	
	    var resourceName = user === undefined || !user ? _accountResourceNames.resourceNames[defaultResourceId] : _accountResourceNames.resourceNames[user.get('resourceId')];
	    var makeBetAvailable = isAvailableMakeBet(betSlipAmounts, _StakeMinAmount.minAmount[resourceName]);
	    var amount = makeBetAvailable ? calcTotalAmount(betSlipAmounts) : 0;
	    var odd = calcTotalOdd(betSlips);
	    var possibleWinAmount = makeBetAvailable ? calcTotalWinning(betSlips, betSlipAmounts) : 0;
	
	    var nextKey = betHistory.size > 0 ? parseInt(betHistory.keySeq().maxBy(function (x) {
	        return parseInt(x);
	    })) + 1 : 1;
	
	    return {
	        countryCode: state.application.get('countryCode'),
	        languageId: languageId,
	        user: user,
	        betSlips: betSlips,
	        betSlipAmounts: betSlipAmounts,
	        betTypes: betTypes,
	        currentBetTypeIndex: currentBetTypeIndex,
	        amount: amount,
	        odd: odd,
	        possibleWinAmount: possibleWinAmount,
	        makeBetAvailable: makeBetAvailable,
	        bettingMode: bettingMode,
	        nextKey: nextKey
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, {
	    requestBetTypesAction: _HistoryBet.requestBetTypes,
	    changeCouponSlipAmountAction: _CouponRate.changeCouponSlipAmount,
	    beginSignInAction: _Auth.beginSignIn,
	    beginJoinAction: _Auth.beginJoin
	})(UnauthControlsExt);

/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var currencyMaps = {
	    1: 'kgs',
	    2: 'rub',
	    3: 'tjs',
	    4: 'kzt',
	    5: 'usd',
	    6: 'eur'
	};
	
	var AuthedSidebarWidgetContainer = function (_React$Component) {
	    (0, _inherits3.default)(AuthedSidebarWidgetContainer, _React$Component);
	
	    function AuthedSidebarWidgetContainer() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, AuthedSidebarWidgetContainer);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AuthedSidebarWidgetContainer.__proto__ || (0, _getPrototypeOf2.default)(AuthedSidebarWidgetContainer)).call.apply(_ref, [this].concat(args))), _this), _this._timeoutId = null, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(AuthedSidebarWidgetContainer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _bt2 = _bt2 || [];
	
	            _bt2.push(['server', 'https://widget02.betgames.tv']);
	            _bt2.push(['partner', 'fairplay_kz']);
	            _bt2.push(['token', this.props.betGames.get('token')]);
	            _bt2.push(['language', 'ru']);
	            _bt2.push(['currency', currencyMaps[this.props.user.get('resourceId')]]);
	            _bt2.push(['iframe_url', 'https://www.fp.kz/betgames']);
	
	            var script = document.createElement("script");
	            script.type = "text/javascript";
	            script.src = 'https://widget02.betgames.tv/js/betgames-widget.js?ts=' + Date.now() + '\'';
	            var parent = document.getElementById('BetGamesWidget_div_iframe');
	            parent.appendChild(script);
	
	            this._timeoutId = window.setTimeout(function () {
	                window.BetGamesWidget.frame(_bt2);
	            }, 3000);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this._timeoutId !== null) {
	                window.clearTimeout(this._timeoutId);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement('div', { id: 'BetGamesWidget_div_iframe' });
	        }
	    }]);
	    return AuthedSidebarWidgetContainer;
	}(_react2.default.Component);
	
	exports.default = AuthedSidebarWidgetContainer;

/***/ },
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BetGames = function (_React$Component) {
	    (0, _inherits3.default)(BetGames, _React$Component);
	
	    function BetGames() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, BetGames);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BetGames.__proto__ || (0, _getPrototypeOf2.default)(BetGames)).call.apply(_ref, [this].concat(args))), _this), _this._timeoutId = null, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(BetGames, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _bt = _bt || [];
	            // _bt.push(['server', 'https://game3.betgames.tv']);
	            _bt.push(['server', 'https://gametv.fp.kz']);
	            _bt.push(['partner', 'fairplay_kz']);
	            _bt.push(['token', this.props.betGames.get("token")]);
	            _bt.push(['language', 'ru']);
	            _bt.push(['timezone', '6']);
	
	            var script = document.createElement("script");
	
	            script.type = "text/javascript";
	            script.src = 'https://game3.betgames.tv/design/client/js/betgames.js?ts=' + Date.now() + '\'';
	            var parent = document.getElementById('betgames-wrapper');
	            parent.appendChild(script);
	
	            this._timeoutId = window.setTimeout(function () {
	                window.BetGames.frame(_bt);
	            }, 2000);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this._timeoutId !== null) {
	                window.clearTimeout(this._timeoutId);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement('div', { id: 'betgames_div_iframe', className: 'betgames-auth' });
	        }
	    }]);
	    return BetGames;
	}(_react2.default.Component);
	
	exports.default = BetGames;

/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BetgamesSidebarWidgetContainer = function (_React$Component) {
	    (0, _inherits3.default)(BetgamesSidebarWidgetContainer, _React$Component);
	
	    function BetgamesSidebarWidgetContainer() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, BetgamesSidebarWidgetContainer);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BetgamesSidebarWidgetContainer.__proto__ || (0, _getPrototypeOf2.default)(BetgamesSidebarWidgetContainer)).call.apply(_ref, [this].concat(args))), _this), _this._timeoutId = null, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(BetgamesSidebarWidgetContainer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _bt2 = _bt2 || [];
	
	            _bt2.push(['server', 'https://widget02.betgames.tv']);
	            _bt2.push(['partner', 'fairplay_kz']);
	            _bt2.push(['token', '-']);
	            _bt2.push(['language', 'ru']);
	            _bt2.push(['currency', 'kzt']);
	            _bt2.push(['iframe_url', 'https://www.fp.kz/betgames']);
	
	            var script = document.createElement("script");
	            script.type = "text/javascript";
	            script.src = 'https://widget02.betgames.tv/js/betgames-widget.js?ts=' + Date.now() + '\'';
	            var parent = document.getElementById('BetGamesWidget_div_iframe');
	            parent.appendChild(script);
	
	            this._timeoutId = window.setTimeout(function () {
	                window.BetGamesWidget.frame(_bt2);
	            }, 3000);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this._timeoutId !== null) {
	                window.clearTimeout(this._timeoutId);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement('div', { id: 'BetGamesWidget_div_iframe' });
	        }
	    }]);
	    return BetgamesSidebarWidgetContainer;
	}(_react2.default.Component);
	
	exports.default = BetgamesSidebarWidgetContainer;

/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _creators = __webpack_require__(731);
	
	var _BetgamesSidebarWidgetContainer = __webpack_require__(1205);
	
	var _BetgamesSidebarWidgetContainer2 = _interopRequireDefault(_BetgamesSidebarWidgetContainer);
	
	var _AuthedSidebarWidgetContainer = __webpack_require__(1203);
	
	var _AuthedSidebarWidgetContainer2 = _interopRequireDefault(_AuthedSidebarWidgetContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SidebarWidget = function (_React$Component) {
	    (0, _inherits3.default)(SidebarWidget, _React$Component);
	
	    function SidebarWidget() {
	        (0, _classCallCheck3.default)(this, SidebarWidget);
	        return (0, _possibleConstructorReturn3.default)(this, (SidebarWidget.__proto__ || (0, _getPrototypeOf2.default)(SidebarWidget)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(SidebarWidget, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            if (this.props.user && this.props.betGames.get('token') === undefined) {
	                this.props.getTokenAction();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.user !== nextProps.user && nextProps.user && nextProps.betGames.get('token') === undefined && nextProps.betGames.get('fetching') === false) {
	                this.props.getTokenAction();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                betGames = _props.betGames,
	                user = _props.user,
	                auth = _props.auth;
	
	            return _react2.default.createElement('div', { className: 'widget-wrapper' });
	        }
	    }]);
	    return SidebarWidget;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        auth: state.auth,
	        user: state.auth.get('user'),
	        betGames: state.betGames
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { getTokenAction: _creators.getToken })(SidebarWidget);

/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UnauthedBetGames = function (_React$Component) {
	    (0, _inherits3.default)(UnauthedBetGames, _React$Component);
	
	    function UnauthedBetGames() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, UnauthedBetGames);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = UnauthedBetGames.__proto__ || (0, _getPrototypeOf2.default)(UnauthedBetGames)).call.apply(_ref, [this].concat(args))), _this), _this._timeoutId = null, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(UnauthedBetGames, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _bt = _bt || [];
	            // _bt.push(['server', 'https://game3.betgames.tv']);
	            _bt.push(['server', 'https://gametv.fp.kz']);
	            _bt.push(['partner', 'fairplay_kz']);
	            _bt.push(['token', '-']);
	            _bt.push(['language', 'ru']);
	            _bt.push(['timezone', '6']);
	
	            var script = document.createElement("script");
	
	            script.type = "text/javascript";
	            script.src = 'https://game3.betgames.tv/design/client/js/betgames.js?ts=' + Date.now() + '\'';
	            var parent = document.getElementById('betgames-wrapper');
	            parent.appendChild(script);
	
	            this._timeoutId = window.setTimeout(function () {
	                window.BetGames.frame(_bt);
	            }, 2000);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this._timeoutId !== null) {
	                window.clearTimeout(this._timeoutId);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement('div', { id: 'betgames_div_iframe', className: 'betgames-unauth' });
	        }
	    }]);
	    return UnauthedBetGames;
	}(_react2.default.Component);
	
	exports.default = UnauthedBetGames;

/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(406);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(1409);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _reactRouter = __webpack_require__(25);
	
	var _SlotsNav = __webpack_require__(594);
	
	var _reactIntl = __webpack_require__(8);
	
	var _jacktop_constants = __webpack_require__(772);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouterRedux = __webpack_require__(23);
	
	var _jacktopGames = __webpack_require__(971);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	  games_back_to_games: {
	    id: 'games.back_to_games',
	    defaultMessage: 'Назад к списку игр'
	  },
	  black_jack: {
	    id: 'games.jacktop.black_jack',
	    defaultMessage: 'Блэкджек'
	  },
	  roulette: {
	    id: 'games.jacktop.roulette',
	    defaultMessage: 'Рулетка'
	  },
	  poker: {
	    id: 'games.jacktop.poker',
	    defaultMessage: 'Покер'
	  },
	  baccarat: {
	    id: 'games.jacktop.baccarat',
	    defaultMessage: 'Баккара'
	  }
	});
	
	var allowedCountries = ['KG', 'UZ'];
	
	var JacktopGames = function (_Component) {
	  (0, _inherits3.default)(JacktopGames, _Component);
	
	  function JacktopGames() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, JacktopGames);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = JacktopGames.__proto__ || (0, _getPrototypeOf2.default)(JacktopGames)).call.apply(_ref, [this].concat(args))), _this), _this.openAuthModal = function () {
	      return _this.props.dispatch({ type: 'BEGIN_SIGNIN' });
	    }, _this.handleGameClick = function (gameId) {
	      var _this$props = _this.props,
	          gamblerId = _this$props.gamblerId,
	          languageId = _this$props.languageId,
	          getJacktopGamesToken = _this$props.getJacktopGamesToken;
	
	
	      if (!gamblerId) {
	        return _this.openAuthModal();
	      } else {
	        getJacktopGamesToken(languageId, gameId);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(JacktopGames, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          countryCode = _props.countryCode,
	          jacktopGames = _props.jacktopGames;
	
	
	      if (!allowedCountries.includes(countryCode)) {
	        this.props.push('/');
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: { display: 'flex', flexDirection: 'column', minHeight: '90vh' } },
	        jacktopGames.fetching && _react2.default.createElement(_Loader2.default, null),
	        _react2.default.createElement(
	          'div',
	          { style: { flexGrow: 1 } },
	          _react2.default.createElement(
	            'div',
	            { className: 'slots--wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'slots__nav' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/games', className: 'slots--back', activeClassName: 'active' },
	                _react2.default.createElement(_SlotsNav.BackIcon, null),
	                _react2.default.createElement(_reactIntl.FormattedMessage, messages.games_back_to_games)
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'slots__list' },
	              (0, _entries2.default)(_jacktop_constants.jacktopConstants.games).map(function (_ref2) {
	                var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
	                    gameName = _ref3[0],
	                    gameData = _ref3[1];
	
	                return _react2.default.createElement(
	                  'div',
	                  {
	                    className: 'slots__game',
	                    key: gameName + gameData.id,
	                    onClick: function onClick() {
	                      return _this2.handleGameClick(gameData.id);
	                    }
	                  },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'slots__game--img', style: { width: '100%', objectFit: 'cover' } },
	                    _react2.default.createElement('img', { src: gameData.img, alt: gameData.id })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'slots__game--name' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages[gameName])
	                  )
	                );
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { flexShrink: 0 } },
	          this.context.footer
	        )
	      );
	    }
	  }]);
	  return JacktopGames;
	}(_react.Component);
	
	JacktopGames.contextTypes = {
	  footer: _react2.default.PropTypes.object
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  var user = state.auth.get('user');
	  var accountResourceId = user ? user.get('resourceId') : 1;
	  var gamblerId = user ? user.get('gamblerId') : null;
	
	  return {
	    user: user,
	    gamblerId: gamblerId,
	    accountResourceId: accountResourceId,
	    countryCode: state.application.get('countryCode'),
	    languageId: state.application.get('languageId'),
	    jacktopGames: state.application.get('jacktopGames')
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    getJacktopGamesToken: function getJacktopGamesToken(languageId, gameId) {
	      return dispatch((0, _jacktopGames.getJacktopGamesToken)(languageId, gameId));
	    },
	    push: function push(url) {
	      return dispatch((0, _reactRouterRedux.push)(url));
	    },
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(JacktopGames);

/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _index = __webpack_require__(773);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _doubleArrow = __webpack_require__(1681);
	
	var _doubleArrow2 = _interopRequireDefault(_doubleArrow);
	
	var _reactIntl = __webpack_require__(8);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _games = __webpack_require__(492);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	  new: {
	    id: 'games.new',
	    defaultMessage: 'Новинки'
	  }
	});
	
	var NewGames = function (_React$Component) {
	  (0, _inherits3.default)(NewGames, _React$Component);
	
	  function NewGames() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, NewGames);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = NewGames.__proto__ || (0, _getPrototypeOf2.default)(NewGames)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      loading: false
	    }, _this.clickBetsolution = function (game) {
	      _this.setState({ loading: true });
	
	      if (_this.props.gamblerId) {
	        fetch('/api/games-betsolutions/').then(function (r) {
	          return r.json();
	        }).then(function (_ref2) {
	          var token = _ref2.token;
	
	          _this.loadGame(game, token);
	        });
	      } else {
	        if (game.productId === 2) {
	          _this.loadGame(game);
	        } else {
	          _this.props.dispatch({ type: 'BEGIN_SIGNIN' });
	          _this.setState({ loading: false });
	        }
	      }
	    }, _this.loadGame = function (game, token) {
	      var config = {
	        Token: token ? token : '54D2A7CA-FD87-46D4-A5A0-6BC0372C43EE',
	        MerchantId: token ? 5096 : 105,
	        GameId: game.id,
	        ProductId: game.productId,
	        IsFreeplay: 1,
	        Lang: _this.props.languageId === 5 ? 'en-US' : 'ru-RU',
	        Platform: 'desktop',
	        IframeContainerId: 'iframeContainer',
	        IframeId: 'gameIFrame',
	        GameOpenType: 'iframe',
	        AuthUrl: token ? 'https://auth-ru.betsolutions.com/auth/auth/' : 'https://auth-tr.betsolutions.com/auth/auth/'
	      };
	      if (game.productId === 1) {
	        config.TableGamesLobbyPageId = 1;
	        if (!token) {
	          config.MerchantId = 34;
	          config.Token = '17B437DF-AB78-44CB-904F-621704BC610F';
	        }
	      }
	      if (token) {
	        config.IsFreeplay = 0;
	      }
	      (0, _games.openBetsolutionGameWindow)(config);
	      _this.setState({ loading: false });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(NewGames, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var loading = this.state.loading;
	
	      var list = _index2.default.slice(0, 5);
	      return _react2.default.createElement(
	        'div',
	        { className: 'banner' },
	        loading && _react2.default.createElement(_Loader2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'banner--title' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, messages.new),
	          _react2.default.createElement('img', { src: _doubleArrow2.default, alt: '' })
	        ),
	        list.map(function (g) {
	          return _react2.default.createElement(
	            'div',
	            {
	              key: g.id,
	              className: 'tdn',
	              onClick: function onClick() {
	                return _this2.clickBetsolution(g);
	              }
	            },
	            _react2.default.createElement(Item, (0, _extends3.default)({ className: 'banner--title' }, g))
	          );
	        })
	      );
	    }
	  }]);
	  return NewGames;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  var user = state.auth.get('user');
	  return {
	    gamblerId: user && user.get('gamblerId'),
	    languageId: state.application.get('languageId')
	  };
	})(NewGames);
	
	
	function Item(_ref3) {
	  var img = _ref3.img,
	      name = _ref3.name;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'banner_item', title: name },
	    _react2.default.createElement(
	      'div',
	      { className: 'banner_item--img' },
	      _react2.default.createElement('img', { src: img, alt: name })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'banner_item--label' },
	      name
	    )
	  );
	}

/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ = __webpack_require__(1720);
	
	var _2 = _interopRequireDefault(_);
	
	var _3 = __webpack_require__(1722);
	
	var _4 = _interopRequireDefault(_3);
	
	var _5 = __webpack_require__(1719);
	
	var _6 = _interopRequireDefault(_5);
	
	var _7 = __webpack_require__(1721);
	
	var _8 = _interopRequireDefault(_7);
	
	var _9 = __webpack_require__(1718);
	
	var _10 = _interopRequireDefault(_9);
	
	var _11 = __webpack_require__(1716);
	
	var _12 = _interopRequireDefault(_11);
	
	var _13 = __webpack_require__(1714);
	
	var _14 = _interopRequireDefault(_13);
	
	var _15 = __webpack_require__(1710);
	
	var _16 = _interopRequireDefault(_15);
	
	var _17 = __webpack_require__(1698);
	
	var _18 = _interopRequireDefault(_17);
	
	var _19 = __webpack_require__(1717);
	
	var _20 = _interopRequireDefault(_19);
	
	var _21 = __webpack_require__(1715);
	
	var _22 = _interopRequireDefault(_21);
	
	var _23 = __webpack_require__(1713);
	
	var _24 = _interopRequireDefault(_23);
	
	var _25 = __webpack_require__(1712);
	
	var _26 = _interopRequireDefault(_25);
	
	var _27 = __webpack_require__(1711);
	
	var _28 = _interopRequireDefault(_27);
	
	var _29 = __webpack_require__(1709);
	
	var _30 = _interopRequireDefault(_29);
	
	var _31 = __webpack_require__(1708);
	
	var _32 = _interopRequireDefault(_31);
	
	var _33 = __webpack_require__(1707);
	
	var _34 = _interopRequireDefault(_33);
	
	var _35 = __webpack_require__(1704);
	
	var _36 = _interopRequireDefault(_35);
	
	var _37 = __webpack_require__(1706);
	
	var _38 = _interopRequireDefault(_37);
	
	var _39 = __webpack_require__(1705);
	
	var _40 = _interopRequireDefault(_39);
	
	var _41 = __webpack_require__(1697);
	
	var _42 = _interopRequireDefault(_41);
	
	var _43 = __webpack_require__(1703);
	
	var _44 = _interopRequireDefault(_43);
	
	var _45 = __webpack_require__(1702);
	
	var _46 = _interopRequireDefault(_45);
	
	var _47 = __webpack_require__(1701);
	
	var _48 = _interopRequireDefault(_47);
	
	var _49 = __webpack_require__(1700);
	
	var _50 = _interopRequireDefault(_49);
	
	var _51 = __webpack_require__(1699);
	
	var _52 = _interopRequireDefault(_51);
	
	var _53 = __webpack_require__(1696);
	
	var _54 = _interopRequireDefault(_53);
	
	var _55 = __webpack_require__(1695);
	
	var _56 = _interopRequireDefault(_55);
	
	var _57 = __webpack_require__(1694);
	
	var _58 = _interopRequireDefault(_57);
	
	var _59 = __webpack_require__(1693);
	
	var _60 = _interopRequireDefault(_59);
	
	var _61 = __webpack_require__(1692);
	
	var _62 = _interopRequireDefault(_61);
	
	var _63 = __webpack_require__(1691);
	
	var _64 = _interopRequireDefault(_63);
	
	var _65 = __webpack_require__(1690);
	
	var _66 = _interopRequireDefault(_65);
	
	var _67 = __webpack_require__(1689);
	
	var _68 = _interopRequireDefault(_67);
	
	var _69 = __webpack_require__(1687);
	
	var _70 = _interopRequireDefault(_69);
	
	var _71 = __webpack_require__(1686);
	
	var _72 = _interopRequireDefault(_71);
	
	var _73 = __webpack_require__(1688);
	
	var _74 = _interopRequireDefault(_73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ type: "betsoft", img: _2.default, id: 817, name: "Back to Venus!" }, { type: "betsoft", img: _4.default, id: 819, name: "Monster Pop" }, { type: "betsoft", img: _6.default, id: 816, name: "Spring Tails" }, { type: "betsoft", img: _8.default, id: 818, name: "Total Overdrive" }, { type: "betsoft", img: _10.default, id: 815, name: "Super Sweets" }, { type: "betsoft", img: _12.default, id: 813, name: "Take The Bank" }, { type: "betsoft", img: _14.default, id: 811, name: "Gemmed" }, { type: "betsoft", img: _16.default, id: 806, name: "BAMBOO RUSH" }, { type: "betsoft", img: _18.default, id: 784, name: "SugarPop 2: Double Dipped" }, { type: "betsoft", img: _20.default, id: 814, name: "Dragon & Phoenix" }, { type: "betsoft", img: _22.default, id: 812, name: "Caishen’s Arrival " }, { type: "betsoft", img: _24.default, id: 810, name: "Wolf Moon Rising" }, { type: "betsoft", img: _26.default, id: 809, name: "Gold Canyon" }, { type: "betsoft", img: _28.default, id: 807, name: "Spinfinity Man" }, { type: "betsoft", img: _30.default, id: 805, name: "Viking Voyage" }, { type: "betsoft", img: _32.default, id: 804, name: "Fruitbat Crazy" }, { type: "betsoft", img: _34.default, id: 802, name: "Carnaval Forever" }, { type: "betsoft", img: _36.default, id: 798, name: "Faerie Spells" }, { type: "betsoft", img: _38.default, id: 801, name: "Yak, Yeti and Roll" }, { type: "betsoft", img: _40.default, id: 800, name: "ChilliPop" },
	// { type: "betsoft", img: game779, id: 779, name: "MAX QUEST: WRATH OF RA" },
	{ type: "betsoft", img: _44.default, id: 796, name: "Dragon Kings" }, { type: "betsoft", img: _46.default, id: 794, name: "The Golden Owl of Athena" }, { type: "betsoft", img: _48.default, id: 793, name: "Ogre Empire" }, { type: "betsoft", img: _50.default, id: 792, name: "Reels of Wealth" }, { type: "betsoft", img: _52.default, id: 788, name: "Tiger's Claw" }, { type: "betsoft", img: _54.default, id: 775, name: "Legend of the Nile" }, { type: "betsoft", img: _56.default, id: 771, name: "Stampede" }, { type: "betsoft", img: _58.default, id: 767, name: "Jumbo Joker" }, { type: "betsoft", img: _60.default, id: 763, name: "Blood Eternal" }, { type: "betsoft", img: _62.default, id: 759, name: "Giovanni's Gems" }, { type: "betsoft", img: _64.default, id: 755, name: "Fire & Steel" }, { type: "betsoft", img: _66.default, id: 751, name: "Magic Shoppe" }, { type: "betsoft", img: _68.default, id: 747, name: "The Angler" }, { type: "betsoft", img: _70.default, id: 704, name: "The SlotFather Part II" }, { type: "betsoft", img: _72.default, id: 692, name: "Fa-Fa Twins" }, { type: "betsoft", img: _74.default, id: 727, name: "Kawaii Kitty" }];

/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _SlotsNav = __webpack_require__(594);
	
	var _SlotsNav2 = _interopRequireDefault(_SlotsNav);
	
	var _index = __webpack_require__(1210);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(773);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(1213);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _slotList = __webpack_require__(1212);
	
	var _slotList2 = _interopRequireDefault(_slotList);
	
	var _NewGamesBanner = __webpack_require__(1209);
	
	var _NewGamesBanner2 = _interopRequireDefault(_NewGamesBanner);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _games = __webpack_require__(492);
	
	var _GamesRedirect = __webpack_require__(980);
	
	var _GamesRedirect2 = _interopRequireDefault(_GamesRedirect);
	
	var _GamblerInfo = __webpack_require__(737);
	
	var _reactIntl = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	  user_blocked: {
	    id: 'sign_in.errors.user_blocked',
	    defaultMessage: 'Ваша учетная запись временно заблокирована! Обратитесь в техподдержку'
	  }
	}); /* eslint-disable jsx-a11y/iframe-has-title */
	
	var SlotsGames = function (_Component) {
	  (0, _inherits3.default)(SlotsGames, _Component);
	
	  function SlotsGames() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SlotsGames);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SlotsGames.__proto__ || (0, _getPrototypeOf2.default)(SlotsGames)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      loading: false
	    }, _this.userBlockedAlert = function () {
	      return window.alert(_this.props.intl.formatMessage(messages.user_blocked));
	    }, _this.clickBetsolution = function (game) {
	      _this.setState({ loading: true });
	
	      var _this$props = _this.props,
	          gamblerInfo = _this$props.gamblerInfo,
	          gamblerId = _this$props.gamblerId;
	
	      if (gamblerInfo && gamblerInfo.data && gamblerInfo.data.IsBlocked) {
	        _this.userBlockedAlert();
	      } else if (gamblerId) {
	        fetch('/api/games-betsolutions/').then(function (r) {
	          return r.json();
	        }).then(function (_ref2) {
	          var token = _ref2.token;
	
	          _this.loadGame(game, token);
	        });
	      } else {
	        if (game.productId === 2) {
	          _this.loadGame(game);
	        } else {
	          _this.props.dispatch({ type: 'BEGIN_SIGNIN' });
	          _this.setState({ loading: false });
	        }
	      }
	    }, _this.loadGame = function (game, token) {
	      var langType = _this.props.langType;
	
	      var config = {
	        Token: token ? token : '54D2A7CA-FD87-46D4-A5A0-6BC0372C43EE',
	        MerchantId: token ? 5096 : 105,
	        Lang: langType === 'ru' ? 'ru-RU' : 'en-US',
	        GameId: game.id,
	        ProductId: game.productId,
	        IsFreeplay: 1,
	        Platform: 'desktop',
	        IframeContainerId: 'iframeContainer',
	        IframeId: 'gameIFrame',
	        GameOpenType: 'iframe',
	        AuthUrl: token ? 'https://auth-ru.betsolutions.com/auth/auth/' : 'https://auth-tr.betsolutions.com/auth/auth/'
	      };
	      if (game.productId === 1) {
	        config.TableGamesLobbyPageId = 1;
	        if (!token) {
	          config.MerchantId = 34;
	          config.Token = '17B437DF-AB78-44CB-904F-621704BC610F';
	        }
	      }
	      if (token) {
	        config.IsFreeplay = 0;
	      }
	      (0, _games.openBetsolutionGameWindow)(config);
	      _this.setState({ loading: false });
	    }, _this.clickBetsoft = function (game) {
	      var gamblerInfo = _this.props.gamblerInfo;
	
	      if (gamblerInfo && gamblerInfo.data && gamblerInfo.data.IsBlocked) {
	        _this.userBlockedAlert();
	      } else {
	        _this.props.router.push('/games/slots/betsoft/' + game.id);
	      }
	    }, _this.clickTomHorn = function (game) {
	      var gamblerInfo = _this.props.gamblerInfo;
	
	      if (gamblerInfo && gamblerInfo.data && gamblerInfo.data.IsBlocked) {
	        _this.userBlockedAlert();
	      } else {
	        _this.props.router.push('/games/slots/tom-horn/' + game.id);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SlotsGames, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          getGamblerInfo = _props.getGamblerInfo,
	          gamblerId = _props.gamblerId;
	
	
	      if (gamblerId) {
	        getGamblerInfo();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var loading = this.state.loading;
	      var _props2 = this.props,
	          languageId = _props2.languageId,
	          countryCode = _props2.countryCode,
	          gamblerInfo = _props2.gamblerInfo;
	
	      var isNotUz = countryCode !== 'UZ';
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        loading || gamblerInfo && gamblerInfo.fetching && _react2.default.createElement(_Loader2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'slots--wrapper' },
	          _react2.default.createElement(_SlotsNav2.default, { languageId: languageId, countryCode: countryCode }),
	          isNotUz && _react2.default.createElement(_NewGamesBanner2.default, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'slots__list' },
	            (0, _slotList2.default)(_index2.default, this.clickBetsoft),
	            isNotUz && (0, _slotList2.default)(_index4.default, this.clickBetsolution),
	            (0, _slotList2.default)(_index6.default, this.clickTomHorn)
	          )
	        ),
	        this.context.footer
	      );
	    }
	  }]);
	  return SlotsGames;
	}(_react.Component);
	
	SlotsGames.contextTypes = {
	  footer: _react2.default.PropTypes.object
	};
	exports.default = (0, _GamesRedirect2.default)((0, _reactRedux.connect)(function (state) {
	  var user = state.auth.get('user');
	  return {
	    gamblerId: user && user.get('gamblerId'),
	    languageId: state.application.get('languageId'),
	    countryCode: state.application.get('countryCode'),
	    gamblerInfo: state.application.get('gamblerInfo')
	  };
	}, { getGamblerInfo: _GamblerInfo.getGamblerInfo })((0, _reactIntl.injectIntl)(SlotsGames)));

/***/ },
/* 1212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var _onClick = arguments[1];
	
	  return list.map(function (item) {
	    return _react2.default.createElement(
	      "div",
	      { className: "slots__game", key: item.id, onClick: function onClick() {
	          return _onClick(item);
	        } },
	      _react2.default.createElement(
	        "div",
	        { className: "slots__game--img", title: item.name },
	        _react2.default.createElement("img", { src: item.img })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "slots__game--name" },
	        item.name
	      )
	    );
	  });
	};

/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ = __webpack_require__(1763);
	
	var _2 = _interopRequireDefault(_);
	
	var _3 = __webpack_require__(1770);
	
	var _4 = _interopRequireDefault(_3);
	
	var _5 = __webpack_require__(1771);
	
	var _6 = _interopRequireDefault(_5);
	
	var _7 = __webpack_require__(1772);
	
	var _8 = _interopRequireDefault(_7);
	
	var _9 = __webpack_require__(1773);
	
	var _10 = _interopRequireDefault(_9);
	
	var _11 = __webpack_require__(1774);
	
	var _12 = _interopRequireDefault(_11);
	
	var _13 = __webpack_require__(1775);
	
	var _14 = _interopRequireDefault(_13);
	
	var _15 = __webpack_require__(1776);
	
	var _16 = _interopRequireDefault(_15);
	
	var _17 = __webpack_require__(1777);
	
	var _18 = _interopRequireDefault(_17);
	
	var _19 = __webpack_require__(1765);
	
	var _20 = _interopRequireDefault(_19);
	
	var _21 = __webpack_require__(1761);
	
	var _22 = _interopRequireDefault(_21);
	
	var _23 = __webpack_require__(1745);
	
	var _24 = _interopRequireDefault(_23);
	
	var _25 = __webpack_require__(1744);
	
	var _26 = _interopRequireDefault(_25);
	
	var _27 = __webpack_require__(1764);
	
	var _28 = _interopRequireDefault(_27);
	
	var _29 = __webpack_require__(1753);
	
	var _30 = _interopRequireDefault(_29);
	
	var _31 = __webpack_require__(1759);
	
	var _32 = _interopRequireDefault(_31);
	
	var _33 = __webpack_require__(1754);
	
	var _34 = _interopRequireDefault(_33);
	
	var _35 = __webpack_require__(1755);
	
	var _36 = _interopRequireDefault(_35);
	
	var _37 = __webpack_require__(1752);
	
	var _38 = _interopRequireDefault(_37);
	
	var _39 = __webpack_require__(1748);
	
	var _40 = _interopRequireDefault(_39);
	
	var _41 = __webpack_require__(1760);
	
	var _42 = _interopRequireDefault(_41);
	
	var _43 = __webpack_require__(1751);
	
	var _44 = _interopRequireDefault(_43);
	
	var _45 = __webpack_require__(1750);
	
	var _46 = _interopRequireDefault(_45);
	
	var _47 = __webpack_require__(1758);
	
	var _48 = _interopRequireDefault(_47);
	
	var _49 = __webpack_require__(1747);
	
	var _50 = _interopRequireDefault(_49);
	
	var _51 = __webpack_require__(1746);
	
	var _52 = _interopRequireDefault(_51);
	
	var _53 = __webpack_require__(1762);
	
	var _54 = _interopRequireDefault(_53);
	
	var _55 = __webpack_require__(1757);
	
	var _56 = _interopRequireDefault(_55);
	
	var _57 = __webpack_require__(1756);
	
	var _58 = _interopRequireDefault(_57);
	
	var _59 = __webpack_require__(1749);
	
	var _60 = _interopRequireDefault(_59);
	
	var _61 = __webpack_require__(1766);
	
	var _62 = _interopRequireDefault(_61);
	
	var _63 = __webpack_require__(1767);
	
	var _64 = _interopRequireDefault(_63);
	
	var _65 = __webpack_require__(1769);
	
	var _66 = _interopRequireDefault(_65);
	
	var _67 = __webpack_require__(1768);
	
	var _68 = _interopRequireDefault(_67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ type: "tomhorn", img: _2.default, id: 176, name: "243 Crystal Fruits" }, { type: "tomhorn", img: _10.default, id: 200, name: "The Secret Of BA" }, { type: "tomhorn", img: _36.default, id: 160, name: "Book Of Spells" }, { type: "tomhorn", img: _14.default, id: 205, name: "243 Crystal Fruits Reversed" }, { type: "tomhorn", img: _22.default, id: 170, name: "Fire'n'Hot" }, { type: "tomhorn", img: _26.default, id: 149, name: "Dragon Egg" }, { type: "tomhorn", img: _4.default, id: 187, name: "Hot'n'Fruity" }, { type: "tomhorn", img: _64.default, id: 184, name: "Sherlock. A Scandal in Bohemia" }, { type: "tomhorn", img: _60.default, id: 154, name: "Flaming Fruit" }, { type: "tomhorn", img: _12.default, id: 203, name: "Joker Reelz" }, { type: "tomhorn", img: _16.default, id: 210, name: "Wolf Sierra" }, { type: "tomhorn", img: _58.default, id: 161, name: "Monkey 27" }, { type: "tomhorn", img: _56.default, id: 162, name: "Don Juan's Peppers" }, { type: "tomhorn", img: _18.default, id: 211, name: "Gold X" }, { type: "tomhorn", img: _68.default, id: 185, name: "Kongo Bongo" }, { type: "tomhorn", img: _34.default, id: 159, name: "Blackbeard's Quest" }, { type: "tomhorn", img: _66.default, id: 186, name: "Inca's Treasure" }, { type: "tomhorn", img: _40.default, id: 153, name: "The Cup" }, { type: "tomhorn", img: _48.default, id: 163, name: "Thrones Of Persia" }, { type: "tomhorn", img: _54.default, id: 175, name: "Pandas Run" }, { type: "tomhorn", img: _44.default, id: 156, name: "Black Mummy" }, { type: "tomhorn", img: _6.default, id: 188, name: "Diamond Hill" }, { type: "tomhorn", img: _30.default, id: 158, name: "Hot Blizzard" }, { type: "tomhorn", img: _62.default, id: 183, name: "Frozen Queen" }, { type: "tomhorn", img: _32.default, id: 165, name: "Geisha's Fan" }, { type: "tomhorn", img: _8.default, id: 189, name: "Spinball " }, { type: "tomhorn", img: _20.default, id: 180, name: "Dragon Riches" }, { type: "tomhorn", img: _24.default, id: 150, name: "Feng Fu" }, { type: "tomhorn", img: _28.default, id: 178, name: "Monster Madness" }, { type: "tomhorn", img: _38.default, id: 157, name: "Sizable Win" }, { type: "tomhorn", img: _42.default, id: 167, name: "Shaolin's Tiger" }, { type: "tomhorn", img: _46.default, id: 155, name: "Triple Joker" }, { type: "tomhorn", img: _50.default, id: 152, name: "Sky Barons" }, { type: "tomhorn", img: _52.default, id: 151, name: "Savannah King" }];

/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouterRedux = __webpack_require__(23);
	
	var _reactIntl = __webpack_require__(8);
	
	var _creators = __webpack_require__(386);
	
	var _games = __webpack_require__(492);
	
	var _balanceAction = __webpack_require__(132);
	
	var _vbl = __webpack_require__(1778);
	
	var _vbl2 = _interopRequireDefault(_vbl);
	
	var _vfac = __webpack_require__(1779);
	
	var _vfac2 = _interopRequireDefault(_vfac);
	
	var _vfcc = __webpack_require__(1781);
	
	var _vfcc2 = _interopRequireDefault(_vfcc);
	
	var _vfc = __webpack_require__(1780);
	
	var _vfc2 = _interopRequireDefault(_vfc);
	
	var _vfl = __webpack_require__(1782);
	
	var _vfl2 = _interopRequireDefault(_vfl);
	
	var _vfwc = __webpack_require__(1783);
	
	var _vfwc2 = _interopRequireDefault(_vfwc);
	
	var _SlotsNav = __webpack_require__(594);
	
	var _functions = __webpack_require__(305);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	  games_sport_vfl: {
	    id: "games.sport_vfl",
	    defaultMessage: "Футбольная лига"
	  },
	  games_sport_vfcc: {
	    id: "games.sport_vfcc",
	    defaultMessage: "Футбол Кубок чемпионов"
	  },
	  games_sport_vfwc: {
	    id: "games.sport_vfwc",
	    defaultMessage: "Футбол Чемпионат Мира"
	  },
	  games_sport_vfc: {
	    id: "games.sport_vfc",
	    defaultMessage: "Футбол Еврокубок 2020"
	  },
	  games_sport_vfac: {
	    id: "games.sport_vfac",
	    defaultMessage: "Футбол Кубок Азии"
	  },
	  games_sport_vbl: {
	    id: "games.sport_vbl",
	    defaultMessage: "Баскетбольная лига"
	  },
	  games_back_to_games: {
	    id: "games.back_to_games",
	    defaultMessage: "Назад к списку игр"
	  }
	}); /* eslint-disable react/prop-types */
	
	
	var LIST = [{
	  name: messages.games_sport_vfl,
	  img: _vfl2.default,
	  link: "vflm"
	}, {
	  name: messages.games_sport_vfcc,
	  img: _vfcc2.default,
	  link: "vfcc"
	}, {
	  name: messages.games_sport_vfwc,
	  img: _vfwc2.default,
	  link: "vfwc"
	}, {
	  name: messages.games_sport_vfc,
	  img: _vfc2.default,
	  link: "vfc"
	}, {
	  name: messages.games_sport_vfac,
	  img: _vfac2.default,
	  link: "vfas"
	}, {
	  name: messages.games_sport_vbl,
	  img: _vbl2.default,
	  link: "vbl"
	}];
	
	var VirtualSports = function (_Component) {
	  (0, _inherits3.default)(VirtualSports, _Component);
	
	  function VirtualSports() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, VirtualSports);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = VirtualSports.__proto__ || (0, _getPrototypeOf2.default)(VirtualSports)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.componentWillUnmount = function () {
	      window.removeEventListener("message", _this.listener);
	    }, _this.listener = function (_ref2) {
	      var json = _ref2.data;
	
	      var _ref3 = typeof json === "string" ? JSON.parse(json) : {},
	          type = _ref3.type,
	          data = _ref3.data;
	
	      switch (type) {
	        case "rgs-height-change":
	          return _this.setState({
	            height: data.height
	          });
	        case "rgs-betslip-place":
	          _this.props.getBalanceAction({
	            accountId: _this.props.user.get("accountId")
	          });
	          break;
	        default:
	          break;
	      }
	    }, _this.componentWillReceiveProps = function (nextProps) {
	      var _this$props = _this.props,
	          user = _this$props.user,
	          countryCode = _this$props.countryCode;
	
	      var gamblerId = user ? user.get("gamblerId") : null;
	      var resourceId = user ? user.get("resourceId") : null;
	
	      if (user !== nextProps.user && nextProps.user && (0, _functions.isAvailableGames)(countryCode, resourceId, gamblerId)) {
	        _this.props.fetchVirtualSportsGamesToken(nextProps.user.toJS());
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(VirtualSports, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var _props = this.props,
	          user = _props.user,
	          countryCode = _props.countryCode;
	
	      var gamblerId = user ? user.get("gamblerId") : null;
	      var resourceId = user ? user.get("resourceId") : null;
	
	      if (user && (0, _functions.isAvailableGames)(countryCode, resourceId, gamblerId)) {
	        this.props.fetchVirtualSportsGamesToken(user.toJS());
	      }
	
	      if (window.addEventListener) {
	        window.addEventListener("message", this.listener, false);
	      } else {
	        window.attachEvent("onmessage", this.listener);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          token = _props2.virtual.token,
	          languageId = _props2.languageId,
	          user = _props2.user;
	      var _state = this.state,
	          gameType = _state.gameType,
	          height = _state.height;
	
	      var lang = languageId === 5 ? "en" : "ru";
	      var gamblerId = user ? user.get("accountNum") : null;
	
	      if (gameType) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            {
	              onClick: function onClick() {
	                return _this2.setState({ gameType: null });
	              },
	              className: "virtual--back"
	            },
	            _react2.default.createElement(_SlotsNav.BackIcon, null),
	            _react2.default.createElement(_reactIntl.FormattedMessage, messages.games_back_to_games)
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "virtual_iframe" },
	            _react2.default.createElement("iframe", {
	              src: (0, _games.getVirtualSportsGamesURL)({
	                gameType: gameType,
	                token: token,
	                lang: lang,
	                gamblerId: gamblerId
	              }),
	              frameBorder: "0",
	              scrolling: "no",
	              height: height + "px"
	            })
	          ),
	          this.context.footer
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "games" },
	          LIST.map(function (item) {
	            return _react2.default.createElement(
	              "a",
	              {
	                onClick: function onClick() {
	                  return _this2.setState({ gameType: item.link });
	                },
	                className: "games__card",
	                key: item.link
	              },
	              _react2.default.createElement("div", {
	                className: "games__card--image",
	                style: {
	                  backgroundImage: "url(" + item.img + ")"
	                }
	              }),
	              _react2.default.createElement(
	                "div",
	                { className: "games__card--title" },
	                _react2.default.createElement(_reactIntl.FormattedMessage, item.name)
	              )
	            );
	          })
	        ),
	        this.context.footer
	      );
	    }
	  }]);
	  return VirtualSports;
	}(_react.Component);
	
	VirtualSports.contextTypes = {
	  footer: _react2.default.PropTypes.object
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.auth.get("user"),
	    countryCode: state.application.get("countryCode"),
	    languageId: state.application.get("languageId"),
	    virtual: state.games.virtual
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  fetchVirtualSportsGamesToken: _creators.fetchVirtualSportsGamesToken,
	  getBalanceAction: _balanceAction.balance,
	  push: _reactRouterRedux.push
	})(VirtualSports);

/***/ },
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _SportType = __webpack_require__(89);
	
	var SportType = _interopRequireWildcard(_SportType);
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	var _MatchScore = __webpack_require__(752);
	
	var MatchScoreType = _interopRequireWildcard(_MatchScore);
	
	var _PeriodMap = __webpack_require__(780);
	
	var _PeriodMap2 = _interopRequireDefault(_PeriodMap);
	
	var _ScoreMap = __webpack_require__(1266);
	
	var _ScoreMap2 = _interopRequireDefault(_ScoreMap);
	
	var _GroupMap = __webpack_require__(1265);
	
	var _GroupMap2 = _interopRequireDefault(_GroupMap);
	
	var _PeriodMap3 = __webpack_require__(781);
	
	var _PeriodMap4 = _interopRequireDefault(_PeriodMap3);
	
	var _ScoreMap3 = __webpack_require__(1268);
	
	var _ScoreMap4 = _interopRequireDefault(_ScoreMap3);
	
	var _GroupMap3 = __webpack_require__(1267);
	
	var _GroupMap4 = _interopRequireDefault(_GroupMap3);
	
	var _PeriodMap5 = __webpack_require__(782);
	
	var _PeriodMap6 = _interopRequireDefault(_PeriodMap5);
	
	var _ScoreMap5 = __webpack_require__(1270);
	
	var _ScoreMap6 = _interopRequireDefault(_ScoreMap5);
	
	var _GroupMap5 = __webpack_require__(1269);
	
	var _GroupMap6 = _interopRequireDefault(_GroupMap5);
	
	var _PeriodMap7 = __webpack_require__(783);
	
	var _PeriodMap8 = _interopRequireDefault(_PeriodMap7);
	
	var _GroupMap7 = __webpack_require__(1271);
	
	var _GroupMap8 = _interopRequireDefault(_GroupMap7);
	
	var _ScoreMap7 = __webpack_require__(1272);
	
	var _ScoreMap8 = _interopRequireDefault(_ScoreMap7);
	
	var _PeriodMap9 = __webpack_require__(784);
	
	var _PeriodMap10 = _interopRequireDefault(_PeriodMap9);
	
	var _GroupMap9 = __webpack_require__(1273);
	
	var _GroupMap10 = _interopRequireDefault(_GroupMap9);
	
	var _ScoreMap9 = __webpack_require__(1274);
	
	var _ScoreMap10 = _interopRequireDefault(_ScoreMap9);
	
	var _GroupMap11 = __webpack_require__(1275);
	
	var _GroupMap12 = _interopRequireDefault(_GroupMap11);
	
	var _PeriodMap11 = __webpack_require__(785);
	
	var _PeriodMap12 = _interopRequireDefault(_PeriodMap11);
	
	var _ScoreMap11 = __webpack_require__(1276);
	
	var _ScoreMap12 = _interopRequireDefault(_ScoreMap11);
	
	var _GroupMap13 = __webpack_require__(1277);
	
	var _GroupMap14 = _interopRequireDefault(_GroupMap13);
	
	var _PeriodMap13 = __webpack_require__(786);
	
	var _PeriodMap14 = _interopRequireDefault(_PeriodMap13);
	
	var _ScoreMap13 = __webpack_require__(1278);
	
	var _ScoreMap14 = _interopRequireDefault(_ScoreMap13);
	
	var _PeriodMap15 = __webpack_require__(787);
	
	var _PeriodMap16 = _interopRequireDefault(_PeriodMap15);
	
	var _GroupMap15 = __webpack_require__(1279);
	
	var _GroupMap16 = _interopRequireDefault(_GroupMap15);
	
	var _ScoreMap15 = __webpack_require__(1280);
	
	var _ScoreMap16 = _interopRequireDefault(_ScoreMap15);
	
	var _PeriodMap17 = __webpack_require__(788);
	
	var _PeriodMap18 = _interopRequireDefault(_PeriodMap17);
	
	var _ScoreMap17 = __webpack_require__(1282);
	
	var _ScoreMap18 = _interopRequireDefault(_ScoreMap17);
	
	var _GroupMap17 = __webpack_require__(1281);
	
	var _GroupMap18 = _interopRequireDefault(_GroupMap17);
	
	var _PeriodMap19 = __webpack_require__(789);
	
	var _PeriodMap20 = _interopRequireDefault(_PeriodMap19);
	
	var _ScoreMap19 = __webpack_require__(1284);
	
	var _ScoreMap20 = _interopRequireDefault(_ScoreMap19);
	
	var _GroupMap19 = __webpack_require__(1283);
	
	var _GroupMap20 = _interopRequireDefault(_GroupMap19);
	
	var _PeriodMap21 = __webpack_require__(790);
	
	var _PeriodMap22 = _interopRequireDefault(_PeriodMap21);
	
	var _ScoreMap21 = __webpack_require__(1286);
	
	var _ScoreMap22 = _interopRequireDefault(_ScoreMap21);
	
	var _GroupMap21 = __webpack_require__(1285);
	
	var _GroupMap22 = _interopRequireDefault(_GroupMap21);
	
	var _PeriodMap23 = __webpack_require__(791);
	
	var _PeriodMap24 = _interopRequireDefault(_PeriodMap23);
	
	var _GroupMap23 = __webpack_require__(1290);
	
	var _GroupMap24 = _interopRequireDefault(_GroupMap23);
	
	var _ScoreMap23 = __webpack_require__(1291);
	
	var _ScoreMap24 = _interopRequireDefault(_ScoreMap23);
	
	var _PeriodMap25 = __webpack_require__(792);
	
	var _PeriodMap26 = _interopRequireDefault(_PeriodMap25);
	
	var _ScoreMap25 = __webpack_require__(1293);
	
	var _ScoreMap26 = _interopRequireDefault(_ScoreMap25);
	
	var _GroupMap25 = __webpack_require__(1292);
	
	var _GroupMap26 = _interopRequireDefault(_GroupMap25);
	
	var _PeriodMap27 = __webpack_require__(793);
	
	var _PeriodMap28 = _interopRequireDefault(_PeriodMap27);
	
	var _GroupMap27 = __webpack_require__(1294);
	
	var _GroupMap28 = _interopRequireDefault(_GroupMap27);
	
	var _ScoreMap27 = __webpack_require__(1295);
	
	var _ScoreMap28 = _interopRequireDefault(_ScoreMap27);
	
	var _PeriodMap29 = __webpack_require__(794);
	
	var _PeriodMap30 = _interopRequireDefault(_PeriodMap29);
	
	var _GroupMap29 = __webpack_require__(1296);
	
	var _GroupMap30 = _interopRequireDefault(_GroupMap29);
	
	var _ScoreMap29 = __webpack_require__(1297);
	
	var _ScoreMap30 = _interopRequireDefault(_ScoreMap29);
	
	var _PeriodMap31 = __webpack_require__(795);
	
	var _PeriodMap32 = _interopRequireDefault(_PeriodMap31);
	
	var _GroupMap31 = __webpack_require__(1298);
	
	var _GroupMap32 = _interopRequireDefault(_GroupMap31);
	
	var _ScoreMap31 = __webpack_require__(1299);
	
	var _ScoreMap32 = _interopRequireDefault(_ScoreMap31);
	
	var _PeriodMap33 = __webpack_require__(1288);
	
	var _PeriodMap34 = _interopRequireDefault(_PeriodMap33);
	
	var _GroupMap33 = __webpack_require__(1287);
	
	var _GroupMap34 = _interopRequireDefault(_GroupMap33);
	
	var _ScoreMap33 = __webpack_require__(1289);
	
	var _ScoreMap34 = _interopRequireDefault(_ScoreMap33);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sportGroupMap = {};
	
	//import GENERIC_SCORE_MAP from '../sportGlossary/Generic/ScoreMap';
	
	sportGroupMap[SportType.BADMINTON] = _GroupMap2.default;
	sportGroupMap[SportType.BANDY] = _GroupMap4.default;
	sportGroupMap[SportType.BASKETBALL] = _GroupMap6.default;
	sportGroupMap[SportType.BASKTBALL_NCAA] = _GroupMap8.default;
	sportGroupMap[SportType.BEACH_VOLLEYBALL] = _GroupMap10.default;
	sportGroupMap[SportType.BIATHLON] = _GroupMap12.default;
	sportGroupMap[SportType.BOX] = _GroupMap14.default;
	sportGroupMap[SportType.CYBER_SPORTS_DOTA2] = _GroupMap16.default;
	sportGroupMap[SportType.FOOTBALL] = _GroupMap18.default;
	sportGroupMap[SportType.HANDBALL] = _GroupMap20.default;
	sportGroupMap[SportType.ICE_HOCKEY] = _GroupMap22.default;
	sportGroupMap[SportType.TABLE_TENNIS] = _GroupMap24.default;
	sportGroupMap[SportType.TENNIS] = _GroupMap26.default;
	sportGroupMap[SportType.VOLLEYBALL] = _GroupMap28.default;
	sportGroupMap[SportType.WATER_POLLO] = _GroupMap30.default;
	sportGroupMap[SportType.WHAT_WHERE_WHEN] = _GroupMap32.default;
	sportGroupMap[SportType.MARTIAL_ARTS] = _GroupMap34.default;
	
	var sportPeriodMap = {};
	sportPeriodMap[SportType.BADMINTON] = _PeriodMap2.default;
	sportPeriodMap[SportType.BANDY] = _PeriodMap4.default;
	sportPeriodMap[SportType.BASKETBALL] = _PeriodMap6.default;
	sportPeriodMap[SportType.BASKTBALL_NCAA] = _PeriodMap8.default;
	sportPeriodMap[SportType.BEACH_VOLLEYBALL] = _PeriodMap10.default;
	sportPeriodMap[SportType.BIATHLON] = _PeriodMap12.default;
	sportPeriodMap[SportType.BOX] = _PeriodMap14.default;
	sportPeriodMap[SportType.CYBER_SPORTS_DOTA2] = _PeriodMap16.default;
	sportPeriodMap[SportType.FOOTBALL] = _PeriodMap18.default;
	sportPeriodMap[SportType.HANDBALL] = _PeriodMap20.default;
	sportPeriodMap[SportType.ICE_HOCKEY] = _PeriodMap22.default;
	sportPeriodMap[SportType.TABLE_TENNIS] = _PeriodMap24.default;
	sportPeriodMap[SportType.TENNIS] = _PeriodMap26.default;
	sportPeriodMap[SportType.VOLLEYBALL] = _PeriodMap28.default;
	sportPeriodMap[SportType.WATER_POLLO] = _PeriodMap30.default;
	sportPeriodMap[SportType.WHAT_WHERE_WHEN] = _PeriodMap32.default;
	sportPeriodMap[SportType.MARTIAL_ARTS] = _PeriodMap34.default;
	
	var scoreRepresentation = {};
	scoreRepresentation[SportType.BADMINTON] = _ScoreMap2.default;
	scoreRepresentation[SportType.BANDY] = _ScoreMap4.default;
	scoreRepresentation[SportType.BASKETBALL] = _ScoreMap6.default;
	scoreRepresentation[SportType.BASKTBALL_NCAA] = _ScoreMap8.default;
	scoreRepresentation[SportType.BEACH_VOLLEYBALL] = _ScoreMap10.default;
	scoreRepresentation[SportType.BIATHLON] = _ScoreMap12.default;
	scoreRepresentation[SportType.BOX] = _ScoreMap14.default;
	scoreRepresentation[SportType.CYBER_SPORTS_DOTA2] = _ScoreMap16.default;
	scoreRepresentation[SportType.FOOTBALL] = _ScoreMap18.default;
	scoreRepresentation[SportType.HANDBALL] = _ScoreMap20.default;
	scoreRepresentation[SportType.ICE_HOCKEY] = _ScoreMap22.default;
	scoreRepresentation[SportType.TABLE_TENNIS] = _ScoreMap24.default;
	scoreRepresentation[SportType.TENNIS] = _ScoreMap26.default;
	scoreRepresentation[SportType.VOLLEYBALL] = _ScoreMap28.default;
	scoreRepresentation[SportType.WATER_POLLO] = _ScoreMap30.default;
	scoreRepresentation[SportType.WHAT_WHERE_WHEN] = _ScoreMap32.default;
	scoreRepresentation[SportType.MARTIAL_ARTS] = _ScoreMap34.default;
	
	var _class = function () {
	    function _class() {
	        (0, _classCallCheck3.default)(this, _class);
	    }
	
	    (0, _createClass3.default)(_class, null, [{
	        key: 'getGroupScores',
	        value: function getGroupScores(match, groupTypeId, scores) {
	            var groupScores = [];
	
	            var realSportId = match.get('realSportId');
	
	            var period = match.get('period');
	            if (!period) {
	                return groupScores;
	            }
	
	            var periodId = period.get('id');
	
	            var sportPeriods = sportPeriodMap[realSportId];
	            if (!sportPeriods) {
	                return groupScores;
	            }
	
	            var matchPhase = sportPeriods[periodId];
	            if (matchPhase === undefined) {
	                return groupScores;
	            }
	
	            var sportScoresRepresentation = scoreRepresentation[realSportId];
	            if (!sportScoresRepresentation) {
	                return groupScores;
	            }
	
	            var matchPhaseScoreRepresentation = sportScoresRepresentation[matchPhase];
	
	            if (!matchPhaseScoreRepresentation) {
	                return groupScores;
	            }
	
	            var sportGroups = sportGroupMap[realSportId];
	            if (!sportGroups) {
	                return groupScores;
	            }
	
	            var sportGroupType = sportGroups[groupTypeId];
	
	            if (sportGroupType === undefined) {
	                return groupScores;
	            }
	
	            var groupScoreRepresentation = matchPhaseScoreRepresentation[sportGroupType];
	
	            if (!groupScoreRepresentation) {
	                return groupScores;
	            }
	
	            if (groupScoreRepresentation.info && matchPhase !== Period.FINISHED) {
	                groupScores.push({
	                    type: MatchScoreType.INFO,
	                    value: groupScoreRepresentation.info
	                });
	            }
	
	            if (groupScoreRepresentation.period_info && matchPhase >= Period.NOT_STARTED && matchPhase <= Period.FINISHED) {
	                groupScores.push({
	                    type: MatchScoreType.PERIOD_INFO,
	                    value: groupScoreRepresentation.period_info,
	                    sportId: realSportId,
	                    periodId: periodId
	                });
	            }
	
	            if (!groupScoreRepresentation.main) {
	                return groupScores;
	            }
	
	            var matchScores = match.get('scores');
	
	            var scoreId = matchScores.get(groupScoreRepresentation.main);
	            if (!scoreId) {
	                return groupScores;
	            }
	
	            var mainScore = {
	                type: MatchScoreType.MAIN,
	                value: scores.get(scoreId)
	            };
	
	            groupScores.push(mainScore);
	
	            if (groupScoreRepresentation.additional) {
	                var additional = [];
	
	                for (var i = 0; i < groupScoreRepresentation.additional.length; i++) {
	                    var scoreType = groupScoreRepresentation.additional[i];
	                    var score = scores.get(matchScores.get(scoreType));
	
	                    if (score && score.get('score1') !== null && score.get('score1') !== undefined && score.get('score2') !== null && score.get('score2') !== undefined) {
	                        additional.push(score);
	                    }
	                }
	
	                if (additional.length > 0) {
	                    groupScores.push({
	                        type: MatchScoreType.ADDITIONAL,
	                        value: additional
	                    });
	                }
	            }
	
	            if (groupScoreRepresentation.currentGame) {
	                var currentGameScoreId = matchScores.get(groupScoreRepresentation.currentGame);
	
	                if (currentGameScoreId) {
	                    groupScores.push({
	                        type: MatchScoreType.CURRENT_GAME,
	                        value: scores.get(currentGameScoreId)
	                    });
	                }
	            }
	
	            if (groupScoreRepresentation.overtime) {
	                var overtimeScoreId = matchScores.get(groupScoreRepresentation.overtime);
	
	                if (overtimeScoreId) {
	                    groupScores.push({
	                        type: MatchScoreType.OVERTIME,
	                        value: scores.get(overtimeScoreId)
	                    });
	                }
	            }
	
	            if (groupScoreRepresentation.fouls) {
	                var foulsScoreId = matchScores.get(groupScoreRepresentation.fouls);
	
	                if (foulsScoreId) {
	                    groupScores.push({
	                        type: MatchScoreType.FOULS,
	                        value: scores.get(foulsScoreId)
	                    });
	                }
	            }
	
	            if (groupScoreRepresentation.possession) {
	                var possessionScoreId = matchScores.get(groupScoreRepresentation.possession);
	
	                if (possessionScoreId) {
	                    var _score = scores.get(possessionScoreId);
	                    var team = _score.get('team');
	                    if (team !== undefined) {
	                        var mainScoreOffset = groupScores.indexOf(mainScore);
	
	                        if (mainScoreOffset !== -1) {
	                            mainScore.possession = team;
	                            groupScores[mainScoreOffset] = mainScore;
	                        }
	                    }
	                }
	            }
	
	            if (groupScoreRepresentation.info && matchPhase === Period.FINISHED) {
	                groupScores.push({
	                    type: MatchScoreType.INFO,
	                    value: groupScoreRepresentation.info
	                });
	            }
	
	            if (groupScoreRepresentation.powerplay) {
	                var powerPlayScoreId = matchScores.get(groupScoreRepresentation.powerplay);
	
	                if (powerPlayScoreId) {
	                    var _score2 = scores.get(powerPlayScoreId);
	                    var _team = _score2.get('team');
	                    if (_team !== undefined) {
	                        var _mainScoreOffset = groupScores.indexOf(mainScore);
	
	                        if (_mainScoreOffset !== -1) {
	                            mainScore.powerplay = _team;
	                            groupScores[_mainScoreOffset] = mainScore;
	                        }
	                    }
	                }
	            }
	
	            return groupScores;
	        }
	    }]);
	    return _class;
	}();

	exports.default = _class;

/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(8);
	
	var _Leagues = __webpack_require__(1219);
	
	var _Leagues2 = _interopRequireDefault(_Leagues);
	
	var _LiveMenu = __webpack_require__(1220);
	
	var _LiveMenu2 = _interopRequireDefault(_LiveMenu);
	
	var _PreMatchMenu = __webpack_require__(1222);
	
	var _PreMatchMenu2 = _interopRequireDefault(_PreMatchMenu);
	
	var _reactPerfectScrollbar = __webpack_require__(547);
	
	var _reactPerfectScrollbar2 = _interopRequireDefault(_reactPerfectScrollbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	  live_matches: {
	    id: 'grid.header.live.matches',
	    defaultMessage: 'Live матчи'
	  },
	  event: {
	    id: 'grid.header.event',
	    defaultMessage: 'Ставки на спорт'
	  },
	  live_bets_online: {
	    id: 'grid.header.live_bets_online',
	    defaultMessage: ' live ставки онлайн'
	  },
	  football: {
	    id: 'grid.header.football',
	    defaultMessage: 'Футбол'
	  },
	  tennis: {
	    id: 'grid.header.tennis',
	    defaultMessage: 'Теннис'
	  },
	  volleyball: {
	    id: 'grid.header.volleyball',
	    defaultMessage: 'Волейбол'
	  },
	  handball: {
	    id: 'grid.header.handball',
	    defaultMessage: 'Гандбол'
	  },
	  hockey: {
	    id: 'grid.header.hockey',
	    defaultMessage: 'Хоккей'
	  },
	  cyberSport: {
	    id: 'grid.header.cybersport',
	    defaultMessage: 'Киберспорт'
	  },
	  basketball: {
	    id: 'grid.header.basketball',
	    defaultMessage: 'Баскетбол'
	  },
	  boxing: {
	    id: "grid.header.boxing",
	    defineMessages: "Ставки на бокс онлайн"
	  },
	  UFC_MMA: {
	    id: "grid.header.UFC_MMA",
	    defineMessages: "Ставки на UFC и MMA онлайн"
	  },
	  american_football: {
	    id: "grid.header.american_football",
	    defineMessages: "Ставки на американский футбол онлайн"
	  },
	  table_tennis: {
	    id: "grid.header.table_tennis",
	    defineMessages: "Ставки на настольный теннис онлайн"
	  },
	  win1: {
	    id: 'grid.header.win1',
	    defaultMessage: 'П1'
	  },
	  draw: {
	    id: 'grid.header.draw',
	    defaultMessage: 'X'
	  },
	  win2: {
	    id: 'grid.header.win2',
	    defaultMessage: 'П2'
	  },
	  win1draw: {
	    id: 'grid.header.win1_draw',
	    defaultMessage: '1X'
	  },
	  win12: {
	    id: 'grid.header.win12',
	    defaultMessage: '12'
	  },
	  drawWin2: {
	    id: 'grid.header.draw_win2',
	    defaultMessage: 'X2'
	  },
	  handicap: {
	    id: 'grid.header.handicap',
	    defaultMessage: 'ФОРА'
	  },
	  handicap1: {
	    id: 'grid.header.handicap1',
	    defaultMessage: '1'
	  },
	  handicap2: {
	    id: 'grid.header.handicap2',
	    defaultMessage: '2'
	  },
	  under: {
	    id: 'grid.header.under',
	    defaultMessage: 'МЕН'
	  },
	  total: {
	    id: 'grid.header.total',
	    defaultMessage: 'ТОТ'
	  },
	  over: {
	    id: 'grid.header.over',
	    defaultMessage: 'БОЛ'
	  },
	  allTime: {
	    id: 'grid.menu.prematch_filter.all_time',
	    defaultMessage: 'За всё время'
	  },
	  nextHour: {
	    id: 'grid.menu.prematch_filter.next_hour',
	    defaultMessage: 'Ближайший час'
	  },
	  next2Hours: {
	    id: 'grid.menu.prematch_filter.next_2_hours',
	    defaultMessage: 'Ближайшие 2 часа'
	  },
	  next4Hours: {
	    id: 'grid.menu.prematch_filter.next_4_hours',
	    defaultMessage: 'Ближайшие 4 часа'
	  },
	  next6Hours: {
	    id: 'grid.menu.prematch_filter.next_6_hours',
	    defaultMessage: 'Ближайшие 6 часов'
	  },
	  next12Hours: {
	    id: 'grid.menu.prematch_filter.next_12_hours',
	    defaultMessage: 'Ближайшие 12 часов'
	  },
	  nextDay: {
	    id: 'grid.menu.prematch_filter.next_day',
	    defaultMessage: 'Ближайший день'
	  },
	  next2Days: {
	    id: 'grid.menu.prematch_filter.next_2_days',
	    defaultMessage: 'Ближайшие 2 дня'
	  }
	});
	
	var HeaderItem = function HeaderItem(_ref) {
	  var message = _ref.message;
	  return _react2.default.createElement(
	    _reactIntl.FormattedMessage,
	    message,
	    function (m) {
	      return _react2.default.createElement(
	        'span',
	        { className: 'cell cell-outcomes' },
	        m
	      );
	    }
	  );
	};
	
	var Grid = function (_React$Component) {
	  (0, _inherits3.default)(Grid, _React$Component);
	
	  function Grid(props) {
	    (0, _classCallCheck3.default)(this, Grid);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Grid.__proto__ || (0, _getPrototypeOf2.default)(Grid)).call(this, props));
	
	    _this.state = { showMenu: false, filter: null };
	
	    _this._handleMenuClose = _this._handleMenuClose.bind(_this);
	    _this._handleShowMenuClick = _this._handleShowMenuClick.bind(_this);
	    _this._handleExpandAllMatchesClick = _this._handleExpandAllMatchesClick.bind(_this);
	    _this._handleCollapseAllMatchesClick = _this._handleCollapseAllMatchesClick.bind(_this);
	    _this._handleExpandAllGroupsClick = _this._handleExpandAllGroupsClick.bind(_this);
	    _this._handleCollapseAllGroupsClick = _this._handleCollapseAllGroupsClick.bind(_this);
	    _this._handleDisplayLineNumbersClick = _this._handleDisplayLineNumbersClick.bind(_this);
	    _this._handleHideLineNumbersClick = _this._handleHideLineNumbersClick.bind(_this);
	
	    _this._handleFilterClick = _this._handleFilterClick.bind(_this);
	
	    _this._handleWidthAdjust = _this._handleWidthAdjust.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Grid, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._widthAdjustmentInterval = window.setInterval(this._handleWidthAdjust, 500);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._widthAdjustmentInterval) {
	        window.clearInterval(this._widthAdjustmentInterval);
	      }
	    }
	  }, {
	    key: '_handleMenuClose',
	    value: function _handleMenuClose() {
	      var state = this.state;
	
	      this.setState((0, _extends3.default)({}, state, {
	        showMenu: false
	      }));
	    }
	  }, {
	    key: '_handleShowMenuClick',
	    value: function _handleShowMenuClick(e) {
	      e.preventDefault();
	
	      var state = this.state;
	
	      this.setState((0, _extends3.default)({}, state, {
	        showMenu: true
	      }));
	    }
	  }, {
	    key: '_handleExpandAllMatchesClick',
	    value: function _handleExpandAllMatchesClick(e) {
	      e.preventDefault();
	
	      this.props.expandAllMatchesAction();
	    }
	  }, {
	    key: '_handleCollapseAllMatchesClick',
	    value: function _handleCollapseAllMatchesClick(e) {
	      e.preventDefault();
	
	      this.props.collapseAllMatchesAction();
	    }
	  }, {
	    key: '_handleExpandAllGroupsClick',
	    value: function _handleExpandAllGroupsClick(e) {
	      e.preventDefault();
	
	      this.props.expandAllGroupsAction();
	    }
	  }, {
	    key: '_handleCollapseAllGroupsClick',
	    value: function _handleCollapseAllGroupsClick(e) {
	      e.preventDefault();
	
	      this.props.collapseAllGroupsAction();
	    }
	  }, {
	    key: '_handleDisplayLineNumbersClick',
	    value: function _handleDisplayLineNumbersClick(e) {
	      e.preventDefault();
	
	      this.props.showLineNumbersAction(this.props.section);
	    }
	  }, {
	    key: '_handleHideLineNumbersClick',
	    value: function _handleHideLineNumbersClick(e) {
	      e.preventDefault();
	
	      this.props.hideLineNumbersAction(this.props.section);
	    }
	  }, {
	    key: '_handleWidthAdjust',
	    value: function _handleWidthAdjust() {
	      var contentWidth = this.refs.content.offsetWidth;
	      var contentHeight = this.refs.content.offsetHeight;
	      var titleWidth = this.refs.title.offsetWidth;
	
	      if (contentHeight !== this.state.contentHeight) {
	        this.setState({ contentHeight: contentHeight });
	        this.refs._scrollBarRef.updateScroll();
	      }
	
	      if (contentWidth !== titleWidth) {
	        this.refs.title.style.width = contentWidth + 'px';
	      }
	    }
	  }, {
	    key: '_handleFilterClick',
	    value: function _handleFilterClick(filter) {
	      var state = this.state;
	      this.props.changeFilter(filter);
	      this.setState((0, _extends3.default)({}, state, {
	        filter: filter
	      }));
	    }
	  }, {
	    key: 'getPageH1',
	    value: function getPageH1(sportId) {
	      var formattedMessage = function formattedMessage(h1, phrase) {
	        var title = _react2.default.createElement(_reactIntl.FormattedMessage, h1);
	        var message = phrase ? _react2.default.createElement(_reactIntl.FormattedMessage, messages.live_bets_online) : null;
	
	        return _react2.default.createElement(
	          'h1',
	          { style: { display: 'inline-block' } },
	          title,
	          message
	        );
	      };
	      switch (sportId) {
	        case '4':
	          {
	            return formattedMessage(messages.volleyball, true);
	          }
	        case '6':
	          {
	            return formattedMessage(messages.tennis, true);
	          }
	        case '7':
	          {
	            return formattedMessage(messages.football, true);
	          }
	        case '19':
	          {
	            return formattedMessage(messages.handball, true);
	          }
	        case '30':
	          {
	            return formattedMessage(messages.hockey, true);
	          }
	        case '31':
	          {
	            return formattedMessage(messages.basketball, true);
	          }
	        case '38':
	          {
	            return formattedMessage(messages.cyberSport, true);
	          }
	        case '5':
	          {
	            return formattedMessage(messages.boxing);
	          }
	        case '39':
	          {
	            return formattedMessage(messages.UFC_MMA);
	          }
	        case '11':
	          {
	            return formattedMessage(messages.american_football);
	          }
	        case '2':
	          {
	            return formattedMessage(messages.table_tennis);
	          }
	        default:
	          {
	            return formattedMessage(messages.event);
	          }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          section = _props.section,
	          gridLocalization = _props.gridLocalization,
	          matchId = _props.matchId,
	          gridSelection = _props.gridSelection,
	          selectionToggleMatchAction = _props.selectionToggleMatchAction,
	          sportId = _props.sportId;
	      var _state = this.state,
	          showMenu = _state.showMenu,
	          filter = _state.filter;
	
	
	      var selectedTitle = messages.allTime;
	      switch (filter) {
	        case 1:
	          selectedTitle = messages.nextHour;
	          break;
	        case 2:
	          selectedTitle = messages.next2Hours;
	          break;
	        case 4:
	          selectedTitle = messages.next4Hours;
	          break;
	        case 6:
	          selectedTitle = messages.next6Hours;
	          break;
	        case 12:
	          selectedTitle = messages.next12Hours;
	          break;
	        case 24:
	          selectedTitle = messages.nextDay;
	          break;
	        case 48:
	          selectedTitle = messages.next2Days;
	          break;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'live-content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'live-titles scroll--top', ref: 'title' },
	          _react2.default.createElement(
	            'div',
	            { className: 'table main-heading' },
	            section === 'live' && _react2.default.createElement(
	              'a',
	              { href: '#', className: 'events-toggle', onClick: this._handleShowMenuClick },
	              '\xA0'
	            ),
	            section === 'live' && showMenu && _react2.default.createElement(_LiveMenu2.default, { onShowClickCallback: this._handleShowMenuClick,
	              onCollapseAllMatchesClick: this._handleCollapseAllMatchesClick,
	              onExpandAllMatchesClick: this._handleExpandAllMatchesClick,
	              onCollapseAllGroupsClick: this._handleCollapseAllGroupsClick,
	              onExpandAllGroupsClick: this._handleExpandAllGroupsClick,
	              onDisplayLineNumbersClick: this._handleDisplayLineNumbersClick,
	              onHideLineNumbersClick: this._handleHideLineNumbersClick,
	              onClosing: this._handleMenuClose
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'span',
	                { className: 'cell main' },
	                section === 'live' && _react2.default.createElement(
	                  _reactIntl.FormattedMessage,
	                  messages.live_matches,
	                  function (title) {
	                    return _react2.default.createElement(
	                      'h1',
	                      { onClick: _this2._handleShowMenuClick },
	                      title
	                    );
	                  }
	                ),
	                section !== 'live' && this.getPageH1(sportId),
	                section === 'preMatch' && _react2.default.createElement(
	                  'div',
	                  { className: 'pull-right' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'schedule--events' },
	                    _react2.default.createElement(
	                      'a',
	                      { href: '#', className: 'dropdown--toggle',
	                        onClick: this._handleShowMenuClick },
	                      _react2.default.createElement(_reactIntl.FormattedMessage, selectedTitle)
	                    ),
	                    showMenu && _react2.default.createElement(_PreMatchMenu2.default, { onFilterClick: this._handleFilterClick,
	                      onClosing: this._handleMenuClose,
	                      activeElement: filter })
	                  )
	                )
	              ),
	              _react2.default.createElement(HeaderItem, { message: messages.win1 }),
	              _react2.default.createElement(HeaderItem, { message: messages.draw }),
	              _react2.default.createElement(HeaderItem, { message: messages.win2 }),
	              _react2.default.createElement(HeaderItem, { message: messages.win1draw }),
	              _react2.default.createElement(HeaderItem, { message: messages.win12 }),
	              _react2.default.createElement(HeaderItem, { message: messages.drawWin2 }),
	              _react2.default.createElement(HeaderItem, { message: messages.handicap }),
	              _react2.default.createElement(HeaderItem, { message: messages.handicap1 }),
	              _react2.default.createElement(HeaderItem, { message: messages.handicap }),
	              _react2.default.createElement(HeaderItem, { message: messages.handicap2 }),
	              _react2.default.createElement(HeaderItem, { message: messages.under }),
	              _react2.default.createElement(HeaderItem, { message: messages.total }),
	              _react2.default.createElement(HeaderItem, { message: messages.over })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'scroll--wrapper' },
	          _react2.default.createElement(
	            _reactPerfectScrollbar2.default,
	            { ref: '_scrollBarRef' },
	            _react2.default.createElement(
	              'div',
	              { className: 'scroll--wrapper__inner', ref: 'content' },
	              _react2.default.createElement(_Leagues2.default, { section: section,
	                gridLocalization: gridLocalization,
	                filter: filter,
	                matchId: matchId,
	                gridSelection: gridSelection,
	                selectionToggleMatchAction: selectionToggleMatchAction,
	                currentPage: this.props.currentPage,
	                perPage: this.props.perPage,
	                changePaginationItemCount: this.props.changePaginationItemCount
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return Grid;
	}(_react2.default.Component);
	
	Grid.propTypes = {
	  section: _react2.default.PropTypes.string.isRequired,
	  gridLocalization: _react2.default.PropTypes.object.isRequired,
	  expandAllMatchesAction: _react2.default.PropTypes.func.isRequired,
	  collapseAllMatchesAction: _react2.default.PropTypes.func.isRequired,
	  expandAllGroupsAction: _react2.default.PropTypes.func.isRequired,
	  collapseAllGroupsAction: _react2.default.PropTypes.func.isRequired,
	  showLineNumbersAction: _react2.default.PropTypes.func.isRequired,
	  hideLineNumbersAction: _react2.default.PropTypes.func.isRequired,
	  matchId: _react2.default.PropTypes.any,
	  gridSelection: _react2.default.PropTypes.object.isRequired,
	  selectionToggleMatchAction: _react2.default.PropTypes.func.isRequired
	};
	exports.default = Grid;

/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _ToggleGroup = __webpack_require__(739);
	
	var _Body = __webpack_require__(774);
	
	var _Body2 = _interopRequireDefault(_Body);
	
	var _MainLine = __webpack_require__(775);
	
	var _MainLine2 = _interopRequireDefault(_MainLine);
	
	var _MatchScores = __webpack_require__(776);
	
	var _MatchScores2 = _interopRequireDefault(_MatchScores);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Group = function (_React$Component) {
	    (0, _inherits3.default)(Group, _React$Component);
	
	    function Group(props) {
	        (0, _classCallCheck3.default)(this, Group);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Group.__proto__ || (0, _getPrototypeOf2.default)(Group)).call(this, props));
	
	        _this._onExpandBodyClick = _this._onExpandBodyClick.bind(_this);
	        _this._onExpandGroupClick = _this._onExpandGroupClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(Group, [{
	        key: '_onExpandBodyClick',
	        value: function _onExpandBodyClick(e) {
	            e.preventDefault();
	            this.props.toggleGroupAction(this.props.group.get('id'), this.props.section);
	        }
	    }, {
	        key: '_onExpandGroupClick',
	        value: function _onExpandGroupClick(e) {
	            e.preventDefault();
	            this.props.toggleExpandGroup(this.props.group.get('id'), this.props.section);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var props = this.props;
	            var section = props.section,
	                group = props.group,
	                matchId = props.matchId,
	                gridLocalization = props.gridLocalization,
	                nestingLevel = props.nestingLevel,
	                hasChildGroups = props.hasChildGroups,
	                isParentExpanded = props.isParentExpanded,
	                hasParent = props.hasParent;
	
	
	            if (group === undefined || matchId === undefined) {
	                return false;
	            }
	
	            var groupId = group.get('id');
	            var realSportId = group.get('realSportId');
	            var groupType = group.get('type');
	            var groupName = gridLocalization.getGroupName(realSportId, groupType);
	
	            var groupIsClosed = group.get('isClosed');
	            var groupIsExpanded = group.get('isExpanded');
	
	            var headerCls = 'event-body-sections';
	            if (hasParent && !isParentExpanded) {
	                headerCls += " closed";
	            }
	
	            var groupClass = 'event-section-name';
	            // const hasBody = group.get('outcomes').size > group.get('headers').size;
	            var hasBody = group.get('hasBody');
	            if (hasBody) {
	                groupClass += groupIsClosed ? ' event-section-name--closed' : ' event-section-name--expanded';
	            }
	
	            var scoresProps = {
	                section: section,
	                matchId: matchId,
	                groupId: groupId,
	                gridLocalization: gridLocalization
	            };
	
	            var expandClass = groupIsExpanded ? "expand" : "collapse";
	
	            var groupHeader = void 0;
	            if (hasBody) {
	                groupHeader = _react2.default.createElement(
	                    'div',
	                    { className: 'group-controls' },
	                    hasChildGroups && _react2.default.createElement(
	                        'a',
	                        { href: '#', className: expandClass, onClick: this._onExpandGroupClick },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            '\xA0'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#',
	                            className: groupClass,
	                            style: { paddingLeft: '15px' },
	                            onClick: this._onExpandBodyClick },
	                        groupName
	                    )
	                );
	            } else {
	                groupHeader = _react2.default.createElement(
	                    'div',
	                    { className: 'group-controls' },
	                    hasChildGroups && _react2.default.createElement(
	                        'a',
	                        { href: '#', className: expandClass, onClick: this._onExpandGroupClick },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            '\xA0'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: groupClass, style: { paddingLeft: '15px' } },
	                        groupName
	                    )
	                );
	            }
	
	            var bodyProps = (0, _extends3.default)({}, props, {
	                nestingLevel: nestingLevel
	            });
	
	            var cellContentClass = 'cell-content level-' + nestingLevel;
	
	            return _react2.default.createElement(
	                'div',
	                { className: headerCls },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'table inner' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row inner' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'cell main' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: cellContentClass },
	                                groupHeader,
	                                section === 'live' && _react2.default.createElement(
	                                    'span',
	                                    { className: 'cell-main tools ' },
	                                    _react2.default.createElement(_MatchScores2.default, scoresProps)
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_MainLine2.default, { id: groupId, section: section, gridLocalization: gridLocalization })
	                    )
	                ),
	                !groupIsClosed && _react2.default.createElement(_Body2.default, (0, _extends3.default)({ key: groupId, id: groupId }, bodyProps))
	            );
	        }
	    }]);
	    return Group;
	}(_react2.default.Component);
	
	Group.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    group: _react2.default.PropTypes.object,
	    hasChildGroups: _react2.default.PropTypes.bool.isRequired,
	    isParentExpanded: _react2.default.PropTypes.bool,
	    hasParent: _react2.default.PropTypes.bool,
	    matchId: _react2.default.PropTypes.number,
	    gridLocalization: _react2.default.PropTypes.object.isRequired,
	    toggleGroupAction: _react2.default.PropTypes.func.isRequired,
	    toggleExpandGroup: _react2.default.PropTypes.func.isRequired,
	    nestingLevel: _react2.default.PropTypes.number
	};
	
	
	function select(state, props) {
	    var section = props.section,
	        id = props.id,
	        matchId = props.matchId,
	        gridLocalization = props.gridLocalization,
	        hasChildGroups = props.hasChildGroups;
	
	    var group = state.application.getIn([section, 'groups', id]);
	
	    return {
	        section: section,
	        matchId: matchId,
	        group: group,
	        gridLocalization: gridLocalization,
	        hasChildGroups: hasChildGroups
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, { toggleGroupAction: _ToggleGroup.toggleGroup, toggleExpandGroup: _ToggleGroup.expandGroup })(Group);

/***/ },
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _RegularMatch = __webpack_require__(1223);
	
	var _RegularMatch2 = _interopRequireDefault(_RegularMatch);
	
	var _DisplayMode = __webpack_require__(78);
	
	var DisplayMode = _interopRequireWildcard(_DisplayMode);
	
	var _FavouriteState = __webpack_require__(79);
	
	var FavouriteState = _interopRequireWildcard(_FavouriteState);
	
	var _SportCssMap = __webpack_require__(120);
	
	var _Sorting = __webpack_require__(136);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function filterMatches(matches, filter) {
	    if (filter === null || filter === undefined) {
	        return matches;
	    }
	
	    var date = new Date();
	
	    var dateFilter = new Date(date.getTime() + filter * 60 * 60 * 1000);
	
	    return matches.filter(function (m) {
	        return m.get('startDate') <= dateFilter;
	    });
	}
	
	var League = function (_React$Component) {
	    (0, _inherits3.default)(League, _React$Component);
	
	    function League() {
	        (0, _classCallCheck3.default)(this, League);
	        return (0, _possibleConstructorReturn3.default)(this, (League.__proto__ || (0, _getPrototypeOf2.default)(League)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(League, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return this.props.league !== nextProps.league || this.props.displayMode !== nextProps.displayMode || this.props.filter !== nextProps.filter;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                section = _props.section,
	                sport = _props.sport,
	                league = _props.league,
	                displayMode = _props.displayMode,
	                matches = _props.matches,
	                gridLocalization = _props.gridLocalization,
	                matchId = _props.matchId,
	                gridSelection = _props.gridSelection,
	                selectionToggleMatchAction = _props.selectionToggleMatchAction;
	
	
	            if (league === undefined || sport === undefined) {
	                return false;
	            }
	
	            var sportId = sport.get('id');
	
	            var matchIds = league.get('matches');
	
	            var showTitle = true;
	            var showLeague = true;
	
	            if (section === 'live') {
	                if (displayMode.type === DisplayMode.FAVOURITE) {
	                    var favouriteState = league.get('favouriteState');
	                    if (favouriteState === FavouriteState.NONE) {
	                        showLeague = false;
	                    }
	                } else if (displayMode.type === DisplayMode.SPORT) {
	                    if (sportId !== displayMode.id) {
	                        showLeague = false;
	                    }
	                } else if (displayMode.type === DisplayMode.LEAGUE) {
	                    if (league.get('id') !== displayMode.id) {
	                        showLeague = false;
	                    }
	                } else if (displayMode.type === DisplayMode.MATCH) {
	                    var containsSelectedMatch = matchIds.includes(displayMode.id);
	
	                    if (containsSelectedMatch) {
	                        showTitle = false;
	                    } else {
	                        showLeague = false;
	                    }
	                }
	            }
	
	            if (!showLeague) {
	                return false;
	            }
	
	            var leagueMatches = matchIds.map(function (m) {
	                return matches.get(m);
	            });
	
	            if (section === 'preMatch') {
	                leagueMatches = filterMatches(leagueMatches, this.props.filter);
	            }
	
	            if (leagueMatches.size === 0) {
	                return false;
	            }
	
	            var sortedMatches = leagueMatches.sort(section === 'live' ? _Sorting.matchSortFunc : _Sorting.matchStartDateSortFunc);
	
	            var sportCssName = _SportCssMap.cssClassMap[sportId];
	
	            var leagueClass = 'league ' + sportCssName;
	            var sportIconClass = 'sport-icon svg-' + sportCssName;
	
	            var leagueName = league.get('name');
	            var sportName = sport.get('name');
	
	            var matchProps = {
	                section: section,
	                gridLocalization: gridLocalization,
	                matchId: matchId,
	                gridSelection: gridSelection,
	                selectionToggleMatchAction: selectionToggleMatchAction
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: leagueClass },
	                showTitle && _react2.default.createElement(
	                    'div',
	                    { className: 'title' },
	                    _react2.default.createElement('i', { className: sportIconClass }),
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        sportName + '. '
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        leagueName
	                    )
	                ),
	                sortedMatches.map(function (m) {
	                    return League.renderMatch(m, matchProps);
	                })
	            );
	        }
	    }], [{
	        key: 'renderMatch',
	        value: function renderMatch(match, props) {
	            var matchId = match.get('id');
	
	            return _react2.default.createElement(_RegularMatch2.default, (0, _extends3.default)({ key: matchId, id: matchId }, props));
	        }
	    }]);
	    return League;
	}(_react2.default.Component);
	
	League.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    filter: _react2.default.PropTypes.number,
	    league: _react2.default.PropTypes.object,
	    sport: _react2.default.PropTypes.object,
	    matchId: _react2.default.PropTypes.any,
	    matches: _react2.default.PropTypes.object.isRequired,
	    displayMode: _react2.default.PropTypes.object.isRequired,
	    gridLocalization: _react2.default.PropTypes.object.isRequired,
	    gridSelection: _react2.default.PropTypes.object.isRequired,
	    selectionToggleMatchAction: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select(state, props) {
	    var section = props.section,
	        id = props.id,
	        gridLocalization = props.gridLocalization,
	        filter = props.filter,
	        matchId = props.matchId;
	
	    var league = state.application.getIn([section, 'leagues', id]);
	
	    var sport = void 0;
	
	    if (league !== undefined) {
	        var sportId = league.get('sportId');
	        sport = state.application.getIn([section, 'sports', sportId]);
	    }
	
	    return {
	        section: section,
	        filter: filter,
	        sport: sport,
	        league: league,
	        matchId: matchId,
	        matches: state.application.getIn([section, 'matches']),
	        displayMode: state.application.get('displayMode'),
	        gridLocalization: gridLocalization,
	        gridSelection: props.gridSelection,
	        selectionToggleMatchAction: props.selectionToggleMatchAction
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, null, null, false)(League);

/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _immutable = __webpack_require__(14);
	
	var _League = __webpack_require__(1218);
	
	var _League2 = _interopRequireDefault(_League);
	
	var _Sorting = __webpack_require__(136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function renderLeague(league, props) {
	    var leagueId = league.get('id');
	    return _react2.default.createElement(_League2.default, (0, _extends3.default)({ key: leagueId, id: leagueId }, props));
	}
	
	function filterMatches(matches, date, filter) {
	    if (filter === null || filter === undefined) {
	        return matches;
	    }
	
	    return matches.filter(function (m) {
	        return m.get('startDate') <= date;
	    });
	}
	
	function sortLeagues(sports, leagues) {
	    var result = new _immutable.List();
	    if (sports) {
	        sports = sports.sort(_Sorting.sportSortFunc);
	
	        sports.forEach(function (sport) {
	            var sportLeagues = sport.get('leagues').map(function (l) {
	                return leagues.get(l);
	            }).sort(_Sorting.leagueSortFunc);
	
	            result = result.concat(sportLeagues);
	        });
	    }
	
	    return result;
	}
	
	var Leagues = function (_React$Component) {
	    (0, _inherits3.default)(Leagues, _React$Component);
	
	    function Leagues(props) {
	        (0, _classCallCheck3.default)(this, Leagues);
	        return (0, _possibleConstructorReturn3.default)(this, (Leagues.__proto__ || (0, _getPrototypeOf2.default)(Leagues)).call(this, props));
	    }
	
	    (0, _createClass3.default)(Leagues, [{
	        key: 'renderLeagues',
	        value: function renderLeagues(leagues, leagueProps) {
	            var _props = this.props,
	                currentPage = _props.currentPage,
	                perPage = _props.perPage,
	                matches = _props.matches,
	                filter = _props.filter;
	
	
	            var start = (currentPage - 1) * perPage;
	            var end = currentPage * perPage;
	
	            var matchCounter = 0;
	            var dateFilter = void 0;
	
	            var leagueRenderElements = [];
	
	            if (filter === null) {
	                dateFilter = null;
	            } else {
	                var date = new Date();
	
	                dateFilter = new Date(date.getTime() + filter * 60 * 60 * 1000);
	            }
	
	            if (currentPage && perPage) {
	                leagues.map(function (league) {
	                    var leagueMatches = matches.filter(function (match) {
	                        return match.get('leagueId') === league.get('id');
	                    });
	                    var filteredMatches = [];
	                    if (leagueMatches.size > 0) {
	                        filteredMatches = filterMatches(leagueMatches, dateFilter, filter);
	                    }
	                    matchCounter += filteredMatches.size;
	
	                    if (filteredMatches.size > perPage) {
	                        if (Math.floor(start / perPage) !== Math.floor(filteredMatches.size / perPage)) {
	                            leagueRenderElements.push(renderLeague(league, leagueProps));
	                        }
	                    } else {
	                        if (start <= matchCounter - filteredMatches.size && matchCounter - filteredMatches.size <= end) {
	                            leagueRenderElements.push(renderLeague(league, leagueProps));
	                        }
	                    }
	                });
	            } else {
	                leagues.map(function (league) {
	                    leagueRenderElements.push(renderLeague(league, leagueProps));
	                });
	            }
	
	            return leagueRenderElements;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                section = _props2.section,
	                gridLocalization = _props2.gridLocalization,
	                sports = _props2.sports,
	                leagues = _props2.leagues,
	                filter = _props2.filter,
	                matchId = _props2.matchId,
	                gridSelection = _props2.gridSelection,
	                selectionToggleMatchAction = _props2.selectionToggleMatchAction;
	
	
	            var sortedLeagues = sortLeagues(sports, leagues);
	
	            var leagueProps = {
	                section: section,
	                gridLocalization: gridLocalization,
	                filter: filter,
	                matchId: matchId,
	                gridSelection: gridSelection,
	                selectionToggleMatchAction: selectionToggleMatchAction
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                this.renderLeagues(sortedLeagues, leagueProps)
	            );
	        }
	    }]);
	    return Leagues;
	}(_react2.default.Component);
	
	Leagues.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    gridLocalization: _react2.default.PropTypes.object.isRequired,
	    sports: _react2.default.PropTypes.object.isRequired,
	    leagues: _react2.default.PropTypes.object.isRequired,
	    matches: _react2.default.PropTypes.object.isRequired,
	    filter: _react2.default.PropTypes.number,
	    gridSelection: _react2.default.PropTypes.object.isRequired,
	    selectionToggleMatchAction: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select(state, props) {
	    var section = props.section;
	
	
	    var sports = state.application.get(section).get('sports');
	    var leagues = state.application.get(section).get('leagues');
	    var matches = state.application.get(section).get('matches');
	
	    return (0, _extends3.default)({}, props, {
	        sports: sports,
	        leagues: leagues,
	        matches: matches
	    });
	}
	
	exports.default = (0, _reactRedux.connect)(select)(Leagues);

/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(8);
	
	var _DropDownMenu = __webpack_require__(502);
	
	var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    title: {
	        id: 'grid.menu.title',
	        defaultMessage: 'Меню событий'
	    },
	    collapseAllEvents: {
	        id: 'grid.menu.collapse_all_events',
	        defaultMessage: 'Свернуть все события'
	    },
	    expandAllEvents: {
	        id: 'grid.menu.expand_all_events',
	        defaultMessage: 'Развернуть все события'
	    },
	    collapseAllGroups: {
	        id: 'grid.menu.collapse_all_groups',
	        defaultMessage: 'Свернуть все доп. ставки'
	    },
	    expandAllGroups: {
	        id: 'grid.menu.expand_all_groups',
	        defaultMessage: 'Развернуть все доп. ставки'
	    },
	    displayLineNumbers: {
	        id: 'grid.menu.display_line_numbers',
	        defaultMessage: 'Отображать номера событий'
	    },
	    hideLineNumbers: {
	        id: 'grid.menu.hide_line_numbers',
	        defaultMessage: 'Скрыть номера событий'
	    }
	});
	
	function _localizedLink(message, onClick) {
	    return _react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        message,
	        function (localizedMessage) {
	            return _react2.default.createElement(
	                'a',
	                { href: '#', target: '_blank', className: 'dropdown--menu__link', onClick: onClick },
	                localizedMessage
	            );
	        }
	    );
	}
	
	var LiveMenu = function (_React$Component) {
	    (0, _inherits3.default)(LiveMenu, _React$Component);
	
	    function LiveMenu(props) {
	        (0, _classCallCheck3.default)(this, LiveMenu);
	        return (0, _possibleConstructorReturn3.default)(this, (LiveMenu.__proto__ || (0, _getPrototypeOf2.default)(LiveMenu)).call(this, props));
	    }
	
	    (0, _createClass3.default)(LiveMenu, [{
	        key: 'render',
	        value: function render() {
	            var cssClass = 'dropdown--menu-live-grid';
	
	            var _props = this.props,
	                onCollapseAllMatchesClick = _props.onCollapseAllMatchesClick,
	                onExpandAllMatchesClick = _props.onExpandAllMatchesClick,
	                onCollapseAllGroupsClick = _props.onCollapseAllGroupsClick,
	                onExpandAllGroupsClick = _props.onExpandAllGroupsClick,
	                onDisplayLineNumbersClick = _props.onDisplayLineNumbersClick,
	                onHideLineNumbersClick = _props.onHideLineNumbersClick,
	                onClosing = _props.onClosing;
	
	
	            var elements = [{ content: _localizedLink(messages.collapseAllEvents, onCollapseAllMatchesClick) }, { content: _localizedLink(messages.expandAllEvents, onExpandAllMatchesClick) }, { content: _localizedLink(messages.collapseAllGroups, onCollapseAllGroupsClick) }, { content: _localizedLink(messages.expandAllGroups, onExpandAllGroupsClick) }, { content: _localizedLink(messages.displayLineNumbers, onDisplayLineNumbersClick) }, { content: _localizedLink(messages.hideLineNumbers, onHideLineNumbersClick) }];
	
	            var title = _react2.default.createElement(_reactIntl.FormattedMessage, messages.title);
	
	            return _react2.default.createElement(_DropDownMenu2.default, { cssClass: cssClass,
	                title: title,
	                elements: elements,
	                onClosing: onClosing
	            });
	        }
	    }]);
	    return LiveMenu;
	}(_react2.default.Component);
	
	LiveMenu.propTypes = {
	    onCollapseAllMatchesClick: _react2.default.PropTypes.func.isRequired,
	    onExpandAllMatchesClick: _react2.default.PropTypes.func.isRequired,
	    onCollapseAllGroupsClick: _react2.default.PropTypes.func.isRequired,
	    onExpandAllGroupsClick: _react2.default.PropTypes.func.isRequired,
	    onDisplayLineNumbersClick: _react2.default.PropTypes.func.isRequired,
	    onHideLineNumbersClick: _react2.default.PropTypes.func.isRequired,
	    onClosing: _react2.default.PropTypes.func.isRequired
	};
	exports.default = LiveMenu;

/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _FavouriteState = __webpack_require__(79);
	
	var FavouriteState = _interopRequireWildcard(_FavouriteState);
	
	var _ToggleMatch = __webpack_require__(961);
	
	var _ToggleGroup = __webpack_require__(739);
	
	var _Favourites = __webpack_require__(736);
	
	var _Line = __webpack_require__(562);
	
	var _Stream = __webpack_require__(564);
	
	var _index = __webpack_require__(565);
	
	var _Body = __webpack_require__(774);
	
	var _Body2 = _interopRequireDefault(_Body);
	
	var _MainLine = __webpack_require__(775);
	
	var _MainLine2 = _interopRequireDefault(_MainLine);
	
	var _MatchScores = __webpack_require__(776);
	
	var _MatchScores2 = _interopRequireDefault(_MatchScores);
	
	var _MatchTime = __webpack_require__(1230);
	
	var _MatchTime2 = _interopRequireDefault(_MatchTime);
	
	var _Locales = __webpack_require__(80);
	
	var _Locales2 = _interopRequireDefault(_Locales);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var calendarConfig = {
	    en: {
	        sameDay: '[Today at] HH:mm',
	        nextDay: '[Tomorrow at] HH:mm',
	        lastWeek: 'D MMMM [at] HH:mm',
	        nextWeek: 'D MMMM [at] HH:mm',
	        sameElse: 'D MMMM [at] HH:mm'
	    },
	    ru: {
	        sameDay: '[Сегодня в] HH:mm',
	        nextDay: '[Завтра в] HH:mm',
	        lastWeek: 'D MMMM [в] HH:mm',
	        nextWeek: 'D MMMM [в] HH:mm',
	        sameElse: 'D MMMM [в] HH:mm'
	    },
	    uz: {
	        sameDay: '[Бугун соат] HH:mm',
	        nextDay: '[Эртага соат] HH:mm',
	        lastWeek: 'D MMMM HH:mm [да]',
	        nextWeek: 'D MMMM HH:mm [да]',
	        sameElse: 'D MMMM HH:mm [да]'
	    }
	};
	
	var MatchHeader = function (_React$Component) {
	    (0, _inherits3.default)(MatchHeader, _React$Component);
	
	    function MatchHeader(props) {
	        (0, _classCallCheck3.default)(this, MatchHeader);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (MatchHeader.__proto__ || (0, _getPrototypeOf2.default)(MatchHeader)).call(this, props));
	
	        _this._onExpandMatchClick = _this._onExpandMatchClick.bind(_this);
	        _this._onExpandBodyClick = _this._onExpandBodyClick.bind(_this);
	        _this._onFavouriteClick = _this._onFavouriteClick.bind(_this);
	        _this._onStreamClick = _this._onStreamClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(MatchHeader, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                section = _props.section,
	                gridLocalization = _props.gridLocalization,
	                match = _props.match,
	                matchId = _props.matchId,
	                isChoosenMatch = _props.isChoosenMatch,
	                gridSelection = _props.gridSelection;
	
	            var inGridSelection = gridSelection.get('matchesExpanded').includes(matchId);
	
	            if (isChoosenMatch || inGridSelection) {
	                if (section === 'preMatch' && !match.get('isFullyLoaded')) {
	                    this.props.requestFullLineAction({
	                        eventId: matchId,
	                        languageId: gridLocalization.languageId
	                    });
	                } else if (section === 'live' && !match.get('isClosed')) {
	                    this.props.toggleMatchAction({ matchId: matchId, isClosed: !match.get('isClosed') }, section);
	                }
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return this.props.match !== nextProps.match || this.props.activeWidgetId !== nextProps.activeWidgetId || this.props.matchGroupIsClosed !== nextProps.matchGroupIsClosed || this.props.gridLocalization.languageId !== nextProps.gridLocalization.languageId || this.props.showLineNumbers !== nextProps.showLineNumbers;
	        }
	    }, {
	        key: '_onExpandMatchClick',
	        value: function _onExpandMatchClick(e) {
	            e.preventDefault();
	
	            var _props2 = this.props,
	                section = _props2.section,
	                gridLocalization = _props2.gridLocalization,
	                matchId = _props2.matchId,
	                match = _props2.match;
	
	            var isClosed = match.get('isClosed');
	
	            this.props.selectionToggleMatchAction({ id: matchId });
	
	            if (section === 'preMatch' && !match.get('isFullyLoaded')) {
	                this.props.requestFullLineAction({
	                    eventId: matchId,
	                    languageId: gridLocalization.languageId
	                });
	
	                return;
	            }
	
	            this.props.toggleMatchAction({ matchId: matchId, isClosed: !isClosed }, section);
	        }
	    }, {
	        key: '_onExpandBodyClick',
	        value: function _onExpandBodyClick(e) {
	            e.preventDefault();
	
	            var _props3 = this.props,
	                section = _props3.section,
	                gridLocalization = _props3.gridLocalization,
	                match = _props3.match,
	                matchId = _props3.matchId,
	                matchGroupId = _props3.matchGroupId;
	
	            var isClosed = match.get('isClosed');
	
	            if (section === 'preMatch' && !match.get('isFullyLoaded')) {
	                this.props.requestFullLineAction({
	                    eventId: matchId,
	                    languageId: gridLocalization.languageId
	                });
	
	                if (isClosed) {
	                    this.props.selectionToggleMatchAction({ id: matchId });
	                }
	
	                return;
	            }
	
	            if (isClosed) {
	                this.props.toggleMatchAction({ matchId: matchId, isClosed: !isClosed }, section);
	            }
	
	            if (matchGroupId !== null) {
	                this.props.toggleGroupAction(matchGroupId, section);
	            }
	        }
	    }, {
	        key: '_onFavouriteClick',
	        value: function _onFavouriteClick(e) {
	            e.preventDefault();
	            this.props.toggleFavouriteMatchAction(this.props.match);
	        }
	    }, {
	        key: 'renderMatchDate',
	        value: function renderMatchDate(date, languageId) {
	            var timezone = _moment2.default.tz.guess();
	
	            var locale = _Locales2.default[languageId];
	            _moment2.default.locale(locale);
	
	            _moment2.default.updateLocale(locale, {
	                calendar: calendarConfig[locale]
	            });
	
	            date.locale(locale).tz(timezone);
	
	            return _react2.default.createElement(
	                'span',
	                { className: 'match-header__date' },
	                date.calendar()
	            );
	        }
	    }, {
	        key: '_onStreamClick',
	        value: function _onStreamClick() {
	            var matchId = this.props.match.get('id');
	            var channelStream = this.props.match.get('channel') || null;
	            //const channelStream = "Матч! Футбол 1; url: http://172.28.3.150/hls/relay/MinCNUX/index.m3u8";
	
	            if (channelStream !== null) {
	                var src = void 0;
	                var myRegexp = /url:(.*)/;
	                var regexArray = myRegexp.exec(channelStream);
	
	                if (regexArray) {
	                    src = regexArray[1].trim();
	                }
	
	                this.props.fetchStreamAction({ matchId: matchId, src: src });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props4 = this.props,
	                section = _props4.section,
	                match = _props4.match,
	                matchGroup = _props4.matchGroup,
	                matchGroupId = _props4.matchGroupId,
	                matchGroupIsClosed = _props4.matchGroupIsClosed,
	                gridLocalization = _props4.gridLocalization,
	                showLineNumbers = _props4.showLineNumbers,
	                activeWidgetId = _props4.activeWidgetId,
	                languageId = _props4.languageId;
	
	
	            if (match === undefined) {
	                return false;
	            }
	
	            var matchId = match.get('id');
	            var radarId = match.get('radarId');
	            var sportId = match.get('sportId');
	            var notice = match.get('notice') || null;
	
	            var name = match.get('name');
	            if (notice !== null) {
	                name = name + ' (' + notice + ')';
	            }
	
	            var tv = null;
	            var channel = match.get('channel') || null;
	            if (channel !== null) {
	                tv = _react2.default.createElement(
	                    'span',
	                    { className: 'tv', title: channel },
	                    ' '
	                );
	            }
	
	            var groupsExist = match.get('groups').size > 0;
	
	            var favourite = null;
	            if (section === 'live') {
	                var favouritesCls = 'favourites';
	
	                if (match.get('favouriteState') === FavouriteState.FULL) {
	                    favouritesCls += ' added';
	                }
	
	                favourite = _react2.default.createElement(
	                    'a',
	                    { href: '#', className: favouritesCls, onClick: this._onFavouriteClick },
	                    _react2.default.createElement('span', { className: 'favourites__icon' })
	                );
	            }
	
	            var matchGroupClass = 'event-name__link';
	            var matchIsClosed = match.get('isClosed');
	            var matchIsFullyLoaded = match.get('isFullyLoaded');
	            var matchLineNumber = match.get('lineNumber');
	
	            var renderBody = false;
	
	            if (matchIsClosed === true || matchIsFullyLoaded === false) {
	                matchGroupClass = 'event-name__link event-name__link--closed';
	            } else {
	                // const hasBody = matchGroup && matchGroup.get('outcomes').size > matchGroup.get('headers').size;
	                var hasBody = matchGroup && matchGroup.get('hasBody');
	                if (matchGroupId && hasBody) {
	                    matchGroupClass += matchGroupIsClosed ? ' event-name__link--closed' : ' event-name__link--expanded';
	
	                    renderBody = !matchGroupIsClosed;
	                }
	            }
	
	            var groupProps = {
	                section: section,
	                gridLocalization: gridLocalization
	            };
	
	            var scoresProps = {
	                section: section,
	                matchId: matchId,
	                groupId: matchGroupId,
	                gridLocalization: gridLocalization
	            };
	
	            var mainLineProps = {
	                id: matchGroupId,
	                section: section,
	                gridLocalization: gridLocalization
	            };
	
	            var channelStream = match.get('channel') || null;
	            var stream = channelStream !== null && channelStream.includes('url:');
	
	            var isWidgetActive = radarId && activeWidgetId === radarId ? 'active' : '';
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'event-header' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'controls' },
	                    groupsExist && _react2.default.createElement(
	                        'a',
	                        { href: '#', className: 'expand', onClick: this._onExpandMatchClick },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            '\xA0'
	                        )
	                    ),
	                    favourite
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'table' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'cell main' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'event-name' },
	                                _react2.default.createElement(
	                                    'a',
	                                    { className: matchGroupClass, href: '#', onClick: this._onExpandBodyClick, title: name },
	                                    _react2.default.createElement(
	                                        'strong',
	                                        null,
	                                        showLineNumbers && matchLineNumber
	                                    ),
	                                    ' \xA0 ',
	                                    name
	                                ),
	                                radarId && _react2.default.createElement('button', { onClick: function onClick() {
	                                        return _this2.props.setRadarWidget({ radarId: radarId, name: name, sportId: sportId });
	                                    }, id: radarId, className: 'radar-widget_btn ' + isWidgetActive })
	                            ),
	                            section === 'preMatch' && this.renderMatchDate(match.get('startDate'), languageId),
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'cell-main tools' },
	                                section === 'preMatch' && tv,
	                                section === 'live' && _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    this.props.countryCode === 'KG' && stream && _react2.default.createElement('button', { onClick: this._onStreamClick, className: 'play-stream_btn' }),
	                                    _react2.default.createElement(_MatchScores2.default, scoresProps),
	                                    _react2.default.createElement(_MatchTime2.default, { id: match.get('id'), section: section })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_MainLine2.default, mainLineProps)
	                    )
	                ),
	                matchGroupId && matchIsFullyLoaded && renderBody && _react2.default.createElement(_Body2.default, (0, _extends3.default)({ key: matchGroupId, id: matchGroupId }, groupProps))
	            );
	        }
	    }]);
	    return MatchHeader;
	}(_react2.default.Component);
	
	MatchHeader.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    languageId: _react2.default.PropTypes.number.isRequired,
	    matchId: _react2.default.PropTypes.number,
	    matchGroup: _react2.default.PropTypes.object,
	    matchGroupId: _react2.default.PropTypes.number,
	    matchGroupIsClosed: _react2.default.PropTypes.bool,
	    match: _react2.default.PropTypes.object,
	    isChoosenMatch: _react2.default.PropTypes.bool,
	    gridLocalization: _react2.default.PropTypes.object.isRequired,
	    showLineNumbers: _react2.default.PropTypes.bool.isRequired,
	    toggleGroupAction: _react2.default.PropTypes.func.isRequired,
	    toggleMatchAction: _react2.default.PropTypes.func.isRequired,
	    toggleFavouriteMatchAction: _react2.default.PropTypes.func.isRequired,
	    requestFullLineAction: _react2.default.PropTypes.func.isRequired,
	    setRadarWidget: _react2.default.PropTypes.func.isRequired,
	    gridSelection: _react2.default.PropTypes.object.isRequired,
	    selectionToggleMatchAction: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select(state, props) {
	    var section = props.section,
	        id = props.id,
	        gridLocalization = props.gridLocalization,
	        isChoosenMatch = props.isChoosenMatch,
	        gridSelection = props.gridSelection,
	        selectionToggleMatchAction = props.selectionToggleMatchAction;
	
	
	    var languageId = state.application.get('languageId');
	    var activeWidgetId = state.application.get('betradar').activeWidgetId;
	    var match = state.application.getIn([section, 'matches', id]);
	    var showLineNumbers = state.application.hasIn([section, 'showLineNumbers']) ? state.application.getIn([section, 'showLineNumbers'], false) : false;
	
	    var matchGroup = void 0;
	    var matchGroupId = void 0;
	    var matchGroupIsClosed = true;
	
	    if (match !== undefined) {
	        matchGroupId = match.get('matchGroup');
	
	        if (matchGroupId !== undefined) {
	            matchGroup = state.application.getIn([section, 'groups', matchGroupId]);
	
	            if (matchGroup !== undefined) {
	                matchGroupIsClosed = matchGroup.get('isClosed');
	            }
	        }
	    }
	
	    return {
	        section: section,
	        languageId: languageId,
	        match: match,
	        matchGroup: matchGroup,
	        matchGroupId: matchGroupId,
	        matchGroupIsClosed: matchGroupIsClosed,
	        gridLocalization: gridLocalization,
	        showLineNumbers: showLineNumbers,
	        isChoosenMatch: isChoosenMatch,
	        gridSelection: gridSelection,
	        selectionToggleMatchAction: selectionToggleMatchAction,
	        countryCode: state.application.get('countryCode'),
	        user: state.auth.get('user'),
	        activeWidgetId: activeWidgetId
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, {
	    fetchStreamAction: _Stream.fetchStream, toggleGroupAction: _ToggleGroup.toggleGroup, toggleMatchAction: _ToggleMatch.toggleMatch, toggleFavouriteMatchAction: _Favourites.toggleFavouriteMatch, requestFullLineAction: _Line.requestFullLine, setRadarWidget: _index.setRadarWidget
	})(MatchHeader);

/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(8);
	
	var _DropDownMenu = __webpack_require__(502);
	
	var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    title: {
	        id: 'grid.menu.prematch_filter.title',
	        defaultMessage: 'Фильтр событий'
	    },
	    allTime: {
	        id: 'grid.menu.prematch_filter.all_time',
	        defaultMessage: 'За всё время'
	    },
	    nextHour: {
	        id: 'grid.menu.prematch_filter.next_hour',
	        defaultMessage: 'Ближайший час'
	    },
	    next2Hours: {
	        id: 'grid.menu.prematch_filter.next_2_hours',
	        defaultMessage: 'Ближайшие 2 часа'
	    },
	    next4Hours: {
	        id: 'grid.menu.prematch_filter.next_4_hours',
	        defaultMessage: 'Ближайшие 4 часа'
	    },
	    next6Hours: {
	        id: 'grid.menu.prematch_filter.next_6_hours',
	        defaultMessage: 'Ближайшие 6 часов'
	    },
	    next12Hours: {
	        id: 'grid.menu.prematch_filter.next_12_hours',
	        defaultMessage: 'Ближайшие 12 часов'
	    },
	    nextDay: {
	        id: 'grid.menu.prematch_filter.next_day',
	        defaultMessage: 'Ближайший день'
	    },
	    next2Days: {
	        id: 'grid.menu.prematch_filter.next_2_days',
	        defaultMessage: 'Ближайшие 2 дня'
	    }
	});
	
	function _localizedLink(message, onClick) {
	    var isActive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var linkClass = isActive ? 'dropdown--menu__link active' : 'dropdown--menu__link';
	
	    return _react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        message,
	        function (localizedMessage) {
	            return _react2.default.createElement(
	                'a',
	                { href: '#', className: linkClass, onClick: onClick },
	                localizedMessage
	            );
	        }
	    );
	}
	
	var PreMatchMenu = function (_React$Component) {
	    (0, _inherits3.default)(PreMatchMenu, _React$Component);
	
	    function PreMatchMenu(props) {
	        (0, _classCallCheck3.default)(this, PreMatchMenu);
	        return (0, _possibleConstructorReturn3.default)(this, (PreMatchMenu.__proto__ || (0, _getPrototypeOf2.default)(PreMatchMenu)).call(this, props));
	    }
	
	    (0, _createClass3.default)(PreMatchMenu, [{
	        key: 'render',
	        value: function render() {
	            var cssClass = 'dropdown--menu-live-grid-filter';
	
	            var _props = this.props,
	                onFilterClick = _props.onFilterClick,
	                onClosing = _props.onClosing,
	                activeElement = _props.activeElement;
	
	
	            var curryFilter = function curryFilter(filter) {
	                return function () {
	                    return onFilterClick(filter);
	                };
	            };
	
	            var elements = [{ content: _localizedLink(messages.allTime, curryFilter(null), activeElement === null) }, { content: _localizedLink(messages.nextHour, curryFilter(1), activeElement === 1) }, { content: _localizedLink(messages.next2Hours, curryFilter(2), activeElement === 2) }, { content: _localizedLink(messages.next4Hours, curryFilter(4), activeElement === 4) }, { content: _localizedLink(messages.next6Hours, curryFilter(6), activeElement === 6) }, { content: _localizedLink(messages.next12Hours, curryFilter(12), activeElement === 12) }, { content: _localizedLink(messages.nextDay, curryFilter(24), activeElement === 24) }, { content: _localizedLink(messages.next2Days, curryFilter(48), activeElement === 48) }];
	
	            var title = _react2.default.createElement(_reactIntl.FormattedMessage, messages.title);
	
	            return _react2.default.createElement(_DropDownMenu2.default, { cssClass: cssClass,
	                title: title,
	                elements: elements,
	                onClosing: onClosing });
	        }
	    }]);
	    return PreMatchMenu;
	}(_react2.default.Component);
	
	PreMatchMenu.propTypes = {
	    onFilterClick: _react2.default.PropTypes.func.isRequired,
	    onClosing: _react2.default.PropTypes.func.isRequired,
	    activeElement: _react2.default.PropTypes.any
	};
	exports.default = PreMatchMenu;

/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(511);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _DisplayMode = __webpack_require__(78);
	
	var DisplayMode = _interopRequireWildcard(_DisplayMode);
	
	var _FavouriteState = __webpack_require__(79);
	
	var FavouriteState = _interopRequireWildcard(_FavouriteState);
	
	var _MatchHeader = __webpack_require__(1221);
	
	var _MatchHeader2 = _interopRequireDefault(_MatchHeader);
	
	var _MatchStats = __webpack_require__(1229);
	
	var _MatchStats2 = _interopRequireDefault(_MatchStats);
	
	var _Group = __webpack_require__(1217);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Sorting = __webpack_require__(136);
	
	var _groupNesting = __webpack_require__(1824);
	
	var _groupNesting2 = _interopRequireDefault(_groupNesting);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegularMatch = function (_React$Component) {
	    (0, _inherits3.default)(RegularMatch, _React$Component);
	    (0, _createClass3.default)(RegularMatch, null, [{
	        key: 'renderParentGroup',
	        value: function renderParentGroup(group, nestingLevel, props) {
	            var groupId = group.get('id');
	            var hasChildGroups = group.get('childGroups') ? group.get('childGroups').size > 0 : false;
	
	            var groupElements = [];
	            var childGroups = group.get('childGroups');
	
	            groupElements.push(_react2.default.createElement(_Group2.default, (0, _extends3.default)({ key: groupId, id: groupId, hasChildGroups: hasChildGroups }, props)));
	
	            if (childGroups) {
	                nestingLevel += 1;
	                var childProps = (0, _extends3.default)({}, props, {
	                    nestingLevel: nestingLevel,
	                    isParentExpanded: group.get('isExpanded'),
	                    hasParent: true
	                });
	
	                childGroups.forEach(function (childGroup) {
	                    var childGroupElements = RegularMatch.renderParentGroup(childGroup, nestingLevel, childProps);
	                    groupElements = groupElements.concat(childGroupElements);
	                });
	            }
	
	            return groupElements;
	        }
	    }]);
	
	    function RegularMatch(props) {
	        (0, _classCallCheck3.default)(this, RegularMatch);
	        return (0, _possibleConstructorReturn3.default)(this, (RegularMatch.__proto__ || (0, _getPrototypeOf2.default)(RegularMatch)).call(this, props));
	    }
	
	    (0, _createClass3.default)(RegularMatch, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                section = _props.section,
	                match = _props.match,
	                groups = _props.groups,
	                displayMode = _props.displayMode,
	                gridLocalization = _props.gridLocalization,
	                isChoosenMatch = _props.isChoosenMatch,
	                gridSelection = _props.gridSelection,
	                selectionToggleMatchAction = _props.selectionToggleMatchAction;
	
	
	            if (match === undefined) {
	                return false;
	            }
	
	            var matchId = match.get('id');
	
	            var sortedMatchGroups = groups.sort(_Sorting.groupsSortFunc);
	
	            var headerCls = 'event';
	
	            var isFullyLoaded = match.get('isFullyLoaded');
	
	            var isLive = section === "live";
	
	            var isClosed = false;
	            if (match.get('isClosed') === true || !isLive && !isFullyLoaded) {
	                headerCls += ' closed';
	                isClosed = true;
	            }
	
	            var showMatch = true;
	
	            if (isLive) {
	                if (displayMode.type === DisplayMode.FAVOURITE) {
	                    var favouriteState = match.get('favouriteState');
	                    if (favouriteState === FavouriteState.NONE) {
	                        headerCls += ' hidden';
	                        showMatch = false;
	                    }
	                } else if (displayMode.type === DisplayMode.MATCH) {
	                    if (matchId !== displayMode.id) {
	                        headerCls += ' hidden';
	                        showMatch = false;
	                    }
	                }
	            }
	
	            if (!showMatch) {
	                return false;
	            }
	
	            var builtMatchGroups = buildGroups(sortedMatchGroups);
	            builtMatchGroups = buildCustomNestingGroups(match.get('realSportId'), builtMatchGroups);
	            var hasGroups = builtMatchGroups.length > 0;
	
	            var props = {
	                section: section,
	                matchId: matchId,
	                gridLocalization: gridLocalization,
	                isChoosenMatch: isChoosenMatch
	            };
	
	            var headerProps = (0, _extends3.default)({}, props, {
	                gridSelection: gridSelection,
	                selectionToggleMatchAction: selectionToggleMatchAction,
	                isChoosenMatch: isChoosenMatch
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { className: headerCls },
	                _react2.default.createElement(_MatchHeader2.default, (0, _extends3.default)({ id: matchId }, headerProps)),
	                !isClosed && hasGroups && _react2.default.createElement(
	                    'div',
	                    { className: 'event-body' },
	                    builtMatchGroups.map(function (g) {
	                        return RegularMatch.renderParentGroup(g, 1, props);
	                    })
	                ),
	                !isClosed && isLive && _react2.default.createElement(_MatchStats2.default, (0, _extends3.default)({ key: matchId }, props))
	            );
	        }
	    }]);
	    return RegularMatch;
	}(_react2.default.Component);
	
	RegularMatch.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    match: _react2.default.PropTypes.object,
	    groups: _react2.default.PropTypes.object,
	    isChoosenMatch: _react2.default.PropTypes.bool,
	    displayMode: _react2.default.PropTypes.object.isRequired,
	    gridLocalization: _react2.default.PropTypes.object.isRequired,
	    gridSelection: _react2.default.PropTypes.object.isRequired,
	    selectionToggleMatchAction: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select(state, props) {
	    var section = props.section,
	        id = props.id,
	        gridLocalization = props.gridLocalization,
	        matchId = props.matchId;
	
	    var match = state.application.getIn([section, 'matches', id]);
	    var groups = state.application.getIn([section, 'groups']).filter(function (g) {
	        return g.get('matchId') === id && g.get('type') !== 0;
	    });
	    var displayMode = state.application.get('displayMode');
	
	    var isChoosenMatch = id == matchId;
	
	    return {
	        section: section,
	        match: match,
	        groups: groups,
	        displayMode: displayMode,
	        gridLocalization: gridLocalization,
	        isChoosenMatch: isChoosenMatch,
	        gridSelection: props.gridSelection,
	        selectionToggleMatchAction: props.selectionToggleMatchAction
	    };
	}
	
	function buildGroups(groups) {
	    var rootGroups = groups.filter(function (group) {
	        return group.get('parentId') == null;
	    });
	    groups = cleanGroups(groups, rootGroups);
	
	    rootGroups.forEach(function (rootGroup, index) {
	        var newRootGroup = appendChildGroups(rootGroup);
	        rootGroups = rootGroups.set(index, newRootGroup);
	    });
	
	    function appendChildGroups(rootGroup) {
	        var childGroups = groups.filter(function (group) {
	            return group.get('parentId') === rootGroup.get('type');
	        });
	        groups = cleanGroups(groups, childGroups);
	
	        childGroups.forEach(function (childGroup, index) {
	            var newLevelChildGroups = groups.filter(function (group) {
	                return group.get('parentId') === childGroup.get('type');
	            });
	            var hasNewLevelChildGroups = newLevelChildGroups.size > 0;
	
	            if (hasNewLevelChildGroups) {
	                var newChildGroup = appendChildGroups(childGroup, childGroups);
	                childGroups = childGroups.set(index, newChildGroup);
	            }
	
	            groups = cleanGroups(groups, newLevelChildGroups);
	        });
	
	        return rootGroup.set('childGroups', childGroups);
	    }
	
	    var hasNotAppendedGroups = groups.size > 0;
	
	    if (hasNotAppendedGroups) {
	        rootGroups = rootGroups.concat(groups);
	    }
	    return rootGroups;
	}
	
	function buildCustomNestingGroups(sportId, groups) {
	    if (groups.size === 0) {
	        return groups.toArray();
	    }
	    var nestingConfig = _groupNesting2.default[sportId];
	
	    if (!nestingConfig) {
	        return groups.toArray();
	    }
	
	    var groupKeys = (0, _keys2.default)(nestingConfig);
	    if (groupKeys.length === 0) {
	        return groups.toArray();
	    }
	
	    var customNestingGroups = [];
	    var foundNestedGroupTypes = [];
	    var foundParent = false;
	
	    groups.forEach(function (group) {
	        var groupType = group.get('type');
	        var nestedGroupTypes = nestingConfig[groupType];
	        if (!foundParent && containsValue(groupKeys, groupType) && nestedGroupTypes) {
	            foundParent = true;
	            foundNestedGroupTypes = nestedGroupTypes;
	
	            var nestedGroups = groups.filter(function (g) {
	                return nestedGroupTypes.indexOf(g.get('type')) !== -1;
	            });
	            group = group.set('childGroups', nestedGroups);
	
	            customNestingGroups.push(group);
	        } else {
	            if (!containsValue(foundNestedGroupTypes, groupType)) {
	                customNestingGroups.push(group);
	            }
	        }
	    });
	
	    return customNestingGroups;
	}
	
	function containsValue(arr, val) {
	    for (var i = 0; i < arr.length; i++) {
	        if (arr[i] == val) {
	            return true;
	        }
	    }
	
	    return false;
	}
	
	function cleanGroups(groups, groupsToRemove) {
	    return groups.filterNot(function (group) {
	        return groupsToRemove.includes(group);
	    });
	}
	
	exports.default = (0, _reactRedux.connect)(select)(RegularMatch);

/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _HeaderRate = __webpack_require__(506);
	
	var _HeaderRate2 = _interopRequireDefault(_HeaderRate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DoubleOutcome = function (_React$Component) {
	    (0, _inherits3.default)(DoubleOutcome, _React$Component);
	
	    function DoubleOutcome(props) {
	        (0, _classCallCheck3.default)(this, DoubleOutcome);
	        return (0, _possibleConstructorReturn3.default)(this, (DoubleOutcome.__proto__ || (0, _getPrototypeOf2.default)(DoubleOutcome)).call(this, props));
	    }
	
	    (0, _createClass3.default)(DoubleOutcome, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                section = _props.section,
	                outcome = _props.outcome,
	                gridLocalization = _props.gridLocalization;
	
	
	            if (outcome === undefined) {
	                return _react2.default.createElement(
	                    'span',
	                    { className: 'cell-title-wrapper' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'cell rate empty-cell' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'cell rate empty-cell' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'cell rate empty-cell' },
	                        '\xA0'
	                    )
	                );
	            }
	
	            var outcomeRates = [];
	
	            outcome.get('rates').entrySeq().sortBy(function (r) {
	                return r[0];
	            }).forEach(function (r) {
	                outcomeRates.push(r[1]);
	            });
	
	            var props = {
	                section: section,
	                gridLocalization: gridLocalization
	            };
	
	            return _react2.default.createElement(
	                'span',
	                { className: 'cell-title-wrapper' },
	                _react2.default.createElement(_HeaderRate2.default, (0, _extends3.default)({ key: outcomeRates[0], id: outcomeRates[0] }, props)),
	                _react2.default.createElement(_HeaderRate2.default, (0, _extends3.default)({ key: outcomeRates[1], id: outcomeRates[1] }, props)),
	                _react2.default.createElement(_HeaderRate2.default, (0, _extends3.default)({ key: outcomeRates[2], id: outcomeRates[2] }, props))
	            );
	        }
	    }]);
	    return DoubleOutcome;
	}(_react2.default.Component);
	
	DoubleOutcome.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    outcome: _react2.default.PropTypes.object,
	    gridLocalization: _react2.default.PropTypes.object.isRequired
	};
	
	
	function select(state, props) {
	    var section = props.section,
	        id = props.id;
	
	    var outcome = void 0;
	
	    if (id && id !== null) {
	        outcome = state.application.getIn([section, 'outcomes', id]);
	    }
	
	    return {
	        section: section,
	        outcome: outcome
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select)(DoubleOutcome);

/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _renderingCommons = __webpack_require__(137);
	
	var _HeaderRate = __webpack_require__(506);
	
	var _HeaderRate2 = _interopRequireDefault(_HeaderRate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HandicapOutcome = function (_React$Component) {
	    (0, _inherits3.default)(HandicapOutcome, _React$Component);
	
	    function HandicapOutcome(props) {
	        (0, _classCallCheck3.default)(this, HandicapOutcome);
	        return (0, _possibleConstructorReturn3.default)(this, (HandicapOutcome.__proto__ || (0, _getPrototypeOf2.default)(HandicapOutcome)).call(this, props));
	    }
	
	    (0, _createClass3.default)(HandicapOutcome, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                section = _props.section,
	                outcome = _props.outcome,
	                gridLocalization = _props.gridLocalization;
	
	
	            if (outcome === undefined) {
	                return _react2.default.createElement(
	                    'span',
	                    { className: 'cell-title-wrapper' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'cell cond' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'cell rate empty-cell' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'cell cond' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'cell rate empty-cell' },
	                        '\xA0'
	                    )
	                );
	            }
	
	            var outcomeRates = [];
	
	            outcome.get('rates').entrySeq().sortBy(function (r) {
	                return r[0];
	            }).forEach(function (r) {
	                outcomeRates.push(r[1]);
	            });
	
	            var isBlocked = outcome.get('isBlocked');
	
	            var conditionCls = 'cell cond' + (isBlocked ? ' closed' : '');
	
	            var props = {
	                section: section,
	                gridLocalization: gridLocalization
	            };
	
	            return _react2.default.createElement(
	                'span',
	                { className: 'cell-title-wrapper' },
	                _react2.default.createElement(
	                    'span',
	                    { className: conditionCls },
	                    (0, _renderingCommons.firstHandicapCondition)(outcome.get('condition'))
	                ),
	                _react2.default.createElement(_HeaderRate2.default, (0, _extends3.default)({ key: outcomeRates[0], id: outcomeRates[0] }, props)),
	                _react2.default.createElement(
	                    'span',
	                    { className: conditionCls },
	                    (0, _renderingCommons.secondHandicapCondition)(outcome.get('condition'))
	                ),
	                _react2.default.createElement(_HeaderRate2.default, (0, _extends3.default)({ key: outcomeRates[1], id: outcomeRates[1] }, props))
	            );
	        }
	    }]);
	    return HandicapOutcome;
	}(_react2.default.Component);
	
	HandicapOutcome.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    outcome: _react2.default.PropTypes.object,
	    gridLocalization: _react2.default.PropTypes.object.isRequired
	};
	
	
	function select(state, props) {
	    var section = props.section,
	        id = props.id;
	
	    var outcome = void 0;
	
	    if (id && id !== null) {
	        outcome = state.application.getIn([section, 'outcomes', id]);
	    }
	
	    return {
	        section: section,
	        outcome: outcome
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select)(HandicapOutcome);

/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(511);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _HeaderRate = __webpack_require__(506);
	
	var _HeaderRate2 = _interopRequireDefault(_HeaderRate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResultOutcome = function (_React$Component) {
	    (0, _inherits3.default)(ResultOutcome, _React$Component);
	
	    function ResultOutcome(props) {
	        (0, _classCallCheck3.default)(this, ResultOutcome);
	        return (0, _possibleConstructorReturn3.default)(this, (ResultOutcome.__proto__ || (0, _getPrototypeOf2.default)(ResultOutcome)).call(this, props));
	    }
	
	    (0, _createClass3.default)(ResultOutcome, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                section = _props.section,
	                outcome = _props.outcome,
	                gridLocalization = _props.gridLocalization;
	
	
	            if (outcome === undefined) {
	                return _react2.default.createElement(
	                    'span',
	                    { className: 'cell-title-wrapper' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'cell rate empty-cell' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'cell rate empty-cell' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'cell rate empty-cell' },
	                        '\xA0'
	                    )
	                );
	            }
	
	            var outcomeRates = [];
	
	            outcome.get('rates').entrySeq().sortBy(function (r) {
	                return r[0];
	            }).forEach(function (r) {
	                outcomeRates.push(r[1]);
	            });
	
	            var props = {
	                section: section,
	                gridLocalization: gridLocalization
	            };
	
	            if ((0, _keys2.default)(outcomeRates).length === 3) {
	                return _react2.default.createElement(
	                    'span',
	                    { className: 'cell-title-wrapper' },
	                    _react2.default.createElement(_HeaderRate2.default, (0, _extends3.default)({ key: outcomeRates[0], id: outcomeRates[0] }, props)),
	                    _react2.default.createElement(_HeaderRate2.default, (0, _extends3.default)({ key: outcomeRates[1], id: outcomeRates[1] }, props)),
	                    _react2.default.createElement(_HeaderRate2.default, (0, _extends3.default)({ key: outcomeRates[2], id: outcomeRates[2] }, props))
	                );
	            }
	
	            return _react2.default.createElement(
	                'span',
	                { className: 'cell-title-wrapper' },
	                _react2.default.createElement(_HeaderRate2.default, (0, _extends3.default)({ key: outcomeRates[0], id: outcomeRates[0] }, props)),
	                _react2.default.createElement('span', { className: 'cell rate empty-cell' }),
	                _react2.default.createElement(_HeaderRate2.default, (0, _extends3.default)({ key: outcomeRates[1], id: outcomeRates[1] }, props))
	            );
	        }
	    }]);
	    return ResultOutcome;
	}(_react2.default.Component);
	
	ResultOutcome.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    outcome: _react2.default.PropTypes.object,
	    gridLocalization: _react2.default.PropTypes.object.isRequired
	};
	
	
	function select(state, props) {
	    var section = props.section,
	        id = props.id;
	
	    var outcome = void 0;
	
	    if (id && id !== null) {
	        outcome = state.application.getIn([section, 'outcomes', id]);
	    }
	
	    return {
	        section: section,
	        outcome: outcome
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select)(ResultOutcome);

/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _HeaderRate = __webpack_require__(506);
	
	var _HeaderRate2 = _interopRequireDefault(_HeaderRate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TotalOutcome = function (_React$Component) {
	    (0, _inherits3.default)(TotalOutcome, _React$Component);
	
	    function TotalOutcome(props) {
	        (0, _classCallCheck3.default)(this, TotalOutcome);
	        return (0, _possibleConstructorReturn3.default)(this, (TotalOutcome.__proto__ || (0, _getPrototypeOf2.default)(TotalOutcome)).call(this, props));
	    }
	
	    (0, _createClass3.default)(TotalOutcome, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                section = _props.section,
	                outcome = _props.outcome,
	                gridLocalization = _props.gridLocalization;
	
	
	            if (outcome === undefined) {
	                return _react2.default.createElement(
	                    'span',
	                    { className: 'cell-title-wrapper' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'cell rate empty-cell' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'cell cond' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'cell rate empty-cell' },
	                        '\xA0'
	                    )
	                );
	            }
	
	            var outcomeRates = [];
	
	            outcome.get('rates').entrySeq().sortBy(function (r) {
	                return r[0];
	            }).forEach(function (r) {
	                outcomeRates.push(r[1]);
	            });
	
	            var isBlocked = outcome.get('isBlocked');
	
	            var conditionCls = 'cell cond' + (isBlocked ? ' closed' : '');
	
	            var props = {
	                section: section,
	                gridLocalization: gridLocalization
	            };
	
	            return _react2.default.createElement(
	                'span',
	                { className: 'cell-title-wrapper' },
	                _react2.default.createElement(_HeaderRate2.default, (0, _extends3.default)({ key: outcomeRates[0], id: outcomeRates[0] }, props)),
	                _react2.default.createElement(
	                    'span',
	                    { className: conditionCls },
	                    outcome.get('condition')
	                ),
	                _react2.default.createElement(_HeaderRate2.default, (0, _extends3.default)({ key: outcomeRates[1], id: outcomeRates[1] }, props))
	            );
	        }
	    }]);
	    return TotalOutcome;
	}(_react2.default.Component);
	
	TotalOutcome.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    outcome: _react2.default.PropTypes.object,
	    gridLocalization: _react2.default.PropTypes.object.isRequired
	};
	
	
	function select(state, props) {
	    var section = props.section,
	        id = props.id;
	
	    var outcome = void 0;
	
	    if (id && id !== null) {
	        outcome = state.application.getIn([section, 'outcomes', id]);
	    }
	
	    return {
	        section: section,
	        outcome: outcome
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select)(TotalOutcome);

/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _renderingCommons = __webpack_require__(137);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FlashScore = function (_React$Component) {
	    (0, _inherits3.default)(FlashScore, _React$Component);
	
	    function FlashScore(props) {
	        (0, _classCallCheck3.default)(this, FlashScore);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (FlashScore.__proto__ || (0, _getPrototypeOf2.default)(FlashScore)).call(this, props));
	
	        _this._timeoutId = null;
	        return _this;
	    }
	
	    (0, _createClass3.default)(FlashScore, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return this.props.scoreString !== nextProps.scoreString;
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.languageId !== prevProps.languageId) {
	                return;
	            }
	
	            var element = this.refs.scores;
	
	            if (!element) {
	                return;
	            }
	
	            var className = 'changed-score';
	
	            (0, _renderingCommons.addClass)(element, className);
	
	            this._timeoutId = window.setTimeout(this._onTimeout.bind(this, element, className), 2000);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this._timeoutId !== null) {
	                window.clearTimeout(this._timeoutId);
	            }
	        }
	    }, {
	        key: '_onTimeout',
	        value: function _onTimeout(element, className) {
	            (0, _renderingCommons.removeClass)(element, className);
	            this._timeoutId = null;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var scoreString = this.props.scoreString;
	
	
	            return _react2.default.createElement(
	                'span',
	                { ref: 'scores', className: 'score full' },
	                scoreString
	            );
	        }
	    }]);
	    return FlashScore;
	}(_react2.default.Component);
	
	FlashScore.propTypes = {
	    scoreString: _react2.default.PropTypes.string.isRequired,
	    languageId: _react2.default.PropTypes.number.isRequired
	};
	exports.default = FlashScore;

/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _factory = __webpack_require__(1235);
	
	var _factory2 = _interopRequireDefault(_factory);
	
	var _SportCssMap = __webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchStats = function (_React$Component) {
	    (0, _inherits3.default)(MatchStats, _React$Component);
	
	    function MatchStats() {
	        (0, _classCallCheck3.default)(this, MatchStats);
	        return (0, _possibleConstructorReturn3.default)(this, (MatchStats.__proto__ || (0, _getPrototypeOf2.default)(MatchStats)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(MatchStats, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return this.props.scores !== nextProps.scores || this.props.period !== nextProps.period || this.props.gridLocalization.languageId !== nextProps.gridLocalization.languageId || this.props.remark !== nextProps.remark;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                section = _props.section,
	                matchId = _props.matchId,
	                period = _props.period,
	                scores = _props.scores,
	                remark = _props.remark,
	                sportId = _props.sportId,
	                gridLocalization = _props.gridLocalization;
	
	
	            if (!sportId || !period) {
	                return false;
	            }
	
	            var Renderer = (0, _factory2.default)(sportId);
	
	            if (!remark && !Renderer) {
	                return false;
	            }
	
	            var rendererProps = void 0;
	
	            var iconClass = 'sport-icon svg-' + _SportCssMap.cssClassMap[sportId];
	
	            var periodId = period.get('id');
	
	            var periodName = gridLocalization.getPeriodName(sportId, periodId);
	            var timeoutText = gridLocalization.getTimeoutText();
	            var foulsText = gridLocalization.getFoulsText();
	
	            var periodJs = this.props.period.set('name', periodName).toJS();
	
	            rendererProps = { section: section, matchId: matchId, sportId: sportId, scores: scores, periodJs: periodJs, timeoutText: timeoutText, foulsText: foulsText, iconClass: iconClass, remark: remark };
	
	            return _react2.default.createElement(Renderer, rendererProps);
	        }
	    }]);
	    return MatchStats;
	}(_react2.default.Component);
	
	MatchStats.propTypes = {
	    section: _react.PropTypes.string.isRequired,
	    matchId: _react.PropTypes.number.isRequired,
	    gridLocalization: _react.PropTypes.object.isRequired,
	    scores: _react.PropTypes.object,
	    remark: _react.PropTypes.string,
	    period: _react.PropTypes.object,
	    sportId: _react.PropTypes.number
	};
	
	
	function select(state, props) {
	    var section = props.section,
	        matchId = props.matchId;
	
	
	    var match = state.application.getIn([section, 'matches', matchId]);
	
	    var scores = void 0,
	        remark = void 0,
	        period = void 0,
	        sportId = void 0;
	
	    if (match) {
	        scores = match.get('scores');
	        remark = match.get('remark');
	        period = match.get('period');
	        sportId = match.get('realSportId');
	    }
	
	    return {
	        section: section,
	        matchId: matchId,
	        scores: scores,
	        remark: remark,
	        period: period,
	        sportId: sportId
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select)(MatchStats);

/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(8);
	
	var _direction = __webpack_require__(1232);
	
	var _MatchPeriod = __webpack_require__(1251);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    forward: {
	        id: 'grid.match-current-time.forward',
	        defaultMessage: '{minute}\''
	    },
	    backward: {
	        id: 'grid.match-current-time.backward',
	        defaultMessage: 'ост. < {minute}\''
	    }
	});
	
	var MatchTime = function (_React$Component) {
	    (0, _inherits3.default)(MatchTime, _React$Component);
	
	    function MatchTime(props) {
	        (0, _classCallCheck3.default)(this, MatchTime);
	        return (0, _possibleConstructorReturn3.default)(this, (MatchTime.__proto__ || (0, _getPrototypeOf2.default)(MatchTime)).call(this, props));
	    }
	
	    (0, _createClass3.default)(MatchTime, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return this.props.period !== nextProps.period;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                period = _props.period,
	                sportId = _props.sportId;
	
	
	            if (period === undefined || sportId === undefined) {
	                return false;
	            }
	
	            var periodId = period.get('id');
	
	            if (_MatchPeriod.End[sportId] !== undefined && _MatchPeriod.End[sportId].indexOf(periodId) !== -1 || _MatchPeriod.BreakWithoutTimer[sportId] !== undefined && _MatchPeriod.BreakWithoutTimer[sportId].indexOf(periodId) !== -1) {
	                return false;
	            }
	
	            var minute = period.get('minute');
	
	            if (minute === 0) {
	                return false;
	            }
	
	            var direction = (0, _direction.getDirection)(sportId);
	
	            var message = direction === _direction.FORWARD ? messages.forward : messages.backward;
	
	            var values = { minute: minute };
	
	            return _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                (0, _extends3.default)({}, message, { values: values }),
	                function (message) {
	                    return _react2.default.createElement(
	                        'span',
	                        { className: 'current-time' },
	                        message
	                    );
	                }
	            );
	        }
	    }]);
	    return MatchTime;
	}(_react2.default.Component);
	
	MatchTime.propTypes = {
	    sportId: _react2.default.PropTypes.number,
	    period: _react2.default.PropTypes.object
	};
	
	
	function select(state, props) {
	    var section = props.section,
	        id = props.id;
	
	    var match = state.application.getIn([section, 'matches', id]);
	
	    var period = void 0;
	    var sportId = void 0;
	    if (match !== undefined) {
	        period = match.get('period');
	        sportId = match.get('sportId');
	    }
	
	    return {
	        sportId: sportId,
	        period: period
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, null, null, false)(MatchTime);

/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Score = function (_React$Component) {
	    (0, _inherits3.default)(Score, _React$Component);
	
	    function Score() {
	        (0, _classCallCheck3.default)(this, Score);
	        return (0, _possibleConstructorReturn3.default)(this, (Score.__proto__ || (0, _getPrototypeOf2.default)(Score)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Score, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return this.props.score !== nextProps.score;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                score = _props.score,
	                spanClass = _props.spanClass,
	                showNulls = _props.showNulls;
	
	
	            var score1 = score.get('score1');
	            var score2 = score.get('score2');
	
	            if (!showNulls && (score1 === undefined || score2 === undefined)) {
	                return false;
	            } else {
	                score1 = score1 || 0;
	                score2 = score2 || 0;
	            }
	
	            return _react2.default.createElement(
	                'span',
	                { className: spanClass },
	                score1 + ':' + score2
	            );
	        }
	    }]);
	    return Score;
	}(_react2.default.Component);
	
	Score.propTypes = {
	    score: _react.PropTypes.object.isRequired,
	    spanClass: _react.PropTypes.string.isRequired,
	    showNulls: _react.PropTypes.bool
	};
	exports.default = Score;

/***/ },
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DirectionMap = exports.BACKWARD = exports.FORWARD = undefined;
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _DirectionMap;
	
	exports.getDirection = getDirection;
	
	var _SportType = __webpack_require__(89);
	
	var SportType = _interopRequireWildcard(_SportType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FORWARD = exports.FORWARD = 1;
	var BACKWARD = exports.BACKWARD = 2;
	
	var DirectionMap = exports.DirectionMap = (_DirectionMap = {}, (0, _defineProperty3.default)(_DirectionMap, SportType.BASKETBALL, BACKWARD), (0, _defineProperty3.default)(_DirectionMap, SportType.ICE_HOCKEY, BACKWARD), _DirectionMap);
	
	function getDirection(sportId) {
	    return DirectionMap[sportId] || FORWARD;
	}

/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Default = function (_React$Component) {
	    (0, _inherits3.default)(Default, _React$Component);
	
	    function Default() {
	        (0, _classCallCheck3.default)(this, Default);
	        return (0, _possibleConstructorReturn3.default)(this, (Default.__proto__ || (0, _getPrototypeOf2.default)(Default)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Default, [{
	        key: "render",
	        value: function render() {
	            var remark = this.props.remark;
	
	
	            if (!remark) {
	                return false;
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: "event-stats" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "event-comments" },
	                    remark
	                )
	            );
	        }
	    }]);
	    return Default;
	}(_react2.default.Component);
	
	Default.propTypes = {
	    remark: _react2.default.PropTypes.string
	};
	exports.default = Default;

/***/ },
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _immutable = __webpack_require__(14);
	
	var _ScoreType = __webpack_require__(40);
	
	var ScoreType = _interopRequireWildcard(_ScoreType);
	
	var _Score = __webpack_require__(1231);
	
	var _Score2 = _interopRequireDefault(_Score);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Soccer = function (_React$Component) {
	    (0, _inherits3.default)(Soccer, _React$Component);
	
	    function Soccer() {
	        (0, _classCallCheck3.default)(this, Soccer);
	        return (0, _possibleConstructorReturn3.default)(this, (Soccer.__proto__ || (0, _getPrototypeOf2.default)(Soccer)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Soccer, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                scores = _props.scores,
	                remark = _props.remark;
	
	
	            var cornerScore = scores.get(ScoreType.Corner);
	            var yellowCardScore = scores.get(ScoreType.YellowCard);
	            var redCardScore = scores.get(ScoreType.RedCard);
	
	            if (!cornerScore && !yellowCardScore && !redCardScore && !remark) {
	                return false;
	            }
	            if (cornerScore && (cornerScore.get('score1') === undefined || cornerScore.get('score2') === undefined) && yellowCardScore && (yellowCardScore.get('score1') === undefined || yellowCardScore.get('score2') === undefined) && redCardScore && (redCardScore.get('score1') === undefined || redCardScore.get('score2') === undefined) && !remark) {
	                return false;
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'event-stats' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'table' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        cornerScore && _react2.default.createElement(_Score2.default, { key: cornerScore.get('id'), score: cornerScore, spanClass: 'cell corners' }),
	                        yellowCardScore && _react2.default.createElement(_Score2.default, { key: yellowCardScore.get('id'), score: yellowCardScore, spanClass: 'cell yellow-cards' }),
	                        redCardScore && _react2.default.createElement(_Score2.default, { key: redCardScore.get('id'), score: redCardScore, spanClass: 'cell red-cards' })
	                    )
	                ),
	                remark && _react2.default.createElement(
	                    'div',
	                    { className: 'event-comments' },
	                    remark
	                )
	            );
	        }
	    }]);
	    return Soccer;
	}(_react2.default.Component);
	
	Soccer.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    scores: _react2.default.PropTypes.object,
	    remark: _react2.default.PropTypes.string
	};
	
	
	function select(state, props) {
	    var scoresStore = state.application.getIn([props.section, 'scores']);
	    var scores = (0, _immutable.Seq)(props.scores).map(function (id) {
	        return scoresStore.get(id);
	    });
	
	    return (0, _extends3.default)({}, props, {
	        scores: scores
	    });
	}
	
	exports.default = (0, _reactRedux.connect)(select)(Soccer);

/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _SportType = __webpack_require__(89);
	
	var SportType = _interopRequireWildcard(_SportType);
	
	var _Soccer = __webpack_require__(1234);
	
	var _Soccer2 = _interopRequireDefault(_Soccer);
	
	var _Default = __webpack_require__(1233);
	
	var _Default2 = _interopRequireDefault(_Default);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = function (sportId) {
	    switch (sportId) {
	        case SportType.FOOTBALL:
	            return _Soccer2.default;
	        default:
	            return _Default2.default;
	    }
	};

/***/ },
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NamedOutcomeRate = __webpack_require__(1239);
	
	var _NamedOutcomeRate2 = _interopRequireDefault(_NamedOutcomeRate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NamedOutcome = function NamedOutcome(_ref) {
	    var section = _ref.section,
	        sportId = _ref.sportId,
	        gridLocalization = _ref.gridLocalization,
	        outcome = _ref.outcome,
	        match = _ref.match;
	
	    var type = outcome.get('type');
	
	    var outcomeObject = {
	        type: type,
	        condition: outcome.get('condition')
	    };
	
	    var matchObject = {
	        homeTeam: match.get('firstTeam'),
	        awayTeam: match.get('secondTeam')
	    };
	
	    var outcomeName = gridLocalization.getOutcomeName(sportId, outcomeObject, matchObject);
	
	    var outcomeRates = [];
	
	    outcome.get('rates').entrySeq().sortBy(function (r) {
	        return r[0];
	    }).forEach(function (r) {
	        outcomeRates.push(r[1]);
	    });
	
	    var isBlocked = outcome.get('isBlocked');
	
	    var cls = 'out' + (isBlocked ? ' closed' : '');
	
	    var props = {
	        section: section,
	        gridLocalization: gridLocalization
	    };
	
	    return _react2.default.createElement(
	        'span',
	        { className: cls },
	        outcomeName,
	        outcomeRates.map(function (r) {
	            return _react2.default.createElement(_NamedOutcomeRate2.default, (0, _extends3.default)({ key: r, id: r }, props));
	        })
	    );
	};
	
	NamedOutcome.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    sportId: _react2.default.PropTypes.number.isRequired,
	    gridLocalization: _react2.default.PropTypes.object.isRequired,
	    outcome: _react2.default.PropTypes.object.isRequired,
	    match: _react2.default.PropTypes.object.isRequired
	};
	
	exports.default = NamedOutcome;

/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TennisGameRate = __webpack_require__(1240);
	
	var _TennisGameRate2 = _interopRequireDefault(_TennisGameRate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TennisGameOutcome = function TennisGameOutcome(_ref) {
	    var section = _ref.section,
	        sportId = _ref.sportId,
	        match = _ref.match,
	        outcome = _ref.outcome,
	        gridLocalization = _ref.gridLocalization;
	
	    var outcomeRates = {};
	
	    outcome.get('rates').entrySeq().sortBy(function (r) {
	        return r[0];
	    }).forEach(function (r) {
	        outcomeRates[r[0]] = r[1];
	    });
	
	    var matchObj = {
	        homeTeam: match.get('firstTeam'),
	        awayTeam: match.get('secondTeam')
	    };
	
	    var outcomeName = gridLocalization.getOutcomeName(sportId, outcome.toJS(), matchObj);
	
	    var isBlocked = outcome.get('isBlocked');
	
	    var conditionCls = 'out-cond' + (isBlocked ? ' closed' : '');
	
	    var props = {
	        section: section,
	        gridLocalization: gridLocalization
	    };
	
	    return _react2.default.createElement(
	        'span',
	        { className: 'out' },
	        _react2.default.createElement(_TennisGameRate2.default, (0, _extends3.default)({ key: outcomeRates[1], id: outcomeRates[1] }, props)),
	        _react2.default.createElement(
	            'span',
	            { className: conditionCls },
	            outcomeName
	        ),
	        _react2.default.createElement(_TennisGameRate2.default, (0, _extends3.default)({ key: outcomeRates[2], id: outcomeRates[2] }, props))
	    );
	};
	
	TennisGameOutcome.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    sportId: _react2.default.PropTypes.number.isRequired,
	    match: _react2.default.PropTypes.object.isRequired,
	    outcome: _react2.default.PropTypes.object.isRequired,
	    gridLocalization: _react2.default.PropTypes.object.isRequired
	};
	
	exports.default = TennisGameOutcome;

/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TotalRate = __webpack_require__(1241);
	
	var _TotalRate2 = _interopRequireDefault(_TotalRate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TotalOutcome = function TotalOutcome(_ref) {
	    var section = _ref.section,
	        outcome = _ref.outcome,
	        gridLocalization = _ref.gridLocalization;
	
	    var outcomeRates = {};
	
	    outcome.get('rates').entrySeq().sortBy(function (r) {
	        return r[0];
	    }).forEach(function (r) {
	        outcomeRates[r[0]] = r[1];
	    });
	
	    var outcomeCondition = outcome.get('condition');
	
	    var isBlocked = outcome.get('isBlocked');
	
	    var conditionCls = 'out-cond' + (isBlocked ? ' closed' : '');
	    var cls = 'out total-match' + (isBlocked ? ' closed' : '');
	
	    var props = {
	        section: section,
	        gridLocalization: gridLocalization
	    };
	
	    return _react2.default.createElement(
	        'span',
	        { className: cls },
	        _react2.default.createElement(_TotalRate2.default, (0, _extends3.default)({ key: outcomeRates[1], id: outcomeRates[1] }, props)),
	        _react2.default.createElement(
	            'span',
	            { className: conditionCls },
	            '<' + outcomeCondition + '>'
	        ),
	        _react2.default.createElement(_TotalRate2.default, (0, _extends3.default)({ key: outcomeRates[2], id: outcomeRates[2] }, props))
	    );
	};
	
	TotalOutcome.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    outcome: _react2.default.PropTypes.object.isRequired,
	    gridLocalization: _react2.default.PropTypes.object.isRequired
	};
	
	exports.default = TotalOutcome;

/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _BaseRate2 = __webpack_require__(341);
	
	var _CouponRate = __webpack_require__(72);
	
	var _MakeBet = __webpack_require__(133);
	
	var _HistoryBet = __webpack_require__(65);
	
	var _renderingCommons = __webpack_require__(137);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NamedOutcomeRate = function (_BaseRate) {
	    (0, _inherits3.default)(NamedOutcomeRate, _BaseRate);
	
	    function NamedOutcomeRate(props) {
	        (0, _classCallCheck3.default)(this, NamedOutcomeRate);
	        return (0, _possibleConstructorReturn3.default)(this, (NamedOutcomeRate.__proto__ || (0, _getPrototypeOf2.default)(NamedOutcomeRate)).call(this, props));
	    }
	
	    (0, _createClass3.default)(NamedOutcomeRate, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                rate = _props.rate,
	                outcomeIsBlocked = _props.outcomeIsBlocked;
	
	
	            if (rate === undefined) {
	                return false;
	            }
	
	            var rateName = rate.get('shortName');
	
	            var rateValue = (0, _renderingCommons.getRateDisplayValue)(rate.get('value'));
	            var isVisible = rate.get('isVisible');
	
	            if (!isVisible) {
	                rateValue = '';
	            }
	
	            var isBlocked = rate.get('isBlocked') || outcomeIsBlocked;
	
	            var rateCls = 'out-rate' + (isBlocked ? ' closed' : '');
	            var conditionCls = 'out-cond' + (isBlocked ? ' closed' : '');
	
	            return _react2.default.createElement(
	                'span',
	                { key: rate.get('id'), ref: 'rate', className: 'named-outcome--wrapper', onClick: this._onClick },
	                _react2.default.createElement(
	                    'span',
	                    { className: conditionCls },
	                    rateName
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: rateCls },
	                    rateValue
	                )
	            );
	        }
	    }]);
	    return NamedOutcomeRate;
	}(_BaseRate2.BaseRate);
	
	exports.default = (0, _reactRedux.connect)(_BaseRate2.mapStateToProps, {
	    addCouponRateAction: _CouponRate.addCouponRate, makeBetAction: _MakeBet.makeBet, requestBetTypesAction: _HistoryBet.requestBetTypes, addRateAction: _CouponRate.addRate
	}, null, false)(NamedOutcomeRate);

/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _BaseRate2 = __webpack_require__(341);
	
	var _CouponRate = __webpack_require__(72);
	
	var _MakeBet = __webpack_require__(133);
	
	var _HistoryBet = __webpack_require__(65);
	
	var _renderingCommons = __webpack_require__(137);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TennisGameRate = function (_BaseRate) {
	    (0, _inherits3.default)(TennisGameRate, _BaseRate);
	
	    function TennisGameRate(props) {
	        (0, _classCallCheck3.default)(this, TennisGameRate);
	        return (0, _possibleConstructorReturn3.default)(this, (TennisGameRate.__proto__ || (0, _getPrototypeOf2.default)(TennisGameRate)).call(this, props));
	    }
	
	    (0, _createClass3.default)(TennisGameRate, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                rate = _props.rate,
	                outcomeIsBlocked = _props.outcomeIsBlocked;
	
	
	            if (rate === undefined) {
	                return false;
	            }
	
	            var rateName = rate.get('shortName');
	
	            var rateValue = (0, _renderingCommons.getRateDisplayValue)(rate.get('value'));
	            var isVisible = rate.get('isVisible');
	
	            if (!isVisible) {
	                rateValue = '';
	            }
	
	            var isBlocked = rate.get('isBlocked') || outcomeIsBlocked;
	
	            var rateCls = 'inner-rate' + (isBlocked ? ' closed' : '');
	            var conditionCls = 'rate-name' + (isBlocked ? ' closed' : '');
	
	            return _react2.default.createElement(
	                'span',
	                { key: rate.get('id'), ref: 'rate', className: 'out-rate', onClick: this._onClick },
	                _react2.default.createElement(
	                    'span',
	                    { className: conditionCls },
	                    rateName
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: rateCls },
	                    rateValue
	                )
	            );
	        }
	    }]);
	    return TennisGameRate;
	}(_BaseRate2.BaseRate);
	
	exports.default = (0, _reactRedux.connect)(_BaseRate2.mapStateToProps, {
	    addCouponRateAction: _CouponRate.addCouponRate, makeBetAction: _MakeBet.makeBet, requestBetTypesAction: _HistoryBet.requestBetTypes, addRateAction: _CouponRate.addRate
	}, null, false)(TennisGameRate);

/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _BaseRate2 = __webpack_require__(341);
	
	var _CouponRate = __webpack_require__(72);
	
	var _MakeBet = __webpack_require__(133);
	
	var _HistoryBet = __webpack_require__(65);
	
	var _renderingCommons = __webpack_require__(137);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TotalRate = function (_BaseRate) {
	    (0, _inherits3.default)(TotalRate, _BaseRate);
	
	    function TotalRate(props) {
	        (0, _classCallCheck3.default)(this, TotalRate);
	        return (0, _possibleConstructorReturn3.default)(this, (TotalRate.__proto__ || (0, _getPrototypeOf2.default)(TotalRate)).call(this, props));
	    }
	
	    (0, _createClass3.default)(TotalRate, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                rate = _props.rate,
	                outcomeIsBlocked = _props.outcomeIsBlocked;
	
	
	            if (rate === undefined) {
	                return false;
	            }
	
	            var isVisible = rate.get('isVisible');
	            var rateValue = isVisible ? (0, _renderingCommons.getRateDisplayValue)(rate.get('value')) : '';
	
	            var cls = 'out-rate';
	
	            if (rate.get('isBlocked') || outcomeIsBlocked) {
	                cls += ' closed';
	            }
	
	            return _react2.default.createElement(
	                'span',
	                { key: rate.get('id'), ref: 'rate', className: cls, onClick: this._onClick },
	                rateValue
	            );
	        }
	    }]);
	    return TotalRate;
	}(_BaseRate2.BaseRate);
	
	exports.default = (0, _reactRedux.connect)(_BaseRate2.mapStateToProps, {
	    addCouponRateAction: _CouponRate.addCouponRate, makeBetAction: _MakeBet.makeBet, requestBetTypesAction: _HistoryBet.requestBetTypes, addRateAction: _CouponRate.addRate
	}, null, false)(TotalRate);

/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MultiOutcome = __webpack_require__(777);
	
	var _MultiOutcome2 = _interopRequireDefault(_MultiOutcome);
	
	var _SlotName = __webpack_require__(161);
	
	var _SlotName2 = _interopRequireDefault(_SlotName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MultiOutcomeSlot = function (_React$Component) {
	    (0, _inherits3.default)(MultiOutcomeSlot, _React$Component);
	
	    function MultiOutcomeSlot() {
	        (0, _classCallCheck3.default)(this, MultiOutcomeSlot);
	        return (0, _possibleConstructorReturn3.default)(this, (MultiOutcomeSlot.__proto__ || (0, _getPrototypeOf2.default)(MultiOutcomeSlot)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(MultiOutcomeSlot, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return this.props.gridLocalization !== nextProps.gridLocalization || this.props.slot !== nextProps.slot || this.props.outcomes !== nextProps.outcomes;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                section = _props.section,
	                sportId = _props.sportId,
	                match = _props.match,
	                slot = _props.slot,
	                outcomes = _props.outcomes,
	                gridLocalization = _props.gridLocalization;
	
	
	            var slotNameProps = {
	                sportId: sportId,
	                match: match,
	                slot: slot,
	                outcome: outcomes[0],
	                gridLocalization: gridLocalization
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'table detailed' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row inner' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cell main' },
	                        _react2.default.createElement(_SlotName2.default, slotNameProps)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cell rate multi' },
	                        outcomes.map(function (o) {
	                            return MultiOutcomeSlot.renderOutcome(o, section, gridLocalization);
	                        })
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'renderOutcome',
	        value: function renderOutcome(outcome, section, gridLocalization) {
	            var id = outcome.get('id');
	            return _react2.default.createElement(_MultiOutcome2.default, { key: id, outcome: outcome, section: section, gridLocalization: gridLocalization });
	        }
	    }]);
	    return MultiOutcomeSlot;
	}(_react2.default.Component);
	
	MultiOutcomeSlot.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    sportId: _react2.default.PropTypes.number.isRequired,
	    match: _react2.default.PropTypes.object,
	    slot: _react2.default.PropTypes.object.isRequired,
	    outcomes: _react2.default.PropTypes.array.isRequired,
	    gridLocalization: _react2.default.PropTypes.object.isRequired
	};
	exports.default = MultiOutcomeSlot;

/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NamedOutcome = __webpack_require__(1236);
	
	var _NamedOutcome2 = _interopRequireDefault(_NamedOutcome);
	
	var _SlotName = __webpack_require__(161);
	
	var _SlotName2 = _interopRequireDefault(_SlotName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NamedOutcomeSlot = function (_React$Component) {
	    (0, _inherits3.default)(NamedOutcomeSlot, _React$Component);
	
	    function NamedOutcomeSlot() {
	        (0, _classCallCheck3.default)(this, NamedOutcomeSlot);
	        return (0, _possibleConstructorReturn3.default)(this, (NamedOutcomeSlot.__proto__ || (0, _getPrototypeOf2.default)(NamedOutcomeSlot)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(NamedOutcomeSlot, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return this.props.gridLocalization !== nextProps.gridLocalization || this.props.slot !== nextProps.slot || this.props.outcomes !== nextProps.outcomes;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                section = _props.section,
	                sportId = _props.sportId,
	                match = _props.match,
	                slot = _props.slot,
	                outcomes = _props.outcomes,
	                gridLocalization = _props.gridLocalization;
	
	
	            var slotNameProps = {
	                sportId: sportId,
	                match: match,
	                slot: slot,
	                outcome: outcomes[0],
	                gridLocalization: gridLocalization
	            };
	
	            var props = {
	                section: section,
	                sportId: sportId,
	                match: match,
	                gridLocalization: gridLocalization
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'table detailed named-outcome' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row inner' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cell main' },
	                        _react2.default.createElement(_SlotName2.default, slotNameProps)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cell rate ss' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'rates' },
	                            outcomes.map(function (o) {
	                                return NamedOutcomeSlot.renderOutcome(o, props);
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'renderOutcome',
	        value: function renderOutcome(outcome, props) {
	            return _react2.default.createElement(_NamedOutcome2.default, (0, _extends3.default)({ key: outcome.get('id'), outcome: outcome }, props));
	        }
	    }]);
	    return NamedOutcomeSlot;
	}(_react2.default.Component);
	
	NamedOutcomeSlot.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    sportId: _react2.default.PropTypes.number.isRequired,
	    match: _react2.default.PropTypes.object,
	    slot: _react2.default.PropTypes.object.isRequired,
	    outcomes: _react2.default.PropTypes.array.isRequired,
	    gridLocalization: _react2.default.PropTypes.object.isRequired
	};
	exports.default = NamedOutcomeSlot;

/***/ },
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RegularRate = __webpack_require__(507);
	
	var _RegularRate2 = _interopRequireDefault(_RegularRate);
	
	var _SlotName = __webpack_require__(161);
	
	var _SlotName2 = _interopRequireDefault(_SlotName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SingleOutcomeSlot = function (_React$Component) {
	    (0, _inherits3.default)(SingleOutcomeSlot, _React$Component);
	
	    function SingleOutcomeSlot() {
	        (0, _classCallCheck3.default)(this, SingleOutcomeSlot);
	        return (0, _possibleConstructorReturn3.default)(this, (SingleOutcomeSlot.__proto__ || (0, _getPrototypeOf2.default)(SingleOutcomeSlot)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(SingleOutcomeSlot, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return this.props.gridLocalization !== nextProps.gridLocalization || this.props.slot !== nextProps.slot || this.props.outcomes !== nextProps.outcomes;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                section = _props.section,
	                sportId = _props.sportId,
	                slot = _props.slot,
	                match = _props.match,
	                gridLocalization = _props.gridLocalization,
	                outcomes = _props.outcomes;
	
	
	            var outcome = outcomes[0];
	            var outcomeRates = [];
	
	            outcome.get('rates').entrySeq().sortBy(function (r) {
	                return r[0];
	            }).forEach(function (r) {
	                outcomeRates.push(r[1]);
	            });
	
	            var slotNameProps = {
	                sportId: sportId,
	                match: match,
	                slot: slot,
	                outcome: outcome,
	                gridLocalization: gridLocalization
	            };
	
	            var props = {
	                section: section,
	                gridLocalization: gridLocalization
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'table detailed' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row inner' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cell main' },
	                        _react2.default.createElement(_SlotName2.default, slotNameProps)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cell rate ss' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'rates' },
	                            outcomeRates.map(function (r) {
	                                return _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: r, id: r }, props));
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return SingleOutcomeSlot;
	}(_react2.default.Component);
	
	SingleOutcomeSlot.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    sportId: _react2.default.PropTypes.number.isRequired,
	    match: _react2.default.PropTypes.object,
	    slot: _react2.default.PropTypes.object.isRequired,
	    outcomes: _react2.default.PropTypes.array.isRequired,
	    gridLocalization: _react2.default.PropTypes.object.isRequired
	};
	exports.default = SingleOutcomeSlot;

/***/ },
/* 1245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TotalOutcome = __webpack_require__(1238);
	
	var _TotalOutcome2 = _interopRequireDefault(_TotalOutcome);
	
	var _SlotName = __webpack_require__(161);
	
	var _SlotName2 = _interopRequireDefault(_SlotName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TotalSlot = function (_React$Component) {
	    (0, _inherits3.default)(TotalSlot, _React$Component);
	
	    function TotalSlot() {
	        (0, _classCallCheck3.default)(this, TotalSlot);
	        return (0, _possibleConstructorReturn3.default)(this, (TotalSlot.__proto__ || (0, _getPrototypeOf2.default)(TotalSlot)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(TotalSlot, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return this.props.gridLocalization !== nextProps.gridLocalization || this.props.slot !== nextProps.slot || this.props.outcomes !== nextProps.outcomes;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                section = _props.section,
	                sportId = _props.sportId,
	                match = _props.match,
	                slot = _props.slot,
	                outcomes = _props.outcomes,
	                gridLocalization = _props.gridLocalization;
	
	
	            var slotProps = {
	                sportId: sportId,
	                match: match,
	                slot: slot,
	                outcome: outcomes[0],
	                gridLocalization: gridLocalization
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'table detailed long' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row inner' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cell main' },
	                        _react2.default.createElement(_SlotName2.default, slotProps)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cell rate ss' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'rates' },
	                            outcomes.map(function (o) {
	                                return TotalSlot.renderOutcome(o, section, gridLocalization);
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'renderOutcome',
	        value: function renderOutcome(outcome, section, gridLocalization) {
	            return _react2.default.createElement(_TotalOutcome2.default, { key: outcome.get('id'), outcome: outcome, section: section, gridLocalization: gridLocalization });
	        }
	    }]);
	    return TotalSlot;
	}(_react2.default.Component);
	
	TotalSlot.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    sportId: _react2.default.PropTypes.number.isRequired,
	    match: _react2.default.PropTypes.object,
	    slot: _react2.default.PropTypes.object.isRequired,
	    outcomes: _react2.default.PropTypes.array.isRequired,
	    gridLocalization: _react2.default.PropTypes.object.isRequired
	};
	exports.default = TotalSlot;

/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MultiOutcome = __webpack_require__(777);
	
	var _MultiOutcome2 = _interopRequireDefault(_MultiOutcome);
	
	var _SlotName = __webpack_require__(161);
	
	var _SlotName2 = _interopRequireDefault(_SlotName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WideMultiOutcomeSlot = function (_React$Component) {
	    (0, _inherits3.default)(WideMultiOutcomeSlot, _React$Component);
	
	    function WideMultiOutcomeSlot() {
	        (0, _classCallCheck3.default)(this, WideMultiOutcomeSlot);
	        return (0, _possibleConstructorReturn3.default)(this, (WideMultiOutcomeSlot.__proto__ || (0, _getPrototypeOf2.default)(WideMultiOutcomeSlot)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(WideMultiOutcomeSlot, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return this.props.gridLocalization !== nextProps.gridLocalization || this.props.slot !== nextProps.slot || this.props.outcomes !== nextProps.outcomes;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                section = _props.section,
	                sportId = _props.sportId,
	                match = _props.match,
	                slot = _props.slot,
	                outcomes = _props.outcomes,
	                gridLocalization = _props.gridLocalization;
	
	
	            var slotProps = {
	                sportId: sportId,
	                match: match,
	                slot: slot,
	                outcome: outcomes[0],
	                gridLocalization: gridLocalization
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'table detailed who-score' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row inner' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cell main' },
	                        _react2.default.createElement(_SlotName2.default, slotProps)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cell rate ss' },
	                        outcomes.map(function (o) {
	                            return WideMultiOutcomeSlot.renderOutcome(o, section, gridLocalization);
	                        })
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'renderOutcome',
	        value: function renderOutcome(outcome, section, gridLocalization) {
	            return _react2.default.createElement(_MultiOutcome2.default, { key: outcome.get('id'), outcome: outcome, section: section,
	                gridLocalization: gridLocalization });
	        }
	    }]);
	    return WideMultiOutcomeSlot;
	}(_react2.default.Component);
	
	WideMultiOutcomeSlot.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    sportId: _react2.default.PropTypes.number.isRequired,
	    match: _react2.default.PropTypes.object,
	    slot: _react2.default.PropTypes.object.isRequired,
	    outcomes: _react2.default.PropTypes.array.isRequired,
	    gridLocalization: _react2.default.PropTypes.object.isRequired
	};
	exports.default = WideMultiOutcomeSlot;

/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RegularRate = __webpack_require__(507);
	
	var _RegularRate2 = _interopRequireDefault(_RegularRate);
	
	var _SlotName = __webpack_require__(161);
	
	var _SlotName2 = _interopRequireDefault(_SlotName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WideSingleOutcomeSlot = function (_React$Component) {
	    (0, _inherits3.default)(WideSingleOutcomeSlot, _React$Component);
	
	    function WideSingleOutcomeSlot() {
	        (0, _classCallCheck3.default)(this, WideSingleOutcomeSlot);
	        return (0, _possibleConstructorReturn3.default)(this, (WideSingleOutcomeSlot.__proto__ || (0, _getPrototypeOf2.default)(WideSingleOutcomeSlot)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(WideSingleOutcomeSlot, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return this.props.gridLocalization !== nextProps.gridLocalization || this.props.slot !== nextProps.slot || this.props.outcomes !== nextProps.outcomes;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                section = _props.section,
	                sportId = _props.sportId,
	                slot = _props.slot,
	                outcomes = _props.outcomes,
	                match = _props.match,
	                gridLocalization = _props.gridLocalization;
	
	
	            var outcome = outcomes[0];
	
	            var outcomeRates = [];
	
	            outcome.get('rates').entrySeq().sortBy(function (r) {
	                return r[0];
	            }).forEach(function (r) {
	                outcomeRates.push(r[1]);
	            });
	
	            var slotNameProps = {
	                sportId: sportId,
	                match: match,
	                slot: slot,
	                outcome: outcome,
	                gridLocalization: gridLocalization
	            };
	
	            var props = {
	                section: section,
	                gridLocalization: gridLocalization
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'table detailed who-score' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row inner' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cell main' },
	                        _react2.default.createElement(_SlotName2.default, slotNameProps)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cell rate ss' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'rates' },
	                            outcomeRates.map(function (r) {
	                                return _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: r, id: r }, props));
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return WideSingleOutcomeSlot;
	}(_react2.default.Component);
	
	WideSingleOutcomeSlot.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    sportId: _react2.default.PropTypes.number.isRequired,
	    match: _react2.default.PropTypes.object,
	    slot: _react2.default.PropTypes.object.isRequired,
	    outcomes: _react2.default.PropTypes.array.isRequired,
	    gridLocalization: _react2.default.PropTypes.object.isRequired
	};
	exports.default = WideSingleOutcomeSlot;

/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RegularRate = __webpack_require__(507);
	
	var _RegularRate2 = _interopRequireDefault(_RegularRate);
	
	var _SlotName = __webpack_require__(161);
	
	var _SlotName2 = _interopRequireDefault(_SlotName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchCorrectScoreOutcomeSlot = function (_React$Component) {
	    (0, _inherits3.default)(MatchCorrectScoreOutcomeSlot, _React$Component);
	
	    function MatchCorrectScoreOutcomeSlot() {
	        (0, _classCallCheck3.default)(this, MatchCorrectScoreOutcomeSlot);
	        return (0, _possibleConstructorReturn3.default)(this, (MatchCorrectScoreOutcomeSlot.__proto__ || (0, _getPrototypeOf2.default)(MatchCorrectScoreOutcomeSlot)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(MatchCorrectScoreOutcomeSlot, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return this.props.gridLocalization.languageId !== nextProps.gridLocalization.languageId || this.props.slot !== nextProps.slot || this.props.outcomes !== nextProps.outcomes;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                section = _props.section,
	                sportId = _props.sportId,
	                slot = _props.slot,
	                outcomes = _props.outcomes,
	                match = _props.match,
	                gridLocalization = _props.gridLocalization;
	
	
	            var outcome = outcomes[0];
	
	            var outcomeRates = {};
	
	            outcome.get('rates').entrySeq().sortBy(function (r) {
	                return r[0];
	            }).forEach(function (r) {
	                outcomeRates[r[0]] = r[1];
	            });
	
	            var slotNameProps = {
	                sportId: sportId,
	                match: match,
	                slot: slot,
	                outcome: outcome,
	                gridLocalization: gridLocalization
	            };
	
	            var props = {
	                section: section,
	                gridLocalization: gridLocalization
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'table detailed' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row inner' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cell main' },
	                        _react2.default.createElement(_SlotName2.default, slotNameProps)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cell rate ss' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'correct-score cf' },
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[8], id: outcomeRates[8]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[15], id: outcomeRates[15]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[16], id: outcomeRates[16]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[20], id: outcomeRates[20]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[21], id: outcomeRates[21]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[22], id: outcomeRates[22]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[24], id: outcomeRates[24]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[25], id: outcomeRates[25]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[26], id: outcomeRates[26]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[27], id: outcomeRates[27]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[28], id: outcomeRates[28]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[29], id: outcomeRates[29]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[30], id: outcomeRates[30]
	                            }, props))
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'correct-score cf' },
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[1], id: outcomeRates[1]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[9], id: outcomeRates[9]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[17], id: outcomeRates[17]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[23], id: outcomeRates[23]
	                            }, props))
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'correct-score cf' },
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[2], id: outcomeRates[2]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[3], id: outcomeRates[3]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[10], id: outcomeRates[10]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[4], id: outcomeRates[4]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[11], id: outcomeRates[11]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[18], id: outcomeRates[18]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[5], id: outcomeRates[5]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[12], id: outcomeRates[12]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[19], id: outcomeRates[19]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[6], id: outcomeRates[6]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[13], id: outcomeRates[13]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[7], id: outcomeRates[7]
	                            }, props)),
	                            _react2.default.createElement(_RegularRate2.default, (0, _extends3.default)({ key: outcomeRates[14], id: outcomeRates[14]
	                            }, props))
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return MatchCorrectScoreOutcomeSlot;
	}(_react2.default.Component);
	
	MatchCorrectScoreOutcomeSlot.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    match: _react2.default.PropTypes.object,
	    outcomes: _react2.default.PropTypes.array.isRequired,
	    sportId: _react2.default.PropTypes.number.isRequired,
	    slot: _react2.default.PropTypes.object.isRequired,
	    gridLocalization: _react2.default.PropTypes.object.isRequired
	};
	exports.default = MatchCorrectScoreOutcomeSlot;

/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TennisGameOutcome = __webpack_require__(1237);
	
	var _TennisGameOutcome2 = _interopRequireDefault(_TennisGameOutcome);
	
	var _SlotName = __webpack_require__(161);
	
	var _SlotName2 = _interopRequireDefault(_SlotName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TennisGameSlot = function (_React$Component) {
	    (0, _inherits3.default)(TennisGameSlot, _React$Component);
	
	    function TennisGameSlot() {
	        (0, _classCallCheck3.default)(this, TennisGameSlot);
	        return (0, _possibleConstructorReturn3.default)(this, (TennisGameSlot.__proto__ || (0, _getPrototypeOf2.default)(TennisGameSlot)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(TennisGameSlot, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return this.props.gridLocalization.languageId !== nextProps.gridLocalization.languageId || this.props.slot !== nextProps.slot || this.props.outcomes !== nextProps.outcomes;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                section = _props.section,
	                sportId = _props.sportId,
	                match = _props.match,
	                slot = _props.slot,
	                outcomes = _props.outcomes,
	                gridLocalization = _props.gridLocalization;
	
	
	            var slotNameProps = {
	                sportId: sportId,
	                match: match,
	                slot: slot,
	                outcome: outcomes[0],
	                gridLocalization: gridLocalization
	            };
	
	            var outcomeProps = {
	                section: section,
	                sportId: sportId,
	                match: match,
	                gridLocalization: gridLocalization
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'table detailed long' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row inner' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cell main' },
	                        _react2.default.createElement(_SlotName2.default, slotNameProps)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cell rate ss' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'rates long-total' },
	                            outcomes.map(function (o) {
	                                return TennisGameSlot.renderOutcome(o, outcomeProps);
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'renderOutcome',
	        value: function renderOutcome(outcome, props) {
	            return _react2.default.createElement(_TennisGameOutcome2.default, (0, _extends3.default)({ key: outcome.get('id'), outcome: outcome }, props));
	        }
	    }]);
	    return TennisGameSlot;
	}(_react2.default.Component);
	
	TennisGameSlot.propTypes = {
	    section: _react2.default.PropTypes.string.isRequired,
	    sportId: _react2.default.PropTypes.number.isRequired,
	    match: _react2.default.PropTypes.object,
	    slot: _react2.default.PropTypes.object.isRequired,
	    outcomes: _react2.default.PropTypes.array.isRequired,
	    gridLocalization: _react2.default.PropTypes.object.isRequired
	};
	exports.default = TennisGameSlot;

/***/ },
/* 1250 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var RESULT = exports.RESULT = 1;
	var DOUBLE = exports.DOUBLE = 2;
	var HANDICAP = exports.HANDICAP = 3;
	var TOTAL = exports.TOTAL = 4;

/***/ },
/* 1251 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// sportId to matchFinishPeriodId map
	var End = exports.End = {
	    2: [208],
	    3: [304],
	    4: [406],
	    5: [513],
	    6: [606],
	    7: [710],
	    8: [810],
	    9: [904],
	    12: [1204],
	    18: [1810],
	    19: [1905],
	    20: [2017],
	    28: [2802],
	    29: [2974],
	    30: [3010],
	    31: [3110, 4106],
	    32: [3204],
	    34: [3410],
	    35: [3504],
	    36: [3610],
	    37: [3701],
	    38: [3801, 4206],
	    39: [3901],
	    40: [4001],
	    41: [4106],
	    42: [4206]
	};
	
	// sportId to matchBreakPeriodId map
	var Break = exports.Break = {
	    7: [702, 704, 706, 708],
	    8: [802, 804, 806, 808],
	    9: [902],
	    12: [1202],
	    18: [1802, 1804, 1806, 1808],
	    19: [1902, 1904],
	    29: [2906, 2908, 2910, 2912, 2914, 2964, 2966, 2968, 2970, 2972, 2948, 2950, 2952, 2954, 2956, 2958, 2960, 2962, 2932, 2934, 2936, 2938, 2940, 2942, 2944, 2946, 2916, 2918, 2920, 2922, 2924, 2926, 2928, 2930, 2902, 2904],
	    30: [3002, 3004, 3006, 3008],
	    31: [3108, 3106, 3104, 3102, 4102, 4104],
	    34: [3402, 3404, 3406, 3408],
	    35: [3502],
	    36: [3602, 3604, 3606, 3608],
	    41: [4102, 4104]
	};
	
	// sportId to matchBreakPeriodId map
	var BreakWithoutTimer = exports.BreakWithoutTimer = {
	    7: [702, 704, 706, 708],
	    19: [1902, 1904],
	    30: [3002, 3004, 3006, 3008],
	    31: [3108, 3106, 3104, 3102, 4102, 4104],
	    41: [4102, 4104]
	};

/***/ },
/* 1252 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (slotId, slotType, slotFamily, rate) {
	    var slot = {
	        id: slotId,
	        type: slotType,
	        family: slotFamily,
	        outcomes: []
	    };
	
	    slot.condition = rate ? rate.get('value') : 1;
	
	    return slot;
	};

/***/ },
/* 1253 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (slotId, slotType, slotFamily, outcome) {
	    var slot = {
	        id: slotId,
	        type: slotType,
	        family: slotFamily,
	        outcomes: []
	    };
	
	    slot.condition = outcome.get('condition');
	
	    return slot;
	};

/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _parseFloat = __webpack_require__(510);
	
	var _parseFloat2 = _interopRequireDefault(_parseFloat);
	
	exports.getGroupName = getGroupName;
	exports.getSlotName = getSlotName;
	exports.getOutcomeName = getOutcomeName;
	exports.getRateName = getRateName;
	exports.getMatchInfoText = getMatchInfoText;
	exports.getPeriodName = getPeriodName;
	exports.getFoulsText = getFoulsText;
	exports.getTimeoutText = getTimeoutText;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function numeralFemaleEnding(condition) {
	    var m10 = condition % 10;
	    var m100 = condition % 100;
	
	    if (m10 === 1 && m100 !== 11) {
	        return condition + "-st";
	    }
	
	    if (m10 === 2 && m100 !== 12) {
	        return condition + "-nd";
	    }
	
	    if (m10 === 3 && m100 !== 13) {
	        return condition + "-d";
	    }
	
	    return condition + "-th";
	}
	
	function numeralMaleEnding(condition) {
	    var m10 = condition % 10;
	    var m100 = condition % 100;
	
	    if (m10 === 1 && m100 !== 11) {
	        return condition + "-st";
	    }
	
	    if (m10 === 2 && m100 !== 12) {
	        return condition + "-nd";
	    }
	
	    if (m10 === 3 && m100 !== 13) {
	        return condition + "-d";
	    }
	
	    return condition + "-th";
	}
	
	function numeralNeuterEnding(condition) {
	    var m10 = condition % 10;
	    var m100 = condition % 100;
	
	    if (m10 === 1 && m100 !== 11) {
	        return condition + "-st";
	    }
	
	    if (m10 === 2 && m100 !== 12) {
	        return condition + "-nd";
	    }
	
	    if (m10 === 3 && m100 !== 13) {
	        return condition + "-d";
	    }
	
	    return condition + "-th";
	}
	
	function plural(count, parameters) {
	    return count === 1 ? parameters[0] : parameters[1];
	}
	
	function signed(condition) {
	    if (condition === 0) {
	        return '0';
	    }
	
	    var num = (0, _parseFloat2.default)(condition.toFixed(2));
	
	    if (condition > 0) {
	        return '+' + num.toString();
	    }
	
	    return num.toString();
	}
	
	function europeanHandicapCondition(condition) {
	    if (condition < 0) {
	        return "0:" + Math.abs(condition);
	    } else {
	        return Math.abs(condition) + ":0";
	    }
	}
	
	var sl_b1 = function sl_b1(match, outcome) {
	    return 'Winner';
	};
	var sl_c1 = function sl_c1(match, outcome) {
	    return 'Handicap';
	};
	var sl_d1 = function sl_d1(match, outcome) {
	    return 'Total';
	};
	var sl_e1 = function sl_e1(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']);
	};
	var sl_f1 = function sl_f1(match, outcome) {
	    return "To Score " + numeralNeuterEnding(outcome.condition) + " Point";
	};
	var sl_g1 = function sl_g1(match, outcome) {
	    return match.homeTeam + " Winning Margin - " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']);
	};
	var sl_h1 = function sl_h1(match, outcome) {
	    return match.awayTeam + " Winning Margin - " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']);
	};
	var sl_i1 = function sl_i1(match, outcome) {
	    return match.homeTeam + " Total";
	};
	var sl_j1 = function sl_j1(match, outcome) {
	    return match.awayTeam + " Total";
	};
	var sl_k1 = function sl_k1(match, outcome) {
	    return 'Result';
	};
	var sl_l1 = function sl_l1(match, outcome) {
	    return ' Result';
	};
	var sl_m1 = function sl_m1(match, outcome) {
	    return ' Handicap';
	};
	var sl_n1 = function sl_n1(match, outcome) {
	    return ' Total';
	};
	var sl_o1 = function sl_o1(match, outcome) {
	    return ' Exact Total';
	};
	var sl_p1 = function sl_p1(match, outcome) {
	    return match.homeTeam + " Winning Margin";
	};
	var sl_q1 = function sl_q1(match, outcome) {
	    return match.awayTeam + " Winning Margin";
	};
	var sl_r1 = function sl_r1(match, outcome) {
	    return "Race To " + outcome.condition;
	};
	var sl_s1 = function sl_s1(match, outcome) {
	    return 'Winning Margin';
	};
	var sl_t1 = function sl_t1(match, outcome) {
	    return 'First In Match';
	};
	var sl_u1 = function sl_u1(match, outcome) {
	    return 'Exact Total';
	};
	var sl_v1 = function sl_v1(match, outcome) {
	    return 'How many teams score?';
	};
	var sl_w1 = function sl_w1(match, outcome) {
	    return 'Correct Score';
	};
	var sl_x1 = function sl_x1(match, outcome) {
	    return "Result / Total " + outcome.condition;
	};
	var sl_y1 = function sl_y1(match, outcome) {
	    return 'Even/Odd';
	};
	var sl_z1 = function sl_z1(match, outcome) {
	    return match.homeTeam + " Exact total";
	};
	var sl_a2 = function sl_a2(match, outcome) {
	    return match.awayTeam + " Exact total";
	};
	var sl_b2 = function sl_b2(match, outcome) {
	    return "To Win " + outcome.condition + " Point";
	};
	var sl_c2 = function sl_c2(match, outcome) {
	    return "Race to " + outcome.condition + " kills";
	};
	var sl_d2 = function sl_d2(match, outcome) {
	    return 'First Blood';
	};
	var sl_e2 = function sl_e2(match, outcome) {
	    return match.homeTeam + " to win by";
	};
	var sl_f2 = function sl_f2(match, outcome) {
	    return match.awayTeam + " to win by";
	};
	var sl_g2 = function sl_g2(match, outcome) {
	    return match.homeTeam + " To Score";
	};
	var sl_h2 = function sl_h2(match, outcome) {
	    return match.awayTeam + " To Score";
	};
	var sl_i2 = function sl_i2(match, outcome) {
	    return 'Teams To Score';
	};
	var sl_j2 = function sl_j2(match, outcome) {
	    return match.homeTeam + " Goals";
	};
	var sl_k2 = function sl_k2(match, outcome) {
	    return match.awayTeam + " Goals";
	};
	var sl_l2 = function sl_l2(match, outcome) {
	    return 'Injury Time';
	};
	var sl_m2 = function sl_m2(match, outcome) {
	    return 'Total Even/Odd';
	};
	var sl_n2 = function sl_n2(match, outcome) {
	    return "European Handicap " + europeanHandicapCondition(outcome.condition);
	};
	var sl_o2 = function sl_o2(match, outcome) {
	    return "Who Scores " + numeralMaleEnding(outcome.condition) + " Goal?";
	};
	var sl_p2 = function sl_p2(match, outcome) {
	    return "Rest (current score " + outcome.condition + ":" + outcome.conditionTwo + ")";
	};
	var sl_q2 = function sl_q2(match, outcome) {
	    return 'Double Chance';
	};
	var sl_r2 = function sl_r2(match, outcome) {
	    return 'Двойной исход';
	};
	var sl_s2 = function sl_s2(match, outcome) {
	    return ' Double Chance';
	};
	var sl_t2 = function sl_t2(match, outcome) {
	    return match.homeTeam + "  Total";
	};
	var sl_u2 = function sl_u2(match, outcome) {
	    return match.awayTeam + "  Total";
	};
	var sl_v2 = function sl_v2(match, outcome) {
	    return 'Full Time Result';
	};
	var sl_w2 = function sl_w2(match, outcome) {
	    return 'Full Time Handicap';
	};
	var sl_x2 = function sl_x2(match, outcome) {
	    return 'To Be Corner Kicks From Each Pitch Corner';
	};
	var sl_y2 = function sl_y2(match, outcome) {
	    return "Total: " + match.homeTeam;
	};
	var sl_z2 = function sl_z2(match, outcome) {
	    return "Total: " + match.awayTeam;
	};
	var sl_a3 = function sl_a3(match, outcome) {
	    return 'Corners';
	};
	var sl_b3 = function sl_b3(match, outcome) {
	    return 'For Simulation';
	};
	var sl_c3 = function sl_c3(match, outcome) {
	    return 'For Taken Off T-Shirt';
	};
	var sl_d3 = function sl_d3(match, outcome) {
	    return 'Exact Score';
	};
	var sl_e3 = function sl_e3(match, outcome) {
	    return match.homeTeam + " - " + match.awayTeam;
	};
	var sl_f3 = function sl_f3(match, outcome) {
	    return "Who Scores " + numeralMaleEnding(outcome.condition) + " goal?";
	};
	var sl_g3 = function sl_g3(match, outcome) {
	    return "Total Penalty Scored: " + match.awayTeam;
	};
	var sl_h3 = function sl_h3(match, outcome) {
	    return "Total Penalty Scored: " + match.homeTeam;
	};
	var sl_i3 = function sl_i3(match, outcome) {
	    return 'Total Penalty Scored';
	};
	var sl_j3 = function sl_j3(match, outcome) {
	    return 'Total Penalty Missed';
	};
	var sl_k3 = function sl_k3(match, outcome) {
	    return 'How many teams score';
	};
	var sl_l3 = function sl_l3(match, outcome) {
	    return 'First Player To Pot';
	};
	var sl_m3 = function sl_m3(match, outcome) {
	    return 'First Legally Potted Colour';
	};
	var sl_n3 = function sl_n3(match, outcome) {
	    return numeralNeuterEnding(outcome.condition) + " Point";
	};
	var sl_o3 = function sl_o3(match, outcome) {
	    return "To Be In " + outcome.condition + " game";
	};
	var sl_p3 = function sl_p3(match, outcome) {
	    return 'Breaks Total';
	};
	var sl_q3 = function sl_q3(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['Game', 'Games', 'Games']);
	};
	var sl_r3 = function sl_r3(match, outcome) {
	    return 'Score';
	};
	var sl_s3 = function sl_s3(match, outcome) {
	    return "Result & Total " + outcome.condition;
	};
	var sl_t3 = function sl_t3(match, outcome) {
	    return 'Tie Break';
	};
	var sl_u3 = function sl_u3(match, outcome) {
	    return 'Tie Break Winner';
	};
	var sl_v3 = function sl_v3(match, outcome) {
	    return 'Tie Break Exact Total';
	};
	var sl_w3 = function sl_w3(match, outcome) {
	    return 'Tie-Break Score';
	};
	var sl_x3 = function sl_x3(match, outcome) {
	    return 'Tie-Break Total';
	};
	var sl_y3 = function sl_y3(match, outcome) {
	    return match.homeTeam + " Breaks Total";
	};
	var sl_z3 = function sl_z3(match, outcome) {
	    return match.awayTeam + " Breaks Total";
	};
	var sl_a4 = function sl_a4(match, outcome) {
	    return "A Player To Win " + outcome.condition + " " + plural(outcome.condition, ['Game', 'Games', 'Games']) + " In A Row";
	};
	var sl_b4 = function sl_b4(match, outcome) {
	    return match.homeTeam + " To Win " + outcome.condition + " " + plural(outcome.condition, ['Game', 'Games', 'Games']) + " In A Row";
	};
	var sl_c4 = function sl_c4(match, outcome) {
	    return match.awayTeam + " To Win " + outcome.condition + " " + plural(outcome.condition, ['Game', 'Games', 'Games']) + " In A Row";
	};
	var sl_d4 = function sl_d4(match, outcome) {
	    return 'Breaks Result';
	};
	var sl_e4 = function sl_e4(match, outcome) {
	    return 'Breaks Handicap';
	};
	var sl_f4 = function sl_f4(match, outcome) {
	    return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 " + numeralNeuterEnding(outcome.condition) + " \u043E\u0447\u043A\u043E";
	};
	
	var bo_b1 = function bo_b1(match, outcome) {
	    return 'Handicap';
	};
	var bo_c1 = function bo_c1(match, outcome) {
	    return 'Game Total';
	};
	var bo_d1 = function bo_d1(match, outcome) {
	    return match.homeTeam + " Total";
	};
	var bo_e1 = function bo_e1(match, outcome) {
	    return match.awayTeam + " Total";
	};
	var bo_f1 = function bo_f1(match, outcome) {
	    return 'Game Total Even/Odd';
	};
	var bo_g1 = function bo_g1(match, outcome) {
	    return match.homeTeam + " - " + match.awayTeam;
	};
	var bo_h1 = function bo_h1(match, outcome) {
	    return outcome.teamOne + " - " + outcome.teamTwo;
	};
	var bo_i1 = function bo_i1(match, outcome) {
	    return "" + outcome.teamOne;
	};
	var bo_j1 = function bo_j1(match, outcome) {
	    return 'Match Total';
	};
	var bo_k1 = function bo_k1(match, outcome) {
	    return 'First Game Handicap';
	};
	var bo_l1 = function bo_l1(match, outcome) {
	    return 'Second Game Handicap';
	};
	var bo_m1 = function bo_m1(match, outcome) {
	    return 'Third Game Handicap';
	};
	var bo_n1 = function bo_n1(match, outcome) {
	    return 'First Game Total';
	};
	var bo_o1 = function bo_o1(match, outcome) {
	    return 'Second Game Total';
	};
	var bo_p1 = function bo_p1(match, outcome) {
	    return 'Third Game Total';
	};
	var bo_q1 = function bo_q1(match, outcome) {
	    return 'Total Games In Match';
	};
	var bo_r1 = function bo_r1(match, outcome) {
	    return 'Match Score';
	};
	var bo_s1 = function bo_s1(match, outcome) {
	    return 'Match Total Even/Odd';
	};
	var bo_t1 = function bo_t1(match, outcome) {
	    return 'First Game Winner';
	};
	var bo_u1 = function bo_u1(match, outcome) {
	    return 'Second Game Winner';
	};
	var bo_v1 = function bo_v1(match, outcome) {
	    return 'Third Game Winner';
	};
	var bo_w1 = function bo_w1(match, outcome) {
	    return match.homeTeam + " First Game Total";
	};
	var bo_x1 = function bo_x1(match, outcome) {
	    return match.homeTeam + " Second Game Total";
	};
	var bo_y1 = function bo_y1(match, outcome) {
	    return match.homeTeam + " Third Game Total";
	};
	var bo_z1 = function bo_z1(match, outcome) {
	    return match.awayTeam + " First Game Total";
	};
	var bo_a2 = function bo_a2(match, outcome) {
	    return match.awayTeam + " Second Game Total";
	};
	var bo_b2 = function bo_b2(match, outcome) {
	    return match.awayTeam + " Third Game Total";
	};
	var bo_c2 = function bo_c2(match, outcome) {
	    return match.homeTeam + " First Game Winning Margin - " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']);
	};
	var bo_d2 = function bo_d2(match, outcome) {
	    return match.homeTeam + " Second Game Winning Margin - " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']);
	};
	var bo_e2 = function bo_e2(match, outcome) {
	    return match.homeTeam + " Third Game Winning Margin - " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']);
	};
	var bo_f2 = function bo_f2(match, outcome) {
	    return match.awayTeam + " First Game Winning Margin - " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']);
	};
	var bo_g2 = function bo_g2(match, outcome) {
	    return match.awayTeam + " Second Game Winning Margin - " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']);
	};
	var bo_h2 = function bo_h2(match, outcome) {
	    return match.awayTeam + " Third Game Winning Margin - " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']);
	};
	var bo_i2 = function bo_i2(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " - First Game";
	};
	var bo_j2 = function bo_j2(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " - Second Game";
	};
	var bo_k2 = function bo_k2(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " - Third Game";
	};
	var bo_l2 = function bo_l2(match, outcome) {
	    return "To Score " + numeralNeuterEnding(outcome.condition) + " Point - First Game";
	};
	var bo_m2 = function bo_m2(match, outcome) {
	    return "To Score " + numeralNeuterEnding(outcome.condition) + " Point - Second Game";
	};
	var bo_n2 = function bo_n2(match, outcome) {
	    return "To Score " + numeralNeuterEnding(outcome.condition) + " Point - Third Game";
	};
	var bo_o2 = function bo_o2(match, outcome) {
	    return match.homeTeam + " Match Total";
	};
	var bo_p2 = function bo_p2(match, outcome) {
	    return match.awayTeam + " Match Total";
	};
	var bo_q2 = function bo_q2(match, outcome) {
	    return '10 Points Miniset Winner - First Set';
	};
	var bo_r2 = function bo_r2(match, outcome) {
	    return '10 Points Miniset Winner - Second Set';
	};
	var bo_s2 = function bo_s2(match, outcome) {
	    return '10 Points Miniset Winner - Third Set';
	};
	var bo_t2 = function bo_t2(match, outcome) {
	    return '10 Points Miniset Handicap - First Set';
	};
	var bo_u2 = function bo_u2(match, outcome) {
	    return '10 Points Miniset Handicap - Second Set';
	};
	var bo_v2 = function bo_v2(match, outcome) {
	    return '10 Points Miniset Handicap - Third Set';
	};
	var bo_w2 = function bo_w2(match, outcome) {
	    return '10 Points Miniset Total - First Set';
	};
	var bo_x2 = function bo_x2(match, outcome) {
	    return '10 Points Miniset Total - Second Set';
	};
	var bo_y2 = function bo_y2(match, outcome) {
	    return '10 Points Miniset Total - Third Set';
	};
	var bo_z2 = function bo_z2(match, outcome) {
	    return '15 Points Miniset Winner - First Set';
	};
	var bo_a3 = function bo_a3(match, outcome) {
	    return '15 Points Miniset Winner - Second Set';
	};
	var bo_b3 = function bo_b3(match, outcome) {
	    return '15 Points Miniset Winner - Third Set';
	};
	var bo_c3 = function bo_c3(match, outcome) {
	    return '15 Points Miniset Handicap - First Set';
	};
	var bo_d3 = function bo_d3(match, outcome) {
	    return '15 Points Miniset Handicap - Second Set';
	};
	var bo_e3 = function bo_e3(match, outcome) {
	    return '15 Points Miniset Handicap - Third Set';
	};
	var bo_f3 = function bo_f3(match, outcome) {
	    return '15 Points Miniset Total - First Set';
	};
	var bo_g3 = function bo_g3(match, outcome) {
	    return '15 Points Miniset Total - Second Set';
	};
	var bo_h3 = function bo_h3(match, outcome) {
	    return '15 Points Miniset Total - Third Set';
	};
	var bo_i3 = function bo_i3(match, outcome) {
	    return match.homeTeam + " First Half Total";
	};
	var bo_j3 = function bo_j3(match, outcome) {
	    return 'First Half Handicap';
	};
	var bo_k3 = function bo_k3(match, outcome) {
	    return 'First Half Result';
	};
	var bo_l3 = function bo_l3(match, outcome) {
	    return match.awayTeam + " First Half Total";
	};
	var bo_m3 = function bo_m3(match, outcome) {
	    return "Team To Score The " + numeralMaleEnding(outcome.condition) + " Goal";
	};
	var bo_n3 = function bo_n3(match, outcome) {
	    return 'Double Chance';
	};
	var bo_o3 = function bo_o3(match, outcome) {
	    return 'First Half Total';
	};
	var bo_p3 = function bo_p3(match, outcome) {
	    return "Match Result / Total " + outcome.condition;
	};
	var bo_q3 = function bo_q3(match, outcome) {
	    return match.homeTeam + " Winning Margin - Exactly " + outcome.condition + " " + plural(outcome.condition, ['Goal', 'Goals', 'Goals']);
	};
	var bo_r3 = function bo_r3(match, outcome) {
	    return match.awayTeam + " Winning Margin - Exactly " + outcome.condition + " " + plural(outcome.condition, ['Goal', 'Goals', 'Goals']);
	};
	var bo_s3 = function bo_s3(match, outcome) {
	    return 'Full Time Exact Total';
	};
	var bo_t3 = function bo_t3(match, outcome) {
	    return 'Teams To Score';
	};
	var bo_u3 = function bo_u3(match, outcome) {
	    return 'Full Time Correct Score';
	};
	var bo_v3 = function bo_v3(match, outcome) {
	    return 'Asian Handicap';
	};
	var bo_w3 = function bo_w3(match, outcome) {
	    return 'First Quarter Handicap';
	};
	var bo_x3 = function bo_x3(match, outcome) {
	    return 'Second Quarter Handicap';
	};
	var bo_y3 = function bo_y3(match, outcome) {
	    return 'Third Quarter Handicap';
	};
	var bo_z3 = function bo_z3(match, outcome) {
	    return 'Fourth Quarter Handicap';
	};
	var bo_a4 = function bo_a4(match, outcome) {
	    return 'First Quarter Total';
	};
	var bo_b4 = function bo_b4(match, outcome) {
	    return 'Second Quarter Total';
	};
	var bo_c4 = function bo_c4(match, outcome) {
	    return 'Third Quarter Total';
	};
	var bo_d4 = function bo_d4(match, outcome) {
	    return 'Fourth Quarter Total';
	};
	var bo_e4 = function bo_e4(match, outcome) {
	    return 'First Quarter Result';
	};
	var bo_f4 = function bo_f4(match, outcome) {
	    return 'Second Quarter Result';
	};
	var bo_g4 = function bo_g4(match, outcome) {
	    return 'Third Quarter Result';
	};
	var bo_h4 = function bo_h4(match, outcome) {
	    return 'Fourth Quarter Result';
	};
	var bo_i4 = function bo_i4(match, outcome) {
	    return 'Game Total Odd/Even';
	};
	var bo_j4 = function bo_j4(match, outcome) {
	    return match.homeTeam + " First Quarter Total";
	};
	var bo_k4 = function bo_k4(match, outcome) {
	    return match.homeTeam + " Second Quarter Total";
	};
	var bo_l4 = function bo_l4(match, outcome) {
	    return match.homeTeam + " Third Quarter Total";
	};
	var bo_m4 = function bo_m4(match, outcome) {
	    return match.homeTeam + " Fourth Quarter Total";
	};
	var bo_n4 = function bo_n4(match, outcome) {
	    return match.awayTeam + " First Quarter Total";
	};
	var bo_o4 = function bo_o4(match, outcome) {
	    return match.awayTeam + " Second Quarter Total";
	};
	var bo_p4 = function bo_p4(match, outcome) {
	    return match.awayTeam + " Third Quarter Total";
	};
	var bo_q4 = function bo_q4(match, outcome) {
	    return match.awayTeam + " Fourth Quarter Total";
	};
	var bo_r4 = function bo_r4(match, outcome) {
	    return 'Second Half Result';
	};
	var bo_s4 = function bo_s4(match, outcome) {
	    return 'Second Half Total';
	};
	var bo_t4 = function bo_t4(match, outcome) {
	    return 'Second Half Handicap';
	};
	var bo_u4 = function bo_u4(match, outcome) {
	    return match.homeTeam + " Second Half Total";
	};
	var bo_v4 = function bo_v4(match, outcome) {
	    return match.awayTeam + " Second Half Total";
	};
	var bo_w4 = function bo_w4(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['points', 'points', 'points']) + "  In The 1st Quarter";
	};
	var bo_x4 = function bo_x4(match, outcome) {
	    return "Race To Score " + outcome.condition + " " + plural(outcome.condition, ['points', 'points', 'points']) + "  In The 2nd Quarter";
	};
	var bo_y4 = function bo_y4(match, outcome) {
	    return "Race To Score " + outcome.condition + " " + plural(outcome.condition, ['points', 'points', 'points']) + "  In The 3rd Quarter";
	};
	var bo_z4 = function bo_z4(match, outcome) {
	    return "Race To Score " + outcome.condition + " " + plural(outcome.condition, ['points', 'points', 'points']) + "  In The 4th Quarter";
	};
	var bo_a5 = function bo_a5(match, outcome) {
	    return 'Game Exact Total';
	};
	var bo_b5 = function bo_b5(match, outcome) {
	    return 'First Quarter Exact Total';
	};
	var bo_c5 = function bo_c5(match, outcome) {
	    return 'Second Quarter Exact Total';
	};
	var bo_d5 = function bo_d5(match, outcome) {
	    return 'Third Quarter Exact Total';
	};
	var bo_e5 = function bo_e5(match, outcome) {
	    return 'Fourth Quarter Exact Total';
	};
	var bo_f5 = function bo_f5(match, outcome) {
	    return match.homeTeam + " Winning Margin";
	};
	var bo_g5 = function bo_g5(match, outcome) {
	    return match.awayTeam + " Winning Margin";
	};
	var bo_h5 = function bo_h5(match, outcome) {
	    return 'To Qualify Next Round';
	};
	var bo_i5 = function bo_i5(match, outcome) {
	    return match.homeTeam + " To Win All Quarters";
	};
	var bo_j5 = function bo_j5(match, outcome) {
	    return match.awayTeam + " To Win All Quarters";
	};
	var bo_k5 = function bo_k5(match, outcome) {
	    return match.homeTeam + " To Win Both Halves";
	};
	var bo_l5 = function bo_l5(match, outcome) {
	    return match.awayTeam + " To Win Both Halves";
	};
	var bo_m5 = function bo_m5(match, outcome) {
	    return 'Highest Scoring Half';
	};
	var bo_n5 = function bo_n5(match, outcome) {
	    return 'Highest Scoring Quarter';
	};
	var bo_o5 = function bo_o5(match, outcome) {
	    return 'Highest Scoring Quarter Total';
	};
	var bo_p5 = function bo_p5(match, outcome) {
	    return 'Lowest Scoring Quarter Total';
	};
	var bo_q5 = function bo_q5(match, outcome) {
	    return match.homeTeam + " To Win First Quarter & Game";
	};
	var bo_r5 = function bo_r5(match, outcome) {
	    return match.awayTeam + " To Win First Quarter & Game";
	};
	var bo_s5 = function bo_s5(match, outcome) {
	    return match.homeTeam + " To Win First Half & Game";
	};
	var bo_t5 = function bo_t5(match, outcome) {
	    return match.awayTeam + " To Win First Half & Game";
	};
	var bo_u5 = function bo_u5(match, outcome) {
	    return 'Will There Be Overtime?';
	};
	var bo_v5 = function bo_v5(match, outcome) {
	    return 'Winning Margin';
	};
	var bo_w5 = function bo_w5(match, outcome) {
	    return match.homeTeam + " First Quarter Winning Margin";
	};
	var bo_x5 = function bo_x5(match, outcome) {
	    return match.homeTeam + " Second Quarter Winning Margin";
	};
	var bo_y5 = function bo_y5(match, outcome) {
	    return match.homeTeam + " Third Quarter Winning Margin";
	};
	var bo_z5 = function bo_z5(match, outcome) {
	    return match.homeTeam + " Fourth Quarter Winning Margin";
	};
	var bo_a6 = function bo_a6(match, outcome) {
	    return match.awayTeam + " First Quarter Winning Margin";
	};
	var bo_b6 = function bo_b6(match, outcome) {
	    return match.awayTeam + " Second Quarter Winning Margin";
	};
	var bo_c6 = function bo_c6(match, outcome) {
	    return match.awayTeam + " Third Quarter Winning Margin";
	};
	var bo_d6 = function bo_d6(match, outcome) {
	    return match.awayTeam + " Fourth Quarter Winning Margin";
	};
	var bo_e6 = function bo_e6(match, outcome) {
	    return outcome.playerName + " (" + match.homeTeam + ") Total";
	};
	var bo_f6 = function bo_f6(match, outcome) {
	    return outcome.playerName + " (" + match.awayTeam + ") Total";
	};
	var bo_g6 = function bo_g6(match, outcome) {
	    return '3-Pointers Total';
	};
	var bo_h6 = function bo_h6(match, outcome) {
	    return '2-Pointers Total';
	};
	var bo_i6 = function bo_i6(match, outcome) {
	    return match.homeTeam + " 3-Pointers Total";
	};
	var bo_j6 = function bo_j6(match, outcome) {
	    return match.awayTeam + " 3-Pointers Total";
	};
	var bo_k6 = function bo_k6(match, outcome) {
	    return match.homeTeam + " 2-Pointers Total";
	};
	var bo_l6 = function bo_l6(match, outcome) {
	    return match.awayTeam + " 2-Pointers Total";
	};
	var bo_m6 = function bo_m6(match, outcome) {
	    return '3-Pointers Handicap';
	};
	var bo_n6 = function bo_n6(match, outcome) {
	    return '2-Pointers Handicap';
	};
	var bo_o6 = function bo_o6(match, outcome) {
	    return '3-Pointers Result';
	};
	var bo_p6 = function bo_p6(match, outcome) {
	    return '2-Pointers Result';
	};
	var bo_q6 = function bo_q6(match, outcome) {
	    return 'Lowest Scoring Quarter';
	};
	var bo_r6 = function bo_r6(match, outcome) {
	    return 'Match Total Assists';
	};
	var bo_s6 = function bo_s6(match, outcome) {
	    return match.homeTeam + " Match Total Assists";
	};
	var bo_t6 = function bo_t6(match, outcome) {
	    return match.awayTeam + " Match Total Assists";
	};
	var bo_u6 = function bo_u6(match, outcome) {
	    return 'Assists Match Handicap';
	};
	var bo_v6 = function bo_v6(match, outcome) {
	    return 'Assists Result';
	};
	var bo_w6 = function bo_w6(match, outcome) {
	    return 'First 2-Pointer In Match';
	};
	var bo_x6 = function bo_x6(match, outcome) {
	    return 'First 3-Pointer In Match';
	};
	var bo_y6 = function bo_y6(match, outcome) {
	    return 'First Free Throw In Match';
	};
	var bo_z6 = function bo_z6(match, outcome) {
	    return 'To Happen First';
	};
	var bo_a7 = function bo_a7(match, outcome) {
	    return 'Most Points In A Quarter';
	};
	var bo_b7 = function bo_b7(match, outcome) {
	    return "Race To " + outcome.condition + " Points In Match";
	};
	var bo_c7 = function bo_c7(match, outcome) {
	    return 'Triple-Double Total In Match';
	};
	var bo_d7 = function bo_d7(match, outcome) {
	    return 'Double-Double Total In Match';
	};
	var bo_e7 = function bo_e7(match, outcome) {
	    return "Race To " + outcome.condition + " - First Quarter";
	};
	var bo_f7 = function bo_f7(match, outcome) {
	    return "Race To " + outcome.condition + " - Second Quarter";
	};
	var bo_g7 = function bo_g7(match, outcome) {
	    return "Race To " + outcome.condition + " - Third Quarter";
	};
	var bo_h7 = function bo_h7(match, outcome) {
	    return "Race To " + outcome.condition + " - Fourth Quarter";
	};
	var bo_i7 = function bo_i7(match, outcome) {
	    return 'Winning Margin 3-Way';
	};
	var bo_j7 = function bo_j7(match, outcome) {
	    return 'Winning Margin - First Quarter';
	};
	var bo_k7 = function bo_k7(match, outcome) {
	    return 'Winning Margin - Second Quarter';
	};
	var bo_l7 = function bo_l7(match, outcome) {
	    return 'Winning Margin - Third Quarter';
	};
	var bo_m7 = function bo_m7(match, outcome) {
	    return 'Winning Margin - Fourth Quarter';
	};
	var bo_n7 = function bo_n7(match, outcome) {
	    return 'First Half Exact Total';
	};
	var bo_o7 = function bo_o7(match, outcome) {
	    return 'Second Half Exact Total';
	};
	var bo_p7 = function bo_p7(match, outcome) {
	    return match.homeTeam + " First Half Winning Margin";
	};
	var bo_q7 = function bo_q7(match, outcome) {
	    return match.homeTeam + " Second Half Winning Margin";
	};
	var bo_r7 = function bo_r7(match, outcome) {
	    return match.awayTeam + " First Half Winning Margin";
	};
	var bo_s7 = function bo_s7(match, outcome) {
	    return match.awayTeam + " Second Half Winning Margin";
	};
	var bo_t7 = function bo_t7(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['points', 'points', 'points']) + "  In The 1st Half";
	};
	var bo_u7 = function bo_u7(match, outcome) {
	    return "Race To Score " + outcome.condition + " " + plural(outcome.condition, ['points', 'points', 'points']) + "  In The 2nd Half";
	};
	var bo_v7 = function bo_v7(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u043C\u0430\u0442\u0447\u0435";
	};
	var bo_w7 = function bo_w7(match, outcome) {
	    return 'Highest Scoring Half Total';
	};
	var bo_x7 = function bo_x7(match, outcome) {
	    return 'Lowest Scoring Half Total';
	};
	var bo_y7 = function bo_y7(match, outcome) {
	    return "Race To " + outcome.condition + " - First Half";
	};
	var bo_z7 = function bo_z7(match, outcome) {
	    return "Race To " + outcome.condition + " - Second Half";
	};
	var bo_a8 = function bo_a8(match, outcome) {
	    return 'First Period Total';
	};
	var bo_b8 = function bo_b8(match, outcome) {
	    return 'Second Period Total';
	};
	var bo_c8 = function bo_c8(match, outcome) {
	    return 'Third Period Total';
	};
	var bo_d8 = function bo_d8(match, outcome) {
	    return 'First Period Result';
	};
	var bo_e8 = function bo_e8(match, outcome) {
	    return 'Second Period Result';
	};
	var bo_f8 = function bo_f8(match, outcome) {
	    return 'Third Period Result';
	};
	var bo_g8 = function bo_g8(match, outcome) {
	    return 'To Win Match (inc. Penalty Shootouts)';
	};
	var bo_h8 = function bo_h8(match, outcome) {
	    return 'How many teams score in the 1 period';
	};
	var bo_i8 = function bo_i8(match, outcome) {
	    return 'How many teams score in the 2 period';
	};
	var bo_j8 = function bo_j8(match, outcome) {
	    return 'How many teams score in the 3 period';
	};
	var bo_k8 = function bo_k8(match, outcome) {
	    return 'Period&Match';
	};
	var bo_l8 = function bo_l8(match, outcome) {
	    return 'Overtime Total';
	};
	var bo_m8 = function bo_m8(match, outcome) {
	    return 'Overtime Result';
	};
	var bo_n8 = function bo_n8(match, outcome) {
	    return 'Overtime Handicap';
	};
	var bo_o8 = function bo_o8(match, outcome) {
	    return 'Final Score';
	};
	var bo_p8 = function bo_p8(match, outcome) {
	    return 'First Period Handicap';
	};
	var bo_q8 = function bo_q8(match, outcome) {
	    return 'Second Period Handicap';
	};
	var bo_r8 = function bo_r8(match, outcome) {
	    return 'Third Period Handicap';
	};
	var bo_s8 = function bo_s8(match, outcome) {
	    return 'First Period Correct Score';
	};
	var bo_t8 = function bo_t8(match, outcome) {
	    return 'Second Period Correct Score';
	};
	var bo_u8 = function bo_u8(match, outcome) {
	    return 'Third Period Correct Score';
	};
	var bo_v8 = function bo_v8(match, outcome) {
	    return numeralMaleEnding(outcome.condition) + " Goal";
	};
	var bo_w8 = function bo_w8(match, outcome) {
	    return 'First Set Handicap';
	};
	var bo_x8 = function bo_x8(match, outcome) {
	    return 'Second Set Handicap';
	};
	var bo_y8 = function bo_y8(match, outcome) {
	    return 'Third Set Handicap';
	};
	var bo_z8 = function bo_z8(match, outcome) {
	    return 'First Set Total';
	};
	var bo_a9 = function bo_a9(match, outcome) {
	    return 'Second Set Total';
	};
	var bo_b9 = function bo_b9(match, outcome) {
	    return 'Third Set Total';
	};
	var bo_c9 = function bo_c9(match, outcome) {
	    return 'Sets Total';
	};
	var bo_d9 = function bo_d9(match, outcome) {
	    return match.homeTeam + " First Set Total";
	};
	var bo_e9 = function bo_e9(match, outcome) {
	    return match.homeTeam + " Second Set Total";
	};
	var bo_f9 = function bo_f9(match, outcome) {
	    return match.homeTeam + " Third Set Total";
	};
	var bo_g9 = function bo_g9(match, outcome) {
	    return match.awayTeam + " First Set Total";
	};
	var bo_h9 = function bo_h9(match, outcome) {
	    return match.awayTeam + " Second Set Total";
	};
	var bo_i9 = function bo_i9(match, outcome) {
	    return match.awayTeam + " Third Set Total";
	};
	var bo_j9 = function bo_j9(match, outcome) {
	    return 'First Set Winner';
	};
	var bo_k9 = function bo_k9(match, outcome) {
	    return 'Second Set Winner';
	};
	var bo_l9 = function bo_l9(match, outcome) {
	    return 'Third Set Winner';
	};
	var bo_m9 = function bo_m9(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " - First Set";
	};
	var bo_n9 = function bo_n9(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " - Second Set";
	};
	var bo_o9 = function bo_o9(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " - Third Set";
	};
	var bo_p9 = function bo_p9(match, outcome) {
	    return 'Sets Handicap';
	};
	var bo_q9 = function bo_q9(match, outcome) {
	    return 'First Set Exact total';
	};
	var bo_r9 = function bo_r9(match, outcome) {
	    return 'Second Set Exact total';
	};
	var bo_s9 = function bo_s9(match, outcome) {
	    return 'Third Set Exact total';
	};
	var bo_t9 = function bo_t9(match, outcome) {
	    return match.homeTeam + " First Set Winning Margin";
	};
	var bo_u9 = function bo_u9(match, outcome) {
	    return match.homeTeam + " Second Set Winning Margin";
	};
	var bo_v9 = function bo_v9(match, outcome) {
	    return match.homeTeam + " Third Set Winning Margin";
	};
	var bo_w9 = function bo_w9(match, outcome) {
	    return match.awayTeam + " First Set Winning Margin";
	};
	var bo_x9 = function bo_x9(match, outcome) {
	    return match.awayTeam + " Second Set Winning Margin";
	};
	var bo_y9 = function bo_y9(match, outcome) {
	    return match.awayTeam + " Third Set Winning Margin";
	};
	var bo_z9 = function bo_z9(match, outcome) {
	    return 'First Set Even/Odd';
	};
	var bo_a10 = function bo_a10(match, outcome) {
	    return 'Second Set Even/Odd';
	};
	var bo_b10 = function bo_b10(match, outcome) {
	    return 'Third Set Even/Odd';
	};
	var bo_c10 = function bo_c10(match, outcome) {
	    return "First Set Result / Total " + outcome.condition;
	};
	var bo_d10 = function bo_d10(match, outcome) {
	    return "Second Set Result / Total " + outcome.condition;
	};
	var bo_e10 = function bo_e10(match, outcome) {
	    return "Third Set Result / Total " + outcome.condition;
	};
	var bo_f10 = function bo_f10(match, outcome) {
	    return 'To Win condition Point - First Set';
	};
	var bo_g10 = function bo_g10(match, outcome) {
	    return 'To Win condition Point - Second Set';
	};
	var bo_h10 = function bo_h10(match, outcome) {
	    return 'To Win condition Point - Third Set';
	};
	var bo_i10 = function bo_i10(match, outcome) {
	    return "Full time Result / Total " + outcome.condition;
	};
	var bo_j10 = function bo_j10(match, outcome) {
	    return 'First Set Winning Margin';
	};
	var bo_k10 = function bo_k10(match, outcome) {
	    return 'Second Set Winning Margin';
	};
	var bo_l10 = function bo_l10(match, outcome) {
	    return 'Third Set Winning Margin';
	};
	var bo_m10 = function bo_m10(match, outcome) {
	    return 'Race Total';
	};
	var bo_n10 = function bo_n10(match, outcome) {
	    return 'First Fire Line Total';
	};
	var bo_o10 = function bo_o10(match, outcome) {
	    return 'Second Fire Line Total';
	};
	var bo_p10 = function bo_p10(match, outcome) {
	    return 'Third Fire Line Total';
	};
	var bo_q10 = function bo_q10(match, outcome) {
	    return 'Fourth Fire Line Total';
	};
	var bo_r10 = function bo_r10(match, outcome) {
	    return 'Fifth Fire Line Total';
	};
	var bo_s10 = function bo_s10(match, outcome) {
	    return 'Sixth Fire Line Total';
	};
	var bo_t10 = function bo_t10(match, outcome) {
	    return 'Seventh Fire Line Total';
	};
	var bo_u10 = function bo_u10(match, outcome) {
	    return 'Eighth Fire Line Total';
	};
	var bo_v10 = function bo_v10(match, outcome) {
	    return match.homeTeam + " First Fire Line Total";
	};
	var bo_w10 = function bo_w10(match, outcome) {
	    return match.homeTeam + " Second Fire Line Total";
	};
	var bo_x10 = function bo_x10(match, outcome) {
	    return match.homeTeam + " Third Fire Line Total";
	};
	var bo_y10 = function bo_y10(match, outcome) {
	    return match.homeTeam + " Fourth Fire Line Total";
	};
	var bo_z10 = function bo_z10(match, outcome) {
	    return match.homeTeam + " Fifth Fire Line Total";
	};
	var bo_a11 = function bo_a11(match, outcome) {
	    return match.homeTeam + " Sixth Fire Line Total";
	};
	var bo_b11 = function bo_b11(match, outcome) {
	    return match.homeTeam + " Seventh Fire Line Total";
	};
	var bo_c11 = function bo_c11(match, outcome) {
	    return match.homeTeam + " Eighth Fire Line Total";
	};
	var bo_d11 = function bo_d11(match, outcome) {
	    return match.awayTeam + " First Fire Line Total";
	};
	var bo_e11 = function bo_e11(match, outcome) {
	    return match.awayTeam + " Second Fire Line Total";
	};
	var bo_f11 = function bo_f11(match, outcome) {
	    return match.awayTeam + " Third Fire Line Total";
	};
	var bo_g11 = function bo_g11(match, outcome) {
	    return match.awayTeam + " Fourth Fire Line Total";
	};
	var bo_h11 = function bo_h11(match, outcome) {
	    return match.awayTeam + " Fifth Fire Line Total";
	};
	var bo_i11 = function bo_i11(match, outcome) {
	    return match.awayTeam + " Sixth Fire Line Total";
	};
	var bo_j11 = function bo_j11(match, outcome) {
	    return match.awayTeam + " Seventh Fire Line Total";
	};
	var bo_k11 = function bo_k11(match, outcome) {
	    return match.awayTeam + " Eighth Fire Line Total";
	};
	var bo_l11 = function bo_l11(match, outcome) {
	    return 'First Fire Line Handicap';
	};
	var bo_m11 = function bo_m11(match, outcome) {
	    return 'Second Fire Line Handicap';
	};
	var bo_n11 = function bo_n11(match, outcome) {
	    return 'Third Fire Line Handicap';
	};
	var bo_o11 = function bo_o11(match, outcome) {
	    return 'Fourth Fire Line Handicap';
	};
	var bo_p11 = function bo_p11(match, outcome) {
	    return 'Fifth Fire Line Handicap';
	};
	var bo_q11 = function bo_q11(match, outcome) {
	    return 'Sixth Fire Line Handicap';
	};
	var bo_r11 = function bo_r11(match, outcome) {
	    return 'Seventh Fire Line Handicap';
	};
	var bo_s11 = function bo_s11(match, outcome) {
	    return 'Eighth Fire Line Handicap';
	};
	var bo_t11 = function bo_t11(match, outcome) {
	    return 'First Fire Line Result';
	};
	var bo_u11 = function bo_u11(match, outcome) {
	    return 'Second Fire Line Result';
	};
	var bo_v11 = function bo_v11(match, outcome) {
	    return 'Third Fire Line Result';
	};
	var bo_w11 = function bo_w11(match, outcome) {
	    return 'Fourth Fire Line Result';
	};
	var bo_x11 = function bo_x11(match, outcome) {
	    return 'Fifth Fire Line Result';
	};
	var bo_y11 = function bo_y11(match, outcome) {
	    return 'Sixth Fire Line Result';
	};
	var bo_z11 = function bo_z11(match, outcome) {
	    return 'Seventh Fire Line Result';
	};
	var bo_a12 = function bo_a12(match, outcome) {
	    return 'Eighth Fire Line Result';
	};
	var bo_b12 = function bo_b12(match, outcome) {
	    return 'First Fire Line Exact Total';
	};
	var bo_c12 = function bo_c12(match, outcome) {
	    return 'Second Fire Line Exact Total';
	};
	var bo_d12 = function bo_d12(match, outcome) {
	    return 'Third Fire Line Exact Total';
	};
	var bo_e12 = function bo_e12(match, outcome) {
	    return 'Fourth Fire Line Exact Total';
	};
	var bo_f12 = function bo_f12(match, outcome) {
	    return 'Fifth Fire Line Exact Total';
	};
	var bo_g12 = function bo_g12(match, outcome) {
	    return 'Sixth Fire Line Exact Total';
	};
	var bo_h12 = function bo_h12(match, outcome) {
	    return 'Seventh Fire Line Exact Total';
	};
	var bo_i12 = function bo_i12(match, outcome) {
	    return 'Eighth Fire Line Exact Total';
	};
	var bo_j12 = function bo_j12(match, outcome) {
	    return 'Will Fight Go The Distance?';
	};
	var bo_k12 = function bo_k12(match, outcome) {
	    return 'Fight Result';
	};
	var bo_l12 = function bo_l12(match, outcome) {
	    return 'Round Betting';
	};
	var bo_m12 = function bo_m12(match, outcome) {
	    return 'Double Outcome';
	};
	var bo_n12 = function bo_n12(match, outcome) {
	    return 'Total';
	};
	var bo_o12 = function bo_o12(match, outcome) {
	    return "Who Wins " + outcome.condition + " Round?";
	};
	var bo_p12 = function bo_p12(match, outcome) {
	    return 'FirstBlood';
	};
	var bo_q12 = function bo_q12(match, outcome) {
	    return "FirstBlood In " + outcome.condition + " Round";
	};
	var bo_r12 = function bo_r12(match, outcome) {
	    return "Who Wins " + numeralNeuterEnding(outcome.condition) + " Map?";
	};
	var bo_s12 = function bo_s12(match, outcome) {
	    return "FirstBlood In " + numeralNeuterEnding(outcome.condition) + " Map";
	};
	var bo_t12 = function bo_t12(match, outcome) {
	    return "Race To " + outcome.condition + " Kills In 1st Map";
	};
	var bo_u12 = function bo_u12(match, outcome) {
	    return "Race To " + outcome.condition + " Kills In 2nd Map";
	};
	var bo_v12 = function bo_v12(match, outcome) {
	    return "Race To " + outcome.condition + " Kills In 3rd Map";
	};
	var bo_w12 = function bo_w12(match, outcome) {
	    return "Race To " + outcome.condition + " Kills In 4th Map";
	};
	var bo_x12 = function bo_x12(match, outcome) {
	    return "Race To " + outcome.condition + " Kills In 5th Map";
	};
	var bo_y12 = function bo_y12(match, outcome) {
	    return 'First Map Result';
	};
	var bo_z12 = function bo_z12(match, outcome) {
	    return 'Second Map Result';
	};
	var bo_a13 = function bo_a13(match, outcome) {
	    return 'Third Map Result';
	};
	var bo_b13 = function bo_b13(match, outcome) {
	    return 'Fourth Map Result';
	};
	var bo_c13 = function bo_c13(match, outcome) {
	    return 'Fifth Map Result';
	};
	var bo_d13 = function bo_d13(match, outcome) {
	    return 'First blood In First Map';
	};
	var bo_e13 = function bo_e13(match, outcome) {
	    return 'First blood In Second Map';
	};
	var bo_f13 = function bo_f13(match, outcome) {
	    return 'First blood In Third Map';
	};
	var bo_g13 = function bo_g13(match, outcome) {
	    return 'First blood In Fourth Map';
	};
	var bo_h13 = function bo_h13(match, outcome) {
	    return 'First blood In Fifth Map';
	};
	var bo_i13 = function bo_i13(match, outcome) {
	    return 'To Win Match (inc. Shootouts)';
	};
	var bo_j13 = function bo_j13(match, outcome) {
	    return "Total Of Team Scored " + outcome.conditionTwo + "+ Goals";
	};
	var bo_k13 = function bo_k13(match, outcome) {
	    return 'Highest Scoring Team Total';
	};
	var bo_l13 = function bo_l13(match, outcome) {
	    return "Both Halves Total Under " + outcome.condition;
	};
	var bo_m13 = function bo_m13(match, outcome) {
	    return "Both Halves Total Over " + outcome.condition;
	};
	var bo_n13 = function bo_n13(match, outcome) {
	    return 'First Half Total Even/Odd';
	};
	var bo_o13 = function bo_o13(match, outcome) {
	    return 'Second Half Total Even/Odd';
	};
	var bo_p13 = function bo_p13(match, outcome) {
	    return match.homeTeam + " First Half Goals";
	};
	var bo_q13 = function bo_q13(match, outcome) {
	    return match.homeTeam + " Second Half Goals";
	};
	var bo_r13 = function bo_r13(match, outcome) {
	    return match.awayTeam + " First Half Goals";
	};
	var bo_s13 = function bo_s13(match, outcome) {
	    return match.awayTeam + " Second Half Goals";
	};
	var bo_t13 = function bo_t13(match, outcome) {
	    return match.homeTeam + " Full Time Goals";
	};
	var bo_u13 = function bo_u13(match, outcome) {
	    return match.awayTeam + " Full Time Goals";
	};
	var bo_v13 = function bo_v13(match, outcome) {
	    return 'Lowest Scoring Team Total';
	};
	var bo_w13 = function bo_w13(match, outcome) {
	    return match.homeTeam + " To Score In The First Half Only";
	};
	var bo_x13 = function bo_x13(match, outcome) {
	    return match.awayTeam + " To Score In The First Half Only";
	};
	var bo_y13 = function bo_y13(match, outcome) {
	    return match.homeTeam + " To Score In The Second Half Only";
	};
	var bo_z13 = function bo_z13(match, outcome) {
	    return match.awayTeam + " To Score In The Second Half Only";
	};
	var bo_a14 = function bo_a14(match, outcome) {
	    return 'Teams To Score In The First Half';
	};
	var bo_b14 = function bo_b14(match, outcome) {
	    return 'Teams To Score In The Second Half';
	};
	var bo_c14 = function bo_c14(match, outcome) {
	    return "Teams To Score Over " + outcome.condition + " " + plural(outcome.condition, ['Goal', 'Goals', 'Goals']);
	};
	var bo_d14 = function bo_d14(match, outcome) {
	    return 'First Goal Method';
	};
	var bo_e14 = function bo_e14(match, outcome) {
	    return 'Team To Qualify Next Round';
	};
	var bo_f14 = function bo_f14(match, outcome) {
	    return 'Team To Kick Off';
	};
	var bo_g14 = function bo_g14(match, outcome) {
	    return 'Either Team To Score Two Goals In A Row';
	};
	var bo_h14 = function bo_h14(match, outcome) {
	    return match.homeTeam + " To Win From Behind";
	};
	var bo_i14 = function bo_i14(match, outcome) {
	    return "The " + numeralFemaleEnding(outcome.condition) + " Yellow Card To Receive";
	};
	var bo_j14 = function bo_j14(match, outcome) {
	    return match.awayTeam + " To Win From Behind";
	};
	var bo_k14 = function bo_k14(match, outcome) {
	    return 'First To Happen In Match';
	};
	var bo_l14 = function bo_l14(match, outcome) {
	    return 'A Player to Score Exacly 2 Goals';
	};
	var bo_m14 = function bo_m14(match, outcome) {
	    return 'Hat-Trick';
	};
	var bo_n14 = function bo_n14(match, outcome) {
	    return "Team To Serve " + numeralMaleEnding(outcome.condition) + " Corner In The Full Time";
	};
	var bo_o14 = function bo_o14(match, outcome) {
	    return "Teams To Score Exactly " + outcome.conditionTwo + " " + plural(outcome.conditionTwo, ['Goal', 'Goals', 'Goals']);
	};
	var bo_p14 = function bo_p14(match, outcome) {
	    return "Both Teams To Score Exactly " + outcome.condition + " " + plural(outcome.condition, ['Goal', 'Goalа', 'Goals']);
	};
	var bo_q14 = function bo_q14(match, outcome) {
	    return 'Last Team To Score';
	};
	var bo_r14 = function bo_r14(match, outcome) {
	    return 'Own Goal';
	};
	var bo_s14 = function bo_s14(match, outcome) {
	    return 'Substitute To Score';
	};
	var bo_t14 = function bo_t14(match, outcome) {
	    return 'Last Goal Minute';
	};
	var bo_u14 = function bo_u14(match, outcome) {
	    return 'Team To Lift The Cup';
	};
	var bo_v14 = function bo_v14(match, outcome) {
	    return 'Team To Lift The Super Cup';
	};
	var bo_w14 = function bo_w14(match, outcome) {
	    return "Half When " + numeralMaleEnding(outcome.condition) + " Goal To Score";
	};
	var bo_x14 = function bo_x14(match, outcome) {
	    return '1-15th Mins Double Chance';
	};
	var bo_y14 = function bo_y14(match, outcome) {
	    return '16-30th Mins Double Chance';
	};
	var bo_z14 = function bo_z14(match, outcome) {
	    return '31st Min - Half Time Double Chance';
	};
	var bo_a15 = function bo_a15(match, outcome) {
	    return '46-60th Mins Double Chance';
	};
	var bo_b15 = function bo_b15(match, outcome) {
	    return '61-75th Mins Double Chance';
	};
	var bo_c15 = function bo_c15(match, outcome) {
	    return '75th Min - Full Time Double Chance';
	};
	var bo_d15 = function bo_d15(match, outcome) {
	    return match.homeTeam + " To Score The " + numeralMaleEnding(outcome.condition) + " Shootout Penalty";
	};
	var bo_e15 = function bo_e15(match, outcome) {
	    return match.awayTeam + " To Score The " + numeralMaleEnding(outcome.condition) + " Shootout Penalty";
	};
	var bo_f15 = function bo_f15(match, outcome) {
	    return match.homeTeam + " To Score The " + numeralMaleEnding(outcome.condition) + " Goal";
	};
	var bo_g15 = function bo_g15(match, outcome) {
	    return match.awayTeam + " To Score Its " + numeralMaleEnding(outcome.condition) + " Goal";
	};
	var bo_h15 = function bo_h15(match, outcome) {
	    return 'First Half Corners';
	};
	var bo_i15 = function bo_i15(match, outcome) {
	    return 'First Half Yellow Cards';
	};
	var bo_j15 = function bo_j15(match, outcome) {
	    return 'Full Time Corners Handicap';
	};
	var bo_k15 = function bo_k15(match, outcome) {
	    return 'First Half Corners Handicap';
	};
	var bo_l15 = function bo_l15(match, outcome) {
	    return 'Yellow Cards Handicap';
	};
	var bo_m15 = function bo_m15(match, outcome) {
	    return 'First Half Yellow Cards Handicap';
	};
	var bo_n15 = function bo_n15(match, outcome) {
	    return 'Full Time Corners Result';
	};
	var bo_o15 = function bo_o15(match, outcome) {
	    return 'First Half Corners Result';
	};
	var bo_p15 = function bo_p15(match, outcome) {
	    return 'Full Time Yellow Cards Result';
	};
	var bo_q15 = function bo_q15(match, outcome) {
	    return 'First Half Yellow Cards Result';
	};
	var bo_r15 = function bo_r15(match, outcome) {
	    return "Race To Score " + outcome.condition + " " + plural(outcome.condition, ['Goal', 'Goals', 'Goals']) + " In The Full Time";
	};
	var bo_s15 = function bo_s15(match, outcome) {
	    return numeralMaleEnding(outcome.condition) + " Penalty To Be Missed";
	};
	var bo_t15 = function bo_t15(match, outcome) {
	    return 'Full Time Total';
	};
	var bo_u15 = function bo_u15(match, outcome) {
	    return 'Total Throws-in';
	};
	var bo_v15 = function bo_v15(match, outcome) {
	    return 'Half Time / Full Time';
	};
	var bo_w15 = function bo_w15(match, outcome) {
	    return 'Asian Total';
	};
	var bo_x15 = function bo_x15(match, outcome) {
	    return 'Total Corners';
	};
	var bo_y15 = function bo_y15(match, outcome) {
	    return 'Full Time Result';
	};
	var bo_z15 = function bo_z15(match, outcome) {
	    return 'Penalties Total';
	};
	var bo_a16 = function bo_a16(match, outcome) {
	    return 'Red Cards Total';
	};
	var bo_b16 = function bo_b16(match, outcome) {
	    return 'First Goal Minute';
	};
	var bo_c16 = function bo_c16(match, outcome) {
	    return 'Goal Minutes Total';
	};
	var bo_d16 = function bo_d16(match, outcome) {
	    return 'Total Shots On Target';
	};
	var bo_e16 = function bo_e16(match, outcome) {
	    return 'Yellow Cards Total';
	};
	var bo_f16 = function bo_f16(match, outcome) {
	    return '1-15th Mins Handicap';
	};
	var bo_g16 = function bo_g16(match, outcome) {
	    return '16-30th Mins Handicap';
	};
	var bo_h16 = function bo_h16(match, outcome) {
	    return '31st Min - Half Time Handicap';
	};
	var bo_i16 = function bo_i16(match, outcome) {
	    return '46-60th Mins Handicap';
	};
	var bo_j16 = function bo_j16(match, outcome) {
	    return '61-75th Mins Handicap';
	};
	var bo_k16 = function bo_k16(match, outcome) {
	    return '76th Min - Full Time';
	};
	var bo_l16 = function bo_l16(match, outcome) {
	    return match.awayTeam + " Clean Sheet";
	};
	var bo_m16 = function bo_m16(match, outcome) {
	    return match.homeTeam + " Clean Sheet";
	};
	var bo_n16 = function bo_n16(match, outcome) {
	    return 'Substitutions Total';
	};
	var bo_o16 = function bo_o16(match, outcome) {
	    return 'Full Time Total Even/Odd';
	};
	var bo_p16 = function bo_p16(match, outcome) {
	    return '1-15th Mins Total';
	};
	var bo_q16 = function bo_q16(match, outcome) {
	    return '16-30th Mins Total';
	};
	var bo_r16 = function bo_r16(match, outcome) {
	    return '31st Min - Half Time Total';
	};
	var bo_s16 = function bo_s16(match, outcome) {
	    return '46-60th Mins Total';
	};
	var bo_t16 = function bo_t16(match, outcome) {
	    return '61-75th Mins Total';
	};
	var bo_u16 = function bo_u16(match, outcome) {
	    return '76th Min - Full Time Total';
	};
	var bo_v16 = function bo_v16(match, outcome) {
	    return match.homeTeam + " 1-15th Mins Total";
	};
	var bo_w16 = function bo_w16(match, outcome) {
	    return match.homeTeam + " 16-30th Mins Total";
	};
	var bo_x16 = function bo_x16(match, outcome) {
	    return match.homeTeam + " 31st Min - Half Time Total";
	};
	var bo_y16 = function bo_y16(match, outcome) {
	    return match.homeTeam + " 46-60th Mins Total";
	};
	var bo_z16 = function bo_z16(match, outcome) {
	    return match.homeTeam + " 61-75th Mins Total";
	};
	var bo_a17 = function bo_a17(match, outcome) {
	    return match.homeTeam + " 76th Min - Full Time Total";
	};
	var bo_b17 = function bo_b17(match, outcome) {
	    return match.awayTeam + " 1-15th Mins Total";
	};
	var bo_c17 = function bo_c17(match, outcome) {
	    return match.awayTeam + " 16-30th Mins Total";
	};
	var bo_d17 = function bo_d17(match, outcome) {
	    return match.awayTeam + " 31st Min - Half Time Total";
	};
	var bo_e17 = function bo_e17(match, outcome) {
	    return match.awayTeam + " 46-60th Mins Total";
	};
	var bo_f17 = function bo_f17(match, outcome) {
	    return match.awayTeam + " 61-75th Mins Total";
	};
	var bo_g17 = function bo_g17(match, outcome) {
	    return match.awayTeam + " 76th Min - Full Time Total";
	};
	var bo_h17 = function bo_h17(match, outcome) {
	    return 'Exact First Half Total';
	};
	var bo_i17 = function bo_i17(match, outcome) {
	    return 'Exact Second Half Total';
	};
	var bo_j17 = function bo_j17(match, outcome) {
	    return match.homeTeam + " To Win To Nil";
	};
	var bo_k17 = function bo_k17(match, outcome) {
	    return match.awayTeam + " To Win To Nil";
	};
	var bo_l17 = function bo_l17(match, outcome) {
	    return match.homeTeam + " To Score Exactly " + outcome.condition + " " + plural(outcome.condition, ['Goal', 'Goals', 'Goals']);
	};
	var bo_m17 = function bo_m17(match, outcome) {
	    return match.awayTeam + " To Score Exactly " + outcome.condition + " " + plural(outcome.condition, ['Goal', 'Goalа', 'Goals']);
	};
	var bo_n17 = function bo_n17(match, outcome) {
	    return 'First Half Correct Score';
	};
	var bo_o17 = function bo_o17(match, outcome) {
	    return 'Second Half Correct Score';
	};
	var bo_p17 = function bo_p17(match, outcome) {
	    return 'Missed Penalties Total';
	};
	var bo_q17 = function bo_q17(match, outcome) {
	    return "Both Teams To Score Under " + outcome.condition;
	};
	var bo_r17 = function bo_r17(match, outcome) {
	    return "Both Teams To Score Over " + outcome.condition;
	};
	var bo_s17 = function bo_s17(match, outcome) {
	    return 'Half With Most Goals';
	};
	var bo_t17 = function bo_t17(match, outcome) {
	    return '1-15th Mins Result';
	};
	var bo_u17 = function bo_u17(match, outcome) {
	    return '16-30th Mins Result';
	};
	var bo_v17 = function bo_v17(match, outcome) {
	    return '31st Min - Half Time Result';
	};
	var bo_w17 = function bo_w17(match, outcome) {
	    return '46-60th Mins Result';
	};
	var bo_x17 = function bo_x17(match, outcome) {
	    return '61-75th Mins Result';
	};
	var bo_y17 = function bo_y17(match, outcome) {
	    return '75th Min - Full Time Result';
	};
	var bo_z17 = function bo_z17(match, outcome) {
	    return match.homeTeam + " To Win Either Half";
	};
	var bo_a18 = function bo_a18(match, outcome) {
	    return match.awayTeam + " To Win Either Half";
	};
	var bo_b18 = function bo_b18(match, outcome) {
	    return "Total Of Teams Scored " + outcome.conditionTwo + " - " + outcome.conditionThree + " Goals\xA0";
	};
	var bo_c18 = function bo_c18(match, outcome) {
	    return outcome.playerName + " (" + match.homeTeam + ") To Score";
	};
	var bo_d18 = function bo_d18(match, outcome) {
	    return outcome.playerName + " (" + match.awayTeam + ") To Score";
	};
	var bo_e18 = function bo_e18(match, outcome) {
	    return 'Games Result';
	};
	var bo_f18 = function bo_f18(match, outcome) {
	    return 'Games Handicap';
	};
	var bo_g18 = function bo_g18(match, outcome) {
	    return 'Games Total';
	};
	var bo_h18 = function bo_h18(match, outcome) {
	    return 'Home Teams Total';
	};
	var bo_i18 = function bo_i18(match, outcome) {
	    return 'Away Teams Total';
	};
	var bo_j18 = function bo_j18(match, outcome) {
	    return 'Highest Scoring Match Total';
	};
	var bo_k18 = function bo_k18(match, outcome) {
	    return 'Lowest Scoring Match Total';
	};
	var bo_l18 = function bo_l18(match, outcome) {
	    return 'Scoreless Games Total';
	};
	var bo_m18 = function bo_m18(match, outcome) {
	    return 'Home Teams To Win Total';
	};
	var bo_n18 = function bo_n18(match, outcome) {
	    return 'Away Teams To Win Total';
	};
	var bo_o18 = function bo_o18(match, outcome) {
	    return 'Draws Total';
	};
	var bo_p18 = function bo_p18(match, outcome) {
	    return 'Both Teams To Score: 1st Half&2nd Half';
	};
	var bo_q18 = function bo_q18(match, outcome) {
	    return "Total " + outcome.condition + "/Both Teams To Score";
	};
	var bo_r18 = function bo_r18(match, outcome) {
	    return match.homeTeam + " To Score and Not To Win";
	};
	var bo_s18 = function bo_s18(match, outcome) {
	    return match.awayTeam + " To Score and Not To Win";
	};
	var bo_t18 = function bo_t18(match, outcome) {
	    return 'Winning Method';
	};
	var bo_u18 = function bo_u18(match, outcome) {
	    return 'Injury Time in First Half';
	};
	var bo_v18 = function bo_v18(match, outcome) {
	    return 'Injury Time in Second Half';
	};
	var bo_w18 = function bo_w18(match, outcome) {
	    return 'Will Anybody Hit the Goalpost or Crossbar?';
	};
	var bo_x18 = function bo_x18(match, outcome) {
	    return 'First Substitution time';
	};
	var bo_y18 = function bo_y18(match, outcome) {
	    return match.homeTeam + " to Recieve Red Card";
	};
	var bo_z18 = function bo_z18(match, outcome) {
	    return match.awayTeam + "  to Recieve Red Card";
	};
	var bo_a19 = function bo_a19(match, outcome) {
	    return 'To Be Penalty an Send Off';
	};
	var bo_b19 = function bo_b19(match, outcome) {
	    return 'Goal In Injury Time';
	};
	var bo_c19 = function bo_c19(match, outcome) {
	    return 'Yellow Card For Simulation';
	};
	var bo_d19 = function bo_d19(match, outcome) {
	    return 'Yellow Card For Taken Off T-Shirt';
	};
	var bo_e19 = function bo_e19(match, outcome) {
	    return 'To Be Corner Kicks From Each Pitch Corner';
	};
	var bo_f19 = function bo_f19(match, outcome) {
	    return 'Who Takes 3rd Place?';
	};
	var bo_g19 = function bo_g19(match, outcome) {
	    return "Total: " + match.awayTeam + "  (Extra Time)";
	};
	var bo_h19 = function bo_h19(match, outcome) {
	    return "Total: " + match.homeTeam + "  (Extra Time)";
	};
	var bo_i19 = function bo_i19(match, outcome) {
	    return 'Double Chance (Extra Time)';
	};
	var bo_j19 = function bo_j19(match, outcome) {
	    return 'Точный счет  (Extra Time)';
	};
	var bo_k19 = function bo_k19(match, outcome) {
	    return 'Handicap (Extra Time)';
	};
	var bo_l19 = function bo_l19(match, outcome) {
	    return 'Total (Extra Time)';
	};
	var bo_m19 = function bo_m19(match, outcome) {
	    return match.homeTeam + " - " + match.awayTeam + " (Extra Time)";
	};
	var bo_n19 = function bo_n19(match, outcome) {
	    return "Who Scores " + numeralMaleEnding(outcome.condition) + " goal?";
	};
	var bo_o19 = function bo_o19(match, outcome) {
	    return 'Handicap - First Extra Time';
	};
	var bo_p19 = function bo_p19(match, outcome) {
	    return 'First Extra Time Total';
	};
	var bo_q19 = function bo_q19(match, outcome) {
	    return 'First Extra Time Result';
	};
	var bo_r19 = function bo_r19(match, outcome) {
	    return 'Handicap - Second Extra Time';
	};
	var bo_s19 = function bo_s19(match, outcome) {
	    return 'Second Extra Time Total';
	};
	var bo_t19 = function bo_t19(match, outcome) {
	    return 'Second Extra Time Result';
	};
	var bo_u19 = function bo_u19(match, outcome) {
	    return 'Shoot-out Correct Score';
	};
	var bo_v19 = function bo_v19(match, outcome) {
	    return "Total Penalty Scored: " + match.awayTeam + " (Shoot-out)";
	};
	var bo_w19 = function bo_w19(match, outcome) {
	    return "Total Penalty Scored: " + match.homeTeam + " (Shoot-out)";
	};
	var bo_x19 = function bo_x19(match, outcome) {
	    return 'Total Penalty Scored (Shoot-out)';
	};
	var bo_y19 = function bo_y19(match, outcome) {
	    return 'Total Penalty Missed (Shoot-out)';
	};
	var bo_z19 = function bo_z19(match, outcome) {
	    return "European Handicap " + europeanHandicapCondition(outcome.condition);
	};
	var bo_a20 = function bo_a20(match, outcome) {
	    return "European Handicap " + europeanHandicapCondition(outcome.condition) + " - First Half";
	};
	var bo_b20 = function bo_b20(match, outcome) {
	    return "European Handicap " + europeanHandicapCondition(outcome.condition) + " - Second Half";
	};
	var bo_c20 = function bo_c20(match, outcome) {
	    return "Who Scores " + numeralMaleEnding(outcome.condition) + " Goal - First Half?";
	};
	var bo_d20 = function bo_d20(match, outcome) {
	    return "Rest Of Game (current score " + outcome.condition + ":" + outcome.conditionTwo + ")";
	};
	var bo_e20 = function bo_e20(match, outcome) {
	    return "Rest Of First Half (current score " + outcome.condition + ":" + outcome.conditionTwo + ")";
	};
	var bo_f20 = function bo_f20(match, outcome) {
	    return "First Corners Half Total: " + match.homeTeam;
	};
	var bo_g20 = function bo_g20(match, outcome) {
	    return "First Corners Half Total: " + match.awayTeam;
	};
	var bo_h20 = function bo_h20(match, outcome) {
	    return "Corners Total: " + match.homeTeam;
	};
	var bo_i20 = function bo_i20(match, outcome) {
	    return "Corners Total: " + match.awayTeam;
	};
	var bo_j20 = function bo_j20(match, outcome) {
	    return 'First Half Double Chance';
	};
	var bo_k20 = function bo_k20(match, outcome) {
	    return 'Second Half Double Chance';
	};
	var bo_l20 = function bo_l20(match, outcome) {
	    return 'Both To Score?';
	};
	var bo_m20 = function bo_m20(match, outcome) {
	    return "Both Teams To Score " + outcome.conditionTwo + " And More Goals\xA0(Their Total)";
	};
	var bo_n20 = function bo_n20(match, outcome) {
	    return 'First Half Even/Odd';
	};
	var bo_o20 = function bo_o20(match, outcome) {
	    return 'Second Half Even/Odd';
	};
	var bo_p20 = function bo_p20(match, outcome) {
	    return match.homeTeam + " To Score In The First Half";
	};
	var bo_q20 = function bo_q20(match, outcome) {
	    return match.homeTeam + " To Score In The Second Half";
	};
	var bo_r20 = function bo_r20(match, outcome) {
	    return match.awayTeam + " To Score In The First Half";
	};
	var bo_s20 = function bo_s20(match, outcome) {
	    return match.awayTeam + " To Score In The Second Half";
	};
	var bo_t20 = function bo_t20(match, outcome) {
	    return "Teams To Score Over " + outcome.condition + " " + plural(outcome.condition, ['goal', 'Goals', 'Goals']);
	};
	var bo_u20 = function bo_u20(match, outcome) {
	    return "Teams To Score Exactly " + outcome.conditionTwo + " " + plural(outcome.conditionTwo, ['goal', 'Goals', 'Goals']) + "\xA0(Their Total)";
	};
	var bo_v20 = function bo_v20(match, outcome) {
	    return 'Match (Full Time) Total';
	};
	var bo_w20 = function bo_w20(match, outcome) {
	    return 'Half Time / Match (Full Time)';
	};
	var bo_x20 = function bo_x20(match, outcome) {
	    return 'Match (Full Time) Correct Score';
	};
	var bo_y20 = function bo_y20(match, outcome) {
	    return 'Match (Full Time) Exact Total';
	};
	var bo_z20 = function bo_z20(match, outcome) {
	    return 'Match (Full Time) Draw';
	};
	var bo_a21 = function bo_a21(match, outcome) {
	    return 'Total Penalties';
	};
	var bo_b21 = function bo_b21(match, outcome) {
	    return 'Total Red Cards';
	};
	var bo_c21 = function bo_c21(match, outcome) {
	    return 'Total Goal Minutes';
	};
	var bo_d21 = function bo_d21(match, outcome) {
	    return 'Total Yellow Cards';
	};
	var bo_e21 = function bo_e21(match, outcome) {
	    return '1-15th Min Handicap';
	};
	var bo_f21 = function bo_f21(match, outcome) {
	    return '16-30th Min Handicap';
	};
	var bo_g21 = function bo_g21(match, outcome) {
	    return '46-60th Min Handicap';
	};
	var bo_h21 = function bo_h21(match, outcome) {
	    return '61-75th Min Handicap';
	};
	var bo_i21 = function bo_i21(match, outcome) {
	    return match.homeTeam + " To Score";
	};
	var bo_j21 = function bo_j21(match, outcome) {
	    return match.awayTeam + " To Score";
	};
	var bo_k21 = function bo_k21(match, outcome) {
	    return 'Total Substitutions';
	};
	var bo_l21 = function bo_l21(match, outcome) {
	    return 'Match (Full Time) Total Even/Odd';
	};
	var bo_m21 = function bo_m21(match, outcome) {
	    return '1-15th Min Total';
	};
	var bo_n21 = function bo_n21(match, outcome) {
	    return '16-30th Min Total';
	};
	var bo_o21 = function bo_o21(match, outcome) {
	    return '46-60th Min Total';
	};
	var bo_p21 = function bo_p21(match, outcome) {
	    return '61-75th Min Total';
	};
	var bo_q21 = function bo_q21(match, outcome) {
	    return match.homeTeam + " 1-15th Min Total";
	};
	var bo_r21 = function bo_r21(match, outcome) {
	    return match.homeTeam + " 16-30th Min Total";
	};
	var bo_s21 = function bo_s21(match, outcome) {
	    return match.homeTeam + " 46-60th Min Total";
	};
	var bo_t21 = function bo_t21(match, outcome) {
	    return match.homeTeam + " 61-75th Min Total";
	};
	var bo_u21 = function bo_u21(match, outcome) {
	    return match.awayTeam + " 1-15th Min Total";
	};
	var bo_v21 = function bo_v21(match, outcome) {
	    return match.awayTeam + " 16-30th Min Total";
	};
	var bo_w21 = function bo_w21(match, outcome) {
	    return match.awayTeam + " 46-60th Min Total";
	};
	var bo_x21 = function bo_x21(match, outcome) {
	    return match.awayTeam + " 61-75th Min Total";
	};
	var bo_y21 = function bo_y21(match, outcome) {
	    return match.awayTeam + " To Score Exactly " + outcome.condition + " " + plural(outcome.condition, ['Goal', 'Goals', 'Goals']);
	};
	var bo_z21 = function bo_z21(match, outcome) {
	    return 'Total Missed Penalties';
	};
	var bo_a22 = function bo_a22(match, outcome) {
	    return 'Team To Win 1st-15th Min';
	};
	var bo_b22 = function bo_b22(match, outcome) {
	    return 'Team To Win 16th-30th Min';
	};
	var bo_c22 = function bo_c22(match, outcome) {
	    return 'Team To Win 31st Min - Half Time';
	};
	var bo_d22 = function bo_d22(match, outcome) {
	    return 'Team To Win 46th-60th Min';
	};
	var bo_e22 = function bo_e22(match, outcome) {
	    return 'Team To Win 61st-75th Min';
	};
	var bo_f22 = function bo_f22(match, outcome) {
	    return 'Team To Win 75th Min - Full Time';
	};
	var bo_g22 = function bo_g22(match, outcome) {
	    return "Teams To Score " + outcome.conditionTwo + " Through " + outcome.conditionThree + " Goals\xA0(Total)";
	};
	var bo_h22 = function bo_h22(match, outcome) {
	    return "Team To Score The " + numeralMaleEnding(outcome.condition) + " goal";
	};
	var bo_i22 = function bo_i22(match, outcome) {
	    return 'First Period Exact Total';
	};
	var bo_j22 = function bo_j22(match, outcome) {
	    return 'Second Period Exact Total';
	};
	var bo_k22 = function bo_k22(match, outcome) {
	    return "Game Result / Total " + outcome.condition;
	};
	var bo_l22 = function bo_l22(match, outcome) {
	    return match.homeTeam + " First Period Winning Margin";
	};
	var bo_m22 = function bo_m22(match, outcome) {
	    return match.homeTeam + " Second Period Winning Margin";
	};
	var bo_n22 = function bo_n22(match, outcome) {
	    return match.awayTeam + " First Period Winning Margin";
	};
	var bo_o22 = function bo_o22(match, outcome) {
	    return match.awayTeam + " Second Period Winning Margin";
	};
	var bo_p22 = function bo_p22(match, outcome) {
	    return "Team To First Score " + outcome.condition + " " + plural(outcome.condition, ['goal', 'goals', 'goals']);
	};
	var bo_q22 = function bo_q22(match, outcome) {
	    return 'Hat-Tricks Total';
	};
	var bo_r22 = function bo_r22(match, outcome) {
	    return 'To Win Match (inc. shootouts)';
	};
	var bo_s22 = function bo_s22(match, outcome) {
	    return match.homeTeam + " Victory Margin - " + outcome.condition + " " + plural(outcome.condition, ['goal', 'goals', 'goals']);
	};
	var bo_t22 = function bo_t22(match, outcome) {
	    return match.awayTeam + " Victory Margin - " + outcome.condition + " " + plural(outcome.condition, ['goal', 'goals', 'goals']);
	};
	var bo_u22 = function bo_u22(match, outcome) {
	    return "Teams To Score Over " + outcome.condition + " " + plural(outcome.condition, ['goal', 'goals', 'goals']);
	};
	var bo_v22 = function bo_v22(match, outcome) {
	    return 'First Period Even/Odd';
	};
	var bo_w22 = function bo_w22(match, outcome) {
	    return 'Second Period Even/Odd';
	};
	var bo_x22 = function bo_x22(match, outcome) {
	    return 'Third Period Even/Odd';
	};
	var bo_y22 = function bo_y22(match, outcome) {
	    return 'Highest Scoring Period Total';
	};
	var bo_z22 = function bo_z22(match, outcome) {
	    return 'Lowest Scoring Period Total';
	};
	var bo_a23 = function bo_a23(match, outcome) {
	    return 'Third Period Exact Total';
	};
	var bo_b23 = function bo_b23(match, outcome) {
	    return match.homeTeam + " First Period Total";
	};
	var bo_c23 = function bo_c23(match, outcome) {
	    return match.homeTeam + " Second Period Total";
	};
	var bo_d23 = function bo_d23(match, outcome) {
	    return match.homeTeam + " Third Period Total";
	};
	var bo_e23 = function bo_e23(match, outcome) {
	    return match.awayTeam + " First Period Total";
	};
	var bo_f23 = function bo_f23(match, outcome) {
	    return match.awayTeam + " Second Period Total";
	};
	var bo_g23 = function bo_g23(match, outcome) {
	    return match.awayTeam + " Third Period Total";
	};
	var bo_h23 = function bo_h23(match, outcome) {
	    return 'Overtime';
	};
	var bo_i23 = function bo_i23(match, outcome) {
	    return 'Both Teams To Score';
	};
	var bo_j23 = function bo_j23(match, outcome) {
	    return match.homeTeam + " To Score " + numeralMaleEnding(outcome.condition) + " Shootout";
	};
	var bo_k23 = function bo_k23(match, outcome) {
	    return match.awayTeam + " To Score " + numeralMaleEnding(outcome.condition) + " Shootout";
	};
	var bo_l23 = function bo_l23(match, outcome) {
	    return 'To Win Match (inc. overtime)';
	};
	var bo_m23 = function bo_m23(match, outcome) {
	    return match.homeTeam + " to Score Each Period";
	};
	var bo_n23 = function bo_n23(match, outcome) {
	    return match.awayTeam + "  to Score Each Period";
	};
	var bo_o23 = function bo_o23(match, outcome) {
	    return 'To Score Each Period';
	};
	var bo_p23 = function bo_p23(match, outcome) {
	    return 'Highest Scoring Period';
	};
	var bo_q23 = function bo_q23(match, outcome) {
	    return match.homeTeam + " to Win One of Periods";
	};
	var bo_r23 = function bo_r23(match, outcome) {
	    return match.awayTeam + " to Win One of Periods";
	};
	var bo_s23 = function bo_s23(match, outcome) {
	    return 'Draw to Be One of Periods';
	};
	var bo_t23 = function bo_t23(match, outcome) {
	    return '1-10 Minutes Result';
	};
	var bo_u23 = function bo_u23(match, outcome) {
	    return '11-20 Minutes Result';
	};
	var bo_v23 = function bo_v23(match, outcome) {
	    return '21-30 Minutes Result';
	};
	var bo_w23 = function bo_w23(match, outcome) {
	    return '31-40 Minutes Result';
	};
	var bo_x23 = function bo_x23(match, outcome) {
	    return '41-50 Minutes Result';
	};
	var bo_y23 = function bo_y23(match, outcome) {
	    return '51-60 Minutes Result';
	};
	var bo_z23 = function bo_z23(match, outcome) {
	    return '1-10 Minutes Handicap';
	};
	var bo_a24 = function bo_a24(match, outcome) {
	    return '11-20 Minutes Handicap';
	};
	var bo_b24 = function bo_b24(match, outcome) {
	    return '21-30 Minutes Handicap';
	};
	var bo_c24 = function bo_c24(match, outcome) {
	    return '31-40 Minutes Handicap';
	};
	var bo_d24 = function bo_d24(match, outcome) {
	    return '41-50 Minutes Handicap';
	};
	var bo_e24 = function bo_e24(match, outcome) {
	    return '51-60 Minutes Handicap';
	};
	var bo_f24 = function bo_f24(match, outcome) {
	    return '1-10 Minutes Total';
	};
	var bo_g24 = function bo_g24(match, outcome) {
	    return '11-20 Minutes Total';
	};
	var bo_h24 = function bo_h24(match, outcome) {
	    return '21-30 Minutes Total';
	};
	var bo_i24 = function bo_i24(match, outcome) {
	    return '31-40 Minutes Total';
	};
	var bo_j24 = function bo_j24(match, outcome) {
	    return '41-50 Minutes Total';
	};
	var bo_k24 = function bo_k24(match, outcome) {
	    return '51-60 Minutes Total';
	};
	var bo_l24 = function bo_l24(match, outcome) {
	    return 'Highest Number Even/Odd';
	};
	var bo_m24 = function bo_m24(match, outcome) {
	    return 'Lowest Number Even/Odd';
	};
	var bo_n24 = function bo_n24(match, outcome) {
	    return 'First Number Even/Odd';
	};
	var bo_o24 = function bo_o24(match, outcome) {
	    return 'Last Number Even/Odd';
	};
	var bo_p24 = function bo_p24(match, outcome) {
	    return 'First Is Greater Than Last Number';
	};
	var bo_q24 = function bo_q24(match, outcome) {
	    return 'All Drawn Numbers Even';
	};
	var bo_r24 = function bo_r24(match, outcome) {
	    return 'All Drawn Numbers Odd';
	};
	var bo_s24 = function bo_s24(match, outcome) {
	    return 'Two Сonsecutive Numbers To Draw';
	};
	var bo_t24 = function bo_t24(match, outcome) {
	    return 'Lowest Number';
	};
	var bo_u24 = function bo_u24(match, outcome) {
	    return 'Highest Number';
	};
	var bo_v24 = function bo_v24(match, outcome) {
	    return 'Drawn Numbers Total Value';
	};
	var bo_w24 = function bo_w24(match, outcome) {
	    return "To Draw A Number Divisible By " + outcome.condition;
	};
	var bo_x24 = function bo_x24(match, outcome) {
	    return 'Difference Between The Highest And The Lowest Numbers Drawn';
	};
	var bo_y24 = function bo_y24(match, outcome) {
	    return 'Odd Numbers Total Value';
	};
	var bo_z24 = function bo_z24(match, outcome) {
	    return 'Even Numbers Total Value';
	};
	var bo_a25 = function bo_a25(match, outcome) {
	    return 'First Number';
	};
	var bo_b25 = function bo_b25(match, outcome) {
	    return 'Second Number';
	};
	var bo_c25 = function bo_c25(match, outcome) {
	    return 'Third Number';
	};
	var bo_d25 = function bo_d25(match, outcome) {
	    return 'Fourth Number';
	};
	var bo_e25 = function bo_e25(match, outcome) {
	    return 'Fifth Number';
	};
	var bo_f25 = function bo_f25(match, outcome) {
	    return 'Sixth Number';
	};
	var bo_g25 = function bo_g25(match, outcome) {
	    return 'Seventh Number';
	};
	var bo_h25 = function bo_h25(match, outcome) {
	    return "At Least One Number Drawn Between " + outcome.condition + " - " + outcome.conditionTwo;
	};
	var bo_i25 = function bo_i25(match, outcome) {
	    return 'Lowest And Highest Numbers Drawn Total';
	};
	var bo_j25 = function bo_j25(match, outcome) {
	    return match.homeTeam + " to win by Submission";
	};
	var bo_k25 = function bo_k25(match, outcome) {
	    return match.awayTeam + " to win by Submission";
	};
	var bo_l25 = function bo_l25(match, outcome) {
	    return match.homeTeam + " to win by KO/TKO/DQ";
	};
	var bo_m25 = function bo_m25(match, outcome) {
	    return match.awayTeam + " to win by KO/TKO/DQ";
	};
	var bo_n25 = function bo_n25(match, outcome) {
	    return 'Medals Total';
	};
	var bo_o25 = function bo_o25(match, outcome) {
	    return 'Twenty Ninth Frame Result';
	};
	var bo_p25 = function bo_p25(match, outcome) {
	    return 'Thirtieth Frame Result';
	};
	var bo_q25 = function bo_q25(match, outcome) {
	    return 'Thirty First Frame Result';
	};
	var bo_r25 = function bo_r25(match, outcome) {
	    return 'Thirty Second Frame Result';
	};
	var bo_s25 = function bo_s25(match, outcome) {
	    return 'Thirty Third Frame Result';
	};
	var bo_t25 = function bo_t25(match, outcome) {
	    return 'Thirty Fourth Frame Result';
	};
	var bo_u25 = function bo_u25(match, outcome) {
	    return 'Thirty Fifth Frame Result';
	};
	var bo_v25 = function bo_v25(match, outcome) {
	    return 'Thirty Sixth Frame Result';
	};
	var bo_w25 = function bo_w25(match, outcome) {
	    return 'Thirty Seventh Frame Result';
	};
	var bo_x25 = function bo_x25(match, outcome) {
	    return 'Eighteenth Frame Even/Odd';
	};
	var bo_y25 = function bo_y25(match, outcome) {
	    return 'Nineteenth Frame Even/Odd';
	};
	var bo_z25 = function bo_z25(match, outcome) {
	    return 'Twentieth Frame Even/Odd';
	};
	var bo_a26 = function bo_a26(match, outcome) {
	    return 'Twenty First Frame Even/Odd';
	};
	var bo_b26 = function bo_b26(match, outcome) {
	    return 'Twenty Second Frame Even/Odd';
	};
	var bo_c26 = function bo_c26(match, outcome) {
	    return 'Twenty Third Frame Even/Odd';
	};
	var bo_d26 = function bo_d26(match, outcome) {
	    return 'Twenty Fourth Frame Even/Odd';
	};
	var bo_e26 = function bo_e26(match, outcome) {
	    return 'Twenty Fifth Frame Even/Odd';
	};
	var bo_f26 = function bo_f26(match, outcome) {
	    return 'Twenty Sixth Frame Even/Odd';
	};
	var bo_g26 = function bo_g26(match, outcome) {
	    return 'Twenty Seventh Frame Even/Odd';
	};
	var bo_h26 = function bo_h26(match, outcome) {
	    return 'Twenty Eighth Frame Even/Odd';
	};
	var bo_i26 = function bo_i26(match, outcome) {
	    return 'Twenty Ninth Frame Even/Odd';
	};
	var bo_j26 = function bo_j26(match, outcome) {
	    return 'Thirty Frame Even/Odd';
	};
	var bo_k26 = function bo_k26(match, outcome) {
	    return 'Thirty First Frame Even/Odd';
	};
	var bo_l26 = function bo_l26(match, outcome) {
	    return 'Thirty Second Frame Even/Odd';
	};
	var bo_m26 = function bo_m26(match, outcome) {
	    return 'Thirty Third Frame Even/Odd';
	};
	var bo_n26 = function bo_n26(match, outcome) {
	    return 'Thirty Fourth Frame Even/Odd';
	};
	var bo_o26 = function bo_o26(match, outcome) {
	    return 'Thirty Fifth Frame Even/Odd';
	};
	var bo_p26 = function bo_p26(match, outcome) {
	    return 'Thirty Sixth Frame Even/Odd';
	};
	var bo_q26 = function bo_q26(match, outcome) {
	    return 'Thirty Seventh Frame Even/Odd';
	};
	var bo_r26 = function bo_r26(match, outcome) {
	    return 'First Legally Potted Colour - First Frame';
	};
	var bo_s26 = function bo_s26(match, outcome) {
	    return 'First Legally Potted Colour - Second Frame';
	};
	var bo_t26 = function bo_t26(match, outcome) {
	    return 'First Legally Potted Colour - Third Frame';
	};
	var bo_u26 = function bo_u26(match, outcome) {
	    return 'First Legally Potted Colour - Fourth Frame';
	};
	var bo_v26 = function bo_v26(match, outcome) {
	    return 'First Legally Potted Colour - Fifth Frame';
	};
	var bo_w26 = function bo_w26(match, outcome) {
	    return 'First Legally Potted Colour - Sixth Frame';
	};
	var bo_x26 = function bo_x26(match, outcome) {
	    return 'First Legally Potted Colour - Seventh Frame';
	};
	var bo_y26 = function bo_y26(match, outcome) {
	    return 'First Legally Potted Colour - Eighth Frame';
	};
	var bo_z26 = function bo_z26(match, outcome) {
	    return 'First Legally Potted Colour - Ninth Frame';
	};
	var bo_a27 = function bo_a27(match, outcome) {
	    return 'First Legally Potted Colour - Tenth Frame';
	};
	var bo_b27 = function bo_b27(match, outcome) {
	    return 'First Legally Potted Colour - Eleventh Frame';
	};
	var bo_c27 = function bo_c27(match, outcome) {
	    return 'First Legally Potted Colour - Twelfth Frame';
	};
	var bo_d27 = function bo_d27(match, outcome) {
	    return 'First Legally Potted Colour - Thirteenth Frame';
	};
	var bo_e27 = function bo_e27(match, outcome) {
	    return 'First Legally Potted Colour - Fourteenth Frame';
	};
	var bo_f27 = function bo_f27(match, outcome) {
	    return 'First Legally Potted Colour - Fifteenth Frame';
	};
	var bo_g27 = function bo_g27(match, outcome) {
	    return 'First Legally Potted Colour - Sixteenth Frame';
	};
	var bo_h27 = function bo_h27(match, outcome) {
	    return 'First Legally Potted Colour - Seventeenth Frame';
	};
	var bo_i27 = function bo_i27(match, outcome) {
	    return 'First Legally Potted Colour - Eighteenth Frame';
	};
	var bo_j27 = function bo_j27(match, outcome) {
	    return 'First Legally Potted Colour - Nineteenth Frame';
	};
	var bo_k27 = function bo_k27(match, outcome) {
	    return 'First Legally Potted Colour - Twentieth Frame';
	};
	var bo_l27 = function bo_l27(match, outcome) {
	    return 'First Legally Potted Colour - Twenty First Frame';
	};
	var bo_m27 = function bo_m27(match, outcome) {
	    return 'First Legally Potted Colour - Twenty Second Frame';
	};
	var bo_n27 = function bo_n27(match, outcome) {
	    return 'First Legally Potted Colour - Twenty Third Frame';
	};
	var bo_o27 = function bo_o27(match, outcome) {
	    return 'First Legally Potted Colour - Twenty Fourth Frame';
	};
	var bo_p27 = function bo_p27(match, outcome) {
	    return 'First Legally Potted Colour - Twenty Fifth Frame';
	};
	var bo_q27 = function bo_q27(match, outcome) {
	    return 'First Legally Potted Colour - Twenty Sixth Frame';
	};
	var bo_r27 = function bo_r27(match, outcome) {
	    return 'First Legally Potted Colour - Twenty Seventh Frame';
	};
	var bo_s27 = function bo_s27(match, outcome) {
	    return 'First Legally Potted Colour - Twenty Eighth Frame';
	};
	var bo_t27 = function bo_t27(match, outcome) {
	    return 'First Legally Potted Colour - Twenty Ninth Frame';
	};
	var bo_u27 = function bo_u27(match, outcome) {
	    return 'First Legally Potted Colour - Thirtieth Frame';
	};
	var bo_v27 = function bo_v27(match, outcome) {
	    return 'First Legally Potted Colour - Thirty First Frame';
	};
	var bo_w27 = function bo_w27(match, outcome) {
	    return 'First Legally Potted Colour - Thirty Second Frame';
	};
	var bo_x27 = function bo_x27(match, outcome) {
	    return 'First Legally Potted Colour - Thirty Third Frame';
	};
	var bo_y27 = function bo_y27(match, outcome) {
	    return 'First Legally Potted Colour - Thirty Fourth Frame';
	};
	var bo_z27 = function bo_z27(match, outcome) {
	    return 'First Legally Potted Colour - Thirty Fifth Frame';
	};
	var bo_a28 = function bo_a28(match, outcome) {
	    return 'First Legally Potted Colour - Thirty Sixth Frame';
	};
	var bo_b28 = function bo_b28(match, outcome) {
	    return 'First Legally Potted Colour - Thirty Seventh Frame';
	};
	var bo_c28 = function bo_c28(match, outcome) {
	    return 'First Frame Result';
	};
	var bo_d28 = function bo_d28(match, outcome) {
	    return 'Second Frame Result';
	};
	var bo_e28 = function bo_e28(match, outcome) {
	    return 'Third Frame Result';
	};
	var bo_f28 = function bo_f28(match, outcome) {
	    return 'Fourth Frame Result';
	};
	var bo_g28 = function bo_g28(match, outcome) {
	    return 'Fifth Frame Result';
	};
	var bo_h28 = function bo_h28(match, outcome) {
	    return 'Sixth Frame Result';
	};
	var bo_i28 = function bo_i28(match, outcome) {
	    return 'Seventh Frame Result';
	};
	var bo_j28 = function bo_j28(match, outcome) {
	    return 'Eighth Frame Result';
	};
	var bo_k28 = function bo_k28(match, outcome) {
	    return 'Ninth Frame Result';
	};
	var bo_l28 = function bo_l28(match, outcome) {
	    return 'Tenth Frame Result';
	};
	var bo_m28 = function bo_m28(match, outcome) {
	    return 'Eleventh Frame Result';
	};
	var bo_n28 = function bo_n28(match, outcome) {
	    return 'Twelfth Frame Result';
	};
	var bo_o28 = function bo_o28(match, outcome) {
	    return 'Thirteenth Frame Result';
	};
	var bo_p28 = function bo_p28(match, outcome) {
	    return 'Fourteenth Frame Result';
	};
	var bo_q28 = function bo_q28(match, outcome) {
	    return 'Fifteenth Frame Result';
	};
	var bo_r28 = function bo_r28(match, outcome) {
	    return 'Sixteenth Frame Result';
	};
	var bo_s28 = function bo_s28(match, outcome) {
	    return 'Seventeenth Frame Result';
	};
	var bo_t28 = function bo_t28(match, outcome) {
	    return 'Eighteenth Frame Result';
	};
	var bo_u28 = function bo_u28(match, outcome) {
	    return 'Nineteenth Frame Result';
	};
	var bo_v28 = function bo_v28(match, outcome) {
	    return 'Twentieth Frame Result';
	};
	var bo_w28 = function bo_w28(match, outcome) {
	    return 'Twenty First Frame Result';
	};
	var bo_x28 = function bo_x28(match, outcome) {
	    return 'Twenty Second Frame Result';
	};
	var bo_y28 = function bo_y28(match, outcome) {
	    return 'Twenty Third Frame Result';
	};
	var bo_z28 = function bo_z28(match, outcome) {
	    return 'Twenty Fourth Frame Result';
	};
	var bo_a29 = function bo_a29(match, outcome) {
	    return 'Twenty Fifth Frame Result';
	};
	var bo_b29 = function bo_b29(match, outcome) {
	    return 'Twenty Sixth Frame Result';
	};
	var bo_c29 = function bo_c29(match, outcome) {
	    return 'Twenty Seventh Frame Result';
	};
	var bo_d29 = function bo_d29(match, outcome) {
	    return 'Twenty Eighth Frame Result';
	};
	var bo_e29 = function bo_e29(match, outcome) {
	    return 'First Player To Pot - Seventh Frame';
	};
	var bo_f29 = function bo_f29(match, outcome) {
	    return 'First Player To Pot - Eighth Frame';
	};
	var bo_g29 = function bo_g29(match, outcome) {
	    return 'First Player To Pot - Ninth Frame';
	};
	var bo_h29 = function bo_h29(match, outcome) {
	    return 'First Player To Pot - Tenth Frame';
	};
	var bo_i29 = function bo_i29(match, outcome) {
	    return 'First Player To Pot - Eleventh Frame';
	};
	var bo_j29 = function bo_j29(match, outcome) {
	    return 'First Player To Pot - Twelfth Frame';
	};
	var bo_k29 = function bo_k29(match, outcome) {
	    return 'First Player To Pot - Thirteenth Frame';
	};
	var bo_l29 = function bo_l29(match, outcome) {
	    return 'First Player To Pot - Fourteenth Frame';
	};
	var bo_m29 = function bo_m29(match, outcome) {
	    return 'First Player To Pot - Fifteenth Frame';
	};
	var bo_n29 = function bo_n29(match, outcome) {
	    return 'First Player To Pot - Sixteenth Frame';
	};
	var bo_o29 = function bo_o29(match, outcome) {
	    return 'First Player To Pot - Seventeenth Frame';
	};
	var bo_p29 = function bo_p29(match, outcome) {
	    return 'First Player To Pot - Eighteenth Frame';
	};
	var bo_q29 = function bo_q29(match, outcome) {
	    return 'First Player To Pot - Nineteenth Frame';
	};
	var bo_r29 = function bo_r29(match, outcome) {
	    return 'First Player To Pot - Twentieth Frame';
	};
	var bo_s29 = function bo_s29(match, outcome) {
	    return 'First Player To Pot - Twenty First Frame';
	};
	var bo_t29 = function bo_t29(match, outcome) {
	    return 'First Player To Pot - Twenty Second Frame';
	};
	var bo_u29 = function bo_u29(match, outcome) {
	    return 'First Player To Pot - Twenty Third Frame';
	};
	var bo_v29 = function bo_v29(match, outcome) {
	    return 'First Player To Pot - Twenty Fourth Frame';
	};
	var bo_w29 = function bo_w29(match, outcome) {
	    return 'First Player To Pot - Twenty Fifth Frame';
	};
	var bo_x29 = function bo_x29(match, outcome) {
	    return 'First Player To Pot - Twenty Sixth Frame';
	};
	var bo_y29 = function bo_y29(match, outcome) {
	    return 'First Player To Pot - Twenty Seventh Frame';
	};
	var bo_z29 = function bo_z29(match, outcome) {
	    return 'First Player To Pot - Twenty Eighth Frame';
	};
	var bo_a30 = function bo_a30(match, outcome) {
	    return 'First Player To Pot - Twenty Ninth Frame';
	};
	var bo_b30 = function bo_b30(match, outcome) {
	    return 'First Player To Pot - Thirtieth Frame';
	};
	var bo_c30 = function bo_c30(match, outcome) {
	    return 'First Player To Pot - Thirty First Frame';
	};
	var bo_d30 = function bo_d30(match, outcome) {
	    return 'First Player To Pot - Thirty Second Frame';
	};
	var bo_e30 = function bo_e30(match, outcome) {
	    return 'First Player To Pot - Thirty Third Frame';
	};
	var bo_f30 = function bo_f30(match, outcome) {
	    return 'First Player To Pot - Thirty Fourth Frame';
	};
	var bo_g30 = function bo_g30(match, outcome) {
	    return 'First Player To Pot - Thirty Fifth Frame';
	};
	var bo_h30 = function bo_h30(match, outcome) {
	    return 'First Player To Pot - Thirty Sixth Frame';
	};
	var bo_i30 = function bo_i30(match, outcome) {
	    return 'First Player To Pot - Thirty Seventh Frame';
	};
	var bo_j30 = function bo_j30(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The First Frame";
	};
	var bo_k30 = function bo_k30(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Second Frame";
	};
	var bo_l30 = function bo_l30(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Third Frame";
	};
	var bo_m30 = function bo_m30(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Fourth Frame";
	};
	var bo_n30 = function bo_n30(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Fifth Frame";
	};
	var bo_o30 = function bo_o30(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Sixth Frame";
	};
	var bo_p30 = function bo_p30(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Seventh Frame";
	};
	var bo_q30 = function bo_q30(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Eighth Frame";
	};
	var bo_r30 = function bo_r30(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Ninth Frame";
	};
	var bo_s30 = function bo_s30(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Tenth Frame";
	};
	var bo_t30 = function bo_t30(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Eleventh Frame";
	};
	var bo_u30 = function bo_u30(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Twelfth Frame";
	};
	var bo_v30 = function bo_v30(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Thirteenth Frame";
	};
	var bo_w30 = function bo_w30(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Fourteenth Frame";
	};
	var bo_x30 = function bo_x30(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Fifteenth Frame";
	};
	var bo_y30 = function bo_y30(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Sixteenth Frame";
	};
	var bo_z30 = function bo_z30(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Seventeenth Frame";
	};
	var bo_a31 = function bo_a31(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Eighteenth Frame";
	};
	var bo_b31 = function bo_b31(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Nineteenth Frame";
	};
	var bo_c31 = function bo_c31(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Twentieth Frame";
	};
	var bo_d31 = function bo_d31(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Twenty First Frame";
	};
	var bo_e31 = function bo_e31(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Twenty Second Frame";
	};
	var bo_f31 = function bo_f31(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Twenty Third Frame";
	};
	var bo_g31 = function bo_g31(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Twenty Fourth Frame";
	};
	var bo_h31 = function bo_h31(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Twenty Fifth Frame";
	};
	var bo_i31 = function bo_i31(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Twenty Sixth Frame";
	};
	var bo_j31 = function bo_j31(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Twenty Seventh Frame";
	};
	var bo_k31 = function bo_k31(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Twenty Eighth Frame";
	};
	var bo_l31 = function bo_l31(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Twenty Ninth Frame";
	};
	var bo_m31 = function bo_m31(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Thirtieth Frame";
	};
	var bo_n31 = function bo_n31(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Thirty First Frame";
	};
	var bo_o31 = function bo_o31(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Thirty Second Frame";
	};
	var bo_p31 = function bo_p31(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Thirty Third Frame";
	};
	var bo_q31 = function bo_q31(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Thirty Fourth Frame";
	};
	var bo_r31 = function bo_r31(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Thirty Fifth Frame";
	};
	var bo_s31 = function bo_s31(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Thirty Sixth Frame";
	};
	var bo_t31 = function bo_t31(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " In The Thirty Seventh Frame";
	};
	var bo_u31 = function bo_u31(match, outcome) {
	    return 'First Frame Even/Odd';
	};
	var bo_v31 = function bo_v31(match, outcome) {
	    return 'Second Frame Even/Odd';
	};
	var bo_w31 = function bo_w31(match, outcome) {
	    return 'Third Frame Even/Odd';
	};
	var bo_x31 = function bo_x31(match, outcome) {
	    return 'Fourth Frame Even/Odd';
	};
	var bo_y31 = function bo_y31(match, outcome) {
	    return 'Fifth Frame Even/Odd';
	};
	var bo_z31 = function bo_z31(match, outcome) {
	    return 'Sixth Frame Even/Odd';
	};
	var bo_a32 = function bo_a32(match, outcome) {
	    return 'Seventh Frame Even/Odd';
	};
	var bo_b32 = function bo_b32(match, outcome) {
	    return 'Eighth Frame Even/Odd';
	};
	var bo_c32 = function bo_c32(match, outcome) {
	    return 'Ninth Frame Even/Odd';
	};
	var bo_d32 = function bo_d32(match, outcome) {
	    return 'Tenth Frame Even/Odd';
	};
	var bo_e32 = function bo_e32(match, outcome) {
	    return 'Eleventh Frame Even/Odd';
	};
	var bo_f32 = function bo_f32(match, outcome) {
	    return 'Twelfth Frame Even/Odd';
	};
	var bo_g32 = function bo_g32(match, outcome) {
	    return 'Thirteenth Frame Even/Odd';
	};
	var bo_h32 = function bo_h32(match, outcome) {
	    return 'Fourteenth Frame Even/Odd';
	};
	var bo_i32 = function bo_i32(match, outcome) {
	    return 'Fifteenth Frame Even/Odd';
	};
	var bo_j32 = function bo_j32(match, outcome) {
	    return 'Sixteenth Frame Even/Odd';
	};
	var bo_k32 = function bo_k32(match, outcome) {
	    return 'Seventeenth Frame Even/Odd';
	};
	var bo_l32 = function bo_l32(match, outcome) {
	    return 'Match Century Breaks Total';
	};
	var bo_m32 = function bo_m32(match, outcome) {
	    return 'First Frame Handicap';
	};
	var bo_n32 = function bo_n32(match, outcome) {
	    return 'Second Frame Handicap';
	};
	var bo_o32 = function bo_o32(match, outcome) {
	    return 'Third Frame Handicap';
	};
	var bo_p32 = function bo_p32(match, outcome) {
	    return 'Fourth Frame Handicap';
	};
	var bo_q32 = function bo_q32(match, outcome) {
	    return 'Fifth Frame Handicap';
	};
	var bo_r32 = function bo_r32(match, outcome) {
	    return 'Sixth Frame Handicap';
	};
	var bo_s32 = function bo_s32(match, outcome) {
	    return 'Seventh Frame Handicap';
	};
	var bo_t32 = function bo_t32(match, outcome) {
	    return 'Eighth Frame Handicap';
	};
	var bo_u32 = function bo_u32(match, outcome) {
	    return 'Ninth Frame Handicap';
	};
	var bo_v32 = function bo_v32(match, outcome) {
	    return 'Tenth Frame Handicap';
	};
	var bo_w32 = function bo_w32(match, outcome) {
	    return 'Eleventh Frame Handicap';
	};
	var bo_x32 = function bo_x32(match, outcome) {
	    return 'Twelfth Frame Handicap';
	};
	var bo_y32 = function bo_y32(match, outcome) {
	    return 'Thirteenth Frame Handicap';
	};
	var bo_z32 = function bo_z32(match, outcome) {
	    return 'Fourteenth Frame Handicap';
	};
	var bo_a33 = function bo_a33(match, outcome) {
	    return 'Fifteenth Frame Handicap';
	};
	var bo_b33 = function bo_b33(match, outcome) {
	    return 'Sixteenth Frame Handicap';
	};
	var bo_c33 = function bo_c33(match, outcome) {
	    return 'Seventeenth Frame Handicap';
	};
	var bo_d33 = function bo_d33(match, outcome) {
	    return 'Eighteenth Frame Handicap';
	};
	var bo_e33 = function bo_e33(match, outcome) {
	    return 'Nineteenth Frame Handicap';
	};
	var bo_f33 = function bo_f33(match, outcome) {
	    return 'Twentieth Frame Handicap';
	};
	var bo_g33 = function bo_g33(match, outcome) {
	    return 'Twenty First Frame Handicap';
	};
	var bo_h33 = function bo_h33(match, outcome) {
	    return 'Twenty Second Frame Handicap';
	};
	var bo_i33 = function bo_i33(match, outcome) {
	    return 'Twenty Third Frame Handicap';
	};
	var bo_j33 = function bo_j33(match, outcome) {
	    return 'Twenty Fourth Frame Handicap';
	};
	var bo_k33 = function bo_k33(match, outcome) {
	    return 'Twenty Fifth Frame Handicap';
	};
	var bo_l33 = function bo_l33(match, outcome) {
	    return 'Twenty Sixth Frame Handicap';
	};
	var bo_m33 = function bo_m33(match, outcome) {
	    return 'Twenty Seventh Frame Handicap';
	};
	var bo_n33 = function bo_n33(match, outcome) {
	    return 'Twenty Eighth Frame Handicap';
	};
	var bo_o33 = function bo_o33(match, outcome) {
	    return 'Twenty Ninth Frame Handicap';
	};
	var bo_p33 = function bo_p33(match, outcome) {
	    return 'Thirty Frame Handicap';
	};
	var bo_q33 = function bo_q33(match, outcome) {
	    return 'Thirty First Frame Handicap';
	};
	var bo_r33 = function bo_r33(match, outcome) {
	    return 'Thirty Second Frame Handicap';
	};
	var bo_s33 = function bo_s33(match, outcome) {
	    return 'Thirty Third Frame Handicap';
	};
	var bo_t33 = function bo_t33(match, outcome) {
	    return 'Thirty Fourth Frame Handicap';
	};
	var bo_u33 = function bo_u33(match, outcome) {
	    return 'Thirty Fifth Frame Handicap';
	};
	var bo_v33 = function bo_v33(match, outcome) {
	    return 'Thirty Sixth Frame Handicap';
	};
	var bo_w33 = function bo_w33(match, outcome) {
	    return 'Thirty Seventh Frame Handicap';
	};
	var bo_x33 = function bo_x33(match, outcome) {
	    return 'First Frame Total';
	};
	var bo_y33 = function bo_y33(match, outcome) {
	    return 'Second Frame Total';
	};
	var bo_z33 = function bo_z33(match, outcome) {
	    return 'Third Frame Total';
	};
	var bo_a34 = function bo_a34(match, outcome) {
	    return 'Fourth Frame Total';
	};
	var bo_b34 = function bo_b34(match, outcome) {
	    return 'Fifth Frame Total';
	};
	var bo_c34 = function bo_c34(match, outcome) {
	    return 'Sixth Frame Total';
	};
	var bo_d34 = function bo_d34(match, outcome) {
	    return 'Seventh Frame Total';
	};
	var bo_e34 = function bo_e34(match, outcome) {
	    return 'Eighth Frame Total';
	};
	var bo_f34 = function bo_f34(match, outcome) {
	    return 'Ninth Frame Total';
	};
	var bo_g34 = function bo_g34(match, outcome) {
	    return 'Tenth Frame Total';
	};
	var bo_h34 = function bo_h34(match, outcome) {
	    return 'Eleventh Frame Total';
	};
	var bo_i34 = function bo_i34(match, outcome) {
	    return 'Twelfth Frame Total';
	};
	var bo_j34 = function bo_j34(match, outcome) {
	    return 'Thirteenth Frame Total';
	};
	var bo_k34 = function bo_k34(match, outcome) {
	    return 'Fourteenth Frame Total';
	};
	var bo_l34 = function bo_l34(match, outcome) {
	    return 'Fifteenth Frame Total';
	};
	var bo_m34 = function bo_m34(match, outcome) {
	    return 'Sixteenth Frame Total';
	};
	var bo_n34 = function bo_n34(match, outcome) {
	    return 'Seventeenth Frame Total';
	};
	var bo_o34 = function bo_o34(match, outcome) {
	    return 'Eighteenth Frame Total';
	};
	var bo_p34 = function bo_p34(match, outcome) {
	    return 'Nineteenth Frame Total';
	};
	var bo_q34 = function bo_q34(match, outcome) {
	    return 'Twentieth Frame Total';
	};
	var bo_r34 = function bo_r34(match, outcome) {
	    return 'Twenty First Frame Total';
	};
	var bo_s34 = function bo_s34(match, outcome) {
	    return 'Twenty Second Frame Total';
	};
	var bo_t34 = function bo_t34(match, outcome) {
	    return 'Twenty Third Frame';
	};
	var bo_u34 = function bo_u34(match, outcome) {
	    return 'Twenty Fourth Frame Total';
	};
	var bo_v34 = function bo_v34(match, outcome) {
	    return 'Twenty Fifth Frame Total';
	};
	var bo_w34 = function bo_w34(match, outcome) {
	    return 'Twenty Sixth Frame Total';
	};
	var bo_x34 = function bo_x34(match, outcome) {
	    return 'Twenty Seventh Frame Total';
	};
	var bo_y34 = function bo_y34(match, outcome) {
	    return 'Twenty Eighth Frame Total';
	};
	var bo_z34 = function bo_z34(match, outcome) {
	    return 'Twenty Ninth Frame Total';
	};
	var bo_a35 = function bo_a35(match, outcome) {
	    return 'Thirtieth Frame Total';
	};
	var bo_b35 = function bo_b35(match, outcome) {
	    return 'Thirty First Frame Total';
	};
	var bo_c35 = function bo_c35(match, outcome) {
	    return 'Thirty Second Frame Total';
	};
	var bo_d35 = function bo_d35(match, outcome) {
	    return 'Thirty Third Frame Total';
	};
	var bo_e35 = function bo_e35(match, outcome) {
	    return 'Thirty Fourth Frame';
	};
	var bo_f35 = function bo_f35(match, outcome) {
	    return 'Thirty Fifth Frame Total';
	};
	var bo_g35 = function bo_g35(match, outcome) {
	    return 'Thirty Sixth Frame Total';
	};
	var bo_h35 = function bo_h35(match, outcome) {
	    return 'Thirty Seventh Frame Total';
	};
	var bo_i35 = function bo_i35(match, outcome) {
	    return 'First Player To Pot - First Frame';
	};
	var bo_j35 = function bo_j35(match, outcome) {
	    return 'First Player To Pot - Second Frame';
	};
	var bo_k35 = function bo_k35(match, outcome) {
	    return 'First Player To Pot - Third Frame';
	};
	var bo_l35 = function bo_l35(match, outcome) {
	    return 'First Player To Pot - Fourth Frame';
	};
	var bo_m35 = function bo_m35(match, outcome) {
	    return 'First Player To Pot - Fifth Frame';
	};
	var bo_n35 = function bo_n35(match, outcome) {
	    return 'First Player To Pot - Sixth Frame';
	};
	var bo_o35 = function bo_o35(match, outcome) {
	    return 'Fourth Game Handicap';
	};
	var bo_p35 = function bo_p35(match, outcome) {
	    return 'Fifth Game Handicap';
	};
	var bo_q35 = function bo_q35(match, outcome) {
	    return 'Sixth Game Handicap';
	};
	var bo_r35 = function bo_r35(match, outcome) {
	    return 'Seventh Game Handicap';
	};
	var bo_s35 = function bo_s35(match, outcome) {
	    return 'Fourth Game Total';
	};
	var bo_t35 = function bo_t35(match, outcome) {
	    return 'Fifth Game Total';
	};
	var bo_u35 = function bo_u35(match, outcome) {
	    return 'Sixth Game Total';
	};
	var bo_v35 = function bo_v35(match, outcome) {
	    return 'Seventh Game Total';
	};
	var bo_w35 = function bo_w35(match, outcome) {
	    return 'Match Games Total';
	};
	var bo_x35 = function bo_x35(match, outcome) {
	    return match.homeTeam + " Fourth Game Total";
	};
	var bo_y35 = function bo_y35(match, outcome) {
	    return match.homeTeam + " Fifth Game Total";
	};
	var bo_z35 = function bo_z35(match, outcome) {
	    return match.homeTeam + " Sixth Game Total";
	};
	var bo_a36 = function bo_a36(match, outcome) {
	    return match.homeTeam + " Seventh Game Total";
	};
	var bo_b36 = function bo_b36(match, outcome) {
	    return match.awayTeam + " Fourth Game Total";
	};
	var bo_c36 = function bo_c36(match, outcome) {
	    return match.awayTeam + " Fifth Game Total";
	};
	var bo_d36 = function bo_d36(match, outcome) {
	    return match.awayTeam + " Sixth Game Total";
	};
	var bo_e36 = function bo_e36(match, outcome) {
	    return match.awayTeam + " Seventh Game Total";
	};
	var bo_f36 = function bo_f36(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " - Fourth Game";
	};
	var bo_g36 = function bo_g36(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " - Fifth Game";
	};
	var bo_h36 = function bo_h36(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " - Sixth Game";
	};
	var bo_i36 = function bo_i36(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " - Seventh Game";
	};
	var bo_j36 = function bo_j36(match, outcome) {
	    return 'Fourth Game Winner';
	};
	var bo_k36 = function bo_k36(match, outcome) {
	    return 'Fifth Game Winner';
	};
	var bo_l36 = function bo_l36(match, outcome) {
	    return 'Sixth Game Winner';
	};
	var bo_m36 = function bo_m36(match, outcome) {
	    return 'Seventh Game Winner';
	};
	var bo_n36 = function bo_n36(match, outcome) {
	    return match.homeTeam + " 1st Game Winning Margin - " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']);
	};
	var bo_o36 = function bo_o36(match, outcome) {
	    return match.homeTeam + " 2nd Game Winning Margin - " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']);
	};
	var bo_p36 = function bo_p36(match, outcome) {
	    return match.homeTeam + " 3rd Game Winning Margin - " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']);
	};
	var bo_q36 = function bo_q36(match, outcome) {
	    return match.homeTeam + " 4th Game Winning Margin - " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']);
	};
	var bo_r36 = function bo_r36(match, outcome) {
	    return match.homeTeam + " 5th Game Winning Margin - " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']);
	};
	var bo_s36 = function bo_s36(match, outcome) {
	    return match.homeTeam + " 6th Game Winning Margin - " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']);
	};
	var bo_t36 = function bo_t36(match, outcome) {
	    return match.homeTeam + " 7th Game Winning Margin - " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']);
	};
	var bo_u36 = function bo_u36(match, outcome) {
	    return match.awayTeam + " 1st Game Winning Margin - " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']);
	};
	var bo_v36 = function bo_v36(match, outcome) {
	    return match.awayTeam + " 2nd Game Winning Margin - " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']);
	};
	var bo_w36 = function bo_w36(match, outcome) {
	    return match.awayTeam + " 3rd Game Winning Margin - " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']);
	};
	var bo_x36 = function bo_x36(match, outcome) {
	    return match.awayTeam + " 4th Game Winning Margin - " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']);
	};
	var bo_y36 = function bo_y36(match, outcome) {
	    return match.awayTeam + " 5th Game Winning Margin - " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']);
	};
	var bo_z36 = function bo_z36(match, outcome) {
	    return match.awayTeam + " 6th Game Winning Margin - " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']);
	};
	var bo_a37 = function bo_a37(match, outcome) {
	    return match.awayTeam + " 7th Game Winning Margin - " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']);
	};
	var bo_b37 = function bo_b37(match, outcome) {
	    return 'First Game Exact Total';
	};
	var bo_c37 = function bo_c37(match, outcome) {
	    return 'Second Game Exact Total';
	};
	var bo_d37 = function bo_d37(match, outcome) {
	    return 'Third Game Exact Total';
	};
	var bo_e37 = function bo_e37(match, outcome) {
	    return 'Fourth Game Exact Total';
	};
	var bo_f37 = function bo_f37(match, outcome) {
	    return 'Fifth Game Exact Total';
	};
	var bo_g37 = function bo_g37(match, outcome) {
	    return 'Sixth Game Exact Total';
	};
	var bo_h37 = function bo_h37(match, outcome) {
	    return 'Seventh Game Exact Total';
	};
	var bo_i37 = function bo_i37(match, outcome) {
	    return numeralNeuterEnding(outcome.condition) + " Point - First Game";
	};
	var bo_j37 = function bo_j37(match, outcome) {
	    return numeralNeuterEnding(outcome.condition) + " Point - Second Game";
	};
	var bo_k37 = function bo_k37(match, outcome) {
	    return numeralNeuterEnding(outcome.condition) + " Point - Third Game";
	};
	var bo_l37 = function bo_l37(match, outcome) {
	    return numeralNeuterEnding(outcome.condition) + " Point - Fourth Game";
	};
	var bo_m37 = function bo_m37(match, outcome) {
	    return numeralNeuterEnding(outcome.condition) + " Point - Fifth Game";
	};
	var bo_n37 = function bo_n37(match, outcome) {
	    return numeralNeuterEnding(outcome.condition) + " Point - Sixth Game";
	};
	var bo_o37 = function bo_o37(match, outcome) {
	    return numeralNeuterEnding(outcome.condition) + " Point - Seventh Game";
	};
	var bo_p37 = function bo_p37(match, outcome) {
	    return 'Fourth Set Even/Odd';
	};
	var bo_q37 = function bo_q37(match, outcome) {
	    return 'Fifth Set Even/Odd';
	};
	var bo_r37 = function bo_r37(match, outcome) {
	    return 'Sixth Set Even/Odd';
	};
	var bo_s37 = function bo_s37(match, outcome) {
	    return 'Seventh Set Even/Odd';
	};
	var bo_t37 = function bo_t37(match, outcome) {
	    return 'Match Correct Score';
	};
	var bo_u37 = function bo_u37(match, outcome) {
	    return match.awayTeam + " To Break In The 1st or 2-nd Games";
	};
	var bo_v37 = function bo_v37(match, outcome) {
	    return 'Games Taken In A Row Total By Player';
	};
	var bo_w37 = function bo_w37(match, outcome) {
	    return 'Players To Exchange The Breaks';
	};
	var bo_x37 = function bo_x37(match, outcome) {
	    return match.homeTeam + " Fourth Set Total";
	};
	var bo_y37 = function bo_y37(match, outcome) {
	    return match.homeTeam + " Fifth Set Total";
	};
	var bo_z37 = function bo_z37(match, outcome) {
	    return match.awayTeam + " Fourth Set Total";
	};
	var bo_a38 = function bo_a38(match, outcome) {
	    return match.awayTeam + " Fifth Set Total";
	};
	var bo_b38 = function bo_b38(match, outcome) {
	    return 'First Set / Match';
	};
	var bo_c38 = function bo_c38(match, outcome) {
	    return "Break Point In The " + outcome.condition + " Game";
	};
	var bo_d38 = function bo_d38(match, outcome) {
	    return 'Second Set Breaks Total';
	};
	var bo_e38 = function bo_e38(match, outcome) {
	    return 'Third Set Breaks Total';
	};
	var bo_f38 = function bo_f38(match, outcome) {
	    return 'Fourth Set Breaks Total';
	};
	var bo_g38 = function bo_g38(match, outcome) {
	    return 'Fifth Set Breaks Total';
	};
	var bo_h38 = function bo_h38(match, outcome) {
	    return "Result & Total " + outcome.condition + " - Second Set";
	};
	var bo_i38 = function bo_i38(match, outcome) {
	    return "Result & Total " + outcome.condition + " - Third Set";
	};
	var bo_j38 = function bo_j38(match, outcome) {
	    return "Result & Total " + outcome.condition + " - Fourth Set";
	};
	var bo_k38 = function bo_k38(match, outcome) {
	    return "Result & Total " + outcome.condition + " - Fifth Set";
	};
	var bo_l38 = function bo_l38(match, outcome) {
	    return match.homeTeam + " First Set Breaks Total";
	};
	var bo_m38 = function bo_m38(match, outcome) {
	    return match.homeTeam + " Second Set Breaks Total";
	};
	var bo_n38 = function bo_n38(match, outcome) {
	    return match.homeTeam + " Third Set Breaks Total";
	};
	var bo_o38 = function bo_o38(match, outcome) {
	    return match.homeTeam + " Fourth Set Breaks Total";
	};
	var bo_p38 = function bo_p38(match, outcome) {
	    return match.homeTeam + " Fifth Set Breaks Total";
	};
	var bo_q38 = function bo_q38(match, outcome) {
	    return match.awayTeam + " First Set Breaks Total";
	};
	var bo_r38 = function bo_r38(match, outcome) {
	    return match.awayTeam + " Second Set Breaks Total";
	};
	var bo_s38 = function bo_s38(match, outcome) {
	    return match.awayTeam + " Third Set Breaks Total";
	};
	var bo_t38 = function bo_t38(match, outcome) {
	    return match.awayTeam + " Fourth Set Breaks Total";
	};
	var bo_u38 = function bo_u38(match, outcome) {
	    return match.awayTeam + " Fifth Set Breaks Total";
	};
	var bo_v38 = function bo_v38(match, outcome) {
	    return "A Player To Win " + outcome.condition + " " + plural(outcome.condition, ['Game', 'Games', 'Games']) + " In A Row - First Set";
	};
	var bo_w38 = function bo_w38(match, outcome) {
	    return "A Player To Win " + outcome.condition + " " + plural(outcome.condition, ['Game', 'Games', 'Games']) + " In A Row - Second Set";
	};
	var bo_x38 = function bo_x38(match, outcome) {
	    return "A Player To Win " + outcome.condition + " " + plural(outcome.condition, ['Game', 'Games', 'Games']) + " In A Row - Third Set";
	};
	var bo_y38 = function bo_y38(match, outcome) {
	    return "A Player To Win " + outcome.condition + " " + plural(outcome.condition, ['Game', 'Games', 'Games']) + " In A Row - Fourth Set";
	};
	var bo_z38 = function bo_z38(match, outcome) {
	    return "A Player To Win " + outcome.condition + " " + plural(outcome.condition, ['Game', 'Games', 'Games']) + " In A Row - Fifth Set";
	};
	var bo_a39 = function bo_a39(match, outcome) {
	    return match.homeTeam + " To Win " + outcome.condition + " " + plural(outcome.condition, ['Game', 'Games', 'Games']) + " In A Row - Second Set";
	};
	var bo_b39 = function bo_b39(match, outcome) {
	    return match.homeTeam + " To Win " + outcome.condition + " " + plural(outcome.condition, ['Game', 'Games', 'Games']) + " In A Row - Third Set";
	};
	var bo_c39 = function bo_c39(match, outcome) {
	    return match.homeTeam + " To Win " + outcome.condition + " " + plural(outcome.condition, ['Game', 'Games', 'Games']) + " In A Row - Fourth Set";
	};
	var bo_d39 = function bo_d39(match, outcome) {
	    return match.homeTeam + " To Win " + outcome.condition + " " + plural(outcome.condition, ['Game', 'Games', 'Games']) + " In A Row - Fifth Set";
	};
	var bo_e39 = function bo_e39(match, outcome) {
	    return match.awayTeam + " To Win " + outcome.condition + " " + plural(outcome.condition, ['Game', 'Games', 'Games']) + " In A Row - First Set";
	};
	var bo_f39 = function bo_f39(match, outcome) {
	    return match.awayTeam + " To Win " + outcome.condition + " " + plural(outcome.condition, ['Game', 'Games', 'Games']) + " In A Row - Second Set";
	};
	var bo_g39 = function bo_g39(match, outcome) {
	    return match.awayTeam + " To Win " + outcome.condition + " " + plural(outcome.condition, ['Game', 'Games', 'Games']) + " In A Row - Third Set";
	};
	var bo_h39 = function bo_h39(match, outcome) {
	    return match.awayTeam + " To Win " + outcome.condition + " " + plural(outcome.condition, ['Game', 'Games', 'Games']) + " In A Row - Fourth Set";
	};
	var bo_i39 = function bo_i39(match, outcome) {
	    return match.awayTeam + " To Win " + outcome.condition + " " + plural(outcome.condition, ['Game', 'Games', 'Games']) + " In A Row - Fifth Set";
	};
	var bo_j39 = function bo_j39(match, outcome) {
	    return 'Match Handicap';
	};
	var bo_k39 = function bo_k39(match, outcome) {
	    return 'Fourth Set Handicap';
	};
	var bo_l39 = function bo_l39(match, outcome) {
	    return 'Fifth Set Handicap';
	};
	var bo_m39 = function bo_m39(match, outcome) {
	    return 'Fourth Set Total';
	};
	var bo_n39 = function bo_n39(match, outcome) {
	    return 'Fifth Set Total';
	};
	var bo_o39 = function bo_o39(match, outcome) {
	    return 'Number of Sets';
	};
	var bo_p39 = function bo_p39(match, outcome) {
	    return outcome.condition + " Game Score";
	};
	var bo_q39 = function bo_q39(match, outcome) {
	    return outcome.condition + " Game Winner";
	};
	var bo_r39 = function bo_r39(match, outcome) {
	    return '1st Set Score';
	};
	var bo_s39 = function bo_s39(match, outcome) {
	    return '2nd Set Score';
	};
	var bo_t39 = function bo_t39(match, outcome) {
	    return '3rd Set Score';
	};
	var bo_u39 = function bo_u39(match, outcome) {
	    return '4th Set Score';
	};
	var bo_v39 = function bo_v39(match, outcome) {
	    return '5th Set Score';
	};
	var bo_w39 = function bo_w39(match, outcome) {
	    return "15X15 in " + outcome.condition + " Game";
	};
	var bo_x39 = function bo_x39(match, outcome) {
	    return "30X30 in " + outcome.condition + " Game";
	};
	var bo_y39 = function bo_y39(match, outcome) {
	    return outcome.condition + " Game To Deuce";
	};
	var bo_z39 = function bo_z39(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['Game', 'Games', 'Games']) + " - First Set";
	};
	var bo_a40 = function bo_a40(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['Game', 'Games', 'Games']) + " - Second Set";
	};
	var bo_b40 = function bo_b40(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['Game', 'Games', 'Games']) + " - Third Set";
	};
	var bo_c40 = function bo_c40(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['Game', 'Games', 'Games']) + " - Fourth Set";
	};
	var bo_d40 = function bo_d40(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['Game', 'Games', 'Games']) + " - Fifth Set";
	};
	var bo_e40 = function bo_e40(match, outcome) {
	    return 'Fourth Set Winner';
	};
	var bo_f40 = function bo_f40(match, outcome) {
	    return 'Fifth Set Winner';
	};
	var bo_g40 = function bo_g40(match, outcome) {
	    return "First Point - " + outcome.condition + " Game";
	};
	var bo_h40 = function bo_h40(match, outcome) {
	    return 'Tie Break in First Set';
	};
	var bo_i40 = function bo_i40(match, outcome) {
	    return 'Tie Break in Second Set';
	};
	var bo_j40 = function bo_j40(match, outcome) {
	    return 'Tie Break in Third Set';
	};
	var bo_k40 = function bo_k40(match, outcome) {
	    return 'Tie Break in Fourth Set';
	};
	var bo_l40 = function bo_l40(match, outcome) {
	    return 'Tie Break in Fifth Set';
	};
	var bo_m40 = function bo_m40(match, outcome) {
	    return 'Tie Break in Match';
	};
	var bo_n40 = function bo_n40(match, outcome) {
	    return 'First Set Tie-Break Total';
	};
	var bo_o40 = function bo_o40(match, outcome) {
	    return 'Second Set Tie-Break Total';
	};
	var bo_p40 = function bo_p40(match, outcome) {
	    return 'Third Set Tie-Break Total';
	};
	var bo_q40 = function bo_q40(match, outcome) {
	    return 'Fourth Set Tie-Break Total';
	};
	var bo_r40 = function bo_r40(match, outcome) {
	    return 'Fifth Set Tie-Break Total';
	};
	var bo_s40 = function bo_s40(match, outcome) {
	    return 'First Set Tie-Break Score';
	};
	var bo_t40 = function bo_t40(match, outcome) {
	    return 'Second Set Tie-Break Score';
	};
	var bo_u40 = function bo_u40(match, outcome) {
	    return 'Third Set Tie-Break Score';
	};
	var bo_v40 = function bo_v40(match, outcome) {
	    return 'Fourth Set Tie-Break Score';
	};
	var bo_w40 = function bo_w40(match, outcome) {
	    return 'Fifth Set Tie-Break Score';
	};
	var bo_x40 = function bo_x40(match, outcome) {
	    return 'First Set Tie Break Exact Total';
	};
	var bo_y40 = function bo_y40(match, outcome) {
	    return 'Second Set Tie Break Exact Total';
	};
	var bo_z40 = function bo_z40(match, outcome) {
	    return 'Third Set Tie Break Exact Total';
	};
	var bo_a41 = function bo_a41(match, outcome) {
	    return 'Fourth Set Tie Break Exact Total';
	};
	var bo_b41 = function bo_b41(match, outcome) {
	    return 'Fifth Set Tie Break Exact Total';
	};
	var bo_c41 = function bo_c41(match, outcome) {
	    return 'First Set Tie Break Winner';
	};
	var bo_d41 = function bo_d41(match, outcome) {
	    return 'Second Set Tie Break Winner';
	};
	var bo_e41 = function bo_e41(match, outcome) {
	    return 'Third Set Tie Break Winner';
	};
	var bo_f41 = function bo_f41(match, outcome) {
	    return 'Fourth Set Tie Break Winner';
	};
	var bo_g41 = function bo_g41(match, outcome) {
	    return 'Fifth Set Tie Break Winner';
	};
	var bo_h41 = function bo_h41(match, outcome) {
	    return 'First Set Breaks Total';
	};
	var bo_i41 = function bo_i41(match, outcome) {
	    return 'Match Breaks Total';
	};
	var bo_j41 = function bo_j41(match, outcome) {
	    return match.homeTeam + " To Win A Set In The Match";
	};
	var bo_k41 = function bo_k41(match, outcome) {
	    return match.awayTeam + " To Win A Set In The Match";
	};
	var bo_l41 = function bo_l41(match, outcome) {
	    return "Result & Total " + outcome.condition + " - First Set";
	};
	var bo_m41 = function bo_m41(match, outcome) {
	    return 'Lowest Scoring Set Total';
	};
	var bo_n41 = function bo_n41(match, outcome) {
	    return 'To Serve The First Ace';
	};
	var bo_o41 = function bo_o41(match, outcome) {
	    return 'To Double Fault First';
	};
	var bo_p41 = function bo_p41(match, outcome) {
	    return match.homeTeam + " Highest Serving Speed (km/h)";
	};
	var bo_q41 = function bo_q41(match, outcome) {
	    return match.awayTeam + " Highest Serving Speed (km/h)";
	};
	var bo_r41 = function bo_r41(match, outcome) {
	    return 'To Lose First Set / To Win Match';
	};
	var bo_s41 = function bo_s41(match, outcome) {
	    return match.homeTeam + " % Good First Serves";
	};
	var bo_t41 = function bo_t41(match, outcome) {
	    return match.awayTeam + " % Good First Serves";
	};
	var bo_u41 = function bo_u41(match, outcome) {
	    return 'Match Breaks Result';
	};
	var bo_v41 = function bo_v41(match, outcome) {
	    return match.homeTeam + " Breaks Total";
	};
	var bo_w41 = function bo_w41(match, outcome) {
	    return match.awayTeam + " Breaks Total";
	};
	var bo_x41 = function bo_x41(match, outcome) {
	    return 'To Break First';
	};
	var bo_y41 = function bo_y41(match, outcome) {
	    return match.homeTeam + " To Break In The 1st or 2nd Game";
	};
	var bo_z41 = function bo_z41(match, outcome) {
	    return 'A Set To Be Completed 6:0 or 0:6';
	};
	var bo_a42 = function bo_a42(match, outcome) {
	    return numeralMaleEnding(outcome.condition) + " Game Winner";
	};
	var bo_b42 = function bo_b42(match, outcome) {
	    return "To Be 15x15 In " + outcome.condition + " Game?";
	};
	var bo_c42 = function bo_c42(match, outcome) {
	    return "To Be 30x30 In " + outcome.condition + " Game?";
	};
	var bo_d42 = function bo_d42(match, outcome) {
	    return "To Be 40x40 In " + outcome.condition + " Game?";
	};
	var bo_e42 = function bo_e42(match, outcome) {
	    return numeralMaleEnding(outcome.condition) + " Game Score";
	};
	var bo_f42 = function bo_f42(match, outcome) {
	    return 'Aces Total';
	};
	var bo_g42 = function bo_g42(match, outcome) {
	    return "Match Aces Total: " + match.homeTeam;
	};
	var bo_h42 = function bo_h42(match, outcome) {
	    return "Match Aces Total: " + match.awayTeam;
	};
	var bo_i42 = function bo_i42(match, outcome) {
	    return 'Match Total Double Faults';
	};
	var bo_j42 = function bo_j42(match, outcome) {
	    return "Match Total Double Faults: " + match.homeTeam;
	};
	var bo_k42 = function bo_k42(match, outcome) {
	    return "Match Total Double Faults: " + match.awayTeam;
	};
	var bo_l42 = function bo_l42(match, outcome) {
	    return 'Highest Scoring Set';
	};
	var bo_m42 = function bo_m42(match, outcome) {
	    return 'To Win Match By Ace';
	};
	var bo_n42 = function bo_n42(match, outcome) {
	    return "To Be Ace In 1st Or 2nd Games: " + match.homeTeam;
	};
	var bo_o42 = function bo_o42(match, outcome) {
	    return "To Be Ace In 1st Or 2nd Games: " + match.awayTeam;
	};
	var bo_p42 = function bo_p42(match, outcome) {
	    return "To Be Double Fault In 1st Or 2nd Games: " + match.homeTeam;
	};
	var bo_q42 = function bo_q42(match, outcome) {
	    return "To Be Double Fault In 1st Or 2nd Games: " + match.awayTeam;
	};
	var bo_r42 = function bo_r42(match, outcome) {
	    return 'First Set Aces Total';
	};
	var bo_s42 = function bo_s42(match, outcome) {
	    return 'To Be Disqualification Or Retirement';
	};
	var bo_t42 = function bo_t42(match, outcome) {
	    return "Win % 1st serve " + match.homeTeam;
	};
	var bo_u42 = function bo_u42(match, outcome) {
	    return "Win % 1st serve " + match.awayTeam;
	};
	var bo_v42 = function bo_v42(match, outcome) {
	    return 'Breaks Result - First Set';
	};
	var bo_w42 = function bo_w42(match, outcome) {
	    return 'Breaks Result - Second Set';
	};
	var bo_x42 = function bo_x42(match, outcome) {
	    return 'Breaks Result - Third Set';
	};
	var bo_y42 = function bo_y42(match, outcome) {
	    return 'Breaks Result - Fourth Set';
	};
	var bo_z42 = function bo_z42(match, outcome) {
	    return 'Breaks Result - Fifth Set';
	};
	var bo_a43 = function bo_a43(match, outcome) {
	    return 'Match Breaks Handicap';
	};
	var bo_b43 = function bo_b43(match, outcome) {
	    return 'Breaks Handicap - First Set';
	};
	var bo_c43 = function bo_c43(match, outcome) {
	    return 'Breaks Handicap - Second Set';
	};
	var bo_d43 = function bo_d43(match, outcome) {
	    return 'Breaks Handicap - Third Set';
	};
	var bo_e43 = function bo_e43(match, outcome) {
	    return 'Breaks Handicap - Fourth Set';
	};
	var bo_f43 = function bo_f43(match, outcome) {
	    return 'Breaks Handicap - Fifth Set';
	};
	var bo_g43 = function bo_g43(match, outcome) {
	    return "Point Winner - Point " + outcome.conditionTwo + ", Game " + numeralMaleEnding(outcome.condition);
	};
	var bo_h43 = function bo_h43(match, outcome) {
	    return "To Win " + outcome.condition + " And " + outcome.conditionTwo + " Games";
	};
	var bo_i43 = function bo_i43(match, outcome) {
	    return numeralMaleEnding(outcome.conditionTwo) + " Game Handicap";
	};
	var bo_j43 = function bo_j43(match, outcome) {
	    return numeralMaleEnding(outcome.conditionTwo) + " Game Total";
	};
	var bo_k43 = function bo_k43(match, outcome) {
	    return 'First Set Result';
	};
	var bo_l43 = function bo_l43(match, outcome) {
	    return 'Second Set Result';
	};
	var bo_m43 = function bo_m43(match, outcome) {
	    return 'Third Set Result';
	};
	var bo_n43 = function bo_n43(match, outcome) {
	    return 'Fourth Set Result';
	};
	var bo_o43 = function bo_o43(match, outcome) {
	    return 'Fifth Set Result';
	};
	var bo_p43 = function bo_p43(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " - Fourth Set";
	};
	var bo_q43 = function bo_q43(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " - Fifth Set";
	};
	var bo_r43 = function bo_r43(match, outcome) {
	    return 'Handicap - Sets';
	};
	var bo_s43 = function bo_s43(match, outcome) {
	    return 'First Set Exact Total';
	};
	var bo_t43 = function bo_t43(match, outcome) {
	    return 'Second Set Exact Total';
	};
	var bo_u43 = function bo_u43(match, outcome) {
	    return 'Third Set Exact Total';
	};
	var bo_v43 = function bo_v43(match, outcome) {
	    return 'Fourth Set Exact Total';
	};
	var bo_w43 = function bo_w43(match, outcome) {
	    return 'Fifth Set Exact Total';
	};
	var bo_x43 = function bo_x43(match, outcome) {
	    return match.homeTeam + " Fourth Set Winning Margin";
	};
	var bo_y43 = function bo_y43(match, outcome) {
	    return match.homeTeam + " Fifth Set Winning Margin";
	};
	var bo_z43 = function bo_z43(match, outcome) {
	    return match.awayTeam + " Fourth Set Winning Margin";
	};
	var bo_a44 = function bo_a44(match, outcome) {
	    return match.awayTeam + " Fifth Set Winning Margin";
	};
	var bo_b44 = function bo_b44(match, outcome) {
	    return "First Set Result & Total " + outcome.condition;
	};
	var bo_c44 = function bo_c44(match, outcome) {
	    return "Fourth Set Result / Total " + outcome.condition;
	};
	var bo_d44 = function bo_d44(match, outcome) {
	    return "Fifth Set Result / Total " + outcome.condition;
	};
	var bo_e44 = function bo_e44(match, outcome) {
	    return 'Fifth Set Result / Total';
	};
	var bo_f44 = function bo_f44(match, outcome) {
	    return 'Highest Scoring Set Total';
	};
	var bo_g44 = function bo_g44(match, outcome) {
	    return 'Fourth Set Winning Margin';
	};
	var bo_h44 = function bo_h44(match, outcome) {
	    return 'Fifth Set Winning Margin';
	};
	var bo_i44 = function bo_i44(match, outcome) {
	    return '10 Points Miniset Winner - Fourth Set';
	};
	var bo_j44 = function bo_j44(match, outcome) {
	    return '10 Points Miniset Handicap - Fourth Set';
	};
	var bo_k44 = function bo_k44(match, outcome) {
	    return '10 Points Miniset Total - Fourth Set';
	};
	var bo_l44 = function bo_l44(match, outcome) {
	    return '15 Points Miniset Winner - Fourth Set';
	};
	var bo_m44 = function bo_m44(match, outcome) {
	    return '15 Points Miniset Handicap - Fourth Set';
	};
	var bo_n44 = function bo_n44(match, outcome) {
	    return '15 Points Miniset Total - Fourth Set';
	};
	var bo_o44 = function bo_o44(match, outcome) {
	    return "Who Wins " + numeralNeuterEnding(outcome.condition) + " Point In First Set";
	};
	var bo_p44 = function bo_p44(match, outcome) {
	    return "Who Wins " + numeralNeuterEnding(outcome.condition) + " Point In Second Set";
	};
	var bo_q44 = function bo_q44(match, outcome) {
	    return "Who Wins " + numeralNeuterEnding(outcome.condition) + " Point In Third Set";
	};
	var bo_r44 = function bo_r44(match, outcome) {
	    return "Who Wins " + numeralNeuterEnding(outcome.condition) + " Point In Fourth Set";
	};
	var bo_s44 = function bo_s44(match, outcome) {
	    return "Who Wins " + numeralNeuterEnding(outcome.condition) + " Point In Fifth Set";
	};
	var bo_t44 = function bo_t44(match, outcome) {
	    return "Result / Total " + outcome.condition;
	};
	var bo_u44 = function bo_u44(match, outcome) {
	    return 'Golden Set Handicap';
	};
	var bo_v44 = function bo_v44(match, outcome) {
	    return 'Golden Set Total';
	};
	var bo_w44 = function bo_w44(match, outcome) {
	    return match.homeTeam + " Golden Set Total";
	};
	var bo_x44 = function bo_x44(match, outcome) {
	    return match.awayTeam + " Golden Set Total";
	};
	var bo_y44 = function bo_y44(match, outcome) {
	    return 'Golden Set Result';
	};
	var bo_z44 = function bo_z44(match, outcome) {
	    return "Race To " + outcome.condition + " " + plural(outcome.condition, ['point', 'points', 'points']) + " - Golden Set";
	};
	var bo_a45 = function bo_a45(match, outcome) {
	    return 'Golden Set Exact Total';
	};
	var bo_b45 = function bo_b45(match, outcome) {
	    return 'Golden Set Even/Odd';
	};
	var bo_c45 = function bo_c45(match, outcome) {
	    return "Golden Set Result / Total " + outcome.condition;
	};
	var bo_d45 = function bo_d45(match, outcome) {
	    return 'Golden Set Winning Margin';
	};
	var bo_e45 = function bo_e45(match, outcome) {
	    return 'How many sets will exceed score limit';
	};
	var bo_f45 = function bo_f45(match, outcome) {
	    return outcome.condition + " Round Winner";
	};
	var bo_g45 = function bo_g45(match, outcome) {
	    return 'Game Handicap';
	};
	var bo_h45 = function bo_h45(match, outcome) {
	    return 'Game Score';
	};
	var bo_i45 = function bo_i45(match, outcome) {
	    return '13th Sector To Appear';
	};
	var bo_j45 = function bo_j45(match, outcome) {
	    return '13th Sector To Appear in The First Round';
	};
	
	var fa_b1 = function fa_b1(match, outcome) {
	    return "Han1(" + signed(outcome.condition) + ")";
	};
	var fa_c1 = function fa_c1(match, outcome) {
	    return "Han2(" + signed(-outcome.condition) + ")";
	};
	var fa_d1 = function fa_d1(match, outcome) {
	    return "Under " + outcome.condition;
	};
	var fa_e1 = function fa_e1(match, outcome) {
	    return "Over " + outcome.condition;
	};
	var fa_f1 = function fa_f1(match, outcome) {
	    return 'Even';
	};
	var fa_g1 = function fa_g1(match, outcome) {
	    return 'Odd';
	};
	var fa_h1 = function fa_h1(match, outcome) {
	    return "" + match.homeTeam;
	};
	var fa_i1 = function fa_i1(match, outcome) {
	    return "" + match.awayTeam;
	};
	var fa_j1 = function fa_j1(match, outcome) {
	    return '1-st Higher';
	};
	var fa_k1 = function fa_k1(match, outcome) {
	    return '2-nd Higher';
	};
	var fa_l1 = function fa_l1(match, outcome) {
	    return 'Yes';
	};
	var fa_m1 = function fa_m1(match, outcome) {
	    return 'No';
	};
	var fa_n1 = function fa_n1(match, outcome) {
	    return '0-2';
	};
	var fa_o1 = function fa_o1(match, outcome) {
	    return '0-3';
	};
	var fa_p1 = function fa_p1(match, outcome) {
	    return '1-2';
	};
	var fa_q1 = function fa_q1(match, outcome) {
	    return '1-3';
	};
	var fa_r1 = function fa_r1(match, outcome) {
	    return '2-0';
	};
	var fa_s1 = function fa_s1(match, outcome) {
	    return '2-1';
	};
	var fa_t1 = function fa_t1(match, outcome) {
	    return '2-3';
	};
	var fa_u1 = function fa_u1(match, outcome) {
	    return '3-0';
	};
	var fa_v1 = function fa_v1(match, outcome) {
	    return '3-1';
	};
	var fa_w1 = function fa_w1(match, outcome) {
	    return '3-2';
	};
	var fa_x1 = function fa_x1(match, outcome) {
	    return 'W1';
	};
	var fa_y1 = function fa_y1(match, outcome) {
	    return 'W2';
	};
	var fa_z1 = function fa_z1(match, outcome) {
	    return 'Х';
	};
	var fa_a2 = function fa_a2(match, outcome) {
	    return 'No one';
	};
	var fa_b2 = function fa_b2(match, outcome) {
	    return '1X';
	};
	var fa_c2 = function fa_c2(match, outcome) {
	    return '12';
	};
	var fa_d2 = function fa_d2(match, outcome) {
	    return '2X';
	};
	var fa_e2 = function fa_e2(match, outcome) {
	    return "W1&Tu " + outcome.condition;
	};
	var fa_f2 = function fa_f2(match, outcome) {
	    return "W1&To " + outcome.condition;
	};
	var fa_g2 = function fa_g2(match, outcome) {
	    return "W2&Tu " + outcome.condition;
	};
	var fa_h2 = function fa_h2(match, outcome) {
	    return "W2&To " + outcome.condition;
	};
	var fa_i2 = function fa_i2(match, outcome) {
	    return "\u0425&Tu " + outcome.condition;
	};
	var fa_j2 = function fa_j2(match, outcome) {
	    return "\u0425&To " + outcome.condition;
	};
	var fa_k2 = function fa_k2(match, outcome) {
	    return '0';
	};
	var fa_l2 = function fa_l2(match, outcome) {
	    return '1';
	};
	var fa_m2 = function fa_m2(match, outcome) {
	    return '2';
	};
	var fa_n2 = function fa_n2(match, outcome) {
	    return '3';
	};
	var fa_o2 = function fa_o2(match, outcome) {
	    return '4';
	};
	var fa_p2 = function fa_p2(match, outcome) {
	    return '≥ 5';
	};
	var fa_q2 = function fa_q2(match, outcome) {
	    return 'Both';
	};
	var fa_r2 = function fa_r2(match, outcome) {
	    return 'One';
	};
	var fa_s2 = function fa_s2(match, outcome) {
	    return 'No Goals';
	};
	var fa_t2 = function fa_t2(match, outcome) {
	    return '0-0';
	};
	var fa_u2 = function fa_u2(match, outcome) {
	    return '0-1';
	};
	var fa_v2 = function fa_v2(match, outcome) {
	    return '0-4';
	};
	var fa_w2 = function fa_w2(match, outcome) {
	    return '0-5';
	};
	var fa_x2 = function fa_x2(match, outcome) {
	    return '1-0';
	};
	var fa_y2 = function fa_y2(match, outcome) {
	    return '1-1';
	};
	var fa_z2 = function fa_z2(match, outcome) {
	    return '1-4';
	};
	var fa_a3 = function fa_a3(match, outcome) {
	    return '1-5';
	};
	var fa_b3 = function fa_b3(match, outcome) {
	    return '2-2';
	};
	var fa_c3 = function fa_c3(match, outcome) {
	    return '2-4';
	};
	var fa_d3 = function fa_d3(match, outcome) {
	    return '2-5';
	};
	var fa_e3 = function fa_e3(match, outcome) {
	    return '2-6';
	};
	var fa_f3 = function fa_f3(match, outcome) {
	    return '3-3';
	};
	var fa_g3 = function fa_g3(match, outcome) {
	    return '3-4';
	};
	var fa_h3 = function fa_h3(match, outcome) {
	    return '3-5';
	};
	var fa_i3 = function fa_i3(match, outcome) {
	    return '4-0';
	};
	var fa_j3 = function fa_j3(match, outcome) {
	    return '4-1';
	};
	var fa_k3 = function fa_k3(match, outcome) {
	    return '4-2';
	};
	var fa_l3 = function fa_l3(match, outcome) {
	    return '4-3';
	};
	var fa_m3 = function fa_m3(match, outcome) {
	    return '4-4';
	};
	var fa_n3 = function fa_n3(match, outcome) {
	    return '5-0';
	};
	var fa_o3 = function fa_o3(match, outcome) {
	    return '5-1';
	};
	var fa_p3 = function fa_p3(match, outcome) {
	    return '5-2';
	};
	var fa_q3 = function fa_q3(match, outcome) {
	    return '5-3';
	};
	var fa_r3 = function fa_r3(match, outcome) {
	    return 'Any Other';
	};
	var fa_s3 = function fa_s3(match, outcome) {
	    return "\u2264 " + outcome.condition;
	};
	var fa_t3 = function fa_t3(match, outcome) {
	    return outcome.condition + 1 + " - " + (outcome.condition + 2);
	};
	var fa_u3 = function fa_u3(match, outcome) {
	    return outcome.condition + 3 + " - " + (outcome.condition + 4);
	};
	var fa_v3 = function fa_v3(match, outcome) {
	    return outcome.condition + 5 + " - " + (outcome.condition + 6);
	};
	var fa_w3 = function fa_w3(match, outcome) {
	    return outcome.condition + 7 + " - " + (outcome.condition + 8);
	};
	var fa_x3 = function fa_x3(match, outcome) {
	    return "\u2265 " + (outcome.condition + 9);
	};
	var fa_y3 = function fa_y3(match, outcome) {
	    return '6-9';
	};
	var fa_z3 = function fa_z3(match, outcome) {
	    return '10-12';
	};
	var fa_a4 = function fa_a4(match, outcome) {
	    return '13-16';
	};
	var fa_b4 = function fa_b4(match, outcome) {
	    return '17-20';
	};
	var fa_c4 = function fa_c4(match, outcome) {
	    return '21+';
	};
	var fa_d4 = function fa_d4(match, outcome) {
	    return '1st Half';
	};
	var fa_e4 = function fa_e4(match, outcome) {
	    return '2nd Half';
	};
	var fa_f4 = function fa_f4(match, outcome) {
	    return '1st Quarter';
	};
	var fa_g4 = function fa_g4(match, outcome) {
	    return '2nd Quarter';
	};
	var fa_h4 = function fa_h4(match, outcome) {
	    return '3rd Quarter';
	};
	var fa_i4 = function fa_i4(match, outcome) {
	    return '4th Quarter';
	};
	var fa_j4 = function fa_j4(match, outcome) {
	    return 'W1: 1-2';
	};
	var fa_k4 = function fa_k4(match, outcome) {
	    return 'W1: 3-5';
	};
	var fa_l4 = function fa_l4(match, outcome) {
	    return 'W1: 6-9';
	};
	var fa_m4 = function fa_m4(match, outcome) {
	    return 'W1: 10-12';
	};
	var fa_n4 = function fa_n4(match, outcome) {
	    return 'W1: 13-16';
	};
	var fa_o4 = function fa_o4(match, outcome) {
	    return 'W1: 17-20';
	};
	var fa_p4 = function fa_p4(match, outcome) {
	    return 'W1: 21+';
	};
	var fa_q4 = function fa_q4(match, outcome) {
	    return 'W2: 1-2';
	};
	var fa_r4 = function fa_r4(match, outcome) {
	    return 'W2: 3-5';
	};
	var fa_s4 = function fa_s4(match, outcome) {
	    return 'W2: 6-9';
	};
	var fa_t4 = function fa_t4(match, outcome) {
	    return 'W2: 10-12';
	};
	var fa_u4 = function fa_u4(match, outcome) {
	    return 'W2: 13-16';
	};
	var fa_v4 = function fa_v4(match, outcome) {
	    return 'W2: 17-20';
	};
	var fa_w4 = function fa_w4(match, outcome) {
	    return 'W2: 21+';
	};
	var fa_x4 = function fa_x4(match, outcome) {
	    return 'W1: 3-4';
	};
	var fa_y4 = function fa_y4(match, outcome) {
	    return 'W1: 5-7';
	};
	var fa_z4 = function fa_z4(match, outcome) {
	    return 'W1: 8+';
	};
	var fa_a5 = function fa_a5(match, outcome) {
	    return 'Х2';
	};
	var fa_b5 = function fa_b5(match, outcome) {
	    return 'W2: 3-4';
	};
	var fa_c5 = function fa_c5(match, outcome) {
	    return 'W2: 5-7';
	};
	var fa_d5 = function fa_d5(match, outcome) {
	    return 'W2: 8+';
	};
	var fa_e5 = function fa_e5(match, outcome) {
	    return 'Х1';
	};
	var fa_f5 = function fa_f5(match, outcome) {
	    return 'Free Throw';
	};
	var fa_g5 = function fa_g5(match, outcome) {
	    return '3-Pointer';
	};
	var fa_h5 = function fa_h5(match, outcome) {
	    return '2-Pointer';
	};
	var fa_i5 = function fa_i5(match, outcome) {
	    return "W1 \u2265 " + outcome.condition;
	};
	var fa_j5 = function fa_j5(match, outcome) {
	    return "Margin under " + outcome.condition;
	};
	var fa_k5 = function fa_k5(match, outcome) {
	    return "W2 \u2265 " + outcome.condition;
	};
	var fa_l5 = function fa_l5(match, outcome) {
	    return 'Neither';
	};
	var fa_m5 = function fa_m5(match, outcome) {
	    return 'W1: 1';
	};
	var fa_n5 = function fa_n5(match, outcome) {
	    return 'W1: 2';
	};
	var fa_o5 = function fa_o5(match, outcome) {
	    return 'W1: 3';
	};
	var fa_p5 = function fa_p5(match, outcome) {
	    return 'W1: 4';
	};
	var fa_q5 = function fa_q5(match, outcome) {
	    return 'W1: 5+';
	};
	var fa_r5 = function fa_r5(match, outcome) {
	    return 'W2: 1';
	};
	var fa_s5 = function fa_s5(match, outcome) {
	    return 'W2: 2';
	};
	var fa_t5 = function fa_t5(match, outcome) {
	    return 'W2: 3';
	};
	var fa_u5 = function fa_u5(match, outcome) {
	    return 'W2: 4';
	};
	var fa_v5 = function fa_v5(match, outcome) {
	    return 'W2: 5+';
	};
	var fa_w5 = function fa_w5(match, outcome) {
	    return '1Х';
	};
	var fa_x5 = function fa_x5(match, outcome) {
	    return '0 or 1';
	};
	var fa_y5 = function fa_y5(match, outcome) {
	    return '5';
	};
	var fa_z5 = function fa_z5(match, outcome) {
	    return '6';
	};
	var fa_a6 = function fa_a6(match, outcome) {
	    return '7';
	};
	var fa_b6 = function fa_b6(match, outcome) {
	    return '8+';
	};
	var fa_c6 = function fa_c6(match, outcome) {
	    return 'W1&W1';
	};
	var fa_d6 = function fa_d6(match, outcome) {
	    return 'W1&X';
	};
	var fa_e6 = function fa_e6(match, outcome) {
	    return 'W1&W2';
	};
	var fa_f6 = function fa_f6(match, outcome) {
	    return 'X&W1';
	};
	var fa_g6 = function fa_g6(match, outcome) {
	    return 'X&X';
	};
	var fa_h6 = function fa_h6(match, outcome) {
	    return 'X&W2';
	};
	var fa_i6 = function fa_i6(match, outcome) {
	    return 'W2&W1';
	};
	var fa_j6 = function fa_j6(match, outcome) {
	    return 'W2&X';
	};
	var fa_k6 = function fa_k6(match, outcome) {
	    return 'W2&W2';
	};
	var fa_l6 = function fa_l6(match, outcome) {
	    return "" + (outcome.condition + 1);
	};
	var fa_m6 = function fa_m6(match, outcome) {
	    return "" + (outcome.condition + 2);
	};
	var fa_n6 = function fa_n6(match, outcome) {
	    return "" + (outcome.condition + 3);
	};
	var fa_o6 = function fa_o6(match, outcome) {
	    return "" + (outcome.condition + 4);
	};
	var fa_p6 = function fa_p6(match, outcome) {
	    return "" + (outcome.condition + 5);
	};
	var fa_q6 = function fa_q6(match, outcome) {
	    return "" + (outcome.condition + 6);
	};
	var fa_r6 = function fa_r6(match, outcome) {
	    return "\u2265 " + (outcome.condition + 7);
	};
	var fa_s6 = function fa_s6(match, outcome) {
	    return '4-6';
	};
	var fa_t6 = function fa_t6(match, outcome) {
	    return '7+';
	};
	var fa_u6 = function fa_u6(match, outcome) {
	    return '7 And More';
	};
	var fa_v6 = function fa_v6(match, outcome) {
	    return '7 and more';
	};
	var fa_w6 = function fa_w6(match, outcome) {
	    return 'W1&U';
	};
	var fa_x6 = function fa_x6(match, outcome) {
	    return 'W1&O';
	};
	var fa_y6 = function fa_y6(match, outcome) {
	    return 'W2&U';
	};
	var fa_z6 = function fa_z6(match, outcome) {
	    return 'W2&O';
	};
	var fa_a7 = function fa_a7(match, outcome) {
	    return 'W1: 2-3';
	};
	var fa_b7 = function fa_b7(match, outcome) {
	    return 'W1: 4-6';
	};
	var fa_c7 = function fa_c7(match, outcome) {
	    return 'W1: ≥7';
	};
	var fa_d7 = function fa_d7(match, outcome) {
	    return 'W2: 2-3';
	};
	var fa_e7 = function fa_e7(match, outcome) {
	    return 'W2: 4-6';
	};
	var fa_f7 = function fa_f7(match, outcome) {
	    return 'W2: ≥7';
	};
	var fa_g7 = function fa_g7(match, outcome) {
	    return "" + outcome.condition;
	};
	var fa_h7 = function fa_h7(match, outcome) {
	    return "\u2265 " + (outcome.condition + 6);
	};
	var fa_i7 = function fa_i7(match, outcome) {
	    return 'W1: To Win Inside Distance';
	};
	var fa_j7 = function fa_j7(match, outcome) {
	    return 'W1: Point Victory';
	};
	var fa_k7 = function fa_k7(match, outcome) {
	    return 'Draw';
	};
	var fa_l7 = function fa_l7(match, outcome) {
	    return 'W2: To Win Inside Distance';
	};
	var fa_m7 = function fa_m7(match, outcome) {
	    return 'W2: Point Victory';
	};
	var fa_n7 = function fa_n7(match, outcome) {
	    return 'W1: 1 round';
	};
	var fa_o7 = function fa_o7(match, outcome) {
	    return 'W1: 2 round';
	};
	var fa_p7 = function fa_p7(match, outcome) {
	    return 'W1: 3 round';
	};
	var fa_q7 = function fa_q7(match, outcome) {
	    return 'W1: 4 round';
	};
	var fa_r7 = function fa_r7(match, outcome) {
	    return 'W1: 5 round';
	};
	var fa_s7 = function fa_s7(match, outcome) {
	    return 'W1: 6 round';
	};
	var fa_t7 = function fa_t7(match, outcome) {
	    return 'W1: 7 round';
	};
	var fa_u7 = function fa_u7(match, outcome) {
	    return 'W1: 8 round';
	};
	var fa_v7 = function fa_v7(match, outcome) {
	    return 'W1: 9 round';
	};
	var fa_w7 = function fa_w7(match, outcome) {
	    return 'W1: 10 round';
	};
	var fa_x7 = function fa_x7(match, outcome) {
	    return 'W1: 11 round';
	};
	var fa_y7 = function fa_y7(match, outcome) {
	    return 'W1: 12 round';
	};
	var fa_z7 = function fa_z7(match, outcome) {
	    return 'W2: 1 round';
	};
	var fa_a8 = function fa_a8(match, outcome) {
	    return 'W2: 2 round';
	};
	var fa_b8 = function fa_b8(match, outcome) {
	    return 'W2: 3 round';
	};
	var fa_c8 = function fa_c8(match, outcome) {
	    return 'W2: 4 round';
	};
	var fa_d8 = function fa_d8(match, outcome) {
	    return 'W2: 5 round';
	};
	var fa_e8 = function fa_e8(match, outcome) {
	    return 'W2: 6 round';
	};
	var fa_f8 = function fa_f8(match, outcome) {
	    return 'W2: 7 round';
	};
	var fa_g8 = function fa_g8(match, outcome) {
	    return 'W2: 8 round';
	};
	var fa_h8 = function fa_h8(match, outcome) {
	    return 'W2: 9 round';
	};
	var fa_i8 = function fa_i8(match, outcome) {
	    return 'W2: 10 round';
	};
	var fa_j8 = function fa_j8(match, outcome) {
	    return 'W2: 11 round';
	};
	var fa_k8 = function fa_k8(match, outcome) {
	    return 'W2: 12 round';
	};
	var fa_l8 = function fa_l8(match, outcome) {
	    return "HAN1(" + signed(outcome.condition) + ")";
	};
	var fa_m8 = function fa_m8(match, outcome) {
	    return "HAN2(" + signed(-outcome.condition) + ")";
	};
	var fa_n8 = function fa_n8(match, outcome) {
	    return '1st Higher';
	};
	var fa_o8 = function fa_o8(match, outcome) {
	    return '2nd Higher';
	};
	var fa_p8 = function fa_p8(match, outcome) {
	    return 'X';
	};
	var fa_q8 = function fa_q8(match, outcome) {
	    return 'One Only';
	};
	var fa_r8 = function fa_r8(match, outcome) {
	    return 'Both Teams';
	};
	var fa_s8 = function fa_s8(match, outcome) {
	    return 'Only One';
	};
	var fa_t8 = function fa_t8(match, outcome) {
	    return 'Header';
	};
	var fa_u8 = function fa_u8(match, outcome) {
	    return 'Shot';
	};
	var fa_v8 = function fa_v8(match, outcome) {
	    return 'Own Goal';
	};
	var fa_w8 = function fa_w8(match, outcome) {
	    return 'Penalty';
	};
	var fa_x8 = function fa_x8(match, outcome) {
	    return "Next Round: " + match.homeTeam;
	};
	var fa_y8 = function fa_y8(match, outcome) {
	    return "Next Round: " + match.awayTeam;
	};
	var fa_z8 = function fa_z8(match, outcome) {
	    return 'No Yellow Cards';
	};
	var fa_a9 = function fa_a9(match, outcome) {
	    return 'Corner';
	};
	var fa_b9 = function fa_b9(match, outcome) {
	    return 'Offside';
	};
	var fa_c9 = function fa_c9(match, outcome) {
	    return 'Yellow Card';
	};
	var fa_d9 = function fa_d9(match, outcome) {
	    return 'Goal';
	};
	var fa_e9 = function fa_e9(match, outcome) {
	    return "Before " + outcome.condition;
	};
	var fa_f9 = function fa_f9(match, outcome) {
	    return "After " + outcome.condition;
	};
	var fa_g9 = function fa_g9(match, outcome) {
	    return 'First Half';
	};
	var fa_h9 = function fa_h9(match, outcome) {
	    return 'Second Half';
	};
	var fa_i9 = function fa_i9(match, outcome) {
	    return 'In The First Half';
	};
	var fa_j9 = function fa_j9(match, outcome) {
	    return 'In The Second Half';
	};
	var fa_k9 = function fa_k9(match, outcome) {
	    return 'Not To Score';
	};
	var fa_l9 = function fa_l9(match, outcome) {
	    return 'No One';
	};
	var fa_m9 = function fa_m9(match, outcome) {
	    return '1&1';
	};
	var fa_n9 = function fa_n9(match, outcome) {
	    return '1&X';
	};
	var fa_o9 = function fa_o9(match, outcome) {
	    return '1&2';
	};
	var fa_p9 = function fa_p9(match, outcome) {
	    return 'X&1';
	};
	var fa_q9 = function fa_q9(match, outcome) {
	    return 'X&2';
	};
	var fa_r9 = function fa_r9(match, outcome) {
	    return '2&1';
	};
	var fa_s9 = function fa_s9(match, outcome) {
	    return '2&X';
	};
	var fa_t9 = function fa_t9(match, outcome) {
	    return '2&2';
	};
	var fa_u9 = function fa_u9(match, outcome) {
	    return '0-6';
	};
	var fa_v9 = function fa_v9(match, outcome) {
	    return '1-6';
	};
	var fa_w9 = function fa_w9(match, outcome) {
	    return '6-0';
	};
	var fa_x9 = function fa_x9(match, outcome) {
	    return '6-1';
	};
	var fa_y9 = function fa_y9(match, outcome) {
	    return 'Draw by Goals';
	};
	var fa_z9 = function fa_z9(match, outcome) {
	    return 'Scoreless Draw';
	};
	var fa_a10 = function fa_a10(match, outcome) {
	    return 'No Draw';
	};
	var fa_b10 = function fa_b10(match, outcome) {
	    return 'No Goal';
	};
	var fa_c10 = function fa_c10(match, outcome) {
	    return 'Tie';
	};
	var fa_d10 = function fa_d10(match, outcome) {
	    return 'Yes&Yes';
	};
	var fa_e10 = function fa_e10(match, outcome) {
	    return 'Yes&No';
	};
	var fa_f10 = function fa_f10(match, outcome) {
	    return 'No&Yes';
	};
	var fa_g10 = function fa_g10(match, outcome) {
	    return 'No&No';
	};
	var fa_h10 = function fa_h10(match, outcome) {
	    return 'Over&Yes';
	};
	var fa_i10 = function fa_i10(match, outcome) {
	    return 'Over&No';
	};
	var fa_j10 = function fa_j10(match, outcome) {
	    return 'Under&Yes';
	};
	var fa_k10 = function fa_k10(match, outcome) {
	    return 'Under&No';
	};
	var fa_l10 = function fa_l10(match, outcome) {
	    return 'W1 in Full Time';
	};
	var fa_m10 = function fa_m10(match, outcome) {
	    return 'W2 in Full Time';
	};
	var fa_n10 = function fa_n10(match, outcome) {
	    return 'W1 in Extra Time';
	};
	var fa_o10 = function fa_o10(match, outcome) {
	    return 'W2 in Extra Time';
	};
	var fa_p10 = function fa_p10(match, outcome) {
	    return 'W1 by Shootouts';
	};
	var fa_q10 = function fa_q10(match, outcome) {
	    return 'W2 by Shootouts';
	};
	var fa_r10 = function fa_r10(match, outcome) {
	    return 'Half Time';
	};
	var fa_s10 = function fa_s10(match, outcome) {
	    return 'Any other';
	};
	var fa_t10 = function fa_t10(match, outcome) {
	    return 'П1';
	};
	var fa_u10 = function fa_u10(match, outcome) {
	    return 'П2';
	};
	var fa_v10 = function fa_v10(match, outcome) {
	    return '5-4';
	};
	var fa_w10 = function fa_w10(match, outcome) {
	    return 'W1 with any other';
	};
	var fa_x10 = function fa_x10(match, outcome) {
	    return '4-5';
	};
	var fa_y10 = function fa_y10(match, outcome) {
	    return 'W2 with any other';
	};
	var fa_z10 = function fa_z10(match, outcome) {
	    return '1-10';
	};
	var fa_a11 = function fa_a11(match, outcome) {
	    return '11-20';
	};
	var fa_b11 = function fa_b11(match, outcome) {
	    return '21-30';
	};
	var fa_c11 = function fa_c11(match, outcome) {
	    return '31-40';
	};
	var fa_d11 = function fa_d11(match, outcome) {
	    return '41-50';
	};
	var fa_e11 = function fa_e11(match, outcome) {
	    return '51-60';
	};
	var fa_f11 = function fa_f11(match, outcome) {
	    return '61-70';
	};
	var fa_g11 = function fa_g11(match, outcome) {
	    return '71-80';
	};
	var fa_h11 = function fa_h11(match, outcome) {
	    return '81-FT';
	};
	var fa_i11 = function fa_i11(match, outcome) {
	    return '5 And More';
	};
	var fa_j11 = function fa_j11(match, outcome) {
	    return 'No One To Score';
	};
	var fa_k11 = function fa_k11(match, outcome) {
	    return 'Each Team';
	};
	var fa_l11 = function fa_l11(match, outcome) {
	    return 'V1';
	};
	var fa_m11 = function fa_m11(match, outcome) {
	    return 'V2';
	};
	var fa_n11 = function fa_n11(match, outcome) {
	    return 'To Score';
	};
	var fa_o11 = function fa_o11(match, outcome) {
	    return 'First Under';
	};
	var fa_p11 = function fa_p11(match, outcome) {
	    return 'Equal';
	};
	var fa_q11 = function fa_q11(match, outcome) {
	    return 'First Over';
	};
	var fa_r11 = function fa_r11(match, outcome) {
	    return 'V1: 1-2';
	};
	var fa_s11 = function fa_s11(match, outcome) {
	    return 'V1: 3-4';
	};
	var fa_t11 = function fa_t11(match, outcome) {
	    return 'V1: 5-7';
	};
	var fa_u11 = function fa_u11(match, outcome) {
	    return 'V1: 8 and more';
	};
	var fa_v11 = function fa_v11(match, outcome) {
	    return 'X2';
	};
	var fa_w11 = function fa_w11(match, outcome) {
	    return 'X1';
	};
	var fa_x11 = function fa_x11(match, outcome) {
	    return 'no one';
	};
	var fa_y11 = function fa_y11(match, outcome) {
	    return 'One not to score';
	};
	var fa_z11 = function fa_z11(match, outcome) {
	    return '5+';
	};
	var fa_a12 = function fa_a12(match, outcome) {
	    return '1<2';
	};
	var fa_b12 = function fa_b12(match, outcome) {
	    return '1=2';
	};
	var fa_c12 = function fa_c12(match, outcome) {
	    return '1>2';
	};
	var fa_d12 = function fa_d12(match, outcome) {
	    return '1<3';
	};
	var fa_e12 = function fa_e12(match, outcome) {
	    return '1=3';
	};
	var fa_f12 = function fa_f12(match, outcome) {
	    return '1>3';
	};
	var fa_g12 = function fa_g12(match, outcome) {
	    return '2<3';
	};
	var fa_h12 = function fa_h12(match, outcome) {
	    return '2=3';
	};
	var fa_i12 = function fa_i12(match, outcome) {
	    return '2>3';
	};
	var fa_j12 = function fa_j12(match, outcome) {
	    return 'yes';
	};
	var fa_k12 = function fa_k12(match, outcome) {
	    return 'no';
	};
	var fa_l12 = function fa_l12(match, outcome) {
	    return 'Yellow Ball';
	};
	var fa_m12 = function fa_m12(match, outcome) {
	    return 'Green Ball';
	};
	var fa_n12 = function fa_n12(match, outcome) {
	    return 'Brown Ball';
	};
	var fa_o12 = function fa_o12(match, outcome) {
	    return 'Blue Ball';
	};
	var fa_p12 = function fa_p12(match, outcome) {
	    return 'Pink Ball';
	};
	var fa_q12 = function fa_q12(match, outcome) {
	    return 'Black Ball';
	};
	var fa_r12 = function fa_r12(match, outcome) {
	    return "\u2265 " + (outcome.condition + 5);
	};
	var fa_s12 = function fa_s12(match, outcome) {
	    return '≤ 14';
	};
	var fa_t12 = function fa_t12(match, outcome) {
	    return ' 15 - 17';
	};
	var fa_u12 = function fa_u12(match, outcome) {
	    return ' 18 - 19';
	};
	var fa_v12 = function fa_v12(match, outcome) {
	    return '≥ 20';
	};
	var fa_w12 = function fa_w12(match, outcome) {
	    return 'W1-Love';
	};
	var fa_x12 = function fa_x12(match, outcome) {
	    return 'W1-15';
	};
	var fa_y12 = function fa_y12(match, outcome) {
	    return 'W1-30';
	};
	var fa_z12 = function fa_z12(match, outcome) {
	    return 'W1-40';
	};
	var fa_a13 = function fa_a13(match, outcome) {
	    return 'Love-W2';
	};
	var fa_b13 = function fa_b13(match, outcome) {
	    return '15-W2';
	};
	var fa_c13 = function fa_c13(match, outcome) {
	    return '30-W2';
	};
	var fa_d13 = function fa_d13(match, outcome) {
	    return '40-W2';
	};
	var fa_e13 = function fa_e13(match, outcome) {
	    return '3-6';
	};
	var fa_f13 = function fa_f13(match, outcome) {
	    return '5-7';
	};
	var fa_g13 = function fa_g13(match, outcome) {
	    return '6-2';
	};
	var fa_h13 = function fa_h13(match, outcome) {
	    return '6-3';
	};
	var fa_i13 = function fa_i13(match, outcome) {
	    return '6-4';
	};
	var fa_j13 = function fa_j13(match, outcome) {
	    return '6-7';
	};
	var fa_k13 = function fa_k13(match, outcome) {
	    return '7-5';
	};
	var fa_l13 = function fa_l13(match, outcome) {
	    return '7-6';
	};
	var fa_m13 = function fa_m13(match, outcome) {
	    return '7-0';
	};
	var fa_n13 = function fa_n13(match, outcome) {
	    return '7-1';
	};
	var fa_o13 = function fa_o13(match, outcome) {
	    return '7-2';
	};
	var fa_p13 = function fa_p13(match, outcome) {
	    return '7-3';
	};
	var fa_q13 = function fa_q13(match, outcome) {
	    return '7-4';
	};
	var fa_r13 = function fa_r13(match, outcome) {
	    return 'W1 Any Other';
	};
	var fa_s13 = function fa_s13(match, outcome) {
	    return '0-7';
	};
	var fa_t13 = function fa_t13(match, outcome) {
	    return '1-7';
	};
	var fa_u13 = function fa_u13(match, outcome) {
	    return '2-7';
	};
	var fa_v13 = function fa_v13(match, outcome) {
	    return '3-7';
	};
	var fa_w13 = function fa_w13(match, outcome) {
	    return '4-7';
	};
	var fa_x13 = function fa_x13(match, outcome) {
	    return 'W2 Any Other';
	};
	var fa_y13 = function fa_y13(match, outcome) {
	    return '8';
	};
	var fa_z13 = function fa_z13(match, outcome) {
	    return '9';
	};
	var fa_a14 = function fa_a14(match, outcome) {
	    return '10';
	};
	var fa_b14 = function fa_b14(match, outcome) {
	    return '11';
	};
	var fa_c14 = function fa_c14(match, outcome) {
	    return '≥ 13';
	};
	var fa_d14 = function fa_d14(match, outcome) {
	    return match.homeTeam + " (Svr)";
	};
	var fa_e14 = function fa_e14(match, outcome) {
	    return match.awayTeam + " (Svr)";
	};
	var fa_f14 = function fa_f14(match, outcome) {
	    return 'W1-0';
	};
	var fa_g14 = function fa_g14(match, outcome) {
	    return '0-W2';
	};
	var fa_h14 = function fa_h14(match, outcome) {
	    return 'Second';
	};
	var fa_i14 = function fa_i14(match, outcome) {
	    return 'First';
	};
	var fa_j14 = function fa_j14(match, outcome) {
	    return 'Да';
	};
	var fa_k14 = function fa_k14(match, outcome) {
	    return 'Нет';
	};
	var fa_l14 = function fa_l14(match, outcome) {
	    return 'Both W1';
	};
	var fa_m14 = function fa_m14(match, outcome) {
	    return 'Both W2';
	};
	var fa_n14 = function fa_n14(match, outcome) {
	    return 'Han1';
	};
	var fa_o14 = function fa_o14(match, outcome) {
	    return 'Han2';
	};
	var fa_p14 = function fa_p14(match, outcome) {
	    return 'W1: 7+';
	};
	var fa_q14 = function fa_q14(match, outcome) {
	    return 'W2: 7+';
	};
	var fa_r14 = function fa_r14(match, outcome) {
	    return '6-5';
	};
	var fa_s14 = function fa_s14(match, outcome) {
	    return '5-6';
	};
	
	var groupConfig = {
	    32: {
	        0: 'Матч',
	        1: 'First Set',
	        2: 'Second Set',
	        3: 'ThirdSet',
	        4: 'Miniset to 10 Points (First Set)',
	        5: 'Miniset to 15 Points (First Set)',
	        6: 'Miniset to 10 Points (Second Set)',
	        7: 'Miniset to 15 Points (Second Set)',
	        8: 'Miniset to 10 Points (Third Set)',
	        9: 'Miniset to 15 Points (Third Set)'
	    },
	    35: {
	        0: 'Матч',
	        1: 'Первый период'
	    },
	    31: {
	        0: 'Матч',
	        1: 'First Quarter',
	        2: 'Second Quarter',
	        3: 'Third Quarter',
	        4: 'Fourth Quarter',
	        5: '2-Pointers',
	        6: '3-Pointers',
	        7: 'First Half',
	        8: 'Second Half'
	    },
	    41: {
	        0: 'Матч',
	        1: 'First Half',
	        2: 'Second Half',
	        3: '2-Pointers',
	        4: '3-Pointers'
	    },
	    18: {
	        0: 'Матч',
	        1: 'Первый период',
	        2: 'Второй период',
	        3: 'Третий период'
	    },
	    3: {
	        0: 'Матч',
	        1: 'First Set',
	        2: 'Second Set',
	        3: 'Third Set',
	        4: 'Miniset to 10 Points (First Period)',
	        5: 'Miniset to 15 Points (First Period)',
	        6: 'Miniset to 10 Points (Second Period)',
	        7: 'Miniset to 15 Points (Second Period)'
	    },
	    20: {
	        0: 'Матч',
	        1: 'Первый огневой рубеж',
	        2: 'Второй огневой рубеж',
	        3: 'Третий огневой рубеж',
	        4: 'Четвертый огневой рубеж',
	        5: 'Пятый огневой рубеж',
	        6: 'Шестой огневой рубеж',
	        7: 'Седьмой огневой рубеж',
	        8: 'Восьмой огневой рубеж'
	    },
	    42: {
	        0: 'Match',
	        1: 'First map',
	        2: 'Second map',
	        3: 'Third map',
	        4: 'Fourth map',
	        5: 'Fifth map'
	    },
	    36: {
	        0: 'Матч',
	        1: 'Первый период'
	    },
	    7: {
	        0: 'Матч',
	        1: 'First Half',
	        2: 'Second Half',
	        3: '1-15th Mins',
	        4: '16-30th Mins',
	        5: '31st Min - Half Time',
	        6: '46-60th Mins',
	        7: '60-75th Mins',
	        8: '76th Min - Full Time',
	        9: 'Corners',
	        10: 'Corners (First Half)',
	        11: 'Yellow Cards',
	        12: 'Yellow Cards (First Half)',
	        13: 'Overtime',
	        14: 'First Overtime',
	        15: 'Second Overtime',
	        16: 'Серия пенальти'
	    },
	    34: {
	        0: 'Матч',
	        1: 'First Time',
	        2: 'Second Time',
	        3: '1-15th Mins',
	        4: '16-30th Mins',
	        5: '31st Min - Half Time',
	        6: '46-60th Mins',
	        7: '60-75th Mins',
	        8: '76th Min - Full Time',
	        9: 'Corners',
	        10: 'Yellow Cards'
	    },
	    19: {
	        0: 'Матч',
	        1: 'Первый период',
	        2: 'Второй период'
	    },
	    30: {
	        0: 'Матч',
	        1: 'First Period',
	        2: 'Second Period',
	        3: 'Third Period',
	        4: '1-10 Minutes',
	        5: '11-20 Minutes',
	        6: '21-30 Minutes',
	        7: '31-40 Minutes',
	        8: '41-50 Minutes',
	        9: '51-60 Minutes'
	    },
	    9: {
	        0: 'Матч',
	        1: 'Первый период',
	        2: 'Второй период'
	    },
	    29: {
	        0: 'Матч',
	        1: 'Первый период',
	        2: 'Второй период',
	        3: 'Третий период',
	        4: 'Четвертый период',
	        5: 'Пятый период',
	        6: 'Шестой период',
	        7: 'Седьмой период',
	        8: 'Восьмой период',
	        9: 'Девятый период',
	        10: 'Десятый период',
	        11: 'Одинадцатый период',
	        12: 'Двенадцатый период',
	        13: 'Тринадцатый период',
	        14: 'Четырнадцатый период',
	        15: 'Пятнадцатый период',
	        16: 'Шестнадцатый период',
	        17: 'Семнадцатый период',
	        18: 'Восемнадцатый период',
	        19: 'Девятнадцатый период',
	        20: 'Двадцатый период',
	        21: 'Двадцать первый период',
	        22: 'Двадцать второй период',
	        23: 'Двадцать третий период',
	        24: 'Двадцать четвертый период',
	        25: 'Двадцать пятый период',
	        26: 'Двадцать шестой период',
	        27: 'Двадцать седьмой период',
	        28: 'Двадцать восьмой период',
	        29: 'Двадцать девятый период',
	        30: 'Тридцатый период',
	        31: 'Тридцать первый период',
	        32: 'Тридцать второй период',
	        33: 'Тридцать третий период',
	        34: 'Тридцать четвертый период',
	        35: 'Тридцать пятый период',
	        36: 'Тридцать шестой период',
	        37: 'Тридцать седьмой период'
	    },
	    2: {
	        0: 'Матч',
	        1: 'First Set',
	        2: 'Second Set',
	        3: 'Third Set',
	        4: 'Fourth Set',
	        5: 'Fifth Set',
	        6: 'Sixth Set',
	        7: 'Seventh Set'
	    },
	    6: {
	        0: 'Матч',
	        1: 'First Set',
	        2: 'Second Set',
	        3: 'Third Set',
	        4: 'Fourth Set',
	        5: 'Fifth Set'
	    },
	    4: {
	        0: 'Матч',
	        1: 'First Set',
	        2: 'Second Set',
	        3: 'Third Set',
	        4: 'Fourth Set',
	        5: 'Fifth Set',
	        6: 'Golden Set',
	        7: 'Miniset to 10 Points (First Set)',
	        8: 'Miniset to 15 Points (First Set)',
	        9: 'Miniset to 10 Points (Second Set)',
	        10: 'Miniset to 15 Points (Second Set)',
	        11: 'Miniset to 10 Points (Third Set)',
	        12: 'Miniset to 15 Points (Third Set)',
	        13: 'Miniset to 10 Points (Fourth Set)',
	        14: 'Miniset to 15 Points (Fourth Set)'
	    },
	    8: {
	        0: 'Матч',
	        1: 'First Quarter',
	        2: 'Second Quarter',
	        3: 'Third Quarter',
	        4: 'Fourth Quarter'
	    }
	};
	
	var slotConfig = {
	    32: {
	        366: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        557: sl_e1,
	        607: sl_f1,
	        122: sl_g1,
	        129: sl_h1,
	        138: sl_i1,
	        182: sl_j1,
	        367: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        558: sl_e1,
	        608: sl_f1,
	        123: sl_g1,
	        130: sl_h1,
	        139: sl_i1,
	        183: sl_j1,
	        368: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        559: sl_e1,
	        609: sl_f1,
	        124: sl_g1,
	        131: sl_h1,
	        140: sl_i1,
	        184: sl_j1,
	        362: sl_b1,
	        17: sl_c1,
	        176: sl_d1,
	        358: sl_b1,
	        13: sl_c1,
	        172: sl_d1,
	        363: sl_b1,
	        18: sl_c1,
	        177: sl_d1,
	        359: sl_b1,
	        14: sl_c1,
	        173: sl_d1,
	        364: sl_b1,
	        19: sl_c1,
	        178: sl_d1,
	        360: sl_b1,
	        15: sl_c1,
	        174: sl_d1
	    },
	    35: {
	        664: sl_k1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1
	    },
	    31: {
	        664: sl_l1,
	        21: sl_m1,
	        195: sl_n1,
	        769: sl_o1,
	        138: sl_i1,
	        182: sl_j1,
	        775: sl_p1,
	        765: sl_q1,
	        629: sl_r1,
	        633: sl_s1,
	        665: sl_l1,
	        22: sl_m1,
	        196: sl_n1,
	        770: sl_o1,
	        139: sl_i1,
	        183: sl_j1,
	        776: sl_p1,
	        766: sl_q1,
	        630: sl_r1,
	        634: sl_s1,
	        666: sl_l1,
	        23: sl_m1,
	        197: sl_n1,
	        771: sl_o1,
	        140: sl_i1,
	        184: sl_j1,
	        777: sl_p1,
	        767: sl_q1,
	        631: sl_r1,
	        635: sl_s1,
	        667: sl_l1,
	        24: sl_m1,
	        198: sl_n1,
	        772: sl_o1,
	        141: sl_i1,
	        185: sl_j1,
	        778: sl_p1,
	        768: sl_q1,
	        632: sl_r1,
	        636: sl_s1,
	        676: sl_k1,
	        248: sl_d1,
	        62: sl_c1,
	        241: sl_i1,
	        233: sl_j1,
	        406: sl_t1,
	        675: sl_k1,
	        246: sl_d1,
	        61: sl_c1,
	        240: sl_i1,
	        232: sl_j1,
	        405: sl_t1,
	        672: sl_k1,
	        58: sl_c1,
	        238: sl_d1,
	        234: sl_i1,
	        236: sl_j1,
	        673: sl_k1,
	        59: sl_c1,
	        239: sl_d1,
	        235: sl_i1,
	        237: sl_j1
	    },
	    41: {
	        664: sl_k1,
	        21: sl_c1,
	        195: sl_d1,
	        782: sl_u1,
	        785: sl_p1,
	        780: sl_q1,
	        138: sl_i1,
	        182: sl_j1,
	        639: sl_r1,
	        665: sl_k1,
	        22: sl_c1,
	        196: sl_d1,
	        783: sl_u1,
	        786: sl_p1,
	        781: sl_q1,
	        139: sl_i1,
	        183: sl_j1,
	        640: sl_r1,
	        64: sl_c1,
	        678: sl_k1,
	        250: sl_d1,
	        63: sl_c1,
	        677: sl_k1,
	        249: sl_d1
	    },
	    18: {
	        664: sl_k1,
	        195: sl_d1,
	        698: sl_v1,
	        21: sl_c1,
	        734: sl_w1,
	        665: sl_k1,
	        196: sl_d1,
	        699: sl_v1,
	        22: sl_c1,
	        735: sl_w1,
	        666: sl_k1,
	        197: sl_d1,
	        700: sl_v1,
	        23: sl_c1,
	        736: sl_w1
	    },
	    3: {
	        366: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        896: sl_x1,
	        138: sl_i1,
	        182: sl_j1,
	        557: sl_e1,
	        83: sl_y1,
	        788: sl_p1,
	        842: sl_q1,
	        845: sl_z1,
	        848: sl_a2,
	        607: sl_b2,
	        791: sl_s1,
	        367: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        897: sl_x1,
	        139: sl_i1,
	        183: sl_j1,
	        558: sl_e1,
	        84: sl_y1,
	        789: sl_p1,
	        843: sl_q1,
	        846: sl_z1,
	        849: sl_a2,
	        608: sl_b2,
	        792: sl_s1,
	        368: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        898: sl_x1,
	        140: sl_i1,
	        184: sl_j1,
	        559: sl_e1,
	        85: sl_y1,
	        790: sl_p1,
	        844: sl_q1,
	        847: sl_z1,
	        850: sl_a2,
	        609: sl_b2,
	        793: sl_s1,
	        362: sl_b1,
	        17: sl_c1,
	        176: sl_d1,
	        358: sl_b1,
	        13: sl_c1,
	        172: sl_d1,
	        363: sl_b1,
	        18: sl_c1,
	        177: sl_d1,
	        359: sl_b1,
	        14: sl_c1,
	        173: sl_d1
	    },
	    20: {
	        664: sl_k1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1,
	        851: sl_u1,
	        665: sl_k1,
	        22: sl_c1,
	        196: sl_d1,
	        139: sl_i1,
	        183: sl_j1,
	        852: sl_u1,
	        666: sl_k1,
	        23: sl_c1,
	        197: sl_d1,
	        140: sl_i1,
	        184: sl_j1,
	        853: sl_u1,
	        667: sl_k1,
	        24: sl_c1,
	        198: sl_d1,
	        141: sl_i1,
	        185: sl_j1,
	        854: sl_u1,
	        199: sl_k1,
	        142: sl_c1,
	        186: sl_d1,
	        25: sl_i1,
	        668: sl_j1,
	        855: sl_u1,
	        200: sl_k1,
	        143: sl_c1,
	        187: sl_d1,
	        26: sl_i1,
	        669: sl_j1,
	        856: sl_u1,
	        201: sl_k1,
	        144: sl_c1,
	        188: sl_d1,
	        27: sl_i1,
	        670: sl_j1,
	        857: sl_u1,
	        202: sl_k1,
	        145: sl_c1,
	        189: sl_d1,
	        28: sl_i1,
	        671: sl_j1,
	        858: sl_u1
	    },
	    42: {
	        557: sl_c2,
	        1865: sl_d2,
	        558: sl_c2,
	        1866: sl_d2,
	        559: sl_c2,
	        1867: sl_d2,
	        560: sl_c2,
	        1868: sl_d2,
	        561: sl_c2,
	        1869: sl_d2
	    },
	    36: {
	        664: sl_k1,
	        21: sl_c1,
	        195: sl_d1
	    },
	    7: {
	        426: sl_e2,
	        526: sl_f2,
	        419: sl_g2,
	        519: sl_h2,
	        664: sl_k1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1,
	        734: sl_w1,
	        756: sl_u1,
	        698: sl_i2,
	        794: sl_j2,
	        860: sl_k2,
	        273: sl_l2,
	        83: sl_m2,
	        727: sl_n2,
	        729: sl_o2,
	        731: sl_p2,
	        648: sl_q2,
	        420: sl_g2,
	        520: sl_h2,
	        665: sl_k1,
	        22: sl_c1,
	        196: sl_d1,
	        139: sl_i1,
	        183: sl_j1,
	        735: sl_w1,
	        757: sl_u1,
	        699: sl_i2,
	        859: sl_j2,
	        861: sl_k2,
	        274: sl_l2,
	        84: sl_m2,
	        728: sl_n2,
	        649: sl_r2,
	        652: sl_k1,
	        641: sl_q2,
	        2: sl_c1,
	        160: sl_d1,
	        148: sl_i1,
	        154: sl_j1,
	        655: sl_k1,
	        642: sl_q2,
	        5: sl_c1,
	        163: sl_d1,
	        149: sl_i1,
	        155: sl_j1,
	        657: sl_l1,
	        643: sl_s2,
	        7: sl_m1,
	        165: sl_n1,
	        150: sl_t2,
	        156: sl_u2,
	        658: sl_k1,
	        644: sl_q2,
	        930: sl_c1,
	        166: sl_d1,
	        151: sl_i1,
	        157: sl_j1,
	        660: sl_k1,
	        645: sl_q2,
	        9: sl_c1,
	        168: sl_d1,
	        152: sl_i1,
	        158: sl_j1,
	        663: sl_k1,
	        646: sl_q2,
	        12: sl_c1,
	        171: sl_d1,
	        153: sl_i1,
	        159: sl_j1,
	        680: sl_v2,
	        66: sl_w2,
	        255: sl_d1,
	        438: sl_x2,
	        354: sl_y2,
	        355: sl_z2,
	        681: sl_k1,
	        67: sl_c1,
	        258: sl_a3,
	        356: sl_y2,
	        357: sl_z2,
	        690: sl_k1,
	        81: sl_c1,
	        353: sl_d1,
	        440: sl_b3,
	        441: sl_c3,
	        682: sl_k1,
	        68: sl_c1,
	        259: sl_d1,
	        146: sl_y2,
	        650: sl_q2,
	        740: sl_d3,
	        69: sl_c1,
	        262: sl_d1,
	        683: sl_e3,
	        694: sl_f3,
	        180: sl_z2,
	        70: sl_c1,
	        263: sl_d1,
	        684: sl_k1,
	        72: sl_c1,
	        277: sl_d1,
	        686: sl_k1,
	        181: sl_g3,
	        147: sl_h3,
	        741: sl_w1,
	        276: sl_i3,
	        275: sl_j3
	    },
	    34: {
	        419: sl_g2,
	        519: sl_h2,
	        664: sl_k1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1,
	        734: sl_w1,
	        756: sl_u1,
	        698: sl_i2,
	        794: sl_j2,
	        860: sl_k2,
	        83: sl_y1,
	        420: sl_g2,
	        520: sl_h2,
	        665: sl_k1,
	        22: sl_c1,
	        196: sl_d1,
	        139: sl_i1,
	        183: sl_j1,
	        735: sl_w1,
	        757: sl_u1,
	        699: sl_i2,
	        795: sl_j2,
	        861: sl_k2,
	        84: sl_y1,
	        652: sl_k1,
	        2: sl_c1,
	        160: sl_d1,
	        148: sl_i1,
	        154: sl_j1,
	        655: sl_k1,
	        5: sl_c1,
	        163: sl_d1,
	        149: sl_i1,
	        155: sl_j1,
	        657: sl_k1,
	        7: sl_c1,
	        165: sl_d1,
	        150: sl_i1,
	        156: sl_j1,
	        658: sl_k1,
	        930: sl_c1,
	        166: sl_d1,
	        151: sl_i1,
	        157: sl_j1,
	        660: sl_k1,
	        9: sl_c1,
	        168: sl_d1,
	        152: sl_i1,
	        158: sl_j1,
	        663: sl_k1,
	        12: sl_c1,
	        171: sl_d1,
	        153: sl_i1,
	        159: sl_j1,
	        255: sl_d1,
	        353: sl_d1
	    },
	    19: {
	        664: sl_k1,
	        21: sl_c1,
	        195: sl_d1,
	        877: sl_u1,
	        138: sl_i1,
	        182: sl_j1,
	        875: sl_p1,
	        873: sl_q1,
	        196: sl_d1,
	        878: sl_u1,
	        876: sl_p1,
	        874: sl_q1,
	        665: sl_k1,
	        22: sl_c1
	    },
	    30: {
	        664: sl_k1,
	        21: sl_c1,
	        195: sl_d1,
	        756: sl_u1,
	        138: sl_i1,
	        182: sl_j1,
	        734: sl_w1,
	        83: sl_y1,
	        698: sl_k3,
	        665: sl_k1,
	        22: sl_c1,
	        196: sl_d1,
	        757: sl_u1,
	        139: sl_i1,
	        183: sl_j1,
	        735: sl_w1,
	        84: sl_y1,
	        699: sl_k3,
	        666: sl_k1,
	        23: sl_c1,
	        197: sl_d1,
	        758: sl_u1,
	        140: sl_i1,
	        184: sl_j1,
	        736: sl_w1,
	        85: sl_y1,
	        700: sl_k3,
	        653: sl_k1,
	        161: sl_d1,
	        3: sl_c1,
	        654: sl_k1,
	        162: sl_d1,
	        4: sl_c1,
	        656: sl_k1,
	        164: sl_d1,
	        6: sl_c1,
	        659: sl_k1,
	        167: sl_d1,
	        8: sl_c1,
	        661: sl_k1,
	        169: sl_d1,
	        10: sl_c1,
	        662: sl_k1,
	        170: sl_d1,
	        11: sl_c1
	    },
	    9: {
	        664: sl_k1,
	        195: sl_d1,
	        665: sl_k1,
	        196: sl_d1
	    },
	    29: {
	        366: sl_k1,
	        21: sl_c1,
	        195: sl_d1,
	        466: sl_l3,
	        557: sl_e1,
	        799: sl_m3,
	        83: sl_y1,
	        367: sl_k1,
	        22: sl_c1,
	        196: sl_d1,
	        467: sl_l3,
	        558: sl_e1,
	        800: sl_m3,
	        84: sl_y1,
	        368: sl_k1,
	        23: sl_c1,
	        197: sl_d1,
	        468: sl_l3,
	        559: sl_e1,
	        801: sl_m3,
	        85: sl_y1,
	        369: sl_k1,
	        24: sl_c1,
	        198: sl_d1,
	        469: sl_l3,
	        560: sl_e1,
	        802: sl_m3,
	        86: sl_y1,
	        370: sl_k1,
	        25: sl_c1,
	        199: sl_d1,
	        470: sl_l3,
	        561: sl_e1,
	        803: sl_m3,
	        87: sl_y1,
	        371: sl_k1,
	        26: sl_c1,
	        200: sl_d1,
	        471: sl_l3,
	        562: sl_e1,
	        804: sl_m3,
	        88: sl_y1,
	        372: sl_k1,
	        27: sl_c1,
	        201: sl_d1,
	        472: sl_l3,
	        563: sl_e1,
	        805: sl_m3,
	        89: sl_y1,
	        373: sl_k1,
	        28: sl_c1,
	        202: sl_d1,
	        473: sl_l3,
	        564: sl_e1,
	        806: sl_m3,
	        90: sl_y1,
	        374: sl_k1,
	        29: sl_c1,
	        203: sl_d1,
	        474: sl_l3,
	        565: sl_e1,
	        807: sl_m3,
	        91: sl_y1,
	        375: sl_k1,
	        30: sl_c1,
	        204: sl_d1,
	        475: sl_l3,
	        566: sl_e1,
	        808: sl_m3,
	        92: sl_y1,
	        376: sl_k1,
	        31: sl_c1,
	        205: sl_d1,
	        476: sl_l3,
	        567: sl_e1,
	        809: sl_m3,
	        93: sl_y1,
	        377: sl_k1,
	        32: sl_c1,
	        206: sl_d1,
	        477: sl_l3,
	        568: sl_e1,
	        810: sl_m3,
	        94: sl_y1,
	        378: sl_k1,
	        33: sl_c1,
	        207: sl_d1,
	        478: sl_l3,
	        569: sl_e1,
	        811: sl_m3,
	        95: sl_y1,
	        379: sl_k1,
	        34: sl_c1,
	        208: sl_d1,
	        479: sl_l3,
	        570: sl_e1,
	        812: sl_m3,
	        96: sl_y1,
	        380: sl_k1,
	        35: sl_c1,
	        209: sl_d1,
	        480: sl_l3,
	        571: sl_e1,
	        813: sl_m3,
	        97: sl_y1,
	        381: sl_k1,
	        36: sl_c1,
	        210: sl_d1,
	        481: sl_l3,
	        572: sl_e1,
	        814: sl_m3,
	        98: sl_y1,
	        382: sl_k1,
	        37: sl_c1,
	        211: sl_d1,
	        482: sl_l3,
	        573: sl_e1,
	        815: sl_m3,
	        99: sl_y1,
	        383: sl_k1,
	        38: sl_c1,
	        212: sl_d1,
	        483: sl_l3,
	        574: sl_e1,
	        816: sl_m3,
	        100: sl_y1,
	        384: sl_k1,
	        39: sl_c1,
	        213: sl_d1,
	        484: sl_l3,
	        575: sl_e1,
	        817: sl_m3,
	        101: sl_y1,
	        385: sl_k1,
	        40: sl_c1,
	        214: sl_d1,
	        485: sl_l3,
	        576: sl_e1,
	        818: sl_m3,
	        104: sl_y1,
	        386: sl_k1,
	        41: sl_c1,
	        215: sl_d1,
	        486: sl_l3,
	        577: sl_e1,
	        819: sl_m3,
	        105: sl_y1,
	        387: sl_k1,
	        42: sl_c1,
	        216: sl_d1,
	        487: sl_l3,
	        578: sl_e1,
	        820: sl_m3,
	        106: sl_y1,
	        388: sl_k1,
	        43: sl_c1,
	        217: sl_d1,
	        488: sl_l3,
	        579: sl_e1,
	        821: sl_m3,
	        107: sl_y1,
	        389: sl_k1,
	        44: sl_c1,
	        218: sl_d1,
	        489: sl_l3,
	        580: sl_e1,
	        822: sl_m3,
	        108: sl_y1,
	        390: sl_k1,
	        45: sl_c1,
	        219: sl_d1,
	        490: sl_l3,
	        581: sl_e1,
	        823: sl_m3,
	        109: sl_y1,
	        391: sl_k1,
	        46: sl_c1,
	        220: sl_d1,
	        491: sl_l3,
	        582: sl_e1,
	        824: sl_m3,
	        110: sl_y1,
	        392: sl_k1,
	        47: sl_c1,
	        221: sl_d1,
	        492: sl_l3,
	        583: sl_e1,
	        825: sl_m3,
	        111: sl_y1,
	        393: sl_k1,
	        48: sl_c1,
	        222: sl_d1,
	        493: sl_l3,
	        584: sl_e1,
	        826: sl_m3,
	        112: sl_y1,
	        394: sl_k1,
	        49: sl_c1,
	        223: sl_d1,
	        494: sl_l3,
	        585: sl_e1,
	        827: sl_m3,
	        113: sl_y1,
	        395: sl_k1,
	        50: sl_c1,
	        224: sl_d1,
	        495: sl_l3,
	        586: sl_e1,
	        828: sl_m3,
	        114: sl_y1,
	        396: sl_k1,
	        51: sl_c1,
	        225: sl_d1,
	        496: sl_l3,
	        587: sl_e1,
	        829: sl_m3,
	        115: sl_y1,
	        397: sl_k1,
	        52: sl_c1,
	        226: sl_d1,
	        497: sl_l3,
	        588: sl_e1,
	        830: sl_m3,
	        116: sl_y1,
	        398: sl_k1,
	        53: sl_c1,
	        227: sl_d1,
	        498: sl_l3,
	        589: sl_e1,
	        831: sl_m3,
	        117: sl_y1,
	        399: sl_k1,
	        54: sl_c1,
	        228: sl_d1,
	        499: sl_l3,
	        590: sl_e1,
	        832: sl_m3,
	        118: sl_y1,
	        400: sl_k1,
	        55: sl_c1,
	        229: sl_d1,
	        500: sl_l3,
	        591: sl_e1,
	        833: sl_m3,
	        119: sl_y1,
	        401: sl_k1,
	        56: sl_c1,
	        230: sl_d1,
	        501: sl_l3,
	        592: sl_e1,
	        834: sl_m3,
	        120: sl_y1,
	        402: sl_k1,
	        57: sl_c1,
	        231: sl_d1,
	        502: sl_l3,
	        593: sl_e1,
	        835: sl_m3,
	        121: sl_y1
	    },
	    2: {
	        366: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1,
	        607: sl_n3,
	        557: sl_e1,
	        863: sl_u1,
	        885: sl_u1,
	        122: sl_g1,
	        129: sl_h1,
	        83: sl_y1,
	        367: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        139: sl_i1,
	        183: sl_j1,
	        608: sl_n3,
	        558: sl_e1,
	        864: sl_u1,
	        886: sl_u1,
	        123: sl_g1,
	        130: sl_h1,
	        84: sl_y1,
	        368: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        140: sl_i1,
	        184: sl_j1,
	        609: sl_n3,
	        559: sl_e1,
	        865: sl_u1,
	        887: sl_u1,
	        124: sl_g1,
	        131: sl_h1,
	        85: sl_y1,
	        369: sl_b1,
	        24: sl_c1,
	        198: sl_d1,
	        141: sl_i1,
	        185: sl_j1,
	        610: sl_n3,
	        560: sl_e1,
	        866: sl_u1,
	        888: sl_u1,
	        125: sl_g1,
	        132: sl_h1,
	        86: sl_y1,
	        370: sl_b1,
	        25: sl_c1,
	        199: sl_d1,
	        142: sl_i1,
	        186: sl_j1,
	        611: sl_n3,
	        561: sl_e1,
	        867: sl_u1,
	        889: sl_u1,
	        126: sl_g1,
	        133: sl_h1,
	        87: sl_y1,
	        371: sl_b1,
	        26: sl_c1,
	        200: sl_d1,
	        143: sl_i1,
	        187: sl_j1,
	        612: sl_n3,
	        562: sl_e1,
	        868: sl_u1,
	        890: sl_u1,
	        127: sl_g1,
	        134: sl_h1,
	        88: sl_y1,
	        372: sl_b1,
	        27: sl_c1,
	        201: sl_d1,
	        144: sl_i1,
	        188: sl_j1,
	        613: sl_n3,
	        563: sl_e1,
	        869: sl_u1,
	        891: sl_u1,
	        128: sl_g1,
	        135: sl_h1,
	        89: sl_y1
	    },
	    6: {
	        1861: sl_o3,
	        366: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1,
	        333: sl_p3,
	        557: sl_q3,
	        745: sl_r3,
	        896: sl_s3,
	        618: sl_t3,
	        594: sl_u3,
	        759: sl_v3,
	        750: sl_w3,
	        190: sl_x3,
	        83: sl_y1,
	        300: sl_y3,
	        310: sl_z3,
	        545: sl_a4,
	        508: sl_b4,
	        552: sl_c4,
	        708: sl_d4,
	        76: sl_e4,
	        367: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        139: sl_i1,
	        183: sl_j1,
	        334: sl_p3,
	        558: sl_q3,
	        746: sl_r3,
	        897: sl_s3,
	        619: sl_t3,
	        595: sl_u3,
	        760: sl_v3,
	        751: sl_w3,
	        191: sl_x3,
	        84: sl_y1,
	        301: sl_y3,
	        311: sl_z3,
	        546: sl_a4,
	        509: sl_b4,
	        553: sl_c4,
	        709: sl_d4,
	        77: sl_e4,
	        368: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        140: sl_i1,
	        184: sl_j1,
	        335: sl_p3,
	        559: sl_q3,
	        747: sl_r3,
	        898: sl_s3,
	        620: sl_t3,
	        596: sl_u3,
	        761: sl_v3,
	        752: sl_w3,
	        192: sl_x3,
	        85: sl_y1,
	        302: sl_y3,
	        312: sl_z3,
	        547: sl_a4,
	        510: sl_b4,
	        554: sl_c4,
	        710: sl_d4,
	        78: sl_e4,
	        369: sl_b1,
	        24: sl_c1,
	        198: sl_d1,
	        141: sl_i1,
	        185: sl_j1,
	        336: sl_p3,
	        560: sl_q3,
	        748: sl_r3,
	        899: sl_s3,
	        621: sl_t3,
	        597: sl_u3,
	        762: sl_v3,
	        753: sl_w3,
	        193: sl_x3,
	        86: sl_y1,
	        303: sl_y3,
	        313: sl_z3,
	        548: sl_a4,
	        511: sl_b4,
	        555: sl_c4,
	        711: sl_d4,
	        79: sl_e4,
	        370: sl_b1,
	        25: sl_c1,
	        199: sl_d1,
	        142: sl_i1,
	        186: sl_j1,
	        337: sl_p3,
	        561: sl_q3,
	        749: sl_r3,
	        900: sl_s3,
	        622: sl_t3,
	        598: sl_u3,
	        763: sl_v3,
	        754: sl_w3,
	        194: sl_x3,
	        87: sl_y1,
	        304: sl_y3,
	        314: sl_z3,
	        549: sl_a4,
	        512: sl_b4,
	        556: sl_c4,
	        712: sl_d4,
	        80: sl_e4
	    },
	    4: {
	        366: sl_k1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1,
	        896: sl_s3,
	        557: sl_e1,
	        836: sl_p1,
	        909: sl_q1,
	        914: sl_u1,
	        920: sl_u1,
	        83: sl_y1,
	        903: sl_s1,
	        607: sl_f4,
	        367: sl_k1,
	        22: sl_c1,
	        196: sl_d1,
	        139: sl_i1,
	        183: sl_j1,
	        897: sl_s3,
	        558: sl_e1,
	        837: sl_p1,
	        910: sl_q1,
	        915: sl_u1,
	        921: sl_u1,
	        84: sl_y1,
	        904: sl_s1,
	        608: sl_f4,
	        368: sl_k1,
	        23: sl_c1,
	        197: sl_d1,
	        140: sl_i1,
	        184: sl_j1,
	        898: sl_s3,
	        559: sl_e1,
	        838: sl_p1,
	        911: sl_q1,
	        916: sl_u1,
	        922: sl_u1,
	        85: sl_y1,
	        905: sl_s1,
	        609: sl_f4,
	        369: sl_k1,
	        24: sl_c1,
	        198: sl_d1,
	        141: sl_i1,
	        185: sl_j1,
	        899: sl_s3,
	        560: sl_e1,
	        839: sl_p1,
	        912: sl_q1,
	        917: sl_u1,
	        923: sl_u1,
	        86: sl_y1,
	        906: sl_s1,
	        610: sl_f4,
	        370: sl_k1,
	        25: sl_c1,
	        199: sl_d1,
	        142: sl_i1,
	        186: sl_j1,
	        900: sl_s3,
	        561: sl_e1,
	        840: sl_p1,
	        913: sl_q1,
	        918: sl_u1,
	        924: sl_u1,
	        87: sl_y1,
	        907: sl_s1,
	        611: sl_f4,
	        26: sl_c1,
	        200: sl_d1,
	        143: sl_i1,
	        187: sl_j1,
	        371: sl_k1,
	        562: sl_e1,
	        919: sl_u1,
	        925: sl_u1,
	        901: sl_x1,
	        908: sl_s1,
	        88: sl_y1,
	        362: sl_b1,
	        17: sl_c1,
	        176: sl_d1,
	        358: sl_b1,
	        13: sl_c1,
	        172: sl_d1,
	        363: sl_b1,
	        18: sl_c1,
	        177: sl_d1,
	        359: sl_b1,
	        14: sl_c1,
	        173: sl_d1,
	        364: sl_b1,
	        19: sl_c1,
	        178: sl_d1,
	        360: sl_b1,
	        15: sl_c1,
	        174: sl_d1,
	        365: sl_b1,
	        20: sl_c1,
	        179: sl_d1,
	        361: sl_b1,
	        16: sl_c1,
	        175: sl_d1
	    },
	    8: {
	        664: sl_k1,
	        195: sl_d1,
	        665: sl_k1,
	        196: sl_d1,
	        666: sl_k1,
	        197: sl_d1,
	        667: sl_k1,
	        198: sl_d1
	    }
	};
	
	var baseOutcomeConfig = {
	    11: {
	        74: bo_b1,
	        349: bo_c1,
	        256: bo_d1,
	        306: bo_e1,
	        103: bo_f1,
	        403: bo_g1,
	        443: bo_h1,
	        608: bo_i1
	    },
	    32: {
	        73: bo_b1,
	        318: bo_j1,
	        21: bo_k1,
	        22: bo_l1,
	        23: bo_m1,
	        195: bo_n1,
	        196: bo_o1,
	        197: bo_p1,
	        352: bo_q1,
	        748: bo_r1,
	        102: bo_s1,
	        403: bo_g1,
	        366: bo_t1,
	        367: bo_u1,
	        368: bo_v1,
	        138: bo_w1,
	        139: bo_x1,
	        140: bo_y1,
	        182: bo_z1,
	        183: bo_a2,
	        184: bo_b2,
	        122: bo_c2,
	        123: bo_d2,
	        124: bo_e2,
	        129: bo_f2,
	        130: bo_g2,
	        131: bo_h2,
	        566: bo_i2,
	        567: bo_j2,
	        568: bo_k2,
	        616: bo_l2,
	        617: bo_m2,
	        618: bo_n2,
	        257: bo_o2,
	        307: bo_p2,
	        443: bo_h1,
	        608: bo_i1,
	        362: bo_q2,
	        363: bo_r2,
	        364: bo_s2,
	        17: bo_t2,
	        18: bo_u2,
	        19: bo_v2,
	        176: bo_w2,
	        177: bo_x2,
	        178: bo_y2,
	        358: bo_z2,
	        359: bo_a3,
	        360: bo_b3,
	        13: bo_c3,
	        14: bo_d3,
	        15: bo_e3,
	        172: bo_f3,
	        173: bo_g3,
	        174: bo_h3,
	        256: bo_d1,
	        306: bo_e1
	    },
	    35: {
	        138: bo_i3,
	        256: bo_d1,
	        21: bo_j3,
	        673: bo_k3,
	        182: bo_l3,
	        306: bo_e1,
	        698: bo_g1,
	        731: bo_m3,
	        656: bo_n3,
	        195: bo_o3,
	        74: bo_b1,
	        349: bo_j1,
	        443: bo_h1,
	        608: bo_i1,
	        911: bo_p3,
	        426: bo_q3,
	        535: bo_r3,
	        871: bo_s3,
	        710: bo_t3,
	        742: bo_u3
	    },
	    10: {
	        74: bo_b1,
	        349: bo_c1,
	        256: bo_d1,
	        306: bo_e1,
	        103: bo_f1,
	        403: bo_g1,
	        1: bo_v3,
	        443: bo_h1,
	        608: bo_i1
	    },
	    31: {
	        74: bo_b1,
	        349: bo_c1,
	        21: bo_w3,
	        22: bo_x3,
	        23: bo_y3,
	        24: bo_z3,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_a4,
	        196: bo_b4,
	        197: bo_c4,
	        198: bo_d4,
	        673: bo_e4,
	        674: bo_f4,
	        675: bo_g4,
	        676: bo_h4,
	        103: bo_i4,
	        403: bo_g1,
	        138: bo_j4,
	        139: bo_k4,
	        140: bo_l4,
	        141: bo_m4,
	        182: bo_n4,
	        183: bo_o4,
	        184: bo_p4,
	        185: bo_q4,
	        238: bo_o3,
	        682: bo_r4,
	        239: bo_s4,
	        58: bo_j3,
	        59: bo_t4,
	        681: bo_k3,
	        234: bo_i3,
	        235: bo_u4,
	        236: bo_l3,
	        237: bo_v4,
	        725: bo_w4,
	        726: bo_x4,
	        727: bo_y4,
	        728: bo_z4,
	        782: bo_a5,
	        778: bo_b5,
	        779: bo_c5,
	        780: bo_d5,
	        781: bo_e5,
	        783: bo_f5,
	        773: bo_g5,
	        474: bo_h5,
	        421: bo_i5,
	        530: bo_j5,
	        422: bo_k5,
	        531: bo_l5,
	        444: bo_m5,
	        888: bo_n5,
	        280: bo_o5,
	        317: bo_p5,
	        424: bo_q5,
	        533: bo_r5,
	        423: bo_s5,
	        532: bo_t5,
	        637: bo_u5,
	        788: bo_v5,
	        784: bo_w5,
	        785: bo_x5,
	        786: bo_y5,
	        787: bo_z5,
	        774: bo_a6,
	        775: bo_b6,
	        776: bo_c6,
	        777: bo_d6,
	        281: bo_e6,
	        137: bo_f6,
	        246: bo_g6,
	        248: bo_h6,
	        240: bo_i6,
	        232: bo_j6,
	        241: bo_k6,
	        233: bo_l6,
	        61: bo_m6,
	        62: bo_n6,
	        684: bo_o6,
	        685: bo_p6,
	        443: bo_h1,
	        608: bo_i1,
	        890: bo_q6,
	        242: bo_r6,
	        245: bo_s6,
	        243: bo_t6,
	        60: bo_u6,
	        683: bo_v6,
	        406: bo_w6,
	        405: bo_x6,
	        404: bo_y6,
	        700: bo_z6,
	        408: bo_a7,
	        407: bo_b7,
	        247: bo_c7,
	        244: bo_d7,
	        638: bo_e7,
	        639: bo_f7,
	        640: bo_g7,
	        641: bo_h7,
	        646: bo_i7,
	        642: bo_j7,
	        643: bo_k7,
	        644: bo_l7,
	        645: bo_m7
	    },
	    41: {
	        74: bo_b1,
	        349: bo_c1,
	        21: bo_j3,
	        22: bo_t4,
	        403: bo_g1,
	        673: bo_k3,
	        674: bo_r4,
	        195: bo_o3,
	        196: bo_s4,
	        791: bo_n7,
	        792: bo_o7,
	        637: bo_u5,
	        796: bo_v5,
	        794: bo_p7,
	        795: bo_q7,
	        789: bo_r7,
	        790: bo_s7,
	        725: bo_t7,
	        726: bo_u7,
	        793: bo_a5,
	        411: bo_v7,
	        701: bo_m5,
	        251: bo_w7,
	        252: bo_x7,
	        409: bo_k5,
	        430: bo_l5,
	        410: bo_s5,
	        431: bo_t5,
	        281: bo_e6,
	        137: bo_f6,
	        249: bo_g6,
	        250: bo_h6,
	        63: bo_m6,
	        64: bo_n6,
	        686: bo_o6,
	        687: bo_p6,
	        103: bo_i4,
	        256: bo_d1,
	        306: bo_e1,
	        138: bo_i3,
	        139: bo_u4,
	        182: bo_l3,
	        183: bo_v4,
	        443: bo_h1,
	        608: bo_i1,
	        648: bo_y7,
	        649: bo_z7
	    },
	    18: {
	        74: bo_b1,
	        349: bo_j1,
	        656: bo_n3,
	        698: bo_g1,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_a8,
	        196: bo_b8,
	        197: bo_c8,
	        673: bo_d8,
	        674: bo_e8,
	        675: bo_f8,
	        610: bo_g8,
	        443: bo_h1,
	        608: bo_i1,
	        806: bo_v5,
	        893: bo_v5,
	        707: bo_h8,
	        708: bo_i8,
	        709: bo_j8,
	        889: bo_a5,
	        904: bo_k8,
	        253: bo_l8,
	        688: bo_m8,
	        65: bo_n8,
	        751: bo_o8,
	        21: bo_p8,
	        22: bo_q8,
	        23: bo_r8,
	        743: bo_s8,
	        744: bo_t8,
	        745: bo_u8,
	        615: bo_v8,
	        350: bo_l8
	    },
	    3: {
	        73: bo_b1,
	        318: bo_j1,
	        21: bo_w8,
	        22: bo_x8,
	        23: bo_y8,
	        195: bo_z8,
	        196: bo_a9,
	        197: bo_b9,
	        352: bo_c9,
	        746: bo_r1,
	        102: bo_s1,
	        403: bo_g1,
	        138: bo_d9,
	        139: bo_e9,
	        140: bo_f9,
	        182: bo_g9,
	        183: bo_h9,
	        184: bo_i9,
	        366: bo_j9,
	        367: bo_k9,
	        368: bo_l9,
	        566: bo_m9,
	        567: bo_n9,
	        568: bo_o9,
	        74: bo_p9,
	        854: bo_q9,
	        855: bo_r9,
	        856: bo_s9,
	        857: bo_q9,
	        858: bo_r9,
	        859: bo_s9,
	        797: bo_t9,
	        798: bo_u9,
	        799: bo_v9,
	        851: bo_w9,
	        852: bo_x9,
	        853: bo_y9,
	        83: bo_z9,
	        84: bo_a10,
	        85: bo_b10,
	        905: bo_c10,
	        906: bo_d10,
	        907: bo_e10,
	        443: bo_h1,
	        608: bo_i1,
	        362: bo_q2,
	        363: bo_r2,
	        17: bo_t2,
	        18: bo_u2,
	        176: bo_w2,
	        177: bo_x2,
	        358: bo_z2,
	        359: bo_a3,
	        13: bo_c3,
	        14: bo_d3,
	        172: bo_f3,
	        173: bo_g3,
	        616: bo_f10,
	        617: bo_g10,
	        618: bo_h10,
	        891: bo_i10,
	        257: bo_d1,
	        307: bo_e1,
	        800: bo_j10,
	        801: bo_k10,
	        802: bo_l10
	    },
	    20: {
	        74: bo_b1,
	        349: bo_m10,
	        256: bo_d1,
	        306: bo_e1,
	        698: bo_g1,
	        195: bo_n10,
	        196: bo_o10,
	        197: bo_p10,
	        198: bo_q10,
	        199: bo_r10,
	        200: bo_s10,
	        201: bo_t10,
	        202: bo_u10,
	        138: bo_v10,
	        139: bo_w10,
	        140: bo_x10,
	        141: bo_y10,
	        142: bo_z10,
	        143: bo_a11,
	        144: bo_b11,
	        145: bo_c11,
	        182: bo_d11,
	        183: bo_e11,
	        184: bo_f11,
	        185: bo_g11,
	        186: bo_h11,
	        187: bo_i11,
	        188: bo_j11,
	        189: bo_k11,
	        21: bo_l11,
	        22: bo_m11,
	        23: bo_n11,
	        24: bo_o11,
	        25: bo_p11,
	        26: bo_q11,
	        27: bo_r11,
	        28: bo_s11,
	        673: bo_t11,
	        674: bo_u11,
	        675: bo_v11,
	        676: bo_w11,
	        677: bo_x11,
	        678: bo_y11,
	        679: bo_z11,
	        680: bo_a12,
	        860: bo_b12,
	        861: bo_c12,
	        862: bo_d12,
	        863: bo_e12,
	        864: bo_f12,
	        865: bo_g12,
	        866: bo_h12,
	        867: bo_i12,
	        443: bo_h1,
	        608: bo_i1
	    },
	    5: {
	        349: bo_j1,
	        698: bo_g1,
	        443: bo_h1,
	        608: bo_i1,
	        945: bo_j12,
	        948: bo_k12,
	        949: bo_l12
	    },
	    40: {
	        656: bo_m12,
	        698: bo_g1,
	        443: bo_h1,
	        608: bo_i1
	    },
	    37: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    38: {
	        403: bo_g1,
	        443: bo_h1,
	        608: bo_i1,
	        74: bo_b1,
	        349: bo_n12,
	        615: bo_o12,
	        413: bo_p12,
	        414: bo_q12
	    },
	    42: {
	        403: bo_g1,
	        443: bo_h1,
	        608: bo_i1,
	        74: bo_b1,
	        349: bo_n12,
	        615: bo_r12,
	        413: bo_p12,
	        414: bo_s12,
	        566: bo_t12,
	        567: bo_u12,
	        568: bo_v12,
	        569: bo_w12,
	        570: bo_x12,
	        698: bo_g1,
	        366: bo_y12,
	        367: bo_z12,
	        368: bo_a13,
	        369: bo_b13,
	        370: bo_c13,
	        940: bo_d13,
	        941: bo_e13,
	        942: bo_f13,
	        943: bo_g13,
	        944: bo_h13
	    },
	    26: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    25: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    16: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    12: {
	        74: bo_b1,
	        349: bo_c1,
	        656: bo_n3,
	        698: bo_g1,
	        256: bo_d1,
	        306: bo_e1,
	        103: bo_f1,
	        443: bo_h1,
	        608: bo_i1
	    },
	    36: {
	        610: bo_i13,
	        698: bo_g1,
	        656: bo_n3,
	        74: bo_b1,
	        349: bo_c1,
	        615: bo_v8,
	        256: bo_d1,
	        306: bo_e1,
	        673: bo_d8,
	        21: bo_p8,
	        195: bo_a8,
	        443: bo_h1,
	        608: bo_i1
	    },
	    7: {
	        425: bo_k5,
	        534: bo_l5,
	        540: bo_j13,
	        343: bo_k13,
	        345: bo_w7,
	        260: bo_l13,
	        261: bo_m13,
	        83: bo_n13,
	        84: bo_o13,
	        803: bo_p13,
	        868: bo_q13,
	        869: bo_r13,
	        870: bo_s13,
	        805: bo_t13,
	        892: bo_u13,
	        346: bo_v13,
	        419: bo_w13,
	        528: bo_x13,
	        420: bo_y13,
	        529: bo_z13,
	        707: bo_a14,
	        708: bo_b14,
	        706: bo_c14,
	        804: bo_d14,
	        474: bo_e14,
	        614: bo_f14,
	        609: bo_g14,
	        416: bo_h14,
	        732: bo_i14,
	        525: bo_j14,
	        850: bo_k14,
	        473: bo_l14,
	        442: bo_m14,
	        729: bo_n14,
	        538: bo_o14,
	        542: bo_p14,
	        730: bo_q14,
	        471: bo_r14,
	        635: bo_s14,
	        714: bo_t14,
	        624: bo_u14,
	        625: bo_v14,
	        715: bo_w14,
	        650: bo_x14,
	        651: bo_y14,
	        652: bo_z14,
	        653: bo_a15,
	        654: bo_b15,
	        655: bo_c15,
	        634: bo_d15,
	        626: bo_e15,
	        733: bo_f15,
	        734: bo_g15,
	        258: bo_h15,
	        259: bo_i15,
	        66: bo_j15,
	        67: bo_k15,
	        81: bo_l15,
	        68: bo_m15,
	        689: bo_n15,
	        690: bo_o15,
	        699: bo_p15,
	        691: bo_q15,
	        723: bo_r15,
	        633: bo_s15,
	        74: bo_b1,
	        349: bo_t15,
	        656: bo_n3,
	        698: bo_g1,
	        322: bo_u15,
	        904: bo_v15,
	        1: bo_v3,
	        136: bo_w15,
	        747: bo_u3,
	        871: bo_s3,
	        255: bo_x15,
	        705: bo_y15,
	        323: bo_z15,
	        324: bo_a16,
	        702: bo_b16,
	        278: bo_c16,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_o3,
	        196: bo_s4,
	        21: bo_j3,
	        22: bo_t4,
	        282: bo_d16,
	        911: bo_i10,
	        353: bo_e16,
	        673: bo_k3,
	        674: bo_r4,
	        2: bo_f16,
	        5: bo_g16,
	        7: bo_h16,
	        939: bo_i16,
	        9: bo_j16,
	        12: bo_k16,
	        417: bo_l16,
	        526: bo_m16,
	        325: bo_n16,
	        103: bo_o16,
	        160: bo_p16,
	        163: bo_q16,
	        165: bo_r16,
	        166: bo_s16,
	        168: bo_t16,
	        171: bo_u16,
	        148: bo_v16,
	        149: bo_w16,
	        150: bo_x16,
	        151: bo_y16,
	        152: bo_z16,
	        153: bo_a17,
	        154: bo_b17,
	        155: bo_c17,
	        156: bo_d17,
	        157: bo_e17,
	        158: bo_f17,
	        159: bo_g17,
	        731: bo_v8,
	        765: bo_h17,
	        766: bo_i17,
	        415: bo_j17,
	        524: bo_k17,
	        418: bo_l17,
	        527: bo_m17,
	        743: bo_n17,
	        744: bo_o17,
	        710: bo_t3,
	        321: bo_p17,
	        326: bo_q17,
	        327: bo_r17,
	        724: bo_s17,
	        661: bo_t17,
	        664: bo_u17,
	        666: bo_v17,
	        667: bo_w17,
	        669: bo_x17,
	        672: bo_y17,
	        426: bo_q3,
	        535: bo_r3,
	        537: bo_z17,
	        541: bo_a18,
	        539: bo_b18,
	        138: bo_i3,
	        139: bo_u4,
	        182: bo_l3,
	        183: bo_v4,
	        437: bo_c18,
	        436: bo_d18,
	        694: bo_e18,
	        71: bo_f18,
	        271: bo_g18,
	        268: bo_h18,
	        265: bo_i18,
	        267: bo_j18,
	        270: bo_k18,
	        272: bo_l18,
	        269: bo_m18,
	        266: bo_n18,
	        264: bo_o18,
	        281: bo_e6,
	        137: bo_f6,
	        660: bo_n3,
	        880: bo_p18,
	        879: bo_q18,
	        429: bo_r18,
	        433: bo_s18,
	        443: bo_h1,
	        608: bo_i1,
	        881: bo_t18,
	        273: bo_u18,
	        274: bo_v18,
	        435: bo_w18,
	        704: bo_x18,
	        432: bo_y18,
	        428: bo_z18,
	        434: bo_a19,
	        439: bo_b19,
	        440: bo_c19,
	        441: bo_d19,
	        438: bo_e19,
	        623: bo_f19,
	        180: bo_g19,
	        146: bo_h19,
	        659: bo_i19,
	        749: bo_j19,
	        69: bo_k19,
	        262: bo_l19,
	        692: bo_m19,
	        703: bo_n19,
	        70: bo_o19,
	        263: bo_p19,
	        693: bo_q19,
	        72: bo_r19,
	        277: bo_s19,
	        695: bo_t19,
	        750: bo_u19,
	        181: bo_v19,
	        147: bo_w19,
	        276: bo_x19,
	        275: bo_y19,
	        735: bo_z19,
	        736: bo_a20,
	        737: bo_b20,
	        738: bo_c20,
	        739: bo_d20,
	        740: bo_e20,
	        356: bo_f20,
	        357: bo_g20,
	        354: bo_h20,
	        355: bo_i20,
	        937: bo_b16,
	        657: bo_j20,
	        658: bo_k20,
	        412: bo_l20
	    },
	    14: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    34: {
	        425: bo_k5,
	        534: bo_l5,
	        540: bo_m20,
	        343: bo_k13,
	        345: bo_w7,
	        260: bo_l13,
	        261: bo_m13,
	        83: bo_n20,
	        84: bo_o20,
	        803: bo_p20,
	        868: bo_q20,
	        869: bo_r20,
	        870: bo_s20,
	        346: bo_v13,
	        419: bo_w13,
	        528: bo_x13,
	        420: bo_y13,
	        529: bo_z13,
	        707: bo_a14,
	        708: bo_b14,
	        706: bo_t20,
	        538: bo_u20,
	        74: bo_b1,
	        349: bo_v20,
	        656: bo_m12,
	        698: bo_g1,
	        322: bo_u15,
	        904: bo_w20,
	        1: bo_v3,
	        136: bo_w15,
	        747: bo_x20,
	        871: bo_y20,
	        255: bo_x15,
	        705: bo_z20,
	        323: bo_a21,
	        324: bo_b21,
	        702: bo_b16,
	        278: bo_c21,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_o3,
	        196: bo_s4,
	        21: bo_j3,
	        22: bo_t4,
	        282: bo_d16,
	        911: bo_p3,
	        353: bo_d21,
	        673: bo_k3,
	        674: bo_r4,
	        2: bo_e21,
	        5: bo_f21,
	        7: bo_h16,
	        939: bo_g21,
	        9: bo_h21,
	        12: bo_k16,
	        417: bo_i21,
	        526: bo_j21,
	        325: bo_k21,
	        103: bo_l21,
	        160: bo_m21,
	        163: bo_n21,
	        165: bo_r16,
	        166: bo_o21,
	        168: bo_p21,
	        171: bo_u16,
	        148: bo_q21,
	        149: bo_r21,
	        150: bo_x16,
	        151: bo_s21,
	        152: bo_t21,
	        153: bo_a17,
	        154: bo_u21,
	        155: bo_v21,
	        156: bo_d17,
	        157: bo_w21,
	        158: bo_x21,
	        159: bo_g17,
	        731: bo_v8,
	        765: bo_h17,
	        766: bo_i17,
	        415: bo_j17,
	        524: bo_k17,
	        418: bo_l17,
	        527: bo_y21,
	        743: bo_n17,
	        744: bo_o17,
	        710: bo_t3,
	        321: bo_z21,
	        326: bo_q17,
	        327: bo_r17,
	        724: bo_s17,
	        661: bo_a22,
	        664: bo_b22,
	        666: bo_c22,
	        667: bo_d22,
	        669: bo_e22,
	        672: bo_f22,
	        426: bo_q3,
	        535: bo_r3,
	        537: bo_z17,
	        541: bo_a18,
	        539: bo_g22,
	        138: bo_i3,
	        139: bo_u4,
	        182: bo_l3,
	        183: bo_v4,
	        443: bo_h1,
	        608: bo_i1
	    },
	    19: {
	        74: bo_b1,
	        349: bo_j1,
	        698: bo_g1,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_a8,
	        196: bo_b8,
	        103: bo_s1,
	        615: bo_h22,
	        886: bo_i22,
	        887: bo_j22,
	        911: bo_k22,
	        884: bo_l22,
	        885: bo_m22,
	        882: bo_n22,
	        883: bo_o22,
	        723: bo_p22,
	        673: bo_d8,
	        674: bo_e8,
	        21: bo_j3,
	        22: bo_t4,
	        138: bo_i3,
	        182: bo_l3,
	        443: bo_h1,
	        608: bo_i1
	    },
	    30: {
	        74: bo_b1,
	        349: bo_c1,
	        656: bo_n3,
	        698: bo_g1,
	        21: bo_p8,
	        22: bo_q8,
	        23: bo_r8,
	        279: bo_q22,
	        610: bo_r22,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_a8,
	        196: bo_b8,
	        197: bo_c8,
	        673: bo_d8,
	        674: bo_e8,
	        675: bo_f8,
	        350: bo_l8,
	        103: bo_i4,
	        415: bo_j17,
	        524: bo_k17,
	        743: bo_s8,
	        744: bo_t8,
	        745: bo_u8,
	        710: bo_t3,
	        403: bo_g1,
	        426: bo_s22,
	        535: bo_t22,
	        706: bo_u22,
	        343: bo_k13,
	        346: bo_v13,
	        83: bo_v22,
	        84: bo_w22,
	        85: bo_x22,
	        344: bo_y22,
	        347: bo_z22,
	        765: bo_i22,
	        766: bo_j22,
	        767: bo_a23,
	        138: bo_b23,
	        139: bo_c23,
	        140: bo_d23,
	        182: bo_e23,
	        183: bo_f23,
	        184: bo_g23,
	        751: bo_o8,
	        911: bo_p3,
	        889: bo_a5,
	        637: bo_h23,
	        615: bo_v8,
	        412: bo_i23,
	        634: bo_j23,
	        626: bo_k23,
	        611: bo_l23,
	        443: bo_h1,
	        608: bo_i1,
	        904: bo_k8,
	        449: bo_m23,
	        446: bo_n23,
	        451: bo_o23,
	        711: bo_p23,
	        712: bo_p23,
	        713: bo_p23,
	        450: bo_q23,
	        447: bo_r23,
	        448: bo_s23,
	        662: bo_t23,
	        663: bo_u23,
	        665: bo_v23,
	        668: bo_w23,
	        670: bo_x23,
	        671: bo_y23,
	        3: bo_z23,
	        4: bo_a24,
	        6: bo_b24,
	        8: bo_c24,
	        10: bo_d24,
	        11: bo_e24,
	        161: bo_f24,
	        162: bo_g24,
	        164: bo_h24,
	        167: bo_i24,
	        169: bo_j24,
	        170: bo_k24,
	        707: bo_h8,
	        708: bo_i8,
	        709: bo_j8,
	        946: bo_h14,
	        947: bo_j14
	    },
	    23: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    13: {
	        468: bo_l24,
	        470: bo_m24,
	        467: bo_n24,
	        469: bo_o24,
	        464: bo_p24,
	        466: bo_q24,
	        465: bo_r24,
	        463: bo_s24,
	        289: bo_t24,
	        288: bo_u24,
	        292: bo_v24,
	        461: bo_w24,
	        283: bo_x24,
	        295: bo_y24,
	        293: bo_z24,
	        284: bo_a25,
	        285: bo_b25,
	        316: bo_c25,
	        286: bo_d25,
	        287: bo_e25,
	        290: bo_f25,
	        291: bo_g25,
	        462: bo_h25,
	        294: bo_i25
	    },
	    39: {
	        403: bo_g1,
	        443: bo_h1,
	        608: bo_i1,
	        698: bo_g1,
	        349: bo_j1,
	        950: bo_l12,
	        955: bo_j12,
	        951: bo_j25,
	        952: bo_k25,
	        953: bo_l25,
	        954: bo_m25
	    },
	    33: {
	        348: bo_n25,
	        443: bo_h1,
	        608: bo_i1
	    },
	    24: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    9: {
	        74: bo_b1,
	        349: bo_j1,
	        656: bo_n3,
	        698: bo_g1,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_o3,
	        196: bo_s4,
	        673: bo_k3,
	        674: bo_r4,
	        443: bo_h1,
	        608: bo_i1
	    },
	    21: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    29: {
	        394: bo_o25,
	        395: bo_p25,
	        396: bo_q25,
	        397: bo_r25,
	        398: bo_s25,
	        399: bo_t25,
	        400: bo_u25,
	        401: bo_v25,
	        402: bo_w25,
	        100: bo_x25,
	        101: bo_y25,
	        104: bo_z25,
	        105: bo_a26,
	        106: bo_b26,
	        107: bo_c26,
	        108: bo_d26,
	        109: bo_e26,
	        110: bo_f26,
	        111: bo_g26,
	        112: bo_h26,
	        113: bo_i26,
	        114: bo_j26,
	        115: bo_k26,
	        116: bo_l26,
	        117: bo_m26,
	        118: bo_n26,
	        119: bo_o26,
	        120: bo_p26,
	        121: bo_q26,
	        808: bo_r26,
	        809: bo_s26,
	        810: bo_t26,
	        811: bo_u26,
	        812: bo_v26,
	        813: bo_w26,
	        814: bo_x26,
	        815: bo_y26,
	        816: bo_z26,
	        817: bo_a27,
	        818: bo_b27,
	        819: bo_c27,
	        820: bo_d27,
	        821: bo_e27,
	        822: bo_f27,
	        823: bo_g27,
	        824: bo_h27,
	        825: bo_i27,
	        826: bo_j27,
	        827: bo_k27,
	        828: bo_l27,
	        829: bo_m27,
	        830: bo_n27,
	        831: bo_o27,
	        832: bo_p27,
	        833: bo_q27,
	        834: bo_r27,
	        835: bo_s27,
	        836: bo_t27,
	        837: bo_u27,
	        838: bo_v27,
	        839: bo_w27,
	        840: bo_x27,
	        841: bo_y27,
	        842: bo_z27,
	        843: bo_a28,
	        844: bo_b28,
	        366: bo_c28,
	        367: bo_d28,
	        368: bo_e28,
	        369: bo_f28,
	        370: bo_g28,
	        371: bo_h28,
	        372: bo_i28,
	        373: bo_j28,
	        374: bo_k28,
	        375: bo_l28,
	        376: bo_m28,
	        377: bo_n28,
	        378: bo_o28,
	        379: bo_p28,
	        380: bo_q28,
	        381: bo_r28,
	        382: bo_s28,
	        383: bo_t28,
	        384: bo_u28,
	        385: bo_v28,
	        386: bo_w28,
	        387: bo_x28,
	        388: bo_y28,
	        389: bo_z28,
	        390: bo_a29,
	        391: bo_b29,
	        392: bo_c29,
	        393: bo_d29,
	        481: bo_e29,
	        482: bo_f29,
	        483: bo_g29,
	        484: bo_h29,
	        485: bo_i29,
	        486: bo_j29,
	        487: bo_k29,
	        488: bo_l29,
	        489: bo_m29,
	        490: bo_n29,
	        491: bo_o29,
	        492: bo_p29,
	        493: bo_q29,
	        494: bo_r29,
	        495: bo_s29,
	        496: bo_t29,
	        497: bo_u29,
	        498: bo_v29,
	        499: bo_w29,
	        500: bo_x29,
	        501: bo_y29,
	        502: bo_z29,
	        503: bo_a30,
	        504: bo_b30,
	        505: bo_c30,
	        506: bo_d30,
	        507: bo_e30,
	        508: bo_f30,
	        509: bo_g30,
	        510: bo_h30,
	        511: bo_i30,
	        566: bo_j30,
	        567: bo_k30,
	        568: bo_l30,
	        569: bo_m30,
	        570: bo_n30,
	        571: bo_o30,
	        572: bo_p30,
	        573: bo_q30,
	        574: bo_r30,
	        575: bo_s30,
	        576: bo_t30,
	        577: bo_u30,
	        578: bo_v30,
	        579: bo_w30,
	        580: bo_x30,
	        581: bo_y30,
	        582: bo_z30,
	        583: bo_a31,
	        584: bo_b31,
	        585: bo_c31,
	        586: bo_d31,
	        587: bo_e31,
	        588: bo_f31,
	        589: bo_g31,
	        590: bo_h31,
	        591: bo_i31,
	        592: bo_j31,
	        593: bo_k31,
	        594: bo_l31,
	        595: bo_m31,
	        596: bo_n31,
	        597: bo_o31,
	        598: bo_p31,
	        599: bo_q31,
	        600: bo_r31,
	        601: bo_s31,
	        602: bo_t31,
	        83: bo_u31,
	        84: bo_v31,
	        85: bo_w31,
	        86: bo_x31,
	        87: bo_y31,
	        88: bo_z31,
	        89: bo_a32,
	        90: bo_b32,
	        91: bo_c32,
	        92: bo_d32,
	        93: bo_e32,
	        94: bo_f32,
	        95: bo_g32,
	        96: bo_h32,
	        97: bo_i32,
	        98: bo_j32,
	        99: bo_k32,
	        74: bo_b1,
	        349: bo_j1,
	        254: bo_l32,
	        403: bo_g1,
	        21: bo_m32,
	        22: bo_n32,
	        23: bo_o32,
	        24: bo_p32,
	        25: bo_q32,
	        26: bo_r32,
	        27: bo_s32,
	        28: bo_t32,
	        29: bo_u32,
	        30: bo_v32,
	        31: bo_w32,
	        32: bo_x32,
	        33: bo_y32,
	        34: bo_z32,
	        35: bo_a33,
	        36: bo_b33,
	        37: bo_c33,
	        38: bo_d33,
	        39: bo_e33,
	        40: bo_f33,
	        41: bo_g33,
	        42: bo_h33,
	        43: bo_i33,
	        44: bo_j33,
	        45: bo_k33,
	        46: bo_l33,
	        47: bo_m33,
	        48: bo_n33,
	        49: bo_o33,
	        50: bo_p33,
	        51: bo_q33,
	        52: bo_r33,
	        53: bo_s33,
	        54: bo_t33,
	        55: bo_u33,
	        56: bo_v33,
	        57: bo_w33,
	        195: bo_x33,
	        196: bo_y33,
	        197: bo_z33,
	        198: bo_a34,
	        199: bo_b34,
	        200: bo_c34,
	        201: bo_d34,
	        202: bo_e34,
	        203: bo_f34,
	        204: bo_g34,
	        205: bo_h34,
	        206: bo_i34,
	        207: bo_j34,
	        208: bo_k34,
	        209: bo_l34,
	        210: bo_m34,
	        211: bo_n34,
	        212: bo_o34,
	        213: bo_p34,
	        214: bo_q34,
	        215: bo_r34,
	        216: bo_s34,
	        217: bo_t34,
	        218: bo_u34,
	        219: bo_v34,
	        220: bo_w34,
	        221: bo_x34,
	        222: bo_y34,
	        223: bo_z34,
	        224: bo_a35,
	        225: bo_b35,
	        226: bo_c35,
	        227: bo_d35,
	        228: bo_e35,
	        229: bo_f35,
	        230: bo_g35,
	        231: bo_h35,
	        475: bo_i35,
	        476: bo_j35,
	        477: bo_k35,
	        478: bo_l35,
	        479: bo_m35,
	        480: bo_n35,
	        443: bo_h1,
	        608: bo_i1
	    },
	    15: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    2: {
	        73: bo_b1,
	        318: bo_j1,
	        21: bo_k1,
	        22: bo_l1,
	        23: bo_m1,
	        24: bo_o35,
	        25: bo_p35,
	        26: bo_q35,
	        27: bo_r35,
	        195: bo_n1,
	        196: bo_o1,
	        197: bo_p1,
	        198: bo_s35,
	        199: bo_t35,
	        200: bo_u35,
	        201: bo_v35,
	        352: bo_w35,
	        102: bo_s1,
	        403: bo_g1,
	        138: bo_w1,
	        139: bo_x1,
	        140: bo_y1,
	        141: bo_x35,
	        142: bo_y35,
	        143: bo_z35,
	        144: bo_a36,
	        182: bo_z1,
	        183: bo_a2,
	        184: bo_b2,
	        185: bo_b36,
	        186: bo_c36,
	        187: bo_d36,
	        188: bo_e36,
	        566: bo_i2,
	        567: bo_j2,
	        568: bo_k2,
	        569: bo_f36,
	        570: bo_g36,
	        571: bo_h36,
	        572: bo_i36,
	        366: bo_t1,
	        367: bo_u1,
	        368: bo_v1,
	        369: bo_j36,
	        370: bo_k36,
	        371: bo_l36,
	        372: bo_m36,
	        122: bo_n36,
	        123: bo_o36,
	        124: bo_p36,
	        125: bo_q36,
	        126: bo_r36,
	        127: bo_s36,
	        128: bo_t36,
	        129: bo_u36,
	        130: bo_v36,
	        131: bo_w36,
	        132: bo_x36,
	        133: bo_y36,
	        134: bo_z36,
	        135: bo_a37,
	        872: bo_b37,
	        873: bo_c37,
	        874: bo_d37,
	        875: bo_e37,
	        876: bo_f37,
	        877: bo_g37,
	        878: bo_h37,
	        616: bo_i37,
	        617: bo_j37,
	        618: bo_k37,
	        619: bo_l37,
	        620: bo_m37,
	        621: bo_n37,
	        622: bo_o37,
	        894: bo_b37,
	        895: bo_c37,
	        896: bo_d37,
	        897: bo_e37,
	        898: bo_f37,
	        899: bo_g37,
	        900: bo_h37,
	        443: bo_h1,
	        608: bo_i1,
	        83: bo_z9,
	        84: bo_a10,
	        85: bo_b10,
	        86: bo_p37,
	        87: bo_q37,
	        88: bo_r37,
	        89: bo_s37,
	        257: bo_d1,
	        307: bo_e1,
	        752: bo_t37,
	        753: bo_t37
	    },
	    6: {
	        553: bo_u37,
	        339: bo_v37,
	        547: bo_w37,
	        138: bo_d9,
	        139: bo_e9,
	        140: bo_f9,
	        141: bo_x37,
	        142: bo_y37,
	        182: bo_g9,
	        183: bo_h9,
	        184: bo_i9,
	        185: bo_z37,
	        186: bo_a38,
	        83: bo_z9,
	        84: bo_a10,
	        85: bo_b10,
	        86: bo_p37,
	        87: bo_q37,
	        807: bo_b38,
	        636: bo_c38,
	        334: bo_d38,
	        335: bo_e38,
	        336: bo_f38,
	        337: bo_g38,
	        906: bo_h38,
	        907: bo_i38,
	        908: bo_j38,
	        909: bo_k38,
	        300: bo_l38,
	        301: bo_m38,
	        302: bo_n38,
	        303: bo_o38,
	        304: bo_p38,
	        310: bo_q38,
	        311: bo_r38,
	        312: bo_s38,
	        313: bo_t38,
	        314: bo_u38,
	        554: bo_v38,
	        555: bo_w38,
	        556: bo_x38,
	        557: bo_y38,
	        558: bo_z38,
	        517: bo_a39,
	        518: bo_a39,
	        519: bo_b39,
	        520: bo_c39,
	        521: bo_d39,
	        561: bo_e39,
	        562: bo_f39,
	        563: bo_g39,
	        564: bo_h39,
	        565: bo_i39,
	        73: bo_j39,
	        318: bo_j1,
	        21: bo_w8,
	        22: bo_x8,
	        23: bo_y8,
	        24: bo_k39,
	        25: bo_l39,
	        195: bo_z8,
	        196: bo_a9,
	        197: bo_b9,
	        198: bo_m39,
	        199: bo_n39,
	        352: bo_o39,
	        748: bo_r1,
	        102: bo_s1,
	        403: bo_g1,
	        903: bo_p39,
	        445: bo_q39,
	        754: bo_r39,
	        755: bo_s39,
	        756: bo_t39,
	        757: bo_u39,
	        758: bo_v39,
	        452: bo_w39,
	        453: bo_x39,
	        454: bo_y39,
	        566: bo_z39,
	        567: bo_a40,
	        568: bo_b40,
	        569: bo_c40,
	        570: bo_d40,
	        366: bo_j9,
	        367: bo_k9,
	        368: bo_l9,
	        369: bo_e40,
	        370: bo_f40,
	        522: bo_g40,
	        627: bo_h40,
	        628: bo_i40,
	        629: bo_j40,
	        630: bo_k40,
	        631: bo_l40,
	        632: bo_m40,
	        190: bo_n40,
	        191: bo_o40,
	        192: bo_p40,
	        193: bo_q40,
	        194: bo_r40,
	        759: bo_s40,
	        760: bo_t40,
	        761: bo_u40,
	        762: bo_v40,
	        763: bo_w40,
	        768: bo_x40,
	        769: bo_y40,
	        770: bo_z40,
	        771: bo_a41,
	        772: bo_b41,
	        603: bo_c41,
	        604: bo_d41,
	        605: bo_e41,
	        606: bo_f41,
	        607: bo_g41,
	        257: bo_d1,
	        307: bo_e1,
	        696: bo_g1,
	        333: bo_h41,
	        341: bo_i41,
	        427: bo_j41,
	        536: bo_k41,
	        905: bo_l41,
	        320: bo_m41,
	        514: bo_n41,
	        516: bo_o41,
	        305: bo_p41,
	        315: bo_q41,
	        523: bo_r41,
	        299: bo_s41,
	        309: bo_t41,
	        697: bo_u41,
	        298: bo_v41,
	        308: bo_w41,
	        515: bo_x41,
	        549: bo_y41,
	        548: bo_z41,
	        443: bo_h1,
	        608: bo_i1,
	        550: bo_a42,
	        551: bo_a42,
	        455: bo_b42,
	        456: bo_b42,
	        457: bo_c42,
	        458: bo_c42,
	        459: bo_d42,
	        460: bo_d42,
	        512: bo_g40,
	        513: bo_g40,
	        901: bo_e42,
	        902: bo_e42,
	        340: bo_f42,
	        328: bo_g42,
	        329: bo_h42,
	        342: bo_i42,
	        330: bo_j42,
	        331: bo_k42,
	        722: bo_l42,
	        560: bo_m42,
	        543: bo_n42,
	        544: bo_o42,
	        545: bo_p42,
	        546: bo_q42,
	        332: bo_r42,
	        559: bo_s42,
	        296: bo_t42,
	        297: bo_u42,
	        717: bo_v42,
	        718: bo_w42,
	        719: bo_x42,
	        720: bo_y42,
	        721: bo_z42,
	        552: bo_a43,
	        76: bo_b43,
	        77: bo_c43,
	        78: bo_d43,
	        79: bo_e43,
	        80: bo_f43,
	        647: bo_g43,
	        741: bo_h43,
	        82: bo_i43,
	        338: bo_j43
	    },
	    17: {
	        348: bo_n25,
	        443: bo_h1,
	        608: bo_i1
	    },
	    4: {
	        73: bo_b1,
	        318: bo_j1,
	        21: bo_w8,
	        22: bo_x8,
	        23: bo_y8,
	        24: bo_k39,
	        25: bo_l39,
	        195: bo_z8,
	        196: bo_a9,
	        197: bo_b9,
	        198: bo_m39,
	        199: bo_n39,
	        352: bo_c9,
	        764: bo_t37,
	        102: bo_s1,
	        403: bo_g1,
	        138: bo_d9,
	        139: bo_e9,
	        140: bo_f9,
	        141: bo_x37,
	        142: bo_y37,
	        182: bo_g9,
	        183: bo_h9,
	        184: bo_i9,
	        185: bo_z37,
	        186: bo_a38,
	        366: bo_k43,
	        367: bo_l43,
	        368: bo_m43,
	        369: bo_n43,
	        370: bo_o43,
	        566: bo_m9,
	        567: bo_n9,
	        568: bo_o9,
	        569: bo_p43,
	        570: bo_q43,
	        74: bo_r43,
	        923: bo_s43,
	        924: bo_t43,
	        925: bo_u43,
	        926: bo_v43,
	        927: bo_w43,
	        929: bo_s43,
	        930: bo_t43,
	        931: bo_u43,
	        932: bo_v43,
	        933: bo_w43,
	        845: bo_t9,
	        846: bo_u9,
	        847: bo_v9,
	        848: bo_x43,
	        849: bo_y43,
	        918: bo_w9,
	        919: bo_x9,
	        920: bo_y9,
	        921: bo_z43,
	        922: bo_a44,
	        83: bo_z9,
	        84: bo_a10,
	        85: bo_b10,
	        86: bo_p37,
	        87: bo_q37,
	        905: bo_b44,
	        906: bo_d10,
	        907: bo_e10,
	        908: bo_c44,
	        909: bo_d44,
	        807: bo_e44,
	        319: bo_f44,
	        320: bo_m41,
	        912: bo_j10,
	        913: bo_k10,
	        914: bo_l10,
	        915: bo_g44,
	        916: bo_h44,
	        443: bo_h1,
	        608: bo_i1,
	        257: bo_d1,
	        307: bo_e1,
	        362: bo_q2,
	        363: bo_r2,
	        364: bo_s2,
	        365: bo_i44,
	        17: bo_t2,
	        18: bo_u2,
	        19: bo_v2,
	        20: bo_j44,
	        176: bo_w2,
	        177: bo_x2,
	        178: bo_y2,
	        179: bo_k44,
	        358: bo_z2,
	        359: bo_a3,
	        360: bo_b3,
	        361: bo_l44,
	        13: bo_c3,
	        14: bo_d3,
	        15: bo_e3,
	        16: bo_m44,
	        172: bo_f3,
	        173: bo_g3,
	        174: bo_h3,
	        175: bo_n44,
	        281: bo_e6,
	        137: bo_f6,
	        616: bo_o44,
	        617: bo_p44,
	        618: bo_q44,
	        619: bo_r44,
	        620: bo_s44,
	        891: bo_t44,
	        26: bo_u44,
	        200: bo_v44,
	        143: bo_w44,
	        187: bo_x44,
	        371: bo_y44,
	        571: bo_z44,
	        928: bo_a45,
	        934: bo_a45,
	        88: bo_b45,
	        910: bo_c45,
	        917: bo_d45,
	        936: bo_e45
	    },
	    8: {
	        74: bo_b1,
	        349: bo_j1,
	        656: bo_n3,
	        698: bo_g1,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_a4,
	        196: bo_b4,
	        197: bo_c4,
	        198: bo_d4,
	        673: bo_e4,
	        674: bo_f4,
	        675: bo_g4,
	        676: bo_h4,
	        103: bo_s1,
	        443: bo_h1,
	        608: bo_i1
	    },
	    27: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    28: {
	        403: bo_g1,
	        615: bo_f45,
	        74: bo_g45,
	        349: bo_c1,
	        256: bo_d1,
	        306: bo_e1,
	        103: bo_f1,
	        935: bo_h45,
	        612: bo_i45,
	        613: bo_j45,
	        443: bo_h1,
	        608: bo_i1
	    }
	};
	
	var outcomeConfig = {
	    7: {
	        426: function _(match, outcome) {
	            return match.homeTeam + " to win by " + outcome.condition + " " + plural(outcome.condition, ['goal', 'goals']);
	        },
	        535: function _(match, outcome) {
	            return match.awayTeam + " to win by " + outcome.condition + " " + plural(outcome.condition, ['goal', 'goals']);
	        }
	    },
	    6: {
	        455: function _(match, outcome) {
	            return "To Be 15x15 In " + outcome.condition + " game?";
	        },
	        456: function _(match, outcome) {
	            return "To Be 15x15 In " + outcome.condition + " game?";
	        },
	        457: function _(match, outcome) {
	            return "To Be 30x30 In " + outcome.condition + " game?";
	        },
	        458: function _(match, outcome) {
	            return "To Be 30x30 In " + outcome.condition + " game?";
	        },
	        459: function _(match, outcome) {
	            return "To Be 40x40 In " + outcome.condition + " game?";
	        },
	        460: function _(match, outcome) {
	            return "To Be 40x40 In " + outcome.condition + " game?";
	        }
	    }
	};
	
	var baseFactorNameConfig = {
	    11: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        403: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    32: {
	        73: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        318: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        352: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        748: {
	            1: fa_n1,
	            2: fa_o1,
	            3: fa_p1,
	            4: fa_q1,
	            5: fa_r1,
	            6: fa_s1,
	            7: fa_t1,
	            8: fa_u1,
	            9: fa_v1,
	            10: fa_w1
	        },
	        102: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        366: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        367: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        368: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        122: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        123: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        124: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        129: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        130: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        131: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        566: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        567: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        568: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        616: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        617: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        618: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        257: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        307: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        362: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        363: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        364: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        17: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        18: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        19: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        176: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        177: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        178: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        358: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        359: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        360: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        13: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        14: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        15: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        172: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        173: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        174: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        }
	    },
	    35: {
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        673: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        698: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        731: {
	            1: fa_h1,
	            2: fa_a2,
	            3: fa_i1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        911: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2,
	            4: fa_h2,
	            5: fa_i2,
	            6: fa_j2
	        },
	        426: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        535: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        871: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        710: {
	            1: fa_q2,
	            2: fa_r2,
	            3: fa_s2
	        },
	        742: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_v2,
	            6: fa_w2,
	            7: fa_x2,
	            8: fa_y2,
	            9: fa_p1,
	            10: fa_q1,
	            11: fa_z2,
	            12: fa_a3,
	            13: fa_r1,
	            14: fa_s1,
	            15: fa_b3,
	            16: fa_t1,
	            17: fa_c3,
	            18: fa_d3,
	            19: fa_e3,
	            20: fa_u1,
	            21: fa_v1,
	            22: fa_w1,
	            23: fa_f3,
	            24: fa_g3,
	            25: fa_h3,
	            26: fa_i3,
	            27: fa_j3,
	            28: fa_k3,
	            29: fa_l3,
	            30: fa_m3,
	            31: fa_n3,
	            32: fa_o3,
	            33: fa_p3,
	            34: fa_q3,
	            35: fa_r3
	        }
	    },
	    10: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        1: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    31: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        24: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        674: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        675: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        676: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        141: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        185: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        238: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        682: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        239: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        58: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        59: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        681: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        234: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        235: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        236: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        237: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        725: {
	            1: fa_h1,
	            2: fa_a2,
	            3: fa_i1
	        },
	        726: {
	            1: fa_h1,
	            2: fa_a2,
	            3: fa_i1
	        },
	        727: {
	            1: fa_h1,
	            2: fa_a2,
	            3: fa_i1
	        },
	        728: {
	            1: fa_h1,
	            2: fa_a2,
	            3: fa_i1
	        },
	        782: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        778: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        779: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        780: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        781: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        783: {
	            1: fa_p1,
	            2: fa_h3,
	            3: fa_y3,
	            4: fa_z3,
	            5: fa_a4,
	            6: fa_b4,
	            7: fa_c4,
	            8: fa_y1
	        },
	        773: {
	            1: fa_p1,
	            2: fa_h3,
	            3: fa_y3,
	            4: fa_z3,
	            5: fa_a4,
	            6: fa_b4,
	            7: fa_c4,
	            8: fa_x1
	        },
	        474: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        421: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        530: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        422: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        531: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        444: {
	            1: fa_d4,
	            2: fa_e4
	        },
	        888: {
	            1: fa_f4,
	            2: fa_g4,
	            3: fa_h4,
	            4: fa_i4
	        },
	        280: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        317: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        424: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        533: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        423: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        532: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        637: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        788: {
	            1: fa_j4,
	            2: fa_k4,
	            3: fa_l4,
	            4: fa_m4,
	            5: fa_n4,
	            6: fa_o4,
	            7: fa_p4,
	            8: fa_q4,
	            9: fa_r4,
	            10: fa_s4,
	            11: fa_t4,
	            12: fa_u4,
	            13: fa_v4,
	            14: fa_w4
	        },
	        784: {
	            1: fa_j4,
	            2: fa_x4,
	            3: fa_y4,
	            4: fa_z4,
	            5: fa_a5
	        },
	        785: {
	            1: fa_j4,
	            2: fa_x4,
	            3: fa_y4,
	            4: fa_z4,
	            5: fa_a5
	        },
	        786: {
	            1: fa_j4,
	            2: fa_x4,
	            3: fa_y4,
	            4: fa_z4,
	            5: fa_a5
	        },
	        787: {
	            1: fa_j4,
	            2: fa_x4,
	            3: fa_y4,
	            4: fa_z4,
	            5: fa_a5
	        },
	        774: {
	            1: fa_q4,
	            2: fa_b5,
	            3: fa_c5,
	            4: fa_d5,
	            5: fa_e5
	        },
	        775: {
	            1: fa_q4,
	            2: fa_b5,
	            3: fa_c5,
	            4: fa_d5,
	            5: fa_e5
	        },
	        776: {
	            1: fa_q4,
	            2: fa_b5,
	            3: fa_c5,
	            4: fa_d5,
	            5: fa_e5
	        },
	        777: {
	            1: fa_q4,
	            2: fa_b5,
	            3: fa_c5,
	            4: fa_d5,
	            5: fa_e5
	        },
	        281: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        137: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        246: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        248: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        240: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        232: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        241: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        233: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        61: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        62: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        684: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        685: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        890: {
	            1: fa_f4,
	            2: fa_g4,
	            3: fa_h4,
	            4: fa_i4
	        },
	        242: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        245: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        243: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        60: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        683: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        406: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        405: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        404: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        700: {
	            1: fa_f5,
	            2: fa_g5,
	            3: fa_h5
	        },
	        408: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        407: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        247: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        244: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        638: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        639: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        640: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        641: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        646: {
	            1: fa_i5,
	            2: fa_j5,
	            3: fa_k5
	        },
	        642: {
	            1: fa_i5,
	            2: fa_j5,
	            3: fa_k5
	        },
	        643: {
	            1: fa_i5,
	            2: fa_j5,
	            3: fa_k5
	        },
	        644: {
	            1: fa_i5,
	            2: fa_j5,
	            3: fa_k5
	        },
	        645: {
	            1: fa_i5,
	            2: fa_j5,
	            3: fa_k5
	        }
	    },
	    41: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        673: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        674: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        791: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        792: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        637: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        796: {
	            1: fa_j4,
	            2: fa_k4,
	            3: fa_l4,
	            4: fa_m4,
	            5: fa_n4,
	            6: fa_o4,
	            7: fa_p4,
	            8: fa_q4,
	            9: fa_r4,
	            10: fa_s4,
	            11: fa_t4,
	            12: fa_u4,
	            13: fa_v4,
	            14: fa_w4
	        },
	        794: {
	            1: fa_j4,
	            2: fa_x4,
	            3: fa_y4,
	            4: fa_z4,
	            5: fa_a5
	        },
	        795: {
	            1: fa_j4,
	            2: fa_x4,
	            3: fa_y4,
	            4: fa_z4,
	            5: fa_a5
	        },
	        789: {
	            1: fa_q4,
	            2: fa_b5,
	            3: fa_c5,
	            4: fa_d5,
	            5: fa_e5
	        },
	        790: {
	            1: fa_q4,
	            2: fa_b5,
	            3: fa_c5,
	            4: fa_d5,
	            5: fa_e5
	        },
	        725: {
	            1: fa_h1,
	            2: fa_a2,
	            3: fa_i1
	        },
	        726: {
	            1: fa_h1,
	            2: fa_a2,
	            3: fa_i1
	        },
	        793: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        411: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        701: {
	            1: fa_d4,
	            2: fa_e4,
	            3: fa_l5
	        },
	        251: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        252: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        409: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        430: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        410: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        431: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        281: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        137: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        249: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        250: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        63: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        64: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        686: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        687: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        648: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        649: {
	            1: fa_h1,
	            2: fa_i1
	        }
	    },
	    18: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        698: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        674: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        675: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        610: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        806: {
	            1: fa_m5,
	            2: fa_n5,
	            3: fa_o5,
	            4: fa_p5,
	            5: fa_q5,
	            6: fa_a5
	        },
	        893: {
	            1: fa_r5,
	            2: fa_s5,
	            3: fa_t5,
	            4: fa_u5,
	            5: fa_v5,
	            6: fa_w5
	        },
	        707: {
	            1: fa_q2,
	            2: fa_r2,
	            3: fa_l5
	        },
	        708: {
	            1: fa_q2,
	            2: fa_r2,
	            3: fa_l5
	        },
	        709: {
	            1: fa_q2,
	            2: fa_r2,
	            3: fa_l5
	        },
	        889: {
	            1: fa_x5,
	            2: fa_m2,
	            3: fa_n2,
	            4: fa_o2,
	            5: fa_y5,
	            6: fa_z5,
	            7: fa_a6,
	            8: fa_b6
	        },
	        904: {
	            1: fa_c6,
	            2: fa_d6,
	            3: fa_e6,
	            4: fa_f6,
	            5: fa_g6,
	            6: fa_h6,
	            7: fa_i6,
	            8: fa_j6,
	            9: fa_k6
	        },
	        253: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        688: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        65: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        751: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_v2,
	            6: fa_w2,
	            7: fa_x2,
	            8: fa_y2,
	            9: fa_p1,
	            10: fa_q1,
	            11: fa_z2,
	            12: fa_a3,
	            13: fa_r1,
	            14: fa_s1,
	            15: fa_b3,
	            16: fa_t1,
	            17: fa_c3,
	            18: fa_d3,
	            19: fa_e3,
	            20: fa_u1,
	            21: fa_v1,
	            22: fa_w1,
	            23: fa_f3,
	            24: fa_g3,
	            25: fa_h3,
	            26: fa_i3,
	            27: fa_j3,
	            28: fa_k3,
	            29: fa_l3,
	            30: fa_m3,
	            31: fa_n3,
	            32: fa_o3,
	            33: fa_p3,
	            34: fa_q3,
	            35: fa_r3
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        743: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_r3
	        },
	        744: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_r3
	        },
	        745: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_r3
	        },
	        615: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        350: {
	            1: fa_d1,
	            2: fa_e1
	        }
	    },
	    3: {
	        73: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        318: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        352: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        746: {
	            1: fa_r1,
	            2: fa_s1,
	            3: fa_p1,
	            4: fa_n1
	        },
	        102: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        366: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        367: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        368: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        566: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        567: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        568: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        854: {
	            1: fa_s3,
	            2: fa_l6,
	            3: fa_m6,
	            4: fa_n6,
	            5: fa_o6,
	            6: fa_p6,
	            7: fa_q6,
	            8: fa_r6
	        },
	        855: {
	            1: fa_s3,
	            2: fa_l6,
	            3: fa_m6,
	            4: fa_n6,
	            5: fa_o6,
	            6: fa_p6,
	            7: fa_q6,
	            8: fa_r6
	        },
	        856: {
	            1: fa_s3,
	            2: fa_l6,
	            3: fa_m6,
	            4: fa_n6,
	            5: fa_o6,
	            6: fa_p6,
	            7: fa_q6,
	            8: fa_r6
	        },
	        857: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_r6
	        },
	        858: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_r6
	        },
	        859: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_r6
	        },
	        797: {
	            1: fa_t1,
	            2: fa_s6,
	            3: fa_t6,
	            4: fa_y1
	        },
	        798: {
	            1: fa_t1,
	            2: fa_s6,
	            3: fa_t6,
	            4: fa_y1
	        },
	        799: {
	            1: fa_t1,
	            2: fa_s6,
	            3: fa_u6,
	            4: fa_y1
	        },
	        851: {
	            1: fa_t1,
	            2: fa_s6,
	            3: fa_u6,
	            4: fa_x1
	        },
	        852: {
	            1: fa_t1,
	            2: fa_s6,
	            3: fa_u6,
	            4: fa_x1
	        },
	        853: {
	            1: fa_t1,
	            2: fa_s6,
	            3: fa_v6,
	            4: fa_x1
	        },
	        83: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        84: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        85: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        905: {
	            1: fa_w6,
	            2: fa_x6,
	            3: fa_y6,
	            4: fa_z6
	        },
	        906: {
	            1: fa_w6,
	            2: fa_x6,
	            3: fa_y6,
	            4: fa_z6
	        },
	        907: {
	            1: fa_w6,
	            2: fa_x6,
	            3: fa_y6,
	            4: fa_z6
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        362: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        363: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        17: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        18: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        176: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        177: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        358: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        359: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        13: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        14: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        172: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        173: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        616: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        617: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        618: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        891: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2,
	            4: fa_h2
	        },
	        257: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        307: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        800: {
	            1: fa_a7,
	            2: fa_b7,
	            3: fa_c7,
	            4: fa_d7,
	            5: fa_e7,
	            6: fa_f7
	        },
	        801: {
	            1: fa_a7,
	            2: fa_b7,
	            3: fa_c7,
	            4: fa_d7,
	            5: fa_e7,
	            6: fa_f7
	        },
	        802: {
	            1: fa_a7,
	            2: fa_b7,
	            3: fa_c7,
	            4: fa_d7,
	            5: fa_e7,
	            6: fa_f7
	        }
	    },
	    20: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        698: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        199: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        200: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        201: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        202: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        141: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        142: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        143: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        144: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        145: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        185: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        186: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        187: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        188: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        189: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        24: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        25: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        26: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        27: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        28: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        673: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        674: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        675: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        676: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        677: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        678: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        679: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        680: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        860: {
	            1: fa_g7,
	            2: fa_l6,
	            3: fa_m6,
	            4: fa_n6,
	            5: fa_o6,
	            6: fa_p6,
	            7: fa_h7
	        },
	        861: {
	            1: fa_g7,
	            2: fa_l6,
	            3: fa_m6,
	            4: fa_n6,
	            5: fa_o6,
	            6: fa_p6,
	            7: fa_h7
	        },
	        862: {
	            1: fa_g7,
	            2: fa_l6,
	            3: fa_m6,
	            4: fa_n6,
	            5: fa_o6,
	            6: fa_p6,
	            7: fa_h7
	        },
	        863: {
	            1: fa_g7,
	            2: fa_l6,
	            3: fa_m6,
	            4: fa_n6,
	            5: fa_o6,
	            6: fa_p6,
	            7: fa_h7
	        },
	        864: {
	            1: fa_g7,
	            2: fa_l6,
	            3: fa_m6,
	            4: fa_n6,
	            5: fa_o6,
	            6: fa_p6,
	            7: fa_h7
	        },
	        865: {
	            1: fa_g7,
	            2: fa_l6,
	            3: fa_m6,
	            4: fa_n6,
	            5: fa_o6,
	            6: fa_p6,
	            7: fa_h7
	        },
	        866: {
	            1: fa_g7,
	            2: fa_l6,
	            3: fa_m6,
	            4: fa_n6,
	            5: fa_o6,
	            6: fa_p6,
	            7: fa_h7
	        },
	        867: {
	            1: fa_g7,
	            2: fa_l6,
	            3: fa_m6,
	            4: fa_n6,
	            5: fa_o6,
	            6: fa_p6,
	            7: fa_h7
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    5: {
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        698: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        945: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        948: {
	            1: fa_i7,
	            2: fa_j7,
	            3: fa_k7,
	            4: fa_l7,
	            5: fa_m7
	        },
	        949: {
	            1: fa_n7,
	            2: fa_o7,
	            3: fa_p7,
	            4: fa_q7,
	            5: fa_r7,
	            6: fa_s7,
	            7: fa_t7,
	            8: fa_u7,
	            9: fa_v7,
	            10: fa_w7,
	            11: fa_x7,
	            12: fa_y7,
	            13: fa_j7,
	            14: fa_k7,
	            15: fa_z7,
	            16: fa_a8,
	            17: fa_b8,
	            18: fa_c8,
	            19: fa_d8,
	            20: fa_e8,
	            21: fa_f8,
	            22: fa_g8,
	            23: fa_h8,
	            24: fa_i8,
	            25: fa_j8,
	            26: fa_k8,
	            27: fa_m7
	        }
	    },
	    40: {
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        698: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    37: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    38: {
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        74: {
	            1: fa_l8,
	            2: fa_m8
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        615: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        413: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        414: {
	            1: fa_h1,
	            2: fa_i1
	        }
	    },
	    42: {
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        443: {
	            1: fa_n8,
	            2: fa_o8
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        74: {
	            1: fa_l8,
	            2: fa_m8
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        615: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        413: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        414: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        566: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        567: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        568: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        569: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        570: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        698: {
	            1: fa_h1,
	            2: fa_p8,
	            3: fa_i1
	        },
	        366: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        367: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        368: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        369: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        370: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        940: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        941: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        942: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        943: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        944: {
	            1: fa_h1,
	            2: fa_i1
	        }
	    },
	    26: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    25: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    16: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    12: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        698: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    36: {
	        610: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        698: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        615: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    7: {
	        425: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        534: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        540: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        343: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        345: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        260: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        261: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        83: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        84: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        803: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        868: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        869: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        870: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        805: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        892: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        346: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        419: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        528: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        420: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        529: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        707: {
	            1: fa_q2,
	            2: fa_q8,
	            3: fa_l5
	        },
	        708: {
	            1: fa_q2,
	            2: fa_q8,
	            3: fa_l5
	        },
	        706: {
	            1: fa_r8,
	            2: fa_s8,
	            3: fa_l5
	        },
	        804: {
	            1: fa_t8,
	            2: fa_u8,
	            3: fa_v8,
	            4: fa_w8
	        },
	        474: {
	            1: fa_x8,
	            2: fa_y8
	        },
	        614: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        609: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        416: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        732: {
	            1: fa_h1,
	            2: fa_z8,
	            3: fa_i1
	        },
	        525: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        850: {
	            1: fa_a9,
	            2: fa_b9,
	            3: fa_c9,
	            4: fa_d9
	        },
	        473: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        442: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        729: {
	            1: fa_h1,
	            2: fa_l5,
	            3: fa_i1
	        },
	        538: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        542: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        730: {
	            1: fa_h1,
	            2: fa_s2,
	            3: fa_i1
	        },
	        471: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        635: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        714: {
	            1: fa_e9,
	            2: fa_s2,
	            3: fa_f9
	        },
	        624: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        625: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        715: {
	            1: fa_g9,
	            2: fa_h9,
	            3: fa_s2
	        },
	        650: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        651: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        652: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        653: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        654: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        655: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        634: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        626: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        733: {
	            1: fa_i9,
	            2: fa_j9,
	            3: fa_k9
	        },
	        734: {
	            1: fa_i9,
	            2: fa_j9,
	            3: fa_k9
	        },
	        258: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        259: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        66: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        67: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        81: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        68: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        689: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        690: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        699: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        691: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        723: {
	            1: fa_h1,
	            2: fa_l9,
	            3: fa_i1
	        },
	        633: {
	            1: fa_m1,
	            2: fa_l1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        698: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        322: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        904: {
	            1: fa_m9,
	            2: fa_n9,
	            3: fa_o9,
	            4: fa_p9,
	            5: fa_g6,
	            6: fa_q9,
	            7: fa_r9,
	            8: fa_s9,
	            9: fa_t9
	        },
	        1: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        136: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        747: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_v2,
	            6: fa_w2,
	            7: fa_u9,
	            8: fa_x2,
	            9: fa_y2,
	            10: fa_p1,
	            11: fa_q1,
	            12: fa_z2,
	            13: fa_a3,
	            14: fa_v9,
	            15: fa_r1,
	            16: fa_s1,
	            17: fa_b3,
	            18: fa_t1,
	            19: fa_c3,
	            20: fa_u1,
	            21: fa_v1,
	            22: fa_w1,
	            23: fa_f3,
	            24: fa_i3,
	            25: fa_j3,
	            26: fa_k3,
	            27: fa_n3,
	            28: fa_o3,
	            29: fa_w9,
	            30: fa_x9,
	            31: fa_r3
	        },
	        871: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        255: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        705: {
	            1: fa_y9,
	            2: fa_z9,
	            3: fa_a10
	        },
	        323: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        324: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        702: {
	            1: fa_e9,
	            2: fa_s2,
	            3: fa_f9
	        },
	        278: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        282: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        911: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2,
	            4: fa_h2,
	            5: fa_i2,
	            6: fa_j2
	        },
	        353: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        674: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        2: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        5: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        7: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        939: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        9: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        12: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        417: {
	            1: fa_m1,
	            2: fa_l1
	        },
	        526: {
	            1: fa_m1,
	            2: fa_l1
	        },
	        325: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        160: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        163: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        165: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        166: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        168: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        171: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        148: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        149: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        150: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        151: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        152: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        153: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        154: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        155: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        156: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        157: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        158: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        159: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        731: {
	            1: fa_h1,
	            2: fa_b10,
	            3: fa_i1
	        },
	        765: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        766: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        415: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        524: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        418: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        527: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        743: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_r3
	        },
	        744: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_r3
	        },
	        710: {
	            1: fa_q2,
	            2: fa_r2,
	            3: fa_s2
	        },
	        321: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        326: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        327: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        724: {
	            1: fa_h9,
	            2: fa_c10,
	            3: fa_g9
	        },
	        661: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        664: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        666: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        667: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        669: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        672: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        426: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        535: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        537: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        541: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        539: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        437: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        436: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        694: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        71: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        271: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        268: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        265: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        267: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        270: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        272: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        269: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        266: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        264: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        281: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        137: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        660: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        880: {
	            1: fa_d10,
	            2: fa_e10,
	            3: fa_f10,
	            4: fa_g10
	        },
	        879: {
	            1: fa_h10,
	            2: fa_i10,
	            3: fa_j10,
	            4: fa_k10
	        },
	        429: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        433: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        881: {
	            1: fa_l10,
	            2: fa_m10,
	            3: fa_n10,
	            4: fa_o10,
	            5: fa_p10,
	            6: fa_q10
	        },
	        273: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        274: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        435: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        704: {
	            1: fa_g9,
	            2: fa_r10,
	            3: fa_h9
	        },
	        432: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        428: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        434: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        439: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        440: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        441: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        438: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        623: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        180: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        146: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        659: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        749: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_s10
	        },
	        69: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        262: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        692: {
	            1: fa_x1,
	            2: fa_p8,
	            3: fa_y1
	        },
	        703: {
	            1: fa_h1,
	            2: fa_b10,
	            3: fa_i1
	        },
	        70: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        263: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        693: {
	            1: fa_t10,
	            2: fa_z1,
	            3: fa_u10
	        },
	        72: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        277: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        695: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        750: {
	            1: fa_x2,
	            2: fa_r1,
	            3: fa_u1,
	            4: fa_s1,
	            5: fa_v1,
	            6: fa_w1,
	            7: fa_j3,
	            8: fa_k3,
	            9: fa_l3,
	            10: fa_q3,
	            11: fa_v10,
	            12: fa_w10,
	            13: fa_u2,
	            14: fa_n1,
	            15: fa_o1,
	            16: fa_p1,
	            17: fa_q1,
	            18: fa_t1,
	            19: fa_z2,
	            20: fa_c3,
	            21: fa_g3,
	            22: fa_h3,
	            23: fa_x10,
	            24: fa_y10
	        },
	        181: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        147: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        276: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        275: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        735: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        736: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        737: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        738: {
	            1: fa_h1,
	            2: fa_b10,
	            3: fa_i1
	        },
	        739: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        740: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        356: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        357: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        354: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        355: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        937: {
	            1: fa_z10,
	            2: fa_a11,
	            3: fa_b11,
	            4: fa_c11,
	            5: fa_d11,
	            6: fa_e11,
	            7: fa_f11,
	            8: fa_g11,
	            9: fa_h11,
	            10: fa_b10
	        },
	        657: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        658: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        412: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    14: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    34: {
	        425: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        534: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        540: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        343: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        345: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        260: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        261: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        83: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        84: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        803: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_i11
	        },
	        868: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_i11
	        },
	        869: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_i11
	        },
	        870: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_i11
	        },
	        346: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        419: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        528: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        420: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        529: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        707: {
	            1: fa_q2,
	            2: fa_q8,
	            3: fa_j11
	        },
	        708: {
	            1: fa_q2,
	            2: fa_q8,
	            3: fa_j11
	        },
	        706: {
	            1: fa_k11,
	            2: fa_s8,
	            3: fa_l5
	        },
	        538: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        698: {
	            1: fa_l11,
	            2: fa_z1,
	            3: fa_m11
	        },
	        322: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        904: {
	            1: fa_m9,
	            2: fa_n9,
	            3: fa_o9,
	            4: fa_p9,
	            5: fa_g6,
	            6: fa_q9,
	            7: fa_r9,
	            8: fa_s9,
	            9: fa_r9
	        },
	        1: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        136: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        747: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_v2,
	            6: fa_w2,
	            7: fa_u9,
	            8: fa_x2,
	            9: fa_y2,
	            10: fa_p1,
	            11: fa_q1,
	            12: fa_z2,
	            13: fa_a3,
	            14: fa_v9,
	            15: fa_r1,
	            16: fa_s1,
	            17: fa_b3,
	            18: fa_t1,
	            19: fa_c3,
	            20: fa_u1,
	            21: fa_v1,
	            22: fa_w1,
	            23: fa_f3,
	            24: fa_i3,
	            25: fa_j3,
	            26: fa_k3,
	            27: fa_n3,
	            28: fa_o3,
	            29: fa_w9,
	            30: fa_x9,
	            31: fa_r3
	        },
	        871: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        255: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        705: {
	            1: fa_y9,
	            2: fa_z9,
	            3: fa_a10
	        },
	        323: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        324: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        702: {
	            1: fa_e9,
	            2: fa_s2,
	            3: fa_f9
	        },
	        278: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        282: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        911: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2,
	            4: fa_h2,
	            5: fa_i2,
	            6: fa_j2
	        },
	        353: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        674: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        2: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        5: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        7: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        939: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        9: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        12: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        417: {
	            1: fa_n11,
	            2: fa_k9
	        },
	        526: {
	            1: fa_n11,
	            2: fa_k9
	        },
	        325: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        160: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        163: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        165: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        166: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        168: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        171: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        148: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        149: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        150: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        151: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        152: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        153: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        154: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        155: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        156: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        157: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        158: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        159: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        731: {
	            1: fa_h1,
	            2: fa_b10,
	            3: fa_i1
	        },
	        765: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        766: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        415: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        524: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        418: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        527: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        743: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_r3
	        },
	        744: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_r3
	        },
	        710: {
	            1: fa_q2,
	            2: fa_r2,
	            3: fa_l9
	        },
	        321: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        326: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        327: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        724: {
	            1: fa_o11,
	            2: fa_p11,
	            3: fa_q11
	        },
	        661: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        664: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        666: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        667: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        669: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        672: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        426: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        535: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        537: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        541: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        539: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    19: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        698: {
	            1: fa_l11,
	            2: fa_z1,
	            3: fa_m11
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        615: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        886: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        887: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        911: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2,
	            4: fa_h2,
	            5: fa_i2,
	            6: fa_j2
	        },
	        884: {
	            1: fa_r11,
	            2: fa_s11,
	            3: fa_t11,
	            4: fa_u11,
	            5: fa_a5
	        },
	        885: {
	            1: fa_r11,
	            2: fa_s11,
	            3: fa_t11,
	            4: fa_u11,
	            5: fa_v11
	        },
	        882: {
	            1: fa_r11,
	            2: fa_s11,
	            3: fa_t11,
	            4: fa_u11,
	            5: fa_e5
	        },
	        883: {
	            1: fa_r11,
	            2: fa_s11,
	            3: fa_t11,
	            4: fa_u11,
	            5: fa_w11
	        },
	        723: {
	            1: fa_h1,
	            2: fa_x11,
	            3: fa_i1
	        },
	        673: {
	            1: fa_l11,
	            2: fa_z1,
	            3: fa_m11
	        },
	        674: {
	            1: fa_l11,
	            2: fa_z1,
	            3: fa_m11
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    30: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        698: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        279: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        610: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        674: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        675: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        350: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        415: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        524: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        743: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_r3
	        },
	        744: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_r3
	        },
	        745: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_r3
	        },
	        710: {
	            1: fa_q2,
	            2: fa_y11,
	            3: fa_s2
	        },
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        426: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        535: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        706: {
	            1: fa_r8,
	            2: fa_s8,
	            3: fa_l5
	        },
	        343: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        346: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        83: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        84: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        85: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        344: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        347: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        765: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_z11
	        },
	        766: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_z11
	        },
	        767: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_z11
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        751: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_v2,
	            6: fa_w2,
	            7: fa_x2,
	            8: fa_y2,
	            9: fa_p1,
	            10: fa_q1,
	            11: fa_z2,
	            12: fa_a3,
	            13: fa_r1,
	            14: fa_s1,
	            15: fa_b3,
	            16: fa_t1,
	            17: fa_c3,
	            18: fa_d3,
	            19: fa_e3,
	            20: fa_u1,
	            21: fa_v1,
	            22: fa_w1,
	            23: fa_f3,
	            24: fa_g3,
	            25: fa_h3,
	            26: fa_i3,
	            27: fa_j3,
	            28: fa_k3,
	            29: fa_l3,
	            30: fa_m3,
	            31: fa_n3,
	            32: fa_o3,
	            33: fa_p3,
	            34: fa_q3,
	            35: fa_r3
	        },
	        911: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2,
	            4: fa_h2,
	            5: fa_i2,
	            6: fa_j2
	        },
	        889: {
	            1: fa_x5,
	            2: fa_m2,
	            3: fa_n2,
	            4: fa_o2,
	            5: fa_y5,
	            6: fa_z5,
	            7: fa_a6,
	            8: fa_b6
	        },
	        637: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        615: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        412: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        634: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        626: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        611: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        904: {
	            1: fa_c6,
	            2: fa_d6,
	            3: fa_e6,
	            4: fa_f6,
	            5: fa_g6,
	            6: fa_h6,
	            7: fa_i6,
	            8: fa_j6,
	            9: fa_k6
	        },
	        449: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        446: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        451: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        711: {
	            1: fa_a12,
	            2: fa_b12,
	            3: fa_c12
	        },
	        712: {
	            1: fa_d12,
	            2: fa_e12,
	            3: fa_f12
	        },
	        713: {
	            1: fa_g12,
	            2: fa_h12,
	            3: fa_i12
	        },
	        450: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        447: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        448: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        662: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        663: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        665: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        668: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        670: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        671: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        3: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        4: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        6: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        8: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        10: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        11: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        161: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        162: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        164: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        167: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        169: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        170: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        707: {
	            1: fa_q2,
	            2: fa_r2,
	            3: fa_l5
	        },
	        708: {
	            1: fa_q2,
	            2: fa_r2,
	            3: fa_l5
	        },
	        709: {
	            1: fa_q2,
	            2: fa_r2,
	            3: fa_l5
	        },
	        946: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        947: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    23: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    13: {
	        468: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        470: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        467: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        469: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        464: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        466: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        465: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        463: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        289: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        288: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        292: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        461: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        283: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        295: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        293: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        284: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        285: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        316: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        286: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        287: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        290: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        291: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        462: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        294: {
	            1: fa_d1,
	            2: fa_e1
	        }
	    },
	    39: {
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        698: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        950: {
	            1: fa_n7,
	            2: fa_o7,
	            3: fa_p7,
	            4: fa_q7,
	            5: fa_r7,
	            6: fa_j7,
	            7: fa_k7,
	            8: fa_z7,
	            9: fa_a8,
	            10: fa_b8,
	            11: fa_c8,
	            12: fa_d8,
	            13: fa_m7
	        },
	        955: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        951: {
	            1: fa_j12,
	            2: fa_k12
	        },
	        952: {
	            1: fa_j12,
	            2: fa_k12
	        },
	        953: {
	            1: fa_j12,
	            2: fa_k12
	        },
	        954: {
	            1: fa_j12,
	            2: fa_k12
	        }
	    },
	    33: {
	        348: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    24: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    9: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        698: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        674: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    21: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    29: {
	        394: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        395: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        396: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        397: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        398: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        399: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        400: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        401: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        402: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        100: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        101: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        104: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        105: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        106: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        107: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        108: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        109: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        110: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        111: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        112: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        113: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        114: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        115: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        116: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        117: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        118: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        119: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        120: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        121: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        808: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        809: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        810: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        811: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        812: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        813: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        814: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        815: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        816: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        817: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        818: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        819: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        820: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        821: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        822: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        823: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        824: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        825: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        826: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        827: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        828: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        829: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        830: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        831: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        832: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        833: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        834: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        835: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        836: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        837: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        838: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        839: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        840: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        841: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        842: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        843: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        844: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12,
	            4: fa_o12,
	            5: fa_p12,
	            6: fa_q12
	        },
	        366: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        367: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        368: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        369: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        370: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        371: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        372: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        373: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        374: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        375: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        376: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        377: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        378: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        379: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        380: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        381: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        382: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        383: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        384: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        385: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        386: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        387: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        388: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        389: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        390: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        391: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        392: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        393: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        481: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        482: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        483: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        484: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        485: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        486: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        487: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        488: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        489: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        490: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        491: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        492: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        493: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        494: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        495: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        496: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        497: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        498: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        499: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        500: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        501: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        502: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        503: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        504: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        505: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        506: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        507: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        508: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        509: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        510: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        511: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        566: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        567: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        568: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        569: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        570: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        571: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        572: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        573: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        574: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        575: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        576: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        577: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        578: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        579: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        580: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        581: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        582: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        583: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        584: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        585: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        586: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        587: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        588: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        589: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        590: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        591: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        592: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        593: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        594: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        595: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        596: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        597: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        598: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        599: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        600: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        601: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        602: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        83: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        84: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        85: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        86: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        87: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        88: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        89: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        90: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        91: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        92: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        93: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        94: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        95: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        96: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        97: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        98: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        99: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        254: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        24: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        25: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        26: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        27: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        28: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        29: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        30: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        31: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        32: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        33: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        34: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        35: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        36: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        37: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        38: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        39: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        40: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        41: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        42: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        43: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        44: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        45: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        46: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        47: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        48: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        49: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        50: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        51: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        52: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        53: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        54: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        55: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        56: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        57: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        199: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        200: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        201: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        202: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        203: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        204: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        205: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        206: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        207: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        208: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        209: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        210: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        211: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        212: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        213: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        214: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        215: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        216: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        217: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        218: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        219: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        220: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        221: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        222: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        223: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        224: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        225: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        226: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        227: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        228: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        229: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        230: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        231: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        475: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        476: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        477: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        478: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        479: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        480: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    15: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    2: {
	        73: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        318: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        24: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        25: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        26: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        27: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        199: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        200: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        201: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        352: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        102: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        141: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        142: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        143: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        144: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        185: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        186: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        187: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        188: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        566: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        567: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        568: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        569: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        570: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        571: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        572: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        366: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        367: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        368: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        369: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        370: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        371: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        372: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        122: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        123: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        124: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        125: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        126: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        127: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        128: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        129: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        130: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        131: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        132: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        133: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        134: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        135: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        872: {
	            1: fa_s3,
	            2: fa_l6,
	            3: fa_m6,
	            4: fa_n6,
	            5: fa_o6,
	            6: fa_r12
	        },
	        873: {
	            1: fa_s3,
	            2: fa_l6,
	            3: fa_m6,
	            4: fa_n6,
	            5: fa_o6,
	            6: fa_r12
	        },
	        874: {
	            1: fa_s3,
	            2: fa_l6,
	            3: fa_m6,
	            4: fa_n6,
	            5: fa_o6,
	            6: fa_r12
	        },
	        875: {
	            1: fa_s3,
	            2: fa_l6,
	            3: fa_m6,
	            4: fa_n6,
	            5: fa_o6,
	            6: fa_r12
	        },
	        876: {
	            1: fa_s3,
	            2: fa_l6,
	            3: fa_m6,
	            4: fa_n6,
	            5: fa_o6,
	            6: fa_r12
	        },
	        877: {
	            1: fa_s3,
	            2: fa_l6,
	            3: fa_m6,
	            4: fa_n6,
	            5: fa_o6,
	            6: fa_r12
	        },
	        878: {
	            1: fa_s3,
	            2: fa_l6,
	            3: fa_m6,
	            4: fa_n6,
	            5: fa_o6,
	            6: fa_r12
	        },
	        616: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        617: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        618: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        619: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        620: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        621: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        622: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        894: {
	            1: fa_s12,
	            2: fa_t12,
	            3: fa_u12,
	            4: fa_v12
	        },
	        895: {
	            1: fa_s12,
	            2: fa_t12,
	            3: fa_u12,
	            4: fa_v12
	        },
	        896: {
	            1: fa_s12,
	            2: fa_t12,
	            3: fa_u12,
	            4: fa_v12
	        },
	        897: {
	            1: fa_s12,
	            2: fa_t12,
	            3: fa_u12,
	            4: fa_v12
	        },
	        898: {
	            1: fa_s12,
	            2: fa_t12,
	            3: fa_u12,
	            4: fa_v12
	        },
	        899: {
	            1: fa_s12,
	            2: fa_t12,
	            3: fa_u12,
	            4: fa_v12
	        },
	        900: {
	            1: fa_s12,
	            2: fa_t12,
	            3: fa_u12,
	            4: fa_v12
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        83: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        84: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        85: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        86: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        87: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        88: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        89: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        257: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        307: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        752: {
	            1: fa_u1,
	            2: fa_v1,
	            3: fa_w1,
	            4: fa_t1,
	            5: fa_q1,
	            6: fa_o1
	        },
	        753: {
	            1: fa_i3,
	            2: fa_j3,
	            3: fa_k3,
	            4: fa_l3,
	            5: fa_g3,
	            6: fa_c3,
	            7: fa_z2,
	            8: fa_v2
	        }
	    },
	    6: {
	        553: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        339: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        547: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        141: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        142: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        185: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        186: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        83: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        84: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        85: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        86: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        87: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        807: {
	            1: fa_c6,
	            2: fa_e6,
	            3: fa_i6,
	            4: fa_k6
	        },
	        636: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        334: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        335: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        336: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        337: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        906: {
	            1: fa_w6,
	            2: fa_x6,
	            3: fa_y6,
	            4: fa_z6
	        },
	        907: {
	            1: fa_w6,
	            2: fa_x6,
	            3: fa_y6,
	            4: fa_z6
	        },
	        908: {
	            1: fa_w6,
	            2: fa_x6,
	            3: fa_y6,
	            4: fa_z6
	        },
	        909: {
	            1: fa_w6,
	            2: fa_x6,
	            3: fa_y6,
	            4: fa_z6
	        },
	        300: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        301: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        302: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        303: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        304: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        310: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        311: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        312: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        313: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        314: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        554: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        555: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        556: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        557: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        558: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        517: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        518: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        519: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        520: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        521: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        561: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        562: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        563: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        564: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        565: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        73: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        318: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        24: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        25: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        199: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        352: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        748: {
	            1: fa_n1,
	            2: fa_o1,
	            3: fa_p1,
	            4: fa_q1,
	            5: fa_r1,
	            6: fa_s1,
	            7: fa_t1,
	            8: fa_u1,
	            9: fa_v1,
	            10: fa_w1
	        },
	        102: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        903: {
	            1: fa_w12,
	            2: fa_x12,
	            3: fa_y12,
	            4: fa_z12,
	            5: fa_a13,
	            6: fa_b13,
	            7: fa_c13,
	            8: fa_d13
	        },
	        445: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        754: {
	            1: fa_u9,
	            2: fa_v9,
	            3: fa_e3,
	            4: fa_e13,
	            5: fa_s6,
	            6: fa_f13,
	            7: fa_w9,
	            8: fa_x9,
	            9: fa_g13,
	            10: fa_h13,
	            11: fa_i13,
	            12: fa_j13,
	            13: fa_k13,
	            14: fa_l13
	        },
	        755: {
	            1: fa_u9,
	            2: fa_v9,
	            3: fa_e3,
	            4: fa_e13,
	            5: fa_s6,
	            6: fa_f13,
	            7: fa_w9,
	            8: fa_x9,
	            9: fa_g13,
	            10: fa_h13,
	            11: fa_i13,
	            12: fa_j13,
	            13: fa_k13,
	            14: fa_l13
	        },
	        756: {
	            1: fa_u9,
	            2: fa_v9,
	            3: fa_e3,
	            4: fa_e13,
	            5: fa_s6,
	            6: fa_f13,
	            7: fa_w9,
	            8: fa_x9,
	            9: fa_g13,
	            10: fa_h13,
	            11: fa_i13,
	            12: fa_j13,
	            13: fa_k13,
	            14: fa_l13
	        },
	        757: {
	            1: fa_u9,
	            2: fa_v9,
	            3: fa_e3,
	            4: fa_e13,
	            5: fa_s6,
	            6: fa_f13,
	            7: fa_w9,
	            8: fa_x9,
	            9: fa_g13,
	            10: fa_h13,
	            11: fa_i13,
	            12: fa_j13,
	            13: fa_k13,
	            14: fa_l13
	        },
	        758: {
	            1: fa_u9,
	            2: fa_v9,
	            3: fa_e3,
	            4: fa_e13,
	            5: fa_s6,
	            6: fa_f13,
	            7: fa_w9,
	            8: fa_x9,
	            9: fa_g13,
	            10: fa_h13,
	            11: fa_i13,
	            12: fa_j13,
	            13: fa_k13,
	            14: fa_l13
	        },
	        452: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        453: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        454: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        566: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        567: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        568: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        569: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        570: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        366: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        367: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        368: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        369: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        370: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        522: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        627: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        628: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        629: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        630: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        631: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        632: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        190: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        191: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        192: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        193: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        194: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        759: {
	            1: fa_m13,
	            2: fa_n13,
	            3: fa_o13,
	            4: fa_p13,
	            5: fa_q13,
	            6: fa_k13,
	            7: fa_r13,
	            8: fa_s13,
	            9: fa_t13,
	            10: fa_u13,
	            11: fa_v13,
	            12: fa_w13,
	            13: fa_f13,
	            14: fa_x13
	        },
	        760: {
	            1: fa_m13,
	            2: fa_n13,
	            3: fa_o13,
	            4: fa_p13,
	            5: fa_q13,
	            6: fa_k13,
	            7: fa_r13,
	            8: fa_s13,
	            9: fa_t13,
	            10: fa_u13,
	            11: fa_v13,
	            12: fa_w13,
	            13: fa_f13,
	            14: fa_x13
	        },
	        761: {
	            1: fa_m13,
	            2: fa_n13,
	            3: fa_o13,
	            4: fa_p13,
	            5: fa_q13,
	            6: fa_k13,
	            7: fa_r13,
	            8: fa_s13,
	            9: fa_t13,
	            10: fa_u13,
	            11: fa_v13,
	            12: fa_w13,
	            13: fa_f13,
	            14: fa_x13
	        },
	        762: {
	            1: fa_m13,
	            2: fa_n13,
	            3: fa_o13,
	            4: fa_p13,
	            5: fa_q13,
	            6: fa_k13,
	            7: fa_r13,
	            8: fa_s13,
	            9: fa_t13,
	            10: fa_u13,
	            11: fa_v13,
	            12: fa_w13,
	            13: fa_f13,
	            14: fa_x13
	        },
	        763: {
	            1: fa_m13,
	            2: fa_n13,
	            3: fa_o13,
	            4: fa_p13,
	            5: fa_q13,
	            6: fa_k13,
	            7: fa_r13,
	            8: fa_s13,
	            9: fa_t13,
	            10: fa_u13,
	            11: fa_v13,
	            12: fa_w13,
	            13: fa_f13,
	            14: fa_x13
	        },
	        768: {
	            1: fa_a6,
	            2: fa_y13,
	            3: fa_z13,
	            4: fa_a14,
	            5: fa_b14,
	            6: fa_c2,
	            7: fa_c14
	        },
	        769: {
	            1: fa_a6,
	            2: fa_y13,
	            3: fa_z13,
	            4: fa_a14,
	            5: fa_b14,
	            6: fa_c2,
	            7: fa_c14
	        },
	        770: {
	            1: fa_a6,
	            2: fa_y13,
	            3: fa_z13,
	            4: fa_a14,
	            5: fa_b14,
	            6: fa_c2,
	            7: fa_c14
	        },
	        771: {
	            1: fa_a6,
	            2: fa_y13,
	            3: fa_z13,
	            4: fa_a14,
	            5: fa_b14,
	            6: fa_c2,
	            7: fa_c14
	        },
	        772: {
	            1: fa_a6,
	            2: fa_y13,
	            3: fa_z13,
	            4: fa_a14,
	            5: fa_b14,
	            6: fa_c2,
	            7: fa_c14
	        },
	        603: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        604: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        605: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        606: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        607: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        257: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        307: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        696: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        333: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        341: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        427: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        536: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        905: {
	            1: fa_w6,
	            2: fa_x6,
	            3: fa_y6,
	            4: fa_z6
	        },
	        320: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        514: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        516: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        305: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        315: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        523: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        299: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        309: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        697: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        298: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        308: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        515: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        549: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        548: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        550: {
	            1: fa_d14,
	            2: fa_i1
	        },
	        551: {
	            1: fa_h1,
	            2: fa_e14
	        },
	        455: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        456: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        457: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        458: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        459: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        460: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        512: {
	            1: fa_d14,
	            2: fa_i1
	        },
	        513: {
	            1: fa_h1,
	            2: fa_e14
	        },
	        901: {
	            1: fa_f14,
	            2: fa_x12,
	            3: fa_y12,
	            4: fa_z12,
	            5: fa_g14,
	            6: fa_b13,
	            7: fa_c13,
	            8: fa_d13
	        },
	        902: {
	            1: fa_f14,
	            2: fa_x12,
	            3: fa_y12,
	            4: fa_z12,
	            5: fa_g14,
	            6: fa_b13,
	            7: fa_c13,
	            8: fa_d13
	        },
	        340: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        328: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        329: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        342: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        330: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        331: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        722: {
	            1: fa_h14,
	            2: fa_p11,
	            3: fa_i14
	        },
	        560: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        543: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        544: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        545: {
	            1: fa_j14,
	            2: fa_k14
	        },
	        546: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        332: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        559: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        296: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        297: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        717: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        718: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        719: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        720: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        721: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        552: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        76: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        77: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        78: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        79: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        80: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        647: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        741: {
	            1: fa_l14,
	            2: fa_k7,
	            3: fa_m14
	        },
	        82: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        338: {
	            1: fa_d1,
	            2: fa_e1
	        }
	    },
	    17: {
	        348: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    4: {
	        73: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        318: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        24: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        25: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        199: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        352: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        764: {
	            1: fa_o1,
	            2: fa_q1,
	            3: fa_t1,
	            4: fa_u1,
	            5: fa_v1,
	            6: fa_w1
	        },
	        102: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        141: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        142: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        185: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        186: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        366: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        367: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        368: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        369: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        370: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        566: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        567: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        568: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        569: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        570: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        923: {
	            1: fa_s3,
	            2: fa_l6,
	            3: fa_m6,
	            4: fa_n6,
	            5: fa_o6,
	            6: fa_p6,
	            7: fa_q6,
	            8: fa_r6
	        },
	        924: {
	            1: fa_s3,
	            2: fa_l6,
	            3: fa_m6,
	            4: fa_n6,
	            5: fa_o6,
	            6: fa_p6,
	            7: fa_q6,
	            8: fa_r6
	        },
	        925: {
	            1: fa_s3,
	            2: fa_l6,
	            3: fa_m6,
	            4: fa_n6,
	            5: fa_o6,
	            6: fa_p6,
	            7: fa_q6,
	            8: fa_r6
	        },
	        926: {
	            1: fa_s3,
	            2: fa_l6,
	            3: fa_m6,
	            4: fa_n6,
	            5: fa_o6,
	            6: fa_p6,
	            7: fa_q6,
	            8: fa_r6
	        },
	        927: {
	            1: fa_s3,
	            2: fa_l6,
	            3: fa_m6,
	            4: fa_n6,
	            5: fa_o6,
	            6: fa_p6,
	            7: fa_q6,
	            8: fa_r6
	        },
	        929: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_r6
	        },
	        930: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_r6
	        },
	        931: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_r6
	        },
	        932: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_r6
	        },
	        933: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_r6
	        },
	        845: {
	            1: fa_t1,
	            2: fa_s6,
	            3: fa_t6,
	            4: fa_y1
	        },
	        846: {
	            1: fa_t1,
	            2: fa_s6,
	            3: fa_t6,
	            4: fa_y1
	        },
	        847: {
	            1: fa_t1,
	            2: fa_s6,
	            3: fa_t6,
	            4: fa_y1
	        },
	        848: {
	            1: fa_t1,
	            2: fa_s6,
	            3: fa_t6,
	            4: fa_y1
	        },
	        849: {
	            1: fa_t1,
	            2: fa_s6,
	            3: fa_t6,
	            4: fa_y1
	        },
	        918: {
	            1: fa_t1,
	            2: fa_s6,
	            3: fa_t6,
	            4: fa_y1
	        },
	        919: {
	            1: fa_t1,
	            2: fa_s6,
	            3: fa_t6,
	            4: fa_y1
	        },
	        920: {
	            1: fa_t1,
	            2: fa_s6,
	            3: fa_t6,
	            4: fa_y1
	        },
	        921: {
	            1: fa_t1,
	            2: fa_s6,
	            3: fa_t6,
	            4: fa_y1
	        },
	        922: {
	            1: fa_t1,
	            2: fa_s6,
	            3: fa_t6,
	            4: fa_y1
	        },
	        83: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        84: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        85: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        86: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        87: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        905: {
	            1: fa_w6,
	            2: fa_x6,
	            3: fa_y6,
	            4: fa_z6
	        },
	        906: {
	            1: fa_w6,
	            2: fa_x6,
	            3: fa_y6,
	            4: fa_z6
	        },
	        907: {
	            1: fa_w6,
	            2: fa_x6,
	            3: fa_y6,
	            4: fa_z6
	        },
	        908: {
	            1: fa_w6,
	            2: fa_x6,
	            3: fa_y6,
	            4: fa_z6
	        },
	        909: {
	            1: fa_w6,
	            2: fa_x6,
	            3: fa_y6,
	            4: fa_z6
	        },
	        807: {
	            1: fa_c6,
	            2: fa_e6,
	            3: fa_i6,
	            4: fa_k6
	        },
	        319: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        320: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        912: {
	            1: fa_a7,
	            2: fa_b7,
	            3: fa_c7,
	            4: fa_d7,
	            5: fa_e7,
	            6: fa_f7
	        },
	        913: {
	            1: fa_a7,
	            2: fa_b7,
	            3: fa_c7,
	            4: fa_d7,
	            5: fa_e7,
	            6: fa_f7
	        },
	        914: {
	            1: fa_a7,
	            2: fa_b7,
	            3: fa_c7,
	            4: fa_d7,
	            5: fa_e7,
	            6: fa_f7
	        },
	        915: {
	            1: fa_a7,
	            2: fa_b7,
	            3: fa_c7,
	            4: fa_d7,
	            5: fa_e7,
	            6: fa_f7
	        },
	        916: {
	            1: fa_a7,
	            2: fa_b7,
	            3: fa_c7,
	            4: fa_d7,
	            5: fa_e7,
	            6: fa_f7
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        257: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        307: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        362: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        363: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        364: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        365: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        17: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        18: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        19: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        20: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        176: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        177: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        178: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        179: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        358: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        359: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        360: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        361: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        13: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        14: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        15: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        16: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        172: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        173: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        174: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        175: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        281: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        137: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        616: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        617: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        618: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        619: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        620: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        891: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2,
	            4: fa_h2
	        },
	        26: {
	            1: fa_n14,
	            2: fa_o14
	        },
	        200: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        143: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        187: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        371: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        571: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        928: {
	            1: fa_s3,
	            2: fa_l6,
	            3: fa_m6,
	            4: fa_n6,
	            5: fa_o6,
	            6: fa_p6,
	            7: fa_q6,
	            8: fa_r6
	        },
	        934: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_r6
	        },
	        88: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        910: {
	            1: fa_w6,
	            2: fa_x6,
	            3: fa_y6,
	            4: fa_z6
	        },
	        917: {
	            1: fa_a7,
	            2: fa_b7,
	            3: fa_p14,
	            4: fa_d7,
	            5: fa_e7,
	            6: fa_q14
	        },
	        936: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_y5
	        }
	    },
	    8: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        698: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        674: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        675: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        676: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    27: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    28: {
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        615: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        935: {
	            1: fa_w9,
	            2: fa_x9,
	            3: fa_g13,
	            4: fa_h13,
	            5: fa_i13,
	            6: fa_r14,
	            7: fa_u9,
	            8: fa_v9,
	            9: fa_e3,
	            10: fa_e13,
	            11: fa_s6,
	            12: fa_s14
	        },
	        612: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        613: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    }
	};
	
	var periodConfig = {
	    2: {
	        200: 'Not Started',
	        201: 'First Game',
	        208: 'End',
	        207: 'Seventh Game',
	        206: 'Sixth Game',
	        205: 'Fifth Game',
	        204: 'Fourth Game',
	        203: 'Third Game',
	        202: 'Second Game'
	    },
	    3: {
	        300: 'Not Started',
	        301: 'First Set',
	        302: 'Second Set',
	        303: 'Third Set',
	        304: 'End'
	    },
	    4: {
	        401: 'First Set',
	        400: 'Not Started',
	        407: 'Golden Set',
	        402: 'Second Set',
	        406: 'End',
	        405: 'Fifth Set',
	        404: 'Fourth Set',
	        403: 'Third Set'
	    },
	    5: {
	        501: 'First round',
	        500: 'Not Started',
	        502: 'Second round',
	        513: 'Match finished',
	        512: 'Twelfth round',
	        511: 'Eleventh round',
	        510: 'Tenth round',
	        509: 'Ninth round',
	        508: 'Eighth round',
	        507: 'Seventh round',
	        506: 'Sixth round',
	        505: 'Fifth round',
	        504: 'Fourth round',
	        503: 'Third round'
	    },
	    6: {
	        602: 'Second Set',
	        601: 'First Set',
	        600: 'Not Started',
	        603: 'Third Set',
	        606: 'End',
	        605: 'Fifth Set',
	        604: 'Fourth Set'
	    },
	    7: {
	        709: 'Shootout',
	        708: 'End of Second Extra Time',
	        707: 'Second Extra Time',
	        706: 'End of First Extra Time',
	        705: 'First Extra Time',
	        704: 'Full Time',
	        703: 'Second Half',
	        702: 'Half Time',
	        701: 'First Half',
	        700: 'Not Started',
	        710: 'Match Ended'
	    },
	    8: {
	        800: 'Not Started',
	        801: 'First Quarter',
	        802: 'Pause',
	        803: 'Second Quater',
	        804: 'Intermission',
	        810: 'End',
	        806: 'Pause',
	        807: 'Fourth Quater',
	        808: 'Pause',
	        809: 'Overtime',
	        805: 'Third Quarter'
	    },
	    9: {
	        900: 'Not Started',
	        901: 'First Half',
	        902: 'Half Time',
	        903: 'Second Half',
	        904: 'End'
	    },
	    12: {
	        1200: 'Not Started',
	        1201: 'First Half',
	        1202: 'Half Time',
	        1203: 'Second Half',
	        1204: 'End'
	    },
	    18: {
	        1800: 'Not Started',
	        1801: 'First Period',
	        1802: 'First Intermission',
	        1803: 'Second Period',
	        1804: 'Second Intermission',
	        1810: 'End',
	        1806: 'End of Regulation Time',
	        1807: 'Overtime',
	        1808: 'End of Overtime',
	        1809: 'Shootout',
	        1805: 'Third Period'
	    },
	    19: {
	        1900: 'Not Started',
	        1901: 'First Half',
	        1902: 'Half Time',
	        1903: 'Second Half',
	        1904: 'Full Time',
	        1905: 'End'
	    },
	    20: {
	        2000: 'Not Started',
	        2001: 'First',
	        2002: 'First Fire Line',
	        2003: 'Second Lap',
	        2004: 'Second Fire Line',
	        2005: 'Third Lap',
	        2006: 'Third Fire Line',
	        2007: 'Fourth Lap',
	        2008: 'Fourth Fire Line',
	        2009: 'Fifth Lap',
	        2010: 'Fifth Fire Line',
	        2011: 'Sixth Lap',
	        2012: 'Sixth Fire Line',
	        2013: 'Seventh Lap',
	        2014: 'Seventh Fire Line',
	        2015: 'Eighth Lap',
	        2016: 'Eighth Fire Line',
	        2017: 'End'
	    },
	    28: {
	        2800: 'Not Started',
	        2801: 'Regular Time',
	        2802: 'End'
	    },
	    29: {
	        2953: '27th Frame',
	        2954: 'Intermission',
	        2955: '28th Frame',
	        2956: 'Intermission',
	        2957: '29th Frame',
	        2958: 'Intermission',
	        2959: '30th Frame',
	        2960: 'Intermission',
	        2961: '31st Frame',
	        2962: 'Intermission',
	        2963: '32nd Frame',
	        2964: 'Intermission',
	        2965: '33rd Frame',
	        2966: 'Intermission',
	        2967: '34th Frame',
	        2968: 'Intermission',
	        2969: '35th Frame',
	        2970: 'Intermission',
	        2971: '36th Frame',
	        2972: 'Intermission',
	        2973: '37th Frame',
	        2974: 'End',
	        2900: 'Not Started',
	        2901: '1st Frame',
	        2902: 'Intermission',
	        2903: '2nd Frame',
	        2904: 'Intermission',
	        2905: '3rd Frame',
	        2906: 'Intermission',
	        2907: '4th Frame',
	        2908: 'Intermission',
	        2909: '5th Frame',
	        2910: 'Intermission',
	        2911: '6th Frame',
	        2912: 'Intermission',
	        2913: '7th Frame',
	        2914: 'Intermission',
	        2915: '8th Frame',
	        2916: 'Intermission',
	        2917: '9th Frame',
	        2918: 'Intermission',
	        2919: '10th Frame',
	        2920: 'Intermission',
	        2921: '11th Frame',
	        2922: 'Intermission',
	        2923: '12th Frame',
	        2924: 'Intermission',
	        2925: '13th Frame',
	        2926: 'Intermission',
	        2927: '14th Frame',
	        2928: 'Intermission',
	        2929: '15th Frame',
	        2930: 'Intermission',
	        2931: '16th Frame',
	        2932: 'Intermission',
	        2933: '17th Frame',
	        2934: 'Intermission',
	        2935: '18th Frame',
	        2936: 'Intermission',
	        2937: '19th Frame',
	        2938: 'Intermission',
	        2939: '20th Frame',
	        2940: 'Intermission',
	        2941: '21st Frame',
	        2942: 'Intermission',
	        2943: '22nd Frame',
	        2944: 'Intermission',
	        2945: '23rd Frame',
	        2946: 'Intermission',
	        2947: '24th Frame',
	        2948: 'Intermission',
	        2949: '25th Frame',
	        2950: 'Intermission',
	        2951: '26th Frame',
	        2952: 'Intermission'
	    },
	    30: {
	        3000: 'Not Started',
	        3001: 'First Period',
	        3002: 'First Intermission',
	        3003: 'Second Period',
	        3004: 'Second Intermission',
	        3010: 'End',
	        3006: 'End of Regulation Time',
	        3007: 'Overtime',
	        3008: 'End of Overtime',
	        3009: 'Shootout',
	        3005: 'Third Period'
	    },
	    31: {
	        3100: 'Not Started',
	        3101: 'First Quarter',
	        3102: 'Pause',
	        3103: 'Second Quarter',
	        3104: 'Intermission',
	        3110: 'End',
	        3106: 'Pause',
	        3107: 'Fourth Quarter',
	        3108: 'Pause',
	        3109: 'Overtime',
	        3105: 'Third Quarter'
	    },
	    32: {
	        3200: 'Not Started',
	        3201: 'First Game',
	        3202: 'Second Game',
	        3203: 'Third Game',
	        3204: 'End'
	    },
	    34: {
	        3400: 'Not started',
	        3401: 'First Half',
	        3402: 'Half Time',
	        3403: 'Second Half',
	        3404: 'Full Time',
	        3409: 'Shootout',
	        3405: 'First Extra Time',
	        3406: 'End of First Extra Time',
	        3407: 'Second Extra Time',
	        3408: 'End of Second Extra Time',
	        3410: 'Match Ended'
	    },
	    35: {
	        3500: 'Not Started',
	        3501: 'First Half',
	        3502: 'Half Time',
	        3503: 'Second Half',
	        3504: 'Full Time'
	    },
	    36: {
	        3609: 'Shootout',
	        3608: 'End of Overtime',
	        3607: 'Overtime',
	        3606: 'End of Regulation Time',
	        3605: 'Third Period',
	        3604: 'Second Intermission',
	        3603: 'Second Period',
	        3602: 'First Intermission',
	        3601: 'First Period',
	        3600: 'Not Started',
	        3610: 'End'
	    },
	    37: {
	        3700: 'Not Started',
	        3701: 'End'
	    },
	    38: {
	        3800: 'Not Started',
	        3801: 'End'
	    },
	    39: {
	        3900: 'Not Started',
	        3901: 'End',
	        3902: 'First round',
	        3903: 'Second round',
	        3904: 'Third round',
	        3905: 'Fourth round',
	        3906: 'Fifth round'
	    },
	    40: {
	        4000: 'Not Started',
	        4001: 'End'
	    },
	    41: {
	        4105: 'Overtime',
	        4104: 'Second intermission',
	        4103: 'Second half',
	        4102: 'First intermission',
	        4100: 'Not Started',
	        4101: 'First half',
	        4106: 'End'
	    },
	    42: {
	        4205: 'Fifth map',
	        4204: 'Fourth map',
	        4203: 'Third map',
	        4202: 'Second map',
	        4200: 'Not Started',
	        4201: 'First map',
	        4206: 'End'
	    }
	};
	
	function getGroupName(sportId, groupType) {
	    if (groupConfig !== undefined && groupConfig[sportId] !== undefined) {
	        return groupConfig[sportId][groupType];
	    }
	
	    return undefined;
	}
	
	function getSlotName(sportId, match, slot) {
	    var func = void 0;
	
	    if (slotConfig !== undefined && slotConfig[sportId] !== undefined) {
	        func = slotConfig[sportId][slot.type];
	    }
	
	    if (func === undefined) {
	        return undefined;
	    }
	
	    return func(match, slot);
	}
	
	function getOutcomeName(sportId, outcome, match) {
	    var func = void 0;
	
	    if (baseOutcomeConfig !== undefined && baseOutcomeConfig[sportId] !== undefined && baseOutcomeConfig[sportId]) {
	        func = baseOutcomeConfig[sportId][outcome.type];
	    }
	
	    if (outcomeConfig !== undefined && outcomeConfig[sportId] !== undefined && outcomeConfig[sportId][outcome.type] !== undefined) {
	        func = outcomeConfig[sportId][outcome.type];
	    }
	
	    if (func === undefined) {
	        return undefined;
	    }
	
	    return func(match, outcome);
	}
	
	function getRateName(sportId, outcome, factorType, match) {
	    var func = void 0;
	
	    if (baseFactorNameConfig !== undefined && baseFactorNameConfig[sportId] !== undefined && baseFactorNameConfig[sportId][outcome.type] !== undefined) {
	        func = baseFactorNameConfig[sportId][outcome.type][factorType];
	    }
	
	    if (func === undefined) {
	        return undefined;
	    }
	
	    return func(match, outcome);
	}
	
	function getMatchInfoText(matchInfoType) {
	    switch (matchInfoType) {
	        case 1:
	            return "Match not started";
	        case 2:
	            return "Match finished";
	        case 3:
	            return "Intermission";
	        case 4:
	            return "Full time";
	        case 5:
	            return "First extra time finished";
	        case 6:
	            return "Penalty series";
	    }
	
	    return "";
	}
	
	function getPeriodName(sportId, periodId) {
	    if (periodConfig !== undefined && periodConfig[sportId] !== undefined) {
	        return periodConfig[sportId][periodId];
	    }
	
	    return undefined;
	}
	
	function getFoulsText() {
	    return "Fouls";
	}
	
	function getTimeoutText() {
	    return "Timeout";
	}

/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _parseFloat = __webpack_require__(510);
	
	var _parseFloat2 = _interopRequireDefault(_parseFloat);
	
	exports.getGroupName = getGroupName;
	exports.getSlotName = getSlotName;
	exports.getOutcomeName = getOutcomeName;
	exports.getRateName = getRateName;
	exports.getMatchInfoText = getMatchInfoText;
	exports.getPeriodName = getPeriodName;
	exports.getFoulsText = getFoulsText;
	exports.getTimeoutText = getTimeoutText;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function numeralFemaleEnding(condition) {
	    return condition + "-ші";
	}
	
	function numeralMaleEnding(condition) {
	    return condition + "-ші";
	}
	
	function numeralNeuterEnding(condition) {
	    return condition + "-ші";
	}
	
	function plural(count, parameters) {
	    if (count === 1) {
	        return parameters[0];
	    }
	    return parameters[1];
	}
	
	function signed(condition) {
	    if (condition === 0) {
	        return '0';
	    }
	
	    var num = (0, _parseFloat2.default)(condition.toFixed(2));
	
	    if (condition > 0) {
	        return '+' + num.toString();
	    }
	
	    return num.toString();
	}
	
	function europeanHandicapCondition(condition) {
	    if (condition < 0) {
	        return "0:" + Math.abs(condition);
	    } else {
	        return Math.abs(condition) + ":0";
	    }
	}
	
	var sl_b1 = function sl_b1(match, outcome) {
	    return 'Нәтижесі';
	};
	var sl_c1 = function sl_c1(match, outcome) {
	    return 'Фора';
	};
	var sl_d1 = function sl_d1(match, outcome) {
	    return 'Тоталы';
	};
	var sl_e1 = function sl_e1(match, outcome) {
	    return "\u041A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439\u0434\u044B \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u0430\u043B\u0430\u0434\u044B?";
	};
	var sl_f1 = function sl_f1(match, outcome) {
	    return "\u041A\u0456\u043C " + numeralNeuterEnding(outcome.condition) + " \u04B1\u043F\u0430\u0439 \u04B1\u0442\u0430\u0434\u044B";
	};
	var sl_g1 = function sl_g1(match, outcome) {
	    return match.homeTeam + " \u0442\u0443\u0440\u0430 " + outcome.condition + " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var sl_h1 = function sl_h1(match, outcome) {
	    return match.awayTeam + " \u0442\u0443\u0443\u0440\u0430 " + outcome.condition + " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var sl_i1 = function sl_i1(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam;
	};
	var sl_j1 = function sl_j1(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam;
	};
	var sl_k1 = function sl_k1(match, outcome) {
	    return match.homeTeam + " \u0442\u0443\u0443\u0440\u0430 " + outcome.condition + " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var sl_l1 = function sl_l1(match, outcome) {
	    return 'Победа';
	};
	var sl_m1 = function sl_m1(match, outcome) {
	    return 'Тотал';
	};
	var sl_n1 = function sl_n1(match, outcome) {
	    return 'Дәл тоталы';
	};
	var sl_o1 = function sl_o1(match, outcome) {
	    return match.homeTeam + " \u0410\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0456\u0441";
	};
	var sl_p1 = function sl_p1(match, outcome) {
	    return match.awayTeam + " \u0410\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0456\u0441";
	};
	var sl_q1 = function sl_q1(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']);
	};
	var sl_r1 = function sl_r1(match, outcome) {
	    return 'Ұпай айырмашылығы';
	};
	var sl_s1 = function sl_s1(match, outcome) {
	    return 'Разница очков';
	};
	var sl_t1 = function sl_t1(match, outcome) {
	    return 'Нәтиже';
	};
	var sl_u1 = function sl_u1(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam;
	};
	var sl_v1 = function sl_v1(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam;
	};
	var sl_w1 = function sl_w1(match, outcome) {
	    return 'Первый в матче';
	};
	var sl_x1 = function sl_x1(match, outcome) {
	    return 'Результат';
	};
	var sl_y1 = function sl_y1(match, outcome) {
	    return 'Точный тотал';
	};
	var sl_z1 = function sl_z1(match, outcome) {
	    return match.homeTeam + " \u041F\u043E\u0431\u0435\u0434\u0430 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439";
	};
	var sl_a2 = function sl_a2(match, outcome) {
	    return match.awayTeam + " \u041F\u043E\u0431\u0435\u0434\u0430 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439";
	};
	var sl_b2 = function sl_b2(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']);
	};
	var sl_c2 = function sl_c2(match, outcome) {
	    return 'Сколько команд забьет?';
	};
	var sl_d2 = function sl_d2(match, outcome) {
	    return 'Точный счет';
	};
	var sl_e2 = function sl_e2(match, outcome) {
	    return "\u0416\u0435\u04A3\u0456\u0441 \u0436\u04D9\u043D\u0435 \u0441\u0435\u0442\u0442\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B " + outcome.condition;
	};
	var sl_f2 = function sl_f2(match, outcome) {
	    return 'Жұп/тақ болуы';
	};
	var sl_g2 = function sl_g2(match, outcome) {
	    return match.homeTeam + " \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var sl_h2 = function sl_h2(match, outcome) {
	    return match.awayTeam + " \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var sl_i2 = function sl_i2(match, outcome) {
	    return match.homeTeam + " \u0414\u04D9\u043B \u0442\u043E\u0442\u0430\u043B\u044B";
	};
	var sl_j2 = function sl_j2(match, outcome) {
	    return match.awayTeam + " \u0414\u04D9\u043B \u0442\u043E\u0442\u0430\u043B\u044B";
	};
	var sl_k2 = function sl_k2(match, outcome) {
	    return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 " + numeralNeuterEnding(outcome.condition) + " \u043E\u0447\u043A\u043E?";
	};
	var sl_l2 = function sl_l2(match, outcome) {
	    return 'Победа с разницей';
	};
	var sl_m2 = function sl_m2(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['убийство', 'убийства', 'убийств']);
	};
	var sl_n2 = function sl_n2(match, outcome) {
	    return 'First Blood';
	};
	var sl_o2 = function sl_o2(match, outcome) {
	    return match.homeTeam + " \u0436\u0435\u04A3\u0456\u0441\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var sl_p2 = function sl_p2(match, outcome) {
	    return match.awayTeam + " \u0436\u0435\u04A3\u0456\u0441\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var sl_q2 = function sl_q2(match, outcome) {
	    return match.homeTeam + " \u0442\u0435\u043A \u0441\u043E\u0493\u0430\u0434\u044B \u043C\u0430?";
	};
	var sl_r2 = function sl_r2(match, outcome) {
	    return match.awayTeam + " \u0442\u0435\u043A \u0441\u043E\u0493\u0430\u0434\u044B \u043C\u0430?";
	};
	var sl_s2 = function sl_s2(match, outcome) {
	    return 'Дәл есебі';
	};
	var sl_t2 = function sl_t2(match, outcome) {
	    return 'Қанша команда соғады';
	};
	var sl_u2 = function sl_u2(match, outcome) {
	    return "\u041D\u0435\u0448\u0435 \u0433\u043E\u043B \u0441\u0430\u043B\u0430\u0434\u044B " + match.homeTeam + "?";
	};
	var sl_v2 = function sl_v2(match, outcome) {
	    return "\u041D\u0435\u0448\u0435 \u0433\u043E\u043B \u0441\u0430\u043B\u0430\u0434\u044B " + match.awayTeam + "?";
	};
	var sl_w2 = function sl_w2(match, outcome) {
	    return 'Өтелген уақыт';
	};
	var sl_x2 = function sl_x2(match, outcome) {
	    return "\u0415\u0443\u0440\u043E\u043F\u0430\u043B\u044B\u043B\u044B\u049B \u0444\u043E\u0440\u0430 " + europeanHandicapCondition(outcome.condition);
	};
	var sl_y2 = function sl_y2(match, outcome) {
	    return "\u041A\u0456\u043C " + numeralMaleEnding(outcome.condition) + " \u0433\u043E\u043B \u0441\u0430\u043B\u0430\u0434\u044B?";
	};
	var sl_z2 = function sl_z2(match, outcome) {
	    return "\u049A\u0430\u043B\u0493\u0430\u043D \u0443\u0430\u049B\u044B\u0442\u044B (\u0442\u0435\u043A\u0443\u0449\u0438\u0439 \u0441\u0447\u0435\u0442 " + outcome.condition + ":" + outcome.conditionTwo + ")";
	};
	var sl_a3 = function sl_a3(match, outcome) {
	    return 'Қосарлы нәтиже';
	};
	var sl_b3 = function sl_b3(match, outcome) {
	    return 'Әр жалаушадан';
	};
	var sl_c3 = function sl_c3(match, outcome) {
	    return 'За симуляцию';
	};
	var sl_d3 = function sl_d3(match, outcome) {
	    return 'За снятую футболку';
	};
	var sl_e3 = function sl_e3(match, outcome) {
	    return 'Дәл есеп';
	};
	var sl_f3 = function sl_f3(match, outcome) {
	    return match.homeTeam + " - " + match.awayTeam;
	};
	var sl_g3 = function sl_g3(match, outcome) {
	    return "\u0421\u0430\u043B\u044B\u043D\u0493\u0430\u043D \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438 \u0442\u043E\u0442\u0430\u043B\u044B: " + match.awayTeam;
	};
	var sl_h3 = function sl_h3(match, outcome) {
	    return "\u0421\u0430\u043B\u044B\u043D\u0493\u0430\u043D \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438 \u0442\u043E\u0442\u0430\u043B\u044B: " + match.homeTeam;
	};
	var sl_i3 = function sl_i3(match, outcome) {
	    return 'Салынған пенальти тоталы';
	};
	var sl_j3 = function sl_j3(match, outcome) {
	    return 'Салынбаған пенальти тоталы';
	};
	var sl_k3 = function sl_k3(match, outcome) {
	    return "\u0421\u043A\u043E\u043B\u044C\u043A\u043E \u0433\u043E\u043B\u043E\u0432 \u0437\u0430\u0431\u044C\u0435\u0442 " + match.homeTeam + "?";
	};
	var sl_l3 = function sl_l3(match, outcome) {
	    return "\u0421\u043A\u043E\u043B\u044C\u043A\u043E \u0433\u043E\u043B\u043E\u0432 \u0437\u0430\u0431\u044C\u0435\u0442 " + match.awayTeam + "?";
	};
	var sl_m3 = function sl_m3(match, outcome) {
	    return 'Кім бірінші болып шар соғады?';
	};
	var sl_n3 = function sl_n3(match, outcome) {
	    return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var sl_o3 = function sl_o3(match, outcome) {
	    return 'Кандай түсті шар бірінші болып салынады?';
	};
	var sl_p3 = function sl_p3(match, outcome) {
	    return match.awayTeam + " \u0442\u0443\u0440\u0430 " + outcome.condition + " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var sl_q3 = function sl_q3(match, outcome) {
	    return 'Чет/Нечет тотала';
	};
	var sl_r3 = function sl_r3(match, outcome) {
	    return outcome.condition + " \u0433\u0435\u0439\u043C\u0434\u0435 \u0431\u043E\u043B\u043E\u0431\u0443?";
	};
	var sl_s3 = function sl_s3(match, outcome) {
	    return 'Брейктердің тоталы';
	};
	var sl_t3 = function sl_t3(match, outcome) {
	    return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u0433\u0435\u0439\u043C\u0434\u0456 \u0430\u043B\u0430\u0434\u044B";
	};
	var sl_u3 = function sl_u3(match, outcome) {
	    return "\u0416\u0435\u04A3\u0456\u0441 \u0436\u04D9\u043D\u0435 \u0442\u043E\u0442\u0430\u043B\u044B " + outcome.condition;
	};
	var sl_v3 = function sl_v3(match, outcome) {
	    return 'Тай-брейк бола ма?';
	};
	var sl_w3 = function sl_w3(match, outcome) {
	    return 'Тай-брейкте кім жеңеді?';
	};
	var sl_x3 = function sl_x3(match, outcome) {
	    return 'Тай-брейктің дәл тоталы';
	};
	var sl_y3 = function sl_y3(match, outcome) {
	    return 'Тай-брейктің дәл есебі';
	};
	var sl_z3 = function sl_z3(match, outcome) {
	    return 'Тай-брейктің тоталы';
	};
	var sl_a4 = function sl_a4(match, outcome) {
	    return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: " + match.homeTeam;
	};
	var sl_b4 = function sl_b4(match, outcome) {
	    return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: " + match.awayTeam;
	};
	var sl_c4 = function sl_c4(match, outcome) {
	    return "\u04D9\u043B\u0434\u0435\u043A\u0456\u043C \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D " + outcome.condition + " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?";
	};
	var sl_d4 = function sl_d4(match, outcome) {
	    return match.homeTeam + " \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D " + outcome.condition + " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?";
	};
	var sl_e4 = function sl_e4(match, outcome) {
	    return match.awayTeam + " \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D " + outcome.condition + " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?";
	};
	var sl_f4 = function sl_f4(match, outcome) {
	    return 'Кім көп брейк жасайды';
	};
	var sl_g4 = function sl_g4(match, outcome) {
	    return 'Брейктерден фора';
	};
	var sl_h4 = function sl_h4(match, outcome) {
	    return "\u041F\u043E\u0431\u0435\u0434\u0430 \u0438 \u0442\u043E\u0442\u0430\u043B " + outcome.condition;
	};
	var sl_i4 = function sl_i4(match, outcome) {
	    return 'Чет/Нечет';
	};
	
	var bo_b1 = function bo_b1(match, outcome) {
	    return 'Фора';
	};
	var bo_c1 = function bo_c1(match, outcome) {
	    return 'Матч тоталы';
	};
	var bo_d1 = function bo_d1(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam;
	};
	var bo_e1 = function bo_e1(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam;
	};
	var bo_f1 = function bo_f1(match, outcome) {
	    return 'Матч тоталының жұп/тақ болуы';
	};
	var bo_g1 = function bo_g1(match, outcome) {
	    return match.homeTeam + " - " + match.awayTeam;
	};
	var bo_h1 = function bo_h1(match, outcome) {
	    return outcome.teamOne + " - " + outcome.teamTwo;
	};
	var bo_i1 = function bo_i1(match, outcome) {
	    return "" + outcome.teamOne;
	};
	var bo_j1 = function bo_j1(match, outcome) {
	    return 'Бірінші сеттегі фора';
	};
	var bo_k1 = function bo_k1(match, outcome) {
	    return 'Екінші сеттегі фора';
	};
	var bo_l1 = function bo_l1(match, outcome) {
	    return 'Үшінші сеттегі фора';
	};
	var bo_m1 = function bo_m1(match, outcome) {
	    return 'Бірінші сеттің тоталы';
	};
	var bo_n1 = function bo_n1(match, outcome) {
	    return 'Екінші сеттің тоталы';
	};
	var bo_o1 = function bo_o1(match, outcome) {
	    return 'Үшінші сеттің тоталы';
	};
	var bo_p1 = function bo_p1(match, outcome) {
	    return 'Матчтағы сеттер тоталы';
	};
	var bo_q1 = function bo_q1(match, outcome) {
	    return 'Матч есебі';
	};
	var bo_r1 = function bo_r1(match, outcome) {
	    return 'Бірінші сет нәтижесі';
	};
	var bo_s1 = function bo_s1(match, outcome) {
	    return 'Екінші сет нәтижесі';
	};
	var bo_t1 = function bo_t1(match, outcome) {
	    return 'Үшінші сет нәтижесі';
	};
	var bo_u1 = function bo_u1(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435";
	};
	var bo_v1 = function bo_v1(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0435\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435";
	};
	var bo_w1 = function bo_w1(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u04AF\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435";
	};
	var bo_x1 = function bo_x1(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435";
	};
	var bo_y1 = function bo_y1(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0435\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435";
	};
	var bo_z1 = function bo_z1(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u04AF\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435";
	};
	var bo_a2 = function bo_a2(match, outcome) {
	    return match.homeTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0442\u0443\u0440\u0430 " + outcome.condition + " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_b2 = function bo_b2(match, outcome) {
	    return match.homeTeam + " \u0435\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0442\u0443\u0443\u0440\u0430 " + outcome.condition + " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_c2 = function bo_c2(match, outcome) {
	    return match.homeTeam + " \u04AF\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0442\u0443\u0443\u0440\u0430 " + outcome.condition + " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_d2 = function bo_d2(match, outcome) {
	    return match.awayTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0442\u0443\u0443\u0440\u0430 " + outcome.condition + " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_e2 = function bo_e2(match, outcome) {
	    return match.awayTeam + " \u0435\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0442\u0443\u0443\u0440\u0430 " + outcome.condition + " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_f2 = function bo_f2(match, outcome) {
	    return match.awayTeam + " \u04AF\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0442\u0443\u0443\u0440\u0430 " + outcome.condition + " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_g2 = function bo_g2(match, outcome) {
	    return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439\u0434\u044B \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u0430\u043B\u0430\u0434\u044B?";
	};
	var bo_h2 = function bo_h2(match, outcome) {
	    return "\u0415\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439\u0434\u044B \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u0430\u043B\u0430\u0434\u044B?";
	};
	var bo_i2 = function bo_i2(match, outcome) {
	    return "\u04AE\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439\u0434\u044B \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u0430\u043B\u0430\u0434\u044B?";
	};
	var bo_j2 = function bo_j2(match, outcome) {
	    return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C " + numeralNeuterEnding(outcome.condition) + " \u04B1\u043F\u0430\u0439 \u04B1\u0442\u0430\u0434\u044B";
	};
	var bo_k2 = function bo_k2(match, outcome) {
	    return "\u0415\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C " + numeralNeuterEnding(outcome.condition) + " \u04B1\u043F\u0430\u0439 \u04B1\u0442\u0430\u0434\u044B";
	};
	var bo_l2 = function bo_l2(match, outcome) {
	    return "\u04AE\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C " + numeralNeuterEnding(outcome.condition) + " \u04B1\u043F\u0430\u0439 \u04B1\u0442\u0430\u0434\u044B";
	};
	var bo_m2 = function bo_m2(match, outcome) {
	    return 'Бірінші сеттің 10 ұпайына дейін шағын сеттегі жеңіс';
	};
	var bo_n2 = function bo_n2(match, outcome) {
	    return 'Екінші сеттің 10 ұпайына дейін шағын сеттегі жеңіс';
	};
	var bo_o2 = function bo_o2(match, outcome) {
	    return 'Үшінші сеттің 10 ұпайына дейін шағын сеттегі жеңіс';
	};
	var bo_p2 = function bo_p2(match, outcome) {
	    return 'Бірінші сеттің 10 ұпайына дейін шағын сеттегі фора';
	};
	var bo_q2 = function bo_q2(match, outcome) {
	    return 'Екінші сеттің 10 ұпайына дейін шағын сеттегі фора';
	};
	var bo_r2 = function bo_r2(match, outcome) {
	    return 'Үшінші сеттің 10 ұпайына дейін шағын сеттегі фора';
	};
	var bo_s2 = function bo_s2(match, outcome) {
	    return 'Бірінші сеттің 10 ұпайына дейін шағын сеттегі тотал';
	};
	var bo_t2 = function bo_t2(match, outcome) {
	    return 'Екінші сеттің 10 ұпайына дейін шағын сеттегі тотал';
	};
	var bo_u2 = function bo_u2(match, outcome) {
	    return 'Үшінші сеттің 10 ұпайына дейін шағын сеттегі тотал';
	};
	var bo_v2 = function bo_v2(match, outcome) {
	    return 'Бірінші сеттің 15 ұпайына дейін шағын сеттегі жеңіс';
	};
	var bo_w2 = function bo_w2(match, outcome) {
	    return 'Екінші сеттің 15 ұпайына дейін шағын сеттегі жеңіс';
	};
	var bo_x2 = function bo_x2(match, outcome) {
	    return 'Үшінші сеттің 15 ұпайына дейін шағын сеттегі жеңіс';
	};
	var bo_y2 = function bo_y2(match, outcome) {
	    return 'Бірінші сеттің 15 ұпайына дейін шағын сеттегі фора';
	};
	var bo_z2 = function bo_z2(match, outcome) {
	    return 'Екінші сеттің 15 ұпайына дейін шағын сеттегі фора';
	};
	var bo_a3 = function bo_a3(match, outcome) {
	    return 'Үшінші сеттің 15 ұпайына дейін шағын сеттегі фора';
	};
	var bo_b3 = function bo_b3(match, outcome) {
	    return 'Бірінші сеттің 15 ұпайына дейін шағын сеттегі тотал';
	};
	var bo_c3 = function bo_c3(match, outcome) {
	    return 'Екінші сеттің 15 ұпайына дейін шағын сеттегі тотал';
	};
	var bo_d3 = function bo_d3(match, outcome) {
	    return 'Үшінші сеттің 15 ұпайына дейін шағын сеттегі тотал';
	};
	var bo_e3 = function bo_e3(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430";
	};
	var bo_f3 = function bo_f3(match, outcome) {
	    return 'Бірінші таймдағы фора';
	};
	var bo_g3 = function bo_g3(match, outcome) {
	    return 'Бірінші тайм нәтижесі';
	};
	var bo_h3 = function bo_h3(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430";
	};
	var bo_i3 = function bo_i3(match, outcome) {
	    return "\u041A\u0456\u043C " + numeralMaleEnding(outcome.condition) + " \u0433\u043E\u043B \u0441\u043E\u0493\u0430\u0434\u044B?";
	};
	var bo_j3 = function bo_j3(match, outcome) {
	    return 'Қосарлы нәтиже';
	};
	var bo_k3 = function bo_k3(match, outcome) {
	    return 'Бірінші таймның тоталы';
	};
	var bo_l3 = function bo_l3(match, outcome) {
	    return "\u0416\u0435\u04A3\u0456\u0441 \u0436\u04D9\u043D\u0435 \u043C\u0430\u0442\u0447 \u0442\u043E\u0442\u0430\u043B\u044B " + outcome.condition;
	};
	var bo_m3 = function bo_m3(match, outcome) {
	    return match.homeTeam + " \u0442\u0443\u0440\u0430 " + outcome.condition + " \u0433\u043E\u043B\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_n3 = function bo_n3(match, outcome) {
	    return match.awayTeam + " \u0442\u0443\u0440\u0430 " + outcome.condition + " \u0433\u043E\u043B\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_o3 = function bo_o3(match, outcome) {
	    return 'Матчтың дәл тоталы';
	};
	var bo_p3 = function bo_p3(match, outcome) {
	    return 'Қанша команда соғады';
	};
	var bo_q3 = function bo_q3(match, outcome) {
	    return 'Дәл есеп';
	};
	var bo_r3 = function bo_r3(match, outcome) {
	    return 'Азиялық фора';
	};
	var bo_s3 = function bo_s3(match, outcome) {
	    return 'Бірінші ширектегі фора';
	};
	var bo_t3 = function bo_t3(match, outcome) {
	    return 'Екінші ширектегі фора';
	};
	var bo_u3 = function bo_u3(match, outcome) {
	    return 'Үшінші ширектегі фора';
	};
	var bo_v3 = function bo_v3(match, outcome) {
	    return 'Төртінші ширектегі фора';
	};
	var bo_w3 = function bo_w3(match, outcome) {
	    return 'Бірінші ширектiң тоталы';
	};
	var bo_x3 = function bo_x3(match, outcome) {
	    return 'Екінші ширектің тоталы';
	};
	var bo_y3 = function bo_y3(match, outcome) {
	    return 'Үшінші ширектің тоталы';
	};
	var bo_z3 = function bo_z3(match, outcome) {
	    return 'Төртінші ширектің тоталы';
	};
	var bo_a4 = function bo_a4(match, outcome) {
	    return 'Бірінші ширек нәтижесі';
	};
	var bo_b4 = function bo_b4(match, outcome) {
	    return 'Екінші ширек нәтижесі';
	};
	var bo_c4 = function bo_c4(match, outcome) {
	    return 'Үшінші ширек нәтижесі';
	};
	var bo_d4 = function bo_d4(match, outcome) {
	    return 'Төртінші ширек нәтижесі';
	};
	var bo_e4 = function bo_e4(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435";
	};
	var bo_f4 = function bo_f4(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0435\u043A\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435";
	};
	var bo_g4 = function bo_g4(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u04AF\u0448\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435";
	};
	var bo_h4 = function bo_h4(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435";
	};
	var bo_i4 = function bo_i4(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435";
	};
	var bo_j4 = function bo_j4(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0435\u043A\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435";
	};
	var bo_k4 = function bo_k4(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u04AF\u0448\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435";
	};
	var bo_l4 = function bo_l4(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435";
	};
	var bo_m4 = function bo_m4(match, outcome) {
	    return 'Бірінші жартының тоталы';
	};
	var bo_n4 = function bo_n4(match, outcome) {
	    return 'Екінші жартыдағы нәтиже';
	};
	var bo_o4 = function bo_o4(match, outcome) {
	    return 'Екінші жартының тоталы';
	};
	var bo_p4 = function bo_p4(match, outcome) {
	    return 'Бірінші жартыдағы фора';
	};
	var bo_q4 = function bo_q4(match, outcome) {
	    return 'Екінші жартыдағы фора';
	};
	var bo_r4 = function bo_r4(match, outcome) {
	    return 'Бірінші жартыдағы нәтиже';
	};
	var bo_s4 = function bo_s4(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0436\u0430\u0440\u0442\u044B\u0434\u0430";
	};
	var bo_t4 = function bo_t4(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0435\u043Ai\u043D\u0448i \u0436\u0430\u0440\u0442\u044B\u0434\u0430";
	};
	var bo_u4 = function bo_u4(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0436\u0430\u0440\u0442\u044B\u0434\u0430";
	};
	var bo_v4 = function bo_v4(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0435\u043Ai\u043D\u0448i \u0436\u0430\u0440\u0442\u044B\u0434\u0430";
	};
	var bo_w4 = function bo_w4(match, outcome) {
	    return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435 \u043A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B";
	};
	var bo_x4 = function bo_x4(match, outcome) {
	    return "\u0415\u043A\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435 \u043A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B";
	};
	var bo_y4 = function bo_y4(match, outcome) {
	    return "\u04AE\u0448\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435 \u043A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B";
	};
	var bo_z4 = function bo_z4(match, outcome) {
	    return "\u0422\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435 \u043A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B";
	};
	var bo_a5 = function bo_a5(match, outcome) {
	    return 'Бірінші ширектің дәл тоталы';
	};
	var bo_b5 = function bo_b5(match, outcome) {
	    return 'Екінші ширектің дәл тоталы';
	};
	var bo_c5 = function bo_c5(match, outcome) {
	    return 'Үшінші ширектің дәл тоталы';
	};
	var bo_d5 = function bo_d5(match, outcome) {
	    return 'Төртінші ширектің дәл тоталы';
	};
	var bo_e5 = function bo_e5(match, outcome) {
	    return match.homeTeam + " \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_f5 = function bo_f5(match, outcome) {
	    return match.awayTeam + " \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_g5 = function bo_g5(match, outcome) {
	    return 'Өту';
	};
	var bo_h5 = function bo_h5(match, outcome) {
	    return match.homeTeam + " \u0431\u0430\u0440\u043B\u044B\u049B \u0448\u0438\u0440\u0435\u043A\u0442\u0435 \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_i5 = function bo_i5(match, outcome) {
	    return match.awayTeam + " \u0431\u0430\u0440\u043B\u044B\u049B \u0448\u0438\u0440\u0435\u043A\u0442\u0435 \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_j5 = function bo_j5(match, outcome) {
	    return match.homeTeam + " \u0435\u043A\u0456 \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u0430 \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_k5 = function bo_k5(match, outcome) {
	    return match.awayTeam + " \u0435\u043A\u0456 \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u0430 \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_l5 = function bo_l5(match, outcome) {
	    return 'Ең нәтижелі жартылық';
	};
	var bo_m5 = function bo_m5(match, outcome) {
	    return 'Ең нәтижелі ширек';
	};
	var bo_n5 = function bo_n5(match, outcome) {
	    return 'Ең нәтижелі ширектің тоталы';
	};
	var bo_o5 = function bo_o5(match, outcome) {
	    return 'Ең нәтижесіз ширектің тоталы';
	};
	var bo_p5 = function bo_p5(match, outcome) {
	    return match.homeTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435 \u0436\u04D9\u043D\u0435 \u043C\u0430\u0442\u0447\u0442\u0430 \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_q5 = function bo_q5(match, outcome) {
	    return match.awayTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435 \u0436\u04D9\u043D\u0435 \u043C\u0430\u0442\u0447\u0442\u0430 \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_r5 = function bo_r5(match, outcome) {
	    return match.homeTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u0430 \u0436\u04D9\u043D\u0435 \u043C\u0430\u0442\u0447\u0442\u0430 \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_s5 = function bo_s5(match, outcome) {
	    return match.awayTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u0430 \u0436\u04D9\u043D\u0435 \u043C\u0430\u0442\u0447\u0442\u0430 \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_t5 = function bo_t5(match, outcome) {
	    return 'Овертайм бола ма';
	};
	var bo_u5 = function bo_u5(match, outcome) {
	    return 'Айырмашылықпен жеңіс';
	};
	var bo_v5 = function bo_v5(match, outcome) {
	    return 'Бірінші ширекте айырмашылықпен жеңіс';
	};
	var bo_w5 = function bo_w5(match, outcome) {
	    return 'Екінші ширекте айырмашылықпен жеңіс';
	};
	var bo_x5 = function bo_x5(match, outcome) {
	    return 'Үшінші ширекте айырмашылықпен жеңіс';
	};
	var bo_y5 = function bo_y5(match, outcome) {
	    return 'Төртінші ширекте айырмашылықпен жеңіс';
	};
	var bo_z5 = function bo_z5(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + outcome.playerName + " (" + match.homeTeam + ")";
	};
	var bo_a6 = function bo_a6(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + outcome.playerName + " (" + match.awayTeam + ")";
	};
	var bo_b6 = function bo_b6(match, outcome) {
	    return 'Тотал: 3-ұпайлық лақтырулар';
	};
	var bo_c6 = function bo_c6(match, outcome) {
	    return 'Тотал: 2-ұпайлық лақтырулар';
	};
	var bo_d6 = function bo_d6(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " 3-\u04B1\u043F\u0430\u0439\u043B\u044B\u049B \u043B\u0430\u049B\u0442\u044B\u0440\u0443\u043B\u0430\u0440";
	};
	var bo_e6 = function bo_e6(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " 3-\u04B1\u043F\u0430\u0439\u043B\u044B\u049B \u043B\u0430\u049B\u0442\u044B\u0440\u0443\u043B\u0430\u0440";
	};
	var bo_f6 = function bo_f6(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " 2-\u04B1\u043F\u0430\u0439\u043B\u044B\u049B \u043B\u0430\u049B\u0442\u044B\u0440\u0443\u043B\u0430\u0440";
	};
	var bo_g6 = function bo_g6(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " 2-\u04B1\u043F\u0430\u0439\u043B\u044B\u049B \u043B\u0430\u049B\u0442\u044B\u0440\u0443\u043B\u0430\u0440";
	};
	var bo_h6 = function bo_h6(match, outcome) {
	    return 'Фора 3-ұпайлық лақтырулар';
	};
	var bo_i6 = function bo_i6(match, outcome) {
	    return 'Фора 2-ұпайлық лақтырулар';
	};
	var bo_j6 = function bo_j6(match, outcome) {
	    return 'Нәтиже по 3-ұпайлық лақтырулар';
	};
	var bo_k6 = function bo_k6(match, outcome) {
	    return '2-ұпайлық лақтырулар бойынша нәтиже';
	};
	var bo_l6 = function bo_l6(match, outcome) {
	    return 'Ең нәтижесіз ширек';
	};
	var bo_m6 = function bo_m6(match, outcome) {
	    return 'Матчта доп беру тоталы';
	};
	var bo_n6 = function bo_n6(match, outcome) {
	    return "\u041C\u0430\u0442\u0447\u0442\u0430 " + match.homeTeam + " \u0434\u043E\u043F \u0431\u0435\u0440\u0443 \u0442\u043E\u0442\u0430\u043B\u044B";
	};
	var bo_o6 = function bo_o6(match, outcome) {
	    return "\u041C\u0430\u0442\u0447\u0442\u0430 " + match.awayTeam + " \u0434\u043E\u043F \u0431\u0435\u0440\u0443 \u0442\u043E\u0442\u0430\u043B\u044B";
	};
	var bo_p6 = function bo_p6(match, outcome) {
	    return 'Матчта доп берулерден фора';
	};
	var bo_q6 = function bo_q6(match, outcome) {
	    return 'Матчта доп берулерден жеңіс';
	};
	var bo_r6 = function bo_r6(match, outcome) {
	    return 'Матчтағы бірінші 2-ұпайлық лақтыру';
	};
	var bo_s6 = function bo_s6(match, outcome) {
	    return 'Матчтағы бірінші 3-ұпайлық лақтыру';
	};
	var bo_t6 = function bo_t6(match, outcome) {
	    return 'Матчтағы бірінші айыппұл доп';
	};
	var bo_u6 = function bo_u6(match, outcome) {
	    return 'Қайсысы ертерек болады';
	};
	var bo_v6 = function bo_v6(match, outcome) {
	    return 'Ширектегі ең көп ұпай саны';
	};
	var bo_w6 = function bo_w6(match, outcome) {
	    return "\u041C\u0430\u0442\u0447\u0442\u0430 \u043A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F " + outcome.condition + " " + plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар']) + " \u04B1\u043F\u0430\u0439 \u0430\u043B\u0430\u0434\u044B";
	};
	var bo_x6 = function bo_x6(match, outcome) {
	    return 'Матчта трипл-дабл тоталы';
	};
	var bo_y6 = function bo_y6(match, outcome) {
	    return 'Матчта дабл-дабл тоталы';
	};
	var bo_z6 = function bo_z6(match, outcome) {
	    return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435 \u043A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F " + outcome.condition + " " + plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар']) + " \u04B1\u043F\u0430\u0439 \u0430\u043B\u0430\u0434\u044B";
	};
	var bo_a7 = function bo_a7(match, outcome) {
	    return "\u0415\u043A\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435 \u043A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F " + outcome.condition + " " + plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар']) + " \u04B1\u043F\u0430\u0439 \u0430\u043B\u0430\u0434\u044B";
	};
	var bo_b7 = function bo_b7(match, outcome) {
	    return "\u04AE\u0448\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435 \u043A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456\u0431\u043E\u043B\u044B\u043F " + outcome.condition + " " + plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар']) + " \u04B1\u043F\u0430\u0439 \u0430\u043B\u0430\u0434\u044B";
	};
	var bo_c7 = function bo_c7(match, outcome) {
	    return "\u0422\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435 \u043A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F " + outcome.condition + " " + plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар']) + " \u04B1\u043F\u0430\u0439 \u0430\u043B\u0430\u0434\u044B";
	};
	var bo_d7 = function bo_d7(match, outcome) {
	    return 'Матчтағы ұпай айырмашылығы';
	};
	var bo_e7 = function bo_e7(match, outcome) {
	    return 'Бірінші ширектегі ұпай айырмашылығы';
	};
	var bo_f7 = function bo_f7(match, outcome) {
	    return 'Екінші ширектегі ұпай айырмашылығы';
	};
	var bo_g7 = function bo_g7(match, outcome) {
	    return 'Үшінші ширектегі ұпай айырмашылығы';
	};
	var bo_h7 = function bo_h7(match, outcome) {
	    return 'Төртінші ширектегі ұпай айырмашылығы';
	};
	var bo_i7 = function bo_i7(match, outcome) {
	    return 'Бірінші жартылықта фора';
	};
	var bo_j7 = function bo_j7(match, outcome) {
	    return 'Екінші жартылықта фора';
	};
	var bo_k7 = function bo_k7(match, outcome) {
	    return 'Бірінші жартылық нәтижесі';
	};
	var bo_l7 = function bo_l7(match, outcome) {
	    return 'Екінші жартылық нәтижесі';
	};
	var bo_m7 = function bo_m7(match, outcome) {
	    return 'Бірінші жартылықтың тоталы';
	};
	var bo_n7 = function bo_n7(match, outcome) {
	    return 'Екінші жартылықтың тоталы';
	};
	var bo_o7 = function bo_o7(match, outcome) {
	    return 'Бірінші жартылықтың нақты тоталы';
	};
	var bo_p7 = function bo_p7(match, outcome) {
	    return 'Овертайм болады ма';
	};
	var bo_q7 = function bo_q7(match, outcome) {
	    return 'Бірінші жартылықта айырмашылықпен жеңіс';
	};
	var bo_r7 = function bo_r7(match, outcome) {
	    return 'Екінші жартылықта айырмашылықпен жеңіс';
	};
	var bo_s7 = function bo_s7(match, outcome) {
	    return "\u041A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F " + outcome.condition + " " + plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар']) + " \u0430\u043B\u0430\u0434\u044B";
	};
	var bo_t7 = function bo_t7(match, outcome) {
	    return "\u041A\u0456\u043C \u0435\u043A\u0456\u043D\u0448\u0456 \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F " + outcome.condition + " " + plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар']) + " \u0430\u043B\u0430\u0434\u044B";
	};
	var bo_u7 = function bo_u7(match, outcome) {
	    return 'Матчтың нақты тоталы';
	};
	var bo_v7 = function bo_v7(match, outcome) {
	    return "\u041A\u0456\u043C \u043C\u0430\u0442\u0447\u0442\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F" + outcome.condition + " " + plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар']) + " \u0430\u043B\u0430\u0434\u044B";
	};
	var bo_w7 = function bo_w7(match, outcome) {
	    return 'Ең нәтижелі жартылықтың тоталы';
	};
	var bo_x7 = function bo_x7(match, outcome) {
	    return 'Ең нәтижесіз жартылықтың тоталы';
	};
	var bo_y7 = function bo_y7(match, outcome) {
	    return match.homeTeam + " \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u044B\u04A3 \u0435\u043A\u0435\u0443\u0456\u043D \u0434\u0435 \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_z7 = function bo_z7(match, outcome) {
	    return match.awayTeam + " \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u044B\u04A3 \u0435\u043A\u0435\u0443\u0456\u043D \u0434\u0435 \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_a8 = function bo_a8(match, outcome) {
	    return match.homeTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u044B \u0436\u04D9\u043D\u0435 \u043C\u0430\u0442\u0447\u0442\u044B \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_b8 = function bo_b8(match, outcome) {
	    return match.awayTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u044B \u0436\u04D9\u043D\u0435 \u043C\u0430\u0442\u0447\u0442\u044B \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_c8 = function bo_c8(match, outcome) {
	    return 'Тотал: 3-ұпайлық лақтыру';
	};
	var bo_d8 = function bo_d8(match, outcome) {
	    return 'Тотал: 2-ұпайлық лақтыру';
	};
	var bo_e8 = function bo_e8(match, outcome) {
	    return 'Фора 3-ұпайлық лақтыру';
	};
	var bo_f8 = function bo_f8(match, outcome) {
	    return 'Фора 2-ұпайлық лақтыру';
	};
	var bo_g8 = function bo_g8(match, outcome) {
	    return '3-ұпайлық лақтыру бойынша нәтиже';
	};
	var bo_h8 = function bo_h8(match, outcome) {
	    return '2-ұпайлық лақтыру бойынша нәтиже';
	};
	var bo_i8 = function bo_i8(match, outcome) {
	    return 'Матч тоталының жұп/тағы';
	};
	var bo_j8 = function bo_j8(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u0430";
	};
	var bo_k8 = function bo_k8(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0435\u043A\u0456\u043D\u0448\u0456 \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u0430";
	};
	var bo_l8 = function bo_l8(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u0430";
	};
	var bo_m8 = function bo_m8(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0435\u043A\u0456\u043D\u0448\u0456 \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u0430";
	};
	var bo_n8 = function bo_n8(match, outcome) {
	    return 'Бірінші кезеңнiң тоталы';
	};
	var bo_o8 = function bo_o8(match, outcome) {
	    return 'Екінші кезеңнiң тоталы';
	};
	var bo_p8 = function bo_p8(match, outcome) {
	    return 'Үшінші кезеңнiң тоталы';
	};
	var bo_q8 = function bo_q8(match, outcome) {
	    return 'Бірінші кезең нәтижесі';
	};
	var bo_r8 = function bo_r8(match, outcome) {
	    return 'Екінші кезең нәтижесі';
	};
	var bo_s8 = function bo_s8(match, outcome) {
	    return 'Үшінші кезең нәтижесі';
	};
	var bo_t8 = function bo_t8(match, outcome) {
	    return 'Пенальтиді ескерумен жеңіс';
	};
	var bo_u8 = function bo_u8(match, outcome) {
	    return '1айырмашылықпен жеңіс';
	};
	var bo_v8 = function bo_v8(match, outcome) {
	    return '2 1айырмашылықпен жеңіс';
	};
	var bo_w8 = function bo_w8(match, outcome) {
	    return 'Бірінші кезеңде неше команда соғады?';
	};
	var bo_x8 = function bo_x8(match, outcome) {
	    return 'Екінші кезеңде неше команда соғады?';
	};
	var bo_y8 = function bo_y8(match, outcome) {
	    return 'Үшінші кезеңде неше команда соғады?';
	};
	var bo_z8 = function bo_z8(match, outcome) {
	    return 'Кезең-Матч';
	};
	var bo_a9 = function bo_a9(match, outcome) {
	    return 'Овертайм тоталы';
	};
	var bo_b9 = function bo_b9(match, outcome) {
	    return 'Оветайм нәтижесі';
	};
	var bo_c9 = function bo_c9(match, outcome) {
	    return 'Овертаймдағы фора';
	};
	var bo_d9 = function bo_d9(match, outcome) {
	    return 'Бірінші кезеңдегі фора';
	};
	var bo_e9 = function bo_e9(match, outcome) {
	    return 'Екінші кезеңдегі фора';
	};
	var bo_f9 = function bo_f9(match, outcome) {
	    return 'Үшінші кезеңдегі фора';
	};
	var bo_g9 = function bo_g9(match, outcome) {
	    return 'Бірінші кезеңнің нақты есебі';
	};
	var bo_h9 = function bo_h9(match, outcome) {
	    return 'Екінші кезеңнің нақты есебі';
	};
	var bo_i9 = function bo_i9(match, outcome) {
	    return 'Үшінші кезеңнің нақты есебі';
	};
	var bo_j9 = function bo_j9(match, outcome) {
	    return "\u041A\u0456\u043C " + numeralMaleEnding(outcome.condition) + " \u0433\u043E\u043B\u0434\u044B \u0441\u0430\u043B\u0430\u0434\u044B?";
	};
	var bo_k9 = function bo_k9(match, outcome) {
	    return 'Матчта партиялар бойынша фора';
	};
	var bo_l9 = function bo_l9(match, outcome) {
	    return 'Бірінші сеттің дәл тоталы';
	};
	var bo_m9 = function bo_m9(match, outcome) {
	    return 'Екінші сеттің дәл тоталы';
	};
	var bo_n9 = function bo_n9(match, outcome) {
	    return 'Үшінші сеттің дәл тоталы';
	};
	var bo_o9 = function bo_o9(match, outcome) {
	    return match.homeTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_p9 = function bo_p9(match, outcome) {
	    return match.homeTeam + " \u0435\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_q9 = function bo_q9(match, outcome) {
	    return match.homeTeam + " \u04AF\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_r9 = function bo_r9(match, outcome) {
	    return match.awayTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_s9 = function bo_s9(match, outcome) {
	    return match.awayTeam + " \u0435\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_t9 = function bo_t9(match, outcome) {
	    return match.awayTeam + " \u04AF\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_u9 = function bo_u9(match, outcome) {
	    return 'Бірінші сеттің жұп/тақ болуы';
	};
	var bo_v9 = function bo_v9(match, outcome) {
	    return 'Екінші сеттің жұп/тақ болуы';
	};
	var bo_w9 = function bo_w9(match, outcome) {
	    return 'Үшінші сеттің жұп/тақ болуы';
	};
	var bo_x9 = function bo_x9(match, outcome) {
	    return "\u0416\u0435\u04A3\u0456\u0441 \u0436\u04D9\u043D\u0435 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B " + outcome.condition;
	};
	var bo_y9 = function bo_y9(match, outcome) {
	    return "\u0416\u0435\u04A3\u0456\u0441 \u0436\u04D9\u043D\u0435 \u0435\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B " + outcome.condition;
	};
	var bo_z9 = function bo_z9(match, outcome) {
	    return "\u0416\u0435\u04A3\u0456\u0441 \u0436\u04D9\u043D\u0435 \u04AF\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B " + outcome.condition;
	};
	var bo_a10 = function bo_a10(match, outcome) {
	    return 'Шағын сетте бірінші сеттің 10 ұпайына дейін жеңіс';
	};
	var bo_b10 = function bo_b10(match, outcome) {
	    return 'Шағын сетте екінші сеттің 10 ұпайына дейін жеңіс';
	};
	var bo_c10 = function bo_c10(match, outcome) {
	    return 'Шағын сетте бірінші сеттің 10 ұпайына дейін фора';
	};
	var bo_d10 = function bo_d10(match, outcome) {
	    return 'Шағын сетте екінші сеттің 10 ұпайына дейін фора';
	};
	var bo_e10 = function bo_e10(match, outcome) {
	    return 'Шағын сетте бірінші сеттің 10 ұпайына дейін тотал';
	};
	var bo_f10 = function bo_f10(match, outcome) {
	    return 'Шағын сетте екінші сеттің 10 ұпайына дейін тотал';
	};
	var bo_g10 = function bo_g10(match, outcome) {
	    return 'Шағын сетте екінші сеттің 15 ұпайына дейін жеңіс';
	};
	var bo_h10 = function bo_h10(match, outcome) {
	    return 'Шағын сетте бірінші сеттің 15 ұпайына дейін фора';
	};
	var bo_i10 = function bo_i10(match, outcome) {
	    return 'Шағын сетте екінші сеттің 15 ұпайына дейін фора';
	};
	var bo_j10 = function bo_j10(match, outcome) {
	    return 'Шағын сетте бірінші сеттің 15 ұпайына дейін тотал';
	};
	var bo_k10 = function bo_k10(match, outcome) {
	    return 'Шағын сетте екінші сеттің 15 ұпайына дейін тотал';
	};
	var bo_l10 = function bo_l10(match, outcome) {
	    return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C " + numeralNeuterEnding(outcome.condition) + " \u04B1\u043F\u0430\u0439 \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_m10 = function bo_m10(match, outcome) {
	    return "\u0415\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C " + numeralNeuterEnding(outcome.condition) + " \u04B1\u043F\u0430\u0439 \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_n10 = function bo_n10(match, outcome) {
	    return "\u04AE\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C " + numeralNeuterEnding(outcome.condition) + " \u04B1\u043F\u0430\u0439 \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_o10 = function bo_o10(match, outcome) {
	    return 'Бірінші сетте айырмашылықпен жеңіс';
	};
	var bo_p10 = function bo_p10(match, outcome) {
	    return 'Екінші сетте айырмашылықпен жеңіс';
	};
	var bo_q10 = function bo_q10(match, outcome) {
	    return 'Үшінші сетте айырмашылықпен жеңіс';
	};
	var bo_r10 = function bo_r10(match, outcome) {
	    return 'Тотал: Бірінші атыс шебіде';
	};
	var bo_s10 = function bo_s10(match, outcome) {
	    return 'Тотал: Екінші атыс шебіде';
	};
	var bo_t10 = function bo_t10(match, outcome) {
	    return 'Тотал: Үшінші атыс шебіде';
	};
	var bo_u10 = function bo_u10(match, outcome) {
	    return 'Тотал: Төртінші атыс шебіде';
	};
	var bo_v10 = function bo_v10(match, outcome) {
	    return 'Тотал: Бесінші атыс шебіде';
	};
	var bo_w10 = function bo_w10(match, outcome) {
	    return 'Тотал: Алтыншы атыс шебіде';
	};
	var bo_x10 = function bo_x10(match, outcome) {
	    return 'Тотал: Жетінші атыс шебіде';
	};
	var bo_y10 = function bo_y10(match, outcome) {
	    return 'Тотал: Сегізінші атыс шебіде';
	};
	var bo_z10 = function bo_z10(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435";
	};
	var bo_a11 = function bo_a11(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0435\u043A\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435";
	};
	var bo_b11 = function bo_b11(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u04AF\u0448\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435";
	};
	var bo_c11 = function bo_c11(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435";
	};
	var bo_d11 = function bo_d11(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435";
	};
	var bo_e11 = function bo_e11(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0430\u043B\u0442\u044B\u043D\u0448\u044B \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435";
	};
	var bo_f11 = function bo_f11(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0436\u0435\u0442\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435";
	};
	var bo_g11 = function bo_g11(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0441\u0435\u0433\u0456\u0437\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435";
	};
	var bo_h11 = function bo_h11(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435";
	};
	var bo_i11 = function bo_i11(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0435\u043A\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435";
	};
	var bo_j11 = function bo_j11(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u04AF\u0448\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435";
	};
	var bo_k11 = function bo_k11(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435";
	};
	var bo_l11 = function bo_l11(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435";
	};
	var bo_m11 = function bo_m11(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0430\u043B\u0442\u044B\u043D\u0448\u044B \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435";
	};
	var bo_n11 = function bo_n11(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0436\u0435\u0442\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435";
	};
	var bo_o11 = function bo_o11(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0441\u0435\u0433\u0456\u0437\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435";
	};
	var bo_p11 = function bo_p11(match, outcome) {
	    return 'Фора: Бірінші атыс шебіде';
	};
	var bo_q11 = function bo_q11(match, outcome) {
	    return 'Фора: Екінші атыс шебіде';
	};
	var bo_r11 = function bo_r11(match, outcome) {
	    return 'Фора: Үшінші атыс шебіде';
	};
	var bo_s11 = function bo_s11(match, outcome) {
	    return 'Фора: Төртінші атыс шебіде';
	};
	var bo_t11 = function bo_t11(match, outcome) {
	    return 'Фора: Бесінші атыс шебіде';
	};
	var bo_u11 = function bo_u11(match, outcome) {
	    return 'Фора: Алтыншы атыс шебіде';
	};
	var bo_v11 = function bo_v11(match, outcome) {
	    return 'Фора: Жетінші атыс шебіде';
	};
	var bo_w11 = function bo_w11(match, outcome) {
	    return 'Фора: Сегізінші атыс шебіде';
	};
	var bo_x11 = function bo_x11(match, outcome) {
	    return 'Нәтиже: Бірінші атыс шебіде';
	};
	var bo_y11 = function bo_y11(match, outcome) {
	    return 'Нәтиже: Екінші атыс шебіде';
	};
	var bo_z11 = function bo_z11(match, outcome) {
	    return 'Нәтиже: Үшінші атыс шебіде';
	};
	var bo_a12 = function bo_a12(match, outcome) {
	    return 'Нәтиже: Төртінші атыс шебіде';
	};
	var bo_b12 = function bo_b12(match, outcome) {
	    return 'Нәтиже: Бесінші атыс шебіде';
	};
	var bo_c12 = function bo_c12(match, outcome) {
	    return 'Нәтиже: Алтыншы атыс шебіде';
	};
	var bo_d12 = function bo_d12(match, outcome) {
	    return 'Нәтиже: Жетінші атыс шебіде';
	};
	var bo_e12 = function bo_e12(match, outcome) {
	    return 'Нәтиже: Сегізінші атыс шебіде';
	};
	var bo_f12 = function bo_f12(match, outcome) {
	    return 'Дәл тоталы: Бірінші атыс шебіде';
	};
	var bo_g12 = function bo_g12(match, outcome) {
	    return 'Дәл тоталы: Екінші атыс шебіде';
	};
	var bo_h12 = function bo_h12(match, outcome) {
	    return 'Дәл тоталы: Үшінші атыс шебіде';
	};
	var bo_i12 = function bo_i12(match, outcome) {
	    return 'Дәл тоталы: Төртінші атыс шебіде';
	};
	var bo_j12 = function bo_j12(match, outcome) {
	    return 'Дәл тоталы: Бесінші атыс шебіде';
	};
	var bo_k12 = function bo_k12(match, outcome) {
	    return 'Дәл тоталы: Алтыншы атыс шебіде';
	};
	var bo_l12 = function bo_l12(match, outcome) {
	    return 'Дәл тоталы: Жетінші атыс шебіде';
	};
	var bo_m12 = function bo_m12(match, outcome) {
	    return 'Дәл тоталы: Сегізінші атыс шебіде';
	};
	var bo_n12 = function bo_n12(match, outcome) {
	    return 'Мерзімнен бұрын женіс болады ма?';
	};
	var bo_o12 = function bo_o12(match, outcome) {
	    return 'Жекпе-жекте жеңу тәсілі';
	};
	var bo_p12 = function bo_p12(match, outcome) {
	    return 'Жекпе-жекте жеңу';
	};
	var bo_q12 = function bo_q12(match, outcome) {
	    return 'Тотал';
	};
	var bo_r12 = function bo_r12(match, outcome) {
	    return "\u041A\u0456\u043C " + outcome.condition + " \u0440\u0430\u0443\u043D\u0434\u0442\u044B \u0436\u0435\u04A3\u0435\u0434\u0456?";
	};
	var bo_s12 = function bo_s12(match, outcome) {
	    return 'FirstBlood';
	};
	var bo_t12 = function bo_t12(match, outcome) {
	    return "FirstBlood " + outcome.condition + " \u0440\u0430\u0443\u043D\u0434\u0442\u0430";
	};
	var bo_u12 = function bo_u12(match, outcome) {
	    return outcome.condition + " \u043A\u0430\u0440\u0442\u0430\u043D\u044B \u043A\u0456\u043C \u0436\u0435\u04A3\u0435\u0434\u0456?";
	};
	var bo_v12 = function bo_v12(match, outcome) {
	    return "FirstBlood " + outcome.condition + " \u043A\u0430\u0440\u0442\u0430\u0434\u0430";
	};
	var bo_w12 = function bo_w12(match, outcome) {
	    return "\u041A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F 1-\u0456\u043D\u0448\u0456 \u043A\u0430\u0440\u0442\u0430\u0434\u0430 " + outcome.condition + " \u04E9\u043B\u0442\u0456\u0440\u0443 \u0436\u0438\u043D\u0430\u0439\u0434\u044B";
	};
	var bo_x12 = function bo_x12(match, outcome) {
	    return "\u041A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F 2-\u043D\u0448\u0456 \u043A\u0430\u0440\u0442\u0430\u0434\u0430 " + outcome.condition + " \u04E9\u043B\u0442\u0456\u0440\u0443 \u0436\u0438\u043D\u0430\u0439\u0434\u044B";
	};
	var bo_y12 = function bo_y12(match, outcome) {
	    return "\u041A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F 3-\u0456\u043D\u0448\u0456 \u043A\u0430\u0440\u0442\u0430\u0434\u0430 " + outcome.condition + " \u04E9\u043B\u0442\u0456\u0440\u0443 \u0436\u0438\u043D\u0430\u0439\u0434\u044B";
	};
	var bo_z12 = function bo_z12(match, outcome) {
	    return "\u041A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F 4-\u0456\u043D\u0448\u0456 \u043A\u0430\u0440\u0442\u0430\u0434\u0430 " + outcome.condition + " \u04E9\u043B\u0442\u0456\u0440\u0443 \u0436\u0438\u043D\u0430\u0439\u0434\u044B";
	};
	var bo_a13 = function bo_a13(match, outcome) {
	    return "\u041A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F 5-\u0456\u043D\u0448\u0456 \u043A\u0430\u0440\u0442\u0430\u0434\u0430 " + outcome.condition + " \u04E9\u043B\u0442\u0456\u0440\u0443 \u0436\u0438\u043D\u0430\u0439\u0434\u044B";
	};
	var bo_b13 = function bo_b13(match, outcome) {
	    return 'Матчта нәтиже';
	};
	var bo_c13 = function bo_c13(match, outcome) {
	    return '1-інші картада жеңіс';
	};
	var bo_d13 = function bo_d13(match, outcome) {
	    return '2-нші картада жеңіс';
	};
	var bo_e13 = function bo_e13(match, outcome) {
	    return '3-інші картада жеңіс';
	};
	var bo_f13 = function bo_f13(match, outcome) {
	    return '4-інші картада жеңіс';
	};
	var bo_g13 = function bo_g13(match, outcome) {
	    return '5-інші картада жеңіс';
	};
	var bo_h13 = function bo_h13(match, outcome) {
	    return 'First blood бірінші картада';
	};
	var bo_i13 = function bo_i13(match, outcome) {
	    return 'First blood екінші картада';
	};
	var bo_j13 = function bo_j13(match, outcome) {
	    return 'First blood үшінші картада';
	};
	var bo_k13 = function bo_k13(match, outcome) {
	    return 'First blood төртінші картада';
	};
	var bo_l13 = function bo_l13(match, outcome) {
	    return 'First blood бесінші картада';
	};
	var bo_m13 = function bo_m13(match, outcome) {
	    return 'Буллиттерді ескерумен жеңіс';
	};
	var bo_n13 = function bo_n13(match, outcome) {
	    return match.homeTeam + " \u0435\u043A\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 \u0434\u0430 \u04B1\u0442\u0430\u0434\u044B";
	};
	var bo_o13 = function bo_o13(match, outcome) {
	    return match.awayTeam + " \u0435\u043A\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 \u0434\u0430 \u04B1\u0442\u0430\u0434\u044B";
	};
	var bo_p13 = function bo_p13(match, outcome) {
	    return outcome.conditionTwo + " \u0436\u04D9\u043D\u0435 \u043E\u0434\u0430\u043D \u043A\u04E9\u043F \u0433\u043E\u043B \u0441\u043E\u0493\u0430\u0442\u044B\u043D \u043A\u043E\u043C\u0430\u043D\u0434\u0430\u043B\u0430\u0440 (\u043E\u043B\u0430\u0440\u0434\u044B\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B)";
	};
	var bo_q13 = function bo_q13(match, outcome) {
	    return 'Еі нәтижелі команда (оның тоталы)';
	};
	var bo_r13 = function bo_r13(match, outcome) {
	    return 'Ең нәтижелі тайм (тотал)';
	};
	var bo_s13 = function bo_s13(match, outcome) {
	    return "\u0415\u043A\u0456 \u0442\u0430\u0439\u043C \u0434\u0430 \u0441\u0430\u043B\u044B\u0441\u0442\u044B\u0440\u0493\u0430\u043D\u0434\u0430 " + outcome.condition + " \u0430\u0437";
	};
	var bo_t13 = function bo_t13(match, outcome) {
	    return "\u0415\u043A\u0456 \u0442\u0430\u0439\u043C \u0434\u0430 \u0441\u0430\u043B\u044B\u0441\u0442\u044B\u0440\u0493\u0430\u043D\u0434\u0430 " + outcome.condition + " \u043A\u04E9\u043F";
	};
	var bo_u13 = function bo_u13(match, outcome) {
	    return 'Бірінші таймның жұп/тақ болуы';
	};
	var bo_v13 = function bo_v13(match, outcome) {
	    return 'Екінші таймның жұп/тақ болуы';
	};
	var bo_w13 = function bo_w13(match, outcome) {
	    return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 " + match.homeTeam + " \u043D\u0435\u0448\u0435 \u0433\u043E\u043B \u0441\u0430\u043B\u0430\u0434\u044B?";
	};
	var bo_x13 = function bo_x13(match, outcome) {
	    return "\u0415\u043A\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 " + match.homeTeam + " \u043D\u0435\u0448\u0435 \u0433\u043E\u043B \u0441\u0430\u043B\u0430\u0434\u044B?";
	};
	var bo_y13 = function bo_y13(match, outcome) {
	    return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 " + match.awayTeam + " \u043D\u0435\u0448\u0435 \u0433\u043E\u043B \u0441\u0430\u043B\u0430\u0434\u044B?";
	};
	var bo_z13 = function bo_z13(match, outcome) {
	    return "\u0415\u043A\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 " + match.awayTeam + " \u043D\u0435\u0448\u0435 \u0433\u043E\u043B \u0441\u0430\u043B\u0430\u0434\u044B?";
	};
	var bo_a14 = function bo_a14(match, outcome) {
	    return "\u041C\u0430\u0442\u0447\u0442\u0430 " + match.homeTeam + " \u043D\u0435\u0448\u0435 \u0433\u043E\u043B \u0441\u0430\u043B\u0430\u0434\u044B?";
	};
	var bo_b14 = function bo_b14(match, outcome) {
	    return "\u041C\u0430\u0442\u0447\u0442\u0430 " + match.awayTeam + " \u043D\u0435\u0448\u0435 \u0433\u043E\u043B \u0441\u0430\u043B\u0430\u0434\u044B?";
	};
	var bo_c14 = function bo_c14(match, outcome) {
	    return 'Ең нәтижесіз  команда (оның тоталы)';
	};
	var bo_d14 = function bo_d14(match, outcome) {
	    return match.homeTeam + " \u0442\u0435\u043A \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 \u0441\u043E\u0493\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_e14 = function bo_e14(match, outcome) {
	    return match.awayTeam + " \u0442\u0435\u043A \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 \u0441\u043E\u0493\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_f14 = function bo_f14(match, outcome) {
	    return match.homeTeam + " \u0442\u0435\u043A \u0435\u043A\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 \u0441\u043E\u0493\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_g14 = function bo_g14(match, outcome) {
	    return match.awayTeam + " \u0442\u0435\u043A \u0435\u043A\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 \u0441\u043E\u0493\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_h14 = function bo_h14(match, outcome) {
	    return 'Қанша команда бірінші таймда соғады';
	};
	var bo_i14 = function bo_i14(match, outcome) {
	    return 'Қанша команда екінші таймда соғады';
	};
	var bo_j14 = function bo_j14(match, outcome) {
	    return "\u049A\u0430\u043D\u0448\u0430 \u043A\u043E\u043C\u0430\u043D\u0434\u0430 " + outcome.condition + " \u0430\u0441\u0430 \u0441\u043E\u0493\u0430\u0434\u044B";
	};
	var bo_k14 = function bo_k14(match, outcome) {
	    return 'Бірінші гол қалай салынады?';
	};
	var bo_l14 = function bo_l14(match, outcome) {
	    return 'Келесі айналымға шығу';
	};
	var bo_m14 = function bo_m14(match, outcome) {
	    return 'Кім алаң ортасынан бастайды?';
	};
	var bo_n14 = function bo_n14(match, outcome) {
	    return 'Екі гол қатарынан бір командамен салынады';
	};
	var bo_o14 = function bo_o14(match, outcome) {
	    return match.homeTeam + " \u0435\u0440\u0456\u043A\u0442\u0456 \u0436\u0435\u04A3\u0456\u0441\u043A\u0435 \u0436\u0435\u0442\u0435\u0434\u0456";
	};
	var bo_p14 = function bo_p14(match, outcome) {
	    return "\u041A\u0456\u043C " + numeralFemaleEnding(outcome.condition) + " \u0421\u041A \u0430\u043B\u0430\u0434\u044B";
	};
	var bo_q14 = function bo_q14(match, outcome) {
	    return match.awayTeam + " \u0435\u0440\u0456\u043A\u0442\u0456 \u0436\u0435\u04A3\u0456\u0441\u043A\u0435 \u0436\u0435\u0442\u0435\u0434\u0456";
	};
	var bo_r14 = function bo_r14(match, outcome) {
	    return 'Матчта бірінші болып не орын алады?';
	};
	var bo_s14 = function bo_s14(match, outcome) {
	    return 'Дубль';
	};
	var bo_t14 = function bo_t14(match, outcome) {
	    return 'Хет-трик';
	};
	var bo_u14 = function bo_u14(match, outcome) {
	    return "\u041A\u0456\u043C " + numeralMaleEnding(outcome.condition) + " \u0431\u04B1\u0440\u044B\u0448\u0442\u0430\u043C\u0430\u043D\u044B \u0431\u0435\u0440\u0435\u0434\u0456?";
	};
	var bo_v14 = function bo_v14(match, outcome) {
	    return "\u0422\u0443\u0440\u0430 " + outcome.conditionTwo + " \u0441\u043E\u049B\u049B\u0430\u043D \u043A\u043E\u043C\u0430\u043D\u0434\u0430\u043B\u0430\u0440 (\u043E\u043B\u0430\u0440\u0434\u044B\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B)";
	};
	var bo_w14 = function bo_w14(match, outcome) {
	    return "\u041C\u0430\u0442\u0447\u0442\u0430 \u0442\u0443\u0440\u0430 " + outcome.condition + " \u0433\u043E\u043B \u0441\u0430\u043B\u0430\u0434\u044B \u043C\u0430";
	};
	var bo_x14 = function bo_x14(match, outcome) {
	    return 'Соңғы голды кім салады?';
	};
	var bo_y14 = function bo_y14(match, outcome) {
	    return 'Автогол';
	};
	var bo_z14 = function bo_z14(match, outcome) {
	    return 'Ауыстыруға шыққан ойыншы салады ма?';
	};
	var bo_a15 = function bo_a15(match, outcome) {
	    return 'Соңғы гол уақыты';
	};
	var bo_b15 = function bo_b15(match, outcome) {
	    return 'Кубок иегері';
	};
	var bo_c15 = function bo_c15(match, outcome) {
	    return 'Суперкубок иегері';
	};
	var bo_d15 = function bo_d15(match, outcome) {
	    return "\u049A\u0430\u0439 \u0442\u0430\u0439\u043C\u0434\u0430 " + numeralMaleEnding(outcome.condition) + " \u0433\u043E\u043B \u0433\u043E\u043B \u0441\u0430\u043B\u044B\u043D\u0430\u0434\u044B?";
	};
	var bo_e15 = function bo_e15(match, outcome) {
	    return '1-ден 15 минут аралығында қосарлы нәтиже';
	};
	var bo_f15 = function bo_f15(match, outcome) {
	    return '16-дан 30 минут аралығында қосарлы нәтиже';
	};
	var bo_g15 = function bo_g15(match, outcome) {
	    return '31 минуттан үзіліске дейін қосарлы нәтиже';
	};
	var bo_h15 = function bo_h15(match, outcome) {
	    return '46-дан 60 минут аралығында қосарлы нәтиже';
	};
	var bo_i15 = function bo_i15(match, outcome) {
	    return '61-ден 75 минут аралығында қосарлы нәтиже';
	};
	var bo_j15 = function bo_j15(match, outcome) {
	    return '76 минуттан НУ соңына дейін қосарлы нәтиже';
	};
	var bo_k15 = function bo_k15(match, outcome) {
	    return match.homeTeam + " " + numeralMaleEnding(outcome.condition) + " \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438\u0434\u0456 \u0441\u043E\u0493\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_l15 = function bo_l15(match, outcome) {
	    return match.awayTeam + " " + numeralMaleEnding(outcome.condition) + " \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438\u0434\u0456 \u0441\u043E\u0493\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_m15 = function bo_m15(match, outcome) {
	    return match.homeTeam + " \u04E9\u0437\u0456\u043D\u0456\u04A3 " + numeralMaleEnding(outcome.condition) + " \u0433\u043E\u043B\u044B\u043D \u0441\u043E\u0493\u0430\u0434\u044B";
	};
	var bo_n15 = function bo_n15(match, outcome) {
	    return match.awayTeam + " \u04E9\u0437\u0456\u043D\u0456\u04A3 " + numeralMaleEnding(outcome.condition) + " \u0433\u043E\u043B\u044B\u043D \u0441\u043E\u0493\u0430\u0434\u044B";
	};
	var bo_o15 = function bo_o15(match, outcome) {
	    return 'Бірінші таймдағы бұрыштамалар тоталы';
	};
	var bo_p15 = function bo_p15(match, outcome) {
	    return 'Бірінші таймдағы СК тоталы';
	};
	var bo_q15 = function bo_q15(match, outcome) {
	    return 'Матчтағы бұрыштамалар бойынша фора';
	};
	var bo_r15 = function bo_r15(match, outcome) {
	    return 'Бірінші таймдағы бұрыштамалар бойынша фора';
	};
	var bo_s15 = function bo_s15(match, outcome) {
	    return 'СК бойынша фора';
	};
	var bo_t15 = function bo_t15(match, outcome) {
	    return 'Бірінші таймда СК бойынша фора';
	};
	var bo_u15 = function bo_u15(match, outcome) {
	    return 'Бұрыштамалар бойынша матч нәтижесі';
	};
	var bo_v15 = function bo_v15(match, outcome) {
	    return 'Бұрыштамалар бойынша бірінші тайм нәтижесі';
	};
	var bo_w15 = function bo_w15(match, outcome) {
	    return 'СК бойынша матч нәтижесі';
	};
	var bo_x15 = function bo_x15(match, outcome) {
	    return 'СК бойынша бірінші тайм нәтижесі';
	};
	var bo_y15 = function bo_y15(match, outcome) {
	    return "\u041A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F " + outcome.condition + " " + plural(outcome.condition, ['гол']) + " \u0441\u0430\u043B\u0430\u0434\u044B";
	};
	var bo_z15 = function bo_z15(match, outcome) {
	    return " " + numeralMaleEnding(outcome.condition) + " \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438 \u0441\u0430\u043B\u044B\u043D\u0430\u0434\u044B \u043C\u0430";
	};
	var bo_a16 = function bo_a16(match, outcome) {
	    return 'Ауттар';
	};
	var bo_b16 = function bo_b16(match, outcome) {
	    return 'Тайм-Матч';
	};
	var bo_c16 = function bo_c16(match, outcome) {
	    return 'Матч тоталы (Азия)';
	};
	var bo_d16 = function bo_d16(match, outcome) {
	    return 'Бұрыштамалар тоталы';
	};
	var bo_e16 = function bo_e16(match, outcome) {
	    return 'Матч қалай аяқталады?';
	};
	var bo_f16 = function bo_f16(match, outcome) {
	    return 'Пенальти (тотал)';
	};
	var bo_g16 = function bo_g16(match, outcome) {
	    return 'Қызыл карточкалар тоталы';
	};
	var bo_h16 = function bo_h16(match, outcome) {
	    return 'Бірінші гол уақыты';
	};
	var bo_i16 = function bo_i16(match, outcome) {
	    return 'Минут голдар жиынтығы';
	};
	var bo_j16 = function bo_j16(match, outcome) {
	    return 'Екінші таймның тоталы';
	};
	var bo_k16 = function bo_k16(match, outcome) {
	    return 'Екінші таймдағы фора';
	};
	var bo_l16 = function bo_l16(match, outcome) {
	    return 'Қақпаның жақтауына соғу';
	};
	var bo_m16 = function bo_m16(match, outcome) {
	    return 'Сары карточкалар тоталы';
	};
	var bo_n16 = function bo_n16(match, outcome) {
	    return 'Екінші тайм нәтижесі';
	};
	var bo_o16 = function bo_o16(match, outcome) {
	    return '1-ден 15 минут аралығында матчтағы фора';
	};
	var bo_p16 = function bo_p16(match, outcome) {
	    return '16-дан 30 минут аралығында матчтағы фора';
	};
	var bo_q16 = function bo_q16(match, outcome) {
	    return '31 минуттан үзіліске дейін матчтағы фора';
	};
	var bo_r16 = function bo_r16(match, outcome) {
	    return '46-дан 60 минут аралығында матчтағы фора';
	};
	var bo_s16 = function bo_s16(match, outcome) {
	    return '61-ден 75 минут аралығында матчтағы фора';
	};
	var bo_t16 = function bo_t16(match, outcome) {
	    return '76 минуттан НУ соңына дейін матчтағы фора';
	};
	var bo_u16 = function bo_u16(match, outcome) {
	    return match.homeTeam + " \u0433\u043E\u043B\u0434\u0430\u0440";
	};
	var bo_v16 = function bo_v16(match, outcome) {
	    return match.awayTeam + " \u0433\u043E\u043B\u0434\u0430\u0440";
	};
	var bo_w16 = function bo_w16(match, outcome) {
	    return 'Ауыстырулар тоталы';
	};
	var bo_x16 = function bo_x16(match, outcome) {
	    return '1-ден 15 минут аралығындағы матч тоталы';
	};
	var bo_y16 = function bo_y16(match, outcome) {
	    return '16-дан 30 минут аралығындағы матч тоталы';
	};
	var bo_z16 = function bo_z16(match, outcome) {
	    return '31-ден минут үзіліске дейін аралығындағы матч тоталы';
	};
	var bo_a17 = function bo_a17(match, outcome) {
	    return '46-дан 60 минут аралығындағы матч тоталы';
	};
	var bo_b17 = function bo_b17(match, outcome) {
	    return '61-ден 75 минут аралығындағы матч тоталы';
	};
	var bo_c17 = function bo_c17(match, outcome) {
	    return '76 минуттан НУ соңына дейін матч тоталы';
	};
	var bo_d17 = function bo_d17(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u043C\u0430\u0442\u0447\u0442\u0430\u0493\u044B 1-\u0434\u0435\u043D 15 \u043C\u0438\u043D\u0443\u0442 \u0430\u0440\u0430\u043B\u044B\u0493\u044B\u043D\u0434\u0430";
	};
	var bo_e17 = function bo_e17(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u043C\u0430\u0442\u0447\u0442\u0430\u0493\u044B 16-\u0434\u0430\u043D 30 \u043C\u0438\u043D\u0443\u0442 \u0430\u0440\u0430\u043B\u044B\u0493\u044B\u043D\u0434\u0430";
	};
	var bo_f17 = function bo_f17(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u043C\u0430\u0442\u0447\u0442\u0430\u0493\u044B 31 \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u04AF\u0437\u0456\u043B\u0456\u0441\u043A\u0435 \u0434\u0435\u0439\u0456\u043D";
	};
	var bo_g17 = function bo_g17(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u043C\u0430\u0442\u0447\u0442\u0430\u0493\u044B 46-\u0434\u0430\u043D 60 \u043C\u0438\u043D\u0443\u0442 \u0430\u0440\u0430\u043B\u044B\u0493\u044B\u043D\u0434\u0430";
	};
	var bo_h17 = function bo_h17(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u043C\u0430\u0442\u0447\u0442\u0430\u0493\u044B 61-\u0434\u0435\u043D 75 \u043C\u0438\u043D\u0443\u0442 \u0430\u0440\u0430\u043B\u044B\u0493\u044B\u043D\u0434\u0430";
	};
	var bo_i17 = function bo_i17(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u043C\u0430\u0442\u0447\u0442\u0430\u0493\u044B 76 \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u041D\u0423 \u0441\u043E\u04A3\u044B\u043D\u0430 \u0434\u0435\u0439\u0456\u043D";
	};
	var bo_j17 = function bo_j17(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u043C\u0430\u0442\u0447\u0442\u0430\u0493\u044B 1-\u0434\u0435\u043D 15 \u043C\u0438\u043D\u0443\u0442 \u0430\u0440\u0430\u043B\u044B\u0493\u044B\u043D\u0434\u0430";
	};
	var bo_k17 = function bo_k17(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u043C\u0430\u0442\u0447\u0442\u0430\u0493\u044B 16-\u0434\u0430\u043D 30 \u043C\u0438\u043D\u0443\u0442 \u0430\u0440\u0430\u043B\u044B\u0493\u044B\u043D\u0434\u0430";
	};
	var bo_l17 = function bo_l17(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u043C\u0430\u0442\u0447\u0442\u0430\u0493\u044B 31 \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u04AF\u0437\u0456\u043B\u0456\u0441\u043A\u0435 \u0434\u0435\u0439\u0456\u043D";
	};
	var bo_m17 = function bo_m17(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u043C\u0430\u0442\u0447\u0442\u0430\u0493\u044B 46-\u0434\u0430\u043D 60 \u043C\u0438\u043D\u0443\u0442 \u0430\u0440\u0430\u043B\u044B\u0493\u044B\u043D\u0434\u0430";
	};
	var bo_n17 = function bo_n17(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u043C\u0430\u0442\u0447\u0442\u0430\u0493\u044B 61-\u0434\u0435\u043D 75 \u043C\u0438\u043D\u0443\u0442 \u0430\u0440\u0430\u043B\u044B\u0493\u044B\u043D\u0434\u0430";
	};
	var bo_o17 = function bo_o17(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u043C\u0430\u0442\u0447\u0442\u0430\u0493\u044B 76 \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u041D\u0423 \u0441\u043E\u04A3\u044B\u043D\u0430 \u0434\u0435\u0439\u0456\u043D";
	};
	var bo_p17 = function bo_p17(match, outcome) {
	    return 'Бірінші таймның дәл тоталы';
	};
	var bo_q17 = function bo_q17(match, outcome) {
	    return 'Екінші таймның дәл тоталы';
	};
	var bo_r17 = function bo_r17(match, outcome) {
	    return match.homeTeam + " \u04B1\u0442\u0430\u0434\u044B \u0436\u04D9\u043D\u0435 \u04E9\u0442\u043A\u0456\u0437\u0431\u0435\u0439\u0434\u0456";
	};
	var bo_s17 = function bo_s17(match, outcome) {
	    return match.awayTeam + " \u04B1\u0442\u0430\u0434\u044B \u0436\u04D9\u043D\u0435 \u04E9\u0442\u043A\u0456\u0437\u0431\u0435\u0439\u0434\u0456";
	};
	var bo_t17 = function bo_t17(match, outcome) {
	    return match.homeTeam + " \u0442\u0443\u0440\u0430 " + outcome.condition + " \u0433\u043E\u043B \u0441\u043E\u0493\u0430\u0434\u044B";
	};
	var bo_u17 = function bo_u17(match, outcome) {
	    return match.awayTeam + " \u0442\u0443\u0440\u0430 " + outcome.condition + " \u0433\u043E\u043B \u0441\u043E\u0493\u0430\u0434\u044B";
	};
	var bo_v17 = function bo_v17(match, outcome) {
	    return 'Бірінші таймның дәл есебі';
	};
	var bo_w17 = function bo_w17(match, outcome) {
	    return 'Екінші таймның дәл есебі';
	};
	var bo_x17 = function bo_x17(match, outcome) {
	    return 'Салынбаған пенальти';
	};
	var bo_y17 = function bo_y17(match, outcome) {
	    return "\u0415\u043A\u0456 \u043A\u043E\u043C\u0430\u043D\u0434\u0430 " + outcome.condition + " \u0441\u0430\u043B\u044B\u0441\u0442\u044B\u0440\u0493\u0430\u043D\u0434\u0430 \u0430\u0437 \u0441\u0430\u043B\u0430\u0434\u044B";
	};
	var bo_z17 = function bo_z17(match, outcome) {
	    return "\u0415\u043A\u0456 \u043A\u043E\u043C\u0430\u043D\u0434\u0430 " + outcome.condition + " \u0441\u0430\u043B\u044B\u0441\u0442\u044B\u0440\u0493\u0430\u043D\u0434\u0430 \u043A\u04E9\u043F \u0441\u0430\u043B\u0430\u0434\u044B";
	};
	var bo_a18 = function bo_a18(match, outcome) {
	    return 'Таймдарды (голдарды) салыстыру';
	};
	var bo_b18 = function bo_b18(match, outcome) {
	    return '1-ден 15 минут аралығында матчтағы жеңіс';
	};
	var bo_c18 = function bo_c18(match, outcome) {
	    return '16-дан 30 минут аралығында матчтағы жеңіс';
	};
	var bo_d18 = function bo_d18(match, outcome) {
	    return '31 минуттан үзіліске дейін матчтағы жеңіс';
	};
	var bo_e18 = function bo_e18(match, outcome) {
	    return '46-дан 60 минут аралығында матчтағы жеңіс';
	};
	var bo_f18 = function bo_f18(match, outcome) {
	    return '61-ден 75 минут аралығында матчтағы жеңіс';
	};
	var bo_g18 = function bo_g18(match, outcome) {
	    return '76 минуттан НУ соңына дейін матчтағы жеңіс';
	};
	var bo_h18 = function bo_h18(match, outcome) {
	    return match.homeTeam + " \u0442\u0430\u0439\u043C\u0434\u0430\u0440\u0434\u044B\u04A3 \u0431\u0456\u0440\u0456\u043D\u0434\u0435 \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_i18 = function bo_i18(match, outcome) {
	    return match.awayTeam + " \u0442\u0430\u0439\u043C\u0434\u0430\u0440\u0434\u044B\u04A3 \u0431\u0456\u0440\u0456\u043D\u0434\u0435 \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_j18 = function bo_j18(match, outcome) {
	    return outcome.conditionTwo + " - " + outcome.conditionThree + " \u0433\u043E\u043B\u0493\u0430 \u0434\u0435\u0439\u0456\u043D \u0441\u043E\u049B\u049B\u0430\u043D \u043A\u043E\u043C\u0430\u043D\u0434\u0430\u043B\u0430\u0440 (\u043E\u043B\u0430\u0440\u0434\u044B\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B)";
	};
	var bo_k18 = function bo_k18(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0435\u043A\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430";
	};
	var bo_l18 = function bo_l18(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0435\u043A\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430";
	};
	var bo_m18 = function bo_m18(match, outcome) {
	    return " " + outcome.playerName + " (" + match.homeTeam + ") \u0433\u043E\u043B \u0441\u0430\u043B\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_n18 = function bo_n18(match, outcome) {
	    return outcome.playerName + " (" + match.awayTeam + ") \u0433\u043E\u043B \u0441\u0430\u043B\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_o18 = function bo_o18(match, outcome) {
	    return 'Матч нәтижесі';
	};
	var bo_p18 = function bo_p18(match, outcome) {
	    return 'Матч форасы';
	};
	var bo_q18 = function bo_q18(match, outcome) {
	    return 'Қожайындар тоталы';
	};
	var bo_r18 = function bo_r18(match, outcome) {
	    return 'Қонақтар тоталы';
	};
	var bo_s18 = function bo_s18(match, outcome) {
	    return 'Ең нәтижелі матч тоталы';
	};
	var bo_t18 = function bo_t18(match, outcome) {
	    return 'Ең нәтижесіз матч тоталы';
	};
	var bo_u18 = function bo_u18(match, outcome) {
	    return 'Голсыз матч тоталы';
	};
	var bo_v18 = function bo_v18(match, outcome) {
	    return 'Қожайындар жеңістерінің тоталы';
	};
	var bo_w18 = function bo_w18(match, outcome) {
	    return 'Қонақтар жеңістерінің тоталы';
	};
	var bo_x18 = function bo_x18(match, outcome) {
	    return 'Тең ойын тоталы';
	};
	var bo_y18 = function bo_y18(match, outcome) {
	    return 'Қос нәтиже';
	};
	var bo_z18 = function bo_z18(match, outcome) {
	    return 'Команданың екеуі де салады: 1 тайм/2 тайм';
	};
	var bo_a19 = function bo_a19(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B " + outcome.condition + " \u0436\u04D9\u043D\u0435 \u0435\u043A\u0443\u0456 \u0434\u0435 \u0441\u0430\u043B\u0430\u0434\u044B";
	};
	var bo_b19 = function bo_b19(match, outcome) {
	    return match.homeTeam + " \u0441\u0430\u043B\u0430\u0434\u044B \u0436\u04D9\u043D\u0435 \u0436\u0435\u04A3\u0431\u0435\u0439\u0434\u0456";
	};
	var bo_c19 = function bo_c19(match, outcome) {
	    return match.awayTeam + " \u0437\u0441\u0430\u043B\u0430\u0434\u044B \u0436\u04D9\u043D\u0435 \u0436\u0435\u04A3\u0431\u0435\u0439\u0434\u0456";
	};
	var bo_d19 = function bo_d19(match, outcome) {
	    return 'Матчта жеңу тәсілі';
	};
	var bo_e19 = function bo_e19(match, outcome) {
	    return '1-інші таймда өтелген уақыт';
	};
	var bo_f19 = function bo_f19(match, outcome) {
	    return '2-інші таймда өтелген уақыт';
	};
	var bo_g19 = function bo_g19(match, outcome) {
	    return 'Матчта штанга/жолақ боалды ма';
	};
	var bo_h19 = function bo_h19(match, outcome) {
	    return 'Бірінші ауысу уақыты';
	};
	var bo_i19 = function bo_i19(match, outcome) {
	    return "\u049A\u044B\u0437\u044B\u043B \u043A\u0430\u0440\u0442\u0430\u043D\u044B " + match.homeTeam + " \u043E\u0439\u044B\u043D\u0448\u044B\u0441\u044B \u0430\u043B\u0430\u0434\u044B";
	};
	var bo_j19 = function bo_j19(match, outcome) {
	    return "\u049A\u044B\u0437\u044B\u043B \u043A\u0430\u0440\u0442\u0430\u043D\u044B" + match.awayTeam + " \u043E\u0439\u044B\u043D\u0448\u044B\u0441\u044B \u0430\u043B\u0430\u0434\u044B";
	};
	var bo_k19 = function bo_k19(match, outcome) {
	    return 'Пенальти мен жою болады ма';
	};
	var bo_l19 = function bo_l19(match, outcome) {
	    return 'Гол өтелген уақытта';
	};
	var bo_m19 = function bo_m19(match, outcome) {
	    return 'Алдау үшін Сары Карта';
	};
	var bo_n19 = function bo_n19(match, outcome) {
	    return 'Шешілген жейде үшін Сары Карта';
	};
	var bo_o19 = function bo_o19(match, outcome) {
	    return 'Әр жалаушадан бұрыштамалар';
	};
	var bo_p19 = function bo_p19(match, outcome) {
	    return '3-ші орын кім алады?';
	};
	var bo_q19 = function bo_q19(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + "  (\u049A\u043E\u0441\u044B\u043C\u0448\u0430 \u0443\u0430\u049B\u044B\u0442)";
	};
	var bo_r19 = function bo_r19(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + "  (\u049A\u043E\u0441\u044B\u043C\u0448\u0430 \u0443\u0430\u049B\u044B\u0442)";
	};
	var bo_s19 = function bo_s19(match, outcome) {
	    return 'Қос нәтиже (Қосымша уақыт)';
	};
	var bo_t19 = function bo_t19(match, outcome) {
	    return 'Дәл есеп (Қосымша уақыт)';
	};
	var bo_u19 = function bo_u19(match, outcome) {
	    return 'Фора (Қосымша уақыт)';
	};
	var bo_v19 = function bo_v19(match, outcome) {
	    return 'Тотал  (Қосымша уақыт)';
	};
	var bo_w19 = function bo_w19(match, outcome) {
	    return match.homeTeam + " - " + match.awayTeam + " (\u049A\u043E\u0441\u044B\u043C\u0448\u0430 \u0443\u0430\u049B\u044B\u0442)";
	};
	var bo_x19 = function bo_x19(match, outcome) {
	    return "\u041A\u0456\u043C " + numeralMaleEnding(outcome.condition) + " \u0433\u043E\u043B \u0441\u0430\u043B\u0430\u0434\u044B?";
	};
	var bo_y19 = function bo_y19(match, outcome) {
	    return 'Бірінші қосымша уақытта фора';
	};
	var bo_z19 = function bo_z19(match, outcome) {
	    return 'Бірінші қосымша уақыттың тоталы';
	};
	var bo_a20 = function bo_a20(match, outcome) {
	    return 'Бірінші қосымша уақытта нәтиже';
	};
	var bo_b20 = function bo_b20(match, outcome) {
	    return 'Екінші қосымша уақытта фора';
	};
	var bo_c20 = function bo_c20(match, outcome) {
	    return 'Екінші қосымша уақыттың тоталы';
	};
	var bo_d20 = function bo_d20(match, outcome) {
	    return 'Екінші қосымша уақытта нәтиже';
	};
	var bo_e20 = function bo_e20(match, outcome) {
	    return 'Пенальти сериясында дәл есеп';
	};
	var bo_f20 = function bo_f20(match, outcome) {
	    return "\u0441\u0430\u043B\u044B\u043D\u0493\u0430\u043D \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438 \u0442\u043E\u0442\u0430\u043B\u044B: " + match.awayTeam + " (\u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438 \u0441\u0435\u0440\u0438\u044F\u0441\u044B)";
	};
	var bo_g20 = function bo_g20(match, outcome) {
	    return "\u0421\u0430\u043B\u044B\u043D\u0493\u0430\u043D \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438 \u0442\u043E\u0442\u0430\u043B\u044B: " + match.homeTeam + " (\u0441\u0435\u0440\u0438\u044F \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438)";
	};
	var bo_h20 = function bo_h20(match, outcome) {
	    return 'салынған пенальти тоталы:  (пенальти сериясы)';
	};
	var bo_i20 = function bo_i20(match, outcome) {
	    return 'Салынбаған пенальти тоталы:  (пенальти сериясы)';
	};
	var bo_j20 = function bo_j20(match, outcome) {
	    return "\u0415\u0443\u0440\u043E\u043F\u0430\u043B\u044B\u043B\u044B\u049B \u0444\u043E\u0440\u0430 " + europeanHandicapCondition(outcome.condition);
	};
	var bo_k20 = function bo_k20(match, outcome) {
	    return "\u0415\u0443\u0440\u043E\u043F\u0430\u043B\u044B\u049B \u0444\u043E\u0440\u0430 " + europeanHandicapCondition(outcome.condition) + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430";
	};
	var bo_l20 = function bo_l20(match, outcome) {
	    return "\u0415\u0443\u0440\u043E\u043F\u0430\u043B\u044B\u049B \u0444\u043E\u0440\u0430 " + europeanHandicapCondition(outcome.condition) + " 2-\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430";
	};
	var bo_m20 = function bo_m20(match, outcome) {
	    return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 \u043A\u0456\u043C " + numeralMaleEnding(outcome.condition) + " \u0433\u043E\u043B \u0441\u0430\u043B\u0430\u0434\u044B?";
	};
	var bo_n20 = function bo_n20(match, outcome) {
	    return "\u041C\u0430\u0442\u0447\u0442\u044B\u04A3 \u049B\u0430\u043B\u0493\u0430\u043D \u0443\u0430\u049B\u044B\u0442\u044B (\u0430\u0493\u044B\u043C\u0434\u0430\u0493\u044B \u0435\u0441\u0435\u043F " + outcome.condition + ":" + outcome.conditionTwo + ")";
	};
	var bo_o20 = function bo_o20(match, outcome) {
	    return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u043D\u044B\u04A3 \u049B\u0430\u043B\u0493\u0430\u043D \u0443\u0430\u049B\u044B\u0442\u044B (\u0430\u0493\u044B\u043C\u0434\u0430\u0493\u044B \u0435\u0441\u0435\u043F " + outcome.condition + ":" + outcome.conditionTwo + ")";
	};
	var bo_p20 = function bo_p20(match, outcome) {
	    return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u043D\u044B\u04A3 \u0431\u04B1\u0440\u044B\u0448\u0442\u0430\u043C\u0430\u043B\u0430\u0440 \u0442\u043E\u0442\u0430\u043B\u044B: " + match.homeTeam;
	};
	var bo_q20 = function bo_q20(match, outcome) {
	    return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u043D\u044B\u04A3 \u0431\u04B1\u0440\u044B\u0448\u0442\u0430\u043C\u0430\u043B\u0430\u0440 \u0442\u043E\u0442\u0430\u043B\u044B: " + match.awayTeam;
	};
	var bo_r20 = function bo_r20(match, outcome) {
	    return "\u0411\u04B1\u0440\u044B\u0448\u0442\u0430\u043C\u0430\u043B\u0430\u0440 \u0442\u043E\u0442\u0430\u043B\u044B: " + match.homeTeam;
	};
	var bo_s20 = function bo_s20(match, outcome) {
	    return "\u0411\u04B1\u0440\u044B\u0448\u0442\u0430\u043C\u0430\u043B\u0430\u0440 \u0442\u043E\u0442\u0430\u043B\u044B: " + match.awayTeam;
	};
	var bo_t20 = function bo_t20(match, outcome) {
	    return 'Бірінші гол уақыты (мин)';
	};
	var bo_u20 = function bo_u20(match, outcome) {
	    return 'Бірінші таймның қос нәтижесі';
	};
	var bo_v20 = function bo_v20(match, outcome) {
	    return 'Екінші таймның қос нәтижесі';
	};
	var bo_w20 = function bo_w20(match, outcome) {
	    return 'Екеуі де алады ма?';
	};
	var bo_x20 = function bo_x20(match, outcome) {
	    return match.homeTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_y20 = function bo_y20(match, outcome) {
	    return match.homeTeam + " \u0435\u043A\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_z20 = function bo_z20(match, outcome) {
	    return match.awayTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_a21 = function bo_a21(match, outcome) {
	    return match.awayTeam + " \u0435\u043A\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_b21 = function bo_b21(match, outcome) {
	    return 'Хет-триктер (олардың тоталы)';
	};
	var bo_c21 = function bo_c21(match, outcome) {
	    return 'Бірінші кезеңнің тоталы';
	};
	var bo_d21 = function bo_d21(match, outcome) {
	    return 'Екінші кезеңнің тоталы';
	};
	var bo_e21 = function bo_e21(match, outcome) {
	    return 'Үшінші кезеңнің тоталы';
	};
	var bo_f21 = function bo_f21(match, outcome) {
	    return 'Бірінші кезеңнің дәл есебі';
	};
	var bo_g21 = function bo_g21(match, outcome) {
	    return 'Екінші кезеңнің дәл есебі';
	};
	var bo_h21 = function bo_h21(match, outcome) {
	    return 'Үшінші кезеңнің дәл есебі';
	};
	var bo_i21 = function bo_i21(match, outcome) {
	    return 'Бірінші кезеңнің жұп/тақ болуы';
	};
	var bo_j21 = function bo_j21(match, outcome) {
	    return 'Екінші кезеңнің жұп/тақ болуы';
	};
	var bo_k21 = function bo_k21(match, outcome) {
	    return 'Үшінші кезеңнің жұп/тақ болуы';
	};
	var bo_l21 = function bo_l21(match, outcome) {
	    return 'Ең нәтижелі кезең (тотал)';
	};
	var bo_m21 = function bo_m21(match, outcome) {
	    return 'Ең нәтижесіз кезең (тотал)';
	};
	var bo_n21 = function bo_n21(match, outcome) {
	    return 'Бірінші кезеңнің дәл тоталы';
	};
	var bo_o21 = function bo_o21(match, outcome) {
	    return 'Екінші кезеңнің дәл тоталы';
	};
	var bo_p21 = function bo_p21(match, outcome) {
	    return 'Үшінші кезеңнің дәл тоталы';
	};
	var bo_q21 = function bo_q21(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u043A\u0435\u0437\u0435\u04A3\u0434\u0435";
	};
	var bo_r21 = function bo_r21(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0435\u043A\u0456\u043D\u0448\u0456 \u043A\u0435\u0437\u0435\u04A3\u0434\u0435";
	};
	var bo_s21 = function bo_s21(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u04AF\u0448\u0456\u043D\u0448\u0456 \u043A\u0435\u0437\u0435\u04A3\u0434\u0435";
	};
	var bo_t21 = function bo_t21(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u043A\u0435\u0437\u0435\u04A3\u0434\u0435";
	};
	var bo_u21 = function bo_u21(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0435\u043A\u0456\u043D\u0448\u0456 \u043A\u0435\u0437\u0435\u04A3\u0434\u0435";
	};
	var bo_v21 = function bo_v21(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u04AF\u0448\u0456\u043D\u0448\u0456 \u043A\u0435\u0437\u0435\u04A3\u0434\u0435";
	};
	var bo_w21 = function bo_w21(match, outcome) {
	    return 'Екі команда да салады';
	};
	var bo_x21 = function bo_x21(match, outcome) {
	    return 'ОТ ескерумен жеңіс';
	};
	var bo_y21 = function bo_y21(match, outcome) {
	    return 'Период-Матч';
	};
	var bo_z21 = function bo_z21(match, outcome) {
	    return match.homeTeam + " \u04D9\u0440 \u043A\u0435\u0437\u0435\u04A3\u0434\u0456 \u0441\u0430\u043B\u0430\u0434\u044B";
	};
	var bo_a22 = function bo_a22(match, outcome) {
	    return match.awayTeam + " \u04D9\u0440 \u043A\u0435\u0437\u0435\u04A3\u0434\u0435 \u0441\u0430\u043B\u0430\u0434\u044B";
	};
	var bo_b22 = function bo_b22(match, outcome) {
	    return 'Барлық кезеңдерде салады';
	};
	var bo_c22 = function bo_c22(match, outcome) {
	    return 'бірінші және екінші кезеңді салыстыру';
	};
	var bo_d22 = function bo_d22(match, outcome) {
	    return 'Бірінші және үшінші кезеңді салыстыру';
	};
	var bo_e22 = function bo_e22(match, outcome) {
	    return 'Екінші және үшінші кезеңді салыстыру';
	};
	var bo_f22 = function bo_f22(match, outcome) {
	    return match.homeTeam + " \u043A\u0435\u0437\u0435\u04A3\u0434\u0435\u0440\u0434\u0456\u04A3 \u0431\u0456\u0440\u0435\u0443\u0456\u043D\u0434\u0435 \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_g22 = function bo_g22(match, outcome) {
	    return match.awayTeam + " \u043A\u0435\u0437\u0435\u04A3\u0434\u0435\u0440\u0434\u0456\u04A3 \u0431\u0456\u0440\u0435\u0443\u0456\u043D\u0434\u0435 \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_h22 = function bo_h22(match, outcome) {
	    return 'Кемінде бір кезеңде тең ойын';
	};
	var bo_i22 = function bo_i22(match, outcome) {
	    return 'Матчта 1-10 минутқа дейін жеңу';
	};
	var bo_j22 = function bo_j22(match, outcome) {
	    return 'Матчта 11-20 минутқа дейін жеңу';
	};
	var bo_k22 = function bo_k22(match, outcome) {
	    return 'Матчта 21-30 минутқа дейін жеңу';
	};
	var bo_l22 = function bo_l22(match, outcome) {
	    return 'Матчта 31-40 минутқа дейін жеңу';
	};
	var bo_m22 = function bo_m22(match, outcome) {
	    return 'Матчта 41-50 минутқа дейін жеңу';
	};
	var bo_n22 = function bo_n22(match, outcome) {
	    return 'Матчта 51-60 минутқа дейін жеңу';
	};
	var bo_o22 = function bo_o22(match, outcome) {
	    return 'Матчта 1-10 минутқа дейін фора';
	};
	var bo_p22 = function bo_p22(match, outcome) {
	    return 'Матчта 11-20 минутқа дейін фора';
	};
	var bo_q22 = function bo_q22(match, outcome) {
	    return 'Матчта 21-30 минутқа дейін фора';
	};
	var bo_r22 = function bo_r22(match, outcome) {
	    return 'Матчта 31-40 минутқа дейін фора';
	};
	var bo_s22 = function bo_s22(match, outcome) {
	    return 'Матчта 41-50 минутқа дейін фора';
	};
	var bo_t22 = function bo_t22(match, outcome) {
	    return 'Матчта 51-60 минутқа дейін фора';
	};
	var bo_u22 = function bo_u22(match, outcome) {
	    return 'Матчта 1-10 минутқа дейін тотал';
	};
	var bo_v22 = function bo_v22(match, outcome) {
	    return 'Матчта 11-20 минутқа дейін тотал';
	};
	var bo_w22 = function bo_w22(match, outcome) {
	    return 'Матчта 21-30 минутқа дейін тотал';
	};
	var bo_x22 = function bo_x22(match, outcome) {
	    return 'Матчта 31-40 минутқа дейін тотал';
	};
	var bo_y22 = function bo_y22(match, outcome) {
	    return 'Матчта 41-50 минутқа дейін тотал';
	};
	var bo_z22 = function bo_z22(match, outcome) {
	    return 'Матчта 51-60 минутқа дейін тотал';
	};
	var bo_a23 = function bo_a23(match, outcome) {
	    return 'Бірінші кезеңді неше команда салады?';
	};
	var bo_b23 = function bo_b23(match, outcome) {
	    return 'Екінші кезеңді неше команда салады?';
	};
	var bo_c23 = function bo_c23(match, outcome) {
	    return 'Үшінші кезеңді неше команда салады?';
	};
	var bo_d23 = function bo_d23(match, outcome) {
	    return match.homeTeam + " \u0435\u0440\u0456\u043A\u0442\u0456\u043A \u0436\u0435\u04A3\u0456\u0441\u043A\u0435 \u0436\u0435\u0442\u0435\u0434\u0456";
	};
	var bo_e23 = function bo_e23(match, outcome) {
	    return match.awayTeam + " \u0435\u0440\u0456\u043A\u0442\u0456\u043A \u0436\u0435\u04A3\u0456\u0441\u043A\u0435 \u0436\u0435\u0442\u0435\u0434\u0456";
	};
	var bo_f23 = function bo_f23(match, outcome) {
	    return 'Чет/Нечет наибольшего выпавшего шара';
	};
	var bo_g23 = function bo_g23(match, outcome) {
	    return 'Чет/Нечет наименьшего выпавшего шара';
	};
	var bo_h23 = function bo_h23(match, outcome) {
	    return 'Чет/Нечет первого выпавшего шара';
	};
	var bo_i23 = function bo_i23(match, outcome) {
	    return 'Чет/Нечет последнего выпавшего шара';
	};
	var bo_j23 = function bo_j23(match, outcome) {
	    return 'Первый меньше/больше последнего';
	};
	var bo_k23 = function bo_k23(match, outcome) {
	    return 'Все шары четные';
	};
	var bo_l23 = function bo_l23(match, outcome) {
	    return 'Все шары нечетные';
	};
	var bo_m23 = function bo_m23(match, outcome) {
	    return 'Хотя бы два шара с соседними номерами';
	};
	var bo_n23 = function bo_n23(match, outcome) {
	    return 'Наименьший выпавший шар';
	};
	var bo_o23 = function bo_o23(match, outcome) {
	    return 'Наибольший выпавший шар';
	};
	var bo_p23 = function bo_p23(match, outcome) {
	    return 'Сумма выпавших шаров';
	};
	var bo_q23 = function bo_q23(match, outcome) {
	    return "\u0425\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u0438\u043D \u0438\u0437 \u0432\u044B\u043F\u0430\u0432\u0448\u0438\u0445 \u0448\u0430\u0440\u043E\u0432 \u043A\u0440\u0430\u0442\u0435\u043D " + outcome.condition;
	};
	var bo_r23 = function bo_r23(match, outcome) {
	    return 'Разница между наименьшим и наибольшим шарами';
	};
	var bo_s23 = function bo_s23(match, outcome) {
	    return 'Сумма нечетных шаров';
	};
	var bo_t23 = function bo_t23(match, outcome) {
	    return 'Сумма четных шаров';
	};
	var bo_u23 = function bo_u23(match, outcome) {
	    return 'Первый выпавший шар';
	};
	var bo_v23 = function bo_v23(match, outcome) {
	    return 'Второй выпавший шар';
	};
	var bo_w23 = function bo_w23(match, outcome) {
	    return 'Третий выпавший шар';
	};
	var bo_x23 = function bo_x23(match, outcome) {
	    return 'Четвертый выпавший шар';
	};
	var bo_y23 = function bo_y23(match, outcome) {
	    return 'Пятый выпавший шар';
	};
	var bo_z23 = function bo_z23(match, outcome) {
	    return 'Шестой выпавший шар';
	};
	var bo_a24 = function bo_a24(match, outcome) {
	    return 'Седьмой выпавший шар';
	};
	var bo_b24 = function bo_b24(match, outcome) {
	    return "\u0425\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u0438\u043D \u0448\u0430\u0440 \u043F\u043E\u043F\u0430\u0434\u0435\u0442 \u0432 \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B \u043E\u0442 " + outcome.condition + " \u0434\u043E " + outcome.conditionTwo;
	};
	var bo_c24 = function bo_c24(match, outcome) {
	    return 'Сумма наименьшего и наибольшего шаров';
	};
	var bo_d24 = function bo_d24(match, outcome) {
	    return 'Ұрыста жеңіске жету';
	};
	var bo_e24 = function bo_e24(match, outcome) {
	    return 'Мерзімнен ерте жеңіс болады ма?';
	};
	var bo_f24 = function bo_f24(match, outcome) {
	    return match.homeTeam + " \u0430\u0443\u044B\u0440\u0442\u0443/\u0442\u04B1\u043D\u0448\u044B\u049B\u0442\u044B\u0440\u0443/\u0435\u0440\u0456\u043A\u0442\u0456 \u0431\u0435\u0440\u0456\u043B\u0443 \u0430\u0440\u049B\u044B\u043B\u044B \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_g24 = function bo_g24(match, outcome) {
	    return match.awayTeam + " \u0430\u0443\u044B\u0440\u0442\u0443/\u0442\u04B1\u043D\u0448\u044B\u049B\u0442\u044B\u0440\u0443/\u0435\u0440\u0456\u043A\u0442\u0456 \u0431\u0435\u0440\u0456\u043B\u0443 \u0430\u0440\u049B\u044B\u043B\u044B \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_h24 = function bo_h24(match, outcome) {
	    return match.homeTeam + "  \u043D\u043E\u043A\u0430\u0443\u0442\u043F\u0435\u043D/\u0442\u0435\u0445\u043D\u0438\u043A\u0430\u043B\u044B\u049B \u043D\u043E\u043A\u0430\u0443\u0442\u043F\u0435\u043D/\u0414\u0438\u0441\u043A\u0432\u0430\u043B\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_i24 = function bo_i24(match, outcome) {
	    return match.awayTeam + "  \u043D\u043E\u043A\u0430\u0443\u0442\u043F\u0435\u043D/\u0442\u0435\u0445\u043D\u0438\u043A\u0430\u043B\u044B\u049B \u043D\u043E\u043A\u0430\u0443\u0442\u043F\u0435\u043D/\u0414\u0438\u0441\u043A\u0432\u0430\u043B\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_j24 = function bo_j24(match, outcome) {
	    return 'Медальдар тоталы';
	};
	var bo_k24 = function bo_k24(match, outcome) {
	    return 'Жиырма тоғызыншы партияның нәтижесі';
	};
	var bo_l24 = function bo_l24(match, outcome) {
	    return 'Отызыншы партияның нәтижесі';
	};
	var bo_m24 = function bo_m24(match, outcome) {
	    return 'Отыз бірінші партияның нәтижесі';
	};
	var bo_n24 = function bo_n24(match, outcome) {
	    return 'Отыз екінші партияның нәтижесі';
	};
	var bo_o24 = function bo_o24(match, outcome) {
	    return 'Отыз үшінші партияның нәтижесі';
	};
	var bo_p24 = function bo_p24(match, outcome) {
	    return 'Отыз төртінші партияның нәтижесі';
	};
	var bo_q24 = function bo_q24(match, outcome) {
	    return 'Отыз бесінші партияның нәтижесі';
	};
	var bo_r24 = function bo_r24(match, outcome) {
	    return 'Отыз алтыншы партияның нәтижесі';
	};
	var bo_s24 = function bo_s24(match, outcome) {
	    return 'Отыз жетінші партияның нәтижесі';
	};
	var bo_t24 = function bo_t24(match, outcome) {
	    return 'Он сегізінші партияның жұп/тақ болуы';
	};
	var bo_u24 = function bo_u24(match, outcome) {
	    return 'Он тоғызыншы партияның жұп/тақ болуы';
	};
	var bo_v24 = function bo_v24(match, outcome) {
	    return 'Жиырмасыншы партияның жұп/тақ болуы';
	};
	var bo_w24 = function bo_w24(match, outcome) {
	    return 'Жиырма бірінші партияның жұп/тақ болуы';
	};
	var bo_x24 = function bo_x24(match, outcome) {
	    return 'Жиырма екінші партияның жұп/тақ болуы';
	};
	var bo_y24 = function bo_y24(match, outcome) {
	    return 'Жиырма үшінші партияның жұп/тақ болуы';
	};
	var bo_z24 = function bo_z24(match, outcome) {
	    return 'Жиырма төртінші партияның жұп/тақ болуы';
	};
	var bo_a25 = function bo_a25(match, outcome) {
	    return 'Жиырма бесінші партияның жұп/тақ болуы';
	};
	var bo_b25 = function bo_b25(match, outcome) {
	    return 'Жиырма алтыншы партияның жұп/тақ болуы';
	};
	var bo_c25 = function bo_c25(match, outcome) {
	    return 'Жиырма жетінші партияның жұп/тақ болуы';
	};
	var bo_d25 = function bo_d25(match, outcome) {
	    return 'Жиырма сегізінші партияның жұп/тақ болуы';
	};
	var bo_e25 = function bo_e25(match, outcome) {
	    return 'Жиырма тоғызыншы партияның жұп/тақ болуы';
	};
	var bo_f25 = function bo_f25(match, outcome) {
	    return 'Отызыншы партияның жұп/тақ болуы';
	};
	var bo_g25 = function bo_g25(match, outcome) {
	    return 'Отыз бірінші партияның жұп/тақ болуы';
	};
	var bo_h25 = function bo_h25(match, outcome) {
	    return 'Отыз екінші партияның жұп/тақ болуы';
	};
	var bo_i25 = function bo_i25(match, outcome) {
	    return 'Отыз үшінші партияның жұп/тақ болуы';
	};
	var bo_j25 = function bo_j25(match, outcome) {
	    return 'Отыз төртінші партияның жұп/тақ болуы';
	};
	var bo_k25 = function bo_k25(match, outcome) {
	    return 'Отыз бесінші партияның жұп/тақ болуы';
	};
	var bo_l25 = function bo_l25(match, outcome) {
	    return 'Отыз алтыншы партияның жұп/тақ болуы';
	};
	var bo_m25 = function bo_m25(match, outcome) {
	    return 'Отыз жетінші партияның жұп/тақ болуы';
	};
	var bo_n25 = function bo_n25(match, outcome) {
	    return 'Бірінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_o25 = function bo_o25(match, outcome) {
	    return 'Екінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_p25 = function bo_p25(match, outcome) {
	    return 'Үшінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_q25 = function bo_q25(match, outcome) {
	    return 'Төртінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_r25 = function bo_r25(match, outcome) {
	    return 'Бесінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_s25 = function bo_s25(match, outcome) {
	    return 'Алтыншы партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_t25 = function bo_t25(match, outcome) {
	    return 'Жетінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_u25 = function bo_u25(match, outcome) {
	    return 'Сегізінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_v25 = function bo_v25(match, outcome) {
	    return 'Тоғызыншы партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_w25 = function bo_w25(match, outcome) {
	    return 'Оныншы партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_x25 = function bo_x25(match, outcome) {
	    return 'Он бірінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_y25 = function bo_y25(match, outcome) {
	    return 'Он екінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_z25 = function bo_z25(match, outcome) {
	    return 'Он үшінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_a26 = function bo_a26(match, outcome) {
	    return 'Он төртінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_b26 = function bo_b26(match, outcome) {
	    return 'Он бесінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_c26 = function bo_c26(match, outcome) {
	    return 'Он алтыншы партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_d26 = function bo_d26(match, outcome) {
	    return 'Он жетінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_e26 = function bo_e26(match, outcome) {
	    return 'Он сегізінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_f26 = function bo_f26(match, outcome) {
	    return 'Он тоғызыншы партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_g26 = function bo_g26(match, outcome) {
	    return 'Жиырмасыншы партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_h26 = function bo_h26(match, outcome) {
	    return 'Жиырма бірінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_i26 = function bo_i26(match, outcome) {
	    return 'Жиырма екінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_j26 = function bo_j26(match, outcome) {
	    return 'Жиырма үшінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_k26 = function bo_k26(match, outcome) {
	    return 'Жиырма төртінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_l26 = function bo_l26(match, outcome) {
	    return 'Жиырма бесінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_m26 = function bo_m26(match, outcome) {
	    return 'Жиырма алтыншы партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_n26 = function bo_n26(match, outcome) {
	    return 'Жиырма жетінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_o26 = function bo_o26(match, outcome) {
	    return 'Жиырма сегізінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_p26 = function bo_p26(match, outcome) {
	    return 'Жиырма тоғызыншы партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_q26 = function bo_q26(match, outcome) {
	    return 'Отызыншы партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_r26 = function bo_r26(match, outcome) {
	    return 'Отыз бірінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_s26 = function bo_s26(match, outcome) {
	    return 'Отыз екінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_t26 = function bo_t26(match, outcome) {
	    return 'Отыз үшінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_u26 = function bo_u26(match, outcome) {
	    return 'Отыз төртінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_v26 = function bo_v26(match, outcome) {
	    return 'Отыз бесінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_w26 = function bo_w26(match, outcome) {
	    return 'Отыз алтыншы партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_x26 = function bo_x26(match, outcome) {
	    return 'Отыз жетінші партияда қандай түсті шар бірінші болып салынады?';
	};
	var bo_y26 = function bo_y26(match, outcome) {
	    return 'Бірінші партияның нәтижесі';
	};
	var bo_z26 = function bo_z26(match, outcome) {
	    return 'Екінші партияның нәтижесі';
	};
	var bo_a27 = function bo_a27(match, outcome) {
	    return 'Үшінші партияның нәтижесі';
	};
	var bo_b27 = function bo_b27(match, outcome) {
	    return 'Төртінші партияның нәтижесі';
	};
	var bo_c27 = function bo_c27(match, outcome) {
	    return 'Бесінші партияның нәтижесі';
	};
	var bo_d27 = function bo_d27(match, outcome) {
	    return 'Алтыншы партияның нәтижесі';
	};
	var bo_e27 = function bo_e27(match, outcome) {
	    return 'Жетінші партияның нәтижесі';
	};
	var bo_f27 = function bo_f27(match, outcome) {
	    return 'Сегізінші партияның нәтижесі';
	};
	var bo_g27 = function bo_g27(match, outcome) {
	    return 'Тоғызыншы партияның нәтижесі';
	};
	var bo_h27 = function bo_h27(match, outcome) {
	    return 'Оныншы партияның нәтижесі';
	};
	var bo_i27 = function bo_i27(match, outcome) {
	    return 'Он бірінші партияның нәтижесі';
	};
	var bo_j27 = function bo_j27(match, outcome) {
	    return 'Он екінші партияның нәтижесі';
	};
	var bo_k27 = function bo_k27(match, outcome) {
	    return 'Он үшінші партияның нәтижесі';
	};
	var bo_l27 = function bo_l27(match, outcome) {
	    return 'Он төртінші партияның нәтижесі';
	};
	var bo_m27 = function bo_m27(match, outcome) {
	    return 'Он бесінші партияның нәтижесі';
	};
	var bo_n27 = function bo_n27(match, outcome) {
	    return 'Он алтыншы партияның нәтижесі';
	};
	var bo_o27 = function bo_o27(match, outcome) {
	    return 'Он жетінші партияның нәтижесі';
	};
	var bo_p27 = function bo_p27(match, outcome) {
	    return 'Он сегізінші партияның нәтижесі';
	};
	var bo_q27 = function bo_q27(match, outcome) {
	    return 'Он тоғызыншы партияның нәтижесі';
	};
	var bo_r27 = function bo_r27(match, outcome) {
	    return 'Жиырмасыншы партияның нәтижесі';
	};
	var bo_s27 = function bo_s27(match, outcome) {
	    return 'Жиырма бірінші партияның нәтижесі';
	};
	var bo_t27 = function bo_t27(match, outcome) {
	    return 'Жиырма екінші партияның нәтижесі';
	};
	var bo_u27 = function bo_u27(match, outcome) {
	    return 'Жиырма үшінші партияның нәтижесі';
	};
	var bo_v27 = function bo_v27(match, outcome) {
	    return 'Жиырма төртінші партияның нәтижесі';
	};
	var bo_w27 = function bo_w27(match, outcome) {
	    return 'Жиырма бесінші партияның нәтижесі';
	};
	var bo_x27 = function bo_x27(match, outcome) {
	    return 'Жиырма алтыншы партияның нәтижесі';
	};
	var bo_y27 = function bo_y27(match, outcome) {
	    return 'Жиырма жетінші партияның нәтижесі';
	};
	var bo_z27 = function bo_z27(match, outcome) {
	    return 'Жиырма сегізінші партияның нәтижесі';
	};
	var bo_a28 = function bo_a28(match, outcome) {
	    return 'Жетінші партияда кім бірінші болып шар соғады?';
	};
	var bo_b28 = function bo_b28(match, outcome) {
	    return 'Сегізінші партияда кім бірінші болып шар соғады?';
	};
	var bo_c28 = function bo_c28(match, outcome) {
	    return 'Тоғызыншы партияда кім бірінші болып шар соғады?';
	};
	var bo_d28 = function bo_d28(match, outcome) {
	    return 'Оныншы партияда кім бірінші болып шар соғады?';
	};
	var bo_e28 = function bo_e28(match, outcome) {
	    return 'Он бірінші партияда кім бірінші болып шар соғады?';
	};
	var bo_f28 = function bo_f28(match, outcome) {
	    return 'Он екінші партияда кім бірінші болып шар соғады?';
	};
	var bo_g28 = function bo_g28(match, outcome) {
	    return 'Он үшінші партияда кім бірінші болып шар соғады?';
	};
	var bo_h28 = function bo_h28(match, outcome) {
	    return 'Он төртінші партияда кім бірінші болып шар соғады?';
	};
	var bo_i28 = function bo_i28(match, outcome) {
	    return 'Он бесінші партияда кім бірінші болып шар соғады?';
	};
	var bo_j28 = function bo_j28(match, outcome) {
	    return 'Он алтыншы партияда кім бірінші болып шар соғады?';
	};
	var bo_k28 = function bo_k28(match, outcome) {
	    return 'Он жетінші партияда кім бірінші болып шар соғады?';
	};
	var bo_l28 = function bo_l28(match, outcome) {
	    return 'Он сегізінші партияда кім бірінші болып шар соғады?';
	};
	var bo_m28 = function bo_m28(match, outcome) {
	    return 'Он тоғызыншы партияда кім бірінші болып шар соғады?';
	};
	var bo_n28 = function bo_n28(match, outcome) {
	    return 'Жиырмасыншы партияда кім бірінші болып шар соғады?';
	};
	var bo_o28 = function bo_o28(match, outcome) {
	    return 'Жиырма бірінші партияда кім бірінші болып шар соғады?';
	};
	var bo_p28 = function bo_p28(match, outcome) {
	    return 'Жиырма екінші партияда кім бірінші болып шар соғады?';
	};
	var bo_q28 = function bo_q28(match, outcome) {
	    return 'Жиырма үшінші партияда кім бірінші болып шар соғады?';
	};
	var bo_r28 = function bo_r28(match, outcome) {
	    return 'Жиырма төртінші партияда кім бірінші болып шар соғады?';
	};
	var bo_s28 = function bo_s28(match, outcome) {
	    return 'Жиырма бесінші партияда кім бірінші болып шар соғады?';
	};
	var bo_t28 = function bo_t28(match, outcome) {
	    return 'Жиырма алтыншы партияда кім бірінші болып шар соғады?';
	};
	var bo_u28 = function bo_u28(match, outcome) {
	    return 'Жиырма жетінші партияда кім бірінші болып шар соғады?';
	};
	var bo_v28 = function bo_v28(match, outcome) {
	    return 'Жиырма сегізінші партияда кім бірінші болып шар соғады?';
	};
	var bo_w28 = function bo_w28(match, outcome) {
	    return 'Жиырма тоғызыншы партияда кім бірінші болып шар соғады?';
	};
	var bo_x28 = function bo_x28(match, outcome) {
	    return 'Отызыншы партияда кім бірінші болып шар соғады?';
	};
	var bo_y28 = function bo_y28(match, outcome) {
	    return 'Отыз бірінші партияда кім бірінші болып шар соғады?';
	};
	var bo_z28 = function bo_z28(match, outcome) {
	    return 'Отыз екінші партияда кім бірінші болып шар соғады?';
	};
	var bo_a29 = function bo_a29(match, outcome) {
	    return 'Отыз үшінші партияда кім бірінші болып шар соғады?';
	};
	var bo_b29 = function bo_b29(match, outcome) {
	    return 'Отыз төртінші партияда кім бірінші болып шар соғады?';
	};
	var bo_c29 = function bo_c29(match, outcome) {
	    return 'Отыз бесінші партияда кім бірінші болып шар соғады?';
	};
	var bo_d29 = function bo_d29(match, outcome) {
	    return 'Отыз алтыншы партияда кім бірінші болып шар соғады?';
	};
	var bo_e29 = function bo_e29(match, outcome) {
	    return 'Отыз жетінші партияда кім бірінші болып шар соғады?';
	};
	var bo_f29 = function bo_f29(match, outcome) {
	    return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_g29 = function bo_g29(match, outcome) {
	    return "\u0415\u043A\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_h29 = function bo_h29(match, outcome) {
	    return "\u04AE\u0448\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_i29 = function bo_i29(match, outcome) {
	    return "\u0422\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_j29 = function bo_j29(match, outcome) {
	    return "\u0411\u0435\u0441\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_k29 = function bo_k29(match, outcome) {
	    return "\u0410\u043B\u0442\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_l29 = function bo_l29(match, outcome) {
	    return "\u0416\u0435\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_m29 = function bo_m29(match, outcome) {
	    return "\u0421\u0435\u0433\u0456\u0437\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_n29 = function bo_n29(match, outcome) {
	    return "\u0422\u043E\u0493\u044B\u0437\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_o29 = function bo_o29(match, outcome) {
	    return "\u041E\u043D\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_p29 = function bo_p29(match, outcome) {
	    return "\u041E\u043D \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_q29 = function bo_q29(match, outcome) {
	    return "\u041E\u043D \u0435\u043A\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_r29 = function bo_r29(match, outcome) {
	    return "\u041E\u043D \u04AF\u0448\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_s29 = function bo_s29(match, outcome) {
	    return "\u041E\u043D \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_t29 = function bo_t29(match, outcome) {
	    return "\u041E\u043D \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_u29 = function bo_u29(match, outcome) {
	    return "\u041E\u043D \u0430\u043B\u0442\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_v29 = function bo_v29(match, outcome) {
	    return "\u041E\u043D \u0436\u0435\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_w29 = function bo_w29(match, outcome) {
	    return "\u041E\u043D \u0441\u0435\u0433\u0456\u0437\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_x29 = function bo_x29(match, outcome) {
	    return "\u041E\u043D \u0442\u043E\u0493\u044B\u0437\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_y29 = function bo_y29(match, outcome) {
	    return "\u0416\u0438\u044B\u0440\u043C\u0430\u0441\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_z29 = function bo_z29(match, outcome) {
	    return "\u0416\u0438\u044B\u0440\u043C\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_a30 = function bo_a30(match, outcome) {
	    return "\u0416\u0438\u044B\u0440\u043C\u0430 \u0435\u043A\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_b30 = function bo_b30(match, outcome) {
	    return "\u0416\u0438\u044B\u0440\u043C\u0430 \u04AF\u0448\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_c30 = function bo_c30(match, outcome) {
	    return "\u0416\u0438\u044B\u0440\u043C\u0430 \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_d30 = function bo_d30(match, outcome) {
	    return "\u0416\u0438\u044B\u0440\u043C\u0430 \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_e30 = function bo_e30(match, outcome) {
	    return "\u0416\u0438\u044B\u0440\u043C\u0430 \u0430\u043B\u0442\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_f30 = function bo_f30(match, outcome) {
	    return "\u0416\u0438\u044B\u0440\u043C\u0430 \u0436\u0435\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_g30 = function bo_g30(match, outcome) {
	    return "\u0416\u0438\u044B\u0440\u043C\u0430 \u0441\u0435\u0433\u0456\u0437\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_h30 = function bo_h30(match, outcome) {
	    return "\u0416\u0438\u044B\u0440\u043C\u0430 \u0442\u043E\u0493\u044B\u0437\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_i30 = function bo_i30(match, outcome) {
	    return "\u041E\u0442\u044B\u0437\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_j30 = function bo_j30(match, outcome) {
	    return "\u041E\u0442\u044B\u0437 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_k30 = function bo_k30(match, outcome) {
	    return "\u041E\u0442\u044B\u0437 \u0435\u043A\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_l30 = function bo_l30(match, outcome) {
	    return "\u041E\u0442\u044B\u0437 \u04AF\u0448\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_m30 = function bo_m30(match, outcome) {
	    return "\u041E\u0442\u044B\u0437 \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_n30 = function bo_n30(match, outcome) {
	    return "\u041E\u0442\u044B\u0437 \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_o30 = function bo_o30(match, outcome) {
	    return "\u041E\u0442\u044B\u0437 \u0430\u043B\u0442\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_p30 = function bo_p30(match, outcome) {
	    return "\u041E\u0442\u044B\u0437 \u0436\u0435\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?";
	};
	var bo_q30 = function bo_q30(match, outcome) {
	    return 'Бірінші партияның жұп/тақ болуы';
	};
	var bo_r30 = function bo_r30(match, outcome) {
	    return 'Екінші партияның жұп/тақ болуы';
	};
	var bo_s30 = function bo_s30(match, outcome) {
	    return 'Үшінші партияның жұп/тақ болуы';
	};
	var bo_t30 = function bo_t30(match, outcome) {
	    return 'Төртінші партияның жұп/тақ болуы';
	};
	var bo_u30 = function bo_u30(match, outcome) {
	    return 'Бесінші партияның жұп/тақ болуы';
	};
	var bo_v30 = function bo_v30(match, outcome) {
	    return 'Алтыншы партияның жұп/тақ болуы';
	};
	var bo_w30 = function bo_w30(match, outcome) {
	    return 'Жетінші партияның жұп/тақ болуы';
	};
	var bo_x30 = function bo_x30(match, outcome) {
	    return 'Сегізінші партияның жұп/тақ болуы';
	};
	var bo_y30 = function bo_y30(match, outcome) {
	    return 'Тоғызыншы партияның жұп/тақ болуы';
	};
	var bo_z30 = function bo_z30(match, outcome) {
	    return 'Оныншы партияның жұп/тақ болуы';
	};
	var bo_a31 = function bo_a31(match, outcome) {
	    return 'Он бірінші партияның жұп/тақ болуы';
	};
	var bo_b31 = function bo_b31(match, outcome) {
	    return 'Он екінші партияның жұп/тақ болуы';
	};
	var bo_c31 = function bo_c31(match, outcome) {
	    return 'Он үшінші партияның жұп/тақ болуы';
	};
	var bo_d31 = function bo_d31(match, outcome) {
	    return 'Он төртінші партияның жұп/тақ болуы';
	};
	var bo_e31 = function bo_e31(match, outcome) {
	    return 'Он бесінші партияның жұп/тақ болуы';
	};
	var bo_f31 = function bo_f31(match, outcome) {
	    return 'Он алтыншы партияның жұп/тақ болуы';
	};
	var bo_g31 = function bo_g31(match, outcome) {
	    return 'Он жетінші партияның жұп/тақ болуы';
	};
	var bo_h31 = function bo_h31(match, outcome) {
	    return 'Матчтағы сенчури брейктер тоталы';
	};
	var bo_i31 = function bo_i31(match, outcome) {
	    return 'Бірінші партиядағы фора';
	};
	var bo_j31 = function bo_j31(match, outcome) {
	    return 'Екінші партиядағы фора';
	};
	var bo_k31 = function bo_k31(match, outcome) {
	    return 'Үшінші партиядағы фора';
	};
	var bo_l31 = function bo_l31(match, outcome) {
	    return 'Төртінші партиядағы фора';
	};
	var bo_m31 = function bo_m31(match, outcome) {
	    return 'Бесінші партиядағы фора';
	};
	var bo_n31 = function bo_n31(match, outcome) {
	    return 'Алтыншы партиядағы фора';
	};
	var bo_o31 = function bo_o31(match, outcome) {
	    return 'Жетінші партиядағы фора';
	};
	var bo_p31 = function bo_p31(match, outcome) {
	    return 'Сегізінші партиядағы фора';
	};
	var bo_q31 = function bo_q31(match, outcome) {
	    return 'Тоғызыншы партиядағы фора';
	};
	var bo_r31 = function bo_r31(match, outcome) {
	    return 'Оныншы партиядағы фора';
	};
	var bo_s31 = function bo_s31(match, outcome) {
	    return 'Он бірінші партиядағы фора';
	};
	var bo_t31 = function bo_t31(match, outcome) {
	    return 'Он екінші партиядағы фора';
	};
	var bo_u31 = function bo_u31(match, outcome) {
	    return 'Он үшінші партиядағы фора';
	};
	var bo_v31 = function bo_v31(match, outcome) {
	    return 'Он төртінші партиядағы фора';
	};
	var bo_w31 = function bo_w31(match, outcome) {
	    return 'Он бесінші партиядағы фора';
	};
	var bo_x31 = function bo_x31(match, outcome) {
	    return 'Он алтыншы партиядағы фора';
	};
	var bo_y31 = function bo_y31(match, outcome) {
	    return 'Он жетінші партиядағы фора';
	};
	var bo_z31 = function bo_z31(match, outcome) {
	    return 'Он сегізінші партиядағы фора';
	};
	var bo_a32 = function bo_a32(match, outcome) {
	    return 'Он тоғызыншы партиядағы фора';
	};
	var bo_b32 = function bo_b32(match, outcome) {
	    return 'Жиырмасыншы партиядағы фора';
	};
	var bo_c32 = function bo_c32(match, outcome) {
	    return 'Жиырма бірінші партиядағы фора';
	};
	var bo_d32 = function bo_d32(match, outcome) {
	    return 'Жиырма екінші партиядағы фора';
	};
	var bo_e32 = function bo_e32(match, outcome) {
	    return 'Жиырма үшінші партиядағы фора';
	};
	var bo_f32 = function bo_f32(match, outcome) {
	    return 'Жиырма төртінші партиядағы фора';
	};
	var bo_g32 = function bo_g32(match, outcome) {
	    return 'Жиырма бесінші партиядағы фора';
	};
	var bo_h32 = function bo_h32(match, outcome) {
	    return 'Жиырма алтыншы партиядағы фора';
	};
	var bo_i32 = function bo_i32(match, outcome) {
	    return 'Жиырма жетінші партиядағы фора';
	};
	var bo_j32 = function bo_j32(match, outcome) {
	    return 'Жиырма сегізінші партиядағы фора';
	};
	var bo_k32 = function bo_k32(match, outcome) {
	    return 'Жиырма тоғызыншы партиядағы фора';
	};
	var bo_l32 = function bo_l32(match, outcome) {
	    return 'Отызыншы партиядағы фора';
	};
	var bo_m32 = function bo_m32(match, outcome) {
	    return 'Отыз бірінші партиядағы фора';
	};
	var bo_n32 = function bo_n32(match, outcome) {
	    return 'Отыз екінші партиядағы фора';
	};
	var bo_o32 = function bo_o32(match, outcome) {
	    return 'Отыз үшінші партиядағы фора';
	};
	var bo_p32 = function bo_p32(match, outcome) {
	    return 'Отыз төртінші партиядағы фора';
	};
	var bo_q32 = function bo_q32(match, outcome) {
	    return 'Отыз бесінші партиядағы фора';
	};
	var bo_r32 = function bo_r32(match, outcome) {
	    return 'Отыз алтыншы партиядағы фора';
	};
	var bo_s32 = function bo_s32(match, outcome) {
	    return 'Отыз жетінші партиядағы фора';
	};
	var bo_t32 = function bo_t32(match, outcome) {
	    return 'Бірінші партияның тоталы';
	};
	var bo_u32 = function bo_u32(match, outcome) {
	    return 'Екінші партияның тоталы';
	};
	var bo_v32 = function bo_v32(match, outcome) {
	    return 'Үшінші партияның тоталы';
	};
	var bo_w32 = function bo_w32(match, outcome) {
	    return 'Төртінші партияның тоталы';
	};
	var bo_x32 = function bo_x32(match, outcome) {
	    return 'Бесінші партияның тоталы';
	};
	var bo_y32 = function bo_y32(match, outcome) {
	    return 'Алтыншы партияның тоталы';
	};
	var bo_z32 = function bo_z32(match, outcome) {
	    return 'Жетінші партияның тоталы';
	};
	var bo_a33 = function bo_a33(match, outcome) {
	    return 'Сегізінші партияның тоталы';
	};
	var bo_b33 = function bo_b33(match, outcome) {
	    return 'Тоғызыншы партияның тоталы';
	};
	var bo_c33 = function bo_c33(match, outcome) {
	    return 'Оныншы партияның тоталы';
	};
	var bo_d33 = function bo_d33(match, outcome) {
	    return 'Он бірінші партияның тоталы';
	};
	var bo_e33 = function bo_e33(match, outcome) {
	    return 'Он екінші партияның тоталы';
	};
	var bo_f33 = function bo_f33(match, outcome) {
	    return 'Он үшінші партияның тоталы';
	};
	var bo_g33 = function bo_g33(match, outcome) {
	    return 'Он төртінші партияның тоталы';
	};
	var bo_h33 = function bo_h33(match, outcome) {
	    return 'Он бесінші партияның тоталы';
	};
	var bo_i33 = function bo_i33(match, outcome) {
	    return 'Он алтыншы партияның тоталы';
	};
	var bo_j33 = function bo_j33(match, outcome) {
	    return 'Он жетінші партияның тоталы';
	};
	var bo_k33 = function bo_k33(match, outcome) {
	    return 'Он сегізінші партияның тоталы';
	};
	var bo_l33 = function bo_l33(match, outcome) {
	    return 'Он тоғызыншы партияның тоталы';
	};
	var bo_m33 = function bo_m33(match, outcome) {
	    return 'Жиырмасыншы партияның тоталы';
	};
	var bo_n33 = function bo_n33(match, outcome) {
	    return 'Жиырма бірінші партияның тоталы';
	};
	var bo_o33 = function bo_o33(match, outcome) {
	    return 'Жиырма екінші партияның тоталы';
	};
	var bo_p33 = function bo_p33(match, outcome) {
	    return 'Жиырма үшінші партияның тоталы';
	};
	var bo_q33 = function bo_q33(match, outcome) {
	    return 'Жиырма төртінші партияның тоталы';
	};
	var bo_r33 = function bo_r33(match, outcome) {
	    return 'Жиырма бесінші партияның тоталы';
	};
	var bo_s33 = function bo_s33(match, outcome) {
	    return 'Жиырма алтыншы партияның тоталы';
	};
	var bo_t33 = function bo_t33(match, outcome) {
	    return 'Жиырма жетінші партияның тоталы';
	};
	var bo_u33 = function bo_u33(match, outcome) {
	    return 'Жиырма сегізінші партияның тоталы';
	};
	var bo_v33 = function bo_v33(match, outcome) {
	    return 'Жиырма тоғызыншы партияның тоталы';
	};
	var bo_w33 = function bo_w33(match, outcome) {
	    return 'Отызыншы партияның тоталы';
	};
	var bo_x33 = function bo_x33(match, outcome) {
	    return 'Отыз бірінші партияның тоталы';
	};
	var bo_y33 = function bo_y33(match, outcome) {
	    return 'Отыз екінші партияның тоталы';
	};
	var bo_z33 = function bo_z33(match, outcome) {
	    return 'Отыз үшінші партияның тоталы';
	};
	var bo_a34 = function bo_a34(match, outcome) {
	    return 'Отыз төртінші партияның тоталы';
	};
	var bo_b34 = function bo_b34(match, outcome) {
	    return 'Отыз бесінші партияның тоталы';
	};
	var bo_c34 = function bo_c34(match, outcome) {
	    return 'Отыз алтыншы партияның тоталы';
	};
	var bo_d34 = function bo_d34(match, outcome) {
	    return 'Отыз жетінші партияның тоталы';
	};
	var bo_e34 = function bo_e34(match, outcome) {
	    return 'Бірінші партияда кім бірінші болып шар соғады?';
	};
	var bo_f34 = function bo_f34(match, outcome) {
	    return 'Екінші партияда кім бірінші болып шар соғады?';
	};
	var bo_g34 = function bo_g34(match, outcome) {
	    return 'Үшінші партияда кім бірінші болып шар соғады?';
	};
	var bo_h34 = function bo_h34(match, outcome) {
	    return 'Төртінші партияда кім бірінші болып шар соғады?';
	};
	var bo_i34 = function bo_i34(match, outcome) {
	    return 'Бесінші партияда кім бірінші болып шар соғады?';
	};
	var bo_j34 = function bo_j34(match, outcome) {
	    return 'Алтыншы партияда кім бірінші болып шар соғады?';
	};
	var bo_k34 = function bo_k34(match, outcome) {
	    return 'Матчтағы партиялар тоталы';
	};
	var bo_l34 = function bo_l34(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430";
	};
	var bo_m34 = function bo_m34(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0435\u043A\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430";
	};
	var bo_n34 = function bo_n34(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u04AF\u0448\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430";
	};
	var bo_o34 = function bo_o34(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430";
	};
	var bo_p34 = function bo_p34(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430";
	};
	var bo_q34 = function bo_q34(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0430\u043B\u0442\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430";
	};
	var bo_r34 = function bo_r34(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0436\u0435\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430";
	};
	var bo_s34 = function bo_s34(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430";
	};
	var bo_t34 = function bo_t34(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0435\u043A\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430";
	};
	var bo_u34 = function bo_u34(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u04AF\u0448\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430";
	};
	var bo_v34 = function bo_v34(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430";
	};
	var bo_w34 = function bo_w34(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430";
	};
	var bo_x34 = function bo_x34(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0430\u043B\u0442\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430";
	};
	var bo_y34 = function bo_y34(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0436\u0435\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430";
	};
	var bo_z34 = function bo_z34(match, outcome) {
	    return match.homeTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0440\u0430 " + outcome.condition + " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_a35 = function bo_a35(match, outcome) {
	    return match.homeTeam + " \u0435\u043A\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0443\u0440\u0430 " + outcome.condition + " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_b35 = function bo_b35(match, outcome) {
	    return match.homeTeam + " \u04AF\u0448\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0443\u0440\u0430 " + outcome.condition + " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_c35 = function bo_c35(match, outcome) {
	    return match.homeTeam + " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0440\u0430 " + outcome.condition + " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_d35 = function bo_d35(match, outcome) {
	    return match.homeTeam + " \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0443\u0440\u0430 " + outcome.condition + " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_e35 = function bo_e35(match, outcome) {
	    return match.homeTeam + " \u0430\u043B\u0442\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0443\u0440\u0430 " + outcome.condition + " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_f35 = function bo_f35(match, outcome) {
	    return match.homeTeam + " \u0436\u0435\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0443\u0440\u0430 " + outcome.condition + " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_g35 = function bo_g35(match, outcome) {
	    return match.awayTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0440\u0430 " + outcome.condition + " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_h35 = function bo_h35(match, outcome) {
	    return match.awayTeam + " \u0435\u043A\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0443\u0440\u0430 " + outcome.condition + " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_i35 = function bo_i35(match, outcome) {
	    return match.awayTeam + " \u04AF\u0448\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0443\u0440\u0430 " + outcome.condition + " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_j35 = function bo_j35(match, outcome) {
	    return match.awayTeam + " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0440\u0430 " + outcome.condition + " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_k35 = function bo_k35(match, outcome) {
	    return match.awayTeam + " \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0443\u0440\u0430 " + outcome.condition + " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_l35 = function bo_l35(match, outcome) {
	    return match.awayTeam + " \u0430\u043B\u0442\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0443\u0440\u0430 " + outcome.condition + " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_m35 = function bo_m35(match, outcome) {
	    return match.awayTeam + " \u0436\u0435\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0443\u0440\u0430 " + outcome.condition + " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_n35 = function bo_n35(match, outcome) {
	    return 'Бірінші партияның дәл тоталы';
	};
	var bo_o35 = function bo_o35(match, outcome) {
	    return 'Екінші партияның дәл тоталы';
	};
	var bo_p35 = function bo_p35(match, outcome) {
	    return 'Үшінші партияның дәл тоталы';
	};
	var bo_q35 = function bo_q35(match, outcome) {
	    return 'Төртінші партияның дәл тоталы';
	};
	var bo_r35 = function bo_r35(match, outcome) {
	    return 'Бесінші партияның дәл тоталы';
	};
	var bo_s35 = function bo_s35(match, outcome) {
	    return 'Алтыншы партияның дәл тоталы';
	};
	var bo_t35 = function bo_t35(match, outcome) {
	    return 'Жетінші партияның дәл тоталы';
	};
	var bo_u35 = function bo_u35(match, outcome) {
	    return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u043A\u0456\u043C " + numeralNeuterEnding(outcome.condition) + " \u04B1\u043F\u0430\u0439 \u04B1\u0442\u0430\u0434\u044B";
	};
	var bo_v35 = function bo_v35(match, outcome) {
	    return "\u0415\u043A\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u043A\u0456\u043C " + numeralNeuterEnding(outcome.condition) + " \u04B1\u043F\u0430\u0439 \u04B1\u0442\u0430\u0434\u044B";
	};
	var bo_w35 = function bo_w35(match, outcome) {
	    return "\u04AE\u0448\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u043A\u0456\u043C " + numeralNeuterEnding(outcome.condition) + " \u04B1\u043F\u0430\u0439 \u04B1\u0442\u0430\u0434\u044B";
	};
	var bo_x35 = function bo_x35(match, outcome) {
	    return "\u0422\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u043A\u0456\u043C " + numeralNeuterEnding(outcome.condition) + " \u04B1\u043F\u0430\u0439 \u04B1\u0442\u0430\u0434\u044B";
	};
	var bo_y35 = function bo_y35(match, outcome) {
	    return "\u0411\u0435\u0441\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u043A\u0456\u043C " + numeralNeuterEnding(outcome.condition) + " \u04B1\u043F\u0430\u0439 \u04B1\u0442\u0430\u0434\u044B";
	};
	var bo_z35 = function bo_z35(match, outcome) {
	    return "\u0410\u043B\u0442\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u043A\u0456\u043C " + numeralNeuterEnding(outcome.condition) + " \u04B1\u043F\u0430\u0439 \u04B1\u0442\u0430\u0434\u044B";
	};
	var bo_a36 = function bo_a36(match, outcome) {
	    return "\u0416\u0435\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u043A\u0456\u043C " + numeralNeuterEnding(outcome.condition) + " \u04B1\u043F\u0430\u0439 \u04B1\u0442\u0430\u0434\u044B";
	};
	var bo_b36 = function bo_b36(match, outcome) {
	    return 'Жұп/бірінші кезеңнің тотал тағы';
	};
	var bo_c36 = function bo_c36(match, outcome) {
	    return 'Жұп/екінші кезеңнің тотал тағы';
	};
	var bo_d36 = function bo_d36(match, outcome) {
	    return 'Жұп/үшінші кезеңнің тотал тағы';
	};
	var bo_e36 = function bo_e36(match, outcome) {
	    return 'Жұп/төртінші кезеңнің тотал тағы';
	};
	var bo_f36 = function bo_f36(match, outcome) {
	    return 'Жұп/бесінші кезеңнің тотал тағы';
	};
	var bo_g36 = function bo_g36(match, outcome) {
	    return 'Жұп/алтыншы кезеңнің тотал тағы';
	};
	var bo_h36 = function bo_h36(match, outcome) {
	    return 'Жұп/жетінші кезеңнің тотал тағы';
	};
	var bo_i36 = function bo_i36(match, outcome) {
	    return 'Матчтың дәл есебі';
	};
	var bo_j36 = function bo_j36(match, outcome) {
	    return match.awayTeam + " 1-\u0448\u0456 \u043D\u0435\u043C\u0435\u0441\u0435 2-\u0448\u0456 \u0433\u0435\u0439\u043C\u0434\u0435\u0440\u0434\u0435 \u0431\u0440\u0435\u0439\u043A \u0436\u0430\u0441\u0430\u0439\u0434\u044B";
	};
	var bo_k36 = function bo_k36(match, outcome) {
	    return 'Теннисшімен қатарынан алынған геймдердің ең жоғарғы саны';
	};
	var bo_l36 = function bo_l36(match, outcome) {
	    return 'Брейктермен алмасу болады ма (екі қатар)?';
	};
	var bo_m36 = function bo_m36(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435";
	};
	var bo_n36 = function bo_n36(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435";
	};
	var bo_o36 = function bo_o36(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435";
	};
	var bo_p36 = function bo_p36(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435";
	};
	var bo_q36 = function bo_q36(match, outcome) {
	    return 'Төртінші сеттің жұп/тақ болуы';
	};
	var bo_r36 = function bo_r36(match, outcome) {
	    return 'Бесінші сеттің жұп/тақ болуы';
	};
	var bo_s36 = function bo_s36(match, outcome) {
	    return 'Бірінші сет/матч';
	};
	var bo_t36 = function bo_t36(match, outcome) {
	    return outcome.condition + " \u0433\u0435\u0439\u043C\u0434\u0435 \u0431\u0440\u0435\u0439\u043A \u043F\u043E\u0439\u043D\u0442 \u0431\u043E\u043B\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_u36 = function bo_u36(match, outcome) {
	    return 'Екінші сеттің брейктердің тоталы';
	};
	var bo_v36 = function bo_v36(match, outcome) {
	    return 'Үшінші сеттің брейктердің тоталы';
	};
	var bo_w36 = function bo_w36(match, outcome) {
	    return 'Төртінші сеттің брейктердің тоталы';
	};
	var bo_x36 = function bo_x36(match, outcome) {
	    return 'Бесінші сеттің брейктердің тоталы';
	};
	var bo_y36 = function bo_y36(match, outcome) {
	    return "\u0416\u0435\u04A3\u0456\u0441 \u0436\u04D9\u043D\u0435 \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B " + outcome.condition;
	};
	var bo_z36 = function bo_z36(match, outcome) {
	    return "\u0416\u0435\u04A3\u0456\u0441 \u0436\u04D9\u043D\u0435 \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B " + outcome.condition;
	};
	var bo_a37 = function bo_a37(match, outcome) {
	    return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: " + match.homeTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435";
	};
	var bo_b37 = function bo_b37(match, outcome) {
	    return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: " + match.homeTeam + " \u0435\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435";
	};
	var bo_c37 = function bo_c37(match, outcome) {
	    return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: " + match.homeTeam + " \u04AF\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435";
	};
	var bo_d37 = function bo_d37(match, outcome) {
	    return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: " + match.homeTeam + " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435";
	};
	var bo_e37 = function bo_e37(match, outcome) {
	    return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: " + match.homeTeam + " \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435";
	};
	var bo_f37 = function bo_f37(match, outcome) {
	    return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: " + match.awayTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435";
	};
	var bo_g37 = function bo_g37(match, outcome) {
	    return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: " + match.awayTeam + " \u0435\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435";
	};
	var bo_h37 = function bo_h37(match, outcome) {
	    return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: " + match.awayTeam + " \u04AF\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435";
	};
	var bo_i37 = function bo_i37(match, outcome) {
	    return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: " + match.awayTeam + " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435";
	};
	var bo_j37 = function bo_j37(match, outcome) {
	    return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: " + match.awayTeam + " \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435";
	};
	var bo_k37 = function bo_k37(match, outcome) {
	    return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u04D9\u043B\u0434\u0435\u043A\u0456\u043C \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D " + outcome.condition + " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_l37 = function bo_l37(match, outcome) {
	    return "\u0415\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u04D9\u043B\u0434\u0435\u043A\u0456\u043C \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D " + outcome.condition + " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_m37 = function bo_m37(match, outcome) {
	    return "\u04AE\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u04D9\u043B\u0434\u0435\u043A\u0456\u043C \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D " + outcome.condition + " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_n37 = function bo_n37(match, outcome) {
	    return "\u0422\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u04D9\u043B\u0434\u0435\u043A\u0456\u043C \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D " + outcome.condition + " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_o37 = function bo_o37(match, outcome) {
	    return "\u0411\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u04D9\u043B\u0434\u0435\u043A\u0456\u043C \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D " + outcome.condition + " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_p37 = function bo_p37(match, outcome) {
	    return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 " + match.homeTeam + " \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D " + outcome.condition + " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_q37 = function bo_q37(match, outcome) {
	    return "\u0415\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 " + match.homeTeam + " \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D " + outcome.condition + " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_r37 = function bo_r37(match, outcome) {
	    return "\u04AE\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 " + match.homeTeam + " \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D " + outcome.condition + " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_s37 = function bo_s37(match, outcome) {
	    return "\u0422\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 " + match.homeTeam + " \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D " + outcome.condition + " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_t37 = function bo_t37(match, outcome) {
	    return "\u0411\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 " + match.homeTeam + " \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D " + outcome.condition + " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_u37 = function bo_u37(match, outcome) {
	    return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 " + match.awayTeam + " \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D " + outcome.condition + " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_v37 = function bo_v37(match, outcome) {
	    return "\u0415\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 " + match.awayTeam + " \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D " + outcome.condition + " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_w37 = function bo_w37(match, outcome) {
	    return "\u04AE\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 " + match.awayTeam + " \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D " + outcome.condition + " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_x37 = function bo_x37(match, outcome) {
	    return "\u0422\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 " + match.awayTeam + " \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D " + outcome.condition + " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_y37 = function bo_y37(match, outcome) {
	    return "\u0411\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 " + match.awayTeam + " \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D " + outcome.condition + " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_z37 = function bo_z37(match, outcome) {
	    return 'Төртінші сеттегі фора';
	};
	var bo_a38 = function bo_a38(match, outcome) {
	    return 'Бесінші сеттегі фора';
	};
	var bo_b38 = function bo_b38(match, outcome) {
	    return 'Төртінші сеттің тоталы';
	};
	var bo_c38 = function bo_c38(match, outcome) {
	    return 'Бесінші сеттің тоталы';
	};
	var bo_d38 = function bo_d38(match, outcome) {
	    return outcome.condition + " \u0433\u0435\u0439\u043C\u043D\u0456\u04A3 \u0434\u04D9\u043B \u0435\u0441\u0435\u0431\u0456";
	};
	var bo_e38 = function bo_e38(match, outcome) {
	    return outcome.condition + " \u0433\u0435\u0439\u043C\u0434\u0456 \u043A\u0456\u043C \u0430\u043B\u0430\u0434\u044B?";
	};
	var bo_f38 = function bo_f38(match, outcome) {
	    return 'Бірінші сеттің дәл есебі';
	};
	var bo_g38 = function bo_g38(match, outcome) {
	    return 'Екінші сеттің дәл есебі';
	};
	var bo_h38 = function bo_h38(match, outcome) {
	    return 'Үшінші сеттің дәл есебі';
	};
	var bo_i38 = function bo_i38(match, outcome) {
	    return 'Төртінші сеттің дәл есебі';
	};
	var bo_j38 = function bo_j38(match, outcome) {
	    return 'Бесінші сеттің дәл есебі';
	};
	var bo_k38 = function bo_k38(match, outcome) {
	    return outcome.condition + " \u0433\u0435\u0439\u043C\u0434\u0435 15x15 \u0431\u043E\u043B\u0430 \u043C\u0430?";
	};
	var bo_l38 = function bo_l38(match, outcome) {
	    return outcome.condition + " \u0433\u0435\u0439\u043C\u0434\u0435 30x30 \u0431\u043E\u043B\u0430 \u043C\u0430?";
	};
	var bo_m38 = function bo_m38(match, outcome) {
	    return outcome.condition + " \u0433\u0435\u0439\u043C\u0434\u0435 40x40 \u0431\u043E\u043B\u0430 \u043C\u0430?";
	};
	var bo_n38 = function bo_n38(match, outcome) {
	    return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u0433\u0435\u0439\u043C\u0434\u0456 \u0430\u043B\u0430\u0434\u044B";
	};
	var bo_o38 = function bo_o38(match, outcome) {
	    return "\u0415\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u0433\u0435\u0439\u043C\u0434\u0456 \u0430\u043B\u0430\u0434\u044B";
	};
	var bo_p38 = function bo_p38(match, outcome) {
	    return "\u04AE\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u0433\u0435\u0439\u043C\u0434\u0456 \u0430\u043B\u0430\u0434\u044B";
	};
	var bo_q38 = function bo_q38(match, outcome) {
	    return "\u0422\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u0433\u0435\u0439\u043C\u0434\u0456 \u0430\u043B\u0430\u0434\u044B";
	};
	var bo_r38 = function bo_r38(match, outcome) {
	    return "\u0411\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C " + outcome.condition + " \u0433\u0435\u0439\u043C\u0434\u0456 \u0430\u043B\u0430\u0434\u044B";
	};
	var bo_s38 = function bo_s38(match, outcome) {
	    return 'Төртінші сет нәтижесі';
	};
	var bo_t38 = function bo_t38(match, outcome) {
	    return 'Бесінші сет нәтижесі';
	};
	var bo_u38 = function bo_u38(match, outcome) {
	    return outcome.condition + " \u0433\u0435\u0439\u043C\u0434\u0435 \u043A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u04B1\u0442\u044B\u0441\u0442\u044B \u0430\u043B\u0430\u0434\u044B?";
	};
	var bo_v38 = function bo_v38(match, outcome) {
	    return 'Бірінші сетте тай-брейк бола ма?';
	};
	var bo_w38 = function bo_w38(match, outcome) {
	    return 'Екінші сетте тай-брейк бола ма?';
	};
	var bo_x38 = function bo_x38(match, outcome) {
	    return 'Үшінші сетте тай-брейк бола ма?';
	};
	var bo_y38 = function bo_y38(match, outcome) {
	    return 'Төртінші сетте тай-брейк бола ма?';
	};
	var bo_z38 = function bo_z38(match, outcome) {
	    return 'Бесінші сетте тай-брейк бола ма?';
	};
	var bo_a39 = function bo_a39(match, outcome) {
	    return 'Матчта тай-брейк болады ма?';
	};
	var bo_b39 = function bo_b39(match, outcome) {
	    return 'Бірінші сеттегі тай-брейктің тоталы';
	};
	var bo_c39 = function bo_c39(match, outcome) {
	    return 'Екінші сеттегі тай-брейктің тоталы';
	};
	var bo_d39 = function bo_d39(match, outcome) {
	    return 'Үшінші сеттегі тай-брейктің тоталы';
	};
	var bo_e39 = function bo_e39(match, outcome) {
	    return 'Төртінші сеттегі тай-брейктің тоталы';
	};
	var bo_f39 = function bo_f39(match, outcome) {
	    return 'Бесінші сеттегі тай-брейктің тоталы';
	};
	var bo_g39 = function bo_g39(match, outcome) {
	    return 'Бірінші сеттегі тай-брейктің дәл есебі';
	};
	var bo_h39 = function bo_h39(match, outcome) {
	    return 'Екінші сеттегі тай-брейктің дәл есебі';
	};
	var bo_i39 = function bo_i39(match, outcome) {
	    return 'Үшінші сеттегі тай-брейктің дәл есебі';
	};
	var bo_j39 = function bo_j39(match, outcome) {
	    return 'Төртінші сеттегі тай-брейктің дәл есебі';
	};
	var bo_k39 = function bo_k39(match, outcome) {
	    return 'Бесінші сеттегі тай-брейктің дәл есебі';
	};
	var bo_l39 = function bo_l39(match, outcome) {
	    return 'Бірінші сеттегі тай-брейктің дәл тоталы';
	};
	var bo_m39 = function bo_m39(match, outcome) {
	    return 'Екінші сеттегі тай-брейктің дәл тоталы';
	};
	var bo_n39 = function bo_n39(match, outcome) {
	    return 'Үшінші сеттегі тай-брейктің дәл тоталы';
	};
	var bo_o39 = function bo_o39(match, outcome) {
	    return 'Төртінші сеттегі тай-брейктің дәл тоталы';
	};
	var bo_p39 = function bo_p39(match, outcome) {
	    return 'Бесінші сеттегі тай-брейктің дәл тоталы';
	};
	var bo_q39 = function bo_q39(match, outcome) {
	    return 'Бірінші сетте тай-брейкте кім жеңеді?';
	};
	var bo_r39 = function bo_r39(match, outcome) {
	    return 'Екінші сетте тай-брейкте кім жеңеді?';
	};
	var bo_s39 = function bo_s39(match, outcome) {
	    return 'Үшінші сетте тай-брейкте кім жеңеді?';
	};
	var bo_t39 = function bo_t39(match, outcome) {
	    return 'Төртінші сетте тай-брейкте кім жеңеді?';
	};
	var bo_u39 = function bo_u39(match, outcome) {
	    return 'Бесінші сетте тай-брейкте кім жеңеді?';
	};
	var bo_v39 = function bo_v39(match, outcome) {
	    return 'Бірінші сеттің брейктердің тоталы';
	};
	var bo_w39 = function bo_w39(match, outcome) {
	    return 'Матчтағы брейктердің тоталы';
	};
	var bo_x39 = function bo_x39(match, outcome) {
	    return match.homeTeam + " \u043C\u0430\u0442\u0447\u0442\u0430 \u0441\u0435\u0442\u0442\u0456 \u04B1\u0442\u0430\u0434\u044B";
	};
	var bo_y39 = function bo_y39(match, outcome) {
	    return match.awayTeam + " \u043C\u0430\u0442\u0447\u0442\u0430 \u0441\u0435\u0442\u0442\u0456 \u04B1\u0442\u0430\u0434\u044B";
	};
	var bo_z39 = function bo_z39(match, outcome) {
	    return 'Ең нәтижесіз сеттің тоталы';
	};
	var bo_a40 = function bo_a40(match, outcome) {
	    return 'Матчта кім бірінші эйсті береді';
	};
	var bo_b40 = function bo_b40(match, outcome) {
	    return 'Матчта кім бірінші қосарлы қателікті жасайды';
	};
	var bo_c40 = function bo_c40(match, outcome) {
	    return match.homeTeam + ": \u0431\u0435\u0440\u0443\u0434\u0456\u04A3 \u0435\u04A3 \u0436\u043E\u0493\u0430\u0440\u0493\u044B \u0436\u044B\u043B\u0434\u0430\u043C\u0434\u044B\u0493\u044B (\u043A\u043C/\u0441)";
	};
	var bo_d40 = function bo_d40(match, outcome) {
	    return match.awayTeam + ": \u0431\u0435\u0440\u0443\u0434\u0456\u04A3 \u0435\u04A3 \u0436\u043E\u0493\u0430\u0440\u0493\u044B \u0436\u044B\u043B\u0434\u0430\u043C\u0434\u044B\u0493\u044B (\u043A\u043C/\u0441)";
	};
	var bo_e40 = function bo_e40(match, outcome) {
	    return 'Бірінші сеттің ұтылысынан кейін матчтағы жеңіс';
	};
	var bo_f40 = function bo_f40(match, outcome) {
	    return match.homeTeam + ": \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u0435\u0440\u0443 %;";
	};
	var bo_g40 = function bo_g40(match, outcome) {
	    return match.awayTeam + ": \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u0435\u0440\u0443 %;";
	};
	var bo_h40 = function bo_h40(match, outcome) {
	    return 'Матчта кім көп брейк жасайды';
	};
	var bo_i40 = function bo_i40(match, outcome) {
	    return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: " + match.homeTeam;
	};
	var bo_j40 = function bo_j40(match, outcome) {
	    return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: " + match.awayTeam;
	};
	var bo_k40 = function bo_k40(match, outcome) {
	    return 'Матчта кім бірінші брейкті жасайды';
	};
	var bo_l40 = function bo_l40(match, outcome) {
	    return match.homeTeam + " 1-\u0448\u0456 \u043D\u0435\u043C\u0435\u0441\u0435 2-\u0448\u0456 \u0433\u0435\u0439\u043C\u0434\u0435\u0440\u0434\u0435 \u0431\u0440\u0435\u0439\u043A \u0436\u0430\u0441\u0430\u0439\u0434\u044B";
	};
	var bo_m40 = function bo_m40(match, outcome) {
	    return 'Матчта 6:0 немесе 0:6 есеппен сет болады ма?';
	};
	var bo_n40 = function bo_n40(match, outcome) {
	    return "\u041A\u0456\u043C " + outcome.condition + " \u0433\u0435\u0439\u043C \u0430\u043B\u0430\u0434\u044B?";
	};
	var bo_o40 = function bo_o40(match, outcome) {
	    return outcome.condition + " \u0433\u0435\u0439\u043C\u0434\u0435 15x15 \u0431\u043E\u043B\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_p40 = function bo_p40(match, outcome) {
	    return outcome.condition + " \u0433\u0435\u0439\u043C\u0434\u0435 30x30 \u0431\u043E\u043B\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_q40 = function bo_q40(match, outcome) {
	    return outcome.condition + " \u0433\u0435\u0439\u043C\u0434\u0435 40x40 \u0431\u043E\u043B\u0430\u0434\u044B \u043C\u0430?";
	};
	var bo_r40 = function bo_r40(match, outcome) {
	    return outcome.condition + " \u0433\u0435\u0439\u043C\u0434\u0435 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u04B1\u043F\u0430\u0439";
	};
	var bo_s40 = function bo_s40(match, outcome) {
	    return " " + outcome.condition + " \u0433\u0435\u0439\u043C\u0434\u0435 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u04B1\u043F\u0430\u0439";
	};
	var bo_t40 = function bo_t40(match, outcome) {
	    return 'Матчтағы эйстер тоталы';
	};
	var bo_u40 = function bo_u40(match, outcome) {
	    return "\u041C\u0430\u0442\u0447\u0442\u0430\u0493\u044B \u044D\u0439\u0441\u0442\u0435\u0440 \u0442\u043E\u0442\u0430\u043B\u044B: " + match.homeTeam;
	};
	var bo_v40 = function bo_v40(match, outcome) {
	    return "\u041C\u0430\u0442\u0447\u0442\u0430\u0493\u044B \u044D\u0439\u0441\u0442\u0435\u0440 \u0442\u043E\u0442\u0430\u043B\u044B: " + match.awayTeam;
	};
	var bo_w40 = function bo_w40(match, outcome) {
	    return 'Матчтағы қос қателер тоталы';
	};
	var bo_x40 = function bo_x40(match, outcome) {
	    return "\u041C\u0430\u0442\u0447\u0442\u0430\u0493\u044B \u049B\u043E\u0441 \u049B\u0430\u0442\u0435\u043B\u0435\u0440 \u0442\u043E\u0442\u0430\u043B\u044B : " + match.homeTeam;
	};
	var bo_y40 = function bo_y40(match, outcome) {
	    return "\u041C\u0430\u0442\u0447\u0442\u0430\u0493\u044B \u049B\u043E\u0441 \u049B\u0430\u0442\u0435\u043B\u0435\u0440 \u0442\u043E\u0442\u0430\u043B\u044B : " + match.awayTeam;
	};
	var bo_z40 = function bo_z40(match, outcome) {
	    return 'Сеттер (Тотал) нәтижелілігі';
	};
	var bo_a41 = function bo_a41(match, outcome) {
	    return 'Матчта өтіп шығу беріспен жеңеді';
	};
	var bo_b41 = function bo_b41(match, outcome) {
	    return "1-\u0456\u043D\u0448\u0456 \u043D\u0435\u043C\u0435\u0441\u0435 2-\u043D\u0448\u0456 \u0433\u0435\u0439\u043C\u0434\u0435\u0440\u0434\u0435 \u044D\u0439\u0441: " + match.homeTeam;
	};
	var bo_c41 = function bo_c41(match, outcome) {
	    return "1-\u0456\u043D\u0448\u0456 \u043D\u0435\u043C\u0435\u0441\u0435 2-\u043D\u0448\u0456 \u0433\u0435\u0439\u043C\u0434\u0435\u0440\u0434\u0435 \u044D\u0439\u0441: " + match.awayTeam;
	};
	var bo_d41 = function bo_d41(match, outcome) {
	    return "1-\u0456\u043D\u0448\u0456 \u043D\u0435\u043C\u0435\u0441\u0435 2-\u043D\u0448\u0456 \u0433\u0435\u0439\u043C\u0434\u0435\u0440\u0434\u0435 \u049B\u043E\u0441 \u049B\u0430\u0442\u0435: " + match.homeTeam;
	};
	var bo_e41 = function bo_e41(match, outcome) {
	    return "1-\u0456\u043D\u0448\u0456 \u043D\u0435\u043C\u0435\u0441\u0435 2-\u043D\u0448\u0456 \u0433\u0435\u0439\u043C\u0434\u0435\u0440\u0434\u0435 \u049B\u043E\u0441 \u049B\u0430\u0442\u0435: " + match.awayTeam;
	};
	var bo_f41 = function bo_f41(match, outcome) {
	    return 'Бірінші сетте эйс тоталы';
	};
	var bo_g41 = function bo_g41(match, outcome) {
	    return 'Матч барысында споршы шығады (дискв.)';
	};
	var bo_h41 = function bo_h41(match, outcome) {
	    return match.homeTeam + " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u0435\u0440\u0456\u0441\u0442\u0456\u04A3 \u0442\u0438\u0433\u0456\u0437\u0443 %";
	};
	var bo_i41 = function bo_i41(match, outcome) {
	    return match.awayTeam + "  \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u0435\u0440\u0456\u0441\u0442\u0456\u04A3 \u0442\u0438\u0433\u0456\u0437\u0443 %";
	};
	var bo_j41 = function bo_j41(match, outcome) {
	    return 'Бірінші сетте брейктерден нәтиже';
	};
	var bo_k41 = function bo_k41(match, outcome) {
	    return 'Екінші сетте брейктерден нәтиже';
	};
	var bo_l41 = function bo_l41(match, outcome) {
	    return 'Үшінші сетте брейктерден нәтиже';
	};
	var bo_m41 = function bo_m41(match, outcome) {
	    return 'Төртінші сетте брейктерден нәтиже';
	};
	var bo_n41 = function bo_n41(match, outcome) {
	    return 'Бесінші сетте брейктерден нәтиже';
	};
	var bo_o41 = function bo_o41(match, outcome) {
	    return 'Матчтағы брейктерден фора';
	};
	var bo_p41 = function bo_p41(match, outcome) {
	    return 'Бірінші сетте брейктерден фора';
	};
	var bo_q41 = function bo_q41(match, outcome) {
	    return 'Екінші сетте брейктерден фора';
	};
	var bo_r41 = function bo_r41(match, outcome) {
	    return 'Үшінші сетте брейктерден фора';
	};
	var bo_s41 = function bo_s41(match, outcome) {
	    return 'Төртінші сетте брейктерден фора';
	};
	var bo_t41 = function bo_t41(match, outcome) {
	    return 'Бесінші сетте брейктерден фора';
	};
	var bo_u41 = function bo_u41(match, outcome) {
	    return "\u041A\u0456\u043C " + outcome.conditionTwo + " \u04B1\u043F\u0430\u0439\u0434\u044B " + outcome.condition + " \u0433\u0435\u0439\u043C\u0434\u0435 \u0430\u043B\u0430\u0434\u044B";
	};
	var bo_v41 = function bo_v41(match, outcome) {
	    return outcome.condition + " \u0436\u04D9\u043D\u0435 " + outcome.conditionTwo + " \u0433\u0435\u0439\u043C\u0434\u0435\u0440\u0434\u0435 \u043D\u04D9\u0442\u0438\u0436\u0435";
	};
	var bo_w41 = function bo_w41(match, outcome) {
	    return outcome.conditionTwo + " \u0433\u0435\u0439\u043C\u0434\u0435 \u0444\u043E\u0440\u0430";
	};
	var bo_x41 = function bo_x41(match, outcome) {
	    return outcome.conditionTwo + " \u0433\u0435\u0439\u043C\u0434\u0435 \u0442\u043E\u0442\u0430\u043B";
	};
	var bo_y41 = function bo_y41(match, outcome) {
	    return "\u0422\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439\u0434\u044B \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u0430\u043B\u0430\u0434\u044B?";
	};
	var bo_z41 = function bo_z41(match, outcome) {
	    return "\u0411\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C " + outcome.condition + " \u04B1\u043F\u0430\u0439\u0434\u044B \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u0430\u043B\u0430\u0434\u044B?";
	};
	var bo_a42 = function bo_a42(match, outcome) {
	    return 'Төртінші сеттің дәл тоталы';
	};
	var bo_b42 = function bo_b42(match, outcome) {
	    return 'Бесінші сеттің дәл тоталы';
	};
	var bo_c42 = function bo_c42(match, outcome) {
	    return match.homeTeam + " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_d42 = function bo_d42(match, outcome) {
	    return match.homeTeam + " \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_e42 = function bo_e42(match, outcome) {
	    return match.awayTeam + " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_f42 = function bo_f42(match, outcome) {
	    return match.awayTeam + " \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	};
	var bo_g42 = function bo_g42(match, outcome) {
	    return 'Ең нәтижелі сеттің тоталы';
	};
	var bo_h42 = function bo_h42(match, outcome) {
	    return 'Төртінші сетте айырмашылықпен жеңіс';
	};
	var bo_i42 = function bo_i42(match, outcome) {
	    return 'Бесінші сетте айырмашылықпен жеңіс';
	};
	var bo_j42 = function bo_j42(match, outcome) {
	    return 'Бірінші сеттің 10 ұпайға дейін шағын сетте жеңіс';
	};
	var bo_k42 = function bo_k42(match, outcome) {
	    return 'Екінші сеттің 10 ұпайға дейін шағын сетте жеңіс';
	};
	var bo_l42 = function bo_l42(match, outcome) {
	    return 'Үшінші сеттің 10 ұпайға дейін шағын сетте жеңіс';
	};
	var bo_m42 = function bo_m42(match, outcome) {
	    return 'Төртінші сеттің 10 ұпайға дейін шағын сетте жеңіс';
	};
	var bo_n42 = function bo_n42(match, outcome) {
	    return 'Бірінші сеттің 10 ұпайына дейін шағын сетте фора';
	};
	var bo_o42 = function bo_o42(match, outcome) {
	    return 'Екінші сеттің 10 ұпайына дейін шағын сетте фора';
	};
	var bo_p42 = function bo_p42(match, outcome) {
	    return 'Үшінші сеттің 10 ұпайына дейін шағын сетте фора';
	};
	var bo_q42 = function bo_q42(match, outcome) {
	    return 'Төртінші сеттің 10 ұпайына дейін шағын сетте фора';
	};
	var bo_r42 = function bo_r42(match, outcome) {
	    return 'Бірінші сеттің 10 ұпайына дейін шағын сетте тотал';
	};
	var bo_s42 = function bo_s42(match, outcome) {
	    return 'Екінші сеттің 10 ұпайына дейін шағын сетте тотал';
	};
	var bo_t42 = function bo_t42(match, outcome) {
	    return 'Үшінші сеттің 10 ұпайына дейін шағын сетте тотал';
	};
	var bo_u42 = function bo_u42(match, outcome) {
	    return 'Төртінші сеттің 10 ұпайына дейін шағын сетте тотал';
	};
	var bo_v42 = function bo_v42(match, outcome) {
	    return 'Бірінші сеттің 15 ұпайына дейін шағын сетте жеңіс';
	};
	var bo_w42 = function bo_w42(match, outcome) {
	    return 'Екінші сеттің 15 ұпайына дейін шағын сетте жеңіс';
	};
	var bo_x42 = function bo_x42(match, outcome) {
	    return 'Үшінші сеттің 15 ұпайына дейін шағын сетте жеңіс';
	};
	var bo_y42 = function bo_y42(match, outcome) {
	    return 'Төртінші сеттің 15 ұпайына дейін шағын сетте жеңіс';
	};
	var bo_z42 = function bo_z42(match, outcome) {
	    return 'Бірінші сеттің 15 ұпайына дейін шағын сетте фора';
	};
	var bo_a43 = function bo_a43(match, outcome) {
	    return 'Екінші сеттің 15 ұпайына дейін шағын сетте фора';
	};
	var bo_b43 = function bo_b43(match, outcome) {
	    return 'Үшінші сеттің 15 ұпайына дейін шағын сетте фора';
	};
	var bo_c43 = function bo_c43(match, outcome) {
	    return 'Төртінші сеттің 15 ұпайына дейін шағын сетте фора';
	};
	var bo_d43 = function bo_d43(match, outcome) {
	    return 'Бірінші сеттің 15 ұпайына дейін шағын сетте тотал';
	};
	var bo_e43 = function bo_e43(match, outcome) {
	    return 'Екінші сеттің 15 ұпайына дейін шағын сетте тотал';
	};
	var bo_f43 = function bo_f43(match, outcome) {
	    return 'Үшінші сеттің 15 ұпайына дейін шағын сетте тотал';
	};
	var bo_g43 = function bo_g43(match, outcome) {
	    return 'Төртінші сеттің 15 ұпайына дейін шағын сетте тотал';
	};
	var bo_h43 = function bo_h43(match, outcome) {
	    return "\u0422\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C " + numeralNeuterEnding(outcome.condition) + " \u04B1\u043F\u0430\u0439 \u04B1\u0442\u0430\u0434\u044B";
	};
	var bo_i43 = function bo_i43(match, outcome) {
	    return "\u0411\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C " + numeralNeuterEnding(outcome.condition) + " \u04B1\u043F\u0430\u0439 \u04B1\u0442\u0430\u0434\u044B";
	};
	var bo_j43 = function bo_j43(match, outcome) {
	    return 'Алтын сетте фора';
	};
	var bo_k43 = function bo_k43(match, outcome) {
	    return 'Алтын сет тоталы';
	};
	var bo_l43 = function bo_l43(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + "\u0410\u043B\u0442\u044B\u043D \u0441\u0435\u0442\u0442\u0435";
	};
	var bo_m43 = function bo_m43(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0410\u043B\u0442\u044B\u043D \u0441\u0435\u0442\u0442\u0435";
	};
	var bo_n43 = function bo_n43(match, outcome) {
	    return 'Алтын сет нәтижесі';
	};
	var bo_o43 = function bo_o43(match, outcome) {
	    return "\u041A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u0410\u043B\u0442\u044B\u043D \u0441\u0435\u0442\u0442\u0435 " + outcome.condition + " " + plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар']) + " \u0430\u043B\u0430\u0434\u044B";
	};
	var bo_p43 = function bo_p43(match, outcome) {
	    return 'Алтын сеттің дәл тоталы';
	};
	var bo_q43 = function bo_q43(match, outcome) {
	    return 'Алтын сеттің жұп/тақ';
	};
	var bo_r43 = function bo_r43(match, outcome) {
	    return "\u0410\u043B\u0442\u044B\u043D \u0441\u0435\u0442\u0442\u0456\u04A3 \u0436\u0435\u04A3\u0456\u0441\u0456 \u0436\u04D9\u043D\u0435 \u0442\u043E\u0442\u0430\u043B\u044B " + outcome.condition;
	};
	var bo_s43 = function bo_s43(match, outcome) {
	    return 'Алтын сетте айырмашылықпен жеңіс';
	};
	var bo_t43 = function bo_t43(match, outcome) {
	    return 'Неше сетте шағын тай-брейк болады?';
	};
	var bo_u43 = function bo_u43(match, outcome) {
	    return outcome.condition + " \u0440\u0430\u0443\u043D\u0434\u0442\u044B \u043A\u0456\u043C \u0436\u0435\u04A3\u0435\u0434\u0456?";
	};
	var bo_v43 = function bo_v43(match, outcome) {
	    return 'Выпадет ли 13 сектор?';
	};
	var bo_w43 = function bo_w43(match, outcome) {
	    return "\u0412\u044B\u043F\u0430\u0434\u0435\u0442 \u043B\u0438 13 \u0441\u0435\u043A\u0442\u043E\u0440 \u0432 " + outcome.condition + "-\u043C \u0440\u0430\u0443\u043D\u0434\u0435?";
	};
	
	var fa_b1 = function fa_b1(match, outcome) {
	    return "\u04241(" + signed(outcome.condition) + ")";
	};
	var fa_c1 = function fa_c1(match, outcome) {
	    return "\u04242(" + signed(-outcome.condition) + ")";
	};
	var fa_d1 = function fa_d1(match, outcome) {
	    return "\u0410\u0437 " + outcome.condition;
	};
	var fa_e1 = function fa_e1(match, outcome) {
	    return "\u041A\u04E9\u043F " + outcome.condition;
	};
	var fa_f1 = function fa_f1(match, outcome) {
	    return outcome.condition + " \u0430\u0437";
	};
	var fa_g1 = function fa_g1(match, outcome) {
	    return outcome.condition + " \u043A\u04E9\u043F";
	};
	var fa_h1 = function fa_h1(match, outcome) {
	    return 'Жұп';
	};
	var fa_i1 = function fa_i1(match, outcome) {
	    return 'Тақ';
	};
	var fa_j1 = function fa_j1(match, outcome) {
	    return 'Ж1';
	};
	var fa_k1 = function fa_k1(match, outcome) {
	    return 'Ж2';
	};
	var fa_l1 = function fa_l1(match, outcome) {
	    return '1-інші жоғары';
	};
	var fa_m1 = function fa_m1(match, outcome) {
	    return '2-нші жоғары';
	};
	var fa_n1 = function fa_n1(match, outcome) {
	    return 'Иә';
	};
	var fa_o1 = function fa_o1(match, outcome) {
	    return 'Жоқ';
	};
	var fa_p1 = function fa_p1(match, outcome) {
	    return "\u041A\u04E9\u043F" + outcome.condition;
	};
	var fa_q1 = function fa_q1(match, outcome) {
	    return '0-2';
	};
	var fa_r1 = function fa_r1(match, outcome) {
	    return '0-3';
	};
	var fa_s1 = function fa_s1(match, outcome) {
	    return '1-2';
	};
	var fa_t1 = function fa_t1(match, outcome) {
	    return '1-3';
	};
	var fa_u1 = function fa_u1(match, outcome) {
	    return '2-0';
	};
	var fa_v1 = function fa_v1(match, outcome) {
	    return '2-1';
	};
	var fa_w1 = function fa_w1(match, outcome) {
	    return '2-3';
	};
	var fa_x1 = function fa_x1(match, outcome) {
	    return '3-0';
	};
	var fa_y1 = function fa_y1(match, outcome) {
	    return '3-1';
	};
	var fa_z1 = function fa_z1(match, outcome) {
	    return '3-2';
	};
	var fa_a2 = function fa_a2(match, outcome) {
	    return "" + match.homeTeam;
	};
	var fa_b2 = function fa_b2(match, outcome) {
	    return "" + match.awayTeam;
	};
	var fa_c2 = function fa_c2(match, outcome) {
	    return 'Х';
	};
	var fa_d2 = function fa_d2(match, outcome) {
	    return 'Ешкім';
	};
	var fa_e2 = function fa_e2(match, outcome) {
	    return '1X';
	};
	var fa_f2 = function fa_f2(match, outcome) {
	    return '12';
	};
	var fa_g2 = function fa_g2(match, outcome) {
	    return '2X';
	};
	var fa_h2 = function fa_h2(match, outcome) {
	    return "\u04161\u0422\u0430 " + outcome.condition;
	};
	var fa_i2 = function fa_i2(match, outcome) {
	    return "\u04161\u0422\u043A " + outcome.condition;
	};
	var fa_j2 = function fa_j2(match, outcome) {
	    return "\u04162\u0422\u0430 " + outcome.condition;
	};
	var fa_k2 = function fa_k2(match, outcome) {
	    return "\u04162\u0422\u043A " + outcome.condition;
	};
	var fa_l2 = function fa_l2(match, outcome) {
	    return "\u0425\u0422\u0430 " + outcome.condition;
	};
	var fa_m2 = function fa_m2(match, outcome) {
	    return "\u0425\u0422\u043A " + outcome.condition;
	};
	var fa_n2 = function fa_n2(match, outcome) {
	    return '0';
	};
	var fa_o2 = function fa_o2(match, outcome) {
	    return '1';
	};
	var fa_p2 = function fa_p2(match, outcome) {
	    return '2';
	};
	var fa_q2 = function fa_q2(match, outcome) {
	    return '3';
	};
	var fa_r2 = function fa_r2(match, outcome) {
	    return '4';
	};
	var fa_s2 = function fa_s2(match, outcome) {
	    return '≥ 5';
	};
	var fa_t2 = function fa_t2(match, outcome) {
	    return 'Екі команда соғады';
	};
	var fa_u2 = function fa_u2(match, outcome) {
	    return 'Тура бір команда соғады';
	};
	var fa_v2 = function fa_v2(match, outcome) {
	    return 'Екі команда соөқпайды';
	};
	var fa_w2 = function fa_w2(match, outcome) {
	    return '0-0';
	};
	var fa_x2 = function fa_x2(match, outcome) {
	    return '0-1';
	};
	var fa_y2 = function fa_y2(match, outcome) {
	    return '0-4';
	};
	var fa_z2 = function fa_z2(match, outcome) {
	    return '0-5';
	};
	var fa_a3 = function fa_a3(match, outcome) {
	    return '1-0';
	};
	var fa_b3 = function fa_b3(match, outcome) {
	    return '1-1';
	};
	var fa_c3 = function fa_c3(match, outcome) {
	    return '1-4';
	};
	var fa_d3 = function fa_d3(match, outcome) {
	    return '1-5';
	};
	var fa_e3 = function fa_e3(match, outcome) {
	    return '2-2';
	};
	var fa_f3 = function fa_f3(match, outcome) {
	    return '2-4';
	};
	var fa_g3 = function fa_g3(match, outcome) {
	    return '2-5';
	};
	var fa_h3 = function fa_h3(match, outcome) {
	    return '2-6';
	};
	var fa_i3 = function fa_i3(match, outcome) {
	    return '3-3';
	};
	var fa_j3 = function fa_j3(match, outcome) {
	    return '3-4';
	};
	var fa_k3 = function fa_k3(match, outcome) {
	    return '3-5';
	};
	var fa_l3 = function fa_l3(match, outcome) {
	    return '4-0';
	};
	var fa_m3 = function fa_m3(match, outcome) {
	    return '4-1';
	};
	var fa_n3 = function fa_n3(match, outcome) {
	    return '4-2';
	};
	var fa_o3 = function fa_o3(match, outcome) {
	    return '4-3';
	};
	var fa_p3 = function fa_p3(match, outcome) {
	    return '4-4';
	};
	var fa_q3 = function fa_q3(match, outcome) {
	    return '5-0';
	};
	var fa_r3 = function fa_r3(match, outcome) {
	    return '5-1';
	};
	var fa_s3 = function fa_s3(match, outcome) {
	    return '5-2';
	};
	var fa_t3 = function fa_t3(match, outcome) {
	    return '5-3';
	};
	var fa_u3 = function fa_u3(match, outcome) {
	    return 'Кез келген басқа';
	};
	var fa_v3 = function fa_v3(match, outcome) {
	    return "\u2264 " + outcome.condition;
	};
	var fa_w3 = function fa_w3(match, outcome) {
	    return outcome.condition + 1 + " - " + (outcome.condition + 2);
	};
	var fa_x3 = function fa_x3(match, outcome) {
	    return outcome.condition + 3 + " - " + (outcome.condition + 4);
	};
	var fa_y3 = function fa_y3(match, outcome) {
	    return outcome.condition + 5 + " - " + (outcome.condition + 6);
	};
	var fa_z3 = function fa_z3(match, outcome) {
	    return outcome.condition + 7 + " - " + (outcome.condition + 8);
	};
	var fa_a4 = function fa_a4(match, outcome) {
	    return "\u2265 " + (outcome.condition + 9);
	};
	var fa_b4 = function fa_b4(match, outcome) {
	    return '6-9';
	};
	var fa_c4 = function fa_c4(match, outcome) {
	    return '10-12';
	};
	var fa_d4 = function fa_d4(match, outcome) {
	    return '13-16';
	};
	var fa_e4 = function fa_e4(match, outcome) {
	    return '17-20';
	};
	var fa_f4 = function fa_f4(match, outcome) {
	    return '≥21';
	};
	var fa_g4 = function fa_g4(match, outcome) {
	    return "\u04E8\u0442\u0443: " + match.homeTeam;
	};
	var fa_h4 = function fa_h4(match, outcome) {
	    return "\u04E8\u0442\u0443: " + match.awayTeam;
	};
	var fa_i4 = function fa_i4(match, outcome) {
	    return '1-ші жарты';
	};
	var fa_j4 = function fa_j4(match, outcome) {
	    return '2-ші жарты';
	};
	var fa_k4 = function fa_k4(match, outcome) {
	    return '1-ші ширек';
	};
	var fa_l4 = function fa_l4(match, outcome) {
	    return '2-ші ширек';
	};
	var fa_m4 = function fa_m4(match, outcome) {
	    return '3-ші ширек';
	};
	var fa_n4 = function fa_n4(match, outcome) {
	    return '4-ші ширек';
	};
	var fa_o4 = function fa_o4(match, outcome) {
	    return 'Ж1: 1-2';
	};
	var fa_p4 = function fa_p4(match, outcome) {
	    return 'Ж1: 3-5';
	};
	var fa_q4 = function fa_q4(match, outcome) {
	    return 'Ж1: 6-9';
	};
	var fa_r4 = function fa_r4(match, outcome) {
	    return 'Ж1: 10-12';
	};
	var fa_s4 = function fa_s4(match, outcome) {
	    return 'Ж1: 13-16';
	};
	var fa_t4 = function fa_t4(match, outcome) {
	    return 'Ж1: 17-20';
	};
	var fa_u4 = function fa_u4(match, outcome) {
	    return 'Ж1: ≥21';
	};
	var fa_v4 = function fa_v4(match, outcome) {
	    return 'Ж2: 1-2';
	};
	var fa_w4 = function fa_w4(match, outcome) {
	    return 'Ж2: 3-5';
	};
	var fa_x4 = function fa_x4(match, outcome) {
	    return 'Ж2: 6-9';
	};
	var fa_y4 = function fa_y4(match, outcome) {
	    return 'Ж2: 10-12';
	};
	var fa_z4 = function fa_z4(match, outcome) {
	    return 'Ж2: 13-16';
	};
	var fa_a5 = function fa_a5(match, outcome) {
	    return 'Ж2: 17-20';
	};
	var fa_b5 = function fa_b5(match, outcome) {
	    return 'Ж2: ≥21';
	};
	var fa_c5 = function fa_c5(match, outcome) {
	    return 'Ж1: 3-4';
	};
	var fa_d5 = function fa_d5(match, outcome) {
	    return 'Ж1: 5-7';
	};
	var fa_e5 = function fa_e5(match, outcome) {
	    return 'Ж1: ≥8';
	};
	var fa_f5 = function fa_f5(match, outcome) {
	    return 'Х2';
	};
	var fa_g5 = function fa_g5(match, outcome) {
	    return 'Ж2: 3-4';
	};
	var fa_h5 = function fa_h5(match, outcome) {
	    return 'Ж2: 5-7';
	};
	var fa_i5 = function fa_i5(match, outcome) {
	    return 'Ж2: ≥8';
	};
	var fa_j5 = function fa_j5(match, outcome) {
	    return 'Х1';
	};
	var fa_k5 = function fa_k5(match, outcome) {
	    return '1-інші ширек';
	};
	var fa_l5 = function fa_l5(match, outcome) {
	    return '2-нші ширек';
	};
	var fa_m5 = function fa_m5(match, outcome) {
	    return '3-інші ширек';
	};
	var fa_n5 = function fa_n5(match, outcome) {
	    return '4-інші ширек';
	};
	var fa_o5 = function fa_o5(match, outcome) {
	    return 'Айыппұл доп';
	};
	var fa_p5 = function fa_p5(match, outcome) {
	    return '3-ұпайлық';
	};
	var fa_q5 = function fa_q5(match, outcome) {
	    return '2-ұпайлық';
	};
	var fa_r5 = function fa_r5(match, outcome) {
	    return "\u04161 \u2265 " + outcome.condition;
	};
	var fa_s5 = function fa_s5(match, outcome) {
	    return "\u0410\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B " + outcome.condition + " \u0430\u0437";
	};
	var fa_t5 = function fa_t5(match, outcome) {
	    return "\u04162 \u2265 " + outcome.condition;
	};
	var fa_u5 = function fa_u5(match, outcome) {
	    return "\u04161: " + outcome.condition + " \u043A\u04E9\u043F =21";
	};
	var fa_v5 = function fa_v5(match, outcome) {
	    return "\u04162:" + outcome.condition + " \u043A\u04E9\u043F=21";
	};
	var fa_w5 = function fa_w5(match, outcome) {
	    return 'Ж1: 8 және одан көп';
	};
	var fa_x5 = function fa_x5(match, outcome) {
	    return 'Ж2: 8 және одан көп';
	};
	var fa_y5 = function fa_y5(match, outcome) {
	    return '1-інші жартылық';
	};
	var fa_z5 = function fa_z5(match, outcome) {
	    return '2-нші жартылық';
	};
	var fa_a6 = function fa_a6(match, outcome) {
	    return 'Ешқандай';
	};
	var fa_b6 = function fa_b6(match, outcome) {
	    return 'жұп';
	};
	var fa_c6 = function fa_c6(match, outcome) {
	    return 'тақ';
	};
	var fa_d6 = function fa_d6(match, outcome) {
	    return 'Ж1: 1';
	};
	var fa_e6 = function fa_e6(match, outcome) {
	    return 'Ж1: 2';
	};
	var fa_f6 = function fa_f6(match, outcome) {
	    return 'Ж1: 3';
	};
	var fa_g6 = function fa_g6(match, outcome) {
	    return 'Ж1: 4';
	};
	var fa_h6 = function fa_h6(match, outcome) {
	    return 'Ж1: ≥ 5';
	};
	var fa_i6 = function fa_i6(match, outcome) {
	    return 'Ж2: 1';
	};
	var fa_j6 = function fa_j6(match, outcome) {
	    return 'Ж2: 2';
	};
	var fa_k6 = function fa_k6(match, outcome) {
	    return 'Ж2: 3';
	};
	var fa_l6 = function fa_l6(match, outcome) {
	    return 'Ж2: 4';
	};
	var fa_m6 = function fa_m6(match, outcome) {
	    return 'Ж2: ≥ 5';
	};
	var fa_n6 = function fa_n6(match, outcome) {
	    return '1Х';
	};
	var fa_o6 = function fa_o6(match, outcome) {
	    return 'Екеуі де';
	};
	var fa_p6 = function fa_p6(match, outcome) {
	    return 'Бір';
	};
	var fa_q6 = function fa_q6(match, outcome) {
	    return 'Ешқайсысы';
	};
	var fa_r6 = function fa_r6(match, outcome) {
	    return '0 немесе 1';
	};
	var fa_s6 = function fa_s6(match, outcome) {
	    return '5';
	};
	var fa_t6 = function fa_t6(match, outcome) {
	    return '6';
	};
	var fa_u6 = function fa_u6(match, outcome) {
	    return '7';
	};
	var fa_v6 = function fa_v6(match, outcome) {
	    return '≥ 8';
	};
	var fa_w6 = function fa_w6(match, outcome) {
	    return 'Ж1Ж1';
	};
	var fa_x6 = function fa_x6(match, outcome) {
	    return 'Ж1Ж';
	};
	var fa_y6 = function fa_y6(match, outcome) {
	    return 'Ж1Ж2';
	};
	var fa_z6 = function fa_z6(match, outcome) {
	    return 'НЖ1';
	};
	var fa_a7 = function fa_a7(match, outcome) {
	    return 'НН';
	};
	var fa_b7 = function fa_b7(match, outcome) {
	    return 'НЖ2';
	};
	var fa_c7 = function fa_c7(match, outcome) {
	    return 'Ж2Ж1';
	};
	var fa_d7 = function fa_d7(match, outcome) {
	    return 'Ж2Н';
	};
	var fa_e7 = function fa_e7(match, outcome) {
	    return 'Ж2Ж2';
	};
	var fa_f7 = function fa_f7(match, outcome) {
	    return "" + (outcome.condition + 1);
	};
	var fa_g7 = function fa_g7(match, outcome) {
	    return "" + (outcome.condition + 2);
	};
	var fa_h7 = function fa_h7(match, outcome) {
	    return "" + (outcome.condition + 3);
	};
	var fa_i7 = function fa_i7(match, outcome) {
	    return "" + (outcome.condition + 4);
	};
	var fa_j7 = function fa_j7(match, outcome) {
	    return "" + (outcome.condition + 5);
	};
	var fa_k7 = function fa_k7(match, outcome) {
	    return "" + (outcome.condition + 6);
	};
	var fa_l7 = function fa_l7(match, outcome) {
	    return "\u2265 " + (outcome.condition + 7);
	};
	var fa_m7 = function fa_m7(match, outcome) {
	    return outcome.condition + 1 + " - " + (outcome.condition + 2) + " \u0434\u0435\u0439\u0456\u043D";
	};
	var fa_n7 = function fa_n7(match, outcome) {
	    return outcome.condition + 3 + " - " + (outcome.condition + 4) + " \u0434\u0435\u0439\u0456\u043D";
	};
	var fa_o7 = function fa_o7(match, outcome) {
	    return outcome.condition + 5 + " - " + (outcome.condition + 6) + " \u0434\u0435\u0439\u0456\u043D";
	};
	var fa_p7 = function fa_p7(match, outcome) {
	    return "\u2265 " + (outcome.condition + 7) + " \u0436\u04D9\u043D\u0435 \u043E\u0434\u0430\u043D \u0430\u0441\u0430\u0434\u044B";
	};
	var fa_q7 = function fa_q7(match, outcome) {
	    return '44960';
	};
	var fa_r7 = function fa_r7(match, outcome) {
	    return '45022';
	};
	var fa_s7 = function fa_s7(match, outcome) {
	    return '7 және одан асады';
	};
	var fa_t7 = function fa_t7(match, outcome) {
	    return '4-6';
	};
	var fa_u7 = function fa_u7(match, outcome) {
	    return 'Ж1Та';
	};
	var fa_v7 = function fa_v7(match, outcome) {
	    return 'Ж1Тк';
	};
	var fa_w7 = function fa_w7(match, outcome) {
	    return 'Ж2Та';
	};
	var fa_x7 = function fa_x7(match, outcome) {
	    return 'Ж2Тк';
	};
	var fa_y7 = function fa_y7(match, outcome) {
	    return '1-ші көп';
	};
	var fa_z7 = function fa_z7(match, outcome) {
	    return '2-нші көп';
	};
	var fa_a8 = function fa_a8(match, outcome) {
	    return 'Ж1: 2-3';
	};
	var fa_b8 = function fa_b8(match, outcome) {
	    return 'Ж1: 4-6';
	};
	var fa_c8 = function fa_c8(match, outcome) {
	    return 'Ж1: ≥7';
	};
	var fa_d8 = function fa_d8(match, outcome) {
	    return 'Ж2: 2-3';
	};
	var fa_e8 = function fa_e8(match, outcome) {
	    return 'Ж2: 4-6';
	};
	var fa_f8 = function fa_f8(match, outcome) {
	    return 'Ж2: ≥7';
	};
	var fa_g8 = function fa_g8(match, outcome) {
	    return "" + outcome.condition;
	};
	var fa_h8 = function fa_h8(match, outcome) {
	    return "\u2265 " + (outcome.condition + 6);
	};
	var fa_i8 = function fa_i8(match, outcome) {
	    return 'Ж1: мерзімнен бұрын жеңу';
	};
	var fa_j8 = function fa_j8(match, outcome) {
	    return 'Ж1: ұпайдан жеңу';
	};
	var fa_k8 = function fa_k8(match, outcome) {
	    return 'Тең';
	};
	var fa_l8 = function fa_l8(match, outcome) {
	    return 'Ж2: мерзімнен бұрын жеңу';
	};
	var fa_m8 = function fa_m8(match, outcome) {
	    return 'Ж2: ұпайдан жеңу';
	};
	var fa_n8 = function fa_n8(match, outcome) {
	    return 'Ж1: 1 раунд';
	};
	var fa_o8 = function fa_o8(match, outcome) {
	    return 'Ж1: 2 раунд';
	};
	var fa_p8 = function fa_p8(match, outcome) {
	    return 'Ж1: 3 раунд';
	};
	var fa_q8 = function fa_q8(match, outcome) {
	    return 'ЖЖ1: 4 раунд';
	};
	var fa_r8 = function fa_r8(match, outcome) {
	    return 'Ж1: 5 раунд';
	};
	var fa_s8 = function fa_s8(match, outcome) {
	    return 'Ж1: 6 раунд';
	};
	var fa_t8 = function fa_t8(match, outcome) {
	    return 'Ж1: 7 раунд';
	};
	var fa_u8 = function fa_u8(match, outcome) {
	    return 'Ж1: 8 раунд';
	};
	var fa_v8 = function fa_v8(match, outcome) {
	    return 'Ж1: 9 раунд';
	};
	var fa_w8 = function fa_w8(match, outcome) {
	    return 'Ж1: 10 раунд';
	};
	var fa_x8 = function fa_x8(match, outcome) {
	    return 'Ж1: 11 раунд';
	};
	var fa_y8 = function fa_y8(match, outcome) {
	    return 'Ж1: 12 раунд';
	};
	var fa_z8 = function fa_z8(match, outcome) {
	    return 'Ж2: 1 раунд';
	};
	var fa_a9 = function fa_a9(match, outcome) {
	    return 'Ж2: 2 раунд';
	};
	var fa_b9 = function fa_b9(match, outcome) {
	    return 'Ж2: 3 раунд';
	};
	var fa_c9 = function fa_c9(match, outcome) {
	    return 'Ж2: 4 раунд';
	};
	var fa_d9 = function fa_d9(match, outcome) {
	    return 'Ж2: 5 раунд';
	};
	var fa_e9 = function fa_e9(match, outcome) {
	    return 'Ж2: 6 раунд';
	};
	var fa_f9 = function fa_f9(match, outcome) {
	    return 'Ж2: 7 раунд';
	};
	var fa_g9 = function fa_g9(match, outcome) {
	    return 'Ж2: 8 раунд';
	};
	var fa_h9 = function fa_h9(match, outcome) {
	    return 'Ж2: 9 раунд';
	};
	var fa_i9 = function fa_i9(match, outcome) {
	    return 'Ж2: 10 раунд';
	};
	var fa_j9 = function fa_j9(match, outcome) {
	    return 'Ж2: 11 раунд';
	};
	var fa_k9 = function fa_k9(match, outcome) {
	    return 'Ж2: 12 раунд';
	};
	var fa_l9 = function fa_l9(match, outcome) {
	    return 'Ия';
	};
	var fa_m9 = function fa_m9(match, outcome) {
	    return 'X';
	};
	var fa_n9 = function fa_n9(match, outcome) {
	    return '5 және одан көп';
	};
	var fa_o9 = function fa_o9(match, outcome) {
	    return 'Екі';
	};
	var fa_p9 = function fa_p9(match, outcome) {
	    return 'Ешбірі';
	};
	var fa_q9 = function fa_q9(match, outcome) {
	    return "\u041A\u043E\u043C\u0430\u043D\u0434\u0430\u043B\u0430\u0440\u0434\u044B\u04A3 \u04D9\u0440\u049B\u0430\u0439\u0441\u044B\u0441\u044B " + (outcome.condition + 1) + " \u043D\u0435\u043C\u0435\u0441\u0435 \u043E\u0434\u0430\u043D \u0430\u0441\u0430\u0442\u044B\u043D \u0433\u043E\u043B\u0434\u044B \u0441\u0430\u043B\u0430\u0434\u044B";
	};
	var fa_r9 = function fa_r9(match, outcome) {
	    return "\u0422\u0443\u0440\u0430 \u0431\u0456\u0440\u0435\u0443\u0456 " + (outcome.condition + 1) + " \u043D\u0435\u043C\u0435\u0441\u0435 \u043E\u0434\u0430\u043D \u0430\u0441\u0430\u0442\u044B\u043D \u0433\u043E\u043B\u0434\u044B \u0441\u0430\u043B\u0430\u0434\u044B";
	};
	var fa_s9 = function fa_s9(match, outcome) {
	    return "\u0415\u0448\u043A\u0456\u043C " + (outcome.condition + 1) + " \u043D\u0435\u043C\u0435\u0441\u0435 \u043E\u0434\u0430\u043D \u0430\u0441\u0430\u0442\u044B\u043D \u0433\u043E\u043B\u0434\u044B \u0441\u0430\u043B\u0430\u0434\u044B";
	};
	var fa_t9 = function fa_t9(match, outcome) {
	    return 'Бірінші голды баспен ұрып салады';
	};
	var fa_u9 = function fa_u9(match, outcome) {
	    return 'Бірінші голды аяқпен (ойындағы) салады';
	};
	var fa_v9 = function fa_v9(match, outcome) {
	    return 'Бірінші гол автогол болады';
	};
	var fa_w9 = function fa_w9(match, outcome) {
	    return 'Бірінші гол пенальтиден салынады';
	};
	var fa_x9 = function fa_x9(match, outcome) {
	    return 'Бұрыштама';
	};
	var fa_y9 = function fa_y9(match, outcome) {
	    return 'Офсайд';
	};
	var fa_z9 = function fa_z9(match, outcome) {
	    return 'СК';
	};
	var fa_a10 = function fa_a10(match, outcome) {
	    return 'Гол';
	};
	var fa_b10 = function fa_b10(match, outcome) {
	    return 'Болады';
	};
	var fa_c10 = function fa_c10(match, outcome) {
	    return 'Болмайды';
	};
	var fa_d10 = function fa_d10(match, outcome) {
	    return "\u0415\u0440\u0442\u0435 " + outcome.condition;
	};
	var fa_e10 = function fa_e10(match, outcome) {
	    return 'Кейін';
	};
	var fa_f10 = function fa_f10(match, outcome) {
	    return 'Бірінші таймда';
	};
	var fa_g10 = function fa_g10(match, outcome) {
	    return 'Екінші таймда';
	};
	var fa_h10 = function fa_h10(match, outcome) {
	    return 'Гол болмайды';
	};
	var fa_i10 = function fa_i10(match, outcome) {
	    return 'Салмайды';
	};
	var fa_j10 = function fa_j10(match, outcome) {
	    return 'Ж1Т';
	};
	var fa_k10 = function fa_k10(match, outcome) {
	    return 'ТЖ1';
	};
	var fa_l10 = function fa_l10(match, outcome) {
	    return 'ТТ';
	};
	var fa_m10 = function fa_m10(match, outcome) {
	    return 'ТЖ2';
	};
	var fa_n10 = function fa_n10(match, outcome) {
	    return 'Ж2Т';
	};
	var fa_o10 = function fa_o10(match, outcome) {
	    return '0-6';
	};
	var fa_p10 = function fa_p10(match, outcome) {
	    return '1-6';
	};
	var fa_q10 = function fa_q10(match, outcome) {
	    return '6-0';
	};
	var fa_r10 = function fa_r10(match, outcome) {
	    return '6-1';
	};
	var fa_s10 = function fa_s10(match, outcome) {
	    return 'Голдық тең ойын';
	};
	var fa_t10 = function fa_t10(match, outcome) {
	    return 'Голсыз тең ойын';
	};
	var fa_u10 = function fa_u10(match, outcome) {
	    return 'Тең ойын емес';
	};
	var fa_v10 = function fa_v10(match, outcome) {
	    return 'Ерте';
	};
	var fa_w10 = function fa_w10(match, outcome) {
	    return 'Соғады';
	};
	var fa_x10 = function fa_x10(match, outcome) {
	    return 'Соқпайды';
	};
	var fa_y10 = function fa_y10(match, outcome) {
	    return 'Екі команда соқпайды';
	};
	var fa_z10 = function fa_z10(match, outcome) {
	    return 'Бірінші аздау';
	};
	var fa_a11 = function fa_a11(match, outcome) {
	    return 'Теңдік';
	};
	var fa_b11 = function fa_b11(match, outcome) {
	    return 'Бірінші көп';
	};
	var fa_c11 = function fa_c11(match, outcome) {
	    return "\u041C\u0435\u043D. " + outcome.condition;
	};
	var fa_d11 = function fa_d11(match, outcome) {
	    return "\u0411\u043E\u043B. " + outcome.condition;
	};
	var fa_e11 = function fa_e11(match, outcome) {
	    return 'Иә/Иә';
	};
	var fa_f11 = function fa_f11(match, outcome) {
	    return 'Иә/Жоқ';
	};
	var fa_g11 = function fa_g11(match, outcome) {
	    return 'Жоқ/Иә';
	};
	var fa_h11 = function fa_h11(match, outcome) {
	    return 'Жоқ/Жоқ';
	};
	var fa_i11 = function fa_i11(match, outcome) {
	    return "\u0422\u0431" + outcome.condition + "/\u0418\u04D9";
	};
	var fa_j11 = function fa_j11(match, outcome) {
	    return "\u0422\u0431" + outcome.condition + "/\u0416\u043E\u049B";
	};
	var fa_k11 = function fa_k11(match, outcome) {
	    return "\u0422\u043C" + outcome.condition + "/\u0418\u04D9";
	};
	var fa_l11 = function fa_l11(match, outcome) {
	    return "\u0422\u043C" + outcome.condition + "/\u0416\u043E\u049B";
	};
	var fa_m11 = function fa_m11(match, outcome) {
	    return 'Ж1 негізгі уақытта';
	};
	var fa_n11 = function fa_n11(match, outcome) {
	    return 'Ж2 негізгі уақытта';
	};
	var fa_o11 = function fa_o11(match, outcome) {
	    return 'Ж1 қосымша уақытта';
	};
	var fa_p11 = function fa_p11(match, outcome) {
	    return 'Ж2 қосымша уақытта';
	};
	var fa_q11 = function fa_q11(match, outcome) {
	    return 'Ж1 пенальти сериясында';
	};
	var fa_r11 = function fa_r11(match, outcome) {
	    return 'Ж2 пенальти сериясында';
	};
	var fa_s11 = function fa_s11(match, outcome) {
	    return '1 тайм';
	};
	var fa_t11 = function fa_t11(match, outcome) {
	    return 'Үзіліс';
	};
	var fa_u11 = function fa_u11(match, outcome) {
	    return '2 тайм';
	};
	var fa_v11 = function fa_v11(match, outcome) {
	    return "\u0410\u0437" + outcome.condition;
	};
	var fa_w11 = function fa_w11(match, outcome) {
	    return '5-4';
	};
	var fa_x11 = function fa_x11(match, outcome) {
	    return 'Ж1 кез келген басқамен';
	};
	var fa_y11 = function fa_y11(match, outcome) {
	    return '4-5';
	};
	var fa_z11 = function fa_z11(match, outcome) {
	    return 'Ж2 кез келген басқамен';
	};
	var fa_a12 = function fa_a12(match, outcome) {
	    return '1-10';
	};
	var fa_b12 = function fa_b12(match, outcome) {
	    return '11-20';
	};
	var fa_c12 = function fa_c12(match, outcome) {
	    return '21-30';
	};
	var fa_d12 = function fa_d12(match, outcome) {
	    return '31-40';
	};
	var fa_e12 = function fa_e12(match, outcome) {
	    return '41-50';
	};
	var fa_f12 = function fa_f12(match, outcome) {
	    return '51-60';
	};
	var fa_g12 = function fa_g12(match, outcome) {
	    return '61-70';
	};
	var fa_h12 = function fa_h12(match, outcome) {
	    return '71-80';
	};
	var fa_i12 = function fa_i12(match, outcome) {
	    return '81-ОВ соңы';
	};
	var fa_j12 = function fa_j12(match, outcome) {
	    return 'Гол жоқ';
	};
	var fa_k12 = function fa_k12(match, outcome) {
	    return 'Ж1: 8 және одан асады';
	};
	var fa_l12 = function fa_l12(match, outcome) {
	    return '1<2';
	};
	var fa_m12 = function fa_m12(match, outcome) {
	    return '1=2';
	};
	var fa_n12 = function fa_n12(match, outcome) {
	    return '1>2';
	};
	var fa_o12 = function fa_o12(match, outcome) {
	    return '1<3';
	};
	var fa_p12 = function fa_p12(match, outcome) {
	    return '1=3';
	};
	var fa_q12 = function fa_q12(match, outcome) {
	    return '1>3';
	};
	var fa_r12 = function fa_r12(match, outcome) {
	    return '2<3';
	};
	var fa_s12 = function fa_s12(match, outcome) {
	    return '2=3';
	};
	var fa_t12 = function fa_t12(match, outcome) {
	    return '2>3';
	};
	var fa_u12 = function fa_u12(match, outcome) {
	    return 'Чет';
	};
	var fa_v12 = function fa_v12(match, outcome) {
	    return 'Нечет';
	};
	var fa_w12 = function fa_w12(match, outcome) {
	    return 'Первый меньше';
	};
	var fa_x12 = function fa_x12(match, outcome) {
	    return 'Первый больше';
	};
	var fa_y12 = function fa_y12(match, outcome) {
	    return 'Да';
	};
	var fa_z12 = function fa_z12(match, outcome) {
	    return 'Нет';
	};
	var fa_a13 = function fa_a13(match, outcome) {
	    return '1-ші жоғары';
	};
	var fa_b13 = function fa_b13(match, outcome) {
	    return '2-ші жоғары';
	};
	var fa_c13 = function fa_c13(match, outcome) {
	    return 'Ж1: 4 раунд';
	};
	var fa_d13 = function fa_d13(match, outcome) {
	    return 'Ж1: ұпай бойынша жеңіс';
	};
	var fa_e13 = function fa_e13(match, outcome) {
	    return 'Тең түсу';
	};
	var fa_f13 = function fa_f13(match, outcome) {
	    return 'Ж2: ұпайлар бойынша жеңіс';
	};
	var fa_g13 = function fa_g13(match, outcome) {
	    return 'иә';
	};
	var fa_h13 = function fa_h13(match, outcome) {
	    return 'жоқ';
	};
	var fa_i13 = function fa_i13(match, outcome) {
	    return 'Сары шар';
	};
	var fa_j13 = function fa_j13(match, outcome) {
	    return 'Жасыл шар';
	};
	var fa_k13 = function fa_k13(match, outcome) {
	    return 'Қоңыр шар';
	};
	var fa_l13 = function fa_l13(match, outcome) {
	    return 'Көк шар';
	};
	var fa_m13 = function fa_m13(match, outcome) {
	    return 'Қызғылт шар';
	};
	var fa_n13 = function fa_n13(match, outcome) {
	    return 'Қара шар';
	};
	var fa_o13 = function fa_o13(match, outcome) {
	    return "\u2265 " + (outcome.condition + 5);
	};
	var fa_p13 = function fa_p13(match, outcome) {
	    return '≤ 14';
	};
	var fa_q13 = function fa_q13(match, outcome) {
	    return '15-тен 17 дейін';
	};
	var fa_r13 = function fa_r13(match, outcome) {
	    return '18-ден 19 дейін';
	};
	var fa_s13 = function fa_s13(match, outcome) {
	    return '≥ 20';
	};
	var fa_t13 = function fa_t13(match, outcome) {
	    return "\u0410\u0437 " + outcome.condition;
	};
	var fa_u13 = function fa_u13(match, outcome) {
	    return 'Ж1-0';
	};
	var fa_v13 = function fa_v13(match, outcome) {
	    return 'Ж1-15';
	};
	var fa_w13 = function fa_w13(match, outcome) {
	    return 'Ж1-30';
	};
	var fa_x13 = function fa_x13(match, outcome) {
	    return 'Ж1-40';
	};
	var fa_y13 = function fa_y13(match, outcome) {
	    return '0-Ж2';
	};
	var fa_z13 = function fa_z13(match, outcome) {
	    return '15-Ж2';
	};
	var fa_a14 = function fa_a14(match, outcome) {
	    return '30-Ж2';
	};
	var fa_b14 = function fa_b14(match, outcome) {
	    return '40-Ж2';
	};
	var fa_c14 = function fa_c14(match, outcome) {
	    return '3-6';
	};
	var fa_d14 = function fa_d14(match, outcome) {
	    return '5-7';
	};
	var fa_e14 = function fa_e14(match, outcome) {
	    return '6-2';
	};
	var fa_f14 = function fa_f14(match, outcome) {
	    return '6-3';
	};
	var fa_g14 = function fa_g14(match, outcome) {
	    return '6-4';
	};
	var fa_h14 = function fa_h14(match, outcome) {
	    return '6-7';
	};
	var fa_i14 = function fa_i14(match, outcome) {
	    return '7-5';
	};
	var fa_j14 = function fa_j14(match, outcome) {
	    return '7-6';
	};
	var fa_k14 = function fa_k14(match, outcome) {
	    return '7-0';
	};
	var fa_l14 = function fa_l14(match, outcome) {
	    return '7-1';
	};
	var fa_m14 = function fa_m14(match, outcome) {
	    return '7-2';
	};
	var fa_n14 = function fa_n14(match, outcome) {
	    return '7-3';
	};
	var fa_o14 = function fa_o14(match, outcome) {
	    return '7-4';
	};
	var fa_p14 = function fa_p14(match, outcome) {
	    return 'Кез келген басқамен Ж1';
	};
	var fa_q14 = function fa_q14(match, outcome) {
	    return '0-7';
	};
	var fa_r14 = function fa_r14(match, outcome) {
	    return '1-7';
	};
	var fa_s14 = function fa_s14(match, outcome) {
	    return '2-7';
	};
	var fa_t14 = function fa_t14(match, outcome) {
	    return '3-7';
	};
	var fa_u14 = function fa_u14(match, outcome) {
	    return '4-7';
	};
	var fa_v14 = function fa_v14(match, outcome) {
	    return 'Кез келген басқамен Ж2';
	};
	var fa_w14 = function fa_w14(match, outcome) {
	    return '8';
	};
	var fa_x14 = function fa_x14(match, outcome) {
	    return '9';
	};
	var fa_y14 = function fa_y14(match, outcome) {
	    return '10';
	};
	var fa_z14 = function fa_z14(match, outcome) {
	    return '11';
	};
	var fa_a15 = function fa_a15(match, outcome) {
	    return '≥ 13';
	};
	var fa_b15 = function fa_b15(match, outcome) {
	    return match.homeTeam + " (\u0421.\u041F.)";
	};
	var fa_c15 = function fa_c15(match, outcome) {
	    return match.awayTeam + " (\u0421.\u041F.)";
	};
	var fa_d15 = function fa_d15(match, outcome) {
	    return 'Равенство';
	};
	var fa_e15 = function fa_e15(match, outcome) {
	    return 'Екеуі деП1';
	};
	var fa_f15 = function fa_f15(match, outcome) {
	    return 'Тең ойын';
	};
	var fa_g15 = function fa_g15(match, outcome) {
	    return 'Екеуі де Ж2';
	};
	var fa_h15 = function fa_h15(match, outcome) {
	    return 'ПЖ';
	};
	var fa_i15 = function fa_i15(match, outcome) {
	    return 'Ф1';
	};
	var fa_j15 = function fa_j15(match, outcome) {
	    return 'Ф2';
	};
	var fa_k15 = function fa_k15(match, outcome) {
	    return outcome.condition + 1 + " " + (outcome.condition + 2) + " \u0434\u0435\u0439\u0456\u043D";
	};
	var fa_l15 = function fa_l15(match, outcome) {
	    return " " + (outcome.condition + 3) + " " + (outcome.condition + 4) + " \u0434\u0435\u0439\u0456\u043D";
	};
	var fa_m15 = function fa_m15(match, outcome) {
	    return " " + (outcome.condition + 5) + " " + (outcome.condition + 6) + " \u0434\u0435\u0439\u0456\u043D";
	};
	var fa_n15 = function fa_n15(match, outcome) {
	    return 'Ж1: 7 және одан көп';
	};
	var fa_o15 = function fa_o15(match, outcome) {
	    return 'Ж2: 7 және одан көп';
	};
	var fa_p15 = function fa_p15(match, outcome) {
	    return '6-5';
	};
	var fa_q15 = function fa_q15(match, outcome) {
	    return '5-6';
	};
	
	var groupConfig = {
	    32: {
	        0: 'Жарыс',
	        1: 'Бірінші сет',
	        2: 'Екінші сет',
	        3: 'Үшінші сет',
	        4: 'Кіші-сет - 10 ұпайға дейін (Бірінші сет)',
	        5: 'Кіші-сет - 15 ұпайға дейін (Бірінші сет)',
	        6: 'Кіші-сет - 10 ұпайға дейін (Екінші сет)',
	        7: 'Кіші-сет - 15 ұпайға дейін (Екінші сет)',
	        8: 'Кіші-сет - 10 ұпайға дейін (Үшінші сет)',
	        9: 'Кіші-сет - 15 ұпайға дейін (Үшінші сет)'
	    },
	    35: {
	        0: 'Жарыс',
	        1: 'Бірінші кезең'
	    },
	    31: {
	        0: 'Жарыс',
	        1: 'Бірінші ширек',
	        2: 'Екінші ширек',
	        3: 'Үшінші ширек',
	        4: 'Төртінші ширек',
	        5: 'Екі ұпайлы лақтыру',
	        6: 'Үш ұпайлы лақтыру',
	        7: 'Бірінші жарты',
	        8: 'Екінші жарты'
	    },
	    41: {
	        0: 'Жарыс',
	        1: 'Бірінші жарты',
	        2: 'Екінші жарты',
	        3: 'Екі ұпайлы лақтыру',
	        4: 'Үш ұпайлы лақтыру'
	    },
	    18: {
	        0: 'Жарыс',
	        1: 'Бірінші кезең',
	        2: 'Екінші кезең',
	        3: 'Үшінші кезең'
	    },
	    3: {
	        0: 'Жарыс',
	        1: 'Бірінші сет',
	        2: 'Екінші сет',
	        3: 'Үшінші сет',
	        4: 'Кіші-сет - 10 ұпайға дейін (Бірінші сет)',
	        5: 'Кіші-сет - 15 ұпайға дейін (Бірінші сет)',
	        6: 'Кіші-сет - 10 ұпайға дейін (Екінші сет)',
	        7: 'Кіші-сет - 15 ұпайға дейін (Екінші сет)'
	    },
	    20: {
	        0: 'Жарыс',
	        1: 'Бірінші ату шебі',
	        2: 'Екінші ату шебі',
	        3: 'Үшінші ату шебі',
	        4: 'Төртінші ату шебі',
	        5: 'Бесінші ату шебі',
	        6: 'Алтыншы ату шебі',
	        7: 'Жетінші ату шебі',
	        8: 'Сегізінші ату шебі'
	    },
	    42: {
	        0: 'Жарыс',
	        1: 'Бірінші карта',
	        2: 'Екінші карта',
	        3: 'Үшінші карта',
	        4: 'Төртінші карта',
	        5: 'Бесінші карта'
	    },
	    36: {
	        0: 'Жарыс',
	        1: 'Бірінші кезең'
	    },
	    7: {
	        0: 'Жарыс',
	        1: 'Бірінші тайм',
	        2: 'Екінші тайм',
	        3: '1-ден 15 минут аралығында',
	        4: '16-дан 30 минут аралығында',
	        5: '31 минуттан үзіліске дейін',
	        6: '46-дан 60 минут аралығында',
	        7: '61-ден 75 минут аралығында',
	        8: '76 минуттан НУ соңына дейін',
	        9: 'Бұрыштық',
	        10: 'Бұрыштық (Бірінші тайм)',
	        11: 'Сары карточкалар',
	        12: 'Сары карточкалар (Бірінші тайм)',
	        13: 'Қосымша уақыт',
	        14: 'Бірінші қосымша уақыт',
	        15: 'Екінші қосымша уақыт',
	        16: 'Пенальти сериясы'
	    },
	    34: {
	        0: 'Жарыс',
	        1: 'Бірінші тайм',
	        2: 'Екінші тайм',
	        3: '1-ден 15 минут аралығында',
	        4: '16-дан 30 минут аралығында',
	        5: '31 минуттан үзіліске дейін',
	        6: '46-дан 60 минут аралығында',
	        7: '61-ден 75 минут аралығында',
	        8: '76 минуттан НУ соңына дейін',
	        9: 'Бұрыштық',
	        10: 'Сары карточкалар'
	    },
	    19: {
	        0: 'Жарыс',
	        1: 'Бірінші кезең',
	        2: 'Екінші кезең'
	    },
	    30: {
	        0: 'Жарыс',
	        1: 'Бірінші кезең',
	        2: 'Екінші кезең',
	        3: 'Үшінші кезең',
	        4: '1-ден 10 минут аралығында',
	        5: '11-ден 20 минут аралығында',
	        6: '21-ден 30 минут аралығында',
	        7: '31-ден 40 минут аралығында',
	        8: '41-ден 50 минут аралығында',
	        9: '51-ден 60 минут аралығында'
	    },
	    9: {
	        0: 'Жарыс',
	        1: 'Бірінші кезең',
	        2: 'Екінші кезең'
	    },
	    29: {
	        0: 'Жарыс',
	        1: 'Бірінші кезең',
	        2: 'Екінші кезең',
	        3: 'Үшінші кезең',
	        4: 'Төртінші кезең',
	        5: 'Бесінші кезең',
	        6: 'Алтыншы кезең',
	        7: 'Жетінші кезең',
	        8: 'Сегізінші кезең',
	        9: 'Тоғызыншы кезең',
	        10: 'Оныншы кезең',
	        11: 'Он бірінші кезең',
	        12: 'Он екінші кезең',
	        13: 'Он үшінші кезең',
	        14: 'Он төртінші кезең',
	        15: 'Он бесінші кезең',
	        16: 'Он алтыншы кезең',
	        17: 'Семнадцатый период',
	        18: 'Он жетінші кезең',
	        19: 'Он сегізінші кезең',
	        20: 'Жиырмасыншы кезең',
	        21: 'Жиырма бірінші кезең',
	        22: 'Жиырма екінші кезең',
	        23: 'Жиырма үшінші кезең',
	        24: 'Жиырма төртінші кезең',
	        25: 'Жиырма бесінші кезең',
	        26: 'Жиырма алтыншы кезең',
	        27: 'Жиырма жетінші кезең',
	        28: 'Жиырма сегізінші кезең',
	        29: 'Жиырма тоғызыншы кезең',
	        30: 'Отызыншы кезең',
	        31: 'Отыз бірінші кезең',
	        32: 'Отыз екінші кезең',
	        33: 'Отыз үшінші кезең',
	        34: 'Отыз төртінші кезең',
	        35: 'Отыз бесінші кезең',
	        36: 'Отыз алтыншы кезең',
	        37: 'Отыз жетінші кезең'
	    },
	    2: {
	        0: 'Жарыс',
	        1: 'Бірінші сет',
	        2: 'Екінші сет',
	        3: 'Үшінші сет',
	        4: 'Төртінші сет',
	        5: 'Бесінші сет',
	        6: 'Алтыншы сет',
	        7: 'Жетінші сет'
	    },
	    6: {
	        0: 'Матч',
	        1: 'Бірінші сет',
	        2: 'Екінші сет',
	        3: 'Үшінші сет',
	        4: 'Төртінші сет',
	        5: 'Бесінші сет'
	    },
	    4: {
	        0: 'Жарыс',
	        1: 'Бірінші сет',
	        2: 'Екінші сет',
	        3: 'Үшінші сет',
	        4: 'Төртінші сет',
	        5: 'Бесінші сет',
	        6: 'Алтыншы сет',
	        7: 'Кіші-сет - 10 ұпайға дейін (Бірінші сет)',
	        8: 'Кіші-сет - 15 ұпайға дейін (Бірінші сет)',
	        9: 'Кіші-сет - 10 ұпайға дейін (Екінші сет)',
	        10: 'Кіші-сет - 15 ұпайға дейін (Екінші сет)',
	        11: 'Кіші-сет - 10 ұпайға дейін (Үшінші сет)',
	        12: 'Кіші-сет - 15 ұпайға дейін (Үшінші сет)',
	        13: 'Кіші-сет - 10 ұпайға дейін (Төртінші сет)',
	        14: 'Кіші-сет - 15 ұпайға дейін (Төртінші сет)'
	    },
	    8: {
	        0: 'Жарыс',
	        1: 'Бірінші ширек',
	        2: 'Екінші ширек',
	        3: 'Үшінші ширек',
	        4: 'Төртінші ширек'
	    }
	};
	
	var slotConfig = {
	    32: {
	        366: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        557: sl_e1,
	        607: sl_f1,
	        122: sl_g1,
	        129: sl_h1,
	        138: sl_i1,
	        182: sl_j1,
	        367: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        558: sl_e1,
	        608: sl_f1,
	        123: sl_k1,
	        130: sl_h1,
	        139: sl_i1,
	        183: sl_j1,
	        368: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        559: sl_e1,
	        609: sl_f1,
	        124: sl_k1,
	        131: sl_h1,
	        140: sl_i1,
	        184: sl_j1,
	        362: sl_l1,
	        17: sl_c1,
	        176: sl_m1,
	        358: sl_l1,
	        13: sl_c1,
	        172: sl_m1,
	        363: sl_l1,
	        18: sl_c1,
	        177: sl_m1,
	        359: sl_l1,
	        14: sl_c1,
	        173: sl_m1,
	        364: sl_l1,
	        19: sl_c1,
	        178: sl_m1,
	        360: sl_l1,
	        15: sl_c1,
	        174: sl_m1
	    },
	    35: {
	        664: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1
	    },
	    31: {
	        664: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        769: sl_n1,
	        138: sl_i1,
	        182: sl_j1,
	        775: sl_o1,
	        765: sl_p1,
	        629: sl_q1,
	        633: sl_r1,
	        665: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        770: sl_n1,
	        139: sl_i1,
	        183: sl_j1,
	        776: sl_o1,
	        766: sl_p1,
	        630: sl_q1,
	        634: sl_s1,
	        666: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        771: sl_n1,
	        140: sl_i1,
	        184: sl_j1,
	        777: sl_o1,
	        767: sl_p1,
	        631: sl_q1,
	        635: sl_r1,
	        667: sl_b1,
	        24: sl_c1,
	        198: sl_d1,
	        772: sl_n1,
	        141: sl_i1,
	        185: sl_j1,
	        778: sl_o1,
	        768: sl_p1,
	        632: sl_q1,
	        636: sl_r1,
	        676: sl_t1,
	        248: sl_m1,
	        62: sl_c1,
	        241: sl_u1,
	        233: sl_v1,
	        406: sl_w1,
	        675: sl_t1,
	        246: sl_m1,
	        61: sl_c1,
	        240: sl_u1,
	        232: sl_v1,
	        405: sl_w1,
	        672: sl_t1,
	        58: sl_c1,
	        238: sl_d1,
	        234: sl_i1,
	        236: sl_j1,
	        673: sl_t1,
	        59: sl_c1,
	        239: sl_d1,
	        235: sl_i1,
	        237: sl_j1
	    },
	    41: {
	        664: sl_x1,
	        21: sl_c1,
	        195: sl_m1,
	        782: sl_y1,
	        785: sl_z1,
	        780: sl_a2,
	        138: sl_u1,
	        182: sl_v1,
	        639: sl_b2,
	        665: sl_x1,
	        22: sl_c1,
	        196: sl_m1,
	        783: sl_y1,
	        786: sl_z1,
	        781: sl_a2,
	        139: sl_u1,
	        183: sl_v1,
	        640: sl_b2,
	        64: sl_c1,
	        678: sl_x1,
	        250: sl_m1,
	        63: sl_c1,
	        677: sl_x1,
	        249: sl_m1
	    },
	    18: {
	        664: sl_b1,
	        195: sl_d1,
	        698: sl_c2,
	        21: sl_c1,
	        734: sl_d2,
	        665: sl_b1,
	        196: sl_d1,
	        699: sl_c2,
	        22: sl_c1,
	        735: sl_d2,
	        666: sl_b1,
	        197: sl_d1,
	        700: sl_c2,
	        23: sl_c1,
	        736: sl_d2
	    },
	    3: {
	        366: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        896: sl_e2,
	        138: sl_i1,
	        182: sl_j1,
	        557: sl_e1,
	        83: sl_f2,
	        788: sl_g2,
	        842: sl_h2,
	        845: sl_i2,
	        848: sl_j2,
	        607: sl_k2,
	        791: sl_l2,
	        367: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        897: sl_e2,
	        139: sl_i1,
	        183: sl_j1,
	        558: sl_e1,
	        84: sl_f2,
	        789: sl_g2,
	        843: sl_h2,
	        846: sl_i2,
	        849: sl_j2,
	        608: sl_k2,
	        792: sl_l2,
	        368: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        898: sl_e2,
	        140: sl_i1,
	        184: sl_j1,
	        559: sl_e1,
	        85: sl_f2,
	        790: sl_g2,
	        844: sl_h2,
	        847: sl_i2,
	        850: sl_j2,
	        609: sl_k2,
	        793: sl_l2,
	        362: sl_l1,
	        17: sl_c1,
	        176: sl_m1,
	        358: sl_l1,
	        13: sl_c1,
	        172: sl_m1,
	        363: sl_l1,
	        18: sl_c1,
	        177: sl_m1,
	        359: sl_l1,
	        14: sl_c1,
	        173: sl_m1
	    },
	    20: {
	        664: sl_t1,
	        21: sl_c1,
	        195: sl_m1,
	        138: sl_i1,
	        182: sl_j1,
	        851: sl_n1,
	        665: sl_t1,
	        22: sl_c1,
	        196: sl_m1,
	        139: sl_i1,
	        183: sl_j1,
	        852: sl_n1,
	        666: sl_t1,
	        23: sl_c1,
	        197: sl_m1,
	        140: sl_i1,
	        184: sl_j1,
	        853: sl_n1,
	        667: sl_t1,
	        24: sl_c1,
	        198: sl_m1,
	        141: sl_i1,
	        185: sl_j1,
	        854: sl_n1,
	        199: sl_t1,
	        142: sl_c1,
	        186: sl_m1,
	        25: sl_i1,
	        668: sl_j1,
	        855: sl_n1,
	        200: sl_t1,
	        143: sl_c1,
	        187: sl_m1,
	        26: sl_i1,
	        669: sl_j1,
	        856: sl_n1,
	        201: sl_t1,
	        144: sl_c1,
	        188: sl_m1,
	        27: sl_i1,
	        670: sl_j1,
	        857: sl_n1,
	        202: sl_t1,
	        145: sl_c1,
	        189: sl_m1,
	        28: sl_i1,
	        671: sl_j1,
	        858: sl_n1
	    },
	    42: {
	        557: sl_m2,
	        1865: sl_n2,
	        558: sl_m2,
	        1866: sl_n2,
	        559: sl_m2,
	        1867: sl_n2,
	        560: sl_m2,
	        1868: sl_n2,
	        561: sl_m2,
	        1869: sl_n2
	    },
	    36: {
	        664: sl_b1,
	        21: sl_c1,
	        195: sl_d1
	    },
	    7: {
	        426: sl_o2,
	        526: sl_p2,
	        419: sl_q2,
	        519: sl_r2,
	        664: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1,
	        734: sl_s2,
	        756: sl_n1,
	        698: sl_t2,
	        794: sl_u2,
	        860: sl_v2,
	        273: sl_w2,
	        83: sl_f2,
	        727: sl_x2,
	        729: sl_y2,
	        731: sl_z2,
	        648: sl_a3,
	        420: sl_q2,
	        520: sl_r2,
	        665: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        139: sl_i1,
	        183: sl_j1,
	        735: sl_s2,
	        757: sl_n1,
	        699: sl_t2,
	        859: sl_u2,
	        861: sl_v2,
	        274: sl_w2,
	        84: sl_f2,
	        728: sl_x2,
	        649: sl_a3,
	        652: sl_b1,
	        641: sl_a3,
	        2: sl_c1,
	        160: sl_d1,
	        148: sl_i1,
	        154: sl_j1,
	        655: sl_b1,
	        642: sl_a3,
	        5: sl_c1,
	        163: sl_d1,
	        149: sl_i1,
	        155: sl_j1,
	        657: sl_b1,
	        643: sl_a3,
	        7: sl_c1,
	        165: sl_d1,
	        150: sl_i1,
	        156: sl_j1,
	        658: sl_b1,
	        644: sl_a3,
	        930: sl_c1,
	        166: sl_d1,
	        151: sl_i1,
	        157: sl_j1,
	        660: sl_b1,
	        645: sl_a3,
	        9: sl_c1,
	        168: sl_d1,
	        152: sl_i1,
	        158: sl_j1,
	        663: sl_b1,
	        646: sl_a3,
	        12: sl_c1,
	        171: sl_d1,
	        153: sl_i1,
	        159: sl_j1,
	        680: sl_b1,
	        66: sl_c1,
	        255: sl_d1,
	        438: sl_b3,
	        354: sl_i1,
	        355: sl_j1,
	        681: sl_b1,
	        67: sl_c1,
	        258: sl_d1,
	        356: sl_i1,
	        357: sl_j1,
	        690: sl_b1,
	        81: sl_c1,
	        353: sl_d1,
	        440: sl_c3,
	        441: sl_d3,
	        682: sl_b1,
	        68: sl_c1,
	        259: sl_d1,
	        146: sl_i1,
	        650: sl_a3,
	        740: sl_e3,
	        69: sl_c1,
	        262: sl_m1,
	        683: sl_f3,
	        694: sl_y2,
	        180: sl_j1,
	        70: sl_c1,
	        263: sl_m1,
	        684: sl_b1,
	        72: sl_c1,
	        277: sl_m1,
	        686: sl_b1,
	        181: sl_g3,
	        147: sl_h3,
	        741: sl_e3,
	        276: sl_i3,
	        275: sl_j3
	    },
	    34: {
	        419: sl_q2,
	        519: sl_r2,
	        664: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1,
	        734: sl_s2,
	        756: sl_n1,
	        698: sl_t2,
	        794: sl_k3,
	        860: sl_l3,
	        83: sl_f2,
	        420: sl_q2,
	        520: sl_r2,
	        665: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        139: sl_i1,
	        183: sl_j1,
	        735: sl_s2,
	        757: sl_n1,
	        699: sl_t2,
	        795: sl_k3,
	        861: sl_l3,
	        84: sl_f2,
	        652: sl_b1,
	        2: sl_c1,
	        160: sl_d1,
	        148: sl_i1,
	        154: sl_j1,
	        655: sl_b1,
	        5: sl_c1,
	        163: sl_d1,
	        149: sl_i1,
	        155: sl_j1,
	        657: sl_b1,
	        7: sl_c1,
	        165: sl_d1,
	        150: sl_i1,
	        156: sl_j1,
	        658: sl_b1,
	        930: sl_c1,
	        166: sl_d1,
	        151: sl_i1,
	        157: sl_j1,
	        660: sl_b1,
	        9: sl_c1,
	        168: sl_d1,
	        152: sl_i1,
	        158: sl_j1,
	        663: sl_b1,
	        12: sl_c1,
	        171: sl_d1,
	        153: sl_i1,
	        159: sl_j1,
	        255: sl_d1,
	        353: sl_d1
	    },
	    19: {
	        664: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        877: sl_n1,
	        138: sl_i1,
	        182: sl_j1,
	        875: sl_g2,
	        873: sl_h2,
	        196: sl_d1,
	        878: sl_n1,
	        876: sl_g2,
	        874: sl_h2,
	        665: sl_b1,
	        22: sl_c1
	    },
	    30: {
	        664: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        756: sl_n1,
	        138: sl_i1,
	        182: sl_j1,
	        734: sl_s2,
	        83: sl_f2,
	        698: sl_c2,
	        665: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        757: sl_n1,
	        139: sl_i1,
	        183: sl_j1,
	        735: sl_s2,
	        84: sl_f2,
	        699: sl_c2,
	        666: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        758: sl_n1,
	        140: sl_i1,
	        184: sl_j1,
	        736: sl_s2,
	        85: sl_f2,
	        700: sl_c2,
	        653: sl_b1,
	        161: sl_d1,
	        3: sl_c1,
	        654: sl_b1,
	        162: sl_d1,
	        4: sl_c1,
	        656: sl_b1,
	        164: sl_d1,
	        6: sl_c1,
	        659: sl_b1,
	        167: sl_d1,
	        8: sl_c1,
	        661: sl_b1,
	        169: sl_d1,
	        10: sl_c1,
	        662: sl_b1,
	        170: sl_d1,
	        11: sl_c1
	    },
	    9: {
	        664: sl_b1,
	        195: sl_d1,
	        665: sl_b1,
	        196: sl_d1
	    },
	    29: {
	        366: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        466: sl_m3,
	        557: sl_n3,
	        799: sl_o3,
	        83: sl_f2,
	        367: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        467: sl_m3,
	        558: sl_n3,
	        800: sl_o3,
	        84: sl_f2,
	        368: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        468: sl_m3,
	        559: sl_n3,
	        801: sl_o3,
	        85: sl_f2,
	        369: sl_b1,
	        24: sl_c1,
	        198: sl_d1,
	        469: sl_m3,
	        560: sl_n3,
	        802: sl_o3,
	        86: sl_f2,
	        370: sl_b1,
	        25: sl_c1,
	        199: sl_d1,
	        470: sl_m3,
	        561: sl_n3,
	        803: sl_o3,
	        87: sl_f2,
	        371: sl_b1,
	        26: sl_c1,
	        200: sl_d1,
	        471: sl_m3,
	        562: sl_n3,
	        804: sl_o3,
	        88: sl_f2,
	        372: sl_b1,
	        27: sl_c1,
	        201: sl_d1,
	        472: sl_m3,
	        563: sl_n3,
	        805: sl_o3,
	        89: sl_f2,
	        373: sl_b1,
	        28: sl_c1,
	        202: sl_d1,
	        473: sl_m3,
	        564: sl_n3,
	        806: sl_o3,
	        90: sl_f2,
	        374: sl_b1,
	        29: sl_c1,
	        203: sl_d1,
	        474: sl_m3,
	        565: sl_n3,
	        807: sl_o3,
	        91: sl_f2,
	        375: sl_b1,
	        30: sl_c1,
	        204: sl_d1,
	        475: sl_m3,
	        566: sl_n3,
	        808: sl_o3,
	        92: sl_f2,
	        376: sl_b1,
	        31: sl_c1,
	        205: sl_d1,
	        476: sl_m3,
	        567: sl_n3,
	        809: sl_o3,
	        93: sl_f2,
	        377: sl_b1,
	        32: sl_c1,
	        206: sl_d1,
	        477: sl_m3,
	        568: sl_n3,
	        810: sl_o3,
	        94: sl_f2,
	        378: sl_b1,
	        33: sl_c1,
	        207: sl_d1,
	        478: sl_m3,
	        569: sl_n3,
	        811: sl_o3,
	        95: sl_f2,
	        379: sl_b1,
	        34: sl_c1,
	        208: sl_d1,
	        479: sl_m3,
	        570: sl_n3,
	        812: sl_o3,
	        96: sl_f2,
	        380: sl_b1,
	        35: sl_c1,
	        209: sl_d1,
	        480: sl_m3,
	        571: sl_n3,
	        813: sl_o3,
	        97: sl_f2,
	        381: sl_b1,
	        36: sl_c1,
	        210: sl_d1,
	        481: sl_m3,
	        572: sl_n3,
	        814: sl_o3,
	        98: sl_f2,
	        382: sl_b1,
	        37: sl_c1,
	        211: sl_d1,
	        482: sl_m3,
	        573: sl_n3,
	        815: sl_o3,
	        99: sl_f2,
	        383: sl_b1,
	        38: sl_c1,
	        212: sl_d1,
	        483: sl_m3,
	        574: sl_n3,
	        816: sl_o3,
	        100: sl_f2,
	        384: sl_b1,
	        39: sl_c1,
	        213: sl_d1,
	        484: sl_m3,
	        575: sl_n3,
	        817: sl_o3,
	        101: sl_f2,
	        385: sl_b1,
	        40: sl_c1,
	        214: sl_d1,
	        485: sl_m3,
	        576: sl_n3,
	        818: sl_o3,
	        104: sl_f2,
	        386: sl_b1,
	        41: sl_c1,
	        215: sl_d1,
	        486: sl_m3,
	        577: sl_n3,
	        819: sl_o3,
	        105: sl_f2,
	        387: sl_b1,
	        42: sl_c1,
	        216: sl_d1,
	        487: sl_m3,
	        578: sl_n3,
	        820: sl_o3,
	        106: sl_f2,
	        388: sl_b1,
	        43: sl_c1,
	        217: sl_d1,
	        488: sl_m3,
	        579: sl_n3,
	        821: sl_o3,
	        107: sl_f2,
	        389: sl_b1,
	        44: sl_c1,
	        218: sl_d1,
	        489: sl_m3,
	        580: sl_n3,
	        822: sl_o3,
	        108: sl_f2,
	        390: sl_b1,
	        45: sl_c1,
	        219: sl_d1,
	        490: sl_m3,
	        581: sl_n3,
	        823: sl_o3,
	        109: sl_f2,
	        391: sl_b1,
	        46: sl_c1,
	        220: sl_d1,
	        491: sl_m3,
	        582: sl_n3,
	        824: sl_o3,
	        110: sl_f2,
	        392: sl_b1,
	        47: sl_c1,
	        221: sl_d1,
	        492: sl_m3,
	        583: sl_n3,
	        825: sl_o3,
	        111: sl_f2,
	        393: sl_b1,
	        48: sl_c1,
	        222: sl_d1,
	        493: sl_m3,
	        584: sl_n3,
	        826: sl_o3,
	        112: sl_f2,
	        394: sl_b1,
	        49: sl_c1,
	        223: sl_d1,
	        494: sl_m3,
	        585: sl_n3,
	        827: sl_o3,
	        113: sl_f2,
	        395: sl_b1,
	        50: sl_c1,
	        224: sl_d1,
	        495: sl_m3,
	        586: sl_n3,
	        828: sl_o3,
	        114: sl_f2,
	        396: sl_b1,
	        51: sl_c1,
	        225: sl_d1,
	        496: sl_m3,
	        587: sl_n3,
	        829: sl_o3,
	        115: sl_f2,
	        397: sl_b1,
	        52: sl_c1,
	        226: sl_d1,
	        497: sl_m3,
	        588: sl_n3,
	        830: sl_o3,
	        116: sl_f2,
	        398: sl_b1,
	        53: sl_c1,
	        227: sl_d1,
	        498: sl_m3,
	        589: sl_n3,
	        831: sl_o3,
	        117: sl_f2,
	        399: sl_b1,
	        54: sl_c1,
	        228: sl_d1,
	        499: sl_m3,
	        590: sl_n3,
	        832: sl_o3,
	        118: sl_f2,
	        400: sl_b1,
	        55: sl_c1,
	        229: sl_d1,
	        500: sl_m3,
	        591: sl_n3,
	        833: sl_o3,
	        119: sl_f2,
	        401: sl_b1,
	        56: sl_c1,
	        230: sl_d1,
	        501: sl_m3,
	        592: sl_n3,
	        834: sl_o3,
	        120: sl_f2,
	        402: sl_b1,
	        57: sl_c1,
	        231: sl_d1,
	        502: sl_m3,
	        593: sl_n3,
	        835: sl_o3,
	        121: sl_f2
	    },
	    2: {
	        366: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1,
	        607: sl_f1,
	        557: sl_n3,
	        863: sl_n1,
	        885: sl_n1,
	        122: sl_g1,
	        129: sl_p3,
	        83: sl_q3,
	        367: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        139: sl_i1,
	        183: sl_j1,
	        608: sl_f1,
	        558: sl_n3,
	        864: sl_n1,
	        886: sl_n1,
	        123: sl_g1,
	        130: sl_p3,
	        84: sl_q3,
	        368: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        140: sl_i1,
	        184: sl_j1,
	        609: sl_f1,
	        559: sl_n3,
	        865: sl_n1,
	        887: sl_n1,
	        124: sl_g1,
	        131: sl_p3,
	        85: sl_q3,
	        369: sl_b1,
	        24: sl_c1,
	        198: sl_d1,
	        141: sl_i1,
	        185: sl_j1,
	        610: sl_f1,
	        560: sl_n3,
	        866: sl_n1,
	        888: sl_n1,
	        125: sl_g1,
	        132: sl_p3,
	        86: sl_q3,
	        370: sl_b1,
	        25: sl_c1,
	        199: sl_d1,
	        142: sl_i1,
	        186: sl_j1,
	        611: sl_f1,
	        561: sl_n3,
	        867: sl_n1,
	        889: sl_n1,
	        126: sl_g1,
	        133: sl_p3,
	        87: sl_q3,
	        371: sl_b1,
	        26: sl_c1,
	        200: sl_d1,
	        143: sl_i1,
	        187: sl_j1,
	        612: sl_f1,
	        562: sl_n3,
	        868: sl_n1,
	        890: sl_n1,
	        127: sl_g1,
	        134: sl_p3,
	        88: sl_q3,
	        372: sl_b1,
	        27: sl_c1,
	        201: sl_d1,
	        144: sl_i1,
	        188: sl_j1,
	        613: sl_f1,
	        563: sl_n3,
	        869: sl_n1,
	        891: sl_n1,
	        128: sl_g1,
	        135: sl_p3,
	        89: sl_q3
	    },
	    6: {
	        1861: sl_r3,
	        366: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1,
	        333: sl_s3,
	        557: sl_t3,
	        745: sl_s2,
	        896: sl_u3,
	        618: sl_v3,
	        594: sl_w3,
	        759: sl_x3,
	        750: sl_y3,
	        190: sl_z3,
	        83: sl_f2,
	        300: sl_a4,
	        310: sl_b4,
	        545: sl_c4,
	        508: sl_d4,
	        552: sl_e4,
	        708: sl_f4,
	        76: sl_g4,
	        367: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        139: sl_i1,
	        183: sl_j1,
	        334: sl_s3,
	        558: sl_t3,
	        746: sl_s2,
	        897: sl_u3,
	        619: sl_v3,
	        595: sl_w3,
	        760: sl_x3,
	        751: sl_y3,
	        191: sl_z3,
	        84: sl_f2,
	        301: sl_a4,
	        311: sl_b4,
	        546: sl_c4,
	        509: sl_d4,
	        553: sl_e4,
	        709: sl_f4,
	        77: sl_g4,
	        368: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        140: sl_i1,
	        184: sl_j1,
	        335: sl_s3,
	        559: sl_t3,
	        747: sl_s2,
	        898: sl_u3,
	        620: sl_v3,
	        596: sl_w3,
	        761: sl_x3,
	        752: sl_y3,
	        192: sl_z3,
	        85: sl_f2,
	        302: sl_a4,
	        312: sl_b4,
	        547: sl_c4,
	        510: sl_d4,
	        554: sl_e4,
	        710: sl_f4,
	        78: sl_g4,
	        369: sl_b1,
	        24: sl_c1,
	        198: sl_d1,
	        141: sl_i1,
	        185: sl_j1,
	        336: sl_s3,
	        560: sl_t3,
	        748: sl_s2,
	        899: sl_u3,
	        621: sl_v3,
	        597: sl_w3,
	        762: sl_x3,
	        753: sl_y3,
	        193: sl_z3,
	        86: sl_f2,
	        303: sl_a4,
	        313: sl_b4,
	        548: sl_c4,
	        511: sl_d4,
	        555: sl_e4,
	        711: sl_f4,
	        79: sl_g4,
	        370: sl_b1,
	        25: sl_c1,
	        199: sl_d1,
	        142: sl_i1,
	        186: sl_j1,
	        337: sl_s3,
	        561: sl_t3,
	        749: sl_s2,
	        900: sl_u3,
	        622: sl_v3,
	        598: sl_w3,
	        763: sl_x3,
	        754: sl_y3,
	        194: sl_z3,
	        87: sl_f2,
	        304: sl_a4,
	        314: sl_b4,
	        549: sl_c4,
	        512: sl_d4,
	        556: sl_e4,
	        712: sl_f4,
	        80: sl_g4
	    },
	    4: {
	        366: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1,
	        896: sl_u3,
	        557: sl_e1,
	        836: sl_g2,
	        909: sl_h2,
	        914: sl_n1,
	        920: sl_n1,
	        83: sl_f2,
	        903: sl_l2,
	        607: sl_f1,
	        367: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        139: sl_i1,
	        183: sl_j1,
	        897: sl_u3,
	        558: sl_e1,
	        837: sl_g2,
	        910: sl_h2,
	        915: sl_n1,
	        921: sl_n1,
	        84: sl_f2,
	        904: sl_l2,
	        608: sl_f1,
	        368: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        140: sl_i1,
	        184: sl_j1,
	        898: sl_u3,
	        559: sl_e1,
	        838: sl_g2,
	        911: sl_h2,
	        916: sl_n1,
	        922: sl_n1,
	        85: sl_f2,
	        905: sl_l2,
	        609: sl_f1,
	        369: sl_b1,
	        24: sl_c1,
	        198: sl_d1,
	        141: sl_i1,
	        185: sl_j1,
	        899: sl_u3,
	        560: sl_e1,
	        839: sl_g2,
	        912: sl_h2,
	        917: sl_n1,
	        923: sl_n1,
	        86: sl_f2,
	        906: sl_l2,
	        610: sl_f1,
	        370: sl_b1,
	        25: sl_c1,
	        199: sl_d1,
	        142: sl_i1,
	        186: sl_j1,
	        900: sl_u3,
	        561: sl_e1,
	        840: sl_g2,
	        913: sl_h2,
	        918: sl_n1,
	        924: sl_n1,
	        87: sl_f2,
	        907: sl_l2,
	        611: sl_f1,
	        26: sl_c1,
	        200: sl_m1,
	        143: sl_i1,
	        187: sl_j1,
	        371: sl_x1,
	        562: sl_q1,
	        919: sl_y1,
	        925: sl_y1,
	        901: sl_h4,
	        908: sl_l2,
	        88: sl_i4,
	        362: sl_l1,
	        17: sl_c1,
	        176: sl_m1,
	        358: sl_l1,
	        13: sl_c1,
	        172: sl_m1,
	        363: sl_l1,
	        18: sl_c1,
	        177: sl_m1,
	        359: sl_l1,
	        14: sl_c1,
	        173: sl_m1,
	        364: sl_l1,
	        19: sl_c1,
	        178: sl_m1,
	        360: sl_l1,
	        15: sl_c1,
	        174: sl_m1,
	        365: sl_l1,
	        20: sl_c1,
	        179: sl_m1,
	        361: sl_l1,
	        16: sl_c1,
	        175: sl_m1
	    },
	    8: {
	        664: sl_b1,
	        195: sl_d1,
	        665: sl_b1,
	        196: sl_d1,
	        666: sl_b1,
	        197: sl_d1,
	        667: sl_b1,
	        198: sl_d1
	    }
	};
	
	var baseOutcomeConfig = {
	    11: {
	        74: bo_b1,
	        349: bo_c1,
	        256: bo_d1,
	        306: bo_e1,
	        103: bo_f1,
	        403: bo_g1,
	        443: bo_h1,
	        608: bo_i1
	    },
	    32: {
	        73: bo_b1,
	        318: bo_c1,
	        21: bo_j1,
	        22: bo_k1,
	        23: bo_l1,
	        195: bo_m1,
	        196: bo_n1,
	        197: bo_o1,
	        352: bo_p1,
	        748: bo_q1,
	        102: bo_f1,
	        403: bo_g1,
	        366: bo_r1,
	        367: bo_s1,
	        368: bo_t1,
	        138: bo_u1,
	        139: bo_v1,
	        140: bo_w1,
	        182: bo_x1,
	        183: bo_y1,
	        184: bo_z1,
	        122: bo_a2,
	        123: bo_b2,
	        124: bo_c2,
	        129: bo_d2,
	        130: bo_e2,
	        131: bo_f2,
	        566: bo_g2,
	        567: bo_h2,
	        568: bo_i2,
	        616: bo_j2,
	        617: bo_k2,
	        618: bo_l2,
	        257: bo_d1,
	        307: bo_e1,
	        443: bo_h1,
	        608: bo_i1,
	        362: bo_m2,
	        363: bo_n2,
	        364: bo_o2,
	        17: bo_p2,
	        18: bo_q2,
	        19: bo_r2,
	        176: bo_s2,
	        177: bo_t2,
	        178: bo_u2,
	        358: bo_v2,
	        359: bo_w2,
	        360: bo_x2,
	        13: bo_y2,
	        14: bo_z2,
	        15: bo_a3,
	        172: bo_b3,
	        173: bo_c3,
	        174: bo_d3,
	        256: bo_d1,
	        306: bo_e1
	    },
	    35: {
	        138: bo_e3,
	        256: bo_d1,
	        21: bo_f3,
	        673: bo_g3,
	        182: bo_h3,
	        306: bo_e1,
	        698: bo_g1,
	        731: bo_i3,
	        656: bo_j3,
	        195: bo_k3,
	        74: bo_b1,
	        349: bo_c1,
	        443: bo_h1,
	        608: bo_i1,
	        911: bo_l3,
	        426: bo_m3,
	        535: bo_n3,
	        871: bo_o3,
	        710: bo_p3,
	        742: bo_q3
	    },
	    10: {
	        74: bo_b1,
	        349: bo_c1,
	        256: bo_d1,
	        306: bo_e1,
	        103: bo_f1,
	        403: bo_g1,
	        1: bo_r3,
	        443: bo_h1,
	        608: bo_i1
	    },
	    31: {
	        74: bo_b1,
	        349: bo_c1,
	        21: bo_s3,
	        22: bo_t3,
	        23: bo_u3,
	        24: bo_v3,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_w3,
	        196: bo_x3,
	        197: bo_y3,
	        198: bo_z3,
	        673: bo_a4,
	        674: bo_b4,
	        675: bo_c4,
	        676: bo_d4,
	        103: bo_f1,
	        403: bo_g1,
	        138: bo_e4,
	        139: bo_f4,
	        140: bo_g4,
	        141: bo_h4,
	        182: bo_i4,
	        183: bo_j4,
	        184: bo_k4,
	        185: bo_l4,
	        238: bo_m4,
	        682: bo_n4,
	        239: bo_o4,
	        58: bo_p4,
	        59: bo_q4,
	        681: bo_r4,
	        234: bo_s4,
	        235: bo_t4,
	        236: bo_u4,
	        237: bo_v4,
	        725: bo_w4,
	        726: bo_x4,
	        727: bo_y4,
	        728: bo_z4,
	        782: bo_o3,
	        778: bo_a5,
	        779: bo_b5,
	        780: bo_c5,
	        781: bo_d5,
	        783: bo_e5,
	        773: bo_f5,
	        474: bo_g5,
	        421: bo_h5,
	        530: bo_i5,
	        422: bo_j5,
	        531: bo_k5,
	        444: bo_l5,
	        888: bo_m5,
	        280: bo_n5,
	        317: bo_o5,
	        424: bo_p5,
	        533: bo_q5,
	        423: bo_r5,
	        532: bo_s5,
	        637: bo_t5,
	        788: bo_u5,
	        784: bo_v5,
	        785: bo_w5,
	        786: bo_x5,
	        787: bo_y5,
	        774: bo_v5,
	        775: bo_w5,
	        776: bo_x5,
	        777: bo_y5,
	        281: bo_z5,
	        137: bo_a6,
	        246: bo_b6,
	        248: bo_c6,
	        240: bo_d6,
	        232: bo_e6,
	        241: bo_f6,
	        233: bo_g6,
	        61: bo_h6,
	        62: bo_i6,
	        684: bo_j6,
	        685: bo_k6,
	        443: bo_h1,
	        608: bo_i1,
	        890: bo_l6,
	        242: bo_m6,
	        245: bo_n6,
	        243: bo_o6,
	        60: bo_p6,
	        683: bo_q6,
	        406: bo_r6,
	        405: bo_s6,
	        404: bo_t6,
	        700: bo_u6,
	        408: bo_v6,
	        407: bo_w6,
	        247: bo_x6,
	        244: bo_y6,
	        638: bo_z6,
	        639: bo_a7,
	        640: bo_b7,
	        641: bo_c7,
	        646: bo_d7,
	        642: bo_e7,
	        643: bo_f7,
	        644: bo_g7,
	        645: bo_h7
	    },
	    41: {
	        74: bo_b1,
	        349: bo_c1,
	        21: bo_i7,
	        22: bo_j7,
	        403: bo_g1,
	        673: bo_k7,
	        674: bo_l7,
	        195: bo_m7,
	        196: bo_n7,
	        791: bo_o7,
	        792: bo_n7,
	        637: bo_p7,
	        796: bo_u5,
	        794: bo_q7,
	        795: bo_r7,
	        789: bo_q7,
	        790: bo_r7,
	        725: bo_s7,
	        726: bo_t7,
	        793: bo_u7,
	        411: bo_v7,
	        701: bo_l5,
	        251: bo_w7,
	        252: bo_x7,
	        409: bo_y7,
	        430: bo_z7,
	        410: bo_a8,
	        431: bo_b8,
	        281: bo_z5,
	        137: bo_a6,
	        249: bo_c8,
	        250: bo_d8,
	        63: bo_e8,
	        64: bo_f8,
	        686: bo_g8,
	        687: bo_h8,
	        103: bo_i8,
	        256: bo_d1,
	        306: bo_e1,
	        138: bo_j8,
	        139: bo_k8,
	        182: bo_l8,
	        183: bo_m8,
	        443: bo_h1,
	        608: bo_i1,
	        648: bo_s7,
	        649: bo_t7
	    },
	    18: {
	        74: bo_b1,
	        349: bo_c1,
	        656: bo_j3,
	        698: bo_g1,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_n8,
	        196: bo_o8,
	        197: bo_p8,
	        673: bo_q8,
	        674: bo_r8,
	        675: bo_s8,
	        610: bo_t8,
	        443: bo_h1,
	        608: bo_i1,
	        806: bo_u8,
	        893: bo_v8,
	        707: bo_w8,
	        708: bo_x8,
	        709: bo_y8,
	        889: bo_u7,
	        904: bo_z8,
	        253: bo_a9,
	        688: bo_b9,
	        65: bo_c9,
	        751: bo_q3,
	        21: bo_d9,
	        22: bo_e9,
	        23: bo_f9,
	        743: bo_g9,
	        744: bo_h9,
	        745: bo_i9,
	        615: bo_j9,
	        350: bo_a9
	    },
	    3: {
	        73: bo_b1,
	        318: bo_c1,
	        21: bo_j1,
	        22: bo_k1,
	        23: bo_l1,
	        195: bo_m1,
	        196: bo_n1,
	        197: bo_o1,
	        352: bo_p1,
	        746: bo_q3,
	        102: bo_f1,
	        403: bo_g1,
	        138: bo_u1,
	        139: bo_v1,
	        140: bo_w1,
	        182: bo_x1,
	        183: bo_y1,
	        184: bo_z1,
	        366: bo_r1,
	        367: bo_s1,
	        368: bo_t1,
	        566: bo_g2,
	        567: bo_h2,
	        568: bo_i2,
	        74: bo_k9,
	        854: bo_l9,
	        855: bo_m9,
	        856: bo_n9,
	        857: bo_l9,
	        858: bo_m9,
	        859: bo_n9,
	        797: bo_o9,
	        798: bo_p9,
	        799: bo_q9,
	        851: bo_r9,
	        852: bo_s9,
	        853: bo_t9,
	        83: bo_u9,
	        84: bo_v9,
	        85: bo_w9,
	        905: bo_x9,
	        906: bo_y9,
	        907: bo_z9,
	        443: bo_h1,
	        608: bo_i1,
	        362: bo_a10,
	        363: bo_b10,
	        17: bo_c10,
	        18: bo_d10,
	        176: bo_e10,
	        177: bo_f10,
	        358: bo_g10,
	        359: bo_g10,
	        13: bo_h10,
	        14: bo_i10,
	        172: bo_j10,
	        173: bo_k10,
	        616: bo_l10,
	        617: bo_m10,
	        618: bo_n10,
	        891: bo_l3,
	        257: bo_d1,
	        307: bo_e1,
	        800: bo_o10,
	        801: bo_p10,
	        802: bo_q10
	    },
	    20: {
	        74: bo_b1,
	        349: bo_c1,
	        256: bo_d1,
	        306: bo_e1,
	        698: bo_g1,
	        195: bo_r10,
	        196: bo_s10,
	        197: bo_t10,
	        198: bo_u10,
	        199: bo_v10,
	        200: bo_w10,
	        201: bo_x10,
	        202: bo_y10,
	        138: bo_z10,
	        139: bo_a11,
	        140: bo_b11,
	        141: bo_c11,
	        142: bo_d11,
	        143: bo_e11,
	        144: bo_f11,
	        145: bo_g11,
	        182: bo_h11,
	        183: bo_i11,
	        184: bo_j11,
	        185: bo_k11,
	        186: bo_l11,
	        187: bo_m11,
	        188: bo_n11,
	        189: bo_o11,
	        21: bo_p11,
	        22: bo_q11,
	        23: bo_r11,
	        24: bo_s11,
	        25: bo_t11,
	        26: bo_u11,
	        27: bo_v11,
	        28: bo_w11,
	        673: bo_x11,
	        674: bo_y11,
	        675: bo_z11,
	        676: bo_a12,
	        677: bo_b12,
	        678: bo_c12,
	        679: bo_d12,
	        680: bo_e12,
	        860: bo_f12,
	        861: bo_g12,
	        862: bo_h12,
	        863: bo_i12,
	        864: bo_j12,
	        865: bo_k12,
	        866: bo_l12,
	        867: bo_m12,
	        443: bo_h1,
	        608: bo_i1
	    },
	    5: {
	        349: bo_c1,
	        698: bo_g1,
	        443: bo_h1,
	        608: bo_i1,
	        945: bo_n12,
	        948: bo_o12,
	        949: bo_p12
	    },
	    40: {
	        656: bo_j3,
	        698: bo_g1,
	        443: bo_h1,
	        608: bo_i1
	    },
	    37: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    38: {
	        403: bo_g1,
	        443: bo_h1,
	        608: bo_i1,
	        74: bo_b1,
	        349: bo_q12,
	        615: bo_r12,
	        413: bo_s12,
	        414: bo_t12
	    },
	    42: {
	        403: bo_g1,
	        443: bo_h1,
	        608: bo_i1,
	        74: bo_b1,
	        349: bo_q12,
	        615: bo_u12,
	        413: bo_s12,
	        414: bo_v12,
	        566: bo_w12,
	        567: bo_x12,
	        568: bo_y12,
	        569: bo_z12,
	        570: bo_a13,
	        698: bo_b13,
	        366: bo_c13,
	        367: bo_d13,
	        368: bo_e13,
	        369: bo_f13,
	        370: bo_g13,
	        940: bo_h13,
	        941: bo_i13,
	        942: bo_j13,
	        943: bo_k13,
	        944: bo_l13
	    },
	    26: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    25: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    16: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    12: {
	        74: bo_b1,
	        349: bo_c1,
	        656: bo_j3,
	        698: bo_g1,
	        256: bo_d1,
	        306: bo_e1,
	        103: bo_f1,
	        443: bo_h1,
	        608: bo_i1
	    },
	    36: {
	        610: bo_m13,
	        698: bo_g1,
	        656: bo_j3,
	        74: bo_b1,
	        349: bo_c1,
	        615: bo_j9,
	        256: bo_d1,
	        306: bo_e1,
	        673: bo_q8,
	        21: bo_d9,
	        195: bo_n8,
	        443: bo_h1,
	        608: bo_i1
	    },
	    7: {
	        425: bo_n13,
	        534: bo_o13,
	        540: bo_p13,
	        343: bo_q13,
	        345: bo_r13,
	        260: bo_s13,
	        261: bo_t13,
	        83: bo_u13,
	        84: bo_v13,
	        803: bo_w13,
	        868: bo_x13,
	        869: bo_y13,
	        870: bo_z13,
	        805: bo_a14,
	        892: bo_b14,
	        346: bo_c14,
	        419: bo_d14,
	        528: bo_e14,
	        420: bo_f14,
	        529: bo_g14,
	        707: bo_h14,
	        708: bo_i14,
	        706: bo_j14,
	        804: bo_k14,
	        474: bo_l14,
	        614: bo_m14,
	        609: bo_n14,
	        416: bo_o14,
	        732: bo_p14,
	        525: bo_q14,
	        850: bo_r14,
	        473: bo_s14,
	        442: bo_t14,
	        729: bo_u14,
	        538: bo_v14,
	        542: bo_w14,
	        730: bo_x14,
	        471: bo_y14,
	        635: bo_z14,
	        714: bo_a15,
	        624: bo_b15,
	        625: bo_c15,
	        715: bo_d15,
	        650: bo_e15,
	        651: bo_f15,
	        652: bo_g15,
	        653: bo_h15,
	        654: bo_i15,
	        655: bo_j15,
	        634: bo_k15,
	        626: bo_l15,
	        733: bo_m15,
	        734: bo_n15,
	        258: bo_o15,
	        259: bo_p15,
	        66: bo_q15,
	        67: bo_r15,
	        81: bo_s15,
	        68: bo_t15,
	        689: bo_u15,
	        690: bo_v15,
	        699: bo_w15,
	        691: bo_x15,
	        723: bo_y15,
	        633: bo_z15,
	        74: bo_b1,
	        349: bo_c1,
	        656: bo_j3,
	        698: bo_g1,
	        322: bo_a16,
	        904: bo_b16,
	        1: bo_r3,
	        136: bo_c16,
	        747: bo_q3,
	        871: bo_o3,
	        255: bo_d16,
	        705: bo_e16,
	        323: bo_f16,
	        324: bo_g16,
	        702: bo_h16,
	        278: bo_i16,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_k3,
	        196: bo_j16,
	        21: bo_f3,
	        22: bo_k16,
	        282: bo_l16,
	        911: bo_l3,
	        353: bo_m16,
	        673: bo_g3,
	        674: bo_n16,
	        2: bo_o16,
	        5: bo_p16,
	        7: bo_q16,
	        939: bo_r16,
	        9: bo_s16,
	        12: bo_t16,
	        417: bo_u16,
	        526: bo_v16,
	        325: bo_w16,
	        103: bo_f1,
	        160: bo_x16,
	        163: bo_y16,
	        165: bo_z16,
	        166: bo_a17,
	        168: bo_b17,
	        171: bo_c17,
	        148: bo_d17,
	        149: bo_e17,
	        150: bo_f17,
	        151: bo_g17,
	        152: bo_h17,
	        153: bo_i17,
	        154: bo_j17,
	        155: bo_k17,
	        156: bo_l17,
	        157: bo_m17,
	        158: bo_n17,
	        159: bo_o17,
	        731: bo_i3,
	        765: bo_p17,
	        766: bo_q17,
	        415: bo_r17,
	        524: bo_s17,
	        418: bo_t17,
	        527: bo_u17,
	        743: bo_v17,
	        744: bo_w17,
	        710: bo_p3,
	        321: bo_x17,
	        326: bo_y17,
	        327: bo_z17,
	        724: bo_a18,
	        661: bo_b18,
	        664: bo_c18,
	        666: bo_d18,
	        667: bo_e18,
	        669: bo_f18,
	        672: bo_g18,
	        426: bo_m3,
	        535: bo_n3,
	        537: bo_h18,
	        541: bo_i18,
	        539: bo_j18,
	        138: bo_e3,
	        139: bo_k18,
	        182: bo_h3,
	        183: bo_l18,
	        437: bo_m18,
	        436: bo_n18,
	        694: bo_o18,
	        71: bo_p18,
	        271: bo_c1,
	        268: bo_q18,
	        265: bo_r18,
	        267: bo_s18,
	        270: bo_t18,
	        272: bo_u18,
	        269: bo_v18,
	        266: bo_w18,
	        264: bo_x18,
	        281: bo_z5,
	        137: bo_a6,
	        660: bo_y18,
	        880: bo_z18,
	        879: bo_a19,
	        429: bo_b19,
	        433: bo_c19,
	        443: bo_h1,
	        608: bo_i1,
	        881: bo_d19,
	        273: bo_e19,
	        274: bo_f19,
	        435: bo_g19,
	        704: bo_h19,
	        432: bo_i19,
	        428: bo_j19,
	        434: bo_k19,
	        439: bo_l19,
	        440: bo_m19,
	        441: bo_n19,
	        438: bo_o19,
	        623: bo_p19,
	        180: bo_q19,
	        146: bo_r19,
	        659: bo_s19,
	        749: bo_t19,
	        69: bo_u19,
	        262: bo_v19,
	        692: bo_w19,
	        703: bo_x19,
	        70: bo_y19,
	        263: bo_z19,
	        693: bo_a20,
	        72: bo_b20,
	        277: bo_c20,
	        695: bo_d20,
	        750: bo_e20,
	        181: bo_f20,
	        147: bo_g20,
	        276: bo_h20,
	        275: bo_i20,
	        735: bo_j20,
	        736: bo_k20,
	        737: bo_l20,
	        738: bo_m20,
	        739: bo_n20,
	        740: bo_o20,
	        356: bo_p20,
	        357: bo_q20,
	        354: bo_r20,
	        355: bo_s20,
	        937: bo_t20,
	        657: bo_u20,
	        658: bo_v20,
	        412: bo_w20
	    },
	    14: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    34: {
	        425: bo_n13,
	        534: bo_o13,
	        540: bo_p13,
	        343: bo_q13,
	        345: bo_r13,
	        260: bo_s13,
	        261: bo_t13,
	        83: bo_u13,
	        84: bo_v13,
	        803: bo_w13,
	        868: bo_x13,
	        869: bo_y13,
	        870: bo_z13,
	        346: bo_c14,
	        419: bo_d14,
	        528: bo_e14,
	        420: bo_f14,
	        529: bo_g14,
	        707: bo_h14,
	        708: bo_i14,
	        706: bo_j14,
	        538: bo_v14,
	        74: bo_b1,
	        349: bo_c1,
	        656: bo_j3,
	        698: bo_g1,
	        322: bo_a16,
	        904: bo_b16,
	        1: bo_r3,
	        136: bo_c16,
	        747: bo_q3,
	        871: bo_o3,
	        255: bo_d16,
	        705: bo_e16,
	        323: bo_f16,
	        324: bo_g16,
	        702: bo_h16,
	        278: bo_i16,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_k3,
	        196: bo_j16,
	        21: bo_f3,
	        22: bo_k16,
	        282: bo_l16,
	        911: bo_l3,
	        353: bo_m16,
	        673: bo_g3,
	        674: bo_n16,
	        2: bo_o16,
	        5: bo_p16,
	        7: bo_q16,
	        939: bo_r16,
	        9: bo_s16,
	        12: bo_t16,
	        417: bo_u16,
	        526: bo_v16,
	        325: bo_w16,
	        103: bo_f1,
	        160: bo_x16,
	        163: bo_y16,
	        165: bo_z16,
	        166: bo_a17,
	        168: bo_b17,
	        171: bo_c17,
	        148: bo_d17,
	        149: bo_e17,
	        150: bo_f17,
	        151: bo_g17,
	        152: bo_h17,
	        153: bo_i17,
	        154: bo_j17,
	        155: bo_k17,
	        156: bo_l17,
	        157: bo_m17,
	        158: bo_n17,
	        159: bo_o17,
	        731: bo_i3,
	        765: bo_p17,
	        766: bo_q17,
	        415: bo_r17,
	        524: bo_s17,
	        418: bo_t17,
	        527: bo_u17,
	        743: bo_v17,
	        744: bo_w17,
	        710: bo_p3,
	        321: bo_x17,
	        326: bo_y17,
	        327: bo_z17,
	        724: bo_a18,
	        661: bo_b18,
	        664: bo_c18,
	        666: bo_d18,
	        667: bo_e18,
	        669: bo_f18,
	        672: bo_g18,
	        426: bo_m3,
	        535: bo_n3,
	        537: bo_h18,
	        541: bo_i18,
	        539: bo_j18,
	        138: bo_e3,
	        139: bo_k18,
	        182: bo_h3,
	        183: bo_l18,
	        443: bo_h1,
	        608: bo_i1
	    },
	    19: {
	        74: bo_b1,
	        349: bo_c1,
	        698: bo_g1,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_k3,
	        196: bo_j16,
	        103: bo_f1,
	        615: bo_j9,
	        886: bo_p17,
	        887: bo_q17,
	        911: bo_l3,
	        884: bo_x20,
	        885: bo_y20,
	        882: bo_z20,
	        883: bo_a21,
	        723: bo_y15,
	        673: bo_g3,
	        674: bo_n16,
	        21: bo_f3,
	        22: bo_k16,
	        138: bo_e3,
	        182: bo_h3,
	        443: bo_h1,
	        608: bo_i1
	    },
	    30: {
	        74: bo_b1,
	        349: bo_c1,
	        656: bo_j3,
	        698: bo_g1,
	        21: bo_d9,
	        22: bo_e9,
	        23: bo_f9,
	        279: bo_b21,
	        610: bo_t8,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_c21,
	        196: bo_d21,
	        197: bo_e21,
	        673: bo_q8,
	        674: bo_r8,
	        675: bo_s8,
	        350: bo_a9,
	        103: bo_f1,
	        415: bo_r17,
	        524: bo_s17,
	        743: bo_f21,
	        744: bo_g21,
	        745: bo_h21,
	        710: bo_p3,
	        403: bo_g1,
	        426: bo_m3,
	        535: bo_n3,
	        706: bo_j14,
	        343: bo_q13,
	        346: bo_c14,
	        83: bo_i21,
	        84: bo_j21,
	        85: bo_k21,
	        344: bo_l21,
	        347: bo_m21,
	        765: bo_n21,
	        766: bo_o21,
	        767: bo_p21,
	        138: bo_q21,
	        139: bo_r21,
	        140: bo_s21,
	        182: bo_t21,
	        183: bo_u21,
	        184: bo_v21,
	        751: bo_q3,
	        911: bo_l3,
	        889: bo_o3,
	        637: bo_t5,
	        615: bo_j9,
	        412: bo_w21,
	        634: bo_k15,
	        626: bo_l15,
	        611: bo_x21,
	        443: bo_h1,
	        608: bo_i1,
	        904: bo_y21,
	        449: bo_z21,
	        446: bo_a22,
	        451: bo_b22,
	        711: bo_c22,
	        712: bo_d22,
	        713: bo_e22,
	        450: bo_f22,
	        447: bo_g22,
	        448: bo_h22,
	        662: bo_i22,
	        663: bo_j22,
	        665: bo_k22,
	        668: bo_l22,
	        670: bo_m22,
	        671: bo_n22,
	        3: bo_o22,
	        4: bo_p22,
	        6: bo_q22,
	        8: bo_r22,
	        10: bo_s22,
	        11: bo_t22,
	        161: bo_u22,
	        162: bo_v22,
	        164: bo_w22,
	        167: bo_x22,
	        169: bo_y22,
	        170: bo_z22,
	        707: bo_a23,
	        708: bo_b23,
	        709: bo_c23,
	        946: bo_d23,
	        947: bo_e23
	    },
	    23: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    13: {
	        468: bo_f23,
	        470: bo_g23,
	        467: bo_h23,
	        469: bo_i23,
	        464: bo_j23,
	        466: bo_k23,
	        465: bo_l23,
	        463: bo_m23,
	        289: bo_n23,
	        288: bo_o23,
	        292: bo_p23,
	        461: bo_q23,
	        283: bo_r23,
	        295: bo_s23,
	        293: bo_t23,
	        284: bo_u23,
	        285: bo_v23,
	        316: bo_w23,
	        286: bo_x23,
	        287: bo_y23,
	        290: bo_z23,
	        291: bo_a24,
	        462: bo_b24,
	        294: bo_c24
	    },
	    39: {
	        403: bo_g1,
	        443: bo_h1,
	        608: bo_i1,
	        698: bo_g1,
	        349: bo_c1,
	        950: bo_d24,
	        955: bo_e24,
	        951: bo_f24,
	        952: bo_g24,
	        953: bo_h24,
	        954: bo_i24
	    },
	    33: {
	        348: bo_j24,
	        443: bo_h1,
	        608: bo_i1
	    },
	    24: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    9: {
	        74: bo_b1,
	        349: bo_c1,
	        656: bo_j3,
	        698: bo_g1,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_k3,
	        196: bo_j16,
	        673: bo_g3,
	        674: bo_n16,
	        443: bo_h1,
	        608: bo_i1
	    },
	    21: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    29: {
	        394: bo_k24,
	        395: bo_l24,
	        396: bo_m24,
	        397: bo_n24,
	        398: bo_o24,
	        399: bo_p24,
	        400: bo_q24,
	        401: bo_r24,
	        402: bo_s24,
	        100: bo_t24,
	        101: bo_u24,
	        104: bo_v24,
	        105: bo_w24,
	        106: bo_x24,
	        107: bo_y24,
	        108: bo_z24,
	        109: bo_a25,
	        110: bo_b25,
	        111: bo_c25,
	        112: bo_d25,
	        113: bo_e25,
	        114: bo_f25,
	        115: bo_g25,
	        116: bo_h25,
	        117: bo_i25,
	        118: bo_j25,
	        119: bo_k25,
	        120: bo_l25,
	        121: bo_m25,
	        808: bo_n25,
	        809: bo_o25,
	        810: bo_p25,
	        811: bo_q25,
	        812: bo_r25,
	        813: bo_s25,
	        814: bo_t25,
	        815: bo_u25,
	        816: bo_v25,
	        817: bo_w25,
	        818: bo_x25,
	        819: bo_y25,
	        820: bo_z25,
	        821: bo_a26,
	        822: bo_b26,
	        823: bo_c26,
	        824: bo_d26,
	        825: bo_e26,
	        826: bo_f26,
	        827: bo_g26,
	        828: bo_h26,
	        829: bo_i26,
	        830: bo_j26,
	        831: bo_k26,
	        832: bo_l26,
	        833: bo_m26,
	        834: bo_n26,
	        835: bo_o26,
	        836: bo_p26,
	        837: bo_q26,
	        838: bo_r26,
	        839: bo_s26,
	        840: bo_t26,
	        841: bo_u26,
	        842: bo_v26,
	        843: bo_w26,
	        844: bo_x26,
	        366: bo_y26,
	        367: bo_z26,
	        368: bo_a27,
	        369: bo_b27,
	        370: bo_c27,
	        371: bo_d27,
	        372: bo_e27,
	        373: bo_f27,
	        374: bo_g27,
	        375: bo_h27,
	        376: bo_i27,
	        377: bo_j27,
	        378: bo_k27,
	        379: bo_l27,
	        380: bo_m27,
	        381: bo_n27,
	        382: bo_o27,
	        383: bo_p27,
	        384: bo_q27,
	        385: bo_r27,
	        386: bo_s27,
	        387: bo_t27,
	        388: bo_u27,
	        389: bo_v27,
	        390: bo_w27,
	        391: bo_x27,
	        392: bo_y27,
	        393: bo_z27,
	        481: bo_a28,
	        482: bo_b28,
	        483: bo_c28,
	        484: bo_d28,
	        485: bo_e28,
	        486: bo_f28,
	        487: bo_g28,
	        488: bo_h28,
	        489: bo_i28,
	        490: bo_j28,
	        491: bo_k28,
	        492: bo_l28,
	        493: bo_m28,
	        494: bo_n28,
	        495: bo_o28,
	        496: bo_p28,
	        497: bo_q28,
	        498: bo_r28,
	        499: bo_s28,
	        500: bo_t28,
	        501: bo_u28,
	        502: bo_v28,
	        503: bo_w28,
	        504: bo_x28,
	        505: bo_y28,
	        506: bo_z28,
	        507: bo_a29,
	        508: bo_b29,
	        509: bo_c29,
	        510: bo_d29,
	        511: bo_e29,
	        566: bo_f29,
	        567: bo_g29,
	        568: bo_h29,
	        569: bo_i29,
	        570: bo_j29,
	        571: bo_k29,
	        572: bo_l29,
	        573: bo_m29,
	        574: bo_n29,
	        575: bo_o29,
	        576: bo_p29,
	        577: bo_q29,
	        578: bo_r29,
	        579: bo_s29,
	        580: bo_t29,
	        581: bo_u29,
	        582: bo_v29,
	        583: bo_w29,
	        584: bo_x29,
	        585: bo_y29,
	        586: bo_z29,
	        587: bo_a30,
	        588: bo_b30,
	        589: bo_c30,
	        590: bo_d30,
	        591: bo_e30,
	        592: bo_f30,
	        593: bo_g30,
	        594: bo_h30,
	        595: bo_i30,
	        596: bo_j30,
	        597: bo_k30,
	        598: bo_l30,
	        599: bo_m30,
	        600: bo_n30,
	        601: bo_o30,
	        602: bo_p30,
	        83: bo_q30,
	        84: bo_r30,
	        85: bo_s30,
	        86: bo_t30,
	        87: bo_u30,
	        88: bo_v30,
	        89: bo_w30,
	        90: bo_x30,
	        91: bo_y30,
	        92: bo_z30,
	        93: bo_a31,
	        94: bo_b31,
	        95: bo_c31,
	        96: bo_d31,
	        97: bo_e31,
	        98: bo_f31,
	        99: bo_g31,
	        74: bo_b1,
	        349: bo_c1,
	        254: bo_h31,
	        403: bo_g1,
	        21: bo_i31,
	        22: bo_j31,
	        23: bo_k31,
	        24: bo_l31,
	        25: bo_m31,
	        26: bo_n31,
	        27: bo_o31,
	        28: bo_p31,
	        29: bo_q31,
	        30: bo_r31,
	        31: bo_s31,
	        32: bo_t31,
	        33: bo_u31,
	        34: bo_v31,
	        35: bo_w31,
	        36: bo_x31,
	        37: bo_y31,
	        38: bo_z31,
	        39: bo_a32,
	        40: bo_b32,
	        41: bo_c32,
	        42: bo_d32,
	        43: bo_e32,
	        44: bo_f32,
	        45: bo_g32,
	        46: bo_h32,
	        47: bo_i32,
	        48: bo_j32,
	        49: bo_k32,
	        50: bo_l32,
	        51: bo_m32,
	        52: bo_n32,
	        53: bo_o32,
	        54: bo_p32,
	        55: bo_q32,
	        56: bo_r32,
	        57: bo_s32,
	        195: bo_t32,
	        196: bo_u32,
	        197: bo_v32,
	        198: bo_w32,
	        199: bo_x32,
	        200: bo_y32,
	        201: bo_z32,
	        202: bo_a33,
	        203: bo_b33,
	        204: bo_c33,
	        205: bo_d33,
	        206: bo_e33,
	        207: bo_f33,
	        208: bo_g33,
	        209: bo_h33,
	        210: bo_i33,
	        211: bo_j33,
	        212: bo_k33,
	        213: bo_l33,
	        214: bo_m33,
	        215: bo_n33,
	        216: bo_o33,
	        217: bo_p33,
	        218: bo_q33,
	        219: bo_r33,
	        220: bo_s33,
	        221: bo_t33,
	        222: bo_u33,
	        223: bo_v33,
	        224: bo_w33,
	        225: bo_x33,
	        226: bo_y33,
	        227: bo_z33,
	        228: bo_a34,
	        229: bo_b34,
	        230: bo_c34,
	        231: bo_d34,
	        475: bo_e34,
	        476: bo_f34,
	        477: bo_g34,
	        478: bo_h34,
	        479: bo_i34,
	        480: bo_j34,
	        443: bo_h1,
	        608: bo_i1
	    },
	    15: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    2: {
	        73: bo_b1,
	        318: bo_c1,
	        21: bo_i31,
	        22: bo_j31,
	        23: bo_k31,
	        24: bo_l31,
	        25: bo_m31,
	        26: bo_n31,
	        27: bo_o31,
	        195: bo_t32,
	        196: bo_u32,
	        197: bo_v32,
	        198: bo_w32,
	        199: bo_x32,
	        200: bo_y32,
	        201: bo_z32,
	        352: bo_k34,
	        102: bo_f1,
	        403: bo_g1,
	        138: bo_l34,
	        139: bo_m34,
	        140: bo_n34,
	        141: bo_o34,
	        142: bo_p34,
	        143: bo_q34,
	        144: bo_r34,
	        182: bo_s34,
	        183: bo_t34,
	        184: bo_u34,
	        185: bo_v34,
	        186: bo_w34,
	        187: bo_x34,
	        188: bo_y34,
	        566: bo_f29,
	        567: bo_g29,
	        568: bo_h29,
	        569: bo_i29,
	        570: bo_j29,
	        571: bo_k29,
	        572: bo_l29,
	        366: bo_y26,
	        367: bo_z26,
	        368: bo_a27,
	        369: bo_b27,
	        370: bo_c27,
	        371: bo_d27,
	        372: bo_e27,
	        122: bo_z34,
	        123: bo_a35,
	        124: bo_b35,
	        125: bo_c35,
	        126: bo_d35,
	        127: bo_e35,
	        128: bo_f35,
	        129: bo_g35,
	        130: bo_h35,
	        131: bo_i35,
	        132: bo_j35,
	        133: bo_k35,
	        134: bo_l35,
	        135: bo_m35,
	        872: bo_n35,
	        873: bo_o35,
	        874: bo_p35,
	        875: bo_q35,
	        876: bo_r35,
	        877: bo_s35,
	        878: bo_t35,
	        616: bo_u35,
	        617: bo_v35,
	        618: bo_w35,
	        619: bo_x35,
	        620: bo_y35,
	        621: bo_z35,
	        622: bo_a36,
	        894: bo_n35,
	        895: bo_o35,
	        896: bo_p35,
	        897: bo_q35,
	        898: bo_r35,
	        899: bo_s35,
	        900: bo_t35,
	        443: bo_h1,
	        608: bo_i1,
	        83: bo_b36,
	        84: bo_c36,
	        85: bo_d36,
	        86: bo_e36,
	        87: bo_f36,
	        88: bo_g36,
	        89: bo_h36,
	        257: bo_d1,
	        307: bo_e1,
	        752: bo_i36,
	        753: bo_i36
	    },
	    6: {
	        553: bo_j36,
	        339: bo_k36,
	        547: bo_l36,
	        138: bo_u1,
	        139: bo_v1,
	        140: bo_w1,
	        141: bo_m36,
	        142: bo_n36,
	        182: bo_x1,
	        183: bo_y1,
	        184: bo_z1,
	        185: bo_o36,
	        186: bo_p36,
	        83: bo_u9,
	        84: bo_v9,
	        85: bo_w9,
	        86: bo_q36,
	        87: bo_r36,
	        807: bo_s36,
	        636: bo_t36,
	        334: bo_u36,
	        335: bo_v36,
	        336: bo_w36,
	        337: bo_x36,
	        906: bo_y9,
	        907: bo_z9,
	        908: bo_y36,
	        909: bo_z36,
	        300: bo_a37,
	        301: bo_b37,
	        302: bo_c37,
	        303: bo_d37,
	        304: bo_e37,
	        310: bo_f37,
	        311: bo_g37,
	        312: bo_h37,
	        313: bo_i37,
	        314: bo_j37,
	        554: bo_k37,
	        555: bo_l37,
	        556: bo_m37,
	        557: bo_n37,
	        558: bo_o37,
	        517: bo_p37,
	        518: bo_q37,
	        519: bo_r37,
	        520: bo_s37,
	        521: bo_t37,
	        561: bo_u37,
	        562: bo_v37,
	        563: bo_w37,
	        564: bo_x37,
	        565: bo_y37,
	        73: bo_b1,
	        318: bo_c1,
	        21: bo_j1,
	        22: bo_k1,
	        23: bo_l1,
	        24: bo_z37,
	        25: bo_a38,
	        195: bo_m1,
	        196: bo_n1,
	        197: bo_o1,
	        198: bo_b38,
	        199: bo_c38,
	        352: bo_p1,
	        748: bo_q1,
	        102: bo_f1,
	        403: bo_g1,
	        903: bo_d38,
	        445: bo_e38,
	        754: bo_f38,
	        755: bo_g38,
	        756: bo_h38,
	        757: bo_i38,
	        758: bo_j38,
	        452: bo_k38,
	        453: bo_l38,
	        454: bo_m38,
	        566: bo_n38,
	        567: bo_o38,
	        568: bo_p38,
	        569: bo_q38,
	        570: bo_r38,
	        366: bo_r1,
	        367: bo_s1,
	        368: bo_t1,
	        369: bo_s38,
	        370: bo_t38,
	        522: bo_u38,
	        627: bo_v38,
	        628: bo_w38,
	        629: bo_x38,
	        630: bo_y38,
	        631: bo_z38,
	        632: bo_a39,
	        190: bo_b39,
	        191: bo_c39,
	        192: bo_d39,
	        193: bo_e39,
	        194: bo_f39,
	        759: bo_g39,
	        760: bo_h39,
	        761: bo_i39,
	        762: bo_j39,
	        763: bo_k39,
	        768: bo_l39,
	        769: bo_m39,
	        770: bo_n39,
	        771: bo_o39,
	        772: bo_p39,
	        603: bo_q39,
	        604: bo_r39,
	        605: bo_s39,
	        606: bo_t39,
	        607: bo_u39,
	        257: bo_d1,
	        307: bo_e1,
	        696: bo_g1,
	        333: bo_v39,
	        341: bo_w39,
	        427: bo_x39,
	        536: bo_y39,
	        905: bo_x9,
	        320: bo_z39,
	        514: bo_a40,
	        516: bo_b40,
	        305: bo_c40,
	        315: bo_d40,
	        523: bo_e40,
	        299: bo_f40,
	        309: bo_g40,
	        697: bo_h40,
	        298: bo_i40,
	        308: bo_j40,
	        515: bo_k40,
	        549: bo_l40,
	        548: bo_m40,
	        443: bo_h1,
	        608: bo_i1,
	        550: bo_n40,
	        551: bo_n40,
	        455: bo_o40,
	        456: bo_o40,
	        457: bo_p40,
	        458: bo_p40,
	        459: bo_q40,
	        460: bo_q40,
	        512: bo_r40,
	        513: bo_s40,
	        901: bo_d38,
	        902: bo_d38,
	        340: bo_t40,
	        328: bo_u40,
	        329: bo_v40,
	        342: bo_w40,
	        330: bo_x40,
	        331: bo_y40,
	        722: bo_z40,
	        560: bo_a41,
	        543: bo_b41,
	        544: bo_c41,
	        545: bo_d41,
	        546: bo_e41,
	        332: bo_f41,
	        559: bo_g41,
	        296: bo_h41,
	        297: bo_i41,
	        717: bo_j41,
	        718: bo_k41,
	        719: bo_l41,
	        720: bo_m41,
	        721: bo_n41,
	        552: bo_o41,
	        76: bo_p41,
	        77: bo_q41,
	        78: bo_r41,
	        79: bo_s41,
	        80: bo_t41,
	        647: bo_u41,
	        741: bo_v41,
	        82: bo_w41,
	        338: bo_x41
	    },
	    17: {
	        348: bo_j24,
	        443: bo_h1,
	        608: bo_i1
	    },
	    4: {
	        73: bo_b1,
	        318: bo_c1,
	        21: bo_j1,
	        22: bo_k1,
	        23: bo_l1,
	        24: bo_z37,
	        25: bo_a38,
	        195: bo_m1,
	        196: bo_n1,
	        197: bo_o1,
	        198: bo_b38,
	        199: bo_c38,
	        352: bo_p1,
	        764: bo_q3,
	        102: bo_f1,
	        403: bo_g1,
	        138: bo_u1,
	        139: bo_v1,
	        140: bo_w1,
	        141: bo_m36,
	        142: bo_n36,
	        182: bo_x1,
	        183: bo_y1,
	        184: bo_z1,
	        185: bo_o36,
	        186: bo_p36,
	        366: bo_r1,
	        367: bo_s1,
	        368: bo_t1,
	        369: bo_s38,
	        370: bo_t38,
	        566: bo_g2,
	        567: bo_h2,
	        568: bo_i2,
	        569: bo_y41,
	        570: bo_z41,
	        74: bo_k9,
	        923: bo_l9,
	        924: bo_m9,
	        925: bo_n9,
	        926: bo_a42,
	        927: bo_b42,
	        929: bo_l9,
	        930: bo_m9,
	        931: bo_n9,
	        932: bo_a42,
	        933: bo_b42,
	        845: bo_o9,
	        846: bo_p9,
	        847: bo_q9,
	        848: bo_c42,
	        849: bo_d42,
	        918: bo_r9,
	        919: bo_s9,
	        920: bo_t9,
	        921: bo_e42,
	        922: bo_f42,
	        83: bo_u9,
	        84: bo_v9,
	        85: bo_w9,
	        86: bo_q36,
	        87: bo_r36,
	        905: bo_x9,
	        906: bo_y9,
	        907: bo_z9,
	        908: bo_y36,
	        909: bo_z36,
	        807: bo_s36,
	        319: bo_g42,
	        320: bo_z39,
	        912: bo_o10,
	        913: bo_p10,
	        914: bo_q10,
	        915: bo_h42,
	        916: bo_i42,
	        443: bo_h1,
	        608: bo_i1,
	        257: bo_d1,
	        307: bo_e1,
	        362: bo_j42,
	        363: bo_k42,
	        364: bo_l42,
	        365: bo_m42,
	        17: bo_n42,
	        18: bo_o42,
	        19: bo_p42,
	        20: bo_q42,
	        176: bo_r42,
	        177: bo_s42,
	        178: bo_t42,
	        179: bo_u42,
	        358: bo_v42,
	        359: bo_w42,
	        360: bo_x42,
	        361: bo_y42,
	        13: bo_z42,
	        14: bo_a43,
	        15: bo_b43,
	        16: bo_c43,
	        172: bo_d43,
	        173: bo_e43,
	        174: bo_f43,
	        175: bo_g43,
	        281: bo_z5,
	        137: bo_a6,
	        616: bo_j2,
	        617: bo_k2,
	        618: bo_l2,
	        619: bo_h43,
	        620: bo_i43,
	        891: bo_l3,
	        26: bo_j43,
	        200: bo_k43,
	        143: bo_l43,
	        187: bo_m43,
	        371: bo_n43,
	        571: bo_o43,
	        928: bo_p43,
	        934: bo_p43,
	        88: bo_q43,
	        910: bo_r43,
	        917: bo_s43,
	        936: bo_t43
	    },
	    8: {
	        74: bo_b1,
	        349: bo_c1,
	        656: bo_j3,
	        698: bo_g1,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_w3,
	        196: bo_x3,
	        197: bo_y3,
	        198: bo_z3,
	        673: bo_a4,
	        674: bo_b4,
	        675: bo_c4,
	        676: bo_d4,
	        103: bo_f1,
	        443: bo_h1,
	        608: bo_i1
	    },
	    27: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    28: {
	        403: bo_g1,
	        615: bo_u43,
	        74: bo_b1,
	        349: bo_c1,
	        256: bo_d1,
	        306: bo_e1,
	        103: bo_f1,
	        935: bo_q3,
	        612: bo_v43,
	        613: bo_w43,
	        443: bo_h1,
	        608: bo_i1
	    }
	};
	
	var outcomeConfig = {
	    7: {
	        426: function _(match, outcome) {
	            return match.homeTeam + " \u0434\u04D9\u043B " + outcome.condition + " \u0433\u043E\u043B \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u0493\u044B\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	        },
	        535: function _(match, outcome) {
	            return match.awayTeam + " \u0434\u04D9\u043B " + outcome.condition + " \u0433\u043E\u043B \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u0493\u044B\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456";
	        }
	    },
	    6: {
	        455: function _(match, outcome) {
	            return outcome.condition + " \u0433\u0435\u0439\u043C\u0434\u0435 15x15 \u0431\u043E\u043B\u0430\u0434\u044B \u043C\u0430?";
	        },
	        456: function _(match, outcome) {
	            return outcome.condition + " \u0433\u0435\u0439\u043C\u0434\u0435 15x15 \u0431\u043E\u043B\u0430\u0434\u044B \u043C\u0430?";
	        },
	        457: function _(match, outcome) {
	            return outcome.condition + " \u0433\u0435\u0439\u043C\u0434\u0435 30x30 \u0431\u043E\u043B\u0430\u0434\u044B \u043C\u0430?";
	        },
	        458: function _(match, outcome) {
	            return outcome.condition + " \u0433\u0435\u0439\u043C\u0434\u0435 30x30 \u0431\u043E\u043B\u0430\u0434\u044B \u043C\u0430?";
	        },
	        459: function _(match, outcome) {
	            return outcome.condition + " \u0433\u0435\u0439\u043C\u0434\u0435 40x40 \u0431\u043E\u043B\u0430\u0434\u044B \u043C\u0430?";
	        },
	        460: function _(match, outcome) {
	            return outcome.condition + " \u0433\u0435\u0439\u043C\u0434\u0435 40x40 \u0431\u043E\u043B\u0430\u0434\u044B \u043C\u0430?";
	        }
	    }
	};
	
	var baseFactorNameConfig = {
	    11: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        103: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        403: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    },
	    32: {
	        73: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        318: {
	            1: fa_d1,
	            2: fa_p1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        352: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        748: {
	            1: fa_q1,
	            2: fa_r1,
	            3: fa_s1,
	            4: fa_t1,
	            5: fa_u1,
	            6: fa_v1,
	            7: fa_w1,
	            8: fa_x1,
	            9: fa_y1,
	            10: fa_z1
	        },
	        102: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        403: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        366: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        367: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        368: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_p1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        122: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        123: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        124: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        129: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        130: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        131: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        566: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        567: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        568: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        616: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        617: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        618: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        257: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        307: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        362: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        363: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        364: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        17: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        18: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        19: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        176: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        177: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        178: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        358: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        359: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        360: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        13: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        14: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        15: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        172: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        173: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        174: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        }
	    },
	    35: {
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        673: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        698: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        731: {
	            1: fa_a2,
	            2: fa_d2,
	            3: fa_b2
	        },
	        656: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        911: {
	            1: fa_h2,
	            2: fa_i2,
	            3: fa_j2,
	            4: fa_k2,
	            5: fa_l2,
	            6: fa_m2
	        },
	        426: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        535: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        871: {
	            1: fa_n2,
	            2: fa_o2,
	            3: fa_p2,
	            4: fa_q2,
	            5: fa_r2,
	            6: fa_s2
	        },
	        710: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_v2
	        },
	        742: {
	            1: fa_w2,
	            2: fa_x2,
	            3: fa_q1,
	            4: fa_r1,
	            5: fa_y2,
	            6: fa_z2,
	            7: fa_a3,
	            8: fa_b3,
	            9: fa_s1,
	            10: fa_t1,
	            11: fa_c3,
	            12: fa_d3,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_e3,
	            16: fa_w1,
	            17: fa_f3,
	            18: fa_g3,
	            19: fa_h3,
	            20: fa_x1,
	            21: fa_y1,
	            22: fa_z1,
	            23: fa_i3,
	            24: fa_j3,
	            25: fa_k3,
	            26: fa_l3,
	            27: fa_m3,
	            28: fa_n3,
	            29: fa_o3,
	            30: fa_p3,
	            31: fa_q3,
	            32: fa_r3,
	            33: fa_s3,
	            34: fa_t3,
	            35: fa_u3
	        }
	    },
	    10: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        403: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        1: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    },
	    31: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        24: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        674: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        675: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        676: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        103: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        403: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        141: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        185: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        238: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        682: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        239: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        58: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        59: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        681: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        234: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        235: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        236: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        237: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        725: {
	            1: fa_a2,
	            2: fa_d2,
	            3: fa_b2
	        },
	        726: {
	            1: fa_a2,
	            2: fa_d2,
	            3: fa_b2
	        },
	        727: {
	            1: fa_a2,
	            2: fa_d2,
	            3: fa_b2
	        },
	        728: {
	            1: fa_a2,
	            2: fa_d2,
	            3: fa_b2
	        },
	        782: {
	            1: fa_v3,
	            2: fa_w3,
	            3: fa_x3,
	            4: fa_y3,
	            5: fa_z3,
	            6: fa_a4
	        },
	        778: {
	            1: fa_v3,
	            2: fa_w3,
	            3: fa_x3,
	            4: fa_y3,
	            5: fa_z3,
	            6: fa_a4
	        },
	        779: {
	            1: fa_v3,
	            2: fa_w3,
	            3: fa_x3,
	            4: fa_y3,
	            5: fa_z3,
	            6: fa_a4
	        },
	        780: {
	            1: fa_v3,
	            2: fa_w3,
	            3: fa_x3,
	            4: fa_y3,
	            5: fa_z3,
	            6: fa_a4
	        },
	        781: {
	            1: fa_v3,
	            2: fa_w3,
	            3: fa_x3,
	            4: fa_y3,
	            5: fa_z3,
	            6: fa_a4
	        },
	        783: {
	            1: fa_s1,
	            2: fa_k3,
	            3: fa_b4,
	            4: fa_c4,
	            5: fa_d4,
	            6: fa_e4,
	            7: fa_f4,
	            8: fa_k1
	        },
	        773: {
	            1: fa_s1,
	            2: fa_k3,
	            3: fa_b4,
	            4: fa_c4,
	            5: fa_d4,
	            6: fa_e4,
	            7: fa_f4,
	            8: fa_j1
	        },
	        474: {
	            1: fa_g4,
	            2: fa_h4
	        },
	        421: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        530: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        422: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        531: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        444: {
	            1: fa_i4,
	            2: fa_j4
	        },
	        888: {
	            1: fa_k4,
	            2: fa_l4,
	            3: fa_m4,
	            4: fa_n4
	        },
	        280: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        317: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        424: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        533: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        423: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        532: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        637: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        788: {
	            1: fa_o4,
	            2: fa_p4,
	            3: fa_q4,
	            4: fa_r4,
	            5: fa_s4,
	            6: fa_t4,
	            7: fa_u4,
	            8: fa_v4,
	            9: fa_w4,
	            10: fa_x4,
	            11: fa_y4,
	            12: fa_z4,
	            13: fa_a5,
	            14: fa_b5
	        },
	        784: {
	            1: fa_o4,
	            2: fa_c5,
	            3: fa_d5,
	            4: fa_e5,
	            5: fa_f5
	        },
	        785: {
	            1: fa_o4,
	            2: fa_c5,
	            3: fa_d5,
	            4: fa_e5,
	            5: fa_f5
	        },
	        786: {
	            1: fa_o4,
	            2: fa_c5,
	            3: fa_d5,
	            4: fa_e5,
	            5: fa_f5
	        },
	        787: {
	            1: fa_o4,
	            2: fa_c5,
	            3: fa_d5,
	            4: fa_e5,
	            5: fa_f5
	        },
	        774: {
	            1: fa_v4,
	            2: fa_g5,
	            3: fa_h5,
	            4: fa_i5,
	            5: fa_j5
	        },
	        775: {
	            1: fa_v4,
	            2: fa_g5,
	            3: fa_h5,
	            4: fa_i5,
	            5: fa_j5
	        },
	        776: {
	            1: fa_v4,
	            2: fa_g5,
	            3: fa_h5,
	            4: fa_i5,
	            5: fa_j5
	        },
	        777: {
	            1: fa_v4,
	            2: fa_g5,
	            3: fa_h5,
	            4: fa_i5,
	            5: fa_j5
	        },
	        281: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        137: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        246: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        248: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        240: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        232: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        241: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        233: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        61: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        62: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        684: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        685: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        890: {
	            1: fa_k5,
	            2: fa_l5,
	            3: fa_m5,
	            4: fa_n5
	        },
	        242: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        245: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        243: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        60: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        683: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        406: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        405: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        404: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        700: {
	            1: fa_o5,
	            2: fa_p5,
	            3: fa_q5
	        },
	        408: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        407: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        247: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        244: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        638: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        639: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        640: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        641: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        646: {
	            1: fa_r5,
	            2: fa_s5,
	            3: fa_t5
	        },
	        642: {
	            1: fa_r5,
	            2: fa_s5,
	            3: fa_t5
	        },
	        643: {
	            1: fa_r5,
	            2: fa_s5,
	            3: fa_t5
	        },
	        644: {
	            1: fa_r5,
	            2: fa_s5,
	            3: fa_t5
	        },
	        645: {
	            1: fa_r5,
	            2: fa_s5,
	            3: fa_t5
	        }
	    },
	    41: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        403: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        673: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        674: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        791: {
	            1: fa_v3,
	            2: fa_w3,
	            3: fa_x3,
	            4: fa_y3,
	            5: fa_z3,
	            6: fa_a4
	        },
	        792: {
	            1: fa_v3,
	            2: fa_w3,
	            3: fa_x3,
	            4: fa_y3,
	            5: fa_z3,
	            6: fa_a4
	        },
	        637: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        796: {
	            1: fa_o4,
	            2: fa_p4,
	            3: fa_q4,
	            4: fa_r4,
	            5: fa_s4,
	            6: fa_t4,
	            7: fa_u5,
	            8: fa_v4,
	            9: fa_w4,
	            10: fa_x4,
	            11: fa_y4,
	            12: fa_z4,
	            13: fa_a5,
	            14: fa_v5
	        },
	        794: {
	            1: fa_o4,
	            2: fa_c5,
	            3: fa_d5,
	            4: fa_w5,
	            5: fa_f5
	        },
	        795: {
	            1: fa_o4,
	            2: fa_c5,
	            3: fa_d5,
	            4: fa_w5,
	            5: fa_f5
	        },
	        789: {
	            1: fa_v4,
	            2: fa_g5,
	            3: fa_h5,
	            4: fa_x5,
	            5: fa_j5
	        },
	        790: {
	            1: fa_v4,
	            2: fa_g5,
	            3: fa_h5,
	            4: fa_x5,
	            5: fa_j5
	        },
	        725: {
	            1: fa_a2,
	            2: fa_d2,
	            3: fa_b2
	        },
	        726: {
	            1: fa_a2,
	            2: fa_d2,
	            3: fa_b2
	        },
	        793: {
	            1: fa_v3,
	            2: fa_w3,
	            3: fa_x3,
	            4: fa_y3,
	            5: fa_z3,
	            6: fa_a4
	        },
	        411: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        701: {
	            1: fa_y5,
	            2: fa_z5,
	            3: fa_a6
	        },
	        251: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        252: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        409: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        430: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        410: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        431: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        281: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        137: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        249: {
	            1: fa_d1,
	            2: fa_p1
	        },
	        250: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        63: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        64: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        686: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        687: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        103: {
	            1: fa_b6,
	            2: fa_c6
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        648: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        649: {
	            1: fa_a2,
	            2: fa_b2
	        }
	    },
	    18: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2
	        },
	        698: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        674: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        675: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        610: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        806: {
	            1: fa_d6,
	            2: fa_e6,
	            3: fa_f6,
	            4: fa_g6,
	            5: fa_h6,
	            6: fa_f5
	        },
	        893: {
	            1: fa_i6,
	            2: fa_j6,
	            3: fa_k6,
	            4: fa_l6,
	            5: fa_m6,
	            6: fa_n6
	        },
	        707: {
	            1: fa_o6,
	            2: fa_p6,
	            3: fa_q6
	        },
	        708: {
	            1: fa_o6,
	            2: fa_p6,
	            3: fa_q6
	        },
	        709: {
	            1: fa_o6,
	            2: fa_p6,
	            3: fa_q6
	        },
	        889: {
	            1: fa_r6,
	            2: fa_p2,
	            3: fa_q2,
	            4: fa_r2,
	            5: fa_s6,
	            6: fa_t6,
	            7: fa_u6,
	            8: fa_v6
	        },
	        904: {
	            1: fa_w6,
	            2: fa_x6,
	            3: fa_y6,
	            4: fa_z6,
	            5: fa_a7,
	            6: fa_b7,
	            7: fa_c7,
	            8: fa_d7,
	            9: fa_e7
	        },
	        253: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        688: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        65: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        751: {
	            1: fa_w2,
	            2: fa_x2,
	            3: fa_q1,
	            4: fa_r1,
	            5: fa_y2,
	            6: fa_z2,
	            7: fa_a3,
	            8: fa_b3,
	            9: fa_s1,
	            10: fa_t1,
	            11: fa_c3,
	            12: fa_d3,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_e3,
	            16: fa_w1,
	            17: fa_f3,
	            18: fa_g3,
	            19: fa_h3,
	            20: fa_x1,
	            21: fa_y1,
	            22: fa_z1,
	            23: fa_i3,
	            24: fa_j3,
	            25: fa_k3,
	            26: fa_l3,
	            27: fa_m3,
	            28: fa_n3,
	            29: fa_o3,
	            30: fa_p3,
	            31: fa_q3,
	            32: fa_r3,
	            33: fa_s3,
	            34: fa_t3,
	            35: fa_u3
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        743: {
	            1: fa_w2,
	            2: fa_x2,
	            3: fa_q1,
	            4: fa_r1,
	            5: fa_a3,
	            6: fa_b3,
	            7: fa_s1,
	            8: fa_t1,
	            9: fa_u1,
	            10: fa_v1,
	            11: fa_e3,
	            12: fa_w1,
	            13: fa_x1,
	            14: fa_y1,
	            15: fa_z1,
	            16: fa_i3,
	            17: fa_u3
	        },
	        744: {
	            1: fa_w2,
	            2: fa_x2,
	            3: fa_q1,
	            4: fa_r1,
	            5: fa_a3,
	            6: fa_b3,
	            7: fa_s1,
	            8: fa_t1,
	            9: fa_u1,
	            10: fa_v1,
	            11: fa_e3,
	            12: fa_w1,
	            13: fa_x1,
	            14: fa_y1,
	            15: fa_z1,
	            16: fa_i3,
	            17: fa_u3
	        },
	        745: {
	            1: fa_w2,
	            2: fa_x2,
	            3: fa_q1,
	            4: fa_r1,
	            5: fa_a3,
	            6: fa_b3,
	            7: fa_s1,
	            8: fa_t1,
	            9: fa_u1,
	            10: fa_v1,
	            11: fa_e3,
	            12: fa_w1,
	            13: fa_x1,
	            14: fa_y1,
	            15: fa_z1,
	            16: fa_i3,
	            17: fa_u3
	        },
	        615: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        350: {
	            1: fa_d1,
	            2: fa_e1
	        }
	    },
	    3: {
	        73: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        318: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        352: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        746: {
	            1: fa_u1,
	            2: fa_v1,
	            3: fa_s1,
	            4: fa_q1
	        },
	        102: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        403: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        366: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        367: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        368: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        566: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        567: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        568: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        854: {
	            1: fa_v3,
	            2: fa_f7,
	            3: fa_g7,
	            4: fa_h7,
	            5: fa_i7,
	            6: fa_j7,
	            7: fa_k7,
	            8: fa_l7
	        },
	        855: {
	            1: fa_v3,
	            2: fa_f7,
	            3: fa_g7,
	            4: fa_h7,
	            5: fa_i7,
	            6: fa_j7,
	            7: fa_k7,
	            8: fa_l7
	        },
	        856: {
	            1: fa_v3,
	            2: fa_f7,
	            3: fa_g7,
	            4: fa_h7,
	            5: fa_i7,
	            6: fa_j7,
	            7: fa_k7,
	            8: fa_l7
	        },
	        857: {
	            1: fa_v3,
	            2: fa_m7,
	            3: fa_n7,
	            4: fa_o7,
	            5: fa_p7
	        },
	        858: {
	            1: fa_v3,
	            2: fa_m7,
	            3: fa_n7,
	            4: fa_o7,
	            5: fa_p7
	        },
	        859: {
	            1: fa_v3,
	            2: fa_m7,
	            3: fa_n7,
	            4: fa_o7,
	            5: fa_p7
	        },
	        797: {
	            1: fa_q7,
	            2: fa_r7,
	            3: fa_s7,
	            4: fa_k1
	        },
	        798: {
	            1: fa_w1,
	            2: fa_t7,
	            3: fa_s7,
	            4: fa_k1
	        },
	        799: {
	            1: fa_w1,
	            2: fa_t7,
	            3: fa_s7,
	            4: fa_k1
	        },
	        851: {
	            1: fa_w1,
	            2: fa_t7,
	            3: fa_s7,
	            4: fa_j1
	        },
	        852: {
	            1: fa_w1,
	            2: fa_t7,
	            3: fa_s7,
	            4: fa_j1
	        },
	        853: {
	            1: fa_q7,
	            2: fa_r7,
	            3: fa_s7,
	            4: fa_j1
	        },
	        83: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        84: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        85: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        905: {
	            1: fa_u7,
	            2: fa_v7,
	            3: fa_w7,
	            4: fa_x7
	        },
	        906: {
	            1: fa_u7,
	            2: fa_v7,
	            3: fa_w7,
	            4: fa_x7
	        },
	        907: {
	            1: fa_u7,
	            2: fa_v7,
	            3: fa_w7,
	            4: fa_x7
	        },
	        443: {
	            1: fa_y7,
	            2: fa_z7
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        362: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        363: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        17: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        18: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        176: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        177: {
	            1: fa_d1,
	            2: fa_p1
	        },
	        358: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        359: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        13: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        14: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        172: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        173: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        616: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        617: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        618: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        891: {
	            1: fa_h2,
	            2: fa_i2,
	            3: fa_j2,
	            4: fa_k2
	        },
	        257: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        307: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        800: {
	            1: fa_a8,
	            2: fa_b8,
	            3: fa_c8,
	            4: fa_d8,
	            5: fa_e8,
	            6: fa_f8
	        },
	        801: {
	            1: fa_a8,
	            2: fa_b8,
	            3: fa_c8,
	            4: fa_d8,
	            5: fa_e8,
	            6: fa_f8
	        },
	        802: {
	            1: fa_a8,
	            2: fa_b8,
	            3: fa_c8,
	            4: fa_d8,
	            5: fa_e8,
	            6: fa_f8
	        }
	    },
	    20: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        698: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        199: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        200: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        201: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        202: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        141: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        142: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        143: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        144: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        145: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        185: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        186: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        187: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        188: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        189: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        24: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        25: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        26: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        27: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        28: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        673: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        674: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        675: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        676: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        677: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        678: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        679: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        680: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        860: {
	            1: fa_g8,
	            2: fa_f7,
	            3: fa_g7,
	            4: fa_h7,
	            5: fa_i7,
	            6: fa_j7,
	            7: fa_h8
	        },
	        861: {
	            1: fa_g8,
	            2: fa_f7,
	            3: fa_g7,
	            4: fa_h7,
	            5: fa_i7,
	            6: fa_j7,
	            7: fa_h8
	        },
	        862: {
	            1: fa_g8,
	            2: fa_f7,
	            3: fa_g7,
	            4: fa_h7,
	            5: fa_i7,
	            6: fa_j7,
	            7: fa_h8
	        },
	        863: {
	            1: fa_g8,
	            2: fa_f7,
	            3: fa_g7,
	            4: fa_h7,
	            5: fa_i7,
	            6: fa_j7,
	            7: fa_h8
	        },
	        864: {
	            1: fa_g8,
	            2: fa_f7,
	            3: fa_g7,
	            4: fa_h7,
	            5: fa_i7,
	            6: fa_j7,
	            7: fa_h8
	        },
	        865: {
	            1: fa_g8,
	            2: fa_f7,
	            3: fa_g7,
	            4: fa_h7,
	            5: fa_i7,
	            6: fa_j7,
	            7: fa_h8
	        },
	        866: {
	            1: fa_g8,
	            2: fa_f7,
	            3: fa_g7,
	            4: fa_h7,
	            5: fa_i7,
	            6: fa_j7,
	            7: fa_h8
	        },
	        867: {
	            1: fa_g8,
	            2: fa_f7,
	            3: fa_g7,
	            4: fa_h7,
	            5: fa_i7,
	            6: fa_j7,
	            7: fa_h8
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    },
	    5: {
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        698: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        945: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        948: {
	            1: fa_i8,
	            2: fa_j8,
	            3: fa_k8,
	            4: fa_l8,
	            5: fa_m8
	        },
	        949: {
	            1: fa_n8,
	            2: fa_o8,
	            3: fa_p8,
	            4: fa_q8,
	            5: fa_r8,
	            6: fa_s8,
	            7: fa_t8,
	            8: fa_u8,
	            9: fa_v8,
	            10: fa_w8,
	            11: fa_x8,
	            12: fa_y8,
	            13: fa_j8,
	            14: fa_k8,
	            15: fa_z8,
	            16: fa_a9,
	            17: fa_b9,
	            18: fa_c9,
	            19: fa_d9,
	            20: fa_e9,
	            21: fa_f9,
	            22: fa_g9,
	            23: fa_h9,
	            24: fa_i9,
	            25: fa_j9,
	            26: fa_k9,
	            27: fa_m8
	        }
	    },
	    40: {
	        656: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2
	        },
	        698: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    },
	    37: {
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    },
	    38: {
	        403: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        615: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        413: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        414: {
	            1: fa_a2,
	            2: fa_b2
	        }
	    },
	    42: {
	        403: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_l9,
	            2: fa_o1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        615: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        413: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        414: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        566: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        567: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        568: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        569: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        570: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        698: {
	            1: fa_j1,
	            2: fa_m9,
	            3: fa_k1
	        },
	        366: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        367: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        368: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        369: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        370: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        940: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        941: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        942: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        943: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        944: {
	            1: fa_j1,
	            2: fa_k1
	        }
	    },
	    26: {
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    },
	    25: {
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    },
	    16: {
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    },
	    12: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2
	        },
	        698: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    },
	    36: {
	        610: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        698: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        656: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        615: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    },
	    7: {
	        425: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        534: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        540: {
	            1: fa_d1,
	            2: fa_p1
	        },
	        343: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        345: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        260: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        261: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        83: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        84: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        803: {
	            1: fa_n2,
	            2: fa_o2,
	            3: fa_p2,
	            4: fa_q2,
	            5: fa_r2,
	            6: fa_n9
	        },
	        868: {
	            1: fa_n2,
	            2: fa_o2,
	            3: fa_p2,
	            4: fa_q2,
	            5: fa_r2,
	            6: fa_n9
	        },
	        869: {
	            1: fa_n2,
	            2: fa_o2,
	            3: fa_p2,
	            4: fa_q2,
	            5: fa_r2,
	            6: fa_n9
	        },
	        870: {
	            1: fa_n2,
	            2: fa_o2,
	            3: fa_p2,
	            4: fa_q2,
	            5: fa_r2,
	            6: fa_n9
	        },
	        805: {
	            1: fa_n2,
	            2: fa_o2,
	            3: fa_p2,
	            4: fa_q2,
	            5: fa_r2,
	            6: fa_n9
	        },
	        892: {
	            1: fa_n2,
	            2: fa_o2,
	            3: fa_p2,
	            4: fa_q2,
	            5: fa_r2,
	            6: fa_n9
	        },
	        346: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        419: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        528: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        420: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        529: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        707: {
	            1: fa_o9,
	            2: fa_p6,
	            3: fa_p9
	        },
	        708: {
	            1: fa_o9,
	            2: fa_p6,
	            3: fa_p9
	        },
	        706: {
	            1: fa_q9,
	            2: fa_r9,
	            3: fa_s9
	        },
	        804: {
	            1: fa_t9,
	            2: fa_u9,
	            3: fa_v9,
	            4: fa_w9
	        },
	        474: {
	            1: fa_g4,
	            2: fa_h4
	        },
	        614: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        609: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        416: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        732: {
	            1: fa_a2,
	            2: fa_d2,
	            3: fa_b2
	        },
	        525: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        850: {
	            1: fa_x9,
	            2: fa_y9,
	            3: fa_z9,
	            4: fa_a10
	        },
	        473: {
	            1: fa_b10,
	            2: fa_c10
	        },
	        442: {
	            1: fa_b10,
	            2: fa_c10
	        },
	        729: {
	            1: fa_a2,
	            2: fa_d2,
	            3: fa_b2
	        },
	        538: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        542: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        730: {
	            1: fa_a2,
	            2: fa_d2,
	            3: fa_b2
	        },
	        471: {
	            1: fa_b10,
	            2: fa_c10
	        },
	        635: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        714: {
	            1: fa_d10,
	            2: fa_d2,
	            3: fa_e10
	        },
	        624: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        625: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        715: {
	            1: fa_f10,
	            2: fa_g10,
	            3: fa_h10
	        },
	        650: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2
	        },
	        651: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2
	        },
	        652: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2
	        },
	        653: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2
	        },
	        654: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2
	        },
	        655: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2
	        },
	        634: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        626: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        733: {
	            1: fa_f10,
	            2: fa_g10,
	            3: fa_i10
	        },
	        734: {
	            1: fa_f10,
	            2: fa_g10,
	            3: fa_i10
	        },
	        258: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        259: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        66: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        67: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        81: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        68: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        689: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        690: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        699: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        691: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        723: {
	            1: fa_a2,
	            2: fa_d2,
	            3: fa_b2
	        },
	        633: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2
	        },
	        698: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        322: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        904: {
	            1: fa_w6,
	            2: fa_j10,
	            3: fa_y6,
	            4: fa_k10,
	            5: fa_l10,
	            6: fa_m10,
	            7: fa_c7,
	            8: fa_n10,
	            9: fa_e7
	        },
	        1: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        136: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        747: {
	            1: fa_w2,
	            2: fa_x2,
	            3: fa_q1,
	            4: fa_r1,
	            5: fa_y2,
	            6: fa_z2,
	            7: fa_o10,
	            8: fa_a3,
	            9: fa_b3,
	            10: fa_s1,
	            11: fa_t1,
	            12: fa_c3,
	            13: fa_d3,
	            14: fa_p10,
	            15: fa_u1,
	            16: fa_v1,
	            17: fa_e3,
	            18: fa_w1,
	            19: fa_f3,
	            20: fa_x1,
	            21: fa_y1,
	            22: fa_z1,
	            23: fa_i3,
	            24: fa_l3,
	            25: fa_m3,
	            26: fa_n3,
	            27: fa_q3,
	            28: fa_r3,
	            29: fa_q10,
	            30: fa_r10,
	            31: fa_u3
	        },
	        871: {
	            1: fa_n2,
	            2: fa_o2,
	            3: fa_p2,
	            4: fa_q2,
	            5: fa_r2,
	            6: fa_s2
	        },
	        255: {
	            1: fa_d1,
	            2: fa_p1
	        },
	        705: {
	            1: fa_s10,
	            2: fa_t10,
	            3: fa_u10
	        },
	        323: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        324: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        702: {
	            1: fa_v10,
	            2: fa_d2,
	            3: fa_e10
	        },
	        278: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        282: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        911: {
	            1: fa_h2,
	            2: fa_i2,
	            3: fa_j2,
	            4: fa_k2,
	            5: fa_l2,
	            6: fa_m2
	        },
	        353: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        674: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        2: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        5: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        7: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        939: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        9: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        12: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        417: {
	            1: fa_w10,
	            2: fa_x10
	        },
	        526: {
	            1: fa_w10,
	            2: fa_x10
	        },
	        325: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        160: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        163: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        165: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        166: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        168: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        171: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        148: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        149: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        150: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        151: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        152: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        153: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        154: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        155: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        156: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        157: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        158: {
	            1: fa_d1,
	            2: fa_p1
	        },
	        159: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        731: {
	            1: fa_a2,
	            2: fa_d2,
	            3: fa_b2
	        },
	        765: {
	            1: fa_n2,
	            2: fa_o2,
	            3: fa_p2,
	            4: fa_q2,
	            5: fa_r2,
	            6: fa_s2
	        },
	        766: {
	            1: fa_n2,
	            2: fa_o2,
	            3: fa_p2,
	            4: fa_q2,
	            5: fa_r2,
	            6: fa_s2
	        },
	        415: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        524: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        418: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        527: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        743: {
	            1: fa_w2,
	            2: fa_x2,
	            3: fa_q1,
	            4: fa_r1,
	            5: fa_a3,
	            6: fa_b3,
	            7: fa_s1,
	            8: fa_t1,
	            9: fa_u1,
	            10: fa_v1,
	            11: fa_e3,
	            12: fa_w1,
	            13: fa_x1,
	            14: fa_y1,
	            15: fa_z1,
	            16: fa_i3,
	            17: fa_u3
	        },
	        744: {
	            1: fa_w2,
	            2: fa_x2,
	            3: fa_q1,
	            4: fa_r1,
	            5: fa_a3,
	            6: fa_b3,
	            7: fa_s1,
	            8: fa_t1,
	            9: fa_u1,
	            10: fa_v1,
	            11: fa_e3,
	            12: fa_w1,
	            13: fa_x1,
	            14: fa_y1,
	            15: fa_z1,
	            16: fa_i3,
	            17: fa_u3
	        },
	        710: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_y10
	        },
	        321: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        326: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        327: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        724: {
	            1: fa_z10,
	            2: fa_a11,
	            3: fa_b11
	        },
	        661: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        664: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        666: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        667: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        669: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        672: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        426: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        535: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        537: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        541: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        539: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        437: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        436: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        694: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        71: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        271: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        268: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        265: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        267: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        270: {
	            1: fa_c11,
	            2: fa_d11
	        },
	        272: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        269: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        266: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        264: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        281: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        137: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        660: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2
	        },
	        880: {
	            1: fa_e11,
	            2: fa_f11,
	            3: fa_g11,
	            4: fa_h11
	        },
	        879: {
	            1: fa_i11,
	            2: fa_j11,
	            3: fa_k11,
	            4: fa_l11
	        },
	        429: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        433: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        881: {
	            1: fa_m11,
	            2: fa_n11,
	            3: fa_o11,
	            4: fa_p11,
	            5: fa_q11,
	            6: fa_r11
	        },
	        273: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        274: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        435: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        704: {
	            1: fa_s11,
	            2: fa_t11,
	            3: fa_u11
	        },
	        432: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        428: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        434: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        439: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        440: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        441: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        438: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        623: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        180: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        146: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        659: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2
	        },
	        749: {
	            1: fa_w2,
	            2: fa_x2,
	            3: fa_q1,
	            4: fa_r1,
	            5: fa_a3,
	            6: fa_b3,
	            7: fa_s1,
	            8: fa_t1,
	            9: fa_u1,
	            10: fa_v1,
	            11: fa_e3,
	            12: fa_w1,
	            13: fa_x1,
	            14: fa_y1,
	            15: fa_z1,
	            16: fa_i3,
	            17: fa_u3
	        },
	        69: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        262: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        692: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        703: {
	            1: fa_a2,
	            2: fa_d2,
	            3: fa_b2
	        },
	        70: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        263: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        693: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        72: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        277: {
	            1: fa_v11,
	            2: fa_e1
	        },
	        695: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        750: {
	            1: fa_a3,
	            2: fa_u1,
	            3: fa_x1,
	            4: fa_v1,
	            5: fa_y1,
	            6: fa_z1,
	            7: fa_m3,
	            8: fa_n3,
	            9: fa_o3,
	            10: fa_t3,
	            11: fa_w11,
	            12: fa_x11,
	            13: fa_x2,
	            14: fa_q1,
	            15: fa_r1,
	            16: fa_s1,
	            17: fa_t1,
	            18: fa_w1,
	            19: fa_c3,
	            20: fa_f3,
	            21: fa_j3,
	            22: fa_k3,
	            23: fa_y11,
	            24: fa_z11
	        },
	        181: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        147: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        276: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        275: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        735: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        736: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        737: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        738: {
	            1: fa_a2,
	            2: fa_d2,
	            3: fa_b2
	        },
	        739: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        740: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        356: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        357: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        354: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        355: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        937: {
	            1: fa_a12,
	            2: fa_b12,
	            3: fa_c12,
	            4: fa_d12,
	            5: fa_e12,
	            6: fa_f12,
	            7: fa_g12,
	            8: fa_h12,
	            9: fa_i12,
	            10: fa_j12
	        },
	        657: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2
	        },
	        658: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2
	        },
	        412: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    },
	    14: {
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    },
	    34: {
	        425: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        534: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        540: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        343: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        345: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        260: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        261: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        83: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        84: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        803: {
	            1: fa_n2,
	            2: fa_o2,
	            3: fa_p2,
	            4: fa_q2,
	            5: fa_r2,
	            6: fa_n9
	        },
	        868: {
	            1: fa_n2,
	            2: fa_o2,
	            3: fa_p2,
	            4: fa_q2,
	            5: fa_r2,
	            6: fa_n9
	        },
	        869: {
	            1: fa_n2,
	            2: fa_o2,
	            3: fa_p2,
	            4: fa_q2,
	            5: fa_r2,
	            6: fa_n9
	        },
	        870: {
	            1: fa_n2,
	            2: fa_o2,
	            3: fa_p2,
	            4: fa_q2,
	            5: fa_r2,
	            6: fa_n9
	        },
	        346: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        419: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        528: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        420: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        529: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        707: {
	            1: fa_o9,
	            2: fa_p6,
	            3: fa_p9
	        },
	        708: {
	            1: fa_o9,
	            2: fa_p6,
	            3: fa_p9
	        },
	        706: {
	            1: fa_q9,
	            2: fa_r9,
	            3: fa_s9
	        },
	        538: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2
	        },
	        698: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        322: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        904: {
	            1: fa_w6,
	            2: fa_j10,
	            3: fa_y6,
	            4: fa_k10,
	            5: fa_l10,
	            6: fa_m10,
	            7: fa_c7,
	            8: fa_n10,
	            9: fa_e7
	        },
	        1: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        136: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        747: {
	            1: fa_w2,
	            2: fa_x2,
	            3: fa_q1,
	            4: fa_r1,
	            5: fa_y2,
	            6: fa_z2,
	            7: fa_o10,
	            8: fa_a3,
	            9: fa_b3,
	            10: fa_s1,
	            11: fa_t1,
	            12: fa_c3,
	            13: fa_d3,
	            14: fa_p10,
	            15: fa_u1,
	            16: fa_v1,
	            17: fa_e3,
	            18: fa_w1,
	            19: fa_f3,
	            20: fa_x1,
	            21: fa_y1,
	            22: fa_z1,
	            23: fa_i3,
	            24: fa_l3,
	            25: fa_m3,
	            26: fa_n3,
	            27: fa_q3,
	            28: fa_r3,
	            29: fa_q10,
	            30: fa_r10,
	            31: fa_u3
	        },
	        871: {
	            1: fa_n2,
	            2: fa_o2,
	            3: fa_p2,
	            4: fa_q2,
	            5: fa_r2,
	            6: fa_s2
	        },
	        255: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        705: {
	            1: fa_s10,
	            2: fa_t10,
	            3: fa_u10
	        },
	        323: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        324: {
	            1: fa_c11,
	            2: fa_d11
	        },
	        702: {
	            1: fa_v10,
	            2: fa_d2,
	            3: fa_e10
	        },
	        278: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        282: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        911: {
	            1: fa_h2,
	            2: fa_i2,
	            3: fa_j2,
	            4: fa_k2,
	            5: fa_l2,
	            6: fa_m2
	        },
	        353: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        674: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        2: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        5: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        7: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        939: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        9: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        12: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        417: {
	            1: fa_w10,
	            2: fa_x10
	        },
	        526: {
	            1: fa_w10,
	            2: fa_x10
	        },
	        325: {
	            1: fa_c11,
	            2: fa_d11
	        },
	        103: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        160: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        163: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        165: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        166: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        168: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        171: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        148: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        149: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        150: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        151: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        152: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        153: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        154: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        155: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        156: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        157: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        158: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        159: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        731: {
	            1: fa_a2,
	            2: fa_d2,
	            3: fa_b2
	        },
	        765: {
	            1: fa_n2,
	            2: fa_o2,
	            3: fa_p2,
	            4: fa_q2,
	            5: fa_r2,
	            6: fa_s2
	        },
	        766: {
	            1: fa_n2,
	            2: fa_o2,
	            3: fa_p2,
	            4: fa_q2,
	            5: fa_r2,
	            6: fa_s2
	        },
	        415: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        524: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        418: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        527: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        743: {
	            1: fa_w2,
	            2: fa_x2,
	            3: fa_q1,
	            4: fa_r1,
	            5: fa_a3,
	            6: fa_b3,
	            7: fa_s1,
	            8: fa_t1,
	            9: fa_u1,
	            10: fa_v1,
	            11: fa_e3,
	            12: fa_w1,
	            13: fa_x1,
	            14: fa_y1,
	            15: fa_z1,
	            16: fa_i3,
	            17: fa_u3
	        },
	        744: {
	            1: fa_w2,
	            2: fa_x2,
	            3: fa_q1,
	            4: fa_r1,
	            5: fa_a3,
	            6: fa_b3,
	            7: fa_s1,
	            8: fa_t1,
	            9: fa_u1,
	            10: fa_v1,
	            11: fa_e3,
	            12: fa_w1,
	            13: fa_x1,
	            14: fa_y1,
	            15: fa_z1,
	            16: fa_i3,
	            17: fa_u3
	        },
	        710: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_v2
	        },
	        321: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        326: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        327: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        724: {
	            1: fa_z10,
	            2: fa_a11,
	            3: fa_b11
	        },
	        661: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        664: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        666: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        667: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        669: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        672: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        426: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        535: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        537: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        541: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        539: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    },
	    19: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        698: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        615: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        886: {
	            1: fa_v3,
	            2: fa_w3,
	            3: fa_x3,
	            4: fa_y3,
	            5: fa_z3,
	            6: fa_a4
	        },
	        887: {
	            1: fa_v3,
	            2: fa_w3,
	            3: fa_x3,
	            4: fa_y3,
	            5: fa_z3,
	            6: fa_a4
	        },
	        911: {
	            1: fa_h2,
	            2: fa_i2,
	            3: fa_j2,
	            4: fa_k2,
	            5: fa_l2,
	            6: fa_m2
	        },
	        884: {
	            1: fa_o4,
	            2: fa_c5,
	            3: fa_d5,
	            4: fa_k12,
	            5: fa_f5
	        },
	        885: {
	            1: fa_o4,
	            2: fa_c5,
	            3: fa_d5,
	            4: fa_k12,
	            5: fa_f5
	        },
	        882: {
	            1: fa_o4,
	            2: fa_c5,
	            3: fa_d5,
	            4: fa_k12,
	            5: fa_e2
	        },
	        883: {
	            1: fa_o4,
	            2: fa_c5,
	            3: fa_d5,
	            4: fa_k12,
	            5: fa_e2
	        },
	        723: {
	            1: fa_a2,
	            2: fa_d2,
	            3: fa_b2
	        },
	        673: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        674: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    },
	    30: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2
	        },
	        698: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        279: {
	            1: fa_c11,
	            2: fa_d11
	        },
	        610: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        674: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        675: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        350: {
	            1: fa_c11,
	            2: fa_d11
	        },
	        103: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        415: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        524: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        743: {
	            1: fa_w2,
	            2: fa_x2,
	            3: fa_q1,
	            4: fa_r1,
	            5: fa_a3,
	            6: fa_b3,
	            7: fa_s1,
	            8: fa_t1,
	            9: fa_u1,
	            10: fa_v1,
	            11: fa_e3,
	            12: fa_w1,
	            13: fa_x1,
	            14: fa_y1,
	            15: fa_z1,
	            16: fa_i3,
	            17: fa_u3
	        },
	        744: {
	            1: fa_w2,
	            2: fa_x2,
	            3: fa_q1,
	            4: fa_r1,
	            5: fa_a3,
	            6: fa_b3,
	            7: fa_s1,
	            8: fa_t1,
	            9: fa_u1,
	            10: fa_v1,
	            11: fa_e3,
	            12: fa_w1,
	            13: fa_x1,
	            14: fa_y1,
	            15: fa_z1,
	            16: fa_i3,
	            17: fa_u3
	        },
	        745: {
	            1: fa_w2,
	            2: fa_x2,
	            3: fa_q1,
	            4: fa_r1,
	            5: fa_a3,
	            6: fa_b3,
	            7: fa_s1,
	            8: fa_t1,
	            9: fa_u1,
	            10: fa_v1,
	            11: fa_e3,
	            12: fa_w1,
	            13: fa_x1,
	            14: fa_y1,
	            15: fa_z1,
	            16: fa_i3,
	            17: fa_u3
	        },
	        710: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_v2
	        },
	        403: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        426: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        535: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        706: {
	            1: fa_q9,
	            2: fa_r9,
	            3: fa_s9
	        },
	        343: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        346: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        83: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        84: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        85: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        344: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        347: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        765: {
	            1: fa_n2,
	            2: fa_o2,
	            3: fa_p2,
	            4: fa_q2,
	            5: fa_r2,
	            6: fa_s2
	        },
	        766: {
	            1: fa_n2,
	            2: fa_o2,
	            3: fa_p2,
	            4: fa_q2,
	            5: fa_r2,
	            6: fa_s2
	        },
	        767: {
	            1: fa_n2,
	            2: fa_o2,
	            3: fa_p2,
	            4: fa_q2,
	            5: fa_r2,
	            6: fa_s2
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        751: {
	            1: fa_w2,
	            2: fa_x2,
	            3: fa_q1,
	            4: fa_r1,
	            5: fa_y2,
	            6: fa_z2,
	            7: fa_a3,
	            8: fa_b3,
	            9: fa_s1,
	            10: fa_t1,
	            11: fa_c3,
	            12: fa_d3,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_e3,
	            16: fa_w1,
	            17: fa_f3,
	            18: fa_g3,
	            19: fa_h3,
	            20: fa_x1,
	            21: fa_y1,
	            22: fa_z1,
	            23: fa_i3,
	            24: fa_j3,
	            25: fa_k3,
	            26: fa_l3,
	            27: fa_m3,
	            28: fa_n3,
	            29: fa_o3,
	            30: fa_p3,
	            31: fa_q3,
	            32: fa_r3,
	            33: fa_s3,
	            34: fa_t3,
	            35: fa_u3
	        },
	        911: {
	            1: fa_h2,
	            2: fa_i2,
	            3: fa_j2,
	            4: fa_k2,
	            5: fa_l2,
	            6: fa_m2
	        },
	        889: {
	            1: fa_r6,
	            2: fa_p2,
	            3: fa_q2,
	            4: fa_r2,
	            5: fa_s6,
	            6: fa_t6,
	            7: fa_u6,
	            8: fa_v6
	        },
	        637: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        615: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        412: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        634: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        626: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        611: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        904: {
	            1: fa_w6,
	            2: fa_j10,
	            3: fa_y6,
	            4: fa_k10,
	            5: fa_l10,
	            6: fa_m10,
	            7: fa_c7,
	            8: fa_n10,
	            9: fa_e7
	        },
	        449: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        446: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        451: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        711: {
	            1: fa_l12,
	            2: fa_m12,
	            3: fa_n12
	        },
	        712: {
	            1: fa_o12,
	            2: fa_p12,
	            3: fa_q12
	        },
	        713: {
	            1: fa_r12,
	            2: fa_s12,
	            3: fa_t12
	        },
	        450: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        447: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        448: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        662: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        663: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        665: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        668: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        670: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        671: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        3: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        4: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        6: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        8: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        10: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        11: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        161: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        162: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        164: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        167: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        169: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        170: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        707: {
	            1: fa_o6,
	            2: fa_p6,
	            3: fa_q6
	        },
	        708: {
	            1: fa_o6,
	            2: fa_p6,
	            3: fa_q6
	        },
	        709: {
	            1: fa_o6,
	            2: fa_p6,
	            3: fa_q6
	        },
	        946: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        947: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    },
	    23: {
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    },
	    13: {
	        468: {
	            1: fa_u12,
	            2: fa_v12
	        },
	        470: {
	            1: fa_u12,
	            2: fa_v12
	        },
	        467: {
	            1: fa_u12,
	            2: fa_v12
	        },
	        469: {
	            1: fa_u12,
	            2: fa_v12
	        },
	        464: {
	            1: fa_w12,
	            2: fa_x12
	        },
	        466: {
	            1: fa_y12,
	            2: fa_z12
	        },
	        465: {
	            1: fa_y12,
	            2: fa_z12
	        },
	        463: {
	            1: fa_y12,
	            2: fa_z12
	        },
	        289: {
	            1: fa_c11,
	            2: fa_d11
	        },
	        288: {
	            1: fa_c11,
	            2: fa_d11
	        },
	        292: {
	            1: fa_c11,
	            2: fa_d11
	        },
	        461: {
	            1: fa_y12,
	            2: fa_z12
	        },
	        283: {
	            1: fa_c11,
	            2: fa_d11
	        },
	        295: {
	            1: fa_c11,
	            2: fa_d11
	        },
	        293: {
	            1: fa_c11,
	            2: fa_d11
	        },
	        284: {
	            1: fa_c11,
	            2: fa_d11
	        },
	        285: {
	            1: fa_c11,
	            2: fa_d11
	        },
	        316: {
	            1: fa_c11,
	            2: fa_d11
	        },
	        286: {
	            1: fa_c11,
	            2: fa_d11
	        },
	        287: {
	            1: fa_c11,
	            2: fa_d11
	        },
	        290: {
	            1: fa_c11,
	            2: fa_d11
	        },
	        291: {
	            1: fa_c11,
	            2: fa_d11
	        },
	        462: {
	            1: fa_y12,
	            2: fa_z12
	        },
	        294: {
	            1: fa_c11,
	            2: fa_d11
	        }
	    },
	    39: {
	        403: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        443: {
	            1: fa_a13,
	            2: fa_b13
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        698: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        950: {
	            1: fa_n8,
	            2: fa_o8,
	            3: fa_p8,
	            4: fa_c13,
	            5: fa_r8,
	            6: fa_d13,
	            7: fa_e13,
	            8: fa_z8,
	            9: fa_a9,
	            10: fa_b9,
	            11: fa_c9,
	            12: fa_d9,
	            13: fa_f13
	        },
	        955: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        951: {
	            1: fa_g13,
	            2: fa_h13
	        },
	        952: {
	            1: fa_g13,
	            2: fa_h13
	        },
	        953: {
	            1: fa_g13,
	            2: fa_h13
	        },
	        954: {
	            1: fa_g13,
	            2: fa_h13
	        }
	    },
	    33: {
	        348: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    },
	    24: {
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    },
	    9: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2
	        },
	        698: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        674: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    },
	    21: {
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    },
	    29: {
	        394: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        395: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        396: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        397: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        398: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        399: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        400: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        401: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        402: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        100: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        101: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        104: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        105: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        106: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        107: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        108: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        109: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        110: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        111: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        112: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        113: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        114: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        115: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        116: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        117: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        118: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        119: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        120: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        121: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        808: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        809: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        810: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        811: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        812: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        813: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        814: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        815: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        816: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        817: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        818: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        819: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        820: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        821: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        822: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        823: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        824: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        825: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        826: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        827: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        828: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        829: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        830: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        831: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        832: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        833: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        834: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        835: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        836: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        837: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        838: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        839: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        840: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        841: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        842: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        843: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        844: {
	            1: fa_i13,
	            2: fa_j13,
	            3: fa_k13,
	            4: fa_l13,
	            5: fa_m13,
	            6: fa_n13
	        },
	        366: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        367: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        368: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        369: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        370: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        371: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        372: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        373: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        374: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        375: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        376: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        377: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        378: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        379: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        380: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        381: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        382: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        383: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        384: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        385: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        386: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        387: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        388: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        389: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        390: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        391: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        392: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        393: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        481: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        482: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        483: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        484: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        485: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        486: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        487: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        488: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        489: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        490: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        491: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        492: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        493: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        494: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        495: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        496: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        497: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        498: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        499: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        500: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        501: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        502: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        503: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        504: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        505: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        506: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        507: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        508: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        509: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        510: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        511: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        566: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        567: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        568: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        569: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        570: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        571: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        572: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        573: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        574: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        575: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        576: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        577: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        578: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        579: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        580: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        581: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        582: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        583: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        584: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        585: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        586: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        587: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        588: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        589: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        590: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        591: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        592: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        593: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        594: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        595: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        596: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        597: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        598: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        599: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        600: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        601: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        602: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        83: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        84: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        85: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        86: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        87: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        88: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        89: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        90: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        91: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        92: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        93: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        94: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        95: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        96: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        97: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        98: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        99: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_c11,
	            2: fa_d11
	        },
	        254: {
	            1: fa_c11,
	            2: fa_d11
	        },
	        403: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        24: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        25: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        26: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        27: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        28: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        29: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        30: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        31: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        32: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        33: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        34: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        35: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        36: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        37: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        38: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        39: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        40: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        41: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        42: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        43: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        44: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        45: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        46: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        47: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        48: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        49: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        50: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        51: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        52: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        53: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        54: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        55: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        56: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        57: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        199: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        200: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        201: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        202: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        203: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        204: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        205: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        206: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        207: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        208: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        209: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        210: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        211: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        212: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        213: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        214: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        215: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        216: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        217: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        218: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        219: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        220: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        221: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        222: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        223: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        224: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        225: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        226: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        227: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        228: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        229: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        230: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        231: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        475: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        476: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        477: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        478: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        479: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        480: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    },
	    15: {
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    },
	    2: {
	        73: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        318: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        24: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        25: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        26: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        27: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_c11,
	            2: fa_d11
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        199: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        200: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        201: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        352: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        102: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        403: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        141: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        142: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        143: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        144: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        185: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        186: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        187: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        188: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        566: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        567: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        568: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        569: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        570: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        571: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        572: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        366: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        367: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        368: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        369: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        370: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        371: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        372: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        122: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        123: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        124: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        125: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        126: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        127: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        128: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        129: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        130: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        131: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        132: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        133: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        134: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        135: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        872: {
	            1: fa_v3,
	            2: fa_f7,
	            3: fa_g7,
	            4: fa_h7,
	            5: fa_i7,
	            6: fa_o13
	        },
	        873: {
	            1: fa_v3,
	            2: fa_f7,
	            3: fa_g7,
	            4: fa_h7,
	            5: fa_i7,
	            6: fa_o13
	        },
	        874: {
	            1: fa_v3,
	            2: fa_f7,
	            3: fa_g7,
	            4: fa_h7,
	            5: fa_i7,
	            6: fa_o13
	        },
	        875: {
	            1: fa_v3,
	            2: fa_f7,
	            3: fa_g7,
	            4: fa_h7,
	            5: fa_i7,
	            6: fa_o13
	        },
	        876: {
	            1: fa_v3,
	            2: fa_f7,
	            3: fa_g7,
	            4: fa_h7,
	            5: fa_i7,
	            6: fa_o13
	        },
	        877: {
	            1: fa_v3,
	            2: fa_f7,
	            3: fa_g7,
	            4: fa_h7,
	            5: fa_i7,
	            6: fa_o13
	        },
	        878: {
	            1: fa_v3,
	            2: fa_f7,
	            3: fa_g7,
	            4: fa_h7,
	            5: fa_i7,
	            6: fa_o13
	        },
	        616: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        617: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        618: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        619: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        620: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        621: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        622: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        894: {
	            1: fa_p13,
	            2: fa_q13,
	            3: fa_r13,
	            4: fa_s13
	        },
	        895: {
	            1: fa_p13,
	            2: fa_q13,
	            3: fa_r13,
	            4: fa_s13
	        },
	        896: {
	            1: fa_p13,
	            2: fa_q13,
	            3: fa_r13,
	            4: fa_s13
	        },
	        897: {
	            1: fa_p13,
	            2: fa_q13,
	            3: fa_r13,
	            4: fa_s13
	        },
	        898: {
	            1: fa_p13,
	            2: fa_q13,
	            3: fa_r13,
	            4: fa_s13
	        },
	        899: {
	            1: fa_p13,
	            2: fa_q13,
	            3: fa_r13,
	            4: fa_s13
	        },
	        900: {
	            1: fa_p13,
	            2: fa_q13,
	            3: fa_r13,
	            4: fa_s13
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        83: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        84: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        85: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        86: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        87: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        88: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        89: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        257: {
	            1: fa_t13,
	            2: fa_e1
	        },
	        307: {
	            1: fa_t13,
	            2: fa_e1
	        },
	        752: {
	            1: fa_x1,
	            2: fa_y1,
	            3: fa_z1,
	            4: fa_w1,
	            5: fa_t1,
	            6: fa_r1
	        },
	        753: {
	            1: fa_l3,
	            2: fa_m3,
	            3: fa_n3,
	            4: fa_o3,
	            5: fa_j3,
	            6: fa_f3,
	            7: fa_c3,
	            8: fa_y2
	        }
	    },
	    6: {
	        553: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        339: {
	            1: fa_d1,
	            2: fa_p1
	        },
	        547: {
	            1: fa_b10,
	            2: fa_c10
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        141: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        142: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        185: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        186: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        83: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        84: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        85: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        86: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        87: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        807: {
	            1: fa_w6,
	            2: fa_y6,
	            3: fa_c7,
	            4: fa_e7
	        },
	        636: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        334: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        335: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        336: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        337: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        906: {
	            1: fa_u7,
	            2: fa_v7,
	            3: fa_w7,
	            4: fa_x7
	        },
	        907: {
	            1: fa_u7,
	            2: fa_v7,
	            3: fa_w7,
	            4: fa_x7
	        },
	        908: {
	            1: fa_u7,
	            2: fa_v7,
	            3: fa_w7,
	            4: fa_x7
	        },
	        909: {
	            1: fa_u7,
	            2: fa_v7,
	            3: fa_w7,
	            4: fa_x7
	        },
	        300: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        301: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        302: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        303: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        304: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        310: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        311: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        312: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        313: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        314: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        554: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        555: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        556: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        557: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        558: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        517: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        518: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        519: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        520: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        521: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        561: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        562: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        563: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        564: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        565: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        73: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        318: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        24: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        25: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        199: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        352: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        748: {
	            1: fa_q1,
	            2: fa_r1,
	            3: fa_s1,
	            4: fa_t1,
	            5: fa_u1,
	            6: fa_v1,
	            7: fa_w1,
	            8: fa_x1,
	            9: fa_y1,
	            10: fa_z1
	        },
	        102: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        403: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        903: {
	            1: fa_u13,
	            2: fa_v13,
	            3: fa_w13,
	            4: fa_x13,
	            5: fa_y13,
	            6: fa_z13,
	            7: fa_a14,
	            8: fa_b14
	        },
	        445: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        754: {
	            1: fa_o10,
	            2: fa_p10,
	            3: fa_h3,
	            4: fa_c14,
	            5: fa_t7,
	            6: fa_d14,
	            7: fa_q10,
	            8: fa_r10,
	            9: fa_e14,
	            10: fa_f14,
	            11: fa_g14,
	            12: fa_h14,
	            13: fa_i14,
	            14: fa_j14
	        },
	        755: {
	            1: fa_o10,
	            2: fa_p10,
	            3: fa_h3,
	            4: fa_c14,
	            5: fa_t7,
	            6: fa_d14,
	            7: fa_q10,
	            8: fa_r10,
	            9: fa_e14,
	            10: fa_f14,
	            11: fa_g14,
	            12: fa_h14,
	            13: fa_i14,
	            14: fa_j14
	        },
	        756: {
	            1: fa_o10,
	            2: fa_p10,
	            3: fa_h3,
	            4: fa_c14,
	            5: fa_t7,
	            6: fa_d14,
	            7: fa_q10,
	            8: fa_r10,
	            9: fa_e14,
	            10: fa_f14,
	            11: fa_g14,
	            12: fa_h14,
	            13: fa_i14,
	            14: fa_j14
	        },
	        757: {
	            1: fa_o10,
	            2: fa_p10,
	            3: fa_h3,
	            4: fa_c14,
	            5: fa_t7,
	            6: fa_d14,
	            7: fa_q10,
	            8: fa_r10,
	            9: fa_e14,
	            10: fa_f14,
	            11: fa_g14,
	            12: fa_h14,
	            13: fa_i14,
	            14: fa_j14
	        },
	        758: {
	            1: fa_o10,
	            2: fa_p10,
	            3: fa_h3,
	            4: fa_c14,
	            5: fa_t7,
	            6: fa_d14,
	            7: fa_q10,
	            8: fa_r10,
	            9: fa_e14,
	            10: fa_f14,
	            11: fa_g14,
	            12: fa_h14,
	            13: fa_i14,
	            14: fa_j14
	        },
	        452: {
	            1: fa_b10,
	            2: fa_c10
	        },
	        453: {
	            1: fa_b10,
	            2: fa_c10
	        },
	        454: {
	            1: fa_b10,
	            2: fa_c10
	        },
	        566: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        567: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        568: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        569: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        570: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        366: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        367: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        368: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        369: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        370: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        522: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        627: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        628: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        629: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        630: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        631: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        632: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        190: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        191: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        192: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        193: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        194: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        759: {
	            1: fa_k14,
	            2: fa_l14,
	            3: fa_m14,
	            4: fa_n14,
	            5: fa_o14,
	            6: fa_i14,
	            7: fa_p14,
	            8: fa_q14,
	            9: fa_r14,
	            10: fa_s14,
	            11: fa_t14,
	            12: fa_u14,
	            13: fa_d14,
	            14: fa_v14
	        },
	        760: {
	            1: fa_k14,
	            2: fa_l14,
	            3: fa_m14,
	            4: fa_n14,
	            5: fa_o14,
	            6: fa_i14,
	            7: fa_p14,
	            8: fa_q14,
	            9: fa_r14,
	            10: fa_s14,
	            11: fa_t14,
	            12: fa_u14,
	            13: fa_d14,
	            14: fa_v14
	        },
	        761: {
	            1: fa_k14,
	            2: fa_l14,
	            3: fa_m14,
	            4: fa_n14,
	            5: fa_o14,
	            6: fa_i14,
	            7: fa_p14,
	            8: fa_q14,
	            9: fa_r14,
	            10: fa_s14,
	            11: fa_t14,
	            12: fa_u14,
	            13: fa_d14,
	            14: fa_v14
	        },
	        762: {
	            1: fa_k14,
	            2: fa_l14,
	            3: fa_m14,
	            4: fa_n14,
	            5: fa_o14,
	            6: fa_i14,
	            7: fa_p14,
	            8: fa_q14,
	            9: fa_r14,
	            10: fa_s14,
	            11: fa_t14,
	            12: fa_u14,
	            13: fa_d14,
	            14: fa_v14
	        },
	        763: {
	            1: fa_k14,
	            2: fa_l14,
	            3: fa_m14,
	            4: fa_n14,
	            5: fa_o14,
	            6: fa_i14,
	            7: fa_p14,
	            8: fa_q14,
	            9: fa_r14,
	            10: fa_s14,
	            11: fa_t14,
	            12: fa_u14,
	            13: fa_d14,
	            14: fa_v14
	        },
	        768: {
	            1: fa_u6,
	            2: fa_w14,
	            3: fa_x14,
	            4: fa_y14,
	            5: fa_z14,
	            6: fa_f2,
	            7: fa_a15
	        },
	        769: {
	            1: fa_u6,
	            2: fa_w14,
	            3: fa_x14,
	            4: fa_y14,
	            5: fa_z14,
	            6: fa_f2,
	            7: fa_a15
	        },
	        770: {
	            1: fa_u6,
	            2: fa_w14,
	            3: fa_x14,
	            4: fa_y14,
	            5: fa_z14,
	            6: fa_f2,
	            7: fa_a15
	        },
	        771: {
	            1: fa_u6,
	            2: fa_w14,
	            3: fa_x14,
	            4: fa_y14,
	            5: fa_z14,
	            6: fa_f2,
	            7: fa_a15
	        },
	        772: {
	            1: fa_u6,
	            2: fa_w14,
	            3: fa_x14,
	            4: fa_y14,
	            5: fa_z14,
	            6: fa_f2,
	            7: fa_a15
	        },
	        603: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        604: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        605: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        606: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        607: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        257: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        307: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        696: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        333: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        341: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        427: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        536: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        905: {
	            1: fa_u7,
	            2: fa_v7,
	            3: fa_w7,
	            4: fa_x7
	        },
	        320: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        514: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        516: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        305: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        315: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        523: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        299: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        309: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        697: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        298: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        308: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        515: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        549: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        548: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        550: {
	            1: fa_b15,
	            2: fa_b2
	        },
	        551: {
	            1: fa_a2,
	            2: fa_c15
	        },
	        455: {
	            1: fa_b10,
	            2: fa_c10
	        },
	        456: {
	            1: fa_b10,
	            2: fa_c10
	        },
	        457: {
	            1: fa_b10,
	            2: fa_c10
	        },
	        458: {
	            1: fa_b10,
	            2: fa_c10
	        },
	        459: {
	            1: fa_b10,
	            2: fa_c10
	        },
	        460: {
	            1: fa_b10,
	            2: fa_c10
	        },
	        512: {
	            1: fa_b15,
	            2: fa_b2
	        },
	        513: {
	            1: fa_a2,
	            2: fa_c15
	        },
	        901: {
	            1: fa_u13,
	            2: fa_v13,
	            3: fa_w13,
	            4: fa_x13,
	            5: fa_y13,
	            6: fa_z13,
	            7: fa_a14,
	            8: fa_b14
	        },
	        902: {
	            1: fa_u13,
	            2: fa_v13,
	            3: fa_w13,
	            4: fa_x13,
	            5: fa_y13,
	            6: fa_z13,
	            7: fa_a14,
	            8: fa_b14
	        },
	        340: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        328: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        329: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        342: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        330: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        331: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        722: {
	            1: fa_w12,
	            2: fa_d15,
	            3: fa_x12
	        },
	        560: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        543: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        544: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        545: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        546: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        332: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        559: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        296: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        297: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        717: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        718: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        719: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        720: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        721: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        552: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        76: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        77: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        78: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        79: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        80: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        647: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        741: {
	            1: fa_e15,
	            2: fa_f15,
	            3: fa_g15
	        },
	        82: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        338: {
	            1: fa_d1,
	            2: fa_e1
	        }
	    },
	    17: {
	        348: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    },
	    4: {
	        73: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        318: {
	            1: fa_d1,
	            2: fa_p1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        24: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        25: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        199: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        352: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        764: {
	            1: fa_r1,
	            2: fa_t1,
	            3: fa_w1,
	            4: fa_x1,
	            5: fa_y1,
	            6: fa_z1
	        },
	        102: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        403: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        141: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        142: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        185: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        186: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        366: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        367: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        368: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        369: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        370: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        566: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        567: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        568: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        569: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        570: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        923: {
	            1: fa_v3,
	            2: fa_f7,
	            3: fa_g7,
	            4: fa_h7,
	            5: fa_i7,
	            6: fa_j7,
	            7: fa_k7,
	            8: fa_l7
	        },
	        924: {
	            1: fa_v3,
	            2: fa_f7,
	            3: fa_g7,
	            4: fa_h7,
	            5: fa_i7,
	            6: fa_j7,
	            7: fa_k7,
	            8: fa_l7
	        },
	        925: {
	            1: fa_v3,
	            2: fa_f7,
	            3: fa_g7,
	            4: fa_h7,
	            5: fa_i7,
	            6: fa_j7,
	            7: fa_k7,
	            8: fa_l7
	        },
	        926: {
	            1: fa_v3,
	            2: fa_f7,
	            3: fa_g7,
	            4: fa_h7,
	            5: fa_i7,
	            6: fa_j7,
	            7: fa_k7,
	            8: fa_l7
	        },
	        927: {
	            1: fa_v3,
	            2: fa_f7,
	            3: fa_g7,
	            4: fa_h7,
	            5: fa_i7,
	            6: fa_j7,
	            7: fa_k7,
	            8: fa_l7
	        },
	        929: {
	            1: fa_v3,
	            2: fa_m7,
	            3: fa_n7,
	            4: fa_o7,
	            5: fa_l7
	        },
	        930: {
	            1: fa_v3,
	            2: fa_m7,
	            3: fa_n7,
	            4: fa_o7,
	            5: fa_l7
	        },
	        931: {
	            1: fa_v3,
	            2: fa_m7,
	            3: fa_n7,
	            4: fa_o7,
	            5: fa_l7
	        },
	        932: {
	            1: fa_v3,
	            2: fa_m7,
	            3: fa_n7,
	            4: fa_o7,
	            5: fa_l7
	        },
	        933: {
	            1: fa_v3,
	            2: fa_m7,
	            3: fa_n7,
	            4: fa_o7,
	            5: fa_l7
	        },
	        845: {
	            1: fa_w1,
	            2: fa_t7,
	            3: fa_s7,
	            4: fa_k1
	        },
	        846: {
	            1: fa_w1,
	            2: fa_t7,
	            3: fa_s7,
	            4: fa_k1
	        },
	        847: {
	            1: fa_w1,
	            2: fa_t7,
	            3: fa_s7,
	            4: fa_k1
	        },
	        848: {
	            1: fa_w1,
	            2: fa_t7,
	            3: fa_s7,
	            4: fa_k1
	        },
	        849: {
	            1: fa_w1,
	            2: fa_t7,
	            3: fa_s7,
	            4: fa_k1
	        },
	        918: {
	            1: fa_w1,
	            2: fa_t7,
	            3: fa_s7,
	            4: fa_j1
	        },
	        919: {
	            1: fa_w1,
	            2: fa_t7,
	            3: fa_s7,
	            4: fa_j1
	        },
	        920: {
	            1: fa_w1,
	            2: fa_t7,
	            3: fa_s7,
	            4: fa_j1
	        },
	        921: {
	            1: fa_w1,
	            2: fa_t7,
	            3: fa_s7,
	            4: fa_j1
	        },
	        922: {
	            1: fa_w1,
	            2: fa_t7,
	            3: fa_s7,
	            4: fa_j1
	        },
	        83: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        84: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        85: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        86: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        87: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        905: {
	            1: fa_u7,
	            2: fa_v7,
	            3: fa_w7,
	            4: fa_x7
	        },
	        906: {
	            1: fa_u7,
	            2: fa_v7,
	            3: fa_w7,
	            4: fa_x7
	        },
	        907: {
	            1: fa_u7,
	            2: fa_v7,
	            3: fa_w7,
	            4: fa_x7
	        },
	        908: {
	            1: fa_u7,
	            2: fa_v7,
	            3: fa_w7,
	            4: fa_x7
	        },
	        909: {
	            1: fa_u7,
	            2: fa_v7,
	            3: fa_w7,
	            4: fa_x7
	        },
	        807: {
	            1: fa_w6,
	            2: fa_y6,
	            3: fa_c7,
	            4: fa_e7
	        },
	        319: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        320: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        912: {
	            1: fa_a8,
	            2: fa_b8,
	            3: fa_c8,
	            4: fa_d8,
	            5: fa_e8,
	            6: fa_f8
	        },
	        913: {
	            1: fa_a8,
	            2: fa_b8,
	            3: fa_c8,
	            4: fa_d8,
	            5: fa_e8,
	            6: fa_f8
	        },
	        914: {
	            1: fa_h15,
	            2: fa_b8,
	            3: fa_c8,
	            4: fa_d8,
	            5: fa_e8,
	            6: fa_f8
	        },
	        915: {
	            1: fa_a8,
	            2: fa_b8,
	            3: fa_c8,
	            4: fa_d8,
	            5: fa_e8,
	            6: fa_f8
	        },
	        916: {
	            1: fa_a8,
	            2: fa_b8,
	            3: fa_c8,
	            4: fa_d8,
	            5: fa_e8,
	            6: fa_f8
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        257: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        307: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        362: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        363: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        364: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        365: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        17: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        18: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        19: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        20: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        176: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        177: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        178: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        179: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        358: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        359: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        360: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        361: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        13: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        14: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        15: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        16: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        172: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        173: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        174: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        175: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        281: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        137: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        616: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        617: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        618: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        619: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        620: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        891: {
	            1: fa_h2,
	            2: fa_i2,
	            3: fa_j2,
	            4: fa_k2
	        },
	        26: {
	            1: fa_i15,
	            2: fa_j15
	        },
	        200: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        143: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        187: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        371: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        571: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        928: {
	            1: fa_v3,
	            2: fa_f7,
	            3: fa_g7,
	            4: fa_h7,
	            5: fa_i7,
	            6: fa_j7,
	            7: fa_k7,
	            8: fa_l7
	        },
	        934: {
	            1: fa_v3,
	            2: fa_k15,
	            3: fa_l15,
	            4: fa_m15,
	            5: fa_l7
	        },
	        88: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        910: {
	            1: fa_u7,
	            2: fa_v7,
	            3: fa_w7,
	            4: fa_x7
	        },
	        917: {
	            1: fa_a8,
	            2: fa_b8,
	            3: fa_n15,
	            4: fa_d8,
	            5: fa_e8,
	            6: fa_o15
	        },
	        936: {
	            1: fa_n2,
	            2: fa_o2,
	            3: fa_p2,
	            4: fa_q2,
	            5: fa_r2,
	            6: fa_s6
	        }
	    },
	    8: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2
	        },
	        698: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        674: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        675: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        676: {
	            1: fa_j1,
	            2: fa_c2,
	            3: fa_k1
	        },
	        103: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    },
	    27: {
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    },
	    28: {
	        403: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        615: {
	            1: fa_a2,
	            2: fa_b2
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        935: {
	            1: fa_q10,
	            2: fa_r10,
	            3: fa_e14,
	            4: fa_f14,
	            5: fa_g14,
	            6: fa_p15,
	            7: fa_o10,
	            8: fa_p10,
	            9: fa_h3,
	            10: fa_c14,
	            11: fa_t7,
	            12: fa_q15
	        },
	        612: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        613: {
	            1: fa_n1,
	            2: fa_o1
	        },
	        443: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        608: {
	            1: fa_n1,
	            2: fa_o1
	        }
	    }
	};
	
	var periodConfig = {
	    2: {
	        208: 'Матч аяқталды',
	        207: 'Жетінші партия',
	        206: 'Алтыншы партия',
	        205: 'Бесінші партия',
	        200: 'Матч әлі басталған жоқ',
	        203: 'Үшінші партия',
	        202: 'Екінші партия',
	        201: 'Бірінші партия',
	        204: 'Төртінші партия'
	    },
	    3: {
	        304: 'Матч аяқталды',
	        303: 'Үшінші сет',
	        302: 'Екінші сет',
	        301: 'Бірінші сет',
	        300: 'Матч әлі басталған жоқ'
	    },
	    4: {
	        406: 'Матч аяқталды',
	        403: 'Үшінші сет',
	        402: 'Екінші сет',
	        401: 'Бірінші сет',
	        400: 'Матч әлі басталған жоқ',
	        407: 'Алтын сет',
	        405: 'Бесінші сет',
	        404: 'Төртінші сет'
	    },
	    5: {
	        510: 'Оныншы раунд',
	        509: 'Тоғызыншы раунд',
	        508: 'Сегізінші раунд',
	        507: 'Жетінші раунд',
	        506: 'Алтыншы раунд',
	        505: 'Бесінші раунд',
	        513: 'Матч аяқталды',
	        503: 'Үшінші раунд',
	        500: 'Матч әлі басталған жоқ',
	        501: 'Бірінші раунд',
	        502: 'Екінші тур',
	        511: 'Он бірінші раунд',
	        512: 'Он екінші раунд',
	        504: 'Төртінші раунд'
	    },
	    6: {
	        600: 'Матч әлі басталған жоқ',
	        601: 'Бірінші сет',
	        602: 'Екінші сет',
	        603: 'Үшінші сет',
	        604: 'Төртінші сет',
	        605: 'Бесінші сет',
	        606: 'Матч аяқталды'
	    },
	    7: {
	        701: 'Бірінші тайм',
	        700: 'Матч әлі басталған жоқ',
	        703: 'Екінші тайм',
	        704: 'Негізгі уақыт аяқталды',
	        705: 'Бірінші қосымша уақыт',
	        702: 'Үзіліс',
	        707: 'Екінші қосымша уақыт',
	        708: 'Екінші қосымша уақыт аяқталады',
	        709: 'Пенальти',
	        710: 'Матч аяқталды',
	        706: 'Бірінші қосымша уақыт аяқталады'
	    },
	    8: {
	        808: 'Кідірту',
	        807: 'Төртінші ширек',
	        806: 'Кідірту',
	        805: 'Үшінші ширек',
	        804: 'Үзіліс',
	        809: 'Овертайм',
	        802: 'Кідірту',
	        801: 'Бірінші ширек',
	        800: 'Матч әлі басталған жоқ',
	        810: 'Матч аяқталды',
	        803: 'Екінші ширек'
	    },
	    9: {
	        903: 'Екінші тайм',
	        902: 'Үзіліс',
	        901: 'Бірінші тайм',
	        900: 'Матч әлі басталған жоқ',
	        904: 'Матч аяқталды'
	    },
	    12: {
	        1203: 'Екінші тайм',
	        1202: 'Үзіліс',
	        1201: 'Бірінші тайм',
	        1200: 'Матч әлі басталған жоқ',
	        1204: 'Матч аяқталды'
	    },
	    18: {
	        1808: 'Овертайм аяқталады',
	        1807: 'Овертайм',
	        1806: 'Негізгі уақыт аяқталды',
	        1805: 'Үшінші кезең',
	        1804: 'Екінші үзіліс',
	        1809: 'Пенальти',
	        1802: 'Бірінші үзіліс',
	        1801: 'Бірінші кезең',
	        1800: 'Матч әлі басталған жоқ',
	        1810: 'Матч аяқталды',
	        1803: 'Екінші кезең'
	    },
	    19: {
	        1904: 'Негізгі уақыт аяқталды',
	        1903: 'Екінші тайм',
	        1902: 'Үзіліс',
	        1901: 'Бірінші тайм',
	        1900: 'Матч әлі басталған жоқ',
	        1905: 'Матч аяқталды'
	    },
	    20: {
	        2016: 'Сегізінші атыс желісі',
	        2017: 'Матч аяқталды',
	        2000: 'Матч әлі басталған жоқ',
	        2001: 'Бірінші тур',
	        2002: 'Бірінші атыс сызығы',
	        2003: 'Екінші тур',
	        2004: 'Екінші атыс желісі',
	        2005: 'Үшінші тур',
	        2006: 'Үшінші атыс желісі',
	        2007: 'Төртінші тур',
	        2008: 'Төртінші атыс желісі',
	        2009: 'Бесінші тур',
	        2010: 'Бесінші атыс желісі',
	        2011: 'Алтыншы тур',
	        2012: 'Алтыншы атыс желісі',
	        2013: 'Жетінші тур',
	        2014: 'Жетінші атыс желісі',
	        2015: 'Сегізінші тур'
	    },
	    28: {
	        2801: 'Негізгі уақыт',
	        2802: 'Матч аяқталды',
	        2800: 'Матч әлі басталған жоқ'
	    },
	    29: {
	        2911: '6-шы партия',
	        2912: 'Үзіліс',
	        2913: '7-ші партия',
	        2914: 'Үзіліс',
	        2915: '8-ші партия',
	        2916: 'Үзіліс',
	        2917: '9-шы партия',
	        2918: 'Үзіліс',
	        2919: '10-шы партия',
	        2920: 'Үзіліс',
	        2921: '11-ші партия',
	        2964: 'Үзіліс',
	        2965: '33-ші партия',
	        2966: 'Үзіліс',
	        2967: '34-ші партия',
	        2968: 'Үзіліс',
	        2969: '35-ші партия',
	        2970: 'Үзіліс',
	        2971: '36-шы партия',
	        2972: 'Үзіліс',
	        2973: '37-ші партия',
	        2974: 'Матч аяқталды',
	        2943: '22-ші партия',
	        2944: 'Үзіліс',
	        2945: '23-ші партия',
	        2946: 'Үзіліс',
	        2947: '24-ші партия',
	        2948: 'Үзіліс',
	        2949: '25-ші партия',
	        2950: 'Үзіліс',
	        2951: '26-шы партия',
	        2952: 'Үзіліс',
	        2953: '27-ші партия',
	        2954: 'Үзіліс',
	        2955: '28-ші партия',
	        2956: 'Үзіліс',
	        2957: '29-шы партия',
	        2958: 'Үзіліс',
	        2959: '30-шы партия',
	        2960: 'Үзіліс',
	        2961: '31-ші партия',
	        2962: 'Үзіліс',
	        2963: '32-ші партия',
	        2922: 'Үзіліс',
	        2923: '12-ші партия',
	        2924: 'Үзіліс',
	        2925: '13-ші партия',
	        2926: 'Үзіліс',
	        2927: '14-ші партия',
	        2928: 'Үзіліс',
	        2929: '15-ші партия',
	        2930: 'Үзіліс',
	        2931: '16-шы партия',
	        2932: 'Үзіліс',
	        2933: '17-ші партия',
	        2934: 'Үзіліс',
	        2935: '18-ші партия',
	        2936: 'Үзіліс',
	        2937: '19-шы партия',
	        2938: 'Үзіліс',
	        2939: '20-шы партия',
	        2940: 'Үзіліс',
	        2941: '21-ші партия',
	        2942: 'Үзіліс',
	        2900: 'Матч әлі басталған жоқ',
	        2901: '1-ші партия',
	        2902: 'Үзіліс',
	        2903: '2-ші партия',
	        2904: 'Үзіліс',
	        2905: '3-ші партия',
	        2906: 'Үзіліс',
	        2907: '4-ші партия',
	        2908: 'Үзіліс',
	        2909: '5-ші партия',
	        2910: 'Үзіліс'
	    },
	    30: {
	        3008: 'Қосымша уақыт аяқталды',
	        3007: 'Овертайм',
	        3006: 'Негізгі уақыт аяқталды',
	        3005: 'Үшінші кезең',
	        3004: 'Екінші үзіліс',
	        3009: 'Буллеттер',
	        3002: 'Бірінші үзіліс',
	        3001: 'Бірінші кезең',
	        3000: 'Матч әлі басталған жоқ',
	        3010: 'Матч аяқталды',
	        3003: 'Екінші кезең'
	    },
	    31: {
	        3108: 'Кідірту',
	        3107: 'Төртінші ширек',
	        3106: 'Кідірту',
	        3105: 'Үшінші ширек',
	        3104: 'Үзіліс',
	        3109: 'Овертайм',
	        3102: 'Кідірту',
	        3101: 'Бірінші ширек',
	        3100: 'Матч әлі басталған жоқ',
	        3110: 'Матч аяқталды',
	        3103: 'Екінші ширек'
	    },
	    32: {
	        3203: 'Үшінші сет',
	        3202: 'Екінші сет',
	        3201: 'Бірінші сет',
	        3200: 'Матч әлі басталған жоқ',
	        3204: 'Матч аяқталды'
	    },
	    34: {
	        3400: 'Матч әлі басталған жоқ',
	        3401: 'Бірінші тайм',
	        3402: 'Үзіліс',
	        3403: 'Екінші тайм',
	        3404: 'Негізгі уақыт аяқталды',
	        3410: 'Матч аяқталды',
	        3406: 'Бірінші қосымша уақыт аяқталады',
	        3407: 'Екінші қосымша уақыт',
	        3408: 'Екінші қосымша уақыт аяқталады',
	        3409: 'Пенальти',
	        3405: 'Бірінші қосымша уақыт'
	    },
	    35: {
	        3500: 'Матч әлі басталған жоқ',
	        3501: 'Бірінші тайм',
	        3502: 'Үзіліс',
	        3503: 'Екінші тайм',
	        3504: 'Матч аяқталды'
	    },
	    36: {
	        3601: 'Бірінші кезең',
	        3602: 'Бірінші үзіліс',
	        3603: 'Екінші кезең',
	        3604: 'Екінші үзіліс',
	        3605: 'Үшінші кезең',
	        3600: 'Матч әлі басталған жоқ',
	        3607: 'Овертайм',
	        3608: 'Қосымша уақыт аяқталды',
	        3609: 'Буллеттер',
	        3610: 'Матч аяқталды',
	        3606: 'Негізгі уақыт аяқталды'
	    },
	    37: {
	        3701: 'Матч аяқталды',
	        3700: 'Матч әлі басталған жоқ'
	    },
	    38: {
	        3801: 'Матч аяқталды',
	        3800: 'Матч әлі басталған жоқ'
	    },
	    39: {
	        3901: 'Матч аяқталды',
	        3900: 'Матч әлі басталған жоқ',
	        3902: 'Бірінші раунд',
	        3903: 'Екінші тур',
	        3904: 'Үшінші раунд',
	        3905: 'Төртінші раунд',
	        3906: 'Бесінші раунд'
	    },
	    40: {
	        4001: 'Матч аяқталды',
	        4000: 'Матч әлі басталған жоқ'
	    },
	    41: {
	        4102: 'Бірінші үзіліс',
	        4106: 'Матч аяқталды',
	        4105: 'Овертайм',
	        4104: 'Екінші үзіліс',
	        4103: 'Екінші жартылық',
	        4101: 'Бірінші жартылық',
	        4100: 'Матч әлі басталған жоқ'
	    },
	    42: {
	        4202: 'Екінші карта',
	        4206: 'Матч аяқталды',
	        4205: 'Бесінші карта',
	        4204: 'Төртінші карта',
	        4203: 'Үшінші карта',
	        4201: 'Бірінші карта',
	        4200: 'Матч әлі басталған жоқ'
	    }
	};
	
	function getGroupName(sportId, groupType) {
	    if (groupConfig !== undefined && groupConfig[sportId] !== undefined) {
	        return groupConfig[sportId][groupType];
	    }
	
	    return undefined;
	}
	
	function getSlotName(sportId, match, slot) {
	    var func = void 0;
	
	    if (slotConfig !== undefined && slotConfig[sportId] !== undefined) {
	        func = slotConfig[sportId][slot.type];
	    }
	
	    if (func === undefined) {
	        return undefined;
	    }
	
	    return func(match, slot);
	}
	
	function getOutcomeName(sportId, outcome, match) {
	    var func = void 0;
	
	    if (baseOutcomeConfig !== undefined && baseOutcomeConfig[sportId] !== undefined && baseOutcomeConfig[sportId]) {
	        func = baseOutcomeConfig[sportId][outcome.type];
	    }
	
	    if (outcomeConfig !== undefined && outcomeConfig[sportId] !== undefined && outcomeConfig[sportId][outcome.type] !== undefined) {
	        func = outcomeConfig[sportId][outcome.type];
	    }
	
	    if (func === undefined) {
	        return undefined;
	    }
	
	    return func(match, outcome);
	}
	
	function getRateName(sportId, outcome, factorType, match) {
	    var func = void 0;
	
	    if (baseFactorNameConfig !== undefined && baseFactorNameConfig[sportId] !== undefined && baseFactorNameConfig[sportId][outcome.type] !== undefined) {
	        func = baseFactorNameConfig[sportId][outcome.type][factorType];
	    }
	
	    if (func === undefined) {
	        return undefined;
	    }
	
	    return func(match, outcome);
	}
	
	function getMatchInfoText(matchInfoType) {
	    switch (matchInfoType) {
	        case 1:
	            return "Матч басталған жоқ";
	        case 2:
	            return "Матч аяқталды";
	        case 3:
	            return "Үзіліс";
	        case 4:
	            return "Негізгі уақыт аяқталды";
	        case 5:
	            return "Бірінші қосымша тайм аяқталды";
	        case 6:
	            return "Пенальти сериясы";
	    }
	
	    return "";
	}
	
	function getPeriodName(sportId, periodId) {
	    if (periodConfig !== undefined && periodConfig[sportId] !== undefined) {
	        return periodConfig[sportId][periodId];
	    }
	
	    return undefined;
	}
	
	function getFoulsText() {
	    return "Фолдар";
	}
	
	function getTimeoutText() {
	    return "Үзіліс";
	}

/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _parseFloat = __webpack_require__(510);
	
	var _parseFloat2 = _interopRequireDefault(_parseFloat);
	
	exports.getGroupName = getGroupName;
	exports.getSlotName = getSlotName;
	exports.getOutcomeName = getOutcomeName;
	exports.getRateName = getRateName;
	exports.getMatchInfoText = getMatchInfoText;
	exports.getPeriodName = getPeriodName;
	exports.getFoulsText = getFoulsText;
	exports.getTimeoutText = getTimeoutText;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function numeralFemaleEnding(condition) {
	    var val = condition % 10;
	
	    return val === 3 && condition !== 13 ? condition + "-ью" : condition + "-ую";
	}
	
	function numeralMaleEnding(condition) {
	    var val = condition % 10;
	
	    if (condition >= 10 && condition <= 20 || val === 0 && condition !== 0 && condition % 100 !== 40 || val === 1 || val === 4 || val === 5 || val === 9) {
	        return condition + "-ый";
	    }
	
	    return val === 3 ? condition + "-ий" : condition + "-ой";
	}
	
	function numeralNeuterEnding(condition) {
	    var val = condition % 10;
	    return val === 3 && condition !== 13 ? condition + "-ье" : condition + "-ое";
	}
	
	function plural(count, parameters) {
	    var m10 = count % 10;
	    var m100 = count % 100;
	
	    if (m10 === 1 && m100 !== 11) {
	        return parameters[0];
	    }
	
	    if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) {
	        return parameters[1];
	    }
	
	    return parameters[2];
	}
	
	function signed(condition) {
	    if (condition === 0) {
	        return '0';
	    }
	
	    var num = (0, _parseFloat2.default)(condition.toFixed(2));
	
	    if (condition > 0) {
	        return '+' + num.toString();
	    }
	
	    return num.toString();
	}
	
	function europeanHandicapCondition(condition) {
	    if (condition < 0) {
	        return "0:" + Math.abs(condition);
	    } else {
	        return Math.abs(condition) + ":0";
	    }
	}
	
	var sl_b1 = function sl_b1(match, outcome) {
	    return 'Результат';
	};
	var sl_c1 = function sl_c1(match, outcome) {
	    return 'Фора';
	};
	var sl_d1 = function sl_d1(match, outcome) {
	    return 'Тотал';
	};
	var sl_e1 = function sl_e1(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']);
	};
	var sl_f1 = function sl_f1(match, outcome) {
	    return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 " + numeralNeuterEnding(outcome.condition) + " \u043E\u0447\u043A\u043E";
	};
	var sl_g1 = function sl_g1(match, outcome) {
	    return match.homeTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']);
	};
	var sl_h1 = function sl_h1(match, outcome) {
	    return match.awayTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']);
	};
	var sl_i1 = function sl_i1(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam;
	};
	var sl_j1 = function sl_j1(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam;
	};
	var sl_k1 = function sl_k1(match, outcome) {
	    return 'Победа';
	};
	var sl_l1 = function sl_l1(match, outcome) {
	    return 'Точный тотал';
	};
	var sl_m1 = function sl_m1(match, outcome) {
	    return match.homeTeam + " \u041F\u043E\u0431\u0435\u0434\u0430 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439";
	};
	var sl_n1 = function sl_n1(match, outcome) {
	    return match.awayTeam + " \u041F\u043E\u0431\u0435\u0434\u0430 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439";
	};
	var sl_o1 = function sl_o1(match, outcome) {
	    return 'Разница очков';
	};
	var sl_p1 = function sl_p1(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam;
	};
	var sl_q1 = function sl_q1(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam;
	};
	var sl_r1 = function sl_r1(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']);
	};
	var sl_s1 = function sl_s1(match, outcome) {
	    return 'Первый в матче';
	};
	var sl_t1 = function sl_t1(match, outcome) {
	    return 'Победа с разницей';
	};
	var sl_u1 = function sl_u1(match, outcome) {
	    return 'Сколько команд забьет?';
	};
	var sl_v1 = function sl_v1(match, outcome) {
	    return 'Точный счет';
	};
	var sl_w1 = function sl_w1(match, outcome) {
	    return "\u041F\u043E\u0431\u0435\u0434\u0430 \u0438 \u0442\u043E\u0442\u0430\u043B " + outcome.condition;
	};
	var sl_x1 = function sl_x1(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']);
	};
	var sl_y1 = function sl_y1(match, outcome) {
	    return 'Чет/Нечет';
	};
	var sl_z1 = function sl_z1(match, outcome) {
	    return match.homeTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439";
	};
	var sl_a2 = function sl_a2(match, outcome) {
	    return match.awayTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439";
	};
	var sl_b2 = function sl_b2(match, outcome) {
	    return match.homeTeam + " \u0422\u043E\u0447\u043D\u044B\u0439 \u0442\u043E\u0442\u0430\u043B";
	};
	var sl_c2 = function sl_c2(match, outcome) {
	    return match.awayTeam + " \u0422\u043E\u0447\u043D\u044B\u0439 \u0442\u043E\u0442\u0430\u043B";
	};
	var sl_d2 = function sl_d2(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['убийство', 'убийства', 'убийств']);
	};
	var sl_e2 = function sl_e2(match, outcome) {
	    return 'First Blood';
	};
	var sl_f2 = function sl_f2(match, outcome) {
	    return "\u0417\u0430\u0431\u044C\u0435\u0442 \u043B\u0438 " + match.homeTeam + "?";
	};
	var sl_g2 = function sl_g2(match, outcome) {
	    return "\u0417\u0430\u0431\u044C\u0435\u0442 \u043B\u0438 " + match.awayTeam + "?";
	};
	var sl_h2 = function sl_h2(match, outcome) {
	    return 'Сколько команд забьёт';
	};
	var sl_i2 = function sl_i2(match, outcome) {
	    return "\u0421\u043A\u043E\u043B\u044C\u043A\u043E \u0433\u043E\u043B\u043E\u0432 \u0437\u0430\u0431\u044C\u0435\u0442 " + match.homeTeam + "?";
	};
	var sl_j2 = function sl_j2(match, outcome) {
	    return "\u0421\u043A\u043E\u043B\u044C\u043A\u043E \u0433\u043E\u043B\u043E\u0432 \u0437\u0430\u0431\u044C\u0435\u0442 " + match.awayTeam + "?";
	};
	var sl_k2 = function sl_k2(match, outcome) {
	    return 'Компенсированное время';
	};
	var sl_l2 = function sl_l2(match, outcome) {
	    return "\u0415\u0432\u0440\u043E\u043F\u0435\u0439\u0441\u043A\u0430\u044F \u0444\u043E\u0440\u0430 " + europeanHandicapCondition(outcome.condition);
	};
	var sl_m2 = function sl_m2(match, outcome) {
	    return "\u041A\u0442\u043E \u0437\u0430\u0431\u044C\u0435\u0442 " + numeralMaleEnding(outcome.condition) + " \u0433\u043E\u043B?";
	};
	var sl_n2 = function sl_n2(match, outcome) {
	    return "\u041E\u0441\u0442\u0430\u0442\u043E\u043A (\u0442\u0435\u043A\u0443\u0449\u0438\u0439 \u0441\u0447\u0435\u0442 " + outcome.condition + ":" + outcome.conditionTwo + ")";
	};
	var sl_o2 = function sl_o2(match, outcome) {
	    return 'Двойной исход';
	};
	var sl_p2 = function sl_p2(match, outcome) {
	    return 'С каждого флажка';
	};
	var sl_q2 = function sl_q2(match, outcome) {
	    return 'Результат матча';
	};
	var sl_r2 = function sl_r2(match, outcome) {
	    return 'За симуляцию';
	};
	var sl_s2 = function sl_s2(match, outcome) {
	    return 'За снятую футболку';
	};
	var sl_t2 = function sl_t2(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u0437\u0430\u0431\u0438\u0442\u044B\u0445 \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438: " + match.awayTeam;
	};
	var sl_u2 = function sl_u2(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u0437\u0430\u0431\u0438\u0442\u044B\u0445 \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438: " + match.homeTeam;
	};
	var sl_v2 = function sl_v2(match, outcome) {
	    return 'Тотал забитых пенальти';
	};
	var sl_w2 = function sl_w2(match, outcome) {
	    return 'Тотал незабитых пенальти';
	};
	var sl_x2 = function sl_x2(match, outcome) {
	    return "\u041F\u043E\u0431\u0435\u0434\u0430 " + match.homeTeam + " \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439";
	};
	var sl_y2 = function sl_y2(match, outcome) {
	    return "\u041F\u043E\u0431\u0435\u0434\u0430 " + match.awayTeam + " \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439";
	};
	var sl_z2 = function sl_z2(match, outcome) {
	    return 'Кто первым(ой) забьет шар?';
	};
	var sl_a3 = function sl_a3(match, outcome) {
	    return 'Какой цветной шар будет забит первым?';
	};
	var sl_b3 = function sl_b3(match, outcome) {
	    return 'Чет/Нечет тотала';
	};
	var sl_c3 = function sl_c3(match, outcome) {
	    return "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 \u0432 " + outcome.condition + " \u0433\u0435\u0439\u043C\u0435?";
	};
	var sl_d3 = function sl_d3(match, outcome) {
	    return 'Тотал брейков';
	};
	var sl_e3 = function sl_e3(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u0432\u043E\u0437\u044C\u043C\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['гейм', 'гейма', 'геймов']);
	};
	var sl_f3 = function sl_f3(match, outcome) {
	    return 'Будет ли тай-брейк?';
	};
	var sl_g3 = function sl_g3(match, outcome) {
	    return 'Кто победит в тай-брейке?';
	};
	var sl_h3 = function sl_h3(match, outcome) {
	    return 'Точный тотал тай-брейка';
	};
	var sl_i3 = function sl_i3(match, outcome) {
	    return 'Точный счет тай-брейка';
	};
	var sl_j3 = function sl_j3(match, outcome) {
	    return 'Тотал тай-брейка';
	};
	var sl_k3 = function sl_k3(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: " + match.homeTeam;
	};
	var sl_l3 = function sl_l3(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: " + match.awayTeam;
	};
	var sl_m3 = function sl_m3(match, outcome) {
	    return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 \u043A\u0442\u043E-\u043D\u0438\u0431\u0443\u0434\u044C \u043F\u043E\u0434\u0440\u044F\u0434 " + outcome.condition + " " + plural(outcome.condition, ['гейм', 'гейма', 'геймов']) + "?";
	};
	var sl_n3 = function sl_n3(match, outcome) {
	    return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 " + match.homeTeam + " \u043F\u043E\u0434\u0440\u044F\u0434 " + outcome.condition + " " + plural(outcome.condition, ['гейм', 'гейма', 'геймов']) + "?";
	};
	var sl_o3 = function sl_o3(match, outcome) {
	    return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 " + match.awayTeam + " \u043F\u043E\u0434\u0440\u044F\u0434 " + outcome.condition + " " + plural(outcome.condition, ['гейм', 'гейма', 'геймов']) + "?";
	};
	var sl_p3 = function sl_p3(match, outcome) {
	    return 'Результат по брейкам';
	};
	var sl_q3 = function sl_q3(match, outcome) {
	    return 'Фора по брейкам';
	};
	var sl_r3 = function sl_r3(match, outcome) {
	    return "\u041F\u043E\u0431\u0435\u0434\u0430 \u0438 \u0442\u043E\u0442\u0430\u043B" + outcome.condition;
	};
	
	var bo_b1 = function bo_b1(match, outcome) {
	    return 'Фора';
	};
	var bo_c1 = function bo_c1(match, outcome) {
	    return 'Тотал матча';
	};
	var bo_d1 = function bo_d1(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam;
	};
	var bo_e1 = function bo_e1(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam;
	};
	var bo_f1 = function bo_f1(match, outcome) {
	    return 'Чет/Нечет тотала матча';
	};
	var bo_g1 = function bo_g1(match, outcome) {
	    return match.homeTeam + " - " + match.awayTeam;
	};
	var bo_h1 = function bo_h1(match, outcome) {
	    return outcome.teamOne + " - " + outcome.teamTwo;
	};
	var bo_i1 = function bo_i1(match, outcome) {
	    return "" + outcome.teamOne;
	};
	var bo_j1 = function bo_j1(match, outcome) {
	    return 'Фора в первом сете';
	};
	var bo_k1 = function bo_k1(match, outcome) {
	    return 'Фора во втором сете';
	};
	var bo_l1 = function bo_l1(match, outcome) {
	    return 'Фора в третьем сете';
	};
	var bo_m1 = function bo_m1(match, outcome) {
	    return 'Тотал первого сета';
	};
	var bo_n1 = function bo_n1(match, outcome) {
	    return 'Тотал второго сета';
	};
	var bo_o1 = function bo_o1(match, outcome) {
	    return 'Тотал третьего сета';
	};
	var bo_p1 = function bo_p1(match, outcome) {
	    return 'Тотал сетов в матче';
	};
	var bo_q1 = function bo_q1(match, outcome) {
	    return 'Счет матча';
	};
	var bo_r1 = function bo_r1(match, outcome) {
	    return 'Результат первого сета';
	};
	var bo_s1 = function bo_s1(match, outcome) {
	    return 'Результат второго сета';
	};
	var bo_t1 = function bo_t1(match, outcome) {
	    return 'Результат третьего сета';
	};
	var bo_u1 = function bo_u1(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_v1 = function bo_v1(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_w1 = function bo_w1(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_x1 = function bo_x1(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_y1 = function bo_y1(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_z1 = function bo_z1(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_a2 = function bo_a2(match, outcome) {
	    return match.homeTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_b2 = function bo_b2(match, outcome) {
	    return match.homeTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_c2 = function bo_c2(match, outcome) {
	    return match.homeTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_d2 = function bo_d2(match, outcome) {
	    return match.awayTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_e2 = function bo_e2(match, outcome) {
	    return match.awayTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_f2 = function bo_f2(match, outcome) {
	    return match.awayTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_g2 = function bo_g2(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 1\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_h2 = function bo_h2(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432\u043E 2\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_i2 = function bo_i2(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 3\u0435\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_j2 = function bo_j2(match, outcome) {
	    return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 " + numeralNeuterEnding(outcome.condition) + " \u043E\u0447\u043A\u043E \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_k2 = function bo_k2(match, outcome) {
	    return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 " + numeralNeuterEnding(outcome.condition) + " \u043E\u0447\u043A\u043E \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_l2 = function bo_l2(match, outcome) {
	    return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 " + numeralNeuterEnding(outcome.condition) + " \u043E\u0447\u043A\u043E \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_m2 = function bo_m2(match, outcome) {
	    return 'Победа в минисете до 10 очков первого сета';
	};
	var bo_n2 = function bo_n2(match, outcome) {
	    return 'Победа в минисете до 10 очков второго сета';
	};
	var bo_o2 = function bo_o2(match, outcome) {
	    return 'Победа в минисете до 10 очков третьего сета';
	};
	var bo_p2 = function bo_p2(match, outcome) {
	    return 'Фора в минисете до 10 очков первого сета';
	};
	var bo_q2 = function bo_q2(match, outcome) {
	    return 'Фора в минисете до 10 очков второго сета';
	};
	var bo_r2 = function bo_r2(match, outcome) {
	    return 'Фора в минисете до 10 очков третьего сета';
	};
	var bo_s2 = function bo_s2(match, outcome) {
	    return 'Тотал в минисете до 10 очков первого сета';
	};
	var bo_t2 = function bo_t2(match, outcome) {
	    return 'Тотал в минисете до 10 очков второго сета';
	};
	var bo_u2 = function bo_u2(match, outcome) {
	    return 'Тотал в минисете до 10 очков третьего сета';
	};
	var bo_v2 = function bo_v2(match, outcome) {
	    return 'Победа в минисете до 15 очков первого сета';
	};
	var bo_w2 = function bo_w2(match, outcome) {
	    return 'Победа в минисете до 15 очков второго сета';
	};
	var bo_x2 = function bo_x2(match, outcome) {
	    return 'Победа в минисете до 15 очков третьего сета';
	};
	var bo_y2 = function bo_y2(match, outcome) {
	    return 'Фора в минисете до 15 очков первого сета';
	};
	var bo_z2 = function bo_z2(match, outcome) {
	    return 'Фора в минисете до 15 очков второго сета';
	};
	var bo_a3 = function bo_a3(match, outcome) {
	    return 'Фора в минисете до 15 очков третьего сета';
	};
	var bo_b3 = function bo_b3(match, outcome) {
	    return 'Тотал в минисете до 15 очков первого сета';
	};
	var bo_c3 = function bo_c3(match, outcome) {
	    return 'Тотал в минисете до 15 очков второго сета';
	};
	var bo_d3 = function bo_d3(match, outcome) {
	    return 'Тотал в минисете до 15 очков третьего сета';
	};
	var bo_e3 = function bo_e3(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0442\u0430\u0439\u043C\u0435";
	};
	var bo_f3 = function bo_f3(match, outcome) {
	    return 'Фора в первом тайме';
	};
	var bo_g3 = function bo_g3(match, outcome) {
	    return 'Результат первого тайма';
	};
	var bo_h3 = function bo_h3(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0442\u0430\u0439\u043C\u0435";
	};
	var bo_i3 = function bo_i3(match, outcome) {
	    return "\u041A\u0442\u043E \u0437\u0430\u0431\u044C\u0435\u0442 " + numeralMaleEnding(outcome.condition) + " \u0433\u043E\u043B?";
	};
	var bo_j3 = function bo_j3(match, outcome) {
	    return 'Двойной исход';
	};
	var bo_k3 = function bo_k3(match, outcome) {
	    return 'Тотал первого тайма';
	};
	var bo_l3 = function bo_l3(match, outcome) {
	    return "\u041F\u043E\u0431\u0435\u0434\u0430 \u0438 \u0442\u043E\u0442\u0430\u043B \u043C\u0430\u0442\u0447\u0430 " + outcome.condition;
	};
	var bo_m3 = function bo_m3(match, outcome) {
	    return match.homeTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['гол', 'гола', 'голов']);
	};
	var bo_n3 = function bo_n3(match, outcome) {
	    return match.awayTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['гол', 'гола', 'голов']);
	};
	var bo_o3 = function bo_o3(match, outcome) {
	    return 'Точный тотал матча';
	};
	var bo_p3 = function bo_p3(match, outcome) {
	    return 'Сколько команд забьёт';
	};
	var bo_q3 = function bo_q3(match, outcome) {
	    return 'Точный счет';
	};
	var bo_r3 = function bo_r3(match, outcome) {
	    return 'Азиатская фора';
	};
	var bo_s3 = function bo_s3(match, outcome) {
	    return 'Фора в первой четверти';
	};
	var bo_t3 = function bo_t3(match, outcome) {
	    return 'Фора во второй четверти';
	};
	var bo_u3 = function bo_u3(match, outcome) {
	    return 'Фора в третьей четверти';
	};
	var bo_v3 = function bo_v3(match, outcome) {
	    return 'Фора в четвертой четверти';
	};
	var bo_w3 = function bo_w3(match, outcome) {
	    return 'Тотал первой четверти';
	};
	var bo_x3 = function bo_x3(match, outcome) {
	    return 'Тотал второй четверти';
	};
	var bo_y3 = function bo_y3(match, outcome) {
	    return 'Тотал третьей четверти';
	};
	var bo_z3 = function bo_z3(match, outcome) {
	    return 'Тотал четвертой четверти';
	};
	var bo_a4 = function bo_a4(match, outcome) {
	    return 'Результат первой четверти';
	};
	var bo_b4 = function bo_b4(match, outcome) {
	    return 'Результат второй четверти';
	};
	var bo_c4 = function bo_c4(match, outcome) {
	    return 'Результат третьей четверти';
	};
	var bo_d4 = function bo_d4(match, outcome) {
	    return 'Результат четвертой четверти';
	};
	var bo_e4 = function bo_e4(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0432 \u043F\u0435\u0440\u0432\u043E\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438";
	};
	var bo_f4 = function bo_f4(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438";
	};
	var bo_g4 = function bo_g4(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438";
	};
	var bo_h4 = function bo_h4(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438";
	};
	var bo_i4 = function bo_i4(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0432 \u043F\u0435\u0440\u0432\u043E\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438";
	};
	var bo_j4 = function bo_j4(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438";
	};
	var bo_k4 = function bo_k4(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438";
	};
	var bo_l4 = function bo_l4(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438";
	};
	var bo_m4 = function bo_m4(match, outcome) {
	    return 'Тотал первой половины';
	};
	var bo_n4 = function bo_n4(match, outcome) {
	    return 'Результат во второй половине';
	};
	var bo_o4 = function bo_o4(match, outcome) {
	    return 'Тотал второй половины';
	};
	var bo_p4 = function bo_p4(match, outcome) {
	    return 'Фора в первой половине';
	};
	var bo_q4 = function bo_q4(match, outcome) {
	    return 'Фора во второй половине';
	};
	var bo_r4 = function bo_r4(match, outcome) {
	    return 'Результат в первой половине';
	};
	var bo_s4 = function bo_s4(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0432 \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0435";
	};
	var bo_t4 = function bo_t4(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u0439 \u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0435";
	};
	var bo_u4 = function bo_u4(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0432 \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0435";
	};
	var bo_v4 = function bo_v4(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u0439 \u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0435";
	};
	var bo_w4 = function bo_w4(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 1\u043E\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438";
	};
	var bo_x4 = function bo_x4(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432\u043E 2\u043E\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438";
	};
	var bo_y4 = function bo_y4(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 3\u0435\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438";
	};
	var bo_z4 = function bo_z4(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 4\u043E\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438";
	};
	var bo_a5 = function bo_a5(match, outcome) {
	    return 'Точный тотал первой четверти';
	};
	var bo_b5 = function bo_b5(match, outcome) {
	    return 'Точный тотал второй четверти';
	};
	var bo_c5 = function bo_c5(match, outcome) {
	    return 'Точный тотал третьей четверти';
	};
	var bo_d5 = function bo_d5(match, outcome) {
	    return 'Точный тотал четвертой четверти';
	};
	var bo_e5 = function bo_e5(match, outcome) {
	    return match.homeTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439";
	};
	var bo_f5 = function bo_f5(match, outcome) {
	    return match.awayTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439";
	};
	var bo_g5 = function bo_g5(match, outcome) {
	    return 'Проход';
	};
	var bo_h5 = function bo_h5(match, outcome) {
	    return match.homeTeam + " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u0432\u0441\u0435 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438";
	};
	var bo_i5 = function bo_i5(match, outcome) {
	    return match.awayTeam + " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u0432\u0441\u0435 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438";
	};
	var bo_j5 = function bo_j5(match, outcome) {
	    return match.homeTeam + " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043E\u0431\u0435 \u043F\u043E\u043B\u043E\u0432\u0438\u043D\u044B";
	};
	var bo_k5 = function bo_k5(match, outcome) {
	    return match.awayTeam + " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043E\u0431\u0435 \u043F\u043E\u043B\u043E\u0432\u0438\u043D\u044B";
	};
	var bo_l5 = function bo_l5(match, outcome) {
	    return 'Самая результативная половина';
	};
	var bo_m5 = function bo_m5(match, outcome) {
	    return 'Самая результативная четверть';
	};
	var bo_n5 = function bo_n5(match, outcome) {
	    return 'Тотал самой результативной четверти';
	};
	var bo_o5 = function bo_o5(match, outcome) {
	    return 'Тотал самой нерезультативной четверти';
	};
	var bo_p5 = function bo_p5(match, outcome) {
	    return match.homeTeam + " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043F\u0435\u0440\u0432\u0443\u044E \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u044C \u0438 \u043C\u0430\u0442\u0447";
	};
	var bo_q5 = function bo_q5(match, outcome) {
	    return match.awayTeam + " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043F\u0435\u0440\u0432\u0443\u044E \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u044C \u0438 \u043C\u0430\u0442\u0447";
	};
	var bo_r5 = function bo_r5(match, outcome) {
	    return match.homeTeam + " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043F\u0435\u0440\u0432\u0443\u044E \u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0443 \u0438 \u043C\u0430\u0442\u0447";
	};
	var bo_s5 = function bo_s5(match, outcome) {
	    return match.awayTeam + " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043F\u0435\u0440\u0432\u0443\u044E \u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0443 \u0438 \u043C\u0430\u0442\u0447";
	};
	var bo_t5 = function bo_t5(match, outcome) {
	    return 'Будет ли овертайм';
	};
	var bo_u5 = function bo_u5(match, outcome) {
	    return 'Победа с разницей';
	};
	var bo_v5 = function bo_v5(match, outcome) {
	    return 'Победа с разницей в первой четверти';
	};
	var bo_w5 = function bo_w5(match, outcome) {
	    return 'Победа с разницей во второй четверти';
	};
	var bo_x5 = function bo_x5(match, outcome) {
	    return 'Победа с разницей в третьей четверти';
	};
	var bo_y5 = function bo_y5(match, outcome) {
	    return 'Победа с разницей в четвертой четверти';
	};
	var bo_z5 = function bo_z5(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + outcome.playerName + " (" + match.homeTeam + ")";
	};
	var bo_a6 = function bo_a6(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + outcome.playerName + " (" + match.awayTeam + ")";
	};
	var bo_b6 = function bo_b6(match, outcome) {
	    return 'Тотал: 3-очковые броски';
	};
	var bo_c6 = function bo_c6(match, outcome) {
	    return 'Тотал: 2-очковые броски';
	};
	var bo_d6 = function bo_d6(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " 3-\u043E\u0447\u043A\u043E\u0432\u044B\u0435 \u0431\u0440\u043E\u0441\u043A\u0438";
	};
	var bo_e6 = function bo_e6(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " 3-\u043E\u0447\u043A\u043E\u0432\u044B\u0435 \u0431\u0440\u043E\u0441\u043A\u0438";
	};
	var bo_f6 = function bo_f6(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " 2-\u043E\u0447\u043A\u043E\u0432\u044B\u0435 \u0431\u0440\u043E\u0441\u043A\u0438";
	};
	var bo_g6 = function bo_g6(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " 2-\u043E\u0447\u043A\u043E\u0432\u044B\u0435 \u0431\u0440\u043E\u0441\u043A\u0438";
	};
	var bo_h6 = function bo_h6(match, outcome) {
	    return 'Фора 3-очковых бросков';
	};
	var bo_i6 = function bo_i6(match, outcome) {
	    return 'Фора 2-очковых бросков';
	};
	var bo_j6 = function bo_j6(match, outcome) {
	    return 'Результат по 3-очковым броскам';
	};
	var bo_k6 = function bo_k6(match, outcome) {
	    return 'Результат по 2-очковым броскам';
	};
	var bo_l6 = function bo_l6(match, outcome) {
	    return 'Самая НЕ результативная четверть';
	};
	var bo_m6 = function bo_m6(match, outcome) {
	    return 'Тотал передач в матче';
	};
	var bo_n6 = function bo_n6(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u043F\u0435\u0440\u0435\u0434\u0430\u0447 " + match.homeTeam + " \u0432 \u043C\u0430\u0442\u0447\u0435";
	};
	var bo_o6 = function bo_o6(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u043F\u0435\u0440\u0435\u0434\u0430\u0447 " + match.awayTeam + " \u0432 \u043C\u0430\u0442\u0447\u0435";
	};
	var bo_p6 = function bo_p6(match, outcome) {
	    return 'Фора по передачам в матче';
	};
	var bo_q6 = function bo_q6(match, outcome) {
	    return 'Победа по передачам в матче';
	};
	var bo_r6 = function bo_r6(match, outcome) {
	    return 'Первый 2-очковый бросок в матче';
	};
	var bo_s6 = function bo_s6(match, outcome) {
	    return 'Первый 3-очковый бросок в матче';
	};
	var bo_t6 = function bo_t6(match, outcome) {
	    return 'Первый штрафной бросок в матче';
	};
	var bo_u6 = function bo_u6(match, outcome) {
	    return 'Что будет раньше';
	};
	var bo_v6 = function bo_v6(match, outcome) {
	    return 'Наибольшее количество очков в четверти';
	};
	var bo_w6 = function bo_w6(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u043C\u0430\u0442\u0447\u0435";
	};
	var bo_x6 = function bo_x6(match, outcome) {
	    return 'Тотал трипл-даблов в матче';
	};
	var bo_y6 = function bo_y6(match, outcome) {
	    return 'Тотал дабл-даблов в матче';
	};
	var bo_z6 = function bo_z6(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u043F\u0435\u0440\u0432\u043E\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438";
	};
	var bo_a7 = function bo_a7(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438";
	};
	var bo_b7 = function bo_b7(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438";
	};
	var bo_c7 = function bo_c7(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438";
	};
	var bo_d7 = function bo_d7(match, outcome) {
	    return 'Разница очков в матче';
	};
	var bo_e7 = function bo_e7(match, outcome) {
	    return 'Разница очков в первой четверти';
	};
	var bo_f7 = function bo_f7(match, outcome) {
	    return 'Разница очков во второй четверти';
	};
	var bo_g7 = function bo_g7(match, outcome) {
	    return 'Разница очков в третьей четверти';
	};
	var bo_h7 = function bo_h7(match, outcome) {
	    return 'Разница очков в четвертой четверти';
	};
	var bo_i7 = function bo_i7(match, outcome) {
	    return 'Результат первой половины';
	};
	var bo_j7 = function bo_j7(match, outcome) {
	    return 'Результат второй половины';
	};
	var bo_k7 = function bo_k7(match, outcome) {
	    return 'Точный тотал первой половины';
	};
	var bo_l7 = function bo_l7(match, outcome) {
	    return 'Точный тотал второй половины';
	};
	var bo_m7 = function bo_m7(match, outcome) {
	    return 'Победа с разницей в первой половине';
	};
	var bo_n7 = function bo_n7(match, outcome) {
	    return 'Победа с разницей во второй половине';
	};
	var bo_o7 = function bo_o7(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 1\u043E\u0439 \u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0435";
	};
	var bo_p7 = function bo_p7(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432\u043E 2\u043E\u0439 \u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0435";
	};
	var bo_q7 = function bo_q7(match, outcome) {
	    return 'Тотал самой результативной половины';
	};
	var bo_r7 = function bo_r7(match, outcome) {
	    return 'Тотал самой НЕрезультативной половины';
	};
	var bo_s7 = function bo_s7(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0435";
	};
	var bo_t7 = function bo_t7(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u0439 \u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0435";
	};
	var bo_u7 = function bo_u7(match, outcome) {
	    return 'Тотал первого периода';
	};
	var bo_v7 = function bo_v7(match, outcome) {
	    return 'Тотал второго периода';
	};
	var bo_w7 = function bo_w7(match, outcome) {
	    return 'Тотал третьего периода';
	};
	var bo_x7 = function bo_x7(match, outcome) {
	    return 'Результат первого периода';
	};
	var bo_y7 = function bo_y7(match, outcome) {
	    return 'Результат второго периода';
	};
	var bo_z7 = function bo_z7(match, outcome) {
	    return 'Результат третьего периода';
	};
	var bo_a8 = function bo_a8(match, outcome) {
	    return 'Победа с учетом пенальти';
	};
	var bo_b8 = function bo_b8(match, outcome) {
	    return 'Победа с разницей 1';
	};
	var bo_c8 = function bo_c8(match, outcome) {
	    return 'Победа с разницей 2';
	};
	var bo_d8 = function bo_d8(match, outcome) {
	    return 'Сколько команд забьет в 1-м периоде?';
	};
	var bo_e8 = function bo_e8(match, outcome) {
	    return 'Сколько команд забьет в 2-м периоде?';
	};
	var bo_f8 = function bo_f8(match, outcome) {
	    return 'Сколько команд забьет в 3-м периоде?';
	};
	var bo_g8 = function bo_g8(match, outcome) {
	    return 'Период-Матч';
	};
	var bo_h8 = function bo_h8(match, outcome) {
	    return 'Тотал овертайма';
	};
	var bo_i8 = function bo_i8(match, outcome) {
	    return 'Результат оветайма';
	};
	var bo_j8 = function bo_j8(match, outcome) {
	    return 'Фора в овертайме';
	};
	var bo_k8 = function bo_k8(match, outcome) {
	    return 'Фора в первом периоде';
	};
	var bo_l8 = function bo_l8(match, outcome) {
	    return 'Фора во втором периоде';
	};
	var bo_m8 = function bo_m8(match, outcome) {
	    return 'Фора в третьем периоде';
	};
	var bo_n8 = function bo_n8(match, outcome) {
	    return 'Точный счет первого периода';
	};
	var bo_o8 = function bo_o8(match, outcome) {
	    return 'Точный счет второго периода';
	};
	var bo_p8 = function bo_p8(match, outcome) {
	    return 'Точный счет третьего периода';
	};
	var bo_q8 = function bo_q8(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432 1\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_r8 = function bo_r8(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432\u043E 2\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_s8 = function bo_s8(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432 3\u0435\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_t8 = function bo_t8(match, outcome) {
	    return 'Фора по партиям в матче';
	};
	var bo_u8 = function bo_u8(match, outcome) {
	    return 'Точный тотал первого сета';
	};
	var bo_v8 = function bo_v8(match, outcome) {
	    return 'Точный тотал второго сета';
	};
	var bo_w8 = function bo_w8(match, outcome) {
	    return 'Точный тотал третьего сета';
	};
	var bo_x8 = function bo_x8(match, outcome) {
	    return match.homeTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_y8 = function bo_y8(match, outcome) {
	    return match.homeTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_z8 = function bo_z8(match, outcome) {
	    return match.homeTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_a9 = function bo_a9(match, outcome) {
	    return match.awayTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_b9 = function bo_b9(match, outcome) {
	    return match.awayTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_c9 = function bo_c9(match, outcome) {
	    return match.awayTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_d9 = function bo_d9(match, outcome) {
	    return 'Чет/Нечет первого сета';
	};
	var bo_e9 = function bo_e9(match, outcome) {
	    return 'Чет/Нечет второго сета';
	};
	var bo_f9 = function bo_f9(match, outcome) {
	    return 'Чет/Нечет третьего сета';
	};
	var bo_g9 = function bo_g9(match, outcome) {
	    return "\u041F\u043E\u0431\u0435\u0434\u0430 \u0438 \u0442\u043E\u0442\u0430\u043B \u043F\u0435\u0440\u0432\u043E\u0433\u043E \u0441\u0435\u0442\u0430 " + outcome.condition;
	};
	var bo_h9 = function bo_h9(match, outcome) {
	    return "\u041F\u043E\u0431\u0435\u0434\u0430 \u0438 \u0442\u043E\u0442\u0430\u043B \u0432\u0442\u043E\u0440\u043E\u0433\u043E \u0441\u0435\u0442\u0430 " + outcome.condition;
	};
	var bo_i9 = function bo_i9(match, outcome) {
	    return "\u041F\u043E\u0431\u0435\u0434\u0430 \u0438 \u0442\u043E\u0442\u0430\u043B \u0442\u0440\u0435\u0442\u044C\u0435\u0433\u043E \u0441\u0435\u0442\u0430 " + outcome.condition;
	};
	var bo_j9 = function bo_j9(match, outcome) {
	    return 'Победа с разницей в первом сете';
	};
	var bo_k9 = function bo_k9(match, outcome) {
	    return 'Победа с разницей во втором сете';
	};
	var bo_l9 = function bo_l9(match, outcome) {
	    return 'Победа с разницей в третьем сете';
	};
	var bo_m9 = function bo_m9(match, outcome) {
	    return 'Тотал на первом огневом рубеже';
	};
	var bo_n9 = function bo_n9(match, outcome) {
	    return 'Тотал на втором огневом рубеже';
	};
	var bo_o9 = function bo_o9(match, outcome) {
	    return 'Тотал на третьем огневом рубеже';
	};
	var bo_p9 = function bo_p9(match, outcome) {
	    return 'Тотал на четвертом огневом рубеже';
	};
	var bo_q9 = function bo_q9(match, outcome) {
	    return 'Тотал на пятом огневом рубеже';
	};
	var bo_r9 = function bo_r9(match, outcome) {
	    return 'Тотал на шестом огневом рубеже';
	};
	var bo_s9 = function bo_s9(match, outcome) {
	    return 'Тотал на седьмом огневом рубеже';
	};
	var bo_t9 = function bo_t9(match, outcome) {
	    return 'Тотал на восьмом огневом рубеже';
	};
	var bo_u9 = function bo_u9(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u043D\u0430 \u043F\u0435\u0440\u0432\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435";
	};
	var bo_v9 = function bo_v9(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u043D\u0430 \u0432\u0442\u043E\u0440\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435";
	};
	var bo_w9 = function bo_w9(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u043D\u0430 \u0442\u0435\u0440\u0442\u044C\u0435\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435";
	};
	var bo_x9 = function bo_x9(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u043D\u0430 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435";
	};
	var bo_y9 = function bo_y9(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u043D\u0430 \u043F\u044F\u0442\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435";
	};
	var bo_z9 = function bo_z9(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u043D\u0430 \u0448\u0435\u0441\u0442\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435";
	};
	var bo_a10 = function bo_a10(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u043D\u0430 \u0441\u0435\u0434\u044C\u043C\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435";
	};
	var bo_b10 = function bo_b10(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u043D\u0430 \u0432\u043E\u0441\u044C\u043C\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435";
	};
	var bo_c10 = function bo_c10(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u043D\u0430 \u043F\u0435\u0440\u0432\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435";
	};
	var bo_d10 = function bo_d10(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u043D\u0430 \u0432\u0442\u043E\u0440\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435";
	};
	var bo_e10 = function bo_e10(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u043D\u0430 \u0442\u0435\u0440\u0442\u044C\u0435\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435";
	};
	var bo_f10 = function bo_f10(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u043D\u0430 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435";
	};
	var bo_g10 = function bo_g10(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u043D\u0430 \u043F\u044F\u0442\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435";
	};
	var bo_h10 = function bo_h10(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u043D\u0430 \u0448\u0435\u0441\u0442\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435";
	};
	var bo_i10 = function bo_i10(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u043D\u0430 \u0441\u0435\u0434\u044C\u043C\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435";
	};
	var bo_j10 = function bo_j10(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u043D\u0430 \u0432\u043E\u0441\u044C\u043C\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435";
	};
	var bo_k10 = function bo_k10(match, outcome) {
	    return 'Фора на первом огневом рубеже';
	};
	var bo_l10 = function bo_l10(match, outcome) {
	    return 'Фора на втором огневом рубеже';
	};
	var bo_m10 = function bo_m10(match, outcome) {
	    return 'Фора на третьем огневом рубеже';
	};
	var bo_n10 = function bo_n10(match, outcome) {
	    return 'Фора на четвертом огневом рубеже';
	};
	var bo_o10 = function bo_o10(match, outcome) {
	    return 'Фора на пятом огневом рубеже';
	};
	var bo_p10 = function bo_p10(match, outcome) {
	    return 'Фора на шестом огневом рубеже';
	};
	var bo_q10 = function bo_q10(match, outcome) {
	    return 'Фора на седьмом огневом рубеже';
	};
	var bo_r10 = function bo_r10(match, outcome) {
	    return 'Фора на восьмом огневом рубеже';
	};
	var bo_s10 = function bo_s10(match, outcome) {
	    return 'Результат на первом огневом рубеже';
	};
	var bo_t10 = function bo_t10(match, outcome) {
	    return 'Результат на втором огневом рубеже';
	};
	var bo_u10 = function bo_u10(match, outcome) {
	    return 'Результат на третьем огневом рубеже';
	};
	var bo_v10 = function bo_v10(match, outcome) {
	    return 'Результат на четвертом огневом рубеже';
	};
	var bo_w10 = function bo_w10(match, outcome) {
	    return 'Результат на пятом огневом рубеже';
	};
	var bo_x10 = function bo_x10(match, outcome) {
	    return 'Результат на шестом огневом рубеже';
	};
	var bo_y10 = function bo_y10(match, outcome) {
	    return 'Результат на седьмом огневом рубеже';
	};
	var bo_z10 = function bo_z10(match, outcome) {
	    return 'Результат на восьмом огневом рубеже';
	};
	var bo_a11 = function bo_a11(match, outcome) {
	    return 'Точный тотал на первом огневом рубеже';
	};
	var bo_b11 = function bo_b11(match, outcome) {
	    return 'Точный тотал на втором огневом рубеже';
	};
	var bo_c11 = function bo_c11(match, outcome) {
	    return 'Точный тотал на третьем огневом рубеже';
	};
	var bo_d11 = function bo_d11(match, outcome) {
	    return 'Точный тотал на четвертом огневом рубеже';
	};
	var bo_e11 = function bo_e11(match, outcome) {
	    return 'Точный тотал на пятом огневом рубеже';
	};
	var bo_f11 = function bo_f11(match, outcome) {
	    return 'Точный тотал на шестом огневом рубеже';
	};
	var bo_g11 = function bo_g11(match, outcome) {
	    return 'Точный тотал на седьмом огневом рубеже';
	};
	var bo_h11 = function bo_h11(match, outcome) {
	    return 'Точный тотал на восьмом огневом рубеже';
	};
	var bo_i11 = function bo_i11(match, outcome) {
	    return 'Будет ли досрочная победа?';
	};
	var bo_j11 = function bo_j11(match, outcome) {
	    return 'Метод победы в бою';
	};
	var bo_k11 = function bo_k11(match, outcome) {
	    return 'Победа в бою';
	};
	var bo_l11 = function bo_l11(match, outcome) {
	    return 'Тотал';
	};
	var bo_m11 = function bo_m11(match, outcome) {
	    return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 " + outcome.condition + " \u0440\u0430\u0443\u043D\u0434?";
	};
	var bo_n11 = function bo_n11(match, outcome) {
	    return 'FirstBlood';
	};
	var bo_o11 = function bo_o11(match, outcome) {
	    return "FirstBlood \u0432 " + outcome.condition + " \u0440\u0430\u0443\u043D\u0434\u0435";
	};
	var bo_p11 = function bo_p11(match, outcome) {
	    return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 " + outcome.condition + " \u043A\u0430\u0440\u0442\u0443?";
	};
	var bo_q11 = function bo_q11(match, outcome) {
	    return "FirstBlood \u0432 " + outcome.condition + " \u043A\u0430\u0440\u0442\u0435";
	};
	var bo_r11 = function bo_r11(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " \u0443\u0431\u0438\u0439\u0441\u0442\u0432 \u0432 1\u043E\u0439 \u043A\u0430\u0440\u0442\u0435";
	};
	var bo_s11 = function bo_s11(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " \u0443\u0431\u0438\u0439\u0441\u0442\u0432 \u0432\u043E 2\u043E\u0439 \u043A\u0430\u0440\u0442\u0435";
	};
	var bo_t11 = function bo_t11(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " \u0443\u0431\u0438\u0439\u0441\u0442\u0432 \u0432 3\u0435\u0439 \u043A\u0430\u0440\u0442\u0435";
	};
	var bo_u11 = function bo_u11(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " \u0443\u0431\u0438\u0439\u0441\u0442\u0432 \u0432 4\u043E\u0439 \u043A\u0430\u0440\u0442\u0435";
	};
	var bo_v11 = function bo_v11(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " \u0443\u0431\u0438\u0439\u0441\u0442\u0432 \u0432 5\u043E\u0439 \u043A\u0430\u0440\u0442\u0435";
	};
	var bo_w11 = function bo_w11(match, outcome) {
	    return 'Результат в матче';
	};
	var bo_x11 = function bo_x11(match, outcome) {
	    return 'Победа в первой карте';
	};
	var bo_y11 = function bo_y11(match, outcome) {
	    return 'Победа во второй карте';
	};
	var bo_z11 = function bo_z11(match, outcome) {
	    return 'Победа в третьей карте';
	};
	var bo_a12 = function bo_a12(match, outcome) {
	    return 'Победа в четвертой карте';
	};
	var bo_b12 = function bo_b12(match, outcome) {
	    return 'Победа в пятой карте';
	};
	var bo_c12 = function bo_c12(match, outcome) {
	    return 'First blood в первой карте';
	};
	var bo_d12 = function bo_d12(match, outcome) {
	    return 'First blood во второй карте';
	};
	var bo_e12 = function bo_e12(match, outcome) {
	    return 'First blood в третьей карте';
	};
	var bo_f12 = function bo_f12(match, outcome) {
	    return 'First blood в четвертой карте';
	};
	var bo_g12 = function bo_g12(match, outcome) {
	    return 'First blood в пятой карте';
	};
	var bo_h12 = function bo_h12(match, outcome) {
	    return 'Победа с учетом буллитов';
	};
	var bo_i12 = function bo_i12(match, outcome) {
	    return match.homeTeam + " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u0432 \u043E\u0431\u043E\u0438\u0445 \u0442\u0430\u0439\u043C\u0430\u0445";
	};
	var bo_j12 = function bo_j12(match, outcome) {
	    return match.awayTeam + " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u0432 \u043E\u0431\u043E\u0438\u0445 \u0442\u0430\u0439\u043C\u0430\u0445";
	};
	var bo_k12 = function bo_k12(match, outcome) {
	    return "\u041A\u043E\u043C\u0430\u043D\u0434, \u0437\u0430\u0431\u0438\u0432\u0448\u0438\u0445 " + outcome.conditionTwo + " \u0438 \u0431\u043E\u043B\u0435\u0435 \u0433\u043E\u043B\u043E\u0432\xA0\xA0(\u0438\u0445 \u0442\u043E\u0442\u0430\u043B)";
	};
	var bo_l12 = function bo_l12(match, outcome) {
	    return 'Самая результативная команда (её тотал)';
	};
	var bo_m12 = function bo_m12(match, outcome) {
	    return 'Самый результативный тайм (тотал)';
	};
	var bo_n12 = function bo_n12(match, outcome) {
	    return "\u041E\u0431\u0430 \u0442\u0430\u0439\u043C\u0430 \u043C\u0435\u043D\u044C\u0448\u0435 \u0447\u0435\u043C " + outcome.condition;
	};
	var bo_o12 = function bo_o12(match, outcome) {
	    return "\u041E\u0431\u0430 \u0442\u0430\u0439\u043C\u0430 \u0431\u043E\u043B\u044C\u0448\u0435 \u0447\u0435\u043C " + outcome.condition;
	};
	var bo_p12 = function bo_p12(match, outcome) {
	    return 'Чет/Нечет первого тайма';
	};
	var bo_q12 = function bo_q12(match, outcome) {
	    return 'Чет/Нечет второго тайма';
	};
	var bo_r12 = function bo_r12(match, outcome) {
	    return "\u0421\u043A\u043E\u043B\u044C\u043A\u043E \u0433\u043E\u043B\u043E\u0432 \u0437\u0430\u0431\u044C\u0435\u0442 " + match.homeTeam + " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0442\u0430\u0439\u043C\u0435?";
	};
	var bo_s12 = function bo_s12(match, outcome) {
	    return "\u0421\u043A\u043E\u043B\u044C\u043A\u043E \u0433\u043E\u043B\u043E\u0432 \u0437\u0430\u0431\u044C\u0435\u0442 " + match.homeTeam + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0442\u0430\u0439\u043C\u0435?";
	};
	var bo_t12 = function bo_t12(match, outcome) {
	    return "\u0421\u043A\u043E\u043B\u044C\u043A\u043E \u0433\u043E\u043B\u043E\u0432 \u0437\u0430\u0431\u044C\u0435\u0442 " + match.awayTeam + " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0442\u0430\u0439\u043C\u0435?";
	};
	var bo_u12 = function bo_u12(match, outcome) {
	    return "\u0421\u043A\u043E\u043B\u044C\u043A\u043E \u0433\u043E\u043B\u043E\u0432 \u0437\u0430\u0431\u044C\u0435\u0442 " + match.awayTeam + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0442\u0430\u0439\u043C\u0435?";
	};
	var bo_v12 = function bo_v12(match, outcome) {
	    return "\u0421\u043A\u043E\u043B\u044C\u043A\u043E \u0433\u043E\u043B\u043E\u0432 \u0437\u0430\u0431\u044C\u0435\u0442 " + match.homeTeam + " \u0432 \u043C\u0430\u0442\u0447\u0435?";
	};
	var bo_w12 = function bo_w12(match, outcome) {
	    return "\u0421\u043A\u043E\u043B\u044C\u043A\u043E \u0433\u043E\u043B\u043E\u0432 \u0437\u0430\u0431\u044C\u0435\u0442 " + match.awayTeam + " \u0432 \u043C\u0430\u0442\u0447\u0435?";
	};
	var bo_x12 = function bo_x12(match, outcome) {
	    return 'Самая нерезультативная команда (её тотал)';
	};
	var bo_y12 = function bo_y12(match, outcome) {
	    return "\u0417\u0430\u0431\u044C\u0435\u0442 \u043B\u0438 " + match.homeTeam + " \u0442\u043E\u043B\u044C\u043A\u043E \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0442\u0430\u0439\u043C\u0435?";
	};
	var bo_z12 = function bo_z12(match, outcome) {
	    return "\u0417\u0430\u0431\u044C\u0435\u0442 \u043B\u0438 " + match.awayTeam + " \u0442\u043E\u043B\u044C\u043A\u043E \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0442\u0430\u0439\u043C\u0435?";
	};
	var bo_a13 = function bo_a13(match, outcome) {
	    return "\u0417\u0430\u0431\u044C\u0435\u0442 \u043B\u0438 " + match.homeTeam + " \u0442\u043E\u043B\u044C\u043A\u043E \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0442\u0430\u0439\u043C\u0435?";
	};
	var bo_b13 = function bo_b13(match, outcome) {
	    return "\u0417\u0430\u0431\u044C\u0435\u0442 \u043B\u0438 " + match.awayTeam + " \u0442\u043E\u043B\u044C\u043A\u043E \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0442\u0430\u0439\u043C\u0435?";
	};
	var bo_c13 = function bo_c13(match, outcome) {
	    return 'Сколько команд забьёт в первом тайме';
	};
	var bo_d13 = function bo_d13(match, outcome) {
	    return 'Сколько команд забьёт во втором тайме';
	};
	var bo_e13 = function bo_e13(match, outcome) {
	    return "\u0421\u043A\u043E\u043B\u044C\u043A\u043E \u043A\u043E\u043C\u0430\u043D\u0434 \u0437\u0430\u0431\u044C\u0451\u0442 \u0431\u043E\u043B\u044C\u0448\u0435 " + outcome.condition + " " + plural(outcome.condition, ['гола', 'голов', 'голов']);
	};
	var bo_f13 = function bo_f13(match, outcome) {
	    return 'Как будет забит первый гол?';
	};
	var bo_g13 = function bo_g13(match, outcome) {
	    return 'Выход в следующий круг';
	};
	var bo_h13 = function bo_h13(match, outcome) {
	    return 'Кто начнет с центра поля?';
	};
	var bo_i13 = function bo_i13(match, outcome) {
	    return 'Два гола подряд одной командой';
	};
	var bo_j13 = function bo_j13(match, outcome) {
	    return match.homeTeam + " \u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u0432\u043E\u043B\u0435\u0432\u0443\u044E \u043F\u043E\u0431\u0435\u0434\u0443";
	};
	var bo_k13 = function bo_k13(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u043E\u043B\u0443\u0447\u0438\u0442 " + numeralFemaleEnding(outcome.condition) + " \u0416\u041A";
	};
	var bo_l13 = function bo_l13(match, outcome) {
	    return match.awayTeam + " \u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u0432\u043E\u043B\u0435\u0432\u0443\u044E \u043F\u043E\u0431\u0435\u0434\u0443";
	};
	var bo_m13 = function bo_m13(match, outcome) {
	    return 'Что в матче произойдет раньше?';
	};
	var bo_n13 = function bo_n13(match, outcome) {
	    return 'Дубль';
	};
	var bo_o13 = function bo_o13(match, outcome) {
	    return 'Хет-трик';
	};
	var bo_p13 = function bo_p13(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u043E\u0434\u0430\u0441\u0442 " + numeralMaleEnding(outcome.condition) + " \u0443\u0433\u043B\u043E\u0432\u043E\u0439";
	};
	var bo_q13 = function bo_q13(match, outcome) {
	    return "\u041A\u043E\u043C\u0430\u043D\u0434, \u0437\u0430\u0431\u0438\u0432\u0448\u0438\u0445 \u0440\u043E\u0432\u043D\u043E " + outcome.conditionTwo + " " + plural(outcome.conditionTwo, ['гол', 'гола', 'голов']) + "\xA0(\u0438\u0445 \u0442\u043E\u0442\u0430\u043B)";
	};
	var bo_r13 = function bo_r13(match, outcome) {
	    return "\u0417\u0430\u0431\u044C\u044E\u0442 \u043B\u0438 \u0432 \u043C\u0430\u0442\u0447\u0435 \u0440\u043E\u0432\u043D\u043E " + outcome.condition + " " + plural(outcome.condition, ['гол', 'гола', 'голов']);
	};
	var bo_s13 = function bo_s13(match, outcome) {
	    return 'Кто забьет последний гол?';
	};
	var bo_t13 = function bo_t13(match, outcome) {
	    return 'Автогол';
	};
	var bo_u13 = function bo_u13(match, outcome) {
	    return 'Забьет ли игрок вышедший на замену?';
	};
	var bo_v13 = function bo_v13(match, outcome) {
	    return 'Время последнего гола';
	};
	var bo_w13 = function bo_w13(match, outcome) {
	    return 'Обладатель Кубка';
	};
	var bo_x13 = function bo_x13(match, outcome) {
	    return 'Обладатель Суперкубка';
	};
	var bo_y13 = function bo_y13(match, outcome) {
	    return "\u0412 \u043A\u0430\u043A\u043E\u043C \u0442\u0430\u0439\u043C\u0435 \u0431\u0443\u0434\u0435\u0442 \u0437\u0430\u0431\u0438\u0442 " + numeralMaleEnding(outcome.condition) + " \u0433\u043E\u043B?";
	};
	var bo_z13 = function bo_z13(match, outcome) {
	    return 'Двойной исход с 1 по 15 минуту';
	};
	var bo_a14 = function bo_a14(match, outcome) {
	    return 'Двойной исход с 16 по 30 минуту';
	};
	var bo_b14 = function bo_b14(match, outcome) {
	    return 'Двойной исход с 31 минуты до перерыва';
	};
	var bo_c14 = function bo_c14(match, outcome) {
	    return 'Двойной исход с 46 по 60 минуту';
	};
	var bo_d14 = function bo_d14(match, outcome) {
	    return 'Двойной исход с 61 по 75 минуту';
	};
	var bo_e14 = function bo_e14(match, outcome) {
	    return 'Двойной исход с 76 минуты до конца ОВ';
	};
	var bo_f14 = function bo_f14(match, outcome) {
	    return "\u0417\u0430\u0431\u044C\u0435\u0442 \u043B\u0438 " + match.homeTeam + " " + numeralMaleEnding(outcome.condition) + " \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438? (\u0441\u0435\u0440\u0438\u044F \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438)";
	};
	var bo_g14 = function bo_g14(match, outcome) {
	    return "\u0417\u0430\u0431\u044C\u0435\u0442 \u043B\u0438 " + match.awayTeam + " " + numeralMaleEnding(outcome.condition) + " \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438? (\u0441\u0435\u0440\u0438\u044F \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438)";
	};
	var bo_h14 = function bo_h14(match, outcome) {
	    return match.homeTeam + " \u0437\u0430\u0431\u044C\u0435\u0442 \u0441\u0432\u043E\u0439 " + numeralMaleEnding(outcome.condition) + " \u0433\u043E\u043B";
	};
	var bo_i14 = function bo_i14(match, outcome) {
	    return match.awayTeam + " \u0437\u0430\u0431\u044C\u0435\u0442 \u0441\u0432\u043E\u0439 " + numeralMaleEnding(outcome.condition) + " \u0433\u043E\u043B";
	};
	var bo_j14 = function bo_j14(match, outcome) {
	    return 'Тотал угловых в первом тайме';
	};
	var bo_k14 = function bo_k14(match, outcome) {
	    return 'Тотал ЖК в первом тайме';
	};
	var bo_l14 = function bo_l14(match, outcome) {
	    return 'Фора по угловым в матче';
	};
	var bo_m14 = function bo_m14(match, outcome) {
	    return 'Фора по угловым в первом тайме';
	};
	var bo_n14 = function bo_n14(match, outcome) {
	    return 'Фора по ЖК';
	};
	var bo_o14 = function bo_o14(match, outcome) {
	    return 'Фора по ЖК в первом тайме';
	};
	var bo_p14 = function bo_p14(match, outcome) {
	    return 'Результат матча по угловым';
	};
	var bo_q14 = function bo_q14(match, outcome) {
	    return 'Результат первого тайма по угловым';
	};
	var bo_r14 = function bo_r14(match, outcome) {
	    return 'Результат матча по ЖК';
	};
	var bo_s14 = function bo_s14(match, outcome) {
	    return 'Результат первого тайма по ЖК';
	};
	var bo_t14 = function bo_t14(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u0437\u0430\u0431\u044C\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['гол', 'гола', 'голов']);
	};
	var bo_u14 = function bo_u14(match, outcome) {
	    return "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 \u0437\u0430\u0431\u0438\u0442 " + numeralMaleEnding(outcome.condition) + " \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438";
	};
	var bo_v14 = function bo_v14(match, outcome) {
	    return 'Ауты';
	};
	var bo_w14 = function bo_w14(match, outcome) {
	    return 'Тайм-Матч';
	};
	var bo_x14 = function bo_x14(match, outcome) {
	    return 'Тотал матча (Азия)';
	};
	var bo_y14 = function bo_y14(match, outcome) {
	    return 'Тотал угловых';
	};
	var bo_z14 = function bo_z14(match, outcome) {
	    return 'Как закончится матч?';
	};
	var bo_a15 = function bo_a15(match, outcome) {
	    return 'Пенальти (тотал)';
	};
	var bo_b15 = function bo_b15(match, outcome) {
	    return 'Тотал красных карточек';
	};
	var bo_c15 = function bo_c15(match, outcome) {
	    return 'Время первого гола';
	};
	var bo_d15 = function bo_d15(match, outcome) {
	    return 'Сумма минут голов';
	};
	var bo_e15 = function bo_e15(match, outcome) {
	    return 'Тотал второго тайма';
	};
	var bo_f15 = function bo_f15(match, outcome) {
	    return 'Фора во втором тайме';
	};
	var bo_g15 = function bo_g15(match, outcome) {
	    return 'Удары в створ ворот';
	};
	var bo_h15 = function bo_h15(match, outcome) {
	    return 'Тотал желтых карточек';
	};
	var bo_i15 = function bo_i15(match, outcome) {
	    return 'Результат второго тайма';
	};
	var bo_j15 = function bo_j15(match, outcome) {
	    return 'Фора в матче с 1 по 15 минуту';
	};
	var bo_k15 = function bo_k15(match, outcome) {
	    return 'Фора в матче с 16 по 30 минуту';
	};
	var bo_l15 = function bo_l15(match, outcome) {
	    return 'Фора в матче с 31 минуты до перерыва';
	};
	var bo_m15 = function bo_m15(match, outcome) {
	    return 'Фора в матче с 46 по 60 минуту';
	};
	var bo_n15 = function bo_n15(match, outcome) {
	    return 'Фора в матче с 61 по 75 минуту';
	};
	var bo_o15 = function bo_o15(match, outcome) {
	    return 'Фора в матче с 76 минуты до конца ОВ';
	};
	var bo_p15 = function bo_p15(match, outcome) {
	    return match.homeTeam + " \u0433\u043E\u043B\u044B";
	};
	var bo_q15 = function bo_q15(match, outcome) {
	    return match.awayTeam + " \u0433\u043E\u043B\u044B";
	};
	var bo_r15 = function bo_r15(match, outcome) {
	    return 'Тотал замен';
	};
	var bo_s15 = function bo_s15(match, outcome) {
	    return 'Тотал матча с 1 по 15 минуту';
	};
	var bo_t15 = function bo_t15(match, outcome) {
	    return 'Тотал матча с 16 по 30 минуту';
	};
	var bo_u15 = function bo_u15(match, outcome) {
	    return 'Тотал матча с 31 минуты до перерыва';
	};
	var bo_v15 = function bo_v15(match, outcome) {
	    return 'Тотал матча с 46 по 60 минуту';
	};
	var bo_w15 = function bo_w15(match, outcome) {
	    return 'Тотал матча с 61 по 75 минуту';
	};
	var bo_x15 = function bo_x15(match, outcome) {
	    return 'Тотал матча с 76 минуты до конца ОВ';
	};
	var bo_y15 = function bo_y15(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0441 1 \u043F\u043E 15 \u043C\u0438\u043D\u0443\u0442\u0443";
	};
	var bo_z15 = function bo_z15(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0441 16 \u043F\u043E 30 \u043C\u0438\u043D\u0443\u0442\u0443";
	};
	var bo_a16 = function bo_a16(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0441 31 \u043C\u0438\u043D\u0443\u0442\u044B \u0434\u043E \u043F\u0435\u0440\u0435\u0440\u044B\u0432\u0430";
	};
	var bo_b16 = function bo_b16(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0441 46 \u043F\u043E 60 \u043C\u0438\u043D\u0443\u0442\u0443";
	};
	var bo_c16 = function bo_c16(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0441 61 \u043F\u043E 75 \u043C\u0438\u043D\u0443\u0442\u0443";
	};
	var bo_d16 = function bo_d16(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0441 76 \u043C\u0438\u043D\u0443\u0442\u044B \u0434\u043E \u043A\u043E\u043D\u0446\u0430 \u041E\u0412";
	};
	var bo_e16 = function bo_e16(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0441 1 \u043F\u043E 15 \u043C\u0438\u043D\u0443\u0442\u0443";
	};
	var bo_f16 = function bo_f16(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0441 16 \u043F\u043E 30 \u043C\u0438\u043D\u0443\u0442\u0443";
	};
	var bo_g16 = function bo_g16(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0441 31 \u043C\u0438\u043D\u0443\u0442\u044B \u0434\u043E \u043F\u0435\u0440\u0435\u0440\u044B\u0432\u0430";
	};
	var bo_h16 = function bo_h16(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0441 46 \u043F\u043E 60 \u043C\u0438\u043D\u0443\u0442\u0443";
	};
	var bo_i16 = function bo_i16(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0441 61 \u043F\u043E 75 \u043C\u0438\u043D\u0443\u0442\u0443";
	};
	var bo_j16 = function bo_j16(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0441 76 \u043C\u0438\u043D\u0443\u0442\u044B \u0434\u043E \u043A\u043E\u043D\u0446\u0430 \u041E\u0412";
	};
	var bo_k16 = function bo_k16(match, outcome) {
	    return 'Точный тотал первого тайма';
	};
	var bo_l16 = function bo_l16(match, outcome) {
	    return 'Точный тотал второго тайма';
	};
	var bo_m16 = function bo_m16(match, outcome) {
	    return match.homeTeam + " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u0438 \u043D\u0435 \u043F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u0442";
	};
	var bo_n16 = function bo_n16(match, outcome) {
	    return match.awayTeam + " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u0438 \u043D\u0435 \u043F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u0442";
	};
	var bo_o16 = function bo_o16(match, outcome) {
	    return match.homeTeam + " \u0437\u0430\u0431\u044C\u0435\u0442 \u0440\u043E\u0432\u043D\u043E " + outcome.condition + " " + plural(outcome.condition, ['гол', 'гола', 'голов']);
	};
	var bo_p16 = function bo_p16(match, outcome) {
	    return match.awayTeam + " \u0437\u0430\u0431\u044C\u0435\u0442 \u0440\u043E\u0432\u043D\u043E " + outcome.condition + " " + plural(outcome.condition, ['гол', 'гола', 'голов']);
	};
	var bo_q16 = function bo_q16(match, outcome) {
	    return 'Точный счет первого тайма';
	};
	var bo_r16 = function bo_r16(match, outcome) {
	    return 'Точный счет второго тайма';
	};
	var bo_s16 = function bo_s16(match, outcome) {
	    return 'Тотал не забитых пенальти';
	};
	var bo_t16 = function bo_t16(match, outcome) {
	    return "\u041E\u0431\u0435 \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0437\u0430\u0431\u044C\u044E\u0442 \u043C\u0435\u043D\u044C\u0448\u0435 \u0447\u0435\u043C " + outcome.condition;
	};
	var bo_u16 = function bo_u16(match, outcome) {
	    return "\u041E\u0431\u0435 \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0437\u0430\u0431\u044C\u044E\u0442 \u0431\u043E\u043B\u044C\u0448\u0435 \u0447\u0435\u043C " + outcome.condition;
	};
	var bo_v16 = function bo_v16(match, outcome) {
	    return 'Сравнение таймов (голы)';
	};
	var bo_w16 = function bo_w16(match, outcome) {
	    return 'Победа в матче с 1 по 15 минуту';
	};
	var bo_x16 = function bo_x16(match, outcome) {
	    return 'Победа в матче с 16 по 30 минуту';
	};
	var bo_y16 = function bo_y16(match, outcome) {
	    return 'Победа в матче с 31 минуты до перерыва';
	};
	var bo_z16 = function bo_z16(match, outcome) {
	    return 'Победа в матче с 46 по 60 минуту';
	};
	var bo_a17 = function bo_a17(match, outcome) {
	    return 'Победа в матче с 61 по 75 минуту';
	};
	var bo_b17 = function bo_b17(match, outcome) {
	    return 'Победа в матче с 76 минуты до конца ОВ';
	};
	var bo_c17 = function bo_c17(match, outcome) {
	    return match.homeTeam + " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u0432 \u043E\u0434\u043D\u043E\u043C \u0438\u0437 \u0442\u0430\u0439\u043C\u043E\u0432";
	};
	var bo_d17 = function bo_d17(match, outcome) {
	    return match.awayTeam + " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u0432 \u043E\u0434\u043D\u043E\u043C \u0438\u0437 \u0442\u0430\u0439\u043C\u043E\u0432";
	};
	var bo_e17 = function bo_e17(match, outcome) {
	    return "\u041A\u043E\u043C\u0430\u043D\u0434, \u0437\u0430\u0431\u0438\u0432\u0448\u0438\u0445 \u043E\u0442 " + outcome.conditionTwo + " \u0434\u043E " + outcome.conditionThree + " \u0433\u043E\u043B\u043E\u0432\xA0(\u0438\u0445 \u0442\u043E\u0442\u0430\u043B)";
	};
	var bo_f17 = function bo_f17(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0442\u0430\u0439\u043C\u0435";
	};
	var bo_g17 = function bo_g17(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0442\u0430\u0439\u043C\u0435";
	};
	var bo_h17 = function bo_h17(match, outcome) {
	    return "\u0417\u0430\u0431\u044C\u0435\u0442 \u043B\u0438 " + outcome.playerName + " (" + match.homeTeam + ") \u0433\u043E\u043B?";
	};
	var bo_i17 = function bo_i17(match, outcome) {
	    return "\u0417\u0430\u0431\u044C\u0435\u0442 \u043B\u0438 " + outcome.playerName + " (" + match.awayTeam + ") \u0433\u043E\u043B?";
	};
	var bo_j17 = function bo_j17(match, outcome) {
	    return 'Результат матча';
	};
	var bo_k17 = function bo_k17(match, outcome) {
	    return 'Фора матча';
	};
	var bo_l17 = function bo_l17(match, outcome) {
	    return 'Тотал хозяев';
	};
	var bo_m17 = function bo_m17(match, outcome) {
	    return 'Тотал гостей';
	};
	var bo_n17 = function bo_n17(match, outcome) {
	    return 'Тотал самого результативного матча';
	};
	var bo_o17 = function bo_o17(match, outcome) {
	    return 'Тотал самого НЕрезультативного матча';
	};
	var bo_p17 = function bo_p17(match, outcome) {
	    return 'Тотал матчей без голов';
	};
	var bo_q17 = function bo_q17(match, outcome) {
	    return 'Тотал побед хозяев';
	};
	var bo_r17 = function bo_r17(match, outcome) {
	    return 'Тотал побед гостей';
	};
	var bo_s17 = function bo_s17(match, outcome) {
	    return 'Тотал ничьих';
	};
	var bo_t17 = function bo_t17(match, outcome) {
	    return 'Обе команды забьют: 1 тайм/2 тайм';
	};
	var bo_u17 = function bo_u17(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B " + outcome.condition + " \u0438 \u041E\u0431\u0435 \u0437\u0430\u0431\u044C\u044E\u0442";
	};
	var bo_v17 = function bo_v17(match, outcome) {
	    return match.homeTeam + " \u0437\u0430\u0431\u044C\u0435\u0442 \u0438 \u043D\u0435 \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442";
	};
	var bo_w17 = function bo_w17(match, outcome) {
	    return match.awayTeam + " \u0437\u0430\u0431\u044C\u0435\u0442 \u0438 \u043D\u0435 \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442";
	};
	var bo_x17 = function bo_x17(match, outcome) {
	    return 'Метод победы в матче';
	};
	var bo_y17 = function bo_y17(match, outcome) {
	    return 'Компенсированное время в 1ом тайме';
	};
	var bo_z17 = function bo_z17(match, outcome) {
	    return 'Компенсированное время во 2ом тайме';
	};
	var bo_a18 = function bo_a18(match, outcome) {
	    return 'Будет ли в матче штанга/перекладина';
	};
	var bo_b18 = function bo_b18(match, outcome) {
	    return 'Время первой замены';
	};
	var bo_c18 = function bo_c18(match, outcome) {
	    return "\u041A\u0440\u0430\u0441\u043D\u0443\u044E \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0443 \u043F\u043E\u043B\u0443\u0447\u0438\u0442 \u0438\u0433\u0440\u043E\u043A " + match.homeTeam;
	};
	var bo_d18 = function bo_d18(match, outcome) {
	    return "\u041A\u0440\u0430\u0441\u043D\u0443\u044E \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0443 \u043F\u043E\u043B\u0443\u0447\u0438\u0442 \u0438\u0433\u0440\u043E\u043A " + match.awayTeam;
	};
	var bo_e18 = function bo_e18(match, outcome) {
	    return 'Будет ли пенальти и удаление';
	};
	var bo_f18 = function bo_f18(match, outcome) {
	    return 'Гол в компенсированное время';
	};
	var bo_g18 = function bo_g18(match, outcome) {
	    return 'ЖК за симуляцию';
	};
	var bo_h18 = function bo_h18(match, outcome) {
	    return 'ЖК за снятую футболку';
	};
	var bo_i18 = function bo_i18(match, outcome) {
	    return 'Угловые с каждого флажка';
	};
	var bo_j18 = function bo_j18(match, outcome) {
	    return 'Кто займет 3-е место?';
	};
	var bo_k18 = function bo_k18(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + "  (\u0414\u043E\u043F.\u0432\u0440\u0435\u043C\u044F)";
	};
	var bo_l18 = function bo_l18(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + "  (\u0414\u043E\u043F.\u0432\u0440\u0435\u043C\u044F)";
	};
	var bo_m18 = function bo_m18(match, outcome) {
	    return 'Двойной исход (Доп.время)';
	};
	var bo_n18 = function bo_n18(match, outcome) {
	    return 'Точный счет  (Доп.время)';
	};
	var bo_o18 = function bo_o18(match, outcome) {
	    return 'Фора (Доп.время)';
	};
	var bo_p18 = function bo_p18(match, outcome) {
	    return 'Тотал  (Доп.время)';
	};
	var bo_q18 = function bo_q18(match, outcome) {
	    return 'Результат (Доп.время)';
	};
	var bo_r18 = function bo_r18(match, outcome) {
	    return "\u041A\u0442\u043E \u0437\u0430\u0431\u044C\u0435\u0442 " + numeralMaleEnding(outcome.condition) + " \u0433\u043E\u043B \u0432 \u0434\u043E\u043F.\u0432.?";
	};
	var bo_s18 = function bo_s18(match, outcome) {
	    return 'Фора в первом дополнительном времени';
	};
	var bo_t18 = function bo_t18(match, outcome) {
	    return 'Тотал первого дополнительного  времени';
	};
	var bo_u18 = function bo_u18(match, outcome) {
	    return 'Результат в первом дополнительном времени';
	};
	var bo_v18 = function bo_v18(match, outcome) {
	    return 'Фора во втором дополнительном времени';
	};
	var bo_w18 = function bo_w18(match, outcome) {
	    return 'Тотал второго дополнительного  времени';
	};
	var bo_x18 = function bo_x18(match, outcome) {
	    return 'Результат во второе дополнительное время';
	};
	var bo_y18 = function bo_y18(match, outcome) {
	    return 'Точный счет в серии пенальти';
	};
	var bo_z18 = function bo_z18(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u0437\u0430\u0431\u0438\u0442\u044B\u0445 \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438: " + match.awayTeam + " (\u0441\u0435\u0440\u0438\u044F \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438)";
	};
	var bo_a19 = function bo_a19(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u0437\u0430\u0431\u0438\u0442\u044B\u0445 \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438: " + match.homeTeam + " (\u0441\u0435\u0440\u0438\u044F \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438)";
	};
	var bo_b19 = function bo_b19(match, outcome) {
	    return 'Тотал забитых пенальти (серия пенальти)';
	};
	var bo_c19 = function bo_c19(match, outcome) {
	    return 'Тотал незабитых пенальти (серия пенальти)';
	};
	var bo_d19 = function bo_d19(match, outcome) {
	    return "\u0415\u0432\u0440\u043E\u043F\u0435\u0439\u0441\u043A\u0430\u044F \u0444\u043E\u0440\u0430 " + europeanHandicapCondition(outcome.condition);
	};
	var bo_e19 = function bo_e19(match, outcome) {
	    return "\u0415\u0432\u0440\u043E\u043F\u0435\u0439\u0441\u043A\u0430\u044F \u0444\u043E\u0440\u0430 " + europeanHandicapCondition(outcome.condition) + " \u0432 1\u043E\u043C \u0442\u0430\u0439\u043C\u0435";
	};
	var bo_f19 = function bo_f19(match, outcome) {
	    return "\u0415\u0432\u0440\u043E\u043F\u0435\u0439\u0441\u043A\u0430\u044F \u0444\u043E\u0440\u0430 " + europeanHandicapCondition(outcome.condition) + " \u0432\u043E 2\u043E\u043C \u0442\u0430\u0439\u043C\u0435";
	};
	var bo_g19 = function bo_g19(match, outcome) {
	    return "\u041A\u0442\u043E \u0437\u0430\u0431\u044C\u0435\u0442 " + numeralMaleEnding(outcome.condition) + " \u0433\u043E\u043B \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0442\u0430\u0439\u043C\u0435?";
	};
	var bo_h19 = function bo_h19(match, outcome) {
	    return "\u041E\u0441\u0442\u0430\u0442\u043E\u043A \u043C\u0430\u0442\u0447\u0430 (\u0442\u0435\u043A\u0443\u0449\u0438\u0439 \u0441\u0447\u0435\u0442 " + outcome.condition + ":" + outcome.conditionTwo + ")";
	};
	var bo_i19 = function bo_i19(match, outcome) {
	    return "\u041E\u0441\u0442\u0430\u0442\u043E\u043A \u043F\u0435\u0440\u0432\u043E\u0433\u043E \u0442\u0430\u0439\u043C\u0430 (\u0442\u0435\u043A\u0443\u0449\u0438\u0439 \u0441\u0447\u0435\u0442 " + outcome.condition + ":" + outcome.conditionTwo + ")";
	};
	var bo_j19 = function bo_j19(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u0443\u0433\u043B\u043E\u0432\u044B\u0445 \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0442\u0430\u0439\u043C\u0435: " + match.homeTeam;
	};
	var bo_k19 = function bo_k19(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u0443\u0433\u043B\u043E\u0432\u044B\u0445 \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0442\u0430\u0439\u043C\u0435: " + match.awayTeam;
	};
	var bo_l19 = function bo_l19(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u0443\u0433\u043B\u043E\u0432\u044B\u0445: " + match.homeTeam;
	};
	var bo_m19 = function bo_m19(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u0443\u0433\u043B\u043E\u0432\u044B\u0445: " + match.awayTeam;
	};
	var bo_n19 = function bo_n19(match, outcome) {
	    return 'Время первого гола (мин)';
	};
	var bo_o19 = function bo_o19(match, outcome) {
	    return 'Двойной исход первого тайма';
	};
	var bo_p19 = function bo_p19(match, outcome) {
	    return 'Двойной исход второго тайма';
	};
	var bo_q19 = function bo_q19(match, outcome) {
	    return 'Обе забьют?';
	};
	var bo_r19 = function bo_r19(match, outcome) {
	    return 'не забитых пенальти';
	};
	var bo_s19 = function bo_s19(match, outcome) {
	    return "\u041F\u043E\u0431\u0435\u0434\u0430 " + match.homeTeam + " \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0442\u0430\u0439\u043C\u0435";
	};
	var bo_t19 = function bo_t19(match, outcome) {
	    return "\u041F\u043E\u0431\u0435\u0434\u0430 " + match.homeTeam + " \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0442\u0430\u0439\u043C\u0435";
	};
	var bo_u19 = function bo_u19(match, outcome) {
	    return "\u041F\u043E\u0431\u0435\u0434\u0430 " + match.awayTeam + " \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0442\u0430\u0439\u043C\u0435";
	};
	var bo_v19 = function bo_v19(match, outcome) {
	    return "\u041F\u043E\u0431\u0435\u0434\u0430 " + match.awayTeam + " \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0442\u0430\u0439\u043C\u0435";
	};
	var bo_w19 = function bo_w19(match, outcome) {
	    return 'Хет-трики (их тотал)';
	};
	var bo_x19 = function bo_x19(match, outcome) {
	    return 'Чет/Нечет первого периода';
	};
	var bo_y19 = function bo_y19(match, outcome) {
	    return 'Чет/Нечет второго периода';
	};
	var bo_z19 = function bo_z19(match, outcome) {
	    return 'Чет/Нечет третьего периода';
	};
	var bo_a20 = function bo_a20(match, outcome) {
	    return 'Самый результативный период (тотал)';
	};
	var bo_b20 = function bo_b20(match, outcome) {
	    return 'Самый нерезультативный период (тотал)';
	};
	var bo_c20 = function bo_c20(match, outcome) {
	    return 'Точный тотал первого периода';
	};
	var bo_d20 = function bo_d20(match, outcome) {
	    return 'Точный тотал второго периода';
	};
	var bo_e20 = function bo_e20(match, outcome) {
	    return 'Точный тотал третьего периода';
	};
	var bo_f20 = function bo_f20(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u043F\u0435\u0440\u0438\u043E\u0434\u0435";
	};
	var bo_g20 = function bo_g20(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u043F\u0435\u0440\u0438\u043E\u0434\u0435";
	};
	var bo_h20 = function bo_h20(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u043F\u0435\u0440\u0438\u043E\u0434\u0435";
	};
	var bo_i20 = function bo_i20(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u043F\u0435\u0440\u0438\u043E\u0434\u0435";
	};
	var bo_j20 = function bo_j20(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u043F\u0435\u0440\u0438\u043E\u0434\u0435";
	};
	var bo_k20 = function bo_k20(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u043F\u0435\u0440\u0438\u043E\u0434\u0435";
	};
	var bo_l20 = function bo_l20(match, outcome) {
	    return 'Обе команды забьют';
	};
	var bo_m20 = function bo_m20(match, outcome) {
	    return "\u0417\u0430\u0431\u044C\u0435\u0442 \u043B\u0438 " + match.homeTeam + " " + numeralMaleEnding(outcome.condition) + " \u0431\u0443\u043B\u043B\u0438\u0442?";
	};
	var bo_n20 = function bo_n20(match, outcome) {
	    return "\u0417\u0430\u0431\u044C\u0435\u0442 \u043B\u0438 " + match.awayTeam + " " + numeralMaleEnding(outcome.condition) + " \u0431\u0443\u043B\u043B\u0438\u0442?";
	};
	var bo_o20 = function bo_o20(match, outcome) {
	    return 'Победа с учетом ОТ';
	};
	var bo_p20 = function bo_p20(match, outcome) {
	    return match.homeTeam + " \u0437\u0430\u0431\u044C\u0435\u0442 \u0432 \u043A\u0430\u0436\u0434\u043E\u043C \u043F\u0435\u0440\u0438\u043E\u0434\u0435";
	};
	var bo_q20 = function bo_q20(match, outcome) {
	    return match.awayTeam + " \u0437\u0430\u0431\u044C\u0435\u0442 \u0432 \u043A\u0430\u0436\u0434\u043E\u043C \u043F\u0435\u0440\u0438\u043E\u0434\u0435";
	};
	var bo_r20 = function bo_r20(match, outcome) {
	    return 'Забьют во всех периодах';
	};
	var bo_s20 = function bo_s20(match, outcome) {
	    return 'Сравнение первого и второго периода';
	};
	var bo_t20 = function bo_t20(match, outcome) {
	    return 'Сравнение первого и третьего периода';
	};
	var bo_u20 = function bo_u20(match, outcome) {
	    return 'Сравнение второго и третьего периода';
	};
	var bo_v20 = function bo_v20(match, outcome) {
	    return match.homeTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0432 \u043E\u0434\u043D\u043E\u043C \u0438\u0437 \u043F\u0435\u0440\u0438\u043E\u0434\u043E\u0432";
	};
	var bo_w20 = function bo_w20(match, outcome) {
	    return match.awayTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0432 \u043E\u0434\u043D\u043E\u043C \u0438\u0437 \u043F\u0435\u0440\u0438\u043E\u0434\u043E\u0432";
	};
	var bo_x20 = function bo_x20(match, outcome) {
	    return 'Ничья хоты бы в одном периоде';
	};
	var bo_y20 = function bo_y20(match, outcome) {
	    return 'Победа в матче с 1 по 10 минуту';
	};
	var bo_z20 = function bo_z20(match, outcome) {
	    return 'Победа в матче с 11 по 20 минуту';
	};
	var bo_a21 = function bo_a21(match, outcome) {
	    return 'Победа в матче с 21 по 30 минуту';
	};
	var bo_b21 = function bo_b21(match, outcome) {
	    return 'Победа в матче с 31 по 40 минуту';
	};
	var bo_c21 = function bo_c21(match, outcome) {
	    return 'Победа в матче с 41 по 50 минуту';
	};
	var bo_d21 = function bo_d21(match, outcome) {
	    return 'Победа в матче с 51 по 60 минуту';
	};
	var bo_e21 = function bo_e21(match, outcome) {
	    return 'Фора в матче с 1 по 10 минуту';
	};
	var bo_f21 = function bo_f21(match, outcome) {
	    return 'Фора в матче с 11 по 20 минуту';
	};
	var bo_g21 = function bo_g21(match, outcome) {
	    return 'Фора в матче с 21 по 30 минуту';
	};
	var bo_h21 = function bo_h21(match, outcome) {
	    return 'Фора в матче с 31 по 40 минуту';
	};
	var bo_i21 = function bo_i21(match, outcome) {
	    return 'Фора в матче с 41 по 50 минуту';
	};
	var bo_j21 = function bo_j21(match, outcome) {
	    return 'Фора в матче с 51 по 60 минуту';
	};
	var bo_k21 = function bo_k21(match, outcome) {
	    return 'Тотал матча с 1 по 10 минуту';
	};
	var bo_l21 = function bo_l21(match, outcome) {
	    return 'Тотал матча с 11 по 20 минуту';
	};
	var bo_m21 = function bo_m21(match, outcome) {
	    return 'Тотал матча с 21 по 30 минуту';
	};
	var bo_n21 = function bo_n21(match, outcome) {
	    return 'Тотал матча с 31 по 40 минуту';
	};
	var bo_o21 = function bo_o21(match, outcome) {
	    return 'Тотал матча с 41 по 50 минуту';
	};
	var bo_p21 = function bo_p21(match, outcome) {
	    return 'Тотал матча с 51 по 60 минуту';
	};
	var bo_q21 = function bo_q21(match, outcome) {
	    return 'Чет/Нечет наибольшего выпавшего шара';
	};
	var bo_r21 = function bo_r21(match, outcome) {
	    return 'Чет/Нечет наименьшего выпавшего шара';
	};
	var bo_s21 = function bo_s21(match, outcome) {
	    return 'Чет/Нечет первого выпавшего шара';
	};
	var bo_t21 = function bo_t21(match, outcome) {
	    return 'Чет/Нечет последнего выпавшего шара';
	};
	var bo_u21 = function bo_u21(match, outcome) {
	    return 'Первый меньше/больше последнего';
	};
	var bo_v21 = function bo_v21(match, outcome) {
	    return 'Все шары четные';
	};
	var bo_w21 = function bo_w21(match, outcome) {
	    return 'Все шары нечетные';
	};
	var bo_x21 = function bo_x21(match, outcome) {
	    return 'Хотя бы два шара с соседними номерами';
	};
	var bo_y21 = function bo_y21(match, outcome) {
	    return 'Наименьший выпавший шар';
	};
	var bo_z21 = function bo_z21(match, outcome) {
	    return 'Наибольший выпавший шар';
	};
	var bo_a22 = function bo_a22(match, outcome) {
	    return 'Сумма выпавших шаров';
	};
	var bo_b22 = function bo_b22(match, outcome) {
	    return "\u0425\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u0438\u043D \u0438\u0437 \u0432\u044B\u043F\u0430\u0432\u0448\u0438\u0445 \u0448\u0430\u0440\u043E\u0432 \u043A\u0440\u0430\u0442\u0435\u043D " + outcome.condition;
	};
	var bo_c22 = function bo_c22(match, outcome) {
	    return 'Разница между наименьшим и наибольшим шарами';
	};
	var bo_d22 = function bo_d22(match, outcome) {
	    return 'Сумма нечетных шаров';
	};
	var bo_e22 = function bo_e22(match, outcome) {
	    return 'Сумма четных шаров';
	};
	var bo_f22 = function bo_f22(match, outcome) {
	    return 'Первый выпавший шар';
	};
	var bo_g22 = function bo_g22(match, outcome) {
	    return 'Второй выпавший шар';
	};
	var bo_h22 = function bo_h22(match, outcome) {
	    return 'Третий выпавший шар';
	};
	var bo_i22 = function bo_i22(match, outcome) {
	    return 'Четвертый выпавший шар';
	};
	var bo_j22 = function bo_j22(match, outcome) {
	    return 'Пятый выпавший шар';
	};
	var bo_k22 = function bo_k22(match, outcome) {
	    return 'Шестой выпавший шар';
	};
	var bo_l22 = function bo_l22(match, outcome) {
	    return 'Седьмой выпавший шар';
	};
	var bo_m22 = function bo_m22(match, outcome) {
	    return "\u0425\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u0438\u043D \u0448\u0430\u0440 \u043F\u043E\u043F\u0430\u0434\u0435\u0442 \u0432 \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B \u043E\u0442 " + outcome.condition + " \u0434\u043E " + outcome.conditionTwo;
	};
	var bo_n22 = function bo_n22(match, outcome) {
	    return 'Сумма наименьшего и наибольшего шаров';
	};
	var bo_o22 = function bo_o22(match, outcome) {
	    return match.homeTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0411\u043E\u043B\u0435\u0432\u044B\u043C/\u0423\u0434\u0443\u0448\u0430\u044E\u0449\u0438\u043C/\u0414\u043E\u0431\u0440\u043E\u0432\u043E\u043B\u044C\u043D\u043E\u0439 \u0441\u0434\u0430\u0447\u0435\u0439";
	};
	var bo_p22 = function bo_p22(match, outcome) {
	    return match.awayTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0411\u043E\u043B\u0435\u0432\u044B\u043C/\u0423\u0434\u0443\u0448\u0430\u044E\u0449\u0438\u043C/\u0414\u043E\u0431\u0440\u043E\u0432\u043E\u043B\u044C\u043D\u043E\u0439 \u0441\u0434\u0430\u0447\u0435\u0439";
	};
	var bo_q22 = function bo_q22(match, outcome) {
	    return match.homeTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u041D\u043E\u043A\u0430\u0443\u0442\u043E\u043C/\u0422\u0435\u0445\u043D\u0438\u0447. \u043D\u043E\u043A\u0430\u0443\u0442\u043E\u043C/\u0414\u0438\u0441\u043A\u0432\u0430\u043B\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0435\u0439";
	};
	var bo_r22 = function bo_r22(match, outcome) {
	    return match.awayTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u041D\u043E\u043A\u0430\u0443\u0442\u043E\u043C/\u0422\u0435\u0445\u043D\u0438\u0447. \u043D\u043E\u043A\u0430\u0443\u0442\u043E\u043C/\u0414\u0438\u0441\u043A\u0432\u0430\u043B\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0435\u0439";
	};
	var bo_s22 = function bo_s22(match, outcome) {
	    return 'Тотал медалей';
	};
	var bo_t22 = function bo_t22(match, outcome) {
	    return 'Результат двадцать девятой партии';
	};
	var bo_u22 = function bo_u22(match, outcome) {
	    return 'Результат тридцатой партии';
	};
	var bo_v22 = function bo_v22(match, outcome) {
	    return 'Результат тридцать первой партии';
	};
	var bo_w22 = function bo_w22(match, outcome) {
	    return 'Результат тридцать второй партии';
	};
	var bo_x22 = function bo_x22(match, outcome) {
	    return 'Результат тридцать третьей партии';
	};
	var bo_y22 = function bo_y22(match, outcome) {
	    return 'Результат тридцать четвертой партии';
	};
	var bo_z22 = function bo_z22(match, outcome) {
	    return 'Результат тридцать пятой партии';
	};
	var bo_a23 = function bo_a23(match, outcome) {
	    return 'Результат тридцать шестой партии';
	};
	var bo_b23 = function bo_b23(match, outcome) {
	    return 'Результат тридцать седьмой партии';
	};
	var bo_c23 = function bo_c23(match, outcome) {
	    return 'Чет/Нечет восемнадцатой партии';
	};
	var bo_d23 = function bo_d23(match, outcome) {
	    return 'Чет/Нечет девятнадцатой партии';
	};
	var bo_e23 = function bo_e23(match, outcome) {
	    return 'Чет/Нечет двадцатой партии';
	};
	var bo_f23 = function bo_f23(match, outcome) {
	    return 'Чет/Нечет двадцать первой партии';
	};
	var bo_g23 = function bo_g23(match, outcome) {
	    return 'Чет/Нечет двадцать второй партии';
	};
	var bo_h23 = function bo_h23(match, outcome) {
	    return 'Чет/Нечет двадцать третьей партии';
	};
	var bo_i23 = function bo_i23(match, outcome) {
	    return 'Чет/Нечет двадцать четвертой партии';
	};
	var bo_j23 = function bo_j23(match, outcome) {
	    return 'Чет/Нечет двадцать пятой партии';
	};
	var bo_k23 = function bo_k23(match, outcome) {
	    return 'Чет/Нечет двадцать шестой партии';
	};
	var bo_l23 = function bo_l23(match, outcome) {
	    return 'Чет/Нечет двадцать седьмой партии';
	};
	var bo_m23 = function bo_m23(match, outcome) {
	    return 'Чет/Нечет двадцать восьмой партии';
	};
	var bo_n23 = function bo_n23(match, outcome) {
	    return 'Чет/Нечет двадцать девятой партии';
	};
	var bo_o23 = function bo_o23(match, outcome) {
	    return 'Чет/Нечет тридцатой партии';
	};
	var bo_p23 = function bo_p23(match, outcome) {
	    return 'Чет/Нечет тридцать первой партии';
	};
	var bo_q23 = function bo_q23(match, outcome) {
	    return 'Чет/Нечет тридцать второй партии';
	};
	var bo_r23 = function bo_r23(match, outcome) {
	    return 'Чет/Нечет тридцать третьей партии';
	};
	var bo_s23 = function bo_s23(match, outcome) {
	    return 'Чет/Нечет тридцать четвертой партии';
	};
	var bo_t23 = function bo_t23(match, outcome) {
	    return 'Чет/Нечет тридцать пятой партии';
	};
	var bo_u23 = function bo_u23(match, outcome) {
	    return 'Чет/Нечет тридцать шестой партии';
	};
	var bo_v23 = function bo_v23(match, outcome) {
	    return 'Чет/Нечет тридцать седьмой партии';
	};
	var bo_w23 = function bo_w23(match, outcome) {
	    return 'Какой цветной шар будет забит первым в первой партии?';
	};
	var bo_x23 = function bo_x23(match, outcome) {
	    return 'Какой цветной шар будет забит первым во второй партии?';
	};
	var bo_y23 = function bo_y23(match, outcome) {
	    return 'Какой цветной шар будет забит первым в третьей партии?';
	};
	var bo_z23 = function bo_z23(match, outcome) {
	    return 'Какой цветной шар будет забит первым в четвертой партии?';
	};
	var bo_a24 = function bo_a24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в пятой партии?';
	};
	var bo_b24 = function bo_b24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в шестой партии?';
	};
	var bo_c24 = function bo_c24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в седьмой партии?';
	};
	var bo_d24 = function bo_d24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в восьмой партии?';
	};
	var bo_e24 = function bo_e24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в девятой партии?';
	};
	var bo_f24 = function bo_f24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в десятой партии?';
	};
	var bo_g24 = function bo_g24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в одиннадцатой партии?';
	};
	var bo_h24 = function bo_h24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в двенадцатой партии?';
	};
	var bo_i24 = function bo_i24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в тринадцатой партии?';
	};
	var bo_j24 = function bo_j24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в четырнадцатой партии?';
	};
	var bo_k24 = function bo_k24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в пятнадцатой партии?';
	};
	var bo_l24 = function bo_l24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в шестнадцатой партии?';
	};
	var bo_m24 = function bo_m24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в семнадцатой партии?';
	};
	var bo_n24 = function bo_n24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в восемнадцатой партии?';
	};
	var bo_o24 = function bo_o24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в девятнадцатой партии?';
	};
	var bo_p24 = function bo_p24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в двадцатой партии?';
	};
	var bo_q24 = function bo_q24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в двадцать первой партии?';
	};
	var bo_r24 = function bo_r24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в двадцать второй партии?';
	};
	var bo_s24 = function bo_s24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в двадцать третьей партии?';
	};
	var bo_t24 = function bo_t24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в двадцать четвертой партии?';
	};
	var bo_u24 = function bo_u24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в двадцать пятой партии?';
	};
	var bo_v24 = function bo_v24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в двадцать шестой партии?';
	};
	var bo_w24 = function bo_w24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в двадцать седьмой партии?';
	};
	var bo_x24 = function bo_x24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в двадцать восьмой партии?';
	};
	var bo_y24 = function bo_y24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в двадцать девятой партии?';
	};
	var bo_z24 = function bo_z24(match, outcome) {
	    return 'Какой цветной шар будет забит первым в тридцатой партии?';
	};
	var bo_a25 = function bo_a25(match, outcome) {
	    return 'Какой цветной шар будет забит первым в тридцать первой партии?';
	};
	var bo_b25 = function bo_b25(match, outcome) {
	    return 'Какой цветной шар будет забит первым в тридцать второй партии?';
	};
	var bo_c25 = function bo_c25(match, outcome) {
	    return 'Какой цветной шар будет забит первым в тридцать третьей партии?';
	};
	var bo_d25 = function bo_d25(match, outcome) {
	    return 'Какой цветной шар будет забит первым в тридцать четвертой партии?';
	};
	var bo_e25 = function bo_e25(match, outcome) {
	    return 'Какой цветной шар будет забит первым в тридцать пятой партии?';
	};
	var bo_f25 = function bo_f25(match, outcome) {
	    return 'Какой цветной шар будет забит первым в тридцать шестой партии?';
	};
	var bo_g25 = function bo_g25(match, outcome) {
	    return 'Какой цветной шар будет забит первым в тридцать седьмой партии?';
	};
	var bo_h25 = function bo_h25(match, outcome) {
	    return 'Результат первой партии';
	};
	var bo_i25 = function bo_i25(match, outcome) {
	    return 'Результат второй партии';
	};
	var bo_j25 = function bo_j25(match, outcome) {
	    return 'Результат третьей партии';
	};
	var bo_k25 = function bo_k25(match, outcome) {
	    return 'Результат четвертой партии';
	};
	var bo_l25 = function bo_l25(match, outcome) {
	    return 'Результат пятой партии';
	};
	var bo_m25 = function bo_m25(match, outcome) {
	    return 'Результат шестой партии';
	};
	var bo_n25 = function bo_n25(match, outcome) {
	    return 'Результат седьмой партии';
	};
	var bo_o25 = function bo_o25(match, outcome) {
	    return 'Результат восьмой партии';
	};
	var bo_p25 = function bo_p25(match, outcome) {
	    return 'Результат девятой партии';
	};
	var bo_q25 = function bo_q25(match, outcome) {
	    return 'Результат десятой партии';
	};
	var bo_r25 = function bo_r25(match, outcome) {
	    return 'Результат одиннадцатой партии';
	};
	var bo_s25 = function bo_s25(match, outcome) {
	    return 'Результат двенадцатой партии';
	};
	var bo_t25 = function bo_t25(match, outcome) {
	    return 'Результат тринадцатой партии';
	};
	var bo_u25 = function bo_u25(match, outcome) {
	    return 'Результат четырнадцатой партии';
	};
	var bo_v25 = function bo_v25(match, outcome) {
	    return 'Результат пятнадцатой партии';
	};
	var bo_w25 = function bo_w25(match, outcome) {
	    return 'Результат шестнадцатой партии';
	};
	var bo_x25 = function bo_x25(match, outcome) {
	    return 'Результат семнадцатой партии';
	};
	var bo_y25 = function bo_y25(match, outcome) {
	    return 'Результат восемнадцатой партии';
	};
	var bo_z25 = function bo_z25(match, outcome) {
	    return 'Результат девятнадцатой партии';
	};
	var bo_a26 = function bo_a26(match, outcome) {
	    return 'Результат двадцатой партии';
	};
	var bo_b26 = function bo_b26(match, outcome) {
	    return 'Результат двадцать первой партии';
	};
	var bo_c26 = function bo_c26(match, outcome) {
	    return 'Результат двадцать второй партии';
	};
	var bo_d26 = function bo_d26(match, outcome) {
	    return 'Результат двадцать третьей партии';
	};
	var bo_e26 = function bo_e26(match, outcome) {
	    return 'Результат двадцать четвертой партии';
	};
	var bo_f26 = function bo_f26(match, outcome) {
	    return 'Результат двадцать пятой партии';
	};
	var bo_g26 = function bo_g26(match, outcome) {
	    return 'Результат двадцать шестой партии';
	};
	var bo_h26 = function bo_h26(match, outcome) {
	    return 'Результат двадцать седьмой партии';
	};
	var bo_i26 = function bo_i26(match, outcome) {
	    return 'Результат двадцать восьмой партии';
	};
	var bo_j26 = function bo_j26(match, outcome) {
	    return 'Кто первым(ой) забьет шар в седьмой партии ?';
	};
	var bo_k26 = function bo_k26(match, outcome) {
	    return 'Кто первым(ой) забьет шар в восьмой партии ?';
	};
	var bo_l26 = function bo_l26(match, outcome) {
	    return 'Кто первым(ой) забьет шар в девятой партии ?';
	};
	var bo_m26 = function bo_m26(match, outcome) {
	    return 'Кто первым(ой) забьет шар в десятой партии ?';
	};
	var bo_n26 = function bo_n26(match, outcome) {
	    return 'Кто первым(ой) забьет шар в одиннадцатой партии ?';
	};
	var bo_o26 = function bo_o26(match, outcome) {
	    return 'Кто первым(ой) забьет шар в двенадцатой партии ?';
	};
	var bo_p26 = function bo_p26(match, outcome) {
	    return 'Кто первым(ой) забьет шар в тринадцатой партии ?';
	};
	var bo_q26 = function bo_q26(match, outcome) {
	    return 'Кто первым(ой) забьет шар в четырнадцатой партии ?';
	};
	var bo_r26 = function bo_r26(match, outcome) {
	    return 'Кто первым(ой) забьет шар в пятнадцатой партии ?';
	};
	var bo_s26 = function bo_s26(match, outcome) {
	    return 'Кто первым(ой) забьет шар в шестнадцатой партии ?';
	};
	var bo_t26 = function bo_t26(match, outcome) {
	    return 'Кто первым(ой) забьет шар в семнадцатой партии ?';
	};
	var bo_u26 = function bo_u26(match, outcome) {
	    return 'Кто первым(ой) забьет шар в восемнадцатой партии ?';
	};
	var bo_v26 = function bo_v26(match, outcome) {
	    return 'Кто первым(ой) забьет шар в девятнадцатой партии ?';
	};
	var bo_w26 = function bo_w26(match, outcome) {
	    return 'Кто первым(ой) забьет шар в двадцатой партии ?';
	};
	var bo_x26 = function bo_x26(match, outcome) {
	    return 'Кто первым(ой) забьет шар в двадцать первой партии ?';
	};
	var bo_y26 = function bo_y26(match, outcome) {
	    return 'Кто первым(ой) забьет шар в двадцать второй партии ?';
	};
	var bo_z26 = function bo_z26(match, outcome) {
	    return 'Кто первым(ой) забьет шар в двадцать третьей партии ?';
	};
	var bo_a27 = function bo_a27(match, outcome) {
	    return 'Кто первым(ой) забьет шар в двадцать четвертой партии ?';
	};
	var bo_b27 = function bo_b27(match, outcome) {
	    return 'Кто первым(ой) забьет шар в двадцать пятой партии ?';
	};
	var bo_c27 = function bo_c27(match, outcome) {
	    return 'Кто первым(ой) забьет шар в двадцать шестой партии ?';
	};
	var bo_d27 = function bo_d27(match, outcome) {
	    return 'Кто первым(ой) забьет шар в двадцать седьмой партии ?';
	};
	var bo_e27 = function bo_e27(match, outcome) {
	    return 'Кто первым(ой) забьет шар в двадцать восьмой партии ?';
	};
	var bo_f27 = function bo_f27(match, outcome) {
	    return 'Кто первым(ой) забьет шар в двадцать девятой партии ?';
	};
	var bo_g27 = function bo_g27(match, outcome) {
	    return 'Кто первым(ой) забьет шар в тридцатой партии ?';
	};
	var bo_h27 = function bo_h27(match, outcome) {
	    return 'Кто первым(ой) забьет шар в тридцать первой партии ?';
	};
	var bo_i27 = function bo_i27(match, outcome) {
	    return 'Кто первым(ой) забьет шар в тридцать второй партии ?';
	};
	var bo_j27 = function bo_j27(match, outcome) {
	    return 'Кто первым(ой) забьет шар в тридцать третьей партии ?';
	};
	var bo_k27 = function bo_k27(match, outcome) {
	    return 'Кто первым(ой) забьет шар в тридцать четвертой партии ?';
	};
	var bo_l27 = function bo_l27(match, outcome) {
	    return 'Кто первым(ой) забьет шар в тридцать пятой партии ?';
	};
	var bo_m27 = function bo_m27(match, outcome) {
	    return 'Кто первым(ой) забьет шар в тридцать шестой партии ?';
	};
	var bo_n27 = function bo_n27(match, outcome) {
	    return 'Кто первым(ой) забьет шар в тридцать седьмой партии ?';
	};
	var bo_o27 = function bo_o27(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_p27 = function bo_p27(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_q27 = function bo_q27(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_r27 = function bo_r27(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_s27 = function bo_s27(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u043F\u044F\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_t27 = function bo_t27(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0448\u0435\u0441\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_u27 = function bo_u27(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0441\u0435\u0434\u044C\u043C\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_v27 = function bo_v27(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0432\u043E\u0441\u044C\u043C\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_w27 = function bo_w27(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0434\u0435\u0432\u044F\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_x27 = function bo_x27(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0434\u0435\u0441\u044F\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_y27 = function bo_y27(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u043E\u0434\u0438\u043D\u043D\u0430\u0434\u0446\u0430\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_z27 = function bo_z27(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0434\u0432\u0435\u043D\u0430\u0434\u0446\u0430\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_a28 = function bo_a28(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0442\u0440\u0438\u043D\u0430\u0434\u0446\u0430\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_b28 = function bo_b28(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0447\u0435\u0442\u044B\u0440\u043D\u0430\u0434\u0446\u0430\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_c28 = function bo_c28(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u043F\u044F\u0442\u043D\u0430\u0434\u0446\u0430\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_d28 = function bo_d28(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0448\u0435\u0441\u0442\u043D\u0430\u0434\u0446\u0430\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_e28 = function bo_e28(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0441\u0435\u043C\u043D\u0430\u0434\u0446\u0430\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_f28 = function bo_f28(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0432\u043E\u0441\u0435\u043C\u043D\u0430\u0434\u0446\u0430\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_g28 = function bo_g28(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0434\u0435\u0432\u044F\u0442\u043D\u0430\u0434\u0446\u0430\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_h28 = function bo_h28(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0434\u0432\u0430\u0434\u0446\u0430\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_i28 = function bo_i28(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0434\u0432\u0430\u0434\u0446\u0430\u0442\u044C \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_j28 = function bo_j28(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0434\u0432\u0430\u0434\u0446\u0430\u0442\u044C \u0432\u0442\u043E\u0440\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_k28 = function bo_k28(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0434\u0432\u0430\u0434\u0446\u0430\u0442\u044C \u0442\u0440\u0435\u0442\u044C\u0435\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_l28 = function bo_l28(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0434\u0432\u0430\u0434\u0446\u0430\u0442\u044C \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_m28 = function bo_m28(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0434\u0432\u0430\u0434\u0446\u0430\u0442\u044C \u043F\u044F\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_n28 = function bo_n28(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0434\u0432\u0430\u0434\u0446\u0430\u0442\u044C \u0448\u0435\u0441\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_o28 = function bo_o28(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0434\u0432\u0430\u0434\u0446\u0430\u0442\u044C \u0441\u0435\u0434\u044C\u043C\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_p28 = function bo_p28(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0434\u0432\u0430\u0434\u0446\u0430\u0442\u044C \u0432\u043E\u0441\u044C\u043C\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_q28 = function bo_q28(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0434\u0432\u0430\u0434\u0446\u0430\u0442\u044C \u0434\u0435\u0432\u044F\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_r28 = function bo_r28(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0442\u0440\u0438\u0434\u0446\u0430\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_s28 = function bo_s28(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0442\u0440\u0438\u0434\u0446\u0430\u0442\u044C \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_t28 = function bo_t28(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0442\u0440\u0438\u0434\u0446\u0430\u0442\u044C \u0432\u0442\u043E\u0440\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_u28 = function bo_u28(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0442\u0440\u0438\u0434\u0446\u0430\u0442\u044C \u0442\u0440\u0435\u0442\u044C\u0435\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_v28 = function bo_v28(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0442\u0440\u0438\u0434\u0446\u0430\u0442\u044C \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_w28 = function bo_w28(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0442\u0440\u0438\u0434\u0446\u0430\u0442\u044C \u043F\u044F\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_x28 = function bo_x28(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0442\u0440\u0438\u0434\u0446\u0430\u0442\u044C \u0448\u0435\u0441\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_y28 = function bo_y28(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0442\u0440\u0438\u0434\u0446\u0430\u0442\u044C \u0441\u0435\u0434\u044C\u043C\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_z28 = function bo_z28(match, outcome) {
	    return 'Чет/Нечет первой партии';
	};
	var bo_a29 = function bo_a29(match, outcome) {
	    return 'Чет/Нечет второй партии';
	};
	var bo_b29 = function bo_b29(match, outcome) {
	    return 'Чет/Нечет третьей партии';
	};
	var bo_c29 = function bo_c29(match, outcome) {
	    return 'Чет/Нечет четвертой партии';
	};
	var bo_d29 = function bo_d29(match, outcome) {
	    return 'Чет/Нечет пятой партии';
	};
	var bo_e29 = function bo_e29(match, outcome) {
	    return 'Чет/Нечет шестой партии';
	};
	var bo_f29 = function bo_f29(match, outcome) {
	    return 'Чет/Нечет седьмой партии';
	};
	var bo_g29 = function bo_g29(match, outcome) {
	    return 'Чет/Нечет восьмой партии';
	};
	var bo_h29 = function bo_h29(match, outcome) {
	    return 'Чет/Нечет девятой партии';
	};
	var bo_i29 = function bo_i29(match, outcome) {
	    return 'Чет/Нечет десятой партии';
	};
	var bo_j29 = function bo_j29(match, outcome) {
	    return 'Чет/Нечет одиннадцатой партии';
	};
	var bo_k29 = function bo_k29(match, outcome) {
	    return 'Чет/Нечет двенадцатой партии';
	};
	var bo_l29 = function bo_l29(match, outcome) {
	    return 'Чет/Нечет тринадцатой партии';
	};
	var bo_m29 = function bo_m29(match, outcome) {
	    return 'Чет/Нечет четырнадцатой партии';
	};
	var bo_n29 = function bo_n29(match, outcome) {
	    return 'Чет/Нечет пятнадцатой партии';
	};
	var bo_o29 = function bo_o29(match, outcome) {
	    return 'Чет/Нечет шестнадцатой партии';
	};
	var bo_p29 = function bo_p29(match, outcome) {
	    return 'Чет/Нечет семнадцатой партии';
	};
	var bo_q29 = function bo_q29(match, outcome) {
	    return 'Тотал сенчури брейков в матче';
	};
	var bo_r29 = function bo_r29(match, outcome) {
	    return 'Фора в первой партии';
	};
	var bo_s29 = function bo_s29(match, outcome) {
	    return 'Фора во второй партии';
	};
	var bo_t29 = function bo_t29(match, outcome) {
	    return 'Фора в третьей партии';
	};
	var bo_u29 = function bo_u29(match, outcome) {
	    return 'Фора в четвертой партии';
	};
	var bo_v29 = function bo_v29(match, outcome) {
	    return 'Фора в пятой партии';
	};
	var bo_w29 = function bo_w29(match, outcome) {
	    return 'Фора в шестой партии';
	};
	var bo_x29 = function bo_x29(match, outcome) {
	    return 'Фора в седьмой партии';
	};
	var bo_y29 = function bo_y29(match, outcome) {
	    return 'Фора в восьмой партии';
	};
	var bo_z29 = function bo_z29(match, outcome) {
	    return 'Фора в девятой партии';
	};
	var bo_a30 = function bo_a30(match, outcome) {
	    return 'Фора в десятой партии';
	};
	var bo_b30 = function bo_b30(match, outcome) {
	    return 'Фора в одиннадцатой партии';
	};
	var bo_c30 = function bo_c30(match, outcome) {
	    return 'Фора в двенадцатой партии';
	};
	var bo_d30 = function bo_d30(match, outcome) {
	    return 'Фора в тринадцатой партии';
	};
	var bo_e30 = function bo_e30(match, outcome) {
	    return 'Фора в четырнадцатой партии';
	};
	var bo_f30 = function bo_f30(match, outcome) {
	    return 'Фора в пятнадцатой партии';
	};
	var bo_g30 = function bo_g30(match, outcome) {
	    return 'Фора в шестнадцатой партии';
	};
	var bo_h30 = function bo_h30(match, outcome) {
	    return 'Фора в семнадцатой партии';
	};
	var bo_i30 = function bo_i30(match, outcome) {
	    return 'Фора в восемнадцатой партии';
	};
	var bo_j30 = function bo_j30(match, outcome) {
	    return 'Фора в девятнадцатой партии';
	};
	var bo_k30 = function bo_k30(match, outcome) {
	    return 'Фора в двадцатой партии';
	};
	var bo_l30 = function bo_l30(match, outcome) {
	    return 'Фора в двадцать первой партии';
	};
	var bo_m30 = function bo_m30(match, outcome) {
	    return 'Фора в двадцать второй партии';
	};
	var bo_n30 = function bo_n30(match, outcome) {
	    return 'Фора в двадцать третьей партии';
	};
	var bo_o30 = function bo_o30(match, outcome) {
	    return 'Фора в двадцать четвертой партии';
	};
	var bo_p30 = function bo_p30(match, outcome) {
	    return 'Фора в двадцать пятой партии';
	};
	var bo_q30 = function bo_q30(match, outcome) {
	    return 'Фора в двадцать шестой партии';
	};
	var bo_r30 = function bo_r30(match, outcome) {
	    return 'Фора в двадцать седьмой партии';
	};
	var bo_s30 = function bo_s30(match, outcome) {
	    return 'Фора в двадцать восьмой партии';
	};
	var bo_t30 = function bo_t30(match, outcome) {
	    return 'Фора в двадцать девятой партии';
	};
	var bo_u30 = function bo_u30(match, outcome) {
	    return 'Фора в тридцатой партии';
	};
	var bo_v30 = function bo_v30(match, outcome) {
	    return 'Фора в тридцать первой партии';
	};
	var bo_w30 = function bo_w30(match, outcome) {
	    return 'Фора в тридцать второй партии';
	};
	var bo_x30 = function bo_x30(match, outcome) {
	    return 'Фора в тридцать третьей партии';
	};
	var bo_y30 = function bo_y30(match, outcome) {
	    return 'Фора в тридцать четвертой партии';
	};
	var bo_z30 = function bo_z30(match, outcome) {
	    return 'Фора в тридцать пятой партии';
	};
	var bo_a31 = function bo_a31(match, outcome) {
	    return 'Фора в тридцать шестой партии';
	};
	var bo_b31 = function bo_b31(match, outcome) {
	    return 'Фора в тридцать седьмой партии';
	};
	var bo_c31 = function bo_c31(match, outcome) {
	    return 'Тотал первой партии';
	};
	var bo_d31 = function bo_d31(match, outcome) {
	    return 'Тотал второй партии';
	};
	var bo_e31 = function bo_e31(match, outcome) {
	    return 'Тотал третьей партии';
	};
	var bo_f31 = function bo_f31(match, outcome) {
	    return 'Тотал четвертой партии';
	};
	var bo_g31 = function bo_g31(match, outcome) {
	    return 'Тотал пятой партии';
	};
	var bo_h31 = function bo_h31(match, outcome) {
	    return 'Тотал шестой партии';
	};
	var bo_i31 = function bo_i31(match, outcome) {
	    return 'Тотал седьмой партии';
	};
	var bo_j31 = function bo_j31(match, outcome) {
	    return 'Тотал восьмой партии';
	};
	var bo_k31 = function bo_k31(match, outcome) {
	    return 'Тотал девятой партии';
	};
	var bo_l31 = function bo_l31(match, outcome) {
	    return 'Тотал десятой партии';
	};
	var bo_m31 = function bo_m31(match, outcome) {
	    return 'Тотал одиннадцатой партии';
	};
	var bo_n31 = function bo_n31(match, outcome) {
	    return 'Тотал двенадцатой партии';
	};
	var bo_o31 = function bo_o31(match, outcome) {
	    return 'Тотал тринадцатой партии';
	};
	var bo_p31 = function bo_p31(match, outcome) {
	    return 'Тотал четырнадцатой партии';
	};
	var bo_q31 = function bo_q31(match, outcome) {
	    return 'Тотал пятнадцатой партии';
	};
	var bo_r31 = function bo_r31(match, outcome) {
	    return 'Тотал шестнадцатой партии';
	};
	var bo_s31 = function bo_s31(match, outcome) {
	    return 'Тотал семнадцатой партии';
	};
	var bo_t31 = function bo_t31(match, outcome) {
	    return 'Тотал восемнадцатой партии';
	};
	var bo_u31 = function bo_u31(match, outcome) {
	    return 'Тотал девятнадцатой партии';
	};
	var bo_v31 = function bo_v31(match, outcome) {
	    return 'Тотал двадцатой партии';
	};
	var bo_w31 = function bo_w31(match, outcome) {
	    return 'Тотал двадцать первой партии';
	};
	var bo_x31 = function bo_x31(match, outcome) {
	    return 'Тотал двадцать второй партии';
	};
	var bo_y31 = function bo_y31(match, outcome) {
	    return 'Тотал двадцать третьей партии';
	};
	var bo_z31 = function bo_z31(match, outcome) {
	    return 'Тотал двадцать четвертой партии';
	};
	var bo_a32 = function bo_a32(match, outcome) {
	    return 'Тотал двадцать пятой партии';
	};
	var bo_b32 = function bo_b32(match, outcome) {
	    return 'Тотал двадцать шестой партии';
	};
	var bo_c32 = function bo_c32(match, outcome) {
	    return 'Тотал двадцать седьмой партии';
	};
	var bo_d32 = function bo_d32(match, outcome) {
	    return 'Тотал двадцать восьмой партии';
	};
	var bo_e32 = function bo_e32(match, outcome) {
	    return 'Тотал двадцать девятой партии';
	};
	var bo_f32 = function bo_f32(match, outcome) {
	    return 'Тотал тридцатой партии';
	};
	var bo_g32 = function bo_g32(match, outcome) {
	    return 'Тотал тридцать первой партии';
	};
	var bo_h32 = function bo_h32(match, outcome) {
	    return 'Тотал тридцать второй партии';
	};
	var bo_i32 = function bo_i32(match, outcome) {
	    return 'Тотал тридцать третьей партии';
	};
	var bo_j32 = function bo_j32(match, outcome) {
	    return 'Тотал тридцать четвертой партии';
	};
	var bo_k32 = function bo_k32(match, outcome) {
	    return 'Тотал тридцать пятой партии';
	};
	var bo_l32 = function bo_l32(match, outcome) {
	    return 'Тотал тридцать шестой партии';
	};
	var bo_m32 = function bo_m32(match, outcome) {
	    return 'Тотал тридцать седьмой партии';
	};
	var bo_n32 = function bo_n32(match, outcome) {
	    return 'Кто первым(ой) забьет шар в первой партии ?';
	};
	var bo_o32 = function bo_o32(match, outcome) {
	    return 'Кто первым(ой) забьет шар во второй партии ?';
	};
	var bo_p32 = function bo_p32(match, outcome) {
	    return 'Кто первым(ой) забьет шар в третьей партии ?';
	};
	var bo_q32 = function bo_q32(match, outcome) {
	    return 'Кто первым(ой) забьет шар в четвертой партии ?';
	};
	var bo_r32 = function bo_r32(match, outcome) {
	    return 'Кто первым(ой) забьет шар в пятой партии ?';
	};
	var bo_s32 = function bo_s32(match, outcome) {
	    return 'Кто первым(ой) забьет шар в шестой партии ?';
	};
	var bo_t32 = function bo_t32(match, outcome) {
	    return 'Тотал партий в матче';
	};
	var bo_u32 = function bo_u32(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0432 \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_v32 = function bo_v32(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_w32 = function bo_w32(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_x32 = function bo_x32(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_y32 = function bo_y32(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0432 \u043F\u044F\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_z32 = function bo_z32(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0432 \u0448\u0435\u0441\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_a33 = function bo_a33(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0432 \u0441\u0435\u0434\u044C\u043C\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_b33 = function bo_b33(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0432 \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_c33 = function bo_c33(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_d33 = function bo_d33(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_e33 = function bo_e33(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_f33 = function bo_f33(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0432 \u043F\u044F\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_g33 = function bo_g33(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0432 \u0448\u0435\u0441\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_h33 = function bo_h33(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0432 \u0441\u0435\u0434\u044C\u043C\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_i33 = function bo_i33(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432 1\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_j33 = function bo_j33(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432\u043E 2\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_k33 = function bo_k33(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432 3\u0435\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_l33 = function bo_l33(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432 4\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_m33 = function bo_m33(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432\u043E 5\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_n33 = function bo_n33(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432 6\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_o33 = function bo_o33(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432 7\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_p33 = function bo_p33(match, outcome) {
	    return match.homeTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432 \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_q33 = function bo_q33(match, outcome) {
	    return match.homeTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_r33 = function bo_r33(match, outcome) {
	    return match.homeTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_s33 = function bo_s33(match, outcome) {
	    return match.homeTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_t33 = function bo_t33(match, outcome) {
	    return match.homeTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432 \u043F\u044F\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_u33 = function bo_u33(match, outcome) {
	    return match.homeTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432 \u0448\u0435\u0441\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_v33 = function bo_v33(match, outcome) {
	    return match.homeTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432 \u0441\u0435\u0434\u044C\u043C\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_w33 = function bo_w33(match, outcome) {
	    return match.awayTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432 \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_x33 = function bo_x33(match, outcome) {
	    return match.awayTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_y33 = function bo_y33(match, outcome) {
	    return match.awayTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_z33 = function bo_z33(match, outcome) {
	    return match.awayTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_a34 = function bo_a34(match, outcome) {
	    return match.awayTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432 \u043F\u044F\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_b34 = function bo_b34(match, outcome) {
	    return match.awayTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432 \u0448\u0435\u0441\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_c34 = function bo_c34(match, outcome) {
	    return match.awayTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очка', 'очков']) + " \u0432 \u0441\u0435\u0434\u044C\u043C\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_d34 = function bo_d34(match, outcome) {
	    return 'Точный тотал первой партии';
	};
	var bo_e34 = function bo_e34(match, outcome) {
	    return 'Точный тотал второй партии';
	};
	var bo_f34 = function bo_f34(match, outcome) {
	    return 'Точный тотал третьей партии';
	};
	var bo_g34 = function bo_g34(match, outcome) {
	    return 'Точный тотал четвертой партии';
	};
	var bo_h34 = function bo_h34(match, outcome) {
	    return 'Точный тотал пятой партии';
	};
	var bo_i34 = function bo_i34(match, outcome) {
	    return 'Точный тотал шестой партии';
	};
	var bo_j34 = function bo_j34(match, outcome) {
	    return 'Точный тотал седьмой партии';
	};
	var bo_k34 = function bo_k34(match, outcome) {
	    return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 " + numeralNeuterEnding(outcome.condition) + " \u043E\u0447\u043A\u043E \u0432 \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_l34 = function bo_l34(match, outcome) {
	    return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 " + numeralNeuterEnding(outcome.condition) + " \u043E\u0447\u043A\u043E \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_m34 = function bo_m34(match, outcome) {
	    return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 " + numeralNeuterEnding(outcome.condition) + " \u043E\u0447\u043A\u043E \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_n34 = function bo_n34(match, outcome) {
	    return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 " + numeralNeuterEnding(outcome.condition) + " \u043E\u0447\u043A\u043E \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_o34 = function bo_o34(match, outcome) {
	    return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 " + numeralNeuterEnding(outcome.condition) + " \u043E\u0447\u043A\u043E \u0432 \u043F\u044F\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_p34 = function bo_p34(match, outcome) {
	    return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 " + numeralNeuterEnding(outcome.condition) + " \u043E\u0447\u043A\u043E \u0432 \u0448\u0435\u0441\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_q34 = function bo_q34(match, outcome) {
	    return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 " + numeralNeuterEnding(outcome.condition) + " \u043E\u0447\u043A\u043E \u0432 \u0441\u0435\u0434\u044C\u043C\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438";
	};
	var bo_r34 = function bo_r34(match, outcome) {
	    return 'Чет/Нечет тотала первого периода';
	};
	var bo_s34 = function bo_s34(match, outcome) {
	    return 'Чет/Нечет тотала второго периода';
	};
	var bo_t34 = function bo_t34(match, outcome) {
	    return 'Чет/Нечет тотала третьего периода';
	};
	var bo_u34 = function bo_u34(match, outcome) {
	    return 'Чет/Нечет тотала четвертого периода';
	};
	var bo_v34 = function bo_v34(match, outcome) {
	    return 'Чет/Нечет тотала пятого периода';
	};
	var bo_w34 = function bo_w34(match, outcome) {
	    return 'Чет/Нечет тотала шестого периода';
	};
	var bo_x34 = function bo_x34(match, outcome) {
	    return 'Чет/Нечет тотала седьмого периода';
	};
	var bo_y34 = function bo_y34(match, outcome) {
	    return 'Точный счет матча';
	};
	var bo_z34 = function bo_z34(match, outcome) {
	    return match.awayTeam + " \u0441\u0434\u0435\u043B\u0430\u0435\u0442 \u0431\u0440\u0435\u0439\u043A \u0432 1-\u043C \u0438\u043B\u0438 \u0432\u043E 2-\u043C \u0433\u0435\u0439\u043C\u0430\u0445";
	};
	var bo_a35 = function bo_a35(match, outcome) {
	    return 'Максимальное количество геймов взятых подряд теннисистом';
	};
	var bo_b35 = function bo_b35(match, outcome) {
	    return 'Будет ли обмен брейками (два подряд)?';
	};
	var bo_c35 = function bo_c35(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_d35 = function bo_d35(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0432 \u043F\u044F\u0442\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_e35 = function bo_e35(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_f35 = function bo_f35(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0432 \u043F\u044F\u0442\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_g35 = function bo_g35(match, outcome) {
	    return 'Чет/Нечет четвертого сета';
	};
	var bo_h35 = function bo_h35(match, outcome) {
	    return 'Чет/Нечет пятого сета';
	};
	var bo_i35 = function bo_i35(match, outcome) {
	    return 'Первый сет/матч';
	};
	var bo_j35 = function bo_j35(match, outcome) {
	    return "\u0411\u0440\u0435\u0439\u043A \u043F\u043E\u0439\u043D\u0442 \u0432 " + outcome.condition + " \u0433\u0435\u0439\u043C\u0435";
	};
	var bo_k35 = function bo_k35(match, outcome) {
	    return 'Тотал брейков во втором сете';
	};
	var bo_l35 = function bo_l35(match, outcome) {
	    return 'Тотал брейков в третьем сете';
	};
	var bo_m35 = function bo_m35(match, outcome) {
	    return 'Тотал брейков в четвертом сете';
	};
	var bo_n35 = function bo_n35(match, outcome) {
	    return 'Тотал брейков в пятом сете';
	};
	var bo_o35 = function bo_o35(match, outcome) {
	    return "\u041F\u043E\u0431\u0435\u0434\u0430 \u0438 \u0442\u043E\u0442\u0430\u043B \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u0433\u043E \u0441\u0435\u0442\u0430 " + outcome.condition;
	};
	var bo_p35 = function bo_p35(match, outcome) {
	    return "\u041F\u043E\u0431\u0435\u0434\u0430 \u0438 \u0442\u043E\u0442\u0430\u043B \u043F\u044F\u0442\u043E\u0433\u043E \u0441\u0435\u0442\u0430 " + outcome.condition;
	};
	var bo_q35 = function bo_q35(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: " + match.homeTeam + " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_r35 = function bo_r35(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: " + match.homeTeam + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_s35 = function bo_s35(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: " + match.homeTeam + " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_t35 = function bo_t35(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: " + match.homeTeam + " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_u35 = function bo_u35(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: " + match.homeTeam + " \u0432 \u043F\u044F\u0442\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_v35 = function bo_v35(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: " + match.awayTeam + " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_w35 = function bo_w35(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: " + match.awayTeam + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_x35 = function bo_x35(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: " + match.awayTeam + " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_y35 = function bo_y35(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: " + match.awayTeam + " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_z35 = function bo_z35(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: " + match.awayTeam + " \u0432 \u043F\u044F\u0442\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_a36 = function bo_a36(match, outcome) {
	    return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 \u043A\u0442\u043E-\u043D\u0438\u0431\u0443\u0434\u044C \u043F\u043E\u0434\u0440\u044F\u0434 " + outcome.condition + " " + plural(outcome.condition, ['гейм', 'гейма', 'геймов']) + " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0441\u0435\u0442\u0435?";
	};
	var bo_b36 = function bo_b36(match, outcome) {
	    return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 \u043A\u0442\u043E-\u043D\u0438\u0431\u0443\u0434\u044C \u043F\u043E\u0434\u0440\u044F\u0434 " + outcome.condition + " " + plural(outcome.condition, ['гейм', 'гейма', 'геймов']) + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0441\u0435\u0442\u0435?";
	};
	var bo_c36 = function bo_c36(match, outcome) {
	    return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 \u043A\u0442\u043E-\u043D\u0438\u0431\u0443\u0434\u044C \u043F\u043E\u0434\u0440\u044F\u0434 " + outcome.condition + " " + plural(outcome.condition, ['гейм', 'гейма', 'геймов']) + " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u0441\u0435\u0442\u0435?";
	};
	var bo_d36 = function bo_d36(match, outcome) {
	    return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 \u043A\u0442\u043E-\u043D\u0438\u0431\u0443\u0434\u044C \u043F\u043E\u0434\u0440\u044F\u0434 " + outcome.condition + " " + plural(outcome.condition, ['гейм', 'гейма', 'геймов']) + " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u043C \u0441\u0435\u0442\u0435?";
	};
	var bo_e36 = function bo_e36(match, outcome) {
	    return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 \u043A\u0442\u043E-\u043D\u0438\u0431\u0443\u0434\u044C \u043F\u043E\u0434\u0440\u044F\u0434 " + outcome.condition + " " + plural(outcome.condition, ['гейм', 'гейма', 'геймов']) + " \u0432 \u043F\u044F\u0442\u043E\u043C \u0441\u0435\u0442\u0435?";
	};
	var bo_f36 = function bo_f36(match, outcome) {
	    return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 " + match.homeTeam + " \u043F\u043E\u0434\u0440\u044F\u0434 " + outcome.condition + " " + plural(outcome.condition, ['гейм', 'гейма', 'геймов']) + " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0441\u0435\u0442\u0435?";
	};
	var bo_g36 = function bo_g36(match, outcome) {
	    return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 " + match.homeTeam + " \u043F\u043E\u0434\u0440\u044F\u0434 " + outcome.condition + " " + plural(outcome.condition, ['гейм', 'гейма', 'геймов']) + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0441\u0435\u0442\u0435?";
	};
	var bo_h36 = function bo_h36(match, outcome) {
	    return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 " + match.homeTeam + " \u043F\u043E\u0434\u0440\u044F\u0434 " + outcome.condition + " " + plural(outcome.condition, ['гейм', 'гейма', 'геймов']) + " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u0441\u0435\u0442\u0435?";
	};
	var bo_i36 = function bo_i36(match, outcome) {
	    return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 " + match.homeTeam + " \u043F\u043E\u0434\u0440\u044F\u0434 " + outcome.condition + " " + plural(outcome.condition, ['гейм', 'гейма', 'геймов']) + " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u043C \u0441\u0435\u0442\u0435?";
	};
	var bo_j36 = function bo_j36(match, outcome) {
	    return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 " + match.homeTeam + " \u043F\u043E\u0434\u0440\u044F\u0434 " + outcome.condition + " " + plural(outcome.condition, ['гейм', 'гейма', 'геймов']) + " \u0432 \u043F\u044F\u0442\u043E\u043C \u0441\u0435\u0442\u0435?";
	};
	var bo_k36 = function bo_k36(match, outcome) {
	    return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 " + match.awayTeam + " \u043F\u043E\u0434\u0440\u044F\u0434 " + outcome.condition + " " + plural(outcome.condition, ['гейм', 'гейма', 'геймов']) + " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0441\u0435\u0442\u0435?";
	};
	var bo_l36 = function bo_l36(match, outcome) {
	    return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 " + match.awayTeam + " \u043F\u043E\u0434\u0440\u044F\u0434 " + outcome.condition + " " + plural(outcome.condition, ['гейм', 'гейма', 'геймов']) + " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0441\u0435\u0442\u0435?";
	};
	var bo_m36 = function bo_m36(match, outcome) {
	    return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 " + match.awayTeam + " \u043F\u043E\u0434\u0440\u044F\u0434 " + outcome.condition + " " + plural(outcome.condition, ['гейм', 'гейма', 'геймов']) + " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u0441\u0435\u0442\u0435?";
	};
	var bo_n36 = function bo_n36(match, outcome) {
	    return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 " + match.awayTeam + " \u043F\u043E\u0434\u0440\u044F\u0434 " + outcome.condition + " " + plural(outcome.condition, ['гейм', 'гейма', 'геймов']) + " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u043C \u0441\u0435\u0442\u0435?";
	};
	var bo_o36 = function bo_o36(match, outcome) {
	    return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 " + match.awayTeam + " \u043F\u043E\u0434\u0440\u044F\u0434 " + outcome.condition + " " + plural(outcome.condition, ['гейм', 'гейма', 'геймов']) + " \u0432 \u043F\u044F\u0442\u043E\u043C \u0441\u0435\u0442\u0435?";
	};
	var bo_p36 = function bo_p36(match, outcome) {
	    return 'Фора в четвертом сете';
	};
	var bo_q36 = function bo_q36(match, outcome) {
	    return 'Фора в пятом сете';
	};
	var bo_r36 = function bo_r36(match, outcome) {
	    return 'Тотал четвертого сета';
	};
	var bo_s36 = function bo_s36(match, outcome) {
	    return 'Тотал пятого сета';
	};
	var bo_t36 = function bo_t36(match, outcome) {
	    return "\u0422\u043E\u0447\u043D\u044B\u0439 \u0441\u0447\u0435\u0442 " + outcome.condition + " \u0433\u0435\u0439\u043C\u0430";
	};
	var bo_u36 = function bo_u36(match, outcome) {
	    return "\u041A\u0442\u043E \u0432\u043E\u0437\u044C\u043C\u0435\u0442 " + outcome.condition + " \u0433\u0435\u0439\u043C?";
	};
	var bo_v36 = function bo_v36(match, outcome) {
	    return 'Точный счет первого сета';
	};
	var bo_w36 = function bo_w36(match, outcome) {
	    return 'Точный счет второго сета';
	};
	var bo_x36 = function bo_x36(match, outcome) {
	    return 'Точный счет третьего сета';
	};
	var bo_y36 = function bo_y36(match, outcome) {
	    return 'Точный счет четвертого сета';
	};
	var bo_z36 = function bo_z36(match, outcome) {
	    return 'Точный счет пятого сета';
	};
	var bo_a37 = function bo_a37(match, outcome) {
	    return "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 15x15 \u0432 " + outcome.condition + " \u0433\u0435\u0439\u043C\u0435?";
	};
	var bo_b37 = function bo_b37(match, outcome) {
	    return "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 30x30 \u0432 " + outcome.condition + " \u0433\u0435\u0439\u043C\u0435?";
	};
	var bo_c37 = function bo_c37(match, outcome) {
	    return "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 40x40 \u0432 " + outcome.condition + " \u0433\u0435\u0439\u043C\u0435?";
	};
	var bo_d37 = function bo_d37(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u0432\u043E\u0437\u044C\u043C\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['гейм', 'гейма', 'геймов']) + " \u0432 1\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_e37 = function bo_e37(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u0432\u043E\u0437\u044C\u043C\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['гейм', 'гейма', 'геймов']) + " \u0432 2\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_f37 = function bo_f37(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u0432\u043E\u0437\u044C\u043C\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['гейм', 'гейма', 'геймов']) + " \u0432 3\u0435\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_g37 = function bo_g37(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u0432\u043E\u0437\u044C\u043C\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['гейм', 'гейма', 'геймов']) + " \u0432 4\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_h37 = function bo_h37(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u0432\u043E\u0437\u044C\u043C\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['гейм', 'гейма', 'геймов']) + " \u0432 5\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_i37 = function bo_i37(match, outcome) {
	    return 'Результат четвертого сета';
	};
	var bo_j37 = function bo_j37(match, outcome) {
	    return 'Результат пятого сета';
	};
	var bo_k37 = function bo_k37(match, outcome) {
	    return "\u041F\u0435\u0440\u0432\u043E\u0435 \u043E\u0447\u043A\u043E \u0432 " + outcome.condition + " \u0433\u0435\u0439\u043C\u0435";
	};
	var bo_l37 = function bo_l37(match, outcome) {
	    return 'Будет ли тай-брейк в первом сете?';
	};
	var bo_m37 = function bo_m37(match, outcome) {
	    return 'Будет ли тай-брейк во втором сете?';
	};
	var bo_n37 = function bo_n37(match, outcome) {
	    return 'Будет ли тай-брейк в третьем сете?';
	};
	var bo_o37 = function bo_o37(match, outcome) {
	    return 'Будет ли тай-брейк в четвертом сете?';
	};
	var bo_p37 = function bo_p37(match, outcome) {
	    return 'Будет ли тай-брейк в пятом сете?';
	};
	var bo_q37 = function bo_q37(match, outcome) {
	    return 'Будет ли тай-брейк в матче?';
	};
	var bo_r37 = function bo_r37(match, outcome) {
	    return 'Тотал тай-брейка в первом сете';
	};
	var bo_s37 = function bo_s37(match, outcome) {
	    return 'Тотал тай-брейка во втором сете';
	};
	var bo_t37 = function bo_t37(match, outcome) {
	    return 'Тотал тай-брейка в третьем сете';
	};
	var bo_u37 = function bo_u37(match, outcome) {
	    return 'Тотал тай-брейка в четвертом сете';
	};
	var bo_v37 = function bo_v37(match, outcome) {
	    return 'Тотал тай-брейка в пятом сете';
	};
	var bo_w37 = function bo_w37(match, outcome) {
	    return 'Точный счет тай-брейка в первом сете';
	};
	var bo_x37 = function bo_x37(match, outcome) {
	    return 'Точный счет тай-брейка во втором сете';
	};
	var bo_y37 = function bo_y37(match, outcome) {
	    return 'Точный счет тай-брейка в третьем сете';
	};
	var bo_z37 = function bo_z37(match, outcome) {
	    return 'Точный счет тай-брейка в четвертом сете';
	};
	var bo_a38 = function bo_a38(match, outcome) {
	    return 'Точный счет тай-брейка в пятом сете';
	};
	var bo_b38 = function bo_b38(match, outcome) {
	    return 'Точный тотал тай-брейка в первом сете';
	};
	var bo_c38 = function bo_c38(match, outcome) {
	    return 'Точный тотал тай-брейка во втором сете';
	};
	var bo_d38 = function bo_d38(match, outcome) {
	    return 'Точный тотал тай-брейка в третьем сете';
	};
	var bo_e38 = function bo_e38(match, outcome) {
	    return 'Точный тотал тай-брейка в четвертом сете';
	};
	var bo_f38 = function bo_f38(match, outcome) {
	    return 'Точный тотал тай-брейка в пятом сете';
	};
	var bo_g38 = function bo_g38(match, outcome) {
	    return 'Кто победит в тай-брейке в первом сете?';
	};
	var bo_h38 = function bo_h38(match, outcome) {
	    return 'Кто победит в тай-брейке во втором сете?';
	};
	var bo_i38 = function bo_i38(match, outcome) {
	    return 'Кто победит в тай-брейке в третьем сете?';
	};
	var bo_j38 = function bo_j38(match, outcome) {
	    return 'Кто победит в тай-брейке в четвертом сете?';
	};
	var bo_k38 = function bo_k38(match, outcome) {
	    return 'Кто победит в тай-брейке в пятом сете?';
	};
	var bo_l38 = function bo_l38(match, outcome) {
	    return 'Тотал брейков в первом сете';
	};
	var bo_m38 = function bo_m38(match, outcome) {
	    return 'Тотал брейков в матче';
	};
	var bo_n38 = function bo_n38(match, outcome) {
	    return match.homeTeam + " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u0441\u0435\u0442 \u0432 \u043C\u0430\u0442\u0447\u0435";
	};
	var bo_o38 = function bo_o38(match, outcome) {
	    return match.awayTeam + " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u0441\u0435\u0442 \u0432 \u043C\u0430\u0442\u0447\u0435";
	};
	var bo_p38 = function bo_p38(match, outcome) {
	    return 'Тотал самого нерезультативного сета';
	};
	var bo_q38 = function bo_q38(match, outcome) {
	    return 'Кто подаст первый эйс в матче';
	};
	var bo_r38 = function bo_r38(match, outcome) {
	    return 'Кто сделает первую двойную ошибку в матче';
	};
	var bo_s38 = function bo_s38(match, outcome) {
	    return match.homeTeam + ": \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u043A\u043E\u0440\u043E\u0441\u0442\u044C \u043F\u043E\u0434\u0430\u0447\u0438 (\u043A\u043C/\u0447)";
	};
	var bo_t38 = function bo_t38(match, outcome) {
	    return match.awayTeam + ": \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u043A\u043E\u0440\u043E\u0441\u0442\u044C \u043F\u043E\u0434\u0430\u0447\u0438 (\u043A\u043C/\u0447)";
	};
	var bo_u38 = function bo_u38(match, outcome) {
	    return 'Победа в матче после проигрыша первого сета';
	};
	var bo_v38 = function bo_v38(match, outcome) {
	    return match.homeTeam + ": % \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u043E\u0434\u0430\u0447\u0438";
	};
	var bo_w38 = function bo_w38(match, outcome) {
	    return match.awayTeam + ": % \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u043E\u0434\u0430\u0447\u0438";
	};
	var bo_x38 = function bo_x38(match, outcome) {
	    return 'Результат по брейкам в матче';
	};
	var bo_y38 = function bo_y38(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: " + match.homeTeam;
	};
	var bo_z38 = function bo_z38(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: " + match.awayTeam;
	};
	var bo_a39 = function bo_a39(match, outcome) {
	    return 'Кто сделает первый брейк в матче';
	};
	var bo_b39 = function bo_b39(match, outcome) {
	    return match.homeTeam + " \u0441\u0434\u0435\u043B\u0430\u0435\u0442 \u0431\u0440\u0435\u0439\u043A \u0432 1-\u043C \u0438\u043B\u0438 \u0432\u043E 2-\u043C \u0433\u0435\u0439\u043C\u0430\u0445";
	};
	var bo_c39 = function bo_c39(match, outcome) {
	    return 'Будет ли в матче сет со счетом 6:0 или 0:6?';
	};
	var bo_d39 = function bo_d39(match, outcome) {
	    return 'Тотал эйсов в матче';
	};
	var bo_e39 = function bo_e39(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u044D\u0439\u0441\u043E\u0432 \u0432 \u043C\u0430\u0442\u0447\u0435: " + match.homeTeam;
	};
	var bo_f39 = function bo_f39(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u044D\u0439\u0441\u043E\u0432 \u0432 \u043C\u0430\u0442\u0447\u0435: " + match.awayTeam;
	};
	var bo_g39 = function bo_g39(match, outcome) {
	    return 'Тотал двойных ошибок в матче';
	};
	var bo_h39 = function bo_h39(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u0434\u0432\u043E\u0439\u043D\u044B\u0445 \u043E\u0448\u0438\u0431\u043E\u043A \u0432 \u043C\u0430\u0442\u0447\u0435: " + match.homeTeam;
	};
	var bo_i39 = function bo_i39(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u0434\u0432\u043E\u0439\u043D\u044B\u0445 \u043E\u0448\u0438\u0431\u043E\u043A \u0432 \u043C\u0430\u0442\u0447\u0435: " + match.awayTeam;
	};
	var bo_j39 = function bo_j39(match, outcome) {
	    return 'Результативность сетов(Тотал)';
	};
	var bo_k39 = function bo_k39(match, outcome) {
	    return 'Матч будет выигран подачей навылет';
	};
	var bo_l39 = function bo_l39(match, outcome) {
	    return "\u042D\u0439\u0441 \u0432 1-\u043C \u0438\u043B\u0438 2-\u043C \u0433\u0435\u0439\u043C\u0430\u0445: " + match.homeTeam;
	};
	var bo_m39 = function bo_m39(match, outcome) {
	    return "\u042D\u0439\u0441 \u0432 1-\u043C \u0438\u043B\u0438 2-\u043C \u0433\u0435\u0439\u043C\u0430\u0445: " + match.awayTeam;
	};
	var bo_n39 = function bo_n39(match, outcome) {
	    return "\u0414\u0432\u043E\u0439\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430 \u0432 1-\u043C \u0438\u043B\u0438 2-\u043C \u0433\u0435\u0439\u043C\u0430\u0445: " + match.homeTeam;
	};
	var bo_o39 = function bo_o39(match, outcome) {
	    return "\u0414\u0432\u043E\u0439\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430 \u0432 1-\u043C \u0438\u043B\u0438 2-\u043C \u0433\u0435\u0439\u043C\u0430\u0445: " + match.awayTeam;
	};
	var bo_p39 = function bo_p39(match, outcome) {
	    return 'Тотал эйсов в первом сете';
	};
	var bo_q39 = function bo_q39(match, outcome) {
	    return 'Спортсмен снимется (дискв.) в течение матча';
	};
	var bo_r39 = function bo_r39(match, outcome) {
	    return "% \u043F\u043E\u043F\u0430\u0434\u0430\u043D\u0438\u044F \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u043E\u0434\u0430\u0447\u0438 " + match.homeTeam;
	};
	var bo_s39 = function bo_s39(match, outcome) {
	    return "% \u043F\u043E\u043F\u0430\u0434\u0430\u043D\u0438\u044F \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u043E\u0434\u0430\u0447\u0438 " + match.awayTeam;
	};
	var bo_t39 = function bo_t39(match, outcome) {
	    return 'Результат по брейкам в первом сете';
	};
	var bo_u39 = function bo_u39(match, outcome) {
	    return 'Результат по брейкам во втором сете';
	};
	var bo_v39 = function bo_v39(match, outcome) {
	    return 'Результат по брейкам в третьем сете';
	};
	var bo_w39 = function bo_w39(match, outcome) {
	    return 'Результат по брейкам в четвертом сете';
	};
	var bo_x39 = function bo_x39(match, outcome) {
	    return 'Результат по брейкам в пятом сете';
	};
	var bo_y39 = function bo_y39(match, outcome) {
	    return 'Фора по брейкам в матче';
	};
	var bo_z39 = function bo_z39(match, outcome) {
	    return 'Фора по брейкам в первом сете';
	};
	var bo_a40 = function bo_a40(match, outcome) {
	    return 'Фора по брейкам во втором сете';
	};
	var bo_b40 = function bo_b40(match, outcome) {
	    return 'Фора по брейкам в третьем сете';
	};
	var bo_c40 = function bo_c40(match, outcome) {
	    return 'Фора по брейкам в четвертом сете';
	};
	var bo_d40 = function bo_d40(match, outcome) {
	    return 'Фора по брейкам в пятом сете';
	};
	var bo_e40 = function bo_e40(match, outcome) {
	    return "\u041A\u0442\u043E \u0432\u043E\u0437\u044C\u043C\u0435\u0442 " + outcome.conditionTwo + " \u043E\u0447\u043A\u043E \u0432 " + outcome.condition + " \u0433\u0435\u0439\u043C\u0435";
	};
	var bo_f40 = function bo_f40(match, outcome) {
	    return "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 \u0432 " + outcome.condition + " \u0438 " + outcome.conditionTwo + " \u0433\u0435\u0439\u043C\u0430\u0445";
	};
	var bo_g40 = function bo_g40(match, outcome) {
	    return "\u0424\u043E\u0440\u0430 \u0432 " + outcome.conditionTwo + " \u0433\u0435\u0439\u043C\u0435";
	};
	var bo_h40 = function bo_h40(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B \u0432 " + outcome.conditionTwo + " \u0433\u0435\u0439\u043C\u0435";
	};
	var bo_i40 = function bo_i40(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 4\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_j40 = function bo_j40(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432\u043E 5\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_k40 = function bo_k40(match, outcome) {
	    return 'Точный тотал четвертого сета';
	};
	var bo_l40 = function bo_l40(match, outcome) {
	    return 'Точный тотал пятого сета';
	};
	var bo_m40 = function bo_m40(match, outcome) {
	    return match.homeTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_n40 = function bo_n40(match, outcome) {
	    return match.homeTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432 \u043F\u044F\u0442\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_o40 = function bo_o40(match, outcome) {
	    return match.awayTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_p40 = function bo_p40(match, outcome) {
	    return match.awayTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432 \u043F\u044F\u0442\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_q40 = function bo_q40(match, outcome) {
	    return 'Тотал самого результативного сета';
	};
	var bo_r40 = function bo_r40(match, outcome) {
	    return 'Победа с разницей в четвертом сете';
	};
	var bo_s40 = function bo_s40(match, outcome) {
	    return 'Победа с разницей в пятом сете';
	};
	var bo_t40 = function bo_t40(match, outcome) {
	    return 'Победа в минисете до 10 очков четвертого сета';
	};
	var bo_u40 = function bo_u40(match, outcome) {
	    return 'Фора в минисете до 10 очков четвертого сета';
	};
	var bo_v40 = function bo_v40(match, outcome) {
	    return 'Тотал в минисете до 10 очков четвертого сета';
	};
	var bo_w40 = function bo_w40(match, outcome) {
	    return 'Победа в минисете до 15 очков четвертого сета';
	};
	var bo_x40 = function bo_x40(match, outcome) {
	    return 'Фора в минисете до 15 очков четвертого сета';
	};
	var bo_y40 = function bo_y40(match, outcome) {
	    return 'Тотал в минисете до 15 очков четвертого сета';
	};
	var bo_z40 = function bo_z40(match, outcome) {
	    return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 " + numeralNeuterEnding(outcome.condition) + " \u043E\u0447\u043A\u043E \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_a41 = function bo_a41(match, outcome) {
	    return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 " + numeralNeuterEnding(outcome.condition) + " \u043E\u0447\u043A\u043E \u0432 \u043F\u044F\u0442\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_b41 = function bo_b41(match, outcome) {
	    return 'Фора в Золотом сете';
	};
	var bo_c41 = function bo_c41(match, outcome) {
	    return 'Тотал Золотого сета';
	};
	var bo_d41 = function bo_d41(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.homeTeam + " \u0432 \u0417\u043E\u043B\u043E\u0442\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_e41 = function bo_e41(match, outcome) {
	    return "\u0422\u043E\u0442\u0430\u043B: " + match.awayTeam + " \u0432 \u0417\u043E\u043B\u043E\u0442\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_f41 = function bo_f41(match, outcome) {
	    return 'Результат Золотого сета';
	};
	var bo_g41 = function bo_g41(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']) + " \u0432 \u0417\u043E\u043B\u043E\u0442\u043E\u043C \u0441\u0435\u0442\u0435";
	};
	var bo_h41 = function bo_h41(match, outcome) {
	    return 'Точный тотал Золотого сета';
	};
	var bo_i41 = function bo_i41(match, outcome) {
	    return 'Чет/Нечет Золотого сета';
	};
	var bo_j41 = function bo_j41(match, outcome) {
	    return "\u041F\u043E\u0431\u0435\u0434\u0430 \u0438 \u0442\u043E\u0442\u0430\u043B \u0417\u043E\u043B\u043E\u0442\u043E\u0433\u043E \u0441\u0435\u0442\u0430 " + outcome.condition;
	};
	var bo_k41 = function bo_k41(match, outcome) {
	    return 'Победа с разницей в Золотом сете';
	};
	var bo_l41 = function bo_l41(match, outcome) {
	    return 'В скольких сетах будет мини тай-брейк?';
	};
	var bo_m41 = function bo_m41(match, outcome) {
	    return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 " + outcome.condition + "\u0439 \u0440\u0430\u0443\u043D\u0434?";
	};
	var bo_n41 = function bo_n41(match, outcome) {
	    return 'Выпадет ли 13 сектор?';
	};
	var bo_o41 = function bo_o41(match, outcome) {
	    return "\u0412\u044B\u043F\u0430\u0434\u0435\u0442 \u043B\u0438 13 \u0441\u0435\u043A\u0442\u043E\u0440 \u0432 " + outcome.condition + "-\u043C \u0440\u0430\u0443\u043D\u0434\u0435?";
	};
	
	var fa_b1 = function fa_b1(match, outcome) {
	    return "\u04241(" + signed(outcome.condition) + ")";
	};
	var fa_c1 = function fa_c1(match, outcome) {
	    return "\u04242(" + signed(-outcome.condition) + ")";
	};
	var fa_d1 = function fa_d1(match, outcome) {
	    return "\u041C\u0435\u043D. " + outcome.condition;
	};
	var fa_e1 = function fa_e1(match, outcome) {
	    return "\u0411\u043E\u043B. " + outcome.condition;
	};
	var fa_f1 = function fa_f1(match, outcome) {
	    return 'Чет';
	};
	var fa_g1 = function fa_g1(match, outcome) {
	    return 'Нечет';
	};
	var fa_h1 = function fa_h1(match, outcome) {
	    return "" + match.homeTeam;
	};
	var fa_i1 = function fa_i1(match, outcome) {
	    return "" + match.awayTeam;
	};
	var fa_j1 = function fa_j1(match, outcome) {
	    return '1-ая выше';
	};
	var fa_k1 = function fa_k1(match, outcome) {
	    return '2-ая выше';
	};
	var fa_l1 = function fa_l1(match, outcome) {
	    return 'Да';
	};
	var fa_m1 = function fa_m1(match, outcome) {
	    return 'Нет';
	};
	var fa_n1 = function fa_n1(match, outcome) {
	    return '0-2';
	};
	var fa_o1 = function fa_o1(match, outcome) {
	    return '0-3';
	};
	var fa_p1 = function fa_p1(match, outcome) {
	    return '1-2';
	};
	var fa_q1 = function fa_q1(match, outcome) {
	    return '1-3';
	};
	var fa_r1 = function fa_r1(match, outcome) {
	    return '2-0';
	};
	var fa_s1 = function fa_s1(match, outcome) {
	    return '2-1';
	};
	var fa_t1 = function fa_t1(match, outcome) {
	    return '2-3';
	};
	var fa_u1 = function fa_u1(match, outcome) {
	    return '3-0';
	};
	var fa_v1 = function fa_v1(match, outcome) {
	    return '3-1';
	};
	var fa_w1 = function fa_w1(match, outcome) {
	    return '3-2';
	};
	var fa_x1 = function fa_x1(match, outcome) {
	    return 'П1';
	};
	var fa_y1 = function fa_y1(match, outcome) {
	    return 'П2';
	};
	var fa_z1 = function fa_z1(match, outcome) {
	    return 'Х';
	};
	var fa_a2 = function fa_a2(match, outcome) {
	    return 'Никто';
	};
	var fa_b2 = function fa_b2(match, outcome) {
	    return '1X';
	};
	var fa_c2 = function fa_c2(match, outcome) {
	    return '12';
	};
	var fa_d2 = function fa_d2(match, outcome) {
	    return '2X';
	};
	var fa_e2 = function fa_e2(match, outcome) {
	    return "\u041F1\u0422\u043C " + outcome.condition;
	};
	var fa_f2 = function fa_f2(match, outcome) {
	    return "\u041F1\u0422\u0431 " + outcome.condition;
	};
	var fa_g2 = function fa_g2(match, outcome) {
	    return "\u041F2\u0422\u043C " + outcome.condition;
	};
	var fa_h2 = function fa_h2(match, outcome) {
	    return "\u041F2\u0422\u0431 " + outcome.condition;
	};
	var fa_i2 = function fa_i2(match, outcome) {
	    return "\u0425\u0422\u043C " + outcome.condition;
	};
	var fa_j2 = function fa_j2(match, outcome) {
	    return "\u0425\u0422\u0431 " + outcome.condition;
	};
	var fa_k2 = function fa_k2(match, outcome) {
	    return '0';
	};
	var fa_l2 = function fa_l2(match, outcome) {
	    return '1';
	};
	var fa_m2 = function fa_m2(match, outcome) {
	    return '2';
	};
	var fa_n2 = function fa_n2(match, outcome) {
	    return '3';
	};
	var fa_o2 = function fa_o2(match, outcome) {
	    return '4';
	};
	var fa_p2 = function fa_p2(match, outcome) {
	    return '≥ 5';
	};
	var fa_q2 = function fa_q2(match, outcome) {
	    return 'Обе забьют';
	};
	var fa_r2 = function fa_r2(match, outcome) {
	    return 'Одна забьёт';
	};
	var fa_s2 = function fa_s2(match, outcome) {
	    return 'Обе не забьют';
	};
	var fa_t2 = function fa_t2(match, outcome) {
	    return '0-0';
	};
	var fa_u2 = function fa_u2(match, outcome) {
	    return '0-1';
	};
	var fa_v2 = function fa_v2(match, outcome) {
	    return '0-4';
	};
	var fa_w2 = function fa_w2(match, outcome) {
	    return '0-5';
	};
	var fa_x2 = function fa_x2(match, outcome) {
	    return '1-0';
	};
	var fa_y2 = function fa_y2(match, outcome) {
	    return '1-1';
	};
	var fa_z2 = function fa_z2(match, outcome) {
	    return '1-4';
	};
	var fa_a3 = function fa_a3(match, outcome) {
	    return '1-5';
	};
	var fa_b3 = function fa_b3(match, outcome) {
	    return '2-2';
	};
	var fa_c3 = function fa_c3(match, outcome) {
	    return '2-4';
	};
	var fa_d3 = function fa_d3(match, outcome) {
	    return '2-5';
	};
	var fa_e3 = function fa_e3(match, outcome) {
	    return '2-6';
	};
	var fa_f3 = function fa_f3(match, outcome) {
	    return '3-3';
	};
	var fa_g3 = function fa_g3(match, outcome) {
	    return '3-4';
	};
	var fa_h3 = function fa_h3(match, outcome) {
	    return '3-5';
	};
	var fa_i3 = function fa_i3(match, outcome) {
	    return '4-0';
	};
	var fa_j3 = function fa_j3(match, outcome) {
	    return '4-1';
	};
	var fa_k3 = function fa_k3(match, outcome) {
	    return '4-2';
	};
	var fa_l3 = function fa_l3(match, outcome) {
	    return '4-3';
	};
	var fa_m3 = function fa_m3(match, outcome) {
	    return '4-4';
	};
	var fa_n3 = function fa_n3(match, outcome) {
	    return '5-0';
	};
	var fa_o3 = function fa_o3(match, outcome) {
	    return '5-1';
	};
	var fa_p3 = function fa_p3(match, outcome) {
	    return '5-2';
	};
	var fa_q3 = function fa_q3(match, outcome) {
	    return '5-3';
	};
	var fa_r3 = function fa_r3(match, outcome) {
	    return 'Любой другой';
	};
	var fa_s3 = function fa_s3(match, outcome) {
	    return "\u2264 " + outcome.condition;
	};
	var fa_t3 = function fa_t3(match, outcome) {
	    return outcome.condition + 1 + " - " + (outcome.condition + 2);
	};
	var fa_u3 = function fa_u3(match, outcome) {
	    return outcome.condition + 3 + " - " + (outcome.condition + 4);
	};
	var fa_v3 = function fa_v3(match, outcome) {
	    return outcome.condition + 5 + " - " + (outcome.condition + 6);
	};
	var fa_w3 = function fa_w3(match, outcome) {
	    return outcome.condition + 7 + " - " + (outcome.condition + 8);
	};
	var fa_x3 = function fa_x3(match, outcome) {
	    return "\u2265 " + (outcome.condition + 9);
	};
	var fa_y3 = function fa_y3(match, outcome) {
	    return '6-9';
	};
	var fa_z3 = function fa_z3(match, outcome) {
	    return '10-12';
	};
	var fa_a4 = function fa_a4(match, outcome) {
	    return '13-16';
	};
	var fa_b4 = function fa_b4(match, outcome) {
	    return '17-20';
	};
	var fa_c4 = function fa_c4(match, outcome) {
	    return '≥21';
	};
	var fa_d4 = function fa_d4(match, outcome) {
	    return "\u041F\u0440\u043E\u0445\u043E\u0434: " + match.homeTeam;
	};
	var fa_e4 = function fa_e4(match, outcome) {
	    return "\u041F\u0440\u043E\u0445\u043E\u0434: " + match.awayTeam;
	};
	var fa_f4 = function fa_f4(match, outcome) {
	    return '1-ая половина';
	};
	var fa_g4 = function fa_g4(match, outcome) {
	    return '2-ая половина';
	};
	var fa_h4 = function fa_h4(match, outcome) {
	    return '1-ая четверть';
	};
	var fa_i4 = function fa_i4(match, outcome) {
	    return '2-ая четверть';
	};
	var fa_j4 = function fa_j4(match, outcome) {
	    return '3-ая четверть';
	};
	var fa_k4 = function fa_k4(match, outcome) {
	    return '4-ая четверть';
	};
	var fa_l4 = function fa_l4(match, outcome) {
	    return 'П1: 1-2';
	};
	var fa_m4 = function fa_m4(match, outcome) {
	    return 'П1: 3-5';
	};
	var fa_n4 = function fa_n4(match, outcome) {
	    return 'П1: 6-9';
	};
	var fa_o4 = function fa_o4(match, outcome) {
	    return 'П1: 10-12';
	};
	var fa_p4 = function fa_p4(match, outcome) {
	    return 'П1: 13-16';
	};
	var fa_q4 = function fa_q4(match, outcome) {
	    return 'П1: 17-20';
	};
	var fa_r4 = function fa_r4(match, outcome) {
	    return 'П1: ≥21';
	};
	var fa_s4 = function fa_s4(match, outcome) {
	    return 'П2: 1-2';
	};
	var fa_t4 = function fa_t4(match, outcome) {
	    return 'П2: 3-5';
	};
	var fa_u4 = function fa_u4(match, outcome) {
	    return 'П2: 6-9';
	};
	var fa_v4 = function fa_v4(match, outcome) {
	    return 'П2: 10-12';
	};
	var fa_w4 = function fa_w4(match, outcome) {
	    return 'П2: 13-16';
	};
	var fa_x4 = function fa_x4(match, outcome) {
	    return 'П2: 17-20';
	};
	var fa_y4 = function fa_y4(match, outcome) {
	    return 'П2: ≥21';
	};
	var fa_z4 = function fa_z4(match, outcome) {
	    return 'П1: 3-4';
	};
	var fa_a5 = function fa_a5(match, outcome) {
	    return 'П1: 5-7';
	};
	var fa_b5 = function fa_b5(match, outcome) {
	    return 'П1: ≥8';
	};
	var fa_c5 = function fa_c5(match, outcome) {
	    return 'Х2';
	};
	var fa_d5 = function fa_d5(match, outcome) {
	    return 'П2: 3-4';
	};
	var fa_e5 = function fa_e5(match, outcome) {
	    return 'П2: 5-7';
	};
	var fa_f5 = function fa_f5(match, outcome) {
	    return 'П2: ≥8';
	};
	var fa_g5 = function fa_g5(match, outcome) {
	    return 'Х1';
	};
	var fa_h5 = function fa_h5(match, outcome) {
	    return 'Штрафной';
	};
	var fa_i5 = function fa_i5(match, outcome) {
	    return '3-очковый';
	};
	var fa_j5 = function fa_j5(match, outcome) {
	    return '2-очковый';
	};
	var fa_k5 = function fa_k5(match, outcome) {
	    return "\u041F1 \u2265 " + outcome.condition;
	};
	var fa_l5 = function fa_l5(match, outcome) {
	    return "\u0420\u0430\u0437\u043D\u0438\u0446\u0430 \u043C\u0435\u043D\u044C\u0448\u0435 " + outcome.condition;
	};
	var fa_m5 = function fa_m5(match, outcome) {
	    return "\u041F2 \u2265 " + outcome.condition;
	};
	var fa_n5 = function fa_n5(match, outcome) {
	    return "\u041F1: \u0411\u043E\u043B. " + outcome.condition + "=21";
	};
	var fa_o5 = function fa_o5(match, outcome) {
	    return "\u041F2: \u0411\u043E\u043B. " + outcome.condition + "=21";
	};
	var fa_p5 = function fa_p5(match, outcome) {
	    return 'П1: 8 и более';
	};
	var fa_q5 = function fa_q5(match, outcome) {
	    return 'П2: 8 и более';
	};
	var fa_r5 = function fa_r5(match, outcome) {
	    return 'Никакая';
	};
	var fa_s5 = function fa_s5(match, outcome) {
	    return 'П1: 1';
	};
	var fa_t5 = function fa_t5(match, outcome) {
	    return 'П1: 2';
	};
	var fa_u5 = function fa_u5(match, outcome) {
	    return 'П1: 3';
	};
	var fa_v5 = function fa_v5(match, outcome) {
	    return 'П1: 4';
	};
	var fa_w5 = function fa_w5(match, outcome) {
	    return 'П1: ≥ 5';
	};
	var fa_x5 = function fa_x5(match, outcome) {
	    return 'П2: 1';
	};
	var fa_y5 = function fa_y5(match, outcome) {
	    return 'П2: 2';
	};
	var fa_z5 = function fa_z5(match, outcome) {
	    return 'П2: 3';
	};
	var fa_a6 = function fa_a6(match, outcome) {
	    return 'П2: 4';
	};
	var fa_b6 = function fa_b6(match, outcome) {
	    return 'П2: ≥ 5';
	};
	var fa_c6 = function fa_c6(match, outcome) {
	    return '1Х';
	};
	var fa_d6 = function fa_d6(match, outcome) {
	    return 'Обе';
	};
	var fa_e6 = function fa_e6(match, outcome) {
	    return 'Одна';
	};
	var fa_f6 = function fa_f6(match, outcome) {
	    return 'Ни одна';
	};
	var fa_g6 = function fa_g6(match, outcome) {
	    return '0 или 1';
	};
	var fa_h6 = function fa_h6(match, outcome) {
	    return '5';
	};
	var fa_i6 = function fa_i6(match, outcome) {
	    return '6';
	};
	var fa_j6 = function fa_j6(match, outcome) {
	    return '7';
	};
	var fa_k6 = function fa_k6(match, outcome) {
	    return '≥ 8';
	};
	var fa_l6 = function fa_l6(match, outcome) {
	    return 'П1П1';
	};
	var fa_m6 = function fa_m6(match, outcome) {
	    return 'П1Н';
	};
	var fa_n6 = function fa_n6(match, outcome) {
	    return 'П1П2';
	};
	var fa_o6 = function fa_o6(match, outcome) {
	    return 'НП1';
	};
	var fa_p6 = function fa_p6(match, outcome) {
	    return 'НН';
	};
	var fa_q6 = function fa_q6(match, outcome) {
	    return 'НП2';
	};
	var fa_r6 = function fa_r6(match, outcome) {
	    return 'П2П1';
	};
	var fa_s6 = function fa_s6(match, outcome) {
	    return 'П2Н';
	};
	var fa_t6 = function fa_t6(match, outcome) {
	    return 'П2П2';
	};
	var fa_u6 = function fa_u6(match, outcome) {
	    return "" + (outcome.condition + 1);
	};
	var fa_v6 = function fa_v6(match, outcome) {
	    return "" + (outcome.condition + 2);
	};
	var fa_w6 = function fa_w6(match, outcome) {
	    return "" + (outcome.condition + 3);
	};
	var fa_x6 = function fa_x6(match, outcome) {
	    return "" + (outcome.condition + 4);
	};
	var fa_y6 = function fa_y6(match, outcome) {
	    return "" + (outcome.condition + 5);
	};
	var fa_z6 = function fa_z6(match, outcome) {
	    return "" + (outcome.condition + 6);
	};
	var fa_a7 = function fa_a7(match, outcome) {
	    return "\u2265 " + (outcome.condition + 7);
	};
	var fa_b7 = function fa_b7(match, outcome) {
	    return "\u043E\u0442 " + (outcome.condition + 1) + " \u0434\u043E " + (outcome.condition + 2);
	};
	var fa_c7 = function fa_c7(match, outcome) {
	    return "\u043E\u0442 " + (outcome.condition + 3) + " \u0434\u043E " + (outcome.condition + 4);
	};
	var fa_d7 = function fa_d7(match, outcome) {
	    return "\u043E\u0442 " + (outcome.condition + 5) + " \u0434\u043E " + (outcome.condition + 6);
	};
	var fa_e7 = function fa_e7(match, outcome) {
	    return '4-6';
	};
	var fa_f7 = function fa_f7(match, outcome) {
	    return '7 и более';
	};
	var fa_g7 = function fa_g7(match, outcome) {
	    return 'П1Тм';
	};
	var fa_h7 = function fa_h7(match, outcome) {
	    return 'П1Тб';
	};
	var fa_i7 = function fa_i7(match, outcome) {
	    return 'П2Тм';
	};
	var fa_j7 = function fa_j7(match, outcome) {
	    return 'П2Тб';
	};
	var fa_k7 = function fa_k7(match, outcome) {
	    return 'П1: 2-3';
	};
	var fa_l7 = function fa_l7(match, outcome) {
	    return 'П1: 4-6';
	};
	var fa_m7 = function fa_m7(match, outcome) {
	    return 'П1: ≥7';
	};
	var fa_n7 = function fa_n7(match, outcome) {
	    return 'П2: 2-3';
	};
	var fa_o7 = function fa_o7(match, outcome) {
	    return 'П2: 4-6';
	};
	var fa_p7 = function fa_p7(match, outcome) {
	    return 'П2: ≥7';
	};
	var fa_q7 = function fa_q7(match, outcome) {
	    return "" + outcome.condition;
	};
	var fa_r7 = function fa_r7(match, outcome) {
	    return "\u2265 " + (outcome.condition + 6);
	};
	var fa_s7 = function fa_s7(match, outcome) {
	    return 'П1: досрочная победа';
	};
	var fa_t7 = function fa_t7(match, outcome) {
	    return 'П1: победа по очкам';
	};
	var fa_u7 = function fa_u7(match, outcome) {
	    return 'Ничья';
	};
	var fa_v7 = function fa_v7(match, outcome) {
	    return 'П2: досрочная победа';
	};
	var fa_w7 = function fa_w7(match, outcome) {
	    return 'П2: победа по очкам';
	};
	var fa_x7 = function fa_x7(match, outcome) {
	    return 'П1: 1 раунд';
	};
	var fa_y7 = function fa_y7(match, outcome) {
	    return 'П1: 2 раунд';
	};
	var fa_z7 = function fa_z7(match, outcome) {
	    return 'П1: 3 раунд';
	};
	var fa_a8 = function fa_a8(match, outcome) {
	    return 'П1: 4 раунд';
	};
	var fa_b8 = function fa_b8(match, outcome) {
	    return 'П1: 5 раунд';
	};
	var fa_c8 = function fa_c8(match, outcome) {
	    return 'П1: 6 раунд';
	};
	var fa_d8 = function fa_d8(match, outcome) {
	    return 'П1: 7 раунд';
	};
	var fa_e8 = function fa_e8(match, outcome) {
	    return 'П1: 8 раунд';
	};
	var fa_f8 = function fa_f8(match, outcome) {
	    return 'П1: 9 раунд';
	};
	var fa_g8 = function fa_g8(match, outcome) {
	    return 'П1: 10 раунд';
	};
	var fa_h8 = function fa_h8(match, outcome) {
	    return 'П1: 11 раунд';
	};
	var fa_i8 = function fa_i8(match, outcome) {
	    return 'П1: 12 раунд';
	};
	var fa_j8 = function fa_j8(match, outcome) {
	    return 'П2: 1 раунд';
	};
	var fa_k8 = function fa_k8(match, outcome) {
	    return 'П2: 2 раунд';
	};
	var fa_l8 = function fa_l8(match, outcome) {
	    return 'П2: 3 раунд';
	};
	var fa_m8 = function fa_m8(match, outcome) {
	    return 'П2: 4 раунд';
	};
	var fa_n8 = function fa_n8(match, outcome) {
	    return 'П2: 5 раунд';
	};
	var fa_o8 = function fa_o8(match, outcome) {
	    return 'П2: 6 раунд';
	};
	var fa_p8 = function fa_p8(match, outcome) {
	    return 'П2: 7 раунд';
	};
	var fa_q8 = function fa_q8(match, outcome) {
	    return 'П2: 8 раунд';
	};
	var fa_r8 = function fa_r8(match, outcome) {
	    return 'П2: 9 раунд';
	};
	var fa_s8 = function fa_s8(match, outcome) {
	    return 'П2: 10 раунд';
	};
	var fa_t8 = function fa_t8(match, outcome) {
	    return 'П2: 11 раунд';
	};
	var fa_u8 = function fa_u8(match, outcome) {
	    return 'П2: 12 раунд';
	};
	var fa_v8 = function fa_v8(match, outcome) {
	    return 'X';
	};
	var fa_w8 = function fa_w8(match, outcome) {
	    return '5 и более';
	};
	var fa_x8 = function fa_x8(match, outcome) {
	    return 'Ни одной';
	};
	var fa_y8 = function fa_y8(match, outcome) {
	    return "\u041A\u0430\u0436\u0434\u0430\u044F \u0438\u0437 \u043A\u043E\u043C\u0430\u043D\u0434 \u0437\u0430\u0431\u044C\u0451\u0442 " + (outcome.condition + 1) + " \u0438\u043B\u0438 \u0431\u043E\u043B\u0435\u0435 \u0433\u043E\u043B\u043E\u0432";
	};
	var fa_z8 = function fa_z8(match, outcome) {
	    return "\u0420\u043E\u0432\u043D\u043E \u043E\u0434\u043D\u0430 \u0437\u0430\u0431\u044C\u0451\u0442 " + (outcome.condition + 1) + " \u0438\u043B\u0438 \u0431\u043E\u043B\u0435\u0435 \u0433\u043E\u043B\u043E\u0432";
	};
	var fa_a9 = function fa_a9(match, outcome) {
	    return "\u041D\u0438\u043A\u0442\u043E \u043D\u0435 \u0437\u0430\u0431\u044C\u0451\u0442 " + (outcome.condition + 1) + " \u0438\u043B\u0438 \u0431\u043E\u043B\u0435\u0435 \u0433\u043E\u043B\u043E\u0432";
	};
	var fa_b9 = function fa_b9(match, outcome) {
	    return 'Головой';
	};
	var fa_c9 = function fa_c9(match, outcome) {
	    return 'Ногой(с игры)';
	};
	var fa_d9 = function fa_d9(match, outcome) {
	    return 'Автоголом';
	};
	var fa_e9 = function fa_e9(match, outcome) {
	    return 'С пенальти';
	};
	var fa_f9 = function fa_f9(match, outcome) {
	    return 'Угловой';
	};
	var fa_g9 = function fa_g9(match, outcome) {
	    return 'Офсайд';
	};
	var fa_h9 = function fa_h9(match, outcome) {
	    return 'ЖК';
	};
	var fa_i9 = function fa_i9(match, outcome) {
	    return 'Гол';
	};
	var fa_j9 = function fa_j9(match, outcome) {
	    return 'Будет';
	};
	var fa_k9 = function fa_k9(match, outcome) {
	    return 'Не будет';
	};
	var fa_l9 = function fa_l9(match, outcome) {
	    return "\u0420\u0430\u043D\u044C\u0448\u0435 " + outcome.condition;
	};
	var fa_m9 = function fa_m9(match, outcome) {
	    return "\u041F\u043E\u0437\u0436\u0435 " + outcome.condition;
	};
	var fa_n9 = function fa_n9(match, outcome) {
	    return 'В первом тайме';
	};
	var fa_o9 = function fa_o9(match, outcome) {
	    return 'Во втором тайме';
	};
	var fa_p9 = function fa_p9(match, outcome) {
	    return 'Гола не будет';
	};
	var fa_q9 = function fa_q9(match, outcome) {
	    return 'Не забьет';
	};
	var fa_r9 = function fa_r9(match, outcome) {
	    return '0-6';
	};
	var fa_s9 = function fa_s9(match, outcome) {
	    return '1-6';
	};
	var fa_t9 = function fa_t9(match, outcome) {
	    return '6-0';
	};
	var fa_u9 = function fa_u9(match, outcome) {
	    return '6-1';
	};
	var fa_v9 = function fa_v9(match, outcome) {
	    return 'Голевая ничья';
	};
	var fa_w9 = function fa_w9(match, outcome) {
	    return 'Безголевая ничья';
	};
	var fa_x9 = function fa_x9(match, outcome) {
	    return 'Не ничья';
	};
	var fa_y9 = function fa_y9(match, outcome) {
	    return 'Забьет';
	};
	var fa_z9 = function fa_z9(match, outcome) {
	    return 'Первый меньше';
	};
	var fa_a10 = function fa_a10(match, outcome) {
	    return 'Равенство';
	};
	var fa_b10 = function fa_b10(match, outcome) {
	    return 'Первый больше';
	};
	var fa_c10 = function fa_c10(match, outcome) {
	    return 'Да/Да';
	};
	var fa_d10 = function fa_d10(match, outcome) {
	    return 'Да/Нет';
	};
	var fa_e10 = function fa_e10(match, outcome) {
	    return 'Нет/Да';
	};
	var fa_f10 = function fa_f10(match, outcome) {
	    return 'Нет/Нет';
	};
	var fa_g10 = function fa_g10(match, outcome) {
	    return "\u0422\u0431" + outcome.condition + "/\u0414\u0430";
	};
	var fa_h10 = function fa_h10(match, outcome) {
	    return "\u0422\u0431" + outcome.condition + "/\u041D\u0435\u0442";
	};
	var fa_i10 = function fa_i10(match, outcome) {
	    return "\u0422\u043C" + outcome.condition + "/\u0414\u0430";
	};
	var fa_j10 = function fa_j10(match, outcome) {
	    return "\u0422\u043C" + outcome.condition + "/\u041D\u0435\u0442";
	};
	var fa_k10 = function fa_k10(match, outcome) {
	    return 'П1 в основное время';
	};
	var fa_l10 = function fa_l10(match, outcome) {
	    return 'П2 в основное время';
	};
	var fa_m10 = function fa_m10(match, outcome) {
	    return 'П1 в доп. время';
	};
	var fa_n10 = function fa_n10(match, outcome) {
	    return 'П2 в доп. время';
	};
	var fa_o10 = function fa_o10(match, outcome) {
	    return 'П1 в серии пенальти';
	};
	var fa_p10 = function fa_p10(match, outcome) {
	    return 'П2 в серии пенальти';
	};
	var fa_q10 = function fa_q10(match, outcome) {
	    return '1 тайм';
	};
	var fa_r10 = function fa_r10(match, outcome) {
	    return 'Перерыв';
	};
	var fa_s10 = function fa_s10(match, outcome) {
	    return '2 тайм';
	};
	var fa_t10 = function fa_t10(match, outcome) {
	    return '5-4';
	};
	var fa_u10 = function fa_u10(match, outcome) {
	    return 'П1 с любым другим';
	};
	var fa_v10 = function fa_v10(match, outcome) {
	    return '4-5';
	};
	var fa_w10 = function fa_w10(match, outcome) {
	    return 'П2 с любым другим';
	};
	var fa_x10 = function fa_x10(match, outcome) {
	    return '1-10';
	};
	var fa_y10 = function fa_y10(match, outcome) {
	    return '11-20';
	};
	var fa_z10 = function fa_z10(match, outcome) {
	    return '21-30';
	};
	var fa_a11 = function fa_a11(match, outcome) {
	    return '31-40';
	};
	var fa_b11 = function fa_b11(match, outcome) {
	    return '41-50';
	};
	var fa_c11 = function fa_c11(match, outcome) {
	    return '51-60';
	};
	var fa_d11 = function fa_d11(match, outcome) {
	    return '61-70';
	};
	var fa_e11 = function fa_e11(match, outcome) {
	    return '71-80';
	};
	var fa_f11 = function fa_f11(match, outcome) {
	    return '81-конец ОВ';
	};
	var fa_g11 = function fa_g11(match, outcome) {
	    return 'Нет гола';
	};
	var fa_h11 = function fa_h11(match, outcome) {
	    return 'X2';
	};
	var fa_i11 = function fa_i11(match, outcome) {
	    return '1<2';
	};
	var fa_j11 = function fa_j11(match, outcome) {
	    return '1=2';
	};
	var fa_k11 = function fa_k11(match, outcome) {
	    return '1>2';
	};
	var fa_l11 = function fa_l11(match, outcome) {
	    return '1<3';
	};
	var fa_m11 = function fa_m11(match, outcome) {
	    return '1=3';
	};
	var fa_n11 = function fa_n11(match, outcome) {
	    return '1>3';
	};
	var fa_o11 = function fa_o11(match, outcome) {
	    return '2<3';
	};
	var fa_p11 = function fa_p11(match, outcome) {
	    return '2=3';
	};
	var fa_q11 = function fa_q11(match, outcome) {
	    return '2>3';
	};
	var fa_r11 = function fa_r11(match, outcome) {
	    return 'да';
	};
	var fa_s11 = function fa_s11(match, outcome) {
	    return 'нет';
	};
	var fa_t11 = function fa_t11(match, outcome) {
	    return 'Желтый шар';
	};
	var fa_u11 = function fa_u11(match, outcome) {
	    return 'Зеленый шар';
	};
	var fa_v11 = function fa_v11(match, outcome) {
	    return 'Коричневый шар';
	};
	var fa_w11 = function fa_w11(match, outcome) {
	    return 'Голубой шар';
	};
	var fa_x11 = function fa_x11(match, outcome) {
	    return 'Розовый шар';
	};
	var fa_y11 = function fa_y11(match, outcome) {
	    return 'Черный шар';
	};
	var fa_z11 = function fa_z11(match, outcome) {
	    return "\u2265 " + (outcome.condition + 5);
	};
	var fa_a12 = function fa_a12(match, outcome) {
	    return '≤ 14';
	};
	var fa_b12 = function fa_b12(match, outcome) {
	    return 'от 15 до 17';
	};
	var fa_c12 = function fa_c12(match, outcome) {
	    return 'от 18 до 19';
	};
	var fa_d12 = function fa_d12(match, outcome) {
	    return '≥ 20';
	};
	var fa_e12 = function fa_e12(match, outcome) {
	    return 'П1-0';
	};
	var fa_f12 = function fa_f12(match, outcome) {
	    return 'П1-15';
	};
	var fa_g12 = function fa_g12(match, outcome) {
	    return 'П1-30';
	};
	var fa_h12 = function fa_h12(match, outcome) {
	    return 'П1-40';
	};
	var fa_i12 = function fa_i12(match, outcome) {
	    return '0-П2';
	};
	var fa_j12 = function fa_j12(match, outcome) {
	    return '15-П2';
	};
	var fa_k12 = function fa_k12(match, outcome) {
	    return '30-П2';
	};
	var fa_l12 = function fa_l12(match, outcome) {
	    return '40-П2';
	};
	var fa_m12 = function fa_m12(match, outcome) {
	    return '3-6';
	};
	var fa_n12 = function fa_n12(match, outcome) {
	    return '5-7';
	};
	var fa_o12 = function fa_o12(match, outcome) {
	    return '6-2';
	};
	var fa_p12 = function fa_p12(match, outcome) {
	    return '6-3';
	};
	var fa_q12 = function fa_q12(match, outcome) {
	    return '6-4';
	};
	var fa_r12 = function fa_r12(match, outcome) {
	    return '6-7';
	};
	var fa_s12 = function fa_s12(match, outcome) {
	    return '7-5';
	};
	var fa_t12 = function fa_t12(match, outcome) {
	    return '7-6';
	};
	var fa_u12 = function fa_u12(match, outcome) {
	    return '7-0';
	};
	var fa_v12 = function fa_v12(match, outcome) {
	    return '7-1';
	};
	var fa_w12 = function fa_w12(match, outcome) {
	    return '7-2';
	};
	var fa_x12 = function fa_x12(match, outcome) {
	    return '7-3';
	};
	var fa_y12 = function fa_y12(match, outcome) {
	    return '7-4';
	};
	var fa_z12 = function fa_z12(match, outcome) {
	    return '0-7';
	};
	var fa_a13 = function fa_a13(match, outcome) {
	    return '1-7';
	};
	var fa_b13 = function fa_b13(match, outcome) {
	    return '2-7';
	};
	var fa_c13 = function fa_c13(match, outcome) {
	    return '3-7';
	};
	var fa_d13 = function fa_d13(match, outcome) {
	    return '4-7';
	};
	var fa_e13 = function fa_e13(match, outcome) {
	    return '8';
	};
	var fa_f13 = function fa_f13(match, outcome) {
	    return '9';
	};
	var fa_g13 = function fa_g13(match, outcome) {
	    return '10';
	};
	var fa_h13 = function fa_h13(match, outcome) {
	    return '11';
	};
	var fa_i13 = function fa_i13(match, outcome) {
	    return '≥ 13';
	};
	var fa_j13 = function fa_j13(match, outcome) {
	    return match.homeTeam + " (\u0421.\u041F.)";
	};
	var fa_k13 = function fa_k13(match, outcome) {
	    return match.awayTeam + " (\u0421.\u041F.)";
	};
	var fa_l13 = function fa_l13(match, outcome) {
	    return 'Оба П1';
	};
	var fa_m13 = function fa_m13(match, outcome) {
	    return 'Оба П2';
	};
	var fa_n13 = function fa_n13(match, outcome) {
	    return 'Ф1';
	};
	var fa_o13 = function fa_o13(match, outcome) {
	    return 'Ф2';
	};
	var fa_p13 = function fa_p13(match, outcome) {
	    return 'П1: 7 и более';
	};
	var fa_q13 = function fa_q13(match, outcome) {
	    return 'П2: 7 и более';
	};
	var fa_r13 = function fa_r13(match, outcome) {
	    return '6-5';
	};
	var fa_s13 = function fa_s13(match, outcome) {
	    return '5-6';
	};
	
	var groupConfig = {
	    32: {
	        0: 'Матч',
	        1: 'Первый сет',
	        2: 'Второй сет',
	        3: 'Третий сет',
	        4: 'Мини-сет до 10 очков (Первый сет)',
	        5: 'Мини-сет до 15 очков (Первый сет)',
	        6: 'Мини-сет до 10 очков (Второй сет)',
	        7: 'Мини-сет до 15 очков (Второй сет)',
	        8: 'Мини-сет до 10 очков (Третий сет)',
	        9: 'Мини-сет до 15 очков (Третий сет)'
	    },
	    35: {
	        0: 'Матч',
	        1: 'Первый период'
	    },
	    31: {
	        0: 'Матч',
	        1: 'Первая четверть',
	        2: 'Вторая четверть',
	        3: 'Третья четверть',
	        4: 'Четвертая четверть',
	        5: 'Двухочковые броски',
	        6: 'Трехочковые броски',
	        7: 'Первая половина',
	        8: 'Вторая половина'
	    },
	    41: {
	        0: 'Матч',
	        1: 'Первая половина',
	        2: 'Вторая половина',
	        3: 'Двухочковые броски',
	        4: 'Трехочковые броски'
	    },
	    18: {
	        0: 'Матч',
	        1: 'Первый период',
	        2: 'Второй период',
	        3: 'Третий период'
	    },
	    3: {
	        0: 'Матч',
	        1: 'Первый сет',
	        2: 'Второй сет',
	        3: 'Третий сет',
	        4: 'Мини-сет до 10 очков (Первый сет)',
	        5: 'Мини-сет до 15 очков (Первый сет)',
	        6: 'Мини-сет до 10 очков (Второй сет)',
	        7: 'Мини-сет до 15 очков (Второй сет)'
	    },
	    20: {
	        0: 'Матч',
	        1: 'Первый огневой рубеж',
	        2: 'Второй огневой рубеж',
	        3: 'Третий огневой рубеж',
	        4: 'Четвертый огневой рубеж',
	        5: 'Пятый огневой рубеж',
	        6: 'Шестой огневой рубеж',
	        7: 'Седьмой огневой рубеж',
	        8: 'Восьмой огневой рубеж'
	    },
	    42: {
	        0: 'Матч',
	        1: 'Первая карта',
	        2: 'Вторая карта',
	        3: 'Третья карта',
	        4: 'Четвертая карта',
	        5: 'Пятая карта'
	    },
	    36: {
	        0: 'Матч',
	        1: 'Первый период'
	    },
	    7: {
	        0: 'Матч',
	        1: 'Первый тайм',
	        2: 'Второй тайм',
	        3: 'С 1 по 15 минуту',
	        4: 'С 16 по 30 минуту',
	        5: 'С 31 минуты до перерыва',
	        6: 'С 46 по 60 минуту',
	        7: 'С 61 по 75 минуту',
	        8: 'С 76 минуты до конца ОВ',
	        9: 'Угловые',
	        10: 'Угловые (Первый тайм)',
	        11: 'Желтые карточки',
	        12: 'Желтые карточки (Первый тайм)',
	        13: 'Доп. время',
	        14: 'Первое доп. время',
	        15: 'Второе доп. время',
	        16: 'Серия пенальти'
	    },
	    34: {
	        0: 'Матч',
	        1: 'Первый тайм',
	        2: 'Второй тайм',
	        3: 'С 1 по 15 минуту',
	        4: 'С 16 по 30 минуту',
	        5: 'С 31 минуты до перерыва',
	        6: 'С 46 по 60 минуту',
	        7: 'С 61 по 75 минуту',
	        8: 'С 76 минуты до конца ОВ',
	        9: 'Угловые',
	        10: 'Желтые карточки'
	    },
	    19: {
	        0: 'Матч',
	        1: 'Первый период',
	        2: 'Второй период'
	    },
	    30: {
	        0: 'Матч',
	        1: 'Первый период',
	        2: 'Второй период',
	        3: 'Третий период',
	        4: 'С 1 по 10 минуту',
	        5: 'С 11 по 20 минуту',
	        6: 'С 21 по 30 минуту',
	        7: 'С 31 по 40 минуту',
	        8: 'С 41 по 50 минуту',
	        9: 'С 51 по 60 минуту'
	    },
	    9: {
	        0: 'Матч',
	        1: 'Первый период',
	        2: 'Второй период'
	    },
	    29: {
	        0: 'Матч',
	        1: 'Первый период',
	        2: 'Второй период',
	        3: 'Третий период',
	        4: 'Четвертый период',
	        5: 'Пятый период',
	        6: 'Шестой период',
	        7: 'Седьмой период',
	        8: 'Восьмой период',
	        9: 'Девятый период',
	        10: 'Десятый период',
	        11: 'Одинадцатый период',
	        12: 'Двенадцатый период',
	        13: 'Тринадцатый период',
	        14: 'Четырнадцатый период',
	        15: 'Пятнадцатый период',
	        16: 'Шестнадцатый период',
	        17: 'Семнадцатый период',
	        18: 'Восемнадцатый период',
	        19: 'Девятнадцатый период',
	        20: 'Двадцатый период',
	        21: 'Двадцать первый период',
	        22: 'Двадцать второй период',
	        23: 'Двадцать третий период',
	        24: 'Двадцать четвертый период',
	        25: 'Двадцать пятый период',
	        26: 'Двадцать шестой период',
	        27: 'Двадцать седьмой период',
	        28: 'Двадцать восьмой период',
	        29: 'Двадцать девятый период',
	        30: 'Тридцатый период',
	        31: 'Тридцать первый период',
	        32: 'Тридцать второй период',
	        33: 'Тридцать третий период',
	        34: 'Тридцать четвертый период',
	        35: 'Тридцать пятый период',
	        36: 'Тридцать шестой период',
	        37: 'Тридцать седьмой период'
	    },
	    2: {
	        0: 'Матч',
	        1: 'Первый сет',
	        2: 'Второй сет',
	        3: 'Третий сет',
	        4: 'Четвертый сет',
	        5: 'Пятый сет',
	        6: 'Шестой сет',
	        7: 'Седьмой сет'
	    },
	    6: {
	        0: 'Матч',
	        1: 'Первый сет',
	        2: 'Второй сет',
	        3: 'Третий сет',
	        4: 'Четвертый сет',
	        5: 'Пятый сет'
	    },
	    4: {
	        0: 'Матч',
	        1: 'Первый сет',
	        2: 'Второй сет',
	        3: 'Третий сет',
	        4: 'Четвертый сет',
	        5: 'Пятый сет',
	        6: 'Шестой сет',
	        7: 'Мини-сет до 10 очков (Первый сет)',
	        8: 'Мини-сет до 15 очков (Первый сет)',
	        9: 'Мини-сет до 10 очков (Второй сет)',
	        10: 'Мини-сет до 15 очков (Второй сет)',
	        11: 'Мини-сет до 10 очков (Третий сет)',
	        12: 'Мини-сет до 15 очков (Третий сет)',
	        13: 'Мини-сет до 10 очков (Четвертый сет)',
	        14: 'Мини-сет до 15 очков (Четвертый сет)'
	    },
	    8: {
	        0: 'Матч',
	        1: 'Первая четверть',
	        2: 'Вторая четверть',
	        3: 'Третья четверть',
	        4: 'Четвертая четверть'
	    }
	};
	
	var slotConfig = {
	    32: {
	        366: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        557: sl_e1,
	        607: sl_f1,
	        122: sl_g1,
	        129: sl_h1,
	        138: sl_i1,
	        182: sl_j1,
	        367: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        558: sl_e1,
	        608: sl_f1,
	        123: sl_g1,
	        130: sl_h1,
	        139: sl_i1,
	        183: sl_j1,
	        368: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        559: sl_e1,
	        609: sl_f1,
	        124: sl_g1,
	        131: sl_h1,
	        140: sl_i1,
	        184: sl_j1,
	        362: sl_k1,
	        17: sl_c1,
	        176: sl_d1,
	        358: sl_k1,
	        13: sl_c1,
	        172: sl_d1,
	        363: sl_k1,
	        18: sl_c1,
	        177: sl_d1,
	        359: sl_k1,
	        14: sl_c1,
	        173: sl_d1,
	        364: sl_k1,
	        19: sl_c1,
	        178: sl_d1,
	        360: sl_k1,
	        15: sl_c1,
	        174: sl_d1
	    },
	    35: {
	        664: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1
	    },
	    31: {
	        664: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        769: sl_l1,
	        138: sl_i1,
	        182: sl_j1,
	        775: sl_m1,
	        765: sl_n1,
	        629: sl_e1,
	        633: sl_o1,
	        665: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        770: sl_l1,
	        139: sl_i1,
	        183: sl_j1,
	        776: sl_m1,
	        766: sl_n1,
	        630: sl_e1,
	        634: sl_o1,
	        666: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        771: sl_l1,
	        140: sl_p1,
	        184: sl_q1,
	        777: sl_m1,
	        767: sl_n1,
	        631: sl_r1,
	        635: sl_o1,
	        667: sl_b1,
	        24: sl_c1,
	        198: sl_d1,
	        772: sl_l1,
	        141: sl_p1,
	        185: sl_q1,
	        778: sl_m1,
	        768: sl_n1,
	        632: sl_r1,
	        636: sl_o1,
	        676: sl_b1,
	        248: sl_d1,
	        62: sl_c1,
	        241: sl_p1,
	        233: sl_q1,
	        406: sl_s1,
	        675: sl_b1,
	        246: sl_d1,
	        61: sl_c1,
	        240: sl_p1,
	        232: sl_q1,
	        405: sl_s1,
	        672: sl_b1,
	        58: sl_c1,
	        238: sl_d1,
	        234: sl_p1,
	        236: sl_q1,
	        673: sl_b1,
	        59: sl_c1,
	        239: sl_d1,
	        235: sl_p1,
	        237: sl_q1
	    },
	    41: {
	        664: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        782: sl_l1,
	        785: sl_m1,
	        780: sl_n1,
	        138: sl_p1,
	        182: sl_q1,
	        639: sl_r1,
	        665: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        783: sl_l1,
	        786: sl_t1,
	        781: sl_t1,
	        139: sl_p1,
	        183: sl_q1,
	        640: sl_r1,
	        64: sl_c1,
	        678: sl_b1,
	        250: sl_d1,
	        63: sl_c1,
	        677: sl_b1,
	        249: sl_d1
	    },
	    18: {
	        664: sl_b1,
	        195: sl_d1,
	        698: sl_u1,
	        21: sl_c1,
	        734: sl_v1,
	        665: sl_b1,
	        196: sl_d1,
	        699: sl_u1,
	        22: sl_c1,
	        735: sl_v1,
	        666: sl_b1,
	        197: sl_d1,
	        700: sl_u1,
	        23: sl_c1,
	        736: sl_v1
	    },
	    3: {
	        366: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        896: sl_w1,
	        138: sl_i1,
	        182: sl_j1,
	        557: sl_x1,
	        83: sl_y1,
	        788: sl_z1,
	        842: sl_a2,
	        845: sl_b2,
	        848: sl_c2,
	        607: sl_f1,
	        791: sl_t1,
	        367: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        897: sl_w1,
	        139: sl_i1,
	        183: sl_j1,
	        558: sl_x1,
	        84: sl_y1,
	        789: sl_z1,
	        843: sl_a2,
	        846: sl_b2,
	        849: sl_c2,
	        608: sl_f1,
	        792: sl_t1,
	        368: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        898: sl_w1,
	        140: sl_i1,
	        184: sl_j1,
	        559: sl_x1,
	        85: sl_y1,
	        790: sl_z1,
	        844: sl_a2,
	        847: sl_b2,
	        850: sl_c2,
	        609: sl_f1,
	        793: sl_t1,
	        362: sl_k1,
	        17: sl_c1,
	        176: sl_d1,
	        358: sl_k1,
	        13: sl_c1,
	        172: sl_d1,
	        363: sl_k1,
	        18: sl_c1,
	        177: sl_d1,
	        359: sl_k1,
	        14: sl_c1,
	        173: sl_d1
	    },
	    20: {
	        664: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1,
	        851: sl_l1,
	        665: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        139: sl_i1,
	        183: sl_j1,
	        852: sl_l1,
	        666: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        140: sl_i1,
	        184: sl_j1,
	        853: sl_l1,
	        667: sl_b1,
	        24: sl_c1,
	        198: sl_d1,
	        141: sl_i1,
	        185: sl_j1,
	        854: sl_l1,
	        199: sl_d1,
	        142: sl_i1,
	        186: sl_j1,
	        25: sl_c1,
	        668: sl_b1,
	        855: sl_l1,
	        200: sl_d1,
	        143: sl_i1,
	        187: sl_j1,
	        26: sl_c1,
	        669: sl_b1,
	        856: sl_l1,
	        201: sl_d1,
	        144: sl_i1,
	        188: sl_j1,
	        27: sl_c1,
	        670: sl_b1,
	        857: sl_l1,
	        202: sl_d1,
	        145: sl_i1,
	        189: sl_j1,
	        28: sl_c1,
	        671: sl_b1,
	        858: sl_l1
	    },
	    42: {
	        557: sl_d2,
	        1865: sl_e2,
	        558: sl_d2,
	        1866: sl_e2,
	        559: sl_d2,
	        1867: sl_e2,
	        560: sl_d2,
	        1868: sl_e2,
	        561: sl_d2,
	        1869: sl_e2
	    },
	    36: {
	        664: sl_b1,
	        21: sl_c1,
	        195: sl_d1
	    },
	    7: {
	        426: sl_z1,
	        526: sl_a2,
	        419: sl_f2,
	        519: sl_g2,
	        664: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1,
	        734: sl_v1,
	        756: sl_l1,
	        698: sl_h2,
	        794: sl_i2,
	        860: sl_j2,
	        273: sl_k2,
	        83: sl_y1,
	        727: sl_l2,
	        729: sl_m2,
	        731: sl_n2,
	        648: sl_o2,
	        420: sl_f2,
	        520: sl_g2,
	        665: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        139: sl_i1,
	        183: sl_j1,
	        735: sl_v1,
	        757: sl_l1,
	        699: sl_h2,
	        859: sl_i2,
	        861: sl_j2,
	        274: sl_k2,
	        84: sl_y1,
	        728: sl_l2,
	        649: sl_o2,
	        652: sl_b1,
	        641: sl_o2,
	        2: sl_c1,
	        160: sl_d1,
	        148: sl_i1,
	        154: sl_j1,
	        655: sl_b1,
	        642: sl_o2,
	        5: sl_c1,
	        163: sl_d1,
	        149: sl_i1,
	        155: sl_j1,
	        657: sl_b1,
	        643: sl_o2,
	        7: sl_c1,
	        165: sl_d1,
	        150: sl_i1,
	        156: sl_j1,
	        658: sl_b1,
	        644: sl_o2,
	        930: sl_c1,
	        166: sl_d1,
	        151: sl_i1,
	        157: sl_j1,
	        660: sl_b1,
	        645: sl_o2,
	        9: sl_c1,
	        168: sl_d1,
	        152: sl_i1,
	        158: sl_j1,
	        663: sl_b1,
	        646: sl_o2,
	        12: sl_c1,
	        171: sl_d1,
	        153: sl_i1,
	        159: sl_j1,
	        680: sl_b1,
	        66: sl_c1,
	        255: sl_d1,
	        438: sl_p2,
	        354: sl_i1,
	        355: sl_j1,
	        681: sl_b1,
	        67: sl_c1,
	        258: sl_d1,
	        356: sl_i1,
	        357: sl_j1,
	        690: sl_q2,
	        81: sl_c1,
	        353: sl_d1,
	        440: sl_r2,
	        441: sl_s2,
	        682: sl_b1,
	        68: sl_c1,
	        259: sl_d1,
	        146: sl_i1,
	        650: sl_o2,
	        740: sl_v1,
	        69: sl_c1,
	        262: sl_d1,
	        683: sl_b1,
	        694: sl_m2,
	        180: sl_q1,
	        70: sl_c1,
	        263: sl_d1,
	        684: sl_b1,
	        72: sl_c1,
	        277: sl_d1,
	        686: sl_b1,
	        181: sl_t2,
	        147: sl_u2,
	        741: sl_v1,
	        276: sl_v2,
	        275: sl_w2
	    },
	    34: {
	        419: sl_f2,
	        519: sl_g2,
	        664: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1,
	        734: sl_v1,
	        756: sl_l1,
	        698: sl_h2,
	        794: sl_i2,
	        860: sl_j2,
	        83: sl_y1,
	        420: sl_f2,
	        520: sl_g2,
	        665: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        139: sl_i1,
	        183: sl_j1,
	        735: sl_v1,
	        757: sl_l1,
	        699: sl_h2,
	        795: sl_i2,
	        861: sl_j2,
	        84: sl_y1,
	        652: sl_b1,
	        2: sl_c1,
	        160: sl_d1,
	        148: sl_i1,
	        154: sl_j1,
	        655: sl_b1,
	        5: sl_c1,
	        163: sl_d1,
	        149: sl_i1,
	        155: sl_j1,
	        657: sl_b1,
	        7: sl_c1,
	        165: sl_d1,
	        150: sl_i1,
	        156: sl_j1,
	        658: sl_b1,
	        930: sl_c1,
	        166: sl_d1,
	        151: sl_i1,
	        157: sl_j1,
	        660: sl_b1,
	        9: sl_c1,
	        168: sl_d1,
	        152: sl_i1,
	        158: sl_j1,
	        663: sl_b1,
	        12: sl_c1,
	        171: sl_d1,
	        153: sl_i1,
	        159: sl_j1,
	        255: sl_d1,
	        353: sl_d1
	    },
	    19: {
	        664: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        877: sl_l1,
	        138: sl_i1,
	        182: sl_j1,
	        875: sl_x2,
	        873: sl_y2,
	        196: sl_d1,
	        878: sl_l1,
	        876: sl_x2,
	        874: sl_y2,
	        665: sl_b1,
	        22: sl_c1
	    },
	    30: {
	        664: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        756: sl_l1,
	        138: sl_i1,
	        182: sl_j1,
	        734: sl_v1,
	        83: sl_y1,
	        698: sl_u1,
	        665: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        757: sl_l1,
	        139: sl_i1,
	        183: sl_j1,
	        735: sl_v1,
	        84: sl_y1,
	        699: sl_u1,
	        666: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        758: sl_l1,
	        140: sl_i1,
	        184: sl_j1,
	        736: sl_v1,
	        85: sl_y1,
	        700: sl_u1,
	        653: sl_b1,
	        161: sl_d1,
	        3: sl_c1,
	        654: sl_b1,
	        162: sl_d1,
	        4: sl_c1,
	        656: sl_b1,
	        164: sl_d1,
	        6: sl_c1,
	        659: sl_b1,
	        167: sl_d1,
	        8: sl_c1,
	        661: sl_b1,
	        169: sl_d1,
	        10: sl_c1,
	        662: sl_b1,
	        170: sl_d1,
	        11: sl_c1
	    },
	    9: {
	        664: sl_b1,
	        195: sl_d1,
	        665: sl_b1,
	        196: sl_d1
	    },
	    29: {
	        366: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        466: sl_z2,
	        557: sl_e1,
	        799: sl_a3,
	        83: sl_y1,
	        367: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        467: sl_z2,
	        558: sl_e1,
	        800: sl_a3,
	        84: sl_y1,
	        368: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        468: sl_z2,
	        559: sl_e1,
	        801: sl_a3,
	        85: sl_y1,
	        369: sl_b1,
	        24: sl_c1,
	        198: sl_d1,
	        469: sl_z2,
	        560: sl_e1,
	        802: sl_a3,
	        86: sl_y1,
	        370: sl_b1,
	        25: sl_c1,
	        199: sl_d1,
	        470: sl_z2,
	        561: sl_e1,
	        803: sl_a3,
	        87: sl_y1,
	        371: sl_b1,
	        26: sl_c1,
	        200: sl_d1,
	        471: sl_z2,
	        562: sl_e1,
	        804: sl_a3,
	        88: sl_y1,
	        372: sl_b1,
	        27: sl_c1,
	        201: sl_d1,
	        472: sl_z2,
	        563: sl_e1,
	        805: sl_a3,
	        89: sl_y1,
	        373: sl_b1,
	        28: sl_c1,
	        202: sl_d1,
	        473: sl_z2,
	        564: sl_e1,
	        806: sl_a3,
	        90: sl_y1,
	        374: sl_b1,
	        29: sl_c1,
	        203: sl_d1,
	        474: sl_z2,
	        565: sl_e1,
	        807: sl_a3,
	        91: sl_y1,
	        375: sl_b1,
	        30: sl_c1,
	        204: sl_d1,
	        475: sl_z2,
	        566: sl_e1,
	        808: sl_a3,
	        92: sl_y1,
	        376: sl_b1,
	        31: sl_c1,
	        205: sl_d1,
	        476: sl_z2,
	        567: sl_e1,
	        809: sl_a3,
	        93: sl_y1,
	        377: sl_b1,
	        32: sl_c1,
	        206: sl_d1,
	        477: sl_z2,
	        568: sl_e1,
	        810: sl_a3,
	        94: sl_y1,
	        378: sl_b1,
	        33: sl_c1,
	        207: sl_d1,
	        478: sl_z2,
	        569: sl_e1,
	        811: sl_a3,
	        95: sl_y1,
	        379: sl_b1,
	        34: sl_c1,
	        208: sl_d1,
	        479: sl_z2,
	        570: sl_e1,
	        812: sl_a3,
	        96: sl_y1,
	        380: sl_b1,
	        35: sl_c1,
	        209: sl_d1,
	        480: sl_z2,
	        571: sl_e1,
	        813: sl_a3,
	        97: sl_y1,
	        381: sl_b1,
	        36: sl_c1,
	        210: sl_d1,
	        481: sl_z2,
	        572: sl_e1,
	        814: sl_a3,
	        98: sl_y1,
	        382: sl_b1,
	        37: sl_c1,
	        211: sl_d1,
	        482: sl_z2,
	        573: sl_e1,
	        815: sl_a3,
	        99: sl_y1,
	        383: sl_b1,
	        38: sl_c1,
	        212: sl_d1,
	        483: sl_z2,
	        574: sl_e1,
	        816: sl_a3,
	        100: sl_y1,
	        384: sl_b1,
	        39: sl_c1,
	        213: sl_d1,
	        484: sl_z2,
	        575: sl_e1,
	        817: sl_a3,
	        101: sl_y1,
	        385: sl_b1,
	        40: sl_c1,
	        214: sl_d1,
	        485: sl_z2,
	        576: sl_e1,
	        818: sl_a3,
	        104: sl_y1,
	        386: sl_b1,
	        41: sl_c1,
	        215: sl_d1,
	        486: sl_z2,
	        577: sl_e1,
	        819: sl_a3,
	        105: sl_y1,
	        387: sl_b1,
	        42: sl_c1,
	        216: sl_d1,
	        487: sl_z2,
	        578: sl_e1,
	        820: sl_a3,
	        106: sl_y1,
	        388: sl_b1,
	        43: sl_c1,
	        217: sl_d1,
	        488: sl_z2,
	        579: sl_e1,
	        821: sl_a3,
	        107: sl_y1,
	        389: sl_b1,
	        44: sl_c1,
	        218: sl_d1,
	        489: sl_z2,
	        580: sl_e1,
	        822: sl_a3,
	        108: sl_y1,
	        390: sl_b1,
	        45: sl_c1,
	        219: sl_d1,
	        490: sl_z2,
	        581: sl_e1,
	        823: sl_a3,
	        109: sl_y1,
	        391: sl_b1,
	        46: sl_c1,
	        220: sl_d1,
	        491: sl_z2,
	        582: sl_e1,
	        824: sl_a3,
	        110: sl_y1,
	        392: sl_b1,
	        47: sl_c1,
	        221: sl_d1,
	        492: sl_z2,
	        583: sl_e1,
	        825: sl_a3,
	        111: sl_y1,
	        393: sl_b1,
	        48: sl_c1,
	        222: sl_d1,
	        493: sl_z2,
	        584: sl_e1,
	        826: sl_a3,
	        112: sl_y1,
	        394: sl_b1,
	        49: sl_c1,
	        223: sl_d1,
	        494: sl_z2,
	        585: sl_e1,
	        827: sl_a3,
	        113: sl_y1,
	        395: sl_b1,
	        50: sl_c1,
	        224: sl_d1,
	        495: sl_z2,
	        586: sl_e1,
	        828: sl_a3,
	        114: sl_y1,
	        396: sl_b1,
	        51: sl_c1,
	        225: sl_d1,
	        496: sl_z2,
	        587: sl_e1,
	        829: sl_a3,
	        115: sl_y1,
	        397: sl_b1,
	        52: sl_c1,
	        226: sl_d1,
	        497: sl_z2,
	        588: sl_e1,
	        830: sl_a3,
	        116: sl_y1,
	        398: sl_b1,
	        53: sl_c1,
	        227: sl_d1,
	        498: sl_z2,
	        589: sl_e1,
	        831: sl_a3,
	        117: sl_y1,
	        399: sl_b1,
	        54: sl_c1,
	        228: sl_d1,
	        499: sl_z2,
	        590: sl_e1,
	        832: sl_a3,
	        118: sl_y1,
	        400: sl_b1,
	        55: sl_c1,
	        229: sl_d1,
	        500: sl_z2,
	        591: sl_e1,
	        833: sl_a3,
	        119: sl_y1,
	        401: sl_b1,
	        56: sl_c1,
	        230: sl_d1,
	        501: sl_z2,
	        592: sl_e1,
	        834: sl_a3,
	        120: sl_y1,
	        402: sl_b1,
	        57: sl_c1,
	        231: sl_d1,
	        502: sl_z2,
	        593: sl_e1,
	        835: sl_a3,
	        121: sl_y1
	    },
	    2: {
	        366: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1,
	        607: sl_f1,
	        557: sl_x1,
	        863: sl_l1,
	        885: sl_l1,
	        122: sl_g1,
	        129: sl_h1,
	        83: sl_b3,
	        367: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        139: sl_i1,
	        183: sl_j1,
	        608: sl_f1,
	        558: sl_x1,
	        864: sl_l1,
	        886: sl_l1,
	        123: sl_g1,
	        130: sl_h1,
	        84: sl_b3,
	        368: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        140: sl_i1,
	        184: sl_j1,
	        609: sl_f1,
	        559: sl_x1,
	        865: sl_l1,
	        887: sl_l1,
	        124: sl_g1,
	        131: sl_h1,
	        85: sl_b3,
	        369: sl_b1,
	        24: sl_c1,
	        198: sl_d1,
	        141: sl_i1,
	        185: sl_j1,
	        610: sl_f1,
	        560: sl_x1,
	        866: sl_l1,
	        888: sl_l1,
	        125: sl_g1,
	        132: sl_h1,
	        86: sl_b3,
	        370: sl_b1,
	        25: sl_c1,
	        199: sl_d1,
	        142: sl_i1,
	        186: sl_j1,
	        611: sl_f1,
	        561: sl_x1,
	        867: sl_l1,
	        889: sl_l1,
	        126: sl_g1,
	        133: sl_h1,
	        87: sl_b3,
	        371: sl_b1,
	        26: sl_c1,
	        200: sl_d1,
	        143: sl_i1,
	        187: sl_j1,
	        612: sl_f1,
	        562: sl_x1,
	        868: sl_l1,
	        890: sl_l1,
	        127: sl_g1,
	        134: sl_h1,
	        88: sl_b3,
	        372: sl_b1,
	        27: sl_c1,
	        201: sl_d1,
	        144: sl_i1,
	        188: sl_j1,
	        613: sl_f1,
	        563: sl_x1,
	        869: sl_l1,
	        891: sl_l1,
	        128: sl_g1,
	        135: sl_h1,
	        89: sl_b3
	    },
	    6: {
	        1861: sl_c3,
	        366: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1,
	        333: sl_d3,
	        557: sl_e3,
	        745: sl_v1,
	        896: sl_w1,
	        618: sl_f3,
	        594: sl_g3,
	        759: sl_h3,
	        750: sl_i3,
	        190: sl_j3,
	        83: sl_y1,
	        300: sl_k3,
	        310: sl_l3,
	        545: sl_m3,
	        508: sl_n3,
	        552: sl_o3,
	        708: sl_p3,
	        76: sl_q3,
	        367: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        139: sl_i1,
	        183: sl_j1,
	        334: sl_d3,
	        558: sl_e3,
	        746: sl_v1,
	        897: sl_w1,
	        619: sl_f3,
	        595: sl_g3,
	        760: sl_h3,
	        751: sl_i3,
	        191: sl_j3,
	        84: sl_y1,
	        301: sl_k3,
	        311: sl_l3,
	        546: sl_m3,
	        509: sl_n3,
	        553: sl_o3,
	        709: sl_p3,
	        77: sl_q3,
	        368: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        140: sl_i1,
	        184: sl_j1,
	        335: sl_d3,
	        559: sl_e3,
	        747: sl_v1,
	        898: sl_w1,
	        620: sl_f3,
	        596: sl_g3,
	        761: sl_h3,
	        752: sl_i3,
	        192: sl_j3,
	        85: sl_y1,
	        302: sl_k3,
	        312: sl_l3,
	        547: sl_m3,
	        510: sl_n3,
	        554: sl_o3,
	        710: sl_p3,
	        78: sl_q3,
	        369: sl_b1,
	        24: sl_c1,
	        198: sl_d1,
	        141: sl_i1,
	        185: sl_j1,
	        336: sl_d3,
	        560: sl_e3,
	        748: sl_v1,
	        899: sl_w1,
	        621: sl_f3,
	        597: sl_g3,
	        762: sl_h3,
	        753: sl_i3,
	        193: sl_j3,
	        86: sl_y1,
	        303: sl_k3,
	        313: sl_l3,
	        548: sl_m3,
	        511: sl_n3,
	        555: sl_o3,
	        711: sl_p3,
	        79: sl_q3,
	        370: sl_b1,
	        25: sl_c1,
	        199: sl_d1,
	        142: sl_i1,
	        186: sl_j1,
	        337: sl_d3,
	        561: sl_e3,
	        749: sl_v1,
	        900: sl_w1,
	        622: sl_f3,
	        598: sl_g3,
	        763: sl_h3,
	        754: sl_i3,
	        194: sl_j3,
	        87: sl_y1,
	        304: sl_k3,
	        314: sl_l3,
	        549: sl_m3,
	        512: sl_n3,
	        556: sl_o3,
	        712: sl_p3,
	        80: sl_q3
	    },
	    4: {
	        366: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1,
	        896: sl_w1,
	        557: sl_e1,
	        836: sl_z1,
	        909: sl_a2,
	        914: sl_l1,
	        920: sl_l1,
	        83: sl_y1,
	        903: sl_t1,
	        607: sl_f1,
	        367: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        139: sl_i1,
	        183: sl_j1,
	        897: sl_w1,
	        558: sl_e1,
	        837: sl_z1,
	        910: sl_a2,
	        915: sl_l1,
	        921: sl_l1,
	        84: sl_y1,
	        904: sl_t1,
	        608: sl_f1,
	        368: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        140: sl_i1,
	        184: sl_j1,
	        898: sl_w1,
	        559: sl_e1,
	        838: sl_z1,
	        911: sl_a2,
	        916: sl_l1,
	        922: sl_l1,
	        85: sl_y1,
	        905: sl_t1,
	        609: sl_f1,
	        369: sl_b1,
	        24: sl_c1,
	        198: sl_d1,
	        141: sl_i1,
	        185: sl_j1,
	        899: sl_w1,
	        560: sl_e1,
	        839: sl_z1,
	        912: sl_a2,
	        917: sl_l1,
	        923: sl_l1,
	        86: sl_y1,
	        906: sl_t1,
	        610: sl_f1,
	        370: sl_b1,
	        25: sl_c1,
	        199: sl_d1,
	        142: sl_i1,
	        186: sl_j1,
	        900: sl_w1,
	        561: sl_e1,
	        840: sl_z1,
	        913: sl_a2,
	        918: sl_l1,
	        924: sl_l1,
	        87: sl_y1,
	        907: sl_t1,
	        611: sl_f1,
	        26: sl_c1,
	        200: sl_d1,
	        143: sl_i1,
	        187: sl_j1,
	        371: sl_b1,
	        562: sl_e1,
	        919: sl_l1,
	        925: sl_l1,
	        901: sl_r3,
	        908: sl_t1,
	        88: sl_y1,
	        362: sl_k1,
	        17: sl_c1,
	        176: sl_d1,
	        358: sl_k1,
	        13: sl_c1,
	        172: sl_d1,
	        363: sl_k1,
	        18: sl_c1,
	        177: sl_d1,
	        359: sl_k1,
	        14: sl_c1,
	        173: sl_d1,
	        364: sl_k1,
	        19: sl_c1,
	        178: sl_d1,
	        360: sl_k1,
	        15: sl_c1,
	        174: sl_d1,
	        365: sl_k1,
	        20: sl_c1,
	        179: sl_d1,
	        361: sl_k1,
	        16: sl_c1,
	        175: sl_d1
	    },
	    8: {
	        664: sl_b1,
	        195: sl_d1,
	        665: sl_b1,
	        196: sl_d1,
	        666: sl_b1,
	        197: sl_d1,
	        667: sl_b1,
	        198: sl_d1
	    }
	};
	
	var baseOutcomeConfig = {
	    11: {
	        74: bo_b1,
	        349: bo_c1,
	        256: bo_d1,
	        306: bo_e1,
	        103: bo_f1,
	        403: bo_g1,
	        443: bo_h1,
	        608: bo_i1
	    },
	    32: {
	        73: bo_b1,
	        318: bo_c1,
	        21: bo_j1,
	        22: bo_k1,
	        23: bo_l1,
	        195: bo_m1,
	        196: bo_n1,
	        197: bo_o1,
	        352: bo_p1,
	        748: bo_q1,
	        102: bo_f1,
	        403: bo_g1,
	        366: bo_r1,
	        367: bo_s1,
	        368: bo_t1,
	        138: bo_u1,
	        139: bo_v1,
	        140: bo_w1,
	        182: bo_x1,
	        183: bo_y1,
	        184: bo_z1,
	        122: bo_a2,
	        123: bo_b2,
	        124: bo_c2,
	        129: bo_d2,
	        130: bo_e2,
	        131: bo_f2,
	        566: bo_g2,
	        567: bo_h2,
	        568: bo_i2,
	        616: bo_j2,
	        617: bo_k2,
	        618: bo_l2,
	        257: bo_d1,
	        307: bo_e1,
	        443: bo_h1,
	        608: bo_i1,
	        362: bo_m2,
	        363: bo_n2,
	        364: bo_o2,
	        17: bo_p2,
	        18: bo_q2,
	        19: bo_r2,
	        176: bo_s2,
	        177: bo_t2,
	        178: bo_u2,
	        358: bo_v2,
	        359: bo_w2,
	        360: bo_x2,
	        13: bo_y2,
	        14: bo_z2,
	        15: bo_a3,
	        172: bo_b3,
	        173: bo_c3,
	        174: bo_d3,
	        256: bo_d1,
	        306: bo_e1
	    },
	    35: {
	        138: bo_e3,
	        256: bo_d1,
	        21: bo_f3,
	        673: bo_g3,
	        182: bo_h3,
	        306: bo_e1,
	        698: bo_g1,
	        731: bo_i3,
	        656: bo_j3,
	        195: bo_k3,
	        74: bo_b1,
	        349: bo_c1,
	        443: bo_h1,
	        608: bo_i1,
	        911: bo_l3,
	        426: bo_m3,
	        535: bo_n3,
	        871: bo_o3,
	        710: bo_p3,
	        742: bo_q3
	    },
	    10: {
	        74: bo_b1,
	        349: bo_c1,
	        256: bo_d1,
	        306: bo_e1,
	        103: bo_f1,
	        403: bo_g1,
	        1: bo_r3,
	        443: bo_h1,
	        608: bo_i1
	    },
	    31: {
	        74: bo_b1,
	        349: bo_c1,
	        21: bo_s3,
	        22: bo_t3,
	        23: bo_u3,
	        24: bo_v3,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_w3,
	        196: bo_x3,
	        197: bo_y3,
	        198: bo_z3,
	        673: bo_a4,
	        674: bo_b4,
	        675: bo_c4,
	        676: bo_d4,
	        103: bo_f1,
	        403: bo_g1,
	        138: bo_e4,
	        139: bo_f4,
	        140: bo_g4,
	        141: bo_h4,
	        182: bo_i4,
	        183: bo_j4,
	        184: bo_k4,
	        185: bo_l4,
	        238: bo_m4,
	        682: bo_n4,
	        239: bo_o4,
	        58: bo_p4,
	        59: bo_q4,
	        681: bo_r4,
	        234: bo_s4,
	        235: bo_t4,
	        236: bo_u4,
	        237: bo_v4,
	        725: bo_w4,
	        726: bo_x4,
	        727: bo_y4,
	        728: bo_z4,
	        782: bo_o3,
	        778: bo_a5,
	        779: bo_b5,
	        780: bo_c5,
	        781: bo_d5,
	        783: bo_e5,
	        773: bo_f5,
	        474: bo_g5,
	        421: bo_h5,
	        530: bo_i5,
	        422: bo_j5,
	        531: bo_k5,
	        444: bo_l5,
	        888: bo_m5,
	        280: bo_n5,
	        317: bo_o5,
	        424: bo_p5,
	        533: bo_q5,
	        423: bo_r5,
	        532: bo_s5,
	        637: bo_t5,
	        788: bo_u5,
	        784: bo_v5,
	        785: bo_w5,
	        786: bo_x5,
	        787: bo_y5,
	        774: bo_v5,
	        775: bo_w5,
	        776: bo_x5,
	        777: bo_y5,
	        281: bo_z5,
	        137: bo_a6,
	        246: bo_b6,
	        248: bo_c6,
	        240: bo_d6,
	        232: bo_e6,
	        241: bo_f6,
	        233: bo_g6,
	        61: bo_h6,
	        62: bo_i6,
	        684: bo_j6,
	        685: bo_k6,
	        443: bo_h1,
	        608: bo_i1,
	        890: bo_l6,
	        242: bo_m6,
	        245: bo_n6,
	        243: bo_o6,
	        60: bo_p6,
	        683: bo_q6,
	        406: bo_r6,
	        405: bo_s6,
	        404: bo_t6,
	        700: bo_u6,
	        408: bo_v6,
	        407: bo_w6,
	        247: bo_x6,
	        244: bo_y6,
	        638: bo_z6,
	        639: bo_a7,
	        640: bo_b7,
	        641: bo_c7,
	        646: bo_d7,
	        642: bo_e7,
	        643: bo_f7,
	        644: bo_g7,
	        645: bo_h7
	    },
	    41: {
	        74: bo_b1,
	        349: bo_c1,
	        21: bo_p4,
	        22: bo_q4,
	        403: bo_g1,
	        673: bo_i7,
	        674: bo_j7,
	        195: bo_m4,
	        196: bo_o4,
	        791: bo_k7,
	        792: bo_l7,
	        637: bo_t5,
	        796: bo_u5,
	        794: bo_m7,
	        795: bo_n7,
	        789: bo_m7,
	        790: bo_n7,
	        725: bo_o7,
	        726: bo_p7,
	        793: bo_o3,
	        411: bo_w6,
	        701: bo_l5,
	        251: bo_q7,
	        252: bo_r7,
	        409: bo_j5,
	        430: bo_k5,
	        410: bo_r5,
	        431: bo_s5,
	        281: bo_z5,
	        137: bo_a6,
	        249: bo_b6,
	        250: bo_c6,
	        63: bo_h6,
	        64: bo_i6,
	        686: bo_j6,
	        687: bo_k6,
	        103: bo_f1,
	        256: bo_d1,
	        306: bo_e1,
	        138: bo_s4,
	        139: bo_t4,
	        182: bo_u4,
	        183: bo_v4,
	        443: bo_h1,
	        608: bo_i1,
	        648: bo_s7,
	        649: bo_t7
	    },
	    18: {
	        74: bo_b1,
	        349: bo_c1,
	        656: bo_j3,
	        698: bo_g1,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_u7,
	        196: bo_v7,
	        197: bo_w7,
	        673: bo_x7,
	        674: bo_y7,
	        675: bo_z7,
	        610: bo_a8,
	        443: bo_h1,
	        608: bo_i1,
	        806: bo_b8,
	        893: bo_c8,
	        707: bo_d8,
	        708: bo_e8,
	        709: bo_f8,
	        889: bo_o3,
	        904: bo_g8,
	        253: bo_h8,
	        688: bo_i8,
	        65: bo_j8,
	        751: bo_q3,
	        21: bo_k8,
	        22: bo_l8,
	        23: bo_m8,
	        743: bo_n8,
	        744: bo_o8,
	        745: bo_p8,
	        615: bo_i3,
	        350: bo_h8
	    },
	    3: {
	        73: bo_b1,
	        318: bo_c1,
	        21: bo_j1,
	        22: bo_k1,
	        23: bo_l1,
	        195: bo_m1,
	        196: bo_n1,
	        197: bo_o1,
	        352: bo_p1,
	        746: bo_q3,
	        102: bo_f1,
	        403: bo_g1,
	        138: bo_u1,
	        139: bo_v1,
	        140: bo_w1,
	        182: bo_x1,
	        183: bo_y1,
	        184: bo_z1,
	        366: bo_r1,
	        367: bo_s1,
	        368: bo_t1,
	        566: bo_q8,
	        567: bo_r8,
	        568: bo_s8,
	        74: bo_t8,
	        854: bo_u8,
	        855: bo_v8,
	        856: bo_w8,
	        857: bo_u8,
	        858: bo_v8,
	        859: bo_w8,
	        797: bo_x8,
	        798: bo_y8,
	        799: bo_z8,
	        851: bo_a9,
	        852: bo_b9,
	        853: bo_c9,
	        83: bo_d9,
	        84: bo_e9,
	        85: bo_f9,
	        905: bo_g9,
	        906: bo_h9,
	        907: bo_i9,
	        443: bo_h1,
	        608: bo_i1,
	        362: bo_m2,
	        363: bo_n2,
	        17: bo_p2,
	        18: bo_q2,
	        176: bo_s2,
	        177: bo_t2,
	        358: bo_v2,
	        359: bo_w2,
	        13: bo_y2,
	        14: bo_z2,
	        172: bo_b3,
	        173: bo_c3,
	        616: bo_j2,
	        617: bo_k2,
	        618: bo_l2,
	        891: bo_l3,
	        257: bo_d1,
	        307: bo_e1,
	        800: bo_j9,
	        801: bo_k9,
	        802: bo_l9
	    },
	    20: {
	        74: bo_b1,
	        349: bo_c1,
	        256: bo_d1,
	        306: bo_e1,
	        698: bo_g1,
	        195: bo_m9,
	        196: bo_n9,
	        197: bo_o9,
	        198: bo_p9,
	        199: bo_q9,
	        200: bo_r9,
	        201: bo_s9,
	        202: bo_t9,
	        138: bo_u9,
	        139: bo_v9,
	        140: bo_w9,
	        141: bo_x9,
	        142: bo_y9,
	        143: bo_z9,
	        144: bo_a10,
	        145: bo_b10,
	        182: bo_c10,
	        183: bo_d10,
	        184: bo_e10,
	        185: bo_f10,
	        186: bo_g10,
	        187: bo_h10,
	        188: bo_i10,
	        189: bo_j10,
	        21: bo_k10,
	        22: bo_l10,
	        23: bo_m10,
	        24: bo_n10,
	        25: bo_o10,
	        26: bo_p10,
	        27: bo_q10,
	        28: bo_r10,
	        673: bo_s10,
	        674: bo_t10,
	        675: bo_u10,
	        676: bo_v10,
	        677: bo_w10,
	        678: bo_x10,
	        679: bo_y10,
	        680: bo_z10,
	        860: bo_a11,
	        861: bo_b11,
	        862: bo_c11,
	        863: bo_d11,
	        864: bo_e11,
	        865: bo_f11,
	        866: bo_g11,
	        867: bo_h11,
	        443: bo_h1,
	        608: bo_i1
	    },
	    5: {
	        349: bo_c1,
	        698: bo_g1,
	        443: bo_h1,
	        608: bo_i1,
	        945: bo_i11,
	        948: bo_j11,
	        949: bo_k11
	    },
	    40: {
	        656: bo_j3,
	        698: bo_g1,
	        443: bo_h1,
	        608: bo_i1
	    },
	    37: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    38: {
	        403: bo_g1,
	        443: bo_h1,
	        608: bo_i1,
	        74: bo_b1,
	        349: bo_l11,
	        615: bo_m11,
	        413: bo_n11,
	        414: bo_o11
	    },
	    42: {
	        403: bo_g1,
	        443: bo_h1,
	        608: bo_i1,
	        74: bo_b1,
	        349: bo_l11,
	        615: bo_p11,
	        413: bo_n11,
	        414: bo_q11,
	        566: bo_r11,
	        567: bo_s11,
	        568: bo_t11,
	        569: bo_u11,
	        570: bo_v11,
	        698: bo_w11,
	        366: bo_x11,
	        367: bo_y11,
	        368: bo_z11,
	        369: bo_a12,
	        370: bo_b12,
	        940: bo_c12,
	        941: bo_d12,
	        942: bo_e12,
	        943: bo_f12,
	        944: bo_g12
	    },
	    26: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    25: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    16: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    12: {
	        74: bo_b1,
	        349: bo_c1,
	        656: bo_j3,
	        698: bo_g1,
	        256: bo_d1,
	        306: bo_e1,
	        103: bo_f1,
	        443: bo_h1,
	        608: bo_i1
	    },
	    36: {
	        610: bo_h12,
	        698: bo_g1,
	        656: bo_j3,
	        74: bo_b1,
	        349: bo_c1,
	        615: bo_i3,
	        256: bo_d1,
	        306: bo_e1,
	        673: bo_x7,
	        21: bo_k8,
	        195: bo_u7,
	        443: bo_h1,
	        608: bo_i1
	    },
	    7: {
	        425: bo_i12,
	        534: bo_j12,
	        540: bo_k12,
	        343: bo_l12,
	        345: bo_m12,
	        260: bo_n12,
	        261: bo_o12,
	        83: bo_p12,
	        84: bo_q12,
	        803: bo_r12,
	        868: bo_s12,
	        869: bo_t12,
	        870: bo_u12,
	        805: bo_v12,
	        892: bo_w12,
	        346: bo_x12,
	        419: bo_y12,
	        528: bo_z12,
	        420: bo_a13,
	        529: bo_b13,
	        707: bo_c13,
	        708: bo_d13,
	        706: bo_e13,
	        804: bo_f13,
	        474: bo_g13,
	        614: bo_h13,
	        609: bo_i13,
	        416: bo_j13,
	        732: bo_k13,
	        525: bo_l13,
	        850: bo_m13,
	        473: bo_n13,
	        442: bo_o13,
	        729: bo_p13,
	        538: bo_q13,
	        542: bo_r13,
	        730: bo_s13,
	        471: bo_t13,
	        635: bo_u13,
	        714: bo_v13,
	        624: bo_w13,
	        625: bo_x13,
	        715: bo_y13,
	        650: bo_z13,
	        651: bo_a14,
	        652: bo_b14,
	        653: bo_c14,
	        654: bo_d14,
	        655: bo_e14,
	        634: bo_f14,
	        626: bo_g14,
	        733: bo_h14,
	        734: bo_i14,
	        258: bo_j14,
	        259: bo_k14,
	        66: bo_l14,
	        67: bo_m14,
	        81: bo_n14,
	        68: bo_o14,
	        689: bo_p14,
	        690: bo_q14,
	        699: bo_r14,
	        691: bo_s14,
	        723: bo_t14,
	        633: bo_u14,
	        74: bo_b1,
	        349: bo_c1,
	        656: bo_j3,
	        698: bo_g1,
	        322: bo_v14,
	        904: bo_w14,
	        1: bo_r3,
	        136: bo_x14,
	        747: bo_q3,
	        871: bo_o3,
	        255: bo_y14,
	        705: bo_z14,
	        323: bo_a15,
	        324: bo_b15,
	        702: bo_c15,
	        278: bo_d15,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_k3,
	        196: bo_e15,
	        21: bo_f3,
	        22: bo_f15,
	        282: bo_g15,
	        911: bo_l3,
	        353: bo_h15,
	        673: bo_g3,
	        674: bo_i15,
	        2: bo_j15,
	        5: bo_k15,
	        7: bo_l15,
	        939: bo_m15,
	        9: bo_n15,
	        12: bo_o15,
	        417: bo_p15,
	        526: bo_q15,
	        325: bo_r15,
	        103: bo_f1,
	        160: bo_s15,
	        163: bo_t15,
	        165: bo_u15,
	        166: bo_v15,
	        168: bo_w15,
	        171: bo_x15,
	        148: bo_y15,
	        149: bo_z15,
	        150: bo_a16,
	        151: bo_b16,
	        152: bo_c16,
	        153: bo_d16,
	        154: bo_e16,
	        155: bo_f16,
	        156: bo_g16,
	        157: bo_h16,
	        158: bo_i16,
	        159: bo_j16,
	        731: bo_i3,
	        765: bo_k16,
	        766: bo_l16,
	        415: bo_m16,
	        524: bo_n16,
	        418: bo_o16,
	        527: bo_p16,
	        743: bo_q16,
	        744: bo_r16,
	        710: bo_p3,
	        321: bo_s16,
	        326: bo_t16,
	        327: bo_u16,
	        724: bo_v16,
	        661: bo_w16,
	        664: bo_x16,
	        666: bo_y16,
	        667: bo_z16,
	        669: bo_a17,
	        672: bo_b17,
	        426: bo_m3,
	        535: bo_n3,
	        537: bo_c17,
	        541: bo_d17,
	        539: bo_e17,
	        138: bo_e3,
	        139: bo_f17,
	        182: bo_h3,
	        183: bo_g17,
	        437: bo_h17,
	        436: bo_i17,
	        694: bo_j17,
	        71: bo_k17,
	        271: bo_c1,
	        268: bo_l17,
	        265: bo_m17,
	        267: bo_n17,
	        270: bo_o17,
	        272: bo_p17,
	        269: bo_q17,
	        266: bo_r17,
	        264: bo_s17,
	        281: bo_z5,
	        137: bo_a6,
	        660: bo_j3,
	        880: bo_t17,
	        879: bo_u17,
	        429: bo_v17,
	        433: bo_w17,
	        443: bo_h1,
	        608: bo_i1,
	        881: bo_x17,
	        273: bo_y17,
	        274: bo_z17,
	        435: bo_a18,
	        704: bo_b18,
	        432: bo_c18,
	        428: bo_d18,
	        434: bo_e18,
	        439: bo_f18,
	        440: bo_g18,
	        441: bo_h18,
	        438: bo_i18,
	        623: bo_j18,
	        180: bo_k18,
	        146: bo_l18,
	        659: bo_m18,
	        749: bo_n18,
	        69: bo_o18,
	        262: bo_p18,
	        692: bo_q18,
	        703: bo_r18,
	        70: bo_s18,
	        263: bo_t18,
	        693: bo_u18,
	        72: bo_v18,
	        277: bo_w18,
	        695: bo_x18,
	        750: bo_y18,
	        181: bo_z18,
	        147: bo_a19,
	        276: bo_b19,
	        275: bo_c19,
	        735: bo_d19,
	        736: bo_e19,
	        737: bo_f19,
	        738: bo_g19,
	        739: bo_h19,
	        740: bo_i19,
	        356: bo_j19,
	        357: bo_k19,
	        354: bo_l19,
	        355: bo_m19,
	        937: bo_n19,
	        657: bo_o19,
	        658: bo_p19,
	        412: bo_q19
	    },
	    14: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    34: {
	        425: bo_i12,
	        534: bo_j12,
	        540: bo_k12,
	        343: bo_l12,
	        345: bo_m12,
	        260: bo_n12,
	        261: bo_o12,
	        83: bo_p12,
	        84: bo_q12,
	        803: bo_r12,
	        868: bo_s12,
	        869: bo_t12,
	        870: bo_u12,
	        346: bo_x12,
	        419: bo_y12,
	        528: bo_z12,
	        420: bo_a13,
	        529: bo_b13,
	        707: bo_c13,
	        708: bo_d13,
	        706: bo_e13,
	        538: bo_q13,
	        74: bo_b1,
	        349: bo_c1,
	        656: bo_j3,
	        698: bo_g1,
	        322: bo_v14,
	        904: bo_w14,
	        1: bo_r3,
	        136: bo_x14,
	        747: bo_q3,
	        871: bo_o3,
	        255: bo_y14,
	        705: bo_z14,
	        323: bo_a15,
	        324: bo_b15,
	        702: bo_c15,
	        278: bo_d15,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_k3,
	        196: bo_e15,
	        21: bo_f3,
	        22: bo_f15,
	        282: bo_g15,
	        911: bo_l3,
	        353: bo_h15,
	        673: bo_g3,
	        674: bo_i15,
	        2: bo_j15,
	        5: bo_k15,
	        7: bo_l15,
	        939: bo_m15,
	        9: bo_n15,
	        12: bo_o15,
	        417: bo_p15,
	        526: bo_q15,
	        325: bo_r15,
	        103: bo_f1,
	        160: bo_s15,
	        163: bo_t15,
	        165: bo_u15,
	        166: bo_v15,
	        168: bo_w15,
	        171: bo_x15,
	        148: bo_y15,
	        149: bo_z15,
	        150: bo_a16,
	        151: bo_b16,
	        152: bo_c16,
	        153: bo_d16,
	        154: bo_e16,
	        155: bo_f16,
	        156: bo_g16,
	        157: bo_h16,
	        158: bo_i16,
	        159: bo_j16,
	        731: bo_i3,
	        765: bo_k16,
	        766: bo_l16,
	        415: bo_m16,
	        524: bo_n16,
	        418: bo_o16,
	        527: bo_p16,
	        743: bo_q16,
	        744: bo_r16,
	        710: bo_p3,
	        321: bo_r19,
	        326: bo_t16,
	        327: bo_u16,
	        724: bo_v16,
	        661: bo_w16,
	        664: bo_x16,
	        666: bo_y16,
	        667: bo_z16,
	        669: bo_a17,
	        672: bo_b17,
	        426: bo_m3,
	        535: bo_n3,
	        537: bo_c17,
	        541: bo_d17,
	        539: bo_e17,
	        138: bo_e3,
	        139: bo_f17,
	        182: bo_h3,
	        183: bo_g17,
	        443: bo_h1,
	        608: bo_i1
	    },
	    19: {
	        74: bo_b1,
	        349: bo_c1,
	        698: bo_g1,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_k3,
	        196: bo_e15,
	        103: bo_f1,
	        615: bo_i3,
	        886: bo_k16,
	        887: bo_l16,
	        911: bo_l3,
	        884: bo_s19,
	        885: bo_t19,
	        882: bo_u19,
	        883: bo_v19,
	        723: bo_t14,
	        673: bo_g3,
	        674: bo_i15,
	        21: bo_f3,
	        22: bo_f15,
	        138: bo_e3,
	        182: bo_h3,
	        443: bo_h1,
	        608: bo_i1
	    },
	    30: {
	        74: bo_b1,
	        349: bo_c1,
	        656: bo_j3,
	        698: bo_g1,
	        21: bo_k8,
	        22: bo_l8,
	        23: bo_m8,
	        279: bo_w19,
	        610: bo_h12,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_u7,
	        196: bo_v7,
	        197: bo_w7,
	        673: bo_x7,
	        674: bo_y7,
	        675: bo_z7,
	        350: bo_h8,
	        103: bo_f1,
	        415: bo_m16,
	        524: bo_n16,
	        743: bo_n8,
	        744: bo_o8,
	        745: bo_p8,
	        710: bo_p3,
	        403: bo_g1,
	        426: bo_m3,
	        535: bo_n3,
	        706: bo_e13,
	        343: bo_l12,
	        346: bo_x12,
	        83: bo_x19,
	        84: bo_y19,
	        85: bo_z19,
	        344: bo_a20,
	        347: bo_b20,
	        765: bo_c20,
	        766: bo_d20,
	        767: bo_e20,
	        138: bo_f20,
	        139: bo_g20,
	        140: bo_h20,
	        182: bo_i20,
	        183: bo_j20,
	        184: bo_k20,
	        751: bo_q3,
	        911: bo_l3,
	        889: bo_o3,
	        637: bo_t5,
	        615: bo_i3,
	        412: bo_l20,
	        634: bo_m20,
	        626: bo_n20,
	        611: bo_o20,
	        443: bo_h1,
	        608: bo_i1,
	        904: bo_g8,
	        449: bo_p20,
	        446: bo_q20,
	        451: bo_r20,
	        711: bo_s20,
	        712: bo_t20,
	        713: bo_u20,
	        450: bo_v20,
	        447: bo_w20,
	        448: bo_x20,
	        662: bo_y20,
	        663: bo_z20,
	        665: bo_a21,
	        668: bo_b21,
	        670: bo_c21,
	        671: bo_d21,
	        3: bo_e21,
	        4: bo_f21,
	        6: bo_g21,
	        8: bo_h21,
	        10: bo_i21,
	        11: bo_j21,
	        161: bo_k21,
	        162: bo_l21,
	        164: bo_m21,
	        167: bo_n21,
	        169: bo_o21,
	        170: bo_p21,
	        707: bo_d8,
	        708: bo_e8,
	        709: bo_f8,
	        946: bo_j13,
	        947: bo_l13
	    },
	    23: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    13: {
	        468: bo_q21,
	        470: bo_r21,
	        467: bo_s21,
	        469: bo_t21,
	        464: bo_u21,
	        466: bo_v21,
	        465: bo_w21,
	        463: bo_x21,
	        289: bo_y21,
	        288: bo_z21,
	        292: bo_a22,
	        461: bo_b22,
	        283: bo_c22,
	        295: bo_d22,
	        293: bo_e22,
	        284: bo_f22,
	        285: bo_g22,
	        316: bo_h22,
	        286: bo_i22,
	        287: bo_j22,
	        290: bo_k22,
	        291: bo_l22,
	        462: bo_m22,
	        294: bo_n22
	    },
	    39: {
	        403: bo_g1,
	        443: bo_h1,
	        608: bo_i1,
	        698: bo_g1,
	        349: bo_c1,
	        950: bo_k11,
	        955: bo_i11,
	        951: bo_o22,
	        952: bo_p22,
	        953: bo_q22,
	        954: bo_r22
	    },
	    33: {
	        348: bo_s22,
	        443: bo_h1,
	        608: bo_i1
	    },
	    24: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    9: {
	        74: bo_b1,
	        349: bo_c1,
	        656: bo_j3,
	        698: bo_g1,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_k3,
	        196: bo_e15,
	        673: bo_g3,
	        674: bo_i15,
	        443: bo_h1,
	        608: bo_i1
	    },
	    21: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    29: {
	        394: bo_t22,
	        395: bo_u22,
	        396: bo_v22,
	        397: bo_w22,
	        398: bo_x22,
	        399: bo_y22,
	        400: bo_z22,
	        401: bo_a23,
	        402: bo_b23,
	        100: bo_c23,
	        101: bo_d23,
	        104: bo_e23,
	        105: bo_f23,
	        106: bo_g23,
	        107: bo_h23,
	        108: bo_i23,
	        109: bo_j23,
	        110: bo_k23,
	        111: bo_l23,
	        112: bo_m23,
	        113: bo_n23,
	        114: bo_o23,
	        115: bo_p23,
	        116: bo_q23,
	        117: bo_r23,
	        118: bo_s23,
	        119: bo_t23,
	        120: bo_u23,
	        121: bo_v23,
	        808: bo_w23,
	        809: bo_x23,
	        810: bo_y23,
	        811: bo_z23,
	        812: bo_a24,
	        813: bo_b24,
	        814: bo_c24,
	        815: bo_d24,
	        816: bo_e24,
	        817: bo_f24,
	        818: bo_g24,
	        819: bo_h24,
	        820: bo_i24,
	        821: bo_j24,
	        822: bo_k24,
	        823: bo_l24,
	        824: bo_m24,
	        825: bo_n24,
	        826: bo_o24,
	        827: bo_p24,
	        828: bo_q24,
	        829: bo_r24,
	        830: bo_s24,
	        831: bo_t24,
	        832: bo_u24,
	        833: bo_v24,
	        834: bo_w24,
	        835: bo_x24,
	        836: bo_y24,
	        837: bo_z24,
	        838: bo_a25,
	        839: bo_b25,
	        840: bo_c25,
	        841: bo_d25,
	        842: bo_e25,
	        843: bo_f25,
	        844: bo_g25,
	        366: bo_h25,
	        367: bo_i25,
	        368: bo_j25,
	        369: bo_k25,
	        370: bo_l25,
	        371: bo_m25,
	        372: bo_n25,
	        373: bo_o25,
	        374: bo_p25,
	        375: bo_q25,
	        376: bo_r25,
	        377: bo_s25,
	        378: bo_t25,
	        379: bo_u25,
	        380: bo_v25,
	        381: bo_w25,
	        382: bo_x25,
	        383: bo_y25,
	        384: bo_z25,
	        385: bo_a26,
	        386: bo_b26,
	        387: bo_c26,
	        388: bo_d26,
	        389: bo_e26,
	        390: bo_f26,
	        391: bo_g26,
	        392: bo_h26,
	        393: bo_i26,
	        481: bo_j26,
	        482: bo_k26,
	        483: bo_l26,
	        484: bo_m26,
	        485: bo_n26,
	        486: bo_o26,
	        487: bo_p26,
	        488: bo_q26,
	        489: bo_r26,
	        490: bo_s26,
	        491: bo_t26,
	        492: bo_u26,
	        493: bo_v26,
	        494: bo_w26,
	        495: bo_x26,
	        496: bo_y26,
	        497: bo_z26,
	        498: bo_a27,
	        499: bo_b27,
	        500: bo_c27,
	        501: bo_d27,
	        502: bo_e27,
	        503: bo_f27,
	        504: bo_g27,
	        505: bo_h27,
	        506: bo_i27,
	        507: bo_j27,
	        508: bo_k27,
	        509: bo_l27,
	        510: bo_m27,
	        511: bo_n27,
	        566: bo_o27,
	        567: bo_p27,
	        568: bo_q27,
	        569: bo_r27,
	        570: bo_s27,
	        571: bo_t27,
	        572: bo_u27,
	        573: bo_v27,
	        574: bo_w27,
	        575: bo_x27,
	        576: bo_y27,
	        577: bo_z27,
	        578: bo_a28,
	        579: bo_b28,
	        580: bo_c28,
	        581: bo_d28,
	        582: bo_e28,
	        583: bo_f28,
	        584: bo_g28,
	        585: bo_h28,
	        586: bo_i28,
	        587: bo_j28,
	        588: bo_k28,
	        589: bo_l28,
	        590: bo_m28,
	        591: bo_n28,
	        592: bo_o28,
	        593: bo_p28,
	        594: bo_q28,
	        595: bo_r28,
	        596: bo_s28,
	        597: bo_t28,
	        598: bo_u28,
	        599: bo_v28,
	        600: bo_w28,
	        601: bo_x28,
	        602: bo_y28,
	        83: bo_z28,
	        84: bo_a29,
	        85: bo_b29,
	        86: bo_c29,
	        87: bo_d29,
	        88: bo_e29,
	        89: bo_f29,
	        90: bo_g29,
	        91: bo_h29,
	        92: bo_i29,
	        93: bo_j29,
	        94: bo_k29,
	        95: bo_l29,
	        96: bo_m29,
	        97: bo_n29,
	        98: bo_o29,
	        99: bo_p29,
	        74: bo_b1,
	        349: bo_c1,
	        254: bo_q29,
	        403: bo_g1,
	        21: bo_r29,
	        22: bo_s29,
	        23: bo_t29,
	        24: bo_u29,
	        25: bo_v29,
	        26: bo_w29,
	        27: bo_x29,
	        28: bo_y29,
	        29: bo_z29,
	        30: bo_a30,
	        31: bo_b30,
	        32: bo_c30,
	        33: bo_d30,
	        34: bo_e30,
	        35: bo_f30,
	        36: bo_g30,
	        37: bo_h30,
	        38: bo_i30,
	        39: bo_j30,
	        40: bo_k30,
	        41: bo_l30,
	        42: bo_m30,
	        43: bo_n30,
	        44: bo_o30,
	        45: bo_p30,
	        46: bo_q30,
	        47: bo_r30,
	        48: bo_s30,
	        49: bo_t30,
	        50: bo_u30,
	        51: bo_v30,
	        52: bo_w30,
	        53: bo_x30,
	        54: bo_y30,
	        55: bo_z30,
	        56: bo_a31,
	        57: bo_b31,
	        195: bo_c31,
	        196: bo_d31,
	        197: bo_e31,
	        198: bo_f31,
	        199: bo_g31,
	        200: bo_h31,
	        201: bo_i31,
	        202: bo_j31,
	        203: bo_k31,
	        204: bo_l31,
	        205: bo_m31,
	        206: bo_n31,
	        207: bo_o31,
	        208: bo_p31,
	        209: bo_q31,
	        210: bo_r31,
	        211: bo_s31,
	        212: bo_t31,
	        213: bo_u31,
	        214: bo_v31,
	        215: bo_w31,
	        216: bo_x31,
	        217: bo_y31,
	        218: bo_z31,
	        219: bo_a32,
	        220: bo_b32,
	        221: bo_c32,
	        222: bo_d32,
	        223: bo_e32,
	        224: bo_f32,
	        225: bo_g32,
	        226: bo_h32,
	        227: bo_i32,
	        228: bo_j32,
	        229: bo_k32,
	        230: bo_l32,
	        231: bo_m32,
	        475: bo_n32,
	        476: bo_o32,
	        477: bo_p32,
	        478: bo_q32,
	        479: bo_r32,
	        480: bo_s32,
	        443: bo_h1,
	        608: bo_i1
	    },
	    15: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    2: {
	        73: bo_b1,
	        318: bo_c1,
	        21: bo_r29,
	        22: bo_s29,
	        23: bo_t29,
	        24: bo_u29,
	        25: bo_v29,
	        26: bo_w29,
	        27: bo_x29,
	        195: bo_c31,
	        196: bo_d31,
	        197: bo_e31,
	        198: bo_f31,
	        199: bo_g31,
	        200: bo_h31,
	        201: bo_i31,
	        352: bo_t32,
	        102: bo_f1,
	        403: bo_g1,
	        138: bo_u32,
	        139: bo_v32,
	        140: bo_w32,
	        141: bo_x32,
	        142: bo_y32,
	        143: bo_z32,
	        144: bo_a33,
	        182: bo_b33,
	        183: bo_c33,
	        184: bo_d33,
	        185: bo_e33,
	        186: bo_f33,
	        187: bo_g33,
	        188: bo_h33,
	        566: bo_i33,
	        567: bo_j33,
	        568: bo_k33,
	        569: bo_l33,
	        570: bo_m33,
	        571: bo_n33,
	        572: bo_o33,
	        366: bo_h25,
	        367: bo_i25,
	        368: bo_j25,
	        369: bo_k25,
	        370: bo_l25,
	        371: bo_m25,
	        372: bo_n25,
	        122: bo_p33,
	        123: bo_q33,
	        124: bo_r33,
	        125: bo_s33,
	        126: bo_t33,
	        127: bo_u33,
	        128: bo_v33,
	        129: bo_w33,
	        130: bo_x33,
	        131: bo_y33,
	        132: bo_z33,
	        133: bo_a34,
	        134: bo_b34,
	        135: bo_c34,
	        872: bo_d34,
	        873: bo_e34,
	        874: bo_f34,
	        875: bo_g34,
	        876: bo_h34,
	        877: bo_i34,
	        878: bo_j34,
	        616: bo_k34,
	        617: bo_l34,
	        618: bo_m34,
	        619: bo_n34,
	        620: bo_o34,
	        621: bo_p34,
	        622: bo_q34,
	        894: bo_d34,
	        895: bo_e34,
	        896: bo_f34,
	        897: bo_g34,
	        898: bo_h34,
	        899: bo_i34,
	        900: bo_j34,
	        443: bo_h1,
	        608: bo_i1,
	        83: bo_r34,
	        84: bo_s34,
	        85: bo_t34,
	        86: bo_u34,
	        87: bo_v34,
	        88: bo_w34,
	        89: bo_x34,
	        257: bo_d1,
	        307: bo_e1,
	        752: bo_y34,
	        753: bo_y34
	    },
	    6: {
	        553: bo_z34,
	        339: bo_a35,
	        547: bo_b35,
	        138: bo_u1,
	        139: bo_v1,
	        140: bo_w1,
	        141: bo_c35,
	        142: bo_d35,
	        182: bo_x1,
	        183: bo_y1,
	        184: bo_z1,
	        185: bo_e35,
	        186: bo_f35,
	        83: bo_d9,
	        84: bo_e9,
	        85: bo_f9,
	        86: bo_g35,
	        87: bo_h35,
	        807: bo_i35,
	        636: bo_j35,
	        334: bo_k35,
	        335: bo_l35,
	        336: bo_m35,
	        337: bo_n35,
	        906: bo_h9,
	        907: bo_i9,
	        908: bo_o35,
	        909: bo_p35,
	        300: bo_q35,
	        301: bo_r35,
	        302: bo_s35,
	        303: bo_t35,
	        304: bo_u35,
	        310: bo_v35,
	        311: bo_w35,
	        312: bo_x35,
	        313: bo_y35,
	        314: bo_z35,
	        554: bo_a36,
	        555: bo_b36,
	        556: bo_c36,
	        557: bo_d36,
	        558: bo_e36,
	        517: bo_f36,
	        518: bo_g36,
	        519: bo_h36,
	        520: bo_i36,
	        521: bo_j36,
	        561: bo_k36,
	        562: bo_l36,
	        563: bo_m36,
	        564: bo_n36,
	        565: bo_o36,
	        73: bo_b1,
	        318: bo_c1,
	        21: bo_j1,
	        22: bo_k1,
	        23: bo_l1,
	        24: bo_p36,
	        25: bo_q36,
	        195: bo_m1,
	        196: bo_n1,
	        197: bo_o1,
	        198: bo_r36,
	        199: bo_s36,
	        352: bo_p1,
	        748: bo_q1,
	        102: bo_f1,
	        403: bo_g1,
	        903: bo_t36,
	        445: bo_u36,
	        754: bo_v36,
	        755: bo_w36,
	        756: bo_x36,
	        757: bo_y36,
	        758: bo_z36,
	        452: bo_a37,
	        453: bo_b37,
	        454: bo_c37,
	        566: bo_d37,
	        567: bo_e37,
	        568: bo_f37,
	        569: bo_g37,
	        570: bo_h37,
	        366: bo_r1,
	        367: bo_s1,
	        368: bo_t1,
	        369: bo_i37,
	        370: bo_j37,
	        522: bo_k37,
	        627: bo_l37,
	        628: bo_m37,
	        629: bo_n37,
	        630: bo_o37,
	        631: bo_p37,
	        632: bo_q37,
	        190: bo_r37,
	        191: bo_s37,
	        192: bo_t37,
	        193: bo_u37,
	        194: bo_v37,
	        759: bo_w37,
	        760: bo_x37,
	        761: bo_y37,
	        762: bo_z37,
	        763: bo_a38,
	        768: bo_b38,
	        769: bo_c38,
	        770: bo_d38,
	        771: bo_e38,
	        772: bo_f38,
	        603: bo_g38,
	        604: bo_h38,
	        605: bo_i38,
	        606: bo_j38,
	        607: bo_k38,
	        257: bo_d1,
	        307: bo_e1,
	        696: bo_g1,
	        333: bo_l38,
	        341: bo_m38,
	        427: bo_n38,
	        536: bo_o38,
	        905: bo_g9,
	        320: bo_p38,
	        514: bo_q38,
	        516: bo_r38,
	        305: bo_s38,
	        315: bo_t38,
	        523: bo_u38,
	        299: bo_v38,
	        309: bo_w38,
	        697: bo_x38,
	        298: bo_y38,
	        308: bo_z38,
	        515: bo_a39,
	        549: bo_b39,
	        548: bo_c39,
	        443: bo_h1,
	        608: bo_i1,
	        550: bo_u36,
	        551: bo_u36,
	        455: bo_a37,
	        456: bo_a37,
	        457: bo_b37,
	        458: bo_b37,
	        459: bo_c37,
	        460: bo_c37,
	        512: bo_k37,
	        513: bo_k37,
	        901: bo_t36,
	        902: bo_t36,
	        340: bo_d39,
	        328: bo_e39,
	        329: bo_f39,
	        342: bo_g39,
	        330: bo_h39,
	        331: bo_i39,
	        722: bo_j39,
	        560: bo_k39,
	        543: bo_l39,
	        544: bo_m39,
	        545: bo_n39,
	        546: bo_o39,
	        332: bo_p39,
	        559: bo_q39,
	        296: bo_r39,
	        297: bo_s39,
	        717: bo_t39,
	        718: bo_u39,
	        719: bo_v39,
	        720: bo_w39,
	        721: bo_x39,
	        552: bo_y39,
	        76: bo_z39,
	        77: bo_a40,
	        78: bo_b40,
	        79: bo_c40,
	        80: bo_d40,
	        647: bo_e40,
	        741: bo_f40,
	        82: bo_g40,
	        338: bo_h40
	    },
	    17: {
	        348: bo_s22,
	        443: bo_h1,
	        608: bo_i1
	    },
	    4: {
	        73: bo_b1,
	        318: bo_c1,
	        21: bo_j1,
	        22: bo_k1,
	        23: bo_l1,
	        24: bo_p36,
	        25: bo_q36,
	        195: bo_m1,
	        196: bo_n1,
	        197: bo_o1,
	        198: bo_r36,
	        199: bo_s36,
	        352: bo_p1,
	        764: bo_q3,
	        102: bo_f1,
	        403: bo_g1,
	        138: bo_u1,
	        139: bo_v1,
	        140: bo_w1,
	        141: bo_c35,
	        142: bo_d35,
	        182: bo_x1,
	        183: bo_y1,
	        184: bo_z1,
	        185: bo_e35,
	        186: bo_f35,
	        366: bo_r1,
	        367: bo_s1,
	        368: bo_t1,
	        369: bo_i37,
	        370: bo_j37,
	        566: bo_g2,
	        567: bo_h2,
	        568: bo_i2,
	        569: bo_i40,
	        570: bo_j40,
	        74: bo_t8,
	        923: bo_u8,
	        924: bo_v8,
	        925: bo_w8,
	        926: bo_k40,
	        927: bo_l40,
	        929: bo_u8,
	        930: bo_v8,
	        931: bo_w8,
	        932: bo_k40,
	        933: bo_l40,
	        845: bo_x8,
	        846: bo_y8,
	        847: bo_z8,
	        848: bo_m40,
	        849: bo_n40,
	        918: bo_a9,
	        919: bo_b9,
	        920: bo_c9,
	        921: bo_o40,
	        922: bo_p40,
	        83: bo_d9,
	        84: bo_e9,
	        85: bo_f9,
	        86: bo_g35,
	        87: bo_h35,
	        905: bo_g9,
	        906: bo_h9,
	        907: bo_i9,
	        908: bo_o35,
	        909: bo_p35,
	        807: bo_i35,
	        319: bo_q40,
	        320: bo_p38,
	        912: bo_j9,
	        913: bo_k9,
	        914: bo_l9,
	        915: bo_r40,
	        916: bo_s40,
	        443: bo_h1,
	        608: bo_i1,
	        257: bo_d1,
	        307: bo_e1,
	        362: bo_m2,
	        363: bo_n2,
	        364: bo_o2,
	        365: bo_t40,
	        17: bo_p2,
	        18: bo_q2,
	        19: bo_r2,
	        20: bo_u40,
	        176: bo_s2,
	        177: bo_t2,
	        178: bo_u2,
	        179: bo_v40,
	        358: bo_v2,
	        359: bo_w2,
	        360: bo_x2,
	        361: bo_w40,
	        13: bo_y2,
	        14: bo_z2,
	        15: bo_a3,
	        16: bo_x40,
	        172: bo_b3,
	        173: bo_c3,
	        174: bo_d3,
	        175: bo_y40,
	        281: bo_z5,
	        137: bo_a6,
	        616: bo_j2,
	        617: bo_k2,
	        618: bo_l2,
	        619: bo_z40,
	        620: bo_a41,
	        891: bo_l3,
	        26: bo_b41,
	        200: bo_c41,
	        143: bo_d41,
	        187: bo_e41,
	        371: bo_f41,
	        571: bo_g41,
	        928: bo_h41,
	        934: bo_h41,
	        88: bo_i41,
	        910: bo_j41,
	        917: bo_k41,
	        936: bo_l41
	    },
	    8: {
	        74: bo_b1,
	        349: bo_c1,
	        656: bo_j3,
	        698: bo_g1,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_w3,
	        196: bo_x3,
	        197: bo_y3,
	        198: bo_z3,
	        673: bo_a4,
	        674: bo_b4,
	        675: bo_c4,
	        676: bo_d4,
	        103: bo_f1,
	        443: bo_h1,
	        608: bo_i1
	    },
	    27: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    28: {
	        403: bo_g1,
	        615: bo_m41,
	        74: bo_b1,
	        349: bo_c1,
	        256: bo_d1,
	        306: bo_e1,
	        103: bo_f1,
	        935: bo_q3,
	        612: bo_n41,
	        613: bo_o41,
	        443: bo_h1,
	        608: bo_i1
	    }
	};
	
	var outcomeConfig = {
	    7: {
	        426: function _(match, outcome) {
	            return match.homeTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['гол', 'гола', 'голов']);
	        },
	        535: function _(match, outcome) {
	            return match.awayTeam + " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0440\u043E\u0432\u043D\u043E \u0432 " + outcome.condition + " " + plural(outcome.condition, ['гол', 'гола', 'голов']);
	        }
	    },
	    6: {
	        455: function _(match, outcome) {
	            return "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 15x15 \u0432 " + outcome.condition + " \u0433\u0435\u0439\u043C\u0435?";
	        },
	        456: function _(match, outcome) {
	            return "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 15x15 \u0432 " + outcome.condition + " \u0433\u0435\u0439\u043C\u0435?";
	        },
	        457: function _(match, outcome) {
	            return "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 30x30 \u0432 " + outcome.condition + " \u0433\u0435\u0439\u043C\u0435?";
	        },
	        458: function _(match, outcome) {
	            return "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 30x30 \u0432 " + outcome.condition + " \u0433\u0435\u0439\u043C\u0435?";
	        },
	        459: function _(match, outcome) {
	            return "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 40x40 \u0432 " + outcome.condition + " \u0433\u0435\u0439\u043C\u0435?";
	        },
	        460: function _(match, outcome) {
	            return "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 40x40 \u0432 " + outcome.condition + " \u0433\u0435\u0439\u043C\u0435?";
	        }
	    }
	};
	
	var baseFactorNameConfig = {
	    11: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        403: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    32: {
	        73: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        318: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        352: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        748: {
	            1: fa_n1,
	            2: fa_o1,
	            3: fa_p1,
	            4: fa_q1,
	            5: fa_r1,
	            6: fa_s1,
	            7: fa_t1,
	            8: fa_u1,
	            9: fa_v1,
	            10: fa_w1
	        },
	        102: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        366: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        367: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        368: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        122: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        123: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        124: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        129: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        130: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        131: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        566: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        567: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        568: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        616: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        617: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        618: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        257: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        307: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        362: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        363: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        364: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        17: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        18: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        19: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        176: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        177: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        178: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        358: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        359: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        360: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        13: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        14: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        15: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        172: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        173: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        174: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        }
	    },
	    35: {
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        673: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        698: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        731: {
	            1: fa_h1,
	            2: fa_a2,
	            3: fa_i1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        911: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2,
	            4: fa_h2,
	            5: fa_i2,
	            6: fa_j2
	        },
	        426: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        535: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        871: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        710: {
	            1: fa_q2,
	            2: fa_r2,
	            3: fa_s2
	        },
	        742: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_v2,
	            6: fa_w2,
	            7: fa_x2,
	            8: fa_y2,
	            9: fa_p1,
	            10: fa_q1,
	            11: fa_z2,
	            12: fa_a3,
	            13: fa_r1,
	            14: fa_s1,
	            15: fa_b3,
	            16: fa_t1,
	            17: fa_c3,
	            18: fa_d3,
	            19: fa_e3,
	            20: fa_u1,
	            21: fa_v1,
	            22: fa_w1,
	            23: fa_f3,
	            24: fa_g3,
	            25: fa_h3,
	            26: fa_i3,
	            27: fa_j3,
	            28: fa_k3,
	            29: fa_l3,
	            30: fa_m3,
	            31: fa_n3,
	            32: fa_o3,
	            33: fa_p3,
	            34: fa_q3,
	            35: fa_r3
	        }
	    },
	    10: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        1: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    31: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        24: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        674: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        675: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        676: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        141: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        185: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        238: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        682: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        239: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        58: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        59: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        681: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        234: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        235: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        236: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        237: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        725: {
	            1: fa_h1,
	            2: fa_a2,
	            3: fa_i1
	        },
	        726: {
	            1: fa_h1,
	            2: fa_a2,
	            3: fa_i1
	        },
	        727: {
	            1: fa_h1,
	            2: fa_a2,
	            3: fa_i1
	        },
	        728: {
	            1: fa_h1,
	            2: fa_a2,
	            3: fa_i1
	        },
	        782: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        778: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        779: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        780: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        781: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        783: {
	            1: fa_p1,
	            2: fa_h3,
	            3: fa_y3,
	            4: fa_z3,
	            5: fa_a4,
	            6: fa_b4,
	            7: fa_c4,
	            8: fa_y1
	        },
	        773: {
	            1: fa_p1,
	            2: fa_h3,
	            3: fa_y3,
	            4: fa_z3,
	            5: fa_a4,
	            6: fa_b4,
	            7: fa_c4,
	            8: fa_x1
	        },
	        474: {
	            1: fa_d4,
	            2: fa_e4
	        },
	        421: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        530: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        422: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        531: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        444: {
	            1: fa_f4,
	            2: fa_g4
	        },
	        888: {
	            1: fa_h4,
	            2: fa_i4,
	            3: fa_j4,
	            4: fa_k4
	        },
	        280: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        317: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        424: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        533: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        423: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        532: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        637: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        788: {
	            1: fa_l4,
	            2: fa_m4,
	            3: fa_n4,
	            4: fa_o4,
	            5: fa_p4,
	            6: fa_q4,
	            7: fa_r4,
	            8: fa_s4,
	            9: fa_t4,
	            10: fa_u4,
	            11: fa_v4,
	            12: fa_w4,
	            13: fa_x4,
	            14: fa_y4
	        },
	        784: {
	            1: fa_l4,
	            2: fa_z4,
	            3: fa_a5,
	            4: fa_b5,
	            5: fa_c5
	        },
	        785: {
	            1: fa_l4,
	            2: fa_z4,
	            3: fa_a5,
	            4: fa_b5,
	            5: fa_c5
	        },
	        786: {
	            1: fa_l4,
	            2: fa_z4,
	            3: fa_a5,
	            4: fa_b5,
	            5: fa_c5
	        },
	        787: {
	            1: fa_l4,
	            2: fa_z4,
	            3: fa_a5,
	            4: fa_b5,
	            5: fa_c5
	        },
	        774: {
	            1: fa_s4,
	            2: fa_d5,
	            3: fa_e5,
	            4: fa_f5,
	            5: fa_g5
	        },
	        775: {
	            1: fa_s4,
	            2: fa_d5,
	            3: fa_e5,
	            4: fa_f5,
	            5: fa_g5
	        },
	        776: {
	            1: fa_s4,
	            2: fa_d5,
	            3: fa_e5,
	            4: fa_f5,
	            5: fa_g5
	        },
	        777: {
	            1: fa_s4,
	            2: fa_d5,
	            3: fa_e5,
	            4: fa_f5,
	            5: fa_g5
	        },
	        281: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        137: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        246: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        248: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        240: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        232: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        241: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        233: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        61: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        62: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        684: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        685: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        890: {
	            1: fa_h4,
	            2: fa_i4,
	            3: fa_j4,
	            4: fa_k4
	        },
	        242: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        245: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        243: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        60: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        683: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        406: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        405: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        404: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        700: {
	            1: fa_h5,
	            2: fa_i5,
	            3: fa_j5
	        },
	        408: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        407: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        247: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        244: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        638: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        639: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        640: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        641: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        646: {
	            1: fa_k5,
	            2: fa_l5,
	            3: fa_m5
	        },
	        642: {
	            1: fa_k5,
	            2: fa_l5,
	            3: fa_m5
	        },
	        643: {
	            1: fa_k5,
	            2: fa_l5,
	            3: fa_m5
	        },
	        644: {
	            1: fa_k5,
	            2: fa_l5,
	            3: fa_m5
	        },
	        645: {
	            1: fa_k5,
	            2: fa_l5,
	            3: fa_m5
	        }
	    },
	    41: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        673: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        674: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        791: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        792: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        637: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        796: {
	            1: fa_l4,
	            2: fa_m4,
	            3: fa_n4,
	            4: fa_o4,
	            5: fa_p4,
	            6: fa_q4,
	            7: fa_n5,
	            8: fa_s4,
	            9: fa_t4,
	            10: fa_u4,
	            11: fa_v4,
	            12: fa_w4,
	            13: fa_x4,
	            14: fa_o5
	        },
	        794: {
	            1: fa_l4,
	            2: fa_z4,
	            3: fa_a5,
	            4: fa_p5,
	            5: fa_c5
	        },
	        795: {
	            1: fa_l4,
	            2: fa_z4,
	            3: fa_a5,
	            4: fa_p5,
	            5: fa_c5
	        },
	        789: {
	            1: fa_s4,
	            2: fa_d5,
	            3: fa_e5,
	            4: fa_q5,
	            5: fa_g5
	        },
	        790: {
	            1: fa_s4,
	            2: fa_d5,
	            3: fa_e5,
	            4: fa_q5,
	            5: fa_g5
	        },
	        725: {
	            1: fa_h1,
	            2: fa_a2,
	            3: fa_i1
	        },
	        726: {
	            1: fa_h1,
	            2: fa_a2,
	            3: fa_i1
	        },
	        793: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        411: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        701: {
	            1: fa_f4,
	            2: fa_g4,
	            3: fa_r5
	        },
	        251: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        252: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        409: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        430: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        410: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        431: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        281: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        137: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        249: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        250: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        63: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        64: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        686: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        687: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        648: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        649: {
	            1: fa_h1,
	            2: fa_i1
	        }
	    },
	    18: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        698: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        674: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        675: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        610: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        806: {
	            1: fa_s5,
	            2: fa_t5,
	            3: fa_u5,
	            4: fa_v5,
	            5: fa_w5,
	            6: fa_c5
	        },
	        893: {
	            1: fa_x5,
	            2: fa_y5,
	            3: fa_z5,
	            4: fa_a6,
	            5: fa_b6,
	            6: fa_c6
	        },
	        707: {
	            1: fa_d6,
	            2: fa_e6,
	            3: fa_f6
	        },
	        708: {
	            1: fa_d6,
	            2: fa_e6,
	            3: fa_f6
	        },
	        709: {
	            1: fa_d6,
	            2: fa_e6,
	            3: fa_f6
	        },
	        889: {
	            1: fa_g6,
	            2: fa_m2,
	            3: fa_n2,
	            4: fa_o2,
	            5: fa_h6,
	            6: fa_i6,
	            7: fa_j6,
	            8: fa_k6
	        },
	        904: {
	            1: fa_l6,
	            2: fa_m6,
	            3: fa_n6,
	            4: fa_o6,
	            5: fa_p6,
	            6: fa_q6,
	            7: fa_r6,
	            8: fa_s6,
	            9: fa_t6
	        },
	        253: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        688: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        65: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        751: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_v2,
	            6: fa_w2,
	            7: fa_x2,
	            8: fa_y2,
	            9: fa_p1,
	            10: fa_q1,
	            11: fa_z2,
	            12: fa_a3,
	            13: fa_r1,
	            14: fa_s1,
	            15: fa_b3,
	            16: fa_t1,
	            17: fa_c3,
	            18: fa_d3,
	            19: fa_e3,
	            20: fa_u1,
	            21: fa_v1,
	            22: fa_w1,
	            23: fa_f3,
	            24: fa_g3,
	            25: fa_h3,
	            26: fa_i3,
	            27: fa_j3,
	            28: fa_k3,
	            29: fa_l3,
	            30: fa_m3,
	            31: fa_n3,
	            32: fa_o3,
	            33: fa_p3,
	            34: fa_q3,
	            35: fa_r3
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        743: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_r3
	        },
	        744: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_r3
	        },
	        745: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_r3
	        },
	        615: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        350: {
	            1: fa_d1,
	            2: fa_e1
	        }
	    },
	    3: {
	        73: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        318: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        352: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        746: {
	            1: fa_r1,
	            2: fa_s1,
	            3: fa_p1,
	            4: fa_n1
	        },
	        102: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        366: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        367: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        368: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        566: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        567: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        568: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        854: {
	            1: fa_s3,
	            2: fa_u6,
	            3: fa_v6,
	            4: fa_w6,
	            5: fa_x6,
	            6: fa_y6,
	            7: fa_z6,
	            8: fa_a7
	        },
	        855: {
	            1: fa_s3,
	            2: fa_u6,
	            3: fa_v6,
	            4: fa_w6,
	            5: fa_x6,
	            6: fa_y6,
	            7: fa_z6,
	            8: fa_a7
	        },
	        856: {
	            1: fa_s3,
	            2: fa_u6,
	            3: fa_v6,
	            4: fa_w6,
	            5: fa_x6,
	            6: fa_y6,
	            7: fa_z6,
	            8: fa_a7
	        },
	        857: {
	            1: fa_s3,
	            2: fa_b7,
	            3: fa_c7,
	            4: fa_d7,
	            5: fa_a7
	        },
	        858: {
	            1: fa_s3,
	            2: fa_b7,
	            3: fa_c7,
	            4: fa_d7,
	            5: fa_a7
	        },
	        859: {
	            1: fa_s3,
	            2: fa_b7,
	            3: fa_c7,
	            4: fa_d7,
	            5: fa_a7
	        },
	        797: {
	            1: fa_t1,
	            2: fa_e7,
	            3: fa_f7,
	            4: fa_y1
	        },
	        798: {
	            1: fa_t1,
	            2: fa_e7,
	            3: fa_f7,
	            4: fa_y1
	        },
	        799: {
	            1: fa_t1,
	            2: fa_e7,
	            3: fa_f7,
	            4: fa_y1
	        },
	        851: {
	            1: fa_t1,
	            2: fa_e7,
	            3: fa_f7,
	            4: fa_x1
	        },
	        852: {
	            1: fa_t1,
	            2: fa_e7,
	            3: fa_f7,
	            4: fa_x1
	        },
	        853: {
	            1: fa_t1,
	            2: fa_e7,
	            3: fa_f7,
	            4: fa_x1
	        },
	        83: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        84: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        85: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        905: {
	            1: fa_g7,
	            2: fa_h7,
	            3: fa_i7,
	            4: fa_j7
	        },
	        906: {
	            1: fa_g7,
	            2: fa_h7,
	            3: fa_i7,
	            4: fa_j7
	        },
	        907: {
	            1: fa_g7,
	            2: fa_h7,
	            3: fa_i7,
	            4: fa_j7
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        362: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        363: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        17: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        18: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        176: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        177: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        358: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        359: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        13: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        14: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        172: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        173: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        616: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        617: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        618: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        891: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2,
	            4: fa_h2
	        },
	        257: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        307: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        800: {
	            1: fa_k7,
	            2: fa_l7,
	            3: fa_m7,
	            4: fa_n7,
	            5: fa_o7,
	            6: fa_p7
	        },
	        801: {
	            1: fa_k7,
	            2: fa_l7,
	            3: fa_m7,
	            4: fa_n7,
	            5: fa_o7,
	            6: fa_p7
	        },
	        802: {
	            1: fa_k7,
	            2: fa_l7,
	            3: fa_m7,
	            4: fa_n7,
	            5: fa_o7,
	            6: fa_p7
	        }
	    },
	    20: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        698: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        199: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        200: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        201: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        202: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        141: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        142: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        143: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        144: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        145: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        185: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        186: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        187: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        188: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        189: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        24: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        25: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        26: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        27: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        28: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        673: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        674: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        675: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        676: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        677: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        678: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        679: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        680: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        860: {
	            1: fa_q7,
	            2: fa_u6,
	            3: fa_v6,
	            4: fa_w6,
	            5: fa_x6,
	            6: fa_y6,
	            7: fa_r7
	        },
	        861: {
	            1: fa_q7,
	            2: fa_u6,
	            3: fa_v6,
	            4: fa_w6,
	            5: fa_x6,
	            6: fa_y6,
	            7: fa_r7
	        },
	        862: {
	            1: fa_q7,
	            2: fa_u6,
	            3: fa_v6,
	            4: fa_w6,
	            5: fa_x6,
	            6: fa_y6,
	            7: fa_r7
	        },
	        863: {
	            1: fa_q7,
	            2: fa_u6,
	            3: fa_v6,
	            4: fa_w6,
	            5: fa_x6,
	            6: fa_y6,
	            7: fa_r7
	        },
	        864: {
	            1: fa_q7,
	            2: fa_u6,
	            3: fa_v6,
	            4: fa_w6,
	            5: fa_x6,
	            6: fa_y6,
	            7: fa_r7
	        },
	        865: {
	            1: fa_q7,
	            2: fa_u6,
	            3: fa_v6,
	            4: fa_w6,
	            5: fa_x6,
	            6: fa_y6,
	            7: fa_r7
	        },
	        866: {
	            1: fa_q7,
	            2: fa_u6,
	            3: fa_v6,
	            4: fa_w6,
	            5: fa_x6,
	            6: fa_y6,
	            7: fa_r7
	        },
	        867: {
	            1: fa_q7,
	            2: fa_u6,
	            3: fa_v6,
	            4: fa_w6,
	            5: fa_x6,
	            6: fa_y6,
	            7: fa_r7
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    5: {
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        698: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        945: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        948: {
	            1: fa_s7,
	            2: fa_t7,
	            3: fa_u7,
	            4: fa_v7,
	            5: fa_w7
	        },
	        949: {
	            1: fa_x7,
	            2: fa_y7,
	            3: fa_z7,
	            4: fa_a8,
	            5: fa_b8,
	            6: fa_c8,
	            7: fa_d8,
	            8: fa_e8,
	            9: fa_f8,
	            10: fa_g8,
	            11: fa_h8,
	            12: fa_i8,
	            13: fa_t7,
	            14: fa_u7,
	            15: fa_j8,
	            16: fa_k8,
	            17: fa_l8,
	            18: fa_m8,
	            19: fa_n8,
	            20: fa_o8,
	            21: fa_p8,
	            22: fa_q8,
	            23: fa_r8,
	            24: fa_s8,
	            25: fa_t8,
	            26: fa_u8,
	            27: fa_w7
	        }
	    },
	    40: {
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        698: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    37: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    38: {
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        615: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        413: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        414: {
	            1: fa_h1,
	            2: fa_i1
	        }
	    },
	    42: {
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        615: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        413: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        414: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        566: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        567: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        568: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        569: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        570: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        698: {
	            1: fa_x1,
	            2: fa_v8,
	            3: fa_y1
	        },
	        366: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        367: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        368: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        369: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        370: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        940: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        941: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        942: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        943: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        944: {
	            1: fa_x1,
	            2: fa_y1
	        }
	    },
	    26: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    25: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    16: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    12: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        698: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    36: {
	        610: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        698: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        615: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    7: {
	        425: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        534: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        540: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        343: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        345: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        260: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        261: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        83: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        84: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        803: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_w8
	        },
	        868: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_w8
	        },
	        869: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_w8
	        },
	        870: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_w8
	        },
	        805: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_w8
	        },
	        892: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_w8
	        },
	        346: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        419: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        528: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        420: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        529: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        707: {
	            1: fa_d6,
	            2: fa_e6,
	            3: fa_x8
	        },
	        708: {
	            1: fa_d6,
	            2: fa_e6,
	            3: fa_x8
	        },
	        706: {
	            1: fa_y8,
	            2: fa_z8,
	            3: fa_a9
	        },
	        804: {
	            1: fa_b9,
	            2: fa_c9,
	            3: fa_d9,
	            4: fa_e9
	        },
	        474: {
	            1: fa_d4,
	            2: fa_e4
	        },
	        614: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        609: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        416: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        732: {
	            1: fa_h1,
	            2: fa_a2,
	            3: fa_i1
	        },
	        525: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        850: {
	            1: fa_f9,
	            2: fa_g9,
	            3: fa_h9,
	            4: fa_i9
	        },
	        473: {
	            1: fa_j9,
	            2: fa_k9
	        },
	        442: {
	            1: fa_j9,
	            2: fa_k9
	        },
	        729: {
	            1: fa_h1,
	            2: fa_a2,
	            3: fa_i1
	        },
	        538: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        542: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        730: {
	            1: fa_h1,
	            2: fa_a2,
	            3: fa_i1
	        },
	        471: {
	            1: fa_j9,
	            2: fa_k9
	        },
	        635: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        714: {
	            1: fa_l9,
	            2: fa_a2,
	            3: fa_m9
	        },
	        624: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        625: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        715: {
	            1: fa_n9,
	            2: fa_o9,
	            3: fa_p9
	        },
	        650: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        651: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        652: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        653: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        654: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        655: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        634: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        626: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        733: {
	            1: fa_n9,
	            2: fa_o9,
	            3: fa_q9
	        },
	        734: {
	            1: fa_n9,
	            2: fa_o9,
	            3: fa_q9
	        },
	        258: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        259: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        66: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        67: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        81: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        68: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        689: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        690: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        699: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        691: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        723: {
	            1: fa_h1,
	            2: fa_a2,
	            3: fa_i1
	        },
	        633: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        698: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        322: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        904: {
	            1: fa_l6,
	            2: fa_m6,
	            3: fa_n6,
	            4: fa_o6,
	            5: fa_p6,
	            6: fa_q6,
	            7: fa_r6,
	            8: fa_s6,
	            9: fa_t6
	        },
	        1: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        136: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        747: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_v2,
	            6: fa_w2,
	            7: fa_r9,
	            8: fa_x2,
	            9: fa_y2,
	            10: fa_p1,
	            11: fa_q1,
	            12: fa_z2,
	            13: fa_a3,
	            14: fa_s9,
	            15: fa_r1,
	            16: fa_s1,
	            17: fa_b3,
	            18: fa_t1,
	            19: fa_c3,
	            20: fa_u1,
	            21: fa_v1,
	            22: fa_w1,
	            23: fa_f3,
	            24: fa_i3,
	            25: fa_j3,
	            26: fa_k3,
	            27: fa_n3,
	            28: fa_o3,
	            29: fa_t9,
	            30: fa_u9,
	            31: fa_r3
	        },
	        871: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        255: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        705: {
	            1: fa_v9,
	            2: fa_w9,
	            3: fa_x9
	        },
	        323: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        324: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        702: {
	            1: fa_l9,
	            2: fa_a2,
	            3: fa_m9
	        },
	        278: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        282: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        911: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2,
	            4: fa_h2,
	            5: fa_i2,
	            6: fa_j2
	        },
	        353: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        674: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        2: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        5: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        7: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        939: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        9: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        12: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        417: {
	            1: fa_y9,
	            2: fa_q9
	        },
	        526: {
	            1: fa_y9,
	            2: fa_q9
	        },
	        325: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        160: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        163: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        165: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        166: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        168: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        171: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        148: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        149: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        150: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        151: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        152: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        153: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        154: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        155: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        156: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        157: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        158: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        159: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        731: {
	            1: fa_h1,
	            2: fa_a2,
	            3: fa_i1
	        },
	        765: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        766: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        415: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        524: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        418: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        527: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        743: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_r3
	        },
	        744: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_r3
	        },
	        710: {
	            1: fa_q2,
	            2: fa_r2,
	            3: fa_s2
	        },
	        321: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        326: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        327: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        724: {
	            1: fa_z9,
	            2: fa_a10,
	            3: fa_b10
	        },
	        661: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        664: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        666: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        667: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        669: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        672: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        426: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        535: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        537: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        541: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        539: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        437: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        436: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        694: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        71: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        271: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        268: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        265: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        267: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        270: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        272: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        269: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        266: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        264: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        281: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        137: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        660: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        880: {
	            1: fa_c10,
	            2: fa_d10,
	            3: fa_e10,
	            4: fa_f10
	        },
	        879: {
	            1: fa_g10,
	            2: fa_h10,
	            3: fa_i10,
	            4: fa_j10
	        },
	        429: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        433: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        881: {
	            1: fa_k10,
	            2: fa_l10,
	            3: fa_m10,
	            4: fa_n10,
	            5: fa_o10,
	            6: fa_p10
	        },
	        273: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        274: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        435: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        704: {
	            1: fa_q10,
	            2: fa_r10,
	            3: fa_s10
	        },
	        432: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        428: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        434: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        439: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        440: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        441: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        438: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        623: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        180: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        146: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        659: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        749: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_r3
	        },
	        69: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        262: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        692: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        703: {
	            1: fa_h1,
	            2: fa_a2,
	            3: fa_i1
	        },
	        70: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        263: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        693: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        72: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        277: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        695: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        750: {
	            1: fa_x2,
	            2: fa_r1,
	            3: fa_u1,
	            4: fa_s1,
	            5: fa_v1,
	            6: fa_w1,
	            7: fa_j3,
	            8: fa_k3,
	            9: fa_l3,
	            10: fa_q3,
	            11: fa_t10,
	            12: fa_u10,
	            13: fa_u2,
	            14: fa_n1,
	            15: fa_o1,
	            16: fa_p1,
	            17: fa_q1,
	            18: fa_t1,
	            19: fa_z2,
	            20: fa_c3,
	            21: fa_g3,
	            22: fa_h3,
	            23: fa_v10,
	            24: fa_w10
	        },
	        181: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        147: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        276: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        275: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        735: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        736: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        737: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        738: {
	            1: fa_h1,
	            2: fa_a2,
	            3: fa_i1
	        },
	        739: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        740: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        356: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        357: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        354: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        355: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        937: {
	            1: fa_x10,
	            2: fa_y10,
	            3: fa_z10,
	            4: fa_a11,
	            5: fa_b11,
	            6: fa_c11,
	            7: fa_d11,
	            8: fa_e11,
	            9: fa_f11,
	            10: fa_g11
	        },
	        657: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        658: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        412: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    14: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    34: {
	        425: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        534: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        540: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        343: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        345: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        260: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        261: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        83: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        84: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        803: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_w8
	        },
	        868: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_w8
	        },
	        869: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_w8
	        },
	        870: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_w8
	        },
	        346: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        419: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        528: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        420: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        529: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        707: {
	            1: fa_d6,
	            2: fa_e6,
	            3: fa_x8
	        },
	        708: {
	            1: fa_d6,
	            2: fa_e6,
	            3: fa_x8
	        },
	        706: {
	            1: fa_y8,
	            2: fa_z8,
	            3: fa_a9
	        },
	        538: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        698: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        322: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        904: {
	            1: fa_l6,
	            2: fa_m6,
	            3: fa_n6,
	            4: fa_o6,
	            5: fa_p6,
	            6: fa_q6,
	            7: fa_r6,
	            8: fa_s6,
	            9: fa_t6
	        },
	        1: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        136: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        747: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_v2,
	            6: fa_w2,
	            7: fa_r9,
	            8: fa_x2,
	            9: fa_y2,
	            10: fa_p1,
	            11: fa_q1,
	            12: fa_z2,
	            13: fa_a3,
	            14: fa_s9,
	            15: fa_r1,
	            16: fa_s1,
	            17: fa_b3,
	            18: fa_t1,
	            19: fa_c3,
	            20: fa_u1,
	            21: fa_v1,
	            22: fa_w1,
	            23: fa_f3,
	            24: fa_i3,
	            25: fa_j3,
	            26: fa_k3,
	            27: fa_n3,
	            28: fa_o3,
	            29: fa_t9,
	            30: fa_u9,
	            31: fa_r3
	        },
	        871: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        255: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        705: {
	            1: fa_v9,
	            2: fa_w9,
	            3: fa_x9
	        },
	        323: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        324: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        702: {
	            1: fa_l9,
	            2: fa_a2,
	            3: fa_m9
	        },
	        278: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        282: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        911: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2,
	            4: fa_h2,
	            5: fa_i2,
	            6: fa_j2
	        },
	        353: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        674: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        2: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        5: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        7: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        939: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        9: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        12: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        417: {
	            1: fa_y9,
	            2: fa_q9
	        },
	        526: {
	            1: fa_y9,
	            2: fa_q9
	        },
	        325: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        160: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        163: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        165: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        166: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        168: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        171: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        148: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        149: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        150: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        151: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        152: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        153: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        154: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        155: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        156: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        157: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        158: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        159: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        731: {
	            1: fa_h1,
	            2: fa_a2,
	            3: fa_i1
	        },
	        765: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        766: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        415: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        524: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        418: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        527: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        743: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_r3
	        },
	        744: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_r3
	        },
	        710: {
	            1: fa_q2,
	            2: fa_r2,
	            3: fa_s2
	        },
	        321: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        326: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        327: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        724: {
	            1: fa_z9,
	            2: fa_a10,
	            3: fa_b10
	        },
	        661: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        664: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        666: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        667: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        669: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        672: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        426: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        535: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        537: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        541: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        539: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    19: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        698: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        615: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        886: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        887: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        911: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2,
	            4: fa_h2,
	            5: fa_i2,
	            6: fa_j2
	        },
	        884: {
	            1: fa_l4,
	            2: fa_z4,
	            3: fa_a5,
	            4: fa_p5,
	            5: fa_c5
	        },
	        885: {
	            1: fa_l4,
	            2: fa_z4,
	            3: fa_a5,
	            4: fa_p5,
	            5: fa_h11
	        },
	        882: {
	            1: fa_s4,
	            2: fa_d5,
	            3: fa_e5,
	            4: fa_q5,
	            5: fa_b2
	        },
	        883: {
	            1: fa_s4,
	            2: fa_d5,
	            3: fa_e5,
	            4: fa_q5,
	            5: fa_b2
	        },
	        723: {
	            1: fa_h1,
	            2: fa_a2,
	            3: fa_i1
	        },
	        673: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        674: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    30: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        698: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        279: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        610: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        674: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        675: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        350: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        415: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        524: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        743: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_r3
	        },
	        744: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_r3
	        },
	        745: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_r3
	        },
	        710: {
	            1: fa_q2,
	            2: fa_r2,
	            3: fa_s2
	        },
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        426: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        535: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        706: {
	            1: fa_y8,
	            2: fa_z8,
	            3: fa_a9
	        },
	        343: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        346: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        83: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        84: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        85: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        344: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        347: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        765: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        766: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        767: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        751: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_v2,
	            6: fa_w2,
	            7: fa_x2,
	            8: fa_y2,
	            9: fa_p1,
	            10: fa_q1,
	            11: fa_z2,
	            12: fa_a3,
	            13: fa_r1,
	            14: fa_s1,
	            15: fa_b3,
	            16: fa_t1,
	            17: fa_c3,
	            18: fa_d3,
	            19: fa_e3,
	            20: fa_u1,
	            21: fa_v1,
	            22: fa_w1,
	            23: fa_f3,
	            24: fa_g3,
	            25: fa_h3,
	            26: fa_i3,
	            27: fa_j3,
	            28: fa_k3,
	            29: fa_l3,
	            30: fa_m3,
	            31: fa_n3,
	            32: fa_o3,
	            33: fa_p3,
	            34: fa_q3,
	            35: fa_r3
	        },
	        911: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2,
	            4: fa_h2,
	            5: fa_i2,
	            6: fa_j2
	        },
	        889: {
	            1: fa_g6,
	            2: fa_m2,
	            3: fa_n2,
	            4: fa_o2,
	            5: fa_h6,
	            6: fa_i6,
	            7: fa_j6,
	            8: fa_k6
	        },
	        637: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        615: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        412: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        634: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        626: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        611: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        904: {
	            1: fa_l6,
	            2: fa_m6,
	            3: fa_n6,
	            4: fa_o6,
	            5: fa_p6,
	            6: fa_q6,
	            7: fa_r6,
	            8: fa_s6,
	            9: fa_t6
	        },
	        449: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        446: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        451: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        711: {
	            1: fa_i11,
	            2: fa_j11,
	            3: fa_k11
	        },
	        712: {
	            1: fa_l11,
	            2: fa_m11,
	            3: fa_n11
	        },
	        713: {
	            1: fa_o11,
	            2: fa_p11,
	            3: fa_q11
	        },
	        450: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        447: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        448: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        662: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        663: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        665: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        668: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        670: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        671: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        3: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        4: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        6: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        8: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        10: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        11: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        161: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        162: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        164: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        167: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        169: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        170: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        707: {
	            1: fa_d6,
	            2: fa_e6,
	            3: fa_f6
	        },
	        708: {
	            1: fa_d6,
	            2: fa_e6,
	            3: fa_f6
	        },
	        709: {
	            1: fa_d6,
	            2: fa_e6,
	            3: fa_f6
	        },
	        946: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        947: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    23: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    13: {
	        468: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        470: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        467: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        469: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        464: {
	            1: fa_z9,
	            2: fa_b10
	        },
	        466: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        465: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        463: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        289: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        288: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        292: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        461: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        283: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        295: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        293: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        284: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        285: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        316: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        286: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        287: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        290: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        291: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        462: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        294: {
	            1: fa_d1,
	            2: fa_e1
	        }
	    },
	    39: {
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        698: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        950: {
	            1: fa_x7,
	            2: fa_y7,
	            3: fa_z7,
	            4: fa_a8,
	            5: fa_b8,
	            6: fa_t7,
	            7: fa_u7,
	            8: fa_j8,
	            9: fa_k8,
	            10: fa_l8,
	            11: fa_m8,
	            12: fa_n8,
	            13: fa_w7
	        },
	        955: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        951: {
	            1: fa_r11,
	            2: fa_s11
	        },
	        952: {
	            1: fa_r11,
	            2: fa_s11
	        },
	        953: {
	            1: fa_r11,
	            2: fa_s11
	        },
	        954: {
	            1: fa_r11,
	            2: fa_s11
	        }
	    },
	    33: {
	        348: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    24: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    9: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        698: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        674: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    21: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    29: {
	        394: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        395: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        396: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        397: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        398: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        399: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        400: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        401: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        402: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        100: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        101: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        104: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        105: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        106: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        107: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        108: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        109: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        110: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        111: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        112: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        113: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        114: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        115: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        116: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        117: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        118: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        119: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        120: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        121: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        808: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        809: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        810: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        811: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        812: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        813: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        814: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        815: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        816: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        817: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        818: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        819: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        820: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        821: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        822: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        823: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        824: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        825: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        826: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        827: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        828: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        829: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        830: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        831: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        832: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        833: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        834: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        835: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        836: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        837: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        838: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        839: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        840: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        841: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        842: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        843: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        844: {
	            1: fa_t11,
	            2: fa_u11,
	            3: fa_v11,
	            4: fa_w11,
	            5: fa_x11,
	            6: fa_y11
	        },
	        366: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        367: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        368: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        369: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        370: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        371: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        372: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        373: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        374: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        375: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        376: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        377: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        378: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        379: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        380: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        381: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        382: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        383: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        384: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        385: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        386: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        387: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        388: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        389: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        390: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        391: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        392: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        393: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        481: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        482: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        483: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        484: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        485: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        486: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        487: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        488: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        489: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        490: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        491: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        492: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        493: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        494: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        495: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        496: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        497: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        498: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        499: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        500: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        501: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        502: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        503: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        504: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        505: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        506: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        507: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        508: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        509: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        510: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        511: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        566: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        567: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        568: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        569: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        570: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        571: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        572: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        573: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        574: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        575: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        576: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        577: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        578: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        579: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        580: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        581: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        582: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        583: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        584: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        585: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        586: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        587: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        588: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        589: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        590: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        591: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        592: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        593: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        594: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        595: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        596: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        597: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        598: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        599: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        600: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        601: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        602: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        83: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        84: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        85: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        86: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        87: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        88: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        89: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        90: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        91: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        92: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        93: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        94: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        95: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        96: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        97: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        98: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        99: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        254: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        24: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        25: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        26: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        27: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        28: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        29: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        30: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        31: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        32: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        33: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        34: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        35: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        36: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        37: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        38: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        39: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        40: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        41: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        42: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        43: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        44: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        45: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        46: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        47: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        48: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        49: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        50: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        51: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        52: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        53: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        54: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        55: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        56: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        57: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        199: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        200: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        201: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        202: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        203: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        204: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        205: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        206: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        207: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        208: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        209: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        210: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        211: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        212: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        213: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        214: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        215: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        216: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        217: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        218: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        219: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        220: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        221: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        222: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        223: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        224: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        225: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        226: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        227: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        228: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        229: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        230: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        231: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        475: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        476: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        477: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        478: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        479: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        480: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    15: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    2: {
	        73: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        318: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        24: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        25: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        26: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        27: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        199: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        200: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        201: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        352: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        102: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        141: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        142: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        143: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        144: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        185: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        186: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        187: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        188: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        566: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        567: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        568: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        569: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        570: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        571: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        572: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        366: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        367: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        368: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        369: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        370: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        371: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        372: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        122: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        123: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        124: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        125: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        126: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        127: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        128: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        129: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        130: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        131: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        132: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        133: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        134: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        135: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        872: {
	            1: fa_s3,
	            2: fa_u6,
	            3: fa_v6,
	            4: fa_w6,
	            5: fa_x6,
	            6: fa_z11
	        },
	        873: {
	            1: fa_s3,
	            2: fa_u6,
	            3: fa_v6,
	            4: fa_w6,
	            5: fa_x6,
	            6: fa_z11
	        },
	        874: {
	            1: fa_s3,
	            2: fa_u6,
	            3: fa_v6,
	            4: fa_w6,
	            5: fa_x6,
	            6: fa_z11
	        },
	        875: {
	            1: fa_s3,
	            2: fa_u6,
	            3: fa_v6,
	            4: fa_w6,
	            5: fa_x6,
	            6: fa_z11
	        },
	        876: {
	            1: fa_s3,
	            2: fa_u6,
	            3: fa_v6,
	            4: fa_w6,
	            5: fa_x6,
	            6: fa_z11
	        },
	        877: {
	            1: fa_s3,
	            2: fa_u6,
	            3: fa_v6,
	            4: fa_w6,
	            5: fa_x6,
	            6: fa_z11
	        },
	        878: {
	            1: fa_s3,
	            2: fa_u6,
	            3: fa_v6,
	            4: fa_w6,
	            5: fa_x6,
	            6: fa_z11
	        },
	        616: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        617: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        618: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        619: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        620: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        621: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        622: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        894: {
	            1: fa_a12,
	            2: fa_b12,
	            3: fa_c12,
	            4: fa_d12
	        },
	        895: {
	            1: fa_a12,
	            2: fa_b12,
	            3: fa_c12,
	            4: fa_d12
	        },
	        896: {
	            1: fa_a12,
	            2: fa_b12,
	            3: fa_c12,
	            4: fa_d12
	        },
	        897: {
	            1: fa_a12,
	            2: fa_b12,
	            3: fa_c12,
	            4: fa_d12
	        },
	        898: {
	            1: fa_a12,
	            2: fa_b12,
	            3: fa_c12,
	            4: fa_d12
	        },
	        899: {
	            1: fa_a12,
	            2: fa_b12,
	            3: fa_c12,
	            4: fa_d12
	        },
	        900: {
	            1: fa_a12,
	            2: fa_b12,
	            3: fa_c12,
	            4: fa_d12
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        83: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        84: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        85: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        86: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        87: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        88: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        89: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        257: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        307: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        752: {
	            1: fa_u1,
	            2: fa_v1,
	            3: fa_w1,
	            4: fa_t1,
	            5: fa_q1,
	            6: fa_o1
	        },
	        753: {
	            1: fa_i3,
	            2: fa_j3,
	            3: fa_k3,
	            4: fa_l3,
	            5: fa_g3,
	            6: fa_c3,
	            7: fa_z2,
	            8: fa_v2
	        }
	    },
	    6: {
	        553: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        339: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        547: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        141: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        142: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        185: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        186: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        83: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        84: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        85: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        86: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        87: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        807: {
	            1: fa_l6,
	            2: fa_n6,
	            3: fa_r6,
	            4: fa_t6
	        },
	        636: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        334: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        335: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        336: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        337: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        906: {
	            1: fa_g7,
	            2: fa_h7,
	            3: fa_i7,
	            4: fa_j7
	        },
	        907: {
	            1: fa_g7,
	            2: fa_h7,
	            3: fa_i7,
	            4: fa_j7
	        },
	        908: {
	            1: fa_g7,
	            2: fa_h7,
	            3: fa_i7,
	            4: fa_j7
	        },
	        909: {
	            1: fa_g7,
	            2: fa_h7,
	            3: fa_i7,
	            4: fa_j7
	        },
	        300: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        301: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        302: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        303: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        304: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        310: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        311: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        312: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        313: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        314: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        554: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        555: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        556: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        557: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        558: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        517: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        518: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        519: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        520: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        521: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        561: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        562: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        563: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        564: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        565: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        73: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        318: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        24: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        25: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        199: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        352: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        748: {
	            1: fa_n1,
	            2: fa_o1,
	            3: fa_p1,
	            4: fa_q1,
	            5: fa_r1,
	            6: fa_s1,
	            7: fa_t1,
	            8: fa_u1,
	            9: fa_v1,
	            10: fa_w1
	        },
	        102: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        903: {
	            1: fa_e12,
	            2: fa_f12,
	            3: fa_g12,
	            4: fa_h12,
	            5: fa_i12,
	            6: fa_j12,
	            7: fa_k12,
	            8: fa_l12
	        },
	        445: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        754: {
	            1: fa_r9,
	            2: fa_s9,
	            3: fa_e3,
	            4: fa_m12,
	            5: fa_e7,
	            6: fa_n12,
	            7: fa_t9,
	            8: fa_u9,
	            9: fa_o12,
	            10: fa_p12,
	            11: fa_q12,
	            12: fa_r12,
	            13: fa_s12,
	            14: fa_t12
	        },
	        755: {
	            1: fa_r9,
	            2: fa_s9,
	            3: fa_e3,
	            4: fa_m12,
	            5: fa_e7,
	            6: fa_n12,
	            7: fa_t9,
	            8: fa_u9,
	            9: fa_o12,
	            10: fa_p12,
	            11: fa_q12,
	            12: fa_r12,
	            13: fa_s12,
	            14: fa_t12
	        },
	        756: {
	            1: fa_r9,
	            2: fa_s9,
	            3: fa_e3,
	            4: fa_m12,
	            5: fa_e7,
	            6: fa_n12,
	            7: fa_t9,
	            8: fa_u9,
	            9: fa_o12,
	            10: fa_p12,
	            11: fa_q12,
	            12: fa_r12,
	            13: fa_s12,
	            14: fa_t12
	        },
	        757: {
	            1: fa_r9,
	            2: fa_s9,
	            3: fa_e3,
	            4: fa_m12,
	            5: fa_e7,
	            6: fa_n12,
	            7: fa_t9,
	            8: fa_u9,
	            9: fa_o12,
	            10: fa_p12,
	            11: fa_q12,
	            12: fa_r12,
	            13: fa_s12,
	            14: fa_t12
	        },
	        758: {
	            1: fa_r9,
	            2: fa_s9,
	            3: fa_e3,
	            4: fa_m12,
	            5: fa_e7,
	            6: fa_n12,
	            7: fa_t9,
	            8: fa_u9,
	            9: fa_o12,
	            10: fa_p12,
	            11: fa_q12,
	            12: fa_r12,
	            13: fa_s12,
	            14: fa_t12
	        },
	        452: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        453: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        454: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        566: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        567: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        568: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        569: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        570: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        366: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        367: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        368: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        369: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        370: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        522: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        627: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        628: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        629: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        630: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        631: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        632: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        190: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        191: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        192: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        193: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        194: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        759: {
	            1: fa_u12,
	            2: fa_v12,
	            3: fa_w12,
	            4: fa_x12,
	            5: fa_y12,
	            6: fa_s12,
	            7: fa_u10,
	            8: fa_z12,
	            9: fa_a13,
	            10: fa_b13,
	            11: fa_c13,
	            12: fa_d13,
	            13: fa_n12,
	            14: fa_w10
	        },
	        760: {
	            1: fa_u12,
	            2: fa_v12,
	            3: fa_w12,
	            4: fa_x12,
	            5: fa_y12,
	            6: fa_s12,
	            7: fa_u10,
	            8: fa_z12,
	            9: fa_a13,
	            10: fa_b13,
	            11: fa_c13,
	            12: fa_d13,
	            13: fa_n12,
	            14: fa_w10
	        },
	        761: {
	            1: fa_u12,
	            2: fa_v12,
	            3: fa_w12,
	            4: fa_x12,
	            5: fa_y12,
	            6: fa_s12,
	            7: fa_u10,
	            8: fa_z12,
	            9: fa_a13,
	            10: fa_b13,
	            11: fa_c13,
	            12: fa_d13,
	            13: fa_n12,
	            14: fa_w10
	        },
	        762: {
	            1: fa_u12,
	            2: fa_v12,
	            3: fa_w12,
	            4: fa_x12,
	            5: fa_y12,
	            6: fa_s12,
	            7: fa_u10,
	            8: fa_z12,
	            9: fa_a13,
	            10: fa_b13,
	            11: fa_c13,
	            12: fa_d13,
	            13: fa_n12,
	            14: fa_w10
	        },
	        763: {
	            1: fa_u12,
	            2: fa_v12,
	            3: fa_w12,
	            4: fa_x12,
	            5: fa_y12,
	            6: fa_s12,
	            7: fa_u10,
	            8: fa_z12,
	            9: fa_a13,
	            10: fa_b13,
	            11: fa_c13,
	            12: fa_d13,
	            13: fa_n12,
	            14: fa_w10
	        },
	        768: {
	            1: fa_j6,
	            2: fa_e13,
	            3: fa_f13,
	            4: fa_g13,
	            5: fa_h13,
	            6: fa_c2,
	            7: fa_i13
	        },
	        769: {
	            1: fa_j6,
	            2: fa_e13,
	            3: fa_f13,
	            4: fa_g13,
	            5: fa_h13,
	            6: fa_c2,
	            7: fa_i13
	        },
	        770: {
	            1: fa_j6,
	            2: fa_e13,
	            3: fa_f13,
	            4: fa_g13,
	            5: fa_h13,
	            6: fa_c2,
	            7: fa_i13
	        },
	        771: {
	            1: fa_j6,
	            2: fa_e13,
	            3: fa_f13,
	            4: fa_g13,
	            5: fa_h13,
	            6: fa_c2,
	            7: fa_i13
	        },
	        772: {
	            1: fa_j6,
	            2: fa_e13,
	            3: fa_f13,
	            4: fa_g13,
	            5: fa_h13,
	            6: fa_c2,
	            7: fa_i13
	        },
	        603: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        604: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        605: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        606: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        607: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        257: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        307: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        696: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        333: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        341: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        427: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        536: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        905: {
	            1: fa_g7,
	            2: fa_h7,
	            3: fa_i7,
	            4: fa_j7
	        },
	        320: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        514: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        516: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        305: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        315: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        523: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        299: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        309: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        697: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        298: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        308: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        515: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        549: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        548: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        550: {
	            1: fa_j13,
	            2: fa_i1
	        },
	        551: {
	            1: fa_h1,
	            2: fa_k13
	        },
	        455: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        456: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        457: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        458: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        459: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        460: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        512: {
	            1: fa_j13,
	            2: fa_i1
	        },
	        513: {
	            1: fa_h1,
	            2: fa_k13
	        },
	        901: {
	            1: fa_e12,
	            2: fa_f12,
	            3: fa_g12,
	            4: fa_h12,
	            5: fa_i12,
	            6: fa_j12,
	            7: fa_k12,
	            8: fa_l12
	        },
	        902: {
	            1: fa_e12,
	            2: fa_f12,
	            3: fa_g12,
	            4: fa_h12,
	            5: fa_i12,
	            6: fa_j12,
	            7: fa_k12,
	            8: fa_l12
	        },
	        340: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        328: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        329: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        342: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        330: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        331: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        722: {
	            1: fa_z9,
	            2: fa_a10,
	            3: fa_b10
	        },
	        560: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        543: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        544: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        545: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        546: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        332: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        559: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        296: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        297: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        717: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        718: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        719: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        720: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        721: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        552: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        76: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        77: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        78: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        79: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        80: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        647: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        741: {
	            1: fa_l13,
	            2: fa_u7,
	            3: fa_m13
	        },
	        82: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        338: {
	            1: fa_d1,
	            2: fa_e1
	        }
	    },
	    17: {
	        348: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    4: {
	        73: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        318: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        24: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        25: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        199: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        352: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        764: {
	            1: fa_o1,
	            2: fa_q1,
	            3: fa_t1,
	            4: fa_u1,
	            5: fa_v1,
	            6: fa_w1
	        },
	        102: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        141: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        142: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        185: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        186: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        366: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        367: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        368: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        369: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        370: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        566: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        567: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        568: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        569: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        570: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        923: {
	            1: fa_s3,
	            2: fa_u6,
	            3: fa_v6,
	            4: fa_w6,
	            5: fa_x6,
	            6: fa_y6,
	            7: fa_z6,
	            8: fa_a7
	        },
	        924: {
	            1: fa_s3,
	            2: fa_u6,
	            3: fa_v6,
	            4: fa_w6,
	            5: fa_x6,
	            6: fa_y6,
	            7: fa_z6,
	            8: fa_a7
	        },
	        925: {
	            1: fa_s3,
	            2: fa_u6,
	            3: fa_v6,
	            4: fa_w6,
	            5: fa_x6,
	            6: fa_y6,
	            7: fa_z6,
	            8: fa_a7
	        },
	        926: {
	            1: fa_s3,
	            2: fa_u6,
	            3: fa_v6,
	            4: fa_w6,
	            5: fa_x6,
	            6: fa_y6,
	            7: fa_z6,
	            8: fa_a7
	        },
	        927: {
	            1: fa_s3,
	            2: fa_u6,
	            3: fa_v6,
	            4: fa_w6,
	            5: fa_x6,
	            6: fa_y6,
	            7: fa_z6,
	            8: fa_a7
	        },
	        929: {
	            1: fa_s3,
	            2: fa_b7,
	            3: fa_c7,
	            4: fa_d7,
	            5: fa_a7
	        },
	        930: {
	            1: fa_s3,
	            2: fa_b7,
	            3: fa_c7,
	            4: fa_d7,
	            5: fa_a7
	        },
	        931: {
	            1: fa_s3,
	            2: fa_b7,
	            3: fa_c7,
	            4: fa_d7,
	            5: fa_a7
	        },
	        932: {
	            1: fa_s3,
	            2: fa_b7,
	            3: fa_c7,
	            4: fa_d7,
	            5: fa_a7
	        },
	        933: {
	            1: fa_s3,
	            2: fa_b7,
	            3: fa_c7,
	            4: fa_d7,
	            5: fa_a7
	        },
	        845: {
	            1: fa_t1,
	            2: fa_e7,
	            3: fa_f7,
	            4: fa_y1
	        },
	        846: {
	            1: fa_t1,
	            2: fa_e7,
	            3: fa_f7,
	            4: fa_y1
	        },
	        847: {
	            1: fa_t1,
	            2: fa_e7,
	            3: fa_f7,
	            4: fa_y1
	        },
	        848: {
	            1: fa_t1,
	            2: fa_e7,
	            3: fa_f7,
	            4: fa_y1
	        },
	        849: {
	            1: fa_t1,
	            2: fa_e7,
	            3: fa_f7,
	            4: fa_y1
	        },
	        918: {
	            1: fa_t1,
	            2: fa_e7,
	            3: fa_f7,
	            4: fa_x1
	        },
	        919: {
	            1: fa_t1,
	            2: fa_e7,
	            3: fa_f7,
	            4: fa_x1
	        },
	        920: {
	            1: fa_t1,
	            2: fa_e7,
	            3: fa_f7,
	            4: fa_x1
	        },
	        921: {
	            1: fa_t1,
	            2: fa_e7,
	            3: fa_f7,
	            4: fa_x1
	        },
	        922: {
	            1: fa_t1,
	            2: fa_e7,
	            3: fa_f7,
	            4: fa_x1
	        },
	        83: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        84: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        85: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        86: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        87: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        905: {
	            1: fa_g7,
	            2: fa_h7,
	            3: fa_i7,
	            4: fa_j7
	        },
	        906: {
	            1: fa_g7,
	            2: fa_h7,
	            3: fa_i7,
	            4: fa_j7
	        },
	        907: {
	            1: fa_g7,
	            2: fa_h7,
	            3: fa_i7,
	            4: fa_j7
	        },
	        908: {
	            1: fa_g7,
	            2: fa_h7,
	            3: fa_i7,
	            4: fa_j7
	        },
	        909: {
	            1: fa_g7,
	            2: fa_h7,
	            3: fa_i7,
	            4: fa_j7
	        },
	        807: {
	            1: fa_l6,
	            2: fa_n6,
	            3: fa_r6,
	            4: fa_t6
	        },
	        319: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        320: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        912: {
	            1: fa_k7,
	            2: fa_l7,
	            3: fa_m7,
	            4: fa_n7,
	            5: fa_o7,
	            6: fa_p7
	        },
	        913: {
	            1: fa_k7,
	            2: fa_l7,
	            3: fa_m7,
	            4: fa_n7,
	            5: fa_o7,
	            6: fa_p7
	        },
	        914: {
	            1: fa_k7,
	            2: fa_l7,
	            3: fa_m7,
	            4: fa_n7,
	            5: fa_o7,
	            6: fa_p7
	        },
	        915: {
	            1: fa_k7,
	            2: fa_l7,
	            3: fa_m7,
	            4: fa_n7,
	            5: fa_o7,
	            6: fa_p7
	        },
	        916: {
	            1: fa_k7,
	            2: fa_l7,
	            3: fa_m7,
	            4: fa_n7,
	            5: fa_o7,
	            6: fa_p7
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        257: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        307: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        362: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        363: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        364: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        365: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        17: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        18: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        19: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        20: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        176: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        177: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        178: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        179: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        358: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        359: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        360: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        361: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        13: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        14: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        15: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        16: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        172: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        173: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        174: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        175: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        281: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        137: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        616: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        617: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        618: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        619: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        620: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        891: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2,
	            4: fa_h2
	        },
	        26: {
	            1: fa_n13,
	            2: fa_o13
	        },
	        200: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        143: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        187: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        371: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        571: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        928: {
	            1: fa_s3,
	            2: fa_u6,
	            3: fa_v6,
	            4: fa_w6,
	            5: fa_x6,
	            6: fa_y6,
	            7: fa_z6,
	            8: fa_a7
	        },
	        934: {
	            1: fa_s3,
	            2: fa_b7,
	            3: fa_c7,
	            4: fa_d7,
	            5: fa_a7
	        },
	        88: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        910: {
	            1: fa_g7,
	            2: fa_h7,
	            3: fa_i7,
	            4: fa_j7
	        },
	        917: {
	            1: fa_k7,
	            2: fa_l7,
	            3: fa_p13,
	            4: fa_n7,
	            5: fa_o7,
	            6: fa_q13
	        },
	        936: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_h6
	        }
	    },
	    8: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        698: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        674: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        675: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        676: {
	            1: fa_x1,
	            2: fa_z1,
	            3: fa_y1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    27: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    28: {
	        403: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        615: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        935: {
	            1: fa_t9,
	            2: fa_u9,
	            3: fa_o12,
	            4: fa_p12,
	            5: fa_q12,
	            6: fa_r13,
	            7: fa_r9,
	            8: fa_s9,
	            9: fa_e3,
	            10: fa_m12,
	            11: fa_e7,
	            12: fa_s13
	        },
	        612: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        613: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    }
	};
	
	var periodConfig = {
	    2: {
	        208: 'Матч закончился',
	        207: 'Седьмая партия',
	        206: 'Шестая партия',
	        205: 'Пятая партия',
	        200: 'Матч еще не начался',
	        203: 'Третья партия',
	        202: 'Вторая партия',
	        201: 'Первая партия',
	        204: 'Четвертая партия'
	    },
	    3: {
	        304: 'Матч закончился',
	        303: 'Третий сет',
	        302: 'Второй сет',
	        301: 'Первый сет',
	        300: 'Матч еще не начался'
	    },
	    4: {
	        406: 'Матч закончился',
	        403: 'Третий сет',
	        402: 'Второй сет',
	        401: 'Первый сет',
	        400: 'Матч еще не начался',
	        407: 'Золотой сет',
	        405: 'Пятый сет',
	        404: 'Четвертый сет'
	    },
	    5: {
	        510: 'Десятый раунд',
	        509: 'Девятый раунд',
	        508: 'Восьмой раунд',
	        507: 'Седьмой раунд',
	        506: 'Шестой раунд',
	        505: 'Пятый раунд',
	        513: 'Матч закончился',
	        503: 'Третий раунд',
	        500: 'Матч еще не начался',
	        501: 'Первый раунд',
	        502: 'Второй раунд',
	        511: 'Одиннадцатый раунд',
	        512: 'Двенадцатый раунд',
	        504: 'Четвертый раунд'
	    },
	    6: {
	        600: 'Матч еще не начался',
	        601: 'Первый сет',
	        602: 'Второй сет',
	        603: 'Третий сет',
	        604: 'Четвертый сет',
	        605: 'Пятый сет',
	        606: 'Матч закончился'
	    },
	    7: {
	        701: 'Первый тайм',
	        700: 'Матч еще не начался',
	        703: 'Второй тайм',
	        704: 'Основное время закончилось',
	        705: 'Первое дополнительное время',
	        702: 'Перерыв',
	        707: 'Второе дополнительное время',
	        708: 'Закончилось второе дополнительное время',
	        709: 'Пенальти',
	        710: 'Матч закончился',
	        706: 'Закончилось первое дополнительное время'
	    },
	    8: {
	        808: 'Пауза',
	        807: 'Четвёртая четверть',
	        806: 'Пауза',
	        805: 'Третья четверть',
	        804: 'Перерыв',
	        809: 'Овертайм',
	        802: 'Пауза',
	        801: 'Первая четверть',
	        800: 'Матч еще не начался',
	        810: 'Матч закончился',
	        803: 'Вторая четверть'
	    },
	    9: {
	        903: 'Второй тайм',
	        902: 'Перерыв',
	        901: 'Первый тайм',
	        900: 'Матч еще не начался',
	        904: 'Матч закончился'
	    },
	    12: {
	        1203: 'Второй тайм',
	        1202: 'Перерыв',
	        1201: 'Первый тайм',
	        1200: 'Матч еще не начался',
	        1204: 'Матч закончился'
	    },
	    18: {
	        1808: 'Закончился овертайм',
	        1807: 'Овертайм',
	        1806: 'Основное время закончилось',
	        1805: 'Третий период',
	        1804: 'Второй перерыв',
	        1809: 'Пенальти',
	        1802: 'Первый перерыв',
	        1801: 'Первый период',
	        1800: 'Матч еще не начался',
	        1810: 'Матч закончился',
	        1803: 'Второй период'
	    },
	    19: {
	        1904: 'Основное время закончилось',
	        1903: 'Второй тайм',
	        1902: 'Перерыв',
	        1901: 'Первый тайм',
	        1900: 'Матч еще не начался',
	        1905: 'Матч закончился'
	    },
	    20: {
	        2016: 'Восьмой огневой рубеж',
	        2017: 'Матч закончился',
	        2000: 'Матч еще не начался',
	        2001: 'Первый круг',
	        2002: 'Первый огневой рубеж',
	        2003: 'Второй круг',
	        2004: 'Второй огневой рубеж',
	        2005: 'Третий круг',
	        2006: 'Третий огневой рубеж',
	        2007: 'Четвертый круг',
	        2008: 'Четвертый огневой рубеж',
	        2009: 'Пятый круг',
	        2010: 'Пятый огневой рубеж',
	        2011: 'Шестой круг',
	        2012: 'Шестой огневой рубеж',
	        2013: 'Седьмой круг',
	        2014: 'Седьмой огневой рубеж',
	        2015: 'Восьмой круг'
	    },
	    28: {
	        2801: 'Основное время',
	        2802: 'Матч закончился',
	        2800: 'Матч еще не начался'
	    },
	    29: {
	        2911: '6-ая партия',
	        2912: 'Перерыв',
	        2913: '7-ая партия',
	        2914: 'Перерыв',
	        2915: '8-ая партия',
	        2916: 'Перерыв',
	        2917: '9-ая партия',
	        2918: 'Перерыв',
	        2919: '10-ая партия',
	        2920: 'Перерыв',
	        2921: '11-ая партия',
	        2964: 'Перерыв',
	        2965: '33-ья партия',
	        2966: 'Перерыв',
	        2967: '34-ая партия',
	        2968: 'Перерыв',
	        2969: '35-ая партия',
	        2970: 'Перерыв',
	        2971: '36-ая партия',
	        2972: 'Перерыв',
	        2973: '37-ая партия',
	        2974: 'Матч закончился',
	        2943: '22-ая партия',
	        2944: 'Перерыв',
	        2945: '23-ья партия',
	        2946: 'Перерыв',
	        2947: '24-ая партия',
	        2948: 'Перерыв',
	        2949: '25-ая партия',
	        2950: 'Перерыв',
	        2951: '26-ая партия',
	        2952: 'Перерыв',
	        2953: '27-ая партия',
	        2954: 'Перерыв',
	        2955: '28-ая партия',
	        2956: 'Перерыв',
	        2957: '29-ая партия',
	        2958: 'Перерыв',
	        2959: '30-ая партия',
	        2960: 'Перерыв',
	        2961: '31-ая партия',
	        2962: 'Перерыв',
	        2963: '32-ая партия',
	        2922: 'Перерыв',
	        2923: '12-ая партия',
	        2924: 'Перерыв',
	        2925: '13-ая партия',
	        2926: 'Перерыв',
	        2927: '14-ая партия',
	        2928: 'Перерыв',
	        2929: '15-ая партия',
	        2930: 'Перерыв',
	        2931: '16-ая партия',
	        2932: 'Перерыв',
	        2933: '17-ая партия',
	        2934: 'Перерыв',
	        2935: '18-ая партия',
	        2936: 'Перерыв',
	        2937: '19-ая партия',
	        2938: 'Перерыв',
	        2939: '20-ая партия',
	        2940: 'Перерыв',
	        2941: '21-ая партия',
	        2942: 'Перерыв',
	        2900: 'Матч еще не начался',
	        2901: '1-ая партия',
	        2902: 'Перерыв',
	        2903: '2-ая партия',
	        2904: 'Перерыв',
	        2905: '3-ья партия',
	        2906: 'Перерыв',
	        2907: '4-ая партия',
	        2908: 'Перерыв',
	        2909: '5-ая партия',
	        2910: 'Перерыв'
	    },
	    30: {
	        3008: 'Закончилось дополнительное время',
	        3007: 'Овертайм',
	        3006: 'Основное время закончилось',
	        3005: 'Третий период',
	        3004: 'Второй перерыв',
	        3009: 'Буллиты',
	        3002: 'Первый перерыв',
	        3001: 'Первый период',
	        3000: 'Матч еще не начался',
	        3010: 'Матч закончился',
	        3003: 'Второй период'
	    },
	    31: {
	        3108: 'Пауза',
	        3107: 'Четвёртая четверть',
	        3106: 'Пауза',
	        3105: 'Третья четверть',
	        3104: 'Перерыв',
	        3109: 'Овертайм',
	        3102: 'Пауза',
	        3101: 'Первая четверть',
	        3100: 'Матч еще не начался',
	        3110: 'Матч закончился',
	        3103: 'Вторая четверть'
	    },
	    32: {
	        3203: 'Третий сет',
	        3202: 'Второй сет',
	        3201: 'Первый сет',
	        3200: 'Матч еще не начался',
	        3204: 'Матч закончился'
	    },
	    34: {
	        3400: 'Матч еще не начался',
	        3401: 'Первый тайм',
	        3402: 'Перерыв',
	        3403: 'Второй тайм',
	        3404: 'Основное время закончилось',
	        3410: 'Матч закончился',
	        3406: 'Закончилось первое дополнительное время',
	        3407: 'Второе дополнительное время',
	        3408: 'Закончилось второе дополнительное время',
	        3409: 'Пенальти',
	        3405: 'Первое дополнительное время'
	    },
	    35: {
	        3500: 'Матч еще не начался',
	        3501: 'Первый тайм',
	        3502: 'Перерыв',
	        3503: 'Второй тайм',
	        3504: 'Матч закончился'
	    },
	    36: {
	        3601: 'Первый период',
	        3602: 'Первый перерыв',
	        3603: 'Второй период',
	        3604: 'Второй перерыв',
	        3605: 'Третий период',
	        3600: 'Матч еще не начался',
	        3607: 'Овертайм',
	        3608: 'Закончилось дополнительное время',
	        3609: 'Буллиты',
	        3610: 'Матч закончился',
	        3606: 'Основное время закончилось'
	    },
	    37: {
	        3701: 'Матч закончился',
	        3700: 'Матч еще не начался'
	    },
	    38: {
	        3801: 'Матч закончился',
	        3800: 'Матч еще не начался'
	    },
	    39: {
	        3901: 'Матч закончился',
	        3900: 'Матч еще не начался',
	        3902: 'Первый раунд',
	        3903: 'Второй раунд',
	        3904: 'Третий раунд',
	        3905: 'Четвертый раунд',
	        3906: 'Пятый раунд'
	    },
	    40: {
	        4001: 'Матч закончился',
	        4000: 'Матч еще не начался'
	    },
	    41: {
	        4102: 'Первый перерыв',
	        4106: 'Матч закончился',
	        4105: 'Овертайм',
	        4104: 'Второй перерыв',
	        4103: 'Вторая половина',
	        4101: 'Первая половина',
	        4100: 'Матч еще не начался'
	    },
	    42: {
	        4202: 'Вторая карта',
	        4206: 'Матч закончился',
	        4205: 'Пятая карта',
	        4204: 'Четвертая карта',
	        4203: 'Третья карта',
	        4201: 'Первая карта',
	        4200: 'Матч еще не начался'
	    }
	};
	
	function getGroupName(sportId, groupType) {
	    if (groupConfig !== undefined && groupConfig[sportId] !== undefined) {
	        return groupConfig[sportId][groupType];
	    }
	
	    return undefined;
	}
	
	function getSlotName(sportId, match, slot) {
	    var func = void 0;
	
	    if (slotConfig !== undefined && slotConfig[sportId] !== undefined) {
	        func = slotConfig[sportId][slot.type];
	    }
	
	    if (func === undefined) {
	        return undefined;
	    }
	
	    return func(match, slot);
	}
	
	function getOutcomeName(sportId, outcome, match) {
	    var func = void 0;
	
	    if (baseOutcomeConfig !== undefined && baseOutcomeConfig[sportId] !== undefined && baseOutcomeConfig[sportId]) {
	        func = baseOutcomeConfig[sportId][outcome.type];
	    }
	
	    if (outcomeConfig !== undefined && outcomeConfig[sportId] !== undefined && outcomeConfig[sportId][outcome.type] !== undefined) {
	        func = outcomeConfig[sportId][outcome.type];
	    }
	
	    if (func === undefined) {
	        return undefined;
	    }
	
	    return func(match, outcome);
	}
	
	function getRateName(sportId, outcome, factorType, match) {
	    var func = void 0;
	
	    if (baseFactorNameConfig !== undefined && baseFactorNameConfig[sportId] !== undefined && baseFactorNameConfig[sportId][outcome.type] !== undefined) {
	        func = baseFactorNameConfig[sportId][outcome.type][factorType];
	    }
	
	    if (func === undefined) {
	        return undefined;
	    }
	
	    return func(match, outcome);
	}
	
	function getMatchInfoText(matchInfoType) {
	    switch (matchInfoType) {
	        case 1:
	            return "Матч не начался";
	        case 2:
	            return "Матч закончился";
	        case 3:
	            return "Перерыв";
	        case 4:
	            return "Основное время закончилось";
	        case 5:
	            return "Первое доп. время закончилось";
	        case 6:
	            return "Серия пенальти";
	    }
	
	    return "";
	}
	
	function getPeriodName(sportId, periodId) {
	    if (periodConfig !== undefined && periodConfig[sportId] !== undefined) {
	        return periodConfig[sportId][periodId];
	    }
	
	    return undefined;
	}
	
	function getFoulsText() {
	    return "Фолы";
	}
	
	function getTimeoutText() {
	    return "Таймаут";
	}

/***/ },
/* 1257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _parseFloat = __webpack_require__(510);
	
	var _parseFloat2 = _interopRequireDefault(_parseFloat);
	
	exports.getGroupName = getGroupName;
	exports.getSlotName = getSlotName;
	exports.getOutcomeName = getOutcomeName;
	exports.getRateName = getRateName;
	exports.getMatchInfoText = getMatchInfoText;
	exports.getPeriodName = getPeriodName;
	exports.getFoulsText = getFoulsText;
	exports.getTimeoutText = getTimeoutText;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function numeralFemaleEnding(condition) {
	    return condition + "-";
	}
	
	function numeralMaleEnding(condition) {
	    return condition + "-";
	}
	
	function numeralNeuterEnding(condition) {
	    return condition + "-";
	}
	
	function plural(count, parameters) {
	    var m10 = count % 10;
	    var m100 = count % 100;
	
	    if (m10 === 1 && m100 !== 11) {
	        return parameters[0];
	    }
	
	    if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) {
	        return parameters[1];
	    }
	
	    return parameters[2];
	}
	
	function signed(condition) {
	    if (condition === 0) {
	        return '0';
	    }
	
	    var num = (0, _parseFloat2.default)(condition.toFixed(2));
	
	    if (condition > 0) {
	        return '+' + num.toString();
	    }
	
	    return num.toString();
	}
	
	function europeanHandicapCondition(condition) {
	    if (condition < 0) {
	        return "0:" + Math.abs(condition);
	    } else {
	        return Math.abs(condition) + ":0";
	    }
	}
	
	var sl_b1 = function sl_b1(match, outcome) {
	    return 'Natija';
	};
	var sl_c1 = function sl_c1(match, outcome) {
	    return 'Fora';
	};
	var sl_d1 = function sl_d1(match, outcome) {
	    return 'Jami hisob';
	};
	var sl_e1 = function sl_e1(match, outcome) {
	    return "Kim birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var sl_f1 = function sl_f1(match, outcome) {
	    return "Kim " + numeralNeuterEnding(outcome.condition) + " ochkoni yutadi";
	};
	var sl_g1 = function sl_g1(match, outcome) {
	    return match.homeTeam + " aniq " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " bilan g&apos;alaba qozonadi";
	};
	var sl_h1 = function sl_h1(match, outcome) {
	    return match.awayTeam + " aniq " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " bilan g&apos;alaba qozonadi";
	};
	var sl_i1 = function sl_i1(match, outcome) {
	    return "Jami hisob: " + match.homeTeam;
	};
	var sl_j1 = function sl_j1(match, outcome) {
	    return "Jami hisob: " + match.awayTeam;
	};
	var sl_k1 = function sl_k1(match, outcome) {
	    return 'G&apos;alaba';
	};
	var sl_l1 = function sl_l1(match, outcome) {
	    return 'Aniq jami hisob';
	};
	var sl_m1 = function sl_m1(match, outcome) {
	    return match.homeTeam + " farq bilan g&apos;alaba";
	};
	var sl_n1 = function sl_n1(match, outcome) {
	    return match.awayTeam + " farq bilan g&apos;alaba";
	};
	var sl_o1 = function sl_o1(match, outcome) {
	    return 'Ochkolar farqi';
	};
	var sl_p1 = function sl_p1(match, outcome) {
	    return 'O&apos;yinda birinchi';
	};
	var sl_q1 = function sl_q1(match, outcome) {
	    return 'Nechta jamoa to&apos;p kiritadi?';
	};
	var sl_r1 = function sl_r1(match, outcome) {
	    return 'Aniq hisob';
	};
	var sl_s1 = function sl_s1(match, outcome) {
	    return "G&apos;alaba va jami hisobi " + outcome.condition;
	};
	var sl_t1 = function sl_t1(match, outcome) {
	    return "Kib birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var sl_u1 = function sl_u1(match, outcome) {
	    return 'Juft/toq';
	};
	var sl_v1 = function sl_v1(match, outcome) {
	    return match.homeTeam + " farq bilan g&apos;alaba qozonadi";
	};
	var sl_w1 = function sl_w1(match, outcome) {
	    return match.awayTeam + " farq bilan g&apos;alaba qozonadi";
	};
	var sl_x1 = function sl_x1(match, outcome) {
	    return match.homeTeam + " aniq hisob";
	};
	var sl_y1 = function sl_y1(match, outcome) {
	    return match.awayTeam + " aniq hisob";
	};
	var sl_z1 = function sl_z1(match, outcome) {
	    return 'Farq bilan g&apos;alaba';
	};
	var sl_a2 = function sl_a2(match, outcome) {
	    return "Kim birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['qotillik', 'qotillik', 'qotillik']) + " jamlaydi";
	};
	var sl_b2 = function sl_b2(match, outcome) {
	    return 'First Blood';
	};
	var sl_c2 = function sl_c2(match, outcome) {
	    return match.homeTeam + " to&apos;p kiritadimi?";
	};
	var sl_d2 = function sl_d2(match, outcome) {
	    return match.awayTeam + " to&apos;p kiritadimi?";
	};
	var sl_e2 = function sl_e2(match, outcome) {
	    return 'Nechta jamoa to&apos;p kiritadi';
	};
	var sl_f2 = function sl_f2(match, outcome) {
	    return match.homeTeam + " nechta to&apos;p kiritadi?";
	};
	var sl_g2 = function sl_g2(match, outcome) {
	    return match.awayTeam + " nechta to&apos;p kiritadi?";
	};
	var sl_h2 = function sl_h2(match, outcome) {
	    return 'Qo&apos;shib berilgan vaqt';
	};
	var sl_i2 = function sl_i2(match, outcome) {
	    return "Yevropacha fora" + europeanHandicapCondition(outcome.condition);
	};
	var sl_j2 = function sl_j2(match, outcome) {
	    return "Kim " + numeralMaleEnding(outcome.condition) + "-golni kiritadi?";
	};
	var sl_k2 = function sl_k2(match, outcome) {
	    return "Qolgan vaqtda (hozirgi hisob " + outcome.condition + ":" + outcome.conditionTwo + ")";
	};
	var sl_l2 = function sl_l2(match, outcome) {
	    return 'Ikkilangan natija';
	};
	var sl_m2 = function sl_m2(match, outcome) {
	    return 'Har bir bayroqchadan';
	};
	var sl_n2 = function sl_n2(match, outcome) {
	    return 'Simulyatsiya uchun';
	};
	var sl_o2 = function sl_o2(match, outcome) {
	    return 'Fudbolkani yechganlik uchun';
	};
	var sl_p2 = function sl_p2(match, outcome) {
	    return "Kiritilgan jami penaltilar: " + match.awayTeam;
	};
	var sl_q2 = function sl_q2(match, outcome) {
	    return "Kiritilgan jami penaltilar: " + match.homeTeam;
	};
	var sl_r2 = function sl_r2(match, outcome) {
	    return 'Kiritilgan jami penaltilar';
	};
	var sl_s2 = function sl_s2(match, outcome) {
	    return 'Kiritilmagan jami penaltilar';
	};
	var sl_t2 = function sl_t2(match, outcome) {
	    return 'Aniq Jami hisob';
	};
	var sl_u2 = function sl_u2(match, outcome) {
	    return 'Kim birinchi sharni savatga tushiradi?';
	};
	var sl_v2 = function sl_v2(match, outcome) {
	    return "Kim birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + "ni qo&apos;lga kiritadi";
	};
	var sl_w2 = function sl_w2(match, outcome) {
	    return 'Qaysi rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var sl_x2 = function sl_x2(match, outcome) {
	    return 'Результат';
	};
	var sl_y2 = function sl_y2(match, outcome) {
	    return 'Фора';
	};
	var sl_z2 = function sl_z2(match, outcome) {
	    return 'Тотал';
	};
	var sl_a3 = function sl_a3(match, outcome) {
	    return 'Кто первым(ой) забьет шар?';
	};
	var sl_b3 = function sl_b3(match, outcome) {
	    return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 " + outcome.condition + " " + plural(outcome.condition, ['очко', 'очков', 'очков']);
	};
	var sl_c3 = function sl_c3(match, outcome) {
	    return 'Какой цветной шар будет забит первым?';
	};
	var sl_d3 = function sl_d3(match, outcome) {
	    return 'Чет/Нечет';
	};
	var sl_e3 = function sl_e3(match, outcome) {
	    return "Kim " + numeralNeuterEnding(outcome.condition) + " ochkoni yutib oladi";
	};
	var sl_f3 = function sl_f3(match, outcome) {
	    return "Kim birinchi " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + "ni yutadi";
	};
	var sl_g3 = function sl_g3(match, outcome) {
	    return match.homeTeam + " " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " farqi bilan g&apos;alaba qozonadi";
	};
	var sl_h3 = function sl_h3(match, outcome) {
	    return match.awayTeam + " " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " farqi bilan g&apos;alaba qozonadi";
	};
	var sl_i3 = function sl_i3(match, outcome) {
	    return 'Juft/toq jami hisobi';
	};
	var sl_j3 = function sl_j3(match, outcome) {
	    return outcome.condition + "-geymda bo&apos;ladimi?";
	};
	var sl_k3 = function sl_k3(match, outcome) {
	    return 'Breyklar jami hisobi';
	};
	var sl_l3 = function sl_l3(match, outcome) {
	    return "Kim birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['geym', 'geym', 'geym']) + " ni qo&apos;lga kiritadi";
	};
	var sl_m3 = function sl_m3(match, outcome) {
	    return "G&apos;alaba va jami hisob " + outcome.condition;
	};
	var sl_n3 = function sl_n3(match, outcome) {
	    return 'Tie-brake bo&apos;ladimi?';
	};
	var sl_o3 = function sl_o3(match, outcome) {
	    return 'Tie-brakeda kim g&apos;alaba qozonadi?';
	};
	var sl_p3 = function sl_p3(match, outcome) {
	    return 'Tie-brakening aniq jami hisobi';
	};
	var sl_q3 = function sl_q3(match, outcome) {
	    return 'Tie-brakening aniq hisobi';
	};
	var sl_r3 = function sl_r3(match, outcome) {
	    return 'Tie-brakelar aniq hisobi';
	};
	var sl_s3 = function sl_s3(match, outcome) {
	    return "Tie-brake jami hisobi: " + match.homeTeam;
	};
	var sl_t3 = function sl_t3(match, outcome) {
	    return "Tie-brake jami hisobi: " + match.awayTeam;
	};
	var sl_u3 = function sl_u3(match, outcome) {
	    return "Kimdir " + outcome.condition + " " + plural(outcome.condition, ['geym', 'geym', 'geym']) + " ni ketma-ket yuta oladimi?";
	};
	var sl_v3 = function sl_v3(match, outcome) {
	    return match.homeTeam + " " + outcome.condition + " " + plural(outcome.condition, ['geym', 'geym', 'geym']) + " ni ketma-ket yuta oladimi?";
	};
	var sl_w3 = function sl_w3(match, outcome) {
	    return match.awayTeam + " " + outcome.condition + " " + plural(outcome.condition, ['geym', 'geym', 'geym']) + " ni ketma-ket yuta oladimi?";
	};
	var sl_x3 = function sl_x3(match, outcome) {
	    return 'Breyklar bo&apos;yicha natija';
	};
	var sl_y3 = function sl_y3(match, outcome) {
	    return 'Breyklar bo&apos;yicha fora';
	};
	var sl_z3 = function sl_z3(match, outcome) {
	    return "Kim birinchi " + numeralNeuterEnding(outcome.condition) + " ochko to&apos;playdi";
	};
	
	var bo_b1 = function bo_b1(match, outcome) {
	    return 'Fora';
	};
	var bo_c1 = function bo_c1(match, outcome) {
	    return 'O&apos;yinning jami hisobi';
	};
	var bo_d1 = function bo_d1(match, outcome) {
	    return "Jami hisob: " + match.homeTeam;
	};
	var bo_e1 = function bo_e1(match, outcome) {
	    return "Jami hisob: " + match.awayTeam;
	};
	var bo_f1 = function bo_f1(match, outcome) {
	    return 'O&apos;yinning jami hisobi juft/toq';
	};
	var bo_g1 = function bo_g1(match, outcome) {
	    return match.homeTeam + " - " + match.awayTeam;
	};
	var bo_h1 = function bo_h1(match, outcome) {
	    return outcome.teamOne + " - " + outcome.teamTwo;
	};
	var bo_i1 = function bo_i1(match, outcome) {
	    return "" + outcome.teamOne;
	};
	var bo_j1 = function bo_j1(match, outcome) {
	    return 'Birinchi setdagi Fora';
	};
	var bo_k1 = function bo_k1(match, outcome) {
	    return 'Ikkinchi setdagi Fora';
	};
	var bo_l1 = function bo_l1(match, outcome) {
	    return 'Uchinchi setdagi Fora';
	};
	var bo_m1 = function bo_m1(match, outcome) {
	    return 'Birinchi setdagi jami hisob';
	};
	var bo_n1 = function bo_n1(match, outcome) {
	    return 'Ikkinchi setdagi jami hisob';
	};
	var bo_o1 = function bo_o1(match, outcome) {
	    return 'Uchinchi setdagi jami hisob';
	};
	var bo_p1 = function bo_p1(match, outcome) {
	    return 'O&apos;yindagi jami setlar soni';
	};
	var bo_q1 = function bo_q1(match, outcome) {
	    return 'O&apos;yin hisobi';
	};
	var bo_r1 = function bo_r1(match, outcome) {
	    return 'Birinchi set natijasi';
	};
	var bo_s1 = function bo_s1(match, outcome) {
	    return 'Ikkinchi set natijasi';
	};
	var bo_t1 = function bo_t1(match, outcome) {
	    return 'Uchinchi set natijasi';
	};
	var bo_u1 = function bo_u1(match, outcome) {
	    return "Birinchi setda " + match.homeTeam + " ning jami hisobi";
	};
	var bo_v1 = function bo_v1(match, outcome) {
	    return "Ikkinchi setda " + match.homeTeam + " ning jami hisobi";
	};
	var bo_w1 = function bo_w1(match, outcome) {
	    return "Uchinchi setda " + match.homeTeam + " ning jami hisobi";
	};
	var bo_x1 = function bo_x1(match, outcome) {
	    return "Birinchi setda " + match.awayTeam + " ning jami hisobi";
	};
	var bo_y1 = function bo_y1(match, outcome) {
	    return "Ikkinchi setda " + match.awayTeam + " ning jami hisobi";
	};
	var bo_z1 = function bo_z1(match, outcome) {
	    return "Uchinchi setda " + match.awayTeam + " ning jami hisobi";
	};
	var bo_a2 = function bo_a2(match, outcome) {
	    return match.homeTeam + " birinchi setda " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " farq bilan g&apos;alaba qozonadi";
	};
	var bo_b2 = function bo_b2(match, outcome) {
	    return match.homeTeam + " ikkinchi setda " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " farq bilan g&apos;alaba qozonadi";
	};
	var bo_c2 = function bo_c2(match, outcome) {
	    return match.homeTeam + " uchinchi setda " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " farq bilan g&apos;alaba qozonadi";
	};
	var bo_d2 = function bo_d2(match, outcome) {
	    return match.awayTeam + " birinchi setda " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " farq bilan g&apos;alaba qozonadi";
	};
	var bo_e2 = function bo_e2(match, outcome) {
	    return match.awayTeam + " ikkinchi setda " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " farq bilan g&apos;alaba qozonadi";
	};
	var bo_f2 = function bo_f2(match, outcome) {
	    return match.awayTeam + " uchinchi setda " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " farq bilan g&apos;alaba qozonadi";
	};
	var bo_g2 = function bo_g2(match, outcome) {
	    return "1-setda kim birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_h2 = function bo_h2(match, outcome) {
	    return "2-setda kim birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_i2 = function bo_i2(match, outcome) {
	    return "3-setda kim birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_j2 = function bo_j2(match, outcome) {
	    return "Kim birinchi setda " + numeralNeuterEnding(outcome.condition) + " ochko yutadi";
	};
	var bo_k2 = function bo_k2(match, outcome) {
	    return "Kim ikkinchi setda " + numeralNeuterEnding(outcome.condition) + " ochko yutadi";
	};
	var bo_l2 = function bo_l2(match, outcome) {
	    return "Kim uchinchi setda " + numeralNeuterEnding(outcome.condition) + " ochko yutadi";
	};
	var bo_m2 = function bo_m2(match, outcome) {
	    return 'Birinchi setning 10 ochkogacha bo&apos;lgan minisetida g&apos;alaba';
	};
	var bo_n2 = function bo_n2(match, outcome) {
	    return 'Ikkinchi setning 10 ochkogacha bo&apos;lgan minisetida g&apos;alaba';
	};
	var bo_o2 = function bo_o2(match, outcome) {
	    return 'Uchinchi setning 10 ochkogacha bo&apos;lgan minisetida g&apos;alaba';
	};
	var bo_p2 = function bo_p2(match, outcome) {
	    return 'Birinchi setning 10 ochkogacha bo&apos;lgan minisetida fora';
	};
	var bo_q2 = function bo_q2(match, outcome) {
	    return 'Ikkinchi setning 10 ochkogacha bo&apos;lgan minisetida fora';
	};
	var bo_r2 = function bo_r2(match, outcome) {
	    return 'Uchinchi setning 10 ochkogacha bo&apos;lgan minisetida fora';
	};
	var bo_s2 = function bo_s2(match, outcome) {
	    return 'Birinchi setning 10 ochkogacha bo&apos;lgan minisetida jami hisob';
	};
	var bo_t2 = function bo_t2(match, outcome) {
	    return 'Ikkinchi setning 10 ochkogacha bo&apos;lgan minisetida jami hisob';
	};
	var bo_u2 = function bo_u2(match, outcome) {
	    return 'Uchinchi setning 10 ochkogacha bo&apos;lgan minisetida jami hisob';
	};
	var bo_v2 = function bo_v2(match, outcome) {
	    return 'Birinchi setning 15 ochkogacha bo&apos;lgan minisetida g&apos;alaba';
	};
	var bo_w2 = function bo_w2(match, outcome) {
	    return 'Ikkinchi setning 15 ochkogacha bo&apos;lgan minisetida g&apos;alaba';
	};
	var bo_x2 = function bo_x2(match, outcome) {
	    return 'Uchinchi setning 15 ochkogacha bo&apos;lgan minisetida g&apos;alaba';
	};
	var bo_y2 = function bo_y2(match, outcome) {
	    return 'Birinchi setning 15 ochkogacha bo&apos;lgan minisetida fora';
	};
	var bo_z2 = function bo_z2(match, outcome) {
	    return 'Ikkinchi setning 15 ochkogacha bo&apos;lgan minisetida fora';
	};
	var bo_a3 = function bo_a3(match, outcome) {
	    return 'Uchinchi setning 15 ochkogacha bo&apos;lgan minisetida fora';
	};
	var bo_b3 = function bo_b3(match, outcome) {
	    return 'Birinchi setning 15 ochkogacha bo&apos;lgan minisetida jami hisob';
	};
	var bo_c3 = function bo_c3(match, outcome) {
	    return 'Ikkinchi setning 15 ochkogacha bo&apos;lgan minisetida jami hisob';
	};
	var bo_d3 = function bo_d3(match, outcome) {
	    return 'Uchinchi setning 15 ochkogacha bo&apos;lgan minisetida jami hisob';
	};
	var bo_e3 = function bo_e3(match, outcome) {
	    return match.homeTeam + " ning birinchi bo&apos;limdagi jami hisobi";
	};
	var bo_f3 = function bo_f3(match, outcome) {
	    return 'Birinchi bo&apos;limda fora';
	};
	var bo_g3 = function bo_g3(match, outcome) {
	    return 'Birinchi bo&apos;lim natijasi';
	};
	var bo_h3 = function bo_h3(match, outcome) {
	    return match.awayTeam + " ning birinchi bo&apos;limdagi jami hisobi";
	};
	var bo_i3 = function bo_i3(match, outcome) {
	    return "Kim " + numeralMaleEnding(outcome.condition) + " chi golni kiritadi?";
	};
	var bo_j3 = function bo_j3(match, outcome) {
	    return 'Ikkilangan natija';
	};
	var bo_k3 = function bo_k3(match, outcome) {
	    return 'Birinchi bo&apos;lim jami hisobi';
	};
	var bo_l3 = function bo_l3(match, outcome) {
	    return "G&apos;alaba va o&apos;yinning jami hisobi " + outcome.condition;
	};
	var bo_m3 = function bo_m3(match, outcome) {
	    return match.homeTeam + " jamoasi " + outcome.condition + " " + plural(outcome.condition, ['gol', 'gol', 'gol']) + " farqi bilan g&apos;alaba qozonadi";
	};
	var bo_n3 = function bo_n3(match, outcome) {
	    return match.awayTeam + " jamoasi " + outcome.condition + " " + plural(outcome.condition, ['gol', 'gol', 'gol']) + " farqi bilan g&apos;alaba qozonadi";
	};
	var bo_o3 = function bo_o3(match, outcome) {
	    return 'O&apos;yinning aniq jami hisobi';
	};
	var bo_p3 = function bo_p3(match, outcome) {
	    return 'Nechta jamoa to&apos;p kiritadi';
	};
	var bo_q3 = function bo_q3(match, outcome) {
	    return 'Aniq hisob';
	};
	var bo_r3 = function bo_r3(match, outcome) {
	    return 'Osiyocha fora';
	};
	var bo_s3 = function bo_s3(match, outcome) {
	    return 'Fora birinchi chorakda';
	};
	var bo_t3 = function bo_t3(match, outcome) {
	    return 'Fora ikkinchi chorakda';
	};
	var bo_u3 = function bo_u3(match, outcome) {
	    return 'Fora uchinchi chorakda';
	};
	var bo_v3 = function bo_v3(match, outcome) {
	    return 'Fora to&apos;rtinchi chorakda';
	};
	var bo_w3 = function bo_w3(match, outcome) {
	    return 'Birinchi chorakning jami hisobi';
	};
	var bo_x3 = function bo_x3(match, outcome) {
	    return 'Ikkinchi chorakning jami hisobi';
	};
	var bo_y3 = function bo_y3(match, outcome) {
	    return 'Uchinchi chorakning jami hisobi';
	};
	var bo_z3 = function bo_z3(match, outcome) {
	    return 'To&apos;rtinchi chorakning jami hisobi';
	};
	var bo_a4 = function bo_a4(match, outcome) {
	    return 'Birinchi chorak natijasi';
	};
	var bo_b4 = function bo_b4(match, outcome) {
	    return 'Ikkinchi chorak natijasi';
	};
	var bo_c4 = function bo_c4(match, outcome) {
	    return 'Uchinchi chorak natijasi';
	};
	var bo_d4 = function bo_d4(match, outcome) {
	    return 'To&apos;rtinchi chorak natijasi';
	};
	var bo_e4 = function bo_e4(match, outcome) {
	    return match.homeTeam + " ning birinchi chorakdagi jami hisobi";
	};
	var bo_f4 = function bo_f4(match, outcome) {
	    return match.homeTeam + " ning ikkinchi chorakdagi jami hisobi";
	};
	var bo_g4 = function bo_g4(match, outcome) {
	    return match.homeTeam + " ning uchinchi chorakdagi jami hisobi";
	};
	var bo_h4 = function bo_h4(match, outcome) {
	    return match.homeTeam + " ning to&apos;rtinchi chorakdagi jami hisobi";
	};
	var bo_i4 = function bo_i4(match, outcome) {
	    return match.awayTeam + " ning birinchi chorakdagi jami hisobi";
	};
	var bo_j4 = function bo_j4(match, outcome) {
	    return match.awayTeam + " ning ikkinchi chorakdagi jami hisobi";
	};
	var bo_k4 = function bo_k4(match, outcome) {
	    return match.awayTeam + " ning uchinchi chorakdagi jami hisobi";
	};
	var bo_l4 = function bo_l4(match, outcome) {
	    return match.awayTeam + " ning to&apos;rtinchi chorakdagi jami hisobi";
	};
	var bo_m4 = function bo_m4(match, outcome) {
	    return 'O&apos;yin birinchi yarimining jami hisobi';
	};
	var bo_n4 = function bo_n4(match, outcome) {
	    return 'O&apos;yin ikkinchi yarimining natijasi';
	};
	var bo_o4 = function bo_o4(match, outcome) {
	    return 'O&apos;yin ikkinchi yarimining jami hisobi';
	};
	var bo_p4 = function bo_p4(match, outcome) {
	    return 'O&apos;yin birinchi yarimida fora bilan g&apos;alaba qozonadi';
	};
	var bo_q4 = function bo_q4(match, outcome) {
	    return 'O&apos;yin ikkinchi yarimida fora bilan g&apos;alaba qozonadi';
	};
	var bo_r4 = function bo_r4(match, outcome) {
	    return 'O&apos;yin birinchi yarimining natijasi';
	};
	var bo_s4 = function bo_s4(match, outcome) {
	    return "O&apos;yin birinchi yarimida " + match.homeTeam + " ning jami hisobi";
	};
	var bo_t4 = function bo_t4(match, outcome) {
	    return "O&apos;yin ikkinchi yarimida " + match.homeTeam + " ning jami hisobi";
	};
	var bo_u4 = function bo_u4(match, outcome) {
	    return "O&apos;yin birinchi yarimida " + match.awayTeam + " ning jami hisobi";
	};
	var bo_v4 = function bo_v4(match, outcome) {
	    return "O&apos;yin ikkinchi yarimida " + match.awayTeam + " ning jami hisobi";
	};
	var bo_w4 = function bo_w4(match, outcome) {
	    return "1-chorakda kim birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_x4 = function bo_x4(match, outcome) {
	    return "2-chorakda kim birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_y4 = function bo_y4(match, outcome) {
	    return "3-chorakda kim birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_z4 = function bo_z4(match, outcome) {
	    return "4-chorakda kim birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_a5 = function bo_a5(match, outcome) {
	    return 'O&apos;yindagi aniq jami hisob';
	};
	var bo_b5 = function bo_b5(match, outcome) {
	    return 'Birinchi chorakdagi aniq jami hisob';
	};
	var bo_c5 = function bo_c5(match, outcome) {
	    return 'Ikkinchi chorakdagi aniq jami hisob';
	};
	var bo_d5 = function bo_d5(match, outcome) {
	    return 'Uchinchi chorakdagi aniq jami hisob';
	};
	var bo_e5 = function bo_e5(match, outcome) {
	    return 'To&apos;rtinchi chorakdagi aniq jami hisob';
	};
	var bo_f5 = function bo_f5(match, outcome) {
	    return match.homeTeam + " ochkolar farqi bilan g&apos;alaba qozonadi";
	};
	var bo_g5 = function bo_g5(match, outcome) {
	    return match.awayTeam + " ochkolar farqi bilan g&apos;alaba qozonadi";
	};
	var bo_h5 = function bo_h5(match, outcome) {
	    return 'O&apos;tish';
	};
	var bo_i5 = function bo_i5(match, outcome) {
	    return match.homeTeam + " barcha choraklarda g&apos;alaba qozonadi";
	};
	var bo_j5 = function bo_j5(match, outcome) {
	    return match.awayTeam + " barcha choraklarda g&apos;alaba qozonadi";
	};
	var bo_k5 = function bo_k5(match, outcome) {
	    return match.homeTeam + " o&apos;yinning ikkala yarmida ham g&apos;alaba qozonadi";
	};
	var bo_l5 = function bo_l5(match, outcome) {
	    return match.awayTeam + " o&apos;yinning ikkala yarmida ham g&apos;alaba qozonadi";
	};
	var bo_m5 = function bo_m5(match, outcome) {
	    return 'Eng sermahsul o&apos;yinning yarmi';
	};
	var bo_n5 = function bo_n5(match, outcome) {
	    return 'Eng sermahsul o&apos;yin choragi';
	};
	var bo_o5 = function bo_o5(match, outcome) {
	    return 'Eng sermahsul chorakning jami hisobi';
	};
	var bo_p5 = function bo_p5(match, outcome) {
	    return 'Eng sermahsul bo&apos;lmagan chorakning jami hisobi';
	};
	var bo_q5 = function bo_q5(match, outcome) {
	    return match.homeTeam + " birinchi chorakda va o&apos;yinda g&apos;alaba qozonadi";
	};
	var bo_r5 = function bo_r5(match, outcome) {
	    return match.awayTeam + " birinchi chorakda va o&apos;yinda g&apos;alaba qozonadi";
	};
	var bo_s5 = function bo_s5(match, outcome) {
	    return match.homeTeam + " o&apos;yinning birinchi yarmida va o&apos;yinda g&apos;alaba qozonadi";
	};
	var bo_t5 = function bo_t5(match, outcome) {
	    return match.awayTeam + " o&apos;yinning birinchi yarmida va o&apos;yinda g&apos;alaba qozonadi";
	};
	var bo_u5 = function bo_u5(match, outcome) {
	    return 'Overtime bo&apos;ladimi';
	};
	var bo_v5 = function bo_v5(match, outcome) {
	    return 'O&apos;yinda ochko farqi bilan g&apos;alaba';
	};
	var bo_w5 = function bo_w5(match, outcome) {
	    return 'Birinchi chorakda ochko farqi bilan g&apos;alaba';
	};
	var bo_x5 = function bo_x5(match, outcome) {
	    return 'Ikkinchi chorakda ochko farqi bilan g&apos;alaba';
	};
	var bo_y5 = function bo_y5(match, outcome) {
	    return 'Uchinchi chorakda ochko farqi bilan g&apos;alaba';
	};
	var bo_z5 = function bo_z5(match, outcome) {
	    return 'To&apos;rtinchi chorakda ochko farqi bilan g&apos;alaba';
	};
	var bo_a6 = function bo_a6(match, outcome) {
	    return "Jami hisob: " + outcome.playerName + " (" + match.homeTeam + ")";
	};
	var bo_b6 = function bo_b6(match, outcome) {
	    return "Jami hisob: " + outcome.playerName + " (" + match.awayTeam + ")";
	};
	var bo_c6 = function bo_c6(match, outcome) {
	    return 'Jami hisob: 3 ochkolik to&apos;p otishlar';
	};
	var bo_d6 = function bo_d6(match, outcome) {
	    return 'Jami hisob: 2 ochkolik to&apos;p otishlar';
	};
	var bo_e6 = function bo_e6(match, outcome) {
	    return "Jami hisob: " + match.homeTeam + " ning 3 ochkolik to&apos;p otishlari";
	};
	var bo_f6 = function bo_f6(match, outcome) {
	    return "Jami hisob: " + match.awayTeam + " ning 3 ochkolik to&apos;p otishlari";
	};
	var bo_g6 = function bo_g6(match, outcome) {
	    return "Jami hisob: " + match.homeTeam + " ning 2 ochkolik to&apos;p otishlari";
	};
	var bo_h6 = function bo_h6(match, outcome) {
	    return "Jami hisob: " + match.awayTeam + " ning 2 ochkolik to&apos;p otishlari";
	};
	var bo_i6 = function bo_i6(match, outcome) {
	    return 'Fora 3 ochkolik to&apos;p otishlari';
	};
	var bo_j6 = function bo_j6(match, outcome) {
	    return 'Fora 2 ochkolik to&apos;p otishlari';
	};
	var bo_k6 = function bo_k6(match, outcome) {
	    return '3 ochkolik to&apos;p otishlari bo&apos;yicha natija';
	};
	var bo_l6 = function bo_l6(match, outcome) {
	    return '2 ochkolik to&apos;p otishlari bo&apos;yicha natija';
	};
	var bo_m6 = function bo_m6(match, outcome) {
	    return 'Eng sermahsul bo&apos;lmagan chorak';
	};
	var bo_n6 = function bo_n6(match, outcome) {
	    return 'O&apos;yindagi jami uzatmalar soni';
	};
	var bo_o6 = function bo_o6(match, outcome) {
	    return match.homeTeam + " o&apos;yindagi jami uzatmalar soni";
	};
	var bo_p6 = function bo_p6(match, outcome) {
	    return match.awayTeam + " o&apos;yindagi jami uzatmalar soni";
	};
	var bo_q6 = function bo_q6(match, outcome) {
	    return 'O&apos;yindagi uzatmalar sonida fora';
	};
	var bo_r6 = function bo_r6(match, outcome) {
	    return 'O&apos;yindagi uzatmalar soni bo&apos;yicha g&apos;alaba';
	};
	var bo_s6 = function bo_s6(match, outcome) {
	    return 'O&apos;yindagi birinchi 2 ochkolik to&apos;p otish';
	};
	var bo_t6 = function bo_t6(match, outcome) {
	    return 'O&apos;yindagi birinchi 3 ochkolik to&apos;p otish';
	};
	var bo_u6 = function bo_u6(match, outcome) {
	    return 'O&apos;yindagi birinchi jarimadan to&apos;p otilishi';
	};
	var bo_v6 = function bo_v6(match, outcome) {
	    return 'Qaysi biri oldin bo&apos;ladi';
	};
	var bo_w6 = function bo_w6(match, outcome) {
	    return 'Choraklardagi eng ko&apos;p ochko';
	};
	var bo_x6 = function bo_x6(match, outcome) {
	    return "O&apos;yinda kim birinchi " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " yig&apos;adi";
	};
	var bo_y6 = function bo_y6(match, outcome) {
	    return 'O&apos;yindagi jami triple-double soni';
	};
	var bo_z6 = function bo_z6(match, outcome) {
	    return 'O&apos;yindagi jami double-double soni';
	};
	var bo_a7 = function bo_a7(match, outcome) {
	    return "Birinchi chorakda kim birinchi " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_b7 = function bo_b7(match, outcome) {
	    return "Ikkinchi chorakda kim birinchi " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_c7 = function bo_c7(match, outcome) {
	    return "Uchinchi chorakda kim birinchi " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_d7 = function bo_d7(match, outcome) {
	    return "To&apos;rtinchi chorakda kim birinchi " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_e7 = function bo_e7(match, outcome) {
	    return 'O&apos;yindagi ochkolar farqi';
	};
	var bo_f7 = function bo_f7(match, outcome) {
	    return 'Birinchi chorakdagi ochkolar farqi';
	};
	var bo_g7 = function bo_g7(match, outcome) {
	    return 'Ikkinchi chorakdagi ochkolar farqi';
	};
	var bo_h7 = function bo_h7(match, outcome) {
	    return 'Uchinchi chorakdagi ochkolar farqi';
	};
	var bo_i7 = function bo_i7(match, outcome) {
	    return 'To&apos;rtinchi chorakdagi ochkolar farqi';
	};
	var bo_j7 = function bo_j7(match, outcome) {
	    return 'O&apos;yinning birinchi yarimida fora';
	};
	var bo_k7 = function bo_k7(match, outcome) {
	    return 'O&apos;yinning ikkinchi yarimida fora';
	};
	var bo_l7 = function bo_l7(match, outcome) {
	    return 'O&apos;yinning birinchi yarimi natijasi';
	};
	var bo_m7 = function bo_m7(match, outcome) {
	    return 'O&apos;yinning ikkinchi yarimi natijasi';
	};
	var bo_n7 = function bo_n7(match, outcome) {
	    return 'O&apos;yinning birinchi yarimi jami hisobi';
	};
	var bo_o7 = function bo_o7(match, outcome) {
	    return 'O&apos;yinning ikkinchi yarimi jami hisobi';
	};
	var bo_p7 = function bo_p7(match, outcome) {
	    return 'O&apos;yinning birinchi yarimi aniq natijasi';
	};
	var bo_q7 = function bo_q7(match, outcome) {
	    return 'O&apos;yinning ikkinchi yarimi aniq natijasi';
	};
	var bo_r7 = function bo_r7(match, outcome) {
	    return 'O&apos;yinning birinchi yarimida ochko farqi bilan g&apos;alaba';
	};
	var bo_s7 = function bo_s7(match, outcome) {
	    return 'O&apos;yinning ikkinchi yarimida ochko farqi bilan g&apos;alaba';
	};
	var bo_t7 = function bo_t7(match, outcome) {
	    return "O&apos;yinning birinchi yarimida kim birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_u7 = function bo_u7(match, outcome) {
	    return "O&apos;yinning ikkinchi yarimida kim birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_v7 = function bo_v7(match, outcome) {
	    return "O&apos;yinda kim birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_w7 = function bo_w7(match, outcome) {
	    return 'O&apos;yinning eng sermahsul yarmi';
	};
	var bo_x7 = function bo_x7(match, outcome) {
	    return 'O&apos;yinning eng sermahsul yarmi jami hisobi';
	};
	var bo_y7 = function bo_y7(match, outcome) {
	    return 'O&apos;yinning eng sermahsul bo&apos;lmagan yarmi jami hisobi';
	};
	var bo_z7 = function bo_z7(match, outcome) {
	    return match.homeTeam + " o&apos;yinning birinchi yarmida ham g&apos;alaba qozonadi";
	};
	var bo_a8 = function bo_a8(match, outcome) {
	    return match.awayTeam + " o&apos;yinning birinchi yarmida ham g&apos;alaba qozonadi";
	};
	var bo_b8 = function bo_b8(match, outcome) {
	    return match.homeTeam + " ning o&apos;yin birinchi yarmidagi jami hisobi";
	};
	var bo_c8 = function bo_c8(match, outcome) {
	    return match.homeTeam + " ning o&apos;yin ikkinchi yarmidagi jami hisobi";
	};
	var bo_d8 = function bo_d8(match, outcome) {
	    return match.awayTeam + " ning o&apos;yin birinchi yarmidagi jami hisobi";
	};
	var bo_e8 = function bo_e8(match, outcome) {
	    return match.awayTeam + " ning o&apos;yin ikkinchi yarmidagi jami hisobi";
	};
	var bo_f8 = function bo_f8(match, outcome) {
	    return "O&apos;yinning birinchi yarmida kim birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_g8 = function bo_g8(match, outcome) {
	    return "O&apos;yinning ikkinchi yarmida kim birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_h8 = function bo_h8(match, outcome) {
	    return 'Birinchi davr jami hisobi';
	};
	var bo_i8 = function bo_i8(match, outcome) {
	    return 'Ikkinchi davr jami hisobi';
	};
	var bo_j8 = function bo_j8(match, outcome) {
	    return 'Uchinchi davr jami hisobi';
	};
	var bo_k8 = function bo_k8(match, outcome) {
	    return 'Birinchi davr natijasi';
	};
	var bo_l8 = function bo_l8(match, outcome) {
	    return 'Ikkinchi davr natijasi';
	};
	var bo_m8 = function bo_m8(match, outcome) {
	    return 'Uchinchi davr natijasi';
	};
	var bo_n8 = function bo_n8(match, outcome) {
	    return 'Penaltini hisobga olgandagi g&apos;alaba';
	};
	var bo_o8 = function bo_o8(match, outcome) {
	    return 'Farq bilan g&apos;alaba 1';
	};
	var bo_p8 = function bo_p8(match, outcome) {
	    return 'Farq bilan g&apos;alaba 2';
	};
	var bo_q8 = function bo_q8(match, outcome) {
	    return '1-davrda nechta jamoa gol uradi?';
	};
	var bo_r8 = function bo_r8(match, outcome) {
	    return '2-davrda nechta jamoa gol uradi?';
	};
	var bo_s8 = function bo_s8(match, outcome) {
	    return '3-davrda nechta jamoa gol uradi?';
	};
	var bo_t8 = function bo_t8(match, outcome) {
	    return 'Davr-o&apos;yin';
	};
	var bo_u8 = function bo_u8(match, outcome) {
	    return 'Overtime jami hisobi';
	};
	var bo_v8 = function bo_v8(match, outcome) {
	    return 'Overtime natijasi';
	};
	var bo_w8 = function bo_w8(match, outcome) {
	    return 'Overtime da fora';
	};
	var bo_x8 = function bo_x8(match, outcome) {
	    return 'Birinchi davrda fora';
	};
	var bo_y8 = function bo_y8(match, outcome) {
	    return 'Ikkinchi davrda fora';
	};
	var bo_z8 = function bo_z8(match, outcome) {
	    return 'Uchinchi davrda fora';
	};
	var bo_a9 = function bo_a9(match, outcome) {
	    return 'Birinchi davr aniq hisobi';
	};
	var bo_b9 = function bo_b9(match, outcome) {
	    return 'Ikkinchi davr aniq hisobi';
	};
	var bo_c9 = function bo_c9(match, outcome) {
	    return 'Uchinchi davr aniq hisobi';
	};
	var bo_d9 = function bo_d9(match, outcome) {
	    return "Kim " + numeralMaleEnding(outcome.condition) + "-golni kiritadi?";
	};
	var bo_e9 = function bo_e9(match, outcome) {
	    return 'Birinchi setda Fora';
	};
	var bo_f9 = function bo_f9(match, outcome) {
	    return 'Ikkinchi setda Fora';
	};
	var bo_g9 = function bo_g9(match, outcome) {
	    return 'Uchinchi setda Fora';
	};
	var bo_h9 = function bo_h9(match, outcome) {
	    return 'Birinchi set jami hisobi';
	};
	var bo_i9 = function bo_i9(match, outcome) {
	    return 'Ikkinchi set jami hisobi';
	};
	var bo_j9 = function bo_j9(match, outcome) {
	    return 'Uchinchi set jami hisobi';
	};
	var bo_k9 = function bo_k9(match, outcome) {
	    return 'O&apos;yindagi jami setlar hisobi';
	};
	var bo_l9 = function bo_l9(match, outcome) {
	    return 'O&apos;yin jami hisobining juft/tuq';
	};
	var bo_m9 = function bo_m9(match, outcome) {
	    return match.homeTeam + " ning birinchi setdagi jami hisobi";
	};
	var bo_n9 = function bo_n9(match, outcome) {
	    return match.homeTeam + " ning ikkinchi setdagi jami hisobi";
	};
	var bo_o9 = function bo_o9(match, outcome) {
	    return match.homeTeam + " ning uchinchi setdagi jami hisobi";
	};
	var bo_p9 = function bo_p9(match, outcome) {
	    return match.awayTeam + " ning birinchi setdagi jami hisobi";
	};
	var bo_q9 = function bo_q9(match, outcome) {
	    return match.awayTeam + " ning ikkinchi setdagi jami hisobi";
	};
	var bo_r9 = function bo_r9(match, outcome) {
	    return match.awayTeam + " ning uchinchi setdagi jami hisobi";
	};
	var bo_s9 = function bo_s9(match, outcome) {
	    return 'O&apos;yin partiyalari bo&apos;yicha fora';
	};
	var bo_t9 = function bo_t9(match, outcome) {
	    return 'Birinchi setning aniq jami hisobi';
	};
	var bo_u9 = function bo_u9(match, outcome) {
	    return 'Ikkinchi setning aniq jami hisobi';
	};
	var bo_v9 = function bo_v9(match, outcome) {
	    return 'Uchinchi setning aniq jami hisobi';
	};
	var bo_w9 = function bo_w9(match, outcome) {
	    return match.homeTeam + " birinchi setda farq bilan g&apos;alaba qozonadi";
	};
	var bo_x9 = function bo_x9(match, outcome) {
	    return match.homeTeam + " ikkinchi setda farq bilan g&apos;alaba qozonadi";
	};
	var bo_y9 = function bo_y9(match, outcome) {
	    return match.homeTeam + " uchinchi setda farq bilan g&apos;alaba qozonadi";
	};
	var bo_z9 = function bo_z9(match, outcome) {
	    return match.awayTeam + " birinchi setda farq bilan g&apos;alaba qozonadi";
	};
	var bo_a10 = function bo_a10(match, outcome) {
	    return match.awayTeam + " ikkinchi setda farq bilan g&apos;alaba qozonadi";
	};
	var bo_b10 = function bo_b10(match, outcome) {
	    return match.awayTeam + " uchinchi setda farq bilan g&apos;alaba qozonadi";
	};
	var bo_c10 = function bo_c10(match, outcome) {
	    return 'Birinchi set juft/toq';
	};
	var bo_d10 = function bo_d10(match, outcome) {
	    return 'Ikkinchi set juft/toq';
	};
	var bo_e10 = function bo_e10(match, outcome) {
	    return 'Uchinchi set juft/toq';
	};
	var bo_f10 = function bo_f10(match, outcome) {
	    return "Birinchi set g&apos;alaba va " + outcome.condition + " jami hisob";
	};
	var bo_g10 = function bo_g10(match, outcome) {
	    return "Ikkinchi set g&apos;alaba va " + outcome.condition + " jami hisob";
	};
	var bo_h10 = function bo_h10(match, outcome) {
	    return "Uchinchi set g&apos;alaba va " + outcome.condition + " jami hisob";
	};
	var bo_i10 = function bo_i10(match, outcome) {
	    return 'Birinchi setning 10 ochkogacha bo&apos;lgan kichik setida g&apos;alaba';
	};
	var bo_j10 = function bo_j10(match, outcome) {
	    return 'Ikkinchi setning 10 ochkogacha bo&apos;lgan kichik setida g&apos;alaba';
	};
	var bo_k10 = function bo_k10(match, outcome) {
	    return 'Birinchi setning 10 ochkogacha bo&apos;lgan kichik setida fora';
	};
	var bo_l10 = function bo_l10(match, outcome) {
	    return 'Ikkinchi setning 10 ochkogacha bo&apos;lgan kichik setida fora';
	};
	var bo_m10 = function bo_m10(match, outcome) {
	    return 'Birinchi setning 10 ochkogacha bo&apos;lgan kichik setida jami hisob';
	};
	var bo_n10 = function bo_n10(match, outcome) {
	    return 'Ikkinchi setning 10 ochkogacha bo&apos;lgan kichik setida jami hisob';
	};
	var bo_o10 = function bo_o10(match, outcome) {
	    return 'Birinchi setning 15 ochkogacha bo&apos;lgan kichik setida g&apos;alaba';
	};
	var bo_p10 = function bo_p10(match, outcome) {
	    return 'Ikkinchi setning 15 ochkogacha bo&apos;lgan kichik setida g&apos;alaba';
	};
	var bo_q10 = function bo_q10(match, outcome) {
	    return 'Birinchi setning 15 ochkogacha bo&apos;lgan kichik setida fora';
	};
	var bo_r10 = function bo_r10(match, outcome) {
	    return 'Ikkinchi setning 15 ochkogacha bo&apos;lgan kichik setida fora';
	};
	var bo_s10 = function bo_s10(match, outcome) {
	    return 'Birinchi setning 15 ochkogacha bo&apos;lgan kichik setida jami hisob';
	};
	var bo_t10 = function bo_t10(match, outcome) {
	    return 'Ikkinchi setning 15 ochkogacha bo&apos;lgan kichik setida jami hisob';
	};
	var bo_u10 = function bo_u10(match, outcome) {
	    return "Birinchi setda kim " + numeralNeuterEnding(outcome.condition) + " ochkoni ni yutadi";
	};
	var bo_v10 = function bo_v10(match, outcome) {
	    return "Ikkinchi setda kim " + numeralNeuterEnding(outcome.condition) + " ochkoni ni yutadi";
	};
	var bo_w10 = function bo_w10(match, outcome) {
	    return "Uchinchi setda kim " + numeralNeuterEnding(outcome.condition) + " ochkoni ni yutadi";
	};
	var bo_x10 = function bo_x10(match, outcome) {
	    return "O&apos;yin jami hisobi " + outcome.condition + " va g&apos;alaba";
	};
	var bo_y10 = function bo_y10(match, outcome) {
	    return 'Birinchi setda farq bilan g&apos;alaba';
	};
	var bo_z10 = function bo_z10(match, outcome) {
	    return 'Ikkinchi setda farq bilan g&apos;alaba';
	};
	var bo_a11 = function bo_a11(match, outcome) {
	    return 'Uchinchi setda farq bilan g&apos;alaba';
	};
	var bo_b11 = function bo_b11(match, outcome) {
	    return 'Birinchi otish marrasidagi jami hisob';
	};
	var bo_c11 = function bo_c11(match, outcome) {
	    return 'Ikkinchi otish marrasidagi jami hisob';
	};
	var bo_d11 = function bo_d11(match, outcome) {
	    return 'Uchinchi otish marrasidagi jami hisob';
	};
	var bo_e11 = function bo_e11(match, outcome) {
	    return 'To&apos;rtinchi otish marrasidagi jami hisob';
	};
	var bo_f11 = function bo_f11(match, outcome) {
	    return 'Beshinchi otish marrasidagi jami hisob';
	};
	var bo_g11 = function bo_g11(match, outcome) {
	    return 'Oltinchi otish marrasidagi jami hisob';
	};
	var bo_h11 = function bo_h11(match, outcome) {
	    return 'Yettinchi otish marrasidagi jami hisob';
	};
	var bo_i11 = function bo_i11(match, outcome) {
	    return 'Sakkizinchi otish marrasidagi jami hisob';
	};
	var bo_j11 = function bo_j11(match, outcome) {
	    return "Birinchi otish marrasidagi " + match.homeTeam + " jami hisobi";
	};
	var bo_k11 = function bo_k11(match, outcome) {
	    return "Ikkinchi otish marrasidagi " + match.homeTeam + " jami hisobi";
	};
	var bo_l11 = function bo_l11(match, outcome) {
	    return "Uchinchi otish marrasidagi " + match.homeTeam + " jami hisobi";
	};
	var bo_m11 = function bo_m11(match, outcome) {
	    return "To&apos;rtinchi otish marrasidagi " + match.homeTeam + " jami hisobi";
	};
	var bo_n11 = function bo_n11(match, outcome) {
	    return "Beshinchi otish marrasidagi " + match.homeTeam + " jami hisobi";
	};
	var bo_o11 = function bo_o11(match, outcome) {
	    return "Oltinchi otish marrasidagi " + match.homeTeam + " jami hisobi";
	};
	var bo_p11 = function bo_p11(match, outcome) {
	    return "Yettinchi otish marrasidagi " + match.homeTeam + " jami hisobi";
	};
	var bo_q11 = function bo_q11(match, outcome) {
	    return "Sakkizinchi otish marrasidagi " + match.homeTeam + " jami hisobi";
	};
	var bo_r11 = function bo_r11(match, outcome) {
	    return "Birinchi otish marrasidagi " + match.awayTeam + " jami hisobi";
	};
	var bo_s11 = function bo_s11(match, outcome) {
	    return "Ikkinchi otish marrasidagi " + match.awayTeam + " jami hisobi";
	};
	var bo_t11 = function bo_t11(match, outcome) {
	    return "Uchinchi otish marrasidagi " + match.awayTeam + " jami hisobi";
	};
	var bo_u11 = function bo_u11(match, outcome) {
	    return "To&apos;rtinchi otish marrasidagi " + match.awayTeam + " jami hisobi";
	};
	var bo_v11 = function bo_v11(match, outcome) {
	    return "Beshinchi otish marrasidagi " + match.awayTeam + " jami hisobi";
	};
	var bo_w11 = function bo_w11(match, outcome) {
	    return "Oltinchi otish marrasidagi " + match.awayTeam + " jami hisobi";
	};
	var bo_x11 = function bo_x11(match, outcome) {
	    return "Yettinchi otish marrasidagi " + match.awayTeam + " jami hisobi";
	};
	var bo_y11 = function bo_y11(match, outcome) {
	    return "Sakkizinchi otish marrasidagi " + match.awayTeam + " jami hisobi";
	};
	var bo_z11 = function bo_z11(match, outcome) {
	    return 'Birinchi otish marrasidagi fora';
	};
	var bo_a12 = function bo_a12(match, outcome) {
	    return 'Ikkinchi otish marrasidagi fora';
	};
	var bo_b12 = function bo_b12(match, outcome) {
	    return 'Uchinchi otish marrasidagi fora';
	};
	var bo_c12 = function bo_c12(match, outcome) {
	    return 'To&apos;rtinchi otish marrasidagi fora';
	};
	var bo_d12 = function bo_d12(match, outcome) {
	    return 'Beshinchi otish marrasidagi fora';
	};
	var bo_e12 = function bo_e12(match, outcome) {
	    return 'Oltinchi otish marrasidagi fora';
	};
	var bo_f12 = function bo_f12(match, outcome) {
	    return 'Yettinchi otish marrasidagi fora';
	};
	var bo_g12 = function bo_g12(match, outcome) {
	    return 'Sakkinzinchi otish marrasidagi fora';
	};
	var bo_h12 = function bo_h12(match, outcome) {
	    return 'Birinchi otish marrasi natijasi';
	};
	var bo_i12 = function bo_i12(match, outcome) {
	    return 'Ikkinchi otish marrasi natijasi';
	};
	var bo_j12 = function bo_j12(match, outcome) {
	    return 'Uchinchi otish marrasi natijasi';
	};
	var bo_k12 = function bo_k12(match, outcome) {
	    return 'To&apos;rtinchi otish marrasi natijasi';
	};
	var bo_l12 = function bo_l12(match, outcome) {
	    return 'Beshinchi otish marrasi natijasi';
	};
	var bo_m12 = function bo_m12(match, outcome) {
	    return 'Oltinchi otish marrasi natijasi';
	};
	var bo_n12 = function bo_n12(match, outcome) {
	    return 'Yettinchi otish marrasi natijasi';
	};
	var bo_o12 = function bo_o12(match, outcome) {
	    return 'Sakkizinchi otish marrasi natijasi';
	};
	var bo_p12 = function bo_p12(match, outcome) {
	    return 'Birinchi otish marrasida aniq jami hisob';
	};
	var bo_q12 = function bo_q12(match, outcome) {
	    return 'Ikkinchi otish marrasida aniq jami hisob';
	};
	var bo_r12 = function bo_r12(match, outcome) {
	    return 'Uchinchi otish marrasida aniq jami hisob';
	};
	var bo_s12 = function bo_s12(match, outcome) {
	    return 'To&apos;rtinchi otish marrasida aniq jami hisob';
	};
	var bo_t12 = function bo_t12(match, outcome) {
	    return 'Beshinchi otish marrasida aniq jami hisob';
	};
	var bo_u12 = function bo_u12(match, outcome) {
	    return 'Oltinchi otish marrasida aniq jami hisob';
	};
	var bo_v12 = function bo_v12(match, outcome) {
	    return 'Yettinchi otish marrasida aniq jami hisob';
	};
	var bo_w12 = function bo_w12(match, outcome) {
	    return 'Sakkizinchi otish marrasida aniq jami hisob';
	};
	var bo_x12 = function bo_x12(match, outcome) {
	    return 'Muddatidan avval g&apos;alaba bo&apos;ladimi?';
	};
	var bo_y12 = function bo_y12(match, outcome) {
	    return 'Jangdagi g&apos;alaba usullari';
	};
	var bo_z12 = function bo_z12(match, outcome) {
	    return 'Jangdagi g&apos;alaba';
	};
	var bo_a13 = function bo_a13(match, outcome) {
	    return "Kim " + outcome.condition + " raundda g&apos;alaba qozonadi?";
	};
	var bo_b13 = function bo_b13(match, outcome) {
	    return 'FirstBlood';
	};
	var bo_c13 = function bo_c13(match, outcome) {
	    return "FirstBlood " + outcome.condition + " raundda";
	};
	var bo_d13 = function bo_d13(match, outcome) {
	    return "Kim " + outcome.condition + " xaritasida g&apos;alaba qozonadi?";
	};
	var bo_e13 = function bo_e13(match, outcome) {
	    return "FirstBlood " + outcome.condition + " xaritasida";
	};
	var bo_f13 = function bo_f13(match, outcome) {
	    return "Kim birinchi bo&apos;lib 1-xaritada " + outcome.condition + " ta o&apos;ldirishlarni amalga oshiradi";
	};
	var bo_g13 = function bo_g13(match, outcome) {
	    return "Kim birinchi bo&apos;lib 2-xaritada " + outcome.condition + " ta o&apos;ldirishlarni amalga oshiradi";
	};
	var bo_h13 = function bo_h13(match, outcome) {
	    return "Kim birinchi bo&apos;lib 3-xaritada " + outcome.condition + " ta o&apos;ldirishlarni amalga oshiradi";
	};
	var bo_i13 = function bo_i13(match, outcome) {
	    return "Kim birinchi bo&apos;lib 4-xaritada " + outcome.condition + " ta o&apos;ldirishlarni amalga oshiradi";
	};
	var bo_j13 = function bo_j13(match, outcome) {
	    return "Kim birinchi bo&apos;lib 5-xaritada " + outcome.condition + " ta o&apos;ldirishlarni amalga oshiradi";
	};
	var bo_k13 = function bo_k13(match, outcome) {
	    return 'O&apos;yin natijasi';
	};
	var bo_l13 = function bo_l13(match, outcome) {
	    return 'Birinchi xaritada g&apos;alaba';
	};
	var bo_m13 = function bo_m13(match, outcome) {
	    return 'Ikkinchi xaritada g&apos;alaba';
	};
	var bo_n13 = function bo_n13(match, outcome) {
	    return 'Uchinchi xaritada g&apos;alaba';
	};
	var bo_o13 = function bo_o13(match, outcome) {
	    return 'To&apos;rtinchi xaritada g&apos;alaba';
	};
	var bo_p13 = function bo_p13(match, outcome) {
	    return 'Beshinchi xaritada g&apos;alaba';
	};
	var bo_q13 = function bo_q13(match, outcome) {
	    return 'Birinchi xaritada First blood';
	};
	var bo_r13 = function bo_r13(match, outcome) {
	    return 'Ikkinchi xaritada First blood';
	};
	var bo_s13 = function bo_s13(match, outcome) {
	    return 'Uchinchi xaritada First blood';
	};
	var bo_t13 = function bo_t13(match, outcome) {
	    return 'To&apos;rtinchi xaritada First blood';
	};
	var bo_u13 = function bo_u13(match, outcome) {
	    return 'Beshinchi xaritada First blood';
	};
	var bo_v13 = function bo_v13(match, outcome) {
	    return 'Bullitlarni hisobga olgandagi g&apos;alaba';
	};
	var bo_w13 = function bo_w13(match, outcome) {
	    return match.homeTeam + " ikkala o&apos;yinda ham g&apos;alaba qozonadi";
	};
	var bo_x13 = function bo_x13(match, outcome) {
	    return match.awayTeam + " ikkala o&apos;yinda ham g&apos;alaba qozonadi";
	};
	var bo_y13 = function bo_y13(match, outcome) {
	    return outcome.conditionTwo + " ta va undan ko&apos;p gol urgan jamoalar (ularning jamisi)";
	};
	var bo_z13 = function bo_z13(match, outcome) {
	    return 'Eng sermahsul jamoa (uning jamisi)';
	};
	var bo_a14 = function bo_a14(match, outcome) {
	    return 'Eng sermahsul bo&apos;lim (jami)';
	};
	var bo_b14 = function bo_b14(match, outcome) {
	    return "Ikkala bo&apos;lim ham " + outcome.condition + " dan kam";
	};
	var bo_c14 = function bo_c14(match, outcome) {
	    return "Ikkala bo&apos;lim ham " + outcome.condition + " dan ko&apos;p";
	};
	var bo_d14 = function bo_d14(match, outcome) {
	    return 'Birinchi bo&apos;lim juft/toq';
	};
	var bo_e14 = function bo_e14(match, outcome) {
	    return 'Ikkinchi bo&apos;lim juft/toq';
	};
	var bo_f14 = function bo_f14(match, outcome) {
	    return match.homeTeam + " birinchi bo&apos;limda nechta gol kiritadi?";
	};
	var bo_g14 = function bo_g14(match, outcome) {
	    return match.homeTeam + " ikkinchi bo&apos;limda nechta gol kiritadi?";
	};
	var bo_h14 = function bo_h14(match, outcome) {
	    return match.awayTeam + "  birinchi bo&apos;limda nechta gol kiritadi?";
	};
	var bo_i14 = function bo_i14(match, outcome) {
	    return match.awayTeam + " ikkinchi bo&apos;limda nechta gol kiritadi?";
	};
	var bo_j14 = function bo_j14(match, outcome) {
	    return match.homeTeam + " o&apos;yinda nechta to&apos;p kiritadi?";
	};
	var bo_k14 = function bo_k14(match, outcome) {
	    return match.awayTeam + " o&apos;yinda nechta to&apos;p kiritadi?";
	};
	var bo_l14 = function bo_l14(match, outcome) {
	    return 'Eng sermahsul bo&apos;lmagan jamoa (uning jamisi)';
	};
	var bo_m14 = function bo_m14(match, outcome) {
	    return match.homeTeam + " faqat birinchi bo&apos;limda to&apos;p kiritadimi?";
	};
	var bo_n14 = function bo_n14(match, outcome) {
	    return match.awayTeam + " faqat birinchi bo&apos;limda to&apos;p kiritadimi?";
	};
	var bo_o14 = function bo_o14(match, outcome) {
	    return match.homeTeam + " faqat ikkinchi bo&apos;limda to&apos;p kiritadimi?";
	};
	var bo_p14 = function bo_p14(match, outcome) {
	    return match.awayTeam + " faqat ikkinchi bo&apos;limda to&apos;p kiritadimi?";
	};
	var bo_q14 = function bo_q14(match, outcome) {
	    return 'Birinchi bo&apos;limda nechta to&apos;p kiritadi';
	};
	var bo_r14 = function bo_r14(match, outcome) {
	    return 'Ikkinchi bo&apos;limda nechta to&apos;p kiritadi';
	};
	var bo_s14 = function bo_s14(match, outcome) {
	    return "Nechta jamoalar " + outcome.condition + " dan ko&apos;p " + plural(outcome.condition, ['gol', 'gol', 'gol']) + " urishadi";
	};
	var bo_t14 = function bo_t14(match, outcome) {
	    return 'Birinchi gol qanday kiritiladi?';
	};
	var bo_u14 = function bo_u14(match, outcome) {
	    return 'Keyingi davraga o&apos;tish';
	};
	var bo_v14 = function bo_v14(match, outcome) {
	    return 'Kim maydon markazidan boshlaydi?';
	};
	var bo_w14 = function bo_w14(match, outcome) {
	    return 'Bir jamoa tomonidan ketma-ket ikkita to&apos;p';
	};
	var bo_x14 = function bo_x14(match, outcome) {
	    return match.homeTeam + " jamoasi irodali g&apos;alabaga erishadi";
	};
	var bo_y14 = function bo_y14(match, outcome) {
	    return "Kim " + numeralFemaleEnding(outcome.condition) + " SK oladi";
	};
	var bo_z14 = function bo_z14(match, outcome) {
	    return match.awayTeam + " jamoasi irodali g&apos;alabaga erishadi";
	};
	var bo_a15 = function bo_a15(match, outcome) {
	    return 'O&apos;yinda oldin nima sodir bo&apos;ladi?';
	};
	var bo_b15 = function bo_b15(match, outcome) {
	    return 'Dubl';
	};
	var bo_c15 = function bo_c15(match, outcome) {
	    return 'Xet-trik';
	};
	var bo_d15 = function bo_d15(match, outcome) {
	    return "Kim " + numeralMaleEnding(outcome.condition) + " burchak to&apos;pini oshirib beradi";
	};
	var bo_e15 = function bo_e15(match, outcome) {
	    return "Aniq " + outcome.conditionTwo + " ta " + plural(outcome.conditionTwo, ['gol', 'gol', 'gol']) + " kiritgan jamoalar jami soni";
	};
	var bo_f15 = function bo_f15(match, outcome) {
	    return "O&apos;yinda aniq  " + outcome.condition + " ta " + plural(outcome.condition, ['gol', 'gol', 'gol']) + " kiritiladimi";
	};
	var bo_g15 = function bo_g15(match, outcome) {
	    return 'Kim oxirgi golni kiritadi';
	};
	var bo_h15 = function bo_h15(match, outcome) {
	    return 'Avtogol';
	};
	var bo_i15 = function bo_i15(match, outcome) {
	    return 'Zahiradan maydonga tushgan o&apos;yinchi gol uradimi?';
	};
	var bo_j15 = function bo_j15(match, outcome) {
	    return 'Oxirgi gol vaqti';
	};
	var bo_k15 = function bo_k15(match, outcome) {
	    return 'Kubok sohibi';
	};
	var bo_l15 = function bo_l15(match, outcome) {
	    return 'Superkubok sohibi';
	};
	var bo_m15 = function bo_m15(match, outcome) {
	    return "Qaysi bo&apos;limda " + numeralMaleEnding(outcome.condition) + " gol kiritiladi?";
	};
	var bo_n15 = function bo_n15(match, outcome) {
	    return '1-daqiqadan 15-daqiqagacha ikkilangan natija';
	};
	var bo_o15 = function bo_o15(match, outcome) {
	    return '16-daqiqadan 30-daqiqagacha ikkilangan natija';
	};
	var bo_p15 = function bo_p15(match, outcome) {
	    return '31-daqiqadan tanaffusgacha ikkilangan natija';
	};
	var bo_q15 = function bo_q15(match, outcome) {
	    return '46-daqiqadan 60-daqiqagacha ikkilangan natija';
	};
	var bo_r15 = function bo_r15(match, outcome) {
	    return '61-daqiqadan 75-daqiqagacha ikkilangan natija';
	};
	var bo_s15 = function bo_s15(match, outcome) {
	    return '76-daqiqadan o&apos;yin oxirigacha ikkilangan natija';
	};
	var bo_t15 = function bo_t15(match, outcome) {
	    return match.homeTeam + " jamoasi " + numeralMaleEnding(outcome.condition) + " penaltini amalga oshiradimi (penaltilar seriyasida)?";
	};
	var bo_u15 = function bo_u15(match, outcome) {
	    return match.awayTeam + " jamoasi " + numeralMaleEnding(outcome.condition) + " penaltini amalga oshiradimi (penaltilar seriyasida)?";
	};
	var bo_v15 = function bo_v15(match, outcome) {
	    return match.homeTeam + " o&apos;zining " + numeralMaleEnding(outcome.condition) + "-chi golini kiritadi";
	};
	var bo_w15 = function bo_w15(match, outcome) {
	    return match.awayTeam + " o&apos;zining " + numeralMaleEnding(outcome.condition) + "-chi golini kiritadi";
	};
	var bo_x15 = function bo_x15(match, outcome) {
	    return 'Birinchi bo&apos;limdagi jami burchak to&apos;p oshirilishlari soni';
	};
	var bo_y15 = function bo_y15(match, outcome) {
	    return 'Birinchi bo&apos;limdagi jami SK soni';
	};
	var bo_z15 = function bo_z15(match, outcome) {
	    return 'O&apos;yin davomidagi burchak zarbalari bo&apos;yicha  fora';
	};
	var bo_a16 = function bo_a16(match, outcome) {
	    return 'Birinchi bo&apos;lim uchun burchak zarbalari bo&apos;yicha fora';
	};
	var bo_b16 = function bo_b16(match, outcome) {
	    return 'Sariq kartochkalar bo&apos;yicha fora';
	};
	var bo_c16 = function bo_c16(match, outcome) {
	    return 'Birinchi bo&apos;lim uchun sariq kartochkalar bo&apos;yicha fora';
	};
	var bo_d16 = function bo_d16(match, outcome) {
	    return 'Burchak zarbalari bo&apos;yicha natija';
	};
	var bo_e16 = function bo_e16(match, outcome) {
	    return 'Burchak zarbalari bo&apos;yicha birinchi bo&apos;lim natijasi';
	};
	var bo_f16 = function bo_f16(match, outcome) {
	    return 'Sariq kartochkalar bo&apos;yicha natija';
	};
	var bo_g16 = function bo_g16(match, outcome) {
	    return 'Sariq kartochkalar bo&apos;yicha birinchi bo&apos;lim natijasi';
	};
	var bo_h16 = function bo_h16(match, outcome) {
	    return "Kim birinchi " + outcome.condition + " ta " + plural(outcome.condition, ['gol', 'gol', 'gol']) + " kiritadi";
	};
	var bo_i16 = function bo_i16(match, outcome) {
	    return numeralMaleEnding(outcome.condition) + "- penalti aniq amalga oshiriladimi?";
	};
	var bo_j16 = function bo_j16(match, outcome) {
	    return 'O&apos;yinda kiritilgan to&apos;plar jamisi';
	};
	var bo_k16 = function bo_k16(match, outcome) {
	    return 'Ikkitalik natija';
	};
	var bo_l16 = function bo_l16(match, outcome) {
	    return 'Yon tomondan to&apos;p oshirilishlar jamisi';
	};
	var bo_m16 = function bo_m16(match, outcome) {
	    return 'Bo&apos;lim-o&apos;yin';
	};
	var bo_n16 = function bo_n16(match, outcome) {
	    return 'O&apos;yin hisobi jamisi (Osiyo)';
	};
	var bo_o16 = function bo_o16(match, outcome) {
	    return 'O&apos;yin hisobining aniq jamisi';
	};
	var bo_p16 = function bo_p16(match, outcome) {
	    return 'Jami burchak to&apos;plari';
	};
	var bo_q16 = function bo_q16(match, outcome) {
	    return 'O&apos;yin qanday tugaydi?';
	};
	var bo_r16 = function bo_r16(match, outcome) {
	    return 'Penaltilar (jami)';
	};
	var bo_s16 = function bo_s16(match, outcome) {
	    return 'Jami qizil kartochkalar';
	};
	var bo_t16 = function bo_t16(match, outcome) {
	    return 'Birinchi gol vaqti';
	};
	var bo_u16 = function bo_u16(match, outcome) {
	    return 'Gollar yig&apos;indisi';
	};
	var bo_v16 = function bo_v16(match, outcome) {
	    return "Jami: " + match.homeTeam;
	};
	var bo_w16 = function bo_w16(match, outcome) {
	    return "Jami: " + match.awayTeam;
	};
	var bo_x16 = function bo_x16(match, outcome) {
	    return 'Birinchi bo&apos;lim jamisi';
	};
	var bo_y16 = function bo_y16(match, outcome) {
	    return 'Ikkinchi bo&apos;lim jamisi';
	};
	var bo_z16 = function bo_z16(match, outcome) {
	    return 'Birinchi bo&apos;lim uchun fora';
	};
	var bo_a17 = function bo_a17(match, outcome) {
	    return 'Ikkinchi bo&apos;lim uchun fora';
	};
	var bo_b17 = function bo_b17(match, outcome) {
	    return 'Darvoza tomon zarbalar';
	};
	var bo_c17 = function bo_c17(match, outcome) {
	    return "G&apos;alaba va " + outcome.condition + " jami hisob";
	};
	var bo_d17 = function bo_d17(match, outcome) {
	    return 'Jami sariq kartochkalar';
	};
	var bo_e17 = function bo_e17(match, outcome) {
	    return 'Ikkinchi bo&apos;lim natijasi';
	};
	var bo_f17 = function bo_f17(match, outcome) {
	    return 'O&apos;yinning 1-daqiqasidan 15-daqiqasigacha fora';
	};
	var bo_g17 = function bo_g17(match, outcome) {
	    return 'O&apos;yinning 16-daqiqasidan 30-daqiqasigacha fora';
	};
	var bo_h17 = function bo_h17(match, outcome) {
	    return 'O&apos;yinning 31-daqiqasidan tanaffusgacha fora';
	};
	var bo_i17 = function bo_i17(match, outcome) {
	    return 'O&apos;yinning 46-daqiqasidan 60-daqiqasigacha fora';
	};
	var bo_j17 = function bo_j17(match, outcome) {
	    return 'O&apos;yinning 61-daqiqasidan 75-daqiqasigacha fora';
	};
	var bo_k17 = function bo_k17(match, outcome) {
	    return 'O&apos;yinning 76-daqiqasidan o&apos;yin yakuniga qadar fora';
	};
	var bo_l17 = function bo_l17(match, outcome) {
	    return match.homeTeam + " gollar";
	};
	var bo_m17 = function bo_m17(match, outcome) {
	    return match.awayTeam + " gollar";
	};
	var bo_n17 = function bo_n17(match, outcome) {
	    return 'Jami o&apos;zgartirishlar';
	};
	var bo_o17 = function bo_o17(match, outcome) {
	    return 'Jami hisob Juft/Toq';
	};
	var bo_p17 = function bo_p17(match, outcome) {
	    return '1-dan 15-daqaqiqagacha jami hisob';
	};
	var bo_q17 = function bo_q17(match, outcome) {
	    return '16-dan 30-daqaqiqagacha jami hisob';
	};
	var bo_r17 = function bo_r17(match, outcome) {
	    return '31-daqiqadan tanaffusgacha jami hisob';
	};
	var bo_s17 = function bo_s17(match, outcome) {
	    return '46-dan 60-daqaqiqagacha jami hisob';
	};
	var bo_t17 = function bo_t17(match, outcome) {
	    return '61-dan 75-daqaqiqagacha jami hisob';
	};
	var bo_u17 = function bo_u17(match, outcome) {
	    return '76-daqiqadan o&apos;yin yakunigacha jami hisob';
	};
	var bo_v17 = function bo_v17(match, outcome) {
	    return "1-dan 15-daqiqagacha " + match.homeTeam + " ning jami hisobi";
	};
	var bo_w17 = function bo_w17(match, outcome) {
	    return "16-dan 30-daqiqagacha " + match.homeTeam + " ning jami hisobi";
	};
	var bo_x17 = function bo_x17(match, outcome) {
	    return "31-daqiqadan tanaffusgacha " + match.homeTeam + " ning jami hisobi";
	};
	var bo_y17 = function bo_y17(match, outcome) {
	    return "46-dan 60-daqiqagacha " + match.homeTeam + " ning jami hisobi";
	};
	var bo_z17 = function bo_z17(match, outcome) {
	    return "61-dan 75-daqiqagacha " + match.homeTeam + " ning jami hisobi";
	};
	var bo_a18 = function bo_a18(match, outcome) {
	    return "76-daqiqadan o&apos;yin yakunigacha " + match.homeTeam + " ning jami hisobi";
	};
	var bo_b18 = function bo_b18(match, outcome) {
	    return "1-dan 15-daqiqagacha " + match.awayTeam + " ning jami hisobi";
	};
	var bo_c18 = function bo_c18(match, outcome) {
	    return "16-dan 30-daqiqagacha " + match.awayTeam + " ning jami hisobi";
	};
	var bo_d18 = function bo_d18(match, outcome) {
	    return "31-daqiqadan tanaffusgacha " + match.awayTeam + " ning jami hisobi";
	};
	var bo_e18 = function bo_e18(match, outcome) {
	    return "46-dan 60-daqiqagacha " + match.awayTeam + " ning jami hisobi";
	};
	var bo_f18 = function bo_f18(match, outcome) {
	    return "61-dan 75-daqiqagacha " + match.awayTeam + " ning jami hisobi";
	};
	var bo_g18 = function bo_g18(match, outcome) {
	    return "76-daqiqadan o&apos;yin yakunigacha " + match.awayTeam + " ning jami hisobi";
	};
	var bo_h18 = function bo_h18(match, outcome) {
	    return 'Birinchi bo&apos;limning aniq jami hisobi';
	};
	var bo_i18 = function bo_i18(match, outcome) {
	    return 'Ikkinchi bo&apos;limning aniq jami hisobi';
	};
	var bo_j18 = function bo_j18(match, outcome) {
	    return match.homeTeam + " g&apos;alaba qozonadi va yutqazmaydi";
	};
	var bo_k18 = function bo_k18(match, outcome) {
	    return match.awayTeam + " g&apos;alaba qozonadi va yutqazmaydi";
	};
	var bo_l18 = function bo_l18(match, outcome) {
	    return match.homeTeam + " aniq " + outcome.condition + " ta " + plural(outcome.condition, ['gol', 'gol', 'gol']) + " kiritadi";
	};
	var bo_m18 = function bo_m18(match, outcome) {
	    return match.awayTeam + " aniq " + outcome.condition + " ta " + plural(outcome.condition, ['gol', 'gol', 'gol']) + " kiritadi";
	};
	var bo_n18 = function bo_n18(match, outcome) {
	    return 'Birinchi bo&apos;limning aniq hisobi';
	};
	var bo_o18 = function bo_o18(match, outcome) {
	    return 'Ikkinchi bo&apos;limning aniq hisobi';
	};
	var bo_p18 = function bo_p18(match, outcome) {
	    return 'Jami kiritilmagan penaltilar soni';
	};
	var bo_q18 = function bo_q18(match, outcome) {
	    return "Ikkala jamoa ham " + outcome.condition + " tadan kam to&apos;p kiritishadi";
	};
	var bo_r18 = function bo_r18(match, outcome) {
	    return "Ikkala jamoa ham " + outcome.condition + " tadan ko&apos;p to&apos;p kiritishadi";
	};
	var bo_s18 = function bo_s18(match, outcome) {
	    return 'Bo&apos;limlarni taqqoslash (gollar)';
	};
	var bo_t18 = function bo_t18(match, outcome) {
	    return '1-dan 15-daqiqagacha g&apos;alaba';
	};
	var bo_u18 = function bo_u18(match, outcome) {
	    return '16-dan 30-daqiqagacha g&apos;alaba';
	};
	var bo_v18 = function bo_v18(match, outcome) {
	    return '31-daqiqadan tanaffusgacha g&apos;alaba';
	};
	var bo_w18 = function bo_w18(match, outcome) {
	    return '46-dan 60-daqiqagacha g&apos;alaba';
	};
	var bo_x18 = function bo_x18(match, outcome) {
	    return '61-dan 75-daqiqagacha g&apos;alaba';
	};
	var bo_y18 = function bo_y18(match, outcome) {
	    return '76-daqiqadan o&apos;yin yakunigacha g&apos;alaba';
	};
	var bo_z18 = function bo_z18(match, outcome) {
	    return match.homeTeam + " jamoasi " + outcome.condition + " ta " + plural(outcome.condition, ['gol', 'gol', 'gol']) + " farqi bilan g&apos;alaba qozonadi";
	};
	var bo_a19 = function bo_a19(match, outcome) {
	    return match.awayTeam + " jamoasi " + outcome.condition + " ta " + plural(outcome.condition, ['gol', 'gol', 'gol']) + " farqi bilan g&apos;alaba qozonadi";
	};
	var bo_b19 = function bo_b19(match, outcome) {
	    return match.homeTeam + " bitta bo&apos;limda g&apos;alaba qozonadi";
	};
	var bo_c19 = function bo_c19(match, outcome) {
	    return match.awayTeam + " bitta bo&apos;limda g&apos;alaba qozonadi";
	};
	var bo_d19 = function bo_d19(match, outcome) {
	    return outcome.conditionTwo + " tadan " + outcome.conditionThree + " gacha to&apos;p kiritgan jamoalarining jami soni";
	};
	var bo_e19 = function bo_e19(match, outcome) {
	    return "Jami: " + match.homeTeam + " uchun birinchi bo&apos;lim";
	};
	var bo_f19 = function bo_f19(match, outcome) {
	    return "Jami: " + match.homeTeam + " uchun ikkinchi bo&apos;lim";
	};
	var bo_g19 = function bo_g19(match, outcome) {
	    return "Jami: " + match.awayTeam + " uchun birinchi bo&apos;lim";
	};
	var bo_h19 = function bo_h19(match, outcome) {
	    return "Jami: " + match.awayTeam + " uchun ikkinchi bo&apos;lim";
	};
	var bo_i19 = function bo_i19(match, outcome) {
	    return "(" + match.homeTeam + ") jamoasidagi " + outcome.playerName + " to&apos;p kiritadimi?";
	};
	var bo_j19 = function bo_j19(match, outcome) {
	    return "(" + match.awayTeam + ") jamoasidagi " + outcome.playerName + " to&apos;p kiritadimi?";
	};
	var bo_k19 = function bo_k19(match, outcome) {
	    return 'O&apos;yin forasi';
	};
	var bo_l19 = function bo_l19(match, outcome) {
	    return 'O&apos;yin jami hisobi';
	};
	var bo_m19 = function bo_m19(match, outcome) {
	    return 'Mezbonlar jami hisobi';
	};
	var bo_n19 = function bo_n19(match, outcome) {
	    return 'Mehmonlar jami hisobi';
	};
	var bo_o19 = function bo_o19(match, outcome) {
	    return 'Eng sermahsul o&apos;yin jami hisobi';
	};
	var bo_p19 = function bo_p19(match, outcome) {
	    return 'Eng sermahsul bo&apos;lmagan o&apos;yin jami hisobi';
	};
	var bo_q19 = function bo_q19(match, outcome) {
	    return 'Golsiz o&apos;yinlar jami hisobi';
	};
	var bo_r19 = function bo_r19(match, outcome) {
	    return 'Mezbonlarning jami g&apos;alabalari';
	};
	var bo_s19 = function bo_s19(match, outcome) {
	    return 'Mehmonlarning jami g&apos;alabalari';
	};
	var bo_t19 = function bo_t19(match, outcome) {
	    return 'Durranglar jami soni';
	};
	var bo_u19 = function bo_u19(match, outcome) {
	    return "Jami: " + outcome.playerName + " (" + match.homeTeam + ")";
	};
	var bo_v19 = function bo_v19(match, outcome) {
	    return "Jami: " + outcome.playerName + " (" + match.awayTeam + ")";
	};
	var bo_w19 = function bo_w19(match, outcome) {
	    return 'Ikkala jamoa ham 1-bo&apos;lim / 2-bo&apos;limda to&apos;p kiritadi';
	};
	var bo_x19 = function bo_x19(match, outcome) {
	    return "Jami hisob " + outcome.condition + " va ikkala jamoa to&apos;p kiritadi";
	};
	var bo_y19 = function bo_y19(match, outcome) {
	    return match.homeTeam + " to&apos;p kiritadi va g&apos;alaba qozonmaydi";
	};
	var bo_z19 = function bo_z19(match, outcome) {
	    return "(" + match.awayTeam + ") to&apos;p kiritadi va g&apos;alaba qozonmaydi";
	};
	var bo_a20 = function bo_a20(match, outcome) {
	    return 'Метод победы в матче O&apos;yinda g&apos;alaba qozonish usuli';
	};
	var bo_b20 = function bo_b20(match, outcome) {
	    return '1-bo&apos;limga qo&apos;shib berilgan vaqt';
	};
	var bo_c20 = function bo_c20(match, outcome) {
	    return '2-bo&apos;limga qo&apos;shib berilgan vaqt';
	};
	var bo_d20 = function bo_d20(match, outcome) {
	    return 'O&apos;yinda to&apos;sin / ustunga to&apos;p tegadimi';
	};
	var bo_e20 = function bo_e20(match, outcome) {
	    return 'Birinchi o&apos;yin almashtirilish vaqti';
	};
	var bo_f20 = function bo_f20(match, outcome) {
	    return "Qizil kartochkani " + match.homeTeam + " jamoasi vakili oladi";
	};
	var bo_g20 = function bo_g20(match, outcome) {
	    return "Qizil kartochkani " + match.awayTeam + " jamoasi vakili oladi";
	};
	var bo_h20 = function bo_h20(match, outcome) {
	    return 'Penalti va chetlatish bo&apos;ladimi';
	};
	var bo_i20 = function bo_i20(match, outcome) {
	    return 'Qo&apos;shimcha vaqtda gol';
	};
	var bo_j20 = function bo_j20(match, outcome) {
	    return 'Simulyatsiya uchun sariq kartochka';
	};
	var bo_k20 = function bo_k20(match, outcome) {
	    return 'Fudbolkani yechganlik uchun SK';
	};
	var bo_l20 = function bo_l20(match, outcome) {
	    return 'Har bir bayroqchadan burchak to&apos;pi';
	};
	var bo_m20 = function bo_m20(match, outcome) {
	    return 'Kim 3-o&apos;rinni egallaydi?';
	};
	var bo_n20 = function bo_n20(match, outcome) {
	    return "Jami: " + match.awayTeam + "  (qo&apos;shimcha bo&apos;lim)";
	};
	var bo_o20 = function bo_o20(match, outcome) {
	    return "Jami: " + match.homeTeam + "  (qo&apos;shimcha bo&apos;lim)";
	};
	var bo_p20 = function bo_p20(match, outcome) {
	    return 'Ikkilangan natija (qo&apos;shimcha vaqt)';
	};
	var bo_q20 = function bo_q20(match, outcome) {
	    return 'Aniq hisob  (qo&apos;shimcha bo&apos;lim)';
	};
	var bo_r20 = function bo_r20(match, outcome) {
	    return 'Fora (Qo&apos;shimcha bo&apos;lim)';
	};
	var bo_s20 = function bo_s20(match, outcome) {
	    return 'Jami hisob  (Qo&apos;shimcha bo&apos;lim)';
	};
	var bo_t20 = function bo_t20(match, outcome) {
	    return 'Natija (Qo&apos;shimcha bo&apos;lim)';
	};
	var bo_u20 = function bo_u20(match, outcome) {
	    return "Qo&apos;shimcha bo&apos;limda " + numeralMaleEnding(outcome.condition) + " golni kim kiritadi?";
	};
	var bo_v20 = function bo_v20(match, outcome) {
	    return '1-qo&apos;shimcha bo&apos;limdagi fora';
	};
	var bo_w20 = function bo_w20(match, outcome) {
	    return '1-qo&apos;shimcha bo&apos;limdagi jami hisob';
	};
	var bo_x20 = function bo_x20(match, outcome) {
	    return '1-qo&apos;shimcha bo&apos;limdagi natija';
	};
	var bo_y20 = function bo_y20(match, outcome) {
	    return '2-qo&apos;shimcha bo&apos;limdagi fora';
	};
	var bo_z20 = function bo_z20(match, outcome) {
	    return '2-qo&apos;shimcha bo&apos;limdagi jami hisob';
	};
	var bo_a21 = function bo_a21(match, outcome) {
	    return '2-qo&apos;shimcha bo&apos;limdagi natija';
	};
	var bo_b21 = function bo_b21(match, outcome) {
	    return 'Penaltilar seriyasidagi aniq hisob';
	};
	var bo_c21 = function bo_c21(match, outcome) {
	    return "Jami kiritilgan penaltilar soni: " + match.awayTeam + " (penaltilar seriyasida)";
	};
	var bo_d21 = function bo_d21(match, outcome) {
	    return "Jami kiritilgan penaltilar soni: " + match.homeTeam + " (penaltilar seriyasida)";
	};
	var bo_e21 = function bo_e21(match, outcome) {
	    return 'Jami kiritilgan penaltilar soni (penaltilar seriyasida)';
	};
	var bo_f21 = function bo_f21(match, outcome) {
	    return 'Jami kiritilmagan penaltilar soni (penaltilar seriyasida)';
	};
	var bo_g21 = function bo_g21(match, outcome) {
	    return "Yevropacha fora  " + europeanHandicapCondition(outcome.condition);
	};
	var bo_h21 = function bo_h21(match, outcome) {
	    return "1-bo&apos;limda yevropacha fora  " + europeanHandicapCondition(outcome.condition);
	};
	var bo_i21 = function bo_i21(match, outcome) {
	    return "2-bo&apos;limda yevropacha fora  " + europeanHandicapCondition(outcome.condition);
	};
	var bo_j21 = function bo_j21(match, outcome) {
	    return "Birinchi bo&apos;limda kim " + numeralMaleEnding(outcome.condition) + " golni kiritadi?";
	};
	var bo_k21 = function bo_k21(match, outcome) {
	    return "O&apos;yinning qolgan vaqti (hozirgi hisob " + outcome.condition + ":" + outcome.conditionTwo + ")";
	};
	var bo_l21 = function bo_l21(match, outcome) {
	    return "Birinchi bo&apos;limning qolgan vaqti (hozirgi hisob " + outcome.condition + ":" + outcome.conditionTwo + ")";
	};
	var bo_m21 = function bo_m21(match, outcome) {
	    return match.homeTeam + " ning jami burchak zarbalari soni";
	};
	var bo_n21 = function bo_n21(match, outcome) {
	    return match.awayTeam + " ning jami burchak zarbalari soni";
	};
	var bo_o21 = function bo_o21(match, outcome) {
	    return match.homeTeam + " ning jami burchak to&apos;plari soni";
	};
	var bo_p21 = function bo_p21(match, outcome) {
	    return match.awayTeam + " ning jami burchak to&apos;plari soni";
	};
	var bo_q21 = function bo_q21(match, outcome) {
	    return 'Birinchi golning daqiqasi';
	};
	var bo_r21 = function bo_r21(match, outcome) {
	    return 'Birinchi bo&apos;lim ikkilangan natija';
	};
	var bo_s21 = function bo_s21(match, outcome) {
	    return 'Ikkinchi bo&apos;lim ikkilangan natija';
	};
	var bo_t21 = function bo_t21(match, outcome) {
	    return 'Ikkalasi gor uradimi?';
	};
	var bo_u21 = function bo_u21(match, outcome) {
	    return match.homeTeam + " ikkala bo&apos;limda ham g&apos;alaba qozonadi";
	};
	var bo_v21 = function bo_v21(match, outcome) {
	    return match.awayTeam + " ikkala bo&apos;limda ham g&apos;alaba qozonadi";
	};
	var bo_w21 = function bo_w21(match, outcome) {
	    return 'O&apos;yin hisobi jamisi';
	};
	var bo_x21 = function bo_x21(match, outcome) {
	    return 'Gollar vaqtlari yig&apos;indisi';
	};
	var bo_y21 = function bo_y21(match, outcome) {
	    return match.homeTeam + " g&apos;alaba qozonadi va to&apos;p o&apos;tqazmaydi";
	};
	var bo_z21 = function bo_z21(match, outcome) {
	    return match.awayTeam + " g&apos;alaba qozonadi va to&apos;p o&apos;tqazmaydi";
	};
	var bo_a22 = function bo_a22(match, outcome) {
	    return 'Ikkinchi bo&apos;lim jami hisobi';
	};
	var bo_b22 = function bo_b22(match, outcome) {
	    return 'Birinchi bo&apos;lim aniq jami hisobi';
	};
	var bo_c22 = function bo_c22(match, outcome) {
	    return 'Ikkinchi bo&apos;lim aniq jami hisobi';
	};
	var bo_d22 = function bo_d22(match, outcome) {
	    return "O&apos;yinning jami hisobi " + outcome.condition + " va g&apos;alaba";
	};
	var bo_e22 = function bo_e22(match, outcome) {
	    return match.homeTeam + " farq bilan birinchi bo&apos;limdagi g&apos;alabasi";
	};
	var bo_f22 = function bo_f22(match, outcome) {
	    return match.homeTeam + " farq bilan ikkinchi bo&apos;limdagi g&apos;alabasi";
	};
	var bo_g22 = function bo_g22(match, outcome) {
	    return match.awayTeam + " farq bilan birinchi bo&apos;limdagi g&apos;alabasi";
	};
	var bo_h22 = function bo_h22(match, outcome) {
	    return match.awayTeam + " farq bilan ikkinchi bo&apos;limdagi g&apos;alabasi";
	};
	var bo_i22 = function bo_i22(match, outcome) {
	    return "Kim birinchi bo&apos;lib " + outcome.condition + " ta " + plural(outcome.condition, ['gol', 'gol', 'gol']) + " kiritadi";
	};
	var bo_j22 = function bo_j22(match, outcome) {
	    return 'Ikkinchi bo&apos;limda fora';
	};
	var bo_k22 = function bo_k22(match, outcome) {
	    return 'Xet-triklar (jami hisobi)';
	};
	var bo_l22 = function bo_l22(match, outcome) {
	    return 'O&apos;yin jami hisobi jami hisobi juft/toq';
	};
	var bo_m22 = function bo_m22(match, outcome) {
	    return match.homeTeam + " g&apos;alaba qozonadi va o&apos;tkazib yubormaydi";
	};
	var bo_n22 = function bo_n22(match, outcome) {
	    return match.awayTeam + " g&apos;alaba qozonadi va o&apos;tkazib yubormaydi";
	};
	var bo_o22 = function bo_o22(match, outcome) {
	    return 'Birinchi davr aniq jami hisobi';
	};
	var bo_p22 = function bo_p22(match, outcome) {
	    return 'Ikkinchi davr aniq jami hisobi';
	};
	var bo_q22 = function bo_q22(match, outcome) {
	    return 'Uchinchi davr aniq jami hisobi';
	};
	var bo_r22 = function bo_r22(match, outcome) {
	    return "Nechta jamoa  " + outcome.condition + " ta " + plural(outcome.condition, ['gol', 'gol', 'gol']) + " kiritadi";
	};
	var bo_s22 = function bo_s22(match, outcome) {
	    return match.homeTeam + " aniq " + outcome.condition + " ta " + plural(outcome.condition, ['gol', 'gol', 'gol']) + " bilan g&apos;alaba qozonadi";
	};
	var bo_t22 = function bo_t22(match, outcome) {
	    return match.awayTeam + " aniq " + outcome.condition + " ta " + plural(outcome.condition, ['gol', 'gol', 'gol']) + " bilan g&apos;alaba qozonadi";
	};
	var bo_u22 = function bo_u22(match, outcome) {
	    return "Nechta jamoa " + outcome.condition + " ta " + plural(outcome.condition, ['gol', 'gol', 'gol']) + " kiritadi";
	};
	var bo_v22 = function bo_v22(match, outcome) {
	    return 'Eng sermahsul jamoa (uning jami hisobi)';
	};
	var bo_w22 = function bo_w22(match, outcome) {
	    return 'Eng sermahsul bo&apos;lmagan jamoa (uning jami hisobi)';
	};
	var bo_x22 = function bo_x22(match, outcome) {
	    return 'Birinchi davr juft/toq';
	};
	var bo_y22 = function bo_y22(match, outcome) {
	    return 'Ikkinchi davr juft/toq';
	};
	var bo_z22 = function bo_z22(match, outcome) {
	    return 'Uchinchi davr juft/toq';
	};
	var bo_a23 = function bo_a23(match, outcome) {
	    return 'Eng sermahsul davr (jami hisob)';
	};
	var bo_b23 = function bo_b23(match, outcome) {
	    return 'Eng sermahsul bo&apos;lmagan davr (jami hisob)';
	};
	var bo_c23 = function bo_c23(match, outcome) {
	    return 'Birinchi davrning aniq jami hisobi';
	};
	var bo_d23 = function bo_d23(match, outcome) {
	    return 'Ikkinchi davrning aniq jami hisobi';
	};
	var bo_e23 = function bo_e23(match, outcome) {
	    return 'Uchinchi davrning aniq jami hisobi';
	};
	var bo_f23 = function bo_f23(match, outcome) {
	    return match.homeTeam + " ning birinchi davrdagi jami hisobi";
	};
	var bo_g23 = function bo_g23(match, outcome) {
	    return match.homeTeam + " ning ikkinchi davrdagi jami hisobi";
	};
	var bo_h23 = function bo_h23(match, outcome) {
	    return match.homeTeam + " ning uchinchi davrdagi jami hisobi";
	};
	var bo_i23 = function bo_i23(match, outcome) {
	    return match.awayTeam + " ning birinchi davrdagi jami hisobi";
	};
	var bo_j23 = function bo_j23(match, outcome) {
	    return match.awayTeam + " ning ikkinchi davrdagi jami hisobi";
	};
	var bo_k23 = function bo_k23(match, outcome) {
	    return match.awayTeam + " ning uchinchi davrdagi jami hisobi";
	};
	var bo_l23 = function bo_l23(match, outcome) {
	    return "G&apos;alaba va o&apos;yinning aniq hisobi " + outcome.condition;
	};
	var bo_m23 = function bo_m23(match, outcome) {
	    return 'Overtime bo&apos;lidimi';
	};
	var bo_n23 = function bo_n23(match, outcome) {
	    return 'Ikkala jamoa ham gol uradi';
	};
	var bo_o23 = function bo_o23(match, outcome) {
	    return match.homeTeam + " " + numeralMaleEnding(outcome.condition) + "-bullitni kiritadimi?";
	};
	var bo_p23 = function bo_p23(match, outcome) {
	    return match.awayTeam + " " + numeralMaleEnding(outcome.condition) + "-bullitni kiritadimi?";
	};
	var bo_q23 = function bo_q23(match, outcome) {
	    return 'OT ni hisobga olgandagi g&apos;alaba';
	};
	var bo_r23 = function bo_r23(match, outcome) {
	    return 'Davr-O&apos;yin';
	};
	var bo_s23 = function bo_s23(match, outcome) {
	    return match.homeTeam + " har bir davrda gol uradi";
	};
	var bo_t23 = function bo_t23(match, outcome) {
	    return match.awayTeam + " har bir davrda gol uradi";
	};
	var bo_u23 = function bo_u23(match, outcome) {
	    return 'Har bir davrda gol uriladi';
	};
	var bo_v23 = function bo_v23(match, outcome) {
	    return 'Birinchi va ikkinchi davrni taqqoslash';
	};
	var bo_w23 = function bo_w23(match, outcome) {
	    return 'Birinchi va uchinchi davrni taqqoslash';
	};
	var bo_x23 = function bo_x23(match, outcome) {
	    return 'Uchinchi va ikkinchi davrni taqqoslash';
	};
	var bo_y23 = function bo_y23(match, outcome) {
	    return match.homeTeam + " davrlarning birida g&apos;alaba qozonadi";
	};
	var bo_z23 = function bo_z23(match, outcome) {
	    return match.awayTeam + " davrlarning birida g&apos;alaba qozonadi";
	};
	var bo_a24 = function bo_a24(match, outcome) {
	    return 'Hech bo&apos;lmaganda bitta davrda durrang';
	};
	var bo_b24 = function bo_b24(match, outcome) {
	    return 'O&apos;yinning 1 dan 10-daqiqasigacha g&apos;alaba';
	};
	var bo_c24 = function bo_c24(match, outcome) {
	    return 'O&apos;yinning 11 dan 20-daqiqasigacha g&apos;alaba';
	};
	var bo_d24 = function bo_d24(match, outcome) {
	    return 'O&apos;yinning 21 dan 30-daqiqasigacha g&apos;alaba';
	};
	var bo_e24 = function bo_e24(match, outcome) {
	    return 'O&apos;yinning 31 dan 40-daqiqasigacha g&apos;alaba';
	};
	var bo_f24 = function bo_f24(match, outcome) {
	    return 'O&apos;yinning 41 dan 50-daqiqasigacha g&apos;alaba';
	};
	var bo_g24 = function bo_g24(match, outcome) {
	    return 'O&apos;yinning 51 dan 60-daqiqasigacha g&apos;alaba';
	};
	var bo_h24 = function bo_h24(match, outcome) {
	    return 'O&apos;yinning 1 dan 10-daqiqasigacha fora';
	};
	var bo_i24 = function bo_i24(match, outcome) {
	    return 'O&apos;yinning 11 dan 20-daqiqasigacha fora';
	};
	var bo_j24 = function bo_j24(match, outcome) {
	    return 'O&apos;yinning 21 dan 30-daqiqasigacha fora';
	};
	var bo_k24 = function bo_k24(match, outcome) {
	    return 'O&apos;yinning 31 dan 40-daqiqasigacha fora';
	};
	var bo_l24 = function bo_l24(match, outcome) {
	    return 'O&apos;yinning 41 dan 50-daqiqasigacha fora';
	};
	var bo_m24 = function bo_m24(match, outcome) {
	    return 'O&apos;yinning 51 dan 60-daqiqasigacha fora';
	};
	var bo_n24 = function bo_n24(match, outcome) {
	    return 'O&apos;yinning 1 dan 10-daqiqasigacha jami hisob';
	};
	var bo_o24 = function bo_o24(match, outcome) {
	    return 'O&apos;yinning 11 dan 20-daqiqasigacha jami hisob';
	};
	var bo_p24 = function bo_p24(match, outcome) {
	    return 'O&apos;yinning 21 dan 30-daqiqasigacha jami hisob';
	};
	var bo_q24 = function bo_q24(match, outcome) {
	    return 'O&apos;yinning 31 dan 40-daqiqasigacha jami hisob';
	};
	var bo_r24 = function bo_r24(match, outcome) {
	    return 'O&apos;yinning 41 dan 50-daqiqasigacha jami hisob';
	};
	var bo_s24 = function bo_s24(match, outcome) {
	    return 'O&apos;yinning 51 dan 60-daqiqasigacha jami hisob';
	};
	var bo_t24 = function bo_t24(match, outcome) {
	    return 'Nechta jamoa birinchi davrda gol uradi?';
	};
	var bo_u24 = function bo_u24(match, outcome) {
	    return 'Nechta jamoa ikkinchi davrda gol uradi?';
	};
	var bo_v24 = function bo_v24(match, outcome) {
	    return 'Nechta jamoa uchinchi davrda gol uradi?';
	};
	var bo_w24 = function bo_w24(match, outcome) {
	    return match.homeTeam + " irodali g&apos;alaba qozonadi";
	};
	var bo_x24 = function bo_x24(match, outcome) {
	    return match.awayTeam + " irodali g&apos;alaba qozonadi";
	};
	var bo_y24 = function bo_y24(match, outcome) {
	    return 'Tushgan eng katta shar juft/toq';
	};
	var bo_z24 = function bo_z24(match, outcome) {
	    return 'Tushgan eng kichik shar juft/toq';
	};
	var bo_a25 = function bo_a25(match, outcome) {
	    return 'Tushgan birinchi shar juft/toq';
	};
	var bo_b25 = function bo_b25(match, outcome) {
	    return 'Tushgan oxirgi shar juft/toq';
	};
	var bo_c25 = function bo_c25(match, outcome) {
	    return 'Birinchisi oxirgisidan kichik/katta';
	};
	var bo_d25 = function bo_d25(match, outcome) {
	    return 'Barcha sharlat juft';
	};
	var bo_e25 = function bo_e25(match, outcome) {
	    return 'Barcha sharlat toq';
	};
	var bo_f25 = function bo_f25(match, outcome) {
	    return 'Hech bo&apos;lmaganda ikkita shar qo&apos;shni raqamlar';
	};
	var bo_g25 = function bo_g25(match, outcome) {
	    return 'Tushgan eng kichik shar';
	};
	var bo_h25 = function bo_h25(match, outcome) {
	    return 'Tushgan eng katta shar';
	};
	var bo_i25 = function bo_i25(match, outcome) {
	    return 'Tushgan jami sharlar yig&apos;indisi';
	};
	var bo_j25 = function bo_j25(match, outcome) {
	    return "Hech bo&apos;lmaganda bitta shar karrali " + outcome.condition;
	};
	var bo_k25 = function bo_k25(match, outcome) {
	    return 'Eng kichik va eng katta sharlar farqi';
	};
	var bo_l25 = function bo_l25(match, outcome) {
	    return 'Toq sharlar yig&apos;indisi';
	};
	var bo_m25 = function bo_m25(match, outcome) {
	    return 'Juft sharlar yig&apos;indisi';
	};
	var bo_n25 = function bo_n25(match, outcome) {
	    return 'Birinchi tushgan shar';
	};
	var bo_o25 = function bo_o25(match, outcome) {
	    return 'Ikkinchi tushgan shar';
	};
	var bo_p25 = function bo_p25(match, outcome) {
	    return 'Uchinchi tushgan shar';
	};
	var bo_q25 = function bo_q25(match, outcome) {
	    return 'To&apos;rtinchi tushgan shar';
	};
	var bo_r25 = function bo_r25(match, outcome) {
	    return 'Beshinchi tushgan shar';
	};
	var bo_s25 = function bo_s25(match, outcome) {
	    return 'Oltinchi tushgan shar';
	};
	var bo_t25 = function bo_t25(match, outcome) {
	    return 'Yettinchi tushgan shar';
	};
	var bo_u25 = function bo_u25(match, outcome) {
	    return "Hech bo&apos;lmaganda bitta shar " + outcome.condition + " dan " + outcome.conditionTwo + " gacha oraliqda tushadi";
	};
	var bo_v25 = function bo_v25(match, outcome) {
	    return 'Eng katta va eng kichik sharlar yig&apos;indisi';
	};
	var bo_w25 = function bo_w25(match, outcome) {
	    return 'Match Total';
	};
	var bo_x25 = function bo_x25(match, outcome) {
	    return 'Round Betting';
	};
	var bo_y25 = function bo_y25(match, outcome) {
	    return 'Will Fight Go The Distance?';
	};
	var bo_z25 = function bo_z25(match, outcome) {
	    return match.homeTeam + " to win by Submission";
	};
	var bo_a26 = function bo_a26(match, outcome) {
	    return match.awayTeam + " to win by Submission";
	};
	var bo_b26 = function bo_b26(match, outcome) {
	    return match.homeTeam + " to win by KO/TKO/DQ";
	};
	var bo_c26 = function bo_c26(match, outcome) {
	    return match.awayTeam + " to win by KO/TKO/DQ";
	};
	var bo_d26 = function bo_d26(match, outcome) {
	    return 'Jami medallar soni';
	};
	var bo_e26 = function bo_e26(match, outcome) {
	    return 'Yigirma to&apos;qqizinchi partiya natijasi';
	};
	var bo_f26 = function bo_f26(match, outcome) {
	    return 'O&apos;ttizinchi partiya natijasi';
	};
	var bo_g26 = function bo_g26(match, outcome) {
	    return 'O&apos;ttiz birinchi partiya natijasi';
	};
	var bo_h26 = function bo_h26(match, outcome) {
	    return 'O&apos;ttiz ikkinchi partiya natijasi';
	};
	var bo_i26 = function bo_i26(match, outcome) {
	    return 'O&apos;ttiz uchinchi partiya natijasi';
	};
	var bo_j26 = function bo_j26(match, outcome) {
	    return 'O&apos;ttiz to&apos;rtinchi partiya natijasi';
	};
	var bo_k26 = function bo_k26(match, outcome) {
	    return 'O&apos;ttiz beshinchi partiya natijasi';
	};
	var bo_l26 = function bo_l26(match, outcome) {
	    return 'O&apos;ttiz oltinchi partiya natijasi';
	};
	var bo_m26 = function bo_m26(match, outcome) {
	    return 'O&apos;ttiz yettinchi partiya natijasi';
	};
	var bo_n26 = function bo_n26(match, outcome) {
	    return 'O&apos;n sakkizinchi partiya juft/toq';
	};
	var bo_o26 = function bo_o26(match, outcome) {
	    return 'O&apos;n to&apos;qqizinchi partiya juft/toq';
	};
	var bo_p26 = function bo_p26(match, outcome) {
	    return 'Yigirmanchi partiya juft/toq';
	};
	var bo_q26 = function bo_q26(match, outcome) {
	    return 'Yigirma birinchi partiya juft/toq';
	};
	var bo_r26 = function bo_r26(match, outcome) {
	    return 'Yigirma ikkinchi partiya juft/toq';
	};
	var bo_s26 = function bo_s26(match, outcome) {
	    return 'Yigirma uchinchi partiya juft/toq';
	};
	var bo_t26 = function bo_t26(match, outcome) {
	    return 'Yigirma to&apos;rtinchi partiya juft/toq';
	};
	var bo_u26 = function bo_u26(match, outcome) {
	    return 'Yigirma beshinchi partiya juft/toq';
	};
	var bo_v26 = function bo_v26(match, outcome) {
	    return 'Yigirma oltinchi partiya juft/toq';
	};
	var bo_w26 = function bo_w26(match, outcome) {
	    return 'Yigirma yettinchi partiya juft/toq';
	};
	var bo_x26 = function bo_x26(match, outcome) {
	    return 'Yigirma sakkizinchi partiya juft/toq';
	};
	var bo_y26 = function bo_y26(match, outcome) {
	    return 'Yigirma to&apos;qqizinchi partiya juft/toq';
	};
	var bo_z26 = function bo_z26(match, outcome) {
	    return 'O&apos;ttizinchi partiya juft/toq';
	};
	var bo_a27 = function bo_a27(match, outcome) {
	    return 'O&apos;ttiz birinchi partiya juft/toq';
	};
	var bo_b27 = function bo_b27(match, outcome) {
	    return 'O&apos;ttiz ikkinchi partiya juft/toq';
	};
	var bo_c27 = function bo_c27(match, outcome) {
	    return 'O&apos;ttiz uchinchi partiya juft/toq';
	};
	var bo_d27 = function bo_d27(match, outcome) {
	    return 'O&apos;ttiz to&apos;rtinchi partiya juft/toq';
	};
	var bo_e27 = function bo_e27(match, outcome) {
	    return 'O&apos;ttiz beshinchi partiya juft/toq';
	};
	var bo_f27 = function bo_f27(match, outcome) {
	    return 'O&apos;ttiz oltinchi partiya juft/toq';
	};
	var bo_g27 = function bo_g27(match, outcome) {
	    return 'O&apos;ttiz yettinchi partiya juft/toq';
	};
	var bo_h27 = function bo_h27(match, outcome) {
	    return 'Birinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_i27 = function bo_i27(match, outcome) {
	    return 'Ikkinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_j27 = function bo_j27(match, outcome) {
	    return 'Uchinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_k27 = function bo_k27(match, outcome) {
	    return 'To&apos;rtinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_l27 = function bo_l27(match, outcome) {
	    return 'Beshinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_m27 = function bo_m27(match, outcome) {
	    return 'Oltinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_n27 = function bo_n27(match, outcome) {
	    return 'Yettinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_o27 = function bo_o27(match, outcome) {
	    return 'Sakkizinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_p27 = function bo_p27(match, outcome) {
	    return 'To&apos;qqizinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_q27 = function bo_q27(match, outcome) {
	    return 'O&apos;ninchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_r27 = function bo_r27(match, outcome) {
	    return 'O&apos;n birinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_s27 = function bo_s27(match, outcome) {
	    return 'O&apos;n ikkinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_t27 = function bo_t27(match, outcome) {
	    return 'O&apos;n uchinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_u27 = function bo_u27(match, outcome) {
	    return 'O&apos;n to&apos;rtinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_v27 = function bo_v27(match, outcome) {
	    return 'O&apos;n beshinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_w27 = function bo_w27(match, outcome) {
	    return 'O&apos;n oltinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_x27 = function bo_x27(match, outcome) {
	    return 'O&apos;n yettinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_y27 = function bo_y27(match, outcome) {
	    return 'O&apos;n sakkizinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_z27 = function bo_z27(match, outcome) {
	    return 'O&apos;n to&apos;qqizinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_a28 = function bo_a28(match, outcome) {
	    return 'Yigirmanchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_b28 = function bo_b28(match, outcome) {
	    return 'Yigirma birinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_c28 = function bo_c28(match, outcome) {
	    return 'Yigirma ikkinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_d28 = function bo_d28(match, outcome) {
	    return 'Yigirma uchinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_e28 = function bo_e28(match, outcome) {
	    return 'Yigirma to&apos;rtinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_f28 = function bo_f28(match, outcome) {
	    return 'Yigirma beshinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_g28 = function bo_g28(match, outcome) {
	    return 'Yigirma oltinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_h28 = function bo_h28(match, outcome) {
	    return 'Yigirma yettinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_i28 = function bo_i28(match, outcome) {
	    return 'Yigirma sakkizinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_j28 = function bo_j28(match, outcome) {
	    return 'Yigirma to&apos;qqizinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_k28 = function bo_k28(match, outcome) {
	    return 'O&apos;ttizinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_l28 = function bo_l28(match, outcome) {
	    return 'O&apos;ttiz birinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_m28 = function bo_m28(match, outcome) {
	    return 'O&apos;ttiz ikkinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_n28 = function bo_n28(match, outcome) {
	    return 'O&apos;ttiz uchinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_o28 = function bo_o28(match, outcome) {
	    return 'O&apos;ttiz to&apos;rtinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_p28 = function bo_p28(match, outcome) {
	    return 'O&apos;ttiz beshinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_q28 = function bo_q28(match, outcome) {
	    return 'O&apos;ttiz oltinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_r28 = function bo_r28(match, outcome) {
	    return 'O&apos;ttiz yettinchi partiyada qanaqa rangli shar birinchi bo&apos;lib savatga tushiriladi?';
	};
	var bo_s28 = function bo_s28(match, outcome) {
	    return 'Birinchi partiya natijasi';
	};
	var bo_t28 = function bo_t28(match, outcome) {
	    return 'Ikkinchi partiya natijasi';
	};
	var bo_u28 = function bo_u28(match, outcome) {
	    return 'Uchinchi partiya natijasi';
	};
	var bo_v28 = function bo_v28(match, outcome) {
	    return 'To&apos;rtinchi partiya natijasi';
	};
	var bo_w28 = function bo_w28(match, outcome) {
	    return 'Beshinchi partiya natijasi';
	};
	var bo_x28 = function bo_x28(match, outcome) {
	    return 'Oltinchi partiya natijasi';
	};
	var bo_y28 = function bo_y28(match, outcome) {
	    return 'Yettinchi partiya natijasi';
	};
	var bo_z28 = function bo_z28(match, outcome) {
	    return 'Sakkizinchi partiya natijasi';
	};
	var bo_a29 = function bo_a29(match, outcome) {
	    return 'To&apos;qqizinchi partiya natijasi';
	};
	var bo_b29 = function bo_b29(match, outcome) {
	    return 'O&apos;ninchi partiya natijasi';
	};
	var bo_c29 = function bo_c29(match, outcome) {
	    return 'O&apos;n birinchi partiya natijasi';
	};
	var bo_d29 = function bo_d29(match, outcome) {
	    return 'O&apos;n ikkinchi partiya natijasi';
	};
	var bo_e29 = function bo_e29(match, outcome) {
	    return 'O&apos;n uchinchi partiya natijasi';
	};
	var bo_f29 = function bo_f29(match, outcome) {
	    return 'O&apos;n to&apos;rtinchi partiya natijasi';
	};
	var bo_g29 = function bo_g29(match, outcome) {
	    return 'O&apos;n beshinchi partiya natijasi';
	};
	var bo_h29 = function bo_h29(match, outcome) {
	    return 'O&apos;n oltinchi partiya natijasi';
	};
	var bo_i29 = function bo_i29(match, outcome) {
	    return 'O&apos;n yettinchi partiya natijasi';
	};
	var bo_j29 = function bo_j29(match, outcome) {
	    return 'O&apos;n sakkizinchi partiya natijasi';
	};
	var bo_k29 = function bo_k29(match, outcome) {
	    return 'O&apos;n to&apos;qqizinchi partiya natijasi';
	};
	var bo_l29 = function bo_l29(match, outcome) {
	    return 'Yigirmanchi partiya natijasi';
	};
	var bo_m29 = function bo_m29(match, outcome) {
	    return 'Yigirma birinchi partiya natijasi';
	};
	var bo_n29 = function bo_n29(match, outcome) {
	    return 'Yigirma ikkinchi partiya natijasi';
	};
	var bo_o29 = function bo_o29(match, outcome) {
	    return 'Yigirma uchinchi partiya natijasi';
	};
	var bo_p29 = function bo_p29(match, outcome) {
	    return 'Yigirma to&apos;rtinchi partiya natijasi';
	};
	var bo_q29 = function bo_q29(match, outcome) {
	    return 'Yigirma beshinchi partiya natijasi';
	};
	var bo_r29 = function bo_r29(match, outcome) {
	    return 'Yigirma oltinchi partiya natijasi';
	};
	var bo_s29 = function bo_s29(match, outcome) {
	    return 'Yigirma yettinchi partiya natijasi';
	};
	var bo_t29 = function bo_t29(match, outcome) {
	    return 'Yigirma sakkizinchi partiya natijasi';
	};
	var bo_u29 = function bo_u29(match, outcome) {
	    return 'Kim yettinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_v29 = function bo_v29(match, outcome) {
	    return 'Kim sakkizinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_w29 = function bo_w29(match, outcome) {
	    return 'Kim to&apos;qqizinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_x29 = function bo_x29(match, outcome) {
	    return 'Kim o&apos;ninchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_y29 = function bo_y29(match, outcome) {
	    return 'Kim o&apos;n birinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_z29 = function bo_z29(match, outcome) {
	    return 'Kim o&apos;n ikkinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_a30 = function bo_a30(match, outcome) {
	    return 'Kim o&apos;n uchinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_b30 = function bo_b30(match, outcome) {
	    return 'Kim o&apos;n to&apos;rtinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_c30 = function bo_c30(match, outcome) {
	    return 'Kim o&apos;n beshinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_d30 = function bo_d30(match, outcome) {
	    return 'Kim o&apos;n oltinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_e30 = function bo_e30(match, outcome) {
	    return 'Kim o&apos;n yettinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_f30 = function bo_f30(match, outcome) {
	    return 'Kim o&apos;n sakkizinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_g30 = function bo_g30(match, outcome) {
	    return 'Kim o&apos;n to&apos;qqizinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_h30 = function bo_h30(match, outcome) {
	    return 'Kim yigirmanchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_i30 = function bo_i30(match, outcome) {
	    return 'Kim yigirma birinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_j30 = function bo_j30(match, outcome) {
	    return 'Kim yigirma ikkinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_k30 = function bo_k30(match, outcome) {
	    return 'Kim yigirma uchinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_l30 = function bo_l30(match, outcome) {
	    return 'Kim yigirma to&apos;rtinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_m30 = function bo_m30(match, outcome) {
	    return 'Kim yigirma beshinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_n30 = function bo_n30(match, outcome) {
	    return 'Kim yigirma oltinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_o30 = function bo_o30(match, outcome) {
	    return 'Kim yigirma yettinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_p30 = function bo_p30(match, outcome) {
	    return 'Kim yigirma sakkizinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_q30 = function bo_q30(match, outcome) {
	    return 'Kim yigirma to&apos;qqizinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_r30 = function bo_r30(match, outcome) {
	    return 'Kim o&apos;ttizinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_s30 = function bo_s30(match, outcome) {
	    return 'Kim o&apos;ttiz birinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_t30 = function bo_t30(match, outcome) {
	    return 'Kim o&apos;ttiz ikkinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_u30 = function bo_u30(match, outcome) {
	    return 'Kim o&apos;ttiz uchinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_v30 = function bo_v30(match, outcome) {
	    return 'Kim o&apos;ttiz to&apos;rtinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_w30 = function bo_w30(match, outcome) {
	    return 'Kim o&apos;ttiz beshinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_x30 = function bo_x30(match, outcome) {
	    return 'Kim o&apos;ttiz oltinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_y30 = function bo_y30(match, outcome) {
	    return 'Kim o&apos;ttiz yettinchi partiyada birinchi bo&apos;lib savatchaga sharni tushiradi?';
	};
	var bo_z30 = function bo_z30(match, outcome) {
	    return "Kim birinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_a31 = function bo_a31(match, outcome) {
	    return "Kim ikkinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_b31 = function bo_b31(match, outcome) {
	    return "Kim uchinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_c31 = function bo_c31(match, outcome) {
	    return "Kim to&apos;rtinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_d31 = function bo_d31(match, outcome) {
	    return "Kim beshinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_e31 = function bo_e31(match, outcome) {
	    return "Kim oltinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_f31 = function bo_f31(match, outcome) {
	    return "Kim yettinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_g31 = function bo_g31(match, outcome) {
	    return "Kim sakkizinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_h31 = function bo_h31(match, outcome) {
	    return "Kim to&apos;qqizinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_i31 = function bo_i31(match, outcome) {
	    return "Kim o&apos;ninchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_j31 = function bo_j31(match, outcome) {
	    return "Kim o&apos;n birinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_k31 = function bo_k31(match, outcome) {
	    return "Kim o&apos;n ikkinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_l31 = function bo_l31(match, outcome) {
	    return "Kim o&apos;n uchinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_m31 = function bo_m31(match, outcome) {
	    return "Kim o&apos;n to&apos;rtinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_n31 = function bo_n31(match, outcome) {
	    return "Kim o&apos;n beshinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_o31 = function bo_o31(match, outcome) {
	    return "Kim o&apos;n oltinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_p31 = function bo_p31(match, outcome) {
	    return "Kim o&apos;n yettinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_q31 = function bo_q31(match, outcome) {
	    return "Kim o&apos;n sakkizinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_r31 = function bo_r31(match, outcome) {
	    return "Kim o&apos;n to&apos;qqizinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_s31 = function bo_s31(match, outcome) {
	    return "Kim yigirmanchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_t31 = function bo_t31(match, outcome) {
	    return "Kim yigirma birinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_u31 = function bo_u31(match, outcome) {
	    return "Kim yigirma ikkinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_v31 = function bo_v31(match, outcome) {
	    return "Kim yigirma uchinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_w31 = function bo_w31(match, outcome) {
	    return "Kim yigirma to&apos;rtinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_x31 = function bo_x31(match, outcome) {
	    return "Kim yigirma beshinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_y31 = function bo_y31(match, outcome) {
	    return "Kim yigirma oltinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_z31 = function bo_z31(match, outcome) {
	    return "Kim yigirma yettinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_a32 = function bo_a32(match, outcome) {
	    return "Kim yigirma sakkizinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_b32 = function bo_b32(match, outcome) {
	    return "Kim yigirma to&apos;qqizinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_c32 = function bo_c32(match, outcome) {
	    return "Kim o&apos;ttizinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_d32 = function bo_d32(match, outcome) {
	    return "Kim o&apos;ttiz birinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_e32 = function bo_e32(match, outcome) {
	    return "Kim o&apos;ttiz ikkinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_f32 = function bo_f32(match, outcome) {
	    return "Kim o&apos;ttiz uchinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_g32 = function bo_g32(match, outcome) {
	    return "Kim o&apos;ttiz to&apos;rtinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_h32 = function bo_h32(match, outcome) {
	    return "Kim o&apos;ttiz beshinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_i32 = function bo_i32(match, outcome) {
	    return "Kim o&apos;ttiz oltinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_j32 = function bo_j32(match, outcome) {
	    return "Kim o&apos;ttiz yettinchi partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_k32 = function bo_k32(match, outcome) {
	    return 'Birinchi partiya juft/toq';
	};
	var bo_l32 = function bo_l32(match, outcome) {
	    return 'Ikkinchi partiya juft/toq';
	};
	var bo_m32 = function bo_m32(match, outcome) {
	    return 'Uchinchi partiya juft/toq';
	};
	var bo_n32 = function bo_n32(match, outcome) {
	    return 'To&apos;rtinchi partiya juft/toq';
	};
	var bo_o32 = function bo_o32(match, outcome) {
	    return 'Beshinchi partiya juft/toq';
	};
	var bo_p32 = function bo_p32(match, outcome) {
	    return 'Oltinchi partiya juft/toq';
	};
	var bo_q32 = function bo_q32(match, outcome) {
	    return 'Yettinchi partiya juft/toq';
	};
	var bo_r32 = function bo_r32(match, outcome) {
	    return 'Sakkizinchi partiya juft/toq';
	};
	var bo_s32 = function bo_s32(match, outcome) {
	    return 'To&apos;qqizinchi partiya juft/toq';
	};
	var bo_t32 = function bo_t32(match, outcome) {
	    return 'O&apos;ninchi partiya juft/toq';
	};
	var bo_u32 = function bo_u32(match, outcome) {
	    return 'O&apos;n birinchi partiya juft/toq';
	};
	var bo_v32 = function bo_v32(match, outcome) {
	    return 'O&apos;n ikkinchi partiya juft/toq';
	};
	var bo_w32 = function bo_w32(match, outcome) {
	    return 'O&apos;n uchinchi partiya juft/toq';
	};
	var bo_x32 = function bo_x32(match, outcome) {
	    return 'O&apos;n to&apos;rtinchi partiya juft/toq';
	};
	var bo_y32 = function bo_y32(match, outcome) {
	    return 'O&apos;n beshinchi partiya juft/toq';
	};
	var bo_z32 = function bo_z32(match, outcome) {
	    return 'O&apos;n oltinchi partiya juft/toq';
	};
	var bo_a33 = function bo_a33(match, outcome) {
	    return 'O&apos;n yettinchi partiya juft/toq';
	};
	var bo_b33 = function bo_b33(match, outcome) {
	    return 'O&apos;yindagi Asr breyklari jami hisobi';
	};
	var bo_c33 = function bo_c33(match, outcome) {
	    return 'Birinchi partiyadagi fora';
	};
	var bo_d33 = function bo_d33(match, outcome) {
	    return 'Ikkinchi partiyadagi fora';
	};
	var bo_e33 = function bo_e33(match, outcome) {
	    return 'Uchinchi partiyadagi fora';
	};
	var bo_f33 = function bo_f33(match, outcome) {
	    return 'To&apos;rtinchi partiyadagi fora';
	};
	var bo_g33 = function bo_g33(match, outcome) {
	    return 'Beshinchi partiyadagi fora';
	};
	var bo_h33 = function bo_h33(match, outcome) {
	    return 'Oltinchi partiyadagi fora';
	};
	var bo_i33 = function bo_i33(match, outcome) {
	    return 'Yettinchi partiyadagi fora';
	};
	var bo_j33 = function bo_j33(match, outcome) {
	    return 'Sakkizinchi partiyadagi fora';
	};
	var bo_k33 = function bo_k33(match, outcome) {
	    return 'To&apos;qqizinchi partiyadagi fora';
	};
	var bo_l33 = function bo_l33(match, outcome) {
	    return 'O&apos;ninchi partiyadagi fora';
	};
	var bo_m33 = function bo_m33(match, outcome) {
	    return 'O&apos;n birinchi partiyadagi fora';
	};
	var bo_n33 = function bo_n33(match, outcome) {
	    return 'O&apos;n ikkinchi partiyadagi fora';
	};
	var bo_o33 = function bo_o33(match, outcome) {
	    return 'O&apos;n uchinchi partiyadagi fora';
	};
	var bo_p33 = function bo_p33(match, outcome) {
	    return 'O&apos;n to&apos;rtinchi partiyadagi fora';
	};
	var bo_q33 = function bo_q33(match, outcome) {
	    return 'O&apos;n beshinchi partiyadagi fora';
	};
	var bo_r33 = function bo_r33(match, outcome) {
	    return 'O&apos;n oltinchi partiyadagi fora';
	};
	var bo_s33 = function bo_s33(match, outcome) {
	    return 'O&apos;n yettinchi partiyadagi fora';
	};
	var bo_t33 = function bo_t33(match, outcome) {
	    return 'O&apos;n sakkizinchi partiyadagi fora';
	};
	var bo_u33 = function bo_u33(match, outcome) {
	    return 'O&apos;n to&apos;qqizinchi partiyadagi fora';
	};
	var bo_v33 = function bo_v33(match, outcome) {
	    return 'Yigirmanchi partiyadagi fora';
	};
	var bo_w33 = function bo_w33(match, outcome) {
	    return 'Yigirma birinchi partiyadagi fora';
	};
	var bo_x33 = function bo_x33(match, outcome) {
	    return 'Yigirma ikkinchi partiyadagi fora';
	};
	var bo_y33 = function bo_y33(match, outcome) {
	    return 'Yigirma uchinchi partiyadagi fora';
	};
	var bo_z33 = function bo_z33(match, outcome) {
	    return 'Yigirma to&apos;rtinchi partiyadagi fora';
	};
	var bo_a34 = function bo_a34(match, outcome) {
	    return 'Yigirma beshinchi partiyadagi fora';
	};
	var bo_b34 = function bo_b34(match, outcome) {
	    return 'Yigirma oltinchi partiyadagi fora';
	};
	var bo_c34 = function bo_c34(match, outcome) {
	    return 'Yigirma yettinchi partiyadagi fora';
	};
	var bo_d34 = function bo_d34(match, outcome) {
	    return 'Yigirma sakkizinchi partiyadagi fora';
	};
	var bo_e34 = function bo_e34(match, outcome) {
	    return 'Yigirma to&apos;qqizinchi partiyadagi fora';
	};
	var bo_f34 = function bo_f34(match, outcome) {
	    return 'O&apos;ttizinchi partiyadagi fora';
	};
	var bo_g34 = function bo_g34(match, outcome) {
	    return 'O&apos;ttiz birinchi partiyadagi fora';
	};
	var bo_h34 = function bo_h34(match, outcome) {
	    return 'O&apos;ttiz ikkinchi partiyadagi fora';
	};
	var bo_i34 = function bo_i34(match, outcome) {
	    return 'O&apos;ttiz uchinchi partiyadagi fora';
	};
	var bo_j34 = function bo_j34(match, outcome) {
	    return 'O&apos;ttiz to&apos;rtinchi partiyadagi fora';
	};
	var bo_k34 = function bo_k34(match, outcome) {
	    return 'O&apos;ttiz beshinchi partiyadagi fora';
	};
	var bo_l34 = function bo_l34(match, outcome) {
	    return 'O&apos;ttiz oltinchi partiyadagi fora';
	};
	var bo_m34 = function bo_m34(match, outcome) {
	    return 'O&apos;ttiz yettinchi partiyadagi fora';
	};
	var bo_n34 = function bo_n34(match, outcome) {
	    return 'Birinchi partiya jami hisobi';
	};
	var bo_o34 = function bo_o34(match, outcome) {
	    return 'Ikkinchi partiya jami hisobi';
	};
	var bo_p34 = function bo_p34(match, outcome) {
	    return 'Uchinchi partiya jami hisobi';
	};
	var bo_q34 = function bo_q34(match, outcome) {
	    return 'To&apos;rtinchi partiya jami hisobi';
	};
	var bo_r34 = function bo_r34(match, outcome) {
	    return 'Beshinchi partiya jami hisobi';
	};
	var bo_s34 = function bo_s34(match, outcome) {
	    return 'Oltinchi partiya jami hisobi';
	};
	var bo_t34 = function bo_t34(match, outcome) {
	    return 'Yettinchi partiya jami hisobi';
	};
	var bo_u34 = function bo_u34(match, outcome) {
	    return 'Sakkizinchi partiya jami hisobi';
	};
	var bo_v34 = function bo_v34(match, outcome) {
	    return 'To&apos;qqizinchi partiya jami hisobi';
	};
	var bo_w34 = function bo_w34(match, outcome) {
	    return 'O&apos;ninchi partiya jami hisobi';
	};
	var bo_x34 = function bo_x34(match, outcome) {
	    return 'O&apos;n birinchi partiya jami hisobi';
	};
	var bo_y34 = function bo_y34(match, outcome) {
	    return 'O&apos;n ikkinchi partiya jami hisobi';
	};
	var bo_z34 = function bo_z34(match, outcome) {
	    return 'O&apos;n uchinchi partiya jami hisobi';
	};
	var bo_a35 = function bo_a35(match, outcome) {
	    return 'O&apos;n to&apos;rtinchi partiya jami hisobi';
	};
	var bo_b35 = function bo_b35(match, outcome) {
	    return 'O&apos;n beshinchi partiya jami hisobi';
	};
	var bo_c35 = function bo_c35(match, outcome) {
	    return 'O&apos;n oltinchi partiya jami hisobi';
	};
	var bo_d35 = function bo_d35(match, outcome) {
	    return 'O&apos;n yettinchi partiya jami hisobi';
	};
	var bo_e35 = function bo_e35(match, outcome) {
	    return 'O&apos;n sakkizinchi partiya jami hisobi';
	};
	var bo_f35 = function bo_f35(match, outcome) {
	    return 'O&apos;n to&apos;qqizinchi partiya jami hisobi';
	};
	var bo_g35 = function bo_g35(match, outcome) {
	    return 'Yigirmanchi partiya jami hisobi';
	};
	var bo_h35 = function bo_h35(match, outcome) {
	    return 'Yigirma birinchi partiya jami hisobi';
	};
	var bo_i35 = function bo_i35(match, outcome) {
	    return 'Yigirma ikkinchi partiya jami hisobi';
	};
	var bo_j35 = function bo_j35(match, outcome) {
	    return 'Yigirma uchinchi partiya jami hisobi';
	};
	var bo_k35 = function bo_k35(match, outcome) {
	    return 'Yigirma to&apos;rtinchi partiya jami hisobi';
	};
	var bo_l35 = function bo_l35(match, outcome) {
	    return 'Yigirma beshinchi partiya jami hisobi';
	};
	var bo_m35 = function bo_m35(match, outcome) {
	    return 'Yigirma oltinchi partiya jami hisobi';
	};
	var bo_n35 = function bo_n35(match, outcome) {
	    return 'Yigirma yettinchi partiya jami hisobi';
	};
	var bo_o35 = function bo_o35(match, outcome) {
	    return 'Yigirma sakkizinchi partiya jami hisobi';
	};
	var bo_p35 = function bo_p35(match, outcome) {
	    return 'Yigirma to&apos;qqizinchi partiya jami hisobi';
	};
	var bo_q35 = function bo_q35(match, outcome) {
	    return 'O&apos;ttizinchi partiya jami hisobi';
	};
	var bo_r35 = function bo_r35(match, outcome) {
	    return 'O&apos;ttiz birinchi partiya jami hisobi';
	};
	var bo_s35 = function bo_s35(match, outcome) {
	    return 'O&apos;ttiz ikkinchi partiya jami hisobi';
	};
	var bo_t35 = function bo_t35(match, outcome) {
	    return 'O&apos;ttiz uchinchi partiya jami hisobi';
	};
	var bo_u35 = function bo_u35(match, outcome) {
	    return 'O&apos;ttiz to&apos;rtinchi partiya jami hisobi';
	};
	var bo_v35 = function bo_v35(match, outcome) {
	    return 'O&apos;ttiz beshinchi partiya jami hisobi';
	};
	var bo_w35 = function bo_w35(match, outcome) {
	    return 'O&apos;ttiz oltinchi partiya jami hisobi';
	};
	var bo_x35 = function bo_x35(match, outcome) {
	    return 'O&apos;ttiz yettinchi partiya jami hisobi';
	};
	var bo_y35 = function bo_y35(match, outcome) {
	    return 'Kim birinchi partiyada birinchi bo&apos;lib sharni savatga tushiradi?';
	};
	var bo_z35 = function bo_z35(match, outcome) {
	    return 'Kim ikkinchi partiyada birinchi bo&apos;lib sharni savatga tushiradi?';
	};
	var bo_a36 = function bo_a36(match, outcome) {
	    return 'Kim uchinchi partiyada birinchi bo&apos;lib sharni savatga tushiradi?';
	};
	var bo_b36 = function bo_b36(match, outcome) {
	    return 'Kim to&apos;rtinchi partiyada birinchi bo&apos;lib sharni savatga tushiradi?';
	};
	var bo_c36 = function bo_c36(match, outcome) {
	    return 'Kim beshinchi partiyada birinchi bo&apos;lib sharni savatga tushiradi?';
	};
	var bo_d36 = function bo_d36(match, outcome) {
	    return 'Kim oltinchi partiyada birinchi bo&apos;lib sharni savatga tushiradi?';
	};
	var bo_e36 = function bo_e36(match, outcome) {
	    return 'Birinchi partiyadagi Fora';
	};
	var bo_f36 = function bo_f36(match, outcome) {
	    return 'Ikkinchi partiyadagi Fora';
	};
	var bo_g36 = function bo_g36(match, outcome) {
	    return 'Uchinchi partiyadagi Fora';
	};
	var bo_h36 = function bo_h36(match, outcome) {
	    return 'To&apos;rtinchi partiyadagi Fora';
	};
	var bo_i36 = function bo_i36(match, outcome) {
	    return 'Beshinchi partiyadagi Fora';
	};
	var bo_j36 = function bo_j36(match, outcome) {
	    return 'Oltinchi partiyadagi Fora';
	};
	var bo_k36 = function bo_k36(match, outcome) {
	    return 'Yettinchi partiyadagi Fora';
	};
	var bo_l36 = function bo_l36(match, outcome) {
	    return 'O&apos;yindagi jami partiyalar soni';
	};
	var bo_m36 = function bo_m36(match, outcome) {
	    return match.homeTeam + " ning birinchi partiyadagi jami hisobi";
	};
	var bo_n36 = function bo_n36(match, outcome) {
	    return match.homeTeam + " ning ikkinchi partiyadagi jami hisobi";
	};
	var bo_o36 = function bo_o36(match, outcome) {
	    return match.homeTeam + " ning uchinchi partiyadagi jami hisobi";
	};
	var bo_p36 = function bo_p36(match, outcome) {
	    return match.homeTeam + " ning to&apos;rtinchi partiyadagi jami hisobi";
	};
	var bo_q36 = function bo_q36(match, outcome) {
	    return match.homeTeam + " ning beshinchi partiyadagi jami hisobi";
	};
	var bo_r36 = function bo_r36(match, outcome) {
	    return match.homeTeam + " ning oltinchi partiyadagi jami hisobi";
	};
	var bo_s36 = function bo_s36(match, outcome) {
	    return match.homeTeam + " ning yettinchi partiyadagi jami hisobi";
	};
	var bo_t36 = function bo_t36(match, outcome) {
	    return match.awayTeam + " ning birinchi partiyadagi jami hisobi";
	};
	var bo_u36 = function bo_u36(match, outcome) {
	    return match.awayTeam + " ning ikkinchi partiyadagi jami hisobi";
	};
	var bo_v36 = function bo_v36(match, outcome) {
	    return match.awayTeam + " ning uchinchi partiyadagi jami hisobi";
	};
	var bo_w36 = function bo_w36(match, outcome) {
	    return match.awayTeam + " ning to&apos;rtinchi partiyadagi jami hisobi";
	};
	var bo_x36 = function bo_x36(match, outcome) {
	    return match.awayTeam + " ning beshinchi partiyadagi jami hisobi";
	};
	var bo_y36 = function bo_y36(match, outcome) {
	    return match.awayTeam + " ning oltinchi partiyadagi jami hisobi";
	};
	var bo_z36 = function bo_z36(match, outcome) {
	    return match.awayTeam + " ning yettinchi partiyadagi jami hisobi";
	};
	var bo_a37 = function bo_a37(match, outcome) {
	    return "Kim 1-partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_b37 = function bo_b37(match, outcome) {
	    return "Kim 2-partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_c37 = function bo_c37(match, outcome) {
	    return "Kim 3-partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_d37 = function bo_d37(match, outcome) {
	    return "Kim 4-partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_e37 = function bo_e37(match, outcome) {
	    return "Kim 5-partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_f37 = function bo_f37(match, outcome) {
	    return "Kim 6-partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_g37 = function bo_g37(match, outcome) {
	    return "Kim 7-partiyada birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_h37 = function bo_h37(match, outcome) {
	    return "Birinchi partiyada " + match.homeTeam + " aniq " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " bilan g&apos;alaba qozonadi";
	};
	var bo_i37 = function bo_i37(match, outcome) {
	    return "Ikkinchi partiyada " + match.homeTeam + " aniq " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " bilan g&apos;alaba qozonadi";
	};
	var bo_j37 = function bo_j37(match, outcome) {
	    return "Uchinchi partiyada " + match.homeTeam + " aniq " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " bilan g&apos;alaba qozonadi";
	};
	var bo_k37 = function bo_k37(match, outcome) {
	    return "To&apos;rtinchi partiyada " + match.homeTeam + " aniq " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " bilan g&apos;alaba qozonadi";
	};
	var bo_l37 = function bo_l37(match, outcome) {
	    return "Beshinchi partiyada " + match.homeTeam + " aniq " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " bilan g&apos;alaba qozonadi";
	};
	var bo_m37 = function bo_m37(match, outcome) {
	    return "Oltinchi partiyada " + match.homeTeam + " aniq " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " bilan g&apos;alaba qozonadi";
	};
	var bo_n37 = function bo_n37(match, outcome) {
	    return "Yettinchi partiyada " + match.homeTeam + " aniq " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " bilan g&apos;alaba qozonadi";
	};
	var bo_o37 = function bo_o37(match, outcome) {
	    return "Birinchi partiyada " + match.awayTeam + " aniq " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " bilan g&apos;alaba qozonadi";
	};
	var bo_p37 = function bo_p37(match, outcome) {
	    return "Ikkinchi partiyada " + match.awayTeam + " aniq " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " bilan g&apos;alaba qozonadi";
	};
	var bo_q37 = function bo_q37(match, outcome) {
	    return "Uchinchi partiyada " + match.awayTeam + " aniq " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " bilan g&apos;alaba qozonadi";
	};
	var bo_r37 = function bo_r37(match, outcome) {
	    return "To&apos;rtinchi partiyada " + match.awayTeam + " aniq " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " bilan g&apos;alaba qozonadi";
	};
	var bo_s37 = function bo_s37(match, outcome) {
	    return "Beshinchi partiyada " + match.awayTeam + " aniq " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " bilan g&apos;alaba qozonadi";
	};
	var bo_t37 = function bo_t37(match, outcome) {
	    return "Oltinchi partiyada " + match.awayTeam + " aniq " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " bilan g&apos;alaba qozonadi";
	};
	var bo_u37 = function bo_u37(match, outcome) {
	    return "Yettinchi partiyada " + match.awayTeam + " aniq " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " bilan g&apos;alaba qozonadi";
	};
	var bo_v37 = function bo_v37(match, outcome) {
	    return 'Birinchi partiya aniq jami hisobi';
	};
	var bo_w37 = function bo_w37(match, outcome) {
	    return 'Ikkinchi partiya aniq jami hisobi';
	};
	var bo_x37 = function bo_x37(match, outcome) {
	    return 'Uchinchi partiya aniq jami hisobi';
	};
	var bo_y37 = function bo_y37(match, outcome) {
	    return 'To&apos;rtinchi partiya aniq jami hisobi';
	};
	var bo_z37 = function bo_z37(match, outcome) {
	    return 'Beshinchi partiya aniq jami hisobi';
	};
	var bo_a38 = function bo_a38(match, outcome) {
	    return 'Oltinchi partiya aniq jami hisobi';
	};
	var bo_b38 = function bo_b38(match, outcome) {
	    return 'Yettinchi partiya aniq jami hisobi';
	};
	var bo_c38 = function bo_c38(match, outcome) {
	    return "Kim birinchi partiyada " + numeralNeuterEnding(outcome.condition) + " ochkoni yutadi";
	};
	var bo_d38 = function bo_d38(match, outcome) {
	    return "Kim ikkinchi partiyada " + numeralNeuterEnding(outcome.condition) + " ochkoni yutadi";
	};
	var bo_e38 = function bo_e38(match, outcome) {
	    return "Kim uchinchi partiyada " + numeralNeuterEnding(outcome.condition) + " ochkoni yutadi";
	};
	var bo_f38 = function bo_f38(match, outcome) {
	    return "Kim to&apos;rtinchi partiyada " + numeralNeuterEnding(outcome.condition) + " ochkoni yutadi";
	};
	var bo_g38 = function bo_g38(match, outcome) {
	    return "Kim beshinchi partiyada " + numeralNeuterEnding(outcome.condition) + " ochkoni yutadi";
	};
	var bo_h38 = function bo_h38(match, outcome) {
	    return "Kim oltinchi partiyada " + numeralNeuterEnding(outcome.condition) + " ochkoni yutadi";
	};
	var bo_i38 = function bo_i38(match, outcome) {
	    return "Kim yettinchi partiyada " + numeralNeuterEnding(outcome.condition) + " ochkoni yutadi";
	};
	var bo_j38 = function bo_j38(match, outcome) {
	    return 'Birinchi partiyada aniq jami hisob';
	};
	var bo_k38 = function bo_k38(match, outcome) {
	    return 'Ikkinchi partiyada aniq jami hisob';
	};
	var bo_l38 = function bo_l38(match, outcome) {
	    return 'Uchinchi partiyada aniq jami hisob';
	};
	var bo_m38 = function bo_m38(match, outcome) {
	    return 'To&apos;rtinchi partiyada aniq jami hisob';
	};
	var bo_n38 = function bo_n38(match, outcome) {
	    return 'Beshinchi partiyada aniq jami hisob';
	};
	var bo_o38 = function bo_o38(match, outcome) {
	    return 'Oltinchi partiyada aniq jami hisob';
	};
	var bo_p38 = function bo_p38(match, outcome) {
	    return 'Yettinchi partiyada aniq jami hisob';
	};
	var bo_q38 = function bo_q38(match, outcome) {
	    return 'Birinchi davr aniq jami hisobi juft/toq';
	};
	var bo_r38 = function bo_r38(match, outcome) {
	    return 'Ikkinchi davr aniq jami hisobi juft/toq';
	};
	var bo_s38 = function bo_s38(match, outcome) {
	    return 'Uchinchi davr aniq jami hisobi juft/toq';
	};
	var bo_t38 = function bo_t38(match, outcome) {
	    return 'To&apos;rtinchi davr aniq jami hisobi juft/toq';
	};
	var bo_u38 = function bo_u38(match, outcome) {
	    return 'Beshinchi davr aniq jami hisobi juft/toq';
	};
	var bo_v38 = function bo_v38(match, outcome) {
	    return 'Oltinchi davr aniq jami hisobi juft/toq';
	};
	var bo_w38 = function bo_w38(match, outcome) {
	    return 'Yettinchi davr aniq jami hisobi juft/toq';
	};
	var bo_x38 = function bo_x38(match, outcome) {
	    return 'O&apos;yinning aniq hisobi';
	};
	var bo_y38 = function bo_y38(match, outcome) {
	    return match.awayTeam + " 1 chi yoki 2 chi geymda breykni amalga oshiradi";
	};
	var bo_z38 = function bo_z38(match, outcome) {
	    return 'Tennischi tomonidan ketma-ket yutilgan geymlarning maksimal soni';
	};
	var bo_a39 = function bo_a39(match, outcome) {
	    return 'Breyklar bilan almashinadimi (ketma-ket ikki marta)?';
	};
	var bo_b39 = function bo_b39(match, outcome) {
	    return match.homeTeam + " ning to&apos;rtinchi setdagi jami hisobi";
	};
	var bo_c39 = function bo_c39(match, outcome) {
	    return match.homeTeam + " ning beshinchi setdagi jami hisobi";
	};
	var bo_d39 = function bo_d39(match, outcome) {
	    return match.awayTeam + " ning to&apos;rtinchi setdagi jami hisobi";
	};
	var bo_e39 = function bo_e39(match, outcome) {
	    return match.awayTeam + " ning beshinchi setdagi jami hisobi";
	};
	var bo_f39 = function bo_f39(match, outcome) {
	    return 'To&apos;rtinchi set juft/toq';
	};
	var bo_g39 = function bo_g39(match, outcome) {
	    return 'Beshinchi set juft/toq';
	};
	var bo_h39 = function bo_h39(match, outcome) {
	    return 'Birinchi set/o&apos;yin';
	};
	var bo_i39 = function bo_i39(match, outcome) {
	    return outcome.condition + "-geymda breyk point amalga oshadi";
	};
	var bo_j39 = function bo_j39(match, outcome) {
	    return 'Ikkinchi setdagi jami breyklar soni';
	};
	var bo_k39 = function bo_k39(match, outcome) {
	    return 'Uchinchi setdagi jami breyklar soni';
	};
	var bo_l39 = function bo_l39(match, outcome) {
	    return 'To&apos;rtinchi setdagi jami breyklar soni';
	};
	var bo_m39 = function bo_m39(match, outcome) {
	    return 'Beshinchi setdagi jami breyklar soni';
	};
	var bo_n39 = function bo_n39(match, outcome) {
	    return "G&apos;alaba va ikkinchi set jami hisobi " + outcome.condition;
	};
	var bo_o39 = function bo_o39(match, outcome) {
	    return "G&apos;alaba va uchinchi set jami hisobi " + outcome.condition;
	};
	var bo_p39 = function bo_p39(match, outcome) {
	    return "G&apos;alaba va to&apos;rtinchi set jami hisobi " + outcome.condition;
	};
	var bo_q39 = function bo_q39(match, outcome) {
	    return "G&apos;alaba va beshinchi set jami hisobi " + outcome.condition;
	};
	var bo_r39 = function bo_r39(match, outcome) {
	    return match.homeTeam + " birinchi setdagi jami breyklar soni";
	};
	var bo_s39 = function bo_s39(match, outcome) {
	    return match.homeTeam + " ikkinchi setdagi jami breyklar soni";
	};
	var bo_t39 = function bo_t39(match, outcome) {
	    return match.homeTeam + " uchinchi setdagi jami breyklar soni";
	};
	var bo_u39 = function bo_u39(match, outcome) {
	    return match.homeTeam + " to&apos;rtinchi setdagi jami breyklar soni";
	};
	var bo_v39 = function bo_v39(match, outcome) {
	    return match.homeTeam + " beshinchi setdagi jami breyklar soni";
	};
	var bo_w39 = function bo_w39(match, outcome) {
	    return match.awayTeam + " birinchi setdagi jami breyklar soni";
	};
	var bo_x39 = function bo_x39(match, outcome) {
	    return match.awayTeam + " ikkinchi setdagi jami breyklar soni";
	};
	var bo_y39 = function bo_y39(match, outcome) {
	    return match.awayTeam + " uchinchi setdagi jami breyklar soni";
	};
	var bo_z39 = function bo_z39(match, outcome) {
	    return match.awayTeam + " to&apos;rtinchi setdagi jami breyklar soni";
	};
	var bo_a40 = function bo_a40(match, outcome) {
	    return match.awayTeam + " beshinchi setdagi jami breyklar soni";
	};
	var bo_b40 = function bo_b40(match, outcome) {
	    return "Kimdir birinchi setda ketma-ket " + outcome.condition + " ta " + plural(outcome.condition, ['geym', 'geym', 'geym']) + " yutadimi?";
	};
	var bo_c40 = function bo_c40(match, outcome) {
	    return "Kimdir ikkinchi setda ketma-ket " + outcome.condition + " ta " + plural(outcome.condition, ['geym', 'geym', 'geym']) + " yutadimi?";
	};
	var bo_d40 = function bo_d40(match, outcome) {
	    return "Kimdir uchinchi setda ketma-ket " + outcome.condition + " ta " + plural(outcome.condition, ['geym', 'geym', 'geym']) + " yutadimi?";
	};
	var bo_e40 = function bo_e40(match, outcome) {
	    return "Kimdir to&apos;rtinchi setda ketma-ket " + outcome.condition + " ta " + plural(outcome.condition, ['geym', 'geym', 'geym']) + " yutadimi?";
	};
	var bo_f40 = function bo_f40(match, outcome) {
	    return "Kimdir beshinchi setda ketma-ket " + outcome.condition + " ta " + plural(outcome.condition, ['geym', 'geym', 'geym']) + " yutadimi?";
	};
	var bo_g40 = function bo_g40(match, outcome) {
	    return match.homeTeam + " birinchi setda ketma-ket " + outcome.condition + " ta " + plural(outcome.condition, ['geym', 'geym', 'geym']) + " yutadimi?";
	};
	var bo_h40 = function bo_h40(match, outcome) {
	    return match.homeTeam + " ikkinchi setda ketma-ket " + outcome.condition + " ta " + plural(outcome.condition, ['geym', 'geym', 'geym']) + " yutadimi?";
	};
	var bo_i40 = function bo_i40(match, outcome) {
	    return match.homeTeam + " uchinchi setda ketma-ket " + outcome.condition + " ta " + plural(outcome.condition, ['geym', 'geym', 'geym']) + " yutadimi?";
	};
	var bo_j40 = function bo_j40(match, outcome) {
	    return match.homeTeam + " to&apos;rtinchi setda ketma-ket " + outcome.condition + " ta " + plural(outcome.condition, ['geym', 'geym', 'geym']) + " yutadimi?";
	};
	var bo_k40 = function bo_k40(match, outcome) {
	    return match.homeTeam + " beshinchi setda ketma-ket " + outcome.condition + " ta " + plural(outcome.condition, ['geym', 'geym', 'geym']) + " yutadimi?";
	};
	var bo_l40 = function bo_l40(match, outcome) {
	    return match.awayTeam + " birinchi setda ketma-ket " + outcome.condition + " ta " + plural(outcome.condition, ['geym', 'geym', 'geym']) + " yutadimi?";
	};
	var bo_m40 = function bo_m40(match, outcome) {
	    return match.awayTeam + " ikkinchi setda ketma-ket " + outcome.condition + " ta " + plural(outcome.condition, ['geym', 'geym', 'geym']) + " yutadimi?";
	};
	var bo_n40 = function bo_n40(match, outcome) {
	    return match.awayTeam + " uchinchi setda ketma-ket " + outcome.condition + " ta " + plural(outcome.condition, ['geym', 'geym', 'geym']) + " yutadimi?";
	};
	var bo_o40 = function bo_o40(match, outcome) {
	    return match.awayTeam + " to&apos;rtinchi setda ketma-ket " + outcome.condition + " ta " + plural(outcome.condition, ['geym', 'geym', 'geym']) + " yutadimi?";
	};
	var bo_p40 = function bo_p40(match, outcome) {
	    return match.awayTeam + " beshinchi setda ketma-ket " + outcome.condition + " ta " + plural(outcome.condition, ['geym', 'geym', 'geym']) + " yutadimi?";
	};
	var bo_q40 = function bo_q40(match, outcome) {
	    return 'To&apos;rtinchi setdagi Fora';
	};
	var bo_r40 = function bo_r40(match, outcome) {
	    return 'Beshinchi setdagi Fora';
	};
	var bo_s40 = function bo_s40(match, outcome) {
	    return 'To&apos;rtinchi set jami hisobi';
	};
	var bo_t40 = function bo_t40(match, outcome) {
	    return 'Beshinchi set jami hisobi';
	};
	var bo_u40 = function bo_u40(match, outcome) {
	    return outcome.condition + "-geymning aniq hisobi";
	};
	var bo_v40 = function bo_v40(match, outcome) {
	    return "Kim " + outcome.condition + "-geymni yutadi?";
	};
	var bo_w40 = function bo_w40(match, outcome) {
	    return 'Birinchi set aniq natijasi';
	};
	var bo_x40 = function bo_x40(match, outcome) {
	    return 'Ikkinchi set aniq natijasi';
	};
	var bo_y40 = function bo_y40(match, outcome) {
	    return 'Uchinchi set aniq natijasi';
	};
	var bo_z40 = function bo_z40(match, outcome) {
	    return 'To&apos;rtinchi set aniq natijasi';
	};
	var bo_a41 = function bo_a41(match, outcome) {
	    return 'Beshinchi set aniq natijasi';
	};
	var bo_b41 = function bo_b41(match, outcome) {
	    return outcome.condition + "-geymda 15x15 bo&apos;ladimi?";
	};
	var bo_c41 = function bo_c41(match, outcome) {
	    return outcome.condition + "-geymda 30x30 bo&apos;ladimi?";
	};
	var bo_d41 = function bo_d41(match, outcome) {
	    return outcome.condition + "-geymda 40x40 bo&apos;ladimi?";
	};
	var bo_e41 = function bo_e41(match, outcome) {
	    return "Kim 1-setda birinchi bo&apos;lib " + outcome.condition + " ta " + plural(outcome.condition, ['geym', 'geym', 'geym']) + " yutadi";
	};
	var bo_f41 = function bo_f41(match, outcome) {
	    return "Kim 2-setda birinchi bo&apos;lib " + outcome.condition + " ta " + plural(outcome.condition, ['geym', 'geym', 'geym']) + " yutadi";
	};
	var bo_g41 = function bo_g41(match, outcome) {
	    return "Kim 3-setda birinchi bo&apos;lib " + outcome.condition + " ta " + plural(outcome.condition, ['geym', 'geym', 'geym']) + " yutadi";
	};
	var bo_h41 = function bo_h41(match, outcome) {
	    return "Kim 4-setda birinchi bo&apos;lib " + outcome.condition + " ta " + plural(outcome.condition, ['geym', 'geym', 'geym']) + " yutadi";
	};
	var bo_i41 = function bo_i41(match, outcome) {
	    return "Kim 5-setda birinchi bo&apos;lib " + outcome.condition + " ta " + plural(outcome.condition, ['geym', 'geym', 'geym']) + " yutadi";
	};
	var bo_j41 = function bo_j41(match, outcome) {
	    return 'To&apos;rtinchi set natijasi';
	};
	var bo_k41 = function bo_k41(match, outcome) {
	    return 'Beshinchi set natijasi';
	};
	var bo_l41 = function bo_l41(match, outcome) {
	    return outcome.condition + "-geymdagi birinchi ochko";
	};
	var bo_m41 = function bo_m41(match, outcome) {
	    return 'Birinchi setda tie-breyk bo&apos;ladimi?';
	};
	var bo_n41 = function bo_n41(match, outcome) {
	    return 'Ikkinchi setda tie-breyk bo&apos;ladimi?';
	};
	var bo_o41 = function bo_o41(match, outcome) {
	    return 'Uchinchi setda tie-breyk bo&apos;ladimi?';
	};
	var bo_p41 = function bo_p41(match, outcome) {
	    return 'To&apos;rtinchi setda tie-breyk bo&apos;ladimi?';
	};
	var bo_q41 = function bo_q41(match, outcome) {
	    return 'Beshinchi setda tie-breyk bo&apos;ladimi?';
	};
	var bo_r41 = function bo_r41(match, outcome) {
	    return 'O&apos;yinda tie-break bo&apos;ladimi?';
	};
	var bo_s41 = function bo_s41(match, outcome) {
	    return 'Birinchi setdagi jami tie-braeklar soni';
	};
	var bo_t41 = function bo_t41(match, outcome) {
	    return 'Ikkinchi setdagi jami tie-braeklar soni';
	};
	var bo_u41 = function bo_u41(match, outcome) {
	    return 'Uchinchi setdagi jami tie-braeklar soni';
	};
	var bo_v41 = function bo_v41(match, outcome) {
	    return 'To&apos;rtinchi setdagi jami tie-braeklar soni';
	};
	var bo_w41 = function bo_w41(match, outcome) {
	    return 'Beshinchi setdagi jami tie-braeklar soni';
	};
	var bo_x41 = function bo_x41(match, outcome) {
	    return 'Birinchi setdagi tie-breakning aniq hisobi';
	};
	var bo_y41 = function bo_y41(match, outcome) {
	    return 'Ikkinchi setdagi tie-breakning aniq hisobi';
	};
	var bo_z41 = function bo_z41(match, outcome) {
	    return 'Uchinchi setdagi tie-breakning aniq hisobi';
	};
	var bo_a42 = function bo_a42(match, outcome) {
	    return 'To&apos;rtinchi setdagi tie-breakning aniq hisobi';
	};
	var bo_b42 = function bo_b42(match, outcome) {
	    return 'Beshinchi setdagi tie-breakning aniq hisobi';
	};
	var bo_c42 = function bo_c42(match, outcome) {
	    return 'Birinchi setdagi tie-breaklarning aniq jami hisobi';
	};
	var bo_d42 = function bo_d42(match, outcome) {
	    return 'Ikkinchi setdagi tie-breaklarning aniq jami hisobi';
	};
	var bo_e42 = function bo_e42(match, outcome) {
	    return 'Uchinchi setdagi tie-breaklarning aniq jami hisobi';
	};
	var bo_f42 = function bo_f42(match, outcome) {
	    return 'To&apos;rtinchi setdagi tie-breaklarning aniq jami hisobi';
	};
	var bo_g42 = function bo_g42(match, outcome) {
	    return 'Beshinchi setdagi tie-breaklarning aniq jami hisobi';
	};
	var bo_h42 = function bo_h42(match, outcome) {
	    return 'Birinchi setdagi tie-breakda kim g&apos;alaba qozonadi?';
	};
	var bo_i42 = function bo_i42(match, outcome) {
	    return 'Ikkinchi setdagi tie-breakda kim g&apos;alaba qozonadi?';
	};
	var bo_j42 = function bo_j42(match, outcome) {
	    return 'Uchinchi setdagi tie-breakda kim g&apos;alaba qozonadi?';
	};
	var bo_k42 = function bo_k42(match, outcome) {
	    return 'To&apos;rtinchi setdagi tie-breakda kim g&apos;alaba qozonadi?';
	};
	var bo_l42 = function bo_l42(match, outcome) {
	    return 'Beshinchi setdagi tie-breakda kim g&apos;alaba qozonadi?';
	};
	var bo_m42 = function bo_m42(match, outcome) {
	    return 'Birinchi setdagi jami breyklar soni';
	};
	var bo_n42 = function bo_n42(match, outcome) {
	    return 'O&apos;yindagi jami breyklar soni';
	};
	var bo_o42 = function bo_o42(match, outcome) {
	    return match.homeTeam + " o&apos;yinda biror setda g&apos;alaba qozonadi";
	};
	var bo_p42 = function bo_p42(match, outcome) {
	    return match.awayTeam + " o&apos;yinda biror setda g&apos;alaba qozonadi";
	};
	var bo_q42 = function bo_q42(match, outcome) {
	    return "G&apos;alaba va birinchi set jami hisobi " + outcome.condition;
	};
	var bo_r42 = function bo_r42(match, outcome) {
	    return 'Eng sermahsul bo&apos;lmagan setning jami hisobi';
	};
	var bo_s42 = function bo_s42(match, outcome) {
	    return 'O&apos;yinda kim birinchi bo&apos;lib eysni amalga oshiradi';
	};
	var bo_t42 = function bo_t42(match, outcome) {
	    return 'O&apos;yinda kim birinchi bo&apos;lib qo&apos;shxatoni amalga oshiradi?';
	};
	var bo_u42 = function bo_u42(match, outcome) {
	    return match.homeTeam + ": to&apos;p oshirilishing eng maksimal tezligi (km/s)";
	};
	var bo_v42 = function bo_v42(match, outcome) {
	    return match.awayTeam + ": to&apos;p oshirilishing eng maksimal tezligi (km/s)";
	};
	var bo_w42 = function bo_w42(match, outcome) {
	    return 'Birinchi setni yutqazib o&apos;yinda g&apos;alaba qozonish';
	};
	var bo_x42 = function bo_x42(match, outcome) {
	    return match.homeTeam + ": birinchi to&apos;p oshirish %";
	};
	var bo_y42 = function bo_y42(match, outcome) {
	    return match.awayTeam + ": birinchi to&apos;p oshirish %";
	};
	var bo_z42 = function bo_z42(match, outcome) {
	    return 'O&apos;yindagi breyklar bo&apos;yicha natija';
	};
	var bo_a43 = function bo_a43(match, outcome) {
	    return "Jami brayklar soni: " + match.homeTeam;
	};
	var bo_b43 = function bo_b43(match, outcome) {
	    return "Jami brayklar soni: " + match.awayTeam;
	};
	var bo_c43 = function bo_c43(match, outcome) {
	    return 'O&apos;yinda kim birinchi breyk qiladi';
	};
	var bo_d43 = function bo_d43(match, outcome) {
	    return match.homeTeam + " 1- yoki 2-setlarda breyk qiladi";
	};
	var bo_e43 = function bo_e43(match, outcome) {
	    return 'O&apos;yinda 6:0 yoki 0:6 hisobli set bo&apos;ladimi?';
	};
	var bo_f43 = function bo_f43(match, outcome) {
	    return outcome.condition + "-geym aniq hisobi";
	};
	var bo_g43 = function bo_g43(match, outcome) {
	    return 'O&apos;yindagi eyslarning jami hisobi';
	};
	var bo_h43 = function bo_h43(match, outcome) {
	    return "O&apos;yindagi eyslarning jami hisobi: " + match.homeTeam;
	};
	var bo_i43 = function bo_i43(match, outcome) {
	    return "O&apos;yindagi eyslarning jami hisobi: " + match.awayTeam;
	};
	var bo_j43 = function bo_j43(match, outcome) {
	    return 'O&apos;yindagi qo&apos;shxatolarning jami hisobi';
	};
	var bo_k43 = function bo_k43(match, outcome) {
	    return "O&apos;yindagi qo&apos;shxatolarning jami hisobi: " + match.homeTeam;
	};
	var bo_l43 = function bo_l43(match, outcome) {
	    return "O&apos;yindagi qo&apos;shxatolarning jami hisobi: " + match.awayTeam;
	};
	var bo_m43 = function bo_m43(match, outcome) {
	    return 'Setlar sermahsulligi (Jami hisob)';
	};
	var bo_n43 = function bo_n43(match, outcome) {
	    return 'O&apos;yin to&apos;pni maydondan to&apos;g&apos;ridan-to&apos;g&apos;ri chiqarib yuborish orqali g&apos;alaba qozoniladi';
	};
	var bo_o43 = function bo_o43(match, outcome) {
	    return "1- yoki 2- geymda eys: " + match.homeTeam;
	};
	var bo_p43 = function bo_p43(match, outcome) {
	    return "1- yoki 2- geymda eys: " + match.awayTeam;
	};
	var bo_q43 = function bo_q43(match, outcome) {
	    return "1- yoki 2- geymda qo&apos;shxato: " + match.homeTeam;
	};
	var bo_r43 = function bo_r43(match, outcome) {
	    return "1- yoki 2- geymda qo&apos;shxato: " + match.awayTeam;
	};
	var bo_s43 = function bo_s43(match, outcome) {
	    return 'Birinchi setdagi jami eyslar soni';
	};
	var bo_t43 = function bo_t43(match, outcome) {
	    return 'O&apos;yinchi o&apos;yin davomida o&apos;yindan bosh tortadi (diskvalifikatsiya)';
	};
	var bo_u43 = function bo_u43(match, outcome) {
	    return match.homeTeam + " ning birinchi to&apos;p oshirilishi tushishi %";
	};
	var bo_v43 = function bo_v43(match, outcome) {
	    return match.awayTeam + " ning birinchi to&apos;p oshirilishi tushishi %";
	};
	var bo_w43 = function bo_w43(match, outcome) {
	    return 'Breyklar bo&apos;yicha birinchi set natijasi';
	};
	var bo_x43 = function bo_x43(match, outcome) {
	    return 'Breyklar bo&apos;yicha ikkinchi set natijasi';
	};
	var bo_y43 = function bo_y43(match, outcome) {
	    return 'Breyklar bo&apos;yicha uchinchi set natijasi';
	};
	var bo_z43 = function bo_z43(match, outcome) {
	    return 'Breyklar bo&apos;yicha to&apos;rtinchi set natijasi';
	};
	var bo_a44 = function bo_a44(match, outcome) {
	    return 'Breyklar bo&apos;yicha beshinchi set natijasi';
	};
	var bo_b44 = function bo_b44(match, outcome) {
	    return 'O&apos;yindagi breyklar bo&apos;yicha fora';
	};
	var bo_c44 = function bo_c44(match, outcome) {
	    return 'Birinchi setdagi breyklar bo&apos;yicha fora';
	};
	var bo_d44 = function bo_d44(match, outcome) {
	    return 'Ikkinchi setdagi breyklar bo&apos;yicha fora';
	};
	var bo_e44 = function bo_e44(match, outcome) {
	    return 'Uchinchi setdagi breyklar bo&apos;yicha fora';
	};
	var bo_f44 = function bo_f44(match, outcome) {
	    return 'To&apos;rtinchi setdagi breyklar bo&apos;yicha fora';
	};
	var bo_g44 = function bo_g44(match, outcome) {
	    return 'Beshinchi setdagi breyklar bo&apos;yicha fora';
	};
	var bo_h44 = function bo_h44(match, outcome) {
	    return outcome.condition + "-geymda " + outcome.conditionTwo + " ochkoni kim yutadi";
	};
	var bo_i44 = function bo_i44(match, outcome) {
	    return outcome.conditionTwo + "- va " + outcome.condition + "-geym natijasi";
	};
	var bo_j44 = function bo_j44(match, outcome) {
	    return outcome.conditionTwo + "-geymda fora";
	};
	var bo_k44 = function bo_k44(match, outcome) {
	    return outcome.conditionTwo + "-geymda jami hisob";
	};
	var bo_l44 = function bo_l44(match, outcome) {
	    return "Kim 1-setda birinchi bo&apos;lib  " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_m44 = function bo_m44(match, outcome) {
	    return "Kim 2-setda birinchi bo&apos;lib  " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_n44 = function bo_n44(match, outcome) {
	    return "Kim 3-setda birinchi bo&apos;lib  " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_o44 = function bo_o44(match, outcome) {
	    return "Kim 4-setda birinchi bo&apos;lib  " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_p44 = function bo_p44(match, outcome) {
	    return "Kim 5-setda birinchi bo&apos;lib  " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_q44 = function bo_q44(match, outcome) {
	    return 'O&apos;yindagi partiyalar bo&apos;yicha fora';
	};
	var bo_r44 = function bo_r44(match, outcome) {
	    return 'Birinchi set aniq jami hisobi';
	};
	var bo_s44 = function bo_s44(match, outcome) {
	    return 'Ikkinchi set aniq jami hisobi';
	};
	var bo_t44 = function bo_t44(match, outcome) {
	    return 'Uchinchi set aniq jami hisobi';
	};
	var bo_u44 = function bo_u44(match, outcome) {
	    return 'To&apos;rtinchi set aniq jami hisobi';
	};
	var bo_v44 = function bo_v44(match, outcome) {
	    return 'Beshinchi set aniq jami hisobi';
	};
	var bo_w44 = function bo_w44(match, outcome) {
	    return 'To&apos;rtinchi setning aniq jami hisobi';
	};
	var bo_x44 = function bo_x44(match, outcome) {
	    return 'Beshinchi setning aniq jami hisobi';
	};
	var bo_y44 = function bo_y44(match, outcome) {
	    return match.homeTeam + " to&apos;rtinchi setda farq bilan g&apos;alaba qozonadi";
	};
	var bo_z44 = function bo_z44(match, outcome) {
	    return match.homeTeam + " beshinchi setda farq bilan g&apos;alaba qozonadi";
	};
	var bo_a45 = function bo_a45(match, outcome) {
	    return match.awayTeam + " to&apos;rtinchi setda farq bilan g&apos;alaba qozonadi";
	};
	var bo_b45 = function bo_b45(match, outcome) {
	    return match.awayTeam + " beshinchi setda farq bilan g&apos;alaba qozonadi";
	};
	var bo_c45 = function bo_c45(match, outcome) {
	    return 'Eng sermahsul set jami hisobi';
	};
	var bo_d45 = function bo_d45(match, outcome) {
	    return 'Eng sermahsul bo&apos;lmagan set jami hisobi';
	};
	var bo_e45 = function bo_e45(match, outcome) {
	    return 'To&apos;rtinchi setda farq bilan g&apos;alaba';
	};
	var bo_f45 = function bo_f45(match, outcome) {
	    return 'Beshinchi setda farq bilan g&apos;alaba';
	};
	var bo_g45 = function bo_g45(match, outcome) {
	    return 'Uchinchi setning 10 ochkogacha bo&apos;lgan kichik setida g&apos;alaba';
	};
	var bo_h45 = function bo_h45(match, outcome) {
	    return 'To&apos;rtinchi setning 10 ochkogacha bo&apos;lgan kichik setida g&apos;alaba';
	};
	var bo_i45 = function bo_i45(match, outcome) {
	    return 'Uchinchi setning 10 ochkogacha bo&apos;lgan kichik setida fora';
	};
	var bo_j45 = function bo_j45(match, outcome) {
	    return 'To&apos;rtinchi setning 10 ochkogacha bo&apos;lgan kichik setida fora';
	};
	var bo_k45 = function bo_k45(match, outcome) {
	    return 'Uchinchi setning 10 ochkogacha bo&apos;lgan kichik setida jami hisob';
	};
	var bo_l45 = function bo_l45(match, outcome) {
	    return 'To&apos;rtinchi setning 10 ochkogacha bo&apos;lgan kichik setida jami hisob';
	};
	var bo_m45 = function bo_m45(match, outcome) {
	    return 'Uchinchi setning 15 ochkogacha bo&apos;lgan kichik setida g&apos;alaba';
	};
	var bo_n45 = function bo_n45(match, outcome) {
	    return 'To&apos;rtinchi setning 15 ochkogacha bo&apos;lgan kichik setida g&apos;alaba';
	};
	var bo_o45 = function bo_o45(match, outcome) {
	    return 'Uchinchi setning 15 ochkogacha bo&apos;lgan kichik setida fora';
	};
	var bo_p45 = function bo_p45(match, outcome) {
	    return 'To&apos;rtinchi setning 15 ochkogacha bo&apos;lgan kichik setida fora';
	};
	var bo_q45 = function bo_q45(match, outcome) {
	    return 'Uchinchi setning 15 ochkogacha bo&apos;lgan kichik setida jami hisob';
	};
	var bo_r45 = function bo_r45(match, outcome) {
	    return 'To&apos;rtinchi setning 15 ochkogacha bo&apos;lgan kichik setida jami hisob';
	};
	var bo_s45 = function bo_s45(match, outcome) {
	    return "Kim to&apos;rtinchi setda " + numeralNeuterEnding(outcome.condition) + " ochko yutadi";
	};
	var bo_t45 = function bo_t45(match, outcome) {
	    return "Kim beshinchi setda " + numeralNeuterEnding(outcome.condition) + " ochko yutadi";
	};
	var bo_u45 = function bo_u45(match, outcome) {
	    return 'Oltin setda fora';
	};
	var bo_v45 = function bo_v45(match, outcome) {
	    return 'Oltin set jami hisobi';
	};
	var bo_w45 = function bo_w45(match, outcome) {
	    return match.homeTeam + " oltin set jami hisobi";
	};
	var bo_x45 = function bo_x45(match, outcome) {
	    return match.awayTeam + " oltin set jami hisobi";
	};
	var bo_y45 = function bo_y45(match, outcome) {
	    return 'Oltin set natijasi';
	};
	var bo_z45 = function bo_z45(match, outcome) {
	    return "Oltin setda kim birinchi bo&apos;lib " + outcome.condition + " " + plural(outcome.condition, ['ochko', 'ochko', 'ochko']) + " to&apos;playdi";
	};
	var bo_a46 = function bo_a46(match, outcome) {
	    return 'Oltin set juft/toq';
	};
	var bo_b46 = function bo_b46(match, outcome) {
	    return "Oltin set jami hisobi " + outcome.condition + " va g&apos;alaba";
	};
	var bo_c46 = function bo_c46(match, outcome) {
	    return 'Oltin setda farq bilan g&apos;alaba';
	};
	var bo_d46 = function bo_d46(match, outcome) {
	    return 'Nechta setda mini tie-braek bo&apos;ladi?';
	};
	var bo_e46 = function bo_e46(match, outcome) {
	    return 'Birinchi chorak jami hisobi';
	};
	var bo_f46 = function bo_f46(match, outcome) {
	    return 'Ikkinchi chorak jami hisobi';
	};
	var bo_g46 = function bo_g46(match, outcome) {
	    return 'Uchinchi chorak jami hisobi';
	};
	var bo_h46 = function bo_h46(match, outcome) {
	    return 'To&apos;rtinchi chorak jami hisobi';
	};
	var bo_i46 = function bo_i46(match, outcome) {
	    return outcome.condition + "-raundda kim g&apos;alaba qozonadi?";
	};
	var bo_j46 = function bo_j46(match, outcome) {
	    return '13-sektor tushadimi?';
	};
	var bo_k46 = function bo_k46(match, outcome) {
	    return outcome.condition + "-raundda 13-sektor tushadimi?";
	};
	
	var fa_b1 = function fa_b1(match, outcome) {
	    return "F1(" + signed(outcome.condition) + ")";
	};
	var fa_c1 = function fa_c1(match, outcome) {
	    return "F2(" + signed(-outcome.condition) + ")";
	};
	var fa_d1 = function fa_d1(match, outcome) {
	    return outcome.condition + " dan kam";
	};
	var fa_e1 = function fa_e1(match, outcome) {
	    return outcome.condition + " dan ko&apos;p";
	};
	var fa_f1 = function fa_f1(match, outcome) {
	    return 'Juft';
	};
	var fa_g1 = function fa_g1(match, outcome) {
	    return 'Toq';
	};
	var fa_h1 = function fa_h1(match, outcome) {
	    return 'G&apos;1';
	};
	var fa_i1 = function fa_i1(match, outcome) {
	    return 'G&apos;2';
	};
	var fa_j1 = function fa_j1(match, outcome) {
	    return '1-si yuqoriroq';
	};
	var fa_k1 = function fa_k1(match, outcome) {
	    return '2-si yuqoriroq';
	};
	var fa_l1 = function fa_l1(match, outcome) {
	    return 'Ha';
	};
	var fa_m1 = function fa_m1(match, outcome) {
	    return 'Yo&apos;q';
	};
	var fa_n1 = function fa_n1(match, outcome) {
	    return '0-2';
	};
	var fa_o1 = function fa_o1(match, outcome) {
	    return '0-3';
	};
	var fa_p1 = function fa_p1(match, outcome) {
	    return '1-2';
	};
	var fa_q1 = function fa_q1(match, outcome) {
	    return '1-3';
	};
	var fa_r1 = function fa_r1(match, outcome) {
	    return '2-0';
	};
	var fa_s1 = function fa_s1(match, outcome) {
	    return '2-1';
	};
	var fa_t1 = function fa_t1(match, outcome) {
	    return '2-3';
	};
	var fa_u1 = function fa_u1(match, outcome) {
	    return '3-0';
	};
	var fa_v1 = function fa_v1(match, outcome) {
	    return '3-1';
	};
	var fa_w1 = function fa_w1(match, outcome) {
	    return '3-2';
	};
	var fa_x1 = function fa_x1(match, outcome) {
	    return "" + match.homeTeam;
	};
	var fa_y1 = function fa_y1(match, outcome) {
	    return "" + match.awayTeam;
	};
	var fa_z1 = function fa_z1(match, outcome) {
	    return 'Х';
	};
	var fa_a2 = function fa_a2(match, outcome) {
	    return 'Hechkim';
	};
	var fa_b2 = function fa_b2(match, outcome) {
	    return '1X';
	};
	var fa_c2 = function fa_c2(match, outcome) {
	    return '12';
	};
	var fa_d2 = function fa_d2(match, outcome) {
	    return '2X';
	};
	var fa_e2 = function fa_e2(match, outcome) {
	    return "G&apos;1Jkam " + outcome.condition;
	};
	var fa_f2 = function fa_f2(match, outcome) {
	    return "G&apos;1Jko&apos;p " + outcome.condition;
	};
	var fa_g2 = function fa_g2(match, outcome) {
	    return "G&apos;2Jkam " + outcome.condition;
	};
	var fa_h2 = function fa_h2(match, outcome) {
	    return "G&apos;2Jko&apos;p " + outcome.condition;
	};
	var fa_i2 = function fa_i2(match, outcome) {
	    return "\u0425Jkam " + outcome.condition;
	};
	var fa_j2 = function fa_j2(match, outcome) {
	    return "\u0425Jko&apos;p " + outcome.condition;
	};
	var fa_k2 = function fa_k2(match, outcome) {
	    return '0';
	};
	var fa_l2 = function fa_l2(match, outcome) {
	    return '1';
	};
	var fa_m2 = function fa_m2(match, outcome) {
	    return '2';
	};
	var fa_n2 = function fa_n2(match, outcome) {
	    return '3';
	};
	var fa_o2 = function fa_o2(match, outcome) {
	    return '4';
	};
	var fa_p2 = function fa_p2(match, outcome) {
	    return '≥ 5';
	};
	var fa_q2 = function fa_q2(match, outcome) {
	    return 'Ikkala jamoa ham to&apos;p kiritadi';
	};
	var fa_r2 = function fa_r2(match, outcome) {
	    return 'Bitta jamoa to&apos;p kiritadi';
	};
	var fa_s2 = function fa_s2(match, outcome) {
	    return 'Ikkala jamoa to&apos;p kirita olmaydi';
	};
	var fa_t2 = function fa_t2(match, outcome) {
	    return '0-0';
	};
	var fa_u2 = function fa_u2(match, outcome) {
	    return '0-1';
	};
	var fa_v2 = function fa_v2(match, outcome) {
	    return '0-4';
	};
	var fa_w2 = function fa_w2(match, outcome) {
	    return '0-5';
	};
	var fa_x2 = function fa_x2(match, outcome) {
	    return '1-0';
	};
	var fa_y2 = function fa_y2(match, outcome) {
	    return '1-1';
	};
	var fa_z2 = function fa_z2(match, outcome) {
	    return '1-4';
	};
	var fa_a3 = function fa_a3(match, outcome) {
	    return '1-5';
	};
	var fa_b3 = function fa_b3(match, outcome) {
	    return '2-2';
	};
	var fa_c3 = function fa_c3(match, outcome) {
	    return '2-4';
	};
	var fa_d3 = function fa_d3(match, outcome) {
	    return '2-5';
	};
	var fa_e3 = function fa_e3(match, outcome) {
	    return '2-6';
	};
	var fa_f3 = function fa_f3(match, outcome) {
	    return '3-3';
	};
	var fa_g3 = function fa_g3(match, outcome) {
	    return '3-4';
	};
	var fa_h3 = function fa_h3(match, outcome) {
	    return '3-5';
	};
	var fa_i3 = function fa_i3(match, outcome) {
	    return '4-0';
	};
	var fa_j3 = function fa_j3(match, outcome) {
	    return '4-1';
	};
	var fa_k3 = function fa_k3(match, outcome) {
	    return '4-2';
	};
	var fa_l3 = function fa_l3(match, outcome) {
	    return '4-3';
	};
	var fa_m3 = function fa_m3(match, outcome) {
	    return '4-4';
	};
	var fa_n3 = function fa_n3(match, outcome) {
	    return '5-0';
	};
	var fa_o3 = function fa_o3(match, outcome) {
	    return '5-1';
	};
	var fa_p3 = function fa_p3(match, outcome) {
	    return '5-2';
	};
	var fa_q3 = function fa_q3(match, outcome) {
	    return '5-3';
	};
	var fa_r3 = function fa_r3(match, outcome) {
	    return 'Har qanday boshqa';
	};
	var fa_s3 = function fa_s3(match, outcome) {
	    return "\u2264 " + outcome.condition;
	};
	var fa_t3 = function fa_t3(match, outcome) {
	    return outcome.condition + 1 + " - " + (outcome.condition + 2);
	};
	var fa_u3 = function fa_u3(match, outcome) {
	    return outcome.condition + 3 + " - " + (outcome.condition + 4);
	};
	var fa_v3 = function fa_v3(match, outcome) {
	    return outcome.condition + 5 + " - " + (outcome.condition + 6);
	};
	var fa_w3 = function fa_w3(match, outcome) {
	    return outcome.condition + 7 + " - " + (outcome.condition + 8);
	};
	var fa_x3 = function fa_x3(match, outcome) {
	    return "\u2265 " + (outcome.condition + 9);
	};
	var fa_y3 = function fa_y3(match, outcome) {
	    return '6-9';
	};
	var fa_z3 = function fa_z3(match, outcome) {
	    return '10-12';
	};
	var fa_a4 = function fa_a4(match, outcome) {
	    return '13-16';
	};
	var fa_b4 = function fa_b4(match, outcome) {
	    return '17-20';
	};
	var fa_c4 = function fa_c4(match, outcome) {
	    return '≥21';
	};
	var fa_d4 = function fa_d4(match, outcome) {
	    return "O&apos;tish: " + match.homeTeam;
	};
	var fa_e4 = function fa_e4(match, outcome) {
	    return "O&apos;tish: " + match.awayTeam;
	};
	var fa_f4 = function fa_f4(match, outcome) {
	    return '1-yarim';
	};
	var fa_g4 = function fa_g4(match, outcome) {
	    return '2-yarim';
	};
	var fa_h4 = function fa_h4(match, outcome) {
	    return '1-chorak';
	};
	var fa_i4 = function fa_i4(match, outcome) {
	    return '2-chorak';
	};
	var fa_j4 = function fa_j4(match, outcome) {
	    return '3-chorak';
	};
	var fa_k4 = function fa_k4(match, outcome) {
	    return '4-chorak';
	};
	var fa_l4 = function fa_l4(match, outcome) {
	    return 'G&apos;1: 1-2';
	};
	var fa_m4 = function fa_m4(match, outcome) {
	    return 'G&apos;1: 3-5';
	};
	var fa_n4 = function fa_n4(match, outcome) {
	    return 'G&apos;1: 6-9';
	};
	var fa_o4 = function fa_o4(match, outcome) {
	    return 'G&apos;1: 10-12';
	};
	var fa_p4 = function fa_p4(match, outcome) {
	    return 'G&apos;1: 13-16';
	};
	var fa_q4 = function fa_q4(match, outcome) {
	    return 'G&apos;1: 17-20';
	};
	var fa_r4 = function fa_r4(match, outcome) {
	    return 'G&apos;1: ≥21';
	};
	var fa_s4 = function fa_s4(match, outcome) {
	    return 'G&apos;2: 1-2';
	};
	var fa_t4 = function fa_t4(match, outcome) {
	    return 'G&apos;2: 3-5';
	};
	var fa_u4 = function fa_u4(match, outcome) {
	    return 'G&apos;2: 6-9';
	};
	var fa_v4 = function fa_v4(match, outcome) {
	    return 'G&apos;2: 10-12';
	};
	var fa_w4 = function fa_w4(match, outcome) {
	    return 'G&apos;2: 13-16';
	};
	var fa_x4 = function fa_x4(match, outcome) {
	    return 'G&apos;2: 17-20';
	};
	var fa_y4 = function fa_y4(match, outcome) {
	    return 'G&apos;2: ≥21';
	};
	var fa_z4 = function fa_z4(match, outcome) {
	    return 'G&apos;1: 3-4';
	};
	var fa_a5 = function fa_a5(match, outcome) {
	    return 'G&apos;1: 5-7';
	};
	var fa_b5 = function fa_b5(match, outcome) {
	    return 'G&apos;1: ≥8';
	};
	var fa_c5 = function fa_c5(match, outcome) {
	    return 'Х2';
	};
	var fa_d5 = function fa_d5(match, outcome) {
	    return 'G&apos;2: 3-4';
	};
	var fa_e5 = function fa_e5(match, outcome) {
	    return 'G&apos;2: 5-7';
	};
	var fa_f5 = function fa_f5(match, outcome) {
	    return 'G&apos;2: ≥8';
	};
	var fa_g5 = function fa_g5(match, outcome) {
	    return 'Х1';
	};
	var fa_h5 = function fa_h5(match, outcome) {
	    return 'Jarima';
	};
	var fa_i5 = function fa_i5(match, outcome) {
	    return '3 ochkolik';
	};
	var fa_j5 = function fa_j5(match, outcome) {
	    return '2 ochkolik';
	};
	var fa_k5 = function fa_k5(match, outcome) {
	    return "G&apos;1 \u2265 " + outcome.condition;
	};
	var fa_l5 = function fa_l5(match, outcome) {
	    return "Farq " + outcome.condition + " dan kam";
	};
	var fa_m5 = function fa_m5(match, outcome) {
	    return "G&apos;2 \u2265 " + outcome.condition;
	};
	var fa_n5 = function fa_n5(match, outcome) {
	    return "G&apos;1: " + outcome.condition + "=21 dan katta";
	};
	var fa_o5 = function fa_o5(match, outcome) {
	    return "G&apos;2: " + outcome.condition + "=21 dan katta";
	};
	var fa_p5 = function fa_p5(match, outcome) {
	    return 'G&apos;1: 8 va undan ko&apos;p';
	};
	var fa_q5 = function fa_q5(match, outcome) {
	    return 'G&apos;2: 8 va undan ko&apos;p';
	};
	var fa_r5 = function fa_r5(match, outcome) {
	    return 'Hech qaysi';
	};
	var fa_s5 = function fa_s5(match, outcome) {
	    return 'G&apos;1: 1';
	};
	var fa_t5 = function fa_t5(match, outcome) {
	    return 'G&apos;1: 2';
	};
	var fa_u5 = function fa_u5(match, outcome) {
	    return 'G&apos;1: 3';
	};
	var fa_v5 = function fa_v5(match, outcome) {
	    return 'G&apos;1: 4';
	};
	var fa_w5 = function fa_w5(match, outcome) {
	    return 'G&apos;1: ≥ 5';
	};
	var fa_x5 = function fa_x5(match, outcome) {
	    return 'G&apos;2: 1';
	};
	var fa_y5 = function fa_y5(match, outcome) {
	    return 'G&apos;2: 2';
	};
	var fa_z5 = function fa_z5(match, outcome) {
	    return 'G&apos;2: 3';
	};
	var fa_a6 = function fa_a6(match, outcome) {
	    return 'G&apos;2: 4';
	};
	var fa_b6 = function fa_b6(match, outcome) {
	    return 'G&apos;2: ≥ 5';
	};
	var fa_c6 = function fa_c6(match, outcome) {
	    return 'Ikkala';
	};
	var fa_d6 = function fa_d6(match, outcome) {
	    return 'Bitta';
	};
	var fa_e6 = function fa_e6(match, outcome) {
	    return 'Birorta ham';
	};
	var fa_f6 = function fa_f6(match, outcome) {
	    return '0 yoki 1';
	};
	var fa_g6 = function fa_g6(match, outcome) {
	    return '5';
	};
	var fa_h6 = function fa_h6(match, outcome) {
	    return '6';
	};
	var fa_i6 = function fa_i6(match, outcome) {
	    return '7';
	};
	var fa_j6 = function fa_j6(match, outcome) {
	    return '≥ 8';
	};
	var fa_k6 = function fa_k6(match, outcome) {
	    return 'G&apos;1G&apos;1';
	};
	var fa_l6 = function fa_l6(match, outcome) {
	    return 'G&apos;1X';
	};
	var fa_m6 = function fa_m6(match, outcome) {
	    return 'G&apos;1G&apos;2';
	};
	var fa_n6 = function fa_n6(match, outcome) {
	    return 'XG&apos;1';
	};
	var fa_o6 = function fa_o6(match, outcome) {
	    return 'XX';
	};
	var fa_p6 = function fa_p6(match, outcome) {
	    return 'XG&apos;2';
	};
	var fa_q6 = function fa_q6(match, outcome) {
	    return 'G&apos;2G&apos;1';
	};
	var fa_r6 = function fa_r6(match, outcome) {
	    return 'G&apos;2X';
	};
	var fa_s6 = function fa_s6(match, outcome) {
	    return 'G&apos;2G&apos;2';
	};
	var fa_t6 = function fa_t6(match, outcome) {
	    return "" + (outcome.condition + 1);
	};
	var fa_u6 = function fa_u6(match, outcome) {
	    return "" + (outcome.condition + 2);
	};
	var fa_v6 = function fa_v6(match, outcome) {
	    return "" + (outcome.condition + 3);
	};
	var fa_w6 = function fa_w6(match, outcome) {
	    return "" + (outcome.condition + 4);
	};
	var fa_x6 = function fa_x6(match, outcome) {
	    return "" + (outcome.condition + 5);
	};
	var fa_y6 = function fa_y6(match, outcome) {
	    return "" + (outcome.condition + 6);
	};
	var fa_z6 = function fa_z6(match, outcome) {
	    return "\u2265 " + (outcome.condition + 7);
	};
	var fa_a7 = function fa_a7(match, outcome) {
	    return "\u043E\u0442 " + (outcome.condition + 1) + " \u0434\u043E " + (outcome.condition + 2);
	};
	var fa_b7 = function fa_b7(match, outcome) {
	    return "\u043E\u0442 " + (outcome.condition + 3) + " \u0434\u043E " + (outcome.condition + 4);
	};
	var fa_c7 = function fa_c7(match, outcome) {
	    return "\u043E\u0442 " + (outcome.condition + 5) + " \u0434\u043E " + (outcome.condition + 6);
	};
	var fa_d7 = function fa_d7(match, outcome) {
	    return '4-6';
	};
	var fa_e7 = function fa_e7(match, outcome) {
	    return '7 va undan ko&apos;p';
	};
	var fa_f7 = function fa_f7(match, outcome) {
	    return 'G&apos;1Jkam';
	};
	var fa_g7 = function fa_g7(match, outcome) {
	    return 'G&apos;1Jko&apos;p';
	};
	var fa_h7 = function fa_h7(match, outcome) {
	    return 'G&apos;2Jkam';
	};
	var fa_i7 = function fa_i7(match, outcome) {
	    return 'G&apos;2Jko&apos;p';
	};
	var fa_j7 = function fa_j7(match, outcome) {
	    return 'G&apos;1: 2-3';
	};
	var fa_k7 = function fa_k7(match, outcome) {
	    return 'G&apos;1: 4-6';
	};
	var fa_l7 = function fa_l7(match, outcome) {
	    return 'G&apos;1: ≥7';
	};
	var fa_m7 = function fa_m7(match, outcome) {
	    return 'G&apos;2: 2-3';
	};
	var fa_n7 = function fa_n7(match, outcome) {
	    return 'G&apos;2: 4-6';
	};
	var fa_o7 = function fa_o7(match, outcome) {
	    return 'G&apos;2: ≥7';
	};
	var fa_p7 = function fa_p7(match, outcome) {
	    return "" + outcome.condition;
	};
	var fa_q7 = function fa_q7(match, outcome) {
	    return "\u2265 " + (outcome.condition + 6);
	};
	var fa_r7 = function fa_r7(match, outcome) {
	    return 'G&apos;1: muddatidan avval g&apos;alaba';
	};
	var fa_s7 = function fa_s7(match, outcome) {
	    return 'G&apos;1: ochkolar bo&apos;yicha g&apos;alaba';
	};
	var fa_t7 = function fa_t7(match, outcome) {
	    return 'Durrang';
	};
	var fa_u7 = function fa_u7(match, outcome) {
	    return 'G&apos;2: muddatidan avval g&apos;alaba';
	};
	var fa_v7 = function fa_v7(match, outcome) {
	    return 'G&apos;2: ochkolar bo&apos;yicha g&apos;alaba';
	};
	var fa_w7 = function fa_w7(match, outcome) {
	    return 'G&apos;1: 1 raund';
	};
	var fa_x7 = function fa_x7(match, outcome) {
	    return 'G&apos;1: 2 raund';
	};
	var fa_y7 = function fa_y7(match, outcome) {
	    return 'G&apos;1: 3 raund';
	};
	var fa_z7 = function fa_z7(match, outcome) {
	    return 'G&apos;1: 4 raund';
	};
	var fa_a8 = function fa_a8(match, outcome) {
	    return 'G&apos;1: 5 raund';
	};
	var fa_b8 = function fa_b8(match, outcome) {
	    return 'G&apos;1: 6 raund';
	};
	var fa_c8 = function fa_c8(match, outcome) {
	    return 'G&apos;1: 7 raund';
	};
	var fa_d8 = function fa_d8(match, outcome) {
	    return 'G&apos;1: 8 raund';
	};
	var fa_e8 = function fa_e8(match, outcome) {
	    return 'G&apos;1: 9 raund';
	};
	var fa_f8 = function fa_f8(match, outcome) {
	    return 'G&apos;1: 10 raund';
	};
	var fa_g8 = function fa_g8(match, outcome) {
	    return 'G&apos;1: 11 raund';
	};
	var fa_h8 = function fa_h8(match, outcome) {
	    return 'G&apos;1: 12 raund';
	};
	var fa_i8 = function fa_i8(match, outcome) {
	    return 'G&apos;2: 1 raund';
	};
	var fa_j8 = function fa_j8(match, outcome) {
	    return 'G&apos;2: 2 raund';
	};
	var fa_k8 = function fa_k8(match, outcome) {
	    return 'G&apos;2: 3 raund';
	};
	var fa_l8 = function fa_l8(match, outcome) {
	    return 'G&apos;2: 4 raund';
	};
	var fa_m8 = function fa_m8(match, outcome) {
	    return 'G&apos;2: 5 raund';
	};
	var fa_n8 = function fa_n8(match, outcome) {
	    return 'G&apos;2: 6 raund';
	};
	var fa_o8 = function fa_o8(match, outcome) {
	    return 'G&apos;2: 7 raund';
	};
	var fa_p8 = function fa_p8(match, outcome) {
	    return 'G&apos;2: 8 raund';
	};
	var fa_q8 = function fa_q8(match, outcome) {
	    return 'G&apos;2: 9 raund';
	};
	var fa_r8 = function fa_r8(match, outcome) {
	    return 'G&apos;2: 10 raund';
	};
	var fa_s8 = function fa_s8(match, outcome) {
	    return 'G&apos;2: 11 raund';
	};
	var fa_t8 = function fa_t8(match, outcome) {
	    return 'G&apos;2: 12 raund';
	};
	var fa_u8 = function fa_u8(match, outcome) {
	    return 'X';
	};
	var fa_v8 = function fa_v8(match, outcome) {
	    return "F\u04242(" + signed(-outcome.condition) + ")";
	};
	var fa_w8 = function fa_w8(match, outcome) {
	    return '5 va undan ko&apos;p';
	};
	var fa_x8 = function fa_x8(match, outcome) {
	    return 'Ikkala jamoa';
	};
	var fa_y8 = function fa_y8(match, outcome) {
	    return 'Bitta jamoa';
	};
	var fa_z8 = function fa_z8(match, outcome) {
	    return 'Hechqaysi';
	};
	var fa_a9 = function fa_a9(match, outcome) {
	    return "Har bir jamoa  " + (outcome.condition + 1) + " yoki undan ko&apos;p to&apos;p kiritadi";
	};
	var fa_b9 = function fa_b9(match, outcome) {
	    return "Faqat bitta jamoa " + (outcome.condition + 1) + " yoki undan ko&apos;p to&apos;p kiritadi";
	};
	var fa_c9 = function fa_c9(match, outcome) {
	    return "Hechqaysi jamoa " + (outcome.condition + 1) + " yoki undan ko&apos;p to&apos;p kiritmaydi";
	};
	var fa_d9 = function fa_d9(match, outcome) {
	    return 'Bosh bilan';
	};
	var fa_e9 = function fa_e9(match, outcome) {
	    return 'Oyoq bilan, o&apos;yindan';
	};
	var fa_f9 = function fa_f9(match, outcome) {
	    return 'Avtogol bilan';
	};
	var fa_g9 = function fa_g9(match, outcome) {
	    return 'Penaltidan';
	};
	var fa_h9 = function fa_h9(match, outcome) {
	    return 'Burchak zarbasi';
	};
	var fa_i9 = function fa_i9(match, outcome) {
	    return 'O&apos;yindan tashqari holat';
	};
	var fa_j9 = function fa_j9(match, outcome) {
	    return 'SK';
	};
	var fa_k9 = function fa_k9(match, outcome) {
	    return 'Gol';
	};
	var fa_l9 = function fa_l9(match, outcome) {
	    return 'Bo&apos;ladi';
	};
	var fa_m9 = function fa_m9(match, outcome) {
	    return 'Bo&apos;lmaydi';
	};
	var fa_n9 = function fa_n9(match, outcome) {
	    return outcome.condition + " dan oldin";
	};
	var fa_o9 = function fa_o9(match, outcome) {
	    return outcome.condition + " dan keyin";
	};
	var fa_p9 = function fa_p9(match, outcome) {
	    return 'Birinchi bo&apos;limda';
	};
	var fa_q9 = function fa_q9(match, outcome) {
	    return 'Ikkinchi bo&apos;limda';
	};
	var fa_r9 = function fa_r9(match, outcome) {
	    return 'Gol kiritilmaydi';
	};
	var fa_s9 = function fa_s9(match, outcome) {
	    return 'Kirita olmaydi';
	};
	var fa_t9 = function fa_t9(match, outcome) {
	    return 'G&apos;1D';
	};
	var fa_u9 = function fa_u9(match, outcome) {
	    return 'DG&apos;1';
	};
	var fa_v9 = function fa_v9(match, outcome) {
	    return 'DD';
	};
	var fa_w9 = function fa_w9(match, outcome) {
	    return 'DG&apos;2';
	};
	var fa_x9 = function fa_x9(match, outcome) {
	    return 'G&apos;2D';
	};
	var fa_y9 = function fa_y9(match, outcome) {
	    return '0-6';
	};
	var fa_z9 = function fa_z9(match, outcome) {
	    return '1-6';
	};
	var fa_a10 = function fa_a10(match, outcome) {
	    return '6-0';
	};
	var fa_b10 = function fa_b10(match, outcome) {
	    return '6-1';
	};
	var fa_c10 = function fa_c10(match, outcome) {
	    return 'Goli durrang';
	};
	var fa_d10 = function fa_d10(match, outcome) {
	    return 'Golsiz durrang';
	};
	var fa_e10 = function fa_e10(match, outcome) {
	    return "G&apos;2ko&apos;p " + outcome.condition;
	};
	var fa_f10 = function fa_f10(match, outcome) {
	    return 'Kiritadi';
	};
	var fa_g10 = function fa_g10(match, outcome) {
	    return 'Kiritmaydi';
	};
	var fa_h10 = function fa_h10(match, outcome) {
	    return 'Har qanday boshqa hisob';
	};
	var fa_i10 = function fa_i10(match, outcome) {
	    return 'Ikkala jamoa to&apos;p kiritadi';
	};
	var fa_j10 = function fa_j10(match, outcome) {
	    return 'Ikkala jamoa ham to&apos;p kiritmaydi';
	};
	var fa_k10 = function fa_k10(match, outcome) {
	    return 'Birinchisi kamroq';
	};
	var fa_l10 = function fa_l10(match, outcome) {
	    return 'Tenglik';
	};
	var fa_m10 = function fa_m10(match, outcome) {
	    return 'Birinchisi ko&apos;proq';
	};
	var fa_n10 = function fa_n10(match, outcome) {
	    return 'Ha/Ha';
	};
	var fa_o10 = function fa_o10(match, outcome) {
	    return 'Ha/Yo&apos;q';
	};
	var fa_p10 = function fa_p10(match, outcome) {
	    return 'Yo&apos;q/Ha';
	};
	var fa_q10 = function fa_q10(match, outcome) {
	    return 'Yo&apos;q/Yo&apos;q';
	};
	var fa_r10 = function fa_r10(match, outcome) {
	    return "Jko&apos;p " + outcome.condition + "/Ha";
	};
	var fa_s10 = function fa_s10(match, outcome) {
	    return "Jko&apos;p " + outcome.condition + "/Yo&apos;q";
	};
	var fa_t10 = function fa_t10(match, outcome) {
	    return "Jkam " + outcome.condition + "/Ha";
	};
	var fa_u10 = function fa_u10(match, outcome) {
	    return "Jkam " + outcome.condition + "/Yo&apos;q";
	};
	var fa_v10 = function fa_v10(match, outcome) {
	    return 'G&apos;1 asosiy vaqtda';
	};
	var fa_w10 = function fa_w10(match, outcome) {
	    return 'G&apos;2 asosiy vaqtda';
	};
	var fa_x10 = function fa_x10(match, outcome) {
	    return 'G&apos;1 qo&apos;shimcha vaqtda';
	};
	var fa_y10 = function fa_y10(match, outcome) {
	    return 'G&apos;2 qo&apos;shimcha vaqtda';
	};
	var fa_z10 = function fa_z10(match, outcome) {
	    return 'G&apos;1 penaltilar seriyasida';
	};
	var fa_a11 = function fa_a11(match, outcome) {
	    return 'G&apos;2 penaltilar seriyasida';
	};
	var fa_b11 = function fa_b11(match, outcome) {
	    return '1-bo&apos;lim';
	};
	var fa_c11 = function fa_c11(match, outcome) {
	    return 'Tanaffus';
	};
	var fa_d11 = function fa_d11(match, outcome) {
	    return '2-bo&apos;lim';
	};
	var fa_e11 = function fa_e11(match, outcome) {
	    return '5-4';
	};
	var fa_f11 = function fa_f11(match, outcome) {
	    return 'G&apos;1 har qanday boshqa hisob bilan';
	};
	var fa_g11 = function fa_g11(match, outcome) {
	    return '4-5';
	};
	var fa_h11 = function fa_h11(match, outcome) {
	    return 'G&apos;2  har qanday boshqa hisob bilan';
	};
	var fa_i11 = function fa_i11(match, outcome) {
	    return 'Hech kim';
	};
	var fa_j11 = function fa_j11(match, outcome) {
	    return '1-10';
	};
	var fa_k11 = function fa_k11(match, outcome) {
	    return '11-20';
	};
	var fa_l11 = function fa_l11(match, outcome) {
	    return '21-30';
	};
	var fa_m11 = function fa_m11(match, outcome) {
	    return '31-40';
	};
	var fa_n11 = function fa_n11(match, outcome) {
	    return '41-50';
	};
	var fa_o11 = function fa_o11(match, outcome) {
	    return '51-60';
	};
	var fa_p11 = function fa_p11(match, outcome) {
	    return '61-70';
	};
	var fa_q11 = function fa_q11(match, outcome) {
	    return '71-80';
	};
	var fa_r11 = function fa_r11(match, outcome) {
	    return '81-O&apos;yin asosiy vaqti oxirigacha';
	};
	var fa_s11 = function fa_s11(match, outcome) {
	    return 'Gol yo&apos;q';
	};
	var fa_t11 = function fa_t11(match, outcome) {
	    return 'G&apos;1: 8 va undan katta';
	};
	var fa_u11 = function fa_u11(match, outcome) {
	    return 'Ikkalasi ham kiritadi';
	};
	var fa_v11 = function fa_v11(match, outcome) {
	    return 'Bittasi kiritadi';
	};
	var fa_w11 = function fa_w11(match, outcome) {
	    return 'Ikklasi ham kiritolmaydi';
	};
	var fa_x11 = function fa_x11(match, outcome) {
	    return "Har bir jamoa " + (outcome.condition + 1) + " ta va undan ko&apos;p gol kiritadi";
	};
	var fa_y11 = function fa_y11(match, outcome) {
	    return "Faqat bitta jamoa " + (outcome.condition + 1) + " ta va undan ko&apos;p gol kiritadi";
	};
	var fa_z11 = function fa_z11(match, outcome) {
	    return "Hechqaysi jamoa " + (outcome.condition + 1) + " ta va undan ko&apos;p gol kirita olmaydi";
	};
	var fa_a12 = function fa_a12(match, outcome) {
	    return '1<2';
	};
	var fa_b12 = function fa_b12(match, outcome) {
	    return '1=2';
	};
	var fa_c12 = function fa_c12(match, outcome) {
	    return '1>2';
	};
	var fa_d12 = function fa_d12(match, outcome) {
	    return '1<3';
	};
	var fa_e12 = function fa_e12(match, outcome) {
	    return '1=3';
	};
	var fa_f12 = function fa_f12(match, outcome) {
	    return '1>3';
	};
	var fa_g12 = function fa_g12(match, outcome) {
	    return '2<3';
	};
	var fa_h12 = function fa_h12(match, outcome) {
	    return '2=3';
	};
	var fa_i12 = function fa_i12(match, outcome) {
	    return '2>3';
	};
	var fa_j12 = function fa_j12(match, outcome) {
	    return 'Birorta';
	};
	var fa_k12 = function fa_k12(match, outcome) {
	    return 'Birinchisi kichik';
	};
	var fa_l12 = function fa_l12(match, outcome) {
	    return 'Birinchisi katta';
	};
	var fa_m12 = function fa_m12(match, outcome) {
	    return 'W1';
	};
	var fa_n12 = function fa_n12(match, outcome) {
	    return 'W2';
	};
	var fa_o12 = function fa_o12(match, outcome) {
	    return "Under " + outcome.condition;
	};
	var fa_p12 = function fa_p12(match, outcome) {
	    return "Over " + outcome.condition;
	};
	var fa_q12 = function fa_q12(match, outcome) {
	    return 'W1: 1 round';
	};
	var fa_r12 = function fa_r12(match, outcome) {
	    return 'W1: 2 round';
	};
	var fa_s12 = function fa_s12(match, outcome) {
	    return 'W1: 3 round';
	};
	var fa_t12 = function fa_t12(match, outcome) {
	    return 'W1: 4 round';
	};
	var fa_u12 = function fa_u12(match, outcome) {
	    return 'W1: 5 round';
	};
	var fa_v12 = function fa_v12(match, outcome) {
	    return 'W1: Point Victory';
	};
	var fa_w12 = function fa_w12(match, outcome) {
	    return 'Draw';
	};
	var fa_x12 = function fa_x12(match, outcome) {
	    return 'W2: 1 round';
	};
	var fa_y12 = function fa_y12(match, outcome) {
	    return 'W2: 2 round';
	};
	var fa_z12 = function fa_z12(match, outcome) {
	    return 'W2: 3 round';
	};
	var fa_a13 = function fa_a13(match, outcome) {
	    return 'W2: 4 round';
	};
	var fa_b13 = function fa_b13(match, outcome) {
	    return 'W2: 5 round';
	};
	var fa_c13 = function fa_c13(match, outcome) {
	    return 'W2: Point Victory';
	};
	var fa_d13 = function fa_d13(match, outcome) {
	    return 'Yes';
	};
	var fa_e13 = function fa_e13(match, outcome) {
	    return 'No';
	};
	var fa_f13 = function fa_f13(match, outcome) {
	    return 'yes';
	};
	var fa_g13 = function fa_g13(match, outcome) {
	    return 'no';
	};
	var fa_h13 = function fa_h13(match, outcome) {
	    return 'Sariq shar';
	};
	var fa_i13 = function fa_i13(match, outcome) {
	    return 'Yashil shar';
	};
	var fa_j13 = function fa_j13(match, outcome) {
	    return 'Jigarrang shar';
	};
	var fa_k13 = function fa_k13(match, outcome) {
	    return 'Ko&apos;k shar';
	};
	var fa_l13 = function fa_l13(match, outcome) {
	    return 'Pushti shar';
	};
	var fa_m13 = function fa_m13(match, outcome) {
	    return 'Qora shar';
	};
	var fa_n13 = function fa_n13(match, outcome) {
	    return "\u2265 " + (outcome.condition + 5);
	};
	var fa_o13 = function fa_o13(match, outcome) {
	    return '≤ 14';
	};
	var fa_p13 = function fa_p13(match, outcome) {
	    return '15 dan 17 gacha';
	};
	var fa_q13 = function fa_q13(match, outcome) {
	    return '18 dan 19 gacha';
	};
	var fa_r13 = function fa_r13(match, outcome) {
	    return '≥ 20';
	};
	var fa_s13 = function fa_s13(match, outcome) {
	    return '2--si yuqoriroq';
	};
	var fa_t13 = function fa_t13(match, outcome) {
	    return 'G&apos;1-0';
	};
	var fa_u13 = function fa_u13(match, outcome) {
	    return 'G&apos;1-15';
	};
	var fa_v13 = function fa_v13(match, outcome) {
	    return 'G&apos;1-30';
	};
	var fa_w13 = function fa_w13(match, outcome) {
	    return 'G&apos;1-40';
	};
	var fa_x13 = function fa_x13(match, outcome) {
	    return '0-G&apos;2';
	};
	var fa_y13 = function fa_y13(match, outcome) {
	    return '15-G&apos;2';
	};
	var fa_z13 = function fa_z13(match, outcome) {
	    return '30-G&apos;2';
	};
	var fa_a14 = function fa_a14(match, outcome) {
	    return '40-G&apos;2';
	};
	var fa_b14 = function fa_b14(match, outcome) {
	    return '3-6';
	};
	var fa_c14 = function fa_c14(match, outcome) {
	    return '5-7';
	};
	var fa_d14 = function fa_d14(match, outcome) {
	    return '6-2';
	};
	var fa_e14 = function fa_e14(match, outcome) {
	    return '6-3';
	};
	var fa_f14 = function fa_f14(match, outcome) {
	    return '6-4';
	};
	var fa_g14 = function fa_g14(match, outcome) {
	    return '6-7';
	};
	var fa_h14 = function fa_h14(match, outcome) {
	    return '7-5';
	};
	var fa_i14 = function fa_i14(match, outcome) {
	    return '7-6';
	};
	var fa_j14 = function fa_j14(match, outcome) {
	    return '7-0';
	};
	var fa_k14 = function fa_k14(match, outcome) {
	    return '7-1';
	};
	var fa_l14 = function fa_l14(match, outcome) {
	    return '7-2';
	};
	var fa_m14 = function fa_m14(match, outcome) {
	    return '7-3';
	};
	var fa_n14 = function fa_n14(match, outcome) {
	    return '7-4';
	};
	var fa_o14 = function fa_o14(match, outcome) {
	    return 'G&apos;1 boshqa harqanday hisob bilan';
	};
	var fa_p14 = function fa_p14(match, outcome) {
	    return '0-7';
	};
	var fa_q14 = function fa_q14(match, outcome) {
	    return '1-7';
	};
	var fa_r14 = function fa_r14(match, outcome) {
	    return '2-7';
	};
	var fa_s14 = function fa_s14(match, outcome) {
	    return '3-7';
	};
	var fa_t14 = function fa_t14(match, outcome) {
	    return '4-7';
	};
	var fa_u14 = function fa_u14(match, outcome) {
	    return 'G&apos;2 boshqa harqanday hisob bilan';
	};
	var fa_v14 = function fa_v14(match, outcome) {
	    return '8';
	};
	var fa_w14 = function fa_w14(match, outcome) {
	    return '9';
	};
	var fa_x14 = function fa_x14(match, outcome) {
	    return '10';
	};
	var fa_y14 = function fa_y14(match, outcome) {
	    return '11';
	};
	var fa_z14 = function fa_z14(match, outcome) {
	    return '≥ 13';
	};
	var fa_a15 = function fa_a15(match, outcome) {
	    return match.homeTeam + " (O&apos;.T.O)";
	};
	var fa_b15 = function fa_b15(match, outcome) {
	    return match.awayTeam + " (O&apos;.T.O)";
	};
	var fa_c15 = function fa_c15(match, outcome) {
	    return "" + match.homeTeam;
	};
	var fa_d15 = function fa_d15(match, outcome) {
	    return 'Ikkalasi G&apos;1';
	};
	var fa_e15 = function fa_e15(match, outcome) {
	    return 'Ikkalasi G&apos;2';
	};
	var fa_f15 = function fa_f15(match, outcome) {
	    return '1-ая выше';
	};
	var fa_g15 = function fa_g15(match, outcome) {
	    return '2-ая выше';
	};
	var fa_h15 = function fa_h15(match, outcome) {
	    return outcome.condition + 1 + " dan " + (outcome.condition + 2) + " gacha";
	};
	var fa_i15 = function fa_i15(match, outcome) {
	    return outcome.condition + 3 + " dan " + (outcome.condition + 4) + " gacha";
	};
	var fa_j15 = function fa_j15(match, outcome) {
	    return outcome.condition + 5 + " dan " + (outcome.condition + 6) + " gacha";
	};
	var fa_k15 = function fa_k15(match, outcome) {
	    return '7 va undan katta';
	};
	var fa_l15 = function fa_l15(match, outcome) {
	    return 'F1';
	};
	var fa_m15 = function fa_m15(match, outcome) {
	    return 'F2';
	};
	var fa_n15 = function fa_n15(match, outcome) {
	    return 'G&apos;1: 7 va undan ko&apos;p';
	};
	var fa_o15 = function fa_o15(match, outcome) {
	    return 'G&apos;2: 7 va undan ko&apos;p';
	};
	var fa_p15 = function fa_p15(match, outcome) {
	    return '6-5';
	};
	var fa_q15 = function fa_q15(match, outcome) {
	    return '5-6';
	};
	
	var groupConfig = {
	    32: {
	        0: 'O&apos;yin',
	        1: 'Birinchi set',
	        2: 'Ikkinchi set',
	        3: 'Uchinchi set',
	        4: '10 ochkogacha kichik set (Birinchi set)',
	        5: '15 ochkogacha kichik set (Birinchi set)',
	        6: '10 ochkogacha kichik set (Ikkinchi set)',
	        7: '15 ochkogacha kichik set (Ikkinchi set)',
	        8: '10 ochkogacha kichik set (Uchinchi set)',
	        9: '15 ochkogacha kichik set (Uchinchi set)'
	    },
	    35: {
	        0: 'O&apos;yin',
	        1: 'Birinchi davr'
	    },
	    31: {
	        0: 'O&apos;yin',
	        1: 'Birinchi chorak',
	        2: 'Ikkinchi chorak',
	        3: 'Uchinchi chorak',
	        4: 'To&apos;rtinchi chorak',
	        5: 'Ikki ochkolik to&apos;p otishlar',
	        6: 'Uch ochkolik to&apos;p otishlar',
	        7: 'O&apos;yinning birinchi yarmi',
	        8: 'O&apos;yinning ikkinchi yarmi'
	    },
	    41: {
	        0: 'O&apos;yin',
	        1: 'O&apos;yinning birinchi yarmi',
	        2: 'O&apos;yinning ikkinchi yarmi',
	        3: 'Ikki ochkolik to&apos;p otishlar',
	        4: 'Uch ochkolik to&apos;p otishlar'
	    },
	    18: {
	        0: 'O&apos;yin',
	        1: 'Birinchi davr',
	        2: 'Ikkinchi davr',
	        3: 'Uchinchi davr'
	    },
	    3: {
	        0: 'O&apos;yin',
	        1: 'Birinchi set',
	        2: 'Ikkinchi set',
	        3: 'Uchinchi set',
	        4: '10 ochkogacha bo&apos;lgan kichik set (birinchi set)',
	        5: '15 ochkogacha bo&apos;lgan kichik set (birinchi set)',
	        6: '10 ochkogacha bo&apos;lgan kichik set (ikkinchi set)',
	        7: '15 ochkogacha bo&apos;lgan kichik set (ikkinchi set)'
	    },
	    20: {
	        0: 'O&apos;yin',
	        1: 'Birinchi o&apos;t ochis marrasi',
	        2: 'Ikkinchi o&apos;t ochis marrasi',
	        3: 'Uchinchi o&apos;t ochis marrasi',
	        4: 'To&apos;rtinchi o&apos;t ochis marrasi',
	        5: 'Beshinchi o&apos;t ochis marrasi',
	        6: 'Oltinchi o&apos;t ochis marrasi',
	        7: 'Yettinchi o&apos;t ochis marrasi',
	        8: 'Sakkizinchi o&apos;t ochis marrasi'
	    },
	    42: {
	        0: 'O&apos;yin',
	        1: 'Birinchi xarita',
	        2: 'Ikkinchi xarita',
	        3: 'Uchinchi xarita',
	        4: 'To&apos;rtinchi xarita',
	        5: 'Beshinchi xarita'
	    },
	    36: {
	        0: 'O&apos;yin',
	        1: 'Birinchi davr'
	    },
	    7: {
	        0: 'O&apos;yin',
	        1: 'Birinchi bo&apos;lim',
	        2: 'Ikkinchi bo&apos;lim',
	        3: '1-daqiqadan 15-daqiqagacha',
	        4: '16-daqiqadan 30-daqiqagacha',
	        5: '31-daqiqadan tanaffusgacha',
	        6: '46-daqiqadan 60-daqiqagacha',
	        7: '61-daqiqadan 75-daqiqagacha',
	        8: '75-daqiqadan O&apos;yin oxirigacha',
	        9: 'Burchak zarbalari',
	        10: 'Burchak zarbalari (birinchi bo&apos;lim)',
	        11: 'Sariq kartochkalar',
	        12: 'Sariq kartochkalar  (birinchi bo&apos;lim)',
	        13: 'Qo&apos;shimcha bo&apos;limlar',
	        14: 'Birinchi qo&apos;shimcha bo&apos;lim',
	        15: 'Ikkinchi qo&apos;shimcha bo&apos;lim',
	        16: 'Penaltilar seriyasi'
	    },
	    34: {
	        0: 'O&apos;yin',
	        1: 'Birinchi bo&apos;lim',
	        2: 'Ikkinchi bo&apos;lim',
	        3: '1-daqiqadan 15-daqiqagacha',
	        4: '16-daqiqadan 30-daqiqagacha',
	        5: '31-daqiqadan bo&apos;lim so&apos;ngigacha',
	        6: '46-daqiqadan 60-daqiqagacha',
	        7: '61-daqiqadan 75-daqiqagacha',
	        8: '76-daqiqadan o&apos;yin so&apos;ngigacha',
	        9: 'Burchak zarbalari',
	        10: 'Sariq kartochkalar'
	    },
	    19: {
	        0: 'O&apos;yin',
	        1: 'Birinchi davr',
	        2: 'Ikkinchi davr'
	    },
	    30: {
	        0: 'O&apos;yin',
	        1: 'Birinchi davr',
	        2: 'Ikkinchi davr',
	        3: 'Uchinchi davr',
	        4: '1-daqiqadan 10-daqiqagacha',
	        5: '11-daqiqadan 20-daqiqagacha',
	        6: '21-daqiqadan 30-daqiqagacha',
	        7: '31-daqiqadan 40-daqiqagacha',
	        8: '41-daqiqadan 50-daqiqagacha',
	        9: '51-daqiqadan 60-daqiqagacha'
	    },
	    9: {
	        0: 'O&apos;yin',
	        1: 'Birinchi davr',
	        2: 'Ikkinchi davr'
	    },
	    29: {
	        0: 'O&apos;yin',
	        1: 'Birinchi davr',
	        2: 'Ikkinchi davr',
	        3: 'Uchinchi davr',
	        4: 'To&apos;rtinchi davr',
	        5: 'Beshinchi davr',
	        6: 'Oltinchi davr',
	        7: 'Yettinchi davr',
	        8: 'Sakkizinchi davr',
	        9: 'To&apos;qqizinchi davr',
	        10: 'O&apos;ninchi davr',
	        11: 'O&apos;n birinchi davr',
	        12: 'O&apos;n ikkinchi davr',
	        13: 'O&apos;n uchinchi davr',
	        14: 'O&apos;n to&apos;rtinchi davr',
	        15: 'O&apos;n beshinchi davr',
	        16: 'O&apos;n oltinchi davr',
	        17: 'O&apos;n yettinchi davr',
	        18: 'O&apos;n sakkizinchi davr',
	        19: 'O&apos;n to&apos;qqizinchi davr',
	        20: 'Yigirmanchi davr',
	        21: 'Yigirma birinchi davr',
	        22: 'Yigirma ikkinchi davr',
	        23: 'Yigirma uchinchi davr',
	        24: 'Yigirma to&apos;rtinchi davr',
	        25: 'Yigirma beshinchi davr',
	        26: 'Yigirma oltinchi davr',
	        27: 'Yigirma yettinchi davr',
	        28: 'Yigirma sakkizinchi davr',
	        29: 'Yigirma to&apos;qqizinchi davr',
	        30: 'O&apos;ttizinchi davr',
	        31: 'O&apos;ttiz birinchi davr',
	        32: 'O&apos;ttiz ikkinchi davr',
	        33: 'O&apos;ttiz uchinchi davr',
	        34: 'O&apos;ttiz to&apos;rtinchi davr',
	        35: 'O&apos;ttiz beshinchi davr',
	        36: 'O&apos;ttiz oltinchi davr',
	        37: 'O&apos;ttiz yettinchi davr'
	    },
	    2: {
	        0: 'O&apos;yin',
	        1: 'Birinchi set',
	        2: 'Ikkinchi set',
	        3: 'Uchinchi set',
	        4: 'To&apos;rtinchi set',
	        5: 'Beshinchi set',
	        6: 'Oltinchi set',
	        7: 'Yettinchi set'
	    },
	    6: {
	        0: 'O&apos;yin',
	        1: 'Birinchi set',
	        2: 'Ikkinchi set',
	        3: 'Uchinchi set',
	        4: 'To&apos;rtinchi set',
	        5: 'Beshinchi set'
	    },
	    4: {
	        0: 'O&apos;yin',
	        1: 'Birinchi set',
	        2: 'Ikkinchi set',
	        3: 'Uchinchi set',
	        4: 'To&apos;rtinchi set',
	        5: 'Beshinchi set',
	        6: 'Oltinchi set',
	        7: '10 ochkogacha bo&apos;lgan kichik set (birinchi set)',
	        8: '15 ochkogacha bo&apos;lgan kichik set (birinchi set)',
	        9: '10 ochkogacha bo&apos;lgan kichik set (ikkinchi set)',
	        10: '15 ochkogacha bo&apos;lgan kichik set (ikkinchi set)',
	        11: '10 ochkogacha bo&apos;lgan kichik set (uchinchi set)',
	        12: '15 ochkogacha bo&apos;lgan kichik set (uchinchi set)',
	        13: '10 ochkogacha bo&apos;lgan kichik set (to&apos;rtinchi set)',
	        14: '15 ochkogacha bo&apos;lgan kichik set (to&apos;rtinchi set)'
	    },
	    8: {
	        0: 'O&apos;yin',
	        1: 'Birinchi chorak',
	        2: 'Ikkinchi chorak',
	        3: 'Uchinchi chorak',
	        4: 'To&apos;rtinchi chorak'
	    }
	};
	
	var slotConfig = {
	    32: {
	        366: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        557: sl_e1,
	        607: sl_f1,
	        122: sl_g1,
	        129: sl_h1,
	        138: sl_i1,
	        182: sl_j1,
	        367: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        558: sl_e1,
	        608: sl_f1,
	        123: sl_g1,
	        130: sl_h1,
	        139: sl_i1,
	        183: sl_j1,
	        368: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        559: sl_e1,
	        609: sl_f1,
	        124: sl_g1,
	        131: sl_h1,
	        140: sl_i1,
	        184: sl_j1,
	        362: sl_k1,
	        17: sl_c1,
	        176: sl_d1,
	        358: sl_k1,
	        13: sl_c1,
	        172: sl_d1,
	        363: sl_k1,
	        18: sl_c1,
	        177: sl_d1,
	        359: sl_k1,
	        14: sl_c1,
	        173: sl_d1,
	        364: sl_k1,
	        19: sl_c1,
	        178: sl_d1,
	        360: sl_k1,
	        15: sl_c1,
	        174: sl_d1
	    },
	    35: {
	        664: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1
	    },
	    31: {
	        664: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        769: sl_l1,
	        138: sl_i1,
	        182: sl_j1,
	        775: sl_m1,
	        765: sl_n1,
	        629: sl_e1,
	        633: sl_o1,
	        665: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        770: sl_l1,
	        139: sl_i1,
	        183: sl_j1,
	        776: sl_m1,
	        766: sl_n1,
	        630: sl_e1,
	        634: sl_o1,
	        666: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        771: sl_l1,
	        140: sl_i1,
	        184: sl_j1,
	        777: sl_m1,
	        767: sl_n1,
	        631: sl_e1,
	        635: sl_o1,
	        667: sl_b1,
	        24: sl_c1,
	        198: sl_d1,
	        772: sl_l1,
	        141: sl_i1,
	        185: sl_j1,
	        778: sl_m1,
	        768: sl_n1,
	        632: sl_e1,
	        636: sl_o1,
	        676: sl_b1,
	        248: sl_c1,
	        62: sl_d1,
	        241: sl_i1,
	        233: sl_j1,
	        406: sl_p1,
	        675: sl_b1,
	        246: sl_c1,
	        61: sl_d1,
	        240: sl_i1,
	        232: sl_j1,
	        405: sl_p1,
	        672: sl_b1,
	        58: sl_c1,
	        238: sl_d1,
	        234: sl_i1,
	        236: sl_j1,
	        673: sl_b1,
	        59: sl_c1,
	        239: sl_d1,
	        235: sl_i1,
	        237: sl_j1
	    },
	    41: {
	        664: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        782: sl_l1,
	        785: sl_m1,
	        780: sl_n1,
	        138: sl_i1,
	        182: sl_j1,
	        639: sl_e1,
	        665: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        783: sl_l1,
	        786: sl_m1,
	        781: sl_n1,
	        139: sl_i1,
	        183: sl_j1,
	        640: sl_e1,
	        64: sl_c1,
	        678: sl_b1,
	        250: sl_d1,
	        63: sl_c1,
	        677: sl_b1,
	        249: sl_d1
	    },
	    18: {
	        664: sl_b1,
	        195: sl_d1,
	        698: sl_q1,
	        21: sl_c1,
	        734: sl_r1,
	        665: sl_b1,
	        196: sl_d1,
	        699: sl_q1,
	        22: sl_c1,
	        735: sl_r1,
	        666: sl_b1,
	        197: sl_d1,
	        700: sl_q1,
	        23: sl_c1,
	        736: sl_r1
	    },
	    3: {
	        366: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        896: sl_s1,
	        138: sl_i1,
	        182: sl_j1,
	        557: sl_t1,
	        83: sl_u1,
	        788: sl_v1,
	        842: sl_w1,
	        845: sl_x1,
	        848: sl_y1,
	        607: sl_f1,
	        791: sl_z1,
	        367: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        897: sl_s1,
	        139: sl_i1,
	        183: sl_j1,
	        558: sl_t1,
	        84: sl_u1,
	        789: sl_v1,
	        843: sl_w1,
	        846: sl_x1,
	        849: sl_y1,
	        608: sl_f1,
	        792: sl_z1,
	        368: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        898: sl_s1,
	        140: sl_i1,
	        184: sl_j1,
	        559: sl_t1,
	        85: sl_u1,
	        790: sl_v1,
	        844: sl_w1,
	        847: sl_x1,
	        850: sl_y1,
	        609: sl_f1,
	        793: sl_z1,
	        362: sl_k1,
	        17: sl_c1,
	        176: sl_d1,
	        358: sl_k1,
	        13: sl_c1,
	        172: sl_d1,
	        363: sl_k1,
	        18: sl_c1,
	        177: sl_d1,
	        359: sl_k1,
	        14: sl_c1,
	        173: sl_d1
	    },
	    20: {
	        664: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1,
	        851: sl_l1,
	        665: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        139: sl_i1,
	        183: sl_j1,
	        852: sl_l1,
	        666: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        140: sl_i1,
	        184: sl_j1,
	        853: sl_l1,
	        667: sl_b1,
	        24: sl_c1,
	        198: sl_d1,
	        141: sl_i1,
	        185: sl_j1,
	        854: sl_l1,
	        199: sl_d1,
	        142: sl_i1,
	        186: sl_j1,
	        25: sl_c1,
	        668: sl_b1,
	        855: sl_l1,
	        200: sl_d1,
	        143: sl_i1,
	        187: sl_j1,
	        26: sl_c1,
	        669: sl_b1,
	        856: sl_l1,
	        201: sl_d1,
	        144: sl_i1,
	        188: sl_j1,
	        27: sl_c1,
	        670: sl_b1,
	        857: sl_l1,
	        202: sl_d1,
	        145: sl_i1,
	        189: sl_j1,
	        28: sl_c1,
	        671: sl_b1,
	        858: sl_l1
	    },
	    42: {
	        557: sl_a2,
	        1865: sl_b2,
	        558: sl_a2,
	        1866: sl_b2,
	        559: sl_a2,
	        1867: sl_b2,
	        560: sl_a2,
	        1868: sl_b2,
	        561: sl_a2,
	        1869: sl_b2
	    },
	    36: {
	        664: sl_b1,
	        21: sl_c1,
	        195: sl_d1
	    },
	    7: {
	        426: sl_v1,
	        526: sl_w1,
	        419: sl_c2,
	        519: sl_d2,
	        664: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1,
	        734: sl_r1,
	        756: sl_l1,
	        698: sl_e2,
	        794: sl_f2,
	        860: sl_g2,
	        273: sl_h2,
	        83: sl_u1,
	        727: sl_i2,
	        729: sl_j2,
	        731: sl_k2,
	        648: sl_l2,
	        420: sl_c2,
	        520: sl_d2,
	        665: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        139: sl_i1,
	        183: sl_j1,
	        735: sl_r1,
	        757: sl_l1,
	        699: sl_e2,
	        859: sl_f2,
	        861: sl_g2,
	        274: sl_h2,
	        84: sl_u1,
	        728: sl_i2,
	        649: sl_l2,
	        652: sl_b1,
	        641: sl_l2,
	        2: sl_c1,
	        160: sl_d1,
	        148: sl_i1,
	        154: sl_j1,
	        655: sl_b1,
	        642: sl_l2,
	        5: sl_c1,
	        163: sl_d1,
	        149: sl_i1,
	        155: sl_j1,
	        657: sl_b1,
	        643: sl_l2,
	        7: sl_c1,
	        165: sl_d1,
	        150: sl_i1,
	        156: sl_j1,
	        658: sl_b1,
	        644: sl_l2,
	        930: sl_c1,
	        166: sl_d1,
	        151: sl_i1,
	        157: sl_j1,
	        660: sl_b1,
	        645: sl_l2,
	        9: sl_c1,
	        168: sl_d1,
	        152: sl_i1,
	        158: sl_j1,
	        663: sl_b1,
	        646: sl_l2,
	        12: sl_c1,
	        171: sl_d1,
	        153: sl_i1,
	        159: sl_j1,
	        680: sl_b1,
	        66: sl_c1,
	        255: sl_d1,
	        438: sl_m2,
	        354: sl_i1,
	        355: sl_j1,
	        681: sl_b1,
	        67: sl_c1,
	        258: sl_d1,
	        356: sl_i1,
	        357: sl_j1,
	        690: sl_b1,
	        81: sl_c1,
	        353: sl_d1,
	        440: sl_n2,
	        441: sl_o2,
	        682: sl_b1,
	        68: sl_c1,
	        259: sl_d1,
	        146: sl_i1,
	        650: sl_l2,
	        740: sl_r1,
	        69: sl_c1,
	        262: sl_d1,
	        683: sl_b1,
	        694: sl_j2,
	        180: sl_j1,
	        70: sl_c1,
	        263: sl_d1,
	        684: sl_b1,
	        72: sl_c1,
	        277: sl_d1,
	        686: sl_b1,
	        181: sl_p2,
	        147: sl_q2,
	        741: sl_r1,
	        276: sl_r2,
	        275: sl_s2
	    },
	    34: {
	        419: sl_c2,
	        519: sl_d2,
	        664: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1,
	        734: sl_r1,
	        756: sl_t2,
	        698: sl_e2,
	        794: sl_f2,
	        860: sl_g2,
	        83: sl_u1,
	        420: sl_c2,
	        520: sl_d2,
	        665: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        139: sl_i1,
	        183: sl_j1,
	        735: sl_r1,
	        757: sl_t2,
	        699: sl_e2,
	        795: sl_f2,
	        861: sl_g2,
	        84: sl_u1,
	        652: sl_b1,
	        2: sl_c1,
	        160: sl_d1,
	        148: sl_i1,
	        154: sl_j1,
	        655: sl_b1,
	        5: sl_c1,
	        163: sl_d1,
	        149: sl_i1,
	        155: sl_j1,
	        657: sl_b1,
	        7: sl_c1,
	        165: sl_d1,
	        150: sl_i1,
	        156: sl_j1,
	        658: sl_b1,
	        930: sl_c1,
	        166: sl_d1,
	        151: sl_i1,
	        157: sl_j1,
	        660: sl_b1,
	        9: sl_c1,
	        168: sl_d1,
	        152: sl_i1,
	        158: sl_j1,
	        663: sl_b1,
	        12: sl_c1,
	        171: sl_d1,
	        153: sl_i1,
	        159: sl_j1,
	        255: sl_d1,
	        353: sl_d1
	    },
	    19: {
	        664: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        877: sl_t2,
	        138: sl_i1,
	        182: sl_j1,
	        875: sl_m1,
	        873: sl_n1,
	        196: sl_d1,
	        878: sl_t2,
	        876: sl_i1,
	        874: sl_j1,
	        665: sl_b1,
	        22: sl_c1
	    },
	    30: {
	        664: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        756: sl_l1,
	        138: sl_i1,
	        182: sl_j1,
	        734: sl_r1,
	        83: sl_u1,
	        698: sl_q1,
	        665: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        757: sl_l1,
	        139: sl_i1,
	        183: sl_j1,
	        735: sl_r1,
	        84: sl_u1,
	        699: sl_q1,
	        666: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        758: sl_l1,
	        140: sl_i1,
	        184: sl_j1,
	        736: sl_r1,
	        85: sl_u1,
	        700: sl_q1,
	        653: sl_b1,
	        161: sl_d1,
	        3: sl_c1,
	        654: sl_b1,
	        162: sl_d1,
	        4: sl_c1,
	        656: sl_b1,
	        164: sl_d1,
	        6: sl_c1,
	        659: sl_b1,
	        167: sl_d1,
	        8: sl_c1,
	        661: sl_b1,
	        169: sl_d1,
	        10: sl_c1,
	        662: sl_b1,
	        170: sl_d1,
	        11: sl_c1
	    },
	    9: {
	        664: sl_b1,
	        195: sl_d1,
	        665: sl_b1,
	        196: sl_d1
	    },
	    29: {
	        366: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        466: sl_u2,
	        557: sl_v2,
	        799: sl_w2,
	        83: sl_u1,
	        367: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        467: sl_u2,
	        558: sl_v2,
	        800: sl_w2,
	        84: sl_u1,
	        368: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        468: sl_u2,
	        559: sl_v2,
	        801: sl_w2,
	        85: sl_u1,
	        369: sl_b1,
	        24: sl_c1,
	        198: sl_d1,
	        469: sl_u2,
	        560: sl_v2,
	        802: sl_w2,
	        86: sl_u1,
	        370: sl_b1,
	        25: sl_c1,
	        199: sl_d1,
	        470: sl_u2,
	        561: sl_v2,
	        803: sl_w2,
	        87: sl_u1,
	        371: sl_b1,
	        26: sl_c1,
	        200: sl_d1,
	        471: sl_u2,
	        562: sl_v2,
	        804: sl_w2,
	        88: sl_u1,
	        372: sl_b1,
	        27: sl_c1,
	        201: sl_d1,
	        472: sl_u2,
	        563: sl_v2,
	        805: sl_w2,
	        89: sl_u1,
	        373: sl_b1,
	        28: sl_c1,
	        202: sl_d1,
	        473: sl_u2,
	        564: sl_v2,
	        806: sl_w2,
	        90: sl_u1,
	        374: sl_b1,
	        29: sl_c1,
	        203: sl_d1,
	        474: sl_u2,
	        565: sl_v2,
	        807: sl_w2,
	        91: sl_u1,
	        375: sl_b1,
	        30: sl_c1,
	        204: sl_d1,
	        475: sl_u2,
	        566: sl_v2,
	        808: sl_w2,
	        92: sl_u1,
	        376: sl_b1,
	        31: sl_c1,
	        205: sl_d1,
	        476: sl_u2,
	        567: sl_v2,
	        809: sl_w2,
	        93: sl_u1,
	        377: sl_b1,
	        32: sl_c1,
	        206: sl_d1,
	        477: sl_u2,
	        568: sl_v2,
	        810: sl_w2,
	        94: sl_u1,
	        378: sl_b1,
	        33: sl_c1,
	        207: sl_d1,
	        478: sl_u2,
	        569: sl_v2,
	        811: sl_w2,
	        95: sl_u1,
	        379: sl_b1,
	        34: sl_c1,
	        208: sl_d1,
	        479: sl_u2,
	        570: sl_v2,
	        812: sl_w2,
	        96: sl_u1,
	        380: sl_b1,
	        35: sl_c1,
	        209: sl_d1,
	        480: sl_u2,
	        571: sl_v2,
	        813: sl_w2,
	        97: sl_u1,
	        381: sl_b1,
	        36: sl_c1,
	        210: sl_d1,
	        481: sl_u2,
	        572: sl_v2,
	        814: sl_w2,
	        98: sl_u1,
	        382: sl_b1,
	        37: sl_c1,
	        211: sl_d1,
	        482: sl_u2,
	        573: sl_v2,
	        815: sl_w2,
	        99: sl_u1,
	        383: sl_b1,
	        38: sl_c1,
	        212: sl_d1,
	        483: sl_u2,
	        574: sl_v2,
	        816: sl_w2,
	        100: sl_u1,
	        384: sl_b1,
	        39: sl_c1,
	        213: sl_d1,
	        484: sl_u2,
	        575: sl_v2,
	        817: sl_w2,
	        101: sl_u1,
	        385: sl_b1,
	        40: sl_c1,
	        214: sl_d1,
	        485: sl_u2,
	        576: sl_v2,
	        818: sl_w2,
	        104: sl_u1,
	        386: sl_b1,
	        41: sl_c1,
	        215: sl_d1,
	        486: sl_u2,
	        577: sl_v2,
	        819: sl_w2,
	        105: sl_u1,
	        387: sl_b1,
	        42: sl_c1,
	        216: sl_d1,
	        487: sl_u2,
	        578: sl_v2,
	        820: sl_w2,
	        106: sl_u1,
	        388: sl_b1,
	        43: sl_c1,
	        217: sl_d1,
	        488: sl_u2,
	        579: sl_v2,
	        821: sl_w2,
	        107: sl_u1,
	        389: sl_b1,
	        44: sl_c1,
	        218: sl_d1,
	        489: sl_u2,
	        580: sl_v2,
	        822: sl_w2,
	        108: sl_u1,
	        390: sl_b1,
	        45: sl_c1,
	        219: sl_d1,
	        490: sl_u2,
	        581: sl_v2,
	        823: sl_w2,
	        109: sl_u1,
	        391: sl_x2,
	        46: sl_y2,
	        220: sl_z2,
	        491: sl_a3,
	        582: sl_b3,
	        824: sl_c3,
	        110: sl_d3,
	        392: sl_b1,
	        47: sl_c1,
	        221: sl_d1,
	        492: sl_u2,
	        583: sl_v2,
	        825: sl_w2,
	        111: sl_u1,
	        393: sl_b1,
	        48: sl_c1,
	        222: sl_d1,
	        493: sl_u2,
	        584: sl_v2,
	        826: sl_w2,
	        112: sl_u1,
	        394: sl_b1,
	        49: sl_c1,
	        223: sl_d1,
	        494: sl_u2,
	        585: sl_v2,
	        827: sl_w2,
	        113: sl_u1,
	        395: sl_b1,
	        50: sl_c1,
	        224: sl_d1,
	        495: sl_u2,
	        586: sl_v2,
	        828: sl_w2,
	        114: sl_u1,
	        396: sl_b1,
	        51: sl_c1,
	        225: sl_d1,
	        496: sl_u2,
	        587: sl_v2,
	        829: sl_w2,
	        115: sl_u1,
	        397: sl_b1,
	        52: sl_c1,
	        226: sl_d1,
	        497: sl_u2,
	        588: sl_v2,
	        830: sl_w2,
	        116: sl_u1,
	        398: sl_b1,
	        53: sl_c1,
	        227: sl_d1,
	        498: sl_u2,
	        589: sl_v2,
	        831: sl_w2,
	        117: sl_u1,
	        399: sl_b1,
	        54: sl_c1,
	        228: sl_d1,
	        499: sl_u2,
	        590: sl_v2,
	        832: sl_w2,
	        118: sl_u1,
	        400: sl_b1,
	        55: sl_c1,
	        229: sl_d1,
	        500: sl_u2,
	        591: sl_v2,
	        833: sl_w2,
	        119: sl_u1,
	        401: sl_b1,
	        56: sl_c1,
	        230: sl_d1,
	        501: sl_u2,
	        592: sl_v2,
	        834: sl_w2,
	        120: sl_u1,
	        402: sl_b1,
	        57: sl_c1,
	        231: sl_d1,
	        502: sl_u2,
	        593: sl_v2,
	        835: sl_w2,
	        121: sl_u1
	    },
	    2: {
	        366: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1,
	        607: sl_e3,
	        557: sl_f3,
	        863: sl_l1,
	        885: sl_l1,
	        122: sl_g3,
	        129: sl_h3,
	        83: sl_i3,
	        367: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        139: sl_i1,
	        183: sl_j1,
	        608: sl_e3,
	        558: sl_f3,
	        864: sl_l1,
	        886: sl_l1,
	        123: sl_g3,
	        130: sl_h3,
	        84: sl_i3,
	        368: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        140: sl_i1,
	        184: sl_j1,
	        609: sl_e3,
	        559: sl_f3,
	        865: sl_l1,
	        887: sl_l1,
	        124: sl_g3,
	        131: sl_h3,
	        85: sl_i3,
	        369: sl_b1,
	        24: sl_c1,
	        198: sl_d1,
	        141: sl_i1,
	        185: sl_j1,
	        610: sl_e3,
	        560: sl_f3,
	        866: sl_l1,
	        888: sl_l1,
	        125: sl_g3,
	        132: sl_h3,
	        86: sl_i3,
	        370: sl_b1,
	        25: sl_c1,
	        199: sl_d1,
	        142: sl_i1,
	        186: sl_j1,
	        611: sl_e3,
	        561: sl_f3,
	        867: sl_l1,
	        889: sl_l1,
	        126: sl_g3,
	        133: sl_h3,
	        87: sl_i3,
	        371: sl_b1,
	        26: sl_c1,
	        200: sl_d1,
	        143: sl_i1,
	        187: sl_j1,
	        612: sl_e3,
	        562: sl_f3,
	        868: sl_l1,
	        890: sl_l1,
	        127: sl_g3,
	        134: sl_h3,
	        88: sl_i3,
	        372: sl_b1,
	        27: sl_c1,
	        201: sl_d1,
	        144: sl_i1,
	        188: sl_j1,
	        613: sl_e3,
	        563: sl_f3,
	        869: sl_l1,
	        891: sl_l1,
	        128: sl_g3,
	        135: sl_h3,
	        89: sl_i3
	    },
	    6: {
	        1861: sl_j3,
	        366: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1,
	        333: sl_k3,
	        557: sl_l3,
	        745: sl_r1,
	        896: sl_m3,
	        618: sl_n3,
	        594: sl_o3,
	        759: sl_p3,
	        750: sl_q3,
	        190: sl_r3,
	        83: sl_u1,
	        300: sl_s3,
	        310: sl_t3,
	        545: sl_u3,
	        508: sl_v3,
	        552: sl_w3,
	        708: sl_x3,
	        76: sl_y3,
	        367: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        139: sl_i1,
	        183: sl_j1,
	        334: sl_k3,
	        558: sl_l3,
	        746: sl_r1,
	        897: sl_m3,
	        619: sl_n3,
	        595: sl_o3,
	        760: sl_p3,
	        751: sl_q3,
	        191: sl_r3,
	        84: sl_u1,
	        301: sl_s3,
	        311: sl_t3,
	        546: sl_u3,
	        509: sl_v3,
	        553: sl_w3,
	        709: sl_x3,
	        77: sl_y3,
	        368: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        140: sl_i1,
	        184: sl_j1,
	        335: sl_k3,
	        559: sl_l3,
	        747: sl_r1,
	        898: sl_m3,
	        620: sl_n3,
	        596: sl_o3,
	        761: sl_p3,
	        752: sl_q3,
	        192: sl_r3,
	        85: sl_u1,
	        302: sl_s3,
	        312: sl_t3,
	        547: sl_u3,
	        510: sl_v3,
	        554: sl_w3,
	        710: sl_x3,
	        78: sl_y3,
	        369: sl_b1,
	        24: sl_c1,
	        198: sl_d1,
	        141: sl_i1,
	        185: sl_j1,
	        336: sl_k3,
	        560: sl_l3,
	        748: sl_r1,
	        899: sl_m3,
	        621: sl_n3,
	        597: sl_o3,
	        762: sl_p3,
	        753: sl_q3,
	        193: sl_r3,
	        86: sl_u1,
	        303: sl_s3,
	        313: sl_t3,
	        548: sl_u3,
	        511: sl_v3,
	        555: sl_w3,
	        711: sl_x3,
	        79: sl_y3,
	        370: sl_b1,
	        25: sl_c1,
	        199: sl_d1,
	        142: sl_i1,
	        186: sl_j1,
	        337: sl_k3,
	        561: sl_l3,
	        749: sl_r1,
	        900: sl_m3,
	        622: sl_n3,
	        598: sl_o3,
	        763: sl_p3,
	        754: sl_q3,
	        194: sl_r3,
	        87: sl_u1,
	        304: sl_s3,
	        314: sl_t3,
	        549: sl_u3,
	        512: sl_v3,
	        556: sl_w3,
	        712: sl_x3,
	        80: sl_y3
	    },
	    4: {
	        366: sl_b1,
	        21: sl_c1,
	        195: sl_d1,
	        138: sl_i1,
	        182: sl_j1,
	        896: sl_m3,
	        557: sl_e1,
	        836: sl_v1,
	        909: sl_w1,
	        914: sl_l1,
	        920: sl_l1,
	        83: sl_u1,
	        903: sl_z1,
	        607: sl_z3,
	        367: sl_b1,
	        22: sl_c1,
	        196: sl_d1,
	        139: sl_i1,
	        183: sl_j1,
	        897: sl_m3,
	        558: sl_e1,
	        837: sl_v1,
	        910: sl_w1,
	        915: sl_l1,
	        921: sl_l1,
	        84: sl_u1,
	        904: sl_z1,
	        608: sl_z3,
	        368: sl_b1,
	        23: sl_c1,
	        197: sl_d1,
	        140: sl_i1,
	        184: sl_j1,
	        898: sl_m3,
	        559: sl_e1,
	        838: sl_v1,
	        911: sl_w1,
	        916: sl_l1,
	        922: sl_l1,
	        85: sl_u1,
	        905: sl_z1,
	        609: sl_z3,
	        369: sl_b1,
	        24: sl_c1,
	        198: sl_d1,
	        141: sl_i1,
	        185: sl_j1,
	        899: sl_m3,
	        560: sl_e1,
	        839: sl_v1,
	        912: sl_w1,
	        917: sl_l1,
	        923: sl_l1,
	        86: sl_u1,
	        906: sl_z1,
	        610: sl_z3,
	        370: sl_b1,
	        25: sl_c1,
	        199: sl_d1,
	        142: sl_i1,
	        186: sl_j1,
	        900: sl_m3,
	        561: sl_e1,
	        840: sl_v1,
	        913: sl_w1,
	        918: sl_l1,
	        924: sl_l1,
	        87: sl_u1,
	        907: sl_z1,
	        611: sl_z3,
	        26: sl_c1,
	        200: sl_d1,
	        143: sl_i1,
	        187: sl_j1,
	        371: sl_b1,
	        562: sl_e1,
	        919: sl_l1,
	        925: sl_l1,
	        901: sl_m3,
	        908: sl_z1,
	        88: sl_u1,
	        362: sl_k1,
	        17: sl_c1,
	        176: sl_d1,
	        358: sl_k1,
	        13: sl_c1,
	        172: sl_d1,
	        363: sl_k1,
	        18: sl_c1,
	        177: sl_d1,
	        359: sl_k1,
	        14: sl_c1,
	        173: sl_d1,
	        364: sl_k1,
	        19: sl_c1,
	        178: sl_d1,
	        360: sl_k1,
	        15: sl_c1,
	        174: sl_d1,
	        365: sl_k1,
	        20: sl_c1,
	        179: sl_d1,
	        361: sl_k1,
	        16: sl_c1,
	        175: sl_d1
	    },
	    8: {
	        664: sl_b1,
	        195: sl_d1,
	        665: sl_b1,
	        196: sl_d1,
	        666: sl_b1,
	        197: sl_d1,
	        667: sl_b1,
	        198: sl_d1
	    }
	};
	
	var baseOutcomeConfig = {
	    11: {
	        74: bo_b1,
	        349: bo_c1,
	        256: bo_d1,
	        306: bo_e1,
	        103: bo_f1,
	        403: bo_g1,
	        443: bo_h1,
	        608: bo_i1
	    },
	    32: {
	        73: bo_b1,
	        318: bo_c1,
	        21: bo_j1,
	        22: bo_k1,
	        23: bo_l1,
	        195: bo_m1,
	        196: bo_n1,
	        197: bo_o1,
	        352: bo_p1,
	        748: bo_q1,
	        102: bo_f1,
	        403: bo_g1,
	        366: bo_r1,
	        367: bo_s1,
	        368: bo_t1,
	        138: bo_u1,
	        139: bo_v1,
	        140: bo_w1,
	        182: bo_x1,
	        183: bo_y1,
	        184: bo_z1,
	        122: bo_a2,
	        123: bo_b2,
	        124: bo_c2,
	        129: bo_d2,
	        130: bo_e2,
	        131: bo_f2,
	        566: bo_g2,
	        567: bo_h2,
	        568: bo_i2,
	        616: bo_j2,
	        617: bo_k2,
	        618: bo_l2,
	        257: bo_d1,
	        307: bo_e1,
	        443: bo_h1,
	        608: bo_i1,
	        362: bo_m2,
	        363: bo_n2,
	        364: bo_o2,
	        17: bo_p2,
	        18: bo_q2,
	        19: bo_r2,
	        176: bo_s2,
	        177: bo_t2,
	        178: bo_u2,
	        358: bo_v2,
	        359: bo_w2,
	        360: bo_x2,
	        13: bo_y2,
	        14: bo_z2,
	        15: bo_a3,
	        172: bo_b3,
	        173: bo_c3,
	        174: bo_d3,
	        256: bo_d1,
	        306: bo_e1
	    },
	    35: {
	        138: bo_e3,
	        256: bo_d1,
	        21: bo_f3,
	        673: bo_g3,
	        182: bo_h3,
	        306: bo_e1,
	        698: bo_g1,
	        731: bo_i3,
	        656: bo_j3,
	        195: bo_k3,
	        74: bo_b1,
	        349: bo_c1,
	        443: bo_h1,
	        608: bo_i1,
	        911: bo_l3,
	        426: bo_m3,
	        535: bo_n3,
	        871: bo_o3,
	        710: bo_p3,
	        742: bo_q3
	    },
	    10: {
	        74: bo_b1,
	        349: bo_c1,
	        256: bo_d1,
	        306: bo_e1,
	        103: bo_c1,
	        403: bo_g1,
	        1: bo_r3,
	        443: bo_h1,
	        608: bo_i1
	    },
	    31: {
	        74: bo_b1,
	        349: bo_c1,
	        21: bo_s3,
	        22: bo_t3,
	        23: bo_u3,
	        24: bo_v3,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_w3,
	        196: bo_x3,
	        197: bo_y3,
	        198: bo_z3,
	        673: bo_a4,
	        674: bo_b4,
	        675: bo_c4,
	        676: bo_d4,
	        103: bo_f1,
	        403: bo_g1,
	        138: bo_e4,
	        139: bo_f4,
	        140: bo_g4,
	        141: bo_h4,
	        182: bo_i4,
	        183: bo_j4,
	        184: bo_k4,
	        185: bo_l4,
	        238: bo_m4,
	        682: bo_n4,
	        239: bo_o4,
	        58: bo_p4,
	        59: bo_q4,
	        681: bo_r4,
	        234: bo_s4,
	        235: bo_t4,
	        236: bo_u4,
	        237: bo_v4,
	        725: bo_w4,
	        726: bo_x4,
	        727: bo_y4,
	        728: bo_z4,
	        782: bo_a5,
	        778: bo_b5,
	        779: bo_c5,
	        780: bo_d5,
	        781: bo_e5,
	        783: bo_f5,
	        773: bo_g5,
	        474: bo_h5,
	        421: bo_i5,
	        530: bo_j5,
	        422: bo_k5,
	        531: bo_l5,
	        444: bo_m5,
	        888: bo_n5,
	        280: bo_o5,
	        317: bo_p5,
	        424: bo_q5,
	        533: bo_r5,
	        423: bo_s5,
	        532: bo_t5,
	        637: bo_u5,
	        788: bo_v5,
	        784: bo_w5,
	        785: bo_x5,
	        786: bo_y5,
	        787: bo_z5,
	        774: bo_w5,
	        775: bo_x5,
	        776: bo_y5,
	        777: bo_z5,
	        281: bo_a6,
	        137: bo_b6,
	        246: bo_c6,
	        248: bo_d6,
	        240: bo_e6,
	        232: bo_f6,
	        241: bo_g6,
	        233: bo_h6,
	        61: bo_i6,
	        62: bo_j6,
	        684: bo_k6,
	        685: bo_l6,
	        443: bo_h1,
	        608: bo_i1,
	        890: bo_m6,
	        242: bo_n6,
	        245: bo_o6,
	        243: bo_p6,
	        60: bo_q6,
	        683: bo_r6,
	        406: bo_s6,
	        405: bo_t6,
	        404: bo_u6,
	        700: bo_v6,
	        408: bo_w6,
	        407: bo_x6,
	        247: bo_y6,
	        244: bo_z6,
	        638: bo_a7,
	        639: bo_b7,
	        640: bo_c7,
	        641: bo_d7,
	        646: bo_e7,
	        642: bo_f7,
	        643: bo_g7,
	        644: bo_h7,
	        645: bo_i7
	    },
	    41: {
	        74: bo_b1,
	        349: bo_c1,
	        21: bo_j7,
	        22: bo_k7,
	        403: bo_g1,
	        673: bo_l7,
	        674: bo_m7,
	        195: bo_n7,
	        196: bo_o7,
	        791: bo_p7,
	        792: bo_q7,
	        637: bo_u5,
	        796: bo_v5,
	        794: bo_r7,
	        795: bo_s7,
	        789: bo_r7,
	        790: bo_s7,
	        725: bo_t7,
	        726: bo_u7,
	        793: bo_a5,
	        411: bo_v7,
	        701: bo_w7,
	        251: bo_x7,
	        252: bo_y7,
	        409: bo_k5,
	        430: bo_l5,
	        410: bo_z7,
	        431: bo_a8,
	        281: bo_a6,
	        137: bo_b6,
	        249: bo_c6,
	        250: bo_d6,
	        63: bo_i6,
	        64: bo_j6,
	        686: bo_k6,
	        687: bo_l6,
	        103: bo_f1,
	        256: bo_d1,
	        306: bo_e1,
	        138: bo_b8,
	        139: bo_c8,
	        182: bo_d8,
	        183: bo_e8,
	        443: bo_h1,
	        608: bo_i1,
	        648: bo_f8,
	        649: bo_g8
	    },
	    18: {
	        74: bo_b1,
	        349: bo_c1,
	        656: bo_j3,
	        698: bo_g1,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_h8,
	        196: bo_i8,
	        197: bo_j8,
	        673: bo_k8,
	        674: bo_l8,
	        675: bo_m8,
	        610: bo_n8,
	        443: bo_h1,
	        608: bo_i1,
	        806: bo_o8,
	        893: bo_p8,
	        707: bo_q8,
	        708: bo_r8,
	        709: bo_s8,
	        889: bo_o3,
	        904: bo_t8,
	        253: bo_u8,
	        688: bo_v8,
	        65: bo_w8,
	        751: bo_q3,
	        21: bo_x8,
	        22: bo_y8,
	        23: bo_z8,
	        743: bo_a9,
	        744: bo_b9,
	        745: bo_c9,
	        615: bo_d9,
	        350: bo_u8
	    },
	    3: {
	        73: bo_b1,
	        318: bo_c1,
	        21: bo_e9,
	        22: bo_f9,
	        23: bo_g9,
	        195: bo_h9,
	        196: bo_i9,
	        197: bo_j9,
	        352: bo_k9,
	        746: bo_q3,
	        102: bo_l9,
	        403: bo_g1,
	        138: bo_m9,
	        139: bo_n9,
	        140: bo_o9,
	        182: bo_p9,
	        183: bo_q9,
	        184: bo_r9,
	        366: bo_r1,
	        367: bo_s1,
	        368: bo_t1,
	        566: bo_g2,
	        567: bo_h2,
	        568: bo_i2,
	        74: bo_s9,
	        854: bo_t9,
	        855: bo_u9,
	        856: bo_v9,
	        857: bo_t9,
	        858: bo_u9,
	        859: bo_v9,
	        797: bo_w9,
	        798: bo_x9,
	        799: bo_y9,
	        851: bo_z9,
	        852: bo_a10,
	        853: bo_b10,
	        83: bo_c10,
	        84: bo_d10,
	        85: bo_e10,
	        905: bo_f10,
	        906: bo_g10,
	        907: bo_h10,
	        443: bo_h1,
	        608: bo_i1,
	        362: bo_i10,
	        363: bo_j10,
	        17: bo_k10,
	        18: bo_l10,
	        176: bo_m10,
	        177: bo_n10,
	        358: bo_o10,
	        359: bo_p10,
	        13: bo_q10,
	        14: bo_r10,
	        172: bo_s10,
	        173: bo_t10,
	        616: bo_u10,
	        617: bo_v10,
	        618: bo_w10,
	        891: bo_x10,
	        257: bo_d1,
	        307: bo_e1,
	        800: bo_y10,
	        801: bo_z10,
	        802: bo_a11
	    },
	    20: {
	        74: bo_b1,
	        349: bo_c1,
	        256: bo_d1,
	        306: bo_e1,
	        698: bo_g1,
	        195: bo_b11,
	        196: bo_c11,
	        197: bo_d11,
	        198: bo_e11,
	        199: bo_f11,
	        200: bo_g11,
	        201: bo_h11,
	        202: bo_i11,
	        138: bo_j11,
	        139: bo_k11,
	        140: bo_l11,
	        141: bo_m11,
	        142: bo_n11,
	        143: bo_o11,
	        144: bo_p11,
	        145: bo_q11,
	        182: bo_r11,
	        183: bo_s11,
	        184: bo_t11,
	        185: bo_u11,
	        186: bo_v11,
	        187: bo_w11,
	        188: bo_x11,
	        189: bo_y11,
	        21: bo_z11,
	        22: bo_a12,
	        23: bo_b12,
	        24: bo_c12,
	        25: bo_d12,
	        26: bo_e12,
	        27: bo_f12,
	        28: bo_g12,
	        673: bo_h12,
	        674: bo_i12,
	        675: bo_j12,
	        676: bo_k12,
	        677: bo_l12,
	        678: bo_m12,
	        679: bo_n12,
	        680: bo_o12,
	        860: bo_p12,
	        861: bo_q12,
	        862: bo_r12,
	        863: bo_s12,
	        864: bo_t12,
	        865: bo_u12,
	        866: bo_v12,
	        867: bo_w12,
	        443: bo_h1,
	        608: bo_i1
	    },
	    5: {
	        349: bo_c1,
	        698: bo_g1,
	        443: bo_h1,
	        608: bo_i1,
	        945: bo_x12,
	        948: bo_y12,
	        949: bo_z12
	    },
	    40: {
	        656: bo_j3,
	        698: bo_g1,
	        443: bo_h1,
	        608: bo_i1
	    },
	    37: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    38: {
	        403: bo_g1,
	        443: bo_h1,
	        608: bo_i1,
	        74: bo_b1,
	        349: bo_c1,
	        615: bo_a13,
	        413: bo_b13,
	        414: bo_c13
	    },
	    42: {
	        403: bo_g1,
	        443: bo_h1,
	        608: bo_i1,
	        74: bo_b1,
	        349: bo_c1,
	        615: bo_d13,
	        413: bo_b13,
	        414: bo_e13,
	        566: bo_f13,
	        567: bo_g13,
	        568: bo_h13,
	        569: bo_i13,
	        570: bo_j13,
	        698: bo_k13,
	        366: bo_l13,
	        367: bo_m13,
	        368: bo_n13,
	        369: bo_o13,
	        370: bo_p13,
	        940: bo_q13,
	        941: bo_r13,
	        942: bo_s13,
	        943: bo_t13,
	        944: bo_u13
	    },
	    26: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    25: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    16: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    12: {
	        74: bo_b1,
	        349: bo_c1,
	        656: bo_j3,
	        698: bo_g1,
	        256: bo_d1,
	        306: bo_e1,
	        103: bo_f1,
	        443: bo_h1,
	        608: bo_i1
	    },
	    36: {
	        610: bo_v13,
	        698: bo_g1,
	        656: bo_j3,
	        74: bo_b1,
	        349: bo_c1,
	        615: bo_d9,
	        256: bo_d1,
	        306: bo_e1,
	        673: bo_k8,
	        21: bo_x8,
	        195: bo_h8,
	        443: bo_h1,
	        608: bo_i1
	    },
	    7: {
	        425: bo_w13,
	        534: bo_x13,
	        540: bo_y13,
	        343: bo_z13,
	        345: bo_a14,
	        260: bo_b14,
	        261: bo_c14,
	        83: bo_d14,
	        84: bo_e14,
	        803: bo_f14,
	        868: bo_g14,
	        869: bo_h14,
	        870: bo_i14,
	        805: bo_j14,
	        892: bo_k14,
	        346: bo_l14,
	        419: bo_m14,
	        528: bo_n14,
	        420: bo_o14,
	        529: bo_p14,
	        707: bo_q14,
	        708: bo_r14,
	        706: bo_s14,
	        804: bo_t14,
	        474: bo_u14,
	        614: bo_v14,
	        609: bo_w14,
	        416: bo_x14,
	        732: bo_y14,
	        525: bo_z14,
	        850: bo_a15,
	        473: bo_b15,
	        442: bo_c15,
	        729: bo_d15,
	        538: bo_e15,
	        542: bo_f15,
	        730: bo_g15,
	        471: bo_h15,
	        635: bo_i15,
	        714: bo_j15,
	        624: bo_k15,
	        625: bo_l15,
	        715: bo_m15,
	        650: bo_n15,
	        651: bo_o15,
	        652: bo_p15,
	        653: bo_q15,
	        654: bo_r15,
	        655: bo_s15,
	        634: bo_t15,
	        626: bo_u15,
	        733: bo_v15,
	        734: bo_w15,
	        258: bo_x15,
	        259: bo_y15,
	        66: bo_z15,
	        67: bo_a16,
	        81: bo_b16,
	        68: bo_c16,
	        689: bo_d16,
	        690: bo_e16,
	        699: bo_f16,
	        691: bo_g16,
	        723: bo_h16,
	        633: bo_i16,
	        74: bo_b1,
	        349: bo_j16,
	        656: bo_k16,
	        698: bo_g1,
	        322: bo_l16,
	        904: bo_m16,
	        1: bo_r3,
	        136: bo_n16,
	        747: bo_q3,
	        871: bo_o16,
	        255: bo_p16,
	        705: bo_q16,
	        323: bo_r16,
	        324: bo_s16,
	        702: bo_t16,
	        278: bo_u16,
	        256: bo_v16,
	        306: bo_w16,
	        195: bo_x16,
	        196: bo_y16,
	        21: bo_z16,
	        22: bo_a17,
	        282: bo_b17,
	        911: bo_c17,
	        353: bo_d17,
	        673: bo_g3,
	        674: bo_e17,
	        2: bo_f17,
	        5: bo_g17,
	        7: bo_h17,
	        939: bo_i17,
	        9: bo_j17,
	        12: bo_k17,
	        417: bo_l17,
	        526: bo_m17,
	        325: bo_n17,
	        103: bo_o17,
	        160: bo_p17,
	        163: bo_q17,
	        165: bo_r17,
	        166: bo_s17,
	        168: bo_t17,
	        171: bo_u17,
	        148: bo_v17,
	        149: bo_w17,
	        150: bo_x17,
	        151: bo_y17,
	        152: bo_z17,
	        153: bo_a18,
	        154: bo_b18,
	        155: bo_c18,
	        156: bo_d18,
	        157: bo_e18,
	        158: bo_f18,
	        159: bo_g18,
	        731: bo_d9,
	        765: bo_h18,
	        766: bo_i18,
	        415: bo_j18,
	        524: bo_k18,
	        418: bo_l18,
	        527: bo_m18,
	        743: bo_n18,
	        744: bo_o18,
	        710: bo_p3,
	        321: bo_p18,
	        326: bo_q18,
	        327: bo_r18,
	        724: bo_s18,
	        661: bo_t18,
	        664: bo_u18,
	        666: bo_v18,
	        667: bo_w18,
	        669: bo_x18,
	        672: bo_y18,
	        426: bo_z18,
	        535: bo_a19,
	        537: bo_b19,
	        541: bo_c19,
	        539: bo_d19,
	        138: bo_e19,
	        139: bo_f19,
	        182: bo_g19,
	        183: bo_h19,
	        437: bo_i19,
	        436: bo_j19,
	        694: bo_k13,
	        71: bo_k19,
	        271: bo_l19,
	        268: bo_m19,
	        265: bo_n19,
	        267: bo_o19,
	        270: bo_p19,
	        272: bo_q19,
	        269: bo_r19,
	        266: bo_s19,
	        264: bo_t19,
	        281: bo_u19,
	        137: bo_v19,
	        660: bo_j3,
	        880: bo_w19,
	        879: bo_x19,
	        429: bo_y19,
	        433: bo_z19,
	        443: bo_h1,
	        608: bo_i1,
	        881: bo_a20,
	        273: bo_b20,
	        274: bo_c20,
	        435: bo_d20,
	        704: bo_e20,
	        432: bo_f20,
	        428: bo_g20,
	        434: bo_h20,
	        439: bo_i20,
	        440: bo_j20,
	        441: bo_k20,
	        438: bo_l20,
	        623: bo_m20,
	        180: bo_n20,
	        146: bo_o20,
	        659: bo_p20,
	        749: bo_q20,
	        69: bo_r20,
	        262: bo_s20,
	        692: bo_t20,
	        703: bo_u20,
	        70: bo_v20,
	        263: bo_w20,
	        693: bo_x20,
	        72: bo_y20,
	        277: bo_z20,
	        695: bo_a21,
	        750: bo_b21,
	        181: bo_c21,
	        147: bo_d21,
	        276: bo_e21,
	        275: bo_f21,
	        735: bo_g21,
	        736: bo_h21,
	        737: bo_i21,
	        738: bo_j21,
	        739: bo_k21,
	        740: bo_l21,
	        356: bo_m21,
	        357: bo_n21,
	        354: bo_o21,
	        355: bo_p21,
	        937: bo_q21,
	        657: bo_r21,
	        658: bo_s21,
	        412: bo_t21
	    },
	    14: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    34: {
	        425: bo_u21,
	        534: bo_v21,
	        540: bo_y13,
	        343: bo_z13,
	        345: bo_a14,
	        260: bo_b14,
	        261: bo_c14,
	        83: bo_d14,
	        84: bo_e14,
	        803: bo_f14,
	        868: bo_g14,
	        869: bo_h14,
	        870: bo_i14,
	        346: bo_l14,
	        419: bo_m14,
	        528: bo_n14,
	        420: bo_o14,
	        529: bo_p14,
	        707: bo_q14,
	        708: bo_r14,
	        706: bo_s14,
	        538: bo_e15,
	        74: bo_b1,
	        349: bo_w21,
	        656: bo_k16,
	        698: bo_g1,
	        322: bo_l16,
	        904: bo_m16,
	        1: bo_r3,
	        136: bo_n16,
	        747: bo_q3,
	        871: bo_o16,
	        255: bo_p16,
	        705: bo_q16,
	        323: bo_r16,
	        324: bo_s16,
	        702: bo_t16,
	        278: bo_x21,
	        256: bo_v16,
	        306: bo_w16,
	        195: bo_x16,
	        196: bo_y16,
	        21: bo_z16,
	        22: bo_a17,
	        282: bo_b17,
	        911: bo_c17,
	        353: bo_d17,
	        673: bo_g3,
	        674: bo_e17,
	        2: bo_f17,
	        5: bo_g17,
	        7: bo_h17,
	        939: bo_i17,
	        9: bo_j17,
	        12: bo_k17,
	        417: bo_l17,
	        526: bo_m17,
	        325: bo_n17,
	        103: bo_o17,
	        160: bo_p17,
	        163: bo_q17,
	        165: bo_r17,
	        166: bo_s17,
	        168: bo_t17,
	        171: bo_u17,
	        148: bo_v17,
	        149: bo_w17,
	        150: bo_x17,
	        151: bo_y17,
	        152: bo_z17,
	        153: bo_a18,
	        154: bo_b18,
	        155: bo_c18,
	        156: bo_d18,
	        157: bo_e18,
	        158: bo_f18,
	        159: bo_g18,
	        731: bo_d9,
	        765: bo_h18,
	        766: bo_i18,
	        415: bo_y21,
	        524: bo_z21,
	        418: bo_l18,
	        527: bo_m18,
	        743: bo_n18,
	        744: bo_o18,
	        710: bo_p3,
	        321: bo_p18,
	        326: bo_q18,
	        327: bo_r18,
	        724: bo_s18,
	        661: bo_t18,
	        664: bo_u18,
	        666: bo_v18,
	        667: bo_w18,
	        669: bo_x18,
	        672: bo_y18,
	        426: bo_z18,
	        535: bo_a19,
	        537: bo_b19,
	        541: bo_c19,
	        539: bo_d19,
	        138: bo_e19,
	        139: bo_f19,
	        182: bo_g19,
	        183: bo_h19,
	        443: bo_h1,
	        608: bo_i1
	    },
	    19: {
	        74: bo_b1,
	        349: bo_c1,
	        698: bo_g1,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_k3,
	        196: bo_a22,
	        103: bo_f1,
	        615: bo_d9,
	        886: bo_b22,
	        887: bo_c22,
	        911: bo_d22,
	        884: bo_e22,
	        885: bo_f22,
	        882: bo_g22,
	        883: bo_h22,
	        723: bo_i22,
	        673: bo_g3,
	        674: bo_e17,
	        21: bo_f3,
	        22: bo_j22,
	        138: bo_d1,
	        182: bo_e1,
	        443: bo_h1,
	        608: bo_i1
	    },
	    30: {
	        74: bo_b1,
	        349: bo_c1,
	        656: bo_j3,
	        698: bo_g1,
	        21: bo_x8,
	        22: bo_y8,
	        23: bo_z8,
	        279: bo_k22,
	        610: bo_v13,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_h8,
	        196: bo_i8,
	        197: bo_j8,
	        673: bo_k8,
	        674: bo_l8,
	        675: bo_m8,
	        350: bo_u8,
	        103: bo_l22,
	        415: bo_m22,
	        524: bo_n22,
	        743: bo_o22,
	        744: bo_p22,
	        745: bo_q22,
	        710: bo_r22,
	        403: bo_g1,
	        426: bo_s22,
	        535: bo_t22,
	        706: bo_u22,
	        343: bo_v22,
	        346: bo_w22,
	        83: bo_x22,
	        84: bo_y22,
	        85: bo_z22,
	        344: bo_a23,
	        347: bo_b23,
	        765: bo_c23,
	        766: bo_d23,
	        767: bo_e23,
	        138: bo_f23,
	        139: bo_g23,
	        140: bo_h23,
	        182: bo_i23,
	        183: bo_j23,
	        184: bo_k23,
	        751: bo_q3,
	        911: bo_l23,
	        889: bo_c1,
	        637: bo_m23,
	        615: bo_d9,
	        412: bo_n23,
	        634: bo_o23,
	        626: bo_p23,
	        611: bo_q23,
	        443: bo_h1,
	        608: bo_i1,
	        904: bo_r23,
	        449: bo_s23,
	        446: bo_t23,
	        451: bo_u23,
	        711: bo_v23,
	        712: bo_w23,
	        713: bo_x23,
	        450: bo_y23,
	        447: bo_z23,
	        448: bo_a24,
	        662: bo_b24,
	        663: bo_c24,
	        665: bo_d24,
	        668: bo_e24,
	        670: bo_f24,
	        671: bo_g24,
	        3: bo_h24,
	        4: bo_i24,
	        6: bo_j24,
	        8: bo_k24,
	        10: bo_l24,
	        11: bo_m24,
	        161: bo_n24,
	        162: bo_o24,
	        164: bo_p24,
	        167: bo_q24,
	        169: bo_r24,
	        170: bo_s24,
	        707: bo_t24,
	        708: bo_u24,
	        709: bo_v24,
	        946: bo_w24,
	        947: bo_x24
	    },
	    23: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    13: {
	        468: bo_y24,
	        470: bo_z24,
	        467: bo_a25,
	        469: bo_b25,
	        464: bo_c25,
	        466: bo_d25,
	        465: bo_e25,
	        463: bo_f25,
	        289: bo_g25,
	        288: bo_h25,
	        292: bo_i25,
	        461: bo_j25,
	        283: bo_k25,
	        295: bo_l25,
	        293: bo_m25,
	        284: bo_n25,
	        285: bo_o25,
	        316: bo_p25,
	        286: bo_q25,
	        287: bo_r25,
	        290: bo_s25,
	        291: bo_t25,
	        462: bo_u25,
	        294: bo_v25
	    },
	    39: {
	        403: bo_g1,
	        443: bo_h1,
	        608: bo_i1,
	        698: bo_g1,
	        349: bo_w25,
	        950: bo_x25,
	        955: bo_y25,
	        951: bo_z25,
	        952: bo_a26,
	        953: bo_b26,
	        954: bo_c26
	    },
	    33: {
	        348: bo_d26,
	        443: bo_h1,
	        608: bo_i1
	    },
	    24: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    9: {
	        74: bo_b1,
	        349: bo_c1,
	        656: bo_j3,
	        698: bo_g1,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_k3,
	        196: bo_a22,
	        673: bo_g3,
	        674: bo_e17,
	        443: bo_h1,
	        608: bo_i1
	    },
	    21: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    29: {
	        394: bo_e26,
	        395: bo_f26,
	        396: bo_g26,
	        397: bo_h26,
	        398: bo_i26,
	        399: bo_j26,
	        400: bo_k26,
	        401: bo_l26,
	        402: bo_m26,
	        100: bo_n26,
	        101: bo_o26,
	        104: bo_p26,
	        105: bo_q26,
	        106: bo_r26,
	        107: bo_s26,
	        108: bo_t26,
	        109: bo_u26,
	        110: bo_v26,
	        111: bo_w26,
	        112: bo_x26,
	        113: bo_y26,
	        114: bo_z26,
	        115: bo_a27,
	        116: bo_b27,
	        117: bo_c27,
	        118: bo_d27,
	        119: bo_e27,
	        120: bo_f27,
	        121: bo_g27,
	        808: bo_h27,
	        809: bo_i27,
	        810: bo_j27,
	        811: bo_k27,
	        812: bo_l27,
	        813: bo_m27,
	        814: bo_n27,
	        815: bo_o27,
	        816: bo_p27,
	        817: bo_q27,
	        818: bo_r27,
	        819: bo_s27,
	        820: bo_t27,
	        821: bo_u27,
	        822: bo_v27,
	        823: bo_w27,
	        824: bo_x27,
	        825: bo_y27,
	        826: bo_z27,
	        827: bo_a28,
	        828: bo_b28,
	        829: bo_c28,
	        830: bo_d28,
	        831: bo_e28,
	        832: bo_f28,
	        833: bo_g28,
	        834: bo_h28,
	        835: bo_i28,
	        836: bo_j28,
	        837: bo_k28,
	        838: bo_l28,
	        839: bo_m28,
	        840: bo_n28,
	        841: bo_o28,
	        842: bo_p28,
	        843: bo_q28,
	        844: bo_r28,
	        366: bo_s28,
	        367: bo_t28,
	        368: bo_u28,
	        369: bo_v28,
	        370: bo_w28,
	        371: bo_x28,
	        372: bo_y28,
	        373: bo_z28,
	        374: bo_a29,
	        375: bo_b29,
	        376: bo_c29,
	        377: bo_d29,
	        378: bo_e29,
	        379: bo_f29,
	        380: bo_g29,
	        381: bo_h29,
	        382: bo_i29,
	        383: bo_j29,
	        384: bo_k29,
	        385: bo_l29,
	        386: bo_m29,
	        387: bo_n29,
	        388: bo_o29,
	        389: bo_p29,
	        390: bo_q29,
	        391: bo_r29,
	        392: bo_s29,
	        393: bo_t29,
	        481: bo_u29,
	        482: bo_v29,
	        483: bo_w29,
	        484: bo_x29,
	        485: bo_y29,
	        486: bo_z29,
	        487: bo_a30,
	        488: bo_b30,
	        489: bo_c30,
	        490: bo_d30,
	        491: bo_e30,
	        492: bo_f30,
	        493: bo_g30,
	        494: bo_h30,
	        495: bo_i30,
	        496: bo_j30,
	        497: bo_k30,
	        498: bo_l30,
	        499: bo_m30,
	        500: bo_n30,
	        501: bo_o30,
	        502: bo_p30,
	        503: bo_q30,
	        504: bo_r30,
	        505: bo_s30,
	        506: bo_t30,
	        507: bo_u30,
	        508: bo_v30,
	        509: bo_w30,
	        510: bo_x30,
	        511: bo_y30,
	        566: bo_z30,
	        567: bo_a31,
	        568: bo_b31,
	        569: bo_c31,
	        570: bo_d31,
	        571: bo_e31,
	        572: bo_f31,
	        573: bo_g31,
	        574: bo_h31,
	        575: bo_i31,
	        576: bo_j31,
	        577: bo_k31,
	        578: bo_l31,
	        579: bo_m31,
	        580: bo_n31,
	        581: bo_o31,
	        582: bo_p31,
	        583: bo_q31,
	        584: bo_r31,
	        585: bo_s31,
	        586: bo_t31,
	        587: bo_u31,
	        588: bo_v31,
	        589: bo_w31,
	        590: bo_x31,
	        591: bo_y31,
	        592: bo_z31,
	        593: bo_a32,
	        594: bo_b32,
	        595: bo_c32,
	        596: bo_d32,
	        597: bo_e32,
	        598: bo_f32,
	        599: bo_g32,
	        600: bo_h32,
	        601: bo_i32,
	        602: bo_j32,
	        83: bo_k32,
	        84: bo_l32,
	        85: bo_m32,
	        86: bo_n32,
	        87: bo_o32,
	        88: bo_p32,
	        89: bo_q32,
	        90: bo_r32,
	        91: bo_s32,
	        92: bo_t32,
	        93: bo_u32,
	        94: bo_v32,
	        95: bo_w32,
	        96: bo_x32,
	        97: bo_y32,
	        98: bo_z32,
	        99: bo_a33,
	        74: bo_b1,
	        349: bo_c1,
	        254: bo_b33,
	        403: bo_g1,
	        21: bo_c33,
	        22: bo_d33,
	        23: bo_e33,
	        24: bo_f33,
	        25: bo_g33,
	        26: bo_h33,
	        27: bo_i33,
	        28: bo_j33,
	        29: bo_k33,
	        30: bo_l33,
	        31: bo_m33,
	        32: bo_n33,
	        33: bo_o33,
	        34: bo_p33,
	        35: bo_q33,
	        36: bo_r33,
	        37: bo_s33,
	        38: bo_t33,
	        39: bo_u33,
	        40: bo_v33,
	        41: bo_w33,
	        42: bo_x33,
	        43: bo_y33,
	        44: bo_z33,
	        45: bo_a34,
	        46: bo_b34,
	        47: bo_c34,
	        48: bo_d34,
	        49: bo_e34,
	        50: bo_f34,
	        51: bo_g34,
	        52: bo_h34,
	        53: bo_i34,
	        54: bo_j34,
	        55: bo_k34,
	        56: bo_l34,
	        57: bo_m34,
	        195: bo_n34,
	        196: bo_o34,
	        197: bo_p34,
	        198: bo_q34,
	        199: bo_r34,
	        200: bo_s34,
	        201: bo_t34,
	        202: bo_u34,
	        203: bo_v34,
	        204: bo_w34,
	        205: bo_x34,
	        206: bo_y34,
	        207: bo_z34,
	        208: bo_a35,
	        209: bo_b35,
	        210: bo_c35,
	        211: bo_d35,
	        212: bo_e35,
	        213: bo_f35,
	        214: bo_g35,
	        215: bo_h35,
	        216: bo_i35,
	        217: bo_j35,
	        218: bo_k35,
	        219: bo_l35,
	        220: bo_m35,
	        221: bo_n35,
	        222: bo_o35,
	        223: bo_p35,
	        224: bo_q35,
	        225: bo_r35,
	        226: bo_s35,
	        227: bo_t35,
	        228: bo_u35,
	        229: bo_v35,
	        230: bo_w35,
	        231: bo_x35,
	        475: bo_y35,
	        476: bo_z35,
	        477: bo_a36,
	        478: bo_b36,
	        479: bo_c36,
	        480: bo_d36,
	        443: bo_h1,
	        608: bo_i1
	    },
	    15: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    2: {
	        73: bo_b1,
	        318: bo_c1,
	        21: bo_e36,
	        22: bo_f36,
	        23: bo_g36,
	        24: bo_h36,
	        25: bo_i36,
	        26: bo_j36,
	        27: bo_k36,
	        195: bo_n34,
	        196: bo_o34,
	        197: bo_p34,
	        198: bo_q34,
	        199: bo_r34,
	        200: bo_s34,
	        201: bo_t34,
	        352: bo_l36,
	        102: bo_f1,
	        403: bo_g1,
	        138: bo_m36,
	        139: bo_n36,
	        140: bo_o36,
	        141: bo_p36,
	        142: bo_q36,
	        143: bo_r36,
	        144: bo_s36,
	        182: bo_t36,
	        183: bo_u36,
	        184: bo_v36,
	        185: bo_w36,
	        186: bo_x36,
	        187: bo_y36,
	        188: bo_z36,
	        566: bo_a37,
	        567: bo_b37,
	        568: bo_c37,
	        569: bo_d37,
	        570: bo_e37,
	        571: bo_f37,
	        572: bo_g37,
	        366: bo_s28,
	        367: bo_t28,
	        368: bo_u28,
	        369: bo_v28,
	        370: bo_w28,
	        371: bo_x28,
	        372: bo_y28,
	        122: bo_h37,
	        123: bo_i37,
	        124: bo_j37,
	        125: bo_k37,
	        126: bo_l37,
	        127: bo_m37,
	        128: bo_n37,
	        129: bo_o37,
	        130: bo_p37,
	        131: bo_q37,
	        132: bo_r37,
	        133: bo_s37,
	        134: bo_t37,
	        135: bo_u37,
	        872: bo_v37,
	        873: bo_w37,
	        874: bo_x37,
	        875: bo_y37,
	        876: bo_z37,
	        877: bo_a38,
	        878: bo_b38,
	        616: bo_c38,
	        617: bo_d38,
	        618: bo_e38,
	        619: bo_f38,
	        620: bo_g38,
	        621: bo_h38,
	        622: bo_i38,
	        894: bo_j38,
	        895: bo_k38,
	        896: bo_l38,
	        897: bo_m38,
	        898: bo_n38,
	        899: bo_o38,
	        900: bo_p38,
	        443: bo_h1,
	        608: bo_i1,
	        83: bo_q38,
	        84: bo_r38,
	        85: bo_s38,
	        86: bo_t38,
	        87: bo_u38,
	        88: bo_v38,
	        89: bo_w38,
	        257: bo_d1,
	        307: bo_e1,
	        752: bo_x38,
	        753: bo_x38
	    },
	    6: {
	        553: bo_y38,
	        339: bo_z38,
	        547: bo_a39,
	        138: bo_m9,
	        139: bo_n9,
	        140: bo_o9,
	        141: bo_b39,
	        142: bo_c39,
	        182: bo_p9,
	        183: bo_q9,
	        184: bo_r9,
	        185: bo_d39,
	        186: bo_e39,
	        83: bo_c10,
	        84: bo_d10,
	        85: bo_e10,
	        86: bo_f39,
	        87: bo_g39,
	        807: bo_h39,
	        636: bo_i39,
	        334: bo_j39,
	        335: bo_k39,
	        336: bo_l39,
	        337: bo_m39,
	        906: bo_n39,
	        907: bo_o39,
	        908: bo_p39,
	        909: bo_q39,
	        300: bo_r39,
	        301: bo_s39,
	        302: bo_t39,
	        303: bo_u39,
	        304: bo_v39,
	        310: bo_w39,
	        311: bo_x39,
	        312: bo_y39,
	        313: bo_z39,
	        314: bo_a40,
	        554: bo_b40,
	        555: bo_c40,
	        556: bo_d40,
	        557: bo_e40,
	        558: bo_f40,
	        517: bo_g40,
	        518: bo_h40,
	        519: bo_i40,
	        520: bo_j40,
	        521: bo_k40,
	        561: bo_l40,
	        562: bo_m40,
	        563: bo_n40,
	        564: bo_o40,
	        565: bo_p40,
	        73: bo_b1,
	        318: bo_c1,
	        21: bo_j1,
	        22: bo_k1,
	        23: bo_l1,
	        24: bo_q40,
	        25: bo_r40,
	        195: bo_h9,
	        196: bo_i9,
	        197: bo_j9,
	        198: bo_s40,
	        199: bo_t40,
	        352: bo_p1,
	        748: bo_q1,
	        102: bo_f1,
	        403: bo_g1,
	        903: bo_u40,
	        445: bo_v40,
	        754: bo_w40,
	        755: bo_x40,
	        756: bo_y40,
	        757: bo_z40,
	        758: bo_a41,
	        452: bo_b41,
	        453: bo_c41,
	        454: bo_d41,
	        566: bo_e41,
	        567: bo_f41,
	        568: bo_g41,
	        569: bo_h41,
	        570: bo_i41,
	        366: bo_r1,
	        367: bo_s1,
	        368: bo_t1,
	        369: bo_j41,
	        370: bo_k41,
	        522: bo_l41,
	        627: bo_m41,
	        628: bo_n41,
	        629: bo_o41,
	        630: bo_p41,
	        631: bo_q41,
	        632: bo_r41,
	        190: bo_s41,
	        191: bo_t41,
	        192: bo_u41,
	        193: bo_v41,
	        194: bo_w41,
	        759: bo_x41,
	        760: bo_y41,
	        761: bo_z41,
	        762: bo_a42,
	        763: bo_b42,
	        768: bo_c42,
	        769: bo_d42,
	        770: bo_e42,
	        771: bo_f42,
	        772: bo_g42,
	        603: bo_h42,
	        604: bo_i42,
	        605: bo_j42,
	        606: bo_k42,
	        607: bo_l42,
	        257: bo_d1,
	        307: bo_e1,
	        696: bo_g1,
	        333: bo_m42,
	        341: bo_n42,
	        427: bo_o42,
	        536: bo_p42,
	        905: bo_q42,
	        320: bo_r42,
	        514: bo_s42,
	        516: bo_t42,
	        305: bo_u42,
	        315: bo_v42,
	        523: bo_w42,
	        299: bo_x42,
	        309: bo_y42,
	        697: bo_z42,
	        298: bo_a43,
	        308: bo_b43,
	        515: bo_c43,
	        549: bo_d43,
	        548: bo_e43,
	        443: bo_h1,
	        608: bo_i1,
	        550: bo_v40,
	        551: bo_v40,
	        455: bo_b41,
	        456: bo_b41,
	        457: bo_c41,
	        458: bo_c41,
	        459: bo_d41,
	        460: bo_d41,
	        512: bo_l41,
	        513: bo_l41,
	        901: bo_f43,
	        902: bo_f43,
	        340: bo_g43,
	        328: bo_h43,
	        329: bo_i43,
	        342: bo_j43,
	        330: bo_k43,
	        331: bo_l43,
	        722: bo_m43,
	        560: bo_n43,
	        543: bo_o43,
	        544: bo_p43,
	        545: bo_q43,
	        546: bo_r43,
	        332: bo_s43,
	        559: bo_t43,
	        296: bo_u43,
	        297: bo_v43,
	        717: bo_w43,
	        718: bo_x43,
	        719: bo_y43,
	        720: bo_z43,
	        721: bo_a44,
	        552: bo_b44,
	        76: bo_c44,
	        77: bo_d44,
	        78: bo_e44,
	        79: bo_f44,
	        80: bo_g44,
	        647: bo_h44,
	        741: bo_i44,
	        82: bo_j44,
	        338: bo_k44
	    },
	    17: {
	        348: bo_d26,
	        443: bo_h1,
	        608: bo_i1
	    },
	    4: {
	        73: bo_b1,
	        318: bo_c1,
	        21: bo_j1,
	        22: bo_k1,
	        23: bo_l1,
	        24: bo_q40,
	        25: bo_r40,
	        195: bo_h9,
	        196: bo_i9,
	        197: bo_j9,
	        198: bo_s40,
	        199: bo_t40,
	        352: bo_p1,
	        764: bo_q3,
	        102: bo_f1,
	        403: bo_g1,
	        138: bo_m9,
	        139: bo_n9,
	        140: bo_o9,
	        141: bo_b39,
	        142: bo_c39,
	        182: bo_p9,
	        183: bo_q9,
	        184: bo_r9,
	        185: bo_d39,
	        186: bo_e39,
	        366: bo_r1,
	        367: bo_s1,
	        368: bo_t1,
	        369: bo_j41,
	        370: bo_k41,
	        566: bo_l44,
	        567: bo_m44,
	        568: bo_n44,
	        569: bo_o44,
	        570: bo_p44,
	        74: bo_q44,
	        923: bo_r44,
	        924: bo_s44,
	        925: bo_t44,
	        926: bo_u44,
	        927: bo_v44,
	        929: bo_t9,
	        930: bo_u9,
	        931: bo_v9,
	        932: bo_w44,
	        933: bo_x44,
	        845: bo_w9,
	        846: bo_x9,
	        847: bo_y9,
	        848: bo_y44,
	        849: bo_z44,
	        918: bo_z9,
	        919: bo_a10,
	        920: bo_b10,
	        921: bo_a45,
	        922: bo_b45,
	        83: bo_c10,
	        84: bo_d10,
	        85: bo_e10,
	        86: bo_f39,
	        87: bo_g39,
	        905: bo_q42,
	        906: bo_n39,
	        907: bo_o39,
	        908: bo_p39,
	        909: bo_q39,
	        807: bo_h39,
	        319: bo_c45,
	        320: bo_d45,
	        912: bo_y10,
	        913: bo_z10,
	        914: bo_a11,
	        915: bo_e45,
	        916: bo_f45,
	        443: bo_h1,
	        608: bo_i1,
	        257: bo_d1,
	        307: bo_e1,
	        362: bo_i10,
	        363: bo_j10,
	        364: bo_g45,
	        365: bo_h45,
	        17: bo_k10,
	        18: bo_l10,
	        19: bo_i45,
	        20: bo_j45,
	        176: bo_m10,
	        177: bo_n10,
	        178: bo_k45,
	        179: bo_l45,
	        358: bo_o10,
	        359: bo_p10,
	        360: bo_m45,
	        361: bo_n45,
	        13: bo_q10,
	        14: bo_r10,
	        15: bo_o45,
	        16: bo_p45,
	        172: bo_s10,
	        173: bo_t10,
	        174: bo_q45,
	        175: bo_r45,
	        281: bo_a6,
	        137: bo_a6,
	        616: bo_j2,
	        617: bo_k2,
	        618: bo_l2,
	        619: bo_s45,
	        620: bo_t45,
	        891: bo_x10,
	        26: bo_u45,
	        200: bo_v45,
	        143: bo_w45,
	        187: bo_x45,
	        371: bo_y45,
	        571: bo_z45,
	        928: bo_v45,
	        934: bo_v45,
	        88: bo_a46,
	        910: bo_b46,
	        917: bo_c46,
	        936: bo_d46
	    },
	    8: {
	        74: bo_b1,
	        349: bo_c1,
	        656: bo_j3,
	        698: bo_g1,
	        256: bo_d1,
	        306: bo_e1,
	        195: bo_e46,
	        196: bo_f46,
	        197: bo_g46,
	        198: bo_h46,
	        673: bo_a4,
	        674: bo_b4,
	        675: bo_c4,
	        676: bo_d4,
	        103: bo_f1,
	        443: bo_h1,
	        608: bo_i1
	    },
	    27: {
	        443: bo_h1,
	        608: bo_i1
	    },
	    28: {
	        403: bo_g1,
	        615: bo_i46,
	        74: bo_b1,
	        349: bo_c1,
	        256: bo_d1,
	        306: bo_e1,
	        103: bo_f1,
	        935: bo_q3,
	        612: bo_j46,
	        613: bo_k46,
	        443: bo_h1,
	        608: bo_i1
	    }
	};
	
	var outcomeConfig = {
	    7: {
	        426: function _(match, outcome) {
	            return "Aniq " + outcome.condition + " " + plural(outcome.condition, ['gol', 'gol', 'gol']) + " bilan";
	        },
	        535: function _(match, outcome) {
	            return "Aniq " + outcome.condition + " " + plural(outcome.condition, ['gol', 'gol', 'gol']) + " bilan";
	        }
	    },
	    6: {
	        455: function _(match, outcome) {
	            return '15x15';
	        },
	        456: function _(match, outcome) {
	            return '15x15';
	        },
	        457: function _(match, outcome) {
	            return '30x30';
	        },
	        458: function _(match, outcome) {
	            return '30x30';
	        },
	        459: function _(match, outcome) {
	            return '40x40';
	        },
	        460: function _(match, outcome) {
	            return '40x40';
	        }
	    }
	};
	
	var baseFactorNameConfig = {
	    11: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        403: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    32: {
	        73: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        318: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        352: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        748: {
	            1: fa_n1,
	            2: fa_o1,
	            3: fa_p1,
	            4: fa_q1,
	            5: fa_r1,
	            6: fa_s1,
	            7: fa_t1,
	            8: fa_u1,
	            9: fa_v1,
	            10: fa_w1
	        },
	        102: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        403: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        366: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        367: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        368: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        122: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        123: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        124: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        129: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        130: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        131: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        566: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        567: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        568: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        616: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        617: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        618: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        257: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        307: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        362: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        363: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        364: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        17: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        18: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        19: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        176: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        177: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        178: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        358: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        359: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        360: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        13: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        14: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        15: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        172: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        173: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        174: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        }
	    },
	    35: {
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        673: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        698: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        731: {
	            1: fa_x1,
	            2: fa_a2,
	            3: fa_y1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        911: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2,
	            4: fa_h2,
	            5: fa_i2,
	            6: fa_j2
	        },
	        426: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        535: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        871: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        710: {
	            1: fa_q2,
	            2: fa_r2,
	            3: fa_s2
	        },
	        742: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_v2,
	            6: fa_w2,
	            7: fa_x2,
	            8: fa_y2,
	            9: fa_p1,
	            10: fa_q1,
	            11: fa_z2,
	            12: fa_a3,
	            13: fa_r1,
	            14: fa_s1,
	            15: fa_b3,
	            16: fa_t1,
	            17: fa_c3,
	            18: fa_d3,
	            19: fa_e3,
	            20: fa_u1,
	            21: fa_v1,
	            22: fa_w1,
	            23: fa_f3,
	            24: fa_g3,
	            25: fa_h3,
	            26: fa_i3,
	            27: fa_j3,
	            28: fa_k3,
	            29: fa_l3,
	            30: fa_m3,
	            31: fa_n3,
	            32: fa_o3,
	            33: fa_p3,
	            34: fa_q3,
	            35: fa_r3
	        }
	    },
	    10: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        403: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        1: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    31: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        24: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        674: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        675: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        676: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        403: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        141: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        185: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        238: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        682: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        239: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        58: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        59: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        681: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        234: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        235: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        236: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        237: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        725: {
	            1: fa_x1,
	            2: fa_a2,
	            3: fa_y1
	        },
	        726: {
	            1: fa_x1,
	            2: fa_a2,
	            3: fa_y1
	        },
	        727: {
	            1: fa_x1,
	            2: fa_a2,
	            3: fa_y1
	        },
	        728: {
	            1: fa_x1,
	            2: fa_a2,
	            3: fa_y1
	        },
	        782: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        778: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        779: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        780: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        781: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        783: {
	            1: fa_p1,
	            2: fa_h3,
	            3: fa_y3,
	            4: fa_z3,
	            5: fa_a4,
	            6: fa_b4,
	            7: fa_c4,
	            8: fa_i1
	        },
	        773: {
	            1: fa_p1,
	            2: fa_h3,
	            3: fa_y3,
	            4: fa_z3,
	            5: fa_a4,
	            6: fa_b4,
	            7: fa_c4,
	            8: fa_i1
	        },
	        474: {
	            1: fa_d4,
	            2: fa_e4
	        },
	        421: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        530: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        422: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        531: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        444: {
	            1: fa_f4,
	            2: fa_g4
	        },
	        888: {
	            1: fa_h4,
	            2: fa_i4,
	            3: fa_j4,
	            4: fa_k4
	        },
	        280: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        317: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        424: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        533: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        423: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        532: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        637: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        788: {
	            1: fa_l4,
	            2: fa_m4,
	            3: fa_n4,
	            4: fa_o4,
	            5: fa_p4,
	            6: fa_q4,
	            7: fa_r4,
	            8: fa_s4,
	            9: fa_t4,
	            10: fa_u4,
	            11: fa_v4,
	            12: fa_w4,
	            13: fa_x4,
	            14: fa_y4
	        },
	        784: {
	            1: fa_l4,
	            2: fa_z4,
	            3: fa_a5,
	            4: fa_b5,
	            5: fa_c5
	        },
	        785: {
	            1: fa_l4,
	            2: fa_z4,
	            3: fa_a5,
	            4: fa_b5,
	            5: fa_c5
	        },
	        786: {
	            1: fa_l4,
	            2: fa_z4,
	            3: fa_a5,
	            4: fa_b5,
	            5: fa_c5
	        },
	        787: {
	            1: fa_l4,
	            2: fa_z4,
	            3: fa_a5,
	            4: fa_b5,
	            5: fa_c5
	        },
	        774: {
	            1: fa_s4,
	            2: fa_d5,
	            3: fa_e5,
	            4: fa_f5,
	            5: fa_g5
	        },
	        775: {
	            1: fa_s4,
	            2: fa_d5,
	            3: fa_e5,
	            4: fa_f5,
	            5: fa_g5
	        },
	        776: {
	            1: fa_s4,
	            2: fa_d5,
	            3: fa_e5,
	            4: fa_f5,
	            5: fa_g5
	        },
	        777: {
	            1: fa_s4,
	            2: fa_d5,
	            3: fa_e5,
	            4: fa_f5,
	            5: fa_g5
	        },
	        281: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        137: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        246: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        248: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        240: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        232: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        241: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        233: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        61: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        62: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        684: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        685: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        890: {
	            1: fa_h4,
	            2: fa_i4,
	            3: fa_j4,
	            4: fa_k4
	        },
	        242: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        245: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        243: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        60: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        683: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        406: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        405: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        404: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        700: {
	            1: fa_h5,
	            2: fa_i5,
	            3: fa_j5
	        },
	        408: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        407: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        247: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        244: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        638: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        639: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        640: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        641: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        646: {
	            1: fa_k5,
	            2: fa_l5,
	            3: fa_m5
	        },
	        642: {
	            1: fa_k5,
	            2: fa_l5,
	            3: fa_m5
	        },
	        643: {
	            1: fa_k5,
	            2: fa_l5,
	            3: fa_m5
	        },
	        644: {
	            1: fa_k5,
	            2: fa_l5,
	            3: fa_m5
	        },
	        645: {
	            1: fa_k5,
	            2: fa_l5,
	            3: fa_m5
	        }
	    },
	    41: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        403: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        673: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        674: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        791: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        792: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        637: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        796: {
	            1: fa_l4,
	            2: fa_m4,
	            3: fa_n4,
	            4: fa_o4,
	            5: fa_p4,
	            6: fa_q4,
	            7: fa_n5,
	            8: fa_s4,
	            9: fa_t4,
	            10: fa_u4,
	            11: fa_v4,
	            12: fa_w4,
	            13: fa_x4,
	            14: fa_o5
	        },
	        794: {
	            1: fa_l4,
	            2: fa_z4,
	            3: fa_a5,
	            4: fa_p5,
	            5: fa_c5
	        },
	        795: {
	            1: fa_l4,
	            2: fa_z4,
	            3: fa_a5,
	            4: fa_p5,
	            5: fa_c5
	        },
	        789: {
	            1: fa_s4,
	            2: fa_d5,
	            3: fa_e5,
	            4: fa_q5,
	            5: fa_g5
	        },
	        790: {
	            1: fa_s4,
	            2: fa_d5,
	            3: fa_e5,
	            4: fa_q5,
	            5: fa_g5
	        },
	        725: {
	            1: fa_x1,
	            2: fa_a2,
	            3: fa_y1
	        },
	        726: {
	            1: fa_x1,
	            2: fa_a2,
	            3: fa_y1
	        },
	        793: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        411: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        701: {
	            1: fa_f4,
	            2: fa_g4,
	            3: fa_r5
	        },
	        251: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        252: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        409: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        430: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        410: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        431: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        281: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        137: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        249: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        250: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        63: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        64: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        686: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        687: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        648: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        649: {
	            1: fa_x1,
	            2: fa_y1
	        }
	    },
	    18: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        698: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        674: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        675: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        610: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        806: {
	            1: fa_s5,
	            2: fa_t5,
	            3: fa_u5,
	            4: fa_v5,
	            5: fa_w5,
	            6: fa_c5
	        },
	        893: {
	            1: fa_x5,
	            2: fa_y5,
	            3: fa_z5,
	            4: fa_a6,
	            5: fa_b6,
	            6: fa_c5
	        },
	        707: {
	            1: fa_c6,
	            2: fa_d6,
	            3: fa_e6
	        },
	        708: {
	            1: fa_c6,
	            2: fa_d6,
	            3: fa_e6
	        },
	        709: {
	            1: fa_c6,
	            2: fa_d6,
	            3: fa_e6
	        },
	        889: {
	            1: fa_f6,
	            2: fa_m2,
	            3: fa_n2,
	            4: fa_o2,
	            5: fa_g6,
	            6: fa_h6,
	            7: fa_i6,
	            8: fa_j6
	        },
	        904: {
	            1: fa_k6,
	            2: fa_l6,
	            3: fa_m6,
	            4: fa_n6,
	            5: fa_o6,
	            6: fa_p6,
	            7: fa_q6,
	            8: fa_r6,
	            9: fa_s6
	        },
	        253: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        688: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        65: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        751: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_v2,
	            6: fa_w2,
	            7: fa_x2,
	            8: fa_y2,
	            9: fa_p1,
	            10: fa_q1,
	            11: fa_z2,
	            12: fa_a3,
	            13: fa_r1,
	            14: fa_s1,
	            15: fa_b3,
	            16: fa_t1,
	            17: fa_c3,
	            18: fa_d3,
	            19: fa_e3,
	            20: fa_u1,
	            21: fa_v1,
	            22: fa_w1,
	            23: fa_f3,
	            24: fa_g3,
	            25: fa_h3,
	            26: fa_i3,
	            27: fa_j3,
	            28: fa_k3,
	            29: fa_l3,
	            30: fa_m3,
	            31: fa_n3,
	            32: fa_o3,
	            33: fa_p3,
	            34: fa_q3,
	            35: fa_r3
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        743: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_r3
	        },
	        744: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_r3
	        },
	        745: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_r3
	        },
	        615: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        350: {
	            1: fa_d1,
	            2: fa_e1
	        }
	    },
	    3: {
	        73: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        318: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        352: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        746: {
	            1: fa_r1,
	            2: fa_s1,
	            3: fa_p1,
	            4: fa_n1
	        },
	        102: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        403: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        366: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        367: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        368: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        566: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        567: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        568: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        854: {
	            1: fa_s3,
	            2: fa_t6,
	            3: fa_u6,
	            4: fa_v6,
	            5: fa_w6,
	            6: fa_x6,
	            7: fa_y6,
	            8: fa_z6
	        },
	        855: {
	            1: fa_s3,
	            2: fa_t6,
	            3: fa_u6,
	            4: fa_v6,
	            5: fa_w6,
	            6: fa_x6,
	            7: fa_y6,
	            8: fa_z6
	        },
	        856: {
	            1: fa_s3,
	            2: fa_t6,
	            3: fa_u6,
	            4: fa_v6,
	            5: fa_w6,
	            6: fa_x6,
	            7: fa_y6,
	            8: fa_z6
	        },
	        857: {
	            1: fa_s3,
	            2: fa_a7,
	            3: fa_b7,
	            4: fa_c7,
	            5: fa_z6
	        },
	        858: {
	            1: fa_s3,
	            2: fa_a7,
	            3: fa_b7,
	            4: fa_c7,
	            5: fa_z6
	        },
	        859: {
	            1: fa_s3,
	            2: fa_a7,
	            3: fa_b7,
	            4: fa_c7,
	            5: fa_z6
	        },
	        797: {
	            1: fa_t1,
	            2: fa_d7,
	            3: fa_e7,
	            4: fa_i1
	        },
	        798: {
	            1: fa_t1,
	            2: fa_d7,
	            3: fa_e7,
	            4: fa_i1
	        },
	        799: {
	            1: fa_t1,
	            2: fa_d7,
	            3: fa_e7,
	            4: fa_i1
	        },
	        851: {
	            1: fa_t1,
	            2: fa_d7,
	            3: fa_e7,
	            4: fa_h1
	        },
	        852: {
	            1: fa_t1,
	            2: fa_d7,
	            3: fa_e7,
	            4: fa_h1
	        },
	        853: {
	            1: fa_t1,
	            2: fa_d7,
	            3: fa_e7,
	            4: fa_h1
	        },
	        83: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        84: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        85: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        905: {
	            1: fa_f7,
	            2: fa_g7,
	            3: fa_h7,
	            4: fa_i7
	        },
	        906: {
	            1: fa_f7,
	            2: fa_g7,
	            3: fa_h7,
	            4: fa_i7
	        },
	        907: {
	            1: fa_f7,
	            2: fa_g7,
	            3: fa_h7,
	            4: fa_i7
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        362: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        363: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        17: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        18: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        176: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        177: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        358: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        359: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        13: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        14: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        172: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        173: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        616: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        617: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        618: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        891: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2,
	            4: fa_h2
	        },
	        257: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        307: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        800: {
	            1: fa_j7,
	            2: fa_k7,
	            3: fa_l7,
	            4: fa_m7,
	            5: fa_n7,
	            6: fa_o7
	        },
	        801: {
	            1: fa_j7,
	            2: fa_k7,
	            3: fa_l7,
	            4: fa_m7,
	            5: fa_n7,
	            6: fa_o7
	        },
	        802: {
	            1: fa_j7,
	            2: fa_k7,
	            3: fa_l7,
	            4: fa_m7,
	            5: fa_n7,
	            6: fa_o7
	        }
	    },
	    20: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        698: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        199: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        200: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        201: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        202: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        141: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        142: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        143: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        144: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        145: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        185: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        186: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        187: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        188: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        189: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        24: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        25: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        26: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        27: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        28: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        673: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        674: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        675: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        676: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        677: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        678: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        679: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        680: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        860: {
	            1: fa_p7,
	            2: fa_t6,
	            3: fa_u6,
	            4: fa_v6,
	            5: fa_w6,
	            6: fa_x6,
	            7: fa_q7
	        },
	        861: {
	            1: fa_p7,
	            2: fa_t6,
	            3: fa_u6,
	            4: fa_v6,
	            5: fa_w6,
	            6: fa_x6,
	            7: fa_q7
	        },
	        862: {
	            1: fa_p7,
	            2: fa_t6,
	            3: fa_u6,
	            4: fa_v6,
	            5: fa_w6,
	            6: fa_x6,
	            7: fa_q7
	        },
	        863: {
	            1: fa_p7,
	            2: fa_t6,
	            3: fa_u6,
	            4: fa_v6,
	            5: fa_w6,
	            6: fa_x6,
	            7: fa_q7
	        },
	        864: {
	            1: fa_p7,
	            2: fa_t6,
	            3: fa_u6,
	            4: fa_v6,
	            5: fa_w6,
	            6: fa_x6,
	            7: fa_q7
	        },
	        865: {
	            1: fa_p7,
	            2: fa_t6,
	            3: fa_u6,
	            4: fa_v6,
	            5: fa_w6,
	            6: fa_x6,
	            7: fa_q7
	        },
	        866: {
	            1: fa_p7,
	            2: fa_t6,
	            3: fa_u6,
	            4: fa_v6,
	            5: fa_w6,
	            6: fa_x6,
	            7: fa_q7
	        },
	        867: {
	            1: fa_p7,
	            2: fa_t6,
	            3: fa_u6,
	            4: fa_v6,
	            5: fa_w6,
	            6: fa_x6,
	            7: fa_q7
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    5: {
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        698: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        945: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        948: {
	            1: fa_r7,
	            2: fa_s7,
	            3: fa_t7,
	            4: fa_u7,
	            5: fa_v7
	        },
	        949: {
	            1: fa_w7,
	            2: fa_x7,
	            3: fa_y7,
	            4: fa_z7,
	            5: fa_a8,
	            6: fa_b8,
	            7: fa_c8,
	            8: fa_d8,
	            9: fa_e8,
	            10: fa_f8,
	            11: fa_g8,
	            12: fa_h8,
	            13: fa_s7,
	            14: fa_t7,
	            15: fa_i8,
	            16: fa_j8,
	            17: fa_k8,
	            18: fa_l8,
	            19: fa_m8,
	            20: fa_n8,
	            21: fa_o8,
	            22: fa_p8,
	            23: fa_q8,
	            24: fa_r8,
	            25: fa_s8,
	            26: fa_t8,
	            27: fa_v7
	        }
	    },
	    40: {
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        698: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    37: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    38: {
	        403: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        615: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        413: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        414: {
	            1: fa_x1,
	            2: fa_y1
	        }
	    },
	    42: {
	        403: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        615: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        413: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        414: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        566: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        567: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        568: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        569: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        570: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        698: {
	            1: fa_h1,
	            2: fa_u8,
	            3: fa_i1
	        },
	        366: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        367: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        368: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        369: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        370: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        940: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        941: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        942: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        943: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        944: {
	            1: fa_h1,
	            2: fa_i1
	        }
	    },
	    26: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    25: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    16: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    12: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        698: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    36: {
	        610: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        698: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        615: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_v8
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    7: {
	        425: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        534: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        540: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        343: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        345: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        260: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        261: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        83: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        84: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        803: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_w8
	        },
	        868: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_w8
	        },
	        869: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_w8
	        },
	        870: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_w8
	        },
	        805: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_w8
	        },
	        892: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_w8
	        },
	        346: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        419: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        528: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        420: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        529: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        707: {
	            1: fa_x8,
	            2: fa_y8,
	            3: fa_z8
	        },
	        708: {
	            1: fa_x8,
	            2: fa_y8,
	            3: fa_z8
	        },
	        706: {
	            1: fa_a9,
	            2: fa_b9,
	            3: fa_c9
	        },
	        804: {
	            1: fa_d9,
	            2: fa_e9,
	            3: fa_f9,
	            4: fa_g9
	        },
	        474: {
	            1: fa_d4,
	            2: fa_e4
	        },
	        614: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        609: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        416: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        732: {
	            1: fa_x1,
	            2: fa_a2,
	            3: fa_y1
	        },
	        525: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        850: {
	            1: fa_h9,
	            2: fa_i9,
	            3: fa_j9,
	            4: fa_k9
	        },
	        473: {
	            1: fa_l9,
	            2: fa_m9
	        },
	        442: {
	            1: fa_l9,
	            2: fa_m9
	        },
	        729: {
	            1: fa_x1,
	            2: fa_a2,
	            3: fa_y1
	        },
	        538: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        542: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        730: {
	            1: fa_x1,
	            2: fa_a2,
	            3: fa_y1
	        },
	        471: {
	            1: fa_l9,
	            2: fa_m9
	        },
	        635: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        714: {
	            1: fa_n9,
	            2: fa_a2,
	            3: fa_o9
	        },
	        624: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        625: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        715: {
	            1: fa_p9,
	            2: fa_q9,
	            3: fa_r9
	        },
	        650: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        651: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        652: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        653: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        654: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        655: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        634: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        626: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        733: {
	            1: fa_p9,
	            2: fa_q9,
	            3: fa_s9
	        },
	        734: {
	            1: fa_p9,
	            2: fa_q9,
	            3: fa_s9
	        },
	        258: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        259: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        66: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        67: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        81: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        68: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        689: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        690: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        699: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        691: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        723: {
	            1: fa_x1,
	            2: fa_a2,
	            3: fa_y1
	        },
	        633: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        698: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        322: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        904: {
	            1: fa_k6,
	            2: fa_t9,
	            3: fa_m6,
	            4: fa_u9,
	            5: fa_v9,
	            6: fa_w9,
	            7: fa_q6,
	            8: fa_x9,
	            9: fa_s6
	        },
	        1: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        136: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        747: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_v2,
	            6: fa_w2,
	            7: fa_y9,
	            8: fa_x2,
	            9: fa_y2,
	            10: fa_p1,
	            11: fa_q1,
	            12: fa_z2,
	            13: fa_a3,
	            14: fa_z9,
	            15: fa_r1,
	            16: fa_s1,
	            17: fa_b3,
	            18: fa_t1,
	            19: fa_c3,
	            20: fa_u1,
	            21: fa_v1,
	            22: fa_w1,
	            23: fa_f3,
	            24: fa_i3,
	            25: fa_j3,
	            26: fa_k3,
	            27: fa_n3,
	            28: fa_o3,
	            29: fa_a10,
	            30: fa_b10,
	            31: fa_r3
	        },
	        871: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        255: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        705: {
	            1: fa_c10,
	            2: fa_d10,
	            3: fa_t7
	        },
	        323: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        324: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        702: {
	            1: fa_n9,
	            2: fa_a2,
	            3: fa_o9
	        },
	        278: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        282: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        911: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2,
	            4: fa_e10,
	            5: fa_i2,
	            6: fa_j2
	        },
	        353: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        674: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        2: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        5: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        7: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        939: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        9: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        12: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        417: {
	            1: fa_f10,
	            2: fa_g10
	        },
	        526: {
	            1: fa_f10,
	            2: fa_g10
	        },
	        325: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        160: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        163: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        165: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        166: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        168: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        171: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        148: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        149: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        150: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        151: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        152: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        153: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        154: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        155: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        156: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        157: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        158: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        159: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        731: {
	            1: fa_x1,
	            2: fa_a2,
	            3: fa_y1
	        },
	        765: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        766: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        415: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        524: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        418: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        527: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        743: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_h10
	        },
	        744: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_h10
	        },
	        710: {
	            1: fa_i10,
	            2: fa_r2,
	            3: fa_j10
	        },
	        321: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        326: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        327: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        724: {
	            1: fa_k10,
	            2: fa_l10,
	            3: fa_m10
	        },
	        661: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        664: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        666: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        667: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        669: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        672: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        426: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        535: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        537: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        541: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        539: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        437: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        436: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        694: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        71: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        271: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        268: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        265: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        267: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        270: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        272: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        269: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        266: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        264: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        281: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        137: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        660: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        880: {
	            1: fa_n10,
	            2: fa_o10,
	            3: fa_p10,
	            4: fa_q10
	        },
	        879: {
	            1: fa_r10,
	            2: fa_s10,
	            3: fa_t10,
	            4: fa_u10
	        },
	        429: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        433: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        881: {
	            1: fa_v10,
	            2: fa_w10,
	            3: fa_x10,
	            4: fa_y10,
	            5: fa_z10,
	            6: fa_a11
	        },
	        273: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        274: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        435: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        704: {
	            1: fa_b11,
	            2: fa_c11,
	            3: fa_d11
	        },
	        432: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        428: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        434: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        439: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        440: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        441: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        438: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        623: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        180: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        146: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        659: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        749: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_r3
	        },
	        69: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        262: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        692: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        703: {
	            1: fa_x1,
	            2: fa_a2,
	            3: fa_y1
	        },
	        70: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        263: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        693: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        72: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        277: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        695: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        750: {
	            1: fa_x2,
	            2: fa_r1,
	            3: fa_u1,
	            4: fa_s1,
	            5: fa_v1,
	            6: fa_w1,
	            7: fa_j3,
	            8: fa_k3,
	            9: fa_l3,
	            10: fa_q3,
	            11: fa_e11,
	            12: fa_f11,
	            13: fa_u2,
	            14: fa_n1,
	            15: fa_o1,
	            16: fa_p1,
	            17: fa_q1,
	            18: fa_t1,
	            19: fa_z2,
	            20: fa_c3,
	            21: fa_g3,
	            22: fa_h3,
	            23: fa_g11,
	            24: fa_h11
	        },
	        181: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        147: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        276: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        275: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        735: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        736: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        737: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        738: {
	            1: fa_x1,
	            2: fa_i11,
	            3: fa_y1
	        },
	        739: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        740: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        356: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        357: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        354: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        355: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        937: {
	            1: fa_j11,
	            2: fa_k11,
	            3: fa_l11,
	            4: fa_m11,
	            5: fa_n11,
	            6: fa_o11,
	            7: fa_p11,
	            8: fa_q11,
	            9: fa_r11,
	            10: fa_s11
	        },
	        657: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        658: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        412: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    14: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    34: {
	        425: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        534: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        540: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        343: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        345: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        260: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        261: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        83: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        84: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        803: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_w8
	        },
	        868: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_w8
	        },
	        869: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_w8
	        },
	        870: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_w8
	        },
	        346: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        419: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        528: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        420: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        529: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        707: {
	            1: fa_x8,
	            2: fa_y8,
	            3: fa_z8
	        },
	        708: {
	            1: fa_x8,
	            2: fa_y8,
	            3: fa_z8
	        },
	        706: {
	            1: fa_a9,
	            2: fa_b9,
	            3: fa_c9
	        },
	        538: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        698: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        322: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        904: {
	            1: fa_k6,
	            2: fa_t9,
	            3: fa_m6,
	            4: fa_u9,
	            5: fa_v9,
	            6: fa_w9,
	            7: fa_q6,
	            8: fa_x9,
	            9: fa_s6
	        },
	        1: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        136: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        747: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_v2,
	            6: fa_w2,
	            7: fa_y9,
	            8: fa_x2,
	            9: fa_y2,
	            10: fa_p1,
	            11: fa_q1,
	            12: fa_z2,
	            13: fa_a3,
	            14: fa_z9,
	            15: fa_r1,
	            16: fa_s1,
	            17: fa_b3,
	            18: fa_t1,
	            19: fa_c3,
	            20: fa_u1,
	            21: fa_v1,
	            22: fa_w1,
	            23: fa_f3,
	            24: fa_i3,
	            25: fa_j3,
	            26: fa_k3,
	            27: fa_n3,
	            28: fa_o3,
	            29: fa_a10,
	            30: fa_b10,
	            31: fa_r3
	        },
	        871: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        255: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        705: {
	            1: fa_c10,
	            2: fa_d10,
	            3: fa_t7
	        },
	        323: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        324: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        702: {
	            1: fa_n9,
	            2: fa_a2,
	            3: fa_o9
	        },
	        278: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        282: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        911: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2,
	            4: fa_e10,
	            5: fa_i2,
	            6: fa_j2
	        },
	        353: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        674: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        2: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        5: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        7: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        939: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        9: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        12: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        417: {
	            1: fa_f10,
	            2: fa_g10
	        },
	        526: {
	            1: fa_f10,
	            2: fa_g10
	        },
	        325: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        160: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        163: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        165: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        166: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        168: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        171: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        148: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        149: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        150: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        151: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        152: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        153: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        154: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        155: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        156: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        157: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        158: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        159: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        731: {
	            1: fa_x1,
	            2: fa_a2,
	            3: fa_y1
	        },
	        765: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        766: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        415: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        524: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        418: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        527: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        743: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_h10
	        },
	        744: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_h10
	        },
	        710: {
	            1: fa_i10,
	            2: fa_r2,
	            3: fa_j10
	        },
	        321: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        326: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        327: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        724: {
	            1: fa_k10,
	            2: fa_l10,
	            3: fa_m10
	        },
	        661: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        664: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        666: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        667: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        669: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        672: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        426: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        535: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        537: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        541: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        539: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    19: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        698: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        615: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        886: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        887: {
	            1: fa_s3,
	            2: fa_t3,
	            3: fa_u3,
	            4: fa_v3,
	            5: fa_w3,
	            6: fa_x3
	        },
	        911: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2,
	            4: fa_h2,
	            5: fa_i2,
	            6: fa_j2
	        },
	        884: {
	            1: fa_l4,
	            2: fa_z4,
	            3: fa_a5,
	            4: fa_t11,
	            5: fa_c5
	        },
	        885: {
	            1: fa_l4,
	            2: fa_z4,
	            3: fa_a5,
	            4: fa_t11,
	            5: fa_c5
	        },
	        882: {
	            1: fa_l4,
	            2: fa_z4,
	            3: fa_a5,
	            4: fa_t11,
	            5: fa_c5
	        },
	        883: {
	            1: fa_l4,
	            2: fa_z4,
	            3: fa_a5,
	            4: fa_t11,
	            5: fa_c5
	        },
	        723: {
	            1: fa_x1,
	            2: fa_a2,
	            3: fa_y1
	        },
	        673: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        674: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    30: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        698: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_v8
	        },
	        22: {
	            1: fa_b1,
	            2: fa_v8
	        },
	        23: {
	            1: fa_b1,
	            2: fa_v8
	        },
	        279: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        610: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        674: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        675: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        350: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        415: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        524: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        743: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_h10
	        },
	        744: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_h10
	        },
	        745: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_x2,
	            6: fa_y2,
	            7: fa_p1,
	            8: fa_q1,
	            9: fa_r1,
	            10: fa_s1,
	            11: fa_b3,
	            12: fa_t1,
	            13: fa_u1,
	            14: fa_v1,
	            15: fa_w1,
	            16: fa_f3,
	            17: fa_h10
	        },
	        710: {
	            1: fa_u11,
	            2: fa_v11,
	            3: fa_w11
	        },
	        403: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        426: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        535: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        706: {
	            1: fa_x11,
	            2: fa_y11,
	            3: fa_z11
	        },
	        343: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        346: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        83: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        84: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        85: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        344: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        347: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        765: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        766: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        767: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_p2
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        751: {
	            1: fa_t2,
	            2: fa_u2,
	            3: fa_n1,
	            4: fa_o1,
	            5: fa_v2,
	            6: fa_w2,
	            7: fa_x2,
	            8: fa_y2,
	            9: fa_p1,
	            10: fa_q1,
	            11: fa_z2,
	            12: fa_a3,
	            13: fa_r1,
	            14: fa_s1,
	            15: fa_b3,
	            16: fa_t1,
	            17: fa_c3,
	            18: fa_d3,
	            19: fa_e3,
	            20: fa_u1,
	            21: fa_v1,
	            22: fa_w1,
	            23: fa_f3,
	            24: fa_g3,
	            25: fa_h3,
	            26: fa_i3,
	            27: fa_j3,
	            28: fa_k3,
	            29: fa_l3,
	            30: fa_m3,
	            31: fa_n3,
	            32: fa_o3,
	            33: fa_p3,
	            34: fa_q3,
	            35: fa_h10
	        },
	        911: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2,
	            4: fa_h2,
	            5: fa_i2,
	            6: fa_j2
	        },
	        889: {
	            1: fa_f6,
	            2: fa_m2,
	            3: fa_n2,
	            4: fa_o2,
	            5: fa_g6,
	            6: fa_h6,
	            7: fa_i6,
	            8: fa_j6
	        },
	        637: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        615: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        412: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        634: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        626: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        611: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        904: {
	            1: fa_k6,
	            2: fa_t9,
	            3: fa_m6,
	            4: fa_u9,
	            5: fa_v9,
	            6: fa_w9,
	            7: fa_q6,
	            8: fa_x9,
	            9: fa_s6
	        },
	        449: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        446: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        451: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        711: {
	            1: fa_a12,
	            2: fa_b12,
	            3: fa_c12
	        },
	        712: {
	            1: fa_d12,
	            2: fa_e12,
	            3: fa_f12
	        },
	        713: {
	            1: fa_g12,
	            2: fa_h12,
	            3: fa_i12
	        },
	        450: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        447: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        448: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        662: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        663: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        665: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        668: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        670: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        671: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        3: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        4: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        6: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        8: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        10: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        11: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        161: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        162: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        164: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        167: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        169: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        170: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        707: {
	            1: fa_c6,
	            2: fa_d6,
	            3: fa_j12
	        },
	        708: {
	            1: fa_c6,
	            2: fa_d6,
	            3: fa_j12
	        },
	        709: {
	            1: fa_c6,
	            2: fa_d6,
	            3: fa_j12
	        },
	        946: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        947: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    23: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    13: {
	        468: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        470: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        467: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        469: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        464: {
	            1: fa_k12,
	            2: fa_l12
	        },
	        466: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        465: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        463: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        289: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        288: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        292: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        461: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        283: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        295: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        293: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        284: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        285: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        316: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        286: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        287: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        290: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        291: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        462: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        294: {
	            1: fa_d1,
	            2: fa_e1
	        }
	    },
	    39: {
	        403: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        698: {
	            1: fa_m12,
	            2: fa_z1,
	            3: fa_n12
	        },
	        349: {
	            1: fa_o12,
	            2: fa_p12
	        },
	        950: {
	            1: fa_q12,
	            2: fa_r12,
	            3: fa_s12,
	            4: fa_t12,
	            5: fa_u12,
	            6: fa_v12,
	            7: fa_w12,
	            8: fa_x12,
	            9: fa_y12,
	            10: fa_z12,
	            11: fa_a13,
	            12: fa_b13,
	            13: fa_c13
	        },
	        955: {
	            1: fa_d13,
	            2: fa_e13
	        },
	        951: {
	            1: fa_f13,
	            2: fa_g13
	        },
	        952: {
	            1: fa_f13,
	            2: fa_g13
	        },
	        953: {
	            1: fa_f13,
	            2: fa_g13
	        },
	        954: {
	            1: fa_f13,
	            2: fa_g13
	        }
	    },
	    33: {
	        348: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    24: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    9: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        698: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        674: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    21: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    29: {
	        394: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        395: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        396: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        397: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        398: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        399: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        400: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        401: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        402: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        100: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        101: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        104: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        105: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        106: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        107: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        108: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        109: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        110: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        111: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        112: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        113: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        114: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        115: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        116: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        117: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        118: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        119: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        120: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        121: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        808: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        809: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        810: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        811: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        812: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        813: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        814: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        815: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        816: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        817: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        818: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        819: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        820: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        821: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        822: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        823: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        824: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        825: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        826: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        827: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        828: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        829: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        830: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        831: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        832: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        833: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        834: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        835: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        836: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        837: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        838: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        839: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        840: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        841: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        842: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        843: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        844: {
	            1: fa_h13,
	            2: fa_i13,
	            3: fa_j13,
	            4: fa_k13,
	            5: fa_l13,
	            6: fa_m13
	        },
	        366: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        367: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        368: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        369: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        370: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        371: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        372: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        373: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        374: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        375: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        376: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        377: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        378: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        379: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        380: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        381: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        382: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        383: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        384: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        385: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        386: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        387: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        388: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        389: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        390: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        391: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        392: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        393: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        481: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        482: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        483: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        484: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        485: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        486: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        487: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        488: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        489: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        490: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        491: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        492: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        493: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        494: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        495: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        496: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        497: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        498: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        499: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        500: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        501: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        502: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        503: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        504: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        505: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        506: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        507: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        508: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        509: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        510: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        511: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        566: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        567: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        568: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        569: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        570: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        571: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        572: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        573: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        574: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        575: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        576: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        577: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        578: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        579: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        580: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        581: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        582: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        583: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        584: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        585: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        586: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        587: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        588: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        589: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        590: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        591: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        592: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        593: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        594: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        595: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        596: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        597: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        598: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        599: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        600: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        601: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        602: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        83: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        84: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        85: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        86: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        87: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        88: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        89: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        90: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        91: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        92: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        93: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        94: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        95: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        96: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        97: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        98: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        99: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        254: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        403: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        24: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        25: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        26: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        27: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        28: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        29: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        30: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        31: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        32: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        33: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        34: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        35: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        36: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        37: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        38: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        39: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        40: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        41: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        42: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        43: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        44: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        45: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        46: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        47: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        48: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        49: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        50: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        51: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        52: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        53: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        54: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        55: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        56: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        57: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        199: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        200: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        201: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        202: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        203: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        204: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        205: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        206: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        207: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        208: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        209: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        210: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        211: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        212: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        213: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        214: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        215: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        216: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        217: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        218: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        219: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        220: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        221: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        222: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        223: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        224: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        225: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        226: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        227: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        228: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        229: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        230: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        231: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        475: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        476: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        477: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        478: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        479: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        480: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    15: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    2: {
	        73: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        318: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        24: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        25: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        26: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        27: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        199: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        200: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        201: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        352: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        102: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        403: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        141: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        142: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        143: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        144: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        185: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        186: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        187: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        188: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        566: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        567: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        568: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        569: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        570: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        571: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        572: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        366: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        367: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        368: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        369: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        370: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        371: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        372: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        122: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        123: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        124: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        125: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        126: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        127: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        128: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        129: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        130: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        131: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        132: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        133: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        134: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        135: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        872: {
	            1: fa_s3,
	            2: fa_t6,
	            3: fa_u6,
	            4: fa_v6,
	            5: fa_w6,
	            6: fa_n13
	        },
	        873: {
	            1: fa_s3,
	            2: fa_t6,
	            3: fa_u6,
	            4: fa_v6,
	            5: fa_w6,
	            6: fa_n13
	        },
	        874: {
	            1: fa_s3,
	            2: fa_t6,
	            3: fa_u6,
	            4: fa_v6,
	            5: fa_w6,
	            6: fa_n13
	        },
	        875: {
	            1: fa_s3,
	            2: fa_t6,
	            3: fa_u6,
	            4: fa_v6,
	            5: fa_w6,
	            6: fa_n13
	        },
	        876: {
	            1: fa_s3,
	            2: fa_t6,
	            3: fa_u6,
	            4: fa_v6,
	            5: fa_w6,
	            6: fa_n13
	        },
	        877: {
	            1: fa_s3,
	            2: fa_t6,
	            3: fa_u6,
	            4: fa_v6,
	            5: fa_w6,
	            6: fa_n13
	        },
	        878: {
	            1: fa_s3,
	            2: fa_t6,
	            3: fa_u6,
	            4: fa_v6,
	            5: fa_w6,
	            6: fa_n13
	        },
	        616: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        617: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        618: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        619: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        620: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        621: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        622: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        894: {
	            1: fa_o13,
	            2: fa_p13,
	            3: fa_q13,
	            4: fa_r13
	        },
	        895: {
	            1: fa_o13,
	            2: fa_p13,
	            3: fa_q13,
	            4: fa_r13
	        },
	        896: {
	            1: fa_o13,
	            2: fa_p13,
	            3: fa_q13,
	            4: fa_r13
	        },
	        897: {
	            1: fa_o13,
	            2: fa_p13,
	            3: fa_q13,
	            4: fa_r13
	        },
	        898: {
	            1: fa_o13,
	            2: fa_p13,
	            3: fa_q13,
	            4: fa_r13
	        },
	        899: {
	            1: fa_o13,
	            2: fa_p13,
	            3: fa_q13,
	            4: fa_r13
	        },
	        900: {
	            1: fa_o13,
	            2: fa_p13,
	            3: fa_q13,
	            4: fa_r13
	        },
	        443: {
	            1: fa_j1,
	            2: fa_s13
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        83: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        84: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        85: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        86: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        87: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        88: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        89: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        257: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        307: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        752: {
	            1: fa_u1,
	            2: fa_v1,
	            3: fa_w1,
	            4: fa_t1,
	            5: fa_q1,
	            6: fa_o1
	        },
	        753: {
	            1: fa_i3,
	            2: fa_j3,
	            3: fa_k3,
	            4: fa_l3,
	            5: fa_g3,
	            6: fa_c3,
	            7: fa_z2,
	            8: fa_v2
	        }
	    },
	    6: {
	        553: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        339: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        547: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        141: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        142: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        185: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        186: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        83: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        84: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        85: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        86: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        87: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        807: {
	            1: fa_k6,
	            2: fa_m6,
	            3: fa_q6,
	            4: fa_s6
	        },
	        636: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        334: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        335: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        336: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        337: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        906: {
	            1: fa_f7,
	            2: fa_g7,
	            3: fa_h7,
	            4: fa_i7
	        },
	        907: {
	            1: fa_f7,
	            2: fa_g7,
	            3: fa_h7,
	            4: fa_i7
	        },
	        908: {
	            1: fa_f7,
	            2: fa_g7,
	            3: fa_h7,
	            4: fa_i7
	        },
	        909: {
	            1: fa_f7,
	            2: fa_g7,
	            3: fa_h7,
	            4: fa_i7
	        },
	        300: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        301: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        302: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        303: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        304: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        310: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        311: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        312: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        313: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        314: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        554: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        555: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        556: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        557: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        558: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        517: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        518: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        519: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        520: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        521: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        561: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        562: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        563: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        564: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        565: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        73: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        318: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        24: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        25: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        199: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        352: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        748: {
	            1: fa_n1,
	            2: fa_o1,
	            3: fa_p1,
	            4: fa_q1,
	            5: fa_r1,
	            6: fa_s1,
	            7: fa_t1,
	            8: fa_u1,
	            9: fa_v1,
	            10: fa_w1
	        },
	        102: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        403: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        903: {
	            1: fa_t13,
	            2: fa_u13,
	            3: fa_v13,
	            4: fa_w13,
	            5: fa_x13,
	            6: fa_y13,
	            7: fa_z13,
	            8: fa_a14
	        },
	        445: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        754: {
	            1: fa_y9,
	            2: fa_z9,
	            3: fa_e3,
	            4: fa_b14,
	            5: fa_d7,
	            6: fa_c14,
	            7: fa_a10,
	            8: fa_b10,
	            9: fa_d14,
	            10: fa_e14,
	            11: fa_f14,
	            12: fa_g14,
	            13: fa_h14,
	            14: fa_i14
	        },
	        755: {
	            1: fa_y9,
	            2: fa_z9,
	            3: fa_e3,
	            4: fa_b14,
	            5: fa_d7,
	            6: fa_c14,
	            7: fa_a10,
	            8: fa_b10,
	            9: fa_d14,
	            10: fa_e14,
	            11: fa_f14,
	            12: fa_g14,
	            13: fa_h14,
	            14: fa_i14
	        },
	        756: {
	            1: fa_y9,
	            2: fa_z9,
	            3: fa_e3,
	            4: fa_b14,
	            5: fa_d7,
	            6: fa_c14,
	            7: fa_a10,
	            8: fa_b10,
	            9: fa_d14,
	            10: fa_e14,
	            11: fa_f14,
	            12: fa_g14,
	            13: fa_h14,
	            14: fa_i14
	        },
	        757: {
	            1: fa_y9,
	            2: fa_z9,
	            3: fa_e3,
	            4: fa_b14,
	            5: fa_d7,
	            6: fa_c14,
	            7: fa_a10,
	            8: fa_b10,
	            9: fa_d14,
	            10: fa_e14,
	            11: fa_f14,
	            12: fa_g14,
	            13: fa_h14,
	            14: fa_i14
	        },
	        758: {
	            1: fa_y9,
	            2: fa_z9,
	            3: fa_e3,
	            4: fa_b14,
	            5: fa_d7,
	            6: fa_c14,
	            7: fa_a10,
	            8: fa_b10,
	            9: fa_d14,
	            10: fa_e14,
	            11: fa_f14,
	            12: fa_g14,
	            13: fa_h14,
	            14: fa_i14
	        },
	        452: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        453: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        454: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        566: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        567: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        568: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        569: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        570: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        366: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        367: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        368: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        369: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        370: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        522: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        627: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        628: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        629: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        630: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        631: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        632: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        190: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        191: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        192: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        193: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        194: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        759: {
	            1: fa_j14,
	            2: fa_k14,
	            3: fa_l14,
	            4: fa_m14,
	            5: fa_n14,
	            6: fa_h14,
	            7: fa_o14,
	            8: fa_p14,
	            9: fa_q14,
	            10: fa_r14,
	            11: fa_s14,
	            12: fa_t14,
	            13: fa_c14,
	            14: fa_u14
	        },
	        760: {
	            1: fa_j14,
	            2: fa_k14,
	            3: fa_l14,
	            4: fa_m14,
	            5: fa_n14,
	            6: fa_h14,
	            7: fa_o14,
	            8: fa_p14,
	            9: fa_q14,
	            10: fa_r14,
	            11: fa_s14,
	            12: fa_t14,
	            13: fa_c14,
	            14: fa_u14
	        },
	        761: {
	            1: fa_j14,
	            2: fa_k14,
	            3: fa_l14,
	            4: fa_m14,
	            5: fa_n14,
	            6: fa_h14,
	            7: fa_o14,
	            8: fa_p14,
	            9: fa_q14,
	            10: fa_r14,
	            11: fa_s14,
	            12: fa_t14,
	            13: fa_c14,
	            14: fa_u14
	        },
	        762: {
	            1: fa_j14,
	            2: fa_k14,
	            3: fa_l14,
	            4: fa_m14,
	            5: fa_n14,
	            6: fa_h14,
	            7: fa_o14,
	            8: fa_p14,
	            9: fa_q14,
	            10: fa_r14,
	            11: fa_s14,
	            12: fa_t14,
	            13: fa_c14,
	            14: fa_u14
	        },
	        763: {
	            1: fa_j14,
	            2: fa_k14,
	            3: fa_l14,
	            4: fa_m14,
	            5: fa_n14,
	            6: fa_h14,
	            7: fa_o14,
	            8: fa_p14,
	            9: fa_q14,
	            10: fa_r14,
	            11: fa_s14,
	            12: fa_t14,
	            13: fa_c14,
	            14: fa_u14
	        },
	        768: {
	            1: fa_i6,
	            2: fa_v14,
	            3: fa_w14,
	            4: fa_x14,
	            5: fa_y14,
	            6: fa_c2,
	            7: fa_z14
	        },
	        769: {
	            1: fa_i6,
	            2: fa_v14,
	            3: fa_w14,
	            4: fa_x14,
	            5: fa_y14,
	            6: fa_c2,
	            7: fa_z14
	        },
	        770: {
	            1: fa_i6,
	            2: fa_v14,
	            3: fa_w14,
	            4: fa_x14,
	            5: fa_y14,
	            6: fa_c2,
	            7: fa_z14
	        },
	        771: {
	            1: fa_i6,
	            2: fa_v14,
	            3: fa_w14,
	            4: fa_x14,
	            5: fa_y14,
	            6: fa_c2,
	            7: fa_z14
	        },
	        772: {
	            1: fa_i6,
	            2: fa_v14,
	            3: fa_w14,
	            4: fa_x14,
	            5: fa_y14,
	            6: fa_c2,
	            7: fa_z14
	        },
	        603: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        604: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        605: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        606: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        607: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        257: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        307: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        696: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        333: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        341: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        427: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        536: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        905: {
	            1: fa_f7,
	            2: fa_g7,
	            3: fa_h7,
	            4: fa_i7
	        },
	        320: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        514: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        516: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        305: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        315: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        523: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        299: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        309: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        697: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        298: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        308: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        515: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        549: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        548: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        550: {
	            1: fa_a15,
	            2: fa_y1
	        },
	        551: {
	            1: fa_x1,
	            2: fa_b15
	        },
	        455: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        456: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        457: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        458: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        459: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        460: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        512: {
	            1: fa_a15,
	            2: fa_y1
	        },
	        513: {
	            1: fa_c15,
	            2: fa_b15
	        },
	        901: {
	            1: fa_t13,
	            2: fa_u13,
	            3: fa_v13,
	            4: fa_w13,
	            5: fa_x13,
	            6: fa_y13,
	            7: fa_z13,
	            8: fa_a14
	        },
	        902: {
	            1: fa_t13,
	            2: fa_u13,
	            3: fa_v13,
	            4: fa_w13,
	            5: fa_x13,
	            6: fa_y13,
	            7: fa_z13,
	            8: fa_a14
	        },
	        340: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        328: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        329: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        342: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        330: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        331: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        722: {
	            1: fa_k10,
	            2: fa_l10,
	            3: fa_m10
	        },
	        560: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        543: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        544: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        545: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        546: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        332: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        559: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        296: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        297: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        717: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        718: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        719: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        720: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        721: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        552: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        76: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        77: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        78: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        79: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        80: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        647: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        741: {
	            1: fa_d15,
	            2: fa_t7,
	            3: fa_e15
	        },
	        82: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        338: {
	            1: fa_d1,
	            2: fa_e1
	        }
	    },
	    17: {
	        348: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        443: {
	            1: fa_f15,
	            2: fa_g15
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    4: {
	        73: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        318: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        21: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        22: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        23: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        24: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        25: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        199: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        352: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        764: {
	            1: fa_o1,
	            2: fa_q1,
	            3: fa_t1,
	            4: fa_u1,
	            5: fa_v1,
	            6: fa_w1
	        },
	        102: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        403: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        138: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        139: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        140: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        141: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        142: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        182: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        183: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        184: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        185: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        186: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        366: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        367: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        368: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        369: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        370: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        566: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        567: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        568: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        569: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        570: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        923: {
	            1: fa_s3,
	            2: fa_t6,
	            3: fa_u6,
	            4: fa_v6,
	            5: fa_w6,
	            6: fa_x6,
	            7: fa_y6,
	            8: fa_z6
	        },
	        924: {
	            1: fa_s3,
	            2: fa_t6,
	            3: fa_u6,
	            4: fa_v6,
	            5: fa_w6,
	            6: fa_x6,
	            7: fa_y6,
	            8: fa_z6
	        },
	        925: {
	            1: fa_s3,
	            2: fa_t6,
	            3: fa_u6,
	            4: fa_v6,
	            5: fa_w6,
	            6: fa_x6,
	            7: fa_y6,
	            8: fa_z6
	        },
	        926: {
	            1: fa_s3,
	            2: fa_t6,
	            3: fa_u6,
	            4: fa_v6,
	            5: fa_w6,
	            6: fa_x6,
	            7: fa_y6,
	            8: fa_z6
	        },
	        927: {
	            1: fa_s3,
	            2: fa_t6,
	            3: fa_u6,
	            4: fa_v6,
	            5: fa_w6,
	            6: fa_x6,
	            7: fa_y6,
	            8: fa_z6
	        },
	        929: {
	            1: fa_s3,
	            2: fa_h15,
	            3: fa_i15,
	            4: fa_j15,
	            5: fa_z6
	        },
	        930: {
	            1: fa_s3,
	            2: fa_h15,
	            3: fa_i15,
	            4: fa_j15,
	            5: fa_z6
	        },
	        931: {
	            1: fa_s3,
	            2: fa_h15,
	            3: fa_i15,
	            4: fa_j15,
	            5: fa_z6
	        },
	        932: {
	            1: fa_s3,
	            2: fa_h15,
	            3: fa_i15,
	            4: fa_j15,
	            5: fa_z6
	        },
	        933: {
	            1: fa_s3,
	            2: fa_h15,
	            3: fa_i15,
	            4: fa_j15,
	            5: fa_z6
	        },
	        845: {
	            1: fa_t1,
	            2: fa_d7,
	            3: fa_k15,
	            4: fa_i1
	        },
	        846: {
	            1: fa_t1,
	            2: fa_d7,
	            3: fa_k15,
	            4: fa_i1
	        },
	        847: {
	            1: fa_t1,
	            2: fa_d7,
	            3: fa_k15,
	            4: fa_i1
	        },
	        848: {
	            1: fa_t1,
	            2: fa_d7,
	            3: fa_k15,
	            4: fa_i1
	        },
	        849: {
	            1: fa_t1,
	            2: fa_d7,
	            3: fa_k15,
	            4: fa_i1
	        },
	        918: {
	            1: fa_t1,
	            2: fa_d7,
	            3: fa_k15,
	            4: fa_h1
	        },
	        919: {
	            1: fa_t1,
	            2: fa_d7,
	            3: fa_k15,
	            4: fa_h1
	        },
	        920: {
	            1: fa_t1,
	            2: fa_d7,
	            3: fa_k15,
	            4: fa_h1
	        },
	        921: {
	            1: fa_t1,
	            2: fa_d7,
	            3: fa_k15,
	            4: fa_h1
	        },
	        922: {
	            1: fa_t1,
	            2: fa_d7,
	            3: fa_k15,
	            4: fa_h1
	        },
	        83: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        84: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        85: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        86: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        87: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        905: {
	            1: fa_f7,
	            2: fa_g7,
	            3: fa_h7,
	            4: fa_i7
	        },
	        906: {
	            1: fa_f7,
	            2: fa_g7,
	            3: fa_h7,
	            4: fa_i7
	        },
	        907: {
	            1: fa_f7,
	            2: fa_g7,
	            3: fa_h7,
	            4: fa_i7
	        },
	        908: {
	            1: fa_f7,
	            2: fa_g7,
	            3: fa_h7,
	            4: fa_i7
	        },
	        909: {
	            1: fa_f7,
	            2: fa_g7,
	            3: fa_h7,
	            4: fa_i7
	        },
	        807: {
	            1: fa_k6,
	            2: fa_m6,
	            3: fa_q6,
	            4: fa_s6
	        },
	        319: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        320: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        912: {
	            1: fa_j7,
	            2: fa_k7,
	            3: fa_l7,
	            4: fa_m7,
	            5: fa_n7,
	            6: fa_o7
	        },
	        913: {
	            1: fa_j7,
	            2: fa_k7,
	            3: fa_l7,
	            4: fa_m7,
	            5: fa_n7,
	            6: fa_o7
	        },
	        914: {
	            1: fa_j7,
	            2: fa_k7,
	            3: fa_l7,
	            4: fa_m7,
	            5: fa_n7,
	            6: fa_o7
	        },
	        915: {
	            1: fa_j7,
	            2: fa_k7,
	            3: fa_l7,
	            4: fa_m7,
	            5: fa_n7,
	            6: fa_o7
	        },
	        916: {
	            1: fa_j7,
	            2: fa_k7,
	            3: fa_l7,
	            4: fa_m7,
	            5: fa_n7,
	            6: fa_o7
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        257: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        307: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        362: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        363: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        364: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        365: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        17: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        18: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        19: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        20: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        176: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        177: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        178: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        179: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        358: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        359: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        360: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        361: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        13: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        14: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        15: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        16: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        172: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        173: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        174: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        175: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        281: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        137: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        616: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        617: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        618: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        619: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        620: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        891: {
	            1: fa_e2,
	            2: fa_f2,
	            3: fa_g2,
	            4: fa_h2
	        },
	        26: {
	            1: fa_l15,
	            2: fa_m15
	        },
	        200: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        143: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        187: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        371: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        571: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        928: {
	            1: fa_s3,
	            2: fa_t6,
	            3: fa_u6,
	            4: fa_v6,
	            5: fa_w6,
	            6: fa_x6,
	            7: fa_y6,
	            8: fa_z6
	        },
	        934: {
	            1: fa_s3,
	            2: fa_h15,
	            3: fa_i15,
	            4: fa_j15,
	            5: fa_z6
	        },
	        88: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        910: {
	            1: fa_f7,
	            2: fa_g7,
	            3: fa_h7,
	            4: fa_i7
	        },
	        917: {
	            1: fa_j7,
	            2: fa_k7,
	            3: fa_n15,
	            4: fa_m7,
	            5: fa_n7,
	            6: fa_o15
	        },
	        936: {
	            1: fa_k2,
	            2: fa_l2,
	            3: fa_m2,
	            4: fa_n2,
	            5: fa_o2,
	            6: fa_g6
	        }
	    },
	    8: {
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        656: {
	            1: fa_b2,
	            2: fa_c2,
	            3: fa_d2
	        },
	        698: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        195: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        196: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        197: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        198: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        673: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        674: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        675: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        676: {
	            1: fa_h1,
	            2: fa_z1,
	            3: fa_i1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    27: {
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    },
	    28: {
	        403: {
	            1: fa_h1,
	            2: fa_i1
	        },
	        615: {
	            1: fa_x1,
	            2: fa_y1
	        },
	        74: {
	            1: fa_b1,
	            2: fa_c1
	        },
	        349: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        256: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        306: {
	            1: fa_d1,
	            2: fa_e1
	        },
	        103: {
	            1: fa_f1,
	            2: fa_g1
	        },
	        935: {
	            1: fa_a10,
	            2: fa_b10,
	            3: fa_d14,
	            4: fa_e14,
	            5: fa_f14,
	            6: fa_p15,
	            7: fa_y9,
	            8: fa_z9,
	            9: fa_e3,
	            10: fa_b14,
	            11: fa_d7,
	            12: fa_q15
	        },
	        612: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        613: {
	            1: fa_l1,
	            2: fa_m1
	        },
	        443: {
	            1: fa_j1,
	            2: fa_k1
	        },
	        608: {
	            1: fa_l1,
	            2: fa_m1
	        }
	    }
	};
	
	var periodConfig = {
	    2: {
	        208: 'O`yin tugadi',
	        207: 'Yettinchi partiya',
	        206: 'Oltinchi partiya',
	        205: 'Beshinchi partiya',
	        200: 'O`yin hali boshlanmadi',
	        203: 'Uchinchi partiya',
	        202: 'Ikkinchi partiya',
	        201: 'Birinchi partiya',
	        204: 'To`rtinchi partiya'
	    },
	    3: {
	        304: 'O`yin tugadi',
	        303: 'Uchinchi set',
	        302: 'Ikkinchi set',
	        301: 'Birinchi set',
	        300: 'O`yin hali boshlanmadi'
	    },
	    4: {
	        406: 'O`yin tugadi',
	        403: 'Uchinchi set',
	        402: 'Ikkinchi set',
	        401: 'Birinchi set',
	        400: 'O`yin hali boshlanmadi',
	        407: 'Oltin set',
	        405: 'Beshinchi set',
	        404: 'To`rtinchi set'
	    },
	    5: {
	        510: 'O`ninchi raund',
	        509: 'To`qqizinchi raund',
	        508: 'Sakkizinchi raund',
	        507: 'Yettinchi raund',
	        506: 'Oltinchi raund',
	        505: 'Beshinchi raund',
	        513: 'O`yin tugadi',
	        503: 'Uchinchi raund',
	        500: 'O`yin hali boshlanmadi',
	        501: 'Birinchi raund',
	        502: 'Ikkinchi raund',
	        511: 'O`n birinchi raund',
	        512: 'O`n ikkinchi raund',
	        504: 'To`rtinchi raund'
	    },
	    6: {
	        600: 'O`yin hali boshlanmadi',
	        601: 'Birinchi set',
	        602: 'Ikkinchi set',
	        603: 'Uchinchi set',
	        604: 'To`rtinchi set',
	        605: 'Beshinchi set',
	        606: 'O`yin tugadi'
	    },
	    7: {
	        701: 'Birinchi Bo`lim',
	        700: 'O`yin hali boshlanmadi',
	        703: 'Ikkinchi Bo`lim',
	        704: 'Asosiy vaqt tugadi',
	        705: 'Birinchi qo`shimcha bo`lim',
	        702: 'Tanaffus',
	        707: 'Ikkinchi qo`shimcha bo`lim',
	        708: 'Ikkinchi qo`shimcha bo`lim tugadi',
	        709: 'Penalti',
	        710: 'O`yin tugadi',
	        706: 'Birinchi qo`shimcha bo`lim tugadi'
	    },
	    8: {
	        808: 'To`xtalish',
	        807: 'To`rtinchi chorak',
	        806: 'To`xtalish',
	        805: 'Uchinchi chorak',
	        804: 'Tanaffus',
	        809: 'Overtime',
	        802: 'To`xtalish',
	        801: 'Birinchi chorak',
	        800: 'O`yin hali boshlanmadi',
	        810: 'O`yin tugadi',
	        803: 'Ikkinchi chorak'
	    },
	    9: {
	        903: 'Ikkinchi Bo`lim',
	        902: 'Tanaffus',
	        901: 'Birinchi Bo`lim',
	        900: 'O`yin hali boshlanmadi',
	        904: 'O`yin tugadi'
	    },
	    12: {
	        1203: 'Ikkinchi Bo`lim',
	        1202: 'Tanaffus',
	        1201: 'Birinchi Bo`lim',
	        1200: 'O`yin hali boshlanmadi',
	        1204: 'O`yin tugadi'
	    },
	    18: {
	        1808: 'Overtime tugadi',
	        1807: 'Overtime',
	        1806: 'Asosiy vaqt tugadi',
	        1805: 'Uchinchi davr',
	        1804: 'Ikkinchi Tanaffus',
	        1809: 'Penalti',
	        1802: 'Birinchi Tanaffus',
	        1801: 'Birinchi davr',
	        1800: 'O`yin hali boshlanmadi',
	        1810: 'O`yin tugadi',
	        1803: 'Ikkinchi davr'
	    },
	    19: {
	        1904: 'Asosiy vaqt tugadi',
	        1903: 'Ikkinchi Bo`lim',
	        1902: 'Tanaffus',
	        1901: 'Birinchi Bo`lim',
	        1900: 'O`yin hali boshlanmadi',
	        1905: 'O`yin tugadi'
	    },
	    20: {
	        2016: 'Sakkizinchi o`t ochish marrasi',
	        2017: 'O`yin tugadi',
	        2000: 'O`yin hali boshlanmadi',
	        2001: 'Birinchi aylana',
	        2002: 'Birinchi o`t ochish marrasi',
	        2003: 'Ikkinchi aylana',
	        2004: 'Ikkinchi o`t ochish marrasi',
	        2005: 'Uchinchi aylana',
	        2006: 'Uchinchi o`t ochish marrasi',
	        2007: 'To`rtinchi aylana',
	        2008: 'To`rtinchi o`t ochish marrasi',
	        2009: 'Beshinchi aylana',
	        2010: 'Beshinchi o`t ochish marrasi',
	        2011: 'Oltinchi aylana',
	        2012: 'Oltinchi o`t ochish marrasi',
	        2013: 'Yettinchi aylana',
	        2014: 'Yettinchi o`t ochish marrasi',
	        2015: 'Sakkizinchi aylana'
	    },
	    28: {
	        2801: 'Asosiy vaqt',
	        2802: 'O`yin tugadi',
	        2800: 'O`yin hali boshlanmadi'
	    },
	    29: {
	        2911: '6-partiya',
	        2912: 'Tanaffus',
	        2913: '7-partiya',
	        2914: 'Tanaffus',
	        2915: '8-partiya',
	        2916: 'Tanaffus',
	        2917: '9-partiya',
	        2918: 'Tanaffus',
	        2919: '10-partiya',
	        2920: 'Tanaffus',
	        2921: '11-partiya',
	        2964: 'Tanaffus',
	        2965: '33-partiya',
	        2966: 'Tanaffus',
	        2967: '34-partiya',
	        2968: 'Tanaffus',
	        2969: '35-partiya',
	        2970: 'Tanaffus',
	        2971: '36-partiya',
	        2972: 'Tanaffus',
	        2973: '37-partiya',
	        2974: 'O`yin tugadi',
	        2943: '22-partiya',
	        2944: 'Tanaffus',
	        2945: '23-partiya',
	        2946: 'Tanaffus',
	        2947: '24-partiya',
	        2948: 'Tanaffus',
	        2949: '25-partiya',
	        2950: 'Tanaffus',
	        2951: '26-partiya',
	        2952: 'Tanaffus',
	        2953: '27-partiya',
	        2954: 'Tanaffus',
	        2955: '28-partiya',
	        2956: 'Tanaffus',
	        2957: '29-partiya',
	        2958: 'Tanaffus',
	        2959: '30-partiya',
	        2960: 'Tanaffus',
	        2961: '31-partiya',
	        2962: 'Tanaffus',
	        2963: '32-partiya',
	        2922: 'Tanaffus',
	        2923: '12-partiya',
	        2924: 'Tanaffus',
	        2925: '13-partiya',
	        2926: 'Tanaffus',
	        2927: '14-partiya',
	        2928: 'Tanaffus',
	        2929: '15-partiya',
	        2930: 'Tanaffus',
	        2931: '16-partiya',
	        2932: 'Tanaffus',
	        2933: '17-partiya',
	        2934: 'Tanaffus',
	        2935: '18-partiya',
	        2936: 'Tanaffus',
	        2937: '19-partiya',
	        2938: 'Tanaffus',
	        2939: '20-partiya',
	        2940: 'Tanaffus',
	        2941: '21-partiya',
	        2942: 'Tanaffus',
	        2900: 'O`yin hali boshlanmadi',
	        2901: '1-partiya',
	        2902: 'Tanaffus',
	        2903: '2-partiya',
	        2904: 'Tanaffus',
	        2905: '3-partiya',
	        2906: 'Tanaffus',
	        2907: '4-partiya',
	        2908: 'Tanaffus',
	        2909: '5-partiya',
	        2910: 'Tanaffus'
	    },
	    30: {
	        3008: 'Qo`shimcha vaqt tugadi',
	        3007: 'Overtime',
	        3006: 'Asosiy vaqt tugadi',
	        3005: 'Uchinchi davr',
	        3004: 'Ikkinchi Tanaffus',
	        3009: 'Bullitlar',
	        3002: 'Birinchi Tanaffus',
	        3001: 'Birinchi davr',
	        3000: 'O`yin hali boshlanmadi',
	        3010: 'O`yin tugadi',
	        3003: 'Ikkinchi davr'
	    },
	    31: {
	        3108: 'To`xtalish',
	        3107: 'To`rtinchi chorak',
	        3106: 'To`xtalish',
	        3105: 'Uchinchi chorak',
	        3104: 'Tanaffus',
	        3109: 'Overtime',
	        3102: 'To`xtalish',
	        3101: 'Birinchi chorak',
	        3100: 'O`yin hali boshlanmadi',
	        3110: 'O`yin tugadi',
	        3103: 'Ikkinchi chorak'
	    },
	    32: {
	        3203: 'Uchinchi set',
	        3202: 'Ikkinchi set',
	        3201: 'Birinchi set',
	        3200: 'O`yin hali boshlanmadi',
	        3204: 'O`yin tugadi'
	    },
	    34: {
	        3400: 'O`yin hali boshlanmadi',
	        3401: 'Birinchi bo`lim',
	        3402: 'Tanaffus',
	        3403: 'Ikkinchi bo`lim',
	        3404: 'Asosiy vaqt tugadi',
	        3410: 'O`yin tugadi',
	        3406: 'Birinchi qo`shimcha bo`lim tugadi',
	        3407: 'Ikkinchi qo`shimcha bo`lim',
	        3408: 'Ikkinchi qo`shimcha bo`lim tugadi',
	        3409: 'Penalti',
	        3405: 'Birinchi qo`shimcha bo`lim'
	    },
	    35: {
	        3500: 'O`yin hali boshlanmadi',
	        3501: 'Birinchi Bo`lim',
	        3502: 'Tanaffus',
	        3503: 'Ikkinchi Bo`lim',
	        3504: 'O`yin tugadi'
	    },
	    36: {
	        3601: 'Birinchi davr',
	        3602: 'Birinchi Tanaffus',
	        3603: 'Ikkinchi davr',
	        3604: 'Ikkinchi Tanaffus',
	        3605: 'Uchinchi davr',
	        3600: 'O`yin hali boshlanmadi',
	        3607: 'Overtime',
	        3608: 'Qo`shimcha vaqt tugadi',
	        3609: 'Bullitlar',
	        3610: 'O`yin tugadi',
	        3606: 'Asosiy vaqt tugadi'
	    },
	    37: {
	        3701: 'O`yin tugadi',
	        3700: 'O`yin hali boshlanmadi'
	    },
	    38: {
	        3801: 'O`yin tugadi',
	        3800: 'O`yin hali boshlanmadi'
	    },
	    39: {
	        3901: 'O`yin tugadi',
	        3900: 'O`yin hali boshlanmadi',
	        3902: 'Birinchi raund',
	        3903: 'Ikkinchi raund',
	        3904: 'Uchinchi raund',
	        3905: 'To`rtinchi raund',
	        3906: 'Beshinchi raund'
	    },
	    40: {
	        4001: 'O`yin tugadi',
	        4000: 'O`yin hali boshlanmadi'
	    },
	    41: {
	        4102: 'Birinchi Tanaffus',
	        4106: 'O`yin tugadi',
	        4105: 'Overtime',
	        4104: 'Ikkinchi Tanaffus',
	        4103: 'O`yinning ikkinchi yarmi',
	        4101: 'O`yinning birinchi yarmi',
	        4100: 'O`yin hali boshlanmadi'
	    },
	    42: {
	        4202: 'Ikkinchi xarita',
	        4206: 'O`yin tugadi',
	        4205: 'Beshinchi xarita',
	        4204: 'To`rtinchi xarita',
	        4203: 'Uchinchi xarita',
	        4201: 'Birinchi xarita',
	        4200: 'O`yin hali boshlanmadi'
	    }
	};
	
	function getGroupName(sportId, groupType) {
	    if (groupConfig !== undefined && groupConfig[sportId] !== undefined) {
	        return groupConfig[sportId][groupType];
	    }
	
	    return undefined;
	}
	
	function getSlotName(sportId, match, slot) {
	    var func = void 0;
	
	    if (slotConfig !== undefined && slotConfig[sportId] !== undefined) {
	        func = slotConfig[sportId][slot.type];
	    }
	
	    if (func === undefined) {
	        return undefined;
	    }
	
	    return func(match, slot);
	}
	
	function getOutcomeName(sportId, outcome, match) {
	    var func = void 0;
	
	    if (baseOutcomeConfig !== undefined && baseOutcomeConfig[sportId] !== undefined && baseOutcomeConfig[sportId]) {
	        func = baseOutcomeConfig[sportId][outcome.type];
	    }
	
	    if (outcomeConfig !== undefined && outcomeConfig[sportId] !== undefined && outcomeConfig[sportId][outcome.type] !== undefined) {
	        func = outcomeConfig[sportId][outcome.type];
	    }
	
	    if (func === undefined) {
	        return undefined;
	    }
	
	    return func(match, outcome);
	}
	
	function getRateName(sportId, outcome, factorType, match) {
	    var func = void 0;
	
	    if (baseFactorNameConfig !== undefined && baseFactorNameConfig[sportId] !== undefined && baseFactorNameConfig[sportId][outcome.type] !== undefined) {
	        func = baseFactorNameConfig[sportId][outcome.type][factorType];
	    }
	
	    if (func === undefined) {
	        return undefined;
	    }
	
	    return func(match, outcome);
	}
	
	function getMatchInfoText(matchInfoType) {
	    switch (matchInfoType) {
	        case 1:
	            return "O`yin boshlanmadi";
	        case 2:
	            return "O`yin tugadi";
	        case 3:
	            return "Tanaffus";
	        case 4:
	            return "Asosiy vaqt tugadi";
	        case 5:
	            return "Birinchi qo`shimcha vaqt tugadi";
	        case 6:
	            return "Penaltilar seriyasi";
	    }
	
	    return "";
	}
	
	function getPeriodName(sportId, periodId) {
	    if (periodConfig !== undefined && periodConfig[sportId] !== undefined) {
	        return periodConfig[sportId][periodId];
	    }
	
	    return undefined;
	}
	
	function getFoulsText() {
	    return "O`yin qoidasi buzilishi";
	}
	
	function getTimeoutText() {
	    return "Tanaffus";
	}

/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = customSlotIdProvider;
	
	var _SlotFamilyType = __webpack_require__(508);
	
	var SlotFamilyType = _interopRequireWildcard(_SlotFamilyType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function customSlotIdProvider(slotType, slotFamily, rate) {
	    var outcomeId = rate.get('outcomeId');
	    var rateValue = rate.get('value');
	
	    switch (slotFamily) {
	        case SlotFamilyType.SINGLE_OUTCOME:
	        case SlotFamilyType.WIDE_SINGLE_OUTCOME:
	            return slotType + '_' + rateValue + '_' + outcomeId;
	    }
	
	    return slotType;
	}

/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = slotFamilyProvider;
	
	var _SlotFamilyType = __webpack_require__(508);
	
	var SlotFamilyType = _interopRequireWildcard(_SlotFamilyType);
	
	var _slotFamiliesConfig = __webpack_require__(1826);
	
	var _slotFamiliesConfig2 = _interopRequireDefault(_slotFamiliesConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function slotFamilyProvider(sportId, groupType, slotType) {
	    //slotType => slotFamily
	    var slotFamilies = _slotFamiliesConfig2.default[sportId][groupType];
	
	    if (slotFamilies === undefined) {
	        return SlotFamilyType.SINGLE_OUTCOME;
	    }
	
	    return slotFamilies[slotType] || SlotFamilyType.SINGLE_OUTCOME;
	}

/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = slotIdProvider;
	
	var _SlotFamilyType = __webpack_require__(508);
	
	var SlotFamilyType = _interopRequireWildcard(_SlotFamilyType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function slotIdProvider(slotType, slotFamily, outcome) {
	    var id = outcome.get('id');
	    var conditionOne = outcome.get('condition');
	    var playerId = outcome.get('playerId');
	
	    switch (slotFamily) {
	        case SlotFamilyType.TENNIS_GAME:
	            return slotType + '_' + conditionOne;
	
	        case SlotFamilyType.SINGLE_OUTCOME:
	        case SlotFamilyType.WIDE_SINGLE_OUTCOME:
	            return slotType + '_' + id;
	
	        case SlotFamilyType.TOTAL:
	            if (playerId !== undefined && playerId !== null) {
	                return slotType + '_' + playerId + '_' + conditionOne;
	            }
	            return slotType;
	    }
	
	    return slotType;
	}

/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = getSlotTypes;
	
	var _slotTypesConfig = __webpack_require__(1827);
	
	var _slotTypesConfig2 = _interopRequireDefault(_slotTypesConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getSlotTypes(sportId, groupType, outcomeType) {
	    try {
	        var slotTypes = _slotTypesConfig2.default[sportId][groupType][outcomeType];
	
	        if (slotTypes === undefined) {
	            console.warn('Cannot find slot types for sport#' + sportId + ', group#' + groupType + ' outcome#' + outcomeType); //eslint-disable-line no-console
	        }
	
	        return slotTypes || [outcomeType];
	    } catch (e) {
	        console.log('Cant find slot type for sport#' + sportId + ', group#' + groupType + ' outcome#' + outcomeType + ':', e); //eslint-disable-line no-console
	    }
	
	    return [outcomeType];
	}

/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SLOT_TYPE_POSITION_CALCULATOR = exports.CONDITION_POSITION_CALCULATOR = undefined;
	exports.default = positionCalculatorProvider;
	
	var _SlotTypePositionCalculator = __webpack_require__(779);
	
	var _SlotTypePositionCalculator2 = _interopRequireDefault(_SlotTypePositionCalculator);
	
	var _ConditionPositionCalculator = __webpack_require__(1264);
	
	var _ConditionPositionCalculator2 = _interopRequireDefault(_ConditionPositionCalculator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CONDITION_POSITION_CALCULATOR = exports.CONDITION_POSITION_CALCULATOR = 1;
	var SLOT_TYPE_POSITION_CALCULATOR = exports.SLOT_TYPE_POSITION_CALCULATOR = 2;
	
	function positionCalculatorProvider(positionCalculatorType) {
	    switch (positionCalculatorType) {
	        case SLOT_TYPE_POSITION_CALCULATOR:
	            return _SlotTypePositionCalculator2.default;
	
	        case CONDITION_POSITION_CALCULATOR:
	            return _ConditionPositionCalculator2.default;
	    }
	
	    console.warn('Cannot find position calculator', positionCalculatorType); //eslint-disable-line no-console
	}

/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _PositionCalculatorProvider = __webpack_require__(1262);
	
	var _PositionCalculatorProvider2 = _interopRequireDefault(_PositionCalculatorProvider);
	
	var _slotOrderFunctionsConfig = __webpack_require__(1829);
	
	var _slotOrderFunctionsConfig2 = _interopRequireDefault(_slotOrderFunctionsConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultSlotArrangementPolicy = function () {
	    function DefaultSlotArrangementPolicy() {
	        (0, _classCallCheck3.default)(this, DefaultSlotArrangementPolicy);
	    }
	
	    (0, _createClass3.default)(DefaultSlotArrangementPolicy, null, [{
	        key: 'getPosition',
	        value: function getPosition(sportId, groupType, slot) {
	            var slotType = slot.type;
	
	            //slotType => order functions
	            var orderFunctions = _slotOrderFunctionsConfig2.default[sportId][groupType];
	
	            var positionCalculatorTypes = [_PositionCalculatorProvider.SLOT_TYPE_POSITION_CALCULATOR];
	
	            if (orderFunctions !== undefined) {
	                positionCalculatorTypes = orderFunctions[slotType] || [_PositionCalculatorProvider.SLOT_TYPE_POSITION_CALCULATOR];
	            }
	
	            var position = [];
	
	            for (var i = 0; i < positionCalculatorTypes.length; i++) {
	                var positionCalculator = (0, _PositionCalculatorProvider2.default)(positionCalculatorTypes[i]);
	
	                position.push(positionCalculator(sportId, groupType, slot));
	            }
	
	            return position;
	        }
	    }]);
	    return DefaultSlotArrangementPolicy;
	}();
	
	exports.default = DefaultSlotArrangementPolicy;

/***/ },
/* 1264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = conditionPositionCalculator;
	
	var _SlotTypePositionCalculator = __webpack_require__(779);
	
	var _SlotTypePositionCalculator2 = _interopRequireDefault(_SlotTypePositionCalculator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function conditionPositionCalculator(sportType, groupType, slot) {
	    var position = (0, _SlotTypePositionCalculator2.default)(sportType, groupType, slot);
	
	    return position + (slot.condition || 0);
	}

/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var BADMINTON_GROUP_MAP = {};
	
	BADMINTON_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
	BADMINTON_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
	BADMINTON_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
	BADMINTON_GROUP_MAP[3] = GroupType.THIRD_PERIOD_GROUP;
	BADMINTON_GROUP_MAP[4] = GroupType.FIRST_PERIOD_TEN_POINTS_MINI_MATCH_GROUP;
	BADMINTON_GROUP_MAP[5] = GroupType.FIRST_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP;
	BADMINTON_GROUP_MAP[6] = GroupType.SECOND_PERIOD_TEN_POINTS_MINI_MATCH_GROUP;
	BADMINTON_GROUP_MAP[7] = GroupType.SECOND_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP;
	BADMINTON_GROUP_MAP[8] = GroupType.THIRD_PERIOD_TEN_POINTS_MINI_MATCH_GROUP;
	BADMINTON_GROUP_MAP[9] = GroupType.THIRD_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP;
	
	exports.default = BADMINTON_GROUP_MAP;

/***/ },
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _BADMINTON_SCORE_MAP$, _BADMINTON_SCORE_MAP$2, _BADMINTON_SCORE_MAP$3, _BADMINTON_SCORE_MAP$4;
	
	var _ScoreType = __webpack_require__(40);
	
	var ScoreType = _interopRequireWildcard(_ScoreType);
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	var _MatchInfo = __webpack_require__(73);
	
	var MatchInfo = _interopRequireWildcard(_MatchInfo);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BADMINTON_SCORE_MAP = {};
	BADMINTON_SCORE_MAP[Period.NOT_STARTED] = (_BADMINTON_SCORE_MAP$ = {}, (0, _defineProperty3.default)(_BADMINTON_SCORE_MAP$, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_NOT_STARTED,
	    main: ScoreType.Match
	}), (0, _defineProperty3.default)(_BADMINTON_SCORE_MAP$, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_BADMINTON_SCORE_MAP$, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_BADMINTON_SCORE_MAP$, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), _BADMINTON_SCORE_MAP$);
	
	BADMINTON_SCORE_MAP[Period.FIRST] = (_BADMINTON_SCORE_MAP$2 = {}, (0, _defineProperty3.default)(_BADMINTON_SCORE_MAP$2, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod]
	}), (0, _defineProperty3.default)(_BADMINTON_SCORE_MAP$2, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_BADMINTON_SCORE_MAP$2, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_BADMINTON_SCORE_MAP$2, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), _BADMINTON_SCORE_MAP$2);
	
	BADMINTON_SCORE_MAP[Period.SECOND] = (_BADMINTON_SCORE_MAP$3 = {}, (0, _defineProperty3.default)(_BADMINTON_SCORE_MAP$3, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod]
	}), (0, _defineProperty3.default)(_BADMINTON_SCORE_MAP$3, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_BADMINTON_SCORE_MAP$3, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), _BADMINTON_SCORE_MAP$3);
	
	BADMINTON_SCORE_MAP[Period.THIRD] = (_BADMINTON_SCORE_MAP$4 = {}, (0, _defineProperty3.default)(_BADMINTON_SCORE_MAP$4, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod]
	}), (0, _defineProperty3.default)(_BADMINTON_SCORE_MAP$4, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_BADMINTON_SCORE_MAP$4, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), _BADMINTON_SCORE_MAP$4);
	
	BADMINTON_SCORE_MAP[Period.FINISHED] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_FINISHED,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod]
	});
	
	exports.default = BADMINTON_SCORE_MAP;

/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var BANDY_GROUP_MAP = {};
	
	BANDY_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
	BANDY_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
	BANDY_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
	
	exports.default = BANDY_GROUP_MAP;

/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _BANDY_SCORE_MAP$Peri, _BANDY_SCORE_MAP$Peri2, _BANDY_SCORE_MAP$Peri3, _BANDY_SCORE_MAP$Peri4;
	
	var _ScoreType = __webpack_require__(40);
	
	var ScoreType = _interopRequireWildcard(_ScoreType);
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	var _MatchInfo = __webpack_require__(73);
	
	var MatchInfo = _interopRequireWildcard(_MatchInfo);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BANDY_SCORE_MAP = {};
	BANDY_SCORE_MAP[Period.NOT_STARTED] = (_BANDY_SCORE_MAP$Peri = {}, (0, _defineProperty3.default)(_BANDY_SCORE_MAP$Peri, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_NOT_STARTED,
	    main: ScoreType.Match
	}), (0, _defineProperty3.default)(_BANDY_SCORE_MAP$Peri, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_BANDY_SCORE_MAP$Peri, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), _BANDY_SCORE_MAP$Peri);
	
	BANDY_SCORE_MAP[Period.FIRST] = (_BANDY_SCORE_MAP$Peri2 = {}, (0, _defineProperty3.default)(_BANDY_SCORE_MAP$Peri2, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match
	}), (0, _defineProperty3.default)(_BANDY_SCORE_MAP$Peri2, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_BANDY_SCORE_MAP$Peri2, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), _BANDY_SCORE_MAP$Peri2);
	
	BANDY_SCORE_MAP[Period.FIRST_BREAK] = (_BANDY_SCORE_MAP$Peri3 = {}, (0, _defineProperty3.default)(_BANDY_SCORE_MAP$Peri3, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.INTERMISSION,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod]
	}), (0, _defineProperty3.default)(_BANDY_SCORE_MAP$Peri3, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), _BANDY_SCORE_MAP$Peri3);
	
	BANDY_SCORE_MAP[Period.SECOND] = (_BANDY_SCORE_MAP$Peri4 = {}, (0, _defineProperty3.default)(_BANDY_SCORE_MAP$Peri4, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod]
	}), (0, _defineProperty3.default)(_BANDY_SCORE_MAP$Peri4, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), _BANDY_SCORE_MAP$Peri4);
	
	BANDY_SCORE_MAP[Period.FINISHED] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_FINISHED,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod]
	});
	
	exports.default = BANDY_SCORE_MAP;

/***/ },
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var BASKETBALL_GROUP_MAP = {};
	
	BASKETBALL_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
	BASKETBALL_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
	BASKETBALL_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
	BASKETBALL_GROUP_MAP[3] = GroupType.THIRD_PERIOD_GROUP;
	BASKETBALL_GROUP_MAP[4] = GroupType.FOURTH_PERIOD_GROUP;
	BASKETBALL_GROUP_MAP[5] = GroupType.BASKETBALL_MATCH_TWO_POINTS_GROUP;
	BASKETBALL_GROUP_MAP[6] = GroupType.BASKETBALL_MATCH_THREE_POINTS_GROUP;
	BASKETBALL_GROUP_MAP[7] = GroupType.FIRST_HALF_GROUP;
	BASKETBALL_GROUP_MAP[8] = GroupType.SECOND_HALF_GROUP;
	
	exports.default = BASKETBALL_GROUP_MAP;

/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _BASKETBALL_SCORE_MAP, _BASKETBALL_SCORE_MAP2, _BASKETBALL_SCORE_MAP3, _BASKETBALL_SCORE_MAP4, _BASKETBALL_SCORE_MAP5, _BASKETBALL_SCORE_MAP6, _BASKETBALL_SCORE_MAP7, _BASKETBALL_SCORE_MAP8;
	
	var _ScoreType = __webpack_require__(40);
	
	var ScoreType = _interopRequireWildcard(_ScoreType);
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	var _MatchInfo = __webpack_require__(73);
	
	var MatchInfo = _interopRequireWildcard(_MatchInfo);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BASKETBALL_SCORE_MAP = {};
	BASKETBALL_SCORE_MAP[Period.NOT_STARTED] = (_BASKETBALL_SCORE_MAP = {}, (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_NOT_STARTED,
	    main: ScoreType.Match
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), _BASKETBALL_SCORE_MAP);
	
	BASKETBALL_SCORE_MAP[Period.FIRST] = (_BASKETBALL_SCORE_MAP2 = {}, (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP2, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod],
	    fouls: ScoreType.FirstPeriodFouls,
	    possession: ScoreType.BallPossession
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP2, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP2, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP2, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP2, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), _BASKETBALL_SCORE_MAP2);
	
	BASKETBALL_SCORE_MAP[Period.FIRST_BREAK] = (_BASKETBALL_SCORE_MAP3 = {}, (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP3, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.INTERMISSION,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod]
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP3, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP3, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP3, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP3, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), _BASKETBALL_SCORE_MAP3);
	
	BASKETBALL_SCORE_MAP[Period.SECOND] = (_BASKETBALL_SCORE_MAP4 = {}, (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP4, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod],
	    fouls: ScoreType.SecondPeriodFouls,
	    possession: ScoreType.BallPossession
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP4, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP4, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP4, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP4, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), _BASKETBALL_SCORE_MAP4);
	
	BASKETBALL_SCORE_MAP[Period.SECOND_BREAK] = (_BASKETBALL_SCORE_MAP5 = {}, (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP5, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.INTERMISSION,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod]
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP5, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP5, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP5, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP5, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), _BASKETBALL_SCORE_MAP5);
	
	BASKETBALL_SCORE_MAP[Period.THIRD] = (_BASKETBALL_SCORE_MAP6 = {}, (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP6, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod],
	    fouls: ScoreType.ThirdPeriodFouls,
	    possession: ScoreType.BallPossession
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP6, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP6, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP6, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP6, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), _BASKETBALL_SCORE_MAP6);
	
	BASKETBALL_SCORE_MAP[Period.THIRD_BREAK] = (_BASKETBALL_SCORE_MAP7 = {}, (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP7, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.INTERMISSION,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod]
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP7, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP7, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP7, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP7, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), _BASKETBALL_SCORE_MAP7);
	
	BASKETBALL_SCORE_MAP[Period.FOURTH] = (_BASKETBALL_SCORE_MAP8 = {}, (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP8, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod],
	    fouls: ScoreType.FourthPeriodFouls,
	    possession: ScoreType.BallPossession
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP8, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP8, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP8, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_SCORE_MAP8, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), _BASKETBALL_SCORE_MAP8);
	
	BASKETBALL_SCORE_MAP[Period.FOURTH_BREAK] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.INTERMISSION,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod]
	});
	
	BASKETBALL_SCORE_MAP[Period.OVERTIME] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod],
	    overtime: ScoreType.Overtime,
	    possession: ScoreType.BallPossession
	});
	
	BASKETBALL_SCORE_MAP[Period.FINISHED] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_FINISHED,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod],
	    overtime: ScoreType.Overtime
	});
	
	exports.default = BASKETBALL_SCORE_MAP;

/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var BASKETBALL_NCAA_GROUP_MAP = {};
	
	BASKETBALL_NCAA_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
	BASKETBALL_NCAA_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
	BASKETBALL_NCAA_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
	BASKETBALL_NCAA_GROUP_MAP[3] = GroupType.BASKETBALL_MATCH_TWO_POINTS_GROUP;
	BASKETBALL_NCAA_GROUP_MAP[4] = GroupType.BASKETBALL_MATCH_THREE_POINTS_GROUP;
	
	exports.default = BASKETBALL_NCAA_GROUP_MAP;

/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _BASKETBALL_NCAA_SCOR, _BASKETBALL_NCAA_SCOR2, _BASKETBALL_NCAA_SCOR3, _BASKETBALL_NCAA_SCOR4, _BASKETBALL_NCAA_SCOR5;
	
	var _ScoreType = __webpack_require__(40);
	
	var ScoreType = _interopRequireWildcard(_ScoreType);
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	var _MatchInfo = __webpack_require__(73);
	
	var MatchInfo = _interopRequireWildcard(_MatchInfo);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BASKETBALL_NCAA_SCORE_MAP = {};
	BASKETBALL_NCAA_SCORE_MAP[Period.NOT_STARTED] = (_BASKETBALL_NCAA_SCOR = {}, (0, _defineProperty3.default)(_BASKETBALL_NCAA_SCOR, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_NOT_STARTED,
	    main: ScoreType.Match
	}), (0, _defineProperty3.default)(_BASKETBALL_NCAA_SCOR, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_NCAA_SCOR, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), _BASKETBALL_NCAA_SCOR);
	
	BASKETBALL_NCAA_SCORE_MAP[Period.FIRST] = (_BASKETBALL_NCAA_SCOR2 = {}, (0, _defineProperty3.default)(_BASKETBALL_NCAA_SCOR2, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod],
	    fouls: ScoreType.FirstPeriodFouls,
	    possession: ScoreType.BallPossession
	}), (0, _defineProperty3.default)(_BASKETBALL_NCAA_SCOR2, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_NCAA_SCOR2, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), _BASKETBALL_NCAA_SCOR2);
	
	BASKETBALL_NCAA_SCORE_MAP[Period.FIRST_BREAK] = (_BASKETBALL_NCAA_SCOR3 = {}, (0, _defineProperty3.default)(_BASKETBALL_NCAA_SCOR3, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.INTERMISSION,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod]
	}), (0, _defineProperty3.default)(_BASKETBALL_NCAA_SCOR3, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_NCAA_SCOR3, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), _BASKETBALL_NCAA_SCOR3);
	
	BASKETBALL_NCAA_SCORE_MAP[Period.SECOND] = (_BASKETBALL_NCAA_SCOR4 = {}, (0, _defineProperty3.default)(_BASKETBALL_NCAA_SCOR4, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod],
	    fouls: ScoreType.SecondPeriodFouls,
	    possession: ScoreType.BallPossession
	}), (0, _defineProperty3.default)(_BASKETBALL_NCAA_SCOR4, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_NCAA_SCOR4, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), _BASKETBALL_NCAA_SCOR4);
	
	BASKETBALL_NCAA_SCORE_MAP[Period.SECOND_BREAK] = (_BASKETBALL_NCAA_SCOR5 = {}, (0, _defineProperty3.default)(_BASKETBALL_NCAA_SCOR5, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.INTERMISSION,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod]
	}), (0, _defineProperty3.default)(_BASKETBALL_NCAA_SCOR5, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_BASKETBALL_NCAA_SCOR5, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), _BASKETBALL_NCAA_SCOR5);
	
	BASKETBALL_NCAA_SCORE_MAP[Period.OVERTIME] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod],
	    overtime: ScoreType.Overtime,
	    possession: ScoreType.BallPossession
	});
	
	BASKETBALL_NCAA_SCORE_MAP[Period.FINISHED] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_FINISHED,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod],
	    overtime: ScoreType.Overtime
	});
	
	exports.default = BASKETBALL_NCAA_SCORE_MAP;

/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var BEACH_VOLLEYBALL_GROUP_MAP = {};
	
	BEACH_VOLLEYBALL_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
	BEACH_VOLLEYBALL_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
	BEACH_VOLLEYBALL_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
	BEACH_VOLLEYBALL_GROUP_MAP[3] = GroupType.THIRD_PERIOD_GROUP;
	BEACH_VOLLEYBALL_GROUP_MAP[4] = GroupType.FIRST_PERIOD_TEN_POINTS_MINI_MATCH_GROUP;
	BEACH_VOLLEYBALL_GROUP_MAP[5] = GroupType.FIRST_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP;
	BEACH_VOLLEYBALL_GROUP_MAP[6] = GroupType.SECOND_PERIOD_TEN_POINTS_MINI_MATCH_GROUP;
	BEACH_VOLLEYBALL_GROUP_MAP[7] = GroupType.SECOND_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP;
	
	exports.default = BEACH_VOLLEYBALL_GROUP_MAP;

/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _BEACH_VOLLEYBALL_SCO, _BEACH_VOLLEYBALL_SCO2, _BEACH_VOLLEYBALL_SCO3, _BEACH_VOLLEYBALL_SCO4;
	
	var _ScoreType = __webpack_require__(40);
	
	var ScoreType = _interopRequireWildcard(_ScoreType);
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	var _MatchInfo = __webpack_require__(73);
	
	var MatchInfo = _interopRequireWildcard(_MatchInfo);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BEACH_VOLLEYBALL_SCORE_MAP = {};
	BEACH_VOLLEYBALL_SCORE_MAP[Period.NOT_STARTED] = (_BEACH_VOLLEYBALL_SCO = {}, (0, _defineProperty3.default)(_BEACH_VOLLEYBALL_SCO, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_NOT_STARTED,
	    main: ScoreType.Match
	}), (0, _defineProperty3.default)(_BEACH_VOLLEYBALL_SCO, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_BEACH_VOLLEYBALL_SCO, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_BEACH_VOLLEYBALL_SCO, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), _BEACH_VOLLEYBALL_SCO);
	
	BEACH_VOLLEYBALL_SCORE_MAP[Period.FIRST] = (_BEACH_VOLLEYBALL_SCO2 = {}, (0, _defineProperty3.default)(_BEACH_VOLLEYBALL_SCO2, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod]
	}), (0, _defineProperty3.default)(_BEACH_VOLLEYBALL_SCO2, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_BEACH_VOLLEYBALL_SCO2, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_BEACH_VOLLEYBALL_SCO2, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), _BEACH_VOLLEYBALL_SCO2);
	
	BEACH_VOLLEYBALL_SCORE_MAP[Period.SECOND] = (_BEACH_VOLLEYBALL_SCO3 = {}, (0, _defineProperty3.default)(_BEACH_VOLLEYBALL_SCO3, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod]
	}), (0, _defineProperty3.default)(_BEACH_VOLLEYBALL_SCO3, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_BEACH_VOLLEYBALL_SCO3, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_BEACH_VOLLEYBALL_SCO3, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), _BEACH_VOLLEYBALL_SCO3);
	
	BEACH_VOLLEYBALL_SCORE_MAP[Period.THIRD] = (_BEACH_VOLLEYBALL_SCO4 = {}, (0, _defineProperty3.default)(_BEACH_VOLLEYBALL_SCO4, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod]
	}), (0, _defineProperty3.default)(_BEACH_VOLLEYBALL_SCO4, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_BEACH_VOLLEYBALL_SCO4, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_BEACH_VOLLEYBALL_SCO4, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), _BEACH_VOLLEYBALL_SCO4);
	
	BEACH_VOLLEYBALL_SCORE_MAP[Period.FINISHED] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_FINISHED,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod]
	});
	
	exports.default = BEACH_VOLLEYBALL_SCORE_MAP;

/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var BIATHLON_GROUP_MAP = {};
	
	BIATHLON_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
	BIATHLON_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
	BIATHLON_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
	BIATHLON_GROUP_MAP[3] = GroupType.THIRD_PERIOD_GROUP;
	BIATHLON_GROUP_MAP[4] = GroupType.FOURTH_PERIOD_GROUP;
	BIATHLON_GROUP_MAP[5] = GroupType.FIFTH_PERIOD_GROUP;
	BIATHLON_GROUP_MAP[6] = GroupType.SIXTH_PERIOD_GROUP;
	BIATHLON_GROUP_MAP[7] = GroupType.SEVENTH_PERIOD_GROUP;
	BIATHLON_GROUP_MAP[8] = GroupType.EIGHTH_PERIOD_GROUP;
	
	exports.default = BIATHLON_GROUP_MAP;

/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _BIATHLON_SCORE_MAP$P;
	
	var _ScoreType = __webpack_require__(40);
	
	var ScoreType = _interopRequireWildcard(_ScoreType);
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BIATHLON_SCORE_MAP = {};
	BIATHLON_SCORE_MAP[Period.NOT_STARTED] = (_BIATHLON_SCORE_MAP$P = {}, (0, _defineProperty3.default)(_BIATHLON_SCORE_MAP$P, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod, ScoreType.FifthPeriod, ScoreType.SixthPeriod, ScoreType.SeventhPeriod, ScoreType.EighthPeriod]
	}), (0, _defineProperty3.default)(_BIATHLON_SCORE_MAP$P, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_BIATHLON_SCORE_MAP$P, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_BIATHLON_SCORE_MAP$P, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_BIATHLON_SCORE_MAP$P, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_BIATHLON_SCORE_MAP$P, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), (0, _defineProperty3.default)(_BIATHLON_SCORE_MAP$P, GroupType.SIXTH_PERIOD_GROUP, {
	    main: ScoreType.SixthPeriod
	}), (0, _defineProperty3.default)(_BIATHLON_SCORE_MAP$P, GroupType.SEVENTH_PERIOD_GROUP, {
	    main: ScoreType.SeventhPeriod
	}), (0, _defineProperty3.default)(_BIATHLON_SCORE_MAP$P, GroupType.EIGHTH_PERIOD_GROUP, {
	    main: ScoreType.EighthPeriod
	}), _BIATHLON_SCORE_MAP$P);
	
	exports.default = BIATHLON_SCORE_MAP;

/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = { 0: GroupType.DEFAULT_GROUP };

/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BOXING_SCORE_MAP = {};
	BOXING_SCORE_MAP[Period.NOT_STARTED] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    period_info: true
	});
	
	BOXING_SCORE_MAP[Period.ROUND_FIRST] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    period_info: true
	});
	
	BOXING_SCORE_MAP[Period.ROUND_SECOND] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    period_info: true
	});
	
	BOXING_SCORE_MAP[Period.ROUND_THIRD] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    period_info: true
	});
	
	BOXING_SCORE_MAP[Period.ROUND_FOURTH] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    period_info: true
	});
	
	BOXING_SCORE_MAP[Period.ROUND_FIFTH] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    period_info: true
	});
	
	BOXING_SCORE_MAP[Period.ROUND_SIXTH] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    period_info: true
	});
	
	BOXING_SCORE_MAP[Period.ROUND_SEVENTH] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    period_info: true
	});
	
	BOXING_SCORE_MAP[Period.ROUND_EIGHTH] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    period_info: true
	});
	
	BOXING_SCORE_MAP[Period.ROUND_NINTH] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    period_info: true
	});
	
	BOXING_SCORE_MAP[Period.ROUND_TENTH] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    period_info: true
	});
	
	BOXING_SCORE_MAP[Period.ROUND_ELEVENTH] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    period_info: true
	});
	
	BOXING_SCORE_MAP[Period.ROUND_TWELFTH] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    period_info: true
	});
	
	BOXING_SCORE_MAP[Period.FINISHED] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    period_info: true
	});
	
	exports.default = BOXING_SCORE_MAP;

/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var CYBERSPORTDOTA2_GROUP_MAP = {};
	
	CYBERSPORTDOTA2_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
	CYBERSPORTDOTA2_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
	CYBERSPORTDOTA2_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
	CYBERSPORTDOTA2_GROUP_MAP[3] = GroupType.THIRD_PERIOD_GROUP;
	CYBERSPORTDOTA2_GROUP_MAP[4] = GroupType.FOURTH_PERIOD_GROUP;
	CYBERSPORTDOTA2_GROUP_MAP[5] = GroupType.FIFTH_PERIOD_GROUP;
	
	exports.default = CYBERSPORTDOTA2_GROUP_MAP;

/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _CYBERSPORTDOTA2_SCOR, _CYBERSPORTDOTA2_SCOR2, _CYBERSPORTDOTA2_SCOR3, _CYBERSPORTDOTA2_SCOR4, _CYBERSPORTDOTA2_SCOR5, _CYBERSPORTDOTA2_SCOR6;
	
	var _ScoreType = __webpack_require__(40);
	
	var ScoreType = _interopRequireWildcard(_ScoreType);
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	var _MatchInfo = __webpack_require__(73);
	
	var MatchInfo = _interopRequireWildcard(_MatchInfo);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CYBERSPORTDOTA2_SCORE_MAP = {};
	CYBERSPORTDOTA2_SCORE_MAP[Period.NOT_STARTED] = (_CYBERSPORTDOTA2_SCOR = {}, (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_NOT_STARTED,
	    main: ScoreType.Match
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), _CYBERSPORTDOTA2_SCOR);
	
	CYBERSPORTDOTA2_SCORE_MAP[Period.FIRST] = (_CYBERSPORTDOTA2_SCOR2 = {}, (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR2, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod]
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR2, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR2, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR2, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR2, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR2, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), _CYBERSPORTDOTA2_SCOR2);
	
	CYBERSPORTDOTA2_SCORE_MAP[Period.SECOND] = (_CYBERSPORTDOTA2_SCOR3 = {}, (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR3, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod]
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR3, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR3, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR3, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR3, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR3, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), _CYBERSPORTDOTA2_SCOR3);
	
	CYBERSPORTDOTA2_SCORE_MAP[Period.THIRD] = (_CYBERSPORTDOTA2_SCOR4 = {}, (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR4, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod]
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR4, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR4, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR4, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR4, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR4, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), _CYBERSPORTDOTA2_SCOR4);
	
	CYBERSPORTDOTA2_SCORE_MAP[Period.FOURTH] = (_CYBERSPORTDOTA2_SCOR5 = {}, (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR5, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod]
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR5, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR5, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR5, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR5, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR5, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), _CYBERSPORTDOTA2_SCOR5);
	
	CYBERSPORTDOTA2_SCORE_MAP[Period.FIFTH] = (_CYBERSPORTDOTA2_SCOR6 = {}, (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR6, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod, ScoreType.FifthPeriod]
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR6, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR6, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR6, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR6, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_CYBERSPORTDOTA2_SCOR6, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), _CYBERSPORTDOTA2_SCOR6);
	
	CYBERSPORTDOTA2_SCORE_MAP[Period.FINISHED] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_FINISHED,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod, ScoreType.FifthPeriod]
	});
	
	exports.default = CYBERSPORTDOTA2_SCORE_MAP;

/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var FOOTBALL_GROUP_MAP = {};
	
	FOOTBALL_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
	FOOTBALL_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
	FOOTBALL_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
	FOOTBALL_GROUP_MAP[3] = GroupType.FIRST_MINI_MATCH_GROUP;
	FOOTBALL_GROUP_MAP[4] = GroupType.SECOND_MINI_MATCH_GROUP;
	FOOTBALL_GROUP_MAP[5] = GroupType.THIRD_MINI_MATCH_GROUP;
	FOOTBALL_GROUP_MAP[6] = GroupType.FOURTH_MINI_MATCH_GROUP;
	FOOTBALL_GROUP_MAP[7] = GroupType.FIFTH_MINI_MATCH_GROUP;
	FOOTBALL_GROUP_MAP[8] = GroupType.SIXTH_MINI_MATCH_GROUP;
	FOOTBALL_GROUP_MAP[9] = GroupType.CORNER_GROUP;
	FOOTBALL_GROUP_MAP[10] = GroupType.FIRST_PERIOD_CORNER_GROUP;
	FOOTBALL_GROUP_MAP[11] = GroupType.YELLOW_CARD_GROUP;
	FOOTBALL_GROUP_MAP[12] = GroupType.FIRST_PERIOD_YELLOW_CARD_GROUP;
	FOOTBALL_GROUP_MAP[13] = GroupType.OVERTIME_GROUP;
	FOOTBALL_GROUP_MAP[14] = GroupType.FIRST_OVERTIME_GROUP;
	FOOTBALL_GROUP_MAP[15] = GroupType.SECOND_OVERTIME_GROUP;
	FOOTBALL_GROUP_MAP[16] = GroupType.PENALTIES_GROUP;
	
	exports.default = FOOTBALL_GROUP_MAP;

/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _FOOTBALL_SCORE_MAP$P, _FOOTBALL_SCORE_MAP$P2, _FOOTBALL_SCORE_MAP$P3, _FOOTBALL_SCORE_MAP$P4, _FOOTBALL_SCORE_MAP$P5, _FOOTBALL_SCORE_MAP$P6, _FOOTBALL_SCORE_MAP$P7, _FOOTBALL_SCORE_MAP$P8, _FOOTBALL_SCORE_MAP$P9;
	
	var _ScoreType = __webpack_require__(40);
	
	var ScoreType = _interopRequireWildcard(_ScoreType);
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	var _MatchInfo = __webpack_require__(73);
	
	var MatchInfo = _interopRequireWildcard(_MatchInfo);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FOOTBALL_SCORE_MAP = {};
	FOOTBALL_SCORE_MAP[Period.NOT_STARTED] = (_FOOTBALL_SCORE_MAP$P = {}, (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_NOT_STARTED,
	    main: ScoreType.Match
	}), (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P, GroupType.CORNER_GROUP, {
	    main: ScoreType.Corner
	}), (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P, GroupType.FIRST_PERIOD_CORNER_GROUP, {
	    main: ScoreType.Corner
	}), (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P, GroupType.YELLOW_CARD_GROUP, {
	    main: ScoreType.YellowCard
	}), (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P, GroupType.FIRST_PERIOD_YELLOW_CARD_GROUP, {
	    main: ScoreType.YellowCard
	}), _FOOTBALL_SCORE_MAP$P);
	
	FOOTBALL_SCORE_MAP[Period.FIRST] = (_FOOTBALL_SCORE_MAP$P2 = {}, (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P2, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match
	}), (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P2, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P2, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P2, GroupType.CORNER_GROUP, {
	    main: ScoreType.Corner
	}), (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P2, GroupType.FIRST_PERIOD_CORNER_GROUP, {
	    main: ScoreType.Corner
	}), (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P2, GroupType.YELLOW_CARD_GROUP, {
	    main: ScoreType.YellowCard
	}), (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P2, GroupType.FIRST_PERIOD_YELLOW_CARD_GROUP, {
	    main: ScoreType.YellowCard
	}), _FOOTBALL_SCORE_MAP$P2);
	
	FOOTBALL_SCORE_MAP[Period.FIRST_BREAK] = (_FOOTBALL_SCORE_MAP$P3 = {}, (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P3, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.INTERMISSION,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod]
	}), (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P3, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P3, GroupType.CORNER_GROUP, {
	    main: ScoreType.Corner
	}), (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P3, GroupType.YELLOW_CARD_GROUP, {
	    main: ScoreType.YellowCard
	}), _FOOTBALL_SCORE_MAP$P3);
	
	FOOTBALL_SCORE_MAP[Period.SECOND] = (_FOOTBALL_SCORE_MAP$P4 = {}, (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P4, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod]
	}), (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P4, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P4, GroupType.CORNER_GROUP, {
	    main: ScoreType.Corner
	}), (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P4, GroupType.YELLOW_CARD_GROUP, {
	    main: ScoreType.YellowCard
	}), _FOOTBALL_SCORE_MAP$P4);
	
	FOOTBALL_SCORE_MAP[Period.FULL_TIME] = (_FOOTBALL_SCORE_MAP$P5 = {}, (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P5, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.FULL_TIME,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod],
	    overtime: ScoreType.Overtime
	}), (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P5, GroupType.FIRST_OVERTIME_GROUP, {
	    main: ScoreType.Match
	}), (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P5, GroupType.SECOND_OVERTIME_GROUP, {
	    main: ScoreType.Match
	}), _FOOTBALL_SCORE_MAP$P5);
	
	FOOTBALL_SCORE_MAP[Period.FIRST_EXTRA] = (_FOOTBALL_SCORE_MAP$P6 = {}, (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P6, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod],
	    overtime: ScoreType.ExtraTime
	}), (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P6, GroupType.FIRST_OVERTIME_GROUP, {
	    main: ScoreType.Match
	}), (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P6, GroupType.SECOND_OVERTIME_GROUP, {
	    main: ScoreType.Match
	}), _FOOTBALL_SCORE_MAP$P6);
	
	FOOTBALL_SCORE_MAP[Period.FIRST_EXTRA_BREAK] = (_FOOTBALL_SCORE_MAP$P7 = {}, (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P7, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.FIRST_EXTRA_ENDED,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod],
	    overtime: ScoreType.ExtraTime
	}), (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P7, GroupType.SECOND_OVERTIME_GROUP, {
	    main: ScoreType.Match
	}), _FOOTBALL_SCORE_MAP$P7);
	
	FOOTBALL_SCORE_MAP[Period.SECOND_EXTRA] = (_FOOTBALL_SCORE_MAP$P8 = {}, (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P8, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod],
	    overtime: ScoreType.ExtraTime
	}), (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P8, GroupType.SECOND_OVERTIME_GROUP, {
	    main: ScoreType.Match
	}), _FOOTBALL_SCORE_MAP$P8);
	
	FOOTBALL_SCORE_MAP[Period.SECOND_EXTRA_BREAK] = (_FOOTBALL_SCORE_MAP$P9 = {}, (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P9, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod],
	    overtime: ScoreType.ExtraTime
	}), (0, _defineProperty3.default)(_FOOTBALL_SCORE_MAP$P9, GroupType.SECOND_OVERTIME_GROUP, {
	    main: ScoreType.Match
	}), _FOOTBALL_SCORE_MAP$P9);
	
	FOOTBALL_SCORE_MAP[Period.PENALTIES] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.PENALTY_SERIES,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.PenaltySeries],
	    overtime: ScoreType.ExtraTime
	});
	
	FOOTBALL_SCORE_MAP[Period.FINISHED] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_FINISHED,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod],
	    overtime: ScoreType.ExtraTime
	});
	
	exports.default = FOOTBALL_SCORE_MAP;

/***/ },
/* 1283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var HANDBALL_GROUP_MAP = {};
	
	HANDBALL_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
	HANDBALL_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
	HANDBALL_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
	
	exports.default = HANDBALL_GROUP_MAP;

/***/ },
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _HANDBALL_SCORE_MAP$P, _HANDBALL_SCORE_MAP$P2, _HANDBALL_SCORE_MAP$P3, _HANDBALL_SCORE_MAP$P4;
	
	var _ScoreType = __webpack_require__(40);
	
	var ScoreType = _interopRequireWildcard(_ScoreType);
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	var _MatchInfo = __webpack_require__(73);
	
	var MatchInfo = _interopRequireWildcard(_MatchInfo);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HANDBALL_SCORE_MAP = {};
	HANDBALL_SCORE_MAP[Period.NOT_STARTED] = (_HANDBALL_SCORE_MAP$P = {}, (0, _defineProperty3.default)(_HANDBALL_SCORE_MAP$P, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_NOT_STARTED,
	    main: ScoreType.Match
	}), (0, _defineProperty3.default)(_HANDBALL_SCORE_MAP$P, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_HANDBALL_SCORE_MAP$P, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), _HANDBALL_SCORE_MAP$P);
	
	HANDBALL_SCORE_MAP[Period.FIRST] = (_HANDBALL_SCORE_MAP$P2 = {}, (0, _defineProperty3.default)(_HANDBALL_SCORE_MAP$P2, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match
	}), (0, _defineProperty3.default)(_HANDBALL_SCORE_MAP$P2, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_HANDBALL_SCORE_MAP$P2, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), _HANDBALL_SCORE_MAP$P2);
	
	HANDBALL_SCORE_MAP[Period.FIRST_BREAK] = (_HANDBALL_SCORE_MAP$P3 = {}, (0, _defineProperty3.default)(_HANDBALL_SCORE_MAP$P3, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.INTERMISSION,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod]
	}), (0, _defineProperty3.default)(_HANDBALL_SCORE_MAP$P3, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), _HANDBALL_SCORE_MAP$P3);
	
	HANDBALL_SCORE_MAP[Period.SECOND] = (_HANDBALL_SCORE_MAP$P4 = {}, (0, _defineProperty3.default)(_HANDBALL_SCORE_MAP$P4, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod]
	}), (0, _defineProperty3.default)(_HANDBALL_SCORE_MAP$P4, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), _HANDBALL_SCORE_MAP$P4);
	
	HANDBALL_SCORE_MAP[Period.FINISHED] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_FINISHED,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod]
	});
	
	exports.default = HANDBALL_SCORE_MAP;

/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var ICE_HOCKEY_GROUP_MAP = {};
	
	ICE_HOCKEY_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
	ICE_HOCKEY_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
	ICE_HOCKEY_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
	ICE_HOCKEY_GROUP_MAP[3] = GroupType.THIRD_PERIOD_GROUP;
	ICE_HOCKEY_GROUP_MAP[4] = GroupType.ICE_HOCKEY_FIRST_MINI_MATCH_GROUP;
	ICE_HOCKEY_GROUP_MAP[5] = GroupType.ICE_HOCKEY_SECOND_MINI_MATCH_GROUP;
	ICE_HOCKEY_GROUP_MAP[6] = GroupType.ICE_HOCKEY_THIRD_MINI_MATCH_GROUP;
	ICE_HOCKEY_GROUP_MAP[7] = GroupType.ICE_HOCKEY_FOURTH_MINI_MATCH_GROUP;
	ICE_HOCKEY_GROUP_MAP[8] = GroupType.ICE_HOCKEY_FIFTH_MINI_MATCH_GROUP;
	ICE_HOCKEY_GROUP_MAP[9] = GroupType.ICE_HOCKEY_SIXTH_MINI_MATCH_GROUP;
	
	exports.default = ICE_HOCKEY_GROUP_MAP;

/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _ICE_HOCKEY_SCORE_MAP, _ICE_HOCKEY_SCORE_MAP2, _ICE_HOCKEY_SCORE_MAP3, _ICE_HOCKEY_SCORE_MAP4, _ICE_HOCKEY_SCORE_MAP5, _ICE_HOCKEY_SCORE_MAP6, _ICE_HOCKEY_SCORE_MAP7;
	
	var _ScoreType = __webpack_require__(40);
	
	var ScoreType = _interopRequireWildcard(_ScoreType);
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	var _MatchInfo = __webpack_require__(73);
	
	var MatchInfo = _interopRequireWildcard(_MatchInfo);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ICE_HOCKEY_SCORE_MAP = {};
	ICE_HOCKEY_SCORE_MAP[Period.NOT_STARTED] = (_ICE_HOCKEY_SCORE_MAP = {}, (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_NOT_STARTED,
	    main: ScoreType.Match
	}), (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), _ICE_HOCKEY_SCORE_MAP);
	
	ICE_HOCKEY_SCORE_MAP[Period.FIRST] = (_ICE_HOCKEY_SCORE_MAP2 = {}, (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP2, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    powerplay: ScoreType.PowerPlay
	}), (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP2, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP2, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP2, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), _ICE_HOCKEY_SCORE_MAP2);
	
	ICE_HOCKEY_SCORE_MAP[Period.FIRST_BREAK] = (_ICE_HOCKEY_SCORE_MAP3 = {}, (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP3, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.INTERMISSION,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod]
	}), (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP3, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP3, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP3, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), _ICE_HOCKEY_SCORE_MAP3);
	
	ICE_HOCKEY_SCORE_MAP[Period.SECOND] = (_ICE_HOCKEY_SCORE_MAP4 = {}, (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP4, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    powerplay: ScoreType.PowerPlay,
	    additional: [ScoreType.FirstPeriod]
	}), (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP4, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP4, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP4, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), _ICE_HOCKEY_SCORE_MAP4);
	
	ICE_HOCKEY_SCORE_MAP[Period.SECOND_BREAK] = (_ICE_HOCKEY_SCORE_MAP5 = {}, (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP5, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.INTERMISSION,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod]
	}), (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP5, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP5, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP5, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), _ICE_HOCKEY_SCORE_MAP5);
	
	ICE_HOCKEY_SCORE_MAP[Period.THIRD] = (_ICE_HOCKEY_SCORE_MAP6 = {}, (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP6, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    powerplay: ScoreType.PowerPlay,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod]
	}), (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP6, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP6, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP6, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), _ICE_HOCKEY_SCORE_MAP6);
	
	ICE_HOCKEY_SCORE_MAP[Period.THIRD_BREAK] = (_ICE_HOCKEY_SCORE_MAP7 = {}, (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP7, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.INTERMISSION,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod]
	}), (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP7, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP7, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_ICE_HOCKEY_SCORE_MAP7, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), _ICE_HOCKEY_SCORE_MAP7);
	
	ICE_HOCKEY_SCORE_MAP[Period.OVERTIME] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod],
	    overtime: ScoreType.Overtime
	});
	
	ICE_HOCKEY_SCORE_MAP[Period.PENALTIES] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod]
	});
	ICE_HOCKEY_SCORE_MAP[Period.FINISHED] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_FINISHED,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod],
	    overtime: ScoreType.Overtime
	});
	
	exports.default = ICE_HOCKEY_SCORE_MAP;

/***/ },
/* 1287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var MARTIAL_ART_GROUP_MAP = {};
	
	MARTIAL_ART_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
	MARTIAL_ART_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
	MARTIAL_ART_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
	MARTIAL_ART_GROUP_MAP[3] = GroupType.THIRD_PERIOD_GROUP;
	MARTIAL_ART_GROUP_MAP[4] = GroupType.FOURTH_PERIOD_GROUP;
	MARTIAL_ART_GROUP_MAP[5] = GroupType.FIFTH_PERIOD_GROUP;
	
	exports.default = MARTIAL_ART_GROUP_MAP;

/***/ },
/* 1288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var MARTIAL_ART_PERIOD_MAP = {};
	MARTIAL_ART_PERIOD_MAP[3900] = Period.NOT_STARTED;
	MARTIAL_ART_PERIOD_MAP[3902] = Period.FIRST;
	MARTIAL_ART_PERIOD_MAP[3903] = Period.SECOND;
	MARTIAL_ART_PERIOD_MAP[3904] = Period.THIRD;
	MARTIAL_ART_PERIOD_MAP[3905] = Period.FOURTH;
	MARTIAL_ART_PERIOD_MAP[3906] = Period.FIFTH;
	MARTIAL_ART_PERIOD_MAP[3901] = Period.FINISHED;
	
	exports.default = MARTIAL_ART_PERIOD_MAP;

/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MARTIAL_ART_SCORE_MAP = {};
	var defaultItem = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	  period_info: true
	});
	MARTIAL_ART_SCORE_MAP[Period.NOT_STARTED] = defaultItem;
	MARTIAL_ART_SCORE_MAP[Period.FIRST] = defaultItem;
	MARTIAL_ART_SCORE_MAP[Period.SECOND] = defaultItem;
	MARTIAL_ART_SCORE_MAP[Period.THIRD] = defaultItem;
	MARTIAL_ART_SCORE_MAP[Period.FOURTH] = defaultItem;
	MARTIAL_ART_SCORE_MAP[Period.FIFTH] = defaultItem;
	MARTIAL_ART_SCORE_MAP[Period.FINISHED] = defaultItem;
	
	exports.default = MARTIAL_ART_SCORE_MAP;

/***/ },
/* 1290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var TABLE_TENNIS_GROUP_MAP = {};
	
	TABLE_TENNIS_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
	TABLE_TENNIS_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
	TABLE_TENNIS_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
	TABLE_TENNIS_GROUP_MAP[3] = GroupType.THIRD_PERIOD_GROUP;
	TABLE_TENNIS_GROUP_MAP[4] = GroupType.FOURTH_PERIOD_GROUP;
	TABLE_TENNIS_GROUP_MAP[5] = GroupType.FIFTH_PERIOD_GROUP;
	TABLE_TENNIS_GROUP_MAP[6] = GroupType.SIXTH_PERIOD_GROUP;
	TABLE_TENNIS_GROUP_MAP[7] = GroupType.SEVENTH_PERIOD_GROUP;
	
	exports.default = TABLE_TENNIS_GROUP_MAP;

/***/ },
/* 1291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _TABLE_TENNIS_SCORE_M, _TABLE_TENNIS_SCORE_M2, _TABLE_TENNIS_SCORE_M3, _TABLE_TENNIS_SCORE_M4, _TABLE_TENNIS_SCORE_M5, _TABLE_TENNIS_SCORE_M6, _TABLE_TENNIS_SCORE_M7, _TABLE_TENNIS_SCORE_M8;
	
	var _ScoreType = __webpack_require__(40);
	
	var ScoreType = _interopRequireWildcard(_ScoreType);
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	var _MatchInfo = __webpack_require__(73);
	
	var MatchInfo = _interopRequireWildcard(_MatchInfo);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TABLE_TENNIS_SCORE_MAP = {};
	TABLE_TENNIS_SCORE_MAP[Period.NOT_STARTED] = (_TABLE_TENNIS_SCORE_M = {}, (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_NOT_STARTED,
	    main: ScoreType.Match
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M, GroupType.SIXTH_PERIOD_GROUP, {
	    main: ScoreType.SixthPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M, GroupType.SEVENTH_PERIOD_GROUP, {
	    main: ScoreType.SeventhPeriod
	}), _TABLE_TENNIS_SCORE_M);
	
	TABLE_TENNIS_SCORE_MAP[Period.FIRST] = (_TABLE_TENNIS_SCORE_M2 = {}, (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M2, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod]
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M2, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M2, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M2, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M2, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M2, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M2, GroupType.SIXTH_PERIOD_GROUP, {
	    main: ScoreType.SixthPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M2, GroupType.SEVENTH_PERIOD_GROUP, {
	    main: ScoreType.SeventhPeriod
	}), _TABLE_TENNIS_SCORE_M2);
	
	TABLE_TENNIS_SCORE_MAP[Period.SECOND] = (_TABLE_TENNIS_SCORE_M3 = {}, (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M3, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod]
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M3, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M3, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M3, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M3, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M3, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M3, GroupType.SIXTH_PERIOD_GROUP, {
	    main: ScoreType.SixthPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M3, GroupType.SEVENTH_PERIOD_GROUP, {
	    main: ScoreType.SeventhPeriod
	}), _TABLE_TENNIS_SCORE_M3);
	
	TABLE_TENNIS_SCORE_MAP[Period.THIRD] = (_TABLE_TENNIS_SCORE_M4 = {}, (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M4, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod]
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M4, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M4, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M4, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M4, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M4, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M4, GroupType.SIXTH_PERIOD_GROUP, {
	    main: ScoreType.SixthPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M4, GroupType.SEVENTH_PERIOD_GROUP, {
	    main: ScoreType.SeventhPeriod
	}), _TABLE_TENNIS_SCORE_M4);
	
	TABLE_TENNIS_SCORE_MAP[Period.FOURTH] = (_TABLE_TENNIS_SCORE_M5 = {}, (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M5, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod]
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M5, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M5, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M5, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M5, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M5, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M5, GroupType.SIXTH_PERIOD_GROUP, {
	    main: ScoreType.SixthPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M5, GroupType.SEVENTH_PERIOD_GROUP, {
	    main: ScoreType.SeventhPeriod
	}), _TABLE_TENNIS_SCORE_M5);
	
	TABLE_TENNIS_SCORE_MAP[Period.FIFTH] = (_TABLE_TENNIS_SCORE_M6 = {}, (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M6, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod, ScoreType.FifthPeriod]
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M6, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M6, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M6, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M6, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M6, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M6, GroupType.SIXTH_PERIOD_GROUP, {
	    main: ScoreType.SixthPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M6, GroupType.SEVENTH_PERIOD_GROUP, {
	    main: ScoreType.SeventhPeriod
	}), _TABLE_TENNIS_SCORE_M6);
	
	TABLE_TENNIS_SCORE_MAP[Period.SIXTH] = (_TABLE_TENNIS_SCORE_M7 = {}, (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M7, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod, ScoreType.FifthPeriod, ScoreType.SixthPeriod]
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M7, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M7, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M7, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M7, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M7, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M7, GroupType.SIXTH_PERIOD_GROUP, {
	    main: ScoreType.SixthPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M7, GroupType.SEVENTH_PERIOD_GROUP, {
	    main: ScoreType.SeventhPeriod
	}), _TABLE_TENNIS_SCORE_M7);
	
	TABLE_TENNIS_SCORE_MAP[Period.SEVENTH] = (_TABLE_TENNIS_SCORE_M8 = {}, (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M8, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod, ScoreType.FifthPeriod, ScoreType.SixthPeriod, ScoreType.SeventhPeriod]
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M8, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M8, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M8, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M8, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M8, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M8, GroupType.SIXTH_PERIOD_GROUP, {
	    main: ScoreType.SixthPeriod
	}), (0, _defineProperty3.default)(_TABLE_TENNIS_SCORE_M8, GroupType.SEVENTH_PERIOD_GROUP, {
	    main: ScoreType.SeventhPeriod
	}), _TABLE_TENNIS_SCORE_M8);
	
	TABLE_TENNIS_SCORE_MAP[Period.FINISHED] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_FINISHED,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod, ScoreType.FifthPeriod, ScoreType.SixthPeriod, ScoreType.SeventhPeriod]
	});
	
	exports.default = TABLE_TENNIS_SCORE_MAP;

/***/ },
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var TENNIS_GROUP_MAP = {};
	
	TENNIS_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
	TENNIS_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
	TENNIS_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
	TENNIS_GROUP_MAP[3] = GroupType.THIRD_PERIOD_GROUP;
	TENNIS_GROUP_MAP[4] = GroupType.FOURTH_PERIOD_GROUP;
	TENNIS_GROUP_MAP[5] = GroupType.FIFTH_PERIOD_GROUP;
	
	exports.default = TENNIS_GROUP_MAP;

/***/ },
/* 1293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _TENNIS_SCORE_MAP$Per, _TENNIS_SCORE_MAP$Per2, _TENNIS_SCORE_MAP$Per3, _TENNIS_SCORE_MAP$Per4, _TENNIS_SCORE_MAP$Per5, _TENNIS_SCORE_MAP$Per6;
	
	var _ScoreType = __webpack_require__(40);
	
	var ScoreType = _interopRequireWildcard(_ScoreType);
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	var _MatchInfo = __webpack_require__(73);
	
	var MatchInfo = _interopRequireWildcard(_MatchInfo);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TENNIS_SCORE_MAP = {};
	TENNIS_SCORE_MAP[Period.NOT_STARTED] = (_TENNIS_SCORE_MAP$Per = {}, (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_NOT_STARTED,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod],
	    currentGame: ScoreType.CurrentGame
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), _TENNIS_SCORE_MAP$Per);
	
	TENNIS_SCORE_MAP[Period.FIRST] = (_TENNIS_SCORE_MAP$Per2 = {}, (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per2, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod],
	    currentGame: ScoreType.CurrentGame
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per2, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per2, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per2, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per2, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per2, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), _TENNIS_SCORE_MAP$Per2);
	
	TENNIS_SCORE_MAP[Period.SECOND] = (_TENNIS_SCORE_MAP$Per3 = {}, (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per3, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod],
	    currentGame: ScoreType.CurrentGame
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per3, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per3, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per3, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per3, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per3, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), _TENNIS_SCORE_MAP$Per3);
	
	TENNIS_SCORE_MAP[Period.THIRD] = (_TENNIS_SCORE_MAP$Per4 = {}, (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per4, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod],
	    currentGame: ScoreType.CurrentGame
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per4, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per4, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per4, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per4, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per4, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), _TENNIS_SCORE_MAP$Per4);
	
	TENNIS_SCORE_MAP[Period.FOURTH] = (_TENNIS_SCORE_MAP$Per5 = {}, (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per5, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod],
	    currentGame: ScoreType.CurrentGame
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per5, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per5, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per5, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per5, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per5, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), _TENNIS_SCORE_MAP$Per5);
	
	TENNIS_SCORE_MAP[Period.FIFTH] = (_TENNIS_SCORE_MAP$Per6 = {}, (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per6, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod, ScoreType.FifthPeriod],
	    currentGame: ScoreType.CurrentGame
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per6, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per6, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per6, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per6, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_TENNIS_SCORE_MAP$Per6, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), _TENNIS_SCORE_MAP$Per6);
	
	TENNIS_SCORE_MAP[Period.FINISHED] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod, ScoreType.FifthPeriod]
	});
	
	exports.default = TENNIS_SCORE_MAP;

/***/ },
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var VOLLEYBALL_GROUP_MAP = {};
	
	VOLLEYBALL_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
	VOLLEYBALL_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
	VOLLEYBALL_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
	VOLLEYBALL_GROUP_MAP[3] = GroupType.THIRD_PERIOD_GROUP;
	VOLLEYBALL_GROUP_MAP[4] = GroupType.FOURTH_PERIOD_GROUP;
	VOLLEYBALL_GROUP_MAP[5] = GroupType.FIFTH_PERIOD_GROUP;
	VOLLEYBALL_GROUP_MAP[6] = GroupType.SIXTH_PERIOD_GROUP;
	VOLLEYBALL_GROUP_MAP[7] = GroupType.FIRST_PERIOD_TEN_POINTS_MINI_MATCH_GROUP;
	VOLLEYBALL_GROUP_MAP[8] = GroupType.FIRST_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP;
	VOLLEYBALL_GROUP_MAP[9] = GroupType.SECOND_PERIOD_TEN_POINTS_MINI_MATCH_GROUP;
	VOLLEYBALL_GROUP_MAP[10] = GroupType.SECOND_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP;
	VOLLEYBALL_GROUP_MAP[11] = GroupType.THIRD_PERIOD_TEN_POINTS_MINI_MATCH_GROUP;
	VOLLEYBALL_GROUP_MAP[12] = GroupType.THIRD_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP;
	VOLLEYBALL_GROUP_MAP[13] = GroupType.FOURTH_PERIOD_TEN_POINTS_MINI_MATCH_GROUP;
	VOLLEYBALL_GROUP_MAP[14] = GroupType.FOURTH_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP;
	
	exports.default = VOLLEYBALL_GROUP_MAP;

/***/ },
/* 1295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _VOLLEYBALL_SCORE_MAP, _VOLLEYBALL_SCORE_MAP2, _VOLLEYBALL_SCORE_MAP3, _VOLLEYBALL_SCORE_MAP4, _VOLLEYBALL_SCORE_MAP5, _VOLLEYBALL_SCORE_MAP6, _VOLLEYBALL_SCORE_MAP7;
	
	var _ScoreType = __webpack_require__(40);
	
	var ScoreType = _interopRequireWildcard(_ScoreType);
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	var _MatchInfo = __webpack_require__(73);
	
	var MatchInfo = _interopRequireWildcard(_MatchInfo);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VOLLEYBALL_SCORE_MAP = {};
	VOLLEYBALL_SCORE_MAP[Period.NOT_STARTED] = (_VOLLEYBALL_SCORE_MAP = {}, (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_NOT_STARTED,
	    main: ScoreType.Match
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), _VOLLEYBALL_SCORE_MAP);
	
	VOLLEYBALL_SCORE_MAP[Period.FIRST] = (_VOLLEYBALL_SCORE_MAP2 = {}, (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP2, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod]
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP2, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP2, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP2, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP2, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP2, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), _VOLLEYBALL_SCORE_MAP2);
	
	VOLLEYBALL_SCORE_MAP[Period.SECOND] = (_VOLLEYBALL_SCORE_MAP3 = {}, (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP3, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod]
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP3, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP3, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP3, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP3, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP3, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), _VOLLEYBALL_SCORE_MAP3);
	
	VOLLEYBALL_SCORE_MAP[Period.THIRD] = (_VOLLEYBALL_SCORE_MAP4 = {}, (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP4, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod]
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP4, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP4, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP4, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP4, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP4, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), _VOLLEYBALL_SCORE_MAP4);
	
	VOLLEYBALL_SCORE_MAP[Period.FOURTH] = (_VOLLEYBALL_SCORE_MAP5 = {}, (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP5, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod]
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP5, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP5, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP5, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP5, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP5, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), _VOLLEYBALL_SCORE_MAP5);
	
	VOLLEYBALL_SCORE_MAP[Period.FIFTH] = (_VOLLEYBALL_SCORE_MAP6 = {}, (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP6, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod, ScoreType.FifthPeriod]
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP6, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP6, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP6, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP6, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP6, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), _VOLLEYBALL_SCORE_MAP6);
	
	VOLLEYBALL_SCORE_MAP[Period.SIXTH] = (_VOLLEYBALL_SCORE_MAP7 = {}, (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP7, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod, ScoreType.FifthPeriod, ScoreType.SixthPeriod]
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP7, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP7, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP7, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP7, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP7, GroupType.FIFTH_PERIOD_GROUP, {
	    main: ScoreType.FifthPeriod
	}), (0, _defineProperty3.default)(_VOLLEYBALL_SCORE_MAP7, GroupType.SIXTH_PERIOD_GROUP, {
	    main: ScoreType.SixthPeriod
	}), _VOLLEYBALL_SCORE_MAP7);
	
	VOLLEYBALL_SCORE_MAP[Period.FINISHED] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_FINISHED,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod, ScoreType.FifthPeriod, ScoreType.SixthPeriod]
	});
	
	exports.default = VOLLEYBALL_SCORE_MAP;

/***/ },
/* 1296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var WATERPOLO_GROUP_MAP = {};
	
	WATERPOLO_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
	WATERPOLO_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
	WATERPOLO_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
	WATERPOLO_GROUP_MAP[3] = GroupType.THIRD_PERIOD_GROUP;
	WATERPOLO_GROUP_MAP[4] = GroupType.FOURTH_PERIOD_GROUP;
	
	exports.default = WATERPOLO_GROUP_MAP;

/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _WATERPOLO_SCORE_MAP$, _WATERPOLO_SCORE_MAP$2, _WATERPOLO_SCORE_MAP$3, _WATERPOLO_SCORE_MAP$4, _WATERPOLO_SCORE_MAP$5, _WATERPOLO_SCORE_MAP$6, _WATERPOLO_SCORE_MAP$7, _WATERPOLO_SCORE_MAP$8, _WATERPOLO_SCORE_MAP$9;
	
	var _ScoreType = __webpack_require__(40);
	
	var ScoreType = _interopRequireWildcard(_ScoreType);
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	var _MatchInfo = __webpack_require__(73);
	
	var MatchInfo = _interopRequireWildcard(_MatchInfo);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WATERPOLO_SCORE_MAP = {};
	WATERPOLO_SCORE_MAP[Period.NOT_STARTED] = (_WATERPOLO_SCORE_MAP$ = {}, (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_NOT_STARTED,
	    main: ScoreType.Match
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), _WATERPOLO_SCORE_MAP$);
	
	WATERPOLO_SCORE_MAP[Period.FIRST] = (_WATERPOLO_SCORE_MAP$2 = {}, (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$2, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod]
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$2, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$2, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$2, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$2, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), _WATERPOLO_SCORE_MAP$2);
	
	WATERPOLO_SCORE_MAP[Period.FIRST_BREAK] = (_WATERPOLO_SCORE_MAP$3 = {}, (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$3, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod]
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$3, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$3, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$3, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$3, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), _WATERPOLO_SCORE_MAP$3);
	
	WATERPOLO_SCORE_MAP[Period.SECOND] = (_WATERPOLO_SCORE_MAP$4 = {}, (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$4, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod]
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$4, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$4, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$4, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$4, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), _WATERPOLO_SCORE_MAP$4);
	
	WATERPOLO_SCORE_MAP[Period.SECOND_BREAK] = (_WATERPOLO_SCORE_MAP$5 = {}, (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$5, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod]
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$5, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$5, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$5, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$5, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), _WATERPOLO_SCORE_MAP$5);
	
	WATERPOLO_SCORE_MAP[Period.THIRD] = (_WATERPOLO_SCORE_MAP$6 = {}, (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$6, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod]
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$6, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$6, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$6, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$6, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), _WATERPOLO_SCORE_MAP$6);
	
	WATERPOLO_SCORE_MAP[Period.THIRD_BREAK] = (_WATERPOLO_SCORE_MAP$7 = {}, (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$7, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod]
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$7, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$7, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$7, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$7, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), _WATERPOLO_SCORE_MAP$7);
	
	WATERPOLO_SCORE_MAP[Period.FOURTH] = (_WATERPOLO_SCORE_MAP$8 = {}, (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$8, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod]
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$8, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$8, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$8, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$8, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), _WATERPOLO_SCORE_MAP$8);
	
	WATERPOLO_SCORE_MAP[Period.FOURTH_BREAK] = (_WATERPOLO_SCORE_MAP$9 = {}, (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$9, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod]
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$9, GroupType.FIRST_PERIOD_GROUP, {
	    main: ScoreType.FirstPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$9, GroupType.SECOND_PERIOD_GROUP, {
	    main: ScoreType.SecondPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$9, GroupType.THIRD_PERIOD_GROUP, {
	    main: ScoreType.ThirdPeriod
	}), (0, _defineProperty3.default)(_WATERPOLO_SCORE_MAP$9, GroupType.FOURTH_PERIOD_GROUP, {
	    main: ScoreType.FourthPeriod
	}), _WATERPOLO_SCORE_MAP$9);
	
	WATERPOLO_SCORE_MAP[Period.OVERTIME] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod],
	    overtime: ScoreType.Overtime
	});
	
	WATERPOLO_SCORE_MAP[Period.FINISHED] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_FINISHED,
	    main: ScoreType.Match,
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod],
	    overtime: ScoreType.Overtime
	});
	
	exports.default = WATERPOLO_SCORE_MAP;

/***/ },
/* 1298 */
1277,
/* 1299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _ScoreType = __webpack_require__(40);
	
	var ScoreType = _interopRequireWildcard(_ScoreType);
	
	var _GroupType = __webpack_require__(26);
	
	var GroupType = _interopRequireWildcard(_GroupType);
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	var _MatchInfo = __webpack_require__(73);
	
	var MatchInfo = _interopRequireWildcard(_MatchInfo);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WHATWHEREWHEN_SCORE_MAP = {};
	WHATWHEREWHEN_SCORE_MAP[Period.NOT_STARTED] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_NOT_STARTED,
	    main: ScoreType.Match
	});
	
	WHATWHEREWHEN_SCORE_MAP[Period.FIRST] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    main: ScoreType.Match
	});
	
	WHATWHEREWHEN_SCORE_MAP[Period.FINISHED] = (0, _defineProperty3.default)({}, GroupType.DEFAULT_GROUP, {
	    info: MatchInfo.MATCH_FINISHED,
	    main: ScoreType.Match
	});
	
	exports.default = WHATWHEREWHEN_SCORE_MAP;

/***/ },
/* 1300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _SportType = __webpack_require__(89);
	
	var SportType = _interopRequireWildcard(_SportType);
	
	var _PeriodMap = __webpack_require__(780);
	
	var _PeriodMap2 = _interopRequireDefault(_PeriodMap);
	
	var _PeriodMap3 = __webpack_require__(781);
	
	var _PeriodMap4 = _interopRequireDefault(_PeriodMap3);
	
	var _PeriodMap5 = __webpack_require__(782);
	
	var _PeriodMap6 = _interopRequireDefault(_PeriodMap5);
	
	var _PeriodMap7 = __webpack_require__(783);
	
	var _PeriodMap8 = _interopRequireDefault(_PeriodMap7);
	
	var _PeriodMap9 = __webpack_require__(784);
	
	var _PeriodMap10 = _interopRequireDefault(_PeriodMap9);
	
	var _PeriodMap11 = __webpack_require__(785);
	
	var _PeriodMap12 = _interopRequireDefault(_PeriodMap11);
	
	var _PeriodMap13 = __webpack_require__(786);
	
	var _PeriodMap14 = _interopRequireDefault(_PeriodMap13);
	
	var _PeriodMap15 = __webpack_require__(787);
	
	var _PeriodMap16 = _interopRequireDefault(_PeriodMap15);
	
	var _PeriodMap17 = __webpack_require__(788);
	
	var _PeriodMap18 = _interopRequireDefault(_PeriodMap17);
	
	var _PeriodMap19 = __webpack_require__(789);
	
	var _PeriodMap20 = _interopRequireDefault(_PeriodMap19);
	
	var _PeriodMap21 = __webpack_require__(790);
	
	var _PeriodMap22 = _interopRequireDefault(_PeriodMap21);
	
	var _PeriodMap23 = __webpack_require__(791);
	
	var _PeriodMap24 = _interopRequireDefault(_PeriodMap23);
	
	var _PeriodMap25 = __webpack_require__(792);
	
	var _PeriodMap26 = _interopRequireDefault(_PeriodMap25);
	
	var _PeriodMap27 = __webpack_require__(793);
	
	var _PeriodMap28 = _interopRequireDefault(_PeriodMap27);
	
	var _PeriodMap29 = __webpack_require__(794);
	
	var _PeriodMap30 = _interopRequireDefault(_PeriodMap29);
	
	var _PeriodMap31 = __webpack_require__(795);
	
	var _PeriodMap32 = _interopRequireDefault(_PeriodMap31);
	
	var _Period = __webpack_require__(22);
	
	var Period = _interopRequireWildcard(_Period);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sportPeriodMap = {};
	sportPeriodMap[SportType.BADMINTON] = _PeriodMap2.default;
	sportPeriodMap[SportType.BANDY] = _PeriodMap4.default;
	sportPeriodMap[SportType.BASKETBALL] = _PeriodMap6.default;
	sportPeriodMap[SportType.BASKTBALL_NCAA] = _PeriodMap8.default;
	sportPeriodMap[SportType.BEACH_VOLLEYBALL] = _PeriodMap10.default;
	sportPeriodMap[SportType.BIATHLON] = _PeriodMap12.default;
	sportPeriodMap[SportType.BOX] = _PeriodMap14.default;
	sportPeriodMap[SportType.CYBER_SPORTS_DOTA2] = _PeriodMap16.default;
	//sportPeriodMap[SportType.CYBER_SPORTS] = CYBERSPORTDOTA2_PERIOD_MAP;
	sportPeriodMap[SportType.FOOTBALL] = _PeriodMap18.default;
	sportPeriodMap[SportType.HANDBALL] = _PeriodMap20.default;
	sportPeriodMap[SportType.ICE_HOCKEY] = _PeriodMap22.default;
	sportPeriodMap[SportType.TABLE_TENNIS] = _PeriodMap24.default;
	sportPeriodMap[SportType.TENNIS] = _PeriodMap26.default;
	sportPeriodMap[SportType.VOLLEYBALL] = _PeriodMap28.default;
	sportPeriodMap[SportType.WATER_POLLO] = _PeriodMap30.default;
	sportPeriodMap[SportType.WHAT_WHERE_WHEN] = _PeriodMap32.default;
	
	var MatchPhaseProvider = function () {
	    function MatchPhaseProvider() {
	        (0, _classCallCheck3.default)(this, MatchPhaseProvider);
	    }
	
	    (0, _createClass3.default)(MatchPhaseProvider, null, [{
	        key: 'getMatchPhase',
	        value: function getMatchPhase(sportId, periodId) {
	            return sportPeriodMap[sportId][periodId];
	        }
	    }, {
	        key: 'isMatchFinished',
	        value: function isMatchFinished(sportId, periodId) {
	            var matchPhase = MatchPhaseProvider.getMatchPhase(sportId, periodId);
	            return matchPhase === Period.FINISHED;
	        }
	    }, {
	        key: 'isMatchNotStarted',
	        value: function isMatchNotStarted(sportId, periodId) {
	            var matchPhase = MatchPhaseProvider.getMatchPhase(sportId, periodId);
	            return matchPhase === Period.NOT_STARTED;
	        }
	    }]);
	    return MatchPhaseProvider;
	}();
	
	exports.default = MatchPhaseProvider;

/***/ },
/* 1301 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getPeriodInfo = getPeriodInfo;
	
	var _matchPhaseProvider = __webpack_require__(1300);
	
	var _matchPhaseProvider2 = _interopRequireDefault(_matchPhaseProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getPeriodInfo(match, gridLocalization) {
	    var sportId = match.get("realSportId");
	    var periodId = match.getIn(["period", "id"]);
	    var matchPhase = _matchPhaseProvider2.default.getMatchPhase(sportId, periodId);
	
	    return {
	        matchMinute: match.getIn(["period", "minute"]),
	        period: gridLocalization.getPeriodName(sportId, periodId),
	        matchPhase: matchPhase
	    };
	}

/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _LoginButton = __webpack_require__(1307);
	
	var _LoginButton2 = _interopRequireDefault(_LoginButton);
	
	var _Balance = __webpack_require__(1303);
	
	var _Balance2 = _interopRequireDefault(_Balance);
	
	var _balanceAction = __webpack_require__(132);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Authenticated = function (_React$Component) {
	    (0, _inherits3.default)(Authenticated, _React$Component);
	
	    function Authenticated(props) {
	        (0, _classCallCheck3.default)(this, Authenticated);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Authenticated.__proto__ || (0, _getPrototypeOf2.default)(Authenticated)).call(this, props));
	
	        _this._handleHelpClick = _this._handleHelpClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(Authenticated, [{
	        key: '_handleHelpClick',
	        value: function _handleHelpClick(e) {
	            e.preventDefault();
	            var domain = this.props.domain;
	
	
	            var link = '//members.' + domain + '/messages/incoming';
	
	            window.open(link, 'MyAccount', "toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650");
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var balance = this.props.balance;
	            var login = this.props.user.get('login');
	            var resourceId = this.props.user.get('resourceId');
	            var accountNum = this.props.user.get('accountNum');
	            var balanceAction = this.props.balanceAction;
	
	            return _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(_LoginButton2.default, { login: login, accountNum: accountNum }),
	                _react2.default.createElement(_Balance2.default, { resourceId: resourceId, balance: balance, refreshAction: balanceAction })
	            );
	        }
	    }]);
	    return Authenticated;
	}(_react2.default.Component);
	
	Authenticated.propTypes = {
	    user: _react.PropTypes.object.isRequired,
	    balance: _react.PropTypes.any.isRequired,
	    domain: _react.PropTypes.string.isRequired,
	    balanceAction: _react.PropTypes.func.isRequired
	};
	
	
	var select = function select(state, props) {
	    return (0, _extends3.default)({}, props);
	};
	
	exports.default = (0, _reactRedux.connect)(select, { balanceAction: _balanceAction.balance })(Authenticated);

/***/ },
/* 1303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(8);
	
	var _accountResourceNames = __webpack_require__(59);
	
	var resources = _interopRequireWildcard(_accountResourceNames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Balance = function (_React$Component) {
	    (0, _inherits3.default)(Balance, _React$Component);
	
	    function Balance(props) {
	        (0, _classCallCheck3.default)(this, Balance);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Balance.__proto__ || (0, _getPrototypeOf2.default)(Balance)).call(this, props));
	
	        _this._onRefreshClick = _this._onRefreshClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(Balance, [{
	        key: '_onRefreshClick',
	        value: function _onRefreshClick(e) {
	            e.preventDefault();
	
	            this.props.refreshAction();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                balance = _props.balance,
	                resourceId = _props.resourceId;
	
	            var currency = resources.resourceNames[resourceId];
	
	            return _react2.default.createElement(
	                'li',
	                { className: 'balance' },
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', onClick: this._onRefreshClick },
	                    currency,
	                    '\xA0',
	                    _react2.default.createElement(_reactIntl.FormattedNumber, { value: balance, maximumFractionDigits: 2 })
	                )
	            );
	        }
	    }]);
	    return Balance;
	}(_react2.default.Component);
	
	Balance.propTypes = {
	    balance: _react.PropTypes.any.isRequired,
	    resourceId: _react.PropTypes.number.isRequired,
	    refreshAction: _react.PropTypes.func.isRequired
	};
	exports.default = Balance;

/***/ },
/* 1304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(8);
	
	var _Language = __webpack_require__(47);
	
	var Language = _interopRequireWildcard(_Language);
	
	var _accountResourceNames = __webpack_require__(59);
	
	var resources = _interopRequireWildcard(_accountResourceNames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatDateTime(moment) {
	    return moment.format('DD-MM-YYYY, HH:mm');
	}
	
	var messages = (0, _reactIntl.defineMessages)({
	    title_default: {
	        id: 'header.freebet.title.default',
	        defaultMessage: 'Вам доступна бесплатная ставка (фрибет)'
	    },
	    title_promocode: {
	        id: 'header.freebet.title.promocode',
	        defaultMessage: 'Вам доступна бесплатная ставка (фрибет) на сумму'
	    },
	    maxFactor: {
	        id: 'header.freebet.max_factor',
	        defaultMessage: 'Распространяется на любые ставки с максимальным коэфф. {maxFactor}.'
	    },
	    validThru: {
	        id: 'header.freebet.valid_thru',
	        defaultMessage: 'Начало действия от {startDate}'
	    },
	    validUntil: {
	        id: 'header.freebet.valid_until',
	        defaultMessage: 'Срок действия до {expireDate}'
	    },
	    details: {
	        id: 'header.freebet.details',
	        defaultMessage: 'Подробнее о фрибете'
	    }
	});
	
	var Freebet = function (_React$Component) {
	    (0, _inherits3.default)(Freebet, _React$Component);
	
	    function Freebet(props) {
	        (0, _classCallCheck3.default)(this, Freebet);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Freebet.__proto__ || (0, _getPrototypeOf2.default)(Freebet)).call(this, props));
	
	        _this._isInsidePopup = _this._isInsidePopup.bind(_this);
	        _this._onDocumentClick = _this._onDocumentClick.bind(_this);
	
	        _this._boundFreebetClick = _this._boundFreebetClick.bind(_this);
	        _this._onToggleDropdown = _this._onToggleDropdown.bind(_this);
	        _this.state = { dropdownHidden: true };
	        return _this;
	    }
	
	    (0, _createClass3.default)(Freebet, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            document.addEventListener('click', this._onDocumentClick);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener('click', this._onDocumentClick);
	        }
	    }, {
	        key: '_isInsidePopup',
	        value: function _isInsidePopup(element) {
	            if (element === null) {
	                return false;
	            }
	
	            if (element === this.refs.freebet) {
	                return true;
	            }
	
	            return this._isInsidePopup(element.parentElement);
	        }
	    }, {
	        key: '_onDocumentClick',
	        value: function _onDocumentClick(e) {
	            if (this._isInsidePopup(e.target)) {
	                return;
	            }
	
	            this.setState({ dropdownHidden: true });
	        }
	    }, {
	        key: '_boundFreebetClick',
	        value: function _boundFreebetClick(link, e) {
	            e.preventDefault();
	
	            window.open(link, 'Menu', "toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650");
	        }
	    }, {
	        key: '_onToggleDropdown',
	        value: function _onToggleDropdown(e) {
	            e.preventDefault();
	
	            this.setState({ dropdownHidden: !this.state.dropdownHidden });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                freebet = _props.freebet,
	                resourceId = _props.resourceId,
	                languageId = _props.languageId,
	                domain = _props.domain;
	            var dropdownHidden = this.state.dropdownHidden;
	
	            var currency = resources.resourceNames[resourceId];
	
	            var amount = freebet.get('amount');
	            var startDate = freebet.get('startDate');
	            var expireDate = freebet.get('expireDate');
	            var freebetUrl = '//members.' + domain + '/bonus/freebet';
	            var boundFreebetClick = this._boundFreebetClick.bind(this, freebetUrl);
	            var promocodeText = freebet.get('promocodeText');
	
	            var dropdownStyle = dropdownHidden ? { display: 'none' } : { display: 'block' };
	
	            if (amount === undefined) {
	                return false;
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { ref: 'freebet', className: 'freebet', onClick: this._onToggleDropdown },
	                _react2.default.createElement('div', { className: 'freebet--icon freebet--icon__header' }),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'freebet--amount' },
	                    Freebet.renderAmount(amount, currency, languageId)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'freebet--dropdown', style: dropdownStyle },
	                    _react2.default.createElement(
	                        'p',
	                        { style: { textAlign: 'left', lineHeight: '1.6' } },
	                        promocodeText ? _react2.default.createElement(
	                            _reactIntl.FormattedMessage,
	                            { id: 'header.freebet.title.promocode', values: {
	                                    promocode: promocodeText,
	                                    sum: amount,
	                                    currency: currency,
	                                    start: formatDateTime(startDate),
	                                    end: formatDateTime(expireDate)
	                                } },
	                            function (e) {
	                                return _react2.default.createElement('div', {
	                                    dangerouslySetInnerHTML: {
	                                        __html: e.replace(/\n/g, "<br/>")
	                                    }
	                                });
	                            }
	                        ) : _react2.default.createElement(
	                            _reactIntl.FormattedMessage,
	                            {
	                                id: 'header.freebet.title.default',
	                                values: {
	                                    sum: amount,
	                                    currency: currency,
	                                    start: formatDateTime(startDate),
	                                    end: formatDateTime(expireDate)
	                                }
	                            },
	                            function (e) {
	                                return _react2.default.createElement('div', {
	                                    dangerouslySetInnerHTML: {
	                                        __html: e.replace(/\n/g, "<br/>")
	                                    }
	                                });
	                            }
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: freebetUrl, onClick: boundFreebetClick,
	                                className: 'content--box__btn freebet--dropdown__btn' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.details)
	                        )
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'renderAmount',
	        value: function renderAmount(amount, currency, languageId) {
	            if (languageId != Language.EN) {
	                return _react2.default.createElement(_reactIntl.FormattedNumber, { value: amount, style: 'currency', currency: currency });
	            }
	
	            var floatAmount = parseFloat(amount).toFixed(2);
	
	            return _react2.default.createElement(
	                'span',
	                null,
	                currency + ' ' + floatAmount
	            );
	        }
	    }]);
	    return Freebet;
	}(_react2.default.Component);
	
	Freebet.propTypes = {
	    freebet: _react.PropTypes.object.isRequired,
	    resourceId: _react.PropTypes.number.isRequired,
	    languageId: _react.PropTypes.number.isRequired,
	    domain: _react.PropTypes.string.isRequired
	};
	exports.default = Freebet;

/***/ },
/* 1305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _underscore = __webpack_require__(145);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(25);
	
	var _reactIntl = __webpack_require__(8);
	
	var _Locale = __webpack_require__(1306);
	
	var _Locale2 = _interopRequireDefault(_Locale);
	
	var _Time = __webpack_require__(1309);
	
	var _Time2 = _interopRequireDefault(_Time);
	
	var _Menu = __webpack_require__(1308);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Authenticated = __webpack_require__(1302);
	
	var _Authenticated2 = _interopRequireDefault(_Authenticated);
	
	var _SignIn = __webpack_require__(342);
	
	var _SignIn2 = _interopRequireDefault(_SignIn);
	
	var _Freebet = __webpack_require__(1304);
	
	var _Freebet2 = _interopRequireDefault(_Freebet);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _games = __webpack_require__(492);
	
	var _reactRedux = __webpack_require__(9);
	
	var _functions = __webpack_require__(305);
	
	var _domainUtils = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    fast_sport: {
	        id: 'header.navigation.fastsport',
	        defaultMessage: 'Быстрые игры'
	    },
	    sports: {
	        id: 'header.navigation.sports',
	        defaultMessage: 'Спорт'
	    },
	    live: {
	        id: 'header.navigation.live',
	        defaultMessage: 'Лайв'
	    },
	    cybersport: {
	        id: 'header.navigation.cybersport',
	        defaultMessage: 'Киберспорт'
	    },
	    results: {
	        id: 'header.navigation.results',
	        defaultMessage: 'Результаты'
	    },
	    promotions: {
	        id: 'header.navigation.promotions',
	        defaultMessage: 'Акции и бонусы'
	    },
	    more: {
	        id: 'header.navigation.more',
	        defaultMessage: 'Ещё'
	    },
	    help: {
	        id: 'header.help',
	        defaultMessage: 'Помощь'
	    },
	    games: {
	        id: 'header.games',
	        defaultMessage: 'Игры'
	    }
	});
	
	var NavbarLink = function NavbarLink(_ref) {
	    var to = _ref.to,
	        className = _ref.className,
	        component = _ref.component,
	        children = _ref.children;
	
	    var Comp = component || _reactRouter.Link;
	
	    return _react2.default.createElement(
	        Comp,
	        { to: to, className: className, activeClassName: 'active' },
	        children
	    );
	};
	
	var Header = function (_React$Component) {
	    (0, _inherits3.default)(Header, _React$Component);
	
	    function Header(props) {
	        (0, _classCallCheck3.default)(this, Header);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).call(this, props));
	
	        _this.state = { loading: false };
	
	        _this.clickBetsolution = function () {
	            var gamblerId = _this.props.user ? _this.props.user.get('gamblerId') : null;
	            var game = { id: 7001, productId: 3, type: "betsolutions", name: "Zeppelin" };
	            _this.setState({ loading: true });
	
	            if (gamblerId) {
	                fetch('/api/games-betsolutions/').then(function (r) {
	                    return r.json();
	                }).then(function (_ref2) {
	                    var token = _ref2.token;
	
	                    _this.loadGame(game, token);
	                });
	            } else {
	                if (game.productId === 2) {
	                    _this.loadGame(game);
	                } else {
	                    _this.props.dispatch({ type: 'BEGIN_SIGNIN' });
	                    _this.setState({ loading: false });
	                }
	            }
	        };
	
	        _this.loadGame = function (game, token) {
	            var config = {
	                Token: token ? token : '54D2A7CA-FD87-46D4-A5A0-6BC0372C43EE',
	                MerchantId: token ? 5096 : 105,
	                GameId: game.id,
	                ProductId: game.productId,
	                IsFreeplay: 1,
	                Lang: _this.props.languageId === 5 ? 'en-US' : 'ru-RU',
	                Platform: 'desktop',
	                IframeContainerId: 'iframeContainer',
	                IframeId: 'gameIFrame',
	                GameOpenType: 'iframe',
	                AuthUrl: token ? 'https://auth-ru.betsolutions.com/auth/auth/' : 'https://auth-tr.betsolutions.com/auth/auth/'
	            };
	            if (game.productId === 1) {
	                config.TableGamesLobbyPageId = 1;
	                if (!token) {
	                    config.MerchantId = 34;
	                    config.Token = '17B437DF-AB78-44CB-904F-621704BC610F';
	                }
	            }
	            if (token) {
	                config.IsFreeplay = 0;
	            }
	            (0, _games.openBetsolutionGameWindow)(config);
	            _this.setState({ loading: false });
	        };
	
	        _this._handleHelpClick = _this._handleHelpClick.bind(_this);
	        _this._handlePromotionsClick = _this._handlePromotionsClick.bind(_this);
	        _this._handleHiddenMenuClick = _this._handleHiddenMenuClick.bind(_this);
	        _this._onDocumentClick = _this._onDocumentClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(Header, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.openHiddenMenu) {
	                document.addEventListener('click', this._onDocumentClick);
	            }
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({ openHiddenMenu: false });
	            document.removeEventListener('click', this._onDocumentClick);
	        }
	    }, {
	        key: '_handleHelpClick',
	        value: function _handleHelpClick(e) {
	            e.preventDefault();
	            var domain = this.props.domain;
	
	
	            window.open('//help.' + domain + '/faq', 'MyAccount', "toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650");
	        }
	    }, {
	        key: '_handleResultsClick',
	        value: function _handleResultsClick(link, e) {
	            e.preventDefault();
	            var domain = this.props.domain;
	
	
	            window.open('//results.' + domain + link, 'Results', "toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650");
	        }
	    }, {
	        key: '_handlePromotionsClick',
	        value: function _handlePromotionsClick(e) {
	            e.preventDefault();
	            var _props = this.props,
	                user = _props.user,
	                domain = _props.domain;
	
	
	            if (user) {
	                window.open('//members.' + domain + '/bonus/campaign', 'Promotions', "toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650");
	            } else {
	                window.open('//info.' + domain + '/promotions', 'Promotions', "toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650");
	            }
	        }
	    }, {
	        key: '_onDocumentClick',
	        value: function _onDocumentClick() {
	            document.removeEventListener('click', this._onDocumentClick);
	
	            this.setState({
	                openHiddenMenu: false
	            });
	        }
	    }, {
	        key: '_handleHiddenMenuClick',
	        value: function _handleHiddenMenuClick() {
	            this.setState({ openHiddenMenu: this.state.openHiddenMenu ? false : true });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                languageId = _props2.languageId,
	                user = _props2.user,
	                freebet = _props2.freebet,
	                balance = _props2.balance,
	                newMessagesCount = _props2.newMessagesCount,
	                countryCode = _props2.countryCode,
	                userGridSelection = _props2.userGridSelection,
	                domain = _props2.domain,
	                sportId = _props2.sportId,
	                leagueId = _props2.leagueId;
	
	            var isAvailable = (0, _functions.isAvailableGames)(countryCode);
	            var isUz = countryCode === "UZ";
	
	            var authenticatedProps = {
	                user: user,
	                balance: balance || 0,
	                newMessagesCount: newMessagesCount || 0,
	                domain: domain
	            };
	
	            var sportDefined = sportId !== undefined && sportId !== null && sportId.length;
	            var leagueDefined = leagueId !== undefined && leagueId !== null && leagueId.length;
	            var sportMenuClassName = sportDefined || leagueDefined ? 'active' : null;
	
	            var freebetProps = void 0;
	            if (user && freebet) {
	                freebetProps = {
	                    freebet: freebet,
	                    resourceId: user.get('resourceId'),
	                    languageId: languageId,
	                    domain: domain
	                };
	            }
	
	            var preMatchLinkAttr = userGridSelection.get('lastShown');
	            var preMatchSportId = !preMatchLinkAttr ? null : preMatchLinkAttr.get('sportId');
	            var preMatchLeagueId = !preMatchLinkAttr ? null : preMatchLinkAttr.get('leagueId', null);
	            var preMatchLink = _underscore2.default.compact(['/sports', preMatchSportId, preMatchLeagueId]).join('/');
	
	            var resultsDomain = '//results.' + domain;
	            var membersDomain = '//members.' + domain;
	            var infoDomain = '//info.' + domain;
	
	            var hiddenMenuClass = this.state.openHiddenMenu ? "hidden-menu open" : "hidden-menu";
	
	            var isFreebet = freebet && user ? ' with-freebet' : '';
	
	            return _react2.default.createElement(
	                'header',
	                { id: 'header', className: "header wrapper" + isFreebet },
	                this.state.loading && _react2.default.createElement(_Loader2.default, null),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'settings cf' },
	                    _react2.default.createElement(_Locale2.default, null),
	                    _react2.default.createElement(_Time2.default, { languageId: languageId })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'header-bottom' },
	                    _react2.default.createElement(_Menu2.default, { domain: domain, countryCode: countryCode, user: user }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'logo pull-left' },
	                        _react2.default.createElement(NavbarLink, { to: '/', component: _reactRouter.IndexLink })
	                    ),
	                    _react2.default.createElement(
	                        'nav',
	                        { className: 'nav pull-left' },
	                        _react2.default.createElement(
	                            'ul',
	                            null,
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    NavbarLink,
	                                    { to: preMatchLink, className: sportMenuClassName },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.sports)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    NavbarLink,
	                                    { to: '/live' },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.live)
	                                )
	                            ),
	                            (_domainUtils.isFpBet || isUz) && _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    NavbarLink,
	                                    { to: '/games', target: '_blank', style: { position: 'relative' } },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.games)
	                                )
	                            ),
	                            _domainUtils.isRingo && _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    NavbarLink,
	                                    { to: '/games', target: '_blank', style: { position: 'relative' } },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.fast_sport)
	                                )
	                            ),
	                            _domainUtils.isRingo && _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    NavbarLink,
	                                    { to: '/cybersport' },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.cybersport)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                { className: 'visible-lg-block' },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: resultsDomain, target: '_blank',
	                                        onClick: this._handleResultsClick.bind(this, "/sports") },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.results)
	                                )
	                            ),
	                            !isAvailable && _react2.default.createElement(
	                                'li',
	                                { className: 'visible-lg-block' },
	                                user && _react2.default.createElement(
	                                    'a',
	                                    { href: membersDomain, className: 'promotions', target: '_blank', onClick: this._handlePromotionsClick },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.promotions)
	                                ),
	                                !user && _react2.default.createElement(
	                                    'a',
	                                    { href: infoDomain, className: 'promotions', target: '_blank', onClick: this._handlePromotionsClick },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.promotions)
	                                )
	                            ),
	                            _react2.default.createElement('li', { className: 'stretch' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'hidden-menu-wrap visible-md-block' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: hiddenMenuClass, onClick: this._handleHiddenMenuClick.bind(this) },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'items' },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: resultsDomain, target: '_blank', onClick: this._handleResultsClick.bind(this, "/sports") },
	                                    _react2.default.createElement('span', { className: 'arrow' }),
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.results)
	                                ),
	                                !isAvailable && _react2.default.createElement(
	                                    'a',
	                                    { href: membersDomain, target: '_blank', onClick: this._handlePromotionsClick },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.promotions)
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'actions pull-right' },
	                        freebet && user && _react2.default.createElement(_Freebet2.default, freebetProps),
	                        _react2.default.createElement(
	                            'a',
	                            { href: "//help." + domain + "/faq",
	                                className: 'help',
	                                onClick: this._handleHelpClick,
	                                target: '_blank' },
	                            '?'
	                        ),
	                        !user && _react2.default.createElement(_SignIn2.default, { languageId: languageId }),
	                        user && _react2.default.createElement(_Authenticated2.default, authenticatedProps)
	                    )
	                )
	            );
	        }
	    }]);
	    return Header;
	}(_react2.default.Component);
	
	Header.propTypes = {
	    languageId: _react.PropTypes.number.isRequired,
	    user: _react.PropTypes.any,
	    freebet: _react.PropTypes.any,
	    balance: _react.PropTypes.any,
	    newMessagesCount: _react.PropTypes.any,
	    userGridSelection: _react.PropTypes.object.isRequired,
	    domain: _react.PropTypes.string.isRequired,
	    sportId: _react.PropTypes.any,
	    leagueId: _react.PropTypes.any
	};
	exports.default = (0, _reactRedux.connect)()((0, _reactRouter.withRouter)(Header));

/***/ },
/* 1306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(9);
	
	var _Locale = __webpack_require__(405);
	
	var _Locale2 = _interopRequireDefault(_Locale);
	
	var _changeLanguage = __webpack_require__(385);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function select(state) {
	    var languageId = state.application.get('languageId');
	
	    return {
	        languageId: languageId
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, { onLocaleChange: _changeLanguage.changeLanguage })(_Locale2.default);

/***/ },
/* 1307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UserDropDownMenu = __webpack_require__(1310);
	
	var _UserDropDownMenu2 = _interopRequireDefault(_UserDropDownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_React$Component) {
	    (0, _inherits3.default)(_class, _React$Component);
	
	    function _class(props) {
	        (0, _classCallCheck3.default)(this, _class);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, props));
	
	        _this._handleClick = _this._handleClick.bind(_this);
	        _this._handleMenuClosing = _this._handleMenuClosing.bind(_this);
	
	        _this.state = { isMenuVisible: false };
	        return _this;
	    }
	
	    (0, _createClass3.default)(_class, [{
	        key: '_handleClick',
	        value: function _handleClick(e) {
	            e.preventDefault();
	
	            var isMenuVisible = this.state.isMenuVisible;
	
	
	            this.setState({
	                isMenuVisible: !isMenuVisible
	            });
	        }
	    }, {
	        key: '_handleMenuClosing',
	        value: function _handleMenuClosing() {
	            this.setState({
	                isMenuVisible: false
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                login = _props.login,
	                accountNum = _props.accountNum;
	            var isMenuVisible = this.state.isMenuVisible;
	
	
	            return _react2.default.createElement(
	                'li',
	                { className: 'user dropdown--menu__container dropdown--menu__container-user' },
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', className: 'dropdown--toggle', onClick: this._handleClick },
	                    login
	                ),
	                isMenuVisible && _react2.default.createElement(_UserDropDownMenu2.default, { onClosing: this._handleMenuClosing, accountNum: accountNum })
	            );
	        }
	    }]);
	    return _class;
	}(_react2.default.Component);
	
	_class.propTypes = {
	    login: _react2.default.PropTypes.string.isRequired,
	    accountNum: _react2.default.PropTypes.string.isRequired
	};
	exports.default = _class;

/***/ },
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    menuText: {
	        id: 'header.menu.menu_text',
	        defaultMessage: 'Меню'
	    },
	    companyNews: {
	        id: 'header.menu.company_news',
	        defaultMessage: 'Новости компании'
	    },
	    regulations: {
	        id: 'header.menu.regulations',
	        defaultMessage: 'Правила'
	    },
	    responsibleGame: {
	        id: 'header.menu.responsible_game',
	        defaultMessage: 'Ответственная игра'
	    },
	    contactInformation: {
	        id: 'header.menu.contact_information',
	        defaultMessage: 'Контактная информация'
	    },
	    bettingShop: {
	        id: 'header.menu.betting_shop',
	        defaultMessage: 'Пункты приема ставок'
	    },
	    playersBestBets: {
	        id: 'header.menu.players_best_bets',
	        defaultMessage: 'Лучшие ставки игроков'
	    },
	    internetBonus: {
	        id: 'header.menu.internet_bonus',
	        defaultMessage: 'Акции и бонусы'
	    },
	    privacyPolicy: {
	        id: 'header.menu.privacy_policy',
	        defaultMessage: 'Политика конфиденциальности'
	    }
	});
	
	var _class = function (_React$Component) {
	    (0, _inherits3.default)(_class, _React$Component);
	
	    function _class(props) {
	        (0, _classCallCheck3.default)(this, _class);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, props));
	
	        _this.state = { showMenu: false };
	
	        _this._onDocumentClick = _this._onDocumentClick.bind(_this);
	        _this._onShowMenuClick = _this._onShowMenuClick.bind(_this);
	        _this._handleItemClick = _this._handleItemClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(_class, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return this.state.showMenu !== nextState.showMenu;
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.showMenu) {
	                document.addEventListener('click', this._onDocumentClick);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener('click', this._onDocumentClick);
	        }
	    }, {
	        key: '_handleItemClick',
	        value: function _handleItemClick(link, e) {
	            e.preventDefault();
	
	            window.open(link, 'Menu', "toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650");
	        }
	    }, {
	        key: '_onDocumentClick',
	        value: function _onDocumentClick() {
	            document.removeEventListener('click', this._onDocumentClick);
	
	            this.setState({
	                showMenu: false
	            });
	        }
	    }, {
	        key: '_onShowMenuClick',
	        value: function _onShowMenuClick(e) {
	            e.preventDefault();
	
	            this.setState({
	                showMenu: true
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var dropdownCls = 'dropdown' + (this.state.showMenu ? ' shown' : '');
	
	            var _props = this.props,
	                domain = _props.domain,
	                countryCode = _props.countryCode,
	                user = _props.user;
	
	
	            var helpDomain = '//help.' + domain;
	            var infoDomain = '//info.' + domain;
	
	            var boundCompanyNewsClick = this._handleItemClick.bind(this, infoDomain + '/news');
	            var boundRegulationsNewsClick = this._handleItemClick.bind(this, helpDomain);
	            var boundResponsibleNewsClick = this._handleItemClick.bind(this, helpDomain + '/responsible');
	            var boundContactsNewsClick = this._handleItemClick.bind(this, infoDomain + '/contacts');
	            var boundPrivacyClick = this._handleItemClick.bind(this, helpDomain + '/privacy');
	            var boundSalepointsNewsClick = this._handleItemClick.bind(this, helpDomain + '/salepoints');
	            var boundBestStakesNewsClick = this._handleItemClick.bind(this, infoDomain);
	            var boundPromotionsClick = this._handleItemClick.bind(this, infoDomain + '/promotions');
	
	            var showContactMenu = true;
	
	            if (!user && countryCode === 'KG' || user !== null && user.get('resourceId') === 1) {
	                showContactMenu = false;
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'sidebar-toggle pull-left' },
	                _react2.default.createElement('a', { href: '#', className: 'toggle-menu', onClick: this._onShowMenuClick }),
	                _react2.default.createElement(
	                    'ul',
	                    { className: dropdownCls },
	                    _react2.default.createElement(
	                        'li',
	                        { className: 'title' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.menuText)
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: helpDomain, className: 'regulations', onClick: boundRegulationsNewsClick,
	                                target: '_blank' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.regulations)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: helpDomain + '/privacy', className: 'responsible-game', onClick: boundPrivacyClick,
	                                target: '_blank' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.privacyPolicy)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: infoDomain, className: 'players-best-bets',
	                                onClick: boundBestStakesNewsClick,
	                                target: '_blank' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.playersBestBets)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: infoDomain + '/promotions', className: 'internet-bonus',
	                                onClick: boundPromotionsClick,
	                                target: '_blank' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.internetBonus)
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return _class;
	}(_react2.default.Component);
	
	_class.propTypes = {
	    domain: _react2.default.PropTypes.string.isRequired
	};
	exports.default = _class;

/***/ },
/* 1309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_React$Component) {
	    (0, _inherits3.default)(_class, _React$Component);
	
	    function _class(props) {
	        (0, _classCallCheck3.default)(this, _class);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, props));
	
	        _this.state = {
	            currentTime: new Date()
	        };
	
	        _this.interval = null;
	        return _this;
	    }
	
	    (0, _createClass3.default)(_class, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            this.interval = setInterval(function () {
	                _this2.setState({
	                    currentTime: new Date()
	                });
	            }, 1000);
	
	            this.setState({
	                currentTime: new Date()
	            });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.interval !== null) {
	                clearInterval(this.interval);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var curTime = void 0,
	                timeStr = void 0,
	                timeZone = void 0;
	
	            curTime = (0, _moment2.default)(this.state.currentTime);
	            timeStr = curTime.format("HH:mm:ss");
	            timeZone = curTime.format("Z");
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'date-time' },
	                timeStr + ' GMT' + timeZone
	            );
	        }
	    }]);
	    return _class;
	}(_react2.default.Component);
	
	_class.propTypes = {
	    languageId: _react2.default.PropTypes.number.isRequired
	};
	exports.default = _class;

/***/ },
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(8);
	
	var _DropDownMenu = __webpack_require__(502);
	
	var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);
	
	var _SignoutAction = __webpack_require__(118);
	
	var _Combobet = __webpack_require__(387);
	
	var _domainUtils = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    title: {
	        id: 'header.user_menu.title',
	        defaultMessage: 'Профиль'
	    },
	    accountNum: {
	        id: 'header.user_menu.account_num',
	        defaultMessage: 'Номер счета'
	    },
	    recharge: {
	        id: 'header.user_menu.recharge',
	        defaultMessage: 'Пополнить баланс'
	    },
	    briefcase: {
	        id: 'header.user_menu.briefcase',
	        defaultMessage: 'Портфель ставок'
	    },
	    betHistory: {
	        id: 'header.user_menu.bet_history',
	        defaultMessage: 'История ставок'
	    },
	    accountHistory: {
	        id: 'header.user_menu.account_history',
	        defaultMessage: 'История счета'
	    },
	    withdraw: {
	        id: 'header.user_menu.withdraw',
	        defaultMessage: 'Снять со счета'
	    },
	    opexСhecks: {
	        id: 'header.user_menu.opex_checks',
	        defaultMessage: 'Чеки «Opex»'
	    },
	    usdtСhecks: {
	        id: 'header.user_menu.usdt_checks',
	        defaultMessage: 'Чеки «USD₮»'
	    },
	    profile: {
	        id: 'header.user_menu.profile',
	        defaultMessage: 'Мой профиль'
	    },
	    bonus: {
	        id: 'header.user_menu.bonus',
	        defaultMessage: "Бонусы"
	    },
	    logout: {
	        id: 'header.user_menu.logout',
	        defaultMessage: 'Выйти'
	    }
	});
	
	function _localizedLink(message, link, additionalClass) {
	    var linkClass = "dropdown--menu__link";
	    if (additionalClass) {
	        linkClass = linkClass + ' ' + additionalClass;
	    }
	
	    return _react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        message,
	        function (localizedMessage) {
	            return _react2.default.createElement(
	                'a',
	                { href: link, target: '_blank', className: linkClass, onClick: _handleClick.bind(null, link) },
	                localizedMessage
	            );
	        }
	    );
	}
	
	function _handleClick(link, e) {
	    e.preventDefault();
	
	    window.open(link, 'MyAccount', "toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650");
	}
	
	var UserDropDownMenu = function (_React$Component) {
	    (0, _inherits3.default)(UserDropDownMenu, _React$Component);
	
	    function UserDropDownMenu(props) {
	        (0, _classCallCheck3.default)(this, UserDropDownMenu);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (UserDropDownMenu.__proto__ || (0, _getPrototypeOf2.default)(UserDropDownMenu)).call(this, props));
	
	        _this._handleLogout = _this._handleLogout.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(UserDropDownMenu, [{
	        key: '_handleLogout',
	        value: function _handleLogout() {
	            this.props.SignoutAction();
	        }
	    }, {
	        key: '_renderTitle',
	        value: function _renderTitle() {
	            var accountNum = this.props.accountNum;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactIntl.FormattedMessage, messages.accountNum),
	                ':',
	                '\xA0',
	                _react2.default.createElement(
	                    'span',
	                    { style: { color: '#ffea00' } },
	                    accountNum
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var cssClass = 'dropdown--menu-user';
	
	            var _props = this.props,
	                domain = _props.domain,
	                user = _props.user;
	
	            var isKGZDemoUser = user && user.get('accountNum') === '276502';
	
	            var LogoutLink = _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                messages.logout,
	                function (localizedMessage) {
	                    return _react2.default.createElement(
	                        'a',
	                        { href: '#', className: 'dropdown--menu__link', onClick: _this2._handleLogout },
	                        localizedMessage
	                    );
	                }
	            );
	
	            var elements = [_domainUtils.isRingo ? null : { content: _localizedLink(messages.recharge, '//members.' + domain + '/balance/recharge') }, { content: _localizedLink(messages.briefcase, '//members.' + domain + '/balance/briefcase') }, { content: _localizedLink(messages.betHistory, '//members.' + domain + '/history/bets') }, { content: _localizedLink(messages.accountHistory, '//members.' + domain + '/history/account') }, { content: _localizedLink(messages.withdraw, '//members.' + domain + '/balance/withdraw') }, { content: _localizedLink(messages.profile, '//members.' + domain + '/profile') }, { content: _localizedLink(messages.bonus, '//members.' + domain + '/bonus', 'bonus-link') }, { content: LogoutLink }];
	
	            if (_Combobet.allowedAccountResources.find(function (accountResource) {
	                return accountResource === user.get('resourceId');
	            })) {
	                elements = [_domainUtils.isRingo ? null : { content: _localizedLink(messages.recharge, '//members.' + domain + '/balance/recharge') }, { content: _localizedLink(messages.briefcase, '//members.' + domain + '/balance/briefcase') }, { content: _localizedLink(messages.betHistory, '//members.' + domain + '/history/bets') }, { content: _localizedLink(messages.accountHistory, '//members.' + domain + '/history/account') }, { content: _localizedLink(messages.withdraw, '//members.' + domain + '/balance/withdraw') }, { content: _localizedLink(messages.opexСhecks, '//members.' + domain + '/opex-checks') }, isKGZDemoUser ? { content: _localizedLink(messages.usdtСhecks, '//members.' + domain + '/usdt-checks') } : null, { content: _localizedLink(messages.profile, '//members.' + domain + '/profile') }, { content: _localizedLink(messages.bonus, '//members.' + domain + '/bonus', 'bonus-link') }, { content: LogoutLink }];
	            }
	
	            var title = this._renderTitle();
	
	            return _react2.default.createElement(_DropDownMenu2.default, { cssClass: cssClass,
	                title: title,
	                elements: elements,
	                onClosing: this.props.onClosing
	            });
	        }
	    }]);
	    return UserDropDownMenu;
	}(_react2.default.Component);
	
	UserDropDownMenu.propTypes = {
	    user: _react2.default.PropTypes.any,
	    domain: _react2.default.PropTypes.string.isRequired,
	    onClosing: _react2.default.PropTypes.func.isRequired,
	    accountNum: _react2.default.PropTypes.string.isRequired,
	    SignoutAction: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select(state) {
	    var domain = window.location.host === "qa1.fp.kz" ? 'qa1.fp.kz' : state.domain;
	    return {
	        domain: domain,
	        user: state.auth.get('user')
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, { SignoutAction: _SignoutAction.signout })(UserDropDownMenu);

/***/ },
/* 1311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(1305);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Header2.default;

/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Application = __webpack_require__(1171);
	
	Object.defineProperty(exports, 'Application', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Application).default;
	  }
	});
	
	var _MainPage = __webpack_require__(1347);
	
	Object.defineProperty(exports, 'MainPage', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MainPage).default;
	  }
	});
	
	var _BironexPage = __webpack_require__(1339);
	
	Object.defineProperty(exports, 'BironexPage', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BironexPage).default;
	  }
	});
	
	var _SportsPage = __webpack_require__(1352);
	
	Object.defineProperty(exports, 'SportsPage', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SportsPage).default;
	  }
	});
	
	var _LivePage = __webpack_require__(1346);
	
	Object.defineProperty(exports, 'LivePage', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LivePage).default;
	  }
	});
	
	var _BetGamesPage = __webpack_require__(1338);
	
	Object.defineProperty(exports, 'BetGamesPage', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BetGamesPage).default;
	  }
	});
	
	var _index = __webpack_require__(1211);
	
	Object.defineProperty(exports, 'SlotsGamesPage', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_index).default;
	  }
	});
	
	var _virtualSports = __webpack_require__(1214);
	
	Object.defineProperty(exports, 'VirtualGamesPage', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_virtualSports).default;
	  }
	});
	
	var _SignIn = __webpack_require__(1350);
	
	Object.defineProperty(exports, 'SignInPage', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SignIn).default;
	  }
	});
	
	var _SignUp = __webpack_require__(1351);
	
	Object.defineProperty(exports, 'SignUpPage', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SignUp).default;
	  }
	});
	
	var _IdentifyPage = __webpack_require__(1345);
	
	Object.defineProperty(exports, 'IdentifyPage', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_IdentifyPage).default;
	  }
	});
	
	var _Cybersport = __webpack_require__(1340);
	
	Object.defineProperty(exports, 'CybersportPage', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Cybersport).default;
	  }
	});
	
	var _GamesPageNew = __webpack_require__(1342);
	
	Object.defineProperty(exports, 'GamesNewPage', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GamesPageNew).default;
	  }
	});
	
	var _Footer = __webpack_require__(1173);
	
	Object.defineProperty(exports, 'Footer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Footer).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _domainUtils = __webpack_require__(27);
	
	var _reactSlick = __webpack_require__(698);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(1665);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Language = __webpack_require__(47);
	
	var _Highlights = __webpack_require__(1314);
	
	var _Highlights2 = _interopRequireDefault(_Highlights);
	
	var _JacktopGamesBanner = __webpack_require__(1315);
	
	var _JacktopGamesBanner2 = _interopRequireDefault(_JacktopGamesBanner);
	
	var _index = __webpack_require__(1316);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatErrorMessage = function formatErrorMessage(langType) {
	  var _getLanguageType = (0, _Language.getLanguageType)(langType),
	      _getLanguageType$name = _getLanguageType.name,
	      name = _getLanguageType$name === undefined ? 'en' : _getLanguageType$name;
	
	  var localization = {
	    en: {
	      gamesErrorMessage: 'Banner loading error. Please try again later'
	    },
	    ru: {
	      gamesErrorMessage: 'Ошибка загрузки баннера. Повторите попытку позже'
	    }
	  };
	  return localization[name];
	};
	
	var Banner = function (_Component) {
	  (0, _inherits3.default)(Banner, _Component);
	
	  function Banner() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Banner);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Banner.__proto__ || (0, _getPrototypeOf2.default)(Banner)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      activeSlide: 0
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Banner, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.tvBetGame.error !== this.props.tvBetGame.error && this.props.tvBetGame.error) {
	        alert(formatErrorMessage(this.props.languageId).gamesErrorMessage);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var activeSlide = this.state.activeSlide;
	
	      var slides = [];
	      if (_domainUtils.isFpBet) slides.push(_Highlights2.default, _JacktopGamesBanner2.default, _index2.default);
	      // if (isUz) slides.push(FastSport)
	
	      var moreThan1Slide = slides.length > 1;
	
	      var settings = {
	        dots: true,
	        infinite: moreThan1Slide,
	        autoplay: true,
	        autoplaySpeed: 4000,
	        speed: 500,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        centerMode: true,
	        centerPadding: moreThan1Slide ? '80px' : '0',
	        arrows: false,
	        focusOnSelect: true,
	        customPaging: function customPaging(i) {
	          return _react2.default.createElement(
	            'button',
	            null,
	            i + 1
	          );
	        },
	        beforeChange: function beforeChange(_, next) {
	          return _this2.setState({ activeSlide: next });
	        },
	        size: '20px',
	        pauseOnHover: false,
	        pauseOnFocus: false
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: { marginBottom: 10 } },
	        this.props.tvBetGame.loading && _react2.default.createElement(_Loader2.default, null),
	        _react2.default.createElement(
	          _reactSlick2.default,
	          settings,
	          slides.map(function (Slide, index) {
	            return _react2.default.createElement(
	              'div',
	              { key: index, style: { paddingRight: '10px' } },
	              _react2.default.createElement(
	                'div',
	                {
	                  style: {
	                    opacity: activeSlide === index ? 1 : 0.5,
	                    transition: 'opacity 0.5s'
	                  }
	                },
	                _react2.default.createElement(Slide, { isActiveSlide: activeSlide === index })
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	  return Banner;
	}(_react.Component);
	
	function select(state) {
	  var languageId = state.application.get('languageId');
	
	  var user = state.auth.get('user');
	  var accountNum = user ? user.get('accountNum') : null;
	
	  return {
	    languageId: languageId,
	    accountNum: accountNum,
	    tvBetGame: state.games.tvbet
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(select)(Banner);

/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouterRedux = __webpack_require__(23);
	
	var _Language = __webpack_require__(47);
	
	var Languages = _interopRequireWildcard(_Language);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Highlights = function (_React$Component) {
	  (0, _inherits3.default)(Highlights, _React$Component);
	
	  function Highlights(props) {
	    (0, _classCallCheck3.default)(this, Highlights);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Highlights.__proto__ || (0, _getPrototypeOf2.default)(Highlights)).call(this, props));
	
	    _this.CashbackBannerClick = _this.CashbackBannerClick.bind(_this);
	    _this.OpexBannerClick = _this.OpexBannerClick.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Highlights, [{
	    key: 'CashbackBannerClick',
	    value: function CashbackBannerClick(link, e) {
	      e.preventDefault();
	      var _props = this.props,
	          index = _props.index,
	          activeSlide = _props.activeSlide;
	
	
	      if (index === activeSlide) {
	        window.open(link, 'Menu', 'toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650');
	      }
	    }
	  }, {
	    key: 'OpexBannerClick',
	    value: function OpexBannerClick() {
	      var isActiveSlide = this.props.isActiveSlide;
	
	      if (isActiveSlide) this.props.push('/bironex');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          languageId = _props2.languageId,
	          countryCode = _props2.countryCode;
	
	
	      var bannerClass = 'banner-slider__item banner-slider__item--cashback';
	
	      if (languageId === Languages.UZ) {
	        bannerClass += ' uz';
	      }
	      if (languageId === Languages.RU) {
	        bannerClass += ' ru';
	      }
	      if (languageId === Languages.EN) {
	        bannerClass += ' en';
	      }
	
	      var CashbackBannerClick = this.CashbackBannerClick.bind(this, '//info.' + this.props.domain + '/promotions');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'mute-slider banner-slider' },
	        _react2.default.createElement(
	          'div',
	          {
	            id: 'banner',
	            className: bannerClass,
	            onClick: CashbackBannerClick
	          },
	          _react2.default.createElement('div', { className: 'money country-' + countryCode }),
	          _react2.default.createElement('div', { className: 'label' }),
	          _react2.default.createElement('div', { className: 'message' })
	        )
	      );
	    }
	  }]);
	  return Highlights;
	}(_react2.default.Component);
	
	Highlights.propTypes = {
	  languageId: _react2.default.PropTypes.number.isRequired,
	  domain: _react2.default.PropTypes.string.isRequired
	};
	
	
	function select(state) {
	  var languageId = state.application.get('languageId');
	  var domain = state.domain;
	
	  return {
	    languageId: languageId,
	    domain: domain,
	    user: state.auth.get('user'),
	    countryCode: state.application.get('countryCode')
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(select, { push: _reactRouterRedux.push })(Highlights);

/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouterRedux = __webpack_require__(23);
	
	var _Language = __webpack_require__(47);
	
	var _domainUtils = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var liveCasino = {
	  ru: '/img/jacktop-games-live-casino-games-ru.png',
	  en: '/img/jacktop-games-live-casino-games-en.png'
	};
	
	var tryNew = {
	  ru: '/img/jacktop-games-try-new-ru.png',
	  en: '/img/jacktop-games-try-new-en.png'
	};
	
	var JacktopGamesBanner = function (_Component) {
	  (0, _inherits3.default)(JacktopGamesBanner, _Component);
	
	  function JacktopGamesBanner() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, JacktopGamesBanner);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = JacktopGamesBanner.__proto__ || (0, _getPrototypeOf2.default)(JacktopGamesBanner)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function () {
	      var isActiveSlide = _this.props.isActiveSlide;
	
	      if (isActiveSlide) _this.props.push('/games?provider=' + (_domainUtils.isStage ? 22 : 4));
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(JacktopGamesBanner, [{
	    key: 'render',
	    value: function render() {
	      var langId = this.props.langId;
	
	      var locale = _Language.languageMap[langId].name;
	
	      var src = tryNew[locale] || tryNew['ru'];
	      var liveCasinoSrc = liveCasino[locale] || liveCasino['ru'];
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'jacktop-games-banner', onClick: this.onClick },
	        _react2.default.createElement('img', { src: src, alt: 'Live Casino Games' }),
	        _react2.default.createElement('img', { src: liveCasinoSrc, alt: 'Live Casino Games' }),
	        _react2.default.createElement('img', { src: '/img/jacktop-banner-logo.png', alt: 'Jacktop logo' }),
	        _react2.default.createElement('img', { src: '/img/jacktop-banner-girl.png', alt: 'Jacktop Girl' })
	      );
	    }
	  }]);
	  return JacktopGamesBanner;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    langId: state.application.get('languageId')
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { push: _reactRouterRedux.push })(JacktopGamesBanner);

/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(82);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(97);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _Language = __webpack_require__(47);
	
	var _creators = __webpack_require__(386);
	
	var _Auth = __webpack_require__(95);
	
	var _domainUtils = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-console */
	var GAME_ID = _domainUtils.isStage ? 2661 : 14085;
	
	var LuckyChiken = function (_Component) {
	  (0, _inherits3.default)(LuckyChiken, _Component);
	
	  function LuckyChiken() {
	    var _ref,
	        _this2 = this;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, LuckyChiken);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LuckyChiken.__proto__ || (0, _getPrototypeOf2.default)(LuckyChiken)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function () {
	      var _this$props = _this.props,
	          gamblerId = _this$props.gamblerId,
	          isActiveSlide = _this$props.isActiveSlide;
	
	      if (isActiveSlide) {
	        if (gamblerId) {
	          _this.launchGame();
	        } else {
	          _this.props.beginSignIn();
	        }
	      }
	    }, _this.launchGame = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var _this$props2, gamblerId, languageId, language, queryParam, response, data;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$props2 = _this.props, gamblerId = _this$props2.gamblerId, languageId = _this$props2.languageId;
	              _context.prev = 1;
	              language = (0, _Language.getLanguageType)(languageId).name;
	              queryParam = '?gamblerId=' + gamblerId + '&language=' + language;
	              _context.next = 6;
	              return fetch('/api/games/' + GAME_ID + '/launch/' + queryParam);
	
	            case 6:
	              response = _context.sent;
	
	              if (response.ok) {
	                _context.next = 9;
	                break;
	              }
	
	              throw new Error('Network response was not ok');
	
	            case 9:
	              _context.next = 11;
	              return response.json();
	
	            case 11:
	              data = _context.sent;
	
	
	              window.location.assign(data.LaunchUrl);
	              _context.next = 18;
	              break;
	
	            case 15:
	              _context.prev = 15;
	              _context.t0 = _context['catch'](1);
	
	              console.error('Failed to fetch game details:', _context.t0);
	
	            case 18:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[1, 15]]);
	    })), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(LuckyChiken, [{
	    key: 'render',
	    value: function render() {
	      var _getLanguageType = (0, _Language.getLanguageType)(this.props.languageId),
	          name = _getLanguageType.name;
	
	      var btnSrc = '/img/banners/lucky-chiken/btn-' + name + '.png';
	      var textSrc = '/img/banners/lucky-chiken/text-' + name + '.png';
	
	      return _react2.default.createElement(
	        'div',
	        { onClick: this.onClick, className: 'lucky-chiken-banner' },
	        _react2.default.createElement('img', { src: '/img/banners/lucky-chiken/mid.png', className: 'mid', alt: '' }),
	        _react2.default.createElement('img', { src: '/img/banners/lucky-chiken/logo.png', className: 'logo', alt: '' }),
	        _react2.default.createElement('img', { src: btnSrc, className: 'btn', alt: '' }),
	        _react2.default.createElement('img', { src: textSrc, className: 'text', alt: '' })
	      );
	    }
	  }]);
	  return LuckyChiken;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  var user = state.auth.get('user');
	  return {
	    gamblerId: user && user.get('gamblerId'),
	    languageId: state.application.get('languageId')
	  };
	}, { fetchFastsportToken: _creators.fetchFastsportToken, beginSignIn: _Auth.beginSignIn })(LuckyChiken);

/***/ },
/* 1317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(698);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _reactIntl = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    readTitle: {
	        id: 'news.read_title',
	        defaultMessage: 'Читать'
	    },
	    companyNews: {
	        id: 'news.company_news',
	        defaultMessage: 'Новости компании'
	    }
	});
	
	var News = function (_React$Component) {
	    (0, _inherits3.default)(News, _React$Component);
	
	    function News(props) {
	        (0, _classCallCheck3.default)(this, News);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (News.__proto__ || (0, _getPrototypeOf2.default)(News)).call(this, props));
	
	        _this._newsItemClick = _this._newsItemClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(News, [{
	        key: '_newsItemClick',
	        value: function _newsItemClick(link, e) {
	            e.preventDefault();
	
	            window.open(link, 'News', "toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650");
	        }
	    }, {
	        key: 'renderNews',
	        value: function renderNews(news) {
	            var newsElements = [];
	
	            for (var i = 0; i < news.length; i++) {
	                var newsItem = news[i];
	
	                var link = newsItem.link;
	                var newsItemClick = this._newsItemClick.bind(this, link);
	
	                newsElements.push(_react2.default.createElement(
	                    'div',
	                    { key: newsItem.id },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'slideshow--content__item' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'slideshow--content__item__date' },
	                            _react2.default.createElement(_reactIntl.FormattedDate, {
	                                value: newsItem.date,
	                                day: 'numeric',
	                                month: 'long',
	                                year: 'numeric' })
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'slideshow--content__item__content' },
	                            _react2.default.createElement(
	                                'strong',
	                                { className: 'slideshow--content__item__content__title' },
	                                newsItem.title
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                newsItem.content
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: link,
	                                onClick: newsItemClick,
	                                className: 'slideshow--content__item__readmore',
	                                target: '_blank' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.readTitle)
	                        )
	                    )
	                ));
	            }
	
	            return newsElements;
	        }
	
	        ///TODO: fix 'same keys problem' or change to another slider
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var news = this.props.news;
	
	            if (!news || !news.length) {
	                return false;
	            }
	
	            var settings = {
	                dots: true,
	                initialSlide: 0,
	                infinite: true,
	                speed: 1000,
	                arrows: true,
	                autoplay: true,
	                autoplaySpeed: 5000,
	                className: "slideshow--content__list slideshow--content__list_js",
	                cssEase: 'ease-in-out'
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'slideshow--content', style: { backgroundColor: '#9bbda8' } },
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'slideshow--content__title' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.companyNews)
	                ),
	                _react2.default.createElement(
	                    _reactSlick2.default,
	                    settings,
	                    this.renderNews(news)
	                )
	            );
	        }
	
	        /*render() {
	            const news = this.props.news;
	             if (!news || !news.length) {
	                return false;
	            }
	             return (
	                <div className="slideshow--content" style={{backgroundColor:'#9bbda8'}}>
	                    <h3 className="slideshow--content__title">
	                        <FormattedMessage {...messages.companyNews} />
	                    </h3>
	                    {this.renderNews(news)}
	                </div>
	            );
	        }*/
	
	    }]);
	    return News;
	}(_react2.default.Component);
	
	News.propTypes = {
	    news: _react2.default.PropTypes.array.isRequired
	};
	exports.default = News;

/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _BaseRate2 = __webpack_require__(341);
	
	var _CouponRate = __webpack_require__(72);
	
	var _MakeBet = __webpack_require__(133);
	
	var _HistoryBet = __webpack_require__(65);
	
	var _renderingCommons = __webpack_require__(137);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopularMatchRate = function (_BaseRate) {
	    (0, _inherits3.default)(PopularMatchRate, _BaseRate);
	
	    function PopularMatchRate(props) {
	        (0, _classCallCheck3.default)(this, PopularMatchRate);
	        return (0, _possibleConstructorReturn3.default)(this, (PopularMatchRate.__proto__ || (0, _getPrototypeOf2.default)(PopularMatchRate)).call(this, props));
	    }
	
	    (0, _createClass3.default)(PopularMatchRate, [{
	        key: 'render',
	        value: function render() {
	            var rate = this.props.rate;
	
	
	            if (!rate) {
	                return _react2.default.createElement('span', { className: 'cell rate empty-cell' });
	            }
	
	            var rateValue = (0, _renderingCommons.getRateDisplayValue)(rate.get('value'));
	
	            return _react2.default.createElement(
	                'span',
	                { className: 'cell rate', onClick: this._onClick },
	                rateValue
	            );
	        }
	    }]);
	    return PopularMatchRate;
	}(_BaseRate2.BaseRate);
	
	PopularMatchRate.propTypes = {
	    rate: _react2.default.PropTypes.object,
	    addCouponRateAction: _react2.default.PropTypes.func.isRequired,
	    gridLocalization: _react2.default.PropTypes.object.isRequired,
	    addRateAction: _react2.default.PropTypes.func.isRequired,
	    makeBetAction: _react2.default.PropTypes.func.isRequired,
	    requestBetTypesAction: _react2.default.PropTypes.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)(_BaseRate2.mapStateToProps, {
	    addCouponRateAction: _CouponRate.addCouponRate, makeBetAction: _MakeBet.makeBet, requestBetTypesAction: _HistoryBet.requestBetTypes, addRateAction: _CouponRate.addRate
	}, null, false)(PopularMatchRate);

/***/ },
/* 1319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(25);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(9);
	
	var _SportCssMap = __webpack_require__(120);
	
	var _PopularMatchRate = __webpack_require__(1318);
	
	var _PopularMatchRate2 = _interopRequireDefault(_PopularMatchRate);
	
	var _Locales = __webpack_require__(80);
	
	var _Locales2 = _interopRequireDefault(_Locales);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopularMatch = function (_React$Component) {
	    (0, _inherits3.default)(PopularMatch, _React$Component);
	
	    function PopularMatch(props) {
	        (0, _classCallCheck3.default)(this, PopularMatch);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (PopularMatch.__proto__ || (0, _getPrototypeOf2.default)(PopularMatch)).call(this, props));
	
	        _this.renderMatchDate = _this.renderMatchDate.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(PopularMatch, [{
	        key: 'renderMatchDate',
	        value: function renderMatchDate(date) {
	            var timezone = _moment2.default.tz.guess();
	
	            var locale = _Locales2.default[this.props.languageId];
	            _moment2.default.locale(locale);
	
	            _moment2.default.updateLocale('en', {
	                calendar: {
	                    sameDay: '[Today at] HH:mm',
	                    nextDay: '[Tomorrow at] HH:mm',
	                    lastWeek: 'D MMMM [at] HH:mm',
	                    nextWeek: 'D MMMM [at] HH:mm',
	                    sameElse: 'D MMMM [at] HH:mm'
	                }
	            });
	
	            _moment2.default.updateLocale('ru', {
	                calendar: {
	                    sameDay: '[Сегодня в] HH:mm',
	                    nextDay: '[Завтра в] HH:mm',
	                    lastWeek: 'D MMMM [в] HH:mm',
	                    nextWeek: 'D MMMM [в] HH:mm',
	                    sameElse: 'D MMMM [в] HH:mm'
	                }
	            });
	
	            date.locale(locale).tz(timezone);
	
	            return _react2.default.createElement(
	                'span',
	                { className: 'event__date' },
	                date.calendar()
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                sport = _props.sport,
	                league = _props.league,
	                match = _props.match,
	                rates = _props.rates,
	                gridLocalization = _props.gridLocalization;
	
	
	            if (!sport) {
	                return false;
	            }
	
	            var iconCls = 'sport-icon svg-' + _SportCssMap.cssClassMap[sport.get('id')];
	
	            var channel = match.get('channel');
	
	            var name = match.get('name');
	            var notice = match.get('notice');
	            if (notice) {
	                name = name + ' (' + notice + ')';
	            }
	
	            var outcomesCount = match.get('outcomesCount') > 1 ? match.get('outcomesCount') - 1 : false;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'table popular--table' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'cell main' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'event-name popular--event-name' },
	                            this.renderMatchDate(match.get('startDate')),
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/sports/' + sport.get('id') + '/' + league.get('id') + '/' + match.get('id'),
	                                    className: 'event-name__link' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'hint hint--league' },
	                                    league.get('name')
	                                ),
	                                _react2.default.createElement('span', { className: iconCls }),
	                                name,
	                                channel && _react2.default.createElement(
	                                    'sup',
	                                    { className: 'icon icon--tv', title: channel },
	                                    ' '
	                                )
	                            ),
	                            outcomesCount && _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/sports/' + sport.get('id') + '/' + league.get('id'),
	                                    className: 'outcome-count' },
	                                '+',
	                                outcomesCount
	                            )
	                        ),
	                        _react2.default.createElement('span', { className: 'cell-main tools' })
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        PopularMatch.renderRates(rates, gridLocalization)
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'renderRates',
	        value: function renderRates(rates, gridLocalization) {
	            var size = rates.length;
	
	            var win1Rate = rates[0].get('id');
	            var drawRate = size === 3 ? rates[1].get('id') : undefined;
	            var win2Rate = rates[size - 1].get('id');
	
	            return _react2.default.createElement(
	                'span',
	                { className: 'cell-title-wrapper' },
	                _react2.default.createElement(_PopularMatchRate2.default, { key: '0', id: win1Rate, section: 'popularMatches', gridLocalization: gridLocalization }),
	                _react2.default.createElement(_PopularMatchRate2.default, { key: '1', id: drawRate, section: 'popularMatches', gridLocalization: gridLocalization }),
	                _react2.default.createElement(_PopularMatchRate2.default, { key: '2', id: win2Rate, section: 'popularMatches', gridLocalization: gridLocalization })
	            );
	        }
	    }]);
	    return PopularMatch;
	}(_react2.default.Component);
	
	PopularMatch.propTypes = {
	    languageId: _react2.default.PropTypes.number.isRequired,
	    gridLocalization: _react2.default.PropTypes.object.isRequired,
	    sport: _react2.default.PropTypes.object,
	    league: _react2.default.PropTypes.object,
	    match: _react2.default.PropTypes.object,
	    rates: _react2.default.PropTypes.array
	};
	
	
	function select(state, props) {
	    var match = props.match;
	    var matchId = match.get('id');
	
	    var languageId = state.application.get('languageId');
	    var sports = state.application.getIn(['popularMatches', 'sports']);
	    var leagues = state.application.getIn(['popularMatches', 'leagues']);
	    var rates = state.application.getIn(['popularMatches', 'rates']);
	
	    var matchRates = rates.valueSeq().filter(function (r) {
	        return r.get('matchId') === matchId;
	    }).sort(function (a, b) {
	        if (a.get('type') > b.get('type')) {
	            return 1;
	        } else {
	            return -1;
	        }
	    }).toArray();
	
	    return {
	        languageId: languageId,
	        match: match,
	        sport: sports.getIn([match.get('sportId')]),
	        league: leagues.getIn([match.get('leagueId')]),
	        rates: matchRates
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select)(PopularMatch);

/***/ },
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(8);
	
	var _PopularMatch = __webpack_require__(1319);
	
	var _PopularMatch2 = _interopRequireDefault(_PopularMatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    title: {
	        id: 'popular.title',
	        defaultMessage: 'Популярные ставки'
	    },
	    win1: {
	        id: 'popular.win1',
	        defaultMessage: 'П1'
	    },
	    draw: {
	        id: 'popular.draw',
	        defaultMessage: 'Х'
	    },
	    win2: {
	        id: 'popular.win2',
	        defaultMessage: 'П2'
	    }
	});
	
	var Popular = function (_React$Component) {
	    (0, _inherits3.default)(Popular, _React$Component);
	
	    function Popular(props) {
	        (0, _classCallCheck3.default)(this, Popular);
	        return (0, _possibleConstructorReturn3.default)(this, (Popular.__proto__ || (0, _getPrototypeOf2.default)(Popular)).call(this, props));
	    }
	
	    (0, _createClass3.default)(Popular, [{
	        key: 'render',
	        value: function render() {
	            var gridLocalization = this.props.gridLocalization;
	
	            var matches = this.props.matches.valueSeq().toList();
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'popular' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'table popular--table main-heading' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'cell main' },
	                            _react2.default.createElement(
	                                _reactIntl.FormattedMessage,
	                                messages.title,
	                                function (title) {
	                                    return _react2.default.createElement(
	                                        'h1',
	                                        { style: { display: 'inline-block' } },
	                                        title
	                                    );
	                                }
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'cell cell-outcomes' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.win1)
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'cell cell-outcomes' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.draw)
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'cell cell-outcomes' },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.win2)
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'event popular--event' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'event-header popular--event-header' },
	                        matches.map(function (match) {
	                            return Popular.renderMatch(match, gridLocalization);
	                        })
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'renderMatch',
	        value: function renderMatch(match, gridLocalization) {
	            return _react2.default.createElement(_PopularMatch2.default, { key: match.get('id'), match: match, gridLocalization: gridLocalization });
	        }
	    }]);
	    return Popular;
	}(_react2.default.Component);
	
	Popular.propTypes = {
	    matches: _react2.default.PropTypes.object,
	    gridLocalization: _react2.default.PropTypes.object.isRequired
	};
	
	
	function select(state) {
	    var matches = state.application.getIn(['popularMatches', 'matches']);
	
	    return {
	        matches: matches
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select)(Popular);

/***/ },
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ScoreType = __webpack_require__(40);
	
	var ScoreType = _interopRequireWildcard(_ScoreType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdditionalScore = function (_React$Component) {
	    (0, _inherits3.default)(AdditionalScore, _React$Component);
	
	    function AdditionalScore() {
	        (0, _classCallCheck3.default)(this, AdditionalScore);
	        return (0, _possibleConstructorReturn3.default)(this, (AdditionalScore.__proto__ || (0, _getPrototypeOf2.default)(AdditionalScore)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(AdditionalScore, [{
	        key: 'render',
	        value: function render() {
	            var score = this.props.score;
	
	            if (score === undefined || score.get('score1') === null || score.get('score2') === null) {
	                return null;
	            }
	
	            var scoreType = score.get('type');
	
	            if (scoreType === ScoreType.CurrentGame) {
	                return AdditionalScore.renderTennisGameScore(score);
	            }
	
	            return AdditionalScore.renderRegularScore(score);
	        }
	    }], [{
	        key: 'renderRegularScore',
	        value: function renderRegularScore(score) {
	            var scoreId = score.get('id');
	
	            var score1 = score.get('score1');
	            var score2 = score.get('score2');
	
	            if (score1 > score2) {
	                return _react2.default.createElement(
	                    'span',
	                    { key: scoreId, className: 'additional' },
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        score1
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        ':' + score2
	                    )
	                );
	            }
	            if (score1 < score2) {
	                return _react2.default.createElement(
	                    'span',
	                    { key: scoreId, className: 'additional' },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        score1 + ':'
	                    ),
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        score2
	                    )
	                );
	            }
	
	            return _react2.default.createElement(
	                'span',
	                { key: scoreId, className: 'additional' },
	                score1 + ':' + score2
	            );
	        }
	    }, {
	        key: 'renderTennisGameScore',
	        value: function renderTennisGameScore(score) {
	            var scoreId = score.get('id');
	
	            var team = score.get('team');
	            var score1 = score.get('score1');
	            var score2 = score.get('score2');
	
	            score1 = score1 === 100 ? 'A' : score1;
	            score2 = score2 === 100 ? 'A' : score2;
	
	            var result = score1 + ':' + score2;
	
	            if (team !== null) {
	
	                if (team === 1) {
	                    result = '*' + result;
	                } else if (team === 2) {
	                    result = result + '*';
	                }
	            }
	
	            return _react2.default.createElement(
	                'span',
	                { key: scoreId, className: 'additional' },
	                result
	            );
	        }
	    }]);
	    return AdditionalScore;
	}(_react2.default.Component);
	
	AdditionalScore.propTypes = {
	    score: _react2.default.PropTypes.object
	};
	exports.default = AdditionalScore;

/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdditionalScores = function (_React$Component) {
	    (0, _inherits3.default)(AdditionalScores, _React$Component);
	
	    function AdditionalScores() {
	        (0, _classCallCheck3.default)(this, AdditionalScores);
	        return (0, _possibleConstructorReturn3.default)(this, (AdditionalScores.__proto__ || (0, _getPrototypeOf2.default)(AdditionalScores)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(AdditionalScores, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var additionalScores = this.props.additionalScores;
	
	
	            if (additionalScores === undefined || additionalScores.length === 0) {
	                return false;
	            }
	
	            return _react2.default.createElement(
	                'span',
	                { className: 'score-full' },
	                additionalScores.map(function (s) {
	                    return AdditionalScores.renderAdditionalScore(s, _this2.props);
	                })
	            );
	        }
	    }], [{
	        key: 'renderAdditionalScore',
	        value: function renderAdditionalScore(scoreId, props) {
	            var scoreProps = {
	                scoreId: scoreId
	            };
	
	            var Comp = props.additionalScoreElement;
	
	            return _react2.default.createElement(Comp, (0, _extends3.default)({ key: scoreId }, scoreProps));
	        }
	    }]);
	    return AdditionalScores;
	}(_react2.default.Component);
	
	AdditionalScores.propTypes = {
	    additionalScores: _react.PropTypes.arrayOf(_react.PropTypes.number),
	    scores: _react.PropTypes.instanceOf(_immutable.Map),
	    additionalScoreElement: _react.PropTypes.func.isRequired
	};
	exports.default = AdditionalScores;

/***/ },
/* 1323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainScore = function (_React$Component) {
	    (0, _inherits3.default)(MainScore, _React$Component);
	
	    function MainScore() {
	        (0, _classCallCheck3.default)(this, MainScore);
	        return (0, _possibleConstructorReturn3.default)(this, (MainScore.__proto__ || (0, _getPrototypeOf2.default)(MainScore)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(MainScore, [{
	        key: 'render',
	        value: function render() {
	            var score = this.props.score;
	
	            if (score === undefined) {
	                return false;
	            }
	
	            var score1 = score.get('score1') || 0;
	            var score2 = score.get('score2') || 0;
	
	            return _react2.default.createElement(
	                'span',
	                { className: 'score' },
	                score1 + ':' + score2
	            );
	        }
	    }]);
	    return MainScore;
	}(_react2.default.Component);
	
	MainScore.propTypes = {
	    score: _react2.default.PropTypes.object
	};
	exports.default = MainScore;

/***/ },
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FavouriteState = __webpack_require__(79);
	
	var FavouriteState = _interopRequireWildcard(_FavouriteState);
	
	var _DisplayMode = __webpack_require__(78);
	
	var DisplayMode = _interopRequireWildcard(_DisplayMode);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Match = function (_React$Component) {
	    (0, _inherits3.default)(Match, _React$Component);
	
	    function Match(props) {
	        (0, _classCallCheck3.default)(this, Match);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Match.__proto__ || (0, _getPrototypeOf2.default)(Match)).call(this, props));
	
	        _this._onFavouriteClick = _this._onFavouriteClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(Match, [{
	        key: '_onMatchClick',
	        value: function _onMatchClick(id, e) {
	            e.preventDefault();
	            this.props.matchClickCallback(id);
	        }
	    }, {
	        key: '_onFavouriteClick',
	        value: function _onFavouriteClick(e) {
	            e.preventDefault();
	            e.stopPropagation();
	
	            this.props.matchFavouriteClickCallback(this.props.match);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                match = _props.match,
	                scores = _props.scores,
	                displayMode = _props.displayMode;
	
	
	            if (match === undefined) {
	                return false;
	            }
	
	            var matchId = match.get('id');
	            var notice = match.get('notice') || null;
	
	            var name = match.get('name');
	            if (notice !== null) {
	                name = name + ' (' + notice + ')';
	            }
	
	            var isSelected = displayMode.type === DisplayMode.MATCH && displayMode.id === matchId;
	            var cls = 'event' + (isSelected ? ' selected' : '');
	
	            var favouritesCls = 'favourites';
	
	            if (match.get('favouriteState') === FavouriteState.FULL) {
	                favouritesCls += ' added';
	            }
	
	            var boundMatchClick = this._onMatchClick.bind(this, matchId);
	
	            var matchScores = match.get('scores').map(function (id) {
	                return scores.get(id);
	            }).filter(function (s) {
	                return s.get('score1') !== null && s.get('score1') !== undefined && s.get('score2') !== null && s.get('score2') !== undefined;
	            }).toMap();
	
	            return _react2.default.createElement(
	                'li',
	                { className: cls, onClick: boundMatchClick },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'event-title' },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'event-name', title: name },
	                        name
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#', className: favouritesCls, onClick: this._onFavouriteClick },
	                        '\xA0'
	                    )
	                ),
	                matchScores && matchScores.size > 0 && Match.renderMatchScores(match, matchScores, this.props)
	            );
	        }
	    }], [{
	        key: 'renderMatchScores',
	        value: function renderMatchScores(match, matchScores, props) {
	            var matchStatsProps = {
	                match: match,
	                matchScores: matchScores,
	                mainScoreElement: props.mainScoreElement,
	                additionalScoresElement: props.additionalScoresElement,
	                additionalScoreElement: props.additionalScoreElement
	            };
	
	            var MatchStatsElement = props.matchStatsElement;
	
	            return _react2.default.createElement(MatchStatsElement, matchStatsProps);
	        }
	    }]);
	    return Match;
	}(_react2.default.Component);
	
	Match.propTypes = {
	    match: _react2.default.PropTypes.object,
	    scores: _react2.default.PropTypes.object,
	    displayMode: _react2.default.PropTypes.object.isRequired,
	    matchStatsElement: _react2.default.PropTypes.func.isRequired,
	    matchClickCallback: _react2.default.PropTypes.func.isRequired,
	    matchFavouriteClickCallback: _react2.default.PropTypes.func
	};
	exports.default = Match;

/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MatchScoresAdapter = __webpack_require__(1326);
	
	var _MatchScoresAdapter2 = _interopRequireDefault(_MatchScoresAdapter);
	
	var _MatchScoresAdapter3 = __webpack_require__(768);
	
	var MainScoreAdapter = _interopRequireWildcard(_MatchScoresAdapter3);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchStats = function (_React$Component) {
	    (0, _inherits3.default)(MatchStats, _React$Component);
	
	    function MatchStats() {
	        (0, _classCallCheck3.default)(this, MatchStats);
	        return (0, _possibleConstructorReturn3.default)(this, (MatchStats.__proto__ || (0, _getPrototypeOf2.default)(MatchStats)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(MatchStats, [{
	        key: 'render',
	        value: function render() {
	            var match = this.props.match;
	            var scores = this.props.matchScores;
	
	            if (match === undefined) {
	                return false;
	            }
	
	            var sportId = match.get('realSportId');
	
	            var mainScoreId = MainScoreAdapter.getMainScore(scores);
	            var additionalScores = _MatchScoresAdapter2.default.getAdditionalScores(sportId, scores);
	
	            if (mainScoreId === null && additionalScores.length === 0) {
	                return false;
	            }
	
	            if (mainScoreId === null) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'event-stats' },
	                    MatchStats.renderAdditionalScores(additionalScores, this.props)
	                );
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'event-stats' },
	                MatchStats.renderMainScore(mainScoreId, this.props),
	                MatchStats.renderAdditionalScores(additionalScores, this.props)
	            );
	        }
	    }], [{
	        key: 'renderAdditionalScores',
	        value: function renderAdditionalScores(additionalScores, props) {
	            var scoreProps = {
	                additionalScores: additionalScores,
	                additionalScoreElement: props.additionalScoreElement
	            };
	
	            var AdditionalScoresElement = props.additionalScoresElement;
	
	            return _react2.default.createElement(AdditionalScoresElement, scoreProps);
	        }
	    }, {
	        key: 'renderMainScore',
	        value: function renderMainScore(scoreId, props) {
	            var scoreProps = {
	                scoreId: scoreId
	            };
	
	            var MainScoreElement = props.mainScoreElement;
	
	            return _react2.default.createElement(MainScoreElement, (0, _extends3.default)({ key: scoreId }, scoreProps));
	        }
	    }]);
	    return MatchStats;
	}(_react2.default.Component);
	
	MatchStats.propTypes = {
	    match: _react2.default.PropTypes.object,
	    matchScores: _react2.default.PropTypes.object,
	    mainScoreElement: _react2.default.PropTypes.func.isRequired,
	    additionalScoresElement: _react2.default.PropTypes.func.isRequired
	};
	exports.default = MatchStats;

/***/ },
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _SportType = __webpack_require__(89);
	
	var SportType = _interopRequireWildcard(_SportType);
	
	var _ScoreType = __webpack_require__(40);
	
	var ScoreType = _interopRequireWildcard(_ScoreType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GENERIC_TWO_PERIODS = {
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod]
	};
	var GENERIC_THREE_PERIODS = {
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod]
	};
	var GENERIC_FOUR_PERIODS = {
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod]
	};
	var GENERIC_FIVE_PERIODS = {
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod, ScoreType.FifthPeriod]
	};
	var GENERIC_SEVEN_PERIODS = {
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod, ScoreType.FifthPeriod, ScoreType.SixthPeriod, ScoreType.SeventhPeriod]
	};
	var TENNIS = {
	    additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod, ScoreType.FifthPeriod, ScoreType.CurrentGame]
	};
	
	var statsPresentation = {};
	
	statsPresentation[SportType.TABLE_TENNIS] = GENERIC_SEVEN_PERIODS;
	statsPresentation[SportType.VOLLEYBALL] = GENERIC_FIVE_PERIODS;
	statsPresentation[SportType.BEACH_VOLLEYBAL] = GENERIC_THREE_PERIODS;
	statsPresentation[SportType.FOOTBALL] = GENERIC_TWO_PERIODS;
	statsPresentation[SportType.BEACH_FOOTBALL] = GENERIC_THREE_PERIODS;
	statsPresentation[SportType.HANDBALL] = GENERIC_TWO_PERIODS;
	statsPresentation[SportType.ICE_HOCKEY] = GENERIC_THREE_PERIODS;
	statsPresentation[SportType.BASKETBALL] = GENERIC_FOUR_PERIODS;
	statsPresentation[SportType.BADMINTON] = GENERIC_THREE_PERIODS;
	statsPresentation[SportType.FUTSAL] = GENERIC_THREE_PERIODS;
	statsPresentation[SportType.BASKETBALL_NCAA] = GENERIC_TWO_PERIODS;
	statsPresentation[SportType.TENNIS] = TENNIS;
	
	var MatchScoresAdapter = function () {
	    function MatchScoresAdapter() {
	        (0, _classCallCheck3.default)(this, MatchScoresAdapter);
	    }
	
	    (0, _createClass3.default)(MatchScoresAdapter, null, [{
	        key: 'getAdditionalScores',
	        value: function getAdditionalScores(sportId, scores) {
	            var result = [];
	
	            if (!statsPresentation.hasOwnProperty(sportId)) {
	                return result;
	            }
	
	            var map = statsPresentation[sportId];
	
	            if (!map.hasOwnProperty('additional')) {
	                return result;
	            }
	
	            for (var i = 0; i < map.additional.length; i++) {
	                var type = map.additional[i];
	
	                var score = scores.getIn([type]);
	                if (score && score.get('score1') !== null && score.get('score1') !== undefined && score.get('score2') !== null && score.get('score2') !== undefined) {
	                    result[i] = score.get('id');
	                }
	            }
	
	            return result;
	        }
	    }]);
	    return MatchScoresAdapter;
	}();
	
	exports.default = MatchScoresAdapter;

/***/ },
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _reactRedux = __webpack_require__(9);
	
	var _AdditionalScore = __webpack_require__(1321);
	
	var _AdditionalScore2 = _interopRequireDefault(_AdditionalScore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function select(state, props) {
	    var score = state.application.getIn(['live', 'scores', props.scoreId]);
	
	    return (0, _extends3.default)({}, props, {
	        score: score
	    });
	}
	
	exports.default = (0, _reactRedux.connect)(select)(_AdditionalScore2.default);

/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _reactRedux = __webpack_require__(9);
	
	var _AdditionalScores = __webpack_require__(1322);
	
	var _AdditionalScores2 = _interopRequireDefault(_AdditionalScores);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function select(state, props) {
	    var additionalScores = props.additionalScores;
	    var scores = state.application.getIn(['live', 'scores']);
	
	    return (0, _extends3.default)({}, props, {
	        additionalScores: additionalScores,
	        scores: scores
	    });
	}
	
	exports.default = (0, _reactRedux.connect)(select)(_AdditionalScores2.default);

/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _reactRedux = __webpack_require__(9);
	
	var _League = __webpack_require__(796);
	
	var _League2 = _interopRequireDefault(_League);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function select(state, props) {
	    var league = state.application.getIn(['live', 'leagues', props.leagueId]);
	    var matches = state.application.getIn(['live', 'matches']);
	
	    return (0, _extends3.default)({}, props, {
	        league: league,
	        matches: matches
	    });
	}
	
	exports.default = (0, _reactRedux.connect)(select, null, null, false)(_League2.default);

/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _reactRedux = __webpack_require__(9);
	
	var _MainScore = __webpack_require__(1323);
	
	var _MainScore2 = _interopRequireDefault(_MainScore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function select(state, props) {
	    var score = state.application.getIn(['live', 'scores', props.scoreId]);
	
	    return (0, _extends3.default)({}, props, {
	        score: score
	    });
	}
	
	exports.default = (0, _reactRedux.connect)(select)(_MainScore2.default);

/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _reactRedux = __webpack_require__(9);
	
	var _Match = __webpack_require__(1324);
	
	var _Match2 = _interopRequireDefault(_Match);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function select(state, props) {
	    var match = state.application.getIn(['live', 'matches', props.matchId]);
	    var scores = state.application.getIn(['live', 'scores']);
	    var displayMode = state.application.get('displayMode');
	
	    return (0, _extends3.default)({}, props, {
	        displayMode: displayMode,
	        match: match,
	        scores: scores
	    });
	}
	
	exports.default = (0, _reactRedux.connect)(select)(_Match2.default, null, null, false);

/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _reactRedux = __webpack_require__(9);
	
	var _MatchStats = __webpack_require__(1325);
	
	var _MatchStats2 = _interopRequireDefault(_MatchStats);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function select(state, props) {
	    return (0, _extends3.default)({}, props);
	}
	
	exports.default = (0, _reactRedux.connect)(select)(_MatchStats2.default);

/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _reactRedux = __webpack_require__(9);
	
	var _Menu = __webpack_require__(797);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function select(state, props) {
	    var sports = state.application.getIn(['live', 'sports']);
	    var displayMode = state.application.get('displayMode');
	
	    return (0, _extends3.default)({}, props, {
	        sports: sports,
	        displayMode: displayMode,
	        user: state.auth.get('user'),
	        countryCode: state.application.get('countryCode')
	    });
	}
	
	exports.default = (0, _reactRedux.connect)(select)(_Menu2.default);

/***/ },
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _reactRedux = __webpack_require__(9);
	
	var _Sport = __webpack_require__(798);
	
	var _Sport2 = _interopRequireDefault(_Sport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function select(state, props) {
	    var sport = state.application.getIn(['live', 'sports', props.sportId]);
	    var leagues = state.application.getIn(['live', 'leagues']);
	    var displayMode = state.application.get('displayMode');
	
	    return (0, _extends3.default)({}, props, {
	        displayMode: displayMode,
	        sport: sport,
	        leagues: leagues
	    });
	}
	
	exports.default = (0, _reactRedux.connect)(select, null, null, false)(_Sport2.default);

/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _reactRedux = __webpack_require__(9);
	
	var _Sports = __webpack_require__(799);
	
	var _Sports2 = _interopRequireDefault(_Sports);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function select(state, props) {
	    return (0, _extends3.default)({}, props, {
	        isLive: true
	    });
	}
	
	exports.default = (0, _reactRedux.connect)(select, null, null, false)(_Sports2.default);

/***/ },
/* 1336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MenuElements = undefined;
	
	var _Menu = __webpack_require__(1333);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Sports = __webpack_require__(1335);
	
	var _Sports2 = _interopRequireDefault(_Sports);
	
	var _Sport = __webpack_require__(1334);
	
	var _Sport2 = _interopRequireDefault(_Sport);
	
	var _League = __webpack_require__(1329);
	
	var _League2 = _interopRequireDefault(_League);
	
	var _Match = __webpack_require__(1331);
	
	var _Match2 = _interopRequireDefault(_Match);
	
	var _MatchStats = __webpack_require__(1332);
	
	var _MatchStats2 = _interopRequireDefault(_MatchStats);
	
	var _MainScore = __webpack_require__(1330);
	
	var _MainScore2 = _interopRequireDefault(_MainScore);
	
	var _AdditionalScores = __webpack_require__(1328);
	
	var _AdditionalScores2 = _interopRequireDefault(_AdditionalScores);
	
	var _AdditionalScore = __webpack_require__(1327);
	
	var _AdditionalScore2 = _interopRequireDefault(_AdditionalScore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MenuElements = exports.MenuElements = {
	    sportsElement: _Sports2.default,
	    sportElement: _Sport2.default,
	    leagueElement: _League2.default,
	    matchElement: _Match2.default,
	    matchStatsElement: _MatchStats2.default,
	    mainScoreElement: _MainScore2.default,
	    additionalScoresElement: _AdditionalScores2.default,
	    additionalScoreElement: _AdditionalScore2.default
	};
	
	exports.default = _Menu2.default;

/***/ },
/* 1337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(162);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _regenerator = __webpack_require__(82);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _toConsumableArray2 = __webpack_require__(308);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _asyncToGenerator2 = __webpack_require__(97);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(25);
	
	var _reactRedux = __webpack_require__(9);
	
	var _gameUtils = __webpack_require__(343);
	
	var _SignIn = __webpack_require__(342);
	
	var _SignIn2 = _interopRequireDefault(_SignIn);
	
	var _reactIntl = __webpack_require__(8);
	
	var _messages = __webpack_require__(344);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AllGamesPage = function (_Component) {
	  (0, _inherits3.default)(AllGamesPage, _Component);
	
	  function AllGamesPage(props) {
	    var _this2 = this;
	
	    (0, _classCallCheck3.default)(this, AllGamesPage);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AllGamesPage.__proto__ || (0, _getPrototypeOf2.default)(AllGamesPage)).call(this, props));
	
	    _this.handleLoadMoreGames = function () {
	      _this.setState(function (prevState) {
	        var newPage = prevState.page + 1;
	        _this.fetchAllGames(newPage, true);
	        return { page: newPage };
	      });
	    };
	
	    _this.fetchAllGames = function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	        var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	        var append = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        var _this$state, limit, games, offset, response, data, newGames;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$state = _this.state, limit = _this$state.limit, games = _this$state.games;
	
	                _this.setState({ isLoading: true });
	
	                _context.prev = 2;
	                offset = (page - 1) * limit;
	                _context.next = 6;
	                return fetch('/api/games/all-games?limit=' + limit + '&offset=' + offset);
	
	              case 6:
	                response = _context.sent;
	                _context.next = 9;
	                return response.json();
	
	              case 9:
	                data = _context.sent;
	                newGames = data.Items.filter(function (newGame) {
	                  return !games.some(function (existingGame) {
	                    return existingGame.Id === newGame.Id;
	                  });
	                });
	
	
	                _this.setState(function (prevState) {
	                  return {
	                    games: append ? [].concat((0, _toConsumableArray3.default)(prevState.games), (0, _toConsumableArray3.default)(newGames)) : newGames,
	                    isLoading: false,
	                    hasMoreGames: newGames.length === limit
	                  };
	                });
	                _context.next = 18;
	                break;
	
	              case 14:
	                _context.prev = 14;
	                _context.t0 = _context['catch'](2);
	
	                console.error('Failed to fetch games by category:', _context.t0);
	                _this.setState({ isLoading: false });
	
	              case 18:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2, [[2, 14]]);
	      }));
	
	      return function () {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.openAuthModal = function () {
	      var user = _this.props.user;
	
	      if (user) {
	        alert('Игра не доступна');
	      } else {
	        _this.props.dispatch({ type: 'BEGIN_SIGNIN' });
	      }
	    };
	
	    _this.handleGameClickWrapper = function (gameId) {
	      var user = _this.props.user;
	
	      _this.setState({ isLoading: true });
	      (0, _gameUtils.handleGameClick)(gameId, user, function (loading) {
	        return _this.setState({ isLoading: loading });
	      }, function (errorCode) {
	        return (0, _gameUtils.handleErrorCode)(errorCode, _gameUtils.showErrorMessage, function () {
	          return _this.openAuthModal();
	        });
	      });
	    };
	
	    _this.saveFavoriteGamesToStorage = function (favoriteGames) {
	      localStorage.setItem('favoriteGames', (0, _stringify2.default)(favoriteGames));
	    };
	
	    _this.getFavoriteGamesFromStorage = function () {
	      try {
	        var favorites = localStorage.getItem('favoriteGames');
	        return favorites ? JSON.parse(favorites) : [];
	      } catch (error) {
	        console.error('Failed to parse favorite games from localStorage:', error);
	        return [];
	      }
	    };
	
	    _this.addGameToFavorites = function (gameId) {
	      var _this$state2 = _this.state,
	          favoriteGames = _this$state2.favoriteGames,
	          games = _this$state2.games;
	
	      var gameToAdd = games.find(function (game) {
	        return game.Id === gameId;
	      });
	      var updatedFavorites = [].concat((0, _toConsumableArray3.default)(favoriteGames), [gameToAdd]);
	      _this.setState({ favoriteGames: updatedFavorites }, function () {
	        _this.saveFavoriteGamesToStorage(updatedFavorites);
	      });
	    };
	
	    _this.removeGameFromFavorites = function (gameId) {
	      var updatedFavorites = _this.state.favoriteGames.filter(function (game) {
	        return game.Id !== gameId;
	      });
	      _this.setState({ favoriteGames: updatedFavorites }, function () {
	        _this.saveFavoriteGamesToStorage(updatedFavorites);
	      });
	    };
	
	    _this.pinGame = function () {
	      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(gameId) {
	        var user, gamblerId, response;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                user = _this.props.user;
	
	                if (user) {
	                  _context2.next = 4;
	                  break;
	                }
	
	                alert('Зарегистрируйтесь для того чтобы добавить в избранные');
	                return _context2.abrupt('return');
	
	              case 4:
	                gamblerId = user.get('gamblerId');
	
	                if (!(gamblerId === null)) {
	                  _context2.next = 8;
	                  break;
	                }
	
	                alert('Зарегистрируйтесь для того чтобы добавить в избранные');
	                return _context2.abrupt('return');
	
	              case 8:
	                _context2.prev = 8;
	                _context2.next = 11;
	                return fetch('/api/games/pin/' + gameId, {
	                  method: 'POST',
	                  headers: { 'Content-Type': 'application/json' },
	                  body: (0, _stringify2.default)({ gamblerId: gamblerId })
	                });
	
	              case 11:
	                response = _context2.sent;
	
	
	                if (response.status === 200) {
	                  _this.addGameToFavorites(gameId);
	                } else {
	                  _this.removeGameFromFavorites(gameId);
	                }
	                _context2.next = 18;
	                break;
	
	              case 15:
	                _context2.prev = 15;
	                _context2.t0 = _context2['catch'](8);
	
	                console.error('Error pinning the game:', _context2.t0);
	
	              case 18:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2, [[8, 15]]);
	      }));
	
	      return function (_x3) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.unpinGame = function () {
	      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(gameId) {
	        var user, gamblerId, response;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                user = _this.props.user;
	
	                if (user) {
	                  _context3.next = 4;
	                  break;
	                }
	
	                alert('Зарегистрируйтесь для того чтобы удалить из избранных');
	                return _context3.abrupt('return');
	
	              case 4:
	                gamblerId = user.get('gamblerId');
	
	                if (!(gamblerId === null)) {
	                  _context3.next = 8;
	                  break;
	                }
	
	                alert('Зарегистрируйтесь для того чтобы удалить из избранных');
	                return _context3.abrupt('return');
	
	              case 8:
	                _context3.prev = 8;
	                _context3.next = 11;
	                return fetch('/api/games/un-pin/' + gameId, {
	                  method: 'POST',
	                  headers: { 'Content-Type': 'application/json' },
	                  body: (0, _stringify2.default)({ gamblerId: gamblerId })
	                });
	
	              case 11:
	                response = _context3.sent;
	
	
	                if (response.status === 200) {
	                  _this.removeGameFromFavorites(gameId);
	                } else {
	                  console.error('Failed to unpin the game');
	                }
	                _context3.next = 18;
	                break;
	
	              case 15:
	                _context3.prev = 15;
	                _context3.t0 = _context3['catch'](8);
	
	                console.error('Error unpinning the game:', _context3.t0);
	
	              case 18:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2, [[8, 15]]);
	      }));
	
	      return function (_x4) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      games: [],
	      isLoading: true,
	      showSignIn: false,
	      favoriteGames: _this.getFavoriteGamesFromStorage() || [],
	      page: 1,
	      limit: 24,
	      hasMoreGames: true
	    };
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(AllGamesPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchAllGames(this.state.page);
	      window.addEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _this3 = this;
	
	      var categoryId = this.props.params.categoryId;
	
	      if (prevProps.params.categoryId !== categoryId) {
	        this.setState({ category: categoryId, page: 1, games: [], hasMoreGames: true }, function () {
	          _this3.fetchAllGames(1);
	        });
	      }
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll() {
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          hasMoreGames = _state.hasMoreGames;
	
	      if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 50 && !isLoading && hasMoreGames) {
	        this.handleLoadMoreGames();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state2 = this.state,
	          games = _state2.games,
	          isLoading = _state2.isLoading,
	          showSignIn = _state2.showSignIn,
	          hasMoreGames = _state2.hasMoreGames;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'game-types-page' },
	        showSignIn && _react2.default.createElement(_SignIn2.default, null),
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/games' },
	          _react2.default.createElement(
	            'button',
	            { className: 'view-all-button' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, _messages.messages.goBackToGames)
	          )
	        ),
	        _react2.default.createElement(
	          'h1',
	          { className: 'page-title' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, _messages.messages.allGames)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'game-list' },
	          games.length > 0 ? games.map(function (game) {
	            return (0, _gameUtils.renderGame)(game, _this4.handleGameClickWrapper, _this4.state.favoriteGames, _this4.pinGame, _this4.unpinGame);
	          }) : _react2.default.createElement(
	            'div',
	            { className: 'no-games-message' },
	            '\u041D\u0435\u0442 \u0438\u0433\u0440'
	          )
	        ),
	        isLoading && _react2.default.createElement(
	          'div',
	          null,
	          'Loading...'
	        ),
	        _react2.default.createElement('br', null),
	        games.length > 0 && hasMoreGames && !isLoading && _react2.default.createElement(
	          'button',
	          { className: 'showAll', onClick: this.handleLoadMoreGames },
	          _react2.default.createElement(_reactIntl.FormattedMessage, _messages.messages.showMore)
	        )
	      );
	    }
	  }]);
	  return AllGamesPage;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state, dispatch) {
	  return {
	    user: state.auth.get('user'),
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(AllGamesPage));

/***/ },
/* 1338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouterRedux = __webpack_require__(23);
	
	var _reactIntl = __webpack_require__(8);
	
	var _BetGames = __webpack_require__(1204);
	
	var _BetGames2 = _interopRequireDefault(_BetGames);
	
	var _UnauthedBetGames = __webpack_require__(1207);
	
	var _UnauthedBetGames2 = _interopRequireDefault(_UnauthedBetGames);
	
	var _creators = __webpack_require__(731);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    disclaimer1: {
	        id: 'betgames.disclaimer1',
	        defaultMessage: 'Ставки на BetGamesTV основаны только на предстоящих реальных событиях. Данный вид ставок не является онлайн-казино, поскольку не относится к предусмотренному Законом «Об игорном бизнесе» понятию «азартной игры».'
	    },
	    disclaimer2: {
	        id: 'betgames.disclaimer2',
	        defaultMessage: 'БК «Fair Play» не организовывает данный вид событий и не участвует в них, равно как и участники пари (игроки). Организатором данного вида реальных событий является компания «TV ZAIDIMAI». События транслируются в режиме реального времени и не зависят от Букмекера или участников пари (игроков). Результаты событий формируются организатором независимо от БК «Fair Play» и публикуются на его официальном сайте.'
	    }
	});
	
	var BironexPage = function (_React$Component) {
	    (0, _inherits3.default)(BironexPage, _React$Component);
	
	    function BironexPage() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, BironexPage);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BironexPage.__proto__ || (0, _getPrototypeOf2.default)(BironexPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            showBetgames: false
	        }, _this.onSubmit = function (event) {
	            _this.setState({ showBetgames: true });
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(BironexPage, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            if (this.props.user && this.props.betGames.get('token') === undefined && this.props.countryCode === 'KG') {
	                this.props.getTokenAction();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.user !== nextProps.user && nextProps.user && nextProps.betGames.get('token') === undefined && nextProps.betGames.get('fetching') === false && this.props.countryCode === 'KG') {
	                this.props.getTokenAction();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                user = _props.user,
	                betGames = _props.betGames;
	
	
	            if (this.props.countryCode !== 'KG') {
	                return false;
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'betgames', id: 'betgames-wrapper' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'betgames__disclaimer' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.disclaimer1)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.disclaimer2)
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'betgames__initial', hidden: this.state.showBetgames },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '\u0422\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0440\u0430\u0431\u043E\u0442\u044B \u0434\u043E 09.03.2020, \u043F\u0440\u0438\u043D\u043E\u0441\u0438\u043C \u0438\u0437\u0432\u0438\u043D\u0435\u043D\u0438\u044F \u0437\u0430 \u043D\u0435\u0443\u0434\u043E\u0431\u0441\u0442\u0432\u0430.'
	                    )
	                ),
	                user && betGames.get('token') !== undefined && this.state.showBetgames == true && _react2.default.createElement(_BetGames2.default, { betGames: betGames }),
	                user === null && betGames.get('token') === undefined && this.state.showBetgames == true && _react2.default.createElement(_UnauthedBetGames2.default, { betGames: betGames }),
	                this.context.footer
	            );
	        }
	    }]);
	    return BironexPage;
	}(_react2.default.Component);
	
	BironexPage.contextTypes = {
	    footer: _react2.default.PropTypes.object
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        user: state.auth.get('user'),
	        countryCode: state.application.get('countryCode'),
	        betGames: state.betGames
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { getTokenAction: _creators.getToken, push: _reactRouterRedux.push })(BironexPage);

/***/ },
/* 1339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouterRedux = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BironexPage = function (_React$Component) {
	    (0, _inherits3.default)(BironexPage, _React$Component);
	
	    function BironexPage() {
	        (0, _classCallCheck3.default)(this, BironexPage);
	        return (0, _possibleConstructorReturn3.default)(this, (BironexPage.__proto__ || (0, _getPrototypeOf2.default)(BironexPage)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(BironexPage, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (!this.props.user && this.props.countryCode !== 'KG' || this.props.user && this.props.user.get('resourceId') !== 1) {
	                this.props.push('/');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'bironex-modal' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'bironex-modal__block bironex-modal__block--top' },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '\u041F\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u0431\u0430\u043B\u0430\u043D\u0441 \u0438 \u043E\u0431\u043D\u0430\u043B\u0438\u0447\u0438\u0442\u044C \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430 \u0432 \u0432\u0430\u0448\u0435\u043C \u0440\u0435\u0433\u0438\u043E\u043D\u0435 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0431\u0435\u0437 \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0438 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u043A\u0440\u0438\u043F\u0442\u043E\u0432\u0430\u043B\u044E\u0442\u044B \xABOpex\xBB \u0432 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430\u0445 \xABPay24\xBB \u0438 \xABBironex\xBB. \u041E\u0431\u043C\u0435\u043D\u043D\u044B\u0439 \u043A\u0443\u0440\u0441: 1 OPX = 1 \u0423.\u0415.'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u043E\u0441\u0442\u0438 \u0438 \u0430\u0434\u0440\u0435\u0441\u0430 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u043E\u0432 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u043D\u0430 ',
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'http://bironex.com/', target: '_blank' },
	                                'bironex.com'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'bironex-modal__block' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'bironex-modal__block__title' },
	                            '\u041A\u0430\u043A \u043F\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u044C'
	                        ),
	                        _react2.default.createElement('iframe', { width: '760', height: '425', src: 'https://www.youtube.com/embed/IiU8luXXqVg', frameBorder: '0', allowFullScreen: true })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'bironex-modal__block' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'bironex-modal__block__title' },
	                            '\u041A\u0430\u043A \u043E\u0431\u043D\u0430\u043B\u0438\u0447\u0438\u0442\u044C'
	                        ),
	                        _react2.default.createElement('iframe', { width: '760', height: '425', src: 'https://www.youtube.com/embed/Qs4jonzXyYI', frameBorder: '0', allowFullScreen: true })
	                    )
	                ),
	                this.context.footer
	            );
	        }
	    }]);
	    return BironexPage;
	}(_react2.default.Component);
	
	BironexPage.contextTypes = {
	    footer: _react2.default.PropTypes.object
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        user: state.auth.get('user'),
	        countryCode: state.application.get('countryCode')
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { push: _reactRouterRedux.push })(BironexPage);

/***/ },
/* 1340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(82);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(97);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _axios = __webpack_require__(146);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _withVerifyCheck = __webpack_require__(1168);
	
	var _withVerifyCheck2 = _interopRequireDefault(_withVerifyCheck);
	
	var _Auth = __webpack_require__(95);
	
	var _Language = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Cybersport = function (_Component) {
	  (0, _inherits3.default)(Cybersport, _Component);
	
	  function Cybersport() {
	    var _ref,
	        _this2 = this;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Cybersport);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Cybersport.__proto__ || (0, _getPrototypeOf2.default)(Cybersport)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isLoading: false,
	      token: null
	    }, _this.componentDidMount = function () {
	      _this.fetchToken();
	      _this.hideJivo();
	    }, _this.componentDidUpdate = function (prevProps) {
	      if (prevProps.locale !== _this.props.locale || prevProps.gamblerId !== _this.props.gamblerId) {
	        _this.fetchToken();
	      }
	      if (prevProps.gamblerId !== _this.props.gamblerId && !_this.props.gamblerId) {
	        _this.props.beginSignInAction();
	        _this.props.router.push('/');
	      }
	    }, _this.componentWillUnmount = function () {
	      _this.unHideJivo();
	    }, _this.hideJivo = function () {
	      try {
	        var styles = '\n        jdiv { \n          display: none!important;\n        }\n      ';
	        var styleSheet = document.createElement('style');
	        styleSheet.id = 'jdiv-id-key';
	        styleSheet.innerText = styles;
	        document.head.appendChild(styleSheet);
	      } catch (err) {
	        console.log(err);
	      }
	    }, _this.unHideJivo = function () {
	      try {
	        document.getElementById('jdiv-id-key').remove();
	      } catch (err) {
	        console.log(err);
	      }
	    }, _this.fetchToken = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var _ref3, _ref3$data, data;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	
	              _this.setState({ isLoading: true });
	              _context.next = 4;
	              return (0, _axios2.default)({
	                url: '/api/games-databet/'
	              });
	
	            case 4:
	              _ref3 = _context.sent;
	              _ref3$data = _ref3.data;
	              data = _ref3$data === undefined ? {} : _ref3$data;
	
	              if (data.token) {
	                _this.setState({
	                  token: data.token
	                });
	              }
	              _context.next = 13;
	              break;
	
	            case 10:
	              _context.prev = 10;
	              _context.t0 = _context['catch'](0);
	
	              console.error(_context.t0);
	
	            case 13:
	
	              _this.setState({ isLoading: false });
	
	            case 14:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[0, 10]]);
	    })), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Cybersport, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          token = _state.token;
	      var _props = this.props,
	          locale = _props.locale,
	          isVerified = _props.isVerified;
	
	
	      var urlLocale = locale === 'kk' ? 'ru' : locale;
	
	      if (isLoading) return _react2.default.createElement(_Loader2.default, null);
	
	      return _react2.default.createElement('iframe', {
	        style: {
	          position: 'fixed',
	          top: 75,
	          left: 8,
	          right: 8,
	          bottom: 8,
	          width: 'calc(100vw - 16px)',
	          height: 'calc(100vh - 83px)'
	        }
	        // scrolling="no"
	        , frameBorder: '0',
	        sandbox: 'allow-scripts allow-same-origin',
	        allowFullScreen: true,
	        src: '/databet.html?locale=' + (urlLocale || '') + '&token=' + (token || '')
	      });
	    }
	  }]);
	  return Cybersport;
	}(_react.Component);
	
	exports.default = (0, _withVerifyCheck2.default)((0, _reactRedux.connect)(function (s) {
	  var languageId = s.application.get('languageId');
	  var gamblerId = s.auth.get('user') && s.auth.get('user').get('gamblerId');
	
	  return {
	    locale: (0, _Language.getLanguageType)(languageId).name,
	    gamblerId: gamblerId
	  };
	}, { beginSignInAction: _Auth.beginSignIn })(Cybersport));

/***/ },
/* 1341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(82);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _stringify = __webpack_require__(162);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _asyncToGenerator2 = __webpack_require__(97);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _reactRouterRedux = __webpack_require__(23);
	
	var _index = __webpack_require__(386);
	
	var _reactRouter = __webpack_require__(25);
	
	var _gameUtils = __webpack_require__(343);
	
	var _SignIn = __webpack_require__(342);
	
	var _SignIn2 = _interopRequireDefault(_SignIn);
	
	var _reactIntl = __webpack_require__(8);
	
	var _messages = __webpack_require__(344);
	
	var _Language = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FavoriteGames = function (_React$Component) {
	  (0, _inherits3.default)(FavoriteGames, _React$Component);
	
	  function FavoriteGames(props) {
	    var _this2 = this;
	
	    (0, _classCallCheck3.default)(this, FavoriteGames);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FavoriteGames.__proto__ || (0, _getPrototypeOf2.default)(FavoriteGames)).call(this, props));
	
	    _this.getFavoriteGamesFromStorage = function () {
	      try {
	        var favorites = localStorage.getItem('favoriteGames');
	        return favorites ? JSON.parse(favorites) : [];
	      } catch (error) {
	        console.error('Failed to parse favorite games from localStorage:', error);
	        return [];
	      }
	    };
	
	    _this.unpinGame = function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(gameId) {
	        var gamblerId, response, updatedFavorites;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                gamblerId = _this.props.gamblerId;
	                _context.prev = 1;
	                _context.next = 4;
	                return fetch('/api/games/un-pin/' + gameId, {
	                  method: 'POST',
	                  headers: {
	                    'Content-Type': 'application/json'
	                  },
	                  body: (0, _stringify2.default)({ gamblerId: gamblerId })
	                });
	
	              case 4:
	                response = _context.sent;
	
	                if (!response.ok) {
	                  _context.next = 10;
	                  break;
	                }
	
	                updatedFavorites = _this.state.favoriteGames.filter(function (game) {
	                  return game.Id !== gameId;
	                });
	
	                _this.setState({ favoriteGames: updatedFavorites }, function () {
	                  localStorage.setItem('favoriteGames', (0, _stringify2.default)(updatedFavorites));
	                });
	                _context.next = 11;
	                break;
	
	              case 10:
	                throw new Error('Failed to unpin the game');
	
	              case 11:
	                _context.next = 16;
	                break;
	
	              case 13:
	                _context.prev = 13;
	                _context.t0 = _context['catch'](1);
	
	                console.error('Error unpinning the game:', _context.t0);
	
	              case 16:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2, [[1, 13]]);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.handleGameClick = function () {
	      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(gameId, gamblerId) {
	        var language, response, data;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                language = (0, _Language.getLanguageType)().name;
	                _context2.prev = 1;
	
	                _this.setState({ loading: true });
	
	                _context2.next = 5;
	                return fetch('/api/games/' + gameId + '/launch/?gamblerId=' + gamblerId + '&language=' + language);
	
	              case 5:
	                response = _context2.sent;
	
	                if (response.ok) {
	                  _context2.next = 8;
	                  break;
	                }
	
	                throw new Error('Network response was not ok');
	
	              case 8:
	                _context2.next = 10;
	                return response.json();
	
	              case 10:
	                data = _context2.sent;
	
	
	                console.log('Game Data:', data.LaunchUrl);
	                window.open(data.LaunchUrl);
	                _context2.next = 18;
	                break;
	
	              case 15:
	                _context2.prev = 15;
	                _context2.t0 = _context2['catch'](1);
	
	                console.error('Failed to fetch game details:', _context2.t0);
	
	              case 18:
	                _context2.prev = 18;
	
	                _this.setState({ loading: false });
	                return _context2.finish(18);
	
	              case 21:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2, [[1, 15, 18, 21]]);
	      }));
	
	      return function (_x2, _x3) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.openAuthModal = function () {
	      var user = _this.props.user;
	
	
	      if (user) {
	        alert('Игра не доступна');
	      } else {
	        _this.props.dispatch({ type: 'BEGIN_SIGNIN' });
	      }
	    };
	
	    _this.handleGameClickWrapper = function (gameId) {
	      var user = _this.props.user;
	
	      _this.setState({ isLoading: true });
	
	      (0, _gameUtils.handleGameClick)(gameId, user, function (loading) {
	        return _this.setState({ isLoading: loading });
	      }, function (errorCode) {
	        return (0, _gameUtils.handleErrorCode)(errorCode, _gameUtils.showErrorMessage, function () {
	          return _this.openAuthModal();
	        });
	      });
	    };
	
	    _this.renderGame = function (game, handleGameClickWrapper, favoriteGames, unpinGame) {
	      var isFavorite = favoriteGames.some(function (g) {
	        return g.Id === game.Id;
	      });
	      var handleFavoriteClick = function handleFavoriteClick(e) {
	        e.stopPropagation();
	        unpinGame(game.Id);
	      };
	      return _react2.default.createElement(
	        'div',
	        { key: game.Id, className: 'game-card', onClick: function onClick() {
	            return handleGameClickWrapper(game.Id);
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'game-thumbnail' },
	          (game.ThumbnailUrl || '').endsWith(".mp4") ? _react2.default.createElement(
	            'video',
	            { poster: game.ThumbnailUrl, autoPlay: true, muted: true, loop: true, controls: false, className: 'game-image' },
	            _react2.default.createElement('source', { src: game.ThumbnailUrl, type: 'video/mp4' })
	          ) : _react2.default.createElement('img', { src: game.ThumbnailUrl, alt: 'Game ' + game.Name, className: 'game-image' }),
	          _react2.default.createElement(
	            'h3',
	            { className: 'game-title' },
	            game.Name
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'favorite-button ' + (isFavorite ? 'favorite' : ''), onClick: handleFavoriteClick },
	            isFavorite ? '★' : '☆'
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      loading: false,
	      favoriteGames: [],
	      showSignIn: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(FavoriteGames, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var favoriteGames = this.getFavoriteGamesFromStorage();
	      this.setState({ favoriteGames: favoriteGames });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          loading = _state.loading,
	          favoriteGames = _state.favoriteGames,
	          showSignIn = _state.showSignIn;
	
	
	      if (loading) {
	        return _react2.default.createElement(_Loader2.default, null);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'favorite-games' },
	        showSignIn && _react2.default.createElement(_SignIn2.default, null),
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/games' },
	          _react2.default.createElement(
	            'button',
	            { className: 'view-all-button' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, _messages.messages.goBackToGames)
	          )
	        ),
	        _react2.default.createElement(
	          'h1',
	          { className: 'title' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, _messages.messages.favoriteGames)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'game-grid' },
	          favoriteGames.length > 0 ? favoriteGames.map(function (game) {
	            return _this3.renderGame(game, _this3.handleGameClickWrapper, _this3.state.favoriteGames, _this3.unpinGame);
	          }) : _react2.default.createElement(
	            'p',
	            { className: 'no-favorites' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, _messages.messages.favoriteGamesNot)
	          )
	        )
	      );
	    }
	  }]);
	  return FavoriteGames;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state, dispatch) {
	  var user = state.auth.get('user');
	  return {
	    gamblerId: user && user.get('gamblerId'),
	    languageId: state.application.get('languageId'),
	    user: user,
	    dispatch: dispatch
	  };
	}, { push: _reactRouterRedux.push, joinXpressGameAction: _index.joinXpressGame })(FavoriteGames);

/***/ },
/* 1342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getIterator2 = __webpack_require__(807);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _regenerator = __webpack_require__(82);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _toConsumableArray2 = __webpack_require__(308);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _asyncToGenerator2 = __webpack_require__(97);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _stringify = __webpack_require__(162);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactSlick = __webpack_require__(698);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _reactRouter = __webpack_require__(25);
	
	var _gameUtils = __webpack_require__(343);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _reactIntl = __webpack_require__(8);
	
	var _messages = __webpack_require__(344);
	
	var _recent = __webpack_require__(1784);
	
	var _recent2 = _interopRequireDefault(_recent);
	
	var _resetIcon = __webpack_require__(1785);
	
	var _resetIcon2 = _interopRequireDefault(_resetIcon);
	
	var _Input = __webpack_require__(1343);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Select = __webpack_require__(1180);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GameLayout = function (_Component) {
	  (0, _inherits3.default)(GameLayout, _Component);
	
	  function GameLayout(props) {
	    var _this2 = this;
	
	    (0, _classCallCheck3.default)(this, GameLayout);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (GameLayout.__proto__ || (0, _getPrototypeOf2.default)(GameLayout)).call(this, props));
	
	    _this.componentDidMount = function () {
	      var location = _this.props.location;
	
	
	      _this.fetchLobbyGames();
	      _this.fetchProviders();
	      _this.fetchCategories();
	      var cachedPopularGames = JSON.parse(localStorage.getItem('popularGames')) || [];
	      var cachedAnotherGames = JSON.parse(localStorage.getItem('anotherGames')) || [];
	
	      _this.setState({
	        popularGames: cachedPopularGames,
	        anotherGames: cachedAnotherGames,
	        isLoading: false
	      });
	      if (_this.props.params.searchTerm) {
	        _this.setState({ showType: false, showPopular: false }, function () {
	          return _this.fetchAllGames('');
	        });
	      }
	      if (location.query && !isNaN(location.query.provider) && location.query.provider !== '') {
	        _this.setState({
	          selectedProviderId: Number(location.query.provider),
	          showPopular: false,
	          showType: false
	        }, function () {
	          return _this.fetchAllGames(Number(location.query.provider));
	        });
	      }
	      window.addEventListener('scroll', _this.handleScroll);
	    };
	
	    _this.componentWillUnmount = function () {
	      window.removeEventListener('scroll', _this.handleScroll);
	    };
	
	    _this.componentDidUpdate = function (prevProps, prevState) {
	      if (prevState.selectedProviderId !== _this.state.selectedProviderId && _this.state.selectedProviderId === '' || prevState.selectedCategoryId !== _this.state.selectedCategoryId && _this.state.selectedCategoryId === '') {
	        var cachedPopularGames = JSON.parse(localStorage.getItem('popularGames')) || [];
	        var cachedAnotherGames = JSON.parse(localStorage.getItem('anotherGames')) || [];
	        _this.setState({
	          popularGames: cachedPopularGames,
	          anotherGames: cachedAnotherGames,
	          isLoading: false
	        }, _this.updateFilteredGames);
	      }
	
	      if (prevProps.languageId !== _this.props.languageId) {
	        _this.fetchLobbyGames();
	        _this.fetchCategories();
	      }
	    };
	
	    _this.handleScroll = function () {
	      var _this$state = _this.state,
	          isLoading = _this$state.isLoading,
	          hasMoreGames = _this$state.hasMoreGames,
	          selectedProviderId = _this$state.selectedProviderId;
	
	      if (!selectedProviderId || isLoading || !hasMoreGames) return;
	
	      var documentHeight = document.documentElement.scrollHeight;
	
	      if (window.scrollY + window.innerHeight >= documentHeight - 150) {
	        _this.loadMoreGames();
	      }
	    };
	
	    _this.loadMoreGames = function () {
	      var selectedProviderId = _this.state.selectedProviderId;
	
	
	      _this.setState(function (prevState) {
	        var newPage = prevState.page + 1;
	        _this.fetchAllGames(selectedProviderId, newPage, true);
	        return { page: newPage };
	      });
	    };
	
	    _this.getGamesFromStorage = function () {
	      try {
	        var games = localStorage.getItem('lobbyGames');
	        return games ? JSON.parse(games) : [];
	      } catch (error) {
	        console.error('Failed to parse games from localStorage:', error);
	        return [];
	      }
	    };
	
	    _this.getFavoriteGamesFromStorage = function () {
	      try {
	        var favorites = localStorage.getItem('favoriteGames');
	        return favorites ? JSON.parse(favorites) : [];
	      } catch (error) {
	        console.error('Failed to parse favorite games from localStorage:', error);
	        return [];
	      }
	    };
	
	    _this.saveFavoriteGamesToStorage = function (favoriteGames) {
	      localStorage.setItem('favoriteGames', (0, _stringify2.default)(favoriteGames));
	    };
	
	    _this.filterGames = function (games) {
	      var selectedCategoryId = _this.state.selectedCategoryId;
	
	
	      return games.filter(function (game) {
	        var matchesCategory = selectedCategoryId === '' || game.GameTypeId === parseInt(selectedCategoryId);
	
	        return matchesCategory;
	      });
	    };
	
	    _this.fetchAllGames = function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	        var providerId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	        var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	        var append = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	        var searchTerm, providerQuery, searchQuery, offset, responseAllGames, dataAllGames, newGames;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this.setState({ isLoading: true });
	                _context.prev = 1;
	                searchTerm = _this.state.searchTerm;
	                providerQuery = providerId ? '&providers=' + providerId : '';
	                searchQuery = searchTerm ? '&name=' + searchTerm : '';
	                offset = (page - 1) * 64;
	                _context.next = 8;
	                return fetch('/api/games/all-games?limit=64&offset=' + offset + providerQuery + searchQuery);
	
	              case 8:
	                responseAllGames = _context.sent;
	
	                if (responseAllGames.ok) {
	                  _context.next = 11;
	                  break;
	                }
	
	                throw new Error('Failed to fetch all games');
	
	              case 11:
	                _context.next = 13;
	                return responseAllGames.json();
	
	              case 13:
	                dataAllGames = _context.sent;
	                newGames = dataAllGames.Items || [];
	
	
	                _this.setState(function (prevState) {
	                  return {
	                    allGames: append ? [].concat((0, _toConsumableArray3.default)(prevState.allGames), (0, _toConsumableArray3.default)(newGames)) : newGames,
	                    hasMoreGames: newGames.length === 64
	                  };
	                });
	                _context.next = 22;
	                break;
	
	              case 18:
	                _context.prev = 18;
	                _context.t0 = _context['catch'](1);
	
	                console.error('Failed to fetch all games:', _context.t0);
	                _this.setState({ isLoading: false, hasMoreGames: false });
	
	              case 22:
	                _context.prev = 22;
	
	                _this.setState({ isLoading: false });
	                return _context.finish(22);
	
	              case 25:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2, [[1, 18, 22, 25]]);
	      }));
	
	      return function () {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.fetchLobbyGames = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
	      var dataLobby, responseLobbyGames;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this.setState({ isLoading: true });
	              _context2.prev = 1;
	              dataLobby = { Items: [], TopGames: [], GameTypes: [] };
	              _context2.next = 5;
	              return fetch('/api/games/lobby?limit=80&language=' + _this.props.languageId);
	
	            case 5:
	              responseLobbyGames = _context2.sent;
	
	              if (responseLobbyGames.ok) {
	                _context2.next = 8;
	                break;
	              }
	
	              throw new Error('Failed to fetch lobby games');
	
	            case 8:
	              _context2.next = 10;
	              return responseLobbyGames.json();
	
	            case 10:
	              dataLobby = _context2.sent;
	
	
	              _this.saveGamesToStorage(dataLobby.TopGames || [], dataLobby.GameTypes || []);
	              _this.setState({
	                lobbyGames: dataLobby.Items || [],
	                popularGames: dataLobby.TopGames || [],
	                anotherGames: dataLobby.GameTypes || []
	              });
	              _context2.next = 18;
	              break;
	
	            case 15:
	              _context2.prev = 15;
	              _context2.t0 = _context2['catch'](1);
	
	              console.error('Failed to fetch lobby games:', _context2.t0);
	
	            case 18:
	              _context2.prev = 18;
	
	              _this.setState({ isLoading: false });
	              return _context2.finish(18);
	
	            case 21:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2, [[1, 15, 18, 21]]);
	    }));
	    _this.fetchCategories = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
	      var responseCategories, dataCategories;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _context3.prev = 0;
	              _context3.next = 3;
	              return fetch('/api/games/types?language=' + _this.props.languageId);
	
	            case 3:
	              responseCategories = _context3.sent;
	
	              if (responseCategories.ok) {
	                _context3.next = 6;
	                break;
	              }
	
	              throw new Error('Failed to fetch categories');
	
	            case 6:
	              _context3.next = 8;
	              return responseCategories.json();
	
	            case 8:
	              dataCategories = _context3.sent;
	
	
	              if (dataCategories.Items) {
	                _this.setState({
	                  categories: dataCategories.Items || []
	                });
	              }
	              _context3.next = 15;
	              break;
	
	            case 12:
	              _context3.prev = 12;
	              _context3.t0 = _context3['catch'](0);
	
	              console.error('Failed to fetchCategories:', _context3.t0);
	
	            case 15:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2, [[0, 12]]);
	    }));
	    _this.fetchProviders = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
	      var responseProviders, dataProviders;
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _context4.prev = 0;
	              _context4.next = 3;
	              return fetch('/api/games/providers');
	
	            case 3:
	              responseProviders = _context4.sent;
	
	              if (responseProviders.ok) {
	                _context4.next = 6;
	                break;
	              }
	
	              throw new Error('Failed to fetch providers');
	
	            case 6:
	              _context4.next = 8;
	              return responseProviders.json();
	
	            case 8:
	              dataProviders = _context4.sent;
	
	
	              if (dataProviders.Items) {
	                _this.setState({
	                  providers: dataProviders.Items || []
	                });
	              }
	              _context4.next = 15;
	              break;
	
	            case 12:
	              _context4.prev = 12;
	              _context4.t0 = _context4['catch'](0);
	
	              console.error('Failed to fetchProviders:', _context4.t0);
	
	            case 15:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this2, [[0, 12]]);
	    }));
	
	    _this.saveGamesToStorage = function (popularGames, anotherGames) {
	      localStorage.setItem('popularGames', (0, _stringify2.default)(popularGames));
	      localStorage.setItem('anotherGames', (0, _stringify2.default)(anotherGames));
	    };
	
	    _this.pinGame = function () {
	      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(gameId) {
	        var user, gamblerId, response;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                user = _this.props.user;
	
	                if (user) {
	                  _context5.next = 4;
	                  break;
	                }
	
	                _this.props.dispatch({ type: 'BEGIN_SIGNIN' });
	                return _context5.abrupt('return');
	
	              case 4:
	                gamblerId = user.get('gamblerId');
	
	                if (!(gamblerId === null)) {
	                  _context5.next = 8;
	                  break;
	                }
	
	                alert('Зарегистрируйтесь для того чтобы добавить в избранные');
	                return _context5.abrupt('return');
	
	              case 8:
	                _context5.prev = 8;
	                _context5.next = 11;
	                return fetch('/api/games/pin/' + gameId, {
	                  method: 'POST',
	                  headers: { 'Content-Type': 'application/json' },
	                  body: (0, _stringify2.default)({ gamblerId: gamblerId })
	                });
	
	              case 11:
	                response = _context5.sent;
	
	
	                if (response.status === 200) {
	                  _this.addGameToFavorites(gameId);
	                } else {
	                  _this.removeGameFromFavorites(gameId);
	                }
	                _context5.next = 18;
	                break;
	
	              case 15:
	                _context5.prev = 15;
	                _context5.t0 = _context5['catch'](8);
	
	                console.error('Error pinning the game:', _context5.t0);
	
	              case 18:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2, [[8, 15]]);
	      }));
	
	      return function (_x4) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.unpinGame = function () {
	      var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(gameId) {
	        var user, gamblerId, response;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                user = _this.props.user;
	
	                if (user) {
	                  _context6.next = 4;
	                  break;
	                }
	
	                _this.props.dispatch({ type: 'BEGIN_SIGNIN' });
	                return _context6.abrupt('return');
	
	              case 4:
	                gamblerId = user.get('gamblerId');
	
	                if (!(gamblerId === null)) {
	                  _context6.next = 8;
	                  break;
	                }
	
	                _this.props.dispatch({ type: 'BEGIN_SIGNIN' });
	                return _context6.abrupt('return');
	
	              case 8:
	                _context6.prev = 8;
	                _context6.next = 11;
	                return fetch('/api/games/un-pin/' + gameId, {
	                  method: 'POST',
	                  headers: { 'Content-Type': 'application/json' },
	                  body: (0, _stringify2.default)({ gamblerId: gamblerId })
	                });
	
	              case 11:
	                response = _context6.sent;
	
	
	                if (response.status === 200) {
	                  _this.removeGameFromFavorites(gameId);
	                } else {
	                  console.error('Failed to unpin the game');
	                }
	                _context6.next = 18;
	                break;
	
	              case 15:
	                _context6.prev = 15;
	                _context6.t0 = _context6['catch'](8);
	
	                console.error('Error unpinning the game:', _context6.t0);
	
	              case 18:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this2, [[8, 15]]);
	      }));
	
	      return function (_x5) {
	        return _ref6.apply(this, arguments);
	      };
	    }();
	
	    _this.addGameToFavorites = function (gameId) {
	      var _this$state2 = _this.state,
	          favoriteGames = _this$state2.favoriteGames,
	          popularGames = _this$state2.popularGames,
	          anotherGames = _this$state2.anotherGames;
	
	
	      var gameToAdd = popularGames.find(function (game) {
	        return game.Id === gameId;
	      });
	
	      if (!gameToAdd) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(anotherGames), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var gameType = _step.value;
	
	            gameToAdd = gameType.Games.find(function (game) {
	              return game.Id === gameId;
	            });
	            if (gameToAdd) break;
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	      if (gameToAdd) {
	        var updatedFavorites = [].concat((0, _toConsumableArray3.default)(favoriteGames), [gameToAdd]);
	        _this.setState({ favoriteGames: updatedFavorites }, function () {
	          _this.saveFavoriteGamesToStorage(updatedFavorites);
	        });
	      }
	    };
	
	    _this.handleSearchChange = function (event) {
	      _this.setState({ searchTerm: event.target.value });
	    };
	
	    _this.handleSearchSubmit = function () {
	      var searchTerm = _this.state.searchTerm;
	
	      _this.setState({ showType: false, showPopular: false, page: 1, hasMoreGames: true }, function () {
	        return _this.fetchAllGames('');
	      });
	      _this.props.router.push('/games/' + searchTerm);
	    };
	
	    _this.handleProviderChange = function (value) {
	      if (value === '') {
	        _this.reloadPage();
	      } else {
	        _this.setState({
	          selectedProviderId: value,
	          showPopular: false,
	          showType: false,
	          page: 1,
	          hasMoreGames: true
	        }, function () {
	          return _this.fetchAllGames(value);
	        });
	      }
	    };
	
	    _this.handleCategoryChange = function (event) {
	      var selectedCategoryId = event.target.value;
	      if (selectedCategoryId === '') {
	        // temporary
	        _this.reloadPage();
	      } else {
	        _this.setState({ selectedCategoryId: selectedCategoryId, showPopular: false, hideAllGames: true }, _this.updateFilteredGames);
	      }
	    };
	
	    _this.updateFilteredGames = function () {
	      var _this$state3 = _this.state,
	          selectedCategoryId = _this$state3.selectedCategoryId,
	          selectedProviderId = _this$state3.selectedProviderId;
	
	      var cachedPopularGames = JSON.parse(localStorage.getItem('popularGames')) || [];
	      var cachedAnotherGames = JSON.parse(localStorage.getItem('anotherGames')) || [];
	
	      var filterGames = function filterGames(games) {
	        return games.filter(function (game) {
	          var matchesCategory = selectedCategoryId === '' || game.GameTypeId === parseInt(selectedCategoryId);
	          var matchesProvider = selectedProviderId === '' || game.ProviderId === parseInt(selectedProviderId);
	          return matchesCategory && matchesProvider;
	        });
	      };
	
	      var filteredPopularGames = filterGames(cachedPopularGames);
	      var filteredAnotherGames = cachedAnotherGames.map(function (type) {
	        return (0, _extends3.default)({}, type, {
	          Games: filterGames(type.Games)
	        });
	      });
	
	      _this.setState({
	        popularGames: filteredPopularGames,
	        anotherGames: filteredAnotherGames.filter(function (type) {
	          return type.Games.length > 0;
	        })
	      });
	    };
	
	    _this.openAuthModal = function () {
	      var user = _this.props.user;
	
	
	      if (user) {
	        alert('Игра не доступна.');
	      } else {
	        _this.props.dispatch({ type: 'BEGIN_SIGNIN' });
	      }
	    };
	
	    _this.handleGameClickWrapper = function (gameId) {
	      var user = _this.props.user;
	
	      _this.setState({ isLoading: true });
	
	      (0, _gameUtils.handleGameClick)(gameId, user, function (loading) {
	        return _this.setState({ isLoading: loading });
	      }, function (errorCode) {
	        return (0, _gameUtils.handleErrorCode)(errorCode, _gameUtils.showErrorMessage, function () {
	          return _this.openAuthModal();
	        });
	      });
	    };
	
	    _this.removeGameFromFavorites = function (gameId) {
	      var favoriteGames = _this.state.favoriteGames;
	
	      var updatedFavorites = favoriteGames.filter(function (game) {
	        return game.Id !== gameId;
	      });
	
	      _this.setState({ favoriteGames: updatedFavorites }, function () {
	        _this.saveFavoriteGamesToStorage(updatedFavorites);
	      });
	    };
	
	    _this.chunkArray = function (array, chunkSize) {
	      var result = [];
	      for (var i = 0; i < array.length; i += chunkSize) {
	        result.push(array.slice(i, i + chunkSize));
	      }
	      return result;
	    };
	
	    _this.reloadPage = function () {
	      window.location.reload();
	    };
	
	    _this.handleResetSearch = function () {
	      _this.setState({
	        searchTerm: '',
	        showType: true,
	        showPopular: true,
	        selectedCategoryId: '',
	        selectedProviderId: ''
	      }, function () {
	        _this.props.router.push('/games');
	        _this.fetchLobbyGames();
	      });
	    };
	
	    _this.state = {
	      categories: [],
	      providers: [],
	      popularGames: [],
	      anotherGames: [],
	      selectedCategoryId: '',
	      selectedProviderId: '',
	      searchTerm: _this.props.params.searchTerm || '',
	      allGames: [],
	      page: 1,
	      hasMoreGames: true,
	      isLoading: true,
	      placeholder: '',
	      favoriteGames: _this.getFavoriteGamesFromStorage() || [],
	      showPopular: true,
	      showType: true,
	      hideAllGames: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(GameLayout, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          categories = _state.categories,
	          selectedCategoryId = _state.selectedCategoryId,
	          selectedProviderId = _state.selectedProviderId,
	          searchTerm = _state.searchTerm,
	          isLoading = _state.isLoading,
	          providers = _state.providers,
	          popularGames = _state.popularGames,
	          anotherGames = _state.anotherGames,
	          allGames = _state.allGames,
	          showPopular = _state.showPopular,
	          showType = _state.showType,
	          hideAllGames = _state.hideAllGames;
	
	
	      var filteredPopularGames = this.filterGames(popularGames);
	      var filteredAnotherGames = anotherGames.map(function (type) {
	        return (0, _extends3.default)({}, type, {
	          Games: _this3.filterGames(type.Games)
	        });
	      }).filter(function (type) {
	        return type.Games.length > 0;
	      });
	
	      var sliderSettings = {
	        speed: 400,
	        infinite: false,
	        slidesPerRow: 1,
	        slidesToShow: 6,
	        slidesToScroll: 2,
	        rows: 2
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'game-layout' },
	        isLoading && _react2.default.createElement(_Loader2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'game-search-bar' },
	          _react2.default.createElement(
	            'div',
	            { className: 'game-search-bar' },
	            _react2.default.createElement('img', {
	              src: _resetIcon2.default,
	              alt: 'Reset Search',
	              width: 30,
	              onClick: this.handleResetSearch,
	              style: { cursor: 'pointer' }
	            }),
	            ' ',
	            _react2.default.createElement(_Input2.default, {
	              searchTerm: searchTerm,
	              onSearchChange: this.handleSearchChange,
	              onSearchSubmit: this.handleSearchSubmit
	            }),
	            _react2.default.createElement(_Select.Select, {
	              options: [{
	                label: _react2.default.createElement(_reactIntl.FormattedMessage, _messages.messages.allProviders),
	                value: ''
	              }].concat((0, _toConsumableArray3.default)(providers.map(function (provider) {
	                var tag = undefined;
	
	                if (provider.IsTop) {
	                  tag = { text: _react2.default.createElement(_reactIntl.FormattedMessage, _messages.messages.hot), type: 'top' };
	                } else if (provider.IsNew) {
	                  tag = { text: _react2.default.createElement(_reactIntl.FormattedMessage, _messages.messages.new), type: 'new' };
	                }
	
	                return (0, _extends3.default)({
	                  label: provider.Name,
	                  value: provider.Id
	                }, tag ? { tag: tag } : {});
	              }))),
	              onChange: this.handleProviderChange,
	              value: selectedProviderId
	            }),
	            _react2.default.createElement(
	              'select',
	              { className: 'game-type-select', onChange: this.handleCategoryChange, value: selectedCategoryId },
	              _react2.default.createElement(
	                'option',
	                { value: '' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, _messages.messages.allTypes)
	              ),
	              categories.map(function (category) {
	                return _react2.default.createElement(
	                  'option',
	                  { key: category.Id, value: category.Id },
	                  category.Name
	                );
	              })
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/games/favorites', className: 'tooltip-container' },
	              _react2.default.createElement(
	                'button',
	                { className: 'star-button' },
	                '\u2605'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip-text' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, _messages.messages.showFavorites)
	              )
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/games/recent', className: 'tooltip-container' },
	              _react2.default.createElement(
	                'button',
	                { className: 'refresh-button' },
	                _react2.default.createElement('img', { src: _recent2.default, alt: '', width: 44 })
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip-text' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, _messages.messages.showRecentGames)
	              )
	            )
	          )
	        ),
	        showPopular && !!filteredPopularGames.length && _react2.default.createElement(
	          'div',
	          { className: 'game-section' },
	          showPopular && _react2.default.createElement(
	            'h1',
	            { className: 'section-title' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, _messages.messages.popular)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-container' },
	            _react2.default.createElement(
	              'div',
	              { style: { display: 'flex', justifyContent: 'flex-end' } },
	              showPopular && _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/games/popularGames' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'showAll' },
	                  _react2.default.createElement(_reactIntl.FormattedMessage, _messages.messages.showAll)
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactSlick2.default,
	              sliderSettings,
	              filteredPopularGames.map(function (game) {
	                return (0, _gameUtils.renderGame)(game, _this3.handleGameClickWrapper, _this3.state.favoriteGames, _this3.pinGame, _this3.unpinGame);
	              })
	            ),
	            ' '
	          )
	        ),
	        showType && filteredAnotherGames.map(function (type) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'game-section', key: type.Id },
	            _react2.default.createElement(
	              'h1',
	              { className: 'section-title' },
	              type.Name
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { display: 'flex', justifyContent: 'flex-end' } },
	              type.Games.length > 0 && type.Games[0].GameTypeId !== undefined ? _react2.default.createElement(
	                'button',
	                { className: 'showAll' },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/games/types/' + type.Games[0].GameTypeId },
	                  _react2.default.createElement(_reactIntl.FormattedMessage, _messages.messages.showAll)
	                )
	              ) : _react2.default.createElement(
	                'button',
	                { className: 'showAll', disabled: true },
	                _react2.default.createElement(_reactIntl.FormattedMessage, _messages.messages.showAll)
	              )
	            ),
	            _react2.default.createElement(
	              _reactSlick2.default,
	              sliderSettings,
	              type.Games.map(function (game) {
	                return (0, _gameUtils.renderGame)(game, _this3.handleGameClickWrapper, _this3.state.favoriteGames, _this3.pinGame, _this3.unpinGame);
	              })
	            )
	          );
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'flex', maxWidth: '1400px', flexWrap: 'wrap', gap: '20px' } },
	          !showType && allGames.length > 0 ? allGames.map(function (game) {
	            return _react2.default.createElement(
	              'div',
	              { key: game.Id },
	              (0, _gameUtils.renderGame)(game, _this3.handleGameClickWrapper, _this3.state.favoriteGames, _this3.pinGame, _this3.unpinGame)
	            );
	          }) : _react2.default.createElement('div', { className: 'no-games-message' })
	        ),
	        !hideAllGames && showType ? _react2.default.createElement(
	          'div',
	          { className: 'game-section' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'section-title' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, _messages.messages.allGames)
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'flex-end' } },
	            _react2.default.createElement(
	              'button',
	              { className: 'showAll' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/games/allGames' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, _messages.messages.showAll)
	              )
	            )
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-container' },
	            _react2.default.createElement(
	              _reactSlick2.default,
	              sliderSettings,
	              allGames.map(function (game) {
	                return (0, _gameUtils.renderGame)(game, _this3.handleGameClickWrapper, _this3.state.favoriteGames, _this3.pinGame, _this3.unpinGame);
	              })
	            ),
	            ' '
	          )
	        ) : null
	      );
	    }
	  }]);
	  return GameLayout;
	}(_react.Component);
	// import SignIn from '../../SignIn.jsx'
	
	
	var mapStateToProps = function mapStateToProps(state, dispatch) {
	  return {
	    languageId: state.application.get('languageId'),
	    user: state.auth.get('user'),
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(GameLayout));

/***/ },
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _searchIcon = __webpack_require__(1786);
	
	var _searchIcon2 = _interopRequireDefault(_searchIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// SearchInput.js
	var SearchInput = function SearchInput(_ref) {
	  var searchTerm = _ref.searchTerm,
	      onSearchChange = _ref.onSearchChange,
	      onSearchSubmit = _ref.onSearchSubmit;
	
	  return _react2.default.createElement(
	    'div',
	    { style: { position: 'relative', width: '100%', maxWidth: '400px' } },
	    _react2.default.createElement('input', {
	      type: 'text',
	      value: searchTerm,
	      onChange: onSearchChange,
	      placeholder: localStorage.getItem('languageId') === '5' ? 'Search' : 'Поиск',
	      style: {
	        width: '100%',
	        padding: '12px 50px 12px 15px',
	        border: '1px solid #ccc',
	        outline: 'none',
	        fontSize: '16px',
	        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
	      }
	    }),
	    _react2.default.createElement('img', {
	      src: _searchIcon2.default,
	      alt: '',
	      width: 37,
	      onClick: onSearchSubmit,
	      style: {
	        position: 'absolute',
	        right: '10px',
	        top: '50%',
	        transform: 'translateY(-50%)',
	        border: 'none',
	        color: 'white',
	        padding: '6px 8px',
	        cursor: 'pointer',
	        fontSize: '36px'
	      }
	    })
	  );
	};
	
	exports.default = SearchInput;

/***/ },
/* 1344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(162);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _regenerator = __webpack_require__(82);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _toConsumableArray2 = __webpack_require__(308);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _asyncToGenerator2 = __webpack_require__(97);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(25);
	
	var _reactRedux = __webpack_require__(9);
	
	var _gameUtils = __webpack_require__(343);
	
	var _SignIn = __webpack_require__(342);
	
	var _SignIn2 = _interopRequireDefault(_SignIn);
	
	var _reactIntl = __webpack_require__(8);
	
	var _messages = __webpack_require__(344);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GameTypesPage = function (_Component) {
	  (0, _inherits3.default)(GameTypesPage, _Component);
	
	  function GameTypesPage(props) {
	    var _this2 = this;
	
	    (0, _classCallCheck3.default)(this, GameTypesPage);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (GameTypesPage.__proto__ || (0, _getPrototypeOf2.default)(GameTypesPage)).call(this, props));
	
	    _this.fetchGamesByCategory = function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(categoryId) {
	        var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	        var append = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        var _this$state, limit, games, offset, response, data, newGames;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$state = _this.state, limit = _this$state.limit, games = _this$state.games;
	
	                _this.setState({ isLoading: true });
	
	                _context.prev = 2;
	                offset = (page - 1) * limit;
	                _context.next = 6;
	                return fetch('/api/games/all-games?types=' + categoryId + '&limit=' + limit + '&offset=' + offset);
	
	              case 6:
	                response = _context.sent;
	                _context.next = 9;
	                return response.json();
	
	              case 9:
	                data = _context.sent;
	
	                console.log('Fetched data:', data);
	
	                newGames = data.Items.filter(function (newGame) {
	                  return !games.some(function (existingGame) {
	                    return existingGame.Id === newGame.Id;
	                  });
	                });
	
	
	                _this.setState(function (prevState) {
	                  return {
	                    games: append ? [].concat((0, _toConsumableArray3.default)(prevState.games), (0, _toConsumableArray3.default)(newGames)) : newGames,
	                    isLoading: false,
	                    hasMoreGames: newGames.length === limit
	                  };
	                });
	                _context.next = 19;
	                break;
	
	              case 15:
	                _context.prev = 15;
	                _context.t0 = _context['catch'](2);
	
	                console.error('Failed to fetch games by category:', _context.t0);
	                _this.setState({ isLoading: false });
	
	              case 19:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2, [[2, 15]]);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.openAuthModal = function () {
	      var user = _this.props.user;
	
	
	      if (user) {
	        alert('Игра не доступна');
	      } else {
	        _this.props.dispatch({ type: 'BEGIN_SIGNIN' });
	      }
	    };
	
	    _this.handleGameClickWrapper = function (gameId) {
	      var user = _this.props.user;
	
	      _this.setState({ isLoading: true });
	
	      (0, _gameUtils.handleGameClick)(gameId, user, function (loading) {
	        return _this.setState({ isLoading: loading });
	      }, function (errorCode) {
	        return (0, _gameUtils.handleErrorCode)(errorCode, _gameUtils.showErrorMessage, function () {
	          return _this.openAuthModal();
	        });
	      });
	    };
	
	    _this.saveFavoriteGamesToStorage = function (favoriteGames) {
	      localStorage.setItem('favoriteGames', (0, _stringify2.default)(favoriteGames));
	    };
	
	    _this.getFavoriteGamesFromStorage = function () {
	      try {
	        var favorites = localStorage.getItem('favoriteGames');
	        return favorites ? JSON.parse(favorites) : [];
	      } catch (error) {
	        console.error('Failed to parse favorite games from localStorage:', error);
	        return [];
	      }
	    };
	
	    _this.addGameToFavorites = function (gameId) {
	      var _this$state2 = _this.state,
	          favoriteGames = _this$state2.favoriteGames,
	          games = _this$state2.games;
	
	      var gameToAdd = games.find(function (game) {
	        return game.Id === gameId;
	      });
	
	      var updatedFavorites = [].concat((0, _toConsumableArray3.default)(favoriteGames), [gameToAdd]);
	      _this.setState({ favoriteGames: updatedFavorites }, function () {
	        _this.saveFavoriteGamesToStorage(updatedFavorites);
	      });
	    };
	
	    _this.removeGameFromFavorites = function (gameId) {
	      var updatedFavorites = _this.state.favoriteGames.filter(function (game) {
	        return game.Id !== gameId;
	      });
	      _this.setState({ favoriteGames: updatedFavorites }, function () {
	        _this.saveFavoriteGamesToStorage(updatedFavorites);
	      });
	    };
	
	    _this.unpinGame = function () {
	      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(gameId) {
	        var user, gamblerId, response;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                user = _this.props.user;
	
	                if (user) {
	                  _context2.next = 4;
	                  break;
	                }
	
	                alert('Зарегистрируйтесь для того чтобы удалить из избранных');
	                return _context2.abrupt('return');
	
	              case 4:
	                gamblerId = user.get('gamblerId');
	
	                if (!(gamblerId === null)) {
	                  _context2.next = 8;
	                  break;
	                }
	
	                alert('Зарегистрируйтесь для того чтобы удалить из избранных');
	                return _context2.abrupt('return');
	
	              case 8:
	                _context2.prev = 8;
	                _context2.next = 11;
	                return fetch('/api/games/un-pin/' + gameId, {
	                  method: 'POST',
	                  headers: { 'Content-Type': 'application/json' },
	                  body: (0, _stringify2.default)({ gamblerId: gamblerId })
	                });
	
	              case 11:
	                response = _context2.sent;
	
	
	                if (response.status === 200) {
	                  _this.removeGameFromFavorites(gameId);
	                } else {
	                  console.error('Failed to unpin the game');
	                }
	                _context2.next = 18;
	                break;
	
	              case 15:
	                _context2.prev = 15;
	                _context2.t0 = _context2['catch'](8);
	
	                console.error('Error unpinning the game:', _context2.t0);
	
	              case 18:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2, [[8, 15]]);
	      }));
	
	      return function (_x4) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.pinGame = function () {
	      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(gameId) {
	        var user, gamblerId, response;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                user = _this.props.user;
	
	                if (user) {
	                  _context3.next = 4;
	                  break;
	                }
	
	                alert('Зарегистрируйтесь для того чтобы добавить в избранные');
	                return _context3.abrupt('return');
	
	              case 4:
	                gamblerId = user.get('gamblerId');
	
	                if (!(gamblerId === null)) {
	                  _context3.next = 8;
	                  break;
	                }
	
	                alert('Зарегистрируйтесь для того чтобы добавить в избранные');
	                return _context3.abrupt('return');
	
	              case 8:
	                _context3.prev = 8;
	                _context3.next = 11;
	                return fetch('/api/games/pin/' + gameId, {
	                  method: 'POST',
	                  headers: { 'Content-Type': 'application/json' },
	                  body: (0, _stringify2.default)({ gamblerId: gamblerId })
	                });
	
	              case 11:
	                response = _context3.sent;
	
	
	                if (response.status === 200) {
	                  _this.addGameToFavorites(gameId);
	                } else {
	                  _this.removeGameFromFavorites(gameId);
	                }
	                _context3.next = 18;
	                break;
	
	              case 15:
	                _context3.prev = 15;
	                _context3.t0 = _context3['catch'](8);
	
	                console.error('Error pinning the game:', _context3.t0);
	
	              case 18:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2, [[8, 15]]);
	      }));
	
	      return function (_x5) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      games: [],
	      category: null,
	      isLoading: true,
	      showSignIn: false,
	      favoriteGames: _this.getFavoriteGamesFromStorage() || [],
	      page: 1,
	      limit: 18,
	      hasMoreGames: true
	    };
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(GameTypesPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var categoryId = this.props.params.categoryId;
	
	      console.log('Mount categoryId:', categoryId);
	      this.fetchGamesByCategory(categoryId);
	      this.setState({ category: categoryId || 'Категория' });
	
	      // Add scroll event listener
	      window.addEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // Clean up the scroll event listener
	      window.removeEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _this3 = this;
	
	      var categoryId = this.props.params.categoryId;
	
	      console.log('Updated categoryId:', categoryId);
	      if (prevProps.params.categoryId !== categoryId) {
	        this.setState({ category: categoryId, page: 1, games: [], hasMoreGames: true }, function () {
	          _this3.fetchGamesByCategory(categoryId);
	        });
	      }
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll() {
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          hasMoreGames = _state.hasMoreGames;
	      // Check if we are near the bottom of the page
	
	      if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 50 && !isLoading && hasMoreGames) {
	        this.handleLoadMoreGames();
	      }
	    }
	  }, {
	    key: 'handleLoadMoreGames',
	    value: function handleLoadMoreGames() {
	      var _this4 = this;
	
	      var categoryId = this.props.params.categoryId;
	
	
	      if (!categoryId) {
	        console.error('Category ID is not defined');
	        return;
	      }
	
	      this.setState(function (prevState) {
	        var newPage = prevState.page + 1;
	        console.log('New Page:', newPage);
	
	        _this4.fetchGamesByCategory(categoryId, newPage, true);
	
	        return { page: newPage };
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _state2 = this.state,
	          games = _state2.games,
	          category = _state2.category,
	          isLoading = _state2.isLoading,
	          showSignIn = _state2.showSignIn;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'game-types-page' },
	        showSignIn && _react2.default.createElement(_SignIn2.default, null),
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/games' },
	          _react2.default.createElement(
	            'button',
	            { className: 'view-all-button' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, _messages.messages.goBackToGames)
	          )
	        ),
	        category && _react2.default.createElement(
	          'h1',
	          { className: 'page-title' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, _messages.messages.allGamesForCategory),
	          ': ',
	          games[0].GameType || 'Категория'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'game-list' },
	          games.length > 0 ? games.map(function (game) {
	            return (0, _gameUtils.renderGame)(game, _this5.handleGameClickWrapper, _this5.state.favoriteGames, _this5.pinGame, _this5.unpinGame);
	          }) : _react2.default.createElement(
	            'div',
	            { className: 'no-games-message' },
	            _react2.default.createElement(_Loader2.default, null)
	          )
	        ),
	        isLoading && _react2.default.createElement(_Loader2.default, null)
	      );
	    }
	  }]);
	  return GameTypesPage;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.auth.get('user')
	  };
	};
	
	exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(GameTypesPage));

/***/ },
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(12);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _axios = __webpack_require__(146);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactIntl = __webpack_require__(8);
	
	var _idCardFront = __webpack_require__(1679);
	
	var _idCardFront2 = _interopRequireDefault(_idCardFront);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	  verify_form_title: {
	    id: 'verify_form.title',
	    defineMessage: 'Загрузите или перетащите изображения. Документ должен помещаться в кадр целиком, информация должна быть читабельной.'
	  },
	  verify_form_available_files: {
	    id: 'verify_form.available_files',
	    defineMessage: 'Разрешенные файлы: image/jpeg, image/png.'
	  },
	  verify_form_max_file_size: {
	    id: 'verify_form.max_file_size',
	    defineMessage: 'Размер не более: 20.00 мб.'
	  },
	  verify_form_front_side: {
	    id: 'verify_form.document_front_side',
	    defineMessage: 'Лицевая сторона документа'
	  },
	  verify_form_back_side: {
	    id: 'verify_form.document_back_side',
	    defineMessage: 'Оборотная сторона документа'
	  },
	  verify_form_selfie: {
	    id: 'verify_form.selfie_with_document',
	    defineMessage: 'Селфи с документом'
	  },
	  verify_form_send: {
	    id: 'verify_form.submit',
	    defineMessage: 'Отправить'
	  },
	  loading: {
	    id: 'loading',
	    defineMessage: 'Загрузка...'
	  }
	});
	
	var VerifyForm = function (_Component) {
	  (0, _inherits3.default)(VerifyForm, _Component);
	
	  function VerifyForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, VerifyForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = VerifyForm.__proto__ || (0, _getPrototypeOf2.default)(VerifyForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      front: '',
	      back: '',
	      face: '',
	      sending: false
	    }, _this.handleSubmit = function () {
	      var formData = new FormData();
	      formData.append('id', _this.props.accountNumber);
	      formData.append('front', _this.state.front);
	      formData.append('back', _this.state.back);
	      formData.append('face', _this.state.face);
	
	      _this.setState({ sending: true });
	
	      (0, _axios2.default)({
	        url: '/verify',
	        method: 'POST',
	        data: formData
	      }).then(function (res) {
	        if (res.status === 200) {
	          alert('Заявка отправлена!');
	          window.location.assign('/');
	        }
	      }).catch(function () {
	        alert('Ошибка, попробуйте позже!');
	      }).finally(function () {
	        _this.setState({ sending: false });
	      });
	    }, _this.handleChangeImage = function (e) {
	      _this.setState((0, _defineProperty3.default)({}, e.target.name, e.target.files[0]));
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(VerifyForm, [{
	    key: 'render',
	    value: function render() {
	      var accountNumber = this.props.accountNumber;
	      var _state = this.state,
	          front = _state.front,
	          back = _state.back,
	          face = _state.face,
	          sending = _state.sending;
	
	
	      if (!accountNumber) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'verify_form' },
	        _react2.default.createElement(
	          'p',
	          { style: {
	              lineHeight: '1.5'
	            } },
	          _react2.default.createElement(_reactIntl.FormattedMessage, messages.verify_form_title),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_reactIntl.FormattedMessage, messages.verify_form_available_files),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_reactIntl.FormattedMessage, messages.verify_form_max_file_size)
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'label',
	          null,
	          front && _react2.default.createElement('img', { className: 'preview', src: URL.createObjectURL(front), alt: '' }),
	          _react2.default.createElement('img', { src: _idCardFront2.default, alt: '', height: 40 }),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, messages.verify_form_front_side)
	          ),
	          _react2.default.createElement('input', { type: 'file', name: 'front', onChange: this.handleChangeImage, accept: 'image/png, image/jpeg' })
	        ),
	        _react2.default.createElement(
	          'label',
	          null,
	          back && _react2.default.createElement('img', { className: 'preview', src: URL.createObjectURL(back), alt: '' }),
	          _react2.default.createElement('img', { className: 'icon', src: _idCardFront2.default, alt: '', height: 40 }),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, messages.verify_form_back_side)
	          ),
	          _react2.default.createElement('input', { type: 'file', name: 'back', onChange: this.handleChangeImage, accept: 'image/png, image/jpeg' })
	        ),
	        _react2.default.createElement(
	          'label',
	          null,
	          face && _react2.default.createElement('img', { className: 'preview', src: URL.createObjectURL(face), alt: '' }),
	          _react2.default.createElement('img', { src: _idCardFront2.default, alt: '', height: 40 }),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, messages.verify_form_selfie)
	          ),
	          _react2.default.createElement('input', { type: 'file', name: 'face', onChange: this.handleChangeImage, accept: 'image/png, image/jpeg' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'controls' },
	          sending ? _react2.default.createElement(
	            'button',
	            { disabled: true },
	            _react2.default.createElement(_reactIntl.FormattedMessage, messages.loading)
	          ) : _react2.default.createElement(
	            'button',
	            { onClick: this.handleSubmit, disabled: !(front && back && face) },
	            _react2.default.createElement(_reactIntl.FormattedMessage, messages.verify_form_send)
	          )
	        )
	      );
	    }
	  }]);
	  return VerifyForm;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (s) {
	  var user = s.auth.get('user');
	
	  return {
	    accountNumber: user ? user.get('accountNum') : null
	  };
	})(VerifyForm);

/***/ },
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouterRedux = __webpack_require__(23);
	
	var _LocalizedDocumentMeta = __webpack_require__(339);
	
	var _live = __webpack_require__(1336);
	
	var _live2 = _interopRequireDefault(_live);
	
	var _betPanelControl = __webpack_require__(771);
	
	var _betPanelControl2 = _interopRequireDefault(_betPanelControl);
	
	var _ModalWindow = __webpack_require__(138);
	
	var _ModalWindow2 = _interopRequireDefault(_ModalWindow);
	
	var _ConnectionLost = __webpack_require__(1172);
	
	var _ConnectionLost2 = _interopRequireDefault(_ConnectionLost);
	
	var _Stream = __webpack_require__(564);
	
	var _DisplayMode = __webpack_require__(78);
	
	var DisplayMode = _interopRequireWildcard(_DisplayMode);
	
	var _ConnectionStatus = __webpack_require__(494);
	
	var ConnectionStatus = _interopRequireWildcard(_ConnectionStatus);
	
	var _Live = __webpack_require__(957);
	
	var _Timetable = __webpack_require__(960);
	
	var _SetDisplayMode = __webpack_require__(563);
	
	var _utils = __webpack_require__(1301);
	
	var _Period = __webpack_require__(22);
	
	var PeriodType = _interopRequireWildcard(_Period);
	
	var _Favourites = __webpack_require__(736);
	
	var _UserSelection = __webpack_require__(489);
	
	var _StreamPanel = __webpack_require__(806);
	
	var _StreamPanel2 = _interopRequireDefault(_StreamPanel);
	
	var _BetradarWidget = __webpack_require__(1353);
	
	var _BetradarWidget2 = _interopRequireDefault(_BetradarWidget);
	
	var _metadata = __webpack_require__(340);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import {defineMessages} from 'react-intl';
	function fetchDisplayMode(props) {
	    var defaultDisplayMode = { type: DisplayMode.ALL };
	
	    if (props.gridSelection === undefined || !props.gridSelection) {
	        return defaultDisplayMode;
	    }
	
	    var newDisplayMode = void 0;
	    var displayModeAttr = props.gridSelection.get('lastShown');
	
	    if (!displayModeAttr) {
	        newDisplayMode = defaultDisplayMode;
	    } else {
	        if (displayModeAttr.has('sportId')) {
	            newDisplayMode = { type: DisplayMode.SPORT, id: displayModeAttr.get('sportId') };
	        }
	
	        if (displayModeAttr.has('leagueId')) {
	            newDisplayMode = { type: DisplayMode.LEAGUE, id: displayModeAttr.get('leagueId') };
	        }
	    }
	
	    return newDisplayMode;
	}
	
	var LivePage = function (_React$Component) {
	    (0, _inherits3.default)(LivePage, _React$Component);
	
	    function LivePage(props, context) {
	        (0, _classCallCheck3.default)(this, LivePage);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (LivePage.__proto__ || (0, _getPrototypeOf2.default)(LivePage)).call(this, props, context));
	
	        _this._menuShowAll = _this._menuShowAll.bind(_this);
	        _this._menuShowFavourites = _this._menuShowFavourites.bind(_this);
	        _this._sportClick = _this._sportClick.bind(_this);
	        _this._sportFavouriteClick = _this._sportFavouriteClick.bind(_this);
	        _this._leagueClick = _this._leagueClick.bind(_this);
	        _this._leagueFavouriteClick = _this._leagueFavouriteClick.bind(_this);
	        _this._matchClick = _this._matchClick.bind(_this);
	        _this._matchFavouriteClick = _this._matchFavouriteClick.bind(_this);
	        _this._connectionLostCloseClick = _this._connectionLostCloseClick.bind(_this);
	
	        _this.state = {
	            dismissConnectionLost: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(LivePage, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.setDisplayModeAction(fetchDisplayMode(this.props));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.gridSelection.get('lastShown') !== nextProps.gridSelection.get('lastShown')) {
	                this.props.setDisplayModeAction(fetchDisplayMode(nextProps));
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.clearLiveAction();
	            this.props.clearTimetableAction();
	        }
	    }, {
	        key: '_menuShowFavourites',
	        value: function _menuShowFavourites() {
	            this.props.push('/live');
	            this.props.setDisplayModeAction({ type: DisplayMode.FAVOURITE });
	        }
	    }, {
	        key: '_menuShowAll',
	        value: function _menuShowAll() {
	            this.props.push('/live');
	            this.props.setDisplayModeAction({ type: DisplayMode.ALL });
	            this.props.showAllLiveAction();
	        }
	    }, {
	        key: '_sportClick',
	        value: function _sportClick(id) {
	            this.props.push('/live');
	            this.props.setDisplayModeAction({ type: DisplayMode.SPORT, id: id });
	        }
	    }, {
	        key: '_sportFavouriteClick',
	        value: function _sportFavouriteClick(sport) {
	            this.props.toggleFavouriteSportAction(sport);
	        }
	    }, {
	        key: '_leagueClick',
	        value: function _leagueClick(sportId, id) {
	            this.props.push('/live');
	            this.props.setDisplayModeAction({ type: DisplayMode.LEAGUE, id: id });
	        }
	    }, {
	        key: '_leagueFavouriteClick',
	        value: function _leagueFavouriteClick(league) {
	            this.props.toggleFavouriteLeagueAction(league);
	        }
	    }, {
	        key: '_matchClick',
	        value: function _matchClick(id) {
	            this.props.push('/live');
	            this.props.setDisplayModeAction({ type: DisplayMode.MATCH, id: id });
	        }
	    }, {
	        key: '_matchFavouriteClick',
	        value: function _matchFavouriteClick(match) {
	            this.props.toggleFavouriteMatchAction(match);
	        }
	    }, {
	        key: '_connectionLostCloseClick',
	        value: function _connectionLostCloseClick() {
	            var state = this.state;
	
	            this.setState((0, _extends3.default)({}, state, {
	                dismissConnectionLost: true
	            }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                connectionStatus = _props.connectionStatus,
	                gridSelection = _props.gridSelection,
	                gridLocalization = _props.gridLocalization,
	                isShortcut = _props.isShortcut,
	                toggleSportLiveAction = _props.toggleSportLiveAction,
	                toggleLeagueLiveAction = _props.toggleLeagueLiveAction,
	                user = _props.user,
	                stream = _props.stream,
	                streamName = _props.streamName,
	                matchIsBlocked = _props.matchIsBlocked,
	                countryCode = _props.countryCode;
	            var _state = this.state,
	                dismissConnectionLost = _state.dismissConnectionLost,
	                selectedMenuItem = _state.selectedMenuItem;
	
	
	            var menu = (0, _extends3.default)({}, _live.MenuElements, {
	                selectedItem: selectedMenuItem,
	                showSlider: true,
	                showBookmarks: true,
	                showCalendar: true,
	                showMatches: true,
	                showAllSports: true,
	                gridSelection: gridSelection,
	                showFavouritesCallback: this._menuShowFavourites,
	                showAllCallback: this._menuShowAll,
	                sportClickCallback: this._sportClick,
	                sportFavouriteClickCallback: this._sportFavouriteClick,
	                leagueClickCallback: this._leagueClick,
	                leagueFavouriteClickCallback: this._leagueFavouriteClick,
	                matchClickCallback: this._matchClick,
	                matchFavouriteClickCallback: this._matchFavouriteClick,
	                selectionToggleCallback: toggleSportLiveAction,
	                selectionToggleLeagueCallback: toggleLeagueLiveAction,
	                isShortcut: isShortcut
	            });
	
	            var withProps = _react2.default.cloneElement(this.props.center, { gridLocalization: gridLocalization, section: 'live' });
	
	            var metadata = (0, _metadata.getMetadata)(countryCode, null, 'live');
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'no-scroll-wrapper' },
	                _react2.default.createElement(_LocalizedDocumentMeta.LocalizedDocumentMeta, { title: metadata.title, description: metadata.description, keywords: metadata.keywords }),
	                _react2.default.createElement(
	                    'div',
	                    { id: 'left', className: 'live-left' },
	                    _react2.default.createElement(_live2.default, menu)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { id: 'right' },
	                    _react2.default.createElement(_BetradarWidget2.default, null),
	                    user && !matchIsBlocked && stream.src && _react2.default.createElement(_StreamPanel2.default, { stream: stream,
	                        stopFetchStreamAction: this.props.stopFetchStreamAction,
	                        streamName: streamName,
	                        user: user }),
	                    _react2.default.createElement(_betPanelControl2.default, null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { id: 'center', className: 'live-center' },
	                    withProps
	                ),
	                connectionStatus === ConnectionStatus.DISCONNECTED && !dismissConnectionLost && _react2.default.createElement(
	                    _ModalWindow2.default,
	                    null,
	                    _react2.default.createElement(_ConnectionLost2.default, { onClose: this._connectionLostCloseClick })
	                )
	            );
	        }
	    }]);
	    return LivePage;
	}(_react2.default.Component);
	
	LivePage.propTypes = {
	    center: _react2.default.PropTypes.any.isRequired,
	    languageId: _react2.default.PropTypes.number.isRequired,
	    connectionStatus: _react2.default.PropTypes.number.isRequired,
	    gridSelection: _react2.default.PropTypes.object.isRequired,
	    gridLocalization: _react2.default.PropTypes.object.isRequired,
	    clearLiveAction: _react2.default.PropTypes.func.isRequired,
	    clearTimetableAction: _react2.default.PropTypes.func.isRequired,
	    setDisplayModeAction: _react2.default.PropTypes.func.isRequired,
	    toggleFavouriteSportAction: _react2.default.PropTypes.func.isRequired,
	    toggleFavouriteLeagueAction: _react2.default.PropTypes.func.isRequired,
	    toggleFavouriteMatchAction: _react2.default.PropTypes.func.isRequired,
	    toggleSportLiveAction: _react2.default.PropTypes.func.isRequired,
	    toggleLeagueLiveAction: _react2.default.PropTypes.func.isRequired,
	    showAllLiveAction: _react2.default.PropTypes.func.isRequired,
	    user: _react2.default.PropTypes.any,
	    activeWidgetId: _react2.default.PropTypes.any,
	    isShortcut: _react2.default.PropTypes.any,
	    matchIsBlocked: _react2.default.PropTypes.any,
	    push: _react2.default.PropTypes.func.isRequired,
	    stream: _react2.default.PropTypes.object.isRequired,
	    streamName: _react2.default.PropTypes.any,
	    stopFetchStreamAction: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select(state, props) {
	    var languageId = state.application.get('languageId');
	    var connectionStatus = state.application.get('connectionStatus');
	    var gridSelection = state.application.getIn(['userGridSelection', 'live']);
	    var user = state.auth.get('user');
	    var stream = state.application.get('stream');
	    var activeWidgetId = state.application.get('betradar').activeWidgetId;
	    var countryCode = state.application.get('countryCode');
	    var match = state.application.getIn(['live', 'matches', state.application.get('stream').matchId]);
	
	    var matchIsBlocked = true;
	    var streamName = '';
	    if (match) {
	        var periodInfo = (0, _utils.getPeriodInfo)(match, props.gridLocalization);
	        var matchPhase = periodInfo.matchPhase;
	        matchIsBlocked = matchPhase === PeriodType.FINISHED;
	        streamName = match.get('name') ? match.get('name') : '';
	    }
	
	    return {
	        languageId: languageId,
	        connectionStatus: connectionStatus,
	        gridSelection: gridSelection,
	        user: user,
	        stream: stream,
	        streamName: streamName,
	        matchIsBlocked: matchIsBlocked,
	        activeWidgetId: activeWidgetId,
	        countryCode: countryCode
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, {
	    clearLiveAction: _Live.clearLive,
	    clearTimetableAction: _Timetable.clearTimetable,
	    setDisplayModeAction: _SetDisplayMode.setDisplayMode,
	    toggleFavouriteSportAction: _Favourites.toggleFavouriteSport,
	    toggleFavouriteLeagueAction: _Favourites.toggleFavouriteLeague,
	    toggleFavouriteMatchAction: _Favourites.toggleFavouriteMatch,
	    toggleSportLiveAction: _UserSelection.toggleSportLive,
	    toggleLeagueLiveAction: _UserSelection.toggleLeagueLive,
	    showAllLiveAction: _UserSelection.showAllLive,
	    push: _reactRouterRedux.push,
	    stopFetchStreamAction: _Stream.stopFetchStream
	})(LivePage);

/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouterRedux = __webpack_require__(23);
	
	var _LocalizedDocumentMeta = __webpack_require__(339);
	
	var _Menu = __webpack_require__(801);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Sports = __webpack_require__(803);
	
	var _Sports2 = _interopRequireDefault(_Sports);
	
	var _Sport = __webpack_require__(802);
	
	var _Sport2 = _interopRequireDefault(_Sport);
	
	var _League = __webpack_require__(800);
	
	var _League2 = _interopRequireDefault(_League);
	
	var _StreamPanel = __webpack_require__(806);
	
	var _StreamPanel2 = _interopRequireDefault(_StreamPanel);
	
	var _Banner = __webpack_require__(1313);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _Popular = __webpack_require__(1320);
	
	var _Popular2 = _interopRequireDefault(_Popular);
	
	var _News = __webpack_require__(1317);
	
	var _News2 = _interopRequireDefault(_News);
	
	var _BetPanel = __webpack_require__(770);
	
	var _BetPanel2 = _interopRequireDefault(_BetPanel);
	
	var _Stream = __webpack_require__(564);
	
	var _PreMatchMenu = __webpack_require__(738);
	
	var _News3 = __webpack_require__(958);
	
	var _Popular3 = __webpack_require__(959);
	
	var _UserSelection = __webpack_require__(489);
	
	var _metadata = __webpack_require__(340);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// const messages = defineMessages({
	//     title: {
	//         id: 'pages.main.title',
	//         defaultMessage: 'Ставки на спорт онлайн. Букмекерская контора FairPlay в Казахстане.'
	//     },
	//     description: {
	//         id: 'pages.main.description',
	//         defaultMessage: 'Круглосуточно принимаем ставки в режиме онлайн на все спортивные события' +
	//             ' с высокими коэффициентами: футбол, теннис, баскетбол, волейбол, ' +
	//             'хоккей, бокс, борьба, плавание, лыжи.'
	//     }
	// });
	
	// import {defineMessages} from 'react-intl';
	var MainPage = function (_React$Component) {
	    (0, _inherits3.default)(MainPage, _React$Component);
	
	    function MainPage(props, context) {
	        (0, _classCallCheck3.default)(this, MainPage);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (MainPage.__proto__ || (0, _getPrototypeOf2.default)(MainPage)).call(this, props, context));
	
	        _this._menuShowAll = _this._menuShowAll.bind(_this);
	        _this._sportClick = _this._sportClick.bind(_this);
	        _this._leagueClick = _this._leagueClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(MainPage, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var languageId = this.props.languageId;
	
	            // this.props.getNewsAction(languageId);
	            this.props.getPopularMatchesAction({ languageId: languageId });
	            this.props.initPreMatchMenuAction({ languageId: languageId });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.languageId !== nextProps.languageId) {
	                // this.props.getNewsAction(nextProps.languageId);
	                this.props.getPopularMatchesAction({ languageId: nextProps.languageId });
	                this.props.initPreMatchMenuAction({ languageId: nextProps.languageId });
	            }
	        }
	    }, {
	        key: '_menuShowAll',
	        value: function _menuShowAll() {
	            this.props.push('/sports');
	        }
	    }, {
	        key: '_sportClick',
	        value: function _sportClick(id) {
	            this.props.push('/sports/' + id);
	        }
	    }, {
	        key: '_leagueClick',
	        value: function _leagueClick(sportId, id) {
	            return this.props.push('/sports/' + sportId + '/' + id);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                toggleSportMainAction = _props.toggleSportMainAction,
	                gridSelection = _props.gridSelection,
	                news = _props.news,
	                gridLocalization = _props.gridLocalization,
	                countryCode = _props.countryCode,
	                stream = _props.stream,
	                user = _props.user,
	                streamName = _props.streamName,
	                matchIsBlocked = _props.matchIsBlocked,
	                params = _props.params;
	
	
	            var menuProps = {
	                showSlider: false,
	                showBookmarks: false,
	                showCalendar: false,
	                showMatches: false,
	                sportsElement: _Sports2.default,
	                sportElement: _Sport2.default,
	                leagueElement: _League2.default,
	                showAllSports: false,
	                gridSelection: gridSelection,
	                showAllCallback: this._menuShowAll,
	                sportClickCallback: this._sportClick,
	                leagueClickCallback: this._leagueClick,
	                selectionToggleCallback: toggleSportMainAction,
	                selectionToggleLeagueCallback: null,
	                isShortcut: false
	            };
	
	            var newsProps = {
	                news: news
	            };
	
	            var metadata = (0, _metadata.getMetadata)(countryCode, params.sportId);
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'no-scroll-wrapper' },
	                _react2.default.createElement(_LocalizedDocumentMeta.LocalizedDocumentMeta, { title: metadata.title, description: metadata.description, keywords: metadata.keywords }),
	                _react2.default.createElement(
	                    'div',
	                    { id: 'left', className: 'main-left' },
	                    _react2.default.createElement(_Menu2.default, menuProps)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { id: 'right' },
	                    user && !matchIsBlocked && stream.src && _react2.default.createElement(_StreamPanel2.default, { stream: stream,
	                        stopFetchStreamAction: this.props.stopFetchStreamAction,
	                        streamName: streamName,
	                        user: user }),
	                    _react2.default.createElement(_BetPanel2.default, null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { id: 'center' },
	                    _react2.default.createElement(_Banner2.default, null),
	                    _react2.default.createElement(_Popular2.default, { gridLocalization: gridLocalization }),
	                    countryCode !== 'KG' && _react2.default.createElement(_News2.default, newsProps),
	                    this.context.footer
	                )
	            );
	        }
	    }]);
	    return MainPage;
	}(_react2.default.Component);
	
	MainPage.propTypes = {
	    languageId: _react2.default.PropTypes.number.isRequired,
	    news: _react2.default.PropTypes.array,
	    gridSelection: _react2.default.PropTypes.object.isRequired,
	    gridLocalization: _react2.default.PropTypes.object.isRequired,
	    stream: _react2.default.PropTypes.object.isRequired,
	    initPreMatchMenuAction: _react2.default.PropTypes.func.isRequired,
	    getPopularMatchesAction: _react2.default.PropTypes.func.isRequired,
	    toggleSportMainAction: _react2.default.PropTypes.func.isRequired,
	    push: _react2.default.PropTypes.func.isRequired,
	    getNewsAction: _react2.default.PropTypes.func.isRequired,
	    stopFetchStreamAction: _react2.default.PropTypes.func.isRequired
	};
	MainPage.contextTypes = {
	    footer: _react2.default.PropTypes.object
	};
	
	
	function select(state) {
	    var languageId = state.application.get('languageId');
	    var countryCode = state.application.get('countryCode');
	    var news = state.application.get('news');
	    var gridSelection = state.application.getIn(['userGridSelection', 'main']);
	    var user = state.auth.get('user');
	    var stream = state.application.get('stream');
	
	    var match = state.application.getIn(['popularMatches', 'matches', state.application.get('stream').matchId]);
	
	    var matchIsBlocked = false;
	    var streamName = '';
	    if (match) {
	        matchIsBlocked = match.get('isBlocked');
	        streamName = match.get('name') ? match.get('name') : '';
	    }
	
	    return {
	        languageId: languageId,
	        countryCode: countryCode,
	        news: news,
	        gridSelection: gridSelection,
	        stream: stream,
	        user: user,
	        streamName: streamName,
	        matchIsBlocked: matchIsBlocked
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, {
	    initPreMatchMenuAction: _PreMatchMenu.initPreMatchMenu,
	    getNewsAction: _News3.getNews,
	    getPopularMatchesAction: _Popular3.fetchPopularMatches,
	    toggleSportMainAction: _UserSelection.toggleSportMain,
	    push: _reactRouterRedux.push,
	    stopFetchStreamAction: _Stream.stopFetchStream
	})(MainPage);

/***/ },
/* 1348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(162);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _regenerator = __webpack_require__(82);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _toConsumableArray2 = __webpack_require__(308);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _asyncToGenerator2 = __webpack_require__(97);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(25);
	
	var _reactRedux = __webpack_require__(9);
	
	var _gameUtils = __webpack_require__(343);
	
	var _SignIn = __webpack_require__(342);
	
	var _SignIn2 = _interopRequireDefault(_SignIn);
	
	var _reactIntl = __webpack_require__(8);
	
	var _messages = __webpack_require__(344);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopularGamesPage = function (_Component) {
	  (0, _inherits3.default)(PopularGamesPage, _Component);
	
	  function PopularGamesPage(props) {
	    var _this2 = this;
	
	    (0, _classCallCheck3.default)(this, PopularGamesPage);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PopularGamesPage.__proto__ || (0, _getPrototypeOf2.default)(PopularGamesPage)).call(this, props));
	
	    _this.handleLoadMoreGames = function () {
	      var _this$state = _this.state,
	          games = _this$state.games,
	          totalGames = _this$state.totalGames,
	          isLoading = _this$state.isLoading;
	
	
	      if (games.length >= totalGames || isLoading) {
	        return;
	      }
	      _this.setState(function (prevState) {
	        var newPage = prevState.page + 1;
	
	        if (!_this.state.isLoading) {
	          _this.fetchPopularGames(newPage, true);
	        }
	
	        return { page: newPage };
	      });
	    };
	
	    _this.fetchPopularGames = function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	        var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	        var append = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        var _this$state2, limit, games, offset, response, data, popularGames;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$state2 = _this.state, limit = _this$state2.limit, games = _this$state2.games;
	
	                _this.setState({ isLoading: true });
	
	                _context.prev = 2;
	                offset = (page - 1) * limit;
	                _context.next = 6;
	                return fetch('/api/games/all-games?limit=' + limit + '&offset=' + offset + '&isTop=true');
	
	              case 6:
	                response = _context.sent;
	                _context.next = 9;
	                return response.json();
	
	              case 9:
	                data = _context.sent;
	                popularGames = data.Items;
	
	
	                _this.setState(function (prevState) {
	                  return {
	                    isLoading: false,
	                    games: append ? [].concat((0, _toConsumableArray3.default)(prevState.games), (0, _toConsumableArray3.default)(popularGames)) : popularGames,
	                    totalGames: data.totalCount || prevState.totalGames
	                  };
	                });
	                _context.next = 18;
	                break;
	
	              case 14:
	                _context.prev = 14;
	                _context.t0 = _context['catch'](2);
	
	                console.error('Failed to fetch games by category:', _context.t0);
	                _this.setState({ isLoading: false });
	
	              case 18:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2, [[2, 14]]);
	      }));
	
	      return function () {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.openAuthModal = function () {
	      var user = _this.props.user;
	
	
	      if (user) {
	        alert('Игра не доступна');
	      } else {
	        _this.props.dispatch({ type: 'BEGIN_SIGNIN' });
	      }
	    };
	
	    _this.handleGameClickWrapper = function (gameId) {
	      var user = _this.props.user;
	
	      _this.setState({ isLoading: true });
	
	      (0, _gameUtils.handleGameClick)(gameId, user, function (loading) {
	        return _this.setState({ isLoading: loading });
	      }, function (errorCode) {
	        return (0, _gameUtils.handleErrorCode)(errorCode, _gameUtils.showErrorMessage, function () {
	          return _this.openAuthModal();
	        });
	      });
	    };
	
	    _this.saveFavoriteGamesToStorage = function (favoriteGames) {
	      localStorage.setItem('favoriteGames', (0, _stringify2.default)(favoriteGames));
	    };
	
	    _this.getFavoriteGamesFromStorage = function () {
	      try {
	        var favorites = localStorage.getItem('favoriteGames');
	        return favorites ? JSON.parse(favorites) : [];
	      } catch (error) {
	        console.error('Failed to parse favorite games from localStorage:', error);
	        return [];
	      }
	    };
	
	    _this.addGameToFavorites = function (gameId) {
	      var _this$state3 = _this.state,
	          favoriteGames = _this$state3.favoriteGames,
	          games = _this$state3.games;
	
	      var gameToAdd = games.find(function (game) {
	        return game.Id === gameId;
	      });
	
	      var updatedFavorites = [].concat((0, _toConsumableArray3.default)(favoriteGames), [gameToAdd]);
	      _this.setState({ favoriteGames: updatedFavorites }, function () {
	        _this.saveFavoriteGamesToStorage(updatedFavorites);
	      });
	    };
	
	    _this.removeGameFromFavorites = function (gameId) {
	      var updatedFavorites = _this.state.favoriteGames.filter(function (game) {
	        return game.Id !== gameId;
	      });
	      _this.setState({ favoriteGames: updatedFavorites }, function () {
	        _this.saveFavoriteGamesToStorage(updatedFavorites);
	      });
	    };
	
	    _this.unpinGame = function () {
	      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(gameId) {
	        var user, gamblerId, response;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                user = _this.props.user;
	
	                if (user) {
	                  _context2.next = 4;
	                  break;
	                }
	
	                alert('Зарегистрируйтесь для того чтобы удалить из избранных');
	                return _context2.abrupt('return');
	
	              case 4:
	                gamblerId = user.get('gamblerId');
	
	                if (!(gamblerId === null)) {
	                  _context2.next = 8;
	                  break;
	                }
	
	                alert('Зарегистрируйтесь для того чтобы удалить из избранных');
	                return _context2.abrupt('return');
	
	              case 8:
	                _context2.prev = 8;
	                _context2.next = 11;
	                return fetch('/api/games/un-pin/' + gameId, {
	                  method: 'POST',
	                  headers: { 'Content-Type': 'application/json' },
	                  body: (0, _stringify2.default)({ gamblerId: gamblerId })
	                });
	
	              case 11:
	                response = _context2.sent;
	
	
	                if (response.status === 200) {
	                  _this.removeGameFromFavorites(gameId);
	                } else {
	                  console.error('Failed to unpin the game');
	                }
	                _context2.next = 18;
	                break;
	
	              case 15:
	                _context2.prev = 15;
	                _context2.t0 = _context2['catch'](8);
	
	                console.error('Error unpinning the game:', _context2.t0);
	
	              case 18:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2, [[8, 15]]);
	      }));
	
	      return function (_x3) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.pinGame = function () {
	      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(gameId) {
	        var user, gamblerId, response;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                user = _this.props.user;
	
	                if (user) {
	                  _context3.next = 4;
	                  break;
	                }
	
	                alert('Зарегистрируйтесь для того чтобы добавить в избранные');
	                return _context3.abrupt('return');
	
	              case 4:
	                gamblerId = user.get('gamblerId');
	
	                if (!(gamblerId === null)) {
	                  _context3.next = 8;
	                  break;
	                }
	
	                alert('Зарегистрируйтесь для того чтобы добавить в избранные');
	                return _context3.abrupt('return');
	
	              case 8:
	                _context3.prev = 8;
	                _context3.next = 11;
	                return fetch('/api/games/pin/' + gameId, {
	                  method: 'POST',
	                  headers: { 'Content-Type': 'application/json' },
	                  body: (0, _stringify2.default)({ gamblerId: gamblerId })
	                });
	
	              case 11:
	                response = _context3.sent;
	
	
	                if (response.status === 200) {
	                  _this.addGameToFavorites(gameId);
	                } else {
	                  _this.removeGameFromFavorites(gameId);
	                }
	                _context3.next = 18;
	                break;
	
	              case 15:
	                _context3.prev = 15;
	                _context3.t0 = _context3['catch'](8);
	
	                console.error('Error pinning the game:', _context3.t0);
	
	              case 18:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2, [[8, 15]]);
	      }));
	
	      return function (_x4) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.openAuthModal = function () {
	      var user = _this.props.user;
	
	
	      if (user) {
	        alert('Игра не доступна');
	      } else {
	        _this.props.dispatch({ type: 'BEGIN_SIGNIN' });
	      }
	    };
	
	    _this.handleGameClickWrapper = function (gameId) {
	      var user = _this.props.user;
	
	      _this.setState({ isLoading: true });
	
	      (0, _gameUtils.handleGameClick)(gameId, user, function (loading) {
	        return _this.setState({ isLoading: loading });
	      }, function (errorCode) {
	        return (0, _gameUtils.handleErrorCode)(errorCode, _gameUtils.showErrorMessage, _this.openAuthModal);
	      });
	    };
	
	    _this.state = {
	      games: [],
	      isLoading: true,
	      showSignIn: false,
	      favoriteGames: _this.getFavoriteGamesFromStorage() || [],
	      page: 1,
	      limit: 20,
	      prevScrollPos: window.pageYOffset
	    };
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    _this.handleLoadMoreGames = _this.handleLoadMoreGames.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(PopularGamesPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchPopularGames();
	      window.addEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll() {
	      var _state = this.state,
	          prevScrollPos = _state.prevScrollPos,
	          isLoading = _state.isLoading;
	
	      var currentScrollPos = window.pageYOffset;
	      var isScrollingDown = currentScrollPos > prevScrollPos;
	
	      this.setState({ prevScrollPos: currentScrollPos });
	
	      if (isScrollingDown && window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 100 && !isLoading) {
	        this.handleLoadMoreGames();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state2 = this.state,
	          games = _state2.games,
	          isLoading = _state2.isLoading,
	          showSignIn = _state2.showSignIn;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'game-types-page' },
	        showSignIn && _react2.default.createElement(_SignIn2.default, null),
	        isLoading && _react2.default.createElement(_Loader2.default, null),
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/games' },
	          _react2.default.createElement(
	            'button',
	            { className: 'view-all-button' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, _messages.messages.goBackToGames)
	          )
	        ),
	        _react2.default.createElement(
	          'h1',
	          { className: 'page-title' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, _messages.messages.popular)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'game-list' },
	          games.length > 0 ? games.map(function (game) {
	            return (0, _gameUtils.renderGame)(game, _this3.handleGameClickWrapper, _this3.state.favoriteGames, _this3.pinGame, _this3.unpinGame);
	          }) : _react2.default.createElement(
	            'div',
	            null,
	            '\u0418\u0433\u0440 \u043D\u0435\u0442'
	          )
	        )
	      );
	    }
	  }]);
	  return PopularGamesPage;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.auth.get('user')
	  };
	};
	
	exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(PopularGamesPage));

/***/ },
/* 1349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(82);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _toConsumableArray2 = __webpack_require__(308);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _asyncToGenerator2 = __webpack_require__(97);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _Loader = __webpack_require__(60);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _reactRouterRedux = __webpack_require__(23);
	
	var _index = __webpack_require__(386);
	
	var _gameUtils = __webpack_require__(343);
	
	var _reactRouter = __webpack_require__(25);
	
	var _SignIn = __webpack_require__(342);
	
	var _SignIn2 = _interopRequireDefault(_SignIn);
	
	var _reactIntl = __webpack_require__(8);
	
	var _messages = __webpack_require__(344);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RecentGames = function (_React$Component) {
	  (0, _inherits3.default)(RecentGames, _React$Component);
	
	  function RecentGames(props) {
	    var _this2 = this;
	
	    (0, _classCallCheck3.default)(this, RecentGames);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (RecentGames.__proto__ || (0, _getPrototypeOf2.default)(RecentGames)).call(this, props));
	
	    _this.fetchGameHistory = function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(gamblerId) {
	        var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	        var append = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        var _this$state, limit, recentGames, offset, response, data, newGames;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$state = _this.state, limit = _this$state.limit, recentGames = _this$state.recentGames;
	
	
	                _this.setState({ loading: true });
	
	                _context.prev = 2;
	                offset = (page - 1) * limit;
	
	                console.log('Fetching with offset:', offset);
	                _context.next = 7;
	                return fetch('/api/games/history?gamblerId=' + gamblerId + '&limit=' + limit + '&offset=' + offset);
	
	              case 7:
	                response = _context.sent;
	                _context.next = 10;
	                return response.json();
	
	              case 10:
	                data = _context.sent;
	
	                console.log('Game history data:', data);
	                newGames = data.Items.filter(function (newGame) {
	                  return !recentGames.some(function (existingGame) {
	                    return existingGame.Id === newGame.Id;
	                  });
	                });
	
	
	                _this.setState(function (prevState) {
	                  return {
	                    recentGames: [].concat((0, _toConsumableArray3.default)(prevState.recentGames), (0, _toConsumableArray3.default)(newGames)),
	                    loading: false,
	                    hasMoreGames: newGames.length === limit
	                  };
	                });
	                _context.next = 20;
	                break;
	
	              case 16:
	                _context.prev = 16;
	                _context.t0 = _context['catch'](2);
	
	                console.error('Error fetching game history:', _context.t0);
	                _this.setState({ loading: false });
	
	              case 20:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2, [[2, 16]]);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.openAuthModal = function () {
	      var user = _this.props.user;
	
	
	      if (user) {
	        alert('Игра не доступна');
	      } else {
	        _this.props.dispatch({ type: 'BEGIN_SIGNIN' });
	      }
	    };
	
	    _this.handleGameClickWrapper = function (gameId) {
	      var user = _this.props.user;
	
	      _this.setState({ isLoading: true });
	
	      (0, _gameUtils.handleGameClick)(gameId, user, function (loading) {
	        return _this.setState({ isLoading: loading });
	      }, function (errorCode) {
	        return (0, _gameUtils.handleErrorCode)(errorCode, _gameUtils.showErrorMessage, function () {
	          return _this.openAuthModal();
	        });
	      });
	    };
	
	    _this.handleLoadMore = function () {
	      var gamblerId = _this.props.gamblerId;
	
	
	      if (!gamblerId) {
	        console.error('Gambler ID is not defined');
	        return;
	      }
	
	      _this.setState(function (prevState) {
	        var newPage = prevState.page + 1;
	        console.log('New Page:', newPage);
	
	        _this.fetchGameHistory(gamblerId, newPage, true);
	
	        return { page: newPage };
	      });
	    };
	
	    _this.renderGame = function (game) {
	      return _react2.default.createElement(
	        'div',
	        { key: game.Id, className: 'game-card', onClick: function onClick() {
	            return _this.handleGameClickWrapper(game.Id);
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'game-thumbnail' },
	          (game.ThumbnailUrl || '').endsWith(".mp4") ? _react2.default.createElement(
	            'video',
	            { poster: game.ThumbnailUrl, autoPlay: true, muted: true, loop: true, controls: false, className: 'game-image' },
	            _react2.default.createElement('source', { src: game.ThumbnailUrl, type: 'video/mp4' })
	          ) : _react2.default.createElement('img', { src: game.ThumbnailUrl, alt: 'Game ' + game.Name, className: 'game-image' }),
	          _react2.default.createElement(
	            'h3',
	            { className: 'game-title' },
	            game.Name
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      loading: false,
	      gamblerIdCheckInterval: null,
	      recentGames: [],
	      page: 1,
	      limit: 100,
	      hasMoreGames: true,
	      showSignIn: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(RecentGames, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var gamblerIdCheckInterval = setInterval(function () {
	        var gamblerId = _this3.props.gamblerId;
	
	        if (gamblerId) {
	          _this3.fetchGameHistory(gamblerId);
	          clearInterval(_this3.state.gamblerIdCheckInterval);
	        }
	      }, 500);
	
	      this.setState({ gamblerIdCheckInterval: gamblerIdCheckInterval });
	    }
	    // componentDidUpdate(prevProps) {
	    //   const { gamblerId } = this.props
	    //   console.log('Updated gamblerId:', gamblerId)
	    //   if (prevProps.params.categoryId !== gamblerId) {
	    //     this.setState({ category: gamblerId }, () => {
	    //       this.fetchGamesByCategory(gamblerId)
	    //     })
	    //   }
	    // }
	
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.gamblerIdCheckInterval) {
	        clearInterval(this.state.gamblerIdCheckInterval);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loading = _state.loading,
	          recentGames = _state.recentGames,
	          showSignIn = _state.showSignIn;
	
	
	      if (loading && recentGames.length === 0) {
	        return _react2.default.createElement(_Loader2.default, null);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'favorite-games' },
	        showSignIn && _react2.default.createElement(_SignIn2.default, null),
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/games' },
	          _react2.default.createElement(
	            'button',
	            { className: 'view-all-button' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, _messages.messages.goBackToGames)
	          )
	        ),
	        _react2.default.createElement(
	          'h1',
	          { className: 'title' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, _messages.messages.recentGames)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'game-grid' },
	          recentGames.length > 0 ? recentGames.map(this.renderGame) : _react2.default.createElement(
	            'p',
	            { className: 'no-favorites' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, _messages.messages.recentGamesNot)
	          )
	        )
	      );
	    }
	  }]);
	  return RecentGames;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state, dispatch) {
	  var user = state.auth.get('user');
	  return {
	    gamblerId: user && user.get('gamblerId'),
	    languageId: state.application.get('languageId'),
	    user: user,
	    dispatch: dispatch
	  };
	}, { push: _reactRouterRedux.push, dispatch: function dispatch(_dispatch) {
	    return _dispatch;
	  }, joinXpressGameAction: _index.joinXpressGame })(RecentGames);

/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouter = __webpack_require__(25);
	
	var _Auth = __webpack_require__(95);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SignIn = function (_React$Component) {
	  (0, _inherits3.default)(SignIn, _React$Component);
	
	  function SignIn() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SignIn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SignIn.__proto__ || (0, _getPrototypeOf2.default)(SignIn)).call.apply(_ref, [this].concat(args))), _this), _this.componentDidMount = function () {
	      _this.props.beginSignIn();
	      _this.props.router.push('/');
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SignIn, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'h1',
	        null,
	        'SignIn'
	      );
	    }
	  }]);
	  return SignIn;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(function (s) {
	  return s;
	}, { beginSignIn: _Auth.beginSignIn })(SignIn));

/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouter = __webpack_require__(25);
	
	var _Auth = __webpack_require__(95);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SignUp = function (_React$Component) {
	  (0, _inherits3.default)(SignUp, _React$Component);
	
	  function SignUp() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SignUp);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SignUp.__proto__ || (0, _getPrototypeOf2.default)(SignUp)).call.apply(_ref, [this].concat(args))), _this), _this.componentDidMount = function () {
	      _this.props.beginJoin();
	      _this.props.router.push('/');
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SignUp, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'h1',
	        null,
	        'SignUp'
	      );
	    }
	  }]);
	  return SignUp;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(function (s) {
	  return s;
	}, { beginJoin: _Auth.beginJoin })(SignUp));

/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouterRedux = __webpack_require__(23);
	
	var _LocalizedDocumentMeta = __webpack_require__(339);
	
	var _Menu = __webpack_require__(801);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Sports = __webpack_require__(803);
	
	var _Sports2 = _interopRequireDefault(_Sports);
	
	var _Sport = __webpack_require__(802);
	
	var _Sport2 = _interopRequireDefault(_Sport);
	
	var _League = __webpack_require__(800);
	
	var _League2 = _interopRequireDefault(_League);
	
	var _Pagination = __webpack_require__(1176);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _gridControl = __webpack_require__(778);
	
	var _gridControl2 = _interopRequireDefault(_gridControl);
	
	var _betPanelControl = __webpack_require__(771);
	
	var _betPanelControl2 = _interopRequireDefault(_betPanelControl);
	
	var _Line = __webpack_require__(562);
	
	var _PreMatchMenu = __webpack_require__(738);
	
	var _UserSelection = __webpack_require__(489);
	
	var _metadata = __webpack_require__(340);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import {defineMessages} from 'react-intl';
	function loadData(props) {
	    var _props$routeParams = props.routeParams,
	        sportId = _props$routeParams.sportId,
	        leagueId = _props$routeParams.leagueId,
	        languageId = props.languageId;
	
	
	    if (!sportId && !leagueId) {
	        props.requestLineHeadersAction({ languageId: languageId });
	    } else if (sportId && !leagueId) {
	        props.requestSportLineHeadersAction({ sportId: sportId, languageId: languageId });
	    } else if (sportId && leagueId) {
	        props.requestLeagueLineHeadersAction({ leagueId: leagueId, languageId: languageId });
	    }
	}
	
	function filterMatches(matches, date, filter) {
	    if (filter === null || filter === undefined) {
	        return matches;
	    }
	
	    return matches.filter(function (m) {
	        return m.get('startDate') <= date;
	    });
	}
	
	var SportsPage = function (_React$Component) {
	    (0, _inherits3.default)(SportsPage, _React$Component);
	
	    function SportsPage(props, context) {
	        (0, _classCallCheck3.default)(this, SportsPage);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (SportsPage.__proto__ || (0, _getPrototypeOf2.default)(SportsPage)).call(this, props, context));
	
	        _this._menuShowAll = _this._menuShowAll.bind(_this);
	        _this._sportClick = _this._sportClick.bind(_this);
	        _this._leagueClick = _this._leagueClick.bind(_this);
	        _this.changePage = _this.changePage.bind(_this);
	        _this.changeFilter = _this.changeFilter.bind(_this);
	        _this.state = { currentPage: 1, perPage: 50, filter: null };
	        return _this;
	    }
	
	    (0, _createClass3.default)(SportsPage, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                initPreMatchMenuAction = _props.initPreMatchMenuAction,
	                showAllPrematchAction = _props.showAllPrematchAction,
	                toggleSportPrematchAction = _props.toggleSportPrematchAction,
	                toggleLeaguePrematchAction = _props.toggleLeaguePrematchAction,
	                languageId = _props.languageId,
	                routeParams = _props.routeParams;
	            var sportId = routeParams.sportId,
	                leagueId = routeParams.leagueId;
	
	
	            if (!sportId && !leagueId) {
	                showAllPrematchAction();
	            } else if (sportId && !leagueId) {
	                toggleSportPrematchAction({ id: sportId, showMatches: true });
	            } else if (sportId && leagueId) {
	                toggleLeaguePrematchAction({ id: leagueId, sportId: sportId, showMatches: true });
	            }
	
	            initPreMatchMenuAction({ languageId: languageId });
	            loadData((0, _extends3.default)({}, this.props));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.routeParams !== this.props.routeParams || nextProps.languageId !== this.props.languageId) {
	
	                if (!nextProps.routeParams.sportId && !nextProps.routeParams.leagueId) {
	                    this.props.showAllPrematchAction();
	                } else if (nextProps.routeParams.sportId && !nextProps.routeParams.leagueId) {
	                    this.props.toggleSportPrematchAction({ id: nextProps.routeParams.sportId, showMatches: true });
	                } else if (nextProps.routeParams.sportId && nextProps.routeParams.leagueId) {
	                    this.props.toggleLeaguePrematchAction({
	                        id: nextProps.routeParams.leagueId,
	                        sportId: nextProps.routeParams.sportId,
	                        showMatches: true
	                    });
	                }
	
	                loadData((0, _extends3.default)({}, nextProps));
	
	                var state = this.state;
	                this.setState((0, _extends3.default)({}, state, { currentPage: 1, paginationItemCount: nextProps.matches.size }));
	            }
	
	            if (nextProps.languageId !== this.props.languageId) {
	                this.props.initPreMatchMenuAction({ languageId: nextProps.languageId });
	            }
	        }
	    }, {
	        key: 'calculateMatchCount',
	        value: function calculateMatchCount() {
	            var matchCounter = 0;
	            var $this = this;
	
	            var dateFilter = void 0;
	
	            var filter = this.state.filter;
	
	
	            if (filter === null) {
	                dateFilter = null;
	            } else {
	                var date = new Date();
	
	                dateFilter = new Date(date.getTime() + filter * 60 * 60 * 1000);
	            }
	
	            this.props.leagues.map(function (league) {
	                var leagueMatches = $this.props.matches.filter(function (match) {
	                    return match.get('leagueId') === league.get('id');
	                });
	                var filteredMatches = [];
	                if (leagueMatches.size > 0) {
	                    filteredMatches = filterMatches(leagueMatches, dateFilter, $this.state.filter);
	                }
	                matchCounter += filteredMatches.size;
	            });
	
	            return matchCounter;
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.clearLineAction();
	        }
	    }, {
	        key: '_menuShowAll',
	        value: function _menuShowAll() {
	            this.props.push('/sports');
	        }
	    }, {
	        key: '_sportClick',
	        value: function _sportClick(id) {
	            this.props.push('/sports/' + id);
	        }
	    }, {
	        key: '_leagueClick',
	        value: function _leagueClick(sportId, id) {
	            this.props.push('/sports/' + sportId + '/' + id);
	        }
	    }, {
	        key: 'changePage',
	        value: function changePage(currentPage) {
	            var state = this.state;
	            this.setState((0, _extends3.default)({}, state, { currentPage: currentPage }));
	        }
	    }, {
	        key: 'changeFilter',
	        value: function changeFilter(filter) {
	            var state = this.state;
	            this.setState((0, _extends3.default)({}, state, { filter: filter, currentPage: 1 }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                toggleSportPrematchAction = _props2.toggleSportPrematchAction,
	                toggleLeaguePrematchAction = _props2.toggleLeaguePrematchAction,
	                gridSelection = _props2.gridSelection,
	                gridLocalization = _props2.gridLocalization,
	                routeParams = _props2.routeParams,
	                isShortcut = _props2.isShortcut,
	                countryCode = _props2.countryCode;
	
	
	            var menu = {
	                params: routeParams,
	                showSlider: true,
	                showBookmarks: false,
	                showCalendar: true,
	                showMatches: false,
	                sportsElement: _Sports2.default,
	                sportElement: _Sport2.default,
	                leagueElement: _League2.default,
	                showAllSports: true,
	                gridSelection: gridSelection,
	                showAllCallback: this._menuShowAll,
	                sportClickCallback: this._sportClick,
	                leagueClickCallback: this._leagueClick,
	                selectionToggleCallback: toggleSportPrematchAction,
	                selectionToggleLeagueCallback: toggleLeaguePrematchAction,
	                isShortcut: isShortcut
	            };
	
	            var sportProps = {
	                section: "preMatch",
	                matchId: routeParams.matchId,
	                sportId: routeParams.sportId,
	                currentPage: this.state.currentPage,
	                perPage: this.state.perPage,
	                gridLocalization: gridLocalization,
	                changeFilter: this.changeFilter
	            };
	
	            var metadata = (0, _metadata.getMetadata)(countryCode, routeParams.sportId);
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'no-scroll-wrapper' },
	                _react2.default.createElement(_LocalizedDocumentMeta.LocalizedDocumentMeta, { title: metadata.title, description: metadata.description, keywords: metadata.keywords }),
	                _react2.default.createElement(
	                    'div',
	                    { id: 'left', className: 'sports-left' },
	                    _react2.default.createElement(_Menu2.default, menu)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { id: 'right' },
	                    _react2.default.createElement(_betPanelControl2.default, null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { id: 'center', className: 'sports-center' },
	                    _react2.default.createElement(_gridControl2.default, sportProps),
	                    !this.props.routeParams.leagueId && _react2.default.createElement(_Pagination2.default, {
	                        count: this.calculateMatchCount(),
	                        perPage: this.state.perPage,
	                        currentPage: this.state.currentPage,
	                        changePage: this.changePage
	                    })
	                )
	            );
	        }
	    }]);
	    return SportsPage;
	}(_react2.default.Component);
	
	SportsPage.propTypes = {
	    languageId: _react2.default.PropTypes.number.isRequired,
	    routeParams: _react2.default.PropTypes.object,
	    gridSelection: _react2.default.PropTypes.object.isRequired,
	    gridLocalization: _react2.default.PropTypes.object.isRequired,
	    initPreMatchMenuAction: _react2.default.PropTypes.func.isRequired,
	    requestLineHeadersAction: _react2.default.PropTypes.func.isRequired,
	    requestSportLineHeadersAction: _react2.default.PropTypes.func.isRequired,
	    requestLeagueLineHeadersAction: _react2.default.PropTypes.func.isRequired,
	    clearLineAction: _react2.default.PropTypes.func.isRequired,
	    toggleSportPrematchAction: _react2.default.PropTypes.func.isRequired,
	    toggleLeaguePrematchAction: _react2.default.PropTypes.func.isRequired,
	    showAllPrematchAction: _react2.default.PropTypes.func.isRequired,
	    push: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select(state, props) {
	    var languageId = state.application.get('languageId');
	    var gridSelection = state.application.getIn(['userGridSelection', 'preMatch']);
	    var matches = state.application.getIn(['preMatch', 'matches']);
	    var leagues = state.application.getIn(['preMatch', 'leagues']);
	    var countryCode = state.application.get('countryCode');
	
	    return {
	        languageId: languageId,
	        gridSelection: gridSelection,
	        matches: matches,
	        leagues: leagues,
	        countryCode: countryCode
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(select, {
	    initPreMatchMenuAction: _PreMatchMenu.initPreMatchMenu,
	    requestLineHeadersAction: _Line.requestLineHeaders,
	    requestSportLineHeadersAction: _Line.requestSportLineHeaders,
	    requestLeagueLineHeadersAction: _Line.requestLeagueLineHeaders,
	    clearLineAction: _Line.clearLine,
	    toggleSportPrematchAction: _UserSelection.toggleSportPrematch,
	    toggleLeaguePrematchAction: _UserSelection.toggleLeaguePrematch,
	    showAllPrematchAction: _UserSelection.showAllPrematch,
	    push: _reactRouterRedux.push
	})(SportsPage);

/***/ },
/* 1353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _index = __webpack_require__(565);
	
	var _SportType = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAvailableStreamSport(sportId) {
	  return [_SportType.FOOTBALL, _SportType.ICE_HOCKEY, _SportType.BASKETBALL].includes(sportId);
	}
	
	var BetradarWidget = function (_Component) {
	  (0, _inherits3.default)(BetradarWidget, _Component);
	
	  function BetradarWidget() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, BetradarWidget);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BetradarWidget.__proto__ || (0, _getPrototypeOf2.default)(BetradarWidget)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      streamURL: null
	    }, _this.componentDidMount = function () {
	      var _this$props = _this.props,
	          activeWidgetId = _this$props.activeWidgetId,
	          activeWidgetSportId = _this$props.activeWidgetSportId;
	
	      _this.checkStreamStatus();
	      window.radarWidget.start(activeWidgetId, activeWidgetSportId);
	    }, _this.componentDidUpdate = function (prevProps) {
	      var _this$props2 = _this.props,
	          gamblerId = _this$props2.gamblerId,
	          streamURL = _this$props2.streamURL,
	          activeWidgetId = _this$props2.activeWidgetId,
	          activeWidgetSportId = _this$props2.activeWidgetSportId;
	
	      if (prevProps.activeWidgetId !== activeWidgetId || prevProps.streamURL !== streamURL || prevProps.gamblerId !== gamblerId) {
	        _this.checkStreamStatus();
	        window.radarWidget.start(activeWidgetId, activeWidgetSportId);
	      }
	    }, _this.checkStreamStatus = function () {
	      var _this$props3 = _this.props,
	          activeWidgetId = _this$props3.activeWidgetId,
	          activeWidgetSportId = _this$props3.activeWidgetSportId,
	          gamblerId = _this$props3.gamblerId,
	          balance = _this$props3.balance;
	
	
	      if (isAvailableStreamSport(activeWidgetSportId) && gamblerId && balance > 0) {
	        fetch('/api/betradar/?radarId=' + activeWidgetId).then(function (r) {
	          return r.json();
	        }).then(function (streamURL) {
	          if (streamURL) {
	            _this.setState({ streamURL: streamURL });
	          } else {
	            _this.setState({ streamURL: '' });
	          }
	        });
	      } else {
	        _this.setState({ streamURL: '' });
	      }
	    }, _this.openPlayerWindow = function () {
	      _this.closePlayerWindow();
	      var windowWidth = window.screen.width || window.innerWidth;
	
	      var streamWidth = windowWidth / 2;
	      var streamHeight = streamWidth / 1.78;
	
	      _this.windowPlayer = window.open('/sportradar-stream.html?name=' + _this.props.name + '&radarId=' + _this.props.activeWidgetId + '&width=' + streamWidth + '&height=' + streamHeight, _this.props.name, 'width=' + streamWidth + ',height=' + streamHeight + ',resize=no');
	    }, _this.closePlayerWindow = function () {
	      if (_this.windowPlayer) {
	        _this.windowPlayer.close();
	        delete _this.windowPlayer;
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(BetradarWidget, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var streamURL = this.state.streamURL;
	      var _props = this.props,
	          name = _props.name,
	          activeWidgetId = _props.activeWidgetId;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'widget-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'widget-container__header' },
	            _react2.default.createElement(
	              'span',
	              { className: 'name' },
	              name
	            ),
	            streamURL && _react2.default.createElement('div', { className: 'toggle-btn', onClick: this.openPlayerWindow }),
	            _react2.default.createElement('div', { className: 'close-btn', onClick: function onClick() {
	                _this2.closePlayerWindow();
	                _this2.props.removeRadarWidget();
	              } })
	          ),
	          _react2.default.createElement('div', { key: activeWidgetId, className: 'match-widget' })
	        )
	      );
	    }
	  }]);
	  return BetradarWidget;
	}(_react.Component);
	
	var withBetradarHOC = function withBetradarHOC(Component) {
	  return function (props) {
	    if (props.activeWidgetId) {
	      return _react2.default.createElement(Component, props);
	    }
	    return null;
	  };
	};
	
	function mapStateToProps(state) {
	  var user = state.auth.get('user');
	  var balance = state.balance.get('value');
	  var gamblerId = user ? user.get('gamblerId') : false;
	
	  return (0, _extends3.default)({}, state.application.get('betradar'), {
	    gamblerId: gamblerId,
	    balance: balance
	  });
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { removeRadarWidget: _index.removeRadarWidget })(withBetradarHOC(BetradarWidget));

/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMaskedinput = __webpack_require__(114);
	
	var _reactMaskedinput2 = _interopRequireDefault(_reactMaskedinput);
	
	var _reactIntl = __webpack_require__(8);
	
	var _reactVirtualizedSelect = __webpack_require__(1968);
	
	var _reactVirtualizedSelect2 = _interopRequireDefault(_reactVirtualizedSelect);
	
	var _domainUtils = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CountryOptionRenderer(_ref) {
	    var focusedOption = _ref.focusedOption,
	        focusOption = _ref.focusOption,
	        option = _ref.option,
	        selectValue = _ref.selectValue,
	        valueArray = _ref.valueArray,
	        style = _ref.style;
	
	    var classNames = ["countryOption"];
	    if (option === focusedOption) {
	        classNames.push("countryOptionFocused");
	    }
	    if (valueArray.indexOf(option)) {
	        classNames.push("countryOptionSelected");
	        classNames.push(option.iconClass);
	    }
	    var optionStyle = (0, _extends3.default)({}, style, {
	        backgroundRepeat: 'no-repeat',
	        width: '300px'
	    });
	
	    return _react2.default.createElement(
	        'div',
	        { className: classNames.join(' '),
	            style: optionStyle,
	            onClick: function onClick() {
	                return selectValue(option);
	            },
	            onMouseOver: function onMouseOver() {
	                return focusOption(option);
	            } },
	        _react2.default.createElement(
	            'label',
	            { className: 'countryLabel' },
	            option.name
	        )
	    );
	}
	
	var selectedCountryTemplate = function selectedCountryTemplate(country) {
	    return _react2.default.createElement('div', { key: country.id, className: country.iconClass });
	};
	
	var FormCountryPhoneField = function (_React$Component) {
	    (0, _inherits3.default)(FormCountryPhoneField, _React$Component);
	    (0, _createClass3.default)(FormCountryPhoneField, null, [{
	        key: 'renderHint',
	        value: function renderHint(hint) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'hint hint--error' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, hint)
	            );
	        }
	    }]);
	
	    function FormCountryPhoneField(props) {
	        (0, _classCallCheck3.default)(this, FormCountryPhoneField);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (FormCountryPhoneField.__proto__ || (0, _getPrototypeOf2.default)(FormCountryPhoneField)).call(this, props));
	
	        _this._handleOnChange = _this._handleOnChange.bind(_this);
	
	        var countryId = props.countryId.value;
	        var country = props.countries[countryId];
	
	        _this.state = {
	            menuIsOpen: true,
	            value: {
	                id: countryId,
	                iconClass: country.short,
	                name: country.name
	            }
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(FormCountryPhoneField, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.countryCode.value !== nextProps.countryCode.value) {
	                var tel = this.refs.tel.mask.value.join('');
	
	                var newLength = nextProps.numberLength.value;
	                var oldLength = this.props.numberLength.value;
	
	                if (newLength > oldLength) {
	                    var diff = newLength - oldLength;
	                    for (var i = 0; i < diff; i++) {
	                        tel = tel.concat('_');
	                    }
	                } else {
	                    tel = tel.substring(0, newLength);
	                }
	
	                nextProps.phone.onChange(tel);
	            }
	        }
	    }, {
	        key: '_handleOnChange',
	        value: function _handleOnChange(e) {
	            if (!e.id) {
	                return;
	            }
	
	            var countryId = e.id;
	            var country = this.props.countries[countryId];
	            var countryCode = country.mask;
	            var countryNumberLength = country.length;
	
	            this.props.countryId.onChange(countryId);
	            this.props.countryCode.onChange(countryCode);
	            this.props.numberLength.onChange(countryNumberLength);
	
	            this.setState({
	                menuIsOpen: true,
	                value: {
	                    id: countryId,
	                    name: country.name,
	                    iconClass: country.short
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                required = _props.required,
	                phone = _props.phone,
	                countryOptions = _props.countryOptions,
	                message = _props.message,
	                countryCode = _props.countryCode,
	                numberLength = _props.numberLength,
	                joinError = _props.joinError,
	                msg = _props.msg;
	
	
	            var notRequiredLabelClass = 'login--form__label form__label';
	            var requiredLabelClass = 'login--form__label form__label form__label__required';
	
	            var phoneInputClass = 'login--form__control form__phone-control';
	            var countryInputClass = 'login--form__control form__country-control';
	            var codeLabelClass = 'login--form__label form__code-label';
	
	            var labelClass = required ? requiredLabelClass : notRequiredLabelClass;
	
	            var countryCodeStr = '(' + countryCode.value + ')';
	            var countrySelectDisabled = _domainUtils.isRingoKg || true;
	
	            var mask = '' + '111111111111'.slice(-numberLength.value);
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'form__row' },
	                _react2.default.createElement(
	                    'label',
	                    { className: labelClass },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, message)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex' } },
	                    _react2.default.createElement(_reactVirtualizedSelect2.default, { name: 'country',
	                        className: countryInputClass,
	                        autofocus: true,
	                        disabled: countrySelectDisabled,
	                        clearable: false,
	                        labelKey: 'name',
	                        options: countryOptions,
	                        valueKey: 'id',
	                        optionHeight: 32,
	                        onChange: this._handleOnChange,
	                        value: this.state.value,
	                        noResultsText: '',
	                        optionRenderer: CountryOptionRenderer,
	                        valueRenderer: selectedCountryTemplate }),
	                    _react2.default.createElement(
	                        'span',
	                        { className: codeLabelClass },
	                        countryCodeStr
	                    ),
	                    _react2.default.createElement(_reactMaskedinput2.default, (0, _extends3.default)({ mask: mask,
	                        size: numberLength.value,
	                        className: phoneInputClass,
	                        ref: 'tel'
	                    }, phone)),
	                    phone.touched && phone.error && FormCountryPhoneField.renderHint(phone.error),
	                    joinError && joinError === -2 && !phone.error && FormCountryPhoneField.renderHint(msg),
	                    joinError && joinError === -4 && !phone.error && FormCountryPhoneField.renderHint({
	                        id: 'join.errors.phone_not_found',
	                        defaultMessage: 'Некорректный номер телефона'
	                    })
	                )
	            );
	        }
	    }]);
	    return FormCountryPhoneField;
	}(_react2.default.Component);
	
	FormCountryPhoneField.propTypes = {
	    phone: _react2.default.PropTypes.object.isRequired,
	    countryId: _react2.default.PropTypes.object.isRequired,
	    message: _react2.default.PropTypes.object.isRequired,
	    countryCode: _react2.default.PropTypes.object.isRequired,
	    numberLength: _react2.default.PropTypes.object.isRequired,
	    countries: _react2.default.PropTypes.object.isRequired,
	    countryOptions: _react2.default.PropTypes.array.isRequired,
	    required: _react2.default.PropTypes.bool
	};
	exports.default = FormCountryPhoneField;

/***/ },
/* 1355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormCountrySelectField = function (_React$Component) {
	    (0, _inherits3.default)(FormCountrySelectField, _React$Component);
	
	    function FormCountrySelectField() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, FormCountrySelectField);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FormCountrySelectField.__proto__ || (0, _getPrototypeOf2.default)(FormCountrySelectField)).call.apply(_ref, [this].concat(args))), _this), _this._handleOnChange = function (e) {
	            var countryId = e.target.value;
	            var country = _this.props.countries[countryId];
	            var countryCode = country.mask;
	            var countryNumberLength = country.length;
	
	            _this.props.field.onChange(countryId);
	            _this.props.countryCodeField.onChange(countryCode);
	            _this.props.countryNumberLengthField.onChange(countryNumberLength);
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(FormCountrySelectField, [{
	        key: 'render',
	        value: function render() {
	            var notRequiredLabelClass = 'login--form__label form__label';
	            var requiredLabelClass = 'login--form__label form__label form__label__required';
	            var inputClass = 'login--form__control form__control';
	            var rowClass = 'form__row';
	
	            var _props = this.props,
	                required = _props.required,
	                field = _props.field,
	                message = _props.message,
	                options = _props.options,
	                disabled = _props.disabled;
	
	
	            var labelClass = required ? requiredLabelClass : notRequiredLabelClass;
	
	            return _react2.default.createElement(
	                'div',
	                { className: rowClass },
	                _react2.default.createElement(
	                    'label',
	                    { className: labelClass },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, message)
	                ),
	                _react2.default.createElement(
	                    'select',
	                    { className: inputClass, value: field.value,
	                        onChange: this._handleOnChange,
	                        onBlur: field.onBlur,
	                        disabled: disabled },
	                    options
	                ),
	                field.touched && field.error && FormCountrySelectField.renderHint(field.error)
	            );
	        }
	    }], [{
	        key: 'renderHint',
	        value: function renderHint(hint) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'hint hint--error' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, hint)
	            );
	        }
	    }]);
	    return FormCountrySelectField;
	}(_react2.default.Component);
	
	FormCountrySelectField.propTypes = {
	    field: _react2.default.PropTypes.object.isRequired,
	    countryCodeField: _react2.default.PropTypes.object.isRequired,
	    countryNumberLengthField: _react2.default.PropTypes.object.isRequired,
	    message: _react2.default.PropTypes.object.isRequired,
	    options: _react2.default.PropTypes.array.isRequired,
	    countries: _react2.default.PropTypes.object.isRequired,
	    required: _react2.default.PropTypes.bool
	};
	exports.default = FormCountrySelectField;

/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMaskedinput = __webpack_require__(114);
	
	var _reactMaskedinput2 = _interopRequireDefault(_reactMaskedinput);
	
	var _reactIntl = __webpack_require__(8);
	
	var _stripCorrectProps = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormDateField = function (_React$Component) {
	    (0, _inherits3.default)(FormDateField, _React$Component);
	
	    function FormDateField(props) {
	        (0, _classCallCheck3.default)(this, FormDateField);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (FormDateField.__proto__ || (0, _getPrototypeOf2.default)(FormDateField)).call(this, props));
	
	        _this._onChange = _this._onChange.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(FormDateField, [{
	        key: '_onChange',
	        value: function _onChange(e) {
	            this.props.field.onChange(e.target.value);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                required = _props.required,
	                field = _props.field,
	                message = _props.message;
	
	
	            var notRequiredLabelClass = 'login--form__label form__label';
	            var requiredLabelClass = 'login--form__label form__label form__label__required';
	
	            var inputClass = 'login--form__control form__control';
	
	            var labelClass = required ? requiredLabelClass : notRequiredLabelClass;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'form__row' },
	                _react2.default.createElement(
	                    'label',
	                    { className: labelClass },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, message)
	                ),
	                _react2.default.createElement(_reactMaskedinput2.default, (0, _extends3.default)({ mask: '11.11.1111',
	                    placeholder: 'dd.mm.yyyy',
	                    onChange: this._onChange,
	                    className: inputClass
	                }, (0, _stripCorrectProps.stripProps)(field))),
	                field.touched && field.error && FormDateField.renderHint(field.error)
	            );
	        }
	    }], [{
	        key: 'renderHint',
	        value: function renderHint(hint) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'hint hint--error' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, hint)
	            );
	        }
	    }]);
	    return FormDateField;
	}(_react2.default.Component);
	
	FormDateField.propTypes = {
	    field: _react2.default.PropTypes.object.isRequired,
	    message: _react2.default.PropTypes.object.isRequired,
	    required: _react2.default.PropTypes.bool
	};
	exports.default = FormDateField;

/***/ },
/* 1357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMaskedinput = __webpack_require__(114);
	
	var _reactMaskedinput2 = _interopRequireDefault(_reactMaskedinput);
	
	var _reactIntl = __webpack_require__(8);
	
	var _stripCorrectProps = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormPhoneField = function (_React$Component) {
	    (0, _inherits3.default)(FormPhoneField, _React$Component);
	
	    function FormPhoneField(props) {
	        (0, _classCallCheck3.default)(this, FormPhoneField);
	        return (0, _possibleConstructorReturn3.default)(this, (FormPhoneField.__proto__ || (0, _getPrototypeOf2.default)(FormPhoneField)).call(this, props));
	    }
	
	    (0, _createClass3.default)(FormPhoneField, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.countryCode.value !== nextProps.countryCode.value) {
	                var tel = this.refs.tel.mask.value.join('');
	
	                var newLength = nextProps.numberLength.value;
	                var oldLength = this.props.numberLength.value;
	
	                if (newLength > oldLength) {
	                    var diff = newLength - oldLength;
	                    for (var i = 0; i < diff; i++) {
	                        tel = tel.concat('_');
	                    }
	                } else {
	                    tel = tel.substring(0, newLength);
	                }
	
	                nextProps.field.onChange(tel);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                required = _props.required,
	                field = _props.field,
	                message = _props.message,
	                countryCode = _props.countryCode,
	                numberLength = _props.numberLength;
	
	
	            var notRequiredLabelClass = 'login--form__label form__label';
	            var requiredLabelClass = 'login--form__label form__label form__label__required';
	
	            var inputClass = 'login--form__control form__phone-control';
	            var codeLabelClass = 'login--form__label form__code-label';
	
	            var labelClass = required ? requiredLabelClass : notRequiredLabelClass;
	
	            var countryCodeStr = '(' + countryCode.value + ')';
	
	            var mask = '' + '111111111111'.slice(-numberLength.value);
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'form__row' },
	                _react2.default.createElement(
	                    'label',
	                    { className: labelClass },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, message)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex' } },
	                    _react2.default.createElement(
	                        'span',
	                        { className: codeLabelClass },
	                        countryCodeStr
	                    ),
	                    _react2.default.createElement(_reactMaskedinput2.default, (0, _extends3.default)({ mask: mask,
	                        size: numberLength.value,
	                        className: inputClass,
	                        ref: 'tel'
	                    }, (0, _stripCorrectProps.stripProps)(field))),
	                    field.touched && field.error && FormPhoneField.renderHint(field.error)
	                )
	            );
	        }
	    }], [{
	        key: 'renderHint',
	        value: function renderHint(hint) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'hint hint--error' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, hint)
	            );
	        }
	    }]);
	    return FormPhoneField;
	}(_react2.default.Component);
	
	FormPhoneField.propTypes = {
	    field: _react2.default.PropTypes.object.isRequired,
	    message: _react2.default.PropTypes.object.isRequired,
	    countryCode: _react2.default.PropTypes.object.isRequired,
	    numberLength: _react2.default.PropTypes.object.isRequired,
	    required: _react2.default.PropTypes.bool
	};
	exports.default = FormPhoneField;

/***/ },
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormRadioGroupField = function (_React$Component) {
	    (0, _inherits3.default)(FormRadioGroupField, _React$Component);
	    (0, _createClass3.default)(FormRadioGroupField, null, [{
	        key: 'renderHint',
	        value: function renderHint(hint) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'hint hint--error' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, hint)
	            );
	        }
	    }]);
	
	    function FormRadioGroupField(props) {
	        (0, _classCallCheck3.default)(this, FormRadioGroupField);
	        return (0, _possibleConstructorReturn3.default)(this, (FormRadioGroupField.__proto__ || (0, _getPrototypeOf2.default)(FormRadioGroupField)).call(this, props));
	    }
	
	    (0, _createClass3.default)(FormRadioGroupField, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                message = _props.message,
	                field = _props.field,
	                name = _props.name,
	                options = _props.options;
	
	
	            var notRequiredLabelClass = 'login--form__label form__label';
	            var rowClass = 'form__row';
	            var labelClass = notRequiredLabelClass;
	
	            var radioElements = [];
	            for (var i = 0; i < options.length; i++) {
	                var optionId = options[i].id;
	                var optionName = options[i].name;
	
	                radioElements.push(_react2.default.createElement(
	                    'label',
	                    { key: optionId, style: { paddingRight: '30px', cursor: 'pointer' } },
	                    _react2.default.createElement('input', { type: 'radio', name: name, value: optionId, checked: field.value == optionId,
	                        onChange: field.onChange,
	                        onBlur: field.onChange }),
	                    _react2.default.createElement(_reactIntl.FormattedMessage, optionName)
	                ));
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: rowClass },
	                _react2.default.createElement(
	                    'label',
	                    { className: labelClass },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, message)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { paddingTop: '5px' } },
	                    radioElements
	                )
	            );
	        }
	    }]);
	    return FormRadioGroupField;
	}(_react2.default.Component);
	
	FormRadioGroupField.propTypes = {
	    field: _react2.default.PropTypes.object.isRequired,
	    name: _react2.default.PropTypes.string.isRequired,
	    message: _react2.default.PropTypes.object.isRequired,
	    options: _react2.default.PropTypes.array.isRequired
	};
	exports.default = FormRadioGroupField;

/***/ },
/* 1359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    title: {
	        id: 'join.title',
	        defaultMessage: 'Регистрация'
	    },
	    linkSentTo: {
	        id: 'join.link_sent_to',
	        defaultMessage: 'Ссылка для подтверждения была выслана на {email}'
	    }
	});
	
	var _class = function (_React$Component) {
	    (0, _inherits3.default)(_class, _React$Component);
	
	    function _class() {
	        (0, _classCallCheck3.default)(this, _class);
	        return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(_class, [{
	        key: 'render',
	        value: function render() {
	            var email = this.props.email;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'modal--dialog' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal--header' },
	                    _react2.default.createElement('div', { className: 'header-inner--logotype__link' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'header-inner__title' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.title)
	                    ),
	                    _react2.default.createElement('button', { className: 'modal__close modal__close__green modal__close__js',
	                        onClick: this.props.cancelCallback })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal--content' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'modal--content__wrapper' },
	                        _react2.default.createElement(
	                            'p',
	                            { className: 'plain-text__paragraph modal--auth-recover__title' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'modal--auth-recover__title__span' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, messages.linkSentTo, { values: { email: email } }))
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return _class;
	}(_react2.default.Component);
	
	_class.propTypes = {
	    languageId: _react2.default.PropTypes.number.isRequired,
	    email: _react2.default.PropTypes.string.isRequired,
	    cancelCallback: _react2.default.PropTypes.func.isRequired
	};
	exports.default = _class;

/***/ },
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reduxForm = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(8);
	
	var _FormField = __webpack_require__(804);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _FormCountryPhoneField = __webpack_require__(1354);
	
	var _FormCountryPhoneField2 = _interopRequireDefault(_FormCountryPhoneField);
	
	var _FormSelectableField = __webpack_require__(805);
	
	var _FormSelectableField2 = _interopRequireDefault(_FormSelectableField);
	
	var _FormRadioGroupField = __webpack_require__(1358);
	
	var _FormRadioGroupField2 = _interopRequireDefault(_FormRadioGroupField);
	
	var _FastRegistrationFormValidation = __webpack_require__(1361);
	
	var _FastRegistrationFormValidation2 = _interopRequireDefault(_FastRegistrationFormValidation);
	
	var _FastJoinType = __webpack_require__(568);
	
	var FastJoinType = _interopRequireWildcard(_FastJoinType);
	
	var _domainUtils = __webpack_require__(27);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    joinType: {
	        id: 'join.fast.type',
	        defaultMessage: 'Регистрация по'
	    },
	    joinTypeSms: {
	        id: 'join.fast.type.sms',
	        defaultMessage: 'SMS'
	    },
	    joinTypeEmail: {
	        id: 'join.fast.type.email',
	        defaultMessage: 'E-mail'
	    },
	    email: {
	        id: 'join.fast.email',
	        defaultMessage: 'E-mail'
	    },
	    phone: {
	        id: 'join.fast.phone',
	        defaultMessage: 'Номер телефона'
	    },
	    currency: {
	        id: 'join.fast.currency',
	        defaultMessage: 'Валюта'
	    },
	    buttonJoin: {
	        id: 'join.fast.button_join',
	        defaultMessage: 'Зарегистрироваться'
	    },
	    tacAgree: {
	        id: 'join.fast.tac_agree',
	        defaultMessage: "Нажимая кнопку, вы соглашаетесь с <a href={rulesLink} target='_blank'>правилами компании</a>, <a href={privacyLink} target='_blank'>политикой конфиденциальности</a>, и подтверждаете свое совершеннолетие"
	    },
	    tacAgreeRingo: {
	        id: 'join.fast.tac_agree_ringo',
	        defaultMessage: "Нажимая кнопку, вы соглашаетесь с <a href={rulesLink} target='_blank'>правилами компании</a>, <a href={privacyLink} target='_blank'>политикой конфиденциальности</a>, и подтверждаете, что Ваш возраст превышает 21 год"
	    },
	    internalErrorText: {
	        id: 'join.errors.internal',
	        defaultMessage: 'Ошибка. Попробуйте позже'
	    },
	    smsExceededErrorText: {
	        id: 'join.errors.smsexceeded',
	        defaultMessage: 'Мы дважды выслали на Ваш номер сообщение для подтверждения счёта. Пожалуйста, дождитесь СМС, либо укажите e-mail и мы вышлем информацию о подтверждении счёта на него.'
	    },
	    emailTakenErrorText: {
	        id: 'join.errors.email_taken',
	        defaultMessage: 'E-mail используется'
	    },
	    phoneTakenErrorText: {
	        id: 'join.errors.phone_taken',
	        defaultMessage: 'Телефон используется'
	    },
	    promoTitle: {
	        id: 'promocode.title',
	        defaultMessage: 'Промо-код'
	    },
	    promoPlaceholder: {
	        id: 'promocode.enter',
	        defaultMessage: 'Введите промо-код'
	    },
	    '-1': {
	        id: "promocode.error.not_found",
	        defaultMessage: "Ошибка. Попробуйте позже"
	    },
	    '-2': {
	        id: "promocode.error.not_active",
	        defaultMessage: "Промокод уже использован"
	    },
	    '-3': {
	        id: "promocode.error.used",
	        defaultMessage: "Промокод не действителен"
	    },
	    '-4': {
	        id: "promocode.error.not_available",
	        defaultMessage: "Промокод не действителен"
	    }
	});
	
	var joinTypes = [{ id: FastJoinType.SMS, name: messages.joinTypeSms }, { id: FastJoinType.EMAIL, name: messages.joinTypeEmail }];
	
	var fields = ['promo', 'type', 'email', 'phone', 'countryId', 'countryCode', 'countryNumberLength', 'accountResourceId', 'PromocodeText'];
	
	var jsonSourceToOptions = function jsonSourceToOptions(jsonSource) {
	    var optionsArr = [];
	
	    var _loop = function _loop(itemKey) {
	        if (!jsonSource.hasOwnProperty(itemKey)) {
	            return 'continue';
	        }
	
	        var option = void 0;
	
	        if (jsonSource[itemKey].hasOwnProperty('id') && jsonSource[itemKey].hasOwnProperty('defaultMessage')) {
	            option = _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                (0, _extends3.default)({ key: itemKey }, jsonSource[itemKey]),
	                function (msg) {
	                    return _react2.default.createElement(
	                        'option',
	                        { key: itemKey, value: itemKey },
	                        msg
	                    );
	                }
	            );
	        } else {
	            option = _react2.default.createElement(
	                'option',
	                { key: itemKey, value: itemKey },
	                jsonSource[itemKey]
	            );
	        }
	
	        optionsArr.push(option);
	    };
	
	    for (var itemKey in jsonSource) {
	        var _ret = _loop(itemKey);
	
	        if (_ret === 'continue') continue;
	    }
	
	    return optionsArr;
	};
	
	var countriesJsonToOptions = function countriesJsonToOptions(jsonSource) {
	    var elements = [];
	    for (var itemKey in jsonSource) {
	        if (!jsonSource.hasOwnProperty(itemKey)) {
	            continue;
	        }
	
	        var country = jsonSource[itemKey];
	
	        elements.push({
	            id: itemKey,
	            key: itemKey,
	            iconClass: country.short,
	            name: country.name
	        });
	    }
	
	    return elements;
	};
	
	var FastRegistrationForm = function (_React$Component) {
	    (0, _inherits3.default)(FastRegistrationForm, _React$Component);
	
	    function FastRegistrationForm() {
	        var _ref;
	
	        var _temp, _this, _ret2;
	
	        (0, _classCallCheck3.default)(this, FastRegistrationForm);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret2 = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FastRegistrationForm.__proto__ || (0, _getPrototypeOf2.default)(FastRegistrationForm)).call.apply(_ref, [this].concat(args))), _this), _this._onSubmit = function (values) {
	            if (values.type == FastJoinType.SMS) {
	                var phone = /^\d+$/.test(values.phone) === false ? undefined : values.countryCode.substring(1).concat(values.phone);
	
	                _this.props.submitAction({
	                    Phone: phone,
	                    CountryId: values.countryId,
	                    AccountResourceId: values.accountResourceId,
	                    LanguageId: _this.props.languageId,
	                    Type: values.type,
	                    Promo: values.promo,
	                    PromocodeText: values.PromocodeText
	                });
	            } else if (values.type == FastJoinType.EMAIL) {
	                _this.props.submitAction({
	                    Email: values.email,
	                    AccountResourceId: values.accountResourceId,
	                    LanguageId: _this.props.languageId,
	                    Type: values.type,
	                    Promo: values.promo,
	                    PromocodeText: values.PromocodeText
	                });
	            }
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret2);
	    }
	
	    (0, _createClass3.default)(FastRegistrationForm, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                _props$fields = _props.fields,
	                type = _props$fields.type,
	                email = _props$fields.email,
	                phone = _props$fields.phone,
	                countryId = _props$fields.countryId,
	                countryCode = _props$fields.countryCode,
	                countryNumberLength = _props$fields.countryNumberLength,
	                accountResourceId = _props$fields.accountResourceId,
	                PromocodeText = _props$fields.PromocodeText,
	                handleSubmit = _props.handleSubmit,
	                submitting = _props.submitting,
	                joinError = _props.joinError,
	                promoCodeError = _props.promoCodeError,
	                joining = _props.joining,
	                accountResources = _props.accountResources,
	                countries = _props.countries,
	                domain = _props.domain,
	                fastJoin = _props.fastJoin;
	
	
	            var submitHandler = this._onSubmit;
	            var isSameEmail = email.value === (fastJoin && fastJoin.get('Email'));
	
	            var accountResourceOptions = jsonSourceToOptions(accountResources);
	            var countriesOptions = countriesJsonToOptions(countries);
	
	            var layerClass = 'login--form__row form__row';
	
	            var btnClass = 'login--form__btn login--form__btn__js form__btn';
	
	            var btnDisabled = submitting || joining || joinError === -3 && type.value == FastJoinType.SMS || type.value == 1 && phone.error || type.value == 2 && email.error;
	            if (btnDisabled) {
	                btnClass += ' disabled';
	            }
	
	            var errMessage = messages.internalErrorText;
	
	            if (joinError === -3) {
	                errMessage = messages.smsExceededErrorText;
	            }
	
	            if (joinError === -5 && promoCodeError) {
	                errMessage = messages[promoCodeError];
	            }
	
	            var agreeOptions = { rulesLink: '//help.' + domain, privacyLink: '//help.' + domain + '/privacy' };
	
	            if (countryCode.value === "+998") {
	                joinTypes[0] = { id: FastJoinType.SMS, name: messages.phone };
	            }
	
	            var showGlobalError = joinError;
	            if (joinError === -2 || joinError === -4) showGlobalError = false;
	
	            return _react2.default.createElement(
	                'form',
	                { className: 'login--form form', onSubmit: handleSubmit(submitHandler), autoComplete: 'off' },
	                showGlobalError && FastRegistrationForm.renderError(errMessage),
	                _react2.default.createElement(_FormRadioGroupField2.default, {
	                    message: messages.joinType,
	                    name: 'joinType',
	                    field: type,
	                    options: joinTypes }),
	                type.touched && type.error && FastRegistrationForm.renderHint(type.error),
	                type.value == FastJoinType.SMS && _react2.default.createElement(_FormCountryPhoneField2.default, { message: messages.phone,
	                    phone: phone,
	                    countryId: countryId,
	                    countries: countries,
	                    countryOptions: countriesOptions,
	                    countryCode: countryCode,
	                    numberLength: countryNumberLength,
	                    joinError: joinError,
	                    msg: messages.phoneTakenErrorText,
	                    required: true }),
	                type.value == FastJoinType.EMAIL && _react2.default.createElement(_FormField2.default, { message: messages.email, type: 'email', field: email, required: true, joinError: isSameEmail && joinError, msg: messages.emailTakenErrorText }),
	                _react2.default.createElement(_FormSelectableField2.default, {
	                    disabled: true,
	                    message: messages.currency,
	                    field: accountResourceId,
	                    options: accountResourceOptions,
	                    required: true }),
	                _react2.default.createElement(_FormField2.default, { message: messages.promoTitle, type: 'PromocodeText', field: PromocodeText, joinError: isSameEmail && joinError }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form__row form__row--terms' },
	                    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, (0, _extends3.default)({}, _domainUtils.isRingo ? messages.tacAgreeRingo : messages.tacAgree, { values: agreeOptions }))
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal--content__controls' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: layerClass },
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'submit',
	                                className: btnClass,
	                                disabled: btnDisabled,
	                                onClick: handleSubmit(submitHandler) },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.buttonJoin)
	                        )
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'renderError',
	        value: function renderError(error) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'error-message' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, error)
	            );
	        }
	    }, {
	        key: 'renderHint',
	        value: function renderHint(hint) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'hint hint--error' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, hint)
	            );
	        }
	    }]);
	    return FastRegistrationForm;
	}(_react2.default.Component);
	
	FastRegistrationForm.propTypes = {
	    fields: _react2.default.PropTypes.object.isRequired,
	    handleSubmit: _react2.default.PropTypes.func.isRequired,
	    submitting: _react2.default.PropTypes.bool.isRequired,
	    languageId: _react2.default.PropTypes.number.isRequired,
	    joining: _react2.default.PropTypes.bool.isRequired,
	    joinError: _react2.default.PropTypes.any,
	    promoCodeError: _react2.default.PropTypes.any,
	    accountResources: _react2.default.PropTypes.object.isRequired,
	    countries: _react2.default.PropTypes.object.isRequired,
	    domain: _react2.default.PropTypes.string.isRequired,
	    submitAction: _react2.default.PropTypes.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)()((0, _reduxForm.reduxForm)({
	    form: 'fast-registration-form',
	    fields: fields,
	    asyncBlurFields: ['email', 'phone', 'countryId', 'promo', 'PromocodeText'],
	    validate: _FastRegistrationFormValidation2.default
	})(FastRegistrationForm));

/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactIntl = __webpack_require__(8);
	
	var messages = (0, _reactIntl.defineMessages)({
	    requiredField: {
	        id: 'join.errors.required_field',
	        defaultMessage: 'Поле обязательно для заполнения'
	    },
	    invalidEmail: {
	        id: 'join.errors.email_invalid',
	        defaultMessage: 'E-mail указан неверно'
	    },
	    invalidPhone: {
	        id: 'join.errors.phone_invalid',
	        defaultMessage: 'Номер телефона указан неверно'
	    },
	    invalidPromo: {
	        id: 'join.errors.promo_length_error',
	        defaultMessage: 'Максимум 4 символа'
	    }
	});
	
	var FastRegistrationFormValidation = function FastRegistrationFormValidation(values) {
	    var errors = {};
	
	    var emailRegex = /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/;
	
	    if (!values.type || values.type != 1 && values.type != 2) {
	        errors.type = messages.requiredField;
	    }
	
	    if (values.type == 1) {
	        if (!values.phone || !values.phone.length) {
	            errors.phone = messages.requiredField;
	        } else if (/^\d+$/.test(values.phone) === false) {
	            errors.phone = messages.invalidPhone;
	        }
	    } else if (values.type == 2) {
	        if (!values.email || !values.email.length) {
	            errors.email = messages.requiredField;
	        } else if (emailRegex.test(values.email) === false) {
	            errors.email = messages.invalidEmail;
	        }
	    }
	
	    if (values.promo && values.promo.length > 4) {
	        errors.promo = messages.invalidPromo;
	    }
	
	    if (!values.accountResourceId) {
	        errors.accountResourceId = messages.requiredField;
	    }
	
	    return errors;
	};
	
	exports.default = FastRegistrationFormValidation;

/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(8);
	
	var _SingleContentModal = __webpack_require__(1167);
	
	var _SingleContentModal2 = _interopRequireDefault(_SingleContentModal);
	
	var _FastJoinType = __webpack_require__(568);
	
	var FastJoinType = _interopRequireWildcard(_FastJoinType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    title: {
	        id: 'join.fast.phone_confirm.title',
	        defaultMessage: 'Подтверждение номера телефона'
	    },
	    confirmButton: {
	        id: 'join.fast.phone_confirm.confirm_button',
	        defaultMessage: 'Подтвердить'
	    },
	    confirmationCode: {
	        id: 'join.fast.phone_confirm.confirmation_code',
	        defaultMessage: 'Код подтверждения'
	    },
	    smsReceivedText: {
	        id: 'join.fast.phone_confirm.sms_received_text',
	        defaultMessage: 'Вам был отправлен код по SMS. Используйте его для подтверждения номера телефона. ' + 'Обратите внимание, что доставка SMS может занять больше минуты.'
	    },
	    smsSentText: {
	        id: 'join.fast.phone_confirm.sms_sent_text',
	        defaultMessage: 'Сообщение было отправлено. '
	    },
	    smsResendInfoText: {
	        id: 'join.fast.phone_confirm.sms_resendinfo_text',
	        defaultMessage: 'Отправить сообщение заново можно будет через {seconds} секунд. '
	    },
	    callResendInfoText: {
	        id: 'join.fast.phone_confirm.call_resendinfo_text',
	        defaultMessage: 'Повторно запросить подтверждение можно будет через {seconds} секунд.'
	    },
	    smsResendText: {
	        id: 'join.fast.phone_confirm.sms_resend_text',
	        defaultMessage: 'Отправить сообщение заново'
	    },
	    callResendText: {
	        id: 'join.fast.phone_confirm.call_resend_text',
	        defaultMessage: 'Повторно запросить подтверждение'
	    },
	    smsResendButtonText: {
	        id: 'join.fast.phone_confirm.sms_resend_button_text',
	        defaultMessage: 'Отправить'
	    },
	    callResendButtonText: {
	        id: 'join.fast.phone_confirm.call_resend_button_text',
	        defaultMessage: 'Запросить'
	    },
	    confirmationError: {
	        id: 'join.fast.phone_confirm.errors.confirmation_fail',
	        defaultMessage: 'Ошибка при подтверждении'
	    },
	    sms_exceeded: {
	        id: 'join.fast.phone_confirm.errors.sms_exceeded',
	        defaultMessage: 'Мы дважды выслали на Ваш номер сообщение для подтверждения счёта. Пожалуйста, дождитесь СМС, либо укажите e-mail и мы вышлем информацию о подтверждении счёта на него.'
	    },
	    invalidConfirmationCode: {
	        id: 'join.fast.phone_confirm.errors.invalid_code',
	        defaultMessage: 'Неправильный код'
	    }
	});
	
	var _class = function (_React$Component) {
	    (0, _inherits3.default)(_class, _React$Component);
	
	    function _class(props) {
	        (0, _classCallCheck3.default)(this, _class);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, props));
	
	        _this._handleCodeConfirmClick = _this._handleCodeConfirmClick.bind(_this);
	        _this._handleResendSmsClick = _this._handleResendSmsClick.bind(_this);
	        _this._onChangeCode = _this._onChangeCode.bind(_this);
	        _this._tick = _this._tick.bind(_this);
	
	        _this.state = {
	            showResend: false,
	            seconds: 60,
	            intervalId: undefined
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(_class, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var intervalId = setInterval(this._tick, 1000);
	            var state = this.state;
	
	            this.setState((0, _extends3.default)({}, state, {
	                intervalId: intervalId
	            }));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps, nextState) {
	            if (nextState.showResend && !this.state.showResend) {
	                clearInterval(this.state.intervalId);
	            }
	            if (nextProps.fastJoin.get('RequestId') !== this.props.fastJoin.get('RequestId')) {
	                clearInterval(this.state.intervalId);
	
	                this.setState({
	                    showResend: false,
	                    seconds: 60,
	                    intervalId: setInterval(this._tick, 1000)
	                });
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearInterval(this.state.intervalId);
	        }
	    }, {
	        key: '_tick',
	        value: function _tick() {
	            var seconds = this.state.seconds - 1;
	            var showResend = seconds <= 0;
	
	            if (showResend) {
	                clearInterval(this.state.intervalId);
	            }
	
	            this.setState({
	                showResend: showResend,
	                seconds: seconds
	            });
	        }
	    }, {
	        key: '_onChangeCode',
	        value: function _onChangeCode(e) {
	            e.preventDefault();
	
	            /*const code = e.target.value;
	            let isValid = true;
	            for (let offset = 0; offset < code.length; offset++) {
	                const charCode = parseInt(code[offset].charCodeAt());
	                if (!((charCode > 47 && charCode < 58) ||
	                    (charCode > 64 && charCode < 91) ||
	                    (charCode > 96 && charCode < 123))) {
	                    isValid = false;
	                }
	            }
	            if (isValid) {
	                e.target.value = e.target.value.toUpperCase();
	            } else {
	                e.target.value = e.target.value.substring(0, e.target.value.length - 1);
	            }*/
	            e.target.value = e.target.value.toUpperCase();
	        }
	    }, {
	        key: '_handleCodeConfirmClick',
	        value: function _handleCodeConfirmClick(e) {
	            e.preventDefault();
	
	            var fastJoin = this.props.fastJoin;
	
	
	            var requestId = fastJoin.get('RequestId');
	            var phone = fastJoin.get('Phone');
	
	            var codeVal = this.refs.code.value;
	            if (codeVal) {
	                this.props.confirmPhone({ Phone: phone, RequestId: requestId, Code: codeVal.toUpperCase() });
	            }
	        }
	    }, {
	        key: '_handleResendSmsClick',
	        value: function _handleResendSmsClick(e) {
	            e.preventDefault();
	
	            var fastJoin = this.props.fastJoin;
	
	            this.props.resendCode({
	                Phone: fastJoin.get('Phone'),
	                CountryId: fastJoin.get('CountryId'),
	                AccountResourceId: fastJoin.get('AccountResourceId'),
	                LanguageId: this.props.languageId,
	                Type: FastJoinType.SMS
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                error = _props.error,
	                closeCallback = _props.closeCallback,
	                countryCode = _props.countryCode;
	            var _state = this.state,
	                seconds = _state.seconds,
	                showResend = _state.showResend;
	
	            var isUzCountry = countryCode === 'UZ';
	
	            var codeStyle = { textTransform: 'uppercase' };
	
	            var modalProps = {
	                type: "wide",
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, messages.title),
	                closeCallback: closeCallback
	            };
	
	            var formGroupClass = "form-group" + (error ? ' invalid' : '');
	
	            var msgError = _react2.default.createElement(_reactIntl.FormattedMessage, messages.confirmationError);
	
	            if (error === -3) {
	                msgError = _react2.default.createElement(_reactIntl.FormattedMessage, messages.sms_exceeded);
	            }
	
	            return _react2.default.createElement(
	                _SingleContentModal2.default,
	                modalProps,
	                _react2.default.createElement(
	                    'p',
	                    { className: 'plain-text__paragraph' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.smsReceivedText)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: formGroupClass },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.confirmationCode)
	                        ),
	                        _react2.default.createElement('input', { ref: 'code', length: 6, maxLength: 6, onChange: this._onChangeCode, style: codeStyle }),
	                        error && _react2.default.createElement(
	                            'div',
	                            { className: 'error' },
	                            msgError
	                        )
	                    ),
	                    showResend && error !== -3 && _react2.default.createElement(
	                        'div',
	                        { className: 'form-group action' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, isUzCountry ? messages.callResendText : messages.smsResendText)
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'btn btn-green', onClick: this._handleResendSmsClick },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, isUzCountry ? messages.callResendButtonText : messages.smsResendButtonText)
	                        )
	                    )
	                ),
	                !showResend && error !== -3 && _react2.default.createElement(
	                    'p',
	                    null,
	                    !isUzCountry && _react2.default.createElement(
	                        'span',
	                        { className: 'success-message' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.smsSentText)
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'hint-message' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, isUzCountry ? messages.callResendInfoText : messages.smsResendInfoText, { values: { seconds: seconds } }))
	                    )
	                ),
	                error !== -3 && _react2.default.createElement(
	                    'div',
	                    { className: 'center-buttons' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'btn btn-yellow', onClick: this._handleCodeConfirmClick },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, messages.confirmButton)
	                    )
	                )
	            );
	        }
	    }]);
	    return _class;
	}(_react2.default.Component);
	
	_class.propTypes = {
	    languageId: _react2.default.PropTypes.number.isRequired,
	    fastJoin: _react2.default.PropTypes.object.isRequired,
	    inProcess: _react2.default.PropTypes.bool.isRequired,
	    error: _react2.default.PropTypes.number,
	    confirmPhone: _react2.default.PropTypes.func.isRequired,
	    resendCode: _react2.default.PropTypes.func.isRequired,
	    closeCallback: _react2.default.PropTypes.func.isRequired
	};
	exports.default = _class;

/***/ },
/* 1363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(8);
	
	var _Alert = __webpack_require__(1162);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    successText: {
	        id: 'join.fast.success.text',
	        defaultMessage: 'Ваш счет успешно активирован!'
	    },
	    rechargeText: {
	        id: 'join.fast.success.recharge_text',
	        defaultMessage: 'Пополните баланс, чтобы начать игру'
	    },
	    btnRechargeText: {
	        id: 'join.fast.success.btn_recharge_text',
	        defaultMessage: 'Пополнить баланс'
	    }
	});
	
	var _class = function (_React$Component) {
	    (0, _inherits3.default)(_class, _React$Component);
	
	    function _class() {
	        (0, _classCallCheck3.default)(this, _class);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this));
	
	        _this._handleClick = _this._handleClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(_class, [{
	        key: '_handleClick',
	        value: function _handleClick() {
	            this.props.finalizeJoin();
	
	            window.open('//members.' + this.props.domain + '/balance/recharge', 'Recharge', "toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650");
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var alertProps = {
	                type: "wide",
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, messages.successText),
	                message: _react2.default.createElement(_reactIntl.FormattedMessage, messages.rechargeText),
	                btnText: _react2.default.createElement(_reactIntl.FormattedMessage, messages.btnRechargeText),
	                clickCallback: this._handleClick
	            };
	
	            return _react2.default.createElement(_Alert2.default, alertProps);
	        }
	    }]);
	    return _class;
	}(_react2.default.Component);
	
	_class.propTypes = {
	    languageId: _react2.default.PropTypes.number.isRequired,
	    domain: _react2.default.PropTypes.string.isRequired,
	    finalizeJoin: _react2.default.PropTypes.func.isRequired
	};
	exports.default = _class;

/***/ },
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _PhoneConfirmation = __webpack_require__(488);
	
	var _PhoneInput = __webpack_require__(1166);
	
	var _PhoneInput2 = _interopRequireDefault(_PhoneInput);
	
	var _CodeInput = __webpack_require__(1164);
	
	var _CodeInput2 = _interopRequireDefault(_CodeInput);
	
	var _ConfirmSuccess = __webpack_require__(1165);
	
	var _ConfirmSuccess2 = _interopRequireDefault(_ConfirmSuccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhoneConfirmation = function (_React$Component) {
	    (0, _inherits3.default)(PhoneConfirmation, _React$Component);
	
	    function PhoneConfirmation(props) {
	        (0, _classCallCheck3.default)(this, PhoneConfirmation);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (PhoneConfirmation.__proto__ || (0, _getPrototypeOf2.default)(PhoneConfirmation)).call(this, props));
	
	        _this._handleDenialClick = _this._handleDenialClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(PhoneConfirmation, [{
	        key: '_handleDenialClick',
	        value: function _handleDenialClick(e) {
	            e.preventDefault();
	
	            this.props.denyConfirmationAction();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                languageId = _props.languageId,
	                gamblerId = _props.gamblerId,
	                joinPromoType = _props.joinPromoType,
	                phone = _props.phone,
	                phoneConfirming = _props.phoneConfirming,
	                phoneConfirmationRequested = _props.phoneConfirmationRequested,
	                phoneConfirmationError = _props.phoneConfirmationError,
	                phoneConfirmed = _props.phoneConfirmed,
	                cancelCallback = _props.cancelCallback;
	
	
	            var defaultValues = {
	                initialValues: {
	                    phone: phone
	                }
	            };
	
	            var phoneInputProps = (0, _extends3.default)({
	                languageId: languageId,
	                gamblerId: gamblerId,
	                joinPromoType: joinPromoType,
	                phone: phone,
	                phoneConfirming: phoneConfirming,
	                phoneConfirmationError: phoneConfirmationError,
	                createPhoneConfirmation: this.props.createPhoneConfirmationAction,
	                denyConfirmationCallback: this._handleDenialClick
	            }, defaultValues);
	
	            var codeInputProps = {
	                languageId: languageId,
	                gamblerId: gamblerId,
	                phone: phone,
	                phoneConfirming: phoneConfirming,
	                phoneConfirmationError: phoneConfirmationError,
	                confirmPhone: this.props.confirmPhoneAction,
	                denyConfirmationCallback: this._handleDenialClick
	            };
	
	            var confirmSuccessProps = {
	                languageId: languageId,
	                joinPromoType: joinPromoType,
	                phone: phone,
	                cancelCallback: cancelCallback
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                !phoneConfirmationRequested && _react2.default.createElement(_PhoneInput2.default, phoneInputProps),
	                phoneConfirmationRequested && !phoneConfirmed && _react2.default.createElement(_CodeInput2.default, codeInputProps),
	                phoneConfirmed && _react2.default.createElement(_ConfirmSuccess2.default, confirmSuccessProps)
	            );
	        }
	    }]);
	    return PhoneConfirmation;
	}(_react2.default.Component);
	
	PhoneConfirmation.propTypes = {
	    languageId: _react2.default.PropTypes.number.isRequired,
	    gamblerId: _react2.default.PropTypes.number.isRequired,
	    joinPromoType: _react2.default.PropTypes.any,
	    phone: _react2.default.PropTypes.string,
	    phoneConfirming: _react2.default.PropTypes.bool.isRequired,
	    phoneConfirmationRequested: _react2.default.PropTypes.bool.isRequired,
	    phoneConfirmed: _react2.default.PropTypes.bool.isRequired,
	    phoneConfirmationError: _react2.default.PropTypes.any,
	    createPhoneConfirmationAction: _react2.default.PropTypes.func.isRequired,
	    confirmPhoneAction: _react2.default.PropTypes.func.isRequired,
	    denyConfirmationAction: _react2.default.PropTypes.func.isRequired,
	    cancelCallback: _react2.default.PropTypes.func.isRequired
	};
	
	
	function select() {
	    return {};
	}
	
	exports.default = (0, _reactRedux.connect)(select, {
	    createPhoneConfirmationAction: _PhoneConfirmation.createPhoneConfirmation,
	    confirmPhoneAction: _PhoneConfirmation.confirmPhone,
	    denyConfirmationAction: _PhoneConfirmation.denyConfirmation
	})(PhoneConfirmation);

/***/ },
/* 1365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _assign = __webpack_require__(15);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _promise = __webpack_require__(307);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reduxForm = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(8);
	
	var _FormField = __webpack_require__(804);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _FormDateField = __webpack_require__(1356);
	
	var _FormDateField2 = _interopRequireDefault(_FormDateField);
	
	var _FormPhoneField = __webpack_require__(1357);
	
	var _FormPhoneField2 = _interopRequireDefault(_FormPhoneField);
	
	var _FormSelectableField = __webpack_require__(805);
	
	var _FormSelectableField2 = _interopRequireDefault(_FormSelectableField);
	
	var _FormCountrySelectField = __webpack_require__(1355);
	
	var _FormCountrySelectField2 = _interopRequireDefault(_FormCountrySelectField);
	
	var _RegistrationFormValidation = __webpack_require__(1366);
	
	var _RegistrationFormValidation2 = _interopRequireDefault(_RegistrationFormValidation);
	
	var _domainUtils = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    title: {
	        id: 'join.title',
	        defaultMessage: 'Регистрация'
	    },
	    login: {
	        id: 'join.login',
	        defaultMessage: 'Логин'
	    },
	    password: {
	        id: 'join.password',
	        defaultMessage: 'Пароль'
	    },
	    passwordRepeat: {
	        id: 'join.password_repeat',
	        defaultMessage: 'Повторите пароль'
	    },
	    firstName: {
	        id: 'join.first_name',
	        defaultMessage: 'Имя'
	    },
	    lastName: {
	        id: 'join.last_name',
	        defaultMessage: 'Фамилия'
	    },
	    dob: {
	        id: 'join.dob',
	        defaultMessage: 'Дата рождения'
	    },
	    email: {
	        id: 'join.email',
	        defaultMessage: 'E-mail'
	    },
	    phone: {
	        id: 'join.phone',
	        defaultMessage: 'Мобильный телефон'
	    },
	    city: {
	        id: 'join.city',
	        defaultMessage: 'Город'
	    },
	    promo: {
	        id: 'join.promo',
	        defaultMessage: 'Промо-код'
	    },
	    country: {
	        id: 'join.country',
	        defaultMessage: 'Страна'
	    },
	    currency: {
	        id: 'join.currency',
	        defaultMessage: 'Валюта счета'
	    },
	    language: {
	        id: 'join.language',
	        defaultMessage: 'Язык'
	    },
	    timezone: {
	        id: 'join.timezone',
	        defaultMessage: 'Часовой пояс'
	    },
	    buttonJoin: {
	        id: 'join.button_join',
	        defaultMessage: 'Зарегистрироваться'
	    },
	    tacAgree: {
	        id: 'join.fast.tac_agree',
	        defaultMessage: "Нажимая кнопку, вы соглашаетесь с <a href={rulesLink} target='_blank'>правилами компании</a>, <a href={privacyLink} target='_blank'>политикой конфиденциальности</a>, и подтверждаете свое совершеннолетие"
	    },
	    tacAgreeRingo: {
	        id: 'join.fast.tac_agree_ringo',
	        defaultMessage: "Нажимая кнопку, вы соглашаетесь с <a href={rulesLink} target='_blank'>правилами компании</a>, <a href={privacyLink} target='_blank'>политикой конфиденциальности</a>, и подтверждаете, что Ваш возраст превышает 21 год"
	    },
	    realInfoWarning: {
	        id: 'join.real_info_warning',
	        defaultMessage: 'Внимание! Вводите реальные данные, при снятии средств со счета они будут сверяться с ' + 'документом удостоверяющим Вашу личность (паспорт, водительское удостоверение). ' + 'Редактирование имени и фамилии после регистрации невозможно.'
	    },
	    internalErrorText: {
	        id: 'join.errors.internal',
	        defaultMessage: 'Ошибка'
	    },
	    loginTakenErrorText: {
	        id: 'join.errors.login_taken',
	        defaultMessage: 'Логин используется'
	    },
	    emailTakenErrorText: {
	        id: 'join.errors.email_taken',
	        defaultMessage: 'E-mail используется'
	    },
	    phoneTakenErrorText: {
	        id: 'join.errors.phone_taken',
	        defaultMessage: 'Телефон используется'
	    },
	    invalidPromo: {
	        id: 'join.errors.invalid_promo',
	        defaultMessage: 'Неверный промо-код'
	    },
	    timezone_1: {
	        id: 'timezones.item_1',
	        defaultMessage: 'Азия/Астана'
	    },
	    timezone_2: {
	        id: 'timezones.item_2',
	        defaultMessage: 'Европа/Москва'
	    },
	    promocodeTitle: {
	        id: 'promocode.title',
	        defaultMessage: 'Промо-код'
	    },
	    promocodePlaceholder: {
	        id: 'promocode.enter',
	        defaultMessage: 'Введите промо-код'
	    },
	    '-1': {
	        id: "promocode.error.not_found",
	        defaultMessage: "Ошибка. Попробуйте позже"
	    },
	    '-2': {
	        id: "promocode.error.not_active",
	        defaultMessage: "Промокод уже использован"
	    },
	    '-3': {
	        id: "promocode.error.used",
	        defaultMessage: "Промокод не действителен"
	    },
	    '-4': {
	        id: "promocode.error.not_available",
	        defaultMessage: "Промокод не действителен"
	    }
	});
	
	var fields = ['login', 'password', 'passwordRepeat', 'firstName', 'lastName', 'dob', 'email', 'phone', 'countryId', 'countryCode', 'countryNumberLength', 'city', 'accountResourceId', 'timezoneId', 'promo', 'PromocodeText'];
	
	var countriesJsonToOptions = function countriesJsonToOptions(jsonSource) {
	    var optionsArr = [];
	    for (var itemKey in jsonSource) {
	        if (!jsonSource.hasOwnProperty(itemKey)) {
	            continue;
	        }
	
	        var country = jsonSource[itemKey];
	        var countryStr = '' + country.name;
	        var option = _react2.default.createElement(
	            'option',
	            { key: itemKey, value: itemKey },
	            countryStr
	        );
	
	        optionsArr.push(option);
	    }
	
	    return optionsArr;
	};
	
	var jsonSourceToOptions = function jsonSourceToOptions(jsonSource) {
	    var optionsArr = [];
	
	    var _loop = function _loop(itemKey) {
	        if (!jsonSource.hasOwnProperty(itemKey)) {
	            return 'continue';
	        }
	
	        var option = void 0;
	
	        if (jsonSource[itemKey].hasOwnProperty('id') && jsonSource[itemKey].hasOwnProperty('defaultMessage')) {
	            option = _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                (0, _extends3.default)({ key: itemKey }, jsonSource[itemKey]),
	                function (msg) {
	                    return _react2.default.createElement(
	                        'option',
	                        { key: itemKey, value: itemKey },
	                        msg
	                    );
	                }
	            );
	        } else {
	            option = _react2.default.createElement(
	                'option',
	                { key: itemKey, value: itemKey },
	                jsonSource[itemKey]
	            );
	        }
	
	        optionsArr.push(option);
	    };
	
	    for (var itemKey in jsonSource) {
	        var _ret = _loop(itemKey);
	
	        if (_ret === 'continue') continue;
	    }
	
	    return optionsArr;
	};
	
	var asyncValidate = function asyncValidate(values) {
	    return new _promise2.default(function (resolve, reject) {
	        var phone = values.countryCode.substring(1).concat(values.phone);
	        if (/^\d+$/.test(values.phone) === false) {
	            phone = undefined;
	        }
	
	        fetch('/api/gambler/credentialsAvailable?login=' + values.login + '&email=' + values.email + '&phone=' + phone, {
	            credentials: 'include'
	        }).then(function (response) {
	            return response.json();
	        }, function () {
	            reject({
	                login: messages.internalErrorText,
	                email: messages.internalErrorText,
	                phone: messages.internalErrorText
	            });
	        }).then(function (data) {
	            if (data && data.login && data.email && data.phone && data.login.available !== undefined && data.email.available !== undefined && data.phone.available !== undefined) {
	                var loginAvailable = data.login.available;
	                var emailAvailable = data.email.available;
	                var phoneAvailable = data.phone.available;
	
	                if (loginAvailable === true && emailAvailable === true && phoneAvailable === true) {
	                    resolve();
	                }
	
	                var response = void 0;
	                if (loginAvailable === false) {
	                    response = {
	                        login: messages.loginTakenErrorText
	                    };
	                }
	                if (emailAvailable === false) {
	                    response = (0, _assign2.default)({}, response, {
	                        email: messages.emailTakenErrorText
	                    });
	                }
	                if (phoneAvailable === false) {
	                    response = (0, _assign2.default)({}, response, {
	                        phone: messages.phoneTakenErrorText
	                    });
	                }
	
	                reject(response);
	            } else {
	                reject({
	                    login: messages.internalErrorText,
	                    email: messages.internalErrorText,
	                    phone: messages.internalErrorText
	                });
	            }
	        });
	    });
	};
	
	var RegistrationForm = function (_React$Component) {
	    (0, _inherits3.default)(RegistrationForm, _React$Component);
	
	    function RegistrationForm() {
	        var _ref;
	
	        var _temp, _this, _ret2;
	
	        (0, _classCallCheck3.default)(this, RegistrationForm);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret2 = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RegistrationForm.__proto__ || (0, _getPrototypeOf2.default)(RegistrationForm)).call.apply(_ref, [this].concat(args))), _this), _this._onSubmit = function (values) {
	            var phone = /^\d+$/.test(values.phone) === false ? undefined : values.countryCode.substring(1).concat(values.phone);
	
	            _this.props.submitAction({
	                Login: values.login,
	                Password: values.password,
	                FirstName: values.firstName,
	                LastName: values.lastName,
	                Birthdate: values.dob,
	                Email: values.email,
	                Phone: phone,
	                CountryId: values.countryId,
	                City: values.city,
	                AccountResourceId: values.accountResourceId,
	                TimeZone: _this.props.timezones[values.timezoneId],
	                languageId: _this.props.languageId,
	                Promo: values.promo,
	                PromocodeText: values.PromocodeText
	            });
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret2);
	    }
	
	    (0, _createClass3.default)(RegistrationForm, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                _props$fields = _props.fields,
	                login = _props$fields.login,
	                password = _props$fields.password,
	                passwordRepeat = _props$fields.passwordRepeat,
	                firstName = _props$fields.firstName,
	                lastName = _props$fields.lastName,
	                dob = _props$fields.dob,
	                email = _props$fields.email,
	                phone = _props$fields.phone,
	                countryId = _props$fields.countryId,
	                PromocodeText = _props$fields.PromocodeText,
	                countryCode = _props$fields.countryCode,
	                countryNumberLength = _props$fields.countryNumberLength,
	                city = _props$fields.city,
	                accountResourceId = _props$fields.accountResourceId,
	                asyncValidating = _props.asyncValidating,
	                handleSubmit = _props.handleSubmit,
	                submitting = _props.submitting,
	                joinError = _props.joinError,
	                promoCodeError = _props.promoCodeError,
	                joining = _props.joining,
	                accountResources = _props.accountResources,
	                countries = _props.countries,
	                domain = _props.domain;
	
	
	            var accountResourceOptions = jsonSourceToOptions(accountResources);
	            var countriesOptions = countriesJsonToOptions(countries);
	
	            var layerClass = 'login--form__row form__row';
	            var warningClass = 'login--form__row form__row form__row--warning';
	            var btnClass = 'login--form__btn login--form__btn__js form__btn';
	
	            var btnDisabled = asyncValidating || submitting || joining ? 'disabled' : '';
	
	            var errMessage = messages.internalErrorText;
	            if (joinError === -15) {
	                errMessage = messages.invalidPromo;
	            }
	            if (joinError === -5 && promoCodeError) {
	                errMessage = messages[promoCodeError];
	            }
	
	            var agreeOptions = { rulesLink: '//help.' + domain, privacyLink: '//help.' + domain + '/privacy' };
	
	            return _react2.default.createElement(
	                'form',
	                { className: 'login--form form', onSubmit: handleSubmit(this._onSubmit), autoComplete: 'off' },
	                _react2.default.createElement('input', { style: { display: "none" }, type: 'text', name: 'fakeusernameremembered' }),
	                _react2.default.createElement('input', { style: { display: "none" }, type: 'password', name: 'fakepasswordremembered' }),
	                joinError && RegistrationForm.renderError(errMessage),
	                _react2.default.createElement(_FormField2.default, { message: messages.login, type: 'text', field: login, required: true }),
	                _react2.default.createElement(_FormField2.default, { message: messages.password, type: 'password', field: password, required: true }),
	                _react2.default.createElement(_FormField2.default, { message: messages.passwordRepeat, type: 'password', field: passwordRepeat,
	                    required: true }),
	                _react2.default.createElement(
	                    'div',
	                    { className: warningClass },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, messages.realInfoWarning)
	                ),
	                _react2.default.createElement(_FormField2.default, { message: messages.firstName, type: 'text', field: firstName, required: true }),
	                _react2.default.createElement(_FormField2.default, { message: messages.lastName, type: 'text', field: lastName, required: true }),
	                _react2.default.createElement(_FormDateField2.default, { message: messages.dob, field: dob, required: true }),
	                _react2.default.createElement(_FormField2.default, { message: messages.email, type: 'email', field: email, required: true }),
	                _react2.default.createElement(_FormPhoneField2.default, { message: messages.phone, type: 'text', field: phone,
	                    countryCode: countryCode, numberLength: countryNumberLength }),
	                _react2.default.createElement(_FormCountrySelectField2.default, {
	                    disabled: true,
	                    message: messages.country,
	                    field: countryId,
	                    countryCodeField: countryCode,
	                    countryNumberLengthField: countryNumberLength,
	                    countries: countries,
	                    options: countriesOptions,
	                    required: true }),
	                _react2.default.createElement(_FormField2.default, { message: messages.city, type: 'text', field: city }),
	                _react2.default.createElement(_FormSelectableField2.default, {
	                    disabled: true,
	                    message: messages.currency,
	                    field: accountResourceId,
	                    options: accountResourceOptions,
	                    required: true }),
	                _react2.default.createElement(_FormField2.default, { message: messages.promocodeTitle, type: 'text', field: PromocodeText }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form__row form__row--terms' },
	                    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, (0, _extends3.default)({}, _domainUtils.isRingo ? messages.tacAgreeRingo : messages.tacAgree, { values: agreeOptions }))
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal--content__controls' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: layerClass },
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'submit',
	                                disabled: btnDisabled,
	                                className: btnClass,
	                                onClick: handleSubmit(this._onSubmit) },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, messages.buttonJoin)
	                        )
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'renderError',
	        value: function renderError(error) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'error-message' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, error)
	            );
	        }
	    }, {
	        key: 'renderHint',
	        value: function renderHint(hint) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'hint hint--error' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, hint)
	            );
	        }
	    }]);
	    return RegistrationForm;
	}(_react2.default.Component);
	
	RegistrationForm.propTypes = {
	    fields: _react2.default.PropTypes.object.isRequired,
	    handleSubmit: _react2.default.PropTypes.func.isRequired,
	    asyncValidating: _react2.default.PropTypes.any.isRequired,
	    submitting: _react2.default.PropTypes.bool.isRequired,
	    languageId: _react2.default.PropTypes.number.isRequired,
	    joining: _react2.default.PropTypes.bool.isRequired,
	    joinError: _react2.default.PropTypes.any,
	    promoCodeError: _react2.default.PropTypes.any,
	    accountResources: _react2.default.PropTypes.object.isRequired,
	    countries: _react2.default.PropTypes.object.isRequired,
	    languages: _react2.default.PropTypes.object.isRequired,
	    timezones: _react2.default.PropTypes.object.isRequired,
	    domain: _react2.default.PropTypes.string.isRequired,
	    submitAction: _react2.default.PropTypes.func.isRequired,
	    cancelCallback: _react2.default.PropTypes.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)()((0, _reduxForm.reduxForm)({
	    form: 'registration-form',
	    fields: fields,
	    asyncValidate: asyncValidate,
	    asyncBlurFields: ['login', 'email', 'phone', 'countryId', 'PromocodeText'],
	    validate: _RegistrationFormValidation2.default
	})(RegistrationForm));

/***/ },
/* 1366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactIntl = __webpack_require__(8);
	
	var _momentTimezone = __webpack_require__(76);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = (0, _reactIntl.defineMessages)({
	    requiredField: {
	        id: 'join.errors.required_field',
	        defaultMessage: 'Поле обязательно для заполнения'
	    },
	    loginRequirements: {
	        id: 'join.errors.login_requirements',
	        defaultMessage: 'Минимум 4 символа, только латинские буквы и цифры'
	    },
	    passwordsNotEqual: {
	        id: 'join.errors.passwords_not_equal',
	        defaultMessage: 'Пароли не совпадают'
	    },
	    invalidEmail: {
	        id: 'join.errors.email_invalid',
	        defaultMessage: 'E-mail указан неверно'
	    },
	    invalidDate: {
	        id: 'join.errors.date_invalid',
	        defaultMessage: 'Дата рождения указана неверно'
	    },
	    invalidPhone: {
	        id: 'join.errors.phone_invalid',
	        defaultMessage: 'Номер телефона указан неверно'
	    },
	    ageIncorrect: {
	        id: 'join.errors.age_incorrect',
	        defaultMessage: 'Дата рождения указана неверно'
	    },
	    ageIllegal: {
	        id: 'join.errors.age_illegal',
	        defaultMessage: 'Недопустимый возраст'
	    },
	    invalidPromo: {
	        id: 'join.errors.promo_length_error',
	        defaultMessage: 'Максимум 4 символа'
	    }
	});
	
	var KZ_COUNTRY_ID = 79;
	var KZ_AGE_RESTRICTION = 21;
	var OTHER_AGE_RESTRICTION = 18;
	
	var RegistrationFormValidation = function RegistrationFormValidation(values) {
	    var errors = {};
	
	    var loginRegex = /^[a-zA-Z0-9]{4,20}/;
	    var emailRegex = /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/;
	
	    if (!values.login || !values.login.length) {
	        errors.login = messages.requiredField;
	    }
	
	    if (loginRegex.test(values.login) === false) {
	        errors.login = messages.loginRequirements;
	    }
	
	    if (!values.password || !values.password.length) {
	        errors.password = messages.requiredField;
	    }
	
	    if (!values.passwordRepeat || !values.passwordRepeat.length) {
	        errors.passwordRepeat = messages.requiredField;
	    }
	
	    if (values.password && values.passwordRepeat && values.passwordRepeat !== values.password) {
	        errors.password = messages.passwordsNotEqual;
	    }
	
	    if (!values.firstName || !values.firstName.length) {
	        errors.firstName = messages.requiredField;
	    }
	
	    if (!values.lastName || !values.lastName.length) {
	        errors.lastName = messages.requiredField;
	    }
	
	    if (!values.dob) {
	        errors.dob = messages.requiredField;
	    } else if (values.dob && values.dob.indexOf('_') === -1) {
	        var parsedDate = (0, _momentTimezone2.default)(values.dob, 'DD/MM/YYYY');
	
	        if (!parsedDate.isValid()) {
	            errors.dob = messages.invalidDate;
	        } else if (parsedDate.isBefore('1900-01-01', 'year')) {
	            errors.dob = messages.ageIncorrect;
	        } else {
	            var momentBefore = (0, _momentTimezone2.default)();
	            if (KZ_COUNTRY_ID == values.countryId) {
	                momentBefore.subtract(KZ_AGE_RESTRICTION, 'y');
	            } else {
	                momentBefore.subtract(OTHER_AGE_RESTRICTION, 'y');
	            }
	
	            if (!parsedDate.isBefore(momentBefore)) {
	                errors.dob = messages.ageIllegal;
	            }
	        }
	    } else if (values.dob && values.dob.indexOf('_') !== -1) {
	        errors.dob = messages.invalidDate;
	    }
	
	    if (!values.email || !values.email.length) {
	        errors.email = messages.requiredField;
	    }
	
	    if (emailRegex.test(values.email) === false) {
	        errors.email = messages.invalidEmail;
	    }
	
	    if (!values.phone || !values.phone.length) {} else if (values.phone && values.phone.length && /\d+/g.test(values.phone) === true && /^\d+$/.test(values.phone) === false) {
	        errors.phone = messages.invalidPhone;
	    }
	
	    if (!values.accountResourceId) {
	        errors.accountResourceId = messages.requiredField;
	    }
	
	    if (!values.timezoneId) {
	        errors.timezoneId = messages.requiredField;
	    }
	
	    return errors;
	};
	
	exports.default = RegistrationFormValidation;

/***/ },
/* 1367 */
1359,
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPlayer = __webpack_require__(1921);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Stream = function (_Component) {
	    (0, _inherits3.default)(Stream, _Component);
	
	    function Stream() {
	        (0, _classCallCheck3.default)(this, Stream);
	        return (0, _possibleConstructorReturn3.default)(this, (Stream.__proto__ || (0, _getPrototypeOf2.default)(Stream)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Stream, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'player-wrapper' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'react-player' },
	                    _react2.default.createElement(_reactPlayer2.default, { url: this.props.src
	                        // loop
	                        , controls: true,
	                        playsinline: true,
	                        playing: true })
	                )
	            );
	        }
	    }]);
	    return Stream;
	}(_react.Component);
	
	Stream.propTypes = {
	    src: _react2.default.PropTypes.string.isRequired
	};
	
	exports.default = Stream;

/***/ },
/* 1369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var providedInitialState = window.__INITIAL_STATE__;
	    var languageId = Number(localStorage.getItem('languageId') || providedInitialState.languageId || parseInt((0, _cookieUtils.getCookie)('languageId')) || 1);
	    var countryCode = providedInitialState.countryCode || 'KZ';
	
	    return {
	        routing: undefined,
	        application: (0, _immutable.Map)({
	            connectionStatus: ConnectionStatus.CONNECTED,
	            languageId: languageId,
	            countryCode: countryCode,
	            menu: new _immutable.Map({
	                sports: new _immutable.Map(),
	                leagues: new _immutable.Map()
	            }),
	            preMatch: new _immutable.Map({
	                sports: new _immutable.Map(),
	                leagues: new _immutable.Map(),
	                matches: new _immutable.Map(),
	                groups: new _immutable.Map(),
	                outcomes: new _immutable.Map(),
	                rates: new _immutable.Map(),
	                valid: true
	            }),
	            live: new _immutable.Map({
	                sports: new _immutable.Map(),
	                leagues: new _immutable.Map(),
	                matches: new _immutable.Map(),
	                scores: new _immutable.Map(),
	                groups: new _immutable.Map(),
	                outcomes: new _immutable.Map(),
	                rates: new _immutable.Map(),
	                valid: true,
	                state: RepositoryState.NOT_INITED,
	                showLineNumbers: false,
	                version: 0
	            }),
	            stakeOfTheDay: new _immutable.Map({
	                sports: new _immutable.Map(),
	                leagues: new _immutable.Map(),
	                matches: new _immutable.Map(),
	                scores: new _immutable.Map(),
	                groups: new _immutable.Map(),
	                outcomes: new _immutable.Map(),
	                rates: new _immutable.Map(),
	                valid: true
	            }),
	            popularMatches: new _immutable.Map({
	                sports: new _immutable.Map(),
	                leagues: new _immutable.Map(),
	                matches: new _immutable.Map(),
	                scores: new _immutable.Map(),
	                groups: new _immutable.Map(),
	                outcomes: new _immutable.Map(),
	                rates: new _immutable.Map(),
	                valid: true
	            }),
	            timetable: new _immutable.Map({
	                sports: new _immutable.Map(),
	                leagues: new _immutable.Map(),
	                matches: new _immutable.Map(),
	                valid: true,
	                state: RepositoryState.NOT_INITED,
	                version: 0
	            }),
	            displayMode: {
	                type: DisplayMode.ALL
	            },
	            bettingMode: new _immutable.Map(),
	            coupon: new _immutable.Map({
	                betSlips: new _immutable.OrderedMap(),
	                betTypes: new _immutable.List(),
	                currentBetTypeIndex: undefined,
	                currentBetTypeSelected: false,
	                state: undefined,
	                amount: 0,
	                betSlipAmounts: new _immutable.Map(),
	                freebet: undefined,
	                isFreebet: new _immutable.Map()
	            }),
	            betHistory: new _immutable.Map(),
	            news: [],
	            messages: new _immutable.Map({ newMessagesCount: undefined }),
	            userGridSelection: new _immutable.Map({
	                main: new _immutable.Map({
	                    sportsExpanded: new _immutable.List()
	                }),
	                preMatch: new _immutable.Map({
	                    sportsExpanded: new _immutable.List(),
	                    leaguesExpanded: new _immutable.List(),
	                    matchesExpanded: new _immutable.List(),
	                    lastShown: null
	                }),
	                live: new _immutable.Map({
	                    sportsExpanded: new _immutable.List(),
	                    leaguesExpanded: new _immutable.List(),
	                    matchesExpanded: new _immutable.List(),
	                    lastShown: null
	                })
	            }),
	            userGridStorable: false,
	            bettingAvailable: true,
	            stream: {
	                openStream: false,
	                matchId: undefined,
	                src: undefined
	            }
	        }),
	        betGames: (0, _immutable.Map)({
	            token: undefined,
	            fetching: false
	        }),
	        promoCode: {
	            error: undefined
	        },
	        domain: (0, _domainUtils.getDomain)(window.location.host)
	    };
	};
	
	var _immutable = __webpack_require__(14);
	
	var _domainUtils = __webpack_require__(27);
	
	var _cookieUtils = __webpack_require__(96);
	
	var _DisplayMode = __webpack_require__(78);
	
	var DisplayMode = _interopRequireWildcard(_DisplayMode);
	
	var _ConnectionStatus = __webpack_require__(494);
	
	var ConnectionStatus = _interopRequireWildcard(_ConnectionStatus);
	
	var _RepositoryState = __webpack_require__(119);
	
	var RepositoryState = _interopRequireWildcard(_RepositoryState);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/***/ },
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = gamblerInfoReducer;
	
	var _GamblerInfo = __webpack_require__(737);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  fetching: false,
	  data: null,
	  error: null
	};
	
	function gamblerInfoReducer(state, action) {
	  if (state === undefined) {
	    return initialState;
	  }
	
	  switch (action.type) {
	    case _GamblerInfo.FETCH_GAMBLER_INFO:
	      {
	        return (0, _extends3.default)({}, state, {
	          fetching: true,
	          data: null,
	          error: null
	        });
	      }
	    case _GamblerInfo.SUCCESS_FETCH_GAMBLER_INFO:
	      {
	        return (0, _extends3.default)({}, state, {
	          fetching: false,
	          error: null,
	          data: action.data
	        });
	      }
	    case _GamblerInfo.FAILURE_FETCH_GAMBLER_INFO:
	      {
	        return (0, _extends3.default)({}, state, {
	          fetching: false,
	          data: null,
	          error: action.data
	        });
	      }
	  }
	  return state;
	}

/***/ },
/* 1371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = applicationReducer;
	
	var _immutable = __webpack_require__(14);
	
	var _cookieUtils = __webpack_require__(96);
	
	var _DisplayMode = __webpack_require__(78);
	
	var DisplayMode = _interopRequireWildcard(_DisplayMode);
	
	var _ConnectionStatus = __webpack_require__(494);
	
	var ConnectionStatus = _interopRequireWildcard(_ConnectionStatus);
	
	var _RepositoryState = __webpack_require__(119);
	
	var RepositoryState = _interopRequireWildcard(_RepositoryState);
	
	var _entitiesReducer = __webpack_require__(580);
	
	var _entitiesReducer2 = _interopRequireDefault(_entitiesReducer);
	
	var _displayModeReducer = __webpack_require__(1389);
	
	var _displayModeReducer2 = _interopRequireDefault(_displayModeReducer);
	
	var _connectionStatusReducer = __webpack_require__(1377);
	
	var _connectionStatusReducer2 = _interopRequireDefault(_connectionStatusReducer);
	
	var _localeReducer = __webpack_require__(1393);
	
	var _localeReducer2 = _interopRequireDefault(_localeReducer);
	
	var _couponReducer = __webpack_require__(1383);
	
	var _couponReducer2 = _interopRequireDefault(_couponReducer);
	
	var _betHistoryReducer = __webpack_require__(1373);
	
	var _betHistoryReducer2 = _interopRequireDefault(_betHistoryReducer);
	
	var _bettingModeReducer = __webpack_require__(1376);
	
	var _bettingModeReducer2 = _interopRequireDefault(_bettingModeReducer);
	
	var _menuReducer = __webpack_require__(1395);
	
	var _menuReducer2 = _interopRequireDefault(_menuReducer);
	
	var _newsReducer = __webpack_require__(1398);
	
	var _newsReducer2 = _interopRequireDefault(_newsReducer);
	
	var _messagesReducer = __webpack_require__(1397);
	
	var _messagesReducer2 = _interopRequireDefault(_messagesReducer);
	
	var _userSelectionReducer = __webpack_require__(1401);
	
	var _userSelectionReducer2 = _interopRequireDefault(_userSelectionReducer);
	
	var _userSelectionStorableReducer = __webpack_require__(1402);
	
	var _userSelectionStorableReducer2 = _interopRequireDefault(_userSelectionStorableReducer);
	
	var _bettingAvailableReducer = __webpack_require__(1375);
	
	var _bettingAvailableReducer2 = _interopRequireDefault(_bettingAvailableReducer);
	
	var _streamReducer = __webpack_require__(1400);
	
	var _streamReducer2 = _interopRequireDefault(_streamReducer);
	
	var _betradarReducer = __webpack_require__(1374);
	
	var _betradarReducer2 = _interopRequireDefault(_betradarReducer);
	
	var _jacktopGamesReducer = __webpack_require__(1391);
	
	var _jacktopGamesReducer2 = _interopRequireDefault(_jacktopGamesReducer);
	
	var _GamblerInfoReducer = __webpack_require__(1370);
	
	var _GamblerInfoReducer2 = _interopRequireDefault(_GamblerInfoReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var providedInitialState = window.__INITIAL_STATE__;
	var languageId = Number(localStorage.getItem('languageId') || providedInitialState.languageId || parseInt((0, _cookieUtils.getCookie)('languageId')) || 1);
	
	var initialState = (0, _immutable.Map)({
	    connectionStatus: ConnectionStatus.CONNECTED,
	    languageId: languageId,
	    menu: new _immutable.Map({
	        sports: new _immutable.Map(),
	        leagues: new _immutable.Map()
	    }),
	    preMatch: new _immutable.Map({
	        sports: new _immutable.Map(),
	        leagues: new _immutable.Map(),
	        matches: new _immutable.Map(),
	        groups: new _immutable.Map(),
	        outcomes: new _immutable.Map(),
	        rates: new _immutable.Map(),
	        valid: true
	    }),
	    live: new _immutable.Map({
	        sports: new _immutable.Map(),
	        leagues: new _immutable.Map(),
	        matches: new _immutable.Map(),
	        scores: new _immutable.Map(),
	        groups: new _immutable.Map(),
	        outcomes: new _immutable.Map(),
	        rates: new _immutable.Map(),
	        valid: true,
	        state: RepositoryState.NOT_INITED,
	        showLineNumbers: false,
	        version: 0
	    }),
	    stakeOfTheDay: new _immutable.Map({
	        sports: new _immutable.Map(),
	        leagues: new _immutable.Map(),
	        matches: new _immutable.Map(),
	        scores: new _immutable.Map(),
	        groups: new _immutable.Map(),
	        outcomes: new _immutable.Map(),
	        rates: new _immutable.Map(),
	        valid: true
	    }),
	    popularMatches: new _immutable.Map({
	        sports: new _immutable.Map(),
	        leagues: new _immutable.Map(),
	        matches: new _immutable.Map(),
	        scores: new _immutable.Map(),
	        groups: new _immutable.Map(),
	        outcomes: new _immutable.Map(),
	        rates: new _immutable.Map(),
	        valid: true
	    }),
	    timetable: new _immutable.Map({
	        sports: new _immutable.Map(),
	        leagues: new _immutable.Map(),
	        matches: new _immutable.Map(),
	        valid: true,
	        state: RepositoryState.NOT_INITED,
	        version: 0
	    }),
	    displayMode: {
	        type: DisplayMode.ALL
	    },
	    bettingMode: new _immutable.Map(),
	    coupon: new _immutable.Map({
	        betSlips: new _immutable.OrderedMap(),
	        betTypes: new _immutable.List(),
	        currentBetTypeIndex: undefined,
	        currentBetTypeSelected: false,
	        state: undefined,
	        betSlipAmounts: new _immutable.Map(),
	        amount: 0,
	        freebet: undefined,
	        isFreebet: new _immutable.Map()
	    }),
	    betHistory: new _immutable.Map(),
	    news: [],
	    messages: new _immutable.Map({
	        newMessagesCount: undefined
	    }),
	    userGridSelection: new _immutable.Map({
	        main: new _immutable.Map({
	            sportsExpanded: new _immutable.List()
	        }),
	        preMatch: new _immutable.Map({
	            sportsExpanded: new _immutable.List(),
	            leaguesExpanded: new _immutable.List(),
	            matchesExpanded: new _immutable.List(),
	            lastShown: null
	        }),
	        live: new _immutable.Map({
	            sportsExpanded: new _immutable.List(),
	            leaguesExpanded: new _immutable.List(),
	            matchesExpanded: new _immutable.List(),
	            lastShown: null
	        })
	    }),
	    userGridStorable: false,
	    bettingAvailable: true,
	    stream: {
	        openStream: false,
	        matchId: undefined,
	        src: undefined
	    },
	    jacktopGames: {
	        fetching: false,
	        token: null,
	        error: null
	    },
	    gamblerInfo: {
	        fetching: false,
	        data: null,
	        error: null
	    }
	});
	
	function applicationReducer(state, action) {
	    if (state === undefined) {
	        return initialState;
	    }
	
	    state = state.update('live', function (s) {
	        return (0, _entitiesReducer2.default)(s, action, 'live');
	    });
	    state = state.update('menu', function (s) {
	        return (0, _entitiesReducer2.default)(s, action, 'menu');
	    });
	    state = state.update('preMatch', function (s) {
	        return (0, _entitiesReducer2.default)(s, action, 'preMatch');
	    });
	    state = state.update('popularMatches', function (s) {
	        return (0, _entitiesReducer2.default)(s, action, 'popularMatches');
	    });
	    state = state.update('stakeOfTheDay', function (s) {
	        return (0, _entitiesReducer2.default)(s, action, 'stakeOfTheDay');
	    });
	    state = state.update('timetable', function (s) {
	        return (0, _entitiesReducer2.default)(s, action, 'timetable');
	    });
	
	    state = state.update('menu', function (e) {
	        return (0, _menuReducer2.default)(e, action);
	    });
	    state = state.update('displayMode', function (dm) {
	        return (0, _displayModeReducer2.default)(dm, action);
	    });
	    state = state.update('connectionStatus', function (cs) {
	        return (0, _connectionStatusReducer2.default)(cs, action);
	    });
	    state = state.update('languageId', function (l) {
	        return (0, _localeReducer2.default)(l, action);
	    });
	    state = state.update('betHistory', function (bh) {
	        return (0, _betHistoryReducer2.default)(bh, action);
	    });
	    state = state.update('bettingMode', function (bm) {
	        return (0, _bettingModeReducer2.default)(bm, action);
	    });
	
	    state = state.update('coupon', function (c) {
	        return (0, _couponReducer2.default)(c, action);
	    });
	    state = state.update('news', function (n) {
	        return (0, _newsReducer2.default)(n, action);
	    });
	    state = state.update('messages', function (m) {
	        return (0, _messagesReducer2.default)(m, action);
	    });
	    state = state.update('userGridSelection', function (us) {
	        return (0, _userSelectionReducer2.default)(us, action);
	    });
	    state = state.update('userGridStorable', function (ugs) {
	        return (0, _userSelectionStorableReducer2.default)(ugs, action);
	    });
	    state = state.update('bettingAvailable', function (ba) {
	        return (0, _bettingAvailableReducer2.default)(ba, action);
	    });
	    state = state.update('stream', function (sr) {
	        return (0, _streamReducer2.default)(sr, action);
	    });
	    state = state.update('betradar', function (s) {
	        return (0, _betradarReducer2.default)(s, action);
	    });
	    state = state.update('jacktopGames', function (jg) {
	        return (0, _jacktopGamesReducer2.default)(jg, action);
	    });
	    state = state.update('gamblerInfo', function (gi) {
	        return (0, _GamblerInfoReducer2.default)(gi, action);
	    });
	
	    return state;
	}

/***/ },
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = join;
	
	var _immutable = __webpack_require__(14);
	
	var _index = __webpack_require__(732);
	
	var BetGamesActions = _interopRequireWildcard(_index);
	
	var _SignoutAction = __webpack_require__(118);
	
	var AuthAction = _interopRequireWildcard(_SignoutAction);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = (0, _immutable.Map)({
	    token: undefined,
	    fetching: false
	});
	
	function join() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case BetGamesActions.FETCH_BETGAMES_TOKEN:
	            return state.set('fetching', true);
	        case BetGamesActions.SUCCESS_FETCH_BETGAMES_TOKEN:
	            state = state.set('fetching', false);
	            if (typeof action.data === 'string') {
	                return state.set('token', action.data);
	            } else {
	                return state.set('token', undefined);
	            }
	
	        case BetGamesActions.FAILURE_FETCH_BETGAMES_TOKEN:
	            return state.set('fetching', false);
	
	        case AuthAction.SUCCESS_SIGNOUT:
	            return state.set('token', undefined);
	    }
	
	    return state;
	}

/***/ },
/* 1373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = betHistoryReducer;
	
	var _immutable = __webpack_require__(14);
	
	var _underscore = __webpack_require__(145);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _momentTimezone = __webpack_require__(76);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _actions = __webpack_require__(30);
	
	var _Storage = __webpack_require__(69);
	
	var StorageActions = _interopRequireWildcard(_Storage);
	
	var _MakeBet = __webpack_require__(117);
	
	var MakeBetActions = _interopRequireWildcard(_MakeBet);
	
	var _HistoryBet = __webpack_require__(302);
	
	var HistoryBetActions = _interopRequireWildcard(_HistoryBet);
	
	var _Cashout = __webpack_require__(705);
	
	var CashoutActions = _interopRequireWildcard(_Cashout);
	
	var _BigStakeRequest = __webpack_require__(704);
	
	var BigStakeRequestActions = _interopRequireWildcard(_BigStakeRequest);
	
	var _SignoutAction = __webpack_require__(118);
	
	var SignoutActions = _interopRequireWildcard(_SignoutAction);
	
	var _BetStatus = __webpack_require__(134);
	
	var BetStatus = _interopRequireWildcard(_BetStatus);
	
	var _StakeStatus = __webpack_require__(304);
	
	var StakeStatus = _interopRequireWildcard(_StakeStatus);
	
	var _CashoutStatus = __webpack_require__(566);
	
	var CashoutStatus = _interopRequireWildcard(_CashoutStatus);
	
	var _CashoutRequestStatus = __webpack_require__(977);
	
	var CashoutRequestStatus = _interopRequireWildcard(_CashoutRequestStatus);
	
	var _BetCreateErrorStatus = __webpack_require__(747);
	
	var BetCreateErrorStatus = _interopRequireWildcard(_BetCreateErrorStatus);
	
	var _BigStakeCancelError = __webpack_require__(749);
	
	var BigStakeCancelError = _interopRequireWildcard(_BigStakeCancelError);
	
	var _BettingState = __webpack_require__(748);
	
	var BettingState = _interopRequireWildcard(_BettingState);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = new _immutable.Map();
	
	function betHistoryReducer(betHistory, action) {
	    switch (action.type) {
	        case SignoutActions.SUCCESS_SIGNOUT:
	            return initialState;
	
	        case StorageActions.LOAD_STORAGE:
	            var storageBetHistory = action.data.betHistory;
	            if (storageBetHistory) {
	                return storageBetHistory;
	            }
	
	            return betHistory;
	
	        case MakeBetActions.MAKE_BET:
	            return makeBet(betHistory, action.historyData);
	
	        case MakeBetActions.SUCCESS_MAKE_BET:
	            if (action.data.some(function (b) {
	                return b.error || b.hasOwnProperty('FreebetErrors');
	            })) {
	                return changeBetsToRejected(betHistory, action.data);
	            }
	            return betCreated(betHistory, action.data);
	
	        case _actions.GET_BET_STATUS.SUCCESS:
	            return changeBetStatus(betHistory, action.data);
	
	        case _actions.GET_BET_STATUS.FAILURE:
	            return changeBetsToRejected(betHistory, [action.data]);
	
	        case MakeBetActions.FAILURE_MAKE_BET:
	            return changeBetsToRejected(betHistory, action.data);
	
	        case HistoryBetActions.REMOVE_HISTORY_BET:
	            return removeHistoryBet(betHistory, action.data);
	
	        case HistoryBetActions.REMOVE_HISTORY_BETS:
	            return removeHistoryBets(betHistory);
	
	        case BigStakeRequestActions.SUCCESS_BIG_STAKE_REQUEST_CANCEL:
	            return cancelBigStakeRequest(betHistory, action.data);
	
	        case _actions.GET_STAKE_STATUS.SUCCESS:
	            betHistory = changeStakeBetStatus(betHistory, action.data);
	            return updateStakeCashoutStatus(betHistory, action.data);
	
	        case CashoutActions.SET_CASHOUT_STATUS:
	            return setCashoutStatus(betHistory, action.data);
	
	        case CashoutActions.SUCCESS_CREATE_CASHOUT:
	            betHistory = createCashout(betHistory, action.data);
	            return betSold(betHistory, action.data);
	
	        case CashoutActions.FAILURE_CREATE_CASHOUT:
	        case _actions.GET_CASHOUT_STATUS.FAILURE:
	            return clearCashout(betHistory, action.data);
	
	        case _actions.GET_CASHOUT_STATUS.SUCCESS:
	            return cashoutRequestStateChanged(betHistory, action.data);
	    }
	
	    return betHistory;
	}
	
	function makeBet(betHistory, bets) {
	    _underscore2.default.map(bets, function (b) {
	        betHistory = betHistory.set(b.id, new _immutable.Map({
	            stakeId: undefined,
	            stakeTime: undefined,
	            cashout: new _immutable.Map({
	                amount: undefined,
	                requestId: undefined,
	                state: undefined
	            }),
	            betSlips: b.betSlips,
	            betType: b.betType,
	            rank: b.rank,
	            amount: b.amount,
	            odd: b.odd.toFixed(2),
	            possibleWinAmount: (b.amount * b.odd).toFixed(2),
	            delay: undefined,
	            rateChange: undefined,
	            betStatus: BetStatus.INIT,
	            stakeStatus: StakeStatus.ACTIVE,
	            betCreateError: undefined,
	            FreebetErrors: undefined,
	            resolution: undefined,
	            bigStakeCancelError: undefined
	        }));
	    });
	
	    return betHistory;
	}
	
	function betCreated(betHistory, createdBets) {
	    var _loop = function _loop(i) {
	        var createdBet = createdBets[i];
	        var id = createdBet.id;
	
	        if (!betHistory.has(id)) {
	            return 'continue';
	        }
	
	        if (createdBet.error) {
	            betHistory = betHistory.updateIn([id], function (bh) {
	                var betErrorStatus = BetCreateErrorStatus.INTERNAL_ERROR;
	                var alternativeStake = null;
	
	                switch (createdBet.error) {
	                    case -3:
	                        betErrorStatus = BetCreateErrorStatus.FACTORS_CHANGED;
	
	                        var factors = createdBet.factors;
	                        if (factors) {
	                            var rateChange = getRateChange(factors);
	
	                            if (rateChange.length > 0) {
	                                bh = bh.set('rateChange', rateChange);
	                            }
	                        }
	                        break;
	                    case -4:
	                        betErrorStatus = BetCreateErrorStatus.INSUFFICIENT_FUNDS;
	                        break;
	                    case -7:
	                    case -15:
	                        betErrorStatus = BetCreateErrorStatus.ACCOUNT_LOCKED;
	                        break;
	                    case -17:
	                        betErrorStatus = BetCreateErrorStatus.SYSTEM_NOT_ALLOWED_FOR_FREEBET;
	                        break;
	
	                    case -6:
	                        betErrorStatus = BetCreateErrorStatus.MIN_STAKE_AMOUNT;
	                        break;
	                    case -1:
	                    case -2:
	                    case -13:
	                        betErrorStatus = BetCreateErrorStatus.INCORRECT_STAKE;
	                        break;
	                    case -5:
	                    case -11:
	                        betErrorStatus = BetCreateErrorStatus.INCORRECT_VIRTUAL_STAKE;
	                        break;
	                    case -12:
	                        betErrorStatus = BetCreateErrorStatus.FREEBET_BIG_STAKE;
	                        break;
	                    case -9:
	                    case -10:
	                        betErrorStatus = BetCreateErrorStatus.INCORRECT_FREEBET_STAKE;
	                        break;
	                    case -14:
	                        betErrorStatus = BetCreateErrorStatus.EXISTING_ACTIVE_STAKE;
	                        break;
	                    case -16:
	                        betErrorStatus = BetCreateErrorStatus.NO_BIG_STAKE_PERMISSION;
	                        break;
	                    case -18:
	                        betErrorStatus = BetCreateErrorStatus.ALTERNATIVE_STAKE;
	                        alternativeStake = createdBet.alternativeStake;
	                        break;
	                    case -19:
	                        betErrorStatus = BetCreateErrorStatus.NOT_POSSIBLE_STAKE;
	                        break;
	                }
	
	                bh = bh.set('betStatus', BetStatus.REJECTED);
	                bh = bh.set('alternativeStake', alternativeStake);
	                return bh.set('betCreateError', betErrorStatus);
	            });
	        } else {
	            betHistory = betHistory.updateIn([id], function (bh) {
	                var stakeTime = _momentTimezone2.default.tz(createdBet.stakeTime, 'Asia/Bishkek').clone().tz('UTC');
	
	                var factors = createdBet.factors;
	                if (factors) {
	                    var rateChange = getRateChange(factors);
	                    if (rateChange.length > 0) {
	                        bh = bh.set('rateChange', rateChange);
	                    }
	                }
	
	                bh = bh.set('betStatus', createdBet.state);
	                bh = bh.set('stakeId', createdBet.stakeId);
	                bh = bh.set('delay', createdBet.delay);
	                bh = bh.set('stakeTime', stakeTime);
	
	                return bh;
	            });
	        }
	    };
	
	    for (var i = 0; i < createdBets.length; i++) {
	        var _ret = _loop(i);
	
	        if (_ret === 'continue') continue;
	    }
	
	    return betHistory;
	}
	
	function changeBetStatus(betHistory, betStatus) {
	    var id = betStatus.id;
	
	    if (!betHistory.has(id)) {
	        return betHistory;
	    }
	
	    if (betStatus.error) {
	        if (betStatus.error === -100) {
	            return betHistory;
	        }
	        return betHistory.updateIn([id], function (bh) {
	            bh = bh.set('betCreateError', BetCreateErrorStatus.INTERNAL_ERROR);
	            return bh.set('betStatus', BetStatus.REJECTED);
	        });
	    }
	
	    var state = betStatus.state;
	    var factors = betStatus.factors;
	    var resolution = betStatus.resolution;
	
	    return betHistory.updateIn([id], function (bh) {
	        bh = bh.set('betStatus', state);
	        bh = bh.set('resolution', resolution);
	
	        if (factors) {
	            var rateChange = getRateChange(factors);
	
	            if (rateChange.length > 0) {
	                bh = bh.set('rateChange', rateChange);
	            }
	        }
	
	        return bh;
	    });
	}
	
	function changeBetsToRejected(betHistory, failedBets) {
	    for (var i = 0; i < failedBets.length; i++) {
	        var failedBet = failedBets[i];
	
	        betHistory = changeBetToRejected(betHistory, failedBet);
	    }
	
	    return betHistory;
	}
	
	function changeBetToRejected(betHistory, failedBet) {
	    if (betHistory.has(failedBet.id)) {
	        betHistory = betHistory.updateIn([failedBet.id], function (bh) {
	            if (failedBet.hasOwnProperty('FreebetErrors')) {
	                bh = bh.set('betCreateError', failedBet.FreebetErrors);
	            } else {
	                bh = bh.set('betCreateError', failedBet.error);
	            }
	
	            bh = bh.set('betStatus', BetStatus.REJECTED);
	            return bh;
	        });
	    }
	
	    return betHistory;
	}
	
	function getRateChange(factors) {
	    var rateChange = [];
	    for (var i = 0; i < factors.length; i++) {
	        var factorId = factors[i].FactorId;
	        var factorInitialValue = factors[i].InitialValue;
	        var factorNewValue = factors[i].Value;
	        var bettingState = factors[i].BettingState;
	
	        switch (bettingState) {
	            case BettingState.CORRECT:
	                if (factorInitialValue !== factorNewValue) {
	                    rateChange.push({
	                        factorId: factorId,
	                        value: factorNewValue
	                    });
	                }
	                break;
	            case BettingState.FACTOR_CHANGED:
	                rateChange.push({
	                    factorId: factorId,
	                    value: factorNewValue
	                });
	                break;
	            case BettingState.FACTOR_CLOSED:
	            case BettingState.OUTCOME_CLOSED:
	            case BettingState.EVENT_CLOSED:
	                rateChange.push({
	                    factorId: factorId,
	                    unavailable: true
	                });
	        }
	    }
	
	    return rateChange;
	}
	
	function removeHistoryBet(betHistory, id) {
	    return betHistory.delete(id);
	}
	
	function removeHistoryBets(betHistory) {
	    var ids = betHistory.keySeq().toArray();
	
	    for (var i = 0; i < ids.length; i++) {
	        var _id = ids[i];
	
	        var betStatus = betHistory.getIn([_id, 'betStatus']);
	        if (betStatus && betStatus !== BetStatus.CONFIRMED && betStatus !== BetStatus.CONFIRM_AWAIT && betStatus !== BetStatus.IN_DELAY && betStatus !== BetStatus.STAKE_REQUEST) {
	            betHistory = betHistory.delete(_id);
	        }
	    }
	
	    return betHistory;
	}
	
	function cancelBigStakeRequest(betHistory, bigStakeRequestCancel) {
	    var id = bigStakeRequestCancel.id;
	    var error = bigStakeRequestCancel.error;
	
	    if (!betHistory.has(id)) {
	        return betHistory;
	    }
	
	    if (error !== undefined) {
	        if (error === -1) {
	            return betHistory.updateIn([id], function (bh) {
	                return bh.set('bigStakeCancelError', BigStakeCancelError.CANCEL_NOT_POSSIBLE);
	            });
	        } else if (error === -100) {
	            return betHistory;
	        }
	    }
	
	    return betHistory.updateIn([id], function (bh) {
	        return bh.set('betStatus', BetStatus.REJECTED);
	    });
	}
	
	function changeStakeBetStatus(betHistory, stakeStatus) {
	    var id = stakeStatus.id;
	
	    if (!betHistory.has(id)) {
	        return betHistory;
	    }
	
	    if (stakeStatus.error) {
	        if (stakeStatus.error === -2) {
	            return betHistory.delete(id);
	        }
	
	        return betHistory;
	    }
	
	    var state = stakeStatus.state;
	    var calculationState = stakeStatus.calculationState;
	
	    return betHistory.updateIn([id], function (bh) {
	        bh = bh.set('betStatus', state);
	        return bh.set('stakeStatus', calculationState);
	    });
	}
	
	function updateStakeCashoutStatus(betHistory, stakeStatus) {
	    var id = stakeStatus.id;
	
	    if (!betHistory.has(id)) {
	        return betHistory;
	    }
	
	    if (stakeStatus.error) {
	        return betHistory;
	    }
	
	    var cashoutAmount = stakeStatus.cashoutAmount;
	    var state = stakeStatus.state;
	
	    switch (state) {
	        case BetStatus.CONFIRMED:
	            var cashoutStatus = betHistory.getIn([id, 'cashout', 'state']);
	            var previousAmount = betHistory.getIn([id, 'cashout', 'amount']);
	
	            if (!cashoutStatus) {
	                if (cashoutAmount > 0) {
	                    if (!betHistory.hasIn([id, 'cashout'])) {
	                        betHistory = betHistory.setIn([id, 'cashout'], new _immutable.Map());
	                    }
	                    betHistory = betHistory.updateIn([id, 'cashout'], function (c) {
	                        c = c.set('state', CashoutStatus.AVAILABLE);
	                        return c.set('amount', cashoutAmount);
	                    });
	                }
	
	                return betHistory;
	            }
	
	            switch (cashoutStatus) {
	                case CashoutStatus.REJECTED:
	                case CashoutStatus.UNAVAILABLE:
	                    if (cashoutAmount > 0) {
	                        betHistory = betHistory.updateIn([id, 'cashout'], function (c) {
	                            return c.set('amount', cashoutAmount);
	                        });
	                        betHistory = betHistory.updateIn([id, 'cashout'], function (c) {
	                            return c.set('state', CashoutStatus.AVAILABLE);
	                        });
	                    }
	                    return betHistory;
	
	                case CashoutStatus.AVAILABLE:
	                    if (cashoutAmount === 0) {
	                        betHistory = betHistory.updateIn([id, 'cashout'], function (c) {
	                            return c.set('state', CashoutStatus.UNAVAILABLE);
	                        });
	                    } else {
	                        betHistory = betHistory.updateIn([id, 'cashout'], function (c) {
	                            return c.set('amount', cashoutAmount);
	                        });
	                    }
	                    return betHistory;
	
	                case CashoutStatus.AMOUNT_CHANGED:
	                    if (cashoutAmount === 0) {
	                        betHistory = betHistory.updateIn([id, 'cashout'], function (c) {
	                            return c.set('state', CashoutStatus.UNAVAILABLE);
	                        });
	                    } else {
	                        betHistory = betHistory.updateIn([id, 'cashout'], function (c) {
	                            return c.set('amount', cashoutAmount);
	                        });
	                        if (cashoutAmount === previousAmount) {
	                            betHistory = betHistory.updateIn([id, 'cashout'], function (c) {
	                                return c.set('state', CashoutStatus.AVAILABLE);
	                            });
	                        }
	                    }
	                    return betHistory;
	
	                case CashoutStatus.MBOX_SHOWN:
	                case CashoutStatus.SELL_REQUESTED:
	                case CashoutStatus.SUCCESS:
	                    return betHistory;
	            }
	
	            return betHistory;
	
	        case BetStatus.CASHOUT:
	            var betCashout = betHistory.getIn([id, 'cashout']);
	            if (betCashout) {
	                return betHistory.updateIn([id, 'cashout'], function (bh) {
	                    return bh.set('state', CashoutStatus.SUCCESS);
	                });
	            }
	    }
	
	    return betHistory;
	}
	
	function setCashoutStatus(betHistory, cashout) {
	    var betId = cashout.betId;
	    var status = cashout.status;
	
	    if (!betHistory.has(betId)) {
	        return betHistory;
	    }
	
	    return betHistory.updateIn([betId, 'cashout'], function (c) {
	        return c.set('state', status);
	    });
	}
	
	function clearCashout(betHistory, cashout) {
	    var betId = cashout.betId;
	
	    if (!betHistory.has(betId)) {
	        return betHistory;
	    }
	
	    return betHistory.updateIn([betId, 'cashout'], function (c) {
	        return c.set('state', CashoutStatus.REJECTED);
	    });
	}
	
	function createCashout(betHistory, createCashout) {
	    var betId = createCashout.betId;
	    var requestId = createCashout.requestId;
	    var amount = createCashout.amount;
	    var error = createCashout.error;
	
	    if (!betHistory.has(betId)) {
	        return betHistory;
	    }
	
	    var betStatus = betHistory.getIn([betId, 'betStatus']);
	    if (betStatus !== BetStatus.CONFIRMED) {
	        return betHistory;
	    }
	
	    if (error !== undefined) {
	        if (error === -2) {
	            betHistory = betHistory.updateIn([betId, 'cashout'], function (c) {
	                return c.set('amount', amount);
	            });
	            return betHistory.updateIn([betId, 'cashout'], function (c) {
	                return c.set('state', CashoutStatus.AMOUNT_CHANGED);
	            });
	        }
	
	        betHistory = betHistory.updateIn([betId, 'cashout'], function (c) {
	            return c.set('amount', 0);
	        });
	        return betHistory.updateIn([betId, 'cashout'], function (c) {
	            return c.set('state', CashoutStatus.REJECTED);
	        });
	    }
	
	    if (requestId === -1) {
	        return betHistory.updateIn([betId, 'cashout'], function (c) {
	            return c.set('state', CashoutStatus.SUCCESS);
	        });
	    }
	
	    betHistory = betHistory.updateIn([betId, 'cashout'], function (c) {
	        return c.set('requestId', requestId);
	    });
	    return betHistory.updateIn([betId, 'cashout'], function (c) {
	        return c.set('state', CashoutStatus.SELL_REQUESTED);
	    });
	}
	
	function betSold(betHistory, createCashout) {
	    var betId = createCashout.betId;
	    var requestId = createCashout.requestId;
	    var amount = createCashout.amount;
	
	    if (!betHistory.has(betId)) {
	        return betHistory;
	    }
	
	    var betStatus = betHistory.getIn([betId, 'betStatus']);
	    if (betStatus !== BetStatus.CONFIRMED) {
	        return betHistory;
	    }
	
	    betHistory = betHistory.updateIn([betId], function (bh) {
	        return bh.set('possibleWinAmount', amount);
	    });
	
	    if (requestId === -1) {
	        return betHistory.updateIn([betId], function (c) {
	            return c.set('betStatus', BetStatus.CASHOUT);
	        });
	    }
	
	    return betHistory;
	}
	
	function cashoutRequestStateChanged(betHistory, cashoutState) {
	    var betId = cashoutState.betId;
	    var state = cashoutState.state;
	    var error = cashoutState.error;
	
	    if (!betHistory.has(betId)) {
	        return betHistory;
	    }
	
	    var betStatus = betHistory.getIn([betId, 'betStatus']);
	    if (betStatus !== BetStatus.CONFIRMED) {
	        return betHistory;
	    }
	
	    if (error) {
	        return betHistory;
	    }
	
	    switch (state) {
	        case CashoutRequestStatus.ACCEPTED:
	            return betHistory.updateIn([betId, 'cashout'], function (c) {
	                return c.set('state', CashoutStatus.SUCCESS);
	            });
	        case CashoutRequestStatus.REJECTED:
	        case CashoutRequestStatus.TIMEDOUT:
	            return betHistory.updateIn([betId, 'cashout'], function (c) {
	                return c.set('state', CashoutStatus.REJECTED);
	            });
	
	    }
	
	    return betHistory;
	}

/***/ },
/* 1374 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = betradarReducer;
	
	var _widget = __webpack_require__(565);
	
	var ActionsType = _interopRequireWildcard(_widget);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  activeWidgetId: null,
	  activeWidgetSportId: null,
	  name: ''
	};
	
	function betradarReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case ActionsType.SET_RADAR_WIDGET:
	      return (0, _extends3.default)({}, state, {
	        activeWidgetId: action.data.radarId,
	        activeWidgetSportId: action.data.sportId,
	        name: action.data.name
	      });
	    case ActionsType.REMOVE_RADAR_WIDGET:
	      window.radarWidget.stop();
	      return (0, _extends3.default)({}, state, {
	        activeWidgetId: null
	      });
	    default:
	      return state;
	  }
	}

/***/ },
/* 1375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    switch (action.type) {
	        case MakeBetActions.MAKE_BET:
	            return false;
	
	        case MakeBetActions.SUCCESS_MAKE_BET:
	        case MakeBetActions.FAILURE_MAKE_BET:
	            return true;
	    }
	
	    return state;
	};
	
	var _MakeBet = __webpack_require__(117);
	
	var MakeBetActions = _interopRequireWildcard(_MakeBet);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/***/ },
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (bettingMode, action) {
	    switch (action.type) {
	        case StorageActions.LOAD_STORAGE:
	            {
	                var storageBettingMode = action.data.bettingMode;
	                if (storageBettingMode) {
	                    return storageBettingMode;
	                }
	                return bettingMode;
	            }
	
	        case BettingModeActions.TOGGLE_ONE_CLICK_MODE:
	            return bettingMode.set('isOneClick', !bettingMode.get('isOneClick'));
	
	        case BettingModeActions.SET_ACCEPT_FACTOR_CHANGE_MODE:
	            return bettingMode.set('acceptFactorChange', action.data);
	
	        case BettingModeActions.TOGGLE_ACCEPT_FACTOR_INCREASE:
	            return setAcceptFactorChangeOnAcceptIncrease(bettingMode, action.data);
	
	        case BettingModeActions.TOGGLE_ACCEPT_FACTOR_DECREASE:
	            return setAcceptFactorChangeOnAcceptDecrease(bettingMode, action.data);
	
	        case BettingModeActions.SET_ONE_CLICK_AMOUNT:
	            return bettingMode.set('oneClickAmount', action.data);
	
	        case BettingModeActions.SET_FAVOURITE_BET_AMOUNT:
	            return setFavouriteBetAmount(bettingMode, action.data);
	    }
	
	    return bettingMode;
	};
	
	var _BettingMode = __webpack_require__(483);
	
	var BettingModeActions = _interopRequireWildcard(_BettingMode);
	
	var _Storage = __webpack_require__(69);
	
	var StorageActions = _interopRequireWildcard(_Storage);
	
	var _AcceptFactorChange = __webpack_require__(333);
	
	var AcceptFactorChangeMode = _interopRequireWildcard(_AcceptFactorChange);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function setFavouriteBetAmount(bettingMode, favouriteBet) {
	    switch (favouriteBet.number) {
	        case 1:
	            return bettingMode.set('favouriteBet1Amount', favouriteBet.amount);
	        case 2:
	            return bettingMode.set('favouriteBet2Amount', favouriteBet.amount);
	        case 3:
	            return bettingMode.set('favouriteBet3Amount', favouriteBet.amount);
	    }
	
	    return bettingMode;
	}
	
	function setAcceptFactorChangeOnAcceptIncrease(bettingMode, acceptIncrease) {
	    var currentMode = bettingMode.get('acceptFactorChange');
	
	    if (acceptIncrease) {
	        if (!currentMode || currentMode === AcceptFactorChangeMode.NONE) {
	            return bettingMode.set('acceptFactorChange', AcceptFactorChangeMode.INCREASE);
	        } else if (currentMode === AcceptFactorChangeMode.DECREASE) {
	            return bettingMode.set('acceptFactorChange', AcceptFactorChangeMode.BOTH);
	        }
	    } else {
	        if (currentMode && currentMode === AcceptFactorChangeMode.BOTH) {
	            return bettingMode.set('acceptFactorChange', AcceptFactorChangeMode.DECREASE);
	        } else if (currentMode === AcceptFactorChangeMode.INCREASE) {
	            return bettingMode.set('acceptFactorChange', AcceptFactorChangeMode.NONE);
	        }
	    }
	
	    return bettingMode;
	}
	
	function setAcceptFactorChangeOnAcceptDecrease(bettingMode, acceptDecrease) {
	    var currentMode = bettingMode.get('acceptFactorChange');
	
	    if (acceptDecrease) {
	        if (!currentMode || currentMode === AcceptFactorChangeMode.NONE) {
	            return bettingMode.set('acceptFactorChange', AcceptFactorChangeMode.DECREASE);
	        } else if (currentMode === AcceptFactorChangeMode.INCREASE) {
	            return bettingMode.set('acceptFactorChange', AcceptFactorChangeMode.BOTH);
	        }
	    } else {
	        if (currentMode && currentMode === AcceptFactorChangeMode.BOTH) {
	            return bettingMode.set('acceptFactorChange', AcceptFactorChangeMode.INCREASE);
	        } else if (currentMode === AcceptFactorChangeMode.DECREASE) {
	            return bettingMode.set('acceptFactorChange', AcceptFactorChangeMode.NONE);
	        }
	    }
	
	    return bettingMode;
	}

/***/ },
/* 1377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = connectionStatusReducer;
	
	var _ConnectionStatus = __webpack_require__(949);
	
	var ConnectionStatusActions = _interopRequireWildcard(_ConnectionStatus);
	
	var _ConnectionStatus2 = __webpack_require__(494);
	
	var ConnectionStatus = _interopRequireWildcard(_ConnectionStatus2);
	
	var _actions = __webpack_require__(30);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function connectionStatusReducer(connectionStatus, action) {
	    switch (action.type) {
	        case ConnectionStatusActions.SET_CONNECTION_STATUS:
	            return action.data;
	        case _actions.LIVE_INIT.FAILURE:
	        case _actions.LIVE_UPDATE.FAILURE:
	        case _actions.TIMETABLE_INIT.FAILURE:
	        case _actions.TIMETABLE_UPDATE.FAILURE:
	            return ConnectionStatus.DISCONNECTED;
	    }
	
	    return connectionStatus;
	}

/***/ },
/* 1378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = alternativeStakeReducer;
	
	var _MakeBet = __webpack_require__(117);
	
	var MakeBetActions = _interopRequireWildcard(_MakeBet);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function alternativeStakeReducer(alternativeStake, action) {
	    switch (action.type) {
	        case MakeBetActions.SUCCESS_MAKE_BET:
	            var createdBets = action.data;
	
	            for (var offset = 0; offset < createdBets.length; offset++) {
	                var createdBet = createdBets[offset];
	
	                if (createdBet.error !== undefined && createdBet.error) {
	                    if (createdBet.error === -18) {
	                        return createdBet.alternativeStake;
	                    } else {
	                        return null;
	                    }
	                }
	            }
	    }
	
	    return null;
	}

/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = amountReducer;
	
	var _CouponRate = __webpack_require__(130);
	
	var CouponRateActions = _interopRequireWildcard(_CouponRate);
	
	var _MakeBet = __webpack_require__(117);
	
	var MakeBetActions = _interopRequireWildcard(_MakeBet);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function amountReducer(amount, action) {
	    switch (action.type) {
	        case CouponRateActions.SET_COUPON_AMOUNT:
	            return action.data;
	        case MakeBetActions.SUCCESS_MAKE_BET:
	            var createdBets = action.data;
	
	            for (var offset = 0; offset < createdBets.length; offset++) {
	                var createdBet = createdBets[offset];
	
	                if (createdBet.error !== undefined && createdBet.error) {
	                    if (createdBet.error === -18) {
	                        return 0;
	                    }
	                }
	            }
	    }
	
	    return amount;
	}

/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = betSlipAmountsReducer;
	
	var _immutable = __webpack_require__(14);
	
	var _CouponRate = __webpack_require__(130);
	
	var CouponRateActions = _interopRequireWildcard(_CouponRate);
	
	var _MakeBet = __webpack_require__(117);
	
	var MakeBetActions = _interopRequireWildcard(_MakeBet);
	
	var _BettingMode = __webpack_require__(483);
	
	var BettingModeActions = _interopRequireWildcard(_BettingMode);
	
	var _SignoutAction = __webpack_require__(118);
	
	var SignoutActions = _interopRequireWildcard(_SignoutAction);
	
	var _Storage = __webpack_require__(69);
	
	var StorageActions = _interopRequireWildcard(_Storage);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = new _immutable.Map();
	
	function betSlipAmountsReducer(betSlipAmounts, action) {
	    switch (action.type) {
	        case StorageActions.LOAD_STORAGE:
	            var storedBetSlipAmounts = action.data.betSlipAmounts;
	            if (storedBetSlipAmounts !== undefined && storedBetSlipAmounts !== null) {
	                for (var rateId in storedBetSlipAmounts) {
	                    betSlipAmounts = betSlipAmounts.set(Number(rateId), new _immutable.Map(storedBetSlipAmounts[rateId]));
	                }
	            }
	            break;
	
	        case SignoutActions.SUCCESS_SIGNOUT:
	            return initialState;
	
	        /*case CouponRateActions.SET_COUPON_BET_TYPE:
	            const betTypeIndex = action.data;
	            return (betTypeIndex !== 0 && betTypeIndex !== -1) ? initialState : betSlipAmounts;*/
	
	        case CouponRateActions.ADD_COUPON_RATE:
	            return addCouponBetSlipAmount(betSlipAmounts, action.data);
	
	        case CouponRateActions.REMOVE_COUPON_RATE:
	            return removeCouponBetSlipAmount(betSlipAmounts, action.data);
	
	        case CouponRateActions.CHANGE_COUPON_SLIP_AMOUNT:
	            return changeCouponBetSlipAmount(betSlipAmounts, action.data);
	
	        case CouponRateActions.REMOVE_COUPON_RATES:
	            return initialState;
	
	        //case MakeBetActions.MAKE_BET:
	        //return initialState;
	
	        case MakeBetActions.SUCCESS_MAKE_BET:
	            var createdBets = action.data;
	            var rateBlockNum = 0;
	
	            var _loop = function _loop(offset) {
	                var createdBet = createdBets[offset];
	
	                if (createdBet.error !== undefined && createdBet.error) {
	                    if (createdBet.error === -3 && createdBet.factors !== undefined) {
	                        rateBlockNum++;
	                    }
	                    if (createdBet.error === -18) {
	                        rateBlockNum++;
	                        ((createdBet.basketBet || {}).factors || []).map(function (_ref) {
	                            var factorId = _ref.factorId;
	
	                            betSlipAmounts = betSlipAmounts.setIn([factorId, 'amount'], 0);
	                            betSlipAmounts = betSlipAmounts.setIn([factorId, 'alternativeStake'], createdBet.alternativeStake);
	                        });
	                    }
	                }
	            };
	
	            for (var offset = 0; offset < createdBets.length; offset++) {
	                _loop(offset);
	            }
	
	            return rateBlockNum === 0 ? initialState : betSlipAmounts;
	
	        case MakeBetActions.FAILURE_MAKE_BET:
	        case BettingModeActions.TOGGLE_ONE_CLICK_MODE:
	            return initialState;
	    }
	
	    return betSlipAmounts;
	}
	
	function addCouponBetSlipAmount(betSlipAmounts, addRate) {
	    var rateId = addRate.rate.get('id');
	
	    if (!betSlipAmounts.has(rateId)) {
	        betSlipAmounts = betSlipAmounts.set(rateId, new _immutable.Map({ amount: 0, isFreeBet: false }));
	    }
	
	    return betSlipAmounts;
	}
	
	function removeCouponBetSlipAmount(betSlipAmounts, removeCouponRate) {
	    var rateId = removeCouponRate.rateId;
	
	    betSlipAmounts = betSlipAmounts.delete(rateId);
	
	    return betSlipAmounts;
	}
	
	function changeCouponBetSlipAmount(betSlipAmounts, couponRates) {
	    for (var offset = 0; offset < couponRates.length; offset++) {
	        var rateId = couponRates[offset].rateId;
	        var amount = couponRates[offset].amount;
	
	        betSlipAmounts = betSlipAmounts.setIn([rateId, 'amount'], amount);
	
	        if (couponRates[offset].isFreeBet !== undefined) {
	            betSlipAmounts = betSlipAmounts.map(function (slipAmount) {
	                return slipAmount.set('isFreeBet', false);
	            });
	            betSlipAmounts = betSlipAmounts.setIn([rateId, 'isFreeBet'], couponRates[offset].isFreeBet);
	        }
	    }
	
	    return betSlipAmounts;
	}

/***/ },
/* 1381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = betSlipsReducer;
	
	var _immutable = __webpack_require__(14);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _actions = __webpack_require__(30);
	
	var _CouponRate = __webpack_require__(130);
	
	var CouponRateActions = _interopRequireWildcard(_CouponRate);
	
	var _MakeBet = __webpack_require__(117);
	
	var MakeBetActions = _interopRequireWildcard(_MakeBet);
	
	var _BettingMode = __webpack_require__(483);
	
	var BettingModeActions = _interopRequireWildcard(_BettingMode);
	
	var _SignoutAction = __webpack_require__(118);
	
	var SignoutActions = _interopRequireWildcard(_SignoutAction);
	
	var _Storage = __webpack_require__(69);
	
	var StorageActions = _interopRequireWildcard(_Storage);
	
	var _BettingState = __webpack_require__(748);
	
	var BettingState = _interopRequireWildcard(_BettingState);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = new _immutable.Map();
	
	function betSlipsReducer(betSlips, action) {
	    switch (action.type) {
	        case StorageActions.LOAD_STORAGE:
	            var storedBetSlips = action.data.betSlips;
	            if (storedBetSlips !== undefined && storedBetSlips !== null) {
	                storedBetSlips.forEach(function (slip) {
	                    var addRate = {
	                        match: slip.get('match'),
	                        outcome: slip.get('outcome'),
	                        score: slip.get('score'),
	                        rate: slip.get('rate')
	                    };
	
	                    betSlips = addCouponBetSlip(betSlips, addRate);
	                });
	
	                return betSlips;
	            }
	            break;
	
	        case SignoutActions.SUCCESS_SIGNOUT:
	            return initialState;
	
	        case _actions.LIVE_UPDATE.SUCCESS:
	            return update(betSlips, action.data);
	
	        case CouponRateActions.ADD_COUPON_RATE:
	            return addCouponBetSlip(betSlips, action.data);
	
	        case CouponRateActions.REMOVE_COUPON_RATE:
	            return removeCouponBetSlip(betSlips, action.data);
	
	        case CouponRateActions.REMOVE_COUPON_RATES:
	            return initialState;
	
	        /*case MakeBetActions.MAKE_BET:
	            return initialState;*/
	
	        case MakeBetActions.SUCCESS_MAKE_BET:
	            var createdBets = action.data;
	            var rateBlockNum = 0;
	
	            for (var offset = 0; offset < createdBets.length; offset++) {
	                var createdBet = createdBets[offset];
	
	                if (createdBet.error !== undefined && createdBet.error) {
	                    if (createdBet.error === -3 && createdBet.factors !== undefined) {
	                        rateBlockNum++;
	                        betSlips = applyRateChanges(betSlips, createdBet.factors);
	                    }
	                    if (createdBet.error === -18) {
	                        rateBlockNum++;
	                    }
	                }
	            }
	
	            return rateBlockNum === 0 ? initialState : betSlips;
	
	        case MakeBetActions.FAILURE_MAKE_BET:
	        case BettingModeActions.TOGGLE_ONE_CLICK_MODE:
	            return initialState;
	
	        case CouponRateActions.ACCEPT_RATE_VALUE_CHANGE:
	            return acceptRateValueChange(betSlips, action.data);
	    }
	
	    return betSlips;
	}
	
	function update(betSlips, data) {
	    if (data.sports !== undefined) {
	        if (data.sports.add !== undefined) {
	            betSlips = updateBetSlipsBlock(betSlips, 'sportId', 'isBlockedBySport', data.sports.add, false);
	        }
	        if (data.sports.remove !== undefined) {
	            betSlips = updateBetSlipsBlock(betSlips, 'sportId', 'isBlockedBySport', data.sports.remove, true);
	        }
	    }
	    if (data.leagues !== undefined) {
	        if (data.leagues.add !== undefined) {
	            betSlips = updateBetSlipsBlock(betSlips, 'leagueId', 'isBlockedByLeague', data.leagues.add, false);
	        }
	        if (data.leagues.remove !== undefined) {
	            betSlips = updateBetSlipsBlock(betSlips, 'leagueId', 'isBlockedByLeague', data.leagues.remove, true);
	        }
	    }
	    if (data.events !== undefined) {
	        if (data.events.add !== undefined) {
	            betSlips = updateBetSlipsBlock(betSlips, 'matchId', 'isBlockedByMatch', data.events.add, false);
	        }
	        if (data.events.remove !== undefined) {
	            betSlips = updateBetSlipsBlock(betSlips, 'matchId', 'isBlockedByMatch', data.events.remove, true);
	        }
	    }
	    if (data.blocked_events !== undefined) {
	        if (data.blocked_events.add !== undefined) {
	            betSlips = updateBetSlipsBlock(betSlips, 'matchId', 'isBlockedByMatch', data.blocked_events.add, true, function (e) {
	                return e;
	            });
	        }
	        if (data.blocked_events.remove !== undefined) {
	            betSlips = updateBetSlipsBlock(betSlips, 'matchId', 'isBlockedByMatch', data.blocked_events.remove, false, function (e) {
	                return e;
	            });
	        }
	    }
	    if (data.groups !== undefined) {
	        if (data.groups.add !== undefined) {
	            betSlips = updateBetSlipsBlock(betSlips, 'groupId', 'isBlockedByGroup', data.groups.add, false);
	        }
	        if (data.groups.remove !== undefined) {
	            betSlips = updateBetSlipsBlock(betSlips, 'groupId', 'isBlockedByGroup', data.groups.remove, true);
	        }
	    }
	    if (data.outcomes !== undefined) {
	        if (data.outcomes.add !== undefined) {
	            betSlips = updateBetSlipsBlock(betSlips, 'outcomeId', 'isBlockedByOutcome', data.outcomes.add, false);
	        }
	        if (data.outcomes.remove !== undefined) {
	            betSlips = updateBetSlipsBlock(betSlips, 'outcomeId', 'isBlockedByOutcome', data.outcomes.remove, true);
	        }
	    }
	    if (data.blocked_outcomes !== undefined) {
	        if (data.blocked_outcomes.add !== undefined) {
	            betSlips = updateBetSlipsBlock(betSlips, 'outcomeId', 'isBlockedByOutcome', data.blocked_outcomes.add, true, function (e) {
	                return e;
	            });
	        }
	        if (data.blocked_outcomes.remove !== undefined) {
	            betSlips = updateBetSlipsBlock(betSlips, 'outcomeId', 'isBlockedByOutcome', data.blocked_outcomes.remove, false, function (e) {
	                return e;
	            });
	        }
	    }
	    if (data.rates !== undefined) {
	        if (data.rates.add !== undefined) {
	            betSlips = addRates(betSlips, data.rates.add);
	        }
	        if (data.rates.change !== undefined) {
	            betSlips = changeRates(betSlips, data.rates.change);
	        }
	    }
	    return betSlips;
	}
	
	function addCouponBetSlip(betSlips, addRate) {
	    var match = addRate.match;
	    var outcome = addRate.outcome;
	    var score = addRate.score;
	    var rate = addRate.rate;
	
	    var rateId = rate.get('id');
	
	    if (!betSlips.has(rateId)) {
	        var value = _immutable2.default.fromJS({
	            rate: rate,
	            outcome: {
	                name: outcome.get('name')
	            },
	            match: {
	                timeAndZone: match.get('timeAndZone'),
	                name: match.get('name'),
	                notice: match.get('notice')
	            },
	            score: score ? {
	                score1: score.get('score1'),
	                score2: score.get('score2')
	            } : undefined
	        });
	
	        betSlips = betSlips.set(rateId, value);
	    }
	
	    return betSlips;
	}
	
	function removeCouponBetSlip(betSlips, removeCouponRate) {
	    var rateId = removeCouponRate.rateId;
	
	    betSlips = betSlips.delete(rateId);
	
	    return betSlips;
	}
	
	function addRates(betSlips, addRates) {
	    for (var i = 0; i < addRates.length; i++) {
	        var rateId = addRates[i].id;
	
	        if (!betSlips.has(rateId)) {
	            continue;
	        }
	
	        betSlips = betSlips.updateIn([rateId, 'rate', 'isBlocked'], function () {
	            return false;
	        });
	    }
	
	    return betSlips;
	}
	
	function changeRates(betSlips, changeRates) {
	    if (changeRates === undefined) {
	        return betSlips;
	    }
	
	    var _loop = function _loop(_rateId) {
	        if (!changeRates.hasOwnProperty(_rateId)) {
	            return 'continue';
	        }
	
	        if (!betSlips.has(parseInt(_rateId))) {
	            return 'continue';
	        }
	
	        var rateValue = changeRates[_rateId];
	        _rateId = parseInt(_rateId);
	
	        betSlips = betSlips.update(_rateId, function (bs) {
	            bs = bs.update('rate', function (r) {
	                return r.update('isBlocked', function () {
	                    return r.get('value') !== rateValue;
	                });
	            });
	
	            return bs.update('rate', function (r) {
	                return r.update('actualValue', function () {
	                    return rateValue;
	                });
	            });
	        });
	        rateId = _rateId;
	    };
	
	    for (var rateId in changeRates) {
	        var _ret = _loop(rateId);
	
	        if (_ret === 'continue') continue;
	    }
	
	    return betSlips;
	}
	
	function acceptRateValueChange(betSlips, ratesChanged) {
	    var _loop2 = function _loop2(i) {
	        var rateChanged = ratesChanged[i];
	
	        betSlips = betSlips.update(rateChanged.id, function (bs) {
	            bs = bs.update('rate', function (r) {
	                return r.update('isBlocked', function () {
	                    return false;
	                });
	            });
	            return bs.update('rate', function (r) {
	                return r.update('value', function () {
	                    return rateChanged.actualValue;
	                });
	            });
	        });
	    };
	
	    for (var i = 0; i < ratesChanged.length; i++) {
	        _loop2(i);
	    }
	
	    return betSlips;
	}
	
	function updateBetSlipsBlock(betSlips, field, blockField, values, isBlocked, valueFunc) {
	    for (var i = 0; i < values.length; i++) {
	        var id = typeof valueFunc === 'function' ? valueFunc(values[i]) : values[i].id;
	
	        var affectedBetSlips = getAffectedBetSlips(betSlips, field, id);
	
	        affectedBetSlips.forEach(function (bs) {
	            var rateId = bs.getIn(['rate', 'id']);
	
	            betSlips = betSlips.updateIn([rateId, 'rate', blockField], function () {
	                return isBlocked;
	            });
	        });
	    }
	
	    return betSlips;
	}
	
	function getAffectedBetSlips(betSlips, field, value) {
	    return betSlips.filter(function (bs) {
	        if (bs.getIn(['rate', field]) === value) {
	            return bs;
	        }
	    });
	}
	
	function applyRateChanges(betSlips, factors) {
	    if (factors !== undefined && factors.length > 0) {
	        for (var offset = 0; offset < factors.length; offset++) {
	            var _rateId2 = factors[offset].FactorId;
	            var state = factors[offset].BettingState;
	            var value = factors[offset].InitialValue;
	            var actualValue = factors[offset].Value;
	
	            var isChangedFactor = state == BettingState.FACTOR_CHANGED || state == BettingState.CORRECT && value !== actualValue;
	
	            var isClosedOutcome = state == BettingState.FACTOR_CLOSED || state == BettingState.OUTCOME_CLOSED;
	
	            var isClosedEvent = state == BettingState.EVENT_CLOSED;
	
	            if (isChangedFactor) {
	                betSlips = betSlips.setIn([_rateId2, 'rate', 'isBlocked'], true);
	                if (actualValue > 0) {
	                    betSlips = betSlips.setIn([_rateId2, 'rate', 'actualValue'], actualValue);
	                }
	            } else if (isClosedOutcome) {
	                betSlips = betSlips.setIn([_rateId2, 'rate', 'isBlockedByOutcome'], true);
	            } else if (isClosedEvent) {
	                betSlips = betSlips.setIn([_rateId2, 'rate', 'isBlockedByMatch'], true);
	            }
	        }
	    }
	
	    return betSlips;
	}

/***/ },
/* 1382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = betTypesReducer;
	
	var _immutable = __webpack_require__(14);
	
	var _underscore = __webpack_require__(145);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _HistoryBet = __webpack_require__(302);
	
	var HistoryBetActions = _interopRequireWildcard(_HistoryBet);
	
	var _CouponRate = __webpack_require__(130);
	
	var CouponRateActions = _interopRequireWildcard(_CouponRate);
	
	var _MakeBet = __webpack_require__(117);
	
	var MakeBetActions = _interopRequireWildcard(_MakeBet);
	
	var _BetType = __webpack_require__(46);
	
	var BetTypes = _interopRequireWildcard(_BetType);
	
	var _Storage = __webpack_require__(69);
	
	var StorageActions = _interopRequireWildcard(_Storage);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function betTypesReducer(betTypes, betSlips, action) {
	    switch (action.type) {
	        case StorageActions.LOAD_STORAGE:
	            var storedBetTypes = action.data.betTypes;
	            if (storedBetTypes !== undefined && storedBetTypes !== null) {
	                return new _immutable.List(storedBetTypes);
	            }
	            break;
	
	        case HistoryBetActions.SUCCESS_REQUEST_BET_TYPES:
	            betTypes = fillBetTypes(betSlips, action.data);
	            break;
	
	        case HistoryBetActions.FAILURE_REQUEST_BET_TYPES:
	        case CouponRateActions.REMOVE_COUPON_RATES:
	        case MakeBetActions.FAILURE_MAKE_BET:
	            //case MakeBetActions.MAKE_BET:
	            return new _immutable.List();
	
	        case MakeBetActions.SUCCESS_MAKE_BET:
	            var createdBets = action.data;
	            var rateBlockNum = 0;
	
	            for (var offset = 0; offset < createdBets.length; offset++) {
	                var createdBet = createdBets[offset];
	
	                if (createdBet.error !== undefined && createdBet.error) {
	                    if (createdBet.error === -3 && createdBet.factors !== undefined) {
	                        rateBlockNum++;
	                    }
	                    if (createdBet.error === -18) {
	                        rateBlockNum++;
	                    }
	                }
	            }
	
	            return rateBlockNum === 0 ? new _immutable.List() : betTypes;
	    }
	
	    return betTypes;
	}
	
	function fillBetTypes(betSlips, data) {
	    if (data.error) {
	        return new _immutable.List();
	    }
	
	    var betTypes = new _immutable.List(data.betTypes);
	    var antiExpressOdd = data.antiExpressOdd;
	
	    var extendedBetTypes = new _immutable.List();
	
	    var ratesCount = betSlips.size;
	    var rateValues = betSlips.valueSeq().map(function (bs) {
	        return bs.getIn(['rate', 'value']);
	    }).toArray();
	
	    for (var i = 0; i < betTypes.size; i++) {
	        var betTypeId = betTypes.get(i);
	
	        var odd = 0;
	        switch (betTypeId) {
	            case BetTypes.SINGLE:
	                odd = _underscore2.default.reduce(rateValues, function (sum, r) {
	                    return sum + r;
	                }, 0);
	
	                extendedBetTypes = extendedBetTypes.push({
	                    type: BetTypes.SINGLE,
	                    odd: odd
	                });
	                break;
	            case BetTypes.EXPRESS:
	                odd = _underscore2.default.reduce(rateValues, function (prod, r) {
	                    return prod * r;
	                }, 1);
	
	                extendedBetTypes = extendedBetTypes.push({
	                    type: BetTypes.EXPRESS,
	                    odd: odd
	                });
	                break;
	            case BetTypes.SYSTEM:
	                for (var rank = 2; rank < ratesCount; rank++) {
	                    odd = getSystemOdd(rateValues, rank);
	
	                    extendedBetTypes = extendedBetTypes.push({
	                        type: betTypeId,
	                        rank: rank,
	                        count: ratesCount,
	                        odd: odd
	                    });
	                }
	                break;
	            /*case BetTypes.ANTIEXPRESS:
	                extendedBetTypes = extendedBetTypes.push({
	                    type: BetTypes.ANTIEXPRESS,
	                    odd: antiExpressOdd
	                });
	                break;*/
	        }
	    }
	
	    return extendedBetTypes;
	}
	
	function getSystemOdd(rates, rank) {
	    function recursiveGetCombinations(rates, rank, index, tempArr, result) {
	        for (var i = index; i < rates.length; i++) {
	            (function (index) {
	                var rateArr = tempArr.slice(0);
	                rateArr.push(rates[index]);
	
	                if (rank > 1) {
	                    return recursiveGetCombinations(rates, rank - 1, index + 1, rateArr, result);
	                } else {
	                    result.push(rateArr);
	                }
	            })(i);
	        }
	
	        return result;
	    }
	
	    var tempArr = [];
	    var resultArr = [];
	
	    var combinations = recursiveGetCombinations(rates, rank, 0, tempArr, resultArr);
	
	    var odd = 0;
	    for (var i = 0; i < combinations.length; i++) {
	        var combination = combinations[i];
	        var expressOdd = _underscore2.default.reduce(combination, function (prod, r) {
	            return prod * r;
	        }, 1);
	        odd = odd + expressOdd / combinations.length;
	    }
	
	    return odd;
	}

/***/ },
/* 1383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = couponReducer;
	
	var _betSlipsReducer = __webpack_require__(1381);
	
	var _betSlipsReducer2 = _interopRequireDefault(_betSlipsReducer);
	
	var _betTypesReducer = __webpack_require__(1382);
	
	var _betTypesReducer2 = _interopRequireDefault(_betTypesReducer);
	
	var _stateReducer = __webpack_require__(1388);
	
	var _stateReducer2 = _interopRequireDefault(_stateReducer);
	
	var _currentBetTypeSelectedReducer = __webpack_require__(1385);
	
	var _currentBetTypeSelectedReducer2 = _interopRequireDefault(_currentBetTypeSelectedReducer);
	
	var _currentBetTypeReducer = __webpack_require__(1384);
	
	var _currentBetTypeReducer2 = _interopRequireDefault(_currentBetTypeReducer);
	
	var _amountReducer = __webpack_require__(1379);
	
	var _amountReducer2 = _interopRequireDefault(_amountReducer);
	
	var _alternativeStakeReducer = __webpack_require__(1378);
	
	var _alternativeStakeReducer2 = _interopRequireDefault(_alternativeStakeReducer);
	
	var _freebetReducer = __webpack_require__(1386);
	
	var _freebetReducer2 = _interopRequireDefault(_freebetReducer);
	
	var _isFreebetReducer = __webpack_require__(1387);
	
	var _isFreebetReducer2 = _interopRequireDefault(_isFreebetReducer);
	
	var _betSlipAmountsReducer = __webpack_require__(1380);
	
	var _betSlipAmountsReducer2 = _interopRequireDefault(_betSlipAmountsReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function couponReducer(coupon, action) {
	    try {
	        coupon = coupon.update('state', function (s) {
	            return (0, _stateReducer2.default)(s, action);
	        });
	        coupon = coupon.update('betSlips', function (bs) {
	            return (0, _betSlipsReducer2.default)(bs, action);
	        });
	        coupon = coupon.update('betSlipAmounts', function (bsa) {
	            return (0, _betSlipAmountsReducer2.default)(bsa, action);
	        });
	        coupon = coupon.update('betTypes', function (bt) {
	            return (0, _betTypesReducer2.default)(bt, coupon.get('betSlips'), action);
	        });
	        coupon = coupon.update('currentBetTypeSelected', function (cbts) {
	            return (0, _currentBetTypeSelectedReducer2.default)(cbts, action);
	        });
	        coupon = coupon.update('currentBetTypeIndex', function (cbt) {
	            return (0, _currentBetTypeReducer2.default)(cbt, coupon.get('betTypes'), coupon.get('currentBetTypeSelected'), action);
	        });
	        coupon = coupon.update('amount', function (a) {
	            return (0, _amountReducer2.default)(a, action);
	        });
	        coupon = coupon.update('alternativeStake', function (a) {
	            return (0, _alternativeStakeReducer2.default)(a, action);
	        });
	        coupon = coupon.update('freebet', function (f) {
	            return (0, _freebetReducer2.default)(f, action);
	        });
	
	        coupon = coupon.update('isFreebet', function (f) {
	            return (0, _isFreebetReducer2.default)(f, coupon.get('freebet'), coupon.get('betSlips'), coupon.get('betTypes'), coupon.get('currentBetTypeIndex'), action);
	        });
	    } catch (err) {
	        for (var key in localStorage) {
	            if (key.indexOf('_betSlips') !== -1 || key.indexOf('_betTypes') !== -1 || key.indexOf('_betSlipAmounts') !== -1 || key.indexOf('_betTypeIndex') !== -1 || key.indexOf('_couponState') !== -1) {
	                delete localStorage[key];
	            }
	        }
	    }
	
	    return coupon;
	}

/***/ },
/* 1384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = currentBetTypeReducer;
	
	var _CouponRate = __webpack_require__(130);
	
	var CouponRateActions = _interopRequireWildcard(_CouponRate);
	
	var _HistoryBet = __webpack_require__(302);
	
	var HistoryBetActions = _interopRequireWildcard(_HistoryBet);
	
	var _MakeBet = __webpack_require__(117);
	
	var MakeBetActions = _interopRequireWildcard(_MakeBet);
	
	var _BetType = __webpack_require__(46);
	
	var possibleBetTypes = _interopRequireWildcard(_BetType);
	
	var _Storage = __webpack_require__(69);
	
	var StorageActions = _interopRequireWildcard(_Storage);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = -1;
	
	function currentBetTypeReducer(currentBetTypeIndex, betTypes, isBetTypeSelected, action) {
	    if (currentBetTypeIndex === undefined) {
	        return initialState;
	    }
	
	    switch (action.type) {
	        case StorageActions.LOAD_STORAGE:
	            var betTypeIndex = action.data.betTypeIndex;
	            if (betTypeIndex !== undefined && betTypeIndex !== null) {
	                currentBetTypeIndex = betTypeIndex;
	            }
	            break;
	
	        case CouponRateActions.SET_COUPON_BET_TYPE:
	            return action.data;
	
	        case HistoryBetActions.SUCCESS_REQUEST_BET_TYPES:
	            if (!isBetTypeSelected || !betTypes.has(currentBetTypeIndex)) {
	                currentBetTypeIndex = betTypes.indexOf(fetchExpressBetType(betTypes));
	
	                if (currentBetTypeIndex === -1 || betTypes.size === 1) {
	                    currentBetTypeIndex = betTypes.indexOf(betTypes.first());
	                }
	            }
	
	            return currentBetTypeIndex;
	
	        case CouponRateActions.REMOVE_COUPON_RATES:
	            //case MakeBetActions.MAKE_BET:
	            return -1;
	
	        case MakeBetActions.SUCCESS_MAKE_BET:
	            var createdBets = action.data;
	            var rateBlockNum = 0;
	
	            for (var offset = 0; offset < createdBets.length; offset++) {
	                var createdBet = createdBets[offset];
	
	                if (createdBet.error !== undefined && createdBet.error) {
	                    if (createdBet.error === -3 && createdBet.factors !== undefined) {
	                        rateBlockNum++;
	                    }
	                    if (createdBet.error === -18) {
	                        rateBlockNum++;
	                    }
	                }
	            }
	
	            return rateBlockNum === 0 ? initialState : currentBetTypeIndex;
	
	        case MakeBetActions.FAILURE_MAKE_BET:
	            return initialState;
	
	        case CouponRateActions.ACCEPT_RATE_VALUE_CHANGE:
	            return currentBetTypeIndex;
	    }
	
	    return currentBetTypeIndex;
	}
	
	function fetchExpressBetType(betTypes) {
	    if (!betTypes) {
	        return -1;
	    }
	
	    var betTypeCollection = betTypes.toArray();
	    var defaultBetType = -1;
	
	    for (var offset in betTypeCollection) {
	        if (betTypeCollection[offset].type == possibleBetTypes.EXPRESS) {
	            defaultBetType = betTypeCollection[offset];
	            break;
	        }
	    }
	
	    return defaultBetType;
	}

/***/ },
/* 1385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = currentBetTypeSelectedReducer;
	
	var _CouponRate = __webpack_require__(130);
	
	var CouponRateActions = _interopRequireWildcard(_CouponRate);
	
	var _MakeBet = __webpack_require__(117);
	
	var MakeBetActions = _interopRequireWildcard(_MakeBet);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = false;
	
	function currentBetTypeSelectedReducer(state, action) {
	    switch (action.type) {
	        case CouponRateActions.SET_COUPON_BET_TYPE:
	            return true;
	
	        case CouponRateActions.REMOVE_COUPON_RATES:
	            return initialState;
	
	        case MakeBetActions.SUCCESS_MAKE_BET:
	            var createdBets = action.data;
	            var rateBlockNum = 0;
	
	            for (var offset = 0; offset < createdBets.length; offset++) {
	                var createdBet = createdBets[offset];
	
	                if (createdBet.error !== undefined && createdBet.error) {
	                    if (createdBet.error === -3 && createdBet.factors !== undefined) {
	                        rateBlockNum++;
	                    }
	                    if (createdBet.error === -18) {
	                        rateBlockNum++;
	                    }
	                }
	            }
	
	            return rateBlockNum === 0 ? initialState : true;
	
	        case MakeBetActions.FAILURE_MAKE_BET:
	            return initialState;
	    }
	
	    return state;
	}

/***/ },
/* 1386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = freebetReducer;
	
	var _immutable = __webpack_require__(14);
	
	var _momentTimezone = __webpack_require__(76);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _actions = __webpack_require__(30);
	
	var _SigninAction = __webpack_require__(158);
	
	var Signin = _interopRequireWildcard(_SigninAction);
	
	var _loadAuthAction = __webpack_require__(131);
	
	var LoadAuth = _interopRequireWildcard(_loadAuthAction);
	
	var _Freebet = __webpack_require__(559);
	
	var Freebet = _interopRequireWildcard(_Freebet);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function freebetReducer(freebet, action) {
	    switch (action.type) {
	        case Freebet.GET_FREEBET:
	        case Freebet.FAILURE_GET_FREEBET:
	        case _actions.GET_FREEBET.REQUEST:
	        case _actions.GET_FREEBET.FAILURE:
	            return new _immutable.Map();
	
	        case Signin.SUCCESS_SIGNIN:
	        case LoadAuth.SUCCESS_RESTORE:
	            return setFreebet(freebet, action.data.Freebet);
	
	        case Freebet.SUCCESS_GET_FREEBET:
	        case _actions.GET_FREEBET.SUCCESS:
	            return setFreebet(freebet, action.data);
	    }
	
	    return freebet;
	}
	
	function setFreebet(freebet, data) {
	    if (data && !data.Error && data.IsPresent) {
	        freebet = new _immutable.Map().set('amount', data.Amount);
	        freebet = freebet.set('maxFactorValue', data.MaxFactorValue);
	        freebet = freebet.set('startDate', _momentTimezone2.default.tz(data.StartDate, 'Asia/Bishkek'));
	        freebet = freebet.set('promocodeText', data.PromocodeText);
	        return freebet.set('expireDate', _momentTimezone2.default.tz(data.ExpireDate, 'Asia/Bishkek'));
	    }
	
	    return freebet;
	}

/***/ },
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = isFreebetReducer;
	
	var _actions = __webpack_require__(30);
	
	var _CouponRate = __webpack_require__(130);
	
	var CouponRateActions = _interopRequireWildcard(_CouponRate);
	
	var _Freebet = __webpack_require__(559);
	
	var FreebetActions = _interopRequireWildcard(_Freebet);
	
	var Freebet = _interopRequireWildcard(_Freebet);
	
	var _HistoryBet = __webpack_require__(302);
	
	var HistoryBetActions = _interopRequireWildcard(_HistoryBet);
	
	var _BetType = __webpack_require__(46);
	
	var BetTypes = _interopRequireWildcard(_BetType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function isFreebetReducer(isFreebet, freebet, betSlips, betTypes, currentBetTypeIndex, action) {
	    switch (action.type) {
	        case FreebetActions.TOGGLE_FREEBET:
	            return isFreebet.update('isFreebet', function () {
	                return action.data;
	            });
	
	        case CouponRateActions.REMOVE_COUPON_RATES:
	            isFreebet = isFreebet.update('freebetAvailable', function () {
	                return false;
	            });
	            return isFreebet.update('isFreebet', function () {
	                return false;
	            });
	
	        case CouponRateActions.SET_COUPON_BET_TYPE:
	        case CouponRateActions.REMOVE_COUPON_RATE:
	        case CouponRateActions.ADD_COUPON_RATE:
	        case HistoryBetActions.SUCCESS_REQUEST_BET_TYPES:
	        case _actions.GET_FREEBET.SUCCESS:
	        case Freebet.SUCCESS_GET_FREEBET:
	            return calculateIsFreebetAvailable(isFreebet, freebet, betSlips, betTypes, currentBetTypeIndex);
	    }
	
	    return isFreebet;
	}
	
	function calculateIsFreebetAvailable(isFreebet, freebet, betSlips, betTypes, currentBetTypeIndex) {
	    if (!freebet || freebet.size === 0) {
	        isFreebet = isFreebet.set('freebetAvailable', false);
	        isFreebet = isFreebet.set('isFreebet', false);
	
	        return isFreebet;
	    }
	
	    var maxFactorValue = freebet.get('maxFactorValue');
	
	    var currentBetType = betTypes.get(currentBetTypeIndex);
	    var odd = currentBetType ? currentBetType.odd : 0;
	
	    var freebetAvailable = freebet && currentBetType && (!maxFactorValue || maxFactorValue >= odd) && (betSlips.size === 1 && currentBetType.type === BetTypes.SINGLE || betSlips.size > 1 && currentBetType.type !== BetTypes.SINGLE && currentBetType.type !== BetTypes.SYSTEM);
	
	    isFreebet = isFreebet.set('freebetAvailable', freebetAvailable);
	    if (!freebetAvailable) {
	        isFreebet = isFreebet.set('isFreebet', false);
	    }
	
	    return isFreebet;
	}

/***/ },
/* 1388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = stateReducer;
	
	var _HistoryBet = __webpack_require__(302);
	
	var HistoryBetActions = _interopRequireWildcard(_HistoryBet);
	
	var _Storage = __webpack_require__(69);
	
	var StorageActions = _interopRequireWildcard(_Storage);
	
	var _CouponState = __webpack_require__(750);
	
	var CouponState = _interopRequireWildcard(_CouponState);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function stateReducer(state, action) {
	    switch (action.type) {
	        case StorageActions.LOAD_STORAGE:
	            var couponState = action.data.couponState;
	            if (couponState !== undefined && couponState !== null) {
	                return couponState;
	            }
	            break;
	
	        case HistoryBetActions.REQUEST_BET_TYPES:
	            return CouponState.DISABLED;
	
	        case HistoryBetActions.SUCCESS_REQUEST_BET_TYPES:
	            return CouponState.ENABLED;
	
	        case HistoryBetActions.FAILURE_REQUEST_BET_TYPES:
	            return CouponState.ENABLED;
	    }
	
	    return state;
	}

/***/ },
/* 1389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = displayModeReducer;
	
	var _SetDisplayMode = __webpack_require__(707);
	
	var SetDisplayModeActions = _interopRequireWildcard(_SetDisplayMode);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function displayModeReducer(displayMode, action) {
	    switch (action.type) {
	        case SetDisplayModeActions.SET_DISPLAY_MODE:
	            return action.data;
	    }
	
	    return displayMode;
	}

/***/ },
/* 1390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = gamesReducer;
	
	var _cookieUtils = __webpack_require__(96);
	
	var _index = __webpack_require__(741);
	
	var GamesActions = _interopRequireWildcard(_index);
	
	var _SignoutAction = __webpack_require__(118);
	
	var AuthAction = _interopRequireWildcard(_SignoutAction);
	
	var _Language = __webpack_require__(47);
	
	var _domainUtils = __webpack_require__(27);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  vivo: {},
	  tvbet: {
	    error: null,
	    loading: false
	  },
	  virtual: {},
	  xpressGames: {
	    games: [],
	    count: 0,
	    loading: false
	  },
	  xpressGamesUrlError: {
	    Code: null,
	    Data: null,
	    Loading: false
	  },
	  xpressGamesFilter: {
	    providers: null,
	    types: null
	  },
	  pinnedXpressGames: {
	    pinnedGames: [],
	    count: 0,
	    loading: false
	  }
	};
	
	var TVBET_CLIENT_ID = _domainUtils.isStage ? 5631 : 5742;
	
	var TVBET_DEMO_CLIENT_ID = 5730;
	var TVBET_ROULLETTE_DEMO_ID = 6299;
	
	function gamesReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  try {
	    var lang = (0, _Language.getLanguageType)(Number((0, _cookieUtils.getCookie)('languageId'))).name;
	    switch (action.type) {
	      case GamesActions.SUCCESS_FETCH_VIVO_GAMES_TOKEN:
	        return (0, _extends3.default)({}, state, {
	          vivo: action.data
	        });
	      case GamesActions.FETCH_TVBET_GAMES_TOKEN:
	        return (0, _extends3.default)({}, state, {
	          tvbet: {
	            loading: true,
	            error: null
	          }
	        });
	      case GamesActions.FAILURE_FETCH_TVBET_GAMES_TOKEN:
	        return (0, _extends3.default)({}, state, {
	          tvbet: {
	            error: action.data,
	            loading: false
	          }
	        });
	      case GamesActions.SUCCESS_FETCH_TVBET_GAMES_TOKEN:
	        if (action.data.token) {
	          window.location.assign('https://tvbetframe10.com/?lng=' + lang + '&clientId=' + TVBET_CLIENT_ID + '&token=' + action.data.token + '#/lobby');
	          return (0, _extends3.default)({}, state, {
	            tvbet: {
	              loading: false,
	              error: null
	            }
	          });
	        } else {
	          return (0, _extends3.default)({}, state, {
	            tvbet: {
	              error: action.data,
	              loading: false
	            }
	          });
	        }
	      case GamesActions.FETCH_TVBET_DEMO_GAMES:
	        window.location.assign('https://tvbetframe10.com/?lng=' + lang + '&clientId=' + TVBET_DEMO_CLIENT_ID + '&token=TvBet-DemoSite-User-BET#/lobby');
	        return state;
	      case GamesActions.FETCH_TVBET_ROULLETTE_DEMO:
	        window.location.assign('https://frame.elcasinoplay.com/?lng=' + lang + '&category=ElCasino&clientId=' + TVBET_ROULLETTE_DEMO_ID + '&token=EC-DemoSite-User-BET#/el-casino/22');
	        return state;
	      case GamesActions.FETCH_FASTSPORT_GAMES_TOKEN:
	        {
	          return (0, _extends3.default)({}, state, {
	            tvbet: {
	              loading: true,
	              error: null
	            }
	          });
	        }
	      case GamesActions.FAILURE_FETCH_FASTSPORT_GAMES_TOKEN:
	        {
	          return (0, _extends3.default)({}, state, {
	            tvbet: {
	              error: action.data,
	              loading: false
	            }
	          });
	        }
	      case GamesActions.SUCCESS_FETCH_FASTSPORT_GAMES_TOKEN:
	        if (action.data.token) {
	          var clientId = _domainUtils.isRingo ? _domainUtils.isStage ? 8057 : 8048 : TVBET_CLIENT_ID;
	          window.location.assign('https://frame.fastsport.bet/?lng=' + lang + '&clientId=' + clientId + '&token=' + action.data.token);
	          return (0, _extends3.default)({}, state, {
	            tvbet: {
	              loading: false,
	              error: null
	            }
	          });
	        } else {
	          return (0, _extends3.default)({}, state, {
	            tvbet: {
	              error: action.data,
	              loading: false
	            }
	          });
	        }
	      case GamesActions.SUCCESS_FETCH_TVBET_ROULLETTE_TOKEN:
	        if (action.data.token) {
	          window.location.assign('https://tvbetframe10.com/?lng=' + lang + '&clientId=5742&token=' + action.data.token + '#/live-casino/22');
	        } else {
	          return (0, _extends3.default)({}, state, {
	            tvbet: {
	              error: action.data
	            }
	          });
	        }
	        return state;
	      case GamesActions.SUCCESS_FETCH_VIRTUAL_SPORTS_GAMES_TOKEN:
	        return (0, _extends3.default)({}, state, {
	          virtual: action.data
	        });
	
	      case GamesActions.FETCH_XPRESS_GAMES:
	        return (0, _extends3.default)({}, state, {
	          xpressGames: (0, _extends3.default)({}, state.xpressGames, {
	            loading: true
	          })
	        });
	
	      case GamesActions.SUCCESS_FETCH_XPRESS_GAMES:
	        if (action.data.Code === 0) {
	          return (0, _extends3.default)({}, state, {
	            xpressGames: {
	              games: action.data.Data.Games,
	              count: action.data.Data.Count,
	              loading: false
	            }
	          });
	        } else if (action.data.Code !== 0) {
	          return (0, _extends3.default)({}, state, {
	            xpressGamesUrlError: {
	              Code: action.data.Code,
	              Data: action.data.Data,
	              Loading: false
	            }
	          });
	        }
	        return state;
	
	      case GamesActions.FETCH_XPRESS_TOKEN:
	        return (0, _extends3.default)({}, state, {
	          xpressGamesUrlError: {
	            Code: null,
	            Data: null,
	            Loading: true
	          }
	        });
	
	      case GamesActions.SUCCESS_FETCH_XPRESS_TOKEN:
	        if (action.data.Code === 0) {
	          window.location.assign(action.data.Data.GameUrl);
	        } else {
	          return (0, _extends3.default)({}, state, {
	            xpressGamesUrlError: {
	              Code: action.data.Code,
	              Data: action.data.Data,
	              Loading: false
	            }
	          });
	        }
	        return state;
	
	      case GamesActions.FAILURE_FETCH_XPRESS_TOKEN:
	        return (0, _extends3.default)({}, state, {
	          xpressGamesUrlError: {
	            Code: action.data.Code,
	            Data: action.data.Data,
	            Loading: false
	          }
	        });
	
	      case AuthAction.SUCCESS_SIGNOUT:
	        {
	          var xpressGamesFilter = state.xpressGamesFilter;
	
	          return (0, _extends3.default)({}, initialState, { xpressGamesFilter: xpressGamesFilter });
	        }
	
	      case AuthAction.CLEAR_TV_BET_ERROR:
	        return (0, _extends3.default)({}, state, {
	          tvbet: {
	            error: null
	          }
	        });
	      case GamesActions.FETCH_PROVIDER_XPRESS_GAMES:
	        return state;
	      case GamesActions.SUCCESS_FETCH_PROVIDER_XPRESS_GAMES:
	        return (0, _extends3.default)({}, state, {
	          xpressGamesFilter: (0, _extends3.default)({}, state.xpressGamesFilter, {
	            providers: action.data.Data
	          })
	        });
	      case GamesActions.FAILURE_FETCH_PROVIDER_XPRESS_GAMES:
	        return state;
	
	      case GamesActions.FETCH_TYPE_XPRESS_GAMES:
	        return state;
	      case GamesActions.SUCCESS_FETCH_TYPE_XPRESS_GAMES:
	        return (0, _extends3.default)({}, state, {
	          xpressGamesFilter: (0, _extends3.default)({}, state.xpressGamesFilter, {
	            types: action.data.Data
	          })
	        });
	      case GamesActions.FAILURE_FETCH_TYPE_XPRESS_GAMES:
	        return state;
	
	      case GamesActions.FETCH_PINNED_XPRESS_GAMES:
	        return (0, _extends3.default)({}, state, {
	          pinnedXpressGames: (0, _extends3.default)({}, state.pinnedXpressGames, {
	            pinnedLoading: true
	          })
	        });
	
	      case GamesActions.SUCCESS_FETCH_PINNED_XPRESS_GAMES:
	        if (action.data.Code === 0) {
	          return (0, _extends3.default)({}, state, {
	            pinnedXpressGames: {
	              pinnedGames: action.data.Data.Games,
	              count: action.data.Data.Count,
	              pinnedLoading: false
	            }
	          });
	        } else if (action.data.Code !== 0) {
	          return (0, _extends3.default)({}, state, {
	            pinnedXpressGames: {
	              Code: action.data.Code
	            }
	          });
	        }
	        return state;
	      case GamesActions.UPDATE_XPRESS_PINNED_GAMES:
	        {
	          var _action$data = action.data,
	              gameId = _action$data.gameId,
	              isPinned = _action$data.isPinned;
	
	          var updatedGames = state.xpressGames.games.map(function (game) {
	            if (game.Id === gameId) {
	              return (0, _extends3.default)({}, game, {
	                IsPinned: !isPinned
	              });
	            } else {
	              return game;
	            }
	          });
	          var updatedPinnedGames = state.pinnedXpressGames.pinnedGames.filter(function (game) {
	            return game.Id !== gameId && isPinned;
	          });
	          return (0, _extends3.default)({}, state, {
	            xpressGames: (0, _extends3.default)({}, state.xpressGames, {
	              games: updatedGames
	            }),
	            pinnedXpressGames: (0, _extends3.default)({}, state.pinnedXpressGames, {
	              pinnedGames: updatedPinnedGames
	            })
	          });
	        }
	    }
	    return state;
	  } catch (error) {
	    // eslint-disable-next-line no-console
	    console.error('gamesReducer', error);
	    return state;
	  }
	}

/***/ },
/* 1391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = jacktopGamesReducer;
	
	var _jacktopGames = __webpack_require__(742);
	
	var _Language = __webpack_require__(47);
	
	var _jacktop_constants = __webpack_require__(772);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  fetching: false,
	  token: null,
	  error: null
	};
	
	function jacktopGamesReducer(state, action) {
	  if (state === undefined) {
	    return initialState;
	  }
	
	  switch (action.type) {
	    case _jacktopGames.GET_JACKTOP_TOKEN:
	      return (0, _extends3.default)({}, state, {
	        fetching: true,
	        error: null
	      });
	    case _jacktopGames.SUCCESS_GET_JACKTOP_TOKEN:
	      {
	        state.token = action.data.token;
	
	        var langCode = (0, _Language.getLanguageType)(action.languageId).name;
	
	        var params = {
	          lng: langCode,
	          clientId: _jacktop_constants.jacktopConstants.client_id,
	          tokenAuth: action.data.token,
	          game_id: action.gameId
	        };
	        var url = _jacktop_constants.jacktopConstants.server + new URLSearchParams(params);
	        window.location.assign(url);
	        return (0, _extends3.default)({}, state, {
	          error: null
	        });
	      }
	    case _jacktopGames.FAILURE_GET_JACKTOP_TOKEN:
	      return (0, _extends3.default)({}, state, {
	        token: null,
	        fetching: false,
	        error: action.data
	      });
	  }
	
	  return state;
	}

/***/ },
/* 1392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = join;
	
	var _immutable = __webpack_require__(14);
	
	var _Join = __webpack_require__(710);
	
	var Join = _interopRequireWildcard(_Join);
	
	var _FastJoin = __webpack_require__(157);
	
	var FastJoin = _interopRequireWildcard(_FastJoin);
	
	var _PhoneConfirmation = __webpack_require__(156);
	
	var PhoneConfirm = _interopRequireWildcard(_PhoneConfirmation);
	
	var _Auth = __webpack_require__(301);
	
	var AuthActions = _interopRequireWildcard(_Auth);
	
	var _JoinStage = __webpack_require__(569);
	
	var JoinStage = _interopRequireWildcard(_JoinStage);
	
	var _JoinType = __webpack_require__(751);
	
	var JoinType = _interopRequireWildcard(_JoinType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = (0, _immutable.Map)({
	    type: JoinType.FAST,
	    stage: JoinStage.NONE,
	    inProcess: false,
	    error: null,
	    userRegistration: undefined,
	    fastJoin: undefined
	});
	
	function join() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case PhoneConfirm.CREATE_PHONE_CONFIRMATION:
	        case PhoneConfirm.FAILURE_CREATE_PHONE_CONFIRMATION:
	        case PhoneConfirm.CONFIRM_PHONE:
	        case PhoneConfirm.SUCCESS_CONFIRM_PHONE:
	        case PhoneConfirm.FAILURE_CONFIRM_PHONE:
	            state = state.set('stage', JoinStage.PHONE_CONFIRMATION);
	            break;
	
	        case PhoneConfirm.SUCCESS_CREATE_PHONE_CONFIRMATION:
	            state = state.set('stage', JoinStage.PHONE_CONFIRMATION);
	            if (action.data.Phone) {
	                state = state.setIn(['userRegistration', 'phone'], action.data.Phone);
	            }
	            break;
	
	        case PhoneConfirm.DENY_CONFIRMATION:
	            state = state.set('stage', JoinStage.SUCCESS);
	            break;
	
	        case '@@router/LOCATION_CHANGE':
	            if (action.payload.pathname === '/' && action.payload.hash === '#join') {
	                state = state.set('stage', JoinStage.INIT);
	            } /*  else {
	                 state = state.set('stage', JoinStage.NONE);
	              } */
	            break;
	
	        case AuthActions.BEGIN_SIGNIN:
	            state = state.set('stage', JoinStage.NONE);
	            break;
	
	        case AuthActions.BEGIN_JOIN:
	            state = state.set('type', JoinType.FAST);
	            state = state.set('stage', JoinStage.INIT);
	            break;
	
	        case Join.CHANGE_JOIN_TYPE:
	            {
	                var newJoinType = action.data.joinType;
	
	                state = state.set('type', newJoinType);
	                state = state.set('stage', JoinStage.INIT);
	                state = state.set('error', null);
	                if (newJoinType === JoinType.FAST) {
	                    state = state.set('userRegistration', undefined);
	                } else if (newJoinType === JoinType.REGULAR) {
	                    state = state.set('fastJoin', undefined);
	                }
	                break;
	            }
	
	        case Join.JOIN:
	            state = state.set('error', null);
	            state = state.set('inProcess', true);
	            break;
	
	        case Join.SUCCESS_JOIN:
	            state = state.set('inProcess', false);
	            if (action.data.Error) {
	                state = state.set('error', action.data.Error);
	                state = action.data.PromocodeError ? state.set('PromocodeError', action.data.PromocodeError) : state.set('PromocodeError', null);
	            } else {
	                var phoneConfirmationNeeded = action.data.PhoneConfirmation;
	
	                var userRegistration = (0, _immutable.Map)({
	                    phone: action.data.Phone,
	                    phoneConfirmationNeeded: phoneConfirmationNeeded,
	                    gamblerId: action.data.UserId,
	                    email: action.data.Email,
	                    joinPromoType: action.data.JoinPromoType
	                });
	
	                state = state.set('error', null);
	                state = state.set('userRegistration', userRegistration);
	
	                if (phoneConfirmationNeeded === true) {
	                    state = state.set('stage', JoinStage.PHONE_CONFIRMATION);
	                } else {
	                    state = state.set('stage', JoinStage.SUCCESS);
	                }
	            }
	            break;
	
	        case FastJoin.FAST_JOIN:
	            state = state.set('fastJoin', (0, _immutable.Map)(action.data));
	            state = state.set('error', null);
	            state = state.set('inProcess', true);
	            break;
	
	        case FastJoin.SUCCESS_FAST_JOIN:
	            state = state.set('inProcess', false);
	            if (action.data.Error) {
	                state = state.set('error', action.data.Error);
	                state = action.data.PromocodeError ? state.set('PromocodeError', action.data.PromocodeError) : state.set('PromocodeError', null);
	            } else if (action.data.RequestId !== undefined && action.data.RequestId !== null) {
	                var requestId = action.data.RequestId;
	
	                state = state.set('error', null);
	                state = state.setIn(['fastJoin', 'RequestId'], requestId);
	                state = state.set('stage', JoinStage.PHONE_CONFIRMATION);
	            } else if (action.data.Email) {
	                state = state.set('error', null);
	                state = state.setIn(['fastJoin', 'Email'], action.data.Email);
	                state = state.set('stage', JoinStage.EMAIL_SENT);
	            }
	            break;
	
	        case FastJoin.FAILURE_FAST_JOIN:
	            state = state.set('inProcess', false);
	            state = state.set('error', -100);
	            break;
	
	        case FastJoin.FAST_CONFIRM_PHONE:
	            state = state.set('inProcess', true);
	            state = state.set('error', null);
	            break;
	
	        case FastJoin.SUCCESS_FAST_CONFIRM_PHONE:
	            state = state.set('inProcess', false);
	            if (action.data.hasOwnProperty('Error')) {
	                state = state.set('error', action.data.Error);
	            } else {
	                state = state.set('error', null);
	                state = state.set('fastJoin', undefined);
	                state = state.set('stage', JoinStage.SUCCESS);
	            }
	            break;
	
	        case FastJoin.FAILURE_FAST_CONFIRM_PHONE:
	            state = state.set('inProcess', false);
	            state = state.set('error', -100);
	            break;
	
	        case AuthActions.CANCEL_JOIN:
	            state = state.set('stage', JoinStage.NONE);
	            state = state.set('error', null);
	            state = state.set('inProcess', false);
	            state = state.set('userRegistration', undefined);
	            state = state.set('fastJoin', undefined);
	            break;
	    }
	
	    return state;
	}

/***/ },
/* 1393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = localeReducer;
	
	var _changeLanguage = __webpack_require__(71);
	
	var ChangeLanguageActions = _interopRequireWildcard(_changeLanguage);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function localeReducer(languageId, action) {
	    switch (action.type) {
	        case ChangeLanguageActions.CHANGE_LANGUAGE:
	            if (window.SIR) {
	                window.SIR('changeLanguage', action.languageId === 1 ? 'ru' : 'en');
	            }
	            localStorage.setItem('languageId', action.languageId);
	            return action.languageId;
	    }
	
	    return languageId;
	}

/***/ },
/* 1394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = leaguesReducer;
	
	var _immutable = __webpack_require__(14);
	
	var _PreMatchMenu = __webpack_require__(560);
	
	var PreMatchMenuActions = _interopRequireWildcard(_PreMatchMenu);
	
	var _Line = __webpack_require__(38);
	
	var LineActions = _interopRequireWildcard(_Line);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function leaguesReducer(leagues, action) {
	    switch (action.type) {
	        case PreMatchMenuActions.SUCCESS_INIT_PREMATCH_MENU:
	            return initMenu(leagues, action.data);
	
	        case LineActions.CLEAR_LINE:
	            return new _immutable.Map();
	    }
	
	    return leagues;
	}
	
	function initMenu(leagues, data) {
	    if (data === undefined) {
	        return leagues;
	    }
	
	    leagues = new _immutable.Map();
	
	    if (data.leagues !== undefined) {
	        leagues = addMenuLeagues(leagues, data.leagues.add);
	    }
	
	    return leagues;
	}
	
	function addMenuLeagues(leagues, addLeagues) {
	    if (addLeagues === undefined) {
	        return leagues;
	    }
	
	    return leagues.withMutations(function (l) {
	        for (var i = 0; i < addLeagues.length; i++) {
	            var league = new _immutable.Map(addLeagues[i]);
	
	            l.set(league.get('id'), league);
	        }
	    });
	}

/***/ },
/* 1395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = menuReducer;
	
	var _sportsReducer = __webpack_require__(1396);
	
	var _sportsReducer2 = _interopRequireDefault(_sportsReducer);
	
	var _leaguesReducer = __webpack_require__(1394);
	
	var _leaguesReducer2 = _interopRequireDefault(_leaguesReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function menuReducer(menu, action) {
	    if (menu === undefined) {
	        return menu;
	    }
	
	    menu = menu.update('sports', function (s) {
	        return (0, _sportsReducer2.default)(s, action);
	    });
	    menu = menu.update('leagues', function (l) {
	        return (0, _leaguesReducer2.default)(l, action);
	    });
	
	    return menu;
	}

/***/ },
/* 1396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = sportsReducer;
	
	var _immutable = __webpack_require__(14);
	
	var _PreMatchMenu = __webpack_require__(560);
	
	var PreMatchMenuActions = _interopRequireWildcard(_PreMatchMenu);
	
	var _Line = __webpack_require__(38);
	
	var LineActions = _interopRequireWildcard(_Line);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function sportsReducer(sports, action) {
	    switch (action.type) {
	        case PreMatchMenuActions.SUCCESS_INIT_PREMATCH_MENU:
	            return initMenu(new _immutable.Map(), action.data);
	
	        case LineActions.CLEAR_LINE:
	            return new _immutable.Map();
	    }
	
	    return sports;
	}
	
	function initMenu(sports, data) {
	    if (data === undefined) {
	        return sports;
	    }
	
	    if (data.sports !== undefined) {
	        sports = addMenuSports(sports, data.sports.add);
	    }
	    if (data.leagues !== undefined) {
	        sports = addSportLeagues(sports, data.leagues.add);
	    }
	
	    return sports;
	}
	
	function addMenuSports(sports, addSports) {
	    if (addSports === undefined) {
	        return sports;
	    }
	
	    sports = sports.withMutations(function (s) {
	        for (var i = 0; i < addSports.length; i++) {
	            var sport = new _immutable.Map(addSports[i]);
	            sport = sport.set('leagues', new _immutable.List());
	
	            s.set(sport.get('id'), sport);
	        }
	    });
	
	    return sports;
	}
	
	function addSportLeagues(sports, addLeagues) {
	    if (addLeagues === undefined) {
	        return sports;
	    }
	
	    for (var i = 0; i < addLeagues.length; i++) {
	        var sportId = addLeagues[i].sportId;
	        var leagueId = addLeagues[i].id;
	
	        (function (sportId, leagueId) {
	            sports = sports.updateIn([sportId, 'leagues'], function (l) {
	                return l.push(leagueId);
	            });
	        })(sportId, leagueId);
	    }
	
	    return sports;
	}

/***/ },
/* 1397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = messagesReducer;
	
	var _Messages = __webpack_require__(950);
	
	var MessageActions = _interopRequireWildcard(_Messages);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function messagesReducer(messages, action) {
	    switch (action.type) {
	        case MessageActions.SUCCESS_GET_NEW_MESSAGES_COUNT:
	            messages = messages.set('newMessagesCount', action.data.Result);
	    }
	
	    return messages;
	}

/***/ },
/* 1398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = newsReducer;
	
	var _underscore = __webpack_require__(145);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _momentTimezone = __webpack_require__(76);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _News = __webpack_require__(706);
	
	var NewsActions = _interopRequireWildcard(_News);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function newsReducer(news, action) {
	    switch (action.type) {
	        case NewsActions.SUCCESS_GET_NEWS:
	            return _underscore2.default.map(action.data.news, function (n) {
	                return {
	                    id: n.id,
	                    title: n.title,
	                    link: n.link,
	                    content: n.content,
	                    date: _momentTimezone2.default.tz(n.date, 'Asia/Bishkek').clone().tz('UTC')
	                };
	            });
	    }
	
	    return news;
	}

/***/ },
/* 1399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (state, action) {
	    if (state === undefined) {
	        return initialState;
	    }
	
	    switch (action.type) {
	        case PasswordRecoveryActions.BEGIN_PASSWORD_RECOVERY:
	            state = state.set('state', PasswordRecoveryStates.INIT);
	            state = state.set('isOngoing', true);
	            break;
	
	        case PasswordRecoveryActions.CANCEL_PASSWORD_RECOVERY:
	            state = initialState;
	            break;
	
	        case PasswordRecoveryActions.RECOVER_PASSWORD:
	            state = state.set('state', PasswordRecoveryStates.REQUEST);
	            break;
	
	        case PasswordRecoveryActions.SUCCESS_RECOVER_PASSWORD:
	            state = state.set('state', action.data.Error ? PasswordRecoveryStates.INIT : PasswordRecoveryStates.FINISH);
	            state = state.set('email', action.data.Email);
	            state = state.set('phone', action.data.Phone);
	            state = state.set('errorCode', action.data.Error);
	            break;
	
	        case PasswordRecoveryActions.FAILURE_RECOVER_PASSWORD:
	            state = state.set('state', PasswordRecoveryStates.FINISH);
	            state = state.set('errorCode', 500);
	            break;
	
	        case PasswordRecoveryActions.SUCCESS_PHONE_RECOVER_PASSWORD:
	            if (action.data.Error) {
	                state = state.set('createPasswordErrorCode', action.data.Error);
	            } else if (action.data.ResulState && action.data.ResulState !== 0) {
	                state = state.set('createPasswordErrorCode', action.data.ResultState);
	            } else if (action.data.ResultState === 0) {
	                state = state.set('createPasswordState', 0);
	                state = state.set('createPasswordErrorCode', undefined);
	            }
	            break;
	
	        case PasswordRecoveryActions.FAILURE_PHONE_RECOVER_PASSWORD:
	            state = state.set('createPasswordErrorCode', action.data.Error);
	            break;
	    }
	
	    return state;
	};
	
	var _immutable = __webpack_require__(14);
	
	var _PasswordRecovery = __webpack_require__(303);
	
	var PasswordRecoveryActions = _interopRequireWildcard(_PasswordRecovery);
	
	var _PasswordRecoveryState = __webpack_require__(335);
	
	var PasswordRecoveryStates = _interopRequireWildcard(_PasswordRecoveryState);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = (0, _immutable.Map)({
	    isOngoing: false,
	    state: undefined,
	    email: undefined,
	    phone: undefined,
	    errorCode: undefined,
	    createPasswordErrorCode: undefined,
	    createPasswordState: undefined
	});

/***/ },
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Stream = __webpack_require__(708);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    openStream: false,
	    matchId: undefined,
	    src: undefined
	};
	
	var streamReducer = function streamReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case _Stream.LOAD_STREAM:
	            return (0, _extends3.default)({}, state, {
	                openStream: true,
	                matchId: action.data.matchId,
	                src: action.data.src
	            });
	        case _Stream.STOP_STREAM:
	            return (0, _extends3.default)({}, state, {
	                src: undefined,
	                matchId: undefined,
	                openStream: false
	            });
	        default:
	            return state;
	    }
	};
	
	exports.default = streamReducer;

/***/ },
/* 1401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var section = void 0,
	        items = void 0,
	        data = void 0,
	        showMatches = void 0,
	        sportId = void 0,
	        leagueId = void 0,
	        lastShownExists = void 0;
	
	    switch (action.type) {
	        case StorageActions.LOAD_STORAGE:
	            {
	                var userGridSelection = action.data.userGridSelection;
	                if (userGridSelection) {
	                    state = state.mergeDeep(userGridSelection);
	                }
	                break;
	            }
	
	        case userSelectionActions.USER_SELECTION_SHOW_ALL:
	            section = action.section;
	
	            if (state.hasIn([section, 'lastShown'])) {
	                state = state.setIn([section, 'lastShown'], null);
	            }
	
	            return state;
	
	        case userSelectionActions.USER_SELECTION_TOGGLE_SPORT:
	            section = action.section;
	            data = action.data;
	            showMatches = data.showMatches;
	            sportId = Number(data.id);
	
	            items = state.getIn([section, 'sportsExpanded']);
	            lastShownExists = state.hasIn([section, 'lastShown']);
	
	            if (showMatches && lastShownExists) {
	                state = state.setIn([section, 'lastShown'], (0, _immutable.Map)({ sportId: sportId }));
	            }
	
	            if (!showMatches || showMatches && !items.includes(sportId)) {
	                items = toggleListItem(items, data);
	                state = state.setIn([section, 'sportsExpanded'], items);
	            }
	
	            return state;
	
	        case userSelectionActions.USER_SELECTION_TOGGLE_LEAGUE:
	            section = action.section;
	            data = action.data;
	            showMatches = data.showMatches;
	            sportId = Number(data.sportId);
	            leagueId = Number(data.id);
	
	            items = state.getIn([section, 'leaguesExpanded']);
	            lastShownExists = state.hasIn([section, 'lastShown']);
	
	            if (showMatches && lastShownExists) {
	                state = state.setIn([section, 'lastShown'], (0, _immutable.Map)({ sportId: sportId, leagueId: leagueId }));
	            }
	
	            if (!showMatches || showMatches && !items.includes(leagueId)) {
	                items = toggleListItem(items, data);
	                state = state.setIn([section, 'leaguesExpanded'], items);
	            }
	
	            return state;
	
	        case userSelectionActions.USER_SELECTION_TOGGLE_MATCH:
	            section = action.section;
	            data = action.data;
	
	            items = state.getIn([section, 'matchesExpanded']);
	            items = toggleListItem(items, data);
	            state = state.setIn([section, 'matchesExpanded'], items);
	
	            return state;
	    }
	
	    return state;
	};
	
	var _immutable = __webpack_require__(14);
	
	var _Storage = __webpack_require__(69);
	
	var StorageActions = _interopRequireWildcard(_Storage);
	
	var _UserSelection = __webpack_require__(709);
	
	var userSelectionActions = _interopRequireWildcard(_UserSelection);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = (0, _immutable.Map)({
	    main: (0, _immutable.Map)({
	        sportsExpanded: (0, _immutable.List)()
	    }),
	    preMatch: (0, _immutable.Map)({
	        sportsExpanded: (0, _immutable.List)(),
	        leaguesExpanded: (0, _immutable.List)(),
	        matchesExpanded: (0, _immutable.List)(),
	        lastShown: null
	    }),
	    live: (0, _immutable.Map)({
	        sportsExpanded: (0, _immutable.List)(),
	        leaguesExpanded: (0, _immutable.List)(),
	        matchesExpanded: (0, _immutable.List)(),
	        lastShown: null
	    })
	});
	
	function toggleListItem(list, item) {
	    var id = Number(item.id);
	
	    if (list.includes(id)) {
	        list = list.filter(function (i) {
	            return i != id;
	        });
	    } else {
	        list = list.push(id);
	    }
	
	    return list;
	}

/***/ },
/* 1402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (state) {
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    switch (action.type) {
	        case StorageActions.LOAD_STORAGE:
	            return true;
	    }
	
	    return state;
	};
	
	var _Storage = __webpack_require__(69);
	
	var StorageActions = _interopRequireWildcard(_Storage);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/***/ },
/* 1403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(64);
	
	var _reactRouterRedux = __webpack_require__(23);
	
	var _reduxForm = __webpack_require__(17);
	
	var _applicationReducer = __webpack_require__(1371);
	
	var _applicationReducer2 = _interopRequireDefault(_applicationReducer);
	
	var _auth = __webpack_require__(576);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _phoneConfirmReducer = __webpack_require__(592);
	
	var _phoneConfirmReducer2 = _interopRequireDefault(_phoneConfirmReducer);
	
	var _joinReducer = __webpack_require__(1392);
	
	var _joinReducer2 = _interopRequireDefault(_joinReducer);
	
	var _createPasswordReducer = __webpack_require__(578);
	
	var _createPasswordReducer2 = _interopRequireDefault(_createPasswordReducer);
	
	var _balance = __webpack_require__(577);
	
	var _balance2 = _interopRequireDefault(_balance);
	
	var _passwordRecoveryReducer = __webpack_require__(1399);
	
	var _passwordRecoveryReducer2 = _interopRequireDefault(_passwordRecoveryReducer);
	
	var _betGamesReducer = __webpack_require__(1372);
	
	var _betGamesReducer2 = _interopRequireDefault(_betGamesReducer);
	
	var _gamesReducer = __webpack_require__(1390);
	
	var _gamesReducer2 = _interopRequireDefault(_gamesReducer);
	
	var _domainReducer = __webpack_require__(501);
	
	var _domainReducer2 = _interopRequireDefault(_domainReducer);
	
	var _promoCodeReducer = __webpack_require__(593);
	
	var _promoCodeReducer2 = _interopRequireDefault(_promoCodeReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reducer = (0, _redux.combineReducers)({
	    routing: _reactRouterRedux.routerReducer,
	    form: _reduxForm.reducer,
	    application: _applicationReducer2.default,
	    auth: _auth2.default,
	    phoneConfirm: _phoneConfirmReducer2.default,
	    join: _joinReducer2.default,
	    createPassword: _createPasswordReducer2.default,
	    balance: _balance2.default,
	    passwordRecovery: _passwordRecoveryReducer2.default,
	    domain: _domainReducer2.default,
	    betGames: _betGamesReducer2.default,
	    games: _gamesReducer2.default,
	    promoCode: _promoCodeReducer2.default
	});
	
	exports.default = reducer;

/***/ },
/* 1404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(82);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = rootSaga;
	
	var _effects = __webpack_require__(929);
	
	var _sagas = __webpack_require__(1160);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(rootSaga);
	
	function rootSaga() {
	    return _regenerator2.default.wrap(function rootSaga$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return [(0, _effects.call)(_sagas.loadInitialLive), (0, _effects.call)(_sagas.loadLiveUpdate), (0, _effects.call)(_sagas.loadInitialTimetable), (0, _effects.call)(_sagas.loadTimetableUpdate), (0, _effects.call)(_sagas.loadBalance), (0, _effects.call)(_sagas.loadFreebet), (0, _effects.call)(_sagas.loadBetsStatus), (0, _effects.call)(_sagas.loadStakesStatus), (0, _effects.call)(_sagas.loadCashoutsStatus)];
	
	                case 2:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked, this);
	}

/***/ },
/* 1405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(25);
	
	var _reactRouterRedux = __webpack_require__(23);
	
	var _components = __webpack_require__(1312);
	
	var _gridControl = __webpack_require__(778);
	
	var _gridControl2 = _interopRequireDefault(_gridControl);
	
	var _Timetable = __webpack_require__(1187);
	
	var _JacktopGames = __webpack_require__(1208);
	
	var _JacktopGames2 = _interopRequireDefault(_JacktopGames);
	
	var _domainUtils = __webpack_require__(27);
	
	var _GamesTypesPage = __webpack_require__(1344);
	
	var _GamesTypesPage2 = _interopRequireDefault(_GamesTypesPage);
	
	var _FavoriteGames = __webpack_require__(1341);
	
	var _FavoriteGames2 = _interopRequireDefault(_FavoriteGames);
	
	var _RecentGamesPage = __webpack_require__(1349);
	
	var _RecentGamesPage2 = _interopRequireDefault(_RecentGamesPage);
	
	var _AllGames = __webpack_require__(1337);
	
	var _AllGames2 = _interopRequireDefault(_AllGames);
	
	var _PopularGames = __webpack_require__(1348);
	
	var _PopularGames2 = _interopRequireDefault(_PopularGames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RingoBlocker = function RingoBlocker() {
	  return _react2.default.createElement(
	    'h1',
	    { style: { fontSize: 24, padding: 20, maxWidth: 900, margin: '0 auto' } },
	    '\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F, \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u0441\u0447\u0435\u0442\u043E\u0432 \u0438 \u043F\u0440\u0438\u0435\u043C \u0441\u0442\u0430\u0432\u043E\u043A \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0432 \u0441\u0432\u044F\u0437\u0438 \u0441 \u043F\u0440\u0435\u043A\u0440\u0430\u0449\u0435\u043D\u0438\u0435\u043C \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043B\u0438\u0446\u0435\u043D\u0437\u0438\u0438 \u211634 \u043D\u0430 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u0435\u043D\u0438\u0435 \u0434\u0435\u044F\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u0431\u0443\u043A\u043C\u0435\u043A\u0435\u0440\u0441\u043A\u043E\u0439 \u043A\u043E\u043D\u0442\u043E\u0440\u044B, \u0432\u044B\u0434\u0430\u043D\u043D\u043E\u0439 \u0422\u041E\u041E "Takebet", \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u043F\u0440\u0438\u043A\u0430\u0437\u0443 \u211619 \u043E\u0442 23.04.2024 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0433\u043E \u0443\u0447\u0440\u0435\u0436\u0434\u0435\u043D\u0438\u044F "\u041A\u043E\u043C\u0438\u0442\u0435\u0442 \u0438\u043D\u0434\u0443\u0441\u0442\u0440\u0438\u0438 \u0442\u0443\u0440\u0438\u0437\u043C\u0430 \u041C\u0438\u043D\u0438\u0441\u0442\u0435\u0440\u0441\u0442\u0432\u0430 \u0442\u0443\u0440\u0438\u0437\u043C\u0430 \u0438 \u0441\u043F\u043E\u0440\u0442\u0430 \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0438 \u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D".'
	  );
	};
	// import PinnedXpressGames from './components/games/xpress/PinnedXpressGames.jsx'
	
	
	// import IndexSlots from './components/games/slots/index'
	// import Betsoft from './components/games/slots/betsoft/index'
	// import BetsoftIframe from './components/games/slots/betsoft/Iframe'
	// import Betsolutions from './components/games/slots/betsolutions/index'
	// import TomHorn from './components/games/slots/tomhorn/index'
	// import TomHornIframe from './components/games/slots/tomhorn/Iframe'
	// import XpressGames from './components/games/xpress/XpressGames.jsx'
	
	
	var routes = function routes(store) {
	  var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);
	
	  if (_domainUtils.isRingo) {
	    return _react2.default.createElement(
	      _reactRouter.Router,
	      { history: history },
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: '/', component: _components.Application },
	        _react2.default.createElement(_reactRouter.IndexRoute, {
	          components: {
	            main: RingoBlocker,
	            footer: _components.Footer
	          }
	        }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: '*',
	          components: {
	            main: RingoBlocker,
	            footer: _components.Footer
	          }
	        })
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    _reactRouter.Router,
	    { history: history },
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: '/', component: _components.Application },
	      _react2.default.createElement(_reactRouter.IndexRoute, { components: { main: _components.MainPage, footer: _components.Footer } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'sign-in', components: { main: _components.SignInPage } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'sign-up', components: { main: _components.SignUpPage } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'identify', components: { main: _components.IdentifyPage } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'sports', components: { main: _components.SportsPage } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'sports/:sportId', components: { main: _components.SportsPage } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'sports/:sportId/:leagueId', components: { main: _components.SportsPage } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'sports/:sportId/:leagueId/:matchId', components: { main: _components.SportsPage } }),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: 'live', components: { main: _components.LivePage } },
	        _react2.default.createElement(_reactRouter.IndexRoute, { components: { center: _gridControl2.default } }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'timetable', components: { center: _Timetable.Timetable } })
	      ),
	      _react2.default.createElement(_reactRouter.Route, { exact: true, path: 'games', components: { main: _components.GamesNewPage, footer: _components.Footer } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'games/types/:categoryId', components: { main: _GamesTypesPage2.default, footer: _components.Footer } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'games/favorites', components: { main: _FavoriteGames2.default, footer: _components.Footer } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'games/recent', components: { main: _RecentGamesPage2.default, footer: _components.Footer } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'games/allGames', components: { main: _AllGames2.default, footer: _components.Footer } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'games/popularGames', components: { main: _PopularGames2.default, footer: _components.Footer } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'games/jacktop', components: { main: _JacktopGames2.default, footer: _components.Footer } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'games/:searchTerm', components: { main: _components.GamesNewPage, footer: _components.Footer } })
	    )
	  );
	};
	
	exports.default = routes;

/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(162);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _cookieUtils = __webpack_require__(96);
	
	var _domainUtils = __webpack_require__(27);
	
	var _HistoryBet = __webpack_require__(302);
	
	var HistoryBetActions = _interopRequireWildcard(_HistoryBet);
	
	var _CouponRate = __webpack_require__(130);
	
	var CouponRateActions = _interopRequireWildcard(_CouponRate);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return function (next) {
	        return function (reducer, initialState) {
	            var store = next(reducer, initialState);
	
	            return (0, _extends3.default)({}, store, {
	                dispatch: function dispatch(action) {
	                    store.dispatch(action);
	
	                    var state = store.getState();
	
	                    var languageId = state.application.get('languageId');
	                    var domain = state.domain;
	
	                    (0, _cookieUtils.setCookie)('languageId', languageId, (0, _domainUtils.getDomain)(domain));
	
	                    var user = state.auth.get('user');
	                    if (!user) {
	                        return action;
	                    }
	
	                    var gamblerId = user.get('gamblerId');
	
	                    var betHistory = state.application.get('betHistory');
	
	                    if (betHistory !== undefined && betHistory.size > 0) {
	                        var keys = betHistory.keySeq().toArray();
	
	                        var _loop = function _loop(i) {
	                            var noCashout = betHistory.get(keys[i]).delete('cashout');
	                            betHistory = betHistory.updateIn(keys[i], function () {
	                                return noCashout;
	                            });
	                        };
	
	                        for (var i = 0; i < keys.length; i++) {
	                            _loop(i);
	                        }
	                        localStorage.setItem(gamblerId + '_betHistory', (0, _stringify2.default)(betHistory.toJS()));
	                    }
	
	                    switch (action.type) {
	                        case HistoryBetActions.REMOVE_HISTORY_BET:
	                            if (betHistory.size === 0) {
	                                localStorage.removeItem(gamblerId + '_betHistory');
	                            }
	                            break;
	                        case HistoryBetActions.REMOVE_HISTORY_BETS:
	                            localStorage.removeItem(gamblerId + '_betHistory');
	                            break;
	                    }
	
	                    var bettingMode = state.application.get('bettingMode');
	                    if (bettingMode !== undefined && bettingMode.size > 0) {
	                        var withoutOneClick = bettingMode.delete('isOneClick');
	                        localStorage.setItem(gamblerId + '_bettingMode', (0, _stringify2.default)(withoutOneClick.toJS()));
	                    }
	
	                    var userGridStorable = state.application.get('userGridStorable');
	                    if (userGridStorable) {
	                        var userSelections = state.application.get('userGridSelection');
	                        if (userSelections !== undefined && userSelections.size > 0) {
	                            var mainNotEmpty = userSelections.getIn(['main', 'sportsExpanded']).size > 0;
	                            var preMatchNotEmpty = userSelections.getIn(['preMatch', 'sportsExpanded']).size > 0 || userSelections.getIn(['preMatch', 'leaguesExpanded']).size > 0 || userSelections.getIn(['preMatch', 'matchesExpanded']).size > 0;
	                            var liveNotEmpty = userSelections.getIn(['live', 'sportsExpanded']).size > 0 || userSelections.getIn(['live', 'leaguesExpanded']).size > 0 || userSelections.getIn(['live', 'matchesExpanded']).size > 0;
	
	                            if (mainNotEmpty || preMatchNotEmpty || liveNotEmpty) {
	                                localStorage.setItem(gamblerId + '_userSelections', (0, _stringify2.default)(userSelections.toJS()));
	                            }
	                        }
	                    }
	
	                    var betSlips = state.application.getIn(['coupon', 'betSlips']);
	                    var betTypes = state.application.getIn(['coupon', 'betTypes']);
	                    var currentBetTypeIndex = state.application.getIn(['coupon', 'currentBetTypeIndex']);
	                    var couponState = state.application.getIn(['coupon', 'state']);
	                    var betSlipAmounts = state.application.getIn(['coupon', 'betSlipAmounts']);
	
	                    if (betSlips !== undefined && betSlips.size > 0 && betTypes !== undefined && betTypes.size > 0 && betSlipAmounts !== undefined && betSlipAmounts.size > 0 && currentBetTypeIndex !== undefined && couponState !== undefined) {
	                        localStorage.setItem(gamblerId + '_betSlips', (0, _stringify2.default)(betSlips.toJS()));
	                        localStorage.setItem(gamblerId + '_betTypes', (0, _stringify2.default)(betTypes.toJS()));
	                        localStorage.setItem(gamblerId + '_betSlipAmounts', (0, _stringify2.default)(betSlipAmounts.toJS()));
	                        localStorage.setItem(gamblerId + '_betTypeIndex', currentBetTypeIndex);
	                        localStorage.setItem(gamblerId + '_couponState', couponState);
	                    }
	
	                    switch (action.type) {
	                        case CouponRateActions.REMOVE_COUPON_RATE:
	                            if (betSlips.size === 0) {
	                                localStorage.removeItem(gamblerId + '_betSlips');
	                                localStorage.removeItem(gamblerId + '_betTypes');
	                                localStorage.removeItem(gamblerId + '_betSlipAmounts');
	                                localStorage.removeItem(gamblerId + '_betTypeIndex');
	                                localStorage.removeItem(gamblerId + '_couponState');
	                            }
	                            break;
	
	                        case CouponRateActions.REMOVE_COUPON_RATES:
	                            localStorage.removeItem(gamblerId + '_betSlips');
	                            localStorage.removeItem(gamblerId + '_betTypes');
	                            localStorage.removeItem(gamblerId + '_betSlipAmounts');
	                            localStorage.removeItem(gamblerId + '_betTypeIndex');
	                            localStorage.removeItem(gamblerId + '_couponState');
	                            break;
	                    }
	
	                    return action;
	                }
	            });
	        };
	    };
	};

/***/ },
/* 1407 */,
/* 1408 */,
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1420), __esModule: true };

/***/ },
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1445);
	module.exports = __webpack_require__(32).Number.parseFloat;


/***/ },
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1453);
	module.exports = __webpack_require__(32).Object.entries;


/***/ },
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */
[2082, 62, 313, 317, 417],
/* 1436 */
[2083, 50, 1439, 821],
/* 1437 */,
/* 1438 */,
/* 1439 */
[2086, 33, 513, 122, 821],
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */
[2090, 33, 1436],
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */
[2096, 33, 1435],
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */
/***/ function(module, exports) {

	'use strict';
	
	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value)
			&& !isSpecial(value)
	};
	
	function isNonNullObject(value) {
		return !!value && typeof value === 'object'
	}
	
	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);
	
		return stringValue === '[object RegExp]'
			|| stringValue === '[object Date]'
			|| isReactElement(value)
	}
	
	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
	
	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE
	}
	
	function emptyTarget(val) {
		return Array.isArray(val) ? [] : {}
	}
	
	function cloneUnlessOtherwiseSpecified(value, options) {
		return (options.clone !== false && options.isMergeableObject(value))
			? deepmerge(emptyTarget(value), value, options)
			: value
	}
	
	function defaultArrayMerge(target, source, options) {
		return target.concat(source).map(function(element) {
			return cloneUnlessOtherwiseSpecified(element, options)
		})
	}
	
	function getMergeFunction(key, options) {
		if (!options.customMerge) {
			return deepmerge
		}
		var customMerge = options.customMerge(key);
		return typeof customMerge === 'function' ? customMerge : deepmerge
	}
	
	function getEnumerableOwnPropertySymbols(target) {
		return Object.getOwnPropertySymbols
			? Object.getOwnPropertySymbols(target).filter(function(symbol) {
				return Object.propertyIsEnumerable.call(target, symbol)
			})
			: []
	}
	
	function getKeys(target) {
		return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
	}
	
	function propertyIsOnObject(object, property) {
		try {
			return property in object
		} catch(_) {
			return false
		}
	}
	
	// Protects from prototype poisoning and unexpected merging up the prototype chain.
	function propertyIsUnsafe(target, key) {
		return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
			&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
				&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
	}
	
	function mergeObject(target, source, options) {
		var destination = {};
		if (options.isMergeableObject(target)) {
			getKeys(target).forEach(function(key) {
				destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
			});
		}
		getKeys(source).forEach(function(key) {
			if (propertyIsUnsafe(target, key)) {
				return
			}
	
			if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
				destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
			} else {
				destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
			}
		});
		return destination
	}
	
	function deepmerge(target, source, options) {
		options = options || {};
		options.arrayMerge = options.arrayMerge || defaultArrayMerge;
		options.isMergeableObject = options.isMergeableObject || isMergeableObject;
		// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
		// implementations can use it. The caller may not replace it.
		options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
	
		var sourceIsArray = Array.isArray(source);
		var targetIsArray = Array.isArray(target);
		var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
	
		if (!sourceAndTargetTypesMatch) {
			return cloneUnlessOtherwiseSpecified(source, options)
		} else if (sourceIsArray) {
			return options.arrayMerge(target, source, options)
		} else {
			return mergeObject(target, source, options)
		}
	}
	
	deepmerge.all = function deepmergeAll(array, options) {
		if (!Array.isArray(array)) {
			throw new Error('first argument should be an array')
		}
	
		return array.reduce(function(prev, next) {
			return deepmerge(prev, next, options)
		}, {})
	};
	
	var deepmerge_1 = deepmerge;
	
	module.exports = deepmerge_1;


/***/ },
/* 1658 */
/***/ function(module, exports) {

	'use strict';
	module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 1659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var canUseDOM = __webpack_require__(1658);
	
	var size;
	
	module.exports = function (recalc) {
	  if (!size || recalc) {
	    if (canUseDOM) {
	      var scrollDiv = document.createElement('div');
	
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	};

/***/ },
/* 1660 */
/***/ function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(1662);
	var each = __webpack_require__(859).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ },
/* 1661 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(1660);
	var Util = __webpack_require__(859);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ },
/* 1662 */
/***/ function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ },
/* 1663 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(1661);
	module.exports = new MediaQueryDispatch();


/***/ },
/* 1664 */,
/* 1665 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "04b115dfb0bbd3f1099fb598bab64c6c.svg";

/***/ },
/* 1679 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3562f4cef75616dd0ebcf3797c967517.svg";

/***/ },
/* 1680 */,
/* 1681 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "24138b29c302d1a01cfd2b29415b8d9a.svg";

/***/ },
/* 1682 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2d77bbe8806965cedf23bfa5959409c9.png";

/***/ },
/* 1683 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6d7f2254f10f76e2b55b98c7ae54bcdb.png";

/***/ },
/* 1684 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0b8b9af0cfd0e9310ebf3af2a86aa9e3.png";

/***/ },
/* 1685 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7d45af2ef3159f250734a46b5a418bd5.png";

/***/ },
/* 1686 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2da7bd6e0b7c167a3e06ad25bf6b8861.png";

/***/ },
/* 1687 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7c4b269e152ff1240cec354fd9afbbc8.png";

/***/ },
/* 1688 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7084a67aa6ab0fd5a121c5484ea552f6.png";

/***/ },
/* 1689 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "54061acab2730ad22b3a0481b8817447.png";

/***/ },
/* 1690 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c4e58e45a4ad28b20ff211385d48647f.png";

/***/ },
/* 1691 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "95e2809573a14f70b8db8114c414b00a.png";

/***/ },
/* 1692 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5b8ce8fe6674f950ce0eb0e46dc32172.png";

/***/ },
/* 1693 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2ed431335e7d3cb1c366ec6ae00d9068.png";

/***/ },
/* 1694 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e5dd0a5405bebda6e3b53f6d17ed8346.png";

/***/ },
/* 1695 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2b436d03147344af38112d91bf784438.png";

/***/ },
/* 1696 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bdccdf3d932ec303c5af3c26ad1f7ec7.png";

/***/ },
/* 1697 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "50e11e4075c62ce47c8b8bee13a9c05e.png";

/***/ },
/* 1698 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6dd0fc0cbd6a0174c5de11c7cc5f5b46.png";

/***/ },
/* 1699 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "371716147f5675f03990c00963aa2d9f.png";

/***/ },
/* 1700 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bf9237f53757b71506d6d05bcfe48b07.png";

/***/ },
/* 1701 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bab19bee8c9c8db6cd215f5c79a97cbb.png";

/***/ },
/* 1702 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "65337a0ce4271fb7644909717b32302c.png";

/***/ },
/* 1703 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "16e865b610cc96a9182a054bbaa52620.png";

/***/ },
/* 1704 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a03ed90208197244020d30d1f382eaf9.png";

/***/ },
/* 1705 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3d2e649f08d4522fa03eb0c652fe0fc4.png";

/***/ },
/* 1706 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c5d043e79dacf99c907132b79b0272e3.png";

/***/ },
/* 1707 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "008a03d2224d2091f7367723e75e99d6.png";

/***/ },
/* 1708 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9924546651cbc9615f9fc288698d6293.png";

/***/ },
/* 1709 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c38513f499c3d9fe31e8724958b2438b.png";

/***/ },
/* 1710 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2b967010d0745b50dc4f4cf3c0993d40.png";

/***/ },
/* 1711 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d9389445addedb7eccc55bf04327421d.png";

/***/ },
/* 1712 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2939449eba3abebcff8b85f81940ff9f.png";

/***/ },
/* 1713 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "aa19bc22783454ad9da32c2f6de524b5.png";

/***/ },
/* 1714 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c14e6ffb22f45bd0a16ba6604be2d0d9.png";

/***/ },
/* 1715 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "aa0319286f84f987920577e80cb7bdeb.png";

/***/ },
/* 1716 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "329ad6261d533473bfee40d40605e10a.png";

/***/ },
/* 1717 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "33a1fcee49e72b4de264074e5d144c2a.png";

/***/ },
/* 1718 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "71cb97ad45675f64a3d4e03df3e59e3b.png";

/***/ },
/* 1719 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2c119104023f6c2cd3a2e43810d477ef.png";

/***/ },
/* 1720 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e84ff57ac423b70365b1b9c51198be69.png";

/***/ },
/* 1721 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "84513624e0f6c8fb129e9462d58f8ea2.png";

/***/ },
/* 1722 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "84cfcbdddfefa41db5437ca6da2ac665.png";

/***/ },
/* 1723 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "712a81393ecad692ac70a28898a5d639.png";

/***/ },
/* 1724 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bb7ae50c07af7775fc1931229542bcdb.png";

/***/ },
/* 1725 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "54af3c62d2c515ca1598f5130dd132d3.png";

/***/ },
/* 1726 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ba5a2fb4728073262a63d157c07af511.png";

/***/ },
/* 1727 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f56820929bebc1b04c7ea8fb21a0a982.png";

/***/ },
/* 1728 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8addaf8ab3bbd316368774ee538903e2.png";

/***/ },
/* 1729 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8a979d33c7204b6d899cc24245f76328.png";

/***/ },
/* 1730 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "885a66164ff7243bfd45aab5a2ebc4e3.png";

/***/ },
/* 1731 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9a5c60d0390a862d0e5254474e919cbc.png";

/***/ },
/* 1732 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c0cbecbe1bee065a4889d0f982533bc5.png";

/***/ },
/* 1733 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c0d5de17d185e4929c7e68f1d0401a29.png";

/***/ },
/* 1734 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a8bfef032fad2490e091b2105572d0e7.png";

/***/ },
/* 1735 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "28e811b1dd4da5a2a092262ee9afcfa7.png";

/***/ },
/* 1736 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4095eaa70e4d29dbfdb3561fa4d0640b.png";

/***/ },
/* 1737 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "685eb22fdaa9a5fca00fd3d5f701ab2d.png";

/***/ },
/* 1738 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "901d8e768b29865e0cc81be6c33b2328.png";

/***/ },
/* 1739 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7726383dd12ac4f81db5d6befb276ea8.png";

/***/ },
/* 1740 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "54b9a2ff3971554da60358eb1327dd6a.png";

/***/ },
/* 1741 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8ec7e03775a36959dfe6a06098d60181.png";

/***/ },
/* 1742 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b747dd387993a29ae7c47175577a2159.png";

/***/ },
/* 1743 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c6b363f5c444235ad6ebba5a832480e9.png";

/***/ },
/* 1744 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "03a869cb3135599ced260d3bd0a8ce21.png";

/***/ },
/* 1745 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "35339101c758e6af82681765a919e173.png";

/***/ },
/* 1746 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1563a8c8fbc09b9c75842f4157ca370e.png";

/***/ },
/* 1747 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "36153e11fef437051d3c6532fd761087.png";

/***/ },
/* 1748 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4299677bd39aee2124d9bec7228afeaa.png";

/***/ },
/* 1749 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "42bfc4f3e97f3c31fda37cdf91161052.png";

/***/ },
/* 1750 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a8314ab7a97624ccc396d838900676f2.png";

/***/ },
/* 1751 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "33f147ba8b7d0ad4490d5042a9c358f9.png";

/***/ },
/* 1752 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d1e548dcf30fb9f27ac3d9d8d02e83e0.png";

/***/ },
/* 1753 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3872a63e91fc3dc5fc3e7f0dc14e35cb.png";

/***/ },
/* 1754 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7563f4c703c8116ceab725a1a8ff238d.png";

/***/ },
/* 1755 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e29a0848471e494f9edd0649a9b1a2d4.png";

/***/ },
/* 1756 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9b03e5da08053f5b1bd2bafb5205c95d.png";

/***/ },
/* 1757 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3c5e4f4307b86963235ac7b04f74d500.png";

/***/ },
/* 1758 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "74b7bb27b901f2a0150883a9e05510c2.png";

/***/ },
/* 1759 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "94d5878ccbadf78da0c32a611229fdd6.png";

/***/ },
/* 1760 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ee1ca9bca22d874c10cf60fea556d924.png";

/***/ },
/* 1761 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3de42eda6b5b4f942400cb1eb467aa96.png";

/***/ },
/* 1762 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7eedd262d94df1e9a5d71121d98c1441.png";

/***/ },
/* 1763 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ec6420b9a6d4a1fab43fb1e7b5002c72.png";

/***/ },
/* 1764 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cf27a898819e1fec79407a1157f1d2b3.png";

/***/ },
/* 1765 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4107a73a1feb867ae74d94564eb6a400.png";

/***/ },
/* 1766 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7eed77f4cb04e9cb678c17eba85afd1e.png";

/***/ },
/* 1767 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "971aa85cdece0821508af523efa17c10.png";

/***/ },
/* 1768 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3fabb57f3251d0b9e2ae15053081bc9e.png";

/***/ },
/* 1769 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7dc4d79241b8d72acad38f96f00a26fd.png";

/***/ },
/* 1770 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f5088687f23a4c2d37e75427364a26f1.png";

/***/ },
/* 1771 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b19802fbc7b5fbc4753af98191a44768.png";

/***/ },
/* 1772 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bd71cdf8cf5a0e38d7168457c2c8fec4.png";

/***/ },
/* 1773 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e732944060004de76276f19d62de3181.png";

/***/ },
/* 1774 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8630a5e0582753d801adb83cb2faec38.png";

/***/ },
/* 1775 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4df9ec7c700810ec1a9d743bbdc7079c.png";

/***/ },
/* 1776 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8c3e0fae59dc242e01bdd94aedc5848f.png";

/***/ },
/* 1777 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1e09c842088a1151e7aef1251025e6b6.png";

/***/ },
/* 1778 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4c1e4c4e1042d6f6bde938d4193b14d1.png";

/***/ },
/* 1779 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "912ce9eff6454a827145f1c0909b9559.png";

/***/ },
/* 1780 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c697c51f952d22807ee72cb3436c8a4c.png";

/***/ },
/* 1781 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ca4068d1d5a9589d4ad48fa3f344bef8.png";

/***/ },
/* 1782 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8181b6db818003d78b31f5c33205acd8.png";

/***/ },
/* 1783 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3e331b3c4622631e097b545aa8476087.png";

/***/ },
/* 1784 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b767bc08ba3ea466880a1b375deabcea.svg";

/***/ },
/* 1785 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ef561b564642c8b1bddda2a99b8e08d6.svg";

/***/ },
/* 1786 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "44882ffe9a4e8f5ee6c91453ceb1818c.svg";

/***/ },
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */
/***/ function(module, exports) {

	module.exports = {
		"1": "KGS",
		"2": "RUR",
		"4": "KZT",
		"5": "USD",
		"6": "EUR",
		"15": "UZS"
	};

/***/ },
/* 1816 */
/***/ function(module, exports) {

	module.exports = {
		"15": "UZS"
	};

/***/ },
/* 1817 */
650,
/* 1818 */
/***/ function(module, exports) {

	module.exports = {
		"192": {
			"name": "Uzbekistan",
			"mask": "+998",
			"length": 9
		}
	};

/***/ },
/* 1819 */
/***/ function(module, exports) {

	module.exports = {
		"1": {
			"name": "Australia",
			"short": "AU",
			"mask": "+61",
			"length": 9
		},
		"2": {
			"name": "Austria",
			"short": "AT",
			"mask": "+43",
			"length": 9
		},
		"3": {
			"name": "Azerbaijan",
			"short": "AZ",
			"mask": "+994",
			"length": 9
		},
		"5": {
			"name": "Algeria",
			"short": "DZ",
			"mask": "+213",
			"length": 9
		},
		"6": {
			"name": "American Samoa",
			"short": "AS",
			"mask": "+1",
			"length": 10
		},
		"7": {
			"name": "Anguilla",
			"short": "AI",
			"mask": "+1",
			"length": 10
		},
		"8": {
			"name": "Angola",
			"short": "AO",
			"mask": "+244",
			"length": 9
		},
		"9": {
			"name": "Andorra",
			"short": "AD",
			"mask": "+376",
			"length": 6
		},
		"11": {
			"name": "Antigua And Barbuda",
			"short": "AG",
			"mask": "+1",
			"length": 10
		},
		"12": {
			"name": "Argentina",
			"short": "AR",
			"mask": "+54",
			"length": 11
		},
		"13": {
			"name": "Armenia",
			"short": "AM",
			"mask": "+374",
			"length": 8
		},
		"14": {
			"name": "Aruba",
			"short": "AW",
			"mask": "+297",
			"length": 7
		},
		"15": {
			"name": "Afghanistan",
			"short": "AF",
			"mask": "+93",
			"length": 9
		},
		"16": {
			"name": "Bahamas",
			"short": "BS",
			"mask": "+1",
			"length": 10
		},
		"17": {
			"name": "Bangladesh",
			"short": "BD",
			"mask": "+880",
			"length": 10
		},
		"18": {
			"name": "Barbados",
			"short": "BB",
			"mask": "+1",
			"length": 10
		},
		"19": {
			"name": "Bahrain",
			"short": "BH",
			"mask": "+973",
			"length": 8
		},
		"20": {
			"name": "Belize",
			"short": "BZ",
			"mask": "+501",
			"length": 7
		},
		"21": {
			"name": "Belarus",
			"short": "BY",
			"mask": "+375",
			"length": 9
		},
		"22": {
			"name": "Belgium",
			"short": "BE",
			"mask": "+32",
			"length": 9
		},
		"23": {
			"name": "Benin",
			"short": "BJ",
			"mask": "+229",
			"length": 8
		},
		"24": {
			"name": "Bermuda",
			"short": "BM",
			"mask": "+1",
			"length": 10
		},
		"25": {
			"name": "Bulgaria",
			"short": "BG",
			"mask": "+359",
			"length": 8
		},
		"26": {
			"name": "Bolivia",
			"short": "BO",
			"mask": "+571",
			"length": 8
		},
		"27": {
			"name": "Bosnia And Herzegovina",
			"short": "BA",
			"mask": "+387",
			"length": 8
		},
		"28": {
			"name": "Botswana",
			"short": "BW",
			"mask": "+267",
			"length": 8
		},
		"29": {
			"name": "Brazil",
			"short": "BR",
			"mask": "+55",
			"length": 10
		},
		"30": {
			"name": "British Indian Ocean Territory",
			"short": "IO",
			"mask": "+246",
			"length": 7
		},
		"32": {
			"name": "Brunei Darussalam",
			"short": "BN",
			"mask": "+673",
			"length": 7
		},
		"33": {
			"name": "Burkina Faso",
			"short": "BF",
			"mask": "+226",
			"length": 8
		},
		"34": {
			"name": "Burundi",
			"short": "BI",
			"mask": "+257",
			"length": 8
		},
		"35": {
			"name": "Bhutan",
			"short": "BT",
			"mask": "+975",
			"length": 8
		},
		"36": {
			"name": "Vanuatu",
			"short": "VU",
			"mask": "+678",
			"length": 7
		},
		"38": {
			"name": "United Kingdom",
			"short": "GB",
			"mask": "+44",
			"length": 10
		},
		"39": {
			"name": "Hungary",
			"short": "HU",
			"mask": "+36",
			"length": 9
		},
		"40": {
			"name": "Venezuela",
			"short": "VE",
			"mask": "+58",
			"length": 10
		},
		"42": {
			"name": "Vietnam",
			"short": "VN",
			"mask": "+84",
			"length": 9
		},
		"43": {
			"name": "Gabon",
			"short": "GA",
			"mask": "+241",
			"length": 8
		},
		"44": {
			"name": "Haiti",
			"short": "HT",
			"mask": "+509",
			"length": 8
		},
		"45": {
			"name": "Guyana",
			"short": "GY",
			"mask": "+592",
			"length": 7
		},
		"46": {
			"name": "Gambia",
			"short": "GM",
			"mask": "+220",
			"length": 7
		},
		"47": {
			"name": "Ghana",
			"short": "GH",
			"mask": "+233",
			"length": 9
		},
		"48": {
			"name": "Guadeloupe",
			"short": "GP",
			"mask": "+590",
			"length": 9
		},
		"49": {
			"name": "Guatemala",
			"short": "GT",
			"mask": "+502",
			"length": 8
		},
		"50": {
			"name": "Guinea",
			"short": "GN",
			"mask": "+224",
			"length": 8
		},
		"51": {
			"name": "Guinea-Bissau",
			"short": "GW",
			"mask": "+245",
			"length": 7
		},
		"52": {
			"name": "Germany",
			"short": "DE",
			"mask": "+49",
			"length": 11
		},
		"53": {
			"name": "Honduras",
			"short": "HN",
			"mask": "+504",
			"length": 8
		},
		"54": {
			"name": "State of Palestine",
			"short": "PS",
			"mask": "+970",
			"length": 9
		},
		"55": {
			"name": "Grenada",
			"short": "GD",
			"mask": "+1",
			"length": 10
		},
		"56": {
			"name": "Greenland",
			"short": "GL",
			"mask": "+299",
			"length": 6
		},
		"58": {
			"name": "Guam",
			"short": "GU",
			"mask": "+1",
			"length": 10
		},
		"60": {
			"name": "Djibouti",
			"short": "DJ",
			"mask": "+253",
			"length": 8
		},
		"61": {
			"name": "Dominica",
			"short": "DM",
			"mask": "+1",
			"length": 10
		},
		"62": {
			"name": "Dominican Republic",
			"short": "DO",
			"mask": "+1",
			"length": 10
		},
		"63": {
			"name": "Egypt",
			"short": "EG",
			"mask": "+20",
			"length": 10
		},
		"64": {
			"name": "Zambia",
			"short": "ZM",
			"mask": "+260",
			"length": 9
		},
		"65": {
			"name": "Western Sahara",
			"short": "EH",
			"mask": "+212",
			"length": 9
		},
		"66": {
			"name": "Zimbabwe",
			"short": "ZW",
			"mask": "+263",
			"length": 9
		},
		"67": {
			"name": "Israel",
			"short": "IL",
			"mask": "+972",
			"length": 9
		},
		"68": {
			"name": "India",
			"short": "IN",
			"mask": "+91",
			"length": 10
		},
		"69": {
			"name": "Indonesia",
			"short": "ID",
			"mask": "+62",
			"length": 9
		},
		"70": {
			"name": "Jordan",
			"short": "JO",
			"mask": "+962",
			"length": 9
		},
		"71": {
			"name": "Iraq",
			"short": "IQ",
			"mask": "+964",
			"length": 10
		},
		"72": {
			"name": "Iran, Islamic Republic of",
			"short": "IR",
			"mask": "+98",
			"length": 10
		},
		"73": {
			"name": "Ireland",
			"short": "IE",
			"mask": "+353",
			"length": 9
		},
		"74": {
			"name": "Iceland",
			"short": "IS",
			"mask": "+354",
			"length": 7
		},
		"75": {
			"name": "Spain",
			"short": "ES",
			"mask": "+34",
			"length": 9
		},
		"76": {
			"name": "Italy",
			"short": "IT",
			"mask": "+39",
			"length": 10
		},
		"77": {
			"name": "Yemen",
			"short": "YE",
			"mask": "+967",
			"length": 9
		},
		"78": {
			"name": "Cape Verde",
			"short": "CV",
			"mask": "+238",
			"length": 7
		},
		"79": {
			"name": "Kazakstan",
			"short": "KZ",
			"mask": "+7",
			"length": 10
		},
		"80": {
			"name": "Cayman Islands",
			"short": "KY",
			"mask": "+1",
			"length": 10
		},
		"81": {
			"name": "Cambodia",
			"short": "KH",
			"mask": "+855",
			"length": 8
		},
		"82": {
			"name": "Cameroon",
			"short": "CM",
			"mask": "+237",
			"length": 8
		},
		"83": {
			"name": "Canada",
			"short": "CA",
			"mask": "+1",
			"length": 10
		},
		"84": {
			"name": "Qatar",
			"short": "QA",
			"mask": "+974",
			"length": 8
		},
		"85": {
			"name": "Kenya",
			"short": "KE",
			"mask": "+254",
			"length": 9
		},
		"86": {
			"name": "Kiribati",
			"short": "KI",
			"mask": "+686",
			"length": 5
		},
		"87": {
			"name": "Taiwan, Province of China",
			"short": "TW",
			"mask": "+886",
			"length": 9
		},
		"88": {
			"name": "Korea, Democratic People's Republic of",
			"short": "KP",
			"mask": "+850",
			"length": 10
		},
		"89": {
			"name": "Cocos (Keeling) Islands",
			"short": "CC",
			"mask": "+61",
			"length": 9
		},
		"90": {
			"name": "Colombia",
			"short": "CO",
			"mask": "+57",
			"length": 10
		},
		"91": {
			"name": "Comoros",
			"short": "KM",
			"mask": "+269",
			"length": 7
		},
		"92": {
			"name": "Costa Rica",
			"short": "CR",
			"mask": "+506",
			"length": 8
		},
		"93": {
			"name": "Cote D'Ivoire",
			"short": "CI",
			"mask": "+255",
			"length": 8
		},
		"94": {
			"name": "Cuba",
			"short": "CU",
			"mask": "+53",
			"length": 8
		},
		"95": {
			"name": "Kuwait",
			"short": "KW",
			"mask": "+965",
			"length": 7
		},
		"96": {
			"name": "Kyrgyzstan",
			"short": "KG",
			"mask": "+996",
			"length": 9
		},
		"97": {
			"name": "Lao People's Democratic Republic",
			"short": "LA",
			"mask": "+856",
			"length": 10
		},
		"98": {
			"name": "Lesotho",
			"short": "LS",
			"mask": "+266",
			"length": 8
		},
		"99": {
			"name": "Liberia",
			"short": "LR",
			"mask": "+231",
			"length": 7
		},
		"100": {
			"name": "Lebanon",
			"short": "LB",
			"mask": "+961",
			"length": 8
		},
		"101": {
			"name": "Libyan Arab Jamahiriya",
			"short": "LY",
			"mask": "+218",
			"length": 9
		},
		"102": {
			"name": "Lithuania",
			"short": "LT",
			"mask": "+218",
			"length": 9
		},
		"103": {
			"name": "Luxembourg",
			"short": "LU",
			"mask": "+352",
			"length": 9
		},
		"104": {
			"name": "Mauritius",
			"short": "MU",
			"mask": "+230",
			"length": 7
		},
		"105": {
			"name": "Mauritania",
			"short": "MR",
			"mask": "+222",
			"length": 8
		},
		"106": {
			"name": "Madagascar",
			"short": "MG",
			"mask": "+261",
			"length": 9
		},
		"107": {
			"name": "Mayotte",
			"short": "YT",
			"mask": "+262",
			"length": 9
		},
		"108": {
			"name": "Malawi",
			"short": "MW",
			"mask": "+265",
			"length": 9
		},
		"109": {
			"name": "Malaysia",
			"short": "MY",
			"mask": "+60",
			"length": 9
		},
		"110": {
			"name": "Mali",
			"short": "ML",
			"mask": "+223",
			"length": 8
		},
		"111": {
			"name": "Maldives",
			"short": "MV",
			"mask": "+960",
			"length": 7
		},
		"112": {
			"name": "Malta",
			"short": "MT",
			"mask": "+356",
			"length": 8
		},
		"113": {
			"name": "Morocco",
			"short": "MA",
			"mask": "+212",
			"length": 9
		},
		"114": {
			"name": "Marshall Islands",
			"short": "MH",
			"mask": "+692",
			"length": 7
		},
		"115": {
			"name": "Mexico",
			"short": "MX",
			"mask": "+52",
			"length": 11
		},
		"116": {
			"name": "Micronesia, Federated States of",
			"short": "FM",
			"mask": "+691",
			"length": 7
		},
		"117": {
			"name": "Mozambique",
			"short": "MZ",
			"mask": "+258",
			"length": 9
		},
		"118": {
			"name": "Moldova, Republic of",
			"short": "MD",
			"mask": "+373",
			"length": 8
		},
		"119": {
			"name": "Monaco",
			"short": "MC",
			"mask": "+377",
			"length": 9
		},
		"120": {
			"name": "Mongolia",
			"short": "MN",
			"mask": "+976",
			"length": 8
		},
		"121": {
			"name": "Montserrat",
			"short": "MS",
			"mask": "+1",
			"length": 10
		},
		"122": {
			"name": "Myanmar",
			"short": "MM",
			"mask": "+95",
			"length": 8
		},
		"123": {
			"name": "Namibia",
			"short": "NA",
			"mask": "+264",
			"length": 9
		},
		"124": {
			"name": "Nauru",
			"short": "NR",
			"mask": "+674",
			"length": 7
		},
		"125": {
			"name": "Nepal",
			"short": "NP",
			"mask": "+977",
			"length": 10
		},
		"126": {
			"name": "Niger",
			"short": "NE",
			"mask": "+227",
			"length": 8
		},
		"127": {
			"name": "Nigeria",
			"short": "NG",
			"mask": "+234",
			"length": 10
		},
		"129": {
			"name": "Netherlands",
			"short": "NL",
			"mask": "+31",
			"length": 9
		},
		"130": {
			"name": "Nicaragua",
			"short": "NI",
			"mask": "+505",
			"length": 8
		},
		"131": {
			"name": "Niue",
			"short": "NU",
			"mask": "+683",
			"length": 4
		},
		"132": {
			"name": "New Zealand",
			"short": "NZ",
			"mask": "+64",
			"length": 9
		},
		"133": {
			"name": "New Caledonia",
			"short": "NC",
			"mask": "+687",
			"length": 6
		},
		"134": {
			"name": "Norway",
			"short": "NO",
			"mask": "+47",
			"length": 8
		},
		"135": {
			"name": "United Arab Emirates",
			"short": "AE",
			"mask": "+971",
			"length": 9
		},
		"136": {
			"name": "Oman",
			"short": "OM",
			"mask": "+968",
			"length": 8
		},
		"138": {
			"name": "Norfolk Island",
			"short": "NF",
			"mask": "+672",
			"length": 6
		},
		"139": {
			"name": "Christmas Island",
			"short": "CX",
			"mask": "+61",
			"length": 9
		},
		"141": {
			"name": "Cook Islands",
			"short": "CK",
			"mask": "+682",
			"length": 5
		},
		"143": {
			"name": "Pakistan",
			"short": "PK",
			"mask": "+92",
			"length": 10
		},
		"144": {
			"name": "Palau",
			"short": "PW",
			"mask": "+680",
			"length": 7
		},
		"145": {
			"name": "Papua New Guinea",
			"short": "PG",
			"mask": "+675",
			"length": 7
		},
		"146": {
			"name": "Paraguay",
			"short": "PY",
			"mask": "+595",
			"length": 9
		},
		"147": {
			"name": "Peru",
			"short": "PE",
			"mask": "+51",
			"length": 9
		},
		"148": {
			"name": "Poland",
			"short": "PL",
			"mask": "+48",
			"length": 9
		},
		"149": {
			"name": "Portugal",
			"short": "PT",
			"mask": "+351",
			"length": 9
		},
		"150": {
			"name": "Puerto Rico",
			"short": "PR",
			"mask": "+1",
			"length": 10
		},
		"151": {
			"name": "Congo",
			"short": "CG",
			"mask": "+243",
			"length": 9
		},
		"152": {
			"name": "Korea, Republic of",
			"short": "KR",
			"mask": "+82",
			"length": 10
		},
		"153": {
			"name": "Macedonia, The Former Yugoslav Republic of",
			"short": "MK",
			"mask": "+389",
			"length": 8
		},
		"154": {
			"name": "Russian Federation",
			"short": "RU",
			"mask": "+7",
			"length": 10
		},
		"155": {
			"name": "Rwanda",
			"short": "RW",
			"mask": "+250",
			"length": 9
		},
		"156": {
			"name": "Romania",
			"short": "RO",
			"mask": "+40",
			"length": 9
		},
		"157": {
			"name": "El Salvador",
			"short": "SV",
			"mask": "+503",
			"length": 8
		},
		"158": {
			"name": "Samoa",
			"short": "WS",
			"mask": "+685",
			"length": 6
		},
		"159": {
			"name": "San Marino",
			"short": "SM",
			"mask": "+378",
			"length": 8
		},
		"160": {
			"name": "Sao Tome And Principe",
			"short": "ST",
			"mask": "+239",
			"length": 7
		},
		"161": {
			"name": "Saudi Arabia",
			"short": "SA",
			"mask": "+966",
			"length": 9
		},
		"162": {
			"name": "Swaziland",
			"short": "SZ",
			"mask": "+268",
			"length": 8
		},
		"163": {
			"name": "Northern Mariana Islands",
			"short": "MP",
			"mask": "+1",
			"length": 10
		},
		"164": {
			"name": "Seychelles",
			"short": "SC",
			"mask": "+248",
			"length": 7
		},
		"165": {
			"name": "Saint Pierre And Miquelon",
			"short": "PM",
			"mask": "+508",
			"length": 6
		},
		"166": {
			"name": "Senegal",
			"short": "SN",
			"mask": "+221",
			"length": 9
		},
		"167": {
			"name": "Saint Vincent And The Grenadines",
			"short": "VC",
			"mask": "+1",
			"length": 10
		},
		"168": {
			"name": "Saint Kitts And Nevis",
			"short": "KN",
			"mask": "+1",
			"length": 10
		},
		"169": {
			"name": "Saint Lucia",
			"short": "LC",
			"mask": "+1",
			"length": 10
		},
		"170": {
			"name": "Serbia",
			"short": "RS",
			"mask": "+381",
			"length": 9
		},
		"171": {
			"name": "Singapore",
			"short": "SG",
			"mask": "+65",
			"length": 8
		},
		"172": {
			"name": "Syrian Arab Republic",
			"short": "SY",
			"mask": "+963",
			"length": 9
		},
		"173": {
			"name": "Slovakia (Slovak Republic)",
			"short": "SK",
			"mask": "+421",
			"length": 9
		},
		"174": {
			"name": "Slovenia",
			"short": "SI",
			"mask": "+386",
			"length": 8
		},
		"175": {
			"name": "Solomon Islands",
			"short": "SB",
			"mask": "+677",
			"length": 7
		},
		"176": {
			"name": "Somalia",
			"short": "SO",
			"mask": "+252",
			"length": 8
		},
		"177": {
			"name": "Sudan",
			"short": "SD",
			"mask": "+249",
			"length": 9
		},
		"178": {
			"name": "Suriname",
			"short": "SR",
			"mask": "+597",
			"length": 7
		},
		"179": {
			"name": "Sierra Leone",
			"short": "SL",
			"mask": "+232",
			"length": 8
		},
		"180": {
			"name": "Tajikistan",
			"short": "TJ",
			"mask": "+992",
			"length": 9
		},
		"181": {
			"name": "Thailand",
			"short": "TH",
			"mask": "+66",
			"length": 9
		},
		"182": {
			"name": "Tanzania, United Republic of",
			"short": "TZ",
			"mask": "+255",
			"length": 9
		},
		"183": {
			"name": "Turks And Caicos Islands",
			"short": "TC",
			"mask": "+1",
			"length": 10
		},
		"184": {
			"name": "Togo",
			"short": "TG",
			"mask": "+228",
			"length": 8
		},
		"185": {
			"name": "Tokelau",
			"short": "TK",
			"mask": "+676",
			"length": 7
		},
		"186": {
			"name": "Tonga",
			"short": "TO",
			"mask": "+676",
			"length": 7
		},
		"187": {
			"name": "Trinidad And Tobago",
			"short": "TT",
			"mask": "+1",
			"length": 10
		},
		"188": {
			"name": "Tuvalu",
			"short": "TV",
			"mask": "+688",
			"length": 6
		},
		"189": {
			"name": "Tunisia",
			"short": "TN",
			"mask": "+216",
			"length": 8
		},
		"190": {
			"name": "Turkmenistan",
			"short": "TM",
			"mask": "+993",
			"length": 8
		},
		"191": {
			"name": "Uganda",
			"short": "UG",
			"mask": "+256",
			"length": 9
		},
		"192": {
			"name": "Uzbekistan",
			"short": "UZ",
			"mask": "+998",
			"length": 9
		},
		"193": {
			"name": "Ukraine",
			"short": "UA",
			"mask": "+380",
			"length": 9
		},
		"194": {
			"name": "Wallis And Futuna Islands",
			"short": "WF",
			"mask": "+681",
			"length": 6
		},
		"195": {
			"name": "Uruguay",
			"short": "UY",
			"mask": "+598",
			"length": 8
		},
		"196": {
			"name": "Faroe Islands",
			"short": "FO",
			"mask": "+298",
			"length": 6
		},
		"197": {
			"name": "Fiji",
			"short": "FJ",
			"mask": "+679",
			"length": 7
		},
		"198": {
			"name": "Philippines",
			"short": "PH",
			"mask": "+63",
			"length": 10
		},
		"199": {
			"name": "Finland",
			"short": "FI",
			"mask": "+358",
			"length": 9
		},
		"200": {
			"name": "Falkland Islands (Malvinas)",
			"short": "FK",
			"mask": "+500",
			"length": 5
		},
		"201": {
			"name": "French Polynesia",
			"short": "PF",
			"mask": "+689",
			"length": 9
		},
		"203": {
			"name": "Central African Republic",
			"short": "CF",
			"mask": "+236",
			"length": 8
		},
		"204": {
			"name": "Chad",
			"short": "TD",
			"mask": "+235",
			"length": 8
		},
		"205": {
			"name": "Montenegro",
			"short": "ME",
			"mask": "+382",
			"length": 8
		},
		"206": {
			"name": "Czech Republic",
			"short": "CZ",
			"mask": "+420",
			"length": 9
		},
		"207": {
			"name": "Chile",
			"short": "CL",
			"mask": "+56",
			"length": 9
		},
		"208": {
			"name": "Sweden",
			"short": "SE",
			"mask": "+46",
			"length": 9
		},
		"209": {
			"name": "Svalbard And Jan Mayen Islands",
			"short": "SJ",
			"mask": "+47",
			"length": 8
		},
		"210": {
			"name": "Sri Lanka",
			"short": "LK",
			"mask": "+94",
			"length": 9
		},
		"211": {
			"name": "Ecuador",
			"short": "EC",
			"mask": "+593",
			"length": 9
		},
		"212": {
			"name": "Equatorial Guinea",
			"short": "GQ",
			"mask": "+240",
			"length": 9
		},
		"213": {
			"name": "Eritrea",
			"short": "ER",
			"mask": "+291",
			"length": 7
		},
		"214": {
			"name": "Estonia",
			"short": "EE",
			"mask": "+372",
			"length": 8
		},
		"216": {
			"name": "South Africa",
			"short": "ZA",
			"mask": "+27",
			"length": 9
		},
		"218": {
			"name": "Jamaica",
			"short": "JM",
			"mask": "+1",
			"length": 10
		},
		"219": {
			"name": "Japan",
			"short": "JP",
			"mask": "+81",
			"length": 10
		}
	};

/***/ },
/* 1820 */
869,
/* 1821 */
/***/ function(module, exports) {

	module.exports = {
		"192": {
			"name": "Uzbekistan",
			"short": "UZ",
			"mask": "+998",
			"length": 9
		}
	};

/***/ },
/* 1822 */
/***/ function(module, exports) {

	module.exports = {
		"1": "Русский",
		"2": "Қазақ тілі",
		"3": "Кыргызча",
		"4": "Тоҷикӣ",
		"5": "English"
	};

/***/ },
/* 1823 */
/***/ function(module, exports) {

	module.exports = {
		"1": "Asia/Astana",
		"2": "Europe/Moscow"
	};

/***/ },
/* 1824 */
/***/ function(module, exports) {

	module.exports = {
		"7": {
			"3": [
				4,
				5,
				6,
				7,
				8
			],
			"4": [
				5,
				6,
				7,
				8
			],
			"5": [
				6,
				7,
				8
			],
			"6": [
				7,
				8
			],
			"7": [
				8
			],
			"8": []
		},
		"30": {
			"4": [
				5,
				6,
				7,
				8,
				9
			],
			"5": [
				6,
				7,
				8,
				9
			],
			"6": [
				7,
				8,
				9
			],
			"7": [
				8,
				9
			],
			"8": [
				9
			],
			"9": []
		}
	};

/***/ },
/* 1825 */
/***/ function(module, exports) {

	module.exports = {
		"2": 3,
		"3": 3,
		"4": 3,
		"5": 3,
		"6": 3,
		"7": 3,
		"8": 3,
		"9": 3,
		"10": 3,
		"11": 3,
		"12": 3,
		"13": 3,
		"14": 3,
		"15": 3,
		"16": 3,
		"17": 3,
		"18": 3,
		"19": 3,
		"20": 3,
		"21": 3,
		"22": 3,
		"23": 3,
		"24": 3,
		"25": 3,
		"26": 3,
		"27": 3,
		"28": 3,
		"29": 3,
		"30": 3,
		"31": 3,
		"32": 3,
		"33": 3,
		"34": 3,
		"35": 3,
		"36": 3,
		"37": 3,
		"38": 3,
		"39": 3,
		"40": 3,
		"41": 3,
		"42": 3,
		"43": 3,
		"44": 3,
		"45": 3,
		"46": 3,
		"47": 3,
		"48": 3,
		"49": 3,
		"50": 3,
		"51": 3,
		"52": 3,
		"53": 3,
		"54": 3,
		"55": 3,
		"56": 3,
		"57": 3,
		"58": 3,
		"59": 3,
		"61": 3,
		"62": 3,
		"66": 3,
		"67": 3,
		"68": 3,
		"69": 3,
		"70": 3,
		"72": 3,
		"73": 3,
		"74": 3,
		"81": 3,
		"160": 4,
		"161": 4,
		"162": 4,
		"163": 4,
		"164": 4,
		"165": 4,
		"166": 4,
		"167": 4,
		"168": 4,
		"169": 4,
		"170": 4,
		"171": 4,
		"172": 4,
		"173": 4,
		"174": 4,
		"175": 4,
		"176": 4,
		"177": 4,
		"178": 4,
		"179": 4,
		"195": 4,
		"196": 4,
		"197": 4,
		"198": 4,
		"199": 4,
		"200": 4,
		"201": 4,
		"202": 4,
		"203": 4,
		"204": 4,
		"205": 4,
		"206": 4,
		"207": 4,
		"208": 4,
		"209": 4,
		"210": 4,
		"211": 4,
		"212": 4,
		"213": 4,
		"214": 4,
		"215": 4,
		"216": 4,
		"217": 4,
		"218": 4,
		"219": 4,
		"220": 4,
		"221": 4,
		"222": 4,
		"223": 4,
		"224": 4,
		"225": 4,
		"226": 4,
		"227": 4,
		"228": 4,
		"229": 4,
		"230": 4,
		"231": 4,
		"238": 4,
		"239": 4,
		"246": 4,
		"248": 4,
		"255": 4,
		"258": 4,
		"259": 4,
		"262": 4,
		"263": 4,
		"277": 4,
		"318": 4,
		"349": 4,
		"353": 4,
		"358": 1,
		"359": 1,
		"360": 1,
		"361": 1,
		"362": 1,
		"363": 1,
		"364": 1,
		"365": 1,
		"366": 1,
		"367": 1,
		"368": 1,
		"369": 1,
		"370": 1,
		"371": 1,
		"372": 1,
		"373": 1,
		"374": 1,
		"375": 1,
		"376": 1,
		"377": 1,
		"378": 1,
		"379": 1,
		"380": 1,
		"381": 1,
		"382": 1,
		"383": 1,
		"384": 1,
		"385": 1,
		"386": 1,
		"387": 1,
		"388": 1,
		"389": 1,
		"390": 1,
		"391": 1,
		"392": 1,
		"393": 1,
		"394": 1,
		"395": 1,
		"396": 1,
		"397": 1,
		"398": 1,
		"399": 1,
		"400": 1,
		"401": 1,
		"402": 1,
		"403": 1,
		"650": 2,
		"651": 2,
		"652": 2,
		"653": 2,
		"654": 2,
		"655": 2,
		"656": 2,
		"657": 2,
		"658": 2,
		"659": 2,
		"661": 1,
		"662": 1,
		"663": 1,
		"664": 1,
		"665": 1,
		"666": 1,
		"667": 1,
		"668": 1,
		"669": 1,
		"670": 1,
		"671": 1,
		"672": 1,
		"673": 1,
		"674": 1,
		"675": 1,
		"676": 1,
		"677": 1,
		"678": 1,
		"679": 1,
		"680": 1,
		"681": 1,
		"682": 1,
		"684": 1,
		"685": 1,
		"689": 1,
		"690": 1,
		"691": 1,
		"692": 1,
		"693": 1,
		"695": 1,
		"698": 1,
		"699": 1,
		"939": 3
	};

/***/ },
/* 1826 */
/***/ function(module, exports) {

	module.exports = {
		"2": {
			"0": {
				"73": 2,
				"102": 1,
				"257": 5,
				"307": 5,
				"318": 5,
				"352": 5,
				"403": 1,
				"443": 1,
				"599": 1,
				"743": 1,
				"744": 1
			},
			"1": {
				"21": 2,
				"83": 1,
				"122": 1,
				"129": 1,
				"138": 5,
				"182": 5,
				"195": 5,
				"366": 1,
				"557": 1,
				"607": 1,
				"863": 1,
				"885": 1
			},
			"2": {
				"22": 2,
				"84": 1,
				"123": 1,
				"130": 1,
				"139": 5,
				"183": 5,
				"196": 5,
				"367": 1,
				"558": 1,
				"608": 1,
				"864": 1,
				"886": 1
			},
			"3": {
				"23": 2,
				"85": 1,
				"124": 1,
				"131": 1,
				"140": 5,
				"184": 5,
				"197": 5,
				"368": 1,
				"559": 1,
				"609": 1,
				"865": 1,
				"887": 1
			},
			"4": {
				"24": 2,
				"86": 1,
				"125": 1,
				"132": 1,
				"141": 5,
				"185": 5,
				"198": 5,
				"369": 1,
				"560": 1,
				"610": 1,
				"866": 1,
				"888": 1
			},
			"5": {
				"25": 2,
				"87": 1,
				"126": 1,
				"133": 1,
				"142": 5,
				"186": 5,
				"199": 5,
				"370": 1,
				"561": 1,
				"611": 1,
				"867": 1,
				"889": 1
			},
			"6": {
				"26": 2,
				"88": 1,
				"127": 1,
				"134": 1,
				"143": 5,
				"187": 5,
				"200": 5,
				"371": 1,
				"562": 1,
				"612": 1,
				"868": 1,
				"890": 1
			},
			"7": {
				"27": 2,
				"89": 1,
				"128": 1,
				"135": 1,
				"144": 5,
				"188": 5,
				"201": 5,
				"372": 1,
				"563": 1,
				"613": 1,
				"869": 1,
				"891": 1
			}
		},
		"3": {
			"0": {
				"73": 2,
				"74": 2,
				"102": 1,
				"257": 5,
				"307": 5,
				"318": 5,
				"352": 5,
				"403": 1,
				"443": 1,
				"599": 1,
				"737": 1,
				"882": 1
			},
			"1": {
				"21": 2,
				"83": 1,
				"138": 5,
				"182": 5,
				"195": 5,
				"366": 1,
				"557": 1,
				"607": 1,
				"788": 1,
				"791": 1,
				"842": 1,
				"845": 1,
				"848": 1,
				"896": 1
			},
			"2": {
				"22": 2,
				"84": 1,
				"139": 5,
				"183": 5,
				"196": 5,
				"367": 1,
				"558": 1,
				"608": 1,
				"789": 1,
				"792": 1,
				"843": 1,
				"846": 1,
				"849": 1,
				"897": 1
			},
			"3": {
				"23": 2,
				"85": 1,
				"140": 5,
				"184": 5,
				"197": 5,
				"368": 1,
				"559": 1,
				"609": 1,
				"790": 1,
				"793": 1,
				"844": 1,
				"847": 1,
				"850": 1,
				"898": 1
			},
			"4": {
				"17": 2,
				"176": 5,
				"362": 1
			},
			"5": {
				"13": 2,
				"172": 5,
				"358": 1
			},
			"6": {
				"18": 2,
				"177": 5,
				"363": 1
			},
			"7": {
				"14": 2,
				"173": 5,
				"359": 1
			}
		},
		"4": {
			"0": {
				"73": 2,
				"74": 2,
				"102": 1,
				"137": 5,
				"257": 5,
				"281": 5,
				"307": 5,
				"318": 5,
				"319": 5,
				"320": 5,
				"352": 5,
				"403": 1,
				"443": 1,
				"599": 1,
				"755": 1,
				"798": 1,
				"882": 1,
				"927": 1
			},
			"1": {
				"21": 2,
				"83": 1,
				"138": 5,
				"182": 5,
				"195": 5,
				"366": 1,
				"557": 1,
				"607": 1,
				"836": 1,
				"896": 1,
				"903": 1,
				"909": 1,
				"914": 1,
				"920": 1
			},
			"2": {
				"22": 2,
				"84": 1,
				"139": 5,
				"183": 5,
				"196": 5,
				"367": 1,
				"558": 1,
				"608": 1,
				"837": 1,
				"897": 1,
				"904": 1,
				"910": 1,
				"915": 1,
				"921": 1
			},
			"3": {
				"23": 2,
				"85": 1,
				"140": 5,
				"184": 5,
				"197": 5,
				"368": 1,
				"559": 1,
				"609": 1,
				"838": 1,
				"898": 1,
				"905": 1,
				"911": 1,
				"916": 1,
				"922": 1
			},
			"4": {
				"24": 2,
				"86": 1,
				"141": 5,
				"185": 5,
				"198": 5,
				"369": 1,
				"560": 1,
				"610": 1,
				"839": 1,
				"899": 1,
				"906": 1,
				"912": 1,
				"917": 1,
				"923": 1
			},
			"5": {
				"25": 2,
				"87": 1,
				"142": 5,
				"186": 5,
				"199": 5,
				"370": 1,
				"561": 1,
				"611": 1,
				"840": 1,
				"900": 1,
				"907": 1,
				"913": 1,
				"918": 1,
				"924": 1
			},
			"6": {
				"26": 2,
				"88": 1,
				"143": 5,
				"187": 5,
				"200": 5,
				"371": 1,
				"562": 1,
				"901": 1,
				"908": 1,
				"919": 1,
				"925": 1
			},
			"7": {
				"17": 2,
				"176": 5,
				"362": 1
			},
			"8": {
				"13": 2,
				"172": 5,
				"358": 1
			},
			"9": {
				"18": 2,
				"177": 5,
				"363": 1
			},
			"10": {
				"14": 2,
				"173": 5,
				"359": 1
			},
			"11": {
				"19": 2,
				"178": 5,
				"364": 1
			},
			"12": {
				"15": 2,
				"174": 5,
				"360": 1
			},
			"13": {
				"20": 2,
				"179": 5,
				"365": 1
			},
			"14": {
				"16": 2,
				"175": 5,
				"361": 1
			}
		},
		"5": {
			"0": {
				"349": 5,
				"443": 1,
				"599": 1,
				"689": 1
			}
		},
		"6": {
			"0": {
				"73": 2,
				"82": 2,
				"102": 1,
				"257": 5,
				"296": 5,
				"297": 5,
				"298": 5,
				"299": 5,
				"305": 1,
				"307": 5,
				"308": 5,
				"309": 5,
				"315": 1,
				"318": 5,
				"320": 5,
				"328": 5,
				"329": 5,
				"330": 5,
				"331": 5,
				"332": 5,
				"337": 5,
				"338": 5,
				"339": 5,
				"340": 5,
				"341": 5,
				"342": 5,
				"352": 5,
				"403": 1,
				"427": 1,
				"443": 1,
				"445": 1,
				"505": 1,
				"506": 1,
				"507": 1,
				"513": 3,
				"514": 1,
				"527": 1,
				"534": 1,
				"535": 1,
				"536": 1,
				"537": 1,
				"538": 1,
				"539": 1,
				"540": 1,
				"543": 2,
				"544": 1,
				"550": 1,
				"551": 1,
				"599": 1,
				"623": 1,
				"627": 1,
				"638": 1,
				"687": 1,
				"688": 1,
				"713": 1,
				"732": 1,
				"739": 1,
				"798": 1,
				"894": 1,
				"1861": 6,
				"1870": 3,
				"1871": 3,
				"1872": 1
			},
			"1": {
				"21": 2,
				"76": 2,
				"83": 1,
				"138": 5,
				"182": 5,
				"190": 5,
				"195": 5,
				"300": 5,
				"310": 5,
				"333": 5,
				"366": 1,
				"508": 1,
				"545": 3,
				"552": 1,
				"557": 3,
				"594": 3,
				"618": 1,
				"708": 1,
				"745": 1,
				"750": 1,
				"759": 1,
				"896": 1
			},
			"2": {
				"22": 2,
				"77": 2,
				"84": 1,
				"139": 5,
				"183": 5,
				"191": 5,
				"196": 5,
				"301": 5,
				"311": 5,
				"334": 5,
				"367": 1,
				"509": 1,
				"546": 1,
				"553": 1,
				"558": 3,
				"595": 1,
				"619": 1,
				"709": 1,
				"746": 1,
				"751": 1,
				"760": 1,
				"897": 1
			},
			"3": {
				"23": 2,
				"78": 2,
				"85": 1,
				"140": 5,
				"184": 5,
				"192": 5,
				"197": 5,
				"302": 5,
				"312": 5,
				"335": 5,
				"368": 1,
				"510": 1,
				"547": 1,
				"554": 1,
				"559": 3,
				"596": 1,
				"620": 1,
				"710": 1,
				"747": 1,
				"752": 1,
				"761": 1,
				"898": 1
			},
			"4": {
				"24": 2,
				"79": 2,
				"86": 1,
				"141": 5,
				"185": 5,
				"193": 5,
				"198": 5,
				"303": 5,
				"313": 5,
				"336": 5,
				"369": 1,
				"511": 1,
				"548": 1,
				"555": 1,
				"560": 3,
				"597": 1,
				"621": 1,
				"711": 1,
				"748": 1,
				"753": 1,
				"762": 1,
				"899": 1
			},
			"5": {
				"25": 2,
				"80": 2,
				"87": 1,
				"142": 5,
				"186": 5,
				"194": 5,
				"199": 5,
				"304": 5,
				"314": 5,
				"370": 1,
				"512": 1,
				"549": 1,
				"556": 1,
				"561": 3,
				"598": 1,
				"622": 1,
				"712": 1,
				"749": 1,
				"754": 1,
				"763": 1,
				"900": 1
			}
		},
		"7": {
			"0": {
				"1": 2,
				"74": 2,
				"103": 1,
				"136": 5,
				"137": 5,
				"256": 5,
				"260": 1,
				"261": 1,
				"278": 1,
				"281": 5,
				"282": 5,
				"306": 5,
				"321": 5,
				"322": 5,
				"323": 5,
				"324": 5,
				"325": 5,
				"326": 1,
				"327": 1,
				"343": 5,
				"345": 5,
				"346": 5,
				"349": 5,
				"412": 1,
				"415": 1,
				"416": 1,
				"417": 1,
				"418": 1,
				"425": 1,
				"426": 10,
				"428": 1,
				"429": 1,
				"432": 1,
				"433": 1,
				"434": 1,
				"435": 1,
				"436": 1,
				"437": 1,
				"439": 1,
				"442": 1,
				"443": 1,
				"462": 1,
				"464": 1,
				"465": 3,
				"515": 1,
				"516": 1,
				"517": 1,
				"518": 1,
				"525": 1,
				"526": 10,
				"528": 1,
				"529": 5,
				"530": 5,
				"531": 5,
				"532": 1,
				"533": 1,
				"599": 1,
				"600": 1,
				"605": 3,
				"614": 3,
				"615": 3,
				"616": 3,
				"617": 1,
				"624": 1,
				"625": 1,
				"626": 1,
				"647": 1,
				"689": 1,
				"693": 1,
				"695": 1,
				"696": 3,
				"697": 3,
				"701": 1,
				"705": 1,
				"706": 1,
				"714": 1,
				"715": 3,
				"720": 3,
				"721": 3,
				"722": 3,
				"723": 3,
				"724": 1,
				"725": 1,
				"726": 1,
				"730": 1,
				"738": 7,
				"795": 1,
				"796": 1,
				"841": 1,
				"862": 1,
				"870": 1,
				"871": 1,
				"872": 1,
				"883": 1,
				"895": 1,
				"902": 1,
				"928": 1
			},
			"1": {
				"21": 2,
				"83": 1,
				"138": 5,
				"182": 5,
				"195": 5,
				"273": 5,
				"419": 1,
				"519": 1,
				"648": 1,
				"664": 1,
				"698": 1,
				"727": 1,
				"729": 1,
				"731": 1,
				"734": 1,
				"756": 1,
				"794": 1,
				"860": 1
			},
			"2": {
				"22": 2,
				"84": 1,
				"139": 5,
				"183": 5,
				"196": 5,
				"274": 5,
				"420": 1,
				"520": 1,
				"649": 1,
				"665": 1,
				"699": 1,
				"728": 1,
				"735": 1,
				"757": 1,
				"859": 1,
				"861": 1
			},
			"3": {
				"2": 2,
				"148": 5,
				"154": 5,
				"160": 5,
				"641": 1,
				"652": 1
			},
			"4": {
				"5": 2,
				"149": 5,
				"155": 5,
				"163": 5,
				"642": 1,
				"655": 1
			},
			"5": {
				"7": 2,
				"150": 5,
				"156": 5,
				"165": 5,
				"643": 1,
				"657": 1
			},
			"6": {
				"151": 5,
				"157": 5,
				"166": 5,
				"644": 1,
				"658": 1,
				"930": 2
			},
			"7": {
				"9": 2,
				"152": 5,
				"158": 5,
				"168": 5,
				"645": 1,
				"660": 1
			},
			"8": {
				"12": 2,
				"153": 5,
				"159": 5,
				"171": 5,
				"646": 1,
				"663": 1
			},
			"9": {
				"66": 2,
				"255": 5,
				"354": 5,
				"355": 5,
				"438": 1,
				"680": 1
			},
			"10": {
				"67": 2,
				"258": 5,
				"356": 5,
				"357": 5,
				"681": 1
			},
			"11": {
				"81": 2,
				"353": 5,
				"440": 1,
				"441": 1,
				"690": 1
			},
			"12": {
				"68": 2,
				"259": 5,
				"682": 1
			},
			"13": {
				"69": 2,
				"146": 5,
				"180": 5,
				"262": 5,
				"650": 1,
				"683": 1,
				"694": 1,
				"740": 1
			},
			"14": {
				"70": 2,
				"263": 5,
				"684": 1
			},
			"15": {
				"72": 2,
				"277": 5,
				"686": 1
			},
			"16": {
				"147": 5,
				"181": 5,
				"275": 5,
				"276": 5,
				"741": 1
			}
		},
		"8": {
			"0": {
				"74": 2,
				"103": 1,
				"256": 5,
				"306": 5,
				"349": 5,
				"443": 1,
				"599": 1,
				"647": 1,
				"689": 1
			},
			"1": {
				"195": 5,
				"664": 1
			},
			"2": {
				"196": 5,
				"665": 1
			},
			"3": {
				"197": 5,
				"666": 1
			},
			"4": {
				"198": 5,
				"667": 1
			}
		},
		"9": {
			"0": {
				"74": 2,
				"256": 5,
				"306": 5,
				"349": 5,
				"443": 1,
				"599": 1,
				"647": 1,
				"689": 1
			},
			"1": {
				"195": 5,
				"664": 1
			},
			"2": {
				"196": 5,
				"665": 1
			}
		},
		"10": {
			"0": {
				"1": 2,
				"74": 2,
				"103": 1,
				"256": 5,
				"306": 5,
				"349": 5,
				"403": 1,
				"443": 1,
				"599": 1
			}
		},
		"11": {
			"0": {
				"74": 2,
				"103": 1,
				"256": 5,
				"306": 5,
				"349": 5,
				"403": 1,
				"443": 1,
				"599": 1
			}
		},
		"12": {
			"0": {
				"74": 2,
				"103": 1,
				"256": 5,
				"306": 5,
				"349": 5,
				"443": 1,
				"599": 1,
				"647": 1,
				"689": 1
			}
		},
		"13": {
			"0": {
				"283": 1,
				"284": 1,
				"285": 1,
				"286": 1,
				"287": 1,
				"288": 1,
				"289": 1,
				"290": 1,
				"291": 1,
				"292": 1,
				"293": 1,
				"294": 1,
				"295": 1,
				"316": 1,
				"452": 1,
				"453": 1,
				"454": 1,
				"455": 1,
				"456": 1,
				"457": 1,
				"458": 1,
				"459": 1,
				"460": 1,
				"461": 1
			}
		},
		"14": {
			"0": {
				"443": 1,
				"599": 1
			}
		},
		"15": {
			"0": {
				"443": 1,
				"599": 1
			}
		},
		"16": {
			"0": {
				"443": 1,
				"599": 1
			}
		},
		"17": {
			"0": {
				"348": 5,
				"443": 1,
				"599": 1
			}
		},
		"18": {
			"0": {
				"65": 2,
				"74": 2,
				"253": 5,
				"256": 5,
				"306": 5,
				"349": 5,
				"350": 5,
				"443": 1,
				"599": 1,
				"601": 1,
				"606": 1,
				"647": 1,
				"679": 1,
				"689": 1,
				"742": 1,
				"797": 1,
				"880": 1,
				"884": 1,
				"895": 1
			},
			"1": {
				"21": 2,
				"195": 5,
				"664": 1,
				"698": 1,
				"734": 1
			},
			"2": {
				"22": 2,
				"196": 5,
				"665": 1,
				"699": 1,
				"735": 1
			},
			"3": {
				"23": 2,
				"197": 5,
				"666": 1,
				"700": 1,
				"736": 1
			}
		},
		"19": {
			"0": {
				"74": 2,
				"103": 1,
				"256": 5,
				"306": 5,
				"349": 5,
				"443": 1,
				"599": 1,
				"606": 1,
				"689": 1,
				"714": 1,
				"902": 1
			},
			"1": {
				"21": 2,
				"138": 5,
				"182": 5,
				"195": 5,
				"664": 1,
				"873": 1,
				"875": 1,
				"877": 1
			},
			"2": {
				"22": 2,
				"196": 5,
				"665": 1,
				"874": 1,
				"876": 1,
				"878": 1
			}
		},
		"20": {
			"0": {
				"74": 2,
				"256": 5,
				"306": 5,
				"349": 5,
				"443": 1,
				"599": 1,
				"689": 1
			},
			"1": {
				"21": 2,
				"138": 5,
				"182": 5,
				"195": 5,
				"664": 1,
				"851": 1
			},
			"2": {
				"22": 2,
				"139": 5,
				"183": 5,
				"196": 5,
				"665": 1,
				"852": 1
			},
			"3": {
				"23": 2,
				"140": 5,
				"184": 5,
				"197": 5,
				"666": 1,
				"853": 1
			},
			"4": {
				"24": 2,
				"141": 5,
				"185": 5,
				"198": 5,
				"667": 1,
				"854": 1
			},
			"5": {
				"25": 2,
				"142": 5,
				"186": 5,
				"199": 5,
				"668": 1,
				"855": 1
			},
			"6": {
				"26": 2,
				"143": 5,
				"187": 5,
				"200": 5,
				"669": 1,
				"856": 1
			},
			"7": {
				"27": 2,
				"144": 5,
				"188": 5,
				"201": 5,
				"670": 1,
				"857": 1
			},
			"8": {
				"28": 2,
				"145": 5,
				"189": 5,
				"202": 5,
				"671": 1,
				"858": 1
			}
		},
		"21": {
			"0": {
				"443": 1,
				"599": 1
			}
		},
		"23": {
			"0": {
				"443": 1,
				"599": 1
			}
		},
		"24": {
			"0": {
				"443": 1,
				"599": 1
			}
		},
		"25": {
			"0": {
				"443": 1,
				"599": 1
			}
		},
		"26": {
			"0": {
				"443": 1,
				"599": 1
			}
		},
		"27": {
			"0": {
				"443": 1,
				"599": 1
			}
		},
		"28": {
			"0": {
				"74": 2,
				"103": 1,
				"256": 5,
				"306": 5,
				"349": 5,
				"403": 1,
				"443": 1,
				"599": 1,
				"603": 1,
				"604": 1,
				"606": 1,
				"926": 1
			}
		},
		"29": {
			"0": {
				"74": 2,
				"254": 5,
				"349": 5,
				"403": 1,
				"443": 1,
				"599": 1
			},
			"1": {
				"21": 2,
				"83": 1,
				"195": 5,
				"366": 1,
				"466": 1,
				"557": 1,
				"799": 1
			},
			"2": {
				"22": 2,
				"84": 1,
				"196": 5,
				"367": 1,
				"467": 1,
				"558": 1,
				"800": 1
			},
			"3": {
				"23": 2,
				"85": 1,
				"197": 5,
				"368": 1,
				"468": 1,
				"559": 1,
				"801": 1
			},
			"4": {
				"24": 2,
				"86": 1,
				"198": 5,
				"369": 1,
				"469": 1,
				"560": 1,
				"802": 1
			},
			"5": {
				"25": 2,
				"87": 1,
				"199": 5,
				"370": 1,
				"470": 1,
				"561": 1,
				"803": 1
			},
			"6": {
				"26": 2,
				"88": 1,
				"200": 5,
				"371": 1,
				"471": 1,
				"562": 1,
				"804": 1
			},
			"7": {
				"27": 2,
				"89": 1,
				"201": 5,
				"372": 1,
				"472": 1,
				"563": 1,
				"805": 1
			},
			"8": {
				"28": 2,
				"90": 1,
				"202": 5,
				"373": 1,
				"473": 1,
				"564": 1,
				"806": 1
			},
			"9": {
				"29": 2,
				"91": 1,
				"203": 5,
				"374": 1,
				"474": 1,
				"565": 1,
				"807": 1
			},
			"10": {
				"30": 2,
				"92": 1,
				"204": 5,
				"375": 1,
				"475": 1,
				"566": 1,
				"808": 1
			},
			"11": {
				"31": 2,
				"93": 1,
				"205": 5,
				"376": 1,
				"476": 1,
				"567": 1,
				"809": 1
			},
			"12": {
				"32": 2,
				"94": 1,
				"206": 5,
				"377": 1,
				"477": 1,
				"568": 1,
				"810": 1
			},
			"13": {
				"33": 2,
				"95": 1,
				"207": 5,
				"378": 1,
				"478": 1,
				"569": 1,
				"811": 1
			},
			"14": {
				"34": 2,
				"96": 1,
				"208": 5,
				"379": 1,
				"479": 1,
				"570": 1,
				"812": 1
			},
			"15": {
				"35": 2,
				"97": 1,
				"209": 5,
				"380": 1,
				"480": 1,
				"571": 1,
				"813": 1
			},
			"16": {
				"36": 2,
				"98": 1,
				"210": 5,
				"381": 1,
				"481": 1,
				"572": 1,
				"814": 1
			},
			"17": {
				"37": 2,
				"99": 1,
				"211": 5,
				"382": 1,
				"482": 1,
				"573": 1,
				"815": 1
			},
			"18": {
				"38": 2,
				"100": 1,
				"212": 5,
				"383": 1,
				"483": 1,
				"574": 1,
				"816": 1
			},
			"19": {
				"39": 2,
				"101": 1,
				"213": 5,
				"384": 1,
				"484": 1,
				"575": 1,
				"817": 1
			},
			"20": {
				"40": 2,
				"104": 1,
				"214": 5,
				"385": 1,
				"485": 1,
				"576": 1,
				"818": 1
			},
			"21": {
				"41": 2,
				"105": 1,
				"215": 5,
				"386": 1,
				"486": 1,
				"577": 1,
				"819": 1
			},
			"22": {
				"42": 2,
				"106": 1,
				"216": 5,
				"387": 1,
				"487": 1,
				"578": 1,
				"820": 1
			},
			"23": {
				"43": 2,
				"107": 1,
				"217": 5,
				"388": 1,
				"488": 1,
				"579": 1,
				"821": 1
			},
			"24": {
				"44": 2,
				"108": 1,
				"218": 5,
				"389": 1,
				"489": 1,
				"580": 1,
				"822": 1
			},
			"25": {
				"45": 2,
				"109": 1,
				"219": 5,
				"390": 1,
				"490": 1,
				"581": 1,
				"823": 1
			},
			"26": {
				"46": 2,
				"110": 1,
				"220": 5,
				"391": 1,
				"491": 1,
				"582": 1,
				"824": 1
			},
			"27": {
				"47": 2,
				"111": 1,
				"221": 5,
				"392": 1,
				"492": 1,
				"583": 1,
				"825": 1
			},
			"28": {
				"48": 2,
				"112": 1,
				"222": 5,
				"393": 1,
				"493": 1,
				"584": 1,
				"826": 1
			},
			"29": {
				"49": 2,
				"113": 1,
				"223": 5,
				"394": 1,
				"494": 1,
				"585": 1,
				"827": 1
			},
			"30": {
				"50": 2,
				"114": 1,
				"224": 5,
				"395": 1,
				"495": 1,
				"586": 1,
				"828": 1
			},
			"31": {
				"51": 2,
				"115": 1,
				"225": 5,
				"396": 1,
				"496": 1,
				"587": 1,
				"829": 1
			},
			"32": {
				"52": 2,
				"116": 1,
				"226": 5,
				"397": 1,
				"497": 1,
				"588": 1,
				"830": 1
			},
			"33": {
				"53": 2,
				"117": 1,
				"227": 5,
				"398": 1,
				"498": 1,
				"589": 1,
				"831": 1
			},
			"34": {
				"54": 2,
				"118": 1,
				"228": 5,
				"399": 1,
				"499": 1,
				"590": 1,
				"832": 1
			},
			"35": {
				"55": 2,
				"119": 1,
				"229": 5,
				"400": 1,
				"500": 1,
				"591": 1,
				"833": 1
			},
			"36": {
				"56": 2,
				"120": 1,
				"230": 5,
				"401": 1,
				"501": 1,
				"592": 1,
				"834": 1
			},
			"37": {
				"57": 2,
				"121": 1,
				"231": 5,
				"402": 1,
				"502": 1,
				"593": 1,
				"835": 1
			}
		},
		"30": {
			"0": {
				"74": 2,
				"103": 1,
				"256": 5,
				"279": 5,
				"306": 5,
				"343": 5,
				"344": 5,
				"346": 5,
				"347": 5,
				"349": 5,
				"350": 5,
				"403": 1,
				"412": 1,
				"415": 1,
				"426": 1,
				"443": 1,
				"446": 1,
				"447": 1,
				"448": 1,
				"449": 1,
				"450": 1,
				"451": 1,
				"515": 1,
				"526": 1,
				"599": 1,
				"601": 1,
				"602": 1,
				"606": 1,
				"617": 1,
				"625": 1,
				"628": 1,
				"647": 1,
				"689": 1,
				"697": 1,
				"701": 1,
				"702": 1,
				"703": 1,
				"704": 1,
				"742": 1,
				"880": 1,
				"895": 1,
				"902": 1
			},
			"1": {
				"21": 2,
				"83": 1,
				"138": 5,
				"182": 5,
				"195": 5,
				"664": 1,
				"698": 1,
				"734": 1,
				"756": 1
			},
			"2": {
				"22": 2,
				"84": 1,
				"139": 5,
				"183": 5,
				"196": 5,
				"665": 1,
				"699": 1,
				"735": 1,
				"757": 1
			},
			"3": {
				"23": 2,
				"85": 1,
				"140": 5,
				"184": 5,
				"197": 5,
				"666": 1,
				"700": 1,
				"736": 1,
				"758": 1
			},
			"4": {
				"3": 2,
				"161": 5,
				"653": 1
			},
			"5": {
				"4": 2,
				"162": 5,
				"654": 1
			},
			"6": {
				"6": 2,
				"164": 5,
				"656": 1
			},
			"7": {
				"8": 2,
				"167": 5,
				"659": 1
			},
			"8": {
				"10": 2,
				"169": 5,
				"661": 1
			},
			"9": {
				"11": 2,
				"170": 5,
				"662": 1
			}
		},
		"31": {
			"0": {
				"60": 2,
				"74": 2,
				"103": 1,
				"137": 5,
				"242": 5,
				"243": 5,
				"244": 5,
				"245": 5,
				"247": 5,
				"256": 5,
				"280": 5,
				"281": 5,
				"306": 5,
				"317": 5,
				"349": 5,
				"403": 1,
				"404": 1,
				"407": 1,
				"408": 1,
				"421": 1,
				"422": 1,
				"423": 1,
				"424": 1,
				"443": 1,
				"444": 1,
				"465": 1,
				"521": 1,
				"522": 1,
				"523": 1,
				"524": 1,
				"599": 1,
				"628": 1,
				"637": 1,
				"674": 1,
				"691": 1,
				"764": 1,
				"773": 1,
				"774": 1,
				"779": 1,
				"879": 1,
				"881": 1
			},
			"1": {
				"21": 2,
				"138": 5,
				"182": 5,
				"195": 5,
				"629": 1,
				"633": 1,
				"664": 1,
				"765": 1,
				"769": 1,
				"775": 1
			},
			"2": {
				"22": 2,
				"139": 5,
				"183": 5,
				"196": 5,
				"630": 1,
				"634": 1,
				"665": 1,
				"766": 1,
				"770": 1,
				"776": 1
			},
			"3": {
				"23": 2,
				"140": 5,
				"184": 5,
				"197": 5,
				"631": 1,
				"635": 1,
				"666": 1,
				"767": 1,
				"771": 1,
				"777": 1
			},
			"4": {
				"24": 2,
				"141": 5,
				"185": 5,
				"198": 5,
				"632": 1,
				"636": 1,
				"667": 1,
				"768": 1,
				"772": 1,
				"778": 1
			},
			"5": {
				"62": 2,
				"233": 5,
				"241": 5,
				"248": 5,
				"406": 1,
				"676": 1
			},
			"6": {
				"61": 2,
				"232": 5,
				"240": 5,
				"246": 5,
				"405": 1,
				"675": 1
			},
			"7": {
				"58": 2,
				"234": 5,
				"236": 5,
				"238": 5,
				"672": 1
			},
			"8": {
				"59": 2,
				"235": 5,
				"237": 5,
				"239": 5,
				"673": 1
			}
		},
		"32": {
			"0": {
				"73": 2,
				"102": 1,
				"256": 5,
				"257": 5,
				"306": 5,
				"307": 5,
				"318": 5,
				"352": 5,
				"403": 1,
				"443": 1,
				"599": 1,
				"739": 1
			},
			"1": {
				"21": 2,
				"122": 1,
				"129": 1,
				"138": 5,
				"182": 5,
				"195": 5,
				"366": 1,
				"557": 1,
				"607": 1
			},
			"2": {
				"22": 2,
				"123": 1,
				"130": 1,
				"139": 5,
				"183": 5,
				"196": 5,
				"367": 1,
				"558": 1,
				"608": 1
			},
			"3": {
				"23": 2,
				"124": 1,
				"131": 1,
				"140": 5,
				"184": 5,
				"197": 5,
				"368": 1,
				"559": 1,
				"609": 1
			},
			"4": {
				"17": 2,
				"176": 5,
				"362": 1
			},
			"5": {
				"13": 2,
				"172": 5,
				"358": 1
			},
			"6": {
				"18": 2,
				"177": 5,
				"363": 1
			},
			"7": {
				"14": 2,
				"173": 5,
				"359": 1
			},
			"8": {
				"19": 2,
				"178": 5,
				"364": 1
			},
			"9": {
				"15": 2,
				"174": 5,
				"360": 1
			}
		},
		"33": {
			"0": {
				"348": 5,
				"443": 1,
				"599": 1
			}
		},
		"34": {
			"0": {
				"1": 2,
				"74": 2,
				"103": 1,
				"136": 5,
				"256": 5,
				"260": 1,
				"261": 1,
				"278": 1,
				"282": 5,
				"306": 5,
				"321": 5,
				"322": 5,
				"323": 5,
				"324": 5,
				"325": 5,
				"326": 1,
				"327": 1,
				"343": 5,
				"345": 5,
				"346": 5,
				"349": 5,
				"415": 1,
				"417": 1,
				"418": 1,
				"425": 1,
				"426": 1,
				"443": 1,
				"515": 1,
				"517": 1,
				"518": 1,
				"525": 1,
				"526": 1,
				"528": 1,
				"529": 5,
				"530": 1,
				"531": 1,
				"532": 1,
				"599": 1,
				"647": 1,
				"689": 1,
				"693": 1,
				"696": 1,
				"697": 1,
				"701": 1,
				"715": 1,
				"722": 1,
				"738": 7,
				"862": 1,
				"895": 1,
				"902": 1
			},
			"1": {
				"21": 2,
				"83": 1,
				"138": 5,
				"182": 5,
				"195": 5,
				"419": 1,
				"519": 1,
				"664": 1,
				"698": 1,
				"734": 1,
				"756": 1,
				"794": 1,
				"860": 1
			},
			"2": {
				"22": 2,
				"84": 1,
				"139": 5,
				"183": 5,
				"196": 5,
				"420": 1,
				"520": 1,
				"665": 1,
				"699": 1,
				"735": 1,
				"757": 1,
				"859": 1,
				"861": 1
			},
			"3": {
				"2": 2,
				"148": 5,
				"154": 5,
				"160": 5,
				"652": 1
			},
			"4": {
				"5": 2,
				"149": 5,
				"155": 5,
				"163": 5,
				"655": 1
			},
			"5": {
				"7": 2,
				"150": 5,
				"156": 5,
				"165": 5,
				"657": 1
			},
			"6": {
				"151": 5,
				"157": 5,
				"166": 5,
				"658": 1,
				"930": 2
			},
			"7": {
				"9": 2,
				"152": 5,
				"158": 5,
				"168": 5,
				"660": 1
			},
			"8": {
				"12": 2,
				"153": 5,
				"159": 5,
				"171": 5,
				"663": 1
			},
			"9": {
				"255": 5
			},
			"10": {
				"353": 5
			}
		},
		"35": {
			"0": {
				"74": 2,
				"256": 5,
				"306": 5,
				"349": 5,
				"426": 1,
				"443": 1,
				"526": 1,
				"599": 1,
				"647": 1,
				"689": 1,
				"701": 1,
				"722": 1,
				"733": 1,
				"862": 1,
				"902": 1
			},
			"1": {
				"21": 2,
				"138": 5,
				"182": 5,
				"195": 5,
				"664": 1
			}
		},
		"36": {
			"0": {
				"74": 2,
				"256": 5,
				"306": 5,
				"349": 5,
				"443": 1,
				"599": 1,
				"601": 1,
				"606": 1,
				"647": 1,
				"689": 1
			},
			"1": {
				"21": 2,
				"195": 5,
				"664": 1
			}
		},
		"37": {
			"0": {
				"443": 1,
				"599": 1
			}
		},
		"38": {
			"0": {
				"74": 2,
				"349": 5,
				"403": 1,
				"413": 1,
				"414": 1,
				"443": 1,
				"599": 1
			}
		},
		"39": {
			"0": {
				"403": 1,
				"443": 1,
				"599": 1
			}
		},
		"40": {
			"0": {
				"443": 1,
				"599": 1,
				"647": 1,
				"689": 1
			}
		},
		"41": {
			"0": {
				"74": 2,
				"103": 1,
				"137": 5,
				"251": 5,
				"252": 5,
				"256": 5,
				"281": 5,
				"306": 5,
				"349": 5,
				"403": 1,
				"409": 1,
				"410": 1,
				"411": 1,
				"430": 1,
				"431": 1,
				"628": 1,
				"692": 1,
				"784": 1,
				"787": 1
			},
			"1": {
				"21": 2,
				"138": 5,
				"182": 5,
				"195": 5,
				"639": 1,
				"664": 1,
				"780": 1,
				"782": 1,
				"785": 1
			},
			"2": {
				"22": 2,
				"139": 5,
				"183": 5,
				"196": 5,
				"640": 1,
				"665": 1,
				"781": 1,
				"783": 1,
				"786": 1
			},
			"3": {
				"64": 2,
				"250": 5,
				"678": 1
			},
			"4": {
				"63": 2,
				"249": 5,
				"677": 1
			}
		},
		"42": {
			"0": {
				"74": 2,
				"349": 5,
				"413": 3,
				"414": 1,
				"443": 1,
				"599": 1
			},
			"1": {
				"557": 1,
				"1865": 1
			},
			"2": {
				"558": 1,
				"1866": 1
			},
			"3": {
				"559": 1,
				"1867": 1
			},
			"4": {
				"560": 1,
				"1868": 1
			},
			"5": {
				"561": 1,
				"1869": 1
			}
		}
	};

/***/ },
/* 1827 */
/***/ function(module, exports) {

	module.exports = {
		"2": {
			"0": {
				"73": [
					73
				],
				"102": [
					102
				],
				"257": [
					257
				],
				"307": [
					307
				],
				"318": [
					318
				],
				"352": [
					352
				],
				"403": [
					403
				],
				"443": [
					443
				],
				"608": [
					599
				],
				"752": [
					743
				],
				"753": [
					744
				]
			},
			"1": {
				"21": [
					21
				],
				"83": [
					83
				],
				"122": [
					122
				],
				"129": [
					129
				],
				"138": [
					138
				],
				"182": [
					182
				],
				"195": [
					195
				],
				"366": [
					366
				],
				"566": [
					557
				],
				"616": [
					607
				],
				"872": [
					863
				],
				"894": [
					885
				]
			},
			"2": {
				"22": [
					22
				],
				"84": [
					84
				],
				"123": [
					123
				],
				"130": [
					130
				],
				"139": [
					139
				],
				"183": [
					183
				],
				"196": [
					196
				],
				"367": [
					367
				],
				"567": [
					558
				],
				"617": [
					608
				],
				"873": [
					864
				],
				"895": [
					886
				]
			},
			"3": {
				"23": [
					23
				],
				"85": [
					85
				],
				"124": [
					124
				],
				"131": [
					131
				],
				"140": [
					140
				],
				"184": [
					184
				],
				"197": [
					197
				],
				"368": [
					368
				],
				"568": [
					559
				],
				"618": [
					609
				],
				"874": [
					865
				],
				"896": [
					887
				]
			},
			"4": {
				"24": [
					24
				],
				"86": [
					86
				],
				"125": [
					125
				],
				"132": [
					132
				],
				"141": [
					141
				],
				"185": [
					185
				],
				"198": [
					198
				],
				"369": [
					369
				],
				"569": [
					560
				],
				"619": [
					610
				],
				"875": [
					866
				],
				"897": [
					888
				]
			},
			"5": {
				"25": [
					25
				],
				"87": [
					87
				],
				"126": [
					126
				],
				"133": [
					133
				],
				"142": [
					142
				],
				"186": [
					186
				],
				"199": [
					199
				],
				"370": [
					370
				],
				"570": [
					561
				],
				"620": [
					611
				],
				"876": [
					867
				],
				"898": [
					889
				]
			},
			"6": {
				"26": [
					26
				],
				"88": [
					88
				],
				"127": [
					127
				],
				"134": [
					134
				],
				"143": [
					143
				],
				"187": [
					187
				],
				"200": [
					200
				],
				"371": [
					371
				],
				"571": [
					562
				],
				"621": [
					612
				],
				"877": [
					868
				],
				"899": [
					890
				]
			},
			"7": {
				"27": [
					27
				],
				"89": [
					89
				],
				"128": [
					128
				],
				"135": [
					135
				],
				"144": [
					144
				],
				"188": [
					188
				],
				"201": [
					201
				],
				"372": [
					372
				],
				"572": [
					563
				],
				"622": [
					613
				],
				"878": [
					869
				],
				"900": [
					891
				]
			}
		},
		"3": {
			"0": {
				"73": [
					73
				],
				"74": [
					74
				],
				"102": [
					102
				],
				"257": [
					257
				],
				"307": [
					307
				],
				"318": [
					318
				],
				"352": [
					352
				],
				"403": [
					403
				],
				"443": [
					443
				],
				"608": [
					599
				],
				"746": [
					737
				],
				"891": [
					882
				]
			},
			"1": {
				"21": [
					21
				],
				"83": [
					83
				],
				"138": [
					138
				],
				"182": [
					182
				],
				"195": [
					195
				],
				"366": [
					366
				],
				"566": [
					557
				],
				"616": [
					607
				],
				"797": [
					788
				],
				"800": [
					791
				],
				"851": [
					842
				],
				"854": [
					845
				],
				"857": [
					848
				],
				"905": [
					896
				]
			},
			"2": {
				"22": [
					22
				],
				"84": [
					84
				],
				"139": [
					139
				],
				"183": [
					183
				],
				"196": [
					196
				],
				"367": [
					367
				],
				"567": [
					558
				],
				"617": [
					608
				],
				"798": [
					789
				],
				"801": [
					792
				],
				"852": [
					843
				],
				"855": [
					846
				],
				"858": [
					849
				],
				"906": [
					897
				]
			},
			"3": {
				"23": [
					23
				],
				"85": [
					85
				],
				"140": [
					140
				],
				"184": [
					184
				],
				"197": [
					197
				],
				"368": [
					368
				],
				"568": [
					559
				],
				"618": [
					609
				],
				"799": [
					790
				],
				"802": [
					793
				],
				"853": [
					844
				],
				"856": [
					847
				],
				"859": [
					850
				],
				"907": [
					898
				]
			},
			"4": {
				"17": [
					17
				],
				"176": [
					176
				],
				"362": [
					362
				]
			},
			"5": {
				"13": [
					13
				],
				"172": [
					172
				],
				"358": [
					358
				]
			},
			"6": {
				"18": [
					18
				],
				"177": [
					177
				],
				"363": [
					363
				]
			},
			"7": {
				"14": [
					14
				],
				"173": [
					173
				],
				"359": [
					359
				]
			}
		},
		"4": {
			"0": {
				"73": [
					73
				],
				"74": [
					74
				],
				"102": [
					102
				],
				"137": [
					137
				],
				"257": [
					257
				],
				"281": [
					281
				],
				"307": [
					307
				],
				"318": [
					318
				],
				"319": [
					319
				],
				"320": [
					320
				],
				"352": [
					352
				],
				"403": [
					403
				],
				"443": [
					443
				],
				"608": [
					599
				],
				"764": [
					755
				],
				"807": [
					798
				],
				"891": [
					882
				],
				"936": [
					927
				]
			},
			"1": {
				"21": [
					21
				],
				"83": [
					83
				],
				"138": [
					138
				],
				"182": [
					182
				],
				"195": [
					195
				],
				"366": [
					366
				],
				"566": [
					557
				],
				"616": [
					607
				],
				"845": [
					836
				],
				"905": [
					896
				],
				"912": [
					903
				],
				"918": [
					909
				],
				"923": [
					914
				],
				"929": [
					920
				]
			},
			"2": {
				"22": [
					22
				],
				"84": [
					84
				],
				"139": [
					139
				],
				"183": [
					183
				],
				"196": [
					196
				],
				"367": [
					367
				],
				"567": [
					558
				],
				"617": [
					608
				],
				"846": [
					837
				],
				"906": [
					897
				],
				"913": [
					904
				],
				"919": [
					910
				],
				"924": [
					915
				],
				"930": [
					921
				]
			},
			"3": {
				"23": [
					23
				],
				"85": [
					85
				],
				"140": [
					140
				],
				"184": [
					184
				],
				"197": [
					197
				],
				"368": [
					368
				],
				"568": [
					559
				],
				"618": [
					609
				],
				"847": [
					838
				],
				"907": [
					898
				],
				"914": [
					905
				],
				"920": [
					911
				],
				"925": [
					916
				],
				"931": [
					922
				]
			},
			"4": {
				"24": [
					24
				],
				"86": [
					86
				],
				"141": [
					141
				],
				"185": [
					185
				],
				"198": [
					198
				],
				"369": [
					369
				],
				"569": [
					560
				],
				"619": [
					610
				],
				"848": [
					839
				],
				"908": [
					899
				],
				"915": [
					906
				],
				"921": [
					912
				],
				"926": [
					917
				],
				"932": [
					923
				]
			},
			"5": {
				"25": [
					25
				],
				"87": [
					87
				],
				"142": [
					142
				],
				"186": [
					186
				],
				"199": [
					199
				],
				"370": [
					370
				],
				"570": [
					561
				],
				"620": [
					611
				],
				"849": [
					840
				],
				"909": [
					900
				],
				"916": [
					907
				],
				"922": [
					913
				],
				"927": [
					918
				],
				"933": [
					924
				]
			},
			"6": {
				"26": [
					26
				],
				"88": [
					88
				],
				"143": [
					143
				],
				"187": [
					187
				],
				"200": [
					200
				],
				"371": [
					371
				],
				"571": [
					562
				],
				"910": [
					901
				],
				"917": [
					908
				],
				"928": [
					919
				],
				"934": [
					925
				]
			},
			"7": {
				"17": [
					17
				],
				"176": [
					176
				],
				"362": [
					362
				]
			},
			"8": {
				"13": [
					13
				],
				"172": [
					172
				],
				"358": [
					358
				]
			},
			"9": {
				"18": [
					18
				],
				"177": [
					177
				],
				"363": [
					363
				]
			},
			"10": {
				"14": [
					14
				],
				"173": [
					173
				],
				"359": [
					359
				]
			},
			"11": {
				"19": [
					19
				],
				"178": [
					178
				],
				"364": [
					364
				]
			},
			"12": {
				"15": [
					15
				],
				"174": [
					174
				],
				"360": [
					360
				]
			},
			"13": {
				"20": [
					20
				],
				"179": [
					179
				],
				"365": [
					365
				]
			},
			"14": {
				"16": [
					16
				],
				"175": [
					175
				],
				"361": [
					361
				]
			}
		},
		"5": {
			"0": {
				"349": [
					349
				],
				"443": [
					443
				],
				"608": [
					599
				],
				"698": [
					689
				]
			}
		},
		"6": {
			"0": {
				"73": [
					73
				],
				"82": [
					82
				],
				"102": [
					102
				],
				"257": [
					257
				],
				"296": [
					296
				],
				"297": [
					297
				],
				"298": [
					298
				],
				"299": [
					299
				],
				"305": [
					305
				],
				"307": [
					307
				],
				"308": [
					308
				],
				"309": [
					309
				],
				"315": [
					315
				],
				"318": [
					318
				],
				"320": [
					320
				],
				"328": [
					328
				],
				"329": [
					329
				],
				"330": [
					330
				],
				"331": [
					331
				],
				"332": [
					332
				],
				"337": [
					337
				],
				"338": [
					338
				],
				"339": [
					339
				],
				"340": [
					340
				],
				"341": [
					341
				],
				"342": [
					342
				],
				"352": [
					352
				],
				"403": [
					403
				],
				"427": [
					427
				],
				"443": [
					443
				],
				"445": [
					445
				],
				"455": [
					1861
				],
				"456": [
					1861
				],
				"457": [
					1861
				],
				"458": [
					1861
				],
				"459": [
					1861
				],
				"460": [
					1861
				],
				"512": [
					1871
				],
				"513": [
					1871
				],
				"514": [
					505
				],
				"515": [
					506
				],
				"516": [
					507
				],
				"522": [
					513
				],
				"523": [
					514
				],
				"536": [
					527
				],
				"543": [
					534
				],
				"544": [
					535
				],
				"545": [
					536
				],
				"546": [
					537
				],
				"547": [
					538
				],
				"548": [
					539
				],
				"549": [
					540
				],
				"550": [
					1870
				],
				"551": [
					1870
				],
				"552": [
					543
				],
				"553": [
					544
				],
				"559": [
					550
				],
				"560": [
					551
				],
				"608": [
					599
				],
				"632": [
					623
				],
				"636": [
					627
				],
				"647": [
					638
				],
				"696": [
					687
				],
				"697": [
					688
				],
				"722": [
					713
				],
				"741": [
					732
				],
				"748": [
					739
				],
				"807": [
					798
				],
				"901": [
					1872
				],
				"902": [
					1872
				],
				"903": [
					894
				]
			},
			"1": {
				"21": [
					21
				],
				"76": [
					76
				],
				"83": [
					83
				],
				"138": [
					138
				],
				"182": [
					182
				],
				"190": [
					190
				],
				"195": [
					195
				],
				"300": [
					300
				],
				"310": [
					310
				],
				"333": [
					333
				],
				"366": [
					366
				],
				"517": [
					508
				],
				"554": [
					545
				],
				"561": [
					552
				],
				"566": [
					557
				],
				"603": [
					594
				],
				"627": [
					618
				],
				"717": [
					708
				],
				"754": [
					745
				],
				"759": [
					750
				],
				"768": [
					759
				],
				"905": [
					896
				]
			},
			"2": {
				"22": [
					22
				],
				"77": [
					77
				],
				"84": [
					84
				],
				"139": [
					139
				],
				"183": [
					183
				],
				"191": [
					191
				],
				"196": [
					196
				],
				"301": [
					301
				],
				"311": [
					311
				],
				"334": [
					334
				],
				"367": [
					367
				],
				"518": [
					509
				],
				"555": [
					546
				],
				"562": [
					553
				],
				"567": [
					558
				],
				"604": [
					595
				],
				"628": [
					619
				],
				"718": [
					709
				],
				"755": [
					746
				],
				"760": [
					751
				],
				"769": [
					760
				],
				"906": [
					897
				]
			},
			"3": {
				"23": [
					23
				],
				"78": [
					78
				],
				"85": [
					85
				],
				"140": [
					140
				],
				"184": [
					184
				],
				"192": [
					192
				],
				"197": [
					197
				],
				"302": [
					302
				],
				"312": [
					312
				],
				"335": [
					335
				],
				"368": [
					368
				],
				"519": [
					510
				],
				"556": [
					547
				],
				"563": [
					554
				],
				"568": [
					559
				],
				"605": [
					596
				],
				"629": [
					620
				],
				"719": [
					710
				],
				"756": [
					747
				],
				"761": [
					752
				],
				"770": [
					761
				],
				"907": [
					898
				]
			},
			"4": {
				"24": [
					24
				],
				"79": [
					79
				],
				"86": [
					86
				],
				"141": [
					141
				],
				"185": [
					185
				],
				"193": [
					193
				],
				"198": [
					198
				],
				"303": [
					303
				],
				"313": [
					313
				],
				"336": [
					336
				],
				"369": [
					369
				],
				"520": [
					511
				],
				"557": [
					548
				],
				"564": [
					555
				],
				"569": [
					560
				],
				"606": [
					597
				],
				"630": [
					621
				],
				"720": [
					711
				],
				"757": [
					748
				],
				"762": [
					753
				],
				"771": [
					762
				],
				"908": [
					899
				]
			},
			"5": {
				"25": [
					25
				],
				"80": [
					80
				],
				"87": [
					87
				],
				"142": [
					142
				],
				"186": [
					186
				],
				"194": [
					194
				],
				"199": [
					199
				],
				"304": [
					304
				],
				"314": [
					314
				],
				"370": [
					370
				],
				"521": [
					512
				],
				"558": [
					549
				],
				"565": [
					556
				],
				"570": [
					561
				],
				"607": [
					598
				],
				"631": [
					622
				],
				"721": [
					712
				],
				"758": [
					749
				],
				"763": [
					754
				],
				"772": [
					763
				],
				"909": [
					900
				]
			}
		},
		"7": {
			"0": {
				"1": [
					1
				],
				"74": [
					74
				],
				"103": [
					103
				],
				"136": [
					136
				],
				"137": [
					137
				],
				"256": [
					256
				],
				"260": [
					260
				],
				"261": [
					261
				],
				"278": [
					278
				],
				"281": [
					281
				],
				"282": [
					282
				],
				"306": [
					306
				],
				"321": [
					321
				],
				"322": [
					322
				],
				"323": [
					323
				],
				"324": [
					324
				],
				"325": [
					325
				],
				"326": [
					326
				],
				"327": [
					327
				],
				"343": [
					343
				],
				"345": [
					345
				],
				"346": [
					346
				],
				"349": [
					349
				],
				"412": [
					412
				],
				"415": [
					415
				],
				"416": [
					416
				],
				"417": [
					417
				],
				"418": [
					418
				],
				"425": [
					425
				],
				"426": [
					426
				],
				"428": [
					428
				],
				"429": [
					429
				],
				"432": [
					432
				],
				"433": [
					433
				],
				"434": [
					434
				],
				"435": [
					435
				],
				"436": [
					436
				],
				"437": [
					437
				],
				"439": [
					439
				],
				"442": [
					442
				],
				"443": [
					443
				],
				"471": [
					462
				],
				"473": [
					464
				],
				"474": [
					465
				],
				"524": [
					515
				],
				"525": [
					516
				],
				"526": [
					517
				],
				"527": [
					518
				],
				"534": [
					525
				],
				"535": [
					526
				],
				"537": [
					528
				],
				"538": [
					529
				],
				"539": [
					530
				],
				"540": [
					531
				],
				"541": [
					532
				],
				"542": [
					533
				],
				"608": [
					599
				],
				"609": [
					600
				],
				"614": [
					605
				],
				"623": [
					614
				],
				"624": [
					615
				],
				"625": [
					616
				],
				"626": [
					617
				],
				"633": [
					624
				],
				"634": [
					625
				],
				"635": [
					626
				],
				"656": [
					647
				],
				"698": [
					689
				],
				"702": [
					693
				],
				"704": [
					695
				],
				"705": [
					696
				],
				"706": [
					697
				],
				"710": [
					701
				],
				"714": [
					705
				],
				"715": [
					706
				],
				"723": [
					714
				],
				"724": [
					715
				],
				"729": [
					720
				],
				"730": [
					721
				],
				"731": [
					722
				],
				"732": [
					723
				],
				"733": [
					724
				],
				"734": [
					725
				],
				"735": [
					726
				],
				"739": [
					730
				],
				"747": [
					738
				],
				"804": [
					795
				],
				"805": [
					796
				],
				"850": [
					841
				],
				"871": [
					862
				],
				"879": [
					870
				],
				"880": [
					871
				],
				"881": [
					872
				],
				"892": [
					883
				],
				"904": [
					895
				],
				"911": [
					902
				],
				"937": [
					928
				]
			},
			"1": {
				"21": [
					21
				],
				"83": [
					83
				],
				"138": [
					138
				],
				"182": [
					182
				],
				"195": [
					195
				],
				"273": [
					273
				],
				"419": [
					419
				],
				"528": [
					519
				],
				"657": [
					648
				],
				"673": [
					664
				],
				"707": [
					698
				],
				"736": [
					727
				],
				"738": [
					729
				],
				"740": [
					731
				],
				"743": [
					734
				],
				"765": [
					756
				],
				"803": [
					794
				],
				"869": [
					860
				]
			},
			"2": {
				"22": [
					22
				],
				"84": [
					84
				],
				"139": [
					139
				],
				"183": [
					183
				],
				"196": [
					196
				],
				"274": [
					274
				],
				"420": [
					420
				],
				"529": [
					520
				],
				"658": [
					649
				],
				"674": [
					665
				],
				"708": [
					699
				],
				"737": [
					728
				],
				"744": [
					735
				],
				"766": [
					757
				],
				"868": [
					859
				],
				"870": [
					861
				]
			},
			"3": {
				"2": [
					2
				],
				"148": [
					148
				],
				"154": [
					154
				],
				"160": [
					160
				],
				"650": [
					641
				],
				"661": [
					652
				]
			},
			"4": {
				"5": [
					5
				],
				"149": [
					149
				],
				"155": [
					155
				],
				"163": [
					163
				],
				"651": [
					642
				],
				"664": [
					655
				]
			},
			"5": {
				"7": [
					7
				],
				"150": [
					150
				],
				"156": [
					156
				],
				"165": [
					165
				],
				"652": [
					643
				],
				"666": [
					657
				]
			},
			"6": {
				"151": [
					151
				],
				"157": [
					157
				],
				"166": [
					166
				],
				"653": [
					644
				],
				"667": [
					658
				],
				"939": [
					930
				]
			},
			"7": {
				"9": [
					9
				],
				"152": [
					152
				],
				"158": [
					158
				],
				"168": [
					168
				],
				"654": [
					645
				],
				"669": [
					660
				]
			},
			"8": {
				"12": [
					12
				],
				"153": [
					153
				],
				"159": [
					159
				],
				"171": [
					171
				],
				"655": [
					646
				],
				"672": [
					663
				]
			},
			"9": {
				"66": [
					66
				],
				"255": [
					255
				],
				"354": [
					354
				],
				"355": [
					355
				],
				"438": [
					438
				],
				"689": [
					680
				]
			},
			"10": {
				"67": [
					67
				],
				"258": [
					258
				],
				"356": [
					356
				],
				"357": [
					357
				],
				"690": [
					681
				]
			},
			"11": {
				"81": [
					81
				],
				"353": [
					353
				],
				"440": [
					440
				],
				"441": [
					441
				],
				"699": [
					690
				]
			},
			"12": {
				"68": [
					68
				],
				"259": [
					259
				],
				"691": [
					682
				]
			},
			"13": {
				"69": [
					69
				],
				"146": [
					146
				],
				"180": [
					180
				],
				"262": [
					262
				],
				"659": [
					650
				],
				"692": [
					683
				],
				"703": [
					694
				],
				"749": [
					740
				]
			},
			"14": {
				"70": [
					70
				],
				"263": [
					263
				],
				"693": [
					684
				]
			},
			"15": {
				"72": [
					72
				],
				"277": [
					277
				],
				"695": [
					686
				]
			},
			"16": {
				"147": [
					147
				],
				"181": [
					181
				],
				"275": [
					275
				],
				"276": [
					276
				],
				"750": [
					741
				]
			}
		},
		"8": {
			"0": {
				"74": [
					74
				],
				"103": [
					103
				],
				"256": [
					256
				],
				"306": [
					306
				],
				"349": [
					349
				],
				"443": [
					443
				],
				"608": [
					599
				],
				"656": [
					647
				],
				"698": [
					689
				]
			},
			"1": {
				"195": [
					195
				],
				"673": [
					664
				]
			},
			"2": {
				"196": [
					196
				],
				"674": [
					665
				]
			},
			"3": {
				"197": [
					197
				],
				"675": [
					666
				]
			},
			"4": {
				"198": [
					198
				],
				"676": [
					667
				]
			}
		},
		"9": {
			"0": {
				"74": [
					74
				],
				"256": [
					256
				],
				"306": [
					306
				],
				"349": [
					349
				],
				"443": [
					443
				],
				"608": [
					599
				],
				"656": [
					647
				],
				"698": [
					689
				]
			},
			"1": {
				"195": [
					195
				],
				"673": [
					664
				]
			},
			"2": {
				"196": [
					196
				],
				"674": [
					665
				]
			}
		},
		"10": {
			"0": {
				"1": [
					1
				],
				"74": [
					74
				],
				"103": [
					103
				],
				"256": [
					256
				],
				"306": [
					306
				],
				"349": [
					349
				],
				"403": [
					403
				],
				"443": [
					443
				],
				"608": [
					599
				]
			}
		},
		"11": {
			"0": {
				"74": [
					74
				],
				"103": [
					103
				],
				"256": [
					256
				],
				"306": [
					306
				],
				"349": [
					349
				],
				"403": [
					403
				],
				"443": [
					443
				],
				"608": [
					599
				]
			}
		},
		"12": {
			"0": {
				"74": [
					74
				],
				"103": [
					103
				],
				"256": [
					256
				],
				"306": [
					306
				],
				"349": [
					349
				],
				"443": [
					443
				],
				"608": [
					599
				],
				"656": [
					647
				],
				"698": [
					689
				]
			}
		},
		"13": {
			"0": {
				"283": [
					283
				],
				"284": [
					284
				],
				"285": [
					285
				],
				"286": [
					286
				],
				"287": [
					287
				],
				"288": [
					288
				],
				"289": [
					289
				],
				"290": [
					290
				],
				"291": [
					291
				],
				"292": [
					292
				],
				"293": [
					293
				],
				"294": [
					294
				],
				"295": [
					295
				],
				"316": [
					316
				],
				"461": [
					452
				],
				"462": [
					453
				],
				"463": [
					454
				],
				"464": [
					455
				],
				"465": [
					456
				],
				"466": [
					457
				],
				"467": [
					458
				],
				"468": [
					459
				],
				"469": [
					460
				],
				"470": [
					461
				]
			}
		},
		"14": {
			"0": {
				"443": [
					443
				],
				"608": [
					599
				]
			}
		},
		"15": {
			"0": {
				"443": [
					443
				],
				"608": [
					599
				]
			}
		},
		"16": {
			"0": {
				"443": [
					443
				],
				"608": [
					599
				]
			}
		},
		"17": {
			"0": {
				"348": [
					348
				],
				"443": [
					443
				],
				"608": [
					599
				]
			}
		},
		"18": {
			"0": {
				"65": [
					65
				],
				"74": [
					74
				],
				"253": [
					253
				],
				"256": [
					256
				],
				"306": [
					306
				],
				"349": [
					349
				],
				"350": [
					350
				],
				"443": [
					443
				],
				"608": [
					599
				],
				"610": [
					601
				],
				"615": [
					606
				],
				"656": [
					647
				],
				"688": [
					679
				],
				"698": [
					689
				],
				"751": [
					742
				],
				"806": [
					797
				],
				"889": [
					880
				],
				"893": [
					884
				],
				"904": [
					895
				]
			},
			"1": {
				"21": [
					21
				],
				"195": [
					195
				],
				"673": [
					664
				],
				"707": [
					698
				],
				"743": [
					734
				]
			},
			"2": {
				"22": [
					22
				],
				"196": [
					196
				],
				"674": [
					665
				],
				"708": [
					699
				],
				"744": [
					735
				]
			},
			"3": {
				"23": [
					23
				],
				"197": [
					197
				],
				"675": [
					666
				],
				"709": [
					700
				],
				"745": [
					736
				]
			}
		},
		"19": {
			"0": {
				"74": [
					74
				],
				"103": [
					103
				],
				"256": [
					256
				],
				"306": [
					306
				],
				"349": [
					349
				],
				"443": [
					443
				],
				"608": [
					599
				],
				"615": [
					606
				],
				"698": [
					689
				],
				"723": [
					714
				],
				"911": [
					902
				]
			},
			"1": {
				"21": [
					21
				],
				"138": [
					138
				],
				"182": [
					182
				],
				"195": [
					195
				],
				"673": [
					664
				],
				"882": [
					873
				],
				"884": [
					875
				],
				"886": [
					877
				]
			},
			"2": {
				"22": [
					22
				],
				"196": [
					196
				],
				"674": [
					665
				],
				"883": [
					874
				],
				"885": [
					876
				],
				"887": [
					878
				]
			}
		},
		"20": {
			"0": {
				"74": [
					74
				],
				"256": [
					256
				],
				"306": [
					306
				],
				"349": [
					349
				],
				"443": [
					443
				],
				"608": [
					599
				],
				"698": [
					689
				]
			},
			"1": {
				"21": [
					21
				],
				"138": [
					138
				],
				"182": [
					182
				],
				"195": [
					195
				],
				"673": [
					664
				],
				"860": [
					851
				]
			},
			"2": {
				"22": [
					22
				],
				"139": [
					139
				],
				"183": [
					183
				],
				"196": [
					196
				],
				"674": [
					665
				],
				"861": [
					852
				]
			},
			"3": {
				"23": [
					23
				],
				"140": [
					140
				],
				"184": [
					184
				],
				"197": [
					197
				],
				"675": [
					666
				],
				"862": [
					853
				]
			},
			"4": {
				"24": [
					24
				],
				"141": [
					141
				],
				"185": [
					185
				],
				"198": [
					198
				],
				"676": [
					667
				],
				"863": [
					854
				]
			},
			"5": {
				"25": [
					25
				],
				"142": [
					142
				],
				"186": [
					186
				],
				"199": [
					199
				],
				"677": [
					668
				],
				"864": [
					855
				]
			},
			"6": {
				"26": [
					26
				],
				"143": [
					143
				],
				"187": [
					187
				],
				"200": [
					200
				],
				"678": [
					669
				],
				"865": [
					856
				]
			},
			"7": {
				"27": [
					27
				],
				"144": [
					144
				],
				"188": [
					188
				],
				"201": [
					201
				],
				"679": [
					670
				],
				"866": [
					857
				]
			},
			"8": {
				"28": [
					28
				],
				"145": [
					145
				],
				"189": [
					189
				],
				"202": [
					202
				],
				"680": [
					671
				],
				"867": [
					858
				]
			}
		},
		"21": {
			"0": {
				"443": [
					443
				],
				"608": [
					599
				]
			}
		},
		"23": {
			"0": {
				"443": [
					443
				],
				"608": [
					599
				]
			}
		},
		"24": {
			"0": {
				"443": [
					443
				],
				"608": [
					599
				]
			}
		},
		"25": {
			"0": {
				"443": [
					443
				],
				"608": [
					599
				]
			}
		},
		"26": {
			"0": {
				"443": [
					443
				],
				"608": [
					599
				]
			}
		},
		"27": {
			"0": {
				"443": [
					443
				],
				"608": [
					599
				]
			}
		},
		"28": {
			"0": {
				"74": [
					74
				],
				"103": [
					103
				],
				"256": [
					256
				],
				"306": [
					306
				],
				"349": [
					349
				],
				"403": [
					403
				],
				"443": [
					443
				],
				"608": [
					599
				],
				"612": [
					603
				],
				"613": [
					604
				],
				"615": [
					606
				],
				"935": [
					926
				]
			}
		},
		"29": {
			"0": {
				"74": [
					74
				],
				"254": [
					254
				],
				"349": [
					349
				],
				"403": [
					403
				],
				"443": [
					443
				],
				"608": [
					599
				]
			},
			"1": {
				"21": [
					21
				],
				"83": [
					83
				],
				"195": [
					195
				],
				"366": [
					366
				],
				"475": [
					466
				],
				"566": [
					557
				],
				"808": [
					799
				]
			},
			"2": {
				"22": [
					22
				],
				"84": [
					84
				],
				"196": [
					196
				],
				"367": [
					367
				],
				"476": [
					467
				],
				"567": [
					558
				],
				"809": [
					800
				]
			},
			"3": {
				"23": [
					23
				],
				"85": [
					85
				],
				"197": [
					197
				],
				"368": [
					368
				],
				"477": [
					468
				],
				"568": [
					559
				],
				"810": [
					801
				]
			},
			"4": {
				"24": [
					24
				],
				"86": [
					86
				],
				"198": [
					198
				],
				"369": [
					369
				],
				"478": [
					469
				],
				"569": [
					560
				],
				"811": [
					802
				]
			},
			"5": {
				"25": [
					25
				],
				"87": [
					87
				],
				"199": [
					199
				],
				"370": [
					370
				],
				"479": [
					470
				],
				"570": [
					561
				],
				"812": [
					803
				]
			},
			"6": {
				"26": [
					26
				],
				"88": [
					88
				],
				"200": [
					200
				],
				"371": [
					371
				],
				"480": [
					471
				],
				"571": [
					562
				],
				"813": [
					804
				]
			},
			"7": {
				"27": [
					27
				],
				"89": [
					89
				],
				"201": [
					201
				],
				"372": [
					372
				],
				"481": [
					472
				],
				"572": [
					563
				],
				"814": [
					805
				]
			},
			"8": {
				"28": [
					28
				],
				"90": [
					90
				],
				"202": [
					202
				],
				"373": [
					373
				],
				"482": [
					473
				],
				"573": [
					564
				],
				"815": [
					806
				]
			},
			"9": {
				"29": [
					29
				],
				"91": [
					91
				],
				"203": [
					203
				],
				"374": [
					374
				],
				"483": [
					474
				],
				"574": [
					565
				],
				"816": [
					807
				]
			},
			"10": {
				"30": [
					30
				],
				"92": [
					92
				],
				"204": [
					204
				],
				"375": [
					375
				],
				"484": [
					475
				],
				"575": [
					566
				],
				"817": [
					808
				]
			},
			"11": {
				"31": [
					31
				],
				"93": [
					93
				],
				"205": [
					205
				],
				"376": [
					376
				],
				"485": [
					476
				],
				"576": [
					567
				],
				"818": [
					809
				]
			},
			"12": {
				"32": [
					32
				],
				"94": [
					94
				],
				"206": [
					206
				],
				"377": [
					377
				],
				"486": [
					477
				],
				"577": [
					568
				],
				"819": [
					810
				]
			},
			"13": {
				"33": [
					33
				],
				"95": [
					95
				],
				"207": [
					207
				],
				"378": [
					378
				],
				"487": [
					478
				],
				"578": [
					569
				],
				"820": [
					811
				]
			},
			"14": {
				"34": [
					34
				],
				"96": [
					96
				],
				"208": [
					208
				],
				"379": [
					379
				],
				"488": [
					479
				],
				"579": [
					570
				],
				"821": [
					812
				]
			},
			"15": {
				"35": [
					35
				],
				"97": [
					97
				],
				"209": [
					209
				],
				"380": [
					380
				],
				"489": [
					480
				],
				"580": [
					571
				],
				"822": [
					813
				]
			},
			"16": {
				"36": [
					36
				],
				"98": [
					98
				],
				"210": [
					210
				],
				"381": [
					381
				],
				"490": [
					481
				],
				"581": [
					572
				],
				"823": [
					814
				]
			},
			"17": {
				"37": [
					37
				],
				"99": [
					99
				],
				"211": [
					211
				],
				"382": [
					382
				],
				"491": [
					482
				],
				"582": [
					573
				],
				"824": [
					815
				]
			},
			"18": {
				"38": [
					38
				],
				"100": [
					100
				],
				"212": [
					212
				],
				"383": [
					383
				],
				"492": [
					483
				],
				"583": [
					574
				],
				"825": [
					816
				]
			},
			"19": {
				"39": [
					39
				],
				"101": [
					101
				],
				"213": [
					213
				],
				"384": [
					384
				],
				"493": [
					484
				],
				"584": [
					575
				],
				"826": [
					817
				]
			},
			"20": {
				"40": [
					40
				],
				"104": [
					104
				],
				"214": [
					214
				],
				"385": [
					385
				],
				"494": [
					485
				],
				"585": [
					576
				],
				"827": [
					818
				]
			},
			"21": {
				"41": [
					41
				],
				"105": [
					105
				],
				"215": [
					215
				],
				"386": [
					386
				],
				"495": [
					486
				],
				"586": [
					577
				],
				"828": [
					819
				]
			},
			"22": {
				"42": [
					42
				],
				"106": [
					106
				],
				"216": [
					216
				],
				"387": [
					387
				],
				"496": [
					487
				],
				"587": [
					578
				],
				"829": [
					820
				]
			},
			"23": {
				"43": [
					43
				],
				"107": [
					107
				],
				"217": [
					217
				],
				"388": [
					388
				],
				"497": [
					488
				],
				"588": [
					579
				],
				"830": [
					821
				]
			},
			"24": {
				"44": [
					44
				],
				"108": [
					108
				],
				"218": [
					218
				],
				"389": [
					389
				],
				"498": [
					489
				],
				"589": [
					580
				],
				"831": [
					822
				]
			},
			"25": {
				"45": [
					45
				],
				"109": [
					109
				],
				"219": [
					219
				],
				"390": [
					390
				],
				"499": [
					490
				],
				"590": [
					581
				],
				"832": [
					823
				]
			},
			"26": {
				"46": [
					46
				],
				"110": [
					110
				],
				"220": [
					220
				],
				"391": [
					391
				],
				"500": [
					491
				],
				"591": [
					582
				],
				"833": [
					824
				]
			},
			"27": {
				"47": [
					47
				],
				"111": [
					111
				],
				"221": [
					221
				],
				"392": [
					392
				],
				"501": [
					492
				],
				"592": [
					583
				],
				"834": [
					825
				]
			},
			"28": {
				"48": [
					48
				],
				"112": [
					112
				],
				"222": [
					222
				],
				"393": [
					393
				],
				"502": [
					493
				],
				"593": [
					584
				],
				"835": [
					826
				]
			},
			"29": {
				"49": [
					49
				],
				"113": [
					113
				],
				"223": [
					223
				],
				"394": [
					394
				],
				"503": [
					494
				],
				"594": [
					585
				],
				"836": [
					827
				]
			},
			"30": {
				"50": [
					50
				],
				"114": [
					114
				],
				"224": [
					224
				],
				"395": [
					395
				],
				"504": [
					495
				],
				"595": [
					586
				],
				"837": [
					828
				]
			},
			"31": {
				"51": [
					51
				],
				"115": [
					115
				],
				"225": [
					225
				],
				"396": [
					396
				],
				"505": [
					496
				],
				"596": [
					587
				],
				"838": [
					829
				]
			},
			"32": {
				"52": [
					52
				],
				"116": [
					116
				],
				"226": [
					226
				],
				"397": [
					397
				],
				"506": [
					497
				],
				"597": [
					588
				],
				"839": [
					830
				]
			},
			"33": {
				"53": [
					53
				],
				"117": [
					117
				],
				"227": [
					227
				],
				"398": [
					398
				],
				"507": [
					498
				],
				"598": [
					589
				],
				"840": [
					831
				]
			},
			"34": {
				"54": [
					54
				],
				"118": [
					118
				],
				"228": [
					228
				],
				"399": [
					399
				],
				"508": [
					499
				],
				"599": [
					590
				],
				"841": [
					832
				]
			},
			"35": {
				"55": [
					55
				],
				"119": [
					119
				],
				"229": [
					229
				],
				"400": [
					400
				],
				"509": [
					500
				],
				"600": [
					591
				],
				"842": [
					833
				]
			},
			"36": {
				"56": [
					56
				],
				"120": [
					120
				],
				"230": [
					230
				],
				"401": [
					401
				],
				"510": [
					501
				],
				"601": [
					592
				],
				"843": [
					834
				]
			},
			"37": {
				"57": [
					57
				],
				"121": [
					121
				],
				"231": [
					231
				],
				"402": [
					402
				],
				"511": [
					502
				],
				"602": [
					593
				],
				"844": [
					835
				]
			}
		},
		"30": {
			"0": {
				"74": [
					74
				],
				"103": [
					103
				],
				"256": [
					256
				],
				"279": [
					279
				],
				"306": [
					306
				],
				"343": [
					343
				],
				"344": [
					344
				],
				"346": [
					346
				],
				"347": [
					347
				],
				"349": [
					349
				],
				"350": [
					350
				],
				"403": [
					403
				],
				"412": [
					412
				],
				"415": [
					415
				],
				"426": [
					426
				],
				"443": [
					443
				],
				"446": [
					446
				],
				"447": [
					447
				],
				"448": [
					448
				],
				"449": [
					449
				],
				"450": [
					450
				],
				"451": [
					451
				],
				"524": [
					515
				],
				"535": [
					526
				],
				"608": [
					599
				],
				"610": [
					601
				],
				"611": [
					602
				],
				"615": [
					606
				],
				"626": [
					617
				],
				"634": [
					625
				],
				"637": [
					628
				],
				"656": [
					647
				],
				"698": [
					689
				],
				"706": [
					697
				],
				"710": [
					701
				],
				"711": [
					702
				],
				"712": [
					703
				],
				"713": [
					704
				],
				"751": [
					742
				],
				"889": [
					880
				],
				"904": [
					895
				],
				"911": [
					902
				]
			},
			"1": {
				"21": [
					21
				],
				"83": [
					83
				],
				"138": [
					138
				],
				"182": [
					182
				],
				"195": [
					195
				],
				"673": [
					664
				],
				"707": [
					698
				],
				"743": [
					734
				],
				"765": [
					756
				]
			},
			"2": {
				"22": [
					22
				],
				"84": [
					84
				],
				"139": [
					139
				],
				"183": [
					183
				],
				"196": [
					196
				],
				"674": [
					665
				],
				"708": [
					699
				],
				"744": [
					735
				],
				"766": [
					757
				]
			},
			"3": {
				"23": [
					23
				],
				"85": [
					85
				],
				"140": [
					140
				],
				"184": [
					184
				],
				"197": [
					197
				],
				"675": [
					666
				],
				"709": [
					700
				],
				"745": [
					736
				],
				"767": [
					758
				]
			},
			"4": {
				"3": [
					3
				],
				"161": [
					161
				],
				"662": [
					653
				]
			},
			"5": {
				"4": [
					4
				],
				"162": [
					162
				],
				"663": [
					654
				]
			},
			"6": {
				"6": [
					6
				],
				"164": [
					164
				],
				"665": [
					656
				]
			},
			"7": {
				"8": [
					8
				],
				"167": [
					167
				],
				"668": [
					659
				]
			},
			"8": {
				"10": [
					10
				],
				"169": [
					169
				],
				"670": [
					661
				]
			},
			"9": {
				"11": [
					11
				],
				"170": [
					170
				],
				"671": [
					662
				]
			}
		},
		"31": {
			"0": {
				"60": [
					60
				],
				"74": [
					74
				],
				"103": [
					103
				],
				"137": [
					137
				],
				"242": [
					242
				],
				"243": [
					243
				],
				"244": [
					244
				],
				"245": [
					245
				],
				"247": [
					247
				],
				"256": [
					256
				],
				"280": [
					280
				],
				"281": [
					281
				],
				"306": [
					306
				],
				"317": [
					317
				],
				"349": [
					349
				],
				"403": [
					403
				],
				"404": [
					404
				],
				"407": [
					407
				],
				"408": [
					408
				],
				"421": [
					421
				],
				"422": [
					422
				],
				"423": [
					423
				],
				"424": [
					424
				],
				"443": [
					443
				],
				"444": [
					444
				],
				"474": [
					465
				],
				"530": [
					521
				],
				"531": [
					522
				],
				"532": [
					523
				],
				"533": [
					524
				],
				"608": [
					599
				],
				"637": [
					628
				],
				"646": [
					637
				],
				"683": [
					674
				],
				"700": [
					691
				],
				"773": [
					764
				],
				"782": [
					773
				],
				"783": [
					774
				],
				"788": [
					779
				],
				"888": [
					879
				],
				"890": [
					881
				]
			},
			"1": {
				"21": [
					21
				],
				"138": [
					138
				],
				"182": [
					182
				],
				"195": [
					195
				],
				"638": [
					629
				],
				"642": [
					633
				],
				"673": [
					664
				],
				"774": [
					765
				],
				"778": [
					769
				],
				"784": [
					775
				]
			},
			"2": {
				"22": [
					22
				],
				"139": [
					139
				],
				"183": [
					183
				],
				"196": [
					196
				],
				"639": [
					630
				],
				"643": [
					634
				],
				"674": [
					665
				],
				"775": [
					766
				],
				"779": [
					770
				],
				"785": [
					776
				]
			},
			"3": {
				"23": [
					23
				],
				"140": [
					140
				],
				"184": [
					184
				],
				"197": [
					197
				],
				"640": [
					631
				],
				"644": [
					635
				],
				"675": [
					666
				],
				"776": [
					767
				],
				"780": [
					771
				],
				"786": [
					777
				]
			},
			"4": {
				"24": [
					24
				],
				"141": [
					141
				],
				"185": [
					185
				],
				"198": [
					198
				],
				"641": [
					632
				],
				"645": [
					636
				],
				"676": [
					667
				],
				"777": [
					768
				],
				"781": [
					772
				],
				"787": [
					778
				]
			},
			"5": {
				"62": [
					62
				],
				"233": [
					233
				],
				"241": [
					241
				],
				"248": [
					248
				],
				"406": [
					406
				],
				"685": [
					676
				]
			},
			"6": {
				"61": [
					61
				],
				"232": [
					232
				],
				"240": [
					240
				],
				"246": [
					246
				],
				"405": [
					405
				],
				"684": [
					675
				]
			},
			"7": {
				"58": [
					58
				],
				"234": [
					234
				],
				"236": [
					236
				],
				"238": [
					238
				],
				"681": [
					672
				]
			},
			"8": {
				"59": [
					59
				],
				"235": [
					235
				],
				"237": [
					237
				],
				"239": [
					239
				],
				"682": [
					673
				]
			}
		},
		"32": {
			"0": {
				"73": [
					73
				],
				"102": [
					102
				],
				"256": [
					256
				],
				"257": [
					257
				],
				"306": [
					306
				],
				"307": [
					307
				],
				"318": [
					318
				],
				"352": [
					352
				],
				"403": [
					403
				],
				"443": [
					443
				],
				"608": [
					599
				],
				"748": [
					739
				]
			},
			"1": {
				"21": [
					21
				],
				"122": [
					122
				],
				"129": [
					129
				],
				"138": [
					138
				],
				"182": [
					182
				],
				"195": [
					195
				],
				"366": [
					366
				],
				"566": [
					557
				],
				"616": [
					607
				]
			},
			"2": {
				"22": [
					22
				],
				"123": [
					123
				],
				"130": [
					130
				],
				"139": [
					139
				],
				"183": [
					183
				],
				"196": [
					196
				],
				"367": [
					367
				],
				"567": [
					558
				],
				"617": [
					608
				]
			},
			"3": {
				"23": [
					23
				],
				"124": [
					124
				],
				"131": [
					131
				],
				"140": [
					140
				],
				"184": [
					184
				],
				"197": [
					197
				],
				"368": [
					368
				],
				"568": [
					559
				],
				"618": [
					609
				]
			},
			"4": {
				"17": [
					17
				],
				"176": [
					176
				],
				"362": [
					362
				]
			},
			"5": {
				"13": [
					13
				],
				"172": [
					172
				],
				"358": [
					358
				]
			},
			"6": {
				"18": [
					18
				],
				"177": [
					177
				],
				"363": [
					363
				]
			},
			"7": {
				"14": [
					14
				],
				"173": [
					173
				],
				"359": [
					359
				]
			},
			"8": {
				"19": [
					19
				],
				"178": [
					178
				],
				"364": [
					364
				]
			},
			"9": {
				"15": [
					15
				],
				"174": [
					174
				],
				"360": [
					360
				]
			}
		},
		"33": {
			"0": {
				"348": [
					348
				],
				"443": [
					443
				],
				"608": [
					599
				]
			}
		},
		"34": {
			"0": {
				"1": [
					1
				],
				"74": [
					74
				],
				"103": [
					103
				],
				"136": [
					136
				],
				"256": [
					256
				],
				"260": [
					260
				],
				"261": [
					261
				],
				"278": [
					278
				],
				"282": [
					282
				],
				"306": [
					306
				],
				"321": [
					321
				],
				"322": [
					322
				],
				"323": [
					323
				],
				"324": [
					324
				],
				"325": [
					325
				],
				"326": [
					326
				],
				"327": [
					327
				],
				"343": [
					343
				],
				"345": [
					345
				],
				"346": [
					346
				],
				"349": [
					349
				],
				"415": [
					415
				],
				"417": [
					417
				],
				"418": [
					418
				],
				"425": [
					425
				],
				"426": [
					426
				],
				"443": [
					443
				],
				"524": [
					515
				],
				"526": [
					517
				],
				"527": [
					518
				],
				"534": [
					525
				],
				"535": [
					526
				],
				"537": [
					528
				],
				"538": [
					529
				],
				"539": [
					530
				],
				"540": [
					531
				],
				"541": [
					532
				],
				"608": [
					599
				],
				"656": [
					647
				],
				"698": [
					689
				],
				"702": [
					693
				],
				"705": [
					696
				],
				"706": [
					697
				],
				"710": [
					701
				],
				"724": [
					715
				],
				"731": [
					722
				],
				"747": [
					738
				],
				"871": [
					862
				],
				"904": [
					895
				],
				"911": [
					902
				]
			},
			"1": {
				"21": [
					21
				],
				"83": [
					83
				],
				"138": [
					138
				],
				"182": [
					182
				],
				"195": [
					195
				],
				"419": [
					419
				],
				"528": [
					519
				],
				"673": [
					664
				],
				"707": [
					698
				],
				"743": [
					734
				],
				"765": [
					756
				],
				"803": [
					794
				],
				"869": [
					860
				]
			},
			"2": {
				"22": [
					22
				],
				"84": [
					84
				],
				"139": [
					139
				],
				"183": [
					183
				],
				"196": [
					196
				],
				"420": [
					420
				],
				"529": [
					520
				],
				"674": [
					665
				],
				"708": [
					699
				],
				"744": [
					735
				],
				"766": [
					757
				],
				"868": [
					859
				],
				"870": [
					861
				]
			},
			"3": {
				"2": [
					2
				],
				"148": [
					148
				],
				"154": [
					154
				],
				"160": [
					160
				],
				"661": [
					652
				]
			},
			"4": {
				"5": [
					5
				],
				"149": [
					149
				],
				"155": [
					155
				],
				"163": [
					163
				],
				"664": [
					655
				]
			},
			"5": {
				"7": [
					7
				],
				"150": [
					150
				],
				"156": [
					156
				],
				"165": [
					165
				],
				"666": [
					657
				]
			},
			"6": {
				"151": [
					151
				],
				"157": [
					157
				],
				"166": [
					166
				],
				"667": [
					658
				],
				"939": [
					930
				]
			},
			"7": {
				"9": [
					9
				],
				"152": [
					152
				],
				"158": [
					158
				],
				"168": [
					168
				],
				"669": [
					660
				]
			},
			"8": {
				"12": [
					12
				],
				"153": [
					153
				],
				"159": [
					159
				],
				"171": [
					171
				],
				"672": [
					663
				]
			},
			"9": {
				"255": [
					255
				]
			},
			"10": {
				"353": [
					353
				]
			}
		},
		"35": {
			"0": {
				"74": [
					74
				],
				"256": [
					256
				],
				"306": [
					306
				],
				"349": [
					349
				],
				"426": [
					426
				],
				"443": [
					443
				],
				"535": [
					526
				],
				"608": [
					599
				],
				"656": [
					647
				],
				"698": [
					689
				],
				"710": [
					701
				],
				"731": [
					722
				],
				"742": [
					733
				],
				"871": [
					862
				],
				"911": [
					902
				]
			},
			"1": {
				"21": [
					21
				],
				"138": [
					138
				],
				"182": [
					182
				],
				"195": [
					195
				],
				"673": [
					664
				]
			}
		},
		"36": {
			"0": {
				"74": [
					74
				],
				"256": [
					256
				],
				"306": [
					306
				],
				"349": [
					349
				],
				"443": [
					443
				],
				"608": [
					599
				],
				"610": [
					601
				],
				"615": [
					606
				],
				"656": [
					647
				],
				"698": [
					689
				]
			},
			"1": {
				"21": [
					21
				],
				"195": [
					195
				],
				"673": [
					664
				]
			}
		},
		"37": {
			"0": {
				"443": [
					443
				],
				"608": [
					599
				]
			}
		},
		"38": {
			"0": {
				"74": [
					74
				],
				"349": [
					349
				],
				"403": [
					403
				],
				"413": [
					413
				],
				"414": [
					414
				],
				"443": [
					443
				],
				"608": [
					599
				]
			}
		},
		"39": {
			"0": {
				"403": [
					403
				],
				"443": [
					443
				],
				"608": [
					599
				]
			}
		},
		"40": {
			"0": {
				"443": [
					443
				],
				"608": [
					599
				],
				"656": [
					647
				],
				"698": [
					689
				]
			}
		},
		"41": {
			"0": {
				"74": [
					74
				],
				"103": [
					103
				],
				"137": [
					137
				],
				"251": [
					251
				],
				"252": [
					252
				],
				"256": [
					256
				],
				"281": [
					281
				],
				"306": [
					306
				],
				"349": [
					349
				],
				"403": [
					403
				],
				"409": [
					409
				],
				"410": [
					410
				],
				"411": [
					411
				],
				"430": [
					430
				],
				"431": [
					431
				],
				"637": [
					628
				],
				"701": [
					692
				],
				"793": [
					784
				],
				"796": [
					787
				]
			},
			"1": {
				"21": [
					21
				],
				"138": [
					138
				],
				"182": [
					182
				],
				"195": [
					195
				],
				"648": [
					639
				],
				"673": [
					664
				],
				"789": [
					780
				],
				"791": [
					782
				],
				"794": [
					785
				]
			},
			"2": {
				"22": [
					22
				],
				"139": [
					139
				],
				"183": [
					183
				],
				"196": [
					196
				],
				"649": [
					640
				],
				"674": [
					665
				],
				"790": [
					781
				],
				"792": [
					783
				],
				"795": [
					786
				]
			},
			"3": {
				"64": [
					64
				],
				"250": [
					250
				],
				"687": [
					678
				]
			},
			"4": {
				"63": [
					63
				],
				"249": [
					249
				],
				"686": [
					677
				]
			}
		},
		"42": {
			"0": {
				"74": [
					74
				],
				"349": [
					349
				],
				"413": [
					413
				],
				"414": [
					414
				],
				"443": [
					443
				],
				"608": [
					599
				]
			},
			"1": {
				"566": [
					557
				],
				"940": [
					1865
				]
			},
			"2": {
				"567": [
					558
				],
				"941": [
					1866
				]
			},
			"3": {
				"568": [
					559
				],
				"942": [
					1867
				]
			},
			"4": {
				"569": [
					560
				],
				"943": [
					1868
				]
			},
			"5": {
				"570": [
					561
				],
				"944": [
					1869
				]
			}
		}
	};

/***/ },
/* 1828 */
/***/ function(module, exports) {

	module.exports = {
		"2": {
			"0": {
				"73": 2,
				"102": 5,
				"257": 9,
				"307": 10,
				"318": 3,
				"352": 4,
				"403": 1,
				"443": 6,
				"599": 7,
				"743": 8,
				"744": 11
			},
			"1": {
				"21": 2,
				"83": 12,
				"122": 10,
				"129": 11,
				"138": 4,
				"182": 5,
				"195": 3,
				"366": 1,
				"557": 7,
				"607": 6,
				"863": 8,
				"885": 9
			},
			"2": {
				"22": 2,
				"84": 12,
				"123": 10,
				"130": 11,
				"139": 4,
				"183": 5,
				"196": 3,
				"367": 1,
				"558": 7,
				"608": 6,
				"864": 8,
				"886": 9
			},
			"3": {
				"23": 2,
				"85": 12,
				"124": 10,
				"131": 11,
				"140": 4,
				"184": 5,
				"197": 3,
				"368": 1,
				"559": 7,
				"609": 6,
				"865": 8,
				"887": 9
			},
			"4": {
				"24": 2,
				"86": 12,
				"125": 10,
				"132": 11,
				"141": 4,
				"185": 5,
				"198": 3,
				"369": 1,
				"560": 7,
				"610": 6,
				"866": 8,
				"888": 9
			},
			"5": {
				"25": 2,
				"87": 12,
				"126": 10,
				"133": 11,
				"142": 4,
				"186": 5,
				"199": 3,
				"370": 1,
				"561": 7,
				"611": 6,
				"867": 8,
				"889": 9
			},
			"6": {
				"26": 2,
				"88": 12,
				"127": 10,
				"134": 11,
				"143": 4,
				"187": 5,
				"200": 3,
				"371": 1,
				"562": 7,
				"612": 6,
				"868": 8,
				"890": 9
			},
			"7": {
				"27": 2,
				"89": 12,
				"128": 10,
				"135": 11,
				"144": 4,
				"188": 5,
				"201": 3,
				"372": 1,
				"563": 7,
				"613": 6,
				"869": 8,
				"891": 9
			}
		},
		"3": {
			"0": {
				"73": 2,
				"74": 12,
				"102": 5,
				"257": 10,
				"307": 11,
				"318": 3,
				"352": 4,
				"403": 1,
				"443": 7,
				"599": 8,
				"737": 6,
				"882": 9
			},
			"1": {
				"21": 2,
				"83": 8,
				"138": 5,
				"182": 6,
				"195": 3,
				"366": 1,
				"557": 7,
				"607": 13,
				"788": 9,
				"791": 14,
				"842": 10,
				"845": 11,
				"848": 12,
				"896": 4
			},
			"2": {
				"22": 2,
				"84": 8,
				"139": 5,
				"183": 6,
				"196": 3,
				"367": 1,
				"558": 7,
				"608": 13,
				"789": 9,
				"792": 14,
				"843": 10,
				"846": 11,
				"849": 12,
				"897": 4
			},
			"3": {
				"23": 2,
				"85": 8,
				"140": 5,
				"184": 6,
				"197": 3,
				"368": 1,
				"559": 7,
				"609": 13,
				"790": 9,
				"793": 14,
				"844": 10,
				"847": 11,
				"850": 12,
				"898": 4
			},
			"4": {
				"17": 2,
				"176": 3,
				"362": 1
			},
			"5": {
				"13": 2,
				"172": 3,
				"358": 1
			},
			"6": {
				"18": 2,
				"177": 3,
				"363": 1
			},
			"7": {
				"14": 2,
				"173": 3,
				"359": 1
			}
		},
		"4": {
			"0": {
				"73": 2,
				"74": 4,
				"102": 11,
				"137": 16,
				"257": 6,
				"281": 15,
				"307": 7,
				"318": 3,
				"319": 8,
				"320": 9,
				"352": 12,
				"403": 1,
				"443": 14,
				"599": 13,
				"755": 10,
				"798": 5,
				"882": 17,
				"927": 18
			},
			"1": {
				"21": 2,
				"83": 12,
				"138": 4,
				"182": 5,
				"195": 3,
				"366": 1,
				"557": 7,
				"607": 14,
				"836": 8,
				"896": 6,
				"903": 13,
				"909": 9,
				"914": 10,
				"920": 11
			},
			"2": {
				"22": 2,
				"84": 12,
				"139": 4,
				"183": 5,
				"196": 3,
				"367": 1,
				"558": 7,
				"608": 14,
				"837": 8,
				"897": 6,
				"904": 13,
				"910": 9,
				"915": 10,
				"921": 11
			},
			"3": {
				"23": 2,
				"85": 12,
				"140": 4,
				"184": 5,
				"197": 3,
				"368": 1,
				"559": 7,
				"609": 14,
				"838": 8,
				"898": 6,
				"905": 13,
				"911": 9,
				"916": 10,
				"922": 11
			},
			"4": {
				"24": 2,
				"86": 12,
				"141": 4,
				"185": 5,
				"198": 3,
				"369": 1,
				"560": 7,
				"610": 14,
				"839": 8,
				"899": 6,
				"906": 13,
				"912": 9,
				"917": 10,
				"923": 11
			},
			"5": {
				"25": 2,
				"87": 12,
				"142": 4,
				"186": 5,
				"199": 3,
				"370": 1,
				"561": 7,
				"611": 14,
				"840": 8,
				"900": 6,
				"907": 13,
				"913": 9,
				"918": 10,
				"924": 11
			},
			"6": {
				"26": 1,
				"88": 11,
				"143": 3,
				"187": 4,
				"200": 2,
				"371": 5,
				"562": 6,
				"901": 9,
				"908": 10,
				"919": 7,
				"925": 8
			},
			"7": {
				"17": 2,
				"176": 3,
				"362": 1
			},
			"8": {
				"13": 2,
				"172": 3,
				"358": 1
			},
			"9": {
				"18": 2,
				"177": 3,
				"363": 1
			},
			"10": {
				"14": 2,
				"173": 3,
				"359": 1
			},
			"11": {
				"19": 2,
				"178": 3,
				"364": 1
			},
			"12": {
				"15": 2,
				"174": 3,
				"360": 1
			},
			"13": {
				"20": 2,
				"179": 3,
				"365": 1
			},
			"14": {
				"16": 2,
				"175": 3,
				"361": 1
			}
		},
		"5": {
			"0": {
				"349": 2,
				"443": 3,
				"599": 4,
				"689": 1
			}
		},
		"6": {
			"0": {
				"73": 3,
				"82": 68,
				"102": 29,
				"257": 7,
				"296": 62,
				"297": 63,
				"298": 16,
				"299": 27,
				"305": 25,
				"307": 8,
				"308": 17,
				"309": 28,
				"315": 26,
				"318": 4,
				"320": 11,
				"328": 49,
				"329": 50,
				"330": 53,
				"331": 54,
				"332": 51,
				"337": 38,
				"338": 67,
				"339": 19,
				"340": 48,
				"341": 15,
				"342": 52,
				"352": 10,
				"403": 1,
				"427": 12,
				"443": 40,
				"445": 30,
				"505": 23,
				"506": 18,
				"507": 24,
				"513": 34,
				"514": 6,
				"527": 13,
				"534": 56,
				"535": 57,
				"536": 58,
				"537": 59,
				"538": 20,
				"539": 39,
				"540": 21,
				"543": 64,
				"544": 22,
				"550": 61,
				"551": 60,
				"599": 41,
				"623": 2,
				"627": 37,
				"638": 65,
				"687": 36,
				"688": 14,
				"713": 55,
				"732": 66,
				"739": 9,
				"798": 5,
				"894": 35,
				"1861": 69,
				"1870": 33,
				"1871": 44,
				"1872": 47
			},
			"1": {
				"21": 2,
				"76": 22,
				"83": 15,
				"138": 4,
				"182": 5,
				"190": 14,
				"195": 3,
				"300": 16,
				"310": 17,
				"333": 6,
				"366": 1,
				"508": 19,
				"545": 18,
				"552": 20,
				"557": 7,
				"594": 11,
				"618": 10,
				"708": 21,
				"745": 8,
				"750": 13,
				"759": 12,
				"896": 9
			},
			"2": {
				"22": 2,
				"77": 22,
				"84": 13,
				"139": 4,
				"183": 5,
				"191": 10,
				"196": 3,
				"301": 15,
				"311": 16,
				"334": 14,
				"367": 1,
				"509": 18,
				"546": 17,
				"553": 19,
				"558": 7,
				"595": 9,
				"619": 8,
				"709": 21,
				"746": 6,
				"751": 12,
				"760": 11,
				"897": 20
			},
			"3": {
				"23": 2,
				"78": 22,
				"85": 13,
				"140": 4,
				"184": 5,
				"192": 10,
				"197": 3,
				"302": 15,
				"312": 16,
				"335": 14,
				"368": 1,
				"510": 18,
				"547": 17,
				"554": 19,
				"559": 7,
				"596": 9,
				"620": 8,
				"710": 21,
				"747": 6,
				"752": 12,
				"761": 11,
				"898": 20
			},
			"4": {
				"24": 2,
				"79": 22,
				"86": 13,
				"141": 4,
				"185": 5,
				"193": 10,
				"198": 3,
				"303": 15,
				"313": 16,
				"336": 14,
				"369": 1,
				"511": 18,
				"548": 17,
				"555": 19,
				"560": 7,
				"597": 9,
				"621": 8,
				"711": 21,
				"748": 6,
				"753": 12,
				"762": 11,
				"899": 20
			},
			"5": {
				"25": 2,
				"80": 21,
				"87": 13,
				"142": 4,
				"186": 5,
				"194": 10,
				"199": 3,
				"304": 14,
				"314": 15,
				"370": 1,
				"512": 17,
				"549": 16,
				"556": 18,
				"561": 7,
				"598": 9,
				"622": 8,
				"712": 20,
				"749": 6,
				"754": 12,
				"763": 11,
				"900": 19
			}
		},
		"7": {
			"0": {
				"1": 11,
				"74": 10,
				"103": 74,
				"136": 14,
				"137": 86,
				"256": 15,
				"260": 71,
				"261": 70,
				"278": 36,
				"281": 87,
				"282": 78,
				"306": 19,
				"321": 44,
				"322": 77,
				"323": 42,
				"324": 43,
				"325": 55,
				"326": 73,
				"327": 72,
				"343": 30,
				"345": 28,
				"346": 29,
				"349": 13,
				"412": 97,
				"415": 61,
				"416": 58,
				"417": 18,
				"418": 17,
				"425": 60,
				"426": 68,
				"428": 85,
				"429": 62,
				"432": 84,
				"433": 67,
				"434": 45,
				"435": 49,
				"436": 89,
				"437": 88,
				"439": 41,
				"442": 46,
				"443": 91,
				"462": 48,
				"464": 47,
				"465": 7,
				"515": 66,
				"516": 63,
				"517": 22,
				"518": 21,
				"525": 65,
				"526": 69,
				"528": 59,
				"529": 39,
				"530": 38,
				"531": 40,
				"532": 64,
				"533": 96,
				"599": 90,
				"600": 51,
				"605": 52,
				"614": 4,
				"615": 5,
				"616": 6,
				"617": 76,
				"624": 81,
				"625": 75,
				"626": 50,
				"647": 2,
				"689": 1,
				"693": 32,
				"695": 56,
				"696": 37,
				"697": 25,
				"701": 26,
				"705": 35,
				"706": 34,
				"714": 92,
				"715": 57,
				"720": 82,
				"721": 33,
				"722": 31,
				"723": 83,
				"724": 79,
				"725": 80,
				"726": 93,
				"730": 94,
				"738": 8,
				"795": 54,
				"796": 16,
				"841": 53,
				"862": 12,
				"870": 24,
				"871": 27,
				"872": 3,
				"883": 20,
				"895": 9,
				"902": 23,
				"928": 95
			},
			"1": {
				"21": 4,
				"83": 14,
				"138": 6,
				"182": 7,
				"195": 5,
				"273": 13,
				"419": 1,
				"519": 2,
				"648": 18,
				"664": 3,
				"698": 10,
				"727": 15,
				"729": 16,
				"731": 17,
				"734": 8,
				"756": 9,
				"794": 11,
				"860": 12
			},
			"2": {
				"22": 4,
				"84": 14,
				"139": 6,
				"183": 7,
				"196": 5,
				"274": 13,
				"420": 1,
				"520": 2,
				"649": 16,
				"665": 3,
				"699": 10,
				"728": 15,
				"735": 8,
				"757": 9,
				"859": 11,
				"861": 12
			},
			"3": {
				"2": 3,
				"148": 5,
				"154": 6,
				"160": 4,
				"641": 2,
				"652": 1
			},
			"4": {
				"5": 3,
				"149": 5,
				"155": 6,
				"163": 4,
				"642": 2,
				"655": 1
			},
			"5": {
				"7": 3,
				"150": 5,
				"156": 6,
				"165": 4,
				"643": 2,
				"657": 1
			},
			"6": {
				"151": 5,
				"157": 6,
				"166": 4,
				"644": 2,
				"658": 1,
				"930": 3
			},
			"7": {
				"9": 3,
				"152": 5,
				"158": 6,
				"168": 4,
				"645": 2,
				"660": 1
			},
			"8": {
				"12": 3,
				"153": 5,
				"159": 6,
				"171": 4,
				"646": 2,
				"663": 1
			},
			"9": {
				"66": 2,
				"255": 3,
				"354": 5,
				"355": 6,
				"438": 4,
				"680": 1
			},
			"10": {
				"67": 2,
				"258": 3,
				"356": 4,
				"357": 5,
				"681": 1
			},
			"11": {
				"81": 2,
				"353": 3,
				"440": 4,
				"441": 5,
				"690": 1
			},
			"12": {
				"68": 2,
				"259": 3,
				"682": 1
			},
			"13": {
				"69": 4,
				"146": 1,
				"180": 8,
				"262": 5,
				"650": 2,
				"683": 6,
				"694": 7,
				"740": 3
			},
			"14": {
				"70": 1,
				"263": 2,
				"684": 3
			},
			"15": {
				"72": 1,
				"277": 2,
				"686": 3
			},
			"16": {
				"147": 2,
				"181": 1,
				"275": 5,
				"276": 4,
				"741": 3
			}
		},
		"8": {
			"0": {
				"74": 3,
				"103": 7,
				"256": 5,
				"306": 6,
				"349": 4,
				"443": 8,
				"599": 9,
				"647": 2,
				"689": 1
			},
			"1": {
				"195": 2,
				"664": 1
			},
			"2": {
				"196": 2,
				"665": 1
			},
			"3": {
				"197": 2,
				"666": 1
			},
			"4": {
				"198": 2,
				"667": 1
			}
		},
		"9": {
			"0": {
				"74": 3,
				"256": 5,
				"306": 6,
				"349": 4,
				"443": 7,
				"599": 8,
				"647": 2,
				"689": 1
			},
			"1": {
				"195": 2,
				"664": 1
			},
			"2": {
				"196": 2,
				"665": 1
			}
		},
		"10": {
			"0": {
				"1": 3,
				"74": 2,
				"103": 7,
				"256": 5,
				"306": 6,
				"349": 4,
				"403": 1,
				"443": 8,
				"599": 9
			}
		},
		"11": {
			"0": {
				"74": 2,
				"103": 6,
				"256": 4,
				"306": 5,
				"349": 3,
				"403": 1,
				"443": 7,
				"599": 8
			}
		},
		"12": {
			"0": {
				"74": 3,
				"103": 7,
				"256": 5,
				"306": 6,
				"349": 4,
				"443": 8,
				"599": 9,
				"647": 2,
				"689": 1
			}
		},
		"13": {
			"0": {
				"283": 18,
				"284": 6,
				"285": 7,
				"286": 9,
				"287": 10,
				"288": 2,
				"289": 3,
				"290": 11,
				"291": 12,
				"292": 1,
				"293": 14,
				"294": 13,
				"295": 15,
				"316": 8,
				"452": 4,
				"453": 5,
				"454": 16,
				"455": 17,
				"456": 20,
				"457": 19,
				"458": 23,
				"459": 21,
				"460": 24,
				"461": 22
			}
		},
		"14": {
			"0": {
				"443": 1,
				"599": 2
			}
		},
		"15": {
			"0": {
				"443": 1,
				"599": 2
			}
		},
		"16": {
			"0": {
				"443": 1,
				"599": 2
			}
		},
		"17": {
			"0": {
				"348": 1,
				"443": 2,
				"599": 3
			}
		},
		"18": {
			"0": {
				"65": 12,
				"74": 4,
				"253": 10,
				"256": 6,
				"306": 7,
				"349": 5,
				"350": 17,
				"443": 8,
				"599": 9,
				"601": 3,
				"606": 19,
				"647": 2,
				"679": 11,
				"689": 1,
				"742": 18,
				"797": 13,
				"880": 15,
				"884": 14,
				"895": 16
			},
			"1": {
				"21": 4,
				"195": 2,
				"664": 1,
				"698": 3,
				"734": 5
			},
			"2": {
				"22": 4,
				"196": 2,
				"665": 1,
				"699": 3,
				"735": 5
			},
			"3": {
				"23": 4,
				"197": 2,
				"666": 1,
				"700": 3,
				"736": 5
			}
		},
		"19": {
			"0": {
				"74": 2,
				"103": 7,
				"256": 4,
				"306": 5,
				"349": 3,
				"443": 10,
				"599": 11,
				"606": 6,
				"689": 1,
				"714": 9,
				"902": 8
			},
			"1": {
				"21": 2,
				"138": 5,
				"182": 6,
				"195": 3,
				"664": 1,
				"873": 8,
				"875": 7,
				"877": 4
			},
			"2": {
				"22": 6,
				"196": 1,
				"665": 5,
				"874": 4,
				"876": 3,
				"878": 2
			}
		},
		"20": {
			"0": {
				"74": 2,
				"256": 4,
				"306": 5,
				"349": 3,
				"443": 6,
				"599": 7,
				"689": 1
			},
			"1": {
				"21": 2,
				"138": 4,
				"182": 5,
				"195": 3,
				"664": 1,
				"851": 6
			},
			"2": {
				"22": 2,
				"139": 4,
				"183": 5,
				"196": 3,
				"665": 1,
				"852": 6
			},
			"3": {
				"23": 2,
				"140": 4,
				"184": 5,
				"197": 3,
				"666": 1,
				"853": 6
			},
			"4": {
				"24": 2,
				"141": 4,
				"185": 5,
				"198": 3,
				"667": 1,
				"854": 6
			},
			"5": {
				"25": 4,
				"142": 2,
				"186": 3,
				"199": 1,
				"668": 5,
				"855": 6
			},
			"6": {
				"26": 4,
				"143": 2,
				"187": 3,
				"200": 1,
				"669": 5,
				"856": 6
			},
			"7": {
				"27": 4,
				"144": 2,
				"188": 3,
				"201": 1,
				"670": 5,
				"857": 6
			},
			"8": {
				"28": 4,
				"145": 2,
				"189": 3,
				"202": 1,
				"671": 5,
				"858": 6
			}
		},
		"21": {
			"0": {
				"443": 1,
				"599": 2
			}
		},
		"23": {
			"0": {
				"443": 1,
				"599": 2
			}
		},
		"24": {
			"0": {
				"443": 1,
				"599": 2
			}
		},
		"25": {
			"0": {
				"443": 1,
				"599": 2
			}
		},
		"26": {
			"0": {
				"443": 1,
				"599": 2
			}
		},
		"27": {
			"0": {
				"443": 1,
				"599": 2
			}
		},
		"28": {
			"0": {
				"74": 2,
				"103": 8,
				"256": 4,
				"306": 5,
				"349": 3,
				"403": 1,
				"443": 10,
				"599": 9,
				"603": 12,
				"604": 11,
				"606": 6,
				"926": 7
			}
		},
		"29": {
			"0": {
				"74": 2,
				"254": 4,
				"349": 3,
				"403": 1,
				"443": 5,
				"599": 6
			},
			"1": {
				"21": 2,
				"83": 7,
				"195": 3,
				"366": 1,
				"466": 4,
				"557": 5,
				"799": 6
			},
			"2": {
				"22": 2,
				"84": 7,
				"196": 3,
				"367": 1,
				"467": 4,
				"558": 5,
				"800": 6
			},
			"3": {
				"23": 2,
				"85": 7,
				"197": 3,
				"368": 1,
				"468": 4,
				"559": 5,
				"801": 6
			},
			"4": {
				"24": 2,
				"86": 7,
				"198": 3,
				"369": 1,
				"469": 4,
				"560": 5,
				"802": 6
			},
			"5": {
				"25": 2,
				"87": 7,
				"199": 3,
				"370": 1,
				"470": 4,
				"561": 5,
				"803": 6
			},
			"6": {
				"26": 2,
				"88": 7,
				"200": 3,
				"371": 1,
				"471": 4,
				"562": 5,
				"804": 6
			},
			"7": {
				"27": 2,
				"89": 7,
				"201": 3,
				"372": 1,
				"472": 4,
				"563": 5,
				"805": 6
			},
			"8": {
				"28": 2,
				"90": 7,
				"202": 3,
				"373": 1,
				"473": 4,
				"564": 5,
				"806": 6
			},
			"9": {
				"29": 2,
				"91": 7,
				"203": 3,
				"374": 1,
				"474": 4,
				"565": 5,
				"807": 6
			},
			"10": {
				"30": 2,
				"92": 7,
				"204": 3,
				"375": 1,
				"475": 4,
				"566": 5,
				"808": 6
			},
			"11": {
				"31": 2,
				"93": 7,
				"205": 3,
				"376": 1,
				"476": 4,
				"567": 5,
				"809": 6
			},
			"12": {
				"32": 2,
				"94": 7,
				"206": 3,
				"377": 1,
				"477": 4,
				"568": 5,
				"810": 6
			},
			"13": {
				"33": 2,
				"95": 7,
				"207": 3,
				"378": 1,
				"478": 4,
				"569": 5,
				"811": 6
			},
			"14": {
				"34": 2,
				"96": 7,
				"208": 3,
				"379": 1,
				"479": 4,
				"570": 5,
				"812": 6
			},
			"15": {
				"35": 2,
				"97": 7,
				"209": 3,
				"380": 1,
				"480": 4,
				"571": 5,
				"813": 6
			},
			"16": {
				"36": 2,
				"98": 7,
				"210": 3,
				"381": 1,
				"481": 4,
				"572": 5,
				"814": 6
			},
			"17": {
				"37": 2,
				"99": 7,
				"211": 3,
				"382": 1,
				"482": 4,
				"573": 5,
				"815": 6
			},
			"18": {
				"38": 2,
				"100": 7,
				"212": 3,
				"383": 1,
				"483": 4,
				"574": 5,
				"816": 6
			},
			"19": {
				"39": 2,
				"101": 7,
				"213": 3,
				"384": 1,
				"484": 4,
				"575": 5,
				"817": 6
			},
			"20": {
				"40": 2,
				"104": 7,
				"214": 3,
				"385": 1,
				"485": 4,
				"576": 5,
				"818": 6
			},
			"21": {
				"41": 2,
				"105": 7,
				"215": 3,
				"386": 1,
				"486": 4,
				"577": 5,
				"819": 6
			},
			"22": {
				"42": 2,
				"106": 7,
				"216": 3,
				"387": 1,
				"487": 4,
				"578": 5,
				"820": 6
			},
			"23": {
				"43": 2,
				"107": 7,
				"217": 3,
				"388": 1,
				"488": 4,
				"579": 5,
				"821": 6
			},
			"24": {
				"44": 2,
				"108": 7,
				"218": 3,
				"389": 1,
				"489": 4,
				"580": 5,
				"822": 6
			},
			"25": {
				"45": 2,
				"109": 7,
				"219": 3,
				"390": 1,
				"490": 4,
				"581": 5,
				"823": 6
			},
			"26": {
				"46": 2,
				"110": 7,
				"220": 3,
				"391": 1,
				"491": 4,
				"582": 5,
				"824": 6
			},
			"27": {
				"47": 2,
				"111": 7,
				"221": 3,
				"392": 1,
				"492": 4,
				"583": 5,
				"825": 6
			},
			"28": {
				"48": 2,
				"112": 7,
				"222": 3,
				"393": 1,
				"493": 4,
				"584": 5,
				"826": 6
			},
			"29": {
				"49": 2,
				"113": 7,
				"223": 3,
				"394": 1,
				"494": 4,
				"585": 5,
				"827": 6
			},
			"30": {
				"50": 2,
				"114": 7,
				"224": 3,
				"395": 1,
				"495": 4,
				"586": 5,
				"828": 6
			},
			"31": {
				"51": 2,
				"115": 7,
				"225": 3,
				"396": 1,
				"496": 4,
				"587": 5,
				"829": 6
			},
			"32": {
				"52": 2,
				"116": 7,
				"226": 3,
				"397": 1,
				"497": 4,
				"588": 5,
				"830": 6
			},
			"33": {
				"53": 2,
				"117": 7,
				"227": 3,
				"398": 1,
				"498": 4,
				"589": 5,
				"831": 6
			},
			"34": {
				"54": 2,
				"118": 7,
				"228": 3,
				"399": 1,
				"499": 4,
				"590": 5,
				"832": 6
			},
			"35": {
				"55": 2,
				"119": 7,
				"229": 3,
				"400": 1,
				"500": 4,
				"591": 5,
				"833": 6
			},
			"36": {
				"56": 2,
				"120": 7,
				"230": 3,
				"401": 1,
				"501": 4,
				"592": 5,
				"834": 6
			},
			"37": {
				"57": 2,
				"121": 7,
				"231": 3,
				"402": 1,
				"502": 4,
				"593": 5,
				"835": 6
			}
		},
		"30": {
			"0": {
				"74": 6,
				"103": 28,
				"256": 8,
				"279": 19,
				"306": 9,
				"343": 14,
				"344": 12,
				"346": 15,
				"347": 13,
				"349": 7,
				"350": 11,
				"403": 2,
				"412": 17,
				"415": 25,
				"426": 21,
				"443": 41,
				"446": 32,
				"447": 37,
				"448": 38,
				"449": 31,
				"450": 36,
				"451": 30,
				"515": 26,
				"526": 22,
				"599": 42,
				"601": 4,
				"602": 5,
				"606": 20,
				"617": 40,
				"625": 39,
				"628": 10,
				"647": 3,
				"689": 1,
				"697": 27,
				"701": 16,
				"702": 33,
				"703": 34,
				"704": 35,
				"742": 24,
				"880": 23,
				"895": 29,
				"902": 18
			},
			"1": {
				"21": 2,
				"83": 8,
				"138": 5,
				"182": 6,
				"195": 3,
				"664": 1,
				"698": 9,
				"734": 7,
				"756": 4
			},
			"2": {
				"22": 2,
				"84": 8,
				"139": 5,
				"183": 6,
				"196": 3,
				"665": 1,
				"699": 9,
				"735": 7,
				"757": 4
			},
			"3": {
				"23": 2,
				"85": 8,
				"140": 5,
				"184": 6,
				"197": 3,
				"666": 1,
				"700": 9,
				"736": 7,
				"758": 4
			},
			"4": {
				"3": 3,
				"161": 2,
				"653": 1
			},
			"5": {
				"4": 3,
				"162": 2,
				"654": 1
			},
			"6": {
				"6": 3,
				"164": 2,
				"656": 1
			},
			"7": {
				"8": 3,
				"167": 2,
				"659": 1
			},
			"8": {
				"10": 3,
				"169": 2,
				"661": 1
			},
			"9": {
				"11": 3,
				"170": 2,
				"662": 1
			}
		},
		"31": {
			"0": {
				"60": 33,
				"74": 3,
				"103": 23,
				"137": 28,
				"242": 30,
				"243": 32,
				"244": 40,
				"245": 31,
				"247": 39,
				"256": 13,
				"280": 10,
				"281": 27,
				"306": 14,
				"317": 11,
				"349": 5,
				"403": 1,
				"404": 35,
				"407": 38,
				"408": 37,
				"421": 15,
				"422": 17,
				"423": 8,
				"424": 6,
				"443": 25,
				"444": 21,
				"465": 2,
				"521": 16,
				"522": 18,
				"523": 9,
				"524": 7,
				"599": 26,
				"628": 22,
				"637": 41,
				"674": 34,
				"691": 36,
				"764": 20,
				"773": 4,
				"774": 19,
				"779": 24,
				"879": 12,
				"881": 29
			},
			"1": {
				"21": 2,
				"138": 5,
				"182": 6,
				"195": 3,
				"629": 9,
				"633": 10,
				"664": 1,
				"765": 8,
				"769": 4,
				"775": 7
			},
			"2": {
				"22": 2,
				"139": 5,
				"183": 6,
				"196": 3,
				"630": 9,
				"634": 10,
				"665": 1,
				"766": 8,
				"770": 4,
				"776": 7
			},
			"3": {
				"23": 2,
				"140": 5,
				"184": 6,
				"197": 3,
				"631": 9,
				"635": 10,
				"666": 1,
				"767": 8,
				"771": 4,
				"777": 7
			},
			"4": {
				"24": 2,
				"141": 5,
				"185": 6,
				"198": 3,
				"632": 9,
				"636": 10,
				"667": 1,
				"768": 8,
				"772": 4,
				"778": 7
			},
			"5": {
				"62": 3,
				"233": 5,
				"241": 4,
				"248": 2,
				"406": 6,
				"676": 1
			},
			"6": {
				"61": 3,
				"232": 5,
				"240": 4,
				"246": 2,
				"405": 6,
				"675": 1
			},
			"7": {
				"58": 2,
				"234": 4,
				"236": 5,
				"238": 3,
				"672": 1
			},
			"8": {
				"59": 2,
				"235": 4,
				"237": 5,
				"239": 3,
				"673": 1
			}
		},
		"32": {
			"0": {
				"73": 2,
				"102": 8,
				"256": 11,
				"257": 5,
				"306": 12,
				"307": 6,
				"318": 3,
				"352": 7,
				"403": 1,
				"443": 9,
				"599": 10,
				"739": 4
			},
			"1": {
				"21": 2,
				"122": 6,
				"129": 7,
				"138": 8,
				"182": 9,
				"195": 3,
				"366": 1,
				"557": 4,
				"607": 5
			},
			"2": {
				"22": 2,
				"123": 6,
				"130": 7,
				"139": 8,
				"183": 9,
				"196": 3,
				"367": 1,
				"558": 4,
				"608": 5
			},
			"3": {
				"23": 2,
				"124": 6,
				"131": 7,
				"140": 8,
				"184": 9,
				"197": 3,
				"368": 1,
				"559": 4,
				"609": 5
			},
			"4": {
				"17": 2,
				"176": 3,
				"362": 1
			},
			"5": {
				"13": 2,
				"172": 3,
				"358": 1
			},
			"6": {
				"18": 2,
				"177": 3,
				"363": 1
			},
			"7": {
				"14": 2,
				"173": 3,
				"359": 1
			},
			"8": {
				"19": 2,
				"178": 3,
				"364": 1
			},
			"9": {
				"15": 2,
				"174": 3,
				"360": 1
			}
		},
		"33": {
			"0": {
				"348": 1,
				"443": 2,
				"599": 3
			}
		},
		"34": {
			"0": {
				"1": 6,
				"74": 5,
				"103": 45,
				"136": 9,
				"256": 10,
				"260": 42,
				"261": 41,
				"278": 24,
				"282": 48,
				"306": 13,
				"321": 31,
				"322": 46,
				"323": 29,
				"324": 30,
				"325": 47,
				"326": 44,
				"327": 43,
				"343": 21,
				"345": 19,
				"346": 20,
				"349": 8,
				"415": 35,
				"417": 12,
				"418": 11,
				"425": 34,
				"426": 39,
				"443": 49,
				"515": 38,
				"517": 15,
				"518": 14,
				"525": 37,
				"526": 40,
				"528": 33,
				"529": 27,
				"530": 26,
				"531": 28,
				"532": 36,
				"599": 50,
				"647": 2,
				"689": 1,
				"693": 23,
				"696": 25,
				"697": 17,
				"701": 18,
				"715": 32,
				"722": 22,
				"738": 3,
				"862": 7,
				"895": 4,
				"902": 16
			},
			"1": {
				"21": 4,
				"83": 13,
				"138": 6,
				"182": 7,
				"195": 5,
				"419": 1,
				"519": 2,
				"664": 3,
				"698": 10,
				"734": 8,
				"756": 9,
				"794": 11,
				"860": 12
			},
			"2": {
				"22": 4,
				"84": 12,
				"139": 6,
				"183": 13,
				"196": 5,
				"420": 1,
				"520": 2,
				"665": 3,
				"699": 9,
				"735": 7,
				"757": 8,
				"859": 10,
				"861": 11
			},
			"3": {
				"2": 2,
				"148": 4,
				"154": 5,
				"160": 3,
				"652": 1
			},
			"4": {
				"5": 2,
				"149": 4,
				"155": 5,
				"163": 3,
				"655": 1
			},
			"5": {
				"7": 2,
				"150": 4,
				"156": 5,
				"165": 3,
				"657": 1
			},
			"6": {
				"151": 4,
				"157": 5,
				"166": 3,
				"658": 1,
				"930": 2
			},
			"7": {
				"9": 2,
				"152": 4,
				"158": 5,
				"168": 3,
				"660": 1
			},
			"8": {
				"12": 2,
				"153": 4,
				"159": 5,
				"171": 3,
				"663": 1
			},
			"9": {
				"255": 1
			},
			"10": {
				"353": 1
			}
		},
		"35": {
			"0": {
				"74": 3,
				"256": 5,
				"306": 6,
				"349": 4,
				"426": 8,
				"443": 14,
				"526": 9,
				"599": 15,
				"647": 2,
				"689": 1,
				"701": 10,
				"722": 7,
				"733": 13,
				"862": 12,
				"902": 11
			},
			"1": {
				"21": 2,
				"138": 4,
				"182": 5,
				"195": 3,
				"664": 1
			}
		},
		"36": {
			"0": {
				"74": 4,
				"256": 6,
				"306": 7,
				"349": 5,
				"443": 9,
				"599": 10,
				"601": 3,
				"606": 8,
				"647": 2,
				"689": 1
			},
			"1": {
				"21": 2,
				"195": 3,
				"664": 1
			}
		},
		"37": {
			"0": {
				"443": 1,
				"599": 2
			}
		},
		"38": {
			"0": {
				"74": 4,
				"349": 5,
				"403": 1,
				"413": 7,
				"414": 8,
				"443": 2,
				"599": 3
			}
		},
		"39": {
			"0": {
				"403": 1,
				"443": 2,
				"599": 3
			}
		},
		"40": {
			"0": {
				"443": 3,
				"599": 4,
				"647": 2,
				"689": 1
			}
		},
		"41": {
			"0": {
				"74": 2,
				"103": 19,
				"137": 18,
				"251": 13,
				"252": 14,
				"256": 4,
				"281": 17,
				"306": 5,
				"349": 3,
				"403": 1,
				"409": 6,
				"410": 15,
				"411": 11,
				"430": 7,
				"431": 16,
				"628": 8,
				"692": 12,
				"784": 10,
				"787": 9
			},
			"1": {
				"21": 2,
				"138": 7,
				"182": 8,
				"195": 3,
				"639": 9,
				"664": 1,
				"780": 6,
				"782": 4,
				"785": 5
			},
			"2": {
				"22": 2,
				"139": 7,
				"183": 8,
				"196": 3,
				"640": 9,
				"665": 1,
				"781": 6,
				"783": 4,
				"786": 5
			},
			"3": {
				"64": 1,
				"250": 3,
				"678": 2
			},
			"4": {
				"63": 1,
				"249": 3,
				"677": 2
			}
		},
		"42": {
			"0": {
				"74": 2,
				"349": 1,
				"413": 3,
				"414": 6,
				"443": 4,
				"599": 5
			},
			"1": {
				"557": 1,
				"1865": 2
			},
			"2": {
				"558": 1,
				"1866": 2
			},
			"3": {
				"559": 1,
				"1867": 2
			},
			"4": {
				"560": 1,
				"1868": 2
			},
			"5": {
				"561": 1,
				"1869": 2
			}
		}
	};

/***/ },
/* 1829 */
/***/ function(module, exports) {

	module.exports = {
		"2": {
			"0": {
				"73": [
					1
				],
				"102": [
					1
				],
				"257": [
					1
				],
				"307": [
					1
				],
				"318": [
					1
				],
				"352": [
					1
				],
				"403": [
					1
				],
				"443": [
					1
				],
				"599": [
					1
				],
				"743": [
					1
				],
				"744": [
					1
				]
			},
			"1": {
				"21": [
					1
				],
				"83": [
					1
				],
				"122": [
					1
				],
				"129": [
					1
				],
				"138": [
					1
				],
				"182": [
					1
				],
				"195": [
					1
				],
				"366": [
					1
				],
				"557": [
					1
				],
				"607": [
					1
				],
				"863": [
					1
				],
				"885": [
					1
				]
			},
			"2": {
				"22": [
					1
				],
				"84": [
					1
				],
				"123": [
					1
				],
				"130": [
					1
				],
				"139": [
					1
				],
				"183": [
					1
				],
				"196": [
					1
				],
				"367": [
					1
				],
				"558": [
					1
				],
				"608": [
					1
				],
				"864": [
					1
				],
				"886": [
					1
				]
			},
			"3": {
				"23": [
					1
				],
				"85": [
					1
				],
				"124": [
					1
				],
				"131": [
					1
				],
				"140": [
					1
				],
				"184": [
					1
				],
				"197": [
					1
				],
				"368": [
					1
				],
				"559": [
					1
				],
				"609": [
					1
				],
				"865": [
					1
				],
				"887": [
					1
				]
			},
			"4": {
				"24": [
					1
				],
				"86": [
					1
				],
				"125": [
					1
				],
				"132": [
					1
				],
				"141": [
					1
				],
				"185": [
					1
				],
				"198": [
					1
				],
				"369": [
					1
				],
				"560": [
					1
				],
				"610": [
					1
				],
				"866": [
					1
				],
				"888": [
					1
				]
			},
			"5": {
				"25": [
					1
				],
				"87": [
					1
				],
				"126": [
					1
				],
				"133": [
					1
				],
				"142": [
					1
				],
				"186": [
					1
				],
				"199": [
					1
				],
				"370": [
					1
				],
				"561": [
					1
				],
				"611": [
					1
				],
				"867": [
					1
				],
				"889": [
					1
				]
			},
			"6": {
				"26": [
					1
				],
				"88": [
					1
				],
				"127": [
					1
				],
				"134": [
					1
				],
				"143": [
					1
				],
				"187": [
					1
				],
				"200": [
					1
				],
				"371": [
					1
				],
				"562": [
					1
				],
				"612": [
					1
				],
				"868": [
					1
				],
				"890": [
					1
				]
			},
			"7": {
				"27": [
					1
				],
				"89": [
					1
				],
				"128": [
					1
				],
				"135": [
					1
				],
				"144": [
					1
				],
				"188": [
					1
				],
				"201": [
					1
				],
				"372": [
					1
				],
				"563": [
					1
				],
				"613": [
					1
				],
				"869": [
					1
				],
				"891": [
					1
				]
			}
		},
		"3": {
			"0": {
				"73": [
					1
				],
				"74": [
					1
				],
				"102": [
					1
				],
				"257": [
					1
				],
				"307": [
					1
				],
				"318": [
					1
				],
				"352": [
					1
				],
				"403": [
					1
				],
				"443": [
					1
				],
				"599": [
					1
				],
				"737": [
					1
				],
				"882": [
					1
				]
			},
			"1": {
				"21": [
					1
				],
				"83": [
					1
				],
				"138": [
					1
				],
				"182": [
					1
				],
				"195": [
					1
				],
				"366": [
					1
				],
				"557": [
					1
				],
				"607": [
					1
				],
				"788": [
					1
				],
				"791": [
					1
				],
				"842": [
					1
				],
				"845": [
					1
				],
				"848": [
					1
				],
				"896": [
					1
				]
			},
			"2": {
				"22": [
					1
				],
				"84": [
					1
				],
				"139": [
					1
				],
				"183": [
					1
				],
				"196": [
					1
				],
				"367": [
					1
				],
				"558": [
					1
				],
				"608": [
					1
				],
				"789": [
					1
				],
				"792": [
					1
				],
				"843": [
					1
				],
				"846": [
					1
				],
				"849": [
					1
				],
				"897": [
					1
				]
			},
			"3": {
				"23": [
					1
				],
				"85": [
					1
				],
				"140": [
					1
				],
				"184": [
					1
				],
				"197": [
					1
				],
				"368": [
					1
				],
				"559": [
					1
				],
				"609": [
					1
				],
				"790": [
					1
				],
				"793": [
					1
				],
				"844": [
					1
				],
				"847": [
					1
				],
				"850": [
					1
				],
				"898": [
					1
				]
			},
			"4": {
				"17": [
					1
				],
				"176": [
					1
				],
				"362": [
					1
				]
			},
			"5": {
				"13": [
					1
				],
				"172": [
					1
				],
				"358": [
					1
				]
			},
			"6": {
				"18": [
					1
				],
				"177": [
					1
				],
				"363": [
					1
				]
			},
			"7": {
				"14": [
					1
				],
				"173": [
					1
				],
				"359": [
					1
				]
			}
		},
		"4": {
			"0": {
				"73": [
					1
				],
				"74": [
					1
				],
				"102": [
					1
				],
				"137": [
					1
				],
				"257": [
					1
				],
				"281": [
					1
				],
				"307": [
					1
				],
				"318": [
					1
				],
				"319": [
					1
				],
				"320": [
					1
				],
				"352": [
					1
				],
				"403": [
					1
				],
				"443": [
					1
				],
				"599": [
					1
				],
				"755": [
					1
				],
				"798": [
					1
				],
				"882": [
					1
				],
				"927": [
					1
				]
			},
			"1": {
				"21": [
					1
				],
				"83": [
					1
				],
				"138": [
					1
				],
				"182": [
					1
				],
				"195": [
					1
				],
				"366": [
					1
				],
				"557": [
					1
				],
				"607": [
					1
				],
				"836": [
					1
				],
				"896": [
					1
				],
				"903": [
					1
				],
				"909": [
					1
				],
				"914": [
					1
				],
				"920": [
					1
				]
			},
			"2": {
				"22": [
					1
				],
				"84": [
					1
				],
				"139": [
					1
				],
				"183": [
					1
				],
				"196": [
					1
				],
				"367": [
					1
				],
				"558": [
					1
				],
				"608": [
					1
				],
				"837": [
					1
				],
				"897": [
					1
				],
				"904": [
					1
				],
				"910": [
					1
				],
				"915": [
					1
				],
				"921": [
					1
				]
			},
			"3": {
				"23": [
					1
				],
				"85": [
					1
				],
				"140": [
					1
				],
				"184": [
					1
				],
				"197": [
					1
				],
				"368": [
					1
				],
				"559": [
					1
				],
				"609": [
					1
				],
				"838": [
					1
				],
				"898": [
					1
				],
				"905": [
					1
				],
				"911": [
					1
				],
				"916": [
					1
				],
				"922": [
					1
				]
			},
			"4": {
				"24": [
					1
				],
				"86": [
					1
				],
				"141": [
					1
				],
				"185": [
					1
				],
				"198": [
					1
				],
				"369": [
					1
				],
				"560": [
					1
				],
				"610": [
					1
				],
				"839": [
					1
				],
				"899": [
					1
				],
				"906": [
					1
				],
				"912": [
					1
				],
				"917": [
					1
				],
				"923": [
					1
				]
			},
			"5": {
				"25": [
					1
				],
				"87": [
					1
				],
				"142": [
					1
				],
				"186": [
					1
				],
				"199": [
					1
				],
				"370": [
					1
				],
				"561": [
					1
				],
				"611": [
					1
				],
				"840": [
					1
				],
				"900": [
					1
				],
				"907": [
					1
				],
				"913": [
					1
				],
				"918": [
					1
				],
				"924": [
					1
				]
			},
			"6": {
				"26": [
					1
				],
				"88": [
					1
				],
				"143": [
					1
				],
				"187": [
					1
				],
				"200": [
					1
				],
				"371": [
					1
				],
				"562": [
					1
				],
				"901": [
					1
				],
				"908": [
					1
				],
				"919": [
					1
				],
				"925": [
					1
				]
			},
			"7": {
				"17": [
					1
				],
				"176": [
					1
				],
				"362": [
					1
				]
			},
			"8": {
				"13": [
					1
				],
				"172": [
					1
				],
				"358": [
					1
				]
			},
			"9": {
				"18": [
					1
				],
				"177": [
					1
				],
				"363": [
					1
				]
			},
			"10": {
				"14": [
					1
				],
				"173": [
					1
				],
				"359": [
					1
				]
			},
			"11": {
				"19": [
					1
				],
				"178": [
					1
				],
				"364": [
					1
				]
			},
			"12": {
				"15": [
					1
				],
				"174": [
					1
				],
				"360": [
					1
				]
			},
			"13": {
				"20": [
					1
				],
				"179": [
					1
				],
				"365": [
					1
				]
			},
			"14": {
				"16": [
					1
				],
				"175": [
					1
				],
				"361": [
					1
				]
			}
		},
		"5": {
			"0": {
				"349": [
					1
				],
				"443": [
					1
				],
				"599": [
					1
				],
				"689": [
					1
				]
			}
		},
		"6": {
			"0": {
				"73": [
					1
				],
				"82": [
					1
				],
				"102": [
					1
				],
				"257": [
					1
				],
				"296": [
					1
				],
				"297": [
					1
				],
				"298": [
					1
				],
				"299": [
					1
				],
				"305": [
					1
				],
				"307": [
					1
				],
				"308": [
					1
				],
				"309": [
					1
				],
				"315": [
					1
				],
				"318": [
					1
				],
				"320": [
					1
				],
				"328": [
					1
				],
				"329": [
					1
				],
				"330": [
					1
				],
				"331": [
					1
				],
				"332": [
					1
				],
				"337": [
					1
				],
				"338": [
					1
				],
				"339": [
					1
				],
				"340": [
					1
				],
				"341": [
					1
				],
				"342": [
					1
				],
				"352": [
					1
				],
				"403": [
					1
				],
				"427": [
					1
				],
				"443": [
					1
				],
				"445": [
					1
				],
				"505": [
					1
				],
				"506": [
					1
				],
				"507": [
					1
				],
				"513": [
					1
				],
				"514": [
					1
				],
				"527": [
					1
				],
				"534": [
					1
				],
				"535": [
					1
				],
				"536": [
					1
				],
				"537": [
					1
				],
				"538": [
					1
				],
				"539": [
					1
				],
				"540": [
					1
				],
				"543": [
					1
				],
				"544": [
					1
				],
				"550": [
					1
				],
				"551": [
					1
				],
				"599": [
					1
				],
				"623": [
					1
				],
				"627": [
					1
				],
				"638": [
					1
				],
				"687": [
					1
				],
				"688": [
					1
				],
				"713": [
					1
				],
				"732": [
					1
				],
				"739": [
					1
				],
				"798": [
					1
				],
				"894": [
					1,
					1
				],
				"1861": [
					1
				],
				"1870": [
					1,
					1
				],
				"1871": [
					1
				],
				"1872": [
					1
				]
			},
			"1": {
				"21": [
					1
				],
				"76": [
					1
				],
				"83": [
					1
				],
				"138": [
					1
				],
				"182": [
					1
				],
				"190": [
					1
				],
				"195": [
					1
				],
				"300": [
					1
				],
				"310": [
					1
				],
				"333": [
					1
				],
				"366": [
					1
				],
				"508": [
					1
				],
				"545": [
					1
				],
				"552": [
					1
				],
				"557": [
					1
				],
				"594": [
					1
				],
				"618": [
					1
				],
				"708": [
					1
				],
				"745": [
					1
				],
				"750": [
					1
				],
				"759": [
					1
				],
				"896": [
					1
				]
			},
			"2": {
				"22": [
					1
				],
				"77": [
					1
				],
				"84": [
					1
				],
				"139": [
					1
				],
				"183": [
					1
				],
				"191": [
					1
				],
				"196": [
					1
				],
				"301": [
					1
				],
				"311": [
					1
				],
				"334": [
					1
				],
				"367": [
					1
				],
				"509": [
					1
				],
				"546": [
					1
				],
				"553": [
					1
				],
				"558": [
					1
				],
				"595": [
					1
				],
				"619": [
					1
				],
				"709": [
					1
				],
				"746": [
					1
				],
				"751": [
					1
				],
				"760": [
					1
				],
				"897": [
					1
				]
			},
			"3": {
				"23": [
					1
				],
				"78": [
					1
				],
				"85": [
					1
				],
				"140": [
					1
				],
				"184": [
					1
				],
				"192": [
					1
				],
				"197": [
					1
				],
				"302": [
					1
				],
				"312": [
					1
				],
				"335": [
					1
				],
				"368": [
					1
				],
				"510": [
					1
				],
				"547": [
					1
				],
				"554": [
					1
				],
				"559": [
					1
				],
				"596": [
					1
				],
				"620": [
					1
				],
				"710": [
					1
				],
				"747": [
					1
				],
				"752": [
					1
				],
				"761": [
					1
				],
				"898": [
					1
				]
			},
			"4": {
				"24": [
					1
				],
				"79": [
					1
				],
				"86": [
					1
				],
				"141": [
					1
				],
				"185": [
					1
				],
				"193": [
					1
				],
				"198": [
					1
				],
				"303": [
					1
				],
				"313": [
					1
				],
				"336": [
					1
				],
				"369": [
					1
				],
				"511": [
					1
				],
				"548": [
					1
				],
				"555": [
					1
				],
				"560": [
					1
				],
				"597": [
					1
				],
				"621": [
					1
				],
				"711": [
					1
				],
				"748": [
					1
				],
				"753": [
					1
				],
				"762": [
					1
				],
				"899": [
					1
				]
			},
			"5": {
				"25": [
					1
				],
				"80": [
					1
				],
				"87": [
					1
				],
				"142": [
					1
				],
				"186": [
					1
				],
				"194": [
					1
				],
				"199": [
					1
				],
				"304": [
					1
				],
				"314": [
					1
				],
				"370": [
					1
				],
				"512": [
					1
				],
				"549": [
					1
				],
				"556": [
					1
				],
				"561": [
					1
				],
				"598": [
					1
				],
				"622": [
					1
				],
				"712": [
					1
				],
				"749": [
					1
				],
				"754": [
					1
				],
				"763": [
					1
				],
				"900": [
					1
				]
			}
		},
		"7": {
			"0": {
				"1": [
					1
				],
				"74": [
					1
				],
				"103": [
					1
				],
				"136": [
					1
				],
				"137": [
					1
				],
				"256": [
					1
				],
				"260": [
					1
				],
				"261": [
					1
				],
				"278": [
					1
				],
				"281": [
					1
				],
				"282": [
					1
				],
				"306": [
					1
				],
				"321": [
					1
				],
				"322": [
					1
				],
				"323": [
					1
				],
				"324": [
					1
				],
				"325": [
					1
				],
				"326": [
					1
				],
				"327": [
					1
				],
				"343": [
					1
				],
				"345": [
					1
				],
				"346": [
					1
				],
				"349": [
					1
				],
				"412": [
					1
				],
				"415": [
					1
				],
				"416": [
					1
				],
				"417": [
					1
				],
				"418": [
					1
				],
				"425": [
					1
				],
				"426": [
					1
				],
				"428": [
					1
				],
				"429": [
					1
				],
				"432": [
					1
				],
				"433": [
					1
				],
				"434": [
					1
				],
				"435": [
					1
				],
				"436": [
					1
				],
				"437": [
					1
				],
				"439": [
					1
				],
				"442": [
					1
				],
				"443": [
					1
				],
				"462": [
					1
				],
				"464": [
					1
				],
				"465": [
					1
				],
				"515": [
					1
				],
				"516": [
					1
				],
				"517": [
					1
				],
				"518": [
					1
				],
				"525": [
					1
				],
				"526": [
					1
				],
				"528": [
					1
				],
				"529": [
					1
				],
				"530": [
					1
				],
				"531": [
					1
				],
				"532": [
					1
				],
				"533": [
					1
				],
				"599": [
					1
				],
				"600": [
					1
				],
				"605": [
					1
				],
				"614": [
					1
				],
				"615": [
					1
				],
				"616": [
					1
				],
				"617": [
					1
				],
				"624": [
					1
				],
				"625": [
					1
				],
				"626": [
					1
				],
				"647": [
					1
				],
				"689": [
					1
				],
				"693": [
					1
				],
				"695": [
					1
				],
				"696": [
					1
				],
				"697": [
					1
				],
				"701": [
					1
				],
				"705": [
					1
				],
				"706": [
					1
				],
				"714": [
					1
				],
				"715": [
					1
				],
				"720": [
					1
				],
				"721": [
					1
				],
				"722": [
					1
				],
				"723": [
					1
				],
				"724": [
					1
				],
				"725": [
					1
				],
				"726": [
					1
				],
				"730": [
					1
				],
				"738": [
					1
				],
				"795": [
					1
				],
				"796": [
					1
				],
				"841": [
					1
				],
				"862": [
					1
				],
				"870": [
					1
				],
				"871": [
					1
				],
				"872": [
					1
				],
				"883": [
					1
				],
				"895": [
					1
				],
				"902": [
					1
				],
				"928": [
					1
				]
			},
			"1": {
				"21": [
					1
				],
				"83": [
					1
				],
				"138": [
					1
				],
				"182": [
					1
				],
				"195": [
					1
				],
				"273": [
					1
				],
				"419": [
					1
				],
				"519": [
					1
				],
				"648": [
					1
				],
				"664": [
					1
				],
				"698": [
					1
				],
				"727": [
					1
				],
				"729": [
					1
				],
				"731": [
					1
				],
				"734": [
					1
				],
				"756": [
					1
				],
				"794": [
					1
				],
				"860": [
					1
				]
			},
			"2": {
				"22": [
					1
				],
				"84": [
					1
				],
				"139": [
					1
				],
				"183": [
					1
				],
				"196": [
					1
				],
				"274": [
					1
				],
				"420": [
					1
				],
				"520": [
					1
				],
				"649": [
					1
				],
				"665": [
					1
				],
				"699": [
					1
				],
				"728": [
					1
				],
				"735": [
					1
				],
				"757": [
					1
				],
				"859": [
					1
				],
				"861": [
					1
				]
			},
			"3": {
				"2": [
					1
				],
				"148": [
					1
				],
				"154": [
					1
				],
				"160": [
					1
				],
				"641": [
					1
				],
				"652": [
					1
				]
			},
			"4": {
				"5": [
					1
				],
				"149": [
					1
				],
				"155": [
					1
				],
				"163": [
					1
				],
				"642": [
					1
				],
				"655": [
					1
				]
			},
			"5": {
				"7": [
					1
				],
				"150": [
					1
				],
				"156": [
					1
				],
				"165": [
					1
				],
				"643": [
					1
				],
				"657": [
					1
				]
			},
			"6": {
				"151": [
					1
				],
				"157": [
					1
				],
				"166": [
					1
				],
				"644": [
					1
				],
				"658": [
					1
				],
				"930": [
					1
				]
			},
			"7": {
				"9": [
					1
				],
				"152": [
					1
				],
				"158": [
					1
				],
				"168": [
					1
				],
				"645": [
					1
				],
				"660": [
					1
				]
			},
			"8": {
				"12": [
					1
				],
				"153": [
					1
				],
				"159": [
					1
				],
				"171": [
					1
				],
				"646": [
					1
				],
				"663": [
					1
				]
			},
			"9": {
				"66": [
					1
				],
				"255": [
					1
				],
				"354": [
					1
				],
				"355": [
					1
				],
				"438": [
					1
				],
				"680": [
					1
				]
			},
			"10": {
				"67": [
					1
				],
				"258": [
					1
				],
				"356": [
					1
				],
				"357": [
					1
				],
				"681": [
					1
				]
			},
			"11": {
				"81": [
					1
				],
				"353": [
					1
				],
				"440": [
					1
				],
				"441": [
					1
				],
				"690": [
					1
				]
			},
			"12": {
				"68": [
					1
				],
				"259": [
					1
				],
				"682": [
					1
				]
			},
			"13": {
				"69": [
					1
				],
				"146": [
					1
				],
				"180": [
					1
				],
				"262": [
					1
				],
				"650": [
					1
				],
				"683": [
					1
				],
				"694": [
					1
				],
				"740": [
					1
				]
			},
			"14": {
				"70": [
					1
				],
				"263": [
					1
				],
				"684": [
					1
				]
			},
			"15": {
				"72": [
					1
				],
				"277": [
					1
				],
				"686": [
					1
				]
			},
			"16": {
				"147": [
					1
				],
				"181": [
					1
				],
				"275": [
					1
				],
				"276": [
					1
				],
				"741": [
					1
				]
			}
		},
		"8": {
			"0": {
				"74": [
					1
				],
				"103": [
					1
				],
				"256": [
					1
				],
				"306": [
					1
				],
				"349": [
					1
				],
				"443": [
					1
				],
				"599": [
					1
				],
				"647": [
					1
				],
				"689": [
					1
				]
			},
			"1": {
				"195": [
					1
				],
				"664": [
					1
				]
			},
			"2": {
				"196": [
					1
				],
				"665": [
					1
				]
			},
			"3": {
				"197": [
					1
				],
				"666": [
					1
				]
			},
			"4": {
				"198": [
					1
				],
				"667": [
					1
				]
			}
		},
		"9": {
			"0": {
				"74": [
					1
				],
				"256": [
					1
				],
				"306": [
					1
				],
				"349": [
					1
				],
				"443": [
					1
				],
				"599": [
					1
				],
				"647": [
					1
				],
				"689": [
					1
				]
			},
			"1": {
				"195": [
					1
				],
				"664": [
					1
				]
			},
			"2": {
				"196": [
					1
				],
				"665": [
					1
				]
			}
		},
		"10": {
			"0": {
				"1": [
					1
				],
				"74": [
					1
				],
				"103": [
					1
				],
				"256": [
					1
				],
				"306": [
					1
				],
				"349": [
					1
				],
				"403": [
					1
				],
				"443": [
					1
				],
				"599": [
					1
				]
			}
		},
		"11": {
			"0": {
				"74": [
					1
				],
				"103": [
					1
				],
				"256": [
					1
				],
				"306": [
					1
				],
				"349": [
					1
				],
				"403": [
					1
				],
				"443": [
					1
				],
				"599": [
					1
				]
			}
		},
		"12": {
			"0": {
				"74": [
					1
				],
				"103": [
					1
				],
				"256": [
					1
				],
				"306": [
					1
				],
				"349": [
					1
				],
				"443": [
					1
				],
				"599": [
					1
				],
				"647": [
					1
				],
				"689": [
					1
				]
			}
		},
		"13": {
			"0": {
				"283": [
					1
				],
				"284": [
					1
				],
				"285": [
					1
				],
				"286": [
					1
				],
				"287": [
					1
				],
				"288": [
					1
				],
				"289": [
					1
				],
				"290": [
					1
				],
				"291": [
					1
				],
				"292": [
					1
				],
				"293": [
					1
				],
				"294": [
					1
				],
				"295": [
					1
				],
				"316": [
					1
				],
				"452": [
					1
				],
				"453": [
					1
				],
				"454": [
					1
				],
				"455": [
					1
				],
				"456": [
					1
				],
				"457": [
					1
				],
				"458": [
					1
				],
				"459": [
					1
				],
				"460": [
					1
				],
				"461": [
					1
				]
			}
		},
		"14": {
			"0": {
				"443": [
					1
				],
				"599": [
					1
				]
			}
		},
		"15": {
			"0": {
				"443": [
					1
				],
				"599": [
					1
				]
			}
		},
		"16": {
			"0": {
				"443": [
					1
				],
				"599": [
					1
				]
			}
		},
		"17": {
			"0": {
				"348": [
					1
				],
				"443": [
					1
				],
				"599": [
					1
				]
			}
		},
		"18": {
			"0": {
				"65": [
					1
				],
				"74": [
					1
				],
				"253": [
					1
				],
				"256": [
					1
				],
				"306": [
					1
				],
				"349": [
					1
				],
				"350": [
					1
				],
				"443": [
					1
				],
				"599": [
					1
				],
				"601": [
					1
				],
				"606": [
					1
				],
				"647": [
					1
				],
				"679": [
					1
				],
				"689": [
					1
				],
				"742": [
					1
				],
				"797": [
					1
				],
				"880": [
					1
				],
				"884": [
					1
				],
				"895": [
					1
				]
			},
			"1": {
				"21": [
					1
				],
				"195": [
					1
				],
				"664": [
					1
				],
				"698": [
					1
				],
				"734": [
					1
				]
			},
			"2": {
				"22": [
					1
				],
				"196": [
					1
				],
				"665": [
					1
				],
				"699": [
					1
				],
				"735": [
					1
				]
			},
			"3": {
				"23": [
					1
				],
				"197": [
					1
				],
				"666": [
					1
				],
				"700": [
					1
				],
				"736": [
					1
				]
			}
		},
		"19": {
			"0": {
				"74": [
					1
				],
				"103": [
					1
				],
				"256": [
					1
				],
				"306": [
					1
				],
				"349": [
					1
				],
				"443": [
					1
				],
				"599": [
					1
				],
				"606": [
					1
				],
				"689": [
					1
				],
				"714": [
					1
				],
				"902": [
					1
				]
			},
			"1": {
				"21": [
					1
				],
				"138": [
					1
				],
				"182": [
					1
				],
				"195": [
					1
				],
				"664": [
					1
				],
				"873": [
					1
				],
				"875": [
					1
				],
				"877": [
					1
				]
			},
			"2": {
				"22": [
					1
				],
				"196": [
					1
				],
				"665": [
					1
				],
				"874": [
					1
				],
				"876": [
					1
				],
				"878": [
					1
				]
			}
		},
		"20": {
			"0": {
				"74": [
					1
				],
				"256": [
					1
				],
				"306": [
					1
				],
				"349": [
					1
				],
				"443": [
					1
				],
				"599": [
					1
				],
				"689": [
					1
				]
			},
			"1": {
				"21": [
					1
				],
				"138": [
					1
				],
				"182": [
					1
				],
				"195": [
					1
				],
				"664": [
					1
				],
				"851": [
					1
				]
			},
			"2": {
				"22": [
					1
				],
				"139": [
					1
				],
				"183": [
					1
				],
				"196": [
					1
				],
				"665": [
					1
				],
				"852": [
					1
				]
			},
			"3": {
				"23": [
					1
				],
				"140": [
					1
				],
				"184": [
					1
				],
				"197": [
					1
				],
				"666": [
					1
				],
				"853": [
					1
				]
			},
			"4": {
				"24": [
					1
				],
				"141": [
					1
				],
				"185": [
					1
				],
				"198": [
					1
				],
				"667": [
					1
				],
				"854": [
					1
				]
			},
			"5": {
				"25": [
					1
				],
				"142": [
					1
				],
				"186": [
					1
				],
				"199": [
					1
				],
				"668": [
					1
				],
				"855": [
					1
				]
			},
			"6": {
				"26": [
					1
				],
				"143": [
					1
				],
				"187": [
					1
				],
				"200": [
					1
				],
				"669": [
					1
				],
				"856": [
					1
				]
			},
			"7": {
				"27": [
					1
				],
				"144": [
					1
				],
				"188": [
					1
				],
				"201": [
					1
				],
				"670": [
					1
				],
				"857": [
					1
				]
			},
			"8": {
				"28": [
					1
				],
				"145": [
					1
				],
				"189": [
					1
				],
				"202": [
					1
				],
				"671": [
					1
				],
				"858": [
					1
				]
			}
		},
		"21": {
			"0": {
				"443": [
					1
				],
				"599": [
					1
				]
			}
		},
		"23": {
			"0": {
				"443": [
					1
				],
				"599": [
					1
				]
			}
		},
		"24": {
			"0": {
				"443": [
					1
				],
				"599": [
					1
				]
			}
		},
		"25": {
			"0": {
				"443": [
					1
				],
				"599": [
					1
				]
			}
		},
		"26": {
			"0": {
				"443": [
					1
				],
				"599": [
					1
				]
			}
		},
		"27": {
			"0": {
				"443": [
					1
				],
				"599": [
					1
				]
			}
		},
		"28": {
			"0": {
				"74": [
					1
				],
				"103": [
					1
				],
				"256": [
					1
				],
				"306": [
					1
				],
				"349": [
					1
				],
				"403": [
					1
				],
				"443": [
					1
				],
				"599": [
					1
				],
				"603": [
					1
				],
				"604": [
					1
				],
				"606": [
					1
				],
				"926": [
					1
				]
			}
		},
		"29": {
			"0": {
				"74": [
					1
				],
				"254": [
					1
				],
				"349": [
					1
				],
				"403": [
					1
				],
				"443": [
					1
				],
				"599": [
					1
				]
			},
			"1": {
				"21": [
					1
				],
				"83": [
					1
				],
				"195": [
					1
				],
				"366": [
					1
				],
				"466": [
					1
				],
				"557": [
					1
				],
				"799": [
					1
				]
			},
			"2": {
				"22": [
					1
				],
				"84": [
					1
				],
				"196": [
					1
				],
				"367": [
					1
				],
				"467": [
					1
				],
				"558": [
					1
				],
				"800": [
					1
				]
			},
			"3": {
				"23": [
					1
				],
				"85": [
					1
				],
				"197": [
					1
				],
				"368": [
					1
				],
				"468": [
					1
				],
				"559": [
					1
				],
				"801": [
					1
				]
			},
			"4": {
				"24": [
					1
				],
				"86": [
					1
				],
				"198": [
					1
				],
				"369": [
					1
				],
				"469": [
					1
				],
				"560": [
					1
				],
				"802": [
					1
				]
			},
			"5": {
				"25": [
					1
				],
				"87": [
					1
				],
				"199": [
					1
				],
				"370": [
					1
				],
				"470": [
					1
				],
				"561": [
					1
				],
				"803": [
					1
				]
			},
			"6": {
				"26": [
					1
				],
				"88": [
					1
				],
				"200": [
					1
				],
				"371": [
					1
				],
				"471": [
					1
				],
				"562": [
					1
				],
				"804": [
					1
				]
			},
			"7": {
				"27": [
					1
				],
				"89": [
					1
				],
				"201": [
					1
				],
				"372": [
					1
				],
				"472": [
					1
				],
				"563": [
					1
				],
				"805": [
					1
				]
			},
			"8": {
				"28": [
					1
				],
				"90": [
					1
				],
				"202": [
					1
				],
				"373": [
					1
				],
				"473": [
					1
				],
				"564": [
					1
				],
				"806": [
					1
				]
			},
			"9": {
				"29": [
					1
				],
				"91": [
					1
				],
				"203": [
					1
				],
				"374": [
					1
				],
				"474": [
					1
				],
				"565": [
					1
				],
				"807": [
					1
				]
			},
			"10": {
				"30": [
					1
				],
				"92": [
					1
				],
				"204": [
					1
				],
				"375": [
					1
				],
				"475": [
					1
				],
				"566": [
					1
				],
				"808": [
					1
				]
			},
			"11": {
				"31": [
					1
				],
				"93": [
					1
				],
				"205": [
					1
				],
				"376": [
					1
				],
				"476": [
					1
				],
				"567": [
					1
				],
				"809": [
					1
				]
			},
			"12": {
				"32": [
					1
				],
				"94": [
					1
				],
				"206": [
					1
				],
				"377": [
					1
				],
				"477": [
					1
				],
				"568": [
					1
				],
				"810": [
					1
				]
			},
			"13": {
				"33": [
					1
				],
				"95": [
					1
				],
				"207": [
					1
				],
				"378": [
					1
				],
				"478": [
					1
				],
				"569": [
					1
				],
				"811": [
					1
				]
			},
			"14": {
				"34": [
					1
				],
				"96": [
					1
				],
				"208": [
					1
				],
				"379": [
					1
				],
				"479": [
					1
				],
				"570": [
					1
				],
				"812": [
					1
				]
			},
			"15": {
				"35": [
					1
				],
				"97": [
					1
				],
				"209": [
					1
				],
				"380": [
					1
				],
				"480": [
					1
				],
				"571": [
					1
				],
				"813": [
					1
				]
			},
			"16": {
				"36": [
					1
				],
				"98": [
					1
				],
				"210": [
					1
				],
				"381": [
					1
				],
				"481": [
					1
				],
				"572": [
					1
				],
				"814": [
					1
				]
			},
			"17": {
				"37": [
					1
				],
				"99": [
					1
				],
				"211": [
					1
				],
				"382": [
					1
				],
				"482": [
					1
				],
				"573": [
					1
				],
				"815": [
					1
				]
			},
			"18": {
				"38": [
					1
				],
				"100": [
					1
				],
				"212": [
					1
				],
				"383": [
					1
				],
				"483": [
					1
				],
				"574": [
					1
				],
				"816": [
					1
				]
			},
			"19": {
				"39": [
					1
				],
				"101": [
					1
				],
				"213": [
					1
				],
				"384": [
					1
				],
				"484": [
					1
				],
				"575": [
					1
				],
				"817": [
					1
				]
			},
			"20": {
				"40": [
					1
				],
				"104": [
					1
				],
				"214": [
					1
				],
				"385": [
					1
				],
				"485": [
					1
				],
				"576": [
					1
				],
				"818": [
					1
				]
			},
			"21": {
				"41": [
					1
				],
				"105": [
					1
				],
				"215": [
					1
				],
				"386": [
					1
				],
				"486": [
					1
				],
				"577": [
					1
				],
				"819": [
					1
				]
			},
			"22": {
				"42": [
					1
				],
				"106": [
					1
				],
				"216": [
					1
				],
				"387": [
					1
				],
				"487": [
					1
				],
				"578": [
					1
				],
				"820": [
					1
				]
			},
			"23": {
				"43": [
					1
				],
				"107": [
					1
				],
				"217": [
					1
				],
				"388": [
					1
				],
				"488": [
					1
				],
				"579": [
					1
				],
				"821": [
					1
				]
			},
			"24": {
				"44": [
					1
				],
				"108": [
					1
				],
				"218": [
					1
				],
				"389": [
					1
				],
				"489": [
					1
				],
				"580": [
					1
				],
				"822": [
					1
				]
			},
			"25": {
				"45": [
					1
				],
				"109": [
					1
				],
				"219": [
					1
				],
				"390": [
					1
				],
				"490": [
					1
				],
				"581": [
					1
				],
				"823": [
					1
				]
			},
			"26": {
				"46": [
					1
				],
				"110": [
					1
				],
				"220": [
					1
				],
				"391": [
					1
				],
				"491": [
					1
				],
				"582": [
					1
				],
				"824": [
					1
				]
			},
			"27": {
				"47": [
					1
				],
				"111": [
					1
				],
				"221": [
					1
				],
				"392": [
					1
				],
				"492": [
					1
				],
				"583": [
					1
				],
				"825": [
					1
				]
			},
			"28": {
				"48": [
					1
				],
				"112": [
					1
				],
				"222": [
					1
				],
				"393": [
					1
				],
				"493": [
					1
				],
				"584": [
					1
				],
				"826": [
					1
				]
			},
			"29": {
				"49": [
					1
				],
				"113": [
					1
				],
				"223": [
					1
				],
				"394": [
					1
				],
				"494": [
					1
				],
				"585": [
					1
				],
				"827": [
					1
				]
			},
			"30": {
				"50": [
					1
				],
				"114": [
					1
				],
				"224": [
					1
				],
				"395": [
					1
				],
				"495": [
					1
				],
				"586": [
					1
				],
				"828": [
					1
				]
			},
			"31": {
				"51": [
					1
				],
				"115": [
					1
				],
				"225": [
					1
				],
				"396": [
					1
				],
				"496": [
					1
				],
				"587": [
					1
				],
				"829": [
					1
				]
			},
			"32": {
				"52": [
					1
				],
				"116": [
					1
				],
				"226": [
					1
				],
				"397": [
					1
				],
				"497": [
					1
				],
				"588": [
					1
				],
				"830": [
					1
				]
			},
			"33": {
				"53": [
					1
				],
				"117": [
					1
				],
				"227": [
					1
				],
				"398": [
					1
				],
				"498": [
					1
				],
				"589": [
					1
				],
				"831": [
					1
				]
			},
			"34": {
				"54": [
					1
				],
				"118": [
					1
				],
				"228": [
					1
				],
				"399": [
					1
				],
				"499": [
					1
				],
				"590": [
					1
				],
				"832": [
					1
				]
			},
			"35": {
				"55": [
					1
				],
				"119": [
					1
				],
				"229": [
					1
				],
				"400": [
					1
				],
				"500": [
					1
				],
				"591": [
					1
				],
				"833": [
					1
				]
			},
			"36": {
				"56": [
					1
				],
				"120": [
					1
				],
				"230": [
					1
				],
				"401": [
					1
				],
				"501": [
					1
				],
				"592": [
					1
				],
				"834": [
					1
				]
			},
			"37": {
				"57": [
					1
				],
				"121": [
					1
				],
				"231": [
					1
				],
				"402": [
					1
				],
				"502": [
					1
				],
				"593": [
					1
				],
				"835": [
					1
				]
			}
		},
		"30": {
			"0": {
				"74": [
					1
				],
				"103": [
					1
				],
				"256": [
					1
				],
				"279": [
					1
				],
				"306": [
					1
				],
				"343": [
					1
				],
				"344": [
					1
				],
				"346": [
					1
				],
				"347": [
					1
				],
				"349": [
					1
				],
				"350": [
					1
				],
				"403": [
					1
				],
				"412": [
					1
				],
				"415": [
					1
				],
				"426": [
					1
				],
				"443": [
					1
				],
				"446": [
					1
				],
				"447": [
					1
				],
				"448": [
					1
				],
				"449": [
					1
				],
				"450": [
					1
				],
				"451": [
					1
				],
				"515": [
					1
				],
				"526": [
					1
				],
				"599": [
					1
				],
				"601": [
					1
				],
				"602": [
					1
				],
				"606": [
					1
				],
				"617": [
					1
				],
				"625": [
					1
				],
				"628": [
					1
				],
				"647": [
					1
				],
				"689": [
					1
				],
				"697": [
					1
				],
				"701": [
					1
				],
				"702": [
					1
				],
				"703": [
					1
				],
				"704": [
					1
				],
				"742": [
					1
				],
				"880": [
					1
				],
				"895": [
					1
				],
				"902": [
					1
				]
			},
			"1": {
				"21": [
					1
				],
				"83": [
					1
				],
				"138": [
					1
				],
				"182": [
					1
				],
				"195": [
					1
				],
				"664": [
					1
				],
				"698": [
					1
				],
				"734": [
					1
				],
				"756": [
					1
				]
			},
			"2": {
				"22": [
					1
				],
				"84": [
					1
				],
				"139": [
					1
				],
				"183": [
					1
				],
				"196": [
					1
				],
				"665": [
					1
				],
				"699": [
					1
				],
				"735": [
					1
				],
				"757": [
					1
				]
			},
			"3": {
				"23": [
					1
				],
				"85": [
					1
				],
				"140": [
					1
				],
				"184": [
					1
				],
				"197": [
					1
				],
				"666": [
					1
				],
				"700": [
					1
				],
				"736": [
					1
				],
				"758": [
					1
				]
			},
			"4": {
				"3": [
					1
				],
				"161": [
					1
				],
				"653": [
					1
				]
			},
			"5": {
				"4": [
					1
				],
				"162": [
					1
				],
				"654": [
					1
				]
			},
			"6": {
				"6": [
					1
				],
				"164": [
					1
				],
				"656": [
					1
				]
			},
			"7": {
				"8": [
					1
				],
				"167": [
					1
				],
				"659": [
					1
				]
			},
			"8": {
				"10": [
					1
				],
				"169": [
					1
				],
				"661": [
					1
				]
			},
			"9": {
				"11": [
					1
				],
				"170": [
					1
				],
				"662": [
					1
				]
			}
		},
		"31": {
			"0": {
				"60": [
					1
				],
				"74": [
					1
				],
				"103": [
					1
				],
				"137": [
					1
				],
				"242": [
					1
				],
				"243": [
					1
				],
				"244": [
					1
				],
				"245": [
					1
				],
				"247": [
					1
				],
				"256": [
					1
				],
				"280": [
					1
				],
				"281": [
					1
				],
				"306": [
					1
				],
				"317": [
					1
				],
				"349": [
					1
				],
				"403": [
					1
				],
				"404": [
					1
				],
				"407": [
					1
				],
				"408": [
					1
				],
				"421": [
					1
				],
				"422": [
					1
				],
				"423": [
					1
				],
				"424": [
					1
				],
				"443": [
					1
				],
				"444": [
					1
				],
				"465": [
					1
				],
				"521": [
					1
				],
				"522": [
					1
				],
				"523": [
					1
				],
				"524": [
					1
				],
				"599": [
					1
				],
				"628": [
					1
				],
				"637": [
					1
				],
				"674": [
					1
				],
				"691": [
					1
				],
				"764": [
					1
				],
				"773": [
					1
				],
				"774": [
					1
				],
				"779": [
					1
				],
				"879": [
					1
				],
				"881": [
					1
				]
			},
			"1": {
				"21": [
					1
				],
				"138": [
					1
				],
				"182": [
					1
				],
				"195": [
					1
				],
				"629": [
					1
				],
				"633": [
					1
				],
				"664": [
					1
				],
				"765": [
					1
				],
				"769": [
					1
				],
				"775": [
					1
				]
			},
			"2": {
				"22": [
					1
				],
				"139": [
					1
				],
				"183": [
					1
				],
				"196": [
					1
				],
				"630": [
					1
				],
				"634": [
					1
				],
				"665": [
					1
				],
				"766": [
					1
				],
				"770": [
					1
				],
				"776": [
					1
				]
			},
			"3": {
				"23": [
					1
				],
				"140": [
					1
				],
				"184": [
					1
				],
				"197": [
					1
				],
				"631": [
					1
				],
				"635": [
					1
				],
				"666": [
					1
				],
				"767": [
					1
				],
				"771": [
					1
				],
				"777": [
					1
				]
			},
			"4": {
				"24": [
					1
				],
				"141": [
					1
				],
				"185": [
					1
				],
				"198": [
					1
				],
				"632": [
					1
				],
				"636": [
					1
				],
				"667": [
					1
				],
				"768": [
					1
				],
				"772": [
					1
				],
				"778": [
					1
				]
			},
			"5": {
				"62": [
					1
				],
				"233": [
					1
				],
				"241": [
					1
				],
				"248": [
					1
				],
				"406": [
					1
				],
				"676": [
					1
				]
			},
			"6": {
				"61": [
					1
				],
				"232": [
					1
				],
				"240": [
					1
				],
				"246": [
					1
				],
				"405": [
					1
				],
				"675": [
					1
				]
			},
			"7": {
				"58": [
					1
				],
				"234": [
					1
				],
				"236": [
					1
				],
				"238": [
					1
				],
				"672": [
					1
				]
			},
			"8": {
				"59": [
					1
				],
				"235": [
					1
				],
				"237": [
					1
				],
				"239": [
					1
				],
				"673": [
					1
				]
			}
		},
		"32": {
			"0": {
				"73": [
					1
				],
				"102": [
					1
				],
				"256": [
					1
				],
				"257": [
					1
				],
				"306": [
					1
				],
				"307": [
					1
				],
				"318": [
					1
				],
				"352": [
					1
				],
				"403": [
					1
				],
				"443": [
					1
				],
				"599": [
					1
				],
				"739": [
					1
				]
			},
			"1": {
				"21": [
					1
				],
				"122": [
					1
				],
				"129": [
					1
				],
				"138": [
					1
				],
				"182": [
					1
				],
				"195": [
					1
				],
				"366": [
					1
				],
				"557": [
					1
				],
				"607": [
					1
				]
			},
			"2": {
				"22": [
					1
				],
				"123": [
					1
				],
				"130": [
					1
				],
				"139": [
					1
				],
				"183": [
					1
				],
				"196": [
					1
				],
				"367": [
					1
				],
				"558": [
					1
				],
				"608": [
					1
				]
			},
			"3": {
				"23": [
					1
				],
				"124": [
					1
				],
				"131": [
					1
				],
				"140": [
					1
				],
				"184": [
					1
				],
				"197": [
					1
				],
				"368": [
					1
				],
				"559": [
					1
				],
				"609": [
					1
				]
			},
			"4": {
				"17": [
					1
				],
				"176": [
					1
				],
				"362": [
					1
				]
			},
			"5": {
				"13": [
					1
				],
				"172": [
					1
				],
				"358": [
					1
				]
			},
			"6": {
				"18": [
					1
				],
				"177": [
					1
				],
				"363": [
					1
				]
			},
			"7": {
				"14": [
					1
				],
				"173": [
					1
				],
				"359": [
					1
				]
			},
			"8": {
				"19": [
					1
				],
				"178": [
					1
				],
				"364": [
					1
				]
			},
			"9": {
				"15": [
					1
				],
				"174": [
					1
				],
				"360": [
					1
				]
			}
		},
		"33": {
			"0": {
				"348": [
					1
				],
				"443": [
					1
				],
				"599": [
					1
				]
			}
		},
		"34": {
			"0": {
				"1": [
					1
				],
				"74": [
					1
				],
				"103": [
					1
				],
				"136": [
					1
				],
				"256": [
					1
				],
				"260": [
					1
				],
				"261": [
					1
				],
				"278": [
					1
				],
				"282": [
					1
				],
				"306": [
					1
				],
				"321": [
					1
				],
				"322": [
					1
				],
				"323": [
					1
				],
				"324": [
					1
				],
				"325": [
					1
				],
				"326": [
					1
				],
				"327": [
					1
				],
				"343": [
					1
				],
				"345": [
					1
				],
				"346": [
					1
				],
				"349": [
					1
				],
				"415": [
					1
				],
				"417": [
					1
				],
				"418": [
					1
				],
				"425": [
					1
				],
				"426": [
					1
				],
				"443": [
					1
				],
				"515": [
					1
				],
				"517": [
					1
				],
				"518": [
					1
				],
				"525": [
					1
				],
				"526": [
					1
				],
				"528": [
					1
				],
				"529": [
					1
				],
				"530": [
					1
				],
				"531": [
					1
				],
				"532": [
					1
				],
				"599": [
					1
				],
				"647": [
					1
				],
				"689": [
					1
				],
				"693": [
					1
				],
				"696": [
					1
				],
				"697": [
					1
				],
				"701": [
					1
				],
				"715": [
					1
				],
				"722": [
					1
				],
				"738": [
					1
				],
				"862": [
					1
				],
				"895": [
					1
				],
				"902": [
					1
				]
			},
			"1": {
				"21": [
					1
				],
				"83": [
					1
				],
				"138": [
					1
				],
				"182": [
					1
				],
				"195": [
					1
				],
				"419": [
					1
				],
				"519": [
					1
				],
				"664": [
					1
				],
				"698": [
					1
				],
				"734": [
					1
				],
				"756": [
					1
				],
				"794": [
					1
				],
				"860": [
					1
				]
			},
			"2": {
				"22": [
					1
				],
				"84": [
					1
				],
				"139": [
					1
				],
				"183": [
					1
				],
				"196": [
					1
				],
				"420": [
					1
				],
				"520": [
					1
				],
				"665": [
					1
				],
				"699": [
					1
				],
				"735": [
					1
				],
				"757": [
					1
				],
				"859": [
					1
				],
				"861": [
					1
				]
			},
			"3": {
				"2": [
					1
				],
				"148": [
					1
				],
				"154": [
					1
				],
				"160": [
					1
				],
				"652": [
					1
				]
			},
			"4": {
				"5": [
					1
				],
				"149": [
					1
				],
				"155": [
					1
				],
				"163": [
					1
				],
				"655": [
					1
				]
			},
			"5": {
				"7": [
					1
				],
				"150": [
					1
				],
				"156": [
					1
				],
				"165": [
					1
				],
				"657": [
					1
				]
			},
			"6": {
				"151": [
					1
				],
				"157": [
					1
				],
				"166": [
					1
				],
				"658": [
					1
				],
				"930": [
					1
				]
			},
			"7": {
				"9": [
					1
				],
				"152": [
					1
				],
				"158": [
					1
				],
				"168": [
					1
				],
				"660": [
					1
				]
			},
			"8": {
				"12": [
					1
				],
				"153": [
					1
				],
				"159": [
					1
				],
				"171": [
					1
				],
				"663": [
					1
				]
			},
			"9": {
				"255": [
					1
				]
			},
			"10": {
				"353": [
					1
				]
			}
		},
		"35": {
			"0": {
				"74": [
					1
				],
				"256": [
					1
				],
				"306": [
					1
				],
				"349": [
					1
				],
				"426": [
					1
				],
				"443": [
					1
				],
				"526": [
					1
				],
				"599": [
					1
				],
				"647": [
					1
				],
				"689": [
					1
				],
				"701": [
					1
				],
				"722": [
					1
				],
				"733": [
					1
				],
				"862": [
					1
				],
				"902": [
					1
				]
			},
			"1": {
				"21": [
					1
				],
				"138": [
					1
				],
				"182": [
					1
				],
				"195": [
					1
				],
				"664": [
					1
				]
			}
		},
		"36": {
			"0": {
				"74": [
					1
				],
				"256": [
					1
				],
				"306": [
					1
				],
				"349": [
					1
				],
				"443": [
					1
				],
				"599": [
					1
				],
				"601": [
					1
				],
				"606": [
					1
				],
				"647": [
					1
				],
				"689": [
					1
				]
			},
			"1": {
				"21": [
					1
				],
				"195": [
					1
				],
				"664": [
					1
				]
			}
		},
		"37": {
			"0": {
				"443": [
					1
				],
				"599": [
					1
				]
			}
		},
		"38": {
			"0": {
				"74": [
					1
				],
				"349": [
					1
				],
				"403": [
					1
				],
				"413": [
					1
				],
				"414": [
					1
				],
				"443": [
					1
				],
				"599": [
					1
				]
			}
		},
		"39": {
			"0": {
				"403": [
					1
				],
				"443": [
					1
				],
				"599": [
					1
				]
			}
		},
		"40": {
			"0": {
				"443": [
					1
				],
				"599": [
					1
				],
				"647": [
					1
				],
				"689": [
					1
				]
			}
		},
		"41": {
			"0": {
				"74": [
					1
				],
				"103": [
					1
				],
				"137": [
					1
				],
				"251": [
					1
				],
				"252": [
					1
				],
				"256": [
					1
				],
				"281": [
					1
				],
				"306": [
					1
				],
				"349": [
					1
				],
				"403": [
					1
				],
				"409": [
					1
				],
				"410": [
					1
				],
				"411": [
					1
				],
				"430": [
					1
				],
				"431": [
					1
				],
				"628": [
					1
				],
				"692": [
					1
				],
				"784": [
					1
				],
				"787": [
					1
				]
			},
			"1": {
				"21": [
					1
				],
				"138": [
					1
				],
				"182": [
					1
				],
				"195": [
					1
				],
				"639": [
					1
				],
				"664": [
					1
				],
				"780": [
					1
				],
				"782": [
					1
				],
				"785": [
					1
				]
			},
			"2": {
				"22": [
					1
				],
				"139": [
					1
				],
				"183": [
					1
				],
				"196": [
					1
				],
				"640": [
					1
				],
				"665": [
					1
				],
				"781": [
					1
				],
				"783": [
					1
				],
				"786": [
					1
				]
			},
			"3": {
				"64": [
					1
				],
				"250": [
					1
				],
				"678": [
					1
				]
			},
			"4": {
				"63": [
					1
				],
				"249": [
					1
				],
				"677": [
					1
				]
			}
		},
		"42": {
			"0": {
				"74": [
					1
				],
				"349": [
					1
				],
				"413": [
					1
				],
				"414": [
					1
				],
				"443": [
					1
				],
				"599": [
					1
				]
			},
			"1": {
				"557": [
					1
				],
				"1865": [
					1
				]
			},
			"2": {
				"558": [
					1
				],
				"1866": [
					1
				]
			},
			"3": {
				"559": [
					1
				],
				"1867": [
					1
				]
			},
			"4": {
				"560": [
					1
				],
				"1868": [
					1
				]
			},
			"5": {
				"561": [
					1
				],
				"1869": [
					1
				]
			}
		}
	};

/***/ },
/* 1830 */
/***/ function(module, exports) {

	module.exports = {
		"header.navigation.sports": "Sports",
		"header.navigation.live": "Live",
		"header.navigation.cybersport": "Esports",
		"header.navigation.results": "Results",
		"header.navigation.fastsport": "Quick games",
		"header.navigation.promotions": "Bonuses & Promotions",
		"header.navigation.more": "More",
		"header.help": "Help",
		"header.locale.choose": "Select language:",
		"header.menu.menu_text": "Menu",
		"header.menu.company_news": "Company news",
		"header.menu.regulations": "Terms & conditions",
		"header.menu.responsible_game": "Responsible gaming",
		"header.menu.contact_information": "Contact information",
		"header.menu.betting_shop": "List of betting shops",
		"header.menu.players_best_bets": "Top winnings",
		"header.menu.internet_bonus": "Bonuses & promotions",
		"header.menu.privacy_policy": "Privacy policy",
		"header.user_menu.title": "Profile",
		"header.user_menu.account_num": "Account ID",
		"header.user_menu.recharge": "Deposit",
		"header.user_menu.briefcase": "Bank",
		"header.user_menu.bet_history": "Bet history",
		"header.user_menu.account_history": "Account history",
		"header.user_menu.withdraw": "Withdraw",
		"header.user_menu.opex_checks": "«Opex» checks",
		"header.user_menu.usdt_checks": "«USD₮» checks",
		"header.user_menu.profile": "My profile",
		"header.user_menu.bonus": "Bonus",
		"header.user_menu.logout": "Logout",
		"header.freebet.title.default": "A free bet (free bet) is available to you for the amount of {sum}{currency}\nStart of action from {start}\nEnd of action to {end}",
		"header.freebet.title.promocode": "A free bet (free bet) is available to you by promo code {promocode} for the amount of {sum}{currency}\nstart of action from {start} \nend of action before {end}",
		"header.freebet.max_factor": "Use it to place any bets with max odd {maxFactor}.",
		"header.freebet.valid_thru": "Valid from {startDate}",
		"header.freebet.valid_until": "Expires on {expireDate}",
		"header.freebet.details": "Read more about Free Bet",
		"header.games": "Games",
		"header.gamesFromVivo": "Vivo Games",
		"notification.new_message.new_message": "New message",
		"notification.new_message.proceed_to_messages": "Messages",
		"notification.new_message.close": "Close",
		"menu.bookmarks": "Favorites",
		"menu.others": "Others",
		"menu.all_sport": "All sports",
		"menu.popular_sport": "Popular Sports",
		"menu.calendar": "Live Events Schedule",
		"grid.menu.title": "Event menu",
		"grid.menu.collapse_all_events": "Collapse all events",
		"grid.menu.expand_all_events": "Expand all events",
		"grid.menu.collapse_all_groups": "Collapse all additional bets",
		"grid.menu.expand_all_groups": "Expand all additional bets",
		"grid.menu.display_line_numbers": "Display line numbers",
		"grid.menu.hide_line_numbers": "Hide line numbers",
		"grid.menu.prematch_filter.title": "Show",
		"grid.menu.prematch_filter.all_time": "All events",
		"grid.menu.prematch_filter.next_hour": "Started in 1 hour",
		"grid.menu.prematch_filter.next_2_hours": "Started in 2 hours",
		"grid.menu.prematch_filter.next_4_hours": "Started in 4 hours",
		"grid.menu.prematch_filter.next_6_hours": "Started in 6 hours",
		"grid.menu.prematch_filter.next_12_hours": "Started in 12 hours",
		"grid.menu.prematch_filter.next_day": "Started in 1 day",
		"grid.menu.prematch_filter.next_2_days": "Started in 2 days",
		"grid.header.event": "Sports betting",
		"grid.header.win1": "W1",
		"grid.header.draw": "X",
		"grid.header.win2": "W2",
		"grid.header.win1_draw": "1X",
		"grid.header.win12": "12",
		"grid.header.draw_win2": "X2",
		"grid.header.handicap": "HAN",
		"grid.header.handicap1": "1",
		"grid.header.handicap2": "2",
		"grid.header.under": "UND",
		"grid.header.total": "TOT",
		"grid.header.over": "OVR",
		"grid.header.live_bets_online": " live betting online",
		"grid.header.football": "Football",
		"grid.header.tennis": "Tennis",
		"grid.header.cybersport": "Cybersport",
		"grid.header.hockey": "Hockey",
		"grid.header.basketball": "Basketball",
		"grid.header.volleyball": "Volleyball",
		"grid.header.handball": "Handball",
		"grid.header.boxing": "Online boxing betting",
		"grid.header.UFC_MMA": "Betting on UFC and MMA online",
		"grid.header.american_football": "Online American Football Betting",
		"grid.header.table_tennis": "Online table tennis betting",
		"grid.header.live.matches": "Live matches",
		"grid.match-current-time.forward": "{minute}'",
		"grid.match-current-time.backward": "< {minute}' rem.",
		"grid.match-current-scores.not_started": " Match not started",
		"grid.match-current-scores.finished": " Match finished",
		"grid.match.datetime_at": "at",
		"grid.match.today": "Today",
		"grid.match.tomorrow": "Tomorrow",
		"play.stream.video": "Live Streaming Available",
		"login.to.watch": "Please log in to view",
		"timetable.title": "Upcoming Live Events Schedule",
		"timetable.time_filter": "All events",
		"timetable.sort_by_time": "Sort by time",
		"timetable.sort_by_league": "Sort by competition",
		"timetable.matches_filter_menu.title": "Show",
		"timetable.matches_filter_menu.no_filter": "All events",
		"timetable.matches_filter_menu.one_hour": "Started in 1 hour",
		"timetable.matches_filter_menu.two_hours": "Started in 2 hours",
		"timetable.matches_filter_menu.four_hours": "Started in 4 hours",
		"timetable.matches_filter_menu.six_hours": "Started in 6 hours",
		"timetable.matches_filter_menu.twelve_hours": "Started in 12 hours",
		"timetable.matches_filter_menu.one_day": "Started in 1 day",
		"timetable.matches_filter_menu.two_days": "Started in 2 days",
		"betpanel.title": "Bets",
		"betpanel.help": "To select a bet click on any price.",
		"coupon.title": "New Bet",
		"coupon.make_bet": "Place Bet",
		"coupon.rate_unavailable": "Rate unavailable",
		"coupon.stake_title": "Outcome:",
		"coupon.rate_title": "Odd:",
		"coupon.rate_changed": "Odd changed",
		"coupon.confirm_rate_value_change": "Accept",
		"coupon.stake_hint": "Stake",
		"coupon.min_amount_hint": "Min.",
		"coupon.max_amount_hint": "Max. {amount} {resource}",
		"coupon.bet_type_hint": "Bet type",
		"coupon.total_odd_hint": "Total odd",
		"coupon.possible_winning_hint": "Possible winning",
		"coupon.possible_winning_hint_short": "To return",
		"coupon.not_possible_stake": "This bet is not possible",
		"coupon.menu.title": "Bet settings",
		"coupon.menu.one-click_checkbox": "One-click bet",
		"coupon.menu.one-click_amount": "Stake",
		"coupon.menu.accept_factor_increase": "Accept the increase in odds",
		"coupon.menu.accept_factor_decrease": "Accept the decrease in odds",
		"coupon.menu.accept_total_and_handicap_change": "",
		"coupon.menu.favouriteBets": "Set favorite stake amounts",
		"coupon.menu.favouriteBet": "Stake {num}",
		"coupon.sum_label": "Sum",
		"coupon_bet_promocode_not_found1": "Promo code not found",
		"coupon_bet_for_get_freebet_fill_balance21": "To get a free bet you need to top up your account in the amount of {amount} {currency}",
		"coupon_bet_for_using_freebet_make_stake_more22": "To use the free bet, you must place a bet of at least {amount} {currency}",
		"coupon_bet_for_using_freebet_nessery_auth24": "To use the free bet, account identification is required",
		"coupon_bet_for_stake_type32": "Applies to bet type: {amount}",
		"coupon_bet_not_for_stake_type37": "Not applicable for this match",
		"coupon_bet_not_for_the_league38": "Not applicable to this league",
		"coupon_bet_min_coef_should33": "The minimum odd must be {amount}",
		"coupon_for_using_freebet_nesessarry_choose_more35": "To use a free bet, you must select at least {amount} events",
		"coupon_bet_nessary_should_more23": "Bets amount must exceed {amount}",
		"coupon_bet_coef_stakes_changed2": " Odds have been changed",
		"coupon_bet_validation_is_not_accept31": "Promo code is only available in {value}",
		"coupon_bet_freebet_sum_not_equal_sum_stake36": "Free bet amount is lower/higher than the bet amount",
		"coupon_bet_validation_is_not_accept_by_minCoef34": "The odd should not exceed {amount}",
		"bet_type.ordinar": "Single",
		"bet_type.accumulator": "Combo",
		"bet_type.looseToWinAccumulator": "Lose-to-Win Combo",
		"bet_type.system": "System {rank} of {count}",
		"bet_title.new_bet": "New bet",
		"bet_status.not_accepted": "Not Accepted",
		"bet_status.accepted": "Unsettled",
		"bet_status.canceled": "Canceled",
		"bet_status.sold": "Sold",
		"bet_status.won": "Won",
		"bet_status.lost": "Lost",
		"bet_history.refund": "Refund",
		"bet_history.bet_under_consideration": "Please wait...",
		"bet_history.bet_under_consideration_tooltip": "Bet is under consideration",
		"bet_history.sell": "Cash out",
		"bet_history.sell_cancel": "Cancel",
		"bet_history.cashout_amount_changed": "Cashout amount changed",
		"bet_history.cashout_confirmation": "Confirm bet cash out",
		"bet_history.event_stake_cashout_forbidden": "Event stake cashout is forbidden",
		"bet_history.rates_changed": "Rates<br/>changed",
		"bet_history.big_stake_cancel": "Cancel bet",
		"bet_history.rate": "Odd: ",
		"bet_history.stake": "Outcome: ",
		"bet_history.errors.insufficient_funds": "Insufficient funds",
		"bet_history.errors.account_locked": "Account is locked",
		"bet_history.errors.system_not_allowed_for_freebet": "'System' is not allowed for Freebet",
		"bet_history.errors.incorrect_stake_data": "Wrong stake data",
		"bet_history.errors.min_stake_amount": "Min stake amount {minAmount} {currency}",
		"bet_history.errors.incorrect_virtual_stake": "Incorrect virtual stake",
		"bet_history.errors.incorrect_freebet_stake": "Incorrect FreeBet stake",
		"bet_history.errors.existing_active_stake": "System error",
		"bet_history.errors.no_big_stake_permission": "Big stake not allowed",
		"bet_history.errors.freebet_big_stake": "Big FreeBet stakes denied",
		"bet_history.errors.bet_not_accepted_by_terms": "To use this bonus, you need to fulfill the conditions specified in the promo code description.",
		"news.read_title": "Read",
		"news.company_news": "Company News",
		"live.error.connection_lost": "Connection failure, please standby",
		"popular.title": "Popular sports betting",
		"popular.win1": "W1",
		"popular.draw": "X",
		"popular.win2": "W2",
		"header.signin.join_title": "Join now",
		"header.signin.title": "Sign In",
		"sign_in.phone": "Phone",
		"sign_in.email": "E-mail",
		"sign_in.login": "Login",
		"sign_in.or": "or",
		"sign_in.title": "Log in to Existing Account",
		"sign_in.requisite": "Requisite",
		"sign_in.password": "Password",
		"sign_in.log_in": "Sign In",
		"sign_in.resend_activation": "Send",
		"sign_in.join": "Join now",
		"sign_in.forgot": "Forgot username or password",
		"sign_in.activation_sent": "The message with activation link has been sent to {email}",
		"sign_in.errors.invalid_credentials": "Incorrect username or password",
		"sign_in.errors.user_blocked": "Too many attempts. Please try again in 15 minutes",
		"sign_in.errors.internal": "Error occured. Please contact tech support",
		"sign_in.errors.not_activated": "Your account is not activated. Send activation link to {email} again?",
		"sign_in.errors.wrong_certificate": "Your certificate has been blocked. Please contact tech support",
		"password_recovery.title": "Account recovery",
		"password_recovery.sent_to": "Password recovery instructions were sent to <strong>{email}</strong>",
		"password_recovery.sent_repeatedly": "We've sent a message with password recovery information to <strong>{email}</strong> several times. For security reasons, please contact our customer care service.",
		"password_recovery.sms_exceeded": "We've sent a message to your number with account recovery information twice. Please wait for the SMS, or else contact our customer care service.",
		"password_recovery.delivery_condition": "If you do not receive message from us in 5 minutes, check the 'Spam' folder",
		"password_recovery.support": "Otherwise, contact support via online chat",
		"password_recovery.registration_requisite": "Enter either username, account number, e-mail address or phone number (in format {mask}), you have used to register the account with:",
		"password_recovery.requisite": "Requisite",
		"password_recovery.recover_title": "Recover",
		"password_recovery.sent_via_sms": "Password was sent to <strong>{phone}</strong>",
		"password_recovery.support_phone": "If you do not receive SMS in the next few minutes, contact customer support via online chat",
		"password_recovery.errors.invalid_credentials": "User not found",
		"password_recovery.errors.internal_error": "Internal error",
		"password_recovery.errors.blocked": "Too many requests. Please try again in 15 minutes",
		"footer.fairplay.copyright": "&copy; {year} FairPlay Bookmaker Company",
		"footer.fairplay.copyright_kz": "&copy; {year} BETtery LLP. Trade mark \"Fair Play\" License # 320 issued on 23.08.2019",
		"footer.fairplay.copyright_ringobet": "&copy; {year} «TakeBet» LLP. Trade mark \"RingoBet\" License # 34 issued on 12.07.2022",
		"join.fast_registration_title": "Quick registration",
		"join.registration_title": "Regular registration",
		"join.title": "Open account",
		"join.login": "Username",
		"join.password": "Password",
		"join.password_repeat": "Retype password",
		"join.first_name": "First name",
		"join.last_name": "Last name",
		"join.dob": "Date of birth",
		"join.email": "E-mail",
		"join.phone": "Mobile phone",
		"join.city": "City",
		"join.country": "Country",
		"join.currency": "Account currency",
		"join.language": "Language",
		"join.timezone": "Timezone",
		"join.promo": "Promo code",
		"join.have_promo": "Have promo code?",
		"join.button_join": "Join now",
		"join.tac_agree": "I am at least 18 years old (for Kazakhstan citizen: at least 21 years old) and I have read, accept and agree to the <a href=\"{rulesLink}\" target=\"_blank\">Terms & Conditions</a>. I also allow to process my personal data using automated devices as described in <a href=\"{privacyLink}\" target=\"_blank\">Privacy Policy</a>",
		"join.real_info_warning": "Warning! Please provide your real personal data, which should match with your identity document (passport, driving license) when withdrawing winnings. You won’t be able to edit your credentials after account creation.",
		"join.link_sent_to": "Activation link was sent to {email}",
		"join.fast.type": "Register by",
		"join.fast.type.sms": "SMS",
		"join.fast.type.email": "Email",
		"join.fast.phone": "Mobile phone",
		"join.fast.email": "Email",
		"join.fast.currency": "Account currency",
		"join.fast.button_join": "Join now",
		"join.fast.tac_agree": "By pressing on this button you agree with the <a href=\"{rulesLink}\" target=\"_blank\">terms and conditions</a> of the company, <a href=\"{privacyLink}\" target=\"_blank\">privacy policy</a> and confirm that you are of legal age.",
		"join.fast.tac_agree_ringo": "By pressing on this button you agree with the <a href=\"{rulesLink}\" target=\"_blank\">terms and conditions</a> of the company, <a href=\"{privacyLink}\" target=\"_blank\">privacy policy</a> and confirm that you are over 21.",
		"join.fast.phone_confirm.title": "Phone number confirmation",
		"join.fast.phone_confirm.confirm_button": "Confirm",
		"join.fast.phone_confirm.confirmation_code": "Confirmation code",
		"join.fast.phone_confirm.sms_received_text": "SMS with confirmation code was sent to you. Use it to confirm your phone number. Please note that SMS delivery may take more than a minute.",
		"join.fast.phone_confirm.sms_sent_text": "Message was sent. ",
		"join.fast.phone_confirm.sms_resendinfo_text": "You will be able to resend it in {seconds} seconds. ",
		"join.fast.phone_confirm.call_resendinfo_text": "You can request confirmation again after {seconds} seconds.",
		"join.fast.phone_confirm.sms_resend_text": "Send SMS with code again",
		"join.fast.phone_confirm.call_resend_text": "Request confirmation again.",
		"join.fast.phone_confirm.sms_resend_button_text": "Send SMS",
		"join.fast.phone_confirm.call_resend_button_text": "Request",
		"join.fast.success.text": "Your account was successfully activated!",
		"join.fast.success.recharge_text": "Deposit and start playing",
		"join.fast.success.btn_recharge_text": "Deposit",
		"join.errors.internal": "Error occured. Try again later",
		"join.errors.smsexceeded": "We've sent a message to your number with account confirmation twice. Please wait for the SMS, or enter your e-mail and we'll send you information about account confirmation.",
		"join.errors.login_taken": "Username is taken",
		"join.errors.email_taken": "E-mail is already registered",
		"join.errors.phone_taken": "Cell phone is already registered",
		"join.errors.phone_not_found": "Invalid phone number",
		"join.errors.required_field": "Required field",
		"join.errors.promo_length_error": "Maximum 4 symbols",
		"join.errors.login_requirements": "At least 4 symbols, english letters and numbers",
		"join.errors.passwords_not_equal": "Passwords do not match",
		"join.errors.email_invalid": "Invalid email",
		"join.errors.invalid_promo": "Invalid promo code",
		"join.errors.phone_invalid": "Invalid phone number",
		"join.errors.age_incorrect": "Invalid birth date",
		"join.errors.age_illegal": "Illegal age",
		"join.errors.date_invalid": "Invalid birth date",
		"join.password_changed": "Password changed",
		"join.fast.phone_confirm.errors.confirmation_fail": "Error during confirmation, try again",
		"join.fast.phone_confirm.errors.sms_exceeded": "We've sent a message to your number with account confirmation twice. Please wait for the SMS, or enter your e-mail and we'll send you information about account confirmation.",
		"join.fast.phone_confirm.errors.invalid_code": "Invalid confirmation code",
		"phone_confirm.title": "Phone number confirmation",
		"phone_confirm.phone": "Mobile phone number",
		"phone_confirm.sms_text": "Confirmation code will be sent via SMS to the specified cell phone",
		"phone_confirm.confirm_button": "Confirm",
		"phone_confirm.denial": "I’m not interested, create the account without bonus",
		"phone_confirm.conditions": "You need to confirm your cell phone to participate in bonus-actions",
		"phone_confirm.confirmation_code": "Confirmation code",
		"phone_confirm.sms_received_text": "Enter the confirmation code from the SMS sent to number {phone}",
		"phone_confirm.success": "Phone number {phone} successfully confirmed!",
		"phone_confirm.start_playing": "Start Betting Now",
		"phone_confirm.errors.confirmation_fail": "Error during confirmation, try again",
		"phone_confirm.errors.phone_taken": "Cell phone is already registered",
		"phone_confirm.phone_hint": "Use international prefix",
		"special_offers.site146_proposal": "You are eligible to apply for a “1000 KZT Welcome Bonus” with the promo code you have entered in the previous step! <br />Please confirm your mobile phone number to receive the bonus. We will send an SMS to the following number with a confirmation code, which you will need to enter during the next step.",
		"special_offers.site146_accepted": "The bonus has been applied to your account.",
		"pages.main.title": "FairPlay - Bookmaker Company",
		"pages.main.description": "FairPlay - Bookmaker Company",
		"pages.live.title": "FairPlay - Bookmaker Company",
		"pages.live.description": "FairPlay - Bookmaker Company",
		"pages.sports.title": "Ставки на спорт в интернет-букмекере №1 в Казахстане — FairPlay",
		"pages.sports.description": "Сделать ставку онлайн очень просто — укажите интересующее вас спортивное событие, выберите желаемый исход и введите сумму ставки. Заключите пари прямо сейчас!",
		"pages.timetable.title": "Спортивные трансляции. Расписание предстоящих матчей.",
		"pages.timetable.description": "Список онлайн трансляций спортивных событий, для которых возможны букмекерские ставки.",
		"betpanel.unauth.how_to_bet": "How to Place a Bet?",
		"betpanel.unauth.to_configure_coupon": "To modify betslip settings, please",
		"betpanel.unauth.auth_or_register": "{signTrigger} or {joinTrigger} to start betting.",
		"betpanel.unauth.time_to_bet": "Now it’s time to place a bet!",
		"betpanel.unauth.sign_trigger": "Sign in",
		"betpanel.unauth.join_trigger": "register",
		"betpanel.unauth.to_place_bet": "To place the bet please",
		"betpanel.unauth.should_auth": "Sign in",
		"betpanel.unauth.should_register": "Join now",
		"betpanel.unauth.auth_or_register_to_bet": "{signTrigger} or {joinTrigger}",
		"timezones.item_1": "Asia/Almaty",
		"timezones.item_2": "Europe/Moscow",
		"create-password.modla-title": "Create password",
		"create-password.profile_password_form_new_password_label": "New password",
		"create-password.profile_password_form_retype_password": "Retype new password",
		"create-password.profile_password_form_btn_msg": "Save",
		"create-password.limit_form_error_empty_field": "Required",
		"create-password.password_form_error_mismatch": "Password confirmation didn't match",
		"create-password.password_changed": "Password changed",
		"betgames.disclaimer1": "All bets placed on BetgamesTV games are bets placed on real upcoming events. These bets do not relate to the term \"gambling\" as defined by the Gaming Law and are therefore not categorised as being of an online-casino nature.",
		"betgames.disclaimer2": "\"Fair Play\" does not participate in the organization of BetgamesTV events and neither the bookmaker, nor its customers are involved at any stage of the events process. The organizer of BetgamesTV events is the company \"TV ZAIDIMAI\". All BetgamesTV events are able to be viewed by customers as they take place via live streams. Neither the bookmaker, not its customers have any influence over the results of the events, which are organized independently and are published on official websites pertaining to the organizer.",
		"games.virtual-sport": "Virtual sports",
		"games.auth-required": "Authorization required",
		"games.vivo_games": "Live casino - roulette, poker, blackjack, baccarat…",
		"games.red_rake": "Slots, Bingo, Poker, Roulette",
		"games.leap_gaming": "Virtual sports, Horse and Dog Racing, Slots",
		"games.vivo_slots": "Slot games",
		"games.tv_bet": "TV games - blackjack, poker, keno, wheel...",
		"games.fastsport": "Quick sport",
		"games.tv_bet_roullette": "Live Roulette",
		"games.xpress": "Slots, casino, live games",
		"games.jacktop": "Live poker, blackjack, baccarat",
		"games.jacktop.black_jack": "Blackjack",
		"games.jacktop.roulette": "Roulette",
		"games.jacktop.poker": "Poker",
		"games.jacktop.baccarat": "Baccarat",
		"games.back_to_games": "Back to all games",
		"games.back_to_slots": "Back to slot games",
		"games.new": "New Games",
		"games.more": "See 20 More",
		"games.all_slots": "All Slots",
		"game.search": "search",
		"games.featured": "Featured Games",
		"games.name_of_games": "Game Name",
		"games.all": "All",
		"games.gamesSlots": "Gaming slot machines",
		"games.sport_vfl": "Football League",
		"games.sport_vfcc": "Football Champions Cup",
		"games.sport_vfwc": "Football World Cup",
		"games.sport_vfc": "Football Euro Cup 2020",
		"games.sport_vfac": "Football Asian Cup",
		"games.sport_vbl": "Basketball League",
		"verify_form.title": "Upload or drag and drop images. The document should fit within the frame entirely, and the information should be legible.",
		"verify_form.available_files": "Available files: image/jpeg, image/png",
		"verify_form.max_file_size": "Max file size: 20.00 MB",
		"verify_form.document_front_side": "Front side of the document",
		"verify_form.document_back_side": "Back side of the document",
		"verify_form.selfie_with_document": "Selfie with the document",
		"verify_form.submit": "Submit",
		"promocode.error.not_found": "Promocode not found",
		"promocode.error.not_active": "Promocode or channel is not active",
		"promocode.error.used": "Promocode has already been used",
		"promocode.error.not_available": "Promocode is not available",
		"promocode.title": "Promocode",
		"promocode.tab": "Promocodes",
		"promocode.enter": "Enter promocode",
		"promocode.apply": "Apply",
		"bonus.banner_title": "Double your winnings",
		"bonus.banner_text": "Place multiple bets and we'll double your winnings!",
		"instagram.banner.iphone_title": "Instagram promotion @fairplay",
		"instagram.banner.freebet_text": "FREEBET GIVEAWAY",
		"instagram.banner.center_text": "Instagram promo",
		"newGames.showAllGames": "View all games",
		"newGames.showRecentGames": "View recent games",
		"newGames.showFavorites": "View favorite games",
		"newGames.allTypes": "All types",
		"newGames.allProviders": "All providers",
		"newGames.popular": "Popular",
		"newGames.showAll": "View all",
		"newGames.searchGame": "Search by game name",
		"newGames.goBackToGames": "Back to games",
		"newGames.allGamesForCategory": "All games for category",
		"newGames.favoriteGames": "Favorite games",
		"newGames.recentGames": "Recent games",
		"newGames.recentGamesNot": "You have no recent games",
		"newGames.favoriteGamesNot": "You have no favorite games",
		"newGames.showMore": "Show more",
		"newGames.allGames": "All Games",
		"newGames.New": "New",
		"newGames.Hot": "Hot"
	};

/***/ },
/* 1831 */
/***/ function(module, exports) {

	module.exports = {
		"header.navigation.sports": "Спорт",
		"header.navigation.live": "Тіркелу",
		"header.navigation.cybersport": "Киберспорт",
		"header.navigation.results": "Нәтижелер",
		"header.navigation.fastsport": "Жылдам ойындар",
		"header.navigation.promotions": "Акциялар мен бонустар",
		"header.navigation.more": "Қосымша",
		"header.help": "Көмек",
		"header.locale.choose": "Тілді таңдау:",
		"header.menu.menu_text": "Мәзір",
		"header.menu.company_news": "Компания жаңалықтары",
		"header.menu.regulations": "Ережелер",
		"header.menu.responsible_game": "Масқара ойын",
		"header.menu.contact_information": "Байланыс мәліметтері",
		"header.menu.betting_shop": "Ставкаларды қабылдау орны",
		"header.menu.players_best_bets": "Ойыншылардың ең жақсы ставкалары",
		"header.menu.internet_bonus": "Акциялар мен бонустар",
		"header.menu.privacy_policy": "Жеке мәселелер политикасы",
		"header.user_menu.title": "Профиль",
		"header.user_menu.account_num": "Тіркеу нөмірі",
		"header.user_menu.recharge": "Балансты толтыру",
		"header.user_menu.briefcase": "Ставкалар портфелі",
		"header.user_menu.bet_history": "Ставкалар тарихы",
		"header.user_menu.account_history": "Есеп тарихы",
		"header.user_menu.withdraw": "Балансты алу",
		"header.user_menu.opex_checks": "Чектер «Opex»",
		"header.user_menu.usdt_checks": "Чектер «USD₮»",
		"header.user_menu.profile": "Менің профилім",
		"header.user_menu.bonus": "Бонустар",
		"header.user_menu.logout": "Шығу",
		"header.freebet.title.default": "Сізге {sum}{currency} сомасына тегін ставка (фрибет) қолжетімді\nӘрекеттің басталуы {start}\nӘрекеттің соңы {end}",
		"header.freebet.title.promocode": "Сізге {promocode} промо-коды бойынша {sum}{currency} сомасына тегін ставка (freebet) қолжетімді\nәрекеттің басталуы {start} \nәрекеттің соңы {end}",
		"header.freebet.max_factor": "Максималды коеффициентпен барлық беттерге шашу.",
		"header.freebet.valid_thru": "{startDate} күнінен бастап өтетін уақыт",
		"header.freebet.valid_until": "{expireDate} күнге дейін өтетін уақыт",
		"header.freebet.details": "Фрибет туралы толығырақ",
		"header.games": "Ойындар",
		"header.gamesFromVivo": "Vivo ұсынған ойындар",
		"notification.new_message.new_message": "Жаңа хабарлама",
		"notification.new_message.proceed_to_messages": "Хабарламаларға өту",
		"notification.new_message.close": "Жабу",
		"menu.bookmarks": "Таңдаулы",
		"menu.others": "Басқа",
		"menu.all_sport": "Барлық оқиғалар",
		"menu.popular_sport": "Танымал оқиғалар",
		"menu.calendar": "Кесте",
		"grid.menu.title": "Оқиғалар менюі",
		"grid.menu.collapse_all_events": "Барлық оқиғаларды жию",
		"grid.menu.expand_all_events": "Барлық оқиғаларды көрсету",
		"grid.menu.collapse_all_groups": "Барлық қосымша ставкаларды жию",
		"grid.menu.expand_all_groups": "Барлық қосымша ставкаларды көрсету",
		"grid.menu.display_line_numbers": "Оқиға нөмірлерді көрсету",
		"grid.menu.hide_line_numbers": "Оқиға нөмірлерді жасыру",
		"grid.menu.prematch_filter.title": "Көрсету",
		"grid.menu.prematch_filter.all_time": "Барлық оқиғалар",
		"grid.menu.prematch_filter.next_hour": "Ертеңгі сағат",
		"grid.menu.prematch_filter.next_2_hours": "Келесі 2 сағат",
		"grid.menu.prematch_filter.next_4_hours": "Келесі 4 сағат",
		"grid.menu.prematch_filter.next_6_hours": "Келесі 6 сағат",
		"grid.menu.prematch_filter.next_12_hours": "Келесі 12 сағат",
		"grid.menu.prematch_filter.next_day": "Ертеңгі күн",
		"grid.menu.prematch_filter.next_2_days": "Келесі 2 күн",
		"grid.header.event": "Спорттық ставкалар",
		"grid.header.win1": "П1",
		"grid.header.draw": "X",
		"grid.header.win2": "П2",
		"grid.header.win1_draw": "1X",
		"grid.header.win12": "12",
		"grid.header.draw_win2": "X2",
		"grid.header.handicap": "ФОРА",
		"grid.header.handicap1": "1",
		"grid.header.handicap2": "2",
		"grid.header.under": "МЕН",
		"grid.header.total": "ТОТ",
		"grid.header.over": "БОЛ",
		"grid.header.live_bets_online": " онлайн ставкалар",
		"grid.header.football": "Футболға",
		"grid.header.tennis": "Тенниске",
		"grid.header.cybersport": "Киберспорт",
		"grid.header.hockey": "Хоккей",
		"grid.header.basketball": "Баскетболға",
		"grid.header.voleyball": "Волейболға",
		"grid.header.handball": "Гандболға",
		"grid.header.boxing": "Онлайн боксқа ставка",
		"grid.header.UFC_MMA": "UFC және MMA бойынша онлайн ставкалар",
		"grid.header.american_football": "Американдық футболға онлайн тігу",
		"grid.header.table_tennis": "Үстел теннисіне онлайн ставка жасау",
		"grid.header.live.matches": "Live матчтар",
		"grid.match-current-time.forward": "{minute}'",
		"grid.match-current-time.backward": "артта < {minute}'",
		"grid.match-current-scores.not_started": " Ойын басталмады",
		"grid.match-current-scores.finished": " Ойын аяқталды",
		"grid.match.datetime_at": "в",
		"grid.match.today": "Бүгін",
		"grid.match.tomorrow": "Ертеңгі күн",
		"play.stream.video": "Жатты трансляция бар",
		"login.to.watch": "Көру үшін жүйеге кіруіңіз",
		"timetable.title": "Тіркелген оқиғалар күнтізбесі",
		"timetable.time_filter": "Барлық оқиғалар",
		"timetable.sort_by_time": "Уақыт бойынша сұрыптау",
		"timetable.sort_by_league": "Жатты тақырып бойынша сұрыптау",
		"timetable.matches_filter_menu.title": "Көрсету",
		"timetable.matches_filter_menu.no_filter": "Барлық оқиғалар",
		"timetable.matches_filter_menu.one_hour": "Ертеңгі сағат",
		"timetable.matches_filter_menu.two_hours": "Келесі 2 сағат",
		"timetable.matches_filter_menu.four_hours": "Келесі 4 сағат",
		"timetable.matches_filter_menu.six_hours": "Келесі 6 сағат",
		"timetable.matches_filter_menu.twelve_hours": "Келесі 12 сағат",
		"timetable.matches_filter_menu.one_day": "Ертеңгі күн",
		"timetable.matches_filter_menu.two_days": "Келесі 2 күн",
		"betpanel.title": "Ставкалар",
		"betpanel.help": "Купонға ставка қосу үшін кез-келген шынындай нәтиже бетін басыңыз.",
		"coupon.title": "Жаңа ставка",
		"coupon.make_bet": "Ставка қою",
		"coupon.rate_unavailable": "Коэффициент қол жетімді емес",
		"coupon.stake_title": "Ставка:",
		"coupon.rate_title": "Коэффициент:",
		"coupon.rate_changed": "Коэффициент өзгерді",
		"coupon.confirm_rate_value_change": "Қабылдау",
		"coupon.stake_hint": "Ставка сомасы",
		"coupon.min_amount_hint": "Мин.",
		"coupon.max_amount_hint": "Макс. {amount} {resource}",
		"coupon.bet_type_hint": "Ставка түрі",
		"coupon.total_odd_hint": "Жалпы коэффициент",
		"coupon.possible_winning_hint": "Мүмкін бола табу",
		"coupon.possible_winning_hint_short": "Табыс",
		"coupon.not_possible_stake": "Бұл ставка мүмкін емес",
		"coupon.menu.title": "Ставкалар менюі",
		"coupon.menu.one-click_checkbox": "Бір басумен ставка қою",
		"coupon.menu.one-click_amount": "Ставка сомасы ",
		"coupon.menu.accept_factor_increase": "Коэффициентті көтеруді қабылдау",
		"coupon.menu.accept_factor_decrease": "Коэффициентті төмендетуді қабылдау",
		"coupon.menu.accept_total_and_handicap_change": "Тотал/Фораны өзгертілген ставкаларды қабылдау",
		"coupon.menu.favouriteBets": "Ұнамалы ставкалар",
		"coupon.menu.favouriteBet": "Ставка {num}",
		"coupon.sum_label": "Сомма",
		"coupon_bet_promocode_not_found1": "Промокод табылмады",
		"coupon_bet_for_get_freebet_fill_balance21": "Тегін ставканы алу үшін {amount} {currency} сомасында шотыңызды толтыру қажет",
		"coupon_bet_for_using_freebet_make_stake_more22": "Тегін ставканы пайдалану үшін кем дегенде {amount} {currency} ставкасын қою керек",
		"coupon_bet_for_using_freebet_nessery_auth24": "Тегін ставканы пайдалану үшін есептік жазбаны сәйкестендіру қажет",
		"coupon_bet_for_stake_type32": "Ставка түріне қолданылады: {amount}",
		"coupon_bet_not_for_stake_type37": "Бұл матчқа қолданылмайды",
		"coupon_bet_not_for_the_league38": "Бұл лигаға қолданылмайды",
		"coupon_bet_min_coef_should33": "Ең аз коэффициент болуы керек {amount}",
		"coupon_for_using_freebet_nesessarry_choose_more35": "Тегін ставканы пайдалану үшін кемінде {amount} оқиғаны таңдау керек",
		"coupon_bet_nessary_should_more23": "Ұтыс тігу сомасы {amount} асуы керек",
		"coupon_bet_coef_stakes_changed2": "Ставка тақ өзгертілді",
		"coupon_bet_validation_is_not_accept31": " Промокод тек {value}",
		"coupon_bet_freebet_sum_not_equal_sum_stake36": "Тегін ставка сомасы ставка сомасынан аз/көп",
		"coupon_bet_validation_is_not_accept_by_minCoef34": "тақ {amount} аспауы керек ",
		"bet_type.ordinar": "Ординар",
		"bet_type.accumulator": "Экспресс",
		"bet_type.looseToWinAccumulator": "Антиэкспресс",
		"bet_type.system": "{count} тармақтан {rank}-ші",
		"bet_title.new_bet": "Жаңа ставка",
		"bet_status.not_accepted": "Қабылдалмаған",
		"bet_status.accepted": "Қабылданған",
		"bet_status.canceled": "Болдырылмаған",
		"bet_status.sold": "Сатылған",
		"bet_status.won": "Жеңген",
		"bet_status.lost": "Жоқ кетті",
		"bet_history.refund": "Қайтарым",
		"bet_history.bet_under_consideration": "Растау астында",
		"bet_history.bet_under_consideration_tooltip": "Ставка растау астында. Тағы-тағы-тағы. Ставка растау астында. Тағы-тағы-тағы.",
		"bet_history.sell": "Сату",
		"bet_history.sell_cancel": "Болдырмау",
		"bet_history.cashout_amount_changed": "Сату сомасы өзгерді",
		"bet_history.cashout_confirmation": "Ставканы сатуын растау,{br}сату сомасы",
		"bet_history.event_stake_cashout_forbidden": "Осы оқиға ставка сату тыйым салынды",
		"bet_history.rates_changed": "Коэффициенттер{br}жаңартылды",
		"bet_history.big_stake_cancel": "Ставканы болдырмау",
		"bet_history.rate": "Коэфф: ",
		"bet_history.stake": "Ставка: ",
		"bet_history.errors.insufficient_funds": "Теңгерім жеткізілмеді",
		"bet_history.errors.account_locked": "Сіздің шотыңыз құлыпталды",
		"bet_history.errors.system_not_allowed_for_freebet": "Фрибет ставка түрі 'Система' рұқсат етілмеген",
		"bet_history.errors.incorrect_stake_data": "Ставка деректері дұрыс емес",
		"bet_history.errors.min_stake_amount": "Минималды ставка сомасы {minAmount} {currency}",
		"bet_history.errors.incorrect_virtual_stake": "Виртуалды шоттан дайында ставка деректері дұрыс емес",
		"bet_history.errors.incorrect_freebet_stake": "Фрибет ставкасы деректері дұрыс емес",
		"bet_history.errors.existing_active_stake": "Жүргізілген ставкалар жоқ",
		"bet_history.errors.no_big_stake_permission": "Үлкен ставкалар рұқсат етілмеген",
		"bet_history.errors.freebet_big_stake": "Фрибет ставкасы үлкен болмайды",
		"bet_history.errors.bet_not_accepted_by_terms": "Бұл бонусты пайдалану үшін промокод сипаттамасында көрсетілген шарттарды орындау қажет.",
		"news.read_title": "Оқу",
		"news.company_news": "Компания жаңалықтары",
		"live.error.connection_lost": "Деректер серверімен байланыс жоғалды, күте тұрыңыз рахмет",
		"popular.title": "Танымал спорттық ставкалар",
		"popular.win1": "П1",
		"popular.draw": "Х",
		"popular.win2": "П2",
		"header.signin.join_title": "Тіркеу",
		"header.signin.title": "Кіру",
		"sign_in.phone": "Телефон",
		"sign_in.email": "E-mail",
		"sign_in.login": "Логин",
		"sign_in.or": "немесе",
		"sign_in.title": "Авторизация",
		"sign_in.requisite": "Реквизит",
		"sign_in.password": "Құпия сөз",
		"sign_in.log_in": "Кіру",
		"sign_in.resend_activation": "Жіберу",
		"sign_in.join": "Тіркеу",
		"sign_in.forgot": "Логин немесе құпия сөзді ұмыттымыз ба?",
		"sign_in.activation_sent": "Тіркеуді растау үшін сілтеме сіздің {email} поштанызға жіберілді",
		"sign_in.errors.invalid_credentials": "Жарамсыз логин немесе құпия сөз!",
		"sign_in.errors.user_blocked": "Слишком много попыток. Попробуйте через 15 минут",
		"sign_in.errors.internal": "Қате. Техникалық көмекке хабарласыңыз",
		"sign_in.errors.not_activated": "Сіздің тіркеуіңіз активациялау қамтымас. Активация үшін сілтемені {email} поштанызға қайта жіберу келе ме?",
		"sign_in.errors.wrong_certificate": "Сіздің сертификатыңыз құлыпталды. Техникалық көмекке хабарласыңыз",
		"password_recovery.title": "Шотты қалпына келтіру",
		"password_recovery.sent_to": "Құпия сөзді қалпына келтіру бойынша нұсқаулар <strong>{email}</strong> мекенжайына жіберілді",
		"password_recovery.sent_repeatedly": "Біз сізге қалпына келтіру туралы ақпаратты бірнеше рет жібердік. Қауіпсіздік мақсатында көмек көрсету үшін, техникалық көмекке хабарласыңыз.",
		"password_recovery.sms_exceeded": "Біз сізге құпия сөзді қалпына келтіру туралы хабарлама екі рет жібердік. Өтініш, SMS күтуін күтіңіз немесе техникалық көмекке хабарласыңыз.",
		"password_recovery.delivery_condition": "Егер біздің хатты бес минут ішінде алмасаңыз, онда 'Спам' тізімін тексеріп көріңіз",
		"password_recovery.support": "Егер болмаса, онлайн-жат арқылы клиенттерге көмек көрсету үшін көмек көмегіне хабарласыңыз",
		"password_recovery.registration_requisite": "Сайтта тіркелген уақытында пайдаланған логин, шот, e-mail немесе телефон нөмірін (форматта {mask}) көрсетіңіз",
		"password_recovery.requisite": "Реквизит",
		"password_recovery.recover_title": "Қалпына келтіру",
		"password_recovery.sent_via_sms": "Құпия сөз номеріне <strong>{phone}</strong> жіберілді",
		"password_recovery.support_phone": "Егер бірнеше минут ішінде SMS келмесе, онлайн-жат арқылы клиенттерге көмек көрсету үшін көмек көмегіне хабарласыңыз",
		"password_recovery.errors.invalid_credentials": "Осы тіркеу деректерлерімен пайдаланушы табылмады",
		"password_recovery.errors.internal_error": "Ішкі қате",
		"password_recovery.errors.blocked": "Тым көп сұраулар. 15 минуттан кейін қайталаңыз",
		"footer.fairplay.copyright": "&copy; {year} Букмекерлік компаниясы «Fair Play»",
		"footer.fairplay.copyright_kz": "&copy; {year} «BETtery» ЖШС. «Fair Play» бағдарысы. Лицензия # 320, 23.08.2019",
		"footer.fairplay.copyright_ringobet": "&copy; {year} «TakeBet» ЖШС. «RingoBet» бағдарысы. Лицензия # 34, 12.07.2022",
		"join.fast_registration_title": "Тез тіркеу",
		"join.registration_title": "Стандартты тіркеу",
		"join.title": "Тіркеу",
		"join.login": "Логин",
		"join.password": "Құпия сөз",
		"join.password_repeat": "Құпия сөзді қайталау",
		"join.first_name": "Аты",
		"join.last_name": "Тегі",
		"join.dob": "Туған күні",
		"join.email": "E-mail",
		"join.phone": "Мобильді телефон",
		"join.city": "Қала",
		"join.country": "Ел",
		"join.currency": "Тіркеудің валютасы",
		"join.language": "Тіл",
		"join.timezone": "Уақыт белгісі",
		"join.promo": "Промо-код",
		"join.have_promo": "Промокод бар ма?",
		"join.button_join": "Тіркеу",
		"join.tac_agree": "Мен 18 жаста жасаушымын (Қазақстандықтар үшін +21). Мен <a href=\"{rulesLink}\" target=\"_blank\">Ережелерді</a> толық оқыдым мен оларды толық растамын. Мен сіздің жеке деректерімді орнату өнімдерді пайдалану арқылы өңдеуімен келісемін. Бұл мазмұнда <a href=\"{privacyLink}\" target=\"_blank\">конфиденциалдылық саясаты</a> көрсетілген",
		"join.real_info_warning": "Ескертпе! Жасырын деректерді енгізіп отырып, толтырылған шоттан аударуымызды қарап тұр. Менің атауым мен тегімім регистрациядан кейін өзгертілмейді.",
		"join.link_sent_to": "Растау үшін сілтеме {email} поштанызға жіберілді",
		"join.fast.type": "Тіркеу",
		"join.fast.type.sms": "SMS",
		"join.fast.type.email": "E-mail",
		"join.fast.phone": "Телефон номері",
		"join.fast.email": "E-mail",
		"join.fast.currency": "Валюта",
		"join.fast.button_join": "Тіркеу",
		"join.fast.tac_agree": "Түймені басу арқылы сіз <a href={rulesLink} target='_blank'>компания ережелерімен</a>, <a href={privacyLink} target='_blank'>құпиялылық саясатымен</a> келісесіз, және жасыңыз 21 жастан асқанын растайсыз.",
		"join.fast.tac_agree_ringo": "Түймені басу арқылы сіз <a href={rulesLink} target='_blank'>компания ережелерімен</a>, <a href={privacyLink} target='_blank'>құпиялылық саясатымен</a> келісесіз, және жасыңыз 21 жастан асқанын растайсыз.",
		"join.fast.phone_confirm.title": "Телефон номерін растау",
		"join.fast.phone_confirm.confirm_button": "Растау",
		"join.fast.phone_confirm.confirmation_code": "Растау коды",
		"join.fast.phone_confirm.sms_received_text": "Сізге SMS арқылы растау коды жіберілді. Телефон номеріні растау үшін оны қолданыңыз. SMS жеткізу уақыты бір минуттан көп болуы мүмкін.",
		"join.fast.phone_confirm.sms_sent_text": "Хабарлама жіберілді. ",
		"join.fast.phone_confirm.sms_resendinfo_text": "Қайталау мүмкіндігі {seconds} секундтан кейін. ",
		"join.fast.phone_confirm.call_resendinfo_text": "Қайталау мүмкіндігі {seconds} секундтан кейін.",
		"join.fast.phone_confirm.sms_resend_text": "Хабарламаны қайталау",
		"join.fast.phone_confirm.call_resend_text": "Растау сұрауын қайталау",
		"join.fast.phone_confirm.sms_resend_button_text": "Жіберу",
		"join.fast.phone_confirm.call_resend_button_text": "Сұрау жасау",
		"join.fast.success.text": "Сіздің шоты сәтті арттырылды!",
		"join.fast.success.recharge_text": "Ойын бастау үшін балансты толтырып алыңыз",
		"join.fast.success.btn_recharge_text": "Балансты толтыру",
		"join.errors.internal": "Қате. Кейінірек өтіңіз",
		"join.errors.smsexceeded": "Сізге шотты растау үшін хабарлама екі рет жіберілді. SMS келмеді дайын емес, жаттығу электрондық поштамен растау жайлы ақпаратты жіберіп отамыз.",
		"join.errors.login_taken": "Логин қазірдің өзінде қолданыста",
		"join.errors.email_taken": "E-mail қазірдің өзінде қолданыста",
		"join.errors.phone_taken": "Телефон қазірдің өзінде қолданыста",
		"join.errors.phone_not_found": "Телефон нөмірі дұрыс емес",
		"join.errors.required_field": "Толтыру қажет",
		"join.errors.promo_length_error": "Ең көп 4 белгі",
		"join.errors.login_requirements": "Ең аз 4 белгі, тек латын әліпбиі мен сандар",
		"join.errors.passwords_not_equal": "Құпия сөздер сәйкес келмейді",
		"join.errors.email_invalid": "E-mail дұрыс емес",
		"join.errors.invalid_promo": "Дұрыс емес промо-код",
		"join.errors.phone_invalid": "Телефон номері дұрыс көрсетілмеген",
		"join.errors.age_incorrect": "Туған күні дұрыс көрсетілмеген",
		"join.errors.age_illegal": "Құпияныс",
		"join.errors.date_invalid": "Туған күні дұрыс көрсетілмеген",
		"join.password_changed": "Құпия сөз өзгертілді",
		"join.fast.phone_confirm.errors.confirmation_fail": "Растау кезінде қате пайда болды",
		"join.fast.phone_confirm.errors.sms_exceeded": "Сізге шотты растау үшін хабарлама екі рет жіберілді. SMS келмеді дайын емес, жаттығу электрондық поштамен растау жайлы ақпаратты жіберіп отамыз.",
		"join.fast.phone_confirm.errors.invalid_code": "Дұрыс емес код",
		"phone_confirm.title": "Телефон нөмірін растау",
		"phone_confirm.phone": "Мобильді телефон",
		"phone_confirm.sms_text": "Бұл нөмірге растау кодымен SMS жіберіледі",
		"phone_confirm.confirm_button": "Растау",
		"phone_confirm.denial": "Мен жеңілдікте қатысу үшін телефон номерімді растаушымын, тек мені регистр тіркеу",
		"phone_confirm.conditions": "Өзгерістерге қатысу үшін мобильді телефон номерін растау керек",
		"phone_confirm.confirmation_code": "Растау коды",
		"phone_confirm.sms_received_text": "SMS хабарламасынан келген кодты енгізіңіз, {phone} номерге жіберілді",
		"phone_confirm.success": "{phone} номер сәтті расталды!",
		"phone_confirm.start_playing": "Ойнау бастау",
		"phone_confirm.errors.confirmation_fail": "Растау кезінде қате пайда болды",
		"phone_confirm.errors.phone_taken": "Телефон номері бұрыннан қолданылды",
		"phone_confirm.phone_hint": "Мемлекеттік префикс пайдаланыңыз",
		"special_offers.site146_proposal": "Сіздікі промо-код «Жаттыру бонус - 1000 теңге!» акциясына қатысызды қамтамасыз етеді.<br /> Бонусты алу үшін мобильді телефон номерін растау керек",
		"special_offers.site146_accepted": "Сіздікі ойын тіркемесі «Жаттыру бонус - 1000 теңге!» акциясына қатысызды қамтамасыз етеді",
		"pages.main.title": "Онлайн спорт параулары. Қазақстандағы FairPlay тотализаторы.",
		"pages.main.description": "Күні бойы көбірек спорт іс-шараларына жарнамаларды өткіземіз: футбол, теннис, баскетбол, волейбол, хоккей, бокс, күрес, салу, шұғылды, шұғылды жаттыру.",
		"pages.live.title": "FairPlay көп салмақты спорттык тотализаторды онлайн ойнау",
		"pages.live.description": "FairPlay букмекерлік компаниясының веб-сайтының Live ставкалары мен оңай интерфейсі көмек көрсету үшін көбірек ставкаларды таңдауға мүмкіндік береді.",
		"pages.sports.title": "Онлайн тотализатор №1 Қазақстанда - FairPlay",
		"pages.sports.description": "Онлайн ставка қою өте оңай - сізді қызықтыратын спорттық іс-шараны көрсетіңіз, қажетті нәтижені таңдаңыз және ставка соммасын енгізіңіз. Ендіден бастап пари жасау!",
		"pages.timetable.title": "Спорт трансляциялары. Келесі ойындар кестесі.",
		"pages.timetable.description": "Тотализаторлық ставкалар үшін мүмкін болатын спорттық іс-шаралардың онлайн трансляциялары тізімі.",
		"betpanel.unauth.how_to_bet": "Ставка қалай ойнау?",
		"betpanel.unauth.to_configure_coupon": "Купонды баптау үшін - ",
		"betpanel.unauth.auth_or_register": "{signTrigger} немесе {joinTrigger}, мәліметтерді толтырып, тіркеусіз.",
		"betpanel.unauth.time_to_bet": "Ставка ойнау уақыт!",
		"betpanel.unauth.sign_trigger": "Кіру",
		"betpanel.unauth.join_trigger": "тіркелу",
		"betpanel.unauth.to_place_bet": "Ставка ойнау үшін - ",
		"betpanel.unauth.should_auth": "кіру",
		"betpanel.unauth.should_register": "тіркеліңіз",
		"betpanel.unauth.auth_or_register_to_bet": "{signTrigger} немесе {joinTrigger}",
		"timezones.item_1": "Азия/Алматы",
		"timezones.item_2": "Еуропа/Мәске",
		"create-password.modla-title": "Парольді көрсетіңіз",
		"create-password.profile_password_form_new_password_label": "Жаңа құпия сөз",
		"create-password.profile_password_form_retype_password": "Құпия сөзді қайталау",
		"create-password.profile_password_form_btn_msg": "Сақтау",
		"create-password.limit_form_error_empty_field": "Мәліметті толтыру міндетті",
		"create-password.password_form_error_mismatch": "Құпия сөзді растау сәйкес келмейді",
		"create-password.password_changed": "Құпия сөз өзгертілді",
		"betgames.disclaimer1": "BetGamesTV үшін ойнау тегін жаттығу келген жаңа ойындарға негізделген. Бұл ойынды онлайн-казино болмаса да, «Ойын ісі» туралы Заңды «оқиға ойын» категориясына жатамайды.",
		"betgames.disclaimer2": "БК «Fair Play» даналық ойындарды организациялау жатамайды және өзі ойын ісінде болмайды, қатар онда паришатқыштар (ойыншылар) әрекет етпейді. Осы түрдегі жаңа ойындарды органайтын компания «TV ZAIDIMAI» болып табылады. Ойындардың өткендігі ойша жатамайды, БК «Fair Play» не ойша көтерушінің немесе паришатқыштың (ойыншының) өткендігінің байланысқысыздығымен жасалады. Ойындардың нәтижелеріні компания «TV ZAIDIMAI» өзі қалпына салады және оларды оның ресми веб-сайтында жариялауы мүмкін.",
		"games.virtual-sport": "Виртуалды спорт",
		"games.auth-required": "Тіркелу қажет",
		"games.vivo_games": "Live казино - рулетка, покер, блэкджек, баккара...",
		"games.red_rake": "Слоттар, Бинго, Покер, Рулетка",
		"games.leap_gaming": "Виртуалды спорт, Жарыс, Слоттар",
		"games.vivo_slots": "Ойындардың слот автоматтары",
		"games.tv_bet": "ТВ-ойындар - блэкджек, покер, кено, тақтаса...",
		"games.fastsport": "Жылдам спорт",
		"games.tv_bet_roullette": "Рулетка Live",
		"games.xpress": "Слоты, казино, лайв-игры",
		"games.back_to_games": "Ойындар тізіміне қайта оралу",
		"games.back_to_slots": "Слот-ойындарды тізіміне қайта оралу",
		"games.new": "Жаңалықтар",
		"games.more": "Қосымша 20 ойын",
		"games.all_slots": "Барлық слоттар",
		"games.gamesSlots": "Ойын автоматтары",
		"games.sport_vfl": "Футбол лигасы",
		"games.sport_vfcc": "Футбол Жеңімпаздар Кубогы",
		"games.sport_vfwc": "Футбол Жаңа Жаңбыр",
		"games.sport_vfc": "Футбол Жеңімпаздар Кубогы 2020",
		"games.sport_vfac": "Футбол Азия Кубогы",
		"games.sport_vbl": "Баскетбол лигасы",
		"verify_form.title": "Суреттерді жүктеп алып немесе айналдырып көрсетіңдер. Құжаттың барлық жағы беті кадрға жатуы керек, ақпарат оқи болуы тиіс.",
		"verify_form.available_files": "Рұқсат етілген файлдар: image/jpeg, image/png",
		"verify_form.max_file_size": "Өлшемі: 20.00 МБ-дан асқан болмауы керек",
		"verify_form.document_front_side": "Құжаттың алдындағы жағы",
		"verify_form.document_back_side": "Құжаттың артындағы жағы",
		"verify_form.selfie_with_document": "Селфи документпен",
		"verify_form.submit": "Жіберу",
		"promocode.error.not_found": "Промокод табылмады",
		"promocode.error.not_active": "Промокод қолданылмайды",
		"promocode.error.used": "Промокод қолданылдган",
		"promocode.error.not_available": "Промокод қолданылмайды",
		"promocode.title": "Жарнамалық код",
		"promocode.tab": "Жарнамалық кодтар",
		"promocode.enter": "Жарнамалық код енгізіңіз",
		"promocode.apply": "Қолдану",
		"instagram.banner.iphone_title": "ГЛАВНЫЙ ПРИЗ",
		"instagram.banner.freebet_text": "РОЗЫГРЫШ ФРИБЕТОВ",
		"instagram.banner.center_text": "Акция в инстаграм",
		"newGames.showAllGames": "Посмотреть все игры",
		"newGames.showRecentGames": "Посмотреть недавние игры",
		"newGames.showFavorites": "Посмотреть избранные игры"
	};

/***/ },
/* 1832 */
/***/ function(module, exports) {

	module.exports = {
		"header.navigation.sports": "Спорт",
		"header.navigation.live": "Live",
		"header.navigation.cybersport": "Киберспорт",
		"header.navigation.results": "Результаты",
		"header.navigation.fastsport": "Быстрые игры",
		"header.navigation.promotions": "Акции и бонусы",
		"header.navigation.more": "Еще",
		"header.help": "Помощь",
		"header.locale.choose": "Выбор языка:",
		"header.menu.menu_text": "Меню",
		"header.menu.company_news": "Новости компании",
		"header.menu.regulations": "Правила",
		"header.menu.responsible_game": "Ответственная игра",
		"header.menu.contact_information": "Контактная информация",
		"header.menu.betting_shop": "Пункты приема ставок",
		"header.menu.players_best_bets": "Лучшие ставки игроков",
		"header.menu.internet_bonus": "Акции и бонусы",
		"header.menu.privacy_policy": "Политика конфиденциальности",
		"header.user_menu.title": "Профиль",
		"header.user_menu.account_num": "Номер счета",
		"header.user_menu.recharge": "Пополнить баланс",
		"header.user_menu.briefcase": "Портфель ставок",
		"header.user_menu.bet_history": "История ставок",
		"header.user_menu.account_history": "История счета",
		"header.user_menu.withdraw": "Снять со счета",
		"header.user_menu.opex_checks": "Чеки «Opex»",
		"header.user_menu.usdt_checks": "Чеки «USD₮»",
		"header.user_menu.profile": "Мой профиль",
		"header.user_menu.bonus": "Бонусы",
		"header.user_menu.logout": "Выйти",
		"header.freebet.title.default": "Вам доступна бесплатная ставка (фрибет) на сумму {sum}{currency}\nНачало действия от {start}\nКонец действия до {end}",
		"header.freebet.title.promocode": "Вам доступна бесплатная ставка (фрибет) по промокоду {promocode} на сумму {sum}{currency}\nНачало действия от {start} \nКонец действия до {end}",
		"header.freebet.max_factor": "Распространяется на любые ставки с максимальным коэфф. {maxFactor}.",
		"header.freebet.valid_thru": "Начало действия от {startDate}",
		"header.freebet.valid_until": "Конец действия до {expireDate}",
		"header.freebet.details": "Подробнее о Фрибете",
		"header.games": "Игры",
		"header.gamesFromVivo": "Игры от Vivo",
		"notification.new_message.new_message": "Новое сообщение",
		"notification.new_message.proceed_to_messages": "Перейти в сообщения",
		"notification.new_message.close": "Закрыть",
		"menu.bookmarks": "Избранное",
		"menu.others": "Разное",
		"menu.all_sport": "Все события",
		"menu.popular_sport": "Популярные события",
		"menu.calendar": "Календарь",
		"grid.menu.title": "Меню событий",
		"grid.menu.collapse_all_events": "Свернуть все события",
		"grid.menu.expand_all_events": "Развернуть все события",
		"grid.menu.collapse_all_groups": "Свернуть все доп. ставки",
		"grid.menu.expand_all_groups": "Развернуть все доп. ставки",
		"grid.menu.display_line_numbers": "Отображать номера событий",
		"grid.menu.hide_line_numbers": "Скрыть номера событий",
		"grid.menu.prematch_filter.title": "Показать",
		"grid.menu.prematch_filter.all_time": "Все события",
		"grid.menu.prematch_filter.next_hour": "Ближайший час",
		"grid.menu.prematch_filter.next_2_hours": "Ближайшие 2 часа",
		"grid.menu.prematch_filter.next_4_hours": "Ближайшие 4 часа",
		"grid.menu.prematch_filter.next_6_hours": "Ближайшие 6 часов",
		"grid.menu.prematch_filter.next_12_hours": "Ближайшие 12 часов",
		"grid.menu.prematch_filter.next_day": "Ближайший день",
		"grid.menu.prematch_filter.next_2_days": "Ближайшие 2 дня",
		"grid.header.win1": "П1",
		"grid.header.event": "Ставки на спорт",
		"grid.header.draw": "X",
		"grid.header.win2": "П2",
		"grid.header.win1_draw": "1X",
		"grid.header.win12": "12",
		"grid.header.draw_win2": "X2",
		"grid.header.handicap": "ФОРА",
		"grid.header.handicap1": "1",
		"grid.header.handicap2": "2",
		"grid.header.under": "МЕН",
		"grid.header.total": "ТОТ",
		"grid.header.over": "БОЛ",
		"grid.header.live_bets_online": " live ставки онлайн",
		"grid.header.football": "Футбол",
		"grid.header.tennis": "Теннис",
		"grid.header.cybersport": "Киберспорт",
		"grid.header.hockey": "Хоккей",
		"grid.header.basketball": "Баскетбол",
		"grid.header.volleyball": "Волейбол",
		"grid.header.handball": "Гандболл",
		"grid.header.boxing": "Ставки на бокс онлайн",
		"grid.header.UFC_MMA": "Ставки на UFC и MMA онлайн",
		"grid.header.american_football": "Ставки на американский футбол онлайн",
		"grid.header.table_tennis": "Ставки на настольный теннис онлайн",
		"grid.header.live.matches": "Live матчи",
		"grid.match-current-time.forward": "{minute}'",
		"grid.match-current-time.backward": "ост. < {minute}'",
		"grid.match-current-scores.not_started": " Матч не начался",
		"grid.match-current-scores.finished": " Матч закончился",
		"grid.match.datetime_at": "в",
		"grid.match.today": "Сегодня",
		"grid.match.tomorrow": "Завтра",
		"play.stream.video": "Доступна прямая трансляция",
		"login.to.watch": "Войдите в систему для просмотра",
		"timetable.title": "Календарь предстоящих событий Live",
		"timetable.time_filter": "Все события",
		"timetable.sort_by_time": "Сортировать по времени",
		"timetable.sort_by_league": "Сортировать по виду соревнования",
		"timetable.matches_filter_menu.title": "Показать",
		"timetable.matches_filter_menu.no_filter": "Все события",
		"timetable.matches_filter_menu.one_hour": "Ближайший час",
		"timetable.matches_filter_menu.two_hours": "Ближайшие 2 часа",
		"timetable.matches_filter_menu.four_hours": "Ближайшие 4 часа",
		"timetable.matches_filter_menu.six_hours": "Ближайшие 6 часов",
		"timetable.matches_filter_menu.twelve_hours": "Ближайшие 12 часов",
		"timetable.matches_filter_menu.one_day": "Ближайший день",
		"timetable.matches_filter_menu.two_days": "Ближайшие 2 дня",
		"betpanel.title": "Ставки",
		"betpanel.help": "Кликните на любой исход, чтобы добавить ставку в купон.",
		"coupon.title": "Новая ставка",
		"coupon.make_bet": "Сделать ставку",
		"coupon.rate_unavailable": "Коэфф недоступен",
		"coupon.stake_title": "Ставка:",
		"coupon.rate_title": "Коэфф:",
		"coupon.rate_changed": "Коэфф изменился",
		"coupon.confirm_rate_value_change": "Принять",
		"coupon.stake_hint": "Сумма ставки",
		"coupon.min_amount_hint": "Мин.",
		"coupon.max_amount_hint": "Макс. {amount} {resource}",
		"coupon.bet_type_hint": "Тип ставки",
		"coupon.total_odd_hint": "Общий коэффициент",
		"coupon.possible_winning_hint": "Возможный выигрыш",
		"coupon.possible_winning_hint_short": "Выигрыш",
		"coupon.not_possible_stake": "Данная ставка невозможна",
		"coupon.menu.title": "Меню ставок",
		"coupon.menu.one-click_checkbox": "Ставка в один клик",
		"coupon.menu.one-click_amount": "Сумма ставки ",
		"coupon.menu.accept_factor_increase": "Согласен на повышение коэффициента",
		"coupon.menu.accept_factor_decrease": "Согласен на понижение коэффициента",
		"coupon.menu.accept_total_and_handicap_change": "Принимать ставки с измененными тоталами/форами",
		"coupon.menu.favouriteBets": "Любимые ставки",
		"coupon.menu.favouriteBet": "Ставка {num}",
		"coupon.sum_label": "Сумма",
		"coupon_bet_promocode_not_found1": "Промокод не найден",
		"coupon_bet_for_get_freebet_fill_balance21": "Для получения фрибета необходимо пополнить счет на сумму {amount} {currency}",
		"coupon_bet_for_using_freebet_make_stake_more22": "Для использования фрибета необходимо сделать ставку на сумму от {amount} {currency}",
		"coupon_bet_for_using_freebet_nessery_auth24": "Для использования фрибета необходима идентификация учетной записи",
		"coupon_bet_for_stake_type32": "Применимо к ставке типа: {amount}",
		"coupon_bet_not_for_stake_type37": "Не применимо к данному матчу",
		"coupon_bet_not_for_the_league38": "Не применимо к данной лиге",
		"coupon_bet_min_coef_should33": "Минимальный коэффициент должен быть {amount}",
		"coupon_for_using_freebet_nesessarry_choose_more35": "Для использования фрибета необходимо выбрать не менее {amounts} событий",
		"coupon_bet_nessary_should_more23": "Сумма ставок должна превышать {amount}",
		"coupon_bet_coef_stakes_changed2": "Коэффициент ставки был изменен",
		"coupon_bet_validation_is_not_accept31": "Промокод доступен только в {value}",
		"coupon_bet_freebet_sum_not_equal_sum_stake36": "Сумма фрибета меньше/больше суммы ставки",
		"coupon_bet_validation_is_not_accept_by_minCoef34": "Коэффициент не должен превышать {amount}",
		"bet_type.ordinar": "Ординар",
		"bet_type.accumulator": "Экспресс",
		"bet_type.looseToWinAccumulator": "Антиэкспресс",
		"bet_type.system": "Система {rank} из {count}",
		"bet_title.new_bet": "Новая ставка",
		"bet_status.not_accepted": "Не принята",
		"bet_status.accepted": "Принята",
		"bet_status.canceled": "Отменена",
		"bet_status.sold": "Продана",
		"bet_status.won": "Выиграла",
		"bet_status.lost": "Проиграла",
		"bet_history.refund": "Возврат",
		"bet_history.bet_under_consideration": "На подтверждении",
		"bet_history.bet_under_consideration_tooltip": "Ставка на потверждении. Ещё-ещё-ещё. Ставка на потверждении. Ещё-ещё-ещё.",
		"bet_history.sell": "Продать",
		"bet_history.sell_cancel": "Отмена",
		"bet_history.cashout_amount_changed": "Сумма продажи изменена",
		"bet_history.cashout_confirmation": "Подтвердите продажу ставки,{br}cумма продажи",
		"bet_history.event_stake_cashout_forbidden": "Продажа ставок на данное событие закрыта",
		"bet_history.rates_changed": "Котировки{br}обновились",
		"bet_history.big_stake_cancel": "Отменить ставку",
		"bet_history.rate": "Коэфф: ",
		"bet_history.stake": "Ставка: ",
		"bet_history.errors.insufficient_funds": "Недостаточно средств на балансе",
		"bet_history.errors.account_locked": "Ваш счет заблокирован",
		"bet_history.errors.system_not_allowed_for_freebet": "Фрибет ставки типа 'Система' запрещены",
		"bet_history.errors.incorrect_stake_data": "Некорректные данные по ставке",
		"bet_history.errors.min_stake_amount": "Минимальная сумма ставки {minAmount} {currency}",
		"bet_history.errors.incorrect_virtual_stake": "Некорректная ставка с виртуального счета",
		"bet_history.errors.incorrect_freebet_stake": "Некорректные данные по бесплатной ставке",
		"bet_history.errors.existing_active_stake": "Ошибка системы",
		"bet_history.errors.no_big_stake_permission": "Крупные ставки запрещены",
		"bet_history.errors.freebet_big_stake": "Фрибет ставка не может быть крупной",
		"bet_history.errors.bet_not_accepted_by_terms": "Для использования данного бонуса необходимо выполнить условия, которые указаны в описании промокода.",
		"news.read_title": "Читать",
		"news.company_news": "Новости компании",
		"live.error.connection_lost": "Соединение с сервером данных не может быть установленно, пожалуйста подождите",
		"popular.title": "Популярные ставки на спорт",
		"popular.win1": "П1",
		"popular.draw": "Х",
		"popular.win2": "П2",
		"header.signin.join_title": "Регистрация",
		"header.signin.title": "Вход",
		"sign_in.phone": "Номер телефона",
		"sign_in.email": "E-mail",
		"sign_in.login": "Логин",
		"sign_in.or": "или",
		"sign_in.title": "Авторизация",
		"sign_in.requisite": "Реквизит",
		"sign_in.password": "Пароль",
		"sign_in.log_in": "Войти",
		"sign_in.resend_activation": "Отправить",
		"sign_in.join": "Регистрация",
		"sign_in.forgot": "Забыли логин или пароль?",
		"sign_in.activation_sent": "Письмо с ссылкой для активации учетной записи отправлено на {email}",
		"sign_in.errors.invalid_credentials": "Неверный логин или пароль!",
		"sign_in.errors.user_blocked": "Слишком много попыток. Попробуйте через 15 минут",
		"sign_in.errors.internal": "Ошибка. Обратитесь в техподдержку",
		"sign_in.errors.not_activated": "Ваша учетная запись не активирована. Отправить ссылку для активации на {email} еще раз?",
		"sign_in.errors.wrong_certificate": "Ваш сертификат заблокирован. Обратитесь в техподдержку",
		"password_recovery.title": "Восстановление учетной записи",
		"password_recovery.sent_to": "Инструкции по восстановлению пароля были высланы на <strong>{email}</strong>",
		"password_recovery.sent_repeatedly": "Мы многократно отправили информацию о восстановлении пароля. В целях безопасности, пожалуйста, обратитесь в службу поддержки.",
		"password_recovery.sms_exceeded": "Мы дважды выслали на Ваш номер сообщение для восстановления пароля. Пожалуйста, дождитесь СМС, либо обратитесь в службу поддержки.",
		"password_recovery.delivery_condition": "Если в течении пяти минут вы не получите от нас письма, то проверьте папку 'Спам'",
		"password_recovery.support": "В противном случае, свяжитесь со службой поддержки клиентов через онлайн-чат",
		"password_recovery.registration_requisite": "Укажите логин, номер счета, е-майл или номер телефона (в формате {mask}), который вы использовали при регистрации на сайте",
		"password_recovery.requisite": "Реквизит",
		"password_recovery.recover_title": "Восстановить",
		"password_recovery.sent_via_sms": "Пароль выслан на номер <strong>{phone}</strong>",
		"password_recovery.support_phone": "Если в течении нескольких минут вы не получите SMS, свяжитесь со службой поддержки клиентов через онлайн-чат",
		"password_recovery.errors.invalid_credentials": "Пользователь с такими регистрационными данными не найден",
		"password_recovery.errors.internal_error": "Внутренняя ошибка",
		"password_recovery.errors.blocked": "Слишком много запросов. Попробуйте через 15 минут",
		"footer.fairplay.copyright": "&copy; {year} Букмекерская компания «Fair Play»",
		"footer.fairplay.copyright_kz": "&copy; {year} ТОО «BETtery». Торговая марка «Fair Play» Лицензия № 320 от 23.08.2019",
		"footer.fairplay.copyright_ringobet": "&copy; {year} ТОО «TakeBet». Торговая марка «RingoBet» Лицензия № 34 от 12.07.2022",
		"join.fast_registration_title": "Быстрая Регистрация",
		"join.registration_title": "Обычная Регистрация",
		"join.title": "Регистрация",
		"join.login": "Логин",
		"join.password": "Пароль",
		"join.password_repeat": "Повторите пароль",
		"join.first_name": "Имя",
		"join.last_name": "Фамилия",
		"join.dob": "Дата рождения",
		"join.email": "E-mail",
		"join.phone": "Мобильный телефон",
		"join.city": "Город",
		"join.country": "Страна",
		"join.currency": "Валюта счета",
		"join.language": "Язык",
		"join.timezone": "Часовой пояс",
		"join.promo": "Промо-код",
		"join.have_promo": "Есть промокод?",
		"join.button_join": "Зарегистрироваться",
		"join.tac_agree": "Мне больше 18 лет (для жителей Казахстана +21). Я внимательно прочитал(а) <a href=\"{rulesLink}\" target=\"_blank\">Правила</a> и полностью соглашаюсь со всеми пунктами. Я также соглашаюсь на обработку моих персональных данных с использованием автоматизированных средств, описанных в <a href=\"{privacyLink}\" target=\"_blank\">политике конфиденциальности</a>.",
		"join.real_info_warning": "Внимание! Вводите реальные данные, при снятии средств со счета они будут сверяться с документом удостоверяющим Вашу личность (паспорт, водительское удостоверение). Редактирование имени и фамилии после регистрации невозможно.",
		"join.link_sent_to": "Ссылка для подтверждения была выслана на {email}",
		"join.fast.type": "Регистрация по",
		"join.fast.type.sms": "SMS",
		"join.fast.type.email": "E-mail",
		"join.fast.phone": "Номер телефона",
		"join.fast.email": "E-mail",
		"join.fast.currency": "Валюта",
		"join.fast.button_join": "Зарегистрироваться",
		"join.fast.tac_agree": "Нажимая кнопку, вы соглашаетесь с <a href={rulesLink} target='_blank'>правилами компании</a>, <a href={privacyLink} target='_blank'>политикой конфиденциальности</a>, и подтверждаете свое совершеннолетие",
		"join.fast.tac_agree_ringo": "Нажимая кнопку, вы соглашаетесь с <a href={rulesLink} target='_blank'>правилами компании</a>, <a href={privacyLink} target='_blank'>политикой конфиденциальности</a>, и подтверждаете, что Ваш возраст превышает 21 год.",
		"join.fast.phone_confirm.title": "Подтверждение номера телефона",
		"join.fast.phone_confirm.confirm_button": "Подтвердить",
		"join.fast.phone_confirm.confirmation_code": "Код подтверждения",
		"join.fast.phone_confirm.sms_received_text": "Вам был отправлен код по SMS. Используйте его для подтверждения номера телефона. Обратите внимание, что доставка SMS может занять больше минуты.",
		"join.fast.phone_confirm.sms_sent_text": "Сообщение было отправлено. ",
		"join.fast.phone_confirm.sms_resendinfo_text": "Отправить сообщение заново можно будет через {seconds} секунд. ",
		"join.fast.phone_confirm.call_resendinfo_text": "Повторно запросить подтверждение можно будет через {seconds} секунд.",
		"join.fast.phone_confirm.sms_resend_text": "Отправить сообщение заново",
		"join.fast.phone_confirm.call_resend_text": "Повторно запросить подтверждение",
		"join.fast.phone_confirm.sms_resend_button_text": "Отправить",
		"join.fast.phone_confirm.call_resend_button_text": "Запросить",
		"join.fast.success.text": "Ваш счет успешно активирован!",
		"join.fast.success.recharge_text": "Пополните баланс, чтобы начать игру",
		"join.fast.success.btn_recharge_text": "Пополнить баланс",
		"join.errors.internal": "Ошибка. Попробуйте позже",
		"join.errors.smsexceeded": "Мы дважды выслали на Ваш номер сообщение для подтверждения счёта. Пожалуйста, дождитесь СМС, либо укажите e-mail и мы вышлем информацию о подтверждении счёта на него.",
		"join.errors.login_taken": "Логин уже используется",
		"join.errors.email_taken": "E-mail уже используется",
		"join.errors.phone_taken": "Телефон уже используется",
		"join.errors.phone_not_found": "Некорректный номер телефона",
		"join.errors.required_field": "Поле обязательно для заполнения",
		"join.errors.promo_length_error": "Максимум 4 символа",
		"join.errors.login_requirements": "Минимум 4 символа, только латинские буквы и цифры",
		"join.errors.passwords_not_equal": "Пароли не совпадают",
		"join.errors.email_invalid": "E-mail указан неверно",
		"join.errors.invalid_promo": "Неверный промо-код",
		"join.errors.phone_invalid": "Номер телефона указан неверно",
		"join.errors.age_incorrect": "Дата рождения указана неверно",
		"join.errors.age_illegal": "Недопустимый возраст",
		"join.errors.date_invalid": "Дата рождения указана неверно",
		"join.password_changed": "Пароль изменен",
		"join.fast.phone_confirm.errors.confirmation_fail": "Ошибка при подтверждении",
		"join.fast.phone_confirm.errors.sms_exceeded": "Мы дважды выслали на Ваш номер сообщение для подтверждения счёта. Пожалуйста, дождитесь СМС, либо укажите e-mail и мы вышлем информацию о подтверждении счёта на него.",
		"join.fast.phone_confirm.errors.invalid_code": "Неправильный код",
		"phone_confirm.title": "Подтверждение номера телефона",
		"phone_confirm.phone": "Мобильный телефон",
		"phone_confirm.sms_text": "На данный телефон будет выслано SMS с кодом подтверждения",
		"phone_confirm.confirm_button": "Подтвердить",
		"phone_confirm.denial": "Не желаю участвовать в акции, просто зарегистрируйте мне счет",
		"phone_confirm.conditions": "Для участия в акциях необходимо подтвердить номер мобильного телефона",
		"phone_confirm.confirmation_code": "Код подтверждения",
		"phone_confirm.sms_received_text": "Введите код из SMS сообщения, высланного на номер {phone}",
		"phone_confirm.success": "Номер {phone} успешно подтвержден!",
		"phone_confirm.start_playing": "Начать игру",
		"phone_confirm.errors.confirmation_fail": "Ошибка при подтверждении",
		"phone_confirm.errors.phone_taken": "Телефон уже используется",
		"phone_confirm.phone_hint": "Используйте международный префикс",
		"special_offers.site146_proposal": "Указанный Вами промо-код позволяет принять участие в акции «Вступительный бонус – 1000 тенге!».<br /> Для начисления бонуса необходимо подтвердить номер мобильного телефона",
		"special_offers.site146_accepted": "Ваш игровой счет принимает участие в акции «Вступительный бонус – 1000 тенге!»",
		"pages.main.title": "Ставки на спорт онлайн. Букмекерская контора FairPlay в Казахстане.",
		"pages.main.description": "Круглосуточно принимаем ставки в режиме онлайн на все спортивные события с высокими коэффициентами: футбол, теннис, баскетбол, волейбол, хоккей, бокс, борьба, плавание, лыжи.",
		"pages.live.title": "Лайв ставки (Live) в спортивном интернет-тотализаторе FairPlay",
		"pages.live.description": "Широкий выбор ставок Live и удобный интерфейс сайта букмекерской конторы FairPlay способен удовлетворить потребности самого искушенного игрока.",
		"pages.sports.title": "Ставки на спорт в интернет-букмекере №1 в Казахстане — FairPlay",
		"pages.sports.description": "Сделать ставку онлайн очень просто — укажите интересующее вас спортивное событие, выберите желаемый исход и введите сумму ставки. Заключите пари прямо сейчас!",
		"pages.timetable.title": "Спортивные трансляции. Расписание предстоящих матчей.",
		"pages.timetable.description": "Список онлайн трансляций спортивных событий, для которых возможны букмекерские ставки.",
		"betpanel.unauth.how_to_bet": "Как сделать ставку?",
		"betpanel.unauth.to_configure_coupon": "Чтобы менять настройки купона - ",
		"betpanel.unauth.auth_or_register": "{signTrigger} или {joinTrigger}, заполнив данные.",
		"betpanel.unauth.time_to_bet": "Самое время сделать ставку!",
		"betpanel.unauth.sign_trigger": "Авторизуйтесь",
		"betpanel.unauth.join_trigger": "зарегистрируйтесь",
		"betpanel.unauth.to_place_bet": "Чтобы сделать ставку - ",
		"betpanel.unauth.should_auth": "войдите",
		"betpanel.unauth.should_register": "зарегистрируйтесь",
		"betpanel.unauth.auth_or_register_to_bet": "{signTrigger} или {joinTrigger}",
		"timezones.item_1": "Азия/Алматы",
		"timezones.item_2": "Европа/Москва",
		"create-password.modla-title": "Придумайте пароль",
		"create-password.profile_password_form_new_password_label": "Новый пароль",
		"create-password.profile_password_form_retype_password": "Повторите пароль",
		"create-password.profile_password_form_btn_msg": "Сохранить",
		"create-password.limit_form_error_empty_field": "Поле обязательно для заполнения",
		"create-password.password_form_error_mismatch": "Подтверждение пароля не совпадает",
		"create-password.password_changed": "Пароль изменен",
		"betgames.disclaimer1": "Ставки на BetGamesTV основаны только на предстоящих реальных событиях. Данный вид ставок не является онлайн-казино, поскольку не относится к предусмотренному Законом «Об игорном бизнесе» понятию «азартной игры».",
		"betgames.disclaimer2": "БК «Fair Play» не организовывает данный вид событий и не участвует в них, равно как и участники пари (игроки). Организатором данного вида реальных событий является компания «TV ZAIDIMAI». События транслируются в режиме реального времени и не зависят от Букмекера или участников пари (игроков). Результаты событий формируются организатором независимо от БК «Fair Play» и публикуются на его официальном сайте.",
		"games.virtual-sport": "Виртуальный спорт",
		"games.auth-required": "Необходима авторизация",
		"games.vivo_games": "Live казино - рулетка, покер, блэкджек, баккара…",
		"games.red_rake": "Слоты, Бинго, Покер, Рулетка",
		"games.leap_gaming": "Виртуальный спорт, Скачки, Слоты",
		"games.vivo_slots": "Игровые слот автоматы",
		"games.tv_bet": "ТВ-игры - блэкджек, покер, кено, колесо...",
		"games.fastsport": "Быстрый спорт",
		"games.tv_bet_roullette": "Рулетка Live",
		"games.xpress": "Слоты, казино, лайв-игры",
		"games.jacktop": "Лайв Покер, Блэкджек, Баккара",
		"games.jacktop.black_jack": "Блэкджек",
		"games.jacktop.roulette": "Рулетка",
		"games.jacktop.poker": "Покер",
		"games.jacktop.baccarat": "Баккара",
		"games.back_to_games": "Назад к списку игр",
		"games.back_to_slots": "Вернуться к списку слот-игр",
		"games.new": "Новинки",
		"games.more": "Еще 20 игр",
		"games.all_slots": "Все слоты",
		"game.search": "Поиск",
		"games.featured": "Избранные игры",
		"games.name_of_games": "Название игры",
		"games.all": "Все",
		"games.gamesSlots": "Игровые слот автоматы",
		"games.sport_vfl": "Футбольная лига",
		"games.sport_vfcc": "Футбол Кубок чемпионов",
		"games.sport_vfwc": "Футбол Чемпионат Мира",
		"games.sport_vfc": "Футбол Еврокубок 2020",
		"games.sport_vfac": "Футбол Кубок Азии",
		"games.sport_vbl": "Баскетбольная лига",
		"verify_form.title": "Загрузите или перетащите изображения. Документ должен помещаться в кадр целиком, информация должна быть читабельной.",
		"verify_form.available_files": "Разрешенные файлы: image/jpeg, image/png",
		"verify_form.max_file_size": "Размер не более: 20.00 МБ",
		"verify_form.document_front_side": "Лицевая сторона документа",
		"verify_form.document_back_side": "Оборотная сторона документа",
		"verify_form.selfie_with_document": "Селфи с документом",
		"verify_form.submit": "Отправить",
		"promocode.error.not_found": "Промокод не найден",
		"promocode.error.not_active": "Промокод не активен",
		"promocode.error.used": "Промокод уже использован",
		"promocode.error.not_available": "Промокод недоступен",
		"promocode.title": "Промокод",
		"promocode.tab": "Промокоды",
		"promocode.enter": "Введите промокод",
		"promocode.apply": "Применить",
		"bonus.banner_title": "Удвой свой выигрыш",
		"bonus.banner_text": "Собирай экспрессы, а мы удвоим твой выигрыш!",
		"page.general_keywords_KZ": "букмекерская контора официальный сайт ставка на спорт ставки ставки на спорт онлайн букмекерская контора букмекер ставки букмекерские ставки онлайн сайт ставки ставки онлайн казахстан ставки букмекерская контора ставки кз букмекерская контора онлайн букмекерская контора сайт бк ставки на спорт онлайн онлайн букмекер букмекерская контора сделать ставку онлайн букмекерская контора букмекерская контора он лайн бк ставки на спорт букмекерская контора ставки онлайн букмекерские ставки на спорт онлайн ставки на спорт официальный сайт ставки на спорт бк ставкина спорт букмекерская контора онлайн букмекер кз интернет ставки на спорт контора букмекерская поставить ставку онлайн ставки онлайн кз букмекерская контора ставки спортивный букмекер онлайн ставки букмекерская контора казахстан букмекерские конторы казахстана онлайн официальный букмекер казахстан ставки на спорт ставки онлайн ставки online ставки онлайн на спорт ставка онлайн ставки спортивные букмекерская контора в казахстане ставки на спорт в казахстане букмекерская контора онлайн ставки на спорт бк в казахстане",
		"page.general_description_KZ": "Онлайн ставки на спорт в Казахстане ➤ Официальный сайт легальной букмекерской конторы {companyName} кз 💰 Делайте ставки онлайн в прематч и live ☝ Бонусы 💲 Привлекательные Коэффициенты ",
		"page.general_page_title_KZ": "Ставки на спорт онлайн - Букмекерская контора {companyName} в Казахстане",
		"page.general_keywords_KG": "букмекерская контора официальный сайт ставка на спорт ставки ставки на спорт онлайн букмекерская контора букмекер ставки букмекерские ставки онлайн сайт ставки ставки онлайн Кыргызстан ставки букмекерская контора ставки кг букмекерская контора онлайн букмекерская контора сайт бк ставки на спорт онлайн онлайн букмекер букмекерская контора сделать ставку онлайн букмекерская контора букмекерская контора он лайн бк ставки на спорт букмекерская контора ставки онлайн букмекерские ставки на спорт онлайн ставки на спорт официальный сайт ставки на спорт бк ставкина спорт букмекерская контора онлайн букмекер кг интернет ставки на спорт контора букмекерская поставить ставку онлайн ставки онлайн кг букмекерская контора ставки спортивный букмекер онлайн ставки букмекерская контора Кыргызстан букмекерские конторы Кыргызстана онлайн официальный букмекер Кыргызстан ставки на спорт ставки онлайн ставки online ставки онлайн на спорт ставка онлайн ставки спортивные букмекерская контора в Кыргызстане ставки на спорт в Кыргызстане букмекерская контора онлайн ставки на спорт бк в Кыргызстане",
		"page.general_description_KG": "Онлайн ставки на спорт в Кыргызстане ➤ Официальный сайт легальной букмекерской конторы {companyName} кг 💰 Делайте ставки онлайн в прематч и live ☝ Бонусы 💲 Привлекательные Коэффициенты",
		"page.general_page_title_KG": "Ставки на спорт онлайн - Букмекерская контора {companyName} в Кыргызстане",
		"page.general_page_title_UZ": "Ставки на спорт онлайн - Букмекерская контора {companyName} в Узбекистане",
		"page.general_description_UZ": "Онлайн ставки на спорт в Узбекистане ➤ Официальный сайт легальной букмекерской конторы {companyName} уз 💰 Делайте ставки онлайн в прематч и live ☝ Бонусы 💲 Привлекательные Коэффициенты ",
		"page.general_keywords_UZ": "букмекерская контора официальный сайт ставка на спорт ставки ставки на спорт онлайн букмекерская контора букмекер ставки букмекерские ставки онлайн сайт ставки ставки онлайн Узбекистан ставки букмекерская контора ставки уз букмекерская контора онлайн букмекерская контора сайт бк ставки на спорт онлайн онлайн букмекер букмекерская контора сделать ставку онлайн букмекерская контора букмекерская контора он лайн бк ставки на спорт букмекерская контора ставки онлайн букмекерские ставки на спорт онлайн ставки на спорт официальный сайт ставки на спорт бк ставкина спорт букмекерская контора онлайн букмекер уз интернет ставки на спорт контора букмекерская поставить ставку онлайн ставки онлайн уз букмекерская контора ставки спортивный букмекер онлайн ставки букмекерская контора Узбекистан букмекерские конторы Узбекистана онлайн официальный букмекер Узбекистан ставки на спорт ставки онлайн ставки online ставки онлайн на спорт ставка онлайн ставки спортивные букмекерская контора в Узбекистане ставки на спорт в Узбекистане букмекерская контора онлайн ставки на спорт бк в Узбекистане",
		"page.live_page_title_KZ": "Лайв ставки на спорт в букмекерской конторе {companyName}",
		"page.live_page_description_KZ": "Сделать лайв-ставки по ходу матча 👉 Ставки на спорт в режиме live на официальной сайте бк РингоБет в Казахстане",
		"page.live_page_keywords_KZ": "live ставки лайв ставки ставки лайв ставки live ставки лайф ставки на лайв лайв ставка live ставка live ставки на спорт ставки лайв на спорт ставки на спорт лайф ставки на сегодня",
		"page.live_page_title_KG": "Лайв ставки на спорт в букмекерской конторе {companyName}",
		"page.live_page_description_KG": "Сделать лайв-ставки по ходу матча 👉 Ставки на спорт в режиме live на официальной сайте бк Фэйрплей в Кыргызстане",
		"page.live_page_keywords_KG": "live ставки лайв ставки ставки лайв ставки live ставки лайф ставки на лайв лайв ставка live ставка live ставки на спорт ставки лайв на спорт ставки на спорт лайф ставки на сегодня",
		"page.live_page_title_UZ": "Лайв ставки на спорт в букмекерской конторе {companyName}",
		"page.live_page_description_UZ": "Сделать лайв-ставки по ходу матча 👉 Ставки на спорт в режиме live на официальной сайте бк Фэйрплей в Узбекистане",
		"page.live_page_keywords_UZ": "live ставки лайв ставки ставки лайв ставки live ставки лайф ставки на лайв лайв ставка live ставка live ставки на спорт ставки лайв на спорт ставки на спорт лайф ставки на сегодня",
		"page.sports_2_title_KZ": "Ставки на настольный теннис онлайн сегодня 👉 бк {companyName} в Казахстане",
		"page.sports_2_description_KZ": "Ставки на настольный теннис онлайн 🏈 Пинг-понг сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на настольный теннис 👉 на официальной сайте бк РингоБет в Казахстане",
		"page.sports_2_keywords_KZ": "настольный теннис лайв результаты ставки на настольный теннис настольный теннис лайв ставки ставки на настольный теннис в лайве настольный теннис ставки ставки настольный теннис ставки на настольный теннис лайв пингпонг ставки ставки на ping pong ставки на пинг понг пинг понг ставки",
		"page.sports_4_title_KZ": "Волейбол лайф - Live ставки на волейбол онлайн сегодня 👉 бк {companyName} в Казахстане",
		"page.sports_4_description_KZ": "Live ставки на волейбол онлайн 🏐 Волейбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Волейбол Live 👉 на официальной сайте бк РингоБет в Казахстане",
		"page.sports_4_keywords_KZ": "ставки на волейбол онлайн волейбол лайв волейбол live live волейбол ставки на волейбол в лайве",
		"page.sports_5_title_KZ": "Ставки на бокс - Ставки на бокс онлайн сегодня 👉 бк {companyName} в Казахстане",
		"page.sports_5_description_KZ": "Ставки на бокс онлайн 🥊 Боксерские бои сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на бокс 👉 на официальной сайте бк РингоБет в Казахстане",
		"page.sports_5_keywords_KZ": "ставки на бокс бокс ставка ставки бокс бокс ставки ставки на бокс на сегодня ставки на бои бокс букмекерские ставки на бокс букмекерская контора ставки на бокс поставить ставку на бокс коэффициенты на бокс ставки на бокс сегодня ставки на спорт бокс сделать ставку на бокс сегодня сделать ставку на бокс сделать ставку на бокс онлайн",
		"page.sports_6_title_KZ": "Теннис лайв - Live ставки на теннис онлайн сегодня 👉 бк {companyName} в Казахстане",
		"page.sports_6_description_KZ": "Live ставки на теннис онлайн 🎾 Теннисные матчи сегодня 💰 Высокие коэффициенты ⭐ Теннис Live 👉 на официальной сайте бк РингоБет в Казахстане",
		"page.sports_6_keywords_KZ": "live ставки на теннис ставки на теннис онлайн ставки теннис лайв теннис лайв ставки лайв ставки на теннис лайв ставки теннис ставки на теннис лайв лайв теннис ставки на теннис в лайве прогнозы на теннис live теннис лайв счет теннис онлайн теннис лайв прогнозы",
		"page.sports_7_title_KZ": "Футбол лайф - Live ставки на футбол онлайн сегодня 👉 бк {companyName} в Казахстане",
		"page.sports_7_description_KZ": "Live ставки на футбол онлайн ⚽ Футбольные матчи сегодня 👍 Ставки по ходу футбольного матча ⭐ Футбол Live 👉 на официальной сайте бк РингоБет в Казахстане",
		"page.sports_7_keywords_KZ": "live ставки футбол live ставки на футбол футбол лайв ставки лайв футболы футбол лай лив футбол ставки в лайве на футбол лайф футбол футбол лайф футбол лайф сегодня ливе футбол футбол life лайв футбол онлайн live футбол live футбол онлайн футбол в лайве футбольный live лайв спорт футбол live sport футбол ливе спорт футбол футбол лайв футбол ставки на сегодня",
		"page.sports_11_title_KZ": "Ставки на американский футбол онлайн сегодня 👉 бк {companyName} в Казахстане",
		"page.sports_11_description_KZ": "Ставки на американский футбол онлайн 🏈 Матчи американского футбола сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на американский футбол 👉 на официальной сайте бк РингоБет в Казахстане",
		"page.sports_11_keywords_KZ": "американский футбол ставки ставки на американский футбол американский футбол сегодня ставки на американский футбол онлайн ставки на американский футбол на сегодня ставки на спорт американский футбол",
		"page.sports_19_title_KZ": "Гандбол лайф - Live ставки на гандбол онлайн сегодня 👉 бк {companyName} в Казахстане",
		"page.sports_19_description_KZ": "Live ставки на гандбол онлайн 🤾 Гандбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Гандбол Live 👉 на официальной сайте бк РингоБет в Казахстане",
		"page.sports_19_keywords_KZ": "ставки на гандбол лайв гандбол онлайн",
		"page.sports_30_title_KZ": "Хоккей лайф - Live ставки на хоккей онлайн сегодня 👉 бк {companyName} в Казахстане",
		"page.sports_30_description_KZ": "Live ставки на хоккей онлайн 🏒 Хоккейные матчи сегодня 💰 Высокие коэффициенты ⭐ Хоккей Live 👉 на официальной сайте бк РингоБет в Казахстане",
		"page.sports_30_keywords_KZ": "хоккей лайв ставки ставки лайв хоккей ставки на хоккей онлайн хоккей лайф хоккей ливе лайв хоккей лайф хоккей хоккей live хоккей лайв ставки хоккей хоккей ставки",
		"page.sports_31_title_KZ": "Баскетбол лайв - Live ставки на баскетбол онлайн сегодня 👉 бк {companyName} в Казахстане",
		"page.sports_31_description_KZ": "Live ставки на баскетбол онлайн 🏀 Баскетбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Баскетбол Live 👉 на официальном сайте бк РингоБет в Казахстане",
		"page.sports_31_keywords_KZ": "баскетбол лайв ставки лайф баскетбол баскетбол ливе баскетбол live ставки на баскетбол в лайве спорт лайф баскетбол",
		"page.sports_38_title_KZ": "Ставки на киберспорт live онлайн сегодня 👉 бк {companyName} в Казахстане",
		"page.sports_38_description_KZ": "Live ставки на киберспорт онлайн 🎮 Киберспорт лайв 💰 Высокие коэффициенты 👉 на официальной сайте бк РингоБет в Казахстане",
		"page.sports_38_keywords_KZ": "лайв ставки на киберспорт лайв ставки киберспорт live ставки на киберспорт ставки киберспорт ставки на киберспор",
		"page.sports_39_title_KZ": "Ставки на UFC - Ставки на ММА онлайн сегодня 👉 бк {companyName} в Казахстане",
		"page.sports_39_description_KZ": "Ставки на смешанные единоборства (MMA и UFC) онлайн 👊 ЮФС бои сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на бой ММА 👉 на официальной сайте бк РингоБет в Казахстане",
		"page.sports_39_keywords_KZ": "ставки на бои ставки на бой ставки на ufc ставки на юфс ufc ставки ставка на юфс ставка на бой ставка на ufc ставки юфс ставки на ufc в казахстане коэффициент ufc юфс ставки ставки на спорт ufc коэффициенты на бои ufc ставки на бои юфс поставить ставку ufc поставить ставку на бой сделать ставку на ufc ставка ufc сделать ставку на бой ставки на ufc онлайн ставки на бои без правил ufc ставки на бои мма коэффициенты на юфс ставки на мма ставки на спорт юфс ставки на мма бои коэффициент на бой ставки на бойцов ufc ставки ufc сделать ставку ufc ставки на бои ufc ufc коэффициенты ставки ufc коэффициенты ставки на мма сегодня поставить ставку на ufc ставки на спорт бои сделать ставку на мма ставки на спорт мма ставки на мма онлайн",
		"page.sports_2_title_KG": "Ставки на настольный теннис онлайн сегодня 👉 бк {companyName} в Кыргызстане",
		"page.sports_2_description_KG": "Ставки на настольный теннис онлайн 🏈 Пинг-понг сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на настольный теннис 👉 на официальной сайте бк Фэйрплей в Кыргызстане",
		"page.sports_2_keywords_KG": "настольный теннис лайв результаты ставки на настольный теннис настольный теннис лайв ставки ставки на настольный теннис в лайве настольный теннис ставки ставки настольный теннис ставки на настольный теннис лайв пингпонг ставки ставки на ping pong ставки на пинг понг пинг понг ставки",
		"page.sports_4_title_KG": "Волейбол лайф - Live ставки на волейбол онлайн сегодня 👉 бк {companyName} в Кыргызстане",
		"page.sports_4_description_KG": "Live ставки на волейбол онлайн 🏐 Волейбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Волейбол Live 👉 на официальной сайте бк Фэйрплей в Кыргызстане",
		"page.sports_4_keywords_KG": "ставки на волейбол онлайн волейбол лайв волейбол live live волейбол ставки на волейбол в лайве",
		"page.sports_5_title_KG": "Ставки на бокс - Ставки на бокс онлайн сегодня 👉 бк {companyName} в Кыргызстане",
		"page.sports_5_description_KG": "Ставки на бокс онлайн 🥊 Боксерские бои сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на бокс 👉 на официальной сайте бк Фэйрплей в Кыргызстане",
		"page.sports_5_keywords_KG": "ставки на бокс бокс ставка ставки бокс бокс ставки ставки на бокс на сегодня ставки на бои бокс букмекерские ставки на бокс букмекерская контора ставки на бокс поставить ставку на бокс коэффициенты на бокс ставки на бокс сегодня ставки на спорт бокс сделать ставку на бокс сегодня сделать ставку на бокс сделать ставку на бокс онлайн",
		"page.sports_6_title_KG": "Теннис лайв - Live ставки на теннис онлайн сегодня 👉 бк {companyName} в Кыргызстане",
		"page.sports_6_description_KG": "Live ставки на теннис онлайн 🎾 Теннисные матчи сегодня 💰 Высокие коэффициенты ⭐ Теннис Live 👉 на официальной сайте бк Фэйрплей в Кыргызстане",
		"page.sports_6_keywords_KG": "live ставки на теннис ставки на теннис онлайн ставки теннис лайв теннис лайв ставки лайв ставки на теннис лайв ставки теннис ставки на теннис лайв лайв теннис ставки на теннис в лайве прогнозы на теннис live теннис лайв счет теннис онлайн теннис лайв прогнозы",
		"page.sports_7_title_KG": "Футбол лайф - Live ставки на футбол онлайн сегодня 👉 бк {companyName} в Кыргызстане",
		"page.sports_7_description_KG": "Live ставки на футбол онлайн ⚽ Футбольные матчи сегодня 👍 Ставки по ходу футбольного матча ⭐ Футбол Live 👉 на официальной сайте бк Фэйрплей в Кыргызстане",
		"page.sports_7_keywords_KG": "live ставки футбол live ставки на футбол футбол лайв ставки лайв футболы футбол лай лив футбол ставки в лайве на футбол лайф футбол футбол лайф футбол лайф сегодня ливе футбол футбол life лайв футбол онлайн live футбол live футбол онлайн футбол в лайве футбольный live лайв спорт футбол live sport футбол ливе спорт футбол футбол лайв футбол ставки на сегодня",
		"page.sports_11_title_KG": "Ставки на американский футбол онлайн сегодня 👉 бк {companyName} в Кыргызстане",
		"page.sports_11_description_KG": "Ставки на американский футбол онлайн 🏈 Матчи американского футбола сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на американский футбол 👉 на официальной сайте бк Фэйрплей в Кыргызстане",
		"page.sports_11_keywords_KG": "американский футбол ставки ставки на американский футбол американский футбол сегодня ставки на американский футбол онлайн ставки на американский футбол на сегодня ставки на спорт американский футбол",
		"page.sports_19_title_KG": "Гандбол лайф - Live ставки на гандбол онлайн сегодня 👉 бк {companyName} в Кыргызстане",
		"page.sports_19_description_KG": "Live ставки на гандбол онлайн 🤾 Гандбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Гандбол Live 👉 на официальной сайте бк Фэйрплей в Кыргызстане",
		"page.sports_19_keywords_KG": "ставки на гандбол лайв гандбол онлайн",
		"page.sports_30_title_KG": "Хоккей лайф - Live ставки на хоккей онлайн сегодня 👉 бк {companyName} в Кыргызстане",
		"page.sports_30_description_KG": "Live ставки на хоккей онлайн 🏒 Хоккейные матчи сегодня 💰 Высокие коэффициенты ⭐ Хоккей Live 👉 на официальной сайте бк Фэйрплей в Кыргызстане",
		"page.sports_30_keywords_KG": "хоккей лайв ставки ставки лайв хоккей ставки на хоккей онлайн хоккей лайф хоккей ливе лайв хоккей лайф хоккей хоккей live хоккей лайв ставки хоккей хоккей ставки",
		"page.sports_31_title_KG": "Баскетбол лайв - Live ставки на баскетбол онлайн сегодня 👉 бк {companyName} в Кыргызстане",
		"page.sports_31_description_KG": "Live ставки на баскетбол онлайн 🏀 Баскетбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Баскетбол Live 👉 на официальной сайте бк Фэйрплей в Кыргызстане",
		"page.sports_31_keywords_KG": "баскетбол лайв ставки лайф баскетбол баскетбол ливе баскетбол live ставки на баскетбол в лайве спорт лайф баскетбол",
		"page.sports_38_title_KG": "Ставки на киберспорт live онлайн сегодня 👉 бк {companyName} в Кыргызстане",
		"page.sports_38_description_KG": "Live ставки на киберспорт онлайн 🎮 Киберспорт лайв 💰 Высокие коэффициенты 👉 на официальной сайте бк Фэйрплей в Кыргызстане",
		"page.sports_38_keywords_KG": "лайв ставки на киберспорт лайв ставки киберспорт live ставки на киберспорт ставки киберспорт ставки на киберспор",
		"page.sports_39_title_KG": "Ставки на UFC - Ставки на ММА онлайн сегодня 👉 бк {companyName} в Кыргызстане",
		"page.sports_39_description_KG": "Ставки на смешанные единоборства (MMA и UFC) онлайн 👊 ЮФС бои сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на бой ММА 👉 на официальной сайте бк Фэйрплей в Кыргызстане",
		"page.sports_39_keywords_KG": "ставки на бои ставки на бой ставки на ufc ставки на юфс ufc ставки ставка на юфс ставка на бой ставка на ufc ставки юфс ставки на ufc в Кыргызстане коэффициент ufc юфс ставки ставки на спорт ufc коэффициенты на бои ufc ставки на бои юфс поставить ставку ufc поставить ставку на бой сделать ставку на ufc ставка ufc сделать ставку на бой ставки на ufc онлайн ставки на бои без правил ufc ставки на бои мма коэффициенты на юфс ставки на мма ставки на спорт юфс ставки на мма бои коэффициент на бой ставки на бойцов ufc ставки ufc сделать ставку ufc ставки на бои ufc ufc коэффициенты ставки ufc коэффициенты ставки на мма сегодня поставить ставку на ufc ставки на спорт бои сделать ставку на мма ставки на спорт мма ставки на мма онлайн",
		"page.sports_2_title_UZ": "Ставки на настольный теннис онлайн сегодня 👉 бк {companyName} в Узбекистане",
		"page.sports_2_description_UZ": "Ставки на настольный теннис онлайн 🏈 Пинг-понг сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на настольный теннис 👉 на официальной сайте бк Фэйрплей в Узбекистане",
		"page.sports_2_keywords_UZ": "настольный теннис лайв результаты ставки на настольный теннис настольный теннис лайв ставки ставки на настольный теннис в лайве настольный теннис ставки ставки настольный теннис ставки на настольный теннис лайв пингпонг ставки ставки на ping pong ставки на пинг понг пинг понг ставки",
		"page.sports_4_title_UZ": "Волейбол лайф - Live ставки на волейбол онлайн сегодня 👉 бк {companyName} в Узбекистане",
		"page.sports_4_description_UZ": "Live ставки на волейбол онлайн 🏐 Волейбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Волейбол Live 👉 на официальной сайте бк Фэйрплей в Узбекистане",
		"page.sports_4_keywords_UZ": "ставки на волейбол онлайн волейбол лайв волейбол live live волейбол ставки на волейбол в лайве",
		"page.sports_5_title_UZ": "Ставки на бокс - Ставки на бокс онлайн сегодня 👉 бк {companyName} в Узбекистане",
		"page.sports_5_description_UZ": "Ставки на бокс онлайн 🥊 Боксерские бои сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на бокс 👉 на официальной сайте бк Фэйрплей в Узбекистане",
		"page.sports_5_keywords_UZ": "ставки на бокс бокс ставка ставки бокс бокс ставки ставки на бокс на сегодня ставки на бои бокс букмекерские ставки на бокс букмекерская контора ставки на бокс поставить ставку на бокс коэффициенты на бокс ставки на бокс сегодня ставки на спорт бокс сделать ставку на бокс сегодня сделать ставку на бокс сделать ставку на бокс онлайн",
		"page.sports_6_title_UZ": "Теннис лайв - Live ставки на теннис онлайн сегодня 👉 бк {companyName} в Узбекистане",
		"page.sports_6_description_UZ": "Live ставки на теннис онлайн 🎾 Теннисные матчи сегодня 💰 Высокие коэффициенты ⭐ Теннис Live 👉 на официальной сайте бк Фэйрплей в Узбекистане",
		"page.sports_6_keywords_UZ": "live ставки на теннис ставки на теннис онлайн ставки теннис лайв теннис лайв ставки лайв ставки на теннис лайв ставки теннис ставки на теннис лайв лайв теннис ставки на теннис в лайве прогнозы на теннис live теннис лайв счет теннис онлайн теннис лайв прогнозы",
		"page.sports_7_title_UZ": "Футбол лайф - Live ставки на футбол онлайн сегодня 👉 бк {companyName} в Узбекистане",
		"page.sports_7_description_UZ": "Live ставки на футбол онлайн ⚽ Футбольные матчи сегодня 👍 Ставки по ходу футбольного матча ⭐ Футбол Live 👉 на официальной сайте бк Фэйрплей в Узбекистане",
		"page.sports_7_keywords_UZ": "live ставки футбол live ставки на футбол футбол лайв ставки лайв футболы футбол лай лив футбол ставки в лайве на футбол лайф футбол футбол лайф футбол лайф сегодня ливе футбол футбол life лайв футбол онлайн live футбол live футбол онлайн футбол в лайве футбольный live лайв спорт футбол live sport футбол ливе спорт футбол футбол лайв футбол ставки на сегодня",
		"page.sports_11_title_UZ": "Ставки на американский футбол онлайн сегодня 👉 бк {companyName} в Узбекистане",
		"page.sports_11_description_UZ": "Ставки на американский футбол онлайн 🏈 Матчи американского футбола сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на американский футбол 👉 на официальной сайте бк Фэйрплей в Узбекистане",
		"page.sports_11_keywords_UZ": "американский футбол ставки ставки на американский футбол американский футбол сегодня ставки на американский футбол онлайн ставки на американский футбол на сегодня ставки на спорт американский футбол",
		"page.sports_19_title_UZ": "Гандбол лайф - Live ставки на гандбол онлайн сегодня 👉 бк {companyName} в Узбекистане",
		"page.sports_19_description_UZ": "Live ставки на гандбол онлайн 🤾 Гандбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Гандбол Live 👉 на официальной сайте бк Фэйрплей в Узбекистане",
		"page.sports_19_keywords_UZ": "ставки на гандбол лайв гандбол онлайн",
		"page.sports_30_title_UZ": "Хоккей лайф - Live ставки на хоккей онлайн сегодня 👉 бк {companyName} в Узбекистане",
		"page.sports_30_description_UZ": "Live ставки на хоккей онлайн 🏒 Хоккейные матчи сегодня 💰 Высокие коэффициенты ⭐ Хоккей Live 👉 на официальной сайте бк Фэйрплей в Узбекистане",
		"page.sports_30_keywords_UZ": "хоккей лайв ставки ставки лайв хоккей ставки на хоккей онлайн хоккей лайф хоккей ливе лайв хоккей лайф хоккей хоккей live хоккей лайв ставки хоккей хоккей ставки",
		"page.sports_31_title_UZ": "Баскетбол лайв - Live ставки на баскетбол онлайн сегодня 👉 бк {companyName} в Узбекистане",
		"page.sports_31_description_UZ": "Live ставки на баскетбол онлайн 🏀 Баскетбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Баскетбол Live 👉 на официальной сайте бк Фэйрплей в Узбекистане",
		"page.sports_31_keywords_UZ": "баскетбол лайв ставки лайф баскетбол баскетбол ливе баскетбол live ставки на баскетбол в лайве спорт лайф баскетбол",
		"page.sports_38_title_UZ": "Ставки на киберспорт live онлайн сегодня 👉 бк {companyName} в Узбекистане",
		"page.sports_38_description_UZ": "Live ставки на киберспорт онлайн 🎮 Киберспорт лайв 💰 Высокие коэффициенты 👉 на официальной сайте бк Фэйрплей в Узбекистане",
		"page.sports_38_keywords_UZ": "лайв ставки на киберспорт лайв ставки киберспорт live ставки на киберспорт ставки киберспорт ставки на киберспор",
		"page.sports_39_title_UZ": "Ставки на UFC - Ставки на ММА онлайн сегодня 👉 бк {companyName} в Узбекистане",
		"page.sports_39_description_UZ": "Ставки на смешанные единоборства (MMA и UFC) онлайн 👊 ЮФС бои сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на бой ММА 👉 на официальной сайте бк Фэйрплей в Узбекистане",
		"page.sports_39_keywords_UZ": "ставки на бои ставки на бой ставки на ufc ставки на юфс ufc ставки ставка на юфс ставка на бой ставка на ufc ставки юфс ставки на ufc в Узбекистане коэффициент ufc юфс ставки ставки на спорт ufc коэффициенты на бои ufc ставки на бои юфс поставить ставку ufc поставить ставку на бой сделать ставку на ufc ставка ufc сделать ставку на бой ставки на ufc онлайн ставки на бои без правил ufc ставки на бои мма коэффициенты на юфс ставки на мма ставки на спорт юфс ставки на мма бои коэффициент на бой ставки на бойцов ufc ставки ufc сделать ставку ufc ставки на бои ufc ufc коэффициенты ставки ufc коэффициенты ставки на мма сегодня поставить ставку на ufc ставки на спорт бои сделать ставку на мма ставки на спорт мма ставки на мма онлайн",
		"instagram.banner.iphone_title": "Акция в инстаграм @fairplay",
		"instagram.banner.freebet_text": "РОЗЫГРЫШ ФРИБЕТОВ",
		"instagram.banner.center_text": "Акция в инстаграм",
		"newGames.showAllGames": "Посмотреть все игры",
		"newGames.showRecentGames": "Посмотреть недавние игры",
		"newGames.showFavorites": "Посмотреть избранные игры",
		"newGames.allTypes": "Все типы",
		"newGames.allProviders": "Все провайдеры",
		"newGames.popular": "Популярные",
		"newGames.showAll": "Показать  все",
		"newGames.searchGame": "Поиск по названию игр",
		"newGames.goBackToGames": "Вернуться к играм",
		"newGames.allGamesForCategory": "Все игры для категории",
		"newGames.favoriteGames": "Избранные игры",
		"newGames.recentGames": "Недавние игры",
		"newGames.recentGamesNot": "У вас нет недавних игр",
		"newGames.favoriteGamesNot": "У вас нет избранных игр",
		"newGames.showMore": "Показать еще",
		"newGames.allGames": "Все игры",
		"newGames.New": "New",
		"newGames.Hot": "Хит"
	};

/***/ },
/* 1833 */
/***/ function(module, exports) {

	module.exports = {
		"header.navigation.sports": "Sport",
		"header.navigation.live": "Live",
		"header.navigation.cybersport": "Киберспорт",
		"header.navigation.results": "Natijalar",
		"header.navigation.fastsport": "Tez sport",
		"header.navigation.promotions": "Aktsiya va bonuslar",
		"header.navigation.more": "Ko'proq",
		"header.help": "Yordam",
		"header.locale.choose": "Til tanlash:",
		"header.menu.menu_text": "Menyu",
		"header.menu.company_news": "Kompaniya yangiliklari",
		"header.menu.regulations": "Qoidalar",
		"header.menu.responsible_game": "Mas'uliyatli o'yin",
		"header.menu.contact_information": "Bog'lanish uchun ma'lumot",
		"header.menu.betting_shop": "Tikish do'konlari",
		"header.menu.players_best_bets": "O`yinchilarning eng yaxshi garovlari",
		"header.menu.internet_bonus": "Aktsiya va bonuslar",
		"header.menu.privacy_policy": "Maxfiylik siyosati",
		"header.user_menu.title": "Profil",
		"header.user_menu.account_num": "Hisob raqami",
		"header.user_menu.recharge": "Balansni to'ldirish",
		"header.user_menu.briefcase": "Garovlar portfeli",
		"header.user_menu.bet_history": "Garovlar tarixi",
		"header.user_menu.account_history": "Hisob tarixi",
		"header.user_menu.withdraw": "Hisobdan pul chiqarish",
		"header.user_menu.opex_checks": "Чеки «Opex»",
		"header.user_menu.usdt_checks": "«USD₮» checks",
		"header.user_menu.profile": "Mening profilim",
		"header.user_menu.bonus": "Bonuslar",
		"header.user_menu.logout": "Saytdan chiqish",
		"header.freebet.title.default": "Siz uchun {sum}{currency} miqdorida bepul stavka (freebet) mavjud\nHarakatning boshlanishi {start}\nHarakatning oxiri {end}",
		"header.freebet.title.promocode": "Siz uchun {sum} {currency} miqdorida{promocode}promo-kodi bo'yicha bepul pul tikish (freebet) mavjud\nHarakatning boshlanishi {start}\nHarakatning oxiri {end}",
		"header.freebet.max_factor": "Распространяется на любые ставки с максимальным коэфф. {maxFactor}.",
		"header.freebet.valid_thru": "Начало действия от {startDate}",
		"header.freebet.valid_until": "Конец действия до {expireDate}",
		"header.freebet.details": "Подробнее о Фрибете",
		"header.games": "O'yinlar",
		"header.gamesFromVivo": "Vivo dan o'yinlar",
		"notification.new_message.new_message": "Yangi xabar",
		"notification.new_message.proceed_to_messages": "Xabarlarga o'ting",
		"notification.new_message.close": "Yaqin",
		"menu.bookmarks": "Saralanganlar",
		"menu.others": "Turli xil",
		"menu.all_sport": "Barcha voqealar",
		"menu.popular_sport": "Mashhur voqealar",
		"menu.calendar": "Kalendar",
		"grid.menu.title": "Hodisalar menyusi",
		"grid.menu.collapse_all_events": "Barcha hodisalarni yoyish",
		"grid.menu.expand_all_events": "Barcha hodisalarni yashirish",
		"grid.menu.collapse_all_groups": "Barcha qo`shimcha garovlarni yashirish",
		"grid.menu.expand_all_groups": "Barcha qo`shimcha garovlarni yoyish",
		"grid.menu.display_line_numbers": "Hodisa raqamlarini ko'rsatish",
		"grid.menu.hide_line_numbers": "Hodisa raqamlarini yashirish",
		"grid.menu.prematch_filter.title": "Ko'rsatish",
		"grid.menu.prematch_filter.all_time": "Barcha voqealar",
		"grid.menu.prematch_filter.next_hour": "Keyingi soat",
		"grid.menu.prematch_filter.next_2_hours": "Keyingi 2 soat",
		"grid.menu.prematch_filter.next_4_hours": "Keyingi 4 часа",
		"grid.menu.prematch_filter.next_6_hours": "Keyingi 6 часов",
		"grid.menu.prematch_filter.next_12_hours": "Keyingi 12 soat",
		"grid.menu.prematch_filter.next_day": "Keyingi kun",
		"grid.menu.prematch_filter.next_2_days": "Keyingi 2 kun",
		"grid.header.event": "Sport tikish",
		"grid.header.win1": "G`1",
		"grid.header.draw": "X",
		"grid.header.win2": "G`2",
		"grid.header.win1_draw": "1X",
		"grid.header.win12": "12",
		"grid.header.draw_win2": "X2",
		"grid.header.handicap": "FORA",
		"grid.header.handicap1": "1",
		"grid.header.handicap2": "2",
		"grid.header.under": "KAM",
		"grid.header.total": "JAMI",
		"grid.header.over": "KO`P",
		"grid.header.live.matches": "Live o'yinlari",
		"grid.match-current-time.forward": "{minute}'",
		"grid.match-current-time.backward": "ост. < {minute}'",
		"grid.match-current-scores.not_started": " Uchrashuv boshlanmadi",
		"grid.match-current-scores.finished": " O'yin tugadi",
		"grid.match.datetime_at": "",
		"grid.match.today": "Bugun",
		"grid.match.tomorrow": "Ertaga",
		"grid.header.live_bets_online": " onlayn tikish",
		"grid.header.football": "Futbolga",
		"grid.header.tennis": "Tennisga",
		"grid.header.cybersport": "Kibersport",
		"grid.header.hockey": "Xokkey",
		"grid.header.basketball": "Basketbolga",
		"grid.header.voleyball": "Voleybol",
		"grid.header.handball": "Qo'l to'pi",
		"grid.header.boxing": "Onlayn boks tikish",
		"grid.header.UFC_MMA": "UFC va MMAga onlayn tikish",
		"grid.header.american_football": "Amerika futboliga onlayn tikish",
		"grid.header.table_tennis": "Onlayn stol tennisi tikish",
		"play.stream.video": "Доступна прямая трансляция",
		"login.to.watch": "Войдите в систему для просмотра",
		"timetable.title": "Kelgusi jonli voqealar taqvimi",
		"timetable.time_filter": "Barcha voqealar",
		"timetable.sort_by_time": "Vaqt bo'yicha saralash",
		"timetable.sort_by_league": "Raqobat turlari bo'yicha saralash",
		"timetable.matches_filter_menu.title": "Ko'rsatish",
		"timetable.matches_filter_menu.no_filter": "Barcha voqealar",
		"timetable.matches_filter_menu.one_hour": "Keyingi soat",
		"timetable.matches_filter_menu.two_hours": "Keyingi 2 soat",
		"timetable.matches_filter_menu.four_hours": "Keyingi 4 soat",
		"timetable.matches_filter_menu.six_hours": "Keyingi 6 soat",
		"timetable.matches_filter_menu.twelve_hours": "Keyingi 12 soat",
		"timetable.matches_filter_menu.one_day": "Keyingi kun",
		"timetable.matches_filter_menu.two_days": "Keyingi 2 kun",
		"betpanel.title": "Tikish",
		"betpanel.help": "Kuponga garov tikish",
		"coupon.title": "Yangi garov",
		"coupon.make_bet": "Garov tikish",
		"coupon.rate_unavailable": "Koeff mavjud emas",
		"coupon.stake_title": "Garov:",
		"coupon.rate_title": "Koef:",
		"coupon.rate_changed": "Koef o'zgargan",
		"coupon.confirm_rate_value_change": "Qabul qilmoq",
		"coupon.stake_hint": "Garov miqdori",
		"coupon.min_amount_hint": "Min.",
		"coupon.max_amount_hint": "Maks. {amount} {resource}",
		"coupon.bet_type_hint": "Garov turi",
		"coupon.total_odd_hint": "Umumiy koeffitsient",
		"coupon.possible_winning_hint": "Kutilayotgan ga`laba",
		"coupon.possible_winning_hint_short": "Yutuqlar",
		"coupon.not_possible_stake": "Bu garov mavjud emas",
		"coupon.menu.title": "Garovlar menyusi",
		"coupon.menu.one-click_checkbox": "Bir bosishda garov tikish",
		"coupon.menu.one-click_amount": "Garov miqdori ",
		"coupon.menu.accept_factor_increase": "Koeffitsient oshishiga roziman",
		"coupon.menu.accept_factor_decrease": "Koeffitsient pasayishiga roziman",
		"coupon.menu.accept_total_and_handicap_change": "O'zgartirilgan totallar/andikaplar bilan garovlarni qabul qiling",
		"coupon.menu.favouriteBets": "Yoqgan garovlar",
		"coupon.menu.favouriteBet": "Garov {num}",
		"coupon.sum_label": "Miqdor",
		"coupon_bet_promocode_not_found1": "Promo-kod topilmadi",
		"coupon_bet_for_get_freebet_fill_balance21": "Bepul tikish uchun hisobingizni {amount} {currency} miqdorida to'ldirishingiz kerak",
		"coupon_bet_for_using_freebet_make_stake_more22": "Bepul garovdan foydalanish uchun siz kamida {amount} {currency} pul tikishingiz kerak.",
		"coupon_bet_for_using_freebet_nessery_auth24": "Bepul tikishdan foydalanish uchun hisobni identifikatsiya qilish talab qilinadi",
		"coupon_bet_for_stake_type32": "Tikish turiga taalluqlidir: {amount}",
		"coupon_bet_not_for_stake_type37": "Bu oʻyin uchun qoʻllanilmaydi",
		"coupon_bet_not_for_the_league38": "Bu ligaga taalluqli emas",
		"coupon_bet_min_coef_should33": "Minimal toq  bo'lishi kerak {amount}",
		"coupon_for_using_freebet_nesessarry_choose_more35": "Bepul tikishdan foydalanish uchun kamida {amount} voqeani tanlashingiz kerak",
		"coupon_bet_nessary_should_more23": "Gamblinglar miqdori {amount} dan oshishi kerak",
		"coupon_bet_coef_stakes_changed2": "garov koeffitsienti o'zgartirildi",
		"coupon_bet_validation_is_not_accept31": " Promo-kod faqat {value} dan oshmasligi kerak ",
		"coupon_bet_validation_is_not_accept_by_minCoef34": " Koeffitsient {amount} dan oshmasligi kerak",
		"coupon_bet_freebet_sum_not_equal_sum_stake36": "Bepul tikish miqdori tikish miqdoridan kam/ko'p",
		"bet_type.ordinar": "Oddiy",
		"bet_type.accumulator": "Ekspress",
		"bet_type.looseToWinAccumulator": "Антиэкспресс",
		"bet_type.system": "{count} dan {rank} tizimi",
		"bet_title.new_bet": "Yangi garov",
		"bet_status.not_accepted": "Qabul qilinmagan",
		"bet_status.accepted": "Qabul qilindi",
		"bet_status.canceled": "Bekor qilindi",
		"bet_status.sold": "Sotildi",
		"bet_status.won": "Yutuq",
		"bet_status.lost": "Yo'qolgan",
		"bet_history.refund": "Qaytish",
		"bet_history.bet_under_consideration": "Tasdiqlashda",
		"bet_history.bet_under_consideration_tooltip": "Tasdiqlash garovi. Ko'proq ko'proq. Tasdiqlash garovi. Ko'proq ko'proq.",
		"bet_history.sell": "Sotish",
		"bet_history.sell_cancel": "Bekor qilish",
		"bet_history.cashout_amount_changed": "Sotish miqdori o'zgartirildi",
		"bet_history.cashout_confirmation": "Savdo taklifini,{br}sotish summasini tasdiqlang",
		"bet_history.event_stake_cashout_forbidden": "Ushbu tadbir uchun garovlar sotuvi yopiq",
		"bet_history.rates_changed": "Iqtibos{br}yangilangan",
		"bet_history.big_stake_cancel": "Garovni bekor qilish",
		"bet_history.rate": "Koef: ",
		"bet_history.stake": "Garov: ",
		"bet_history.errors.insufficient_funds": "Balans yetarli emas",
		"bet_history.errors.account_locked": "Hisobingiz bloklangan",
		"bet_history.errors.system_not_allowed_for_freebet": "'Tizim' kabi bepul garovlarga ruxsat berilmaydi",
		"bet_history.errors.incorrect_stake_data": "Tarif bo'yicha noto'g'ri ma'lumotlar",
		"bet_history.errors.min_stake_amount": "Minimal tikish miqdori {minAmount} {currency}",
		"bet_history.errors.incorrect_virtual_stake": "Virtual hisobdan noto'g'ri tikish",
		"bet_history.errors.incorrect_freebet_stake": "Noto'g'ri bepul tikish ma'lumotlari",
		"bet_history.errors.existing_active_stake": "Tizim xatosi",
		"bet_history.errors.no_big_stake_permission": "Yirik garovlar taqiqlangan",
		"bet_history.errors.freebet_big_stake": "Freebet tikish katta bo'lishi mumkin emas",
		"bet_history.errors.bet_not_accepted_by_terms": "Ushbu bonusdan foydalanish uchun siz promo-kod tavsifida ko'rsatilgan shartlarni bajarishingiz kerak.",
		"news.read_title": "Читать",
		"news.company_news": "Новости компании",
		"live.error.connection_lost": "Maʼlumotlar serveriga ulanish oʻrnatilmadi, kuting",
		"popular.title": "Mashhur sport tikish",
		"popular.win1": "G`1",
		"popular.draw": "Х",
		"popular.win2": "G`2",
		"header.signin.join_title": "Ro'yxatga olish",
		"header.signin.title": "Kirish",
		"sign_in.phone": "Telefon raqami",
		"sign_in.email": "E-mail",
		"sign_in.login": "Kirish",
		"sign_in.or": "yoki",
		"sign_in.title": "Avtorizatsiya",
		"sign_in.requisite": "Taqdimotlar",
		"sign_in.password": "Parol",
		"sign_in.log_in": "Kirish",
		"sign_in.resend_activation": "Yuborish",
		"sign_in.join": "Ro'yxatga olish",
		"sign_in.forgot": "Foydalanuvchi nomingiz yoki parolingizni unutdingizmi?",
		"sign_in.activation_sent": "Hisobingizni faollashtirish uchun havolasi bor xat {email} manziliga yuborildi.",
		"sign_in.errors.invalid_credentials": "Noto'g'ri login yoki parol!",
		"sign_in.errors.user_blocked": "Слишком много попыток. Попробуйте через 15 минут",
		"sign_in.errors.internal": "Xato. Texnik yordamga murojaat qiling",
		"sign_in.errors.not_activated": "Hisobingiz faollashtirilmagan. Faollashtirish havolasi yana {email} manziliga yuborilsinmi?",
		"sign_in.errors.wrong_certificate": "Sertifikatingiz bloklandi. Texnik yordamga murojaat qiling",
		"password_recovery.title": "Hisobni tiklash",
		"password_recovery.sent_to": "Parolni tiklash boʻyicha koʻrsatmalar <strong>{email}</strong> manziliga yuborildi",
		"password_recovery.sent_repeatedly": "Biz parolni tiklash ma'lumotlarini bir necha marta yubordik. Xavfsizlik nuqtai nazaridan yordam xizmatiga murojaat qiling.",
		"password_recovery.sms_exceeded": "Biz sizning raqamingizga ikki marta parolni tiklash xabarini yubordik. Iltimos, SMSni kuting yoki qo'llab-quvvatlash xizmatiga murojaat qiling.",
		"password_recovery.delivery_condition": "Agar besh daqiqa ichida bizdan xat olmagan bo'lsangiz, Spam jildini tekshiring.",
		"password_recovery.support": "Aks holda, onlayn chat orqali mijozlarga xizmat ko'rsatish bilan bog'laning",
		"password_recovery.registration_requisite": "Ro'yxatdan o'tish paytida foydalangan har qanday ma'lumotni belgilang. Hisob raqami, login, email yoki telefon raqami ({mask} formatida)",
		"password_recovery.requisite": "Реквизит",
		"password_recovery.recover_title": "Qayta tiklash",
		"password_recovery.sent_via_sms": "Parol <strong>{phone}</strong> raqamiga yuborildi",
		"password_recovery.support_phone": "Agar siz bir necha daqiqa ichida SMS olmagan bo'lsangiz, onlayn chat orqali mijozlarni qo'llab-quvvatlash xizmatiga murojaat qiling",
		"password_recovery.errors.invalid_credentials": "Bunday kirish ma'lumotlariga ega foydalanuvchi topilmadi",
		"password_recovery.errors.internal_error": "Ichki xato",
		"password_recovery.errors.blocked": "Juda ko'p so'rovlar. 15 daqiqadan keyin qayta urinib ko'ring",
		"footer.fairplay.copyright": "&copy; {year} Bekmeykerlik kompaniyasi «Fair Play»",
		"footer.fairplay.copyright_kz": "&copy; {year} BETtery LLP. Trade mark \"Fair Play\" License # 320 issued on 23.08.2019",
		"footer.fairplay.copyright_ringobet": "&copy; {year} «TakeBet» LLP. Trade mark \"RingoBet\" License # 34 issued on 12.07.2022",
		"join.fast_registration_title": "Tez ro'yxatdan o'tish",
		"join.registration_title": "Doimiy ro'yxatdan o'tish",
		"join.title": "Ro'yxatga olish",
		"join.login": "Kirish",
		"join.password": "Parol",
		"join.password_repeat": "Parolni qayta kiriting",
		"join.first_name": "Ism",
		"join.last_name": "Familiya",
		"join.dob": "Tug'ilgan kun",
		"join.email": "E-mail",
		"join.phone": "Mobil telefon",
		"join.city": "Shahar",
		"join.country": "Mamlakat",
		"join.currency": "Hisob valyutasi",
		"join.language": "Язык",
		"join.timezone": "Vaqt zonasi",
		"join.promo": "Kupon kodi",
		"join.have_promo": "Promo-kod bormi?",
		"join.button_join": "Hozir roʻyxatdan oʻting",
		"join.tac_agree": "Мне больше 18 лет (для жителей Казахстана +21). Я внимательно прочитал(а) <a href=\"{rulesLink}\" target=\"_blank\">Правила</a> и полностью соглашаюсь со всеми пунктами. Я также соглашаюсь на обработку моих персональных данных с использованием автоматизированных средств, описанных в <a href=\"{privacyLink}\" target=\"_blank\">политике конфиденциальности</a>.",
		"join.real_info_warning": "Diqqat! Haqiqiy ma'lumotlarni kiriting, hisobingizdan pul mablag'larini yechib olayotganda ular sizning shaxsingizni tasdiqlovchi hujjat (pasport, haydovchilik guvohnomasi) bilan tekshiriladi. Ro'yxatdan o'tgandan keyin ism va familiyani tahrirlash mumkin emas.",
		"join.link_sent_to": "Tasdiqlash havolasi {email} manziliga yuborildi",
		"join.fast.type": "Orqali ro'yxatdan o'tish",
		"join.fast.type.sms": "SMS",
		"join.fast.type.email": "E-mail",
		"join.fast.phone": "Telefon raqami",
		"join.fast.email": "E-mail",
		"join.fast.currency": "Valyuta",
		"join.fast.button_join": "Hozir roʻyxatdan oʻting",
		"join.fast.tac_agree": "Tugmani bosish orqali siz <a href={rulesLink} target='_blank'>kompaniya qoidalariga</a>, <a href={privacyLink} target='_blank'>maxfiylik siyosatiga</a> rozilik bildirasiz va qonuniy yoshga kirganligingizni tasdiqlaysiz.",
		"join.fast.tac_agree_ringo": "Tugmani bosish orqali siz <a href={rulesLink} target='_blank'>kompaniya qoidalariga</a>, <a href={privacyLink} target='_blank'>maxfiylik siyosatiga</a> rozilik bildirasiz va qonuniy yoshga kirganligingizni tasdiqlaysiz.",
		"join.fast.phone_confirm.title": "Telefon raqamini tasdiqlash",
		"join.fast.phone_confirm.confirm_button": "Tasdiqlash",
		"join.fast.phone_confirm.confirmation_code": "Tasdiqlash kodi",
		"join.fast.phone_confirm.sms_received_text": "Sizga SMS orqali kod yuborildi. Telefon raqamingizni tasdiqlash uchun undan foydalaning. Esda tutingki, SMS yuborish bir daqiqadan ko'proq vaqt olishi mumkin.",
		"join.fast.phone_confirm.sms_sent_text": "Xabar yuborildi. ",
		"join.fast.phone_confirm.sms_resendinfo_text": "Xabarni {seconds} soniyadan keyin yana yuborish mumkin bo'ladi. ",
		"join.fast.phone_confirm.call_resendinfo_text": "Tasdiqlashni yana {seconds} soniyadan soʻng soʻrash mumkin boʻladi.",
		"join.fast.phone_confirm.sms_resend_text": "Xabarni qayta yuboring",
		"join.fast.phone_confirm.call_resend_text": "Tasdiqlashni qayta so'rang",
		"join.fast.phone_confirm.sms_resend_button_text": "Yuborish",
		"join.fast.phone_confirm.call_resend_button_text": "So'rov",
		"join.fast.success.text": "Hisobingiz muvaffaqiyatli faollashtirildi!",
		"join.fast.success.recharge_text": "O‘ynashni boshlash uchun balansingizni to‘ldiring",
		"join.fast.success.btn_recharge_text": "Balansni to'ldirish",
		"join.errors.internal": "Xato. keyinroq urinib ko'ring",
		"join.errors.smsexceeded": "Мы дважды выслали на Ваш номер сообщение для подтверждения счёта. Пожалуйста, дождитесь СМС, либо укажите e-mail и мы вышлем информацию о подтверждении счёта на него.",
		"join.errors.login_taken": "Kirish allaqachon ishlatilmoqda",
		"join.errors.email_taken": "Email allaqachon ishlatilmoqda",
		"join.errors.phone_taken": "Telefon allaqachon ishlatilmoqda",
		"join.errors.phone_not_found": "Telefon raqami noto‘g‘ri",
		"join.errors.required_field": "Majburiy maydon",
		"join.errors.promo_length_error": "Максимум 4 символа",
		"join.errors.login_requirements": "Kamida 4 ta belgi, faqat lotin harflari va raqamlari",
		"join.errors.passwords_not_equal": "Parollar mos kelmayapti",
		"join.errors.email_invalid": "Elektron pochta noto'g'ri",
		"join.errors.invalid_promo": "Неверный промо-код",
		"join.errors.phone_invalid": "Telefon raqami noto'g'ri",
		"join.errors.age_incorrect": "Tug'ilgan sana noto'g'ri",
		"join.errors.age_illegal": "Yaroqsiz yosh",
		"join.errors.date_invalid": "Tug'ilgan sana noto'g'ri",
		"join.password_changed": "Parol o'zgartirildi",
		"join.fast.phone_confirm.errors.confirmation_fail": "Tasdiqlash xatosi",
		"join.fast.phone_confirm.errors.sms_exceeded": "Мы дважды выслали на Ваш номер сообщение для подтверждения счёта. Пожалуйста, дождитесь СМС, либо укажите e-mail и мы вышлем информацию о подтверждении счёта на него.",
		"join.fast.phone_confirm.errors.invalid_code": "Noto'g'ri kod",
		"phone_confirm.title": "Telefon raqamini tasdiqlash",
		"phone_confirm.phone": "Mobil telefon",
		"phone_confirm.sms_text": "На данный телефон будет выслано SMS с кодом подтверждения",
		"phone_confirm.confirm_button": "Tasdiqlash",
		"phone_confirm.denial": "Не желаю участвовать в акции, просто зарегистрируйте мне счет",
		"phone_confirm.conditions": "Для участия в акциях необходимо подтвердить номер мобильного телефона",
		"phone_confirm.confirmation_code": "Код подтверждения",
		"phone_confirm.sms_received_text": "Raqamga yuborilgan SMS-xabardagi kodni kiriting {phone}",
		"phone_confirm.success": "{phone} raqami muvaffaqiyatli tasdiqlandi!",
		"phone_confirm.start_playing": "O'yinni boshlang",
		"phone_confirm.errors.confirmation_fail": "Tasdiqlash xatosi",
		"phone_confirm.errors.phone_taken": "Telefon allaqachon ishlatilmoqda",
		"phone_confirm.phone_hint": "Xalqaro prefiksdan foydalaning",
		"special_offers.site146_proposal": "Указанный Вами промо-код позволяет принять участие в акции «Вступительный бонус – 1000 тенге!».<br /> Для начисления бонуса необходимо подтвердить номер мобильного телефона",
		"special_offers.site146_accepted": "Ваш игровой счет принимает участие в акции «Вступительный бонус – 1000 тенге!»",
		"pages.main.title": "Sportga onlayn tikish. O'zbekistondagi Fair Play bukmekerlik kompaniyasi.",
		"pages.main.description": "Круглосуточно принимаем ставки в режиме онлайн на все спортивные события с высокими коэффициентами: футбол, теннис, баскетбол, волейбол, хоккей, бокс, борьба, плавание, лыжи.",
		"pages.live.title": "Лайв ставки (Live) в спортивном интернет-тотализаторе FairPlay",
		"pages.live.description": "Широкий выбор ставок Live и удобный интерфейс сайта букмекерской конторы FairPlay способен удовлетворить потребности самого искушенного игрока.",
		"pages.sports.title": "Ставки на спорт в интернет-букмекере №1 в Казахстане — FairPlay",
		"pages.sports.description": "Сделать ставку онлайн очень просто — укажите интересующее вас спортивное событие, выберите желаемый исход и введите сумму ставки. Заключите пари прямо сейчас!",
		"pages.timetable.title": "Спортивные трансляции. Расписание предстоящих матчей.",
		"pages.timetable.description": "Список онлайн трансляций спортивных событий, для которых возможны букмекерские ставки.",
		"betpanel.unauth.how_to_bet": "Как сделать ставку?",
		"betpanel.unauth.to_configure_coupon": "Kirish yoki ro`yhatdan o`tish - ",
		"betpanel.unauth.auth_or_register": "{signTrigger} или {joinTrigger}, заполнив данные.",
		"betpanel.unauth.time_to_bet": "Pul tikish vaqti keldi!",
		"betpanel.unauth.sign_trigger": "Tizimga kirish",
		"betpanel.unauth.join_trigger": "зарегистрируйтесь",
		"betpanel.unauth.to_place_bet": "Kuponning sozlamalarini o`zgartirish uchun - ",
		"betpanel.unauth.should_auth": "kiring",
		"betpanel.unauth.should_register": "ro`yhatdan o`ting",
		"betpanel.unauth.auth_or_register_to_bet": "{signTrigger} yoki {joinTrigger}",
		"timezones.item_1": "Osiyo/Olmaota",
		"timezones.item_2": "Yevropa/Moskva",
		"create-password.modla-title": "Parol o'ylab toping",
		"create-password.profile_password_form_new_password_label": "Yangi parol",
		"create-password.profile_password_form_retype_password": "Parolni qayta kiriting",
		"create-password.profile_password_form_btn_msg": "Saqlash",
		"create-password.limit_form_error_empty_field": "Majburiy maydon",
		"create-password.password_form_error_mismatch": "Parol mos kelmasligini tasdiqlang",
		"create-password.password_changed": "Parol o'zgartirildi",
		"betgames.disclaimer1": "Ставки на BetGamesTV основаны только на предстоящих реальных событиях. Данный вид ставок не является онлайн-казино, поскольку не относится к предусмотренному Законом «Об игорном бизнесе» понятию «азартной игры».",
		"betgames.disclaimer2": "БК «Fair Play» не организовывает данный вид событий и не участвует в них, равно как и участники пари (игроки). Организатором данного вида реальных событий является компания «TV ZAIDIMAI». События транслируются в режиме реального времени и не зависят от Букмекера или участников пари (игроков). Результаты событий формируются организатором независимо от БК «Fair Play» и публикуются на его официальном сайте.",
		"games.virtual-sport": "Virtual sport",
		"games.auth-required": "Avtorizatsiya talab qilinadi",
		"games.vivo_games": "Jonli kazino - ruletka, poker, blackjack, bakkara ...",
		"games.red_rake": "Slot, bingo, poker, ruletka",
		"games.leap_gaming": "Virtual sport, ot poygasi, slotlar",
		"games.vivo_slots": "Slot mashinalari",
		"games.tv_bet": "Televizion o'yinlar - blackjack, poker, keno...",
		"games.fastsport": "Tez sport",
		"games.tv_bet_roullette": "Live Roulette",
		"games.xpress": "Slot, kazino, jonli o'yinlar",
		"games.jacktop": "Jonli poker, blackjack, bakkara",
		"games.jacktop.black_jack": "Blackjack",
		"games.jacktop.roulette": "Ruletka",
		"games.jacktop.poker": "Poker",
		"games.jacktop.baccarat": "Bakkara",
		"games.back_to_games": "O'yinlar ro'yxatiga qaytish",
		"games.back_to_slots": "Slot o'yinlari ro'yxatiga qaytish",
		"games.new": "Yangilik",
		"games.more": "Yana 20 ta o'yin",
		"games.all_slots": "Barcha o'yinlar",
		"games.gamesSlots": "O'yin o'yin mashinalari",
		"games.sport_vfl": "Футбольная лига",
		"games.sport_vfcc": "Футбол Кубок чемпионов",
		"games.sport_vfwc": "Футбол Чемпионат Мира",
		"games.sport_vfc": "Футбол Еврокубок 2020",
		"games.sport_vfac": "Футбол Кубок Азии",
		"games.sport_vbl": "Баскетбольная лига",
		"game.search": "qidiruv",
		"games.featured": "Tanlangan o'yinlar",
		"games.name_of_games": "O'yin nomi",
		"games.all": "Barcha",
		"verify_form.title": "Rasmni yuklang yoki olib kelish. Hujjat butun kadrga sig'magan bo'lishi kerak, ma'lumot oqish mumkin bo'lishi kerak.",
		"verify_form.available_files": "Ruxsat berilgan fayllar: image/jpeg, image/png.",
		"verify_form.max_file_size": "Hajmi 20.00 MB dan ko'p bo'lmasin.",
		"verify_form.document_front_side": "Hujjatning old tomoni",
		"verify_form.document_back_side": "Hujjatning orqa tomoni",
		"verify_form.selfie_with_document": "Selfi s hujjat bilan",
		"verify_form.submit": "Yuborish",
		"promocode.error.not_found": "Promokod topilmadi",
		"promocode.error.not_active": "Promokod faol emas",
		"promocode.error.used": "Promokod allaqachon ishlatilgan",
		"promocode.error.not_available": "Promokodni ishlatishga ruxsat yo'q",
		"promocode.title": "Promokodni ishlatish",
		"promocode.tab": "Promo kodlari",
		"promocode.enter": "Promokodni kiriting",
		"promocode.apply": "Ishlatish",
		"page.general_keywords_KZ": "букмекерская контора официальный сайт ставка на спорт ставки ставки на спорт онлайн букмекерская контора букмекер ставки букмекерские ставки онлайн сайт ставки ставки онлайн казахстан ставки букмекерская контора ставки кз букмекерская контора онлайн букмекерская контора сайт бк ставки на спорт онлайн онлайн букмекер букмекерская контора сделать ставку онлайн букмекерская контора букмекерская контора он лайн бк ставки на спорт букмекерская контора ставки онлайн букмекерские ставки на спорт онлайн ставки на спорт официальный сайт ставки на спорт бк ставкина спорт букмекерская контора онлайн букмекер кз интернет ставки на спорт контора букмекерская поставить ставку онлайн ставки онлайн кз букмекерская контора ставки спортивный букмекер онлайн ставки букмекерская контора казахстан букмекерские конторы казахстана онлайн официальный букмекер казахстан ставки на спорт ставки онлайн ставки online ставки онлайн на спорт ставка онлайн ставки спортивные букмекерская контора в казахстане ставки на спорт в казахстане букмекерская контора онлайн ставки на спорт бк в казахстане",
		"page.general_description_KZ": "Онлайн ставки на спорт в Казахстане ➤ Официальный сайт легальной букмекерской конторы {companyName} кз 💰 Делайте ставки онлайн в прематч и live ☝ Бонусы 💲 Привлекательные Коэффициенты ",
		"page.general_page_title_KZ": "Ставки на спорт онлайн - Букмекерская контора {companyName} в Казахстане",
		"page.general_keywords_KG": "букмекерская контора официальный сайт ставка на спорт ставки ставки на спорт онлайн букмекерская контора букмекер ставки букмекерские ставки онлайн сайт ставки ставки онлайн Кыргызстан ставки букмекерская контора ставки кг букмекерская контора онлайн букмекерская контора сайт бк ставки на спорт онлайн онлайн букмекер букмекерская контора сделать ставку онлайн букмекерская контора букмекерская контора он лайн бк ставки на спорт букмекерская контора ставки онлайн букмекерские ставки на спорт онлайн ставки на спорт официальный сайт ставки на спорт бк ставкина спорт букмекерская контора онлайн букмекер кг интернет ставки на спорт контора букмекерская поставить ставку онлайн ставки онлайн кг букмекерская контора ставки спортивный букмекер онлайн ставки букмекерская контора Кыргызстан букмекерские конторы Кыргызстана онлайн официальный букмекер Кыргызстан ставки на спорт ставки онлайн ставки online ставки онлайн на спорт ставка онлайн ставки спортивные букмекерская контора в Кыргызстане ставки на спорт в Кыргызстане букмекерская контора онлайн ставки на спорт бк в Кыргызстане",
		"page.general_description_KG": "Онлайн ставки на спорт в Кыргызстане ➤ Официальный сайт легальной букмекерской конторы {companyName} кг 💰 Делайте ставки онлайн в прематч и live ☝ Бонусы 💲 Привлекательные Коэффициенты",
		"page.general_page_title_KG": "Ставки на спорт онлайн - Букмекерская контора {companyName} в Кыргызстане",
		"page.general_page_title_UZ": "Ставки на спорт онлайн - Букмекерская контора {companyName} в Узбекистане",
		"page.general_description_UZ": "Онлайн ставки на спорт в Узбекистане ➤ Официальный сайт легальной букмекерской конторы {companyName} уз 💰 Делайте ставки онлайн в прематч и live ☝ Бонусы 💲 Привлекательные Коэффициенты ",
		"page.general_keywords_UZ": "букмекерская контора официальный сайт ставка на спорт ставки ставки на спорт онлайн букмекерская контора букмекер ставки букмекерские ставки онлайн сайт ставки ставки онлайн Узбекистан ставки букмекерская контора ставки уз букмекерская контора онлайн букмекерская контора сайт бк ставки на спорт онлайн онлайн букмекер букмекерская контора сделать ставку онлайн букмекерская контора букмекерская контора он лайн бк ставки на спорт букмекерская контора ставки онлайн букмекерские ставки на спорт онлайн ставки на спорт официальный сайт ставки на спорт бк ставкина спорт букмекерская контора онлайн букмекер уз интернет ставки на спорт контора букмекерская поставить ставку онлайн ставки онлайн уз букмекерская контора ставки спортивный букмекер онлайн ставки букмекерская контора Узбекистан букмекерские конторы Узбекистана онлайн официальный букмекер Узбекистан ставки на спорт ставки онлайн ставки online ставки онлайн на спорт ставка онлайн ставки спортивные букмекерская контора в Узбекистане ставки на спорт в Узбекистане букмекерская контора онлайн ставки на спорт бк в Узбекистане",
		"page.live_page_title_KZ": "Лайв ставки на спорт в букмекерской конторе {companyName}",
		"page.live_page_description_KZ": "Сделать лайв-ставки по ходу матча 👉 Ставки на спорт в режиме live на официальной сайте бк РингоБет в Казахстане",
		"page.live_page_keywords_KZ": "live ставки лайв ставки ставки лайв ставки live ставки лайф ставки на лайв лайв ставка live ставка live ставки на спорт ставки лайв на спорт ставки на спорт лайф ставки на сегодня",
		"page.live_page_title_KG": "Лайв ставки на спорт в букмекерской конторе {companyName}",
		"page.live_page_description_KG": "Сделать лайв-ставки по ходу матча 👉 Ставки на спорт в режиме live на официальной сайте бк Фэйрплей в Кыргызстане",
		"page.live_page_keywords_KG": "live ставки лайв ставки ставки лайв ставки live ставки лайф ставки на лайв лайв ставка live ставка live ставки на спорт ставки лайв на спорт ставки на спорт лайф ставки на сегодня",
		"page.live_page_title_UZ": "Лайв ставки на спорт в букмекерской конторе {companyName}",
		"page.live_page_description_UZ": "Сделать лайв-ставки по ходу матча 👉 Ставки на спорт в режиме live на официальной сайте бк Фэйрплей в Узбекистане",
		"page.live_page_keywords_UZ": "live ставки лайв ставки ставки лайв ставки live ставки лайф ставки на лайв лайв ставка live ставка live ставки на спорт ставки лайв на спорт ставки на спорт лайф ставки на сегодня",
		"page.sports_2_title_KZ": "Ставки на настольный теннис онлайн сегодня 👉 бк {companyName} в Казахстане",
		"page.sports_2_description_KZ": "Ставки на настольный теннис онлайн 🏈 Пинг-понг сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на настольный теннис 👉 на официальной сайте бк РингоБет в Казахстане",
		"page.sports_2_keywords_KZ": "настольный теннис лайв результаты ставки на настольный теннис настольный теннис лайв ставки ставки на настольный теннис в лайве настольный теннис ставки ставки настольный теннис ставки на настольный теннис лайв пингпонг ставки ставки на ping pong ставки на пинг понг пинг понг ставки",
		"page.sports_4_title_KZ": "Волейбол лайф - Live ставки на волейбол онлайн сегодня 👉 бк {companyName} в Казахстане",
		"page.sports_4_description_KZ": "Live ставки на волейбол онлайн 🏐 Волейбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Волейбол Live 👉 на официальной сайте бк РингоБет в Казахстане",
		"page.sports_4_keywords_KZ": "ставки на волейбол онлайн волейбол лайв волейбол live live волейбол ставки на волейбол в лайве",
		"page.sports_5_title_KZ": "Ставки на бокс - Ставки на бокс онлайн сегодня 👉 бк {companyName} в Казахстане",
		"page.sports_5_description_KZ": "Ставки на бокс онлайн 🥊 Боксерские бои сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на бокс 👉 на официальной сайте бк РингоБет в Казахстане",
		"page.sports_5_keywords_KZ": "ставки на бокс бокс ставка ставки бокс бокс ставки ставки на бокс на сегодня ставки на бои бокс букмекерские ставки на бокс букмекерская контора ставки на бокс поставить ставку на бокс коэффициенты на бокс ставки на бокс сегодня ставки на спорт бокс сделать ставку на бокс сегодня сделать ставку на бокс сделать ставку на бокс онлайн",
		"page.sports_6_title_KZ": "Теннис лайв - Live ставки на теннис онлайн сегодня 👉 бк {companyName} в Казахстане",
		"page.sports_6_description_KZ": "Live ставки на теннис онлайн 🎾 Теннисные матчи сегодня 💰 Высокие коэффициенты ⭐ Теннис Live 👉 на официальной сайте бк РингоБет в Казахстане",
		"page.sports_6_keywords_KZ": "live ставки на теннис ставки на теннис онлайн ставки теннис лайв теннис лайв ставки лайв ставки на теннис лайв ставки теннис ставки на теннис лайв лайв теннис ставки на теннис в лайве прогнозы на теннис live теннис лайв счет теннис онлайн теннис лайв прогнозы",
		"page.sports_7_title_KZ": "Футбол лайф - Live ставки на футбол онлайн сегодня 👉 бк {companyName} в Казахстане",
		"page.sports_7_description_KZ": "Live ставки на футбол онлайн ⚽ Футбольные матчи сегодня 👍 Ставки по ходу футбольного матча ⭐ Футбол Live 👉 на официальной сайте бк РингоБет в Казахстане",
		"page.sports_7_keywords_KZ": "live ставки футбол live ставки на футбол футбол лайв ставки лайв футболы футбол лай лив футбол ставки в лайве на футбол лайф футбол футбол лайф футбол лайф сегодня ливе футбол футбол life лайв футбол онлайн live футбол live футбол онлайн футбол в лайве футбольный live лайв спорт футбол live sport футбол ливе спорт футбол футбол лайв футбол ставки на сегодня",
		"page.sports_11_title_KZ": "Ставки на американский футбол онлайн сегодня 👉 бк {companyName} в Казахстане",
		"page.sports_11_description_KZ": "Ставки на американский футбол онлайн 🏈 Матчи американского футбола сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на американский футбол 👉 на официальной сайте бк РингоБет в Казахстане",
		"page.sports_11_keywords_KZ": "американский футбол ставки ставки на американский футбол американский футбол сегодня ставки на американский футбол онлайн ставки на американский футбол на сегодня ставки на спорт американский футбол",
		"page.sports_19_title_KZ": "Гандбол лайф - Live ставки на гандбол онлайн сегодня 👉 бк {companyName} в Казахстане",
		"page.sports_19_description_KZ": "Live ставки на гандбол онлайн 🤾 Гандбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Гандбол Live 👉 на официальной сайте бк РингоБет в Казахстане",
		"page.sports_19_keywords_KZ": "ставки на гандбол лайв гандбол онлайн",
		"page.sports_30_title_KZ": "Хоккей лайф - Live ставки на хоккей онлайн сегодня 👉 бк {companyName} в Казахстане",
		"page.sports_30_description_KZ": "Live ставки на хоккей онлайн 🏒 Хоккейные матчи сегодня 💰 Высокие коэффициенты ⭐ Хоккей Live 👉 на официальной сайте бк РингоБет в Казахстане",
		"page.sports_30_keywords_KZ": "хоккей лайв ставки ставки лайв хоккей ставки на хоккей онлайн хоккей лайф хоккей ливе лайв хоккей лайф хоккей хоккей live хоккей лайв ставки хоккей хоккей ставки",
		"page.sports_31_title_KZ": "Баскетбол лайв - Live ставки на баскетбол онлайн сегодня 👉 бк {companyName} в Казахстане",
		"page.sports_31_description_KZ": "Live ставки на баскетбол онлайн 🏀 Баскетбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Баскетбол Live 👉 на официальном сайте бк РингоБет в Казахстане",
		"page.sports_31_keywords_KZ": "баскетбол лайв ставки лайф баскетбол баскетбол ливе баскетбол live ставки на баскетбол в лайве спорт лайф баскетбол",
		"page.sports_38_title_KZ": "Ставки на киберспорт live онлайн сегодня 👉 бк {companyName} в Казахстане",
		"page.sports_38_description_KZ": "Live ставки на киберспорт онлайн 🎮 Киберспорт лайв 💰 Высокие коэффициенты 👉 на официальной сайте бк РингоБет в Казахстане",
		"page.sports_38_keywords_KZ": "лайв ставки на киберспорт лайв ставки киберспорт live ставки на киберспорт ставки киберспорт ставки на киберспор",
		"page.sports_39_title_KZ": "Ставки на UFC - Ставки на ММА онлайн сегодня 👉 бк {companyName} в Казахстане",
		"page.sports_39_description_KZ": "Ставки на смешанные единоборства (MMA и UFC) онлайн 👊 ЮФС бои сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на бой ММА 👉 на официальной сайте бк РингоБет в Казахстане",
		"page.sports_39_keywords_KZ": "ставки на бои ставки на бой ставки на ufc ставки на юфс ufc ставки ставка на юфс ставка на бой ставка на ufc ставки юфс ставки на ufc в казахстане коэффициент ufc юфс ставки ставки на спорт ufc коэффициенты на бои ufc ставки на бои юфс поставить ставку ufc поставить ставку на бой сделать ставку на ufc ставка ufc сделать ставку на бой ставки на ufc онлайн ставки на бои без правил ufc ставки на бои мма коэффициенты на юфс ставки на мма ставки на спорт юфс ставки на мма бои коэффициент на бой ставки на бойцов ufc ставки ufc сделать ставку ufc ставки на бои ufc ufc коэффициенты ставки ufc коэффициенты ставки на мма сегодня поставить ставку на ufc ставки на спорт бои сделать ставку на мма ставки на спорт мма ставки на мма онлайн",
		"page.sports_2_title_KG": "Ставки на настольный теннис онлайн сегодня 👉 бк {companyName} в Кыргызстане",
		"page.sports_2_description_KG": "Ставки на настольный теннис онлайн 🏈 Пинг-понг сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на настольный теннис 👉 на официальной сайте бк Фэйрплей в Кыргызстане",
		"page.sports_2_keywords_KG": "настольный теннис лайв результаты ставки на настольный теннис настольный теннис лайв ставки ставки на настольный теннис в лайве настольный теннис ставки ставки настольный теннис ставки на настольный теннис лайв пингпонг ставки ставки на ping pong ставки на пинг понг пинг понг ставки",
		"page.sports_4_title_KG": "Волейбол лайф - Live ставки на волейбол онлайн сегодня 👉 бк {companyName} в Кыргызстане",
		"page.sports_4_description_KG": "Live ставки на волейбол онлайн 🏐 Волейбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Волейбол Live 👉 на официальной сайте бк Фэйрплей в Кыргызстане",
		"page.sports_4_keywords_KG": "ставки на волейбол онлайн волейбол лайв волейбол live live волейбол ставки на волейбол в лайве",
		"page.sports_5_title_KG": "Ставки на бокс - Ставки на бокс онлайн сегодня 👉 бк {companyName} в Кыргызстане",
		"page.sports_5_description_KG": "Ставки на бокс онлайн 🥊 Боксерские бои сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на бокс 👉 на официальной сайте бк Фэйрплей в Кыргызстане",
		"page.sports_5_keywords_KG": "ставки на бокс бокс ставка ставки бокс бокс ставки ставки на бокс на сегодня ставки на бои бокс букмекерские ставки на бокс букмекерская контора ставки на бокс поставить ставку на бокс коэффициенты на бокс ставки на бокс сегодня ставки на спорт бокс сделать ставку на бокс сегодня сделать ставку на бокс сделать ставку на бокс онлайн",
		"page.sports_6_title_KG": "Теннис лайв - Live ставки на теннис онлайн сегодня 👉 бк {companyName} в Кыргызстане",
		"page.sports_6_description_KG": "Live ставки на теннис онлайн 🎾 Теннисные матчи сегодня 💰 Высокие коэффициенты ⭐ Теннис Live 👉 на официальной сайте бк Фэйрплей в Кыргызстане",
		"page.sports_6_keywords_KG": "live ставки на теннис ставки на теннис онлайн ставки теннис лайв теннис лайв ставки лайв ставки на теннис лайв ставки теннис ставки на теннис лайв лайв теннис ставки на теннис в лайве прогнозы на теннис live теннис лайв счет теннис онлайн теннис лайв прогнозы",
		"page.sports_7_title_KG": "Футбол лайф - Live ставки на футбол онлайн сегодня 👉 бк {companyName} в Кыргызстане",
		"page.sports_7_description_KG": "Live ставки на футбол онлайн ⚽ Футбольные матчи сегодня 👍 Ставки по ходу футбольного матча ⭐ Футбол Live 👉 на официальной сайте бк Фэйрплей в Кыргызстане",
		"page.sports_7_keywords_KG": "live ставки футбол live ставки на футбол футбол лайв ставки лайв футболы футбол лай лив футбол ставки в лайве на футбол лайф футбол футбол лайф футбол лайф сегодня ливе футбол футбол life лайв футбол онлайн live футбол live футбол онлайн футбол в лайве футбольный live лайв спорт футбол live sport футбол ливе спорт футбол футбол лайв футбол ставки на сегодня",
		"page.sports_11_title_KG": "Ставки на американский футбол онлайн сегодня 👉 бк {companyName} в Кыргызстане",
		"page.sports_11_description_KG": "Ставки на американский футбол онлайн 🏈 Матчи американского футбола сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на американский футбол 👉 на официальной сайте бк Фэйрплей в Кыргызстане",
		"page.sports_11_keywords_KG": "американский футбол ставки ставки на американский футбол американский футбол сегодня ставки на американский футбол онлайн ставки на американский футбол на сегодня ставки на спорт американский футбол",
		"page.sports_19_title_KG": "Гандбол лайф - Live ставки на гандбол онлайн сегодня 👉 бк {companyName} в Кыргызстане",
		"page.sports_19_description_KG": "Live ставки на гандбол онлайн 🤾 Гандбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Гандбол Live 👉 на официальной сайте бк Фэйрплей в Кыргызстане",
		"page.sports_19_keywords_KG": "ставки на гандбол лайв гандбол онлайн",
		"page.sports_30_title_KG": "Хоккей лайф - Live ставки на хоккей онлайн сегодня 👉 бк {companyName} в Кыргызстане",
		"page.sports_30_description_KG": "Live ставки на хоккей онлайн 🏒 Хоккейные матчи сегодня 💰 Высокие коэффициенты ⭐ Хоккей Live 👉 на официальной сайте бк Фэйрплей в Кыргызстане",
		"page.sports_30_keywords_KG": "хоккей лайв ставки ставки лайв хоккей ставки на хоккей онлайн хоккей лайф хоккей ливе лайв хоккей лайф хоккей хоккей live хоккей лайв ставки хоккей хоккей ставки",
		"page.sports_31_title_KG": "Баскетбол лайв - Live ставки на баскетбол онлайн сегодня 👉 бк {companyName} в Кыргызстане",
		"page.sports_31_description_KG": "Live ставки на баскетбол онлайн 🏀 Баскетбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Баскетбол Live 👉 на официальной сайте бк Фэйрплей в Кыргызстане",
		"page.sports_31_keywords_KG": "баскетбол лайв ставки лайф баскетбол баскетбол ливе баскетбол live ставки на баскетбол в лайве спорт лайф баскетбол",
		"page.sports_38_title_KG": "Ставки на киберспорт live онлайн сегодня 👉 бк {companyName} в Кыргызстане",
		"page.sports_38_description_KG": "Live ставки на киберспорт онлайн 🎮 Киберспорт лайв 💰 Высокие коэффициенты 👉 на официальной сайте бк Фэйрплей в Кыргызстане",
		"page.sports_38_keywords_KG": "лайв ставки на киберспорт лайв ставки киберспорт live ставки на киберспорт ставки киберспорт ставки на киберспор",
		"page.sports_39_title_KG": "Ставки на UFC - Ставки на ММА онлайн сегодня 👉 бк {companyName} в Кыргызстане",
		"page.sports_39_description_KG": "Ставки на смешанные единоборства (MMA и UFC) онлайн 👊 ЮФС бои сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на бой ММА 👉 на официальной сайте бк Фэйрплей в Кыргызстане",
		"page.sports_39_keywords_KG": "ставки на бои ставки на бой ставки на ufc ставки на юфс ufc ставки ставка на юфс ставка на бой ставка на ufc ставки юфс ставки на ufc в Кыргызстане коэффициент ufc юфс ставки ставки на спорт ufc коэффициенты на бои ufc ставки на бои юфс поставить ставку ufc поставить ставку на бой сделать ставку на ufc ставка ufc сделать ставку на бой ставки на ufc онлайн ставки на бои без правил ufc ставки на бои мма коэффициенты на юфс ставки на мма ставки на спорт юфс ставки на мма бои коэффициент на бой ставки на бойцов ufc ставки ufc сделать ставку ufc ставки на бои ufc ufc коэффициенты ставки ufc коэффициенты ставки на мма сегодня поставить ставку на ufc ставки на спорт бои сделать ставку на мма ставки на спорт мма ставки на мма онлайн",
		"page.sports_2_title_UZ": "Ставки на настольный теннис онлайн сегодня 👉 бк {companyName} в Узбекистане",
		"page.sports_2_description_UZ": "Ставки на настольный теннис онлайн 🏈 Пинг-понг сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на настольный теннис 👉 на официальной сайте бк Фэйрплей в Узбекистане",
		"page.sports_2_keywords_UZ": "настольный теннис лайв результаты ставки на настольный теннис настольный теннис лайв ставки ставки на настольный теннис в лайве настольный теннис ставки ставки настольный теннис ставки на настольный теннис лайв пингпонг ставки ставки на ping pong ставки на пинг понг пинг понг ставки",
		"page.sports_4_title_UZ": "Волейбол лайф - Live ставки на волейбол онлайн сегодня 👉 бк {companyName} в Узбекистане",
		"page.sports_4_description_UZ": "Live ставки на волейбол онлайн 🏐 Волейбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Волейбол Live 👉 на официальной сайте бк Фэйрплей в Узбекистане",
		"page.sports_4_keywords_UZ": "ставки на волейбол онлайн волейбол лайв волейбол live live волейбол ставки на волейбол в лайве",
		"page.sports_5_title_UZ": "Ставки на бокс - Ставки на бокс онлайн сегодня 👉 бк {companyName} в Узбекистане",
		"page.sports_5_description_UZ": "Ставки на бокс онлайн 🥊 Боксерские бои сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на бокс 👉 на официальной сайте бк Фэйрплей в Узбекистане",
		"page.sports_5_keywords_UZ": "ставки на бокс бокс ставка ставки бокс бокс ставки ставки на бокс на сегодня ставки на бои бокс букмекерские ставки на бокс букмекерская контора ставки на бокс поставить ставку на бокс коэффициенты на бокс ставки на бокс сегодня ставки на спорт бокс сделать ставку на бокс сегодня сделать ставку на бокс сделать ставку на бокс онлайн",
		"page.sports_6_title_UZ": "Теннис лайв - Live ставки на теннис онлайн сегодня 👉 бк {companyName} в Узбекистане",
		"page.sports_6_description_UZ": "Live ставки на теннис онлайн 🎾 Теннисные матчи сегодня 💰 Высокие коэффициенты ⭐ Теннис Live 👉 на официальной сайте бк Фэйрплей в Узбекистане",
		"page.sports_6_keywords_UZ": "live ставки на теннис ставки на теннис онлайн ставки теннис лайв теннис лайв ставки лайв ставки на теннис лайв ставки теннис ставки на теннис лайв лайв теннис ставки на теннис в лайве прогнозы на теннис live теннис лайв счет теннис онлайн теннис лайв прогнозы",
		"page.sports_7_title_UZ": "Футбол лайф - Live ставки на футбол онлайн сегодня 👉 бк {companyName} в Узбекистане",
		"page.sports_7_description_UZ": "Live ставки на футбол онлайн ⚽ Футбольные матчи сегодня 👍 Ставки по ходу футбольного матча ⭐ Футбол Live 👉 на официальной сайте бк Фэйрплей в Узбекистане",
		"page.sports_7_keywords_UZ": "live ставки футбол live ставки на футбол футбол лайв ставки лайв футболы футбол лай лив футбол ставки в лайве на футбол лайф футбол футбол лайф футбол лайф сегодня ливе футбол футбол life лайв футбол онлайн live футбол live футбол онлайн футбол в лайве футбольный live лайв спорт футбол live sport футбол ливе спорт футбол футбол лайв футбол ставки на сегодня",
		"page.sports_11_title_UZ": "Ставки на американский футбол онлайн сегодня 👉 бк {companyName} в Узбекистане",
		"page.sports_11_description_UZ": "Ставки на американский футбол онлайн 🏈 Матчи американского футбола сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на американский футбол 👉 на официальной сайте бк Фэйрплей в Узбекистане",
		"page.sports_11_keywords_UZ": "американский футбол ставки ставки на американский футбол американский футбол сегодня ставки на американский футбол онлайн ставки на американский футбол на сегодня ставки на спорт американский футбол",
		"page.sports_19_title_UZ": "Гандбол лайф - Live ставки на гандбол онлайн сегодня 👉 бк {companyName} в Узбекистане",
		"page.sports_19_description_UZ": "Live ставки на гандбол онлайн 🤾 Гандбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Гандбол Live 👉 на официальной сайте бк Фэйрплей в Узбекистане",
		"page.sports_19_keywords_UZ": "ставки на гандбол лайв гандбол онлайн",
		"page.sports_30_title_UZ": "Хоккей лайф - Live ставки на хоккей онлайн сегодня 👉 бк {companyName} в Узбекистане",
		"page.sports_30_description_UZ": "Live ставки на хоккей онлайн 🏒 Хоккейные матчи сегодня 💰 Высокие коэффициенты ⭐ Хоккей Live 👉 на официальной сайте бк Фэйрплей в Узбекистане",
		"page.sports_30_keywords_UZ": "хоккей лайв ставки ставки лайв хоккей ставки на хоккей онлайн хоккей лайф хоккей ливе лайв хоккей лайф хоккей хоккей live хоккей лайв ставки хоккей хоккей ставки",
		"page.sports_31_title_UZ": "Баскетбол лайв - Live ставки на баскетбол онлайн сегодня 👉 бк {companyName} в Узбекистане",
		"page.sports_31_description_UZ": "Live ставки на баскетбол онлайн 🏀 Баскетбольные матчи сегодня 💰 Высокие коэффициенты ⭐ Баскетбол Live 👉 на официальной сайте бк Фэйрплей в Узбекистане",
		"page.sports_31_keywords_UZ": "баскетбол лайв ставки лайф баскетбол баскетбол ливе баскетбол live ставки на баскетбол в лайве спорт лайф баскетбол",
		"page.sports_38_title_UZ": "Ставки на киберспорт live онлайн сегодня 👉 бк {companyName} в Узбекистане",
		"page.sports_38_description_UZ": "Live ставки на киберспорт онлайн 🎮 Киберспорт лайв 💰 Высокие коэффициенты 👉 на официальной сайте бк Фэйрплей в Узбекистане",
		"page.sports_38_keywords_UZ": "лайв ставки на киберспорт лайв ставки киберспорт live ставки на киберспорт ставки киберспорт ставки на киберспор",
		"page.sports_39_title_UZ": "Ставки на UFC - Ставки на ММА онлайн сегодня 👉 бк {companyName} в Узбекистане",
		"page.sports_39_description_UZ": "Ставки на смешанные единоборства (MMA и UFC) онлайн 👊 ЮФС бои сегодня 💰 Высокие коэффициенты ⭐ Сделать ставку на бой ММА 👉 на официальной сайте бк Фэйрплей в Узбекистане",
		"page.sports_39_keywords_UZ": "ставки на бои ставки на бой ставки на ufc ставки на юфс ufc ставки ставка на юфс ставка на бой ставка на ufc ставки юфс ставки на ufc в Узбекистане коэффициент ufc юфс ставки ставки на спорт ufc коэффициенты на бои ufc ставки на бои юфс поставить ставку ufc поставить ставку на бой сделать ставку на ufc ставка ufc сделать ставку на бой ставки на ufc онлайн ставки на бои без правил ufc ставки на бои мма коэффициенты на юфс ставки на мма ставки на спорт юфс ставки на мма бои коэффициент на бой ставки на бойцов ufc ставки ufc сделать ставку ufc ставки на бои ufc ufc коэффициенты ставки ufc коэффициенты ставки на мма сегодня поставить ставку на ufc ставки на спорт бои сделать ставку на мма ставки на спорт мма ставки на мма онлайн",
		"instagram.banner.iphone_title": "ГЛАВНЫЙ ПРИЗ",
		"instagram.banner.freebet_text": "РОЗЫГРЫШ ФРИБЕТОВ",
		"instagram.banner.center_text": "Акция в инстаграм",
		"newGames.showAllGames": "Посмотреть все игры"
	};

/***/ },
/* 1834 */
/***/ function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(2004);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ },
/* 1835 */
/***/ function(module, exports) {

	
	module.exports = function load (src, opts, cb) {
	  var head = document.head || document.getElementsByTagName('head')[0]
	  var script = document.createElement('script')
	
	  if (typeof opts === 'function') {
	    cb = opts
	    opts = {}
	  }
	
	  opts = opts || {}
	  cb = cb || function() {}
	
	  script.type = opts.type || 'text/javascript'
	  script.charset = opts.charset || 'utf8';
	  script.async = 'async' in opts ? !!opts.async : true
	  script.src = src
	
	  if (opts.attrs) {
	    setAttributes(script, opts.attrs)
	  }
	
	  if (opts.text) {
	    script.text = '' + opts.text
	  }
	
	  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
	  onend(script, cb)
	
	  // some good legacy browsers (firefox) fail the 'in' detection above
	  // so as a fallback we always set onload
	  // old IE will ignore this and new IE will set onload
	  if (!script.onload) {
	    stdOnEnd(script, cb);
	  }
	
	  head.appendChild(script)
	}
	
	function setAttributes(script, attrs) {
	  for (var attr in attrs) {
	    script.setAttribute(attr, attrs[attr]);
	  }
	}
	
	function stdOnEnd (script, cb) {
	  script.onload = function () {
	    this.onerror = this.onload = null
	    cb(null, script)
	  }
	  script.onerror = function () {
	    // this.onload = null here is necessary
	    // because even IE9 works not like others
	    this.onerror = this.onload = null
	    cb(new Error('Failed to load ' + this.src), script)
	  }
	}
	
	function ieOnEnd (script, cb) {
	  script.onreadystatechange = function () {
	    if (this.readyState != 'complete' && this.readyState != 'loaded') return
	    this.onreadystatechange = null
	    cb(null, script) // there is no way to catch loading errors in IE8
	  }
	}


/***/ },
/* 1836 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */
/***/ function(module, exports) {

	/*!
	 * perfect-scrollbar v1.5.3
	 * Copyright 2021 Hyunje Jun, MDBootstrap and Contributors
	 * Licensed under MIT
	 */
	
	'use strict';
	
	function get(element) {
	  return getComputedStyle(element);
	}
	
	function set(element, obj) {
	  for (var key in obj) {
	    var val = obj[key];
	    if (typeof val === 'number') {
	      val = val + "px";
	    }
	    element.style[key] = val;
	  }
	  return element;
	}
	
	function div(className) {
	  var div = document.createElement('div');
	  div.className = className;
	  return div;
	}
	
	var elMatches =
	  typeof Element !== 'undefined' &&
	  (Element.prototype.matches ||
	    Element.prototype.webkitMatchesSelector ||
	    Element.prototype.mozMatchesSelector ||
	    Element.prototype.msMatchesSelector);
	
	function matches(element, query) {
	  if (!elMatches) {
	    throw new Error('No element matching method supported');
	  }
	
	  return elMatches.call(element, query);
	}
	
	function remove(element) {
	  if (element.remove) {
	    element.remove();
	  } else {
	    if (element.parentNode) {
	      element.parentNode.removeChild(element);
	    }
	  }
	}
	
	function queryChildren(element, selector) {
	  return Array.prototype.filter.call(element.children, function (child) { return matches(child, selector); }
	  );
	}
	
	var cls = {
	  main: 'ps',
	  rtl: 'ps__rtl',
	  element: {
	    thumb: function (x) { return ("ps__thumb-" + x); },
	    rail: function (x) { return ("ps__rail-" + x); },
	    consuming: 'ps__child--consume',
	  },
	  state: {
	    focus: 'ps--focus',
	    clicking: 'ps--clicking',
	    active: function (x) { return ("ps--active-" + x); },
	    scrolling: function (x) { return ("ps--scrolling-" + x); },
	  },
	};
	
	/*
	 * Helper methods
	 */
	var scrollingClassTimeout = { x: null, y: null };
	
	function addScrollingClass(i, x) {
	  var classList = i.element.classList;
	  var className = cls.state.scrolling(x);
	
	  if (classList.contains(className)) {
	    clearTimeout(scrollingClassTimeout[x]);
	  } else {
	    classList.add(className);
	  }
	}
	
	function removeScrollingClass(i, x) {
	  scrollingClassTimeout[x] = setTimeout(
	    function () { return i.isAlive && i.element.classList.remove(cls.state.scrolling(x)); },
	    i.settings.scrollingThreshold
	  );
	}
	
	function setScrollingClassInstantly(i, x) {
	  addScrollingClass(i, x);
	  removeScrollingClass(i, x);
	}
	
	var EventElement = function EventElement(element) {
	  this.element = element;
	  this.handlers = {};
	};
	
	var prototypeAccessors = { isEmpty: { configurable: true } };
	
	EventElement.prototype.bind = function bind (eventName, handler) {
	  if (typeof this.handlers[eventName] === 'undefined') {
	    this.handlers[eventName] = [];
	  }
	  this.handlers[eventName].push(handler);
	  this.element.addEventListener(eventName, handler, false);
	};
	
	EventElement.prototype.unbind = function unbind (eventName, target) {
	    var this$1 = this;
	
	  this.handlers[eventName] = this.handlers[eventName].filter(function (handler) {
	    if (target && handler !== target) {
	      return true;
	    }
	    this$1.element.removeEventListener(eventName, handler, false);
	    return false;
	  });
	};
	
	EventElement.prototype.unbindAll = function unbindAll () {
	  for (var name in this.handlers) {
	    this.unbind(name);
	  }
	};
	
	prototypeAccessors.isEmpty.get = function () {
	    var this$1 = this;
	
	  return Object.keys(this.handlers).every(
	    function (key) { return this$1.handlers[key].length === 0; }
	  );
	};
	
	Object.defineProperties( EventElement.prototype, prototypeAccessors );
	
	var EventManager = function EventManager() {
	  this.eventElements = [];
	};
	
	EventManager.prototype.eventElement = function eventElement (element) {
	  var ee = this.eventElements.filter(function (ee) { return ee.element === element; })[0];
	  if (!ee) {
	    ee = new EventElement(element);
	    this.eventElements.push(ee);
	  }
	  return ee;
	};
	
	EventManager.prototype.bind = function bind (element, eventName, handler) {
	  this.eventElement(element).bind(eventName, handler);
	};
	
	EventManager.prototype.unbind = function unbind (element, eventName, handler) {
	  var ee = this.eventElement(element);
	  ee.unbind(eventName, handler);
	
	  if (ee.isEmpty) {
	    // remove
	    this.eventElements.splice(this.eventElements.indexOf(ee), 1);
	  }
	};
	
	EventManager.prototype.unbindAll = function unbindAll () {
	  this.eventElements.forEach(function (e) { return e.unbindAll(); });
	  this.eventElements = [];
	};
	
	EventManager.prototype.once = function once (element, eventName, handler) {
	  var ee = this.eventElement(element);
	  var onceHandler = function (evt) {
	    ee.unbind(eventName, onceHandler);
	    handler(evt);
	  };
	  ee.bind(eventName, onceHandler);
	};
	
	function createEvent(name) {
	  if (typeof window.CustomEvent === 'function') {
	    return new CustomEvent(name);
	  } else {
	    var evt = document.createEvent('CustomEvent');
	    evt.initCustomEvent(name, false, false, undefined);
	    return evt;
	  }
	}
	
	function processScrollDiff(
	  i,
	  axis,
	  diff,
	  useScrollingClass,
	  forceFireReachEvent
	) {
	  if ( useScrollingClass === void 0 ) useScrollingClass = true;
	  if ( forceFireReachEvent === void 0 ) forceFireReachEvent = false;
	
	  var fields;
	  if (axis === 'top') {
	    fields = [
	      'contentHeight',
	      'containerHeight',
	      'scrollTop',
	      'y',
	      'up',
	      'down' ];
	  } else if (axis === 'left') {
	    fields = [
	      'contentWidth',
	      'containerWidth',
	      'scrollLeft',
	      'x',
	      'left',
	      'right' ];
	  } else {
	    throw new Error('A proper axis should be provided');
	  }
	
	  processScrollDiff$1(i, diff, fields, useScrollingClass, forceFireReachEvent);
	}
	
	function processScrollDiff$1(
	  i,
	  diff,
	  ref,
	  useScrollingClass,
	  forceFireReachEvent
	) {
	  var contentHeight = ref[0];
	  var containerHeight = ref[1];
	  var scrollTop = ref[2];
	  var y = ref[3];
	  var up = ref[4];
	  var down = ref[5];
	  if ( useScrollingClass === void 0 ) useScrollingClass = true;
	  if ( forceFireReachEvent === void 0 ) forceFireReachEvent = false;
	
	  var element = i.element;
	
	  // reset reach
	  i.reach[y] = null;
	
	  // 1 for subpixel rounding
	  if (element[scrollTop] < 1) {
	    i.reach[y] = 'start';
	  }
	
	  // 1 for subpixel rounding
	  if (element[scrollTop] > i[contentHeight] - i[containerHeight] - 1) {
	    i.reach[y] = 'end';
	  }
	
	  if (diff) {
	    element.dispatchEvent(createEvent(("ps-scroll-" + y)));
	
	    if (diff < 0) {
	      element.dispatchEvent(createEvent(("ps-scroll-" + up)));
	    } else if (diff > 0) {
	      element.dispatchEvent(createEvent(("ps-scroll-" + down)));
	    }
	
	    if (useScrollingClass) {
	      setScrollingClassInstantly(i, y);
	    }
	  }
	
	  if (i.reach[y] && (diff || forceFireReachEvent)) {
	    element.dispatchEvent(createEvent(("ps-" + y + "-reach-" + (i.reach[y]))));
	  }
	}
	
	function toInt(x) {
	  return parseInt(x, 10) || 0;
	}
	
	function isEditable(el) {
	  return (
	    matches(el, 'input,[contenteditable]') ||
	    matches(el, 'select,[contenteditable]') ||
	    matches(el, 'textarea,[contenteditable]') ||
	    matches(el, 'button,[contenteditable]')
	  );
	}
	
	function outerWidth(element) {
	  var styles = get(element);
	  return (
	    toInt(styles.width) +
	    toInt(styles.paddingLeft) +
	    toInt(styles.paddingRight) +
	    toInt(styles.borderLeftWidth) +
	    toInt(styles.borderRightWidth)
	  );
	}
	
	var env = {
	  isWebKit:
	    typeof document !== 'undefined' &&
	    'WebkitAppearance' in document.documentElement.style,
	  supportsTouch:
	    typeof window !== 'undefined' &&
	    ('ontouchstart' in window ||
	      ('maxTouchPoints' in window.navigator &&
	        window.navigator.maxTouchPoints > 0) ||
	      (window.DocumentTouch && document instanceof window.DocumentTouch)),
	  supportsIePointer:
	    typeof navigator !== 'undefined' && navigator.msMaxTouchPoints,
	  isChrome:
	    typeof navigator !== 'undefined' &&
	    /Chrome/i.test(navigator && navigator.userAgent),
	};
	
	function updateGeometry(i) {
	  var element = i.element;
	  var roundedScrollTop = Math.floor(element.scrollTop);
	  var rect = element.getBoundingClientRect();
	
	  i.containerWidth = Math.round(rect.width);
	  i.containerHeight = Math.round(rect.height);
	
	  i.contentWidth = element.scrollWidth;
	  i.contentHeight = element.scrollHeight;
	
	  if (!element.contains(i.scrollbarXRail)) {
	    // clean up and append
	    queryChildren(element, cls.element.rail('x')).forEach(function (el) { return remove(el); }
	    );
	    element.appendChild(i.scrollbarXRail);
	  }
	  if (!element.contains(i.scrollbarYRail)) {
	    // clean up and append
	    queryChildren(element, cls.element.rail('y')).forEach(function (el) { return remove(el); }
	    );
	    element.appendChild(i.scrollbarYRail);
	  }
	
	  if (
	    !i.settings.suppressScrollX &&
	    i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth
	  ) {
	    i.scrollbarXActive = true;
	    i.railXWidth = i.containerWidth - i.railXMarginWidth;
	    i.railXRatio = i.containerWidth / i.railXWidth;
	    i.scrollbarXWidth = getThumbSize(
	      i,
	      toInt((i.railXWidth * i.containerWidth) / i.contentWidth)
	    );
	    i.scrollbarXLeft = toInt(
	      ((i.negativeScrollAdjustment + element.scrollLeft) *
	        (i.railXWidth - i.scrollbarXWidth)) /
	        (i.contentWidth - i.containerWidth)
	    );
	  } else {
	    i.scrollbarXActive = false;
	  }
	
	  if (
	    !i.settings.suppressScrollY &&
	    i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight
	  ) {
	    i.scrollbarYActive = true;
	    i.railYHeight = i.containerHeight - i.railYMarginHeight;
	    i.railYRatio = i.containerHeight / i.railYHeight;
	    i.scrollbarYHeight = getThumbSize(
	      i,
	      toInt((i.railYHeight * i.containerHeight) / i.contentHeight)
	    );
	    i.scrollbarYTop = toInt(
	      (roundedScrollTop * (i.railYHeight - i.scrollbarYHeight)) /
	        (i.contentHeight - i.containerHeight)
	    );
	  } else {
	    i.scrollbarYActive = false;
	  }
	
	  if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) {
	    i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
	  }
	  if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) {
	    i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
	  }
	
	  updateCss(element, i);
	
	  if (i.scrollbarXActive) {
	    element.classList.add(cls.state.active('x'));
	  } else {
	    element.classList.remove(cls.state.active('x'));
	    i.scrollbarXWidth = 0;
	    i.scrollbarXLeft = 0;
	    element.scrollLeft = i.isRtl === true ? i.contentWidth : 0;
	  }
	  if (i.scrollbarYActive) {
	    element.classList.add(cls.state.active('y'));
	  } else {
	    element.classList.remove(cls.state.active('y'));
	    i.scrollbarYHeight = 0;
	    i.scrollbarYTop = 0;
	    element.scrollTop = 0;
	  }
	}
	
	function getThumbSize(i, thumbSize) {
	  if (i.settings.minScrollbarLength) {
	    thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
	  }
	  if (i.settings.maxScrollbarLength) {
	    thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
	  }
	  return thumbSize;
	}
	
	function updateCss(element, i) {
	  var xRailOffset = { width: i.railXWidth };
	  var roundedScrollTop = Math.floor(element.scrollTop);
	
	  if (i.isRtl) {
	    xRailOffset.left =
	      i.negativeScrollAdjustment +
	      element.scrollLeft +
	      i.containerWidth -
	      i.contentWidth;
	  } else {
	    xRailOffset.left = element.scrollLeft;
	  }
	  if (i.isScrollbarXUsingBottom) {
	    xRailOffset.bottom = i.scrollbarXBottom - roundedScrollTop;
	  } else {
	    xRailOffset.top = i.scrollbarXTop + roundedScrollTop;
	  }
	  set(i.scrollbarXRail, xRailOffset);
	
	  var yRailOffset = { top: roundedScrollTop, height: i.railYHeight };
	  if (i.isScrollbarYUsingRight) {
	    if (i.isRtl) {
	      yRailOffset.right =
	        i.contentWidth -
	        (i.negativeScrollAdjustment + element.scrollLeft) -
	        i.scrollbarYRight -
	        i.scrollbarYOuterWidth -
	        9;
	    } else {
	      yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
	    }
	  } else {
	    if (i.isRtl) {
	      yRailOffset.left =
	        i.negativeScrollAdjustment +
	        element.scrollLeft +
	        i.containerWidth * 2 -
	        i.contentWidth -
	        i.scrollbarYLeft -
	        i.scrollbarYOuterWidth;
	    } else {
	      yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
	    }
	  }
	  set(i.scrollbarYRail, yRailOffset);
	
	  set(i.scrollbarX, {
	    left: i.scrollbarXLeft,
	    width: i.scrollbarXWidth - i.railBorderXWidth,
	  });
	  set(i.scrollbarY, {
	    top: i.scrollbarYTop,
	    height: i.scrollbarYHeight - i.railBorderYWidth,
	  });
	}
	
	function clickRail(i) {
	  var element = i.element;
	
	  i.event.bind(i.scrollbarY, 'mousedown', function (e) { return e.stopPropagation(); });
	  i.event.bind(i.scrollbarYRail, 'mousedown', function (e) {
	    var positionTop =
	      e.pageY -
	      window.pageYOffset -
	      i.scrollbarYRail.getBoundingClientRect().top;
	    var direction = positionTop > i.scrollbarYTop ? 1 : -1;
	
	    i.element.scrollTop += direction * i.containerHeight;
	    updateGeometry(i);
	
	    e.stopPropagation();
	  });
	
	  i.event.bind(i.scrollbarX, 'mousedown', function (e) { return e.stopPropagation(); });
	  i.event.bind(i.scrollbarXRail, 'mousedown', function (e) {
	    var positionLeft =
	      e.pageX -
	      window.pageXOffset -
	      i.scrollbarXRail.getBoundingClientRect().left;
	    var direction = positionLeft > i.scrollbarXLeft ? 1 : -1;
	
	    i.element.scrollLeft += direction * i.containerWidth;
	    updateGeometry(i);
	
	    e.stopPropagation();
	  });
	}
	
	function dragThumb(i) {
	  bindMouseScrollHandler(i, [
	    'containerWidth',
	    'contentWidth',
	    'pageX',
	    'railXWidth',
	    'scrollbarX',
	    'scrollbarXWidth',
	    'scrollLeft',
	    'x',
	    'scrollbarXRail' ]);
	  bindMouseScrollHandler(i, [
	    'containerHeight',
	    'contentHeight',
	    'pageY',
	    'railYHeight',
	    'scrollbarY',
	    'scrollbarYHeight',
	    'scrollTop',
	    'y',
	    'scrollbarYRail' ]);
	}
	
	function bindMouseScrollHandler(
	  i,
	  ref
	) {
	  var containerHeight = ref[0];
	  var contentHeight = ref[1];
	  var pageY = ref[2];
	  var railYHeight = ref[3];
	  var scrollbarY = ref[4];
	  var scrollbarYHeight = ref[5];
	  var scrollTop = ref[6];
	  var y = ref[7];
	  var scrollbarYRail = ref[8];
	
	  var element = i.element;
	
	  var startingScrollTop = null;
	  var startingMousePageY = null;
	  var scrollBy = null;
	
	  function mouseMoveHandler(e) {
	    if (e.touches && e.touches[0]) {
	      e[pageY] = e.touches[0].pageY;
	    }
	    element[scrollTop] =
	      startingScrollTop + scrollBy * (e[pageY] - startingMousePageY);
	    addScrollingClass(i, y);
	    updateGeometry(i);
	
	    e.stopPropagation();
	    if (e.type.startsWith('touch') && e.changedTouches.length > 1) {
	      e.preventDefault();
	    }
	  }
	
	  function mouseUpHandler() {
	    removeScrollingClass(i, y);
	    i[scrollbarYRail].classList.remove(cls.state.clicking);
	    i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
	  }
	
	  function bindMoves(e, touchMode) {
	    startingScrollTop = element[scrollTop];
	    if (touchMode && e.touches) {
	      e[pageY] = e.touches[0].pageY;
	    }
	    startingMousePageY = e[pageY];
	    scrollBy =
	      (i[contentHeight] - i[containerHeight]) /
	      (i[railYHeight] - i[scrollbarYHeight]);
	    if (!touchMode) {
	      i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
	      i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);
	      e.preventDefault();
	    } else {
	      i.event.bind(i.ownerDocument, 'touchmove', mouseMoveHandler);
	    }
	
	    i[scrollbarYRail].classList.add(cls.state.clicking);
	
	    e.stopPropagation();
	  }
	
	  i.event.bind(i[scrollbarY], 'mousedown', function (e) {
	    bindMoves(e);
	  });
	  i.event.bind(i[scrollbarY], 'touchstart', function (e) {
	    bindMoves(e, true);
	  });
	}
	
	function keyboard(i) {
	  var element = i.element;
	
	  var elementHovered = function () { return matches(element, ':hover'); };
	  var scrollbarFocused = function () { return matches(i.scrollbarX, ':focus') || matches(i.scrollbarY, ':focus'); };
	
	  function shouldPreventDefault(deltaX, deltaY) {
	    var scrollTop = Math.floor(element.scrollTop);
	    if (deltaX === 0) {
	      if (!i.scrollbarYActive) {
	        return false;
	      }
	      if (
	        (scrollTop === 0 && deltaY > 0) ||
	        (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)
	      ) {
	        return !i.settings.wheelPropagation;
	      }
	    }
	
	    var scrollLeft = element.scrollLeft;
	    if (deltaY === 0) {
	      if (!i.scrollbarXActive) {
	        return false;
	      }
	      if (
	        (scrollLeft === 0 && deltaX < 0) ||
	        (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)
	      ) {
	        return !i.settings.wheelPropagation;
	      }
	    }
	    return true;
	  }
	
	  i.event.bind(i.ownerDocument, 'keydown', function (e) {
	    if (
	      (e.isDefaultPrevented && e.isDefaultPrevented()) ||
	      e.defaultPrevented
	    ) {
	      return;
	    }
	
	    if (!elementHovered() && !scrollbarFocused()) {
	      return;
	    }
	
	    var activeElement = document.activeElement
	      ? document.activeElement
	      : i.ownerDocument.activeElement;
	    if (activeElement) {
	      if (activeElement.tagName === 'IFRAME') {
	        activeElement = activeElement.contentDocument.activeElement;
	      } else {
	        // go deeper if element is a webcomponent
	        while (activeElement.shadowRoot) {
	          activeElement = activeElement.shadowRoot.activeElement;
	        }
	      }
	      if (isEditable(activeElement)) {
	        return;
	      }
	    }
	
	    var deltaX = 0;
	    var deltaY = 0;
	
	    switch (e.which) {
	      case 37: // left
	        if (e.metaKey) {
	          deltaX = -i.contentWidth;
	        } else if (e.altKey) {
	          deltaX = -i.containerWidth;
	        } else {
	          deltaX = -30;
	        }
	        break;
	      case 38: // up
	        if (e.metaKey) {
	          deltaY = i.contentHeight;
	        } else if (e.altKey) {
	          deltaY = i.containerHeight;
	        } else {
	          deltaY = 30;
	        }
	        break;
	      case 39: // right
	        if (e.metaKey) {
	          deltaX = i.contentWidth;
	        } else if (e.altKey) {
	          deltaX = i.containerWidth;
	        } else {
	          deltaX = 30;
	        }
	        break;
	      case 40: // down
	        if (e.metaKey) {
	          deltaY = -i.contentHeight;
	        } else if (e.altKey) {
	          deltaY = -i.containerHeight;
	        } else {
	          deltaY = -30;
	        }
	        break;
	      case 32: // space bar
	        if (e.shiftKey) {
	          deltaY = i.containerHeight;
	        } else {
	          deltaY = -i.containerHeight;
	        }
	        break;
	      case 33: // page up
	        deltaY = i.containerHeight;
	        break;
	      case 34: // page down
	        deltaY = -i.containerHeight;
	        break;
	      case 36: // home
	        deltaY = i.contentHeight;
	        break;
	      case 35: // end
	        deltaY = -i.contentHeight;
	        break;
	      default:
	        return;
	    }
	
	    if (i.settings.suppressScrollX && deltaX !== 0) {
	      return;
	    }
	    if (i.settings.suppressScrollY && deltaY !== 0) {
	      return;
	    }
	
	    element.scrollTop -= deltaY;
	    element.scrollLeft += deltaX;
	    updateGeometry(i);
	
	    if (shouldPreventDefault(deltaX, deltaY)) {
	      e.preventDefault();
	    }
	  });
	}
	
	function wheel(i) {
	  var element = i.element;
	
	  function shouldPreventDefault(deltaX, deltaY) {
	    var roundedScrollTop = Math.floor(element.scrollTop);
	    var isTop = element.scrollTop === 0;
	    var isBottom =
	      roundedScrollTop + element.offsetHeight === element.scrollHeight;
	    var isLeft = element.scrollLeft === 0;
	    var isRight =
	      element.scrollLeft + element.offsetWidth === element.scrollWidth;
	
	    var hitsBound;
	
	    // pick axis with primary direction
	    if (Math.abs(deltaY) > Math.abs(deltaX)) {
	      hitsBound = isTop || isBottom;
	    } else {
	      hitsBound = isLeft || isRight;
	    }
	
	    return hitsBound ? !i.settings.wheelPropagation : true;
	  }
	
	  function getDeltaFromEvent(e) {
	    var deltaX = e.deltaX;
	    var deltaY = -1 * e.deltaY;
	
	    if (typeof deltaX === 'undefined' || typeof deltaY === 'undefined') {
	      // OS X Safari
	      deltaX = (-1 * e.wheelDeltaX) / 6;
	      deltaY = e.wheelDeltaY / 6;
	    }
	
	    if (e.deltaMode && e.deltaMode === 1) {
	      // Firefox in deltaMode 1: Line scrolling
	      deltaX *= 10;
	      deltaY *= 10;
	    }
	
	    if (deltaX !== deltaX && deltaY !== deltaY /* NaN checks */) {
	      // IE in some mouse drivers
	      deltaX = 0;
	      deltaY = e.wheelDelta;
	    }
	
	    if (e.shiftKey) {
	      // reverse axis with shift key
	      return [-deltaY, -deltaX];
	    }
	    return [deltaX, deltaY];
	  }
	
	  function shouldBeConsumedByChild(target, deltaX, deltaY) {
	    // FIXME: this is a workaround for <select> issue in FF and IE #571
	    if (!env.isWebKit && element.querySelector('select:focus')) {
	      return true;
	    }
	
	    if (!element.contains(target)) {
	      return false;
	    }
	
	    var cursor = target;
	
	    while (cursor && cursor !== element) {
	      if (cursor.classList.contains(cls.element.consuming)) {
	        return true;
	      }
	
	      var style = get(cursor);
	
	      // if deltaY && vertical scrollable
	      if (deltaY && style.overflowY.match(/(scroll|auto)/)) {
	        var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
	        if (maxScrollTop > 0) {
	          if (
	            (cursor.scrollTop > 0 && deltaY < 0) ||
	            (cursor.scrollTop < maxScrollTop && deltaY > 0)
	          ) {
	            return true;
	          }
	        }
	      }
	      // if deltaX && horizontal scrollable
	      if (deltaX && style.overflowX.match(/(scroll|auto)/)) {
	        var maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
	        if (maxScrollLeft > 0) {
	          if (
	            (cursor.scrollLeft > 0 && deltaX < 0) ||
	            (cursor.scrollLeft < maxScrollLeft && deltaX > 0)
	          ) {
	            return true;
	          }
	        }
	      }
	
	      cursor = cursor.parentNode;
	    }
	
	    return false;
	  }
	
	  function mousewheelHandler(e) {
	    var ref = getDeltaFromEvent(e);
	    var deltaX = ref[0];
	    var deltaY = ref[1];
	
	    if (shouldBeConsumedByChild(e.target, deltaX, deltaY)) {
	      return;
	    }
	
	    var shouldPrevent = false;
	    if (!i.settings.useBothWheelAxes) {
	      // deltaX will only be used for horizontal scrolling and deltaY will
	      // only be used for vertical scrolling - this is the default
	      element.scrollTop -= deltaY * i.settings.wheelSpeed;
	      element.scrollLeft += deltaX * i.settings.wheelSpeed;
	    } else if (i.scrollbarYActive && !i.scrollbarXActive) {
	      // only vertical scrollbar is active and useBothWheelAxes option is
	      // active, so let's scroll vertical bar using both mouse wheel axes
	      if (deltaY) {
	        element.scrollTop -= deltaY * i.settings.wheelSpeed;
	      } else {
	        element.scrollTop += deltaX * i.settings.wheelSpeed;
	      }
	      shouldPrevent = true;
	    } else if (i.scrollbarXActive && !i.scrollbarYActive) {
	      // useBothWheelAxes and only horizontal bar is active, so use both
	      // wheel axes for horizontal bar
	      if (deltaX) {
	        element.scrollLeft += deltaX * i.settings.wheelSpeed;
	      } else {
	        element.scrollLeft -= deltaY * i.settings.wheelSpeed;
	      }
	      shouldPrevent = true;
	    }
	
	    updateGeometry(i);
	
	    shouldPrevent = shouldPrevent || shouldPreventDefault(deltaX, deltaY);
	    if (shouldPrevent && !e.ctrlKey) {
	      e.stopPropagation();
	      e.preventDefault();
	    }
	  }
	
	  if (typeof window.onwheel !== 'undefined') {
	    i.event.bind(element, 'wheel', mousewheelHandler);
	  } else if (typeof window.onmousewheel !== 'undefined') {
	    i.event.bind(element, 'mousewheel', mousewheelHandler);
	  }
	}
	
	function touch(i) {
	  if (!env.supportsTouch && !env.supportsIePointer) {
	    return;
	  }
	
	  var element = i.element;
	
	  function shouldPrevent(deltaX, deltaY) {
	    var scrollTop = Math.floor(element.scrollTop);
	    var scrollLeft = element.scrollLeft;
	    var magnitudeX = Math.abs(deltaX);
	    var magnitudeY = Math.abs(deltaY);
	
	    if (magnitudeY > magnitudeX) {
	      // user is perhaps trying to swipe up/down the page
	
	      if (
	        (deltaY < 0 && scrollTop === i.contentHeight - i.containerHeight) ||
	        (deltaY > 0 && scrollTop === 0)
	      ) {
	        // set prevent for mobile Chrome refresh
	        return window.scrollY === 0 && deltaY > 0 && env.isChrome;
	      }
	    } else if (magnitudeX > magnitudeY) {
	      // user is perhaps trying to swipe left/right across the page
	
	      if (
	        (deltaX < 0 && scrollLeft === i.contentWidth - i.containerWidth) ||
	        (deltaX > 0 && scrollLeft === 0)
	      ) {
	        return true;
	      }
	    }
	
	    return true;
	  }
	
	  function applyTouchMove(differenceX, differenceY) {
	    element.scrollTop -= differenceY;
	    element.scrollLeft -= differenceX;
	
	    updateGeometry(i);
	  }
	
	  var startOffset = {};
	  var startTime = 0;
	  var speed = {};
	  var easingLoop = null;
	
	  function getTouch(e) {
	    if (e.targetTouches) {
	      return e.targetTouches[0];
	    } else {
	      // Maybe IE pointer
	      return e;
	    }
	  }
	
	  function shouldHandle(e) {
	    if (e.pointerType && e.pointerType === 'pen' && e.buttons === 0) {
	      return false;
	    }
	    if (e.targetTouches && e.targetTouches.length === 1) {
	      return true;
	    }
	    if (
	      e.pointerType &&
	      e.pointerType !== 'mouse' &&
	      e.pointerType !== e.MSPOINTER_TYPE_MOUSE
	    ) {
	      return true;
	    }
	    return false;
	  }
	
	  function touchStart(e) {
	    if (!shouldHandle(e)) {
	      return;
	    }
	
	    var touch = getTouch(e);
	
	    startOffset.pageX = touch.pageX;
	    startOffset.pageY = touch.pageY;
	
	    startTime = new Date().getTime();
	
	    if (easingLoop !== null) {
	      clearInterval(easingLoop);
	    }
	  }
	
	  function shouldBeConsumedByChild(target, deltaX, deltaY) {
	    if (!element.contains(target)) {
	      return false;
	    }
	
	    var cursor = target;
	
	    while (cursor && cursor !== element) {
	      if (cursor.classList.contains(cls.element.consuming)) {
	        return true;
	      }
	
	      var style = get(cursor);
	
	      // if deltaY && vertical scrollable
	      if (deltaY && style.overflowY.match(/(scroll|auto)/)) {
	        var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
	        if (maxScrollTop > 0) {
	          if (
	            (cursor.scrollTop > 0 && deltaY < 0) ||
	            (cursor.scrollTop < maxScrollTop && deltaY > 0)
	          ) {
	            return true;
	          }
	        }
	      }
	      // if deltaX && horizontal scrollable
	      if (deltaX && style.overflowX.match(/(scroll|auto)/)) {
	        var maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
	        if (maxScrollLeft > 0) {
	          if (
	            (cursor.scrollLeft > 0 && deltaX < 0) ||
	            (cursor.scrollLeft < maxScrollLeft && deltaX > 0)
	          ) {
	            return true;
	          }
	        }
	      }
	
	      cursor = cursor.parentNode;
	    }
	
	    return false;
	  }
	
	  function touchMove(e) {
	    if (shouldHandle(e)) {
	      var touch = getTouch(e);
	
	      var currentOffset = { pageX: touch.pageX, pageY: touch.pageY };
	
	      var differenceX = currentOffset.pageX - startOffset.pageX;
	      var differenceY = currentOffset.pageY - startOffset.pageY;
	
	      if (shouldBeConsumedByChild(e.target, differenceX, differenceY)) {
	        return;
	      }
	
	      applyTouchMove(differenceX, differenceY);
	      startOffset = currentOffset;
	
	      var currentTime = new Date().getTime();
	
	      var timeGap = currentTime - startTime;
	      if (timeGap > 0) {
	        speed.x = differenceX / timeGap;
	        speed.y = differenceY / timeGap;
	        startTime = currentTime;
	      }
	
	      if (shouldPrevent(differenceX, differenceY)) {
	        e.preventDefault();
	      }
	    }
	  }
	  function touchEnd() {
	    if (i.settings.swipeEasing) {
	      clearInterval(easingLoop);
	      easingLoop = setInterval(function() {
	        if (i.isInitialized) {
	          clearInterval(easingLoop);
	          return;
	        }
	
	        if (!speed.x && !speed.y) {
	          clearInterval(easingLoop);
	          return;
	        }
	
	        if (Math.abs(speed.x) < 0.01 && Math.abs(speed.y) < 0.01) {
	          clearInterval(easingLoop);
	          return;
	        }
	
	        if (!i.element) {
	          clearInterval(easingLoop);
	          return;
	        }
	
	        applyTouchMove(speed.x * 30, speed.y * 30);
	
	        speed.x *= 0.8;
	        speed.y *= 0.8;
	      }, 10);
	    }
	  }
	
	  if (env.supportsTouch) {
	    i.event.bind(element, 'touchstart', touchStart);
	    i.event.bind(element, 'touchmove', touchMove);
	    i.event.bind(element, 'touchend', touchEnd);
	  } else if (env.supportsIePointer) {
	    if (window.PointerEvent) {
	      i.event.bind(element, 'pointerdown', touchStart);
	      i.event.bind(element, 'pointermove', touchMove);
	      i.event.bind(element, 'pointerup', touchEnd);
	    } else if (window.MSPointerEvent) {
	      i.event.bind(element, 'MSPointerDown', touchStart);
	      i.event.bind(element, 'MSPointerMove', touchMove);
	      i.event.bind(element, 'MSPointerUp', touchEnd);
	    }
	  }
	}
	
	var defaultSettings = function () { return ({
	  handlers: ['click-rail', 'drag-thumb', 'keyboard', 'wheel', 'touch'],
	  maxScrollbarLength: null,
	  minScrollbarLength: null,
	  scrollingThreshold: 1000,
	  scrollXMarginOffset: 0,
	  scrollYMarginOffset: 0,
	  suppressScrollX: false,
	  suppressScrollY: false,
	  swipeEasing: true,
	  useBothWheelAxes: false,
	  wheelPropagation: true,
	  wheelSpeed: 1,
	}); };
	
	var handlers = {
	  'click-rail': clickRail,
	  'drag-thumb': dragThumb,
	  keyboard: keyboard,
	  wheel: wheel,
	  touch: touch,
	};
	
	var PerfectScrollbar = function PerfectScrollbar(element, userSettings) {
	  var this$1 = this;
	  if ( userSettings === void 0 ) userSettings = {};
	
	  if (typeof element === 'string') {
	    element = document.querySelector(element);
	  }
	
	  if (!element || !element.nodeName) {
	    throw new Error('no element is specified to initialize PerfectScrollbar');
	  }
	
	  this.element = element;
	
	  element.classList.add(cls.main);
	
	  this.settings = defaultSettings();
	  for (var key in userSettings) {
	    this.settings[key] = userSettings[key];
	  }
	
	  this.containerWidth = null;
	  this.containerHeight = null;
	  this.contentWidth = null;
	  this.contentHeight = null;
	
	  var focus = function () { return element.classList.add(cls.state.focus); };
	  var blur = function () { return element.classList.remove(cls.state.focus); };
	
	  this.isRtl = get(element).direction === 'rtl';
	  if (this.isRtl === true) {
	    element.classList.add(cls.rtl);
	  }
	  this.isNegativeScroll = (function () {
	    var originalScrollLeft = element.scrollLeft;
	    var result = null;
	    element.scrollLeft = -1;
	    result = element.scrollLeft < 0;
	    element.scrollLeft = originalScrollLeft;
	    return result;
	  })();
	  this.negativeScrollAdjustment = this.isNegativeScroll
	    ? element.scrollWidth - element.clientWidth
	    : 0;
	  this.event = new EventManager();
	  this.ownerDocument = element.ownerDocument || document;
	
	  this.scrollbarXRail = div(cls.element.rail('x'));
	  element.appendChild(this.scrollbarXRail);
	  this.scrollbarX = div(cls.element.thumb('x'));
	  this.scrollbarXRail.appendChild(this.scrollbarX);
	  this.scrollbarX.setAttribute('tabindex', 0);
	  this.event.bind(this.scrollbarX, 'focus', focus);
	  this.event.bind(this.scrollbarX, 'blur', blur);
	  this.scrollbarXActive = null;
	  this.scrollbarXWidth = null;
	  this.scrollbarXLeft = null;
	  var railXStyle = get(this.scrollbarXRail);
	  this.scrollbarXBottom = parseInt(railXStyle.bottom, 10);
	  if (isNaN(this.scrollbarXBottom)) {
	    this.isScrollbarXUsingBottom = false;
	    this.scrollbarXTop = toInt(railXStyle.top);
	  } else {
	    this.isScrollbarXUsingBottom = true;
	  }
	  this.railBorderXWidth =
	    toInt(railXStyle.borderLeftWidth) + toInt(railXStyle.borderRightWidth);
	  // Set rail to display:block to calculate margins
	  set(this.scrollbarXRail, { display: 'block' });
	  this.railXMarginWidth =
	    toInt(railXStyle.marginLeft) + toInt(railXStyle.marginRight);
	  set(this.scrollbarXRail, { display: '' });
	  this.railXWidth = null;
	  this.railXRatio = null;
	
	  this.scrollbarYRail = div(cls.element.rail('y'));
	  element.appendChild(this.scrollbarYRail);
	  this.scrollbarY = div(cls.element.thumb('y'));
	  this.scrollbarYRail.appendChild(this.scrollbarY);
	  this.scrollbarY.setAttribute('tabindex', 0);
	  this.event.bind(this.scrollbarY, 'focus', focus);
	  this.event.bind(this.scrollbarY, 'blur', blur);
	  this.scrollbarYActive = null;
	  this.scrollbarYHeight = null;
	  this.scrollbarYTop = null;
	  var railYStyle = get(this.scrollbarYRail);
	  this.scrollbarYRight = parseInt(railYStyle.right, 10);
	  if (isNaN(this.scrollbarYRight)) {
	    this.isScrollbarYUsingRight = false;
	    this.scrollbarYLeft = toInt(railYStyle.left);
	  } else {
	    this.isScrollbarYUsingRight = true;
	  }
	  this.scrollbarYOuterWidth = this.isRtl ? outerWidth(this.scrollbarY) : null;
	  this.railBorderYWidth =
	    toInt(railYStyle.borderTopWidth) + toInt(railYStyle.borderBottomWidth);
	  set(this.scrollbarYRail, { display: 'block' });
	  this.railYMarginHeight =
	    toInt(railYStyle.marginTop) + toInt(railYStyle.marginBottom);
	  set(this.scrollbarYRail, { display: '' });
	  this.railYHeight = null;
	  this.railYRatio = null;
	
	  this.reach = {
	    x:
	      element.scrollLeft <= 0
	        ? 'start'
	        : element.scrollLeft >= this.contentWidth - this.containerWidth
	        ? 'end'
	        : null,
	    y:
	      element.scrollTop <= 0
	        ? 'start'
	        : element.scrollTop >= this.contentHeight - this.containerHeight
	        ? 'end'
	        : null,
	  };
	
	  this.isAlive = true;
	
	  this.settings.handlers.forEach(function (handlerName) { return handlers[handlerName](this$1); });
	
	  this.lastScrollTop = Math.floor(element.scrollTop); // for onScroll only
	  this.lastScrollLeft = element.scrollLeft; // for onScroll only
	  this.event.bind(this.element, 'scroll', function (e) { return this$1.onScroll(e); });
	  updateGeometry(this);
	};
	
	PerfectScrollbar.prototype.update = function update () {
	  if (!this.isAlive) {
	    return;
	  }
	
	  // Recalcuate negative scrollLeft adjustment
	  this.negativeScrollAdjustment = this.isNegativeScroll
	    ? this.element.scrollWidth - this.element.clientWidth
	    : 0;
	
	  // Recalculate rail margins
	  set(this.scrollbarXRail, { display: 'block' });
	  set(this.scrollbarYRail, { display: 'block' });
	  this.railXMarginWidth =
	    toInt(get(this.scrollbarXRail).marginLeft) +
	    toInt(get(this.scrollbarXRail).marginRight);
	  this.railYMarginHeight =
	    toInt(get(this.scrollbarYRail).marginTop) +
	    toInt(get(this.scrollbarYRail).marginBottom);
	
	  // Hide scrollbars not to affect scrollWidth and scrollHeight
	  set(this.scrollbarXRail, { display: 'none' });
	  set(this.scrollbarYRail, { display: 'none' });
	
	  updateGeometry(this);
	
	  processScrollDiff(this, 'top', 0, false, true);
	  processScrollDiff(this, 'left', 0, false, true);
	
	  set(this.scrollbarXRail, { display: '' });
	  set(this.scrollbarYRail, { display: '' });
	};
	
	PerfectScrollbar.prototype.onScroll = function onScroll (e) {
	  if (!this.isAlive) {
	    return;
	  }
	
	  updateGeometry(this);
	  processScrollDiff(this, 'top', this.element.scrollTop - this.lastScrollTop);
	  processScrollDiff(
	    this,
	    'left',
	    this.element.scrollLeft - this.lastScrollLeft
	  );
	
	  this.lastScrollTop = Math.floor(this.element.scrollTop);
	  this.lastScrollLeft = this.element.scrollLeft;
	};
	
	PerfectScrollbar.prototype.destroy = function destroy () {
	  if (!this.isAlive) {
	    return;
	  }
	
	  this.event.unbindAll();
	  remove(this.scrollbarX);
	  remove(this.scrollbarY);
	  remove(this.scrollbarXRail);
	  remove(this.scrollbarYRail);
	  this.removePsClasses();
	
	  // unset elements
	  this.element = null;
	  this.scrollbarX = null;
	  this.scrollbarY = null;
	  this.scrollbarXRail = null;
	  this.scrollbarYRail = null;
	
	  this.isAlive = false;
	};
	
	PerfectScrollbar.prototype.removePsClasses = function removePsClasses () {
	  this.element.className = this.element.className
	    .split(' ')
	    .filter(function (name) { return !name.match(/^ps([-_].+|)$/); })
	    .join(' ');
	};
	
	module.exports = PerfectScrollbar;
	//# sourceMappingURL=perfect-scrollbar.common.js.map


/***/ },
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(87);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'UNSAFE_componentWillReceiveProps',
			value: function UNSAFE_componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ },
/* 1916 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1919);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(87);
	
	var _perfectScrollbar = __webpack_require__(1845);
	
	var _perfectScrollbar2 = _interopRequireDefault(_perfectScrollbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var handlerNameByEvent = {
	  'ps-scroll-y': 'onScrollY',
	  'ps-scroll-x': 'onScrollX',
	  'ps-scroll-up': 'onScrollUp',
	  'ps-scroll-down': 'onScrollDown',
	  'ps-scroll-left': 'onScrollLeft',
	  'ps-scroll-right': 'onScrollRight',
	  'ps-y-reach-start': 'onYReachStart',
	  'ps-y-reach-end': 'onYReachEnd',
	  'ps-x-reach-start': 'onXReachStart',
	  'ps-x-reach-end': 'onXReachEnd'
	};
	Object.freeze(handlerNameByEvent);
	
	var ScrollBar = function (_Component) {
	  _inherits(ScrollBar, _Component);
	
	  function ScrollBar(props) {
	    _classCallCheck(this, ScrollBar);
	
	    var _this = _possibleConstructorReturn(this, (ScrollBar.__proto__ || Object.getPrototypeOf(ScrollBar)).call(this, props));
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    _this._handlerByEvent = new Map();
	    return _this;
	  }
	
	  _createClass(ScrollBar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this._ps = new _perfectScrollbar2.default(this._container, this.props.option);
	      // hook up events
	      Object.keys(handlerNameByEvent).forEach(function (key) {
	        var callback = _this2.props[handlerNameByEvent[key]];
	        if (callback) {
	          var handler = function handler() {
	            return callback(_this2._container);
	          };
	          _this2._handlerByEvent.set(key, handler);
	          _this2._container.addEventListener(key, handler, false);
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._ps.update();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      // unhook up evens
	      Object.keys(this._handlerByEvent).forEach(function (value, key) {
	        _this3._container.removeEventListener(key, value, false);
	      });
	      this._handlerByEvent.clear();
	      this._ps.destroy();
	      this._ps = null;
	    }
	  }, {
	    key: 'updateScroll',
	    value: function updateScroll() {
	      this._ps.update();
	    }
	  }, {
	    key: 'handleRef',
	    value: function handleRef(ref) {
	      this._container = ref;
	      this.props.containerRef(ref);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          component = _props.component;
	
	      var Comp = component;
	
	      return _react2.default.createElement(
	        Comp,
	        { className: 'scrollbar-container ' + className, ref: this.handleRef },
	        children
	      );
	    }
	  }]);
	
	  return ScrollBar;
	}(_react.Component);
	
	exports.default = ScrollBar;
	
	
	ScrollBar.defaultProps = {
	  className: '',
	  option: undefined,
	  containerRef: function containerRef() {},
	  onScrollY: undefined,
	  onScrollX: undefined,
	  onScrollUp: undefined,
	  onScrollDown: undefined,
	  onScrollLeft: undefined,
	  onScrollRight: undefined,
	  onYReachStart: undefined,
	  onYReachEnd: undefined,
	  onXReachStart: undefined,
	  onXReachEnd: undefined,
	  component: 'div'
	};
	
	ScrollBar.propTypes = {
	  children: _propTypes.PropTypes.node.isRequired,
	  className: _propTypes.PropTypes.string,
	  option: _propTypes.PropTypes.object,
	  containerRef: _propTypes.PropTypes.func,
	  onScrollY: _propTypes.PropTypes.func,
	  onScrollX: _propTypes.PropTypes.func,
	  onScrollUp: _propTypes.PropTypes.func,
	  onScrollDown: _propTypes.PropTypes.func,
	  onScrollLeft: _propTypes.PropTypes.func,
	  onScrollRight: _propTypes.PropTypes.func,
	  onYReachStart: _propTypes.PropTypes.func,
	  onYReachEnd: _propTypes.PropTypes.func,
	  onXReachStart: _propTypes.PropTypes.func,
	  onXReachEnd: _propTypes.PropTypes.func,
	  component: _propTypes.PropTypes.string
	};
	module.exports = exports['default'];

/***/ },
/* 1917 */
49,
/* 1918 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var l=__webpack_require__(1917),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
	60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
	function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
	function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
	function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
	var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
	exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
	key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
	exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ },
/* 1919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1918);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 1920 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ICON_SIZE = '64px';
	
	var Preview =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Preview, _Component);
	
	  function Preview() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Preview);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Preview)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "mounted", false);
	
	    _defineProperty(_assertThisInitialized(_this), "state", {
	      image: null
	    });
	
	    return _this;
	  }
	
	  _createClass(Preview, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true;
	      this.fetchImage(this.props);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this$props = this.props,
	          url = _this$props.url,
	          light = _this$props.light;
	
	      if (prevProps.url !== url || prevProps.light !== light) {
	        this.fetchImage(this.props);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false;
	    }
	  }, {
	    key: "fetchImage",
	    value: function fetchImage(_ref) {
	      var _this2 = this;
	
	      var url = _ref.url,
	          light = _ref.light;
	
	      if (typeof light === 'string') {
	        this.setState({
	          image: light
	        });
	        return;
	      }
	
	      this.setState({
	        image: null
	      });
	      return window.fetch("https://noembed.com/embed?url=".concat(url)).then(function (response) {
	        return response.json();
	      }).then(function (data) {
	        if (data.thumbnail_url && _this2.mounted) {
	          var image = data.thumbnail_url.replace('height=100', 'height=480');
	
	          _this2.setState({
	            image: image
	          });
	        }
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var onClick = this.props.onClick;
	      var image = this.state.image;
	      var flexCenter = {
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center'
	      };
	      var styles = {
	        preview: _objectSpread({
	          width: '100%',
	          height: '100%',
	          backgroundImage: image ? "url(".concat(image, ")") : undefined,
	          backgroundSize: 'cover',
	          backgroundPosition: 'center',
	          cursor: 'pointer'
	        }, flexCenter),
	        shadow: _objectSpread({
	          background: 'radial-gradient(rgb(0, 0, 0, 0.3), rgba(0, 0, 0, 0) 60%)',
	          borderRadius: ICON_SIZE,
	          width: ICON_SIZE,
	          height: ICON_SIZE
	        }, flexCenter),
	        playIcon: {
	          borderStyle: 'solid',
	          borderWidth: '16px 0 16px 26px',
	          borderColor: 'transparent transparent transparent white',
	          marginLeft: '7px'
	        }
	      };
	      return _react["default"].createElement("div", {
	        style: styles.preview,
	        className: "react-player__preview",
	        onClick: onClick
	      }, _react["default"].createElement("div", {
	        style: styles.shadow,
	        className: "react-player__shadow"
	      }, _react["default"].createElement("div", {
	        style: styles.playIcon,
	        className: "react-player__play-icon"
	      })));
	    }
	  }]);
	
	  return Preview;
	}(_react.Component);
	
	exports["default"] = Preview;

/***/ },
/* 1921 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "FilePlayer", {
	  enumerable: true,
	  get: function get() {
	    return _FilePlayer["default"];
	  }
	});
	Object.defineProperty(exports, "YouTube", {
	  enumerable: true,
	  get: function get() {
	    return _YouTube["default"];
	  }
	});
	Object.defineProperty(exports, "SoundCloud", {
	  enumerable: true,
	  get: function get() {
	    return _SoundCloud["default"];
	  }
	});
	Object.defineProperty(exports, "Vimeo", {
	  enumerable: true,
	  get: function get() {
	    return _Vimeo["default"];
	  }
	});
	Object.defineProperty(exports, "Facebook", {
	  enumerable: true,
	  get: function get() {
	    return _Facebook["default"];
	  }
	});
	Object.defineProperty(exports, "Streamable", {
	  enumerable: true,
	  get: function get() {
	    return _Streamable["default"];
	  }
	});
	Object.defineProperty(exports, "Wistia", {
	  enumerable: true,
	  get: function get() {
	    return _Wistia["default"];
	  }
	});
	Object.defineProperty(exports, "Twitch", {
	  enumerable: true,
	  get: function get() {
	    return _Twitch["default"];
	  }
	});
	Object.defineProperty(exports, "DailyMotion", {
	  enumerable: true,
	  get: function get() {
	    return _DailyMotion["default"];
	  }
	});
	Object.defineProperty(exports, "Mixcloud", {
	  enumerable: true,
	  get: function get() {
	    return _Mixcloud["default"];
	  }
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _props = __webpack_require__(548);
	
	var _utils = __webpack_require__(88);
	
	var _players = _interopRequireDefault(__webpack_require__(1922));
	
	var _Player4 = _interopRequireDefault(__webpack_require__(679));
	
	var _Preview = _interopRequireDefault(__webpack_require__(1920));
	
	var _FilePlayer = _interopRequireWildcard(__webpack_require__(896));
	
	var _preload = _interopRequireDefault(__webpack_require__(1923));
	
	var _YouTube = _interopRequireDefault(__webpack_require__(683));
	
	var _SoundCloud = _interopRequireDefault(__webpack_require__(681));
	
	var _Vimeo = _interopRequireDefault(__webpack_require__(682));
	
	var _Facebook = _interopRequireDefault(__webpack_require__(895));
	
	var _Streamable = _interopRequireDefault(__webpack_require__(898));
	
	var _Wistia = _interopRequireDefault(__webpack_require__(900));
	
	var _Twitch = _interopRequireDefault(__webpack_require__(899));
	
	var _DailyMotion = _interopRequireDefault(__webpack_require__(680));
	
	var _Mixcloud = _interopRequireDefault(__webpack_require__(897));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SUPPORTED_PROPS = Object.keys(_props.propTypes);
	var customPlayers = [];
	
	var ReactPlayer =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ReactPlayer, _Component);
	
	  function ReactPlayer() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, ReactPlayer);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ReactPlayer)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "config", (0, _utils.getConfig)(_this.props, _props.defaultProps, true));
	
	    _defineProperty(_assertThisInitialized(_this), "state", {
	      showPreview: !!_this.props.light
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleClickPreview", function () {
	      _this.setState({
	        showPreview: false
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "showPreview", function () {
	      _this.setState({
	        showPreview: true
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "getDuration", function () {
	      if (!_this.player) return null;
	      return _this.player.getDuration();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "getCurrentTime", function () {
	      if (!_this.player) return null;
	      return _this.player.getCurrentTime();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "getSecondsLoaded", function () {
	      if (!_this.player) return null;
	      return _this.player.getSecondsLoaded();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function () {
	      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';
	      if (!_this.player) return null;
	      return _this.player.getInternalPlayer(key);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "seekTo", function (fraction, type) {
	      if (!_this.player) return null;
	
	      _this.player.seekTo(fraction, type);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleReady", function () {
	      _this.props.onReady(_assertThisInitialized(_this));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "wrapperRef", function (wrapper) {
	      _this.wrapper = wrapper;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "activePlayerRef", function (player) {
	      _this.player = player;
	    });
	
	    return _this;
	  }
	
	  _createClass(ReactPlayer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.progressFrequency) {
	        var message = 'ReactPlayer: %cprogressFrequency%c is deprecated, please use %cprogressInterval%c instead';
	        console.warn(message, 'font-weight: bold', '', 'font-weight: bold', '');
	      }
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _utils.isEqual)(this.props, nextProps) || !(0, _utils.isEqual)(this.state, nextState);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var light = this.props.light;
	      this.config = (0, _utils.getConfig)(this.props, _props.defaultProps);
	
	      if (!prevProps.light && light) {
	        this.setState({
	          showPreview: true
	        });
	      }
	
	      if (prevProps.light && !light) {
	        this.setState({
	          showPreview: false
	        });
	      }
	    }
	  }, {
	    key: "getActivePlayer",
	    value: function getActivePlayer(url) {
	      for (var _i = 0, _arr = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players["default"])); _i < _arr.length; _i++) {
	        var _Player = _arr[_i];
	
	        if (_Player.canPlay(url)) {
	          return _Player;
	        }
	      } // Fall back to FilePlayer if nothing else can play the URL
	
	
	      return _FilePlayer.FilePlayer;
	    }
	  }, {
	    key: "renderActivePlayer",
	    value: function renderActivePlayer(url, activePlayer) {
	      if (!url) return null;
	      return _react["default"].createElement(_Player4["default"], _extends({}, this.props, {
	        key: activePlayer.displayName,
	        ref: this.activePlayerRef,
	        config: this.config,
	        activePlayer: activePlayer,
	        onReady: this.handleReady
	      }));
	    }
	  }, {
	    key: "sortPlayers",
	    value: function sortPlayers(a, b) {
	      // Retain player order to prevent weird iframe behaviour when switching players
	      if (a && b) {
	        return a.key < b.key ? -1 : 1;
	      }
	
	      return 0;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          url = _this$props.url,
	          controls = _this$props.controls,
	          style = _this$props.style,
	          width = _this$props.width,
	          height = _this$props.height,
	          light = _this$props.light,
	          Wrapper = _this$props.wrapper;
	      var showPreview = this.state.showPreview && url;
	      var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props.DEPRECATED_CONFIG_PROPS);
	      var activePlayer = this.getActivePlayer(url);
	      var renderedActivePlayer = this.renderActivePlayer(url, activePlayer);
	      var preloadPlayers = (0, _preload["default"])(url, controls, this.config);
	      var players = [renderedActivePlayer].concat(_toConsumableArray(preloadPlayers)).sort(this.sortPlayers);
	
	      var preview = _react["default"].createElement(_Preview["default"], {
	        url: url,
	        light: light,
	        onClick: this.handleClickPreview
	      });
	
	      return _react["default"].createElement(Wrapper, _extends({
	        ref: this.wrapperRef,
	        style: _objectSpread({}, style, {
	          width: width,
	          height: height
	        })
	      }, otherProps), showPreview ? preview : players);
	    }
	  }]);
	
	  return ReactPlayer;
	}(_react.Component);
	
	exports["default"] = ReactPlayer;
	
	_defineProperty(ReactPlayer, "addCustomPlayer", function (player) {
	  customPlayers.push(player);
	});
	
	_defineProperty(ReactPlayer, "removeCustomPlayers", function () {
	  customPlayers = [];
	});
	
	_defineProperty(ReactPlayer, "displayName", 'ReactPlayer');
	
	_defineProperty(ReactPlayer, "propTypes", _props.propTypes);
	
	_defineProperty(ReactPlayer, "defaultProps", _props.defaultProps);
	
	_defineProperty(ReactPlayer, "canPlay", function (url) {
	  for (var _i2 = 0, _arr2 = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players["default"])); _i2 < _arr2.length; _i2++) {
	    var _Player2 = _arr2[_i2];
	
	    if (_Player2.canPlay(url)) {
	      return true;
	    }
	  }
	
	  return false;
	});
	
	_defineProperty(ReactPlayer, "canEnablePIP", function (url) {
	  for (var _i3 = 0, _arr3 = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players["default"])); _i3 < _arr3.length; _i3++) {
	    var _Player3 = _arr3[_i3];
	
	    if (_Player3.canEnablePIP && _Player3.canEnablePIP(url)) {
	      return true;
	    }
	  }
	
	  return false;
	});

/***/ },
/* 1922 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _YouTube = __webpack_require__(683);
	
	var _SoundCloud = __webpack_require__(681);
	
	var _Vimeo = __webpack_require__(682);
	
	var _Facebook = __webpack_require__(895);
	
	var _Streamable = __webpack_require__(898);
	
	var _Wistia = __webpack_require__(900);
	
	var _Twitch = __webpack_require__(899);
	
	var _DailyMotion = __webpack_require__(680);
	
	var _Mixcloud = __webpack_require__(897);
	
	var _FilePlayer = __webpack_require__(896);
	
	var _default = [_YouTube.YouTube, _SoundCloud.SoundCloud, _Vimeo.Vimeo, _Facebook.Facebook, _Streamable.Streamable, _Wistia.Wistia, _Twitch.Twitch, _DailyMotion.DailyMotion, _Mixcloud.Mixcloud, _FilePlayer.FilePlayer];
	exports["default"] = _default;

/***/ },
/* 1923 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = renderPreloadPlayers;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Player = _interopRequireDefault(__webpack_require__(679));
	
	var _YouTube = __webpack_require__(683);
	
	var _SoundCloud = __webpack_require__(681);
	
	var _Vimeo = __webpack_require__(682);
	
	var _DailyMotion = __webpack_require__(680);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var PRELOAD_PLAYERS = [{
	  Player: _YouTube.YouTube,
	  configKey: 'youtube',
	  url: 'https://www.youtube.com/watch?v=GlCmAC4MHek'
	}, {
	  Player: _SoundCloud.SoundCloud,
	  configKey: 'soundcloud',
	  url: 'https://soundcloud.com/seucheu/john-cage-433-8-bit-version'
	}, {
	  Player: _Vimeo.Vimeo,
	  configKey: 'vimeo',
	  url: 'https://vimeo.com/300970506'
	}, {
	  Player: _DailyMotion.DailyMotion,
	  configKey: 'dailymotion',
	  url: 'http://www.dailymotion.com/video/xqdpyk'
	}];
	
	function renderPreloadPlayers(url, controls, config) {
	  var players = [];
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = PRELOAD_PLAYERS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var player = _step.value;
	
	      if (!player.Player.canPlay(url) && config[player.configKey].preload) {
	        players.push(_react["default"].createElement(_Player["default"], {
	          key: player.Player.displayName,
	          activePlayer: player.Player,
	          url: player.url,
	          controls: controls,
	          playing: true,
	          muted: true,
	          display: "none"
	        }));
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
	        _iterator["return"]();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return players;
	}

/***/ },
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */,
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(87);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Async = __webpack_require__(916);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _Creatable = __webpack_require__(917);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Select = __webpack_require__(551);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AsyncCreatableSelect = function (_React$Component) {
		_inherits(AsyncCreatableSelect, _React$Component);
	
		function AsyncCreatableSelect() {
			_classCallCheck(this, AsyncCreatableSelect);
	
			return _possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
		}
	
		_createClass(AsyncCreatableSelect, [{
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					_Async2.default,
					this.props,
					function (_ref) {
						var ref = _ref.ref,
						    asyncProps = _objectWithoutProperties(_ref, ['ref']);
	
						var asyncRef = ref;
						return _react2.default.createElement(
							_Creatable2.default,
							asyncProps,
							function (_ref2) {
								var ref = _ref2.ref,
								    creatableProps = _objectWithoutProperties(_ref2, ['ref']);
	
								var creatableRef = ref;
								return _this2.props.children(_extends({}, creatableProps, {
									ref: function ref(select) {
										creatableRef(select);
										asyncRef(select);
										_this2.select = select;
									}
								}));
							}
						);
					}
				);
			}
		}]);
	
		return AsyncCreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	AsyncCreatableSelect.propTypes = {
		children: _propTypes2.default.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	};
	
	AsyncCreatableSelect.defaultProps = {
		children: defaultChildren
	};
	
	exports.default = AsyncCreatableSelect;

/***/ },
/* 1956 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.defaultFilterOptions = exports.defaultClearRenderer = exports.defaultArrowRenderer = exports.defaultMenuRenderer = exports.Option = exports.Value = exports.Creatable = exports.AsyncCreatable = exports.Async = undefined;
	
	var _Select = __webpack_require__(551);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Async = __webpack_require__(916);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _AsyncCreatable = __webpack_require__(1955);
	
	var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
	var _Creatable = __webpack_require__(917);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Value = __webpack_require__(919);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	var _Option = __webpack_require__(918);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _defaultMenuRenderer = __webpack_require__(694);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _defaultArrowRenderer = __webpack_require__(920);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(921);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(693);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_Select2.default.Async = _Async2.default;
	_Select2.default.AsyncCreatable = _AsyncCreatable2.default;
	_Select2.default.Creatable = _Creatable2.default;
	_Select2.default.Value = _Value2.default;
	_Select2.default.Option = _Option2.default;
	
	exports.default = _Select2.default;
	exports.Async = _Async2.default;
	exports.AsyncCreatable = _AsyncCreatable2.default;
	exports.Creatable = _Creatable2.default;
	exports.Value = _Value2.default;
	exports.Option = _Option2.default;
	exports.defaultMenuRenderer = _defaultMenuRenderer2.default;
	exports.defaultArrowRenderer = _defaultArrowRenderer2.default;
	exports.defaultClearRenderer = _defaultClearRenderer2.default;
	exports.defaultFilterOptions = _defaultFilterOptions2.default;

/***/ },
/* 1957 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (event) {
		event.preventDefault();
		event.stopPropagation();
		if (event.target.tagName !== 'A' || !('href' in event.target)) {
			return;
		}
		if (event.target.target) {
			window.open(event.target.href, event.target.target);
		} else {
			window.location.href = event.target.href;
		}
	};

/***/ },
/* 1958 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var trim = function trim(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	};
	
	exports.default = trim;

/***/ },
/* 1959 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.NextArrow = exports.PrevArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(61);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(552);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
	  _inherits(PrevArrow, _React$PureComponent);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  PrevArrow.prototype.render = function render() {
	    var prevClasses = { "slick-arrow": true, "slick-prev": true };
	    var prevHandler = this.clickHandler.bind(this, { message: "previous" });
	
	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses["slick-disabled"] = true;
	      prevHandler = null;
	    }
	
	    var prevArrowProps = {
	      key: "0",
	      "data-role": "none",
	      className: (0, _classnames2.default)(prevClasses),
	      style: { display: "block" },
	      onClick: prevHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var prevArrow = void 0;
	
	    if (this.props.prevArrow) {
	      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
	    } else {
	      prevArrow = _react2.default.createElement(
	        "button",
	        _extends({ key: "0", type: "button" }, prevArrowProps),
	        " ",
	        "Previous"
	      );
	    }
	
	    return prevArrow;
	  };
	
	  return PrevArrow;
	}(_react2.default.PureComponent);
	
	var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
	  _inherits(NextArrow, _React$PureComponent2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
	  }
	
	  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  NextArrow.prototype.render = function render() {
	    var nextClasses = { "slick-arrow": true, "slick-next": true };
	    var nextHandler = this.clickHandler.bind(this, { message: "next" });
	
	    if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
	      nextClasses["slick-disabled"] = true;
	      nextHandler = null;
	    }
	
	    var nextArrowProps = {
	      key: "1",
	      "data-role": "none",
	      className: (0, _classnames2.default)(nextClasses),
	      style: { display: "block" },
	      onClick: nextHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var nextArrow = void 0;
	
	    if (this.props.nextArrow) {
	      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
	    } else {
	      nextArrow = _react2.default.createElement(
	        "button",
	        _extends({ key: "1", type: "button" }, nextArrowProps),
	        " ",
	        "Next"
	      );
	    }
	
	    return nextArrow;
	  };
	
	  return NextArrow;
	}(_react2.default.PureComponent);

/***/ },
/* 1960 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	  accessibility: true,
	  adaptiveHeight: false,
	  afterChange: null,
	  appendDots: function appendDots(dots) {
	    return _react2.default.createElement(
	      "ul",
	      { style: { display: "block" } },
	      dots
	    );
	  },
	  arrows: true,
	  autoplay: false,
	  autoplaySpeed: 3000,
	  beforeChange: null,
	  centerMode: false,
	  centerPadding: "50px",
	  className: "",
	  cssEase: "ease",
	  customPaging: function customPaging(i) {
	    return _react2.default.createElement(
	      "button",
	      null,
	      i + 1
	    );
	  },
	  dots: false,
	  dotsClass: "slick-dots",
	  draggable: true,
	  easing: "linear",
	  edgeFriction: 0.35,
	  fade: false,
	  focusOnSelect: false,
	  infinite: true,
	  initialSlide: 0,
	  lazyLoad: null,
	  nextArrow: null,
	  onEdge: null,
	  onInit: null,
	  onLazyLoadError: null,
	  onReInit: null,
	  pauseOnDotsHover: false,
	  pauseOnFocus: false,
	  pauseOnHover: true,
	  prevArrow: null,
	  responsive: null,
	  rows: 1,
	  rtl: false,
	  slide: "div",
	  slidesPerRow: 1,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  speed: 500,
	  swipe: true,
	  swipeEvent: null,
	  swipeToSlide: false,
	  touchMove: true,
	  touchThreshold: 5,
	  useCSS: true,
	  useTransform: true,
	  variableWidth: false,
	  vertical: false,
	  waitForAnimate: true
	};
	
	exports.default = defaultProps;

/***/ },
/* 1961 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Dots = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(61);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	
	  if (spec.infinite) {
	    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  } else {
	    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
	  }
	
	  return dots;
	};
	
	var Dots = exports.Dots = function (_React$PureComponent) {
	  _inherits(Dots, _React$PureComponent);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Dots.prototype.clickHandler = function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  };
	
	  Dots.prototype.render = function render() {
	    var _this2 = this;
	
	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll,
	      slidesToShow: this.props.slidesToShow,
	      infinite: this.props.infinite
	    });
	
	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var _props = this.props,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseOver = _props.onMouseOver,
	        onMouseLeave = _props.onMouseLeave;
	
	    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
	    var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
	      var leftBound = i * _this2.props.slidesToScroll;
	      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
	      var className = (0, _classnames2.default)({
	        "slick-active": _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
	      });
	
	      var dotOptions = {
	        message: "dots",
	        index: i,
	        slidesToScroll: _this2.props.slidesToScroll,
	        currentSlide: _this2.props.currentSlide
	      };
	
	      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
	      return _react2.default.createElement(
	        "li",
	        { key: i, className: className },
	        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
	      );
	    });
	
	    return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
	      className: this.props.dotsClass
	    }, mouseEvents));
	  };
	
	  return Dots;
	}(_react2.default.PureComponent);

/***/ },
/* 1962 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var initialState = {
	  animating: false,
	  autoplaying: null,
	  currentDirection: 0,
	  currentLeft: null,
	  currentSlide: 0,
	  direction: 1,
	  dragging: false,
	  edgeDragged: false,
	  initialized: false,
	  lazyLoadedList: [],
	  listHeight: null,
	  listWidth: null,
	  scrolling: false,
	  slideCount: null,
	  slideHeight: null,
	  slideWidth: null,
	  swipeLeft: null,
	  swiped: false, // used by swipeEvent. differentites between touch and swipe.
	  swiping: false,
	  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
	  trackStyle: {},
	  trackWidth: 0
	};
	
	exports.default = initialState;

/***/ },
/* 1963 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.InnerSlider = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(329);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _initialState = __webpack_require__(1962);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _lodash = __webpack_require__(1836);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(61);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(552);
	
	var _track = __webpack_require__(1965);
	
	var _dots = __webpack_require__(1961);
	
	var _arrows = __webpack_require__(1959);
	
	var _resizeObserverPolyfill = __webpack_require__(2002);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InnerSlider = exports.InnerSlider = function (_React$Component) {
	  _inherits(InnerSlider, _React$Component);
	
	  function InnerSlider(props) {
	    _classCallCheck(this, InnerSlider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.listRefHandler = function (ref) {
	      return _this.list = ref;
	    };
	
	    _this.trackRefHandler = function (ref) {
	      return _this.track = ref;
	    };
	
	    _this.adaptHeight = function () {
	      if (_this.props.adaptiveHeight && _this.list) {
	        var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");
	        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
	      }
	    };
	
	    _this.componentWillMount = function () {
	      _this.ssrInit();
	      _this.props.onInit && _this.props.onInit();
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	    };
	
	    _this.componentDidMount = function () {
	      var spec = _extends({ listRef: _this.list, trackRef: _this.track }, _this.props);
	      _this.updateState(spec, true, function () {
	        _this.adaptHeight();
	        _this.props.autoplay && _this.autoPlay("update");
	      });
	      if (_this.props.lazyLoad === "progressive") {
	        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
	      }
	      _this.ro = new _resizeObserverPolyfill2.default(function () {
	        if (_this.state.animating) {
	          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
	          _this.callbackTimers.push(setTimeout(function () {
	            return _this.onWindowResized();
	          }, _this.props.speed));
	        } else {
	          _this.onWindowResized();
	        }
	      });
	      _this.ro.observe(_this.list);
	      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
	        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
	        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
	      });
	      // To support server-side rendering
	      if (!window) {
	        return;
	      }
	      if (window.addEventListener) {
	        window.addEventListener("resize", _this.onWindowResized);
	      } else {
	        window.attachEvent("onresize", _this.onWindowResized);
	      }
	    };
	
	    _this.componentWillUnmount = function () {
	      if (_this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	      }
	      if (_this.lazyLoadTimer) {
	        clearInterval(_this.lazyLoadTimer);
	      }
	      if (_this.callbackTimers.length) {
	        _this.callbackTimers.forEach(function (timer) {
	          return clearTimeout(timer);
	        });
	        _this.callbackTimers = [];
	      }
	      if (window.addEventListener) {
	        window.removeEventListener("resize", _this.onWindowResized);
	      } else {
	        window.detachEvent("onresize", _this.onWindowResized);
	      }
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	    };
	
	    _this.componentWillReceiveProps = function (nextProps) {
	      var spec = _extends({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, nextProps, _this.state);
	      var setTrackStyle = false;
	      for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var key = _ref;
	
	        if (!nextProps.hasOwnProperty(key)) {
	          setTrackStyle = true;
	          break;
	        }
	        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
	          continue;
	        }
	        if (nextProps[key] !== _this.props[key]) {
	          setTrackStyle = true;
	          break;
	        }
	      }
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
	          _this.changeSlide({
	            message: "index",
	            index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
	            currentSlide: _this.state.currentSlide
	          });
	        }
	        if (nextProps.autoplay) {
	          _this.autoPlay("update");
	        } else {
	          _this.pause("paused");
	        }
	      });
	    };
	
	    _this.componentDidUpdate = function () {
	      _this.checkImagesLoad();
	      _this.props.onReInit && _this.props.onReInit();
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	      // if (this.props.onLazyLoad) {
	      //   this.props.onLazyLoad([leftMostSlide])
	      // }
	      _this.adaptHeight();
	    };
	
	    _this.onWindowResized = function (setTrackStyle) {
	      if (_this.debouncedResize) _this.debouncedResize.cancel();
	      _this.debouncedResize = (0, _lodash2.default)(function () {
	        return _this.resizeWindow(setTrackStyle);
	      }, 50);
	      _this.debouncedResize();
	    };
	
	    _this.resizeWindow = function () {
	      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (!_reactDom2.default.findDOMNode(_this.track)) return;
	      var spec = _extends({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props, _this.state);
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
	      });
	      // animating state should be cleared while resizing, otherwise autoplay stops working
	      _this.setState({
	        animating: false
	      });
	      clearTimeout(_this.animationEndCallback);
	      delete _this.animationEndCallback;
	    };
	
	    _this.updateState = function (spec, setTrackStyle, callback) {
	      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
	      spec = _extends({}, spec, updatedState, { slideIndex: updatedState.currentSlide });
	      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
	      spec = _extends({}, spec, { left: targetLeft });
	      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
	      if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
	        updatedState["trackStyle"] = trackStyle;
	      }
	      _this.setState(updatedState, callback);
	    };
	
	    _this.ssrInit = function () {
	      if (_this.props.variableWidth) {
	        var _trackWidth = 0,
	            _trackLeft = 0;
	        var childrenWidths = [];
	        var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	        var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	        _this.props.children.forEach(function (child) {
	          childrenWidths.push(child.props.style.width);
	          _trackWidth += child.props.style.width;
	        });
	        for (var i = 0; i < preClones; i++) {
	          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
	          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
	        }
	        for (var _i2 = 0; _i2 < postClones; _i2++) {
	          _trackWidth += childrenWidths[_i2];
	        }
	        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
	          _trackLeft += childrenWidths[_i3];
	        }
	        var _trackStyle = {
	          width: _trackWidth + "px",
	          left: -_trackLeft + "px"
	        };
	        if (_this.props.centerMode) {
	          var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
	          _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
	        }
	        _this.setState({
	          trackStyle: _trackStyle
	        });
	        return;
	      }
	      var childrenCount = _react2.default.Children.count(_this.props.children);
	      var spec = _extends({}, _this.props, _this.state, { slideCount: childrenCount });
	      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
	      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
	      var slideWidth = 100 / slideCount;
	      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
	      if (_this.props.centerMode) {
	        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
	      }
	      var trackStyle = {
	        width: trackWidth + "%",
	        left: trackLeft + "%"
	      };
	      _this.setState({
	        slideWidth: slideWidth + "%",
	        trackStyle: trackStyle
	      });
	    };
	
	    _this.checkImagesLoad = function () {
	      var images = document.querySelectorAll(".slick-slide img");
	      var imagesCount = images.length,
	          loadedCount = 0;
	      Array.prototype.forEach.call(images, function (image) {
	        var handler = function handler() {
	          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
	        };
	        if (!image.onclick) {
	          image.onclick = function () {
	            return image.parentNode.focus();
	          };
	        } else {
	          var prevClickHandler = image.onclick;
	          image.onclick = function () {
	            prevClickHandler();
	            image.parentNode.focus();
	          };
	        }
	        if (!image.onload) {
	          if (_this.props.lazyLoad) {
	            image.onload = function () {
	              _this.adaptHeight();
	              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
	            };
	          } else {
	            image.onload = handler;
	            image.onerror = function () {
	              handler();
	              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
	            };
	          }
	        }
	      });
	    };
	
	    _this.progressiveLazyLoad = function () {
	      var slidesToLoad = [];
	      var spec = _extends({}, _this.props, _this.state);
	      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
	        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
	          slidesToLoad.push(index);
	          break;
	        }
	      }
	      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
	        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
	          slidesToLoad.push(_index);
	          break;
	        }
	      }
	      if (slidesToLoad.length > 0) {
	        _this.setState(function (state) {
	          return {
	            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
	          };
	        });
	        if (_this.props.onLazyLoad) {
	          _this.props.onLazyLoad(slidesToLoad);
	        }
	      } else {
	        if (_this.lazyLoadTimer) {
	          clearInterval(_this.lazyLoadTimer);
	          delete _this.lazyLoadTimer;
	        }
	      }
	    };
	
	    _this.slideHandler = function (index) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var _this$props = _this.props,
	          asNavFor = _this$props.asNavFor,
	          beforeChange = _this$props.beforeChange,
	          onLazyLoad = _this$props.onLazyLoad,
	          speed = _this$props.speed,
	          afterChange = _this$props.afterChange;
	      // capture currentslide before state is updated
	
	      var currentSlide = _this.state.currentSlide;
	
	      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
	        index: index
	      }, _this.props, _this.state, {
	        trackRef: _this.track,
	        useCSS: _this.props.useCSS && !dontAnimate
	      })),
	          state = _slideHandler.state,
	          nextState = _slideHandler.nextState;
	
	      if (!state) return;
	      beforeChange && beforeChange(currentSlide, state.currentSlide);
	      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
	        return _this.state.lazyLoadedList.indexOf(value) < 0;
	      });
	      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
	      _this.setState(state, function () {
	        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
	        if (!nextState) return;
	        _this.animationEndCallback = setTimeout(function () {
	          var animating = nextState.animating,
	              firstBatch = _objectWithoutProperties(nextState, ["animating"]);
	
	          _this.setState(firstBatch, function () {
	            _this.callbackTimers.push(setTimeout(function () {
	              return _this.setState({ animating: animating });
	            }, 10));
	            afterChange && afterChange(state.currentSlide);
	            delete _this.animationEndCallback;
	          });
	        }, speed);
	      });
	    };
	
	    _this.changeSlide = function (options) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var spec = _extends({}, _this.props, _this.state);
	      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
	      if (targetSlide !== 0 && !targetSlide) return;
	      if (dontAnimate === true) {
	        _this.slideHandler(targetSlide, dontAnimate);
	      } else {
	        _this.slideHandler(targetSlide);
	      }
	    };
	
	    _this.clickHandler = function (e) {
	      if (_this.clickable === false) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	      _this.clickable = true;
	    };
	
	    _this.keyHandler = function (e) {
	      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
	      dir !== "" && _this.changeSlide({ message: dir });
	    };
	
	    _this.selectHandler = function (options) {
	      _this.changeSlide(options);
	    };
	
	    _this.disableBodyScroll = function () {
	      var preventDefault = function preventDefault(e) {
	        e = e || window.event;
	        if (e.preventDefault) e.preventDefault();
	        e.returnValue = false;
	      };
	      window.ontouchmove = preventDefault;
	    };
	
	    _this.enableBodyScroll = function () {
	      window.ontouchmove = null;
	    };
	
	    _this.swipeStart = function (e) {
	      if (_this.props.verticalSwiping) {
	        _this.disableBodyScroll();
	      }
	      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
	      state !== "" && _this.setState(state);
	    };
	
	    _this.swipeMove = function (e) {
	      var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      if (state["swiping"]) {
	        _this.clickable = false;
	      }
	      _this.setState(state);
	    };
	
	    _this.swipeEnd = function (e) {
	      var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      var triggerSlideHandler = state["triggerSlideHandler"];
	      delete state["triggerSlideHandler"];
	      _this.setState(state);
	      if (triggerSlideHandler === undefined) return;
	      _this.slideHandler(triggerSlideHandler);
	      if (_this.props.verticalSwiping) {
	        _this.enableBodyScroll();
	      }
	    };
	
	    _this.slickPrev = function () {
	      // this and fellow methods are wrapped in setTimeout
	      // to make sure initialize setState has happened before
	      // any of such methods are called
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({ message: "previous" });
	      }, 0));
	    };
	
	    _this.slickNext = function () {
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({ message: "next" });
	      }, 0));
	    };
	
	    _this.slickGoTo = function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      slide = Number(slide);
	      if (isNaN(slide)) return "";
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "index",
	          index: slide,
	          currentSlide: _this.state.currentSlide
	        }, dontAnimate);
	      }, 0));
	    };
	
	    _this.play = function () {
	      var nextIndex;
	      if (_this.props.rtl) {
	        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
	      } else {
	        if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
	          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
	        } else {
	          return false;
	        }
	      }
	
	      _this.slideHandler(nextIndex);
	    };
	
	    _this.autoPlay = function (playType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	      var autoplaying = _this.state.autoplaying;
	      if (playType === "update") {
	        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
	          return;
	        }
	      } else if (playType === "leave") {
	        if (autoplaying === "paused" || autoplaying === "focused") {
	          return;
	        }
	      } else if (playType === "blur") {
	        if (autoplaying === "paused" || autoplaying === "hovered") {
	          return;
	        }
	      }
	      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
	      _this.setState({ autoplaying: "playing" });
	    };
	
	    _this.pause = function (pauseType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	        _this.autoplayTimer = null;
	      }
	      var autoplaying = _this.state.autoplaying;
	      if (pauseType === "paused") {
	        _this.setState({ autoplaying: "paused" });
	      } else if (pauseType === "focused") {
	        if (autoplaying === "hovered" || autoplaying === "playing") {
	          _this.setState({ autoplaying: "focused" });
	        }
	      } else {
	        // pauseType  is 'hovered'
	        if (autoplaying === "playing") {
	          _this.setState({ autoplaying: "hovered" });
	        }
	      }
	    };
	
	    _this.onDotsOver = function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    };
	
	    _this.onDotsLeave = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    };
	
	    _this.onTrackOver = function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    };
	
	    _this.onTrackLeave = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    };
	
	    _this.onSlideFocus = function () {
	      return _this.props.autoplay && _this.pause("focused");
	    };
	
	    _this.onSlideBlur = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
	    };
	
	    _this.render = function () {
	      var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
	        "slick-vertical": _this.props.vertical,
	        "slick-initialized": true
	      });
	      var spec = _extends({}, _this.props, _this.state);
	      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
	      var pauseOnHover = _this.props.pauseOnHover;
	
	      trackProps = _extends({}, trackProps, {
	        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
	        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
	        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
	        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
	      });
	
	      var dots;
	      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
	        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
	        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
	
	        dotProps = _extends({}, dotProps, {
	          clickHandler: _this.changeSlide,
	          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
	          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
	          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
	        });
	        dots = _react2.default.createElement(_dots.Dots, dotProps);
	      }
	
	      var prevArrow, nextArrow;
	      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
	      arrowProps.clickHandler = _this.changeSlide;
	
	      if (_this.props.arrows) {
	        prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
	        nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
	      }
	
	      var verticalHeightStyle = null;
	
	      if (_this.props.vertical) {
	        verticalHeightStyle = {
	          height: _this.state.listHeight
	        };
	      }
	
	      var centerPaddingStyle = null;
	
	      if (_this.props.vertical === false) {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: "0px " + _this.props.centerPadding
	          };
	        }
	      } else {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: _this.props.centerPadding + " 0px"
	          };
	        }
	      }
	
	      var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);
	      var touchMove = _this.props.touchMove;
	      var listProps = {
	        className: "slick-list",
	        style: listStyle,
	        onClick: _this.clickHandler,
	        onMouseDown: touchMove ? _this.swipeStart : null,
	        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onMouseUp: touchMove ? _this.swipeEnd : null,
	        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onTouchStart: touchMove ? _this.swipeStart : null,
	        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onTouchEnd: touchMove ? _this.swipeEnd : null,
	        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
	      };
	
	      var innerSliderProps = {
	        className: className,
	        dir: "ltr"
	      };
	
	      if (_this.props.unslick) {
	        listProps = { className: "slick-list" };
	        innerSliderProps = { className: className };
	      }
	      return _react2.default.createElement(
	        "div",
	        innerSliderProps,
	        !_this.props.unslick ? prevArrow : "",
	        _react2.default.createElement(
	          "div",
	          _extends({ ref: _this.listRefHandler }, listProps),
	          _react2.default.createElement(
	            _track.Track,
	            _extends({ ref: _this.trackRefHandler }, trackProps),
	            _this.props.children
	          )
	        ),
	        !_this.props.unslick ? nextArrow : "",
	        !_this.props.unslick ? dots : ""
	      );
	    };
	
	    _this.list = null;
	    _this.track = null;
	    _this.state = _extends({}, _initialState2.default, {
	      currentSlide: _this.props.initialSlide,
	      slideCount: _react2.default.Children.count(_this.props.children)
	    });
	    _this.callbackTimers = [];
	    _this.clickable = true;
	    _this.debouncedResize = null;
	    return _this;
	  }
	
	  return InnerSlider;
	}(_react2.default.Component);

/***/ },
/* 1964 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _innerSlider = __webpack_require__(1963);
	
	var _json2mq = __webpack_require__(1834);
	
	var _json2mq2 = _interopRequireDefault(_json2mq);
	
	var _defaultProps = __webpack_require__(1960);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _innerSliderUtils = __webpack_require__(552);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(1663);
	
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.innerSliderRefHandler = function (ref) {
	      return _this.innerSlider = ref;
	    };
	
	    _this.slickPrev = function () {
	      return _this.innerSlider.slickPrev();
	    };
	
	    _this.slickNext = function () {
	      return _this.innerSlider.slickNext();
	    };
	
	    _this.slickGoTo = function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      return _this.innerSlider.slickGoTo(slide, dontAnimate);
	    };
	
	    _this.slickPause = function () {
	      return _this.innerSlider.pause("paused");
	    };
	
	    _this.slickPlay = function () {
	      return _this.innerSlider.autoPlay("play");
	    };
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    return _this;
	  }
	
	  Slider.prototype.media = function media(query, handler) {
	    // javascript handler for  css media query
	    enquire.register(query, handler);
	    this._responsiveMediaHandlers.push({ query: query, handler: handler });
	  };
	
	  // handles responsive breakpoints
	
	
	  Slider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    // performance monitoring
	    //if (process.env.NODE_ENV !== 'production') {
	    //const { whyDidYouUpdate } = require('why-did-you-update')
	    //whyDidYouUpdate(React)
	    //}
	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      // sort them in increasing order of their numerical value
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });
	
	      breakpoints.forEach(function (breakpoint, index) {
	        // media query for each breakpoint
	        var bQuery = void 0;
	        if (index === 0) {
	          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2.default)({
	            minWidth: breakpoints[index - 1] + 1,
	            maxWidth: breakpoint
	          });
	        }
	        // when not using server side rendering
	        (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
	          _this2.setState({ breakpoint: breakpoint });
	        });
	      });
	
	      // Register media query for full screen. Need to support resize from small to large
	      // convert javascript object to media query string
	      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });
	
	      (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
	        _this2.setState({ breakpoint: null });
	      });
	    }
	  };
	
	  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._responsiveMediaHandlers.forEach(function (obj) {
	      enquire.unregister(obj.query, obj.handler);
	    });
	  };
	
	  Slider.prototype.render = function render() {
	    var _this3 = this;
	
	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this3.state.breakpoint;
	      });
	      settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
	    } else {
	      settings = _extends({}, _defaultProps2.default, this.props);
	    }
	
	    // force scrolling by one if centerMode is on
	    if (settings.centerMode) {
	      if (settings.slidesToScroll > 1 && ("production") !== "production") {
	        console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
	      }
	      settings.slidesToScroll = 1;
	    }
	    // force showing one slide and scrolling by one if the fade mode is on
	    if (settings.fade) {
	      if (settings.slidesToShow > 1 && ("production") !== "production") {
	        console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
	      }
	      if (settings.slidesToScroll > 1 && ("production") !== "production") {
	        console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
	      }
	      settings.slidesToShow = 1;
	      settings.slidesToScroll = 1;
	    }
	
	    // makes sure that children is an array, even when there is only 1 child
	    var children = _react2.default.Children.toArray(this.props.children);
	
	    // Children may contain false or null, so we should filter them
	    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
	    children = children.filter(function (child) {
	      if (typeof child === "string") {
	        return !!child.trim();
	      }
	      return !!child;
	    });
	
	    // rows and slidesPerRow logic is handled here
	    if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
	      console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
	      settings.variableWidth = false;
	    }
	    var newChildren = [];
	    var currentWidth = null;
	    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
	      var newSlide = [];
	      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
	        var row = [];
	        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
	          if (settings.variableWidth && children[k].props.style) {
	            currentWidth = children[k].props.style.width;
	          }
	          if (k >= children.length) break;
	          row.push(_react2.default.cloneElement(children[k], {
	            key: 100 * i + 10 * j + k,
	            tabIndex: -1,
	            style: {
	              width: 100 / settings.slidesPerRow + "%",
	              display: "inline-block"
	            }
	          }));
	        }
	        newSlide.push(_react2.default.createElement(
	          "div",
	          { key: 10 * i + j },
	          row
	        ));
	      }
	      if (settings.variableWidth) {
	        newChildren.push(_react2.default.createElement(
	          "div",
	          { key: i, style: { width: currentWidth } },
	          newSlide
	        ));
	      } else {
	        newChildren.push(_react2.default.createElement(
	          "div",
	          { key: i },
	          newSlide
	        ));
	      }
	    }
	
	    if (settings === "unslick") {
	      var className = "regular slider " + (this.props.className || "");
	      return _react2.default.createElement(
	        "div",
	        { className: className },
	        newChildren
	      );
	    } else if (newChildren.length <= settings.slidesToShow) {
	      settings.unslick = true;
	    }
	    return _react2.default.createElement(
	      _innerSlider.InnerSlider,
	      _extends({ ref: this.innerSliderRefHandler }, settings),
	      newChildren
	    );
	  };
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;

/***/ },
/* 1965 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Track = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(61);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(552);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  var slickCurrent = index === spec.currentSlide;
	  return {
	    "slick-slide": true,
	    "slick-active": slickActive,
	    "slick-center": slickCenter,
	    "slick-cloned": slickCloned,
	    "slick-current": slickCurrent // dubious in case of RTL
	  };
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = "relative";
	    if (spec.vertical) {
	      style.top = -spec.index * parseInt(spec.slideHeight);
	    } else {
	      style.left = -spec.index * parseInt(spec.slideWidth);
	    }
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  return child.key || fallbackKey;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var childrenCount = _react2.default.Children.count(spec.children);
	  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
	  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);
	
	  _react2.default.Children.forEach(spec.children, function (elem, index) {
	    var child = void 0;
	    var childOnClickOptions = {
	      message: "children",
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };
	
	    // in case of lazyLoad, whether or not we want to fetch the slide
	    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
	      child = elem;
	    } else {
	      child = _react2.default.createElement("div", null);
	    }
	    var childStyle = getSlideStyle(_extends({}, spec, { index: index }));
	    var slideClass = child.props.className || "";
	    var slideClasses = getSlideClasses(_extends({}, spec, { index: index }));
	    // push a cloned element of the desired slide
	    slides.push(_react2.default.cloneElement(child, {
	      key: "original" + getKey(child, index),
	      "data-index": index,
	      className: (0, _classnames2.default)(slideClasses, slideClass),
	      tabIndex: "-1",
	      "aria-hidden": !slideClasses["slick-active"],
	      style: _extends({ outline: "none" }, child.props.style || {}, childStyle),
	      onClick: function onClick(e) {
	        child.props && child.props.onClick && child.props.onClick(e);
	        if (spec.focusOnSelect) {
	          spec.focusOnSelect(childOnClickOptions);
	        }
	      }
	    }));
	
	    // if slide needs to be precloned or postcloned
	    if (spec.infinite && spec.fade === false) {
	      var preCloneNo = childrenCount - index;
	      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
	        key = -preCloneNo;
	        if (key >= startIndex) {
	          child = elem;
	        }
	        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
	        preCloneSlides.push(_react2.default.cloneElement(child, {
	          key: "precloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames2.default)(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _extends({}, child.props.style || {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	
	      if (childrenCount !== spec.slidesToShow) {
	        key = childrenCount + index;
	        if (key < endIndex) {
	          child = elem;
	        }
	        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
	        postCloneSlides.push(_react2.default.cloneElement(child, {
	          key: "postcloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames2.default)(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _extends({}, child.props.style || {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = exports.Track = function (_React$PureComponent) {
	  _inherits(Track, _React$PureComponent);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Track.prototype.render = function render() {
	    var slides = renderSlides(this.props);
	    var _props = this.props,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseOver = _props.onMouseOver,
	        onMouseLeave = _props.onMouseLeave;
	
	    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
	    return _react2.default.createElement(
	      "div",
	      _extends({
	        className: "slick-track",
	        style: this.props.trackStyle
	      }, mouseEvents),
	      slides
	    );
	  };
	
	  return Track;
	}(_react2.default.PureComponent);

/***/ },
/* 1966 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(1956);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _AutoSizer = __webpack_require__(1970);
	
	var _AutoSizer2 = _interopRequireDefault(_AutoSizer);
	
	var _List = __webpack_require__(1979);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Import directly to avoid Webpack bundling the parts of react-virtualized that we are not using
	
	
	var VirtualizedSelect = function (_Component) {
	  _inherits(VirtualizedSelect, _Component);
	
	  function VirtualizedSelect(props, context) {
	    _classCallCheck(this, VirtualizedSelect);
	
	    var _this = _possibleConstructorReturn(this, (VirtualizedSelect.__proto__ || Object.getPrototypeOf(VirtualizedSelect)).call(this, props, context));
	
	    _this._renderMenu = _this._renderMenu.bind(_this);
	    _this._optionRenderer = _this._optionRenderer.bind(_this);
	    return _this;
	  }
	
	  /** See List#recomputeRowHeights */
	
	
	  _createClass(VirtualizedSelect, [{
	    key: 'recomputeOptionHeights',
	    value: function recomputeOptionHeights() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      if (this._virtualScroll) {
	        this._virtualScroll.recomputeRowHeights(index);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var SelectComponent = this._getSelectComponent();
	
	      return _react2.default.createElement(SelectComponent, _extends({}, this.props, {
	        menuRenderer: this._renderMenu,
	        menuStyle: { overflow: 'hidden' }
	      }));
	    }
	
	    // See https://github.com/JedWatson/react-select/#effeciently-rendering-large-lists-with-windowing
	
	  }, {
	    key: '_renderMenu',
	    value: function _renderMenu(_ref) {
	      var _this2 = this;
	
	      var focusedOption = _ref.focusedOption;
	      var focusOption = _ref.focusOption;
	      var labelKey = _ref.labelKey;
	      var onSelect = _ref.onSelect;
	      var options = _ref.options;
	      var selectValue = _ref.selectValue;
	      var valueArray = _ref.valueArray;
	      var _props = this.props;
	      var listProps = _props.listProps;
	      var optionRenderer = _props.optionRenderer;
	
	      var focusedOptionIndex = options.indexOf(focusedOption);
	      var height = this._calculateListHeight({ options: options });
	      var innerRowRenderer = optionRenderer || this._optionRenderer;
	
	      // react-select 1.0.0-rc2 passes duplicate `onSelect` and `selectValue` props to `menuRenderer`
	      // The `Creatable` HOC only overrides `onSelect` which breaks an edge-case
	      // In order to support creating items via clicking on the placeholder option,
	      // We need to ensure that the specified `onSelect` handle is the one we use.
	      // See issue #33
	
	      function wrappedRowRenderer(_ref2) {
	        var index = _ref2.index;
	        var key = _ref2.key;
	        var style = _ref2.style;
	
	        var option = options[index];
	
	        return innerRowRenderer({
	          focusedOption: focusedOption,
	          focusedOptionIndex: focusedOptionIndex,
	          focusOption: focusOption,
	          key: key,
	          labelKey: labelKey,
	          onSelect: onSelect,
	          option: option,
	          optionIndex: index,
	          options: options,
	          selectValue: onSelect,
	          style: style,
	          valueArray: valueArray
	        });
	      }
	
	      return _react2.default.createElement(
	        _AutoSizer2.default,
	        { disableHeight: true },
	        function (_ref3) {
	          var width = _ref3.width;
	          return _react2.default.createElement(_List2.default, _extends({
	            className: 'VirtualSelectGrid',
	            height: height,
	            ref: function ref(_ref5) {
	              return _this2._virtualScroll = _ref5;
	            },
	            rowCount: options.length,
	            rowHeight: function rowHeight(_ref4) {
	              var index = _ref4.index;
	              return _this2._getOptionHeight({
	                option: options[index]
	              });
	            },
	            rowRenderer: wrappedRowRenderer,
	            scrollToIndex: focusedOptionIndex,
	            width: width
	          }, listProps));
	        }
	      );
	    }
	  }, {
	    key: '_calculateListHeight',
	    value: function _calculateListHeight(_ref6) {
	      var options = _ref6.options;
	      var maxHeight = this.props.maxHeight;
	
	
	      var height = 0;
	
	      for (var optionIndex = 0; optionIndex < options.length; optionIndex++) {
	        var option = options[optionIndex];
	
	        height += this._getOptionHeight({ option: option });
	
	        if (height > maxHeight) {
	          return maxHeight;
	        }
	      }
	
	      return height;
	    }
	  }, {
	    key: '_getOptionHeight',
	    value: function _getOptionHeight(_ref7) {
	      var option = _ref7.option;
	      var optionHeight = this.props.optionHeight;
	
	
	      return optionHeight instanceof Function ? optionHeight({ option: option }) : optionHeight;
	    }
	  }, {
	    key: '_getSelectComponent',
	    value: function _getSelectComponent() {
	      var _props2 = this.props;
	      var async = _props2.async;
	      var selectComponent = _props2.selectComponent;
	
	
	      if (selectComponent) {
	        return selectComponent;
	      } else if (async) {
	        return _reactSelect2.default.Async;
	      } else {
	        return _reactSelect2.default;
	      }
	    }
	  }, {
	    key: '_optionRenderer',
	    value: function _optionRenderer(_ref8) {
	      var focusedOption = _ref8.focusedOption;
	      var focusOption = _ref8.focusOption;
	      var key = _ref8.key;
	      var labelKey = _ref8.labelKey;
	      var option = _ref8.option;
	      var selectValue = _ref8.selectValue;
	      var style = _ref8.style;
	
	      var className = ['VirtualizedSelectOption'];
	
	      if (option === focusedOption) {
	        className.push('VirtualizedSelectFocusedOption');
	      }
	
	      if (option.disabled) {
	        className.push('VirtualizedSelectDisabledOption');
	      }
	
	      var events = option.disabled ? {} : {
	        onClick: function onClick() {
	          return selectValue(option);
	        },
	        onMouseOver: function onMouseOver() {
	          return focusOption(option);
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        _extends({
	          className: className.join(' '),
	          key: key,
	          style: style
	        }, events),
	        option[labelKey]
	      );
	    }
	  }]);
	
	  return VirtualizedSelect;
	}(_react.Component);
	
	VirtualizedSelect.propTypes = {
	  async: _react.PropTypes.bool,
	  listProps: _react.PropTypes.object,
	  maxHeight: _react.PropTypes.number.isRequired,
	  optionHeight: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.func]).isRequired,
	  optionRenderer: _react.PropTypes.func,
	  selectComponent: _react.PropTypes.func
	};
	VirtualizedSelect.defaultProps = {
	  async: false,
	  maxHeight: 200,
	  optionHeight: 35
	};
	exports.default = VirtualizedSelect;

/***/ },
/* 1967 */
[2102, 1966],
/* 1968 */
[2102, 1967],
/* 1969 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(655);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _detectElementResize = __webpack_require__(1981);
	
	var _detectElementResize2 = _interopRequireDefault(_detectElementResize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Decorator component that automatically adjusts the width and height of a single child.
	 * Child component should not be declared as a child but should rather be specified by a `ChildComponent` property.
	 * All other properties will be passed through to the child component.
	 */
	var AutoSizer = function (_Component) {
	  _inherits(AutoSizer, _Component);
	
	  function AutoSizer(props) {
	    _classCallCheck(this, AutoSizer);
	
	    var _this = _possibleConstructorReturn(this, (AutoSizer.__proto__ || Object.getPrototypeOf(AutoSizer)).call(this, props));
	
	    _this.state = {
	      height: 0,
	      width: 0
	    };
	
	    _this._onResize = _this._onResize.bind(_this);
	    _this._setRef = _this._setRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(AutoSizer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Delay access of parentNode until mount.
	      // This handles edge-cases where the component has already been unmounted before its ref has been set,
	      // As well as libraries like react-lite which have a slightly different lifecycle.
	      this._parentNode = this._autoSizer.parentNode;
	
	      // Defer requiring resize handler in order to support server-side rendering.
	      // See issue #41
	      this._detectElementResize = (0, _detectElementResize2.default)();
	      this._detectElementResize.addResizeListener(this._parentNode, this._onResize);
	
	      this._onResize();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._detectElementResize) {
	        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var disableHeight = _props.disableHeight;
	      var disableWidth = _props.disableWidth;
	      var _state = this.state;
	      var height = _state.height;
	      var width = _state.width;
	
	      // Outer div should not force width/height since that may prevent containers from shrinking.
	      // Inner component should overflow and use calculated width/height.
	      // See issue #68 for more information.
	
	      var outerStyle = { overflow: 'visible' };
	
	      if (!disableHeight) {
	        outerStyle.height = 0;
	      }
	
	      if (!disableWidth) {
	        outerStyle.width = 0;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: this._setRef,
	          style: outerStyle
	        },
	        children({ height: height, width: width })
	      );
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_onResize',
	    value: function _onResize() {
	      var onResize = this.props.onResize;
	
	      // Gaurd against AutoSizer component being removed from the DOM immediately after being added.
	      // This can result in invalid style values which can result in NaN values if we don't handle them.
	      // See issue #150 for more context.
	
	      var boundingRect = this._parentNode.getBoundingClientRect();
	      var height = boundingRect.height || 0;
	      var width = boundingRect.width || 0;
	
	      var style = window.getComputedStyle(this._parentNode) || {};
	      var paddingLeft = parseInt(style.paddingLeft, 10) || 0;
	      var paddingRight = parseInt(style.paddingRight, 10) || 0;
	      var paddingTop = parseInt(style.paddingTop, 10) || 0;
	      var paddingBottom = parseInt(style.paddingBottom, 10) || 0;
	
	      this.setState({
	        height: height - paddingTop - paddingBottom,
	        width: width - paddingLeft - paddingRight
	      });
	
	      onResize({ height: height, width: width });
	    }
	  }, {
	    key: '_setRef',
	    value: function _setRef(autoSizer) {
	      this._autoSizer = autoSizer;
	    }
	  }]);
	
	  return AutoSizer;
	}(_react.Component);
	
	AutoSizer.defaultProps = {
	  onResize: function onResize() {}
	};
	exports.default = AutoSizer;
	 false ? AutoSizer.propTypes = {
	  /**
	  * Function responsible for rendering children.
	  * This function should implement the following signature:
	  * ({ height, width }) => PropTypes.element
	  */
	  children: _react.PropTypes.func.isRequired,
	
	  /** Disable dynamic :height property */
	  disableHeight: _react.PropTypes.bool,
	
	  /** Disable dynamic :width property */
	  disableWidth: _react.PropTypes.bool,
	
	  /** Callback to be invoked on-resize: ({ height, width }) */
	  onResize: _react.PropTypes.func.isRequired
	} : void 0;

/***/ },
/* 1970 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AutoSizer = exports.default = undefined;
	
	var _AutoSizer2 = __webpack_require__(1969);
	
	var _AutoSizer3 = _interopRequireDefault(_AutoSizer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AutoSizer3.default;
	exports.AutoSizer = _AutoSizer3.default;

/***/ },
/* 1971 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(61);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _calculateSizeAndPositionDataAndUpdateScrollOffset = __webpack_require__(1975);
	
	var _calculateSizeAndPositionDataAndUpdateScrollOffset2 = _interopRequireDefault(_calculateSizeAndPositionDataAndUpdateScrollOffset);
	
	var _ScalingCellSizeAndPositionManager = __webpack_require__(1974);
	
	var _ScalingCellSizeAndPositionManager2 = _interopRequireDefault(_ScalingCellSizeAndPositionManager);
	
	var _createCallbackMemoizer = __webpack_require__(1980);
	
	var _createCallbackMemoizer2 = _interopRequireDefault(_createCallbackMemoizer);
	
	var _getOverscanIndices = __webpack_require__(1976);
	
	var _getOverscanIndices2 = _interopRequireDefault(_getOverscanIndices);
	
	var _scrollbarSize = __webpack_require__(1659);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _reactAddonsShallowCompare = __webpack_require__(655);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _updateScrollIndexHelper = __webpack_require__(1977);
	
	var _updateScrollIndexHelper2 = _interopRequireDefault(_updateScrollIndexHelper);
	
	var _defaultCellRangeRenderer = __webpack_require__(923);
	
	var _defaultCellRangeRenderer2 = _interopRequireDefault(_defaultCellRangeRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
	 * This improves performance and makes scrolling smoother.
	 */
	var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
	
	/**
	 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
	 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
	 */
	var SCROLL_POSITION_CHANGE_REASONS = {
	  OBSERVED: 'observed',
	  REQUESTED: 'requested'
	};
	
	/**
	 * Renders tabular data with virtualization along the vertical and horizontal axes.
	 * Row heights and column widths must be known ahead of time and specified as properties.
	 */
	
	var Grid = function (_Component) {
	  _inherits(Grid, _Component);
	
	  function Grid(props, context) {
	    _classCallCheck(this, Grid);
	
	    var _this = _possibleConstructorReturn(this, (Grid.__proto__ || Object.getPrototypeOf(Grid)).call(this, props, context));
	
	    _this.state = {
	      isScrolling: false,
	      scrollDirectionHorizontal: _getOverscanIndices.SCROLL_DIRECTION_FORWARD,
	      scrollDirectionVertical: _getOverscanIndices.SCROLL_DIRECTION_FORWARD,
	      scrollLeft: 0,
	      scrollTop: 0
	    };
	
	    // Invokes onSectionRendered callback only when start/stop row or column indices change
	    _this._onGridRenderedMemoizer = (0, _createCallbackMemoizer2.default)();
	    _this._onScrollMemoizer = (0, _createCallbackMemoizer2.default)(false);
	
	    // Bind functions to instance so they don't lose context when passed around
	    _this._enablePointerEventsAfterDelayCallback = _this._enablePointerEventsAfterDelayCallback.bind(_this);
	    _this._invokeOnGridRenderedHelper = _this._invokeOnGridRenderedHelper.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._updateScrollLeftForScrollToColumn = _this._updateScrollLeftForScrollToColumn.bind(_this);
	    _this._updateScrollTopForScrollToRow = _this._updateScrollTopForScrollToRow.bind(_this);
	
	    _this._columnWidthGetter = _this._wrapSizeGetter(props.columnWidth);
	    _this._rowHeightGetter = _this._wrapSizeGetter(props.rowHeight);
	
	    _this._columnSizeAndPositionManager = new _ScalingCellSizeAndPositionManager2.default({
	      cellCount: props.columnCount,
	      cellSizeGetter: function cellSizeGetter(index) {
	        return _this._columnWidthGetter(index);
	      },
	      estimatedCellSize: _this._getEstimatedColumnSize(props)
	    });
	    _this._rowSizeAndPositionManager = new _ScalingCellSizeAndPositionManager2.default({
	      cellCount: props.rowCount,
	      cellSizeGetter: function cellSizeGetter(index) {
	        return _this._rowHeightGetter(index);
	      },
	      estimatedCellSize: _this._getEstimatedRowSize(props)
	    });
	
	    // See defaultCellRangeRenderer() for more information on the usage of this cache
	    _this._cellCache = {};
	    return _this;
	  }
	
	  /**
	   * Pre-measure all columns and rows in a Grid.
	   * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
	   * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
	   */
	
	
	  _createClass(Grid, [{
	    key: 'measureAllCells',
	    value: function measureAllCells() {
	      var _props = this.props;
	      var columnCount = _props.columnCount;
	      var rowCount = _props.rowCount;
	
	
	      this._columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
	      this._rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
	    }
	
	    /**
	     * Forced recompute of row heights and column widths.
	     * This function should be called if dynamic column or row sizes have changed but nothing else has.
	     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
	     */
	
	  }, {
	    key: 'recomputeGridSize',
	    value: function recomputeGridSize() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var _ref$columnIndex = _ref.columnIndex;
	      var columnIndex = _ref$columnIndex === undefined ? 0 : _ref$columnIndex;
	      var _ref$rowIndex = _ref.rowIndex;
	      var rowIndex = _ref$rowIndex === undefined ? 0 : _ref$rowIndex;
	
	      this._columnSizeAndPositionManager.resetCell(columnIndex);
	      this._rowSizeAndPositionManager.resetCell(rowIndex);
	
	      // Clear cell cache in case we are scrolling;
	      // Invalid row heights likely mean invalid cached content as well.
	      this._cellCache = {};
	
	      this.forceUpdate();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props2 = this.props;
	      var scrollLeft = _props2.scrollLeft;
	      var scrollToColumn = _props2.scrollToColumn;
	      var scrollTop = _props2.scrollTop;
	      var scrollToRow = _props2.scrollToRow;
	
	      // If this component was first rendered server-side, scrollbar size will be undefined.
	      // In that event we need to remeasure.
	
	      if (!this._scrollbarSizeMeasured) {
	        this._scrollbarSize = (0, _scrollbarSize2.default)();
	        this._scrollbarSizeMeasured = true;
	        this.setState({});
	      }
	
	      if (scrollLeft >= 0 || scrollTop >= 0) {
	        this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
	      }
	
	      if (scrollToColumn >= 0 || scrollToRow >= 0) {
	        this._updateScrollLeftForScrollToColumn();
	        this._updateScrollTopForScrollToRow();
	      }
	
	      // Update onRowsRendered callback
	      this._invokeOnGridRenderedHelper();
	
	      // Initialize onScroll callback
	      this._invokeOnScrollMemoizer({
	        scrollLeft: scrollLeft || 0,
	        scrollTop: scrollTop || 0,
	        totalColumnsWidth: this._columnSizeAndPositionManager.getTotalSize(),
	        totalRowsHeight: this._rowSizeAndPositionManager.getTotalSize()
	      });
	    }
	
	    /**
	     * @private
	     * This method updates scrollLeft/scrollTop in state for the following conditions:
	     * 1) New scroll-to-cell props have been set
	     */
	
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this2 = this;
	
	      var _props3 = this.props;
	      var autoHeight = _props3.autoHeight;
	      var columnCount = _props3.columnCount;
	      var height = _props3.height;
	      var rowCount = _props3.rowCount;
	      var scrollToAlignment = _props3.scrollToAlignment;
	      var scrollToColumn = _props3.scrollToColumn;
	      var scrollToRow = _props3.scrollToRow;
	      var width = _props3.width;
	      var _state = this.state;
	      var scrollLeft = _state.scrollLeft;
	      var scrollPositionChangeReason = _state.scrollPositionChangeReason;
	      var scrollTop = _state.scrollTop;
	
	      // Handle edge case where column or row count has only just increased over 0.
	      // In this case we may have to restore a previously-specified scroll offset.
	      // For more info see bvaughn/react-virtualized/issues/218
	
	      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;
	
	      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
	      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
	      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
	      // So we only set these when we require an adjustment of the scroll position.
	      // See issue #2 for more information.
	      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
	        if (scrollLeft >= 0 && (scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
	          this._scrollingContainer.scrollLeft = scrollLeft;
	        }
	
	        // @TRICKY :autoHeight property instructs Grid to leave :scrollTop management to an external HOC (eg WindowScroller).
	        // In this case we should avoid checking scrollingContainer.scrollTop since it forces layout/flow.
	        if (!autoHeight && scrollTop >= 0 && (scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
	          this._scrollingContainer.scrollTop = scrollTop;
	        }
	      }
	
	      // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
	      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
	      (0, _updateScrollIndexHelper2.default)({
	        cellSizeAndPositionManager: this._columnSizeAndPositionManager,
	        previousCellsCount: prevProps.columnCount,
	        previousCellSize: prevProps.columnWidth,
	        previousScrollToAlignment: prevProps.scrollToAlignment,
	        previousScrollToIndex: prevProps.scrollToColumn,
	        previousSize: prevProps.width,
	        scrollOffset: scrollLeft,
	        scrollToAlignment: scrollToAlignment,
	        scrollToIndex: scrollToColumn,
	        size: width,
	        updateScrollIndexCallback: function updateScrollIndexCallback(scrollToColumn) {
	          return _this2._updateScrollLeftForScrollToColumn(_extends({}, _this2.props, { scrollToColumn: scrollToColumn }));
	        }
	      });
	      (0, _updateScrollIndexHelper2.default)({
	        cellSizeAndPositionManager: this._rowSizeAndPositionManager,
	        previousCellsCount: prevProps.rowCount,
	        previousCellSize: prevProps.rowHeight,
	        previousScrollToAlignment: prevProps.scrollToAlignment,
	        previousScrollToIndex: prevProps.scrollToRow,
	        previousSize: prevProps.height,
	        scrollOffset: scrollTop,
	        scrollToAlignment: scrollToAlignment,
	        scrollToIndex: scrollToRow,
	        size: height,
	        updateScrollIndexCallback: function updateScrollIndexCallback(scrollToRow) {
	          return _this2._updateScrollTopForScrollToRow(_extends({}, _this2.props, { scrollToRow: scrollToRow }));
	        }
	      });
	
	      // Update onRowsRendered callback if start/stop indices have changed
	      this._invokeOnGridRenderedHelper();
	
	      // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
	      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
	        var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
	        var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
	
	        this._invokeOnScrollMemoizer({ scrollLeft: scrollLeft, scrollTop: scrollTop, totalColumnsWidth: totalColumnsWidth, totalRowsHeight: totalRowsHeight });
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // If this component is being rendered server-side, getScrollbarSize() will return undefined.
	      // We handle this case in componentDidMount()
	      this._scrollbarSize = (0, _scrollbarSize2.default)();
	      if (this._scrollbarSize === undefined) {
	        this._scrollbarSizeMeasured = false;
	        this._scrollbarSize = 0;
	      } else {
	        this._scrollbarSizeMeasured = true;
	      }
	
	      this._calculateChildrenToRender();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._disablePointerEventsTimeoutId) {
	        clearTimeout(this._disablePointerEventsTimeoutId);
	      }
	    }
	
	    /**
	     * @private
	     * This method updates scrollLeft/scrollTop in state for the following conditions:
	     * 1) Empty content (0 rows or columns)
	     * 2) New scroll props overriding the current state
	     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
	     */
	
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      var _this3 = this;
	
	      if (nextProps.columnCount === 0 && nextState.scrollLeft !== 0 || nextProps.rowCount === 0 && nextState.scrollTop !== 0) {
	        this._setScrollPosition({
	          scrollLeft: 0,
	          scrollTop: 0
	        });
	      } else if (nextProps.scrollLeft !== this.props.scrollLeft || nextProps.scrollTop !== this.props.scrollTop) {
	        this._setScrollPosition({
	          scrollLeft: nextProps.scrollLeft,
	          scrollTop: nextProps.scrollTop
	        });
	      }
	
	      this._columnWidthGetter = this._wrapSizeGetter(nextProps.columnWidth);
	      this._rowHeightGetter = this._wrapSizeGetter(nextProps.rowHeight);
	
	      this._columnSizeAndPositionManager.configure({
	        cellCount: nextProps.columnCount,
	        estimatedCellSize: this._getEstimatedColumnSize(nextProps)
	      });
	      this._rowSizeAndPositionManager.configure({
	        cellCount: nextProps.rowCount,
	        estimatedCellSize: this._getEstimatedRowSize(nextProps)
	      });
	
	      // Update scroll offsets if the size or number of cells have changed, invalidating the previous value
	      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
	        cellCount: this.props.columnCount,
	        cellSize: this.props.columnWidth,
	        computeMetadataCallback: function computeMetadataCallback() {
	          return _this3._columnSizeAndPositionManager.resetCell(0);
	        },
	        computeMetadataCallbackProps: nextProps,
	        nextCellsCount: nextProps.columnCount,
	        nextCellSize: nextProps.columnWidth,
	        nextScrollToIndex: nextProps.scrollToColumn,
	        scrollToIndex: this.props.scrollToColumn,
	        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
	          return _this3._updateScrollLeftForScrollToColumn(nextProps, nextState);
	        }
	      });
	      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
	        cellCount: this.props.rowCount,
	        cellSize: this.props.rowHeight,
	        computeMetadataCallback: function computeMetadataCallback() {
	          return _this3._rowSizeAndPositionManager.resetCell(0);
	        },
	        computeMetadataCallbackProps: nextProps,
	        nextCellsCount: nextProps.rowCount,
	        nextCellSize: nextProps.rowHeight,
	        nextScrollToIndex: nextProps.scrollToRow,
	        scrollToIndex: this.props.scrollToRow,
	        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
	          return _this3._updateScrollTopForScrollToRow(nextProps, nextState);
	        }
	      });
	
	      this._calculateChildrenToRender(nextProps, nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props4 = this.props;
	      var autoContainerWidth = _props4.autoContainerWidth;
	      var autoHeight = _props4.autoHeight;
	      var className = _props4.className;
	      var containerStyle = _props4.containerStyle;
	      var height = _props4.height;
	      var id = _props4.id;
	      var noContentRenderer = _props4.noContentRenderer;
	      var style = _props4.style;
	      var tabIndex = _props4.tabIndex;
	      var width = _props4.width;
	      var isScrolling = this.state.isScrolling;
	
	
	      var gridStyle = {
	        boxSizing: 'border-box',
	        direction: 'ltr',
	        height: autoHeight ? 'auto' : height,
	        position: 'relative',
	        width: width,
	        WebkitOverflowScrolling: 'touch',
	        willChange: 'transform'
	      };
	
	      var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
	      var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
	
	      // Force browser to hide scrollbars when we know they aren't necessary.
	      // Otherwise once scrollbars appear they may not disappear again.
	      // For more info see issue #116
	      var verticalScrollBarSize = totalRowsHeight > height ? this._scrollbarSize : 0;
	      var horizontalScrollBarSize = totalColumnsWidth > width ? this._scrollbarSize : 0;
	
	      // Also explicitly init styles to 'auto' if scrollbars are required.
	      // This works around an obscure edge case where external CSS styles have not yet been loaded,
	      // But an initial scroll index of offset is set as an external prop.
	      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
	      // This was originally reported via clauderic/react-infinite-calendar/issues/23
	      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
	      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
	
	      var childrenToDisplay = this._childrenToDisplay;
	
	      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: function ref(_ref2) {
	            _this4._scrollingContainer = _ref2;
	          },
	          'aria-label': this.props['aria-label'],
	          className: (0, _classnames2.default)('ReactVirtualized__Grid', className),
	          id: id,
	          onScroll: this._onScroll,
	          role: 'grid',
	          style: _extends({}, gridStyle, style),
	          tabIndex: tabIndex
	        },
	        childrenToDisplay.length > 0 && _react2.default.createElement(
	          'div',
	          {
	            className: 'ReactVirtualized__Grid__innerScrollContainer',
	            style: _extends({
	              width: autoContainerWidth ? 'auto' : totalColumnsWidth,
	              height: totalRowsHeight,
	              maxWidth: totalColumnsWidth,
	              maxHeight: totalRowsHeight,
	              overflow: 'hidden',
	              pointerEvents: isScrolling ? 'none' : ''
	            }, containerStyle)
	          },
	          childrenToDisplay
	        ),
	        showNoContentRenderer && noContentRenderer()
	      );
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	
	    /* ---------------------------- Helper methods ---------------------------- */
	
	  }, {
	    key: '_calculateChildrenToRender',
	    value: function _calculateChildrenToRender() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	      var cellRenderer = props.cellRenderer;
	      var cellRangeRenderer = props.cellRangeRenderer;
	      var columnCount = props.columnCount;
	      var height = props.height;
	      var overscanColumnCount = props.overscanColumnCount;
	      var overscanRowCount = props.overscanRowCount;
	      var rowCount = props.rowCount;
	      var width = props.width;
	      var isScrolling = state.isScrolling;
	      var scrollDirectionHorizontal = state.scrollDirectionHorizontal;
	      var scrollDirectionVertical = state.scrollDirectionVertical;
	      var scrollLeft = state.scrollLeft;
	      var scrollTop = state.scrollTop;
	
	
	      this._childrenToDisplay = [];
	
	      // Render only enough columns and rows to cover the visible area of the grid.
	      if (height > 0 && width > 0) {
	        var visibleColumnIndices = this._columnSizeAndPositionManager.getVisibleCellRange({
	          containerSize: width,
	          offset: scrollLeft
	        });
	        var visibleRowIndices = this._rowSizeAndPositionManager.getVisibleCellRange({
	          containerSize: height,
	          offset: scrollTop
	        });
	
	        var horizontalOffsetAdjustment = this._columnSizeAndPositionManager.getOffsetAdjustment({
	          containerSize: width,
	          offset: scrollLeft
	        });
	        var verticalOffsetAdjustment = this._rowSizeAndPositionManager.getOffsetAdjustment({
	          containerSize: height,
	          offset: scrollTop
	        });
	
	        // Store for _invokeOnGridRenderedHelper()
	        this._renderedColumnStartIndex = visibleColumnIndices.start;
	        this._renderedColumnStopIndex = visibleColumnIndices.stop;
	        this._renderedRowStartIndex = visibleRowIndices.start;
	        this._renderedRowStopIndex = visibleRowIndices.stop;
	
	        var overscanColumnIndices = (0, _getOverscanIndices2.default)({
	          cellCount: columnCount,
	          overscanCellsCount: overscanColumnCount,
	          scrollDirection: scrollDirectionHorizontal,
	          startIndex: this._renderedColumnStartIndex,
	          stopIndex: this._renderedColumnStopIndex
	        });
	
	        var overscanRowIndices = (0, _getOverscanIndices2.default)({
	          cellCount: rowCount,
	          overscanCellsCount: overscanRowCount,
	          scrollDirection: scrollDirectionVertical,
	          startIndex: this._renderedRowStartIndex,
	          stopIndex: this._renderedRowStopIndex
	        });
	
	        // Store for _invokeOnGridRenderedHelper()
	        this._columnStartIndex = overscanColumnIndices.overscanStartIndex;
	        this._columnStopIndex = overscanColumnIndices.overscanStopIndex;
	        this._rowStartIndex = overscanRowIndices.overscanStartIndex;
	        this._rowStopIndex = overscanRowIndices.overscanStopIndex;
	
	        this._childrenToDisplay = cellRangeRenderer({
	          cellCache: this._cellCache,
	          cellRenderer: cellRenderer,
	          columnSizeAndPositionManager: this._columnSizeAndPositionManager,
	          columnStartIndex: this._columnStartIndex,
	          columnStopIndex: this._columnStopIndex,
	          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
	          isScrolling: isScrolling,
	          rowSizeAndPositionManager: this._rowSizeAndPositionManager,
	          rowStartIndex: this._rowStartIndex,
	          rowStopIndex: this._rowStopIndex,
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop,
	          verticalOffsetAdjustment: verticalOffsetAdjustment,
	          visibleColumnIndices: visibleColumnIndices,
	          visibleRowIndices: visibleRowIndices
	        });
	      }
	    }
	
	    /**
	     * Sets an :isScrolling flag for a small window of time.
	     * This flag is used to disable pointer events on the scrollable portion of the Grid.
	     * This prevents jerky/stuttery mouse-wheel scrolling.
	     */
	
	  }, {
	    key: '_enablePointerEventsAfterDelay',
	    value: function _enablePointerEventsAfterDelay() {
	      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
	
	
	      if (this._disablePointerEventsTimeoutId) {
	        clearTimeout(this._disablePointerEventsTimeoutId);
	      }
	
	      this._disablePointerEventsTimeoutId = setTimeout(this._enablePointerEventsAfterDelayCallback, scrollingResetTimeInterval);
	    }
	  }, {
	    key: '_enablePointerEventsAfterDelayCallback',
	    value: function _enablePointerEventsAfterDelayCallback() {
	      this._disablePointerEventsTimeoutId = null;
	
	      // Throw away cell cache once scrolling is complete
	      this._cellCache = {};
	
	      this.setState({
	        isScrolling: false
	      });
	    }
	  }, {
	    key: '_getEstimatedColumnSize',
	    value: function _getEstimatedColumnSize(props) {
	      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
	    }
	  }, {
	    key: '_getEstimatedRowSize',
	    value: function _getEstimatedRowSize(props) {
	      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
	    }
	  }, {
	    key: '_invokeOnGridRenderedHelper',
	    value: function _invokeOnGridRenderedHelper() {
	      var onSectionRendered = this.props.onSectionRendered;
	
	
	      this._onGridRenderedMemoizer({
	        callback: onSectionRendered,
	        indices: {
	          columnOverscanStartIndex: this._columnStartIndex,
	          columnOverscanStopIndex: this._columnStopIndex,
	          columnStartIndex: this._renderedColumnStartIndex,
	          columnStopIndex: this._renderedColumnStopIndex,
	          rowOverscanStartIndex: this._rowStartIndex,
	          rowOverscanStopIndex: this._rowStopIndex,
	          rowStartIndex: this._renderedRowStartIndex,
	          rowStopIndex: this._renderedRowStopIndex
	        }
	      });
	    }
	  }, {
	    key: '_invokeOnScrollMemoizer',
	    value: function _invokeOnScrollMemoizer(_ref3) {
	      var _this5 = this;
	
	      var scrollLeft = _ref3.scrollLeft;
	      var scrollTop = _ref3.scrollTop;
	      var totalColumnsWidth = _ref3.totalColumnsWidth;
	      var totalRowsHeight = _ref3.totalRowsHeight;
	
	      this._onScrollMemoizer({
	        callback: function callback(_ref4) {
	          var scrollLeft = _ref4.scrollLeft;
	          var scrollTop = _ref4.scrollTop;
	          var _props5 = _this5.props;
	          var height = _props5.height;
	          var onScroll = _props5.onScroll;
	          var width = _props5.width;
	
	
	          onScroll({
	            clientHeight: height,
	            clientWidth: width,
	            scrollHeight: totalRowsHeight,
	            scrollLeft: scrollLeft,
	            scrollTop: scrollTop,
	            scrollWidth: totalColumnsWidth
	          });
	        },
	        indices: {
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop
	        }
	      });
	    }
	  }, {
	    key: '_setScrollPosition',
	    value: function _setScrollPosition(_ref5) {
	      var scrollLeft = _ref5.scrollLeft;
	      var scrollTop = _ref5.scrollTop;
	
	      var newState = {
	        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
	      };
	
	      if (scrollLeft >= 0) {
	        newState.scrollDirectionHorizontal = scrollLeft > this.state.scrollLeft ? _getOverscanIndices.SCROLL_DIRECTION_FORWARD : _getOverscanIndices.SCROLL_DIRECTION_BACKWARD;
	        newState.scrollLeft = scrollLeft;
	      }
	
	      if (scrollTop >= 0) {
	        newState.scrollDirectionVertical = scrollTop > this.state.scrollTop ? _getOverscanIndices.SCROLL_DIRECTION_FORWARD : _getOverscanIndices.SCROLL_DIRECTION_BACKWARD;
	        newState.scrollTop = scrollTop;
	      }
	
	      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
	        this.setState(newState);
	      }
	    }
	  }, {
	    key: '_wrapPropertyGetter',
	    value: function _wrapPropertyGetter(value) {
	      return value instanceof Function ? value : function () {
	        return value;
	      };
	    }
	  }, {
	    key: '_wrapSizeGetter',
	    value: function _wrapSizeGetter(size) {
	      return this._wrapPropertyGetter(size);
	    }
	  }, {
	    key: '_updateScrollLeftForScrollToColumn',
	    value: function _updateScrollLeftForScrollToColumn() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	      var columnCount = props.columnCount;
	      var scrollToAlignment = props.scrollToAlignment;
	      var scrollToColumn = props.scrollToColumn;
	      var width = props.width;
	      var scrollLeft = state.scrollLeft;
	
	
	      if (scrollToColumn >= 0 && columnCount > 0) {
	        var targetIndex = Math.max(0, Math.min(columnCount - 1, scrollToColumn));
	
	        var calculatedScrollLeft = this._columnSizeAndPositionManager.getUpdatedOffsetForIndex({
	          align: scrollToAlignment,
	          containerSize: width,
	          currentOffset: scrollLeft,
	          targetIndex: targetIndex
	        });
	
	        if (scrollLeft !== calculatedScrollLeft) {
	          this._setScrollPosition({
	            scrollLeft: calculatedScrollLeft
	          });
	        }
	      }
	    }
	  }, {
	    key: '_updateScrollTopForScrollToRow',
	    value: function _updateScrollTopForScrollToRow() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	      var height = props.height;
	      var rowCount = props.rowCount;
	      var scrollToAlignment = props.scrollToAlignment;
	      var scrollToRow = props.scrollToRow;
	      var scrollTop = state.scrollTop;
	
	
	      if (scrollToRow >= 0 && rowCount > 0) {
	        var targetIndex = Math.max(0, Math.min(rowCount - 1, scrollToRow));
	
	        var calculatedScrollTop = this._rowSizeAndPositionManager.getUpdatedOffsetForIndex({
	          align: scrollToAlignment,
	          containerSize: height,
	          currentOffset: scrollTop,
	          targetIndex: targetIndex
	        });
	
	        if (scrollTop !== calculatedScrollTop) {
	          this._setScrollPosition({
	            scrollTop: calculatedScrollTop
	          });
	        }
	      }
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(event) {
	      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
	      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
	      // See issue #404 for more information.
	      if (event.target !== this._scrollingContainer) {
	        return;
	      }
	
	      // Prevent pointer events from interrupting a smooth scroll
	      this._enablePointerEventsAfterDelay();
	
	      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
	      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
	      // This causes a series of rapid renders that is slow for long lists.
	      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.
	      var _props6 = this.props;
	      var height = _props6.height;
	      var width = _props6.width;
	
	      var scrollbarSize = this._scrollbarSize;
	      var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
	      var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
	      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), event.target.scrollLeft);
	      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), event.target.scrollTop);
	
	      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
	      // Don't force a re-render if this is the case.
	      // The mouse may move faster then the animation frame does.
	      // Use requestAnimationFrame to avoid over-updating.
	      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
	        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
	        var scrollDirectionHorizontal = scrollLeft > this.state.scrollLeft ? _getOverscanIndices.SCROLL_DIRECTION_FORWARD : _getOverscanIndices.SCROLL_DIRECTION_BACKWARD;
	        var scrollDirectionVertical = scrollTop > this.state.scrollTop ? _getOverscanIndices.SCROLL_DIRECTION_FORWARD : _getOverscanIndices.SCROLL_DIRECTION_BACKWARD;
	
	        this.setState({
	          isScrolling: true,
	          scrollDirectionHorizontal: scrollDirectionHorizontal,
	          scrollDirectionVertical: scrollDirectionVertical,
	          scrollLeft: scrollLeft,
	          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED,
	          scrollTop: scrollTop
	        });
	      }
	
	      this._invokeOnScrollMemoizer({ scrollLeft: scrollLeft, scrollTop: scrollTop, totalColumnsWidth: totalColumnsWidth, totalRowsHeight: totalRowsHeight });
	    }
	  }]);
	
	  return Grid;
	}(_react.Component);
	
	Grid.defaultProps = {
	  'aria-label': 'grid',
	  cellRangeRenderer: _defaultCellRangeRenderer2.default,
	  estimatedColumnSize: 100,
	  estimatedRowSize: 30,
	  noContentRenderer: function noContentRenderer() {
	    return null;
	  },
	  onScroll: function onScroll() {
	    return null;
	  },
	  onSectionRendered: function onSectionRendered() {
	    return null;
	  },
	  overscanColumnCount: 0,
	  overscanRowCount: 10,
	  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
	  scrollToAlignment: 'auto',
	  style: {},
	  tabIndex: 0
	};
	exports.default = Grid;
	 false ? Grid.propTypes = {
	  'aria-label': _react.PropTypes.string,
	
	  /**
	   * Set the width of the inner scrollable container to 'auto'.
	   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
	   */
	  autoContainerWidth: _react.PropTypes.bool,
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height
	   * of rows can stretch the window. Intended for use with WindowScroller
	   */
	  autoHeight: _react.PropTypes.bool,
	
	  /**
	   * Responsible for rendering a cell given an row and column index.
	   * Should implement the following interface: ({ columnIndex: number, rowIndex: number }): PropTypes.node
	   */
	  cellRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Responsible for rendering a group of cells given their index ranges.
	   * Should implement the following interface: ({
	   *   cellCache: Map,
	   *   cellRenderer: Function,
	   *   columnSizeAndPositionManager: CellSizeAndPositionManager,
	   *   columnStartIndex: number,
	   *   columnStopIndex: number,
	   *   isScrolling: boolean,
	   *   rowSizeAndPositionManager: CellSizeAndPositionManager,
	   *   rowStartIndex: number,
	   *   rowStopIndex: number,
	   *   scrollLeft: number,
	   *   scrollTop: number
	   * }): Array<PropTypes.node>
	   */
	  cellRangeRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Optional custom CSS class name to attach to root Grid element.
	   */
	  className: _react.PropTypes.string,
	
	  /**
	   * Number of columns in grid.
	   */
	  columnCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Either a fixed column width (number) or a function that returns the width of a column given its index.
	   * Should implement the following interface: (index: number): number
	   */
	  columnWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.func]).isRequired,
	
	  /** Optional inline style applied to inner cell-container */
	  containerStyle: _react.PropTypes.object,
	
	  /**
	   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
	   * The estimated total width is adjusted as columns are rendered.
	   */
	  estimatedColumnSize: _react.PropTypes.number.isRequired,
	
	  /**
	   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
	   * The estimated total height is adjusted as rows are rendered.
	   */
	  estimatedRowSize: _react.PropTypes.number.isRequired,
	
	  /**
	   * Height of Grid; this property determines the number of visible (vs virtualized) rows.
	   */
	  height: _react.PropTypes.number.isRequired,
	
	  /**
	   * Optional custom id to attach to root Grid element.
	   */
	  id: _react.PropTypes.string,
	
	  /**
	   * Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.
	   */
	  noContentRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
	   */
	  onScroll: _react.PropTypes.func.isRequired,
	
	  /**
	   * Callback invoked with information about the section of the Grid that was just rendered.
	   * ({ columnStartIndex, columnStopIndex, rowStartIndex, rowStopIndex }): void
	   */
	  onSectionRendered: _react.PropTypes.func.isRequired,
	
	  /**
	   * Number of columns to render before/after the visible section of the grid.
	   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
	   */
	  overscanColumnCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Number of rows to render above/below the visible section of the grid.
	   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
	   */
	  overscanRowCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Either a fixed row height (number) or a function that returns the height of a row given its index.
	   * Should implement the following interface: ({ index: number }): number
	   */
	  rowHeight: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.func]).isRequired,
	
	  /**
	   * Number of rows in grid.
	   */
	  rowCount: _react.PropTypes.number.isRequired,
	
	  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. */
	  scrollingResetTimeInterval: _react.PropTypes.number,
	
	  /** Horizontal offset. */
	  scrollLeft: _react.PropTypes.number,
	
	  /**
	   * Controls scroll-to-cell behavior of the Grid.
	   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
	   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
	   */
	  scrollToAlignment: _react.PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,
	
	  /**
	   * Column index to ensure visible (by forcefully scrolling if necessary)
	   */
	  scrollToColumn: _react.PropTypes.number,
	
	  /** Vertical offset. */
	  scrollTop: _react.PropTypes.number,
	
	  /**
	   * Row index to ensure visible (by forcefully scrolling if necessary)
	   */
	  scrollToRow: _react.PropTypes.number,
	
	  /** Optional inline style */
	  style: _react.PropTypes.object,
	
	  /** Tab index for focus */
	  tabIndex: _react.PropTypes.number,
	
	  /**
	   * Width of Grid; this property determines the number of visible (vs virtualized) columns.
	   */
	  width: _react.PropTypes.number.isRequired
	} : void 0;

/***/ },
/* 1972 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultCellRangeRenderer = exports.Grid = exports.default = undefined;
	
	var _Grid2 = __webpack_require__(1971);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _defaultCellRangeRenderer2 = __webpack_require__(923);
	
	var _defaultCellRangeRenderer3 = _interopRequireDefault(_defaultCellRangeRenderer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Grid3.default;
	exports.Grid = _Grid3.default;
	exports.defaultCellRangeRenderer = _defaultCellRangeRenderer3.default;

/***/ },
/* 1973 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Just-in-time calculates and caches size and position information for a collection of cells.
	 */
	var CellSizeAndPositionManager = function () {
	  function CellSizeAndPositionManager(_ref) {
	    var cellCount = _ref.cellCount;
	    var cellSizeGetter = _ref.cellSizeGetter;
	    var estimatedCellSize = _ref.estimatedCellSize;
	
	    _classCallCheck(this, CellSizeAndPositionManager);
	
	    this._cellSizeGetter = cellSizeGetter;
	    this._cellCount = cellCount;
	    this._estimatedCellSize = estimatedCellSize;
	
	    // Cache of size and position data for cells, mapped by cell index.
	    // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
	    this._cellSizeAndPositionData = {};
	
	    // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
	    this._lastMeasuredIndex = -1;
	  }
	
	  _createClass(CellSizeAndPositionManager, [{
	    key: 'configure',
	    value: function configure(_ref2) {
	      var cellCount = _ref2.cellCount;
	      var estimatedCellSize = _ref2.estimatedCellSize;
	
	      this._cellCount = cellCount;
	      this._estimatedCellSize = estimatedCellSize;
	    }
	  }, {
	    key: 'getCellCount',
	    value: function getCellCount() {
	      return this._cellCount;
	    }
	  }, {
	    key: 'getEstimatedCellSize',
	    value: function getEstimatedCellSize() {
	      return this._estimatedCellSize;
	    }
	  }, {
	    key: 'getLastMeasuredIndex',
	    value: function getLastMeasuredIndex() {
	      return this._lastMeasuredIndex;
	    }
	
	    /**
	     * This method returns the size and position for the cell at the specified index.
	     * It just-in-time calculates (or used cached values) for cells leading up to the index.
	     */
	
	  }, {
	    key: 'getSizeAndPositionOfCell',
	    value: function getSizeAndPositionOfCell(index) {
	      if (index < 0 || index >= this._cellCount) {
	        throw Error('Requested index ' + index + ' is outside of range 0..' + this._cellCount);
	      }
	
	      if (index > this._lastMeasuredIndex) {
	        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
	        var _offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
	
	        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
	          var _size = this._cellSizeGetter({ index: i });
	
	          if (_size == null || isNaN(_size)) {
	            throw Error('Invalid size returned for cell ' + i + ' of value ' + _size);
	          }
	
	          this._cellSizeAndPositionData[i] = {
	            offset: _offset,
	            size: _size
	          };
	
	          _offset += _size;
	        }
	
	        this._lastMeasuredIndex = index;
	      }
	
	      return this._cellSizeAndPositionData[index];
	    }
	  }, {
	    key: 'getSizeAndPositionOfLastMeasuredCell',
	    value: function getSizeAndPositionOfLastMeasuredCell() {
	      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
	        offset: 0,
	        size: 0
	      };
	    }
	
	    /**
	     * Total size of all cells being measured.
	     * This value will be completedly estimated initially.
	     * As cells as measured the estimate will be updated.
	     */
	
	  }, {
	    key: 'getTotalSize',
	    value: function getTotalSize() {
	      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
	
	      return lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size + (this._cellCount - this._lastMeasuredIndex - 1) * this._estimatedCellSize;
	    }
	
	    /**
	     * Determines a new offset that ensures a certain cell is visible, given the current offset.
	     * If the cell is already visible then the current offset will be returned.
	     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
	     *
	     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
	     * @param containerSize Size (width or height) of the container viewport
	     * @param currentOffset Container's current (x or y) offset
	     * @param totalSize Total size (width or height) of all cells
	     * @return Offset to use to ensure the specified cell is visible
	     */
	
	  }, {
	    key: 'getUpdatedOffsetForIndex',
	    value: function getUpdatedOffsetForIndex(_ref3) {
	      var _ref3$align = _ref3.align;
	      var align = _ref3$align === undefined ? 'auto' : _ref3$align;
	      var containerSize = _ref3.containerSize;
	      var currentOffset = _ref3.currentOffset;
	      var targetIndex = _ref3.targetIndex;
	
	      if (containerSize <= 0) {
	        return 0;
	      }
	
	      var datum = this.getSizeAndPositionOfCell(targetIndex);
	      var maxOffset = datum.offset;
	      var minOffset = maxOffset - containerSize + datum.size;
	
	      var idealOffset = void 0;
	
	      switch (align) {
	        case 'start':
	          idealOffset = maxOffset;
	          break;
	        case 'end':
	          idealOffset = minOffset;
	          break;
	        case 'center':
	          idealOffset = maxOffset - (containerSize - datum.size) / 2;
	          break;
	        default:
	          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
	          break;
	      }
	
	      var totalSize = this.getTotalSize();
	
	      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
	    }
	  }, {
	    key: 'getVisibleCellRange',
	    value: function getVisibleCellRange(_ref4) {
	      var containerSize = _ref4.containerSize;
	      var offset = _ref4.offset;
	
	      var totalSize = this.getTotalSize();
	
	      if (totalSize === 0) {
	        return {};
	      }
	
	      var maxOffset = offset + containerSize;
	      var start = this._findNearestCell(offset);
	
	      var datum = this.getSizeAndPositionOfCell(start);
	      offset = datum.offset + datum.size;
	
	      var stop = start;
	
	      while (offset < maxOffset && stop < this._cellCount - 1) {
	        stop++;
	
	        offset += this.getSizeAndPositionOfCell(stop).size;
	      }
	
	      return {
	        start: start,
	        stop: stop
	      };
	    }
	
	    /**
	     * Clear all cached values for cells after the specified index.
	     * This method should be called for any cell that has changed its size.
	     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
	     */
	
	  }, {
	    key: 'resetCell',
	    value: function resetCell(index) {
	      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
	    }
	  }, {
	    key: '_binarySearch',
	    value: function _binarySearch(_ref5) {
	      var high = _ref5.high;
	      var low = _ref5.low;
	      var offset = _ref5.offset;
	
	      var middle = void 0;
	      var currentOffset = void 0;
	
	      while (low <= high) {
	        middle = low + Math.floor((high - low) / 2);
	        currentOffset = this.getSizeAndPositionOfCell(middle).offset;
	
	        if (currentOffset === offset) {
	          return middle;
	        } else if (currentOffset < offset) {
	          low = middle + 1;
	        } else if (currentOffset > offset) {
	          high = middle - 1;
	        }
	      }
	
	      if (low > 0) {
	        return low - 1;
	      }
	    }
	  }, {
	    key: '_exponentialSearch',
	    value: function _exponentialSearch(_ref6) {
	      var index = _ref6.index;
	      var offset = _ref6.offset;
	
	      var interval = 1;
	
	      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
	        index += interval;
	        interval *= 2;
	      }
	
	      return this._binarySearch({
	        high: Math.min(index, this._cellCount - 1),
	        low: Math.floor(index / 2),
	        offset: offset
	      });
	    }
	
	    /**
	     * Searches for the cell (index) nearest the specified offset.
	     *
	     * If no exact match is found the next lowest cell index will be returned.
	     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
	     */
	
	  }, {
	    key: '_findNearestCell',
	    value: function _findNearestCell(offset) {
	      if (isNaN(offset)) {
	        throw Error('Invalid offset ' + offset + ' specified');
	      }
	
	      // Our search algorithms find the nearest match at or below the specified offset.
	      // So make sure the offset is at least 0 or no match will be found.
	      offset = Math.max(0, offset);
	
	      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
	      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);
	
	      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
	        // If we've already measured cells within this range just use a binary search as it's faster.
	        return this._binarySearch({
	          high: lastMeasuredIndex,
	          low: 0,
	          offset: offset
	        });
	      } else {
	        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
	        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
	        // The overall complexity for this approach is O(log n).
	        return this._exponentialSearch({
	          index: lastMeasuredIndex,
	          offset: offset
	        });
	      }
	    }
	  }]);
	
	  return CellSizeAndPositionManager;
	}();
	
	exports.default = CellSizeAndPositionManager;

/***/ },
/* 1974 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_MAX_SCROLL_SIZE = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CellSizeAndPositionManager = __webpack_require__(1973);
	
	var _CellSizeAndPositionManager2 = _interopRequireDefault(_CellSizeAndPositionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
	 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
	 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
	 */
	var DEFAULT_MAX_SCROLL_SIZE = exports.DEFAULT_MAX_SCROLL_SIZE = 1500000;
	
	/**
	 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
	 */
	
	var ScalingCellSizeAndPositionManager = function () {
	  function ScalingCellSizeAndPositionManager(_ref) {
	    var _ref$maxScrollSize = _ref.maxScrollSize;
	    var maxScrollSize = _ref$maxScrollSize === undefined ? DEFAULT_MAX_SCROLL_SIZE : _ref$maxScrollSize;
	
	    var params = _objectWithoutProperties(_ref, ['maxScrollSize']);
	
	    _classCallCheck(this, ScalingCellSizeAndPositionManager);
	
	    // Favor composition over inheritance to simplify IE10 support
	    this._cellSizeAndPositionManager = new _CellSizeAndPositionManager2.default(params);
	    this._maxScrollSize = maxScrollSize;
	  }
	
	  _createClass(ScalingCellSizeAndPositionManager, [{
	    key: 'configure',
	    value: function configure(params) {
	      this._cellSizeAndPositionManager.configure(params);
	    }
	  }, {
	    key: 'getCellCount',
	    value: function getCellCount() {
	      return this._cellSizeAndPositionManager.getCellCount();
	    }
	  }, {
	    key: 'getEstimatedCellSize',
	    value: function getEstimatedCellSize() {
	      return this._cellSizeAndPositionManager.getEstimatedCellSize();
	    }
	  }, {
	    key: 'getLastMeasuredIndex',
	    value: function getLastMeasuredIndex() {
	      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
	    }
	
	    /**
	     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
	     * The offset passed to this function is scalled (safe) as well.
	     */
	
	  }, {
	    key: 'getOffsetAdjustment',
	    value: function getOffsetAdjustment(_ref2) {
	      var containerSize = _ref2.containerSize;
	      var offset = _ref2.offset;
	
	      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
	      var safeTotalSize = this.getTotalSize();
	      var offsetPercentage = this._getOffsetPercentage({
	        containerSize: containerSize,
	        offset: offset,
	        totalSize: safeTotalSize
	      });
	
	      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
	    }
	  }, {
	    key: 'getSizeAndPositionOfCell',
	    value: function getSizeAndPositionOfCell(index) {
	      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
	    }
	  }, {
	    key: 'getSizeAndPositionOfLastMeasuredCell',
	    value: function getSizeAndPositionOfLastMeasuredCell() {
	      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
	    }
	
	    /** See CellSizeAndPositionManager#getTotalSize */
	
	  }, {
	    key: 'getTotalSize',
	    value: function getTotalSize() {
	      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
	    }
	
	    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */
	
	  }, {
	    key: 'getUpdatedOffsetForIndex',
	    value: function getUpdatedOffsetForIndex(_ref3) {
	      var _ref3$align = _ref3.align;
	      var align = _ref3$align === undefined ? 'auto' : _ref3$align;
	      var containerSize = _ref3.containerSize;
	      var currentOffset = _ref3.currentOffset;
	      var targetIndex = _ref3.targetIndex;
	      var totalSize = _ref3.totalSize;
	
	      currentOffset = this._safeOffsetToOffset({
	        containerSize: containerSize,
	        offset: currentOffset
	      });
	
	      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
	        align: align,
	        containerSize: containerSize,
	        currentOffset: currentOffset,
	        targetIndex: targetIndex,
	        totalSize: totalSize
	      });
	
	      return this._offsetToSafeOffset({
	        containerSize: containerSize,
	        offset: offset
	      });
	    }
	
	    /** See CellSizeAndPositionManager#getVisibleCellRange */
	
	  }, {
	    key: 'getVisibleCellRange',
	    value: function getVisibleCellRange(_ref4) {
	      var containerSize = _ref4.containerSize;
	      var offset = _ref4.offset;
	
	      offset = this._safeOffsetToOffset({
	        containerSize: containerSize,
	        offset: offset
	      });
	
	      return this._cellSizeAndPositionManager.getVisibleCellRange({
	        containerSize: containerSize,
	        offset: offset
	      });
	    }
	  }, {
	    key: 'resetCell',
	    value: function resetCell(index) {
	      this._cellSizeAndPositionManager.resetCell(index);
	    }
	  }, {
	    key: '_getOffsetPercentage',
	    value: function _getOffsetPercentage(_ref5) {
	      var containerSize = _ref5.containerSize;
	      var offset = _ref5.offset;
	      var totalSize = _ref5.totalSize;
	
	      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
	    }
	  }, {
	    key: '_offsetToSafeOffset',
	    value: function _offsetToSafeOffset(_ref6) {
	      var containerSize = _ref6.containerSize;
	      var offset = _ref6.offset;
	
	      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
	      var safeTotalSize = this.getTotalSize();
	
	      if (totalSize === safeTotalSize) {
	        return offset;
	      } else {
	        var offsetPercentage = this._getOffsetPercentage({
	          containerSize: containerSize,
	          offset: offset,
	          totalSize: totalSize
	        });
	
	        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
	      }
	    }
	  }, {
	    key: '_safeOffsetToOffset',
	    value: function _safeOffsetToOffset(_ref7) {
	      var containerSize = _ref7.containerSize;
	      var offset = _ref7.offset;
	
	      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
	      var safeTotalSize = this.getTotalSize();
	
	      if (totalSize === safeTotalSize) {
	        return offset;
	      } else {
	        var offsetPercentage = this._getOffsetPercentage({
	          containerSize: containerSize,
	          offset: offset,
	          totalSize: safeTotalSize
	        });
	
	        return Math.round(offsetPercentage * (totalSize - containerSize));
	      }
	    }
	  }]);
	
	  return ScalingCellSizeAndPositionManager;
	}();
	
	exports.default = ScalingCellSizeAndPositionManager;

/***/ },
/* 1975 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculateSizeAndPositionDataAndUpdateScrollOffset;
	/**
	 * Helper method that determines when to recalculate row or column metadata.
	 *
	 * @param cellCount Number of rows or columns in the current axis
	 * @param cellsSize Width or height of cells for the current axis
	 * @param computeMetadataCallback Method to invoke if cell metadata should be recalculated
	 * @param computeMetadataCallbackProps Parameters to pass to :computeMetadataCallback
	 * @param nextCellsCount Newly updated number of rows or columns in the current axis
	 * @param nextCellsSize Newly updated width or height of cells for the current axis
	 * @param nextScrollToIndex Newly updated scroll-to-index
	 * @param scrollToIndex Scroll-to-index
	 * @param updateScrollOffsetForScrollToIndex Callback to invoke if the scroll position should be recalculated
	 */
	function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
	  var cellCount = _ref.cellCount;
	  var cellSize = _ref.cellSize;
	  var computeMetadataCallback = _ref.computeMetadataCallback;
	  var computeMetadataCallbackProps = _ref.computeMetadataCallbackProps;
	  var nextCellsCount = _ref.nextCellsCount;
	  var nextCellSize = _ref.nextCellSize;
	  var nextScrollToIndex = _ref.nextScrollToIndex;
	  var scrollToIndex = _ref.scrollToIndex;
	  var updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;
	
	  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
	  // In that event users should use the manual recompute methods to inform of changes.
	  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
	    computeMetadataCallback(computeMetadataCallbackProps);
	
	    // Updated cell metadata may have hidden the previous scrolled-to item.
	    // In this case we should also update the scrollTop to ensure it stays visible.
	    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
	      updateScrollOffsetForScrollToIndex();
	    }
	  }
	}

/***/ },
/* 1976 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getOverscanIndices;
	var SCROLL_DIRECTION_BACKWARD = exports.SCROLL_DIRECTION_BACKWARD = -1;
	var SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_FORWARD = 1;
	
	/**
	 * Calculates the number of cells to overscan before and after a specified range.
	 * This function ensures that overscanning doesn't exceed the available cells.
	 *
	 * @param cellCount Number of rows or columns in the current axis
	 * @param scrollDirection One of SCROLL_DIRECTION_BACKWARD
	 * @param overscanCellsCount Maximum number of cells to over-render in either direction
	 * @param startIndex Begin of range of visible cells
	 * @param stopIndex End of range of visible cells
	 */
	function getOverscanIndices(_ref) {
	  var cellCount = _ref.cellCount;
	  var overscanCellsCount = _ref.overscanCellsCount;
	  var scrollDirection = _ref.scrollDirection;
	  var startIndex = _ref.startIndex;
	  var stopIndex = _ref.stopIndex;
	
	  var overscanStartIndex = void 0;
	  var overscanStopIndex = void 0;
	
	  switch (scrollDirection) {
	    case SCROLL_DIRECTION_FORWARD:
	      overscanStartIndex = startIndex;
	      overscanStopIndex = stopIndex + overscanCellsCount;
	      break;
	    case SCROLL_DIRECTION_BACKWARD:
	      overscanStartIndex = startIndex - overscanCellsCount;
	      overscanStopIndex = stopIndex;
	      break;
	  }
	
	  return {
	    overscanStartIndex: Math.max(0, overscanStartIndex),
	    overscanStopIndex: Math.min(cellCount - 1, overscanStopIndex)
	  };
	}

/***/ },
/* 1977 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = updateScrollIndexHelper;
	/**
	 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
	 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
	 *
	 * @param cellsSize Width or height of cells for the current axis
	 * @param cellSizeAndPositionManager Manages size and position metadata of cells
	 * @param previousCellsCount Previous number of rows or columns
	 * @param previousCellsSize Previous width or height of cells
	 * @param previousScrollToIndex Previous scroll-to-index
	 * @param previousSize Previous width or height of the virtualized container
	 * @param scrollOffset Current scrollLeft or scrollTop
	 * @param scrollToIndex Scroll-to-index
	 * @param size Width or height of the virtualized container
	 * @param updateScrollIndexCallback Callback to invoke with an scroll-to-index value
	 */
	function updateScrollIndexHelper(_ref) {
	  var cellSize = _ref.cellSize;
	  var cellSizeAndPositionManager = _ref.cellSizeAndPositionManager;
	  var previousCellsCount = _ref.previousCellsCount;
	  var previousCellSize = _ref.previousCellSize;
	  var previousScrollToAlignment = _ref.previousScrollToAlignment;
	  var previousScrollToIndex = _ref.previousScrollToIndex;
	  var previousSize = _ref.previousSize;
	  var scrollOffset = _ref.scrollOffset;
	  var scrollToAlignment = _ref.scrollToAlignment;
	  var scrollToIndex = _ref.scrollToIndex;
	  var size = _ref.size;
	  var updateScrollIndexCallback = _ref.updateScrollIndexCallback;
	
	  var cellCount = cellSizeAndPositionManager.getCellCount();
	  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
	  var sizeHasChanged = size !== previousSize || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;
	
	  // If we have a new scroll target OR if height/row-height has changed,
	  // We should ensure that the scroll target is visible.
	  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
	    updateScrollIndexCallback(scrollToIndex);
	
	    // If we don't have a selected item but list size or number of children have decreased,
	    // Make sure we aren't scrolled too far past the current content.
	  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
	    // We need to ensure that the current scroll offset is still within the collection's range.
	    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
	    // Just check to make sure we're still okay.
	    // Only adjust the scroll position if we've scrolled below the last set of rows.
	    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
	      updateScrollIndexCallback(cellCount - 1);
	    }
	  }
	}

/***/ },
/* 1978 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Grid = __webpack_require__(1972);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(61);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactAddonsShallowCompare = __webpack_require__(655);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
	 * if only a few of those elements are visible. The primary purpose of this component is to improve
	 * performance by only rendering the DOM nodes that a user is able to see based on their current
	 * scroll position.
	 *
	 * This component renders a virtualized list of elements with either fixed or dynamic heights.
	 */
	var List = function (_Component) {
	  _inherits(List, _Component);
	
	  function List(props, context) {
	    _classCallCheck(this, List);
	
	    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props, context));
	
	    _this._cellRenderer = _this._cellRenderer.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
	    return _this;
	  }
	
	  _createClass(List, [{
	    key: 'forceUpdateGrid',
	    value: function forceUpdateGrid() {
	      this.Grid.forceUpdate();
	    }
	
	    /** See Grid#measureAllCells */
	
	  }, {
	    key: 'measureAllRows',
	    value: function measureAllRows() {
	      this.Grid.measureAllCells();
	    }
	
	    /** See Grid#recomputeGridSize */
	
	  }, {
	    key: 'recomputeRowHeights',
	    value: function recomputeRowHeights() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      this.Grid.recomputeGridSize({
	        rowIndex: index
	      });
	      this.forceUpdateGrid();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var className = _props.className;
	      var noRowsRenderer = _props.noRowsRenderer;
	      var scrollToIndex = _props.scrollToIndex;
	      var width = _props.width;
	
	
	      var classNames = (0, _classnames2.default)('ReactVirtualized__List', className);
	
	      return _react2.default.createElement(_Grid2.default, _extends({}, this.props, {
	        autoContainerWidth: true,
	        cellRenderer: this._cellRenderer,
	        className: classNames,
	        columnWidth: width,
	        columnCount: 1,
	        noContentRenderer: noRowsRenderer,
	        onScroll: this._onScroll,
	        onSectionRendered: this._onSectionRendered,
	        ref: function ref(_ref) {
	          _this2.Grid = _ref;
	        },
	        scrollToRow: scrollToIndex
	      }));
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: '_cellRenderer',
	    value: function _cellRenderer(_ref2) {
	      var rowIndex = _ref2.rowIndex;
	      var style = _ref2.style;
	
	      var rest = _objectWithoutProperties(_ref2, ['rowIndex', 'style']);
	
	      var rowRenderer = this.props.rowRenderer;
	
	      // By default, List cells should be 100% width.
	      // This prevents them from flowing under a scrollbar (if present).
	
	      style.width = '100%';
	
	      return rowRenderer(_extends({
	        index: rowIndex,
	        style: style
	      }, rest));
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(_ref3) {
	      var clientHeight = _ref3.clientHeight;
	      var scrollHeight = _ref3.scrollHeight;
	      var scrollTop = _ref3.scrollTop;
	      var onScroll = this.props.onScroll;
	
	
	      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
	    }
	  }, {
	    key: '_onSectionRendered',
	    value: function _onSectionRendered(_ref4) {
	      var rowOverscanStartIndex = _ref4.rowOverscanStartIndex;
	      var rowOverscanStopIndex = _ref4.rowOverscanStopIndex;
	      var rowStartIndex = _ref4.rowStartIndex;
	      var rowStopIndex = _ref4.rowStopIndex;
	      var onRowsRendered = this.props.onRowsRendered;
	
	
	      onRowsRendered({
	        overscanStartIndex: rowOverscanStartIndex,
	        overscanStopIndex: rowOverscanStopIndex,
	        startIndex: rowStartIndex,
	        stopIndex: rowStopIndex
	      });
	    }
	  }]);
	
	  return List;
	}(_react.Component);
	
	List.defaultProps = {
	  estimatedRowSize: 30,
	  noRowsRenderer: function noRowsRenderer() {
	    return null;
	  },
	  onRowsRendered: function onRowsRendered() {
	    return null;
	  },
	  onScroll: function onScroll() {
	    return null;
	  },
	  overscanRowCount: 10,
	  scrollToAlignment: 'auto',
	  style: {}
	};
	exports.default = List;
	 false ? List.propTypes = {
	  'aria-label': _react.PropTypes.string,
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height
	   * of rows can stretch the window. Intended for use with WindowScroller
	   */
	  autoHeight: _react.PropTypes.bool,
	
	  /** Optional CSS class name */
	  className: _react.PropTypes.string,
	
	  /**
	   * Used to estimate the total height of a List before all of its rows have actually been measured.
	   * The estimated total height is adjusted as rows are rendered.
	   */
	  estimatedRowSize: _react.PropTypes.number.isRequired,
	
	  /** Height constraint for list (determines how many actual rows are rendered) */
	  height: _react.PropTypes.number.isRequired,
	
	  /** Optional renderer to be used in place of rows when rowCount is 0 */
	  noRowsRenderer: _react.PropTypes.func.isRequired,
	
	  /**
	   * Callback invoked with information about the slice of rows that were just rendered.
	   * ({ startIndex, stopIndex }): void
	   */
	  onRowsRendered: _react.PropTypes.func.isRequired,
	
	  /**
	   * Number of rows to render above/below the visible bounds of the list.
	   * These rows can help for smoother scrolling on touch devices.
	   */
	  overscanRowCount: _react.PropTypes.number.isRequired,
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   * ({ clientHeight, scrollHeight, scrollTop }): void
	   */
	  onScroll: _react.PropTypes.func.isRequired,
	
	  /**
	   * Either a fixed row height (number) or a function that returns the height of a row given its index.
	   * ({ index: number }): number
	   */
	  rowHeight: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.func]).isRequired,
	
	  /** Responsible for rendering a row given an index; ({ index: number }): node */
	  rowRenderer: _react.PropTypes.func.isRequired,
	
	  /** Number of rows in list. */
	  rowCount: _react.PropTypes.number.isRequired,
	
	  /** See Grid#scrollToAlignment */
	  scrollToAlignment: _react.PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,
	
	  /** Row index to ensure visible (by forcefully scrolling if necessary) */
	  scrollToIndex: _react.PropTypes.number,
	
	  /** Vertical offset. */
	  scrollTop: _react.PropTypes.number,
	
	  /** Optional inline style */
	  style: _react.PropTypes.object,
	
	  /** Tab index for focus */
	  tabIndex: _react.PropTypes.number,
	
	  /** Width of list */
	  width: _react.PropTypes.number.isRequired
	} : void 0;

/***/ },
/* 1979 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.List = exports.default = undefined;
	
	var _List2 = __webpack_require__(1978);
	
	var _List3 = _interopRequireDefault(_List2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _List3.default;
	exports.List = _List3.default;

/***/ },
/* 1980 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createCallbackMemoizer;
	/**
	 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
	 */
	function createCallbackMemoizer() {
	  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	  var cachedIndices = {};
	
	  return function (_ref) {
	    var callback = _ref.callback;
	    var indices = _ref.indices;
	
	    var keys = Object.keys(indices);
	    var allInitialized = !requireAllKeys || keys.every(function (key) {
	      var value = indices[key];
	      return Array.isArray(value) ? value.length > 0 : value >= 0;
	    });
	    var indexChanged = keys.length !== Object.keys(cachedIndices).length || keys.some(function (key) {
	      var cachedValue = cachedIndices[key];
	      var value = indices[key];
	
	      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
	    });
	
	    cachedIndices = indices;
	
	    if (allInitialized && indexChanged) {
	      callback(indices);
	    }
	  };
	}

/***/ },
/* 1981 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createDetectElementResize;
	/**
	 * Detect Element Resize.
	 * https://github.com/sdecima/javascript-detect-element-resize
	 * Sebastian Decima
	 *
	 * Forked from version 0.5.3; includes the following modifications:
	 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
	 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
	 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
	 **/
	
	function createDetectElementResize() {
	  // Check `document` and `window` in case of server-side rendering
	  var _window;
	  if (typeof window !== 'undefined') {
	    _window = window;
	  } else if (typeof self !== 'undefined') {
	    _window = self;
	  } else {
	    _window = this;
	  }
	
	  var attachEvent = typeof document !== 'undefined' && document.attachEvent;
	  var stylesCreated = false;
	
	  if (!attachEvent) {
	    var requestFrame = function () {
	      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
	        return _window.setTimeout(fn, 20);
	      };
	      return function (fn) {
	        return raf(fn);
	      };
	    }();
	
	    var cancelFrame = function () {
	      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
	      return function (id) {
	        return cancel(id);
	      };
	    }();
	
	    var resetTriggers = function resetTriggers(element) {
	      var triggers = element.__resizeTriggers__,
	          expand = triggers.firstElementChild,
	          contract = triggers.lastElementChild,
	          expandChild = expand.firstElementChild;
	      contract.scrollLeft = contract.scrollWidth;
	      contract.scrollTop = contract.scrollHeight;
	      expandChild.style.width = expand.offsetWidth + 1 + 'px';
	      expandChild.style.height = expand.offsetHeight + 1 + 'px';
	      expand.scrollLeft = expand.scrollWidth;
	      expand.scrollTop = expand.scrollHeight;
	    };
	
	    var checkTriggers = function checkTriggers(element) {
	      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
	    };
	
	    var scrollListener = function scrollListener(e) {
	      // Don't measure (which forces) reflow for scrolls that happen inside of children!
	      if (e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
	        return;
	      }
	
	      var element = this;
	      resetTriggers(this);
	      if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
	      this.__resizeRAF__ = requestFrame(function () {
	        if (checkTriggers(element)) {
	          element.__resizeLast__.width = element.offsetWidth;
	          element.__resizeLast__.height = element.offsetHeight;
	          element.__resizeListeners__.forEach(function (fn) {
	            fn.call(element, e);
	          });
	        }
	      });
	    };
	
	    /* Detect CSS Animations support to detect element display/re-attach */
	    var animation = false,
	        animationstring = 'animation',
	        keyframeprefix = '',
	        animationstartevent = 'animationstart',
	        domPrefixes = 'Webkit Moz O ms'.split(' '),
	        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
	        pfx = '';
	    {
	      var elm = document.createElement('fakeelement');
	      if (elm.style.animationName !== undefined) {
	        animation = true;
	      }
	
	      if (animation === false) {
	        for (var i = 0; i < domPrefixes.length; i++) {
	          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
	            pfx = domPrefixes[i];
	            animationstring = pfx + 'Animation';
	            keyframeprefix = '-' + pfx.toLowerCase() + '-';
	            animationstartevent = startEvents[i];
	            animation = true;
	            break;
	          }
	        }
	      }
	    }
	
	    var animationName = 'resizeanim';
	    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
	    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
	  }
	
	  var createStyles = function createStyles() {
	    if (!stylesCreated) {
	      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
	      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: \" \"; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
	          head = document.head || document.getElementsByTagName('head')[0],
	          style = document.createElement('style');
	
	      style.type = 'text/css';
	      if (style.styleSheet) {
	        style.styleSheet.cssText = css;
	      } else {
	        style.appendChild(document.createTextNode(css));
	      }
	
	      head.appendChild(style);
	      stylesCreated = true;
	    }
	  };
	
	  var addResizeListener = function addResizeListener(element, fn) {
	    if (attachEvent) element.attachEvent('onresize', fn);else {
	      if (!element.__resizeTriggers__) {
	        var elementStyle = _window.getComputedStyle(element);
	        if (elementStyle && elementStyle.position == 'static') {
	          element.style.position = 'relative';
	        }
	        createStyles();
	        element.__resizeLast__ = {};
	        element.__resizeListeners__ = [];
	        (element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
	        element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
	        element.appendChild(element.__resizeTriggers__);
	        resetTriggers(element);
	        element.addEventListener('scroll', scrollListener, true);
	
	        /* Listen for a css animation to detect element display/re-attach */
	        if (animationstartevent) {
	          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
	            if (e.animationName == animationName) resetTriggers(element);
	          };
	          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
	        }
	      }
	      element.__resizeListeners__.push(fn);
	    }
	  };
	
	  var removeResizeListener = function removeResizeListener(element, fn) {
	    if (attachEvent) element.detachEvent('onresize', fn);else {
	      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
	      if (!element.__resizeListeners__.length) {
	        element.removeEventListener('scroll', scrollListener, true);
	        if (element.__resizeTriggers__.__animationListener__) {
	          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
	          element.__resizeTriggers__.__animationListener__ = null;
	        }
	        element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
	      }
	    }
	  };
	
	  return {
	    addResizeListener: addResizeListener,
	    removeResizeListener: removeResizeListener
	  };
	}

/***/ },
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var shallowEqual = __webpack_require__(535);
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 * See also https://facebook.github.io/react/docs/shallow-compare.html
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
	}
	
	module.exports = shallowCompare;

/***/ },
/* 1993 */,
/* 1994 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.utils = exports.effects = exports.CANCEL = exports.delay = exports.throttle = exports.takeLatest = exports.takeEvery = exports.buffers = exports.channel = exports.eventChannel = exports.END = exports.runSaga = undefined;
	
	var _runSaga = __webpack_require__(1996);
	
	Object.defineProperty(exports, 'runSaga', {
	  enumerable: true,
	  get: function get() {
	    return _runSaga.runSaga;
	  }
	});
	
	var _channel = __webpack_require__(555);
	
	Object.defineProperty(exports, 'END', {
	  enumerable: true,
	  get: function get() {
	    return _channel.END;
	  }
	});
	Object.defineProperty(exports, 'eventChannel', {
	  enumerable: true,
	  get: function get() {
	    return _channel.eventChannel;
	  }
	});
	Object.defineProperty(exports, 'channel', {
	  enumerable: true,
	  get: function get() {
	    return _channel.channel;
	  }
	});
	
	var _buffers = __webpack_require__(554);
	
	Object.defineProperty(exports, 'buffers', {
	  enumerable: true,
	  get: function get() {
	    return _buffers.buffers;
	  }
	});
	
	var _sagaHelpers = __webpack_require__(1997);
	
	Object.defineProperty(exports, 'takeEvery', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.takeEvery;
	  }
	});
	Object.defineProperty(exports, 'takeLatest', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.takeLatest;
	  }
	});
	Object.defineProperty(exports, 'throttle', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.throttle;
	  }
	});
	
	var _utils = __webpack_require__(144);
	
	Object.defineProperty(exports, 'delay', {
	  enumerable: true,
	  get: function get() {
	    return _utils.delay;
	  }
	});
	Object.defineProperty(exports, 'CANCEL', {
	  enumerable: true,
	  get: function get() {
	    return _utils.CANCEL;
	  }
	});
	
	var _middleware = __webpack_require__(1995);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	var _effects = __webpack_require__(930);
	
	var effects = _interopRequireWildcard(_effects);
	
	var _utils2 = __webpack_require__(1998);
	
	var utils = _interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _middleware2.default;
	exports.effects = effects;
	exports.utils = utils;

/***/ },
/* 1995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sagaMiddlewareFactory;
	
	var _utils = __webpack_require__(144);
	
	var _proc = __webpack_require__(931);
	
	var _proc2 = _interopRequireDefault(_proc);
	
	var _scheduler = __webpack_require__(932);
	
	var _channel = __webpack_require__(555);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function sagaMiddlewareFactory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var runSagaDynamically = void 0;
	  var sagaMonitor = options.sagaMonitor;
	
	
	  if (_utils.is.func(options)) {
	    if (true) {
	      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
	    } else {
	      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
	    }
	  }
	
	  if (options.logger && !_utils.is.func(options.logger)) {
	    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
	  }
	
	  if (options.onerror && !_utils.is.func(options.onerror)) {
	    throw new Error('`options.onerror` passed to the Saga middleware is not a function!');
	  }
	
	  function sagaMiddleware(_ref) {
	    var getState = _ref.getState,
	        dispatch = _ref.dispatch;
	
	    runSagaDynamically = runSaga;
	    var sagaEmitter = (0, _channel.emitter)();
	    var sagaDispatch = (0, _utils.wrapSagaDispatch)(dispatch);
	
	    function runSaga(saga, args, sagaId) {
	      return (0, _proc2.default)(saga.apply(undefined, _toConsumableArray(args)), sagaEmitter.subscribe, sagaDispatch, getState, options, sagaId, saga.name);
	    }
	
	    return function (next) {
	      return function (action) {
	        if (sagaMonitor) {
	          sagaMonitor.actionDispatched(action);
	        }
	        var result = next(action); // hit reducers
	        if (action[_utils.SAGA_ACTION]) {
	          // Saga actions are already scheduled with asap in proc/runPutEffect
	          sagaEmitter.emit(action);
	        } else {
	          (0, _scheduler.asap)(function () {
	            return sagaEmitter.emit(action);
	          });
	        }
	
	        return result;
	      };
	    };
	  }
	
	  sagaMiddleware.run = function (saga) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    (0, _utils.check)(runSagaDynamically, _utils.is.notUndef, 'Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
	    (0, _utils.check)(saga, _utils.is.func, 'sagaMiddleware.run(saga, ...args): saga argument must be a Generator function!');
	
	    var effectId = (0, _utils.uid)();
	    if (sagaMonitor) {
	      sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
	    }
	    var task = runSagaDynamically(saga, args, effectId);
	    if (sagaMonitor) {
	      sagaMonitor.effectResolved(effectId, task);
	    }
	    return task;
	  };
	
	  return sagaMiddleware;
	}

/***/ },
/* 1996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.runSaga = runSaga;
	
	var _utils = __webpack_require__(144);
	
	var _proc = __webpack_require__(931);
	
	var _proc2 = _interopRequireDefault(_proc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function runSaga(iterator, _ref) {
	  var subscribe = _ref.subscribe,
	      dispatch = _ref.dispatch,
	      getState = _ref.getState,
	      sagaMonitor = _ref.sagaMonitor,
	      logger = _ref.logger;
	
	
	  (0, _utils.check)(iterator, _utils.is.iterator, "runSaga must be called on an iterator");
	
	  var effectId = (0, _utils.uid)();
	  if (sagaMonitor) {
	    dispatch = (0, _utils.wrapSagaDispatch)(dispatch);
	    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: iterator, args: [] } });
	  }
	  var task = (0, _proc2.default)(iterator, subscribe, dispatch, getState, { sagaMonitor: sagaMonitor, logger: logger }, effectId, iterator.name);
	
	  if (sagaMonitor) {
	    sagaMonitor.effectResolved(effectId, task);
	  }
	
	  return task;
	}

/***/ },
/* 1997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.takeEvery = takeEvery;
	exports.takeLatest = takeLatest;
	exports.throttle = throttle;
	
	var _channel = __webpack_require__(555);
	
	var _utils = __webpack_require__(144);
	
	var _io = __webpack_require__(556);
	
	var _buffers = __webpack_require__(554);
	
	var done = { done: true, value: undefined };
	var qEnd = {};
	
	function fsmIterator(fsm, q0) {
	  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';
	
	  var updateState = void 0,
	      qNext = q0;
	
	  function next(arg, error) {
	    if (qNext === qEnd) {
	      return done;
	    }
	
	    if (error) {
	      qNext = qEnd;
	      throw error;
	    } else {
	      updateState && updateState(arg);
	
	      var _fsm$qNext = fsm[qNext](),
	          _fsm$qNext2 = _slicedToArray(_fsm$qNext, 3),
	          q = _fsm$qNext2[0],
	          output = _fsm$qNext2[1],
	          _updateState = _fsm$qNext2[2];
	
	      qNext = q;
	      updateState = _updateState;
	      return qNext === qEnd ? done : output;
	    }
	  }
	
	  return (0, _utils.makeIterator)(next, function (error) {
	    return next(null, error);
	  }, name, true);
	}
	
	function safeName(pattern) {
	  if (Array.isArray(pattern)) {
	    return String(pattern.map(function (entry) {
	      return String(entry);
	    }));
	  } else {
	    return String(pattern);
	  }
	}
	
	function takeEvery(pattern, worker) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var yTake = { done: false, value: (0, _io.take)(pattern) };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	
	  var action = void 0,
	      setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return fsmIterator({
	    q1: function q1() {
	      return ['q2', yTake, setAction];
	    },
	    q2: function q2() {
	      return action === _channel.END ? [qEnd] : ['q1', yFork(action)];
	    }
	  }, 'q1', 'takeEvery(' + safeName(pattern) + ', ' + worker.name + ')');
	}
	
	function takeLatest(pattern, worker) {
	  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	    args[_key2 - 2] = arguments[_key2];
	  }
	
	  var yTake = { done: false, value: (0, _io.take)(pattern) };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	  var yCancel = function yCancel(task) {
	    return { done: false, value: (0, _io.cancel)(task) };
	  };
	
	  var task = void 0,
	      action = void 0;
	  var setTask = function setTask(t) {
	    return task = t;
	  };
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return fsmIterator({
	    q1: function q1() {
	      return ['q2', yTake, setAction];
	    },
	    q2: function q2() {
	      return action === _channel.END ? [qEnd] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
	    },
	    q3: function q3() {
	      return ['q1', yFork(action), setTask];
	    }
	  }, 'q1', 'takeLatest(' + safeName(pattern) + ', ' + worker.name + ')');
	}
	
	function throttle(delayLength, pattern, worker) {
	  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
	    args[_key3 - 3] = arguments[_key3];
	  }
	
	  var action = void 0,
	      channel = void 0;
	
	  var yActionChannel = { done: false, value: (0, _io.actionChannel)(pattern, _buffers.buffers.sliding(1)) };
	  var yTake = function yTake() {
	    return { done: false, value: (0, _io.take)(channel, pattern) };
	  };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	  var yDelay = { done: false, value: (0, _io.call)(_utils.delay, delayLength) };
	
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	  var setChannel = function setChannel(ch) {
	    return channel = ch;
	  };
	
	  return fsmIterator({
	    q1: function q1() {
	      return ['q2', yActionChannel, setChannel];
	    },
	    q2: function q2() {
	      return ['q3', yTake(), setAction];
	    },
	    q3: function q3() {
	      return action === _channel.END ? [qEnd] : ['q4', yFork(action)];
	    },
	    q4: function q4() {
	      return ['q2', yDelay];
	    }
	  }, 'q1', 'throttle(' + safeName(pattern) + ', ' + worker.name + ')');
	}

/***/ },
/* 1998 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(144);
	
	Object.defineProperty(exports, 'TASK', {
	  enumerable: true,
	  get: function get() {
	    return _utils.TASK;
	  }
	});
	Object.defineProperty(exports, 'SAGA_ACTION', {
	  enumerable: true,
	  get: function get() {
	    return _utils.SAGA_ACTION;
	  }
	});
	Object.defineProperty(exports, 'noop', {
	  enumerable: true,
	  get: function get() {
	    return _utils.noop;
	  }
	});
	Object.defineProperty(exports, 'is', {
	  enumerable: true,
	  get: function get() {
	    return _utils.is;
	  }
	});
	Object.defineProperty(exports, 'deferred', {
	  enumerable: true,
	  get: function get() {
	    return _utils.deferred;
	  }
	});
	Object.defineProperty(exports, 'arrayOfDeffered', {
	  enumerable: true,
	  get: function get() {
	    return _utils.arrayOfDeffered;
	  }
	});
	Object.defineProperty(exports, 'createMockTask', {
	  enumerable: true,
	  get: function get() {
	    return _utils.createMockTask;
	  }
	});
	
	var _io = __webpack_require__(556);
	
	Object.defineProperty(exports, 'CHANNEL_END', {
	  enumerable: true,
	  get: function get() {
	    return _io.CHANNEL_END;
	  }
	});
	Object.defineProperty(exports, 'asEffect', {
	  enumerable: true,
	  get: function get() {
	    return _io.asEffect;
	  }
	});

/***/ },
/* 1999 */,
/* 2000 */,
/* 2001 */,
/* 2002 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2003 */,
/* 2004 */
/***/ function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ },
/* 2005 */,
/* 2006 */,
/* 2007 */,
/* 2008 */,
/* 2009 */,
/* 2010 */,
/* 2011 */,
/* 2012 */,
/* 2013 */,
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */,
/* 2039 */,
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */,
/* 2044 */,
/* 2045 */,
/* 2046 */,
/* 2047 */,
/* 2048 */,
/* 2049 */,
/* 2050 */,
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */,
/* 2058 */,
/* 2059 */,
/* 2060 */,
/* 2061 */,
/* 2062 */,
/* 2063 */,
/* 2064 */,
/* 2065 */,
/* 2066 */,
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */,
/* 2079 */,
/* 2080 */,
/* 2081 */,
/* 2082 */,
/* 2083 */,
/* 2084 */,
/* 2085 */,
/* 2086 */,
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */,
/* 2091 */,
/* 2092 */,
/* 2093 */,
/* 2094 */,
/* 2095 */,
/* 2096 */,
/* 2097 */,
/* 2098 */,
/* 2099 */,
/* 2100 */,
/* 2101 */,
/* 2102 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _VirtualizedSelect = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _VirtualizedSelect2 = _interopRequireDefault(_VirtualizedSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _VirtualizedSelect2.default;

/***/ }
]);


// WEBPACK FOOTER //
// sport-betting.03022c52dfe6c704eca7.js